// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!./shepherd.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!./mermaid.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/boxicons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/boxicons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/boxicons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/boxicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/boxicons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/la-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/la-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/la-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/la-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/la-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/la-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/la-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/la-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/la-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/la-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/la-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/la-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/la-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/la-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/la-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/remixicon.eot?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/remixicon.woff2?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/remixicon.woff?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/remixicon.ttf?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/remixicon.svg?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28159.5, 168, 196%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%230ab39c%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f06548%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f06548%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--vz-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%2857.6, 72.9, 123.3%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../fonts/hkgrotesk-light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../fonts/hkgrotesk-light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../fonts/hkgrotesk-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../fonts/hkgrotesk-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../fonts/hkgrotesk-medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../fonts/hkgrotesk-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../fonts/hkgrotesk-semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../fonts/hkgrotesk-semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../fonts/hkgrotesk-bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../images/sidebar/img-1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../images/sidebar/img-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../images/sidebar/img-3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../images/sidebar/img-4.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23adb5bd%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../images/modal-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 version=%271.1%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 xmlns:svgjs=%27http://svgjs.com/svgjs%27 width=%271440%27 height=%27560%27 preserveAspectRatio=%27none%27 viewBox=%270 0 1440 560%27%3e%3cg mask=%27url%28%26quot%3b%23SvgjsMask1016%26quot%3b%29%27 fill=%27none%27%3e%3crect width=%271440%27 height=%27560%27 x=%270%27 y=%270%27 fill=%27rgba%2864%2c 81%2c 137%2c 1%29%27%3e%3c/rect%3e%3cpath d=%27M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704%27 fill=%27%2333416e%27%3e%3c/path%3e%3cpath d=%27M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672%27 fill=%27%234d61a4%27%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id=%27SvgjsMask1016%27%3e%3crect width=%271440%27 height=%27560%27 fill=%27white%27%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ced4da%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ced4da%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../images/flags/us.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../images/auth-erp-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../images/cover-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../images/nft/marketplace.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../images/chat-bg-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../images/file.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("../images/landing/bg-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("../images/new.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_75___ = new URL("../images/logo-sm.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:regular,bold,italic&subset=latin,latin-ext);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=6.5.95" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "?#boxicons" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#remixicon" });
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
var ___CSS_LOADER_URL_REPLACEMENT_79___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_75___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 2.0.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}
.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.mdi-ab-testing::before {
  content: "\\f01c9";
}

.mdi-abacus::before {
  content: "\\f16e0";
}

.mdi-abjad-arabic::before {
  content: "\\f1328";
}

.mdi-abjad-hebrew::before {
  content: "\\f1329";
}

.mdi-abugida-devanagari::before {
  content: "\\f132a";
}

.mdi-abugida-thai::before {
  content: "\\f132b";
}

.mdi-access-point::before {
  content: "\\f0003";
}

.mdi-access-point-check::before {
  content: "\\f1538";
}

.mdi-access-point-minus::before {
  content: "\\f1539";
}

.mdi-access-point-network::before {
  content: "\\f0002";
}

.mdi-access-point-network-off::before {
  content: "\\f0be1";
}

.mdi-access-point-off::before {
  content: "\\f1511";
}

.mdi-access-point-plus::before {
  content: "\\f153a";
}

.mdi-access-point-remove::before {
  content: "\\f153b";
}

.mdi-account::before {
  content: "\\f0004";
}

.mdi-account-alert::before {
  content: "\\f0005";
}

.mdi-account-alert-outline::before {
  content: "\\f0b50";
}

.mdi-account-arrow-down::before {
  content: "\\f1868";
}

.mdi-account-arrow-down-outline::before {
  content: "\\f1869";
}

.mdi-account-arrow-left::before {
  content: "\\f0b51";
}

.mdi-account-arrow-left-outline::before {
  content: "\\f0b52";
}

.mdi-account-arrow-right::before {
  content: "\\f0b53";
}

.mdi-account-arrow-right-outline::before {
  content: "\\f0b54";
}

.mdi-account-arrow-up::before {
  content: "\\f1867";
}

.mdi-account-arrow-up-outline::before {
  content: "\\f186a";
}

.mdi-account-box::before {
  content: "\\f0006";
}

.mdi-account-box-multiple::before {
  content: "\\f0934";
}

.mdi-account-box-multiple-outline::before {
  content: "\\f100a";
}

.mdi-account-box-outline::before {
  content: "\\f0007";
}

.mdi-account-cancel::before {
  content: "\\f12df";
}

.mdi-account-cancel-outline::before {
  content: "\\f12e0";
}

.mdi-account-cash::before {
  content: "\\f1097";
}

.mdi-account-cash-outline::before {
  content: "\\f1098";
}

.mdi-account-check::before {
  content: "\\f0008";
}

.mdi-account-check-outline::before {
  content: "\\f0be2";
}

.mdi-account-child::before {
  content: "\\f0a89";
}

.mdi-account-child-circle::before {
  content: "\\f0a8a";
}

.mdi-account-child-outline::before {
  content: "\\f10c8";
}

.mdi-account-circle::before {
  content: "\\f0009";
}

.mdi-account-circle-outline::before {
  content: "\\f0b55";
}

.mdi-account-clock::before {
  content: "\\f0b56";
}

.mdi-account-clock-outline::before {
  content: "\\f0b57";
}

.mdi-account-cog::before {
  content: "\\f1370";
}

.mdi-account-cog-outline::before {
  content: "\\f1371";
}

.mdi-account-convert::before {
  content: "\\f000a";
}

.mdi-account-convert-outline::before {
  content: "\\f1301";
}

.mdi-account-cowboy-hat::before {
  content: "\\f0e9b";
}

.mdi-account-cowboy-hat-outline::before {
  content: "\\f17f3";
}

.mdi-account-details::before {
  content: "\\f0631";
}

.mdi-account-details-outline::before {
  content: "\\f1372";
}

.mdi-account-edit::before {
  content: "\\f06bc";
}

.mdi-account-edit-outline::before {
  content: "\\f0ffb";
}

.mdi-account-eye::before {
  content: "\\f0420";
}

.mdi-account-eye-outline::before {
  content: "\\f127b";
}

.mdi-account-filter::before {
  content: "\\f0936";
}

.mdi-account-filter-outline::before {
  content: "\\f0f9d";
}

.mdi-account-group::before {
  content: "\\f0849";
}

.mdi-account-group-outline::before {
  content: "\\f0b58";
}

.mdi-account-hard-hat::before {
  content: "\\f05b5";
}

.mdi-account-heart::before {
  content: "\\f0899";
}

.mdi-account-heart-outline::before {
  content: "\\f0be3";
}

.mdi-account-injury::before {
  content: "\\f1815";
}

.mdi-account-injury-outline::before {
  content: "\\f1816";
}

.mdi-account-key::before {
  content: "\\f000b";
}

.mdi-account-key-outline::before {
  content: "\\f0be4";
}

.mdi-account-lock::before {
  content: "\\f115e";
}

.mdi-account-lock-open::before {
  content: "\\f1960";
}

.mdi-account-lock-open-outline::before {
  content: "\\f1961";
}

.mdi-account-lock-outline::before {
  content: "\\f115f";
}

.mdi-account-minus::before {
  content: "\\f000d";
}

.mdi-account-minus-outline::before {
  content: "\\f0aec";
}

.mdi-account-multiple::before {
  content: "\\f000e";
}

.mdi-account-multiple-check::before {
  content: "\\f08c5";
}

.mdi-account-multiple-check-outline::before {
  content: "\\f11fe";
}

.mdi-account-multiple-minus::before {
  content: "\\f05d3";
}

.mdi-account-multiple-minus-outline::before {
  content: "\\f0be5";
}

.mdi-account-multiple-outline::before {
  content: "\\f000f";
}

.mdi-account-multiple-plus::before {
  content: "\\f0010";
}

.mdi-account-multiple-plus-outline::before {
  content: "\\f0800";
}

.mdi-account-multiple-remove::before {
  content: "\\f120a";
}

.mdi-account-multiple-remove-outline::before {
  content: "\\f120b";
}

.mdi-account-music::before {
  content: "\\f0803";
}

.mdi-account-music-outline::before {
  content: "\\f0ce9";
}

.mdi-account-network::before {
  content: "\\f0011";
}

.mdi-account-network-outline::before {
  content: "\\f0be6";
}

.mdi-account-off::before {
  content: "\\f0012";
}

.mdi-account-off-outline::before {
  content: "\\f0be7";
}

.mdi-account-outline::before {
  content: "\\f0013";
}

.mdi-account-plus::before {
  content: "\\f0014";
}

.mdi-account-plus-outline::before {
  content: "\\f0801";
}

.mdi-account-question::before {
  content: "\\f0b59";
}

.mdi-account-question-outline::before {
  content: "\\f0b5a";
}

.mdi-account-reactivate::before {
  content: "\\f152b";
}

.mdi-account-reactivate-outline::before {
  content: "\\f152c";
}

.mdi-account-remove::before {
  content: "\\f0015";
}

.mdi-account-remove-outline::before {
  content: "\\f0aed";
}

.mdi-account-search::before {
  content: "\\f0016";
}

.mdi-account-search-outline::before {
  content: "\\f0935";
}

.mdi-account-settings::before {
  content: "\\f0630";
}

.mdi-account-settings-outline::before {
  content: "\\f10c9";
}

.mdi-account-star::before {
  content: "\\f0017";
}

.mdi-account-star-outline::before {
  content: "\\f0be8";
}

.mdi-account-supervisor::before {
  content: "\\f0a8b";
}

.mdi-account-supervisor-circle::before {
  content: "\\f0a8c";
}

.mdi-account-supervisor-circle-outline::before {
  content: "\\f14ec";
}

.mdi-account-supervisor-outline::before {
  content: "\\f112d";
}

.mdi-account-switch::before {
  content: "\\f0019";
}

.mdi-account-switch-outline::before {
  content: "\\f04cb";
}

.mdi-account-sync::before {
  content: "\\f191b";
}

.mdi-account-sync-outline::before {
  content: "\\f191c";
}

.mdi-account-tie::before {
  content: "\\f0ce3";
}

.mdi-account-tie-hat::before {
  content: "\\f1898";
}

.mdi-account-tie-hat-outline::before {
  content: "\\f1899";
}

.mdi-account-tie-outline::before {
  content: "\\f10ca";
}

.mdi-account-tie-voice::before {
  content: "\\f1308";
}

.mdi-account-tie-voice-off::before {
  content: "\\f130a";
}

.mdi-account-tie-voice-off-outline::before {
  content: "\\f130b";
}

.mdi-account-tie-voice-outline::before {
  content: "\\f1309";
}

.mdi-account-voice::before {
  content: "\\f05cb";
}

.mdi-account-voice-off::before {
  content: "\\f0ed4";
}

.mdi-account-wrench::before {
  content: "\\f189a";
}

.mdi-account-wrench-outline::before {
  content: "\\f189b";
}

.mdi-adjust::before {
  content: "\\f001a";
}

.mdi-advertisements::before {
  content: "\\f192a";
}

.mdi-advertisements-off::before {
  content: "\\f192b";
}

.mdi-air-conditioner::before {
  content: "\\f001b";
}

.mdi-air-filter::before {
  content: "\\f0d43";
}

.mdi-air-horn::before {
  content: "\\f0dac";
}

.mdi-air-humidifier::before {
  content: "\\f1099";
}

.mdi-air-humidifier-off::before {
  content: "\\f1466";
}

.mdi-air-purifier::before {
  content: "\\f0d44";
}

.mdi-airbag::before {
  content: "\\f0be9";
}

.mdi-airballoon::before {
  content: "\\f001c";
}

.mdi-airballoon-outline::before {
  content: "\\f100b";
}

.mdi-airplane::before {
  content: "\\f001d";
}

.mdi-airplane-alert::before {
  content: "\\f187a";
}

.mdi-airplane-check::before {
  content: "\\f187b";
}

.mdi-airplane-clock::before {
  content: "\\f187c";
}

.mdi-airplane-cog::before {
  content: "\\f187d";
}

.mdi-airplane-edit::before {
  content: "\\f187e";
}

.mdi-airplane-landing::before {
  content: "\\f05d4";
}

.mdi-airplane-marker::before {
  content: "\\f187f";
}

.mdi-airplane-minus::before {
  content: "\\f1880";
}

.mdi-airplane-off::before {
  content: "\\f001e";
}

.mdi-airplane-plus::before {
  content: "\\f1881";
}

.mdi-airplane-remove::before {
  content: "\\f1882";
}

.mdi-airplane-search::before {
  content: "\\f1883";
}

.mdi-airplane-settings::before {
  content: "\\f1884";
}

.mdi-airplane-takeoff::before {
  content: "\\f05d5";
}

.mdi-airport::before {
  content: "\\f084b";
}

.mdi-alarm::before {
  content: "\\f0020";
}

.mdi-alarm-bell::before {
  content: "\\f078e";
}

.mdi-alarm-check::before {
  content: "\\f0021";
}

.mdi-alarm-light::before {
  content: "\\f078f";
}

.mdi-alarm-light-off::before {
  content: "\\f171e";
}

.mdi-alarm-light-off-outline::before {
  content: "\\f171f";
}

.mdi-alarm-light-outline::before {
  content: "\\f0bea";
}

.mdi-alarm-multiple::before {
  content: "\\f0022";
}

.mdi-alarm-note::before {
  content: "\\f0e71";
}

.mdi-alarm-note-off::before {
  content: "\\f0e72";
}

.mdi-alarm-off::before {
  content: "\\f0023";
}

.mdi-alarm-panel::before {
  content: "\\f15c4";
}

.mdi-alarm-panel-outline::before {
  content: "\\f15c5";
}

.mdi-alarm-plus::before {
  content: "\\f0024";
}

.mdi-alarm-snooze::before {
  content: "\\f068e";
}

.mdi-album::before {
  content: "\\f0025";
}

.mdi-alert::before {
  content: "\\f0026";
}

.mdi-alert-box::before {
  content: "\\f0027";
}

.mdi-alert-box-outline::before {
  content: "\\f0ce4";
}

.mdi-alert-circle::before {
  content: "\\f0028";
}

.mdi-alert-circle-check::before {
  content: "\\f11ed";
}

.mdi-alert-circle-check-outline::before {
  content: "\\f11ee";
}

.mdi-alert-circle-outline::before {
  content: "\\f05d6";
}

.mdi-alert-decagram::before {
  content: "\\f06bd";
}

.mdi-alert-decagram-outline::before {
  content: "\\f0ce5";
}

.mdi-alert-minus::before {
  content: "\\f14bb";
}

.mdi-alert-minus-outline::before {
  content: "\\f14be";
}

.mdi-alert-octagon::before {
  content: "\\f0029";
}

.mdi-alert-octagon-outline::before {
  content: "\\f0ce6";
}

.mdi-alert-octagram::before {
  content: "\\f0767";
}

.mdi-alert-octagram-outline::before {
  content: "\\f0ce7";
}

.mdi-alert-outline::before {
  content: "\\f002a";
}

.mdi-alert-plus::before {
  content: "\\f14ba";
}

.mdi-alert-plus-outline::before {
  content: "\\f14bd";
}

.mdi-alert-remove::before {
  content: "\\f14bc";
}

.mdi-alert-remove-outline::before {
  content: "\\f14bf";
}

.mdi-alert-rhombus::before {
  content: "\\f11ce";
}

.mdi-alert-rhombus-outline::before {
  content: "\\f11cf";
}

.mdi-alien::before {
  content: "\\f089a";
}

.mdi-alien-outline::before {
  content: "\\f10cb";
}

.mdi-align-horizontal-center::before {
  content: "\\f11c3";
}

.mdi-align-horizontal-distribute::before {
  content: "\\f1962";
}

.mdi-align-horizontal-left::before {
  content: "\\f11c2";
}

.mdi-align-horizontal-right::before {
  content: "\\f11c4";
}

.mdi-align-vertical-bottom::before {
  content: "\\f11c5";
}

.mdi-align-vertical-center::before {
  content: "\\f11c6";
}

.mdi-align-vertical-distribute::before {
  content: "\\f1963";
}

.mdi-align-vertical-top::before {
  content: "\\f11c7";
}

.mdi-all-inclusive::before {
  content: "\\f06be";
}

.mdi-all-inclusive-box::before {
  content: "\\f188d";
}

.mdi-all-inclusive-box-outline::before {
  content: "\\f188e";
}

.mdi-allergy::before {
  content: "\\f1258";
}

.mdi-alpha::before {
  content: "\\f002b";
}

.mdi-alpha-a::before {
  content: "\\f0aee";
}

.mdi-alpha-a-box::before {
  content: "\\f0b08";
}

.mdi-alpha-a-box-outline::before {
  content: "\\f0beb";
}

.mdi-alpha-a-circle::before {
  content: "\\f0bec";
}

.mdi-alpha-a-circle-outline::before {
  content: "\\f0bed";
}

.mdi-alpha-b::before {
  content: "\\f0aef";
}

.mdi-alpha-b-box::before {
  content: "\\f0b09";
}

.mdi-alpha-b-box-outline::before {
  content: "\\f0bee";
}

.mdi-alpha-b-circle::before {
  content: "\\f0bef";
}

.mdi-alpha-b-circle-outline::before {
  content: "\\f0bf0";
}

.mdi-alpha-c::before {
  content: "\\f0af0";
}

.mdi-alpha-c-box::before {
  content: "\\f0b0a";
}

.mdi-alpha-c-box-outline::before {
  content: "\\f0bf1";
}

.mdi-alpha-c-circle::before {
  content: "\\f0bf2";
}

.mdi-alpha-c-circle-outline::before {
  content: "\\f0bf3";
}

.mdi-alpha-d::before {
  content: "\\f0af1";
}

.mdi-alpha-d-box::before {
  content: "\\f0b0b";
}

.mdi-alpha-d-box-outline::before {
  content: "\\f0bf4";
}

.mdi-alpha-d-circle::before {
  content: "\\f0bf5";
}

.mdi-alpha-d-circle-outline::before {
  content: "\\f0bf6";
}

.mdi-alpha-e::before {
  content: "\\f0af2";
}

.mdi-alpha-e-box::before {
  content: "\\f0b0c";
}

.mdi-alpha-e-box-outline::before {
  content: "\\f0bf7";
}

.mdi-alpha-e-circle::before {
  content: "\\f0bf8";
}

.mdi-alpha-e-circle-outline::before {
  content: "\\f0bf9";
}

.mdi-alpha-f::before {
  content: "\\f0af3";
}

.mdi-alpha-f-box::before {
  content: "\\f0b0d";
}

.mdi-alpha-f-box-outline::before {
  content: "\\f0bfa";
}

.mdi-alpha-f-circle::before {
  content: "\\f0bfb";
}

.mdi-alpha-f-circle-outline::before {
  content: "\\f0bfc";
}

.mdi-alpha-g::before {
  content: "\\f0af4";
}

.mdi-alpha-g-box::before {
  content: "\\f0b0e";
}

.mdi-alpha-g-box-outline::before {
  content: "\\f0bfd";
}

.mdi-alpha-g-circle::before {
  content: "\\f0bfe";
}

.mdi-alpha-g-circle-outline::before {
  content: "\\f0bff";
}

.mdi-alpha-h::before {
  content: "\\f0af5";
}

.mdi-alpha-h-box::before {
  content: "\\f0b0f";
}

.mdi-alpha-h-box-outline::before {
  content: "\\f0c00";
}

.mdi-alpha-h-circle::before {
  content: "\\f0c01";
}

.mdi-alpha-h-circle-outline::before {
  content: "\\f0c02";
}

.mdi-alpha-i::before {
  content: "\\f0af6";
}

.mdi-alpha-i-box::before {
  content: "\\f0b10";
}

.mdi-alpha-i-box-outline::before {
  content: "\\f0c03";
}

.mdi-alpha-i-circle::before {
  content: "\\f0c04";
}

.mdi-alpha-i-circle-outline::before {
  content: "\\f0c05";
}

.mdi-alpha-j::before {
  content: "\\f0af7";
}

.mdi-alpha-j-box::before {
  content: "\\f0b11";
}

.mdi-alpha-j-box-outline::before {
  content: "\\f0c06";
}

.mdi-alpha-j-circle::before {
  content: "\\f0c07";
}

.mdi-alpha-j-circle-outline::before {
  content: "\\f0c08";
}

.mdi-alpha-k::before {
  content: "\\f0af8";
}

.mdi-alpha-k-box::before {
  content: "\\f0b12";
}

.mdi-alpha-k-box-outline::before {
  content: "\\f0c09";
}

.mdi-alpha-k-circle::before {
  content: "\\f0c0a";
}

.mdi-alpha-k-circle-outline::before {
  content: "\\f0c0b";
}

.mdi-alpha-l::before {
  content: "\\f0af9";
}

.mdi-alpha-l-box::before {
  content: "\\f0b13";
}

.mdi-alpha-l-box-outline::before {
  content: "\\f0c0c";
}

.mdi-alpha-l-circle::before {
  content: "\\f0c0d";
}

.mdi-alpha-l-circle-outline::before {
  content: "\\f0c0e";
}

.mdi-alpha-m::before {
  content: "\\f0afa";
}

.mdi-alpha-m-box::before {
  content: "\\f0b14";
}

.mdi-alpha-m-box-outline::before {
  content: "\\f0c0f";
}

.mdi-alpha-m-circle::before {
  content: "\\f0c10";
}

.mdi-alpha-m-circle-outline::before {
  content: "\\f0c11";
}

.mdi-alpha-n::before {
  content: "\\f0afb";
}

.mdi-alpha-n-box::before {
  content: "\\f0b15";
}

.mdi-alpha-n-box-outline::before {
  content: "\\f0c12";
}

.mdi-alpha-n-circle::before {
  content: "\\f0c13";
}

.mdi-alpha-n-circle-outline::before {
  content: "\\f0c14";
}

.mdi-alpha-o::before {
  content: "\\f0afc";
}

.mdi-alpha-o-box::before {
  content: "\\f0b16";
}

.mdi-alpha-o-box-outline::before {
  content: "\\f0c15";
}

.mdi-alpha-o-circle::before {
  content: "\\f0c16";
}

.mdi-alpha-o-circle-outline::before {
  content: "\\f0c17";
}

.mdi-alpha-p::before {
  content: "\\f0afd";
}

.mdi-alpha-p-box::before {
  content: "\\f0b17";
}

.mdi-alpha-p-box-outline::before {
  content: "\\f0c18";
}

.mdi-alpha-p-circle::before {
  content: "\\f0c19";
}

.mdi-alpha-p-circle-outline::before {
  content: "\\f0c1a";
}

.mdi-alpha-q::before {
  content: "\\f0afe";
}

.mdi-alpha-q-box::before {
  content: "\\f0b18";
}

.mdi-alpha-q-box-outline::before {
  content: "\\f0c1b";
}

.mdi-alpha-q-circle::before {
  content: "\\f0c1c";
}

.mdi-alpha-q-circle-outline::before {
  content: "\\f0c1d";
}

.mdi-alpha-r::before {
  content: "\\f0aff";
}

.mdi-alpha-r-box::before {
  content: "\\f0b19";
}

.mdi-alpha-r-box-outline::before {
  content: "\\f0c1e";
}

.mdi-alpha-r-circle::before {
  content: "\\f0c1f";
}

.mdi-alpha-r-circle-outline::before {
  content: "\\f0c20";
}

.mdi-alpha-s::before {
  content: "\\f0b00";
}

.mdi-alpha-s-box::before {
  content: "\\f0b1a";
}

.mdi-alpha-s-box-outline::before {
  content: "\\f0c21";
}

.mdi-alpha-s-circle::before {
  content: "\\f0c22";
}

.mdi-alpha-s-circle-outline::before {
  content: "\\f0c23";
}

.mdi-alpha-t::before {
  content: "\\f0b01";
}

.mdi-alpha-t-box::before {
  content: "\\f0b1b";
}

.mdi-alpha-t-box-outline::before {
  content: "\\f0c24";
}

.mdi-alpha-t-circle::before {
  content: "\\f0c25";
}

.mdi-alpha-t-circle-outline::before {
  content: "\\f0c26";
}

.mdi-alpha-u::before {
  content: "\\f0b02";
}

.mdi-alpha-u-box::before {
  content: "\\f0b1c";
}

.mdi-alpha-u-box-outline::before {
  content: "\\f0c27";
}

.mdi-alpha-u-circle::before {
  content: "\\f0c28";
}

.mdi-alpha-u-circle-outline::before {
  content: "\\f0c29";
}

.mdi-alpha-v::before {
  content: "\\f0b03";
}

.mdi-alpha-v-box::before {
  content: "\\f0b1d";
}

.mdi-alpha-v-box-outline::before {
  content: "\\f0c2a";
}

.mdi-alpha-v-circle::before {
  content: "\\f0c2b";
}

.mdi-alpha-v-circle-outline::before {
  content: "\\f0c2c";
}

.mdi-alpha-w::before {
  content: "\\f0b04";
}

.mdi-alpha-w-box::before {
  content: "\\f0b1e";
}

.mdi-alpha-w-box-outline::before {
  content: "\\f0c2d";
}

.mdi-alpha-w-circle::before {
  content: "\\f0c2e";
}

.mdi-alpha-w-circle-outline::before {
  content: "\\f0c2f";
}

.mdi-alpha-x::before {
  content: "\\f0b05";
}

.mdi-alpha-x-box::before {
  content: "\\f0b1f";
}

.mdi-alpha-x-box-outline::before {
  content: "\\f0c30";
}

.mdi-alpha-x-circle::before {
  content: "\\f0c31";
}

.mdi-alpha-x-circle-outline::before {
  content: "\\f0c32";
}

.mdi-alpha-y::before {
  content: "\\f0b06";
}

.mdi-alpha-y-box::before {
  content: "\\f0b20";
}

.mdi-alpha-y-box-outline::before {
  content: "\\f0c33";
}

.mdi-alpha-y-circle::before {
  content: "\\f0c34";
}

.mdi-alpha-y-circle-outline::before {
  content: "\\f0c35";
}

.mdi-alpha-z::before {
  content: "\\f0b07";
}

.mdi-alpha-z-box::before {
  content: "\\f0b21";
}

.mdi-alpha-z-box-outline::before {
  content: "\\f0c36";
}

.mdi-alpha-z-circle::before {
  content: "\\f0c37";
}

.mdi-alpha-z-circle-outline::before {
  content: "\\f0c38";
}

.mdi-alphabet-aurebesh::before {
  content: "\\f132c";
}

.mdi-alphabet-cyrillic::before {
  content: "\\f132d";
}

.mdi-alphabet-greek::before {
  content: "\\f132e";
}

.mdi-alphabet-latin::before {
  content: "\\f132f";
}

.mdi-alphabet-piqad::before {
  content: "\\f1330";
}

.mdi-alphabet-tengwar::before {
  content: "\\f1337";
}

.mdi-alphabetical::before {
  content: "\\f002c";
}

.mdi-alphabetical-off::before {
  content: "\\f100c";
}

.mdi-alphabetical-variant::before {
  content: "\\f100d";
}

.mdi-alphabetical-variant-off::before {
  content: "\\f100e";
}

.mdi-altimeter::before {
  content: "\\f05d7";
}

.mdi-ambulance::before {
  content: "\\f002f";
}

.mdi-ammunition::before {
  content: "\\f0ce8";
}

.mdi-ampersand::before {
  content: "\\f0a8d";
}

.mdi-amplifier::before {
  content: "\\f0030";
}

.mdi-amplifier-off::before {
  content: "\\f11b5";
}

.mdi-anchor::before {
  content: "\\f0031";
}

.mdi-android::before {
  content: "\\f0032";
}

.mdi-android-messages::before {
  content: "\\f0d45";
}

.mdi-android-studio::before {
  content: "\\f0034";
}

.mdi-angle-acute::before {
  content: "\\f0937";
}

.mdi-angle-obtuse::before {
  content: "\\f0938";
}

.mdi-angle-right::before {
  content: "\\f0939";
}

.mdi-angular::before {
  content: "\\f06b2";
}

.mdi-angularjs::before {
  content: "\\f06bf";
}

.mdi-animation::before {
  content: "\\f05d8";
}

.mdi-animation-outline::before {
  content: "\\f0a8f";
}

.mdi-animation-play::before {
  content: "\\f093a";
}

.mdi-animation-play-outline::before {
  content: "\\f0a90";
}

.mdi-ansible::before {
  content: "\\f109a";
}

.mdi-antenna::before {
  content: "\\f1119";
}

.mdi-anvil::before {
  content: "\\f089b";
}

.mdi-apache-kafka::before {
  content: "\\f100f";
}

.mdi-api::before {
  content: "\\f109b";
}

.mdi-api-off::before {
  content: "\\f1257";
}

.mdi-apple::before {
  content: "\\f0035";
}

.mdi-apple-finder::before {
  content: "\\f0036";
}

.mdi-apple-icloud::before {
  content: "\\f0038";
}

.mdi-apple-ios::before {
  content: "\\f0037";
}

.mdi-apple-keyboard-caps::before {
  content: "\\f0632";
}

.mdi-apple-keyboard-command::before {
  content: "\\f0633";
}

.mdi-apple-keyboard-control::before {
  content: "\\f0634";
}

.mdi-apple-keyboard-option::before {
  content: "\\f0635";
}

.mdi-apple-keyboard-shift::before {
  content: "\\f0636";
}

.mdi-apple-safari::before {
  content: "\\f0039";
}

.mdi-application::before {
  content: "\\f08c6";
}

.mdi-application-array::before {
  content: "\\f10f5";
}

.mdi-application-array-outline::before {
  content: "\\f10f6";
}

.mdi-application-braces::before {
  content: "\\f10f7";
}

.mdi-application-braces-outline::before {
  content: "\\f10f8";
}

.mdi-application-brackets::before {
  content: "\\f0c8b";
}

.mdi-application-brackets-outline::before {
  content: "\\f0c8c";
}

.mdi-application-cog::before {
  content: "\\f0675";
}

.mdi-application-cog-outline::before {
  content: "\\f1577";
}

.mdi-application-edit::before {
  content: "\\f00ae";
}

.mdi-application-edit-outline::before {
  content: "\\f0619";
}

.mdi-application-export::before {
  content: "\\f0dad";
}

.mdi-application-import::before {
  content: "\\f0dae";
}

.mdi-application-outline::before {
  content: "\\f0614";
}

.mdi-application-parentheses::before {
  content: "\\f10f9";
}

.mdi-application-parentheses-outline::before {
  content: "\\f10fa";
}

.mdi-application-settings::before {
  content: "\\f0b60";
}

.mdi-application-settings-outline::before {
  content: "\\f1555";
}

.mdi-application-variable::before {
  content: "\\f10fb";
}

.mdi-application-variable-outline::before {
  content: "\\f10fc";
}

.mdi-approximately-equal::before {
  content: "\\f0f9e";
}

.mdi-approximately-equal-box::before {
  content: "\\f0f9f";
}

.mdi-apps::before {
  content: "\\f003b";
}

.mdi-apps-box::before {
  content: "\\f0d46";
}

.mdi-arch::before {
  content: "\\f08c7";
}

.mdi-archive::before {
  content: "\\f003c";
}

.mdi-archive-alert::before {
  content: "\\f14fd";
}

.mdi-archive-alert-outline::before {
  content: "\\f14fe";
}

.mdi-archive-arrow-down::before {
  content: "\\f1259";
}

.mdi-archive-arrow-down-outline::before {
  content: "\\f125a";
}

.mdi-archive-arrow-up::before {
  content: "\\f125b";
}

.mdi-archive-arrow-up-outline::before {
  content: "\\f125c";
}

.mdi-archive-cancel::before {
  content: "\\f174b";
}

.mdi-archive-cancel-outline::before {
  content: "\\f174c";
}

.mdi-archive-check::before {
  content: "\\f174d";
}

.mdi-archive-check-outline::before {
  content: "\\f174e";
}

.mdi-archive-clock::before {
  content: "\\f174f";
}

.mdi-archive-clock-outline::before {
  content: "\\f1750";
}

.mdi-archive-cog::before {
  content: "\\f1751";
}

.mdi-archive-cog-outline::before {
  content: "\\f1752";
}

.mdi-archive-edit::before {
  content: "\\f1753";
}

.mdi-archive-edit-outline::before {
  content: "\\f1754";
}

.mdi-archive-eye::before {
  content: "\\f1755";
}

.mdi-archive-eye-outline::before {
  content: "\\f1756";
}

.mdi-archive-lock::before {
  content: "\\f1757";
}

.mdi-archive-lock-open::before {
  content: "\\f1758";
}

.mdi-archive-lock-open-outline::before {
  content: "\\f1759";
}

.mdi-archive-lock-outline::before {
  content: "\\f175a";
}

.mdi-archive-marker::before {
  content: "\\f175b";
}

.mdi-archive-marker-outline::before {
  content: "\\f175c";
}

.mdi-archive-minus::before {
  content: "\\f175d";
}

.mdi-archive-minus-outline::before {
  content: "\\f175e";
}

.mdi-archive-music::before {
  content: "\\f175f";
}

.mdi-archive-music-outline::before {
  content: "\\f1760";
}

.mdi-archive-off::before {
  content: "\\f1761";
}

.mdi-archive-off-outline::before {
  content: "\\f1762";
}

.mdi-archive-outline::before {
  content: "\\f120e";
}

.mdi-archive-plus::before {
  content: "\\f1763";
}

.mdi-archive-plus-outline::before {
  content: "\\f1764";
}

.mdi-archive-refresh::before {
  content: "\\f1765";
}

.mdi-archive-refresh-outline::before {
  content: "\\f1766";
}

.mdi-archive-remove::before {
  content: "\\f1767";
}

.mdi-archive-remove-outline::before {
  content: "\\f1768";
}

.mdi-archive-search::before {
  content: "\\f1769";
}

.mdi-archive-search-outline::before {
  content: "\\f176a";
}

.mdi-archive-settings::before {
  content: "\\f176b";
}

.mdi-archive-settings-outline::before {
  content: "\\f176c";
}

.mdi-archive-star::before {
  content: "\\f176d";
}

.mdi-archive-star-outline::before {
  content: "\\f176e";
}

.mdi-archive-sync::before {
  content: "\\f176f";
}

.mdi-archive-sync-outline::before {
  content: "\\f1770";
}

.mdi-arm-flex::before {
  content: "\\f0fd7";
}

.mdi-arm-flex-outline::before {
  content: "\\f0fd6";
}

.mdi-arrange-bring-forward::before {
  content: "\\f003d";
}

.mdi-arrange-bring-to-front::before {
  content: "\\f003e";
}

.mdi-arrange-send-backward::before {
  content: "\\f003f";
}

.mdi-arrange-send-to-back::before {
  content: "\\f0040";
}

.mdi-arrow-all::before {
  content: "\\f0041";
}

.mdi-arrow-bottom-left::before {
  content: "\\f0042";
}

.mdi-arrow-bottom-left-bold-box::before {
  content: "\\f1964";
}

.mdi-arrow-bottom-left-bold-box-outline::before {
  content: "\\f1965";
}

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\f09b7";
}

.mdi-arrow-bottom-left-thick::before {
  content: "\\f09b8";
}

.mdi-arrow-bottom-left-thin::before {
  content: "\\f19b6";
}

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\f1596";
}

.mdi-arrow-bottom-right::before {
  content: "\\f0043";
}

.mdi-arrow-bottom-right-bold-box::before {
  content: "\\f1966";
}

.mdi-arrow-bottom-right-bold-box-outline::before {
  content: "\\f1967";
}

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\f09b9";
}

.mdi-arrow-bottom-right-thick::before {
  content: "\\f09ba";
}

.mdi-arrow-bottom-right-thin::before {
  content: "\\f19b7";
}

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\f1595";
}

.mdi-arrow-collapse::before {
  content: "\\f0615";
}

.mdi-arrow-collapse-all::before {
  content: "\\f0044";
}

.mdi-arrow-collapse-down::before {
  content: "\\f0792";
}

.mdi-arrow-collapse-horizontal::before {
  content: "\\f084c";
}

.mdi-arrow-collapse-left::before {
  content: "\\f0793";
}

.mdi-arrow-collapse-right::before {
  content: "\\f0794";
}

.mdi-arrow-collapse-up::before {
  content: "\\f0795";
}

.mdi-arrow-collapse-vertical::before {
  content: "\\f084d";
}

.mdi-arrow-decision::before {
  content: "\\f09bb";
}

.mdi-arrow-decision-auto::before {
  content: "\\f09bc";
}

.mdi-arrow-decision-auto-outline::before {
  content: "\\f09bd";
}

.mdi-arrow-decision-outline::before {
  content: "\\f09be";
}

.mdi-arrow-down::before {
  content: "\\f0045";
}

.mdi-arrow-down-bold::before {
  content: "\\f072e";
}

.mdi-arrow-down-bold-box::before {
  content: "\\f072f";
}

.mdi-arrow-down-bold-box-outline::before {
  content: "\\f0730";
}

.mdi-arrow-down-bold-circle::before {
  content: "\\f0047";
}

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\f0048";
}

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\f0049";
}

.mdi-arrow-down-bold-outline::before {
  content: "\\f09bf";
}

.mdi-arrow-down-box::before {
  content: "\\f06c0";
}

.mdi-arrow-down-circle::before {
  content: "\\f0cdb";
}

.mdi-arrow-down-circle-outline::before {
  content: "\\f0cdc";
}

.mdi-arrow-down-drop-circle::before {
  content: "\\f004a";
}

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\f004b";
}

.mdi-arrow-down-left::before {
  content: "\\f17a1";
}

.mdi-arrow-down-left-bold::before {
  content: "\\f17a2";
}

.mdi-arrow-down-right::before {
  content: "\\f17a3";
}

.mdi-arrow-down-right-bold::before {
  content: "\\f17a4";
}

.mdi-arrow-down-thick::before {
  content: "\\f0046";
}

.mdi-arrow-down-thin::before {
  content: "\\f19b3";
}

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\f1599";
}

.mdi-arrow-expand::before {
  content: "\\f0616";
}

.mdi-arrow-expand-all::before {
  content: "\\f004c";
}

.mdi-arrow-expand-down::before {
  content: "\\f0796";
}

.mdi-arrow-expand-horizontal::before {
  content: "\\f084e";
}

.mdi-arrow-expand-left::before {
  content: "\\f0797";
}

.mdi-arrow-expand-right::before {
  content: "\\f0798";
}

.mdi-arrow-expand-up::before {
  content: "\\f0799";
}

.mdi-arrow-expand-vertical::before {
  content: "\\f084f";
}

.mdi-arrow-horizontal-lock::before {
  content: "\\f115b";
}

.mdi-arrow-left::before {
  content: "\\f004d";
}

.mdi-arrow-left-bold::before {
  content: "\\f0731";
}

.mdi-arrow-left-bold-box::before {
  content: "\\f0732";
}

.mdi-arrow-left-bold-box-outline::before {
  content: "\\f0733";
}

.mdi-arrow-left-bold-circle::before {
  content: "\\f004f";
}

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\f0050";
}

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\f0051";
}

.mdi-arrow-left-bold-outline::before {
  content: "\\f09c0";
}

.mdi-arrow-left-bottom::before {
  content: "\\f17a5";
}

.mdi-arrow-left-bottom-bold::before {
  content: "\\f17a6";
}

.mdi-arrow-left-box::before {
  content: "\\f06c1";
}

.mdi-arrow-left-circle::before {
  content: "\\f0cdd";
}

.mdi-arrow-left-circle-outline::before {
  content: "\\f0cde";
}

.mdi-arrow-left-drop-circle::before {
  content: "\\f0052";
}

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\f0053";
}

.mdi-arrow-left-right::before {
  content: "\\f0e73";
}

.mdi-arrow-left-right-bold::before {
  content: "\\f0e74";
}

.mdi-arrow-left-right-bold-outline::before {
  content: "\\f09c1";
}

.mdi-arrow-left-thick::before {
  content: "\\f004e";
}

.mdi-arrow-left-thin::before {
  content: "\\f19b1";
}

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\f159a";
}

.mdi-arrow-left-top::before {
  content: "\\f17a7";
}

.mdi-arrow-left-top-bold::before {
  content: "\\f17a8";
}

.mdi-arrow-projectile::before {
  content: "\\f1840";
}

.mdi-arrow-projectile-multiple::before {
  content: "\\f183f";
}

.mdi-arrow-right::before {
  content: "\\f0054";
}

.mdi-arrow-right-bold::before {
  content: "\\f0734";
}

.mdi-arrow-right-bold-box::before {
  content: "\\f0735";
}

.mdi-arrow-right-bold-box-outline::before {
  content: "\\f0736";
}

.mdi-arrow-right-bold-circle::before {
  content: "\\f0056";
}

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\f0057";
}

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\f0058";
}

.mdi-arrow-right-bold-outline::before {
  content: "\\f09c2";
}

.mdi-arrow-right-bottom::before {
  content: "\\f17a9";
}

.mdi-arrow-right-bottom-bold::before {
  content: "\\f17aa";
}

.mdi-arrow-right-box::before {
  content: "\\f06c2";
}

.mdi-arrow-right-circle::before {
  content: "\\f0cdf";
}

.mdi-arrow-right-circle-outline::before {
  content: "\\f0ce0";
}

.mdi-arrow-right-drop-circle::before {
  content: "\\f0059";
}

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\f005a";
}

.mdi-arrow-right-thick::before {
  content: "\\f0055";
}

.mdi-arrow-right-thin::before {
  content: "\\f19b0";
}

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\f1598";
}

.mdi-arrow-right-top::before {
  content: "\\f17ab";
}

.mdi-arrow-right-top-bold::before {
  content: "\\f17ac";
}

.mdi-arrow-split-horizontal::before {
  content: "\\f093b";
}

.mdi-arrow-split-vertical::before {
  content: "\\f093c";
}

.mdi-arrow-top-left::before {
  content: "\\f005b";
}

.mdi-arrow-top-left-bold-box::before {
  content: "\\f1968";
}

.mdi-arrow-top-left-bold-box-outline::before {
  content: "\\f1969";
}

.mdi-arrow-top-left-bold-outline::before {
  content: "\\f09c3";
}

.mdi-arrow-top-left-bottom-right::before {
  content: "\\f0e75";
}

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\f0e76";
}

.mdi-arrow-top-left-thick::before {
  content: "\\f09c4";
}

.mdi-arrow-top-left-thin::before {
  content: "\\f19b5";
}

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\f1593";
}

.mdi-arrow-top-right::before {
  content: "\\f005c";
}

.mdi-arrow-top-right-bold-box::before {
  content: "\\f196a";
}

.mdi-arrow-top-right-bold-box-outline::before {
  content: "\\f196b";
}

.mdi-arrow-top-right-bold-outline::before {
  content: "\\f09c5";
}

.mdi-arrow-top-right-bottom-left::before {
  content: "\\f0e77";
}

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\f0e78";
}

.mdi-arrow-top-right-thick::before {
  content: "\\f09c6";
}

.mdi-arrow-top-right-thin::before {
  content: "\\f19b4";
}

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\f1594";
}

.mdi-arrow-u-down-left::before {
  content: "\\f17ad";
}

.mdi-arrow-u-down-left-bold::before {
  content: "\\f17ae";
}

.mdi-arrow-u-down-right::before {
  content: "\\f17af";
}

.mdi-arrow-u-down-right-bold::before {
  content: "\\f17b0";
}

.mdi-arrow-u-left-bottom::before {
  content: "\\f17b1";
}

.mdi-arrow-u-left-bottom-bold::before {
  content: "\\f17b2";
}

.mdi-arrow-u-left-top::before {
  content: "\\f17b3";
}

.mdi-arrow-u-left-top-bold::before {
  content: "\\f17b4";
}

.mdi-arrow-u-right-bottom::before {
  content: "\\f17b5";
}

.mdi-arrow-u-right-bottom-bold::before {
  content: "\\f17b6";
}

.mdi-arrow-u-right-top::before {
  content: "\\f17b7";
}

.mdi-arrow-u-right-top-bold::before {
  content: "\\f17b8";
}

.mdi-arrow-u-up-left::before {
  content: "\\f17b9";
}

.mdi-arrow-u-up-left-bold::before {
  content: "\\f17ba";
}

.mdi-arrow-u-up-right::before {
  content: "\\f17bb";
}

.mdi-arrow-u-up-right-bold::before {
  content: "\\f17bc";
}

.mdi-arrow-up::before {
  content: "\\f005d";
}

.mdi-arrow-up-bold::before {
  content: "\\f0737";
}

.mdi-arrow-up-bold-box::before {
  content: "\\f0738";
}

.mdi-arrow-up-bold-box-outline::before {
  content: "\\f0739";
}

.mdi-arrow-up-bold-circle::before {
  content: "\\f005f";
}

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\f0060";
}

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\f0061";
}

.mdi-arrow-up-bold-outline::before {
  content: "\\f09c7";
}

.mdi-arrow-up-box::before {
  content: "\\f06c3";
}

.mdi-arrow-up-circle::before {
  content: "\\f0ce1";
}

.mdi-arrow-up-circle-outline::before {
  content: "\\f0ce2";
}

.mdi-arrow-up-down::before {
  content: "\\f0e79";
}

.mdi-arrow-up-down-bold::before {
  content: "\\f0e7a";
}

.mdi-arrow-up-down-bold-outline::before {
  content: "\\f09c8";
}

.mdi-arrow-up-drop-circle::before {
  content: "\\f0062";
}

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\f0063";
}

.mdi-arrow-up-left::before {
  content: "\\f17bd";
}

.mdi-arrow-up-left-bold::before {
  content: "\\f17be";
}

.mdi-arrow-up-right::before {
  content: "\\f17bf";
}

.mdi-arrow-up-right-bold::before {
  content: "\\f17c0";
}

.mdi-arrow-up-thick::before {
  content: "\\f005e";
}

.mdi-arrow-up-thin::before {
  content: "\\f19b2";
}

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\f1597";
}

.mdi-arrow-vertical-lock::before {
  content: "\\f115c";
}

.mdi-artstation::before {
  content: "\\f0b5b";
}

.mdi-aspect-ratio::before {
  content: "\\f0a24";
}

.mdi-assistant::before {
  content: "\\f0064";
}

.mdi-asterisk::before {
  content: "\\f06c4";
}

.mdi-at::before {
  content: "\\f0065";
}

.mdi-atlassian::before {
  content: "\\f0804";
}

.mdi-atm::before {
  content: "\\f0d47";
}

.mdi-atom::before {
  content: "\\f0768";
}

.mdi-atom-variant::before {
  content: "\\f0e7b";
}

.mdi-attachment::before {
  content: "\\f0066";
}

.mdi-audio-input-rca::before {
  content: "\\f186b";
}

.mdi-audio-input-stereo-minijack::before {
  content: "\\f186c";
}

.mdi-audio-input-xlr::before {
  content: "\\f186d";
}

.mdi-audio-video::before {
  content: "\\f093d";
}

.mdi-audio-video-off::before {
  content: "\\f11b6";
}

.mdi-augmented-reality::before {
  content: "\\f0850";
}

.mdi-auto-download::before {
  content: "\\f137e";
}

.mdi-auto-fix::before {
  content: "\\f0068";
}

.mdi-auto-upload::before {
  content: "\\f0069";
}

.mdi-autorenew::before {
  content: "\\f006a";
}

.mdi-av-timer::before {
  content: "\\f006b";
}

.mdi-aws::before {
  content: "\\f0e0f";
}

.mdi-axe::before {
  content: "\\f08c8";
}

.mdi-axe-battle::before {
  content: "\\f1842";
}

.mdi-axis::before {
  content: "\\f0d48";
}

.mdi-axis-arrow::before {
  content: "\\f0d49";
}

.mdi-axis-arrow-info::before {
  content: "\\f140e";
}

.mdi-axis-arrow-lock::before {
  content: "\\f0d4a";
}

.mdi-axis-lock::before {
  content: "\\f0d4b";
}

.mdi-axis-x-arrow::before {
  content: "\\f0d4c";
}

.mdi-axis-x-arrow-lock::before {
  content: "\\f0d4d";
}

.mdi-axis-x-rotate-clockwise::before {
  content: "\\f0d4e";
}

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\f0d4f";
}

.mdi-axis-x-y-arrow-lock::before {
  content: "\\f0d50";
}

.mdi-axis-y-arrow::before {
  content: "\\f0d51";
}

.mdi-axis-y-arrow-lock::before {
  content: "\\f0d52";
}

.mdi-axis-y-rotate-clockwise::before {
  content: "\\f0d53";
}

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\f0d54";
}

.mdi-axis-z-arrow::before {
  content: "\\f0d55";
}

.mdi-axis-z-arrow-lock::before {
  content: "\\f0d56";
}

.mdi-axis-z-rotate-clockwise::before {
  content: "\\f0d57";
}

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\f0d58";
}

.mdi-babel::before {
  content: "\\f0a25";
}

.mdi-baby::before {
  content: "\\f006c";
}

.mdi-baby-bottle::before {
  content: "\\f0f39";
}

.mdi-baby-bottle-outline::before {
  content: "\\f0f3a";
}

.mdi-baby-buggy::before {
  content: "\\f13e0";
}

.mdi-baby-carriage::before {
  content: "\\f068f";
}

.mdi-baby-carriage-off::before {
  content: "\\f0fa0";
}

.mdi-baby-face::before {
  content: "\\f0e7c";
}

.mdi-baby-face-outline::before {
  content: "\\f0e7d";
}

.mdi-backburger::before {
  content: "\\f006d";
}

.mdi-backspace::before {
  content: "\\f006e";
}

.mdi-backspace-outline::before {
  content: "\\f0b5c";
}

.mdi-backspace-reverse::before {
  content: "\\f0e7e";
}

.mdi-backspace-reverse-outline::before {
  content: "\\f0e7f";
}

.mdi-backup-restore::before {
  content: "\\f006f";
}

.mdi-bacteria::before {
  content: "\\f0ed5";
}

.mdi-bacteria-outline::before {
  content: "\\f0ed6";
}

.mdi-badge-account::before {
  content: "\\f0da7";
}

.mdi-badge-account-alert::before {
  content: "\\f0da8";
}

.mdi-badge-account-alert-outline::before {
  content: "\\f0da9";
}

.mdi-badge-account-horizontal::before {
  content: "\\f0e0d";
}

.mdi-badge-account-horizontal-outline::before {
  content: "\\f0e0e";
}

.mdi-badge-account-outline::before {
  content: "\\f0daa";
}

.mdi-badminton::before {
  content: "\\f0851";
}

.mdi-bag-carry-on::before {
  content: "\\f0f3b";
}

.mdi-bag-carry-on-check::before {
  content: "\\f0d65";
}

.mdi-bag-carry-on-off::before {
  content: "\\f0f3c";
}

.mdi-bag-checked::before {
  content: "\\f0f3d";
}

.mdi-bag-personal::before {
  content: "\\f0e10";
}

.mdi-bag-personal-off::before {
  content: "\\f0e11";
}

.mdi-bag-personal-off-outline::before {
  content: "\\f0e12";
}

.mdi-bag-personal-outline::before {
  content: "\\f0e13";
}

.mdi-bag-suitcase::before {
  content: "\\f158b";
}

.mdi-bag-suitcase-off::before {
  content: "\\f158d";
}

.mdi-bag-suitcase-off-outline::before {
  content: "\\f158e";
}

.mdi-bag-suitcase-outline::before {
  content: "\\f158c";
}

.mdi-baguette::before {
  content: "\\f0f3e";
}

.mdi-balcony::before {
  content: "\\f1817";
}

.mdi-balloon::before {
  content: "\\f0a26";
}

.mdi-ballot::before {
  content: "\\f09c9";
}

.mdi-ballot-outline::before {
  content: "\\f09ca";
}

.mdi-ballot-recount::before {
  content: "\\f0c39";
}

.mdi-ballot-recount-outline::before {
  content: "\\f0c3a";
}

.mdi-bandage::before {
  content: "\\f0daf";
}

.mdi-bank::before {
  content: "\\f0070";
}

.mdi-bank-check::before {
  content: "\\f1655";
}

.mdi-bank-minus::before {
  content: "\\f0db0";
}

.mdi-bank-off::before {
  content: "\\f1656";
}

.mdi-bank-off-outline::before {
  content: "\\f1657";
}

.mdi-bank-outline::before {
  content: "\\f0e80";
}

.mdi-bank-plus::before {
  content: "\\f0db1";
}

.mdi-bank-remove::before {
  content: "\\f0db2";
}

.mdi-bank-transfer::before {
  content: "\\f0a27";
}

.mdi-bank-transfer-in::before {
  content: "\\f0a28";
}

.mdi-bank-transfer-out::before {
  content: "\\f0a29";
}

.mdi-barcode::before {
  content: "\\f0071";
}

.mdi-barcode-off::before {
  content: "\\f1236";
}

.mdi-barcode-scan::before {
  content: "\\f0072";
}

.mdi-barley::before {
  content: "\\f0073";
}

.mdi-barley-off::before {
  content: "\\f0b5d";
}

.mdi-barn::before {
  content: "\\f0b5e";
}

.mdi-barrel::before {
  content: "\\f0074";
}

.mdi-baseball::before {
  content: "\\f0852";
}

.mdi-baseball-bat::before {
  content: "\\f0853";
}

.mdi-baseball-diamond::before {
  content: "\\f15ec";
}

.mdi-baseball-diamond-outline::before {
  content: "\\f15ed";
}

.mdi-bash::before {
  content: "\\f1183";
}

.mdi-basket::before {
  content: "\\f0076";
}

.mdi-basket-check::before {
  content: "\\f18e5";
}

.mdi-basket-check-outline::before {
  content: "\\f18e6";
}

.mdi-basket-fill::before {
  content: "\\f0077";
}

.mdi-basket-minus::before {
  content: "\\f1523";
}

.mdi-basket-minus-outline::before {
  content: "\\f1524";
}

.mdi-basket-off::before {
  content: "\\f1525";
}

.mdi-basket-off-outline::before {
  content: "\\f1526";
}

.mdi-basket-outline::before {
  content: "\\f1181";
}

.mdi-basket-plus::before {
  content: "\\f1527";
}

.mdi-basket-plus-outline::before {
  content: "\\f1528";
}

.mdi-basket-remove::before {
  content: "\\f1529";
}

.mdi-basket-remove-outline::before {
  content: "\\f152a";
}

.mdi-basket-unfill::before {
  content: "\\f0078";
}

.mdi-basketball::before {
  content: "\\f0806";
}

.mdi-basketball-hoop::before {
  content: "\\f0c3b";
}

.mdi-basketball-hoop-outline::before {
  content: "\\f0c3c";
}

.mdi-bat::before {
  content: "\\f0b5f";
}

.mdi-bathtub::before {
  content: "\\f1818";
}

.mdi-bathtub-outline::before {
  content: "\\f1819";
}

.mdi-battery::before {
  content: "\\f0079";
}

.mdi-battery-10::before {
  content: "\\f007a";
}

.mdi-battery-10-bluetooth::before {
  content: "\\f093e";
}

.mdi-battery-20::before {
  content: "\\f007b";
}

.mdi-battery-20-bluetooth::before {
  content: "\\f093f";
}

.mdi-battery-30::before {
  content: "\\f007c";
}

.mdi-battery-30-bluetooth::before {
  content: "\\f0940";
}

.mdi-battery-40::before {
  content: "\\f007d";
}

.mdi-battery-40-bluetooth::before {
  content: "\\f0941";
}

.mdi-battery-50::before {
  content: "\\f007e";
}

.mdi-battery-50-bluetooth::before {
  content: "\\f0942";
}

.mdi-battery-60::before {
  content: "\\f007f";
}

.mdi-battery-60-bluetooth::before {
  content: "\\f0943";
}

.mdi-battery-70::before {
  content: "\\f0080";
}

.mdi-battery-70-bluetooth::before {
  content: "\\f0944";
}

.mdi-battery-80::before {
  content: "\\f0081";
}

.mdi-battery-80-bluetooth::before {
  content: "\\f0945";
}

.mdi-battery-90::before {
  content: "\\f0082";
}

.mdi-battery-90-bluetooth::before {
  content: "\\f0946";
}

.mdi-battery-alert::before {
  content: "\\f0083";
}

.mdi-battery-alert-bluetooth::before {
  content: "\\f0947";
}

.mdi-battery-alert-variant::before {
  content: "\\f10cc";
}

.mdi-battery-alert-variant-outline::before {
  content: "\\f10cd";
}

.mdi-battery-arrow-down::before {
  content: "\\f17de";
}

.mdi-battery-arrow-down-outline::before {
  content: "\\f17df";
}

.mdi-battery-arrow-up::before {
  content: "\\f17e0";
}

.mdi-battery-arrow-up-outline::before {
  content: "\\f17e1";
}

.mdi-battery-bluetooth::before {
  content: "\\f0948";
}

.mdi-battery-bluetooth-variant::before {
  content: "\\f0949";
}

.mdi-battery-charging::before {
  content: "\\f0084";
}

.mdi-battery-charging-10::before {
  content: "\\f089c";
}

.mdi-battery-charging-100::before {
  content: "\\f0085";
}

.mdi-battery-charging-20::before {
  content: "\\f0086";
}

.mdi-battery-charging-30::before {
  content: "\\f0087";
}

.mdi-battery-charging-40::before {
  content: "\\f0088";
}

.mdi-battery-charging-50::before {
  content: "\\f089d";
}

.mdi-battery-charging-60::before {
  content: "\\f0089";
}

.mdi-battery-charging-70::before {
  content: "\\f089e";
}

.mdi-battery-charging-80::before {
  content: "\\f008a";
}

.mdi-battery-charging-90::before {
  content: "\\f008b";
}

.mdi-battery-charging-high::before {
  content: "\\f12a6";
}

.mdi-battery-charging-low::before {
  content: "\\f12a4";
}

.mdi-battery-charging-medium::before {
  content: "\\f12a5";
}

.mdi-battery-charging-outline::before {
  content: "\\f089f";
}

.mdi-battery-charging-wireless::before {
  content: "\\f0807";
}

.mdi-battery-charging-wireless-10::before {
  content: "\\f0808";
}

.mdi-battery-charging-wireless-20::before {
  content: "\\f0809";
}

.mdi-battery-charging-wireless-30::before {
  content: "\\f080a";
}

.mdi-battery-charging-wireless-40::before {
  content: "\\f080b";
}

.mdi-battery-charging-wireless-50::before {
  content: "\\f080c";
}

.mdi-battery-charging-wireless-60::before {
  content: "\\f080d";
}

.mdi-battery-charging-wireless-70::before {
  content: "\\f080e";
}

.mdi-battery-charging-wireless-80::before {
  content: "\\f080f";
}

.mdi-battery-charging-wireless-90::before {
  content: "\\f0810";
}

.mdi-battery-charging-wireless-alert::before {
  content: "\\f0811";
}

.mdi-battery-charging-wireless-outline::before {
  content: "\\f0812";
}

.mdi-battery-check::before {
  content: "\\f17e2";
}

.mdi-battery-check-outline::before {
  content: "\\f17e3";
}

.mdi-battery-heart::before {
  content: "\\f120f";
}

.mdi-battery-heart-outline::before {
  content: "\\f1210";
}

.mdi-battery-heart-variant::before {
  content: "\\f1211";
}

.mdi-battery-high::before {
  content: "\\f12a3";
}

.mdi-battery-lock::before {
  content: "\\f179c";
}

.mdi-battery-lock-open::before {
  content: "\\f179d";
}

.mdi-battery-low::before {
  content: "\\f12a1";
}

.mdi-battery-medium::before {
  content: "\\f12a2";
}

.mdi-battery-minus::before {
  content: "\\f17e4";
}

.mdi-battery-minus-outline::before {
  content: "\\f17e5";
}

.mdi-battery-minus-variant::before {
  content: "\\f008c";
}

.mdi-battery-negative::before {
  content: "\\f008d";
}

.mdi-battery-off::before {
  content: "\\f125d";
}

.mdi-battery-off-outline::before {
  content: "\\f125e";
}

.mdi-battery-outline::before {
  content: "\\f008e";
}

.mdi-battery-plus::before {
  content: "\\f17e6";
}

.mdi-battery-plus-outline::before {
  content: "\\f17e7";
}

.mdi-battery-plus-variant::before {
  content: "\\f008f";
}

.mdi-battery-positive::before {
  content: "\\f0090";
}

.mdi-battery-remove::before {
  content: "\\f17e8";
}

.mdi-battery-remove-outline::before {
  content: "\\f17e9";
}

.mdi-battery-sync::before {
  content: "\\f1834";
}

.mdi-battery-sync-outline::before {
  content: "\\f1835";
}

.mdi-battery-unknown::before {
  content: "\\f0091";
}

.mdi-battery-unknown-bluetooth::before {
  content: "\\f094a";
}

.mdi-beach::before {
  content: "\\f0092";
}

.mdi-beaker::before {
  content: "\\f0cea";
}

.mdi-beaker-alert::before {
  content: "\\f1229";
}

.mdi-beaker-alert-outline::before {
  content: "\\f122a";
}

.mdi-beaker-check::before {
  content: "\\f122b";
}

.mdi-beaker-check-outline::before {
  content: "\\f122c";
}

.mdi-beaker-minus::before {
  content: "\\f122d";
}

.mdi-beaker-minus-outline::before {
  content: "\\f122e";
}

.mdi-beaker-outline::before {
  content: "\\f0690";
}

.mdi-beaker-plus::before {
  content: "\\f122f";
}

.mdi-beaker-plus-outline::before {
  content: "\\f1230";
}

.mdi-beaker-question::before {
  content: "\\f1231";
}

.mdi-beaker-question-outline::before {
  content: "\\f1232";
}

.mdi-beaker-remove::before {
  content: "\\f1233";
}

.mdi-beaker-remove-outline::before {
  content: "\\f1234";
}

.mdi-bed::before {
  content: "\\f02e3";
}

.mdi-bed-double::before {
  content: "\\f0fd4";
}

.mdi-bed-double-outline::before {
  content: "\\f0fd3";
}

.mdi-bed-empty::before {
  content: "\\f08a0";
}

.mdi-bed-king::before {
  content: "\\f0fd2";
}

.mdi-bed-king-outline::before {
  content: "\\f0fd1";
}

.mdi-bed-outline::before {
  content: "\\f0099";
}

.mdi-bed-queen::before {
  content: "\\f0fd0";
}

.mdi-bed-queen-outline::before {
  content: "\\f0fdb";
}

.mdi-bed-single::before {
  content: "\\f106d";
}

.mdi-bed-single-outline::before {
  content: "\\f106e";
}

.mdi-bee::before {
  content: "\\f0fa1";
}

.mdi-bee-flower::before {
  content: "\\f0fa2";
}

.mdi-beehive-off-outline::before {
  content: "\\f13ed";
}

.mdi-beehive-outline::before {
  content: "\\f10ce";
}

.mdi-beekeeper::before {
  content: "\\f14e2";
}

.mdi-beer::before {
  content: "\\f0098";
}

.mdi-beer-outline::before {
  content: "\\f130c";
}

.mdi-bell::before {
  content: "\\f009a";
}

.mdi-bell-alert::before {
  content: "\\f0d59";
}

.mdi-bell-alert-outline::before {
  content: "\\f0e81";
}

.mdi-bell-badge::before {
  content: "\\f116b";
}

.mdi-bell-badge-outline::before {
  content: "\\f0178";
}

.mdi-bell-cancel::before {
  content: "\\f13e7";
}

.mdi-bell-cancel-outline::before {
  content: "\\f13e8";
}

.mdi-bell-check::before {
  content: "\\f11e5";
}

.mdi-bell-check-outline::before {
  content: "\\f11e6";
}

.mdi-bell-circle::before {
  content: "\\f0d5a";
}

.mdi-bell-circle-outline::before {
  content: "\\f0d5b";
}

.mdi-bell-minus::before {
  content: "\\f13e9";
}

.mdi-bell-minus-outline::before {
  content: "\\f13ea";
}

.mdi-bell-off::before {
  content: "\\f009b";
}

.mdi-bell-off-outline::before {
  content: "\\f0a91";
}

.mdi-bell-outline::before {
  content: "\\f009c";
}

.mdi-bell-plus::before {
  content: "\\f009d";
}

.mdi-bell-plus-outline::before {
  content: "\\f0a92";
}

.mdi-bell-remove::before {
  content: "\\f13eb";
}

.mdi-bell-remove-outline::before {
  content: "\\f13ec";
}

.mdi-bell-ring::before {
  content: "\\f009e";
}

.mdi-bell-ring-outline::before {
  content: "\\f009f";
}

.mdi-bell-sleep::before {
  content: "\\f00a0";
}

.mdi-bell-sleep-outline::before {
  content: "\\f0a93";
}

.mdi-beta::before {
  content: "\\f00a1";
}

.mdi-betamax::before {
  content: "\\f09cb";
}

.mdi-biathlon::before {
  content: "\\f0e14";
}

.mdi-bicycle::before {
  content: "\\f109c";
}

.mdi-bicycle-basket::before {
  content: "\\f1235";
}

.mdi-bicycle-cargo::before {
  content: "\\f189c";
}

.mdi-bicycle-electric::before {
  content: "\\f15b4";
}

.mdi-bicycle-penny-farthing::before {
  content: "\\f15e9";
}

.mdi-bike::before {
  content: "\\f00a3";
}

.mdi-bike-fast::before {
  content: "\\f111f";
}

.mdi-billboard::before {
  content: "\\f1010";
}

.mdi-billiards::before {
  content: "\\f0b61";
}

.mdi-billiards-rack::before {
  content: "\\f0b62";
}

.mdi-binoculars::before {
  content: "\\f00a5";
}

.mdi-bio::before {
  content: "\\f00a6";
}

.mdi-biohazard::before {
  content: "\\f00a7";
}

.mdi-bird::before {
  content: "\\f15c6";
}

.mdi-bitbucket::before {
  content: "\\f00a8";
}

.mdi-bitcoin::before {
  content: "\\f0813";
}

.mdi-black-mesa::before {
  content: "\\f00a9";
}

.mdi-blender::before {
  content: "\\f0ceb";
}

.mdi-blender-outline::before {
  content: "\\f181a";
}

.mdi-blender-software::before {
  content: "\\f00ab";
}

.mdi-blinds::before {
  content: "\\f00ac";
}

.mdi-blinds-open::before {
  content: "\\f1011";
}

.mdi-block-helper::before {
  content: "\\f00ad";
}

.mdi-blood-bag::before {
  content: "\\f0cec";
}

.mdi-bluetooth::before {
  content: "\\f00af";
}

.mdi-bluetooth-audio::before {
  content: "\\f00b0";
}

.mdi-bluetooth-connect::before {
  content: "\\f00b1";
}

.mdi-bluetooth-off::before {
  content: "\\f00b2";
}

.mdi-bluetooth-settings::before {
  content: "\\f00b3";
}

.mdi-bluetooth-transfer::before {
  content: "\\f00b4";
}

.mdi-blur::before {
  content: "\\f00b5";
}

.mdi-blur-linear::before {
  content: "\\f00b6";
}

.mdi-blur-off::before {
  content: "\\f00b7";
}

.mdi-blur-radial::before {
  content: "\\f00b8";
}

.mdi-bolt::before {
  content: "\\f0db3";
}

.mdi-bomb::before {
  content: "\\f0691";
}

.mdi-bomb-off::before {
  content: "\\f06c5";
}

.mdi-bone::before {
  content: "\\f00b9";
}

.mdi-book::before {
  content: "\\f00ba";
}

.mdi-book-account::before {
  content: "\\f13ad";
}

.mdi-book-account-outline::before {
  content: "\\f13ae";
}

.mdi-book-alert::before {
  content: "\\f167c";
}

.mdi-book-alert-outline::before {
  content: "\\f167d";
}

.mdi-book-alphabet::before {
  content: "\\f061d";
}

.mdi-book-arrow-down::before {
  content: "\\f167e";
}

.mdi-book-arrow-down-outline::before {
  content: "\\f167f";
}

.mdi-book-arrow-left::before {
  content: "\\f1680";
}

.mdi-book-arrow-left-outline::before {
  content: "\\f1681";
}

.mdi-book-arrow-right::before {
  content: "\\f1682";
}

.mdi-book-arrow-right-outline::before {
  content: "\\f1683";
}

.mdi-book-arrow-up::before {
  content: "\\f1684";
}

.mdi-book-arrow-up-outline::before {
  content: "\\f1685";
}

.mdi-book-cancel::before {
  content: "\\f1686";
}

.mdi-book-cancel-outline::before {
  content: "\\f1687";
}

.mdi-book-check::before {
  content: "\\f14f3";
}

.mdi-book-check-outline::before {
  content: "\\f14f4";
}

.mdi-book-clock::before {
  content: "\\f1688";
}

.mdi-book-clock-outline::before {
  content: "\\f1689";
}

.mdi-book-cog::before {
  content: "\\f168a";
}

.mdi-book-cog-outline::before {
  content: "\\f168b";
}

.mdi-book-cross::before {
  content: "\\f00a2";
}

.mdi-book-edit::before {
  content: "\\f168c";
}

.mdi-book-edit-outline::before {
  content: "\\f168d";
}

.mdi-book-education::before {
  content: "\\f16c9";
}

.mdi-book-education-outline::before {
  content: "\\f16ca";
}

.mdi-book-information-variant::before {
  content: "\\f106f";
}

.mdi-book-lock::before {
  content: "\\f079a";
}

.mdi-book-lock-open::before {
  content: "\\f079b";
}

.mdi-book-lock-open-outline::before {
  content: "\\f168e";
}

.mdi-book-lock-outline::before {
  content: "\\f168f";
}

.mdi-book-marker::before {
  content: "\\f1690";
}

.mdi-book-marker-outline::before {
  content: "\\f1691";
}

.mdi-book-minus::before {
  content: "\\f05d9";
}

.mdi-book-minus-multiple::before {
  content: "\\f0a94";
}

.mdi-book-minus-multiple-outline::before {
  content: "\\f090b";
}

.mdi-book-minus-outline::before {
  content: "\\f1692";
}

.mdi-book-multiple::before {
  content: "\\f00bb";
}

.mdi-book-multiple-outline::before {
  content: "\\f0436";
}

.mdi-book-music::before {
  content: "\\f0067";
}

.mdi-book-music-outline::before {
  content: "\\f1693";
}

.mdi-book-off::before {
  content: "\\f1694";
}

.mdi-book-off-outline::before {
  content: "\\f1695";
}

.mdi-book-open::before {
  content: "\\f00bd";
}

.mdi-book-open-blank-variant::before {
  content: "\\f00be";
}

.mdi-book-open-outline::before {
  content: "\\f0b63";
}

.mdi-book-open-page-variant::before {
  content: "\\f05da";
}

.mdi-book-open-page-variant-outline::before {
  content: "\\f15d6";
}

.mdi-book-open-variant::before {
  content: "\\f14f7";
}

.mdi-book-outline::before {
  content: "\\f0b64";
}

.mdi-book-play::before {
  content: "\\f0e82";
}

.mdi-book-play-outline::before {
  content: "\\f0e83";
}

.mdi-book-plus::before {
  content: "\\f05db";
}

.mdi-book-plus-multiple::before {
  content: "\\f0a95";
}

.mdi-book-plus-multiple-outline::before {
  content: "\\f0ade";
}

.mdi-book-plus-outline::before {
  content: "\\f1696";
}

.mdi-book-refresh::before {
  content: "\\f1697";
}

.mdi-book-refresh-outline::before {
  content: "\\f1698";
}

.mdi-book-remove::before {
  content: "\\f0a97";
}

.mdi-book-remove-multiple::before {
  content: "\\f0a96";
}

.mdi-book-remove-multiple-outline::before {
  content: "\\f04ca";
}

.mdi-book-remove-outline::before {
  content: "\\f1699";
}

.mdi-book-search::before {
  content: "\\f0e84";
}

.mdi-book-search-outline::before {
  content: "\\f0e85";
}

.mdi-book-settings::before {
  content: "\\f169a";
}

.mdi-book-settings-outline::before {
  content: "\\f169b";
}

.mdi-book-sync::before {
  content: "\\f169c";
}

.mdi-book-sync-outline::before {
  content: "\\f16c8";
}

.mdi-book-variant::before {
  content: "\\f00bf";
}

.mdi-book-variant-multiple::before {
  content: "\\f00bc";
}

.mdi-bookmark::before {
  content: "\\f00c0";
}

.mdi-bookmark-box-multiple::before {
  content: "\\f196c";
}

.mdi-bookmark-box-multiple-outline::before {
  content: "\\f196d";
}

.mdi-bookmark-check::before {
  content: "\\f00c1";
}

.mdi-bookmark-check-outline::before {
  content: "\\f137b";
}

.mdi-bookmark-minus::before {
  content: "\\f09cc";
}

.mdi-bookmark-minus-outline::before {
  content: "\\f09cd";
}

.mdi-bookmark-multiple::before {
  content: "\\f0e15";
}

.mdi-bookmark-multiple-outline::before {
  content: "\\f0e16";
}

.mdi-bookmark-music::before {
  content: "\\f00c2";
}

.mdi-bookmark-music-outline::before {
  content: "\\f1379";
}

.mdi-bookmark-off::before {
  content: "\\f09ce";
}

.mdi-bookmark-off-outline::before {
  content: "\\f09cf";
}

.mdi-bookmark-outline::before {
  content: "\\f00c3";
}

.mdi-bookmark-plus::before {
  content: "\\f00c5";
}

.mdi-bookmark-plus-outline::before {
  content: "\\f00c4";
}

.mdi-bookmark-remove::before {
  content: "\\f00c6";
}

.mdi-bookmark-remove-outline::before {
  content: "\\f137a";
}

.mdi-bookshelf::before {
  content: "\\f125f";
}

.mdi-boom-gate::before {
  content: "\\f0e86";
}

.mdi-boom-gate-alert::before {
  content: "\\f0e87";
}

.mdi-boom-gate-alert-outline::before {
  content: "\\f0e88";
}

.mdi-boom-gate-arrow-down::before {
  content: "\\f0e89";
}

.mdi-boom-gate-arrow-down-outline::before {
  content: "\\f0e8a";
}

.mdi-boom-gate-arrow-up::before {
  content: "\\f0e8c";
}

.mdi-boom-gate-arrow-up-outline::before {
  content: "\\f0e8d";
}

.mdi-boom-gate-outline::before {
  content: "\\f0e8b";
}

.mdi-boom-gate-up::before {
  content: "\\f17f9";
}

.mdi-boom-gate-up-outline::before {
  content: "\\f17fa";
}

.mdi-boombox::before {
  content: "\\f05dc";
}

.mdi-boomerang::before {
  content: "\\f10cf";
}

.mdi-bootstrap::before {
  content: "\\f06c6";
}

.mdi-border-all::before {
  content: "\\f00c7";
}

.mdi-border-all-variant::before {
  content: "\\f08a1";
}

.mdi-border-bottom::before {
  content: "\\f00c8";
}

.mdi-border-bottom-variant::before {
  content: "\\f08a2";
}

.mdi-border-color::before {
  content: "\\f00c9";
}

.mdi-border-horizontal::before {
  content: "\\f00ca";
}

.mdi-border-inside::before {
  content: "\\f00cb";
}

.mdi-border-left::before {
  content: "\\f00cc";
}

.mdi-border-left-variant::before {
  content: "\\f08a3";
}

.mdi-border-none::before {
  content: "\\f00cd";
}

.mdi-border-none-variant::before {
  content: "\\f08a4";
}

.mdi-border-outside::before {
  content: "\\f00ce";
}

.mdi-border-right::before {
  content: "\\f00cf";
}

.mdi-border-right-variant::before {
  content: "\\f08a5";
}

.mdi-border-style::before {
  content: "\\f00d0";
}

.mdi-border-top::before {
  content: "\\f00d1";
}

.mdi-border-top-variant::before {
  content: "\\f08a6";
}

.mdi-border-vertical::before {
  content: "\\f00d2";
}

.mdi-bottle-soda::before {
  content: "\\f1070";
}

.mdi-bottle-soda-classic::before {
  content: "\\f1071";
}

.mdi-bottle-soda-classic-outline::before {
  content: "\\f1363";
}

.mdi-bottle-soda-outline::before {
  content: "\\f1072";
}

.mdi-bottle-tonic::before {
  content: "\\f112e";
}

.mdi-bottle-tonic-outline::before {
  content: "\\f112f";
}

.mdi-bottle-tonic-plus::before {
  content: "\\f1130";
}

.mdi-bottle-tonic-plus-outline::before {
  content: "\\f1131";
}

.mdi-bottle-tonic-skull::before {
  content: "\\f1132";
}

.mdi-bottle-tonic-skull-outline::before {
  content: "\\f1133";
}

.mdi-bottle-wine::before {
  content: "\\f0854";
}

.mdi-bottle-wine-outline::before {
  content: "\\f1310";
}

.mdi-bow-arrow::before {
  content: "\\f1841";
}

.mdi-bow-tie::before {
  content: "\\f0678";
}

.mdi-bowl::before {
  content: "\\f028e";
}

.mdi-bowl-mix::before {
  content: "\\f0617";
}

.mdi-bowl-mix-outline::before {
  content: "\\f02e4";
}

.mdi-bowl-outline::before {
  content: "\\f02a9";
}

.mdi-bowling::before {
  content: "\\f00d3";
}

.mdi-box::before {
  content: "\\f00d4";
}

.mdi-box-cutter::before {
  content: "\\f00d5";
}

.mdi-box-cutter-off::before {
  content: "\\f0b4a";
}

.mdi-box-shadow::before {
  content: "\\f0637";
}

.mdi-boxing-glove::before {
  content: "\\f0b65";
}

.mdi-braille::before {
  content: "\\f09d0";
}

.mdi-brain::before {
  content: "\\f09d1";
}

.mdi-bread-slice::before {
  content: "\\f0cee";
}

.mdi-bread-slice-outline::before {
  content: "\\f0cef";
}

.mdi-bridge::before {
  content: "\\f0618";
}

.mdi-briefcase::before {
  content: "\\f00d6";
}

.mdi-briefcase-account::before {
  content: "\\f0cf0";
}

.mdi-briefcase-account-outline::before {
  content: "\\f0cf1";
}

.mdi-briefcase-check::before {
  content: "\\f00d7";
}

.mdi-briefcase-check-outline::before {
  content: "\\f131e";
}

.mdi-briefcase-clock::before {
  content: "\\f10d0";
}

.mdi-briefcase-clock-outline::before {
  content: "\\f10d1";
}

.mdi-briefcase-download::before {
  content: "\\f00d8";
}

.mdi-briefcase-download-outline::before {
  content: "\\f0c3d";
}

.mdi-briefcase-edit::before {
  content: "\\f0a98";
}

.mdi-briefcase-edit-outline::before {
  content: "\\f0c3e";
}

.mdi-briefcase-eye::before {
  content: "\\f17d9";
}

.mdi-briefcase-eye-outline::before {
  content: "\\f17da";
}

.mdi-briefcase-minus::before {
  content: "\\f0a2a";
}

.mdi-briefcase-minus-outline::before {
  content: "\\f0c3f";
}

.mdi-briefcase-off::before {
  content: "\\f1658";
}

.mdi-briefcase-off-outline::before {
  content: "\\f1659";
}

.mdi-briefcase-outline::before {
  content: "\\f0814";
}

.mdi-briefcase-plus::before {
  content: "\\f0a2b";
}

.mdi-briefcase-plus-outline::before {
  content: "\\f0c40";
}

.mdi-briefcase-remove::before {
  content: "\\f0a2c";
}

.mdi-briefcase-remove-outline::before {
  content: "\\f0c41";
}

.mdi-briefcase-search::before {
  content: "\\f0a2d";
}

.mdi-briefcase-search-outline::before {
  content: "\\f0c42";
}

.mdi-briefcase-upload::before {
  content: "\\f00d9";
}

.mdi-briefcase-upload-outline::before {
  content: "\\f0c43";
}

.mdi-briefcase-variant::before {
  content: "\\f1494";
}

.mdi-briefcase-variant-off::before {
  content: "\\f165a";
}

.mdi-briefcase-variant-off-outline::before {
  content: "\\f165b";
}

.mdi-briefcase-variant-outline::before {
  content: "\\f1495";
}

.mdi-brightness-1::before {
  content: "\\f00da";
}

.mdi-brightness-2::before {
  content: "\\f00db";
}

.mdi-brightness-3::before {
  content: "\\f00dc";
}

.mdi-brightness-4::before {
  content: "\\f00dd";
}

.mdi-brightness-5::before {
  content: "\\f00de";
}

.mdi-brightness-6::before {
  content: "\\f00df";
}

.mdi-brightness-7::before {
  content: "\\f00e0";
}

.mdi-brightness-auto::before {
  content: "\\f00e1";
}

.mdi-brightness-percent::before {
  content: "\\f0cf2";
}

.mdi-broadcast::before {
  content: "\\f1720";
}

.mdi-broadcast-off::before {
  content: "\\f1721";
}

.mdi-broom::before {
  content: "\\f00e2";
}

.mdi-brush::before {
  content: "\\f00e3";
}

.mdi-brush-off::before {
  content: "\\f1771";
}

.mdi-brush-variant::before {
  content: "\\f1813";
}

.mdi-bucket::before {
  content: "\\f1415";
}

.mdi-bucket-outline::before {
  content: "\\f1416";
}

.mdi-buffet::before {
  content: "\\f0578";
}

.mdi-bug::before {
  content: "\\f00e4";
}

.mdi-bug-check::before {
  content: "\\f0a2e";
}

.mdi-bug-check-outline::before {
  content: "\\f0a2f";
}

.mdi-bug-outline::before {
  content: "\\f0a30";
}

.mdi-bugle::before {
  content: "\\f0db4";
}

.mdi-bulldozer::before {
  content: "\\f0b22";
}

.mdi-bullet::before {
  content: "\\f0cf3";
}

.mdi-bulletin-board::before {
  content: "\\f00e5";
}

.mdi-bullhorn::before {
  content: "\\f00e6";
}

.mdi-bullhorn-outline::before {
  content: "\\f0b23";
}

.mdi-bullhorn-variant::before {
  content: "\\f196e";
}

.mdi-bullhorn-variant-outline::before {
  content: "\\f196f";
}

.mdi-bullseye::before {
  content: "\\f05dd";
}

.mdi-bullseye-arrow::before {
  content: "\\f08c9";
}

.mdi-bulma::before {
  content: "\\f12e7";
}

.mdi-bunk-bed::before {
  content: "\\f1302";
}

.mdi-bunk-bed-outline::before {
  content: "\\f0097";
}

.mdi-bus::before {
  content: "\\f00e7";
}

.mdi-bus-alert::before {
  content: "\\f0a99";
}

.mdi-bus-articulated-end::before {
  content: "\\f079c";
}

.mdi-bus-articulated-front::before {
  content: "\\f079d";
}

.mdi-bus-clock::before {
  content: "\\f08ca";
}

.mdi-bus-double-decker::before {
  content: "\\f079e";
}

.mdi-bus-electric::before {
  content: "\\f191d";
}

.mdi-bus-marker::before {
  content: "\\f1212";
}

.mdi-bus-multiple::before {
  content: "\\f0f3f";
}

.mdi-bus-school::before {
  content: "\\f079f";
}

.mdi-bus-side::before {
  content: "\\f07a0";
}

.mdi-bus-stop::before {
  content: "\\f1012";
}

.mdi-bus-stop-covered::before {
  content: "\\f1013";
}

.mdi-bus-stop-uncovered::before {
  content: "\\f1014";
}

.mdi-butterfly::before {
  content: "\\f1589";
}

.mdi-butterfly-outline::before {
  content: "\\f158a";
}

.mdi-cabin-a-frame::before {
  content: "\\f188c";
}

.mdi-cable-data::before {
  content: "\\f1394";
}

.mdi-cached::before {
  content: "\\f00e8";
}

.mdi-cactus::before {
  content: "\\f0db5";
}

.mdi-cake::before {
  content: "\\f00e9";
}

.mdi-cake-layered::before {
  content: "\\f00ea";
}

.mdi-cake-variant::before {
  content: "\\f00eb";
}

.mdi-cake-variant-outline::before {
  content: "\\f17f0";
}

.mdi-calculator::before {
  content: "\\f00ec";
}

.mdi-calculator-variant::before {
  content: "\\f0a9a";
}

.mdi-calculator-variant-outline::before {
  content: "\\f15a6";
}

.mdi-calendar::before {
  content: "\\f00ed";
}

.mdi-calendar-account::before {
  content: "\\f0ed7";
}

.mdi-calendar-account-outline::before {
  content: "\\f0ed8";
}

.mdi-calendar-alert::before {
  content: "\\f0a31";
}

.mdi-calendar-arrow-left::before {
  content: "\\f1134";
}

.mdi-calendar-arrow-right::before {
  content: "\\f1135";
}

.mdi-calendar-blank::before {
  content: "\\f00ee";
}

.mdi-calendar-blank-multiple::before {
  content: "\\f1073";
}

.mdi-calendar-blank-outline::before {
  content: "\\f0b66";
}

.mdi-calendar-check::before {
  content: "\\f00ef";
}

.mdi-calendar-check-outline::before {
  content: "\\f0c44";
}

.mdi-calendar-clock::before {
  content: "\\f00f0";
}

.mdi-calendar-clock-outline::before {
  content: "\\f16e1";
}

.mdi-calendar-collapse-horizontal::before {
  content: "\\f189d";
}

.mdi-calendar-cursor::before {
  content: "\\f157b";
}

.mdi-calendar-edit::before {
  content: "\\f08a7";
}

.mdi-calendar-end::before {
  content: "\\f166c";
}

.mdi-calendar-expand-horizontal::before {
  content: "\\f189e";
}

.mdi-calendar-export::before {
  content: "\\f0b24";
}

.mdi-calendar-heart::before {
  content: "\\f09d2";
}

.mdi-calendar-import::before {
  content: "\\f0b25";
}

.mdi-calendar-lock::before {
  content: "\\f1641";
}

.mdi-calendar-lock-outline::before {
  content: "\\f1642";
}

.mdi-calendar-minus::before {
  content: "\\f0d5c";
}

.mdi-calendar-month::before {
  content: "\\f0e17";
}

.mdi-calendar-month-outline::before {
  content: "\\f0e18";
}

.mdi-calendar-multiple::before {
  content: "\\f00f1";
}

.mdi-calendar-multiple-check::before {
  content: "\\f00f2";
}

.mdi-calendar-multiselect::before {
  content: "\\f0a32";
}

.mdi-calendar-outline::before {
  content: "\\f0b67";
}

.mdi-calendar-plus::before {
  content: "\\f00f3";
}

.mdi-calendar-question::before {
  content: "\\f0692";
}

.mdi-calendar-range::before {
  content: "\\f0679";
}

.mdi-calendar-range-outline::before {
  content: "\\f0b68";
}

.mdi-calendar-refresh::before {
  content: "\\f01e1";
}

.mdi-calendar-refresh-outline::before {
  content: "\\f0203";
}

.mdi-calendar-remove::before {
  content: "\\f00f4";
}

.mdi-calendar-remove-outline::before {
  content: "\\f0c45";
}

.mdi-calendar-search::before {
  content: "\\f094c";
}

.mdi-calendar-star::before {
  content: "\\f09d3";
}

.mdi-calendar-start::before {
  content: "\\f166d";
}

.mdi-calendar-sync::before {
  content: "\\f0e8e";
}

.mdi-calendar-sync-outline::before {
  content: "\\f0e8f";
}

.mdi-calendar-text::before {
  content: "\\f00f5";
}

.mdi-calendar-text-outline::before {
  content: "\\f0c46";
}

.mdi-calendar-today::before {
  content: "\\f00f6";
}

.mdi-calendar-week::before {
  content: "\\f0a33";
}

.mdi-calendar-week-begin::before {
  content: "\\f0a34";
}

.mdi-calendar-weekend::before {
  content: "\\f0ed9";
}

.mdi-calendar-weekend-outline::before {
  content: "\\f0eda";
}

.mdi-call-made::before {
  content: "\\f00f7";
}

.mdi-call-merge::before {
  content: "\\f00f8";
}

.mdi-call-missed::before {
  content: "\\f00f9";
}

.mdi-call-received::before {
  content: "\\f00fa";
}

.mdi-call-split::before {
  content: "\\f00fb";
}

.mdi-camcorder::before {
  content: "\\f00fc";
}

.mdi-camcorder-off::before {
  content: "\\f00ff";
}

.mdi-camera::before {
  content: "\\f0100";
}

.mdi-camera-account::before {
  content: "\\f08cb";
}

.mdi-camera-burst::before {
  content: "\\f0693";
}

.mdi-camera-control::before {
  content: "\\f0b69";
}

.mdi-camera-document::before {
  content: "\\f1871";
}

.mdi-camera-document-off::before {
  content: "\\f1872";
}

.mdi-camera-enhance::before {
  content: "\\f0101";
}

.mdi-camera-enhance-outline::before {
  content: "\\f0b6a";
}

.mdi-camera-flip::before {
  content: "\\f15d9";
}

.mdi-camera-flip-outline::before {
  content: "\\f15da";
}

.mdi-camera-front::before {
  content: "\\f0102";
}

.mdi-camera-front-variant::before {
  content: "\\f0103";
}

.mdi-camera-gopro::before {
  content: "\\f07a1";
}

.mdi-camera-image::before {
  content: "\\f08cc";
}

.mdi-camera-iris::before {
  content: "\\f0104";
}

.mdi-camera-marker::before {
  content: "\\f19a7";
}

.mdi-camera-marker-outline::before {
  content: "\\f19a8";
}

.mdi-camera-metering-center::before {
  content: "\\f07a2";
}

.mdi-camera-metering-matrix::before {
  content: "\\f07a3";
}

.mdi-camera-metering-partial::before {
  content: "\\f07a4";
}

.mdi-camera-metering-spot::before {
  content: "\\f07a5";
}

.mdi-camera-off::before {
  content: "\\f05df";
}

.mdi-camera-off-outline::before {
  content: "\\f19bf";
}

.mdi-camera-outline::before {
  content: "\\f0d5d";
}

.mdi-camera-party-mode::before {
  content: "\\f0105";
}

.mdi-camera-plus::before {
  content: "\\f0edb";
}

.mdi-camera-plus-outline::before {
  content: "\\f0edc";
}

.mdi-camera-rear::before {
  content: "\\f0106";
}

.mdi-camera-rear-variant::before {
  content: "\\f0107";
}

.mdi-camera-retake::before {
  content: "\\f0e19";
}

.mdi-camera-retake-outline::before {
  content: "\\f0e1a";
}

.mdi-camera-switch::before {
  content: "\\f0108";
}

.mdi-camera-switch-outline::before {
  content: "\\f084a";
}

.mdi-camera-timer::before {
  content: "\\f0109";
}

.mdi-camera-wireless::before {
  content: "\\f0db6";
}

.mdi-camera-wireless-outline::before {
  content: "\\f0db7";
}

.mdi-campfire::before {
  content: "\\f0edd";
}

.mdi-cancel::before {
  content: "\\f073a";
}

.mdi-candelabra::before {
  content: "\\f17d2";
}

.mdi-candelabra-fire::before {
  content: "\\f17d3";
}

.mdi-candle::before {
  content: "\\f05e2";
}

.mdi-candy::before {
  content: "\\f1970";
}

.mdi-candy-off::before {
  content: "\\f1971";
}

.mdi-candy-off-outline::before {
  content: "\\f1972";
}

.mdi-candy-outline::before {
  content: "\\f1973";
}

.mdi-candycane::before {
  content: "\\f010a";
}

.mdi-cannabis::before {
  content: "\\f07a6";
}

.mdi-cannabis-off::before {
  content: "\\f166e";
}

.mdi-caps-lock::before {
  content: "\\f0a9b";
}

.mdi-car::before {
  content: "\\f010b";
}

.mdi-car-2-plus::before {
  content: "\\f1015";
}

.mdi-car-3-plus::before {
  content: "\\f1016";
}

.mdi-car-arrow-left::before {
  content: "\\f13b2";
}

.mdi-car-arrow-right::before {
  content: "\\f13b3";
}

.mdi-car-back::before {
  content: "\\f0e1b";
}

.mdi-car-battery::before {
  content: "\\f010c";
}

.mdi-car-brake-abs::before {
  content: "\\f0c47";
}

.mdi-car-brake-alert::before {
  content: "\\f0c48";
}

.mdi-car-brake-fluid-level::before {
  content: "\\f1909";
}

.mdi-car-brake-hold::before {
  content: "\\f0d5e";
}

.mdi-car-brake-low-pressure::before {
  content: "\\f190a";
}

.mdi-car-brake-parking::before {
  content: "\\f0d5f";
}

.mdi-car-brake-retarder::before {
  content: "\\f1017";
}

.mdi-car-brake-temperature::before {
  content: "\\f190b";
}

.mdi-car-brake-worn-linings::before {
  content: "\\f190c";
}

.mdi-car-child-seat::before {
  content: "\\f0fa3";
}

.mdi-car-clock::before {
  content: "\\f1974";
}

.mdi-car-clutch::before {
  content: "\\f1018";
}

.mdi-car-cog::before {
  content: "\\f13cc";
}

.mdi-car-connected::before {
  content: "\\f010d";
}

.mdi-car-convertible::before {
  content: "\\f07a7";
}

.mdi-car-coolant-level::before {
  content: "\\f1019";
}

.mdi-car-cruise-control::before {
  content: "\\f0d60";
}

.mdi-car-defrost-front::before {
  content: "\\f0d61";
}

.mdi-car-defrost-rear::before {
  content: "\\f0d62";
}

.mdi-car-door::before {
  content: "\\f0b6b";
}

.mdi-car-door-lock::before {
  content: "\\f109d";
}

.mdi-car-electric::before {
  content: "\\f0b6c";
}

.mdi-car-electric-outline::before {
  content: "\\f15b5";
}

.mdi-car-emergency::before {
  content: "\\f160f";
}

.mdi-car-esp::before {
  content: "\\f0c49";
}

.mdi-car-estate::before {
  content: "\\f07a8";
}

.mdi-car-hatchback::before {
  content: "\\f07a9";
}

.mdi-car-info::before {
  content: "\\f11be";
}

.mdi-car-key::before {
  content: "\\f0b6d";
}

.mdi-car-lifted-pickup::before {
  content: "\\f152d";
}

.mdi-car-light-alert::before {
  content: "\\f190d";
}

.mdi-car-light-dimmed::before {
  content: "\\f0c4a";
}

.mdi-car-light-fog::before {
  content: "\\f0c4b";
}

.mdi-car-light-high::before {
  content: "\\f0c4c";
}

.mdi-car-limousine::before {
  content: "\\f08cd";
}

.mdi-car-multiple::before {
  content: "\\f0b6e";
}

.mdi-car-off::before {
  content: "\\f0e1c";
}

.mdi-car-outline::before {
  content: "\\f14ed";
}

.mdi-car-parking-lights::before {
  content: "\\f0d63";
}

.mdi-car-pickup::before {
  content: "\\f07aa";
}

.mdi-car-seat::before {
  content: "\\f0fa4";
}

.mdi-car-seat-cooler::before {
  content: "\\f0fa5";
}

.mdi-car-seat-heater::before {
  content: "\\f0fa6";
}

.mdi-car-select::before {
  content: "\\f1879";
}

.mdi-car-settings::before {
  content: "\\f13cd";
}

.mdi-car-shift-pattern::before {
  content: "\\f0f40";
}

.mdi-car-side::before {
  content: "\\f07ab";
}

.mdi-car-speed-limiter::before {
  content: "\\f190e";
}

.mdi-car-sports::before {
  content: "\\f07ac";
}

.mdi-car-tire-alert::before {
  content: "\\f0c4d";
}

.mdi-car-traction-control::before {
  content: "\\f0d64";
}

.mdi-car-turbocharger::before {
  content: "\\f101a";
}

.mdi-car-wash::before {
  content: "\\f010e";
}

.mdi-car-windshield::before {
  content: "\\f101b";
}

.mdi-car-windshield-outline::before {
  content: "\\f101c";
}

.mdi-car-wireless::before {
  content: "\\f1878";
}

.mdi-car-wrench::before {
  content: "\\f1814";
}

.mdi-carabiner::before {
  content: "\\f14c0";
}

.mdi-caravan::before {
  content: "\\f07ad";
}

.mdi-card::before {
  content: "\\f0b6f";
}

.mdi-card-account-details::before {
  content: "\\f05d2";
}

.mdi-card-account-details-outline::before {
  content: "\\f0dab";
}

.mdi-card-account-details-star::before {
  content: "\\f02a3";
}

.mdi-card-account-details-star-outline::before {
  content: "\\f06db";
}

.mdi-card-account-mail::before {
  content: "\\f018e";
}

.mdi-card-account-mail-outline::before {
  content: "\\f0e98";
}

.mdi-card-account-phone::before {
  content: "\\f0e99";
}

.mdi-card-account-phone-outline::before {
  content: "\\f0e9a";
}

.mdi-card-bulleted::before {
  content: "\\f0b70";
}

.mdi-card-bulleted-off::before {
  content: "\\f0b71";
}

.mdi-card-bulleted-off-outline::before {
  content: "\\f0b72";
}

.mdi-card-bulleted-outline::before {
  content: "\\f0b73";
}

.mdi-card-bulleted-settings::before {
  content: "\\f0b74";
}

.mdi-card-bulleted-settings-outline::before {
  content: "\\f0b75";
}

.mdi-card-minus::before {
  content: "\\f1600";
}

.mdi-card-minus-outline::before {
  content: "\\f1601";
}

.mdi-card-multiple::before {
  content: "\\f17f1";
}

.mdi-card-multiple-outline::before {
  content: "\\f17f2";
}

.mdi-card-off::before {
  content: "\\f1602";
}

.mdi-card-off-outline::before {
  content: "\\f1603";
}

.mdi-card-outline::before {
  content: "\\f0b76";
}

.mdi-card-plus::before {
  content: "\\f11ff";
}

.mdi-card-plus-outline::before {
  content: "\\f1200";
}

.mdi-card-remove::before {
  content: "\\f1604";
}

.mdi-card-remove-outline::before {
  content: "\\f1605";
}

.mdi-card-search::before {
  content: "\\f1074";
}

.mdi-card-search-outline::before {
  content: "\\f1075";
}

.mdi-card-text::before {
  content: "\\f0b77";
}

.mdi-card-text-outline::before {
  content: "\\f0b78";
}

.mdi-cards::before {
  content: "\\f0638";
}

.mdi-cards-club::before {
  content: "\\f08ce";
}

.mdi-cards-club-outline::before {
  content: "\\f189f";
}

.mdi-cards-diamond::before {
  content: "\\f08cf";
}

.mdi-cards-diamond-outline::before {
  content: "\\f101d";
}

.mdi-cards-heart::before {
  content: "\\f08d0";
}

.mdi-cards-heart-outline::before {
  content: "\\f18a0";
}

.mdi-cards-outline::before {
  content: "\\f0639";
}

.mdi-cards-playing::before {
  content: "\\f18a1";
}

.mdi-cards-playing-club::before {
  content: "\\f18a2";
}

.mdi-cards-playing-club-multiple::before {
  content: "\\f18a3";
}

.mdi-cards-playing-club-multiple-outline::before {
  content: "\\f18a4";
}

.mdi-cards-playing-club-outline::before {
  content: "\\f18a5";
}

.mdi-cards-playing-diamond::before {
  content: "\\f18a6";
}

.mdi-cards-playing-diamond-multiple::before {
  content: "\\f18a7";
}

.mdi-cards-playing-diamond-multiple-outline::before {
  content: "\\f18a8";
}

.mdi-cards-playing-diamond-outline::before {
  content: "\\f18a9";
}

.mdi-cards-playing-heart::before {
  content: "\\f18aa";
}

.mdi-cards-playing-heart-multiple::before {
  content: "\\f18ab";
}

.mdi-cards-playing-heart-multiple-outline::before {
  content: "\\f18ac";
}

.mdi-cards-playing-heart-outline::before {
  content: "\\f18ad";
}

.mdi-cards-playing-outline::before {
  content: "\\f063a";
}

.mdi-cards-playing-spade::before {
  content: "\\f18ae";
}

.mdi-cards-playing-spade-multiple::before {
  content: "\\f18af";
}

.mdi-cards-playing-spade-multiple-outline::before {
  content: "\\f18b0";
}

.mdi-cards-playing-spade-outline::before {
  content: "\\f18b1";
}

.mdi-cards-spade::before {
  content: "\\f08d1";
}

.mdi-cards-spade-outline::before {
  content: "\\f18b2";
}

.mdi-cards-variant::before {
  content: "\\f06c7";
}

.mdi-carrot::before {
  content: "\\f010f";
}

.mdi-cart::before {
  content: "\\f0110";
}

.mdi-cart-arrow-down::before {
  content: "\\f0d66";
}

.mdi-cart-arrow-right::before {
  content: "\\f0c4e";
}

.mdi-cart-arrow-up::before {
  content: "\\f0d67";
}

.mdi-cart-check::before {
  content: "\\f15ea";
}

.mdi-cart-heart::before {
  content: "\\f18e0";
}

.mdi-cart-minus::before {
  content: "\\f0d68";
}

.mdi-cart-off::before {
  content: "\\f066b";
}

.mdi-cart-outline::before {
  content: "\\f0111";
}

.mdi-cart-plus::before {
  content: "\\f0112";
}

.mdi-cart-remove::before {
  content: "\\f0d69";
}

.mdi-cart-variant::before {
  content: "\\f15eb";
}

.mdi-case-sensitive-alt::before {
  content: "\\f0113";
}

.mdi-cash::before {
  content: "\\f0114";
}

.mdi-cash-100::before {
  content: "\\f0115";
}

.mdi-cash-check::before {
  content: "\\f14ee";
}

.mdi-cash-fast::before {
  content: "\\f185c";
}

.mdi-cash-lock::before {
  content: "\\f14ea";
}

.mdi-cash-lock-open::before {
  content: "\\f14eb";
}

.mdi-cash-marker::before {
  content: "\\f0db8";
}

.mdi-cash-minus::before {
  content: "\\f1260";
}

.mdi-cash-multiple::before {
  content: "\\f0116";
}

.mdi-cash-plus::before {
  content: "\\f1261";
}

.mdi-cash-refund::before {
  content: "\\f0a9c";
}

.mdi-cash-register::before {
  content: "\\f0cf4";
}

.mdi-cash-remove::before {
  content: "\\f1262";
}

.mdi-cassette::before {
  content: "\\f09d4";
}

.mdi-cast::before {
  content: "\\f0118";
}

.mdi-cast-audio::before {
  content: "\\f101e";
}

.mdi-cast-audio-variant::before {
  content: "\\f1749";
}

.mdi-cast-connected::before {
  content: "\\f0119";
}

.mdi-cast-education::before {
  content: "\\f0e1d";
}

.mdi-cast-off::before {
  content: "\\f078a";
}

.mdi-cast-variant::before {
  content: "\\f001f";
}

.mdi-castle::before {
  content: "\\f011a";
}

.mdi-cat::before {
  content: "\\f011b";
}

.mdi-cctv::before {
  content: "\\f07ae";
}

.mdi-cctv-off::before {
  content: "\\f185f";
}

.mdi-ceiling-fan::before {
  content: "\\f1797";
}

.mdi-ceiling-fan-light::before {
  content: "\\f1798";
}

.mdi-ceiling-light::before {
  content: "\\f0769";
}

.mdi-ceiling-light-multiple::before {
  content: "\\f18dd";
}

.mdi-ceiling-light-multiple-outline::before {
  content: "\\f18de";
}

.mdi-ceiling-light-outline::before {
  content: "\\f17c7";
}

.mdi-cellphone::before {
  content: "\\f011c";
}

.mdi-cellphone-arrow-down::before {
  content: "\\f09d5";
}

.mdi-cellphone-basic::before {
  content: "\\f011e";
}

.mdi-cellphone-charging::before {
  content: "\\f1397";
}

.mdi-cellphone-check::before {
  content: "\\f17fd";
}

.mdi-cellphone-cog::before {
  content: "\\f0951";
}

.mdi-cellphone-dock::before {
  content: "\\f011f";
}

.mdi-cellphone-information::before {
  content: "\\f0f41";
}

.mdi-cellphone-key::before {
  content: "\\f094e";
}

.mdi-cellphone-link::before {
  content: "\\f0121";
}

.mdi-cellphone-link-off::before {
  content: "\\f0122";
}

.mdi-cellphone-lock::before {
  content: "\\f094f";
}

.mdi-cellphone-marker::before {
  content: "\\f183a";
}

.mdi-cellphone-message::before {
  content: "\\f08d3";
}

.mdi-cellphone-message-off::before {
  content: "\\f10d2";
}

.mdi-cellphone-nfc::before {
  content: "\\f0e90";
}

.mdi-cellphone-nfc-off::before {
  content: "\\f12d8";
}

.mdi-cellphone-off::before {
  content: "\\f0950";
}

.mdi-cellphone-play::before {
  content: "\\f101f";
}

.mdi-cellphone-remove::before {
  content: "\\f094d";
}

.mdi-cellphone-screenshot::before {
  content: "\\f0a35";
}

.mdi-cellphone-settings::before {
  content: "\\f0123";
}

.mdi-cellphone-sound::before {
  content: "\\f0952";
}

.mdi-cellphone-text::before {
  content: "\\f08d2";
}

.mdi-cellphone-wireless::before {
  content: "\\f0815";
}

.mdi-centos::before {
  content: "\\f111a";
}

.mdi-certificate::before {
  content: "\\f0124";
}

.mdi-certificate-outline::before {
  content: "\\f1188";
}

.mdi-chair-rolling::before {
  content: "\\f0f48";
}

.mdi-chair-school::before {
  content: "\\f0125";
}

.mdi-chandelier::before {
  content: "\\f1793";
}

.mdi-charity::before {
  content: "\\f0c4f";
}

.mdi-chart-arc::before {
  content: "\\f0126";
}

.mdi-chart-areaspline::before {
  content: "\\f0127";
}

.mdi-chart-areaspline-variant::before {
  content: "\\f0e91";
}

.mdi-chart-bar::before {
  content: "\\f0128";
}

.mdi-chart-bar-stacked::before {
  content: "\\f076a";
}

.mdi-chart-bell-curve::before {
  content: "\\f0c50";
}

.mdi-chart-bell-curve-cumulative::before {
  content: "\\f0fa7";
}

.mdi-chart-box::before {
  content: "\\f154d";
}

.mdi-chart-box-outline::before {
  content: "\\f154e";
}

.mdi-chart-box-plus-outline::before {
  content: "\\f154f";
}

.mdi-chart-bubble::before {
  content: "\\f05e3";
}

.mdi-chart-donut::before {
  content: "\\f07af";
}

.mdi-chart-donut-variant::before {
  content: "\\f07b0";
}

.mdi-chart-gantt::before {
  content: "\\f066c";
}

.mdi-chart-histogram::before {
  content: "\\f0129";
}

.mdi-chart-line::before {
  content: "\\f012a";
}

.mdi-chart-line-stacked::before {
  content: "\\f076b";
}

.mdi-chart-line-variant::before {
  content: "\\f07b1";
}

.mdi-chart-multiline::before {
  content: "\\f08d4";
}

.mdi-chart-multiple::before {
  content: "\\f1213";
}

.mdi-chart-pie::before {
  content: "\\f012b";
}

.mdi-chart-ppf::before {
  content: "\\f1380";
}

.mdi-chart-sankey::before {
  content: "\\f11df";
}

.mdi-chart-sankey-variant::before {
  content: "\\f11e0";
}

.mdi-chart-scatter-plot::before {
  content: "\\f0e92";
}

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\f066d";
}

.mdi-chart-timeline::before {
  content: "\\f066e";
}

.mdi-chart-timeline-variant::before {
  content: "\\f0e93";
}

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\f15b6";
}

.mdi-chart-tree::before {
  content: "\\f0e94";
}

.mdi-chart-waterfall::before {
  content: "\\f1918";
}

.mdi-chat::before {
  content: "\\f0b79";
}

.mdi-chat-alert::before {
  content: "\\f0b7a";
}

.mdi-chat-alert-outline::before {
  content: "\\f12c9";
}

.mdi-chat-minus::before {
  content: "\\f1410";
}

.mdi-chat-minus-outline::before {
  content: "\\f1413";
}

.mdi-chat-outline::before {
  content: "\\f0ede";
}

.mdi-chat-plus::before {
  content: "\\f140f";
}

.mdi-chat-plus-outline::before {
  content: "\\f1412";
}

.mdi-chat-processing::before {
  content: "\\f0b7b";
}

.mdi-chat-processing-outline::before {
  content: "\\f12ca";
}

.mdi-chat-question::before {
  content: "\\f1738";
}

.mdi-chat-question-outline::before {
  content: "\\f1739";
}

.mdi-chat-remove::before {
  content: "\\f1411";
}

.mdi-chat-remove-outline::before {
  content: "\\f1414";
}

.mdi-chat-sleep::before {
  content: "\\f12d1";
}

.mdi-chat-sleep-outline::before {
  content: "\\f12d2";
}

.mdi-check::before {
  content: "\\f012c";
}

.mdi-check-all::before {
  content: "\\f012d";
}

.mdi-check-bold::before {
  content: "\\f0e1e";
}

.mdi-check-circle::before {
  content: "\\f05e0";
}

.mdi-check-circle-outline::before {
  content: "\\f05e1";
}

.mdi-check-decagram::before {
  content: "\\f0791";
}

.mdi-check-decagram-outline::before {
  content: "\\f1740";
}

.mdi-check-network::before {
  content: "\\f0c53";
}

.mdi-check-network-outline::before {
  content: "\\f0c54";
}

.mdi-check-outline::before {
  content: "\\f0855";
}

.mdi-check-underline::before {
  content: "\\f0e1f";
}

.mdi-check-underline-circle::before {
  content: "\\f0e20";
}

.mdi-check-underline-circle-outline::before {
  content: "\\f0e21";
}

.mdi-checkbook::before {
  content: "\\f0a9d";
}

.mdi-checkbox-blank::before {
  content: "\\f012e";
}

.mdi-checkbox-blank-badge::before {
  content: "\\f1176";
}

.mdi-checkbox-blank-badge-outline::before {
  content: "\\f0117";
}

.mdi-checkbox-blank-circle::before {
  content: "\\f012f";
}

.mdi-checkbox-blank-circle-outline::before {
  content: "\\f0130";
}

.mdi-checkbox-blank-off::before {
  content: "\\f12ec";
}

.mdi-checkbox-blank-off-outline::before {
  content: "\\f12ed";
}

.mdi-checkbox-blank-outline::before {
  content: "\\f0131";
}

.mdi-checkbox-intermediate::before {
  content: "\\f0856";
}

.mdi-checkbox-marked::before {
  content: "\\f0132";
}

.mdi-checkbox-marked-circle::before {
  content: "\\f0133";
}

.mdi-checkbox-marked-circle-outline::before {
  content: "\\f0134";
}

.mdi-checkbox-marked-circle-plus-outline::before {
  content: "\\f1927";
}

.mdi-checkbox-marked-outline::before {
  content: "\\f0135";
}

.mdi-checkbox-multiple-blank::before {
  content: "\\f0136";
}

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\f063b";
}

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\f063c";
}

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\f0137";
}

.mdi-checkbox-multiple-marked::before {
  content: "\\f0138";
}

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\f063d";
}

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\f063e";
}

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\f0139";
}

.mdi-checkbox-multiple-outline::before {
  content: "\\f0c51";
}

.mdi-checkbox-outline::before {
  content: "\\f0c52";
}

.mdi-checkerboard::before {
  content: "\\f013a";
}

.mdi-checkerboard-minus::before {
  content: "\\f1202";
}

.mdi-checkerboard-plus::before {
  content: "\\f1201";
}

.mdi-checkerboard-remove::before {
  content: "\\f1203";
}

.mdi-cheese::before {
  content: "\\f12b9";
}

.mdi-cheese-off::before {
  content: "\\f13ee";
}

.mdi-chef-hat::before {
  content: "\\f0b7c";
}

.mdi-chemical-weapon::before {
  content: "\\f013b";
}

.mdi-chess-bishop::before {
  content: "\\f085c";
}

.mdi-chess-king::before {
  content: "\\f0857";
}

.mdi-chess-knight::before {
  content: "\\f0858";
}

.mdi-chess-pawn::before {
  content: "\\f0859";
}

.mdi-chess-queen::before {
  content: "\\f085a";
}

.mdi-chess-rook::before {
  content: "\\f085b";
}

.mdi-chevron-double-down::before {
  content: "\\f013c";
}

.mdi-chevron-double-left::before {
  content: "\\f013d";
}

.mdi-chevron-double-right::before {
  content: "\\f013e";
}

.mdi-chevron-double-up::before {
  content: "\\f013f";
}

.mdi-chevron-down::before {
  content: "\\f0140";
}

.mdi-chevron-down-box::before {
  content: "\\f09d6";
}

.mdi-chevron-down-box-outline::before {
  content: "\\f09d7";
}

.mdi-chevron-down-circle::before {
  content: "\\f0b26";
}

.mdi-chevron-down-circle-outline::before {
  content: "\\f0b27";
}

.mdi-chevron-left::before {
  content: "\\f0141";
}

.mdi-chevron-left-box::before {
  content: "\\f09d8";
}

.mdi-chevron-left-box-outline::before {
  content: "\\f09d9";
}

.mdi-chevron-left-circle::before {
  content: "\\f0b28";
}

.mdi-chevron-left-circle-outline::before {
  content: "\\f0b29";
}

.mdi-chevron-right::before {
  content: "\\f0142";
}

.mdi-chevron-right-box::before {
  content: "\\f09da";
}

.mdi-chevron-right-box-outline::before {
  content: "\\f09db";
}

.mdi-chevron-right-circle::before {
  content: "\\f0b2a";
}

.mdi-chevron-right-circle-outline::before {
  content: "\\f0b2b";
}

.mdi-chevron-triple-down::before {
  content: "\\f0db9";
}

.mdi-chevron-triple-left::before {
  content: "\\f0dba";
}

.mdi-chevron-triple-right::before {
  content: "\\f0dbb";
}

.mdi-chevron-triple-up::before {
  content: "\\f0dbc";
}

.mdi-chevron-up::before {
  content: "\\f0143";
}

.mdi-chevron-up-box::before {
  content: "\\f09dc";
}

.mdi-chevron-up-box-outline::before {
  content: "\\f09dd";
}

.mdi-chevron-up-circle::before {
  content: "\\f0b2c";
}

.mdi-chevron-up-circle-outline::before {
  content: "\\f0b2d";
}

.mdi-chili-alert::before {
  content: "\\f17ea";
}

.mdi-chili-alert-outline::before {
  content: "\\f17eb";
}

.mdi-chili-hot::before {
  content: "\\f07b2";
}

.mdi-chili-hot-outline::before {
  content: "\\f17ec";
}

.mdi-chili-medium::before {
  content: "\\f07b3";
}

.mdi-chili-medium-outline::before {
  content: "\\f17ed";
}

.mdi-chili-mild::before {
  content: "\\f07b4";
}

.mdi-chili-mild-outline::before {
  content: "\\f17ee";
}

.mdi-chili-off::before {
  content: "\\f1467";
}

.mdi-chili-off-outline::before {
  content: "\\f17ef";
}

.mdi-chip::before {
  content: "\\f061a";
}

.mdi-church::before {
  content: "\\f0144";
}

.mdi-cigar::before {
  content: "\\f1189";
}

.mdi-cigar-off::before {
  content: "\\f141b";
}

.mdi-circle::before {
  content: "\\f0765";
}

.mdi-circle-box::before {
  content: "\\f15dc";
}

.mdi-circle-box-outline::before {
  content: "\\f15dd";
}

.mdi-circle-double::before {
  content: "\\f0e95";
}

.mdi-circle-edit-outline::before {
  content: "\\f08d5";
}

.mdi-circle-expand::before {
  content: "\\f0e96";
}

.mdi-circle-half::before {
  content: "\\f1395";
}

.mdi-circle-half-full::before {
  content: "\\f1396";
}

.mdi-circle-medium::before {
  content: "\\f09de";
}

.mdi-circle-multiple::before {
  content: "\\f0b38";
}

.mdi-circle-multiple-outline::before {
  content: "\\f0695";
}

.mdi-circle-off-outline::before {
  content: "\\f10d3";
}

.mdi-circle-opacity::before {
  content: "\\f1853";
}

.mdi-circle-outline::before {
  content: "\\f0766";
}

.mdi-circle-slice-1::before {
  content: "\\f0a9e";
}

.mdi-circle-slice-2::before {
  content: "\\f0a9f";
}

.mdi-circle-slice-3::before {
  content: "\\f0aa0";
}

.mdi-circle-slice-4::before {
  content: "\\f0aa1";
}

.mdi-circle-slice-5::before {
  content: "\\f0aa2";
}

.mdi-circle-slice-6::before {
  content: "\\f0aa3";
}

.mdi-circle-slice-7::before {
  content: "\\f0aa4";
}

.mdi-circle-slice-8::before {
  content: "\\f0aa5";
}

.mdi-circle-small::before {
  content: "\\f09df";
}

.mdi-circular-saw::before {
  content: "\\f0e22";
}

.mdi-city::before {
  content: "\\f0146";
}

.mdi-city-variant::before {
  content: "\\f0a36";
}

.mdi-city-variant-outline::before {
  content: "\\f0a37";
}

.mdi-clipboard::before {
  content: "\\f0147";
}

.mdi-clipboard-account::before {
  content: "\\f0148";
}

.mdi-clipboard-account-outline::before {
  content: "\\f0c55";
}

.mdi-clipboard-alert::before {
  content: "\\f0149";
}

.mdi-clipboard-alert-outline::before {
  content: "\\f0cf7";
}

.mdi-clipboard-arrow-down::before {
  content: "\\f014a";
}

.mdi-clipboard-arrow-down-outline::before {
  content: "\\f0c56";
}

.mdi-clipboard-arrow-left::before {
  content: "\\f014b";
}

.mdi-clipboard-arrow-left-outline::before {
  content: "\\f0cf8";
}

.mdi-clipboard-arrow-right::before {
  content: "\\f0cf9";
}

.mdi-clipboard-arrow-right-outline::before {
  content: "\\f0cfa";
}

.mdi-clipboard-arrow-up::before {
  content: "\\f0c57";
}

.mdi-clipboard-arrow-up-outline::before {
  content: "\\f0c58";
}

.mdi-clipboard-check::before {
  content: "\\f014e";
}

.mdi-clipboard-check-multiple::before {
  content: "\\f1263";
}

.mdi-clipboard-check-multiple-outline::before {
  content: "\\f1264";
}

.mdi-clipboard-check-outline::before {
  content: "\\f08a8";
}

.mdi-clipboard-clock::before {
  content: "\\f16e2";
}

.mdi-clipboard-clock-outline::before {
  content: "\\f16e3";
}

.mdi-clipboard-edit::before {
  content: "\\f14e5";
}

.mdi-clipboard-edit-outline::before {
  content: "\\f14e6";
}

.mdi-clipboard-file::before {
  content: "\\f1265";
}

.mdi-clipboard-file-outline::before {
  content: "\\f1266";
}

.mdi-clipboard-flow::before {
  content: "\\f06c8";
}

.mdi-clipboard-flow-outline::before {
  content: "\\f1117";
}

.mdi-clipboard-list::before {
  content: "\\f10d4";
}

.mdi-clipboard-list-outline::before {
  content: "\\f10d5";
}

.mdi-clipboard-minus::before {
  content: "\\f1618";
}

.mdi-clipboard-minus-outline::before {
  content: "\\f1619";
}

.mdi-clipboard-multiple::before {
  content: "\\f1267";
}

.mdi-clipboard-multiple-outline::before {
  content: "\\f1268";
}

.mdi-clipboard-off::before {
  content: "\\f161a";
}

.mdi-clipboard-off-outline::before {
  content: "\\f161b";
}

.mdi-clipboard-outline::before {
  content: "\\f014c";
}

.mdi-clipboard-play::before {
  content: "\\f0c59";
}

.mdi-clipboard-play-multiple::before {
  content: "\\f1269";
}

.mdi-clipboard-play-multiple-outline::before {
  content: "\\f126a";
}

.mdi-clipboard-play-outline::before {
  content: "\\f0c5a";
}

.mdi-clipboard-plus::before {
  content: "\\f0751";
}

.mdi-clipboard-plus-outline::before {
  content: "\\f131f";
}

.mdi-clipboard-pulse::before {
  content: "\\f085d";
}

.mdi-clipboard-pulse-outline::before {
  content: "\\f085e";
}

.mdi-clipboard-remove::before {
  content: "\\f161c";
}

.mdi-clipboard-remove-outline::before {
  content: "\\f161d";
}

.mdi-clipboard-search::before {
  content: "\\f161e";
}

.mdi-clipboard-search-outline::before {
  content: "\\f161f";
}

.mdi-clipboard-text::before {
  content: "\\f014d";
}

.mdi-clipboard-text-clock::before {
  content: "\\f18f9";
}

.mdi-clipboard-text-clock-outline::before {
  content: "\\f18fa";
}

.mdi-clipboard-text-multiple::before {
  content: "\\f126b";
}

.mdi-clipboard-text-multiple-outline::before {
  content: "\\f126c";
}

.mdi-clipboard-text-off::before {
  content: "\\f1620";
}

.mdi-clipboard-text-off-outline::before {
  content: "\\f1621";
}

.mdi-clipboard-text-outline::before {
  content: "\\f0a38";
}

.mdi-clipboard-text-play::before {
  content: "\\f0c5b";
}

.mdi-clipboard-text-play-outline::before {
  content: "\\f0c5c";
}

.mdi-clipboard-text-search::before {
  content: "\\f1622";
}

.mdi-clipboard-text-search-outline::before {
  content: "\\f1623";
}

.mdi-clippy::before {
  content: "\\f014f";
}

.mdi-clock::before {
  content: "\\f0954";
}

.mdi-clock-alert::before {
  content: "\\f0955";
}

.mdi-clock-alert-outline::before {
  content: "\\f05ce";
}

.mdi-clock-check::before {
  content: "\\f0fa8";
}

.mdi-clock-check-outline::before {
  content: "\\f0fa9";
}

.mdi-clock-digital::before {
  content: "\\f0e97";
}

.mdi-clock-edit::before {
  content: "\\f19ba";
}

.mdi-clock-edit-outline::before {
  content: "\\f19bb";
}

.mdi-clock-end::before {
  content: "\\f0151";
}

.mdi-clock-fast::before {
  content: "\\f0152";
}

.mdi-clock-in::before {
  content: "\\f0153";
}

.mdi-clock-minus::before {
  content: "\\f1863";
}

.mdi-clock-minus-outline::before {
  content: "\\f1864";
}

.mdi-clock-out::before {
  content: "\\f0154";
}

.mdi-clock-outline::before {
  content: "\\f0150";
}

.mdi-clock-plus::before {
  content: "\\f1861";
}

.mdi-clock-plus-outline::before {
  content: "\\f1862";
}

.mdi-clock-remove::before {
  content: "\\f1865";
}

.mdi-clock-remove-outline::before {
  content: "\\f1866";
}

.mdi-clock-start::before {
  content: "\\f0155";
}

.mdi-clock-time-eight::before {
  content: "\\f1446";
}

.mdi-clock-time-eight-outline::before {
  content: "\\f1452";
}

.mdi-clock-time-eleven::before {
  content: "\\f1449";
}

.mdi-clock-time-eleven-outline::before {
  content: "\\f1455";
}

.mdi-clock-time-five::before {
  content: "\\f1443";
}

.mdi-clock-time-five-outline::before {
  content: "\\f144f";
}

.mdi-clock-time-four::before {
  content: "\\f1442";
}

.mdi-clock-time-four-outline::before {
  content: "\\f144e";
}

.mdi-clock-time-nine::before {
  content: "\\f1447";
}

.mdi-clock-time-nine-outline::before {
  content: "\\f1453";
}

.mdi-clock-time-one::before {
  content: "\\f143f";
}

.mdi-clock-time-one-outline::before {
  content: "\\f144b";
}

.mdi-clock-time-seven::before {
  content: "\\f1445";
}

.mdi-clock-time-seven-outline::before {
  content: "\\f1451";
}

.mdi-clock-time-six::before {
  content: "\\f1444";
}

.mdi-clock-time-six-outline::before {
  content: "\\f1450";
}

.mdi-clock-time-ten::before {
  content: "\\f1448";
}

.mdi-clock-time-ten-outline::before {
  content: "\\f1454";
}

.mdi-clock-time-three::before {
  content: "\\f1441";
}

.mdi-clock-time-three-outline::before {
  content: "\\f144d";
}

.mdi-clock-time-twelve::before {
  content: "\\f144a";
}

.mdi-clock-time-twelve-outline::before {
  content: "\\f1456";
}

.mdi-clock-time-two::before {
  content: "\\f1440";
}

.mdi-clock-time-two-outline::before {
  content: "\\f144c";
}

.mdi-close::before {
  content: "\\f0156";
}

.mdi-close-box::before {
  content: "\\f0157";
}

.mdi-close-box-multiple::before {
  content: "\\f0c5d";
}

.mdi-close-box-multiple-outline::before {
  content: "\\f0c5e";
}

.mdi-close-box-outline::before {
  content: "\\f0158";
}

.mdi-close-circle::before {
  content: "\\f0159";
}

.mdi-close-circle-multiple::before {
  content: "\\f062a";
}

.mdi-close-circle-multiple-outline::before {
  content: "\\f0883";
}

.mdi-close-circle-outline::before {
  content: "\\f015a";
}

.mdi-close-network::before {
  content: "\\f015b";
}

.mdi-close-network-outline::before {
  content: "\\f0c5f";
}

.mdi-close-octagon::before {
  content: "\\f015c";
}

.mdi-close-octagon-outline::before {
  content: "\\f015d";
}

.mdi-close-outline::before {
  content: "\\f06c9";
}

.mdi-close-thick::before {
  content: "\\f1398";
}

.mdi-closed-caption::before {
  content: "\\f015e";
}

.mdi-closed-caption-outline::before {
  content: "\\f0dbd";
}

.mdi-cloud::before {
  content: "\\f015f";
}

.mdi-cloud-alert::before {
  content: "\\f09e0";
}

.mdi-cloud-braces::before {
  content: "\\f07b5";
}

.mdi-cloud-check::before {
  content: "\\f0160";
}

.mdi-cloud-check-outline::before {
  content: "\\f12cc";
}

.mdi-cloud-circle::before {
  content: "\\f0161";
}

.mdi-cloud-download::before {
  content: "\\f0162";
}

.mdi-cloud-download-outline::before {
  content: "\\f0b7d";
}

.mdi-cloud-lock::before {
  content: "\\f11f1";
}

.mdi-cloud-lock-outline::before {
  content: "\\f11f2";
}

.mdi-cloud-off-outline::before {
  content: "\\f0164";
}

.mdi-cloud-outline::before {
  content: "\\f0163";
}

.mdi-cloud-print::before {
  content: "\\f0165";
}

.mdi-cloud-print-outline::before {
  content: "\\f0166";
}

.mdi-cloud-question::before {
  content: "\\f0a39";
}

.mdi-cloud-refresh::before {
  content: "\\f052a";
}

.mdi-cloud-search::before {
  content: "\\f0956";
}

.mdi-cloud-search-outline::before {
  content: "\\f0957";
}

.mdi-cloud-sync::before {
  content: "\\f063f";
}

.mdi-cloud-sync-outline::before {
  content: "\\f12d6";
}

.mdi-cloud-tags::before {
  content: "\\f07b6";
}

.mdi-cloud-upload::before {
  content: "\\f0167";
}

.mdi-cloud-upload-outline::before {
  content: "\\f0b7e";
}

.mdi-clover::before {
  content: "\\f0816";
}

.mdi-coach-lamp::before {
  content: "\\f1020";
}

.mdi-coat-rack::before {
  content: "\\f109e";
}

.mdi-code-array::before {
  content: "\\f0168";
}

.mdi-code-braces::before {
  content: "\\f0169";
}

.mdi-code-braces-box::before {
  content: "\\f10d6";
}

.mdi-code-brackets::before {
  content: "\\f016a";
}

.mdi-code-equal::before {
  content: "\\f016b";
}

.mdi-code-greater-than::before {
  content: "\\f016c";
}

.mdi-code-greater-than-or-equal::before {
  content: "\\f016d";
}

.mdi-code-json::before {
  content: "\\f0626";
}

.mdi-code-less-than::before {
  content: "\\f016e";
}

.mdi-code-less-than-or-equal::before {
  content: "\\f016f";
}

.mdi-code-not-equal::before {
  content: "\\f0170";
}

.mdi-code-not-equal-variant::before {
  content: "\\f0171";
}

.mdi-code-parentheses::before {
  content: "\\f0172";
}

.mdi-code-parentheses-box::before {
  content: "\\f10d7";
}

.mdi-code-string::before {
  content: "\\f0173";
}

.mdi-code-tags::before {
  content: "\\f0174";
}

.mdi-code-tags-check::before {
  content: "\\f0694";
}

.mdi-codepen::before {
  content: "\\f0175";
}

.mdi-coffee::before {
  content: "\\f0176";
}

.mdi-coffee-maker::before {
  content: "\\f109f";
}

.mdi-coffee-maker-check::before {
  content: "\\f1931";
}

.mdi-coffee-maker-check-outline::before {
  content: "\\f1932";
}

.mdi-coffee-maker-outline::before {
  content: "\\f181b";
}

.mdi-coffee-off::before {
  content: "\\f0faa";
}

.mdi-coffee-off-outline::before {
  content: "\\f0fab";
}

.mdi-coffee-outline::before {
  content: "\\f06ca";
}

.mdi-coffee-to-go::before {
  content: "\\f0177";
}

.mdi-coffee-to-go-outline::before {
  content: "\\f130e";
}

.mdi-coffin::before {
  content: "\\f0b7f";
}

.mdi-cog::before {
  content: "\\f0493";
}

.mdi-cog-box::before {
  content: "\\f0494";
}

.mdi-cog-clockwise::before {
  content: "\\f11dd";
}

.mdi-cog-counterclockwise::before {
  content: "\\f11de";
}

.mdi-cog-off::before {
  content: "\\f13ce";
}

.mdi-cog-off-outline::before {
  content: "\\f13cf";
}

.mdi-cog-outline::before {
  content: "\\f08bb";
}

.mdi-cog-pause::before {
  content: "\\f1933";
}

.mdi-cog-pause-outline::before {
  content: "\\f1934";
}

.mdi-cog-play::before {
  content: "\\f1935";
}

.mdi-cog-play-outline::before {
  content: "\\f1936";
}

.mdi-cog-refresh::before {
  content: "\\f145e";
}

.mdi-cog-refresh-outline::before {
  content: "\\f145f";
}

.mdi-cog-stop::before {
  content: "\\f1937";
}

.mdi-cog-stop-outline::before {
  content: "\\f1938";
}

.mdi-cog-sync::before {
  content: "\\f1460";
}

.mdi-cog-sync-outline::before {
  content: "\\f1461";
}

.mdi-cog-transfer::before {
  content: "\\f105b";
}

.mdi-cog-transfer-outline::before {
  content: "\\f105c";
}

.mdi-cogs::before {
  content: "\\f08d6";
}

.mdi-collage::before {
  content: "\\f0640";
}

.mdi-collapse-all::before {
  content: "\\f0aa6";
}

.mdi-collapse-all-outline::before {
  content: "\\f0aa7";
}

.mdi-color-helper::before {
  content: "\\f0179";
}

.mdi-comma::before {
  content: "\\f0e23";
}

.mdi-comma-box::before {
  content: "\\f0e2b";
}

.mdi-comma-box-outline::before {
  content: "\\f0e24";
}

.mdi-comma-circle::before {
  content: "\\f0e25";
}

.mdi-comma-circle-outline::before {
  content: "\\f0e26";
}

.mdi-comment::before {
  content: "\\f017a";
}

.mdi-comment-account::before {
  content: "\\f017b";
}

.mdi-comment-account-outline::before {
  content: "\\f017c";
}

.mdi-comment-alert::before {
  content: "\\f017d";
}

.mdi-comment-alert-outline::before {
  content: "\\f017e";
}

.mdi-comment-arrow-left::before {
  content: "\\f09e1";
}

.mdi-comment-arrow-left-outline::before {
  content: "\\f09e2";
}

.mdi-comment-arrow-right::before {
  content: "\\f09e3";
}

.mdi-comment-arrow-right-outline::before {
  content: "\\f09e4";
}

.mdi-comment-bookmark::before {
  content: "\\f15ae";
}

.mdi-comment-bookmark-outline::before {
  content: "\\f15af";
}

.mdi-comment-check::before {
  content: "\\f017f";
}

.mdi-comment-check-outline::before {
  content: "\\f0180";
}

.mdi-comment-edit::before {
  content: "\\f11bf";
}

.mdi-comment-edit-outline::before {
  content: "\\f12c4";
}

.mdi-comment-eye::before {
  content: "\\f0a3a";
}

.mdi-comment-eye-outline::before {
  content: "\\f0a3b";
}

.mdi-comment-flash::before {
  content: "\\f15b0";
}

.mdi-comment-flash-outline::before {
  content: "\\f15b1";
}

.mdi-comment-minus::before {
  content: "\\f15df";
}

.mdi-comment-minus-outline::before {
  content: "\\f15e0";
}

.mdi-comment-multiple::before {
  content: "\\f085f";
}

.mdi-comment-multiple-outline::before {
  content: "\\f0181";
}

.mdi-comment-off::before {
  content: "\\f15e1";
}

.mdi-comment-off-outline::before {
  content: "\\f15e2";
}

.mdi-comment-outline::before {
  content: "\\f0182";
}

.mdi-comment-plus::before {
  content: "\\f09e5";
}

.mdi-comment-plus-outline::before {
  content: "\\f0183";
}

.mdi-comment-processing::before {
  content: "\\f0184";
}

.mdi-comment-processing-outline::before {
  content: "\\f0185";
}

.mdi-comment-question::before {
  content: "\\f0817";
}

.mdi-comment-question-outline::before {
  content: "\\f0186";
}

.mdi-comment-quote::before {
  content: "\\f1021";
}

.mdi-comment-quote-outline::before {
  content: "\\f1022";
}

.mdi-comment-remove::before {
  content: "\\f05de";
}

.mdi-comment-remove-outline::before {
  content: "\\f0187";
}

.mdi-comment-search::before {
  content: "\\f0a3c";
}

.mdi-comment-search-outline::before {
  content: "\\f0a3d";
}

.mdi-comment-text::before {
  content: "\\f0188";
}

.mdi-comment-text-multiple::before {
  content: "\\f0860";
}

.mdi-comment-text-multiple-outline::before {
  content: "\\f0861";
}

.mdi-comment-text-outline::before {
  content: "\\f0189";
}

.mdi-compare::before {
  content: "\\f018a";
}

.mdi-compare-horizontal::before {
  content: "\\f1492";
}

.mdi-compare-remove::before {
  content: "\\f18b3";
}

.mdi-compare-vertical::before {
  content: "\\f1493";
}

.mdi-compass::before {
  content: "\\f018b";
}

.mdi-compass-off::before {
  content: "\\f0b80";
}

.mdi-compass-off-outline::before {
  content: "\\f0b81";
}

.mdi-compass-outline::before {
  content: "\\f018c";
}

.mdi-compass-rose::before {
  content: "\\f1382";
}

.mdi-cone::before {
  content: "\\f194c";
}

.mdi-cone-off::before {
  content: "\\f194d";
}

.mdi-connection::before {
  content: "\\f1616";
}

.mdi-console::before {
  content: "\\f018d";
}

.mdi-console-line::before {
  content: "\\f07b7";
}

.mdi-console-network::before {
  content: "\\f08a9";
}

.mdi-console-network-outline::before {
  content: "\\f0c60";
}

.mdi-consolidate::before {
  content: "\\f10d8";
}

.mdi-contactless-payment::before {
  content: "\\f0d6a";
}

.mdi-contactless-payment-circle::before {
  content: "\\f0321";
}

.mdi-contactless-payment-circle-outline::before {
  content: "\\f0408";
}

.mdi-contacts::before {
  content: "\\f06cb";
}

.mdi-contacts-outline::before {
  content: "\\f05b8";
}

.mdi-contain::before {
  content: "\\f0a3e";
}

.mdi-contain-end::before {
  content: "\\f0a3f";
}

.mdi-contain-start::before {
  content: "\\f0a40";
}

.mdi-content-copy::before {
  content: "\\f018f";
}

.mdi-content-cut::before {
  content: "\\f0190";
}

.mdi-content-duplicate::before {
  content: "\\f0191";
}

.mdi-content-paste::before {
  content: "\\f0192";
}

.mdi-content-save::before {
  content: "\\f0193";
}

.mdi-content-save-alert::before {
  content: "\\f0f42";
}

.mdi-content-save-alert-outline::before {
  content: "\\f0f43";
}

.mdi-content-save-all::before {
  content: "\\f0194";
}

.mdi-content-save-all-outline::before {
  content: "\\f0f44";
}

.mdi-content-save-check::before {
  content: "\\f18ea";
}

.mdi-content-save-check-outline::before {
  content: "\\f18eb";
}

.mdi-content-save-cog::before {
  content: "\\f145b";
}

.mdi-content-save-cog-outline::before {
  content: "\\f145c";
}

.mdi-content-save-edit::before {
  content: "\\f0cfb";
}

.mdi-content-save-edit-outline::before {
  content: "\\f0cfc";
}

.mdi-content-save-move::before {
  content: "\\f0e27";
}

.mdi-content-save-move-outline::before {
  content: "\\f0e28";
}

.mdi-content-save-off::before {
  content: "\\f1643";
}

.mdi-content-save-off-outline::before {
  content: "\\f1644";
}

.mdi-content-save-outline::before {
  content: "\\f0818";
}

.mdi-content-save-settings::before {
  content: "\\f061b";
}

.mdi-content-save-settings-outline::before {
  content: "\\f0b2e";
}

.mdi-contrast::before {
  content: "\\f0195";
}

.mdi-contrast-box::before {
  content: "\\f0196";
}

.mdi-contrast-circle::before {
  content: "\\f0197";
}

.mdi-controller-classic::before {
  content: "\\f0b82";
}

.mdi-controller-classic-outline::before {
  content: "\\f0b83";
}

.mdi-cookie::before {
  content: "\\f0198";
}

.mdi-cookie-alert::before {
  content: "\\f16d0";
}

.mdi-cookie-alert-outline::before {
  content: "\\f16d1";
}

.mdi-cookie-check::before {
  content: "\\f16d2";
}

.mdi-cookie-check-outline::before {
  content: "\\f16d3";
}

.mdi-cookie-clock::before {
  content: "\\f16e4";
}

.mdi-cookie-clock-outline::before {
  content: "\\f16e5";
}

.mdi-cookie-cog::before {
  content: "\\f16d4";
}

.mdi-cookie-cog-outline::before {
  content: "\\f16d5";
}

.mdi-cookie-edit::before {
  content: "\\f16e6";
}

.mdi-cookie-edit-outline::before {
  content: "\\f16e7";
}

.mdi-cookie-lock::before {
  content: "\\f16e8";
}

.mdi-cookie-lock-outline::before {
  content: "\\f16e9";
}

.mdi-cookie-minus::before {
  content: "\\f16da";
}

.mdi-cookie-minus-outline::before {
  content: "\\f16db";
}

.mdi-cookie-off::before {
  content: "\\f16ea";
}

.mdi-cookie-off-outline::before {
  content: "\\f16eb";
}

.mdi-cookie-outline::before {
  content: "\\f16de";
}

.mdi-cookie-plus::before {
  content: "\\f16d6";
}

.mdi-cookie-plus-outline::before {
  content: "\\f16d7";
}

.mdi-cookie-refresh::before {
  content: "\\f16ec";
}

.mdi-cookie-refresh-outline::before {
  content: "\\f16ed";
}

.mdi-cookie-remove::before {
  content: "\\f16d8";
}

.mdi-cookie-remove-outline::before {
  content: "\\f16d9";
}

.mdi-cookie-settings::before {
  content: "\\f16dc";
}

.mdi-cookie-settings-outline::before {
  content: "\\f16dd";
}

.mdi-coolant-temperature::before {
  content: "\\f03c8";
}

.mdi-copyleft::before {
  content: "\\f1939";
}

.mdi-copyright::before {
  content: "\\f05e6";
}

.mdi-cordova::before {
  content: "\\f0958";
}

.mdi-corn::before {
  content: "\\f07b8";
}

.mdi-corn-off::before {
  content: "\\f13ef";
}

.mdi-cosine-wave::before {
  content: "\\f1479";
}

.mdi-counter::before {
  content: "\\f0199";
}

.mdi-countertop::before {
  content: "\\f181c";
}

.mdi-countertop-outline::before {
  content: "\\f181d";
}

.mdi-cow::before {
  content: "\\f019a";
}

.mdi-cow-off::before {
  content: "\\f18fc";
}

.mdi-cpu-32-bit::before {
  content: "\\f0edf";
}

.mdi-cpu-64-bit::before {
  content: "\\f0ee0";
}

.mdi-cradle::before {
  content: "\\f198b";
}

.mdi-cradle-outline::before {
  content: "\\f1991";
}

.mdi-crane::before {
  content: "\\f0862";
}

.mdi-creation::before {
  content: "\\f0674";
}

.mdi-creative-commons::before {
  content: "\\f0d6b";
}

.mdi-credit-card::before {
  content: "\\f0fef";
}

.mdi-credit-card-check::before {
  content: "\\f13d0";
}

.mdi-credit-card-check-outline::before {
  content: "\\f13d1";
}

.mdi-credit-card-chip::before {
  content: "\\f190f";
}

.mdi-credit-card-chip-outline::before {
  content: "\\f1910";
}

.mdi-credit-card-clock::before {
  content: "\\f0ee1";
}

.mdi-credit-card-clock-outline::before {
  content: "\\f0ee2";
}

.mdi-credit-card-edit::before {
  content: "\\f17d7";
}

.mdi-credit-card-edit-outline::before {
  content: "\\f17d8";
}

.mdi-credit-card-fast::before {
  content: "\\f1911";
}

.mdi-credit-card-fast-outline::before {
  content: "\\f1912";
}

.mdi-credit-card-lock::before {
  content: "\\f18e7";
}

.mdi-credit-card-lock-outline::before {
  content: "\\f18e8";
}

.mdi-credit-card-marker::before {
  content: "\\f06a8";
}

.mdi-credit-card-marker-outline::before {
  content: "\\f0dbe";
}

.mdi-credit-card-minus::before {
  content: "\\f0fac";
}

.mdi-credit-card-minus-outline::before {
  content: "\\f0fad";
}

.mdi-credit-card-multiple::before {
  content: "\\f0ff0";
}

.mdi-credit-card-multiple-outline::before {
  content: "\\f019c";
}

.mdi-credit-card-off::before {
  content: "\\f0ff1";
}

.mdi-credit-card-off-outline::before {
  content: "\\f05e4";
}

.mdi-credit-card-outline::before {
  content: "\\f019b";
}

.mdi-credit-card-plus::before {
  content: "\\f0ff2";
}

.mdi-credit-card-plus-outline::before {
  content: "\\f0676";
}

.mdi-credit-card-refresh::before {
  content: "\\f1645";
}

.mdi-credit-card-refresh-outline::before {
  content: "\\f1646";
}

.mdi-credit-card-refund::before {
  content: "\\f0ff3";
}

.mdi-credit-card-refund-outline::before {
  content: "\\f0aa8";
}

.mdi-credit-card-remove::before {
  content: "\\f0fae";
}

.mdi-credit-card-remove-outline::before {
  content: "\\f0faf";
}

.mdi-credit-card-scan::before {
  content: "\\f0ff4";
}

.mdi-credit-card-scan-outline::before {
  content: "\\f019d";
}

.mdi-credit-card-search::before {
  content: "\\f1647";
}

.mdi-credit-card-search-outline::before {
  content: "\\f1648";
}

.mdi-credit-card-settings::before {
  content: "\\f0ff5";
}

.mdi-credit-card-settings-outline::before {
  content: "\\f08d7";
}

.mdi-credit-card-sync::before {
  content: "\\f1649";
}

.mdi-credit-card-sync-outline::before {
  content: "\\f164a";
}

.mdi-credit-card-wireless::before {
  content: "\\f0802";
}

.mdi-credit-card-wireless-off::before {
  content: "\\f057a";
}

.mdi-credit-card-wireless-off-outline::before {
  content: "\\f057b";
}

.mdi-credit-card-wireless-outline::before {
  content: "\\f0d6c";
}

.mdi-cricket::before {
  content: "\\f0d6d";
}

.mdi-crop::before {
  content: "\\f019e";
}

.mdi-crop-free::before {
  content: "\\f019f";
}

.mdi-crop-landscape::before {
  content: "\\f01a0";
}

.mdi-crop-portrait::before {
  content: "\\f01a1";
}

.mdi-crop-rotate::before {
  content: "\\f0696";
}

.mdi-crop-square::before {
  content: "\\f01a2";
}

.mdi-cross::before {
  content: "\\f0953";
}

.mdi-cross-bolnisi::before {
  content: "\\f0ced";
}

.mdi-cross-celtic::before {
  content: "\\f0cf5";
}

.mdi-cross-outline::before {
  content: "\\f0cf6";
}

.mdi-crosshairs::before {
  content: "\\f01a3";
}

.mdi-crosshairs-gps::before {
  content: "\\f01a4";
}

.mdi-crosshairs-off::before {
  content: "\\f0f45";
}

.mdi-crosshairs-question::before {
  content: "\\f1136";
}

.mdi-crowd::before {
  content: "\\f1975";
}

.mdi-crown::before {
  content: "\\f01a5";
}

.mdi-crown-circle::before {
  content: "\\f17dc";
}

.mdi-crown-circle-outline::before {
  content: "\\f17dd";
}

.mdi-crown-outline::before {
  content: "\\f11d0";
}

.mdi-cryengine::before {
  content: "\\f0959";
}

.mdi-crystal-ball::before {
  content: "\\f0b2f";
}

.mdi-cube::before {
  content: "\\f01a6";
}

.mdi-cube-off::before {
  content: "\\f141c";
}

.mdi-cube-off-outline::before {
  content: "\\f141d";
}

.mdi-cube-outline::before {
  content: "\\f01a7";
}

.mdi-cube-scan::before {
  content: "\\f0b84";
}

.mdi-cube-send::before {
  content: "\\f01a8";
}

.mdi-cube-unfolded::before {
  content: "\\f01a9";
}

.mdi-cup::before {
  content: "\\f01aa";
}

.mdi-cup-off::before {
  content: "\\f05e5";
}

.mdi-cup-off-outline::before {
  content: "\\f137d";
}

.mdi-cup-outline::before {
  content: "\\f130f";
}

.mdi-cup-water::before {
  content: "\\f01ab";
}

.mdi-cupboard::before {
  content: "\\f0f46";
}

.mdi-cupboard-outline::before {
  content: "\\f0f47";
}

.mdi-cupcake::before {
  content: "\\f095a";
}

.mdi-curling::before {
  content: "\\f0863";
}

.mdi-currency-bdt::before {
  content: "\\f0864";
}

.mdi-currency-brl::before {
  content: "\\f0b85";
}

.mdi-currency-btc::before {
  content: "\\f01ac";
}

.mdi-currency-cny::before {
  content: "\\f07ba";
}

.mdi-currency-eth::before {
  content: "\\f07bb";
}

.mdi-currency-eur::before {
  content: "\\f01ad";
}

.mdi-currency-eur-off::before {
  content: "\\f1315";
}

.mdi-currency-gbp::before {
  content: "\\f01ae";
}

.mdi-currency-ils::before {
  content: "\\f0c61";
}

.mdi-currency-inr::before {
  content: "\\f01af";
}

.mdi-currency-jpy::before {
  content: "\\f07bc";
}

.mdi-currency-krw::before {
  content: "\\f07bd";
}

.mdi-currency-kzt::before {
  content: "\\f0865";
}

.mdi-currency-mnt::before {
  content: "\\f1512";
}

.mdi-currency-ngn::before {
  content: "\\f01b0";
}

.mdi-currency-php::before {
  content: "\\f09e6";
}

.mdi-currency-rial::before {
  content: "\\f0e9c";
}

.mdi-currency-rub::before {
  content: "\\f01b1";
}

.mdi-currency-rupee::before {
  content: "\\f1976";
}

.mdi-currency-sign::before {
  content: "\\f07be";
}

.mdi-currency-try::before {
  content: "\\f01b2";
}

.mdi-currency-twd::before {
  content: "\\f07bf";
}

.mdi-currency-usd::before {
  content: "\\f01c1";
}

.mdi-currency-usd-off::before {
  content: "\\f067a";
}

.mdi-current-ac::before {
  content: "\\f1480";
}

.mdi-current-dc::before {
  content: "\\f095c";
}

.mdi-cursor-default::before {
  content: "\\f01c0";
}

.mdi-cursor-default-click::before {
  content: "\\f0cfd";
}

.mdi-cursor-default-click-outline::before {
  content: "\\f0cfe";
}

.mdi-cursor-default-gesture::before {
  content: "\\f1127";
}

.mdi-cursor-default-gesture-outline::before {
  content: "\\f1128";
}

.mdi-cursor-default-outline::before {
  content: "\\f01bf";
}

.mdi-cursor-move::before {
  content: "\\f01be";
}

.mdi-cursor-pointer::before {
  content: "\\f01bd";
}

.mdi-cursor-text::before {
  content: "\\f05e7";
}

.mdi-curtains::before {
  content: "\\f1846";
}

.mdi-curtains-closed::before {
  content: "\\f1847";
}

.mdi-cylinder::before {
  content: "\\f194e";
}

.mdi-cylinder-off::before {
  content: "\\f194f";
}

.mdi-dance-ballroom::before {
  content: "\\f15fb";
}

.mdi-dance-pole::before {
  content: "\\f1578";
}

.mdi-data-matrix::before {
  content: "\\f153c";
}

.mdi-data-matrix-edit::before {
  content: "\\f153d";
}

.mdi-data-matrix-minus::before {
  content: "\\f153e";
}

.mdi-data-matrix-plus::before {
  content: "\\f153f";
}

.mdi-data-matrix-remove::before {
  content: "\\f1540";
}

.mdi-data-matrix-scan::before {
  content: "\\f1541";
}

.mdi-database::before {
  content: "\\f01bc";
}

.mdi-database-alert::before {
  content: "\\f163a";
}

.mdi-database-alert-outline::before {
  content: "\\f1624";
}

.mdi-database-arrow-down::before {
  content: "\\f163b";
}

.mdi-database-arrow-down-outline::before {
  content: "\\f1625";
}

.mdi-database-arrow-left::before {
  content: "\\f163c";
}

.mdi-database-arrow-left-outline::before {
  content: "\\f1626";
}

.mdi-database-arrow-right::before {
  content: "\\f163d";
}

.mdi-database-arrow-right-outline::before {
  content: "\\f1627";
}

.mdi-database-arrow-up::before {
  content: "\\f163e";
}

.mdi-database-arrow-up-outline::before {
  content: "\\f1628";
}

.mdi-database-check::before {
  content: "\\f0aa9";
}

.mdi-database-check-outline::before {
  content: "\\f1629";
}

.mdi-database-clock::before {
  content: "\\f163f";
}

.mdi-database-clock-outline::before {
  content: "\\f162a";
}

.mdi-database-cog::before {
  content: "\\f164b";
}

.mdi-database-cog-outline::before {
  content: "\\f164c";
}

.mdi-database-edit::before {
  content: "\\f0b86";
}

.mdi-database-edit-outline::before {
  content: "\\f162b";
}

.mdi-database-export::before {
  content: "\\f095e";
}

.mdi-database-export-outline::before {
  content: "\\f162c";
}

.mdi-database-eye::before {
  content: "\\f191f";
}

.mdi-database-eye-off::before {
  content: "\\f1920";
}

.mdi-database-eye-off-outline::before {
  content: "\\f1921";
}

.mdi-database-eye-outline::before {
  content: "\\f1922";
}

.mdi-database-import::before {
  content: "\\f095d";
}

.mdi-database-import-outline::before {
  content: "\\f162d";
}

.mdi-database-lock::before {
  content: "\\f0aaa";
}

.mdi-database-lock-outline::before {
  content: "\\f162e";
}

.mdi-database-marker::before {
  content: "\\f12f6";
}

.mdi-database-marker-outline::before {
  content: "\\f162f";
}

.mdi-database-minus::before {
  content: "\\f01bb";
}

.mdi-database-minus-outline::before {
  content: "\\f1630";
}

.mdi-database-off::before {
  content: "\\f1640";
}

.mdi-database-off-outline::before {
  content: "\\f1631";
}

.mdi-database-outline::before {
  content: "\\f1632";
}

.mdi-database-plus::before {
  content: "\\f01ba";
}

.mdi-database-plus-outline::before {
  content: "\\f1633";
}

.mdi-database-refresh::before {
  content: "\\f05c2";
}

.mdi-database-refresh-outline::before {
  content: "\\f1634";
}

.mdi-database-remove::before {
  content: "\\f0d00";
}

.mdi-database-remove-outline::before {
  content: "\\f1635";
}

.mdi-database-search::before {
  content: "\\f0866";
}

.mdi-database-search-outline::before {
  content: "\\f1636";
}

.mdi-database-settings::before {
  content: "\\f0d01";
}

.mdi-database-settings-outline::before {
  content: "\\f1637";
}

.mdi-database-sync::before {
  content: "\\f0cff";
}

.mdi-database-sync-outline::before {
  content: "\\f1638";
}

.mdi-death-star::before {
  content: "\\f08d8";
}

.mdi-death-star-variant::before {
  content: "\\f08d9";
}

.mdi-deathly-hallows::before {
  content: "\\f0b87";
}

.mdi-debian::before {
  content: "\\f08da";
}

.mdi-debug-step-into::before {
  content: "\\f01b9";
}

.mdi-debug-step-out::before {
  content: "\\f01b8";
}

.mdi-debug-step-over::before {
  content: "\\f01b7";
}

.mdi-decagram::before {
  content: "\\f076c";
}

.mdi-decagram-outline::before {
  content: "\\f076d";
}

.mdi-decimal::before {
  content: "\\f10a1";
}

.mdi-decimal-comma::before {
  content: "\\f10a2";
}

.mdi-decimal-comma-decrease::before {
  content: "\\f10a3";
}

.mdi-decimal-comma-increase::before {
  content: "\\f10a4";
}

.mdi-decimal-decrease::before {
  content: "\\f01b6";
}

.mdi-decimal-increase::before {
  content: "\\f01b5";
}

.mdi-delete::before {
  content: "\\f01b4";
}

.mdi-delete-alert::before {
  content: "\\f10a5";
}

.mdi-delete-alert-outline::before {
  content: "\\f10a6";
}

.mdi-delete-circle::before {
  content: "\\f0683";
}

.mdi-delete-circle-outline::before {
  content: "\\f0b88";
}

.mdi-delete-clock::before {
  content: "\\f1556";
}

.mdi-delete-clock-outline::before {
  content: "\\f1557";
}

.mdi-delete-empty::before {
  content: "\\f06cc";
}

.mdi-delete-empty-outline::before {
  content: "\\f0e9d";
}

.mdi-delete-forever::before {
  content: "\\f05e8";
}

.mdi-delete-forever-outline::before {
  content: "\\f0b89";
}

.mdi-delete-off::before {
  content: "\\f10a7";
}

.mdi-delete-off-outline::before {
  content: "\\f10a8";
}

.mdi-delete-outline::before {
  content: "\\f09e7";
}

.mdi-delete-restore::before {
  content: "\\f0819";
}

.mdi-delete-sweep::before {
  content: "\\f05e9";
}

.mdi-delete-sweep-outline::before {
  content: "\\f0c62";
}

.mdi-delete-variant::before {
  content: "\\f01b3";
}

.mdi-delta::before {
  content: "\\f01c2";
}

.mdi-desk::before {
  content: "\\f1239";
}

.mdi-desk-lamp::before {
  content: "\\f095f";
}

.mdi-deskphone::before {
  content: "\\f01c3";
}

.mdi-desktop-classic::before {
  content: "\\f07c0";
}

.mdi-desktop-mac::before {
  content: "\\f01c4";
}

.mdi-desktop-mac-dashboard::before {
  content: "\\f09e8";
}

.mdi-desktop-tower::before {
  content: "\\f01c5";
}

.mdi-desktop-tower-monitor::before {
  content: "\\f0aab";
}

.mdi-details::before {
  content: "\\f01c6";
}

.mdi-dev-to::before {
  content: "\\f0d6e";
}

.mdi-developer-board::before {
  content: "\\f0697";
}

.mdi-deviantart::before {
  content: "\\f01c7";
}

.mdi-devices::before {
  content: "\\f0fb0";
}

.mdi-dharmachakra::before {
  content: "\\f094b";
}

.mdi-diabetes::before {
  content: "\\f1126";
}

.mdi-dialpad::before {
  content: "\\f061c";
}

.mdi-diameter::before {
  content: "\\f0c63";
}

.mdi-diameter-outline::before {
  content: "\\f0c64";
}

.mdi-diameter-variant::before {
  content: "\\f0c65";
}

.mdi-diamond::before {
  content: "\\f0b8a";
}

.mdi-diamond-outline::before {
  content: "\\f0b8b";
}

.mdi-diamond-stone::before {
  content: "\\f01c8";
}

.mdi-dice-1::before {
  content: "\\f01ca";
}

.mdi-dice-1-outline::before {
  content: "\\f114a";
}

.mdi-dice-2::before {
  content: "\\f01cb";
}

.mdi-dice-2-outline::before {
  content: "\\f114b";
}

.mdi-dice-3::before {
  content: "\\f01cc";
}

.mdi-dice-3-outline::before {
  content: "\\f114c";
}

.mdi-dice-4::before {
  content: "\\f01cd";
}

.mdi-dice-4-outline::before {
  content: "\\f114d";
}

.mdi-dice-5::before {
  content: "\\f01ce";
}

.mdi-dice-5-outline::before {
  content: "\\f114e";
}

.mdi-dice-6::before {
  content: "\\f01cf";
}

.mdi-dice-6-outline::before {
  content: "\\f114f";
}

.mdi-dice-d10::before {
  content: "\\f1153";
}

.mdi-dice-d10-outline::before {
  content: "\\f076f";
}

.mdi-dice-d12::before {
  content: "\\f1154";
}

.mdi-dice-d12-outline::before {
  content: "\\f0867";
}

.mdi-dice-d20::before {
  content: "\\f1155";
}

.mdi-dice-d20-outline::before {
  content: "\\f05ea";
}

.mdi-dice-d4::before {
  content: "\\f1150";
}

.mdi-dice-d4-outline::before {
  content: "\\f05eb";
}

.mdi-dice-d6::before {
  content: "\\f1151";
}

.mdi-dice-d6-outline::before {
  content: "\\f05ed";
}

.mdi-dice-d8::before {
  content: "\\f1152";
}

.mdi-dice-d8-outline::before {
  content: "\\f05ec";
}

.mdi-dice-multiple::before {
  content: "\\f076e";
}

.mdi-dice-multiple-outline::before {
  content: "\\f1156";
}

.mdi-digital-ocean::before {
  content: "\\f1237";
}

.mdi-dip-switch::before {
  content: "\\f07c1";
}

.mdi-directions::before {
  content: "\\f01d0";
}

.mdi-directions-fork::before {
  content: "\\f0641";
}

.mdi-disc::before {
  content: "\\f05ee";
}

.mdi-disc-alert::before {
  content: "\\f01d1";
}

.mdi-disc-player::before {
  content: "\\f0960";
}

.mdi-discord::before {
  content: "\\f066f";
}

.mdi-dishwasher::before {
  content: "\\f0aac";
}

.mdi-dishwasher-alert::before {
  content: "\\f11b8";
}

.mdi-dishwasher-off::before {
  content: "\\f11b9";
}

.mdi-disqus::before {
  content: "\\f01d2";
}

.mdi-distribute-horizontal-center::before {
  content: "\\f11c9";
}

.mdi-distribute-horizontal-left::before {
  content: "\\f11c8";
}

.mdi-distribute-horizontal-right::before {
  content: "\\f11ca";
}

.mdi-distribute-vertical-bottom::before {
  content: "\\f11cb";
}

.mdi-distribute-vertical-center::before {
  content: "\\f11cc";
}

.mdi-distribute-vertical-top::before {
  content: "\\f11cd";
}

.mdi-diversify::before {
  content: "\\f1877";
}

.mdi-diving::before {
  content: "\\f1977";
}

.mdi-diving-flippers::before {
  content: "\\f0dbf";
}

.mdi-diving-helmet::before {
  content: "\\f0dc0";
}

.mdi-diving-scuba::before {
  content: "\\f0dc1";
}

.mdi-diving-scuba-flag::before {
  content: "\\f0dc2";
}

.mdi-diving-scuba-tank::before {
  content: "\\f0dc3";
}

.mdi-diving-scuba-tank-multiple::before {
  content: "\\f0dc4";
}

.mdi-diving-snorkel::before {
  content: "\\f0dc5";
}

.mdi-division::before {
  content: "\\f01d4";
}

.mdi-division-box::before {
  content: "\\f01d5";
}

.mdi-dlna::before {
  content: "\\f0a41";
}

.mdi-dna::before {
  content: "\\f0684";
}

.mdi-dns::before {
  content: "\\f01d6";
}

.mdi-dns-outline::before {
  content: "\\f0b8c";
}

.mdi-dock-bottom::before {
  content: "\\f10a9";
}

.mdi-dock-left::before {
  content: "\\f10aa";
}

.mdi-dock-right::before {
  content: "\\f10ab";
}

.mdi-dock-top::before {
  content: "\\f1513";
}

.mdi-dock-window::before {
  content: "\\f10ac";
}

.mdi-docker::before {
  content: "\\f0868";
}

.mdi-doctor::before {
  content: "\\f0a42";
}

.mdi-dog::before {
  content: "\\f0a43";
}

.mdi-dog-service::before {
  content: "\\f0aad";
}

.mdi-dog-side::before {
  content: "\\f0a44";
}

.mdi-dog-side-off::before {
  content: "\\f16ee";
}

.mdi-dolby::before {
  content: "\\f06b3";
}

.mdi-dolly::before {
  content: "\\f0e9e";
}

.mdi-dolphin::before {
  content: "\\f18b4";
}

.mdi-domain::before {
  content: "\\f01d7";
}

.mdi-domain-off::before {
  content: "\\f0d6f";
}

.mdi-domain-plus::before {
  content: "\\f10ad";
}

.mdi-domain-remove::before {
  content: "\\f10ae";
}

.mdi-dome-light::before {
  content: "\\f141e";
}

.mdi-domino-mask::before {
  content: "\\f1023";
}

.mdi-donkey::before {
  content: "\\f07c2";
}

.mdi-door::before {
  content: "\\f081a";
}

.mdi-door-closed::before {
  content: "\\f081b";
}

.mdi-door-closed-lock::before {
  content: "\\f10af";
}

.mdi-door-open::before {
  content: "\\f081c";
}

.mdi-door-sliding::before {
  content: "\\f181e";
}

.mdi-door-sliding-lock::before {
  content: "\\f181f";
}

.mdi-door-sliding-open::before {
  content: "\\f1820";
}

.mdi-doorbell::before {
  content: "\\f12e6";
}

.mdi-doorbell-video::before {
  content: "\\f0869";
}

.mdi-dot-net::before {
  content: "\\f0aae";
}

.mdi-dots-circle::before {
  content: "\\f1978";
}

.mdi-dots-grid::before {
  content: "\\f15fc";
}

.mdi-dots-hexagon::before {
  content: "\\f15ff";
}

.mdi-dots-horizontal::before {
  content: "\\f01d8";
}

.mdi-dots-horizontal-circle::before {
  content: "\\f07c3";
}

.mdi-dots-horizontal-circle-outline::before {
  content: "\\f0b8d";
}

.mdi-dots-square::before {
  content: "\\f15fd";
}

.mdi-dots-triangle::before {
  content: "\\f15fe";
}

.mdi-dots-vertical::before {
  content: "\\f01d9";
}

.mdi-dots-vertical-circle::before {
  content: "\\f07c4";
}

.mdi-dots-vertical-circle-outline::before {
  content: "\\f0b8e";
}

.mdi-download::before {
  content: "\\f01da";
}

.mdi-download-box::before {
  content: "\\f1462";
}

.mdi-download-box-outline::before {
  content: "\\f1463";
}

.mdi-download-circle::before {
  content: "\\f1464";
}

.mdi-download-circle-outline::before {
  content: "\\f1465";
}

.mdi-download-lock::before {
  content: "\\f1320";
}

.mdi-download-lock-outline::before {
  content: "\\f1321";
}

.mdi-download-multiple::before {
  content: "\\f09e9";
}

.mdi-download-network::before {
  content: "\\f06f4";
}

.mdi-download-network-outline::before {
  content: "\\f0c66";
}

.mdi-download-off::before {
  content: "\\f10b0";
}

.mdi-download-off-outline::before {
  content: "\\f10b1";
}

.mdi-download-outline::before {
  content: "\\f0b8f";
}

.mdi-drag::before {
  content: "\\f01db";
}

.mdi-drag-horizontal::before {
  content: "\\f01dc";
}

.mdi-drag-horizontal-variant::before {
  content: "\\f12f0";
}

.mdi-drag-variant::before {
  content: "\\f0b90";
}

.mdi-drag-vertical::before {
  content: "\\f01dd";
}

.mdi-drag-vertical-variant::before {
  content: "\\f12f1";
}

.mdi-drama-masks::before {
  content: "\\f0d02";
}

.mdi-draw::before {
  content: "\\f0f49";
}

.mdi-draw-pen::before {
  content: "\\f19b9";
}

.mdi-drawing::before {
  content: "\\f01de";
}

.mdi-drawing-box::before {
  content: "\\f01df";
}

.mdi-dresser::before {
  content: "\\f0f4a";
}

.mdi-dresser-outline::before {
  content: "\\f0f4b";
}

.mdi-drone::before {
  content: "\\f01e2";
}

.mdi-dropbox::before {
  content: "\\f01e3";
}

.mdi-drupal::before {
  content: "\\f01e4";
}

.mdi-duck::before {
  content: "\\f01e5";
}

.mdi-dumbbell::before {
  content: "\\f01e6";
}

.mdi-dump-truck::before {
  content: "\\f0c67";
}

.mdi-ear-hearing::before {
  content: "\\f07c5";
}

.mdi-ear-hearing-off::before {
  content: "\\f0a45";
}

.mdi-earbuds::before {
  content: "\\f184f";
}

.mdi-earbuds-off::before {
  content: "\\f1850";
}

.mdi-earbuds-off-outline::before {
  content: "\\f1851";
}

.mdi-earbuds-outline::before {
  content: "\\f1852";
}

.mdi-earth::before {
  content: "\\f01e7";
}

.mdi-earth-arrow-right::before {
  content: "\\f1311";
}

.mdi-earth-box::before {
  content: "\\f06cd";
}

.mdi-earth-box-minus::before {
  content: "\\f1407";
}

.mdi-earth-box-off::before {
  content: "\\f06ce";
}

.mdi-earth-box-plus::before {
  content: "\\f1406";
}

.mdi-earth-box-remove::before {
  content: "\\f1408";
}

.mdi-earth-minus::before {
  content: "\\f1404";
}

.mdi-earth-off::before {
  content: "\\f01e8";
}

.mdi-earth-plus::before {
  content: "\\f1403";
}

.mdi-earth-remove::before {
  content: "\\f1405";
}

.mdi-egg::before {
  content: "\\f0aaf";
}

.mdi-egg-easter::before {
  content: "\\f0ab0";
}

.mdi-egg-fried::before {
  content: "\\f184a";
}

.mdi-egg-off::before {
  content: "\\f13f0";
}

.mdi-egg-off-outline::before {
  content: "\\f13f1";
}

.mdi-egg-outline::before {
  content: "\\f13f2";
}

.mdi-eiffel-tower::before {
  content: "\\f156b";
}

.mdi-eight-track::before {
  content: "\\f09ea";
}

.mdi-eject::before {
  content: "\\f01ea";
}

.mdi-eject-outline::before {
  content: "\\f0b91";
}

.mdi-electric-switch::before {
  content: "\\f0e9f";
}

.mdi-electric-switch-closed::before {
  content: "\\f10d9";
}

.mdi-electron-framework::before {
  content: "\\f1024";
}

.mdi-elephant::before {
  content: "\\f07c6";
}

.mdi-elevation-decline::before {
  content: "\\f01eb";
}

.mdi-elevation-rise::before {
  content: "\\f01ec";
}

.mdi-elevator::before {
  content: "\\f01ed";
}

.mdi-elevator-down::before {
  content: "\\f12c2";
}

.mdi-elevator-passenger::before {
  content: "\\f1381";
}

.mdi-elevator-passenger-off::before {
  content: "\\f1979";
}

.mdi-elevator-passenger-off-outline::before {
  content: "\\f197a";
}

.mdi-elevator-passenger-outline::before {
  content: "\\f197b";
}

.mdi-elevator-up::before {
  content: "\\f12c1";
}

.mdi-ellipse::before {
  content: "\\f0ea0";
}

.mdi-ellipse-outline::before {
  content: "\\f0ea1";
}

.mdi-email::before {
  content: "\\f01ee";
}

.mdi-email-alert::before {
  content: "\\f06cf";
}

.mdi-email-alert-outline::before {
  content: "\\f0d42";
}

.mdi-email-box::before {
  content: "\\f0d03";
}

.mdi-email-check::before {
  content: "\\f0ab1";
}

.mdi-email-check-outline::before {
  content: "\\f0ab2";
}

.mdi-email-edit::before {
  content: "\\f0ee3";
}

.mdi-email-edit-outline::before {
  content: "\\f0ee4";
}

.mdi-email-fast::before {
  content: "\\f186f";
}

.mdi-email-fast-outline::before {
  content: "\\f1870";
}

.mdi-email-lock::before {
  content: "\\f01f1";
}

.mdi-email-mark-as-unread::before {
  content: "\\f0b92";
}

.mdi-email-minus::before {
  content: "\\f0ee5";
}

.mdi-email-minus-outline::before {
  content: "\\f0ee6";
}

.mdi-email-multiple::before {
  content: "\\f0ee7";
}

.mdi-email-multiple-outline::before {
  content: "\\f0ee8";
}

.mdi-email-newsletter::before {
  content: "\\f0fb1";
}

.mdi-email-off::before {
  content: "\\f13e3";
}

.mdi-email-off-outline::before {
  content: "\\f13e4";
}

.mdi-email-open::before {
  content: "\\f01ef";
}

.mdi-email-open-multiple::before {
  content: "\\f0ee9";
}

.mdi-email-open-multiple-outline::before {
  content: "\\f0eea";
}

.mdi-email-open-outline::before {
  content: "\\f05ef";
}

.mdi-email-outline::before {
  content: "\\f01f0";
}

.mdi-email-plus::before {
  content: "\\f09eb";
}

.mdi-email-plus-outline::before {
  content: "\\f09ec";
}

.mdi-email-receive::before {
  content: "\\f10da";
}

.mdi-email-receive-outline::before {
  content: "\\f10db";
}

.mdi-email-remove::before {
  content: "\\f1661";
}

.mdi-email-remove-outline::before {
  content: "\\f1662";
}

.mdi-email-seal::before {
  content: "\\f195b";
}

.mdi-email-seal-outline::before {
  content: "\\f195c";
}

.mdi-email-search::before {
  content: "\\f0961";
}

.mdi-email-search-outline::before {
  content: "\\f0962";
}

.mdi-email-send::before {
  content: "\\f10dc";
}

.mdi-email-send-outline::before {
  content: "\\f10dd";
}

.mdi-email-sync::before {
  content: "\\f12c7";
}

.mdi-email-sync-outline::before {
  content: "\\f12c8";
}

.mdi-email-variant::before {
  content: "\\f05f0";
}

.mdi-ember::before {
  content: "\\f0b30";
}

.mdi-emby::before {
  content: "\\f06b4";
}

.mdi-emoticon::before {
  content: "\\f0c68";
}

.mdi-emoticon-angry::before {
  content: "\\f0c69";
}

.mdi-emoticon-angry-outline::before {
  content: "\\f0c6a";
}

.mdi-emoticon-confused::before {
  content: "\\f10de";
}

.mdi-emoticon-confused-outline::before {
  content: "\\f10df";
}

.mdi-emoticon-cool::before {
  content: "\\f0c6b";
}

.mdi-emoticon-cool-outline::before {
  content: "\\f01f3";
}

.mdi-emoticon-cry::before {
  content: "\\f0c6c";
}

.mdi-emoticon-cry-outline::before {
  content: "\\f0c6d";
}

.mdi-emoticon-dead::before {
  content: "\\f0c6e";
}

.mdi-emoticon-dead-outline::before {
  content: "\\f069b";
}

.mdi-emoticon-devil::before {
  content: "\\f0c6f";
}

.mdi-emoticon-devil-outline::before {
  content: "\\f01f4";
}

.mdi-emoticon-excited::before {
  content: "\\f0c70";
}

.mdi-emoticon-excited-outline::before {
  content: "\\f069c";
}

.mdi-emoticon-frown::before {
  content: "\\f0f4c";
}

.mdi-emoticon-frown-outline::before {
  content: "\\f0f4d";
}

.mdi-emoticon-happy::before {
  content: "\\f0c71";
}

.mdi-emoticon-happy-outline::before {
  content: "\\f01f5";
}

.mdi-emoticon-kiss::before {
  content: "\\f0c72";
}

.mdi-emoticon-kiss-outline::before {
  content: "\\f0c73";
}

.mdi-emoticon-lol::before {
  content: "\\f1214";
}

.mdi-emoticon-lol-outline::before {
  content: "\\f1215";
}

.mdi-emoticon-neutral::before {
  content: "\\f0c74";
}

.mdi-emoticon-neutral-outline::before {
  content: "\\f01f6";
}

.mdi-emoticon-outline::before {
  content: "\\f01f2";
}

.mdi-emoticon-poop::before {
  content: "\\f01f7";
}

.mdi-emoticon-poop-outline::before {
  content: "\\f0c75";
}

.mdi-emoticon-sad::before {
  content: "\\f0c76";
}

.mdi-emoticon-sad-outline::before {
  content: "\\f01f8";
}

.mdi-emoticon-sick::before {
  content: "\\f157c";
}

.mdi-emoticon-sick-outline::before {
  content: "\\f157d";
}

.mdi-emoticon-tongue::before {
  content: "\\f01f9";
}

.mdi-emoticon-tongue-outline::before {
  content: "\\f0c77";
}

.mdi-emoticon-wink::before {
  content: "\\f0c78";
}

.mdi-emoticon-wink-outline::before {
  content: "\\f0c79";
}

.mdi-engine::before {
  content: "\\f01fa";
}

.mdi-engine-off::before {
  content: "\\f0a46";
}

.mdi-engine-off-outline::before {
  content: "\\f0a47";
}

.mdi-engine-outline::before {
  content: "\\f01fb";
}

.mdi-epsilon::before {
  content: "\\f10e0";
}

.mdi-equal::before {
  content: "\\f01fc";
}

.mdi-equal-box::before {
  content: "\\f01fd";
}

.mdi-equalizer::before {
  content: "\\f0ea2";
}

.mdi-equalizer-outline::before {
  content: "\\f0ea3";
}

.mdi-eraser::before {
  content: "\\f01fe";
}

.mdi-eraser-variant::before {
  content: "\\f0642";
}

.mdi-escalator::before {
  content: "\\f01ff";
}

.mdi-escalator-box::before {
  content: "\\f1399";
}

.mdi-escalator-down::before {
  content: "\\f12c0";
}

.mdi-escalator-up::before {
  content: "\\f12bf";
}

.mdi-eslint::before {
  content: "\\f0c7a";
}

.mdi-et::before {
  content: "\\f0ab3";
}

.mdi-ethereum::before {
  content: "\\f086a";
}

.mdi-ethernet::before {
  content: "\\f0200";
}

.mdi-ethernet-cable::before {
  content: "\\f0201";
}

.mdi-ethernet-cable-off::before {
  content: "\\f0202";
}

.mdi-ev-plug-ccs1::before {
  content: "\\f1519";
}

.mdi-ev-plug-ccs2::before {
  content: "\\f151a";
}

.mdi-ev-plug-chademo::before {
  content: "\\f151b";
}

.mdi-ev-plug-tesla::before {
  content: "\\f151c";
}

.mdi-ev-plug-type1::before {
  content: "\\f151d";
}

.mdi-ev-plug-type2::before {
  content: "\\f151e";
}

.mdi-ev-station::before {
  content: "\\f05f1";
}

.mdi-evernote::before {
  content: "\\f0204";
}

.mdi-excavator::before {
  content: "\\f1025";
}

.mdi-exclamation::before {
  content: "\\f0205";
}

.mdi-exclamation-thick::before {
  content: "\\f1238";
}

.mdi-exit-run::before {
  content: "\\f0a48";
}

.mdi-exit-to-app::before {
  content: "\\f0206";
}

.mdi-expand-all::before {
  content: "\\f0ab4";
}

.mdi-expand-all-outline::before {
  content: "\\f0ab5";
}

.mdi-expansion-card::before {
  content: "\\f08ae";
}

.mdi-expansion-card-variant::before {
  content: "\\f0fb2";
}

.mdi-exponent::before {
  content: "\\f0963";
}

.mdi-exponent-box::before {
  content: "\\f0964";
}

.mdi-export::before {
  content: "\\f0207";
}

.mdi-export-variant::before {
  content: "\\f0b93";
}

.mdi-eye::before {
  content: "\\f0208";
}

.mdi-eye-arrow-left::before {
  content: "\\f18fd";
}

.mdi-eye-arrow-left-outline::before {
  content: "\\f18fe";
}

.mdi-eye-arrow-right::before {
  content: "\\f18ff";
}

.mdi-eye-arrow-right-outline::before {
  content: "\\f1900";
}

.mdi-eye-check::before {
  content: "\\f0d04";
}

.mdi-eye-check-outline::before {
  content: "\\f0d05";
}

.mdi-eye-circle::before {
  content: "\\f0b94";
}

.mdi-eye-circle-outline::before {
  content: "\\f0b95";
}

.mdi-eye-minus::before {
  content: "\\f1026";
}

.mdi-eye-minus-outline::before {
  content: "\\f1027";
}

.mdi-eye-off::before {
  content: "\\f0209";
}

.mdi-eye-off-outline::before {
  content: "\\f06d1";
}

.mdi-eye-outline::before {
  content: "\\f06d0";
}

.mdi-eye-plus::before {
  content: "\\f086b";
}

.mdi-eye-plus-outline::before {
  content: "\\f086c";
}

.mdi-eye-refresh::before {
  content: "\\f197c";
}

.mdi-eye-refresh-outline::before {
  content: "\\f197d";
}

.mdi-eye-remove::before {
  content: "\\f15e3";
}

.mdi-eye-remove-outline::before {
  content: "\\f15e4";
}

.mdi-eye-settings::before {
  content: "\\f086d";
}

.mdi-eye-settings-outline::before {
  content: "\\f086e";
}

.mdi-eyedropper::before {
  content: "\\f020a";
}

.mdi-eyedropper-minus::before {
  content: "\\f13dd";
}

.mdi-eyedropper-off::before {
  content: "\\f13df";
}

.mdi-eyedropper-plus::before {
  content: "\\f13dc";
}

.mdi-eyedropper-remove::before {
  content: "\\f13de";
}

.mdi-eyedropper-variant::before {
  content: "\\f020b";
}

.mdi-face-agent::before {
  content: "\\f0d70";
}

.mdi-face-man::before {
  content: "\\f0643";
}

.mdi-face-man-outline::before {
  content: "\\f0b96";
}

.mdi-face-man-profile::before {
  content: "\\f0644";
}

.mdi-face-man-shimmer::before {
  content: "\\f15cc";
}

.mdi-face-man-shimmer-outline::before {
  content: "\\f15cd";
}

.mdi-face-mask::before {
  content: "\\f1586";
}

.mdi-face-mask-outline::before {
  content: "\\f1587";
}

.mdi-face-recognition::before {
  content: "\\f0c7b";
}

.mdi-face-woman::before {
  content: "\\f1077";
}

.mdi-face-woman-outline::before {
  content: "\\f1078";
}

.mdi-face-woman-profile::before {
  content: "\\f1076";
}

.mdi-face-woman-shimmer::before {
  content: "\\f15ce";
}

.mdi-face-woman-shimmer-outline::before {
  content: "\\f15cf";
}

.mdi-facebook::before {
  content: "\\f020c";
}

.mdi-facebook-gaming::before {
  content: "\\f07dd";
}

.mdi-facebook-messenger::before {
  content: "\\f020e";
}

.mdi-facebook-workplace::before {
  content: "\\f0b31";
}

.mdi-factory::before {
  content: "\\f020f";
}

.mdi-family-tree::before {
  content: "\\f160e";
}

.mdi-fan::before {
  content: "\\f0210";
}

.mdi-fan-alert::before {
  content: "\\f146c";
}

.mdi-fan-auto::before {
  content: "\\f171d";
}

.mdi-fan-chevron-down::before {
  content: "\\f146d";
}

.mdi-fan-chevron-up::before {
  content: "\\f146e";
}

.mdi-fan-minus::before {
  content: "\\f1470";
}

.mdi-fan-off::before {
  content: "\\f081d";
}

.mdi-fan-plus::before {
  content: "\\f146f";
}

.mdi-fan-remove::before {
  content: "\\f1471";
}

.mdi-fan-speed-1::before {
  content: "\\f1472";
}

.mdi-fan-speed-2::before {
  content: "\\f1473";
}

.mdi-fan-speed-3::before {
  content: "\\f1474";
}

.mdi-fast-forward::before {
  content: "\\f0211";
}

.mdi-fast-forward-10::before {
  content: "\\f0d71";
}

.mdi-fast-forward-15::before {
  content: "\\f193a";
}

.mdi-fast-forward-30::before {
  content: "\\f0d06";
}

.mdi-fast-forward-5::before {
  content: "\\f11f8";
}

.mdi-fast-forward-60::before {
  content: "\\f160b";
}

.mdi-fast-forward-outline::before {
  content: "\\f06d2";
}

.mdi-fax::before {
  content: "\\f0212";
}

.mdi-feather::before {
  content: "\\f06d3";
}

.mdi-feature-search::before {
  content: "\\f0a49";
}

.mdi-feature-search-outline::before {
  content: "\\f0a4a";
}

.mdi-fedora::before {
  content: "\\f08db";
}

.mdi-fence::before {
  content: "\\f179a";
}

.mdi-fence-electric::before {
  content: "\\f17f6";
}

.mdi-fencing::before {
  content: "\\f14c1";
}

.mdi-ferris-wheel::before {
  content: "\\f0ea4";
}

.mdi-ferry::before {
  content: "\\f0213";
}

.mdi-file::before {
  content: "\\f0214";
}

.mdi-file-account::before {
  content: "\\f073b";
}

.mdi-file-account-outline::before {
  content: "\\f1028";
}

.mdi-file-alert::before {
  content: "\\f0a4b";
}

.mdi-file-alert-outline::before {
  content: "\\f0a4c";
}

.mdi-file-cabinet::before {
  content: "\\f0ab6";
}

.mdi-file-cad::before {
  content: "\\f0eeb";
}

.mdi-file-cad-box::before {
  content: "\\f0eec";
}

.mdi-file-cancel::before {
  content: "\\f0dc6";
}

.mdi-file-cancel-outline::before {
  content: "\\f0dc7";
}

.mdi-file-certificate::before {
  content: "\\f1186";
}

.mdi-file-certificate-outline::before {
  content: "\\f1187";
}

.mdi-file-chart::before {
  content: "\\f0215";
}

.mdi-file-chart-outline::before {
  content: "\\f1029";
}

.mdi-file-check::before {
  content: "\\f0216";
}

.mdi-file-check-outline::before {
  content: "\\f0e29";
}

.mdi-file-clock::before {
  content: "\\f12e1";
}

.mdi-file-clock-outline::before {
  content: "\\f12e2";
}

.mdi-file-cloud::before {
  content: "\\f0217";
}

.mdi-file-cloud-outline::before {
  content: "\\f102a";
}

.mdi-file-code::before {
  content: "\\f022e";
}

.mdi-file-code-outline::before {
  content: "\\f102b";
}

.mdi-file-cog::before {
  content: "\\f107b";
}

.mdi-file-cog-outline::before {
  content: "\\f107c";
}

.mdi-file-compare::before {
  content: "\\f08aa";
}

.mdi-file-delimited::before {
  content: "\\f0218";
}

.mdi-file-delimited-outline::before {
  content: "\\f0ea5";
}

.mdi-file-document::before {
  content: "\\f0219";
}

.mdi-file-document-edit::before {
  content: "\\f0dc8";
}

.mdi-file-document-edit-outline::before {
  content: "\\f0dc9";
}

.mdi-file-document-multiple::before {
  content: "\\f1517";
}

.mdi-file-document-multiple-outline::before {
  content: "\\f1518";
}

.mdi-file-document-outline::before {
  content: "\\f09ee";
}

.mdi-file-download::before {
  content: "\\f0965";
}

.mdi-file-download-outline::before {
  content: "\\f0966";
}

.mdi-file-edit::before {
  content: "\\f11e7";
}

.mdi-file-edit-outline::before {
  content: "\\f11e8";
}

.mdi-file-excel::before {
  content: "\\f021b";
}

.mdi-file-excel-box::before {
  content: "\\f021c";
}

.mdi-file-excel-box-outline::before {
  content: "\\f102c";
}

.mdi-file-excel-outline::before {
  content: "\\f102d";
}

.mdi-file-export::before {
  content: "\\f021d";
}

.mdi-file-export-outline::before {
  content: "\\f102e";
}

.mdi-file-eye::before {
  content: "\\f0dca";
}

.mdi-file-eye-outline::before {
  content: "\\f0dcb";
}

.mdi-file-find::before {
  content: "\\f021e";
}

.mdi-file-find-outline::before {
  content: "\\f0b97";
}

.mdi-file-gif-box::before {
  content: "\\f0d78";
}

.mdi-file-hidden::before {
  content: "\\f0613";
}

.mdi-file-image::before {
  content: "\\f021f";
}

.mdi-file-image-marker::before {
  content: "\\f1772";
}

.mdi-file-image-marker-outline::before {
  content: "\\f1773";
}

.mdi-file-image-minus::before {
  content: "\\f193b";
}

.mdi-file-image-minus-outline::before {
  content: "\\f193c";
}

.mdi-file-image-outline::before {
  content: "\\f0eb0";
}

.mdi-file-image-plus::before {
  content: "\\f193d";
}

.mdi-file-image-plus-outline::before {
  content: "\\f193e";
}

.mdi-file-image-remove::before {
  content: "\\f193f";
}

.mdi-file-image-remove-outline::before {
  content: "\\f1940";
}

.mdi-file-import::before {
  content: "\\f0220";
}

.mdi-file-import-outline::before {
  content: "\\f102f";
}

.mdi-file-jpg-box::before {
  content: "\\f0225";
}

.mdi-file-key::before {
  content: "\\f1184";
}

.mdi-file-key-outline::before {
  content: "\\f1185";
}

.mdi-file-link::before {
  content: "\\f1177";
}

.mdi-file-link-outline::before {
  content: "\\f1178";
}

.mdi-file-lock::before {
  content: "\\f0221";
}

.mdi-file-lock-outline::before {
  content: "\\f1030";
}

.mdi-file-marker::before {
  content: "\\f1774";
}

.mdi-file-marker-outline::before {
  content: "\\f1775";
}

.mdi-file-move::before {
  content: "\\f0ab9";
}

.mdi-file-move-outline::before {
  content: "\\f1031";
}

.mdi-file-multiple::before {
  content: "\\f0222";
}

.mdi-file-multiple-outline::before {
  content: "\\f1032";
}

.mdi-file-music::before {
  content: "\\f0223";
}

.mdi-file-music-outline::before {
  content: "\\f0e2a";
}

.mdi-file-outline::before {
  content: "\\f0224";
}

.mdi-file-pdf-box::before {
  content: "\\f0226";
}

.mdi-file-percent::before {
  content: "\\f081e";
}

.mdi-file-percent-outline::before {
  content: "\\f1033";
}

.mdi-file-phone::before {
  content: "\\f1179";
}

.mdi-file-phone-outline::before {
  content: "\\f117a";
}

.mdi-file-plus::before {
  content: "\\f0752";
}

.mdi-file-plus-outline::before {
  content: "\\f0eed";
}

.mdi-file-png-box::before {
  content: "\\f0e2d";
}

.mdi-file-powerpoint::before {
  content: "\\f0227";
}

.mdi-file-powerpoint-box::before {
  content: "\\f0228";
}

.mdi-file-powerpoint-box-outline::before {
  content: "\\f1034";
}

.mdi-file-powerpoint-outline::before {
  content: "\\f1035";
}

.mdi-file-presentation-box::before {
  content: "\\f0229";
}

.mdi-file-question::before {
  content: "\\f086f";
}

.mdi-file-question-outline::before {
  content: "\\f1036";
}

.mdi-file-refresh::before {
  content: "\\f0918";
}

.mdi-file-refresh-outline::before {
  content: "\\f0541";
}

.mdi-file-remove::before {
  content: "\\f0b98";
}

.mdi-file-remove-outline::before {
  content: "\\f1037";
}

.mdi-file-replace::before {
  content: "\\f0b32";
}

.mdi-file-replace-outline::before {
  content: "\\f0b33";
}

.mdi-file-restore::before {
  content: "\\f0670";
}

.mdi-file-restore-outline::before {
  content: "\\f1038";
}

.mdi-file-search::before {
  content: "\\f0c7c";
}

.mdi-file-search-outline::before {
  content: "\\f0c7d";
}

.mdi-file-send::before {
  content: "\\f022a";
}

.mdi-file-send-outline::before {
  content: "\\f1039";
}

.mdi-file-settings::before {
  content: "\\f1079";
}

.mdi-file-settings-outline::before {
  content: "\\f107a";
}

.mdi-file-sign::before {
  content: "\\f19c3";
}

.mdi-file-star::before {
  content: "\\f103a";
}

.mdi-file-star-outline::before {
  content: "\\f103b";
}

.mdi-file-swap::before {
  content: "\\f0fb4";
}

.mdi-file-swap-outline::before {
  content: "\\f0fb5";
}

.mdi-file-sync::before {
  content: "\\f1216";
}

.mdi-file-sync-outline::before {
  content: "\\f1217";
}

.mdi-file-table::before {
  content: "\\f0c7e";
}

.mdi-file-table-box::before {
  content: "\\f10e1";
}

.mdi-file-table-box-multiple::before {
  content: "\\f10e2";
}

.mdi-file-table-box-multiple-outline::before {
  content: "\\f10e3";
}

.mdi-file-table-box-outline::before {
  content: "\\f10e4";
}

.mdi-file-table-outline::before {
  content: "\\f0c7f";
}

.mdi-file-tree::before {
  content: "\\f0645";
}

.mdi-file-tree-outline::before {
  content: "\\f13d2";
}

.mdi-file-undo::before {
  content: "\\f08dc";
}

.mdi-file-undo-outline::before {
  content: "\\f103c";
}

.mdi-file-upload::before {
  content: "\\f0a4d";
}

.mdi-file-upload-outline::before {
  content: "\\f0a4e";
}

.mdi-file-video::before {
  content: "\\f022b";
}

.mdi-file-video-outline::before {
  content: "\\f0e2c";
}

.mdi-file-word::before {
  content: "\\f022c";
}

.mdi-file-word-box::before {
  content: "\\f022d";
}

.mdi-file-word-box-outline::before {
  content: "\\f103d";
}

.mdi-file-word-outline::before {
  content: "\\f103e";
}

.mdi-film::before {
  content: "\\f022f";
}

.mdi-filmstrip::before {
  content: "\\f0230";
}

.mdi-filmstrip-box::before {
  content: "\\f0332";
}

.mdi-filmstrip-box-multiple::before {
  content: "\\f0d18";
}

.mdi-filmstrip-off::before {
  content: "\\f0231";
}

.mdi-filter::before {
  content: "\\f0232";
}

.mdi-filter-check::before {
  content: "\\f18ec";
}

.mdi-filter-check-outline::before {
  content: "\\f18ed";
}

.mdi-filter-menu::before {
  content: "\\f10e5";
}

.mdi-filter-menu-outline::before {
  content: "\\f10e6";
}

.mdi-filter-minus::before {
  content: "\\f0eee";
}

.mdi-filter-minus-outline::before {
  content: "\\f0eef";
}

.mdi-filter-off::before {
  content: "\\f14ef";
}

.mdi-filter-off-outline::before {
  content: "\\f14f0";
}

.mdi-filter-outline::before {
  content: "\\f0233";
}

.mdi-filter-plus::before {
  content: "\\f0ef0";
}

.mdi-filter-plus-outline::before {
  content: "\\f0ef1";
}

.mdi-filter-remove::before {
  content: "\\f0234";
}

.mdi-filter-remove-outline::before {
  content: "\\f0235";
}

.mdi-filter-variant::before {
  content: "\\f0236";
}

.mdi-filter-variant-minus::before {
  content: "\\f1112";
}

.mdi-filter-variant-plus::before {
  content: "\\f1113";
}

.mdi-filter-variant-remove::before {
  content: "\\f103f";
}

.mdi-finance::before {
  content: "\\f081f";
}

.mdi-find-replace::before {
  content: "\\f06d4";
}

.mdi-fingerprint::before {
  content: "\\f0237";
}

.mdi-fingerprint-off::before {
  content: "\\f0eb1";
}

.mdi-fire::before {
  content: "\\f0238";
}

.mdi-fire-alert::before {
  content: "\\f15d7";
}

.mdi-fire-circle::before {
  content: "\\f1807";
}

.mdi-fire-extinguisher::before {
  content: "\\f0ef2";
}

.mdi-fire-hydrant::before {
  content: "\\f1137";
}

.mdi-fire-hydrant-alert::before {
  content: "\\f1138";
}

.mdi-fire-hydrant-off::before {
  content: "\\f1139";
}

.mdi-fire-off::before {
  content: "\\f1722";
}

.mdi-fire-truck::before {
  content: "\\f08ab";
}

.mdi-firebase::before {
  content: "\\f0967";
}

.mdi-firefox::before {
  content: "\\f0239";
}

.mdi-fireplace::before {
  content: "\\f0e2e";
}

.mdi-fireplace-off::before {
  content: "\\f0e2f";
}

.mdi-firewire::before {
  content: "\\f05be";
}

.mdi-firework::before {
  content: "\\f0e30";
}

.mdi-firework-off::before {
  content: "\\f1723";
}

.mdi-fish::before {
  content: "\\f023a";
}

.mdi-fish-off::before {
  content: "\\f13f3";
}

.mdi-fishbowl::before {
  content: "\\f0ef3";
}

.mdi-fishbowl-outline::before {
  content: "\\f0ef4";
}

.mdi-fit-to-page::before {
  content: "\\f0ef5";
}

.mdi-fit-to-page-outline::before {
  content: "\\f0ef6";
}

.mdi-fit-to-screen::before {
  content: "\\f18f4";
}

.mdi-fit-to-screen-outline::before {
  content: "\\f18f5";
}

.mdi-flag::before {
  content: "\\f023b";
}

.mdi-flag-checkered::before {
  content: "\\f023c";
}

.mdi-flag-minus::before {
  content: "\\f0b99";
}

.mdi-flag-minus-outline::before {
  content: "\\f10b2";
}

.mdi-flag-off::before {
  content: "\\f18ee";
}

.mdi-flag-off-outline::before {
  content: "\\f18ef";
}

.mdi-flag-outline::before {
  content: "\\f023d";
}

.mdi-flag-plus::before {
  content: "\\f0b9a";
}

.mdi-flag-plus-outline::before {
  content: "\\f10b3";
}

.mdi-flag-remove::before {
  content: "\\f0b9b";
}

.mdi-flag-remove-outline::before {
  content: "\\f10b4";
}

.mdi-flag-triangle::before {
  content: "\\f023f";
}

.mdi-flag-variant::before {
  content: "\\f0240";
}

.mdi-flag-variant-outline::before {
  content: "\\f023e";
}

.mdi-flare::before {
  content: "\\f0d72";
}

.mdi-flash::before {
  content: "\\f0241";
}

.mdi-flash-alert::before {
  content: "\\f0ef7";
}

.mdi-flash-alert-outline::before {
  content: "\\f0ef8";
}

.mdi-flash-auto::before {
  content: "\\f0242";
}

.mdi-flash-off::before {
  content: "\\f0243";
}

.mdi-flash-outline::before {
  content: "\\f06d5";
}

.mdi-flash-red-eye::before {
  content: "\\f067b";
}

.mdi-flashlight::before {
  content: "\\f0244";
}

.mdi-flashlight-off::before {
  content: "\\f0245";
}

.mdi-flask::before {
  content: "\\f0093";
}

.mdi-flask-empty::before {
  content: "\\f0094";
}

.mdi-flask-empty-minus::before {
  content: "\\f123a";
}

.mdi-flask-empty-minus-outline::before {
  content: "\\f123b";
}

.mdi-flask-empty-off::before {
  content: "\\f13f4";
}

.mdi-flask-empty-off-outline::before {
  content: "\\f13f5";
}

.mdi-flask-empty-outline::before {
  content: "\\f0095";
}

.mdi-flask-empty-plus::before {
  content: "\\f123c";
}

.mdi-flask-empty-plus-outline::before {
  content: "\\f123d";
}

.mdi-flask-empty-remove::before {
  content: "\\f123e";
}

.mdi-flask-empty-remove-outline::before {
  content: "\\f123f";
}

.mdi-flask-minus::before {
  content: "\\f1240";
}

.mdi-flask-minus-outline::before {
  content: "\\f1241";
}

.mdi-flask-off::before {
  content: "\\f13f6";
}

.mdi-flask-off-outline::before {
  content: "\\f13f7";
}

.mdi-flask-outline::before {
  content: "\\f0096";
}

.mdi-flask-plus::before {
  content: "\\f1242";
}

.mdi-flask-plus-outline::before {
  content: "\\f1243";
}

.mdi-flask-remove::before {
  content: "\\f1244";
}

.mdi-flask-remove-outline::before {
  content: "\\f1245";
}

.mdi-flask-round-bottom::before {
  content: "\\f124b";
}

.mdi-flask-round-bottom-empty::before {
  content: "\\f124c";
}

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\f124d";
}

.mdi-flask-round-bottom-outline::before {
  content: "\\f124e";
}

.mdi-fleur-de-lis::before {
  content: "\\f1303";
}

.mdi-flip-horizontal::before {
  content: "\\f10e7";
}

.mdi-flip-to-back::before {
  content: "\\f0247";
}

.mdi-flip-to-front::before {
  content: "\\f0248";
}

.mdi-flip-vertical::before {
  content: "\\f10e8";
}

.mdi-floor-lamp::before {
  content: "\\f08dd";
}

.mdi-floor-lamp-dual::before {
  content: "\\f1040";
}

.mdi-floor-lamp-dual-outline::before {
  content: "\\f17ce";
}

.mdi-floor-lamp-outline::before {
  content: "\\f17c8";
}

.mdi-floor-lamp-torchiere::before {
  content: "\\f1747";
}

.mdi-floor-lamp-torchiere-outline::before {
  content: "\\f17d6";
}

.mdi-floor-lamp-torchiere-variant::before {
  content: "\\f1041";
}

.mdi-floor-lamp-torchiere-variant-outline::before {
  content: "\\f17cf";
}

.mdi-floor-plan::before {
  content: "\\f0821";
}

.mdi-floppy::before {
  content: "\\f0249";
}

.mdi-floppy-variant::before {
  content: "\\f09ef";
}

.mdi-flower::before {
  content: "\\f024a";
}

.mdi-flower-outline::before {
  content: "\\f09f0";
}

.mdi-flower-pollen::before {
  content: "\\f1885";
}

.mdi-flower-pollen-outline::before {
  content: "\\f1886";
}

.mdi-flower-poppy::before {
  content: "\\f0d08";
}

.mdi-flower-tulip::before {
  content: "\\f09f1";
}

.mdi-flower-tulip-outline::before {
  content: "\\f09f2";
}

.mdi-focus-auto::before {
  content: "\\f0f4e";
}

.mdi-focus-field::before {
  content: "\\f0f4f";
}

.mdi-focus-field-horizontal::before {
  content: "\\f0f50";
}

.mdi-focus-field-vertical::before {
  content: "\\f0f51";
}

.mdi-folder::before {
  content: "\\f024b";
}

.mdi-folder-account::before {
  content: "\\f024c";
}

.mdi-folder-account-outline::before {
  content: "\\f0b9c";
}

.mdi-folder-alert::before {
  content: "\\f0dcc";
}

.mdi-folder-alert-outline::before {
  content: "\\f0dcd";
}

.mdi-folder-check::before {
  content: "\\f197e";
}

.mdi-folder-check-outline::before {
  content: "\\f197f";
}

.mdi-folder-clock::before {
  content: "\\f0aba";
}

.mdi-folder-clock-outline::before {
  content: "\\f0abb";
}

.mdi-folder-cog::before {
  content: "\\f107f";
}

.mdi-folder-cog-outline::before {
  content: "\\f1080";
}

.mdi-folder-download::before {
  content: "\\f024d";
}

.mdi-folder-download-outline::before {
  content: "\\f10e9";
}

.mdi-folder-edit::before {
  content: "\\f08de";
}

.mdi-folder-edit-outline::before {
  content: "\\f0dce";
}

.mdi-folder-eye::before {
  content: "\\f178a";
}

.mdi-folder-eye-outline::before {
  content: "\\f178b";
}

.mdi-folder-google-drive::before {
  content: "\\f024e";
}

.mdi-folder-heart::before {
  content: "\\f10ea";
}

.mdi-folder-heart-outline::before {
  content: "\\f10eb";
}

.mdi-folder-hidden::before {
  content: "\\f179e";
}

.mdi-folder-home::before {
  content: "\\f10b5";
}

.mdi-folder-home-outline::before {
  content: "\\f10b6";
}

.mdi-folder-image::before {
  content: "\\f024f";
}

.mdi-folder-information::before {
  content: "\\f10b7";
}

.mdi-folder-information-outline::before {
  content: "\\f10b8";
}

.mdi-folder-key::before {
  content: "\\f08ac";
}

.mdi-folder-key-network::before {
  content: "\\f08ad";
}

.mdi-folder-key-network-outline::before {
  content: "\\f0c80";
}

.mdi-folder-key-outline::before {
  content: "\\f10ec";
}

.mdi-folder-lock::before {
  content: "\\f0250";
}

.mdi-folder-lock-open::before {
  content: "\\f0251";
}

.mdi-folder-marker::before {
  content: "\\f126d";
}

.mdi-folder-marker-outline::before {
  content: "\\f126e";
}

.mdi-folder-move::before {
  content: "\\f0252";
}

.mdi-folder-move-outline::before {
  content: "\\f1246";
}

.mdi-folder-multiple::before {
  content: "\\f0253";
}

.mdi-folder-multiple-image::before {
  content: "\\f0254";
}

.mdi-folder-multiple-outline::before {
  content: "\\f0255";
}

.mdi-folder-multiple-plus::before {
  content: "\\f147e";
}

.mdi-folder-multiple-plus-outline::before {
  content: "\\f147f";
}

.mdi-folder-music::before {
  content: "\\f1359";
}

.mdi-folder-music-outline::before {
  content: "\\f135a";
}

.mdi-folder-network::before {
  content: "\\f0870";
}

.mdi-folder-network-outline::before {
  content: "\\f0c81";
}

.mdi-folder-open::before {
  content: "\\f0770";
}

.mdi-folder-open-outline::before {
  content: "\\f0dcf";
}

.mdi-folder-outline::before {
  content: "\\f0256";
}

.mdi-folder-plus::before {
  content: "\\f0257";
}

.mdi-folder-plus-outline::before {
  content: "\\f0b9d";
}

.mdi-folder-pound::before {
  content: "\\f0d09";
}

.mdi-folder-pound-outline::before {
  content: "\\f0d0a";
}

.mdi-folder-refresh::before {
  content: "\\f0749";
}

.mdi-folder-refresh-outline::before {
  content: "\\f0542";
}

.mdi-folder-remove::before {
  content: "\\f0258";
}

.mdi-folder-remove-outline::before {
  content: "\\f0b9e";
}

.mdi-folder-search::before {
  content: "\\f0968";
}

.mdi-folder-search-outline::before {
  content: "\\f0969";
}

.mdi-folder-settings::before {
  content: "\\f107d";
}

.mdi-folder-settings-outline::before {
  content: "\\f107e";
}

.mdi-folder-star::before {
  content: "\\f069d";
}

.mdi-folder-star-multiple::before {
  content: "\\f13d3";
}

.mdi-folder-star-multiple-outline::before {
  content: "\\f13d4";
}

.mdi-folder-star-outline::before {
  content: "\\f0b9f";
}

.mdi-folder-swap::before {
  content: "\\f0fb6";
}

.mdi-folder-swap-outline::before {
  content: "\\f0fb7";
}

.mdi-folder-sync::before {
  content: "\\f0d0b";
}

.mdi-folder-sync-outline::before {
  content: "\\f0d0c";
}

.mdi-folder-table::before {
  content: "\\f12e3";
}

.mdi-folder-table-outline::before {
  content: "\\f12e4";
}

.mdi-folder-text::before {
  content: "\\f0c82";
}

.mdi-folder-text-outline::before {
  content: "\\f0c83";
}

.mdi-folder-upload::before {
  content: "\\f0259";
}

.mdi-folder-upload-outline::before {
  content: "\\f10ed";
}

.mdi-folder-zip::before {
  content: "\\f06eb";
}

.mdi-folder-zip-outline::before {
  content: "\\f07b9";
}

.mdi-font-awesome::before {
  content: "\\f003a";
}

.mdi-food::before {
  content: "\\f025a";
}

.mdi-food-apple::before {
  content: "\\f025b";
}

.mdi-food-apple-outline::before {
  content: "\\f0c84";
}

.mdi-food-croissant::before {
  content: "\\f07c8";
}

.mdi-food-drumstick::before {
  content: "\\f141f";
}

.mdi-food-drumstick-off::before {
  content: "\\f1468";
}

.mdi-food-drumstick-off-outline::before {
  content: "\\f1469";
}

.mdi-food-drumstick-outline::before {
  content: "\\f1420";
}

.mdi-food-fork-drink::before {
  content: "\\f05f2";
}

.mdi-food-halal::before {
  content: "\\f1572";
}

.mdi-food-hot-dog::before {
  content: "\\f184b";
}

.mdi-food-kosher::before {
  content: "\\f1573";
}

.mdi-food-off::before {
  content: "\\f05f3";
}

.mdi-food-off-outline::before {
  content: "\\f1915";
}

.mdi-food-outline::before {
  content: "\\f1916";
}

.mdi-food-steak::before {
  content: "\\f146a";
}

.mdi-food-steak-off::before {
  content: "\\f146b";
}

.mdi-food-takeout-box::before {
  content: "\\f1836";
}

.mdi-food-takeout-box-outline::before {
  content: "\\f1837";
}

.mdi-food-turkey::before {
  content: "\\f171c";
}

.mdi-food-variant::before {
  content: "\\f025c";
}

.mdi-food-variant-off::before {
  content: "\\f13e5";
}

.mdi-foot-print::before {
  content: "\\f0f52";
}

.mdi-football::before {
  content: "\\f025d";
}

.mdi-football-australian::before {
  content: "\\f025e";
}

.mdi-football-helmet::before {
  content: "\\f025f";
}

.mdi-forest::before {
  content: "\\f1897";
}

.mdi-forklift::before {
  content: "\\f07c9";
}

.mdi-form-dropdown::before {
  content: "\\f1400";
}

.mdi-form-select::before {
  content: "\\f1401";
}

.mdi-form-textarea::before {
  content: "\\f1095";
}

.mdi-form-textbox::before {
  content: "\\f060e";
}

.mdi-form-textbox-lock::before {
  content: "\\f135d";
}

.mdi-form-textbox-password::before {
  content: "\\f07f5";
}

.mdi-format-align-bottom::before {
  content: "\\f0753";
}

.mdi-format-align-center::before {
  content: "\\f0260";
}

.mdi-format-align-justify::before {
  content: "\\f0261";
}

.mdi-format-align-left::before {
  content: "\\f0262";
}

.mdi-format-align-middle::before {
  content: "\\f0754";
}

.mdi-format-align-right::before {
  content: "\\f0263";
}

.mdi-format-align-top::before {
  content: "\\f0755";
}

.mdi-format-annotation-minus::before {
  content: "\\f0abc";
}

.mdi-format-annotation-plus::before {
  content: "\\f0646";
}

.mdi-format-bold::before {
  content: "\\f0264";
}

.mdi-format-clear::before {
  content: "\\f0265";
}

.mdi-format-color-fill::before {
  content: "\\f0266";
}

.mdi-format-color-highlight::before {
  content: "\\f0e31";
}

.mdi-format-color-marker-cancel::before {
  content: "\\f1313";
}

.mdi-format-color-text::before {
  content: "\\f069e";
}

.mdi-format-columns::before {
  content: "\\f08df";
}

.mdi-format-float-center::before {
  content: "\\f0267";
}

.mdi-format-float-left::before {
  content: "\\f0268";
}

.mdi-format-float-none::before {
  content: "\\f0269";
}

.mdi-format-float-right::before {
  content: "\\f026a";
}

.mdi-format-font::before {
  content: "\\f06d6";
}

.mdi-format-font-size-decrease::before {
  content: "\\f09f3";
}

.mdi-format-font-size-increase::before {
  content: "\\f09f4";
}

.mdi-format-header-1::before {
  content: "\\f026b";
}

.mdi-format-header-2::before {
  content: "\\f026c";
}

.mdi-format-header-3::before {
  content: "\\f026d";
}

.mdi-format-header-4::before {
  content: "\\f026e";
}

.mdi-format-header-5::before {
  content: "\\f026f";
}

.mdi-format-header-6::before {
  content: "\\f0270";
}

.mdi-format-header-decrease::before {
  content: "\\f0271";
}

.mdi-format-header-equal::before {
  content: "\\f0272";
}

.mdi-format-header-increase::before {
  content: "\\f0273";
}

.mdi-format-header-pound::before {
  content: "\\f0274";
}

.mdi-format-horizontal-align-center::before {
  content: "\\f061e";
}

.mdi-format-horizontal-align-left::before {
  content: "\\f061f";
}

.mdi-format-horizontal-align-right::before {
  content: "\\f0620";
}

.mdi-format-indent-decrease::before {
  content: "\\f0275";
}

.mdi-format-indent-increase::before {
  content: "\\f0276";
}

.mdi-format-italic::before {
  content: "\\f0277";
}

.mdi-format-letter-case::before {
  content: "\\f0b34";
}

.mdi-format-letter-case-lower::before {
  content: "\\f0b35";
}

.mdi-format-letter-case-upper::before {
  content: "\\f0b36";
}

.mdi-format-letter-ends-with::before {
  content: "\\f0fb8";
}

.mdi-format-letter-matches::before {
  content: "\\f0fb9";
}

.mdi-format-letter-spacing::before {
  content: "\\f1956";
}

.mdi-format-letter-starts-with::before {
  content: "\\f0fba";
}

.mdi-format-line-spacing::before {
  content: "\\f0278";
}

.mdi-format-line-style::before {
  content: "\\f05c8";
}

.mdi-format-line-weight::before {
  content: "\\f05c9";
}

.mdi-format-list-bulleted::before {
  content: "\\f0279";
}

.mdi-format-list-bulleted-square::before {
  content: "\\f0dd0";
}

.mdi-format-list-bulleted-triangle::before {
  content: "\\f0eb2";
}

.mdi-format-list-bulleted-type::before {
  content: "\\f027a";
}

.mdi-format-list-checkbox::before {
  content: "\\f096a";
}

.mdi-format-list-checks::before {
  content: "\\f0756";
}

.mdi-format-list-group::before {
  content: "\\f1860";
}

.mdi-format-list-numbered::before {
  content: "\\f027b";
}

.mdi-format-list-numbered-rtl::before {
  content: "\\f0d0d";
}

.mdi-format-list-text::before {
  content: "\\f126f";
}

.mdi-format-overline::before {
  content: "\\f0eb3";
}

.mdi-format-page-break::before {
  content: "\\f06d7";
}

.mdi-format-page-split::before {
  content: "\\f1917";
}

.mdi-format-paint::before {
  content: "\\f027c";
}

.mdi-format-paragraph::before {
  content: "\\f027d";
}

.mdi-format-pilcrow::before {
  content: "\\f06d8";
}

.mdi-format-quote-close::before {
  content: "\\f027e";
}

.mdi-format-quote-close-outline::before {
  content: "\\f11a8";
}

.mdi-format-quote-open::before {
  content: "\\f0757";
}

.mdi-format-quote-open-outline::before {
  content: "\\f11a7";
}

.mdi-format-rotate-90::before {
  content: "\\f06aa";
}

.mdi-format-section::before {
  content: "\\f069f";
}

.mdi-format-size::before {
  content: "\\f027f";
}

.mdi-format-strikethrough::before {
  content: "\\f0280";
}

.mdi-format-strikethrough-variant::before {
  content: "\\f0281";
}

.mdi-format-subscript::before {
  content: "\\f0282";
}

.mdi-format-superscript::before {
  content: "\\f0283";
}

.mdi-format-text::before {
  content: "\\f0284";
}

.mdi-format-text-rotation-angle-down::before {
  content: "\\f0fbb";
}

.mdi-format-text-rotation-angle-up::before {
  content: "\\f0fbc";
}

.mdi-format-text-rotation-down::before {
  content: "\\f0d73";
}

.mdi-format-text-rotation-down-vertical::before {
  content: "\\f0fbd";
}

.mdi-format-text-rotation-none::before {
  content: "\\f0d74";
}

.mdi-format-text-rotation-up::before {
  content: "\\f0fbe";
}

.mdi-format-text-rotation-vertical::before {
  content: "\\f0fbf";
}

.mdi-format-text-variant::before {
  content: "\\f0e32";
}

.mdi-format-text-variant-outline::before {
  content: "\\f150f";
}

.mdi-format-text-wrapping-clip::before {
  content: "\\f0d0e";
}

.mdi-format-text-wrapping-overflow::before {
  content: "\\f0d0f";
}

.mdi-format-text-wrapping-wrap::before {
  content: "\\f0d10";
}

.mdi-format-textbox::before {
  content: "\\f0d11";
}

.mdi-format-textdirection-l-to-r::before {
  content: "\\f0285";
}

.mdi-format-textdirection-r-to-l::before {
  content: "\\f0286";
}

.mdi-format-title::before {
  content: "\\f05f4";
}

.mdi-format-underline::before {
  content: "\\f0287";
}

.mdi-format-underline-wavy::before {
  content: "\\f18e9";
}

.mdi-format-vertical-align-bottom::before {
  content: "\\f0621";
}

.mdi-format-vertical-align-center::before {
  content: "\\f0622";
}

.mdi-format-vertical-align-top::before {
  content: "\\f0623";
}

.mdi-format-wrap-inline::before {
  content: "\\f0288";
}

.mdi-format-wrap-square::before {
  content: "\\f0289";
}

.mdi-format-wrap-tight::before {
  content: "\\f028a";
}

.mdi-format-wrap-top-bottom::before {
  content: "\\f028b";
}

.mdi-forum::before {
  content: "\\f028c";
}

.mdi-forum-outline::before {
  content: "\\f0822";
}

.mdi-forward::before {
  content: "\\f028d";
}

.mdi-forwardburger::before {
  content: "\\f0d75";
}

.mdi-fountain::before {
  content: "\\f096b";
}

.mdi-fountain-pen::before {
  content: "\\f0d12";
}

.mdi-fountain-pen-tip::before {
  content: "\\f0d13";
}

.mdi-fraction-one-half::before {
  content: "\\f1992";
}

.mdi-freebsd::before {
  content: "\\f08e0";
}

.mdi-french-fries::before {
  content: "\\f1957";
}

.mdi-frequently-asked-questions::before {
  content: "\\f0eb4";
}

.mdi-fridge::before {
  content: "\\f0290";
}

.mdi-fridge-alert::before {
  content: "\\f11b1";
}

.mdi-fridge-alert-outline::before {
  content: "\\f11b2";
}

.mdi-fridge-bottom::before {
  content: "\\f0292";
}

.mdi-fridge-industrial::before {
  content: "\\f15ee";
}

.mdi-fridge-industrial-alert::before {
  content: "\\f15ef";
}

.mdi-fridge-industrial-alert-outline::before {
  content: "\\f15f0";
}

.mdi-fridge-industrial-off::before {
  content: "\\f15f1";
}

.mdi-fridge-industrial-off-outline::before {
  content: "\\f15f2";
}

.mdi-fridge-industrial-outline::before {
  content: "\\f15f3";
}

.mdi-fridge-off::before {
  content: "\\f11af";
}

.mdi-fridge-off-outline::before {
  content: "\\f11b0";
}

.mdi-fridge-outline::before {
  content: "\\f028f";
}

.mdi-fridge-top::before {
  content: "\\f0291";
}

.mdi-fridge-variant::before {
  content: "\\f15f4";
}

.mdi-fridge-variant-alert::before {
  content: "\\f15f5";
}

.mdi-fridge-variant-alert-outline::before {
  content: "\\f15f6";
}

.mdi-fridge-variant-off::before {
  content: "\\f15f7";
}

.mdi-fridge-variant-off-outline::before {
  content: "\\f15f8";
}

.mdi-fridge-variant-outline::before {
  content: "\\f15f9";
}

.mdi-fruit-cherries::before {
  content: "\\f1042";
}

.mdi-fruit-cherries-off::before {
  content: "\\f13f8";
}

.mdi-fruit-citrus::before {
  content: "\\f1043";
}

.mdi-fruit-citrus-off::before {
  content: "\\f13f9";
}

.mdi-fruit-grapes::before {
  content: "\\f1044";
}

.mdi-fruit-grapes-outline::before {
  content: "\\f1045";
}

.mdi-fruit-pineapple::before {
  content: "\\f1046";
}

.mdi-fruit-watermelon::before {
  content: "\\f1047";
}

.mdi-fuel::before {
  content: "\\f07ca";
}

.mdi-fuel-cell::before {
  content: "\\f18b5";
}

.mdi-fullscreen::before {
  content: "\\f0293";
}

.mdi-fullscreen-exit::before {
  content: "\\f0294";
}

.mdi-function::before {
  content: "\\f0295";
}

.mdi-function-variant::before {
  content: "\\f0871";
}

.mdi-furigana-horizontal::before {
  content: "\\f1081";
}

.mdi-furigana-vertical::before {
  content: "\\f1082";
}

.mdi-fuse::before {
  content: "\\f0c85";
}

.mdi-fuse-alert::before {
  content: "\\f142d";
}

.mdi-fuse-blade::before {
  content: "\\f0c86";
}

.mdi-fuse-off::before {
  content: "\\f142c";
}

.mdi-gamepad::before {
  content: "\\f0296";
}

.mdi-gamepad-circle::before {
  content: "\\f0e33";
}

.mdi-gamepad-circle-down::before {
  content: "\\f0e34";
}

.mdi-gamepad-circle-left::before {
  content: "\\f0e35";
}

.mdi-gamepad-circle-outline::before {
  content: "\\f0e36";
}

.mdi-gamepad-circle-right::before {
  content: "\\f0e37";
}

.mdi-gamepad-circle-up::before {
  content: "\\f0e38";
}

.mdi-gamepad-down::before {
  content: "\\f0e39";
}

.mdi-gamepad-left::before {
  content: "\\f0e3a";
}

.mdi-gamepad-outline::before {
  content: "\\f1919";
}

.mdi-gamepad-right::before {
  content: "\\f0e3b";
}

.mdi-gamepad-round::before {
  content: "\\f0e3c";
}

.mdi-gamepad-round-down::before {
  content: "\\f0e3d";
}

.mdi-gamepad-round-left::before {
  content: "\\f0e3e";
}

.mdi-gamepad-round-outline::before {
  content: "\\f0e3f";
}

.mdi-gamepad-round-right::before {
  content: "\\f0e40";
}

.mdi-gamepad-round-up::before {
  content: "\\f0e41";
}

.mdi-gamepad-square::before {
  content: "\\f0eb5";
}

.mdi-gamepad-square-outline::before {
  content: "\\f0eb6";
}

.mdi-gamepad-up::before {
  content: "\\f0e42";
}

.mdi-gamepad-variant::before {
  content: "\\f0297";
}

.mdi-gamepad-variant-outline::before {
  content: "\\f0eb7";
}

.mdi-gamma::before {
  content: "\\f10ee";
}

.mdi-gantry-crane::before {
  content: "\\f0dd1";
}

.mdi-garage::before {
  content: "\\f06d9";
}

.mdi-garage-alert::before {
  content: "\\f0872";
}

.mdi-garage-alert-variant::before {
  content: "\\f12d5";
}

.mdi-garage-lock::before {
  content: "\\f17fb";
}

.mdi-garage-open::before {
  content: "\\f06da";
}

.mdi-garage-open-variant::before {
  content: "\\f12d4";
}

.mdi-garage-variant::before {
  content: "\\f12d3";
}

.mdi-garage-variant-lock::before {
  content: "\\f17fc";
}

.mdi-gas-cylinder::before {
  content: "\\f0647";
}

.mdi-gas-station::before {
  content: "\\f0298";
}

.mdi-gas-station-off::before {
  content: "\\f1409";
}

.mdi-gas-station-off-outline::before {
  content: "\\f140a";
}

.mdi-gas-station-outline::before {
  content: "\\f0eb8";
}

.mdi-gate::before {
  content: "\\f0299";
}

.mdi-gate-alert::before {
  content: "\\f17f8";
}

.mdi-gate-and::before {
  content: "\\f08e1";
}

.mdi-gate-arrow-left::before {
  content: "\\f17f7";
}

.mdi-gate-arrow-right::before {
  content: "\\f1169";
}

.mdi-gate-nand::before {
  content: "\\f08e2";
}

.mdi-gate-nor::before {
  content: "\\f08e3";
}

.mdi-gate-not::before {
  content: "\\f08e4";
}

.mdi-gate-open::before {
  content: "\\f116a";
}

.mdi-gate-or::before {
  content: "\\f08e5";
}

.mdi-gate-xnor::before {
  content: "\\f08e6";
}

.mdi-gate-xor::before {
  content: "\\f08e7";
}

.mdi-gatsby::before {
  content: "\\f0e43";
}

.mdi-gauge::before {
  content: "\\f029a";
}

.mdi-gauge-empty::before {
  content: "\\f0873";
}

.mdi-gauge-full::before {
  content: "\\f0874";
}

.mdi-gauge-low::before {
  content: "\\f0875";
}

.mdi-gavel::before {
  content: "\\f029b";
}

.mdi-gender-female::before {
  content: "\\f029c";
}

.mdi-gender-male::before {
  content: "\\f029d";
}

.mdi-gender-male-female::before {
  content: "\\f029e";
}

.mdi-gender-male-female-variant::before {
  content: "\\f113f";
}

.mdi-gender-non-binary::before {
  content: "\\f1140";
}

.mdi-gender-transgender::before {
  content: "\\f029f";
}

.mdi-gentoo::before {
  content: "\\f08e8";
}

.mdi-gesture::before {
  content: "\\f07cb";
}

.mdi-gesture-double-tap::before {
  content: "\\f073c";
}

.mdi-gesture-pinch::before {
  content: "\\f0abd";
}

.mdi-gesture-spread::before {
  content: "\\f0abe";
}

.mdi-gesture-swipe::before {
  content: "\\f0d76";
}

.mdi-gesture-swipe-down::before {
  content: "\\f073d";
}

.mdi-gesture-swipe-horizontal::before {
  content: "\\f0abf";
}

.mdi-gesture-swipe-left::before {
  content: "\\f073e";
}

.mdi-gesture-swipe-right::before {
  content: "\\f073f";
}

.mdi-gesture-swipe-up::before {
  content: "\\f0740";
}

.mdi-gesture-swipe-vertical::before {
  content: "\\f0ac0";
}

.mdi-gesture-tap::before {
  content: "\\f0741";
}

.mdi-gesture-tap-box::before {
  content: "\\f12a9";
}

.mdi-gesture-tap-button::before {
  content: "\\f12a8";
}

.mdi-gesture-tap-hold::before {
  content: "\\f0d77";
}

.mdi-gesture-two-double-tap::before {
  content: "\\f0742";
}

.mdi-gesture-two-tap::before {
  content: "\\f0743";
}

.mdi-ghost::before {
  content: "\\f02a0";
}

.mdi-ghost-off::before {
  content: "\\f09f5";
}

.mdi-ghost-off-outline::before {
  content: "\\f165c";
}

.mdi-ghost-outline::before {
  content: "\\f165d";
}

.mdi-gift::before {
  content: "\\f0e44";
}

.mdi-gift-off::before {
  content: "\\f16ef";
}

.mdi-gift-off-outline::before {
  content: "\\f16f0";
}

.mdi-gift-open::before {
  content: "\\f16f1";
}

.mdi-gift-open-outline::before {
  content: "\\f16f2";
}

.mdi-gift-outline::before {
  content: "\\f02a1";
}

.mdi-git::before {
  content: "\\f02a2";
}

.mdi-github::before {
  content: "\\f02a4";
}

.mdi-gitlab::before {
  content: "\\f0ba0";
}

.mdi-glass-cocktail::before {
  content: "\\f0356";
}

.mdi-glass-cocktail-off::before {
  content: "\\f15e6";
}

.mdi-glass-flute::before {
  content: "\\f02a5";
}

.mdi-glass-fragile::before {
  content: "\\f1873";
}

.mdi-glass-mug::before {
  content: "\\f02a6";
}

.mdi-glass-mug-off::before {
  content: "\\f15e7";
}

.mdi-glass-mug-variant::before {
  content: "\\f1116";
}

.mdi-glass-mug-variant-off::before {
  content: "\\f15e8";
}

.mdi-glass-pint-outline::before {
  content: "\\f130d";
}

.mdi-glass-stange::before {
  content: "\\f02a7";
}

.mdi-glass-tulip::before {
  content: "\\f02a8";
}

.mdi-glass-wine::before {
  content: "\\f0876";
}

.mdi-glasses::before {
  content: "\\f02aa";
}

.mdi-globe-light::before {
  content: "\\f12d7";
}

.mdi-globe-model::before {
  content: "\\f08e9";
}

.mdi-gmail::before {
  content: "\\f02ab";
}

.mdi-gnome::before {
  content: "\\f02ac";
}

.mdi-go-kart::before {
  content: "\\f0d79";
}

.mdi-go-kart-track::before {
  content: "\\f0d7a";
}

.mdi-gog::before {
  content: "\\f0ba1";
}

.mdi-gold::before {
  content: "\\f124f";
}

.mdi-golf::before {
  content: "\\f0823";
}

.mdi-golf-cart::before {
  content: "\\f11a4";
}

.mdi-golf-tee::before {
  content: "\\f1083";
}

.mdi-gondola::before {
  content: "\\f0686";
}

.mdi-goodreads::before {
  content: "\\f0d7b";
}

.mdi-google::before {
  content: "\\f02ad";
}

.mdi-google-ads::before {
  content: "\\f0c87";
}

.mdi-google-analytics::before {
  content: "\\f07cc";
}

.mdi-google-assistant::before {
  content: "\\f07cd";
}

.mdi-google-cardboard::before {
  content: "\\f02ae";
}

.mdi-google-chrome::before {
  content: "\\f02af";
}

.mdi-google-circles::before {
  content: "\\f02b0";
}

.mdi-google-circles-communities::before {
  content: "\\f02b1";
}

.mdi-google-circles-extended::before {
  content: "\\f02b2";
}

.mdi-google-circles-group::before {
  content: "\\f02b3";
}

.mdi-google-classroom::before {
  content: "\\f02c0";
}

.mdi-google-cloud::before {
  content: "\\f11f6";
}

.mdi-google-controller::before {
  content: "\\f02b4";
}

.mdi-google-controller-off::before {
  content: "\\f02b5";
}

.mdi-google-downasaur::before {
  content: "\\f1362";
}

.mdi-google-drive::before {
  content: "\\f02b6";
}

.mdi-google-earth::before {
  content: "\\f02b7";
}

.mdi-google-fit::before {
  content: "\\f096c";
}

.mdi-google-glass::before {
  content: "\\f02b8";
}

.mdi-google-hangouts::before {
  content: "\\f02c9";
}

.mdi-google-home::before {
  content: "\\f0824";
}

.mdi-google-keep::before {
  content: "\\f06dc";
}

.mdi-google-lens::before {
  content: "\\f09f6";
}

.mdi-google-maps::before {
  content: "\\f05f5";
}

.mdi-google-my-business::before {
  content: "\\f1048";
}

.mdi-google-nearby::before {
  content: "\\f02b9";
}

.mdi-google-play::before {
  content: "\\f02bc";
}

.mdi-google-plus::before {
  content: "\\f02bd";
}

.mdi-google-podcast::before {
  content: "\\f0eb9";
}

.mdi-google-spreadsheet::before {
  content: "\\f09f7";
}

.mdi-google-street-view::before {
  content: "\\f0c88";
}

.mdi-google-translate::before {
  content: "\\f02bf";
}

.mdi-gradient-horizontal::before {
  content: "\\f174a";
}

.mdi-gradient-vertical::before {
  content: "\\f06a0";
}

.mdi-grain::before {
  content: "\\f0d7c";
}

.mdi-graph::before {
  content: "\\f1049";
}

.mdi-graph-outline::before {
  content: "\\f104a";
}

.mdi-graphql::before {
  content: "\\f0877";
}

.mdi-grass::before {
  content: "\\f1510";
}

.mdi-grave-stone::before {
  content: "\\f0ba2";
}

.mdi-grease-pencil::before {
  content: "\\f0648";
}

.mdi-greater-than::before {
  content: "\\f096d";
}

.mdi-greater-than-or-equal::before {
  content: "\\f096e";
}

.mdi-greenhouse::before {
  content: "\\f002d";
}

.mdi-grid::before {
  content: "\\f02c1";
}

.mdi-grid-large::before {
  content: "\\f0758";
}

.mdi-grid-off::before {
  content: "\\f02c2";
}

.mdi-grill::before {
  content: "\\f0e45";
}

.mdi-grill-outline::before {
  content: "\\f118a";
}

.mdi-group::before {
  content: "\\f02c3";
}

.mdi-guitar-acoustic::before {
  content: "\\f0771";
}

.mdi-guitar-electric::before {
  content: "\\f02c4";
}

.mdi-guitar-pick::before {
  content: "\\f02c5";
}

.mdi-guitar-pick-outline::before {
  content: "\\f02c6";
}

.mdi-guy-fawkes-mask::before {
  content: "\\f0825";
}

.mdi-hail::before {
  content: "\\f0ac1";
}

.mdi-hair-dryer::before {
  content: "\\f10ef";
}

.mdi-hair-dryer-outline::before {
  content: "\\f10f0";
}

.mdi-halloween::before {
  content: "\\f0ba3";
}

.mdi-hamburger::before {
  content: "\\f0685";
}

.mdi-hamburger-check::before {
  content: "\\f1776";
}

.mdi-hamburger-minus::before {
  content: "\\f1777";
}

.mdi-hamburger-off::before {
  content: "\\f1778";
}

.mdi-hamburger-plus::before {
  content: "\\f1779";
}

.mdi-hamburger-remove::before {
  content: "\\f177a";
}

.mdi-hammer::before {
  content: "\\f08ea";
}

.mdi-hammer-screwdriver::before {
  content: "\\f1322";
}

.mdi-hammer-sickle::before {
  content: "\\f1887";
}

.mdi-hammer-wrench::before {
  content: "\\f1323";
}

.mdi-hand-back-left::before {
  content: "\\f0e46";
}

.mdi-hand-back-left-off::before {
  content: "\\f1830";
}

.mdi-hand-back-left-off-outline::before {
  content: "\\f1832";
}

.mdi-hand-back-left-outline::before {
  content: "\\f182c";
}

.mdi-hand-back-right::before {
  content: "\\f0e47";
}

.mdi-hand-back-right-off::before {
  content: "\\f1831";
}

.mdi-hand-back-right-off-outline::before {
  content: "\\f1833";
}

.mdi-hand-back-right-outline::before {
  content: "\\f182d";
}

.mdi-hand-clap::before {
  content: "\\f194b";
}

.mdi-hand-coin::before {
  content: "\\f188f";
}

.mdi-hand-coin-outline::before {
  content: "\\f1890";
}

.mdi-hand-extended::before {
  content: "\\f18b6";
}

.mdi-hand-extended-outline::before {
  content: "\\f18b7";
}

.mdi-hand-front-left::before {
  content: "\\f182b";
}

.mdi-hand-front-left-outline::before {
  content: "\\f182e";
}

.mdi-hand-front-right::before {
  content: "\\f0a4f";
}

.mdi-hand-front-right-outline::before {
  content: "\\f182f";
}

.mdi-hand-heart::before {
  content: "\\f10f1";
}

.mdi-hand-heart-outline::before {
  content: "\\f157e";
}

.mdi-hand-okay::before {
  content: "\\f0a50";
}

.mdi-hand-peace::before {
  content: "\\f0a51";
}

.mdi-hand-peace-variant::before {
  content: "\\f0a52";
}

.mdi-hand-pointing-down::before {
  content: "\\f0a53";
}

.mdi-hand-pointing-left::before {
  content: "\\f0a54";
}

.mdi-hand-pointing-right::before {
  content: "\\f02c7";
}

.mdi-hand-pointing-up::before {
  content: "\\f0a55";
}

.mdi-hand-saw::before {
  content: "\\f0e48";
}

.mdi-hand-wash::before {
  content: "\\f157f";
}

.mdi-hand-wash-outline::before {
  content: "\\f1580";
}

.mdi-hand-water::before {
  content: "\\f139f";
}

.mdi-hand-wave::before {
  content: "\\f1821";
}

.mdi-hand-wave-outline::before {
  content: "\\f1822";
}

.mdi-handball::before {
  content: "\\f0f53";
}

.mdi-handcuffs::before {
  content: "\\f113e";
}

.mdi-hands-pray::before {
  content: "\\f0579";
}

.mdi-handshake::before {
  content: "\\f1218";
}

.mdi-handshake-outline::before {
  content: "\\f15a1";
}

.mdi-hanger::before {
  content: "\\f02c8";
}

.mdi-hard-hat::before {
  content: "\\f096f";
}

.mdi-harddisk::before {
  content: "\\f02ca";
}

.mdi-harddisk-plus::before {
  content: "\\f104b";
}

.mdi-harddisk-remove::before {
  content: "\\f104c";
}

.mdi-hat-fedora::before {
  content: "\\f0ba4";
}

.mdi-hazard-lights::before {
  content: "\\f0c89";
}

.mdi-hdr::before {
  content: "\\f0d7d";
}

.mdi-hdr-off::before {
  content: "\\f0d7e";
}

.mdi-head::before {
  content: "\\f135e";
}

.mdi-head-alert::before {
  content: "\\f1338";
}

.mdi-head-alert-outline::before {
  content: "\\f1339";
}

.mdi-head-check::before {
  content: "\\f133a";
}

.mdi-head-check-outline::before {
  content: "\\f133b";
}

.mdi-head-cog::before {
  content: "\\f133c";
}

.mdi-head-cog-outline::before {
  content: "\\f133d";
}

.mdi-head-dots-horizontal::before {
  content: "\\f133e";
}

.mdi-head-dots-horizontal-outline::before {
  content: "\\f133f";
}

.mdi-head-flash::before {
  content: "\\f1340";
}

.mdi-head-flash-outline::before {
  content: "\\f1341";
}

.mdi-head-heart::before {
  content: "\\f1342";
}

.mdi-head-heart-outline::before {
  content: "\\f1343";
}

.mdi-head-lightbulb::before {
  content: "\\f1344";
}

.mdi-head-lightbulb-outline::before {
  content: "\\f1345";
}

.mdi-head-minus::before {
  content: "\\f1346";
}

.mdi-head-minus-outline::before {
  content: "\\f1347";
}

.mdi-head-outline::before {
  content: "\\f135f";
}

.mdi-head-plus::before {
  content: "\\f1348";
}

.mdi-head-plus-outline::before {
  content: "\\f1349";
}

.mdi-head-question::before {
  content: "\\f134a";
}

.mdi-head-question-outline::before {
  content: "\\f134b";
}

.mdi-head-remove::before {
  content: "\\f134c";
}

.mdi-head-remove-outline::before {
  content: "\\f134d";
}

.mdi-head-snowflake::before {
  content: "\\f134e";
}

.mdi-head-snowflake-outline::before {
  content: "\\f134f";
}

.mdi-head-sync::before {
  content: "\\f1350";
}

.mdi-head-sync-outline::before {
  content: "\\f1351";
}

.mdi-headphones::before {
  content: "\\f02cb";
}

.mdi-headphones-bluetooth::before {
  content: "\\f0970";
}

.mdi-headphones-box::before {
  content: "\\f02cc";
}

.mdi-headphones-off::before {
  content: "\\f07ce";
}

.mdi-headphones-settings::before {
  content: "\\f02cd";
}

.mdi-headset::before {
  content: "\\f02ce";
}

.mdi-headset-dock::before {
  content: "\\f02cf";
}

.mdi-headset-off::before {
  content: "\\f02d0";
}

.mdi-heart::before {
  content: "\\f02d1";
}

.mdi-heart-box::before {
  content: "\\f02d2";
}

.mdi-heart-box-outline::before {
  content: "\\f02d3";
}

.mdi-heart-broken::before {
  content: "\\f02d4";
}

.mdi-heart-broken-outline::before {
  content: "\\f0d14";
}

.mdi-heart-circle::before {
  content: "\\f0971";
}

.mdi-heart-circle-outline::before {
  content: "\\f0972";
}

.mdi-heart-cog::before {
  content: "\\f1663";
}

.mdi-heart-cog-outline::before {
  content: "\\f1664";
}

.mdi-heart-flash::before {
  content: "\\f0ef9";
}

.mdi-heart-half::before {
  content: "\\f06df";
}

.mdi-heart-half-full::before {
  content: "\\f06de";
}

.mdi-heart-half-outline::before {
  content: "\\f06e0";
}

.mdi-heart-minus::before {
  content: "\\f142f";
}

.mdi-heart-minus-outline::before {
  content: "\\f1432";
}

.mdi-heart-multiple::before {
  content: "\\f0a56";
}

.mdi-heart-multiple-outline::before {
  content: "\\f0a57";
}

.mdi-heart-off::before {
  content: "\\f0759";
}

.mdi-heart-off-outline::before {
  content: "\\f1434";
}

.mdi-heart-outline::before {
  content: "\\f02d5";
}

.mdi-heart-plus::before {
  content: "\\f142e";
}

.mdi-heart-plus-outline::before {
  content: "\\f1431";
}

.mdi-heart-pulse::before {
  content: "\\f05f6";
}

.mdi-heart-remove::before {
  content: "\\f1430";
}

.mdi-heart-remove-outline::before {
  content: "\\f1433";
}

.mdi-heart-settings::before {
  content: "\\f1665";
}

.mdi-heart-settings-outline::before {
  content: "\\f1666";
}

.mdi-helicopter::before {
  content: "\\f0ac2";
}

.mdi-help::before {
  content: "\\f02d6";
}

.mdi-help-box::before {
  content: "\\f078b";
}

.mdi-help-circle::before {
  content: "\\f02d7";
}

.mdi-help-circle-outline::before {
  content: "\\f0625";
}

.mdi-help-network::before {
  content: "\\f06f5";
}

.mdi-help-network-outline::before {
  content: "\\f0c8a";
}

.mdi-help-rhombus::before {
  content: "\\f0ba5";
}

.mdi-help-rhombus-outline::before {
  content: "\\f0ba6";
}

.mdi-hexadecimal::before {
  content: "\\f12a7";
}

.mdi-hexagon::before {
  content: "\\f02d8";
}

.mdi-hexagon-multiple::before {
  content: "\\f06e1";
}

.mdi-hexagon-multiple-outline::before {
  content: "\\f10f2";
}

.mdi-hexagon-outline::before {
  content: "\\f02d9";
}

.mdi-hexagon-slice-1::before {
  content: "\\f0ac3";
}

.mdi-hexagon-slice-2::before {
  content: "\\f0ac4";
}

.mdi-hexagon-slice-3::before {
  content: "\\f0ac5";
}

.mdi-hexagon-slice-4::before {
  content: "\\f0ac6";
}

.mdi-hexagon-slice-5::before {
  content: "\\f0ac7";
}

.mdi-hexagon-slice-6::before {
  content: "\\f0ac8";
}

.mdi-hexagram::before {
  content: "\\f0ac9";
}

.mdi-hexagram-outline::before {
  content: "\\f0aca";
}

.mdi-high-definition::before {
  content: "\\f07cf";
}

.mdi-high-definition-box::before {
  content: "\\f0878";
}

.mdi-highway::before {
  content: "\\f05f7";
}

.mdi-hiking::before {
  content: "\\f0d7f";
}

.mdi-history::before {
  content: "\\f02da";
}

.mdi-hockey-puck::before {
  content: "\\f0879";
}

.mdi-hockey-sticks::before {
  content: "\\f087a";
}

.mdi-hololens::before {
  content: "\\f02db";
}

.mdi-home::before {
  content: "\\f02dc";
}

.mdi-home-account::before {
  content: "\\f0826";
}

.mdi-home-alert::before {
  content: "\\f087b";
}

.mdi-home-alert-outline::before {
  content: "\\f15d0";
}

.mdi-home-analytics::before {
  content: "\\f0eba";
}

.mdi-home-assistant::before {
  content: "\\f07d0";
}

.mdi-home-automation::before {
  content: "\\f07d1";
}

.mdi-home-battery::before {
  content: "\\f1901";
}

.mdi-home-battery-outline::before {
  content: "\\f1902";
}

.mdi-home-circle::before {
  content: "\\f07d2";
}

.mdi-home-circle-outline::before {
  content: "\\f104d";
}

.mdi-home-city::before {
  content: "\\f0d15";
}

.mdi-home-city-outline::before {
  content: "\\f0d16";
}

.mdi-home-edit::before {
  content: "\\f1159";
}

.mdi-home-edit-outline::before {
  content: "\\f115a";
}

.mdi-home-export-outline::before {
  content: "\\f0f9b";
}

.mdi-home-flood::before {
  content: "\\f0efa";
}

.mdi-home-floor-0::before {
  content: "\\f0dd2";
}

.mdi-home-floor-1::before {
  content: "\\f0d80";
}

.mdi-home-floor-2::before {
  content: "\\f0d81";
}

.mdi-home-floor-3::before {
  content: "\\f0d82";
}

.mdi-home-floor-a::before {
  content: "\\f0d83";
}

.mdi-home-floor-b::before {
  content: "\\f0d84";
}

.mdi-home-floor-g::before {
  content: "\\f0d85";
}

.mdi-home-floor-l::before {
  content: "\\f0d86";
}

.mdi-home-floor-negative-1::before {
  content: "\\f0dd3";
}

.mdi-home-group::before {
  content: "\\f0dd4";
}

.mdi-home-group-minus::before {
  content: "\\f19c1";
}

.mdi-home-group-plus::before {
  content: "\\f19c0";
}

.mdi-home-group-remove::before {
  content: "\\f19c2";
}

.mdi-home-heart::before {
  content: "\\f0827";
}

.mdi-home-import-outline::before {
  content: "\\f0f9c";
}

.mdi-home-lightbulb::before {
  content: "\\f1251";
}

.mdi-home-lightbulb-outline::before {
  content: "\\f1252";
}

.mdi-home-lightning-bolt::before {
  content: "\\f1903";
}

.mdi-home-lightning-bolt-outline::before {
  content: "\\f1904";
}

.mdi-home-lock::before {
  content: "\\f08eb";
}

.mdi-home-lock-open::before {
  content: "\\f08ec";
}

.mdi-home-map-marker::before {
  content: "\\f05f8";
}

.mdi-home-minus::before {
  content: "\\f0974";
}

.mdi-home-minus-outline::before {
  content: "\\f13d5";
}

.mdi-home-modern::before {
  content: "\\f02dd";
}

.mdi-home-outline::before {
  content: "\\f06a1";
}

.mdi-home-plus::before {
  content: "\\f0975";
}

.mdi-home-plus-outline::before {
  content: "\\f13d6";
}

.mdi-home-remove::before {
  content: "\\f1247";
}

.mdi-home-remove-outline::before {
  content: "\\f13d7";
}

.mdi-home-roof::before {
  content: "\\f112b";
}

.mdi-home-search::before {
  content: "\\f13b0";
}

.mdi-home-search-outline::before {
  content: "\\f13b1";
}

.mdi-home-switch::before {
  content: "\\f1794";
}

.mdi-home-switch-outline::before {
  content: "\\f1795";
}

.mdi-home-thermometer::before {
  content: "\\f0f54";
}

.mdi-home-thermometer-outline::before {
  content: "\\f0f55";
}

.mdi-home-variant::before {
  content: "\\f02de";
}

.mdi-home-variant-outline::before {
  content: "\\f0ba7";
}

.mdi-hook::before {
  content: "\\f06e2";
}

.mdi-hook-off::before {
  content: "\\f06e3";
}

.mdi-hoop-house::before {
  content: "\\f0e56";
}

.mdi-hops::before {
  content: "\\f02df";
}

.mdi-horizontal-rotate-clockwise::before {
  content: "\\f10f3";
}

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\f10f4";
}

.mdi-horse::before {
  content: "\\f15bf";
}

.mdi-horse-human::before {
  content: "\\f15c0";
}

.mdi-horse-variant::before {
  content: "\\f15c1";
}

.mdi-horse-variant-fast::before {
  content: "\\f186e";
}

.mdi-horseshoe::before {
  content: "\\f0a58";
}

.mdi-hospital::before {
  content: "\\f0ff6";
}

.mdi-hospital-box::before {
  content: "\\f02e0";
}

.mdi-hospital-box-outline::before {
  content: "\\f0ff7";
}

.mdi-hospital-building::before {
  content: "\\f02e1";
}

.mdi-hospital-marker::before {
  content: "\\f02e2";
}

.mdi-hot-tub::before {
  content: "\\f0828";
}

.mdi-hours-24::before {
  content: "\\f1478";
}

.mdi-hubspot::before {
  content: "\\f0d17";
}

.mdi-hulu::before {
  content: "\\f0829";
}

.mdi-human::before {
  content: "\\f02e6";
}

.mdi-human-baby-changing-table::before {
  content: "\\f138b";
}

.mdi-human-cane::before {
  content: "\\f1581";
}

.mdi-human-capacity-decrease::before {
  content: "\\f159b";
}

.mdi-human-capacity-increase::before {
  content: "\\f159c";
}

.mdi-human-child::before {
  content: "\\f02e7";
}

.mdi-human-dolly::before {
  content: "\\f1980";
}

.mdi-human-edit::before {
  content: "\\f14e8";
}

.mdi-human-female::before {
  content: "\\f0649";
}

.mdi-human-female-boy::before {
  content: "\\f0a59";
}

.mdi-human-female-dance::before {
  content: "\\f15c9";
}

.mdi-human-female-female::before {
  content: "\\f0a5a";
}

.mdi-human-female-girl::before {
  content: "\\f0a5b";
}

.mdi-human-greeting::before {
  content: "\\f17c4";
}

.mdi-human-greeting-proximity::before {
  content: "\\f159d";
}

.mdi-human-greeting-variant::before {
  content: "\\f064a";
}

.mdi-human-handsdown::before {
  content: "\\f064b";
}

.mdi-human-handsup::before {
  content: "\\f064c";
}

.mdi-human-male::before {
  content: "\\f064d";
}

.mdi-human-male-board::before {
  content: "\\f0890";
}

.mdi-human-male-board-poll::before {
  content: "\\f0846";
}

.mdi-human-male-boy::before {
  content: "\\f0a5c";
}

.mdi-human-male-child::before {
  content: "\\f138c";
}

.mdi-human-male-female::before {
  content: "\\f02e8";
}

.mdi-human-male-female-child::before {
  content: "\\f1823";
}

.mdi-human-male-girl::before {
  content: "\\f0a5d";
}

.mdi-human-male-height::before {
  content: "\\f0efb";
}

.mdi-human-male-height-variant::before {
  content: "\\f0efc";
}

.mdi-human-male-male::before {
  content: "\\f0a5e";
}

.mdi-human-non-binary::before {
  content: "\\f1848";
}

.mdi-human-pregnant::before {
  content: "\\f05cf";
}

.mdi-human-queue::before {
  content: "\\f1571";
}

.mdi-human-scooter::before {
  content: "\\f11e9";
}

.mdi-human-wheelchair::before {
  content: "\\f138d";
}

.mdi-human-white-cane::before {
  content: "\\f1981";
}

.mdi-humble-bundle::before {
  content: "\\f0744";
}

.mdi-hvac::before {
  content: "\\f1352";
}

.mdi-hvac-off::before {
  content: "\\f159e";
}

.mdi-hydraulic-oil-level::before {
  content: "\\f1324";
}

.mdi-hydraulic-oil-temperature::before {
  content: "\\f1325";
}

.mdi-hydro-power::before {
  content: "\\f12e5";
}

.mdi-hydrogen-station::before {
  content: "\\f1894";
}

.mdi-ice-cream::before {
  content: "\\f082a";
}

.mdi-ice-cream-off::before {
  content: "\\f0e52";
}

.mdi-ice-pop::before {
  content: "\\f0efd";
}

.mdi-id-card::before {
  content: "\\f0fc0";
}

.mdi-identifier::before {
  content: "\\f0efe";
}

.mdi-ideogram-cjk::before {
  content: "\\f1331";
}

.mdi-ideogram-cjk-variant::before {
  content: "\\f1332";
}

.mdi-image::before {
  content: "\\f02e9";
}

.mdi-image-album::before {
  content: "\\f02ea";
}

.mdi-image-area::before {
  content: "\\f02eb";
}

.mdi-image-area-close::before {
  content: "\\f02ec";
}

.mdi-image-auto-adjust::before {
  content: "\\f0fc1";
}

.mdi-image-broken::before {
  content: "\\f02ed";
}

.mdi-image-broken-variant::before {
  content: "\\f02ee";
}

.mdi-image-edit::before {
  content: "\\f11e3";
}

.mdi-image-edit-outline::before {
  content: "\\f11e4";
}

.mdi-image-filter-black-white::before {
  content: "\\f02f0";
}

.mdi-image-filter-center-focus::before {
  content: "\\f02f1";
}

.mdi-image-filter-center-focus-strong::before {
  content: "\\f0eff";
}

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\f0f00";
}

.mdi-image-filter-center-focus-weak::before {
  content: "\\f02f2";
}

.mdi-image-filter-drama::before {
  content: "\\f02f3";
}

.mdi-image-filter-frames::before {
  content: "\\f02f4";
}

.mdi-image-filter-hdr::before {
  content: "\\f02f5";
}

.mdi-image-filter-none::before {
  content: "\\f02f6";
}

.mdi-image-filter-tilt-shift::before {
  content: "\\f02f7";
}

.mdi-image-filter-vintage::before {
  content: "\\f02f8";
}

.mdi-image-frame::before {
  content: "\\f0e49";
}

.mdi-image-marker::before {
  content: "\\f177b";
}

.mdi-image-marker-outline::before {
  content: "\\f177c";
}

.mdi-image-minus::before {
  content: "\\f1419";
}

.mdi-image-move::before {
  content: "\\f09f8";
}

.mdi-image-multiple::before {
  content: "\\f02f9";
}

.mdi-image-multiple-outline::before {
  content: "\\f02ef";
}

.mdi-image-off::before {
  content: "\\f082b";
}

.mdi-image-off-outline::before {
  content: "\\f11d1";
}

.mdi-image-outline::before {
  content: "\\f0976";
}

.mdi-image-plus::before {
  content: "\\f087c";
}

.mdi-image-remove::before {
  content: "\\f1418";
}

.mdi-image-search::before {
  content: "\\f0977";
}

.mdi-image-search-outline::before {
  content: "\\f0978";
}

.mdi-image-size-select-actual::before {
  content: "\\f0c8d";
}

.mdi-image-size-select-large::before {
  content: "\\f0c8e";
}

.mdi-image-size-select-small::before {
  content: "\\f0c8f";
}

.mdi-image-text::before {
  content: "\\f160d";
}

.mdi-import::before {
  content: "\\f02fa";
}

.mdi-inbox::before {
  content: "\\f0687";
}

.mdi-inbox-arrow-down::before {
  content: "\\f02fb";
}

.mdi-inbox-arrow-down-outline::before {
  content: "\\f1270";
}

.mdi-inbox-arrow-up::before {
  content: "\\f03d1";
}

.mdi-inbox-arrow-up-outline::before {
  content: "\\f1271";
}

.mdi-inbox-full::before {
  content: "\\f1272";
}

.mdi-inbox-full-outline::before {
  content: "\\f1273";
}

.mdi-inbox-multiple::before {
  content: "\\f08b0";
}

.mdi-inbox-multiple-outline::before {
  content: "\\f0ba8";
}

.mdi-inbox-outline::before {
  content: "\\f1274";
}

.mdi-inbox-remove::before {
  content: "\\f159f";
}

.mdi-inbox-remove-outline::before {
  content: "\\f15a0";
}

.mdi-incognito::before {
  content: "\\f05f9";
}

.mdi-incognito-circle::before {
  content: "\\f1421";
}

.mdi-incognito-circle-off::before {
  content: "\\f1422";
}

.mdi-incognito-off::before {
  content: "\\f0075";
}

.mdi-induction::before {
  content: "\\f184c";
}

.mdi-infinity::before {
  content: "\\f06e4";
}

.mdi-information::before {
  content: "\\f02fc";
}

.mdi-information-off::before {
  content: "\\f178c";
}

.mdi-information-off-outline::before {
  content: "\\f178d";
}

.mdi-information-outline::before {
  content: "\\f02fd";
}

.mdi-information-variant::before {
  content: "\\f064e";
}

.mdi-instagram::before {
  content: "\\f02fe";
}

.mdi-instrument-triangle::before {
  content: "\\f104e";
}

.mdi-integrated-circuit-chip::before {
  content: "\\f1913";
}

.mdi-invert-colors::before {
  content: "\\f0301";
}

.mdi-invert-colors-off::before {
  content: "\\f0e4a";
}

.mdi-iobroker::before {
  content: "\\f12e8";
}

.mdi-ip::before {
  content: "\\f0a5f";
}

.mdi-ip-network::before {
  content: "\\f0a60";
}

.mdi-ip-network-outline::before {
  content: "\\f0c90";
}

.mdi-ip-outline::before {
  content: "\\f1982";
}

.mdi-ipod::before {
  content: "\\f0c91";
}

.mdi-iron::before {
  content: "\\f1824";
}

.mdi-iron-board::before {
  content: "\\f1838";
}

.mdi-iron-outline::before {
  content: "\\f1825";
}

.mdi-island::before {
  content: "\\f104f";
}

.mdi-iv-bag::before {
  content: "\\f10b9";
}

.mdi-jabber::before {
  content: "\\f0dd5";
}

.mdi-jeepney::before {
  content: "\\f0302";
}

.mdi-jellyfish::before {
  content: "\\f0f01";
}

.mdi-jellyfish-outline::before {
  content: "\\f0f02";
}

.mdi-jira::before {
  content: "\\f0303";
}

.mdi-jquery::before {
  content: "\\f087d";
}

.mdi-jsfiddle::before {
  content: "\\f0304";
}

.mdi-jump-rope::before {
  content: "\\f12ff";
}

.mdi-kabaddi::before {
  content: "\\f0d87";
}

.mdi-kangaroo::before {
  content: "\\f1558";
}

.mdi-karate::before {
  content: "\\f082c";
}

.mdi-kayaking::before {
  content: "\\f08af";
}

.mdi-keg::before {
  content: "\\f0305";
}

.mdi-kettle::before {
  content: "\\f05fa";
}

.mdi-kettle-alert::before {
  content: "\\f1317";
}

.mdi-kettle-alert-outline::before {
  content: "\\f1318";
}

.mdi-kettle-off::before {
  content: "\\f131b";
}

.mdi-kettle-off-outline::before {
  content: "\\f131c";
}

.mdi-kettle-outline::before {
  content: "\\f0f56";
}

.mdi-kettle-pour-over::before {
  content: "\\f173c";
}

.mdi-kettle-steam::before {
  content: "\\f1319";
}

.mdi-kettle-steam-outline::before {
  content: "\\f131a";
}

.mdi-kettlebell::before {
  content: "\\f1300";
}

.mdi-key::before {
  content: "\\f0306";
}

.mdi-key-alert::before {
  content: "\\f1983";
}

.mdi-key-alert-outline::before {
  content: "\\f1984";
}

.mdi-key-arrow-right::before {
  content: "\\f1312";
}

.mdi-key-chain::before {
  content: "\\f1574";
}

.mdi-key-chain-variant::before {
  content: "\\f1575";
}

.mdi-key-change::before {
  content: "\\f0307";
}

.mdi-key-link::before {
  content: "\\f119f";
}

.mdi-key-minus::before {
  content: "\\f0308";
}

.mdi-key-outline::before {
  content: "\\f0dd6";
}

.mdi-key-plus::before {
  content: "\\f0309";
}

.mdi-key-remove::before {
  content: "\\f030a";
}

.mdi-key-star::before {
  content: "\\f119e";
}

.mdi-key-variant::before {
  content: "\\f030b";
}

.mdi-key-wireless::before {
  content: "\\f0fc2";
}

.mdi-keyboard::before {
  content: "\\f030c";
}

.mdi-keyboard-backspace::before {
  content: "\\f030d";
}

.mdi-keyboard-caps::before {
  content: "\\f030e";
}

.mdi-keyboard-close::before {
  content: "\\f030f";
}

.mdi-keyboard-esc::before {
  content: "\\f12b7";
}

.mdi-keyboard-f1::before {
  content: "\\f12ab";
}

.mdi-keyboard-f10::before {
  content: "\\f12b4";
}

.mdi-keyboard-f11::before {
  content: "\\f12b5";
}

.mdi-keyboard-f12::before {
  content: "\\f12b6";
}

.mdi-keyboard-f2::before {
  content: "\\f12ac";
}

.mdi-keyboard-f3::before {
  content: "\\f12ad";
}

.mdi-keyboard-f4::before {
  content: "\\f12ae";
}

.mdi-keyboard-f5::before {
  content: "\\f12af";
}

.mdi-keyboard-f6::before {
  content: "\\f12b0";
}

.mdi-keyboard-f7::before {
  content: "\\f12b1";
}

.mdi-keyboard-f8::before {
  content: "\\f12b2";
}

.mdi-keyboard-f9::before {
  content: "\\f12b3";
}

.mdi-keyboard-off::before {
  content: "\\f0310";
}

.mdi-keyboard-off-outline::before {
  content: "\\f0e4b";
}

.mdi-keyboard-outline::before {
  content: "\\f097b";
}

.mdi-keyboard-return::before {
  content: "\\f0311";
}

.mdi-keyboard-settings::before {
  content: "\\f09f9";
}

.mdi-keyboard-settings-outline::before {
  content: "\\f09fa";
}

.mdi-keyboard-space::before {
  content: "\\f1050";
}

.mdi-keyboard-tab::before {
  content: "\\f0312";
}

.mdi-keyboard-tab-reverse::before {
  content: "\\f0325";
}

.mdi-keyboard-variant::before {
  content: "\\f0313";
}

.mdi-khanda::before {
  content: "\\f10fd";
}

.mdi-kickstarter::before {
  content: "\\f0745";
}

.mdi-kite::before {
  content: "\\f1985";
}

.mdi-kite-outline::before {
  content: "\\f1986";
}

.mdi-kitesurfing::before {
  content: "\\f1744";
}

.mdi-klingon::before {
  content: "\\f135b";
}

.mdi-knife::before {
  content: "\\f09fb";
}

.mdi-knife-military::before {
  content: "\\f09fc";
}

.mdi-koala::before {
  content: "\\f173f";
}

.mdi-kodi::before {
  content: "\\f0314";
}

.mdi-kubernetes::before {
  content: "\\f10fe";
}

.mdi-label::before {
  content: "\\f0315";
}

.mdi-label-multiple::before {
  content: "\\f1375";
}

.mdi-label-multiple-outline::before {
  content: "\\f1376";
}

.mdi-label-off::before {
  content: "\\f0acb";
}

.mdi-label-off-outline::before {
  content: "\\f0acc";
}

.mdi-label-outline::before {
  content: "\\f0316";
}

.mdi-label-percent::before {
  content: "\\f12ea";
}

.mdi-label-percent-outline::before {
  content: "\\f12eb";
}

.mdi-label-variant::before {
  content: "\\f0acd";
}

.mdi-label-variant-outline::before {
  content: "\\f0ace";
}

.mdi-ladder::before {
  content: "\\f15a2";
}

.mdi-ladybug::before {
  content: "\\f082d";
}

.mdi-lambda::before {
  content: "\\f0627";
}

.mdi-lamp::before {
  content: "\\f06b5";
}

.mdi-lamp-outline::before {
  content: "\\f17d0";
}

.mdi-lamps::before {
  content: "\\f1576";
}

.mdi-lamps-outline::before {
  content: "\\f17d1";
}

.mdi-lan::before {
  content: "\\f0317";
}

.mdi-lan-check::before {
  content: "\\f12aa";
}

.mdi-lan-connect::before {
  content: "\\f0318";
}

.mdi-lan-disconnect::before {
  content: "\\f0319";
}

.mdi-lan-pending::before {
  content: "\\f031a";
}

.mdi-language-c::before {
  content: "\\f0671";
}

.mdi-language-cpp::before {
  content: "\\f0672";
}

.mdi-language-csharp::before {
  content: "\\f031b";
}

.mdi-language-css3::before {
  content: "\\f031c";
}

.mdi-language-fortran::before {
  content: "\\f121a";
}

.mdi-language-go::before {
  content: "\\f07d3";
}

.mdi-language-haskell::before {
  content: "\\f0c92";
}

.mdi-language-html5::before {
  content: "\\f031d";
}

.mdi-language-java::before {
  content: "\\f0b37";
}

.mdi-language-javascript::before {
  content: "\\f031e";
}

.mdi-language-kotlin::before {
  content: "\\f1219";
}

.mdi-language-lua::before {
  content: "\\f08b1";
}

.mdi-language-markdown::before {
  content: "\\f0354";
}

.mdi-language-markdown-outline::before {
  content: "\\f0f5b";
}

.mdi-language-php::before {
  content: "\\f031f";
}

.mdi-language-python::before {
  content: "\\f0320";
}

.mdi-language-r::before {
  content: "\\f07d4";
}

.mdi-language-ruby::before {
  content: "\\f0d2d";
}

.mdi-language-ruby-on-rails::before {
  content: "\\f0acf";
}

.mdi-language-rust::before {
  content: "\\f1617";
}

.mdi-language-swift::before {
  content: "\\f06e5";
}

.mdi-language-typescript::before {
  content: "\\f06e6";
}

.mdi-language-xaml::before {
  content: "\\f0673";
}

.mdi-laptop::before {
  content: "\\f0322";
}

.mdi-laptop-off::before {
  content: "\\f06e7";
}

.mdi-laravel::before {
  content: "\\f0ad0";
}

.mdi-laser-pointer::before {
  content: "\\f1484";
}

.mdi-lasso::before {
  content: "\\f0f03";
}

.mdi-lastpass::before {
  content: "\\f0446";
}

.mdi-latitude::before {
  content: "\\f0f57";
}

.mdi-launch::before {
  content: "\\f0327";
}

.mdi-lava-lamp::before {
  content: "\\f07d5";
}

.mdi-layers::before {
  content: "\\f0328";
}

.mdi-layers-edit::before {
  content: "\\f1892";
}

.mdi-layers-minus::before {
  content: "\\f0e4c";
}

.mdi-layers-off::before {
  content: "\\f0329";
}

.mdi-layers-off-outline::before {
  content: "\\f09fd";
}

.mdi-layers-outline::before {
  content: "\\f09fe";
}

.mdi-layers-plus::before {
  content: "\\f0e4d";
}

.mdi-layers-remove::before {
  content: "\\f0e4e";
}

.mdi-layers-search::before {
  content: "\\f1206";
}

.mdi-layers-search-outline::before {
  content: "\\f1207";
}

.mdi-layers-triple::before {
  content: "\\f0f58";
}

.mdi-layers-triple-outline::before {
  content: "\\f0f59";
}

.mdi-lead-pencil::before {
  content: "\\f064f";
}

.mdi-leaf::before {
  content: "\\f032a";
}

.mdi-leaf-circle::before {
  content: "\\f1905";
}

.mdi-leaf-circle-outline::before {
  content: "\\f1906";
}

.mdi-leaf-maple::before {
  content: "\\f0c93";
}

.mdi-leaf-maple-off::before {
  content: "\\f12da";
}

.mdi-leaf-off::before {
  content: "\\f12d9";
}

.mdi-leak::before {
  content: "\\f0dd7";
}

.mdi-leak-off::before {
  content: "\\f0dd8";
}

.mdi-led-off::before {
  content: "\\f032b";
}

.mdi-led-on::before {
  content: "\\f032c";
}

.mdi-led-outline::before {
  content: "\\f032d";
}

.mdi-led-strip::before {
  content: "\\f07d6";
}

.mdi-led-strip-variant::before {
  content: "\\f1051";
}

.mdi-led-variant-off::before {
  content: "\\f032e";
}

.mdi-led-variant-on::before {
  content: "\\f032f";
}

.mdi-led-variant-outline::before {
  content: "\\f0330";
}

.mdi-leek::before {
  content: "\\f117d";
}

.mdi-less-than::before {
  content: "\\f097c";
}

.mdi-less-than-or-equal::before {
  content: "\\f097d";
}

.mdi-library::before {
  content: "\\f0331";
}

.mdi-library-shelves::before {
  content: "\\f0ba9";
}

.mdi-license::before {
  content: "\\f0fc3";
}

.mdi-lifebuoy::before {
  content: "\\f087e";
}

.mdi-light-flood-down::before {
  content: "\\f1987";
}

.mdi-light-flood-up::before {
  content: "\\f1988";
}

.mdi-light-recessed::before {
  content: "\\f179b";
}

.mdi-light-switch::before {
  content: "\\f097e";
}

.mdi-lightbulb::before {
  content: "\\f0335";
}

.mdi-lightbulb-auto::before {
  content: "\\f1800";
}

.mdi-lightbulb-auto-outline::before {
  content: "\\f1801";
}

.mdi-lightbulb-cfl::before {
  content: "\\f1208";
}

.mdi-lightbulb-cfl-off::before {
  content: "\\f1209";
}

.mdi-lightbulb-cfl-spiral::before {
  content: "\\f1275";
}

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\f12c3";
}

.mdi-lightbulb-fluorescent-tube::before {
  content: "\\f1804";
}

.mdi-lightbulb-fluorescent-tube-outline::before {
  content: "\\f1805";
}

.mdi-lightbulb-group::before {
  content: "\\f1253";
}

.mdi-lightbulb-group-off::before {
  content: "\\f12cd";
}

.mdi-lightbulb-group-off-outline::before {
  content: "\\f12ce";
}

.mdi-lightbulb-group-outline::before {
  content: "\\f1254";
}

.mdi-lightbulb-multiple::before {
  content: "\\f1255";
}

.mdi-lightbulb-multiple-off::before {
  content: "\\f12cf";
}

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\f12d0";
}

.mdi-lightbulb-multiple-outline::before {
  content: "\\f1256";
}

.mdi-lightbulb-off::before {
  content: "\\f0e4f";
}

.mdi-lightbulb-off-outline::before {
  content: "\\f0e50";
}

.mdi-lightbulb-on::before {
  content: "\\f06e8";
}

.mdi-lightbulb-on-outline::before {
  content: "\\f06e9";
}

.mdi-lightbulb-outline::before {
  content: "\\f0336";
}

.mdi-lightbulb-spot::before {
  content: "\\f17f4";
}

.mdi-lightbulb-spot-off::before {
  content: "\\f17f5";
}

.mdi-lightbulb-variant::before {
  content: "\\f1802";
}

.mdi-lightbulb-variant-outline::before {
  content: "\\f1803";
}

.mdi-lighthouse::before {
  content: "\\f09ff";
}

.mdi-lighthouse-on::before {
  content: "\\f0a00";
}

.mdi-lightning-bolt::before {
  content: "\\f140b";
}

.mdi-lightning-bolt-circle::before {
  content: "\\f0820";
}

.mdi-lightning-bolt-outline::before {
  content: "\\f140c";
}

.mdi-line-scan::before {
  content: "\\f0624";
}

.mdi-lingerie::before {
  content: "\\f1476";
}

.mdi-link::before {
  content: "\\f0337";
}

.mdi-link-box::before {
  content: "\\f0d1a";
}

.mdi-link-box-outline::before {
  content: "\\f0d1b";
}

.mdi-link-box-variant::before {
  content: "\\f0d1c";
}

.mdi-link-box-variant-outline::before {
  content: "\\f0d1d";
}

.mdi-link-lock::before {
  content: "\\f10ba";
}

.mdi-link-off::before {
  content: "\\f0338";
}

.mdi-link-plus::before {
  content: "\\f0c94";
}

.mdi-link-variant::before {
  content: "\\f0339";
}

.mdi-link-variant-minus::before {
  content: "\\f10ff";
}

.mdi-link-variant-off::before {
  content: "\\f033a";
}

.mdi-link-variant-plus::before {
  content: "\\f1100";
}

.mdi-link-variant-remove::before {
  content: "\\f1101";
}

.mdi-linkedin::before {
  content: "\\f033b";
}

.mdi-linux::before {
  content: "\\f033d";
}

.mdi-linux-mint::before {
  content: "\\f08ed";
}

.mdi-lipstick::before {
  content: "\\f13b5";
}

.mdi-liquid-spot::before {
  content: "\\f1826";
}

.mdi-liquor::before {
  content: "\\f191e";
}

.mdi-list-status::before {
  content: "\\f15ab";
}

.mdi-litecoin::before {
  content: "\\f0a61";
}

.mdi-loading::before {
  content: "\\f0772";
}

.mdi-location-enter::before {
  content: "\\f0fc4";
}

.mdi-location-exit::before {
  content: "\\f0fc5";
}

.mdi-lock::before {
  content: "\\f033e";
}

.mdi-lock-alert::before {
  content: "\\f08ee";
}

.mdi-lock-alert-outline::before {
  content: "\\f15d1";
}

.mdi-lock-check::before {
  content: "\\f139a";
}

.mdi-lock-check-outline::before {
  content: "\\f16a8";
}

.mdi-lock-clock::before {
  content: "\\f097f";
}

.mdi-lock-minus::before {
  content: "\\f16a9";
}

.mdi-lock-minus-outline::before {
  content: "\\f16aa";
}

.mdi-lock-off::before {
  content: "\\f1671";
}

.mdi-lock-off-outline::before {
  content: "\\f1672";
}

.mdi-lock-open::before {
  content: "\\f033f";
}

.mdi-lock-open-alert::before {
  content: "\\f139b";
}

.mdi-lock-open-alert-outline::before {
  content: "\\f15d2";
}

.mdi-lock-open-check::before {
  content: "\\f139c";
}

.mdi-lock-open-check-outline::before {
  content: "\\f16ab";
}

.mdi-lock-open-minus::before {
  content: "\\f16ac";
}

.mdi-lock-open-minus-outline::before {
  content: "\\f16ad";
}

.mdi-lock-open-outline::before {
  content: "\\f0340";
}

.mdi-lock-open-plus::before {
  content: "\\f16ae";
}

.mdi-lock-open-plus-outline::before {
  content: "\\f16af";
}

.mdi-lock-open-remove::before {
  content: "\\f16b0";
}

.mdi-lock-open-remove-outline::before {
  content: "\\f16b1";
}

.mdi-lock-open-variant::before {
  content: "\\f0fc6";
}

.mdi-lock-open-variant-outline::before {
  content: "\\f0fc7";
}

.mdi-lock-outline::before {
  content: "\\f0341";
}

.mdi-lock-pattern::before {
  content: "\\f06ea";
}

.mdi-lock-plus::before {
  content: "\\f05fb";
}

.mdi-lock-plus-outline::before {
  content: "\\f16b2";
}

.mdi-lock-question::before {
  content: "\\f08ef";
}

.mdi-lock-remove::before {
  content: "\\f16b3";
}

.mdi-lock-remove-outline::before {
  content: "\\f16b4";
}

.mdi-lock-reset::before {
  content: "\\f0773";
}

.mdi-lock-smart::before {
  content: "\\f08b2";
}

.mdi-locker::before {
  content: "\\f07d7";
}

.mdi-locker-multiple::before {
  content: "\\f07d8";
}

.mdi-login::before {
  content: "\\f0342";
}

.mdi-login-variant::before {
  content: "\\f05fc";
}

.mdi-logout::before {
  content: "\\f0343";
}

.mdi-logout-variant::before {
  content: "\\f05fd";
}

.mdi-longitude::before {
  content: "\\f0f5a";
}

.mdi-looks::before {
  content: "\\f0344";
}

.mdi-lotion::before {
  content: "\\f1582";
}

.mdi-lotion-outline::before {
  content: "\\f1583";
}

.mdi-lotion-plus::before {
  content: "\\f1584";
}

.mdi-lotion-plus-outline::before {
  content: "\\f1585";
}

.mdi-loupe::before {
  content: "\\f0345";
}

.mdi-lumx::before {
  content: "\\f0346";
}

.mdi-lungs::before {
  content: "\\f1084";
}

.mdi-mace::before {
  content: "\\f1843";
}

.mdi-magazine-pistol::before {
  content: "\\f0324";
}

.mdi-magazine-rifle::before {
  content: "\\f0323";
}

.mdi-magic-staff::before {
  content: "\\f1844";
}

.mdi-magnet::before {
  content: "\\f0347";
}

.mdi-magnet-on::before {
  content: "\\f0348";
}

.mdi-magnify::before {
  content: "\\f0349";
}

.mdi-magnify-close::before {
  content: "\\f0980";
}

.mdi-magnify-expand::before {
  content: "\\f1874";
}

.mdi-magnify-minus::before {
  content: "\\f034a";
}

.mdi-magnify-minus-cursor::before {
  content: "\\f0a62";
}

.mdi-magnify-minus-outline::before {
  content: "\\f06ec";
}

.mdi-magnify-plus::before {
  content: "\\f034b";
}

.mdi-magnify-plus-cursor::before {
  content: "\\f0a63";
}

.mdi-magnify-plus-outline::before {
  content: "\\f06ed";
}

.mdi-magnify-remove-cursor::before {
  content: "\\f120c";
}

.mdi-magnify-remove-outline::before {
  content: "\\f120d";
}

.mdi-magnify-scan::before {
  content: "\\f1276";
}

.mdi-mail::before {
  content: "\\f0ebb";
}

.mdi-mailbox::before {
  content: "\\f06ee";
}

.mdi-mailbox-open::before {
  content: "\\f0d88";
}

.mdi-mailbox-open-outline::before {
  content: "\\f0d89";
}

.mdi-mailbox-open-up::before {
  content: "\\f0d8a";
}

.mdi-mailbox-open-up-outline::before {
  content: "\\f0d8b";
}

.mdi-mailbox-outline::before {
  content: "\\f0d8c";
}

.mdi-mailbox-up::before {
  content: "\\f0d8d";
}

.mdi-mailbox-up-outline::before {
  content: "\\f0d8e";
}

.mdi-manjaro::before {
  content: "\\f160a";
}

.mdi-map::before {
  content: "\\f034d";
}

.mdi-map-check::before {
  content: "\\f0ebc";
}

.mdi-map-check-outline::before {
  content: "\\f0ebd";
}

.mdi-map-clock::before {
  content: "\\f0d1e";
}

.mdi-map-clock-outline::before {
  content: "\\f0d1f";
}

.mdi-map-legend::before {
  content: "\\f0a01";
}

.mdi-map-marker::before {
  content: "\\f034e";
}

.mdi-map-marker-account::before {
  content: "\\f18e3";
}

.mdi-map-marker-account-outline::before {
  content: "\\f18e4";
}

.mdi-map-marker-alert::before {
  content: "\\f0f05";
}

.mdi-map-marker-alert-outline::before {
  content: "\\f0f06";
}

.mdi-map-marker-check::before {
  content: "\\f0c95";
}

.mdi-map-marker-check-outline::before {
  content: "\\f12fb";
}

.mdi-map-marker-circle::before {
  content: "\\f034f";
}

.mdi-map-marker-distance::before {
  content: "\\f08f0";
}

.mdi-map-marker-down::before {
  content: "\\f1102";
}

.mdi-map-marker-left::before {
  content: "\\f12db";
}

.mdi-map-marker-left-outline::before {
  content: "\\f12dd";
}

.mdi-map-marker-minus::before {
  content: "\\f0650";
}

.mdi-map-marker-minus-outline::before {
  content: "\\f12f9";
}

.mdi-map-marker-multiple::before {
  content: "\\f0350";
}

.mdi-map-marker-multiple-outline::before {
  content: "\\f1277";
}

.mdi-map-marker-off::before {
  content: "\\f0351";
}

.mdi-map-marker-off-outline::before {
  content: "\\f12fd";
}

.mdi-map-marker-outline::before {
  content: "\\f07d9";
}

.mdi-map-marker-path::before {
  content: "\\f0d20";
}

.mdi-map-marker-plus::before {
  content: "\\f0651";
}

.mdi-map-marker-plus-outline::before {
  content: "\\f12f8";
}

.mdi-map-marker-question::before {
  content: "\\f0f07";
}

.mdi-map-marker-question-outline::before {
  content: "\\f0f08";
}

.mdi-map-marker-radius::before {
  content: "\\f0352";
}

.mdi-map-marker-radius-outline::before {
  content: "\\f12fc";
}

.mdi-map-marker-remove::before {
  content: "\\f0f09";
}

.mdi-map-marker-remove-outline::before {
  content: "\\f12fa";
}

.mdi-map-marker-remove-variant::before {
  content: "\\f0f0a";
}

.mdi-map-marker-right::before {
  content: "\\f12dc";
}

.mdi-map-marker-right-outline::before {
  content: "\\f12de";
}

.mdi-map-marker-star::before {
  content: "\\f1608";
}

.mdi-map-marker-star-outline::before {
  content: "\\f1609";
}

.mdi-map-marker-up::before {
  content: "\\f1103";
}

.mdi-map-minus::before {
  content: "\\f0981";
}

.mdi-map-outline::before {
  content: "\\f0982";
}

.mdi-map-plus::before {
  content: "\\f0983";
}

.mdi-map-search::before {
  content: "\\f0984";
}

.mdi-map-search-outline::before {
  content: "\\f0985";
}

.mdi-mapbox::before {
  content: "\\f0baa";
}

.mdi-margin::before {
  content: "\\f0353";
}

.mdi-marker::before {
  content: "\\f0652";
}

.mdi-marker-cancel::before {
  content: "\\f0dd9";
}

.mdi-marker-check::before {
  content: "\\f0355";
}

.mdi-mastodon::before {
  content: "\\f0ad1";
}

.mdi-material-design::before {
  content: "\\f0986";
}

.mdi-material-ui::before {
  content: "\\f0357";
}

.mdi-math-compass::before {
  content: "\\f0358";
}

.mdi-math-cos::before {
  content: "\\f0c96";
}

.mdi-math-integral::before {
  content: "\\f0fc8";
}

.mdi-math-integral-box::before {
  content: "\\f0fc9";
}

.mdi-math-log::before {
  content: "\\f1085";
}

.mdi-math-norm::before {
  content: "\\f0fca";
}

.mdi-math-norm-box::before {
  content: "\\f0fcb";
}

.mdi-math-sin::before {
  content: "\\f0c97";
}

.mdi-math-tan::before {
  content: "\\f0c98";
}

.mdi-matrix::before {
  content: "\\f0628";
}

.mdi-medal::before {
  content: "\\f0987";
}

.mdi-medal-outline::before {
  content: "\\f1326";
}

.mdi-medical-bag::before {
  content: "\\f06ef";
}

.mdi-meditation::before {
  content: "\\f117b";
}

.mdi-memory::before {
  content: "\\f035b";
}

.mdi-menorah::before {
  content: "\\f17d4";
}

.mdi-menorah-fire::before {
  content: "\\f17d5";
}

.mdi-menu::before {
  content: "\\f035c";
}

.mdi-menu-down::before {
  content: "\\f035d";
}

.mdi-menu-down-outline::before {
  content: "\\f06b6";
}

.mdi-menu-left::before {
  content: "\\f035e";
}

.mdi-menu-left-outline::before {
  content: "\\f0a02";
}

.mdi-menu-open::before {
  content: "\\f0bab";
}

.mdi-menu-right::before {
  content: "\\f035f";
}

.mdi-menu-right-outline::before {
  content: "\\f0a03";
}

.mdi-menu-swap::before {
  content: "\\f0a64";
}

.mdi-menu-swap-outline::before {
  content: "\\f0a65";
}

.mdi-menu-up::before {
  content: "\\f0360";
}

.mdi-menu-up-outline::before {
  content: "\\f06b7";
}

.mdi-merge::before {
  content: "\\f0f5c";
}

.mdi-message::before {
  content: "\\f0361";
}

.mdi-message-alert::before {
  content: "\\f0362";
}

.mdi-message-alert-outline::before {
  content: "\\f0a04";
}

.mdi-message-arrow-left::before {
  content: "\\f12f2";
}

.mdi-message-arrow-left-outline::before {
  content: "\\f12f3";
}

.mdi-message-arrow-right::before {
  content: "\\f12f4";
}

.mdi-message-arrow-right-outline::before {
  content: "\\f12f5";
}

.mdi-message-badge::before {
  content: "\\f1941";
}

.mdi-message-badge-outline::before {
  content: "\\f1942";
}

.mdi-message-bookmark::before {
  content: "\\f15ac";
}

.mdi-message-bookmark-outline::before {
  content: "\\f15ad";
}

.mdi-message-bulleted::before {
  content: "\\f06a2";
}

.mdi-message-bulleted-off::before {
  content: "\\f06a3";
}

.mdi-message-cog::before {
  content: "\\f06f1";
}

.mdi-message-cog-outline::before {
  content: "\\f1172";
}

.mdi-message-draw::before {
  content: "\\f0363";
}

.mdi-message-flash::before {
  content: "\\f15a9";
}

.mdi-message-flash-outline::before {
  content: "\\f15aa";
}

.mdi-message-image::before {
  content: "\\f0364";
}

.mdi-message-image-outline::before {
  content: "\\f116c";
}

.mdi-message-lock::before {
  content: "\\f0fcc";
}

.mdi-message-lock-outline::before {
  content: "\\f116d";
}

.mdi-message-minus::before {
  content: "\\f116e";
}

.mdi-message-minus-outline::before {
  content: "\\f116f";
}

.mdi-message-off::before {
  content: "\\f164d";
}

.mdi-message-off-outline::before {
  content: "\\f164e";
}

.mdi-message-outline::before {
  content: "\\f0365";
}

.mdi-message-plus::before {
  content: "\\f0653";
}

.mdi-message-plus-outline::before {
  content: "\\f10bb";
}

.mdi-message-processing::before {
  content: "\\f0366";
}

.mdi-message-processing-outline::before {
  content: "\\f1170";
}

.mdi-message-question::before {
  content: "\\f173a";
}

.mdi-message-question-outline::before {
  content: "\\f173b";
}

.mdi-message-reply::before {
  content: "\\f0367";
}

.mdi-message-reply-outline::before {
  content: "\\f173d";
}

.mdi-message-reply-text::before {
  content: "\\f0368";
}

.mdi-message-reply-text-outline::before {
  content: "\\f173e";
}

.mdi-message-settings::before {
  content: "\\f06f0";
}

.mdi-message-settings-outline::before {
  content: "\\f1171";
}

.mdi-message-star::before {
  content: "\\f069a";
}

.mdi-message-star-outline::before {
  content: "\\f1250";
}

.mdi-message-text::before {
  content: "\\f0369";
}

.mdi-message-text-clock::before {
  content: "\\f1173";
}

.mdi-message-text-clock-outline::before {
  content: "\\f1174";
}

.mdi-message-text-lock::before {
  content: "\\f0fcd";
}

.mdi-message-text-lock-outline::before {
  content: "\\f1175";
}

.mdi-message-text-outline::before {
  content: "\\f036a";
}

.mdi-message-video::before {
  content: "\\f036b";
}

.mdi-meteor::before {
  content: "\\f0629";
}

.mdi-metronome::before {
  content: "\\f07da";
}

.mdi-metronome-tick::before {
  content: "\\f07db";
}

.mdi-micro-sd::before {
  content: "\\f07dc";
}

.mdi-microphone::before {
  content: "\\f036c";
}

.mdi-microphone-minus::before {
  content: "\\f08b3";
}

.mdi-microphone-off::before {
  content: "\\f036d";
}

.mdi-microphone-outline::before {
  content: "\\f036e";
}

.mdi-microphone-plus::before {
  content: "\\f08b4";
}

.mdi-microphone-question::before {
  content: "\\f1989";
}

.mdi-microphone-question-outline::before {
  content: "\\f198a";
}

.mdi-microphone-settings::before {
  content: "\\f036f";
}

.mdi-microphone-variant::before {
  content: "\\f0370";
}

.mdi-microphone-variant-off::before {
  content: "\\f0371";
}

.mdi-microscope::before {
  content: "\\f0654";
}

.mdi-microsoft::before {
  content: "\\f0372";
}

.mdi-microsoft-access::before {
  content: "\\f138e";
}

.mdi-microsoft-azure::before {
  content: "\\f0805";
}

.mdi-microsoft-azure-devops::before {
  content: "\\f0fd5";
}

.mdi-microsoft-bing::before {
  content: "\\f00a4";
}

.mdi-microsoft-dynamics-365::before {
  content: "\\f0988";
}

.mdi-microsoft-edge::before {
  content: "\\f01e9";
}

.mdi-microsoft-excel::before {
  content: "\\f138f";
}

.mdi-microsoft-internet-explorer::before {
  content: "\\f0300";
}

.mdi-microsoft-office::before {
  content: "\\f03c6";
}

.mdi-microsoft-onedrive::before {
  content: "\\f03ca";
}

.mdi-microsoft-onenote::before {
  content: "\\f0747";
}

.mdi-microsoft-outlook::before {
  content: "\\f0d22";
}

.mdi-microsoft-powerpoint::before {
  content: "\\f1390";
}

.mdi-microsoft-sharepoint::before {
  content: "\\f1391";
}

.mdi-microsoft-teams::before {
  content: "\\f02bb";
}

.mdi-microsoft-visual-studio::before {
  content: "\\f0610";
}

.mdi-microsoft-visual-studio-code::before {
  content: "\\f0a1e";
}

.mdi-microsoft-windows::before {
  content: "\\f05b3";
}

.mdi-microsoft-windows-classic::before {
  content: "\\f0a21";
}

.mdi-microsoft-word::before {
  content: "\\f1392";
}

.mdi-microsoft-xbox::before {
  content: "\\f05b9";
}

.mdi-microsoft-xbox-controller::before {
  content: "\\f05ba";
}

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\f074b";
}

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\f0a22";
}

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\f074c";
}

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\f074d";
}

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\f074e";
}

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\f074f";
}

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\f0750";
}

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\f0e6f";
}

.mdi-microsoft-xbox-controller-off::before {
  content: "\\f05bb";
}

.mdi-microsoft-xbox-controller-view::before {
  content: "\\f0e70";
}

.mdi-microwave::before {
  content: "\\f0c99";
}

.mdi-microwave-off::before {
  content: "\\f1423";
}

.mdi-middleware::before {
  content: "\\f0f5d";
}

.mdi-middleware-outline::before {
  content: "\\f0f5e";
}

.mdi-midi::before {
  content: "\\f08f1";
}

.mdi-midi-port::before {
  content: "\\f08f2";
}

.mdi-mine::before {
  content: "\\f0dda";
}

.mdi-minecraft::before {
  content: "\\f0373";
}

.mdi-mini-sd::before {
  content: "\\f0a05";
}

.mdi-minidisc::before {
  content: "\\f0a06";
}

.mdi-minus::before {
  content: "\\f0374";
}

.mdi-minus-box::before {
  content: "\\f0375";
}

.mdi-minus-box-multiple::before {
  content: "\\f1141";
}

.mdi-minus-box-multiple-outline::before {
  content: "\\f1142";
}

.mdi-minus-box-outline::before {
  content: "\\f06f2";
}

.mdi-minus-circle::before {
  content: "\\f0376";
}

.mdi-minus-circle-multiple::before {
  content: "\\f035a";
}

.mdi-minus-circle-multiple-outline::before {
  content: "\\f0ad3";
}

.mdi-minus-circle-off::before {
  content: "\\f1459";
}

.mdi-minus-circle-off-outline::before {
  content: "\\f145a";
}

.mdi-minus-circle-outline::before {
  content: "\\f0377";
}

.mdi-minus-network::before {
  content: "\\f0378";
}

.mdi-minus-network-outline::before {
  content: "\\f0c9a";
}

.mdi-minus-thick::before {
  content: "\\f1639";
}

.mdi-mirror::before {
  content: "\\f11fd";
}

.mdi-mirror-rectangle::before {
  content: "\\f179f";
}

.mdi-mirror-variant::before {
  content: "\\f17a0";
}

.mdi-mixed-martial-arts::before {
  content: "\\f0d8f";
}

.mdi-mixed-reality::before {
  content: "\\f087f";
}

.mdi-molecule::before {
  content: "\\f0bac";
}

.mdi-molecule-co::before {
  content: "\\f12fe";
}

.mdi-molecule-co2::before {
  content: "\\f07e4";
}

.mdi-monitor::before {
  content: "\\f0379";
}

.mdi-monitor-cellphone::before {
  content: "\\f0989";
}

.mdi-monitor-cellphone-star::before {
  content: "\\f098a";
}

.mdi-monitor-dashboard::before {
  content: "\\f0a07";
}

.mdi-monitor-edit::before {
  content: "\\f12c6";
}

.mdi-monitor-eye::before {
  content: "\\f13b4";
}

.mdi-monitor-lock::before {
  content: "\\f0ddb";
}

.mdi-monitor-multiple::before {
  content: "\\f037a";
}

.mdi-monitor-off::before {
  content: "\\f0d90";
}

.mdi-monitor-screenshot::before {
  content: "\\f0e51";
}

.mdi-monitor-share::before {
  content: "\\f1483";
}

.mdi-monitor-shimmer::before {
  content: "\\f1104";
}

.mdi-monitor-small::before {
  content: "\\f1876";
}

.mdi-monitor-speaker::before {
  content: "\\f0f5f";
}

.mdi-monitor-speaker-off::before {
  content: "\\f0f60";
}

.mdi-monitor-star::before {
  content: "\\f0ddc";
}

.mdi-moon-first-quarter::before {
  content: "\\f0f61";
}

.mdi-moon-full::before {
  content: "\\f0f62";
}

.mdi-moon-last-quarter::before {
  content: "\\f0f63";
}

.mdi-moon-new::before {
  content: "\\f0f64";
}

.mdi-moon-waning-crescent::before {
  content: "\\f0f65";
}

.mdi-moon-waning-gibbous::before {
  content: "\\f0f66";
}

.mdi-moon-waxing-crescent::before {
  content: "\\f0f67";
}

.mdi-moon-waxing-gibbous::before {
  content: "\\f0f68";
}

.mdi-moped::before {
  content: "\\f1086";
}

.mdi-moped-electric::before {
  content: "\\f15b7";
}

.mdi-moped-electric-outline::before {
  content: "\\f15b8";
}

.mdi-moped-outline::before {
  content: "\\f15b9";
}

.mdi-more::before {
  content: "\\f037b";
}

.mdi-mortar-pestle::before {
  content: "\\f1748";
}

.mdi-mortar-pestle-plus::before {
  content: "\\f03f1";
}

.mdi-mosque::before {
  content: "\\f1827";
}

.mdi-mother-heart::before {
  content: "\\f1314";
}

.mdi-mother-nurse::before {
  content: "\\f0d21";
}

.mdi-motion::before {
  content: "\\f15b2";
}

.mdi-motion-outline::before {
  content: "\\f15b3";
}

.mdi-motion-pause::before {
  content: "\\f1590";
}

.mdi-motion-pause-outline::before {
  content: "\\f1592";
}

.mdi-motion-play::before {
  content: "\\f158f";
}

.mdi-motion-play-outline::before {
  content: "\\f1591";
}

.mdi-motion-sensor::before {
  content: "\\f0d91";
}

.mdi-motion-sensor-off::before {
  content: "\\f1435";
}

.mdi-motorbike::before {
  content: "\\f037c";
}

.mdi-motorbike-electric::before {
  content: "\\f15ba";
}

.mdi-mouse::before {
  content: "\\f037d";
}

.mdi-mouse-bluetooth::before {
  content: "\\f098b";
}

.mdi-mouse-move-down::before {
  content: "\\f1550";
}

.mdi-mouse-move-up::before {
  content: "\\f1551";
}

.mdi-mouse-move-vertical::before {
  content: "\\f1552";
}

.mdi-mouse-off::before {
  content: "\\f037e";
}

.mdi-mouse-variant::before {
  content: "\\f037f";
}

.mdi-mouse-variant-off::before {
  content: "\\f0380";
}

.mdi-move-resize::before {
  content: "\\f0655";
}

.mdi-move-resize-variant::before {
  content: "\\f0656";
}

.mdi-movie::before {
  content: "\\f0381";
}

.mdi-movie-check::before {
  content: "\\f16f3";
}

.mdi-movie-check-outline::before {
  content: "\\f16f4";
}

.mdi-movie-cog::before {
  content: "\\f16f5";
}

.mdi-movie-cog-outline::before {
  content: "\\f16f6";
}

.mdi-movie-edit::before {
  content: "\\f1122";
}

.mdi-movie-edit-outline::before {
  content: "\\f1123";
}

.mdi-movie-filter::before {
  content: "\\f1124";
}

.mdi-movie-filter-outline::before {
  content: "\\f1125";
}

.mdi-movie-minus::before {
  content: "\\f16f7";
}

.mdi-movie-minus-outline::before {
  content: "\\f16f8";
}

.mdi-movie-off::before {
  content: "\\f16f9";
}

.mdi-movie-off-outline::before {
  content: "\\f16fa";
}

.mdi-movie-open::before {
  content: "\\f0fce";
}

.mdi-movie-open-check::before {
  content: "\\f16fb";
}

.mdi-movie-open-check-outline::before {
  content: "\\f16fc";
}

.mdi-movie-open-cog::before {
  content: "\\f16fd";
}

.mdi-movie-open-cog-outline::before {
  content: "\\f16fe";
}

.mdi-movie-open-edit::before {
  content: "\\f16ff";
}

.mdi-movie-open-edit-outline::before {
  content: "\\f1700";
}

.mdi-movie-open-minus::before {
  content: "\\f1701";
}

.mdi-movie-open-minus-outline::before {
  content: "\\f1702";
}

.mdi-movie-open-off::before {
  content: "\\f1703";
}

.mdi-movie-open-off-outline::before {
  content: "\\f1704";
}

.mdi-movie-open-outline::before {
  content: "\\f0fcf";
}

.mdi-movie-open-play::before {
  content: "\\f1705";
}

.mdi-movie-open-play-outline::before {
  content: "\\f1706";
}

.mdi-movie-open-plus::before {
  content: "\\f1707";
}

.mdi-movie-open-plus-outline::before {
  content: "\\f1708";
}

.mdi-movie-open-remove::before {
  content: "\\f1709";
}

.mdi-movie-open-remove-outline::before {
  content: "\\f170a";
}

.mdi-movie-open-settings::before {
  content: "\\f170b";
}

.mdi-movie-open-settings-outline::before {
  content: "\\f170c";
}

.mdi-movie-open-star::before {
  content: "\\f170d";
}

.mdi-movie-open-star-outline::before {
  content: "\\f170e";
}

.mdi-movie-outline::before {
  content: "\\f0ddd";
}

.mdi-movie-play::before {
  content: "\\f170f";
}

.mdi-movie-play-outline::before {
  content: "\\f1710";
}

.mdi-movie-plus::before {
  content: "\\f1711";
}

.mdi-movie-plus-outline::before {
  content: "\\f1712";
}

.mdi-movie-remove::before {
  content: "\\f1713";
}

.mdi-movie-remove-outline::before {
  content: "\\f1714";
}

.mdi-movie-roll::before {
  content: "\\f07de";
}

.mdi-movie-search::before {
  content: "\\f11d2";
}

.mdi-movie-search-outline::before {
  content: "\\f11d3";
}

.mdi-movie-settings::before {
  content: "\\f1715";
}

.mdi-movie-settings-outline::before {
  content: "\\f1716";
}

.mdi-movie-star::before {
  content: "\\f1717";
}

.mdi-movie-star-outline::before {
  content: "\\f1718";
}

.mdi-mower::before {
  content: "\\f166f";
}

.mdi-mower-bag::before {
  content: "\\f1670";
}

.mdi-muffin::before {
  content: "\\f098c";
}

.mdi-multicast::before {
  content: "\\f1893";
}

.mdi-multiplication::before {
  content: "\\f0382";
}

.mdi-multiplication-box::before {
  content: "\\f0383";
}

.mdi-mushroom::before {
  content: "\\f07df";
}

.mdi-mushroom-off::before {
  content: "\\f13fa";
}

.mdi-mushroom-off-outline::before {
  content: "\\f13fb";
}

.mdi-mushroom-outline::before {
  content: "\\f07e0";
}

.mdi-music::before {
  content: "\\f075a";
}

.mdi-music-accidental-double-flat::before {
  content: "\\f0f69";
}

.mdi-music-accidental-double-sharp::before {
  content: "\\f0f6a";
}

.mdi-music-accidental-flat::before {
  content: "\\f0f6b";
}

.mdi-music-accidental-natural::before {
  content: "\\f0f6c";
}

.mdi-music-accidental-sharp::before {
  content: "\\f0f6d";
}

.mdi-music-box::before {
  content: "\\f0384";
}

.mdi-music-box-multiple::before {
  content: "\\f0333";
}

.mdi-music-box-multiple-outline::before {
  content: "\\f0f04";
}

.mdi-music-box-outline::before {
  content: "\\f0385";
}

.mdi-music-circle::before {
  content: "\\f0386";
}

.mdi-music-circle-outline::before {
  content: "\\f0ad4";
}

.mdi-music-clef-alto::before {
  content: "\\f0f6e";
}

.mdi-music-clef-bass::before {
  content: "\\f0f6f";
}

.mdi-music-clef-treble::before {
  content: "\\f0f70";
}

.mdi-music-note::before {
  content: "\\f0387";
}

.mdi-music-note-bluetooth::before {
  content: "\\f05fe";
}

.mdi-music-note-bluetooth-off::before {
  content: "\\f05ff";
}

.mdi-music-note-eighth::before {
  content: "\\f0388";
}

.mdi-music-note-eighth-dotted::before {
  content: "\\f0f71";
}

.mdi-music-note-half::before {
  content: "\\f0389";
}

.mdi-music-note-half-dotted::before {
  content: "\\f0f72";
}

.mdi-music-note-off::before {
  content: "\\f038a";
}

.mdi-music-note-off-outline::before {
  content: "\\f0f73";
}

.mdi-music-note-outline::before {
  content: "\\f0f74";
}

.mdi-music-note-plus::before {
  content: "\\f0dde";
}

.mdi-music-note-quarter::before {
  content: "\\f038b";
}

.mdi-music-note-quarter-dotted::before {
  content: "\\f0f75";
}

.mdi-music-note-sixteenth::before {
  content: "\\f038c";
}

.mdi-music-note-sixteenth-dotted::before {
  content: "\\f0f76";
}

.mdi-music-note-whole::before {
  content: "\\f038d";
}

.mdi-music-note-whole-dotted::before {
  content: "\\f0f77";
}

.mdi-music-off::before {
  content: "\\f075b";
}

.mdi-music-rest-eighth::before {
  content: "\\f0f78";
}

.mdi-music-rest-half::before {
  content: "\\f0f79";
}

.mdi-music-rest-quarter::before {
  content: "\\f0f7a";
}

.mdi-music-rest-sixteenth::before {
  content: "\\f0f7b";
}

.mdi-music-rest-whole::before {
  content: "\\f0f7c";
}

.mdi-mustache::before {
  content: "\\f15de";
}

.mdi-nail::before {
  content: "\\f0ddf";
}

.mdi-nas::before {
  content: "\\f08f3";
}

.mdi-nativescript::before {
  content: "\\f0880";
}

.mdi-nature::before {
  content: "\\f038e";
}

.mdi-nature-people::before {
  content: "\\f038f";
}

.mdi-navigation::before {
  content: "\\f0390";
}

.mdi-navigation-outline::before {
  content: "\\f1607";
}

.mdi-navigation-variant::before {
  content: "\\f18f0";
}

.mdi-navigation-variant-outline::before {
  content: "\\f18f1";
}

.mdi-near-me::before {
  content: "\\f05cd";
}

.mdi-necklace::before {
  content: "\\f0f0b";
}

.mdi-needle::before {
  content: "\\f0391";
}

.mdi-netflix::before {
  content: "\\f0746";
}

.mdi-network::before {
  content: "\\f06f3";
}

.mdi-network-off::before {
  content: "\\f0c9b";
}

.mdi-network-off-outline::before {
  content: "\\f0c9c";
}

.mdi-network-outline::before {
  content: "\\f0c9d";
}

.mdi-network-strength-1::before {
  content: "\\f08f4";
}

.mdi-network-strength-1-alert::before {
  content: "\\f08f5";
}

.mdi-network-strength-2::before {
  content: "\\f08f6";
}

.mdi-network-strength-2-alert::before {
  content: "\\f08f7";
}

.mdi-network-strength-3::before {
  content: "\\f08f8";
}

.mdi-network-strength-3-alert::before {
  content: "\\f08f9";
}

.mdi-network-strength-4::before {
  content: "\\f08fa";
}

.mdi-network-strength-4-alert::before {
  content: "\\f08fb";
}

.mdi-network-strength-4-cog::before {
  content: "\\f191a";
}

.mdi-network-strength-off::before {
  content: "\\f08fc";
}

.mdi-network-strength-off-outline::before {
  content: "\\f08fd";
}

.mdi-network-strength-outline::before {
  content: "\\f08fe";
}

.mdi-new-box::before {
  content: "\\f0394";
}

.mdi-newspaper::before {
  content: "\\f0395";
}

.mdi-newspaper-check::before {
  content: "\\f1943";
}

.mdi-newspaper-minus::before {
  content: "\\f0f0c";
}

.mdi-newspaper-plus::before {
  content: "\\f0f0d";
}

.mdi-newspaper-remove::before {
  content: "\\f1944";
}

.mdi-newspaper-variant::before {
  content: "\\f1001";
}

.mdi-newspaper-variant-multiple::before {
  content: "\\f1002";
}

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\f1003";
}

.mdi-newspaper-variant-outline::before {
  content: "\\f1004";
}

.mdi-nfc::before {
  content: "\\f0396";
}

.mdi-nfc-search-variant::before {
  content: "\\f0e53";
}

.mdi-nfc-tap::before {
  content: "\\f0397";
}

.mdi-nfc-variant::before {
  content: "\\f0398";
}

.mdi-nfc-variant-off::before {
  content: "\\f0e54";
}

.mdi-ninja::before {
  content: "\\f0774";
}

.mdi-nintendo-game-boy::before {
  content: "\\f1393";
}

.mdi-nintendo-switch::before {
  content: "\\f07e1";
}

.mdi-nintendo-wii::before {
  content: "\\f05ab";
}

.mdi-nintendo-wiiu::before {
  content: "\\f072d";
}

.mdi-nix::before {
  content: "\\f1105";
}

.mdi-nodejs::before {
  content: "\\f0399";
}

.mdi-noodles::before {
  content: "\\f117e";
}

.mdi-not-equal::before {
  content: "\\f098d";
}

.mdi-not-equal-variant::before {
  content: "\\f098e";
}

.mdi-note::before {
  content: "\\f039a";
}

.mdi-note-alert::before {
  content: "\\f177d";
}

.mdi-note-alert-outline::before {
  content: "\\f177e";
}

.mdi-note-check::before {
  content: "\\f177f";
}

.mdi-note-check-outline::before {
  content: "\\f1780";
}

.mdi-note-edit::before {
  content: "\\f1781";
}

.mdi-note-edit-outline::before {
  content: "\\f1782";
}

.mdi-note-minus::before {
  content: "\\f164f";
}

.mdi-note-minus-outline::before {
  content: "\\f1650";
}

.mdi-note-multiple::before {
  content: "\\f06b8";
}

.mdi-note-multiple-outline::before {
  content: "\\f06b9";
}

.mdi-note-off::before {
  content: "\\f1783";
}

.mdi-note-off-outline::before {
  content: "\\f1784";
}

.mdi-note-outline::before {
  content: "\\f039b";
}

.mdi-note-plus::before {
  content: "\\f039c";
}

.mdi-note-plus-outline::before {
  content: "\\f039d";
}

.mdi-note-remove::before {
  content: "\\f1651";
}

.mdi-note-remove-outline::before {
  content: "\\f1652";
}

.mdi-note-search::before {
  content: "\\f1653";
}

.mdi-note-search-outline::before {
  content: "\\f1654";
}

.mdi-note-text::before {
  content: "\\f039e";
}

.mdi-note-text-outline::before {
  content: "\\f11d7";
}

.mdi-notebook::before {
  content: "\\f082e";
}

.mdi-notebook-check::before {
  content: "\\f14f5";
}

.mdi-notebook-check-outline::before {
  content: "\\f14f6";
}

.mdi-notebook-edit::before {
  content: "\\f14e7";
}

.mdi-notebook-edit-outline::before {
  content: "\\f14e9";
}

.mdi-notebook-minus::before {
  content: "\\f1610";
}

.mdi-notebook-minus-outline::before {
  content: "\\f1611";
}

.mdi-notebook-multiple::before {
  content: "\\f0e55";
}

.mdi-notebook-outline::before {
  content: "\\f0ebf";
}

.mdi-notebook-plus::before {
  content: "\\f1612";
}

.mdi-notebook-plus-outline::before {
  content: "\\f1613";
}

.mdi-notebook-remove::before {
  content: "\\f1614";
}

.mdi-notebook-remove-outline::before {
  content: "\\f1615";
}

.mdi-notification-clear-all::before {
  content: "\\f039f";
}

.mdi-npm::before {
  content: "\\f06f7";
}

.mdi-nuke::before {
  content: "\\f06a4";
}

.mdi-null::before {
  content: "\\f07e2";
}

.mdi-numeric::before {
  content: "\\f03a0";
}

.mdi-numeric-0::before {
  content: "\\f0b39";
}

.mdi-numeric-0-box::before {
  content: "\\f03a1";
}

.mdi-numeric-0-box-multiple::before {
  content: "\\f0f0e";
}

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\f03a2";
}

.mdi-numeric-0-box-outline::before {
  content: "\\f03a3";
}

.mdi-numeric-0-circle::before {
  content: "\\f0c9e";
}

.mdi-numeric-0-circle-outline::before {
  content: "\\f0c9f";
}

.mdi-numeric-1::before {
  content: "\\f0b3a";
}

.mdi-numeric-1-box::before {
  content: "\\f03a4";
}

.mdi-numeric-1-box-multiple::before {
  content: "\\f0f0f";
}

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\f03a5";
}

.mdi-numeric-1-box-outline::before {
  content: "\\f03a6";
}

.mdi-numeric-1-circle::before {
  content: "\\f0ca0";
}

.mdi-numeric-1-circle-outline::before {
  content: "\\f0ca1";
}

.mdi-numeric-10::before {
  content: "\\f0fe9";
}

.mdi-numeric-10-box::before {
  content: "\\f0f7d";
}

.mdi-numeric-10-box-multiple::before {
  content: "\\f0fea";
}

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\f0feb";
}

.mdi-numeric-10-box-outline::before {
  content: "\\f0f7e";
}

.mdi-numeric-10-circle::before {
  content: "\\f0fec";
}

.mdi-numeric-10-circle-outline::before {
  content: "\\f0fed";
}

.mdi-numeric-2::before {
  content: "\\f0b3b";
}

.mdi-numeric-2-box::before {
  content: "\\f03a7";
}

.mdi-numeric-2-box-multiple::before {
  content: "\\f0f10";
}

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\f03a8";
}

.mdi-numeric-2-box-outline::before {
  content: "\\f03a9";
}

.mdi-numeric-2-circle::before {
  content: "\\f0ca2";
}

.mdi-numeric-2-circle-outline::before {
  content: "\\f0ca3";
}

.mdi-numeric-3::before {
  content: "\\f0b3c";
}

.mdi-numeric-3-box::before {
  content: "\\f03aa";
}

.mdi-numeric-3-box-multiple::before {
  content: "\\f0f11";
}

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\f03ab";
}

.mdi-numeric-3-box-outline::before {
  content: "\\f03ac";
}

.mdi-numeric-3-circle::before {
  content: "\\f0ca4";
}

.mdi-numeric-3-circle-outline::before {
  content: "\\f0ca5";
}

.mdi-numeric-4::before {
  content: "\\f0b3d";
}

.mdi-numeric-4-box::before {
  content: "\\f03ad";
}

.mdi-numeric-4-box-multiple::before {
  content: "\\f0f12";
}

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\f03b2";
}

.mdi-numeric-4-box-outline::before {
  content: "\\f03ae";
}

.mdi-numeric-4-circle::before {
  content: "\\f0ca6";
}

.mdi-numeric-4-circle-outline::before {
  content: "\\f0ca7";
}

.mdi-numeric-5::before {
  content: "\\f0b3e";
}

.mdi-numeric-5-box::before {
  content: "\\f03b1";
}

.mdi-numeric-5-box-multiple::before {
  content: "\\f0f13";
}

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\f03af";
}

.mdi-numeric-5-box-outline::before {
  content: "\\f03b0";
}

.mdi-numeric-5-circle::before {
  content: "\\f0ca8";
}

.mdi-numeric-5-circle-outline::before {
  content: "\\f0ca9";
}

.mdi-numeric-6::before {
  content: "\\f0b3f";
}

.mdi-numeric-6-box::before {
  content: "\\f03b3";
}

.mdi-numeric-6-box-multiple::before {
  content: "\\f0f14";
}

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\f03b4";
}

.mdi-numeric-6-box-outline::before {
  content: "\\f03b5";
}

.mdi-numeric-6-circle::before {
  content: "\\f0caa";
}

.mdi-numeric-6-circle-outline::before {
  content: "\\f0cab";
}

.mdi-numeric-7::before {
  content: "\\f0b40";
}

.mdi-numeric-7-box::before {
  content: "\\f03b6";
}

.mdi-numeric-7-box-multiple::before {
  content: "\\f0f15";
}

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\f03b7";
}

.mdi-numeric-7-box-outline::before {
  content: "\\f03b8";
}

.mdi-numeric-7-circle::before {
  content: "\\f0cac";
}

.mdi-numeric-7-circle-outline::before {
  content: "\\f0cad";
}

.mdi-numeric-8::before {
  content: "\\f0b41";
}

.mdi-numeric-8-box::before {
  content: "\\f03b9";
}

.mdi-numeric-8-box-multiple::before {
  content: "\\f0f16";
}

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\f03ba";
}

.mdi-numeric-8-box-outline::before {
  content: "\\f03bb";
}

.mdi-numeric-8-circle::before {
  content: "\\f0cae";
}

.mdi-numeric-8-circle-outline::before {
  content: "\\f0caf";
}

.mdi-numeric-9::before {
  content: "\\f0b42";
}

.mdi-numeric-9-box::before {
  content: "\\f03bc";
}

.mdi-numeric-9-box-multiple::before {
  content: "\\f0f17";
}

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\f03bd";
}

.mdi-numeric-9-box-outline::before {
  content: "\\f03be";
}

.mdi-numeric-9-circle::before {
  content: "\\f0cb0";
}

.mdi-numeric-9-circle-outline::before {
  content: "\\f0cb1";
}

.mdi-numeric-9-plus::before {
  content: "\\f0fee";
}

.mdi-numeric-9-plus-box::before {
  content: "\\f03bf";
}

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\f0f18";
}

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\f03c0";
}

.mdi-numeric-9-plus-box-outline::before {
  content: "\\f03c1";
}

.mdi-numeric-9-plus-circle::before {
  content: "\\f0cb2";
}

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\f0cb3";
}

.mdi-numeric-negative-1::before {
  content: "\\f1052";
}

.mdi-numeric-positive-1::before {
  content: "\\f15cb";
}

.mdi-nut::before {
  content: "\\f06f8";
}

.mdi-nutrition::before {
  content: "\\f03c2";
}

.mdi-nuxt::before {
  content: "\\f1106";
}

.mdi-oar::before {
  content: "\\f067c";
}

.mdi-ocarina::before {
  content: "\\f0de0";
}

.mdi-oci::before {
  content: "\\f12e9";
}

.mdi-ocr::before {
  content: "\\f113a";
}

.mdi-octagon::before {
  content: "\\f03c3";
}

.mdi-octagon-outline::before {
  content: "\\f03c4";
}

.mdi-octagram::before {
  content: "\\f06f9";
}

.mdi-octagram-outline::before {
  content: "\\f0775";
}

.mdi-octahedron::before {
  content: "\\f1950";
}

.mdi-octahedron-off::before {
  content: "\\f1951";
}

.mdi-odnoklassniki::before {
  content: "\\f03c5";
}

.mdi-offer::before {
  content: "\\f121b";
}

.mdi-office-building::before {
  content: "\\f0991";
}

.mdi-office-building-cog::before {
  content: "\\f1949";
}

.mdi-office-building-cog-outline::before {
  content: "\\f194a";
}

.mdi-office-building-marker::before {
  content: "\\f1520";
}

.mdi-office-building-marker-outline::before {
  content: "\\f1521";
}

.mdi-office-building-outline::before {
  content: "\\f151f";
}

.mdi-oil::before {
  content: "\\f03c7";
}

.mdi-oil-lamp::before {
  content: "\\f0f19";
}

.mdi-oil-level::before {
  content: "\\f1053";
}

.mdi-oil-temperature::before {
  content: "\\f0ff8";
}

.mdi-om::before {
  content: "\\f0973";
}

.mdi-omega::before {
  content: "\\f03c9";
}

.mdi-one-up::before {
  content: "\\f0bad";
}

.mdi-onepassword::before {
  content: "\\f0881";
}

.mdi-opacity::before {
  content: "\\f05cc";
}

.mdi-open-in-app::before {
  content: "\\f03cb";
}

.mdi-open-in-new::before {
  content: "\\f03cc";
}

.mdi-open-source-initiative::before {
  content: "\\f0bae";
}

.mdi-openid::before {
  content: "\\f03cd";
}

.mdi-opera::before {
  content: "\\f03ce";
}

.mdi-orbit::before {
  content: "\\f0018";
}

.mdi-orbit-variant::before {
  content: "\\f15db";
}

.mdi-order-alphabetical-ascending::before {
  content: "\\f020d";
}

.mdi-order-alphabetical-descending::before {
  content: "\\f0d07";
}

.mdi-order-bool-ascending::before {
  content: "\\f02be";
}

.mdi-order-bool-ascending-variant::before {
  content: "\\f098f";
}

.mdi-order-bool-descending::before {
  content: "\\f1384";
}

.mdi-order-bool-descending-variant::before {
  content: "\\f0990";
}

.mdi-order-numeric-ascending::before {
  content: "\\f0545";
}

.mdi-order-numeric-descending::before {
  content: "\\f0546";
}

.mdi-origin::before {
  content: "\\f0b43";
}

.mdi-ornament::before {
  content: "\\f03cf";
}

.mdi-ornament-variant::before {
  content: "\\f03d0";
}

.mdi-outdoor-lamp::before {
  content: "\\f1054";
}

.mdi-overscan::before {
  content: "\\f1005";
}

.mdi-owl::before {
  content: "\\f03d2";
}

.mdi-pac-man::before {
  content: "\\f0baf";
}

.mdi-package::before {
  content: "\\f03d3";
}

.mdi-package-down::before {
  content: "\\f03d4";
}

.mdi-package-up::before {
  content: "\\f03d5";
}

.mdi-package-variant::before {
  content: "\\f03d6";
}

.mdi-package-variant-closed::before {
  content: "\\f03d7";
}

.mdi-page-first::before {
  content: "\\f0600";
}

.mdi-page-last::before {
  content: "\\f0601";
}

.mdi-page-layout-body::before {
  content: "\\f06fa";
}

.mdi-page-layout-footer::before {
  content: "\\f06fb";
}

.mdi-page-layout-header::before {
  content: "\\f06fc";
}

.mdi-page-layout-header-footer::before {
  content: "\\f0f7f";
}

.mdi-page-layout-sidebar-left::before {
  content: "\\f06fd";
}

.mdi-page-layout-sidebar-right::before {
  content: "\\f06fe";
}

.mdi-page-next::before {
  content: "\\f0bb0";
}

.mdi-page-next-outline::before {
  content: "\\f0bb1";
}

.mdi-page-previous::before {
  content: "\\f0bb2";
}

.mdi-page-previous-outline::before {
  content: "\\f0bb3";
}

.mdi-pail::before {
  content: "\\f1417";
}

.mdi-pail-minus::before {
  content: "\\f1437";
}

.mdi-pail-minus-outline::before {
  content: "\\f143c";
}

.mdi-pail-off::before {
  content: "\\f1439";
}

.mdi-pail-off-outline::before {
  content: "\\f143e";
}

.mdi-pail-outline::before {
  content: "\\f143a";
}

.mdi-pail-plus::before {
  content: "\\f1436";
}

.mdi-pail-plus-outline::before {
  content: "\\f143b";
}

.mdi-pail-remove::before {
  content: "\\f1438";
}

.mdi-pail-remove-outline::before {
  content: "\\f143d";
}

.mdi-palette::before {
  content: "\\f03d8";
}

.mdi-palette-advanced::before {
  content: "\\f03d9";
}

.mdi-palette-outline::before {
  content: "\\f0e0c";
}

.mdi-palette-swatch::before {
  content: "\\f08b5";
}

.mdi-palette-swatch-outline::before {
  content: "\\f135c";
}

.mdi-palette-swatch-variant::before {
  content: "\\f195a";
}

.mdi-palm-tree::before {
  content: "\\f1055";
}

.mdi-pan::before {
  content: "\\f0bb4";
}

.mdi-pan-bottom-left::before {
  content: "\\f0bb5";
}

.mdi-pan-bottom-right::before {
  content: "\\f0bb6";
}

.mdi-pan-down::before {
  content: "\\f0bb7";
}

.mdi-pan-horizontal::before {
  content: "\\f0bb8";
}

.mdi-pan-left::before {
  content: "\\f0bb9";
}

.mdi-pan-right::before {
  content: "\\f0bba";
}

.mdi-pan-top-left::before {
  content: "\\f0bbb";
}

.mdi-pan-top-right::before {
  content: "\\f0bbc";
}

.mdi-pan-up::before {
  content: "\\f0bbd";
}

.mdi-pan-vertical::before {
  content: "\\f0bbe";
}

.mdi-panda::before {
  content: "\\f03da";
}

.mdi-pandora::before {
  content: "\\f03db";
}

.mdi-panorama::before {
  content: "\\f03dc";
}

.mdi-panorama-fisheye::before {
  content: "\\f03dd";
}

.mdi-panorama-horizontal::before {
  content: "\\f1928";
}

.mdi-panorama-horizontal-outline::before {
  content: "\\f03de";
}

.mdi-panorama-outline::before {
  content: "\\f198c";
}

.mdi-panorama-sphere::before {
  content: "\\f198d";
}

.mdi-panorama-sphere-outline::before {
  content: "\\f198e";
}

.mdi-panorama-variant::before {
  content: "\\f198f";
}

.mdi-panorama-variant-outline::before {
  content: "\\f1990";
}

.mdi-panorama-vertical::before {
  content: "\\f1929";
}

.mdi-panorama-vertical-outline::before {
  content: "\\f03df";
}

.mdi-panorama-wide-angle::before {
  content: "\\f195f";
}

.mdi-panorama-wide-angle-outline::before {
  content: "\\f03e0";
}

.mdi-paper-cut-vertical::before {
  content: "\\f03e1";
}

.mdi-paper-roll::before {
  content: "\\f1157";
}

.mdi-paper-roll-outline::before {
  content: "\\f1158";
}

.mdi-paperclip::before {
  content: "\\f03e2";
}

.mdi-parachute::before {
  content: "\\f0cb4";
}

.mdi-parachute-outline::before {
  content: "\\f0cb5";
}

.mdi-paragliding::before {
  content: "\\f1745";
}

.mdi-parking::before {
  content: "\\f03e3";
}

.mdi-party-popper::before {
  content: "\\f1056";
}

.mdi-passport::before {
  content: "\\f07e3";
}

.mdi-passport-biometric::before {
  content: "\\f0de1";
}

.mdi-pasta::before {
  content: "\\f1160";
}

.mdi-patio-heater::before {
  content: "\\f0f80";
}

.mdi-patreon::before {
  content: "\\f0882";
}

.mdi-pause::before {
  content: "\\f03e4";
}

.mdi-pause-circle::before {
  content: "\\f03e5";
}

.mdi-pause-circle-outline::before {
  content: "\\f03e6";
}

.mdi-pause-octagon::before {
  content: "\\f03e7";
}

.mdi-pause-octagon-outline::before {
  content: "\\f03e8";
}

.mdi-paw::before {
  content: "\\f03e9";
}

.mdi-paw-off::before {
  content: "\\f0657";
}

.mdi-paw-off-outline::before {
  content: "\\f1676";
}

.mdi-paw-outline::before {
  content: "\\f1675";
}

.mdi-peace::before {
  content: "\\f0884";
}

.mdi-peanut::before {
  content: "\\f0ffc";
}

.mdi-peanut-off::before {
  content: "\\f0ffd";
}

.mdi-peanut-off-outline::before {
  content: "\\f0fff";
}

.mdi-peanut-outline::before {
  content: "\\f0ffe";
}

.mdi-pen::before {
  content: "\\f03ea";
}

.mdi-pen-lock::before {
  content: "\\f0de2";
}

.mdi-pen-minus::before {
  content: "\\f0de3";
}

.mdi-pen-off::before {
  content: "\\f0de4";
}

.mdi-pen-plus::before {
  content: "\\f0de5";
}

.mdi-pen-remove::before {
  content: "\\f0de6";
}

.mdi-pencil::before {
  content: "\\f03eb";
}

.mdi-pencil-box::before {
  content: "\\f03ec";
}

.mdi-pencil-box-multiple::before {
  content: "\\f1144";
}

.mdi-pencil-box-multiple-outline::before {
  content: "\\f1145";
}

.mdi-pencil-box-outline::before {
  content: "\\f03ed";
}

.mdi-pencil-circle::before {
  content: "\\f06ff";
}

.mdi-pencil-circle-outline::before {
  content: "\\f0776";
}

.mdi-pencil-lock::before {
  content: "\\f03ee";
}

.mdi-pencil-lock-outline::before {
  content: "\\f0de7";
}

.mdi-pencil-minus::before {
  content: "\\f0de8";
}

.mdi-pencil-minus-outline::before {
  content: "\\f0de9";
}

.mdi-pencil-off::before {
  content: "\\f03ef";
}

.mdi-pencil-off-outline::before {
  content: "\\f0dea";
}

.mdi-pencil-outline::before {
  content: "\\f0cb6";
}

.mdi-pencil-plus::before {
  content: "\\f0deb";
}

.mdi-pencil-plus-outline::before {
  content: "\\f0dec";
}

.mdi-pencil-remove::before {
  content: "\\f0ded";
}

.mdi-pencil-remove-outline::before {
  content: "\\f0dee";
}

.mdi-pencil-ruler::before {
  content: "\\f1353";
}

.mdi-penguin::before {
  content: "\\f0ec0";
}

.mdi-pentagon::before {
  content: "\\f0701";
}

.mdi-pentagon-outline::before {
  content: "\\f0700";
}

.mdi-pentagram::before {
  content: "\\f1667";
}

.mdi-percent::before {
  content: "\\f03f0";
}

.mdi-percent-outline::before {
  content: "\\f1278";
}

.mdi-periodic-table::before {
  content: "\\f08b6";
}

.mdi-perspective-less::before {
  content: "\\f0d23";
}

.mdi-perspective-more::before {
  content: "\\f0d24";
}

.mdi-ph::before {
  content: "\\f17c5";
}

.mdi-phone::before {
  content: "\\f03f2";
}

.mdi-phone-alert::before {
  content: "\\f0f1a";
}

.mdi-phone-alert-outline::before {
  content: "\\f118e";
}

.mdi-phone-bluetooth::before {
  content: "\\f03f3";
}

.mdi-phone-bluetooth-outline::before {
  content: "\\f118f";
}

.mdi-phone-cancel::before {
  content: "\\f10bc";
}

.mdi-phone-cancel-outline::before {
  content: "\\f1190";
}

.mdi-phone-check::before {
  content: "\\f11a9";
}

.mdi-phone-check-outline::before {
  content: "\\f11aa";
}

.mdi-phone-classic::before {
  content: "\\f0602";
}

.mdi-phone-classic-off::before {
  content: "\\f1279";
}

.mdi-phone-dial::before {
  content: "\\f1559";
}

.mdi-phone-dial-outline::before {
  content: "\\f155a";
}

.mdi-phone-forward::before {
  content: "\\f03f4";
}

.mdi-phone-forward-outline::before {
  content: "\\f1191";
}

.mdi-phone-hangup::before {
  content: "\\f03f5";
}

.mdi-phone-hangup-outline::before {
  content: "\\f1192";
}

.mdi-phone-in-talk::before {
  content: "\\f03f6";
}

.mdi-phone-in-talk-outline::before {
  content: "\\f1182";
}

.mdi-phone-incoming::before {
  content: "\\f03f7";
}

.mdi-phone-incoming-outline::before {
  content: "\\f1193";
}

.mdi-phone-lock::before {
  content: "\\f03f8";
}

.mdi-phone-lock-outline::before {
  content: "\\f1194";
}

.mdi-phone-log::before {
  content: "\\f03f9";
}

.mdi-phone-log-outline::before {
  content: "\\f1195";
}

.mdi-phone-message::before {
  content: "\\f1196";
}

.mdi-phone-message-outline::before {
  content: "\\f1197";
}

.mdi-phone-minus::before {
  content: "\\f0658";
}

.mdi-phone-minus-outline::before {
  content: "\\f1198";
}

.mdi-phone-missed::before {
  content: "\\f03fa";
}

.mdi-phone-missed-outline::before {
  content: "\\f11a5";
}

.mdi-phone-off::before {
  content: "\\f0def";
}

.mdi-phone-off-outline::before {
  content: "\\f11a6";
}

.mdi-phone-outgoing::before {
  content: "\\f03fb";
}

.mdi-phone-outgoing-outline::before {
  content: "\\f1199";
}

.mdi-phone-outline::before {
  content: "\\f0df0";
}

.mdi-phone-paused::before {
  content: "\\f03fc";
}

.mdi-phone-paused-outline::before {
  content: "\\f119a";
}

.mdi-phone-plus::before {
  content: "\\f0659";
}

.mdi-phone-plus-outline::before {
  content: "\\f119b";
}

.mdi-phone-refresh::before {
  content: "\\f1993";
}

.mdi-phone-refresh-outline::before {
  content: "\\f1994";
}

.mdi-phone-remove::before {
  content: "\\f152f";
}

.mdi-phone-remove-outline::before {
  content: "\\f1530";
}

.mdi-phone-return::before {
  content: "\\f082f";
}

.mdi-phone-return-outline::before {
  content: "\\f119c";
}

.mdi-phone-ring::before {
  content: "\\f11ab";
}

.mdi-phone-ring-outline::before {
  content: "\\f11ac";
}

.mdi-phone-rotate-landscape::before {
  content: "\\f0885";
}

.mdi-phone-rotate-portrait::before {
  content: "\\f0886";
}

.mdi-phone-settings::before {
  content: "\\f03fd";
}

.mdi-phone-settings-outline::before {
  content: "\\f119d";
}

.mdi-phone-sync::before {
  content: "\\f1995";
}

.mdi-phone-sync-outline::before {
  content: "\\f1996";
}

.mdi-phone-voip::before {
  content: "\\f03fe";
}

.mdi-pi::before {
  content: "\\f03ff";
}

.mdi-pi-box::before {
  content: "\\f0400";
}

.mdi-pi-hole::before {
  content: "\\f0df1";
}

.mdi-piano::before {
  content: "\\f067d";
}

.mdi-piano-off::before {
  content: "\\f0698";
}

.mdi-pickaxe::before {
  content: "\\f08b7";
}

.mdi-picture-in-picture-bottom-right::before {
  content: "\\f0e57";
}

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\f0e58";
}

.mdi-picture-in-picture-top-right::before {
  content: "\\f0e59";
}

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\f0e5a";
}

.mdi-pier::before {
  content: "\\f0887";
}

.mdi-pier-crane::before {
  content: "\\f0888";
}

.mdi-pig::before {
  content: "\\f0401";
}

.mdi-pig-variant::before {
  content: "\\f1006";
}

.mdi-pig-variant-outline::before {
  content: "\\f1678";
}

.mdi-piggy-bank::before {
  content: "\\f1007";
}

.mdi-piggy-bank-outline::before {
  content: "\\f1679";
}

.mdi-pill::before {
  content: "\\f0402";
}

.mdi-pillar::before {
  content: "\\f0702";
}

.mdi-pin::before {
  content: "\\f0403";
}

.mdi-pin-off::before {
  content: "\\f0404";
}

.mdi-pin-off-outline::before {
  content: "\\f0930";
}

.mdi-pin-outline::before {
  content: "\\f0931";
}

.mdi-pine-tree::before {
  content: "\\f0405";
}

.mdi-pine-tree-box::before {
  content: "\\f0406";
}

.mdi-pine-tree-fire::before {
  content: "\\f141a";
}

.mdi-pinterest::before {
  content: "\\f0407";
}

.mdi-pinwheel::before {
  content: "\\f0ad5";
}

.mdi-pinwheel-outline::before {
  content: "\\f0ad6";
}

.mdi-pipe::before {
  content: "\\f07e5";
}

.mdi-pipe-disconnected::before {
  content: "\\f07e6";
}

.mdi-pipe-leak::before {
  content: "\\f0889";
}

.mdi-pipe-valve::before {
  content: "\\f184d";
}

.mdi-pipe-wrench::before {
  content: "\\f1354";
}

.mdi-pirate::before {
  content: "\\f0a08";
}

.mdi-pistol::before {
  content: "\\f0703";
}

.mdi-piston::before {
  content: "\\f088a";
}

.mdi-pitchfork::before {
  content: "\\f1553";
}

.mdi-pizza::before {
  content: "\\f0409";
}

.mdi-play::before {
  content: "\\f040a";
}

.mdi-play-box::before {
  content: "\\f127a";
}

.mdi-play-box-multiple::before {
  content: "\\f0d19";
}

.mdi-play-box-multiple-outline::before {
  content: "\\f13e6";
}

.mdi-play-box-outline::before {
  content: "\\f040b";
}

.mdi-play-circle::before {
  content: "\\f040c";
}

.mdi-play-circle-outline::before {
  content: "\\f040d";
}

.mdi-play-network::before {
  content: "\\f088b";
}

.mdi-play-network-outline::before {
  content: "\\f0cb7";
}

.mdi-play-outline::before {
  content: "\\f0f1b";
}

.mdi-play-pause::before {
  content: "\\f040e";
}

.mdi-play-protected-content::before {
  content: "\\f040f";
}

.mdi-play-speed::before {
  content: "\\f08ff";
}

.mdi-playlist-check::before {
  content: "\\f05c7";
}

.mdi-playlist-edit::before {
  content: "\\f0900";
}

.mdi-playlist-minus::before {
  content: "\\f0410";
}

.mdi-playlist-music::before {
  content: "\\f0cb8";
}

.mdi-playlist-music-outline::before {
  content: "\\f0cb9";
}

.mdi-playlist-play::before {
  content: "\\f0411";
}

.mdi-playlist-plus::before {
  content: "\\f0412";
}

.mdi-playlist-remove::before {
  content: "\\f0413";
}

.mdi-playlist-star::before {
  content: "\\f0df2";
}

.mdi-plex::before {
  content: "\\f06ba";
}

.mdi-pliers::before {
  content: "\\f19a4";
}

.mdi-plus::before {
  content: "\\f0415";
}

.mdi-plus-box::before {
  content: "\\f0416";
}

.mdi-plus-box-multiple::before {
  content: "\\f0334";
}

.mdi-plus-box-multiple-outline::before {
  content: "\\f1143";
}

.mdi-plus-box-outline::before {
  content: "\\f0704";
}

.mdi-plus-circle::before {
  content: "\\f0417";
}

.mdi-plus-circle-multiple::before {
  content: "\\f034c";
}

.mdi-plus-circle-multiple-outline::before {
  content: "\\f0418";
}

.mdi-plus-circle-outline::before {
  content: "\\f0419";
}

.mdi-plus-minus::before {
  content: "\\f0992";
}

.mdi-plus-minus-box::before {
  content: "\\f0993";
}

.mdi-plus-minus-variant::before {
  content: "\\f14c9";
}

.mdi-plus-network::before {
  content: "\\f041a";
}

.mdi-plus-network-outline::before {
  content: "\\f0cba";
}

.mdi-plus-outline::before {
  content: "\\f0705";
}

.mdi-plus-thick::before {
  content: "\\f11ec";
}

.mdi-podcast::before {
  content: "\\f0994";
}

.mdi-podium::before {
  content: "\\f0d25";
}

.mdi-podium-bronze::before {
  content: "\\f0d26";
}

.mdi-podium-gold::before {
  content: "\\f0d27";
}

.mdi-podium-silver::before {
  content: "\\f0d28";
}

.mdi-point-of-sale::before {
  content: "\\f0d92";
}

.mdi-pokeball::before {
  content: "\\f041d";
}

.mdi-pokemon-go::before {
  content: "\\f0a09";
}

.mdi-poker-chip::before {
  content: "\\f0830";
}

.mdi-polaroid::before {
  content: "\\f041e";
}

.mdi-police-badge::before {
  content: "\\f1167";
}

.mdi-police-badge-outline::before {
  content: "\\f1168";
}

.mdi-police-station::before {
  content: "\\f1839";
}

.mdi-poll::before {
  content: "\\f041f";
}

.mdi-polo::before {
  content: "\\f14c3";
}

.mdi-polymer::before {
  content: "\\f0421";
}

.mdi-pool::before {
  content: "\\f0606";
}

.mdi-popcorn::before {
  content: "\\f0422";
}

.mdi-post::before {
  content: "\\f1008";
}

.mdi-post-outline::before {
  content: "\\f1009";
}

.mdi-postage-stamp::before {
  content: "\\f0cbb";
}

.mdi-pot::before {
  content: "\\f02e5";
}

.mdi-pot-mix::before {
  content: "\\f065b";
}

.mdi-pot-mix-outline::before {
  content: "\\f0677";
}

.mdi-pot-outline::before {
  content: "\\f02ff";
}

.mdi-pot-steam::before {
  content: "\\f065a";
}

.mdi-pot-steam-outline::before {
  content: "\\f0326";
}

.mdi-pound::before {
  content: "\\f0423";
}

.mdi-pound-box::before {
  content: "\\f0424";
}

.mdi-pound-box-outline::before {
  content: "\\f117f";
}

.mdi-power::before {
  content: "\\f0425";
}

.mdi-power-cycle::before {
  content: "\\f0901";
}

.mdi-power-off::before {
  content: "\\f0902";
}

.mdi-power-on::before {
  content: "\\f0903";
}

.mdi-power-plug::before {
  content: "\\f06a5";
}

.mdi-power-plug-off::before {
  content: "\\f06a6";
}

.mdi-power-plug-off-outline::before {
  content: "\\f1424";
}

.mdi-power-plug-outline::before {
  content: "\\f1425";
}

.mdi-power-settings::before {
  content: "\\f0426";
}

.mdi-power-sleep::before {
  content: "\\f0904";
}

.mdi-power-socket::before {
  content: "\\f0427";
}

.mdi-power-socket-au::before {
  content: "\\f0905";
}

.mdi-power-socket-ch::before {
  content: "\\f0fb3";
}

.mdi-power-socket-de::before {
  content: "\\f1107";
}

.mdi-power-socket-eu::before {
  content: "\\f07e7";
}

.mdi-power-socket-fr::before {
  content: "\\f1108";
}

.mdi-power-socket-it::before {
  content: "\\f14ff";
}

.mdi-power-socket-jp::before {
  content: "\\f1109";
}

.mdi-power-socket-uk::before {
  content: "\\f07e8";
}

.mdi-power-socket-us::before {
  content: "\\f07e9";
}

.mdi-power-standby::before {
  content: "\\f0906";
}

.mdi-powershell::before {
  content: "\\f0a0a";
}

.mdi-prescription::before {
  content: "\\f0706";
}

.mdi-presentation::before {
  content: "\\f0428";
}

.mdi-presentation-play::before {
  content: "\\f0429";
}

.mdi-pretzel::before {
  content: "\\f1562";
}

.mdi-printer::before {
  content: "\\f042a";
}

.mdi-printer-3d::before {
  content: "\\f042b";
}

.mdi-printer-3d-nozzle::before {
  content: "\\f0e5b";
}

.mdi-printer-3d-nozzle-alert::before {
  content: "\\f11c0";
}

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\f11c1";
}

.mdi-printer-3d-nozzle-heat::before {
  content: "\\f18b8";
}

.mdi-printer-3d-nozzle-heat-outline::before {
  content: "\\f18b9";
}

.mdi-printer-3d-nozzle-outline::before {
  content: "\\f0e5c";
}

.mdi-printer-alert::before {
  content: "\\f042c";
}

.mdi-printer-check::before {
  content: "\\f1146";
}

.mdi-printer-eye::before {
  content: "\\f1458";
}

.mdi-printer-off::before {
  content: "\\f0e5d";
}

.mdi-printer-off-outline::before {
  content: "\\f1785";
}

.mdi-printer-outline::before {
  content: "\\f1786";
}

.mdi-printer-pos::before {
  content: "\\f1057";
}

.mdi-printer-search::before {
  content: "\\f1457";
}

.mdi-printer-settings::before {
  content: "\\f0707";
}

.mdi-printer-wireless::before {
  content: "\\f0a0b";
}

.mdi-priority-high::before {
  content: "\\f0603";
}

.mdi-priority-low::before {
  content: "\\f0604";
}

.mdi-professional-hexagon::before {
  content: "\\f042d";
}

.mdi-progress-alert::before {
  content: "\\f0cbc";
}

.mdi-progress-check::before {
  content: "\\f0995";
}

.mdi-progress-clock::before {
  content: "\\f0996";
}

.mdi-progress-close::before {
  content: "\\f110a";
}

.mdi-progress-download::before {
  content: "\\f0997";
}

.mdi-progress-pencil::before {
  content: "\\f1787";
}

.mdi-progress-question::before {
  content: "\\f1522";
}

.mdi-progress-star::before {
  content: "\\f1788";
}

.mdi-progress-upload::before {
  content: "\\f0998";
}

.mdi-progress-wrench::before {
  content: "\\f0cbd";
}

.mdi-projector::before {
  content: "\\f042e";
}

.mdi-projector-screen::before {
  content: "\\f042f";
}

.mdi-projector-screen-off::before {
  content: "\\f180d";
}

.mdi-projector-screen-off-outline::before {
  content: "\\f180e";
}

.mdi-projector-screen-outline::before {
  content: "\\f1724";
}

.mdi-projector-screen-variant::before {
  content: "\\f180f";
}

.mdi-projector-screen-variant-off::before {
  content: "\\f1810";
}

.mdi-projector-screen-variant-off-outline::before {
  content: "\\f1811";
}

.mdi-projector-screen-variant-outline::before {
  content: "\\f1812";
}

.mdi-propane-tank::before {
  content: "\\f1357";
}

.mdi-propane-tank-outline::before {
  content: "\\f1358";
}

.mdi-protocol::before {
  content: "\\f0fd8";
}

.mdi-publish::before {
  content: "\\f06a7";
}

.mdi-publish-off::before {
  content: "\\f1945";
}

.mdi-pulse::before {
  content: "\\f0430";
}

.mdi-pump::before {
  content: "\\f1402";
}

.mdi-pumpkin::before {
  content: "\\f0bbf";
}

.mdi-purse::before {
  content: "\\f0f1c";
}

.mdi-purse-outline::before {
  content: "\\f0f1d";
}

.mdi-puzzle::before {
  content: "\\f0431";
}

.mdi-puzzle-check::before {
  content: "\\f1426";
}

.mdi-puzzle-check-outline::before {
  content: "\\f1427";
}

.mdi-puzzle-edit::before {
  content: "\\f14d3";
}

.mdi-puzzle-edit-outline::before {
  content: "\\f14d9";
}

.mdi-puzzle-heart::before {
  content: "\\f14d4";
}

.mdi-puzzle-heart-outline::before {
  content: "\\f14da";
}

.mdi-puzzle-minus::before {
  content: "\\f14d1";
}

.mdi-puzzle-minus-outline::before {
  content: "\\f14d7";
}

.mdi-puzzle-outline::before {
  content: "\\f0a66";
}

.mdi-puzzle-plus::before {
  content: "\\f14d0";
}

.mdi-puzzle-plus-outline::before {
  content: "\\f14d6";
}

.mdi-puzzle-remove::before {
  content: "\\f14d2";
}

.mdi-puzzle-remove-outline::before {
  content: "\\f14d8";
}

.mdi-puzzle-star::before {
  content: "\\f14d5";
}

.mdi-puzzle-star-outline::before {
  content: "\\f14db";
}

.mdi-pyramid::before {
  content: "\\f1952";
}

.mdi-pyramid-off::before {
  content: "\\f1953";
}

.mdi-qi::before {
  content: "\\f0999";
}

.mdi-qqchat::before {
  content: "\\f0605";
}

.mdi-qrcode::before {
  content: "\\f0432";
}

.mdi-qrcode-edit::before {
  content: "\\f08b8";
}

.mdi-qrcode-minus::before {
  content: "\\f118c";
}

.mdi-qrcode-plus::before {
  content: "\\f118b";
}

.mdi-qrcode-remove::before {
  content: "\\f118d";
}

.mdi-qrcode-scan::before {
  content: "\\f0433";
}

.mdi-quadcopter::before {
  content: "\\f0434";
}

.mdi-quality-high::before {
  content: "\\f0435";
}

.mdi-quality-low::before {
  content: "\\f0a0c";
}

.mdi-quality-medium::before {
  content: "\\f0a0d";
}

.mdi-quora::before {
  content: "\\f0d29";
}

.mdi-rabbit::before {
  content: "\\f0907";
}

.mdi-racing-helmet::before {
  content: "\\f0d93";
}

.mdi-racquetball::before {
  content: "\\f0d94";
}

.mdi-radar::before {
  content: "\\f0437";
}

.mdi-radiator::before {
  content: "\\f0438";
}

.mdi-radiator-disabled::before {
  content: "\\f0ad7";
}

.mdi-radiator-off::before {
  content: "\\f0ad8";
}

.mdi-radio::before {
  content: "\\f0439";
}

.mdi-radio-am::before {
  content: "\\f0cbe";
}

.mdi-radio-fm::before {
  content: "\\f0cbf";
}

.mdi-radio-handheld::before {
  content: "\\f043a";
}

.mdi-radio-off::before {
  content: "\\f121c";
}

.mdi-radio-tower::before {
  content: "\\f043b";
}

.mdi-radioactive::before {
  content: "\\f043c";
}

.mdi-radioactive-circle::before {
  content: "\\f185d";
}

.mdi-radioactive-circle-outline::before {
  content: "\\f185e";
}

.mdi-radioactive-off::before {
  content: "\\f0ec1";
}

.mdi-radiobox-blank::before {
  content: "\\f043d";
}

.mdi-radiobox-marked::before {
  content: "\\f043e";
}

.mdi-radiology-box::before {
  content: "\\f14c5";
}

.mdi-radiology-box-outline::before {
  content: "\\f14c6";
}

.mdi-radius::before {
  content: "\\f0cc0";
}

.mdi-radius-outline::before {
  content: "\\f0cc1";
}

.mdi-railroad-light::before {
  content: "\\f0f1e";
}

.mdi-rake::before {
  content: "\\f1544";
}

.mdi-raspberry-pi::before {
  content: "\\f043f";
}

.mdi-ray-end::before {
  content: "\\f0440";
}

.mdi-ray-end-arrow::before {
  content: "\\f0441";
}

.mdi-ray-start::before {
  content: "\\f0442";
}

.mdi-ray-start-arrow::before {
  content: "\\f0443";
}

.mdi-ray-start-end::before {
  content: "\\f0444";
}

.mdi-ray-start-vertex-end::before {
  content: "\\f15d8";
}

.mdi-ray-vertex::before {
  content: "\\f0445";
}

.mdi-razor-double-edge::before {
  content: "\\f1997";
}

.mdi-razor-single-edge::before {
  content: "\\f1998";
}

.mdi-react::before {
  content: "\\f0708";
}

.mdi-read::before {
  content: "\\f0447";
}

.mdi-receipt::before {
  content: "\\f0449";
}

.mdi-record::before {
  content: "\\f044a";
}

.mdi-record-circle::before {
  content: "\\f0ec2";
}

.mdi-record-circle-outline::before {
  content: "\\f0ec3";
}

.mdi-record-player::before {
  content: "\\f099a";
}

.mdi-record-rec::before {
  content: "\\f044b";
}

.mdi-rectangle::before {
  content: "\\f0e5e";
}

.mdi-rectangle-outline::before {
  content: "\\f0e5f";
}

.mdi-recycle::before {
  content: "\\f044c";
}

.mdi-recycle-variant::before {
  content: "\\f139d";
}

.mdi-reddit::before {
  content: "\\f044d";
}

.mdi-redhat::before {
  content: "\\f111b";
}

.mdi-redo::before {
  content: "\\f044e";
}

.mdi-redo-variant::before {
  content: "\\f044f";
}

.mdi-reflect-horizontal::before {
  content: "\\f0a0e";
}

.mdi-reflect-vertical::before {
  content: "\\f0a0f";
}

.mdi-refresh::before {
  content: "\\f0450";
}

.mdi-refresh-auto::before {
  content: "\\f18f2";
}

.mdi-refresh-circle::before {
  content: "\\f1377";
}

.mdi-regex::before {
  content: "\\f0451";
}

.mdi-registered-trademark::before {
  content: "\\f0a67";
}

.mdi-reiterate::before {
  content: "\\f1588";
}

.mdi-relation-many-to-many::before {
  content: "\\f1496";
}

.mdi-relation-many-to-one::before {
  content: "\\f1497";
}

.mdi-relation-many-to-one-or-many::before {
  content: "\\f1498";
}

.mdi-relation-many-to-only-one::before {
  content: "\\f1499";
}

.mdi-relation-many-to-zero-or-many::before {
  content: "\\f149a";
}

.mdi-relation-many-to-zero-or-one::before {
  content: "\\f149b";
}

.mdi-relation-one-or-many-to-many::before {
  content: "\\f149c";
}

.mdi-relation-one-or-many-to-one::before {
  content: "\\f149d";
}

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\f149e";
}

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\f149f";
}

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\f14a0";
}

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\f14a1";
}

.mdi-relation-one-to-many::before {
  content: "\\f14a2";
}

.mdi-relation-one-to-one::before {
  content: "\\f14a3";
}

.mdi-relation-one-to-one-or-many::before {
  content: "\\f14a4";
}

.mdi-relation-one-to-only-one::before {
  content: "\\f14a5";
}

.mdi-relation-one-to-zero-or-many::before {
  content: "\\f14a6";
}

.mdi-relation-one-to-zero-or-one::before {
  content: "\\f14a7";
}

.mdi-relation-only-one-to-many::before {
  content: "\\f14a8";
}

.mdi-relation-only-one-to-one::before {
  content: "\\f14a9";
}

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\f14aa";
}

.mdi-relation-only-one-to-only-one::before {
  content: "\\f14ab";
}

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\f14ac";
}

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\f14ad";
}

.mdi-relation-zero-or-many-to-many::before {
  content: "\\f14ae";
}

.mdi-relation-zero-or-many-to-one::before {
  content: "\\f14af";
}

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\f14b0";
}

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\f14b1";
}

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\f14b2";
}

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\f14b3";
}

.mdi-relation-zero-or-one-to-many::before {
  content: "\\f14b4";
}

.mdi-relation-zero-or-one-to-one::before {
  content: "\\f14b5";
}

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\f14b6";
}

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\f14b7";
}

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\f14b8";
}

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\f14b9";
}

.mdi-relative-scale::before {
  content: "\\f0452";
}

.mdi-reload::before {
  content: "\\f0453";
}

.mdi-reload-alert::before {
  content: "\\f110b";
}

.mdi-reminder::before {
  content: "\\f088c";
}

.mdi-remote::before {
  content: "\\f0454";
}

.mdi-remote-desktop::before {
  content: "\\f08b9";
}

.mdi-remote-off::before {
  content: "\\f0ec4";
}

.mdi-remote-tv::before {
  content: "\\f0ec5";
}

.mdi-remote-tv-off::before {
  content: "\\f0ec6";
}

.mdi-rename-box::before {
  content: "\\f0455";
}

.mdi-reorder-horizontal::before {
  content: "\\f0688";
}

.mdi-reorder-vertical::before {
  content: "\\f0689";
}

.mdi-repeat::before {
  content: "\\f0456";
}

.mdi-repeat-off::before {
  content: "\\f0457";
}

.mdi-repeat-once::before {
  content: "\\f0458";
}

.mdi-repeat-variant::before {
  content: "\\f0547";
}

.mdi-replay::before {
  content: "\\f0459";
}

.mdi-reply::before {
  content: "\\f045a";
}

.mdi-reply-all::before {
  content: "\\f045b";
}

.mdi-reply-all-outline::before {
  content: "\\f0f1f";
}

.mdi-reply-circle::before {
  content: "\\f11ae";
}

.mdi-reply-outline::before {
  content: "\\f0f20";
}

.mdi-recivil_budget::before {
  content: "\\f045c";
}

.mdi-resistor::before {
  content: "\\f0b44";
}

.mdi-resistor-nodes::before {
  content: "\\f0b45";
}

.mdi-resize::before {
  content: "\\f0a68";
}

.mdi-resize-bottom-right::before {
  content: "\\f045d";
}

.mdi-responsive::before {
  content: "\\f045e";
}

.mdi-restart::before {
  content: "\\f0709";
}

.mdi-restart-alert::before {
  content: "\\f110c";
}

.mdi-restart-off::before {
  content: "\\f0d95";
}

.mdi-restore::before {
  content: "\\f099b";
}

.mdi-restore-alert::before {
  content: "\\f110d";
}

.mdi-rewind::before {
  content: "\\f045f";
}

.mdi-rewind-10::before {
  content: "\\f0d2a";
}

.mdi-rewind-15::before {
  content: "\\f1946";
}

.mdi-rewind-30::before {
  content: "\\f0d96";
}

.mdi-rewind-5::before {
  content: "\\f11f9";
}

.mdi-rewind-60::before {
  content: "\\f160c";
}

.mdi-rewind-outline::before {
  content: "\\f070a";
}

.mdi-rhombus::before {
  content: "\\f070b";
}

.mdi-rhombus-medium::before {
  content: "\\f0a10";
}

.mdi-rhombus-medium-outline::before {
  content: "\\f14dc";
}

.mdi-rhombus-outline::before {
  content: "\\f070c";
}

.mdi-rhombus-split::before {
  content: "\\f0a11";
}

.mdi-rhombus-split-outline::before {
  content: "\\f14dd";
}

.mdi-ribbon::before {
  content: "\\f0460";
}

.mdi-rice::before {
  content: "\\f07ea";
}

.mdi-rickshaw::before {
  content: "\\f15bb";
}

.mdi-rickshaw-electric::before {
  content: "\\f15bc";
}

.mdi-ring::before {
  content: "\\f07eb";
}

.mdi-rivet::before {
  content: "\\f0e60";
}

.mdi-road::before {
  content: "\\f0461";
}

.mdi-road-variant::before {
  content: "\\f0462";
}

.mdi-robber::before {
  content: "\\f1058";
}

.mdi-robot::before {
  content: "\\f06a9";
}

.mdi-robot-angry::before {
  content: "\\f169d";
}

.mdi-robot-angry-outline::before {
  content: "\\f169e";
}

.mdi-robot-confused::before {
  content: "\\f169f";
}

.mdi-robot-confused-outline::before {
  content: "\\f16a0";
}

.mdi-robot-dead::before {
  content: "\\f16a1";
}

.mdi-robot-dead-outline::before {
  content: "\\f16a2";
}

.mdi-robot-excited::before {
  content: "\\f16a3";
}

.mdi-robot-excited-outline::before {
  content: "\\f16a4";
}

.mdi-robot-happy::before {
  content: "\\f1719";
}

.mdi-robot-happy-outline::before {
  content: "\\f171a";
}

.mdi-robot-industrial::before {
  content: "\\f0b46";
}

.mdi-robot-love::before {
  content: "\\f16a5";
}

.mdi-robot-love-outline::before {
  content: "\\f16a6";
}

.mdi-robot-mower::before {
  content: "\\f11f7";
}

.mdi-robot-mower-outline::before {
  content: "\\f11f3";
}

.mdi-robot-off::before {
  content: "\\f16a7";
}

.mdi-robot-off-outline::before {
  content: "\\f167b";
}

.mdi-robot-outline::before {
  content: "\\f167a";
}

.mdi-robot-vacuum::before {
  content: "\\f070d";
}

.mdi-robot-vacuum-variant::before {
  content: "\\f0908";
}

.mdi-rocket::before {
  content: "\\f0463";
}

.mdi-rocket-launch::before {
  content: "\\f14de";
}

.mdi-rocket-launch-outline::before {
  content: "\\f14df";
}

.mdi-rocket-outline::before {
  content: "\\f13af";
}

.mdi-rodent::before {
  content: "\\f1327";
}

.mdi-roller-skate::before {
  content: "\\f0d2b";
}

.mdi-roller-skate-off::before {
  content: "\\f0145";
}

.mdi-rollerblade::before {
  content: "\\f0d2c";
}

.mdi-rollerblade-off::before {
  content: "\\f002e";
}

.mdi-rollupjs::before {
  content: "\\f0bc0";
}

.mdi-roman-numeral-1::before {
  content: "\\f1088";
}

.mdi-roman-numeral-10::before {
  content: "\\f1091";
}

.mdi-roman-numeral-2::before {
  content: "\\f1089";
}

.mdi-roman-numeral-3::before {
  content: "\\f108a";
}

.mdi-roman-numeral-4::before {
  content: "\\f108b";
}

.mdi-roman-numeral-5::before {
  content: "\\f108c";
}

.mdi-roman-numeral-6::before {
  content: "\\f108d";
}

.mdi-roman-numeral-7::before {
  content: "\\f108e";
}

.mdi-roman-numeral-8::before {
  content: "\\f108f";
}

.mdi-roman-numeral-9::before {
  content: "\\f1090";
}

.mdi-room-service::before {
  content: "\\f088d";
}

.mdi-room-service-outline::before {
  content: "\\f0d97";
}

.mdi-rotate-360::before {
  content: "\\f1999";
}

.mdi-rotate-3d::before {
  content: "\\f0ec7";
}

.mdi-rotate-3d-variant::before {
  content: "\\f0464";
}

.mdi-rotate-left::before {
  content: "\\f0465";
}

.mdi-rotate-left-variant::before {
  content: "\\f0466";
}

.mdi-rotate-orbit::before {
  content: "\\f0d98";
}

.mdi-rotate-right::before {
  content: "\\f0467";
}

.mdi-rotate-right-variant::before {
  content: "\\f0468";
}

.mdi-rounded-corner::before {
  content: "\\f0607";
}

.mdi-router::before {
  content: "\\f11e2";
}

.mdi-router-network::before {
  content: "\\f1087";
}

.mdi-router-wireless::before {
  content: "\\f0469";
}

.mdi-router-wireless-off::before {
  content: "\\f15a3";
}

.mdi-router-wireless-settings::before {
  content: "\\f0a69";
}

.mdi-routes::before {
  content: "\\f046a";
}

.mdi-routes-clock::before {
  content: "\\f1059";
}

.mdi-rowing::before {
  content: "\\f0608";
}

.mdi-rss::before {
  content: "\\f046b";
}

.mdi-rss-box::before {
  content: "\\f046c";
}

.mdi-rss-off::before {
  content: "\\f0f21";
}

.mdi-rug::before {
  content: "\\f1475";
}

.mdi-rugby::before {
  content: "\\f0d99";
}

.mdi-ruler::before {
  content: "\\f046d";
}

.mdi-ruler-square::before {
  content: "\\f0cc2";
}

.mdi-ruler-square-compass::before {
  content: "\\f0ebe";
}

.mdi-run::before {
  content: "\\f070e";
}

.mdi-run-fast::before {
  content: "\\f046e";
}

.mdi-rv-truck::before {
  content: "\\f11d4";
}

.mdi-sack::before {
  content: "\\f0d2e";
}

.mdi-sack-percent::before {
  content: "\\f0d2f";
}

.mdi-safe::before {
  content: "\\f0a6a";
}

.mdi-safe-square::before {
  content: "\\f127c";
}

.mdi-safe-square-outline::before {
  content: "\\f127d";
}

.mdi-safety-goggles::before {
  content: "\\f0d30";
}

.mdi-sail-boat::before {
  content: "\\f0ec8";
}

.mdi-sale::before {
  content: "\\f046f";
}

.mdi-salesforce::before {
  content: "\\f088e";
}

.mdi-sass::before {
  content: "\\f07ec";
}

.mdi-satellite::before {
  content: "\\f0470";
}

.mdi-satellite-uplink::before {
  content: "\\f0909";
}

.mdi-satellite-variant::before {
  content: "\\f0471";
}

.mdi-sausage::before {
  content: "\\f08ba";
}

.mdi-sausage-off::before {
  content: "\\f1789";
}

.mdi-saw-blade::before {
  content: "\\f0e61";
}

.mdi-sawtooth-wave::before {
  content: "\\f147a";
}

.mdi-saxophone::before {
  content: "\\f0609";
}

.mdi-scale::before {
  content: "\\f0472";
}

.mdi-scale-balance::before {
  content: "\\f05d1";
}

.mdi-scale-bathroom::before {
  content: "\\f0473";
}

.mdi-scale-off::before {
  content: "\\f105a";
}

.mdi-scale-unbalanced::before {
  content: "\\f19b8";
}

.mdi-scan-helper::before {
  content: "\\f13d8";
}

.mdi-scanner::before {
  content: "\\f06ab";
}

.mdi-scanner-off::before {
  content: "\\f090a";
}

.mdi-scatter-plot::before {
  content: "\\f0ec9";
}

.mdi-scatter-plot-outline::before {
  content: "\\f0eca";
}

.mdi-scent::before {
  content: "\\f1958";
}

.mdi-scent-off::before {
  content: "\\f1959";
}

.mdi-school::before {
  content: "\\f0474";
}

.mdi-school-outline::before {
  content: "\\f1180";
}

.mdi-scissors-cutting::before {
  content: "\\f0a6b";
}

.mdi-scooter::before {
  content: "\\f15bd";
}

.mdi-scooter-electric::before {
  content: "\\f15be";
}

.mdi-scoreboard::before {
  content: "\\f127e";
}

.mdi-scoreboard-outline::before {
  content: "\\f127f";
}

.mdi-screen-rotation::before {
  content: "\\f0475";
}

.mdi-screen-rotation-lock::before {
  content: "\\f0478";
}

.mdi-screw-flat-top::before {
  content: "\\f0df3";
}

.mdi-screw-lag::before {
  content: "\\f0df4";
}

.mdi-screw-machine-flat-top::before {
  content: "\\f0df5";
}

.mdi-screw-machine-round-top::before {
  content: "\\f0df6";
}

.mdi-screw-round-top::before {
  content: "\\f0df7";
}

.mdi-screwdriver::before {
  content: "\\f0476";
}

.mdi-script::before {
  content: "\\f0bc1";
}

.mdi-script-outline::before {
  content: "\\f0477";
}

.mdi-script-text::before {
  content: "\\f0bc2";
}

.mdi-script-text-key::before {
  content: "\\f1725";
}

.mdi-script-text-key-outline::before {
  content: "\\f1726";
}

.mdi-script-text-outline::before {
  content: "\\f0bc3";
}

.mdi-script-text-play::before {
  content: "\\f1727";
}

.mdi-script-text-play-outline::before {
  content: "\\f1728";
}

.mdi-sd::before {
  content: "\\f0479";
}

.mdi-seal::before {
  content: "\\f047a";
}

.mdi-seal-variant::before {
  content: "\\f0fd9";
}

.mdi-search-web::before {
  content: "\\f070f";
}

.mdi-seat::before {
  content: "\\f0cc3";
}

.mdi-seat-flat::before {
  content: "\\f047b";
}

.mdi-seat-flat-angled::before {
  content: "\\f047c";
}

.mdi-seat-individual-suite::before {
  content: "\\f047d";
}

.mdi-seat-legroom-extra::before {
  content: "\\f047e";
}

.mdi-seat-legroom-normal::before {
  content: "\\f047f";
}

.mdi-seat-legroom-reduced::before {
  content: "\\f0480";
}

.mdi-seat-outline::before {
  content: "\\f0cc4";
}

.mdi-seat-passenger::before {
  content: "\\f1249";
}

.mdi-seat-recline-extra::before {
  content: "\\f0481";
}

.mdi-seat-recline-normal::before {
  content: "\\f0482";
}

.mdi-seatbelt::before {
  content: "\\f0cc5";
}

.mdi-security::before {
  content: "\\f0483";
}

.mdi-security-network::before {
  content: "\\f0484";
}

.mdi-seed::before {
  content: "\\f0e62";
}

.mdi-seed-off::before {
  content: "\\f13fd";
}

.mdi-seed-off-outline::before {
  content: "\\f13fe";
}

.mdi-seed-outline::before {
  content: "\\f0e63";
}

.mdi-seesaw::before {
  content: "\\f15a4";
}

.mdi-segment::before {
  content: "\\f0ecb";
}

.mdi-select::before {
  content: "\\f0485";
}

.mdi-select-all::before {
  content: "\\f0486";
}

.mdi-select-color::before {
  content: "\\f0d31";
}

.mdi-select-compare::before {
  content: "\\f0ad9";
}

.mdi-select-drag::before {
  content: "\\f0a6c";
}

.mdi-select-group::before {
  content: "\\f0f82";
}

.mdi-select-inverse::before {
  content: "\\f0487";
}

.mdi-select-marker::before {
  content: "\\f1280";
}

.mdi-select-multiple::before {
  content: "\\f1281";
}

.mdi-select-multiple-marker::before {
  content: "\\f1282";
}

.mdi-select-off::before {
  content: "\\f0488";
}

.mdi-select-place::before {
  content: "\\f0fda";
}

.mdi-select-remove::before {
  content: "\\f17c1";
}

.mdi-select-search::before {
  content: "\\f1204";
}

.mdi-selection::before {
  content: "\\f0489";
}

.mdi-selection-drag::before {
  content: "\\f0a6d";
}

.mdi-selection-ellipse::before {
  content: "\\f0d32";
}

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\f0f22";
}

.mdi-selection-ellipse-remove::before {
  content: "\\f17c2";
}

.mdi-selection-marker::before {
  content: "\\f1283";
}

.mdi-selection-multiple::before {
  content: "\\f1285";
}

.mdi-selection-multiple-marker::before {
  content: "\\f1284";
}

.mdi-selection-off::before {
  content: "\\f0777";
}

.mdi-selection-remove::before {
  content: "\\f17c3";
}

.mdi-selection-search::before {
  content: "\\f1205";
}

.mdi-semantic-web::before {
  content: "\\f1316";
}

.mdi-send::before {
  content: "\\f048a";
}

.mdi-send-check::before {
  content: "\\f1161";
}

.mdi-send-check-outline::before {
  content: "\\f1162";
}

.mdi-send-circle::before {
  content: "\\f0df8";
}

.mdi-send-circle-outline::before {
  content: "\\f0df9";
}

.mdi-send-clock::before {
  content: "\\f1163";
}

.mdi-send-clock-outline::before {
  content: "\\f1164";
}

.mdi-send-lock::before {
  content: "\\f07ed";
}

.mdi-send-lock-outline::before {
  content: "\\f1166";
}

.mdi-send-outline::before {
  content: "\\f1165";
}

.mdi-serial-port::before {
  content: "\\f065c";
}

.mdi-server::before {
  content: "\\f048b";
}

.mdi-server-minus::before {
  content: "\\f048c";
}

.mdi-server-network::before {
  content: "\\f048d";
}

.mdi-server-network-off::before {
  content: "\\f048e";
}

.mdi-server-off::before {
  content: "\\f048f";
}

.mdi-server-plus::before {
  content: "\\f0490";
}

.mdi-server-remove::before {
  content: "\\f0491";
}

.mdi-server-security::before {
  content: "\\f0492";
}

.mdi-set-all::before {
  content: "\\f0778";
}

.mdi-set-center::before {
  content: "\\f0779";
}

.mdi-set-center-right::before {
  content: "\\f077a";
}

.mdi-set-left::before {
  content: "\\f077b";
}

.mdi-set-left-center::before {
  content: "\\f077c";
}

.mdi-set-left-right::before {
  content: "\\f077d";
}

.mdi-set-merge::before {
  content: "\\f14e0";
}

.mdi-set-none::before {
  content: "\\f077e";
}

.mdi-set-right::before {
  content: "\\f077f";
}

.mdi-set-split::before {
  content: "\\f14e1";
}

.mdi-set-square::before {
  content: "\\f145d";
}

.mdi-set-top-box::before {
  content: "\\f099f";
}

.mdi-settings-helper::before {
  content: "\\f0a6e";
}

.mdi-shaker::before {
  content: "\\f110e";
}

.mdi-shaker-outline::before {
  content: "\\f110f";
}

.mdi-shape::before {
  content: "\\f0831";
}

.mdi-shape-circle-plus::before {
  content: "\\f065d";
}

.mdi-shape-outline::before {
  content: "\\f0832";
}

.mdi-shape-oval-plus::before {
  content: "\\f11fa";
}

.mdi-shape-plus::before {
  content: "\\f0495";
}

.mdi-shape-polygon-plus::before {
  content: "\\f065e";
}

.mdi-shape-rectangle-plus::before {
  content: "\\f065f";
}

.mdi-shape-square-plus::before {
  content: "\\f0660";
}

.mdi-shape-square-rounded-plus::before {
  content: "\\f14fa";
}

.mdi-share::before {
  content: "\\f0496";
}

.mdi-share-all::before {
  content: "\\f11f4";
}

.mdi-share-all-outline::before {
  content: "\\f11f5";
}

.mdi-share-circle::before {
  content: "\\f11ad";
}

.mdi-share-off::before {
  content: "\\f0f23";
}

.mdi-share-off-outline::before {
  content: "\\f0f24";
}

.mdi-share-outline::before {
  content: "\\f0932";
}

.mdi-share-variant::before {
  content: "\\f0497";
}

.mdi-share-variant-outline::before {
  content: "\\f1514";
}

.mdi-shark::before {
  content: "\\f18ba";
}

.mdi-shark-fin::before {
  content: "\\f1673";
}

.mdi-shark-fin-outline::before {
  content: "\\f1674";
}

.mdi-shark-off::before {
  content: "\\f18bb";
}

.mdi-sheep::before {
  content: "\\f0cc6";
}

.mdi-shield::before {
  content: "\\f0498";
}

.mdi-shield-account::before {
  content: "\\f088f";
}

.mdi-shield-account-outline::before {
  content: "\\f0a12";
}

.mdi-shield-account-variant::before {
  content: "\\f15a7";
}

.mdi-shield-account-variant-outline::before {
  content: "\\f15a8";
}

.mdi-shield-airplane::before {
  content: "\\f06bb";
}

.mdi-shield-airplane-outline::before {
  content: "\\f0cc7";
}

.mdi-shield-alert::before {
  content: "\\f0ecc";
}

.mdi-shield-alert-outline::before {
  content: "\\f0ecd";
}

.mdi-shield-bug::before {
  content: "\\f13da";
}

.mdi-shield-bug-outline::before {
  content: "\\f13db";
}

.mdi-shield-car::before {
  content: "\\f0f83";
}

.mdi-shield-check::before {
  content: "\\f0565";
}

.mdi-shield-check-outline::before {
  content: "\\f0cc8";
}

.mdi-shield-cross::before {
  content: "\\f0cc9";
}

.mdi-shield-cross-outline::before {
  content: "\\f0cca";
}

.mdi-shield-crown::before {
  content: "\\f18bc";
}

.mdi-shield-crown-outline::before {
  content: "\\f18bd";
}

.mdi-shield-edit::before {
  content: "\\f11a0";
}

.mdi-shield-edit-outline::before {
  content: "\\f11a1";
}

.mdi-shield-half::before {
  content: "\\f1360";
}

.mdi-shield-half-full::before {
  content: "\\f0780";
}

.mdi-shield-home::before {
  content: "\\f068a";
}

.mdi-shield-home-outline::before {
  content: "\\f0ccb";
}

.mdi-shield-key::before {
  content: "\\f0bc4";
}

.mdi-shield-key-outline::before {
  content: "\\f0bc5";
}

.mdi-shield-link-variant::before {
  content: "\\f0d33";
}

.mdi-shield-link-variant-outline::before {
  content: "\\f0d34";
}

.mdi-shield-lock::before {
  content: "\\f099d";
}

.mdi-shield-lock-open::before {
  content: "\\f199a";
}

.mdi-shield-lock-open-outline::before {
  content: "\\f199b";
}

.mdi-shield-lock-outline::before {
  content: "\\f0ccc";
}

.mdi-shield-moon::before {
  content: "\\f1828";
}

.mdi-shield-moon-outline::before {
  content: "\\f1829";
}

.mdi-shield-off::before {
  content: "\\f099e";
}

.mdi-shield-off-outline::before {
  content: "\\f099c";
}

.mdi-shield-outline::before {
  content: "\\f0499";
}

.mdi-shield-plus::before {
  content: "\\f0ada";
}

.mdi-shield-plus-outline::before {
  content: "\\f0adb";
}

.mdi-shield-refresh::before {
  content: "\\f00aa";
}

.mdi-shield-refresh-outline::before {
  content: "\\f01e0";
}

.mdi-shield-remove::before {
  content: "\\f0adc";
}

.mdi-shield-remove-outline::before {
  content: "\\f0add";
}

.mdi-shield-search::before {
  content: "\\f0d9a";
}

.mdi-shield-star::before {
  content: "\\f113b";
}

.mdi-shield-star-outline::before {
  content: "\\f113c";
}

.mdi-shield-sun::before {
  content: "\\f105d";
}

.mdi-shield-sun-outline::before {
  content: "\\f105e";
}

.mdi-shield-sword::before {
  content: "\\f18be";
}

.mdi-shield-sword-outline::before {
  content: "\\f18bf";
}

.mdi-shield-sync::before {
  content: "\\f11a2";
}

.mdi-shield-sync-outline::before {
  content: "\\f11a3";
}

.mdi-shimmer::before {
  content: "\\f1545";
}

.mdi-ship-wheel::before {
  content: "\\f0833";
}

.mdi-shipping-pallet::before {
  content: "\\f184e";
}

.mdi-shoe-ballet::before {
  content: "\\f15ca";
}

.mdi-shoe-cleat::before {
  content: "\\f15c7";
}

.mdi-shoe-formal::before {
  content: "\\f0b47";
}

.mdi-shoe-heel::before {
  content: "\\f0b48";
}

.mdi-shoe-print::before {
  content: "\\f0dfa";
}

.mdi-shoe-sneaker::before {
  content: "\\f15c8";
}

.mdi-shopping::before {
  content: "\\f049a";
}

.mdi-shopping-music::before {
  content: "\\f049b";
}

.mdi-shopping-outline::before {
  content: "\\f11d5";
}

.mdi-shopping-search::before {
  content: "\\f0f84";
}

.mdi-shore::before {
  content: "\\f14f9";
}

.mdi-shovel::before {
  content: "\\f0710";
}

.mdi-shovel-off::before {
  content: "\\f0711";
}

.mdi-shower::before {
  content: "\\f09a0";
}

.mdi-shower-head::before {
  content: "\\f09a1";
}

.mdi-shredder::before {
  content: "\\f049c";
}

.mdi-shuffle::before {
  content: "\\f049d";
}

.mdi-shuffle-disabled::before {
  content: "\\f049e";
}

.mdi-shuffle-variant::before {
  content: "\\f049f";
}

.mdi-shuriken::before {
  content: "\\f137f";
}

.mdi-sickle::before {
  content: "\\f18c0";
}

.mdi-sigma::before {
  content: "\\f04a0";
}

.mdi-sigma-lower::before {
  content: "\\f062b";
}

.mdi-sign-caution::before {
  content: "\\f04a1";
}

.mdi-sign-direction::before {
  content: "\\f0781";
}

.mdi-sign-direction-minus::before {
  content: "\\f1000";
}

.mdi-sign-direction-plus::before {
  content: "\\f0fdc";
}

.mdi-sign-direction-remove::before {
  content: "\\f0fdd";
}

.mdi-sign-pole::before {
  content: "\\f14f8";
}

.mdi-sign-real-estate::before {
  content: "\\f1118";
}

.mdi-sign-text::before {
  content: "\\f0782";
}

.mdi-signal::before {
  content: "\\f04a2";
}

.mdi-signal-2g::before {
  content: "\\f0712";
}

.mdi-signal-3g::before {
  content: "\\f0713";
}

.mdi-signal-4g::before {
  content: "\\f0714";
}

.mdi-signal-5g::before {
  content: "\\f0a6f";
}

.mdi-signal-cellular-1::before {
  content: "\\f08bc";
}

.mdi-signal-cellular-2::before {
  content: "\\f08bd";
}

.mdi-signal-cellular-3::before {
  content: "\\f08be";
}

.mdi-signal-cellular-outline::before {
  content: "\\f08bf";
}

.mdi-signal-distance-variant::before {
  content: "\\f0e64";
}

.mdi-signal-hspa::before {
  content: "\\f0715";
}

.mdi-signal-hspa-plus::before {
  content: "\\f0716";
}

.mdi-signal-off::before {
  content: "\\f0783";
}

.mdi-signal-variant::before {
  content: "\\f060a";
}

.mdi-signature::before {
  content: "\\f0dfb";
}

.mdi-signature-freehand::before {
  content: "\\f0dfc";
}

.mdi-signature-image::before {
  content: "\\f0dfd";
}

.mdi-signature-text::before {
  content: "\\f0dfe";
}

.mdi-silo::before {
  content: "\\f0b49";
}

.mdi-silverware::before {
  content: "\\f04a3";
}

.mdi-silverware-clean::before {
  content: "\\f0fde";
}

.mdi-silverware-fork::before {
  content: "\\f04a4";
}

.mdi-silverware-fork-knife::before {
  content: "\\f0a70";
}

.mdi-silverware-spoon::before {
  content: "\\f04a5";
}

.mdi-silverware-variant::before {
  content: "\\f04a6";
}

.mdi-sim::before {
  content: "\\f04a7";
}

.mdi-sim-alert::before {
  content: "\\f04a8";
}

.mdi-sim-alert-outline::before {
  content: "\\f15d3";
}

.mdi-sim-off::before {
  content: "\\f04a9";
}

.mdi-sim-off-outline::before {
  content: "\\f15d4";
}

.mdi-sim-outline::before {
  content: "\\f15d5";
}

.mdi-simple-icons::before {
  content: "\\f131d";
}

.mdi-sina-weibo::before {
  content: "\\f0adf";
}

.mdi-sine-wave::before {
  content: "\\f095b";
}

.mdi-sitemap::before {
  content: "\\f04aa";
}

.mdi-sitemap-outline::before {
  content: "\\f199c";
}

.mdi-size-l::before {
  content: "\\f13a6";
}

.mdi-size-m::before {
  content: "\\f13a5";
}

.mdi-size-s::before {
  content: "\\f13a4";
}

.mdi-size-xl::before {
  content: "\\f13a7";
}

.mdi-size-xs::before {
  content: "\\f13a3";
}

.mdi-size-xxl::before {
  content: "\\f13a8";
}

.mdi-size-xxs::before {
  content: "\\f13a2";
}

.mdi-size-xxxl::before {
  content: "\\f13a9";
}

.mdi-skate::before {
  content: "\\f0d35";
}

.mdi-skate-off::before {
  content: "\\f0699";
}

.mdi-skateboard::before {
  content: "\\f14c2";
}

.mdi-skateboarding::before {
  content: "\\f0501";
}

.mdi-skew-less::before {
  content: "\\f0d36";
}

.mdi-skew-more::before {
  content: "\\f0d37";
}

.mdi-ski::before {
  content: "\\f1304";
}

.mdi-ski-cross-country::before {
  content: "\\f1305";
}

.mdi-ski-water::before {
  content: "\\f1306";
}

.mdi-skip-backward::before {
  content: "\\f04ab";
}

.mdi-skip-backward-outline::before {
  content: "\\f0f25";
}

.mdi-skip-forward::before {
  content: "\\f04ac";
}

.mdi-skip-forward-outline::before {
  content: "\\f0f26";
}

.mdi-skip-next::before {
  content: "\\f04ad";
}

.mdi-skip-next-circle::before {
  content: "\\f0661";
}

.mdi-skip-next-circle-outline::before {
  content: "\\f0662";
}

.mdi-skip-next-outline::before {
  content: "\\f0f27";
}

.mdi-skip-previous::before {
  content: "\\f04ae";
}

.mdi-skip-previous-circle::before {
  content: "\\f0663";
}

.mdi-skip-previous-circle-outline::before {
  content: "\\f0664";
}

.mdi-skip-previous-outline::before {
  content: "\\f0f28";
}

.mdi-skull::before {
  content: "\\f068c";
}

.mdi-skull-crossbones::before {
  content: "\\f0bc6";
}

.mdi-skull-crossbones-outline::before {
  content: "\\f0bc7";
}

.mdi-skull-outline::before {
  content: "\\f0bc8";
}

.mdi-skull-scan::before {
  content: "\\f14c7";
}

.mdi-skull-scan-outline::before {
  content: "\\f14c8";
}

.mdi-skype::before {
  content: "\\f04af";
}

.mdi-skype-business::before {
  content: "\\f04b0";
}

.mdi-slack::before {
  content: "\\f04b1";
}

.mdi-slash-forward::before {
  content: "\\f0fdf";
}

.mdi-slash-forward-box::before {
  content: "\\f0fe0";
}

.mdi-sledding::before {
  content: "\\f041b";
}

.mdi-sleep::before {
  content: "\\f04b2";
}

.mdi-sleep-off::before {
  content: "\\f04b3";
}

.mdi-slide::before {
  content: "\\f15a5";
}

.mdi-slope-downhill::before {
  content: "\\f0dff";
}

.mdi-slope-uphill::before {
  content: "\\f0e00";
}

.mdi-slot-machine::before {
  content: "\\f1114";
}

.mdi-slot-machine-outline::before {
  content: "\\f1115";
}

.mdi-smart-card::before {
  content: "\\f10bd";
}

.mdi-smart-card-off::before {
  content: "\\f18f7";
}

.mdi-smart-card-off-outline::before {
  content: "\\f18f8";
}

.mdi-smart-card-outline::before {
  content: "\\f10be";
}

.mdi-smart-card-reader::before {
  content: "\\f10bf";
}

.mdi-smart-card-reader-outline::before {
  content: "\\f10c0";
}

.mdi-smog::before {
  content: "\\f0a71";
}

.mdi-smoke::before {
  content: "\\f1799";
}

.mdi-smoke-detector::before {
  content: "\\f0392";
}

.mdi-smoke-detector-alert::before {
  content: "\\f192e";
}

.mdi-smoke-detector-alert-outline::before {
  content: "\\f192f";
}

.mdi-smoke-detector-off::before {
  content: "\\f1809";
}

.mdi-smoke-detector-off-outline::before {
  content: "\\f180a";
}

.mdi-smoke-detector-outline::before {
  content: "\\f1808";
}

.mdi-smoke-detector-variant::before {
  content: "\\f180b";
}

.mdi-smoke-detector-variant-alert::before {
  content: "\\f1930";
}

.mdi-smoke-detector-variant-off::before {
  content: "\\f180c";
}

.mdi-smoking::before {
  content: "\\f04b4";
}

.mdi-smoking-off::before {
  content: "\\f04b5";
}

.mdi-smoking-pipe::before {
  content: "\\f140d";
}

.mdi-smoking-pipe-off::before {
  content: "\\f1428";
}

.mdi-snail::before {
  content: "\\f1677";
}

.mdi-snake::before {
  content: "\\f150e";
}

.mdi-snapchat::before {
  content: "\\f04b6";
}

.mdi-snowboard::before {
  content: "\\f1307";
}

.mdi-snowflake::before {
  content: "\\f0717";
}

.mdi-snowflake-alert::before {
  content: "\\f0f29";
}

.mdi-snowflake-melt::before {
  content: "\\f12cb";
}

.mdi-snowflake-off::before {
  content: "\\f14e3";
}

.mdi-snowflake-variant::before {
  content: "\\f0f2a";
}

.mdi-snowman::before {
  content: "\\f04b7";
}

.mdi-snowmobile::before {
  content: "\\f06dd";
}

.mdi-soccer::before {
  content: "\\f04b8";
}

.mdi-soccer-field::before {
  content: "\\f0834";
}

.mdi-social-distance-2-meters::before {
  content: "\\f1579";
}

.mdi-social-distance-6-feet::before {
  content: "\\f157a";
}

.mdi-sofa::before {
  content: "\\f04b9";
}

.mdi-sofa-outline::before {
  content: "\\f156d";
}

.mdi-sofa-single::before {
  content: "\\f156e";
}

.mdi-sofa-single-outline::before {
  content: "\\f156f";
}

.mdi-solar-panel::before {
  content: "\\f0d9b";
}

.mdi-solar-panel-large::before {
  content: "\\f0d9c";
}

.mdi-solar-power::before {
  content: "\\f0a72";
}

.mdi-soldering-iron::before {
  content: "\\f1092";
}

.mdi-solid::before {
  content: "\\f068d";
}

.mdi-sony-playstation::before {
  content: "\\f0414";
}

.mdi-sort::before {
  content: "\\f04ba";
}

.mdi-sort-alphabetical-ascending::before {
  content: "\\f05bd";
}

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\f1148";
}

.mdi-sort-alphabetical-descending::before {
  content: "\\f05bf";
}

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\f1149";
}

.mdi-sort-alphabetical-variant::before {
  content: "\\f04bb";
}

.mdi-sort-ascending::before {
  content: "\\f04bc";
}

.mdi-sort-bool-ascending::before {
  content: "\\f1385";
}

.mdi-sort-bool-ascending-variant::before {
  content: "\\f1386";
}

.mdi-sort-bool-descending::before {
  content: "\\f1387";
}

.mdi-sort-bool-descending-variant::before {
  content: "\\f1388";
}

.mdi-sort-calendar-ascending::before {
  content: "\\f1547";
}

.mdi-sort-calendar-descending::before {
  content: "\\f1548";
}

.mdi-sort-clock-ascending::before {
  content: "\\f1549";
}

.mdi-sort-clock-ascending-outline::before {
  content: "\\f154a";
}

.mdi-sort-clock-descending::before {
  content: "\\f154b";
}

.mdi-sort-clock-descending-outline::before {
  content: "\\f154c";
}

.mdi-sort-descending::before {
  content: "\\f04bd";
}

.mdi-sort-numeric-ascending::before {
  content: "\\f1389";
}

.mdi-sort-numeric-ascending-variant::before {
  content: "\\f090d";
}

.mdi-sort-numeric-descending::before {
  content: "\\f138a";
}

.mdi-sort-numeric-descending-variant::before {
  content: "\\f0ad2";
}

.mdi-sort-numeric-variant::before {
  content: "\\f04be";
}

.mdi-sort-reverse-variant::before {
  content: "\\f033c";
}

.mdi-sort-variant::before {
  content: "\\f04bf";
}

.mdi-sort-variant-lock::before {
  content: "\\f0ccd";
}

.mdi-sort-variant-lock-open::before {
  content: "\\f0cce";
}

.mdi-sort-variant-remove::before {
  content: "\\f1147";
}

.mdi-soundbar::before {
  content: "\\f17db";
}

.mdi-soundcloud::before {
  content: "\\f04c0";
}

.mdi-source-branch::before {
  content: "\\f062c";
}

.mdi-source-branch-check::before {
  content: "\\f14cf";
}

.mdi-source-branch-minus::before {
  content: "\\f14cb";
}

.mdi-source-branch-plus::before {
  content: "\\f14ca";
}

.mdi-source-branch-refresh::before {
  content: "\\f14cd";
}

.mdi-source-branch-remove::before {
  content: "\\f14cc";
}

.mdi-source-branch-sync::before {
  content: "\\f14ce";
}

.mdi-source-commit::before {
  content: "\\f0718";
}

.mdi-source-commit-end::before {
  content: "\\f0719";
}

.mdi-source-commit-end-local::before {
  content: "\\f071a";
}

.mdi-source-commit-local::before {
  content: "\\f071b";
}

.mdi-source-commit-next-local::before {
  content: "\\f071c";
}

.mdi-source-commit-start::before {
  content: "\\f071d";
}

.mdi-source-commit-start-next-local::before {
  content: "\\f071e";
}

.mdi-source-fork::before {
  content: "\\f04c1";
}

.mdi-source-merge::before {
  content: "\\f062d";
}

.mdi-source-pull::before {
  content: "\\f04c2";
}

.mdi-source-repository::before {
  content: "\\f0ccf";
}

.mdi-source-repository-multiple::before {
  content: "\\f0cd0";
}

.mdi-soy-sauce::before {
  content: "\\f07ee";
}

.mdi-soy-sauce-off::before {
  content: "\\f13fc";
}

.mdi-spa::before {
  content: "\\f0cd1";
}

.mdi-spa-outline::before {
  content: "\\f0cd2";
}

.mdi-space-invaders::before {
  content: "\\f0bc9";
}

.mdi-space-station::before {
  content: "\\f1383";
}

.mdi-spade::before {
  content: "\\f0e65";
}

.mdi-speaker::before {
  content: "\\f04c3";
}

.mdi-speaker-bluetooth::before {
  content: "\\f09a2";
}

.mdi-speaker-multiple::before {
  content: "\\f0d38";
}

.mdi-speaker-off::before {
  content: "\\f04c4";
}

.mdi-speaker-wireless::before {
  content: "\\f071f";
}

.mdi-spear::before {
  content: "\\f1845";
}

.mdi-speedometer::before {
  content: "\\f04c5";
}

.mdi-speedometer-medium::before {
  content: "\\f0f85";
}

.mdi-speedometer-slow::before {
  content: "\\f0f86";
}

.mdi-spellcheck::before {
  content: "\\f04c6";
}

.mdi-sphere::before {
  content: "\\f1954";
}

.mdi-sphere-off::before {
  content: "\\f1955";
}

.mdi-spider::before {
  content: "\\f11ea";
}

.mdi-spider-thread::before {
  content: "\\f11eb";
}

.mdi-spider-web::before {
  content: "\\f0bca";
}

.mdi-spirit-level::before {
  content: "\\f14f1";
}

.mdi-spoon-sugar::before {
  content: "\\f1429";
}

.mdi-spotify::before {
  content: "\\f04c7";
}

.mdi-spotlight::before {
  content: "\\f04c8";
}

.mdi-spotlight-beam::before {
  content: "\\f04c9";
}

.mdi-spray::before {
  content: "\\f0665";
}

.mdi-spray-bottle::before {
  content: "\\f0ae0";
}

.mdi-sprinkler::before {
  content: "\\f105f";
}

.mdi-sprinkler-fire::before {
  content: "\\f199d";
}

.mdi-sprinkler-variant::before {
  content: "\\f1060";
}

.mdi-sprout::before {
  content: "\\f0e66";
}

.mdi-sprout-outline::before {
  content: "\\f0e67";
}

.mdi-square::before {
  content: "\\f0764";
}

.mdi-square-circle::before {
  content: "\\f1500";
}

.mdi-square-edit-outline::before {
  content: "\\f090c";
}

.mdi-square-medium::before {
  content: "\\f0a13";
}

.mdi-square-medium-outline::before {
  content: "\\f0a14";
}

.mdi-square-off::before {
  content: "\\f12ee";
}

.mdi-square-off-outline::before {
  content: "\\f12ef";
}

.mdi-square-opacity::before {
  content: "\\f1854";
}

.mdi-square-outline::before {
  content: "\\f0763";
}

.mdi-square-root::before {
  content: "\\f0784";
}

.mdi-square-root-box::before {
  content: "\\f09a3";
}

.mdi-square-rounded::before {
  content: "\\f14fb";
}

.mdi-square-rounded-outline::before {
  content: "\\f14fc";
}

.mdi-square-small::before {
  content: "\\f0a15";
}

.mdi-square-wave::before {
  content: "\\f147b";
}

.mdi-squeegee::before {
  content: "\\f0ae1";
}

.mdi-ssh::before {
  content: "\\f08c0";
}

.mdi-stack-exchange::before {
  content: "\\f060b";
}

.mdi-stack-overflow::before {
  content: "\\f04cc";
}

.mdi-stackpath::before {
  content: "\\f0359";
}

.mdi-stadium::before {
  content: "\\f0ff9";
}

.mdi-stadium-variant::before {
  content: "\\f0720";
}

.mdi-stairs::before {
  content: "\\f04cd";
}

.mdi-stairs-box::before {
  content: "\\f139e";
}

.mdi-stairs-down::before {
  content: "\\f12be";
}

.mdi-stairs-up::before {
  content: "\\f12bd";
}

.mdi-stamper::before {
  content: "\\f0d39";
}

.mdi-standard-definition::before {
  content: "\\f07ef";
}

.mdi-star::before {
  content: "\\f04ce";
}

.mdi-star-box::before {
  content: "\\f0a73";
}

.mdi-star-box-multiple::before {
  content: "\\f1286";
}

.mdi-star-box-multiple-outline::before {
  content: "\\f1287";
}

.mdi-star-box-outline::before {
  content: "\\f0a74";
}

.mdi-star-check::before {
  content: "\\f1566";
}

.mdi-star-check-outline::before {
  content: "\\f156a";
}

.mdi-star-circle::before {
  content: "\\f04cf";
}

.mdi-star-circle-outline::before {
  content: "\\f09a4";
}

.mdi-star-cog::before {
  content: "\\f1668";
}

.mdi-star-cog-outline::before {
  content: "\\f1669";
}

.mdi-star-crescent::before {
  content: "\\f0979";
}

.mdi-star-david::before {
  content: "\\f097a";
}

.mdi-star-face::before {
  content: "\\f09a5";
}

.mdi-star-four-points::before {
  content: "\\f0ae2";
}

.mdi-star-four-points-outline::before {
  content: "\\f0ae3";
}

.mdi-star-half::before {
  content: "\\f0246";
}

.mdi-star-half-full::before {
  content: "\\f04d0";
}

.mdi-star-minus::before {
  content: "\\f1564";
}

.mdi-star-minus-outline::before {
  content: "\\f1568";
}

.mdi-star-off::before {
  content: "\\f04d1";
}

.mdi-star-off-outline::before {
  content: "\\f155b";
}

.mdi-star-outline::before {
  content: "\\f04d2";
}

.mdi-star-plus::before {
  content: "\\f1563";
}

.mdi-star-plus-outline::before {
  content: "\\f1567";
}

.mdi-star-remove::before {
  content: "\\f1565";
}

.mdi-star-remove-outline::before {
  content: "\\f1569";
}

.mdi-star-settings::before {
  content: "\\f166a";
}

.mdi-star-settings-outline::before {
  content: "\\f166b";
}

.mdi-star-shooting::before {
  content: "\\f1741";
}

.mdi-star-shooting-outline::before {
  content: "\\f1742";
}

.mdi-star-three-points::before {
  content: "\\f0ae4";
}

.mdi-star-three-points-outline::before {
  content: "\\f0ae5";
}

.mdi-state-machine::before {
  content: "\\f11ef";
}

.mdi-steam::before {
  content: "\\f04d3";
}

.mdi-steering::before {
  content: "\\f04d4";
}

.mdi-steering-off::before {
  content: "\\f090e";
}

.mdi-step-backward::before {
  content: "\\f04d5";
}

.mdi-step-backward-2::before {
  content: "\\f04d6";
}

.mdi-step-forward::before {
  content: "\\f04d7";
}

.mdi-step-forward-2::before {
  content: "\\f04d8";
}

.mdi-stethoscope::before {
  content: "\\f04d9";
}

.mdi-sticker::before {
  content: "\\f1364";
}

.mdi-sticker-alert::before {
  content: "\\f1365";
}

.mdi-sticker-alert-outline::before {
  content: "\\f1366";
}

.mdi-sticker-check::before {
  content: "\\f1367";
}

.mdi-sticker-check-outline::before {
  content: "\\f1368";
}

.mdi-sticker-circle-outline::before {
  content: "\\f05d0";
}

.mdi-sticker-emoji::before {
  content: "\\f0785";
}

.mdi-sticker-minus::before {
  content: "\\f1369";
}

.mdi-sticker-minus-outline::before {
  content: "\\f136a";
}

.mdi-sticker-outline::before {
  content: "\\f136b";
}

.mdi-sticker-plus::before {
  content: "\\f136c";
}

.mdi-sticker-plus-outline::before {
  content: "\\f136d";
}

.mdi-sticker-remove::before {
  content: "\\f136e";
}

.mdi-sticker-remove-outline::before {
  content: "\\f136f";
}

.mdi-sticker-text::before {
  content: "\\f178e";
}

.mdi-sticker-text-outline::before {
  content: "\\f178f";
}

.mdi-stocking::before {
  content: "\\f04da";
}

.mdi-stomach::before {
  content: "\\f1093";
}

.mdi-stool::before {
  content: "\\f195d";
}

.mdi-stool-outline::before {
  content: "\\f195e";
}

.mdi-stop::before {
  content: "\\f04db";
}

.mdi-stop-circle::before {
  content: "\\f0666";
}

.mdi-stop-circle-outline::before {
  content: "\\f0667";
}

.mdi-store::before {
  content: "\\f04dc";
}

.mdi-store-24-hour::before {
  content: "\\f04dd";
}

.mdi-store-alert::before {
  content: "\\f18c1";
}

.mdi-store-alert-outline::before {
  content: "\\f18c2";
}

.mdi-store-check::before {
  content: "\\f18c3";
}

.mdi-store-check-outline::before {
  content: "\\f18c4";
}

.mdi-store-clock::before {
  content: "\\f18c5";
}

.mdi-store-clock-outline::before {
  content: "\\f18c6";
}

.mdi-store-cog::before {
  content: "\\f18c7";
}

.mdi-store-cog-outline::before {
  content: "\\f18c8";
}

.mdi-store-edit::before {
  content: "\\f18c9";
}

.mdi-store-edit-outline::before {
  content: "\\f18ca";
}

.mdi-store-marker::before {
  content: "\\f18cb";
}

.mdi-store-marker-outline::before {
  content: "\\f18cc";
}

.mdi-store-minus::before {
  content: "\\f165e";
}

.mdi-store-minus-outline::before {
  content: "\\f18cd";
}

.mdi-store-off::before {
  content: "\\f18ce";
}

.mdi-store-off-outline::before {
  content: "\\f18cf";
}

.mdi-store-outline::before {
  content: "\\f1361";
}

.mdi-store-plus::before {
  content: "\\f165f";
}

.mdi-store-plus-outline::before {
  content: "\\f18d0";
}

.mdi-store-remove::before {
  content: "\\f1660";
}

.mdi-store-remove-outline::before {
  content: "\\f18d1";
}

.mdi-store-search::before {
  content: "\\f18d2";
}

.mdi-store-search-outline::before {
  content: "\\f18d3";
}

.mdi-store-settings::before {
  content: "\\f18d4";
}

.mdi-store-settings-outline::before {
  content: "\\f18d5";
}

.mdi-storefront::before {
  content: "\\f07c7";
}

.mdi-storefront-outline::before {
  content: "\\f10c1";
}

.mdi-stove::before {
  content: "\\f04de";
}

.mdi-strategy::before {
  content: "\\f11d6";
}

.mdi-stretch-to-page::before {
  content: "\\f0f2b";
}

.mdi-stretch-to-page-outline::before {
  content: "\\f0f2c";
}

.mdi-string-lights::before {
  content: "\\f12ba";
}

.mdi-string-lights-off::before {
  content: "\\f12bb";
}

.mdi-subdirectory-arrow-left::before {
  content: "\\f060c";
}

.mdi-subdirectory-arrow-right::before {
  content: "\\f060d";
}

.mdi-submarine::before {
  content: "\\f156c";
}

.mdi-subtitles::before {
  content: "\\f0a16";
}

.mdi-subtitles-outline::before {
  content: "\\f0a17";
}

.mdi-subway::before {
  content: "\\f06ac";
}

.mdi-subway-alert-variant::before {
  content: "\\f0d9d";
}

.mdi-subway-variant::before {
  content: "\\f04df";
}

.mdi-summit::before {
  content: "\\f0786";
}

.mdi-sun-compass::before {
  content: "\\f19a5";
}

.mdi-sun-snowflake::before {
  content: "\\f1796";
}

.mdi-sun-thermometer::before {
  content: "\\f18d6";
}

.mdi-sun-thermometer-outline::before {
  content: "\\f18d7";
}

.mdi-sun-wireless::before {
  content: "\\f17fe";
}

.mdi-sun-wireless-outline::before {
  content: "\\f17ff";
}

.mdi-sunglasses::before {
  content: "\\f04e0";
}

.mdi-surfing::before {
  content: "\\f1746";
}

.mdi-surround-sound::before {
  content: "\\f05c5";
}

.mdi-surround-sound-2-0::before {
  content: "\\f07f0";
}

.mdi-surround-sound-2-1::before {
  content: "\\f1729";
}

.mdi-surround-sound-3-1::before {
  content: "\\f07f1";
}

.mdi-surround-sound-5-1::before {
  content: "\\f07f2";
}

.mdi-surround-sound-5-1-2::before {
  content: "\\f172a";
}

.mdi-surround-sound-7-1::before {
  content: "\\f07f3";
}

.mdi-svg::before {
  content: "\\f0721";
}

.mdi-swap-horizontal::before {
  content: "\\f04e1";
}

.mdi-swap-horizontal-bold::before {
  content: "\\f0bcd";
}

.mdi-swap-horizontal-circle::before {
  content: "\\f0fe1";
}

.mdi-swap-horizontal-circle-outline::before {
  content: "\\f0fe2";
}

.mdi-swap-horizontal-variant::before {
  content: "\\f08c1";
}

.mdi-swap-vertical::before {
  content: "\\f04e2";
}

.mdi-swap-vertical-bold::before {
  content: "\\f0bce";
}

.mdi-swap-vertical-circle::before {
  content: "\\f0fe3";
}

.mdi-swap-vertical-circle-outline::before {
  content: "\\f0fe4";
}

.mdi-swap-vertical-variant::before {
  content: "\\f08c2";
}

.mdi-swim::before {
  content: "\\f04e3";
}

.mdi-switch::before {
  content: "\\f04e4";
}

.mdi-sword::before {
  content: "\\f04e5";
}

.mdi-sword-cross::before {
  content: "\\f0787";
}

.mdi-syllabary-hangul::before {
  content: "\\f1333";
}

.mdi-syllabary-hiragana::before {
  content: "\\f1334";
}

.mdi-syllabary-katakana::before {
  content: "\\f1335";
}

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\f1336";
}

.mdi-symbol::before {
  content: "\\f1501";
}

.mdi-symfony::before {
  content: "\\f0ae6";
}

.mdi-sync::before {
  content: "\\f04e6";
}

.mdi-sync-alert::before {
  content: "\\f04e7";
}

.mdi-sync-circle::before {
  content: "\\f1378";
}

.mdi-sync-off::before {
  content: "\\f04e8";
}

.mdi-tab::before {
  content: "\\f04e9";
}

.mdi-tab-minus::before {
  content: "\\f0b4b";
}

.mdi-tab-plus::before {
  content: "\\f075c";
}

.mdi-tab-remove::before {
  content: "\\f0b4c";
}

.mdi-tab-search::before {
  content: "\\f199e";
}

.mdi-tab-unselected::before {
  content: "\\f04ea";
}

.mdi-table::before {
  content: "\\f04eb";
}

.mdi-table-account::before {
  content: "\\f13b9";
}

.mdi-table-alert::before {
  content: "\\f13ba";
}

.mdi-table-arrow-down::before {
  content: "\\f13bb";
}

.mdi-table-arrow-left::before {
  content: "\\f13bc";
}

.mdi-table-arrow-right::before {
  content: "\\f13bd";
}

.mdi-table-arrow-up::before {
  content: "\\f13be";
}

.mdi-table-border::before {
  content: "\\f0a18";
}

.mdi-table-cancel::before {
  content: "\\f13bf";
}

.mdi-table-chair::before {
  content: "\\f1061";
}

.mdi-table-check::before {
  content: "\\f13c0";
}

.mdi-table-clock::before {
  content: "\\f13c1";
}

.mdi-table-cog::before {
  content: "\\f13c2";
}

.mdi-table-column::before {
  content: "\\f0835";
}

.mdi-table-column-plus-after::before {
  content: "\\f04ec";
}

.mdi-table-column-plus-before::before {
  content: "\\f04ed";
}

.mdi-table-column-remove::before {
  content: "\\f04ee";
}

.mdi-table-column-width::before {
  content: "\\f04ef";
}

.mdi-table-edit::before {
  content: "\\f04f0";
}

.mdi-table-eye::before {
  content: "\\f1094";
}

.mdi-table-eye-off::before {
  content: "\\f13c3";
}

.mdi-table-furniture::before {
  content: "\\f05bc";
}

.mdi-table-headers-eye::before {
  content: "\\f121d";
}

.mdi-table-headers-eye-off::before {
  content: "\\f121e";
}

.mdi-table-heart::before {
  content: "\\f13c4";
}

.mdi-table-key::before {
  content: "\\f13c5";
}

.mdi-table-large::before {
  content: "\\f04f1";
}

.mdi-table-large-plus::before {
  content: "\\f0f87";
}

.mdi-table-large-remove::before {
  content: "\\f0f88";
}

.mdi-table-lock::before {
  content: "\\f13c6";
}

.mdi-table-merge-cells::before {
  content: "\\f09a6";
}

.mdi-table-minus::before {
  content: "\\f13c7";
}

.mdi-table-multiple::before {
  content: "\\f13c8";
}

.mdi-table-network::before {
  content: "\\f13c9";
}

.mdi-table-of-contents::before {
  content: "\\f0836";
}

.mdi-table-off::before {
  content: "\\f13ca";
}

.mdi-table-picnic::before {
  content: "\\f1743";
}

.mdi-table-pivot::before {
  content: "\\f183c";
}

.mdi-table-plus::before {
  content: "\\f0a75";
}

.mdi-table-refresh::before {
  content: "\\f13a0";
}

.mdi-table-remove::before {
  content: "\\f0a76";
}

.mdi-table-row::before {
  content: "\\f0837";
}

.mdi-table-row-height::before {
  content: "\\f04f2";
}

.mdi-table-row-plus-after::before {
  content: "\\f04f3";
}

.mdi-table-row-plus-before::before {
  content: "\\f04f4";
}

.mdi-table-row-remove::before {
  content: "\\f04f5";
}

.mdi-table-search::before {
  content: "\\f090f";
}

.mdi-table-settings::before {
  content: "\\f0838";
}

.mdi-table-split-cell::before {
  content: "\\f142a";
}

.mdi-table-star::before {
  content: "\\f13cb";
}

.mdi-table-sync::before {
  content: "\\f13a1";
}

.mdi-table-tennis::before {
  content: "\\f0e68";
}

.mdi-tablet::before {
  content: "\\f04f6";
}

.mdi-tablet-android::before {
  content: "\\f04f7";
}

.mdi-tablet-cellphone::before {
  content: "\\f09a7";
}

.mdi-tablet-dashboard::before {
  content: "\\f0ece";
}

.mdi-taco::before {
  content: "\\f0762";
}

.mdi-tag::before {
  content: "\\f04f9";
}

.mdi-tag-arrow-down::before {
  content: "\\f172b";
}

.mdi-tag-arrow-down-outline::before {
  content: "\\f172c";
}

.mdi-tag-arrow-left::before {
  content: "\\f172d";
}

.mdi-tag-arrow-left-outline::before {
  content: "\\f172e";
}

.mdi-tag-arrow-right::before {
  content: "\\f172f";
}

.mdi-tag-arrow-right-outline::before {
  content: "\\f1730";
}

.mdi-tag-arrow-up::before {
  content: "\\f1731";
}

.mdi-tag-arrow-up-outline::before {
  content: "\\f1732";
}

.mdi-tag-faces::before {
  content: "\\f04fa";
}

.mdi-tag-heart::before {
  content: "\\f068b";
}

.mdi-tag-heart-outline::before {
  content: "\\f0bcf";
}

.mdi-tag-minus::before {
  content: "\\f0910";
}

.mdi-tag-minus-outline::before {
  content: "\\f121f";
}

.mdi-tag-multiple::before {
  content: "\\f04fb";
}

.mdi-tag-multiple-outline::before {
  content: "\\f12f7";
}

.mdi-tag-off::before {
  content: "\\f1220";
}

.mdi-tag-off-outline::before {
  content: "\\f1221";
}

.mdi-tag-outline::before {
  content: "\\f04fc";
}

.mdi-tag-plus::before {
  content: "\\f0722";
}

.mdi-tag-plus-outline::before {
  content: "\\f1222";
}

.mdi-tag-remove::before {
  content: "\\f0723";
}

.mdi-tag-remove-outline::before {
  content: "\\f1223";
}

.mdi-tag-search::before {
  content: "\\f1907";
}

.mdi-tag-search-outline::before {
  content: "\\f1908";
}

.mdi-tag-text::before {
  content: "\\f1224";
}

.mdi-tag-text-outline::before {
  content: "\\f04fd";
}

.mdi-tailwind::before {
  content: "\\f13ff";
}

.mdi-tangram::before {
  content: "\\f04f8";
}

.mdi-tank::before {
  content: "\\f0d3a";
}

.mdi-tanker-truck::before {
  content: "\\f0fe5";
}

.mdi-tape-drive::before {
  content: "\\f16df";
}

.mdi-tape-measure::before {
  content: "\\f0b4d";
}

.mdi-target::before {
  content: "\\f04fe";
}

.mdi-target-account::before {
  content: "\\f0bd0";
}

.mdi-target-variant::before {
  content: "\\f0a77";
}

.mdi-taxi::before {
  content: "\\f04ff";
}

.mdi-tea::before {
  content: "\\f0d9e";
}

.mdi-tea-outline::before {
  content: "\\f0d9f";
}

.mdi-teamviewer::before {
  content: "\\f0500";
}

.mdi-teddy-bear::before {
  content: "\\f18fb";
}

.mdi-telescope::before {
  content: "\\f0b4e";
}

.mdi-television::before {
  content: "\\f0502";
}

.mdi-television-ambient-light::before {
  content: "\\f1356";
}

.mdi-television-box::before {
  content: "\\f0839";
}

.mdi-television-classic::before {
  content: "\\f07f4";
}

.mdi-television-classic-off::before {
  content: "\\f083a";
}

.mdi-television-guide::before {
  content: "\\f0503";
}

.mdi-television-off::before {
  content: "\\f083b";
}

.mdi-television-pause::before {
  content: "\\f0f89";
}

.mdi-television-play::before {
  content: "\\f0ecf";
}

.mdi-television-shimmer::before {
  content: "\\f1110";
}

.mdi-television-stop::before {
  content: "\\f0f8a";
}

.mdi-temperature-celsius::before {
  content: "\\f0504";
}

.mdi-temperature-fahrenheit::before {
  content: "\\f0505";
}

.mdi-temperature-kelvin::before {
  content: "\\f0506";
}

.mdi-tennis::before {
  content: "\\f0da0";
}

.mdi-tennis-ball::before {
  content: "\\f0507";
}

.mdi-tent::before {
  content: "\\f0508";
}

.mdi-terraform::before {
  content: "\\f1062";
}

.mdi-terrain::before {
  content: "\\f0509";
}

.mdi-test-tube::before {
  content: "\\f0668";
}

.mdi-test-tube-empty::before {
  content: "\\f0911";
}

.mdi-test-tube-off::before {
  content: "\\f0912";
}

.mdi-text::before {
  content: "\\f09a8";
}

.mdi-text-account::before {
  content: "\\f1570";
}

.mdi-text-box::before {
  content: "\\f021a";
}

.mdi-text-box-check::before {
  content: "\\f0ea6";
}

.mdi-text-box-check-outline::before {
  content: "\\f0ea7";
}

.mdi-text-box-minus::before {
  content: "\\f0ea8";
}

.mdi-text-box-minus-outline::before {
  content: "\\f0ea9";
}

.mdi-text-box-multiple::before {
  content: "\\f0ab7";
}

.mdi-text-box-multiple-outline::before {
  content: "\\f0ab8";
}

.mdi-text-box-outline::before {
  content: "\\f09ed";
}

.mdi-text-box-plus::before {
  content: "\\f0eaa";
}

.mdi-text-box-plus-outline::before {
  content: "\\f0eab";
}

.mdi-text-box-remove::before {
  content: "\\f0eac";
}

.mdi-text-box-remove-outline::before {
  content: "\\f0ead";
}

.mdi-text-box-search::before {
  content: "\\f0eae";
}

.mdi-text-box-search-outline::before {
  content: "\\f0eaf";
}

.mdi-text-long::before {
  content: "\\f09aa";
}

.mdi-text-recognition::before {
  content: "\\f113d";
}

.mdi-text-search::before {
  content: "\\f13b8";
}

.mdi-text-shadow::before {
  content: "\\f0669";
}

.mdi-text-short::before {
  content: "\\f09a9";
}

.mdi-text-to-speech::before {
  content: "\\f050a";
}

.mdi-text-to-speech-off::before {
  content: "\\f050b";
}

.mdi-texture::before {
  content: "\\f050c";
}

.mdi-texture-box::before {
  content: "\\f0fe6";
}

.mdi-theater::before {
  content: "\\f050d";
}

.mdi-theme-light-dark::before {
  content: "\\f050e";
}

.mdi-thermometer::before {
  content: "\\f050f";
}

.mdi-thermometer-alert::before {
  content: "\\f0e01";
}

.mdi-thermometer-bluetooth::before {
  content: "\\f1895";
}

.mdi-thermometer-chevron-down::before {
  content: "\\f0e02";
}

.mdi-thermometer-chevron-up::before {
  content: "\\f0e03";
}

.mdi-thermometer-high::before {
  content: "\\f10c2";
}

.mdi-thermometer-lines::before {
  content: "\\f0510";
}

.mdi-thermometer-low::before {
  content: "\\f10c3";
}

.mdi-thermometer-minus::before {
  content: "\\f0e04";
}

.mdi-thermometer-off::before {
  content: "\\f1531";
}

.mdi-thermometer-plus::before {
  content: "\\f0e05";
}

.mdi-thermostat::before {
  content: "\\f0393";
}

.mdi-thermostat-box::before {
  content: "\\f0891";
}

.mdi-thought-bubble::before {
  content: "\\f07f6";
}

.mdi-thought-bubble-outline::before {
  content: "\\f07f7";
}

.mdi-thumb-down::before {
  content: "\\f0511";
}

.mdi-thumb-down-outline::before {
  content: "\\f0512";
}

.mdi-thumb-up::before {
  content: "\\f0513";
}

.mdi-thumb-up-outline::before {
  content: "\\f0514";
}

.mdi-thumbs-up-down::before {
  content: "\\f0515";
}

.mdi-thumbs-up-down-outline::before {
  content: "\\f1914";
}

.mdi-ticket::before {
  content: "\\f0516";
}

.mdi-ticket-account::before {
  content: "\\f0517";
}

.mdi-ticket-confirmation::before {
  content: "\\f0518";
}

.mdi-ticket-confirmation-outline::before {
  content: "\\f13aa";
}

.mdi-ticket-outline::before {
  content: "\\f0913";
}

.mdi-ticket-percent::before {
  content: "\\f0724";
}

.mdi-ticket-percent-outline::before {
  content: "\\f142b";
}

.mdi-tie::before {
  content: "\\f0519";
}

.mdi-tilde::before {
  content: "\\f0725";
}

.mdi-tilde-off::before {
  content: "\\f18f3";
}

.mdi-timelapse::before {
  content: "\\f051a";
}

.mdi-timeline::before {
  content: "\\f0bd1";
}

.mdi-timeline-alert::before {
  content: "\\f0f95";
}

.mdi-timeline-alert-outline::before {
  content: "\\f0f98";
}

.mdi-timeline-check::before {
  content: "\\f1532";
}

.mdi-timeline-check-outline::before {
  content: "\\f1533";
}

.mdi-timeline-clock::before {
  content: "\\f11fb";
}

.mdi-timeline-clock-outline::before {
  content: "\\f11fc";
}

.mdi-timeline-help::before {
  content: "\\f0f99";
}

.mdi-timeline-help-outline::before {
  content: "\\f0f9a";
}

.mdi-timeline-minus::before {
  content: "\\f1534";
}

.mdi-timeline-minus-outline::before {
  content: "\\f1535";
}

.mdi-timeline-outline::before {
  content: "\\f0bd2";
}

.mdi-timeline-plus::before {
  content: "\\f0f96";
}

.mdi-timeline-plus-outline::before {
  content: "\\f0f97";
}

.mdi-timeline-remove::before {
  content: "\\f1536";
}

.mdi-timeline-remove-outline::before {
  content: "\\f1537";
}

.mdi-timeline-text::before {
  content: "\\f0bd3";
}

.mdi-timeline-text-outline::before {
  content: "\\f0bd4";
}

.mdi-timer::before {
  content: "\\f13ab";
}

.mdi-timer-10::before {
  content: "\\f051c";
}

.mdi-timer-3::before {
  content: "\\f051d";
}

.mdi-timer-cog::before {
  content: "\\f1925";
}

.mdi-timer-cog-outline::before {
  content: "\\f1926";
}

.mdi-timer-off::before {
  content: "\\f13ac";
}

.mdi-timer-off-outline::before {
  content: "\\f051e";
}

.mdi-timer-outline::before {
  content: "\\f051b";
}

.mdi-timer-sand::before {
  content: "\\f051f";
}

.mdi-timer-sand-complete::before {
  content: "\\f199f";
}

.mdi-timer-sand-empty::before {
  content: "\\f06ad";
}

.mdi-timer-sand-full::before {
  content: "\\f078c";
}

.mdi-timer-sand-paused::before {
  content: "\\f19a0";
}

.mdi-timer-settings::before {
  content: "\\f1923";
}

.mdi-timer-settings-outline::before {
  content: "\\f1924";
}

.mdi-timetable::before {
  content: "\\f0520";
}

.mdi-tire::before {
  content: "\\f1896";
}

.mdi-toaster::before {
  content: "\\f1063";
}

.mdi-toaster-off::before {
  content: "\\f11b7";
}

.mdi-toaster-oven::before {
  content: "\\f0cd3";
}

.mdi-toggle-switch::before {
  content: "\\f0521";
}

.mdi-toggle-switch-off::before {
  content: "\\f0522";
}

.mdi-toggle-switch-off-outline::before {
  content: "\\f0a19";
}

.mdi-toggle-switch-outline::before {
  content: "\\f0a1a";
}

.mdi-toilet::before {
  content: "\\f09ab";
}

.mdi-toolbox::before {
  content: "\\f09ac";
}

.mdi-toolbox-outline::before {
  content: "\\f09ad";
}

.mdi-tools::before {
  content: "\\f1064";
}

.mdi-tooltip::before {
  content: "\\f0523";
}

.mdi-tooltip-account::before {
  content: "\\f000c";
}

.mdi-tooltip-cellphone::before {
  content: "\\f183b";
}

.mdi-tooltip-check::before {
  content: "\\f155c";
}

.mdi-tooltip-check-outline::before {
  content: "\\f155d";
}

.mdi-tooltip-edit::before {
  content: "\\f0524";
}

.mdi-tooltip-edit-outline::before {
  content: "\\f12c5";
}

.mdi-tooltip-image::before {
  content: "\\f0525";
}

.mdi-tooltip-image-outline::before {
  content: "\\f0bd5";
}

.mdi-tooltip-minus::before {
  content: "\\f155e";
}

.mdi-tooltip-minus-outline::before {
  content: "\\f155f";
}

.mdi-tooltip-outline::before {
  content: "\\f0526";
}

.mdi-tooltip-plus::before {
  content: "\\f0bd6";
}

.mdi-tooltip-plus-outline::before {
  content: "\\f0527";
}

.mdi-tooltip-remove::before {
  content: "\\f1560";
}

.mdi-tooltip-remove-outline::before {
  content: "\\f1561";
}

.mdi-tooltip-text::before {
  content: "\\f0528";
}

.mdi-tooltip-text-outline::before {
  content: "\\f0bd7";
}

.mdi-tooth::before {
  content: "\\f08c3";
}

.mdi-tooth-outline::before {
  content: "\\f0529";
}

.mdi-toothbrush::before {
  content: "\\f1129";
}

.mdi-toothbrush-electric::before {
  content: "\\f112c";
}

.mdi-toothbrush-paste::before {
  content: "\\f112a";
}

.mdi-torch::before {
  content: "\\f1606";
}

.mdi-tortoise::before {
  content: "\\f0d3b";
}

.mdi-toslink::before {
  content: "\\f12b8";
}

.mdi-tournament::before {
  content: "\\f09ae";
}

.mdi-tow-truck::before {
  content: "\\f083c";
}

.mdi-tower-beach::before {
  content: "\\f0681";
}

.mdi-tower-fire::before {
  content: "\\f0682";
}

.mdi-town-hall::before {
  content: "\\f1875";
}

.mdi-toy-brick::before {
  content: "\\f1288";
}

.mdi-toy-brick-marker::before {
  content: "\\f1289";
}

.mdi-toy-brick-marker-outline::before {
  content: "\\f128a";
}

.mdi-toy-brick-minus::before {
  content: "\\f128b";
}

.mdi-toy-brick-minus-outline::before {
  content: "\\f128c";
}

.mdi-toy-brick-outline::before {
  content: "\\f128d";
}

.mdi-toy-brick-plus::before {
  content: "\\f128e";
}

.mdi-toy-brick-plus-outline::before {
  content: "\\f128f";
}

.mdi-toy-brick-remove::before {
  content: "\\f1290";
}

.mdi-toy-brick-remove-outline::before {
  content: "\\f1291";
}

.mdi-toy-brick-search::before {
  content: "\\f1292";
}

.mdi-toy-brick-search-outline::before {
  content: "\\f1293";
}

.mdi-track-light::before {
  content: "\\f0914";
}

.mdi-trackpad::before {
  content: "\\f07f8";
}

.mdi-trackpad-lock::before {
  content: "\\f0933";
}

.mdi-tractor::before {
  content: "\\f0892";
}

.mdi-tractor-variant::before {
  content: "\\f14c4";
}

.mdi-trademark::before {
  content: "\\f0a78";
}

.mdi-traffic-cone::before {
  content: "\\f137c";
}

.mdi-traffic-light::before {
  content: "\\f052b";
}

.mdi-traffic-light-outline::before {
  content: "\\f182a";
}

.mdi-train::before {
  content: "\\f052c";
}

.mdi-train-car::before {
  content: "\\f0bd8";
}

.mdi-train-car-passenger::before {
  content: "\\f1733";
}

.mdi-train-car-passenger-door::before {
  content: "\\f1734";
}

.mdi-train-car-passenger-door-open::before {
  content: "\\f1735";
}

.mdi-train-car-passenger-variant::before {
  content: "\\f1736";
}

.mdi-train-variant::before {
  content: "\\f08c4";
}

.mdi-tram::before {
  content: "\\f052d";
}

.mdi-tram-side::before {
  content: "\\f0fe7";
}

.mdi-transcribe::before {
  content: "\\f052e";
}

.mdi-transcribe-close::before {
  content: "\\f052f";
}

.mdi-transfer::before {
  content: "\\f1065";
}

.mdi-transfer-down::before {
  content: "\\f0da1";
}

.mdi-transfer-left::before {
  content: "\\f0da2";
}

.mdi-transfer-right::before {
  content: "\\f0530";
}

.mdi-transfer-up::before {
  content: "\\f0da3";
}

.mdi-transit-connection::before {
  content: "\\f0d3c";
}

.mdi-transit-connection-horizontal::before {
  content: "\\f1546";
}

.mdi-transit-connection-variant::before {
  content: "\\f0d3d";
}

.mdi-transit-detour::before {
  content: "\\f0f8b";
}

.mdi-transit-skip::before {
  content: "\\f1515";
}

.mdi-transit-transfer::before {
  content: "\\f06ae";
}

.mdi-transition::before {
  content: "\\f0915";
}

.mdi-transition-masked::before {
  content: "\\f0916";
}

.mdi-translate::before {
  content: "\\f05ca";
}

.mdi-translate-off::before {
  content: "\\f0e06";
}

.mdi-transmission-tower::before {
  content: "\\f0d3e";
}

.mdi-transmission-tower-export::before {
  content: "\\f192c";
}

.mdi-transmission-tower-import::before {
  content: "\\f192d";
}

.mdi-trash-can::before {
  content: "\\f0a79";
}

.mdi-trash-can-outline::before {
  content: "\\f0a7a";
}

.mdi-tray::before {
  content: "\\f1294";
}

.mdi-tray-alert::before {
  content: "\\f1295";
}

.mdi-tray-arrow-down::before {
  content: "\\f0120";
}

.mdi-tray-arrow-up::before {
  content: "\\f011d";
}

.mdi-tray-full::before {
  content: "\\f1296";
}

.mdi-tray-minus::before {
  content: "\\f1297";
}

.mdi-tray-plus::before {
  content: "\\f1298";
}

.mdi-tray-remove::before {
  content: "\\f1299";
}

.mdi-treasure-chest::before {
  content: "\\f0726";
}

.mdi-tree::before {
  content: "\\f0531";
}

.mdi-tree-outline::before {
  content: "\\f0e69";
}

.mdi-trello::before {
  content: "\\f0532";
}

.mdi-trending-down::before {
  content: "\\f0533";
}

.mdi-trending-neutral::before {
  content: "\\f0534";
}

.mdi-trending-up::before {
  content: "\\f0535";
}

.mdi-triangle::before {
  content: "\\f0536";
}

.mdi-triangle-outline::before {
  content: "\\f0537";
}

.mdi-triangle-wave::before {
  content: "\\f147c";
}

.mdi-triforce::before {
  content: "\\f0bd9";
}

.mdi-trophy::before {
  content: "\\f0538";
}

.mdi-trophy-award::before {
  content: "\\f0539";
}

.mdi-trophy-broken::before {
  content: "\\f0da4";
}

.mdi-trophy-outline::before {
  content: "\\f053a";
}

.mdi-trophy-variant::before {
  content: "\\f053b";
}

.mdi-trophy-variant-outline::before {
  content: "\\f053c";
}

.mdi-truck::before {
  content: "\\f053d";
}

.mdi-truck-cargo-container::before {
  content: "\\f18d8";
}

.mdi-truck-check::before {
  content: "\\f0cd4";
}

.mdi-truck-check-outline::before {
  content: "\\f129a";
}

.mdi-truck-delivery::before {
  content: "\\f053e";
}

.mdi-truck-delivery-outline::before {
  content: "\\f129b";
}

.mdi-truck-fast::before {
  content: "\\f0788";
}

.mdi-truck-fast-outline::before {
  content: "\\f129c";
}

.mdi-truck-flatbed::before {
  content: "\\f1891";
}

.mdi-truck-minus::before {
  content: "\\f19ae";
}

.mdi-truck-minus-outline::before {
  content: "\\f19bd";
}

.mdi-truck-outline::before {
  content: "\\f129d";
}

.mdi-truck-plus::before {
  content: "\\f19ad";
}

.mdi-truck-plus-outline::before {
  content: "\\f19bc";
}

.mdi-truck-remove::before {
  content: "\\f19af";
}

.mdi-truck-remove-outline::before {
  content: "\\f19be";
}

.mdi-truck-snowflake::before {
  content: "\\f19a6";
}

.mdi-truck-trailer::before {
  content: "\\f0727";
}

.mdi-trumpet::before {
  content: "\\f1096";
}

.mdi-tshirt-crew::before {
  content: "\\f0a7b";
}

.mdi-tshirt-crew-outline::before {
  content: "\\f053f";
}

.mdi-tshirt-v::before {
  content: "\\f0a7c";
}

.mdi-tshirt-v-outline::before {
  content: "\\f0540";
}

.mdi-tumble-dryer::before {
  content: "\\f0917";
}

.mdi-tumble-dryer-alert::before {
  content: "\\f11ba";
}

.mdi-tumble-dryer-off::before {
  content: "\\f11bb";
}

.mdi-tune::before {
  content: "\\f062e";
}

.mdi-tune-variant::before {
  content: "\\f1542";
}

.mdi-tune-vertical::before {
  content: "\\f066a";
}

.mdi-tune-vertical-variant::before {
  content: "\\f1543";
}

.mdi-tunnel::before {
  content: "\\f183d";
}

.mdi-tunnel-outline::before {
  content: "\\f183e";
}

.mdi-turkey::before {
  content: "\\f171b";
}

.mdi-turnstile::before {
  content: "\\f0cd5";
}

.mdi-turnstile-outline::before {
  content: "\\f0cd6";
}

.mdi-turtle::before {
  content: "\\f0cd7";
}

.mdi-twitch::before {
  content: "\\f0543";
}

.mdi-twitter::before {
  content: "\\f0544";
}

.mdi-two-factor-authentication::before {
  content: "\\f09af";
}

.mdi-typewriter::before {
  content: "\\f0f2d";
}

.mdi-ubisoft::before {
  content: "\\f0bda";
}

.mdi-ubuntu::before {
  content: "\\f0548";
}

.mdi-ufo::before {
  content: "\\f10c4";
}

.mdi-ufo-outline::before {
  content: "\\f10c5";
}

.mdi-ultra-high-definition::before {
  content: "\\f07f9";
}

.mdi-umbraco::before {
  content: "\\f0549";
}

.mdi-umbrella::before {
  content: "\\f054a";
}

.mdi-umbrella-beach::before {
  content: "\\f188a";
}

.mdi-umbrella-beach-outline::before {
  content: "\\f188b";
}

.mdi-umbrella-closed::before {
  content: "\\f09b0";
}

.mdi-umbrella-closed-outline::before {
  content: "\\f13e2";
}

.mdi-umbrella-closed-variant::before {
  content: "\\f13e1";
}

.mdi-umbrella-outline::before {
  content: "\\f054b";
}

.mdi-undo::before {
  content: "\\f054c";
}

.mdi-undo-variant::before {
  content: "\\f054d";
}

.mdi-unfold-less-horizontal::before {
  content: "\\f054e";
}

.mdi-unfold-less-vertical::before {
  content: "\\f0760";
}

.mdi-unfold-more-horizontal::before {
  content: "\\f054f";
}

.mdi-unfold-more-vertical::before {
  content: "\\f0761";
}

.mdi-ungroup::before {
  content: "\\f0550";
}

.mdi-unicode::before {
  content: "\\f0ed0";
}

.mdi-unicorn::before {
  content: "\\f15c2";
}

.mdi-unicorn-variant::before {
  content: "\\f15c3";
}

.mdi-unicycle::before {
  content: "\\f15e5";
}

.mdi-unity::before {
  content: "\\f06af";
}

.mdi-unreal::before {
  content: "\\f09b1";
}

.mdi-update::before {
  content: "\\f06b0";
}

.mdi-upload::before {
  content: "\\f0552";
}

.mdi-upload-lock::before {
  content: "\\f1373";
}

.mdi-upload-lock-outline::before {
  content: "\\f1374";
}

.mdi-upload-multiple::before {
  content: "\\f083d";
}

.mdi-upload-network::before {
  content: "\\f06f6";
}

.mdi-upload-network-outline::before {
  content: "\\f0cd8";
}

.mdi-upload-off::before {
  content: "\\f10c6";
}

.mdi-upload-off-outline::before {
  content: "\\f10c7";
}

.mdi-upload-outline::before {
  content: "\\f0e07";
}

.mdi-usb::before {
  content: "\\f0553";
}

.mdi-usb-flash-drive::before {
  content: "\\f129e";
}

.mdi-usb-flash-drive-outline::before {
  content: "\\f129f";
}

.mdi-usb-port::before {
  content: "\\f11f0";
}

.mdi-vacuum::before {
  content: "\\f19a1";
}

.mdi-vacuum-outline::before {
  content: "\\f19a2";
}

.mdi-valve::before {
  content: "\\f1066";
}

.mdi-valve-closed::before {
  content: "\\f1067";
}

.mdi-valve-open::before {
  content: "\\f1068";
}

.mdi-van-passenger::before {
  content: "\\f07fa";
}

.mdi-van-utility::before {
  content: "\\f07fb";
}

.mdi-vanish::before {
  content: "\\f07fc";
}

.mdi-vanish-quarter::before {
  content: "\\f1554";
}

.mdi-vanity-light::before {
  content: "\\f11e1";
}

.mdi-variable::before {
  content: "\\f0ae7";
}

.mdi-variable-box::before {
  content: "\\f1111";
}

.mdi-vector-arrange-above::before {
  content: "\\f0554";
}

.mdi-vector-arrange-below::before {
  content: "\\f0555";
}

.mdi-vector-bezier::before {
  content: "\\f0ae8";
}

.mdi-vector-circle::before {
  content: "\\f0556";
}

.mdi-vector-circle-variant::before {
  content: "\\f0557";
}

.mdi-vector-combine::before {
  content: "\\f0558";
}

.mdi-vector-curve::before {
  content: "\\f0559";
}

.mdi-vector-difference::before {
  content: "\\f055a";
}

.mdi-vector-difference-ab::before {
  content: "\\f055b";
}

.mdi-vector-difference-ba::before {
  content: "\\f055c";
}

.mdi-vector-ellipse::before {
  content: "\\f0893";
}

.mdi-vector-intersection::before {
  content: "\\f055d";
}

.mdi-vector-line::before {
  content: "\\f055e";
}

.mdi-vector-link::before {
  content: "\\f0fe8";
}

.mdi-vector-point::before {
  content: "\\f055f";
}

.mdi-vector-polygon::before {
  content: "\\f0560";
}

.mdi-vector-polygon-variant::before {
  content: "\\f1856";
}

.mdi-vector-polyline::before {
  content: "\\f0561";
}

.mdi-vector-polyline-edit::before {
  content: "\\f1225";
}

.mdi-vector-polyline-minus::before {
  content: "\\f1226";
}

.mdi-vector-polyline-plus::before {
  content: "\\f1227";
}

.mdi-vector-polyline-remove::before {
  content: "\\f1228";
}

.mdi-vector-radius::before {
  content: "\\f074a";
}

.mdi-vector-rectangle::before {
  content: "\\f05c6";
}

.mdi-vector-selection::before {
  content: "\\f0562";
}

.mdi-vector-square::before {
  content: "\\f0001";
}

.mdi-vector-square-close::before {
  content: "\\f1857";
}

.mdi-vector-square-edit::before {
  content: "\\f18d9";
}

.mdi-vector-square-minus::before {
  content: "\\f18da";
}

.mdi-vector-square-open::before {
  content: "\\f1858";
}

.mdi-vector-square-plus::before {
  content: "\\f18db";
}

.mdi-vector-square-remove::before {
  content: "\\f18dc";
}

.mdi-vector-triangle::before {
  content: "\\f0563";
}

.mdi-vector-union::before {
  content: "\\f0564";
}

.mdi-vhs::before {
  content: "\\f0a1b";
}

.mdi-vibrate::before {
  content: "\\f0566";
}

.mdi-vibrate-off::before {
  content: "\\f0cd9";
}

.mdi-video::before {
  content: "\\f0567";
}

.mdi-video-3d::before {
  content: "\\f07fd";
}

.mdi-video-3d-off::before {
  content: "\\f13d9";
}

.mdi-video-3d-variant::before {
  content: "\\f0ed1";
}

.mdi-video-4k-box::before {
  content: "\\f083e";
}

.mdi-video-account::before {
  content: "\\f0919";
}

.mdi-video-box::before {
  content: "\\f00fd";
}

.mdi-video-box-off::before {
  content: "\\f00fe";
}

.mdi-video-check::before {
  content: "\\f1069";
}

.mdi-video-check-outline::before {
  content: "\\f106a";
}

.mdi-video-high-definition::before {
  content: "\\f152e";
}

.mdi-video-image::before {
  content: "\\f091a";
}

.mdi-video-input-antenna::before {
  content: "\\f083f";
}

.mdi-video-input-component::before {
  content: "\\f0840";
}

.mdi-video-input-hdmi::before {
  content: "\\f0841";
}

.mdi-video-input-scart::before {
  content: "\\f0f8c";
}

.mdi-video-input-svideo::before {
  content: "\\f0842";
}

.mdi-video-marker::before {
  content: "\\f19a9";
}

.mdi-video-marker-outline::before {
  content: "\\f19aa";
}

.mdi-video-minus::before {
  content: "\\f09b2";
}

.mdi-video-minus-outline::before {
  content: "\\f02ba";
}

.mdi-video-off::before {
  content: "\\f0568";
}

.mdi-video-off-outline::before {
  content: "\\f0bdb";
}

.mdi-video-outline::before {
  content: "\\f0bdc";
}

.mdi-video-plus::before {
  content: "\\f09b3";
}

.mdi-video-plus-outline::before {
  content: "\\f01d3";
}

.mdi-video-stabilization::before {
  content: "\\f091b";
}

.mdi-video-switch::before {
  content: "\\f0569";
}

.mdi-video-switch-outline::before {
  content: "\\f0790";
}

.mdi-video-vintage::before {
  content: "\\f0a1c";
}

.mdi-video-wireless::before {
  content: "\\f0ed2";
}

.mdi-video-wireless-outline::before {
  content: "\\f0ed3";
}

.mdi-view-agenda::before {
  content: "\\f056a";
}

.mdi-view-agenda-outline::before {
  content: "\\f11d8";
}

.mdi-view-array::before {
  content: "\\f056b";
}

.mdi-view-array-outline::before {
  content: "\\f1485";
}

.mdi-view-carousel::before {
  content: "\\f056c";
}

.mdi-view-carousel-outline::before {
  content: "\\f1486";
}

.mdi-view-column::before {
  content: "\\f056d";
}

.mdi-view-column-outline::before {
  content: "\\f1487";
}

.mdi-view-comfy::before {
  content: "\\f0e6a";
}

.mdi-view-comfy-outline::before {
  content: "\\f1488";
}

.mdi-view-compact::before {
  content: "\\f0e6b";
}

.mdi-view-compact-outline::before {
  content: "\\f0e6c";
}

.mdi-view-dashboard::before {
  content: "\\f056e";
}

.mdi-view-dashboard-edit::before {
  content: "\\f1947";
}

.mdi-view-dashboard-edit-outline::before {
  content: "\\f1948";
}

.mdi-view-dashboard-outline::before {
  content: "\\f0a1d";
}

.mdi-view-dashboard-variant::before {
  content: "\\f0843";
}

.mdi-view-dashboard-variant-outline::before {
  content: "\\f1489";
}

.mdi-view-day::before {
  content: "\\f056f";
}

.mdi-view-day-outline::before {
  content: "\\f148a";
}

.mdi-view-gallery::before {
  content: "\\f1888";
}

.mdi-view-gallery-outline::before {
  content: "\\f1889";
}

.mdi-view-grid::before {
  content: "\\f0570";
}

.mdi-view-grid-outline::before {
  content: "\\f11d9";
}

.mdi-view-grid-plus::before {
  content: "\\f0f8d";
}

.mdi-view-grid-plus-outline::before {
  content: "\\f11da";
}

.mdi-view-headline::before {
  content: "\\f0571";
}

.mdi-view-list::before {
  content: "\\f0572";
}

.mdi-view-list-outline::before {
  content: "\\f148b";
}

.mdi-view-module::before {
  content: "\\f0573";
}

.mdi-view-module-outline::before {
  content: "\\f148c";
}

.mdi-view-parallel::before {
  content: "\\f0728";
}

.mdi-view-parallel-outline::before {
  content: "\\f148d";
}

.mdi-view-quilt::before {
  content: "\\f0574";
}

.mdi-view-quilt-outline::before {
  content: "\\f148e";
}

.mdi-view-sequential::before {
  content: "\\f0729";
}

.mdi-view-sequential-outline::before {
  content: "\\f148f";
}

.mdi-view-split-horizontal::before {
  content: "\\f0bcb";
}

.mdi-view-split-vertical::before {
  content: "\\f0bcc";
}

.mdi-view-stream::before {
  content: "\\f0575";
}

.mdi-view-stream-outline::before {
  content: "\\f1490";
}

.mdi-view-week::before {
  content: "\\f0576";
}

.mdi-view-week-outline::before {
  content: "\\f1491";
}

.mdi-vimeo::before {
  content: "\\f0577";
}

.mdi-violin::before {
  content: "\\f060f";
}

.mdi-virtual-reality::before {
  content: "\\f0894";
}

.mdi-virus::before {
  content: "\\f13b6";
}

.mdi-virus-off::before {
  content: "\\f18e1";
}

.mdi-virus-off-outline::before {
  content: "\\f18e2";
}

.mdi-virus-outline::before {
  content: "\\f13b7";
}

.mdi-vlc::before {
  content: "\\f057c";
}

.mdi-voicemail::before {
  content: "\\f057d";
}

.mdi-volleyball::before {
  content: "\\f09b4";
}

.mdi-volume-high::before {
  content: "\\f057e";
}

.mdi-volume-low::before {
  content: "\\f057f";
}

.mdi-volume-medium::before {
  content: "\\f0580";
}

.mdi-volume-minus::before {
  content: "\\f075e";
}

.mdi-volume-mute::before {
  content: "\\f075f";
}

.mdi-volume-off::before {
  content: "\\f0581";
}

.mdi-volume-plus::before {
  content: "\\f075d";
}

.mdi-volume-source::before {
  content: "\\f1120";
}

.mdi-volume-variant-off::before {
  content: "\\f0e08";
}

.mdi-volume-vibrate::before {
  content: "\\f1121";
}

.mdi-vote::before {
  content: "\\f0a1f";
}

.mdi-vote-outline::before {
  content: "\\f0a20";
}

.mdi-vpn::before {
  content: "\\f0582";
}

.mdi-vuejs::before {
  content: "\\f0844";
}

.mdi-vuetify::before {
  content: "\\f0e6d";
}

.mdi-walk::before {
  content: "\\f0583";
}

.mdi-wall::before {
  content: "\\f07fe";
}

.mdi-wall-sconce::before {
  content: "\\f091c";
}

.mdi-wall-sconce-flat::before {
  content: "\\f091d";
}

.mdi-wall-sconce-flat-outline::before {
  content: "\\f17c9";
}

.mdi-wall-sconce-flat-variant::before {
  content: "\\f041c";
}

.mdi-wall-sconce-flat-variant-outline::before {
  content: "\\f17ca";
}

.mdi-wall-sconce-outline::before {
  content: "\\f17cb";
}

.mdi-wall-sconce-round::before {
  content: "\\f0748";
}

.mdi-wall-sconce-round-outline::before {
  content: "\\f17cc";
}

.mdi-wall-sconce-round-variant::before {
  content: "\\f091e";
}

.mdi-wall-sconce-round-variant-outline::before {
  content: "\\f17cd";
}

.mdi-wallet::before {
  content: "\\f0584";
}

.mdi-wallet-giftcard::before {
  content: "\\f0585";
}

.mdi-wallet-membership::before {
  content: "\\f0586";
}

.mdi-wallet-outline::before {
  content: "\\f0bdd";
}

.mdi-wallet-plus::before {
  content: "\\f0f8e";
}

.mdi-wallet-plus-outline::before {
  content: "\\f0f8f";
}

.mdi-wallet-travel::before {
  content: "\\f0587";
}

.mdi-wallpaper::before {
  content: "\\f0e09";
}

.mdi-wan::before {
  content: "\\f0588";
}

.mdi-wardrobe::before {
  content: "\\f0f90";
}

.mdi-wardrobe-outline::before {
  content: "\\f0f91";
}

.mdi-warehouse::before {
  content: "\\f0f81";
}

.mdi-washing-machine::before {
  content: "\\f072a";
}

.mdi-washing-machine-alert::before {
  content: "\\f11bc";
}

.mdi-washing-machine-off::before {
  content: "\\f11bd";
}

.mdi-watch::before {
  content: "\\f0589";
}

.mdi-watch-export::before {
  content: "\\f058a";
}

.mdi-watch-export-variant::before {
  content: "\\f0895";
}

.mdi-watch-import::before {
  content: "\\f058b";
}

.mdi-watch-import-variant::before {
  content: "\\f0896";
}

.mdi-watch-variant::before {
  content: "\\f0897";
}

.mdi-watch-vibrate::before {
  content: "\\f06b1";
}

.mdi-watch-vibrate-off::before {
  content: "\\f0cda";
}

.mdi-water::before {
  content: "\\f058c";
}

.mdi-water-alert::before {
  content: "\\f1502";
}

.mdi-water-alert-outline::before {
  content: "\\f1503";
}

.mdi-water-boiler::before {
  content: "\\f0f92";
}

.mdi-water-boiler-alert::before {
  content: "\\f11b3";
}

.mdi-water-boiler-off::before {
  content: "\\f11b4";
}

.mdi-water-check::before {
  content: "\\f1504";
}

.mdi-water-check-outline::before {
  content: "\\f1505";
}

.mdi-water-circle::before {
  content: "\\f1806";
}

.mdi-water-minus::before {
  content: "\\f1506";
}

.mdi-water-minus-outline::before {
  content: "\\f1507";
}

.mdi-water-off::before {
  content: "\\f058d";
}

.mdi-water-off-outline::before {
  content: "\\f1508";
}

.mdi-water-opacity::before {
  content: "\\f1855";
}

.mdi-water-outline::before {
  content: "\\f0e0a";
}

.mdi-water-percent::before {
  content: "\\f058e";
}

.mdi-water-percent-alert::before {
  content: "\\f1509";
}

.mdi-water-plus::before {
  content: "\\f150a";
}

.mdi-water-plus-outline::before {
  content: "\\f150b";
}

.mdi-water-polo::before {
  content: "\\f12a0";
}

.mdi-water-pump::before {
  content: "\\f058f";
}

.mdi-water-pump-off::before {
  content: "\\f0f93";
}

.mdi-water-remove::before {
  content: "\\f150c";
}

.mdi-water-remove-outline::before {
  content: "\\f150d";
}

.mdi-water-sync::before {
  content: "\\f17c6";
}

.mdi-water-well::before {
  content: "\\f106b";
}

.mdi-water-well-outline::before {
  content: "\\f106c";
}

.mdi-waterfall::before {
  content: "\\f1849";
}

.mdi-watering-can::before {
  content: "\\f1481";
}

.mdi-watering-can-outline::before {
  content: "\\f1482";
}

.mdi-watermark::before {
  content: "\\f0612";
}

.mdi-wave::before {
  content: "\\f0f2e";
}

.mdi-waveform::before {
  content: "\\f147d";
}

.mdi-waves::before {
  content: "\\f078d";
}

.mdi-waves-arrow-left::before {
  content: "\\f1859";
}

.mdi-waves-arrow-right::before {
  content: "\\f185a";
}

.mdi-waves-arrow-up::before {
  content: "\\f185b";
}

.mdi-waze::before {
  content: "\\f0bde";
}

.mdi-weather-cloudy::before {
  content: "\\f0590";
}

.mdi-weather-cloudy-alert::before {
  content: "\\f0f2f";
}

.mdi-weather-cloudy-arrow-right::before {
  content: "\\f0e6e";
}

.mdi-weather-cloudy-clock::before {
  content: "\\f18f6";
}

.mdi-weather-fog::before {
  content: "\\f0591";
}

.mdi-weather-hail::before {
  content: "\\f0592";
}

.mdi-weather-hazy::before {
  content: "\\f0f30";
}

.mdi-weather-hurricane::before {
  content: "\\f0898";
}

.mdi-weather-lightning::before {
  content: "\\f0593";
}

.mdi-weather-lightning-rainy::before {
  content: "\\f067e";
}

.mdi-weather-night::before {
  content: "\\f0594";
}

.mdi-weather-night-partly-cloudy::before {
  content: "\\f0f31";
}

.mdi-weather-partly-cloudy::before {
  content: "\\f0595";
}

.mdi-weather-partly-lightning::before {
  content: "\\f0f32";
}

.mdi-weather-partly-rainy::before {
  content: "\\f0f33";
}

.mdi-weather-partly-snowy::before {
  content: "\\f0f34";
}

.mdi-weather-partly-snowy-rainy::before {
  content: "\\f0f35";
}

.mdi-weather-pouring::before {
  content: "\\f0596";
}

.mdi-weather-rainy::before {
  content: "\\f0597";
}

.mdi-weather-snowy::before {
  content: "\\f0598";
}

.mdi-weather-snowy-heavy::before {
  content: "\\f0f36";
}

.mdi-weather-snowy-rainy::before {
  content: "\\f067f";
}

.mdi-weather-sunny::before {
  content: "\\f0599";
}

.mdi-weather-sunny-alert::before {
  content: "\\f0f37";
}

.mdi-weather-sunny-off::before {
  content: "\\f14e4";
}

.mdi-weather-sunset::before {
  content: "\\f059a";
}

.mdi-weather-sunset-down::before {
  content: "\\f059b";
}

.mdi-weather-sunset-up::before {
  content: "\\f059c";
}

.mdi-weather-tornado::before {
  content: "\\f0f38";
}

.mdi-weather-windy::before {
  content: "\\f059d";
}

.mdi-weather-windy-variant::before {
  content: "\\f059e";
}

.mdi-web::before {
  content: "\\f059f";
}

.mdi-web-box::before {
  content: "\\f0f94";
}

.mdi-web-cancel::before {
  content: "\\f1790";
}

.mdi-web-check::before {
  content: "\\f0789";
}

.mdi-web-clock::before {
  content: "\\f124a";
}

.mdi-web-minus::before {
  content: "\\f10a0";
}

.mdi-web-off::before {
  content: "\\f0a8e";
}

.mdi-web-plus::before {
  content: "\\f0033";
}

.mdi-web-refresh::before {
  content: "\\f1791";
}

.mdi-web-remove::before {
  content: "\\f0551";
}

.mdi-web-sync::before {
  content: "\\f1792";
}

.mdi-webcam::before {
  content: "\\f05a0";
}

.mdi-webcam-off::before {
  content: "\\f1737";
}

.mdi-webhook::before {
  content: "\\f062f";
}

.mdi-webpack::before {
  content: "\\f072b";
}

.mdi-webrtc::before {
  content: "\\f1248";
}

.mdi-wechat::before {
  content: "\\f0611";
}

.mdi-weight::before {
  content: "\\f05a1";
}

.mdi-weight-gram::before {
  content: "\\f0d3f";
}

.mdi-weight-kilogram::before {
  content: "\\f05a2";
}

.mdi-weight-lifter::before {
  content: "\\f115d";
}

.mdi-weight-pound::before {
  content: "\\f09b5";
}

.mdi-whatsapp::before {
  content: "\\f05a3";
}

.mdi-wheel-barrow::before {
  content: "\\f14f2";
}

.mdi-wheelchair-accessibility::before {
  content: "\\f05a4";
}

.mdi-whistle::before {
  content: "\\f09b6";
}

.mdi-whistle-outline::before {
  content: "\\f12bc";
}

.mdi-white-balance-auto::before {
  content: "\\f05a5";
}

.mdi-white-balance-incandescent::before {
  content: "\\f05a6";
}

.mdi-white-balance-iridescent::before {
  content: "\\f05a7";
}

.mdi-white-balance-sunny::before {
  content: "\\f05a8";
}

.mdi-widgets::before {
  content: "\\f072c";
}

.mdi-widgets-outline::before {
  content: "\\f1355";
}

.mdi-wifi::before {
  content: "\\f05a9";
}

.mdi-wifi-alert::before {
  content: "\\f16b5";
}

.mdi-wifi-arrow-down::before {
  content: "\\f16b6";
}

.mdi-wifi-arrow-left::before {
  content: "\\f16b7";
}

.mdi-wifi-arrow-left-right::before {
  content: "\\f16b8";
}

.mdi-wifi-arrow-right::before {
  content: "\\f16b9";
}

.mdi-wifi-arrow-up::before {
  content: "\\f16ba";
}

.mdi-wifi-arrow-up-down::before {
  content: "\\f16bb";
}

.mdi-wifi-cancel::before {
  content: "\\f16bc";
}

.mdi-wifi-check::before {
  content: "\\f16bd";
}

.mdi-wifi-cog::before {
  content: "\\f16be";
}

.mdi-wifi-lock::before {
  content: "\\f16bf";
}

.mdi-wifi-lock-open::before {
  content: "\\f16c0";
}

.mdi-wifi-marker::before {
  content: "\\f16c1";
}

.mdi-wifi-minus::before {
  content: "\\f16c2";
}

.mdi-wifi-off::before {
  content: "\\f05aa";
}

.mdi-wifi-plus::before {
  content: "\\f16c3";
}

.mdi-wifi-refresh::before {
  content: "\\f16c4";
}

.mdi-wifi-remove::before {
  content: "\\f16c5";
}

.mdi-wifi-settings::before {
  content: "\\f16c6";
}

.mdi-wifi-star::before {
  content: "\\f0e0b";
}

.mdi-wifi-strength-1::before {
  content: "\\f091f";
}

.mdi-wifi-strength-1-alert::before {
  content: "\\f0920";
}

.mdi-wifi-strength-1-lock::before {
  content: "\\f0921";
}

.mdi-wifi-strength-1-lock-open::before {
  content: "\\f16cb";
}

.mdi-wifi-strength-2::before {
  content: "\\f0922";
}

.mdi-wifi-strength-2-alert::before {
  content: "\\f0923";
}

.mdi-wifi-strength-2-lock::before {
  content: "\\f0924";
}

.mdi-wifi-strength-2-lock-open::before {
  content: "\\f16cc";
}

.mdi-wifi-strength-3::before {
  content: "\\f0925";
}

.mdi-wifi-strength-3-alert::before {
  content: "\\f0926";
}

.mdi-wifi-strength-3-lock::before {
  content: "\\f0927";
}

.mdi-wifi-strength-3-lock-open::before {
  content: "\\f16cd";
}

.mdi-wifi-strength-4::before {
  content: "\\f0928";
}

.mdi-wifi-strength-4-alert::before {
  content: "\\f0929";
}

.mdi-wifi-strength-4-lock::before {
  content: "\\f092a";
}

.mdi-wifi-strength-4-lock-open::before {
  content: "\\f16ce";
}

.mdi-wifi-strength-alert-outline::before {
  content: "\\f092b";
}

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\f16cf";
}

.mdi-wifi-strength-lock-outline::before {
  content: "\\f092c";
}

.mdi-wifi-strength-off::before {
  content: "\\f092d";
}

.mdi-wifi-strength-off-outline::before {
  content: "\\f092e";
}

.mdi-wifi-strength-outline::before {
  content: "\\f092f";
}

.mdi-wifi-sync::before {
  content: "\\f16c7";
}

.mdi-wikipedia::before {
  content: "\\f05ac";
}

.mdi-wind-turbine::before {
  content: "\\f0da5";
}

.mdi-wind-turbine-alert::before {
  content: "\\f19ab";
}

.mdi-wind-turbine-check::before {
  content: "\\f19ac";
}

.mdi-window-close::before {
  content: "\\f05ad";
}

.mdi-window-closed::before {
  content: "\\f05ae";
}

.mdi-window-closed-variant::before {
  content: "\\f11db";
}

.mdi-window-maximize::before {
  content: "\\f05af";
}

.mdi-window-minimize::before {
  content: "\\f05b0";
}

.mdi-window-open::before {
  content: "\\f05b1";
}

.mdi-window-open-variant::before {
  content: "\\f11dc";
}

.mdi-window-restore::before {
  content: "\\f05b2";
}

.mdi-window-shutter::before {
  content: "\\f111c";
}

.mdi-window-shutter-alert::before {
  content: "\\f111d";
}

.mdi-window-shutter-open::before {
  content: "\\f111e";
}

.mdi-windsock::before {
  content: "\\f15fa";
}

.mdi-wiper::before {
  content: "\\f0ae9";
}

.mdi-wiper-wash::before {
  content: "\\f0da6";
}

.mdi-wiper-wash-alert::before {
  content: "\\f18df";
}

.mdi-wizard-hat::before {
  content: "\\f1477";
}

.mdi-wordpress::before {
  content: "\\f05b4";
}

.mdi-wrap::before {
  content: "\\f05b6";
}

.mdi-wrap-disabled::before {
  content: "\\f0bdf";
}

.mdi-wrench::before {
  content: "\\f05b7";
}

.mdi-wrench-clock::before {
  content: "\\f19a3";
}

.mdi-wrench-outline::before {
  content: "\\f0be0";
}

.mdi-xamarin::before {
  content: "\\f0845";
}

.mdi-xml::before {
  content: "\\f05c0";
}

.mdi-xmpp::before {
  content: "\\f07ff";
}

.mdi-yahoo::before {
  content: "\\f0b4f";
}

.mdi-yeast::before {
  content: "\\f05c1";
}

.mdi-yin-yang::before {
  content: "\\f0680";
}

.mdi-yoga::before {
  content: "\\f117c";
}

.mdi-youtube::before {
  content: "\\f05c3";
}

.mdi-youtube-gaming::before {
  content: "\\f0848";
}

.mdi-youtube-studio::before {
  content: "\\f0847";
}

.mdi-youtube-subscription::before {
  content: "\\f0d40";
}

.mdi-youtube-tv::before {
  content: "\\f0448";
}

.mdi-yurt::before {
  content: "\\f1516";
}

.mdi-z-wave::before {
  content: "\\f0aea";
}

.mdi-zend::before {
  content: "\\f0aeb";
}

.mdi-zigbee::before {
  content: "\\f0d41";
}

.mdi-zip-box::before {
  content: "\\f05c4";
}

.mdi-zip-box-outline::before {
  content: "\\f0ffa";
}

.mdi-zip-disk::before {
  content: "\\f0a23";
}

.mdi-zodiac-aquarius::before {
  content: "\\f0a7d";
}

.mdi-zodiac-aries::before {
  content: "\\f0a7e";
}

.mdi-zodiac-cancer::before {
  content: "\\f0a7f";
}

.mdi-zodiac-capricorn::before {
  content: "\\f0a80";
}

.mdi-zodiac-gemini::before {
  content: "\\f0a81";
}

.mdi-zodiac-leo::before {
  content: "\\f0a82";
}

.mdi-zodiac-libra::before {
  content: "\\f0a83";
}

.mdi-zodiac-pisces::before {
  content: "\\f0a84";
}

.mdi-zodiac-sagittarius::before {
  content: "\\f0a85";
}

.mdi-zodiac-scorpio::before {
  content: "\\f0a86";
}

.mdi-zodiac-taurus::before {
  content: "\\f0a87";
}

.mdi-zodiac-virgo::before {
  content: "\\f0a88";
}

.mdi-blank::before {
  content: "\\f68c";
  visibility: hidden;
}

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px;
}

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px;
}

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px;
}

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px;
}

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54);
}

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26);
}

.mdi-light:before {
  color: white;
}

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3);
}

.mdi-rotate-45 {
  /*
        // Not included in civil_budget
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-45:before {
  transform: rotate(45deg);
}

.mdi-rotate-90 {
  /*
        // Not included in civil_budget
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-90:before {
  transform: rotate(90deg);
}

.mdi-rotate-135 {
  /*
        // Not included in civil_budget
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-135:before {
  transform: rotate(135deg);
}

.mdi-rotate-180 {
  /*
        // Not included in civil_budget
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-180:before {
  transform: rotate(180deg);
}

.mdi-rotate-225 {
  /*
        // Not included in civil_budget
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-225:before {
  transform: rotate(225deg);
}

.mdi-rotate-270 {
  /*
        // Not included in civil_budget
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-270:before {
  transform: rotate(270deg);
}

.mdi-rotate-315 {
  /*
        // Not included in civil_budget
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */
}

.mdi-rotate-315:before {
  transform: rotate(315deg);
}

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH";
}

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV";
}

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear;
}
@keyframes mdi-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}

@font-face {
  font-family: "boxicons";
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg");
}
.bx {
  font-family: "boxicons" !important;
  font-weight: normal;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  display: inline-block;
  text-transform: none;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.bx-ul {
  margin-left: 2em;
  padding-left: 0;
  list-style: none;
}

.bx-ul > li {
  position: relative;
}

.bx-ul .bx {
  font-size: inherit;
  line-height: inherit;
  position: absolute;
  left: -2em;
  width: 2em;
  text-align: center;
}
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(359deg);
  }
}
@keyframes burst {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  90% {
    transform: scale(1.5);
    opacity: 0;
  }
}
@keyframes flashing {
  0% {
    opacity: 1;
  }
  45% {
    opacity: 0;
  }
  90% {
    opacity: 1;
  }
}
@keyframes fade-left {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(-20px);
    opacity: 0;
  }
}
@keyframes fade-right {
  0% {
    transform: translateX(0);
    opacity: 1;
  }
  75% {
    transform: translateX(20px);
    opacity: 0;
  }
}
@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(-20px);
    opacity: 0;
  }
}
@keyframes fade-down {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(20px);
    opacity: 0;
  }
}
@keyframes tada {
  from {
    transform: scale3d(1, 1, 1);
  }
  10%, 20% {
    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg);
  }
  30%, 50%, 70%, 90% {
    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);
  }
  40%, 60%, 80% {
    transform: rotate3d(0, 0, 1, -10deg);
  }
  to {
    transform: scale3d(1, 1, 1);
  }
}
.bx-spin {
  animation: spin 2s linear infinite;
}

.bx-spin-hover:hover {
  animation: spin 2s linear infinite;
}

.bx-tada {
  animation: tada 1.5s ease infinite;
}

.bx-tada-hover:hover {
  animation: tada 1.5s ease infinite;
}

.bx-flashing {
  animation: flashing 1.5s infinite linear;
}

.bx-flashing-hover:hover {
  animation: flashing 1.5s infinite linear;
}

.bx-burst {
  animation: burst 1.5s infinite linear;
}

.bx-burst-hover:hover {
  animation: burst 1.5s infinite linear;
}

.bx-fade-up {
  animation: fade-up 1.5s infinite linear;
}

.bx-fade-up-hover:hover {
  animation: fade-up 1.5s infinite linear;
}

.bx-fade-down {
  animation: fade-down 1.5s infinite linear;
}

.bx-fade-down-hover:hover {
  animation: fade-down 1.5s infinite linear;
}

.bx-fade-left {
  animation: fade-left 1.5s infinite linear;
}

.bx-fade-left-hover:hover {
  animation: fade-left 1.5s infinite linear;
}

.bx-fade-right {
  animation: fade-right 1.5s infinite linear;
}

.bx-fade-right-hover:hover {
  animation: fade-right 1.5s infinite linear;
}

.bx-xs {
  font-size: 1rem !important;
}

.bx-sm {
  font-size: 1.55rem !important;
}

.bx-md {
  font-size: 2.25rem !important;
}

.bx-lg {
  font-size: 3rem !important;
}

.bx-fw {
  font-size: 1.2857142857em;
  line-height: 0.8em;
  width: 1.2857142857em;
  height: 0.8em;
  margin-top: -0.2em !important;
  vertical-align: middle;
}

.bx-pull-left {
  float: left;
  margin-right: 0.3em !important;
}

.bx-pull-right {
  float: right;
  margin-left: 0.3em !important;
}

.bx-rotate-90 {
  transform: rotate(90deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
}

.bx-rotate-180 {
  transform: rotate(180deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
}

.bx-rotate-270 {
  transform: rotate(270deg);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
}

.bx-flip-horizontal {
  transform: scaleX(-1);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
}

.bx-flip-vertical {
  transform: scaleY(-1);
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
}

.bx-border {
  padding: 0.25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25em;
}

.bx-border-circle {
  padding: 0.25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
}

.bxl-meta:before {
  content: "\\ef27";
}

.bx-lemon:before {
  content: "\\ef28";
}

.bxs-lemon:before {
  content: "\\ef29";
}

.bx-cricket-ball:before {
  content: "\\ef0c";
}

.bx-baguette:before {
  content: "\\ef0d";
}

.bx-bowl-hot:before {
  content: "\\ef0e";
}

.bx-bowl-rice:before {
  content: "\\ef0f";
}

.bx-cable-car:before {
  content: "\\ef10";
}

.bx-candles:before {
  content: "\\ef11";
}

.bx-circle-half:before {
  content: "\\ef12";
}

.bx-circle-quarter:before {
  content: "\\ef13";
}

.bx-circle-three-quarter:before {
  content: "\\ef14";
}

.bx-cross:before {
  content: "\\ef15";
}

.bx-fork:before {
  content: "\\ef16";
}

.bx-knife:before {
  content: "\\ef17";
}

.bx-money-withdraw:before {
  content: "\\ef18";
}

.bx-popsicle:before {
  content: "\\ef19";
}

.bx-scatter-chart:before {
  content: "\\ef1a";
}

.bxs-baguette:before {
  content: "\\ef1b";
}

.bxs-bowl-hot:before {
  content: "\\ef1c";
}

.bxs-bowl-rice:before {
  content: "\\ef1d";
}

.bxs-cable-car:before {
  content: "\\ef1e";
}

.bxs-circle-half:before {
  content: "\\ef1f";
}

.bxs-circle-quarter:before {
  content: "\\ef20";
}

.bxs-circle-three-quarter:before {
  content: "\\ef21";
}

.bxs-cricket-ball:before {
  content: "\\ef22";
}

.bxs-invader:before {
  content: "\\ef23";
}

.bx-male-female:before {
  content: "\\ef24";
}

.bxs-popsicle:before {
  content: "\\ef25";
}

.bxs-tree-alt:before {
  content: "\\ef26";
}

.bxl-venmo:before {
  content: "\\e900";
}

.bxl-upwork:before {
  content: "\\e901";
}

.bxl-netlify:before {
  content: "\\e902";
}

.bxl-java:before {
  content: "\\e903";
}

.bxl-heroku:before {
  content: "\\e904";
}

.bxl-go-lang:before {
  content: "\\e905";
}

.bxl-gmail:before {
  content: "\\e906";
}

.bxl-flask:before {
  content: "\\e907";
}

.bxl-99designs:before {
  content: "\\e908";
}

.bxl-500px:before {
  content: "\\e909";
}

.bxl-adobe:before {
  content: "\\e90a";
}

.bxl-airbnb:before {
  content: "\\e90b";
}

.bxl-algolia:before {
  content: "\\e90c";
}

.bxl-amazon:before {
  content: "\\e90d";
}

.bxl-android:before {
  content: "\\e90e";
}

.bxl-angular:before {
  content: "\\e90f";
}

.bxl-apple:before {
  content: "\\e910";
}

.bxl-audible:before {
  content: "\\e911";
}

.bxl-aws:before {
  content: "\\e912";
}

.bxl-baidu:before {
  content: "\\e913";
}

.bxl-behance:before {
  content: "\\e914";
}

.bxl-bing:before {
  content: "\\e915";
}

.bxl-bitcoin:before {
  content: "\\e916";
}

.bxl-blender:before {
  content: "\\e917";
}

.bxl-blogger:before {
  content: "\\e918";
}

.bxl-bootstrap:before {
  content: "\\e919";
}

.bxl-chrome:before {
  content: "\\e91a";
}

.bxl-codepen:before {
  content: "\\e91b";
}

.bxl-c-plus-plus:before {
  content: "\\e91c";
}

.bxl-creative-commons:before {
  content: "\\e91d";
}

.bxl-css3:before {
  content: "\\e91e";
}

.bxl-dailymotion:before {
  content: "\\e91f";
}

.bxl-deviantart:before {
  content: "\\e920";
}

.bxl-dev-to:before {
  content: "\\e921";
}

.bxl-digg:before {
  content: "\\e922";
}

.bxl-digitalocean:before {
  content: "\\e923";
}

.bxl-discord:before {
  content: "\\e924";
}

.bxl-discord-alt:before {
  content: "\\e925";
}

.bxl-discourse:before {
  content: "\\e926";
}

.bxl-django:before {
  content: "\\e927";
}

.bxl-docker:before {
  content: "\\e928";
}

.bxl-dribbble:before {
  content: "\\e929";
}

.bxl-dropbox:before {
  content: "\\e92a";
}

.bxl-drupal:before {
  content: "\\e92b";
}

.bxl-ebay:before {
  content: "\\e92c";
}

.bxl-edge:before {
  content: "\\e92d";
}

.bxl-etsy:before {
  content: "\\e92e";
}

.bxl-facebook:before {
  content: "\\e92f";
}

.bxl-facebook-circle:before {
  content: "\\e930";
}

.bxl-facebook-square:before {
  content: "\\e931";
}

.bxl-figma:before {
  content: "\\e932";
}

.bxl-firebase:before {
  content: "\\e933";
}

.bxl-firefox:before {
  content: "\\e934";
}

.bxl-flickr:before {
  content: "\\e935";
}

.bxl-flickr-square:before {
  content: "\\e936";
}

.bxl-flutter:before {
  content: "\\e937";
}

.bxl-foursquare:before {
  content: "\\e938";
}

.bxl-git:before {
  content: "\\e939";
}

.bxl-github:before {
  content: "\\e93a";
}

.bxl-gitlab:before {
  content: "\\e93b";
}

.bxl-google:before {
  content: "\\e93c";
}

.bxl-google-cloud:before {
  content: "\\e93d";
}

.bxl-google-plus:before {
  content: "\\e93e";
}

.bxl-google-plus-circle:before {
  content: "\\e93f";
}

.bxl-html5:before {
  content: "\\e940";
}

.bxl-imdb:before {
  content: "\\e941";
}

.bxl-instagram:before {
  content: "\\e942";
}

.bxl-instagram-alt:before {
  content: "\\e943";
}

.bxl-internet-explorer:before {
  content: "\\e944";
}

.bxl-invision:before {
  content: "\\e945";
}

.bxl-javascript:before {
  content: "\\e946";
}

.bxl-joomla:before {
  content: "\\e947";
}

.bxl-jquery:before {
  content: "\\e948";
}

.bxl-jsfiddle:before {
  content: "\\e949";
}

.bxl-kickstarter:before {
  content: "\\e94a";
}

.bxl-kubernetes:before {
  content: "\\e94b";
}

.bxl-less:before {
  content: "\\e94c";
}

.bxl-linkedin:before {
  content: "\\e94d";
}

.bxl-linkedin-square:before {
  content: "\\e94e";
}

.bxl-magento:before {
  content: "\\e94f";
}

.bxl-mailchimp:before {
  content: "\\e950";
}

.bxl-markdown:before {
  content: "\\e951";
}

.bxl-mastercard:before {
  content: "\\e952";
}

.bxl-mastodon:before {
  content: "\\e953";
}

.bxl-medium:before {
  content: "\\e954";
}

.bxl-medium-old:before {
  content: "\\e955";
}

.bxl-medium-square:before {
  content: "\\e956";
}

.bxl-messenger:before {
  content: "\\e957";
}

.bxl-microsoft:before {
  content: "\\e958";
}

.bxl-microsoft-teams:before {
  content: "\\e959";
}

.bxl-nodejs:before {
  content: "\\e95a";
}

.bxl-ok-ru:before {
  content: "\\e95b";
}

.bxl-opera:before {
  content: "\\e95c";
}

.bxl-patreon:before {
  content: "\\e95d";
}

.bxl-paypal:before {
  content: "\\e95e";
}

.bxl-periscope:before {
  content: "\\e95f";
}

.bxl-php:before {
  content: "\\e960";
}

.bxl-pinterest:before {
  content: "\\e961";
}

.bxl-pinterest-alt:before {
  content: "\\e962";
}

.bxl-play-store:before {
  content: "\\e963";
}

.bxl-pocket:before {
  content: "\\e964";
}

.bxl-product-hunt:before {
  content: "\\e965";
}

.bxl-python:before {
  content: "\\e966";
}

.bxl-quora:before {
  content: "\\e967";
}

.bxl-react:before {
  content: "\\e968";
}

.bxl-redbubble:before {
  content: "\\e969";
}

.bxl-reddit:before {
  content: "\\e96a";
}

.bxl-redux:before {
  content: "\\e96b";
}

.bxl-sass:before {
  content: "\\e96c";
}

.bxl-shopify:before {
  content: "\\e96d";
}

.bxl-sketch:before {
  content: "\\e96e";
}

.bxl-skype:before {
  content: "\\e96f";
}

.bxl-slack:before {
  content: "\\e970";
}

.bxl-slack-old:before {
  content: "\\e971";
}

.bxl-snapchat:before {
  content: "\\e972";
}

.bxl-soundcloud:before {
  content: "\\e973";
}

.bxl-spotify:before {
  content: "\\e974";
}

.bxl-spring-boot:before {
  content: "\\e975";
}

.bxl-squarespace:before {
  content: "\\e976";
}

.bxl-stack-overflow:before {
  content: "\\e977";
}

.bxl-steam:before {
  content: "\\e978";
}

.bxl-stripe:before {
  content: "\\e979";
}

.bxl-tailwind-css:before {
  content: "\\e97a";
}

.bxl-telegram:before {
  content: "\\e97b";
}

.bxl-tiktok:before {
  content: "\\e97c";
}

.bxl-trello:before {
  content: "\\e97d";
}

.bxl-trip-advisor:before {
  content: "\\e97e";
}

.bxl-tumblr:before {
  content: "\\e97f";
}

.bxl-tux:before {
  content: "\\e980";
}

.bxl-twitch:before {
  content: "\\e981";
}

.bxl-twitter:before {
  content: "\\e982";
}

.bxl-unity:before {
  content: "\\e983";
}

.bxl-unsplash:before {
  content: "\\e984";
}

.bxl-vimeo:before {
  content: "\\e985";
}

.bxl-visa:before {
  content: "\\e986";
}

.bxl-visual-studio:before {
  content: "\\e987";
}

.bxl-vk:before {
  content: "\\e988";
}

.bxl-vuejs:before {
  content: "\\e989";
}

.bxl-whatsapp:before {
  content: "\\e98a";
}

.bxl-whatsapp-square:before {
  content: "\\e98b";
}

.bxl-wikipedia:before {
  content: "\\e98c";
}

.bxl-windows:before {
  content: "\\e98d";
}

.bxl-wix:before {
  content: "\\e98e";
}

.bxl-wordpress:before {
  content: "\\e98f";
}

.bxl-yahoo:before {
  content: "\\e990";
}

.bxl-yelp:before {
  content: "\\e991";
}

.bxl-youtube:before {
  content: "\\e992";
}

.bxl-zoom:before {
  content: "\\e993";
}

.bx-collapse-alt:before {
  content: "\\e994";
}

.bx-collapse-horizontal:before {
  content: "\\e995";
}

.bx-collapse-vertical:before {
  content: "\\e996";
}

.bx-expand-horizontal:before {
  content: "\\e997";
}

.bx-expand-vertical:before {
  content: "\\e998";
}

.bx-injection:before {
  content: "\\e999";
}

.bx-leaf:before {
  content: "\\e99a";
}

.bx-math:before {
  content: "\\e99b";
}

.bx-party:before {
  content: "\\e99c";
}

.bx-abacus:before {
  content: "\\e99d";
}

.bx-accessibility:before {
  content: "\\e99e";
}

.bx-add-to-queue:before {
  content: "\\e99f";
}

.bx-adjust:before {
  content: "\\e9a0";
}

.bx-alarm:before {
  content: "\\e9a1";
}

.bx-alarm-add:before {
  content: "\\e9a2";
}

.bx-alarm-exclamation:before {
  content: "\\e9a3";
}

.bx-alarm-off:before {
  content: "\\e9a4";
}

.bx-alarm-snooze:before {
  content: "\\e9a5";
}

.bx-album:before {
  content: "\\e9a6";
}

.bx-align-justify:before {
  content: "\\e9a7";
}

.bx-align-left:before {
  content: "\\e9a8";
}

.bx-align-middle:before {
  content: "\\e9a9";
}

.bx-align-right:before {
  content: "\\e9aa";
}

.bx-analyse:before {
  content: "\\e9ab";
}

.bx-anchor:before {
  content: "\\e9ac";
}

.bx-angry:before {
  content: "\\e9ad";
}

.bx-aperture:before {
  content: "\\e9ae";
}

.bx-arch:before {
  content: "\\e9af";
}

.bx-archive:before {
  content: "\\e9b0";
}

.bx-archive-in:before {
  content: "\\e9b1";
}

.bx-archive-out:before {
  content: "\\e9b2";
}

.bx-area:before {
  content: "\\e9b3";
}

.bx-arrow-back:before {
  content: "\\e9b4";
}

.bx-arrow-from-bottom:before {
  content: "\\e9b5";
}

.bx-arrow-from-left:before {
  content: "\\e9b6";
}

.bx-arrow-from-right:before {
  content: "\\e9b7";
}

.bx-arrow-from-top:before {
  content: "\\e9b8";
}

.bx-arrow-to-bottom:before {
  content: "\\e9b9";
}

.bx-arrow-to-left:before {
  content: "\\e9ba";
}

.bx-arrow-to-right:before {
  content: "\\e9bb";
}

.bx-arrow-to-top:before {
  content: "\\e9bc";
}

.bx-at:before {
  content: "\\e9bd";
}

.bx-atom:before {
  content: "\\e9be";
}

.bx-award:before {
  content: "\\e9bf";
}

.bx-badge:before {
  content: "\\e9c0";
}

.bx-badge-check:before {
  content: "\\e9c1";
}

.bx-ball:before {
  content: "\\e9c2";
}

.bx-band-aid:before {
  content: "\\e9c3";
}

.bx-bar-chart:before {
  content: "\\e9c4";
}

.bx-bar-chart-alt:before {
  content: "\\e9c5";
}

.bx-bar-chart-alt-2:before {
  content: "\\e9c6";
}

.bx-bar-chart-square:before {
  content: "\\e9c7";
}

.bx-barcode:before {
  content: "\\e9c8";
}

.bx-barcode-reader:before {
  content: "\\e9c9";
}

.bx-baseball:before {
  content: "\\e9ca";
}

.bx-basket:before {
  content: "\\e9cb";
}

.bx-basketball:before {
  content: "\\e9cc";
}

.bx-bath:before {
  content: "\\e9cd";
}

.bx-battery:before {
  content: "\\e9ce";
}

.bx-bed:before {
  content: "\\e9cf";
}

.bx-been-here:before {
  content: "\\e9d0";
}

.bx-beer:before {
  content: "\\e9d1";
}

.bx-bell:before {
  content: "\\e9d2";
}

.bx-bell-minus:before {
  content: "\\e9d3";
}

.bx-bell-off:before {
  content: "\\e9d4";
}

.bx-bell-plus:before {
  content: "\\e9d5";
}

.bx-bible:before {
  content: "\\e9d6";
}

.bx-bitcoin:before {
  content: "\\e9d7";
}

.bx-blanket:before {
  content: "\\e9d8";
}

.bx-block:before {
  content: "\\e9d9";
}

.bx-bluetooth:before {
  content: "\\e9da";
}

.bx-body:before {
  content: "\\e9db";
}

.bx-bold:before {
  content: "\\e9dc";
}

.bx-bolt-circle:before {
  content: "\\e9dd";
}

.bx-bomb:before {
  content: "\\e9de";
}

.bx-bone:before {
  content: "\\e9df";
}

.bx-bong:before {
  content: "\\e9e0";
}

.bx-book:before {
  content: "\\e9e1";
}

.bx-book-add:before {
  content: "\\e9e2";
}

.bx-book-alt:before {
  content: "\\e9e3";
}

.bx-book-bookmark:before {
  content: "\\e9e4";
}

.bx-book-content:before {
  content: "\\e9e5";
}

.bx-book-heart:before {
  content: "\\e9e6";
}

.bx-bookmark:before {
  content: "\\e9e7";
}

.bx-bookmark-alt:before {
  content: "\\e9e8";
}

.bx-bookmark-alt-minus:before {
  content: "\\e9e9";
}

.bx-bookmark-alt-plus:before {
  content: "\\e9ea";
}

.bx-bookmark-heart:before {
  content: "\\e9eb";
}

.bx-bookmark-minus:before {
  content: "\\e9ec";
}

.bx-bookmark-plus:before {
  content: "\\e9ed";
}

.bx-bookmarks:before {
  content: "\\e9ee";
}

.bx-book-open:before {
  content: "\\e9ef";
}

.bx-book-reader:before {
  content: "\\e9f0";
}

.bx-border-all:before {
  content: "\\e9f1";
}

.bx-border-bottom:before {
  content: "\\e9f2";
}

.bx-border-inner:before {
  content: "\\e9f3";
}

.bx-border-left:before {
  content: "\\e9f4";
}

.bx-border-none:before {
  content: "\\e9f5";
}

.bx-border-outer:before {
  content: "\\e9f6";
}

.bx-border-radius:before {
  content: "\\e9f7";
}

.bx-border-right:before {
  content: "\\e9f8";
}

.bx-border-top:before {
  content: "\\e9f9";
}

.bx-bot:before {
  content: "\\e9fa";
}

.bx-bowling-ball:before {
  content: "\\e9fb";
}

.bx-box:before {
  content: "\\e9fc";
}

.bx-bracket:before {
  content: "\\e9fd";
}

.bx-braille:before {
  content: "\\e9fe";
}

.bx-brain:before {
  content: "\\e9ff";
}

.bx-briefcase:before {
  content: "\\ea00";
}

.bx-briefcase-alt:before {
  content: "\\ea01";
}

.bx-briefcase-alt-2:before {
  content: "\\ea02";
}

.bx-brightness:before {
  content: "\\ea03";
}

.bx-brightness-half:before {
  content: "\\ea04";
}

.bx-broadcast:before {
  content: "\\ea05";
}

.bx-brush:before {
  content: "\\ea06";
}

.bx-brush-alt:before {
  content: "\\ea07";
}

.bx-bug:before {
  content: "\\ea08";
}

.bx-bug-alt:before {
  content: "\\ea09";
}

.bx-building:before {
  content: "\\ea0a";
}

.bx-building-house:before {
  content: "\\ea0b";
}

.bx-buildings:before {
  content: "\\ea0c";
}

.bx-bulb:before {
  content: "\\ea0d";
}

.bx-bullseye:before {
  content: "\\ea0e";
}

.bx-buoy:before {
  content: "\\ea0f";
}

.bx-bus:before {
  content: "\\ea10";
}

.bx-bus-school:before {
  content: "\\ea11";
}

.bx-cabinet:before {
  content: "\\ea12";
}

.bx-cake:before {
  content: "\\ea13";
}

.bx-calculator:before {
  content: "\\ea14";
}

.bx-calendar:before {
  content: "\\ea15";
}

.bx-calendar-alt:before {
  content: "\\ea16";
}

.bx-calendar-check:before {
  content: "\\ea17";
}

.bx-calendar-edit:before {
  content: "\\ea18";
}

.bx-calendar-event:before {
  content: "\\ea19";
}

.bx-calendar-exclamation:before {
  content: "\\ea1a";
}

.bx-calendar-heart:before {
  content: "\\ea1b";
}

.bx-calendar-minus:before {
  content: "\\ea1c";
}

.bx-calendar-plus:before {
  content: "\\ea1d";
}

.bx-calendar-star:before {
  content: "\\ea1e";
}

.bx-calendar-week:before {
  content: "\\ea1f";
}

.bx-calendar-x:before {
  content: "\\ea20";
}

.bx-camera:before {
  content: "\\ea21";
}

.bx-camera-home:before {
  content: "\\ea22";
}

.bx-camera-movie:before {
  content: "\\ea23";
}

.bx-camera-off:before {
  content: "\\ea24";
}

.bx-capsule:before {
  content: "\\ea25";
}

.bx-captions:before {
  content: "\\ea26";
}

.bx-car:before {
  content: "\\ea27";
}

.bx-card:before {
  content: "\\ea28";
}

.bx-caret-down:before {
  content: "\\ea29";
}

.bx-caret-down-circle:before {
  content: "\\ea2a";
}

.bx-caret-down-square:before {
  content: "\\ea2b";
}

.bx-caret-left:before {
  content: "\\ea2c";
}

.bx-caret-left-circle:before {
  content: "\\ea2d";
}

.bx-caret-left-square:before {
  content: "\\ea2e";
}

.bx-caret-right:before {
  content: "\\ea2f";
}

.bx-caret-right-circle:before {
  content: "\\ea30";
}

.bx-caret-right-square:before {
  content: "\\ea31";
}

.bx-caret-up:before {
  content: "\\ea32";
}

.bx-caret-up-circle:before {
  content: "\\ea33";
}

.bx-caret-up-square:before {
  content: "\\ea34";
}

.bx-carousel:before {
  content: "\\ea35";
}

.bx-cart:before {
  content: "\\ea36";
}

.bx-cart-alt:before {
  content: "\\ea37";
}

.bx-cast:before {
  content: "\\ea38";
}

.bx-category:before {
  content: "\\ea39";
}

.bx-category-alt:before {
  content: "\\ea3a";
}

.bx-cctv:before {
  content: "\\ea3b";
}

.bx-certification:before {
  content: "\\ea3c";
}

.bx-chair:before {
  content: "\\ea3d";
}

.bx-chalkboard:before {
  content: "\\ea3e";
}

.bx-chart:before {
  content: "\\ea3f";
}

.bx-chat:before {
  content: "\\ea40";
}

.bx-check:before {
  content: "\\ea41";
}

.bx-checkbox:before {
  content: "\\ea42";
}

.bx-checkbox-checked:before {
  content: "\\ea43";
}

.bx-checkbox-minus:before {
  content: "\\ea44";
}

.bx-checkbox-square:before {
  content: "\\ea45";
}

.bx-check-circle:before {
  content: "\\ea46";
}

.bx-check-double:before {
  content: "\\ea47";
}

.bx-check-shield:before {
  content: "\\ea48";
}

.bx-check-square:before {
  content: "\\ea49";
}

.bx-chevron-down:before {
  content: "\\ea4a";
}

.bx-chevron-down-circle:before {
  content: "\\ea4b";
}

.bx-chevron-down-square:before {
  content: "\\ea4c";
}

.bx-chevron-left:before {
  content: "\\ea4d";
}

.bx-chevron-left-circle:before {
  content: "\\ea4e";
}

.bx-chevron-left-square:before {
  content: "\\ea4f";
}

.bx-chevron-right:before {
  content: "\\ea50";
}

.bx-chevron-right-circle:before {
  content: "\\ea51";
}

.bx-chevron-right-square:before {
  content: "\\ea52";
}

.bx-chevrons-down:before {
  content: "\\ea53";
}

.bx-chevrons-left:before {
  content: "\\ea54";
}

.bx-chevrons-right:before {
  content: "\\ea55";
}

.bx-chevrons-up:before {
  content: "\\ea56";
}

.bx-chevron-up:before {
  content: "\\ea57";
}

.bx-chevron-up-circle:before {
  content: "\\ea58";
}

.bx-chevron-up-square:before {
  content: "\\ea59";
}

.bx-chip:before {
  content: "\\ea5a";
}

.bx-church:before {
  content: "\\ea5b";
}

.bx-circle:before {
  content: "\\ea5c";
}

.bx-clinic:before {
  content: "\\ea5d";
}

.bx-clipboard:before {
  content: "\\ea5e";
}

.bx-closet:before {
  content: "\\ea5f";
}

.bx-cloud:before {
  content: "\\ea60";
}

.bx-cloud-download:before {
  content: "\\ea61";
}

.bx-cloud-drizzle:before {
  content: "\\ea62";
}

.bx-cloud-lightning:before {
  content: "\\ea63";
}

.bx-cloud-light-rain:before {
  content: "\\ea64";
}

.bx-cloud-rain:before {
  content: "\\ea65";
}

.bx-cloud-snow:before {
  content: "\\ea66";
}

.bx-cloud-upload:before {
  content: "\\ea67";
}

.bx-code:before {
  content: "\\ea68";
}

.bx-code-alt:before {
  content: "\\ea69";
}

.bx-code-block:before {
  content: "\\ea6a";
}

.bx-code-curly:before {
  content: "\\ea6b";
}

.bx-coffee:before {
  content: "\\ea6c";
}

.bx-coffee-togo:before {
  content: "\\ea6d";
}

.bx-cog:before {
  content: "\\ea6e";
}

.bx-coin:before {
  content: "\\ea6f";
}

.bx-coin-stack:before {
  content: "\\ea70";
}

.bx-collapse:before {
  content: "\\ea71";
}

.bx-collection:before {
  content: "\\ea72";
}

.bx-color-fill:before {
  content: "\\ea73";
}

.bx-columns:before {
  content: "\\ea74";
}

.bx-command:before {
  content: "\\ea75";
}

.bx-comment:before {
  content: "\\ea76";
}

.bx-comment-add:before {
  content: "\\ea77";
}

.bx-comment-check:before {
  content: "\\ea78";
}

.bx-comment-detail:before {
  content: "\\ea79";
}

.bx-comment-dots:before {
  content: "\\ea7a";
}

.bx-comment-edit:before {
  content: "\\ea7b";
}

.bx-comment-error:before {
  content: "\\ea7c";
}

.bx-comment-minus:before {
  content: "\\ea7d";
}

.bx-comment-x:before {
  content: "\\ea7e";
}

.bx-compass:before {
  content: "\\ea7f";
}

.bx-confused:before {
  content: "\\ea80";
}

.bx-conversation:before {
  content: "\\ea81";
}

.bx-cookie:before {
  content: "\\ea82";
}

.bx-cool:before {
  content: "\\ea83";
}

.bx-copy:before {
  content: "\\ea84";
}

.bx-copy-alt:before {
  content: "\\ea85";
}

.bx-copyright:before {
  content: "\\ea86";
}

.bx-credit-card:before {
  content: "\\ea87";
}

.bx-credit-card-alt:before {
  content: "\\ea88";
}

.bx-credit-card-front:before {
  content: "\\ea89";
}

.bx-crop:before {
  content: "\\ea8a";
}

.bx-crosshair:before {
  content: "\\ea8b";
}

.bx-crown:before {
  content: "\\ea8c";
}

.bx-cube:before {
  content: "\\ea8d";
}

.bx-cube-alt:before {
  content: "\\ea8e";
}

.bx-cuboid:before {
  content: "\\ea8f";
}

.bx-current-location:before {
  content: "\\ea90";
}

.bx-customize:before {
  content: "\\ea91";
}

.bx-cut:before {
  content: "\\ea92";
}

.bx-cycling:before {
  content: "\\ea93";
}

.bx-cylinder:before {
  content: "\\ea94";
}

.bx-data:before {
  content: "\\ea95";
}

.bx-desktop:before {
  content: "\\ea96";
}

.bx-detail:before {
  content: "\\ea97";
}

.bx-devices:before {
  content: "\\ea98";
}

.bx-dialpad:before {
  content: "\\ea99";
}

.bx-dialpad-alt:before {
  content: "\\ea9a";
}

.bx-diamond:before {
  content: "\\ea9b";
}

.bx-dice-1:before {
  content: "\\ea9c";
}

.bx-dice-2:before {
  content: "\\ea9d";
}

.bx-dice-3:before {
  content: "\\ea9e";
}

.bx-dice-4:before {
  content: "\\ea9f";
}

.bx-dice-5:before {
  content: "\\eaa0";
}

.bx-dice-6:before {
  content: "\\eaa1";
}

.bx-directions:before {
  content: "\\eaa2";
}

.bx-disc:before {
  content: "\\eaa3";
}

.bx-dish:before {
  content: "\\eaa4";
}

.bx-dislike:before {
  content: "\\eaa5";
}

.bx-dizzy:before {
  content: "\\eaa6";
}

.bx-dna:before {
  content: "\\eaa7";
}

.bx-dock-bottom:before {
  content: "\\eaa8";
}

.bx-dock-left:before {
  content: "\\eaa9";
}

.bx-dock-right:before {
  content: "\\eaaa";
}

.bx-dock-top:before {
  content: "\\eaab";
}

.bx-dollar:before {
  content: "\\eaac";
}

.bx-dollar-circle:before {
  content: "\\eaad";
}

.bx-donate-blood:before {
  content: "\\eaae";
}

.bx-donate-heart:before {
  content: "\\eaaf";
}

.bx-door-open:before {
  content: "\\eab0";
}

.bx-dots-horizontal:before {
  content: "\\eab1";
}

.bx-dots-horizontal-rounded:before {
  content: "\\eab2";
}

.bx-dots-vertical:before {
  content: "\\eab3";
}

.bx-dots-vertical-rounded:before {
  content: "\\eab4";
}

.bx-doughnut-chart:before {
  content: "\\eab5";
}

.bx-down-arrow:before {
  content: "\\eab6";
}

.bx-down-arrow-alt:before {
  content: "\\eab7";
}

.bx-down-arrow-circle:before {
  content: "\\eab8";
}

.bx-download:before {
  content: "\\eab9";
}

.bx-downvote:before {
  content: "\\eaba";
}

.bx-drink:before {
  content: "\\eabb";
}

.bx-droplet:before {
  content: "\\eabc";
}

.bx-dumbbell:before {
  content: "\\eabd";
}

.bx-duplicate:before {
  content: "\\eabe";
}

.bx-edit:before {
  content: "\\eabf";
}

.bx-edit-alt:before {
  content: "\\eac0";
}

.bx-envelope:before {
  content: "\\eac1";
}

.bx-envelope-open:before {
  content: "\\eac2";
}

.bx-equalizer:before {
  content: "\\eac3";
}

.bx-eraser:before {
  content: "\\eac4";
}

.bx-error:before {
  content: "\\eac5";
}

.bx-error-alt:before {
  content: "\\eac6";
}

.bx-error-circle:before {
  content: "\\eac7";
}

.bx-euro:before {
  content: "\\eac8";
}

.bx-exclude:before {
  content: "\\eac9";
}

.bx-exit:before {
  content: "\\eaca";
}

.bx-exit-fullscreen:before {
  content: "\\eacb";
}

.bx-expand:before {
  content: "\\eacc";
}

.bx-expand-alt:before {
  content: "\\eacd";
}

.bx-export:before {
  content: "\\eace";
}

.bx-extension:before {
  content: "\\eacf";
}

.bx-face:before {
  content: "\\ead0";
}

.bx-fast-forward:before {
  content: "\\ead1";
}

.bx-fast-forward-circle:before {
  content: "\\ead2";
}

.bx-female:before {
  content: "\\ead3";
}

.bx-female-sign:before {
  content: "\\ead4";
}

.bx-file:before {
  content: "\\ead5";
}

.bx-file-blank:before {
  content: "\\ead6";
}

.bx-file-find:before {
  content: "\\ead7";
}

.bx-film:before {
  content: "\\ead8";
}

.bx-filter:before {
  content: "\\ead9";
}

.bx-filter-alt:before {
  content: "\\eada";
}

.bx-fingerprint:before {
  content: "\\eadb";
}

.bx-first-aid:before {
  content: "\\eadc";
}

.bx-first-page:before {
  content: "\\eadd";
}

.bx-flag:before {
  content: "\\eade";
}

.bx-folder:before {
  content: "\\eadf";
}

.bx-folder-minus:before {
  content: "\\eae0";
}

.bx-folder-open:before {
  content: "\\eae1";
}

.bx-folder-plus:before {
  content: "\\eae2";
}

.bx-font:before {
  content: "\\eae3";
}

.bx-font-color:before {
  content: "\\eae4";
}

.bx-font-family:before {
  content: "\\eae5";
}

.bx-font-size:before {
  content: "\\eae6";
}

.bx-food-menu:before {
  content: "\\eae7";
}

.bx-food-tag:before {
  content: "\\eae8";
}

.bx-football:before {
  content: "\\eae9";
}

.bx-fridge:before {
  content: "\\eaea";
}

.bx-fullscreen:before {
  content: "\\eaeb";
}

.bx-game:before {
  content: "\\eaec";
}

.bx-gas-pump:before {
  content: "\\eaed";
}

.bx-ghost:before {
  content: "\\eaee";
}

.bx-gift:before {
  content: "\\eaef";
}

.bx-git-branch:before {
  content: "\\eaf0";
}

.bx-git-commit:before {
  content: "\\eaf1";
}

.bx-git-compare:before {
  content: "\\eaf2";
}

.bx-git-merge:before {
  content: "\\eaf3";
}

.bx-git-pull-request:before {
  content: "\\eaf4";
}

.bx-git-repo-forked:before {
  content: "\\eaf5";
}

.bx-glasses:before {
  content: "\\eaf6";
}

.bx-glasses-alt:before {
  content: "\\eaf7";
}

.bx-globe:before {
  content: "\\eaf8";
}

.bx-globe-alt:before {
  content: "\\eaf9";
}

.bx-grid:before {
  content: "\\eafa";
}

.bx-grid-alt:before {
  content: "\\eafb";
}

.bx-grid-horizontal:before {
  content: "\\eafc";
}

.bx-grid-small:before {
  content: "\\eafd";
}

.bx-grid-vertical:before {
  content: "\\eafe";
}

.bx-group:before {
  content: "\\eaff";
}

.bx-handicap:before {
  content: "\\eb00";
}

.bx-happy:before {
  content: "\\eb01";
}

.bx-happy-alt:before {
  content: "\\eb02";
}

.bx-happy-beaming:before {
  content: "\\eb03";
}

.bx-happy-heart-eyes:before {
  content: "\\eb04";
}

.bx-hash:before {
  content: "\\eb05";
}

.bx-hdd:before {
  content: "\\eb06";
}

.bx-heading:before {
  content: "\\eb07";
}

.bx-headphone:before {
  content: "\\eb08";
}

.bx-health:before {
  content: "\\eb09";
}

.bx-heart:before {
  content: "\\eb0a";
}

.bx-heart-circle:before {
  content: "\\eb0b";
}

.bx-heart-square:before {
  content: "\\eb0c";
}

.bx-help-circle:before {
  content: "\\eb0d";
}

.bx-hide:before {
  content: "\\eb0e";
}

.bx-highlight:before {
  content: "\\eb0f";
}

.bx-history:before {
  content: "\\eb10";
}

.bx-hive:before {
  content: "\\eb11";
}

.bx-home:before {
  content: "\\eb12";
}

.bx-home-alt:before {
  content: "\\eb13";
}

.bx-home-circle:before {
  content: "\\eb14";
}

.bx-home-heart:before {
  content: "\\eb15";
}

.bx-home-smile:before {
  content: "\\eb16";
}

.bx-horizontal-center:before {
  content: "\\eb17";
}

.bx-hotel:before {
  content: "\\eb18";
}

.bx-hourglass:before {
  content: "\\eb19";
}

.bx-id-card:before {
  content: "\\eb1a";
}

.bx-image:before {
  content: "\\eb1b";
}

.bx-image-add:before {
  content: "\\eb1c";
}

.bx-image-alt:before {
  content: "\\eb1d";
}

.bx-images:before {
  content: "\\eb1e";
}

.bx-import:before {
  content: "\\eb1f";
}

.bx-infinite:before {
  content: "\\eb20";
}

.bx-info-circle:before {
  content: "\\eb21";
}

.bx-info-square:before {
  content: "\\eb22";
}

.bx-intersect:before {
  content: "\\eb23";
}

.bx-italic:before {
  content: "\\eb24";
}

.bx-joystick:before {
  content: "\\eb25";
}

.bx-joystick-alt:before {
  content: "\\eb26";
}

.bx-joystick-button:before {
  content: "\\eb27";
}

.bx-key:before {
  content: "\\eb28";
}

.bx-label:before {
  content: "\\eb29";
}

.bx-landscape:before {
  content: "\\eb2a";
}

.bx-laptop:before {
  content: "\\eb2b";
}

.bx-last-page:before {
  content: "\\eb2c";
}

.bx-laugh:before {
  content: "\\eb2d";
}

.bx-layer:before {
  content: "\\eb2e";
}

.bx-layer-minus:before {
  content: "\\eb2f";
}

.bx-layer-plus:before {
  content: "\\eb30";
}

.bx-layout:before {
  content: "\\eb31";
}

.bx-left-arrow:before {
  content: "\\eb32";
}

.bx-left-arrow-alt:before {
  content: "\\eb33";
}

.bx-left-arrow-circle:before {
  content: "\\eb34";
}

.bx-left-down-arrow-circle:before {
  content: "\\eb35";
}

.bx-left-indent:before {
  content: "\\eb36";
}

.bx-left-top-arrow-circle:before {
  content: "\\eb37";
}

.bx-library:before {
  content: "\\eb38";
}

.bx-like:before {
  content: "\\eb39";
}

.bx-line-chart:before {
  content: "\\eb3a";
}

.bx-line-chart-down:before {
  content: "\\eb3b";
}

.bx-link:before {
  content: "\\eb3c";
}

.bx-link-alt:before {
  content: "\\eb3d";
}

.bx-link-external:before {
  content: "\\eb3e";
}

.bx-lira:before {
  content: "\\eb3f";
}

.bx-list-check:before {
  content: "\\eb40";
}

.bx-list-minus:before {
  content: "\\eb41";
}

.bx-list-ol:before {
  content: "\\eb42";
}

.bx-list-plus:before {
  content: "\\eb43";
}

.bx-list-ul:before {
  content: "\\eb44";
}

.bx-loader:before {
  content: "\\eb45";
}

.bx-loader-alt:before {
  content: "\\eb46";
}

.bx-loader-circle:before {
  content: "\\eb47";
}

.bx-location-plus:before {
  content: "\\eb48";
}

.bx-lock:before {
  content: "\\eb49";
}

.bx-lock-alt:before {
  content: "\\eb4a";
}

.bx-lock-open:before {
  content: "\\eb4b";
}

.bx-lock-open-alt:before {
  content: "\\eb4c";
}

.bx-log-in:before {
  content: "\\eb4d";
}

.bx-log-in-circle:before {
  content: "\\eb4e";
}

.bx-log-out:before {
  content: "\\eb4f";
}

.bx-log-out-circle:before {
  content: "\\eb50";
}

.bx-low-vision:before {
  content: "\\eb51";
}

.bx-magnet:before {
  content: "\\eb52";
}

.bx-mail-send:before {
  content: "\\eb53";
}

.bx-male:before {
  content: "\\eb54";
}

.bx-male-sign:before {
  content: "\\eb55";
}

.bx-map:before {
  content: "\\eb56";
}

.bx-map-alt:before {
  content: "\\eb57";
}

.bx-map-pin:before {
  content: "\\eb58";
}

.bx-mask:before {
  content: "\\eb59";
}

.bx-medal:before {
  content: "\\eb5a";
}

.bx-meh:before {
  content: "\\eb5b";
}

.bx-meh-alt:before {
  content: "\\eb5c";
}

.bx-meh-blank:before {
  content: "\\eb5d";
}

.bx-memory-card:before {
  content: "\\eb5e";
}

.bx-menu:before {
  content: "\\eb5f";
}

.bx-menu-alt-left:before {
  content: "\\eb60";
}

.bx-menu-alt-right:before {
  content: "\\eb61";
}

.bx-merge:before {
  content: "\\eb62";
}

.bx-message:before {
  content: "\\eb63";
}

.bx-message-add:before {
  content: "\\eb64";
}

.bx-message-alt:before {
  content: "\\eb65";
}

.bx-message-alt-add:before {
  content: "\\eb66";
}

.bx-message-alt-check:before {
  content: "\\eb67";
}

.bx-message-alt-detail:before {
  content: "\\eb68";
}

.bx-message-alt-dots:before {
  content: "\\eb69";
}

.bx-message-alt-edit:before {
  content: "\\eb6a";
}

.bx-message-alt-error:before {
  content: "\\eb6b";
}

.bx-message-alt-minus:before {
  content: "\\eb6c";
}

.bx-message-alt-x:before {
  content: "\\eb6d";
}

.bx-message-check:before {
  content: "\\eb6e";
}

.bx-message-detail:before {
  content: "\\eb6f";
}

.bx-message-dots:before {
  content: "\\eb70";
}

.bx-message-edit:before {
  content: "\\eb71";
}

.bx-message-error:before {
  content: "\\eb72";
}

.bx-message-minus:before {
  content: "\\eb73";
}

.bx-message-rounded:before {
  content: "\\eb74";
}

.bx-message-rounded-add:before {
  content: "\\eb75";
}

.bx-message-rounded-check:before {
  content: "\\eb76";
}

.bx-message-rounded-detail:before {
  content: "\\eb77";
}

.bx-message-rounded-dots:before {
  content: "\\eb78";
}

.bx-message-rounded-edit:before {
  content: "\\eb79";
}

.bx-message-rounded-error:before {
  content: "\\eb7a";
}

.bx-message-rounded-minus:before {
  content: "\\eb7b";
}

.bx-message-rounded-x:before {
  content: "\\eb7c";
}

.bx-message-square:before {
  content: "\\eb7d";
}

.bx-message-square-add:before {
  content: "\\eb7e";
}

.bx-message-square-check:before {
  content: "\\eb7f";
}

.bx-message-square-detail:before {
  content: "\\eb80";
}

.bx-message-square-dots:before {
  content: "\\eb81";
}

.bx-message-square-edit:before {
  content: "\\eb82";
}

.bx-message-square-error:before {
  content: "\\eb83";
}

.bx-message-square-minus:before {
  content: "\\eb84";
}

.bx-message-square-x:before {
  content: "\\eb85";
}

.bx-message-x:before {
  content: "\\eb86";
}

.bx-meteor:before {
  content: "\\eb87";
}

.bx-microchip:before {
  content: "\\eb88";
}

.bx-microphone:before {
  content: "\\eb89";
}

.bx-microphone-off:before {
  content: "\\eb8a";
}

.bx-minus:before {
  content: "\\eb8b";
}

.bx-minus-back:before {
  content: "\\eb8c";
}

.bx-minus-circle:before {
  content: "\\eb8d";
}

.bx-minus-front:before {
  content: "\\eb8e";
}

.bx-mobile:before {
  content: "\\eb8f";
}

.bx-mobile-alt:before {
  content: "\\eb90";
}

.bx-mobile-landscape:before {
  content: "\\eb91";
}

.bx-mobile-vibration:before {
  content: "\\eb92";
}

.bx-money:before {
  content: "\\eb93";
}

.bx-moon:before {
  content: "\\eb94";
}

.bx-mouse:before {
  content: "\\eb95";
}

.bx-mouse-alt:before {
  content: "\\eb96";
}

.bx-move:before {
  content: "\\eb97";
}

.bx-move-horizontal:before {
  content: "\\eb98";
}

.bx-move-vertical:before {
  content: "\\eb99";
}

.bx-movie:before {
  content: "\\eb9a";
}

.bx-movie-play:before {
  content: "\\eb9b";
}

.bx-music:before {
  content: "\\eb9c";
}

.bx-navigation:before {
  content: "\\eb9d";
}

.bx-network-chart:before {
  content: "\\eb9e";
}

.bx-news:before {
  content: "\\eb9f";
}

.bx-no-entry:before {
  content: "\\eba0";
}

.bx-note:before {
  content: "\\eba1";
}

.bx-notepad:before {
  content: "\\eba2";
}

.bx-notification:before {
  content: "\\eba3";
}

.bx-notification-off:before {
  content: "\\eba4";
}

.bx-outline:before {
  content: "\\eba5";
}

.bx-package:before {
  content: "\\eba6";
}

.bx-paint:before {
  content: "\\eba7";
}

.bx-paint-roll:before {
  content: "\\eba8";
}

.bx-palette:before {
  content: "\\eba9";
}

.bx-paperclip:before {
  content: "\\ebaa";
}

.bx-paper-plane:before {
  content: "\\ebab";
}

.bx-paragraph:before {
  content: "\\ebac";
}

.bx-paste:before {
  content: "\\ebad";
}

.bx-pause:before {
  content: "\\ebae";
}

.bx-pause-circle:before {
  content: "\\ebaf";
}

.bx-pen:before {
  content: "\\ebb0";
}

.bx-pencil:before {
  content: "\\ebb1";
}

.bx-phone:before {
  content: "\\ebb2";
}

.bx-phone-call:before {
  content: "\\ebb3";
}

.bx-phone-incoming:before {
  content: "\\ebb4";
}

.bx-phone-off:before {
  content: "\\ebb5";
}

.bx-phone-outgoing:before {
  content: "\\ebb6";
}

.bx-photo-album:before {
  content: "\\ebb7";
}

.bx-pie-chart:before {
  content: "\\ebb8";
}

.bx-pie-chart-alt:before {
  content: "\\ebb9";
}

.bx-pie-chart-alt-2:before {
  content: "\\ebba";
}

.bx-pin:before {
  content: "\\ebbb";
}

.bx-planet:before {
  content: "\\ebbc";
}

.bx-play:before {
  content: "\\ebbd";
}

.bx-play-circle:before {
  content: "\\ebbe";
}

.bx-plug:before {
  content: "\\ebbf";
}

.bx-plus:before {
  content: "\\ebc0";
}

.bx-plus-circle:before {
  content: "\\ebc1";
}

.bx-plus-medical:before {
  content: "\\ebc2";
}

.bx-podcast:before {
  content: "\\ebc3";
}

.bx-pointer:before {
  content: "\\ebc4";
}

.bx-poll:before {
  content: "\\ebc5";
}

.bx-polygon:before {
  content: "\\ebc6";
}

.bx-pound:before {
  content: "\\ebc7";
}

.bx-power-off:before {
  content: "\\ebc8";
}

.bx-printer:before {
  content: "\\ebc9";
}

.bx-pulse:before {
  content: "\\ebca";
}

.bx-purchase-tag:before {
  content: "\\ebcb";
}

.bx-purchase-tag-alt:before {
  content: "\\ebcc";
}

.bx-pyramid:before {
  content: "\\ebcd";
}

.bx-qr:before {
  content: "\\ebce";
}

.bx-qr-scan:before {
  content: "\\ebcf";
}

.bx-question-mark:before {
  content: "\\ebd0";
}

.bx-radar:before {
  content: "\\ebd1";
}

.bx-radio:before {
  content: "\\ebd2";
}

.bx-radio-circle:before {
  content: "\\ebd3";
}

.bx-radio-circle-marked:before {
  content: "\\ebd4";
}

.bx-receipt:before {
  content: "\\ebd5";
}

.bx-rectangle:before {
  content: "\\ebd6";
}

.bx-recycle:before {
  content: "\\ebd7";
}

.bx-redo:before {
  content: "\\ebd8";
}

.bx-refresh:before {
  content: "\\ebd9";
}

.bx-registered:before {
  content: "\\ebda";
}

.bx-rename:before {
  content: "\\ebdb";
}

.bx-repeat:before {
  content: "\\ebdc";
}

.bx-reply:before {
  content: "\\ebdd";
}

.bx-reply-all:before {
  content: "\\ebde";
}

.bx-repost:before {
  content: "\\ebdf";
}

.bx-reset:before {
  content: "\\ebe0";
}

.bx-restaurant:before {
  content: "\\ebe1";
}

.bx-revision:before {
  content: "\\ebe2";
}

.bx-rewind:before {
  content: "\\ebe3";
}

.bx-rewind-circle:before {
  content: "\\ebe4";
}

.bx-right-arrow:before {
  content: "\\ebe5";
}

.bx-right-arrow-alt:before {
  content: "\\ebe6";
}

.bx-right-arrow-circle:before {
  content: "\\ebe7";
}

.bx-right-down-arrow-circle:before {
  content: "\\ebe8";
}

.bx-right-indent:before {
  content: "\\ebe9";
}

.bx-right-top-arrow-circle:before {
  content: "\\ebea";
}

.bx-rocket:before {
  content: "\\ebeb";
}

.bx-rotate-left:before {
  content: "\\ebec";
}

.bx-rotate-right:before {
  content: "\\ebed";
}

.bx-rss:before {
  content: "\\ebee";
}

.bx-ruble:before {
  content: "\\ebef";
}

.bx-ruler:before {
  content: "\\ebf0";
}

.bx-run:before {
  content: "\\ebf1";
}

.bx-rupee:before {
  content: "\\ebf2";
}

.bx-sad:before {
  content: "\\ebf3";
}

.bx-save:before {
  content: "\\ebf4";
}

.bx-scan:before {
  content: "\\ebf5";
}

.bx-screenshot:before {
  content: "\\ebf6";
}

.bx-search:before {
  content: "\\ebf7";
}

.bx-search-alt:before {
  content: "\\ebf8";
}

.bx-search-alt-2:before {
  content: "\\ebf9";
}

.bx-selection:before {
  content: "\\ebfa";
}

.bx-select-multiple:before {
  content: "\\ebfb";
}

.bx-send:before {
  content: "\\ebfc";
}

.bx-server:before {
  content: "\\ebfd";
}

.bx-shape-circle:before {
  content: "\\ebfe";
}

.bx-shape-polygon:before {
  content: "\\ebff";
}

.bx-shape-square:before {
  content: "\\ec00";
}

.bx-shape-triangle:before {
  content: "\\ec01";
}

.bx-share:before {
  content: "\\ec02";
}

.bx-share-alt:before {
  content: "\\ec03";
}

.bx-shekel:before {
  content: "\\ec04";
}

.bx-shield:before {
  content: "\\ec05";
}

.bx-shield-alt:before {
  content: "\\ec06";
}

.bx-shield-alt-2:before {
  content: "\\ec07";
}

.bx-shield-quarter:before {
  content: "\\ec08";
}

.bx-shield-x:before {
  content: "\\ec09";
}

.bx-shocked:before {
  content: "\\ec0a";
}

.bx-shopping-bag:before {
  content: "\\ec0b";
}

.bx-show:before {
  content: "\\ec0c";
}

.bx-show-alt:before {
  content: "\\ec0d";
}

.bx-shuffle:before {
  content: "\\ec0e";
}

.bx-sidebar:before {
  content: "\\ec0f";
}

.bx-sitemap:before {
  content: "\\ec10";
}

.bx-skip-next:before {
  content: "\\ec11";
}

.bx-skip-next-circle:before {
  content: "\\ec12";
}

.bx-skip-previous:before {
  content: "\\ec13";
}

.bx-skip-previous-circle:before {
  content: "\\ec14";
}

.bx-sleepy:before {
  content: "\\ec15";
}

.bx-slider:before {
  content: "\\ec16";
}

.bx-slider-alt:before {
  content: "\\ec17";
}

.bx-slideshow:before {
  content: "\\ec18";
}

.bx-smile:before {
  content: "\\ec19";
}

.bx-sort:before {
  content: "\\ec1a";
}

.bx-sort-alt-2:before {
  content: "\\ec1b";
}

.bx-sort-a-z:before {
  content: "\\ec1c";
}

.bx-sort-down:before {
  content: "\\ec1d";
}

.bx-sort-up:before {
  content: "\\ec1e";
}

.bx-sort-z-a:before {
  content: "\\ec1f";
}

.bx-spa:before {
  content: "\\ec20";
}

.bx-space-bar:before {
  content: "\\ec21";
}

.bx-speaker:before {
  content: "\\ec22";
}

.bx-spray-can:before {
  content: "\\ec23";
}

.bx-spreadsheet:before {
  content: "\\ec24";
}

.bx-square:before {
  content: "\\ec25";
}

.bx-square-rounded:before {
  content: "\\ec26";
}

.bx-star:before {
  content: "\\ec27";
}

.bx-station:before {
  content: "\\ec28";
}

.bx-stats:before {
  content: "\\ec29";
}

.bx-sticker:before {
  content: "\\ec2a";
}

.bx-stop:before {
  content: "\\ec2b";
}

.bx-stop-circle:before {
  content: "\\ec2c";
}

.bx-stopwatch:before {
  content: "\\ec2d";
}

.bx-store:before {
  content: "\\ec2e";
}

.bx-store-alt:before {
  content: "\\ec2f";
}

.bx-street-view:before {
  content: "\\ec30";
}

.bx-strikethrough:before {
  content: "\\ec31";
}

.bx-subdirectory-left:before {
  content: "\\ec32";
}

.bx-subdirectory-right:before {
  content: "\\ec33";
}

.bx-sun:before {
  content: "\\ec34";
}

.bx-support:before {
  content: "\\ec35";
}

.bx-swim:before {
  content: "\\ec36";
}

.bx-sync:before {
  content: "\\ec37";
}

.bx-tab:before {
  content: "\\ec38";
}

.bx-table:before {
  content: "\\ec39";
}

.bx-tachometer:before {
  content: "\\ec3a";
}

.bx-tag:before {
  content: "\\ec3b";
}

.bx-tag-alt:before {
  content: "\\ec3c";
}

.bx-target-lock:before {
  content: "\\ec3d";
}

.bx-task:before {
  content: "\\ec3e";
}

.bx-task-x:before {
  content: "\\ec3f";
}

.bx-taxi:before {
  content: "\\ec40";
}

.bx-tennis-ball:before {
  content: "\\ec41";
}

.bx-terminal:before {
  content: "\\ec42";
}

.bx-test-tube:before {
  content: "\\ec43";
}

.bx-text:before {
  content: "\\ec44";
}

.bx-time:before {
  content: "\\ec45";
}

.bx-time-five:before {
  content: "\\ec46";
}

.bx-timer:before {
  content: "\\ec47";
}

.bx-tired:before {
  content: "\\ec48";
}

.bx-toggle-left:before {
  content: "\\ec49";
}

.bx-toggle-right:before {
  content: "\\ec4a";
}

.bx-tone:before {
  content: "\\ec4b";
}

.bx-traffic-cone:before {
  content: "\\ec4c";
}

.bx-train:before {
  content: "\\ec4d";
}

.bx-transfer:before {
  content: "\\ec4e";
}

.bx-transfer-alt:before {
  content: "\\ec4f";
}

.bx-trash:before {
  content: "\\ec50";
}

.bx-trash-alt:before {
  content: "\\ec51";
}

.bx-trending-down:before {
  content: "\\ec52";
}

.bx-trending-up:before {
  content: "\\ec53";
}

.bx-trim:before {
  content: "\\ec54";
}

.bx-trip:before {
  content: "\\ec55";
}

.bx-trophy:before {
  content: "\\ec56";
}

.bx-tv:before {
  content: "\\ec57";
}

.bx-underline:before {
  content: "\\ec58";
}

.bx-undo:before {
  content: "\\ec59";
}

.bx-unite:before {
  content: "\\ec5a";
}

.bx-unlink:before {
  content: "\\ec5b";
}

.bx-up-arrow:before {
  content: "\\ec5c";
}

.bx-up-arrow-alt:before {
  content: "\\ec5d";
}

.bx-up-arrow-circle:before {
  content: "\\ec5e";
}

.bx-upload:before {
  content: "\\ec5f";
}

.bx-upside-down:before {
  content: "\\ec60";
}

.bx-upvote:before {
  content: "\\ec61";
}

.bx-usb:before {
  content: "\\ec62";
}

.bx-user:before {
  content: "\\ec63";
}

.bx-user-check:before {
  content: "\\ec64";
}

.bx-user-circle:before {
  content: "\\ec65";
}

.bx-user-minus:before {
  content: "\\ec66";
}

.bx-user-pin:before {
  content: "\\ec67";
}

.bx-user-plus:before {
  content: "\\ec68";
}

.bx-user-voice:before {
  content: "\\ec69";
}

.bx-user-x:before {
  content: "\\ec6a";
}

.bx-vector:before {
  content: "\\ec6b";
}

.bx-vertical-center:before {
  content: "\\ec6c";
}

.bx-vial:before {
  content: "\\ec6d";
}

.bx-video:before {
  content: "\\ec6e";
}

.bx-video-off:before {
  content: "\\ec6f";
}

.bx-video-plus:before {
  content: "\\ec70";
}

.bx-video-recording:before {
  content: "\\ec71";
}

.bx-voicemail:before {
  content: "\\ec72";
}

.bx-volume:before {
  content: "\\ec73";
}

.bx-volume-full:before {
  content: "\\ec74";
}

.bx-volume-low:before {
  content: "\\ec75";
}

.bx-volume-mute:before {
  content: "\\ec76";
}

.bx-walk:before {
  content: "\\ec77";
}

.bx-wallet:before {
  content: "\\ec78";
}

.bx-wallet-alt:before {
  content: "\\ec79";
}

.bx-water:before {
  content: "\\ec7a";
}

.bx-webcam:before {
  content: "\\ec7b";
}

.bx-wifi:before {
  content: "\\ec7c";
}

.bx-wifi-0:before {
  content: "\\ec7d";
}

.bx-wifi-1:before {
  content: "\\ec7e";
}

.bx-wifi-2:before {
  content: "\\ec7f";
}

.bx-wifi-off:before {
  content: "\\ec80";
}

.bx-wind:before {
  content: "\\ec81";
}

.bx-window:before {
  content: "\\ec82";
}

.bx-window-alt:before {
  content: "\\ec83";
}

.bx-window-close:before {
  content: "\\ec84";
}

.bx-window-open:before {
  content: "\\ec85";
}

.bx-windows:before {
  content: "\\ec86";
}

.bx-wine:before {
  content: "\\ec87";
}

.bx-wink-smile:before {
  content: "\\ec88";
}

.bx-wink-tongue:before {
  content: "\\ec89";
}

.bx-won:before {
  content: "\\ec8a";
}

.bx-world:before {
  content: "\\ec8b";
}

.bx-wrench:before {
  content: "\\ec8c";
}

.bx-x:before {
  content: "\\ec8d";
}

.bx-x-circle:before {
  content: "\\ec8e";
}

.bx-yen:before {
  content: "\\ec8f";
}

.bx-zoom-in:before {
  content: "\\ec90";
}

.bx-zoom-out:before {
  content: "\\ec91";
}

.bxs-party:before {
  content: "\\ec92";
}

.bxs-hot:before {
  content: "\\ec93";
}

.bxs-droplet:before {
  content: "\\ec94";
}

.bxs-cat:before {
  content: "\\ec95";
}

.bxs-dog:before {
  content: "\\ec96";
}

.bxs-injection:before {
  content: "\\ec97";
}

.bxs-leaf:before {
  content: "\\ec98";
}

.bxs-add-to-queue:before {
  content: "\\ec99";
}

.bxs-adjust:before {
  content: "\\ec9a";
}

.bxs-adjust-alt:before {
  content: "\\ec9b";
}

.bxs-alarm:before {
  content: "\\ec9c";
}

.bxs-alarm-add:before {
  content: "\\ec9d";
}

.bxs-alarm-exclamation:before {
  content: "\\ec9e";
}

.bxs-alarm-off:before {
  content: "\\ec9f";
}

.bxs-alarm-snooze:before {
  content: "\\eca0";
}

.bxs-album:before {
  content: "\\eca1";
}

.bxs-ambulance:before {
  content: "\\eca2";
}

.bxs-analyse:before {
  content: "\\eca3";
}

.bxs-angry:before {
  content: "\\eca4";
}

.bxs-arch:before {
  content: "\\eca5";
}

.bxs-archive:before {
  content: "\\eca6";
}

.bxs-archive-in:before {
  content: "\\eca7";
}

.bxs-archive-out:before {
  content: "\\eca8";
}

.bxs-area:before {
  content: "\\eca9";
}

.bxs-arrow-from-bottom:before {
  content: "\\ecaa";
}

.bxs-arrow-from-left:before {
  content: "\\ecab";
}

.bxs-arrow-from-right:before {
  content: "\\ecac";
}

.bxs-arrow-from-top:before {
  content: "\\ecad";
}

.bxs-arrow-to-bottom:before {
  content: "\\ecae";
}

.bxs-arrow-to-left:before {
  content: "\\ecaf";
}

.bxs-arrow-to-right:before {
  content: "\\ecb0";
}

.bxs-arrow-to-top:before {
  content: "\\ecb1";
}

.bxs-award:before {
  content: "\\ecb2";
}

.bxs-baby-carriage:before {
  content: "\\ecb3";
}

.bxs-backpack:before {
  content: "\\ecb4";
}

.bxs-badge:before {
  content: "\\ecb5";
}

.bxs-badge-check:before {
  content: "\\ecb6";
}

.bxs-badge-dollar:before {
  content: "\\ecb7";
}

.bxs-ball:before {
  content: "\\ecb8";
}

.bxs-band-aid:before {
  content: "\\ecb9";
}

.bxs-bank:before {
  content: "\\ecba";
}

.bxs-bar-chart-alt-2:before {
  content: "\\ecbb";
}

.bxs-bar-chart-square:before {
  content: "\\ecbc";
}

.bxs-barcode:before {
  content: "\\ecbd";
}

.bxs-baseball:before {
  content: "\\ecbe";
}

.bxs-basket:before {
  content: "\\ecbf";
}

.bxs-basketball:before {
  content: "\\ecc0";
}

.bxs-bath:before {
  content: "\\ecc1";
}

.bxs-battery:before {
  content: "\\ecc2";
}

.bxs-battery-charging:before {
  content: "\\ecc3";
}

.bxs-battery-full:before {
  content: "\\ecc4";
}

.bxs-battery-low:before {
  content: "\\ecc5";
}

.bxs-bed:before {
  content: "\\ecc6";
}

.bxs-been-here:before {
  content: "\\ecc7";
}

.bxs-beer:before {
  content: "\\ecc8";
}

.bxs-bell:before {
  content: "\\ecc9";
}

.bxs-bell-minus:before {
  content: "\\ecca";
}

.bxs-bell-off:before {
  content: "\\eccb";
}

.bxs-bell-plus:before {
  content: "\\eccc";
}

.bxs-bell-ring:before {
  content: "\\eccd";
}

.bxs-bible:before {
  content: "\\ecce";
}

.bxs-binoculars:before {
  content: "\\eccf";
}

.bxs-blanket:before {
  content: "\\ecd0";
}

.bxs-bolt:before {
  content: "\\ecd1";
}

.bxs-bolt-circle:before {
  content: "\\ecd2";
}

.bxs-bomb:before {
  content: "\\ecd3";
}

.bxs-bone:before {
  content: "\\ecd4";
}

.bxs-bong:before {
  content: "\\ecd5";
}

.bxs-book:before {
  content: "\\ecd6";
}

.bxs-book-add:before {
  content: "\\ecd7";
}

.bxs-book-alt:before {
  content: "\\ecd8";
}

.bxs-book-bookmark:before {
  content: "\\ecd9";
}

.bxs-book-content:before {
  content: "\\ecda";
}

.bxs-book-heart:before {
  content: "\\ecdb";
}

.bxs-bookmark:before {
  content: "\\ecdc";
}

.bxs-bookmark-alt:before {
  content: "\\ecdd";
}

.bxs-bookmark-alt-minus:before {
  content: "\\ecde";
}

.bxs-bookmark-alt-plus:before {
  content: "\\ecdf";
}

.bxs-bookmark-heart:before {
  content: "\\ece0";
}

.bxs-bookmark-minus:before {
  content: "\\ece1";
}

.bxs-bookmark-plus:before {
  content: "\\ece2";
}

.bxs-bookmarks:before {
  content: "\\ece3";
}

.bxs-bookmark-star:before {
  content: "\\ece4";
}

.bxs-book-open:before {
  content: "\\ece5";
}

.bxs-book-reader:before {
  content: "\\ece6";
}

.bxs-bot:before {
  content: "\\ece7";
}

.bxs-bowling-ball:before {
  content: "\\ece8";
}

.bxs-box:before {
  content: "\\ece9";
}

.bxs-brain:before {
  content: "\\ecea";
}

.bxs-briefcase:before {
  content: "\\eceb";
}

.bxs-briefcase-alt:before {
  content: "\\ecec";
}

.bxs-briefcase-alt-2:before {
  content: "\\eced";
}

.bxs-brightness:before {
  content: "\\ecee";
}

.bxs-brightness-half:before {
  content: "\\ecef";
}

.bxs-brush:before {
  content: "\\ecf0";
}

.bxs-brush-alt:before {
  content: "\\ecf1";
}

.bxs-bug:before {
  content: "\\ecf2";
}

.bxs-bug-alt:before {
  content: "\\ecf3";
}

.bxs-building:before {
  content: "\\ecf4";
}

.bxs-building-house:before {
  content: "\\ecf5";
}

.bxs-buildings:before {
  content: "\\ecf6";
}

.bxs-bulb:before {
  content: "\\ecf7";
}

.bxs-bullseye:before {
  content: "\\ecf8";
}

.bxs-buoy:before {
  content: "\\ecf9";
}

.bxs-bus:before {
  content: "\\ecfa";
}

.bxs-business:before {
  content: "\\ecfb";
}

.bxs-bus-school:before {
  content: "\\ecfc";
}

.bxs-cabinet:before {
  content: "\\ecfd";
}

.bxs-cake:before {
  content: "\\ecfe";
}

.bxs-calculator:before {
  content: "\\ecff";
}

.bxs-calendar:before {
  content: "\\ed00";
}

.bxs-calendar-alt:before {
  content: "\\ed01";
}

.bxs-calendar-check:before {
  content: "\\ed02";
}

.bxs-calendar-edit:before {
  content: "\\ed03";
}

.bxs-calendar-event:before {
  content: "\\ed04";
}

.bxs-calendar-exclamation:before {
  content: "\\ed05";
}

.bxs-calendar-heart:before {
  content: "\\ed06";
}

.bxs-calendar-minus:before {
  content: "\\ed07";
}

.bxs-calendar-plus:before {
  content: "\\ed08";
}

.bxs-calendar-star:before {
  content: "\\ed09";
}

.bxs-calendar-week:before {
  content: "\\ed0a";
}

.bxs-calendar-x:before {
  content: "\\ed0b";
}

.bxs-camera:before {
  content: "\\ed0c";
}

.bxs-camera-home:before {
  content: "\\ed0d";
}

.bxs-camera-movie:before {
  content: "\\ed0e";
}

.bxs-camera-off:before {
  content: "\\ed0f";
}

.bxs-camera-plus:before {
  content: "\\ed10";
}

.bxs-capsule:before {
  content: "\\ed11";
}

.bxs-captions:before {
  content: "\\ed12";
}

.bxs-car:before {
  content: "\\ed13";
}

.bxs-car-battery:before {
  content: "\\ed14";
}

.bxs-car-crash:before {
  content: "\\ed15";
}

.bxs-card:before {
  content: "\\ed16";
}

.bxs-caret-down-circle:before {
  content: "\\ed17";
}

.bxs-caret-down-square:before {
  content: "\\ed18";
}

.bxs-caret-left-circle:before {
  content: "\\ed19";
}

.bxs-caret-left-square:before {
  content: "\\ed1a";
}

.bxs-caret-right-circle:before {
  content: "\\ed1b";
}

.bxs-caret-right-square:before {
  content: "\\ed1c";
}

.bxs-caret-up-circle:before {
  content: "\\ed1d";
}

.bxs-caret-up-square:before {
  content: "\\ed1e";
}

.bxs-car-garage:before {
  content: "\\ed1f";
}

.bxs-car-mechanic:before {
  content: "\\ed20";
}

.bxs-carousel:before {
  content: "\\ed21";
}

.bxs-cart:before {
  content: "\\ed22";
}

.bxs-cart-add:before {
  content: "\\ed23";
}

.bxs-cart-alt:before {
  content: "\\ed24";
}

.bxs-cart-download:before {
  content: "\\ed25";
}

.bxs-car-wash:before {
  content: "\\ed26";
}

.bxs-category:before {
  content: "\\ed27";
}

.bxs-category-alt:before {
  content: "\\ed28";
}

.bxs-cctv:before {
  content: "\\ed29";
}

.bxs-certification:before {
  content: "\\ed2a";
}

.bxs-chalkboard:before {
  content: "\\ed2b";
}

.bxs-chart:before {
  content: "\\ed2c";
}

.bxs-chat:before {
  content: "\\ed2d";
}

.bxs-checkbox:before {
  content: "\\ed2e";
}

.bxs-checkbox-checked:before {
  content: "\\ed2f";
}

.bxs-checkbox-minus:before {
  content: "\\ed30";
}

.bxs-check-circle:before {
  content: "\\ed31";
}

.bxs-check-shield:before {
  content: "\\ed32";
}

.bxs-check-square:before {
  content: "\\ed33";
}

.bxs-chess:before {
  content: "\\ed34";
}

.bxs-chevron-down:before {
  content: "\\ed35";
}

.bxs-chevron-down-circle:before {
  content: "\\ed36";
}

.bxs-chevron-down-square:before {
  content: "\\ed37";
}

.bxs-chevron-left:before {
  content: "\\ed38";
}

.bxs-chevron-left-circle:before {
  content: "\\ed39";
}

.bxs-chevron-left-square:before {
  content: "\\ed3a";
}

.bxs-chevron-right:before {
  content: "\\ed3b";
}

.bxs-chevron-right-circle:before {
  content: "\\ed3c";
}

.bxs-chevron-right-square:before {
  content: "\\ed3d";
}

.bxs-chevrons-down:before {
  content: "\\ed3e";
}

.bxs-chevrons-left:before {
  content: "\\ed3f";
}

.bxs-chevrons-right:before {
  content: "\\ed40";
}

.bxs-chevrons-up:before {
  content: "\\ed41";
}

.bxs-chevron-up:before {
  content: "\\ed42";
}

.bxs-chevron-up-circle:before {
  content: "\\ed43";
}

.bxs-chevron-up-square:before {
  content: "\\ed44";
}

.bxs-chip:before {
  content: "\\ed45";
}

.bxs-church:before {
  content: "\\ed46";
}

.bxs-circle:before {
  content: "\\ed47";
}

.bxs-city:before {
  content: "\\ed48";
}

.bxs-clinic:before {
  content: "\\ed49";
}

.bxs-cloud:before {
  content: "\\ed4a";
}

.bxs-cloud-download:before {
  content: "\\ed4b";
}

.bxs-cloud-lightning:before {
  content: "\\ed4c";
}

.bxs-cloud-rain:before {
  content: "\\ed4d";
}

.bxs-cloud-upload:before {
  content: "\\ed4e";
}

.bxs-coffee:before {
  content: "\\ed4f";
}

.bxs-coffee-alt:before {
  content: "\\ed50";
}

.bxs-coffee-togo:before {
  content: "\\ed51";
}

.bxs-cog:before {
  content: "\\ed52";
}

.bxs-coin:before {
  content: "\\ed53";
}

.bxs-coin-stack:before {
  content: "\\ed54";
}

.bxs-collection:before {
  content: "\\ed55";
}

.bxs-color-fill:before {
  content: "\\ed56";
}

.bxs-comment:before {
  content: "\\ed57";
}

.bxs-comment-add:before {
  content: "\\ed58";
}

.bxs-comment-check:before {
  content: "\\ed59";
}

.bxs-comment-detail:before {
  content: "\\ed5a";
}

.bxs-comment-dots:before {
  content: "\\ed5b";
}

.bxs-comment-edit:before {
  content: "\\ed5c";
}

.bxs-comment-error:before {
  content: "\\ed5d";
}

.bxs-comment-minus:before {
  content: "\\ed5e";
}

.bxs-comment-x:before {
  content: "\\ed5f";
}

.bxs-compass:before {
  content: "\\ed60";
}

.bxs-component:before {
  content: "\\ed61";
}

.bxs-confused:before {
  content: "\\ed62";
}

.bxs-contact:before {
  content: "\\ed63";
}

.bxs-conversation:before {
  content: "\\ed64";
}

.bxs-cookie:before {
  content: "\\ed65";
}

.bxs-cool:before {
  content: "\\ed66";
}

.bxs-copy:before {
  content: "\\ed67";
}

.bxs-copy-alt:before {
  content: "\\ed68";
}

.bxs-copyright:before {
  content: "\\ed69";
}

.bxs-coupon:before {
  content: "\\ed6a";
}

.bxs-credit-card:before {
  content: "\\ed6b";
}

.bxs-credit-card-alt:before {
  content: "\\ed6c";
}

.bxs-credit-card-front:before {
  content: "\\ed6d";
}

.bxs-crop:before {
  content: "\\ed6e";
}

.bxs-crown:before {
  content: "\\ed6f";
}

.bxs-cube:before {
  content: "\\ed70";
}

.bxs-cube-alt:before {
  content: "\\ed71";
}

.bxs-cuboid:before {
  content: "\\ed72";
}

.bxs-customize:before {
  content: "\\ed73";
}

.bxs-cylinder:before {
  content: "\\ed74";
}

.bxs-dashboard:before {
  content: "\\ed75";
}

.bxs-data:before {
  content: "\\ed76";
}

.bxs-detail:before {
  content: "\\ed77";
}

.bxs-devices:before {
  content: "\\ed78";
}

.bxs-diamond:before {
  content: "\\ed79";
}

.bxs-dice-1:before {
  content: "\\ed7a";
}

.bxs-dice-2:before {
  content: "\\ed7b";
}

.bxs-dice-3:before {
  content: "\\ed7c";
}

.bxs-dice-4:before {
  content: "\\ed7d";
}

.bxs-dice-5:before {
  content: "\\ed7e";
}

.bxs-dice-6:before {
  content: "\\ed7f";
}

.bxs-direction-left:before {
  content: "\\ed80";
}

.bxs-direction-right:before {
  content: "\\ed81";
}

.bxs-directions:before {
  content: "\\ed82";
}

.bxs-disc:before {
  content: "\\ed83";
}

.bxs-discount:before {
  content: "\\ed84";
}

.bxs-dish:before {
  content: "\\ed85";
}

.bxs-dislike:before {
  content: "\\ed86";
}

.bxs-dizzy:before {
  content: "\\ed87";
}

.bxs-dock-bottom:before {
  content: "\\ed88";
}

.bxs-dock-left:before {
  content: "\\ed89";
}

.bxs-dock-right:before {
  content: "\\ed8a";
}

.bxs-dock-top:before {
  content: "\\ed8b";
}

.bxs-dollar-circle:before {
  content: "\\ed8c";
}

.bxs-donate-blood:before {
  content: "\\ed8d";
}

.bxs-donate-heart:before {
  content: "\\ed8e";
}

.bxs-door-open:before {
  content: "\\ed8f";
}

.bxs-doughnut-chart:before {
  content: "\\ed90";
}

.bxs-down-arrow:before {
  content: "\\ed91";
}

.bxs-down-arrow-alt:before {
  content: "\\ed92";
}

.bxs-down-arrow-circle:before {
  content: "\\ed93";
}

.bxs-down-arrow-square:before {
  content: "\\ed94";
}

.bxs-download:before {
  content: "\\ed95";
}

.bxs-downvote:before {
  content: "\\ed96";
}

.bxs-drink:before {
  content: "\\ed97";
}

.bxs-droplet-half:before {
  content: "\\ed98";
}

.bxs-dryer:before {
  content: "\\ed99";
}

.bxs-duplicate:before {
  content: "\\ed9a";
}

.bxs-edit:before {
  content: "\\ed9b";
}

.bxs-edit-alt:before {
  content: "\\ed9c";
}

.bxs-edit-location:before {
  content: "\\ed9d";
}

.bxs-eject:before {
  content: "\\ed9e";
}

.bxs-envelope:before {
  content: "\\ed9f";
}

.bxs-envelope-open:before {
  content: "\\eda0";
}

.bxs-eraser:before {
  content: "\\eda1";
}

.bxs-error:before {
  content: "\\eda2";
}

.bxs-error-alt:before {
  content: "\\eda3";
}

.bxs-error-circle:before {
  content: "\\eda4";
}

.bxs-ev-station:before {
  content: "\\eda5";
}

.bxs-exit:before {
  content: "\\eda6";
}

.bxs-extension:before {
  content: "\\eda7";
}

.bxs-eyedropper:before {
  content: "\\eda8";
}

.bxs-face:before {
  content: "\\eda9";
}

.bxs-face-mask:before {
  content: "\\edaa";
}

.bxs-factory:before {
  content: "\\edab";
}

.bxs-fast-forward-circle:before {
  content: "\\edac";
}

.bxs-file:before {
  content: "\\edad";
}

.bxs-file-archive:before {
  content: "\\edae";
}

.bxs-file-blank:before {
  content: "\\edaf";
}

.bxs-file-css:before {
  content: "\\edb0";
}

.bxs-file-doc:before {
  content: "\\edb1";
}

.bxs-file-export:before {
  content: "\\edb2";
}

.bxs-file-find:before {
  content: "\\edb3";
}

.bxs-file-gif:before {
  content: "\\edb4";
}

.bxs-file-html:before {
  content: "\\edb5";
}

.bxs-file-image:before {
  content: "\\edb6";
}

.bxs-file-import:before {
  content: "\\edb7";
}

.bxs-file-jpg:before {
  content: "\\edb8";
}

.bxs-file-js:before {
  content: "\\edb9";
}

.bxs-file-json:before {
  content: "\\edba";
}

.bxs-file-md:before {
  content: "\\edbb";
}

.bxs-file-pdf:before {
  content: "\\edbc";
}

.bxs-file-plus:before {
  content: "\\edbd";
}

.bxs-file-png:before {
  content: "\\edbe";
}

.bxs-file-txt:before {
  content: "\\edbf";
}

.bxs-film:before {
  content: "\\edc0";
}

.bxs-filter-alt:before {
  content: "\\edc1";
}

.bxs-first-aid:before {
  content: "\\edc2";
}

.bxs-flag:before {
  content: "\\edc3";
}

.bxs-flag-alt:before {
  content: "\\edc4";
}

.bxs-flag-checkered:before {
  content: "\\edc5";
}

.bxs-flame:before {
  content: "\\edc6";
}

.bxs-flask:before {
  content: "\\edc7";
}

.bxs-florist:before {
  content: "\\edc8";
}

.bxs-folder:before {
  content: "\\edc9";
}

.bxs-folder-minus:before {
  content: "\\edca";
}

.bxs-folder-open:before {
  content: "\\edcb";
}

.bxs-folder-plus:before {
  content: "\\edcc";
}

.bxs-food-menu:before {
  content: "\\edcd";
}

.bxs-fridge:before {
  content: "\\edce";
}

.bxs-game:before {
  content: "\\edcf";
}

.bxs-gas-pump:before {
  content: "\\edd0";
}

.bxs-ghost:before {
  content: "\\edd1";
}

.bxs-gift:before {
  content: "\\edd2";
}

.bxs-graduation:before {
  content: "\\edd3";
}

.bxs-grid:before {
  content: "\\edd4";
}

.bxs-grid-alt:before {
  content: "\\edd5";
}

.bxs-group:before {
  content: "\\edd6";
}

.bxs-guitar-amp:before {
  content: "\\edd7";
}

.bxs-hand:before {
  content: "\\edd8";
}

.bxs-hand-down:before {
  content: "\\edd9";
}

.bxs-hand-left:before {
  content: "\\edda";
}

.bxs-hand-right:before {
  content: "\\eddb";
}

.bxs-hand-up:before {
  content: "\\eddc";
}

.bxs-happy:before {
  content: "\\eddd";
}

.bxs-happy-alt:before {
  content: "\\edde";
}

.bxs-happy-beaming:before {
  content: "\\eddf";
}

.bxs-happy-heart-eyes:before {
  content: "\\ede0";
}

.bxs-hdd:before {
  content: "\\ede1";
}

.bxs-heart:before {
  content: "\\ede2";
}

.bxs-heart-circle:before {
  content: "\\ede3";
}

.bxs-heart-square:before {
  content: "\\ede4";
}

.bxs-help-circle:before {
  content: "\\ede5";
}

.bxs-hide:before {
  content: "\\ede6";
}

.bxs-home:before {
  content: "\\ede7";
}

.bxs-home-circle:before {
  content: "\\ede8";
}

.bxs-home-heart:before {
  content: "\\ede9";
}

.bxs-home-smile:before {
  content: "\\edea";
}

.bxs-hotel:before {
  content: "\\edeb";
}

.bxs-hourglass:before {
  content: "\\edec";
}

.bxs-hourglass-bottom:before {
  content: "\\eded";
}

.bxs-hourglass-top:before {
  content: "\\edee";
}

.bxs-id-card:before {
  content: "\\edef";
}

.bxs-image:before {
  content: "\\edf0";
}

.bxs-image-add:before {
  content: "\\edf1";
}

.bxs-image-alt:before {
  content: "\\edf2";
}

.bxs-inbox:before {
  content: "\\edf3";
}

.bxs-info-circle:before {
  content: "\\edf4";
}

.bxs-info-square:before {
  content: "\\edf5";
}

.bxs-institution:before {
  content: "\\edf6";
}

.bxs-joystick:before {
  content: "\\edf7";
}

.bxs-joystick-alt:before {
  content: "\\edf8";
}

.bxs-joystick-button:before {
  content: "\\edf9";
}

.bxs-key:before {
  content: "\\edfa";
}

.bxs-keyboard:before {
  content: "\\edfb";
}

.bxs-label:before {
  content: "\\edfc";
}

.bxs-landmark:before {
  content: "\\edfd";
}

.bxs-landscape:before {
  content: "\\edfe";
}

.bxs-laugh:before {
  content: "\\edff";
}

.bxs-layer:before {
  content: "\\ee00";
}

.bxs-layer-minus:before {
  content: "\\ee01";
}

.bxs-layer-plus:before {
  content: "\\ee02";
}

.bxs-layout:before {
  content: "\\ee03";
}

.bxs-left-arrow:before {
  content: "\\ee04";
}

.bxs-left-arrow-alt:before {
  content: "\\ee05";
}

.bxs-left-arrow-circle:before {
  content: "\\ee06";
}

.bxs-left-arrow-square:before {
  content: "\\ee07";
}

.bxs-left-down-arrow-circle:before {
  content: "\\ee08";
}

.bxs-left-top-arrow-circle:before {
  content: "\\ee09";
}

.bxs-like:before {
  content: "\\ee0a";
}

.bxs-location-plus:before {
  content: "\\ee0b";
}

.bxs-lock:before {
  content: "\\ee0c";
}

.bxs-lock-alt:before {
  content: "\\ee0d";
}

.bxs-lock-open:before {
  content: "\\ee0e";
}

.bxs-lock-open-alt:before {
  content: "\\ee0f";
}

.bxs-log-in:before {
  content: "\\ee10";
}

.bxs-log-in-circle:before {
  content: "\\ee11";
}

.bxs-log-out:before {
  content: "\\ee12";
}

.bxs-log-out-circle:before {
  content: "\\ee13";
}

.bxs-low-vision:before {
  content: "\\ee14";
}

.bxs-magic-wand:before {
  content: "\\ee15";
}

.bxs-magnet:before {
  content: "\\ee16";
}

.bxs-map:before {
  content: "\\ee17";
}

.bxs-map-alt:before {
  content: "\\ee18";
}

.bxs-map-pin:before {
  content: "\\ee19";
}

.bxs-mask:before {
  content: "\\ee1a";
}

.bxs-medal:before {
  content: "\\ee1b";
}

.bxs-megaphone:before {
  content: "\\ee1c";
}

.bxs-meh:before {
  content: "\\ee1d";
}

.bxs-meh-alt:before {
  content: "\\ee1e";
}

.bxs-meh-blank:before {
  content: "\\ee1f";
}

.bxs-memory-card:before {
  content: "\\ee20";
}

.bxs-message:before {
  content: "\\ee21";
}

.bxs-message-add:before {
  content: "\\ee22";
}

.bxs-message-alt:before {
  content: "\\ee23";
}

.bxs-message-alt-add:before {
  content: "\\ee24";
}

.bxs-message-alt-check:before {
  content: "\\ee25";
}

.bxs-message-alt-detail:before {
  content: "\\ee26";
}

.bxs-message-alt-dots:before {
  content: "\\ee27";
}

.bxs-message-alt-edit:before {
  content: "\\ee28";
}

.bxs-message-alt-error:before {
  content: "\\ee29";
}

.bxs-message-alt-minus:before {
  content: "\\ee2a";
}

.bxs-message-alt-x:before {
  content: "\\ee2b";
}

.bxs-message-check:before {
  content: "\\ee2c";
}

.bxs-message-detail:before {
  content: "\\ee2d";
}

.bxs-message-dots:before {
  content: "\\ee2e";
}

.bxs-message-edit:before {
  content: "\\ee2f";
}

.bxs-message-error:before {
  content: "\\ee30";
}

.bxs-message-minus:before {
  content: "\\ee31";
}

.bxs-message-rounded:before {
  content: "\\ee32";
}

.bxs-message-rounded-add:before {
  content: "\\ee33";
}

.bxs-message-rounded-check:before {
  content: "\\ee34";
}

.bxs-message-rounded-detail:before {
  content: "\\ee35";
}

.bxs-message-rounded-dots:before {
  content: "\\ee36";
}

.bxs-message-rounded-edit:before {
  content: "\\ee37";
}

.bxs-message-rounded-error:before {
  content: "\\ee38";
}

.bxs-message-rounded-minus:before {
  content: "\\ee39";
}

.bxs-message-rounded-x:before {
  content: "\\ee3a";
}

.bxs-message-square:before {
  content: "\\ee3b";
}

.bxs-message-square-add:before {
  content: "\\ee3c";
}

.bxs-message-square-check:before {
  content: "\\ee3d";
}

.bxs-message-square-detail:before {
  content: "\\ee3e";
}

.bxs-message-square-dots:before {
  content: "\\ee3f";
}

.bxs-message-square-edit:before {
  content: "\\ee40";
}

.bxs-message-square-error:before {
  content: "\\ee41";
}

.bxs-message-square-minus:before {
  content: "\\ee42";
}

.bxs-message-square-x:before {
  content: "\\ee43";
}

.bxs-message-x:before {
  content: "\\ee44";
}

.bxs-meteor:before {
  content: "\\ee45";
}

.bxs-microchip:before {
  content: "\\ee46";
}

.bxs-microphone:before {
  content: "\\ee47";
}

.bxs-microphone-alt:before {
  content: "\\ee48";
}

.bxs-microphone-off:before {
  content: "\\ee49";
}

.bxs-minus-circle:before {
  content: "\\ee4a";
}

.bxs-minus-square:before {
  content: "\\ee4b";
}

.bxs-mobile:before {
  content: "\\ee4c";
}

.bxs-mobile-vibration:before {
  content: "\\ee4d";
}

.bxs-moon:before {
  content: "\\ee4e";
}

.bxs-mouse:before {
  content: "\\ee4f";
}

.bxs-mouse-alt:before {
  content: "\\ee50";
}

.bxs-movie:before {
  content: "\\ee51";
}

.bxs-movie-play:before {
  content: "\\ee52";
}

.bxs-music:before {
  content: "\\ee53";
}

.bxs-navigation:before {
  content: "\\ee54";
}

.bxs-network-chart:before {
  content: "\\ee55";
}

.bxs-news:before {
  content: "\\ee56";
}

.bxs-no-entry:before {
  content: "\\ee57";
}

.bxs-note:before {
  content: "\\ee58";
}

.bxs-notepad:before {
  content: "\\ee59";
}

.bxs-notification:before {
  content: "\\ee5a";
}

.bxs-notification-off:before {
  content: "\\ee5b";
}

.bxs-offer:before {
  content: "\\ee5c";
}

.bxs-package:before {
  content: "\\ee5d";
}

.bxs-paint:before {
  content: "\\ee5e";
}

.bxs-paint-roll:before {
  content: "\\ee5f";
}

.bxs-palette:before {
  content: "\\ee60";
}

.bxs-paper-plane:before {
  content: "\\ee61";
}

.bxs-parking:before {
  content: "\\ee62";
}

.bxs-paste:before {
  content: "\\ee63";
}

.bxs-pen:before {
  content: "\\ee64";
}

.bxs-pencil:before {
  content: "\\ee65";
}

.bxs-phone:before {
  content: "\\ee66";
}

.bxs-phone-call:before {
  content: "\\ee67";
}

.bxs-phone-incoming:before {
  content: "\\ee68";
}

.bxs-phone-off:before {
  content: "\\ee69";
}

.bxs-phone-outgoing:before {
  content: "\\ee6a";
}

.bxs-photo-album:before {
  content: "\\ee6b";
}

.bxs-piano:before {
  content: "\\ee6c";
}

.bxs-pie-chart:before {
  content: "\\ee6d";
}

.bxs-pie-chart-alt:before {
  content: "\\ee6e";
}

.bxs-pie-chart-alt-2:before {
  content: "\\ee6f";
}

.bxs-pin:before {
  content: "\\ee70";
}

.bxs-pizza:before {
  content: "\\ee71";
}

.bxs-plane:before {
  content: "\\ee72";
}

.bxs-plane-alt:before {
  content: "\\ee73";
}

.bxs-plane-land:before {
  content: "\\ee74";
}

.bxs-planet:before {
  content: "\\ee75";
}

.bxs-plane-take-off:before {
  content: "\\ee76";
}

.bxs-playlist:before {
  content: "\\ee77";
}

.bxs-plug:before {
  content: "\\ee78";
}

.bxs-plus-circle:before {
  content: "\\ee79";
}

.bxs-plus-square:before {
  content: "\\ee7a";
}

.bxs-pointer:before {
  content: "\\ee7b";
}

.bxs-polygon:before {
  content: "\\ee7c";
}

.bxs-printer:before {
  content: "\\ee7d";
}

.bxs-purchase-tag:before {
  content: "\\ee7e";
}

.bxs-purchase-tag-alt:before {
  content: "\\ee7f";
}

.bxs-pyramid:before {
  content: "\\ee80";
}

.bxs-quote-alt-left:before {
  content: "\\ee81";
}

.bxs-quote-alt-right:before {
  content: "\\ee82";
}

.bxs-quote-left:before {
  content: "\\ee83";
}

.bxs-quote-right:before {
  content: "\\ee84";
}

.bxs-quote-single-left:before {
  content: "\\ee85";
}

.bxs-quote-single-right:before {
  content: "\\ee86";
}

.bxs-radiation:before {
  content: "\\ee87";
}

.bxs-radio:before {
  content: "\\ee88";
}

.bxs-receipt:before {
  content: "\\ee89";
}

.bxs-rectangle:before {
  content: "\\ee8a";
}

.bxs-registered:before {
  content: "\\ee8b";
}

.bxs-rename:before {
  content: "\\ee8c";
}

.bxs-report:before {
  content: "\\ee8d";
}

.bxs-rewind-circle:before {
  content: "\\ee8e";
}

.bxs-right-arrow:before {
  content: "\\ee8f";
}

.bxs-right-arrow-alt:before {
  content: "\\ee90";
}

.bxs-right-arrow-circle:before {
  content: "\\ee91";
}

.bxs-right-arrow-square:before {
  content: "\\ee92";
}

.bxs-right-down-arrow-circle:before {
  content: "\\ee93";
}

.bxs-right-top-arrow-circle:before {
  content: "\\ee94";
}

.bxs-rocket:before {
  content: "\\ee95";
}

.bxs-ruler:before {
  content: "\\ee96";
}

.bxs-sad:before {
  content: "\\ee97";
}

.bxs-save:before {
  content: "\\ee98";
}

.bxs-school:before {
  content: "\\ee99";
}

.bxs-search:before {
  content: "\\ee9a";
}

.bxs-search-alt-2:before {
  content: "\\ee9b";
}

.bxs-select-multiple:before {
  content: "\\ee9c";
}

.bxs-send:before {
  content: "\\ee9d";
}

.bxs-server:before {
  content: "\\ee9e";
}

.bxs-shapes:before {
  content: "\\ee9f";
}

.bxs-share:before {
  content: "\\eea0";
}

.bxs-share-alt:before {
  content: "\\eea1";
}

.bxs-shield:before {
  content: "\\eea2";
}

.bxs-shield-alt-2:before {
  content: "\\eea3";
}

.bxs-shield-x:before {
  content: "\\eea4";
}

.bxs-ship:before {
  content: "\\eea5";
}

.bxs-shocked:before {
  content: "\\eea6";
}

.bxs-shopping-bag:before {
  content: "\\eea7";
}

.bxs-shopping-bag-alt:before {
  content: "\\eea8";
}

.bxs-shopping-bags:before {
  content: "\\eea9";
}

.bxs-show:before {
  content: "\\eeaa";
}

.bxs-skip-next-circle:before {
  content: "\\eeab";
}

.bxs-skip-previous-circle:before {
  content: "\\eeac";
}

.bxs-skull:before {
  content: "\\eead";
}

.bxs-sleepy:before {
  content: "\\eeae";
}

.bxs-slideshow:before {
  content: "\\eeaf";
}

.bxs-smile:before {
  content: "\\eeb0";
}

.bxs-sort-alt:before {
  content: "\\eeb1";
}

.bxs-spa:before {
  content: "\\eeb2";
}

.bxs-speaker:before {
  content: "\\eeb3";
}

.bxs-spray-can:before {
  content: "\\eeb4";
}

.bxs-spreadsheet:before {
  content: "\\eeb5";
}

.bxs-square:before {
  content: "\\eeb6";
}

.bxs-square-rounded:before {
  content: "\\eeb7";
}

.bxs-star:before {
  content: "\\eeb8";
}

.bxs-star-half:before {
  content: "\\eeb9";
}

.bxs-sticker:before {
  content: "\\eeba";
}

.bxs-stopwatch:before {
  content: "\\eebb";
}

.bxs-store:before {
  content: "\\eebc";
}

.bxs-store-alt:before {
  content: "\\eebd";
}

.bxs-sun:before {
  content: "\\eebe";
}

.bxs-tachometer:before {
  content: "\\eebf";
}

.bxs-tag:before {
  content: "\\eec0";
}

.bxs-tag-alt:before {
  content: "\\eec1";
}

.bxs-tag-x:before {
  content: "\\eec2";
}

.bxs-taxi:before {
  content: "\\eec3";
}

.bxs-tennis-ball:before {
  content: "\\eec4";
}

.bxs-terminal:before {
  content: "\\eec5";
}

.bxs-thermometer:before {
  content: "\\eec6";
}

.bxs-time:before {
  content: "\\eec7";
}

.bxs-time-five:before {
  content: "\\eec8";
}

.bxs-timer:before {
  content: "\\eec9";
}

.bxs-tired:before {
  content: "\\eeca";
}

.bxs-toggle-left:before {
  content: "\\eecb";
}

.bxs-toggle-right:before {
  content: "\\eecc";
}

.bxs-tone:before {
  content: "\\eecd";
}

.bxs-torch:before {
  content: "\\eece";
}

.bxs-to-top:before {
  content: "\\eecf";
}

.bxs-traffic:before {
  content: "\\eed0";
}

.bxs-traffic-barrier:before {
  content: "\\eed1";
}

.bxs-traffic-cone:before {
  content: "\\eed2";
}

.bxs-train:before {
  content: "\\eed3";
}

.bxs-trash:before {
  content: "\\eed4";
}

.bxs-trash-alt:before {
  content: "\\eed5";
}

.bxs-tree:before {
  content: "\\eed6";
}

.bxs-trophy:before {
  content: "\\eed7";
}

.bxs-truck:before {
  content: "\\eed8";
}

.bxs-t-shirt:before {
  content: "\\eed9";
}

.bxs-tv:before {
  content: "\\eeda";
}

.bxs-up-arrow:before {
  content: "\\eedb";
}

.bxs-up-arrow-alt:before {
  content: "\\eedc";
}

.bxs-up-arrow-circle:before {
  content: "\\eedd";
}

.bxs-up-arrow-square:before {
  content: "\\eede";
}

.bxs-upside-down:before {
  content: "\\eedf";
}

.bxs-upvote:before {
  content: "\\eee0";
}

.bxs-user:before {
  content: "\\eee1";
}

.bxs-user-account:before {
  content: "\\eee2";
}

.bxs-user-badge:before {
  content: "\\eee3";
}

.bxs-user-check:before {
  content: "\\eee4";
}

.bxs-user-circle:before {
  content: "\\eee5";
}

.bxs-user-detail:before {
  content: "\\eee6";
}

.bxs-user-minus:before {
  content: "\\eee7";
}

.bxs-user-pin:before {
  content: "\\eee8";
}

.bxs-user-plus:before {
  content: "\\eee9";
}

.bxs-user-rectangle:before {
  content: "\\eeea";
}

.bxs-user-voice:before {
  content: "\\eeeb";
}

.bxs-user-x:before {
  content: "\\eeec";
}

.bxs-vector:before {
  content: "\\eeed";
}

.bxs-vial:before {
  content: "\\eeee";
}

.bxs-video:before {
  content: "\\eeef";
}

.bxs-video-off:before {
  content: "\\eef0";
}

.bxs-video-plus:before {
  content: "\\eef1";
}

.bxs-video-recording:before {
  content: "\\eef2";
}

.bxs-videos:before {
  content: "\\eef3";
}

.bxs-virus:before {
  content: "\\eef4";
}

.bxs-virus-block:before {
  content: "\\eef5";
}

.bxs-volume:before {
  content: "\\eef6";
}

.bxs-volume-full:before {
  content: "\\eef7";
}

.bxs-volume-low:before {
  content: "\\eef8";
}

.bxs-volume-mute:before {
  content: "\\eef9";
}

.bxs-wallet:before {
  content: "\\eefa";
}

.bxs-wallet-alt:before {
  content: "\\eefb";
}

.bxs-washer:before {
  content: "\\eefc";
}

.bxs-watch:before {
  content: "\\eefd";
}

.bxs-watch-alt:before {
  content: "\\eefe";
}

.bxs-webcam:before {
  content: "\\eeff";
}

.bxs-widget:before {
  content: "\\ef00";
}

.bxs-window-alt:before {
  content: "\\ef01";
}

.bxs-wine:before {
  content: "\\ef02";
}

.bxs-wink-smile:before {
  content: "\\ef03";
}

.bxs-wink-tongue:before {
  content: "\\ef04";
}

.bxs-wrench:before {
  content: "\\ef05";
}

.bxs-x-circle:before {
  content: "\\ef06";
}

.bxs-x-square:before {
  content: "\\ef07";
}

.bxs-yin-yang:before {
  content: "\\ef08";
}

.bxs-zap:before {
  content: "\\ef09";
}

.bxs-zoom-in:before {
  content: "\\ef0a";
}

.bxs-zoom-out:before {
  content: "\\ef0b";
}

.la,
.las,
.lar,
.lal,
.lad,
.lab {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
}

.la-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.la-xs {
  font-size: 0.75em;
}

.la-sm {
  font-size: 0.875em;
}

.la-1x {
  font-size: 1em;
}

.la-2x {
  font-size: 2em;
}

.la-3x {
  font-size: 3em;
}

.la-4x {
  font-size: 4em;
}

.la-5x {
  font-size: 5em;
}

.la-6x {
  font-size: 6em;
}

.la-7x {
  font-size: 7em;
}

.la-8x {
  font-size: 8em;
}

.la-9x {
  font-size: 9em;
}

.la-10x {
  font-size: 10em;
}

.la-fw {
  text-align: center;
  width: 1.25em;
}

.la-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0;
}

.la-ul > li {
  position: relative;
}

.la-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit;
}

.la-border {
  border: solid 0.08em #eee;
  border-radius: 0.1em;
  padding: 0.2em 0.25em 0.15em;
}

.la-pull-left {
  float: left;
}

.la-pull-right {
  float: right;
}

.la.la-pull-left,
.las.la-pull-left,
.lar.la-pull-left,
.lal.la-pull-left,
.lab.la-pull-left {
  margin-right: 0.3em;
}

.la.la-pull-right,
.las.la-pull-right,
.lar.la-pull-right,
.lal.la-pull-right,
.lab.la-pull-right {
  margin-left: 0.3em;
}

.la-spin {
  animation: la-spin 2s infinite linear;
}

.la-pulse {
  animation: la-spin 1s infinite steps(8);
}
@keyframes la-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.la-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg);
}

.la-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg);
}

.la-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg);
}

.la-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1);
}

.la-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1);
}

.la-flip-both, .la-flip-horizontal.la-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(-1, -1);
}

:root .la-rotate-90,
:root .la-rotate-180,
:root .la-rotate-270,
:root .la-flip-horizontal,
:root .la-flip-vertical,
:root .la-flip-both {
  filter: none;
}

.la-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}

.la-stack-1x,
.la-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}

.la-stack-1x {
  line-height: inherit;
}

.la-stack-2x {
  font-size: 2em;
}

.la-inverse {
  color: #fff;
}

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.la-500px:before {
  content: "\\f26e";
}

.la-accessible-icon:before {
  content: "\\f368";
}

.la-accusoft:before {
  content: "\\f369";
}

.la-acquisitions-incorporated:before {
  content: "\\f6af";
}

.la-ad:before {
  content: "\\f641";
}

.la-address-book:before {
  content: "\\f2b9";
}

.la-address-card:before {
  content: "\\f2bb";
}

.la-adjust:before {
  content: "\\f042";
}

.la-adn:before {
  content: "\\f170";
}

.la-adobe:before {
  content: "\\f778";
}

.la-adversal:before {
  content: "\\f36a";
}

.la-affiliatetheme:before {
  content: "\\f36b";
}

.la-air-freshener:before {
  content: "\\f5d0";
}

.la-airbnb:before {
  content: "\\f834";
}

.la-algolia:before {
  content: "\\f36c";
}

.la-align-center:before {
  content: "\\f037";
}

.la-align-justify:before {
  content: "\\f039";
}

.la-align-left:before {
  content: "\\f036";
}

.la-align-right:before {
  content: "\\f038";
}

.la-alipay:before {
  content: "\\f642";
}

.la-allergies:before {
  content: "\\f461";
}

.la-amazon:before {
  content: "\\f270";
}

.la-amazon-pay:before {
  content: "\\f42c";
}

.la-ambulance:before {
  content: "\\f0f9";
}

.la-american-sign-language-interpreting:before {
  content: "\\f2a3";
}

.la-amilia:before {
  content: "\\f36d";
}

.la-anchor:before {
  content: "\\f13d";
}

.la-android:before {
  content: "\\f17b";
}

.la-angellist:before {
  content: "\\f209";
}

.la-angle-double-down:before {
  content: "\\f103";
}

.la-angle-double-left:before {
  content: "\\f100";
}

.la-angle-double-right:before {
  content: "\\f101";
}

.la-angle-double-up:before {
  content: "\\f102";
}

.la-angle-down:before {
  content: "\\f107";
}

.la-angle-left:before {
  content: "\\f104";
}

.la-angle-right:before {
  content: "\\f105";
}

.la-angle-up:before {
  content: "\\f106";
}

.la-angry:before {
  content: "\\f556";
}

.la-angrycreative:before {
  content: "\\f36e";
}

.la-angular:before {
  content: "\\f420";
}

.la-ankh:before {
  content: "\\f644";
}

.la-app-store:before {
  content: "\\f36f";
}

.la-app-store-ios:before {
  content: "\\f370";
}

.la-apper:before {
  content: "\\f371";
}

.la-apple:before {
  content: "\\f179";
}

.la-apple-alt:before {
  content: "\\f5d1";
}

.la-apple-pay:before {
  content: "\\f415";
}

.la-archive:before {
  content: "\\f187";
}

.la-archway:before {
  content: "\\f557";
}

.la-arrow-alt-circle-down:before {
  content: "\\f358";
}

.la-arrow-alt-circle-left:before {
  content: "\\f359";
}

.la-arrow-alt-circle-right:before {
  content: "\\f35a";
}

.la-arrow-alt-circle-up:before {
  content: "\\f35b";
}

.la-arrow-circle-down:before {
  content: "\\f0ab";
}

.la-arrow-circle-left:before {
  content: "\\f0a8";
}

.la-arrow-circle-right:before {
  content: "\\f0a9";
}

.la-arrow-circle-up:before {
  content: "\\f0aa";
}

.la-arrow-down:before {
  content: "\\f063";
}

.la-arrow-left:before {
  content: "\\f060";
}

.la-arrow-right:before {
  content: "\\f061";
}

.la-arrow-up:before {
  content: "\\f062";
}

.la-arrows-alt:before {
  content: "\\f0b2";
}

.la-arrows-alt-h:before {
  content: "\\f337";
}

.la-arrows-alt-v:before {
  content: "\\f338";
}

.la-artstation:before {
  content: "\\f77a";
}

.la-assistive-listening-systems:before {
  content: "\\f2a2";
}

.la-asterisk:before {
  content: "\\f069";
}

.la-asymmetrik:before {
  content: "\\f372";
}

.la-at:before {
  content: "\\f1fa";
}

.la-atlas:before {
  content: "\\f558";
}

.la-atlassian:before {
  content: "\\f77b";
}

.la-atom:before {
  content: "\\f5d2";
}

.la-audible:before {
  content: "\\f373";
}

.la-audio-description:before {
  content: "\\f29e";
}

.la-autoprefixer:before {
  content: "\\f41c";
}

.la-avianex:before {
  content: "\\f374";
}

.la-aviato:before {
  content: "\\f421";
}

.la-award:before {
  content: "\\f559";
}

.la-aws:before {
  content: "\\f375";
}

.la-baby:before {
  content: "\\f77c";
}

.la-baby-carriage:before {
  content: "\\f77d";
}

.la-backspace:before {
  content: "\\f55a";
}

.la-backward:before {
  content: "\\f04a";
}

.la-bacon:before {
  content: "\\f7e5";
}

.la-balance-scale:before {
  content: "\\f24e";
}

.la-balance-scale-left:before {
  content: "\\f515";
}

.la-balance-scale-right:before {
  content: "\\f516";
}

.la-ban:before {
  content: "\\f05e";
}

.la-band-aid:before {
  content: "\\f462";
}

.la-bandcamp:before {
  content: "\\f2d5";
}

.la-barcode:before {
  content: "\\f02a";
}

.la-bars:before {
  content: "\\f0c9";
}

.la-baseball-ball:before {
  content: "\\f433";
}

.la-basketball-ball:before {
  content: "\\f434";
}

.la-bath:before {
  content: "\\f2cd";
}

.la-battery-empty:before {
  content: "\\f244";
}

.la-battery-full:before {
  content: "\\f240";
}

.la-battery-half:before {
  content: "\\f242";
}

.la-battery-quarter:before {
  content: "\\f243";
}

.la-battery-three-quarters:before {
  content: "\\f241";
}

.la-battle-net:before {
  content: "\\f835";
}

.la-bed:before {
  content: "\\f236";
}

.la-beer:before {
  content: "\\f0fc";
}

.la-behance:before {
  content: "\\f1b4";
}

.la-behance-square:before {
  content: "\\f1b5";
}

.la-bell:before {
  content: "\\f0f3";
}

.la-bell-slash:before {
  content: "\\f1f6";
}

.la-bezier-curve:before {
  content: "\\f55b";
}

.la-bible:before {
  content: "\\f647";
}

.la-bicycle:before {
  content: "\\f206";
}

.la-biking:before {
  content: "\\f84a";
}

.la-bimobject:before {
  content: "\\f378";
}

.la-binoculars:before {
  content: "\\f1e5";
}

.la-biohazard:before {
  content: "\\f780";
}

.la-birthday-cake:before {
  content: "\\f1fd";
}

.la-bitbucket:before {
  content: "\\f171";
}

.la-bitcoin:before {
  content: "\\f379";
}

.la-bity:before {
  content: "\\f37a";
}

.la-black-tie:before {
  content: "\\f27e";
}

.la-blackberry:before {
  content: "\\f37b";
}

.la-blender:before {
  content: "\\f517";
}

.la-blender-phone:before {
  content: "\\f6b6";
}

.la-blind:before {
  content: "\\f29d";
}

.la-blog:before {
  content: "\\f781";
}

.la-blogger:before {
  content: "\\f37c";
}

.la-blogger-b:before {
  content: "\\f37d";
}

.la-bluetooth:before {
  content: "\\f293";
}

.la-bluetooth-b:before {
  content: "\\f294";
}

.la-bold:before {
  content: "\\f032";
}

.la-bolt:before {
  content: "\\f0e7";
}

.la-bomb:before {
  content: "\\f1e2";
}

.la-bone:before {
  content: "\\f5d7";
}

.la-bong:before {
  content: "\\f55c";
}

.la-book:before {
  content: "\\f02d";
}

.la-book-dead:before {
  content: "\\f6b7";
}

.la-book-medical:before {
  content: "\\f7e6";
}

.la-book-open:before {
  content: "\\f518";
}

.la-book-reader:before {
  content: "\\f5da";
}

.la-bookmark:before {
  content: "\\f02e";
}

.la-bootstrap:before {
  content: "\\f836";
}

.la-border-all:before {
  content: "\\f84c";
}

.la-border-none:before {
  content: "\\f850";
}

.la-border-style:before {
  content: "\\f853";
}

.la-bowling-ball:before {
  content: "\\f436";
}

.la-box:before {
  content: "\\f466";
}

.la-box-open:before {
  content: "\\f49e";
}

.la-boxes:before {
  content: "\\f468";
}

.la-braille:before {
  content: "\\f2a1";
}

.la-brain:before {
  content: "\\f5dc";
}

.la-bread-slice:before {
  content: "\\f7ec";
}

.la-briefcase:before {
  content: "\\f0b1";
}

.la-briefcase-medical:before {
  content: "\\f469";
}

.la-broadcast-tower:before {
  content: "\\f519";
}

.la-broom:before {
  content: "\\f51a";
}

.la-brush:before {
  content: "\\f55d";
}

.la-btc:before {
  content: "\\f15a";
}

.la-buffer:before {
  content: "\\f837";
}

.la-bug:before {
  content: "\\f188";
}

.la-building:before {
  content: "\\f1ad";
}

.la-bullhorn:before {
  content: "\\f0a1";
}

.la-bullseye:before {
  content: "\\f140";
}

.la-burn:before {
  content: "\\f46a";
}

.la-buromobelexperte:before {
  content: "\\f37f";
}

.la-bus:before {
  content: "\\f207";
}

.la-bus-alt:before {
  content: "\\f55e";
}

.la-business-time:before {
  content: "\\f64a";
}

.la-buy-n-large:before {
  content: "\\f8a6";
}

.la-buysellads:before {
  content: "\\f20d";
}

.la-calculator:before {
  content: "\\f1ec";
}

.la-calendar:before {
  content: "\\f133";
}

.la-calendar-alt:before {
  content: "\\f073";
}

.la-calendar-check:before {
  content: "\\f274";
}

.la-calendar-day:before {
  content: "\\f783";
}

.la-calendar-minus:before {
  content: "\\f272";
}

.la-calendar-plus:before {
  content: "\\f271";
}

.la-calendar-times:before {
  content: "\\f273";
}

.la-calendar-week:before {
  content: "\\f784";
}

.la-camera:before {
  content: "\\f030";
}

.la-camera-retro:before {
  content: "\\f083";
}

.la-campground:before {
  content: "\\f6bb";
}

.la-canadian-maple-leaf:before {
  content: "\\f785";
}

.la-candy-cane:before {
  content: "\\f786";
}

.la-cannabis:before {
  content: "\\f55f";
}

.la-capsules:before {
  content: "\\f46b";
}

.la-car:before {
  content: "\\f1b9";
}

.la-car-alt:before {
  content: "\\f5de";
}

.la-car-battery:before {
  content: "\\f5df";
}

.la-car-crash:before {
  content: "\\f5e1";
}

.la-car-side:before {
  content: "\\f5e4";
}

.la-caret-down:before {
  content: "\\f0d7";
}

.la-caret-left:before {
  content: "\\f0d9";
}

.la-caret-right:before {
  content: "\\f0da";
}

.la-caret-square-down:before {
  content: "\\f150";
}

.la-caret-square-left:before {
  content: "\\f191";
}

.la-caret-square-right:before {
  content: "\\f152";
}

.la-caret-square-up:before {
  content: "\\f151";
}

.la-caret-up:before {
  content: "\\f0d8";
}

.la-carrot:before {
  content: "\\f787";
}

.la-cart-arrow-down:before {
  content: "\\f218";
}

.la-cart-plus:before {
  content: "\\f217";
}

.la-cash-register:before {
  content: "\\f788";
}

.la-cat:before {
  content: "\\f6be";
}

.la-cc-amazon-pay:before {
  content: "\\f42d";
}

.la-cc-amex:before {
  content: "\\f1f3";
}

.la-cc-apple-pay:before {
  content: "\\f416";
}

.la-cc-diners-club:before {
  content: "\\f24c";
}

.la-cc-discover:before {
  content: "\\f1f2";
}

.la-cc-jcb:before {
  content: "\\f24b";
}

.la-cc-mastercard:before {
  content: "\\f1f1";
}

.la-cc-paypal:before {
  content: "\\f1f4";
}

.la-cc-stripe:before {
  content: "\\f1f5";
}

.la-cc-visa:before {
  content: "\\f1f0";
}

.la-centercode:before {
  content: "\\f380";
}

.la-centos:before {
  content: "\\f789";
}

.la-certificate:before {
  content: "\\f0a3";
}

.la-chair:before {
  content: "\\f6c0";
}

.la-chalkboard:before {
  content: "\\f51b";
}

.la-chalkboard-teacher:before {
  content: "\\f51c";
}

.la-charging-station:before {
  content: "\\f5e7";
}

.la-chart-area:before {
  content: "\\f1fe";
}

.la-chart-bar:before {
  content: "\\f080";
}

.la-chart-line:before {
  content: "\\f201";
}

.la-chart-pie:before {
  content: "\\f200";
}

.la-check:before {
  content: "\\f00c";
}

.la-check-circle:before {
  content: "\\f058";
}

.la-check-double:before {
  content: "\\f560";
}

.la-check-square:before {
  content: "\\f14a";
}

.la-cheese:before {
  content: "\\f7ef";
}

.la-chess:before {
  content: "\\f439";
}

.la-chess-bishop:before {
  content: "\\f43a";
}

.la-chess-board:before {
  content: "\\f43c";
}

.la-chess-king:before {
  content: "\\f43f";
}

.la-chess-knight:before {
  content: "\\f441";
}

.la-chess-pawn:before {
  content: "\\f443";
}

.la-chess-queen:before {
  content: "\\f445";
}

.la-chess-rook:before {
  content: "\\f447";
}

.la-chevron-circle-down:before {
  content: "\\f13a";
}

.la-chevron-circle-left:before {
  content: "\\f137";
}

.la-chevron-circle-right:before {
  content: "\\f138";
}

.la-chevron-circle-up:before {
  content: "\\f139";
}

.la-chevron-down:before {
  content: "\\f078";
}

.la-chevron-left:before {
  content: "\\f053";
}

.la-chevron-right:before {
  content: "\\f054";
}

.la-chevron-up:before {
  content: "\\f077";
}

.la-child:before {
  content: "\\f1ae";
}

.la-chrome:before {
  content: "\\f268";
}

.la-chromecast:before {
  content: "\\f838";
}

.la-church:before {
  content: "\\f51d";
}

.la-circle:before {
  content: "\\f111";
}

.la-circle-notch:before {
  content: "\\f1ce";
}

.la-city:before {
  content: "\\f64f";
}

.la-clinic-medical:before {
  content: "\\f7f2";
}

.la-clipboard:before {
  content: "\\f328";
}

.la-clipboard-check:before {
  content: "\\f46c";
}

.la-clipboard-list:before {
  content: "\\f46d";
}

.la-clock:before {
  content: "\\f017";
}

.la-clone:before {
  content: "\\f24d";
}

.la-closed-captioning:before {
  content: "\\f20a";
}

.la-cloud:before {
  content: "\\f0c2";
}

.la-cloud-download-alt:before {
  content: "\\f381";
}

.la-cloud-meatball:before {
  content: "\\f73b";
}

.la-cloud-moon:before {
  content: "\\f6c3";
}

.la-cloud-moon-rain:before {
  content: "\\f73c";
}

.la-cloud-rain:before {
  content: "\\f73d";
}

.la-cloud-showers-heavy:before {
  content: "\\f740";
}

.la-cloud-sun:before {
  content: "\\f6c4";
}

.la-cloud-sun-rain:before {
  content: "\\f743";
}

.la-cloud-upload-alt:before {
  content: "\\f382";
}

.la-cloudscale:before {
  content: "\\f383";
}

.la-cloudsmith:before {
  content: "\\f384";
}

.la-cloudversify:before {
  content: "\\f385";
}

.la-cocktail:before {
  content: "\\f561";
}

.la-code:before {
  content: "\\f121";
}

.la-code-branch:before {
  content: "\\f126";
}

.la-codepen:before {
  content: "\\f1cb";
}

.la-codiepie:before {
  content: "\\f284";
}

.la-coffee:before {
  content: "\\f0f4";
}

.la-cog:before {
  content: "\\f013";
}

.la-cogs:before {
  content: "\\f085";
}

.la-coins:before {
  content: "\\f51e";
}

.la-columns:before {
  content: "\\f0db";
}

.la-comment:before {
  content: "\\f075";
}

.la-comment-alt:before {
  content: "\\f27a";
}

.la-comment-dollar:before {
  content: "\\f651";
}

.la-comment-dots:before {
  content: "\\f4ad";
}

.la-comment-medical:before {
  content: "\\f7f5";
}

.la-comment-slash:before {
  content: "\\f4b3";
}

.la-comments:before {
  content: "\\f086";
}

.la-comments-dollar:before {
  content: "\\f653";
}

.la-compact-disc:before {
  content: "\\f51f";
}

.la-compass:before {
  content: "\\f14e";
}

.la-compress:before {
  content: "\\f066";
}

.la-compress-arrows-alt:before {
  content: "\\f78c";
}

.la-concierge-bell:before {
  content: "\\f562";
}

.la-confluence:before {
  content: "\\f78d";
}

.la-connectdevelop:before {
  content: "\\f20e";
}

.la-contao:before {
  content: "\\f26d";
}

.la-cookie:before {
  content: "\\f563";
}

.la-cookie-bite:before {
  content: "\\f564";
}

.la-copy:before {
  content: "\\f0c5";
}

.la-copyright:before {
  content: "\\f1f9";
}

.la-cotton-bureau:before {
  content: "\\f89e";
}

.la-couch:before {
  content: "\\f4b8";
}

.la-cpanel:before {
  content: "\\f388";
}

.la-creative-commons:before {
  content: "\\f25e";
}

.la-creative-commons-by:before {
  content: "\\f4e7";
}

.la-creative-commons-nc:before {
  content: "\\f4e8";
}

.la-creative-commons-nc-eu:before {
  content: "\\f4e9";
}

.la-creative-commons-nc-jp:before {
  content: "\\f4ea";
}

.la-creative-commons-nd:before {
  content: "\\f4eb";
}

.la-creative-commons-pd:before {
  content: "\\f4ec";
}

.la-creative-commons-pd-alt:before {
  content: "\\f4ed";
}

.la-creative-commons-remix:before {
  content: "\\f4ee";
}

.la-creative-commons-sa:before {
  content: "\\f4ef";
}

.la-creative-commons-sampling:before {
  content: "\\f4f0";
}

.la-creative-commons-sampling-plus:before {
  content: "\\f4f1";
}

.la-creative-commons-share:before {
  content: "\\f4f2";
}

.la-creative-commons-zero:before {
  content: "\\f4f3";
}

.la-credit-card:before {
  content: "\\f09d";
}

.la-critical-role:before {
  content: "\\f6c9";
}

.la-crop:before {
  content: "\\f125";
}

.la-crop-alt:before {
  content: "\\f565";
}

.la-cross:before {
  content: "\\f654";
}

.la-crosshairs:before {
  content: "\\f05b";
}

.la-crow:before {
  content: "\\f520";
}

.la-crown:before {
  content: "\\f521";
}

.la-crutch:before {
  content: "\\f7f7";
}

.la-css3:before {
  content: "\\f13c";
}

.la-css3-alt:before {
  content: "\\f38b";
}

.la-cube:before {
  content: "\\f1b2";
}

.la-cubes:before {
  content: "\\f1b3";
}

.la-cut:before {
  content: "\\f0c4";
}

.la-cuttlefish:before {
  content: "\\f38c";
}

.la-d-and-d:before {
  content: "\\f38d";
}

.la-d-and-d-beyond:before {
  content: "\\f6ca";
}

.la-dashcube:before {
  content: "\\f210";
}

.la-database:before {
  content: "\\f1c0";
}

.la-deaf:before {
  content: "\\f2a4";
}

.la-delicious:before {
  content: "\\f1a5";
}

.la-democrat:before {
  content: "\\f747";
}

.la-deploydog:before {
  content: "\\f38e";
}

.la-deskpro:before {
  content: "\\f38f";
}

.la-desktop:before {
  content: "\\f108";
}

.la-dev:before {
  content: "\\f6cc";
}

.la-deviantart:before {
  content: "\\f1bd";
}

.la-dharmachakra:before {
  content: "\\f655";
}

.la-dhl:before {
  content: "\\f790";
}

.la-diagnoses:before {
  content: "\\f470";
}

.la-diaspora:before {
  content: "\\f791";
}

.la-dice:before {
  content: "\\f522";
}

.la-dice-d20:before {
  content: "\\f6cf";
}

.la-dice-d6:before {
  content: "\\f6d1";
}

.la-dice-five:before {
  content: "\\f523";
}

.la-dice-four:before {
  content: "\\f524";
}

.la-dice-one:before {
  content: "\\f525";
}

.la-dice-six:before {
  content: "\\f526";
}

.la-dice-three:before {
  content: "\\f527";
}

.la-dice-two:before {
  content: "\\f528";
}

.la-digg:before {
  content: "\\f1a6";
}

.la-digital-ocean:before {
  content: "\\f391";
}

.la-digital-tachograph:before {
  content: "\\f566";
}

.la-directions:before {
  content: "\\f5eb";
}

.la-discord:before {
  content: "\\f392";
}

.la-discourse:before {
  content: "\\f393";
}

.la-divide:before {
  content: "\\f529";
}

.la-dizzy:before {
  content: "\\f567";
}

.la-dna:before {
  content: "\\f471";
}

.la-dochub:before {
  content: "\\f394";
}

.la-docker:before {
  content: "\\f395";
}

.la-dog:before {
  content: "\\f6d3";
}

.la-dollar-sign:before {
  content: "\\f155";
}

.la-dolly:before {
  content: "\\f472";
}

.la-dolly-flatbed:before {
  content: "\\f474";
}

.la-donate:before {
  content: "\\f4b9";
}

.la-door-closed:before {
  content: "\\f52a";
}

.la-door-open:before {
  content: "\\f52b";
}

.la-dot-circle:before {
  content: "\\f192";
}

.la-dove:before {
  content: "\\f4ba";
}

.la-download:before {
  content: "\\f019";
}

.la-draft2digital:before {
  content: "\\f396";
}

.la-drafting-compass:before {
  content: "\\f568";
}

.la-dragon:before {
  content: "\\f6d5";
}

.la-draw-polygon:before {
  content: "\\f5ee";
}

.la-dribbble:before {
  content: "\\f17d";
}

.la-dribbble-square:before {
  content: "\\f397";
}

.la-dropbox:before {
  content: "\\f16b";
}

.la-drum:before {
  content: "\\f569";
}

.la-drum-steelpan:before {
  content: "\\f56a";
}

.la-drumstick-bite:before {
  content: "\\f6d7";
}

.la-drupal:before {
  content: "\\f1a9";
}

.la-dumbbell:before {
  content: "\\f44b";
}

.la-dumpster:before {
  content: "\\f793";
}

.la-dumpster-fire:before {
  content: "\\f794";
}

.la-dungeon:before {
  content: "\\f6d9";
}

.la-dyalog:before {
  content: "\\f399";
}

.la-earlybirds:before {
  content: "\\f39a";
}

.la-ebay:before {
  content: "\\f4f4";
}

.la-edge:before {
  content: "\\f282";
}

.la-edit:before {
  content: "\\f044";
}

.la-egg:before {
  content: "\\f7fb";
}

.la-eject:before {
  content: "\\f052";
}

.la-elementor:before {
  content: "\\f430";
}

.la-ellipsis-h:before {
  content: "\\f141";
}

.la-ellipsis-v:before {
  content: "\\f142";
}

.la-ello:before {
  content: "\\f5f1";
}

.la-ember:before {
  content: "\\f423";
}

.la-empire:before {
  content: "\\f1d1";
}

.la-envelope:before {
  content: "\\f0e0";
}

.la-envelope-open:before {
  content: "\\f2b6";
}

.la-envelope-open-text:before {
  content: "\\f658";
}

.la-envelope-square:before {
  content: "\\f199";
}

.la-envira:before {
  content: "\\f299";
}

.la-equals:before {
  content: "\\f52c";
}

.la-eraser:before {
  content: "\\f12d";
}

.la-erlang:before {
  content: "\\f39d";
}

.la-ethereum:before {
  content: "\\f42e";
}

.la-ethernet:before {
  content: "\\f796";
}

.la-etsy:before {
  content: "\\f2d7";
}

.la-euro-sign:before {
  content: "\\f153";
}

.la-evernote:before {
  content: "\\f839";
}

.la-exchange-alt:before {
  content: "\\f362";
}

.la-exclamation:before {
  content: "\\f12a";
}

.la-exclamation-circle:before {
  content: "\\f06a";
}

.la-exclamation-triangle:before {
  content: "\\f071";
}

.la-expand:before {
  content: "\\f065";
}

.la-expand-arrows-alt:before {
  content: "\\f31e";
}

.la-expeditedssl:before {
  content: "\\f23e";
}

.la-external-link-alt:before {
  content: "\\f35d";
}

.la-external-link-square-alt:before {
  content: "\\f360";
}

.la-eye:before {
  content: "\\f06e";
}

.la-eye-dropper:before {
  content: "\\f1fb";
}

.la-eye-slash:before {
  content: "\\f070";
}

.la-facebook:before {
  content: "\\f09a";
}

.la-facebook-f:before {
  content: "\\f39e";
}

.la-facebook-messenger:before {
  content: "\\f39f";
}

.la-facebook-square:before {
  content: "\\f082";
}

.la-fan:before {
  content: "\\f863";
}

.la-fantasy-flight-games:before {
  content: "\\f6dc";
}

.la-fast-backward:before {
  content: "\\f049";
}

.la-fast-forward:before {
  content: "\\f050";
}

.la-fax:before {
  content: "\\f1ac";
}

.la-feather:before {
  content: "\\f52d";
}

.la-feather-alt:before {
  content: "\\f56b";
}

.la-fedex:before {
  content: "\\f797";
}

.la-fedora:before {
  content: "\\f798";
}

.la-female:before {
  content: "\\f182";
}

.la-fighter-jet:before {
  content: "\\f0fb";
}

.la-figma:before {
  content: "\\f799";
}

.la-file:before {
  content: "\\f15b";
}

.la-file-alt:before {
  content: "\\f15c";
}

.la-file-archive:before {
  content: "\\f1c6";
}

.la-file-audio:before {
  content: "\\f1c7";
}

.la-file-code:before {
  content: "\\f1c9";
}

.la-file-contract:before {
  content: "\\f56c";
}

.la-file-csv:before {
  content: "\\f6dd";
}

.la-file-download:before {
  content: "\\f56d";
}

.la-file-excel:before {
  content: "\\f1c3";
}

.la-file-export:before {
  content: "\\f56e";
}

.la-file-image:before {
  content: "\\f1c5";
}

.la-file-import:before {
  content: "\\f56f";
}

.la-file-invoice:before {
  content: "\\f570";
}

.la-file-invoice-dollar:before {
  content: "\\f571";
}

.la-file-medical:before {
  content: "\\f477";
}

.la-file-medical-alt:before {
  content: "\\f478";
}

.la-file-pdf:before {
  content: "\\f1c1";
}

.la-file-powerpoint:before {
  content: "\\f1c4";
}

.la-file-prescription:before {
  content: "\\f572";
}

.la-file-signature:before {
  content: "\\f573";
}

.la-file-upload:before {
  content: "\\f574";
}

.la-file-video:before {
  content: "\\f1c8";
}

.la-file-word:before {
  content: "\\f1c2";
}

.la-fill:before {
  content: "\\f575";
}

.la-fill-drip:before {
  content: "\\f576";
}

.la-film:before {
  content: "\\f008";
}

.la-filter:before {
  content: "\\f0b0";
}

.la-fingerprint:before {
  content: "\\f577";
}

.la-fire:before {
  content: "\\f06d";
}

.la-fire-alt:before {
  content: "\\f7e4";
}

.la-fire-extinguisher:before {
  content: "\\f134";
}

.la-firefox:before {
  content: "\\f269";
}

.la-first-aid:before {
  content: "\\f479";
}

.la-first-order:before {
  content: "\\f2b0";
}

.la-first-order-alt:before {
  content: "\\f50a";
}

.la-firstdraft:before {
  content: "\\f3a1";
}

.la-fish:before {
  content: "\\f578";
}

.la-fist-raised:before {
  content: "\\f6de";
}

.la-flag:before {
  content: "\\f024";
}

.la-flag-checkered:before {
  content: "\\f11e";
}

.la-flag-usa:before {
  content: "\\f74d";
}

.la-flask:before {
  content: "\\f0c3";
}

.la-flickr:before {
  content: "\\f16e";
}

.la-flipboard:before {
  content: "\\f44d";
}

.la-flushed:before {
  content: "\\f579";
}

.la-fly:before {
  content: "\\f417";
}

.la-folder:before {
  content: "\\f07b";
}

.la-folder-minus:before {
  content: "\\f65d";
}

.la-folder-open:before {
  content: "\\f07c";
}

.la-folder-plus:before {
  content: "\\f65e";
}

.la-font:before {
  content: "\\f031";
}

.la-font-awesome:before {
  content: "\\f2b4";
}

.la-font-awesome-alt:before {
  content: "\\f35c";
}

.la-font-awesome-flag:before {
  content: "\\f425";
}

.la-font-awesome-logo-full:before {
  content: "\\f4e6";
}

.la-fonticons:before {
  content: "\\f280";
}

.la-fonticons-fi:before {
  content: "\\f3a2";
}

.la-football-ball:before {
  content: "\\f44e";
}

.la-fort-awesome:before {
  content: "\\f286";
}

.la-fort-awesome-alt:before {
  content: "\\f3a3";
}

.la-forumbee:before {
  content: "\\f211";
}

.la-forward:before {
  content: "\\f04e";
}

.la-foursquare:before {
  content: "\\f180";
}

.la-free-code-camp:before {
  content: "\\f2c5";
}

.la-freebsd:before {
  content: "\\f3a4";
}

.la-frog:before {
  content: "\\f52e";
}

.la-frown:before {
  content: "\\f119";
}

.la-frown-open:before {
  content: "\\f57a";
}

.la-fulcrum:before {
  content: "\\f50b";
}

.la-funnel-dollar:before {
  content: "\\f662";
}

.la-futbol:before {
  content: "\\f1e3";
}

.la-galactic-republic:before {
  content: "\\f50c";
}

.la-galactic-senate:before {
  content: "\\f50d";
}

.la-gamepad:before {
  content: "\\f11b";
}

.la-gas-pump:before {
  content: "\\f52f";
}

.la-gavel:before {
  content: "\\f0e3";
}

.la-gem:before {
  content: "\\f3a5";
}

.la-genderless:before {
  content: "\\f22d";
}

.la-get-pocket:before {
  content: "\\f265";
}

.la-gg:before {
  content: "\\f260";
}

.la-gg-circle:before {
  content: "\\f261";
}

.la-ghost:before {
  content: "\\f6e2";
}

.la-gift:before {
  content: "\\f06b";
}

.la-gifts:before {
  content: "\\f79c";
}

.la-git:before {
  content: "\\f1d3";
}

.la-git-alt:before {
  content: "\\f841";
}

.la-git-square:before {
  content: "\\f1d2";
}

.la-github:before {
  content: "\\f09b";
}

.la-github-alt:before {
  content: "\\f113";
}

.la-github-square:before {
  content: "\\f092";
}

.la-gitkraken:before {
  content: "\\f3a6";
}

.la-gitlab:before {
  content: "\\f296";
}

.la-gitter:before {
  content: "\\f426";
}

.la-glass-cheers:before {
  content: "\\f79f";
}

.la-glass-martini:before {
  content: "\\f000";
}

.la-glass-martini-alt:before {
  content: "\\f57b";
}

.la-glass-whiskey:before {
  content: "\\f7a0";
}

.la-glasses:before {
  content: "\\f530";
}

.la-glide:before {
  content: "\\f2a5";
}

.la-glide-g:before {
  content: "\\f2a6";
}

.la-globe:before {
  content: "\\f0ac";
}

.la-globe-africa:before {
  content: "\\f57c";
}

.la-globe-americas:before {
  content: "\\f57d";
}

.la-globe-asia:before {
  content: "\\f57e";
}

.la-globe-europe:before {
  content: "\\f7a2";
}

.la-gofore:before {
  content: "\\f3a7";
}

.la-golf-ball:before {
  content: "\\f450";
}

.la-goodreads:before {
  content: "\\f3a8";
}

.la-goodreads-g:before {
  content: "\\f3a9";
}

.la-google:before {
  content: "\\f1a0";
}

.la-google-drive:before {
  content: "\\f3aa";
}

.la-google-play:before {
  content: "\\f3ab";
}

.la-google-plus:before {
  content: "\\f2b3";
}

.la-google-plus-g:before {
  content: "\\f0d5";
}

.la-google-plus-square:before {
  content: "\\f0d4";
}

.la-google-wallet:before {
  content: "\\f1ee";
}

.la-gopuram:before {
  content: "\\f664";
}

.la-graduation-cap:before {
  content: "\\f19d";
}

.la-gratipay:before {
  content: "\\f184";
}

.la-grav:before {
  content: "\\f2d6";
}

.la-greater-than:before {
  content: "\\f531";
}

.la-greater-than-equal:before {
  content: "\\f532";
}

.la-grimace:before {
  content: "\\f57f";
}

.la-grin:before {
  content: "\\f580";
}

.la-grin-alt:before {
  content: "\\f581";
}

.la-grin-beam:before {
  content: "\\f582";
}

.la-grin-beam-sweat:before {
  content: "\\f583";
}

.la-grin-hearts:before {
  content: "\\f584";
}

.la-grin-squint:before {
  content: "\\f585";
}

.la-grin-squint-tears:before {
  content: "\\f586";
}

.la-grin-stars:before {
  content: "\\f587";
}

.la-grin-tears:before {
  content: "\\f588";
}

.la-grin-tongue:before {
  content: "\\f589";
}

.la-grin-tongue-squint:before {
  content: "\\f58a";
}

.la-grin-tongue-wink:before {
  content: "\\f58b";
}

.la-grin-wink:before {
  content: "\\f58c";
}

.la-grip-horizontal:before {
  content: "\\f58d";
}

.la-grip-lines:before {
  content: "\\f7a4";
}

.la-grip-lines-vertical:before {
  content: "\\f7a5";
}

.la-grip-vertical:before {
  content: "\\f58e";
}

.la-gripfire:before {
  content: "\\f3ac";
}

.la-grunt:before {
  content: "\\f3ad";
}

.la-guitar:before {
  content: "\\f7a6";
}

.la-gulp:before {
  content: "\\f3ae";
}

.la-h-square:before {
  content: "\\f0fd";
}

.la-hacker-news:before {
  content: "\\f1d4";
}

.la-hacker-news-square:before {
  content: "\\f3af";
}

.la-hackerrank:before {
  content: "\\f5f7";
}

.la-hamburger:before {
  content: "\\f805";
}

.la-hammer:before {
  content: "\\f6e3";
}

.la-hamsa:before {
  content: "\\f665";
}

.la-hand-holding:before {
  content: "\\f4bd";
}

.la-hand-holding-heart:before {
  content: "\\f4be";
}

.la-hand-holding-usd:before {
  content: "\\f4c0";
}

.la-hand-lizard:before {
  content: "\\f258";
}

.la-hand-middle-finger:before {
  content: "\\f806";
}

.la-hand-paper:before {
  content: "\\f256";
}

.la-hand-peace:before {
  content: "\\f25b";
}

.la-hand-point-down:before {
  content: "\\f0a7";
}

.la-hand-point-left:before {
  content: "\\f0a5";
}

.la-hand-point-right:before {
  content: "\\f0a4";
}

.la-hand-point-up:before {
  content: "\\f0a6";
}

.la-hand-pointer:before {
  content: "\\f25a";
}

.la-hand-rock:before {
  content: "\\f255";
}

.la-hand-scissors:before {
  content: "\\f257";
}

.la-hand-spock:before {
  content: "\\f259";
}

.la-hands:before {
  content: "\\f4c2";
}

.la-hands-helping:before {
  content: "\\f4c4";
}

.la-handshake:before {
  content: "\\f2b5";
}

.la-hanukiah:before {
  content: "\\f6e6";
}

.la-hard-hat:before {
  content: "\\f807";
}

.la-hashtag:before {
  content: "\\f292";
}

.la-hat-cowboy:before {
  content: "\\f8c0";
}

.la-hat-cowboy-side:before {
  content: "\\f8c1";
}

.la-hat-wizard:before {
  content: "\\f6e8";
}

.la-haykal:before {
  content: "\\f666";
}

.la-hdd:before {
  content: "\\f0a0";
}

.la-heading:before {
  content: "\\f1dc";
}

.la-headphones:before {
  content: "\\f025";
}

.la-headphones-alt:before {
  content: "\\f58f";
}

.la-headset:before {
  content: "\\f590";
}

.la-heart:before {
  content: "\\f004";
}

.la-heart-broken:before {
  content: "\\f7a9";
}

.la-heartbeat:before {
  content: "\\f21e";
}

.la-helicopter:before {
  content: "\\f533";
}

.la-highlighter:before {
  content: "\\f591";
}

.la-hiking:before {
  content: "\\f6ec";
}

.la-hippo:before {
  content: "\\f6ed";
}

.la-hips:before {
  content: "\\f452";
}

.la-hire-a-helper:before {
  content: "\\f3b0";
}

.la-history:before {
  content: "\\f1da";
}

.la-hockey-puck:before {
  content: "\\f453";
}

.la-holly-berry:before {
  content: "\\f7aa";
}

.la-home:before {
  content: "\\f015";
}

.la-hooli:before {
  content: "\\f427";
}

.la-hornbill:before {
  content: "\\f592";
}

.la-horse:before {
  content: "\\f6f0";
}

.la-horse-head:before {
  content: "\\f7ab";
}

.la-hospital:before {
  content: "\\f0f8";
}

.la-hospital-alt:before {
  content: "\\f47d";
}

.la-hospital-symbol:before {
  content: "\\f47e";
}

.la-hot-tub:before {
  content: "\\f593";
}

.la-hotdog:before {
  content: "\\f80f";
}

.la-hotel:before {
  content: "\\f594";
}

.la-hotjar:before {
  content: "\\f3b1";
}

.la-hourglass:before {
  content: "\\f254";
}

.la-hourglass-end:before {
  content: "\\f253";
}

.la-hourglass-half:before {
  content: "\\f252";
}

.la-hourglass-start:before {
  content: "\\f251";
}

.la-house-damage:before {
  content: "\\f6f1";
}

.la-houzz:before {
  content: "\\f27c";
}

.la-hryvnia:before {
  content: "\\f6f2";
}

.la-html5:before {
  content: "\\f13b";
}

.la-hubspot:before {
  content: "\\f3b2";
}

.la-i-cursor:before {
  content: "\\f246";
}

.la-ice-cream:before {
  content: "\\f810";
}

.la-icicles:before {
  content: "\\f7ad";
}

.la-icons:before {
  content: "\\f86d";
}

.la-id-badge:before {
  content: "\\f2c1";
}

.la-id-card:before {
  content: "\\f2c2";
}

.la-id-card-alt:before {
  content: "\\f47f";
}

.la-igloo:before {
  content: "\\f7ae";
}

.la-image:before {
  content: "\\f03e";
}

.la-images:before {
  content: "\\f302";
}

.la-imdb:before {
  content: "\\f2d8";
}

.la-inbox:before {
  content: "\\f01c";
}

.la-indent:before {
  content: "\\f03c";
}

.la-industry:before {
  content: "\\f275";
}

.la-infinity:before {
  content: "\\f534";
}

.la-info:before {
  content: "\\f129";
}

.la-info-circle:before {
  content: "\\f05a";
}

.la-instagram:before {
  content: "\\f16d";
}

.la-intercom:before {
  content: "\\f7af";
}

.la-internet-explorer:before {
  content: "\\f26b";
}

.la-invision:before {
  content: "\\f7b0";
}

.la-ioxhost:before {
  content: "\\f208";
}

.la-italic:before {
  content: "\\f033";
}

.la-itch-io:before {
  content: "\\f83a";
}

.la-itunes:before {
  content: "\\f3b4";
}

.la-itunes-note:before {
  content: "\\f3b5";
}

.la-java:before {
  content: "\\f4e4";
}

.la-jedi:before {
  content: "\\f669";
}

.la-jedi-order:before {
  content: "\\f50e";
}

.la-jenkins:before {
  content: "\\f3b6";
}

.la-jira:before {
  content: "\\f7b1";
}

.la-joget:before {
  content: "\\f3b7";
}

.la-joint:before {
  content: "\\f595";
}

.la-joomla:before {
  content: "\\f1aa";
}

.la-journal-whills:before {
  content: "\\f66a";
}

.la-js:before {
  content: "\\f3b8";
}

.la-js-square:before {
  content: "\\f3b9";
}

.la-jsfiddle:before {
  content: "\\f1cc";
}

.la-kaaba:before {
  content: "\\f66b";
}

.la-kaggle:before {
  content: "\\f5fa";
}

.la-key:before {
  content: "\\f084";
}

.la-keybase:before {
  content: "\\f4f5";
}

.la-keyboard:before {
  content: "\\f11c";
}

.la-keycdn:before {
  content: "\\f3ba";
}

.la-khanda:before {
  content: "\\f66d";
}

.la-kickstarter:before {
  content: "\\f3bb";
}

.la-kickstarter-k:before {
  content: "\\f3bc";
}

.la-kiss:before {
  content: "\\f596";
}

.la-kiss-beam:before {
  content: "\\f597";
}

.la-kiss-wink-heart:before {
  content: "\\f598";
}

.la-kiwi-bird:before {
  content: "\\f535";
}

.la-korvue:before {
  content: "\\f42f";
}

.la-landmark:before {
  content: "\\f66f";
}

.la-language:before {
  content: "\\f1ab";
}

.la-laptop:before {
  content: "\\f109";
}

.la-laptop-code:before {
  content: "\\f5fc";
}

.la-laptop-medical:before {
  content: "\\f812";
}

.la-laravel:before {
  content: "\\f3bd";
}

.la-lastfm:before {
  content: "\\f202";
}

.la-lastfm-square:before {
  content: "\\f203";
}

.la-laugh:before {
  content: "\\f599";
}

.la-laugh-beam:before {
  content: "\\f59a";
}

.la-laugh-squint:before {
  content: "\\f59b";
}

.la-laugh-wink:before {
  content: "\\f59c";
}

.la-layer-group:before {
  content: "\\f5fd";
}

.la-leaf:before {
  content: "\\f06c";
}

.la-leanpub:before {
  content: "\\f212";
}

.la-lemon:before {
  content: "\\f094";
}

.la-less:before {
  content: "\\f41d";
}

.la-less-than:before {
  content: "\\f536";
}

.la-less-than-equal:before {
  content: "\\f537";
}

.la-level-down-alt:before {
  content: "\\f3be";
}

.la-level-up-alt:before {
  content: "\\f3bf";
}

.la-life-ring:before {
  content: "\\f1cd";
}

.la-lightbulb:before {
  content: "\\f0eb";
}

.la-line:before {
  content: "\\f3c0";
}

.la-link:before {
  content: "\\f0c1";
}

.la-linkedin:before {
  content: "\\f08c";
}

.la-linkedin-in:before {
  content: "\\f0e1";
}

.la-linode:before {
  content: "\\f2b8";
}

.la-linux:before {
  content: "\\f17c";
}

.la-lira-sign:before {
  content: "\\f195";
}

.la-list:before {
  content: "\\f03a";
}

.la-list-alt:before {
  content: "\\f022";
}

.la-list-ol:before {
  content: "\\f0cb";
}

.la-list-ul:before {
  content: "\\f0ca";
}

.la-location-arrow:before {
  content: "\\f124";
}

.la-lock:before {
  content: "\\f023";
}

.la-lock-open:before {
  content: "\\f3c1";
}

.la-long-arrow-alt-down:before {
  content: "\\f309";
}

.la-long-arrow-alt-left:before {
  content: "\\f30a";
}

.la-long-arrow-alt-right:before {
  content: "\\f30b";
}

.la-long-arrow-alt-up:before {
  content: "\\f30c";
}

.la-low-vision:before {
  content: "\\f2a8";
}

.la-luggage-cart:before {
  content: "\\f59d";
}

.la-lyft:before {
  content: "\\f3c3";
}

.la-magento:before {
  content: "\\f3c4";
}

.la-magic:before {
  content: "\\f0d0";
}

.la-magnet:before {
  content: "\\f076";
}

.la-mail-bulk:before {
  content: "\\f674";
}

.la-mailchimp:before {
  content: "\\f59e";
}

.la-male:before {
  content: "\\f183";
}

.la-mandalorian:before {
  content: "\\f50f";
}

.la-map:before {
  content: "\\f279";
}

.la-map-marked:before {
  content: "\\f59f";
}

.la-map-marked-alt:before {
  content: "\\f5a0";
}

.la-map-marker:before {
  content: "\\f041";
}

.la-map-marker-alt:before {
  content: "\\f3c5";
}

.la-map-pin:before {
  content: "\\f276";
}

.la-map-signs:before {
  content: "\\f277";
}

.la-markdown:before {
  content: "\\f60f";
}

.la-marker:before {
  content: "\\f5a1";
}

.la-mars:before {
  content: "\\f222";
}

.la-mars-double:before {
  content: "\\f227";
}

.la-mars-stroke:before {
  content: "\\f229";
}

.la-mars-stroke-h:before {
  content: "\\f22b";
}

.la-mars-stroke-v:before {
  content: "\\f22a";
}

.la-mask:before {
  content: "\\f6fa";
}

.la-mastodon:before {
  content: "\\f4f6";
}

.la-maxcdn:before {
  content: "\\f136";
}

.la-mdb:before {
  content: "\\f8ca";
}

.la-medal:before {
  content: "\\f5a2";
}

.la-medapps:before {
  content: "\\f3c6";
}

.la-medium:before {
  content: "\\f23a";
}

.la-medium-m:before {
  content: "\\f3c7";
}

.la-medkit:before {
  content: "\\f0fa";
}

.la-medrt:before {
  content: "\\f3c8";
}

.la-meetup:before {
  content: "\\f2e0";
}

.la-megaport:before {
  content: "\\f5a3";
}

.la-meh:before {
  content: "\\f11a";
}

.la-meh-blank:before {
  content: "\\f5a4";
}

.la-meh-rolling-eyes:before {
  content: "\\f5a5";
}

.la-memory:before {
  content: "\\f538";
}

.la-mendeley:before {
  content: "\\f7b3";
}

.la-menorah:before {
  content: "\\f676";
}

.la-mercury:before {
  content: "\\f223";
}

.la-meteor:before {
  content: "\\f753";
}

.la-microchip:before {
  content: "\\f2db";
}

.la-microphone:before {
  content: "\\f130";
}

.la-microphone-alt:before {
  content: "\\f3c9";
}

.la-microphone-alt-slash:before {
  content: "\\f539";
}

.la-microphone-slash:before {
  content: "\\f131";
}

.la-microscope:before {
  content: "\\f610";
}

.la-microsoft:before {
  content: "\\f3ca";
}

.la-minus:before {
  content: "\\f068";
}

.la-minus-circle:before {
  content: "\\f056";
}

.la-minus-square:before {
  content: "\\f146";
}

.la-mitten:before {
  content: "\\f7b5";
}

.la-mix:before {
  content: "\\f3cb";
}

.la-mixcloud:before {
  content: "\\f289";
}

.la-mizuni:before {
  content: "\\f3cc";
}

.la-mobile:before {
  content: "\\f10b";
}

.la-mobile-alt:before {
  content: "\\f3cd";
}

.la-modx:before {
  content: "\\f285";
}

.la-monero:before {
  content: "\\f3d0";
}

.la-money-bill:before {
  content: "\\f0d6";
}

.la-money-bill-alt:before {
  content: "\\f3d1";
}

.la-money-bill-wave:before {
  content: "\\f53a";
}

.la-money-bill-wave-alt:before {
  content: "\\f53b";
}

.la-money-check:before {
  content: "\\f53c";
}

.la-money-check-alt:before {
  content: "\\f53d";
}

.la-monument:before {
  content: "\\f5a6";
}

.la-moon:before {
  content: "\\f186";
}

.la-mortar-pestle:before {
  content: "\\f5a7";
}

.la-mosque:before {
  content: "\\f678";
}

.la-motorcycle:before {
  content: "\\f21c";
}

.la-mountain:before {
  content: "\\f6fc";
}

.la-mouse:before {
  content: "\\f8cc";
}

.la-mouse-pointer:before {
  content: "\\f245";
}

.la-mug-hot:before {
  content: "\\f7b6";
}

.la-music:before {
  content: "\\f001";
}

.la-napster:before {
  content: "\\f3d2";
}

.la-neos:before {
  content: "\\f612";
}

.la-network-wired:before {
  content: "\\f6ff";
}

.la-neuter:before {
  content: "\\f22c";
}

.la-newspaper:before {
  content: "\\f1ea";
}

.la-nimblr:before {
  content: "\\f5a8";
}

.la-node:before {
  content: "\\f419";
}

.la-node-js:before {
  content: "\\f3d3";
}

.la-not-equal:before {
  content: "\\f53e";
}

.la-notes-medical:before {
  content: "\\f481";
}

.la-npm:before {
  content: "\\f3d4";
}

.la-ns8:before {
  content: "\\f3d5";
}

.la-nutritionix:before {
  content: "\\f3d6";
}

.la-object-group:before {
  content: "\\f247";
}

.la-object-ungroup:before {
  content: "\\f248";
}

.la-odnoklassniki:before {
  content: "\\f263";
}

.la-odnoklassniki-square:before {
  content: "\\f264";
}

.la-oil-can:before {
  content: "\\f613";
}

.la-old-republic:before {
  content: "\\f510";
}

.la-om:before {
  content: "\\f679";
}

.la-opencart:before {
  content: "\\f23d";
}

.la-openid:before {
  content: "\\f19b";
}

.la-opera:before {
  content: "\\f26a";
}

.la-optin-monster:before {
  content: "\\f23c";
}

.la-orcid:before {
  content: "\\f8d2";
}

.la-osi:before {
  content: "\\f41a";
}

.la-otter:before {
  content: "\\f700";
}

.la-outdent:before {
  content: "\\f03b";
}

.la-page4:before {
  content: "\\f3d7";
}

.la-pagelines:before {
  content: "\\f18c";
}

.la-pager:before {
  content: "\\f815";
}

.la-paint-brush:before {
  content: "\\f1fc";
}

.la-paint-roller:before {
  content: "\\f5aa";
}

.la-palette:before {
  content: "\\f53f";
}

.la-palfed:before {
  content: "\\f3d8";
}

.la-pallet:before {
  content: "\\f482";
}

.la-paper-plane:before {
  content: "\\f1d8";
}

.la-paperclip:before {
  content: "\\f0c6";
}

.la-parachute-box:before {
  content: "\\f4cd";
}

.la-paragraph:before {
  content: "\\f1dd";
}

.la-parking:before {
  content: "\\f540";
}

.la-passport:before {
  content: "\\f5ab";
}

.la-pastafarianism:before {
  content: "\\f67b";
}

.la-paste:before {
  content: "\\f0ea";
}

.la-patreon:before {
  content: "\\f3d9";
}

.la-pause:before {
  content: "\\f04c";
}

.la-pause-circle:before {
  content: "\\f28b";
}

.la-paw:before {
  content: "\\f1b0";
}

.la-paypal:before {
  content: "\\f1ed";
}

.la-peace:before {
  content: "\\f67c";
}

.la-pen:before {
  content: "\\f304";
}

.la-pen-alt:before {
  content: "\\f305";
}

.la-pen-fancy:before {
  content: "\\f5ac";
}

.la-pen-nib:before {
  content: "\\f5ad";
}

.la-pen-square:before {
  content: "\\f14b";
}

.la-pencil-alt:before {
  content: "\\f303";
}

.la-pencil-ruler:before {
  content: "\\f5ae";
}

.la-penny-arcade:before {
  content: "\\f704";
}

.la-people-carry:before {
  content: "\\f4ce";
}

.la-pepper-hot:before {
  content: "\\f816";
}

.la-percent:before {
  content: "\\f295";
}

.la-percentage:before {
  content: "\\f541";
}

.la-periscope:before {
  content: "\\f3da";
}

.la-person-booth:before {
  content: "\\f756";
}

.la-phabricator:before {
  content: "\\f3db";
}

.la-phoenix-framework:before {
  content: "\\f3dc";
}

.la-phoenix-squadron:before {
  content: "\\f511";
}

.la-phone:before {
  content: "\\f095";
}

.la-phone-alt:before {
  content: "\\f879";
}

.la-phone-slash:before {
  content: "\\f3dd";
}

.la-phone-square:before {
  content: "\\f098";
}

.la-phone-square-alt:before {
  content: "\\f87b";
}

.la-phone-volume:before {
  content: "\\f2a0";
}

.la-photo-video:before {
  content: "\\f87c";
}

.la-php:before {
  content: "\\f457";
}

.la-pied-piper:before {
  content: "\\f2ae";
}

.la-pied-piper-alt:before {
  content: "\\f1a8";
}

.la-pied-piper-hat:before {
  content: "\\f4e5";
}

.la-pied-piper-pp:before {
  content: "\\f1a7";
}

.la-piggy-bank:before {
  content: "\\f4d3";
}

.la-pills:before {
  content: "\\f484";
}

.la-pinterest:before {
  content: "\\f0d2";
}

.la-pinterest-p:before {
  content: "\\f231";
}

.la-pinterest-square:before {
  content: "\\f0d3";
}

.la-pizza-slice:before {
  content: "\\f818";
}

.la-place-of-worship:before {
  content: "\\f67f";
}

.la-plane:before {
  content: "\\f072";
}

.la-plane-arrival:before {
  content: "\\f5af";
}

.la-plane-departure:before {
  content: "\\f5b0";
}

.la-play:before {
  content: "\\f04b";
}

.la-play-circle:before {
  content: "\\f144";
}

.la-playstation:before {
  content: "\\f3df";
}

.la-plug:before {
  content: "\\f1e6";
}

.la-plus:before {
  content: "\\f067";
}

.la-plus-circle:before {
  content: "\\f055";
}

.la-plus-square:before {
  content: "\\f0fe";
}

.la-podcast:before {
  content: "\\f2ce";
}

.la-poll:before {
  content: "\\f681";
}

.la-poll-h:before {
  content: "\\f682";
}

.la-poo:before {
  content: "\\f2fe";
}

.la-poo-storm:before {
  content: "\\f75a";
}

.la-poop:before {
  content: "\\f619";
}

.la-portrait:before {
  content: "\\f3e0";
}

.la-pound-sign:before {
  content: "\\f154";
}

.la-power-off:before {
  content: "\\f011";
}

.la-pray:before {
  content: "\\f683";
}

.la-praying-hands:before {
  content: "\\f684";
}

.la-prescription:before {
  content: "\\f5b1";
}

.la-prescription-bottle:before {
  content: "\\f485";
}

.la-prescription-bottle-alt:before {
  content: "\\f486";
}

.la-print:before {
  content: "\\f02f";
}

.la-procedures:before {
  content: "\\f487";
}

.la-product-hunt:before {
  content: "\\f288";
}

.la-project-diagram:before {
  content: "\\f542";
}

.la-pushed:before {
  content: "\\f3e1";
}

.la-puzzle-piece:before {
  content: "\\f12e";
}

.la-python:before {
  content: "\\f3e2";
}

.la-qq:before {
  content: "\\f1d6";
}

.la-qrcode:before {
  content: "\\f029";
}

.la-question:before {
  content: "\\f128";
}

.la-question-circle:before {
  content: "\\f059";
}

.la-quidditch:before {
  content: "\\f458";
}

.la-quinscape:before {
  content: "\\f459";
}

.la-quora:before {
  content: "\\f2c4";
}

.la-quote-left:before {
  content: "\\f10d";
}

.la-quote-right:before {
  content: "\\f10e";
}

.la-quran:before {
  content: "\\f687";
}

.la-r-project:before {
  content: "\\f4f7";
}

.la-radiation:before {
  content: "\\f7b9";
}

.la-radiation-alt:before {
  content: "\\f7ba";
}

.la-rainbow:before {
  content: "\\f75b";
}

.la-random:before {
  content: "\\f074";
}

.la-raspberry-pi:before {
  content: "\\f7bb";
}

.la-ravelry:before {
  content: "\\f2d9";
}

.la-react:before {
  content: "\\f41b";
}

.la-reacteurope:before {
  content: "\\f75d";
}

.la-readme:before {
  content: "\\f4d5";
}

.la-rebel:before {
  content: "\\f1d0";
}

.la-receipt:before {
  content: "\\f543";
}

.la-record-vinyl:before {
  content: "\\f8d9";
}

.la-recycle:before {
  content: "\\f1b8";
}

.la-red-river:before {
  content: "\\f3e3";
}

.la-reddit:before {
  content: "\\f1a1";
}

.la-reddit-alien:before {
  content: "\\f281";
}

.la-reddit-square:before {
  content: "\\f1a2";
}

.la-redhat:before {
  content: "\\f7bc";
}

.la-redo:before {
  content: "\\f01e";
}

.la-redo-alt:before {
  content: "\\f2f9";
}

.la-registered:before {
  content: "\\f25d";
}

.la-remove-format:before {
  content: "\\f87d";
}

.la-renren:before {
  content: "\\f18b";
}

.la-reply:before {
  content: "\\f3e5";
}

.la-reply-all:before {
  content: "\\f122";
}

.la-replyd:before {
  content: "\\f3e6";
}

.la-republican:before {
  content: "\\f75e";
}

.la-researchgate:before {
  content: "\\f4f8";
}

.la-resolving:before {
  content: "\\f3e7";
}

.la-restroom:before {
  content: "\\f7bd";
}

.la-retweet:before {
  content: "\\f079";
}

.la-rev:before {
  content: "\\f5b2";
}

.la-ribbon:before {
  content: "\\f4d6";
}

.la-ring:before {
  content: "\\f70b";
}

.la-road:before {
  content: "\\f018";
}

.la-robot:before {
  content: "\\f544";
}

.la-rocket:before {
  content: "\\f135";
}

.la-rocketchat:before {
  content: "\\f3e8";
}

.la-rockrms:before {
  content: "\\f3e9";
}

.la-route:before {
  content: "\\f4d7";
}

.la-rss:before {
  content: "\\f09e";
}

.la-rss-square:before {
  content: "\\f143";
}

.la-ruble-sign:before {
  content: "\\f158";
}

.la-ruler:before {
  content: "\\f545";
}

.la-ruler-combined:before {
  content: "\\f546";
}

.la-ruler-horizontal:before {
  content: "\\f547";
}

.la-ruler-vertical:before {
  content: "\\f548";
}

.la-running:before {
  content: "\\f70c";
}

.la-rupee-sign:before {
  content: "\\f156";
}

.la-sad-cry:before {
  content: "\\f5b3";
}

.la-sad-tear:before {
  content: "\\f5b4";
}

.la-safari:before {
  content: "\\f267";
}

.la-salesforce:before {
  content: "\\f83b";
}

.la-sass:before {
  content: "\\f41e";
}

.la-satellite:before {
  content: "\\f7bf";
}

.la-satellite-dish:before {
  content: "\\f7c0";
}

.la-save:before {
  content: "\\f0c7";
}

.la-schlix:before {
  content: "\\f3ea";
}

.la-school:before {
  content: "\\f549";
}

.la-screwdriver:before {
  content: "\\f54a";
}

.la-scribd:before {
  content: "\\f28a";
}

.la-scroll:before {
  content: "\\f70e";
}

.la-sd-card:before {
  content: "\\f7c2";
}

.la-search:before {
  content: "\\f002";
}

.la-search-dollar:before {
  content: "\\f688";
}

.la-search-location:before {
  content: "\\f689";
}

.la-search-minus:before {
  content: "\\f010";
}

.la-search-plus:before {
  content: "\\f00e";
}

.la-searchengin:before {
  content: "\\f3eb";
}

.la-seedling:before {
  content: "\\f4d8";
}

.la-sellcast:before {
  content: "\\f2da";
}

.la-sellsy:before {
  content: "\\f213";
}

.la-server:before {
  content: "\\f233";
}

.la-servicestack:before {
  content: "\\f3ec";
}

.la-shapes:before {
  content: "\\f61f";
}

.la-share:before {
  content: "\\f064";
}

.la-share-alt:before {
  content: "\\f1e0";
}

.la-share-alt-square:before {
  content: "\\f1e1";
}

.la-share-square:before {
  content: "\\f14d";
}

.la-shekel-sign:before {
  content: "\\f20b";
}

.la-shield-alt:before {
  content: "\\f3ed";
}

.la-ship:before {
  content: "\\f21a";
}

.la-shipping-fast:before {
  content: "\\f48b";
}

.la-shirtsinbulk:before {
  content: "\\f214";
}

.la-shoe-prints:before {
  content: "\\f54b";
}

.la-shopping-bag:before {
  content: "\\f290";
}

.la-shopping-basket:before {
  content: "\\f291";
}

.la-shopping-cart:before {
  content: "\\f07a";
}

.la-shopware:before {
  content: "\\f5b5";
}

.la-shower:before {
  content: "\\f2cc";
}

.la-shuttle-van:before {
  content: "\\f5b6";
}

.la-sign:before {
  content: "\\f4d9";
}

.la-sign-in-alt:before {
  content: "\\f2f6";
}

.la-sign-language:before {
  content: "\\f2a7";
}

.la-sign-out-alt:before {
  content: "\\f2f5";
}

.la-signal:before {
  content: "\\f012";
}

.la-signature:before {
  content: "\\f5b7";
}

.la-sim-card:before {
  content: "\\f7c4";
}

.la-simplybuilt:before {
  content: "\\f215";
}

.la-sistrix:before {
  content: "\\f3ee";
}

.la-sitemap:before {
  content: "\\f0e8";
}

.la-sith:before {
  content: "\\f512";
}

.la-skating:before {
  content: "\\f7c5";
}

.la-sketch:before {
  content: "\\f7c6";
}

.la-skiing:before {
  content: "\\f7c9";
}

.la-skiing-nordic:before {
  content: "\\f7ca";
}

.la-skull:before {
  content: "\\f54c";
}

.la-skull-crossbones:before {
  content: "\\f714";
}

.la-skyatlas:before {
  content: "\\f216";
}

.la-skype:before {
  content: "\\f17e";
}

.la-slack:before {
  content: "\\f198";
}

.la-slack-hash:before {
  content: "\\f3ef";
}

.la-slash:before {
  content: "\\f715";
}

.la-sleigh:before {
  content: "\\f7cc";
}

.la-sliders-h:before {
  content: "\\f1de";
}

.la-slideshare:before {
  content: "\\f1e7";
}

.la-smile:before {
  content: "\\f118";
}

.la-smile-beam:before {
  content: "\\f5b8";
}

.la-smile-wink:before {
  content: "\\f4da";
}

.la-smog:before {
  content: "\\f75f";
}

.la-smoking:before {
  content: "\\f48d";
}

.la-smoking-ban:before {
  content: "\\f54d";
}

.la-sms:before {
  content: "\\f7cd";
}

.la-snapchat:before {
  content: "\\f2ab";
}

.la-snapchat-ghost:before {
  content: "\\f2ac";
}

.la-snapchat-square:before {
  content: "\\f2ad";
}

.la-snowboarding:before {
  content: "\\f7ce";
}

.la-snowflake:before {
  content: "\\f2dc";
}

.la-snowman:before {
  content: "\\f7d0";
}

.la-snowplow:before {
  content: "\\f7d2";
}

.la-socks:before {
  content: "\\f696";
}

.la-solar-panel:before {
  content: "\\f5ba";
}

.la-sort:before {
  content: "\\f0dc";
}

.la-sort-alpha-down:before {
  content: "\\f15d";
}

.la-sort-alpha-down-alt:before {
  content: "\\f881";
}

.la-sort-alpha-up:before {
  content: "\\f15e";
}

.la-sort-alpha-up-alt:before {
  content: "\\f882";
}

.la-sort-amount-down:before {
  content: "\\f160";
}

.la-sort-amount-down-alt:before {
  content: "\\f884";
}

.la-sort-amount-up:before {
  content: "\\f161";
}

.la-sort-amount-up-alt:before {
  content: "\\f885";
}

.la-sort-down:before {
  content: "\\f0dd";
}

.la-sort-numeric-down:before {
  content: "\\f162";
}

.la-sort-numeric-down-alt:before {
  content: "\\f886";
}

.la-sort-numeric-up:before {
  content: "\\f163";
}

.la-sort-numeric-up-alt:before {
  content: "\\f887";
}

.la-sort-up:before {
  content: "\\f0de";
}

.la-soundcloud:before {
  content: "\\f1be";
}

.la-sourcetree:before {
  content: "\\f7d3";
}

.la-spa:before {
  content: "\\f5bb";
}

.la-space-shuttle:before {
  content: "\\f197";
}

.la-speakap:before {
  content: "\\f3f3";
}

.la-speaker-deck:before {
  content: "\\f83c";
}

.la-spell-check:before {
  content: "\\f891";
}

.la-spider:before {
  content: "\\f717";
}

.la-spinner:before {
  content: "\\f110";
}

.la-splotch:before {
  content: "\\f5bc";
}

.la-spotify:before {
  content: "\\f1bc";
}

.la-spray-can:before {
  content: "\\f5bd";
}

.la-square:before {
  content: "\\f0c8";
}

.la-square-full:before {
  content: "\\f45c";
}

.la-square-root-alt:before {
  content: "\\f698";
}

.la-squarespace:before {
  content: "\\f5be";
}

.la-stack-exchange:before {
  content: "\\f18d";
}

.la-stack-overflow:before {
  content: "\\f16c";
}

.la-stackpath:before {
  content: "\\f842";
}

.la-stamp:before {
  content: "\\f5bf";
}

.la-star:before {
  content: "\\f005";
}

.la-star-and-crescent:before {
  content: "\\f699";
}

.la-star-half:before {
  content: "\\f089";
}

.la-star-half-alt:before {
  content: "\\f5c0";
}

.la-star-of-david:before {
  content: "\\f69a";
}

.la-star-of-life:before {
  content: "\\f621";
}

.la-staylinked:before {
  content: "\\f3f5";
}

.la-steam:before {
  content: "\\f1b6";
}

.la-steam-square:before {
  content: "\\f1b7";
}

.la-steam-symbol:before {
  content: "\\f3f6";
}

.la-step-backward:before {
  content: "\\f048";
}

.la-step-forward:before {
  content: "\\f051";
}

.la-stethoscope:before {
  content: "\\f0f1";
}

.la-sticker-mule:before {
  content: "\\f3f7";
}

.la-sticky-note:before {
  content: "\\f249";
}

.la-stop:before {
  content: "\\f04d";
}

.la-stop-circle:before {
  content: "\\f28d";
}

.la-stopwatch:before {
  content: "\\f2f2";
}

.la-store:before {
  content: "\\f54e";
}

.la-store-alt:before {
  content: "\\f54f";
}

.la-strava:before {
  content: "\\f428";
}

.la-stream:before {
  content: "\\f550";
}

.la-street-view:before {
  content: "\\f21d";
}

.la-strikethrough:before {
  content: "\\f0cc";
}

.la-stripe:before {
  content: "\\f429";
}

.la-stripe-s:before {
  content: "\\f42a";
}

.la-stroopwafel:before {
  content: "\\f551";
}

.la-studiovinari:before {
  content: "\\f3f8";
}

.la-stumbleupon:before {
  content: "\\f1a4";
}

.la-stumbleupon-circle:before {
  content: "\\f1a3";
}

.la-subscript:before {
  content: "\\f12c";
}

.la-subway:before {
  content: "\\f239";
}

.la-suitcase:before {
  content: "\\f0f2";
}

.la-suitcase-rolling:before {
  content: "\\f5c1";
}

.la-sun:before {
  content: "\\f185";
}

.la-superpowers:before {
  content: "\\f2dd";
}

.la-superscript:before {
  content: "\\f12b";
}

.la-supple:before {
  content: "\\f3f9";
}

.la-surprise:before {
  content: "\\f5c2";
}

.la-suse:before {
  content: "\\f7d6";
}

.la-swatchbook:before {
  content: "\\f5c3";
}

.la-swift:before {
  content: "\\f8e1";
}

.la-swimmer:before {
  content: "\\f5c4";
}

.la-swimming-pool:before {
  content: "\\f5c5";
}

.la-symfony:before {
  content: "\\f83d";
}

.la-synagogue:before {
  content: "\\f69b";
}

.la-sync:before {
  content: "\\f021";
}

.la-sync-alt:before {
  content: "\\f2f1";
}

.la-syringe:before {
  content: "\\f48e";
}

.la-table:before {
  content: "\\f0ce";
}

.la-table-tennis:before {
  content: "\\f45d";
}

.la-tablet:before {
  content: "\\f10a";
}

.la-tablet-alt:before {
  content: "\\f3fa";
}

.la-tablets:before {
  content: "\\f490";
}

.la-tachometer-alt:before {
  content: "\\f3fd";
}

.la-tag:before {
  content: "\\f02b";
}

.la-tags:before {
  content: "\\f02c";
}

.la-tape:before {
  content: "\\f4db";
}

.la-tasks:before {
  content: "\\f0ae";
}

.la-taxi:before {
  content: "\\f1ba";
}

.la-teamspeak:before {
  content: "\\f4f9";
}

.la-teeth:before {
  content: "\\f62e";
}

.la-teeth-open:before {
  content: "\\f62f";
}

.la-telegram:before {
  content: "\\f2c6";
}

.la-telegram-plane:before {
  content: "\\f3fe";
}

.la-temperature-high:before {
  content: "\\f769";
}

.la-temperature-low:before {
  content: "\\f76b";
}

.la-tencent-weibo:before {
  content: "\\f1d5";
}

.la-tenge:before {
  content: "\\f7d7";
}

.la-terminal:before {
  content: "\\f120";
}

.la-text-height:before {
  content: "\\f034";
}

.la-text-width:before {
  content: "\\f035";
}

.la-th:before {
  content: "\\f00a";
}

.la-th-large:before {
  content: "\\f009";
}

.la-th-list:before {
  content: "\\f00b";
}

.la-the-red-yeti:before {
  content: "\\f69d";
}

.la-theater-masks:before {
  content: "\\f630";
}

.la-themeco:before {
  content: "\\f5c6";
}

.la-themeisle:before {
  content: "\\f2b2";
}

.la-thermometer:before {
  content: "\\f491";
}

.la-thermometer-empty:before {
  content: "\\f2cb";
}

.la-thermometer-full:before {
  content: "\\f2c7";
}

.la-thermometer-half:before {
  content: "\\f2c9";
}

.la-thermometer-quarter:before {
  content: "\\f2ca";
}

.la-thermometer-three-quarters:before {
  content: "\\f2c8";
}

.la-think-peaks:before {
  content: "\\f731";
}

.la-thumbs-down:before {
  content: "\\f165";
}

.la-thumbs-up:before {
  content: "\\f164";
}

.la-thumbtack:before {
  content: "\\f08d";
}

.la-ticket-alt:before {
  content: "\\f3ff";
}

.la-times:before {
  content: "\\f00d";
}

.la-times-circle:before {
  content: "\\f057";
}

.la-tint:before {
  content: "\\f043";
}

.la-tint-slash:before {
  content: "\\f5c7";
}

.la-tired:before {
  content: "\\f5c8";
}

.la-toggle-off:before {
  content: "\\f204";
}

.la-toggle-on:before {
  content: "\\f205";
}

.la-toilet:before {
  content: "\\f7d8";
}

.la-toilet-paper:before {
  content: "\\f71e";
}

.la-toolbox:before {
  content: "\\f552";
}

.la-tools:before {
  content: "\\f7d9";
}

.la-tooth:before {
  content: "\\f5c9";
}

.la-torah:before {
  content: "\\f6a0";
}

.la-torii-gate:before {
  content: "\\f6a1";
}

.la-tractor:before {
  content: "\\f722";
}

.la-trade-federation:before {
  content: "\\f513";
}

.la-trademark:before {
  content: "\\f25c";
}

.la-traffic-light:before {
  content: "\\f637";
}

.la-train:before {
  content: "\\f238";
}

.la-tram:before {
  content: "\\f7da";
}

.la-transgender:before {
  content: "\\f224";
}

.la-transgender-alt:before {
  content: "\\f225";
}

.la-trash:before {
  content: "\\f1f8";
}

.la-trash-alt:before {
  content: "\\f2ed";
}

.la-trash-restore:before {
  content: "\\f829";
}

.la-trash-restore-alt:before {
  content: "\\f82a";
}

.la-tree:before {
  content: "\\f1bb";
}

.la-trello:before {
  content: "\\f181";
}

.la-tripadvisor:before {
  content: "\\f262";
}

.la-trophy:before {
  content: "\\f091";
}

.la-truck:before {
  content: "\\f0d1";
}

.la-truck-loading:before {
  content: "\\f4de";
}

.la-truck-monster:before {
  content: "\\f63b";
}

.la-truck-moving:before {
  content: "\\f4df";
}

.la-truck-pickup:before {
  content: "\\f63c";
}

.la-tshirt:before {
  content: "\\f553";
}

.la-tty:before {
  content: "\\f1e4";
}

.la-tumblr:before {
  content: "\\f173";
}

.la-tumblr-square:before {
  content: "\\f174";
}

.la-tv:before {
  content: "\\f26c";
}

.la-twitch:before {
  content: "\\f1e8";
}

.la-twitter:before {
  content: "\\f099";
}

.la-twitter-square:before {
  content: "\\f081";
}

.la-typo3:before {
  content: "\\f42b";
}

.la-uber:before {
  content: "\\f402";
}

.la-ubuntu:before {
  content: "\\f7df";
}

.la-uikit:before {
  content: "\\f403";
}

.la-umbraco:before {
  content: "\\f8e8";
}

.la-umbrella:before {
  content: "\\f0e9";
}

.la-umbrella-beach:before {
  content: "\\f5ca";
}

.la-underline:before {
  content: "\\f0cd";
}

.la-undo:before {
  content: "\\f0e2";
}

.la-undo-alt:before {
  content: "\\f2ea";
}

.la-uniregistry:before {
  content: "\\f404";
}

.la-universal-access:before {
  content: "\\f29a";
}

.la-university:before {
  content: "\\f19c";
}

.la-unlink:before {
  content: "\\f127";
}

.la-unlock:before {
  content: "\\f09c";
}

.la-unlock-alt:before {
  content: "\\f13e";
}

.la-untappd:before {
  content: "\\f405";
}

.la-upload:before {
  content: "\\f093";
}

.la-ups:before {
  content: "\\f7e0";
}

.la-usb:before {
  content: "\\f287";
}

.la-user:before {
  content: "\\f007";
}

.la-user-alt:before {
  content: "\\f406";
}

.la-user-alt-slash:before {
  content: "\\f4fa";
}

.la-user-astronaut:before {
  content: "\\f4fb";
}

.la-user-check:before {
  content: "\\f4fc";
}

.la-user-circle:before {
  content: "\\f2bd";
}

.la-user-clock:before {
  content: "\\f4fd";
}

.la-user-cog:before {
  content: "\\f4fe";
}

.la-user-edit:before {
  content: "\\f4ff";
}

.la-user-friends:before {
  content: "\\f500";
}

.la-user-graduate:before {
  content: "\\f501";
}

.la-user-injured:before {
  content: "\\f728";
}

.la-user-lock:before {
  content: "\\f502";
}

.la-user-md:before {
  content: "\\f0f0";
}

.la-user-minus:before {
  content: "\\f503";
}

.la-user-ninja:before {
  content: "\\f504";
}

.la-user-nurse:before {
  content: "\\f82f";
}

.la-user-plus:before {
  content: "\\f234";
}

.la-user-secret:before {
  content: "\\f21b";
}

.la-user-shield:before {
  content: "\\f505";
}

.la-user-slash:before {
  content: "\\f506";
}

.la-user-tag:before {
  content: "\\f507";
}

.la-user-tie:before {
  content: "\\f508";
}

.la-user-times:before {
  content: "\\f235";
}

.la-users:before {
  content: "\\f0c0";
}

.la-users-cog:before {
  content: "\\f509";
}

.la-usps:before {
  content: "\\f7e1";
}

.la-ussunnah:before {
  content: "\\f407";
}

.la-utensil-spoon:before {
  content: "\\f2e5";
}

.la-utensils:before {
  content: "\\f2e7";
}

.la-vaadin:before {
  content: "\\f408";
}

.la-vector-square:before {
  content: "\\f5cb";
}

.la-venus:before {
  content: "\\f221";
}

.la-venus-double:before {
  content: "\\f226";
}

.la-venus-mars:before {
  content: "\\f228";
}

.la-viacoin:before {
  content: "\\f237";
}

.la-viadeo:before {
  content: "\\f2a9";
}

.la-viadeo-square:before {
  content: "\\f2aa";
}

.la-vial:before {
  content: "\\f492";
}

.la-vials:before {
  content: "\\f493";
}

.la-viber:before {
  content: "\\f409";
}

.la-video:before {
  content: "\\f03d";
}

.la-video-slash:before {
  content: "\\f4e2";
}

.la-vihara:before {
  content: "\\f6a7";
}

.la-vimeo:before {
  content: "\\f40a";
}

.la-vimeo-square:before {
  content: "\\f194";
}

.la-vimeo-v:before {
  content: "\\f27d";
}

.la-vine:before {
  content: "\\f1ca";
}

.la-vk:before {
  content: "\\f189";
}

.la-vnv:before {
  content: "\\f40b";
}

.la-voicemail:before {
  content: "\\f897";
}

.la-volleyball-ball:before {
  content: "\\f45f";
}

.la-volume-down:before {
  content: "\\f027";
}

.la-volume-mute:before {
  content: "\\f6a9";
}

.la-volume-off:before {
  content: "\\f026";
}

.la-volume-up:before {
  content: "\\f028";
}

.la-vote-yea:before {
  content: "\\f772";
}

.la-vr-cardboard:before {
  content: "\\f729";
}

.la-vuejs:before {
  content: "\\f41f";
}

.la-walking:before {
  content: "\\f554";
}

.la-wallet:before {
  content: "\\f555";
}

.la-warehouse:before {
  content: "\\f494";
}

.la-water:before {
  content: "\\f773";
}

.la-wave-square:before {
  content: "\\f83e";
}

.la-waze:before {
  content: "\\f83f";
}

.la-weebly:before {
  content: "\\f5cc";
}

.la-weibo:before {
  content: "\\f18a";
}

.la-weight:before {
  content: "\\f496";
}

.la-weight-hanging:before {
  content: "\\f5cd";
}

.la-weixin:before {
  content: "\\f1d7";
}

.la-whatsapp:before {
  content: "\\f232";
}

.la-whatsapp-square:before {
  content: "\\f40c";
}

.la-wheelchair:before {
  content: "\\f193";
}

.la-whmcs:before {
  content: "\\f40d";
}

.la-wifi:before {
  content: "\\f1eb";
}

.la-wikipedia-w:before {
  content: "\\f266";
}

.la-wind:before {
  content: "\\f72e";
}

.la-window-close:before {
  content: "\\f410";
}

.la-window-maximize:before {
  content: "\\f2d0";
}

.la-window-minimize:before {
  content: "\\f2d1";
}

.la-window-restore:before {
  content: "\\f2d2";
}

.la-windows:before {
  content: "\\f17a";
}

.la-wine-bottle:before {
  content: "\\f72f";
}

.la-wine-glass:before {
  content: "\\f4e3";
}

.la-wine-glass-alt:before {
  content: "\\f5ce";
}

.la-wix:before {
  content: "\\f5cf";
}

.la-wizards-of-the-coast:before {
  content: "\\f730";
}

.la-wolf-pack-battalion:before {
  content: "\\f514";
}

.la-won-sign:before {
  content: "\\f159";
}

.la-wordpress:before {
  content: "\\f19a";
}

.la-wordpress-simple:before {
  content: "\\f411";
}

.la-wpbeginner:before {
  content: "\\f297";
}

.la-wpexplorer:before {
  content: "\\f2de";
}

.la-wpforms:before {
  content: "\\f298";
}

.la-wpressr:before {
  content: "\\f3e4";
}

.la-wrench:before {
  content: "\\f0ad";
}

.la-x-ray:before {
  content: "\\f497";
}

.la-xbox:before {
  content: "\\f412";
}

.la-xing:before {
  content: "\\f168";
}

.la-xing-square:before {
  content: "\\f169";
}

.la-y-combinator:before {
  content: "\\f23b";
}

.la-yahoo:before {
  content: "\\f19e";
}

.la-yammer:before {
  content: "\\f840";
}

.la-yandex:before {
  content: "\\f413";
}

.la-yandex-international:before {
  content: "\\f414";
}

.la-yarn:before {
  content: "\\f7e3";
}

.la-yelp:before {
  content: "\\f1e9";
}

.la-yen-sign:before {
  content: "\\f157";
}

.la-yin-yang:before {
  content: "\\f6ad";
}

.la-yoast:before {
  content: "\\f2b1";
}

.la-youtube:before {
  content: "\\f167";
}

.la-youtube-square:before {
  content: "\\f431";
}

.la-zhihu:before {
  content: "\\f63f";
}

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto;
}

@font-face {
  font-family: "Line Awesome Brands";
  font-style: normal;
  font-weight: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg");
}
.lab {
  font-family: "Line Awesome Brands";
}

@font-face {
  font-family: "Line Awesome Free";
  font-style: normal;
  font-weight: 400;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("svg");
}
.lar {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

@font-face {
  font-family: "Line Awesome Free";
  font-style: normal;
  font-weight: 900;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg");
}
.la,
.las {
  font-family: "Line Awesome Free";
  font-weight: 900;
}

.la.la-glass:before {
  content: "\\f000";
}

.la.la-meetup {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-star-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-o:before {
  content: "\\f005";
}

.la.la-remove:before {
  content: "\\f00d";
}

.la.la-close:before {
  content: "\\f00d";
}

.la.la-gear:before {
  content: "\\f013";
}

.la.la-trash-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-trash-o:before {
  content: "\\f2ed";
}

.la.la-file-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-o:before {
  content: "\\f15b";
}

.la.la-clock-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-clock-o:before {
  content: "\\f017";
}

.la.la-arrow-circle-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-down:before {
  content: "\\f358";
}

.la.la-arrow-circle-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-up:before {
  content: "\\f35b";
}

.la.la-play-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-play-circle-o:before {
  content: "\\f144";
}

.la.la-repeat:before {
  content: "\\f01e";
}

.la.la-rotate-right:before {
  content: "\\f01e";
}

.la.la-refresh:before {
  content: "\\f021";
}

.la.la-list-alt {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-dedent:before {
  content: "\\f03b";
}

.la.la-video-camera:before {
  content: "\\f03d";
}

.la.la-picture-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-picture-o:before {
  content: "\\f03e";
}

.la.la-photo {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-photo:before {
  content: "\\f03e";
}

.la.la-image {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-image:before {
  content: "\\f03e";
}

.la.la-pencil:before {
  content: "\\f303";
}

.la.la-map-marker:before {
  content: "\\f3c5";
}

.la.la-pencil-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-pencil-square-o:before {
  content: "\\f044";
}

.la.la-share-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-share-square-o:before {
  content: "\\f14d";
}

.la.la-check-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-check-square-o:before {
  content: "\\f14a";
}

.la.la-arrows:before {
  content: "\\f0b2";
}

.la.la-times-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-times-circle-o:before {
  content: "\\f057";
}

.la.la-check-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-check-circle-o:before {
  content: "\\f058";
}

.la.la-mail-forward:before {
  content: "\\f064";
}

.la.la-eye {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-eye-slash {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-warning:before {
  content: "\\f071";
}

.la.la-calendar:before {
  content: "\\f073";
}

.la.la-arrows-v:before {
  content: "\\f338";
}

.la.la-arrows-h:before {
  content: "\\f337";
}

.la.la-bar-chart {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bar-chart:before {
  content: "\\f080";
}

.la.la-bar-chart-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bar-chart-o:before {
  content: "\\f080";
}

.la.la-twitter-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gears:before {
  content: "\\f085";
}

.la.la-thumbs-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-thumbs-o-up:before {
  content: "\\f164";
}

.la.la-thumbs-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-thumbs-o-down:before {
  content: "\\f165";
}

.la.la-heart-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-heart-o:before {
  content: "\\f004";
}

.la.la-sign-out:before {
  content: "\\f2f5";
}

.la.la-linkedin-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-linkedin-square:before {
  content: "\\f08c";
}

.la.la-thumb-tack:before {
  content: "\\f08d";
}

.la.la-external-link:before {
  content: "\\f35d";
}

.la.la-sign-in:before {
  content: "\\f2f6";
}

.la.la-github-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-lemon-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-lemon-o:before {
  content: "\\f094";
}

.la.la-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-square-o:before {
  content: "\\f0c8";
}

.la.la-bookmark-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bookmark-o:before {
  content: "\\f02e";
}

.la.la-twitter {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook:before {
  content: "\\f39e";
}

.la.la-facebook-f {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook-f:before {
  content: "\\f39e";
}

.la.la-github {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-credit-card {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-feed:before {
  content: "\\f09e";
}

.la.la-hdd-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hdd-o:before {
  content: "\\f0a0";
}

.la.la-hand-o-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-right:before {
  content: "\\f0a4";
}

.la.la-hand-o-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-left:before {
  content: "\\f0a5";
}

.la.la-hand-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-up:before {
  content: "\\f0a6";
}

.la.la-hand-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-o-down:before {
  content: "\\f0a7";
}

.la.la-arrows-alt:before {
  content: "\\f31e";
}

.la.la-group:before {
  content: "\\f0c0";
}

.la.la-chain:before {
  content: "\\f0c1";
}

.la.la-scissors:before {
  content: "\\f0c4";
}

.la.la-files-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-files-o:before {
  content: "\\f0c5";
}

.la.la-floppy-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-floppy-o:before {
  content: "\\f0c7";
}

.la.la-navicon:before {
  content: "\\f0c9";
}

.la.la-reorder:before {
  content: "\\f0c9";
}

.la.la-pinterest {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pinterest-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus:before {
  content: "\\f0d5";
}

.la.la-money {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-money:before {
  content: "\\f3d1";
}

.la.la-unsorted:before {
  content: "\\f0dc";
}

.la.la-sort-desc:before {
  content: "\\f0dd";
}

.la.la-sort-asc:before {
  content: "\\f0de";
}

.la.la-linkedin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-linkedin:before {
  content: "\\f0e1";
}

.la.la-rotate-left:before {
  content: "\\f0e2";
}

.la.la-legal:before {
  content: "\\f0e3";
}

.la.la-tachometer:before {
  content: "\\f3fd";
}

.la.la-dashboard:before {
  content: "\\f3fd";
}

.la.la-comment-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-comment-o:before {
  content: "\\f075";
}

.la.la-comments-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-comments-o:before {
  content: "\\f086";
}

.la.la-flash:before {
  content: "\\f0e7";
}

.la.la-clipboard {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-paste {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-paste:before {
  content: "\\f328";
}

.la.la-lightbulb-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-lightbulb-o:before {
  content: "\\f0eb";
}

.la.la-exchange:before {
  content: "\\f362";
}

.la.la-cloud-download:before {
  content: "\\f381";
}

.la.la-cloud-upload:before {
  content: "\\f382";
}

.la.la-bell-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bell-o:before {
  content: "\\f0f3";
}

.la.la-cutlery:before {
  content: "\\f2e7";
}

.la.la-file-text-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-text-o:before {
  content: "\\f15c";
}

.la.la-building-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-building-o:before {
  content: "\\f1ad";
}

.la.la-hospital-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hospital-o:before {
  content: "\\f0f8";
}

.la.la-tablet:before {
  content: "\\f3fa";
}

.la.la-mobile:before {
  content: "\\f3cd";
}

.la.la-mobile-phone:before {
  content: "\\f3cd";
}

.la.la-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-circle-o:before {
  content: "\\f111";
}

.la.la-mail-reply:before {
  content: "\\f3e5";
}

.la.la-github-alt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-folder-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-folder-o:before {
  content: "\\f07b";
}

.la.la-folder-open-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-folder-open-o:before {
  content: "\\f07c";
}

.la.la-smile-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-smile-o:before {
  content: "\\f118";
}

.la.la-frown-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-frown-o:before {
  content: "\\f119";
}

.la.la-meh-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-meh-o:before {
  content: "\\f11a";
}

.la.la-keyboard-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-keyboard-o:before {
  content: "\\f11c";
}

.la.la-flag-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-flag-o:before {
  content: "\\f024";
}

.la.la-mail-reply-all:before {
  content: "\\f122";
}

.la.la-star-half-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-half-o:before {
  content: "\\f089";
}

.la.la-star-half-empty {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-half-empty:before {
  content: "\\f089";
}

.la.la-star-half-full {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-star-half-full:before {
  content: "\\f089";
}

.la.la-code-fork:before {
  content: "\\f126";
}

.la.la-chain-broken:before {
  content: "\\f127";
}

.la.la-shield:before {
  content: "\\f3ed";
}

.la.la-calendar-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-o:before {
  content: "\\f133";
}

.la.la-maxcdn {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-html5 {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-css3 {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ticket:before {
  content: "\\f3ff";
}

.la.la-minus-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-minus-square-o:before {
  content: "\\f146";
}

.la.la-level-up:before {
  content: "\\f3bf";
}

.la.la-level-down:before {
  content: "\\f3be";
}

.la.la-pencil-square:before {
  content: "\\f14b";
}

.la.la-external-link-square:before {
  content: "\\f360";
}

.la.la-compass {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-down:before {
  content: "\\f150";
}

.la.la-toggle-down {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-down:before {
  content: "\\f150";
}

.la.la-caret-square-o-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-up:before {
  content: "\\f151";
}

.la.la-toggle-up {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-up:before {
  content: "\\f151";
}

.la.la-caret-square-o-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-right:before {
  content: "\\f152";
}

.la.la-toggle-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-right:before {
  content: "\\f152";
}

.la.la-eur:before {
  content: "\\f153";
}

.la.la-euro:before {
  content: "\\f153";
}

.la.la-gbp:before {
  content: "\\f154";
}

.la.la-usd:before {
  content: "\\f155";
}

.la.la-dollar:before {
  content: "\\f155";
}

.la.la-inr:before {
  content: "\\f156";
}

.la.la-rupee:before {
  content: "\\f156";
}

.la.la-jpy:before {
  content: "\\f157";
}

.la.la-cny:before {
  content: "\\f157";
}

.la.la-rmb:before {
  content: "\\f157";
}

.la.la-yen:before {
  content: "\\f157";
}

.la.la-rub:before {
  content: "\\f158";
}

.la.la-ruble:before {
  content: "\\f158";
}

.la.la-rouble:before {
  content: "\\f158";
}

.la.la-krw:before {
  content: "\\f159";
}

.la.la-won:before {
  content: "\\f159";
}

.la.la-btc {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitcoin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitcoin:before {
  content: "\\f15a";
}

.la.la-file-text:before {
  content: "\\f15c";
}

.la.la-sort-alpha-asc:before {
  content: "\\f15d";
}

.la.la-sort-alpha-desc:before {
  content: "\\f881";
}

.la.la-sort-amount-asc:before {
  content: "\\f160";
}

.la.la-sort-amount-desc:before {
  content: "\\f884";
}

.la.la-sort-numeric-asc:before {
  content: "\\f162";
}

.la.la-sort-numeric-desc:before {
  content: "\\f886";
}

.la.la-youtube-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-youtube {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-xing {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-xing-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-youtube-play {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-youtube-play:before {
  content: "\\f167";
}

.la.la-dropbox {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stack-overflow {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-instagram {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-flickr {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-adn {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitbucket {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitbucket-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bitbucket-square:before {
  content: "\\f171";
}

.la.la-tumblr {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-tumblr-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-long-arrow-down:before {
  content: "\\f309";
}

.la.la-long-arrow-up:before {
  content: "\\f30c";
}

.la.la-long-arrow-left:before {
  content: "\\f30a";
}

.la.la-long-arrow-right:before {
  content: "\\f30b";
}

.la.la-apple {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-windows {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-android {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-linux {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-dribbble {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-skype {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-foursquare {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-trello {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gratipay {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gittip {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gittip:before {
  content: "\\f184";
}

.la.la-sun-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-sun-o:before {
  content: "\\f185";
}

.la.la-moon-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-moon-o:before {
  content: "\\f186";
}

.la.la-vk {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-weibo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-renren {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pagelines {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stack-exchange {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-arrow-circle-o-right {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-right:before {
  content: "\\f35a";
}

.la.la-arrow-circle-o-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-arrow-circle-o-left:before {
  content: "\\f359";
}

.la.la-caret-square-o-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-caret-square-o-left:before {
  content: "\\f191";
}

.la.la-toggle-left {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-toggle-left:before {
  content: "\\f191";
}

.la.la-dot-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-dot-circle-o:before {
  content: "\\f192";
}

.la.la-vimeo-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-try:before {
  content: "\\f195";
}

.la.la-turkish-lira:before {
  content: "\\f195";
}

.la.la-plus-square-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-plus-square-o:before {
  content: "\\f0fe";
}

.la.la-slack {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wordpress {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-openid {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-institution:before {
  content: "\\f19c";
}

.la.la-bank:before {
  content: "\\f19c";
}

.la.la-mortar-board:before {
  content: "\\f19d";
}

.la.la-yahoo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-reddit {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-reddit-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stumbleupon-circle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-stumbleupon {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-delicious {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-digg {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pied-piper-pp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pied-piper-alt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-drupal {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-joomla {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-spoon:before {
  content: "\\f2e5";
}

.la.la-behance {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-behance-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-steam {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-steam-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-automobile:before {
  content: "\\f1b9";
}

.la.la-cab:before {
  content: "\\f1ba";
}

.la.la-envelope-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-envelope-o:before {
  content: "\\f0e0";
}

.la.la-deviantart {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-soundcloud {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-file-pdf-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-pdf-o:before {
  content: "\\f1c1";
}

.la.la-file-word-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-word-o:before {
  content: "\\f1c2";
}

.la.la-file-excel-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-excel-o:before {
  content: "\\f1c3";
}

.la.la-file-powerpoint-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-powerpoint-o:before {
  content: "\\f1c4";
}

.la.la-file-image-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-image-o:before {
  content: "\\f1c5";
}

.la.la-file-photo-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-photo-o:before {
  content: "\\f1c5";
}

.la.la-file-picture-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-picture-o:before {
  content: "\\f1c5";
}

.la.la-file-archive-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-archive-o:before {
  content: "\\f1c6";
}

.la.la-file-zip-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-zip-o:before {
  content: "\\f1c6";
}

.la.la-file-audio-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-audio-o:before {
  content: "\\f1c7";
}

.la.la-file-sound-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-sound-o:before {
  content: "\\f1c7";
}

.la.la-file-video-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-video-o:before {
  content: "\\f1c8";
}

.la.la-file-movie-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-movie-o:before {
  content: "\\f1c8";
}

.la.la-file-code-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-file-code-o:before {
  content: "\\f1c9";
}

.la.la-vine {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-codepen {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-jsfiddle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-life-ring {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-bouy {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-bouy:before {
  content: "\\f1cd";
}

.la.la-life-buoy {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-buoy:before {
  content: "\\f1cd";
}

.la.la-life-saver {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-life-saver:before {
  content: "\\f1cd";
}

.la.la-support {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-support:before {
  content: "\\f1cd";
}

.la.la-circle-o-notch:before {
  content: "\\f1ce";
}

.la.la-rebel {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ra {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ra:before {
  content: "\\f1d0";
}

.la.la-resistance {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-resistance:before {
  content: "\\f1d0";
}

.la.la-empire {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ge {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ge:before {
  content: "\\f1d1";
}

.la.la-git-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-git {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-hacker-news {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-y-combinator-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-y-combinator-square:before {
  content: "\\f1d4";
}

.la.la-yc-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yc-square:before {
  content: "\\f1d4";
}

.la.la-tencent-weibo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-qq {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-weixin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wechat {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wechat:before {
  content: "\\f1d7";
}

.la.la-send:before {
  content: "\\f1d8";
}

.la.la-paper-plane-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-paper-plane-o:before {
  content: "\\f1d8";
}

.la.la-send-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-send-o:before {
  content: "\\f1d8";
}

.la.la-circle-thin {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-circle-thin:before {
  content: "\\f111";
}

.la.la-header:before {
  content: "\\f1dc";
}

.la.la-sliders:before {
  content: "\\f1de";
}

.la.la-futbol-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-futbol-o:before {
  content: "\\f1e3";
}

.la.la-soccer-ball-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-soccer-ball-o:before {
  content: "\\f1e3";
}

.la.la-slideshare {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-twitch {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yelp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-newspaper-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-newspaper-o:before {
  content: "\\f1ea";
}

.la.la-paypal {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-wallet {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-visa {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-mastercard {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-discover {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-amex {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-paypal {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-stripe {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bell-slash-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-bell-slash-o:before {
  content: "\\f1f6";
}

.la.la-trash:before {
  content: "\\f2ed";
}

.la.la-copyright {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-eyedropper:before {
  content: "\\f1fb";
}

.la.la-area-chart:before {
  content: "\\f1fe";
}

.la.la-pie-chart:before {
  content: "\\f200";
}

.la.la-line-chart:before {
  content: "\\f201";
}

.la.la-lastfm {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-lastfm-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ioxhost {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-angellist {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-cc:before {
  content: "\\f20a";
}

.la.la-ils:before {
  content: "\\f20b";
}

.la.la-shekel:before {
  content: "\\f20b";
}

.la.la-sheqel:before {
  content: "\\f20b";
}

.la.la-meanpath {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-meanpath:before {
  content: "\\f2b4";
}

.la.la-buysellads {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-connectdevelop {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-dashcube {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-forumbee {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-leanpub {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-sellsy {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-shirtsinbulk {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-simplybuilt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-skyatlas {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-diamond {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-diamond:before {
  content: "\\f3a5";
}

.la.la-intersex:before {
  content: "\\f224";
}

.la.la-facebook-official {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-facebook-official:before {
  content: "\\f09a";
}

.la.la-pinterest-p {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-whatsapp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-hotel:before {
  content: "\\f236";
}

.la.la-viacoin {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-medium {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-y-combinator {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yc {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yc:before {
  content: "\\f23b";
}

.la.la-optin-monster {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-opencart {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-expeditedssl {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-battery-4:before {
  content: "\\f240";
}

.la.la-battery:before {
  content: "\\f240";
}

.la.la-battery-3:before {
  content: "\\f241";
}

.la.la-battery-2:before {
  content: "\\f242";
}

.la.la-battery-1:before {
  content: "\\f243";
}

.la.la-battery-0:before {
  content: "\\f244";
}

.la.la-object-group {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-object-ungroup {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-sticky-note-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-sticky-note-o:before {
  content: "\\f249";
}

.la.la-cc-jcb {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-cc-diners-club {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-clone {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hourglass-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hourglass-o:before {
  content: "\\f254";
}

.la.la-hourglass-1:before {
  content: "\\f251";
}

.la.la-hourglass-2:before {
  content: "\\f252";
}

.la.la-hourglass-3:before {
  content: "\\f253";
}

.la.la-hand-rock-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-rock-o:before {
  content: "\\f255";
}

.la.la-hand-grab-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-grab-o:before {
  content: "\\f255";
}

.la.la-hand-paper-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-paper-o:before {
  content: "\\f256";
}

.la.la-hand-stop-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-stop-o:before {
  content: "\\f256";
}

.la.la-hand-scissors-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-scissors-o:before {
  content: "\\f257";
}

.la.la-hand-lizard-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-lizard-o:before {
  content: "\\f258";
}

.la.la-hand-spock-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-spock-o:before {
  content: "\\f259";
}

.la.la-hand-pointer-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-pointer-o:before {
  content: "\\f25a";
}

.la.la-hand-peace-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-hand-peace-o:before {
  content: "\\f25b";
}

.la.la-registered {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-creative-commons {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gg {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gg-circle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-tripadvisor {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-odnoklassniki {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-odnoklassniki-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-get-pocket {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wikipedia-w {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-safari {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-chrome {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-firefox {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-opera {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-internet-explorer {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-television:before {
  content: "\\f26c";
}

.la.la-contao {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-500px {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-amazon {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-calendar-plus-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-plus-o:before {
  content: "\\f271";
}

.la.la-calendar-minus-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-minus-o:before {
  content: "\\f272";
}

.la.la-calendar-times-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-times-o:before {
  content: "\\f273";
}

.la.la-calendar-check-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-calendar-check-o:before {
  content: "\\f274";
}

.la.la-map-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-map-o:before {
  content: "\\f279";
}

.la.la-commenting:before {
  content: "\\f4ad";
}

.la.la-commenting-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-commenting-o:before {
  content: "\\f4ad";
}

.la.la-houzz {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-vimeo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-vimeo:before {
  content: "\\f27d";
}

.la.la-black-tie {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fonticons {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-reddit-alien {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-edge {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-credit-card-alt:before {
  content: "\\f09d";
}

.la.la-codiepie {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-modx {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fort-awesome {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-usb {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-product-hunt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-mixcloud {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-scribd {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pause-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-pause-circle-o:before {
  content: "\\f28b";
}

.la.la-stop-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-stop-circle-o:before {
  content: "\\f28d";
}

.la.la-bluetooth {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-bluetooth-b {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-gitlab {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wpbeginner {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wpforms {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-envira {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wheelchair-alt {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wheelchair-alt:before {
  content: "\\f368";
}

.la.la-question-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-question-circle-o:before {
  content: "\\f059";
}

.la.la-volume-control-phone:before {
  content: "\\f2a0";
}

.la.la-asl-interpreting:before {
  content: "\\f2a3";
}

.la.la-deafness:before {
  content: "\\f2a4";
}

.la.la-hard-of-hearing:before {
  content: "\\f2a4";
}

.la.la-glide {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-glide-g {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-signing:before {
  content: "\\f2a7";
}

.la.la-viadeo {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-viadeo-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-snapchat {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-snapchat-ghost {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-snapchat-square {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-pied-piper {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-first-order {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-yoast {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-themeisle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-official {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-official:before {
  content: "\\f2b3";
}

.la.la-google-plus-circle {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-google-plus-circle:before {
  content: "\\f2b3";
}

.la.la-font-awesome {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fa {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-fa:before {
  content: "\\f2b4";
}

.la.la-handshake-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-handshake-o:before {
  content: "\\f2b5";
}

.la.la-envelope-open-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-envelope-open-o:before {
  content: "\\f2b6";
}

.la.la-linode {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-address-book-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-address-book-o:before {
  content: "\\f2b9";
}

.la.la-vcard:before {
  content: "\\f2bb";
}

.la.la-address-card-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-address-card-o:before {
  content: "\\f2bb";
}

.la.la-vcard-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-vcard-o:before {
  content: "\\f2bb";
}

.la.la-user-circle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-user-circle-o:before {
  content: "\\f2bd";
}

.la.la-user-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-user-o:before {
  content: "\\f007";
}

.la.la-id-badge {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-drivers-license:before {
  content: "\\f2c2";
}

.la.la-id-card-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-id-card-o:before {
  content: "\\f2c2";
}

.la.la-drivers-license-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-drivers-license-o:before {
  content: "\\f2c2";
}

.la.la-quora {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-free-code-camp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-telegram {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-thermometer-4:before {
  content: "\\f2c7";
}

.la.la-thermometer:before {
  content: "\\f2c7";
}

.la.la-thermometer-3:before {
  content: "\\f2c8";
}

.la.la-thermometer-2:before {
  content: "\\f2c9";
}

.la.la-thermometer-1:before {
  content: "\\f2ca";
}

.la.la-thermometer-0:before {
  content: "\\f2cb";
}

.la.la-bathtub:before {
  content: "\\f2cd";
}

.la.la-s15:before {
  content: "\\f2cd";
}

.la.la-window-maximize {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-window-restore {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-times-rectangle:before {
  content: "\\f410";
}

.la.la-window-close-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-window-close-o:before {
  content: "\\f410";
}

.la.la-times-rectangle-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-times-rectangle-o:before {
  content: "\\f410";
}

.la.la-bandcamp {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-grav {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-etsy {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-imdb {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-ravelry {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-eercast {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-eercast:before {
  content: "\\f2da";
}

.la.la-snowflake-o {
  font-family: "Line Awesome Free";
  font-weight: 400;
}

.la.la-snowflake-o:before {
  content: "\\f2dc";
}

.la.la-superpowers {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-wpexplorer {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

.la.la-spotify {
  font-family: "Line Awesome Brands";
  font-weight: 400;
}

/*
* Remix Icon v2.5.0
* https://remixicon.com
* https://github.com/Remix-Design/RemixIcon
*
* Copyright RemixIcon.com
* Released under the Apache License Version 2.0
*
* Date: 2020-05-23
*/
@font-face {
  font-family: "remixicon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___}); /* IE9*/
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("svg"); /* iOS 4.1- */
  font-display: swap;
}
[class^=ri-], [class*=" ri-"] {
  font-family: "remixicon" !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.ri-lg {
  font-size: 1.3333em;
  line-height: 0.75em;
  vertical-align: -0.0667em;
}

.ri-xl {
  font-size: 1.5em;
  line-height: 0.6666em;
  vertical-align: -0.075em;
}

.ri-xxs {
  font-size: 0.5em;
}

.ri-xs {
  font-size: 0.75em;
}

.ri-sm {
  font-size: 0.875em;
}

.ri-1x {
  font-size: 1em;
}

.ri-2x {
  font-size: 2em;
}

.ri-3x {
  font-size: 3em;
}

.ri-4x {
  font-size: 4em;
}

.ri-5x {
  font-size: 5em;
}

.ri-6x {
  font-size: 6em;
}

.ri-7x {
  font-size: 7em;
}

.ri-8x {
  font-size: 8em;
}

.ri-9x {
  font-size: 9em;
}

.ri-10x {
  font-size: 10em;
}

.ri-fw {
  text-align: center;
  width: 1.25em;
}

.ri-24-hours-fill:before {
  content: "\\ea01";
}

.ri-24-hours-line:before {
  content: "\\ea02";
}

.ri-4k-fill:before {
  content: "\\ea03";
}

.ri-4k-line:before {
  content: "\\ea04";
}

.ri-a-b:before {
  content: "\\ea05";
}

.ri-account-box-fill:before {
  content: "\\ea06";
}

.ri-account-box-line:before {
  content: "\\ea07";
}

.ri-account-circle-fill:before {
  content: "\\ea08";
}

.ri-account-circle-line:before {
  content: "\\ea09";
}

.ri-account-pin-box-fill:before {
  content: "\\ea0a";
}

.ri-account-pin-box-line:before {
  content: "\\ea0b";
}

.ri-account-pin-circle-fill:before {
  content: "\\ea0c";
}

.ri-account-pin-circle-line:before {
  content: "\\ea0d";
}

.ri-add-box-fill:before {
  content: "\\ea0e";
}

.ri-add-box-line:before {
  content: "\\ea0f";
}

.ri-add-circle-fill:before {
  content: "\\ea10";
}

.ri-add-circle-line:before {
  content: "\\ea11";
}

.ri-add-fill:before {
  content: "\\ea12";
}

.ri-add-line:before {
  content: "\\ea13";
}

.ri-admin-fill:before {
  content: "\\ea14";
}

.ri-admin-line:before {
  content: "\\ea15";
}

.ri-advertisement-fill:before {
  content: "\\ea16";
}

.ri-advertisement-line:before {
  content: "\\ea17";
}

.ri-airplay-fill:before {
  content: "\\ea18";
}

.ri-airplay-line:before {
  content: "\\ea19";
}

.ri-alarm-fill:before {
  content: "\\ea1a";
}

.ri-alarm-line:before {
  content: "\\ea1b";
}

.ri-alarm-warning-fill:before {
  content: "\\ea1c";
}

.ri-alarm-warning-line:before {
  content: "\\ea1d";
}

.ri-album-fill:before {
  content: "\\ea1e";
}

.ri-album-line:before {
  content: "\\ea1f";
}

.ri-alert-fill:before {
  content: "\\ea20";
}

.ri-alert-line:before {
  content: "\\ea21";
}

.ri-aliens-fill:before {
  content: "\\ea22";
}

.ri-aliens-line:before {
  content: "\\ea23";
}

.ri-align-bottom:before {
  content: "\\ea24";
}

.ri-align-center:before {
  content: "\\ea25";
}

.ri-align-justify:before {
  content: "\\ea26";
}

.ri-align-left:before {
  content: "\\ea27";
}

.ri-align-right:before {
  content: "\\ea28";
}

.ri-align-top:before {
  content: "\\ea29";
}

.ri-align-vertically:before {
  content: "\\ea2a";
}

.ri-alipay-fill:before {
  content: "\\ea2b";
}

.ri-alipay-line:before {
  content: "\\ea2c";
}

.ri-amazon-fill:before {
  content: "\\ea2d";
}

.ri-amazon-line:before {
  content: "\\ea2e";
}

.ri-anchor-fill:before {
  content: "\\ea2f";
}

.ri-anchor-line:before {
  content: "\\ea30";
}

.ri-ancient-gate-fill:before {
  content: "\\ea31";
}

.ri-ancient-gate-line:before {
  content: "\\ea32";
}

.ri-ancient-pavilion-fill:before {
  content: "\\ea33";
}

.ri-ancient-pavilion-line:before {
  content: "\\ea34";
}

.ri-android-fill:before {
  content: "\\ea35";
}

.ri-android-line:before {
  content: "\\ea36";
}

.ri-angularjs-fill:before {
  content: "\\ea37";
}

.ri-angularjs-line:before {
  content: "\\ea38";
}

.ri-anticlockwise-2-fill:before {
  content: "\\ea39";
}

.ri-anticlockwise-2-line:before {
  content: "\\ea3a";
}

.ri-anticlockwise-fill:before {
  content: "\\ea3b";
}

.ri-anticlockwise-line:before {
  content: "\\ea3c";
}

.ri-app-store-fill:before {
  content: "\\ea3d";
}

.ri-app-store-line:before {
  content: "\\ea3e";
}

.ri-apple-fill:before {
  content: "\\ea3f";
}

.ri-apple-line:before {
  content: "\\ea40";
}

.ri-apps-2-fill:before {
  content: "\\ea41";
}

.ri-apps-2-line:before {
  content: "\\ea42";
}

.ri-apps-fill:before {
  content: "\\ea43";
}

.ri-apps-line:before {
  content: "\\ea44";
}

.ri-archive-drawer-fill:before {
  content: "\\ea45";
}

.ri-archive-drawer-line:before {
  content: "\\ea46";
}

.ri-archive-fill:before {
  content: "\\ea47";
}

.ri-archive-line:before {
  content: "\\ea48";
}

.ri-arrow-down-circle-fill:before {
  content: "\\ea49";
}

.ri-arrow-down-circle-line:before {
  content: "\\ea4a";
}

.ri-arrow-down-fill:before {
  content: "\\ea4b";
}

.ri-arrow-down-line:before {
  content: "\\ea4c";
}

.ri-arrow-down-s-fill:before {
  content: "\\ea4d";
}

.ri-arrow-down-s-line:before {
  content: "\\ea4e";
}

.ri-arrow-drop-down-fill:before {
  content: "\\ea4f";
}

.ri-arrow-drop-down-line:before {
  content: "\\ea50";
}

.ri-arrow-drop-left-fill:before {
  content: "\\ea51";
}

.ri-arrow-drop-left-line:before {
  content: "\\ea52";
}

.ri-arrow-drop-right-fill:before {
  content: "\\ea53";
}

.ri-arrow-drop-right-line:before {
  content: "\\ea54";
}

.ri-arrow-drop-up-fill:before {
  content: "\\ea55";
}

.ri-arrow-drop-up-line:before {
  content: "\\ea56";
}

.ri-arrow-go-back-fill:before {
  content: "\\ea57";
}

.ri-arrow-go-back-line:before {
  content: "\\ea58";
}

.ri-arrow-go-forward-fill:before {
  content: "\\ea59";
}

.ri-arrow-go-forward-line:before {
  content: "\\ea5a";
}

.ri-arrow-left-circle-fill:before {
  content: "\\ea5b";
}

.ri-arrow-left-circle-line:before {
  content: "\\ea5c";
}

.ri-arrow-left-down-fill:before {
  content: "\\ea5d";
}

.ri-arrow-left-down-line:before {
  content: "\\ea5e";
}

.ri-arrow-left-fill:before {
  content: "\\ea5f";
}

.ri-arrow-left-line:before {
  content: "\\ea60";
}

.ri-arrow-left-right-fill:before {
  content: "\\ea61";
}

.ri-arrow-left-right-line:before {
  content: "\\ea62";
}

.ri-arrow-left-s-fill:before {
  content: "\\ea63";
}

.ri-arrow-left-s-line:before {
  content: "\\ea64";
}

.ri-arrow-left-up-fill:before {
  content: "\\ea65";
}

.ri-arrow-left-up-line:before {
  content: "\\ea66";
}

.ri-arrow-right-circle-fill:before {
  content: "\\ea67";
}

.ri-arrow-right-circle-line:before {
  content: "\\ea68";
}

.ri-arrow-right-down-fill:before {
  content: "\\ea69";
}

.ri-arrow-right-down-line:before {
  content: "\\ea6a";
}

.ri-arrow-right-fill:before {
  content: "\\ea6b";
}

.ri-arrow-right-line:before {
  content: "\\ea6c";
}

.ri-arrow-right-s-fill:before {
  content: "\\ea6d";
}

.ri-arrow-right-s-line:before {
  content: "\\ea6e";
}

.ri-arrow-right-up-fill:before {
  content: "\\ea6f";
}

.ri-arrow-right-up-line:before {
  content: "\\ea70";
}

.ri-arrow-up-circle-fill:before {
  content: "\\ea71";
}

.ri-arrow-up-circle-line:before {
  content: "\\ea72";
}

.ri-arrow-up-down-fill:before {
  content: "\\ea73";
}

.ri-arrow-up-down-line:before {
  content: "\\ea74";
}

.ri-arrow-up-fill:before {
  content: "\\ea75";
}

.ri-arrow-up-line:before {
  content: "\\ea76";
}

.ri-arrow-up-s-fill:before {
  content: "\\ea77";
}

.ri-arrow-up-s-line:before {
  content: "\\ea78";
}

.ri-artboard-2-fill:before {
  content: "\\ea79";
}

.ri-artboard-2-line:before {
  content: "\\ea7a";
}

.ri-artboard-fill:before {
  content: "\\ea7b";
}

.ri-artboard-line:before {
  content: "\\ea7c";
}

.ri-article-fill:before {
  content: "\\ea7d";
}

.ri-article-line:before {
  content: "\\ea7e";
}

.ri-aspect-ratio-fill:before {
  content: "\\ea7f";
}

.ri-aspect-ratio-line:before {
  content: "\\ea80";
}

.ri-asterisk:before {
  content: "\\ea81";
}

.ri-at-fill:before {
  content: "\\ea82";
}

.ri-at-line:before {
  content: "\\ea83";
}

.ri-attachment-2:before {
  content: "\\ea84";
}

.ri-attachment-fill:before {
  content: "\\ea85";
}

.ri-attachment-line:before {
  content: "\\ea86";
}

.ri-auction-fill:before {
  content: "\\ea87";
}

.ri-auction-line:before {
  content: "\\ea88";
}

.ri-award-fill:before {
  content: "\\ea89";
}

.ri-award-line:before {
  content: "\\ea8a";
}

.ri-baidu-fill:before {
  content: "\\ea8b";
}

.ri-baidu-line:before {
  content: "\\ea8c";
}

.ri-ball-pen-fill:before {
  content: "\\ea8d";
}

.ri-ball-pen-line:before {
  content: "\\ea8e";
}

.ri-bank-card-2-fill:before {
  content: "\\ea8f";
}

.ri-bank-card-2-line:before {
  content: "\\ea90";
}

.ri-bank-card-fill:before {
  content: "\\ea91";
}

.ri-bank-card-line:before {
  content: "\\ea92";
}

.ri-bank-fill:before {
  content: "\\ea93";
}

.ri-bank-line:before {
  content: "\\ea94";
}

.ri-bar-chart-2-fill:before {
  content: "\\ea95";
}

.ri-bar-chart-2-line:before {
  content: "\\ea96";
}

.ri-bar-chart-box-fill:before {
  content: "\\ea97";
}

.ri-bar-chart-box-line:before {
  content: "\\ea98";
}

.ri-bar-chart-fill:before {
  content: "\\ea99";
}

.ri-bar-chart-grouped-fill:before {
  content: "\\ea9a";
}

.ri-bar-chart-grouped-line:before {
  content: "\\ea9b";
}

.ri-bar-chart-horizontal-fill:before {
  content: "\\ea9c";
}

.ri-bar-chart-horizontal-line:before {
  content: "\\ea9d";
}

.ri-bar-chart-line:before {
  content: "\\ea9e";
}

.ri-barcode-box-fill:before {
  content: "\\ea9f";
}

.ri-barcode-box-line:before {
  content: "\\eaa0";
}

.ri-barcode-fill:before {
  content: "\\eaa1";
}

.ri-barcode-line:before {
  content: "\\eaa2";
}

.ri-barricade-fill:before {
  content: "\\eaa3";
}

.ri-barricade-line:before {
  content: "\\eaa4";
}

.ri-base-station-fill:before {
  content: "\\eaa5";
}

.ri-base-station-line:before {
  content: "\\eaa6";
}

.ri-basketball-fill:before {
  content: "\\eaa7";
}

.ri-basketball-line:before {
  content: "\\eaa8";
}

.ri-battery-2-charge-fill:before {
  content: "\\eaa9";
}

.ri-battery-2-charge-line:before {
  content: "\\eaaa";
}

.ri-battery-2-fill:before {
  content: "\\eaab";
}

.ri-battery-2-line:before {
  content: "\\eaac";
}

.ri-battery-charge-fill:before {
  content: "\\eaad";
}

.ri-battery-charge-line:before {
  content: "\\eaae";
}

.ri-battery-fill:before {
  content: "\\eaaf";
}

.ri-battery-line:before {
  content: "\\eab0";
}

.ri-battery-low-fill:before {
  content: "\\eab1";
}

.ri-battery-low-line:before {
  content: "\\eab2";
}

.ri-battery-saver-fill:before {
  content: "\\eab3";
}

.ri-battery-saver-line:before {
  content: "\\eab4";
}

.ri-battery-share-fill:before {
  content: "\\eab5";
}

.ri-battery-share-line:before {
  content: "\\eab6";
}

.ri-bear-smile-fill:before {
  content: "\\eab7";
}

.ri-bear-smile-line:before {
  content: "\\eab8";
}

.ri-behance-fill:before {
  content: "\\eab9";
}

.ri-behance-line:before {
  content: "\\eaba";
}

.ri-bell-fill:before {
  content: "\\eabb";
}

.ri-bell-line:before {
  content: "\\eabc";
}

.ri-bike-fill:before {
  content: "\\eabd";
}

.ri-bike-line:before {
  content: "\\eabe";
}

.ri-bilibili-fill:before {
  content: "\\eabf";
}

.ri-bilibili-line:before {
  content: "\\eac0";
}

.ri-bill-fill:before {
  content: "\\eac1";
}

.ri-bill-line:before {
  content: "\\eac2";
}

.ri-billiards-fill:before {
  content: "\\eac3";
}

.ri-billiards-line:before {
  content: "\\eac4";
}

.ri-bit-coin-fill:before {
  content: "\\eac5";
}

.ri-bit-coin-line:before {
  content: "\\eac6";
}

.ri-blaze-fill:before {
  content: "\\eac7";
}

.ri-blaze-line:before {
  content: "\\eac8";
}

.ri-bluetooth-connect-fill:before {
  content: "\\eac9";
}

.ri-bluetooth-connect-line:before {
  content: "\\eaca";
}

.ri-bluetooth-fill:before {
  content: "\\eacb";
}

.ri-bluetooth-line:before {
  content: "\\eacc";
}

.ri-blur-off-fill:before {
  content: "\\eacd";
}

.ri-blur-off-line:before {
  content: "\\eace";
}

.ri-body-scan-fill:before {
  content: "\\eacf";
}

.ri-body-scan-line:before {
  content: "\\ead0";
}

.ri-bold:before {
  content: "\\ead1";
}

.ri-book-2-fill:before {
  content: "\\ead2";
}

.ri-book-2-line:before {
  content: "\\ead3";
}

.ri-book-3-fill:before {
  content: "\\ead4";
}

.ri-book-3-line:before {
  content: "\\ead5";
}

.ri-book-fill:before {
  content: "\\ead6";
}

.ri-book-line:before {
  content: "\\ead7";
}

.ri-book-mark-fill:before {
  content: "\\ead8";
}

.ri-book-mark-line:before {
  content: "\\ead9";
}

.ri-book-open-fill:before {
  content: "\\eada";
}

.ri-book-open-line:before {
  content: "\\eadb";
}

.ri-book-read-fill:before {
  content: "\\eadc";
}

.ri-book-read-line:before {
  content: "\\eadd";
}

.ri-booklet-fill:before {
  content: "\\eade";
}

.ri-booklet-line:before {
  content: "\\eadf";
}

.ri-bookmark-2-fill:before {
  content: "\\eae0";
}

.ri-bookmark-2-line:before {
  content: "\\eae1";
}

.ri-bookmark-3-fill:before {
  content: "\\eae2";
}

.ri-bookmark-3-line:before {
  content: "\\eae3";
}

.ri-bookmark-fill:before {
  content: "\\eae4";
}

.ri-bookmark-line:before {
  content: "\\eae5";
}

.ri-boxing-fill:before {
  content: "\\eae6";
}

.ri-boxing-line:before {
  content: "\\eae7";
}

.ri-braces-fill:before {
  content: "\\eae8";
}

.ri-braces-line:before {
  content: "\\eae9";
}

.ri-brackets-fill:before {
  content: "\\eaea";
}

.ri-brackets-line:before {
  content: "\\eaeb";
}

.ri-briefcase-2-fill:before {
  content: "\\eaec";
}

.ri-briefcase-2-line:before {
  content: "\\eaed";
}

.ri-briefcase-3-fill:before {
  content: "\\eaee";
}

.ri-briefcase-3-line:before {
  content: "\\eaef";
}

.ri-briefcase-4-fill:before {
  content: "\\eaf0";
}

.ri-briefcase-4-line:before {
  content: "\\eaf1";
}

.ri-briefcase-5-fill:before {
  content: "\\eaf2";
}

.ri-briefcase-5-line:before {
  content: "\\eaf3";
}

.ri-briefcase-fill:before {
  content: "\\eaf4";
}

.ri-briefcase-line:before {
  content: "\\eaf5";
}

.ri-bring-forward:before {
  content: "\\eaf6";
}

.ri-bring-to-front:before {
  content: "\\eaf7";
}

.ri-broadcast-fill:before {
  content: "\\eaf8";
}

.ri-broadcast-line:before {
  content: "\\eaf9";
}

.ri-brush-2-fill:before {
  content: "\\eafa";
}

.ri-brush-2-line:before {
  content: "\\eafb";
}

.ri-brush-3-fill:before {
  content: "\\eafc";
}

.ri-brush-3-line:before {
  content: "\\eafd";
}

.ri-brush-4-fill:before {
  content: "\\eafe";
}

.ri-brush-4-line:before {
  content: "\\eaff";
}

.ri-brush-fill:before {
  content: "\\eb00";
}

.ri-brush-line:before {
  content: "\\eb01";
}

.ri-bubble-chart-fill:before {
  content: "\\eb02";
}

.ri-bubble-chart-line:before {
  content: "\\eb03";
}

.ri-bug-2-fill:before {
  content: "\\eb04";
}

.ri-bug-2-line:before {
  content: "\\eb05";
}

.ri-bug-fill:before {
  content: "\\eb06";
}

.ri-bug-line:before {
  content: "\\eb07";
}

.ri-building-2-fill:before {
  content: "\\eb08";
}

.ri-building-2-line:before {
  content: "\\eb09";
}

.ri-building-3-fill:before {
  content: "\\eb0a";
}

.ri-building-3-line:before {
  content: "\\eb0b";
}

.ri-building-4-fill:before {
  content: "\\eb0c";
}

.ri-building-4-line:before {
  content: "\\eb0d";
}

.ri-building-fill:before {
  content: "\\eb0e";
}

.ri-building-line:before {
  content: "\\eb0f";
}

.ri-bus-2-fill:before {
  content: "\\eb10";
}

.ri-bus-2-line:before {
  content: "\\eb11";
}

.ri-bus-fill:before {
  content: "\\eb12";
}

.ri-bus-line:before {
  content: "\\eb13";
}

.ri-bus-wifi-fill:before {
  content: "\\eb14";
}

.ri-bus-wifi-line:before {
  content: "\\eb15";
}

.ri-cactus-fill:before {
  content: "\\eb16";
}

.ri-cactus-line:before {
  content: "\\eb17";
}

.ri-cake-2-fill:before {
  content: "\\eb18";
}

.ri-cake-2-line:before {
  content: "\\eb19";
}

.ri-cake-3-fill:before {
  content: "\\eb1a";
}

.ri-cake-3-line:before {
  content: "\\eb1b";
}

.ri-cake-fill:before {
  content: "\\eb1c";
}

.ri-cake-line:before {
  content: "\\eb1d";
}

.ri-calculator-fill:before {
  content: "\\eb1e";
}

.ri-calculator-line:before {
  content: "\\eb1f";
}

.ri-calendar-2-fill:before {
  content: "\\eb20";
}

.ri-calendar-2-line:before {
  content: "\\eb21";
}

.ri-calendar-check-fill:before {
  content: "\\eb22";
}

.ri-calendar-check-line:before {
  content: "\\eb23";
}

.ri-calendar-event-fill:before {
  content: "\\eb24";
}

.ri-calendar-event-line:before {
  content: "\\eb25";
}

.ri-calendar-fill:before {
  content: "\\eb26";
}

.ri-calendar-line:before {
  content: "\\eb27";
}

.ri-calendar-todo-fill:before {
  content: "\\eb28";
}

.ri-calendar-todo-line:before {
  content: "\\eb29";
}

.ri-camera-2-fill:before {
  content: "\\eb2a";
}

.ri-camera-2-line:before {
  content: "\\eb2b";
}

.ri-camera-3-fill:before {
  content: "\\eb2c";
}

.ri-camera-3-line:before {
  content: "\\eb2d";
}

.ri-camera-fill:before {
  content: "\\eb2e";
}

.ri-camera-lens-fill:before {
  content: "\\eb2f";
}

.ri-camera-lens-line:before {
  content: "\\eb30";
}

.ri-camera-line:before {
  content: "\\eb31";
}

.ri-camera-off-fill:before {
  content: "\\eb32";
}

.ri-camera-off-line:before {
  content: "\\eb33";
}

.ri-camera-switch-fill:before {
  content: "\\eb34";
}

.ri-camera-switch-line:before {
  content: "\\eb35";
}

.ri-capsule-fill:before {
  content: "\\eb36";
}

.ri-capsule-line:before {
  content: "\\eb37";
}

.ri-car-fill:before {
  content: "\\eb38";
}

.ri-car-line:before {
  content: "\\eb39";
}

.ri-car-washing-fill:before {
  content: "\\eb3a";
}

.ri-car-washing-line:before {
  content: "\\eb3b";
}

.ri-caravan-fill:before {
  content: "\\eb3c";
}

.ri-caravan-line:before {
  content: "\\eb3d";
}

.ri-cast-fill:before {
  content: "\\eb3e";
}

.ri-cast-line:before {
  content: "\\eb3f";
}

.ri-cellphone-fill:before {
  content: "\\eb40";
}

.ri-cellphone-line:before {
  content: "\\eb41";
}

.ri-celsius-fill:before {
  content: "\\eb42";
}

.ri-celsius-line:before {
  content: "\\eb43";
}

.ri-centos-fill:before {
  content: "\\eb44";
}

.ri-centos-line:before {
  content: "\\eb45";
}

.ri-character-recognition-fill:before {
  content: "\\eb46";
}

.ri-character-recognition-line:before {
  content: "\\eb47";
}

.ri-charging-pile-2-fill:before {
  content: "\\eb48";
}

.ri-charging-pile-2-line:before {
  content: "\\eb49";
}

.ri-charging-pile-fill:before {
  content: "\\eb4a";
}

.ri-charging-pile-line:before {
  content: "\\eb4b";
}

.ri-chat-1-fill:before {
  content: "\\eb4c";
}

.ri-chat-1-line:before {
  content: "\\eb4d";
}

.ri-chat-2-fill:before {
  content: "\\eb4e";
}

.ri-chat-2-line:before {
  content: "\\eb4f";
}

.ri-chat-3-fill:before {
  content: "\\eb50";
}

.ri-chat-3-line:before {
  content: "\\eb51";
}

.ri-chat-4-fill:before {
  content: "\\eb52";
}

.ri-chat-4-line:before {
  content: "\\eb53";
}

.ri-chat-check-fill:before {
  content: "\\eb54";
}

.ri-chat-check-line:before {
  content: "\\eb55";
}

.ri-chat-delete-fill:before {
  content: "\\eb56";
}

.ri-chat-delete-line:before {
  content: "\\eb57";
}

.ri-chat-download-fill:before {
  content: "\\eb58";
}

.ri-chat-download-line:before {
  content: "\\eb59";
}

.ri-chat-follow-up-fill:before {
  content: "\\eb5a";
}

.ri-chat-follow-up-line:before {
  content: "\\eb5b";
}

.ri-chat-forward-fill:before {
  content: "\\eb5c";
}

.ri-chat-forward-line:before {
  content: "\\eb5d";
}

.ri-chat-heart-fill:before {
  content: "\\eb5e";
}

.ri-chat-heart-line:before {
  content: "\\eb5f";
}

.ri-chat-history-fill:before {
  content: "\\eb60";
}

.ri-chat-history-line:before {
  content: "\\eb61";
}

.ri-chat-new-fill:before {
  content: "\\eb62";
}

.ri-chat-new-line:before {
  content: "\\eb63";
}

.ri-chat-off-fill:before {
  content: "\\eb64";
}

.ri-chat-off-line:before {
  content: "\\eb65";
}

.ri-chat-poll-fill:before {
  content: "\\eb66";
}

.ri-chat-poll-line:before {
  content: "\\eb67";
}

.ri-chat-private-fill:before {
  content: "\\eb68";
}

.ri-chat-private-line:before {
  content: "\\eb69";
}

.ri-chat-quote-fill:before {
  content: "\\eb6a";
}

.ri-chat-quote-line:before {
  content: "\\eb6b";
}

.ri-chat-settings-fill:before {
  content: "\\eb6c";
}

.ri-chat-settings-line:before {
  content: "\\eb6d";
}

.ri-chat-smile-2-fill:before {
  content: "\\eb6e";
}

.ri-chat-smile-2-line:before {
  content: "\\eb6f";
}

.ri-chat-smile-3-fill:before {
  content: "\\eb70";
}

.ri-chat-smile-3-line:before {
  content: "\\eb71";
}

.ri-chat-smile-fill:before {
  content: "\\eb72";
}

.ri-chat-smile-line:before {
  content: "\\eb73";
}

.ri-chat-upload-fill:before {
  content: "\\eb74";
}

.ri-chat-upload-line:before {
  content: "\\eb75";
}

.ri-chat-voice-fill:before {
  content: "\\eb76";
}

.ri-chat-voice-line:before {
  content: "\\eb77";
}

.ri-check-double-fill:before {
  content: "\\eb78";
}

.ri-check-double-line:before {
  content: "\\eb79";
}

.ri-check-fill:before {
  content: "\\eb7a";
}

.ri-check-line:before {
  content: "\\eb7b";
}

.ri-checkbox-blank-circle-fill:before {
  content: "\\eb7c";
}

.ri-checkbox-blank-circle-line:before {
  content: "\\eb7d";
}

.ri-checkbox-blank-fill:before {
  content: "\\eb7e";
}

.ri-checkbox-blank-line:before {
  content: "\\eb7f";
}

.ri-checkbox-circle-fill:before {
  content: "\\eb80";
}

.ri-checkbox-circle-line:before {
  content: "\\eb81";
}

.ri-checkbox-fill:before {
  content: "\\eb82";
}

.ri-checkbox-indeterminate-fill:before {
  content: "\\eb83";
}

.ri-checkbox-indeterminate-line:before {
  content: "\\eb84";
}

.ri-checkbox-line:before {
  content: "\\eb85";
}

.ri-checkbox-multiple-blank-fill:before {
  content: "\\eb86";
}

.ri-checkbox-multiple-blank-line:before {
  content: "\\eb87";
}

.ri-checkbox-multiple-fill:before {
  content: "\\eb88";
}

.ri-checkbox-multiple-line:before {
  content: "\\eb89";
}

.ri-china-railway-fill:before {
  content: "\\eb8a";
}

.ri-china-railway-line:before {
  content: "\\eb8b";
}

.ri-chrome-fill:before {
  content: "\\eb8c";
}

.ri-chrome-line:before {
  content: "\\eb8d";
}

.ri-clapperboard-fill:before {
  content: "\\eb8e";
}

.ri-clapperboard-line:before {
  content: "\\eb8f";
}

.ri-clipboard-fill:before {
  content: "\\eb90";
}

.ri-clipboard-line:before {
  content: "\\eb91";
}

.ri-clockwise-2-fill:before {
  content: "\\eb92";
}

.ri-clockwise-2-line:before {
  content: "\\eb93";
}

.ri-clockwise-fill:before {
  content: "\\eb94";
}

.ri-clockwise-line:before {
  content: "\\eb95";
}

.ri-close-circle-fill:before {
  content: "\\eb96";
}

.ri-close-circle-line:before {
  content: "\\eb97";
}

.ri-close-fill:before {
  content: "\\eb98";
}

.ri-close-line:before {
  content: "\\eb99";
}

.ri-closed-captioning-fill:before {
  content: "\\eb9a";
}

.ri-closed-captioning-line:before {
  content: "\\eb9b";
}

.ri-cloud-fill:before {
  content: "\\eb9c";
}

.ri-cloud-line:before {
  content: "\\eb9d";
}

.ri-cloud-off-fill:before {
  content: "\\eb9e";
}

.ri-cloud-off-line:before {
  content: "\\eb9f";
}

.ri-cloud-windy-fill:before {
  content: "\\eba0";
}

.ri-cloud-windy-line:before {
  content: "\\eba1";
}

.ri-cloudy-2-fill:before {
  content: "\\eba2";
}

.ri-cloudy-2-line:before {
  content: "\\eba3";
}

.ri-cloudy-fill:before {
  content: "\\eba4";
}

.ri-cloudy-line:before {
  content: "\\eba5";
}

.ri-code-box-fill:before {
  content: "\\eba6";
}

.ri-code-box-line:before {
  content: "\\eba7";
}

.ri-code-fill:before {
  content: "\\eba8";
}

.ri-code-line:before {
  content: "\\eba9";
}

.ri-code-s-fill:before {
  content: "\\ebaa";
}

.ri-code-s-line:before {
  content: "\\ebab";
}

.ri-code-s-slash-fill:before {
  content: "\\ebac";
}

.ri-code-s-slash-line:before {
  content: "\\ebad";
}

.ri-code-view:before {
  content: "\\ebae";
}

.ri-codepen-fill:before {
  content: "\\ebaf";
}

.ri-codepen-line:before {
  content: "\\ebb0";
}

.ri-coin-fill:before {
  content: "\\ebb1";
}

.ri-coin-line:before {
  content: "\\ebb2";
}

.ri-coins-fill:before {
  content: "\\ebb3";
}

.ri-coins-line:before {
  content: "\\ebb4";
}

.ri-collage-fill:before {
  content: "\\ebb5";
}

.ri-collage-line:before {
  content: "\\ebb6";
}

.ri-command-fill:before {
  content: "\\ebb7";
}

.ri-command-line:before {
  content: "\\ebb8";
}

.ri-community-fill:before {
  content: "\\ebb9";
}

.ri-community-line:before {
  content: "\\ebba";
}

.ri-compass-2-fill:before {
  content: "\\ebbb";
}

.ri-compass-2-line:before {
  content: "\\ebbc";
}

.ri-compass-3-fill:before {
  content: "\\ebbd";
}

.ri-compass-3-line:before {
  content: "\\ebbe";
}

.ri-compass-4-fill:before {
  content: "\\ebbf";
}

.ri-compass-4-line:before {
  content: "\\ebc0";
}

.ri-compass-discover-fill:before {
  content: "\\ebc1";
}

.ri-compass-discover-line:before {
  content: "\\ebc2";
}

.ri-compass-fill:before {
  content: "\\ebc3";
}

.ri-compass-line:before {
  content: "\\ebc4";
}

.ri-compasses-2-fill:before {
  content: "\\ebc5";
}

.ri-compasses-2-line:before {
  content: "\\ebc6";
}

.ri-compasses-fill:before {
  content: "\\ebc7";
}

.ri-compasses-line:before {
  content: "\\ebc8";
}

.ri-computer-fill:before {
  content: "\\ebc9";
}

.ri-computer-line:before {
  content: "\\ebca";
}

.ri-contacts-book-2-fill:before {
  content: "\\ebcb";
}

.ri-contacts-book-2-line:before {
  content: "\\ebcc";
}

.ri-contacts-book-fill:before {
  content: "\\ebcd";
}

.ri-contacts-book-line:before {
  content: "\\ebce";
}

.ri-contacts-book-upload-fill:before {
  content: "\\ebcf";
}

.ri-contacts-book-upload-line:before {
  content: "\\ebd0";
}

.ri-contacts-fill:before {
  content: "\\ebd1";
}

.ri-contacts-line:before {
  content: "\\ebd2";
}

.ri-contrast-2-fill:before {
  content: "\\ebd3";
}

.ri-contrast-2-line:before {
  content: "\\ebd4";
}

.ri-contrast-drop-2-fill:before {
  content: "\\ebd5";
}

.ri-contrast-drop-2-line:before {
  content: "\\ebd6";
}

.ri-contrast-drop-fill:before {
  content: "\\ebd7";
}

.ri-contrast-drop-line:before {
  content: "\\ebd8";
}

.ri-contrast-fill:before {
  content: "\\ebd9";
}

.ri-contrast-line:before {
  content: "\\ebda";
}

.ri-copper-coin-fill:before {
  content: "\\ebdb";
}

.ri-copper-coin-line:before {
  content: "\\ebdc";
}

.ri-copper-diamond-fill:before {
  content: "\\ebdd";
}

.ri-copper-diamond-line:before {
  content: "\\ebde";
}

.ri-copyleft-fill:before {
  content: "\\ebdf";
}

.ri-copyleft-line:before {
  content: "\\ebe0";
}

.ri-copyright-fill:before {
  content: "\\ebe1";
}

.ri-copyright-line:before {
  content: "\\ebe2";
}

.ri-coreos-fill:before {
  content: "\\ebe3";
}

.ri-coreos-line:before {
  content: "\\ebe4";
}

.ri-coupon-2-fill:before {
  content: "\\ebe5";
}

.ri-coupon-2-line:before {
  content: "\\ebe6";
}

.ri-coupon-3-fill:before {
  content: "\\ebe7";
}

.ri-coupon-3-line:before {
  content: "\\ebe8";
}

.ri-coupon-4-fill:before {
  content: "\\ebe9";
}

.ri-coupon-4-line:before {
  content: "\\ebea";
}

.ri-coupon-5-fill:before {
  content: "\\ebeb";
}

.ri-coupon-5-line:before {
  content: "\\ebec";
}

.ri-coupon-fill:before {
  content: "\\ebed";
}

.ri-coupon-line:before {
  content: "\\ebee";
}

.ri-cpu-fill:before {
  content: "\\ebef";
}

.ri-cpu-line:before {
  content: "\\ebf0";
}

.ri-creative-commons-by-fill:before {
  content: "\\ebf1";
}

.ri-creative-commons-by-line:before {
  content: "\\ebf2";
}

.ri-creative-commons-fill:before {
  content: "\\ebf3";
}

.ri-creative-commons-line:before {
  content: "\\ebf4";
}

.ri-creative-commons-nc-fill:before {
  content: "\\ebf5";
}

.ri-creative-commons-nc-line:before {
  content: "\\ebf6";
}

.ri-creative-commons-nd-fill:before {
  content: "\\ebf7";
}

.ri-creative-commons-nd-line:before {
  content: "\\ebf8";
}

.ri-creative-commons-sa-fill:before {
  content: "\\ebf9";
}

.ri-creative-commons-sa-line:before {
  content: "\\ebfa";
}

.ri-creative-commons-zero-fill:before {
  content: "\\ebfb";
}

.ri-creative-commons-zero-line:before {
  content: "\\ebfc";
}

.ri-criminal-fill:before {
  content: "\\ebfd";
}

.ri-criminal-line:before {
  content: "\\ebfe";
}

.ri-crop-2-fill:before {
  content: "\\ebff";
}

.ri-crop-2-line:before {
  content: "\\ec00";
}

.ri-crop-fill:before {
  content: "\\ec01";
}

.ri-crop-line:before {
  content: "\\ec02";
}

.ri-css3-fill:before {
  content: "\\ec03";
}

.ri-css3-line:before {
  content: "\\ec04";
}

.ri-cup-fill:before {
  content: "\\ec05";
}

.ri-cup-line:before {
  content: "\\ec06";
}

.ri-currency-fill:before {
  content: "\\ec07";
}

.ri-currency-line:before {
  content: "\\ec08";
}

.ri-cursor-fill:before {
  content: "\\ec09";
}

.ri-cursor-line:before {
  content: "\\ec0a";
}

.ri-customer-service-2-fill:before {
  content: "\\ec0b";
}

.ri-customer-service-2-line:before {
  content: "\\ec0c";
}

.ri-customer-service-fill:before {
  content: "\\ec0d";
}

.ri-customer-service-line:before {
  content: "\\ec0e";
}

.ri-dashboard-2-fill:before {
  content: "\\ec0f";
}

.ri-dashboard-2-line:before {
  content: "\\ec10";
}

.ri-dashboard-3-fill:before {
  content: "\\ec11";
}

.ri-dashboard-3-line:before {
  content: "\\ec12";
}

.ri-dashboard-fill:before {
  content: "\\ec13";
}

.ri-dashboard-line:before {
  content: "\\ec14";
}

.ri-database-2-fill:before {
  content: "\\ec15";
}

.ri-database-2-line:before {
  content: "\\ec16";
}

.ri-database-fill:before {
  content: "\\ec17";
}

.ri-database-line:before {
  content: "\\ec18";
}

.ri-delete-back-2-fill:before {
  content: "\\ec19";
}

.ri-delete-back-2-line:before {
  content: "\\ec1a";
}

.ri-delete-back-fill:before {
  content: "\\ec1b";
}

.ri-delete-back-line:before {
  content: "\\ec1c";
}

.ri-delete-bin-2-fill:before {
  content: "\\ec1d";
}

.ri-delete-bin-2-line:before {
  content: "\\ec1e";
}

.ri-delete-bin-3-fill:before {
  content: "\\ec1f";
}

.ri-delete-bin-3-line:before {
  content: "\\ec20";
}

.ri-delete-bin-4-fill:before {
  content: "\\ec21";
}

.ri-delete-bin-4-line:before {
  content: "\\ec22";
}

.ri-delete-bin-5-fill:before {
  content: "\\ec23";
}

.ri-delete-bin-5-line:before {
  content: "\\ec24";
}

.ri-delete-bin-6-fill:before {
  content: "\\ec25";
}

.ri-delete-bin-6-line:before {
  content: "\\ec26";
}

.ri-delete-bin-7-fill:before {
  content: "\\ec27";
}

.ri-delete-bin-7-line:before {
  content: "\\ec28";
}

.ri-delete-bin-fill:before {
  content: "\\ec29";
}

.ri-delete-bin-line:before {
  content: "\\ec2a";
}

.ri-delete-column:before {
  content: "\\ec2b";
}

.ri-delete-row:before {
  content: "\\ec2c";
}

.ri-device-fill:before {
  content: "\\ec2d";
}

.ri-device-line:before {
  content: "\\ec2e";
}

.ri-device-recover-fill:before {
  content: "\\ec2f";
}

.ri-device-recover-line:before {
  content: "\\ec30";
}

.ri-dingding-fill:before {
  content: "\\ec31";
}

.ri-dingding-line:before {
  content: "\\ec32";
}

.ri-direction-fill:before {
  content: "\\ec33";
}

.ri-direction-line:before {
  content: "\\ec34";
}

.ri-disc-fill:before {
  content: "\\ec35";
}

.ri-disc-line:before {
  content: "\\ec36";
}

.ri-discord-fill:before {
  content: "\\ec37";
}

.ri-discord-line:before {
  content: "\\ec38";
}

.ri-discuss-fill:before {
  content: "\\ec39";
}

.ri-discuss-line:before {
  content: "\\ec3a";
}

.ri-dislike-fill:before {
  content: "\\ec3b";
}

.ri-dislike-line:before {
  content: "\\ec3c";
}

.ri-disqus-fill:before {
  content: "\\ec3d";
}

.ri-disqus-line:before {
  content: "\\ec3e";
}

.ri-divide-fill:before {
  content: "\\ec3f";
}

.ri-divide-line:before {
  content: "\\ec40";
}

.ri-donut-chart-fill:before {
  content: "\\ec41";
}

.ri-donut-chart-line:before {
  content: "\\ec42";
}

.ri-door-closed-fill:before {
  content: "\\ec43";
}

.ri-door-closed-line:before {
  content: "\\ec44";
}

.ri-door-fill:before {
  content: "\\ec45";
}

.ri-door-line:before {
  content: "\\ec46";
}

.ri-door-lock-box-fill:before {
  content: "\\ec47";
}

.ri-door-lock-box-line:before {
  content: "\\ec48";
}

.ri-door-lock-fill:before {
  content: "\\ec49";
}

.ri-door-lock-line:before {
  content: "\\ec4a";
}

.ri-door-open-fill:before {
  content: "\\ec4b";
}

.ri-door-open-line:before {
  content: "\\ec4c";
}

.ri-dossier-fill:before {
  content: "\\ec4d";
}

.ri-dossier-line:before {
  content: "\\ec4e";
}

.ri-douban-fill:before {
  content: "\\ec4f";
}

.ri-douban-line:before {
  content: "\\ec50";
}

.ri-double-quotes-l:before {
  content: "\\ec51";
}

.ri-double-quotes-r:before {
  content: "\\ec52";
}

.ri-download-2-fill:before {
  content: "\\ec53";
}

.ri-download-2-line:before {
  content: "\\ec54";
}

.ri-download-cloud-2-fill:before {
  content: "\\ec55";
}

.ri-download-cloud-2-line:before {
  content: "\\ec56";
}

.ri-download-cloud-fill:before {
  content: "\\ec57";
}

.ri-download-cloud-line:before {
  content: "\\ec58";
}

.ri-download-fill:before {
  content: "\\ec59";
}

.ri-download-line:before {
  content: "\\ec5a";
}

.ri-draft-fill:before {
  content: "\\ec5b";
}

.ri-draft-line:before {
  content: "\\ec5c";
}

.ri-drag-drop-fill:before {
  content: "\\ec5d";
}

.ri-drag-drop-line:before {
  content: "\\ec5e";
}

.ri-drag-move-2-fill:before {
  content: "\\ec5f";
}

.ri-drag-move-2-line:before {
  content: "\\ec60";
}

.ri-drag-move-fill:before {
  content: "\\ec61";
}

.ri-drag-move-line:before {
  content: "\\ec62";
}

.ri-dribbble-fill:before {
  content: "\\ec63";
}

.ri-dribbble-line:before {
  content: "\\ec64";
}

.ri-drive-fill:before {
  content: "\\ec65";
}

.ri-drive-line:before {
  content: "\\ec66";
}

.ri-drizzle-fill:before {
  content: "\\ec67";
}

.ri-drizzle-line:before {
  content: "\\ec68";
}

.ri-drop-fill:before {
  content: "\\ec69";
}

.ri-drop-line:before {
  content: "\\ec6a";
}

.ri-dropbox-fill:before {
  content: "\\ec6b";
}

.ri-dropbox-line:before {
  content: "\\ec6c";
}

.ri-dual-sim-1-fill:before {
  content: "\\ec6d";
}

.ri-dual-sim-1-line:before {
  content: "\\ec6e";
}

.ri-dual-sim-2-fill:before {
  content: "\\ec6f";
}

.ri-dual-sim-2-line:before {
  content: "\\ec70";
}

.ri-dv-fill:before {
  content: "\\ec71";
}

.ri-dv-line:before {
  content: "\\ec72";
}

.ri-dvd-fill:before {
  content: "\\ec73";
}

.ri-dvd-line:before {
  content: "\\ec74";
}

.ri-e-bike-2-fill:before {
  content: "\\ec75";
}

.ri-e-bike-2-line:before {
  content: "\\ec76";
}

.ri-e-bike-fill:before {
  content: "\\ec77";
}

.ri-e-bike-line:before {
  content: "\\ec78";
}

.ri-earth-fill:before {
  content: "\\ec79";
}

.ri-earth-line:before {
  content: "\\ec7a";
}

.ri-earthquake-fill:before {
  content: "\\ec7b";
}

.ri-earthquake-line:before {
  content: "\\ec7c";
}

.ri-edge-fill:before {
  content: "\\ec7d";
}

.ri-edge-line:before {
  content: "\\ec7e";
}

.ri-edit-2-fill:before {
  content: "\\ec7f";
}

.ri-edit-2-line:before {
  content: "\\ec80";
}

.ri-edit-box-fill:before {
  content: "\\ec81";
}

.ri-edit-box-line:before {
  content: "\\ec82";
}

.ri-edit-circle-fill:before {
  content: "\\ec83";
}

.ri-edit-circle-line:before {
  content: "\\ec84";
}

.ri-edit-fill:before {
  content: "\\ec85";
}

.ri-edit-line:before {
  content: "\\ec86";
}

.ri-eject-fill:before {
  content: "\\ec87";
}

.ri-eject-line:before {
  content: "\\ec88";
}

.ri-emotion-2-fill:before {
  content: "\\ec89";
}

.ri-emotion-2-line:before {
  content: "\\ec8a";
}

.ri-emotion-fill:before {
  content: "\\ec8b";
}

.ri-emotion-happy-fill:before {
  content: "\\ec8c";
}

.ri-emotion-happy-line:before {
  content: "\\ec8d";
}

.ri-emotion-laugh-fill:before {
  content: "\\ec8e";
}

.ri-emotion-laugh-line:before {
  content: "\\ec8f";
}

.ri-emotion-line:before {
  content: "\\ec90";
}

.ri-emotion-normal-fill:before {
  content: "\\ec91";
}

.ri-emotion-normal-line:before {
  content: "\\ec92";
}

.ri-emotion-sad-fill:before {
  content: "\\ec93";
}

.ri-emotion-sad-line:before {
  content: "\\ec94";
}

.ri-emotion-unhappy-fill:before {
  content: "\\ec95";
}

.ri-emotion-unhappy-line:before {
  content: "\\ec96";
}

.ri-empathize-fill:before {
  content: "\\ec97";
}

.ri-empathize-line:before {
  content: "\\ec98";
}

.ri-emphasis-cn:before {
  content: "\\ec99";
}

.ri-emphasis:before {
  content: "\\ec9a";
}

.ri-english-input:before {
  content: "\\ec9b";
}

.ri-equalizer-fill:before {
  content: "\\ec9c";
}

.ri-equalizer-line:before {
  content: "\\ec9d";
}

.ri-eraser-fill:before {
  content: "\\ec9e";
}

.ri-eraser-line:before {
  content: "\\ec9f";
}

.ri-error-warning-fill:before {
  content: "\\eca0";
}

.ri-error-warning-line:before {
  content: "\\eca1";
}

.ri-evernote-fill:before {
  content: "\\eca2";
}

.ri-evernote-line:before {
  content: "\\eca3";
}

.ri-exchange-box-fill:before {
  content: "\\eca4";
}

.ri-exchange-box-line:before {
  content: "\\eca5";
}

.ri-exchange-cny-fill:before {
  content: "\\eca6";
}

.ri-exchange-cny-line:before {
  content: "\\eca7";
}

.ri-exchange-dollar-fill:before {
  content: "\\eca8";
}

.ri-exchange-dollar-line:before {
  content: "\\eca9";
}

.ri-exchange-fill:before {
  content: "\\ecaa";
}

.ri-exchange-funds-fill:before {
  content: "\\ecab";
}

.ri-exchange-funds-line:before {
  content: "\\ecac";
}

.ri-exchange-line:before {
  content: "\\ecad";
}

.ri-external-link-fill:before {
  content: "\\ecae";
}

.ri-external-link-line:before {
  content: "\\ecaf";
}

.ri-eye-2-fill:before {
  content: "\\ecb0";
}

.ri-eye-2-line:before {
  content: "\\ecb1";
}

.ri-eye-close-fill:before {
  content: "\\ecb2";
}

.ri-eye-close-line:before {
  content: "\\ecb3";
}

.ri-eye-fill:before {
  content: "\\ecb4";
}

.ri-eye-line:before {
  content: "\\ecb5";
}

.ri-eye-off-fill:before {
  content: "\\ecb6";
}

.ri-eye-off-line:before {
  content: "\\ecb7";
}

.ri-facebook-box-fill:before {
  content: "\\ecb8";
}

.ri-facebook-box-line:before {
  content: "\\ecb9";
}

.ri-facebook-circle-fill:before {
  content: "\\ecba";
}

.ri-facebook-circle-line:before {
  content: "\\ecbb";
}

.ri-facebook-fill:before {
  content: "\\ecbc";
}

.ri-facebook-line:before {
  content: "\\ecbd";
}

.ri-fahrenheit-fill:before {
  content: "\\ecbe";
}

.ri-fahrenheit-line:before {
  content: "\\ecbf";
}

.ri-feedback-fill:before {
  content: "\\ecc0";
}

.ri-feedback-line:before {
  content: "\\ecc1";
}

.ri-file-2-fill:before {
  content: "\\ecc2";
}

.ri-file-2-line:before {
  content: "\\ecc3";
}

.ri-file-3-fill:before {
  content: "\\ecc4";
}

.ri-file-3-line:before {
  content: "\\ecc5";
}

.ri-file-4-fill:before {
  content: "\\ecc6";
}

.ri-file-4-line:before {
  content: "\\ecc7";
}

.ri-file-add-fill:before {
  content: "\\ecc8";
}

.ri-file-add-line:before {
  content: "\\ecc9";
}

.ri-file-chart-2-fill:before {
  content: "\\ecca";
}

.ri-file-chart-2-line:before {
  content: "\\eccb";
}

.ri-file-chart-fill:before {
  content: "\\eccc";
}

.ri-file-chart-line:before {
  content: "\\eccd";
}

.ri-file-cloud-fill:before {
  content: "\\ecce";
}

.ri-file-cloud-line:before {
  content: "\\eccf";
}

.ri-file-code-fill:before {
  content: "\\ecd0";
}

.ri-file-code-line:before {
  content: "\\ecd1";
}

.ri-file-copy-2-fill:before {
  content: "\\ecd2";
}

.ri-file-copy-2-line:before {
  content: "\\ecd3";
}

.ri-file-copy-fill:before {
  content: "\\ecd4";
}

.ri-file-copy-line:before {
  content: "\\ecd5";
}

.ri-file-damage-fill:before {
  content: "\\ecd6";
}

.ri-file-damage-line:before {
  content: "\\ecd7";
}

.ri-file-download-fill:before {
  content: "\\ecd8";
}

.ri-file-download-line:before {
  content: "\\ecd9";
}

.ri-file-edit-fill:before {
  content: "\\ecda";
}

.ri-file-edit-line:before {
  content: "\\ecdb";
}

.ri-file-excel-2-fill:before {
  content: "\\ecdc";
}

.ri-file-excel-2-line:before {
  content: "\\ecdd";
}

.ri-file-excel-fill:before {
  content: "\\ecde";
}

.ri-file-excel-line:before {
  content: "\\ecdf";
}

.ri-file-fill:before {
  content: "\\ece0";
}

.ri-file-forbid-fill:before {
  content: "\\ece1";
}

.ri-file-forbid-line:before {
  content: "\\ece2";
}

.ri-file-gif-fill:before {
  content: "\\ece3";
}

.ri-file-gif-line:before {
  content: "\\ece4";
}

.ri-file-history-fill:before {
  content: "\\ece5";
}

.ri-file-history-line:before {
  content: "\\ece6";
}

.ri-file-hwp-fill:before {
  content: "\\ece7";
}

.ri-file-hwp-line:before {
  content: "\\ece8";
}

.ri-file-info-fill:before {
  content: "\\ece9";
}

.ri-file-info-line:before {
  content: "\\ecea";
}

.ri-file-line:before {
  content: "\\eceb";
}

.ri-file-list-2-fill:before {
  content: "\\ecec";
}

.ri-file-list-2-line:before {
  content: "\\eced";
}

.ri-file-list-3-fill:before {
  content: "\\ecee";
}

.ri-file-list-3-line:before {
  content: "\\ecef";
}

.ri-file-list-fill:before {
  content: "\\ecf0";
}

.ri-file-list-line:before {
  content: "\\ecf1";
}

.ri-file-lock-fill:before {
  content: "\\ecf2";
}

.ri-file-lock-line:before {
  content: "\\ecf3";
}

.ri-file-mark-fill:before {
  content: "\\ecf4";
}

.ri-file-mark-line:before {
  content: "\\ecf5";
}

.ri-file-music-fill:before {
  content: "\\ecf6";
}

.ri-file-music-line:before {
  content: "\\ecf7";
}

.ri-file-paper-2-fill:before {
  content: "\\ecf8";
}

.ri-file-paper-2-line:before {
  content: "\\ecf9";
}

.ri-file-paper-fill:before {
  content: "\\ecfa";
}

.ri-file-paper-line:before {
  content: "\\ecfb";
}

.ri-file-pdf-fill:before {
  content: "\\ecfc";
}

.ri-file-pdf-line:before {
  content: "\\ecfd";
}

.ri-file-ppt-2-fill:before {
  content: "\\ecfe";
}

.ri-file-ppt-2-line:before {
  content: "\\ecff";
}

.ri-file-ppt-fill:before {
  content: "\\ed00";
}

.ri-file-ppt-line:before {
  content: "\\ed01";
}

.ri-file-reduce-fill:before {
  content: "\\ed02";
}

.ri-file-reduce-line:before {
  content: "\\ed03";
}

.ri-file-search-fill:before {
  content: "\\ed04";
}

.ri-file-search-line:before {
  content: "\\ed05";
}

.ri-file-settings-fill:before {
  content: "\\ed06";
}

.ri-file-settings-line:before {
  content: "\\ed07";
}

.ri-file-shield-2-fill:before {
  content: "\\ed08";
}

.ri-file-shield-2-line:before {
  content: "\\ed09";
}

.ri-file-shield-fill:before {
  content: "\\ed0a";
}

.ri-file-shield-line:before {
  content: "\\ed0b";
}

.ri-file-shred-fill:before {
  content: "\\ed0c";
}

.ri-file-shred-line:before {
  content: "\\ed0d";
}

.ri-file-text-fill:before {
  content: "\\ed0e";
}

.ri-file-text-line:before {
  content: "\\ed0f";
}

.ri-file-transfer-fill:before {
  content: "\\ed10";
}

.ri-file-transfer-line:before {
  content: "\\ed11";
}

.ri-file-unknow-fill:before {
  content: "\\ed12";
}

.ri-file-unknow-line:before {
  content: "\\ed13";
}

.ri-file-upload-fill:before {
  content: "\\ed14";
}

.ri-file-upload-line:before {
  content: "\\ed15";
}

.ri-file-user-fill:before {
  content: "\\ed16";
}

.ri-file-user-line:before {
  content: "\\ed17";
}

.ri-file-warning-fill:before {
  content: "\\ed18";
}

.ri-file-warning-line:before {
  content: "\\ed19";
}

.ri-file-word-2-fill:before {
  content: "\\ed1a";
}

.ri-file-word-2-line:before {
  content: "\\ed1b";
}

.ri-file-word-fill:before {
  content: "\\ed1c";
}

.ri-file-word-line:before {
  content: "\\ed1d";
}

.ri-file-zip-fill:before {
  content: "\\ed1e";
}

.ri-file-zip-line:before {
  content: "\\ed1f";
}

.ri-film-fill:before {
  content: "\\ed20";
}

.ri-film-line:before {
  content: "\\ed21";
}

.ri-filter-2-fill:before {
  content: "\\ed22";
}

.ri-filter-2-line:before {
  content: "\\ed23";
}

.ri-filter-3-fill:before {
  content: "\\ed24";
}

.ri-filter-3-line:before {
  content: "\\ed25";
}

.ri-filter-fill:before {
  content: "\\ed26";
}

.ri-filter-line:before {
  content: "\\ed27";
}

.ri-filter-off-fill:before {
  content: "\\ed28";
}

.ri-filter-off-line:before {
  content: "\\ed29";
}

.ri-find-replace-fill:before {
  content: "\\ed2a";
}

.ri-find-replace-line:before {
  content: "\\ed2b";
}

.ri-finder-fill:before {
  content: "\\ed2c";
}

.ri-finder-line:before {
  content: "\\ed2d";
}

.ri-fingerprint-2-fill:before {
  content: "\\ed2e";
}

.ri-fingerprint-2-line:before {
  content: "\\ed2f";
}

.ri-fingerprint-fill:before {
  content: "\\ed30";
}

.ri-fingerprint-line:before {
  content: "\\ed31";
}

.ri-fire-fill:before {
  content: "\\ed32";
}

.ri-fire-line:before {
  content: "\\ed33";
}

.ri-firefox-fill:before {
  content: "\\ed34";
}

.ri-firefox-line:before {
  content: "\\ed35";
}

.ri-first-aid-kit-fill:before {
  content: "\\ed36";
}

.ri-first-aid-kit-line:before {
  content: "\\ed37";
}

.ri-flag-2-fill:before {
  content: "\\ed38";
}

.ri-flag-2-line:before {
  content: "\\ed39";
}

.ri-flag-fill:before {
  content: "\\ed3a";
}

.ri-flag-line:before {
  content: "\\ed3b";
}

.ri-flashlight-fill:before {
  content: "\\ed3c";
}

.ri-flashlight-line:before {
  content: "\\ed3d";
}

.ri-flask-fill:before {
  content: "\\ed3e";
}

.ri-flask-line:before {
  content: "\\ed3f";
}

.ri-flight-land-fill:before {
  content: "\\ed40";
}

.ri-flight-land-line:before {
  content: "\\ed41";
}

.ri-flight-takeoff-fill:before {
  content: "\\ed42";
}

.ri-flight-takeoff-line:before {
  content: "\\ed43";
}

.ri-flood-fill:before {
  content: "\\ed44";
}

.ri-flood-line:before {
  content: "\\ed45";
}

.ri-flow-chart:before {
  content: "\\ed46";
}

.ri-flutter-fill:before {
  content: "\\ed47";
}

.ri-flutter-line:before {
  content: "\\ed48";
}

.ri-focus-2-fill:before {
  content: "\\ed49";
}

.ri-focus-2-line:before {
  content: "\\ed4a";
}

.ri-focus-3-fill:before {
  content: "\\ed4b";
}

.ri-focus-3-line:before {
  content: "\\ed4c";
}

.ri-focus-fill:before {
  content: "\\ed4d";
}

.ri-focus-line:before {
  content: "\\ed4e";
}

.ri-foggy-fill:before {
  content: "\\ed4f";
}

.ri-foggy-line:before {
  content: "\\ed50";
}

.ri-folder-2-fill:before {
  content: "\\ed51";
}

.ri-folder-2-line:before {
  content: "\\ed52";
}

.ri-folder-3-fill:before {
  content: "\\ed53";
}

.ri-folder-3-line:before {
  content: "\\ed54";
}

.ri-folder-4-fill:before {
  content: "\\ed55";
}

.ri-folder-4-line:before {
  content: "\\ed56";
}

.ri-folder-5-fill:before {
  content: "\\ed57";
}

.ri-folder-5-line:before {
  content: "\\ed58";
}

.ri-folder-add-fill:before {
  content: "\\ed59";
}

.ri-folder-add-line:before {
  content: "\\ed5a";
}

.ri-folder-chart-2-fill:before {
  content: "\\ed5b";
}

.ri-folder-chart-2-line:before {
  content: "\\ed5c";
}

.ri-folder-chart-fill:before {
  content: "\\ed5d";
}

.ri-folder-chart-line:before {
  content: "\\ed5e";
}

.ri-folder-download-fill:before {
  content: "\\ed5f";
}

.ri-folder-download-line:before {
  content: "\\ed60";
}

.ri-folder-fill:before {
  content: "\\ed61";
}

.ri-folder-forbid-fill:before {
  content: "\\ed62";
}

.ri-folder-forbid-line:before {
  content: "\\ed63";
}

.ri-folder-history-fill:before {
  content: "\\ed64";
}

.ri-folder-history-line:before {
  content: "\\ed65";
}

.ri-folder-info-fill:before {
  content: "\\ed66";
}

.ri-folder-info-line:before {
  content: "\\ed67";
}

.ri-folder-keyhole-fill:before {
  content: "\\ed68";
}

.ri-folder-keyhole-line:before {
  content: "\\ed69";
}

.ri-folder-line:before {
  content: "\\ed6a";
}

.ri-folder-lock-fill:before {
  content: "\\ed6b";
}

.ri-folder-lock-line:before {
  content: "\\ed6c";
}

.ri-folder-music-fill:before {
  content: "\\ed6d";
}

.ri-folder-music-line:before {
  content: "\\ed6e";
}

.ri-folder-open-fill:before {
  content: "\\ed6f";
}

.ri-folder-open-line:before {
  content: "\\ed70";
}

.ri-folder-received-fill:before {
  content: "\\ed71";
}

.ri-folder-received-line:before {
  content: "\\ed72";
}

.ri-folder-reduce-fill:before {
  content: "\\ed73";
}

.ri-folder-reduce-line:before {
  content: "\\ed74";
}

.ri-folder-settings-fill:before {
  content: "\\ed75";
}

.ri-folder-settings-line:before {
  content: "\\ed76";
}

.ri-folder-shared-fill:before {
  content: "\\ed77";
}

.ri-folder-shared-line:before {
  content: "\\ed78";
}

.ri-folder-shield-2-fill:before {
  content: "\\ed79";
}

.ri-folder-shield-2-line:before {
  content: "\\ed7a";
}

.ri-folder-shield-fill:before {
  content: "\\ed7b";
}

.ri-folder-shield-line:before {
  content: "\\ed7c";
}

.ri-folder-transfer-fill:before {
  content: "\\ed7d";
}

.ri-folder-transfer-line:before {
  content: "\\ed7e";
}

.ri-folder-unknow-fill:before {
  content: "\\ed7f";
}

.ri-folder-unknow-line:before {
  content: "\\ed80";
}

.ri-folder-upload-fill:before {
  content: "\\ed81";
}

.ri-folder-upload-line:before {
  content: "\\ed82";
}

.ri-folder-user-fill:before {
  content: "\\ed83";
}

.ri-folder-user-line:before {
  content: "\\ed84";
}

.ri-folder-warning-fill:before {
  content: "\\ed85";
}

.ri-folder-warning-line:before {
  content: "\\ed86";
}

.ri-folder-zip-fill:before {
  content: "\\ed87";
}

.ri-folder-zip-line:before {
  content: "\\ed88";
}

.ri-folders-fill:before {
  content: "\\ed89";
}

.ri-folders-line:before {
  content: "\\ed8a";
}

.ri-font-color:before {
  content: "\\ed8b";
}

.ri-font-size-2:before {
  content: "\\ed8c";
}

.ri-font-size:before {
  content: "\\ed8d";
}

.ri-football-fill:before {
  content: "\\ed8e";
}

.ri-football-line:before {
  content: "\\ed8f";
}

.ri-footprint-fill:before {
  content: "\\ed90";
}

.ri-footprint-line:before {
  content: "\\ed91";
}

.ri-forbid-2-fill:before {
  content: "\\ed92";
}

.ri-forbid-2-line:before {
  content: "\\ed93";
}

.ri-forbid-fill:before {
  content: "\\ed94";
}

.ri-forbid-line:before {
  content: "\\ed95";
}

.ri-format-clear:before {
  content: "\\ed96";
}

.ri-fridge-fill:before {
  content: "\\ed97";
}

.ri-fridge-line:before {
  content: "\\ed98";
}

.ri-fullscreen-exit-fill:before {
  content: "\\ed99";
}

.ri-fullscreen-exit-line:before {
  content: "\\ed9a";
}

.ri-fullscreen-fill:before {
  content: "\\ed9b";
}

.ri-fullscreen-line:before {
  content: "\\ed9c";
}

.ri-function-fill:before {
  content: "\\ed9d";
}

.ri-function-line:before {
  content: "\\ed9e";
}

.ri-functions:before {
  content: "\\ed9f";
}

.ri-funds-box-fill:before {
  content: "\\eda0";
}

.ri-funds-box-line:before {
  content: "\\eda1";
}

.ri-funds-fill:before {
  content: "\\eda2";
}

.ri-funds-line:before {
  content: "\\eda3";
}

.ri-gallery-fill:before {
  content: "\\eda4";
}

.ri-gallery-line:before {
  content: "\\eda5";
}

.ri-gallery-upload-fill:before {
  content: "\\eda6";
}

.ri-gallery-upload-line:before {
  content: "\\eda7";
}

.ri-game-fill:before {
  content: "\\eda8";
}

.ri-game-line:before {
  content: "\\eda9";
}

.ri-gamepad-fill:before {
  content: "\\edaa";
}

.ri-gamepad-line:before {
  content: "\\edab";
}

.ri-gas-station-fill:before {
  content: "\\edac";
}

.ri-gas-station-line:before {
  content: "\\edad";
}

.ri-gatsby-fill:before {
  content: "\\edae";
}

.ri-gatsby-line:before {
  content: "\\edaf";
}

.ri-genderless-fill:before {
  content: "\\edb0";
}

.ri-genderless-line:before {
  content: "\\edb1";
}

.ri-ghost-2-fill:before {
  content: "\\edb2";
}

.ri-ghost-2-line:before {
  content: "\\edb3";
}

.ri-ghost-fill:before {
  content: "\\edb4";
}

.ri-ghost-line:before {
  content: "\\edb5";
}

.ri-ghost-smile-fill:before {
  content: "\\edb6";
}

.ri-ghost-smile-line:before {
  content: "\\edb7";
}

.ri-gift-2-fill:before {
  content: "\\edb8";
}

.ri-gift-2-line:before {
  content: "\\edb9";
}

.ri-gift-fill:before {
  content: "\\edba";
}

.ri-gift-line:before {
  content: "\\edbb";
}

.ri-git-branch-fill:before {
  content: "\\edbc";
}

.ri-git-branch-line:before {
  content: "\\edbd";
}

.ri-git-commit-fill:before {
  content: "\\edbe";
}

.ri-git-commit-line:before {
  content: "\\edbf";
}

.ri-git-merge-fill:before {
  content: "\\edc0";
}

.ri-git-merge-line:before {
  content: "\\edc1";
}

.ri-git-pull-request-fill:before {
  content: "\\edc2";
}

.ri-git-pull-request-line:before {
  content: "\\edc3";
}

.ri-git-repository-commits-fill:before {
  content: "\\edc4";
}

.ri-git-repository-commits-line:before {
  content: "\\edc5";
}

.ri-git-repository-fill:before {
  content: "\\edc6";
}

.ri-git-repository-line:before {
  content: "\\edc7";
}

.ri-git-repository-private-fill:before {
  content: "\\edc8";
}

.ri-git-repository-private-line:before {
  content: "\\edc9";
}

.ri-github-fill:before {
  content: "\\edca";
}

.ri-github-line:before {
  content: "\\edcb";
}

.ri-gitlab-fill:before {
  content: "\\edcc";
}

.ri-gitlab-line:before {
  content: "\\edcd";
}

.ri-global-fill:before {
  content: "\\edce";
}

.ri-global-line:before {
  content: "\\edcf";
}

.ri-globe-fill:before {
  content: "\\edd0";
}

.ri-globe-line:before {
  content: "\\edd1";
}

.ri-goblet-fill:before {
  content: "\\edd2";
}

.ri-goblet-line:before {
  content: "\\edd3";
}

.ri-google-fill:before {
  content: "\\edd4";
}

.ri-google-line:before {
  content: "\\edd5";
}

.ri-google-play-fill:before {
  content: "\\edd6";
}

.ri-google-play-line:before {
  content: "\\edd7";
}

.ri-government-fill:before {
  content: "\\edd8";
}

.ri-government-line:before {
  content: "\\edd9";
}

.ri-gps-fill:before {
  content: "\\edda";
}

.ri-gps-line:before {
  content: "\\eddb";
}

.ri-gradienter-fill:before {
  content: "\\eddc";
}

.ri-gradienter-line:before {
  content: "\\eddd";
}

.ri-grid-fill:before {
  content: "\\edde";
}

.ri-grid-line:before {
  content: "\\eddf";
}

.ri-group-2-fill:before {
  content: "\\ede0";
}

.ri-group-2-line:before {
  content: "\\ede1";
}

.ri-group-fill:before {
  content: "\\ede2";
}

.ri-group-line:before {
  content: "\\ede3";
}

.ri-guide-fill:before {
  content: "\\ede4";
}

.ri-guide-line:before {
  content: "\\ede5";
}

.ri-h-1:before {
  content: "\\ede6";
}

.ri-h-2:before {
  content: "\\ede7";
}

.ri-h-3:before {
  content: "\\ede8";
}

.ri-h-4:before {
  content: "\\ede9";
}

.ri-h-5:before {
  content: "\\edea";
}

.ri-h-6:before {
  content: "\\edeb";
}

.ri-hail-fill:before {
  content: "\\edec";
}

.ri-hail-line:before {
  content: "\\eded";
}

.ri-hammer-fill:before {
  content: "\\edee";
}

.ri-hammer-line:before {
  content: "\\edef";
}

.ri-hand-coin-fill:before {
  content: "\\edf0";
}

.ri-hand-coin-line:before {
  content: "\\edf1";
}

.ri-hand-heart-fill:before {
  content: "\\edf2";
}

.ri-hand-heart-line:before {
  content: "\\edf3";
}

.ri-hand-sanitizer-fill:before {
  content: "\\edf4";
}

.ri-hand-sanitizer-line:before {
  content: "\\edf5";
}

.ri-handbag-fill:before {
  content: "\\edf6";
}

.ri-handbag-line:before {
  content: "\\edf7";
}

.ri-hard-drive-2-fill:before {
  content: "\\edf8";
}

.ri-hard-drive-2-line:before {
  content: "\\edf9";
}

.ri-hard-drive-fill:before {
  content: "\\edfa";
}

.ri-hard-drive-line:before {
  content: "\\edfb";
}

.ri-hashtag:before {
  content: "\\edfc";
}

.ri-haze-2-fill:before {
  content: "\\edfd";
}

.ri-haze-2-line:before {
  content: "\\edfe";
}

.ri-haze-fill:before {
  content: "\\edff";
}

.ri-haze-line:before {
  content: "\\ee00";
}

.ri-hd-fill:before {
  content: "\\ee01";
}

.ri-hd-line:before {
  content: "\\ee02";
}

.ri-heading:before {
  content: "\\ee03";
}

.ri-headphone-fill:before {
  content: "\\ee04";
}

.ri-headphone-line:before {
  content: "\\ee05";
}

.ri-health-book-fill:before {
  content: "\\ee06";
}

.ri-health-book-line:before {
  content: "\\ee07";
}

.ri-heart-2-fill:before {
  content: "\\ee08";
}

.ri-heart-2-line:before {
  content: "\\ee09";
}

.ri-heart-3-fill:before {
  content: "\\ee0a";
}

.ri-heart-3-line:before {
  content: "\\ee0b";
}

.ri-heart-add-fill:before {
  content: "\\ee0c";
}

.ri-heart-add-line:before {
  content: "\\ee0d";
}

.ri-heart-fill:before {
  content: "\\ee0e";
}

.ri-heart-line:before {
  content: "\\ee0f";
}

.ri-heart-pulse-fill:before {
  content: "\\ee10";
}

.ri-heart-pulse-line:before {
  content: "\\ee11";
}

.ri-hearts-fill:before {
  content: "\\ee12";
}

.ri-hearts-line:before {
  content: "\\ee13";
}

.ri-heavy-showers-fill:before {
  content: "\\ee14";
}

.ri-heavy-showers-line:before {
  content: "\\ee15";
}

.ri-history-fill:before {
  content: "\\ee16";
}

.ri-history-line:before {
  content: "\\ee17";
}

.ri-home-2-fill:before {
  content: "\\ee18";
}

.ri-home-2-line:before {
  content: "\\ee19";
}

.ri-home-3-fill:before {
  content: "\\ee1a";
}

.ri-home-3-line:before {
  content: "\\ee1b";
}

.ri-home-4-fill:before {
  content: "\\ee1c";
}

.ri-home-4-line:before {
  content: "\\ee1d";
}

.ri-home-5-fill:before {
  content: "\\ee1e";
}

.ri-home-5-line:before {
  content: "\\ee1f";
}

.ri-home-6-fill:before {
  content: "\\ee20";
}

.ri-home-6-line:before {
  content: "\\ee21";
}

.ri-home-7-fill:before {
  content: "\\ee22";
}

.ri-home-7-line:before {
  content: "\\ee23";
}

.ri-home-8-fill:before {
  content: "\\ee24";
}

.ri-home-8-line:before {
  content: "\\ee25";
}

.ri-home-fill:before {
  content: "\\ee26";
}

.ri-home-gear-fill:before {
  content: "\\ee27";
}

.ri-home-gear-line:before {
  content: "\\ee28";
}

.ri-home-heart-fill:before {
  content: "\\ee29";
}

.ri-home-heart-line:before {
  content: "\\ee2a";
}

.ri-home-line:before {
  content: "\\ee2b";
}

.ri-home-smile-2-fill:before {
  content: "\\ee2c";
}

.ri-home-smile-2-line:before {
  content: "\\ee2d";
}

.ri-home-smile-fill:before {
  content: "\\ee2e";
}

.ri-home-smile-line:before {
  content: "\\ee2f";
}

.ri-home-wifi-fill:before {
  content: "\\ee30";
}

.ri-home-wifi-line:before {
  content: "\\ee31";
}

.ri-honor-of-kings-fill:before {
  content: "\\ee32";
}

.ri-honor-of-kings-line:before {
  content: "\\ee33";
}

.ri-honour-fill:before {
  content: "\\ee34";
}

.ri-honour-line:before {
  content: "\\ee35";
}

.ri-hospital-fill:before {
  content: "\\ee36";
}

.ri-hospital-line:before {
  content: "\\ee37";
}

.ri-hotel-bed-fill:before {
  content: "\\ee38";
}

.ri-hotel-bed-line:before {
  content: "\\ee39";
}

.ri-hotel-fill:before {
  content: "\\ee3a";
}

.ri-hotel-line:before {
  content: "\\ee3b";
}

.ri-hotspot-fill:before {
  content: "\\ee3c";
}

.ri-hotspot-line:before {
  content: "\\ee3d";
}

.ri-hq-fill:before {
  content: "\\ee3e";
}

.ri-hq-line:before {
  content: "\\ee3f";
}

.ri-html5-fill:before {
  content: "\\ee40";
}

.ri-html5-line:before {
  content: "\\ee41";
}

.ri-ie-fill:before {
  content: "\\ee42";
}

.ri-ie-line:before {
  content: "\\ee43";
}

.ri-image-2-fill:before {
  content: "\\ee44";
}

.ri-image-2-line:before {
  content: "\\ee45";
}

.ri-image-add-fill:before {
  content: "\\ee46";
}

.ri-image-add-line:before {
  content: "\\ee47";
}

.ri-image-edit-fill:before {
  content: "\\ee48";
}

.ri-image-edit-line:before {
  content: "\\ee49";
}

.ri-image-fill:before {
  content: "\\ee4a";
}

.ri-image-line:before {
  content: "\\ee4b";
}

.ri-inbox-archive-fill:before {
  content: "\\ee4c";
}

.ri-inbox-archive-line:before {
  content: "\\ee4d";
}

.ri-inbox-fill:before {
  content: "\\ee4e";
}

.ri-inbox-line:before {
  content: "\\ee4f";
}

.ri-inbox-unarchive-fill:before {
  content: "\\ee50";
}

.ri-inbox-unarchive-line:before {
  content: "\\ee51";
}

.ri-increase-decrease-fill:before {
  content: "\\ee52";
}

.ri-increase-decrease-line:before {
  content: "\\ee53";
}

.ri-indent-decrease:before {
  content: "\\ee54";
}

.ri-indent-increase:before {
  content: "\\ee55";
}

.ri-indeterminate-circle-fill:before {
  content: "\\ee56";
}

.ri-indeterminate-circle-line:before {
  content: "\\ee57";
}

.ri-information-fill:before {
  content: "\\ee58";
}

.ri-information-line:before {
  content: "\\ee59";
}

.ri-infrared-thermometer-fill:before {
  content: "\\ee5a";
}

.ri-infrared-thermometer-line:before {
  content: "\\ee5b";
}

.ri-ink-bottle-fill:before {
  content: "\\ee5c";
}

.ri-ink-bottle-line:before {
  content: "\\ee5d";
}

.ri-input-cursor-move:before {
  content: "\\ee5e";
}

.ri-input-method-fill:before {
  content: "\\ee5f";
}

.ri-input-method-line:before {
  content: "\\ee60";
}

.ri-insert-column-left:before {
  content: "\\ee61";
}

.ri-insert-column-right:before {
  content: "\\ee62";
}

.ri-insert-row-bottom:before {
  content: "\\ee63";
}

.ri-insert-row-top:before {
  content: "\\ee64";
}

.ri-instagram-fill:before {
  content: "\\ee65";
}

.ri-instagram-line:before {
  content: "\\ee66";
}

.ri-install-fill:before {
  content: "\\ee67";
}

.ri-install-line:before {
  content: "\\ee68";
}

.ri-invision-fill:before {
  content: "\\ee69";
}

.ri-invision-line:before {
  content: "\\ee6a";
}

.ri-italic:before {
  content: "\\ee6b";
}

.ri-kakao-talk-fill:before {
  content: "\\ee6c";
}

.ri-kakao-talk-line:before {
  content: "\\ee6d";
}

.ri-key-2-fill:before {
  content: "\\ee6e";
}

.ri-key-2-line:before {
  content: "\\ee6f";
}

.ri-key-fill:before {
  content: "\\ee70";
}

.ri-key-line:before {
  content: "\\ee71";
}

.ri-keyboard-box-fill:before {
  content: "\\ee72";
}

.ri-keyboard-box-line:before {
  content: "\\ee73";
}

.ri-keyboard-fill:before {
  content: "\\ee74";
}

.ri-keyboard-line:before {
  content: "\\ee75";
}

.ri-keynote-fill:before {
  content: "\\ee76";
}

.ri-keynote-line:before {
  content: "\\ee77";
}

.ri-knife-blood-fill:before {
  content: "\\ee78";
}

.ri-knife-blood-line:before {
  content: "\\ee79";
}

.ri-knife-fill:before {
  content: "\\ee7a";
}

.ri-knife-line:before {
  content: "\\ee7b";
}

.ri-landscape-fill:before {
  content: "\\ee7c";
}

.ri-landscape-line:before {
  content: "\\ee7d";
}

.ri-layout-2-fill:before {
  content: "\\ee7e";
}

.ri-layout-2-line:before {
  content: "\\ee7f";
}

.ri-layout-3-fill:before {
  content: "\\ee80";
}

.ri-layout-3-line:before {
  content: "\\ee81";
}

.ri-layout-4-fill:before {
  content: "\\ee82";
}

.ri-layout-4-line:before {
  content: "\\ee83";
}

.ri-layout-5-fill:before {
  content: "\\ee84";
}

.ri-layout-5-line:before {
  content: "\\ee85";
}

.ri-layout-6-fill:before {
  content: "\\ee86";
}

.ri-layout-6-line:before {
  content: "\\ee87";
}

.ri-layout-bottom-2-fill:before {
  content: "\\ee88";
}

.ri-layout-bottom-2-line:before {
  content: "\\ee89";
}

.ri-layout-bottom-fill:before {
  content: "\\ee8a";
}

.ri-layout-bottom-line:before {
  content: "\\ee8b";
}

.ri-layout-column-fill:before {
  content: "\\ee8c";
}

.ri-layout-column-line:before {
  content: "\\ee8d";
}

.ri-layout-fill:before {
  content: "\\ee8e";
}

.ri-layout-grid-fill:before {
  content: "\\ee8f";
}

.ri-layout-grid-line:before {
  content: "\\ee90";
}

.ri-layout-left-2-fill:before {
  content: "\\ee91";
}

.ri-layout-left-2-line:before {
  content: "\\ee92";
}

.ri-layout-left-fill:before {
  content: "\\ee93";
}

.ri-layout-left-line:before {
  content: "\\ee94";
}

.ri-layout-line:before {
  content: "\\ee95";
}

.ri-layout-masonry-fill:before {
  content: "\\ee96";
}

.ri-layout-masonry-line:before {
  content: "\\ee97";
}

.ri-layout-right-2-fill:before {
  content: "\\ee98";
}

.ri-layout-right-2-line:before {
  content: "\\ee99";
}

.ri-layout-right-fill:before {
  content: "\\ee9a";
}

.ri-layout-right-line:before {
  content: "\\ee9b";
}

.ri-layout-row-fill:before {
  content: "\\ee9c";
}

.ri-layout-row-line:before {
  content: "\\ee9d";
}

.ri-layout-top-2-fill:before {
  content: "\\ee9e";
}

.ri-layout-top-2-line:before {
  content: "\\ee9f";
}

.ri-layout-top-fill:before {
  content: "\\eea0";
}

.ri-layout-top-line:before {
  content: "\\eea1";
}

.ri-leaf-fill:before {
  content: "\\eea2";
}

.ri-leaf-line:before {
  content: "\\eea3";
}

.ri-lifebuoy-fill:before {
  content: "\\eea4";
}

.ri-lifebuoy-line:before {
  content: "\\eea5";
}

.ri-lightbulb-fill:before {
  content: "\\eea6";
}

.ri-lightbulb-flash-fill:before {
  content: "\\eea7";
}

.ri-lightbulb-flash-line:before {
  content: "\\eea8";
}

.ri-lightbulb-line:before {
  content: "\\eea9";
}

.ri-line-chart-fill:before {
  content: "\\eeaa";
}

.ri-line-chart-line:before {
  content: "\\eeab";
}

.ri-line-fill:before {
  content: "\\eeac";
}

.ri-line-height:before {
  content: "\\eead";
}

.ri-line-line:before {
  content: "\\eeae";
}

.ri-link-m:before {
  content: "\\eeaf";
}

.ri-link-unlink-m:before {
  content: "\\eeb0";
}

.ri-link-unlink:before {
  content: "\\eeb1";
}

.ri-link:before {
  content: "\\eeb2";
}

.ri-linkedin-box-fill:before {
  content: "\\eeb3";
}

.ri-linkedin-box-line:before {
  content: "\\eeb4";
}

.ri-linkedin-fill:before {
  content: "\\eeb5";
}

.ri-linkedin-line:before {
  content: "\\eeb6";
}

.ri-links-fill:before {
  content: "\\eeb7";
}

.ri-links-line:before {
  content: "\\eeb8";
}

.ri-list-check-2:before {
  content: "\\eeb9";
}

.ri-list-check:before {
  content: "\\eeba";
}

.ri-list-ordered:before {
  content: "\\eebb";
}

.ri-list-settings-fill:before {
  content: "\\eebc";
}

.ri-list-settings-line:before {
  content: "\\eebd";
}

.ri-list-unordered:before {
  content: "\\eebe";
}

.ri-live-fill:before {
  content: "\\eebf";
}

.ri-live-line:before {
  content: "\\eec0";
}

.ri-loader-2-fill:before {
  content: "\\eec1";
}

.ri-loader-2-line:before {
  content: "\\eec2";
}

.ri-loader-3-fill:before {
  content: "\\eec3";
}

.ri-loader-3-line:before {
  content: "\\eec4";
}

.ri-loader-4-fill:before {
  content: "\\eec5";
}

.ri-loader-4-line:before {
  content: "\\eec6";
}

.ri-loader-5-fill:before {
  content: "\\eec7";
}

.ri-loader-5-line:before {
  content: "\\eec8";
}

.ri-loader-fill:before {
  content: "\\eec9";
}

.ri-loader-line:before {
  content: "\\eeca";
}

.ri-lock-2-fill:before {
  content: "\\eecb";
}

.ri-lock-2-line:before {
  content: "\\eecc";
}

.ri-lock-fill:before {
  content: "\\eecd";
}

.ri-lock-line:before {
  content: "\\eece";
}

.ri-lock-password-fill:before {
  content: "\\eecf";
}

.ri-lock-password-line:before {
  content: "\\eed0";
}

.ri-lock-unlock-fill:before {
  content: "\\eed1";
}

.ri-lock-unlock-line:before {
  content: "\\eed2";
}

.ri-login-box-fill:before {
  content: "\\eed3";
}

.ri-login-box-line:before {
  content: "\\eed4";
}

.ri-login-circle-fill:before {
  content: "\\eed5";
}

.ri-login-circle-line:before {
  content: "\\eed6";
}

.ri-logout-box-fill:before {
  content: "\\eed7";
}

.ri-logout-box-line:before {
  content: "\\eed8";
}

.ri-logout-box-r-fill:before {
  content: "\\eed9";
}

.ri-logout-box-r-line:before {
  content: "\\eeda";
}

.ri-logout-circle-fill:before {
  content: "\\eedb";
}

.ri-logout-circle-line:before {
  content: "\\eedc";
}

.ri-logout-circle-r-fill:before {
  content: "\\eedd";
}

.ri-logout-circle-r-line:before {
  content: "\\eede";
}

.ri-luggage-cart-fill:before {
  content: "\\eedf";
}

.ri-luggage-cart-line:before {
  content: "\\eee0";
}

.ri-luggage-deposit-fill:before {
  content: "\\eee1";
}

.ri-luggage-deposit-line:before {
  content: "\\eee2";
}

.ri-lungs-fill:before {
  content: "\\eee3";
}

.ri-lungs-line:before {
  content: "\\eee4";
}

.ri-mac-fill:before {
  content: "\\eee5";
}

.ri-mac-line:before {
  content: "\\eee6";
}

.ri-macbook-fill:before {
  content: "\\eee7";
}

.ri-macbook-line:before {
  content: "\\eee8";
}

.ri-magic-fill:before {
  content: "\\eee9";
}

.ri-magic-line:before {
  content: "\\eeea";
}

.ri-mail-add-fill:before {
  content: "\\eeeb";
}

.ri-mail-add-line:before {
  content: "\\eeec";
}

.ri-mail-check-fill:before {
  content: "\\eeed";
}

.ri-mail-check-line:before {
  content: "\\eeee";
}

.ri-mail-close-fill:before {
  content: "\\eeef";
}

.ri-mail-close-line:before {
  content: "\\eef0";
}

.ri-mail-download-fill:before {
  content: "\\eef1";
}

.ri-mail-download-line:before {
  content: "\\eef2";
}

.ri-mail-fill:before {
  content: "\\eef3";
}

.ri-mail-forbid-fill:before {
  content: "\\eef4";
}

.ri-mail-forbid-line:before {
  content: "\\eef5";
}

.ri-mail-line:before {
  content: "\\eef6";
}

.ri-mail-lock-fill:before {
  content: "\\eef7";
}

.ri-mail-lock-line:before {
  content: "\\eef8";
}

.ri-mail-open-fill:before {
  content: "\\eef9";
}

.ri-mail-open-line:before {
  content: "\\eefa";
}

.ri-mail-send-fill:before {
  content: "\\eefb";
}

.ri-mail-send-line:before {
  content: "\\eefc";
}

.ri-mail-settings-fill:before {
  content: "\\eefd";
}

.ri-mail-settings-line:before {
  content: "\\eefe";
}

.ri-mail-star-fill:before {
  content: "\\eeff";
}

.ri-mail-star-line:before {
  content: "\\ef00";
}

.ri-mail-unread-fill:before {
  content: "\\ef01";
}

.ri-mail-unread-line:before {
  content: "\\ef02";
}

.ri-mail-volume-fill:before {
  content: "\\ef03";
}

.ri-mail-volume-line:before {
  content: "\\ef04";
}

.ri-map-2-fill:before {
  content: "\\ef05";
}

.ri-map-2-line:before {
  content: "\\ef06";
}

.ri-map-fill:before {
  content: "\\ef07";
}

.ri-map-line:before {
  content: "\\ef08";
}

.ri-map-pin-2-fill:before {
  content: "\\ef09";
}

.ri-map-pin-2-line:before {
  content: "\\ef0a";
}

.ri-map-pin-3-fill:before {
  content: "\\ef0b";
}

.ri-map-pin-3-line:before {
  content: "\\ef0c";
}

.ri-map-pin-4-fill:before {
  content: "\\ef0d";
}

.ri-map-pin-4-line:before {
  content: "\\ef0e";
}

.ri-map-pin-5-fill:before {
  content: "\\ef0f";
}

.ri-map-pin-5-line:before {
  content: "\\ef10";
}

.ri-map-pin-add-fill:before {
  content: "\\ef11";
}

.ri-map-pin-add-line:before {
  content: "\\ef12";
}

.ri-map-pin-fill:before {
  content: "\\ef13";
}

.ri-map-pin-line:before {
  content: "\\ef14";
}

.ri-map-pin-range-fill:before {
  content: "\\ef15";
}

.ri-map-pin-range-line:before {
  content: "\\ef16";
}

.ri-map-pin-time-fill:before {
  content: "\\ef17";
}

.ri-map-pin-time-line:before {
  content: "\\ef18";
}

.ri-map-pin-user-fill:before {
  content: "\\ef19";
}

.ri-map-pin-user-line:before {
  content: "\\ef1a";
}

.ri-mark-pen-fill:before {
  content: "\\ef1b";
}

.ri-mark-pen-line:before {
  content: "\\ef1c";
}

.ri-markdown-fill:before {
  content: "\\ef1d";
}

.ri-markdown-line:before {
  content: "\\ef1e";
}

.ri-markup-fill:before {
  content: "\\ef1f";
}

.ri-markup-line:before {
  content: "\\ef20";
}

.ri-mastercard-fill:before {
  content: "\\ef21";
}

.ri-mastercard-line:before {
  content: "\\ef22";
}

.ri-mastodon-fill:before {
  content: "\\ef23";
}

.ri-mastodon-line:before {
  content: "\\ef24";
}

.ri-medal-2-fill:before {
  content: "\\ef25";
}

.ri-medal-2-line:before {
  content: "\\ef26";
}

.ri-medal-fill:before {
  content: "\\ef27";
}

.ri-medal-line:before {
  content: "\\ef28";
}

.ri-medicine-bottle-fill:before {
  content: "\\ef29";
}

.ri-medicine-bottle-line:before {
  content: "\\ef2a";
}

.ri-medium-fill:before {
  content: "\\ef2b";
}

.ri-medium-line:before {
  content: "\\ef2c";
}

.ri-men-fill:before {
  content: "\\ef2d";
}

.ri-men-line:before {
  content: "\\ef2e";
}

.ri-mental-health-fill:before {
  content: "\\ef2f";
}

.ri-mental-health-line:before {
  content: "\\ef30";
}

.ri-menu-2-fill:before {
  content: "\\ef31";
}

.ri-menu-2-line:before {
  content: "\\ef32";
}

.ri-menu-3-fill:before {
  content: "\\ef33";
}

.ri-menu-3-line:before {
  content: "\\ef34";
}

.ri-menu-4-fill:before {
  content: "\\ef35";
}

.ri-menu-4-line:before {
  content: "\\ef36";
}

.ri-menu-5-fill:before {
  content: "\\ef37";
}

.ri-menu-5-line:before {
  content: "\\ef38";
}

.ri-menu-add-fill:before {
  content: "\\ef39";
}

.ri-menu-add-line:before {
  content: "\\ef3a";
}

.ri-menu-fill:before {
  content: "\\ef3b";
}

.ri-menu-fold-fill:before {
  content: "\\ef3c";
}

.ri-menu-fold-line:before {
  content: "\\ef3d";
}

.ri-menu-line:before {
  content: "\\ef3e";
}

.ri-menu-unfold-fill:before {
  content: "\\ef3f";
}

.ri-menu-unfold-line:before {
  content: "\\ef40";
}

.ri-merge-cells-horizontal:before {
  content: "\\ef41";
}

.ri-merge-cells-vertical:before {
  content: "\\ef42";
}

.ri-message-2-fill:before {
  content: "\\ef43";
}

.ri-message-2-line:before {
  content: "\\ef44";
}

.ri-message-3-fill:before {
  content: "\\ef45";
}

.ri-message-3-line:before {
  content: "\\ef46";
}

.ri-message-fill:before {
  content: "\\ef47";
}

.ri-message-line:before {
  content: "\\ef48";
}

.ri-messenger-fill:before {
  content: "\\ef49";
}

.ri-messenger-line:before {
  content: "\\ef4a";
}

.ri-meteor-fill:before {
  content: "\\ef4b";
}

.ri-meteor-line:before {
  content: "\\ef4c";
}

.ri-mic-2-fill:before {
  content: "\\ef4d";
}

.ri-mic-2-line:before {
  content: "\\ef4e";
}

.ri-mic-fill:before {
  content: "\\ef4f";
}

.ri-mic-line:before {
  content: "\\ef50";
}

.ri-mic-off-fill:before {
  content: "\\ef51";
}

.ri-mic-off-line:before {
  content: "\\ef52";
}

.ri-mickey-fill:before {
  content: "\\ef53";
}

.ri-mickey-line:before {
  content: "\\ef54";
}

.ri-microscope-fill:before {
  content: "\\ef55";
}

.ri-microscope-line:before {
  content: "\\ef56";
}

.ri-microsoft-fill:before {
  content: "\\ef57";
}

.ri-microsoft-line:before {
  content: "\\ef58";
}

.ri-mind-map:before {
  content: "\\ef59";
}

.ri-mini-program-fill:before {
  content: "\\ef5a";
}

.ri-mini-program-line:before {
  content: "\\ef5b";
}

.ri-mist-fill:before {
  content: "\\ef5c";
}

.ri-mist-line:before {
  content: "\\ef5d";
}

.ri-money-cny-box-fill:before {
  content: "\\ef5e";
}

.ri-money-cny-box-line:before {
  content: "\\ef5f";
}

.ri-money-cny-circle-fill:before {
  content: "\\ef60";
}

.ri-money-cny-circle-line:before {
  content: "\\ef61";
}

.ri-money-dollar-box-fill:before {
  content: "\\ef62";
}

.ri-money-dollar-box-line:before {
  content: "\\ef63";
}

.ri-money-dollar-circle-fill:before {
  content: "\\ef64";
}

.ri-money-dollar-circle-line:before {
  content: "\\ef65";
}

.ri-money-euro-box-fill:before {
  content: "\\ef66";
}

.ri-money-euro-box-line:before {
  content: "\\ef67";
}

.ri-money-euro-circle-fill:before {
  content: "\\ef68";
}

.ri-money-euro-circle-line:before {
  content: "\\ef69";
}

.ri-money-pound-box-fill:before {
  content: "\\ef6a";
}

.ri-money-pound-box-line:before {
  content: "\\ef6b";
}

.ri-money-pound-circle-fill:before {
  content: "\\ef6c";
}

.ri-money-pound-circle-line:before {
  content: "\\ef6d";
}

.ri-moon-clear-fill:before {
  content: "\\ef6e";
}

.ri-moon-clear-line:before {
  content: "\\ef6f";
}

.ri-moon-cloudy-fill:before {
  content: "\\ef70";
}

.ri-moon-cloudy-line:before {
  content: "\\ef71";
}

.ri-moon-fill:before {
  content: "\\ef72";
}

.ri-moon-foggy-fill:before {
  content: "\\ef73";
}

.ri-moon-foggy-line:before {
  content: "\\ef74";
}

.ri-moon-line:before {
  content: "\\ef75";
}

.ri-more-2-fill:before {
  content: "\\ef76";
}

.ri-more-2-line:before {
  content: "\\ef77";
}

.ri-more-fill:before {
  content: "\\ef78";
}

.ri-more-line:before {
  content: "\\ef79";
}

.ri-motorbike-fill:before {
  content: "\\ef7a";
}

.ri-motorbike-line:before {
  content: "\\ef7b";
}

.ri-mouse-fill:before {
  content: "\\ef7c";
}

.ri-mouse-line:before {
  content: "\\ef7d";
}

.ri-movie-2-fill:before {
  content: "\\ef7e";
}

.ri-movie-2-line:before {
  content: "\\ef7f";
}

.ri-movie-fill:before {
  content: "\\ef80";
}

.ri-movie-line:before {
  content: "\\ef81";
}

.ri-music-2-fill:before {
  content: "\\ef82";
}

.ri-music-2-line:before {
  content: "\\ef83";
}

.ri-music-fill:before {
  content: "\\ef84";
}

.ri-music-line:before {
  content: "\\ef85";
}

.ri-mv-fill:before {
  content: "\\ef86";
}

.ri-mv-line:before {
  content: "\\ef87";
}

.ri-navigation-fill:before {
  content: "\\ef88";
}

.ri-navigation-line:before {
  content: "\\ef89";
}

.ri-netease-cloud-music-fill:before {
  content: "\\ef8a";
}

.ri-netease-cloud-music-line:before {
  content: "\\ef8b";
}

.ri-netflix-fill:before {
  content: "\\ef8c";
}

.ri-netflix-line:before {
  content: "\\ef8d";
}

.ri-newspaper-fill:before {
  content: "\\ef8e";
}

.ri-newspaper-line:before {
  content: "\\ef8f";
}

.ri-node-tree:before {
  content: "\\ef90";
}

.ri-notification-2-fill:before {
  content: "\\ef91";
}

.ri-notification-2-line:before {
  content: "\\ef92";
}

.ri-notification-3-fill:before {
  content: "\\ef93";
}

.ri-notification-3-line:before {
  content: "\\ef94";
}

.ri-notification-4-fill:before {
  content: "\\ef95";
}

.ri-notification-4-line:before {
  content: "\\ef96";
}

.ri-notification-badge-fill:before {
  content: "\\ef97";
}

.ri-notification-badge-line:before {
  content: "\\ef98";
}

.ri-notification-fill:before {
  content: "\\ef99";
}

.ri-notification-line:before {
  content: "\\ef9a";
}

.ri-notification-off-fill:before {
  content: "\\ef9b";
}

.ri-notification-off-line:before {
  content: "\\ef9c";
}

.ri-npmjs-fill:before {
  content: "\\ef9d";
}

.ri-npmjs-line:before {
  content: "\\ef9e";
}

.ri-number-0:before {
  content: "\\ef9f";
}

.ri-number-1:before {
  content: "\\efa0";
}

.ri-number-2:before {
  content: "\\efa1";
}

.ri-number-3:before {
  content: "\\efa2";
}

.ri-number-4:before {
  content: "\\efa3";
}

.ri-number-5:before {
  content: "\\efa4";
}

.ri-number-6:before {
  content: "\\efa5";
}

.ri-number-7:before {
  content: "\\efa6";
}

.ri-number-8:before {
  content: "\\efa7";
}

.ri-number-9:before {
  content: "\\efa8";
}

.ri-numbers-fill:before {
  content: "\\efa9";
}

.ri-numbers-line:before {
  content: "\\efaa";
}

.ri-nurse-fill:before {
  content: "\\efab";
}

.ri-nurse-line:before {
  content: "\\efac";
}

.ri-oil-fill:before {
  content: "\\efad";
}

.ri-oil-line:before {
  content: "\\efae";
}

.ri-omega:before {
  content: "\\efaf";
}

.ri-open-arm-fill:before {
  content: "\\efb0";
}

.ri-open-arm-line:before {
  content: "\\efb1";
}

.ri-open-source-fill:before {
  content: "\\efb2";
}

.ri-open-source-line:before {
  content: "\\efb3";
}

.ri-opera-fill:before {
  content: "\\efb4";
}

.ri-opera-line:before {
  content: "\\efb5";
}

.ri-order-play-fill:before {
  content: "\\efb6";
}

.ri-order-play-line:before {
  content: "\\efb7";
}

.ri-organization-chart:before {
  content: "\\efb8";
}

.ri-outlet-2-fill:before {
  content: "\\efb9";
}

.ri-outlet-2-line:before {
  content: "\\efba";
}

.ri-outlet-fill:before {
  content: "\\efbb";
}

.ri-outlet-line:before {
  content: "\\efbc";
}

.ri-page-separator:before {
  content: "\\efbd";
}

.ri-pages-fill:before {
  content: "\\efbe";
}

.ri-pages-line:before {
  content: "\\efbf";
}

.ri-paint-brush-fill:before {
  content: "\\efc0";
}

.ri-paint-brush-line:before {
  content: "\\efc1";
}

.ri-paint-fill:before {
  content: "\\efc2";
}

.ri-paint-line:before {
  content: "\\efc3";
}

.ri-palette-fill:before {
  content: "\\efc4";
}

.ri-palette-line:before {
  content: "\\efc5";
}

.ri-pantone-fill:before {
  content: "\\efc6";
}

.ri-pantone-line:before {
  content: "\\efc7";
}

.ri-paragraph:before {
  content: "\\efc8";
}

.ri-parent-fill:before {
  content: "\\efc9";
}

.ri-parent-line:before {
  content: "\\efca";
}

.ri-parentheses-fill:before {
  content: "\\efcb";
}

.ri-parentheses-line:before {
  content: "\\efcc";
}

.ri-parking-box-fill:before {
  content: "\\efcd";
}

.ri-parking-box-line:before {
  content: "\\efce";
}

.ri-parking-fill:before {
  content: "\\efcf";
}

.ri-parking-line:before {
  content: "\\efd0";
}

.ri-passport-fill:before {
  content: "\\efd1";
}

.ri-passport-line:before {
  content: "\\efd2";
}

.ri-patreon-fill:before {
  content: "\\efd3";
}

.ri-patreon-line:before {
  content: "\\efd4";
}

.ri-pause-circle-fill:before {
  content: "\\efd5";
}

.ri-pause-circle-line:before {
  content: "\\efd6";
}

.ri-pause-fill:before {
  content: "\\efd7";
}

.ri-pause-line:before {
  content: "\\efd8";
}

.ri-pause-mini-fill:before {
  content: "\\efd9";
}

.ri-pause-mini-line:before {
  content: "\\efda";
}

.ri-paypal-fill:before {
  content: "\\efdb";
}

.ri-paypal-line:before {
  content: "\\efdc";
}

.ri-pen-nib-fill:before {
  content: "\\efdd";
}

.ri-pen-nib-line:before {
  content: "\\efde";
}

.ri-pencil-fill:before {
  content: "\\efdf";
}

.ri-pencil-line:before {
  content: "\\efe0";
}

.ri-pencil-ruler-2-fill:before {
  content: "\\efe1";
}

.ri-pencil-ruler-2-line:before {
  content: "\\efe2";
}

.ri-pencil-ruler-fill:before {
  content: "\\efe3";
}

.ri-pencil-ruler-line:before {
  content: "\\efe4";
}

.ri-percent-fill:before {
  content: "\\efe5";
}

.ri-percent-line:before {
  content: "\\efe6";
}

.ri-phone-camera-fill:before {
  content: "\\efe7";
}

.ri-phone-camera-line:before {
  content: "\\efe8";
}

.ri-phone-fill:before {
  content: "\\efe9";
}

.ri-phone-find-fill:before {
  content: "\\efea";
}

.ri-phone-find-line:before {
  content: "\\efeb";
}

.ri-phone-line:before {
  content: "\\efec";
}

.ri-phone-lock-fill:before {
  content: "\\efed";
}

.ri-phone-lock-line:before {
  content: "\\efee";
}

.ri-picture-in-picture-2-fill:before {
  content: "\\efef";
}

.ri-picture-in-picture-2-line:before {
  content: "\\eff0";
}

.ri-picture-in-picture-exit-fill:before {
  content: "\\eff1";
}

.ri-picture-in-picture-exit-line:before {
  content: "\\eff2";
}

.ri-picture-in-picture-fill:before {
  content: "\\eff3";
}

.ri-picture-in-picture-line:before {
  content: "\\eff4";
}

.ri-pie-chart-2-fill:before {
  content: "\\eff5";
}

.ri-pie-chart-2-line:before {
  content: "\\eff6";
}

.ri-pie-chart-box-fill:before {
  content: "\\eff7";
}

.ri-pie-chart-box-line:before {
  content: "\\eff8";
}

.ri-pie-chart-fill:before {
  content: "\\eff9";
}

.ri-pie-chart-line:before {
  content: "\\effa";
}

.ri-pin-distance-fill:before {
  content: "\\effb";
}

.ri-pin-distance-line:before {
  content: "\\effc";
}

.ri-ping-pong-fill:before {
  content: "\\effd";
}

.ri-ping-pong-line:before {
  content: "\\effe";
}

.ri-pinterest-fill:before {
  content: "\\efff";
}

.ri-pinterest-line:before {
  content: "\\f000";
}

.ri-pinyin-input:before {
  content: "\\f001";
}

.ri-pixelfed-fill:before {
  content: "\\f002";
}

.ri-pixelfed-line:before {
  content: "\\f003";
}

.ri-plane-fill:before {
  content: "\\f004";
}

.ri-plane-line:before {
  content: "\\f005";
}

.ri-plant-fill:before {
  content: "\\f006";
}

.ri-plant-line:before {
  content: "\\f007";
}

.ri-play-circle-fill:before {
  content: "\\f008";
}

.ri-play-circle-line:before {
  content: "\\f009";
}

.ri-play-fill:before {
  content: "\\f00a";
}

.ri-play-line:before {
  content: "\\f00b";
}

.ri-play-list-2-fill:before {
  content: "\\f00c";
}

.ri-play-list-2-line:before {
  content: "\\f00d";
}

.ri-play-list-add-fill:before {
  content: "\\f00e";
}

.ri-play-list-add-line:before {
  content: "\\f00f";
}

.ri-play-list-fill:before {
  content: "\\f010";
}

.ri-play-list-line:before {
  content: "\\f011";
}

.ri-play-mini-fill:before {
  content: "\\f012";
}

.ri-play-mini-line:before {
  content: "\\f013";
}

.ri-playstation-fill:before {
  content: "\\f014";
}

.ri-playstation-line:before {
  content: "\\f015";
}

.ri-plug-2-fill:before {
  content: "\\f016";
}

.ri-plug-2-line:before {
  content: "\\f017";
}

.ri-plug-fill:before {
  content: "\\f018";
}

.ri-plug-line:before {
  content: "\\f019";
}

.ri-polaroid-2-fill:before {
  content: "\\f01a";
}

.ri-polaroid-2-line:before {
  content: "\\f01b";
}

.ri-polaroid-fill:before {
  content: "\\f01c";
}

.ri-polaroid-line:before {
  content: "\\f01d";
}

.ri-police-car-fill:before {
  content: "\\f01e";
}

.ri-police-car-line:before {
  content: "\\f01f";
}

.ri-price-tag-2-fill:before {
  content: "\\f020";
}

.ri-price-tag-2-line:before {
  content: "\\f021";
}

.ri-price-tag-3-fill:before {
  content: "\\f022";
}

.ri-price-tag-3-line:before {
  content: "\\f023";
}

.ri-price-tag-fill:before {
  content: "\\f024";
}

.ri-price-tag-line:before {
  content: "\\f025";
}

.ri-printer-cloud-fill:before {
  content: "\\f026";
}

.ri-printer-cloud-line:before {
  content: "\\f027";
}

.ri-printer-fill:before {
  content: "\\f028";
}

.ri-printer-line:before {
  content: "\\f029";
}

.ri-product-hunt-fill:before {
  content: "\\f02a";
}

.ri-product-hunt-line:before {
  content: "\\f02b";
}

.ri-profile-fill:before {
  content: "\\f02c";
}

.ri-profile-line:before {
  content: "\\f02d";
}

.ri-projector-2-fill:before {
  content: "\\f02e";
}

.ri-projector-2-line:before {
  content: "\\f02f";
}

.ri-projector-fill:before {
  content: "\\f030";
}

.ri-projector-line:before {
  content: "\\f031";
}

.ri-psychotherapy-fill:before {
  content: "\\f032";
}

.ri-psychotherapy-line:before {
  content: "\\f033";
}

.ri-pulse-fill:before {
  content: "\\f034";
}

.ri-pulse-line:before {
  content: "\\f035";
}

.ri-pushpin-2-fill:before {
  content: "\\f036";
}

.ri-pushpin-2-line:before {
  content: "\\f037";
}

.ri-pushpin-fill:before {
  content: "\\f038";
}

.ri-pushpin-line:before {
  content: "\\f039";
}

.ri-qq-fill:before {
  content: "\\f03a";
}

.ri-qq-line:before {
  content: "\\f03b";
}

.ri-qr-code-fill:before {
  content: "\\f03c";
}

.ri-qr-code-line:before {
  content: "\\f03d";
}

.ri-qr-scan-2-fill:before {
  content: "\\f03e";
}

.ri-qr-scan-2-line:before {
  content: "\\f03f";
}

.ri-qr-scan-fill:before {
  content: "\\f040";
}

.ri-qr-scan-line:before {
  content: "\\f041";
}

.ri-question-answer-fill:before {
  content: "\\f042";
}

.ri-question-answer-line:before {
  content: "\\f043";
}

.ri-question-fill:before {
  content: "\\f044";
}

.ri-question-line:before {
  content: "\\f045";
}

.ri-question-mark:before {
  content: "\\f046";
}

.ri-questionnaire-fill:before {
  content: "\\f047";
}

.ri-questionnaire-line:before {
  content: "\\f048";
}

.ri-quill-pen-fill:before {
  content: "\\f049";
}

.ri-quill-pen-line:before {
  content: "\\f04a";
}

.ri-radar-fill:before {
  content: "\\f04b";
}

.ri-radar-line:before {
  content: "\\f04c";
}

.ri-radio-2-fill:before {
  content: "\\f04d";
}

.ri-radio-2-line:before {
  content: "\\f04e";
}

.ri-radio-button-fill:before {
  content: "\\f04f";
}

.ri-radio-button-line:before {
  content: "\\f050";
}

.ri-radio-fill:before {
  content: "\\f051";
}

.ri-radio-line:before {
  content: "\\f052";
}

.ri-rainbow-fill:before {
  content: "\\f053";
}

.ri-rainbow-line:before {
  content: "\\f054";
}

.ri-rainy-fill:before {
  content: "\\f055";
}

.ri-rainy-line:before {
  content: "\\f056";
}

.ri-reactjs-fill:before {
  content: "\\f057";
}

.ri-reactjs-line:before {
  content: "\\f058";
}

.ri-record-circle-fill:before {
  content: "\\f059";
}

.ri-record-circle-line:before {
  content: "\\f05a";
}

.ri-record-mail-fill:before {
  content: "\\f05b";
}

.ri-record-mail-line:before {
  content: "\\f05c";
}

.ri-recycle-fill:before {
  content: "\\f05d";
}

.ri-recycle-line:before {
  content: "\\f05e";
}

.ri-red-packet-fill:before {
  content: "\\f05f";
}

.ri-red-packet-line:before {
  content: "\\f060";
}

.ri-reddit-fill:before {
  content: "\\f061";
}

.ri-reddit-line:before {
  content: "\\f062";
}

.ri-refresh-fill:before {
  content: "\\f063";
}

.ri-refresh-line:before {
  content: "\\f064";
}

.ri-refund-2-fill:before {
  content: "\\f065";
}

.ri-refund-2-line:before {
  content: "\\f066";
}

.ri-refund-fill:before {
  content: "\\f067";
}

.ri-refund-line:before {
  content: "\\f068";
}

.ri-registered-fill:before {
  content: "\\f069";
}

.ri-registered-line:before {
  content: "\\f06a";
}

.ri-remixicon-fill:before {
  content: "\\f06b";
}

.ri-remixicon-line:before {
  content: "\\f06c";
}

.ri-remote-control-2-fill:before {
  content: "\\f06d";
}

.ri-remote-control-2-line:before {
  content: "\\f06e";
}

.ri-remote-control-fill:before {
  content: "\\f06f";
}

.ri-remote-control-line:before {
  content: "\\f070";
}

.ri-repeat-2-fill:before {
  content: "\\f071";
}

.ri-repeat-2-line:before {
  content: "\\f072";
}

.ri-repeat-fill:before {
  content: "\\f073";
}

.ri-repeat-line:before {
  content: "\\f074";
}

.ri-repeat-one-fill:before {
  content: "\\f075";
}

.ri-repeat-one-line:before {
  content: "\\f076";
}

.ri-reply-all-fill:before {
  content: "\\f077";
}

.ri-reply-all-line:before {
  content: "\\f078";
}

.ri-reply-fill:before {
  content: "\\f079";
}

.ri-reply-line:before {
  content: "\\f07a";
}

.ri-reserved-fill:before {
  content: "\\f07b";
}

.ri-reserved-line:before {
  content: "\\f07c";
}

.ri-rest-time-fill:before {
  content: "\\f07d";
}

.ri-rest-time-line:before {
  content: "\\f07e";
}

.ri-restart-fill:before {
  content: "\\f07f";
}

.ri-restart-line:before {
  content: "\\f080";
}

.ri-restaurant-2-fill:before {
  content: "\\f081";
}

.ri-restaurant-2-line:before {
  content: "\\f082";
}

.ri-restaurant-fill:before {
  content: "\\f083";
}

.ri-restaurant-line:before {
  content: "\\f084";
}

.ri-rewind-fill:before {
  content: "\\f085";
}

.ri-rewind-line:before {
  content: "\\f086";
}

.ri-rewind-mini-fill:before {
  content: "\\f087";
}

.ri-rewind-mini-line:before {
  content: "\\f088";
}

.ri-rhythm-fill:before {
  content: "\\f089";
}

.ri-rhythm-line:before {
  content: "\\f08a";
}

.ri-riding-fill:before {
  content: "\\f08b";
}

.ri-riding-line:before {
  content: "\\f08c";
}

.ri-road-map-fill:before {
  content: "\\f08d";
}

.ri-road-map-line:before {
  content: "\\f08e";
}

.ri-roadster-fill:before {
  content: "\\f08f";
}

.ri-roadster-line:before {
  content: "\\f090";
}

.ri-robot-fill:before {
  content: "\\f091";
}

.ri-robot-line:before {
  content: "\\f092";
}

.ri-rocket-2-fill:before {
  content: "\\f093";
}

.ri-rocket-2-line:before {
  content: "\\f094";
}

.ri-rocket-fill:before {
  content: "\\f095";
}

.ri-rocket-line:before {
  content: "\\f096";
}

.ri-rotate-lock-fill:before {
  content: "\\f097";
}

.ri-rotate-lock-line:before {
  content: "\\f098";
}

.ri-rounded-corner:before {
  content: "\\f099";
}

.ri-route-fill:before {
  content: "\\f09a";
}

.ri-route-line:before {
  content: "\\f09b";
}

.ri-router-fill:before {
  content: "\\f09c";
}

.ri-router-line:before {
  content: "\\f09d";
}

.ri-rss-fill:before {
  content: "\\f09e";
}

.ri-rss-line:before {
  content: "\\f09f";
}

.ri-ruler-2-fill:before {
  content: "\\f0a0";
}

.ri-ruler-2-line:before {
  content: "\\f0a1";
}

.ri-ruler-fill:before {
  content: "\\f0a2";
}

.ri-ruler-line:before {
  content: "\\f0a3";
}

.ri-run-fill:before {
  content: "\\f0a4";
}

.ri-run-line:before {
  content: "\\f0a5";
}

.ri-safari-fill:before {
  content: "\\f0a6";
}

.ri-safari-line:before {
  content: "\\f0a7";
}

.ri-safe-2-fill:before {
  content: "\\f0a8";
}

.ri-safe-2-line:before {
  content: "\\f0a9";
}

.ri-safe-fill:before {
  content: "\\f0aa";
}

.ri-safe-line:before {
  content: "\\f0ab";
}

.ri-sailboat-fill:before {
  content: "\\f0ac";
}

.ri-sailboat-line:before {
  content: "\\f0ad";
}

.ri-save-2-fill:before {
  content: "\\f0ae";
}

.ri-save-2-line:before {
  content: "\\f0af";
}

.ri-save-3-fill:before {
  content: "\\f0b0";
}

.ri-save-3-line:before {
  content: "\\f0b1";
}

.ri-save-fill:before {
  content: "\\f0b2";
}

.ri-save-line:before {
  content: "\\f0b3";
}

.ri-scales-2-fill:before {
  content: "\\f0b4";
}

.ri-scales-2-line:before {
  content: "\\f0b5";
}

.ri-scales-3-fill:before {
  content: "\\f0b6";
}

.ri-scales-3-line:before {
  content: "\\f0b7";
}

.ri-scales-fill:before {
  content: "\\f0b8";
}

.ri-scales-line:before {
  content: "\\f0b9";
}

.ri-scan-2-fill:before {
  content: "\\f0ba";
}

.ri-scan-2-line:before {
  content: "\\f0bb";
}

.ri-scan-fill:before {
  content: "\\f0bc";
}

.ri-scan-line:before {
  content: "\\f0bd";
}

.ri-scissors-2-fill:before {
  content: "\\f0be";
}

.ri-scissors-2-line:before {
  content: "\\f0bf";
}

.ri-scissors-cut-fill:before {
  content: "\\f0c0";
}

.ri-scissors-cut-line:before {
  content: "\\f0c1";
}

.ri-scissors-fill:before {
  content: "\\f0c2";
}

.ri-scissors-line:before {
  content: "\\f0c3";
}

.ri-screenshot-2-fill:before {
  content: "\\f0c4";
}

.ri-screenshot-2-line:before {
  content: "\\f0c5";
}

.ri-screenshot-fill:before {
  content: "\\f0c6";
}

.ri-screenshot-line:before {
  content: "\\f0c7";
}

.ri-sd-card-fill:before {
  content: "\\f0c8";
}

.ri-sd-card-line:before {
  content: "\\f0c9";
}

.ri-sd-card-mini-fill:before {
  content: "\\f0ca";
}

.ri-sd-card-mini-line:before {
  content: "\\f0cb";
}

.ri-search-2-fill:before {
  content: "\\f0cc";
}

.ri-search-2-line:before {
  content: "\\f0cd";
}

.ri-search-eye-fill:before {
  content: "\\f0ce";
}

.ri-search-eye-line:before {
  content: "\\f0cf";
}

.ri-search-fill:before {
  content: "\\f0d0";
}

.ri-search-line:before {
  content: "\\f0d1";
}

.ri-secure-payment-fill:before {
  content: "\\f0d2";
}

.ri-secure-payment-line:before {
  content: "\\f0d3";
}

.ri-seedling-fill:before {
  content: "\\f0d4";
}

.ri-seedling-line:before {
  content: "\\f0d5";
}

.ri-send-backward:before {
  content: "\\f0d6";
}

.ri-send-plane-2-fill:before {
  content: "\\f0d7";
}

.ri-send-plane-2-line:before {
  content: "\\f0d8";
}

.ri-send-plane-fill:before {
  content: "\\f0d9";
}

.ri-send-plane-line:before {
  content: "\\f0da";
}

.ri-send-to-back:before {
  content: "\\f0db";
}

.ri-sensor-fill:before {
  content: "\\f0dc";
}

.ri-sensor-line:before {
  content: "\\f0dd";
}

.ri-separator:before {
  content: "\\f0de";
}

.ri-server-fill:before {
  content: "\\f0df";
}

.ri-server-line:before {
  content: "\\f0e0";
}

.ri-service-fill:before {
  content: "\\f0e1";
}

.ri-service-line:before {
  content: "\\f0e2";
}

.ri-settings-2-fill:before {
  content: "\\f0e3";
}

.ri-settings-2-line:before {
  content: "\\f0e4";
}

.ri-settings-3-fill:before {
  content: "\\f0e5";
}

.ri-settings-3-line:before {
  content: "\\f0e6";
}

.ri-settings-4-fill:before {
  content: "\\f0e7";
}

.ri-settings-4-line:before {
  content: "\\f0e8";
}

.ri-settings-5-fill:before {
  content: "\\f0e9";
}

.ri-settings-5-line:before {
  content: "\\f0ea";
}

.ri-settings-6-fill:before {
  content: "\\f0eb";
}

.ri-settings-6-line:before {
  content: "\\f0ec";
}

.ri-settings-fill:before {
  content: "\\f0ed";
}

.ri-settings-line:before {
  content: "\\f0ee";
}

.ri-shape-2-fill:before {
  content: "\\f0ef";
}

.ri-shape-2-line:before {
  content: "\\f0f0";
}

.ri-shape-fill:before {
  content: "\\f0f1";
}

.ri-shape-line:before {
  content: "\\f0f2";
}

.ri-share-box-fill:before {
  content: "\\f0f3";
}

.ri-share-box-line:before {
  content: "\\f0f4";
}

.ri-share-circle-fill:before {
  content: "\\f0f5";
}

.ri-share-circle-line:before {
  content: "\\f0f6";
}

.ri-share-fill:before {
  content: "\\f0f7";
}

.ri-share-forward-2-fill:before {
  content: "\\f0f8";
}

.ri-share-forward-2-line:before {
  content: "\\f0f9";
}

.ri-share-forward-box-fill:before {
  content: "\\f0fa";
}

.ri-share-forward-box-line:before {
  content: "\\f0fb";
}

.ri-share-forward-fill:before {
  content: "\\f0fc";
}

.ri-share-forward-line:before {
  content: "\\f0fd";
}

.ri-share-line:before {
  content: "\\f0fe";
}

.ri-shield-check-fill:before {
  content: "\\f0ff";
}

.ri-shield-check-line:before {
  content: "\\f100";
}

.ri-shield-cross-fill:before {
  content: "\\f101";
}

.ri-shield-cross-line:before {
  content: "\\f102";
}

.ri-shield-fill:before {
  content: "\\f103";
}

.ri-shield-flash-fill:before {
  content: "\\f104";
}

.ri-shield-flash-line:before {
  content: "\\f105";
}

.ri-shield-keyhole-fill:before {
  content: "\\f106";
}

.ri-shield-keyhole-line:before {
  content: "\\f107";
}

.ri-shield-line:before {
  content: "\\f108";
}

.ri-shield-star-fill:before {
  content: "\\f109";
}

.ri-shield-star-line:before {
  content: "\\f10a";
}

.ri-shield-user-fill:before {
  content: "\\f10b";
}

.ri-shield-user-line:before {
  content: "\\f10c";
}

.ri-ship-2-fill:before {
  content: "\\f10d";
}

.ri-ship-2-line:before {
  content: "\\f10e";
}

.ri-ship-fill:before {
  content: "\\f10f";
}

.ri-ship-line:before {
  content: "\\f110";
}

.ri-shirt-fill:before {
  content: "\\f111";
}

.ri-shirt-line:before {
  content: "\\f112";
}

.ri-shopping-bag-2-fill:before {
  content: "\\f113";
}

.ri-shopping-bag-2-line:before {
  content: "\\f114";
}

.ri-shopping-bag-3-fill:before {
  content: "\\f115";
}

.ri-shopping-bag-3-line:before {
  content: "\\f116";
}

.ri-shopping-bag-fill:before {
  content: "\\f117";
}

.ri-shopping-bag-line:before {
  content: "\\f118";
}

.ri-shopping-basket-2-fill:before {
  content: "\\f119";
}

.ri-shopping-basket-2-line:before {
  content: "\\f11a";
}

.ri-shopping-basket-fill:before {
  content: "\\f11b";
}

.ri-shopping-basket-line:before {
  content: "\\f11c";
}

.ri-shopping-cart-2-fill:before {
  content: "\\f11d";
}

.ri-shopping-cart-2-line:before {
  content: "\\f11e";
}

.ri-shopping-cart-fill:before {
  content: "\\f11f";
}

.ri-shopping-cart-line:before {
  content: "\\f120";
}

.ri-showers-fill:before {
  content: "\\f121";
}

.ri-showers-line:before {
  content: "\\f122";
}

.ri-shuffle-fill:before {
  content: "\\f123";
}

.ri-shuffle-line:before {
  content: "\\f124";
}

.ri-shut-down-fill:before {
  content: "\\f125";
}

.ri-shut-down-line:before {
  content: "\\f126";
}

.ri-side-bar-fill:before {
  content: "\\f127";
}

.ri-side-bar-line:before {
  content: "\\f128";
}

.ri-signal-tower-fill:before {
  content: "\\f129";
}

.ri-signal-tower-line:before {
  content: "\\f12a";
}

.ri-signal-wifi-1-fill:before {
  content: "\\f12b";
}

.ri-signal-wifi-1-line:before {
  content: "\\f12c";
}

.ri-signal-wifi-2-fill:before {
  content: "\\f12d";
}

.ri-signal-wifi-2-line:before {
  content: "\\f12e";
}

.ri-signal-wifi-3-fill:before {
  content: "\\f12f";
}

.ri-signal-wifi-3-line:before {
  content: "\\f130";
}

.ri-signal-wifi-error-fill:before {
  content: "\\f131";
}

.ri-signal-wifi-error-line:before {
  content: "\\f132";
}

.ri-signal-wifi-fill:before {
  content: "\\f133";
}

.ri-signal-wifi-line:before {
  content: "\\f134";
}

.ri-signal-wifi-off-fill:before {
  content: "\\f135";
}

.ri-signal-wifi-off-line:before {
  content: "\\f136";
}

.ri-sim-card-2-fill:before {
  content: "\\f137";
}

.ri-sim-card-2-line:before {
  content: "\\f138";
}

.ri-sim-card-fill:before {
  content: "\\f139";
}

.ri-sim-card-line:before {
  content: "\\f13a";
}

.ri-single-quotes-l:before {
  content: "\\f13b";
}

.ri-single-quotes-r:before {
  content: "\\f13c";
}

.ri-sip-fill:before {
  content: "\\f13d";
}

.ri-sip-line:before {
  content: "\\f13e";
}

.ri-skip-back-fill:before {
  content: "\\f13f";
}

.ri-skip-back-line:before {
  content: "\\f140";
}

.ri-skip-back-mini-fill:before {
  content: "\\f141";
}

.ri-skip-back-mini-line:before {
  content: "\\f142";
}

.ri-skip-forward-fill:before {
  content: "\\f143";
}

.ri-skip-forward-line:before {
  content: "\\f144";
}

.ri-skip-forward-mini-fill:before {
  content: "\\f145";
}

.ri-skip-forward-mini-line:before {
  content: "\\f146";
}

.ri-skull-2-fill:before {
  content: "\\f147";
}

.ri-skull-2-line:before {
  content: "\\f148";
}

.ri-skull-fill:before {
  content: "\\f149";
}

.ri-skull-line:before {
  content: "\\f14a";
}

.ri-skype-fill:before {
  content: "\\f14b";
}

.ri-skype-line:before {
  content: "\\f14c";
}

.ri-slack-fill:before {
  content: "\\f14d";
}

.ri-slack-line:before {
  content: "\\f14e";
}

.ri-slice-fill:before {
  content: "\\f14f";
}

.ri-slice-line:before {
  content: "\\f150";
}

.ri-slideshow-2-fill:before {
  content: "\\f151";
}

.ri-slideshow-2-line:before {
  content: "\\f152";
}

.ri-slideshow-3-fill:before {
  content: "\\f153";
}

.ri-slideshow-3-line:before {
  content: "\\f154";
}

.ri-slideshow-4-fill:before {
  content: "\\f155";
}

.ri-slideshow-4-line:before {
  content: "\\f156";
}

.ri-slideshow-fill:before {
  content: "\\f157";
}

.ri-slideshow-line:before {
  content: "\\f158";
}

.ri-smartphone-fill:before {
  content: "\\f159";
}

.ri-smartphone-line:before {
  content: "\\f15a";
}

.ri-snapchat-fill:before {
  content: "\\f15b";
}

.ri-snapchat-line:before {
  content: "\\f15c";
}

.ri-snowy-fill:before {
  content: "\\f15d";
}

.ri-snowy-line:before {
  content: "\\f15e";
}

.ri-sort-asc:before {
  content: "\\f15f";
}

.ri-sort-desc:before {
  content: "\\f160";
}

.ri-sound-module-fill:before {
  content: "\\f161";
}

.ri-sound-module-line:before {
  content: "\\f162";
}

.ri-soundcloud-fill:before {
  content: "\\f163";
}

.ri-soundcloud-line:before {
  content: "\\f164";
}

.ri-space-ship-fill:before {
  content: "\\f165";
}

.ri-space-ship-line:before {
  content: "\\f166";
}

.ri-space:before {
  content: "\\f167";
}

.ri-spam-2-fill:before {
  content: "\\f168";
}

.ri-spam-2-line:before {
  content: "\\f169";
}

.ri-spam-3-fill:before {
  content: "\\f16a";
}

.ri-spam-3-line:before {
  content: "\\f16b";
}

.ri-spam-fill:before {
  content: "\\f16c";
}

.ri-spam-line:before {
  content: "\\f16d";
}

.ri-speaker-2-fill:before {
  content: "\\f16e";
}

.ri-speaker-2-line:before {
  content: "\\f16f";
}

.ri-speaker-3-fill:before {
  content: "\\f170";
}

.ri-speaker-3-line:before {
  content: "\\f171";
}

.ri-speaker-fill:before {
  content: "\\f172";
}

.ri-speaker-line:before {
  content: "\\f173";
}

.ri-spectrum-fill:before {
  content: "\\f174";
}

.ri-spectrum-line:before {
  content: "\\f175";
}

.ri-speed-fill:before {
  content: "\\f176";
}

.ri-speed-line:before {
  content: "\\f177";
}

.ri-speed-mini-fill:before {
  content: "\\f178";
}

.ri-speed-mini-line:before {
  content: "\\f179";
}

.ri-split-cells-horizontal:before {
  content: "\\f17a";
}

.ri-split-cells-vertical:before {
  content: "\\f17b";
}

.ri-spotify-fill:before {
  content: "\\f17c";
}

.ri-spotify-line:before {
  content: "\\f17d";
}

.ri-spy-fill:before {
  content: "\\f17e";
}

.ri-spy-line:before {
  content: "\\f17f";
}

.ri-stack-fill:before {
  content: "\\f180";
}

.ri-stack-line:before {
  content: "\\f181";
}

.ri-stack-overflow-fill:before {
  content: "\\f182";
}

.ri-stack-overflow-line:before {
  content: "\\f183";
}

.ri-stackshare-fill:before {
  content: "\\f184";
}

.ri-stackshare-line:before {
  content: "\\f185";
}

.ri-star-fill:before {
  content: "\\f186";
}

.ri-star-half-fill:before {
  content: "\\f187";
}

.ri-star-half-line:before {
  content: "\\f188";
}

.ri-star-half-s-fill:before {
  content: "\\f189";
}

.ri-star-half-s-line:before {
  content: "\\f18a";
}

.ri-star-line:before {
  content: "\\f18b";
}

.ri-star-s-fill:before {
  content: "\\f18c";
}

.ri-star-s-line:before {
  content: "\\f18d";
}

.ri-star-smile-fill:before {
  content: "\\f18e";
}

.ri-star-smile-line:before {
  content: "\\f18f";
}

.ri-steam-fill:before {
  content: "\\f190";
}

.ri-steam-line:before {
  content: "\\f191";
}

.ri-steering-2-fill:before {
  content: "\\f192";
}

.ri-steering-2-line:before {
  content: "\\f193";
}

.ri-steering-fill:before {
  content: "\\f194";
}

.ri-steering-line:before {
  content: "\\f195";
}

.ri-stethoscope-fill:before {
  content: "\\f196";
}

.ri-stethoscope-line:before {
  content: "\\f197";
}

.ri-sticky-note-2-fill:before {
  content: "\\f198";
}

.ri-sticky-note-2-line:before {
  content: "\\f199";
}

.ri-sticky-note-fill:before {
  content: "\\f19a";
}

.ri-sticky-note-line:before {
  content: "\\f19b";
}

.ri-stock-fill:before {
  content: "\\f19c";
}

.ri-stock-line:before {
  content: "\\f19d";
}

.ri-stop-circle-fill:before {
  content: "\\f19e";
}

.ri-stop-circle-line:before {
  content: "\\f19f";
}

.ri-stop-fill:before {
  content: "\\f1a0";
}

.ri-stop-line:before {
  content: "\\f1a1";
}

.ri-stop-mini-fill:before {
  content: "\\f1a2";
}

.ri-stop-mini-line:before {
  content: "\\f1a3";
}

.ri-store-2-fill:before {
  content: "\\f1a4";
}

.ri-store-2-line:before {
  content: "\\f1a5";
}

.ri-store-3-fill:before {
  content: "\\f1a6";
}

.ri-store-3-line:before {
  content: "\\f1a7";
}

.ri-store-fill:before {
  content: "\\f1a8";
}

.ri-store-line:before {
  content: "\\f1a9";
}

.ri-strikethrough-2:before {
  content: "\\f1aa";
}

.ri-strikethrough:before {
  content: "\\f1ab";
}

.ri-subscript-2:before {
  content: "\\f1ac";
}

.ri-subscript:before {
  content: "\\f1ad";
}

.ri-subtract-fill:before {
  content: "\\f1ae";
}

.ri-subtract-line:before {
  content: "\\f1af";
}

.ri-subway-fill:before {
  content: "\\f1b0";
}

.ri-subway-line:before {
  content: "\\f1b1";
}

.ri-subway-wifi-fill:before {
  content: "\\f1b2";
}

.ri-subway-wifi-line:before {
  content: "\\f1b3";
}

.ri-suitcase-2-fill:before {
  content: "\\f1b4";
}

.ri-suitcase-2-line:before {
  content: "\\f1b5";
}

.ri-suitcase-3-fill:before {
  content: "\\f1b6";
}

.ri-suitcase-3-line:before {
  content: "\\f1b7";
}

.ri-suitcase-fill:before {
  content: "\\f1b8";
}

.ri-suitcase-line:before {
  content: "\\f1b9";
}

.ri-sun-cloudy-fill:before {
  content: "\\f1ba";
}

.ri-sun-cloudy-line:before {
  content: "\\f1bb";
}

.ri-sun-fill:before {
  content: "\\f1bc";
}

.ri-sun-foggy-fill:before {
  content: "\\f1bd";
}

.ri-sun-foggy-line:before {
  content: "\\f1be";
}

.ri-sun-line:before {
  content: "\\f1bf";
}

.ri-superscript-2:before {
  content: "\\f1c0";
}

.ri-superscript:before {
  content: "\\f1c1";
}

.ri-surgical-mask-fill:before {
  content: "\\f1c2";
}

.ri-surgical-mask-line:before {
  content: "\\f1c3";
}

.ri-surround-sound-fill:before {
  content: "\\f1c4";
}

.ri-surround-sound-line:before {
  content: "\\f1c5";
}

.ri-survey-fill:before {
  content: "\\f1c6";
}

.ri-survey-line:before {
  content: "\\f1c7";
}

.ri-swap-box-fill:before {
  content: "\\f1c8";
}

.ri-swap-box-line:before {
  content: "\\f1c9";
}

.ri-swap-fill:before {
  content: "\\f1ca";
}

.ri-swap-line:before {
  content: "\\f1cb";
}

.ri-switch-fill:before {
  content: "\\f1cc";
}

.ri-switch-line:before {
  content: "\\f1cd";
}

.ri-sword-fill:before {
  content: "\\f1ce";
}

.ri-sword-line:before {
  content: "\\f1cf";
}

.ri-syringe-fill:before {
  content: "\\f1d0";
}

.ri-syringe-line:before {
  content: "\\f1d1";
}

.ri-t-box-fill:before {
  content: "\\f1d2";
}

.ri-t-box-line:before {
  content: "\\f1d3";
}

.ri-t-shirt-2-fill:before {
  content: "\\f1d4";
}

.ri-t-shirt-2-line:before {
  content: "\\f1d5";
}

.ri-t-shirt-air-fill:before {
  content: "\\f1d6";
}

.ri-t-shirt-air-line:before {
  content: "\\f1d7";
}

.ri-t-shirt-fill:before {
  content: "\\f1d8";
}

.ri-t-shirt-line:before {
  content: "\\f1d9";
}

.ri-table-2:before {
  content: "\\f1da";
}

.ri-table-alt-fill:before {
  content: "\\f1db";
}

.ri-table-alt-line:before {
  content: "\\f1dc";
}

.ri-table-fill:before {
  content: "\\f1dd";
}

.ri-table-line:before {
  content: "\\f1de";
}

.ri-tablet-fill:before {
  content: "\\f1df";
}

.ri-tablet-line:before {
  content: "\\f1e0";
}

.ri-takeaway-fill:before {
  content: "\\f1e1";
}

.ri-takeaway-line:before {
  content: "\\f1e2";
}

.ri-taobao-fill:before {
  content: "\\f1e3";
}

.ri-taobao-line:before {
  content: "\\f1e4";
}

.ri-tape-fill:before {
  content: "\\f1e5";
}

.ri-tape-line:before {
  content: "\\f1e6";
}

.ri-task-fill:before {
  content: "\\f1e7";
}

.ri-task-line:before {
  content: "\\f1e8";
}

.ri-taxi-fill:before {
  content: "\\f1e9";
}

.ri-taxi-line:before {
  content: "\\f1ea";
}

.ri-taxi-wifi-fill:before {
  content: "\\f1eb";
}

.ri-taxi-wifi-line:before {
  content: "\\f1ec";
}

.ri-team-fill:before {
  content: "\\f1ed";
}

.ri-team-line:before {
  content: "\\f1ee";
}

.ri-telegram-fill:before {
  content: "\\f1ef";
}

.ri-telegram-line:before {
  content: "\\f1f0";
}

.ri-temp-cold-fill:before {
  content: "\\f1f1";
}

.ri-temp-cold-line:before {
  content: "\\f1f2";
}

.ri-temp-hot-fill:before {
  content: "\\f1f3";
}

.ri-temp-hot-line:before {
  content: "\\f1f4";
}

.ri-terminal-box-fill:before {
  content: "\\f1f5";
}

.ri-terminal-box-line:before {
  content: "\\f1f6";
}

.ri-terminal-fill:before {
  content: "\\f1f7";
}

.ri-terminal-line:before {
  content: "\\f1f8";
}

.ri-terminal-window-fill:before {
  content: "\\f1f9";
}

.ri-terminal-window-line:before {
  content: "\\f1fa";
}

.ri-test-tube-fill:before {
  content: "\\f1fb";
}

.ri-test-tube-line:before {
  content: "\\f1fc";
}

.ri-text-direction-l:before {
  content: "\\f1fd";
}

.ri-text-direction-r:before {
  content: "\\f1fe";
}

.ri-text-spacing:before {
  content: "\\f1ff";
}

.ri-text-wrap:before {
  content: "\\f200";
}

.ri-text:before {
  content: "\\f201";
}

.ri-thermometer-fill:before {
  content: "\\f202";
}

.ri-thermometer-line:before {
  content: "\\f203";
}

.ri-thumb-down-fill:before {
  content: "\\f204";
}

.ri-thumb-down-line:before {
  content: "\\f205";
}

.ri-thumb-up-fill:before {
  content: "\\f206";
}

.ri-thumb-up-line:before {
  content: "\\f207";
}

.ri-thunderstorms-fill:before {
  content: "\\f208";
}

.ri-thunderstorms-line:before {
  content: "\\f209";
}

.ri-ticket-2-fill:before {
  content: "\\f20a";
}

.ri-ticket-2-line:before {
  content: "\\f20b";
}

.ri-ticket-fill:before {
  content: "\\f20c";
}

.ri-ticket-line:before {
  content: "\\f20d";
}

.ri-time-fill:before {
  content: "\\f20e";
}

.ri-time-line:before {
  content: "\\f20f";
}

.ri-timer-2-fill:before {
  content: "\\f210";
}

.ri-timer-2-line:before {
  content: "\\f211";
}

.ri-timer-fill:before {
  content: "\\f212";
}

.ri-timer-flash-fill:before {
  content: "\\f213";
}

.ri-timer-flash-line:before {
  content: "\\f214";
}

.ri-timer-line:before {
  content: "\\f215";
}

.ri-todo-fill:before {
  content: "\\f216";
}

.ri-todo-line:before {
  content: "\\f217";
}

.ri-toggle-fill:before {
  content: "\\f218";
}

.ri-toggle-line:before {
  content: "\\f219";
}

.ri-tools-fill:before {
  content: "\\f21a";
}

.ri-tools-line:before {
  content: "\\f21b";
}

.ri-tornado-fill:before {
  content: "\\f21c";
}

.ri-tornado-line:before {
  content: "\\f21d";
}

.ri-trademark-fill:before {
  content: "\\f21e";
}

.ri-trademark-line:before {
  content: "\\f21f";
}

.ri-traffic-light-fill:before {
  content: "\\f220";
}

.ri-traffic-light-line:before {
  content: "\\f221";
}

.ri-train-fill:before {
  content: "\\f222";
}

.ri-train-line:before {
  content: "\\f223";
}

.ri-train-wifi-fill:before {
  content: "\\f224";
}

.ri-train-wifi-line:before {
  content: "\\f225";
}

.ri-translate-2:before {
  content: "\\f226";
}

.ri-translate:before {
  content: "\\f227";
}

.ri-travesti-fill:before {
  content: "\\f228";
}

.ri-travesti-line:before {
  content: "\\f229";
}

.ri-treasure-map-fill:before {
  content: "\\f22a";
}

.ri-treasure-map-line:before {
  content: "\\f22b";
}

.ri-trello-fill:before {
  content: "\\f22c";
}

.ri-trello-line:before {
  content: "\\f22d";
}

.ri-trophy-fill:before {
  content: "\\f22e";
}

.ri-trophy-line:before {
  content: "\\f22f";
}

.ri-truck-fill:before {
  content: "\\f230";
}

.ri-truck-line:before {
  content: "\\f231";
}

.ri-tumblr-fill:before {
  content: "\\f232";
}

.ri-tumblr-line:before {
  content: "\\f233";
}

.ri-tv-2-fill:before {
  content: "\\f234";
}

.ri-tv-2-line:before {
  content: "\\f235";
}

.ri-tv-fill:before {
  content: "\\f236";
}

.ri-tv-line:before {
  content: "\\f237";
}

.ri-twitch-fill:before {
  content: "\\f238";
}

.ri-twitch-line:before {
  content: "\\f239";
}

.ri-twitter-fill:before {
  content: "\\f23a";
}

.ri-twitter-line:before {
  content: "\\f23b";
}

.ri-typhoon-fill:before {
  content: "\\f23c";
}

.ri-typhoon-line:before {
  content: "\\f23d";
}

.ri-u-disk-fill:before {
  content: "\\f23e";
}

.ri-u-disk-line:before {
  content: "\\f23f";
}

.ri-ubuntu-fill:before {
  content: "\\f240";
}

.ri-ubuntu-line:before {
  content: "\\f241";
}

.ri-umbrella-fill:before {
  content: "\\f242";
}

.ri-umbrella-line:before {
  content: "\\f243";
}

.ri-underline:before {
  content: "\\f244";
}

.ri-uninstall-fill:before {
  content: "\\f245";
}

.ri-uninstall-line:before {
  content: "\\f246";
}

.ri-unsplash-fill:before {
  content: "\\f247";
}

.ri-unsplash-line:before {
  content: "\\f248";
}

.ri-upload-2-fill:before {
  content: "\\f249";
}

.ri-upload-2-line:before {
  content: "\\f24a";
}

.ri-upload-cloud-2-fill:before {
  content: "\\f24b";
}

.ri-upload-cloud-2-line:before {
  content: "\\f24c";
}

.ri-upload-cloud-fill:before {
  content: "\\f24d";
}

.ri-upload-cloud-line:before {
  content: "\\f24e";
}

.ri-upload-fill:before {
  content: "\\f24f";
}

.ri-upload-line:before {
  content: "\\f250";
}

.ri-usb-fill:before {
  content: "\\f251";
}

.ri-usb-line:before {
  content: "\\f252";
}

.ri-user-2-fill:before {
  content: "\\f253";
}

.ri-user-2-line:before {
  content: "\\f254";
}

.ri-user-3-fill:before {
  content: "\\f255";
}

.ri-user-3-line:before {
  content: "\\f256";
}

.ri-user-4-fill:before {
  content: "\\f257";
}

.ri-user-4-line:before {
  content: "\\f258";
}

.ri-user-5-fill:before {
  content: "\\f259";
}

.ri-user-5-line:before {
  content: "\\f25a";
}

.ri-user-6-fill:before {
  content: "\\f25b";
}

.ri-user-6-line:before {
  content: "\\f25c";
}

.ri-user-add-fill:before {
  content: "\\f25d";
}

.ri-user-add-line:before {
  content: "\\f25e";
}

.ri-user-fill:before {
  content: "\\f25f";
}

.ri-user-follow-fill:before {
  content: "\\f260";
}

.ri-user-follow-line:before {
  content: "\\f261";
}

.ri-user-heart-fill:before {
  content: "\\f262";
}

.ri-user-heart-line:before {
  content: "\\f263";
}

.ri-user-line:before {
  content: "\\f264";
}

.ri-user-location-fill:before {
  content: "\\f265";
}

.ri-user-location-line:before {
  content: "\\f266";
}

.ri-user-received-2-fill:before {
  content: "\\f267";
}

.ri-user-received-2-line:before {
  content: "\\f268";
}

.ri-user-received-fill:before {
  content: "\\f269";
}

.ri-user-received-line:before {
  content: "\\f26a";
}

.ri-user-search-fill:before {
  content: "\\f26b";
}

.ri-user-search-line:before {
  content: "\\f26c";
}

.ri-user-settings-fill:before {
  content: "\\f26d";
}

.ri-user-settings-line:before {
  content: "\\f26e";
}

.ri-user-shared-2-fill:before {
  content: "\\f26f";
}

.ri-user-shared-2-line:before {
  content: "\\f270";
}

.ri-user-shared-fill:before {
  content: "\\f271";
}

.ri-user-shared-line:before {
  content: "\\f272";
}

.ri-user-smile-fill:before {
  content: "\\f273";
}

.ri-user-smile-line:before {
  content: "\\f274";
}

.ri-user-star-fill:before {
  content: "\\f275";
}

.ri-user-star-line:before {
  content: "\\f276";
}

.ri-user-unfollow-fill:before {
  content: "\\f277";
}

.ri-user-unfollow-line:before {
  content: "\\f278";
}

.ri-user-voice-fill:before {
  content: "\\f279";
}

.ri-user-voice-line:before {
  content: "\\f27a";
}

.ri-video-add-fill:before {
  content: "\\f27b";
}

.ri-video-add-line:before {
  content: "\\f27c";
}

.ri-video-chat-fill:before {
  content: "\\f27d";
}

.ri-video-chat-line:before {
  content: "\\f27e";
}

.ri-video-download-fill:before {
  content: "\\f27f";
}

.ri-video-download-line:before {
  content: "\\f280";
}

.ri-video-fill:before {
  content: "\\f281";
}

.ri-video-line:before {
  content: "\\f282";
}

.ri-video-upload-fill:before {
  content: "\\f283";
}

.ri-video-upload-line:before {
  content: "\\f284";
}

.ri-vidicon-2-fill:before {
  content: "\\f285";
}

.ri-vidicon-2-line:before {
  content: "\\f286";
}

.ri-vidicon-fill:before {
  content: "\\f287";
}

.ri-vidicon-line:before {
  content: "\\f288";
}

.ri-vimeo-fill:before {
  content: "\\f289";
}

.ri-vimeo-line:before {
  content: "\\f28a";
}

.ri-vip-crown-2-fill:before {
  content: "\\f28b";
}

.ri-vip-crown-2-line:before {
  content: "\\f28c";
}

.ri-vip-crown-fill:before {
  content: "\\f28d";
}

.ri-vip-crown-line:before {
  content: "\\f28e";
}

.ri-vip-diamond-fill:before {
  content: "\\f28f";
}

.ri-vip-diamond-line:before {
  content: "\\f290";
}

.ri-vip-fill:before {
  content: "\\f291";
}

.ri-vip-line:before {
  content: "\\f292";
}

.ri-virus-fill:before {
  content: "\\f293";
}

.ri-virus-line:before {
  content: "\\f294";
}

.ri-visa-fill:before {
  content: "\\f295";
}

.ri-visa-line:before {
  content: "\\f296";
}

.ri-voice-recognition-fill:before {
  content: "\\f297";
}

.ri-voice-recognition-line:before {
  content: "\\f298";
}

.ri-voiceprint-fill:before {
  content: "\\f299";
}

.ri-voiceprint-line:before {
  content: "\\f29a";
}

.ri-volume-down-fill:before {
  content: "\\f29b";
}

.ri-volume-down-line:before {
  content: "\\f29c";
}

.ri-volume-mute-fill:before {
  content: "\\f29d";
}

.ri-volume-mute-line:before {
  content: "\\f29e";
}

.ri-volume-off-vibrate-fill:before {
  content: "\\f29f";
}

.ri-volume-off-vibrate-line:before {
  content: "\\f2a0";
}

.ri-volume-up-fill:before {
  content: "\\f2a1";
}

.ri-volume-up-line:before {
  content: "\\f2a2";
}

.ri-volume-vibrate-fill:before {
  content: "\\f2a3";
}

.ri-volume-vibrate-line:before {
  content: "\\f2a4";
}

.ri-vuejs-fill:before {
  content: "\\f2a5";
}

.ri-vuejs-line:before {
  content: "\\f2a6";
}

.ri-walk-fill:before {
  content: "\\f2a7";
}

.ri-walk-line:before {
  content: "\\f2a8";
}

.ri-wallet-2-fill:before {
  content: "\\f2a9";
}

.ri-wallet-2-line:before {
  content: "\\f2aa";
}

.ri-wallet-3-fill:before {
  content: "\\f2ab";
}

.ri-wallet-3-line:before {
  content: "\\f2ac";
}

.ri-wallet-fill:before {
  content: "\\f2ad";
}

.ri-wallet-line:before {
  content: "\\f2ae";
}

.ri-water-flash-fill:before {
  content: "\\f2af";
}

.ri-water-flash-line:before {
  content: "\\f2b0";
}

.ri-webcam-fill:before {
  content: "\\f2b1";
}

.ri-webcam-line:before {
  content: "\\f2b2";
}

.ri-wechat-2-fill:before {
  content: "\\f2b3";
}

.ri-wechat-2-line:before {
  content: "\\f2b4";
}

.ri-wechat-fill:before {
  content: "\\f2b5";
}

.ri-wechat-line:before {
  content: "\\f2b6";
}

.ri-wechat-pay-fill:before {
  content: "\\f2b7";
}

.ri-wechat-pay-line:before {
  content: "\\f2b8";
}

.ri-weibo-fill:before {
  content: "\\f2b9";
}

.ri-weibo-line:before {
  content: "\\f2ba";
}

.ri-whatsapp-fill:before {
  content: "\\f2bb";
}

.ri-whatsapp-line:before {
  content: "\\f2bc";
}

.ri-wheelchair-fill:before {
  content: "\\f2bd";
}

.ri-wheelchair-line:before {
  content: "\\f2be";
}

.ri-wifi-fill:before {
  content: "\\f2bf";
}

.ri-wifi-line:before {
  content: "\\f2c0";
}

.ri-wifi-off-fill:before {
  content: "\\f2c1";
}

.ri-wifi-off-line:before {
  content: "\\f2c2";
}

.ri-window-2-fill:before {
  content: "\\f2c3";
}

.ri-window-2-line:before {
  content: "\\f2c4";
}

.ri-window-fill:before {
  content: "\\f2c5";
}

.ri-window-line:before {
  content: "\\f2c6";
}

.ri-windows-fill:before {
  content: "\\f2c7";
}

.ri-windows-line:before {
  content: "\\f2c8";
}

.ri-windy-fill:before {
  content: "\\f2c9";
}

.ri-windy-line:before {
  content: "\\f2ca";
}

.ri-wireless-charging-fill:before {
  content: "\\f2cb";
}

.ri-wireless-charging-line:before {
  content: "\\f2cc";
}

.ri-women-fill:before {
  content: "\\f2cd";
}

.ri-women-line:before {
  content: "\\f2ce";
}

.ri-wubi-input:before {
  content: "\\f2cf";
}

.ri-xbox-fill:before {
  content: "\\f2d0";
}

.ri-xbox-line:before {
  content: "\\f2d1";
}

.ri-xing-fill:before {
  content: "\\f2d2";
}

.ri-xing-line:before {
  content: "\\f2d3";
}

.ri-youtube-fill:before {
  content: "\\f2d4";
}

.ri-youtube-line:before {
  content: "\\f2d5";
}

.ri-zcool-fill:before {
  content: "\\f2d6";
}

.ri-zcool-line:before {
  content: "\\f2d7";
}

.ri-zhihu-fill:before {
  content: "\\f2d8";
}

.ri-zhihu-line:before {
  content: "\\f2d9";
}

.ri-zoom-in-fill:before {
  content: "\\f2da";
}

.ri-zoom-in-line:before {
  content: "\\f2db";
}

.ri-zoom-out-fill:before {
  content: "\\f2dc";
}

.ri-zoom-out-line:before {
  content: "\\f2dd";
}

.ri-zzz-fill:before {
  content: "\\f2de";
}

.ri-zzz-line:before {
  content: "\\f2df";
}

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 2.0.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Custom Bootstrap Css File
*/
/*!
 * Bootstrap  v5.2.3 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --vz-blue: #3577f1;
  --vz-indigo: #405189;
  --vz-purple: #6559cc;
  --vz-pink: #f672a7;
  --vz-red: #f06548;
  --vz-orange: #f1963b;
  --vz-yellow: #f7b84b;
  --vz-green: #0ab39c;
  --vz-teal: #02a8b5;
  --vz-cyan: #299cdb;
  --vz-white: #fff;
  --vz-gray: #878a99;
  --vz-gray-dark: #343a40;
  --vz-gray-100: #f3f6f9;
  --vz-gray-200: #eff2f7;
  --vz-gray-300: #e9ebec;
  --vz-gray-400: #ced4da;
  --vz-gray-500: #adb5bd;
  --vz-gray-600: #878a99;
  --vz-gray-700: #495057;
  --vz-gray-800: #343a40;
  --vz-gray-900: #212529;
  --vz-primary: #405189;
  --vz-secondary: #3577f1;
  --vz-success: #0ab39c;
  --vz-info: #299cdb;
  --vz-warning: #f7b84b;
  --vz-danger: #f06548;
  --vz-light: #f3f6f9;
  --vz-dark: #212529;
  --vz-primary-rgb: 64, 81, 137;
  --vz-secondary-rgb: 53, 119, 241;
  --vz-success-rgb: 10, 179, 156;
  --vz-info-rgb: 41, 156, 219;
  --vz-warning-rgb: 247, 184, 75;
  --vz-danger-rgb: 240, 101, 72;
  --vz-light-rgb: 243, 246, 249;
  --vz-dark-rgb: 33, 37, 41;
  --vz-white-rgb: 255, 255, 255;
  --vz-black-rgb: 0, 0, 0;
  --vz-body-color-rgb: 33, 37, 41;
  --vz-body-bg-rgb: 243, 243, 249;
  --vz-font-sans-serif: "Open Sans", sans-serif;
  --vz-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --vz-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --vz-body-font-family: var(--vz-font-sans-serif);
  --vz-body-font-size: 0.8125rem;
  --vz-body-font-weight: 400;
  --vz-body-line-height: 1.5;
  --vz-body-color: #212529;
  --vz-body-bg: #f3f3f9;
  --vz-border-width: 1px;
  --vz-border-style: solid;
  --vz-border-color: var(--vz-border-color);
  --vz-border-color-translucent: rgba(0, 0, 0, 0.175);
  --vz-border-radius: 0.25rem;
  --vz-border-radius-sm: 0.2rem;
  --vz-border-radius-lg: 0.3rem;
  --vz-border-radius-xl: 1rem;
  --vz-border-radius-2xl: 2rem;
  --vz-border-radius-pill: 50rem;
  --vz-link-color: var(--vz-link-color);
  --vz-link-hover-color: var(--vz-link-hover-color);
  --vz-code-color: #f672a7;
  --vz-highlight-bg: #fcf8e3;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--vz-body-font-family);
  font-size: var(--vz-body-font-size);
  font-weight: var(--vz-body-font-weight);
  line-height: var(--vz-body-line-height);
  color: var(--vz-body-color);
  text-align: var(--vz-body-text-align);
  background-color: var(--vz-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1, .h1 {
  font-size: calc(1.328125rem + 0.9375vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.03125rem;
  }
}

h2, .h2 {
  font-size: calc(1.2875rem + 0.45vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 1.625rem;
  }
}

h3, .h3 {
  font-size: calc(1.2671875rem + 0.20625vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.421875rem;
  }
}

h4, .h4 {
  font-size: 1.21875rem;
}

h5, .h5 {
  font-size: 1.015625rem;
}

h6, .h6 {
  font-size: 0.8125rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.2em;
  background-color: var(--vz-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: var(--vz-link-color);
  text-decoration: underline;
}
a:hover {
  color: var(--vz-link-hover-color);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--vz-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--vz-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 0.875em;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
  font-weight: 700;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #878a99;
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend {
  line-height: inherit;
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: textfield;
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.015625rem;
  font-weight: 300;
}

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}
.display-1 {
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}
.display-2 {
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}
.display-3 {
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}
.display-4 {
  font-weight: 300;
  line-height: 1.2;
}

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}
.display-5 {
  font-weight: 300;
  line-height: 1.2;
}

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}
.display-6 {
  font-weight: 300;
  line-height: 1.2;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 0.89375rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #878a99;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--vz-body-bg);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: #878a99;
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --vz-gutter-x: 1.5rem;
  --vz-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--vz-gutter-x) * 0.5);
  padding-left: calc(var(--vz-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
.row {
  --vz-gutter-x: 1.5rem;
  --vz-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--vz-gutter-y));
  margin-right: calc(-0.5 * var(--vz-gutter-x));
  margin-left: calc(-0.5 * var(--vz-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--vz-gutter-x) * 0.5);
  padding-left: calc(var(--vz-gutter-x) * 0.5);
  margin-top: var(--vz-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --vz-gutter-x: 0;
}

.g-0,
.gy-0 {
  --vz-gutter-y: 0;
}

.g-1,
.gx-1 {
  --vz-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --vz-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --vz-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --vz-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --vz-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --vz-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --vz-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --vz-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --vz-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --vz-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --vz-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --vz-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --vz-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --vz-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --vz-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --vz-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --vz-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --vz-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --vz-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --vz-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --vz-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --vz-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --vz-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --vz-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --vz-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --vz-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --vz-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --vz-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --vz-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --vz-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --vz-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --vz-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --vz-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --vz-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --vz-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --vz-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --vz-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --vz-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --vz-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --vz-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --vz-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --vz-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --vz-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --vz-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --vz-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --vz-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --vz-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --vz-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --vz-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --vz-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --vz-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --vz-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --vz-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --vz-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --vz-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.3333333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.6666666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --vz-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --vz-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --vz-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --vz-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --vz-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --vz-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --vz-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --vz-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --vz-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --vz-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --vz-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --vz-gutter-y: 3rem;
  }
}
.table {
  --vz-table-color: var(--vz-body-color);
  --vz-table-bg: transparent;
  --vz-table-border-color: var(--vz-border-color);
  --vz-table-accent-bg: transparent;
  --vz-table-striped-color: var(--vz-body-color);
  --vz-table-striped-bg: rgba(var(--vz-dark-rgb), 0.02);
  --vz-table-active-color: var(--vz-body-color);
  --vz-table-active-bg: rgba(var(--vz-light-rgb), 1);
  --vz-table-hover-color: var(--vz-body-color);
  --vz-table-hover-bg: rgba(var(--vz-light-rgb), 1);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--vz-table-color);
  vertical-align: top;
  border-color: var(--vz-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.75rem 0.6rem;
  background-color: var(--vz-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--vz-table-accent-bg);
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: 2px solid var(--vz-border-color);
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.3rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: 1px 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 1px;
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --vz-table-accent-bg: var(--vz-table-striped-bg);
  color: var(--vz-table-striped-color);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --vz-table-accent-bg: var(--vz-table-striped-bg);
  color: var(--vz-table-striped-color);
}

.table-active {
  --vz-table-accent-bg: var(--vz-table-active-bg);
  color: var(--vz-table-active-color);
}

.table-hover > tbody > tr:hover > * {
  --vz-table-accent-bg: var(--vz-table-hover-bg);
  color: var(--vz-table-hover-color);
}

.table-primary {
  --vz-table-color: #000;
  --vz-table-bg: rgb(216.8, 220.2, 231.4);
  --vz-table-border-color: rgb(195.12, 198.18, 208.26);
  --vz-table-striped-bg: rgb(212.464, 215.796, 226.772);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-secondary {
  --vz-table-color: #000;
  --vz-table-bg: rgb(214.6, 227.8, 252.2);
  --vz-table-border-color: rgb(193.14, 205.02, 226.98);
  --vz-table-striped-bg: rgb(210.308, 223.244, 247.156);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-success {
  --vz-table-color: #000;
  --vz-table-bg: rgb(206, 239.8, 235.2);
  --vz-table-border-color: rgb(185.4, 215.82, 211.68);
  --vz-table-striped-bg: rgb(201.88, 235.004, 230.496);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-info {
  --vz-table-color: #000;
  --vz-table-bg: rgb(212.2, 235.2, 247.8);
  --vz-table-border-color: rgb(190.98, 211.68, 223.02);
  --vz-table-striped-bg: rgb(207.956, 230.496, 242.844);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-warning {
  --vz-table-color: #000;
  --vz-table-bg: rgb(253.4, 240.8, 219);
  --vz-table-border-color: rgb(228.06, 216.72, 197.1);
  --vz-table-striped-bg: rgb(248.332, 235.984, 214.62);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-danger {
  --vz-table-color: #000;
  --vz-table-bg: rgb(252, 224.2, 218.4);
  --vz-table-border-color: rgb(226.8, 201.78, 196.56);
  --vz-table-striped-bg: rgb(246.96, 219.716, 214.032);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-light {
  --vz-table-color: #000;
  --vz-table-bg: #f3f6f9;
  --vz-table-border-color: rgb(218.7, 221.4, 224.1);
  --vz-table-striped-bg: rgb(238.14, 241.08, 244.02);
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-dark {
  --vz-table-color: #fff;
  --vz-table-bg: #212529;
  --vz-table-border-color: rgb(55.2, 58.8, 62.4);
  --vz-table-striped-bg: rgb(37.44, 41.36, 45.28);
  --vz-table-striped-color: #fff;
  --vz-table-active-bg: white;
  --vz-table-active-color: #000;
  --vz-table-hover-bg: white;
  --vz-table-hover-color: #000;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.7rem + 1px);
  padding-bottom: calc(0.7rem + 1px);
  font-size: 1.015625rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.7109375rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #878a99;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--vz-input-border);
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  border-color: var(--vz-input-focus-border);
  outline: 0;
  box-shadow: 0 0 0 0 rgba(64, 81, 137, 0.25);
}
.form-control::-webkit-date-and-time-value {
  height: 1.5em;
}
.form-control::placeholder {
  color: #878a99;
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--vz-input-disabled-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.5rem 0.9rem;
  margin: -0.5rem -0.9rem;
  margin-inline-end: 0.9rem;
  color: var(--vz-body-color);
  background-color: var(--vz-input-group-addon-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: 1px;
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--vz-input-group-addon-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px);
  padding: 0.7rem 1.2rem;
  font-size: 1.015625rem;
  border-radius: 0.3rem;
}
.form-control-lg::file-selector-button {
  padding: 0.7rem 1.2rem;
  margin: -0.7rem -1.2rem;
  margin-inline-end: 1.2rem;
}

textarea.form-control {
  min-height: calc(1.5em + 1rem + 2px);
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px);
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: 0.25rem;
}
.form-control-color::-webkit-color-swatch {
  border-radius: 0.25rem;
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1.4rem + 2px);
}

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 2.7rem 0.5rem 0.9rem;
  -moz-padding-start: calc(0.9rem - 3px);
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 16px 12px;
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select {
  appearance: none;
}
.form-select:focus {
  border-color: var(--vz-input-focus-border);
  outline: 0;
  box-shadow: 0 0 0 0 rgba(64, 81, 137, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.9rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--vz-input-disabled-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--vz-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
}

.form-select-lg {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  padding-left: 1.2rem;
  font-size: 1.015625rem;
  border-radius: 0.3rem;
}

.form-check {
  display: block;
  min-height: 1.21875rem;
  padding-left: 1.6em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.6em;
}

.form-check-reverse {
  padding-right: 1.6em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.6em;
  margin-left: 0;
}

.form-check-input {
  width: 1.1em;
  height: 1.1em;
  margin-top: 0.2em;
  vertical-align: top;
  background-color: var(--vz-input-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--vz-input-check-border);
  appearance: none;
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: var(--vz-input-focus-border);
  outline: 0;
  box-shadow: 0 0 0 0 rgba(64, 81, 137, 0.25);
}
.form-check-input:checked {
  background-color: #405189;
  border-color: #405189;
}
.form-check-input:checked[type=checkbox] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}
.form-check-input:checked[type=radio] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #405189;
  border-color: #405189;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  width: 2em;
  margin-left: -2.5em;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

.form-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #f3f3f9, 0 0 0 0 rgba(64, 81, 137, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #f3f3f9, 0 0 0 0 rgba(64, 81, 137, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #405189;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb {
  appearance: none;
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(197.7, 202.8, 219.6);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--vz-gray-300);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #405189;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb {
  appearance: none;
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(197.7, 202.8, 219.6);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--vz-gray-300);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: #adb5bd;
}
.form-range:disabled::-moz-range-thumb {
  background-color: #adb5bd;
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + 2px);
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 1rem 0.9rem;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.9rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  opacity: 0.65;
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: 1px 0;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--vz-input-group-addon-bg);
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.7rem 1.2rem;
  font-size: 1.015625rem;
  border-radius: 0.3rem;
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7109375rem;
  border-radius: 0.2rem;
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3.6rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #0ab39c;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: 0.1rem;
  font-size: 0.7109375rem;
  color: #fff;
  background-color: rgba(10, 179, 156, 0.9);
  border-radius: 0.2rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #0ab39c;
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #0ab39c;
  box-shadow: 0 0 0 0 rgba(10, 179, 156, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #0ab39c;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  padding-right: 4.95rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___}), url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #0ab39c;
  box-shadow: 0 0 0 0 rgba(10, 179, 156, 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #0ab39c;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #0ab39c;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0 rgba(10, 179, 156, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #0ab39c;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #f06548;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: 0.1rem;
  font-size: 0.7109375rem;
  color: #fff;
  background-color: rgba(240, 101, 72, 0.9);
  border-radius: 0.2rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #f06548;
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #f06548;
  box-shadow: 0 0 0 0 rgba(240, 101, 72, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #f06548;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  padding-right: 4.95rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___}), url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-position: right 0.9rem center, center right 2.7rem;
  background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #f06548;
  box-shadow: 0 0 0 0 rgba(240, 101, 72, 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #f06548;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #f06548;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0 rgba(240, 101, 72, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #f06548;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --vz-btn-padding-x: 0.9rem;
  --vz-btn-padding-y: 0.5rem;
  --vz-btn-font-family: ;
  --vz-btn-font-size: 0.8125rem;
  --vz-btn-font-weight: 400;
  --vz-btn-line-height: 1.5;
  --vz-btn-color: #212529;
  --vz-btn-bg: transparent;
  --vz-btn-border-width: 1px;
  --vz-btn-border-color: transparent;
  --vz-btn-border-radius: 0.25rem;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --vz-btn-disabled-opacity: 0.65;
  --vz-btn-focus-box-shadow: 0 0 0 0 rgba(var(--vz-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--vz-btn-padding-y) var(--vz-btn-padding-x);
  font-family: var(--vz-btn-font-family);
  font-size: var(--vz-btn-font-size);
  font-weight: var(--vz-btn-font-weight);
  line-height: var(--vz-btn-line-height);
  color: var(--vz-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--vz-btn-border-width) solid var(--vz-btn-border-color);
  border-radius: var(--vz-btn-border-radius);
  background-color: var(--vz-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--vz-btn-hover-color);
  background-color: var(--vz-btn-hover-bg);
  border-color: var(--vz-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--vz-btn-color);
  background-color: var(--vz-btn-bg);
  border-color: var(--vz-btn-border-color);
}
.btn:focus-visible {
  color: var(--vz-btn-hover-color);
  background-color: var(--vz-btn-hover-bg);
  border-color: var(--vz-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--vz-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--vz-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--vz-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--vz-btn-active-color);
  background-color: var(--vz-btn-active-bg);
  border-color: var(--vz-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--vz-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--vz-btn-disabled-color);
  pointer-events: none;
  background-color: var(--vz-btn-disabled-bg);
  border-color: var(--vz-btn-disabled-border-color);
  opacity: var(--vz-btn-disabled-opacity);
}

.btn-primary {
  --vz-btn-color: #fff;
  --vz-btn-bg: #405189;
  --vz-btn-border-color: #405189;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(54.4, 68.85, 116.45);
  --vz-btn-hover-border-color: rgb(51.2, 64.8, 109.6);
  --vz-btn-focus-shadow-rgb: 93, 107, 155;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(51.2, 64.8, 109.6);
  --vz-btn-active-border-color: rgb(48, 60.75, 102.75);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #405189;
  --vz-btn-disabled-border-color: #405189;
}

.btn-secondary {
  --vz-btn-color: #fff;
  --vz-btn-bg: #3577f1;
  --vz-btn-border-color: #3577f1;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(45.05, 101.15, 204.85);
  --vz-btn-hover-border-color: rgb(42.4, 95.2, 192.8);
  --vz-btn-focus-shadow-rgb: 83, 139, 243;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(42.4, 95.2, 192.8);
  --vz-btn-active-border-color: rgb(39.75, 89.25, 180.75);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #3577f1;
  --vz-btn-disabled-border-color: #3577f1;
}

.btn-success {
  --vz-btn-color: #fff;
  --vz-btn-bg: #0ab39c;
  --vz-btn-border-color: #0ab39c;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(8.5, 152.15, 132.6);
  --vz-btn-hover-border-color: rgb(8, 143.2, 124.8);
  --vz-btn-focus-shadow-rgb: 47, 190, 171;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(8, 143.2, 124.8);
  --vz-btn-active-border-color: rgb(7.5, 134.25, 117);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #0ab39c;
  --vz-btn-disabled-border-color: #0ab39c;
}

.btn-info {
  --vz-btn-color: #fff;
  --vz-btn-bg: #299cdb;
  --vz-btn-border-color: #299cdb;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(34.85, 132.6, 186.15);
  --vz-btn-hover-border-color: rgb(32.8, 124.8, 175.2);
  --vz-btn-focus-shadow-rgb: 73, 171, 224;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(32.8, 124.8, 175.2);
  --vz-btn-active-border-color: rgb(30.75, 117, 164.25);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #299cdb;
  --vz-btn-disabled-border-color: #299cdb;
}

.btn-warning {
  --vz-btn-color: #fff;
  --vz-btn-bg: #f7b84b;
  --vz-btn-border-color: #f7b84b;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(209.95, 156.4, 63.75);
  --vz-btn-hover-border-color: rgb(197.6, 147.2, 60);
  --vz-btn-focus-shadow-rgb: 248, 195, 102;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(197.6, 147.2, 60);
  --vz-btn-active-border-color: rgb(185.25, 138, 56.25);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #f7b84b;
  --vz-btn-disabled-border-color: #f7b84b;
}

.btn-danger {
  --vz-btn-color: #fff;
  --vz-btn-bg: #f06548;
  --vz-btn-border-color: #f06548;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(204, 85.85, 61.2);
  --vz-btn-hover-border-color: rgb(192, 80.8, 57.6);
  --vz-btn-focus-shadow-rgb: 242, 124, 99;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(192, 80.8, 57.6);
  --vz-btn-active-border-color: rgb(180, 75.75, 54);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #f06548;
  --vz-btn-disabled-border-color: #f06548;
}

.btn-light {
  --vz-btn-color: #000;
  --vz-btn-bg: #f3f6f9;
  --vz-btn-border-color: #f3f6f9;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: rgb(206.55, 209.1, 211.65);
  --vz-btn-hover-border-color: rgb(194.4, 196.8, 199.2);
  --vz-btn-focus-shadow-rgb: 207, 209, 212;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: rgb(194.4, 196.8, 199.2);
  --vz-btn-active-border-color: rgb(182.25, 184.5, 186.75);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #f3f6f9;
  --vz-btn-disabled-border-color: #f3f6f9;
}

.btn-dark {
  --vz-btn-color: #fff;
  --vz-btn-bg: #212529;
  --vz-btn-border-color: #212529;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: rgb(66.3, 69.7, 73.1);
  --vz-btn-hover-border-color: rgb(55.2, 58.8, 62.4);
  --vz-btn-focus-shadow-rgb: 66, 70, 73;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: rgb(77.4, 80.6, 83.8);
  --vz-btn-active-border-color: rgb(55.2, 58.8, 62.4);
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #212529;
  --vz-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --vz-btn-color: #405189;
  --vz-btn-border-color: #405189;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #405189;
  --vz-btn-hover-border-color: #405189;
  --vz-btn-focus-shadow-rgb: 64, 81, 137;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #405189;
  --vz-btn-active-border-color: #405189;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #405189;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #405189;
  --vz-gradient: none;
}

.btn-outline-secondary {
  --vz-btn-color: #3577f1;
  --vz-btn-border-color: #3577f1;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #3577f1;
  --vz-btn-hover-border-color: #3577f1;
  --vz-btn-focus-shadow-rgb: 53, 119, 241;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #3577f1;
  --vz-btn-active-border-color: #3577f1;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #3577f1;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #3577f1;
  --vz-gradient: none;
}

.btn-outline-success {
  --vz-btn-color: #0ab39c;
  --vz-btn-border-color: #0ab39c;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #0ab39c;
  --vz-btn-hover-border-color: #0ab39c;
  --vz-btn-focus-shadow-rgb: 10, 179, 156;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #0ab39c;
  --vz-btn-active-border-color: #0ab39c;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #0ab39c;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #0ab39c;
  --vz-gradient: none;
}

.btn-outline-info {
  --vz-btn-color: #299cdb;
  --vz-btn-border-color: #299cdb;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #299cdb;
  --vz-btn-hover-border-color: #299cdb;
  --vz-btn-focus-shadow-rgb: 41, 156, 219;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #299cdb;
  --vz-btn-active-border-color: #299cdb;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #299cdb;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #299cdb;
  --vz-gradient: none;
}

.btn-outline-warning {
  --vz-btn-color: #f7b84b;
  --vz-btn-border-color: #f7b84b;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #f7b84b;
  --vz-btn-hover-border-color: #f7b84b;
  --vz-btn-focus-shadow-rgb: 247, 184, 75;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #f7b84b;
  --vz-btn-active-border-color: #f7b84b;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #f7b84b;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #f7b84b;
  --vz-gradient: none;
}

.btn-outline-danger {
  --vz-btn-color: #f06548;
  --vz-btn-border-color: #f06548;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #f06548;
  --vz-btn-hover-border-color: #f06548;
  --vz-btn-focus-shadow-rgb: 240, 101, 72;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #f06548;
  --vz-btn-active-border-color: #f06548;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #f06548;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #f06548;
  --vz-gradient: none;
}

.btn-outline-light {
  --vz-btn-color: #f3f6f9;
  --vz-btn-border-color: #f3f6f9;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #f3f6f9;
  --vz-btn-hover-border-color: #f3f6f9;
  --vz-btn-focus-shadow-rgb: 243, 246, 249;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #f3f6f9;
  --vz-btn-active-border-color: #f3f6f9;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #f3f6f9;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #f3f6f9;
  --vz-gradient: none;
}

.btn-outline-dark {
  --vz-btn-color: #212529;
  --vz-btn-border-color: #212529;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #212529;
  --vz-btn-hover-border-color: #212529;
  --vz-btn-focus-shadow-rgb: 33, 37, 41;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #212529;
  --vz-btn-active-border-color: #212529;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #212529;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #212529;
  --vz-gradient: none;
}

.btn-link {
  --vz-btn-font-weight: 400;
  --vz-btn-color: var(--vz-link-color);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-link-hover-color);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-active-color: var(--vz-link-hover-color);
  --vz-btn-active-border-color: transparent;
  --vz-btn-disabled-color: #878a99;
  --vz-btn-disabled-border-color: transparent;
  --vz-btn-box-shadow: none;
  --vz-btn-focus-shadow-rgb: 93, 107, 155;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--vz-btn-color);
}
.btn-link:hover {
  color: var(--vz-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --vz-btn-padding-y: 0.7rem;
  --vz-btn-padding-x: 1.2rem;
  --vz-btn-font-size: 1.015625rem;
  --vz-btn-border-radius: 0.3rem;
}

.btn-sm, .btn-group-sm > .btn {
  --vz-btn-padding-y: 0.25rem;
  --vz-btn-padding-x: 0.5rem;
  --vz-btn-font-size: 0.7109375rem;
  --vz-btn-border-radius: 0.2rem;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  --vz-dropdown-zindex: 1000;
  --vz-dropdown-min-width: 10rem;
  --vz-dropdown-padding-x: 0;
  --vz-dropdown-padding-y: 0.5rem;
  --vz-dropdown-spacer: 0.125rem;
  --vz-dropdown-font-size: 0.8125rem;
  --vz-dropdown-color: var(--vz-body-color);
  --vz-dropdown-bg: #fff;
  --vz-dropdown-border-color: var(--vz-border-color);
  --vz-dropdown-border-radius: 0.3rem;
  --vz-dropdown-border-width: 0;
  --vz-dropdown-inner-border-radius: 0.3rem;
  --vz-dropdown-divider-bg: var(--vz-border-color);
  --vz-dropdown-divider-margin-y: 0.5rem;
  --vz-dropdown-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  --vz-dropdown-link-color: #212529;
  --vz-dropdown-link-hover-color: rgb(29.7, 33.3, 36.9);
  --vz-dropdown-link-hover-bg: #f3f6f9;
  --vz-dropdown-link-active-color: rgb(29.7, 33.3, 36.9);
  --vz-dropdown-link-active-bg: #f3f6f9;
  --vz-dropdown-link-disabled-color: #adb5bd;
  --vz-dropdown-item-padding-x: 1.2rem;
  --vz-dropdown-item-padding-y: 0.35rem;
  --vz-dropdown-header-color: #878a99;
  --vz-dropdown-header-padding-x: 1.2rem;
  --vz-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--vz-dropdown-zindex);
  display: none;
  min-width: var(--vz-dropdown-min-width);
  padding: var(--vz-dropdown-padding-y) var(--vz-dropdown-padding-x);
  margin: 0;
  font-size: var(--vz-dropdown-font-size);
  color: var(--vz-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--vz-dropdown-bg);
  background-clip: padding-box;
  border: var(--vz-dropdown-border-width) solid var(--vz-dropdown-border-color);
  border-radius: var(--vz-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--vz-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--vz-dropdown-spacer);
}
.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--vz-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--vz-dropdown-spacer);
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--vz-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--vz-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--vz-dropdown-item-padding-y) var(--vz-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--vz-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--vz-dropdown-link-hover-color);
  background-color: var(--vz-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--vz-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--vz-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--vz-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--vz-dropdown-header-padding-y) var(--vz-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.7109375rem;
  color: var(--vz-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--vz-dropdown-item-padding-y) var(--vz-dropdown-item-padding-x);
  color: var(--vz-dropdown-link-color);
}

.dropdown-menu-dark {
  --vz-dropdown-color: #e9ebec;
  --vz-dropdown-bg: #343a40;
  --vz-dropdown-border-color: var(--vz-border-color);
  --vz-dropdown-box-shadow: ;
  --vz-dropdown-link-color: #e9ebec;
  --vz-dropdown-link-hover-color: #fff;
  --vz-dropdown-divider-bg: var(--vz-border-color);
  --vz-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --vz-dropdown-link-active-color: #fff;
  --vz-dropdown-link-active-bg: rgb(63.4310344828, 70.75, 78.0689655172);
  --vz-dropdown-link-disabled-color: #adb5bd;
  --vz-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: 0.25rem;
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.675rem;
  padding-left: 0.675rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.9rem;
  padding-left: 0.9rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn ~ .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --vz-nav-link-padding-x: 1rem;
  --vz-nav-link-padding-y: 0.5rem;
  --vz-nav-link-font-weight: ;
  --vz-nav-link-color: var(--vz-link-color);
  --vz-nav-link-hover-color: var(--vz-link-hover-color);
  --vz-nav-link-disabled-color: #878a99;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--vz-nav-link-padding-y) var(--vz-nav-link-padding-x);
  font-size: var(--vz-nav-link-font-size);
  font-weight: var(--vz-nav-link-font-weight);
  color: var(--vz-nav-link-color);
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--vz-nav-link-hover-color);
}
.nav-link.disabled {
  color: var(--vz-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --vz-nav-tabs-border-width: 1px;
  --vz-nav-tabs-border-color: var(--vz-gray-300);
  --vz-nav-tabs-border-radius: 0.25rem;
  --vz-nav-tabs-link-hover-border-color: var(--vz-gray-300) var(--vz-gray-300) var(--vz-gray-300);
  --vz-nav-tabs-link-active-color: #495057;
  --vz-nav-tabs-link-active-bg: var(--vz-nav-tabs-link-active-bg);
  --vz-nav-tabs-link-active-border-color: var(--vz-gray-300) var(--vz-gray-300) var(--vz-nav-tabs-link-active-bg);
  border-bottom: var(--vz-nav-tabs-border-width) solid var(--vz-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--vz-nav-tabs-border-width));
  background: none;
  border: var(--vz-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--vz-nav-tabs-border-radius);
  border-top-right-radius: var(--vz-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--vz-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
  color: var(--vz-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--vz-nav-tabs-link-active-color);
  background-color: var(--vz-nav-tabs-link-active-bg);
  border-color: var(--vz-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--vz-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --vz-nav-pills-border-radius: 0.25rem;
  --vz-nav-pills-link-active-color: #fff;
  --vz-nav-pills-link-active-bg: #405189;
}
.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: var(--vz-nav-pills-border-radius);
}
.nav-pills .nav-link:disabled {
  color: var(--vz-nav-link-disabled-color);
  background-color: transparent;
  border-color: transparent;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--vz-nav-pills-link-active-color);
  background-color: var(--vz-nav-pills-link-active-bg);
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --vz-navbar-padding-x: 0;
  --vz-navbar-padding-y: 0.5rem;
  --vz-navbar-color: rgba(0, 0, 0, 0.55);
  --vz-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --vz-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --vz-navbar-active-color: rgba(0, 0, 0, 0.9);
  --vz-navbar-brand-padding-y: 0.34765625rem;
  --vz-navbar-brand-margin-end: 1rem;
  --vz-navbar-brand-font-size: 1.015625rem;
  --vz-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --vz-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --vz-navbar-nav-link-padding-x: 0.5rem;
  --vz-navbar-toggler-padding-y: 0.25rem;
  --vz-navbar-toggler-padding-x: 0.75rem;
  --vz-navbar-toggler-font-size: 1.015625rem;
  --vz-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  --vz-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --vz-navbar-toggler-border-radius: 0.25rem;
  --vz-navbar-toggler-focus-width: 0;
  --vz-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--vz-navbar-padding-y) var(--vz-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--vz-navbar-brand-padding-y);
  padding-bottom: var(--vz-navbar-brand-padding-y);
  margin-right: var(--vz-navbar-brand-margin-end);
  font-size: var(--vz-navbar-brand-font-size);
  color: var(--vz-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--vz-navbar-brand-hover-color);
}

.navbar-nav {
  --vz-nav-link-padding-x: 0;
  --vz-nav-link-padding-y: 0.5rem;
  --vz-nav-link-font-weight: ;
  --vz-nav-link-color: var(--vz-navbar-color);
  --vz-nav-link-hover-color: var(--vz-navbar-hover-color);
  --vz-nav-link-disabled-color: var(--vz-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .show > .nav-link,
.navbar-nav .nav-link.active {
  color: var(--vz-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--vz-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--vz-navbar-active-color);
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: var(--vz-navbar-toggler-padding-y) var(--vz-navbar-toggler-padding-x);
  font-size: var(--vz-navbar-toggler-font-size);
  line-height: 1;
  color: var(--vz-navbar-color);
  background-color: transparent;
  border: var(--vz-border-width) solid var(--vz-navbar-toggler-border-color);
  border-radius: var(--vz-navbar-toggler-border-radius);
  transition: var(--vz-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--vz-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--vz-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--vz-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--vz-navbar-nav-link-padding-x);
    padding-left: var(--vz-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--vz-navbar-nav-link-padding-x);
  padding-left: var(--vz-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark {
  --vz-navbar-color: rgba(255, 255, 255, 0.55);
  --vz-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --vz-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --vz-navbar-active-color: #fff;
  --vz-navbar-brand-color: #fff;
  --vz-navbar-brand-hover-color: #fff;
  --vz-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --vz-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_44___});
}

.card {
  --vz-card-spacer-y: 1rem;
  --vz-card-spacer-x: 1rem;
  --vz-card-title-spacer-y: 0.5rem;
  --vz-card-border-width: 0;
  --vz-card-border-color: rgba(0, 0, 0, 0.125);
  --vz-card-border-radius: 0.25rem;
  --vz-card-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --vz-card-inner-border-radius: 0.25rem;
  --vz-card-cap-padding-y: 1rem;
  --vz-card-cap-padding-x: 1rem;
  --vz-card-cap-bg: #fff;
  --vz-card-cap-color: ;
  --vz-card-height: ;
  --vz-card-color: ;
  --vz-card-bg: #fff;
  --vz-card-img-overlay-padding: 1rem;
  --vz-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--vz-card-height);
  word-wrap: break-word;
  background-color: var(--vz-card-bg);
  background-clip: border-box;
  border: var(--vz-card-border-width) solid var(--vz-card-border-color);
  border-radius: var(--vz-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--vz-card-inner-border-radius);
  border-top-right-radius: var(--vz-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--vz-card-inner-border-radius);
  border-bottom-left-radius: var(--vz-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--vz-card-spacer-y) var(--vz-card-spacer-x);
  color: var(--vz-card-color);
}

.card-title {
  margin-bottom: var(--vz-card-title-spacer-y);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--vz-card-title-spacer-y));
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--vz-card-spacer-x);
}

.card-header {
  padding: var(--vz-card-cap-padding-y) var(--vz-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--vz-card-cap-color);
  background-color: var(--vz-card-cap-bg);
  border-bottom: var(--vz-card-border-width) solid var(--vz-card-border-color);
}
.card-header:first-child {
  border-radius: var(--vz-card-inner-border-radius) var(--vz-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--vz-card-cap-padding-y) var(--vz-card-cap-padding-x);
  color: var(--vz-card-cap-color);
  background-color: var(--vz-card-cap-bg);
  border-top: var(--vz-card-border-width) solid var(--vz-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--vz-card-inner-border-radius) var(--vz-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--vz-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--vz-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--vz-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--vz-card-bg);
  border-bottom-color: var(--vz-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--vz-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--vz-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--vz-card-img-overlay-padding);
  border-radius: var(--vz-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--vz-card-inner-border-radius);
  border-top-right-radius: var(--vz-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--vz-card-inner-border-radius);
  border-bottom-left-radius: var(--vz-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--vz-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --vz-accordion-color: var(--vz-body-color);
  --vz-accordion-bg: #fff;
  --vz-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --vz-accordion-border-color: var(--vz-border-color);
  --vz-accordion-border-width: 1px;
  --vz-accordion-border-radius: 0.25rem;
  --vz-accordion-inner-border-radius: calc(0.25rem - 1px);
  --vz-accordion-btn-padding-x: 1.25rem;
  --vz-accordion-btn-padding-y: 1rem;
  --vz-accordion-btn-color: var(--vz-body-color);
  --vz-accordion-btn-bg: #fff;
  --vz-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  --vz-accordion-btn-icon-width: 0.75rem;
  --vz-accordion-btn-icon-transform: rotate(-180deg);
  --vz-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --vz-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  --vz-accordion-btn-focus-border-color: var(--vz-input-focus-border);
  --vz-accordion-btn-focus-box-shadow: inset 0 -1px 0 var(--vz-border-color);
  --vz-accordion-body-padding-x: 1.25rem;
  --vz-accordion-body-padding-y: 1rem;
  --vz-accordion-active-color: rgb(57.6, 72.9, 123.3);
  --vz-accordion-active-bg: rgba(64, 81, 137, 0.05);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--vz-accordion-btn-padding-y) var(--vz-accordion-btn-padding-x);
  font-size: 0.8125rem;
  color: var(--vz-accordion-btn-color);
  text-align: left;
  background-color: var(--vz-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--vz-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--vz-accordion-active-color);
  background-color: var(--vz-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--vz-accordion-border-width)) 0 var(--vz-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--vz-accordion-btn-active-icon);
  transform: var(--vz-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--vz-accordion-btn-icon-width);
  height: var(--vz-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--vz-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--vz-accordion-btn-icon-width);
  transition: var(--vz-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  border-color: var(--vz-accordion-btn-focus-border-color);
  outline: 0;
  box-shadow: var(--vz-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--vz-accordion-color);
  background-color: var(--vz-accordion-bg);
  border: var(--vz-accordion-border-width) solid var(--vz-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--vz-accordion-border-radius);
  border-top-right-radius: var(--vz-accordion-border-radius);
}
.accordion-item:first-of-type .accordion-button {
  border-top-left-radius: var(--vz-accordion-inner-border-radius);
  border-top-right-radius: var(--vz-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--vz-accordion-border-radius);
  border-bottom-left-radius: var(--vz-accordion-border-radius);
}
.accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: var(--vz-accordion-inner-border-radius);
  border-bottom-left-radius: var(--vz-accordion-inner-border-radius);
}
.accordion-item:last-of-type .accordion-collapse {
  border-bottom-right-radius: var(--vz-accordion-border-radius);
  border-bottom-left-radius: var(--vz-accordion-border-radius);
}

.accordion-body {
  padding: var(--vz-accordion-body-padding-y) var(--vz-accordion-body-padding-x);
}

.accordion-flush .accordion-collapse {
  border-width: 0;
}
.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
  border-radius: 0;
}

.breadcrumb {
  --vz-breadcrumb-padding-x: 0;
  --vz-breadcrumb-padding-y: 0;
  --vz-breadcrumb-margin-bottom: 1rem;
  --vz-breadcrumb-bg: ;
  --vz-breadcrumb-border-radius: ;
  --vz-breadcrumb-divider-color: #878a99;
  --vz-breadcrumb-item-padding-x: 0.3rem;
  --vz-breadcrumb-item-active-color: #878a99;
  display: flex;
  flex-wrap: wrap;
  padding: var(--vz-breadcrumb-padding-y) var(--vz-breadcrumb-padding-x);
  margin-bottom: var(--vz-breadcrumb-margin-bottom);
  font-size: var(--vz-breadcrumb-font-size);
  list-style: none;
  background-color: var(--vz-breadcrumb-bg);
  border-radius: var(--vz-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--vz-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--vz-breadcrumb-item-padding-x);
  color: var(--vz-breadcrumb-divider-color);
  content: var(--vz-breadcrumb-divider, "\\f0142") /* rtl: var(--vz-breadcrumb-divider, "\\f0142") */;
}
.breadcrumb-item.active {
  color: var(--vz-breadcrumb-item-active-color);
}

.pagination {
  --vz-pagination-padding-x: 0.75rem;
  --vz-pagination-padding-y: 0.375rem;
  --vz-pagination-font-size: 0.8125rem;
  --vz-pagination-color: var(--vz-link-color);
  --vz-pagination-bg: var(--vz-card-bg-custom);
  --vz-pagination-border-width: 1px;
  --vz-pagination-border-color: var(--vz-border-color);
  --vz-pagination-border-radius: 0.25rem;
  --vz-pagination-hover-color: var(--vz-link-hover-color);
  --vz-pagination-hover-bg: #eff2f7;
  --vz-pagination-hover-border-color: var(--vz-border-color);
  --vz-pagination-focus-color: var(--vz-link-hover-color);
  --vz-pagination-focus-bg: #eff2f7;
  --vz-pagination-focus-box-shadow: 0 0 0 0 rgba(64, 81, 137, 0.25);
  --vz-pagination-active-color: #fff;
  --vz-pagination-active-bg: #405189;
  --vz-pagination-active-border-color: #405189;
  --vz-pagination-disabled-color: #878a99;
  --vz-pagination-disabled-bg: var(--vz-card-bg-custom);
  --vz-pagination-disabled-border-color: var(--vz-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--vz-pagination-padding-y) var(--vz-pagination-padding-x);
  font-size: var(--vz-pagination-font-size);
  color: var(--vz-pagination-color);
  text-decoration: none;
  background-color: var(--vz-pagination-bg);
  border: var(--vz-pagination-border-width) solid var(--vz-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--vz-pagination-hover-color);
  background-color: var(--vz-pagination-hover-bg);
  border-color: var(--vz-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--vz-pagination-focus-color);
  background-color: var(--vz-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--vz-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--vz-pagination-active-color);
  background-color: var(--vz-pagination-active-bg);
  border-color: var(--vz-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--vz-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--vz-pagination-disabled-bg);
  border-color: var(--vz-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: -1px;
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--vz-pagination-border-radius);
  border-bottom-left-radius: var(--vz-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--vz-pagination-border-radius);
  border-bottom-right-radius: var(--vz-pagination-border-radius);
}

.pagination-lg {
  --vz-pagination-padding-x: 1.2rem;
  --vz-pagination-padding-y: 0.6rem;
  --vz-pagination-font-size: 1.015625rem;
  --vz-pagination-border-radius: 0.3rem;
}

.pagination-sm {
  --vz-pagination-padding-x: 0.5rem;
  --vz-pagination-padding-y: 0.25rem;
  --vz-pagination-font-size: 0.7109375rem;
  --vz-pagination-border-radius: 0.2rem;
}

.badge {
  --vz-badge-padding-x: 0.65em;
  --vz-badge-padding-y: 0.35em;
  --vz-badge-font-size: 0.75em;
  --vz-badge-font-weight: 600;
  --vz-badge-color: #fff;
  --vz-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--vz-badge-padding-y) var(--vz-badge-padding-x);
  font-size: var(--vz-badge-font-size);
  font-weight: var(--vz-badge-font-weight);
  line-height: 1;
  color: var(--vz-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--vz-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --vz-alert-bg: transparent;
  --vz-alert-padding-x: 1rem;
  --vz-alert-padding-y: 0.8rem;
  --vz-alert-margin-bottom: 1rem;
  --vz-alert-color: inherit;
  --vz-alert-border-color: transparent;
  --vz-alert-border: 1px solid var(--vz-alert-border-color);
  --vz-alert-border-radius: 0.25rem;
  position: relative;
  padding: var(--vz-alert-padding-y) var(--vz-alert-padding-x);
  margin-bottom: var(--vz-alert-margin-bottom);
  color: var(--vz-alert-color);
  background-color: var(--vz-alert-bg);
  border: var(--vz-alert-border);
  border-radius: var(--vz-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1rem 1rem;
}

.alert-primary {
  --vz-alert-color: rgb(48, 60.75, 102.75);
  --vz-alert-bg: rgb(226.35, 228.9, 237.3);
  --vz-alert-border-color: rgb(197.7, 202.8, 219.6);
}
.alert-primary .alert-link {
  color: rgb(38.4, 48.6, 82.2);
}

.alert-secondary {
  --vz-alert-color: rgb(39.75, 89.25, 180.75);
  --vz-alert-bg: rgb(224.7, 234.6, 252.9);
  --vz-alert-border-color: rgb(194.4, 214.2, 250.8);
}
.alert-secondary .alert-link {
  color: rgb(31.8, 71.4, 144.6);
}

.alert-success {
  --vz-alert-color: rgb(7.5, 134.25, 117);
  --vz-alert-bg: rgb(218.25, 243.6, 240.15);
  --vz-alert-border-color: rgb(181.5, 232.2, 225.3);
}
.alert-success .alert-link {
  color: rgb(6, 107.4, 93.6);
}

.alert-info {
  --vz-alert-color: rgb(30.75, 117, 164.25);
  --vz-alert-bg: rgb(222.9, 240.15, 249.6);
  --vz-alert-border-color: rgb(190.8, 225.3, 244.2);
}
.alert-info .alert-link {
  color: rgb(24.6, 93.6, 131.4);
}

.alert-warning {
  --vz-alert-color: rgb(185.25, 138, 56.25);
  --vz-alert-bg: rgb(253.8, 244.35, 228);
  --vz-alert-border-color: rgb(252.6, 233.7, 201);
}
.alert-warning .alert-link {
  color: rgb(148.2, 110.4, 45);
}

.alert-danger {
  --vz-alert-color: rgb(180, 75.75, 54);
  --vz-alert-bg: rgb(252.75, 231.9, 227.55);
  --vz-alert-border-color: rgb(250.5, 208.8, 200.1);
}
.alert-danger .alert-link {
  color: rgb(144, 60.6, 43.2);
}

.alert-light {
  --vz-alert-color: rgb(182.25, 184.5, 186.75);
  --vz-alert-bg: rgb(253.2, 253.65, 254.1);
  --vz-alert-border-color: rgb(251.4, 252.3, 253.2);
}
.alert-light .alert-link {
  color: rgb(145.8, 147.6, 149.4);
}

.alert-dark {
  --vz-alert-color: rgb(24.75, 27.75, 30.75);
  --vz-alert-bg: rgb(221.7, 222.3, 222.9);
  --vz-alert-border-color: rgb(188.4, 189.6, 190.8);
}
.alert-dark .alert-link {
  color: rgb(19.8, 22.2, 24.6);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.625rem;
  }
}
.progress {
  --vz-progress-height: 0.625rem;
  --vz-progress-font-size: 0.609375rem;
  --vz-progress-bg: #eff2f7;
  --vz-progress-border-radius: 0.25rem;
  --vz-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --vz-progress-bar-color: #fff;
  --vz-progress-bar-bg: #405189;
  --vz-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--vz-progress-height);
  overflow: hidden;
  font-size: var(--vz-progress-font-size);
  background-color: var(--vz-progress-bg);
  border-radius: var(--vz-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--vz-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--vz-progress-bar-bg);
  transition: var(--vz-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--vz-progress-height) var(--vz-progress-height);
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --vz-list-group-color: var(--vz-body-color);
  --vz-list-group-bg: var(--vz-card-bg-custom);
  --vz-list-group-border-color: var(--vz-border-color);
  --vz-list-group-border-width: 1px;
  --vz-list-group-border-radius: 0.25rem;
  --vz-list-group-item-padding-x: 1rem;
  --vz-list-group-item-padding-y: 0.7rem;
  --vz-list-group-action-color: var(--vz-body-color);
  --vz-list-group-action-hover-color: var(--vz-body-color);
  --vz-list-group-action-hover-bg: var(--vz-list-group-hover-bg);
  --vz-list-group-action-active-color: var(--vz-body-color);
  --vz-list-group-action-active-bg: var(--vz-list-group-hover-bg);
  --vz-list-group-disabled-color: #878a99;
  --vz-list-group-disabled-bg: var(--vz-card-bg-custom);
  --vz-list-group-active-color: #fff;
  --vz-list-group-active-bg: #405189;
  --vz-list-group-active-border-color: #405189;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--vz-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item-action {
  width: 100%;
  color: var(--vz-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: var(--vz-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--vz-list-group-action-hover-bg);
}
.list-group-item-action:active {
  color: var(--vz-list-group-action-active-color);
  background-color: var(--vz-list-group-action-active-bg);
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--vz-list-group-item-padding-y) var(--vz-list-group-item-padding-x);
  color: var(--vz-list-group-color);
  text-decoration: none;
  background-color: var(--vz-list-group-bg);
  border: var(--vz-list-group-border-width) solid var(--vz-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--vz-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--vz-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--vz-list-group-active-color);
  background-color: var(--vz-list-group-active-bg);
  border-color: var(--vz-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--vz-list-group-border-width));
  border-top-width: var(--vz-list-group-border-width);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--vz-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--vz-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--vz-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--vz-list-group-border-width));
  border-left-width: var(--vz-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--vz-list-group-border-width));
    border-left-width: var(--vz-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--vz-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: rgb(38.4, 48.6, 82.2);
  background-color: rgb(216.8, 220.2, 231.4);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(38.4, 48.6, 82.2);
  background-color: rgb(195.12, 198.18, 208.26);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(38.4, 48.6, 82.2);
  border-color: rgb(38.4, 48.6, 82.2);
}

.list-group-item-secondary {
  color: rgb(31.8, 71.4, 144.6);
  background-color: rgb(214.6, 227.8, 252.2);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(31.8, 71.4, 144.6);
  background-color: rgb(193.14, 205.02, 226.98);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(31.8, 71.4, 144.6);
  border-color: rgb(31.8, 71.4, 144.6);
}

.list-group-item-success {
  color: rgb(6, 107.4, 93.6);
  background-color: rgb(206, 239.8, 235.2);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(6, 107.4, 93.6);
  background-color: rgb(185.4, 215.82, 211.68);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(6, 107.4, 93.6);
  border-color: rgb(6, 107.4, 93.6);
}

.list-group-item-info {
  color: rgb(24.6, 93.6, 131.4);
  background-color: rgb(212.2, 235.2, 247.8);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(24.6, 93.6, 131.4);
  background-color: rgb(190.98, 211.68, 223.02);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(24.6, 93.6, 131.4);
  border-color: rgb(24.6, 93.6, 131.4);
}

.list-group-item-warning {
  color: rgb(148.2, 110.4, 45);
  background-color: rgb(253.4, 240.8, 219);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(148.2, 110.4, 45);
  background-color: rgb(228.06, 216.72, 197.1);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(148.2, 110.4, 45);
  border-color: rgb(148.2, 110.4, 45);
}

.list-group-item-danger {
  color: rgb(144, 60.6, 43.2);
  background-color: rgb(252, 224.2, 218.4);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(144, 60.6, 43.2);
  background-color: rgb(226.8, 201.78, 196.56);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(144, 60.6, 43.2);
  border-color: rgb(144, 60.6, 43.2);
}

.list-group-item-light {
  color: rgb(145.8, 147.6, 149.4);
  background-color: rgb(252.6, 253.2, 253.8);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(145.8, 147.6, 149.4);
  background-color: rgb(227.34, 227.88, 228.42);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(145.8, 147.6, 149.4);
  border-color: rgb(145.8, 147.6, 149.4);
}

.list-group-item-dark {
  color: rgb(19.8, 22.2, 24.6);
  background-color: rgb(210.6, 211.4, 212.2);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(19.8, 22.2, 24.6);
  background-color: rgb(189.54, 190.26, 190.98);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(19.8, 22.2, 24.6);
  border-color: rgb(19.8, 22.2, 24.6);
}

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_47___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5;
}
.btn-close:hover {
  color: #000;
  text-decoration: none;
  opacity: 0.75;
}
.btn-close:focus {
  outline: 0;
  box-shadow: 0 0 0 0 rgba(64, 81, 137, 0.25);
  opacity: 1;
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.25;
}

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --vz-toast-zindex: 1090;
  --vz-toast-padding-x: 0.75rem;
  --vz-toast-padding-y: 0.5rem;
  --vz-toast-spacing: 1.5rem;
  --vz-toast-max-width: 350px;
  --vz-toast-font-size: 0.875rem;
  --vz-toast-color: ;
  --vz-toast-bg: rgba(255, 255, 255, 0.85);
  --vz-toast-border-width: 1px;
  --vz-toast-border-color: rgba(0, 0, 0, 0.1);
  --vz-toast-border-radius: 0.25rem;
  --vz-toast-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --vz-toast-header-color: #878a99;
  --vz-toast-header-bg: rgba(255, 255, 255, 0.85);
  --vz-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--vz-toast-max-width);
  max-width: 100%;
  font-size: var(--vz-toast-font-size);
  color: var(--vz-toast-color);
  pointer-events: auto;
  background-color: var(--vz-toast-bg);
  background-clip: padding-box;
  border: var(--vz-toast-border-width) solid var(--vz-toast-border-color);
  box-shadow: var(--vz-toast-box-shadow);
  border-radius: var(--vz-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --vz-toast-zindex: 1090;
  position: absolute;
  z-index: var(--vz-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--vz-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--vz-toast-padding-y) var(--vz-toast-padding-x);
  color: var(--vz-toast-header-color);
  background-color: var(--vz-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--vz-toast-border-width) solid var(--vz-toast-header-border-color);
  border-top-left-radius: calc(var(--vz-toast-border-radius) - var(--vz-toast-border-width));
  border-top-right-radius: calc(var(--vz-toast-border-radius) - var(--vz-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--vz-toast-padding-x));
  margin-left: var(--vz-toast-padding-x);
}

.toast-body {
  padding: var(--vz-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --vz-modal-zindex: 1055;
  --vz-modal-width: 600px;
  --vz-modal-padding: 1.25rem;
  --vz-modal-margin: 0.5rem;
  --vz-modal-color: ;
  --vz-modal-bg: #fff;
  --vz-modal-border-color: var(--vz-border-color);
  --vz-modal-border-width: 1px;
  --vz-modal-border-radius: 0.3rem;
  --vz-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --vz-modal-inner-border-radius: calc(0.3rem - 1px);
  --vz-modal-header-padding-x: 1.25rem;
  --vz-modal-header-padding-y: 1.25rem;
  --vz-modal-header-padding: 1.25rem 1.25rem;
  --vz-modal-header-border-color: var(--vz-border-color);
  --vz-modal-header-border-width: 0;
  --vz-modal-title-line-height: 1.5;
  --vz-modal-footer-gap: 0.5rem;
  --vz-modal-footer-bg: ;
  --vz-modal-footer-border-color: var(--vz-border-color);
  --vz-modal-footer-border-width: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--vz-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--vz-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--vz-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--vz-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--vz-modal-color);
  pointer-events: auto;
  background-color: var(--vz-modal-bg);
  background-clip: padding-box;
  border: var(--vz-modal-border-width) solid var(--vz-modal-border-color);
  border-radius: var(--vz-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --vz-backdrop-zindex: 1050;
  --vz-backdrop-bg: #000;
  --vz-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--vz-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--vz-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--vz-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--vz-modal-header-padding);
  border-bottom: var(--vz-modal-header-border-width) solid var(--vz-modal-header-border-color);
  border-top-left-radius: var(--vz-modal-inner-border-radius);
  border-top-right-radius: var(--vz-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--vz-modal-header-padding-y) * 0.5) calc(var(--vz-modal-header-padding-x) * 0.5);
  margin: calc(-0.5 * var(--vz-modal-header-padding-y)) calc(-0.5 * var(--vz-modal-header-padding-x)) calc(-0.5 * var(--vz-modal-header-padding-y)) auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--vz-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--vz-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--vz-modal-padding) - var(--vz-modal-footer-gap) * 0.5);
  background-color: var(--vz-modal-footer-bg);
  border-top: var(--vz-modal-footer-border-width) solid var(--vz-modal-footer-border-color);
  border-bottom-right-radius: var(--vz-modal-inner-border-radius);
  border-bottom-left-radius: var(--vz-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--vz-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --vz-modal-margin: 1.75rem;
    --vz-modal-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  }
  .modal-dialog {
    max-width: var(--vz-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --vz-modal-width: 400px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --vz-modal-width: 900px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --vz-modal-width: 1240px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --vz-tooltip-zindex: 1080;
  --vz-tooltip-max-width: 200px;
  --vz-tooltip-padding-x: 0.7rem;
  --vz-tooltip-padding-y: 0.4rem;
  --vz-tooltip-margin: 0;
  --vz-tooltip-font-size: 0.7109375rem;
  --vz-tooltip-color: #fff;
  --vz-tooltip-bg: #000;
  --vz-tooltip-border-radius: 0.2rem;
  --vz-tooltip-opacity: 0.9;
  --vz-tooltip-arrow-width: 0.8rem;
  --vz-tooltip-arrow-height: 0.4rem;
  z-index: var(--vz-tooltip-zindex);
  display: block;
  padding: var(--vz-tooltip-arrow-height);
  margin: var(--vz-tooltip-margin);
  font-family: var(--vz-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--vz-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--vz-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--vz-tooltip-arrow-width);
  height: var(--vz-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: 0;
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--vz-tooltip-arrow-height) calc(var(--vz-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--vz-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: 0;
  width: var(--vz-tooltip-arrow-height);
  height: var(--vz-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--vz-tooltip-arrow-width) * 0.5) var(--vz-tooltip-arrow-height) calc(var(--vz-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--vz-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: 0;
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--vz-tooltip-arrow-width) * 0.5) var(--vz-tooltip-arrow-height);
  border-bottom-color: var(--vz-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: 0;
  width: var(--vz-tooltip-arrow-height);
  height: var(--vz-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--vz-tooltip-arrow-width) * 0.5) 0 calc(var(--vz-tooltip-arrow-width) * 0.5) var(--vz-tooltip-arrow-height);
  border-left-color: var(--vz-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--vz-tooltip-max-width);
  padding: var(--vz-tooltip-padding-y) var(--vz-tooltip-padding-x);
  color: var(--vz-tooltip-color);
  text-align: center;
  background-color: var(--vz-tooltip-bg);
  border-radius: var(--vz-tooltip-border-radius);
}

.popover {
  --vz-popover-zindex: 1070;
  --vz-popover-max-width: 276px;
  --vz-popover-font-size: 0.8125rem;
  --vz-popover-bg: #fff;
  --vz-popover-border-width: 1px;
  --vz-popover-border-color: var(--vz-border-color);
  --vz-popover-border-radius: 0.25rem;
  --vz-popover-inner-border-radius: calc(0.25rem - 1px);
  --vz-popover-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  --vz-popover-header-padding-x: 1rem;
  --vz-popover-header-padding-y: 0.7rem;
  --vz-popover-header-font-size: 0.8125rem;
  --vz-popover-header-color: ;
  --vz-popover-header-bg: var(--vz-popover-bg);
  --vz-popover-body-padding-x: 1rem;
  --vz-popover-body-padding-y: 1rem;
  --vz-popover-body-color: var(--vz-body-color);
  --vz-popover-arrow-width: 1rem;
  --vz-popover-arrow-height: 0.5rem;
  --vz-popover-arrow-border: var(--vz-popover-border-color);
  z-index: var(--vz-popover-zindex);
  display: block;
  max-width: var(--vz-popover-max-width);
  font-family: var(--vz-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--vz-popover-font-size);
  word-wrap: break-word;
  background-color: var(--vz-popover-bg);
  background-clip: padding-box;
  border: var(--vz-popover-border-width) solid var(--vz-popover-border-color);
  border-radius: var(--vz-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--vz-popover-arrow-width);
  height: var(--vz-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--vz-popover-arrow-height) calc(var(--vz-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--vz-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--vz-popover-border-width);
  border-top-color: var(--vz-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
  width: var(--vz-popover-arrow-height);
  height: var(--vz-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--vz-popover-arrow-width) * 0.5) var(--vz-popover-arrow-height) calc(var(--vz-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--vz-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--vz-popover-border-width);
  border-right-color: var(--vz-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--vz-popover-arrow-width) * 0.5) var(--vz-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--vz-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--vz-popover-border-width);
  border-bottom-color: var(--vz-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--vz-popover-arrow-width);
  margin-left: calc(-0.5 * var(--vz-popover-arrow-width));
  content: "";
  border-bottom: var(--vz-popover-border-width) solid var(--vz-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
  width: var(--vz-popover-arrow-height);
  height: var(--vz-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--vz-popover-arrow-width) * 0.5) 0 calc(var(--vz-popover-arrow-width) * 0.5) var(--vz-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--vz-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--vz-popover-border-width);
  border-left-color: var(--vz-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--vz-popover-header-padding-y) var(--vz-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--vz-popover-header-font-size);
  color: var(--vz-popover-header-color);
  background-color: var(--vz-popover-header-bg);
  border-bottom: var(--vz-popover-border-width) solid var(--vz-popover-border-color);
  border-top-left-radius: var(--vz-popover-inner-border-radius);
  border-top-right-radius: var(--vz-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--vz-popover-body-padding-y) var(--vz-popover-body-padding-x);
  color: var(--vz-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center;
}

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100);
}
.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000;
}
.carousel-dark .carousel-caption {
  color: #000;
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--vz-spinner-width);
  height: var(--vz-spinner-height);
  vertical-align: var(--vz-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--vz-spinner-animation-speed) linear infinite var(--vz-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --vz-spinner-width: 2rem;
  --vz-spinner-height: 2rem;
  --vz-spinner-vertical-align: -0.125em;
  --vz-spinner-border-width: 0.25em;
  --vz-spinner-animation-speed: 0.75s;
  --vz-spinner-animation-name: spinner-border;
  border: var(--vz-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --vz-spinner-width: 1rem;
  --vz-spinner-height: 1rem;
  --vz-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --vz-spinner-width: 2rem;
  --vz-spinner-height: 2rem;
  --vz-spinner-vertical-align: -0.125em;
  --vz-spinner-animation-speed: 0.75s;
  --vz-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --vz-spinner-width: 1rem;
  --vz-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --vz-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --vz-offcanvas-zindex: 1045;
  --vz-offcanvas-width: 400px;
  --vz-offcanvas-height: 30vh;
  --vz-offcanvas-padding-x: 1.25rem;
  --vz-offcanvas-padding-y: 1.25rem;
  --vz-offcanvas-color: ;
  --vz-offcanvas-bg: #fff;
  --vz-offcanvas-border-width: 1px;
  --vz-offcanvas-border-color: var(--vz-border-color);
  --vz-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out;
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--vz-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--vz-offcanvas-color);
  visibility: hidden;
  background-color: var(--vz-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: transform 0.3s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--vz-offcanvas-width);
  border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--vz-offcanvas-width);
  border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--vz-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--vz-offcanvas-height);
  max-height: 100%;
  border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--vz-offcanvas-padding-y) var(--vz-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--vz-offcanvas-padding-y) * 0.5) calc(var(--vz-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--vz-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--vz-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--vz-offcanvas-padding-y));
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--vz-offcanvas-padding-y) var(--vz-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(64, 81, 137, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(53, 119, 241, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(10, 179, 156, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(41, 156, 219, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(247, 184, 75, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(240, 101, 72, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(243, 246, 249, var(--vz-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(33, 37, 41, var(--vz-bg-opacity, 1)) !important;
}

.link-primary {
  color: #405189 !important;
}
.link-primary:hover, .link-primary:focus {
  color: rgb(51.2, 64.8, 109.6) !important;
}

.link-secondary {
  color: #3577f1 !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: rgb(42.4, 95.2, 192.8) !important;
}

.link-success {
  color: #0ab39c !important;
}
.link-success:hover, .link-success:focus {
  color: rgb(8, 143.2, 124.8) !important;
}

.link-info {
  color: #299cdb !important;
}
.link-info:hover, .link-info:focus {
  color: rgb(32.8, 124.8, 175.2) !important;
}

.link-warning {
  color: #f7b84b !important;
}
.link-warning:hover, .link-warning:focus {
  color: rgb(197.6, 147.2, 60) !important;
}

.link-danger {
  color: #f06548 !important;
}
.link-danger:hover, .link-danger:focus {
  color: rgb(192, 80.8, 57.6) !important;
}

.link-light {
  color: #f3f6f9 !important;
}
.link-light:hover, .link-light:focus {
  color: rgb(245.4, 247.8, 250.2) !important;
}

.link-dark {
  color: #212529 !important;
}
.link-dark:hover, .link-dark:focus {
  color: rgb(26.4, 29.6, 32.8) !important;
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--vz-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --vz-aspect-ratio: 100%;
}

.ratio-4x3 {
  --vz-aspect-ratio: 75%;
}

.ratio-16x9 {
  --vz-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --vz-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
}

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.shadow-lg {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-primary-rgb), var(--vz-border-opacity)) !important;
}

.border-secondary {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-secondary-rgb), var(--vz-border-opacity)) !important;
}

.border-success {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-success-rgb), var(--vz-border-opacity)) !important;
}

.border-info {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-info-rgb), var(--vz-border-opacity)) !important;
}

.border-warning {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-warning-rgb), var(--vz-border-opacity)) !important;
}

.border-danger {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-danger-rgb), var(--vz-border-opacity)) !important;
}

.border-light {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-light-rgb), var(--vz-border-opacity)) !important;
}

.border-dark {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-dark-rgb), var(--vz-border-opacity)) !important;
}

.border-white {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-white-rgb), var(--vz-border-opacity)) !important;
}

.border-1 {
  --vz-border-width: 1px;
}

.border-2 {
  --vz-border-width: 2px;
}

.border-3 {
  --vz-border-width: 3px;
}

.border-4 {
  --vz-border-width: 4px;
}

.border-5 {
  --vz-border-width: 5px;
}

.border-opacity-10 {
  --vz-border-opacity: 0.1;
}

.border-opacity-25 {
  --vz-border-opacity: 0.25;
}

.border-opacity-50 {
  --vz-border-opacity: 0.5;
}

.border-opacity-75 {
  --vz-border-opacity: 0.75;
}

.border-opacity-100 {
  --vz-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important;
}

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important;
}

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important;
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important;
}

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important;
}

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important;
}

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important;
}

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important;
}

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important;
}

.mt-n1 {
  margin-top: -0.25rem !important;
}

.mt-n2 {
  margin-top: -0.5rem !important;
}

.mt-n3 {
  margin-top: -1rem !important;
}

.mt-n4 {
  margin-top: -1.5rem !important;
}

.mt-n5 {
  margin-top: -3rem !important;
}

.me-n1 {
  margin-right: -0.25rem !important;
}

.me-n2 {
  margin-right: -0.5rem !important;
}

.me-n3 {
  margin-right: -1rem !important;
}

.me-n4 {
  margin-right: -1.5rem !important;
}

.me-n5 {
  margin-right: -3rem !important;
}

.mb-n1 {
  margin-bottom: -0.25rem !important;
}

.mb-n2 {
  margin-bottom: -0.5rem !important;
}

.mb-n3 {
  margin-bottom: -1rem !important;
}

.mb-n4 {
  margin-bottom: -1.5rem !important;
}

.mb-n5 {
  margin-bottom: -3rem !important;
}

.ms-n1 {
  margin-left: -0.25rem !important;
}

.ms-n2 {
  margin-left: -0.5rem !important;
}

.ms-n3 {
  margin-left: -1rem !important;
}

.ms-n4 {
  margin-left: -1.5rem !important;
}

.ms-n5 {
  margin-left: -3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.font-monospace {
  font-family: var(--vz-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.328125rem + 0.9375vw) !important;
}

.fs-2 {
  font-size: calc(1.2875rem + 0.45vw) !important;
}

.fs-3 {
  font-size: calc(1.2671875rem + 0.20625vw) !important;
}

.fs-4 {
  font-size: 1.21875rem !important;
}

.fs-5 {
  font-size: 1.015625rem !important;
}

.fs-6 {
  font-size: 0.8125rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-primary-rgb), var(--vz-text-opacity)) !important;
}

.text-secondary {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-secondary-rgb), var(--vz-text-opacity)) !important;
}

.text-success {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-success-rgb), var(--vz-text-opacity)) !important;
}

.text-info {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-info-rgb), var(--vz-text-opacity)) !important;
}

.text-warning {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-warning-rgb), var(--vz-text-opacity)) !important;
}

.text-danger {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-danger-rgb), var(--vz-text-opacity)) !important;
}

.text-light {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-light-rgb), var(--vz-text-opacity)) !important;
}

.text-dark {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-dark-rgb), var(--vz-text-opacity)) !important;
}

.text-black {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-black-rgb), var(--vz-text-opacity)) !important;
}

.text-white {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-white-rgb), var(--vz-text-opacity)) !important;
}

.text-body {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-body-color-rgb), var(--vz-text-opacity)) !important;
}

.text-muted {
  --vz-text-opacity: 1;
  color: #878a99 !important;
}

.text-black-50 {
  --vz-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --vz-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-reset {
  --vz-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --vz-text-opacity: 0.25;
}

.text-opacity-50 {
  --vz-text-opacity: 0.5;
}

.text-opacity-75 {
  --vz-text-opacity: 0.75;
}

.text-opacity-100 {
  --vz-text-opacity: 1;
}

.bg-primary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-primary-rgb), var(--vz-bg-opacity)) !important;
}

.bg-secondary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-secondary-rgb), var(--vz-bg-opacity)) !important;
}

.bg-success {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-success-rgb), var(--vz-bg-opacity)) !important;
}

.bg-info {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-info-rgb), var(--vz-bg-opacity)) !important;
}

.bg-warning {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-warning-rgb), var(--vz-bg-opacity)) !important;
}

.bg-danger {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-danger-rgb), var(--vz-bg-opacity)) !important;
}

.bg-light {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-light-rgb), var(--vz-bg-opacity)) !important;
}

.bg-dark {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-dark-rgb), var(--vz-bg-opacity)) !important;
}

.bg-black {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-black-rgb), var(--vz-bg-opacity)) !important;
}

.bg-white {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-white-rgb), var(--vz-bg-opacity)) !important;
}

.bg-body {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-body-bg-rgb), var(--vz-bg-opacity)) !important;
}

.bg-transparent {
  --vz-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-opacity-10 {
  --vz-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --vz-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --vz-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --vz-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --vz-bg-opacity: 1;
}

.bg-gradient {
  background-image: var(--vz-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--vz-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--vz-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--vz-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--vz-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--vz-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--vz-border-radius-2xl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--vz-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--vz-border-radius) !important;
  border-top-right-radius: var(--vz-border-radius) !important;
}

.rounded-end {
  border-top-right-radius: var(--vz-border-radius) !important;
  border-bottom-right-radius: var(--vz-border-radius) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--vz-border-radius) !important;
  border-bottom-left-radius: var(--vz-border-radius) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--vz-border-radius) !important;
  border-top-left-radius: var(--vz-border-radius) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-sm-n3 {
    margin-top: -1rem !important;
  }
  .mt-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-sm-n5 {
    margin-top: -3rem !important;
  }
  .me-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .me-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .me-sm-n3 {
    margin-right: -1rem !important;
  }
  .me-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .me-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-sm-n3 {
    margin-left: -1rem !important;
  }
  .ms-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-sm-n5 {
    margin-left: -3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-md-n3 {
    margin-top: -1rem !important;
  }
  .mt-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-md-n5 {
    margin-top: -3rem !important;
  }
  .me-md-n1 {
    margin-right: -0.25rem !important;
  }
  .me-md-n2 {
    margin-right: -0.5rem !important;
  }
  .me-md-n3 {
    margin-right: -1rem !important;
  }
  .me-md-n4 {
    margin-right: -1.5rem !important;
  }
  .me-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-md-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-md-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-md-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-md-n3 {
    margin-left: -1rem !important;
  }
  .ms-md-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-md-n5 {
    margin-left: -3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-lg-n3 {
    margin-top: -1rem !important;
  }
  .mt-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-lg-n5 {
    margin-top: -3rem !important;
  }
  .me-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .me-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .me-lg-n3 {
    margin-right: -1rem !important;
  }
  .me-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .me-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-lg-n3 {
    margin-left: -1rem !important;
  }
  .ms-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-lg-n5 {
    margin-left: -3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xl-n5 {
    margin-top: -3rem !important;
  }
  .me-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xl-n3 {
    margin-right: -1rem !important;
  }
  .me-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xl-n5 {
    margin-left: -3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .m-xxl-n1 {
    margin: -0.25rem !important;
  }
  .m-xxl-n2 {
    margin: -0.5rem !important;
  }
  .m-xxl-n3 {
    margin: -1rem !important;
  }
  .m-xxl-n4 {
    margin: -1.5rem !important;
  }
  .m-xxl-n5 {
    margin: -3rem !important;
  }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important;
  }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important;
  }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important;
  }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important;
  }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important;
  }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important;
  }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important;
  }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important;
  }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important;
  }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important;
  }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important;
  }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important;
  }
  .mt-xxl-n3 {
    margin-top: -1rem !important;
  }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important;
  }
  .mt-xxl-n5 {
    margin-top: -3rem !important;
  }
  .me-xxl-n1 {
    margin-right: -0.25rem !important;
  }
  .me-xxl-n2 {
    margin-right: -0.5rem !important;
  }
  .me-xxl-n3 {
    margin-right: -1rem !important;
  }
  .me-xxl-n4 {
    margin-right: -1.5rem !important;
  }
  .me-xxl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important;
  }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important;
  }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important;
  }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important;
  }
  .ms-xxl-n3 {
    margin-left: -1rem !important;
  }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important;
  }
  .ms-xxl-n5 {
    margin-left: -3rem !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.03125rem !important;
  }
  .fs-2 {
    font-size: 1.625rem !important;
  }
  .fs-3 {
    font-size: 1.421875rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 2.0.0
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Main Css File
*/
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  src: local("hkgrotesk light"), url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format("woff");
  font-weight: 300;
}
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  src: local("hkgrotesk regular"), url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("woff");
  font-weight: 400;
}
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  src: local("hkgrotesk medium"), url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format("woff");
  font-weight: 500;
}
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  src: local("hkgrotesk semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format("woff");
  font-weight: 600;
}
@font-face {
  font-family: "hkgrotesk";
  src: local("hkgrotesk bold"), url(${___CSS_LOADER_URL_REPLACEMENT_58___}) format("woff");
  font-weight: 700;
}
:root {
  --vz-vertical-menu-bg: #fff;
  --vz-vertical-menu-item-color: rgb(108.8918918919, 112.0945945946, 128.1081081081);
  --vz-vertical-menu-item-hover-color: #405189;
  --vz-vertical-menu-item-active-color: #405189;
  --vz-vertical-menu-sub-item-color: rgb(123.972972973, 127.2486486486, 143.627027027);
  --vz-vertical-menu-sub-item-hover-color: #405189;
  --vz-vertical-menu-sub-item-active-color: #405189;
  --vz-vertical-menu-title-color: #919da9;
  --vz-vertical-menu-bg-dark: #212529;
  --vz-vertical-menu-item-color-dark: #a3a6b7;
  --vz-vertical-menu-item-hover-color-dark: #fff;
  --vz-vertical-menu-item-active-color-dark: #fff;
  --vz-vertical-menu-sub-item-color-dark: #a3a6b7;
  --vz-vertical-menu-sub-item-hover-color-dark: #fff;
  --vz-vertical-menu-sub-item-active-color-dark: #fff;
  --vz-vertical-menu-title-color-dark: rgb(108.8918918919, 112.0945945946, 128.1081081081);
  --vz-header-bg: #fff;
  --vz-header-item-color: #e9ecef;
  --vz-header-bg-dark: #405189;
  --vz-header-item-color-dark: #b0c4d9;
  --vz-topbar-search-bg: #f3f3f9;
  --vz-topbar-user-bg: #f3f3f9;
  --vz-topbar-user-bg-dark: #52639c;
  --vz-footer-bg: #fff;
  --vz-footer-color: #98a6ad;
  --vz-topnav-bg: #fff;
  --vz-topnav-item-color: rgb(108.8918918919, 112.0945945946, 128.1081081081);
  --vz-topnav-item-color-active: #405189;
  --vz-twocolumn-menu-iconview-bg: #fff;
  --vz-twocolumn-menu-bg: #fff;
  --vz-twocolumn-menu-iconview-bg-dark: var(--vz-vertical-menu-bg-dark);
  --vz-twocolumn-menu-bg-dark: rgb(67.247761194, 85.1104477612, 143.952238806);
  --vz-twocolumn-menu-item-color-dark: var(--vz-vertical-menu-item-color-dark);
  --vz-twocolumn-menu-item-active-color-dark: #fff;
  --vz-twocolumn-menu-item-active-bg-dark: rgba(255, 255, 255, 0.15);
  --vz-boxed-body-bg: rgb(229.4, 229.4, 242.2);
  --vz-heading-color: #495057;
  --vz-link-color: #405189;
  --vz-link-hover-color: #405189;
  --vz-border-color: #e9ebec;
  --vz-card-bg-custom: #fff;
  --vz-card-logo-dark: block;
  --vz-card-logo-light: none;
}
:root .nav-tabs {
  --vz-nav-tabs-link-active-bg: #f3f3f9;
}
:root .choices, :root .flatpickr-calendar, :root .ck, :root .ql-toolbar, :root .select2-container, :root .menu-dropdown {
  --vz-choices-bg: #fff;
  --vz-choices-link-color: #212529;
  --vz-choices-link-hover-bg: #f3f6f9;
  --vz-choices-link-active-color: rgb(29.7, 33.3, 36.9);
}
:root {
  --vz-list-group-hover-bg: #f3f6f9;
  --vz-input-bg: #fff;
  --vz-input-border: #ced4da;
  --vz-input-focus-border: rgb(159.5, 168, 196);
  --vz-input-disabled-bg: #eff2f7;
  --vz-input-group-addon-bg: #eff2f7;
  --vz-input-check-border: var(--vz-input-border);
}

[data-layout-mode=dark] {
  --vz-gray-100: #1a1d21;
  --vz-gray-200: #212529;
  --vz-gray-300: #2a2f34;
  --vz-gray-400: #878a99;
  --vz-gray-500: #adb5bd;
  --vz-gray-600: #bfc8e2;
  --vz-gray-700: #ced4da;
  --vz-gray-800: #eff2f7;
  --vz-gray-900: #f3f6f9;
  --vz-body-bg: #1a1d21;
  --vz-body-bg-rgb: 26, 29, 33;
  --vz-body-color: #ced4da;
  --vz-body-color-rgb: 206, 212, 218;
  --vz-vertical-menu-bg: #fff;
  --vz-vertical-menu-item-color: rgb(94.8324324324, 97.6216216216, 111.5675675676);
  --vz-vertical-menu-item-hover-color: #405189;
  --vz-vertical-menu-item-active-color: #405189;
  --vz-vertical-menu-sub-item-color: rgb(104.2054054054, 107.2702702703, 122.5945945946);
  --vz-vertical-menu-sub-item-hover-color: #405189;
  --vz-vertical-menu-sub-item-active-color: #405189;
  --vz-vertical-menu-title-color: #878a99;
  --vz-vertical-menu-bg-dark: #212529;
  --vz-vertical-menu-item-color-dark: #878a99;
  --vz-vertical-menu-item-hover-color-dark: #fff;
  --vz-vertical-menu-item-active-color-dark: #fff;
  --vz-vertical-menu-sub-item-color-dark: rgb(123.972972973, 127.2486486486, 143.627027027);
  --vz-vertical-menu-sub-item-hover-color-dark: #fff;
  --vz-vertical-menu-sub-item-active-color-dark: #fff;
  --vz-vertical-menu-title-color-dark: rgb(94.8324324324, 97.6216216216, 111.5675675676);
  --vz-header-bg: #292e32;
  --vz-header-item-color: #e9ecef;
  --vz-header-bg-dark: #405189;
  --vz-header-item-color-dark: #b0c4d9;
  --vz-topbar-search-bg: #202328;
  --vz-topbar-user-bg: rgb(48.8361702128, 54.65, 60.4638297872);
  --vz-topbar-user-bg-dark: #52639c;
  --vz-footer-bg: #212529;
  --vz-footer-color: #878a99;
  --vz-topnav-bg: rgb(38.6858108108, 43.375, 48.0641891892);
  --vz-topnav-item-color: #878a99;
  --vz-topnav-item-color-active: #fff;
  --vz-twocolumn-menu-iconview-bg: #fff;
  --vz-twocolumn-menu-bg: #fff;
  --vz-twocolumn-menu-iconview-bg-dark: var(--vz-vertical-menu-bg-dark);
  --vz-twocolumn-menu-bg-dark: #30363a;
  --vz-twocolumn-menu-item-color-dark: var(--vz-vertical-menu-item-color-dark);
  --vz-twocolumn-menu-item-active-color-dark: #fff;
  --vz-twocolumn-menu-item-active-bg-dark: rgba(255, 255, 255, 0.15);
  --vz-boxed-body-bg: rgb(17.0101694915, 18.9728813559, 21.5898305085);
  --vz-heading-color: #ced4da;
  --vz-light: #2a2f34;
  --vz-light-rgb: 42, 47, 52;
  --vz-dark: #eff2f7;
  --vz-dark-rgb: 239, 242, 247;
  --vz-link-color: #ced4da;
  --vz-link-hover-color: #ced4da;
  --vz-border-color: rgb(49.9755319149, 55.925, 61.8744680851);
}
[data-layout-mode=dark] .dropdown-menu {
  --vz-dropdown-bg: rgb(40.9601351351, 45.925, 50.8898648649);
  --vz-dropdown-link-color: #adb5bd;
  --vz-dropdown-link-hover-color: rgb(185.4, 190.8, 196.2);
  --vz-dropdown-link-hover-bg: rgb(46.5574468085, 52.1, 57.6425531915);
  --vz-dropdown-border-width: 1px;
  --vz-dropdown-link-active-color: #adb5bd;
  --vz-dropdown-link-active-bg: rgb(46.5574468085, 52.1, 57.6425531915);
}
[data-layout-mode=dark] .choices, [data-layout-mode=dark] .flatpickr-calendar, [data-layout-mode=dark] .ck, [data-layout-mode=dark] .ql-toolbar, [data-layout-mode=dark] .select2-container, [data-layout-mode=dark] .menu-dropdown {
  --vz-choices-bg: rgb(40.9601351351, 45.925, 50.8898648649);
  --vz-choices-link-color: #adb5bd;
  --vz-choices-link-hover-bg: rgb(46.5574468085, 52.1, 57.6425531915);
  --vz-choices-link-active-color: rgb(218.7, 221.4, 224.1);
}
[data-layout-mode=dark] .btn-light {
  --vz-btn-color: var(--vz-dark);
  --vz-btn-bg: var(--vz-light);
  --vz-btn-border-color: var(--vz-light);
}
[data-layout-mode=dark] .btn-outline-light {
  --vz-btn-color: var(--vz-dark);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-light);
}
[data-layout-mode=dark] .btn-light, [data-layout-mode=dark] .btn-outline-light {
  --vz-btn-hover-color: var(--vz-dark);
  --vz-btn-hover-bg: rgba(var(--vz-light-rgb), 0.75);
  --vz-btn-hover-border-color: rgba(var(--vz-light-rgb), 0.75);
}
[data-layout-mode=dark] .btn-dark {
  --vz-btn-color: var(--vz-light);
  --vz-btn-bg: var(--vz-dark);
  --vz-btn-border-color: var(--vz-dark);
}
[data-layout-mode=dark] .btn-outline-dark {
  --vz-btn-color: var(--vz-dark);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: var(--vz-dark);
}
[data-layout-mode=dark] .btn-dark, [data-layout-mode=dark] .btn-outline-dark {
  --vz-btn-hover-color: var(--vz-light);
  --vz-btn-hover-bg: rgba(var(--vz-dark-rgb), 0.75);
  --vz-btn-hover-border-color: rgba(var(--vz-dark-rgb), 0.75);
}
[data-layout-mode=dark] .card {
  --vz-card-bg: #212529;
  --vz-card-cap-bg: #212529;
}
[data-layout-mode=dark] {
  --vz-card-bg-custom: #212529;
  --vz-card-logo-dark: none;
  --vz-card-logo-light: block;
}
[data-layout-mode=dark] .modal {
  --vz-modal-bg: #212529;
}
[data-layout-mode=dark] .nav-tabs {
  --vz-nav-tabs-link-active-color: #f3f6f9;
  --vz-nav-tabs-link-active-bg: #2a2f34;
}
[data-layout-mode=dark] .accordion {
  --vz-accordion-button-active-color: #fff;
  --vz-accordion-bg: #212529;
  --vz-accordion-btn-bg: #212529;
}
[data-layout-mode=dark] .offcanvas,
[data-layout-mode=dark] .offcanvas-lg,
[data-layout-mode=dark] .offcanvas-md,
[data-layout-mode=dark] .offcanvas-sm,
[data-layout-mode=dark] .offcanvas-xl,
[data-layout-mode=dark] .offcanvas-xxl {
  --vz-offcanvas-bg: #212529;
}
[data-layout-mode=dark] .progress {
  --vz-progress-bg: #2a2f34;
}
[data-layout-mode=dark] .table {
  --vz-table-striped-bg: rgba(255, 255, 255, 0.03);
  --vz-table-active-bg: rgba(255, 255, 255, 0.07);
  --vz-table-hover-bg: rgba(255, 255, 255, 0.07);
}
[data-layout-mode=dark] .table-light {
  --vz-table-color: #fff;
  --vz-table-bg: rgba(255, 255, 255, 0.05);
  --vz-table-border-color: var(--vz-border-color);
  --vz-table-striped-bg: rgba(255, 255, 255, 0.07);
  --vz-table-striped-color: #fff;
}
[data-layout-mode=dark] .toast {
  --vz-toast-bg: rgba(42, 47, 52, 0.85);
  --vz-toast-header-bg: rgba(42, 47, 52, 0.85);
  --vz-toast-border-color: rgba(255, 255, 255, 0.1);
  --vz-toast-header-border-color: rgba(255, 255, 255, 0.05);
}
[data-layout-mode=dark] {
  --vz-list-group-hover-bg: rgb(38.6858108108, 43.375, 48.0641891892);
}
[data-layout-mode=dark] .popover {
  --vz-popover-bg: rgb(35.2743243243, 39.55, 43.8256756757);
}
[data-layout-mode=dark] .pagination {
  --vz-pagination-hover-bg: rgb(42.0972972973, 47.2, 52.3027027027);
  --vz-pagination-focus-bg: rgb(42.0972972973, 47.2, 52.3027027027);
}
[data-layout-mode=dark] {
  --vz-input-bg: rgb(37.5486486486, 42.1, 46.6513513514);
  --vz-input-border: #2a2f34;
  --vz-input-focus-border: rgb(51.114893617, 57.2, 63.285106383);
  --vz-input-disabled-bg: #212529;
  --vz-input-group-addon-bg: #2a2f34;
  --vz-input-check-border: rgb(51.114893617, 57.2, 63.285106383);
}

[data-sidebar=gradient] {
  --vz-vertical-menu-bg-gradient: linear-gradient(to right, var(--vz-primary), var(--vz-success));
  --vz-vertical-menu-border-gradient: var(--vz-success);
  --vz-twocolumn-menu-bg-dark: var(--vz-success);
}

[data-sidebar=gradient-2] {
  --vz-vertical-menu-bg-gradient: linear-gradient(to right, var(--vz-info), var(--vz-secondary));
  --vz-vertical-menu-border-gradient: var(--vz-secondary);
  --vz-twocolumn-menu-bg-dark: var(--vz-secondary);
}

[data-sidebar=gradient-3] {
  --vz-vertical-menu-bg-gradient: linear-gradient(to right, var(--vz-info), var(--vz-success));
  --vz-vertical-menu-border-gradient: var(--vz-success);
  --vz-twocolumn-menu-bg-dark: var(--vz-success);
}

[data-sidebar=gradient-4] {
  --vz-vertical-menu-bg-gradient: linear-gradient(to right, #1a1d21, var(--vz-primary));
  --vz-vertical-menu-border-gradient: var(--vz-primary);
  --vz-twocolumn-menu-bg-dark: var(--vz-primary);
}

#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1002;
  background-color: var(--vz-header-bg);
  transition: all 0.1s ease-out;
}
#page-topbar.topbar-shadow {
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
}
@media (min-width: 768px) {
  #page-topbar {
    left: 250px;
  }
}

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 70px;
  padding: 0 1.5rem 0 calc(1.5rem / 2);
}
@media (max-width: 767.98px) {
  .navbar-header {
    padding: 0 calc(1.5rem / 2) 0 calc(1.5rem / 2);
  }
}
.navbar-header .topbar-head-dropdown .dropdown-menu.show {
  top: 13px !important;
}
.navbar-header .btn-topbar {
  height: 42px;
  width: 42px;
}
@media (max-width: 360px) {
  .navbar-header .btn-topbar {
    height: 36px;
    width: 36px;
  }
}
.navbar-header .user-name-text {
  color: var(--vz-gray-700);
}

/* Search */
.app-search {
  padding: calc(32px / 2) 0;
}
.app-search .form-control {
  border: none;
  height: 38px;
  padding-left: 40px;
  padding-right: 30px;
  background-color: var(--vz-topbar-search-bg);
  box-shadow: none;
}
.app-search span.search-widget-icon {
  position: absolute;
  z-index: 10;
  font-size: 18px;
  line-height: 38px;
  left: 13px;
  top: 0;
  color: #878a99;
}
.app-search .search-widget-icon-close {
  right: 7px;
  left: auto !important;
}
@media (max-width: 1023.99px) {
  .app-search {
    padding-left: calc(1.5rem / 2);
  }
}

.megamenu-list li {
  position: relative;
  padding: 5px 0px;
}
.megamenu-list li a {
  color: var(--vz-body-color);
}

@media (max-width: 767.98px) {
  .logo span.logo-lg {
    display: none;
  }
  .logo span.logo-sm {
    display: inline-block;
  }
}
.header-item {
  height: 70px;
  display: flex;
  align-items: center;
}

.header-profile-user {
  height: 32px;
  width: 32px;
}

.topbar-badge-sm {
  right: 0;
  top: 7px !important;
}

.topbar-badge {
  right: -9px;
  top: 4px !important;
}

@media (min-width: 768px) {
  .topbar-user {
    background-color: var(--vz-topbar-user-bg);
  }
}
.topbar-user .dropdown-menu {
  top: 6px !important;
}

.notification-item {
  padding: 0.75rem 1rem;
  white-space: inherit;
  position: relative;
}
.notification-item .form-check-input {
  position: relative;
  z-index: 2;
}

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  border: 1px solid transparent;
  color: var(--vz-dropdown-link-color);
}
.dropdown-icon-item img {
  height: 24px;
}
.dropdown-icon-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dropdown-icon-item:hover {
  background-color: var(--vz-dropdown-link-hover-bg);
}

.fullscreen-enable [data-toggle=fullscreen] .bx-fullscreen::before {
  content: "\\eacb";
}

[data-layout-mode=dark] .light-dark-mode .bx-moon::before {
  content: "\\ec34";
}

[data-topbar=dark] #page-topbar {
  background-color: var(--vz-header-bg-dark);
  border-color: var(--vz-header-bg-dark);
}
[data-topbar=dark] .navbar-header .btn-topbar {
  color: var(--vz-header-item-color-dark);
}
[data-topbar=dark] .navbar-header .btn-topbar:hover, [data-topbar=dark] .navbar-header .btn-topbar:focus {
  background-color: rgba(255, 255, 255, 0.07);
  color: #fff;
}
@media (min-width: 767.99px) {
  [data-topbar=dark] .topbar-user {
    background-color: var(--vz-topbar-user-bg-dark);
  }
}
[data-topbar=dark] .topbar-user .user-name-text {
  color: rgba(255, 255, 255, 0.85) !important;
}
[data-topbar=dark] .topbar-user .user-name-sub-text {
  color: var(--vz-header-item-color-dark) !important;
}
[data-topbar=dark] .logo-dark {
  display: none;
}
[data-topbar=dark] .logo-light {
  display: inline-block;
}
[data-topbar=dark] .app-search .form-control {
  background-color: rgba(255, 255, 255, 0.05);
  color: #fff;
}
[data-topbar=dark] .app-search span.search-widget-icon,
[data-topbar=dark] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5);
}
[data-topbar=dark] .hamburger-icon span {
  background-color: #e9ebec;
}

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static;
  }
  .navbar-header .dropdown .dropdown-menu {
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  #search-dropdown-reponsive {
    top: 54px !important;
  }
}
@media (min-width: 1024.1px) {
  [data-layout=vertical][data-layout-style=detached] #page-topbar {
    left: 0 !important;
    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  }
  [data-layout=vertical][data-layout-style=detached] .horizontal-logo {
    display: inline-block;
    padding-left: 0;
  }
  [data-layout=vertical][data-layout-style=detached] .topnav-hamburger {
    visibility: hidden;
  }
  [data-layout=vertical][data-layout-style=detached] .layout-width {
    max-width: 95%;
    margin: 0 auto;
  }
  [data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] .navbar-brand-box, [data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm-hover] .navbar-brand-box {
    background-color: transparent !important;
    position: relative;
    width: auto;
    text-align: left;
  }
  [data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] .navbar-brand-box .logo-sm, [data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm-hover] .navbar-brand-box .logo-sm {
    display: none;
  }
  [data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] .navbar-brand-box .logo-lg, [data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm-hover] .navbar-brand-box .logo-lg {
    display: block;
  }
}
[data-layout=vertical][data-layout-style=detached][data-topbar=dark] .horizontal-logo .logo-dark {
  display: none;
}
[data-layout=vertical][data-layout-style=detached][data-topbar=dark] .horizontal-logo .logo-light {
  display: block;
}

[data-layout=horizontal] #page-topbar {
  left: 0;
  border-bottom: 1px solid var(--vz-gray-300);
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] #page-topbar.topbar-shadow {
    box-shadow: none;
  }
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .page-content {
    margin-top: 70px;
  }
}
[data-layout=horizontal] .page-content {
  padding: calc(45px + 1.5rem) calc(1.5rem / 2) 60px calc(1.5rem / 2);
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal][data-layout-width=boxed] .page-content {
    min-height: calc(100vh - 130px);
  }
}

@media (min-width: 768px) {
  [data-layout=vertical][data-sidebar-size=sm] #page-topbar, [data-layout=vertical][data-sidebar-size=sm-hover] #page-topbar {
    left: 70px;
  }
}
@media (min-width: 768px) {
  [data-layout=vertical][data-sidebar-size=md] #page-topbar {
    left: 180px;
  }
}

@media (min-width: 768px) {
  [data-layout=twocolumn] #page-topbar {
    left: calc(70px + 220px);
  }
}
[data-layout=twocolumn] .horizontal-logo {
  display: none;
}

.page-title-box {
  padding: 10px 1.5rem;
  background-color: var(--vz-card-bg-custom);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  border-bottom: 1px solid none;
  border-top: 1px solid none;
  margin: -23px -1.5rem 1.5rem -1.5rem;
}
.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}
.page-title-box h4, .page-title-box .h4 {
  font-weight: 700;
  font-size: 15px !important;
  text-transform: uppercase;
}

[data-layout=horizontal] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0;
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .page-title-box {
    margin: -19px 0 0 0;
  }
}

[data-layout=vertical][data-layout-style=detached] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0;
}
@media (min-width: 1024.1px) {
  [data-layout=vertical][data-layout-style=detached] .page-title-box {
    margin: -19px 0 0 0;
  }
}

.footer {
  bottom: 0;
  padding: 20px calc(1.5rem * 0.5);
  position: absolute;
  right: 0;
  color: var(--vz-footer-color);
  left: 250px;
  height: 60px;
  background-color: var(--vz-footer-bg);
}
@media (max-width: 991.98px) {
  .footer {
    left: 0;
  }
}

[data-layout=vertical][data-sidebar-size=sm] .footer, [data-layout=vertical][data-sidebar-size=sm-hover] .footer {
  left: 70px;
}
@media (max-width: 767.98px) {
  [data-layout=vertical][data-sidebar-size=sm] .footer, [data-layout=vertical][data-sidebar-size=sm-hover] .footer {
    left: 0;
  }
}
[data-layout=vertical][data-sidebar-size=md] .footer {
  left: 180px;
}
@media (max-width: 991.98px) {
  [data-layout=vertical][data-sidebar-size=md] .footer {
    left: 0;
  }
}

[data-layout=horizontal] .footer {
  left: 0 !important;
}

@media (min-width: 1024.1px) {
  [data-layout=vertical][data-layout-style=detached] .footer {
    left: 0 !important;
    background-color: transparent;
  }
}

@media (min-width: 768.1px) {
  [data-layout=twocolumn] .footer {
    left: calc(70px + 220px);
  }
}

.app-content {
  margin-left: 250px;
  overflow: hidden;
}
.app-content .content {
  padding: 0 15px 10px 15px;
  margin-top: 70px;
}

.main-content {
  transition: all 0.1s ease-out;
}
@media (min-width: 768px) {
  .main-content {
    margin-left: 250px;
  }
}

.page-content {
  padding: calc(70px + 1.5rem) calc(1.5rem * 0.5) 60px calc(1.5rem * 0.5);
}

.navbar-menu {
  width: 250px;
  z-index: 1002;
  background: var(--vz-vertical-menu-bg);
  border-right: 1px solid #fff;
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  padding: 0 0 calc(70px + 25px) 0;
  transition: all 0.1s ease-out;
}
.navbar-menu .navbar-nav .nav-link {
  display: flex;
  align-items: center;
  padding: 0.625rem 1.5rem;
  color: var(--vz-vertical-menu-item-color);
  font-size: 0.9375rem;
  font-family: "Open Sans", sans-serif;
}
.navbar-menu .navbar-nav .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color);
}
.navbar-menu .navbar-nav .nav-link i {
  display: inline-block;
  min-width: 1.75rem;
  font-size: 18px;
  line-height: inherit;
}
.navbar-menu .navbar-nav .nav-link svg {
  width: 18px;
  margin-right: 0.665rem;
  color: var(--vz-vertical-menu-item-color);
}
.navbar-menu .navbar-nav .nav-link .badge {
  margin-left: auto;
  margin-right: -2px;
  z-index: 1;
}
.navbar-menu .navbar-nav .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color);
}
.navbar-menu .navbar-nav .nav-link:hover .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color);
  fill: rgba(64, 81, 137, 0.16);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  display: block;
  content: "\\f0142";
  font-family: "Material Design Icons";
  margin-left: auto;
  transition: transform 0.2s;
  font-size: 1.05rem;
  position: absolute;
  right: 18px;
  color: var(--vz-vertical-menu-title-color);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color);
  fill: rgba(64, 81, 137, 0.16);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  transform: rotate(90deg);
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before {
  opacity: 1;
  background-color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-link.collapsed.active::after {
  transform: rotate(90deg);
}
.navbar-menu .navbar-nav .nav-sm {
  padding-left: 1.75rem;
}
.navbar-menu .navbar-nav .nav-sm .nav-link {
  padding: 0.55rem 1.5rem !important;
  color: var(--vz-vertical-menu-sub-item-color);
  white-space: none;
  position: relative;
  font-size: 0.813rem;
  font-family: "Open Sans", sans-serif;
}
.navbar-menu .navbar-nav .nav-sm .nav-link:before {
  content: "";
  width: 6px;
  height: 1.5px;
  background-color: var(--vz-vertical-menu-sub-item-color);
  position: absolute;
  left: 2px;
  top: 16.5px;
  transition: all 0.4s ease-in-out;
  opacity: 0.5;
}
.navbar-menu .navbar-nav .nav-sm .nav-link:hover {
  color: var(--vz-vertical-menu-sub-item-hover-color);
}
.navbar-menu .navbar-nav .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-sub-item-hover-color) !important;
  opacity: 1;
}
.navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-sm .nav-link.active:before {
  background-color: var(--vz-vertical-menu-item-active-color);
}
.navbar-menu .navbar-nav .nav-sm .nav-sm {
  padding-left: 15px;
}
.navbar-menu .navbar-nav .nav-sm .nav-sm .nav-link:before {
  height: 5px;
  width: 5px;
  left: 5px;
  border-radius: 50%;
  background-color: transparent;
  border: 1px solid;
  top: 16px;
}
.navbar-menu .btn-vertical-sm-hover {
  color: #878a99;
  display: none;
}

.navbar-brand-box {
  padding: 0 1.3rem;
  text-align: center;
  transition: all 0.1s ease-out;
}
@media (max-width: 767.98px) {
  .navbar-brand-box {
    display: none;
  }
}

.hamburger-icon {
  width: 20px;
  height: 14px;
  position: relative;
  cursor: pointer;
  display: inline-block;
}
.hamburger-icon span {
  background-color: #878a99;
  position: absolute;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  width: 100%;
  height: 2px;
  display: block;
  left: 0px;
}
.hamburger-icon span:nth-child(1) {
  top: 0;
  width: 80%;
}
.hamburger-icon span:nth-child(2) {
  top: 6px;
}
.hamburger-icon span:nth-child(3) {
  bottom: 0;
  width: 60%;
}
.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(1) {
  top: -1px;
}
.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(3) {
  bottom: -1px;
}
.hamburger-icon.open {
  transform: rotate(-90deg);
}
.hamburger-icon.open span:nth-child(1) {
  left: 1px;
  top: 5px;
  width: 20px;
  transform: rotate(90deg);
  transition-delay: 150ms;
}
.hamburger-icon.open span:nth-child(2) {
  left: 3px;
  top: 13px;
  width: 10px;
  transform: rotate(45deg);
  transition-delay: 50ms;
}
.hamburger-icon.open span:nth-child(3) {
  left: 9px;
  top: 13px;
  width: 10px;
  transform: rotate(-45deg);
  transition-delay: 100ms;
}

.logo {
  line-height: 70px;
}
.logo .logo-sm {
  display: none;
}

.logo-light {
  display: none;
}

[data-layout=vertical] .app-menu .row {
  margin: 0;
}
[data-layout=vertical] .app-menu .row > * {
  width: 100%;
  padding: 0;
}
@media (max-width: 767.98px) {
  [data-layout=vertical] .app-menu {
    margin-left: -100%;
    padding: 10px 0 20px 0;
  }
}
[data-layout=vertical] .navbar-menu .container-fluid, [data-layout=vertical] .navbar-menu .container-sm, [data-layout=vertical] .navbar-menu .container-md, [data-layout=vertical] .navbar-menu .container-lg, [data-layout=vertical] .navbar-menu .container-xl, [data-layout=vertical] .navbar-menu .container-xxl {
  padding: 0;
}
@media (max-width: 767.98px) {
  [data-layout=vertical] .navbar-brand-box {
    display: none;
  }
}
[data-layout=vertical] .horizontal-logo {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .main-content {
  margin-left: 70px;
}
@media (max-width: 767.98px) {
  [data-layout=vertical][data-sidebar-size=sm-hover] .main-content {
    margin-left: 0;
  }
}
[data-layout=vertical][data-sidebar-size=sm-hover] .logo span.logo-lg {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .logo span.logo-sm {
  display: inline-block;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .btn-vertical-sm-hover {
  display: inline-block;
}
@media (min-width: 768px) {
  [data-layout=vertical][data-sidebar-size=sm-hover] .topnav-hamburger {
    display: none;
  }
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu {
  width: 70px;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .btn-vertical-sm-hover {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .btn-vertical-sm-hover i.ri-record-circle-line:before {
  content: "\\eb7d";
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .badge {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-title {
  text-align: center;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-title span {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-title i {
  display: block;
  line-height: 36px;
  font-size: 1rem;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link span {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i {
  font-size: 22px;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i.las, [data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i.lar, [data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link i.lab {
  font-size: 24px;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link svg {
  margin-right: 0px;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link:after, [data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .nav-link:before {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu .navbar-nav .menu-dropdown {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover {
  width: 250px !important;
}
@media (min-width: 1024.99px) {
  [data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .btn-vertical-sm-hover {
    display: inline-block;
  }
  [data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .navbar-brand-box {
    text-align: left;
  }
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .navbar-nav .menu-dropdown.show {
  display: block;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i {
  font-size: 18px;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i.las, [data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i.lar, [data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link i.lab {
  font-size: 20px;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link svg {
  margin-right: 0.665rem;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link span, [data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link:after, [data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .nav-link:before {
  display: inline-block;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .logo span.logo-lg {
  display: inline-block;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .logo span.logo-sm {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .menu-title {
  text-align: left;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .menu-title span {
  display: inline-block;
}
[data-layout=vertical][data-sidebar-size=sm-hover] .navbar-menu:hover .menu-title i {
  display: none;
}
@media (min-width: 1025px) {
  [data-layout=vertical][data-sidebar-size=sm-hover] .navbar-header, [data-layout=vertical][data-sidebar-size=sm-hover-active] .navbar-header {
    padding-left: 1.5rem;
  }
}
[data-layout=vertical][data-sidebar-size=sm-hover-active] .navbar-brand-box {
  text-align: left;
}
[data-layout=vertical][data-sidebar-size=sm-hover-active] .topnav-hamburger {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm-hover-active] .btn-vertical-sm-hover {
  display: inline-block;
}
@media (min-width: 768px) {
  [data-layout=vertical][data-sidebar-size=sm] {
    min-height: 1400px;
  }
  [data-layout=vertical][data-sidebar-size=sm] .main-content {
    margin-left: 70px;
  }
}
[data-layout=vertical][data-sidebar-size=sm] #page-topbar {
  z-index: calc(1002 + 1);
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-brand-box {
  position: fixed;
  padding: 0;
  width: 70px;
  z-index: 1;
  top: 0;
  background: var(--vz-vertical-menu-bg);
}
[data-layout=vertical][data-sidebar-size=sm] .logo span.logo-lg {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm] .logo span.logo-sm {
  display: inline-block;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu {
  position: absolute;
  width: 70px !important;
  padding-top: 70px;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .simplebar-mask,
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .simplebar-content-wrapper {
  overflow: visible !important;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .simplebar-scrollbar,
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .vertical-menu-btn {
  display: none !important;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .simplebar-offset {
  bottom: 0 !important;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .badge {
  display: none !important;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-title {
  text-align: center;
  font-size: 1rem;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-title span {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-title i {
  display: block;
  line-height: 36px;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link span {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link i {
  font-size: 22px;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link svg {
  margin-right: 0px;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link:after, [data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-link:before {
  display: none;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .menu-dropdown {
  display: none;
  height: auto !important;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item {
  position: relative;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link {
  position: relative;
  width: calc(200px + 70px);
  color: #fff;
  background-color: var(--vz-vertical-menu-bg-dark);
  transition: none;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link span {
  display: inline-block;
  padding-left: 25px;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link:after {
  display: block;
  transform: rotate(90deg);
  color: #fff;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
  display: block;
  left: 70px;
  position: absolute;
  width: 200px;
  background: var(--vz-vertical-menu-bg);
  height: auto !important;
  padding: 0.5rem 0;
  border-radius: 0 0 3px 3px;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm {
  padding: 0;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
  color: var(--vz-vertical-menu-item-hover-color);
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
  color: inherit;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
  display: block !important;
  transform: rotate(0deg) !important;
}
[data-layout=vertical][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
  left: 100% !important;
  top: 0;
  border-radius: 3px !important;
}
@media (min-width: 768px) {
  [data-layout=vertical][data-sidebar-size=md] .main-content {
    margin-left: 180px;
  }
}
[data-layout=vertical][data-sidebar-size=md] .navbar-brand-box {
  width: 180px;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu {
  width: 180px !important;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link {
  display: block;
  text-align: center;
  padding: 0.55rem 0.525rem;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link i {
  display: block;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link svg {
  display: block;
  margin-left: auto;
  margin-right: auto;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link:before {
  display: none !important;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  position: relative;
  display: inline-block;
  right: 0;
  top: 3px;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu .navbar-nav .nav-link.menu-link[data-bs-toggle=collapse]:after {
  display: none;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu .navbar-nav .badge {
  display: none !important;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu .navbar-nav .nav-sm {
  padding-left: 0;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu .menu-title {
  text-align: center;
}
[data-layout=vertical][data-sidebar-size=md] .navbar-menu .menu-title span {
  text-decoration: underline;
}
[data-layout=vertical][data-sidebar=dark] .navbar-menu {
  background: var(--vz-vertical-menu-bg-dark);
  border-right: 1px solid var(--vz-vertical-menu-bg-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-menu .hamburger-icon span {
  background-color: var(--vz-vertical-menu-item-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-menu .btn-vertical-sm-hover {
  color: var(--vz-vertical-menu-item-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-link {
  color: var(--vz-vertical-menu-item-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  color: inherit;
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  color: inherit;
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
  color: var(--vz-vertical-menu-item-active-color-dark);
  fill: rgba(255, 255, 255, 0.1);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-link svg {
  color: var(--vz-vertical-menu-item-color-dark);
  fill: rgba(255, 255, 255, 0.1);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-link:hover .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav > .nav-item .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav > .nav-item .nav-link.active .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-sm .nav-link {
  color: var(--vz-vertical-menu-sub-item-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-sm .nav-link:before {
  background-color: var(--vz-vertical-menu-sub-item-color-dark) !important;
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-sm .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important;
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-sm .nav-sm .nav-link:before {
  background-color: transparent !important;
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important;
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-sm .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .navbar-nav .nav-sm .nav-sm .nav-link.active:before {
  background-color: var(--vz-vertical-menu-item-active-color-dark) !important;
}
[data-layout=vertical][data-sidebar=dark][data-sidebar-size=sm] .navbar-brand-box {
  background: var(--vz-vertical-menu-bg-dark);
}
[data-layout=vertical][data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
  background: var(--vz-vertical-menu-bg-dark);
}
[data-layout=vertical][data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm {
  padding: 0;
}
[data-layout=vertical][data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
  display: block !important;
  transform: rotate(0deg) !important;
}
[data-layout=vertical][data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-layout=vertical][data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
  color: inherit;
}
[data-layout=vertical][data-sidebar=dark][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
  left: 100% !important;
  top: 0;
  border-radius: 3px !important;
}
[data-layout=vertical][data-sidebar=dark] .menu-title {
  color: var(--vz-vertical-menu-title-color-dark);
}
[data-layout=vertical][data-sidebar=dark] .logo-dark {
  display: none;
}
[data-layout=vertical][data-sidebar=dark] .logo-light {
  display: inline-block;
}
[data-layout=vertical][data-sidebar=light] .logo-dark {
  display: inline-block;
}
[data-layout=vertical][data-sidebar=light] .logo-light {
  display: none;
}
[data-layout=vertical][data-layout-style=detached] #layout-wrapper,
[data-layout=vertical][data-layout-style=detached] .main-content {
  min-height: 100vh;
}
@media (min-width: 1024.1px) {
  [data-layout=vertical][data-layout-style=detached] .main-content {
    position: relative;
  }
  [data-layout=vertical][data-layout-style=detached] #layout-wrapper {
    max-width: 95%;
    margin: 0 auto;
    padding-left: 1.5rem;
  }
  [data-layout=vertical][data-layout-style=detached] .navbar-header {
    padding-left: 1.5rem;
  }
  [data-layout=vertical][data-layout-style=detached] .navbar-menu {
    top: calc(70px + 1.5rem);
    bottom: 1.5rem;
    padding: 0;
    border-right: var(--vz-vertical-menu-bg);
    border-radius: 5px;
    padding: 10px 0;
    z-index: 1;
  }
  [data-layout=vertical][data-layout-style=detached] .navbar-menu .navbar-brand-box {
    display: none;
  }
  [data-layout=vertical][data-layout-style=detached][data-sidebar=dark] .logo-dark, [data-layout=vertical][data-layout-style=detached][data-sidebar=gradient] .logo-dark, [data-layout=vertical][data-layout-style=detached][data-sidebar=gradient-2] .logo-dark, [data-layout=vertical][data-layout-style=detached][data-sidebar=gradient-3] .logo-dark, [data-layout=vertical][data-layout-style=detached][data-sidebar=gradient-4] .logo-dark {
    display: inline-block;
  }
  [data-layout=vertical][data-layout-style=detached][data-sidebar=dark] .logo-light, [data-layout=vertical][data-layout-style=detached][data-sidebar=gradient] .logo-light, [data-layout=vertical][data-layout-style=detached][data-sidebar=gradient-2] .logo-light, [data-layout=vertical][data-layout-style=detached][data-sidebar=gradient-3] .logo-light, [data-layout=vertical][data-layout-style=detached][data-sidebar=gradient-4] .logo-light {
    display: none;
  }
}
[data-layout=vertical][data-layout-style=detached] .footer {
  border-top: 1px dashed var(--vz-border-color);
}
[data-layout=vertical][data-layout-style=detached] .auth-page-wrapper .footer {
  border-top: none;
}
@media (min-width: 768px) {
  [data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] #layout-wrapper,
  [data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] .main-content {
    min-height: 1400px;
  }
}
[data-layout=vertical][data-sidebar=gradient] .logo-dark, [data-layout=vertical][data-sidebar=gradient-2] .logo-dark, [data-layout=vertical][data-sidebar=gradient-3] .logo-dark, [data-layout=vertical][data-sidebar=gradient-4] .logo-dark {
  display: none;
}
[data-layout=vertical][data-sidebar=gradient] .logo-light, [data-layout=vertical][data-sidebar=gradient-2] .logo-light, [data-layout=vertical][data-sidebar=gradient-3] .logo-light, [data-layout=vertical][data-sidebar=gradient-4] .logo-light {
  display: inline-block;
}

.menu-title {
  letter-spacing: 0.05em;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--vz-vertical-menu-title-color);
  font-weight: 600;
}
.menu-title span {
  padding: 12px 20px;
  display: inline-block;
}
.menu-title i {
  display: none;
}

.vertical-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 37, 41, 0.35);
  z-index: 1003;
  display: none;
}

.vertical-sidebar-enable .vertical-overlay {
  display: block;
}
.vertical-sidebar-enable .app-menu {
  margin-left: 0 !important;
  z-index: 1004;
}

[dir=rtl] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(180deg);
}
[dir=rtl] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  transform: rotate(270deg);
}

[data-sidebar=gradient] .navbar-menu, [data-sidebar=gradient-2] .navbar-menu, [data-sidebar=gradient-3] .navbar-menu, [data-sidebar=gradient-4] .navbar-menu {
  background: var(--vz-vertical-menu-bg-gradient);
  border-right: 1px solid var(--vz-vertical-menu-border-gradient);
}
[data-sidebar=gradient] .navbar-menu .hamburger-icon span, [data-sidebar=gradient-2] .navbar-menu .hamburger-icon span, [data-sidebar=gradient-3] .navbar-menu .hamburger-icon span, [data-sidebar=gradient-4] .navbar-menu .hamburger-icon span {
  background-color: rgba(255, 255, 255, 0.5);
}
[data-sidebar=gradient] .navbar-menu .btn-vertical-sm-hover, [data-sidebar=gradient-2] .navbar-menu .btn-vertical-sm-hover, [data-sidebar=gradient-3] .navbar-menu .btn-vertical-sm-hover, [data-sidebar=gradient-4] .navbar-menu .btn-vertical-sm-hover {
  color: rgba(255, 255, 255, 0.5);
}
[data-sidebar=gradient] .navbar-nav .nav-link, [data-sidebar=gradient-2] .navbar-nav .nav-link, [data-sidebar=gradient-3] .navbar-nav .nav-link, [data-sidebar=gradient-4] .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
[data-sidebar=gradient] .navbar-nav .nav-link.active, [data-sidebar=gradient-2] .navbar-nav .nav-link.active, [data-sidebar=gradient-3] .navbar-nav .nav-link.active, [data-sidebar=gradient-4] .navbar-nav .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-sidebar=gradient] .navbar-nav .nav-link[data-bs-toggle=collapse]:after, [data-sidebar=gradient-2] .navbar-nav .nav-link[data-bs-toggle=collapse]:after, [data-sidebar=gradient-3] .navbar-nav .nav-link[data-bs-toggle=collapse]:after, [data-sidebar=gradient-4] .navbar-nav .nav-link[data-bs-toggle=collapse]:after {
  color: inherit;
}
[data-sidebar=gradient] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true], [data-sidebar=gradient-2] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true], [data-sidebar=gradient-3] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true], [data-sidebar=gradient-4] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-sidebar=gradient] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after, [data-sidebar=gradient-2] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after, [data-sidebar=gradient-3] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after, [data-sidebar=gradient-4] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  color: inherit;
}
[data-sidebar=gradient] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual, [data-sidebar=gradient-2] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual, [data-sidebar=gradient-3] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual, [data-sidebar=gradient-4] .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
  color: var(--vz-vertical-menu-item-active-color-dark);
  fill: rgba(255, 255, 255, 0.1);
}
[data-sidebar=gradient] .navbar-nav .nav-link svg, [data-sidebar=gradient-2] .navbar-nav .nav-link svg, [data-sidebar=gradient-3] .navbar-nav .nav-link svg, [data-sidebar=gradient-4] .navbar-nav .nav-link svg {
  color: rgba(255, 255, 255, 0.5);
  fill: rgba(255, 255, 255, 0.1);
}
[data-sidebar=gradient] .navbar-nav .nav-link:hover, [data-sidebar=gradient-2] .navbar-nav .nav-link:hover, [data-sidebar=gradient-3] .navbar-nav .nav-link:hover, [data-sidebar=gradient-4] .navbar-nav .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color-dark);
}
[data-sidebar=gradient] .navbar-nav .nav-link:hover .icon-dual, [data-sidebar=gradient-2] .navbar-nav .nav-link:hover .icon-dual, [data-sidebar=gradient-3] .navbar-nav .nav-link:hover .icon-dual, [data-sidebar=gradient-4] .navbar-nav .nav-link:hover .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}
[data-sidebar=gradient] .navbar-nav > .nav-item .nav-link.active, [data-sidebar=gradient-2] .navbar-nav > .nav-item .nav-link.active, [data-sidebar=gradient-3] .navbar-nav > .nav-item .nav-link.active, [data-sidebar=gradient-4] .navbar-nav > .nav-item .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-sidebar=gradient] .navbar-nav > .nav-item .nav-link.active .icon-dual, [data-sidebar=gradient-2] .navbar-nav > .nav-item .nav-link.active .icon-dual, [data-sidebar=gradient-3] .navbar-nav > .nav-item .nav-link.active .icon-dual, [data-sidebar=gradient-4] .navbar-nav > .nav-item .nav-link.active .icon-dual {
  color: var(--vz-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}
[data-sidebar=gradient] .navbar-nav .nav-sm .nav-link, [data-sidebar=gradient-2] .navbar-nav .nav-sm .nav-link, [data-sidebar=gradient-3] .navbar-nav .nav-sm .nav-link, [data-sidebar=gradient-4] .navbar-nav .nav-sm .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
[data-sidebar=gradient] .navbar-nav .nav-sm .nav-link:before, [data-sidebar=gradient-2] .navbar-nav .nav-sm .nav-link:before, [data-sidebar=gradient-3] .navbar-nav .nav-sm .nav-link:before, [data-sidebar=gradient-4] .navbar-nav .nav-sm .nav-link:before {
  background-color: rgba(255, 255, 255, 0.5) !important;
}
[data-sidebar=gradient] .navbar-nav .nav-sm .nav-link:hover, [data-sidebar=gradient-2] .navbar-nav .nav-sm .nav-link:hover, [data-sidebar=gradient-3] .navbar-nav .nav-sm .nav-link:hover, [data-sidebar=gradient-4] .navbar-nav .nav-sm .nav-link:hover {
  color: var(--vz-vertical-menu-item-hover-color-dark);
}
[data-sidebar=gradient] .navbar-nav .nav-sm .nav-link:hover:before, [data-sidebar=gradient-2] .navbar-nav .nav-sm .nav-link:hover:before, [data-sidebar=gradient-3] .navbar-nav .nav-sm .nav-link:hover:before, [data-sidebar=gradient-4] .navbar-nav .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important;
}
[data-sidebar=gradient] .navbar-nav .nav-sm .nav-link.active, [data-sidebar=gradient-2] .navbar-nav .nav-sm .nav-link.active, [data-sidebar=gradient-3] .navbar-nav .nav-sm .nav-link.active, [data-sidebar=gradient-4] .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-sidebar=gradient] .navbar-nav .nav-sm .nav-sm .nav-link:before, [data-sidebar=gradient-2] .navbar-nav .nav-sm .nav-sm .nav-link:before, [data-sidebar=gradient-3] .navbar-nav .nav-sm .nav-sm .nav-link:before, [data-sidebar=gradient-4] .navbar-nav .nav-sm .nav-sm .nav-link:before {
  background-color: transparent !important;
}
[data-sidebar=gradient] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before, [data-sidebar=gradient-2] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before, [data-sidebar=gradient-3] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before, [data-sidebar=gradient-4] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important;
}
[data-sidebar=gradient] .navbar-nav .nav-sm .nav-sm .nav-link.active, [data-sidebar=gradient-2] .navbar-nav .nav-sm .nav-sm .nav-link.active, [data-sidebar=gradient-3] .navbar-nav .nav-sm .nav-sm .nav-link.active, [data-sidebar=gradient-4] .navbar-nav .nav-sm .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-sidebar=gradient] .navbar-nav .nav-sm .nav-sm .nav-link.active:before, [data-sidebar=gradient-2] .navbar-nav .nav-sm .nav-sm .nav-link.active:before, [data-sidebar=gradient-3] .navbar-nav .nav-sm .nav-sm .nav-link.active:before, [data-sidebar=gradient-4] .navbar-nav .nav-sm .nav-sm .nav-link.active:before {
  background-color: var(--vz-vertical-menu-item-active-color-dark) !important;
}
[data-sidebar=gradient][data-sidebar-size=sm] .navbar-brand-box, [data-sidebar=gradient-2][data-sidebar-size=sm] .navbar-brand-box, [data-sidebar=gradient-3][data-sidebar-size=sm] .navbar-brand-box, [data-sidebar=gradient-4][data-sidebar-size=sm] .navbar-brand-box {
  background: var(--vz-vertical-menu-bg-gradient);
}
[data-sidebar=gradient][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown, [data-sidebar=gradient-2][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown, [data-sidebar=gradient-3][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown, [data-sidebar=gradient-4][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
  background: var(--vz-vertical-menu-bg-dark);
}
[data-sidebar=gradient][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm, [data-sidebar=gradient-2][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm, [data-sidebar=gradient-3][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm, [data-sidebar=gradient-4][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm {
  padding: 0;
}
[data-sidebar=gradient][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-link:after, [data-sidebar=gradient-2][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-link:after, [data-sidebar=gradient-3][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-link:after, [data-sidebar=gradient-4][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
  display: block !important;
  transform: rotate(0deg) !important;
}
[data-sidebar=gradient][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link, [data-sidebar=gradient-2][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link, [data-sidebar=gradient-3][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link, [data-sidebar=gradient-4][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
  color: var(--vz-vertical-menu-item-active-color-dark);
}
[data-sidebar=gradient][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after, [data-sidebar=gradient-2][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after, [data-sidebar=gradient-3][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after, [data-sidebar=gradient-4][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
  color: inherit;
}
[data-sidebar=gradient][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .menu-dropdown, [data-sidebar=gradient-2][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .menu-dropdown, [data-sidebar=gradient-3][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .menu-dropdown, [data-sidebar=gradient-4][data-sidebar-size=sm] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
  left: 100% !important;
  top: 0;
  border-radius: 3px !important;
}
[data-sidebar=gradient][data-sidebar-size=sm][data-layout=vertical] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link, [data-sidebar=gradient-2][data-sidebar-size=sm][data-layout=vertical] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link, [data-sidebar=gradient-3][data-sidebar-size=sm][data-layout=vertical] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link, [data-sidebar=gradient-4][data-sidebar-size=sm][data-layout=vertical] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link {
  background: var(--vz-vertical-menu-bg-gradient);
}
[data-sidebar=gradient] .menu-title, [data-sidebar=gradient-2] .menu-title, [data-sidebar=gradient-3] .menu-title, [data-sidebar=gradient-4] .menu-title {
  color: rgba(255, 255, 255, 0.5);
}

.bg-vertical-gradient {
  background: linear-gradient(to right, var(--vz-primary), var(--vz-success));
}

.bg-vertical-gradient-2 {
  background: linear-gradient(to right, var(--vz-info), var(--vz-secondary));
}

.bg-vertical-gradient-3 {
  background: linear-gradient(to right, var(--vz-info), var(--vz-success));
}

.bg-vertical-gradient-4 {
  background: linear-gradient(to right, var(--vz-dark), var(--vz-primary));
}

.sidebar-background {
  position: absolute;
  z-index: -1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: 50%;
  opacity: 0.07;
}

[data-sidebar-image=img-1] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___});
}

[data-sidebar-image=img-2] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
}

[data-sidebar-image=img-3] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
}

[data-sidebar-image=img-4] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___});
}

[data-layout=horizontal] .main-content {
  margin-left: 0;
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .layout-width,
  [data-layout=horizontal] .container-fluid,
  [data-layout=horizontal] .container-sm,
  [data-layout=horizontal] .container-md,
  [data-layout=horizontal] .container-lg,
  [data-layout=horizontal] .container-xl,
  [data-layout=horizontal] .container-xxl {
    max-width: 90%;
    margin: 0 auto;
  }
  [data-layout=horizontal] .topnav-hamburger {
    visibility: hidden;
  }
}
[data-layout=horizontal] .horizontal-logo {
  padding-left: calc(1.5rem / 2);
}
@media (max-width: 1024.98px) {
  [data-layout=horizontal] .horizontal-logo {
    padding-left: 1.5rem;
  }
}
[data-layout=horizontal] .navbar-menu {
  background: var(--vz-topnav-bg);
  border-right-color: transparent;
  padding: 0 calc(1.5rem / 2);
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  margin-top: 70px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  bottom: auto;
}
@media (max-width: 575.98px) {
  [data-layout=horizontal] .navbar-menu .container-fluid, [data-layout=horizontal] .navbar-menu .container-sm, [data-layout=horizontal] .navbar-menu .container-md, [data-layout=horizontal] .navbar-menu .container-lg, [data-layout=horizontal] .navbar-menu .container-xl, [data-layout=horizontal] .navbar-menu .container-xxl {
    padding: 0;
  }
}
[data-layout=horizontal] .navbar-menu .navbar-nav {
  flex-direction: row;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm {
  padding-left: 0;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm .nav-link:before {
  opacity: 0 !important;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout=horizontal] .navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link {
  color: var(--vz-topnav-item-color);
  padding: 0.75rem 1.5rem;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link i {
  line-height: 1;
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link.active {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link.active:after {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link.active .icon-dual {
  color: var(--vz-topnav-item-color-active);
  fill: rgba(64, 81, 137, 0.1);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
  color: var(--vz-topnav-item-color-active);
  fill: rgba(64, 81, 137, 0.1);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-menu .navbar-nav .nav-link:hover .icon-dual {
  color: var(--vz-topnav-item-color-active);
  fill: rgba(64, 81, 137, 0.1);
}
[data-layout=horizontal] .navbar-menu .navbar-nav > .nav-item > .nav-link[data-bs-toggle=collapse]:after {
  right: 0px;
  transform: rotate(90deg) !important;
}
[data-layout=horizontal] .navbar-menu .navbar-nav > li:nth-of-type(2) > .nav-link.menu-link {
  padding-left: 0;
}
[data-layout=horizontal] .navbar-menu .navbar-brand-box {
  display: none;
}
[data-layout=horizontal] .navbar-nav .nav-item {
  position: relative;
}
[data-layout=horizontal] .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after {
  right: 10px;
  transform: rotate(0deg) !important;
}
[data-layout=horizontal] .navbar-nav .nav-item > .nav-link > .badge {
  display: none;
}
[data-layout=horizontal] .navbar-nav .nav-item:hover > .nav-link {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .navbar-nav .nav-item:hover > .nav-link .icon-dual {
  color: var(--vz-topnav-item-color-active);
  fill: rgba(64, 81, 137, 0.1);
}
[data-layout=horizontal] .navbar-nav .nav-item:hover > .nav-link:after {
  color: var(--vz-topnav-item-color-active);
}
@media (min-width: 1024.1px) {
  [data-layout=horizontal] .navbar-nav .nav-item:hover > .menu-dropdown {
    display: block;
    height: auto !important;
  }
}
[data-layout=horizontal] .navbar-nav .nav-item.active {
  color: var(--vz-topnav-item-color-active);
}
[data-layout=horizontal] .menu-dropdown {
  position: absolute;
  min-width: 12rem;
  padding: 0.5rem 0;
  box-shadow: 0 0px 5px rgba(15, 34, 58, 0.15);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  z-index: 1000;
  background-color: var(--vz-choices-bg);
  background-clip: padding-box;
  border: 0 solid var(--vz-border-color);
  border-radius: 0.3rem;
  display: none;
}
[data-layout=horizontal] .menu-dropdown .menu-dropdown {
  top: 0;
  left: 100%;
}
[data-layout=horizontal] .mega-dropdown-menu {
  width: 40rem;
}
[data-layout=horizontal] .menu-title {
  display: none;
}
[data-layout=horizontal] .dropdown-custom-right {
  left: -100% !important;
  right: 100%;
}
@media (max-width: 1024px) {
  [data-layout=horizontal] .navbar-menu {
    display: none;
  }
}

@media (max-width: 1024px) {
  [data-layout=horizontal] .menu .navbar-menu {
    display: block;
    max-height: 360px;
    overflow-y: auto;
    padding-left: 0;
  }
  [data-layout=horizontal] .menu .navbar-menu .navbar-nav {
    flex-direction: column;
  }
  [data-layout=horizontal] .menu .navbar-menu .navbar-nav > li:nth-of-type(2) > .nav-link.menu-link {
    padding-left: 1.5rem;
  }
  [data-layout=horizontal] .menu .navbar-menu .navbar-nav .nav-sm .nav-link:before {
    opacity: 1 !important;
  }
  [data-layout=horizontal] .menu .menu-dropdown {
    position: relative;
    min-width: 100%;
    box-shadow: none;
    padding-left: 28px;
    left: 0;
    animation: none;
    padding-top: 0;
  }
  [data-layout=horizontal] .menu .menu-dropdown.show {
    display: block;
  }
  [data-layout=horizontal] .menu .dropdown-custom-right {
    left: 0 !important;
  }
  [data-layout=horizontal] .menu .nav-item .nav-link[data-bs-toggle=collapse]:after {
    right: 0px;
  }
  [data-layout=horizontal] .menu .mega-dropdown-menu {
    width: 100%;
  }
}

[data-layout-mode=dark][data-topbar=light] .navbar-header .horizontal-logo .logo-dark {
  display: none;
}
[data-layout-mode=dark][data-topbar=light] .navbar-header .horizontal-logo .logo-light {
  display: block;
}

[dir=rtl][data-layout=horizontal] .navbar-menu .navbar-nav > .nav-item > .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(-90deg) !important;
}
[dir=rtl][data-layout=horizontal] .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(-180deg) !important;
}

[data-layout=twocolumn] .app-menu {
  padding-bottom: 0;
  width: 220px;
  left: 70px;
}
[data-layout=twocolumn] .app-menu .menu-link {
  letter-spacing: 0.05em;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--vz-vertical-menu-title-color) !important;
  font-weight: 600;
}
[data-layout=twocolumn] .app-menu .menu-link:after {
  display: none !important;
}
[data-layout=twocolumn] .app-menu .menu-link i {
  display: none;
}
[data-layout=twocolumn] .app-menu .navbar-nav {
  height: calc(100vh - 70px);
}
@media (max-width: 767.98px) {
  [data-layout=twocolumn] .app-menu .navbar-nav {
    padding-top: 16px;
  }
}
[data-layout=twocolumn] .app-menu .navbar-nav > li:not(.twocolumn-item-show) {
  display: none;
}
[data-layout=twocolumn] .app-menu .navbar-nav .twocolumn-item-show > div {
  display: block !important;
  height: auto !important;
}
[data-layout=twocolumn] .app-menu .navbar-nav > .nav-item > .menu-dropdown {
  display: block !important;
  height: auto !important;
}
[data-layout=twocolumn] .app-menu .navbar-nav .nav-item .menu-dropdown .row {
  margin: 0;
}
[data-layout=twocolumn] .app-menu .navbar-nav .nav-item .menu-dropdown .row .col-lg-4 {
  width: 100%;
  padding: 0;
}
[data-layout=twocolumn] .app-menu .navbar-nav .nav-sm .nav-link {
  color: var(--vz-vertical-menu-item-color);
}
[data-layout=twocolumn] .app-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color);
}
[data-layout=twocolumn] .app-menu .container-fluid, [data-layout=twocolumn] .app-menu .container-sm, [data-layout=twocolumn] .app-menu .container-md, [data-layout=twocolumn] .app-menu .container-lg, [data-layout=twocolumn] .app-menu .container-xl, [data-layout=twocolumn] .app-menu .container-xxl {
  padding: 0;
}
[data-layout=twocolumn] .main-content {
  margin-left: calc(220px + 70px);
}
@media (max-width: 767.98px) {
  [data-layout=twocolumn] .main-content {
    margin-left: 70px;
  }
}
[data-layout=twocolumn] .twocolumn-iconview {
  width: 70px;
  background-color: var(--vz-twocolumn-menu-iconview-bg);
  height: 100%;
  left: -70px;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  top: 0;
  position: absolute;
  padding: 0;
  text-align: center;
}
[data-layout=twocolumn] .twocolumn-iconview li {
  position: relative;
  list-style: none;
}
[data-layout=twocolumn] .twocolumn-iconview li .nav-icon::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon {
  width: 42px;
  height: 42px;
  line-height: 42px;
  color: var(--vz-vertical-menu-item-color);
  z-index: 1;
  font-size: 22px;
  text-align: center;
  border-radius: 3px;
  margin: 5px 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon .icon-dual {
  width: 18px;
  color: var(--vz-vertical-menu-item-color);
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon.active {
  background-color: rgba(64, 81, 137, 0.15);
  color: #405189;
}
[data-layout=twocolumn] .twocolumn-iconview .nav-icon.active .icon-dual {
  color: #405189;
  fill: rgba(64, 81, 137, 0.1);
}
[data-layout=twocolumn] .menu-title {
  display: none;
}
@media (max-width: 991.98px) {
  [data-layout=twocolumn] .logo span.logo-lg {
    display: block;
  }
  [data-layout=twocolumn] .logo span.logo-sm {
    display: none;
  }
}
[data-layout=twocolumn][data-sidebar=light] .app-menu .navbar-brand-box .logo-light {
  display: none;
}
[data-layout=twocolumn][data-sidebar=light] .app-menu .navbar-brand-box .logo-dark {
  display: block;
}
[data-layout=twocolumn][data-sidebar=dark] .twocolumn-iconview {
  background-color: var(--vz-twocolumn-menu-iconview-bg-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .twocolumn-iconview .nav-icon {
  color: var(--vz-twocolumn-menu-item-color-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .twocolumn-iconview .nav-icon.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
  background-color: var(--vz-twocolumn-menu-item-active-bg-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .app-menu {
  background-color: var(--vz-twocolumn-menu-bg-dark);
  border-right-color: var(--vz-twocolumn-menu-bg-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .app-menu .navbar-brand-box .logo-light {
  display: block;
}
[data-layout=twocolumn][data-sidebar=dark] .app-menu .navbar-brand-box .logo-dark {
  display: none;
}
[data-layout=twocolumn][data-sidebar=dark] .app-menu .navbar-nav .nav-sm .nav-link {
  color: var(--vz-twocolumn-menu-item-color-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-sm .nav-link:hover::before, [data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-sm .nav-link.active::before {
  background-color: var(--vz-twocolumn-menu-item-active-color-dark) !important;
}
[data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before {
  background-color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn][data-sidebar=dark] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]::after {
  color: var(--vz-twocolumn-menu-item-active-color-dark) !important;
}
[data-layout=twocolumn][data-sidebar=gradient] .twocolumn-iconview, [data-layout=twocolumn][data-sidebar=gradient-2] .twocolumn-iconview, [data-layout=twocolumn][data-sidebar=gradient-3] .twocolumn-iconview, [data-layout=twocolumn][data-sidebar=gradient-4] .twocolumn-iconview {
  background-color: var(--vz-twocolumn-menu-iconview-bg-dark);
}
[data-layout=twocolumn][data-sidebar=gradient] .twocolumn-iconview .nav-icon, [data-layout=twocolumn][data-sidebar=gradient-2] .twocolumn-iconview .nav-icon, [data-layout=twocolumn][data-sidebar=gradient-3] .twocolumn-iconview .nav-icon, [data-layout=twocolumn][data-sidebar=gradient-4] .twocolumn-iconview .nav-icon {
  color: rgba(255, 255, 255, 0.6);
}
[data-layout=twocolumn][data-sidebar=gradient] .twocolumn-iconview .nav-icon.active, [data-layout=twocolumn][data-sidebar=gradient-2] .twocolumn-iconview .nav-icon.active, [data-layout=twocolumn][data-sidebar=gradient-3] .twocolumn-iconview .nav-icon.active, [data-layout=twocolumn][data-sidebar=gradient-4] .twocolumn-iconview .nav-icon.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
  background-color: var(--vz-twocolumn-menu-item-active-bg-dark);
}
[data-layout=twocolumn][data-sidebar=gradient] .app-menu, [data-layout=twocolumn][data-sidebar=gradient-2] .app-menu, [data-layout=twocolumn][data-sidebar=gradient-3] .app-menu, [data-layout=twocolumn][data-sidebar=gradient-4] .app-menu {
  background-color: var(--vz-twocolumn-menu-bg-dark);
  border-right-color: var(--vz-twocolumn-menu-bg-dark);
}
[data-layout=twocolumn][data-sidebar=gradient] .app-menu .navbar-brand-box .logo-light, [data-layout=twocolumn][data-sidebar=gradient-2] .app-menu .navbar-brand-box .logo-light, [data-layout=twocolumn][data-sidebar=gradient-3] .app-menu .navbar-brand-box .logo-light, [data-layout=twocolumn][data-sidebar=gradient-4] .app-menu .navbar-brand-box .logo-light {
  display: block;
}
[data-layout=twocolumn][data-sidebar=gradient] .app-menu .navbar-brand-box .logo-dark, [data-layout=twocolumn][data-sidebar=gradient-2] .app-menu .navbar-brand-box .logo-dark, [data-layout=twocolumn][data-sidebar=gradient-3] .app-menu .navbar-brand-box .logo-dark, [data-layout=twocolumn][data-sidebar=gradient-4] .app-menu .navbar-brand-box .logo-dark {
  display: none;
}
[data-layout=twocolumn][data-sidebar=gradient] .app-menu .navbar-nav .nav-sm .nav-link, [data-layout=twocolumn][data-sidebar=gradient-2] .app-menu .navbar-nav .nav-sm .nav-link, [data-layout=twocolumn][data-sidebar=gradient-3] .app-menu .navbar-nav .nav-sm .nav-link, [data-layout=twocolumn][data-sidebar=gradient-4] .app-menu .navbar-nav .nav-sm .nav-link {
  color: rgba(255, 255, 255, 0.6);
}
[data-layout=twocolumn][data-sidebar=gradient] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout=twocolumn][data-sidebar=gradient] .navbar-menu .navbar-nav .nav-sm .nav-link.active, [data-layout=twocolumn][data-sidebar=gradient-2] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout=twocolumn][data-sidebar=gradient-2] .navbar-menu .navbar-nav .nav-sm .nav-link.active, [data-layout=twocolumn][data-sidebar=gradient-3] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout=twocolumn][data-sidebar=gradient-3] .navbar-menu .navbar-nav .nav-sm .nav-link.active, [data-layout=twocolumn][data-sidebar=gradient-4] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout=twocolumn][data-sidebar=gradient-4] .navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn][data-sidebar=gradient] .navbar-menu .navbar-nav .nav-sm .nav-link:hover::before, [data-layout=twocolumn][data-sidebar=gradient] .navbar-menu .navbar-nav .nav-sm .nav-link.active::before, [data-layout=twocolumn][data-sidebar=gradient-2] .navbar-menu .navbar-nav .nav-sm .nav-link:hover::before, [data-layout=twocolumn][data-sidebar=gradient-2] .navbar-menu .navbar-nav .nav-sm .nav-link.active::before, [data-layout=twocolumn][data-sidebar=gradient-3] .navbar-menu .navbar-nav .nav-sm .nav-link:hover::before, [data-layout=twocolumn][data-sidebar=gradient-3] .navbar-menu .navbar-nav .nav-sm .nav-link.active::before, [data-layout=twocolumn][data-sidebar=gradient-4] .navbar-menu .navbar-nav .nav-sm .nav-link:hover::before, [data-layout=twocolumn][data-sidebar=gradient-4] .navbar-menu .navbar-nav .nav-sm .nav-link.active::before {
  background-color: var(--vz-twocolumn-menu-item-active-color-dark) !important;
}
[data-layout=twocolumn][data-sidebar=gradient] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true], [data-layout=twocolumn][data-sidebar=gradient-2] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true], [data-layout=twocolumn][data-sidebar=gradient-3] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true], [data-layout=twocolumn][data-sidebar=gradient-4] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn][data-sidebar=gradient] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before, [data-layout=twocolumn][data-sidebar=gradient-2] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before, [data-layout=twocolumn][data-sidebar=gradient-3] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before, [data-layout=twocolumn][data-sidebar=gradient-4] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before {
  background-color: var(--vz-twocolumn-menu-item-active-color-dark);
}
[data-layout=twocolumn][data-sidebar=gradient] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]::after, [data-layout=twocolumn][data-sidebar=gradient-2] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]::after, [data-layout=twocolumn][data-sidebar=gradient-3] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]::after, [data-layout=twocolumn][data-sidebar=gradient-4] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]::after {
  color: var(--vz-twocolumn-menu-item-active-color-dark) !important;
}
[data-layout=twocolumn][data-sidebar=gradient][data-layout-mode=dark] .app-menu, [data-layout=twocolumn][data-sidebar=gradient-2][data-layout-mode=dark] .app-menu, [data-layout=twocolumn][data-sidebar=gradient-3][data-layout-mode=dark] .app-menu, [data-layout=twocolumn][data-sidebar=gradient-4][data-layout-mode=dark] .app-menu {
  border-right-color: #495057;
}
[data-layout=twocolumn] .twocolumn-panel .app-menu {
  width: 0;
  border-right: 0;
}
@media (max-width: 575.98px) {
  [data-layout=twocolumn] .twocolumn-panel .app-menu {
    display: none;
  }
}
[data-layout=twocolumn] .twocolumn-panel .navbar-brand-box,
[data-layout=twocolumn] .twocolumn-panel .navbar-nav {
  display: none;
}
[data-layout=twocolumn] .twocolumn-panel .main-content {
  margin-left: 70px;
}
[data-layout=twocolumn] .twocolumn-panel #page-topbar,
[data-layout=twocolumn] .twocolumn-panel .footer {
  left: 70px;
}
@media (max-width: 575.98px) {
  [data-layout=twocolumn] .twocolumn-panel .main-content {
    margin-left: 0;
  }
  [data-layout=twocolumn] .twocolumn-panel #page-topbar,
  [data-layout=twocolumn] .twocolumn-panel .footer {
    left: 0;
  }
}
@media (max-width: 767.98px) {
  [data-layout=twocolumn] #page-topbar,
  [data-layout=twocolumn] .footer {
    left: 70px;
  }
}
@media (max-width: 575.98px) {
  [data-layout=twocolumn] .main-content {
    margin-left: 0;
  }
  [data-layout=twocolumn] #page-topbar,
  [data-layout=twocolumn] .footer {
    left: 0;
  }
}

[data-layout-width=boxed] body {
  background-color: var(--vz-boxed-body-bg);
}
[data-layout-width=boxed] #layout-wrapper {
  max-width: 1300px;
  margin: 0 auto;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  background-color: var(--vz-body-bg);
}
[data-layout-width=boxed][data-layout=vertical] #layout-wrapper {
  min-height: 100vh;
}
[data-layout-width=boxed] #page-topbar,
[data-layout-width=boxed] .footer {
  max-width: 1300px;
  margin: 0 auto;
  left: 0 !important;
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover][data-layout=vertical] #layout-wrapper, [data-layout-width=boxed][data-sidebar-size=sm][data-layout=vertical] #layout-wrapper {
    min-height: 1400px;
  }
}
@media (max-width: 767.98px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover][data-layout=vertical] .main-content, [data-layout-width=boxed][data-sidebar-size=sm][data-layout=vertical] .main-content {
    margin-left: 0;
  }
}
[data-layout-width=boxed][data-sidebar-size=sm-hover] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm-hover] .footer, [data-layout-width=boxed][data-sidebar-size=sm] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm] .footer {
  left: 0 !important;
  max-width: calc(1300px - 70px);
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover] #page-topbar,
  [data-layout-width=boxed][data-sidebar-size=sm-hover] .footer, [data-layout-width=boxed][data-sidebar-size=sm] #page-topbar,
  [data-layout-width=boxed][data-sidebar-size=sm] .footer {
    left: 70px !important;
  }
}
[data-layout-width=boxed][data-sidebar-size=sm-hover-active] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=sm-hover-active] .footer, [data-layout-width=boxed][data-sidebar-size=lg] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=lg] .footer {
  max-width: calc(1300px - 250px);
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=sm-hover-active] #page-topbar,
  [data-layout-width=boxed][data-sidebar-size=sm-hover-active] .footer, [data-layout-width=boxed][data-sidebar-size=lg] #page-topbar,
  [data-layout-width=boxed][data-sidebar-size=lg] .footer {
    left: 250px !important;
  }
}
[data-layout-width=boxed][data-sidebar-size=md] #page-topbar,
[data-layout-width=boxed][data-sidebar-size=md] .footer {
  max-width: calc(1300px - 180px);
}
@media (min-width: 768px) {
  [data-layout-width=boxed][data-sidebar-size=md] #page-topbar,
  [data-layout-width=boxed][data-sidebar-size=md] .footer {
    left: 180px !important;
  }
}
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached] body {
  background-color: var(--vz-body-bg);
}
@media (min-width: 1024.1px) {
  [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached] #layout-wrapper {
    max-width: 1300px;
    box-shadow: none;
  }
  [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached] .layout-width {
    max-width: 1300px;
  }
}
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm-hover] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm-hover] .footer, [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=sm] .footer, [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=md] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=md] .footer, [data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=lg] #page-topbar,
[data-layout-width=boxed][data-layout=vertical][data-layout-style=detached][data-sidebar-size=lg] .footer {
  max-width: 100%;
  left: 0 !important;
}

[data-layout=horizontal][data-layout-width=boxed] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed] #layout-wrapper,
[data-layout=horizontal][data-layout-width=boxed] .footer {
  max-width: 100%;
}
[data-layout=horizontal][data-layout-width=boxed] .container-fluid, [data-layout=horizontal][data-layout-width=boxed] .container-sm, [data-layout=horizontal][data-layout-width=boxed] .container-md, [data-layout=horizontal][data-layout-width=boxed] .container-lg, [data-layout=horizontal][data-layout-width=boxed] .container-xl, [data-layout=horizontal][data-layout-width=boxed] .container-xxl,
[data-layout=horizontal][data-layout-width=boxed] .navbar-header {
  max-width: 1300px;
}
[data-layout=horizontal][data-layout-width=boxed] .navbar-header {
  padding: 0 calc(1.5rem / 2) 0 0;
}
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover] .footer, [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm] [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover-active] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm] [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=sm-hover-active] .footer, [data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=lg] #page-topbar,
[data-layout=horizontal][data-layout-width=boxed][data-sidebar-size=lg] .footer {
  left: 0 !important;
}

@media (min-width: 992px) {
  [data-layout-position=scrollable] #page-topbar,
  [data-layout-position=scrollable] .navbar-menu {
    position: absolute;
  }
}
@media (min-width: 992px) {
  [data-layout-position=scrollable][data-layout=horizontal] #page-topbar,
  [data-layout-position=scrollable][data-layout=horizontal] .topnav {
    position: absolute;
  }
}

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none;
}

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
}

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2);
}

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}

.waves-notransition {
  transition: none !important;
}

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);
}

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1;
}

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em;
}

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em;
}

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom;
}

.waves-input-wrapper.waves-button {
  padding: 0;
}

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%;
}

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms;
}

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);
}

.waves-block {
  display: block;
}

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4);
}

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(64, 81, 137, 0.4);
}

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(10, 179, 156, 0.4);
}

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(41, 156, 219, 0.4);
}

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(247, 184, 75, 0.4);
}

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(240, 101, 72, 0.4);
}

.avatar-xxs {
  height: 1.5rem;
  width: 1.5rem;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-lg {
  height: 6rem;
  width: 6rem;
}

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  background-color: #405189;
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.avatar-group {
  padding-left: 12px;
  display: flex;
  flex-wrap: wrap;
}
.avatar-group .avatar-group-item {
  margin-left: -12px;
  border: 2px solid var(--vz-card-bg-custom);
  border-radius: 50%;
  transition: all 0.2s;
}
.avatar-group .avatar-group-item:hover {
  position: relative;
  transform: translateY(-2px);
  z-index: 1;
}

.accordion .accordion-button {
  font-weight: 500;
}
.accordion .accordion-body {
  color: #878a99;
}
.accordion.accordion-icon-none .accordion-button::after {
  content: "";
  background-image: none !important;
}
.accordion.accordion-icon-none .accordion-button:not(.collapsed)::after {
  content: "";
}

.custom-accordionwithicon .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "\\f0142";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8;
}
.custom-accordionwithicon .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "\\f0140";
  margin-right: -3px;
}

.custom-accordionwithicon-plus .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "\\f0415";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8;
}
.custom-accordionwithicon-plus .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "\\f0374";
  margin-right: -3px;
}

.lefticon-accordion .accordion-button {
  padding-left: 2.75rem;
}
.lefticon-accordion .accordion-button::after {
  position: absolute;
  left: 1.25rem;
  top: 14px;
}
.lefticon-accordion .accordion-button:not(.collapsed)::after {
  top: 20px;
}

.accordion-border-box .accordion-item {
  border-top: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
}
.accordion-border-box .accordion-item:not(:first-of-type) {
  margin-top: 8px;
}
.accordion-border-box .accordion-item .accordion-button {
  border-radius: 0.25rem;
}
.accordion-border-box .accordion-item .accordion-button:not(.collapsed) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.custom-accordion-border .accordion-item {
  border-left: 3px solid var(--vz-border-color);
}

.accordion-primary .accordion-item {
  border-color: rgba(64, 81, 137, 0.6);
}
.accordion-primary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #405189;
  background-color: rgba(64, 81, 137, 0.1) !important;
}
.accordion-primary .accordion-item .accordion-button::after {
  color: #405189;
}

.accordion-fill-primary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #405189 !important;
}

.accordion-secondary .accordion-item {
  border-color: rgba(53, 119, 241, 0.6);
}
.accordion-secondary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-secondary .accordion-item .accordion-button:not(.collapsed) {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.1) !important;
}
.accordion-secondary .accordion-item .accordion-button::after {
  color: #3577f1;
}

.accordion-fill-secondary .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-secondary .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #3577f1 !important;
}

.accordion-success .accordion-item {
  border-color: rgba(10, 179, 156, 0.6);
}
.accordion-success .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-success .accordion-item .accordion-button:not(.collapsed) {
  color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.1) !important;
}
.accordion-success .accordion-item .accordion-button::after {
  color: #0ab39c;
}

.accordion-fill-success .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-success .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #0ab39c !important;
}

.accordion-info .accordion-item {
  border-color: rgba(41, 156, 219, 0.6);
}
.accordion-info .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-info .accordion-item .accordion-button:not(.collapsed) {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1) !important;
}
.accordion-info .accordion-item .accordion-button::after {
  color: #299cdb;
}

.accordion-fill-info .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-info .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #299cdb !important;
}

.accordion-warning .accordion-item {
  border-color: rgba(247, 184, 75, 0.6);
}
.accordion-warning .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-warning .accordion-item .accordion-button:not(.collapsed) {
  color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.1) !important;
}
.accordion-warning .accordion-item .accordion-button::after {
  color: #f7b84b;
}

.accordion-fill-warning .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-warning .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #f7b84b !important;
}

.accordion-danger .accordion-item {
  border-color: rgba(240, 101, 72, 0.6);
}
.accordion-danger .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-danger .accordion-item .accordion-button:not(.collapsed) {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1) !important;
}
.accordion-danger .accordion-item .accordion-button::after {
  color: #f06548;
}

.accordion-fill-danger .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-danger .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #f06548 !important;
}

.accordion-light .accordion-item {
  border-color: rgba(243, 246, 249, 0.6);
}
.accordion-light .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-light .accordion-item .accordion-button:not(.collapsed) {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1) !important;
}
.accordion-light .accordion-item .accordion-button::after {
  color: #f3f6f9;
}

.accordion-fill-light .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-light .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #f3f6f9 !important;
}

.accordion-dark .accordion-item {
  border-color: rgba(33, 37, 41, 0.6);
}
.accordion-dark .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-dark .accordion-item .accordion-button:not(.collapsed) {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1) !important;
}
.accordion-dark .accordion-item .accordion-button::after {
  color: #212529;
}

.accordion-fill-dark .accordion-item .accordion-button {
  box-shadow: none;
}
.accordion-fill-dark .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #212529 !important;
}

[data-layout-mode=dark] .accordion-button:not(.collapsed) {
  color: var(--vz-accordion-button-active-color);
}
[data-layout-mode=dark] .accordion-button:not(.collapsed):after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___});
}
[data-layout-mode=dark] .accordion-button:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
}

[dir=rtl] .custom-accordionwithicon .accordion-button::after {
  transform: rotate(180deg);
}

.fs-10 {
  font-size: 10px !important;
}

.fs-11 {
  font-size: 11px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-13 {
  font-size: 13px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-15 {
  font-size: 15px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-17 {
  font-size: 17px !important;
}

.fs-18 {
  font-size: 18px !important;
}

.fs-19 {
  font-size: 19px !important;
}

.fs-20 {
  font-size: 20px !important;
}

.fs-21 {
  font-size: 21px !important;
}

.fs-22 {
  font-size: 22px !important;
}

.fs-23 {
  font-size: 23px !important;
}

.fs-24 {
  font-size: 24px !important;
}

.fs-36 {
  font-size: 36px !important;
}

.fs-48 {
  font-size: 48px !important;
}

.border-dark {
  border-color: var(--vz-dark) !important;
}

.border-light {
  border-color: var(--vz-light) !important;
}

.border-double {
  border-style: double !important;
}

.border-top-double {
  border-top-style: double !important;
}

.border-bottom-double {
  border-bottom-style: double !important;
}

.border-end-double {
  border-right-style: double !important;
}

.border-start-double {
  border-left-style: double !important;
}

.list-group-flush.border-double {
  border: none !important;
}
.list-group-flush.border-double .list-group-item {
  border-style: double !important;
}

.border-dashed {
  border-style: dashed !important;
}

.border-top-dashed {
  border-top-style: dashed !important;
}

.border-bottom-dashed {
  border-bottom-style: dashed !important;
}

.border-end-dashed {
  border-right-style: dashed !important;
}

.border-start-dashed {
  border-left-style: dashed !important;
}

.list-group-flush.border-dashed {
  border: none !important;
}
.list-group-flush.border-dashed .list-group-item {
  border-style: dashed !important;
}

.border-groove {
  border-style: groove !important;
}

.border-top-groove {
  border-top-style: groove !important;
}

.border-bottom-groove {
  border-bottom-style: groove !important;
}

.border-end-groove {
  border-right-style: groove !important;
}

.border-start-groove {
  border-left-style: groove !important;
}

.list-group-flush.border-groove {
  border: none !important;
}
.list-group-flush.border-groove .list-group-item {
  border-style: groove !important;
}

.border-outset {
  border-style: outset !important;
}

.border-top-outset {
  border-top-style: outset !important;
}

.border-bottom-outset {
  border-bottom-style: outset !important;
}

.border-end-outset {
  border-right-style: outset !important;
}

.border-start-outset {
  border-left-style: outset !important;
}

.list-group-flush.border-outset {
  border: none !important;
}
.list-group-flush.border-outset .list-group-item {
  border-style: outset !important;
}

.border-ridge {
  border-style: ridge !important;
}

.border-top-ridge {
  border-top-style: ridge !important;
}

.border-bottom-ridge {
  border-bottom-style: ridge !important;
}

.border-end-ridge {
  border-right-style: ridge !important;
}

.border-start-ridge {
  border-left-style: ridge !important;
}

.list-group-flush.border-ridge {
  border: none !important;
}
.list-group-flush.border-ridge .list-group-item {
  border-style: ridge !important;
}

.border-dotted {
  border-style: dotted !important;
}

.border-top-dotted {
  border-top-style: dotted !important;
}

.border-bottom-dotted {
  border-bottom-style: dotted !important;
}

.border-end-dotted {
  border-right-style: dotted !important;
}

.border-start-dotted {
  border-left-style: dotted !important;
}

.list-group-flush.border-dotted {
  border: none !important;
}
.list-group-flush.border-dotted .list-group-item {
  border-style: dotted !important;
}

.border-inset {
  border-style: inset !important;
}

.border-top-inset {
  border-top-style: inset !important;
}

.border-bottom-inset {
  border-bottom-style: inset !important;
}

.border-end-inset {
  border-right-style: inset !important;
}

.border-start-inset {
  border-left-style: inset !important;
}

.list-group-flush.border-inset {
  border: none !important;
}
.list-group-flush.border-inset .list-group-item {
  border-style: inset !important;
}

[data-layout-mode=dark] .link-dark, [data-layout-mode=dark] .link-light {
  color: var(--vz-dark) !important;
}
[data-layout-mode=dark] .link-dark:focus, [data-layout-mode=dark] .link-dark:hover, [data-layout-mode=dark] .link-light:focus, [data-layout-mode=dark] .link-light:hover {
  color: rgba(var(--vz-dark-rgb), 0.75) !important;
}

.ff-base {
  font-family: var(--vz-font-sans-serif);
}

.ff-secondary {
  font-family: "Open Sans", sans-serif;
}

.fw-medium {
  font-weight: 500;
}

.flex-1 {
  flex: 1 1;
}

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 4px);
  display: block;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
  text-align: center;
  transition: all 0.4s;
}
.social-list-item:hover {
  color: #878a99;
  background-color: #eff2f7;
}

.bg-pattern {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_65___}) #fff;
}

.w-xs {
  min-width: 80px;
}

.w-sm {
  min-width: 95px;
}

.w-md {
  min-width: 110px;
}

.w-lg {
  min-width: 140px;
}

.w-xl {
  min-width: 160px;
}

.icon-xs {
  height: 16px;
  width: 16px;
}

.icon-sm {
  height: 18px;
  width: 18px;
}

.icon-md {
  height: 22px;
  width: 22px;
}

.icon-lg {
  height: 24px;
  width: 24px;
}

.icon-xl {
  height: 28px;
  width: 28px;
}

.icon-xxl {
  height: 32px;
  width: 32px;
}

.icon-dual {
  color: #adb5bd;
  fill: rgba(173, 181, 189, 0.16);
}

.icon-dual-primary {
  color: #405189;
  fill: rgba(64, 81, 137, 0.16);
}

.icon-dual-secondary {
  color: #3577f1;
  fill: rgba(53, 119, 241, 0.16);
}

.icon-dual-success {
  color: #0ab39c;
  fill: rgba(10, 179, 156, 0.16);
}

.icon-dual-info {
  color: #299cdb;
  fill: rgba(41, 156, 219, 0.16);
}

.icon-dual-warning {
  color: #f7b84b;
  fill: rgba(247, 184, 75, 0.16);
}

.icon-dual-danger {
  color: #f06548;
  fill: rgba(240, 101, 72, 0.16);
}

.icon-dual-light {
  color: #f3f6f9;
  fill: rgba(243, 246, 249, 0.16);
}

.icon-dual-dark {
  color: #212529;
  fill: rgba(33, 37, 41, 0.16);
}

.search-box {
  position: relative;
}
.search-box .form-control {
  padding-left: 40px;
}
.search-box .search-icon {
  font-size: 14px;
  position: absolute;
  left: 13px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  color: #878a99;
}

.bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  opacity: 0.7;
  background-color: #000;
}

.customizer-setting {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 1000;
}

code {
  -webkit-user-select: all;
          user-select: all;
}

.layout-rightside {
  width: 280px;
  margin-right: -1.5rem;
  margin-top: calc(1px - 1.5rem * 1.1);
  height: calc(100% + 1.5rem * 1.1);
}

@media (max-width: 1699.98px) {
  .layout-rightside-col {
    display: none;
    position: fixed !important;
    height: 100vh;
    right: 0px;
    top: 0px;
    bottom: 0px;
    z-index: 1004;
  }
  .layout-rightside-col .overlay {
    position: fixed;
    top: 0;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background-color: rgba(33, 37, 41, 0.2);
  }
  .layout-rightside-col .layout-rightside {
    margin-top: 0px;
    height: 100%;
    margin-left: auto;
  }
  .layout-rightside-col .card-body {
    overflow-y: auto;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1700px) {
  [data-layout=horizontal] .layout-rightside, [data-layout-style=detached] .layout-rightside {
    margin-top: calc(28px - 1.5rem);
    margin-right: 0;
    height: calc(100% - 1.5rem / 5);
  }
}

.object-cover {
  object-fit: cover;
}

.text-truncate-two-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.favourite-btn {
  border-color: transparent;
}
.favourite-btn .ri-star-fill {
  color: #878a99;
}
.favourite-btn.active {
  border-color: transparent;
}
.favourite-btn.active .ri-star-fill {
  color: #f7b84b;
}
.favourite-btn.active .ri-star-fill:before {
  content: "\\f186";
}

.card-logo-light {
  display: var(--vz-card-logo-light);
}

.card-logo-dark {
  display: var(--vz-card-logo-dark);
}

[data-layout-mode=dark] .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}

#back-to-top {
  position: fixed;
  bottom: 100px;
  right: 28px;
  transition: all 0.5s ease;
  display: none;
  z-index: 1000;
}
#back-to-top:hover {
  animation: fade-up 1.5s infinite linear;
}

@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  75% {
    transform: translateY(-20px);
    opacity: 0;
  }
}
.cursor-pointer {
  cursor: pointer;
}

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--vz-card-bg-custom);
  z-index: 9999;
}

[data-preloader=disable] #preloader {
  opacity: 0;
  visibility: hidden;
}

#status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}

[type=tel]::placeholder,
[type=url]::placeholder,
[type=email]::placeholder,
[type=number]::placeholder {
  text-align: left;
}

.main-chart .chart-border-left {
  border-left: 1.4px solid var(--vz-border-color);
  padding: 2px 20px;
}
.main-chart .chart-border-left:last-child {
  margin-right: 0px;
}

/* Activity */
.activity-feed {
  list-style: none;
}
.activity-feed .feed-item {
  position: relative;
  padding-bottom: 27px;
  padding-left: 16px;
  border-left: 2px solid #f3f6f9;
}
.activity-feed .feed-item:after {
  content: "";
  display: block;
  position: absolute;
  top: 4px;
  left: -6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #405189;
  background-color: #fff;
}
.activity-feed .feed-item:last-child {
  border-color: transparent;
}

.mini-stats-wid {
  position: relative;
}
.mini-stats-wid .mini-stat-icon {
  overflow: hidden;
  position: relative;
}
.mini-stats-wid .mini-stat-icon:before, .mini-stats-wid .mini-stat-icon:after {
  content: "";
  position: absolute;
  width: 8px;
  height: 69px;
  background-color: rgba(10, 179, 156, 0.1);
  left: 3px;
  transform: rotate(32deg);
  top: -8px;
  transition: all 0.4s;
}
.mini-stats-wid .mini-stat-icon::after {
  left: 27px;
  width: 8px;
  transition: all 0.2s;
}
.mini-stats-wid:hover .mini-stat-icon::after {
  left: 60px;
}
.mini-stats-wid:hover .mini-stat-icon::before {
  left: 50px;
}

.card-wrapper .jp-card .jp-card-back, .card-wrapper .jp-card .jp-card-front {
  background-color: #0ab39c;
}

.notification-elem {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--vz-card-bg-custom);
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0;
}

.clothes-size li input[type=radio] {
  display: none;
}
.clothes-size li label {
  display: inline-block;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid var(--vz-border-color);
  text-transform: none;
  letter-spacing: 0;
  color: #405189;
}
.clothes-size li input[type=radio]:checked + label {
  background-color: #405189;
  border-color: #405189;
  color: #fff;
}

.button-items {
  margin-left: -8px;
  margin-bottom: -12px;
}
.button-items .btn {
  margin-bottom: 12px;
  margin-left: 8px;
}

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}

[dir=rtl] .modal-open {
  padding-left: 0px !important;
}

.icon-demo-content {
  color: var(--vz-gray-500);
}
.icon-demo-content i {
  font-size: 24px;
  margin-right: 10px;
  color: var(--vz-gray-600);
  transition: all 0.4s;
  vertical-align: middle;
}
.icon-demo-content svg {
  margin-right: 10px;
  transition: all 0.4s;
  height: 20px;
}
.icon-demo-content .col-lg-4 {
  margin-top: 24px;
}
.icon-demo-content .col-lg-4:hover i, .icon-demo-content .col-lg-4:hover svg {
  color: #405189;
  transform: scale(1.5);
}

.grid-structure .grid-container {
  background-color: #f3f6f9;
  margin-top: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 10px 20px;
}

.img-switch .card-radio .form-check-input {
  display: none;
}
.img-switch .card-radio .form-check-input:checked + .form-check-label::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(64, 81, 137, 0.5);
}
.img-switch .card-radio .form-check-input:checked + .form-check-label::after {
  content: "\\eb80";
  font-family: "remixicon";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 18px;
  color: #fff;
}

[data-bs-target="#collapseBgGradient"].active {
  border-color: #405189 !important;
}
[data-bs-target="#collapseBgGradient"].active::before {
  content: "\\eb80";
  font-family: remixicon;
  position: absolute;
  top: 2px;
  right: 6px;
  font-size: 16px;
  color: #405189;
}

[data-layout-mode=dark] .colorscheme-cardradio .form-check-label {
  background-color: var(--vz-dark);
}
[data-layout-mode=dark] .colorscheme-cardradio .bg-light {
  background-color: rgba(var(--vz-light-rgb), 0.1) !important;
}
[data-layout-mode=dark] .colorscheme-cardradio .bg-soft-light {
  background-color: rgba(var(--vz-dark-rgb), 0.1) !important;
}
[data-layout-mode=dark] .colorscheme-cardradio .dark .bg-dark {
  background-color: var(--vz-card-bg-custom) !important;
}

@media print {
  .vertical-menu,
  .right-bar,
  .page-title-box,
  .navbar-header,
  .app-menu,
  .footer,
  #back-to-top {
    display: none !important;
  }
  .card-body,
  .main-content,
  .right-bar,
  .page-content,
  body {
    padding: 0;
    margin: 0;
  }
  .card {
    border: 0;
    box-shadow: none !important;
  }
  .invoice-details .d-sm-flex {
    display: flex !important;
  }
  .address.col-sm-6 {
    flex: 0 0 auto !important;
    width: 50% !important;
    max-width: 100% !important;
  }
}
.ribbon-box {
  position: relative;
}
.ribbon-box .ribbon {
  padding: 5px 12px;
  box-shadow: 2px 5px 10px rgba(33, 37, 41, 0.15);
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
  position: absolute;
  left: -1px;
  top: 5px;
}
.ribbon-box .ribbon.round-shape {
  border-radius: 0 30px 30px 0;
}
.ribbon-box .ribbon.ribbon-shape {
  display: inline-block;
}
.ribbon-box .ribbon.ribbon-shape::before {
  content: "";
  position: absolute;
  right: -17px;
  top: 0;
  border: 14px solid transparent;
}
.ribbon-box .ribbon.ribbon-shape::after {
  content: "";
  position: absolute;
  right: -17px;
  bottom: 0;
  border: 14px solid transparent;
}
.ribbon-box.ribbon-circle .ribbon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 20px;
  top: 20px;
}
.ribbon-box.ribbon-fill {
  overflow: hidden;
}
.ribbon-box.ribbon-fill .ribbon {
  transform: rotate(-45deg);
  width: 93px;
  height: 52px;
  left: -36px;
  top: -16px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.ribbon-box.ribbon-fill.ribbon-sm .ribbon {
  padding: 2px 12px;
  width: 78px;
  height: 42px;
  font-size: 12px;
  box-shadow: none;
}
.ribbon-box.right .ribbon {
  position: absolute;
  left: auto;
  right: 0;
}
.ribbon-box.right .ribbon.round-shape {
  border-radius: 30px 0 0 30px;
}
.ribbon-box.right .ribbon.ribbon-shape {
  text-align: right;
}
.ribbon-box.right .ribbon.ribbon-shape::before, .ribbon-box.right .ribbon.ribbon-shape::after {
  right: auto;
  left: -17px;
  border-left-color: transparent;
}
.ribbon-box.right.ribbon-circle .ribbon {
  left: auto;
  right: 20px;
}
.ribbon-box.right .icon-ribbon {
  right: 24px;
  left: auto;
}
.ribbon-box.right.ribbon-fill .ribbon {
  transform: rotate(45deg);
  right: -38px;
  left: auto;
}
.ribbon-box.right.ribbon-box .ribbon-two {
  left: auto;
  right: -5px;
}
.ribbon-box.right.ribbon-box .ribbon-two span {
  left: auto;
  right: -21px;
  transform: rotate(45deg);
}
.ribbon-box .ribbon-content {
  clear: both;
}
.ribbon-box .ribbon-primary {
  background: #405189;
}
.ribbon-box .ribbon-primary:before {
  border-color: rgb(47.7611940299, 60.447761194, 102.2388059701) transparent transparent;
}
.ribbon-box .ribbon-primary.ribbon-shape::before {
  border-left-color: #405189;
  border-top-color: #405189;
}
.ribbon-box .ribbon-primary.ribbon-shape::after {
  border-left-color: #405189;
  border-bottom-color: #405189;
}
.ribbon-box.right .ribbon-primary {
  background: #405189;
}
.ribbon-box.right .ribbon-primary.ribbon-shape::before {
  border-right-color: #405189;
  border-top-color: #405189;
}
.ribbon-box.right .ribbon-primary.ribbon-shape::after {
  border-right-color: #405189;
  border-bottom-color: #405189;
}
.ribbon-box .ribbon-secondary {
  background: #3577f1;
}
.ribbon-box .ribbon-secondary:before {
  border-color: rgb(15.75, 90, 227.25) transparent transparent;
}
.ribbon-box .ribbon-secondary.ribbon-shape::before {
  border-left-color: #3577f1;
  border-top-color: #3577f1;
}
.ribbon-box .ribbon-secondary.ribbon-shape::after {
  border-left-color: #3577f1;
  border-bottom-color: #3577f1;
}
.ribbon-box.right .ribbon-secondary {
  background: #3577f1;
}
.ribbon-box.right .ribbon-secondary.ribbon-shape::before {
  border-right-color: #3577f1;
  border-top-color: #3577f1;
}
.ribbon-box.right .ribbon-secondary.ribbon-shape::after {
  border-right-color: #3577f1;
  border-bottom-color: #3577f1;
}
.ribbon-box .ribbon-success {
  background: #0ab39c;
}
.ribbon-box .ribbon-success:before {
  border-color: rgb(7.3015873016, 130.6984126984, 113.9047619048) transparent transparent;
}
.ribbon-box .ribbon-success.ribbon-shape::before {
  border-left-color: #0ab39c;
  border-top-color: #0ab39c;
}
.ribbon-box .ribbon-success.ribbon-shape::after {
  border-left-color: #0ab39c;
  border-bottom-color: #0ab39c;
}
.ribbon-box.right .ribbon-success {
  background: #0ab39c;
}
.ribbon-box.right .ribbon-success.ribbon-shape::before {
  border-right-color: #0ab39c;
  border-top-color: #0ab39c;
}
.ribbon-box.right .ribbon-success.ribbon-shape::after {
  border-right-color: #0ab39c;
  border-bottom-color: #0ab39c;
}
.ribbon-box .ribbon-info {
  background: #299cdb;
}
.ribbon-box .ribbon-info:before {
  border-color: rgb(30.096, 126.236, 178.904) transparent transparent;
}
.ribbon-box .ribbon-info.ribbon-shape::before {
  border-left-color: #299cdb;
  border-top-color: #299cdb;
}
.ribbon-box .ribbon-info.ribbon-shape::after {
  border-left-color: #299cdb;
  border-bottom-color: #299cdb;
}
.ribbon-box.right .ribbon-info {
  background: #299cdb;
}
.ribbon-box.right .ribbon-info.ribbon-shape::before {
  border-right-color: #299cdb;
  border-top-color: #299cdb;
}
.ribbon-box.right .ribbon-info.ribbon-shape::after {
  border-right-color: #299cdb;
  border-bottom-color: #299cdb;
}
.ribbon-box .ribbon-warning {
  background: #f7b84b;
}
.ribbon-box .ribbon-warning:before {
  border-color: rgb(244.829787234, 164.7393617021, 26.170212766) transparent transparent;
}
.ribbon-box .ribbon-warning.ribbon-shape::before {
  border-left-color: #f7b84b;
  border-top-color: #f7b84b;
}
.ribbon-box .ribbon-warning.ribbon-shape::after {
  border-left-color: #f7b84b;
  border-bottom-color: #f7b84b;
}
.ribbon-box.right .ribbon-warning {
  background: #f7b84b;
}
.ribbon-box.right .ribbon-warning.ribbon-shape::before {
  border-right-color: #f7b84b;
  border-top-color: #f7b84b;
}
.ribbon-box.right .ribbon-warning.ribbon-shape::after {
  border-right-color: #f7b84b;
  border-bottom-color: #f7b84b;
}
.ribbon-box .ribbon-danger {
  background: #f06548;
}
.ribbon-box .ribbon-danger:before {
  border-color: rgb(236.1363636364, 61.3333333333, 24.8636363636) transparent transparent;
}
.ribbon-box .ribbon-danger.ribbon-shape::before {
  border-left-color: #f06548;
  border-top-color: #f06548;
}
.ribbon-box .ribbon-danger.ribbon-shape::after {
  border-left-color: #f06548;
  border-bottom-color: #f06548;
}
.ribbon-box.right .ribbon-danger {
  background: #f06548;
}
.ribbon-box.right .ribbon-danger.ribbon-shape::before {
  border-right-color: #f06548;
  border-top-color: #f06548;
}
.ribbon-box.right .ribbon-danger.ribbon-shape::after {
  border-right-color: #f06548;
  border-bottom-color: #f06548;
}
.ribbon-box .ribbon-light {
  background: #f3f6f9;
}
.ribbon-box .ribbon-light:before {
  border-color: rgb(209, 220.5, 232) transparent transparent;
}
.ribbon-box .ribbon-light.ribbon-shape::before {
  border-left-color: #f3f6f9;
  border-top-color: #f3f6f9;
}
.ribbon-box .ribbon-light.ribbon-shape::after {
  border-left-color: #f3f6f9;
  border-bottom-color: #f3f6f9;
}
.ribbon-box.right .ribbon-light {
  background: #f3f6f9;
}
.ribbon-box.right .ribbon-light.ribbon-shape::before {
  border-right-color: #f3f6f9;
  border-top-color: #f3f6f9;
}
.ribbon-box.right .ribbon-light.ribbon-shape::after {
  border-right-color: #f3f6f9;
  border-bottom-color: #f3f6f9;
}
.ribbon-box .ribbon-dark {
  background: #212529;
}
.ribbon-box .ribbon-dark:before {
  border-color: rgb(10.2567567568, 11.5, 12.7432432432) transparent transparent;
}
.ribbon-box .ribbon-dark.ribbon-shape::before {
  border-left-color: #212529;
  border-top-color: #212529;
}
.ribbon-box .ribbon-dark.ribbon-shape::after {
  border-left-color: #212529;
  border-bottom-color: #212529;
}
.ribbon-box.right .ribbon-dark {
  background: #212529;
}
.ribbon-box.right .ribbon-dark.ribbon-shape::before {
  border-right-color: #212529;
  border-top-color: #212529;
}
.ribbon-box.right .ribbon-dark.ribbon-shape::after {
  border-right-color: #212529;
  border-bottom-color: #212529;
}
.ribbon-box .icon-ribbon {
  box-shadow: none;
  left: 24px;
  top: -12px;
  font-size: 40px;
  padding: 0;
}
.ribbon-box {
  /* Ribbon two */
}
.ribbon-box .ribbon-two {
  position: absolute;
  left: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}
.ribbon-box .ribbon-two span {
  font-size: 13px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  transform: rotate(-45deg);
  width: 100px;
  display: block;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  position: absolute;
  top: 19px;
  left: -21px;
  font-weight: 600;
}
.ribbon-box .ribbon-two span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 100%;
  z-index: -1;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
}
.ribbon-box .ribbon-two span:after {
  content: "";
  position: absolute;
  right: 0;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-bottom: 3px solid transparent;
}
.ribbon-box .ribbon-two-primary span {
  background: #405189;
}
.ribbon-box .ribbon-two-primary span:before {
  border-left: 3px solid rgb(39.6417910448, 50.171641791, 84.8582089552);
  border-top: 3px solid rgb(39.6417910448, 50.171641791, 84.8582089552);
}
.ribbon-box .ribbon-two-primary span:after {
  border-right: 3px solid rgb(39.6417910448, 50.171641791, 84.8582089552);
  border-top: 3px solid rgb(39.6417910448, 50.171641791, 84.8582089552);
}
.ribbon-box .ribbon-two-secondary span {
  background: #3577f1;
}
.ribbon-box .ribbon-two-secondary span:before {
  border-left: 3px solid rgb(14.0972222222, 80.5555555556, 203.4027777778);
  border-top: 3px solid rgb(14.0972222222, 80.5555555556, 203.4027777778);
}
.ribbon-box .ribbon-two-secondary span:after {
  border-right: 3px solid rgb(14.0972222222, 80.5555555556, 203.4027777778);
  border-top: 3px solid rgb(14.0972222222, 80.5555555556, 203.4027777778);
}
.ribbon-box .ribbon-two-success span {
  background: #0ab39c;
}
.ribbon-box .ribbon-two-success span:before {
  border-left: 3px solid rgb(5.9523809524, 106.5476190476, 92.8571428571);
  border-top: 3px solid rgb(5.9523809524, 106.5476190476, 92.8571428571);
}
.ribbon-box .ribbon-two-success span:after {
  border-right: 3px solid rgb(5.9523809524, 106.5476190476, 92.8571428571);
  border-top: 3px solid rgb(5.9523809524, 106.5476190476, 92.8571428571);
}
.ribbon-box .ribbon-two-info span {
  background: #299cdb;
}
.ribbon-box .ribbon-two-info span:before {
  border-left: 3px solid rgb(26.424, 110.834, 157.076);
  border-top: 3px solid rgb(26.424, 110.834, 157.076);
}
.ribbon-box .ribbon-two-info span:after {
  border-right: 3px solid rgb(26.424, 110.834, 157.076);
  border-top: 3px solid rgb(26.424, 110.834, 157.076);
}
.ribbon-box .ribbon-two-warning span {
  background: #f7b84b;
}
.ribbon-box .ribbon-two-warning span:before {
  border-left: 3px solid rgb(235.0531914894, 152.7845744681, 10.4468085106);
  border-top: 3px solid rgb(235.0531914894, 152.7845744681, 10.4468085106);
}
.ribbon-box .ribbon-two-warning span:after {
  border-right: 3px solid rgb(235.0531914894, 152.7845744681, 10.4468085106);
  border-top: 3px solid rgb(235.0531914894, 152.7845744681, 10.4468085106);
}
.ribbon-box .ribbon-two-danger span {
  background: #f06548;
}
.ribbon-box .ribbon-two-danger span:before {
  border-left: 3px solid rgb(217.6590909091, 52.3333333333, 17.8409090909);
  border-top: 3px solid rgb(217.6590909091, 52.3333333333, 17.8409090909);
}
.ribbon-box .ribbon-two-danger span:after {
  border-right: 3px solid rgb(217.6590909091, 52.3333333333, 17.8409090909);
  border-top: 3px solid rgb(217.6590909091, 52.3333333333, 17.8409090909);
}
.ribbon-box .ribbon-two-light span {
  background: #f3f6f9;
}
.ribbon-box .ribbon-two-light span:before {
  border-left: 3px solid rgb(192, 207.75, 223.5);
  border-top: 3px solid rgb(192, 207.75, 223.5);
}
.ribbon-box .ribbon-two-light span:after {
  border-right: 3px solid rgb(192, 207.75, 223.5);
  border-top: 3px solid rgb(192, 207.75, 223.5);
}
.ribbon-box .ribbon-two-dark span {
  background: #212529;
}
.ribbon-box .ribbon-two-dark span:before {
  border-left: 3px solid black;
  border-top: 3px solid black;
}
.ribbon-box .ribbon-two-dark span:after {
  border-right: 3px solid black;
  border-top: 3px solid black;
}

.ribbon-box.right .ribbon-three {
  position: absolute;
  top: -6.1px;
  right: 10px;
  left: auto;
}

.ribbon-three {
  position: absolute;
  top: -6.1px;
  left: 10px;
}
.ribbon-three span {
  position: relative;
  display: block;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-top-right-radius: 8px;
  width: 90px;
}
.ribbon-three span::after, .ribbon-three span::before {
  position: absolute;
  content: "";
}
.ribbon-three span::before {
  height: 6px;
  width: 6px;
  left: -6px;
  top: 0;
}
.ribbon-three span::after {
  height: 6px;
  width: 8px;
  left: -8px;
  top: 0;
  border-radius: 8px 8px 0 0;
}
.ribbon-three::after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-left: 44px solid transparent;
  border-right: 44px solid transparent;
  border-top: 10px solid;
}

.ribbon-three-primary span {
  background: #405189;
}
.ribbon-three-primary span:before {
  background: #405189;
}
.ribbon-three-primary span:after {
  background: rgb(47.7611940299, 60.447761194, 102.2388059701);
}
.ribbon-three-primary::after {
  border-top-color: #405189;
}

.ribbon-three-secondary span {
  background: #3577f1;
}
.ribbon-three-secondary span:before {
  background: #3577f1;
}
.ribbon-three-secondary span:after {
  background: rgb(15.75, 90, 227.25);
}
.ribbon-three-secondary::after {
  border-top-color: #3577f1;
}

.ribbon-three-success span {
  background: #0ab39c;
}
.ribbon-three-success span:before {
  background: #0ab39c;
}
.ribbon-three-success span:after {
  background: rgb(7.3015873016, 130.6984126984, 113.9047619048);
}
.ribbon-three-success::after {
  border-top-color: #0ab39c;
}

.ribbon-three-info span {
  background: #299cdb;
}
.ribbon-three-info span:before {
  background: #299cdb;
}
.ribbon-three-info span:after {
  background: rgb(30.096, 126.236, 178.904);
}
.ribbon-three-info::after {
  border-top-color: #299cdb;
}

.ribbon-three-warning span {
  background: #f7b84b;
}
.ribbon-three-warning span:before {
  background: #f7b84b;
}
.ribbon-three-warning span:after {
  background: rgb(244.829787234, 164.7393617021, 26.170212766);
}
.ribbon-three-warning::after {
  border-top-color: #f7b84b;
}

.ribbon-three-danger span {
  background: #f06548;
}
.ribbon-three-danger span:before {
  background: #f06548;
}
.ribbon-three-danger span:after {
  background: rgb(236.1363636364, 61.3333333333, 24.8636363636);
}
.ribbon-three-danger::after {
  border-top-color: #f06548;
}

.ribbon-three-light span {
  background: #f3f6f9;
}
.ribbon-three-light span:before {
  background: #f3f6f9;
}
.ribbon-three-light span:after {
  background: rgb(209, 220.5, 232);
}
.ribbon-three-light::after {
  border-top-color: #f3f6f9;
}

.ribbon-three-dark span {
  background: #212529;
}
.ribbon-three-dark span:before {
  background: #212529;
}
.ribbon-three-dark span:after {
  background: rgb(10.2567567568, 11.5, 12.7432432432);
}
.ribbon-three-dark::after {
  border-top-color: #212529;
}

.ribbon-box .trending-ribbon {
  transform: translateX(-50px);
  transition: all 0.5s ease;
}
.ribbon-box .trending-ribbon .trending-ribbon-text {
  transition: all 0.5s ease;
  opacity: 0;
}
.ribbon-box:hover .trending-ribbon {
  transform: translateX(0);
}
.ribbon-box:hover .trending-ribbon .trending-ribbon-text {
  opacity: 1;
}
.ribbon-box.right .trending-ribbon {
  transform: translateX(50px);
  transition: all 0.5s ease;
}
.ribbon-box.right .trending-ribbon .trending-ribbon-text {
  transition: all 0.5s ease;
  opacity: 0;
}
.ribbon-box.right:hover .trending-ribbon {
  transform: translateX(0);
}
.ribbon-box.right:hover .trending-ribbon .trending-ribbon-text {
  opacity: 1;
}

.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast-border-primary .toast-body {
  color: #405189;
  border-bottom: 3px solid #405189;
}

.toast-border-secondary .toast-body {
  color: #3577f1;
  border-bottom: 3px solid #3577f1;
}

.toast-border-success .toast-body {
  color: #0ab39c;
  border-bottom: 3px solid #0ab39c;
}

.toast-border-info .toast-body {
  color: #299cdb;
  border-bottom: 3px solid #299cdb;
}

.toast-border-warning .toast-body {
  color: #f7b84b;
  border-bottom: 3px solid #f7b84b;
}

.toast-border-danger .toast-body {
  color: #f06548;
  border-bottom: 3px solid #f06548;
}

.toast-border-light .toast-body {
  color: #f3f6f9;
  border-bottom: 3px solid #f3f6f9;
}

.toast-border-dark .toast-body {
  color: #212529;
  border-bottom: 3px solid #212529;
}

.scrollspy-example {
  position: relative;
  height: 200px;
  margin-top: 0.5rem;
  overflow: auto;
}

.scrollspy-example-2 {
  position: relative;
  height: 370px;
  overflow: auto;
}

html {
  position: relative;
  min-height: 100%;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--vz-heading-color);
  font-family: "Open Sans", sans-serif;
}

a {
  text-decoration: none !important;
}

label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

b,
strong {
  font-weight: 600;
}

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid var(--vz-gray-300);
}

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid var(--vz-gray-300);
  text-align: right;
}

@media (min-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1140px;
  }
}

.row > * {
  position: relative;
}

.alert-solid .alert-link {
  color: #fff;
}

.alert-outline {
  background-color: var(--vz-card-bg-custom);
  border-width: 2px;
}

.alert-borderless {
  border-width: 0;
}

.alert-label-icon {
  position: relative;
  padding-left: 60px;
  border: 0;
}
.alert-label-icon .label-icon {
  position: absolute;
  width: 45px;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.15);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert-label-icon.label-arrow {
  overflow: hidden;
}
.alert-label-icon.label-arrow .label-icon:after {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  border-left-color: #405189;
  right: -12px;
}

.alert-border-left {
  border-left: 3px solid;
}

.alert-top-border {
  background-color: var(--vz-card-bg-custom);
  border-color: var(--vz-border-color);
  border-top: 2px solid;
  color: var(--vz-body-color);
}

.alert-additional {
  padding: 0;
}
.alert-additional .alert-body {
  padding: 0.8rem 1rem;
}
.alert-additional .alert-content {
  padding: 0.8rem 1rem;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  margin: 0 -1px -1px -1px;
}

.rounded-label .label-icon {
  width: 45px;
  height: 26px;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 0 30px 30px 0;
}

.alert-solid.alert-primary {
  background-color: #405189;
  border-color: #405189;
  color: #fff;
}

.alert-outline.alert-primary {
  color: #405189;
}

.alert-border-left.alert-primary {
  border-left-color: #405189;
}

.alert-top-border.alert-primary {
  border-top-color: #405189;
}

.rounded-label.alert-primary .label-icon {
  background-color: #405189;
  color: #fff;
}

.label-arrow.alert-primary .label-icon {
  color: #fff;
  background-color: #405189;
}
.label-arrow.alert-primary .label-icon:after {
  border-left-color: #405189 !important;
}

.alert.alert-primary .btn-close::after {
  color: #405189;
}

.alert-additional.alert-primary .alert-content {
  background-color: #405189;
  color: #fff;
}

.alert-solid.alert-secondary {
  background-color: #3577f1;
  border-color: #3577f1;
  color: #fff;
}

.alert-outline.alert-secondary {
  color: #3577f1;
}

.alert-border-left.alert-secondary {
  border-left-color: #3577f1;
}

.alert-top-border.alert-secondary {
  border-top-color: #3577f1;
}

.rounded-label.alert-secondary .label-icon {
  background-color: #3577f1;
  color: #fff;
}

.label-arrow.alert-secondary .label-icon {
  color: #fff;
  background-color: #3577f1;
}
.label-arrow.alert-secondary .label-icon:after {
  border-left-color: #3577f1 !important;
}

.alert.alert-secondary .btn-close::after {
  color: #3577f1;
}

.alert-additional.alert-secondary .alert-content {
  background-color: #3577f1;
  color: #fff;
}

.alert-solid.alert-success {
  background-color: #0ab39c;
  border-color: #0ab39c;
  color: #fff;
}

.alert-outline.alert-success {
  color: #0ab39c;
}

.alert-border-left.alert-success {
  border-left-color: #0ab39c;
}

.alert-top-border.alert-success {
  border-top-color: #0ab39c;
}

.rounded-label.alert-success .label-icon {
  background-color: #0ab39c;
  color: #fff;
}

.label-arrow.alert-success .label-icon {
  color: #fff;
  background-color: #0ab39c;
}
.label-arrow.alert-success .label-icon:after {
  border-left-color: #0ab39c !important;
}

.alert.alert-success .btn-close::after {
  color: #0ab39c;
}

.alert-additional.alert-success .alert-content {
  background-color: #0ab39c;
  color: #fff;
}

.alert-solid.alert-info {
  background-color: #299cdb;
  border-color: #299cdb;
  color: #fff;
}

.alert-outline.alert-info {
  color: #299cdb;
}

.alert-border-left.alert-info {
  border-left-color: #299cdb;
}

.alert-top-border.alert-info {
  border-top-color: #299cdb;
}

.rounded-label.alert-info .label-icon {
  background-color: #299cdb;
  color: #fff;
}

.label-arrow.alert-info .label-icon {
  color: #fff;
  background-color: #299cdb;
}
.label-arrow.alert-info .label-icon:after {
  border-left-color: #299cdb !important;
}

.alert.alert-info .btn-close::after {
  color: #299cdb;
}

.alert-additional.alert-info .alert-content {
  background-color: #299cdb;
  color: #fff;
}

.alert-solid.alert-warning {
  background-color: #f7b84b;
  border-color: #f7b84b;
  color: #fff;
}

.alert-outline.alert-warning {
  color: #f7b84b;
}

.alert-border-left.alert-warning {
  border-left-color: #f7b84b;
}

.alert-top-border.alert-warning {
  border-top-color: #f7b84b;
}

.rounded-label.alert-warning .label-icon {
  background-color: #f7b84b;
  color: #fff;
}

.label-arrow.alert-warning .label-icon {
  color: #fff;
  background-color: #f7b84b;
}
.label-arrow.alert-warning .label-icon:after {
  border-left-color: #f7b84b !important;
}

.alert.alert-warning .btn-close::after {
  color: #f7b84b;
}

.alert-additional.alert-warning .alert-content {
  background-color: #f7b84b;
  color: #fff;
}

.alert-solid.alert-danger {
  background-color: #f06548;
  border-color: #f06548;
  color: #fff;
}

.alert-outline.alert-danger {
  color: #f06548;
}

.alert-border-left.alert-danger {
  border-left-color: #f06548;
}

.alert-top-border.alert-danger {
  border-top-color: #f06548;
}

.rounded-label.alert-danger .label-icon {
  background-color: #f06548;
  color: #fff;
}

.label-arrow.alert-danger .label-icon {
  color: #fff;
  background-color: #f06548;
}
.label-arrow.alert-danger .label-icon:after {
  border-left-color: #f06548 !important;
}

.alert.alert-danger .btn-close::after {
  color: #f06548;
}

.alert-additional.alert-danger .alert-content {
  background-color: #f06548;
  color: #fff;
}

.alert-solid.alert-light {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
  color: #000;
}

.alert-outline.alert-light {
  color: #f3f6f9;
}

.alert-border-left.alert-light {
  border-left-color: #f3f6f9;
}

.alert-top-border.alert-light {
  border-top-color: #f3f6f9;
}

.rounded-label.alert-light .label-icon {
  background-color: #f3f6f9;
  color: #000;
}

.label-arrow.alert-light .label-icon {
  color: #000;
  background-color: #f3f6f9;
}
.label-arrow.alert-light .label-icon:after {
  border-left-color: #f3f6f9 !important;
}

.alert.alert-light .btn-close::after {
  color: #f3f6f9;
}

.alert-additional.alert-light .alert-content {
  background-color: #f3f6f9;
  color: #000;
}

.alert-solid.alert-dark {
  background-color: #212529;
  border-color: #212529;
  color: #fff;
}

.alert-outline.alert-dark {
  color: #212529;
}

.alert-border-left.alert-dark {
  border-left-color: #212529;
}

.alert-top-border.alert-dark {
  border-top-color: #212529;
}

.rounded-label.alert-dark .label-icon {
  background-color: #212529;
  color: #fff;
}

.label-arrow.alert-dark .label-icon {
  color: #fff;
  background-color: #212529;
}
.label-arrow.alert-dark .label-icon:after {
  border-left-color: #212529 !important;
}

.alert.alert-dark .btn-close::after {
  color: #212529;
}

.alert-additional.alert-dark .alert-content {
  background-color: #212529;
  color: #fff;
}

.alert-dismissible .btn-close {
  background: transparent !important;
}
.alert-dismissible .btn-close::after {
  background: transparent !important;
  content: "\\f0156" !important;
  font-size: 18px;
  line-height: 15px;
  font-family: "Material Design Icons" !important;
}

.alert-outline.alert-dark {
  color: var(--vz-dark);
}

.bg-soft-primary {
  background-color: rgba(64, 81, 137, 0.18) !important;
}

.bg-soft-secondary {
  background-color: rgba(53, 119, 241, 0.18) !important;
}

.bg-soft-success {
  background-color: rgba(10, 179, 156, 0.18) !important;
}

.bg-soft-info {
  background-color: rgba(41, 156, 219, 0.18) !important;
}

.bg-soft-warning {
  background-color: rgba(247, 184, 75, 0.18) !important;
}

.bg-soft-danger {
  background-color: rgba(240, 101, 72, 0.18) !important;
}

.bg-soft-light {
  background-color: rgba(243, 246, 249, 0.18) !important;
}

.bg-soft-dark {
  background-color: rgba(33, 37, 41, 0.18) !important;
}

.bg-soft-dark {
  background-color: rgba(var(--vz-dark-rgb), 0.18) !important;
}

.bg-soft-light {
  background-color: rgba(var(--vz-light-rgb), 0.18) !important;
}

.badge-outline-primary {
  color: #405189;
  border: 1px solid #405189;
  background-color: transparent;
}

.badge-outline-secondary {
  color: #3577f1;
  border: 1px solid #3577f1;
  background-color: transparent;
}

.badge-outline-success {
  color: #0ab39c;
  border: 1px solid #0ab39c;
  background-color: transparent;
}

.badge-outline-info {
  color: #299cdb;
  border: 1px solid #299cdb;
  background-color: transparent;
}

.badge-outline-warning {
  color: #f7b84b;
  border: 1px solid #f7b84b;
  background-color: transparent;
}

.badge-outline-danger {
  color: #f06548;
  border: 1px solid #f06548;
  background-color: transparent;
}

.badge-outline-light {
  color: #f3f6f9;
  border: 1px solid #f3f6f9;
  background-color: transparent;
}

.badge-outline-dark {
  color: #212529;
  border: 1px solid #212529;
  background-color: transparent;
}

.badge-outline {
  background-color: var(--vz-card-bg-custom);
  border: 1px solid;
}

.badge-soft-primary {
  color: #405189;
  background-color: rgba(64, 81, 137, 0.1);
}

.badge-outline.badge-primary {
  color: #405189;
  border: 1px solid #405189;
  background-color: transparent;
}

.badge-label.bg-primary:before {
  border-right-color: #405189;
}

.badge-soft-secondary {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.1);
}

.badge-outline.badge-secondary {
  color: #3577f1;
  border: 1px solid #3577f1;
  background-color: transparent;
}

.badge-label.bg-secondary:before {
  border-right-color: #3577f1;
}

.badge-soft-success {
  color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.1);
}

.badge-outline.badge-success {
  color: #0ab39c;
  border: 1px solid #0ab39c;
  background-color: transparent;
}

.badge-label.bg-success:before {
  border-right-color: #0ab39c;
}

.badge-soft-info {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1);
}

.badge-outline.badge-info {
  color: #299cdb;
  border: 1px solid #299cdb;
  background-color: transparent;
}

.badge-label.bg-info:before {
  border-right-color: #299cdb;
}

.badge-soft-warning {
  color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.1);
}

.badge-outline.badge-warning {
  color: #f7b84b;
  border: 1px solid #f7b84b;
  background-color: transparent;
}

.badge-label.bg-warning:before {
  border-right-color: #f7b84b;
}

.badge-soft-danger {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1);
}

.badge-outline.badge-danger {
  color: #f06548;
  border: 1px solid #f06548;
  background-color: transparent;
}

.badge-label.bg-danger:before {
  border-right-color: #f06548;
}

.badge-soft-light {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
}

.badge-outline.badge-light {
  color: #f3f6f9;
  border: 1px solid #f3f6f9;
  background-color: transparent;
}

.badge-label.bg-light:before {
  border-right-color: #f3f6f9;
}

.badge-soft-dark {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1);
}

.badge-outline.badge-dark {
  color: #212529;
  border: 1px solid #212529;
  background-color: transparent;
}

.badge-label.bg-dark:before {
  border-right-color: #212529;
}

.badge-border {
  border-left: 2px solid;
}

.badge-label {
  margin-left: 8px;
  position: relative;
}
.badge-label:before {
  content: "";
  position: absolute;
  border: 8px solid transparent;
  border-right-color: #405189;
  left: -14px;
  top: 0;
}

.badge-gradient-primary {
  background: linear-gradient(135deg, #405189 0%, #0ab39c 100%);
}

.badge-gradient-secondary {
  background: linear-gradient(135deg, #3577f1 0%, #299cdb 100%);
}

.badge-gradient-success {
  background: linear-gradient(135deg, #0ab39c 0%, #f7b84b 100%);
}

.badge-gradient-danger {
  background: linear-gradient(135deg, #f06548 0%, #3577f1 100%);
}

.badge-gradient-warning {
  background: linear-gradient(135deg, #f7b84b 0%, rgb(235.0531914894, 152.7845744681, 10.4468085106) 100%);
}

.badge-gradient-info {
  background: linear-gradient(135deg, #299cdb 0%, #0ab39c 100%);
}

.badge-gradient-dark {
  background: linear-gradient(135deg, #212529 0%, #405189 100%);
}

button,
a {
  outline: none !important;
  position: relative;
}

.btn {
  box-shadow: none;
}
.btn:hover, .btn.active, .btn:focus, .btn:active, .btn.show {
  border-color: transparent;
}

.btn-rounded {
  border-radius: 30px;
}

.btn-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: calc(1rem + 1.5em + 2px);
  width: calc(1rem + 1.5em + 2px);
  padding: 0;
}
.btn-icon i,
.btn-icon svg,
.btn-icon img {
  vertical-align: middle;
}
.btn-icon.btn-sm, .btn-group-sm > .btn-icon.btn {
  height: calc(0.5rem + 1.5em + 2px);
  width: calc(0.5rem + 1.5em + 2px);
}
.btn-icon.btn-lg, .btn-group-lg > .btn-icon.btn {
  height: calc(1.4rem + 1.5em + 2px);
  width: calc(1.4rem + 1.5em + 2px);
}

.btn-soft-primary {
  color: #405189;
  background-color: rgba(64, 81, 137, 0.1);
  border-color: transparent;
}
.btn-soft-primary:hover, .btn-soft-primary:focus, .btn-soft-primary:active {
  color: #fff;
  background-color: #405189;
  border-color: transparent;
}

.btn-soft-secondary {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.1);
  border-color: transparent;
}
.btn-soft-secondary:hover, .btn-soft-secondary:focus, .btn-soft-secondary:active {
  color: #fff;
  background-color: #3577f1;
  border-color: transparent;
}

.btn-soft-success {
  color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.1);
  border-color: transparent;
}
.btn-soft-success:hover, .btn-soft-success:focus, .btn-soft-success:active {
  color: #fff;
  background-color: #0ab39c;
  border-color: transparent;
}

.btn-soft-info {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1);
  border-color: transparent;
}
.btn-soft-info:hover, .btn-soft-info:focus, .btn-soft-info:active {
  color: #fff;
  background-color: #299cdb;
  border-color: transparent;
}

.btn-soft-warning {
  color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.1);
  border-color: transparent;
}
.btn-soft-warning:hover, .btn-soft-warning:focus, .btn-soft-warning:active {
  color: #fff;
  background-color: #f7b84b;
  border-color: transparent;
}

.btn-soft-danger {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1);
  border-color: transparent;
}
.btn-soft-danger:hover, .btn-soft-danger:focus, .btn-soft-danger:active {
  color: #fff;
  background-color: #f06548;
  border-color: transparent;
}

.btn-soft-light {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
  border-color: transparent;
}
.btn-soft-light:hover, .btn-soft-light:focus, .btn-soft-light:active {
  color: #fff;
  background-color: #f3f6f9;
  border-color: transparent;
}

.btn-soft-dark {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1);
  border-color: transparent;
}
.btn-soft-dark:hover, .btn-soft-dark:focus, .btn-soft-dark:active {
  color: #fff;
  background-color: #212529;
  border-color: transparent;
}

.btn-ghost-primary {
  color: #405189;
  border-color: transparent;
}
.btn-ghost-primary:hover, .btn-ghost-primary:focus, .btn-ghost-primary:active {
  color: #405189;
  background-color: rgba(64, 81, 137, 0.1);
  border-color: transparent;
}

.btn-ghost-secondary {
  color: #3577f1;
  border-color: transparent;
}
.btn-ghost-secondary:hover, .btn-ghost-secondary:focus, .btn-ghost-secondary:active {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.1);
  border-color: transparent;
}

.btn-ghost-success {
  color: #0ab39c;
  border-color: transparent;
}
.btn-ghost-success:hover, .btn-ghost-success:focus, .btn-ghost-success:active {
  color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.1);
  border-color: transparent;
}

.btn-ghost-info {
  color: #299cdb;
  border-color: transparent;
}
.btn-ghost-info:hover, .btn-ghost-info:focus, .btn-ghost-info:active {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1);
  border-color: transparent;
}

.btn-ghost-warning {
  color: #f7b84b;
  border-color: transparent;
}
.btn-ghost-warning:hover, .btn-ghost-warning:focus, .btn-ghost-warning:active {
  color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.1);
  border-color: transparent;
}

.btn-ghost-danger {
  color: #f06548;
  border-color: transparent;
}
.btn-ghost-danger:hover, .btn-ghost-danger:focus, .btn-ghost-danger:active {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1);
  border-color: transparent;
}

.btn-ghost-light {
  color: #f3f6f9;
  border-color: transparent;
}
.btn-ghost-light:hover, .btn-ghost-light:focus, .btn-ghost-light:active {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
  border-color: transparent;
}

.btn-ghost-dark {
  color: #212529;
  border-color: transparent;
}
.btn-ghost-dark:hover, .btn-ghost-dark:focus, .btn-ghost-dark:active {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1);
  border-color: transparent;
}

.btn-ghost-secondary {
  color: var(--vz-gray-700);
}

.btn-label {
  position: relative;
  padding-left: 44px;
}
.btn-label .label-icon {
  position: absolute;
  width: 35.5px;
  left: -1px;
  top: -1px;
  bottom: -1px;
  background-color: rgba(255, 255, 255, 0.1);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-label.btn-light .label-icon {
  background-color: rgba(33, 37, 41, 0.05);
}
.btn-label.right {
  padding-left: 0.9rem;
  padding-right: 44px;
}
.btn-label.right .label-icon {
  right: -1px;
  left: auto;
}

.btn-animation {
  overflow: hidden;
  transition: border-color 0.3s, background-color 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}
.btn-animation::after {
  content: attr(data-text);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  transform: translate3d(0, 25%, 0);
  padding: 0.5rem 0.9rem;
  transition: transform 0.3s, opacity 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}
.btn-animation > span {
  display: block;
  transition: transform 0.3s, opacity 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}
.btn-animation:hover::after {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}
.btn-animation:hover > span {
  opacity: 0;
  transform: translate3d(0, -25%, 0);
}

.btn-primary.btn-animation {
  background-color: #405189;
  border-color: #405189;
}
.btn-primary.btn-animation:hover, .btn-primary.btn-animation:focus, .btn-primary.btn-animation:active {
  color: #405189;
  background-color: rgba(64, 81, 137, 0.1);
}

.btn-secondary.btn-animation {
  background-color: #3577f1;
  border-color: #3577f1;
}
.btn-secondary.btn-animation:hover, .btn-secondary.btn-animation:focus, .btn-secondary.btn-animation:active {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.1);
}

.btn-success.btn-animation {
  background-color: #0ab39c;
  border-color: #0ab39c;
}
.btn-success.btn-animation:hover, .btn-success.btn-animation:focus, .btn-success.btn-animation:active {
  color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.1);
}

.btn-info.btn-animation {
  background-color: #299cdb;
  border-color: #299cdb;
}
.btn-info.btn-animation:hover, .btn-info.btn-animation:focus, .btn-info.btn-animation:active {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1);
}

.btn-warning.btn-animation {
  background-color: #f7b84b;
  border-color: #f7b84b;
}
.btn-warning.btn-animation:hover, .btn-warning.btn-animation:focus, .btn-warning.btn-animation:active {
  color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.1);
}

.btn-danger.btn-animation {
  background-color: #f06548;
  border-color: #f06548;
}
.btn-danger.btn-animation:hover, .btn-danger.btn-animation:focus, .btn-danger.btn-animation:active {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1);
}

.btn-light.btn-animation {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}
.btn-light.btn-animation:hover, .btn-light.btn-animation:focus, .btn-light.btn-animation:active {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
}

.btn-dark.btn-animation {
  background-color: #212529;
  border-color: #212529;
}
.btn-dark.btn-animation:hover, .btn-dark.btn-animation:focus, .btn-dark.btn-animation:active {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1);
}

.btn-group-vertical label {
  margin-bottom: 0;
}

.btn-group.radio .btn {
  border: none;
}
.btn-group.radio .btn-check:active + .btn-light,
.btn-group.radio .btn-check:checked + .btn-light,
.btn-group.radio .btn-light.active,
.btn-group.radio .btn-light.dropdown-toggle.show,
.btn-group.radio .btn-light:active {
  background-color: rgba(41, 156, 219, 0.2);
  color: #299cdb;
}

[data-layout-mode=dark] .btn-check:focus + .btn-light,
[data-layout-mode=dark] .btn-check:focus + .btn-outline-light,
[data-layout-mode=dark] .btn-check:focus + .btn-soft-light,
[data-layout-mode=dark] .btn-soft-light:focus {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.75);
  border-color: rgba(var(--vz-light-rgb), 0.75);
}
[data-layout-mode=dark] .btn-check:active + .btn-light,
[data-layout-mode=dark] .btn-check:active + .btn-outline-light,
[data-layout-mode=dark] .btn-check:active + .btn-soft-light,
[data-layout-mode=dark] .btn-check:checked + .btn-light,
[data-layout-mode=dark] .btn-check:checked + .btn-outline-light,
[data-layout-mode=dark] .btn-check:checked + .btn-soft-light,
[data-layout-mode=dark] .btn-light.active,
[data-layout-mode=dark] .btn-light:active,
[data-layout-mode=dark] .btn-outline-light.active,
[data-layout-mode=dark] .btn-outline-light:active,
[data-layout-mode=dark] .btn-soft-light.active,
[data-layout-mode=dark] .btn-soft-light:active,
[data-layout-mode=dark] .show > .btn-light.dropdown-toggle,
[data-layout-mode=dark] .show > .btn-outline-light.dropdown-toggle,
[data-layout-mode=dark] .show > .btn-soft-light.dropdown-toggle {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.75);
  border-color: rgba(var(--vz-light-rgb), 0.75);
}
[data-layout-mode=dark] .btn-check:focus + .btn-dark,
[data-layout-mode=dark] .btn-check:focus + .btn-outline-dark,
[data-layout-mode=dark] .btn-check:focus + .btn-soft-dark,
[data-layout-mode=dark] .btn-soft-dark:focus {
  color: var(--vz-light);
  background-color: rgba(var(--vz-dark-rgb), 0.75);
  border-color: rgba(var(--vz-dark-rgb), 0.75);
}
[data-layout-mode=dark] .btn-check:active + .btn-dark,
[data-layout-mode=dark] .btn-check:active + .btn-outline-dark,
[data-layout-mode=dark] .btn-check:active + .btn-soft-dark,
[data-layout-mode=dark] .btn-check:checked + .btn-dark,
[data-layout-mode=dark] .btn-check:checked + .btn-outline-dark,
[data-layout-mode=dark] .btn-check:checked + .btn-soft-dark,
[data-layout-mode=dark] .btn-dark.active,
[data-layout-mode=dark] .btn-dark:active,
[data-layout-mode=dark] .btn-outline-dark.active,
[data-layout-mode=dark] .btn-outline-dark:active,
[data-layout-mode=dark] .btn-soft-dark.active,
[data-layout-mode=dark] .btn-soft-dark:active,
[data-layout-mode=dark] .show > .btn-dark.dropdown-toggle,
[data-layout-mode=dark] .show > .btn-outline-dark.dropdown-toggle,
[data-layout-mode=dark] .show > .btn-soft-dark.dropdown-toggle {
  color: var(--vz-light);
  background-color: rgba(var(--vz-dark-rgb), 0.75);
  border-color: rgba(var(--vz-dark-rgb), 0.75);
}
[data-layout-mode=dark] .btn-soft-light {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.1);
}
[data-layout-mode=dark] .btn-soft-light:hover {
  color: var(--vz-dark);
  background-color: var(--vz-light);
}
[data-layout-mode=dark] .btn-soft-dark {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-dark-rgb), 0.1);
}
[data-layout-mode=dark] .btn-soft-dark:hover {
  color: var(--vz-light);
  background-color: var(--vz-dark);
}
[data-layout-mode=dark] .btn-ghost-light {
  color: var(--vz-dark);
}
[data-layout-mode=dark] .btn-ghost-light:hover, [data-layout-mode=dark] .btn-ghost-light:focus, [data-layout-mode=dark] .btn-ghost-light:active {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.5);
}
[data-layout-mode=dark] .btn-ghost-dark {
  color: var(--vz-dark);
}
[data-layout-mode=dark] .btn-ghost-dark:hover, [data-layout-mode=dark] .btn-ghost-dark:focus, [data-layout-mode=dark] .btn-ghost-dark:active {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-dark-rgb), 0.1);
}

.btn-load .spinner-border,
.btn-load .spinner-grow {
  height: 19px;
  width: 19px;
}

.btn-primary.btn-border,
.btn-outline-primary.btn-border,
.btn-soft-primary.btn-border {
  border-bottom: 2px solid rgb(51.0089552239, 64.5582089552, 109.1910447761);
}

.btn-secondary.btn-border,
.btn-outline-secondary.btn-border,
.btn-soft-secondary.btn-border {
  border-bottom: 2px solid rgb(16.4111111111, 93.7777777778, 236.7888888889);
}

.btn-success.btn-border,
.btn-outline-success.btn-border,
.btn-soft-success.btn-border {
  border-bottom: 2px solid rgb(7.8412698413, 140.3587301587, 122.3238095238);
}

.btn-info.btn-border,
.btn-outline-info.btn-border,
.btn-soft-info.btn-border {
  border-bottom: 2px solid rgb(31.5648, 132.3968, 187.6352);
}

.btn-warning.btn-border,
.btn-outline-warning.btn-border,
.btn-soft-warning.btn-border {
  border-bottom: 2px solid rgb(245.2638297872, 168.5914893617, 35.9361702128);
}

.btn-danger.btn-border,
.btn-outline-danger.btn-border,
.btn-soft-danger.btn-border {
  border-bottom: 2px solid rgb(236.9090909091, 69.2666666667, 34.2909090909);
}

.btn-light.btn-border,
.btn-outline-light.btn-border,
.btn-soft-light.btn-border {
  border-bottom: 2px solid rgb(215.8, 225.6, 235.4);
}

.btn-dark.btn-border,
.btn-outline-dark.btn-border,
.btn-soft-dark.btn-border {
  border-bottom: 2px solid rgb(14.8054054054, 16.6, 18.3945945946);
}

.custom-toggle .icon-off {
  display: none;
}
.custom-toggle.active .icon-on {
  display: none;
}
.custom-toggle.active .icon-off {
  display: block;
}

.breadcrumb-item > a {
  color: var(--vz-gray-700);
}
.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
  font-size: 11px;
}

.card {
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
}

.card-header {
  border-bottom: 1px solid var(--vz-border-color);
}

.card-header-dropdown .dropdown-btn {
  padding: 1rem 0;
}

.card-footer {
  border-top: 1px solid var(--vz-border-color);
}

.card-drop {
  color: #212529;
}

.card-title {
  font-size: 16px;
  margin: 0 0 7px 0;
}

.card-title-desc {
  margin-bottom: 24px;
}

.card-height-100 {
  height: calc(100% - 1.5rem);
}

.card-animate {
  transition: all 0.4s;
}
.card-animate:hover {
  transform: translateY(calc(-1.5rem / 5));
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}

.card-primary {
  color: #fff;
  background-color: #405189;
}
.card-primary .card-header, .card-primary .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-primary .card-title {
  color: #fff;
}

.card-secondary {
  color: #fff;
  background-color: #3577f1;
}
.card-secondary .card-header, .card-secondary .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-secondary .card-title {
  color: #fff;
}

.card-success {
  color: #fff;
  background-color: #0ab39c;
}
.card-success .card-header, .card-success .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-success .card-title {
  color: #fff;
}

.card-info {
  color: #fff;
  background-color: #299cdb;
}
.card-info .card-header, .card-info .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-info .card-title {
  color: #fff;
}

.card-warning {
  color: #fff;
  background-color: #f7b84b;
}
.card-warning .card-header, .card-warning .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-warning .card-title {
  color: #fff;
}

.card-danger {
  color: #fff;
  background-color: #f06548;
}
.card-danger .card-header, .card-danger .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-danger .card-title {
  color: #fff;
}

.card-light {
  color: #fff;
  background-color: #f3f6f9;
}
.card-light .card-header, .card-light .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-light .card-title {
  color: #fff;
}

.card-dark {
  color: #fff;
  background-color: #212529;
}
.card-dark .card-header, .card-dark .card-footer {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}
.card-dark .card-title {
  color: #fff;
}

.card-border-primary {
  border-color: #405189 !important;
}
.card-border-primary .card-header, .card-border-primary .card-footer {
  border-color: #405189;
}

.card-border-secondary {
  border-color: #3577f1 !important;
}
.card-border-secondary .card-header, .card-border-secondary .card-footer {
  border-color: #3577f1;
}

.card-border-success {
  border-color: #0ab39c !important;
}
.card-border-success .card-header, .card-border-success .card-footer {
  border-color: #0ab39c;
}

.card-border-info {
  border-color: #299cdb !important;
}
.card-border-info .card-header, .card-border-info .card-footer {
  border-color: #299cdb;
}

.card-border-warning {
  border-color: #f7b84b !important;
}
.card-border-warning .card-header, .card-border-warning .card-footer {
  border-color: #f7b84b;
}

.card-border-danger {
  border-color: #f06548 !important;
}
.card-border-danger .card-header, .card-border-danger .card-footer {
  border-color: #f06548;
}

.card-border-light {
  border-color: #f3f6f9 !important;
}
.card-border-light .card-header, .card-border-light .card-footer {
  border-color: #f3f6f9;
}

.card-border-dark {
  border-color: #212529 !important;
}
.card-border-dark .card-header, .card-border-dark .card-footer {
  border-color: #212529;
}

.card-light {
  background-color: var(--vz-light);
}
.card-light .card-header, .card-light .card-footer {
  color: var(--vz-body-color) !important;
  background-color: rgba(var(--vz-dark-rgb), 0.1);
}
.card-light .card-title, .card-light .card-text {
  color: var(--vz-body-color) !important;
}

.stretched-link {
  position: static;
}

.card-preloader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(var(--vz-light-rgb), 0.6);
  z-index: 9999;
}

.card-status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) !important;
}

.custom-loader {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.card-overlay {
  position: relative;
  overflow: hidden;
}
.card-overlay:before {
  content: "";
  background-color: rgba(64, 81, 137, 0.2);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}
.card-overlay .card-header, .card-overlay .card-footer {
  border-color: rgba(255, 255, 255, 0.15) !important;
}

.card-toolbar-menu {
  line-height: 0.8;
}
.card-toolbar-menu a {
  font-size: 17px;
}
.card-toolbar-menu .minimize-card .plus {
  display: none;
}
.card-toolbar-menu .minimize-card .minus {
  display: block;
}
.card-toolbar-menu .minimize-card.collapsed .plus {
  display: block;
}
.card-toolbar-menu .minimize-card.collapsed .minus {
  display: none;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  font-size: 15px;
  line-height: 15px;
  content: "\\f0140";
  font-family: "Material Design Icons";
}

.dropdown-menu {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  position: absolute;
  z-index: 1000;
}
.dropdown-menu.dropdown-megamenu {
  padding: 20px;
  left: 0 !important;
  right: 0 !important;
}
.dropdown-menu[data-popper-placement=top-start] {
  animation-name: DropDownSlideDown;
}

@keyframes DropDownSlide {
  100% {
    margin-top: -1px;
  }
  0% {
    margin-top: 8px;
  }
}
@keyframes DropDownSlideDown {
  100% {
    margin-bottom: 0;
  }
  0% {
    margin-bottom: 8px;
  }
}
@media (min-width: 600px) {
  .dropdown-menu-xl {
    width: 420px;
  }
  .dropdown-menu-lg {
    width: 320px;
  }
  .dropdown-menu-md {
    width: 240px;
  }
}
.dropdown-toggle-split {
  border-left: none;
}
.dropdown-toggle-split::after {
  margin-left: 0px;
}
.dropdown-toggle-split:before {
  content: "";
  position: absolute;
  background-color: rgba(255, 255, 255, 0.12);
  top: -1px;
  bottom: -1px;
  right: -1px;
  left: 0;
  border-radius: 0 0.25rem 0.25rem 0;
}

.dropdown-mega {
  position: static !important;
}

.dropdown-mega-menu-xl {
  width: 38rem;
}

.dropdown-mega-menu-lg {
  width: 26rem;
}

[dir=ltr] .dropdown-menu-start {
  --bs-position: end;
}
[dir=ltr] .dropdown-menu-end {
  --bs-position: start;
}

.dropdown-head .nav-tabs-custom {
  border: 0;
}
.dropdown-head .nav-tabs-custom .nav-link {
  color: rgba(255, 255, 255, 0.6);
}
.dropdown-head .nav-tabs-custom .nav-link.active {
  background-color: var(--vz-dropdown-bg);
}
.dropdown-head .nav-tabs-custom .nav-link:hover {
  color: #fff;
}

.dropdownmenu-primary .dropdown-item:focus, .dropdownmenu-primary .dropdown-item:hover, .dropdownmenu-primary .dropdown-item.active {
  background-color: rgba(64, 81, 137, 0.07);
  color: #405189;
}

.dropdownmenu-secondary .dropdown-item:focus, .dropdownmenu-secondary .dropdown-item:hover, .dropdownmenu-secondary .dropdown-item.active {
  background-color: rgba(53, 119, 241, 0.07);
  color: #3577f1;
}

.dropdownmenu-success .dropdown-item:focus, .dropdownmenu-success .dropdown-item:hover, .dropdownmenu-success .dropdown-item.active {
  background-color: rgba(10, 179, 156, 0.07);
  color: #0ab39c;
}

.dropdownmenu-info .dropdown-item:focus, .dropdownmenu-info .dropdown-item:hover, .dropdownmenu-info .dropdown-item.active {
  background-color: rgba(41, 156, 219, 0.07);
  color: #299cdb;
}

.dropdownmenu-warning .dropdown-item:focus, .dropdownmenu-warning .dropdown-item:hover, .dropdownmenu-warning .dropdown-item.active {
  background-color: rgba(247, 184, 75, 0.07);
  color: #f7b84b;
}

.dropdownmenu-danger .dropdown-item:focus, .dropdownmenu-danger .dropdown-item:hover, .dropdownmenu-danger .dropdown-item.active {
  background-color: rgba(240, 101, 72, 0.07);
  color: #f06548;
}

.dropdownmenu-light .dropdown-item:focus, .dropdownmenu-light .dropdown-item:hover, .dropdownmenu-light .dropdown-item.active {
  background-color: rgba(243, 246, 249, 0.07);
  color: #f3f6f9;
}

.dropdownmenu-dark .dropdown-item:focus, .dropdownmenu-dark .dropdown-item:hover, .dropdownmenu-dark .dropdown-item.active {
  background-color: rgba(33, 37, 41, 0.07);
  color: #212529;
}

.nav-tabs > li > a,
.nav-pills > li > a {
  color: var(--vz-gray-700);
  font-weight: 500;
}

.nav-pills > a {
  color: var(--vz-gray-700);
  font-weight: 500;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  box-shadow: none;
}

.nav-tabs-custom {
  border-bottom: 1px solid var(--vz-gray-300);
}
.nav-tabs-custom .nav-item {
  position: relative;
}
.nav-tabs-custom .nav-item .nav-link {
  border: none;
  font-weight: 500;
}
.nav-tabs-custom .nav-item .nav-link::after {
  content: "";
  background: #405189;
  height: 1px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  transition: all 250ms ease 0s;
  transform: scale(0);
}
.nav-tabs-custom .nav-item .nav-link.active {
  color: #405189;
}
.nav-tabs-custom .nav-item .nav-link.active:after {
  transform: scale(1);
}
.nav-tabs-custom.card-header-tabs {
  margin-top: -1rem;
}
.nav-tabs-custom.card-header-tabs .nav-link {
  padding: 1rem 1rem;
}

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px;
}
.vertical-nav .nav .nav-link .nav-icon {
  font-size: 24px;
}

.navtab-bg li > a {
  background-color: #e9ebec;
  margin: 0 5px;
}

.arrow-navtabs .nav-item .nav-link {
  position: relative;
  text-align: center;
}
.arrow-navtabs .nav-item .nav-link:before {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .arrow-navtabs .nav-item .nav-link:before {
    transition: none;
  }
}
.arrow-navtabs .nav-item .nav-link.active:before {
  border-top-color: #405189;
}

.custom-hover-nav-tabs .nav-item {
  text-align: center;
  overflow: hidden;
}
.custom-hover-nav-tabs .nav-item .nav-link {
  width: 120px;
  height: 45px;
  position: relative;
  border-radius: 0px;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-icon {
  font-size: 22px;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-titl {
  font-size: 14px;
}
.custom-hover-nav-tabs .nav-item .nav-link.active .nav-tab-position {
  color: #fff;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position {
  position: absolute;
  left: 0;
  right: 0;
  transition: all 0.4s;
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-icon {
  top: 50%;
  transform: translateY(-50%);
}
.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-titl {
  bottom: -20px;
}
.custom-hover-nav-tabs .nav-item .nav-link:hover .nav-titl {
  bottom: 50%;
  transform: translateY(50%);
}
.custom-hover-nav-tabs .nav-item .nav-link:hover .nav-icon {
  top: -20px;
}

.custom-verti-nav-pills .nav-link {
  background-color: var(--vz-light);
  margin-top: 7px;
  position: relative;
}
@media (min-width: 992px) {
  .custom-verti-nav-pills .nav-link::before {
    content: "";
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    border: 12px solid transparent;
    border-left-color: transparent;
    transition: border-left-color 0.04 ease;
  }
  .custom-verti-nav-pills .nav-link.active::before {
    border-left-color: #405189;
  }
}

.animation-nav li {
  position: relative;
}
.animation-nav li a {
  color: var(--vz-body-color);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  transition: all 0.4s;
  z-index: 1;
}
.animation-nav li a span {
  position: relative;
}
.animation-nav li a::before {
  content: "";
  position: absolute;
  top: 0;
  width: 0;
  right: 0;
  height: 100%;
  transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;
  background-color: #405189;
  z-index: -1;
}
.animation-nav li a:hover, .animation-nav li a.active {
  color: #fff;
  background-color: transparent !important;
}
.animation-nav li a:hover::before, .animation-nav li a.active::before {
  width: 100%;
  left: 0;
}

.nav-border-top .nav-link {
  border-top: 3px solid transparent;
}
.nav-border-top .nav-link.active {
  border-top-color: #405189;
}

.nav-border-top-primary .nav-link.active {
  color: #405189;
  border-top-color: #405189;
}

.nav-border-top-secondary .nav-link.active {
  color: #3577f1;
  border-top-color: #3577f1;
}

.nav-border-top-success .nav-link.active {
  color: #0ab39c;
  border-top-color: #0ab39c;
}

.nav-border-top-info .nav-link.active {
  color: #299cdb;
  border-top-color: #299cdb;
}

.nav-border-top-warning .nav-link.active {
  color: #f7b84b;
  border-top-color: #f7b84b;
}

.nav-border-top-danger .nav-link.active {
  color: #f06548;
  border-top-color: #f06548;
}

.nav-border-top-light .nav-link.active {
  color: #f3f6f9;
  border-top-color: #f3f6f9;
}

.nav-border-top-dark .nav-link.active {
  color: #212529;
  border-top-color: #212529;
}

.nav-custom {
  background-color: #405189;
  border-radius: 0.25rem;
}
.nav-custom .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.75);
}
.nav-custom .nav-item .nav-link.active {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}
.nav-custom.nav-custom-light .nav-item .nav-link {
  color: rgba(var(--vz-dark-rgb), 0.75);
}
.nav-custom.nav-custom-light .nav-item .nav-link.active {
  color: #f3f6f9;
  background-color: #405189;
}

.nav-custom-primary {
  background-color: #405189;
}

.nav-custom-secondary {
  background-color: #3577f1;
}

.nav-custom-success {
  background-color: #0ab39c;
}

.nav-custom-info {
  background-color: #299cdb;
}

.nav-custom-warning {
  background-color: #f7b84b;
}

.nav-custom-danger {
  background-color: #f06548;
}

.nav-custom-light {
  background-color: #f3f6f9;
}

.nav-custom-dark {
  background-color: #212529;
}

.nav-custom-light {
  background-color: var(--vz-light);
}

.nav-primary .nav-link.active {
  color: #fff;
  background-color: #405189;
}
.nav-primary.nav-tabs .nav-link.active {
  color: #405189;
  background-color: var(--vz-card-bg-custom);
}
.nav-primary.nav-tabs-custom .nav-link.active {
  color: #405189;
  background-color: var(--vz-card-bg-custom);
}
.nav-primary.nav-tabs-custom .nav-link.active::after {
  background-color: #405189;
}
.nav-primary.arrow-navtabs .nav-link.active::before {
  border-top-color: #405189;
}
.nav-primary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #405189;
}

.nav-secondary .nav-link.active {
  color: #fff;
  background-color: #3577f1;
}
.nav-secondary.nav-tabs .nav-link.active {
  color: #3577f1;
  background-color: var(--vz-card-bg-custom);
}
.nav-secondary.nav-tabs-custom .nav-link.active {
  color: #3577f1;
  background-color: var(--vz-card-bg-custom);
}
.nav-secondary.nav-tabs-custom .nav-link.active::after {
  background-color: #3577f1;
}
.nav-secondary.arrow-navtabs .nav-link.active::before {
  border-top-color: #3577f1;
}
.nav-secondary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #3577f1;
}

.nav-success .nav-link.active {
  color: #fff;
  background-color: #0ab39c;
}
.nav-success.nav-tabs .nav-link.active {
  color: #0ab39c;
  background-color: var(--vz-card-bg-custom);
}
.nav-success.nav-tabs-custom .nav-link.active {
  color: #0ab39c;
  background-color: var(--vz-card-bg-custom);
}
.nav-success.nav-tabs-custom .nav-link.active::after {
  background-color: #0ab39c;
}
.nav-success.arrow-navtabs .nav-link.active::before {
  border-top-color: #0ab39c;
}
.nav-success.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #0ab39c;
}

.nav-info .nav-link.active {
  color: #fff;
  background-color: #299cdb;
}
.nav-info.nav-tabs .nav-link.active {
  color: #299cdb;
  background-color: var(--vz-card-bg-custom);
}
.nav-info.nav-tabs-custom .nav-link.active {
  color: #299cdb;
  background-color: var(--vz-card-bg-custom);
}
.nav-info.nav-tabs-custom .nav-link.active::after {
  background-color: #299cdb;
}
.nav-info.arrow-navtabs .nav-link.active::before {
  border-top-color: #299cdb;
}
.nav-info.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #299cdb;
}

.nav-warning .nav-link.active {
  color: #fff;
  background-color: #f7b84b;
}
.nav-warning.nav-tabs .nav-link.active {
  color: #f7b84b;
  background-color: var(--vz-card-bg-custom);
}
.nav-warning.nav-tabs-custom .nav-link.active {
  color: #f7b84b;
  background-color: var(--vz-card-bg-custom);
}
.nav-warning.nav-tabs-custom .nav-link.active::after {
  background-color: #f7b84b;
}
.nav-warning.arrow-navtabs .nav-link.active::before {
  border-top-color: #f7b84b;
}
.nav-warning.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f7b84b;
}

.nav-danger .nav-link.active {
  color: #fff;
  background-color: #f06548;
}
.nav-danger.nav-tabs .nav-link.active {
  color: #f06548;
  background-color: var(--vz-card-bg-custom);
}
.nav-danger.nav-tabs-custom .nav-link.active {
  color: #f06548;
  background-color: var(--vz-card-bg-custom);
}
.nav-danger.nav-tabs-custom .nav-link.active::after {
  background-color: #f06548;
}
.nav-danger.arrow-navtabs .nav-link.active::before {
  border-top-color: #f06548;
}
.nav-danger.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f06548;
}

.nav-light .nav-link.active {
  color: #fff;
  background-color: #f3f6f9;
}
.nav-light.nav-tabs .nav-link.active {
  color: #f3f6f9;
  background-color: var(--vz-card-bg-custom);
}
.nav-light.nav-tabs-custom .nav-link.active {
  color: #f3f6f9;
  background-color: var(--vz-card-bg-custom);
}
.nav-light.nav-tabs-custom .nav-link.active::after {
  background-color: #f3f6f9;
}
.nav-light.arrow-navtabs .nav-link.active::before {
  border-top-color: #f3f6f9;
}
.nav-light.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f3f6f9;
}

.nav-dark .nav-link.active {
  color: #fff;
  background-color: #212529;
}
.nav-dark.nav-tabs .nav-link.active {
  color: #212529;
  background-color: var(--vz-card-bg-custom);
}
.nav-dark.nav-tabs-custom .nav-link.active {
  color: #212529;
  background-color: var(--vz-card-bg-custom);
}
.nav-dark.nav-tabs-custom .nav-link.active::after {
  background-color: #212529;
}
.nav-dark.arrow-navtabs .nav-link.active::before {
  border-top-color: #212529;
}
.nav-dark.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #212529;
}

.progress-nav {
  position: relative;
  margin-right: 1rem;
  margin-left: 1rem;
}
.progress-nav .progress {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
.progress-nav .nav {
  margin-right: -1rem;
  margin-left: -1rem;
  justify-content: space-between;
}
.progress-nav .nav .nav-link {
  width: 2rem;
  height: 2rem;
  background-color: var(--vz-light);
  padding: 0;
  color: var(--vz-dark);
  font-weight: 500;
}
.progress-nav .nav .nav-link.active, .progress-nav .nav .nav-link.done {
  background-color: #405189;
  color: #fff;
}

.step-arrow-nav .nav {
  background-color: var(--vz-light);
}
.step-arrow-nav .nav .nav-link {
  border-radius: 0;
  position: relative;
  font-weight: 500;
  color: var(--vz-dark);
}
.step-arrow-nav .nav .nav-link::before {
  content: "";
  position: absolute;
  border: 7px solid transparent;
  right: -14px;
  top: 50%;
  transform: translateY(-50%);
}
.step-arrow-nav .nav .nav-link.done {
  background-color: rgba(64, 81, 137, 0.05);
  color: #405189;
}
.step-arrow-nav .nav .nav-link.done::before {
  border-left-color: transparent;
}
.step-arrow-nav .nav .nav-link.active {
  background-color: rgba(64, 81, 137, 0.1);
  color: #405189;
  box-shadow: none;
}
.step-arrow-nav .nav .nav-link.active::before {
  border-left-color: rgba(64, 81, 137, 0.1);
}
.step-arrow-nav .nav .nav-item:last-child .nav-link:before {
  display: none;
}

.vertical-navs-step .nav {
  gap: 16px;
}
.vertical-navs-step .nav .nav-link {
  text-align: left;
  background-color: rgba(var(--vz-light-rgb), 0.4);
  border: 1px solid var(--vz-border-color);
  color: var(--vz-dark);
}
.vertical-navs-step .nav .nav-link .step-title {
  font-weight: 600;
}
.vertical-navs-step .nav .nav-link .step-icon {
  color: #f06548;
  vertical-align: middle;
  font-weight: 500;
  float: left;
}
.vertical-navs-step .nav .nav-link.active .step-icon, .vertical-navs-step .nav .nav-link.done .step-icon {
  color: #0ab39c;
}
.vertical-navs-step .nav .nav-link.active .step-icon:before, .vertical-navs-step .nav .nav-link.done .step-icon:before {
  content: "\\eb80";
}
.vertical-navs-step .nav .nav-link.active {
  border-color: #405189;
}
.vertical-navs-step .nav .nav-link.done {
  border-color: #0ab39c;
}

.nav-custom-outline.nav .nav-link {
  border: 1px solid transparent;
  border-bottom: 2px solid transparent;
}
.nav-custom-outline.nav .nav-link.active {
  border-color: #405189;
  background-color: transparent;
  color: #405189;
}

.nav-primary.nav-custom-outline .nav-link.active {
  color: #405189;
  border-color: #405189;
}

.nav-secondary.nav-custom-outline .nav-link.active {
  color: #3577f1;
  border-color: #3577f1;
}

.nav-success.nav-custom-outline .nav-link.active {
  color: #0ab39c;
  border-color: #0ab39c;
}

.nav-info.nav-custom-outline .nav-link.active {
  color: #299cdb;
  border-color: #299cdb;
}

.nav-warning.nav-custom-outline .nav-link.active {
  color: #f7b84b;
  border-color: #f7b84b;
}

.nav-danger.nav-custom-outline .nav-link.active {
  color: #f06548;
  border-color: #f06548;
}

.nav-light.nav-custom-outline .nav-link.active {
  color: #f3f6f9;
  border-color: #f3f6f9;
}

.nav-dark.nav-custom-outline .nav-link.active {
  color: #212529;
  border-color: #212529;
}

.nav-customs.nav {
  padding-left: 34px;
  overflow: hidden;
}
.nav-customs.nav .nav-link {
  position: relative;
  display: block;
  float: right;
  background-color: var(--vz-body-bg);
  margin-right: 46px;
  transition: all 0.5s ease;
}
.nav-customs.nav .nav-link::before, .nav-customs.nav .nav-link::after {
  display: block;
  content: " ";
  position: absolute;
  top: -1px;
  bottom: -1px;
  width: 37px;
  background-color: var(--vz-body-bg);
  transition: all 0.5s ease;
}
.nav-customs.nav .nav-link::before {
  border-radius: 0 8px 0 0;
  right: -24px;
  transform: skew(30deg, 0deg);
}
.nav-customs.nav .nav-link::after {
  border-radius: 8px 0 0 0;
  left: -24px;
  transform: skew(-30deg, 0deg);
}
.nav-customs.nav .nav-link.active, .nav-customs.nav .nav-link.active:before, .nav-customs.nav .nav-link.active:after {
  background-color: #405189;
  color: #fff;
}
.nav-customs.nav .nav-link.active {
  z-index: 1;
}

.table th {
  font-weight: 600;
}
.table > thead {
  border-color: var(--vz-border-color);
}
.table > :not(:first-child) {
  border-top-width: 1px;
}

.table-nowrap th,
.table-nowrap td {
  white-space: nowrap;
}

.table-card {
  margin: -1rem -1rem;
}
.table-card th:first-child,
.table-card td:first-child {
  padding-left: 16px;
}
.table-card th:last-child,
.table-card td:last-child {
  padding-right: 16px;
}
.table-card .table > :not(:first-child) {
  border-top-width: 1px;
}

.border-primary.table > thead {
  border-color: #405189 !important;
}

.table-primary.table > thead {
  border-bottom-color: rgb(80.2388059701, 101.552238806, 171.7611940299) !important;
}

.border-secondary.table > thead {
  border-color: #3577f1 !important;
}

.table-secondary.table > thead {
  border-bottom-color: rgb(100.6944444444, 151.1111111111, 244.3055555556) !important;
}

.border-success.table > thead {
  border-color: #0ab39c !important;
}

.table-success.table > thead {
  border-bottom-color: rgb(12.6984126984, 227.3015873016, 198.0952380952) !important;
}

.border-info.table > thead {
  border-color: #299cdb !important;
}

.table-info.table > thead {
  border-bottom-color: rgb(84.656, 176.196, 226.344) !important;
}

.border-warning.table > thead {
  border-color: #f7b84b !important;
}

.table-warning.table > thead {
  border-bottom-color: rgb(249.170212766, 203.2606382979, 123.829787234) !important;
}

.border-danger.table > thead {
  border-color: #f06548 !important;
}

.table-danger.table > thead {
  border-bottom-color: rgb(243.8636363636, 140.6666666667, 119.1363636364) !important;
}

.border-light.table > thead {
  border-color: #f3f6f9 !important;
}

.table-light.table > thead {
  border-bottom-color: white !important;
}

.border-dark.table > thead {
  border-color: #212529 !important;
}

.table-dark.table > thead {
  border-bottom-color: rgb(55.7432432432, 62.5, 69.2567567568) !important;
}

.table .form-check {
  padding-left: 0px;
  margin-bottom: 0px;
}
.table .form-check .form-check-input {
  margin-left: 0px;
  margin-top: 0px;
  float: none;
  vertical-align: middle;
}
.table .sort {
  position: relative;
}
.table .sort::before {
  content: "\\f035d";
  position: absolute;
  right: 0.5rem;
  top: 18px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}
.table .sort::after {
  position: absolute;
  right: 0.5rem;
  content: "\\f0360";
  font-family: "Material Design Icons";
  font-size: 0.8rem;
  top: 12px;
}

[data-layout-mode=dark] .table-light {
  background-color: var(--vz-light);
  color: var(--vz-body-color);
}
[data-layout-mode=dark] .table-light th, [data-layout-mode=dark] .table-light td {
  background-color: var(--vz-light);
}

.rdt_Table.eSTlnH {
  background-color: var(--vz-card-bg) !important;
  color: var(--vz-body-color);
}
.rdt_Table .gZWIKX,
.rdt_Table .jVeafb {
  color: var(--vz-body-color);
  background-color: var(--vz-card-bg);
}
.rdt_Table .jVeafb:not(:last-of-type),
.rdt_Table .gZWIKX {
  border-bottom-color: var(--vz-border-color);
}

.rdt_Pagination.jxflYm {
  background-color: var(--vz-card-bg);
  color: var(--vz-body-color);
  border-top-color: var(--vz-border-color);
}
.rdt_Pagination .bvxQGL {
  fill: var(--vz-dark);
}
.rdt_Pagination .bvxQGL:disabled {
  fill: rgba(var(--vz-dark-rgb), 0.25);
}

.modal-title {
  font-weight: 600;
}

.modal-dialog:not(.modal-dialog-scrollable) .modal-header {
  padding-bottom: 0;
}
.modal-dialog:not(.modal-dialog-scrollable) .modal-header .btn-close {
  margin-top: -1.25rem 1.25rem;
}
.modal-dialog:not(.modal-dialog-scrollable) .modal-footer {
  padding-top: 0;
}

.modal.fadeInRight .modal-dialog {
  opacity: 0;
  transform: translateX(20%);
  transition: all 0.3s ease-in-out;
}
.modal.fadeInRight.show .modal-dialog {
  opacity: 1;
  transform: translateX(0);
}
.modal.fadeInLeft .modal-dialog {
  animation: fadeInLeft 0.3s ease-in-out;
  transform: translate(-50%, 0);
}
.modal.fadeInLeft.show .modal-dialog {
  transform: none;
}
.modal.fadeInUp .modal-dialog {
  animation: fadeInUp 0.3s ease-in-out;
  transform: translate(0, 30%);
}
.modal.fadeInUp.show .modal-dialog {
  transform: none;
}
.modal.flip {
  perspective: 1300px;
}
.modal.flip .modal-dialog {
  opacity: 0;
  transform: rotateY(-70deg);
  transition: all 0.3s;
}
.modal.flip.show .modal-dialog {
  opacity: 1;
  transform: rotateY(0deg);
}
.modal.zoomIn .modal-dialog {
  opacity: 0;
  transform: scale(0.7);
  transition: all 0.3s ease;
}
.modal.zoomIn.show .modal-dialog {
  opacity: 1;
  transform: scale(1);
}

.modal-dialog-right {
  margin-right: 1.75rem;
}

.modal-dialog-bottom {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem);
}
@media (min-width: 576px) {
  .modal-dialog-bottom {
    min-height: calc(100% - 3.5rem);
  }
}

.modal-dialog-bottom-right {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem);
  margin-right: 1.75rem;
}
@media (min-width: 576px) {
  .modal-dialog-bottom-right {
    min-height: calc(100% - 3.5rem);
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translateZ(0);
  }
}
@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 30%, 0);
  }
  to {
    opacity: 1;
    transform: translateZ(0);
  }
}
@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  50% {
    opacity: 1;
  }
}
.login-modal {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  background-size: cover;
  background-position: center;
}

.pagination-separated .page-item .page-link {
  margin-left: 0.35rem;
  border-radius: 0.25rem;
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px !important;
  border: none;
  min-width: 32px;
  min-height: 32px;
  text-align: center;
}
.pagination-rounded.pagination-sm .page-link {
  min-width: 25px;
  min-height: 25px;
}

.page-item.active .page-link {
  box-shadow: none;
}

.progress-sm {
  height: 5px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 16px;
}

.custom-progess {
  position: relative;
}
.custom-progess .progress-icon {
  position: absolute;
  top: -12px;
}
.custom-progess .progress-icon .avatar-title {
  background: var(--vz-card-bg-custom);
}

.animated-progress {
  position: relative;
}
.animated-progress .progress-bar {
  position: relative;
  border-radius: 6px;
  animation: animate-positive 2s;
}

@keyframes animate-positive {
  0% {
    width: 0;
  }
}
.custom-progress {
  height: 15px;
  padding: 4px;
  border-radius: 30px;
}
.custom-progress .progress-bar {
  position: relative;
  border-radius: 30px;
}
.custom-progress .progress-bar::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  background-color: #fff;
  border-radius: 7px;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
}

.progress-label {
  overflow: visible;
}
.progress-label .progress-bar {
  position: relative;
  overflow: visible;
}
.progress-label .progress-bar .label {
  position: absolute;
  top: -25px;
  right: -9px;
  background-color: #405189;
  color: #fff;
  display: inline-block;
  line-height: 18px;
  padding: 0 4px;
  border-radius: 4px;
}
.progress-label .progress-bar .label:after {
  content: "";
  position: absolute;
  border: 4px solid transparent;
  border-top-color: #405189;
  bottom: -7px;
  left: 50%;
  transform: translateX(-50%);
}

.progress-step-arrow {
  height: 3.25rem;
}
.progress-step-arrow .progress-bar {
  position: relative;
  overflow: initial;
  font-size: 0.875rem;
  color: #fff;
}
.progress-step-arrow .progress-bar::after {
  content: "";
  position: absolute;
  border: 10px solid transparent;
  bottom: 15px;
  right: -20px;
  z-index: 1;
}

.progress-primary .progress-bar {
  background-color: #405189;
}
.progress-primary .progress-bar::after {
  border-left-color: #405189;
}
.progress-primary .progress-bar:nth-child(2) {
  background-color: rgba(64, 81, 137, 0.1) !important;
  color: #405189 !important;
}
.progress-primary .progress-bar:nth-child(2)::after {
  border-left-color: rgba(64, 81, 137, 0.1);
}

.progress-secondary .progress-bar {
  background-color: #3577f1;
}
.progress-secondary .progress-bar::after {
  border-left-color: #3577f1;
}
.progress-secondary .progress-bar:nth-child(2) {
  background-color: rgba(53, 119, 241, 0.1) !important;
  color: #3577f1 !important;
}
.progress-secondary .progress-bar:nth-child(2)::after {
  border-left-color: rgba(53, 119, 241, 0.1);
}

.progress-success .progress-bar {
  background-color: #0ab39c;
}
.progress-success .progress-bar::after {
  border-left-color: #0ab39c;
}
.progress-success .progress-bar:nth-child(2) {
  background-color: rgba(10, 179, 156, 0.1) !important;
  color: #0ab39c !important;
}
.progress-success .progress-bar:nth-child(2)::after {
  border-left-color: rgba(10, 179, 156, 0.1);
}

.progress-info .progress-bar {
  background-color: #299cdb;
}
.progress-info .progress-bar::after {
  border-left-color: #299cdb;
}
.progress-info .progress-bar:nth-child(2) {
  background-color: rgba(41, 156, 219, 0.1) !important;
  color: #299cdb !important;
}
.progress-info .progress-bar:nth-child(2)::after {
  border-left-color: rgba(41, 156, 219, 0.1);
}

.progress-warning .progress-bar {
  background-color: #f7b84b;
}
.progress-warning .progress-bar::after {
  border-left-color: #f7b84b;
}
.progress-warning .progress-bar:nth-child(2) {
  background-color: rgba(247, 184, 75, 0.1) !important;
  color: #f7b84b !important;
}
.progress-warning .progress-bar:nth-child(2)::after {
  border-left-color: rgba(247, 184, 75, 0.1);
}

.progress-danger .progress-bar {
  background-color: #f06548;
}
.progress-danger .progress-bar::after {
  border-left-color: #f06548;
}
.progress-danger .progress-bar:nth-child(2) {
  background-color: rgba(240, 101, 72, 0.1) !important;
  color: #f06548 !important;
}
.progress-danger .progress-bar:nth-child(2)::after {
  border-left-color: rgba(240, 101, 72, 0.1);
}

.progress-light .progress-bar {
  background-color: #f3f6f9;
}
.progress-light .progress-bar::after {
  border-left-color: #f3f6f9;
}
.progress-light .progress-bar:nth-child(2) {
  background-color: rgba(243, 246, 249, 0.1) !important;
  color: #f3f6f9 !important;
}
.progress-light .progress-bar:nth-child(2)::after {
  border-left-color: rgba(243, 246, 249, 0.1);
}

.progress-dark .progress-bar {
  background-color: #212529;
}
.progress-dark .progress-bar::after {
  border-left-color: #212529;
}
.progress-dark .progress-bar:nth-child(2) {
  background-color: rgba(33, 37, 41, 0.1) !important;
  color: #212529 !important;
}
.progress-dark .progress-bar:nth-child(2)::after {
  border-left-color: rgba(33, 37, 41, 0.1);
}

.popover {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}

.text-white-75 {
  color: rgba(255, 255, 255, 0.75) !important;
}

.custom-blockquote.blockquote {
  padding: 16px;
  border-left: 3px solid;
}
.custom-blockquote.blockquote.blockquote-outline {
  background-color: var(--vz-card-bg-custom) !important;
  border: 1px solid;
  border-left: 3px solid;
}

.custom-blockquote.blockquote.blockquote-primary {
  color: #405189;
  border-color: #405189;
  background-color: rgba(64, 81, 137, 0.15);
}
.custom-blockquote.blockquote.blockquote-primary .blockquote-footer {
  color: #405189;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-primary {
  border-color: #405189;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-primary .blockquote-footer {
  color: #405189;
}

.custom-blockquote.blockquote.blockquote-secondary {
  color: #3577f1;
  border-color: #3577f1;
  background-color: rgba(53, 119, 241, 0.15);
}
.custom-blockquote.blockquote.blockquote-secondary .blockquote-footer {
  color: #3577f1;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary {
  border-color: #3577f1;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary .blockquote-footer {
  color: #3577f1;
}

.custom-blockquote.blockquote.blockquote-success {
  color: #0ab39c;
  border-color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.15);
}
.custom-blockquote.blockquote.blockquote-success .blockquote-footer {
  color: #0ab39c;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-success {
  border-color: #0ab39c;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-success .blockquote-footer {
  color: #0ab39c;
}

.custom-blockquote.blockquote.blockquote-info {
  color: #299cdb;
  border-color: #299cdb;
  background-color: rgba(41, 156, 219, 0.15);
}
.custom-blockquote.blockquote.blockquote-info .blockquote-footer {
  color: #299cdb;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-info {
  border-color: #299cdb;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-info .blockquote-footer {
  color: #299cdb;
}

.custom-blockquote.blockquote.blockquote-warning {
  color: #f7b84b;
  border-color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.15);
}
.custom-blockquote.blockquote.blockquote-warning .blockquote-footer {
  color: #f7b84b;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-warning {
  border-color: #f7b84b;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-warning .blockquote-footer {
  color: #f7b84b;
}

.custom-blockquote.blockquote.blockquote-danger {
  color: #f06548;
  border-color: #f06548;
  background-color: rgba(240, 101, 72, 0.15);
}
.custom-blockquote.blockquote.blockquote-danger .blockquote-footer {
  color: #f06548;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-danger {
  border-color: #f06548;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-danger .blockquote-footer {
  color: #f06548;
}

.custom-blockquote.blockquote.blockquote-light {
  color: #f3f6f9;
  border-color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.15);
}
.custom-blockquote.blockquote.blockquote-light .blockquote-footer {
  color: #f3f6f9;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-light {
  border-color: #f3f6f9;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-light .blockquote-footer {
  color: #f3f6f9;
}

.custom-blockquote.blockquote.blockquote-dark {
  color: #212529;
  border-color: #212529;
  background-color: rgba(33, 37, 41, 0.15);
}
.custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
  color: #212529;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: #212529;
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-dark .blockquote-footer {
  color: #212529;
}

.custom-blockquote.blockquote.blockquote-dark {
  color: var(--vz-dark);
  border-color: var(--vz-dark);
  background-color: rgba(var(--vz-dark-rgb), 0.15);
}
.custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
  color: var(--vz-dark);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: var(--vz-dark);
}
.custom-blockquote.blockquote.blockquote-outline.blockquote-dark .blockquote-footer {
  color: var(--vz-dark);
}

.form-check {
  position: relative;
  text-align: left;
}
.form-check .form-check-input {
  cursor: pointer;
}
.form-check label {
  cursor: pointer;
}

.form-check-primary .form-check-input:checked {
  background-color: #405189;
  border-color: #405189;
}

.form-radio-primary .form-check-input:checked {
  border-color: #405189;
  background-color: #405189;
}
.form-radio-primary .form-check-input:checked:after {
  background-color: #405189;
}

.form-check-secondary .form-check-input:checked {
  background-color: #3577f1;
  border-color: #3577f1;
}

.form-radio-secondary .form-check-input:checked {
  border-color: #3577f1;
  background-color: #3577f1;
}
.form-radio-secondary .form-check-input:checked:after {
  background-color: #3577f1;
}

.form-check-success .form-check-input:checked {
  background-color: #0ab39c;
  border-color: #0ab39c;
}

.form-radio-success .form-check-input:checked {
  border-color: #0ab39c;
  background-color: #0ab39c;
}
.form-radio-success .form-check-input:checked:after {
  background-color: #0ab39c;
}

.form-check-info .form-check-input:checked {
  background-color: #299cdb;
  border-color: #299cdb;
}

.form-radio-info .form-check-input:checked {
  border-color: #299cdb;
  background-color: #299cdb;
}
.form-radio-info .form-check-input:checked:after {
  background-color: #299cdb;
}

.form-check-warning .form-check-input:checked {
  background-color: #f7b84b;
  border-color: #f7b84b;
}

.form-radio-warning .form-check-input:checked {
  border-color: #f7b84b;
  background-color: #f7b84b;
}
.form-radio-warning .form-check-input:checked:after {
  background-color: #f7b84b;
}

.form-check-danger .form-check-input:checked {
  background-color: #f06548;
  border-color: #f06548;
}

.form-radio-danger .form-check-input:checked {
  border-color: #f06548;
  background-color: #f06548;
}
.form-radio-danger .form-check-input:checked:after {
  background-color: #f06548;
}

.form-check-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.form-radio-light .form-check-input:checked {
  border-color: #f3f6f9;
  background-color: #f3f6f9;
}
.form-radio-light .form-check-input:checked:after {
  background-color: #f3f6f9;
}

.form-check-dark .form-check-input:checked {
  background-color: #212529;
  border-color: #212529;
}

.form-radio-dark .form-check-input:checked {
  border-color: #212529;
  background-color: #212529;
}
.form-radio-dark .form-check-input:checked:after {
  background-color: #212529;
}

.form-check-label {
  cursor: pointer;
  margin-bottom: 0;
}

.form-check-right {
  padding-left: 0;
  display: inline-block;
}
.form-check-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: -1.6em;
}
.form-check-right .form-check-label {
  display: block;
}
.form-check-right.form-switch .form-check-input {
  margin-right: -2.56em;
}

.form-check-outline.form-check-primary .form-check-input:checked[type=checkbox] {
  color: #405189;
  background-color: transparent;
  border-color: #405189;
}

.form-check-outline.form-check-secondary .form-check-input:checked[type=checkbox] {
  color: #3577f1;
  background-color: transparent;
  border-color: #3577f1;
}

.form-check-outline.form-check-success .form-check-input:checked[type=checkbox] {
  color: #0ab39c;
  background-color: transparent;
  border-color: #0ab39c;
}

.form-check-outline.form-check-info .form-check-input:checked[type=checkbox] {
  color: #299cdb;
  background-color: transparent;
  border-color: #299cdb;
}

.form-check-outline.form-check-warning .form-check-input:checked[type=checkbox] {
  color: #f7b84b;
  background-color: transparent;
  border-color: #f7b84b;
}

.form-check-outline.form-check-danger .form-check-input:checked[type=checkbox] {
  color: #f06548;
  background-color: transparent;
  border-color: #f06548;
}

.form-check-outline.form-check-light .form-check-input:checked[type=checkbox] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9;
}

.form-check-outline.form-check-dark .form-check-input:checked[type=checkbox] {
  color: #212529;
  background-color: transparent;
  border-color: #212529;
}

.form-check-outline .form-check-input {
  position: relative;
}
.form-check-outline .form-check-input:checked[type=checkbox] {
  background-image: none;
}
.form-check-outline .form-check-input:checked[type=checkbox]::before {
  content: "\\f012c";
  font-family: "Material Design Icons";
  top: -2px;
  position: absolute;
  font-weight: 700;
  font-size: 11px;
  left: 1px;
}

.form-radio-outline.form-radio-primary .form-check-input:checked[type=radio] {
  color: #405189;
  background-color: transparent;
  border-color: #405189;
}

.form-radio-outline.form-radio-secondary .form-check-input:checked[type=radio] {
  color: #3577f1;
  background-color: transparent;
  border-color: #3577f1;
}

.form-radio-outline.form-radio-success .form-check-input:checked[type=radio] {
  color: #0ab39c;
  background-color: transparent;
  border-color: #0ab39c;
}

.form-radio-outline.form-radio-info .form-check-input:checked[type=radio] {
  color: #299cdb;
  background-color: transparent;
  border-color: #299cdb;
}

.form-radio-outline.form-radio-warning .form-check-input:checked[type=radio] {
  color: #f7b84b;
  background-color: transparent;
  border-color: #f7b84b;
}

.form-radio-outline.form-radio-danger .form-check-input:checked[type=radio] {
  color: #f06548;
  background-color: transparent;
  border-color: #f06548;
}

.form-radio-outline.form-radio-light .form-check-input:checked[type=radio] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9;
}

.form-radio-outline.form-radio-dark .form-check-input:checked[type=radio] {
  color: #212529;
  background-color: transparent;
  border-color: #212529;
}

.form-radio-outline .form-check-input {
  position: relative;
}
.form-radio-outline .form-check-input:checked[type=radio] {
  background-image: none;
}
.form-radio-outline .form-check-input:checked[type=radio]::before {
  content: "\\f0765";
  font-family: "Material Design Icons";
  top: 0px;
  position: absolute;
  font-size: 8px;
  left: 2.2px;
}

.form-switch-md {
  padding-left: 2.5rem;
  min-height: 22px;
  line-height: 22px;
}
.form-switch-md .form-check-input {
  width: 40px;
  height: 20px;
  left: -0.5rem;
  position: relative;
}
.form-switch-md .form-check-label {
  vertical-align: middle;
}

.form-switch-lg {
  padding-left: 2.75rem;
  min-height: 28px;
  line-height: 28px;
}
.form-switch-lg .form-check-input {
  width: 48px;
  height: 24px;
  left: -0.75rem;
  position: relative;
}

.input-group-text {
  margin-bottom: 0px;
}

.form-switch-primary .form-check-input:checked {
  background-color: #405189;
  border-color: #405189;
}

.form-switch-custom.form-switch-primary .form-check-input:checked::before {
  color: #405189;
}

.form-switch-secondary .form-check-input:checked {
  background-color: #3577f1;
  border-color: #3577f1;
}

.form-switch-custom.form-switch-secondary .form-check-input:checked::before {
  color: #3577f1;
}

.form-switch-success .form-check-input:checked {
  background-color: #0ab39c;
  border-color: #0ab39c;
}

.form-switch-custom.form-switch-success .form-check-input:checked::before {
  color: #0ab39c;
}

.form-switch-info .form-check-input:checked {
  background-color: #299cdb;
  border-color: #299cdb;
}

.form-switch-custom.form-switch-info .form-check-input:checked::before {
  color: #299cdb;
}

.form-switch-warning .form-check-input:checked {
  background-color: #f7b84b;
  border-color: #f7b84b;
}

.form-switch-custom.form-switch-warning .form-check-input:checked::before {
  color: #f7b84b;
}

.form-switch-danger .form-check-input:checked {
  background-color: #f06548;
  border-color: #f06548;
}

.form-switch-custom.form-switch-danger .form-check-input:checked::before {
  color: #f06548;
}

.form-switch-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.form-switch-custom.form-switch-light .form-check-input:checked::before {
  color: #f3f6f9;
}

.form-switch-dark .form-check-input:checked {
  background-color: #212529;
  border-color: #212529;
}

.form-switch-custom.form-switch-dark .form-check-input:checked::before {
  color: #212529;
}

.form-switch-custom .form-check-input {
  position: relative;
  background-image: none;
}
.form-switch-custom .form-check-input::before {
  content: "\\f0765";
  font-family: "Material Design Icons";
  top: -9px;
  position: absolute;
  font-size: 20px;
  left: -3px;
  color: #878a99;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch-custom .form-check-input::before {
    transition: none;
  }
}
.form-switch-custom .form-check-input:checked {
  background-image: none;
  background-color: var(--vz-input-bg);
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch-custom .form-check-input:checked {
    transition: none;
  }
}
.form-switch-custom .form-check-input:checked::before {
  right: -3px;
  left: auto;
}
.form-switch-custom .form-check-input:focus {
  background-image: none;
}

.form-switch-right {
  display: inline-block;
  padding-right: 0.8em;
  margin-bottom: 0;
  padding-left: 0 !important;
}
.form-switch-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: -1.6em;
  margin-top: 0.1em !important;
}
.form-switch-right label {
  margin-bottom: 0;
  margin-right: 1rem;
}

.card-radio {
  padding: 0;
}
.card-radio .form-check-label {
  background-color: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-input-check-border);
  border-radius: 0.25rem;
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  position: relative;
  padding-right: 32px;
}
.card-radio .form-check-label:hover {
  cursor: pointer;
}
.card-radio .form-check-input {
  display: none;
}
.card-radio .form-check-input:checked + .form-check-label {
  border-color: #405189 !important;
}
.card-radio .form-check-input:checked + .form-check-label:before {
  content: "\\eb80";
  font-family: "remixicon";
  position: absolute;
  top: 2px;
  right: 6px;
  font-size: 16px;
  color: #405189;
}
.card-radio.dark .form-check-input:checked + .form-check-label:before {
  color: #fff;
}

[data-layout-mode=dark] .form-switch .form-check-input, [data-layout-mode=dark] .form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
}

.form-icon {
  position: relative;
}
.form-icon .form-control-icon {
  padding-left: 2.7rem;
  position: relative;
}
.form-icon i {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 18px;
  display: flex;
  align-items: center;
}
.form-icon.right .form-control-icon {
  padding-right: 2.7rem;
  padding-left: 0.9rem;
  position: relative;
}
.form-icon.right i {
  left: auto;
  right: 18px;
}

[data-layout-mode=dark] .form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  background-color: var(--vz-gray-200) !important;
  border-color: var(--vz-border-color) !important;
}
[data-layout-mode=dark] .form-control {
  background-color: var(--vz-gray-200);
  border-color: var(--vz-border-color);
}

.list-group-fill-primary .list-group-item.active {
  background-color: #405189 !important;
  border-color: #405189;
}

.list-group-fill-secondary .list-group-item.active {
  background-color: #3577f1 !important;
  border-color: #3577f1;
}

.list-group-fill-success .list-group-item.active {
  background-color: #0ab39c !important;
  border-color: #0ab39c;
}

.list-group-fill-info .list-group-item.active {
  background-color: #299cdb !important;
  border-color: #299cdb;
}

.list-group-fill-warning .list-group-item.active {
  background-color: #f7b84b !important;
  border-color: #f7b84b;
}

.list-group-fill-danger .list-group-item.active {
  background-color: #f06548 !important;
  border-color: #f06548;
}

.list-group-fill-light .list-group-item.active {
  background-color: #f3f6f9 !important;
  border-color: #f3f6f9;
}

.list-group-fill-dark .list-group-item.active {
  background-color: #212529 !important;
  border-color: #212529;
}

.list-group-fill-light {
  color: #212529 !important;
}

.list-group-item {
  margin-bottom: 0px;
}
.list-group-item .list-text {
  color: #878a99;
}
.list-group-item.active {
  box-shadow: none;
}
.list-group-item.active .list-title {
  color: #fff;
}
.list-group-item.active .list-text {
  color: rgba(255, 255, 255, 0.5);
}

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  max-height: 100%; /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.simplebar-content:before,
.simplebar-content:after {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 6px;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction=rtl] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.custom-scroll {
  height: 100%;
}

[data-simplebar-track=primary] .simplebar-scrollbar:before {
  background: #405189;
}

[data-simplebar-track=secondary] .simplebar-scrollbar:before {
  background: #3577f1;
}

[data-simplebar-track=success] .simplebar-scrollbar:before {
  background: #0ab39c;
}

[data-simplebar-track=info] .simplebar-scrollbar:before {
  background: #299cdb;
}

[data-simplebar-track=warning] .simplebar-scrollbar:before {
  background: #f7b84b;
}

[data-simplebar-track=danger] .simplebar-scrollbar:before {
  background: #f06548;
}

[data-simplebar-track=light] .simplebar-scrollbar:before {
  background: #f3f6f9;
}

[data-simplebar-track=dark] .simplebar-scrollbar:before {
  background: #212529;
}

/**
 * prism.js default theme for JavaScript, CSS and HTML
 * Based on dabblet (http://dabblet.com)
 * @author Lea Verou
 */
code[class*=language-],
pre[class*=language-] {
  color: black;
  background: none;
  text-shadow: 0 1px white;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none;
}

pre[class*=language-]::selection,
pre[class*=language-] ::selection,
code[class*=language-]::selection,
code[class*=language-] ::selection {
  text-shadow: none;
  background: #b3d4fc;
}

@media print {
  code[class*=language-],
  pre[class*=language-] {
    text-shadow: none;
  }
}
/* Code blocks */
pre[class*=language-] {
  padding: 1em;
  margin: 0;
  overflow: auto;
}

:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: var(--vz-light) !important;
}

/* Inline code */
:not(pre) > code[class*=language-] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: slategray;
}

.token.punctuation {
  color: #999;
}

.token.namespace {
  opacity: 0.7;
}

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
  color: #f06548;
}

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: #690;
}

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #9a6e3a;
  /* This background color was intended by the author of this theme. */
  background: hsla(0, 0%, 100%, 0.5);
}

.token.atrule,
.token.attr-value,
.token.keyword {
  color: #07a;
}

.token.function,
.token.class-name {
  color: #dd4a68;
}

.token.regex,
.token.important,
.token.variable {
  color: #e90;
}

.token.important,
.token.bold {
  font-weight: bold;
}

.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

/* Prism editor */
:not(pre) > code[class*=language-],
pre[class*=language-] {
  background: #eff2f7;
}

code[class*=language-],
pre[class*=language-] {
  color: #878a99;
  text-shadow: none;
}

.language-markup::-webkit-scrollbar {
  -webkit-appearance: none;
}
.language-markup::-webkit-scrollbar:vertical {
  width: 10px;
}
.language-markup::-webkit-scrollbar:horizontal {
  height: 10px;
}
.language-markup::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.1);
  border-radius: 10px;
  border: 2px solid var(--vz-light);
}
.language-markup::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-light);
}

#scroll-top {
  width: 30px;
  height: 30px;
  position: fixed;
  bottom: 65px;
  right: 30px;
  background: #343a40;
  border-color: transparent;
  border-radius: 3px;
  color: #ffffff;
  transition: all 0.5s ease;
}

.btn-clipboard {
  position: absolute !important;
  right: 15px !important;
  z-index: 1 !important;
}

div.code-toolbar > .toolbar {
  opacity: 1 !important;
}
div.code-toolbar > .toolbar button {
  display: inline-block !important;
  margin: 0.375rem 0.5rem !important;
  padding: 0.25rem 0.75rem !important;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  border-radius: 0.2rem !important;
  border: 1px solid rgba(64, 81, 137, 0.35) !important;
  background-color: transparent;
  color: #405189 !important;
  box-shadow: none !important;
}
div.code-toolbar > .toolbar button:focus {
  outline: none !important;
  box-shadow: none !important;
}
div.code-toolbar > .toolbar button:hover {
  background-color: #405189 !important;
  color: #fff !important;
}

.swal2-container .swal2-title {
  padding: 24px 24px 0;
  font-size: 20px;
  font-weight: 500;
}

.swal2-popup {
  padding-bottom: 24px;
  border-radius: 0.3rem;
  background-color: var(--vz-card-bg-custom);
  color: var(--vz-body-color);
}
.swal2-popup .swal2-title {
  color: var(--vz-heading-color);
}
.swal2-popup .swal2-html-container {
  color: var(--vz-body-color);
}

.swal2-footer {
  border-top: 1px solid var(--vz-border-color);
  color: var(--vz-body-color);
}

.swal2-html-container {
  font-size: 16px;
}

.swal2-icon.swal2-question {
  border-color: #299cdb;
  color: #299cdb;
}
.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #0ab39c;
}
.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(10, 179, 156, 0.3);
}
.swal2-icon.swal2-warning {
  border-color: #f7b84b;
  color: #f7b84b;
}

.swal2-styled:focus {
  box-shadow: none;
}

.swal2-loader {
  border-color: #405189 transparent #405189 transparent;
}

.swal2-timer-progress-bar {
  background-color: rgba(10, 179, 156, 0.4);
}

.swal2-progress-steps .swal2-progress-step {
  background: #405189;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #405189;
}
.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step, .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
  background: rgba(64, 81, 137, 0.3);
}
.swal2-progress-steps .swal2-progress-step-line {
  background: #405189;
}

.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {
  border-left-color: #405189 !important;
  border-right-color: #405189 !important;
}

.swal2-file, .swal2-input, .swal2-textarea {
  border: 1px solid var(--vz-input-border);
}
.swal2-file:focus, .swal2-input:focus, .swal2-textarea:focus {
  box-shadow: none;
  border-color: var(--vz-input-focus-border);
}

.swal2-input {
  height: auto;
  display: block;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--vz-input-border);
}

.swal2-close {
  font-family: var(--vz-font-sans-serif);
  font-weight: 300;
  font-size: 28px;
}
.swal2-close:focus {
  box-shadow: none;
}
.swal2-close:hover {
  color: #405189;
}

.swal2-validation-message {
  background-color: transparent;
}

.dropzone {
  min-height: 230px;
  border: 2px dashed var(--vz-border-color);
  background: var(--vz-card-bg-custom);
  border-radius: 6px;
}
.dropzone .dz-message {
  font-size: 24px;
  width: 100%;
  margin: 1em 0;
}

.noUi-connect {
  background: #0ab39c;
}

.noUi-handle {
  background: #0ab39c;
  border: 2px solid var(--vz-card-bg);
  box-shadow: none;
}

.noUi-horizontal {
  height: 4px;
}
.noUi-horizontal .noUi-handle {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  right: -10px !important;
  top: -7px;
}
.noUi-horizontal .noUi-handle::before, .noUi-horizontal .noUi-handle::after {
  display: none;
}
.noUi-horizontal .noUi-handle:focus {
  outline: 0;
}

.noUi-pips-horizontal {
  height: 50px;
}

.noUi-tooltip {
  padding: 0.4rem 0.7rem;
  border-color: var(--vz-border-color);
  border-radius: 0.2rem;
  background-color: var(--vz-card-bg-custom);
  color: var(--vz-body-color);
}

.noUi-vertical {
  width: 4px;
}
.noUi-vertical .noUi-handle {
  height: 16px;
  width: 16px;
  right: -8px;
  top: -12px;
  left: auto;
  border-radius: 50%;
}
.noUi-vertical .noUi-handle::before, .noUi-vertical .noUi-handle::after {
  display: none;
}
.noUi-vertical .noUi-handle:focus {
  outline: 0;
}
.noUi-vertical .noUi-origin {
  top: 0;
}

.noUi-value {
  font-size: 12px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 12px;
}

.noUi-value-horizontal {
  padding-top: 4px;
}

.noUi-target {
  box-shadow: none;
  background-color: var(--vz-light);
  border-color: var(--vz-light);
}

.noUi-touch-area:focus {
  outline: 0;
}

#red, #green, #blue {
  margin: 10px;
  display: inline-block;
  height: 200px;
}

#colorpicker {
  height: 240px;
  width: 310px;
  margin: 0 auto;
  padding: 10px;
  border: 1px solid var(--vz-border-color);
}

#result {
  margin: 60px 26px;
  height: 100px;
  width: 100px;
  display: inline-block;
  vertical-align: top;
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 0 3px;
  border-radius: 7px;
}

#red .noUi-connect {
  background: #f06548;
}

#green .noUi-connect {
  background: #0ab39c;
}

#blue .noUi-connect {
  background: #405189;
}

.form-control.keyboard {
  max-width: 340px !important;
}

.example-val {
  font-size: 12px;
  color: #878a99;
  display: block;
  margin: 15px 0;
}
.example-val:before {
  content: "Value: ";
  font-size: 12px;
  font-weight: 600;
}

.noUi-tooltip {
  display: none;
}

.noUi-active .noUi-tooltip {
  display: block;
}

.c-1-color {
  background: #f06548;
}

.c-2-color {
  background: #f7b84b;
}

.c-3-color {
  background: #0ab39c;
}

.c-4-color {
  background: #405189;
}

.c-5-color {
  background: #6559cc;
}

#slider-toggle {
  height: 50px;
}
#slider-toggle.off .noUi-handle {
  border-color: #f06548;
}

[data-slider-color=primary] .noUi-connect {
  background: #405189;
}
[data-slider-color=primary] .noUi-handle {
  background: #405189;
}
[data-slider-color=primary][data-slider-style=border] .noUi-handle, [data-slider-color=primary][data-slider-style=square] .noUi-handle {
  border-color: #405189;
}

[data-slider-color=secondary] .noUi-connect {
  background: #3577f1;
}
[data-slider-color=secondary] .noUi-handle {
  background: #3577f1;
}
[data-slider-color=secondary][data-slider-style=border] .noUi-handle, [data-slider-color=secondary][data-slider-style=square] .noUi-handle {
  border-color: #3577f1;
}

[data-slider-color=success] .noUi-connect {
  background: #0ab39c;
}
[data-slider-color=success] .noUi-handle {
  background: #0ab39c;
}
[data-slider-color=success][data-slider-style=border] .noUi-handle, [data-slider-color=success][data-slider-style=square] .noUi-handle {
  border-color: #0ab39c;
}

[data-slider-color=info] .noUi-connect {
  background: #299cdb;
}
[data-slider-color=info] .noUi-handle {
  background: #299cdb;
}
[data-slider-color=info][data-slider-style=border] .noUi-handle, [data-slider-color=info][data-slider-style=square] .noUi-handle {
  border-color: #299cdb;
}

[data-slider-color=warning] .noUi-connect {
  background: #f7b84b;
}
[data-slider-color=warning] .noUi-handle {
  background: #f7b84b;
}
[data-slider-color=warning][data-slider-style=border] .noUi-handle, [data-slider-color=warning][data-slider-style=square] .noUi-handle {
  border-color: #f7b84b;
}

[data-slider-color=danger] .noUi-connect {
  background: #f06548;
}
[data-slider-color=danger] .noUi-handle {
  background: #f06548;
}
[data-slider-color=danger][data-slider-style=border] .noUi-handle, [data-slider-color=danger][data-slider-style=square] .noUi-handle {
  border-color: #f06548;
}

[data-slider-color=light] .noUi-connect {
  background: #f3f6f9;
}
[data-slider-color=light] .noUi-handle {
  background: #f3f6f9;
}
[data-slider-color=light][data-slider-style=border] .noUi-handle, [data-slider-color=light][data-slider-style=square] .noUi-handle {
  border-color: #f3f6f9;
}

[data-slider-color=dark] .noUi-connect {
  background: #212529;
}
[data-slider-color=dark] .noUi-handle {
  background: #212529;
}
[data-slider-color=dark][data-slider-style=border] .noUi-handle, [data-slider-color=dark][data-slider-style=square] .noUi-handle {
  border-color: #212529;
}

[data-slider-size=lg].noUi-horizontal {
  height: 12px;
}
[data-slider-size=lg].noUi-horizontal .noUi-handle {
  width: 24px;
  height: 24px;
}

[data-slider-size=md].noUi-horizontal {
  height: 8px;
}
[data-slider-size=md].noUi-horizontal .noUi-handle {
  width: 20px;
  height: 20px;
}

[data-slider-size=sm].noUi-horizontal {
  height: 4px;
}
[data-slider-size=sm].noUi-horizontal .noUi-handle {
  width: 16px;
  height: 16px;
}

[data-slider-style=line].noUi-horizontal .noUi-handle {
  width: 8px;
  border-radius: 4px;
  right: -8px;
}
[data-slider-style=line].noUi-vertical .noUi-handle {
  height: 8px;
  border-radius: 4px;
  top: -3px;
}

[data-slider-style=border] .noUi-handle {
  border-color: #0ab39c;
  background-color: #fff;
}

[data-slider-style=square] .noUi-handle {
  border-radius: 0px;
  transform: rotate(45deg);
  height: 10px;
  width: 10px;
  top: -4px;
  border-color: #0ab39c;
  background-color: #fff;
}

.nested-list .list-group-item {
  background-color: rgba(64, 81, 137, 0.05);
  border-color: rgba(64, 81, 137, 0.05);
}

.nested-list, .nested-1, .nested-2, .nested-3 {
  margin-top: 5px;
}

.nested-sortable-handle .handle {
  position: absolute;
  left: 0;
  top: 0;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
}
.nested-sortable-handle .list-group-item {
  padding-left: 42px;
}

.shepherd-element {
  background: var(--vz-card-bg-custom);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
}

.shepherd-has-title .shepherd-content .shepherd-header {
  background-color: var(--vz-light);
  padding: 0.5rem 0.75rem;
}
.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
  color: rgba(var(--vz-dark-rgb), 0.75);
}
.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
  color: rgba(var(--vz-dark-rgb), 0.75);
}

.shepherd-element.shepherd-has-title[data-popper-placement^=bottom] > .shepherd-arrow:before {
  background-color: var(--vz-light);
}

.shepherd-title {
  font-size: 15px;
  font-weight: 500;
  color: var(--vz-body-color);
}

.shepherd-text {
  padding: 0.75rem;
  font-size: 0.8125rem;
  color: var(--vz-body-color);
}

.shepherd-button.btn-success:not(:disabled):hover {
  background: rgb(9.3253968254, 166.9246031746, 145.4761904762);
  color: #fff;
}
.shepherd-button.btn-light:not(:disabled):hover {
  background: rgba(var(--vz-light-rgb), 0.75);
  color: var(--vz-dark);
}
.shepherd-button.btn-primary:not(:disabled):hover {
  background: rgb(59.9402985075, 75.8619402985, 128.3097014925);
  color: #fff;
}

.shepherd-footer {
  padding: 0 0.75rem 0.75rem;
}

.shepherd-arrow,
.shepherd-arrow:before {
  content: "\\ea75";
  font-family: "remixicon";
  font-size: 24px;
  z-index: 1;
  background-color: transparent !important;
  transform: rotate(0deg);
  color: #405189;
}

.shepherd-element[data-popper-placement^=bottom] > .shepherd-arrow {
  top: -18px;
}

.shepherd-button {
  margin-right: 0.5rem;
}

.swiper-button-next, .swiper-button-prev {
  height: 32px !important;
  width: 32px !important;
  background-color: rgba(64, 81, 137, 0.2);
  backdrop-filter: blur(2px);
  border-radius: 8px;
}
.swiper-button-next::after, .swiper-button-prev::after {
  font-family: remixicon !important;
  font-size: 28px !important;
  color: #405189;
  transition: all 0.3s ease;
}

.swiper-button-prev::after {
  content: "\\ea64" !important;
}

.swiper-button-next::after {
  content: "\\ea6e" !important;
}

.swiper-pagination-bullet {
  width: 22px !important;
  height: 5px !important;
  background-color: #fff !important;
  border-radius: 50px !important;
  box-shadow: none;
}
.swiper-pagination-bullet .swiper-pagination-bullet-active {
  opacity: 1;
}

.dynamic-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background-color: #fff;
  opacity: 0.5;
  transition: all 0.5s ease;
}
.dynamic-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
  width: 20px;
}

.swiper-pagination-fraction {
  color: #fff;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
}

.pagination-custom .swiper-pagination-bullet {
  height: 25px !important;
  width: 25px !important;
  line-height: 25px !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  opacity: 0.5 !important;
  transition: all 0.5s ease;
}
.pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
  color: #3577f1 !important;
  opacity: 1 !important;
}

.swiper-pagination-progressbar {
  height: 6px !important;
  background-color: rgba(10, 179, 156, 0.25) !important;
}
.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background-color: #0ab39c !important;
}

.swiper-scrollbar {
  background-color: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(2px);
  padding: 1.2px;
  height: 6px !important;
}
.swiper-scrollbar .swiper-scrollbar-drag {
  background-color: #fff;
}

.swiper-pagination-dark .swiper-pagination-bullet {
  background-color: #3577f1 !important;
}
.swiper-pagination-dark .dynamic-pagination .swiper-pagination-bullet {
  background-color: #3577f1 !important;
}
.swiper-pagination-dark.pagination-custom .swiper-pagination-bullet {
  color: #fff;
}
.swiper-pagination-dark.pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
}
.swiper-pagination-dark.swiper-scrollbar {
  background-color: rgba(33, 37, 41, 0.35);
}

.multi-wrapper {
  border: none;
  position: relative;
}
.multi-wrapper::before {
  content: "\\ea61";
  position: absolute;
  font-family: "remixicon";
  left: 50%;
  transform: translateX(-50%);
  bottom: 86px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border-radius: 50%;
  color: #878a99;
  background-color: var(--vz-light);
  z-index: 1;
}
.multi-wrapper .non-selected-wrapper {
  border: 1px solid var(--vz-input-border);
  background-color: var(--vz-input-bg);
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar:vertical, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar:vertical {
  width: 10px;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar:horizontal, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar:horizontal {
  height: 9px;
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar-thumb, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.2);
  border-radius: 10px;
  border: 2px solid var(--vz-input-bg);
}
.multi-wrapper .selected-wrapper::-webkit-scrollbar-track, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-input-bg);
}
.multi-wrapper .item-group .group-label {
  font-size: 12px;
}
.multi-wrapper .item {
  color: var(--vz-body-color);
}
.multi-wrapper .item:hover {
  background-color: rgba(64, 81, 137, 0.1);
}
.multi-wrapper .selected-wrapper {
  border: 1px solid var(--vz-input-border);
  background: var(--vz-input-bg);
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}
.multi-wrapper .search-input {
  flex: 0 0 auto;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
  margin-bottom: 16px;
}
.multi-wrapper .search-input::placeholder {
  color: #878a99;
}
.multi-wrapper .header {
  font-weight: 600;
  color: var(--vz-gray-600);
}

.pcr-app {
  background: var(--vz-card-bg-custom);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border-radius: 4px;
  border: 1px solid var(--vz-border-color);
}

.pickr .pcr-button {
  border: 4px solid var(--vz-card-bg-custom);
  box-shadow: 0px 0px 0 2px var(--vz-border-color);
  border-radius: 50%;
  box-shadow: none;
}
.pickr .pcr-button::after, .pickr .pcr-button::before {
  border-radius: 50%;
}

.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview {
  margin-right: 0.75em;
  margin-left: 0;
}
.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser, .pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity {
  margin-left: 0.75em;
  margin-right: 0;
}
.pcr-app[data-theme=monolith] .pcr-result {
  min-width: 100%;
}
.pcr-app .pcr-interaction .pcr-type.active {
  background: #405189;
}
.pcr-app .pcr-interaction .pcr-result {
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
}
.pcr-app .pcr-interaction input {
  border-radius: 0.25rem !important;
}
.pcr-app .pcr-interaction input:focus {
  box-shadow: none;
  background-color: var(--vz-input-bg);
  border-color: var(--vz-input-focus-border);
}
.pcr-app .pcr-interaction .pcr-save {
  background: #0ab39c !important;
}
.pcr-app .pcr-interaction .pcr-clear, .pcr-app .pcr-interaction .pcr-cancel {
  background: #f06548 !important;
}

.filepond--root {
  margin-bottom: 0;
}
.filepond--root[data-style-panel-layout~=circle] .filepond--drop-label label {
  font-size: 14px;
}

.filepond--panel-root {
  border: 2px dashed var(--vz-border-color);
  background: var(--vz-card-bg-custom);
}

.filepond--drop-label {
  color: var(--vz-body-color);
}
.filepond--drop-label label {
  font-weight: 500;
}

.filepond--credits {
  display: none;
}

.filepond--item-panel {
  background-color: #405189 !important;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  height: auto;
}

.input-step {
  border: 1px solid var(--vz-input-border);
  display: inline-flex;
  overflow: visible;
  height: 37.5px;
  border-radius: 0.25rem;
  background: var(--vz-input-bg);
  padding: 4px;
}
.input-step input {
  width: 4em;
  height: 100%;
  text-align: center;
  border: 0;
  background: transparent;
  color: var(--vz-body-color);
  border-radius: 0.25rem;
}
.input-step input:focus-visible {
  outline: 0;
}
.input-step button {
  width: 1.4em;
  font-weight: 300;
  height: 100%;
  line-height: 0.1em;
  font-size: 1.4em;
  padding: 0.2em !important;
  background: var(--vz-light);
  color: var(--vz-body-color);
  border: none;
  border-radius: 0.25rem;
}
.input-step.light {
  background: var(--vz-light);
}
.input-step.light button {
  background-color: var(--vz-input-bg);
}
.input-step.light-input {
  background: var(--vz-light);
}
.input-step.light-input input {
  background-color: var(--vz-input-bg);
}
.input-step.full-width {
  display: flex;
  width: 100%;
}
.input-step.full-width button {
  flex-shrink: 0;
}
.input-step.full-width input {
  flex-grow: 1;
}

.input-step.step-primary button {
  background-color: #405189;
  color: #fff;
}

.input-step.step-secondary button {
  background-color: #3577f1;
  color: #fff;
}

.input-step.step-success button {
  background-color: #0ab39c;
  color: #fff;
}

.input-step.step-info button {
  background-color: #299cdb;
  color: #fff;
}

.input-step.step-warning button {
  background-color: #f7b84b;
  color: #fff;
}

.input-step.step-danger button {
  background-color: #f06548;
  color: #fff;
}

.input-step.step-light button {
  background-color: #f3f6f9;
  color: #fff;
}

.input-step.step-dark button {
  background-color: #212529;
  color: #fff;
}

.ck {
  font-family: var(--vz-font-sans-serif) !important;
}
.ck.ck-reset_all, .ck.ck-reset_all * {
  color: var(--vz-body-color) !important;
}
.ck.ck-toolbar {
  background: rgba(var(--vz-light-rgb), 0.75) !important;
}
.ck p {
  margin-bottom: 0;
}
.ck.ck-toolbar {
  border: 1px solid var(--vz-input-border) !important;
}
.ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {
  flex-wrap: wrap !important;
}
.ck.ck-toolbar .ck.ck-toolbar__separator {
  background: transparent !important;
}
.ck.ck-editor__main > .ck-editor__editable {
  border-top: 0 !important;
  background-color: var(--vz-card-bg-custom) !important;
  border-color: var(--vz-input-border) !important;
  box-shadow: none !important;
}
.ck.ck-dropdown__panel {
  background: var(--vz-choices-bg) !important;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  border-radius: 0.3rem;
}
.ck.ck-list {
  background: var(--vz-choices-bg) !important;
}
.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne, .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
  left: 0;
  right: auto !important;
}
.ck.ck-editor__editable_inline[dir=ltr] {
  text-align: left !important;
}
.ck.ck-dropdown__panel {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important;
  border-radius: 0.3rem !important;
  border: 1px solid var(--vz-border-color) !important;
}

.ck.ck-button:focus, .ck.ck-button:active,
a.ck.ck-button:focus,
a.ck.ck-button:active {
  box-shadow: none !important;
  border: 1px solid var(--vz-light) !important;
}
.ck.ck-button:not(.ck-disabled):hover,
a.ck.ck-button:not(.ck-disabled):hover {
  background: var(--vz-light) !important;
}
.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: var(--vz-light) !important;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.ck-editor__editable {
  min-height: 245px !important;
}

.ck[class*=ck-heading_heading] {
  font-weight: 500 !important;
}

.ck.ck-button.ck-on:not(.ck-disabled):hover, .ck.ck-button.ck-on:not(.ck-disabled):active,
a.ck.ck-button.ck-on:not(.ck-disabled):hover,
a.ck.ck-button.ck-on:not(.ck-disabled):active {
  box-shadow: none !important;
}

.ck.ck-tooltip .ck-tooltip__text {
  background: #212529 !important;
  color: #f3f6f9 !important;
}
.ck.ck-input-text {
  background: var(--vz-input-bg) !important;
  border: 1px solid var(--vz-input-border) !important;
}
.ck.ck-input-text:focus {
  border: 1px solid var(--vz-input-focus-border) !important;
  box-shadow: none !important;
}
.ck.ck-balloon-panel {
  background: #fff !important;
  border: 1px solid var(--vz-border-color) !important;
}
.ck.ck-balloon-panel[class*=arrow_n]:after {
  border-bottom-color: #fff !important;
}
.ck.ck-balloon-panel[class*=arrow_n]::before {
  border-bottom-color: var(--vz-border-color) !important;
}

.ck.ck-labeled-field-view > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
  background: #fff !important;
}

.ck-editor-reverse .ck-editor {
  display: flex;
  flex-direction: column-reverse;
}
.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable {
  border: 1px solid var(--vz-input-border) !important;
  border-bottom: 0 !important;
}
.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck-editor-reverse .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

[dir=rtl] .ck.ck-toolbar > .ck-toolbar__items {
  flex-direction: row-reverse;
}

.ql-editor {
  text-align: left;
}
.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
  padding-right: 0;
}
.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}

.ql-container {
  font-family: var(--vz-font-sans-serif);
}
.ql-container.ql-snow {
  border-color: var(--vz-input-border);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.ql-bubble {
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
}

.ql-toolbar {
  font-family: var(--vz-font-sans-serif) !important;
}
.ql-toolbar span {
  outline: none !important;
  color: var(--vz-choices-link-color);
}
.ql-toolbar span:hover {
  color: #405189 !important;
}
.ql-toolbar.ql-snow {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-color: var(--vz-input-border);
}
.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: transparent;
}
.ql-toolbar.ql-snow .ql-picker-options {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border-radius: 0.3rem;
}

.ql-snow .ql-stroke,
.ql-snow .ql-script,
.ql-snow .ql-strike svg {
  stroke: var(--vz-choices-link-color);
}
.ql-snow .ql-fill {
  fill: var(--vz-choices-link-color);
}
.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  right: 0;
  left: auto;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: var(--vz-choices-link-color);
}

.ql-snow .ql-picker-options {
  background-color: var(--vz-choices-bg);
  border-color: var(--vz-border-color) !important;
}

.gridjs-container {
  color: var(--vz-body-color);
  padding: 0;
  display: block;
}

.gridjs-wrapper {
  box-shadow: none;
  border: 1px solid var(--vz-border-color);
  border-radius: 0px;
}
.gridjs-wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
}
.gridjs-wrapper::-webkit-scrollbar:vertical {
  width: 12px;
}
.gridjs-wrapper::-webkit-scrollbar:horizontal {
  height: 12px;
}
.gridjs-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 10px;
  border: 2px solid var(--vz-card-bg-custom);
}
.gridjs-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-card-bg-custom);
}

.gridjs-footer {
  border: none !important;
  padding: 12px 0 0;
}

.gridjs-table {
  width: 100%;
}

.gridjs-tbody, td.gridjs-td {
  background-color: transparent;
}

th.gridjs-th,
td.gridjs-td {
  border: 1px solid var(--vz-border-color);
  padding: 0.75rem 0.6rem;
}

th.gridjs-th {
  border-top: 0;
  color: var(--vz-body-color);
  background-color: rgba(var(--vz-light-rgb), 0.75);
}
th.gridjs-th-sort:focus, th.gridjs-th-sort:hover {
  background-color: rgba(var(--vz-light-rgb), 0.85);
}

.gridjs-head {
  padding-top: 0;
}

.gridjs-footer {
  box-shadow: none;
  border: 1px solid var(--vz-border-color);
  border-top: 0;
  background-color: transparent;
}

.gridjs-summary {
  color: #878a99;
  margin-top: 8px !important;
}

.gridjs-pagination .gridjs-pages button {
  margin-left: 0.3rem;
  border-radius: 0.25rem !important;
  border: 1px solid var(--vz-border-color);
  background-color: var(--vz-card-bg-custom);
  color: var(--vz-link-color);
}
.gridjs-pagination .gridjs-pages button:last-child {
  border-right: 1px solid var(--vz-border-color);
}
.gridjs-pagination .gridjs-pages button:disabled, .gridjs-pagination .gridjs-pages button:hover:disabled, .gridjs-pagination .gridjs-pages button[disabled] {
  color: #878a99;
  background-color: var(--vz-card-bg-custom);
}
.gridjs-pagination .gridjs-pages button:hover {
  background-color: #eff2f7;
  color: var(--vz-link-hover-color);
}
.gridjs-pagination .gridjs-pages button:focus {
  box-shadow: none;
}
.gridjs-pagination .gridjs-pages button:last-child:hover, .gridjs-pagination .gridjs-pages button:first-child:hover {
  background-color: transparent;
}
.gridjs-pagination .gridjs-pages button.gridjs-currentPage {
  background-color: #405189;
  color: #fff;
  border-color: #405189;
  font-weight: 500;
}

.gridjs-search {
  position: relative;
  float: left;
}
.gridjs-search::before {
  content: "\\f0d1";
  font-family: "remixicon";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  font-size: 14px;
  color: #878a99;
}

input.gridjs-input {
  border-color: var(--vz-input-border);
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  line-height: 1.5;
  padding: 0.5rem 0.9rem 0.5rem 2.025rem;
  border-radius: 0.25rem;
  font-size: 0.8125rem;
}
input.gridjs-input:focus {
  box-shadow: none;
  border-color: var(--vz-input-focus-border);
  background-color: var(--vz-input-bg);
}
input.gridjs-input::placeholder {
  color: #878a99;
}

th.gridjs-th .gridjs-th-content {
  float: none;
  display: inline-block;
  vertical-align: middle;
  font-weight: 600;
}

button.gridjs-sort {
  float: none;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 20px;
}

th.gridjs-th-sort .gridjs-th-content {
  width: calc(100% - 10px);
}

button.gridjs-sort-asc, button.gridjs-sort-desc {
  background-size: 7px;
}

.table-card .gridjs-head {
  padding: 16px 16px 5px;
}
.table-card .gridjs-wrapper {
  border-top: 0;
  border-radius: 0;
  border-width: 1px 0;
}
.table-card .gridjs-footer {
  padding: 8px 16px;
}

.gridjs-tr-selected td {
  background-color: rgba(var(--vz-light-rgb), 1);
}
.gridjs-tr-selected .gridjs-td .gridjs-checkbox[type=checkbox] {
  background-color: #405189;
  border-color: #405189;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
}

.gridjs-td .gridjs-checkbox {
  width: 1.1em;
  height: 1.1em;
  vertical-align: top;
  background-color: var(--vz-input-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--vz-input-check-border);
  appearance: none;
  print-print-color-adjust: exact;
}
.gridjs-td .gridjs-checkbox[type=checkbox] {
  border-radius: 0.25em;
}

.gridjs-border-none td.gridjs-td, .gridjs-border-none th.gridjs-th {
  border-right-width: 0;
  border-left-width: 0;
}

.gridjs-loading-bar {
  background-color: var(--vz-card-bg-custom);
}

[data-layout-mode=dark] button.gridjs-sort-neutral, [data-layout-mode=dark] button.gridjs-sort-asc, [data-layout-mode=dark] button.gridjs-sort-desc {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.listjs-pagination {
  margin-bottom: 0;
  justify-content: flex-end;
  gap: 8px;
}
.listjs-pagination li .page {
  display: block;
  padding: 0.375rem 0.75rem;
  color: var(--vz-link-color);
  background-color: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
}
.listjs-pagination li.active .page {
  color: #fff;
  background-color: #405189;
  border-color: #405189;
}

.pagination-wrap {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center;
}
.pagination-wrap a {
  text-decoration: none;
  display: inline-block;
}

.pagination-next,
.pagination-prev {
  color: #405189;
  font-weight: 500;
  padding: 0.375rem 0.75rem;
  background-color: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
}
.pagination-next:hover,
.pagination-prev:hover {
  color: rgb(113.9104477612, 131.4179104478, 189.0895522388);
}
.pagination-next.disabled,
.pagination-prev.disabled {
  color: #878a99;
  cursor: default;
}
.pagination-next.disabled:hover,
.pagination-prev.disabled:hover {
  color: #878a99;
}

.apex-charts {
  min-height: 10px !important;
}
.apex-charts text {
  font-family: var(--vz-font-sans-serif) !important;
}
.apex-charts .apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-tooltip-title,
.apexcharts-tooltip-text {
  font-family: var(--vz-font-sans-serif) !important;
}

.apexcharts-tooltip {
  border: 1px solid var(--vz-border-color) !important;
  background-color: var(--vz-card-bg-custom) !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
}
.apexcharts-tooltip * {
  font-family: var(--vz-font-sans-serif) !important;
  color: #878a99 !important;
}
.apexcharts-tooltip .apexcharts-tooltip-title {
  background-color: rgba(var(--vz-light-rgb), 0.75) !important;
  border-bottom: 1px solid var(--vz-border-color) !important;
}

.apexcharts-tooltip.apexcharts-theme-dark * {
  color: #fff !important;
}

.apexcharts-legend-series {
  font-weight: 500;
}

.apexcharts-gridline {
  pointer-events: none;
  stroke: rgba(var(--vz-light-rgb), 0.75);
}

.apexcharts-legend-text {
  color: #878a99 !important;
  font-family: var(--vz-font-sans-serif) !important;
  font-size: 13px !important;
}

.apexcharts-pie-label {
  fill: #fff !important;
}

.apexcharts-title-text, .apexcharts-subtitle-text {
  fill: #adb5bd;
}

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: var(--vz-font-sans-serif) !important;
  fill: #adb5bd;
}

.apexcharts-yaxis-title {
  font-weight: 500;
}

#dynamicloadedchart-wrap {
  margin: 0px auto;
  max-width: 800px;
  position: relative;
}

.chart-box {
  padding-left: 0;
}

#chart-year,
#chart-quarter {
  width: 96%;
  max-width: 48%;
  box-shadow: none;
  padding-left: 0;
  padding-top: 20px;
  background: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-border-color);
}

#chart-year {
  float: left;
  position: relative;
  transition: 1s ease transform;
  z-index: 3;
}
#chart-year.chart-quarter-activated {
  transform: translateX(0);
  transition: 1s ease transform;
}

#chart-quarter {
  float: left;
  position: relative;
  z-index: -2;
  transition: 1s ease transform;
}
#chart-quarter.active {
  transition: 1.1s ease-in-out transform;
  transform: translateX(0);
  z-index: 1;
}

@media screen and (min-width: 480px) {
  #chart-year {
    transform: translateX(50%);
  }
  #chart-quarter {
    transform: translateX(-50%);
  }
}
.apexcharts-radar-series polygon, .apexcharts-radar-series line {
  stroke: var(--vz-border-color);
}

.apexcharts-pie circle, .apexcharts-pie line {
  stroke: var(--vz-border-color);
}
.apexcharts-pie text {
  fill: var(--vz-body-color);
}

.apex-charts .apexcharts-xaxis line,
.apex-charts .apexcharts-yaxis line {
  stroke: var(--vz-border-color);
}
.apex-charts .apexcharts-xaxis-tick {
  stroke: var(--vz-border-color);
}
.apex-charts .apexcharts-pie-series path,
.apex-charts .apexcharts-bar-series path {
  stroke: var(--vz-card-bg-custom);
}
.apex-charts .apexcharts-radialbar-track path {
  stroke: var(--vz-light);
}
.apex-charts .apexcharts-marker {
  stroke: var(--vz-card-bg-custom);
}
.apex-charts .apexcharts-boxPlot-series path {
  stroke: var(--vz-border-color);
}
.apex-charts .apexcharts-treemap rect,
.apex-charts .apexcharts-heatmap-series rect {
  stroke: var(--vz-card-bg-custom);
}

.chartjs-chart {
  max-height: 320px;
}

.e-charts {
  height: 350px;
}

.e-charts-height {
  height: 300px;
}

.gmaps, .gmaps-panaroma {
  height: 300px;
  background: #f3f6f9;
  border-radius: 3px;
}

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: #405189;
  border-radius: 4px;
  padding: 10px 20px;
}

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute;
}
.gmaps-overlay_arrow.above {
  bottom: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #405189;
}
.gmaps-overlay_arrow.below {
  top: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #405189;
}

.autoComplete_wrapper {
  display: block;
}
.autoComplete_wrapper > input {
  display: block;
  width: 100%;
  height: auto;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
  background-image: none;
}
.autoComplete_wrapper > input::placeholder {
  padding: 0 !important;
  color: #878a99 !important;
  font-size: 0.8125rem !important;
}
.autoComplete_wrapper > input:focus {
  border: 1px solid var(--vz-input-focus-border);
  color: var(--vz-body-color);
}
.autoComplete_wrapper > input:hover {
  color: var(--vz-body-color);
}
.autoComplete_wrapper > ul {
  border-radius: 0.25rem;
  border-color: var(--vz-border-color);
  background-color: #fff;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  padding: 0;
  overflow: auto;
  max-height: 160px;
  margin: 0;
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
}
.autoComplete_wrapper > ul > li {
  font-size: 0.8125rem;
  margin: 0;
  padding: 0.35rem 1.2rem;
  border-radius: 0;
  background-color: #fff;
  color: var(--vz-body-color);
}
.autoComplete_wrapper > ul > li mark, .autoComplete_wrapper > ul > li .mark {
  color: #f06548;
  font-weight: 600;
  padding: 1px;
}
.autoComplete_wrapper > ul > li[aria-selected=true], .autoComplete_wrapper > ul > li:hover {
  color: rgb(29.7, 33.3, 36.9);
  background-color: #f3f6f9;
}
.autoComplete_wrapper > ul .no_result {
  padding: 0.7rem 1.2rem;
  font-style: italic;
  font-weight: 500;
}

.jvm-tooltip {
  border-radius: 3px;
  background-color: #405189;
  font-family: var(--vz-font-sans-serif);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  padding: 5px 9px;
}

.jvm-container text {
  font-family: var(--vz-font-sans-serif);
  font-size: 0.8125rem;
  fill: var(--vz-gray-700);
}

.jvm-zoom-btn {
  background-color: #405189;
}

.leaflet-map {
  height: 300px;
}
.leaflet-map.leaflet-container {
  z-index: 0;
  font-family: "Open Sans", sans-serif;
}

.fc td,
.fc th {
  border: 1px solid var(--vz-border-color);
}

.fc .fc-toolbar h2, .fc .fc-toolbar .h2 {
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase;
}
@media (max-width: 767.98px) {
  .fc .fc-toolbar .fc-left,
  .fc .fc-toolbar .fc-right,
  .fc .fc-toolbar .fc-center {
    float: none;
    display: block;
    text-align: center;
    clear: both;
    margin: 10px 0;
  }
  .fc .fc-toolbar > * > * {
    float: none;
  }
  .fc .fc-toolbar .fc-today-button {
    display: none;
  }
}
.fc .fc-toolbar .btn {
  text-transform: capitalize;
}
.fc .fc-col-header-cell {
  background-color: var(--vz-light);
}
.fc .fc-col-header-cell-cushion {
  display: block;
  padding: 8px 4px;
}
.fc .fc-daygrid-day-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  margin: 2px;
}
.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(64, 81, 137, 0.1);
}
.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {
  background-color: #405189;
  color: #fff;
}
.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(64, 81, 137, 0.1);
}
.fc .fc-timegrid-col.fc-day-today {
  background-color: rgba(64, 81, 137, 0.1);
}
.fc .fc-list-event:hover td {
  background: transparent;
}
.fc .fc-list-event-title a {
  color: #fff !important;
}
.fc .fc-col-header,
.fc .fc-daygrid-body,
.fc .fc-scrollgrid-sync-table {
  width: 100% !important;
}
.fc .fc-scrollgrid-section > * {
  border-left: 1px solid var(--vz-border-color);
  border-top: 1px solid var(--vz-border-color);
}
.fc .fc-scrollgrid-section-liquid > td {
  border-top: 0;
}

.fc-theme-bootstrap a:not([href]) {
  color: var(--vz-body-color);
}

.fc-event {
  color: #fff;
}

.fc th.fc-widget-header {
  background: #e9ebec;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 700;
}

.fc-unthemed .fc-content,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-list-heading td,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-row,
.fc-unthemed tbody,
.fc-unthemed td,
.fc-unthemed th,
.fc-unthemed thead {
  border-color: #e9ebec;
}
.fc-unthemed td.fc-today {
  background: rgb(245.8, 247.525, 250.4);
}

.fc-button {
  background: var(--vz-card-bg-custom);
  border-color: var(--vz-border-color);
  color: #495057;
  text-transform: capitalize;
  box-shadow: none;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #405189;
  color: #fff;
  text-shadow: none;
}

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center;
}

.fc-event,
.fc-event-dot {
  background-color: #405189;
}

.fc-daygrid-dot-event.fc-event-mirror,
.fc-daygrid-dot-event:hover {
  background-color: #405189;
}

.fc-event-title,
.fc-sticky {
  font-weight: 600 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fc-daygrid-event-dot {
  border-color: #fff !important;
  display: none;
}

.fc-event-time {
  display: none;
}

.fc-event .fc-content {
  color: #fff;
}

#external-events .external-event {
  text-align: left;
  padding: 8px 16px;
  margin: 6px 0;
}

.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark .fc-content {
  color: #f3f6f9;
}

.fc-prev-button,
.fc-next-button {
  position: relative;
  height: 37.5px;
  width: 37.5px;
}
.fc-prev-button::before,
.fc-next-button::before {
  position: absolute;
  font-family: remixicon !important;
  font-size: 20px;
  top: 0;
  bottom: 0px;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fc-prev-button::before {
  content: "\\ea64";
}

.fc-next-button::before {
  content: "\\ea6e";
}

.fc-toolbar-chunk .btn-group {
  box-shadow: none;
}
.fc-toolbar-chunk .btn-group .btn {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.15);
  border: none;
  box-shadow: none;
}
.fc-toolbar-chunk .btn-group .btn:hover, .fc-toolbar-chunk .btn-group .btn.active {
  color: #fff;
  background-color: #3577f1;
}
.fc-toolbar-chunk .fc-today-button {
  background-color: #3577f1 !important;
  border: #3577f1;
}

@media (max-width: 575.98px) {
  .fc-toolbar {
    flex-direction: column;
    gap: 16px;
  }
}

#upcoming-event-list .card:last-child {
  margin-bottom: 6px !important;
}

#event-modal .event-details {
  display: none;
}
#event-modal .view-event .event-form {
  display: none;
}
#event-modal .view-event #event-category-tag {
  display: none;
}
#event-modal .view-event .event-details {
  display: block;
}

.fc-daygrid-event-harness .fc-daygrid-event {
  backdrop-filter: blur(4px);
}

.fc-timegrid-event-harness .fc-timegrid-event {
  backdrop-filter: blur(4px);
}

.fc-timegrid-slots table tr {
  border-color: var(--vz-border-color) !important;
}

.fc-list-table {
  border-color: var(--vz-border-color);
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-main {
  color: #405189 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-primary .fc-event-title {
  color: #405189 !important;
}

.fc-list-table .fc-list-event.bg-soft-primary {
  color: #405189 !important;
}
.fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-title > a {
  color: #405189 !important;
}
.fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-dot {
  border-color: #405189;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-main {
  color: #3577f1 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-secondary .fc-event-title {
  color: #3577f1 !important;
}

.fc-list-table .fc-list-event.bg-soft-secondary {
  color: #3577f1 !important;
}
.fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-title > a {
  color: #3577f1 !important;
}
.fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-dot {
  border-color: #3577f1;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-main {
  color: #0ab39c !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-success .fc-event-title {
  color: #0ab39c !important;
}

.fc-list-table .fc-list-event.bg-soft-success {
  color: #0ab39c !important;
}
.fc-list-table .fc-list-event.bg-soft-success .fc-list-event-title > a {
  color: #0ab39c !important;
}
.fc-list-table .fc-list-event.bg-soft-success .fc-list-event-dot {
  border-color: #0ab39c;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-main {
  color: #299cdb !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-info .fc-event-title {
  color: #299cdb !important;
}

.fc-list-table .fc-list-event.bg-soft-info {
  color: #299cdb !important;
}
.fc-list-table .fc-list-event.bg-soft-info .fc-list-event-title > a {
  color: #299cdb !important;
}
.fc-list-table .fc-list-event.bg-soft-info .fc-list-event-dot {
  border-color: #299cdb;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-main {
  color: #f7b84b !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-warning .fc-event-title {
  color: #f7b84b !important;
}

.fc-list-table .fc-list-event.bg-soft-warning {
  color: #f7b84b !important;
}
.fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-title > a {
  color: #f7b84b !important;
}
.fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-dot {
  border-color: #f7b84b;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-main {
  color: #f06548 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-danger .fc-event-title {
  color: #f06548 !important;
}

.fc-list-table .fc-list-event.bg-soft-danger {
  color: #f06548 !important;
}
.fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-title > a {
  color: #f06548 !important;
}
.fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-dot {
  border-color: #f06548;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-main {
  color: #f3f6f9 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-light .fc-event-title {
  color: #f3f6f9 !important;
}

.fc-list-table .fc-list-event.bg-soft-light {
  color: #f3f6f9 !important;
}
.fc-list-table .fc-list-event.bg-soft-light .fc-list-event-title > a {
  color: #f3f6f9 !important;
}
.fc-list-table .fc-list-event.bg-soft-light .fc-list-event-dot {
  border-color: #f3f6f9;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main {
  color: #212529 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-dark .fc-event-title {
  color: #212529 !important;
}

.fc-list-table .fc-list-event.bg-soft-dark {
  color: #212529 !important;
}
.fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-title > a {
  color: #212529 !important;
}
.fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-dot {
  border-color: #212529;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main, .fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title {
  color: var(--vz-dark) !important;
}

.fc-direction-ltr {
  direction: ltr;
}
.fc-direction-ltr .fc-toolbar > * > :not(:first-child) {
  margin-left: 0.75em;
}

.fg-emoji-picker {
  width: 250px !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
  top: auto !important;
  bottom: 130px;
}
.fg-emoji-picker * {
  font-family: var(--vz-font-sans-serif) !important;
  color: var(--vz-body-color) !important;
}
@media (max-width: 991.98px) {
  .fg-emoji-picker {
    left: 14px !important;
    top: auto !important;
    bottom: 118px;
  }
}
.fg-emoji-picker .fg-emoji-picker-container-title {
  color: #212529 !important;
}
.fg-emoji-picker .fg-emoji-picker-search {
  height: 40px !important;
}
.fg-emoji-picker .fg-emoji-picker-search input {
  background-color: var(--vz-input-bg) !important;
  color: var(--vz-body-color) !important;
  padding: 0.5rem 0.9rem !important;
  font-size: 0.8125rem !important;
}
.fg-emoji-picker .fg-emoji-picker-search input::placeholder {
  color: #878a99 !important;
}
.fg-emoji-picker .fg-emoji-picker-search svg {
  fill: var(--vz-body-color) !important;
  right: 11px;
  top: 12px;
}
.fg-emoji-picker .fg-emoji-picker-categories {
  background-color: #f3f6f9 !important;
}
.fg-emoji-picker .fg-emoji-picker-categories li.active {
  background-color: rgba(var(--bs-primary-rgb), 0.2);
}
.fg-emoji-picker .fg-emoji-picker-categories a:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.2);
}

.fg-emoji-picker-grid > li:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.2) !important;
}

a.fg-emoji-picker-close-button {
  background-color: rgb(229.4, 235.8, 242.2) !important;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
  padding: 50px;
  font-weight: 600;
  --vz-table-accent-bg: var(--vz-card-bg-custom);
}

table.dataTable > thead .sorting:before,
table.dataTable > thead .sorting_asc:before,
table.dataTable > thead .sorting_desc:before,
table.dataTable > thead .sorting_asc_disabled:before,
table.dataTable > thead .sorting_desc_disabled:before {
  content: "\\f0360";
  position: absolute;
  right: 0.5rem;
  top: 12px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}

table.dataTable > thead .sorting:after,
table.dataTable > thead .sorting_asc:after,
table.dataTable > thead .sorting_desc:after,
table.dataTable > thead .sorting_asc_disabled:after,
table.dataTable > thead .sorting_desc_disabled:after {
  content: "\\f035d";
  position: absolute;
  right: 0.5rem;
  top: 18px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}

table.dataTable > tbody > tr.child span.dtr-title {
  font-weight: 600;
  min-width: 150px;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > th.dtr-control::before, table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control::before {
  background-color: #405189;
  border-color: var(--vz-card-bg-custom);
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent.parent > th.dtr-control::before {
  background-color: #f06548;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td.dtr-control::before {
  background-color: #f06548;
}
table.dataTable > tbody > tr.child span.dtr-title {
  min-width: 135px;
}

.table-card .dataTables_length,
.table-card .dataTables_filter {
  padding: 1rem 1rem;
  padding-bottom: 0px;
}
.table-card .dataTables_info,
.table-card .dataTables_paginate {
  padding: 1rem 1rem;
}
.table-card div.dataTables_wrapper .col-md-6 {
  width: 100%;
}
.table-card div.dataTables_wrapper div.dataTables_filter input {
  width: calc(100% - 52px);
}
.table-card div.dataTables_wrapper div.dataTables_filter label {
  display: block;
}

div.dtr-modal div.dtr-modal-display {
  background-color: #fff;
  border-color: var(--vz-border-color);
  box-shadow: none;
  height: 70%;
}
div.dtr-modal div.dtr-modal-content {
  padding: 1.25rem;
}
div.dtr-modal div.dtr-modal-content h2, div.dtr-modal div.dtr-modal-content .h2 {
  font-size: 1.015625rem;
  font-weight: 600;
  margin-bottom: 15px;
}
div.dtr-modal div.dtr-modal-content .dtr-details tr td {
  padding: 0.75rem 0.6rem;
}
div.dtr-modal div.dtr-modal-close {
  font-size: 24px;
  top: 9px;
  right: 11px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  background-color: var(--vz-card-bg-custom);
  border-color: var(--vz-border-color);
}
div.dtr-modal div.dtr-modal-close:hover {
  background-color: var(--vz-light);
}

.dt-buttons button.dt-button,
.dt-buttons div.dt-button,
.dt-buttons a.dt-button,
.dt-buttons input.dt-button {
  border-color: var(--vz-border-color);
  background: var(--vz-light);
  color: var(--vz-gray-800);
}

.select2.select2-container {
  width: 100% !important;
}

.select2-container .select2-selection--single {
  border: 1px solid var(--vz-input-border);
  height: calc(1.5em + 1rem + 2px);
  background-color: var(--vz-input-bg);
  outline: none;
}
.select2-container .select2-selection--single .select2-selection__rendered {
  line-height: 36px;
  padding-left: 12px;
  color: var(--vz-body-color);
}
.select2-container .select2-selection--single .select2-selection__arrow {
  height: 34px;
  width: 34px;
  /*rtl:ignore*/
  right: 3px;
}
.select2-container .select2-selection--single .select2-selection__arrow b {
  border-color: var(--vz-input-border) transparent transparent transparent;
  border-width: 6px 6px 0 6px;
}

.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: transparent transparent var(--vz-input-border) transparent !important;
  border-width: 0 6px 6px 6px !important;
}

.select2-results__option {
  padding: 6px 12px;
}

.select2-dropdown {
  border: 0 solid var(--vz-border-color);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  background-color: var(--vz-choices-bg);
  z-index: 1056;
}

.select2-container--default .select2-results__option--selected {
  background-color: var(--vz-input-disabled-bg);
}
.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: var(--vz-choices-bg);
}
.select2-container--default .select2-search--dropdown .select2-search__field {
  outline: none;
  border: 1px solid var(--vz-input-border);
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  border-radius: 0.25rem;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #405189;
}
.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: var(--vz-choices-bg);
  color: var(--vz-choices-link-active-color);
}
.select2-container--default .select2-results__option[aria-selected=true]:hover {
  background-color: #405189;
  color: #fff;
}
.select2-container--default .select2-selection--multiple .select2-selection__choice__display {
  padding-left: 36px;
  padding-right: 5px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  /*rtl:ignore*/
  right: 1px;
  /*rtl:ignore*/
  left: auto;
}

.select2-container .select2-selection--multiple {
  min-height: calc(1.5em + 1rem + 2px);
  border: 1px solid var(--vz-input-border) !important;
  background-color: var(--vz-input-bg);
}
.select2-container .select2-selection--multiple .select2-selection__rendered {
  padding: 1px 4px;
}
.select2-container .select2-selection--multiple .select2-search__field {
  border: 0;
  color: var(--vz-body-color);
}
.select2-container .select2-selection--multiple .select2-selection__choice {
  background-color: #405189;
  border: none;
  color: #fff;
  border-radius: 3px;
  padding: 3px;
  margin-top: 6px;
}
.select2-container .select2-selection--multiple .select2-selection__choice__remove {
  color: #fff;
  margin-right: 7px;
  border-color: rgb(83.1, 98.4, 148.8);
  padding: 0 8px;
  top: 3px;
}
.select2-container .select2-selection--multiple .select2-selection__choice__remove:hover {
  color: #fff;
  background-color: #405189;
}
.select2-container .select2-search--inline .select2-search__field {
  margin-top: 7px;
  font-family: var(--vz-font-sans-serif);
}
.select2-container .select2-search textarea::placeholder {
  color: #878a99;
}

.select2-container--default.select2-container--disabled .select2-selection--single, .select2-container--default.select2-container--disabled .select2-selection--multiple {
  background-color: var(--vz-input-disabled-bg);
  cursor: default;
}

[data-input-flag] {
  position: relative;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list {
  max-height: 158px;
  overflow-y: auto;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar {
  -webkit-appearance: none;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar:vertical {
  width: 8px;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar:horizontal {
  height: 10px;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 8px;
}
[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-track {
  border-radius: 8px;
}

[data-option-flag-img-name] .flag-input {
  padding-left: 45px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
  background-repeat: no-repeat;
  background-position: 14px 8px;
  background-size: 18px;
}

[data-option-flag-name]::before,
[data-option-flag-img-name]::before {
  content: "\\f0140";
  font-family: "Material Design Icons";
  position: absolute;
  right: 0.9rem;
  top: 0.5rem;
  font-size: 16px;
}

[data-option-countrycode=false] .country-codeno {
  display: none;
}

[data-search-input=false] .searchlist-input {
  display: none;
}

.toastify {
  padding: 12px 16px;
  color: #fff;
  display: inline-block;
  box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);
  background: #0ab39c;
  position: fixed;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  border-radius: 2px;
  cursor: pointer;
  text-decoration: none;
  max-width: calc(50% - 20px);
  z-index: 2147483647;
}
.toastify.on {
  opacity: 1;
}

.toast-close {
  opacity: 0.4;
  padding: 0 5px;
  position: relative;
  left: 4px;
  margin-left: 4px;
  border: none;
  background: none;
}

.toastify-right {
  right: 15px;
}

.toastify-left {
  left: 15px;
}
.toastify-left .toast-close {
  left: -4px;
  margin-left: 0;
  margin-right: 4px;
}

.toastify-top {
  top: -150px;
}

.toastify-bottom {
  bottom: -150px;
}

.toastify-rounded {
  border-radius: 25px;
}

.toastify-avatar {
  width: 1.5em;
  height: 1.5em;
  margin: -7px 5px;
  border-radius: 2px;
}

.toastify-center {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  max-width: fit-content;
  max-width: -moz-fit-content;
}

@media only screen and (max-width: 360px) {
  .toastify-right, .toastify-left {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    max-width: -moz-fit-content;
    max-width: fit-content;
  }
}
.choices {
  position: relative;
  margin-bottom: 24px;
  font-size: 16px;
}
.choices:focus {
  outline: none;
}
.choices:last-child {
  margin-bottom: 0;
}
.choices.is-disabled .choices__inner,
.choices.is-disabled .choices__input {
  background-color: rgba(var(--vz-light-rgb), 0.75);
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
}
.choices.is-disabled .choices__item {
  cursor: not-allowed;
}
.choices [hidden] {
  display: none !important;
}
.choices[data-type*=select-one] {
  cursor: pointer;
}
.choices[data-type*=select-one] .choices__inner {
  padding-bottom: 0.25rem;
}
.choices[data-type*=select-one] .choices__input {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem;
  background-color: var(--vz-input-bg);
  border: 1px solid var(--vz-input-border);
  font-size: 0.8125rem;
  border-radius: 0.25rem;
  color: var(--vz-body-color);
  margin-bottom: 10px;
}
.choices[data-type*=select-one] .choices__button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  padding: 0;
  background-size: 8px;
  position: absolute;
  top: 50%;
  right: 0;
  left: auto;
  margin-top: -10px;
  margin-right: 25px;
  margin-left: 0;
  height: 20px;
  width: 20px;
  border-radius: 10em;
  opacity: 0.5;
}
.choices[data-type*=select-one] .choices__button:hover, .choices[data-type*=select-one] .choices__button:focus {
  opacity: 1;
}
.choices[data-type*=select-one] .choices__button:focus {
  box-shadow: 0px 0px 0px 2px #00bcd4;
}
.choices[data-type*=select-one] .choices__item[data-value=""] .choices__button {
  display: none;
}
.choices[data-type*=select-one]:after {
  content: "\\f0140";
  position: absolute;
  border: 0;
  border-color: #212529 transparent transparent;
  right: 11.5px;
  left: auto;
  font-family: "Material Design Icons";
  width: auto;
  height: auto;
  margin-top: 0;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
.choices[data-type*=select-one].is-open:after {
  margin-top: 0;
  transform: translateY(-50%) rotate(-180deg);
}
.choices[data-type*=select-multiple] .choices__inner, .choices[data-type*=text] .choices__inner {
  cursor: text;
  padding-right: 0.9rem;
}
.choices[data-type*=select-multiple] .choices__button, .choices[data-type*=text] .choices__button {
  position: relative;
  display: inline-block;
  margin-top: 0;
  margin-right: -4px;
  margin-bottom: 0;
  margin-left: 8px;
  padding-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  border-right: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  background-size: 8px;
  width: 8px;
  line-height: 1;
  opacity: 0.75;
  border-radius: 0;
}
.choices[data-type*=select-multiple] .choices__button:hover, .choices[data-type*=select-multiple] .choices__button:focus, .choices[data-type*=text] .choices__button:hover, .choices[data-type*=text] .choices__button:focus {
  opacity: 1;
}
.choices[data-type*=select-multiple] .choices__list--dropdown, .choices[data-type*=text] .choices__list--dropdown {
  padding-bottom: 10px;
}
.choices[data-type*=select-multiple] .choices__list--dropdown .choices__list, .choices[data-type*=text] .choices__list--dropdown .choices__list {
  margin-bottom: 0;
}
.choices[data-type*=select-multiple] .choices__input {
  padding-top: 3px;
}

.input-light .choices__inner {
  background-color: var(--vz-light);
  border: none;
}

.choices__inner {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  background-color: var(--vz-input-bg);
  padding: 0.25rem 3.6rem 0.1rem 0.5rem;
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem !important;
  font-size: 0.8125rem;
  min-height: 37.5px;
  overflow: hidden;
}

.is-focused .choices__inner,
.is-open .choices__inner {
  border-color: var(--vz-input-focus-border);
}

.choices__list {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.choices__list--single {
  display: inline-block;
  padding: 4px 16px 4px 4px;
  width: 100%;
}
.choices__list--single .choices__item {
  width: 100%;
}

.choices__list--multiple {
  display: inline;
}
.choices__list--multiple .choices__item {
  display: inline-block;
  vertical-align: initial;
  border-radius: 7px;
  padding: 2px 7px;
  font-size: 11px;
  font-weight: 400;
  margin-right: 3.75px;
  margin-bottom: 3.75px;
  margin-top: 2px;
  background-color: #405189;
  border: 1px solid #405189;
  word-break: break-all;
  box-sizing: border-box;
  color: #fff;
  box-shadow: none;
}
.choices__list--multiple .choices__item[data-deletable] {
  padding-right: 5px;
}
.choices__list--multiple .choices__item.is-highlighted {
  background-color: #405189;
  border: 1px solid #405189;
}

.is-disabled .choices__list--multiple .choices__item {
  background-color: #3577f1;
  border: 1px solid #3577f1;
}

.choices__list--dropdown {
  visibility: hidden;
  z-index: 1;
  position: absolute;
  width: 100%;
  background-color: var(--vz-choices-bg);
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  top: 100%;
  margin-top: 0;
  padding: 10px 10px 20px 10px;
  border-bottom-left-radius: 2.5px;
  border-bottom-right-radius: 2.5px;
  overflow: hidden;
  word-break: break-all;
  will-change: visibility;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  transform: translateY(1px);
}
.choices__list--dropdown.is-active {
  visibility: visible;
  animation-name: DropDownSlide;
}
.choices__list--dropdown .choices__item--selectable.is-highlighted {
  background-color: var(--vz-choices-link-hover-bg);
}
.choices__list--dropdown .choices__list {
  margin: 0 -16px -16px;
}
.choices__list--dropdown .has-no-results {
  font-style: italic;
  font-weight: 500;
}
.choices__list--dropdown .choices__item--selectable:after {
  display: none;
}

.is-open .choices__list--dropdown {
  border-color: var(--vz-border-color);
}

.is-flipped .choices__list--dropdown {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: -1px;
  border-radius: 0.25rem 0.25rem 0 0;
}
.is-flipped .choices__list--dropdown.is-active {
  animation-name: DropDownSlideDown;
  transform: translateY(-1px);
}

.choices__list--dropdown .choices__list {
  position: relative;
  max-height: 300px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position;
}
.choices__list--dropdown .choices__item {
  position: relative;
  font-size: 0.8125rem;
  padding: 0.35rem 1.2rem 0.35rem 16px;
}

@media (min-width: 640px) {
  .choices__list--dropdown .choices__item--selectable:after {
    content: attr(data-select-text);
    font-size: 12px;
    opacity: 0;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
  .choices__list--dropdown .choices__item--selectable.is-highlighted:after {
    opacity: 0.5;
  }
}
.choices__item {
  cursor: default;
}

.choices__item--selectable {
  cursor: pointer;
}

.choices__item--disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.5;
}

.choices__heading {
  font-weight: 600;
  font-size: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--vz-border-color);
  color: #878a99;
}

.choices__button {
  text-indent: -9999px;
  appearance: none;
  border: 0;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}
.choices__button:focus {
  outline: none;
}

.choices__input {
  display: inline-block;
  vertical-align: baseline;
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  font-size: 0.8125rem;
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
  max-width: 100%;
  padding: 2px 0 2px 2px;
}
.choices__input:focus {
  outline: 0;
}
.choices__input::placeholder {
  color: #878a99;
}

.choices__placeholder {
  color: #878a99;
  opacity: 1;
}

[data-layout-mode=dark] .choices[data-type*=select-one] .choices__button {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.flatpickr-calendar {
  background: transparent;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  background: var(--vz-choices-bg);
  box-shadow: 1px 0 0 var(--vz-border-color), -1px 0 0 var(--vz-border-color), 0 1px 0 var(--vz-border-color), 0 -1px 0 var(--vz-border-color), 0 3px 13px rgba(0, 0, 0, 0.08);
}
.flatpickr-calendar.open, .flatpickr-calendar.inline {
  opacity: 1;
  max-height: 640px;
  visibility: visible;
}
.flatpickr-calendar.open {
  display: inline-block;
  z-index: 1056;
}
.flatpickr-calendar.animate.open {
  animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);
}
.flatpickr-calendar.inline {
  display: block;
  position: relative;
  top: 2px;
  width: 100%;
  box-shadow: none;
}
.flatpickr-calendar.inline .flatpickr-rContainer {
  display: block;
  width: 100%;
}
.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days {
  width: 100%;
  border: 1px solid var(--vz-input-border);
  border-top: none;
  border-radius: 0 0 5px 5px;
}
.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
}
.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer .flatpickr-day {
  max-width: 100%;
  border-radius: 4px;
}
.flatpickr-calendar.inline .flatpickr-time {
  border: 1px solid var(--vz-input-border) !important;
  border-radius: 0.25rem;
}
.flatpickr-calendar.static {
  position: absolute;
  top: calc(100% + 2px);
}
.flatpickr-calendar.static.open {
  z-index: 999;
  display: block;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {
  box-shadow: none !important;
}
.flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {
  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}
.flatpickr-calendar .hasWeeks .dayContainer,
.flatpickr-calendar .hasTime .dayContainer {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.flatpickr-calendar .hasWeeks .dayContainer {
  border-left: 0;
}
.flatpickr-calendar.hasTime .flatpickr-time {
  height: 40px;
  border-top: 1px solid var(--vz-border-color);
}
.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  height: auto;
}
.flatpickr-calendar::before, .flatpickr-calendar::after {
  position: absolute;
  display: block;
  pointer-events: none;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  left: 22px;
}
.flatpickr-calendar.rightMost::before, .flatpickr-calendar.arrowRight::before, .flatpickr-calendar.rightMost::after, .flatpickr-calendar.arrowRight::after {
  left: auto;
  right: 22px;
}
.flatpickr-calendar.arrowCenter::before, .flatpickr-calendar.arrowCenter::after {
  left: 50%;
  right: 50%;
}
.flatpickr-calendar::before {
  border-width: 5px;
  margin: 0 -5px;
}
.flatpickr-calendar::after {
  border-width: 4px;
  margin: 0 -4px;
}
.flatpickr-calendar.arrowTop::before, .flatpickr-calendar.arrowTop::after {
  bottom: 100%;
}
.flatpickr-calendar.arrowTop::before {
  border-bottom-color: #405189;
}
.flatpickr-calendar.arrowTop::after {
  border-bottom-color: #405189;
}
.flatpickr-calendar.arrowBottom::before, .flatpickr-calendar.arrowBottom::after {
  top: 100%;
}
.flatpickr-calendar.arrowBottom::before {
  border-top-color: #405189;
}
.flatpickr-calendar.arrowBottom::after {
  border-top-color: #405189;
}
.flatpickr-calendar:focus {
  outline: 0;
}

.flatpickr-wrapper {
  position: relative;
  display: inline-block;
}

.flatpickr-months {
  display: flex;
  background-color: #405189;
  border-radius: 5px 5px 0px 0px;
}
.flatpickr-months .flatpickr-month {
  background: transparent;
  color: rgba(255, 255, 255, 0.9);
  fill: rgba(255, 255, 255, 0.9);
  height: 34px;
  line-height: 1;
  text-align: center;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  overflow: hidden;
  flex: 1 1;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  text-decoration: none;
  cursor: pointer;
  position: absolute;
  top: 0;
  height: 34px;
  padding: 10px;
  z-index: 3;
  color: rgba(255, 255, 255, 0.9);
  fill: rgba(255, 255, 255, 0.9);
}
.flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
.flatpickr-months .flatpickr-next-month.flatpickr-disabled {
  display: none;
}
.flatpickr-months .flatpickr-prev-month i,
.flatpickr-months .flatpickr-next-month i {
  position: relative;
}
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  left: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  /*
  /*rtl:begin:ignore*/
  /*
  /*rtl:end:ignore*/
}
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
.flatpickr-months .flatpickr-next-month.flatpickr-next-month {
  /*
        /*rtl:begin:ignore*/
  /*
        */
  right: 0;
  /*
        /*rtl:end:ignore*/
  /*
        */
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  /*
  /*rtl:begin:ignore*/
  /*
  /*rtl:end:ignore*/
}
.flatpickr-months .flatpickr-prev-month:hover,
.flatpickr-months .flatpickr-next-month:hover {
  color: #959ea9;
}
.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
  fill: rgba(255, 255, 255, 0.9);
}
.flatpickr-months .flatpickr-prev-month svg,
.flatpickr-months .flatpickr-next-month svg {
  width: 14px;
  height: 14px;
}
.flatpickr-months .flatpickr-prev-month svg path,
.flatpickr-months .flatpickr-next-month svg path {
  transition: fill 0.1s;
  fill: inherit;
}

.numInputWrapper {
  position: relative;
  height: auto;
}
.numInputWrapper input,
.numInputWrapper span {
  display: inline-block;
}
.numInputWrapper input {
  width: 100%;
}
.numInputWrapper input::-ms-clear {
  display: none;
}
.numInputWrapper input::-webkit-outer-spin-button, .numInputWrapper input::-webkit-inner-spin-button {
  margin: 0;
  -webkit-appearance: none;
}
.numInputWrapper span {
  position: absolute;
  right: 0;
  width: 14px;
  padding: 0 4px 0 2px;
  height: 50%;
  line-height: 50%;
  opacity: 0;
  cursor: pointer;
  border: 1px solid rgba(var(--vz-dark-rgb), 0.15);
  box-sizing: border-box;
}
.numInputWrapper span:hover {
  background: rgba(0, 0, 0, 0.1);
}
.numInputWrapper span:active {
  background: rgba(0, 0, 0, 0.2);
}
.numInputWrapper span:after {
  display: block;
  content: "";
  position: absolute;
}
.numInputWrapper span.arrowUp {
  top: 0;
  border-bottom: 0;
}
.numInputWrapper span.arrowUp:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid rgba(57, 57, 57, 0.6);
  top: 26%;
}
.numInputWrapper span.arrowDown {
  top: 50%;
}
.numInputWrapper span.arrowDown:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(57, 57, 57, 0.6);
  top: 40%;
}
.numInputWrapper span svg {
  width: inherit;
  height: auto;
}
.numInputWrapper span svg path {
  fill: rgba(0, 0, 0, 0.5);
}
.numInputWrapper:hover {
  background: rgba(0, 0, 0, 0.05);
}
.numInputWrapper:hover span {
  opacity: 1;
}

.flatpickr-current-month {
  font-size: 100%;
  line-height: inherit;
  font-weight: 300;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 7.48px 0 0 0;
  line-height: 1;
  height: 34px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0px, 0px, 0px);
}
.flatpickr-current-month span.cur-month {
  font-family: inherit;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  margin-left: 0.5ch;
  padding: 0;
}
.flatpickr-current-month span.cur-month:hover {
  background: rgba(0, 0, 0, 0.05);
}
.flatpickr-current-month .numInputWrapper {
  width: 6ch;
  width: 7ch\\0 ;
  display: inline-block;
}
.flatpickr-current-month span.arrowUp::after {
  border-bottom-color: rgba(0, 0, 0, 0.9);
}
.flatpickr-current-month span.arrowDown:after {
  border-top-color: rgba(0, 0, 0, 0.9);
}
.flatpickr-current-month input.cur-year {
  background: transparent;
  box-sizing: border-box;
  color: inherit;
  cursor: text;
  padding: 0 0 0 0.5ch;
  margin: 0;
  display: inline-block;
  font-size: inherit;
  font-family: inherit;
  font-weight: 600;
  line-height: inherit;
  height: auto;
  border: 0;
  border-radius: 0;
  vertical-align: initial;
  appearance: textfield;
}
.flatpickr-current-month input.cur-year:focus {
  outline: 0;
}
.flatpickr-current-month input.cur-year[disabled], .flatpickr-current-month input.cur-year[disabled]:hover {
  font-size: 100%;
  color: rgba(255, 255, 255, 0.9);
  background: transparent;
  pointer-events: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months {
  appearance: menulist;
  background: transparent;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  font-weight: 600;
  height: auto;
  line-height: inherit;
  margin: -1px 0 0 0;
  outline: none;
  padding: 0 0 0 0.5ch;
  position: relative;
  vertical-align: initial;
  width: auto;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:focus, .flatpickr-current-month .flatpickr-monthDropdown-months:active {
  outline: none;
}
.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background-color: transparent;
}
.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  background-color: transparent;
  outline: none;
  padding: 0;
  color: rgba(0, 0, 0, 0.8);
}

.flatpickr-weekdays {
  background-color: #405189;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 36px;
  border-bottom: 1px solid var(--vz-border-color);
}
.flatpickr-weekdays .flatpickr-weekdaycontainer {
  display: flex;
  flex: 1 1;
}

span.flatpickr-weekday {
  cursor: default;
  font-size: 90%;
  background: #405189;
  color: #fff;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1 1;
  font-weight: 500;
}

.dayContainer,
.flatpickr-weeks {
  padding: 1px 0 0 0;
}

.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px;
}
.flatpickr-days:focus {
  outline: 0;
}

.dayContainer {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0px, 0px, 0px);
  opacity: 1;
}
.dayContainer + .dayContainer {
  box-shadow: -1px 0 0 #e6e6e6;
}

.flatpickr-day {
  background: none;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: var(--vz-body-color);
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center;
}
.flatpickr-day:hover, .flatpickr-day:focus {
  background-color: rgba(var(--vz-light-rgb), 0.7);
}
.flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus {
  cursor: pointer;
  outline: 0;
  background-color: var(--vz-light);
  border-color: var(--vz-light);
}
.flatpickr-day.today {
  border-color: #405189;
  background-color: rgba(64, 81, 137, 0.1);
  box-shadow: none;
}
.flatpickr-day.today:hover, .flatpickr-day.today:focus {
  border-color: #405189;
  background-color: rgba(64, 81, 137, 0.15);
  color: var(--vz-dark);
}
.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {
  background: #405189;
  box-shadow: none;
  color: #fff;
  border-color: #405189;
}
.flatpickr-day.selected.startRange, .flatpickr-day.startRange.startRange, .flatpickr-day.endRange.startRange {
  border-radius: 50px 0 0 50px;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 #405189;
}
.flatpickr-day.selected.startRange .endRange, .flatpickr-day.startRange.startRange .endRange, .flatpickr-day.endRange.startRange .endRange {
  border-radius: 50px;
}
.flatpickr-day.selected.endRange, .flatpickr-day.startRange.endRange, .flatpickr-day.endRange.endRange {
  border-radius: 0 50px 50px 0;
}
.flatpickr-day.inRange {
  border-radius: 0;
  box-shadow: -5px 0 0 var(--vz-light), 5px 0 0 var(--vz-light);
}
.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay {
  color: rgba(var(--vz-body-color-rgb), 0.3);
  background: transparent;
  border-color: transparent;
  cursor: default;
}
.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover {
  cursor: not-allowed;
  color: rgba(var(--vz-body-color-rgb), 0.3);
}
.flatpickr-day.week.selected {
  border-radius: 0;
  box-shadow: -5px 0 0 #405189, 5px 0 0 #405189;
}
.flatpickr-day.hidden {
  visibility: hidden;
}

.rangeMode .flatpickr-day {
  margin-top: 1px;
}

.flatpickr-weekwrapper {
  float: left;
}
.flatpickr-weekwrapper .flatpickr-weeks {
  padding: 0 12px;
  box-shadow: 1px 0 0 #e6e6e6;
}
.flatpickr-weekwrapper .flatpickr-weekday {
  float: none;
  width: 100%;
  line-height: 35px;
}
.flatpickr-weekwrapper span.flatpickr-day, .flatpickr-weekwrapper span.flatpickr-day:hover {
  display: block;
  width: 100%;
  max-width: none;
  color: rgba(var(--vz-dark-rgb), 0.3);
  background: transparent;
  cursor: default;
  border: none;
}

.flatpickr-innerContainer {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
}

.flatpickr-rContainer {
  display: inline-block;
  padding: 0;
  box-sizing: border-box;
}

.flatpickr-time {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}
.flatpickr-time:after {
  content: "";
  display: table;
  clear: both;
}
.flatpickr-time .numInputWrapper {
  flex: 1 1;
  width: 40%;
  height: 40px;
  float: left;
}
.flatpickr-time .numInputWrapper span.arrowUp:after, .flatpickr-time .numInputWrapper span.arrowDown:after {
  border-bottom-color: var(--vz-border-color);
}
.flatpickr-time.hasSeconds .numInputWrapper {
  width: 26%;
}
.flatpickr-time.time24hr .numInputWrapper {
  width: 49%;
}
.flatpickr-time input {
  background: transparent;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  text-align: center;
  margin: 0;
  padding: 0;
  height: inherit;
  line-height: inherit;
  color: var(--vz-body-color);
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
  appearance: textfield;
}
.flatpickr-time input.flatpickr-hour {
  font-weight: bold;
}
.flatpickr-time input.flatpickr-minute, .flatpickr-time input.flatpickr-second {
  font-weight: 400;
}
.flatpickr-time input:focus {
  outline: 0;
  border: 0;
}
.flatpickr-time .flatpickr-time-separator,
.flatpickr-time .flatpickr-am-pm {
  height: inherit;
  float: left;
  line-height: inherit;
  color: var(--vz-body-color);
  font-weight: bold;
  width: 2%;
  -webkit-user-select: none;
          user-select: none;
  align-self: center;
}
.flatpickr-time .flatpickr-am-pm {
  outline: 0;
  width: 18%;
  cursor: pointer;
  text-align: center;
  font-weight: 400;
}
.flatpickr-time input:hover, .flatpickr-time input:focus, .flatpickr-time .flatpickr-am-pm:hover, .flatpickr-time .flatpickr-am-pm:focus {
  background: rgba(64, 81, 137, 0.04);
}

.flatpickr-am-pm:focus, .flatpickr-am-pm:hover,
.numInput:focus,
.numInput:hover,
.numInputWrapper:focus,
.numInputWrapper:hover {
  background-color: transparent;
}

.flatpickr-input[readonly] {
  cursor: pointer;
  background-color: var(--vz-input-bg);
}

[data-inline-date=true], [data-time-inline] {
  display: none;
}

@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
[datepicker-inline],
[timepicker-inline] {
  display: none;
}

.auth-page-wrapper .auth-page-content {
  padding-bottom: 60px;
  position: relative;
  z-index: 2;
  width: 100%;
}
.auth-page-wrapper .footer {
  left: 0;
  background-color: transparent;
  color: var(--vz-body-color);
}

.auth-one-bg-position {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 420px;
}
@media (max-width: 575.98px) {
  .auth-one-bg-position {
    height: 280px;
  }
}

.auth-one-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
  background-position: center;
  background-size: cover;
}
.auth-one-bg .bg-overlay {
  background: linear-gradient(to right, rgb(19.3540540541, 21.7, 24.0459459459), #212529);
  opacity: 0.3;
}

.shape {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
}
.shape > svg {
  width: 100%;
  height: auto;
  fill: var(--vz-body-bg);
}

.auth-pass-inputgroup input[type=text] + .btn .ri-eye-fill:before {
  content: "\\ecb6";
}

.particles-js-canvas-el {
  position: relative;
}

.signin-other-title {
  position: relative;
}
.signin-other-title:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  border-top: 1px dashed var(--vz-border-color);
  top: 10px;
}
.signin-other-title .title {
  display: inline-block;
  position: relative;
  z-index: 9;
  background-color: var(--vz-card-bg-custom);
  padding: 2px 16px;
}

.auth-bg-cover {
  background: linear-gradient(-45deg, #405189 50%, #0ab39c);
}
.auth-bg-cover > .bg-overlay {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
  background-position: center;
  background-size: cover;
  opacity: 1;
  background-color: transparent;
}
.auth-bg-cover .footer {
  color: rgba(255, 255, 255, 0.5);
}

#password-contain {
  display: none;
}
#password-contain p {
  padding-left: 13px;
}
#password-contain p.valid {
  color: #0ab39c;
}
#password-contain p.valid::before {
  position: relative;
  left: -8px;
  content: "✔";
}
#password-contain p.invalid {
  color: #f06548;
}
#password-contain p.invalid::before {
  position: relative;
  left: -8px;
  content: "✖";
}

.dash-filter-picker {
  min-width: 210px !important;
}

.upcoming-scheduled {
  position: relative;
}
@media (max-width: 575.98px) {
  .upcoming-scheduled {
    top: 35px !important;
  }
}
.upcoming-scheduled .flatpickr-months {
  position: absolute !important;
  top: -45px !important;
  left: auto !important;
  right: 0px !important;
  width: 200px;
  background-color: transparent;
}
.upcoming-scheduled .flatpickr-months .flatpickr-month {
  color: #878a99 !important;
  fill: #878a99 !important;
}
.upcoming-scheduled .flatpickr-months .flatpickr-prev-month,
.upcoming-scheduled .flatpickr-months .flatpickr-next-month {
  display: none;
}
.upcoming-scheduled .flatpickr-calendar {
  box-shadow: none !important;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-current-month {
  font-size: 13px;
  width: 100%;
  left: 0;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-monthDropdown-months {
  border: 1px solid var(--vz-border-color);
  border-radius: 4px;
  height: 26px;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays {
  background-color: var(--vz-light);
  border: none;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays span.flatpickr-weekday {
  color: var(--vz-dark);
  background-color: var(--vz-light);
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-day.today {
  color: #fff !important;
  background-color: #0ab39c;
  border-color: #0ab39c !important;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-day.today:hover {
  color: #0ab39c !important;
  background-color: rgba(10, 179, 156, 0.2) !important;
}
.upcoming-scheduled .flatpickr-calendar .flatpickr-day.selected {
  background-color: #0ab39c !important;
  border-color: #0ab39c !important;
  color: #fff;
}
.upcoming-scheduled .flatpickr-calendar .numInputWrapper {
  width: 7.5ch;
  margin-left: 10px;
}
.upcoming-scheduled .flatpickr-days {
  border: none !important;
}

.crm-widget .col {
  border-right: 1px solid var(--vz-border-color);
}
.crm-widget .col:last-child {
  border: 0px;
}
@media (min-width: 768px) and (max-width: 1399.98px) {
  .crm-widget .col:nth-child(3) {
    border-right: 0px;
  }
  .crm-widget .col:last-child {
    border-right: 1px solid var(--vz-border-color);
  }
}
@media (max-width: 767.98px) {
  .crm-widget .col {
    border-right: 0px;
    border-bottom: 1px solid var(--vz-border-color);
  }
}

@media (min-width: 1400px) and (max-width: 1599.98px) {
  .project-wrapper > .col-xxl-8,
  .project-wrapper .col-xxl-4 {
    width: 100%;
  }
}
.crypto-widget {
  max-width: 130px !important;
}

.bg-marketplace {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  background-size: cover;
}

.dash-countdown .countdownlist .count-num {
  background-color: var(--vz-card-bg-custom);
  padding: 16px 8px;
  font-size: 22px;
}
@media (max-width: 575.98px) {
  .dash-countdown .countdownlist .count-num {
    font-size: 16px;
    padding: 8px 6px;
  }
}
@media (max-width: 575.98px) {
  .dash-countdown .countdownlist .count-title {
    font-size: 10px;
  }
}

.marketplace-icon {
  position: absolute;
  float: right;
  top: 30px;
  left: 30px;
}

.marketplace-swiper .swiper-button-next,
.marketplace-swiper .swiper-button-prev {
  top: 34px;
  width: 28px;
  height: 28px;
  background-color: rgba(64, 81, 137, 0.1);
  color: #405189;
  border-radius: 0.3rem;
  right: 16px !important;
}
.marketplace-swiper .swiper-button-prev {
  right: 58px !important;
  left: auto !important;
}

.dash-collection .content {
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(5px);
}

@media (max-width: 1441.98px) {
  .dash-nft .col-xxl-9,
  .dash-nft .col-xxl-3 {
    width: 100% !important;
    max-width: 100% !important;
  }
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  width: 32px;
  height: 32px;
  display: inline-block;
  vertical-align: middle;
}

.timeline {
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}
.timeline::after {
  content: "";
  position: absolute;
  width: 2px;
  background: var(--vz-card-bg-custom);
  top: 57px;
  bottom: 166px;
  left: 50%;
  margin-left: -1.5px;
}

.timeline-item {
  padding: 30px 60px;
  position: relative;
  background: inherit;
  width: 50%;
}
.timeline-item .icon {
  position: absolute;
  display: inline-flex;
  width: 60px;
  height: 60px;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  top: 30px;
  right: -30px;
  padding: 9px 0;
  background: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-border-color);
  border-radius: 50px;
  color: #0ab39c;
  z-index: 1;
}
.timeline-item .date {
  position: absolute;
  display: inline-block;
  width: calc(100% - 48px);
  top: 50px;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
}
.timeline-item .content {
  padding: 20px;
  background: var(--vz-card-bg-custom);
  position: relative;
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
.timeline-item.left {
  left: 0;
}
.timeline-item.left .date {
  left: calc(100% + 48px);
  text-align: start;
}
.timeline-item.right {
  left: 50%;
}
.timeline-item.right .icon {
  left: -30px;
}
.timeline-item.right .date {
  right: calc(100% + 48px);
  text-align: end;
}
.timeline-item.right::before {
  left: 28px;
  border-color: transparent transparent transparent #fff;
}

@media (max-width: 991.98px) {
  .timeline::after {
    left: 24px;
    bottom: 180px;
  }
  .timeline-item {
    width: 100%;
    padding-left: 48px;
    padding-right: 0px;
  }
  .timeline-item.right, .timeline-item.left {
    left: 0%;
  }
  .timeline-item.right .icon, .timeline-item.left .icon {
    width: 45px;
    height: 45px;
    top: 0;
    font-size: 18px;
    left: 0;
  }
  .timeline-item.right::before, .timeline-item.left::before {
    left: 110px;
    border-color: transparent transparent transparent var(--vz-border-color);
  }
  .timeline-item.right .date, .timeline-item.left .date {
    right: auto;
    left: 48px;
    width: 79px;
    top: 8px;
    text-align: left;
  }
}
.timeline-2 {
  position: relative;
}
.timeline-2::after {
  position: absolute;
  content: "";
  width: 2px;
  height: 100%;
  top: 15px;
  left: 5px;
  margin-left: -1px;
  background: var(--vz-card-bg-custom);
}
.timeline-2 .timeline-year {
  position: relative;
  width: 100%;
  text-align: left;
  z-index: 1;
}
.timeline-2 .timeline-year p {
  display: inline-flex;
  width: 80px;
  height: 80px;
  margin: 0;
  padding: 23px 10px;
  background: var(--vz-card-bg-custom);
  border-radius: 50px;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.timeline-2 .timeline-year p span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.timeline-2 .timeline-date {
  font-size: 14px;
  font-weight: 500;
  margin: 24px 0 0 0;
  margin-left: 15px;
}
.timeline-2 .timeline-date::after {
  content: "";
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  top: 26px;
  left: 10px;
  align-items: left;
  background: #0ab39c;
  border: 3px solid var(--vz-card-bg-custom);
  border-radius: 50px;
  z-index: 1;
}
.timeline-2 .timeline-box {
  position: relative;
  display: inline-block;
  margin: 10px 22px;
  padding: 15px;
  border: 1px solid var(--vz-border-color);
  border-radius: 6px;
  background: var(--vz-card-bg-custom);
  max-width: 695px;
}
@media (max-width: 991.98px) {
  .timeline-2 .timeline-box {
    margin-right: 0;
  }
}
.timeline-2 .timeline-box::after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  top: 26px;
  right: 100%;
  border-color: transparent var(--vz-card-bg-custom) transparent transparent;
  border-width: 10px;
}
.timeline-2 .timeline-box::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  right: 100%;
  top: 24px;
  border-color: transparent var(--vz-border-color) transparent transparent;
  border-width: 12px;
}
.timeline-2 .timeline-box .timeline-text {
  position: relative;
  float: left;
}
.timeline-2 .timeline-box-s {
  position: relative;
  display: inline-block;
  margin: 10px 22px;
  padding: 15px;
  border: 1px solid var(--vz-border-color);
  border-radius: 6px;
  background: var(--vz-card-bg-custom);
  max-width: 695px;
}
@media (max-width: 991.98px) {
  .timeline-2 .timeline-box-s {
    margin-right: 0;
  }
}
.timeline-2 .timeline-box-s::after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  top: 26px;
  right: 100%;
  border-color: transparent #f7b84b transparent transparent;
  border-width: 10px;
}
.timeline-2 .timeline-box-s::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  right: 100%;
  top: 24px;
  border-color: transparent var(--vz-border-color) transparent transparent;
  border-width: 12px;
}
.timeline-2 .timeline-box-s .timeline-text {
  position: relative;
  float: left;
}
.timeline-2 .timeline-launch {
  position: relative;
  display: inline-block;
  border: 1px solid var(--vz-border-color);
  border-radius: 6px;
  background: #fff;
  width: 100%;
  margin-top: 15px;
  padding: 0;
  border: none;
  text-align: left;
  background: transparent;
}
.timeline-2 .timeline-launch .timeline-box {
  margin-left: 0;
}
.timeline-2 .timeline-launch .timeline-box::after {
  left: 30px;
  margin-left: 0px;
  top: -20px;
  border-color: transparent transparent var(--vz-border-color) transparent;
}
.timeline-2 .timeline-launch .timeline-box::before {
  left: 30px;
  margin-left: 0px;
  top: -19px;
  border-color: transparent transparent var(--vz-card-bg-custom) transparent;
  border-width: 10px;
  z-index: 1;
}

.horizontal-timeline {
  position: relative;
  width: 100%;
  margin: 0 auto;
}
.horizontal-timeline::before {
  content: "";
  position: absolute;
  width: 100%;
  top: 174px;
  left: 0;
  height: 2px;
  background-color: var(--vz-card-bg-custom);
}
.horizontal-timeline .swiper-slide .item-box {
  margin: 227px 0px 0px;
  background-color: transparent;
  box-shadow: none;
}
.horizontal-timeline .swiper-slide .item-box::after {
  content: "";
  position: absolute;
  left: 0px;
  right: 0px;
  margin: 0px auto;
  background: #405189;
  width: 13px;
  height: 13px;
  top: -59px;
  border-radius: 50px;
  border: 3px solid var(--vz-card-bg-custom);
}
.horizontal-timeline .swiper-slide .timeline-content {
  min-height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: var(--vz-card-bg-custom);
}
.horizontal-timeline .swiper-slide .timeline-content::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  left: 0px;
  top: -23px;
  border-color: transparent transparent var(--vz-card-bg-custom) transparent;
  border-width: 12px;
  right: 0;
  margin: 0 auto;
}
.horizontal-timeline .swiper-slide .time {
  position: absolute;
  top: -86px;
  right: 0px;
  left: 0px;
  margin: 0px auto;
}
.horizontal-timeline .swiper-slide:nth-child(even) {
  margin-top: 5px;
  transform: rotate(-180deg);
}
.horizontal-timeline .swiper-slide:nth-child(even) .timeline-content {
  transform: rotate(180deg);
}
.horizontal-timeline .swiper-slide:nth-child(even) .timeline-content::before {
  bottom: -23px;
  top: auto;
  border-color: var(--vz-card-bg-custom) transparent transparent transparent;
}
.horizontal-timeline .swiper-slide:nth-child(even) .time {
  transform: rotate(180deg);
}
.horizontal-timeline .swiper-button-next,
.horizontal-timeline .swiper-button-prev {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 50%;
  background-color: rgb(68.0597014925, 86.1380597015, 145.6902985075);
}
.horizontal-timeline .swiper-button-next::after,
.horizontal-timeline .swiper-button-prev::after {
  font-size: 24px;
  color: #fff;
}
.horizontal-timeline .swiper-button-next.swiper-button-disabled,
.horizontal-timeline .swiper-button-prev.swiper-button-disabled {
  background-color: rgba(64, 81, 137, 0.5);
  opacity: 1;
  cursor: auto;
  backdrop-filter: blur(25px);
  pointer-events: none;
}
.horizontal-timeline .swiper-button-next {
  right: 0;
}
.horizontal-timeline .swiper-button-next::after {
  content: "\\ea6e";
  font-family: remixicon;
}
.horizontal-timeline .swiper-button-prev {
  left: 0;
}
.horizontal-timeline .swiper-button-prev::after {
  content: "\\ea64";
  font-family: remixicon;
}

.acitivity-timeline {
  position: relative;
  overflow: hidden;
}
.acitivity-timeline .acitivity-item {
  position: relative;
}
.acitivity-timeline .acitivity-item .flex-shrink-0 {
  z-index: 2;
}
.acitivity-timeline .acitivity-item .acitivity-avatar {
  background-color: var(--vz-card-bg-custom);
  border: 3px solid var(--vz-card-bg-custom);
  height: 32px;
  width: 32px;
}
.acitivity-timeline .acitivity-item:before {
  content: "";
  position: absolute;
  border-left: 1px dashed var(--vz-border-color);
  left: 16px;
  height: 100%;
  top: 5px;
  z-index: 0;
}
.acitivity-timeline .acitivity-item:last-child::before {
  border-color: transparent;
}

.categories-filter .list-inline-item {
  position: relative;
  margin-right: 0;
}
.categories-filter .list-inline-item a {
  display: block;
  color: var(--vz-body-color);
  font-weight: 600;
  padding: 8px 15px;
  margin: 5px;
  cursor: pointer;
}

.gallery-box {
  position: relative;
  overflow: hidden;
  border: 1px solid transparent;
  margin-bottom: 10px;
  box-shadow: none;
  background-color: transparent;
  padding: 8px;
}
.gallery-box::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 0;
  background-color: var(--vz-card-bg-custom);
  transition: all 0.4s;
}
.gallery-box .gallery-container {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}
.gallery-box .gallery-container a {
  display: block;
}
.gallery-box .gallery-container .gallery-overlay {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  opacity: 0;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 100%);
  visibility: hidden;
  overflow: hidden;
  transition: all 0.4s ease-in-out 0s;
  display: flex;
  width: 100%;
  align-items: flex-end;
  padding: 16px;
}
.gallery-box .gallery-container .gallery-overlay .overlay-caption {
  color: #fff;
  margin: 0;
  font-size: 16px;
}
.gallery-box .gallery-img {
  transition: all 0.2s ease-in-out;
}
.gallery-box .box-content {
  position: relative;
}
.gallery-box .box-content .title {
  font-size: 14px;
  margin-bottom: 4px;
  display: none;
}
.gallery-box .box-content .post {
  margin: 0;
  transition: all 0.2s;
  color: #878a99;
}
.gallery-box:hover::before {
  height: 100%;
}
.gallery-box:hover .box-content {
  bottom: 0;
}
.gallery-box:hover .box-content .post {
  opacity: 1;
}
.gallery-box:hover .gallery-overlay {
  opacity: 1;
  visibility: visible;
}

.gallery-light .gallery-box::before {
  background-color: var(--vz-light);
}

.error-basic-img {
  max-width: 450px;
}

.error-500 .title {
  font-size: 250px;
}
.error-500 .error-500-img {
  position: absolute;
  top: 57px;
  left: 0;
  right: 0;
  margin: 0 auto;
}
@media (min-width: 768px) and (max-width: 991.98px) {
  .error-500 .title {
    font-size: 150px;
  }
  .error-500 .error-500-img {
    width: 20% !important;
    top: 43px;
  }
}
@media (max-width: 767.98px) {
  .error-500 .title {
    font-size: 68px;
    margin-top: 35px;
  }
  .error-500 .error-500-img {
    position: relative;
    top: 0px;
  }
}

@keyframes errorAnimation {
  0% {
    transform: translateX(0%);
  }
  15% {
    transform: translateX(-25%) rotate(-5deg);
  }
  30% {
    transform: translateX(20%) rotate(3deg);
  }
  45% {
    transform: translateX(-15%) rotate(-3deg);
  }
  60% {
    transform: translateX(10%) rotate(2deg);
  }
  75% {
    transform: translateX(-5%) rotate(-1deg);
  }
  100% {
    transform: translateX(0%);
  }
}
.error-img {
  animation: errorAnimation 20s infinite;
}

.error-text {
  text-shadow: 4px 4px rgba(10, 179, 156, 0.4);
}
@media (min-width: 1200px) {
  .error-text {
    font-size: 10rem;
  }
}

.profile-wid-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 320px;
}
@media (max-width: 575.98px) {
  .profile-wid-bg {
    height: 445px;
  }
}
.profile-wid-bg::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0.9;
  background: #405189;
  background: linear-gradient(to top, rgb(23.4029850746, 29.6194029851, 50.0970149254), #405189);
}
.profile-wid-bg .profile-wid-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-nav.nav-pills .nav-link {
  color: rgba(255, 255, 255, 0.8);
}
.profile-nav.nav-pills .nav-link::before {
  background-color: rgba(255, 255, 255, 0.1);
}

.profile-project-card {
  border: 1px solid var(--vz-border-color);
  border-left: 3px solid var(--vz-border-color);
}

.profile-project-card.profile-project-primary {
  border-left-color: #405189;
}

.profile-project-card.profile-project-secondary {
  border-left-color: #3577f1;
}

.profile-project-card.profile-project-success {
  border-left-color: #0ab39c;
}

.profile-project-card.profile-project-info {
  border-left-color: #299cdb;
}

.profile-project-card.profile-project-warning {
  border-left-color: #f7b84b;
}

.profile-project-card.profile-project-danger {
  border-left-color: #f06548;
}

.profile-project-card.profile-project-light {
  border-left-color: #f3f6f9;
}

.profile-project-card.profile-project-dark {
  border-left-color: #212529;
}

.user-profile-img {
  position: relative;
}
.user-profile-img .profile-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
@media (max-width: 991px) {
  .user-profile-img .profile-img {
    height: 160px;
  }
}
.user-profile-img .profile-foreground-img-file-input {
  display: none;
}
.user-profile-img .profile-photo-edit {
  cursor: pointer;
}

.profile-user {
  position: relative;
  display: inline-block;
}
.profile-user .profile-photo-edit {
  position: absolute;
  right: 0;
  left: auto;
  bottom: 0;
  cursor: pointer;
}
.profile-user .user-profile-image {
  object-fit: cover;
}
.profile-user .profile-img-file-input {
  display: none;
}

.profile-timeline .accordion-item {
  position: relative;
}
.profile-timeline .accordion-item .accordion-button {
  background-color: transparent;
}
.profile-timeline .accordion-item .accordion-button::after {
  background: none;
}
.profile-timeline .accordion-item::before {
  content: "";
  border-left: 2px dashed var(--vz-border-color);
  position: absolute;
  height: 100%;
  left: 23px;
}
.profile-timeline .accordion-item:first-child::before {
  top: 8px;
}
.profile-timeline .accordion-item:last-child::before {
  height: 20px;
  top: 3px;
}

.profile-setting-img {
  position: relative;
  height: 260px;
}
.profile-setting-img .overlay-content {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
}
.profile-setting-img .profile-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}
@media (max-width: 991.98px) {
  .profile-setting-img .profile-img {
    height: 160px;
  }
}
.profile-setting-img .profile-foreground-img-file-input {
  display: none;
}
.profile-setting-img .profile-photo-edit {
  cursor: pointer;
}

@media (max-width: 575.98px) {
  [data-layout=horizontal] .profile-foreground {
    margin-top: 0 !important;
  }
}
.sitemap-content {
  width: 100%;
  max-width: 1142px;
  margin: 0 auto;
  padding: 0 20px;
}
.sitemap-content * {
  position: relative;
}

.sitemap-horizontal {
  position: relative;
}
.sitemap-horizontal ul {
  padding: 0;
  margin: 0;
  list-style: none;
}
.sitemap-horizontal ul a {
  display: block;
  background: var(--vz-light);
  border: 2px solid var(--vz-card-bg-custom);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  font-size: 0.8125rem;
  height: 60px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sitemap-horizontal ul a span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.administration .director > li > a {
  width: 50%;
  margin: 0 auto 0px auto;
  border-radius: 4px;
}
.administration .subdirector {
  position: absolute;
  width: 100%;
}
.administration .subdirector::after {
  content: "";
  display: block;
  width: 0;
  height: 130px;
  border-left: 2px dashed var(--vz-border-color);
  left: 45.45%;
  position: relative;
}
.administration .subdirector > li:first-child {
  width: 18.59%;
  height: 64px;
  margin: 0 auto 92px auto;
  padding-top: 25px;
  border-bottom: 2px dashed var(--vz-border-color);
  z-index: 1;
  float: right;
  right: 27.2%;
  border-left: 2px dashed var(--vz-border-color);
}
.administration .subdirector > li:first-child a {
  width: 100%;
  left: 25px;
}
@media screen and (max-width: 767px) {
  .administration .subdirector > li:first-child {
    width: 40%;
    right: 10%;
    margin-right: 2px;
  }
  .administration .subdirector::after {
    left: 49.8%;
  }
}

.departments {
  width: 100%;
}
.departments > li:first-child {
  width: 18.59%;
  height: 64px;
  margin: 0 auto 92px auto;
  padding-top: 25px;
  border-bottom: 2px dashed var(--vz-border-color);
  z-index: 1;
  float: left;
  left: 27%;
}
.departments > li:first-child a {
  width: 100%;
  right: 25px;
}
.departments > li:nth-child(2) {
  margin-left: 0;
  clear: left;
}
.departments > li:nth-child(2).department:before {
  border: none;
}
.departments::after {
  content: "";
  display: block;
  position: absolute;
  width: 81.1%;
  height: 22px;
  border-top: 2px dashed var(--vz-border-color);
  border-right: 2px dashed var(--vz-border-color);
  border-left: 2px dashed var(--vz-border-color);
  margin: 0 auto;
  top: 130px;
  left: 9.1%;
}
@media screen and (max-width: 767px) {
  .departments > li:first-child {
    width: 40%;
    left: 10%;
    margin-left: 2px;
  }
  .departments::after {
    border-right: none;
    left: 0;
    width: 50%;
  }
}

.department {
  border-left: 2px dashed var(--vz-border-color);
  float: left;
  margin-left: 1.75%;
  margin-bottom: 60px;
  width: 18.25%;
}
.department::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 22px;
  border-left: 2px dashed var(--vz-border-color);
  z-index: 1;
  top: -22px;
  left: 50%;
  margin-left: -4px;
}
.department > a {
  margin: 0 0 -26px -4px;
  z-index: 1;
}
.department ul {
  margin-top: 0px;
  margin-bottom: 0px;
}
.department ul li {
  padding-left: 25px;
  border-bottom: 2px dashed var(--vz-border-color);
  height: 80px;
}
.department ul li a {
  background: var(--vz-card-bg-custom);
  margin-top: 48px;
  position: absolute;
  z-index: 1;
  width: 90%;
  height: 60px;
  vertical-align: middle;
  right: -1px;
  text-align: center;
}
.department:first-child {
  margin-left: 0;
  clear: left;
}
@media screen and (min-width: 768px) {
  .department:last-child:before {
    border: none;
  }
}
@media screen and (max-width: 767px) {
  .department {
    float: none;
    width: 100%;
    margin-left: 0;
  }
  .department::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 60px;
    border-left: 2px dashed #fff;
    z-index: 1;
    top: -60px;
    left: 0%;
    margin-left: -4px;
  }
  .department:nth-child(2)::before {
    display: none;
  }
}

.hori-sitemap ul {
  padding: 0;
  padding-top: 10px;
  text-align: center;
}
.hori-sitemap ul li {
  position: relative;
}
@media (max-width: 575.98px) {
  .hori-sitemap ul {
    text-align: left;
  }
  .hori-sitemap ul .parent-title a {
    padding-left: 0;
  }
  .hori-sitemap ul .parent-title a:after {
    display: none;
  }
  .hori-sitemap ul .parent-title:before {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .hori-sitemap > ul {
    position: relative;
  }
  .hori-sitemap > ul li {
    padding-top: 10px;
  }
  .hori-sitemap > ul li .second-list,
  .hori-sitemap > ul li .sub-list {
    position: relative;
  }
  .hori-sitemap > ul li .second-list:before,
  .hori-sitemap > ul li .sub-list:before {
    content: "";
    height: calc(100% - 14px);
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .hori-sitemap > ul li .sub-list:before {
    height: 38%;
  }
  .hori-sitemap > ul li a {
    position: relative;
    padding: 4px 16px 4px 36px;
  }
  .hori-sitemap > ul li a:after {
    content: "";
    width: 24px;
    border-top: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }
  .hori-sitemap > ul li ul {
    margin-left: 36px;
  }
}
@media (min-width: 576px) {
  .hori-sitemap ul {
    padding-top: 20px;
  }
  .hori-sitemap ul li {
    padding-top: 30px;
  }
  .hori-sitemap ul li:before {
    content: "";
    height: 24px;
    width: 0;
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0px auto;
  }
  .hori-sitemap ul li:after {
    content: "";
    width: 100%;
    border-top: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0;
    left: 50%;
  }
  .hori-sitemap ul li:last-of-type:after {
    display: none;
  }
  .hori-sitemap ul li.parent-title::before {
    content: "";
    height: 23px;
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 28px;
    left: 0;
  }
  .hori-sitemap ul li.parent-title::after {
    border: none;
  }
  .hori-sitemap ul li .sub-title {
    position: relative;
  }
  .hori-sitemap ul li .sub-title::before {
    content: "";
    height: 21px;
    border-right: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 27px;
    left: 49%;
    margin: 0 auto;
  }
}
.hori-sitemap a {
  color: var(--vz-body-color);
  padding: 4px 0px;
  display: block;
}

.verti-sitemap a {
  color: var(--vz-body-color);
  display: block;
}
.verti-sitemap .parent-title a {
  padding-left: 0;
}
.verti-sitemap .parent-title a:before {
  display: none;
}
.verti-sitemap .parent-title:before {
  display: none;
}
.verti-sitemap .first-list {
  position: relative;
  padding-top: 10px;
}
.verti-sitemap .first-list:before {
  content: "";
  border-left: 2px dashed var(--vz-border-color);
  position: absolute;
  top: 0;
  height: 100%;
  bottom: 0;
  left: 0;
}
.verti-sitemap .first-list .list-wrap a, .verti-sitemap .first-list li a {
  position: relative;
  padding: 10px 16px 4px 36px;
}
.verti-sitemap .first-list .list-wrap a::before, .verti-sitemap .first-list li a::before {
  content: "";
  width: 24px;
  border-top: 2px dashed var(--vz-border-color);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}
.verti-sitemap .first-list .second-list, .verti-sitemap .first-list .third-list {
  margin-left: 42px;
}
.verti-sitemap .first-list .third-list, .verti-sitemap .first-list .second-list {
  position: relative;
}
.verti-sitemap .first-list .third-list li, .verti-sitemap .first-list .second-list li {
  position: relative;
}
.verti-sitemap .first-list .third-list li:before, .verti-sitemap .first-list .second-list li:before {
  content: "";
  height: 100%;
  border-left: 2px dashed var(--vz-border-color);
  position: absolute;
  top: 0;
  left: 0;
  margin: 0px auto;
}
.verti-sitemap .first-list .third-list li:last-child::before, .verti-sitemap .first-list .second-list li:last-child::before {
  height: 13px;
}
.verti-sitemap .first-list:last-child::before {
  height: 25px;
}

.team-box .team-cover, .profile-offcanvas .team-cover, .modal-team-cover {
  display: none;
  position: relative;
  margin-bottom: -140px;
}
.team-box .team-cover img, .profile-offcanvas .team-cover img, .modal-team-cover img {
  height: 140px;
  width: 100%;
  object-fit: cover;
}
.team-box .team-cover::before, .profile-offcanvas .team-cover::before, .modal-team-cover::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, rgb(23.4029850746, 29.6194029851, 50.0970149254), #405189);
  opacity: 0.6;
}

.team-list.grid-view-filter {
  flex-flow: row wrap;
}
.team-list.grid-view-filter .col {
  flex: 0 0 auto;
  width: 25%;
}
.team-list.grid-view-filter .team-box {
  overflow: hidden;
}
.team-list.grid-view-filter .team-box .team-row {
  align-items: start;
}
.team-list.grid-view-filter .team-box .team-row .col {
  width: 100%;
}
.team-list.grid-view-filter .team-box .team-cover {
  display: block;
}
.team-list.grid-view-filter .team-box .team-settings .col {
  width: 50% !important;
  flex: 0 0 auto;
}
.team-list.grid-view-filter .team-box .team-settings .btn-star {
  color: #fff;
}
.team-list.grid-view-filter .team-box .team-settings .dropdown > a {
  color: #fff;
}
.team-list.grid-view-filter .team-box .team-profile-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;
  margin-top: 36px;
}
.team-list.grid-view-filter .team-box .team-profile-img .avatar-lg {
  font-size: 22px;
}
.team-list.grid-view-filter .team-box .team-profile-img .team-content {
  margin-left: 0px;
  margin-top: 25px;
  text-align: center;
}
.team-list.grid-view-filter .team-box .view-btn {
  width: 100%;
  margin-top: 25px;
}
@media (min-width: 1200px) and (max-width: 1399.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 33.33%;
  }
}
@media (max-width: 1199.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 50%;
  }
}
@media (max-width: 767.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 100%;
  }
}
.team-list.list-view-filter {
  flex-direction: column;
}
.team-list.list-view-filter .team-box {
  margin-bottom: 10px;
}
.team-list.list-view-filter .team-box .team-row {
  align-items: center;
  justify-content: space-between;
}
.team-list.list-view-filter .team-box .team-profile-img {
  display: flex;
  align-items: center;
}
.team-list.list-view-filter .team-box .team-profile-img .avatar-lg {
  height: 4rem;
  width: 4rem;
  font-size: 16px;
}
.team-list.list-view-filter .team-box .team-profile-img .team-content {
  margin-left: 15px;
}
.team-list.list-view-filter .team-box .team-settings {
  width: auto;
  flex: 0 0 auto;
  order: 6;
}
.team-list.list-view-filter .team-box .btn-star {
  color: #405189;
}
@media (max-width: 767.98px) {
  .team-list.list-view-filter {
    flex-direction: row;
  }
  .team-list.list-view-filter .col {
    flex: 0 0 auto;
    width: 100%;
  }
  .team-list.list-view-filter .team-box .team-settings {
    width: 100%;
    flex: 0 0 auto;
    order: -1;
    margin-bottom: 10px;
  }
  .team-list.list-view-filter .team-box .team-settings .col {
    width: 50%;
  }
  .team-list.list-view-filter .team-box .team-profile-img {
    margin-bottom: 25px;
  }
  .team-list.list-view-filter .team-box .view-btn {
    width: 100%;
    margin-top: 25px;
  }
}

.modal-team-cover {
  display: block;
}

.list-grid-nav .nav-link.active {
  background-color: #299cdb;
  color: #fff;
}

.profile-offcanvas .team-cover {
  margin-bottom: -132px;
  display: block;
  z-index: -1;
}
.profile-offcanvas .btn-star {
  color: #fff;
}
.profile-offcanvas .dropdown > a {
  color: #fff;
}

.countdownlist {
  text-align: center;
  display: flex;
  gap: 24px;
}
.countdownlist .countdownlist-item {
  width: 25%;
}
.countdownlist .countdownlist-item:last-of-type .count-num::after {
  display: none;
}
.countdownlist .count-title {
  font-size: 13px;
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
  color: rgba(var(--vz-dark-rgb), 0.5);
  text-transform: uppercase;
}
.countdownlist .count-num {
  background-color: var(--vz-card-bg-custom);
  padding: 16px 8px;
  position: relative;
  border-radius: 0.25rem;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  font-weight: 600;
  font-size: 32px;
}
@media (max-width: 575.98px) {
  .countdownlist .count-num {
    font-size: 18px;
  }
}
.countdownlist .count-num::after {
  content: ":";
  font-size: 20px;
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--vz-dark);
}

.move-animation {
  animation: mover 1s infinite alternate;
}

@keyframes mover {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-16px);
  }
}
.coming-soon-text {
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 3px 4px #0ab39c;
}

.countdown-input-group {
  max-width: 400px;
}

.search-more-results {
  position: relative;
  overflow: hidden;
}
.search-more-results .nav-icon {
  font-size: 14px;
  color: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  left: 0;
  right: 0;
}
.search-more-results .nav-icon i {
  font-size: 20px;
}
@media (max-width: 767.98px) {
  .search-more-results .nav-icon {
    font-size: 14px;
  }
  .search-more-results .nav-icon i {
    font-size: 18px;
  }
}

.video-list .list-element {
  display: none;
}
.video-list .list-element:nth-child(1) {
  display: block;
}
.video-list .list-element:nth-child(2) {
  display: block;
}
.video-list .list-element:nth-child(3) {
  display: block;
}

.search-voice {
  height: 120px;
  width: 120px;
  line-height: 120px;
  margin: 0px auto;
  text-align: center;
  border-radius: 50%;
  z-index: 1;
  position: relative;
}
.search-voice i {
  line-height: 56px;
  font-size: 30px;
}
.search-voice .voice-wave {
  position: absolute;
  width: 120px;
  height: 120px;
  z-index: -1;
  left: 0px;
  right: 0px;
  margin: 0px auto;
  opacity: 0;
  border-radius: 100px;
  animation: voice-wave 1.8s infinite;
  background-color: var(--vz-light);
}
.search-voice .voice-wave:nth-child(2) {
  animation-delay: 0.3s;
}
.search-voice .voice-wave:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes voice-wave {
  0% {
    opacity: 1;
    transform: scale(0);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}
.images-menu .swiper-slide {
  width: auto;
  display: inline-block;
}

#selection-element {
  display: none;
}

.filter-choices-input .choices__inner {
  padding: 0;
  border: none;
  background-color: var(--vz-card-bg-custom);
}
.filter-choices-input .choices__input {
  background-color: var(--vz-card-bg-custom);
}

@media (min-width: 992px) {
  .sticky-side-div {
    position: sticky;
    top: calc(70px + 1.5rem);
  }
}

.product-img-slider .product-nav-slider .nav-slide-item {
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  padding: 0.5rem;
  cursor: pointer;
}
.product-img-slider .product-nav-slider .swiper-slide-thumb-active .nav-slide-item {
  background-color: var(--vz-light);
}

.filter-list a.active .listname {
  color: #0ab39c;
}

.invoice-table tbody:last-child {
  border: none;
}

.currency-select .choices__inner {
  padding: 0px;
  padding-right: 15px;
  min-height: 0px;
}
.currency-select .choices__list--single {
  padding: 0px 16px 0 4px;
}
.currency-select .choices[data-type*=select-one] {
  bottom: 0px;
}
.currency-select .choices[data-type*=select-one] :after {
  top: 4px;
}
.currency-select .choices[data-type*=select-one] .choices__inner {
  padding-bottom: 0px;
}

.chat-wrapper {
  position: relative;
  overflow-x: hidden;
}

.chat-leftsidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--vz-card-bg-custom);
}
@media (min-width: 992px) {
  .chat-leftsidebar {
    min-width: 300px;
    max-width: 300px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}

.chat-list {
  margin: 0;
}
.chat-list > li.active a {
  background-color: rgba(var(--vz-success-rgb), 0.15);
  color: var(--vz-success);
}
.chat-list > li.active a .badge {
  background-color: rgba(var(--vz-success-rgb), 0.15) !important;
  color: #0ab39c !important;
}
.chat-list > li a {
  display: block;
  padding: 7px 24px;
  color: var(--vz-body-color);
  transition: all 0.4s;
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
}
.chat-list > li .chat-user-message {
  font-size: 14px;
}
.chat-list > li .unread-msg-user {
  font-weight: 600;
}
.chat-list > li .unread-message {
  position: absolute;
  display: inline-block;
  right: 24px;
  left: auto;
  top: 33px;
}
.chat-list > li .unread-message .badge {
  line-height: 16px;
  font-weight: 600;
  font-size: 10px;
}

.chat-user-img {
  position: relative;
}
.chat-user-img .user-status {
  width: 10px;
  height: 10px;
  background-color: #adb5bd;
  border-radius: 50%;
  border: 2px solid var(--vz-card-bg-custom);
  position: absolute;
  right: 0;
  left: auto;
  bottom: 0;
}
.chat-user-img.online .user-status {
  background-color: #0ab39c;
}
.chat-user-img.away .user-status {
  background-color: #f7b84b;
}

.chat-room-list {
  max-height: calc(100vh - 296px);
}
@media (max-width: 991.98px) {
  .chat-room-list {
    height: calc(100vh - 296px);
  }
}

.contact-list li {
  cursor: pointer;
  padding: 8px 24px;
  transition: all 0.4s;
  color: var(--vz-body-color);
  font-family: "Open Sans", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
}

.contact-list-title {
  padding: 6px 24px;
  color: #405189;
  font-weight: 500;
  position: relative;
  font-size: 12px;
}
.contact-list-title:after {
  content: "";
  height: 1px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 50px;
  right: 0;
  background-color: var(--vz-light);
}

.user-chat {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
  transition: all 0.4s;
  position: relative;
  background-color: var(--vz-body-bg);
}
@media (max-width: 991.98px) {
  .user-chat {
    position: absolute;
    left: 0;
    top: 3px;
    width: 100%;
    height: calc(100% - 3px);
    visibility: hidden;
    transform: translateX(100%);
    z-index: 99;
    padding-top: 70px;
  }
  .user-chat.user-chat-show {
    visibility: visible;
    transform: translateX(0);
  }
}
.user-chat .chat-content {
  position: relative;
}
.user-chat.user-chat-show .chat-welcome-section {
  display: none;
}
@media (min-width: 992px) {
  .user-chat.user-chat-show .chat-content {
    display: flex !important;
  }
}

.user-chat-topbar {
  border-bottom: 1px solid transparent;
  background-color: var(--vz-card-bg-custom);
}
@media (max-width: 991.98px) {
  .user-chat-topbar {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1;
  }
}

.user-chat-nav .nav-btn {
  height: 40px;
  width: 40px;
  line-height: 40px;
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  color: #343a40;
}
@media (max-width: 575.98px) {
  .user-chat-nav {
    display: flex;
    justify-content: flex-end;
  }
}

.chat-conversation {
  height: calc(100vh - 299px) !important;
}
@media (max-width: 991.98px) {
  .chat-conversation {
    height: calc(100vh - 275px) !important;
  }
}
.chat-conversation .simplebar-content-wrapper {
  display: flex;
  flex-direction: column;
}
.chat-conversation .simplebar-content-wrapper .simplebar-content {
  margin-top: auto;
}
.chat-conversation .chat-conversation-list {
  padding-top: 10px;
  margin-bottom: 0;
}
.chat-conversation .chat-conversation-list > li {
  display: flex;
}
.chat-conversation li:last-of-type .conversation-list {
  margin-bottom: 0;
}
.chat-conversation .chat-list.left .check-message-icon {
  display: none;
}
.chat-conversation .chat-list .message-box-drop {
  visibility: hidden;
}
.chat-conversation .chat-list:hover .message-box-drop {
  visibility: visible;
}
.chat-conversation .chat-avatar {
  margin: 0 16px 0 0;
}
.chat-conversation .chat-avatar img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}
.chat-conversation .chat-day-title {
  position: relative;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 12px;
  width: 100%;
}
.chat-conversation .chat-day-title .title {
  background-color: #fff;
  position: relative;
  font-size: 13px;
  z-index: 1;
  padding: 6px 12px;
  border-radius: 5px;
}
.chat-conversation .chat-day-title:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  background-color: rgba(64, 81, 137, 0.2);
  top: 10px;
}
.chat-conversation .chat-day-title .badge {
  font-size: 12px;
}
.chat-conversation .conversation-list {
  margin-bottom: 24px;
  display: inline-flex;
  position: relative;
  align-items: flex-end;
  max-width: 80%;
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list {
    max-width: 90%;
  }
}
.chat-conversation .conversation-list .ctext-wrap {
  display: flex;
  margin-bottom: 10px;
}
.chat-conversation .conversation-list .ctext-content {
  word-wrap: break-word;
  word-break: break-word;
}
.chat-conversation .conversation-list .ctext-wrap-content {
  padding: 12px 20px;
  background-color: var(--vz-light);
  position: relative;
  border-radius: 3px;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list .ctext-wrap-content .attached-file .attached-file-avatar {
    display: none;
  }
  .chat-conversation .conversation-list .ctext-wrap-content .attached-file .dropdown .dropdown-toggle {
    display: block;
  }
}
.chat-conversation .conversation-list .conversation-name {
  font-weight: 500;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.chat-conversation .conversation-list .dropdown .dropdown-toggle {
  font-size: 18px;
  padding: 4px;
  color: #878a99;
}
.chat-conversation .conversation-list .dropdown .dropdown-toggle::after {
  display: none;
}
@media (max-width: 575.98px) {
  .chat-conversation .conversation-list .dropdown .dropdown-toggle {
    display: none;
  }
}
.chat-conversation .conversation-list .chat-time {
  font-size: 12px;
  margin-top: 4px;
  text-align: right;
}
.chat-conversation .conversation-list .message-img {
  border-radius: 0.2rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.chat-conversation .conversation-list .message-img .message-img-list {
  position: relative;
}
.chat-conversation .conversation-list .message-img img {
  max-width: 150px;
}
.chat-conversation .conversation-list .message-img .message-img-link {
  position: absolute;
  right: 10px;
  left: auto;
  bottom: 10px;
}
.chat-conversation .conversation-list .message-img .message-img-link li > a {
  font-size: 18px;
  color: #fff;
  display: inline-block;
  line-height: 20px;
  width: 26px;
  height: 24px;
  border-radius: 3px;
  background-color: rgba(33, 37, 41, 0.7);
  text-align: center;
}
.chat-conversation .right {
  justify-content: flex-end;
}
.chat-conversation .right .chat-avatar {
  order: 3;
  margin-right: 0px;
  margin-left: 16px;
}
.chat-conversation .right .chat-time {
  text-align: left;
  color: #878a99;
}
.chat-conversation .right .conversation-list {
  text-align: right;
}
.chat-conversation .right .conversation-list .ctext-wrap {
  justify-content: flex-end;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content {
  order: 2;
  background-color: rgba(var(--vz-success-rgb), 0.15);
  color: var(--vz-success);
  text-align: right;
  box-shadow: none;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content .replymessage-block {
  background-color: rgba(255, 255, 255, 0.5);
  border-color: rgba(var(--vz-success-rgb), 1);
  color: #212529;
}
.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content .replymessage-block .conversation-name {
  color: rgba(var(--vz-success-rgb), 1);
}
.chat-conversation .right .conversation-list .conversation-name {
  justify-content: flex-end;
}
.chat-conversation .right .conversation-list .conversation-name .check-message-icon {
  order: 1;
}
.chat-conversation .right .conversation-list .conversation-name .time {
  order: 2;
}
.chat-conversation .right .conversation-list .conversation-name .name {
  order: 3;
}
.chat-conversation .right .conversation-list .dropdown {
  order: 1;
}
.chat-conversation .right .dot {
  background-color: #212529;
}

.chat-input-section {
  border-top: 1px solid transparent;
  background-color: var(--vz-card-bg-custom);
  position: relative;
  z-index: 1;
}
.chat-input-section .chat-input-feedback {
  display: none;
  position: absolute;
  top: -20px;
  left: 4px;
  font-size: 12px;
  color: #f06548;
}
.chat-input-section .show {
  display: block;
}

.chat-input-links {
  display: flex;
}
.chat-input-links .links-list-item > .btn {
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  width: 37.5px;
  height: 37.5px;
}
.chat-input-links .links-list-item > .btn.btn-link {
  color: #878a99;
}

.copyclipboard-alert {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: none;
}

.replyCard {
  position: absolute;
  left: 0;
  right: 0;
  border-top: 1px solid var(--vz-border-color);
  overflow: hidden;
  opacity: 0;
  bottom: 0;
  border-radius: 0;
  transition: all 0.4s;
}
@media (max-width: 991.98px) {
  .replyCard {
    bottom: -12px;
  }
}
.replyCard.show {
  transform: translateY(-88px);
  opacity: 1;
}
@media (max-width: 991.98px) {
  .replyCard.show {
    transform: translateY(-83px);
  }
}

.replymessage-block {
  padding: 12px 20px;
  margin-bottom: 8px;
  text-align: left;
  border-radius: 4px;
  background-color: rgba(var(--vz-success-rgb), 0.1);
  border-left: 2px solid rgba(var(--vz-success-rgb), 1);
}
.replymessage-block .conversation-name {
  color: rgba(var(--vz-success-rgb), 1);
  font-size: 14px;
}

.chat-sm .ctext-wrap-content {
  box-shadow: none !important;
}
.chat-sm .message-img img {
  max-width: 90px !important;
}
.chat-sm .message-img-link {
  bottom: 0 !important;
  right: 5px !important;
}

@media (min-width: 1025px) {
  [data-layout=horizontal] .chat-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-wrapper {
    margin-top: 0 !important;
  }
}
[data-layout=horizontal] .chat-leftsidebar {
  height: calc(100vh - 70px - 60px - 54px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-leftsidebar {
    height: calc(100vh - 70px - 60px - 8px);
  }
}
[data-layout=horizontal] .chat-room-list {
  height: calc(100vh - 352px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-room-list {
    height: calc(100vh - 265px);
  }
}
[data-layout=horizontal] .chat-conversation {
  height: calc(100vh - 343px) !important;
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .chat-conversation {
    height: calc(100vh - 275px) !important;
  }
}

.email-wrapper {
  position: relative;
  overflow-x: hidden;
}

.email-menu-sidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--vz-card-bg-custom);
  transition: all 0.2s;
}
@media (min-width: 992px) {
  .email-menu-sidebar {
    min-width: 250px;
    max-width: 250px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}
@media (max-width: 991.98px) {
  .email-menu-sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 200px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(-100%);
    visibility: hidden;
    height: 100vh;
  }
  .email-menu-sidebar.menubar-show {
    visibility: visible;
    transform: none;
  }
}
.email-menu-sidebar .email-menu-sidebar-scroll {
  height: calc(100vh - 295px);
}
@media (max-width: 991.98px) {
  .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 150px);
  }
}

.mail-list a {
  display: flex;
  align-items: center;
  color: #878a99;
  padding: 5px 0;
  font-weight: 500;
}
.mail-list a:hover {
  color: #405189;
}
.mail-list a i {
  font-size: 14px;
}
.mail-list a.active {
  color: #0ab39c;
  font-weight: 600;
}
.mail-list a.active i {
  color: #0ab39c;
}

.email-chat-list a {
  padding: 6px 24px;
}
.email-chat-list a.active {
  background-color: rgba(var(--vz-light-rgb), 0.7);
}

.email-topbar-link .btn-ghost-secondary {
  color: #878a99;
}
.email-topbar-link .btn-ghost-secondary:hover {
  color: #3577f1;
}

.email-content {
  width: 100%;
  background-color: var(--vz-card-bg-custom);
  transition: all 0.2s;
}

.unreadConversations-alert {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.email-detail-content {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 68%;
  width: 32%;
  background-color: var(--vz-card-bg-custom);
  transform: translateX(200%);
  transition: all 0.2s;
  visibility: hidden;
  border-left: 2px solid var(--vz-body-bg);
}

.email-detail-show .email-detail-content {
  transform: none;
  visibility: visible;
}
.email-detail-show .email-content {
  margin-right: 32%;
}
@media (max-width: 1349.98px) {
  .email-detail-show .email-content {
    margin-right: 0;
  }
}

.email-detail-content-scroll {
  height: calc(100vh - 390px);
}
@media (max-width: 1349.98px) {
  .email-detail-content-scroll {
    height: calc(100vh - 252px);
  }
}

.message-list-content {
  height: calc(100vh - 242px);
}
@media (max-width: 575.98px) {
  .message-list-content {
    height: calc(100vh - 230px);
  }
}

.message-list {
  display: block;
  padding-left: 0;
  margin: 0;
}
.message-list li {
  position: relative;
  display: block;
  height: 50px;
  line-height: 50px;
  cursor: default;
  transition-duration: 0.3s;
  clear: both;
}
.message-list li a {
  color: var(--vz-gray-700);
}
.message-list li:hover {
  background: var(--vz-light);
  transition-duration: 0.05s;
}
.message-list li .col-mail {
  float: left;
  position: relative;
}
.message-list li .col-mail-1 {
  width: 280px;
}
.message-list li .col-mail-1 .star-toggle,
.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot {
  display: block;
  float: left;
}
.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}
.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 0 0 20px;
  line-height: normal;
}
.message-list li .col-mail-1 .star-toggle {
  margin-top: 18px;
  margin-left: 5px;
}
.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 95px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
}
@media (max-width: 575.98px) {
  .message-list li .col-mail-1 .title {
    left: 95px;
  }
}
.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 280px;
  right: 0;
  bottom: 0;
}
.message-list li .col-mail-2 .subject,
.message-list li .col-mail-2 .date {
  position: absolute;
  top: 0;
}
.message-list li .col-mail-2 .subject {
  left: 0;
  right: 110px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.message-list li .col-mail-2 .subject .teaser {
  color: var(--vz-gray-600);
}
.message-list li .col-mail-2 .date {
  right: 0;
  width: 100px;
  padding-left: 20px;
}
.message-list li.active, .message-list li.active:hover {
  box-shadow: inset 3px 0 0 #405189;
  background-color: var(--vz-light);
}
.message-list li.unread {
  color: var(--vz-gray-800);
}
.message-list li.unread a {
  color: var(--vz-gray-800);
  font-weight: 600;
}

#unreadConversations,
#email-topbar-actions {
  display: none;
}

#elmLoader {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}

.email-compose-input {
  padding-right: 80px;
}

@media (max-width: 1349.98px) {
  .email-detail-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%);
  }
  .email-detail-show .email-detail-content {
    transform: none;
  }
}
@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 180px;
  }
}
.email-editor .ck-editor__editable_inline {
  min-height: 200px !important;
}

.email-chat-detail {
  width: 350px;
  position: fixed;
  max-width: 100%;
  bottom: 60px;
  right: 60px;
  z-index: 9;
  display: none;
}
.email-chat-detail .card {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}
@media (max-width: 515.98px) {
  .email-chat-detail {
    left: 16px;
    right: 16px;
  }
}

@media (min-width: 1025px) {
  [data-layout=horizontal] .email-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .email-wrapper {
    margin-top: 0 !important;
  }
}
[data-layout=horizontal] .email-menu-sidebar {
  height: calc(100vh - 70px - 60px - 54px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .email-menu-sidebar {
    height: 100vh;
  }
}
[data-layout=horizontal] .email-menu-sidebar .email-menu-sidebar-scroll {
  height: calc(100vh - 330px);
}
@media (max-width: 991.98px) {
  [data-layout=horizontal] .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 150px);
  }
}
[data-layout=horizontal] .message-list-content {
  height: calc(100vh - 289px);
}
[data-layout=horizontal] .email-detail-content-scroll {
  height: calc(100vh - 435px);
}
@media (max-width: 1349.98px) {
  [data-layout=horizontal] .email-detail-content-scroll {
    height: calc(100vh - 252px);
  }
}

.email-chat-element .chat-conversation1 {
  height: 250px !important;
}

.tasks-board {
  display: flex;
  overflow-x: auto;
  align-items: stretch;
}
.tasks-board .tasks-list {
  min-width: 300px;
  margin-right: 24px;
}
.tasks-board::-webkit-scrollbar {
  -webkit-appearance: none;
}
.tasks-board::-webkit-scrollbar:vertical {
  width: 10px;
}
.tasks-board::-webkit-scrollbar:horizontal {
  height: 8px;
}
.tasks-board::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 8px;
}
.tasks-board::-webkit-scrollbar-track {
  border-radius: 8px;
}

.tasks-box .progress {
  border-radius: 0px 0px 0.25rem 0.25rem;
}
.tasks-box .tasks-img {
  height: 135px;
  width: 100%;
  object-fit: cover;
  object-position: center;
  margin: 12px 0px;
}
.tasks-box:last-child {
  margin-bottom: 0px;
}

.tasks-wrapper {
  max-height: calc(100vh - 418px);
}

.tasks {
  min-height: 180px;
  position: relative;
}
.tasks.noTask::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  height: 180px;
  width: 270px;
  margin: 0 auto;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
  background-size: cover;
  background-position: center;
}

#tasksList tr .tasks-list-menu {
  opacity: 0;
}
#tasksList tr:hover .tasks-list-menu {
  opacity: 1;
}

.layout-wrapper.landing {
  background-color: var(--vz-card-bg-custom);
  font-size: 15px;
}

.section {
  padding: 90px 0;
  position: relative;
}
@media (max-width: 767.98px) {
  .section {
    padding: 50px 0;
  }
}

.icon-effect {
  position: relative;
}
.icon-effect::before {
  content: "";
  position: absolute;
  width: 24px;
  height: 24px;
  background-color: rgba(10, 179, 156, 0.2);
  border-radius: 50%;
  bottom: 0;
  left: 0;
}

.navbar-landing {
  padding: 10px 0px;
  transition: all 0.5s ease;
}
@media (max-width: 991.98px) {
  .navbar-landing {
    background-color: var(--vz-card-bg-custom);
    box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);
    padding: 10px 8px;
  }
}
.navbar-landing .navbar-nav .nav-item .nav-link {
  font-size: 16px;
  font-weight: 500;
  transition: all 0.4s;
  font-family: "Open Sans", sans-serif;
  color: var(--vz-dark);
  padding: 14px;
}
@media (max-width: 991.98px) {
  .navbar-landing .navbar-nav .nav-item .nav-link {
    padding: 8px 0px;
  }
}
.navbar-landing .navbar-nav .nav-item .nav-link:hover, .navbar-landing .navbar-nav .nav-item .nav-link.active, .navbar-landing .navbar-nav .nav-item .nav-link:focus {
  color: #0ab39c !important;
}
.navbar-landing .navbar-nav .nav-item.active .nav-link {
  color: #0ab39c !important;
}
.navbar-landing.is-sticky {
  background-color: var(--vz-card-bg-custom);
  box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);
}

.navbar-light .navbar-brand .card-logo-dark {
  display: none;
}
.navbar-light .navbar-brand .card-logo-light {
  display: block;
}
.navbar-light .navbar-nav .nav-item .nav-link {
  color: rgba(var(--vz-white-rgb), 0.75);
}
.navbar-light.is-sticky .navbar-nav .nav-item .nav-link {
  color: var(--vz-dark);
}
.navbar-light.is-sticky .navbar-brand .card-logo-dark {
  display: block;
}
.navbar-light.is-sticky .navbar-brand .card-logo-light {
  display: none;
}

.hero-section {
  background-color: rgba(var(--vz-light-rgb), 0.5);
}
.hero-section .hero-shape-svg svg path {
  fill: var(--vz-card-bg-custom);
}

.bg-overlay-pattern {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  background-color: transparent;
  background-position: center;
  background-size: cover;
  opacity: 0.2;
}

.demo-carousel {
  position: relative;
  z-index: 1;
}
.demo-carousel .carousel-item .demo-item {
  background-color: var(--vz-card-bg-custom);
  padding: 8px;
  border-radius: 7px;
}
.demo-carousel .demo-img-patten-top {
  position: absolute;
  right: -50px;
  top: -16px;
  max-width: 230px;
}
.demo-carousel .demo-img-patten-bottom {
  position: absolute;
  left: -70px;
  bottom: -50px;
  max-width: 230px;
}

.client-images img {
  max-height: 45px;
  width: auto;
  margin: 12px auto;
  transition: all 0.4s;
}

.plan-box {
  max-width: 356px;
  margin-left: auto;
  margin-right: auto;
}

.process-card {
  position: relative;
}
.process-card .process-arrow-img {
  position: absolute;
  left: 75%;
  top: 7%;
  width: 50%;
  opacity: 0.1;
}

.custom-footer {
  color: #9ba7b3;
}

.footer-list li a {
  color: #9ba7b3;
  padding: 7px 0;
  display: block;
  transition: all 0.3s ease-in-out;
}
.footer-list li a:hover {
  color: rgba(255, 255, 255, 0.9);
}

.footer-social-link .avatar-title {
  color: #778089;
  background-color: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}
.footer-social-link .avatar-title:hover {
  color: #fff;
  background-color: #405189;
}

#back-to-top.landing-back-top {
  bottom: 35px;
}

[data-layout-mode=dark] .layout-wrapper.landing .demo-img-patten-top,
[data-layout-mode=dark] .layout-wrapper.landing .demo-img-patten-bottom {
  opacity: 0.2;
}
[data-layout-mode=dark] .layout-wrapper.landing footer.bg-dark {
  background-color: var(--vz-card-bg-custom) !important;
}
[data-layout-mode=dark] .navbar-light.is-sticky .navbar-brand .card-logo-dark {
  display: none;
}
[data-layout-mode=dark] .navbar-light.is-sticky .navbar-brand .card-logo-light {
  display: block;
}

.bookmark-icon .btn {
  color: #878a99;
  background-color: var(--vz-light);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  font-size: 0.8125rem;
}
.bookmark-icon .btn:hover, .bookmark-icon .btn.active {
  border-color: transparent;
  color: #f06548;
}

.explore-box {
  border-radius: 9px;
  overflow: hidden;
}
.explore-box .explore-img {
  height: 280px;
  object-fit: cover;
}
.explore-box .explore-place-bid-img {
  position: relative;
  overflow: hidden;
  z-index: 0;
}
.explore-box .explore-place-bid-img .bg-overlay {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(33, 37, 41, 0.4);
  opacity: 0;
  transition: all 0.5s ease;
}
.explore-box .explore-place-bid-img .place-bid-btn {
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
.explore-box .explore-place-bid-img .place-bid-btn .btn {
  opacity: 0;
  bottom: -25px;
  transition: 0.5s ease;
}
.explore-box:hover .explore-place-bid-img .place-bid-btn .btn {
  opacity: 1;
  bottom: 0;
}
.explore-box:hover .explore-place-bid-img .bg-overlay {
  opacity: 1;
}
.explore-box .discount-time {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(5px);
  padding: 8px;
}

.nft-hero {
  background-size: cover;
  background-position: bottom;
  padding: 222px 0 150px 0;
}
.nft-hero .bg-overlay {
  background-color: #05175f;
  opacity: 0.85;
}

#explorecard-list .list-element {
  display: none;
}
#explorecard-list .list-element:nth-child(-n+10) {
  display: block;
}

.file-manager-menu {
  max-height: calc(100vh - 296px);
}
@media (max-width: 991.98px) {
  .file-manager-menu {
    height: calc(100vh - 296px);
  }
}
.file-manager-menu li {
  padding: 5px 0px;
}
.file-manager-menu li a {
  color: var(--vz-dark);
  font-weight: 500;
  transition: all 0.5s ease;
}
.file-manager-menu li a.active, .file-manager-menu li a:hover, .file-manager-menu li a[aria-expanded=true] {
  color: #0ab39c;
}
.file-manager-menu li .sub-menu li {
  padding-left: 25px;
  position: relative;
}
.file-manager-menu li .sub-menu li::before {
  content: "\\f0374";
  position: absolute;
  left: 0px;
  font-family: Material Design Icons;
  color: rgba(var(--vz-dark-rgb), 0.4);
}

.file-manager-sidebar {
  position: relative;
  background-color: var(--vz-card-bg-custom);
}
@media (min-width: 992px) {
  .file-manager-sidebar {
    min-width: 300px;
    max-width: 300px;
    height: calc(100vh - 70px - 60px + 20);
  }
}
@media (max-width: 991.98px) {
  .file-manager-sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 200px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(-100%);
    visibility: hidden;
    height: 100vh;
  }
  .file-manager-sidebar.menubar-show {
    visibility: visible;
    transform: none;
  }
}

.file-menu-sidebar-scroll {
  height: calc(100vh - 505px);
}
@media (max-width: 991.98px) {
  .file-menu-sidebar-scroll {
    height: calc(100vh - 320px);
  }
}

.file-manager-content {
  background-color: var(--vz-card-bg-custom);
}

.file-manager-content-scroll {
  height: calc(100vh - 185px);
}
@media (max-width: 991.98px) {
  .file-manager-content-scroll {
    height: calc(100vh - 144px);
  }
}
.file-manager-content-scroll .simplebar-content {
  height: 100%;
}

.file-detail-content-scroll {
  height: calc(100vh - 180px);
}
@media (max-width: 991.98px) {
  .file-detail-content-scroll {
    height: 100vh;
  }
}
.file-detail-content-scroll .simplebar-content {
  height: 100%;
}

.file-manager-detail-content {
  width: 32%;
  max-width: 100%;
  background-color: var(--vz-card-bg-custom);
  display: none;
}

.file-detail-show .file-manager-detail-content {
  display: block;
}

#file-overview {
  display: none;
}

@media (max-width: 1399.98px) {
  .file-manager-detail-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%);
  }
  .file-detail-show .file-manager-detail-content {
    transform: none;
  }
}
.file-details-box {
  height: 195px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.to-do-menu li .nav-link {
  color: var(--vz-body-color);
  padding-left: 0;
  font-weight: 500;
  background-color: var(--vz-light);
  padding: 10px 12px;
  border-radius: 4px;
  display: block;
  margin-bottom: 8px;
}
.to-do-menu li .nav-link:hover, .to-do-menu li .nav-link.active {
  color: #0ab39c;
}

.todo-content {
  height: calc(100vh - 362px);
  overflow-y: auto;
}
.todo-content::-webkit-scrollbar {
  -webkit-appearance: none;
}
.todo-content::-webkit-scrollbar:vertical {
  width: 8px;
}
.todo-content::-webkit-scrollbar:horizontal {
  height: 10px;
}
.todo-content::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.075);
  border-radius: 8px;
}
.todo-content::-webkit-scrollbar-track {
  border-radius: 8px;
}

.todo-task table .form-check .form-check-input:checked + .form-check-label {
  text-decoration: line-through;
}

.task-handle {
  cursor: move;
}

#task-error-msg {
  display: none;
}

.bg-job {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
  background-size: cover;
  background-position: center;
}

.job-list-view-card .background {
  height: 130px;
}

@media (min-width: 1400px) and (max-width: 1499.98px) {
  .job-list-row.row .col-xxl-3 {
    width: 33%;
  }
}

.custom-container {
  width: 90%;
}

.job-navbar .dropdown-menu .dropdown-item .avatar-sm {
  height: 2.5rem;
  width: 2.5rem;
}
@media (max-width: 991.98px) {
  .job-navbar {
    background-color: var(--vz-card-bg-custom);
    padding: 16px 0;
  }
}

.job-hero-section {
  position: relative;
  padding: 165px 0;
  overflow-x: hidden;
}

.job-panel-filter {
  background-color: var(--vz-card-bg-custom);
  border-radius: 0.25rem;
  overflow: hidden;
}
.job-panel-filter .form-control {
  height: 45px;
  border: none;
  border-radius: 0;
  background-color: transparent;
}
.job-panel-filter .btn {
  border-radius: 0;
}
.job-panel-filter input.form-control {
  border-right: 1px solid var(--vz-border-color);
}
@media (max-width: 767.98px) {
  .job-panel-filter {
    background-color: transparent;
  }
  .job-panel-filter .form-control {
    background-color: #fff;
    border-radius: 0.25rem;
  }
  .job-panel-filter input.form-control {
    border: 0;
  }
  .job-panel-filter .btn {
    border-radius: 0.25rem;
  }
}

.circle-effect {
  position: absolute;
  top: 0;
  z-index: 0;
  right: -55px;
  margin: 0 auto;
}
.circle-effect .circle {
  border: 1px solid var(--vz-border-color);
  height: 240px;
  width: 240px;
  margin: 0 auto;
  border-radius: 50%;
}
.circle-effect .circle2 {
  position: absolute;
  top: -20px;
  right: -20px;
  border: 1px solid var(--vz-border-color);
  height: 280px;
  width: 280px;
  margin: 0 auto;
  border-radius: 50%;
}
.circle-effect .circle3 {
  position: absolute;
  top: -40px;
  right: -40px;
  border: 1px solid var(--vz-border-color);
  height: 320px;
  width: 320px;
  margin: 0 auto;
  border-radius: 50%;
}
.circle-effect .circle4 {
  position: absolute;
  top: -60px;
  right: -60px;
  border: 1px solid var(--vz-border-color);
  height: 360px;
  width: 360px;
  margin: 0 auto;
  border-radius: 50%;
}
@media (max-width: 991.98px) {
  .circle-effect {
    display: none;
  }
}

.home-img .user-img {
  position: relative;
  z-index: 1;
}

.application-box,
.feedback-box,
.inquiry-box {
  max-width: 240px;
  position: absolute;
  z-index: 2;
  transition: all 0.5s ease;
}
.application-box:hover,
.feedback-box:hover,
.inquiry-box:hover {
  transform: translateY(-5px);
}

.inquiry-box {
  left: -134px;
  top: 90px;
}
@media (max-width: 991.98px) {
  .inquiry-box {
    left: 0;
  }
}

.application-box {
  bottom: 50px;
  right: -160px;
}
@media (max-width: 991.98px) {
  .application-box {
    right: 0;
  }
}

.feedback-box {
  right: -50px;
  bottom: -54px;
}
@media (max-width: 576.98px) {
  .feedback-box {
    right: 0;
    bottom: 0;
  }
}

.job-icon-effect {
  height: 30px;
  width: 30px;
  position: absolute;
  top: 0px;
  left: -2%;
  border-radius: 50%;
  background: repeating-linear-gradient(-55deg, rgba(255, 255, 255, 0) 0.8px, #0ab39c 1.6px, #0ab39c 2px, rgba(255, 255, 255, 0) 3.8px, rgba(255, 255, 255, 0) 5px);
  z-index: 0;
  opacity: 0.2;
}
.job-icon-effect span {
  position: relative;
  z-index: 1;
}

.about-img-section {
  position: relative;
}
.about-img-section::before {
  content: "";
  position: absolute;
  left: 20px;
  right: -20px;
  top: -20px;
  bottom: 20px;
  border: 1px solid #299cdb;
  z-index: 0;
  border-radius: 0.25rem;
}
@media (max-width: 576.98px) {
  .about-img-section::before {
    right: 20px;
    top: 20px;
  }
}

.features-company-widgets {
  position: absolute;
  bottom: -18px;
  right: -35px;
}

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Custom Css File
*/
.css-b62m3t-container .css-13cymwt-control {
  background-color: var(--vz-gray-200);
  border-color: var(--vz-border-color);
}
.css-b62m3t-container .css-13cymwt-control:hover {
  border-color: var(--vz-border-color);
}
.css-b62m3t-container .css-t3ipsp-control {
  background-color: var(--vz-gray-200);
  border-color: var(--vz-border-color);
  box-shadow: none;
}
.css-b62m3t-container .css-t3ipsp-control:hover {
  border-color: var(--vz-border-color) !important;
}
.css-b62m3t-container .css-1nmdiq5-menu {
  background-color: var(--vz-gray-200);
}
.css-b62m3t-container .css-1nmdiq5-menu .css-10wo9uf-option {
  cursor: pointer;
  background-color: var(--vz-gray-200);
}
.css-b62m3t-container .css-1nmdiq5-menu .css-10wo9uf-option:active {
  background-color: var(--vz-gray-200);
}
.css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option {
  cursor: pointer;
  background-color: var(--vz-gray-100);
}
.css-b62m3t-container .css-1p3m7a8-multiValue {
  background-color: var(--vz-light);
}
.css-b62m3t-container .css-wsp0cs-MultiValueGeneric {
  color: var(--vz-heading-color);
}
.css-b62m3t-container .css-12jo7m5 {
  color: var(--vz-heading-color);
}
.css-b62m3t-container .css-6j8wv5-Input,
.css-b62m3t-container .css-qc6sy-singleValue {
  color: var(--vz-heading-color);
}
.css-b62m3t-container .css-1dimb5e-singleValue {
  color: var(--vz-body-color);
}

.marketplace-swiper .swiper-button-next,
.marketplace-swiper .swiper-button-prev {
  top: 24px;
}

.marquee {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 22px;
  line-height: 2;
}

.marquee div {
  display: block;
  width: 200%;
  height: 30px;
  position: absolute;
  overflow: hidden;
  animation: marquee 35s linear infinite;
}

.marquee span {
  float: left;
  width: 50%;
}

@keyframes marquee {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}
.kVrXuC,
.dwPlXY,
.gKbhqU,
.iSAVrt {
  background-color: transparent !important;
  color: var(--vz-body-color) !important;
}

.fyrdjl {
  color: rgba(var(--vz-body-color-rgb), 0.54) !important;
  fill: rgba(var(--vz-body-color-rgb), 0.54) !important;
}

.fyrdjl:disabled {
  color: rgba(var(--vz-body-color-rgb), 0.18) !important;
  fill: rgba(var(--vz-body-color-rgb), 0.18) !important;
}

.iSAVrt {
  background-color: var(--vz-card-bg-custom) !important;
  border-bottom-color: var(--vz-border-color) !important;
}

.dwPlXY:not(:last-of-type) {
  border-bottom-color: var(--vz-border-color) !important;
}

.dropdown-item a {
  display: block !important;
}

.react-trello-board {
  height: 77.2vh !important;
  background-color: transparent !important;
  color: #495057 !important;
}

.react-trello-lane {
  background-color: #fff !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
}

.react-trello-lane div {
  width: 99%;
  margin-left: 0.5%;
  margin-top: 6px;
}

.react-trello-lane header {
  margin-bottom: 10px;
}

.clGdKf {
  border: 1px solid rgb(204, 204, 204) !important;
}

.sc-kpDqfm {
  color: #495057 !important;
}

.sc-cPiKLX {
  color: #495057 !important;
}

.sc-dAlyuH {
  color: #495057 !important;
}

.sc-dhKdcB {
  max-height: 68vh !important;
}

.flex-container {
  display: flex;
  justify-content: flex-start;
  /* Mengatur ruang antara item secara merata */
  flex-wrap: wrap;
  /* Memungkinkan item untuk melingkar ke baris baru jika ruang tidak mencukupi */
}

.flex-item {
  width: 5.5%;
  text-align: center;
  box-sizing: border-box;
}

/* Media query untuk layar lebih kecil */
@media (max-width: 768px) {
  .flex-item {
    width: 12%;
    /* Lebar item 50% pada layar lebih kecil */
  }
}
@media (max-width: 480px) {
  .flex-item {
    width: 25%;
    /* Lebar penuh pada layar sangat kecil */
  }
}
/* .smooth-dnd-container.horizontal {
  white-space: normal !important;
} */
#dashboard-custom-tooltip {
  width: 400px;
  position: absolute;
  display: none;
  z-index: 1052;
}

.block-badge-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, 56px);
  gap: 5px;
}

.block-badge-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  text-align: center;
}
.block-badge-cell .badge {
  border-radius: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tableFixHead {
  overflow: auto;
  height: 720px;
  padding: 0;
  margin: 0;
}

.tableFixHead thead th {
  position: sticky;
  top: 0;
  z-index: 100;
}

.tableFixHead tfoot th {
  position: sticky;
  bottom: 0;
  z-index: 100;
}

.sticky-col {
  position: sticky;
  background-color: white;
}

.sticky-first-col {
  width: 100px;
  min-width: 100px;
  max-width: 100px;
  left: 0px;
}

.sticky-second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 100px;
}

.courier-prime-regular {
  font-family: "Courier Prime", monospace;
  font-weight: 400;
  font-size: 15px;
  font-style: normal;
}

.courier-prime-bold {
  font-family: "Courier Prime", monospace;
  font-weight: 700;
  font-size: 15px;
  font-style: normal;
}

.text-capitalize {
  text-transform: capitalize;
}

.courier-prime-regular-italic {
  font-family: "Courier Prime", monospace;
  font-weight: 400;
  font-size: 15px;
  font-style: italic;
}

.courier-prime-bold-italic {
  font-family: "Courier Prime", monospace;
  font-weight: 700;
  font-size: 15px;
  font-style: italic;
}

.Toastify__toast-container {
  z-index: 200000 !important;
}

.hero-kwitansi {
  padding: 0px;
}

.hero-kwitansi::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
  background-size: "100%";
  background-repeat: no-repeat;
  background-position: right 40px center;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  opacity: 0.075;
}

.hero-spk {
  padding: 0px;
}

.hero-spk::before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_79___});
  background-size: "100%";
  background-repeat: no-repeat;
  background-position: right 200px;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  opacity: 0.075;
}

.accordion-button:after {
  margin-top: -2px;
  margin-left: -13px;
  margin-right: 0.5em;
}

.accordion-button:not(.collapsed)::after {
  margin-top: -7px;
  margin-left: -6px;
  margin-right: 0.5em;
}

.ledger-content:hover {
  background-color: #e9ebec !important;
}

.ledger-trans-scroll {
  overflow-y: auto;
  overscroll-behavior: contain;
}
.ledger-trans-scroll::-webkit-scrollbar {
  width: 6px;
}
.ledger-trans-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.ledger-trans-scroll::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.ledger-trans-total {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background-color: rgb(212.2, 235.2, 247.8);
}

.floating-btn {
  position: absolute;
  top: 60px;
  right: 60px;
  z-index: 50;
}
@media (max-width: 768px) {
  .floating-btn {
    top: 40px;
    right: 40px;
  }
}
@media (max-width: 480px) {
  .floating-btn {
    top: 20px;
    right: 20px;
  }
}

.table-container-sticky {
  max-height: 530px;
  /* Set a fixed height for the scrollable area */
  overflow-y: auto;
  /* Enable vertical scrolling */
}

.table-fixed-header thead th {
  position: sticky;
  /* Make the header sticky */
  top: -1px;
  /* Stick to the top of the container */
  background-color: #d8edf9;
  /* Add a background color so content doesn't show through */
}

.offcanvas-header-dark .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}

body * {
  outline: none;
}

.noUi-horizontal .noUi-handle {
  height: 16px !important;
  width: 16px !important;
  border-radius: 50% !important;
  right: -10px !important;
  top: -7px !important;
}

.noUi-connect,
.noUi-horizontal {
  height: 2px !important;
}

.noUi-handle {
  background: #0ab39c !important;
  border: 2px solid var(--vz-card-bg) !important;
  box-shadow: none !important;
}

.noUi-target {
  background: #fafafa !important;
  border-radius: 4px !important;
  border: 1px solid #d3d3d3 !important;
  background-color: var(--vz-light) !important;
  border-color: var(--vz-light) !important;
  box-shadow: none !important;
  height: 4px !important;
}

.dropzone .dz-message {
  text-align: center;
}

.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  padding: 5px !important;
  font-size: 12px !important;
  margin-right: 2px;
}

.fc-event {
  border: none !important;
}

@media (max-width: 575.98px) {
  .fc-toolbar {
    display: block !important;
    text-align: center;
  }
  .fc-toolbar .fc-left,
  .fc-toolbar .fc-right,
  .fc-toolbar .fc-center {
    float: none;
    display: block;
    clear: both;
    margin: 10px 0;
  }
  .fc .fc-toolbar > * > * {
    float: none;
  }
  .fc-today-button {
    display: none;
  }
}
.flatpickr-calendar.open {
  z-index: 1090 !important;
}

.upcoming-scheduled .flatpickr-input[readonly] {
  display: none;
}

.ql-container.ql-snow {
  height: 250px;
}

.rangeslider-horizontal .rangeslider__fill {
  background-color: #405189 !important;
}

.simplebar-track-primary .simplebar-scrollbar:before {
  background: #405189 !important;
}

.simplebar-track-secondary .simplebar-scrollbar:before {
  background: #3577f1 !important;
}

.simplebar-track-success .simplebar-scrollbar:before {
  background: #0ab39c !important;
}

.simplebar-track-info .simplebar-scrollbar:before {
  background: #299cdb !important;
}

.simplebar-track-warning .simplebar-scrollbar:before {
  background: #f7b84b !important;
}

.simplebar-track-danger .simplebar-scrollbar:before {
  background: #f06548 !important;
}

.simplebar-track-light .simplebar-scrollbar:before {
  background: #f3f6f9 !important;
}

.simplebar-track-dark .simplebar-scrollbar:before {
  background: #212529 !important;
}

.chat-conversation .chat-list .message-box-drop .nav-btn {
  font-size: 18px;
  padding: 4px;
  color: #878a99;
}

.chatwidgets {
  height: 250px !important;
}

[data-layout=horizontal] .chat-conversation.chatwidgets {
  height: 250px !important;
}

#tsparticles canvas {
  position: absolute !important;
}

.alert-msg-show {
  right: 24px;
  top: 40px;
  z-index: 1005;
}

.pickerEmoji {
  position: absolute;
  bottom: -50px;
  left: 10%;
  transform: translateX(-50%);
}

.Toastify .Toastify__toast {
  min-height: 43px;
}
.Toastify .Toastify__close-button {
  top: 6px;
}
.Toastify .Toastify__close-button--light {
  color: #f3f6f9;
}

.rdl-filter, .rdl-control {
  background-color: var(--vz-input-bg);
  border: 1px solid var(--vz-input-border) !important;
  color: var(--vz-body-color) !important;
}

.rdl-move {
  background: var(--vz-light) !important;
  border: 1px solid var(--vz-light) !important;
  color: var(--vz-body-color) !important;
}

.react-dual-listbox input:disabled, .react-dual-listbox select:disabled {
  background-color: var(--vz-input-disabled-bg) !important;
  border: 1px solid var(--vz-input-border) !important;
}

.css-26l3qy-menu {
  background-color: var(--vz-gray-200) !important;
  border-color: var(--vz-border-color) !important;
}

.css-1n7v3ny-option {
  background-color: var(--vz-gray-300) !important;
  border-color: var(--vz-border-color) !important;
}

/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px var(--vz-input-bg) inset !important;
  background-color: var(--vz-input-bg) !important;
  color: var(--vz-body-color) !important;
  -webkit-text-fill-color: var(--vz-body-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/themes.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/plugins/icons/_materialdesignicons.scss","webpack://./src/assets/scss/plugins/icons/_boxicons.scss","webpack://./src/assets/scss/plugins/icons/_line-awesome.scss","webpack://./src/assets/scss/plugins/icons/_remixicon.scss","webpack://./src/assets/scss/config/default/bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/config/default/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/config/default/app.scss","webpack://./src/assets/scss/fonts/_fonts.scss","webpack://./src/assets/scss/config/default/_theme-light.scss","webpack://./src/assets/scss/config/default/_theme-dark.scss","webpack://./src/assets/scss/structure/_topbar.scss","webpack://./src/assets/scss/structure/_page-head.scss","webpack://./src/assets/scss/structure/_footer.scss","webpack://./src/assets/scss/structure/_vertical.scss","webpack://./src/assets/scss/structure/_horizontal.scss","webpack://./src/assets/scss/structure/_two-column.scss","webpack://./src/assets/scss/structure/_layouts.scss","webpack://./src/assets/scss/components/_waves.scss","webpack://./src/assets/scss/components/_avatar.scss","webpack://./src/assets/scss/components/_accordion.scss","webpack://./src/assets/scss/components/_helper.scss","webpack://./src/assets/scss/components/_preloader.scss","webpack://./src/assets/scss/components/_forms.scss","webpack://./src/assets/scss/components/_widgets.scss","webpack://./src/assets/scss/components/_demos.scss","webpack://./src/assets/scss/components/_print.scss","webpack://./src/assets/scss/components/_ribbons.scss","webpack://./src/assets/scss/components/_toast.scss","webpack://./src/assets/scss/components/_scrollspy.scss","webpack://./src/assets/scss/components/_reboot.scss","webpack://./src/assets/scss/components/_alerts.scss","webpack://./src/assets/scss/components/_backgrounds.scss","webpack://./src/assets/scss/components/_badge.scss","webpack://./src/assets/scss/components/_buttons.scss","webpack://./src/assets/scss/components/_breadcrumb.scss","webpack://./src/assets/scss/components/_card.scss","webpack://./src/assets/scss/components/_dropdown.scss","webpack://./src/assets/scss/components/_nav.scss","webpack://./src/assets/scss/components/_table.scss","webpack://./src/assets/scss/components/_modal.scss","webpack://./src/assets/scss/components/_pagination.scss","webpack://./src/assets/scss/components/_progress.scss","webpack://./src/assets/scss/components/_popover.scss","webpack://./src/assets/scss/components/_type.scss","webpack://./src/assets/scss/components/_form-check.scss","webpack://./src/assets/scss/components/_form-control.scss","webpack://./src/assets/scss/components/_list-group.scss","webpack://./src/assets/scss/plugins/_custom-scrollbar.scss","webpack://./src/assets/scss/plugins/_prismjs.scss","webpack://./src/assets/scss/plugins/_sweetalert2.scss","webpack://./src/assets/scss/plugins/_dropzone.scss","webpack://./src/assets/scss/plugins/_range-slider.scss","webpack://./src/assets/scss/plugins/_sortablejs.scss","webpack://./src/assets/scss/plugins/_tour.scss","webpack://./src/assets/scss/plugins/_swiper.scss","webpack://./src/assets/scss/plugins/_multijs.scss","webpack://./src/assets/scss/plugins/_colorpicker.scss","webpack://./src/assets/scss/plugins/_filepond.scss","webpack://./src/assets/scss/plugins/_form-input-spin.scss","webpack://./src/assets/scss/plugins/_ckeditor.scss","webpack://./src/assets/scss/plugins/_quilljs.scss","webpack://./src/assets/scss/plugins/_gridjs.scss","webpack://./src/assets/scss/plugins/_listjs.scss","webpack://./src/assets/scss/plugins/_apexcharts.scss","webpack://./src/assets/scss/plugins/_chartjs.scss","webpack://./src/assets/scss/plugins/_echarts.scss","webpack://./src/assets/scss/plugins/_google-map.scss","webpack://./src/assets/scss/plugins/_autocomplete.scss","webpack://./src/assets/scss/plugins/_vector-maps.scss","webpack://./src/assets/scss/plugins/_leaflet-maps.scss","webpack://./src/assets/scss/plugins/_fullcalendar.scss","webpack://./src/assets/scss/plugins/_emoji-picker.scss","webpack://./src/assets/scss/plugins/_datatables.scss","webpack://./src/assets/scss/plugins/_select2.scss","webpack://./src/assets/scss/plugins/_flag-input.scss","webpack://./src/assets/scss/plugins/_toastify.scss","webpack://./src/assets/scss/plugins/_choices.scss","webpack://./src/assets/scss/plugins/_flatpicker.scss","webpack://./src/assets/scss/pages/_authentication.scss","webpack://./src/assets/scss/pages/_dashboard.scss","webpack://./src/assets/scss/pages/_timeline.scss","webpack://./src/assets/scss/pages/_gallery.scss","webpack://./src/assets/scss/pages/_errors.scss","webpack://./src/assets/scss/pages/_profile.scss","webpack://./src/assets/scss/pages/_sitemap.scss","webpack://./src/assets/scss/pages/_team.scss","webpack://./src/assets/scss/pages/_coming-soon.scss","webpack://./src/assets/scss/pages/_search-results.scss","webpack://./src/assets/scss/pages/_ecommerce.scss","webpack://./src/assets/scss/pages/_invoice.scss","webpack://./src/assets/scss/pages/_chat.scss","webpack://./src/assets/scss/pages/_email.scss","webpack://./src/assets/scss/pages/_kanban.scss","webpack://./src/assets/scss/pages/_landing.scss","webpack://./src/assets/scss/pages/_nft-landing.scss","webpack://./src/assets/scss/pages/_file-manager.scss","webpack://./src/assets/scss/pages/_to-do.scss","webpack://./src/assets/scss/pages/_jobs.scss","webpack://./src/assets/scss/pages/_job-landing.scss","webpack://./src/assets/scss/config/default/custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;CAAA;ACAA,4BAAA;AACA;EACE,oCAAA;EACA,4CAAA;EACA,qPAAA;EACA,mBAAA;EACA,kBAAA;AFgBF;AEbA;;EAEE,qBAAA;EACA,yDAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,mCAAA;EACA,kCAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,iBAAA;AFeF;;AEZA;EACE,gBAAA;EACA,kBAAA;AFeF;;AEZA;EACE,eAAA;AFeF;;AEZA;EACE,eAAA;AFeF;;AEZA;EACE,eAAA;AFeF;;AEZA;EACE,eAAA;AFeF;;AEZA;EACE,0BAAA;AFeF;;AEZA;EACE,0BAAA;AFeF;;AEZA;EACE,YAAA;AFeF;;AEZA;EACE,+BAAA;AFeF;;AEZA;EACE;;;;;;;;;;;;;;;SAAA;AF8BF;;AEZA;EAGE,wBAAA;AFeF;;AEZA;EACE;;;;;;;;;;;;;;;SAAA;AF8BF;;AEZA;EAGE,wBAAA;AFeF;;AEZA;EACE;;;;;;;;;;;;;;;SAAA;AF8BF;;AEZA;EAGE,yBAAA;AFeF;;AEZA;EACE;;;;;;;;;;;;;;;SAAA;AF8BF;;AEZA;EAGE,yBAAA;AFeF;;AEZA;EACE;;;;;;;;;;;;;;;SAAA;AF8BF;;AEZA;EAGE,yBAAA;AFeF;;AEZA;EACE;;;;;;;;;;;;;;;SAAA;AF8BF;;AEZA;EAGE,yBAAA;AFeF;;AEZA;EACE;;;;;;;;;;;;;;;SAAA;AF8BF;;AEZA;EAGE,yBAAA;AFeF;;AEZA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFeF;;AEZA;EAEE,qBAAA;EACA,aAAA;EACA,mBAAA;AFeF;;AEZA;EAEE,sCAAA;AFeF;AEDA;EACE;IAEE,uBAAA;EFcF;EEZA;IAEE,yBAAA;EFcF;AACF;;AGti0BA;EAEI,uBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,4CAAA;EACA,4SAAA;AHui0BJ;AGji0BA;EAEI,kCAAA;EACA,mBAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;EACA,qBAAA;EAEA,oBAAA;EAEA,WAAA;EACA,mCAAA;EACA,kCAAA;AHgi0BJ;;AG9h0BA;EAEI,gBAAA;EACA,eAAA;EAEA,gBAAA;AH+h0BJ;;AG7h0BA;EAEI,kBAAA;AH+h0BJ;;AG7h0BA;EAEI,kBAAA;EACA,oBAAA;EAEA,kBAAA;EACA,UAAA;EAEA,UAAA;EAEA,kBAAA;AH4h0BJ;AG7g0BA;EAEI;IAGY,oBAAA;EHwh0Bd;EGth0BE;IAGY,yBAAA;EHuh0Bd;AACF;AGpg0BA;EAEI;IAGY,mBAAA;IAER,UAAA;EH+g0BN;EG7g0BE;IAGY,qBAAA;IAER,UAAA;EH6g0BN;AACF;AG5/zBA;EAEI;IAEI,UAAA;EHug0BN;EGrg0BE;IAEI,UAAA;EHsg0BN;EGpg0BE;IAEI,UAAA;EHqg0BN;AACF;AGl/zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EH6/zBN;EG3/zBE;IAGY,4BAAA;IAER,UAAA;EH2/zBN;AACF;AGx+zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EHm/zBN;EGj/zBE;IAGY,2BAAA;IAER,UAAA;EHi/zBN;AACF;AG99zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EHy+zBN;EGv+zBE;IAGY,4BAAA;IAER,UAAA;EHu+zBN;AACF;AGp9zBA;EAEI;IAGY,wBAAA;IAER,UAAA;EH+9zBN;EG79zBE;IAGY,2BAAA;IAER,UAAA;EH69zBN;AACF;AGp7zBA;EAEI;IAGY,2BAAA;EH08zBd;EGv8zBE;IAIY,8DAAA;EHu8zBd;EGp8zBE;IAMY,oDAAA;EHk8zBd;EG/7zBE;IAKY,oCAAA;EH87zBd;EG37zBE;IAGY,2BAAA;EH47zBd;AACF;AG17zBA;EAGY,kCAAA;AH27zBZ;;AGz7zBA;EAGY,kCAAA;AH27zBZ;;AGx7zBA;EAGY,kCAAA;AH07zBZ;;AGx7zBA;EAGY,kCAAA;AH07zBZ;;AGv7zBA;EAGY,wCAAA;AHy7zBZ;;AGv7zBA;EAGY,wCAAA;AHy7zBZ;;AGt7zBA;EAGY,qCAAA;AHw7zBZ;;AGt7zBA;EAGY,qCAAA;AHw7zBZ;;AGt7zBA;EAGY,uCAAA;AHw7zBZ;;AGt7zBA;EAGY,uCAAA;AHw7zBZ;;AGt7zBA;EAGY,yCAAA;AHw7zBZ;;AGt7zBA;EAGY,yCAAA;AHw7zBZ;;AGt7zBA;EAGY,yCAAA;AHw7zBZ;;AGt7zBA;EAGY,yCAAA;AHw7zBZ;;AGt7zBA;EAGY,0CAAA;AHw7zBZ;;AGt7zBA;EAGY,0CAAA;AHw7zBZ;;AGt7zBA;EAEI,0BAAA;AHw7zBJ;;AGt7zBA;EAEI,6BAAA;AHw7zBJ;;AGt7zBA;EAEI,6BAAA;AHw7zBJ;;AGt7zBA;EAEI,0BAAA;AHw7zBJ;;AGt7zBA;EAEI,yBAAA;EACA,kBAAA;EAEA,qBAAA;EACA,aAAA;EACA,6BAAA;EAEA,sBAAA;AHs7zBJ;;AGp7zBA;EAEI,WAAA;EAEA,8BAAA;AHq7zBJ;;AGn7zBA;EAEI,YAAA;EAEA,6BAAA;AHo7zBJ;;AGl7zBA;EAEI,wBAAA;EAEA,sEAAA;AHm7zBJ;;AGj7zBA;EAEI,yBAAA;EAEA,sEAAA;AHk7zBJ;;AGh7zBA;EAEI,yBAAA;EAEA,sEAAA;AHi7zBJ;;AG/6zBA;EAEI,qBAAA;EAEA,gFAAA;AHg7zBJ;;AG96zBA;EAEI,qBAAA;EAEA,gFAAA;AH+6zBJ;;AG76zBA;EAEI,eAAA;EAEA,uCAAA;EACA,qBAAA;AH86zBJ;;AG56zBA;EAEI,eAAA;EAEA,uCAAA;EACA,kBAAA;AH66zBJ;;AGz6zBE;EACE,gBAAA;AH46zBJ;;AG16zBE;EACE,gBAAA;AH66zBJ;;AG36zBE;EACE,gBAAA;AH86zBJ;;AG56zBE;EACE,gBAAA;AH+6zBJ;;AG76zBE;EACE,gBAAA;AHg7zBJ;;AG96zBE;EACE,gBAAA;AHi7zBJ;;AG/6zBE;EACE,gBAAA;AHk7zBJ;;AGh7zBE;EACE,gBAAA;AHm7zBJ;;AGj7zBE;EACE,gBAAA;AHo7zBJ;;AGl7zBE;EACE,gBAAA;AHq7zBJ;;AGn7zBE;EACE,gBAAA;AHs7zBJ;;AGp7zBE;EACE,gBAAA;AHu7zBJ;;AGr7zBE;EACE,gBAAA;AHw7zBJ;;AGt7zBE;EACE,gBAAA;AHy7zBJ;;AGv7zBE;EACE,gBAAA;AH07zBJ;;AGx7zBE;EACE,gBAAA;AH27zBJ;;AGz7zBE;EACE,gBAAA;AH47zBJ;;AG17zBE;EACE,gBAAA;AH67zBJ;;AG37zBE;EACE,gBAAA;AH87zBJ;;AG57zBE;EACE,gBAAA;AH+7zBJ;;AG77zBE;EACE,gBAAA;AHg8zBJ;;AG97zBE;EACE,gBAAA;AHi8zBJ;;AG/7zBE;EACE,gBAAA;AHk8zBJ;;AGh8zBE;EACE,gBAAA;AHm8zBJ;;AGj8zBE;EACE,gBAAA;AHo8zBJ;;AGl8zBE;EACE,gBAAA;AHq8zBJ;;AGn8zBE;EACE,gBAAA;AHs8zBJ;;AGp8zBE;EACE,gBAAA;AHu8zBJ;;AGr8zBE;EACE,gBAAA;AHw8zBJ;;AGt8zBE;EACE,gBAAA;AHy8zBJ;;AGv8zBE;EACE,gBAAA;AH08zBJ;;AGx8zBE;EACE,gBAAA;AH28zBJ;;AGz8zBE;EACE,gBAAA;AH48zBJ;;AG18zBE;EACE,gBAAA;AH68zBJ;;AG38zBE;EACE,gBAAA;AH88zBJ;;AG58zBE;EACE,gBAAA;AH+8zBJ;;AG78zBE;EACE,gBAAA;AHg9zBJ;;AG98zBE;EACE,gBAAA;AHi9zBJ;;AG/8zBE;EACE,gBAAA;AHk9zBJ;;AGh9zBE;EACE,gBAAA;AHm9zBJ;;AGj9zBE;EACE,gBAAA;AHo9zBJ;;AGl9zBE;EACE,gBAAA;AHq9zBJ;;AGn9zBE;EACE,gBAAA;AHs9zBJ;;AGp9zBE;EACE,gBAAA;AHu9zBJ;;AGr9zBE;EACE,gBAAA;AHw9zBJ;;AGt9zBE;EACE,gBAAA;AHy9zBJ;;AGv9zBE;EACE,gBAAA;AH09zBJ;;AGx9zBE;EACE,gBAAA;AH29zBJ;;AGz9zBE;EACE,gBAAA;AH49zBJ;;AG19zBE;EACE,gBAAA;AH69zBJ;;AG39zBE;EACE,gBAAA;AH89zBJ;;AG59zBE;EACE,gBAAA;AH+9zBJ;;AG79zBE;EACE,gBAAA;AHg+zBJ;;AG99zBE;EACE,gBAAA;AHi+zBJ;;AG/9zBE;EACE,gBAAA;AHk+zBJ;;AGh+zBE;EACE,gBAAA;AHm+zBJ;;AGj+zBE;EACE,gBAAA;AHo+zBJ;;AGl+zBE;EACE,gBAAA;AHq+zBJ;;AGn+zBE;EACE,gBAAA;AHs+zBJ;;AGp+zBE;EACE,gBAAA;AHu+zBJ;;AGr+zBE;EACE,gBAAA;AHw+zBJ;;AGt+zBE;EACE,gBAAA;AHy+zBJ;;AGv+zBE;EACE,gBAAA;AH0+zBJ;;AGx+zBE;EACE,gBAAA;AH2+zBJ;;AGz+zBE;EACE,gBAAA;AH4+zBJ;;AG1+zBE;EACE,gBAAA;AH6+zBJ;;AG3+zBE;EACE,gBAAA;AH8+zBJ;;AG5+zBE;EACE,gBAAA;AH++zBJ;;AG7+zBE;EACE,gBAAA;AHg/zBJ;;AG9+zBE;EACE,gBAAA;AHi/zBJ;;AG/+zBE;EACE,gBAAA;AHk/zBJ;;AGh/zBE;EACE,gBAAA;AHm/zBJ;;AGj/zBE;EACE,gBAAA;AHo/zBJ;;AGl/zBE;EACE,gBAAA;AHq/zBJ;;AGn/zBE;EACE,gBAAA;AHs/zBJ;;AGp/zBE;EACE,gBAAA;AHu/zBJ;;AGr/zBE;EACE,gBAAA;AHw/zBJ;;AGt/zBE;EACE,gBAAA;AHy/zBJ;;AGv/zBE;EACE,gBAAA;AH0/zBJ;;AGx/zBE;EACE,gBAAA;AH2/zBJ;;AGz/zBE;EACE,gBAAA;AH4/zBJ;;AG1/zBE;EACE,gBAAA;AH6/zBJ;;AG3/zBE;EACE,gBAAA;AH8/zBJ;;AG5/zBE;EACE,gBAAA;AH+/zBJ;;AG7/zBE;EACE,gBAAA;AHgg0BJ;;AG9/zBE;EACE,gBAAA;AHig0BJ;;AG//zBE;EACE,gBAAA;AHkg0BJ;;AGhg0BE;EACE,gBAAA;AHmg0BJ;;AGjg0BE;EACE,gBAAA;AHog0BJ;;AGlg0BE;EACE,gBAAA;AHqg0BJ;;AGng0BE;EACE,gBAAA;AHsg0BJ;;AGpg0BE;EACE,gBAAA;AHug0BJ;;AGrg0BE;EACE,gBAAA;AHwg0BJ;;AGtg0BE;EACE,gBAAA;AHyg0BJ;;AGvg0BE;EACE,gBAAA;AH0g0BJ;;AGxg0BE;EACE,gBAAA;AH2g0BJ;;AGzg0BE;EACE,gBAAA;AH4g0BJ;;AG1g0BE;EACE,gBAAA;AH6g0BJ;;AG3g0BE;EACE,gBAAA;AH8g0BJ;;AG5g0BE;EACE,gBAAA;AH+g0BJ;;AG7g0BE;EACE,gBAAA;AHgh0BJ;;AG9g0BE;EACE,gBAAA;AHih0BJ;;AG/g0BE;EACE,gBAAA;AHkh0BJ;;AGhh0BE;EACE,gBAAA;AHmh0BJ;;AGjh0BE;EACE,gBAAA;AHoh0BJ;;AGlh0BE;EACE,gBAAA;AHqh0BJ;;AGnh0BE;EACE,gBAAA;AHsh0BJ;;AGph0BE;EACE,gBAAA;AHuh0BJ;;AGrh0BE;EACE,gBAAA;AHwh0BJ;;AGth0BE;EACE,gBAAA;AHyh0BJ;;AGvh0BE;EACE,gBAAA;AH0h0BJ;;AGxh0BE;EACE,gBAAA;AH2h0BJ;;AGzh0BE;EACE,gBAAA;AH4h0BJ;;AG1h0BE;EACE,gBAAA;AH6h0BJ;;AG3h0BE;EACE,gBAAA;AH8h0BJ;;AG5h0BE;EACE,gBAAA;AH+h0BJ;;AG7h0BE;EACE,gBAAA;AHgi0BJ;;AG9h0BE;EACE,gBAAA;AHii0BJ;;AG/h0BE;EACE,gBAAA;AHki0BJ;;AGhi0BE;EACE,gBAAA;AHmi0BJ;;AGji0BE;EACE,gBAAA;AHoi0BJ;;AGli0BE;EACE,gBAAA;AHqi0BJ;;AGni0BE;EACE,gBAAA;AHsi0BJ;;AGpi0BE;EACE,gBAAA;AHui0BJ;;AGri0BE;EACE,gBAAA;AHwi0BJ;;AGti0BE;EACE,gBAAA;AHyi0BJ;;AGvi0BE;EACE,gBAAA;AH0i0BJ;;AGxi0BE;EACE,gBAAA;AH2i0BJ;;AGzi0BE;EACE,gBAAA;AH4i0BJ;;AG1i0BE;EACE,gBAAA;AH6i0BJ;;AG3i0BE;EACE,gBAAA;AH8i0BJ;;AG5i0BE;EACE,gBAAA;AH+i0BJ;;AG7i0BE;EACE,gBAAA;AHgj0BJ;;AG9i0BE;EACE,gBAAA;AHij0BJ;;AG/i0BE;EACE,gBAAA;AHkj0BJ;;AGhj0BE;EACE,gBAAA;AHmj0BJ;;AGjj0BE;EACE,gBAAA;AHoj0BJ;;AGlj0BE;EACE,gBAAA;AHqj0BJ;;AGnj0BE;EACE,gBAAA;AHsj0BJ;;AGpj0BE;EACE,gBAAA;AHuj0BJ;;AGrj0BE;EACE,gBAAA;AHwj0BJ;;AGtj0BE;EACE,gBAAA;AHyj0BJ;;AGvj0BE;EACE,gBAAA;AH0j0BJ;;AGxj0BE;EACE,gBAAA;AH2j0BJ;;AGzj0BE;EACE,gBAAA;AH4j0BJ;;AG1j0BE;EACE,gBAAA;AH6j0BJ;;AG3j0BE;EACE,gBAAA;AH8j0BJ;;AG5j0BE;EACE,gBAAA;AH+j0BJ;;AG7j0BE;EACE,gBAAA;AHgk0BJ;;AG9j0BE;EACE,gBAAA;AHik0BJ;;AG/j0BE;EACE,gBAAA;AHkk0BJ;;AGhk0BE;EACE,gBAAA;AHmk0BJ;;AGjk0BE;EACE,gBAAA;AHok0BJ;;AGlk0BE;EACE,gBAAA;AHqk0BJ;;AGnk0BE;EACE,gBAAA;AHsk0BJ;;AGpk0BE;EACE,gBAAA;AHuk0BJ;;AGrk0BE;EACE,gBAAA;AHwk0BJ;;AGtk0BE;EACE,gBAAA;AHyk0BJ;;AGvk0BE;EACE,gBAAA;AH0k0BJ;;AGxk0BE;EACE,gBAAA;AH2k0BJ;;AGzk0BE;EACE,gBAAA;AH4k0BJ;;AG1k0BE;EACE,gBAAA;AH6k0BJ;;AG3k0BE;EACE,gBAAA;AH8k0BJ;;AG5k0BE;EACE,gBAAA;AH+k0BJ;;AG7k0BE;EACE,gBAAA;AHgl0BJ;;AG9k0BE;EACE,gBAAA;AHil0BJ;;AG/k0BE;EACE,gBAAA;AHkl0BJ;;AGhl0BE;EACE,gBAAA;AHml0BJ;;AGjl0BE;EACE,gBAAA;AHol0BJ;;AGll0BE;EACE,gBAAA;AHql0BJ;;AGnl0BE;EACE,gBAAA;AHsl0BJ;;AGpl0BE;EACE,gBAAA;AHul0BJ;;AGrl0BE;EACE,gBAAA;AHwl0BJ;;AGtl0BE;EACE,gBAAA;AHyl0BJ;;AGvl0BE;EACE,gBAAA;AH0l0BJ;;AGxl0BE;EACE,gBAAA;AH2l0BJ;;AGzl0BE;EACE,gBAAA;AH4l0BJ;;AG1l0BE;EACE,gBAAA;AH6l0BJ;;AG3l0BE;EACE,gBAAA;AH8l0BJ;;AG5l0BE;EACE,gBAAA;AH+l0BJ;;AG7l0BE;EACE,gBAAA;AHgm0BJ;;AG9l0BE;EACE,gBAAA;AHim0BJ;;AG/l0BE;EACE,gBAAA;AHkm0BJ;;AGhm0BE;EACE,gBAAA;AHmm0BJ;;AGjm0BE;EACE,gBAAA;AHom0BJ;;AGlm0BE;EACE,gBAAA;AHqm0BJ;;AGnm0BE;EACE,gBAAA;AHsm0BJ;;AGpm0BE;EACE,gBAAA;AHum0BJ;;AGrm0BE;EACE,gBAAA;AHwm0BJ;;AGtm0BE;EACE,gBAAA;AHym0BJ;;AGvm0BE;EACE,gBAAA;AH0m0BJ;;AGxm0BE;EACE,gBAAA;AH2m0BJ;;AGzm0BE;EACE,gBAAA;AH4m0BJ;;AG1m0BE;EACE,gBAAA;AH6m0BJ;;AG3m0BE;EACE,gBAAA;AH8m0BJ;;AG5m0BE;EACE,gBAAA;AH+m0BJ;;AG7m0BE;EACE,gBAAA;AHgn0BJ;;AG9m0BE;EACE,gBAAA;AHin0BJ;;AG/m0BE;EACE,gBAAA;AHkn0BJ;;AGhn0BE;EACE,gBAAA;AHmn0BJ;;AGjn0BE;EACE,gBAAA;AHon0BJ;;AGln0BE;EACE,gBAAA;AHqn0BJ;;AGnn0BE;EACE,gBAAA;AHsn0BJ;;AGpn0BE;EACE,gBAAA;AHun0BJ;;AGrn0BE;EACE,gBAAA;AHwn0BJ;;AGtn0BE;EACE,gBAAA;AHyn0BJ;;AGvn0BE;EACE,gBAAA;AH0n0BJ;;AGxn0BE;EACE,gBAAA;AH2n0BJ;;AGzn0BE;EACE,gBAAA;AH4n0BJ;;AG1n0BE;EACE,gBAAA;AH6n0BJ;;AG3n0BE;EACE,gBAAA;AH8n0BJ;;AG5n0BE;EACE,gBAAA;AH+n0BJ;;AG7n0BE;EACE,gBAAA;AHgo0BJ;;AG9n0BE;EACE,gBAAA;AHio0BJ;;AG/n0BE;EACE,gBAAA;AHko0BJ;;AGho0BE;EACE,gBAAA;AHmo0BJ;;AGjo0BE;EACE,gBAAA;AHoo0BJ;;AGlo0BE;EACE,gBAAA;AHqo0BJ;;AGno0BE;EACE,gBAAA;AHso0BJ;;AGpo0BE;EACE,gBAAA;AHuo0BJ;;AGro0BE;EACE,gBAAA;AHwo0BJ;;AGto0BE;EACE,gBAAA;AHyo0BJ;;AGvo0BE;EACE,gBAAA;AH0o0BJ;;AGxo0BE;EACE,gBAAA;AH2o0BJ;;AGzo0BE;EACE,gBAAA;AH4o0BJ;;AG1o0BE;EACE,gBAAA;AH6o0BJ;;AG3o0BE;EACE,gBAAA;AH8o0BJ;;AG5o0BE;EACE,gBAAA;AH+o0BJ;;AG7o0BE;EACE,gBAAA;AHgp0BJ;;AG9o0BE;EACE,gBAAA;AHip0BJ;;AG/o0BE;EACE,gBAAA;AHkp0BJ;;AGhp0BE;EACE,gBAAA;AHmp0BJ;;AGjp0BE;EACE,gBAAA;AHop0BJ;;AGlp0BE;EACE,gBAAA;AHqp0BJ;;AGnp0BE;EACE,gBAAA;AHsp0BJ;;AGpp0BE;EACE,gBAAA;AHup0BJ;;AGrp0BE;EACE,gBAAA;AHwp0BJ;;AGtp0BE;EACE,gBAAA;AHyp0BJ;;AGvp0BE;EACE,gBAAA;AH0p0BJ;;AGxp0BE;EACE,gBAAA;AH2p0BJ;;AGzp0BE;EACE,gBAAA;AH4p0BJ;;AG1p0BE;EACE,gBAAA;AH6p0BJ;;AG3p0BE;EACE,gBAAA;AH8p0BJ;;AG5p0BE;EACE,gBAAA;AH+p0BJ;;AG7p0BE;EACE,gBAAA;AHgq0BJ;;AG9p0BE;EACE,gBAAA;AHiq0BJ;;AG/p0BE;EACE,gBAAA;AHkq0BJ;;AGhq0BE;EACE,gBAAA;AHmq0BJ;;AGjq0BE;EACE,gBAAA;AHoq0BJ;;AGlq0BE;EACE,gBAAA;AHqq0BJ;;AGnq0BE;EACE,gBAAA;AHsq0BJ;;AGpq0BE;EACE,gBAAA;AHuq0BJ;;AGrq0BE;EACE,gBAAA;AHwq0BJ;;AGtq0BE;EACE,gBAAA;AHyq0BJ;;AGvq0BE;EACE,gBAAA;AH0q0BJ;;AGxq0BE;EACE,gBAAA;AH2q0BJ;;AGzq0BE;EACE,gBAAA;AH4q0BJ;;AG1q0BE;EACE,gBAAA;AH6q0BJ;;AG3q0BE;EACE,gBAAA;AH8q0BJ;;AG5q0BE;EACE,gBAAA;AH+q0BJ;;AG7q0BE;EACE,gBAAA;AHgr0BJ;;AG9q0BE;EACE,gBAAA;AHir0BJ;;AG/q0BE;EACE,gBAAA;AHkr0BJ;;AGhr0BE;EACE,gBAAA;AHmr0BJ;;AGjr0BE;EACE,gBAAA;AHor0BJ;;AGlr0BE;EACE,gBAAA;AHqr0BJ;;AGnr0BE;EACE,gBAAA;AHsr0BJ;;AGpr0BE;EACE,gBAAA;AHur0BJ;;AGrr0BE;EACE,gBAAA;AHwr0BJ;;AGtr0BE;EACE,gBAAA;AHyr0BJ;;AGvr0BE;EACE,gBAAA;AH0r0BJ;;AGxr0BE;EACE,gBAAA;AH2r0BJ;;AGzr0BE;EACE,gBAAA;AH4r0BJ;;AG1r0BE;EACE,gBAAA;AH6r0BJ;;AG3r0BE;EACE,gBAAA;AH8r0BJ;;AG5r0BE;EACE,gBAAA;AH+r0BJ;;AG7r0BE;EACE,gBAAA;AHgs0BJ;;AG9r0BE;EACE,gBAAA;AHis0BJ;;AG/r0BE;EACE,gBAAA;AHks0BJ;;AGhs0BE;EACE,gBAAA;AHms0BJ;;AGjs0BE;EACE,gBAAA;AHos0BJ;;AGls0BE;EACE,gBAAA;AHqs0BJ;;AGns0BE;EACE,gBAAA;AHss0BJ;;AGps0BE;EACE,gBAAA;AHus0BJ;;AGrs0BE;EACE,gBAAA;AHws0BJ;;AGts0BE;EACE,gBAAA;AHys0BJ;;AGvs0BE;EACE,gBAAA;AH0s0BJ;;AGxs0BE;EACE,gBAAA;AH2s0BJ;;AGzs0BE;EACE,gBAAA;AH4s0BJ;;AG1s0BE;EACE,gBAAA;AH6s0BJ;;AG3s0BE;EACE,gBAAA;AH8s0BJ;;AG5s0BE;EACE,gBAAA;AH+s0BJ;;AG7s0BE;EACE,gBAAA;AHgt0BJ;;AG9s0BE;EACE,gBAAA;AHit0BJ;;AG/s0BE;EACE,gBAAA;AHkt0BJ;;AGht0BE;EACE,gBAAA;AHmt0BJ;;AGjt0BE;EACE,gBAAA;AHot0BJ;;AGlt0BE;EACE,gBAAA;AHqt0BJ;;AGnt0BE;EACE,gBAAA;AHst0BJ;;AGpt0BE;EACE,gBAAA;AHut0BJ;;AGrt0BE;EACE,gBAAA;AHwt0BJ;;AGtt0BE;EACE,gBAAA;AHyt0BJ;;AGvt0BE;EACE,gBAAA;AH0t0BJ;;AGxt0BE;EACE,gBAAA;AH2t0BJ;;AGzt0BE;EACE,gBAAA;AH4t0BJ;;AG1t0BE;EACE,gBAAA;AH6t0BJ;;AG3t0BE;EACE,gBAAA;AH8t0BJ;;AG5t0BE;EACE,gBAAA;AH+t0BJ;;AG7t0BE;EACE,gBAAA;AHgu0BJ;;AG9t0BE;EACE,gBAAA;AHiu0BJ;;AG/t0BE;EACE,gBAAA;AHku0BJ;;AGhu0BE;EACE,gBAAA;AHmu0BJ;;AGju0BE;EACE,gBAAA;AHou0BJ;;AGlu0BE;EACE,gBAAA;AHqu0BJ;;AGnu0BE;EACE,gBAAA;AHsu0BJ;;AGpu0BE;EACE,gBAAA;AHuu0BJ;;AGru0BE;EACE,gBAAA;AHwu0BJ;;AGtu0BE;EACE,gBAAA;AHyu0BJ;;AGvu0BE;EACE,gBAAA;AH0u0BJ;;AGxu0BE;EACE,gBAAA;AH2u0BJ;;AGzu0BE;EACE,gBAAA;AH4u0BJ;;AG1u0BE;EACE,gBAAA;AH6u0BJ;;AG3u0BE;EACE,gBAAA;AH8u0BJ;;AG5u0BE;EACE,gBAAA;AH+u0BJ;;AG7u0BE;EACE,gBAAA;AHgv0BJ;;AG9u0BE;EACE,gBAAA;AHiv0BJ;;AG/u0BE;EACE,gBAAA;AHkv0BJ;;AGhv0BE;EACE,gBAAA;AHmv0BJ;;AGjv0BE;EACE,gBAAA;AHov0BJ;;AGlv0BE;EACE,gBAAA;AHqv0BJ;;AGnv0BE;EACE,gBAAA;AHsv0BJ;;AGpv0BE;EACE,gBAAA;AHuv0BJ;;AGrv0BE;EACE,gBAAA;AHwv0BJ;;AGtv0BE;EACE,gBAAA;AHyv0BJ;;AGvv0BE;EACE,gBAAA;AH0v0BJ;;AGxv0BE;EACE,gBAAA;AH2v0BJ;;AGzv0BE;EACE,gBAAA;AH4v0BJ;;AG1v0BE;EACE,gBAAA;AH6v0BJ;;AG3v0BE;EACE,gBAAA;AH8v0BJ;;AG5v0BE;EACE,gBAAA;AH+v0BJ;;AG7v0BE;EACE,gBAAA;AHgw0BJ;;AG9v0BE;EACE,gBAAA;AHiw0BJ;;AG/v0BE;EACE,gBAAA;AHkw0BJ;;AGhw0BE;EACE,gBAAA;AHmw0BJ;;AGjw0BE;EACE,gBAAA;AHow0BJ;;AGlw0BE;EACE,gBAAA;AHqw0BJ;;AGnw0BE;EACE,gBAAA;AHsw0BJ;;AGpw0BE;EACE,gBAAA;AHuw0BJ;;AGrw0BE;EACE,gBAAA;AHww0BJ;;AGtw0BE;EACE,gBAAA;AHyw0BJ;;AGvw0BE;EACE,gBAAA;AH0w0BJ;;AGxw0BE;EACE,gBAAA;AH2w0BJ;;AGzw0BE;EACE,gBAAA;AH4w0BJ;;AG1w0BE;EACE,gBAAA;AH6w0BJ;;AG3w0BE;EACE,gBAAA;AH8w0BJ;;AG5w0BE;EACE,gBAAA;AH+w0BJ;;AG7w0BE;EACE,gBAAA;AHgx0BJ;;AG9w0BE;EACE,gBAAA;AHix0BJ;;AG/w0BE;EACE,gBAAA;AHkx0BJ;;AGhx0BE;EACE,gBAAA;AHmx0BJ;;AGjx0BE;EACE,gBAAA;AHox0BJ;;AGlx0BE;EACE,gBAAA;AHqx0BJ;;AGnx0BE;EACE,gBAAA;AHsx0BJ;;AGpx0BE;EACE,gBAAA;AHux0BJ;;AGrx0BE;EACE,gBAAA;AHwx0BJ;;AGtx0BE;EACE,gBAAA;AHyx0BJ;;AGvx0BE;EACE,gBAAA;AH0x0BJ;;AGxx0BE;EACE,gBAAA;AH2x0BJ;;AGzx0BE;EACE,gBAAA;AH4x0BJ;;AG1x0BE;EACE,gBAAA;AH6x0BJ;;AG3x0BE;EACE,gBAAA;AH8x0BJ;;AG5x0BE;EACE,gBAAA;AH+x0BJ;;AG7x0BE;EACE,gBAAA;AHgy0BJ;;AG9x0BE;EACE,gBAAA;AHiy0BJ;;AG/x0BE;EACE,gBAAA;AHky0BJ;;AGhy0BE;EACE,gBAAA;AHmy0BJ;;AGjy0BE;EACE,gBAAA;AHoy0BJ;;AGly0BE;EACE,gBAAA;AHqy0BJ;;AGny0BE;EACE,gBAAA;AHsy0BJ;;AGpy0BE;EACE,gBAAA;AHuy0BJ;;AGry0BE;EACE,gBAAA;AHwy0BJ;;AGty0BE;EACE,gBAAA;AHyy0BJ;;AGvy0BE;EACE,gBAAA;AH0y0BJ;;AGxy0BE;EACE,gBAAA;AH2y0BJ;;AGzy0BE;EACE,gBAAA;AH4y0BJ;;AG1y0BE;EACE,gBAAA;AH6y0BJ;;AG3y0BE;EACE,gBAAA;AH8y0BJ;;AG5y0BE;EACE,gBAAA;AH+y0BJ;;AG7y0BE;EACE,gBAAA;AHgz0BJ;;AG9y0BE;EACE,gBAAA;AHiz0BJ;;AG/y0BE;EACE,gBAAA;AHkz0BJ;;AGhz0BE;EACE,gBAAA;AHmz0BJ;;AGjz0BE;EACE,gBAAA;AHoz0BJ;;AGlz0BE;EACE,gBAAA;AHqz0BJ;;AGnz0BE;EACE,gBAAA;AHsz0BJ;;AGpz0BE;EACE,gBAAA;AHuz0BJ;;AGrz0BE;EACE,gBAAA;AHwz0BJ;;AGtz0BE;EACE,gBAAA;AHyz0BJ;;AGvz0BE;EACE,gBAAA;AH0z0BJ;;AGxz0BE;EACE,gBAAA;AH2z0BJ;;AGzz0BE;EACE,gBAAA;AH4z0BJ;;AG1z0BE;EACE,gBAAA;AH6z0BJ;;AG3z0BE;EACE,gBAAA;AH8z0BJ;;AG5z0BE;EACE,gBAAA;AH+z0BJ;;AG7z0BE;EACE,gBAAA;AHg00BJ;;AG9z0BE;EACE,gBAAA;AHi00BJ;;AG/z0BE;EACE,gBAAA;AHk00BJ;;AGh00BE;EACE,gBAAA;AHm00BJ;;AGj00BE;EACE,gBAAA;AHo00BJ;;AGl00BE;EACE,gBAAA;AHq00BJ;;AGn00BE;EACE,gBAAA;AHs00BJ;;AGp00BE;EACE,gBAAA;AHu00BJ;;AGr00BE;EACE,gBAAA;AHw00BJ;;AGt00BE;EACE,gBAAA;AHy00BJ;;AGv00BE;EACE,gBAAA;AH000BJ;;AGx00BE;EACE,gBAAA;AH200BJ;;AGz00BE;EACE,gBAAA;AH400BJ;;AG100BE;EACE,gBAAA;AH600BJ;;AG300BE;EACE,gBAAA;AH800BJ;;AG500BE;EACE,gBAAA;AH+00BJ;;AG700BE;EACE,gBAAA;AHg10BJ;;AG900BE;EACE,gBAAA;AHi10BJ;;AG/00BE;EACE,gBAAA;AHk10BJ;;AGh10BE;EACE,gBAAA;AHm10BJ;;AGj10BE;EACE,gBAAA;AHo10BJ;;AGl10BE;EACE,gBAAA;AHq10BJ;;AGn10BE;EACE,gBAAA;AHs10BJ;;AGp10BE;EACE,gBAAA;AHu10BJ;;AGr10BE;EACE,gBAAA;AHw10BJ;;AGt10BE;EACE,gBAAA;AHy10BJ;;AGv10BE;EACE,gBAAA;AH010BJ;;AGx10BE;EACE,gBAAA;AH210BJ;;AGz10BE;EACE,gBAAA;AH410BJ;;AG110BE;EACE,gBAAA;AH610BJ;;AG310BE;EACE,gBAAA;AH810BJ;;AG510BE;EACE,gBAAA;AH+10BJ;;AG710BE;EACE,gBAAA;AHg20BJ;;AG910BE;EACE,gBAAA;AHi20BJ;;AG/10BE;EACE,gBAAA;AHk20BJ;;AGh20BE;EACE,gBAAA;AHm20BJ;;AGj20BE;EACE,gBAAA;AHo20BJ;;AGl20BE;EACE,gBAAA;AHq20BJ;;AGn20BE;EACE,gBAAA;AHs20BJ;;AGp20BE;EACE,gBAAA;AHu20BJ;;AGr20BE;EACE,gBAAA;AHw20BJ;;AGt20BE;EACE,gBAAA;AHy20BJ;;AGv20BE;EACE,gBAAA;AH020BJ;;AGx20BE;EACE,gBAAA;AH220BJ;;AGz20BE;EACE,gBAAA;AH420BJ;;AG120BE;EACE,gBAAA;AH620BJ;;AG320BE;EACE,gBAAA;AH820BJ;;AG520BE;EACE,gBAAA;AH+20BJ;;AG720BE;EACE,gBAAA;AHg30BJ;;AG920BE;EACE,gBAAA;AHi30BJ;;AG/20BE;EACE,gBAAA;AHk30BJ;;AGh30BE;EACE,gBAAA;AHm30BJ;;AGj30BE;EACE,gBAAA;AHo30BJ;;AGl30BE;EACE,gBAAA;AHq30BJ;;AGn30BE;EACE,gBAAA;AHs30BJ;;AGp30BE;EACE,gBAAA;AHu30BJ;;AGr30BE;EACE,gBAAA;AHw30BJ;;AGt30BE;EACE,gBAAA;AHy30BJ;;AGv30BE;EACE,gBAAA;AH030BJ;;AGx30BE;EACE,gBAAA;AH230BJ;;AGz30BE;EACE,gBAAA;AH430BJ;;AG130BE;EACE,gBAAA;AH630BJ;;AG330BE;EACE,gBAAA;AH830BJ;;AG530BE;EACE,gBAAA;AH+30BJ;;AG730BE;EACE,gBAAA;AHg40BJ;;AG930BE;EACE,gBAAA;AHi40BJ;;AG/30BE;EACE,gBAAA;AHk40BJ;;AGh40BE;EACE,gBAAA;AHm40BJ;;AGj40BE;EACE,gBAAA;AHo40BJ;;AGl40BE;EACE,gBAAA;AHq40BJ;;AGn40BE;EACE,gBAAA;AHs40BJ;;AGp40BE;EACE,gBAAA;AHu40BJ;;AGr40BE;EACE,gBAAA;AHw40BJ;;AGt40BE;EACE,gBAAA;AHy40BJ;;AGv40BE;EACE,gBAAA;AH040BJ;;AGx40BE;EACE,gBAAA;AH240BJ;;AGz40BE;EACE,gBAAA;AH440BJ;;AG140BE;EACE,gBAAA;AH640BJ;;AG340BE;EACE,gBAAA;AH840BJ;;AG540BE;EACE,gBAAA;AH+40BJ;;AG740BE;EACE,gBAAA;AHg50BJ;;AG940BE;EACE,gBAAA;AHi50BJ;;AG/40BE;EACE,gBAAA;AHk50BJ;;AGh50BE;EACE,gBAAA;AHm50BJ;;AGj50BE;EACE,gBAAA;AHo50BJ;;AGl50BE;EACE,gBAAA;AHq50BJ;;AGn50BE;EACE,gBAAA;AHs50BJ;;AGp50BE;EACE,gBAAA;AHu50BJ;;AGr50BE;EACE,gBAAA;AHw50BJ;;AGt50BE;EACE,gBAAA;AHy50BJ;;AGv50BE;EACE,gBAAA;AH050BJ;;AGx50BE;EACE,gBAAA;AH250BJ;;AGz50BE;EACE,gBAAA;AH450BJ;;AG150BE;EACE,gBAAA;AH650BJ;;AG350BE;EACE,gBAAA;AH850BJ;;AG550BE;EACE,gBAAA;AH+50BJ;;AG750BE;EACE,gBAAA;AHg60BJ;;AG950BE;EACE,gBAAA;AHi60BJ;;AG/50BE;EACE,gBAAA;AHk60BJ;;AGh60BE;EACE,gBAAA;AHm60BJ;;AGj60BE;EACE,gBAAA;AHo60BJ;;AGl60BE;EACE,gBAAA;AHq60BJ;;AGn60BE;EACE,gBAAA;AHs60BJ;;AGp60BE;EACE,gBAAA;AHu60BJ;;AGr60BE;EACE,gBAAA;AHw60BJ;;AGt60BE;EACE,gBAAA;AHy60BJ;;AGv60BE;EACE,gBAAA;AH060BJ;;AGx60BE;EACE,gBAAA;AH260BJ;;AGz60BE;EACE,gBAAA;AH460BJ;;AG160BE;EACE,gBAAA;AH660BJ;;AG360BE;EACE,gBAAA;AH860BJ;;AG560BE;EACE,gBAAA;AH+60BJ;;AG760BE;EACE,gBAAA;AHg70BJ;;AG960BE;EACE,gBAAA;AHi70BJ;;AG/60BE;EACE,gBAAA;AHk70BJ;;AGh70BE;EACE,gBAAA;AHm70BJ;;AGj70BE;EACE,gBAAA;AHo70BJ;;AGl70BE;EACE,gBAAA;AHq70BJ;;AGn70BE;EACE,gBAAA;AHs70BJ;;AGp70BE;EACE,gBAAA;AHu70BJ;;AGr70BE;EACE,gBAAA;AHw70BJ;;AGt70BE;EACE,gBAAA;AHy70BJ;;AGv70BE;EACE,gBAAA;AH070BJ;;AGx70BE;EACE,gBAAA;AH270BJ;;AGz70BE;EACE,gBAAA;AH470BJ;;AG170BE;EACE,gBAAA;AH670BJ;;AG370BE;EACE,gBAAA;AH870BJ;;AG570BE;EACE,gBAAA;AH+70BJ;;AG770BE;EACE,gBAAA;AHg80BJ;;AG970BE;EACE,gBAAA;AHi80BJ;;AG/70BE;EACE,gBAAA;AHk80BJ;;AGh80BE;EACE,gBAAA;AHm80BJ;;AGj80BE;EACE,gBAAA;AHo80BJ;;AGl80BE;EACE,gBAAA;AHq80BJ;;AGn80BE;EACE,gBAAA;AHs80BJ;;AGp80BE;EACE,gBAAA;AHu80BJ;;AGr80BE;EACE,gBAAA;AHw80BJ;;AGt80BE;EACE,gBAAA;AHy80BJ;;AGv80BE;EACE,gBAAA;AH080BJ;;AGx80BE;EACE,gBAAA;AH280BJ;;AGz80BE;EACE,gBAAA;AH480BJ;;AG180BE;EACE,gBAAA;AH680BJ;;AG380BE;EACE,gBAAA;AH880BJ;;AG580BE;EACE,gBAAA;AH+80BJ;;AG780BE;EACE,gBAAA;AHg90BJ;;AG980BE;EACE,gBAAA;AHi90BJ;;AG/80BE;EACE,gBAAA;AHk90BJ;;AGh90BE;EACE,gBAAA;AHm90BJ;;AGj90BE;EACE,gBAAA;AHo90BJ;;AGl90BE;EACE,gBAAA;AHq90BJ;;AGn90BE;EACE,gBAAA;AHs90BJ;;AGp90BE;EACE,gBAAA;AHu90BJ;;AGr90BE;EACE,gBAAA;AHw90BJ;;AGt90BE;EACE,gBAAA;AHy90BJ;;AGv90BE;EACE,gBAAA;AH090BJ;;AGx90BE;EACE,gBAAA;AH290BJ;;AGz90BE;EACE,gBAAA;AH490BJ;;AG190BE;EACE,gBAAA;AH690BJ;;AG390BE;EACE,gBAAA;AH890BJ;;AG590BE;EACE,gBAAA;AH+90BJ;;AG790BE;EACE,gBAAA;AHg+0BJ;;AG990BE;EACE,gBAAA;AHi+0BJ;;AG/90BE;EACE,gBAAA;AHk+0BJ;;AGh+0BE;EACE,gBAAA;AHm+0BJ;;AGj+0BE;EACE,gBAAA;AHo+0BJ;;AGl+0BE;EACE,gBAAA;AHq+0BJ;;AGn+0BE;EACE,gBAAA;AHs+0BJ;;AGp+0BE;EACE,gBAAA;AHu+0BJ;;AGr+0BE;EACE,gBAAA;AHw+0BJ;;AGt+0BE;EACE,gBAAA;AHy+0BJ;;AGv+0BE;EACE,gBAAA;AH0+0BJ;;AGx+0BE;EACE,gBAAA;AH2+0BJ;;AGz+0BE;EACE,gBAAA;AH4+0BJ;;AG1+0BE;EACE,gBAAA;AH6+0BJ;;AG3+0BE;EACE,gBAAA;AH8+0BJ;;AG5+0BE;EACE,gBAAA;AH++0BJ;;AG7+0BE;EACE,gBAAA;AHg/0BJ;;AG9+0BE;EACE,gBAAA;AHi/0BJ;;AG/+0BE;EACE,gBAAA;AHk/0BJ;;AGh/0BE;EACE,gBAAA;AHm/0BJ;;AGj/0BE;EACE,gBAAA;AHo/0BJ;;AGl/0BE;EACE,gBAAA;AHq/0BJ;;AGn/0BE;EACE,gBAAA;AHs/0BJ;;AGp/0BE;EACE,gBAAA;AHu/0BJ;;AGr/0BE;EACE,gBAAA;AHw/0BJ;;AGt/0BE;EACE,gBAAA;AHy/0BJ;;AGv/0BE;EACE,gBAAA;AH0/0BJ;;AGx/0BE;EACE,gBAAA;AH2/0BJ;;AGz/0BE;EACE,gBAAA;AH4/0BJ;;AG1/0BE;EACE,gBAAA;AH6/0BJ;;AG3/0BE;EACE,gBAAA;AH8/0BJ;;AG5/0BE;EACE,gBAAA;AH+/0BJ;;AG7/0BE;EACE,gBAAA;AHgg1BJ;;AG9/0BE;EACE,gBAAA;AHig1BJ;;AG//0BE;EACE,gBAAA;AHkg1BJ;;AGhg1BE;EACE,gBAAA;AHmg1BJ;;AGjg1BE;EACE,gBAAA;AHog1BJ;;AGlg1BE;EACE,gBAAA;AHqg1BJ;;AGng1BE;EACE,gBAAA;AHsg1BJ;;AGpg1BE;EACE,gBAAA;AHug1BJ;;AGrg1BE;EACE,gBAAA;AHwg1BJ;;AGtg1BE;EACE,gBAAA;AHyg1BJ;;AGvg1BE;EACE,gBAAA;AH0g1BJ;;AGxg1BE;EACE,gBAAA;AH2g1BJ;;AGzg1BE;EACE,gBAAA;AH4g1BJ;;AG1g1BE;EACE,gBAAA;AH6g1BJ;;AG3g1BE;EACE,gBAAA;AH8g1BJ;;AG5g1BE;EACE,gBAAA;AH+g1BJ;;AG7g1BE;EACE,gBAAA;AHgh1BJ;;AG9g1BE;EACE,gBAAA;AHih1BJ;;AG/g1BE;EACE,gBAAA;AHkh1BJ;;AGhh1BE;EACE,gBAAA;AHmh1BJ;;AGjh1BE;EACE,gBAAA;AHoh1BJ;;AGlh1BE;EACE,gBAAA;AHqh1BJ;;AGnh1BE;EACE,gBAAA;AHsh1BJ;;AGph1BE;EACE,gBAAA;AHuh1BJ;;AGrh1BE;EACE,gBAAA;AHwh1BJ;;AGth1BE;EACE,gBAAA;AHyh1BJ;;AGvh1BE;EACE,gBAAA;AH0h1BJ;;AGxh1BE;EACE,gBAAA;AH2h1BJ;;AGzh1BE;EACE,gBAAA;AH4h1BJ;;AG1h1BE;EACE,gBAAA;AH6h1BJ;;AG3h1BE;EACE,gBAAA;AH8h1BJ;;AG5h1BE;EACE,gBAAA;AH+h1BJ;;AG7h1BE;EACE,gBAAA;AHgi1BJ;;AG9h1BE;EACE,gBAAA;AHii1BJ;;AG/h1BE;EACE,gBAAA;AHki1BJ;;AGhi1BE;EACE,gBAAA;AHmi1BJ;;AGji1BE;EACE,gBAAA;AHoi1BJ;;AGli1BE;EACE,gBAAA;AHqi1BJ;;AGni1BE;EACE,gBAAA;AHsi1BJ;;AGpi1BE;EACE,gBAAA;AHui1BJ;;AGri1BE;EACE,gBAAA;AHwi1BJ;;AGti1BE;EACE,gBAAA;AHyi1BJ;;AGvi1BE;EACE,gBAAA;AH0i1BJ;;AGxi1BE;EACE,gBAAA;AH2i1BJ;;AGzi1BE;EACE,gBAAA;AH4i1BJ;;AG1i1BE;EACE,gBAAA;AH6i1BJ;;AG3i1BE;EACE,gBAAA;AH8i1BJ;;AG5i1BE;EACE,gBAAA;AH+i1BJ;;AG7i1BE;EACE,gBAAA;AHgj1BJ;;AG9i1BE;EACE,gBAAA;AHij1BJ;;AG/i1BE;EACE,gBAAA;AHkj1BJ;;AGhj1BE;EACE,gBAAA;AHmj1BJ;;AGjj1BE;EACE,gBAAA;AHoj1BJ;;AGlj1BE;EACE,gBAAA;AHqj1BJ;;AGnj1BE;EACE,gBAAA;AHsj1BJ;;AGpj1BE;EACE,gBAAA;AHuj1BJ;;AGrj1BE;EACE,gBAAA;AHwj1BJ;;AGtj1BE;EACE,gBAAA;AHyj1BJ;;AGvj1BE;EACE,gBAAA;AH0j1BJ;;AGxj1BE;EACE,gBAAA;AH2j1BJ;;AGzj1BE;EACE,gBAAA;AH4j1BJ;;AG1j1BE;EACE,gBAAA;AH6j1BJ;;AG3j1BE;EACE,gBAAA;AH8j1BJ;;AG5j1BE;EACE,gBAAA;AH+j1BJ;;AG7j1BE;EACE,gBAAA;AHgk1BJ;;AG9j1BE;EACE,gBAAA;AHik1BJ;;AG/j1BE;EACE,gBAAA;AHkk1BJ;;AGhk1BE;EACE,gBAAA;AHmk1BJ;;AGjk1BE;EACE,gBAAA;AHok1BJ;;AGlk1BE;EACE,gBAAA;AHqk1BJ;;AGnk1BE;EACE,gBAAA;AHsk1BJ;;AGpk1BE;EACE,gBAAA;AHuk1BJ;;AGrk1BE;EACE,gBAAA;AHwk1BJ;;AGtk1BE;EACE,gBAAA;AHyk1BJ;;AGvk1BE;EACE,gBAAA;AH0k1BJ;;AGxk1BE;EACE,gBAAA;AH2k1BJ;;AGzk1BE;EACE,gBAAA;AH4k1BJ;;AG1k1BE;EACE,gBAAA;AH6k1BJ;;AG3k1BE;EACE,gBAAA;AH8k1BJ;;AG5k1BE;EACE,gBAAA;AH+k1BJ;;AG7k1BE;EACE,gBAAA;AHgl1BJ;;AG9k1BE;EACE,gBAAA;AHil1BJ;;AG/k1BE;EACE,gBAAA;AHkl1BJ;;AGhl1BE;EACE,gBAAA;AHml1BJ;;AGjl1BE;EACE,gBAAA;AHol1BJ;;AGll1BE;EACE,gBAAA;AHql1BJ;;AGnl1BE;EACE,gBAAA;AHsl1BJ;;AGpl1BE;EACE,gBAAA;AHul1BJ;;AGrl1BE;EACE,gBAAA;AHwl1BJ;;AGtl1BE;EACE,gBAAA;AHyl1BJ;;AGvl1BE;EACE,gBAAA;AH0l1BJ;;AGxl1BE;EACE,gBAAA;AH2l1BJ;;AGzl1BE;EACE,gBAAA;AH4l1BJ;;AG1l1BE;EACE,gBAAA;AH6l1BJ;;AG3l1BE;EACE,gBAAA;AH8l1BJ;;AG5l1BE;EACE,gBAAA;AH+l1BJ;;AG7l1BE;EACE,gBAAA;AHgm1BJ;;AG9l1BE;EACE,gBAAA;AHim1BJ;;AG/l1BE;EACE,gBAAA;AHkm1BJ;;AGhm1BE;EACE,gBAAA;AHmm1BJ;;AGjm1BE;EACE,gBAAA;AHom1BJ;;AGlm1BE;EACE,gBAAA;AHqm1BJ;;AGnm1BE;EACE,gBAAA;AHsm1BJ;;AGpm1BE;EACE,gBAAA;AHum1BJ;;AGrm1BE;EACE,gBAAA;AHwm1BJ;;AGtm1BE;EACE,gBAAA;AHym1BJ;;AGvm1BE;EACE,gBAAA;AH0m1BJ;;AGxm1BE;EACE,gBAAA;AH2m1BJ;;AGzm1BE;EACE,gBAAA;AH4m1BJ;;AG1m1BE;EACE,gBAAA;AH6m1BJ;;AG3m1BE;EACE,gBAAA;AH8m1BJ;;AG5m1BE;EACE,gBAAA;AH+m1BJ;;AG7m1BE;EACE,gBAAA;AHgn1BJ;;AG9m1BE;EACE,gBAAA;AHin1BJ;;AG/m1BE;EACE,gBAAA;AHkn1BJ;;AGhn1BE;EACE,gBAAA;AHmn1BJ;;AGjn1BE;EACE,gBAAA;AHon1BJ;;AGln1BE;EACE,gBAAA;AHqn1BJ;;AGnn1BE;EACE,gBAAA;AHsn1BJ;;AGpn1BE;EACE,gBAAA;AHun1BJ;;AGrn1BE;EACE,gBAAA;AHwn1BJ;;AGtn1BE;EACE,gBAAA;AHyn1BJ;;AGvn1BE;EACE,gBAAA;AH0n1BJ;;AGxn1BE;EACE,gBAAA;AH2n1BJ;;AGzn1BE;EACE,gBAAA;AH4n1BJ;;AG1n1BE;EACE,gBAAA;AH6n1BJ;;AG3n1BE;EACE,gBAAA;AH8n1BJ;;AG5n1BE;EACE,gBAAA;AH+n1BJ;;AG7n1BE;EACE,gBAAA;AHgo1BJ;;AG9n1BE;EACE,gBAAA;AHio1BJ;;AG/n1BE;EACE,gBAAA;AHko1BJ;;AGho1BE;EACE,gBAAA;AHmo1BJ;;AGjo1BE;EACE,gBAAA;AHoo1BJ;;AGlo1BE;EACE,gBAAA;AHqo1BJ;;AGno1BE;EACE,gBAAA;AHso1BJ;;AGpo1BE;EACE,gBAAA;AHuo1BJ;;AGro1BE;EACE,gBAAA;AHwo1BJ;;AGto1BE;EACE,gBAAA;AHyo1BJ;;AGvo1BE;EACE,gBAAA;AH0o1BJ;;AGxo1BE;EACE,gBAAA;AH2o1BJ;;AGzo1BE;EACE,gBAAA;AH4o1BJ;;AG1o1BE;EACE,gBAAA;AH6o1BJ;;AG3o1BE;EACE,gBAAA;AH8o1BJ;;AG5o1BE;EACE,gBAAA;AH+o1BJ;;AG7o1BE;EACE,gBAAA;AHgp1BJ;;AG9o1BE;EACE,gBAAA;AHip1BJ;;AG/o1BE;EACE,gBAAA;AHkp1BJ;;AGhp1BE;EACE,gBAAA;AHmp1BJ;;AGjp1BE;EACE,gBAAA;AHop1BJ;;AGlp1BE;EACE,gBAAA;AHqp1BJ;;AGnp1BE;EACE,gBAAA;AHsp1BJ;;AGpp1BE;EACE,gBAAA;AHup1BJ;;AGrp1BE;EACE,gBAAA;AHwp1BJ;;AGtp1BE;EACE,gBAAA;AHyp1BJ;;AGvp1BE;EACE,gBAAA;AH0p1BJ;;AGxp1BE;EACE,gBAAA;AH2p1BJ;;AGzp1BE;EACE,gBAAA;AH4p1BJ;;AG1p1BE;EACE,gBAAA;AH6p1BJ;;AG3p1BE;EACE,gBAAA;AH8p1BJ;;AG5p1BE;EACE,gBAAA;AH+p1BJ;;AG7p1BE;EACE,gBAAA;AHgq1BJ;;AG9p1BE;EACE,gBAAA;AHiq1BJ;;AG/p1BE;EACE,gBAAA;AHkq1BJ;;AGhq1BE;EACE,gBAAA;AHmq1BJ;;AGjq1BE;EACE,gBAAA;AHoq1BJ;;AGlq1BE;EACE,gBAAA;AHqq1BJ;;AGnq1BE;EACE,gBAAA;AHsq1BJ;;AGpq1BE;EACE,gBAAA;AHuq1BJ;;AGrq1BE;EACE,gBAAA;AHwq1BJ;;AGtq1BE;EACE,gBAAA;AHyq1BJ;;AGvq1BE;EACE,gBAAA;AH0q1BJ;;AGxq1BE;EACE,gBAAA;AH2q1BJ;;AGzq1BE;EACE,gBAAA;AH4q1BJ;;AG1q1BE;EACE,gBAAA;AH6q1BJ;;AG3q1BE;EACE,gBAAA;AH8q1BJ;;AG5q1BE;EACE,gBAAA;AH+q1BJ;;AG7q1BE;EACE,gBAAA;AHgr1BJ;;AG9q1BE;EACE,gBAAA;AHir1BJ;;AG/q1BE;EACE,gBAAA;AHkr1BJ;;AGhr1BE;EACE,gBAAA;AHmr1BJ;;AGjr1BE;EACE,gBAAA;AHor1BJ;;AGlr1BE;EACE,gBAAA;AHqr1BJ;;AGnr1BE;EACE,gBAAA;AHsr1BJ;;AGpr1BE;EACE,gBAAA;AHur1BJ;;AGrr1BE;EACE,gBAAA;AHwr1BJ;;AGtr1BE;EACE,gBAAA;AHyr1BJ;;AGvr1BE;EACE,gBAAA;AH0r1BJ;;AGxr1BE;EACE,gBAAA;AH2r1BJ;;AGzr1BE;EACE,gBAAA;AH4r1BJ;;AG1r1BE;EACE,gBAAA;AH6r1BJ;;AG3r1BE;EACE,gBAAA;AH8r1BJ;;AG5r1BE;EACE,gBAAA;AH+r1BJ;;AG7r1BE;EACE,gBAAA;AHgs1BJ;;AG9r1BE;EACE,gBAAA;AHis1BJ;;AG/r1BE;EACE,gBAAA;AHks1BJ;;AGhs1BE;EACE,gBAAA;AHms1BJ;;AGjs1BE;EACE,gBAAA;AHos1BJ;;AGls1BE;EACE,gBAAA;AHqs1BJ;;AGns1BE;EACE,gBAAA;AHss1BJ;;AGps1BE;EACE,gBAAA;AHus1BJ;;AGrs1BE;EACE,gBAAA;AHws1BJ;;AGts1BE;EACE,gBAAA;AHys1BJ;;AGvs1BE;EACE,gBAAA;AH0s1BJ;;AGxs1BE;EACE,gBAAA;AH2s1BJ;;AGzs1BE;EACE,gBAAA;AH4s1BJ;;AG1s1BE;EACE,gBAAA;AH6s1BJ;;AG3s1BE;EACE,gBAAA;AH8s1BJ;;AG5s1BE;EACE,gBAAA;AH+s1BJ;;AG7s1BE;EACE,gBAAA;AHgt1BJ;;AG9s1BE;EACE,gBAAA;AHit1BJ;;AG/s1BE;EACE,gBAAA;AHkt1BJ;;AGht1BE;EACE,gBAAA;AHmt1BJ;;AGjt1BE;EACE,gBAAA;AHot1BJ;;AGlt1BE;EACE,gBAAA;AHqt1BJ;;AGnt1BE;EACE,gBAAA;AHst1BJ;;AGpt1BE;EACE,gBAAA;AHut1BJ;;AGrt1BE;EACE,gBAAA;AHwt1BJ;;AGtt1BE;EACE,gBAAA;AHyt1BJ;;AGvt1BE;EACE,gBAAA;AH0t1BJ;;AGxt1BE;EACE,gBAAA;AH2t1BJ;;AGzt1BE;EACE,gBAAA;AH4t1BJ;;AG1t1BE;EACE,gBAAA;AH6t1BJ;;AG3t1BE;EACE,gBAAA;AH8t1BJ;;AG5t1BE;EACE,gBAAA;AH+t1BJ;;AG7t1BE;EACE,gBAAA;AHgu1BJ;;AG9t1BE;EACE,gBAAA;AHiu1BJ;;AG/t1BE;EACE,gBAAA;AHku1BJ;;AGhu1BE;EACE,gBAAA;AHmu1BJ;;AGju1BE;EACE,gBAAA;AHou1BJ;;AGlu1BE;EACE,gBAAA;AHqu1BJ;;AGnu1BE;EACE,gBAAA;AHsu1BJ;;AGpu1BE;EACE,gBAAA;AHuu1BJ;;AGru1BE;EACE,gBAAA;AHwu1BJ;;AGtu1BE;EACE,gBAAA;AHyu1BJ;;AGvu1BE;EACE,gBAAA;AH0u1BJ;;AGxu1BE;EACE,gBAAA;AH2u1BJ;;AGzu1BE;EACE,gBAAA;AH4u1BJ;;AG1u1BE;EACE,gBAAA;AH6u1BJ;;AG3u1BE;EACE,gBAAA;AH8u1BJ;;AG5u1BE;EACE,gBAAA;AH+u1BJ;;AG7u1BE;EACE,gBAAA;AHgv1BJ;;AG9u1BE;EACE,gBAAA;AHiv1BJ;;AG/u1BE;EACE,gBAAA;AHkv1BJ;;AGhv1BE;EACE,gBAAA;AHmv1BJ;;AGjv1BE;EACE,gBAAA;AHov1BJ;;AGlv1BE;EACE,gBAAA;AHqv1BJ;;AGnv1BE;EACE,gBAAA;AHsv1BJ;;AGpv1BE;EACE,gBAAA;AHuv1BJ;;AGrv1BE;EACE,gBAAA;AHwv1BJ;;AGtv1BE;EACE,gBAAA;AHyv1BJ;;AGvv1BE;EACE,gBAAA;AH0v1BJ;;AGxv1BE;EACE,gBAAA;AH2v1BJ;;AGzv1BE;EACE,gBAAA;AH4v1BJ;;AG1v1BE;EACE,gBAAA;AH6v1BJ;;AG3v1BE;EACE,gBAAA;AH8v1BJ;;AG5v1BE;EACE,gBAAA;AH+v1BJ;;AG7v1BE;EACE,gBAAA;AHgw1BJ;;AG9v1BE;EACE,gBAAA;AHiw1BJ;;AG/v1BE;EACE,gBAAA;AHkw1BJ;;AGhw1BE;EACE,gBAAA;AHmw1BJ;;AGjw1BE;EACE,gBAAA;AHow1BJ;;AGlw1BE;EACE,gBAAA;AHqw1BJ;;AGnw1BE;EACE,gBAAA;AHsw1BJ;;AGpw1BE;EACE,gBAAA;AHuw1BJ;;AGrw1BE;EACE,gBAAA;AHww1BJ;;AGtw1BE;EACE,gBAAA;AHyw1BJ;;AGvw1BE;EACE,gBAAA;AH0w1BJ;;AGxw1BE;EACE,gBAAA;AH2w1BJ;;AGzw1BE;EACE,gBAAA;AH4w1BJ;;AG1w1BE;EACE,gBAAA;AH6w1BJ;;AG3w1BE;EACE,gBAAA;AH8w1BJ;;AG5w1BE;EACE,gBAAA;AH+w1BJ;;AG7w1BE;EACE,gBAAA;AHgx1BJ;;AG9w1BE;EACE,gBAAA;AHix1BJ;;AG/w1BE;EACE,gBAAA;AHkx1BJ;;AGhx1BE;EACE,gBAAA;AHmx1BJ;;AGjx1BE;EACE,gBAAA;AHox1BJ;;AGlx1BE;EACE,gBAAA;AHqx1BJ;;AGnx1BE;EACE,gBAAA;AHsx1BJ;;AGpx1BE;EACE,gBAAA;AHux1BJ;;AGrx1BE;EACE,gBAAA;AHwx1BJ;;AGtx1BE;EACE,gBAAA;AHyx1BJ;;AGvx1BE;EACE,gBAAA;AH0x1BJ;;AGxx1BE;EACE,gBAAA;AH2x1BJ;;AGzx1BE;EACE,gBAAA;AH4x1BJ;;AG1x1BE;EACE,gBAAA;AH6x1BJ;;AG3x1BE;EACE,gBAAA;AH8x1BJ;;AG5x1BE;EACE,gBAAA;AH+x1BJ;;AG7x1BE;EACE,gBAAA;AHgy1BJ;;AG9x1BE;EACE,gBAAA;AHiy1BJ;;AG/x1BE;EACE,gBAAA;AHky1BJ;;AGhy1BE;EACE,gBAAA;AHmy1BJ;;AGjy1BE;EACE,gBAAA;AHoy1BJ;;AGly1BE;EACE,gBAAA;AHqy1BJ;;AGny1BE;EACE,gBAAA;AHsy1BJ;;AGpy1BE;EACE,gBAAA;AHuy1BJ;;AGry1BE;EACE,gBAAA;AHwy1BJ;;AGty1BE;EACE,gBAAA;AHyy1BJ;;AGvy1BE;EACE,gBAAA;AH0y1BJ;;AGxy1BE;EACE,gBAAA;AH2y1BJ;;AGzy1BE;EACE,gBAAA;AH4y1BJ;;AG1y1BE;EACE,gBAAA;AH6y1BJ;;AG3y1BE;EACE,gBAAA;AH8y1BJ;;AG5y1BE;EACE,gBAAA;AH+y1BJ;;AG7y1BE;EACE,gBAAA;AHgz1BJ;;AG9y1BE;EACE,gBAAA;AHiz1BJ;;AG/y1BE;EACE,gBAAA;AHkz1BJ;;AGhz1BE;EACE,gBAAA;AHmz1BJ;;AGjz1BE;EACE,gBAAA;AHoz1BJ;;AGlz1BE;EACE,gBAAA;AHqz1BJ;;AGnz1BE;EACE,gBAAA;AHsz1BJ;;AGpz1BE;EACE,gBAAA;AHuz1BJ;;AGrz1BE;EACE,gBAAA;AHwz1BJ;;AGtz1BE;EACE,gBAAA;AHyz1BJ;;AGvz1BE;EACE,gBAAA;AH0z1BJ;;AGxz1BE;EACE,gBAAA;AH2z1BJ;;AGzz1BE;EACE,gBAAA;AH4z1BJ;;AG1z1BE;EACE,gBAAA;AH6z1BJ;;AG3z1BE;EACE,gBAAA;AH8z1BJ;;AG5z1BE;EACE,gBAAA;AH+z1BJ;;AG7z1BE;EACE,gBAAA;AHg01BJ;;AG9z1BE;EACE,gBAAA;AHi01BJ;;AG/z1BE;EACE,gBAAA;AHk01BJ;;AGh01BE;EACE,gBAAA;AHm01BJ;;AGj01BE;EACE,gBAAA;AHo01BJ;;AGl01BE;EACE,gBAAA;AHq01BJ;;AGn01BE;EACE,gBAAA;AHs01BJ;;AGp01BE;EACE,gBAAA;AHu01BJ;;AGr01BE;EACE,gBAAA;AHw01BJ;;AGt01BE;EACE,gBAAA;AHy01BJ;;AGv01BE;EACE,gBAAA;AH001BJ;;AGx01BE;EACE,gBAAA;AH201BJ;;AGz01BE;EACE,gBAAA;AH401BJ;;AG101BE;EACE,gBAAA;AH601BJ;;AG301BE;EACE,gBAAA;AH801BJ;;AG501BE;EACE,gBAAA;AH+01BJ;;AG701BE;EACE,gBAAA;AHg11BJ;;AG901BE;EACE,gBAAA;AHi11BJ;;AG/01BE;EACE,gBAAA;AHk11BJ;;AGh11BE;EACE,gBAAA;AHm11BJ;;AGj11BE;EACE,gBAAA;AHo11BJ;;AGl11BE;EACE,gBAAA;AHq11BJ;;AGn11BE;EACE,gBAAA;AHs11BJ;;AGp11BE;EACE,gBAAA;AHu11BJ;;AGr11BE;EACE,gBAAA;AHw11BJ;;AGt11BE;EACE,gBAAA;AHy11BJ;;AGv11BE;EACE,gBAAA;AH011BJ;;AGx11BE;EACE,gBAAA;AH211BJ;;AGz11BE;EACE,gBAAA;AH411BJ;;AG111BE;EACE,gBAAA;AH611BJ;;AG311BE;EACE,gBAAA;AH811BJ;;AG511BE;EACE,gBAAA;AH+11BJ;;AG711BE;EACE,gBAAA;AHg21BJ;;AG911BE;EACE,gBAAA;AHi21BJ;;AG/11BE;EACE,gBAAA;AHk21BJ;;AGh21BE;EACE,gBAAA;AHm21BJ;;AGj21BE;EACE,gBAAA;AHo21BJ;;AGl21BE;EACE,gBAAA;AHq21BJ;;AGn21BE;EACE,gBAAA;AHs21BJ;;AGp21BE;EACE,gBAAA;AHu21BJ;;AGr21BE;EACE,gBAAA;AHw21BJ;;AGt21BE;EACE,gBAAA;AHy21BJ;;AGv21BE;EACE,gBAAA;AH021BJ;;AGx21BE;EACE,gBAAA;AH221BJ;;AGz21BE;EACE,gBAAA;AH421BJ;;AG121BE;EACE,gBAAA;AH621BJ;;AG321BE;EACE,gBAAA;AH821BJ;;AG521BE;EACE,gBAAA;AH+21BJ;;AG721BE;EACE,gBAAA;AHg31BJ;;AG921BE;EACE,gBAAA;AHi31BJ;;AG/21BE;EACE,gBAAA;AHk31BJ;;AGh31BE;EACE,gBAAA;AHm31BJ;;AGj31BE;EACE,gBAAA;AHo31BJ;;AGl31BE;EACE,gBAAA;AHq31BJ;;AGn31BE;EACE,gBAAA;AHs31BJ;;AGp31BE;EACE,gBAAA;AHu31BJ;;AGr31BE;EACE,gBAAA;AHw31BJ;;AGt31BE;EACE,gBAAA;AHy31BJ;;AGv31BE;EACE,gBAAA;AH031BJ;;AGx31BE;EACE,gBAAA;AH231BJ;;AGz31BE;EACE,gBAAA;AH431BJ;;AG131BE;EACE,gBAAA;AH631BJ;;AG331BE;EACE,gBAAA;AH831BJ;;AG531BE;EACE,gBAAA;AH+31BJ;;AG731BE;EACE,gBAAA;AHg41BJ;;AG931BE;EACE,gBAAA;AHi41BJ;;AG/31BE;EACE,gBAAA;AHk41BJ;;AGh41BE;EACE,gBAAA;AHm41BJ;;AGj41BE;EACE,gBAAA;AHo41BJ;;AGl41BE;EACE,gBAAA;AHq41BJ;;AGn41BE;EACE,gBAAA;AHs41BJ;;AGp41BE;EACE,gBAAA;AHu41BJ;;AGr41BE;EACE,gBAAA;AHw41BJ;;AGt41BE;EACE,gBAAA;AHy41BJ;;AGv41BE;EACE,gBAAA;AH041BJ;;AGx41BE;EACE,gBAAA;AH241BJ;;AGz41BE;EACE,gBAAA;AH441BJ;;AG141BE;EACE,gBAAA;AH641BJ;;AG341BE;EACE,gBAAA;AH841BJ;;AG541BE;EACE,gBAAA;AH+41BJ;;AG741BE;EACE,gBAAA;AHg51BJ;;AG941BE;EACE,gBAAA;AHi51BJ;;AG/41BE;EACE,gBAAA;AHk51BJ;;AGh51BE;EACE,gBAAA;AHm51BJ;;AGj51BE;EACE,gBAAA;AHo51BJ;;AGl51BE;EACE,gBAAA;AHq51BJ;;AGn51BE;EACE,gBAAA;AHs51BJ;;AGp51BE;EACE,gBAAA;AHu51BJ;;AGr51BE;EACE,gBAAA;AHw51BJ;;AGt51BE;EACE,gBAAA;AHy51BJ;;AGv51BE;EACE,gBAAA;AH051BJ;;AGx51BE;EACE,gBAAA;AH251BJ;;AGz51BE;EACE,gBAAA;AH451BJ;;AG151BE;EACE,gBAAA;AH651BJ;;AG351BE;EACE,gBAAA;AH851BJ;;AG551BE;EACE,gBAAA;AH+51BJ;;AG751BE;EACE,gBAAA;AHg61BJ;;AG951BE;EACE,gBAAA;AHi61BJ;;AG/51BE;EACE,gBAAA;AHk61BJ;;AGh61BE;EACE,gBAAA;AHm61BJ;;AGj61BE;EACE,gBAAA;AHo61BJ;;AGl61BE;EACE,gBAAA;AHq61BJ;;AGn61BE;EACE,gBAAA;AHs61BJ;;AGp61BE;EACE,gBAAA;AHu61BJ;;AGr61BE;EACE,gBAAA;AHw61BJ;;AGt61BE;EACE,gBAAA;AHy61BJ;;AGv61BE;EACE,gBAAA;AH061BJ;;AGx61BE;EACE,gBAAA;AH261BJ;;AGz61BE;EACE,gBAAA;AH461BJ;;AG161BE;EACE,gBAAA;AH661BJ;;AG361BE;EACE,gBAAA;AH861BJ;;AG561BE;EACE,gBAAA;AH+61BJ;;AG761BE;EACE,gBAAA;AHg71BJ;;AG961BE;EACE,gBAAA;AHi71BJ;;AG/61BE;EACE,gBAAA;AHk71BJ;;AGh71BE;EACE,gBAAA;AHm71BJ;;AGj71BE;EACE,gBAAA;AHo71BJ;;AGl71BE;EACE,gBAAA;AHq71BJ;;AGn71BE;EACE,gBAAA;AHs71BJ;;AGp71BE;EACE,gBAAA;AHu71BJ;;AGr71BE;EACE,gBAAA;AHw71BJ;;AGt71BE;EACE,gBAAA;AHy71BJ;;AGv71BE;EACE,gBAAA;AH071BJ;;AGx71BE;EACE,gBAAA;AH271BJ;;AGz71BE;EACE,gBAAA;AH471BJ;;AG171BE;EACE,gBAAA;AH671BJ;;AG371BE;EACE,gBAAA;AH871BJ;;AG571BE;EACE,gBAAA;AH+71BJ;;AG771BE;EACE,gBAAA;AHg81BJ;;AG971BE;EACE,gBAAA;AHi81BJ;;AG/71BE;EACE,gBAAA;AHk81BJ;;AGh81BE;EACE,gBAAA;AHm81BJ;;AGj81BE;EACE,gBAAA;AHo81BJ;;AGl81BE;EACE,gBAAA;AHq81BJ;;AGn81BE;EACE,gBAAA;AHs81BJ;;AGp81BE;EACE,gBAAA;AHu81BJ;;AGr81BE;EACE,gBAAA;AHw81BJ;;AGt81BE;EACE,gBAAA;AHy81BJ;;AGv81BE;EACE,gBAAA;AH081BJ;;AGx81BE;EACE,gBAAA;AH281BJ;;AGz81BE;EACE,gBAAA;AH481BJ;;AG181BE;EACE,gBAAA;AH681BJ;;AG381BE;EACE,gBAAA;AH881BJ;;AG581BE;EACE,gBAAA;AH+81BJ;;AG781BE;EACE,gBAAA;AHg91BJ;;AG981BE;EACE,gBAAA;AHi91BJ;;AG/81BE;EACE,gBAAA;AHk91BJ;;AGh91BE;EACE,gBAAA;AHm91BJ;;AGj91BE;EACE,gBAAA;AHo91BJ;;AGl91BE;EACE,gBAAA;AHq91BJ;;AGn91BE;EACE,gBAAA;AHs91BJ;;AGp91BE;EACE,gBAAA;AHu91BJ;;AGr91BE;EACE,gBAAA;AHw91BJ;;AGt91BE;EACE,gBAAA;AHy91BJ;;AGv91BE;EACE,gBAAA;AH091BJ;;AGx91BE;EACE,gBAAA;AH291BJ;;AGz91BE;EACE,gBAAA;AH491BJ;;AG191BE;EACE,gBAAA;AH691BJ;;AG391BE;EACE,gBAAA;AH891BJ;;AG591BE;EACE,gBAAA;AH+91BJ;;AG791BE;EACE,gBAAA;AHg+1BJ;;AG991BE;EACE,gBAAA;AHi+1BJ;;AG/91BE;EACE,gBAAA;AHk+1BJ;;AGh+1BE;EACE,gBAAA;AHm+1BJ;;AGj+1BE;EACE,gBAAA;AHo+1BJ;;AGl+1BE;EACE,gBAAA;AHq+1BJ;;AGn+1BE;EACE,gBAAA;AHs+1BJ;;AGp+1BE;EACE,gBAAA;AHu+1BJ;;AGr+1BE;EACE,gBAAA;AHw+1BJ;;AGt+1BE;EACE,gBAAA;AHy+1BJ;;AGv+1BE;EACE,gBAAA;AH0+1BJ;;AGx+1BE;EACE,gBAAA;AH2+1BJ;;AGz+1BE;EACE,gBAAA;AH4+1BJ;;AG1+1BE;EACE,gBAAA;AH6+1BJ;;AG3+1BE;EACE,gBAAA;AH8+1BJ;;AG5+1BE;EACE,gBAAA;AH++1BJ;;AG7+1BE;EACE,gBAAA;AHg/1BJ;;AG9+1BE;EACE,gBAAA;AHi/1BJ;;AG/+1BE;EACE,gBAAA;AHk/1BJ;;AGh/1BE;EACE,gBAAA;AHm/1BJ;;AGj/1BE;EACE,gBAAA;AHo/1BJ;;AGl/1BE;EACE,gBAAA;AHq/1BJ;;AGn/1BE;EACE,gBAAA;AHs/1BJ;;AGp/1BE;EACE,gBAAA;AHu/1BJ;;AGr/1BE;EACE,gBAAA;AHw/1BJ;;AGt/1BE;EACE,gBAAA;AHy/1BJ;;AGv/1BE;EACE,gBAAA;AH0/1BJ;;AGx/1BE;EACE,gBAAA;AH2/1BJ;;AGz/1BE;EACE,gBAAA;AH4/1BJ;;AG1/1BE;EACE,gBAAA;AH6/1BJ;;AG3/1BE;EACE,gBAAA;AH8/1BJ;;AG5/1BE;EACE,gBAAA;AH+/1BJ;;AG7/1BE;EACE,gBAAA;AHgg2BJ;;AG9/1BE;EACE,gBAAA;AHig2BJ;;AG//1BE;EACE,gBAAA;AHkg2BJ;;AGhg2BE;EACE,gBAAA;AHmg2BJ;;AGjg2BE;EACE,gBAAA;AHog2BJ;;AGlg2BE;EACE,gBAAA;AHqg2BJ;;AGng2BE;EACE,gBAAA;AHsg2BJ;;AGpg2BE;EACE,gBAAA;AHug2BJ;;AGrg2BE;EACE,gBAAA;AHwg2BJ;;AGtg2BE;EACE,gBAAA;AHyg2BJ;;AGvg2BE;EACE,gBAAA;AH0g2BJ;;AGxg2BE;EACE,gBAAA;AH2g2BJ;;AGzg2BE;EACE,gBAAA;AH4g2BJ;;AG1g2BE;EACE,gBAAA;AH6g2BJ;;AG3g2BE;EACE,gBAAA;AH8g2BJ;;AG5g2BE;EACE,gBAAA;AH+g2BJ;;AG7g2BE;EACE,gBAAA;AHgh2BJ;;AG9g2BE;EACE,gBAAA;AHih2BJ;;AG/g2BE;EACE,gBAAA;AHkh2BJ;;AGhh2BE;EACE,gBAAA;AHmh2BJ;;AGjh2BE;EACE,gBAAA;AHoh2BJ;;AGlh2BE;EACE,gBAAA;AHqh2BJ;;AGnh2BE;EACE,gBAAA;AHsh2BJ;;AGph2BE;EACE,gBAAA;AHuh2BJ;;AGrh2BE;EACE,gBAAA;AHwh2BJ;;AGth2BE;EACE,gBAAA;AHyh2BJ;;AGvh2BE;EACE,gBAAA;AH0h2BJ;;AGxh2BE;EACE,gBAAA;AH2h2BJ;;AGzh2BE;EACE,gBAAA;AH4h2BJ;;AG1h2BE;EACE,gBAAA;AH6h2BJ;;AG3h2BE;EACE,gBAAA;AH8h2BJ;;AG5h2BE;EACE,gBAAA;AH+h2BJ;;AG7h2BE;EACE,gBAAA;AHgi2BJ;;AG9h2BE;EACE,gBAAA;AHii2BJ;;AG/h2BE;EACE,gBAAA;AHki2BJ;;AGhi2BE;EACE,gBAAA;AHmi2BJ;;AGji2BE;EACE,gBAAA;AHoi2BJ;;AGli2BE;EACE,gBAAA;AHqi2BJ;;AGni2BE;EACE,gBAAA;AHsi2BJ;;AGpi2BE;EACE,gBAAA;AHui2BJ;;AGri2BE;EACE,gBAAA;AHwi2BJ;;AGti2BE;EACE,gBAAA;AHyi2BJ;;AGvi2BE;EACE,gBAAA;AH0i2BJ;;AGxi2BE;EACE,gBAAA;AH2i2BJ;;AGzi2BE;EACE,gBAAA;AH4i2BJ;;AG1i2BE;EACE,gBAAA;AH6i2BJ;;AG3i2BE;EACE,gBAAA;AH8i2BJ;;AG5i2BE;EACE,gBAAA;AH+i2BJ;;AG7i2BE;EACE,gBAAA;AHgj2BJ;;AG9i2BE;EACE,gBAAA;AHij2BJ;;AG/i2BE;EACE,gBAAA;AHkj2BJ;;AGhj2BE;EACE,gBAAA;AHmj2BJ;;AGjj2BE;EACE,gBAAA;AHoj2BJ;;AGlj2BE;EACE,gBAAA;AHqj2BJ;;AGnj2BE;EACE,gBAAA;AHsj2BJ;;AGpj2BE;EACE,gBAAA;AHuj2BJ;;AGrj2BE;EACE,gBAAA;AHwj2BJ;;AGtj2BE;EACE,gBAAA;AHyj2BJ;;AGvj2BE;EACE,gBAAA;AH0j2BJ;;AGxj2BE;EACE,gBAAA;AH2j2BJ;;AGzj2BE;EACE,gBAAA;AH4j2BJ;;AG1j2BE;EACE,gBAAA;AH6j2BJ;;AG3j2BE;EACE,gBAAA;AH8j2BJ;;AG5j2BE;EACE,gBAAA;AH+j2BJ;;AG7j2BE;EACE,gBAAA;AHgk2BJ;;AG9j2BE;EACE,gBAAA;AHik2BJ;;AG/j2BE;EACE,gBAAA;AHkk2BJ;;AGhk2BE;EACE,gBAAA;AHmk2BJ;;AGjk2BE;EACE,gBAAA;AHok2BJ;;AGlk2BE;EACE,gBAAA;AHqk2BJ;;AGnk2BE;EACE,gBAAA;AHsk2BJ;;AGpk2BE;EACE,gBAAA;AHuk2BJ;;AGrk2BE;EACE,gBAAA;AHwk2BJ;;AGtk2BE;EACE,gBAAA;AHyk2BJ;;AGvk2BE;EACE,gBAAA;AH0k2BJ;;AGxk2BE;EACE,gBAAA;AH2k2BJ;;AGzk2BE;EACE,gBAAA;AH4k2BJ;;AG1k2BE;EACE,gBAAA;AH6k2BJ;;AG3k2BE;EACE,gBAAA;AH8k2BJ;;AG5k2BE;EACE,gBAAA;AH+k2BJ;;AG7k2BE;EACE,gBAAA;AHgl2BJ;;AG9k2BE;EACE,gBAAA;AHil2BJ;;AG/k2BE;EACE,gBAAA;AHkl2BJ;;AGhl2BE;EACE,gBAAA;AHml2BJ;;AGjl2BE;EACE,gBAAA;AHol2BJ;;AGll2BE;EACE,gBAAA;AHql2BJ;;AGnl2BE;EACE,gBAAA;AHsl2BJ;;AGpl2BE;EACE,gBAAA;AHul2BJ;;AGrl2BE;EACE,gBAAA;AHwl2BJ;;AGtl2BE;EACE,gBAAA;AHyl2BJ;;AGvl2BE;EACE,gBAAA;AH0l2BJ;;AGxl2BE;EACE,gBAAA;AH2l2BJ;;AGzl2BE;EACE,gBAAA;AH4l2BJ;;AG1l2BE;EACE,gBAAA;AH6l2BJ;;AG3l2BE;EACE,gBAAA;AH8l2BJ;;AG5l2BE;EACE,gBAAA;AH+l2BJ;;AG7l2BE;EACE,gBAAA;AHgm2BJ;;AG9l2BE;EACE,gBAAA;AHim2BJ;;AG/l2BE;EACE,gBAAA;AHkm2BJ;;AGhm2BE;EACE,gBAAA;AHmm2BJ;;AGjm2BE;EACE,gBAAA;AHom2BJ;;AGlm2BE;EACE,gBAAA;AHqm2BJ;;AGnm2BE;EACE,gBAAA;AHsm2BJ;;AGpm2BE;EACE,gBAAA;AHum2BJ;;AGrm2BE;EACE,gBAAA;AHwm2BJ;;AGtm2BE;EACE,gBAAA;AHym2BJ;;AGvm2BE;EACE,gBAAA;AH0m2BJ;;AGxm2BE;EACE,gBAAA;AH2m2BJ;;AGzm2BE;EACE,gBAAA;AH4m2BJ;;AG1m2BE;EACE,gBAAA;AH6m2BJ;;AG3m2BE;EACE,gBAAA;AH8m2BJ;;AG5m2BE;EACE,gBAAA;AH+m2BJ;;AG7m2BE;EACE,gBAAA;AHgn2BJ;;AG9m2BE;EACE,gBAAA;AHin2BJ;;AG/m2BE;EACE,gBAAA;AHkn2BJ;;AGhn2BE;EACE,gBAAA;AHmn2BJ;;AGjn2BE;EACE,gBAAA;AHon2BJ;;AGln2BE;EACE,gBAAA;AHqn2BJ;;AGnn2BE;EACE,gBAAA;AHsn2BJ;;AGpn2BE;EACE,gBAAA;AHun2BJ;;AGrn2BE;EACE,gBAAA;AHwn2BJ;;AGtn2BE;EACE,gBAAA;AHyn2BJ;;AGvn2BE;EACE,gBAAA;AH0n2BJ;;AGxn2BE;EACE,gBAAA;AH2n2BJ;;AGzn2BE;EACE,gBAAA;AH4n2BJ;;AG1n2BE;EACE,gBAAA;AH6n2BJ;;AG3n2BE;EACE,gBAAA;AH8n2BJ;;AG5n2BE;EACE,gBAAA;AH+n2BJ;;AG7n2BE;EACE,gBAAA;AHgo2BJ;;AG9n2BE;EACE,gBAAA;AHio2BJ;;AG/n2BE;EACE,gBAAA;AHko2BJ;;AGho2BE;EACE,gBAAA;AHmo2BJ;;AGjo2BE;EACE,gBAAA;AHoo2BJ;;AGlo2BE;EACE,gBAAA;AHqo2BJ;;AGno2BE;EACE,gBAAA;AHso2BJ;;AGpo2BE;EACE,gBAAA;AHuo2BJ;;AGro2BE;EACE,gBAAA;AHwo2BJ;;AGto2BE;EACE,gBAAA;AHyo2BJ;;AGvo2BE;EACE,gBAAA;AH0o2BJ;;AGxo2BE;EACE,gBAAA;AH2o2BJ;;AGzo2BE;EACE,gBAAA;AH4o2BJ;;AG1o2BE;EACE,gBAAA;AH6o2BJ;;AG3o2BE;EACE,gBAAA;AH8o2BJ;;AG5o2BE;EACE,gBAAA;AH+o2BJ;;AG7o2BE;EACE,gBAAA;AHgp2BJ;;AG9o2BE;EACE,gBAAA;AHip2BJ;;AG/o2BE;EACE,gBAAA;AHkp2BJ;;AGhp2BE;EACE,gBAAA;AHmp2BJ;;AGjp2BE;EACE,gBAAA;AHop2BJ;;AGlp2BE;EACE,gBAAA;AHqp2BJ;;AGnp2BE;EACE,gBAAA;AHsp2BJ;;AGpp2BE;EACE,gBAAA;AHup2BJ;;AGrp2BE;EACE,gBAAA;AHwp2BJ;;AGtp2BE;EACE,gBAAA;AHyp2BJ;;AGvp2BE;EACE,gBAAA;AH0p2BJ;;AGxp2BE;EACE,gBAAA;AH2p2BJ;;AGzp2BE;EACE,gBAAA;AH4p2BJ;;AG1p2BE;EACE,gBAAA;AH6p2BJ;;AG3p2BE;EACE,gBAAA;AH8p2BJ;;AG5p2BE;EACE,gBAAA;AH+p2BJ;;AG7p2BE;EACE,gBAAA;AHgq2BJ;;AG9p2BE;EACE,gBAAA;AHiq2BJ;;AG/p2BE;EACE,gBAAA;AHkq2BJ;;AGhq2BE;EACE,gBAAA;AHmq2BJ;;AGjq2BE;EACE,gBAAA;AHoq2BJ;;AGlq2BE;EACE,gBAAA;AHqq2BJ;;AGnq2BE;EACE,gBAAA;AHsq2BJ;;AGpq2BE;EACE,gBAAA;AHuq2BJ;;AGrq2BE;EACE,gBAAA;AHwq2BJ;;AGtq2BE;EACE,gBAAA;AHyq2BJ;;AGvq2BE;EACE,gBAAA;AH0q2BJ;;AGxq2BE;EACE,gBAAA;AH2q2BJ;;AGzq2BE;EACE,gBAAA;AH4q2BJ;;AG1q2BE;EACE,gBAAA;AH6q2BJ;;AG3q2BE;EACE,gBAAA;AH8q2BJ;;AG5q2BE;EACE,gBAAA;AH+q2BJ;;AG7q2BE;EACE,gBAAA;AHgr2BJ;;AG9q2BE;EACE,gBAAA;AHir2BJ;;AG/q2BE;EACE,gBAAA;AHkr2BJ;;AGhr2BE;EACE,gBAAA;AHmr2BJ;;AGjr2BE;EACE,gBAAA;AHor2BJ;;AGlr2BE;EACE,gBAAA;AHqr2BJ;;AGnr2BE;EACE,gBAAA;AHsr2BJ;;AGpr2BE;EACE,gBAAA;AHur2BJ;;AGrr2BE;EACE,gBAAA;AHwr2BJ;;AGtr2BE;EACE,gBAAA;AHyr2BJ;;AGvr2BE;EACE,gBAAA;AH0r2BJ;;AGxr2BE;EACE,gBAAA;AH2r2BJ;;AGzr2BE;EACE,gBAAA;AH4r2BJ;;AG1r2BE;EACE,gBAAA;AH6r2BJ;;AG3r2BE;EACE,gBAAA;AH8r2BJ;;AG5r2BE;EACE,gBAAA;AH+r2BJ;;AG7r2BE;EACE,gBAAA;AHgs2BJ;;AG9r2BE;EACE,gBAAA;AHis2BJ;;AG/r2BE;EACE,gBAAA;AHks2BJ;;AGhs2BE;EACE,gBAAA;AHms2BJ;;AGjs2BE;EACE,gBAAA;AHos2BJ;;AGls2BE;EACE,gBAAA;AHqs2BJ;;AGns2BE;EACE,gBAAA;AHss2BJ;;AGps2BE;EACE,gBAAA;AHus2BJ;;AGrs2BE;EACE,gBAAA;AHws2BJ;;AGts2BE;EACE,gBAAA;AHys2BJ;;AGvs2BE;EACE,gBAAA;AH0s2BJ;;AGxs2BE;EACE,gBAAA;AH2s2BJ;;AGzs2BE;EACE,gBAAA;AH4s2BJ;;AG1s2BE;EACE,gBAAA;AH6s2BJ;;AG3s2BE;EACE,gBAAA;AH8s2BJ;;AG5s2BE;EACE,gBAAA;AH+s2BJ;;AG7s2BE;EACE,gBAAA;AHgt2BJ;;AG9s2BE;EACE,gBAAA;AHit2BJ;;AG/s2BE;EACE,gBAAA;AHkt2BJ;;AGht2BE;EACE,gBAAA;AHmt2BJ;;AGjt2BE;EACE,gBAAA;AHot2BJ;;AGlt2BE;EACE,gBAAA;AHqt2BJ;;AGnt2BE;EACE,gBAAA;AHst2BJ;;AGpt2BE;EACE,gBAAA;AHut2BJ;;AGrt2BE;EACE,gBAAA;AHwt2BJ;;AGtt2BE;EACE,gBAAA;AHyt2BJ;;AGvt2BE;EACE,gBAAA;AH0t2BJ;;AGxt2BE;EACE,gBAAA;AH2t2BJ;;AGzt2BE;EACE,gBAAA;AH4t2BJ;;AG1t2BE;EACE,gBAAA;AH6t2BJ;;AG3t2BE;EACE,gBAAA;AH8t2BJ;;AG5t2BE;EACE,gBAAA;AH+t2BJ;;AG7t2BE;EACE,gBAAA;AHgu2BJ;;AG9t2BE;EACE,gBAAA;AHiu2BJ;;AG/t2BE;EACE,gBAAA;AHku2BJ;;AGhu2BE;EACE,gBAAA;AHmu2BJ;;AGju2BE;EACE,gBAAA;AHou2BJ;;AGlu2BE;EACE,gBAAA;AHqu2BJ;;AGnu2BE;EACE,gBAAA;AHsu2BJ;;AGpu2BE;EACE,gBAAA;AHuu2BJ;;AGru2BE;EACE,gBAAA;AHwu2BJ;;AGtu2BE;EACE,gBAAA;AHyu2BJ;;AGvu2BE;EACE,gBAAA;AH0u2BJ;;AGxu2BE;EACE,gBAAA;AH2u2BJ;;AGzu2BE;EACE,gBAAA;AH4u2BJ;;AG1u2BE;EACE,gBAAA;AH6u2BJ;;AG3u2BE;EACE,gBAAA;AH8u2BJ;;AG5u2BE;EACE,gBAAA;AH+u2BJ;;AG7u2BE;EACE,gBAAA;AHgv2BJ;;AG9u2BE;EACE,gBAAA;AHiv2BJ;;AG/u2BE;EACE,gBAAA;AHkv2BJ;;AGhv2BE;EACE,gBAAA;AHmv2BJ;;AGjv2BE;EACE,gBAAA;AHov2BJ;;AGlv2BE;EACE,gBAAA;AHqv2BJ;;AGnv2BE;EACE,gBAAA;AHsv2BJ;;AGpv2BE;EACE,gBAAA;AHuv2BJ;;AGrv2BE;EACE,gBAAA;AHwv2BJ;;AGtv2BE;EACE,gBAAA;AHyv2BJ;;AGvv2BE;EACE,gBAAA;AH0v2BJ;;AGxv2BE;EACE,gBAAA;AH2v2BJ;;AGzv2BE;EACE,gBAAA;AH4v2BJ;;AG1v2BE;EACE,gBAAA;AH6v2BJ;;AG3v2BE;EACE,gBAAA;AH8v2BJ;;AG5v2BE;EACE,gBAAA;AH+v2BJ;;AG7v2BE;EACE,gBAAA;AHgw2BJ;;AG9v2BE;EACE,gBAAA;AHiw2BJ;;AG/v2BE;EACE,gBAAA;AHkw2BJ;;AGhw2BE;EACE,gBAAA;AHmw2BJ;;AGjw2BE;EACE,gBAAA;AHow2BJ;;AGlw2BE;EACE,gBAAA;AHqw2BJ;;AGnw2BE;EACE,gBAAA;AHsw2BJ;;AGpw2BE;EACE,gBAAA;AHuw2BJ;;AGrw2BE;EACE,gBAAA;AHww2BJ;;AGtw2BE;EACE,gBAAA;AHyw2BJ;;AGvw2BE;EACE,gBAAA;AH0w2BJ;;AGxw2BE;EACE,gBAAA;AH2w2BJ;;AGzw2BE;EACE,gBAAA;AH4w2BJ;;AG1w2BE;EACE,gBAAA;AH6w2BJ;;AG3w2BE;EACE,gBAAA;AH8w2BJ;;AG5w2BE;EACE,gBAAA;AH+w2BJ;;AG7w2BE;EACE,gBAAA;AHgx2BJ;;AG9w2BE;EACE,gBAAA;AHix2BJ;;AG/w2BE;EACE,gBAAA;AHkx2BJ;;AGhx2BE;EACE,gBAAA;AHmx2BJ;;AGjx2BE;EACE,gBAAA;AHox2BJ;;AGlx2BE;EACE,gBAAA;AHqx2BJ;;AGnx2BE;EACE,gBAAA;AHsx2BJ;;AGpx2BE;EACE,gBAAA;AHux2BJ;;AGrx2BE;EACE,gBAAA;AHwx2BJ;;AGtx2BE;EACE,gBAAA;AHyx2BJ;;AGvx2BE;EACE,gBAAA;AH0x2BJ;;AGxx2BE;EACE,gBAAA;AH2x2BJ;;AGzx2BE;EACE,gBAAA;AH4x2BJ;;AG1x2BE;EACE,gBAAA;AH6x2BJ;;AG3x2BE;EACE,gBAAA;AH8x2BJ;;AG5x2BE;EACE,gBAAA;AH+x2BJ;;AG7x2BE;EACE,gBAAA;AHgy2BJ;;AG9x2BE;EACE,gBAAA;AHiy2BJ;;AG/x2BE;EACE,gBAAA;AHky2BJ;;AGhy2BE;EACE,gBAAA;AHmy2BJ;;AGjy2BE;EACE,gBAAA;AHoy2BJ;;AGly2BE;EACE,gBAAA;AHqy2BJ;;AGny2BE;EACE,gBAAA;AHsy2BJ;;AGpy2BE;EACE,gBAAA;AHuy2BJ;;AGry2BE;EACE,gBAAA;AHwy2BJ;;AGty2BE;EACE,gBAAA;AHyy2BJ;;AGvy2BE;EACE,gBAAA;AH0y2BJ;;AGxy2BE;EACE,gBAAA;AH2y2BJ;;AGzy2BE;EACE,gBAAA;AH4y2BJ;;AG1y2BE;EACE,gBAAA;AH6y2BJ;;AG3y2BE;EACE,gBAAA;AH8y2BJ;;AG5y2BE;EACE,gBAAA;AH+y2BJ;;AG7y2BE;EACE,gBAAA;AHgz2BJ;;AG9y2BE;EACE,gBAAA;AHiz2BJ;;AG/y2BE;EACE,gBAAA;AHkz2BJ;;AGhz2BE;EACE,gBAAA;AHmz2BJ;;AGjz2BE;EACE,gBAAA;AHoz2BJ;;AGlz2BE;EACE,gBAAA;AHqz2BJ;;AGnz2BE;EACE,gBAAA;AHsz2BJ;;AGpz2BE;EACE,gBAAA;AHuz2BJ;;AGrz2BE;EACE,gBAAA;AHwz2BJ;;AGtz2BE;EACE,gBAAA;AHyz2BJ;;AGvz2BE;EACE,gBAAA;AH0z2BJ;;AGxz2BE;EACE,gBAAA;AH2z2BJ;;AGzz2BE;EACE,gBAAA;AH4z2BJ;;AG1z2BE;EACE,gBAAA;AH6z2BJ;;AG3z2BE;EACE,gBAAA;AH8z2BJ;;AG5z2BE;EACE,gBAAA;AH+z2BJ;;AG7z2BE;EACE,gBAAA;AHg02BJ;;AG9z2BE;EACE,gBAAA;AHi02BJ;;AG/z2BE;EACE,gBAAA;AHk02BJ;;AGh02BE;EACE,gBAAA;AHm02BJ;;AGj02BE;EACE,gBAAA;AHo02BJ;;AGl02BE;EACE,gBAAA;AHq02BJ;;AGn02BE;EACE,gBAAA;AHs02BJ;;AGp02BE;EACE,gBAAA;AHu02BJ;;AGr02BE;EACE,gBAAA;AHw02BJ;;AGt02BE;EACE,gBAAA;AHy02BJ;;AGv02BE;EACE,gBAAA;AH002BJ;;AGx02BE;EACE,gBAAA;AH202BJ;;AGz02BE;EACE,gBAAA;AH402BJ;;AG102BE;EACE,gBAAA;AH602BJ;;AG302BE;EACE,gBAAA;AH802BJ;;AG502BE;EACE,gBAAA;AH+02BJ;;AG702BE;EACE,gBAAA;AHg12BJ;;AG902BE;EACE,gBAAA;AHi12BJ;;AG/02BE;EACE,gBAAA;AHk12BJ;;AGh12BE;EACE,gBAAA;AHm12BJ;;AGj12BE;EACE,gBAAA;AHo12BJ;;AGl12BE;EACE,gBAAA;AHq12BJ;;AGn12BE;EACE,gBAAA;AHs12BJ;;AGp12BE;EACE,gBAAA;AHu12BJ;;AGr12BE;EACE,gBAAA;AHw12BJ;;AGt12BE;EACE,gBAAA;AHy12BJ;;AGv12BE;EACE,gBAAA;AH012BJ;;AGx12BE;EACE,gBAAA;AH212BJ;;AGz12BE;EACE,gBAAA;AH412BJ;;AG112BE;EACE,gBAAA;AH612BJ;;AG312BE;EACE,gBAAA;AH812BJ;;AG512BE;EACE,gBAAA;AH+12BJ;;AG712BE;EACE,gBAAA;AHg22BJ;;AG912BE;EACE,gBAAA;AHi22BJ;;AG/12BE;EACE,gBAAA;AHk22BJ;;AGh22BE;EACE,gBAAA;AHm22BJ;;AGj22BE;EACE,gBAAA;AHo22BJ;;AGl22BE;EACE,gBAAA;AHq22BJ;;AGn22BE;EACE,gBAAA;AHs22BJ;;AGp22BE;EACE,gBAAA;AHu22BJ;;AGr22BE;EACE,gBAAA;AHw22BJ;;AGt22BE;EACE,gBAAA;AHy22BJ;;AGv22BE;EACE,gBAAA;AH022BJ;;AGx22BE;EACE,gBAAA;AH222BJ;;AGz22BE;EACE,gBAAA;AH422BJ;;AG122BE;EACE,gBAAA;AH622BJ;;AG322BE;EACE,gBAAA;AH822BJ;;AG522BE;EACE,gBAAA;AH+22BJ;;AG722BE;EACE,gBAAA;AHg32BJ;;AG922BE;EACE,gBAAA;AHi32BJ;;AG/22BE;EACE,gBAAA;AHk32BJ;;AGh32BE;EACE,gBAAA;AHm32BJ;;AGj32BE;EACE,gBAAA;AHo32BJ;;AGl32BE;EACE,gBAAA;AHq32BJ;;AGn32BE;EACE,gBAAA;AHs32BJ;;AGp32BE;EACE,gBAAA;AHu32BJ;;AGr32BE;EACE,gBAAA;AHw32BJ;;AGt32BE;EACE,gBAAA;AHy32BJ;;AGv32BE;EACE,gBAAA;AH032BJ;;AGx32BE;EACE,gBAAA;AH232BJ;;AGz32BE;EACE,gBAAA;AH432BJ;;AG132BE;EACE,gBAAA;AH632BJ;;AG332BE;EACE,gBAAA;AH832BJ;;AG532BE;EACE,gBAAA;AH+32BJ;;AG732BE;EACE,gBAAA;AHg42BJ;;AG932BE;EACE,gBAAA;AHi42BJ;;AG/32BE;EACE,gBAAA;AHk42BJ;;AGh42BE;EACE,gBAAA;AHm42BJ;;AGj42BE;EACE,gBAAA;AHo42BJ;;AGl42BE;EACE,gBAAA;AHq42BJ;;AGn42BE;EACE,gBAAA;AHs42BJ;;AGp42BE;EACE,gBAAA;AHu42BJ;;AGr42BE;EACE,gBAAA;AHw42BJ;;AGt42BE;EACE,gBAAA;AHy42BJ;;AGv42BE;EACE,gBAAA;AH042BJ;;AGx42BE;EACE,gBAAA;AH242BJ;;AGz42BE;EACE,gBAAA;AH442BJ;;AG142BE;EACE,gBAAA;AH642BJ;;AG342BE;EACE,gBAAA;AH842BJ;;AG542BE;EACE,gBAAA;AH+42BJ;;AG742BE;EACE,gBAAA;AHg52BJ;;AG942BE;EACE,gBAAA;AHi52BJ;;AG/42BE;EACE,gBAAA;AHk52BJ;;AGh52BE;EACE,gBAAA;AHm52BJ;;AGj52BE;EACE,gBAAA;AHo52BJ;;AGl52BE;EACE,gBAAA;AHq52BJ;;AGn52BE;EACE,gBAAA;AHs52BJ;;AGp52BE;EACE,gBAAA;AHu52BJ;;AGr52BE;EACE,gBAAA;AHw52BJ;;AGt52BE;EACE,gBAAA;AHy52BJ;;AGv52BE;EACE,gBAAA;AH052BJ;;AGx52BE;EACE,gBAAA;AH252BJ;;AGz52BE;EACE,gBAAA;AH452BJ;;AG152BE;EACE,gBAAA;AH652BJ;;AG352BE;EACE,gBAAA;AH852BJ;;AG552BE;EACE,gBAAA;AH+52BJ;;AG752BE;EACE,gBAAA;AHg62BJ;;AG952BE;EACE,gBAAA;AHi62BJ;;AG/52BE;EACE,gBAAA;AHk62BJ;;AGh62BE;EACE,gBAAA;AHm62BJ;;AGj62BE;EACE,gBAAA;AHo62BJ;;AGl62BE;EACE,gBAAA;AHq62BJ;;AGn62BE;EACE,gBAAA;AHs62BJ;;AGp62BE;EACE,gBAAA;AHu62BJ;;AGr62BE;EACE,gBAAA;AHw62BJ;;AGt62BE;EACE,gBAAA;AHy62BJ;;AGv62BE;EACE,gBAAA;AH062BJ;;AGx62BE;EACE,gBAAA;AH262BJ;;AGz62BE;EACE,gBAAA;AH462BJ;;AG162BE;EACE,gBAAA;AH662BJ;;AG362BE;EACE,gBAAA;AH862BJ;;AG562BE;EACE,gBAAA;AH+62BJ;;AG762BE;EACE,gBAAA;AHg72BJ;;AG962BE;EACE,gBAAA;AHi72BJ;;AG/62BE;EACE,gBAAA;AHk72BJ;;AGh72BE;EACE,gBAAA;AHm72BJ;;AGj72BE;EACE,gBAAA;AHo72BJ;;AGl72BE;EACE,gBAAA;AHq72BJ;;AGn72BE;EACE,gBAAA;AHs72BJ;;AGp72BE;EACE,gBAAA;AHu72BJ;;AGr72BE;EACE,gBAAA;AHw72BJ;;AGt72BE;EACE,gBAAA;AHy72BJ;;AGv72BE;EACE,gBAAA;AH072BJ;;AGx72BE;EACE,gBAAA;AH272BJ;;AGz72BE;EACE,gBAAA;AH472BJ;;AG172BE;EACE,gBAAA;AH672BJ;;AG372BE;EACE,gBAAA;AH872BJ;;AG572BE;EACE,gBAAA;AH+72BJ;;AG772BE;EACE,gBAAA;AHg82BJ;;AG972BE;EACE,gBAAA;AHi82BJ;;AG/72BE;EACE,gBAAA;AHk82BJ;;AGh82BE;EACE,gBAAA;AHm82BJ;;AGj82BE;EACE,gBAAA;AHo82BJ;;AGl82BE;EACE,gBAAA;AHq82BJ;;AGn82BE;EACE,gBAAA;AHs82BJ;;AGp82BE;EACE,gBAAA;AHu82BJ;;AGr82BE;EACE,gBAAA;AHw82BJ;;AGt82BE;EACE,gBAAA;AHy82BJ;;AGv82BE;EACE,gBAAA;AH082BJ;;AGx82BE;EACE,gBAAA;AH282BJ;;AGz82BE;EACE,gBAAA;AH482BJ;;AG182BE;EACE,gBAAA;AH682BJ;;AG382BE;EACE,gBAAA;AH882BJ;;AG582BE;EACE,gBAAA;AH+82BJ;;AG782BE;EACE,gBAAA;AHg92BJ;;AG982BE;EACE,gBAAA;AHi92BJ;;AG/82BE;EACE,gBAAA;AHk92BJ;;AGh92BE;EACE,gBAAA;AHm92BJ;;AGj92BE;EACE,gBAAA;AHo92BJ;;AGl92BE;EACE,gBAAA;AHq92BJ;;AI9lhCA;;;;;;EAME,kCAAA;EACA,mCAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;AJimhCF;;AI/lhCA;EACE,oBAAA;EACA,mBAAA;EACA,yBAAA;AJkmhCF;;AIhmhCA;EACE,iBAAA;AJmmhCF;;AIjmhCA;EACE,kBAAA;AJomhCF;;AIlmhCA;EACE,cAAA;AJqmhCF;;AInmhCA;EACE,cAAA;AJsmhCF;;AIpmhCA;EACE,cAAA;AJumhCF;;AIrmhCA;EACE,cAAA;AJwmhCF;;AItmhCA;EACE,cAAA;AJymhCF;;AIvmhCA;EACE,cAAA;AJ0mhCF;;AIxmhCA;EACE,cAAA;AJ2mhCF;;AIzmhCA;EACE,cAAA;AJ4mhCF;;AI1mhCA;EACE,cAAA;AJ6mhCF;;AI3mhCA;EACE,eAAA;AJ8mhCF;;AI5mhCA;EACE,kBAAA;EACA,aAAA;AJ+mhCF;;AI7mhCA;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AJgnhCF;;AI/mhCE;EACE,kBAAA;AJknhCJ;;AIhnhCA;EACE,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;AJmnhCF;;AIjnhCA;EACE,yBAAA;EACA,oBAAA;EACA,4BAAA;AJonhCF;;AIlnhCA;EACE,WAAA;AJqnhCF;;AInnhCA;EACE,YAAA;AJsnhCF;;AIpnhCA;;;;;EAKE,mBAAA;AJunhCF;;AIrnhCA;;;;;EAKE,kBAAA;AJwnhCF;;AItnhCA;EAEU,qCAAA;AJynhCV;;AIvnhCA;EAEU,uCAAA;AJ0nhCV;AIhnhCA;EACE;IAEU,uBAAA;EJ6nhCV;EI5nhCA;IAEU,yBAAA;EJ8nhCV;AACF;AI7nhCA;EACE,sEAAA;EAEQ,wBAAA;AJ+nhCV;;AI7nhCA;EACE,sEAAA;EAEQ,yBAAA;AJgohCV;;AI9nhCA;EACE,sEAAA;EAEQ,yBAAA;AJiohCV;;AI/nhCA;EACE,gFAAA;EAEQ,uBAAA;AJkohCV;;AIhohCA;EACE,gFAAA;EAEQ,uBAAA;AJmohCV;;AIjohCA;EACE,gFAAA;EAEQ,wBAAA;AJoohCV;;AIlohCA;;;;;;EAOU,YAAA;AJqohCV;;AInohCA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;AJsohCF;;AIpohCA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AJuohCF;;AIrohCA;EACE,oBAAA;AJwohCF;;AItohCA;EACE,cAAA;AJyohCF;;AIvohCA;EACE,WAAA;AJ0ohCF;;AIxohCA;gEAAA;AAEA;EACE,gBAAA;AJ2ohCF;;AIzohCA;EACE,gBAAA;AJ4ohCF;;AI1ohCA;EACE,gBAAA;AJ6ohCF;;AI3ohCA;EACE,gBAAA;AJ8ohCF;;AI5ohCA;EACE,gBAAA;AJ+ohCF;;AI7ohCA;EACE,gBAAA;AJgphCF;;AI9ohCA;EACE,gBAAA;AJiphCF;;AI/ohCA;EACE,gBAAA;AJkphCF;;AIhphCA;EACE,gBAAA;AJmphCF;;AIjphCA;EACE,gBAAA;AJophCF;;AIlphCA;EACE,gBAAA;AJqphCF;;AInphCA;EACE,gBAAA;AJsphCF;;AIpphCA;EACE,gBAAA;AJuphCF;;AIrphCA;EACE,gBAAA;AJwphCF;;AItphCA;EACE,gBAAA;AJyphCF;;AIvphCA;EACE,gBAAA;AJ0phCF;;AIxphCA;EACE,gBAAA;AJ2phCF;;AIzphCA;EACE,gBAAA;AJ4phCF;;AI1phCA;EACE,gBAAA;AJ6phCF;;AI3phCA;EACE,gBAAA;AJ8phCF;;AI5phCA;EACE,gBAAA;AJ+phCF;;AI7phCA;EACE,gBAAA;AJgqhCF;;AI9phCA;EACE,gBAAA;AJiqhCF;;AI/phCA;EACE,gBAAA;AJkqhCF;;AIhqhCA;EACE,gBAAA;AJmqhCF;;AIjqhCA;EACE,gBAAA;AJoqhCF;;AIlqhCA;EACE,gBAAA;AJqqhCF;;AInqhCA;EACE,gBAAA;AJsqhCF;;AIpqhCA;EACE,gBAAA;AJuqhCF;;AIrqhCA;EACE,gBAAA;AJwqhCF;;AItqhCA;EACE,gBAAA;AJyqhCF;;AIvqhCA;EACE,gBAAA;AJ0qhCF;;AIxqhCA;EACE,gBAAA;AJ2qhCF;;AIzqhCA;EACE,gBAAA;AJ4qhCF;;AI1qhCA;EACE,gBAAA;AJ6qhCF;;AI3qhCA;EACE,gBAAA;AJ8qhCF;;AI5qhCA;EACE,gBAAA;AJ+qhCF;;AI7qhCA;EACE,gBAAA;AJgrhCF;;AI9qhCA;EACE,gBAAA;AJirhCF;;AI/qhCA;EACE,gBAAA;AJkrhCF;;AIhrhCA;EACE,gBAAA;AJmrhCF;;AIjrhCA;EACE,gBAAA;AJorhCF;;AIlrhCA;EACE,gBAAA;AJqrhCF;;AInrhCA;EACE,gBAAA;AJsrhCF;;AIprhCA;EACE,gBAAA;AJurhCF;;AIrrhCA;EACE,gBAAA;AJwrhCF;;AItrhCA;EACE,gBAAA;AJyrhCF;;AIvrhCA;EACE,gBAAA;AJ0rhCF;;AIxrhCA;EACE,gBAAA;AJ2rhCF;;AIzrhCA;EACE,gBAAA;AJ4rhCF;;AI1rhCA;EACE,gBAAA;AJ6rhCF;;AI3rhCA;EACE,gBAAA;AJ8rhCF;;AI5rhCA;EACE,gBAAA;AJ+rhCF;;AI7rhCA;EACE,gBAAA;AJgshCF;;AI9rhCA;EACE,gBAAA;AJishCF;;AI/rhCA;EACE,gBAAA;AJkshCF;;AIhshCA;EACE,gBAAA;AJmshCF;;AIjshCA;EACE,gBAAA;AJoshCF;;AIlshCA;EACE,gBAAA;AJqshCF;;AInshCA;EACE,gBAAA;AJsshCF;;AIpshCA;EACE,gBAAA;AJushCF;;AIrshCA;EACE,gBAAA;AJwshCF;;AItshCA;EACE,gBAAA;AJyshCF;;AIvshCA;EACE,gBAAA;AJ0shCF;;AIxshCA;EACE,gBAAA;AJ2shCF;;AIzshCA;EACE,gBAAA;AJ4shCF;;AI1shCA;EACE,gBAAA;AJ6shCF;;AI3shCA;EACE,gBAAA;AJ8shCF;;AI5shCA;EACE,gBAAA;AJ+shCF;;AI7shCA;EACE,gBAAA;AJgthCF;;AI9shCA;EACE,gBAAA;AJithCF;;AI/shCA;EACE,gBAAA;AJkthCF;;AIhthCA;EACE,gBAAA;AJmthCF;;AIjthCA;EACE,gBAAA;AJothCF;;AIlthCA;EACE,gBAAA;AJqthCF;;AInthCA;EACE,gBAAA;AJsthCF;;AIpthCA;EACE,gBAAA;AJuthCF;;AIrthCA;EACE,gBAAA;AJwthCF;;AItthCA;EACE,gBAAA;AJythCF;;AIvthCA;EACE,gBAAA;AJ0thCF;;AIxthCA;EACE,gBAAA;AJ2thCF;;AIzthCA;EACE,gBAAA;AJ4thCF;;AI1thCA;EACE,gBAAA;AJ6thCF;;AI3thCA;EACE,gBAAA;AJ8thCF;;AI5thCA;EACE,gBAAA;AJ+thCF;;AI7thCA;EACE,gBAAA;AJguhCF;;AI9thCA;EACE,gBAAA;AJiuhCF;;AI/thCA;EACE,gBAAA;AJkuhCF;;AIhuhCA;EACE,gBAAA;AJmuhCF;;AIjuhCA;EACE,gBAAA;AJouhCF;;AIluhCA;EACE,gBAAA;AJquhCF;;AInuhCA;EACE,gBAAA;AJsuhCF;;AIpuhCA;EACE,gBAAA;AJuuhCF;;AIruhCA;EACE,gBAAA;AJwuhCF;;AItuhCA;EACE,gBAAA;AJyuhCF;;AIvuhCA;EACE,gBAAA;AJ0uhCF;;AIxuhCA;EACE,gBAAA;AJ2uhCF;;AIzuhCA;EACE,gBAAA;AJ4uhCF;;AI1uhCA;EACE,gBAAA;AJ6uhCF;;AI3uhCA;EACE,gBAAA;AJ8uhCF;;AI5uhCA;EACE,gBAAA;AJ+uhCF;;AI7uhCA;EACE,gBAAA;AJgvhCF;;AI9uhCA;EACE,gBAAA;AJivhCF;;AI/uhCA;EACE,gBAAA;AJkvhCF;;AIhvhCA;EACE,gBAAA;AJmvhCF;;AIjvhCA;EACE,gBAAA;AJovhCF;;AIlvhCA;EACE,gBAAA;AJqvhCF;;AInvhCA;EACE,gBAAA;AJsvhCF;;AIpvhCA;EACE,gBAAA;AJuvhCF;;AIrvhCA;EACE,gBAAA;AJwvhCF;;AItvhCA;EACE,gBAAA;AJyvhCF;;AIvvhCA;EACE,gBAAA;AJ0vhCF;;AIxvhCA;EACE,gBAAA;AJ2vhCF;;AIzvhCA;EACE,gBAAA;AJ4vhCF;;AI1vhCA;EACE,gBAAA;AJ6vhCF;;AI3vhCA;EACE,gBAAA;AJ8vhCF;;AI5vhCA;EACE,gBAAA;AJ+vhCF;;AI7vhCA;EACE,gBAAA;AJgwhCF;;AI9vhCA;EACE,gBAAA;AJiwhCF;;AI/vhCA;EACE,gBAAA;AJkwhCF;;AIhwhCA;EACE,gBAAA;AJmwhCF;;AIjwhCA;EACE,gBAAA;AJowhCF;;AIlwhCA;EACE,gBAAA;AJqwhCF;;AInwhCA;EACE,gBAAA;AJswhCF;;AIpwhCA;EACE,gBAAA;AJuwhCF;;AIrwhCA;EACE,gBAAA;AJwwhCF;;AItwhCA;EACE,gBAAA;AJywhCF;;AIvwhCA;EACE,gBAAA;AJ0whCF;;AIxwhCA;EACE,gBAAA;AJ2whCF;;AIzwhCA;EACE,gBAAA;AJ4whCF;;AI1whCA;EACE,gBAAA;AJ6whCF;;AI3whCA;EACE,gBAAA;AJ8whCF;;AI5whCA;EACE,gBAAA;AJ+whCF;;AI7whCA;EACE,gBAAA;AJgxhCF;;AI9whCA;EACE,gBAAA;AJixhCF;;AI/whCA;EACE,gBAAA;AJkxhCF;;AIhxhCA;EACE,gBAAA;AJmxhCF;;AIjxhCA;EACE,gBAAA;AJoxhCF;;AIlxhCA;EACE,gBAAA;AJqxhCF;;AInxhCA;EACE,gBAAA;AJsxhCF;;AIpxhCA;EACE,gBAAA;AJuxhCF;;AIrxhCA;EACE,gBAAA;AJwxhCF;;AItxhCA;EACE,gBAAA;AJyxhCF;;AIvxhCA;EACE,gBAAA;AJ0xhCF;;AIxxhCA;EACE,gBAAA;AJ2xhCF;;AIzxhCA;EACE,gBAAA;AJ4xhCF;;AI1xhCA;EACE,gBAAA;AJ6xhCF;;AI3xhCA;EACE,gBAAA;AJ8xhCF;;AI5xhCA;EACE,gBAAA;AJ+xhCF;;AI7xhCA;EACE,gBAAA;AJgyhCF;;AI9xhCA;EACE,gBAAA;AJiyhCF;;AI/xhCA;EACE,gBAAA;AJkyhCF;;AIhyhCA;EACE,gBAAA;AJmyhCF;;AIjyhCA;EACE,gBAAA;AJoyhCF;;AIlyhCA;EACE,gBAAA;AJqyhCF;;AInyhCA;EACE,gBAAA;AJsyhCF;;AIpyhCA;EACE,gBAAA;AJuyhCF;;AIryhCA;EACE,gBAAA;AJwyhCF;;AItyhCA;EACE,gBAAA;AJyyhCF;;AIvyhCA;EACE,gBAAA;AJ0yhCF;;AIxyhCA;EACE,gBAAA;AJ2yhCF;;AIzyhCA;EACE,gBAAA;AJ4yhCF;;AI1yhCA;EACE,gBAAA;AJ6yhCF;;AI3yhCA;EACE,gBAAA;AJ8yhCF;;AI5yhCA;EACE,gBAAA;AJ+yhCF;;AI7yhCA;EACE,gBAAA;AJgzhCF;;AI9yhCA;EACE,gBAAA;AJizhCF;;AI/yhCA;EACE,gBAAA;AJkzhCF;;AIhzhCA;EACE,gBAAA;AJmzhCF;;AIjzhCA;EACE,gBAAA;AJozhCF;;AIlzhCA;EACE,gBAAA;AJqzhCF;;AInzhCA;EACE,gBAAA;AJszhCF;;AIpzhCA;EACE,gBAAA;AJuzhCF;;AIrzhCA;EACE,gBAAA;AJwzhCF;;AItzhCA;EACE,gBAAA;AJyzhCF;;AIvzhCA;EACE,gBAAA;AJ0zhCF;;AIxzhCA;EACE,gBAAA;AJ2zhCF;;AIzzhCA;EACE,gBAAA;AJ4zhCF;;AI1zhCA;EACE,gBAAA;AJ6zhCF;;AI3zhCA;EACE,gBAAA;AJ8zhCF;;AI5zhCA;EACE,gBAAA;AJ+zhCF;;AI7zhCA;EACE,gBAAA;AJg0hCF;;AI9zhCA;EACE,gBAAA;AJi0hCF;;AI/zhCA;EACE,gBAAA;AJk0hCF;;AIh0hCA;EACE,gBAAA;AJm0hCF;;AIj0hCA;EACE,gBAAA;AJo0hCF;;AIl0hCA;EACE,gBAAA;AJq0hCF;;AIn0hCA;EACE,gBAAA;AJs0hCF;;AIp0hCA;EACE,gBAAA;AJu0hCF;;AIr0hCA;EACE,gBAAA;AJw0hCF;;AIt0hCA;EACE,gBAAA;AJy0hCF;;AIv0hCA;EACE,gBAAA;AJ00hCF;;AIx0hCA;EACE,gBAAA;AJ20hCF;;AIz0hCA;EACE,gBAAA;AJ40hCF;;AI10hCA;EACE,gBAAA;AJ60hCF;;AI30hCA;EACE,gBAAA;AJ80hCF;;AI50hCA;EACE,gBAAA;AJ+0hCF;;AI70hCA;EACE,gBAAA;AJg1hCF;;AI90hCA;EACE,gBAAA;AJi1hCF;;AI/0hCA;EACE,gBAAA;AJk1hCF;;AIh1hCA;EACE,gBAAA;AJm1hCF;;AIj1hCA;EACE,gBAAA;AJo1hCF;;AIl1hCA;EACE,gBAAA;AJq1hCF;;AIn1hCA;EACE,gBAAA;AJs1hCF;;AIp1hCA;EACE,gBAAA;AJu1hCF;;AIr1hCA;EACE,gBAAA;AJw1hCF;;AIt1hCA;EACE,gBAAA;AJy1hCF;;AIv1hCA;EACE,gBAAA;AJ01hCF;;AIx1hCA;EACE,gBAAA;AJ21hCF;;AIz1hCA;EACE,gBAAA;AJ41hCF;;AI11hCA;EACE,gBAAA;AJ61hCF;;AI31hCA;EACE,gBAAA;AJ81hCF;;AI51hCA;EACE,gBAAA;AJ+1hCF;;AI71hCA;EACE,gBAAA;AJg2hCF;;AI91hCA;EACE,gBAAA;AJi2hCF;;AI/1hCA;EACE,gBAAA;AJk2hCF;;AIh2hCA;EACE,gBAAA;AJm2hCF;;AIj2hCA;EACE,gBAAA;AJo2hCF;;AIl2hCA;EACE,gBAAA;AJq2hCF;;AIn2hCA;EACE,gBAAA;AJs2hCF;;AIp2hCA;EACE,gBAAA;AJu2hCF;;AIr2hCA;EACE,gBAAA;AJw2hCF;;AIt2hCA;EACE,gBAAA;AJy2hCF;;AIv2hCA;EACE,gBAAA;AJ02hCF;;AIx2hCA;EACE,gBAAA;AJ22hCF;;AIz2hCA;EACE,gBAAA;AJ42hCF;;AI12hCA;EACE,gBAAA;AJ62hCF;;AI32hCA;EACE,gBAAA;AJ82hCF;;AI52hCA;EACE,gBAAA;AJ+2hCF;;AI72hCA;EACE,gBAAA;AJg3hCF;;AI92hCA;EACE,gBAAA;AJi3hCF;;AI/2hCA;EACE,gBAAA;AJk3hCF;;AIh3hCA;EACE,gBAAA;AJm3hCF;;AIj3hCA;EACE,gBAAA;AJo3hCF;;AIl3hCA;EACE,gBAAA;AJq3hCF;;AIn3hCA;EACE,gBAAA;AJs3hCF;;AIp3hCA;EACE,gBAAA;AJu3hCF;;AIr3hCA;EACE,gBAAA;AJw3hCF;;AIt3hCA;EACE,gBAAA;AJy3hCF;;AIv3hCA;EACE,gBAAA;AJ03hCF;;AIx3hCA;EACE,gBAAA;AJ23hCF;;AIz3hCA;EACE,gBAAA;AJ43hCF;;AI13hCA;EACE,gBAAA;AJ63hCF;;AI33hCA;EACE,gBAAA;AJ83hCF;;AI53hCA;EACE,gBAAA;AJ+3hCF;;AI73hCA;EACE,gBAAA;AJg4hCF;;AI93hCA;EACE,gBAAA;AJi4hCF;;AI/3hCA;EACE,gBAAA;AJk4hCF;;AIh4hCA;EACE,gBAAA;AJm4hCF;;AIj4hCA;EACE,gBAAA;AJo4hCF;;AIl4hCA;EACE,gBAAA;AJq4hCF;;AIn4hCA;EACE,gBAAA;AJs4hCF;;AIp4hCA;EACE,gBAAA;AJu4hCF;;AIr4hCA;EACE,gBAAA;AJw4hCF;;AIt4hCA;EACE,gBAAA;AJy4hCF;;AIv4hCA;EACE,gBAAA;AJ04hCF;;AIx4hCA;EACE,gBAAA;AJ24hCF;;AIz4hCA;EACE,gBAAA;AJ44hCF;;AI14hCA;EACE,gBAAA;AJ64hCF;;AI34hCA;EACE,gBAAA;AJ84hCF;;AI54hCA;EACE,gBAAA;AJ+4hCF;;AI74hCA;EACE,gBAAA;AJg5hCF;;AI94hCA;EACE,gBAAA;AJi5hCF;;AI/4hCA;EACE,gBAAA;AJk5hCF;;AIh5hCA;EACE,gBAAA;AJm5hCF;;AIj5hCA;EACE,gBAAA;AJo5hCF;;AIl5hCA;EACE,gBAAA;AJq5hCF;;AIn5hCA;EACE,gBAAA;AJs5hCF;;AIp5hCA;EACE,gBAAA;AJu5hCF;;AIr5hCA;EACE,gBAAA;AJw5hCF;;AIt5hCA;EACE,gBAAA;AJy5hCF;;AIv5hCA;EACE,gBAAA;AJ05hCF;;AIx5hCA;EACE,gBAAA;AJ25hCF;;AIz5hCA;EACE,gBAAA;AJ45hCF;;AI15hCA;EACE,gBAAA;AJ65hCF;;AI35hCA;EACE,gBAAA;AJ85hCF;;AI55hCA;EACE,gBAAA;AJ+5hCF;;AI75hCA;EACE,gBAAA;AJg6hCF;;AI95hCA;EACE,gBAAA;AJi6hCF;;AI/5hCA;EACE,gBAAA;AJk6hCF;;AIh6hCA;EACE,gBAAA;AJm6hCF;;AIj6hCA;EACE,gBAAA;AJo6hCF;;AIl6hCA;EACE,gBAAA;AJq6hCF;;AIn6hCA;EACE,gBAAA;AJs6hCF;;AIp6hCA;EACE,gBAAA;AJu6hCF;;AIr6hCA;EACE,gBAAA;AJw6hCF;;AIt6hCA;EACE,gBAAA;AJy6hCF;;AIv6hCA;EACE,gBAAA;AJ06hCF;;AIx6hCA;EACE,gBAAA;AJ26hCF;;AIz6hCA;EACE,gBAAA;AJ46hCF;;AI16hCA;EACE,gBAAA;AJ66hCF;;AI36hCA;EACE,gBAAA;AJ86hCF;;AI56hCA;EACE,gBAAA;AJ+6hCF;;AI76hCA;EACE,gBAAA;AJg7hCF;;AI96hCA;EACE,gBAAA;AJi7hCF;;AI/6hCA;EACE,gBAAA;AJk7hCF;;AIh7hCA;EACE,gBAAA;AJm7hCF;;AIj7hCA;EACE,gBAAA;AJo7hCF;;AIl7hCA;EACE,gBAAA;AJq7hCF;;AIn7hCA;EACE,gBAAA;AJs7hCF;;AIp7hCA;EACE,gBAAA;AJu7hCF;;AIr7hCA;EACE,gBAAA;AJw7hCF;;AIt7hCA;EACE,gBAAA;AJy7hCF;;AIv7hCA;EACE,gBAAA;AJ07hCF;;AIx7hCA;EACE,gBAAA;AJ27hCF;;AIz7hCA;EACE,gBAAA;AJ47hCF;;AI17hCA;EACE,gBAAA;AJ67hCF;;AI37hCA;EACE,gBAAA;AJ87hCF;;AI57hCA;EACE,gBAAA;AJ+7hCF;;AI77hCA;EACE,gBAAA;AJg8hCF;;AI97hCA;EACE,gBAAA;AJi8hCF;;AI/7hCA;EACE,gBAAA;AJk8hCF;;AIh8hCA;EACE,gBAAA;AJm8hCF;;AIj8hCA;EACE,gBAAA;AJo8hCF;;AIl8hCA;EACE,gBAAA;AJq8hCF;;AIn8hCA;EACE,gBAAA;AJs8hCF;;AIp8hCA;EACE,gBAAA;AJu8hCF;;AIr8hCA;EACE,gBAAA;AJw8hCF;;AIt8hCA;EACE,gBAAA;AJy8hCF;;AIv8hCA;EACE,gBAAA;AJ08hCF;;AIx8hCA;EACE,gBAAA;AJ28hCF;;AIz8hCA;EACE,gBAAA;AJ48hCF;;AI18hCA;EACE,gBAAA;AJ68hCF;;AI38hCA;EACE,gBAAA;AJ88hCF;;AI58hCA;EACE,gBAAA;AJ+8hCF;;AI78hCA;EACE,gBAAA;AJg9hCF;;AI98hCA;EACE,gBAAA;AJi9hCF;;AI/8hCA;EACE,gBAAA;AJk9hCF;;AIh9hCA;EACE,gBAAA;AJm9hCF;;AIj9hCA;EACE,gBAAA;AJo9hCF;;AIl9hCA;EACE,gBAAA;AJq9hCF;;AIn9hCA;EACE,gBAAA;AJs9hCF;;AIp9hCA;EACE,gBAAA;AJu9hCF;;AIr9hCA;EACE,gBAAA;AJw9hCF;;AIt9hCA;EACE,gBAAA;AJy9hCF;;AIv9hCA;EACE,gBAAA;AJ09hCF;;AIx9hCA;EACE,gBAAA;AJ29hCF;;AIz9hCA;EACE,gBAAA;AJ49hCF;;AI19hCA;EACE,gBAAA;AJ69hCF;;AI39hCA;EACE,gBAAA;AJ89hCF;;AI59hCA;EACE,gBAAA;AJ+9hCF;;AI79hCA;EACE,gBAAA;AJg+hCF;;AI99hCA;EACE,gBAAA;AJi+hCF;;AI/9hCA;EACE,gBAAA;AJk+hCF;;AIh+hCA;EACE,gBAAA;AJm+hCF;;AIj+hCA;EACE,gBAAA;AJo+hCF;;AIl+hCA;EACE,gBAAA;AJq+hCF;;AIn+hCA;EACE,gBAAA;AJs+hCF;;AIp+hCA;EACE,gBAAA;AJu+hCF;;AIr+hCA;EACE,gBAAA;AJw+hCF;;AIt+hCA;EACE,gBAAA;AJy+hCF;;AIv+hCA;EACE,gBAAA;AJ0+hCF;;AIx+hCA;EACE,gBAAA;AJ2+hCF;;AIz+hCA;EACE,gBAAA;AJ4+hCF;;AI1+hCA;EACE,gBAAA;AJ6+hCF;;AI3+hCA;EACE,gBAAA;AJ8+hCF;;AI5+hCA;EACE,gBAAA;AJ++hCF;;AI7+hCA;EACE,gBAAA;AJg/hCF;;AI9+hCA;EACE,gBAAA;AJi/hCF;;AI/+hCA;EACE,gBAAA;AJk/hCF;;AIh/hCA;EACE,gBAAA;AJm/hCF;;AIj/hCA;EACE,gBAAA;AJo/hCF;;AIl/hCA;EACE,gBAAA;AJq/hCF;;AIn/hCA;EACE,gBAAA;AJs/hCF;;AIp/hCA;EACE,gBAAA;AJu/hCF;;AIr/hCA;EACE,gBAAA;AJw/hCF;;AIt/hCA;EACE,gBAAA;AJy/hCF;;AIv/hCA;EACE,gBAAA;AJ0/hCF;;AIx/hCA;EACE,gBAAA;AJ2/hCF;;AIz/hCA;EACE,gBAAA;AJ4/hCF;;AI1/hCA;EACE,gBAAA;AJ6/hCF;;AI3/hCA;EACE,gBAAA;AJ8/hCF;;AI5/hCA;EACE,gBAAA;AJ+/hCF;;AI7/hCA;EACE,gBAAA;AJggiCF;;AI9/hCA;EACE,gBAAA;AJigiCF;;AI//hCA;EACE,gBAAA;AJkgiCF;;AIhgiCA;EACE,gBAAA;AJmgiCF;;AIjgiCA;EACE,gBAAA;AJogiCF;;AIlgiCA;EACE,gBAAA;AJqgiCF;;AIngiCA;EACE,gBAAA;AJsgiCF;;AIpgiCA;EACE,gBAAA;AJugiCF;;AIrgiCA;EACE,gBAAA;AJwgiCF;;AItgiCA;EACE,gBAAA;AJygiCF;;AIvgiCA;EACE,gBAAA;AJ0giCF;;AIxgiCA;EACE,gBAAA;AJ2giCF;;AIzgiCA;EACE,gBAAA;AJ4giCF;;AI1giCA;EACE,gBAAA;AJ6giCF;;AI3giCA;EACE,gBAAA;AJ8giCF;;AI5giCA;EACE,gBAAA;AJ+giCF;;AI7giCA;EACE,gBAAA;AJghiCF;;AI9giCA;EACE,gBAAA;AJihiCF;;AI/giCA;EACE,gBAAA;AJkhiCF;;AIhhiCA;EACE,gBAAA;AJmhiCF;;AIjhiCA;EACE,gBAAA;AJohiCF;;AIlhiCA;EACE,gBAAA;AJqhiCF;;AInhiCA;EACE,gBAAA;AJshiCF;;AIphiCA;EACE,gBAAA;AJuhiCF;;AIrhiCA;EACE,gBAAA;AJwhiCF;;AIthiCA;EACE,gBAAA;AJyhiCF;;AIvhiCA;EACE,gBAAA;AJ0hiCF;;AIxhiCA;EACE,gBAAA;AJ2hiCF;;AIzhiCA;EACE,gBAAA;AJ4hiCF;;AI1hiCA;EACE,gBAAA;AJ6hiCF;;AI3hiCA;EACE,gBAAA;AJ8hiCF;;AI5hiCA;EACE,gBAAA;AJ+hiCF;;AI7hiCA;EACE,gBAAA;AJgiiCF;;AI9hiCA;EACE,gBAAA;AJiiiCF;;AI/hiCA;EACE,gBAAA;AJkiiCF;;AIhiiCA;EACE,gBAAA;AJmiiCF;;AIjiiCA;EACE,gBAAA;AJoiiCF;;AIliiCA;EACE,gBAAA;AJqiiCF;;AIniiCA;EACE,gBAAA;AJsiiCF;;AIpiiCA;EACE,gBAAA;AJuiiCF;;AIriiCA;EACE,gBAAA;AJwiiCF;;AItiiCA;EACE,gBAAA;AJyiiCF;;AIviiCA;EACE,gBAAA;AJ0iiCF;;AIxiiCA;EACE,gBAAA;AJ2iiCF;;AIziiCA;EACE,gBAAA;AJ4iiCF;;AI1iiCA;EACE,gBAAA;AJ6iiCF;;AI3iiCA;EACE,gBAAA;AJ8iiCF;;AI5iiCA;EACE,gBAAA;AJ+iiCF;;AI7iiCA;EACE,gBAAA;AJgjiCF;;AI9iiCA;EACE,gBAAA;AJijiCF;;AI/iiCA;EACE,gBAAA;AJkjiCF;;AIhjiCA;EACE,gBAAA;AJmjiCF;;AIjjiCA;EACE,gBAAA;AJojiCF;;AIljiCA;EACE,gBAAA;AJqjiCF;;AInjiCA;EACE,gBAAA;AJsjiCF;;AIpjiCA;EACE,gBAAA;AJujiCF;;AIrjiCA;EACE,gBAAA;AJwjiCF;;AItjiCA;EACE,gBAAA;AJyjiCF;;AIvjiCA;EACE,gBAAA;AJ0jiCF;;AIxjiCA;EACE,gBAAA;AJ2jiCF;;AIzjiCA;EACE,gBAAA;AJ4jiCF;;AI1jiCA;EACE,gBAAA;AJ6jiCF;;AI3jiCA;EACE,gBAAA;AJ8jiCF;;AI5jiCA;EACE,gBAAA;AJ+jiCF;;AI7jiCA;EACE,gBAAA;AJgkiCF;;AI9jiCA;EACE,gBAAA;AJikiCF;;AI/jiCA;EACE,gBAAA;AJkkiCF;;AIhkiCA;EACE,gBAAA;AJmkiCF;;AIjkiCA;EACE,gBAAA;AJokiCF;;AIlkiCA;EACE,gBAAA;AJqkiCF;;AInkiCA;EACE,gBAAA;AJskiCF;;AIpkiCA;EACE,gBAAA;AJukiCF;;AIrkiCA;EACE,gBAAA;AJwkiCF;;AItkiCA;EACE,gBAAA;AJykiCF;;AIvkiCA;EACE,gBAAA;AJ0kiCF;;AIxkiCA;EACE,gBAAA;AJ2kiCF;;AIzkiCA;EACE,gBAAA;AJ4kiCF;;AI1kiCA;EACE,gBAAA;AJ6kiCF;;AI3kiCA;EACE,gBAAA;AJ8kiCF;;AI5kiCA;EACE,gBAAA;AJ+kiCF;;AI7kiCA;EACE,gBAAA;AJgliCF;;AI9kiCA;EACE,gBAAA;AJiliCF;;AI/kiCA;EACE,gBAAA;AJkliCF;;AIhliCA;EACE,gBAAA;AJmliCF;;AIjliCA;EACE,gBAAA;AJoliCF;;AIlliCA;EACE,gBAAA;AJqliCF;;AInliCA;EACE,gBAAA;AJsliCF;;AIpliCA;EACE,gBAAA;AJuliCF;;AIrliCA;EACE,gBAAA;AJwliCF;;AItliCA;EACE,gBAAA;AJyliCF;;AIvliCA;EACE,gBAAA;AJ0liCF;;AIxliCA;EACE,gBAAA;AJ2liCF;;AIzliCA;EACE,gBAAA;AJ4liCF;;AI1liCA;EACE,gBAAA;AJ6liCF;;AI3liCA;EACE,gBAAA;AJ8liCF;;AI5liCA;EACE,gBAAA;AJ+liCF;;AI7liCA;EACE,gBAAA;AJgmiCF;;AI9liCA;EACE,gBAAA;AJimiCF;;AI/liCA;EACE,gBAAA;AJkmiCF;;AIhmiCA;EACE,gBAAA;AJmmiCF;;AIjmiCA;EACE,gBAAA;AJomiCF;;AIlmiCA;EACE,gBAAA;AJqmiCF;;AInmiCA;EACE,gBAAA;AJsmiCF;;AIpmiCA;EACE,gBAAA;AJumiCF;;AIrmiCA;EACE,gBAAA;AJwmiCF;;AItmiCA;EACE,gBAAA;AJymiCF;;AIvmiCA;EACE,gBAAA;AJ0miCF;;AIxmiCA;EACE,gBAAA;AJ2miCF;;AIzmiCA;EACE,gBAAA;AJ4miCF;;AI1miCA;EACE,gBAAA;AJ6miCF;;AI3miCA;EACE,gBAAA;AJ8miCF;;AI5miCA;EACE,gBAAA;AJ+miCF;;AI7miCA;EACE,gBAAA;AJgniCF;;AI9miCA;EACE,gBAAA;AJiniCF;;AI/miCA;EACE,gBAAA;AJkniCF;;AIhniCA;EACE,gBAAA;AJmniCF;;AIjniCA;EACE,gBAAA;AJoniCF;;AIlniCA;EACE,gBAAA;AJqniCF;;AInniCA;EACE,gBAAA;AJsniCF;;AIpniCA;EACE,gBAAA;AJuniCF;;AIrniCA;EACE,gBAAA;AJwniCF;;AItniCA;EACE,gBAAA;AJyniCF;;AIvniCA;EACE,gBAAA;AJ0niCF;;AIxniCA;EACE,gBAAA;AJ2niCF;;AIzniCA;EACE,gBAAA;AJ4niCF;;AI1niCA;EACE,gBAAA;AJ6niCF;;AI3niCA;EACE,gBAAA;AJ8niCF;;AI5niCA;EACE,gBAAA;AJ+niCF;;AI7niCA;EACE,gBAAA;AJgoiCF;;AI9niCA;EACE,gBAAA;AJioiCF;;AI/niCA;EACE,gBAAA;AJkoiCF;;AIhoiCA;EACE,gBAAA;AJmoiCF;;AIjoiCA;EACE,gBAAA;AJooiCF;;AIloiCA;EACE,gBAAA;AJqoiCF;;AInoiCA;EACE,gBAAA;AJsoiCF;;AIpoiCA;EACE,gBAAA;AJuoiCF;;AIroiCA;EACE,gBAAA;AJwoiCF;;AItoiCA;EACE,gBAAA;AJyoiCF;;AIvoiCA;EACE,gBAAA;AJ0oiCF;;AIxoiCA;EACE,gBAAA;AJ2oiCF;;AIzoiCA;EACE,gBAAA;AJ4oiCF;;AI1oiCA;EACE,gBAAA;AJ6oiCF;;AI3oiCA;EACE,gBAAA;AJ8oiCF;;AI5oiCA;EACE,gBAAA;AJ+oiCF;;AI7oiCA;EACE,gBAAA;AJgpiCF;;AI9oiCA;EACE,gBAAA;AJipiCF;;AI/oiCA;EACE,gBAAA;AJkpiCF;;AIhpiCA;EACE,gBAAA;AJmpiCF;;AIjpiCA;EACE,gBAAA;AJopiCF;;AIlpiCA;EACE,gBAAA;AJqpiCF;;AInpiCA;EACE,gBAAA;AJspiCF;;AIppiCA;EACE,gBAAA;AJupiCF;;AIrpiCA;EACE,gBAAA;AJwpiCF;;AItpiCA;EACE,gBAAA;AJypiCF;;AIvpiCA;EACE,gBAAA;AJ0piCF;;AIxpiCA;EACE,gBAAA;AJ2piCF;;AIzpiCA;EACE,gBAAA;AJ4piCF;;AI1piCA;EACE,gBAAA;AJ6piCF;;AI3piCA;EACE,gBAAA;AJ8piCF;;AI5piCA;EACE,gBAAA;AJ+piCF;;AI7piCA;EACE,gBAAA;AJgqiCF;;AI9piCA;EACE,gBAAA;AJiqiCF;;AI/piCA;EACE,gBAAA;AJkqiCF;;AIhqiCA;EACE,gBAAA;AJmqiCF;;AIjqiCA;EACE,gBAAA;AJoqiCF;;AIlqiCA;EACE,gBAAA;AJqqiCF;;AInqiCA;EACE,gBAAA;AJsqiCF;;AIpqiCA;EACE,gBAAA;AJuqiCF;;AIrqiCA;EACE,gBAAA;AJwqiCF;;AItqiCA;EACE,gBAAA;AJyqiCF;;AIvqiCA;EACE,gBAAA;AJ0qiCF;;AIxqiCA;EACE,gBAAA;AJ2qiCF;;AIzqiCA;EACE,gBAAA;AJ4qiCF;;AI1qiCA;EACE,gBAAA;AJ6qiCF;;AI3qiCA;EACE,gBAAA;AJ8qiCF;;AI5qiCA;EACE,gBAAA;AJ+qiCF;;AI7qiCA;EACE,gBAAA;AJgriCF;;AI9qiCA;EACE,gBAAA;AJiriCF;;AI/qiCA;EACE,gBAAA;AJkriCF;;AIhriCA;EACE,gBAAA;AJmriCF;;AIjriCA;EACE,gBAAA;AJoriCF;;AIlriCA;EACE,gBAAA;AJqriCF;;AInriCA;EACE,gBAAA;AJsriCF;;AIpriCA;EACE,gBAAA;AJuriCF;;AIrriCA;EACE,gBAAA;AJwriCF;;AItriCA;EACE,gBAAA;AJyriCF;;AIvriCA;EACE,gBAAA;AJ0riCF;;AIxriCA;EACE,gBAAA;AJ2riCF;;AIzriCA;EACE,gBAAA;AJ4riCF;;AI1riCA;EACE,gBAAA;AJ6riCF;;AI3riCA;EACE,gBAAA;AJ8riCF;;AI5riCA;EACE,gBAAA;AJ+riCF;;AI7riCA;EACE,gBAAA;AJgsiCF;;AI9riCA;EACE,gBAAA;AJisiCF;;AI/riCA;EACE,gBAAA;AJksiCF;;AIhsiCA;EACE,gBAAA;AJmsiCF;;AIjsiCA;EACE,gBAAA;AJosiCF;;AIlsiCA;EACE,gBAAA;AJqsiCF;;AInsiCA;EACE,gBAAA;AJssiCF;;AIpsiCA;EACE,gBAAA;AJusiCF;;AIrsiCA;EACE,gBAAA;AJwsiCF;;AItsiCA;EACE,gBAAA;AJysiCF;;AIvsiCA;EACE,gBAAA;AJ0siCF;;AIxsiCA;EACE,gBAAA;AJ2siCF;;AIzsiCA;EACE,gBAAA;AJ4siCF;;AI1siCA;EACE,gBAAA;AJ6siCF;;AI3siCA;EACE,gBAAA;AJ8siCF;;AI5siCA;EACE,gBAAA;AJ+siCF;;AI7siCA;EACE,gBAAA;AJgtiCF;;AI9siCA;EACE,gBAAA;AJitiCF;;AI/siCA;EACE,gBAAA;AJktiCF;;AIhtiCA;EACE,gBAAA;AJmtiCF;;AIjtiCA;EACE,gBAAA;AJotiCF;;AIltiCA;EACE,gBAAA;AJqtiCF;;AIntiCA;EACE,gBAAA;AJstiCF;;AIptiCA;EACE,gBAAA;AJutiCF;;AIrtiCA;EACE,gBAAA;AJwtiCF;;AIttiCA;EACE,gBAAA;AJytiCF;;AIvtiCA;EACE,gBAAA;AJ0tiCF;;AIxtiCA;EACE,gBAAA;AJ2tiCF;;AIztiCA;EACE,gBAAA;AJ4tiCF;;AI1tiCA;EACE,gBAAA;AJ6tiCF;;AI3tiCA;EACE,gBAAA;AJ8tiCF;;AI5tiCA;EACE,gBAAA;AJ+tiCF;;AI7tiCA;EACE,gBAAA;AJguiCF;;AI9tiCA;EACE,gBAAA;AJiuiCF;;AI/tiCA;EACE,gBAAA;AJkuiCF;;AIhuiCA;EACE,gBAAA;AJmuiCF;;AIjuiCA;EACE,gBAAA;AJouiCF;;AIluiCA;EACE,gBAAA;AJquiCF;;AInuiCA;EACE,gBAAA;AJsuiCF;;AIpuiCA;EACE,gBAAA;AJuuiCF;;AIruiCA;EACE,gBAAA;AJwuiCF;;AItuiCA;EACE,gBAAA;AJyuiCF;;AIvuiCA;EACE,gBAAA;AJ0uiCF;;AIxuiCA;EACE,gBAAA;AJ2uiCF;;AIzuiCA;EACE,gBAAA;AJ4uiCF;;AI1uiCA;EACE,gBAAA;AJ6uiCF;;AI3uiCA;EACE,gBAAA;AJ8uiCF;;AI5uiCA;EACE,gBAAA;AJ+uiCF;;AI7uiCA;EACE,gBAAA;AJgviCF;;AI9uiCA;EACE,gBAAA;AJiviCF;;AI/uiCA;EACE,gBAAA;AJkviCF;;AIhviCA;EACE,gBAAA;AJmviCF;;AIjviCA;EACE,gBAAA;AJoviCF;;AIlviCA;EACE,gBAAA;AJqviCF;;AInviCA;EACE,gBAAA;AJsviCF;;AIpviCA;EACE,gBAAA;AJuviCF;;AIrviCA;EACE,gBAAA;AJwviCF;;AItviCA;EACE,gBAAA;AJyviCF;;AIvviCA;EACE,gBAAA;AJ0viCF;;AIxviCA;EACE,gBAAA;AJ2viCF;;AIzviCA;EACE,gBAAA;AJ4viCF;;AI1viCA;EACE,gBAAA;AJ6viCF;;AI3viCA;EACE,gBAAA;AJ8viCF;;AI5viCA;EACE,gBAAA;AJ+viCF;;AI7viCA;EACE,gBAAA;AJgwiCF;;AI9viCA;EACE,gBAAA;AJiwiCF;;AI/viCA;EACE,gBAAA;AJkwiCF;;AIhwiCA;EACE,gBAAA;AJmwiCF;;AIjwiCA;EACE,gBAAA;AJowiCF;;AIlwiCA;EACE,gBAAA;AJqwiCF;;AInwiCA;EACE,gBAAA;AJswiCF;;AIpwiCA;EACE,gBAAA;AJuwiCF;;AIrwiCA;EACE,gBAAA;AJwwiCF;;AItwiCA;EACE,gBAAA;AJywiCF;;AIvwiCA;EACE,gBAAA;AJ0wiCF;;AIxwiCA;EACE,gBAAA;AJ2wiCF;;AIzwiCA;EACE,gBAAA;AJ4wiCF;;AI1wiCA;EACE,gBAAA;AJ6wiCF;;AI3wiCA;EACE,gBAAA;AJ8wiCF;;AI5wiCA;EACE,gBAAA;AJ+wiCF;;AI7wiCA;EACE,gBAAA;AJgxiCF;;AI9wiCA;EACE,gBAAA;AJixiCF;;AI/wiCA;EACE,gBAAA;AJkxiCF;;AIhxiCA;EACE,gBAAA;AJmxiCF;;AIjxiCA;EACE,gBAAA;AJoxiCF;;AIlxiCA;EACE,gBAAA;AJqxiCF;;AInxiCA;EACE,gBAAA;AJsxiCF;;AIpxiCA;EACE,gBAAA;AJuxiCF;;AIrxiCA;EACE,gBAAA;AJwxiCF;;AItxiCA;EACE,gBAAA;AJyxiCF;;AIvxiCA;EACE,gBAAA;AJ0xiCF;;AIxxiCA;EACE,gBAAA;AJ2xiCF;;AIzxiCA;EACE,gBAAA;AJ4xiCF;;AI1xiCA;EACE,gBAAA;AJ6xiCF;;AI3xiCA;EACE,gBAAA;AJ8xiCF;;AI5xiCA;EACE,gBAAA;AJ+xiCF;;AI7xiCA;EACE,gBAAA;AJgyiCF;;AI9xiCA;EACE,gBAAA;AJiyiCF;;AI/xiCA;EACE,gBAAA;AJkyiCF;;AIhyiCA;EACE,gBAAA;AJmyiCF;;AIjyiCA;EACE,gBAAA;AJoyiCF;;AIlyiCA;EACE,gBAAA;AJqyiCF;;AInyiCA;EACE,gBAAA;AJsyiCF;;AIpyiCA;EACE,gBAAA;AJuyiCF;;AIryiCA;EACE,gBAAA;AJwyiCF;;AItyiCA;EACE,gBAAA;AJyyiCF;;AIvyiCA;EACE,gBAAA;AJ0yiCF;;AIxyiCA;EACE,gBAAA;AJ2yiCF;;AIzyiCA;EACE,gBAAA;AJ4yiCF;;AI1yiCA;EACE,gBAAA;AJ6yiCF;;AI3yiCA;EACE,gBAAA;AJ8yiCF;;AI5yiCA;EACE,gBAAA;AJ+yiCF;;AI7yiCA;EACE,gBAAA;AJgziCF;;AI9yiCA;EACE,gBAAA;AJiziCF;;AI/yiCA;EACE,gBAAA;AJkziCF;;AIhziCA;EACE,gBAAA;AJmziCF;;AIjziCA;EACE,gBAAA;AJoziCF;;AIlziCA;EACE,gBAAA;AJqziCF;;AInziCA;EACE,gBAAA;AJsziCF;;AIpziCA;EACE,gBAAA;AJuziCF;;AIrziCA;EACE,gBAAA;AJwziCF;;AItziCA;EACE,gBAAA;AJyziCF;;AIvziCA;EACE,gBAAA;AJ0ziCF;;AIxziCA;EACE,gBAAA;AJ2ziCF;;AIzziCA;EACE,gBAAA;AJ4ziCF;;AI1ziCA;EACE,gBAAA;AJ6ziCF;;AI3ziCA;EACE,gBAAA;AJ8ziCF;;AI5ziCA;EACE,gBAAA;AJ+ziCF;;AI7ziCA;EACE,gBAAA;AJg0iCF;;AI9ziCA;EACE,gBAAA;AJi0iCF;;AI/ziCA;EACE,gBAAA;AJk0iCF;;AIh0iCA;EACE,gBAAA;AJm0iCF;;AIj0iCA;EACE,gBAAA;AJo0iCF;;AIl0iCA;EACE,gBAAA;AJq0iCF;;AIn0iCA;EACE,gBAAA;AJs0iCF;;AIp0iCA;EACE,gBAAA;AJu0iCF;;AIr0iCA;EACE,gBAAA;AJw0iCF;;AIt0iCA;EACE,gBAAA;AJy0iCF;;AIv0iCA;EACE,gBAAA;AJ00iCF;;AIx0iCA;EACE,gBAAA;AJ20iCF;;AIz0iCA;EACE,gBAAA;AJ40iCF;;AI10iCA;EACE,gBAAA;AJ60iCF;;AI30iCA;EACE,gBAAA;AJ80iCF;;AI50iCA;EACE,gBAAA;AJ+0iCF;;AI70iCA;EACE,gBAAA;AJg1iCF;;AI90iCA;EACE,gBAAA;AJi1iCF;;AI/0iCA;EACE,gBAAA;AJk1iCF;;AIh1iCA;EACE,gBAAA;AJm1iCF;;AIj1iCA;EACE,gBAAA;AJo1iCF;;AIl1iCA;EACE,gBAAA;AJq1iCF;;AIn1iCA;EACE,gBAAA;AJs1iCF;;AIp1iCA;EACE,gBAAA;AJu1iCF;;AIr1iCA;EACE,gBAAA;AJw1iCF;;AIt1iCA;EACE,gBAAA;AJy1iCF;;AIv1iCA;EACE,gBAAA;AJ01iCF;;AIx1iCA;EACE,gBAAA;AJ21iCF;;AIz1iCA;EACE,gBAAA;AJ41iCF;;AI11iCA;EACE,gBAAA;AJ61iCF;;AI31iCA;EACE,gBAAA;AJ81iCF;;AI51iCA;EACE,gBAAA;AJ+1iCF;;AI71iCA;EACE,gBAAA;AJg2iCF;;AI91iCA;EACE,gBAAA;AJi2iCF;;AI/1iCA;EACE,gBAAA;AJk2iCF;;AIh2iCA;EACE,gBAAA;AJm2iCF;;AIj2iCA;EACE,gBAAA;AJo2iCF;;AIl2iCA;EACE,gBAAA;AJq2iCF;;AIn2iCA;EACE,gBAAA;AJs2iCF;;AIp2iCA;EACE,gBAAA;AJu2iCF;;AIr2iCA;EACE,gBAAA;AJw2iCF;;AIt2iCA;EACE,gBAAA;AJy2iCF;;AIv2iCA;EACE,gBAAA;AJ02iCF;;AIx2iCA;EACE,gBAAA;AJ22iCF;;AIz2iCA;EACE,gBAAA;AJ42iCF;;AI12iCA;EACE,gBAAA;AJ62iCF;;AI32iCA;EACE,gBAAA;AJ82iCF;;AI52iCA;EACE,gBAAA;AJ+2iCF;;AI72iCA;EACE,gBAAA;AJg3iCF;;AI92iCA;EACE,gBAAA;AJi3iCF;;AI/2iCA;EACE,gBAAA;AJk3iCF;;AIh3iCA;EACE,gBAAA;AJm3iCF;;AIj3iCA;EACE,gBAAA;AJo3iCF;;AIl3iCA;EACE,gBAAA;AJq3iCF;;AIn3iCA;EACE,gBAAA;AJs3iCF;;AIp3iCA;EACE,gBAAA;AJu3iCF;;AIr3iCA;EACE,gBAAA;AJw3iCF;;AIt3iCA;EACE,gBAAA;AJy3iCF;;AIv3iCA;EACE,gBAAA;AJ03iCF;;AIx3iCA;EACE,gBAAA;AJ23iCF;;AIz3iCA;EACE,gBAAA;AJ43iCF;;AI13iCA;EACE,gBAAA;AJ63iCF;;AI33iCA;EACE,gBAAA;AJ83iCF;;AI53iCA;EACE,gBAAA;AJ+3iCF;;AI73iCA;EACE,gBAAA;AJg4iCF;;AI93iCA;EACE,gBAAA;AJi4iCF;;AI/3iCA;EACE,gBAAA;AJk4iCF;;AIh4iCA;EACE,gBAAA;AJm4iCF;;AIj4iCA;EACE,gBAAA;AJo4iCF;;AIl4iCA;EACE,gBAAA;AJq4iCF;;AIn4iCA;EACE,gBAAA;AJs4iCF;;AIp4iCA;EACE,gBAAA;AJu4iCF;;AIr4iCA;EACE,gBAAA;AJw4iCF;;AIt4iCA;EACE,gBAAA;AJy4iCF;;AIv4iCA;EACE,gBAAA;AJ04iCF;;AIx4iCA;EACE,gBAAA;AJ24iCF;;AIz4iCA;EACE,gBAAA;AJ44iCF;;AI14iCA;EACE,gBAAA;AJ64iCF;;AI34iCA;EACE,gBAAA;AJ84iCF;;AI54iCA;EACE,gBAAA;AJ+4iCF;;AI74iCA;EACE,gBAAA;AJg5iCF;;AI94iCA;EACE,gBAAA;AJi5iCF;;AI/4iCA;EACE,gBAAA;AJk5iCF;;AIh5iCA;EACE,gBAAA;AJm5iCF;;AIj5iCA;EACE,gBAAA;AJo5iCF;;AIl5iCA;EACE,gBAAA;AJq5iCF;;AIn5iCA;EACE,gBAAA;AJs5iCF;;AIp5iCA;EACE,gBAAA;AJu5iCF;;AIr5iCA;EACE,gBAAA;AJw5iCF;;AIt5iCA;EACE,gBAAA;AJy5iCF;;AIv5iCA;EACE,gBAAA;AJ05iCF;;AIx5iCA;EACE,gBAAA;AJ25iCF;;AIz5iCA;EACE,gBAAA;AJ45iCF;;AI15iCA;EACE,gBAAA;AJ65iCF;;AI35iCA;EACE,gBAAA;AJ85iCF;;AI55iCA;EACE,gBAAA;AJ+5iCF;;AI75iCA;EACE,gBAAA;AJg6iCF;;AI95iCA;EACE,gBAAA;AJi6iCF;;AI/5iCA;EACE,gBAAA;AJk6iCF;;AIh6iCA;EACE,gBAAA;AJm6iCF;;AIj6iCA;EACE,gBAAA;AJo6iCF;;AIl6iCA;EACE,gBAAA;AJq6iCF;;AIn6iCA;EACE,gBAAA;AJs6iCF;;AIp6iCA;EACE,gBAAA;AJu6iCF;;AIr6iCA;EACE,gBAAA;AJw6iCF;;AIt6iCA;EACE,gBAAA;AJy6iCF;;AIv6iCA;EACE,gBAAA;AJ06iCF;;AIx6iCA;EACE,gBAAA;AJ26iCF;;AIz6iCA;EACE,gBAAA;AJ46iCF;;AI16iCA;EACE,gBAAA;AJ66iCF;;AI36iCA;EACE,gBAAA;AJ86iCF;;AI56iCA;EACE,gBAAA;AJ+6iCF;;AI76iCA;EACE,gBAAA;AJg7iCF;;AI96iCA;EACE,gBAAA;AJi7iCF;;AI/6iCA;EACE,gBAAA;AJk7iCF;;AIh7iCA;EACE,gBAAA;AJm7iCF;;AIj7iCA;EACE,gBAAA;AJo7iCF;;AIl7iCA;EACE,gBAAA;AJq7iCF;;AIn7iCA;EACE,gBAAA;AJs7iCF;;AIp7iCA;EACE,gBAAA;AJu7iCF;;AIr7iCA;EACE,gBAAA;AJw7iCF;;AIt7iCA;EACE,gBAAA;AJy7iCF;;AIv7iCA;EACE,gBAAA;AJ07iCF;;AIx7iCA;EACE,gBAAA;AJ27iCF;;AIz7iCA;EACE,gBAAA;AJ47iCF;;AI17iCA;EACE,gBAAA;AJ67iCF;;AI37iCA;EACE,gBAAA;AJ87iCF;;AI57iCA;EACE,gBAAA;AJ+7iCF;;AI77iCA;EACE,gBAAA;AJg8iCF;;AI97iCA;EACE,gBAAA;AJi8iCF;;AI/7iCA;EACE,gBAAA;AJk8iCF;;AIh8iCA;EACE,gBAAA;AJm8iCF;;AIj8iCA;EACE,gBAAA;AJo8iCF;;AIl8iCA;EACE,gBAAA;AJq8iCF;;AIn8iCA;EACE,gBAAA;AJs8iCF;;AIp8iCA;EACE,gBAAA;AJu8iCF;;AIr8iCA;EACE,gBAAA;AJw8iCF;;AIt8iCA;EACE,gBAAA;AJy8iCF;;AIv8iCA;EACE,gBAAA;AJ08iCF;;AIx8iCA;EACE,gBAAA;AJ28iCF;;AIz8iCA;EACE,gBAAA;AJ48iCF;;AI18iCA;EACE,gBAAA;AJ68iCF;;AI38iCA;EACE,gBAAA;AJ88iCF;;AI58iCA;EACE,gBAAA;AJ+8iCF;;AI78iCA;EACE,gBAAA;AJg9iCF;;AI98iCA;EACE,gBAAA;AJi9iCF;;AI/8iCA;EACE,gBAAA;AJk9iCF;;AIh9iCA;EACE,gBAAA;AJm9iCF;;AIj9iCA;EACE,gBAAA;AJo9iCF;;AIl9iCA;EACE,gBAAA;AJq9iCF;;AIn9iCA;EACE,gBAAA;AJs9iCF;;AIp9iCA;EACE,gBAAA;AJu9iCF;;AIr9iCA;EACE,gBAAA;AJw9iCF;;AIt9iCA;EACE,gBAAA;AJy9iCF;;AIv9iCA;EACE,gBAAA;AJ09iCF;;AIx9iCA;EACE,gBAAA;AJ29iCF;;AIz9iCA;EACE,gBAAA;AJ49iCF;;AI19iCA;EACE,gBAAA;AJ69iCF;;AI39iCA;EACE,gBAAA;AJ89iCF;;AI59iCA;EACE,gBAAA;AJ+9iCF;;AI79iCA;EACE,gBAAA;AJg+iCF;;AI99iCA;EACE,gBAAA;AJi+iCF;;AI/9iCA;EACE,gBAAA;AJk+iCF;;AIh+iCA;EACE,gBAAA;AJm+iCF;;AIj+iCA;EACE,gBAAA;AJo+iCF;;AIl+iCA;EACE,gBAAA;AJq+iCF;;AIn+iCA;EACE,gBAAA;AJs+iCF;;AIp+iCA;EACE,gBAAA;AJu+iCF;;AIr+iCA;EACE,gBAAA;AJw+iCF;;AIt+iCA;EACE,gBAAA;AJy+iCF;;AIv+iCA;EACE,gBAAA;AJ0+iCF;;AIx+iCA;EACE,gBAAA;AJ2+iCF;;AIz+iCA;EACE,gBAAA;AJ4+iCF;;AI1+iCA;EACE,gBAAA;AJ6+iCF;;AI3+iCA;EACE,gBAAA;AJ8+iCF;;AI5+iCA;EACE,gBAAA;AJ++iCF;;AI7+iCA;EACE,gBAAA;AJg/iCF;;AI9+iCA;EACE,gBAAA;AJi/iCF;;AI/+iCA;EACE,gBAAA;AJk/iCF;;AIh/iCA;EACE,gBAAA;AJm/iCF;;AIj/iCA;EACE,gBAAA;AJo/iCF;;AIl/iCA;EACE,gBAAA;AJq/iCF;;AIn/iCA;EACE,gBAAA;AJs/iCF;;AIp/iCA;EACE,gBAAA;AJu/iCF;;AIr/iCA;EACE,gBAAA;AJw/iCF;;AIt/iCA;EACE,gBAAA;AJy/iCF;;AIv/iCA;EACE,gBAAA;AJ0/iCF;;AIx/iCA;EACE,gBAAA;AJ2/iCF;;AIz/iCA;EACE,gBAAA;AJ4/iCF;;AI1/iCA;EACE,gBAAA;AJ6/iCF;;AI3/iCA;EACE,gBAAA;AJ8/iCF;;AI5/iCA;EACE,gBAAA;AJ+/iCF;;AI7/iCA;EACE,gBAAA;AJggjCF;;AI9/iCA;EACE,gBAAA;AJigjCF;;AI//iCA;EACE,gBAAA;AJkgjCF;;AIhgjCA;EACE,gBAAA;AJmgjCF;;AIjgjCA;EACE,gBAAA;AJogjCF;;AIlgjCA;EACE,gBAAA;AJqgjCF;;AIngjCA;EACE,gBAAA;AJsgjCF;;AIpgjCA;EACE,gBAAA;AJugjCF;;AIrgjCA;EACE,gBAAA;AJwgjCF;;AItgjCA;EACE,gBAAA;AJygjCF;;AIvgjCA;EACE,gBAAA;AJ0gjCF;;AIxgjCA;EACE,gBAAA;AJ2gjCF;;AIzgjCA;EACE,gBAAA;AJ4gjCF;;AI1gjCA;EACE,gBAAA;AJ6gjCF;;AI3gjCA;EACE,gBAAA;AJ8gjCF;;AI5gjCA;EACE,gBAAA;AJ+gjCF;;AI7gjCA;EACE,gBAAA;AJghjCF;;AI9gjCA;EACE,gBAAA;AJihjCF;;AI/gjCA;EACE,gBAAA;AJkhjCF;;AIhhjCA;EACE,gBAAA;AJmhjCF;;AIjhjCA;EACE,gBAAA;AJohjCF;;AIlhjCA;EACE,gBAAA;AJqhjCF;;AInhjCA;EACE,gBAAA;AJshjCF;;AIphjCA;EACE,gBAAA;AJuhjCF;;AIrhjCA;EACE,gBAAA;AJwhjCF;;AIthjCA;EACE,gBAAA;AJyhjCF;;AIvhjCA;EACE,gBAAA;AJ0hjCF;;AIxhjCA;EACE,gBAAA;AJ2hjCF;;AIzhjCA;EACE,gBAAA;AJ4hjCF;;AI1hjCA;EACE,gBAAA;AJ6hjCF;;AI3hjCA;EACE,gBAAA;AJ8hjCF;;AI5hjCA;EACE,gBAAA;AJ+hjCF;;AI7hjCA;EACE,gBAAA;AJgijCF;;AI9hjCA;EACE,gBAAA;AJiijCF;;AI/hjCA;EACE,gBAAA;AJkijCF;;AIhijCA;EACE,gBAAA;AJmijCF;;AIjijCA;EACE,gBAAA;AJoijCF;;AIlijCA;EACE,gBAAA;AJqijCF;;AInijCA;EACE,gBAAA;AJsijCF;;AIpijCA;EACE,gBAAA;AJuijCF;;AIrijCA;EACE,gBAAA;AJwijCF;;AItijCA;EACE,gBAAA;AJyijCF;;AIvijCA;EACE,gBAAA;AJ0ijCF;;AIxijCA;EACE,gBAAA;AJ2ijCF;;AIzijCA;EACE,gBAAA;AJ4ijCF;;AI1ijCA;EACE,gBAAA;AJ6ijCF;;AI3ijCA;EACE,gBAAA;AJ8ijCF;;AI5ijCA;EACE,gBAAA;AJ+ijCF;;AI7ijCA;EACE,gBAAA;AJgjjCF;;AI9ijCA;EACE,gBAAA;AJijjCF;;AI/ijCA;EACE,gBAAA;AJkjjCF;;AIhjjCA;EACE,gBAAA;AJmjjCF;;AIjjjCA;EACE,gBAAA;AJojjCF;;AIljjCA;EACE,gBAAA;AJqjjCF;;AInjjCA;EACE,gBAAA;AJsjjCF;;AIpjjCA;EACE,gBAAA;AJujjCF;;AIrjjCA;EACE,gBAAA;AJwjjCF;;AItjjCA;EACE,gBAAA;AJyjjCF;;AIvjjCA;EACE,gBAAA;AJ0jjCF;;AIxjjCA;EACE,gBAAA;AJ2jjCF;;AIzjjCA;EACE,gBAAA;AJ4jjCF;;AI1jjCA;EACE,gBAAA;AJ6jjCF;;AI3jjCA;EACE,gBAAA;AJ8jjCF;;AI5jjCA;EACE,gBAAA;AJ+jjCF;;AI7jjCA;EACE,gBAAA;AJgkjCF;;AI9jjCA;EACE,gBAAA;AJikjCF;;AI/jjCA;EACE,gBAAA;AJkkjCF;;AIhkjCA;EACE,gBAAA;AJmkjCF;;AIjkjCA;EACE,gBAAA;AJokjCF;;AIlkjCA;EACE,gBAAA;AJqkjCF;;AInkjCA;EACE,gBAAA;AJskjCF;;AIpkjCA;EACE,gBAAA;AJukjCF;;AIrkjCA;EACE,gBAAA;AJwkjCF;;AItkjCA;EACE,gBAAA;AJykjCF;;AIvkjCA;EACE,gBAAA;AJ0kjCF;;AIxkjCA;EACE,gBAAA;AJ2kjCF;;AIzkjCA;EACE,gBAAA;AJ4kjCF;;AI1kjCA;EACE,gBAAA;AJ6kjCF;;AI3kjCA;EACE,gBAAA;AJ8kjCF;;AI5kjCA;EACE,gBAAA;AJ+kjCF;;AI7kjCA;EACE,gBAAA;AJgljCF;;AI9kjCA;EACE,gBAAA;AJiljCF;;AI/kjCA;EACE,gBAAA;AJkljCF;;AIhljCA;EACE,gBAAA;AJmljCF;;AIjljCA;EACE,gBAAA;AJoljCF;;AIlljCA;EACE,gBAAA;AJqljCF;;AInljCA;EACE,gBAAA;AJsljCF;;AIpljCA;EACE,gBAAA;AJuljCF;;AIrljCA;EACE,gBAAA;AJwljCF;;AItljCA;EACE,gBAAA;AJyljCF;;AIvljCA;EACE,gBAAA;AJ0ljCF;;AIxljCA;EACE,gBAAA;AJ2ljCF;;AIzljCA;EACE,gBAAA;AJ4ljCF;;AI1ljCA;EACE,gBAAA;AJ6ljCF;;AI3ljCA;EACE,gBAAA;AJ8ljCF;;AI5ljCA;EACE,gBAAA;AJ+ljCF;;AI7ljCA;EACE,gBAAA;AJgmjCF;;AI9ljCA;EACE,gBAAA;AJimjCF;;AI/ljCA;EACE,gBAAA;AJkmjCF;;AIhmjCA;EACE,gBAAA;AJmmjCF;;AIjmjCA;EACE,gBAAA;AJomjCF;;AIlmjCA;EACE,gBAAA;AJqmjCF;;AInmjCA;EACE,gBAAA;AJsmjCF;;AIpmjCA;EACE,gBAAA;AJumjCF;;AIrmjCA;EACE,gBAAA;AJwmjCF;;AItmjCA;EACE,gBAAA;AJymjCF;;AIvmjCA;EACE,gBAAA;AJ0mjCF;;AIxmjCA;EACE,gBAAA;AJ2mjCF;;AIzmjCA;EACE,gBAAA;AJ4mjCF;;AI1mjCA;EACE,gBAAA;AJ6mjCF;;AI3mjCA;EACE,gBAAA;AJ8mjCF;;AI5mjCA;EACE,gBAAA;AJ+mjCF;;AI7mjCA;EACE,gBAAA;AJgnjCF;;AI9mjCA;EACE,gBAAA;AJinjCF;;AI/mjCA;EACE,gBAAA;AJknjCF;;AIhnjCA;EACE,gBAAA;AJmnjCF;;AIjnjCA;EACE,gBAAA;AJonjCF;;AIlnjCA;EACE,gBAAA;AJqnjCF;;AInnjCA;EACE,gBAAA;AJsnjCF;;AIpnjCA;EACE,gBAAA;AJunjCF;;AIrnjCA;EACE,gBAAA;AJwnjCF;;AItnjCA;EACE,gBAAA;AJynjCF;;AIvnjCA;EACE,gBAAA;AJ0njCF;;AIxnjCA;EACE,gBAAA;AJ2njCF;;AIznjCA;EACE,gBAAA;AJ4njCF;;AI1njCA;EACE,gBAAA;AJ6njCF;;AI3njCA;EACE,gBAAA;AJ8njCF;;AI5njCA;EACE,gBAAA;AJ+njCF;;AI7njCA;EACE,gBAAA;AJgojCF;;AI9njCA;EACE,gBAAA;AJiojCF;;AI/njCA;EACE,gBAAA;AJkojCF;;AIhojCA;EACE,gBAAA;AJmojCF;;AIjojCA;EACE,gBAAA;AJoojCF;;AIlojCA;EACE,gBAAA;AJqojCF;;AInojCA;EACE,gBAAA;AJsojCF;;AIpojCA;EACE,gBAAA;AJuojCF;;AIrojCA;EACE,gBAAA;AJwojCF;;AItojCA;EACE,gBAAA;AJyojCF;;AIvojCA;EACE,gBAAA;AJ0ojCF;;AIxojCA;EACE,gBAAA;AJ2ojCF;;AIzojCA;EACE,gBAAA;AJ4ojCF;;AI1ojCA;EACE,gBAAA;AJ6ojCF;;AI3ojCA;EACE,gBAAA;AJ8ojCF;;AI5ojCA;EACE,gBAAA;AJ+ojCF;;AI7ojCA;EACE,gBAAA;AJgpjCF;;AI9ojCA;EACE,gBAAA;AJipjCF;;AI/ojCA;EACE,gBAAA;AJkpjCF;;AIhpjCA;EACE,gBAAA;AJmpjCF;;AIjpjCA;EACE,gBAAA;AJopjCF;;AIlpjCA;EACE,gBAAA;AJqpjCF;;AInpjCA;EACE,gBAAA;AJspjCF;;AIppjCA;EACE,gBAAA;AJupjCF;;AIrpjCA;EACE,gBAAA;AJwpjCF;;AItpjCA;EACE,gBAAA;AJypjCF;;AIvpjCA;EACE,gBAAA;AJ0pjCF;;AIxpjCA;EACE,gBAAA;AJ2pjCF;;AIzpjCA;EACE,gBAAA;AJ4pjCF;;AI1pjCA;EACE,gBAAA;AJ6pjCF;;AI3pjCA;EACE,gBAAA;AJ8pjCF;;AI5pjCA;EACE,gBAAA;AJ+pjCF;;AI7pjCA;EACE,gBAAA;AJgqjCF;;AI9pjCA;EACE,gBAAA;AJiqjCF;;AI/pjCA;EACE,gBAAA;AJkqjCF;;AIhqjCA;EACE,gBAAA;AJmqjCF;;AIjqjCA;EACE,gBAAA;AJoqjCF;;AIlqjCA;EACE,gBAAA;AJqqjCF;;AInqjCA;EACE,gBAAA;AJsqjCF;;AIpqjCA;EACE,gBAAA;AJuqjCF;;AIrqjCA;EACE,gBAAA;AJwqjCF;;AItqjCA;EACE,gBAAA;AJyqjCF;;AIvqjCA;EACE,gBAAA;AJ0qjCF;;AIxqjCA;EACE,gBAAA;AJ2qjCF;;AIzqjCA;EACE,gBAAA;AJ4qjCF;;AI1qjCA;EACE,gBAAA;AJ6qjCF;;AI3qjCA;EACE,gBAAA;AJ8qjCF;;AI5qjCA;EACE,gBAAA;AJ+qjCF;;AI7qjCA;EACE,gBAAA;AJgrjCF;;AI9qjCA;EACE,gBAAA;AJirjCF;;AI/qjCA;EACE,gBAAA;AJkrjCF;;AIhrjCA;EACE,gBAAA;AJmrjCF;;AIjrjCA;EACE,gBAAA;AJorjCF;;AIlrjCA;EACE,gBAAA;AJqrjCF;;AInrjCA;EACE,gBAAA;AJsrjCF;;AIprjCA;EACE,gBAAA;AJurjCF;;AIrrjCA;EACE,gBAAA;AJwrjCF;;AItrjCA;EACE,gBAAA;AJyrjCF;;AIvrjCA;EACE,gBAAA;AJ0rjCF;;AIxrjCA;EACE,gBAAA;AJ2rjCF;;AIzrjCA;EACE,gBAAA;AJ4rjCF;;AI1rjCA;EACE,gBAAA;AJ6rjCF;;AI3rjCA;EACE,gBAAA;AJ8rjCF;;AI5rjCA;EACE,gBAAA;AJ+rjCF;;AI7rjCA;EACE,gBAAA;AJgsjCF;;AI9rjCA;EACE,gBAAA;AJisjCF;;AI/rjCA;EACE,gBAAA;AJksjCF;;AIhsjCA;EACE,gBAAA;AJmsjCF;;AIjsjCA;EACE,gBAAA;AJosjCF;;AIlsjCA;EACE,gBAAA;AJqsjCF;;AInsjCA;EACE,gBAAA;AJssjCF;;AIpsjCA;EACE,gBAAA;AJusjCF;;AIrsjCA;EACE,gBAAA;AJwsjCF;;AItsjCA;EACE,gBAAA;AJysjCF;;AIvsjCA;EACE,gBAAA;AJ0sjCF;;AIxsjCA;EACE,gBAAA;AJ2sjCF;;AIzsjCA;EACE,gBAAA;AJ4sjCF;;AI1sjCA;EACE,gBAAA;AJ6sjCF;;AI3sjCA;EACE,gBAAA;AJ8sjCF;;AI5sjCA;EACE,gBAAA;AJ+sjCF;;AI7sjCA;EACE,gBAAA;AJgtjCF;;AI9sjCA;EACE,gBAAA;AJitjCF;;AI/sjCA;EACE,gBAAA;AJktjCF;;AIhtjCA;EACE,gBAAA;AJmtjCF;;AIjtjCA;EACE,gBAAA;AJotjCF;;AIltjCA;EACE,gBAAA;AJqtjCF;;AIntjCA;EACE,gBAAA;AJstjCF;;AIptjCA;EACE,gBAAA;AJutjCF;;AIrtjCA;EACE,gBAAA;AJwtjCF;;AIttjCA;EACE,gBAAA;AJytjCF;;AIvtjCA;EACE,gBAAA;AJ0tjCF;;AIxtjCA;EACE,gBAAA;AJ2tjCF;;AIztjCA;EACE,gBAAA;AJ4tjCF;;AI1tjCA;EACE,gBAAA;AJ6tjCF;;AI3tjCA;EACE,gBAAA;AJ8tjCF;;AI5tjCA;EACE,gBAAA;AJ+tjCF;;AI7tjCA;EACE,gBAAA;AJgujCF;;AI9tjCA;EACE,gBAAA;AJiujCF;;AI/tjCA;EACE,gBAAA;AJkujCF;;AIhujCA;EACE,gBAAA;AJmujCF;;AIjujCA;EACE,gBAAA;AJoujCF;;AIlujCA;EACE,gBAAA;AJqujCF;;AInujCA;EACE,gBAAA;AJsujCF;;AIpujCA;EACE,gBAAA;AJuujCF;;AIrujCA;EACE,gBAAA;AJwujCF;;AItujCA;EACE,gBAAA;AJyujCF;;AIvujCA;EACE,gBAAA;AJ0ujCF;;AIxujCA;EACE,gBAAA;AJ2ujCF;;AIzujCA;EACE,gBAAA;AJ4ujCF;;AI1ujCA;EACE,gBAAA;AJ6ujCF;;AI3ujCA;EACE,gBAAA;AJ8ujCF;;AI5ujCA;EACE,gBAAA;AJ+ujCF;;AI7ujCA;EACE,gBAAA;AJgvjCF;;AI9ujCA;EACE,gBAAA;AJivjCF;;AI/ujCA;EACE,gBAAA;AJkvjCF;;AIhvjCA;EACE,gBAAA;AJmvjCF;;AIjvjCA;EACE,gBAAA;AJovjCF;;AIlvjCA;EACE,gBAAA;AJqvjCF;;AInvjCA;EACE,gBAAA;AJsvjCF;;AIpvjCA;EACE,gBAAA;AJuvjCF;;AIrvjCA;EACE,gBAAA;AJwvjCF;;AItvjCA;EACE,gBAAA;AJyvjCF;;AIvvjCA;EACE,gBAAA;AJ0vjCF;;AIxvjCA;EACE,gBAAA;AJ2vjCF;;AIzvjCA;EACE,gBAAA;AJ4vjCF;;AI1vjCA;EACE,gBAAA;AJ6vjCF;;AI3vjCA;EACE,gBAAA;AJ8vjCF;;AI5vjCA;EACE,gBAAA;AJ+vjCF;;AI7vjCA;EACE,gBAAA;AJgwjCF;;AI9vjCA;EACE,gBAAA;AJiwjCF;;AI/vjCA;EACE,gBAAA;AJkwjCF;;AIhwjCA;EACE,gBAAA;AJmwjCF;;AIjwjCA;EACE,gBAAA;AJowjCF;;AIlwjCA;EACE,gBAAA;AJqwjCF;;AInwjCA;EACE,gBAAA;AJswjCF;;AIpwjCA;EACE,gBAAA;AJuwjCF;;AIrwjCA;EACE,gBAAA;AJwwjCF;;AItwjCA;EACE,gBAAA;AJywjCF;;AIvwjCA;EACE,gBAAA;AJ0wjCF;;AIxwjCA;EACE,gBAAA;AJ2wjCF;;AIzwjCA;EACE,gBAAA;AJ4wjCF;;AI1wjCA;EACE,gBAAA;AJ6wjCF;;AI3wjCA;EACE,gBAAA;AJ8wjCF;;AI5wjCA;EACE,gBAAA;AJ+wjCF;;AI7wjCA;EACE,gBAAA;AJgxjCF;;AI9wjCA;EACE,gBAAA;AJixjCF;;AI/wjCA;EACE,gBAAA;AJkxjCF;;AIhxjCA;EACE,gBAAA;AJmxjCF;;AIjxjCA;EACE,gBAAA;AJoxjCF;;AIlxjCA;EACE,gBAAA;AJqxjCF;;AInxjCA;EACE,gBAAA;AJsxjCF;;AIpxjCA;EACE,gBAAA;AJuxjCF;;AIrxjCA;EACE,gBAAA;AJwxjCF;;AItxjCA;EACE,gBAAA;AJyxjCF;;AIvxjCA;EACE,gBAAA;AJ0xjCF;;AIxxjCA;EACE,gBAAA;AJ2xjCF;;AIzxjCA;EACE,gBAAA;AJ4xjCF;;AI1xjCA;EACE,gBAAA;AJ6xjCF;;AI3xjCA;EACE,gBAAA;AJ8xjCF;;AI5xjCA;EACE,gBAAA;AJ+xjCF;;AI7xjCA;EACE,gBAAA;AJgyjCF;;AI9xjCA;EACE,gBAAA;AJiyjCF;;AI/xjCA;EACE,gBAAA;AJkyjCF;;AIhyjCA;EACE,gBAAA;AJmyjCF;;AIjyjCA;EACE,gBAAA;AJoyjCF;;AIlyjCA;EACE,gBAAA;AJqyjCF;;AInyjCA;EACE,gBAAA;AJsyjCF;;AIpyjCA;EACE,gBAAA;AJuyjCF;;AIryjCA;EACE,gBAAA;AJwyjCF;;AItyjCA;EACE,gBAAA;AJyyjCF;;AIvyjCA;EACE,gBAAA;AJ0yjCF;;AIxyjCA;EACE,gBAAA;AJ2yjCF;;AIzyjCA;EACE,gBAAA;AJ4yjCF;;AI1yjCA;EACE,gBAAA;AJ6yjCF;;AI3yjCA;EACE,gBAAA;AJ8yjCF;;AI5yjCA;EACE,gBAAA;AJ+yjCF;;AI7yjCA;EACE,gBAAA;AJgzjCF;;AI9yjCA;EACE,gBAAA;AJizjCF;;AI/yjCA;EACE,gBAAA;AJkzjCF;;AIhzjCA;EACE,gBAAA;AJmzjCF;;AIjzjCA;EACE,gBAAA;AJozjCF;;AIlzjCA;EACE,gBAAA;AJqzjCF;;AInzjCA;EACE,gBAAA;AJszjCF;;AIpzjCA;EACE,gBAAA;AJuzjCF;;AIrzjCA;EACE,gBAAA;AJwzjCF;;AItzjCA;EACE,gBAAA;AJyzjCF;;AIvzjCA;EACE,gBAAA;AJ0zjCF;;AIxzjCA;EACE,gBAAA;AJ2zjCF;;AIzzjCA;EACE,gBAAA;AJ4zjCF;;AI1zjCA;EACE,gBAAA;AJ6zjCF;;AI3zjCA;EACE,gBAAA;AJ8zjCF;;AI5zjCA;EACE,gBAAA;AJ+zjCF;;AI7zjCA;EACE,gBAAA;AJg0jCF;;AI9zjCA;EACE,gBAAA;AJi0jCF;;AI/zjCA;EACE,gBAAA;AJk0jCF;;AIh0jCA;EACE,gBAAA;AJm0jCF;;AIj0jCA;EACE,gBAAA;AJo0jCF;;AIl0jCA;EACE,gBAAA;AJq0jCF;;AIn0jCA;EACE,gBAAA;AJs0jCF;;AIp0jCA;EACE,gBAAA;AJu0jCF;;AIr0jCA;EACE,gBAAA;AJw0jCF;;AIt0jCA;EACE,gBAAA;AJy0jCF;;AIv0jCA;EACE,gBAAA;AJ00jCF;;AIx0jCA;EACE,gBAAA;AJ20jCF;;AIz0jCA;EACE,gBAAA;AJ40jCF;;AI10jCA;EACE,gBAAA;AJ60jCF;;AI30jCA;EACE,gBAAA;AJ80jCF;;AI50jCA;EACE,gBAAA;AJ+0jCF;;AI70jCA;EACE,gBAAA;AJg1jCF;;AI90jCA;EACE,gBAAA;AJi1jCF;;AI/0jCA;EACE,gBAAA;AJk1jCF;;AIh1jCA;EACE,gBAAA;AJm1jCF;;AIj1jCA;EACE,gBAAA;AJo1jCF;;AIl1jCA;EACE,gBAAA;AJq1jCF;;AIn1jCA;EACE,gBAAA;AJs1jCF;;AIp1jCA;EACE,gBAAA;AJu1jCF;;AIr1jCA;EACE,gBAAA;AJw1jCF;;AIt1jCA;EACE,gBAAA;AJy1jCF;;AIv1jCA;EACE,gBAAA;AJ01jCF;;AIx1jCA;EACE,gBAAA;AJ21jCF;;AIz1jCA;EACE,gBAAA;AJ41jCF;;AI11jCA;EACE,gBAAA;AJ61jCF;;AI31jCA;EACE,gBAAA;AJ81jCF;;AI51jCA;EACE,gBAAA;AJ+1jCF;;AI71jCA;EACE,gBAAA;AJg2jCF;;AI91jCA;EACE,gBAAA;AJi2jCF;;AI/1jCA;EACE,gBAAA;AJk2jCF;;AIh2jCA;EACE,gBAAA;AJm2jCF;;AIj2jCA;EACE,gBAAA;AJo2jCF;;AIl2jCA;EACE,gBAAA;AJq2jCF;;AIn2jCA;EACE,gBAAA;AJs2jCF;;AIp2jCA;EACE,gBAAA;AJu2jCF;;AIr2jCA;EACE,gBAAA;AJw2jCF;;AIt2jCA;EACE,gBAAA;AJy2jCF;;AIv2jCA;EACE,gBAAA;AJ02jCF;;AIx2jCA;EACE,gBAAA;AJ22jCF;;AIz2jCA;EACE,gBAAA;AJ42jCF;;AI12jCA;EACE,gBAAA;AJ62jCF;;AI32jCA;EACE,gBAAA;AJ82jCF;;AI52jCA;EACE,gBAAA;AJ+2jCF;;AI72jCA;EACE,gBAAA;AJg3jCF;;AI92jCA;EACE,gBAAA;AJi3jCF;;AI/2jCA;EACE,gBAAA;AJk3jCF;;AIh3jCA;EACE,gBAAA;AJm3jCF;;AIj3jCA;EACE,gBAAA;AJo3jCF;;AIl3jCA;EACE,gBAAA;AJq3jCF;;AIn3jCA;EACE,gBAAA;AJs3jCF;;AIp3jCA;EACE,gBAAA;AJu3jCF;;AIr3jCA;EACE,gBAAA;AJw3jCF;;AIt3jCA;EACE,gBAAA;AJy3jCF;;AIv3jCA;EACE,gBAAA;AJ03jCF;;AIx3jCA;EACE,gBAAA;AJ23jCF;;AIz3jCA;EACE,gBAAA;AJ43jCF;;AI13jCA;EACE,gBAAA;AJ63jCF;;AI33jCA;EACE,gBAAA;AJ83jCF;;AI53jCA;EACE,gBAAA;AJ+3jCF;;AI73jCA;EACE,gBAAA;AJg4jCF;;AI93jCA;EACE,gBAAA;AJi4jCF;;AI/3jCA;EACE,gBAAA;AJk4jCF;;AIh4jCA;EACE,gBAAA;AJm4jCF;;AIj4jCA;EACE,gBAAA;AJo4jCF;;AIl4jCA;EACE,gBAAA;AJq4jCF;;AIn4jCA;EACE,gBAAA;AJs4jCF;;AIp4jCA;EACE,gBAAA;AJu4jCF;;AIr4jCA;EACE,gBAAA;AJw4jCF;;AIt4jCA;EACE,gBAAA;AJy4jCF;;AIv4jCA;EACE,gBAAA;AJ04jCF;;AIx4jCA;EACE,gBAAA;AJ24jCF;;AIz4jCA;EACE,gBAAA;AJ44jCF;;AI14jCA;EACE,gBAAA;AJ64jCF;;AI34jCA;EACE,gBAAA;AJ84jCF;;AI54jCA;EACE,gBAAA;AJ+4jCF;;AI74jCA;EACE,gBAAA;AJg5jCF;;AI94jCA;EACE,gBAAA;AJi5jCF;;AI/4jCA;EACE,gBAAA;AJk5jCF;;AIh5jCA;EACE,gBAAA;AJm5jCF;;AIj5jCA;EACE,gBAAA;AJo5jCF;;AIl5jCA;EACE,gBAAA;AJq5jCF;;AIn5jCA;EACE,gBAAA;AJs5jCF;;AIp5jCA;EACE,gBAAA;AJu5jCF;;AIr5jCA;EACE,gBAAA;AJw5jCF;;AIt5jCA;EACE,gBAAA;AJy5jCF;;AIv5jCA;EACE,gBAAA;AJ05jCF;;AIx5jCA;EACE,gBAAA;AJ25jCF;;AIz5jCA;EACE,gBAAA;AJ45jCF;;AI15jCA;EACE,gBAAA;AJ65jCF;;AI35jCA;EACE,gBAAA;AJ85jCF;;AI55jCA;EACE,gBAAA;AJ+5jCF;;AI75jCA;EACE,gBAAA;AJg6jCF;;AI95jCA;EACE,gBAAA;AJi6jCF;;AI/5jCA;EACE,gBAAA;AJk6jCF;;AIh6jCA;EACE,gBAAA;AJm6jCF;;AIj6jCA;EACE,gBAAA;AJo6jCF;;AIl6jCA;EACE,gBAAA;AJq6jCF;;AIn6jCA;EACE,gBAAA;AJs6jCF;;AIp6jCA;EACE,gBAAA;AJu6jCF;;AIr6jCA;EACE,gBAAA;AJw6jCF;;AIt6jCA;EACE,gBAAA;AJy6jCF;;AIv6jCA;EACE,gBAAA;AJ06jCF;;AIx6jCA;EACE,gBAAA;AJ26jCF;;AIz6jCA;EACE,gBAAA;AJ46jCF;;AI16jCA;EACE,gBAAA;AJ66jCF;;AI36jCA;EACE,gBAAA;AJ86jCF;;AI56jCA;EACE,gBAAA;AJ+6jCF;;AI76jCA;EACE,gBAAA;AJg7jCF;;AI96jCA;EACE,gBAAA;AJi7jCF;;AI/6jCA;EACE,gBAAA;AJk7jCF;;AIh7jCA;EACE,gBAAA;AJm7jCF;;AIj7jCA;EACE,gBAAA;AJo7jCF;;AIl7jCA;EACE,gBAAA;AJq7jCF;;AIn7jCA;EACE,gBAAA;AJs7jCF;;AIp7jCA;EACE,gBAAA;AJu7jCF;;AIr7jCA;EACE,gBAAA;AJw7jCF;;AIt7jCA;EACE,gBAAA;AJy7jCF;;AIv7jCA;EACE,gBAAA;AJ07jCF;;AIx7jCA;EACE,gBAAA;AJ27jCF;;AIz7jCA;EACE,gBAAA;AJ47jCF;;AI17jCA;EACE,gBAAA;AJ67jCF;;AI37jCA;EACE,gBAAA;AJ87jCF;;AI57jCA;EACE,gBAAA;AJ+7jCF;;AI77jCA;EACE,gBAAA;AJg8jCF;;AI97jCA;EACE,gBAAA;AJi8jCF;;AI/7jCA;EACE,gBAAA;AJk8jCF;;AIh8jCA;EACE,gBAAA;AJm8jCF;;AIj8jCA;EACE,gBAAA;AJo8jCF;;AIl8jCA;EACE,gBAAA;AJq8jCF;;AIn8jCA;EACE,gBAAA;AJs8jCF;;AIp8jCA;EACE,gBAAA;AJu8jCF;;AIr8jCA;EACE,gBAAA;AJw8jCF;;AIt8jCA;EACE,gBAAA;AJy8jCF;;AIv8jCA;EACE,gBAAA;AJ08jCF;;AIx8jCA;EACE,gBAAA;AJ28jCF;;AIz8jCA;EACE,gBAAA;AJ48jCF;;AI18jCA;EACE,gBAAA;AJ68jCF;;AI38jCA;EACE,gBAAA;AJ88jCF;;AI58jCA;EACE,gBAAA;AJ+8jCF;;AI78jCA;EACE,gBAAA;AJg9jCF;;AI98jCA;EACE,gBAAA;AJi9jCF;;AI/8jCA;EACE,gBAAA;AJk9jCF;;AIh9jCA;EACE,gBAAA;AJm9jCF;;AIj9jCA;EACE,gBAAA;AJo9jCF;;AIl9jCA;EACE,gBAAA;AJq9jCF;;AIn9jCA;EACE,gBAAA;AJs9jCF;;AIp9jCA;EACE,gBAAA;AJu9jCF;;AIr9jCA;EACE,gBAAA;AJw9jCF;;AIt9jCA;EACE,gBAAA;AJy9jCF;;AIv9jCA;EACE,gBAAA;AJ09jCF;;AIx9jCA;EACE,gBAAA;AJ29jCF;;AIz9jCA;EACE,gBAAA;AJ49jCF;;AI19jCA;EACE,gBAAA;AJ69jCF;;AI39jCA;EACE,gBAAA;AJ89jCF;;AI59jCA;EACE,gBAAA;AJ+9jCF;;AI79jCA;EACE,gBAAA;AJg+jCF;;AI99jCA;EACE,gBAAA;AJi+jCF;;AI/9jCA;EACE,gBAAA;AJk+jCF;;AIh+jCA;EACE,gBAAA;AJm+jCF;;AIj+jCA;EACE,gBAAA;AJo+jCF;;AIl+jCA;EACE,gBAAA;AJq+jCF;;AIn+jCA;EACE,gBAAA;AJs+jCF;;AIp+jCA;EACE,gBAAA;AJu+jCF;;AIr+jCA;EACE,gBAAA;AJw+jCF;;AIt+jCA;EACE,gBAAA;AJy+jCF;;AIv+jCA;EACE,gBAAA;AJ0+jCF;;AIx+jCA;EACE,gBAAA;AJ2+jCF;;AIz+jCA;EACE,gBAAA;AJ4+jCF;;AI1+jCA;EACE,gBAAA;AJ6+jCF;;AI3+jCA;EACE,gBAAA;AJ8+jCF;;AI5+jCA;EACE,gBAAA;AJ++jCF;;AI7+jCA;EACE,gBAAA;AJg/jCF;;AI9+jCA;EACE,gBAAA;AJi/jCF;;AI/+jCA;EACE,gBAAA;AJk/jCF;;AIh/jCA;EACE,gBAAA;AJm/jCF;;AIj/jCA;EACE,gBAAA;AJo/jCF;;AIl/jCA;EACE,gBAAA;AJq/jCF;;AIn/jCA;EACE,gBAAA;AJs/jCF;;AIp/jCA;EACE,gBAAA;AJu/jCF;;AIr/jCA;EACE,gBAAA;AJw/jCF;;AIt/jCA;EACE,gBAAA;AJy/jCF;;AIv/jCA;EACE,gBAAA;AJ0/jCF;;AIx/jCA;EACE,gBAAA;AJ2/jCF;;AIz/jCA;EACE,gBAAA;AJ4/jCF;;AI1/jCA;EACE,SAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;AJ6/jCF;;AI3/jCA;EACE,UAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AJ8/jCF;;AI7/jCA;EACE,kCAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iTAAA;AJggkCF;AI9/jCA;EACE,kCAAA;AJggkCF;;AI//jCA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iTAAA;AJkgkCF;AIhgkCA;EACE,gCAAA;EACA,gBAAA;AJkgkCF;;AIjgkCA;EACE,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,6CAAA;EACA,iTAAA;AJogkCF;AIlgkCA;;EAEE,gCAAA;EACA,gBAAA;AJogkCF;;AIlgkCA;EACE,gBAAA;AJqgkCF;;AIngkCA;EACE,kCAAA;EACA,gBAAA;AJsgkCF;;AIpgkCA;EACE,gCAAA;EACA,gBAAA;AJugkCF;;AIrgkCA;EACE,gBAAA;AJwgkCF;;AItgkCA;EACE,gBAAA;AJygkCF;;AIvgkCA;EACE,gBAAA;AJ0gkCF;;AIxgkCA;EACE,gBAAA;AJ2gkCF;;AIzgkCA;EACE,gCAAA;EACA,gBAAA;AJ4gkCF;;AI1gkCA;EACE,gBAAA;AJ6gkCF;;AI3gkCA;EACE,gCAAA;EACA,gBAAA;AJ8gkCF;;AI5gkCA;EACE,gBAAA;AJ+gkCF;;AI7gkCA;EACE,gCAAA;EACA,gBAAA;AJghkCF;;AI9gkCA;EACE,gBAAA;AJihkCF;;AI/gkCA;EACE,gCAAA;EACA,gBAAA;AJkhkCF;;AIhhkCA;EACE,gBAAA;AJmhkCF;;AIjhkCA;EACE,gCAAA;EACA,gBAAA;AJohkCF;;AIlhkCA;EACE,gBAAA;AJqhkCF;;AInhkCA;EACE,gCAAA;EACA,gBAAA;AJshkCF;;AIphkCA;EACE,gBAAA;AJuhkCF;;AIrhkCA;EACE,gBAAA;AJwhkCF;;AIthkCA;EACE,gBAAA;AJyhkCF;;AIvhkCA;EACE,gBAAA;AJ0hkCF;;AIxhkCA;EACE,gCAAA;EACA,gBAAA;AJ2hkCF;;AIzhkCA;EACE,gBAAA;AJ4hkCF;;AI1hkCA;EACE,gBAAA;AJ6hkCF;;AI3hkCA;EACE,gCAAA;EACA,gBAAA;AJ8hkCF;;AI5hkCA;EACE,gBAAA;AJ+hkCF;;AI7hkCA;EACE,gCAAA;EACA,gBAAA;AJgikCF;;AI9hkCA;EACE,gBAAA;AJiikCF;;AI/hkCA;EACE,gCAAA;EACA,gBAAA;AJkikCF;;AIhikCA;EACE,gBAAA;AJmikCF;;AIjikCA;EACE,gBAAA;AJoikCF;;AIlikCA;EACE,gBAAA;AJqikCF;;AInikCA;EACE,gCAAA;EACA,gBAAA;AJsikCF;;AIpikCA;EACE,gBAAA;AJuikCF;;AIrikCA;EACE,gCAAA;EACA,gBAAA;AJwikCF;;AItikCA;EACE,gBAAA;AJyikCF;;AIvikCA;EACE,gCAAA;EACA,gBAAA;AJ0ikCF;;AIxikCA;EACE,gBAAA;AJ2ikCF;;AIzikCA;EACE,gBAAA;AJ4ikCF;;AI1ikCA;EACE,gCAAA;EACA,gBAAA;AJ6ikCF;;AI3ikCA;EACE,gBAAA;AJ8ikCF;;AI5ikCA;EACE,gCAAA;EACA,gBAAA;AJ+ikCF;;AI7ikCA;EACE,gBAAA;AJgjkCF;;AI9ikCA;EACE,gBAAA;AJijkCF;;AI/ikCA;EACE,gCAAA;EACA,gBAAA;AJkjkCF;;AIhjkCA;EACE,gCAAA;EACA,gBAAA;AJmjkCF;;AIjjkCA;EACE,gBAAA;AJojkCF;;AIljkCA;EACE,gBAAA;AJqjkCF;;AInjkCA;EACE,gBAAA;AJsjkCF;;AIpjkCA;EACE,gBAAA;AJujkCF;;AIrjkCA;EACE,gCAAA;EACA,gBAAA;AJwjkCF;;AItjkCA;EACE,gBAAA;AJyjkCF;;AIvjkCA;EACE,gCAAA;EACA,gBAAA;AJ0jkCF;;AIxjkCA;EACE,gBAAA;AJ2jkCF;;AIzjkCA;EACE,kCAAA;EACA,gBAAA;AJ4jkCF;;AI1jkCA;EACE,kCAAA;EACA,gBAAA;AJ6jkCF;;AI3jkCA;EACE,gBAAA;AJ8jkCF;;AI5jkCA;EACE,gCAAA;EACA,gBAAA;AJ+jkCF;;AI7jkCA;EACE,gBAAA;AJgkkCF;;AI9jkCA;EACE,gCAAA;EACA,gBAAA;AJikkCF;;AI/jkCA;EACE,gBAAA;AJkkkCF;;AIhkkCA;EACE,gCAAA;EACA,gBAAA;AJmkkCF;;AIjkkCA;EACE,gBAAA;AJokkCF;;AIlkkCA;EACE,gBAAA;AJqkkCF;;AInkkCA;EACE,kCAAA;EACA,gBAAA;AJskkCF;;AIpkkCA;EACE,gBAAA;AJukkCF;;AIrkkCA;EACE,gBAAA;AJwkkCF;;AItkkCA;EACE,gBAAA;AJykkCF;;AIvkkCA;EACE,gBAAA;AJ0kkCF;;AIxkkCA;EACE,kCAAA;EACA,gBAAA;AJ2kkCF;;AIzkkCA;EACE,gCAAA;EACA,gBAAA;AJ4kkCF;;AI1kkCA;EACE,gBAAA;AJ6kkCF;;AI3kkCA;EACE,gCAAA;EACA,gBAAA;AJ8kkCF;;AI5kkCA;EACE,gBAAA;AJ+kkCF;;AI7kkCA;EACE,gCAAA;EACA,gBAAA;AJglkCF;;AI9kkCA;EACE,gBAAA;AJilkCF;;AI/kkCA;EACE,kCAAA;EACA,gBAAA;AJklkCF;;AIhlkCA;EACE,kCAAA;EACA,gBAAA;AJmlkCF;;AIjlkCA;EACE,gBAAA;AJolkCF;;AIllkCA;EACE,kCAAA;EACA,gBAAA;AJqlkCF;;AInlkCA;EACE,gBAAA;AJslkCF;;AIplkCA;EACE,kCAAA;EACA,gBAAA;AJulkCF;;AIrlkCA;EACE,gCAAA;EACA,gBAAA;AJwlkCF;;AItlkCA;EACE,gBAAA;AJylkCF;;AIvlkCA;EACE,gCAAA;EACA,gBAAA;AJ0lkCF;;AIxlkCA;EACE,gBAAA;AJ2lkCF;;AIzlkCA;EACE,gCAAA;EACA,gBAAA;AJ4lkCF;;AI1lkCA;EACE,gBAAA;AJ6lkCF;;AI3lkCA;EACE,gCAAA;EACA,gBAAA;AJ8lkCF;;AI5lkCA;EACE,gBAAA;AJ+lkCF;;AI7lkCA;EACE,gCAAA;EACA,gBAAA;AJgmkCF;;AI9lkCA;EACE,gBAAA;AJimkCF;;AI/lkCA;EACE,gCAAA;EACA,gBAAA;AJkmkCF;;AIhmkCA;EACE,gBAAA;AJmmkCF;;AIjmkCA;EACE,gBAAA;AJomkCF;;AIlmkCA;EACE,gBAAA;AJqmkCF;;AInmkCA;EACE,gBAAA;AJsmkCF;;AIpmkCA;EACE,gBAAA;AJumkCF;;AIrmkCA;EACE,gCAAA;EACA,gBAAA;AJwmkCF;;AItmkCA;EACE,gBAAA;AJymkCF;;AIvmkCA;EACE,gCAAA;EACA,gBAAA;AJ0mkCF;;AIxmkCA;EACE,gBAAA;AJ2mkCF;;AIzmkCA;EACE,gBAAA;AJ4mkCF;;AI1mkCA;EACE,gBAAA;AJ6mkCF;;AI3mkCA;EACE,kCAAA;EACA,gBAAA;AJ8mkCF;;AI5mkCA;EACE,kCAAA;EACA,gBAAA;AJ+mkCF;;AI7mkCA;EACE,kCAAA;EACA,gBAAA;AJgnkCF;;AI9mkCA;EACE,kCAAA;EACA,gBAAA;AJinkCF;;AI/mkCA;EACE,gBAAA;AJknkCF;;AIhnkCA;EACE,gCAAA;EACA,gBAAA;AJmnkCF;;AIjnkCA;EACE,gBAAA;AJonkCF;;AIlnkCA;EACE,gBAAA;AJqnkCF;;AInnkCA;EACE,gBAAA;AJsnkCF;;AIpnkCA;EACE,gBAAA;AJunkCF;;AIrnkCA;EACE,kCAAA;EACA,gBAAA;AJwnkCF;;AItnkCA;EACE,gBAAA;AJynkCF;;AIvnkCA;EACE,gBAAA;AJ0nkCF;;AIxnkCA;EACE,gBAAA;AJ2nkCF;;AIznkCA;EACE,gBAAA;AJ4nkCF;;AI1nkCA;EACE,gBAAA;AJ6nkCF;;AI3nkCA;EACE,gCAAA;EACA,gBAAA;AJ8nkCF;;AI5nkCA;EACE,gBAAA;AJ+nkCF;;AI7nkCA;EACE,gCAAA;EACA,gBAAA;AJgokCF;;AI9nkCA;EACE,gBAAA;AJiokCF;;AI/nkCA;EACE,gBAAA;AJkokCF;;AIhokCA;EACE,gCAAA;EACA,gBAAA;AJmokCF;;AIjokCA;EACE,gCAAA;EACA,gBAAA;AJookCF;;AIlokCA;EACE,gBAAA;AJqokCF;;AInokCA;EACE,gCAAA;EACA,gBAAA;AJsokCF;;AIpokCA;EACE,gBAAA;AJuokCF;;AIrokCA;EACE,gBAAA;AJwokCF;;AItokCA;EACE,gBAAA;AJyokCF;;AIvokCA;EACE,gBAAA;AJ0okCF;;AIxokCA;EACE,gCAAA;EACA,gBAAA;AJ2okCF;;AIzokCA;EACE,gBAAA;AJ4okCF;;AI1okCA;EACE,gBAAA;AJ6okCF;;AI3okCA;EACE,gCAAA;EACA,gBAAA;AJ8okCF;;AI5okCA;EACE,gBAAA;AJ+okCF;;AI7okCA;EACE,gCAAA;EACA,gBAAA;AJgpkCF;;AI9okCA;EACE,gBAAA;AJipkCF;;AI/okCA;EACE,gCAAA;EACA,gBAAA;AJkpkCF;;AIhpkCA;EACE,gBAAA;AJmpkCF;;AIjpkCA;EACE,gBAAA;AJopkCF;;AIlpkCA;EACE,gBAAA;AJqpkCF;;AInpkCA;EACE,gBAAA;AJspkCF;;AIppkCA;EACE,gCAAA;EACA,gBAAA;AJupkCF;;AIrpkCA;EACE,gBAAA;AJwpkCF;;AItpkCA;EACE,gBAAA;AJypkCF;;AIvpkCA;EACE,kCAAA;EACA,gBAAA;AJ0pkCF;;AIxpkCA;EACE,gCAAA;EACA,gBAAA;AJ2pkCF;;AIzpkCA;EACE,gBAAA;AJ4pkCF;;AI1pkCA;EACE,gCAAA;EACA,gBAAA;AJ6pkCF;;AI3pkCA;EACE,gBAAA;AJ8pkCF;;AI5pkCA;EACE,gCAAA;EACA,gBAAA;AJ+pkCF;;AI7pkCA;EACE,gBAAA;AJgqkCF;;AI9pkCA;EACE,gCAAA;EACA,gBAAA;AJiqkCF;;AI/pkCA;EACE,gBAAA;AJkqkCF;;AIhqkCA;EACE,gCAAA;EACA,gBAAA;AJmqkCF;;AIjqkCA;EACE,gBAAA;AJoqkCF;;AIlqkCA;EACE,gCAAA;EACA,gBAAA;AJqqkCF;;AInqkCA;EACE,gBAAA;AJsqkCF;;AIpqkCA;EACE,gCAAA;EACA,gBAAA;AJuqkCF;;AIrqkCA;EACE,gBAAA;AJwqkCF;;AItqkCA;EACE,gBAAA;AJyqkCF;;AIvqkCA;EACE,gCAAA;EACA,gBAAA;AJ0qkCF;;AIxqkCA;EACE,gBAAA;AJ2qkCF;;AIzqkCA;EACE,gCAAA;EACA,gBAAA;AJ4qkCF;;AI1qkCA;EACE,gBAAA;AJ6qkCF;;AI3qkCA;EACE,gCAAA;EACA,gBAAA;AJ8qkCF;;AI5qkCA;EACE,gBAAA;AJ+qkCF;;AI7qkCA;EACE,gBAAA;AJgrkCF;;AI9qkCA;EACE,gBAAA;AJirkCF;;AI/qkCA;EACE,gBAAA;AJkrkCF;;AIhrkCA;EACE,gCAAA;EACA,gBAAA;AJmrkCF;;AIjrkCA;EACE,gBAAA;AJorkCF;;AIlrkCA;EACE,kCAAA;EACA,gBAAA;AJqrkCF;;AInrkCA;EACE,kCAAA;EACA,gBAAA;AJsrkCF;;AIprkCA;EACE,kCAAA;EACA,gBAAA;AJurkCF;;AIrrkCA;EACE,gBAAA;AJwrkCF;;AItrkCA;EACE,gCAAA;EACA,gBAAA;AJyrkCF;;AIvrkCA;EACE,gBAAA;AJ0rkCF;;AIxrkCA;EACE,gBAAA;AJ2rkCF;;AIzrkCA;EACE,gBAAA;AJ4rkCF;;AI1rkCA;EACE,gBAAA;AJ6rkCF;;AI3rkCA;EACE,gBAAA;AJ8rkCF;;AI5rkCA;EACE,gCAAA;EACA,gBAAA;AJ+rkCF;;AI7rkCA;EACE,gCAAA;EACA,gBAAA;AJgskCF;;AI9rkCA;EACE,gBAAA;AJiskCF;;AI/rkCA;EACE,gCAAA;EACA,gBAAA;AJkskCF;;AIhskCA;EACE,gBAAA;AJmskCF;;AIjskCA;EACE,gCAAA;EACA,gBAAA;AJoskCF;;AIlskCA;EACE,gBAAA;AJqskCF;;AInskCA;EACE,gCAAA;EACA,gBAAA;AJsskCF;;AIpskCA;EACE,gBAAA;AJuskCF;;AIrskCA;EACE,gCAAA;EACA,gBAAA;AJwskCF;;AItskCA;EACE,gBAAA;AJyskCF;;AIvskCA;EACE,gCAAA;EACA,gBAAA;AJ0skCF;;AIxskCA;EACE,gBAAA;AJ2skCF;;AIzskCA;EACE,gBAAA;AJ4skCF;;AI1skCA;EACE,gBAAA;AJ6skCF;;AI3skCA;EACE,gBAAA;AJ8skCF;;AI5skCA;EACE,gBAAA;AJ+skCF;;AI7skCA;EACE,gBAAA;AJgtkCF;;AI9skCA;EACE,gBAAA;AJitkCF;;AI/skCA;EACE,gBAAA;AJktkCF;;AIhtkCA;EACE,gBAAA;AJmtkCF;;AIjtkCA;EACE,gBAAA;AJotkCF;;AIltkCA;EACE,gBAAA;AJqtkCF;;AIntkCA;EACE,gBAAA;AJstkCF;;AIptkCA;EACE,gBAAA;AJutkCF;;AIrtkCA;EACE,gBAAA;AJwtkCF;;AIttkCA;EACE,gBAAA;AJytkCF;;AIvtkCA;EACE,gBAAA;AJ0tkCF;;AIxtkCA;EACE,gBAAA;AJ2tkCF;;AIztkCA;EACE,kCAAA;EACA,gBAAA;AJ4tkCF;;AI1tkCA;EACE,kCAAA;EACA,gBAAA;AJ6tkCF;;AI3tkCA;EACE,gBAAA;AJ8tkCF;;AI5tkCA;EACE,gBAAA;AJ+tkCF;;AI7tkCA;EACE,gBAAA;AJgukCF;;AI9tkCA;EACE,gBAAA;AJiukCF;;AI/tkCA;EACE,gBAAA;AJkukCF;;AIhukCA;EACE,gBAAA;AJmukCF;;AIjukCA;EACE,gBAAA;AJoukCF;;AIlukCA;EACE,gBAAA;AJqukCF;;AInukCA;EACE,kCAAA;EACA,gBAAA;AJsukCF;;AIpukCA;EACE,kCAAA;EACA,gBAAA;AJuukCF;;AIrukCA;EACE,kCAAA;EACA,gBAAA;AJwukCF;;AItukCA;EACE,kCAAA;EACA,gBAAA;AJyukCF;;AIvukCA;EACE,kCAAA;EACA,gBAAA;AJ0ukCF;;AIxukCA;EACE,gBAAA;AJ2ukCF;;AIzukCA;EACE,kCAAA;EACA,gBAAA;AJ4ukCF;;AI1ukCA;EACE,kCAAA;EACA,gBAAA;AJ6ukCF;;AI3ukCA;EACE,kCAAA;EACA,gBAAA;AJ8ukCF;;AI5ukCA;EACE,kCAAA;EACA,gBAAA;AJ+ukCF;;AI7ukCA;EACE,kCAAA;EACA,gBAAA;AJgvkCF;;AI9ukCA;EACE,kCAAA;EACA,gBAAA;AJivkCF;;AI/ukCA;EACE,kCAAA;EACA,gBAAA;AJkvkCF;;AIhvkCA;EACE,gBAAA;AJmvkCF;;AIjvkCA;EACE,kCAAA;EACA,gBAAA;AJovkCF;;AIlvkCA;EACE,kCAAA;EACA,gBAAA;AJqvkCF;;AInvkCA;EACE,gBAAA;AJsvkCF;;AIpvkCA;EACE,gBAAA;AJuvkCF;;AIrvkCA;EACE,gBAAA;AJwvkCF;;AItvkCA;EACE,gBAAA;AJyvkCF;;AIvvkCA;EACE,kCAAA;EACA,gBAAA;AJ0vkCF;;AIxvkCA;EACE,kCAAA;EACA,gBAAA;AJ2vkCF;;AIzvkCA;EACE,kCAAA;EACA,gBAAA;AJ4vkCF;;AI1vkCA;EACE,kCAAA;EACA,gBAAA;AJ6vkCF;;AI3vkCA;EACE,kCAAA;EACA,gBAAA;AJ8vkCF;;AI5vkCA;EACE,kCAAA;EACA,gBAAA;AJ+vkCF;;AI7vkCA;EACE,kCAAA;EACA,gBAAA;AJgwkCF;;AI9vkCA;EACE,kCAAA;EACA,gBAAA;AJiwkCF;;AI/vkCA;EACE,kCAAA;EACA,gBAAA;AJkwkCF;;AIhwkCA;EACE,kCAAA;EACA,gBAAA;AJmwkCF;;AIjwkCA;EACE,gBAAA;AJowkCF;;AIlwkCA;EACE,gCAAA;EACA,gBAAA;AJqwkCF;;AInwkCA;EACE,gBAAA;AJswkCF;;AIpwkCA;EACE,gCAAA;EACA,gBAAA;AJuwkCF;;AIrwkCA;EACE,gBAAA;AJwwkCF;;AItwkCA;EACE,kCAAA;EACA,gBAAA;AJywkCF;;AIvwkCA;EACE,kCAAA;EACA,gBAAA;AJ0wkCF;;AIxwkCA;EACE,kCAAA;EACA,gBAAA;AJ2wkCF;;AIzwkCA;EACE,kCAAA;EACA,gBAAA;AJ4wkCF;;AI1wkCA;EACE,kCAAA;EACA,gBAAA;AJ6wkCF;;AI3wkCA;EACE,gCAAA;EACA,gBAAA;AJ8wkCF;;AI5wkCA;EACE,gBAAA;AJ+wkCF;;AI7wkCA;EACE,gCAAA;EACA,gBAAA;AJgxkCF;;AI9wkCA;EACE,gBAAA;AJixkCF;;AI/wkCA;EACE,gCAAA;EACA,gBAAA;AJkxkCF;;AIhxkCA;EACE,gBAAA;AJmxkCF;;AIjxkCA;EACE,gCAAA;EACA,gBAAA;AJoxkCF;;AIlxkCA;EACE,gBAAA;AJqxkCF;;AInxkCA;EACE,gCAAA;EACA,gBAAA;AJsxkCF;;AIpxkCA;EACE,gBAAA;AJuxkCF;;AIrxkCA;EACE,kCAAA;EACA,gBAAA;AJwxkCF;;AItxkCA;EACE,gBAAA;AJyxkCF;;AIvxkCA;EACE,gBAAA;AJ0xkCF;;AIxxkCA;EACE,gCAAA;EACA,gBAAA;AJ2xkCF;;AIzxkCA;EACE,gBAAA;AJ4xkCF;;AI1xkCA;EACE,kCAAA;EACA,gBAAA;AJ6xkCF;;AI3xkCA;EACE,kCAAA;EACA,gBAAA;AJ8xkCF;;AI5xkCA;EACE,kCAAA;EACA,gBAAA;AJ+xkCF;;AI7xkCA;EACE,gBAAA;AJgykCF;;AI9xkCA;EACE,gBAAA;AJiykCF;;AI/xkCA;EACE,gBAAA;AJkykCF;;AIhykCA;EACE,kCAAA;EACA,gBAAA;AJmykCF;;AIjykCA;EACE,kCAAA;EACA,gBAAA;AJoykCF;;AIlykCA;EACE,kCAAA;EACA,gBAAA;AJqykCF;;AInykCA;EACE,kCAAA;EACA,gBAAA;AJsykCF;;AIpykCA;EACE,kCAAA;EACA,gBAAA;AJuykCF;;AIrykCA;EACE,kCAAA;EACA,gBAAA;AJwykCF;;AItykCA;EACE,kCAAA;EACA,gBAAA;AJyykCF;;AIvykCA;EACE,kCAAA;EACA,gBAAA;AJ0ykCF;;AIxykCA;EACE,kCAAA;EACA,gBAAA;AJ2ykCF;;AIzykCA;EACE,kCAAA;EACA,gBAAA;AJ4ykCF;;AI1ykCA;EACE,kCAAA;EACA,gBAAA;AJ6ykCF;;AI3ykCA;EACE,kCAAA;EACA,gBAAA;AJ8ykCF;;AI5ykCA;EACE,gBAAA;AJ+ykCF;;AI7ykCA;EACE,kCAAA;EACA,gBAAA;AJgzkCF;;AI9ykCA;EACE,kCAAA;EACA,gBAAA;AJizkCF;;AI/ykCA;EACE,kCAAA;EACA,gBAAA;AJkzkCF;;AIhzkCA;EACE,kCAAA;EACA,gBAAA;AJmzkCF;;AIjzkCA;EACE,gBAAA;AJozkCF;;AIlzkCA;EACE,gBAAA;AJqzkCF;;AInzkCA;EACE,gCAAA;EACA,gBAAA;AJszkCF;;AIpzkCA;EACE,gBAAA;AJuzkCF;;AIrzkCA;EACE,kCAAA;EACA,gBAAA;AJwzkCF;;AItzkCA;EACE,kCAAA;EACA,gBAAA;AJyzkCF;;AIvzkCA;EACE,gCAAA;EACA,gBAAA;AJ0zkCF;;AIxzkCA;EACE,gBAAA;AJ2zkCF;;AIzzkCA;EACE,gCAAA;EACA,gBAAA;AJ4zkCF;;AI1zkCA;EACE,gBAAA;AJ6zkCF;;AI3zkCA;EACE,gCAAA;EACA,gBAAA;AJ8zkCF;;AI5zkCA;EACE,gBAAA;AJ+zkCF;;AI7zkCA;EACE,gCAAA;EACA,gBAAA;AJg0kCF;;AI9zkCA;EACE,gBAAA;AJi0kCF;;AI/zkCA;EACE,gCAAA;EACA,gBAAA;AJk0kCF;;AIh0kCA;EACE,gBAAA;AJm0kCF;;AIj0kCA;EACE,gCAAA;EACA,gBAAA;AJo0kCF;;AIl0kCA;EACE,gBAAA;AJq0kCF;;AIn0kCA;EACE,gCAAA;EACA,gBAAA;AJs0kCF;;AIp0kCA;EACE,gBAAA;AJu0kCF;;AIr0kCA;EACE,gCAAA;EACA,gBAAA;AJw0kCF;;AIt0kCA;EACE,gBAAA;AJy0kCF;;AIv0kCA;EACE,gCAAA;EACA,gBAAA;AJ00kCF;;AIx0kCA;EACE,gBAAA;AJ20kCF;;AIz0kCA;EACE,gCAAA;EACA,gBAAA;AJ40kCF;;AI10kCA;EACE,gBAAA;AJ60kCF;;AI30kCA;EACE,gCAAA;EACA,gBAAA;AJ80kCF;;AI50kCA;EACE,gBAAA;AJ+0kCF;;AI70kCA;EACE,gCAAA;EACA,gBAAA;AJg1kCF;;AI90kCA;EACE,gBAAA;AJi1kCF;;AI/0kCA;EACE,gCAAA;EACA,gBAAA;AJk1kCF;;AIh1kCA;EACE,gBAAA;AJm1kCF;;AIj1kCA;EACE,gCAAA;EACA,gBAAA;AJo1kCF;;AIl1kCA;EACE,gBAAA;AJq1kCF;;AIn1kCA;EACE,kCAAA;EACA,gBAAA;AJs1kCF;;AIp1kCA;EACE,kCAAA;EACA,gBAAA;AJu1kCF;;AIr1kCA;EACE,kCAAA;EACA,gBAAA;AJw1kCF;;AIt1kCA;EACE,gCAAA;EACA,gBAAA;AJy1kCF;;AIv1kCA;EACE,gCAAA;EACA,gBAAA;AJ01kCF;;AIx1kCA;EACE,gBAAA;AJ21kCF;;AIz1kCA;EACE,gCAAA;EACA,gBAAA;AJ41kCF;;AI11kCA;EACE,gBAAA;AJ61kCF;;AI31kCA;EACE,gCAAA;EACA,gBAAA;AJ81kCF;;AI51kCA;EACE,gBAAA;AJ+1kCF;;AI71kCA;EACE,gCAAA;EACA,gBAAA;AJg2kCF;;AI91kCA;EACE,gBAAA;AJi2kCF;;AI/1kCA;EACE,gBAAA;AJk2kCF;;AIh2kCA;EACE,kCAAA;EACA,gBAAA;AJm2kCF;;AIj2kCA;EACE,kCAAA;EACA,gBAAA;AJo2kCF;;AIl2kCA;EACE,gBAAA;AJq2kCF;;AIn2kCA;EACE,kCAAA;EACA,gBAAA;AJs2kCF;;AIp2kCA;EACE,gBAAA;AJu2kCF;;AIr2kCA;EACE,kCAAA;EACA,gBAAA;AJw2kCF;;AIt2kCA;EACE,kCAAA;EACA,gBAAA;AJy2kCF;;AIv2kCA;EACE,gBAAA;AJ02kCF;;AIx2kCA;EACE,kCAAA;EACA,gBAAA;AJ22kCF;;AIz2kCA;EACE,kCAAA;EACA,gBAAA;AJ42kCF;;AI12kCA;EACE,kCAAA;EACA,gBAAA;AJ62kCF;;AI32kCA;EACE,kCAAA;EACA,gBAAA;AJ82kCF;;AI52kCA;EACE,gBAAA;AJ+2kCF;;AI72kCA;EACE,kCAAA;EACA,gBAAA;AJg3kCF;;AI92kCA;EACE,gBAAA;AJi3kCF;;AI/2kCA;EACE,kCAAA;EACA,gBAAA;AJk3kCF;;AIh3kCA;EACE,kCAAA;EACA,gBAAA;AJm3kCF;;AIj3kCA;EACE,kCAAA;EACA,gBAAA;AJo3kCF;;AIl3kCA;EACE,kCAAA;EACA,gBAAA;AJq3kCF;;AIn3kCA;EACE,gBAAA;AJs3kCF;;AIp3kCA;EACE,gBAAA;AJu3kCF;;AIr3kCA;EACE,gCAAA;EACA,gBAAA;AJw3kCF;;AIt3kCA;EACE,gBAAA;AJy3kCF;;AIv3kCA;EACE,gCAAA;EACA,gBAAA;AJ03kCF;;AIx3kCA;EACE,gBAAA;AJ23kCF;;AIz3kCA;EACE,gCAAA;EACA,gBAAA;AJ43kCF;;AI13kCA;EACE,gBAAA;AJ63kCF;;AI33kCA;EACE,gBAAA;AJ83kCF;;AI53kCA;EACE,gBAAA;AJ+3kCF;;AI73kCA;EACE,gCAAA;EACA,gBAAA;AJg4kCF;;AI93kCA;EACE,gBAAA;AJi4kCF;;AI/3kCA;EACE,gCAAA;EACA,gBAAA;AJk4kCF;;AIh4kCA;EACE,gBAAA;AJm4kCF;;AIj4kCA;EACE,kCAAA;EACA,gBAAA;AJo4kCF;;AIl4kCA;EACE,kCAAA;EACA,gBAAA;AJq4kCF;;AIn4kCA;EACE,kCAAA;EACA,gBAAA;AJs4kCF;;AIp4kCA;EACE,gCAAA;EACA,gBAAA;AJu4kCF;;AIr4kCA;EACE,gBAAA;AJw4kCF;;AIt4kCA;EACE,kCAAA;EACA,gBAAA;AJy4kCF;;AIv4kCA;EACE,kCAAA;EACA,gBAAA;AJ04kCF;;AIx4kCA;EACE,kCAAA;EACA,gBAAA;AJ24kCF;;AIz4kCA;EACE,kCAAA;EACA,gBAAA;AJ44kCF;;AI14kCA;EACE,kCAAA;EACA,gBAAA;AJ64kCF;;AI34kCA;EACE,kCAAA;EACA,gBAAA;AJ84kCF;;AI54kCA;EACE,kCAAA;EACA,gBAAA;AJ+4kCF;;AI74kCA;EACE,kCAAA;EACA,gBAAA;AJg5kCF;;AI94kCA;EACE,gCAAA;EACA,gBAAA;AJi5kCF;;AI/4kCA;EACE,gBAAA;AJk5kCF;;AIh5kCA;EACE,gBAAA;AJm5kCF;;AIj5kCA;EACE,gCAAA;EACA,gBAAA;AJo5kCF;;AIl5kCA;EACE,gBAAA;AJq5kCF;;AIn5kCA;EACE,gBAAA;AJs5kCF;;AIp5kCA;EACE,gBAAA;AJu5kCF;;AIr5kCA;EACE,gBAAA;AJw5kCF;;AIt5kCA;EACE,kCAAA;EACA,gBAAA;AJy5kCF;;AIv5kCA;EACE,kCAAA;EACA,gBAAA;AJ05kCF;;AIx5kCA;EACE,kCAAA;EACA,gBAAA;AJ25kCF;;AIz5kCA;EACE,kCAAA;EACA,gBAAA;AJ45kCF;;AI15kCA;EACE,gCAAA;EACA,gBAAA;AJ65kCF;;AI35kCA;EACE,gBAAA;AJ85kCF;;AI55kCA;EACE,gBAAA;AJ+5kCF;;AI75kCA;EACE,gBAAA;AJg6kCF;;AI95kCA;EACE,gBAAA;AJi6kCF;;AI/5kCA;EACE,kCAAA;EACA,gBAAA;AJk6kCF;;AIh6kCA;EACE,gBAAA;AJm6kCF;;AIj6kCA;EACE,kCAAA;EACA,gBAAA;AJo6kCF;;AIl6kCA;EACE,kCAAA;EACA,gBAAA;AJq6kCF;;AIn6kCA;EACE,kCAAA;EACA,gBAAA;AJs6kCF;;AIp6kCA;EACE,kCAAA;EACA,gBAAA;AJu6kCF;;AIr6kCA;EACE,kCAAA;EACA,gBAAA;AJw6kCF;;AIt6kCA;EACE,kCAAA;EACA,gBAAA;AJy6kCF;;AIv6kCA;EACE,kCAAA;EACA,gBAAA;AJ06kCF;;AIx6kCA;EACE,kCAAA;EACA,gBAAA;AJ26kCF;;AIz6kCA;EACE,kCAAA;EACA,gBAAA;AJ46kCF;;AI16kCA;EACE,gCAAA;EACA,gBAAA;AJ66kCF;;AI36kCA;EACE,gBAAA;AJ86kCF;;AI56kCA;EACE,gBAAA;AJ+6kCF;;AI76kCA;EACE,kCAAA;EACA,gBAAA;AJg7kCF;;AI96kCA;EACE,gBAAA;AJi7kCF;;AI/6kCA;EACE,kCAAA;EACA,gBAAA;AJk7kCF;;AIh7kCA;EACE,kCAAA;EACA,gBAAA;AJm7kCF;;AIj7kCA;EACE,gBAAA;AJo7kCF;;AIl7kCA;EACE,kCAAA;EACA,gBAAA;AJq7kCF;;AIn7kCA;EACE,kCAAA;EACA,gBAAA;AJs7kCF;;AIp7kCA;EACE,kCAAA;EACA,gBAAA;AJu7kCF;;AIr7kCA;EACE,kCAAA;EACA,gBAAA;AJw7kCF;;AIt7kCA;EACE,gBAAA;AJy7kCF;;AIv7kCA;EACE,kCAAA;EACA,gBAAA;AJ07kCF;;AIx7kCA;EACE,kCAAA;EACA,gBAAA;AJ27kCF;;AIz7kCA;EACE,kCAAA;EACA,gBAAA;AJ47kCF;;AI17kCA;EACE,gBAAA;AJ67kCF;;AI37kCA;EACE,gBAAA;AJ87kCF;;AI57kCA;EACE,gBAAA;AJ+7kCF;;AI77kCA;EACE,gBAAA;AJg8kCF;;AI97kCA;EACE,gBAAA;AJi8kCF;;AI/7kCA;EACE,gBAAA;AJk8kCF;;AIh8kCA;EACE,gCAAA;EACA,gBAAA;AJm8kCF;;AIj8kCA;EACE,gCAAA;EACA,gBAAA;AJo8kCF;;AIl8kCA;EACE,gCAAA;EACA,gBAAA;AJq8kCF;;AIn8kCA;EACE,gBAAA;AJs8kCF;;AIp8kCA;EACE,kCAAA;EACA,gBAAA;AJu8kCF;;AIr8kCA;EACE,kCAAA;EACA,gBAAA;AJw8kCF;;AIt8kCA;EACE,gCAAA;EACA,gBAAA;AJy8kCF;;AIv8kCA;EACE,gCAAA;EACA,gBAAA;AJ08kCF;;AIx8kCA;EACE,gBAAA;AJ28kCF;;AIz8kCA;EACE,gBAAA;AJ48kCF;;AI18kCA;EACE,gBAAA;AJ68kCF;;AI38kCA;EACE,gBAAA;AJ88kCF;;AI58kCA;EACE,gCAAA;EACA,gBAAA;AJ+8kCF;;AI78kCA;EACE,gBAAA;AJg9kCF;;AI98kCA;EACE,gCAAA;EACA,gBAAA;AJi9kCF;;AI/8kCA;EACE,gBAAA;AJk9kCF;;AIh9kCA;EACE,gCAAA;EACA,gBAAA;AJm9kCF;;AIj9kCA;EACE,gBAAA;AJo9kCF;;AIl9kCA;EACE,gCAAA;EACA,gBAAA;AJq9kCF;;AIn9kCA;EACE,gBAAA;AJs9kCF;;AIp9kCA;EACE,gCAAA;EACA,gBAAA;AJu9kCF;;AIr9kCA;EACE,gBAAA;AJw9kCF;;AIt9kCA;EACE,gCAAA;EACA,gBAAA;AJy9kCF;;AIv9kCA;EACE,gBAAA;AJ09kCF;;AIx9kCA;EACE,gCAAA;EACA,gBAAA;AJ29kCF;;AIz9kCA;EACE,gBAAA;AJ49kCF;;AI19kCA;EACE,gCAAA;EACA,gBAAA;AJ69kCF;;AI39kCA;EACE,gBAAA;AJ89kCF;;AI59kCA;EACE,gCAAA;EACA,gBAAA;AJ+9kCF;;AI79kCA;EACE,gBAAA;AJg+kCF;;AI99kCA;EACE,gCAAA;EACA,gBAAA;AJi+kCF;;AI/9kCA;EACE,kCAAA;EACA,gBAAA;AJk+kCF;;AIh+kCA;EACE,kCAAA;EACA,gBAAA;AJm+kCF;;AIj+kCA;EACE,kCAAA;EACA,gBAAA;AJo+kCF;;AIl+kCA;EACE,kCAAA;EACA,gBAAA;AJq+kCF;;AIn+kCA;EACE,kCAAA;EACA,gBAAA;AJs+kCF;;AIp+kCA;EACE,kCAAA;EACA,gBAAA;AJu+kCF;;AIr+kCA;EACE,kCAAA;EACA,gBAAA;AJw+kCF;;AIt+kCA;EACE,kCAAA;EACA,gBAAA;AJy+kCF;;AIv+kCA;EACE,kCAAA;EACA,gBAAA;AJ0+kCF;;AIx+kCA;EACE,kCAAA;EACA,gBAAA;AJ2+kCF;;AIz+kCA;EACE,kCAAA;EACA,gBAAA;AJ4+kCF;;AI1+kCA;EACE,kCAAA;EACA,gBAAA;AJ6+kCF;;AI3+kCA;EACE,kCAAA;EACA,gBAAA;AJ8+kCF;;AI5+kCA;EACE,gBAAA;AJ++kCF;;AI7+kCA;EACE,kCAAA;EACA,gBAAA;AJg/kCF;;AI9+kCA;EACE,kCAAA;EACA,gBAAA;AJi/kCF;;AI/+kCA;EACE,kCAAA;EACA,gBAAA;AJk/kCF;;AIh/kCA;EACE,gCAAA;EACA,gBAAA;AJm/kCF;;AIj/kCA;EACE,gBAAA;AJo/kCF;;AIl/kCA;EACE,gCAAA;EACA,gBAAA;AJq/kCF;;AIn/kCA;EACE,gBAAA;AJs/kCF;;AIp/kCA;EACE,gCAAA;EACA,gBAAA;AJu/kCF;;AIr/kCA;EACE,gBAAA;AJw/kCF;;AIt/kCA;EACE,gCAAA;EACA,gBAAA;AJy/kCF;;AIv/kCA;EACE,gBAAA;AJ0/kCF;;AIx/kCA;EACE,gCAAA;EACA,gBAAA;AJ2/kCF;;AIz/kCA;EACE,gBAAA;AJ4/kCF;;AI1/kCA;EACE,gBAAA;AJ6/kCF;;AI3/kCA;EACE,gCAAA;EACA,gBAAA;AJ8/kCF;;AI5/kCA;EACE,gBAAA;AJ+/kCF;;AI7/kCA;EACE,kCAAA;EACA,gBAAA;AJgglCF;;AI9/kCA;EACE,kCAAA;EACA,gBAAA;AJiglCF;;AI//kCA;EACE,gBAAA;AJkglCF;;AIhglCA;EACE,kCAAA;EACA,gBAAA;AJmglCF;;AIjglCA;EACE,kCAAA;EACA,gBAAA;AJoglCF;;AIlglCA;EACE,kCAAA;EACA,gBAAA;AJqglCF;;AInglCA;EACE,kCAAA;EACA,gBAAA;AJsglCF;;AIpglCA;EACE,gBAAA;AJuglCF;;AIrglCA;EACE,kCAAA;EACA,gBAAA;AJwglCF;;AItglCA;EACE,kCAAA;EACA,gBAAA;AJyglCF;;AIvglCA;EACE,kCAAA;EACA,gBAAA;AJ0glCF;;AIxglCA;EACE,kCAAA;EACA,gBAAA;AJ2glCF;;AIzglCA;EACE,kCAAA;EACA,gBAAA;AJ4glCF;;AI1glCA;EACE,kCAAA;EACA,gBAAA;AJ6glCF;;AI3glCA;EACE,kCAAA;EACA,gBAAA;AJ8glCF;;AI5glCA;EACE,gCAAA;EACA,gBAAA;AJ+glCF;;AI7glCA;EACE,gBAAA;AJghlCF;;AI9glCA;EACE,gCAAA;EACA,gBAAA;AJihlCF;;AI/glCA;EACE,gBAAA;AJkhlCF;;AIhhlCA;EACE,kCAAA;EACA,gBAAA;AJmhlCF;;AIjhlCA;EACE,kCAAA;EACA,gBAAA;AJohlCF;;AIlhlCA;EACE,kCAAA;EACA,gBAAA;AJqhlCF;;AInhlCA;EACE,kCAAA;EACA,gBAAA;AJshlCF;;AIphlCA;EACE,kCAAA;EACA,gBAAA;AJuhlCF;;AIrhlCA;EACE,kCAAA;EACA,gBAAA;AJwhlCF;;AIthlCA;EACE,kCAAA;EACA,gBAAA;AJyhlCF;;AIvhlCA;EACE,gBAAA;AJ0hlCF;;AIxhlCA;EACE,gCAAA;EACA,gBAAA;AJ2hlCF;;AIzhlCA;EACE,gBAAA;AJ4hlCF;;AI1hlCA;EACE,gBAAA;AJ6hlCF;;AI3hlCA;EACE,gBAAA;AJ8hlCF;;AI5hlCA;EACE,gBAAA;AJ+hlCF;;AI7hlCA;EACE,gBAAA;AJgilCF;;AI9hlCA;EACE,kCAAA;EACA,gBAAA;AJiilCF;;AI/hlCA;EACE,kCAAA;EACA,gBAAA;AJkilCF;;AIhilCA;EACE,gBAAA;AJmilCF;;AIjilCA;EACE,kCAAA;EACA,gBAAA;AJoilCF;;AIlilCA;EACE,kCAAA;EACA,gBAAA;AJqilCF;;AInilCA;EACE,kCAAA;EACA,gBAAA;AJsilCF;;AIpilCA;EACE,kCAAA;EACA,gBAAA;AJuilCF;;AIrilCA;EACE,kCAAA;EACA,gBAAA;AJwilCF;;AItilCA;EACE,kCAAA;EACA,gBAAA;AJyilCF;;AIvilCA;EACE,kCAAA;EACA,gBAAA;AJ0ilCF;;AIxilCA;EACE,kCAAA;EACA,gBAAA;AJ2ilCF;;AIzilCA;EACE,kCAAA;EACA,gBAAA;AJ4ilCF;;AI1ilCA;EACE,kCAAA;EACA,gBAAA;AJ6ilCF;;AI3ilCA;EACE,gBAAA;AJ8ilCF;;AI5ilCA;EACE,kCAAA;EACA,gBAAA;AJ+ilCF;;AI7ilCA;EACE,gBAAA;AJgjlCF;;AI9ilCA;EACE,kCAAA;EACA,gBAAA;AJijlCF;;AI/ilCA;EACE,kCAAA;EACA,gBAAA;AJkjlCF;;AIhjlCA;EACE,gBAAA;AJmjlCF;;AIjjlCA;EACE,gCAAA;EACA,gBAAA;AJojlCF;;AIljlCA;EACE,gBAAA;AJqjlCF;;AInjlCA;EACE,gCAAA;EACA,gBAAA;AJsjlCF;;AIpjlCA;EACE,gBAAA;AJujlCF;;AIrjlCA;EACE,kCAAA;EACA,gBAAA;AJwjlCF;;AItjlCA;EACE,gCAAA;EACA,gBAAA;AJyjlCF;;AIvjlCA;EACE,gBAAA;AJ0jlCF;;AIxjlCA;EACE,gBAAA;AJ2jlCF;;AIzjlCA;EACE,gCAAA;EACA,gBAAA;AJ4jlCF;;AI1jlCA;EACE,gBAAA;AJ6jlCF;;AI3jlCA;EACE,gCAAA;EACA,gBAAA;AJ8jlCF;;AI5jlCA;EACE,gBAAA;AJ+jlCF;;AI7jlCA;EACE,gCAAA;EACA,gBAAA;AJgklCF;;AI9jlCA;EACE,gBAAA;AJiklCF;;AI/jlCA;EACE,gCAAA;EACA,gBAAA;AJkklCF;;AIhklCA;EACE,gBAAA;AJmklCF;;AIjklCA;EACE,gCAAA;EACA,gBAAA;AJoklCF;;AIlklCA;EACE,gBAAA;AJqklCF;;AInklCA;EACE,gCAAA;EACA,gBAAA;AJsklCF;;AIpklCA;EACE,gBAAA;AJuklCF;;AIrklCA;EACE,gCAAA;EACA,gBAAA;AJwklCF;;AItklCA;EACE,gBAAA;AJyklCF;;AIvklCA;EACE,kCAAA;EACA,gBAAA;AJ0klCF;;AIxklCA;EACE,kCAAA;EACA,gBAAA;AJ2klCF;;AIzklCA;EACE,kCAAA;EACA,gBAAA;AJ4klCF;;AI1klCA;EACE,gBAAA;AJ6klCF;;AI3klCA;EACE,gBAAA;AJ8klCF;;AI5klCA;EACE,gBAAA;AJ+klCF;;AI7klCA;EACE,gBAAA;AJgllCF;;AI9klCA;EACE,gBAAA;AJillCF;;AI/klCA;EACE,gBAAA;AJkllCF;;AIhllCA;EACE,gBAAA;AJmllCF;;AIjllCA;EACE,gBAAA;AJollCF;;AIlllCA;EACE,gCAAA;EACA,gBAAA;AJqllCF;;AInllCA;EACE,gCAAA;EACA,gBAAA;AJsllCF;;AIpllCA;EACE,gBAAA;AJullCF;;AIrllCA;EACE,gCAAA;EACA,gBAAA;AJwllCF;;AItllCA;EACE,gBAAA;AJyllCF;;AIvllCA;EACE,gCAAA;EACA,gBAAA;AJ0llCF;;AIxllCA;EACE,gBAAA;AJ2llCF;;AIzllCA;EACE,kCAAA;EACA,gBAAA;AJ4llCF;;AI1llCA;EACE,kCAAA;EACA,gBAAA;AJ6llCF;;AI3llCA;EACE,kCAAA;EACA,gBAAA;AJ8llCF;;AI5llCA;EACE,kCAAA;EACA,gBAAA;AJ+llCF;;AI7llCA;EACE,kCAAA;EACA,gBAAA;AJgmlCF;;AI9llCA;EACE,kCAAA;EACA,gBAAA;AJimlCF;;AI/llCA;EACE,gBAAA;AJkmlCF;;AIhmlCA;EACE,gCAAA;EACA,gBAAA;AJmmlCF;;AIjmlCA;EACE,gBAAA;AJomlCF;;AIlmlCA;EACE,kCAAA;EACA,gBAAA;AJqmlCF;;AInmlCA;EACE,kCAAA;EACA,gBAAA;AJsmlCF;;AIpmlCA;EACE,kCAAA;EACA,gBAAA;AJumlCF;;AK5hyCA;;;;;;;;;CAAA;AAUA;EACE,wBAAA;EACA,6CAAA,EAAA,OAAA;EACA,iTAAA,EAI6E,aAAA;EAC7E,kBAAA;AL2hyCF;AKxhyCA;EACE,mCAAA;EACA,kBAAA;EACA,mCAAA;EACA,kCAAA;AL0hyCF;;AKvhyCA;EAAS,mBAAA;EAAqB,mBAAA;EAAqB,yBAAA;AL6hyCnD;;AK5hyCA;EAAS,gBAAA;EAAkB,qBAAA;EAAuB,wBAAA;ALkiyClD;;AKjiyCA;EAAU,gBAAA;ALqiyCV;;AKpiyCA;EAAS,iBAAA;ALwiyCT;;AKviyCA;EAAS,kBAAA;AL2iyCT;;AK1iyCA;EAAS,cAAA;AL8iyCT;;AK7iyCA;EAAS,cAAA;ALijyCT;;AKhjyCA;EAAS,cAAA;ALojyCT;;AKnjyCA;EAAS,cAAA;ALujyCT;;AKtjyCA;EAAS,cAAA;AL0jyCT;;AKzjyCA;EAAS,cAAA;AL6jyCT;;AK5jyCA;EAAS,cAAA;ALgkyCT;;AK/jyCA;EAAS,cAAA;ALmkyCT;;AKlkyCA;EAAS,cAAA;ALskyCT;;AKrkyCA;EAAU,eAAA;ALykyCV;;AKxkyCA;EAAS,kBAAA;EAAoB,aAAA;AL6kyC7B;;AK3kyCA;EAA2B,gBAAA;AL+kyC3B;;AK9kyCA;EAA2B,gBAAA;ALklyC3B;;AKjlyCA;EAAqB,gBAAA;ALqlyCrB;;AKplyCA;EAAqB,gBAAA;ALwlyCrB;;AKvlyCA;EAAiB,gBAAA;AL2lyCjB;;AK1lyCA;EAA8B,gBAAA;AL8lyC9B;;AK7lyCA;EAA8B,gBAAA;ALimyC9B;;AKhmyCA;EAAiC,gBAAA;ALomyCjC;;AKnmyCA;EAAiC,gBAAA;ALumyCjC;;AKtmyCA;EAAkC,gBAAA;AL0myClC;;AKzmyCA;EAAkC,gBAAA;AL6myClC;;AK5myCA;EAAqC,gBAAA;ALgnyCrC;;AK/myCA;EAAqC,gBAAA;ALmnyCrC;;AKlnyCA;EAA0B,gBAAA;ALsnyC1B;;AKrnyCA;EAA0B,gBAAA;ALynyC1B;;AKxnyCA;EAA6B,gBAAA;AL4nyC7B;;AK3nyCA;EAA6B,gBAAA;AL+nyC7B;;AK9nyCA;EAAsB,gBAAA;ALkoyCtB;;AKjoyCA;EAAsB,gBAAA;ALqoyCtB;;AKpoyCA;EAAwB,gBAAA;ALwoyCxB;;AKvoyCA;EAAwB,gBAAA;AL2oyCxB;;AK1oyCA;EAAgC,gBAAA;AL8oyChC;;AK7oyCA;EAAgC,gBAAA;ALipyChC;;AKhpyCA;EAA0B,gBAAA;ALopyC1B;;AKnpyCA;EAA0B,gBAAA;ALupyC1B;;AKtpyCA;EAAwB,gBAAA;AL0pyCxB;;AKzpyCA;EAAwB,gBAAA;AL6pyCxB;;AK5pyCA;EAAgC,gBAAA;ALgqyChC;;AK/pyCA;EAAgC,gBAAA;ALmqyChC;;AKlqyCA;EAAwB,gBAAA;ALsqyCxB;;AKrqyCA;EAAwB,gBAAA;ALyqyCxB;;AKxqyCA;EAAwB,gBAAA;AL4qyCxB;;AK3qyCA;EAAwB,gBAAA;AL+qyCxB;;AK9qyCA;EAAyB,gBAAA;ALkryCzB;;AKjryCA;EAAyB,gBAAA;ALqryCzB;;AKpryCA;EAA0B,gBAAA;ALwryC1B;;AKvryCA;EAA0B,gBAAA;AL2ryC1B;;AK1ryCA;EAA2B,gBAAA;AL8ryC3B;;AK7ryCA;EAAwB,gBAAA;ALisyCxB;;AKhsyCA;EAAyB,gBAAA;ALosyCzB;;AKnsyCA;EAAuB,gBAAA;ALusyCvB;;AKtsyCA;EAA8B,gBAAA;AL0syC9B;;AKzsyCA;EAAyB,gBAAA;AL6syCzB;;AK5syCA;EAAyB,gBAAA;ALgtyCzB;;AK/syCA;EAAyB,gBAAA;ALmtyCzB;;AKltyCA;EAAyB,gBAAA;ALstyCzB;;AKrtyCA;EAAyB,gBAAA;ALytyCzB;;AKxtyCA;EAAyB,gBAAA;AL4tyCzB;;AK3tyCA;EAA+B,gBAAA;AL+tyC/B;;AK9tyCA;EAA+B,gBAAA;ALkuyC/B;;AKjuyCA;EAAmC,gBAAA;ALquyCnC;;AKpuyCA;EAAmC,gBAAA;ALwuyCnC;;AKvuyCA;EAA0B,gBAAA;AL2uyC1B;;AK1uyCA;EAA0B,gBAAA;AL8uyC1B;;AK7uyCA;EAA4B,gBAAA;ALivyC5B;;AKhvyCA;EAA4B,gBAAA;ALovyC5B;;AKnvyCA;EAAkC,gBAAA;ALuvyClC;;AKtvyCA;EAAkC,gBAAA;AL0vyClC;;AKzvyCA;EAAgC,gBAAA;AL6vyChC;;AK5vyCA;EAAgC,gBAAA;ALgwyChC;;AK/vyCA;EAA4B,gBAAA;ALmwyC5B;;AKlwyCA;EAA4B,gBAAA;ALswyC5B;;AKrwyCA;EAAwB,gBAAA;ALywyCxB;;AKxwyCA;EAAwB,gBAAA;AL4wyCxB;;AK3wyCA;EAAyB,gBAAA;AL+wyCzB;;AK9wyCA;EAAyB,gBAAA;ALkxyCzB;;AKjxyCA;EAAuB,gBAAA;ALqxyCvB;;AKpxyCA;EAAuB,gBAAA;ALwxyCvB;;AKvxyCA;EAAiC,gBAAA;AL2xyCjC;;AK1xyCA;EAAiC,gBAAA;AL8xyCjC;;AK7xyCA;EAA0B,gBAAA;ALiyyC1B;;AKhyyCA;EAA0B,gBAAA;ALoyyC1B;;AKnyyCA;EAAoC,gBAAA;ALuyyCpC;;AKtyyCA;EAAoC,gBAAA;AL0yyCpC;;AKzyyCA;EAA6B,gBAAA;AL6yyC7B;;AK5yyCA;EAA6B,gBAAA;ALgzyC7B;;AK/yyCA;EAA+B,gBAAA;ALmzyC/B;;AKlzyCA;EAA+B,gBAAA;ALszyC/B;;AKrzyCA;EAAkC,gBAAA;ALyzyClC;;AKxzyCA;EAAkC,gBAAA;AL4zyClC;;AK3zyCA;EAAkC,gBAAA;AL+zyClC;;AK9zyCA;EAAkC,gBAAA;ALk0yClC;;AKj0yCA;EAAmC,gBAAA;ALq0yCnC;;AKp0yCA;EAAmC,gBAAA;ALw0yCnC;;AKv0yCA;EAAgC,gBAAA;AL20yChC;;AK10yCA;EAAgC,gBAAA;AL80yChC;;AK70yCA;EAAgC,gBAAA;ALi1yChC;;AKh1yCA;EAAgC,gBAAA;ALo1yChC;;AKn1yCA;EAAmC,gBAAA;ALu1yCnC;;AKt1yCA;EAAmC,gBAAA;AL01yCnC;;AKz1yCA;EAAoC,gBAAA;AL61yCpC;;AK51yCA;EAAoC,gBAAA;ALg2yCpC;;AK/1yCA;EAAkC,gBAAA;ALm2yClC;;AKl2yCA;EAAkC,gBAAA;ALs2yClC;;AKr2yCA;EAA6B,gBAAA;ALy2yC7B;;AKx2yCA;EAA6B,gBAAA;AL42yC7B;;AK32yCA;EAAmC,gBAAA;AL+2yCnC;;AK92yCA;EAAmC,gBAAA;ALk3yCnC;;AKj3yCA;EAA+B,gBAAA;ALq3yC/B;;AKp3yCA;EAA+B,gBAAA;ALw3yC/B;;AKv3yCA;EAAgC,gBAAA;AL23yChC;;AK13yCA;EAAgC,gBAAA;AL83yChC;;AK73yCA;EAAqC,gBAAA;ALi4yCrC;;AKh4yCA;EAAqC,gBAAA;ALo4yCrC;;AKn4yCA;EAAmC,gBAAA;ALu4yCnC;;AKt4yCA;EAAmC,gBAAA;AL04yCnC;;AKz4yCA;EAA8B,gBAAA;AL64yC9B;;AK54yCA;EAA8B,gBAAA;ALg5yC9B;;AK/4yCA;EAAgC,gBAAA;ALm5yChC;;AKl5yCA;EAAgC,gBAAA;ALs5yChC;;AKr5yCA;EAAiC,gBAAA;ALy5yCjC;;AKx5yCA;EAAiC,gBAAA;AL45yCjC;;AK35yCA;EAAkC,gBAAA;AL+5yClC;;AK95yCA;EAAkC,gBAAA;ALk6yClC;;AKj6yCA;EAAgC,gBAAA;ALq6yChC;;AKp6yCA;EAAgC,gBAAA;ALw6yChC;;AKv6yCA;EAA2B,gBAAA;AL26yC3B;;AK16yCA;EAA2B,gBAAA;AL86yC3B;;AK76yCA;EAA6B,gBAAA;ALi7yC7B;;AKh7yCA;EAA6B,gBAAA;ALo7yC7B;;AKn7yCA;EAA6B,gBAAA;ALu7yC7B;;AKt7yCA;EAA6B,gBAAA;AL07yC7B;;AKz7yCA;EAA2B,gBAAA;AL67yC3B;;AK57yCA;EAA2B,gBAAA;ALg8yC3B;;AK/7yCA;EAA0B,gBAAA;ALm8yC1B;;AKl8yCA;EAA0B,gBAAA;ALs8yC1B;;AKr8yCA;EAA+B,gBAAA;ALy8yC/B;;AKx8yCA;EAA+B,gBAAA;AL48yC/B;;AK38yCA;EAAsB,gBAAA;AL+8yCtB;;AK98yCA;EAAqB,gBAAA;ALk9yCrB;;AKj9yCA;EAAqB,gBAAA;ALq9yCrB;;AKp9yCA;EAA0B,gBAAA;ALw9yC1B;;AKv9yCA;EAA6B,gBAAA;AL29yC7B;;AK19yCA;EAA6B,gBAAA;AL89yC7B;;AK79yCA;EAA0B,gBAAA;ALi+yC1B;;AKh+yCA;EAA0B,gBAAA;ALo+yC1B;;AKn+yCA;EAAwB,gBAAA;ALu+yCxB;;AKt+yCA;EAAwB,gBAAA;AL0+yCxB;;AKz+yCA;EAAwB,gBAAA;AL6+yCxB;;AK5+yCA;EAAwB,gBAAA;ALg/yCxB;;AK/+yCA;EAA2B,gBAAA;ALm/yC3B;;AKl/yCA;EAA2B,gBAAA;ALs/yC3B;;AKr/yCA;EAA8B,gBAAA;ALy/yC9B;;AKx/yCA;EAA8B,gBAAA;AL4/yC9B;;AK3/yCA;EAA4B,gBAAA;AL+/yC5B;;AK9/yCA;EAA4B,gBAAA;ALkgzC5B;;AKjgzCA;EAAuB,gBAAA;ALqgzCvB;;AKpgzCA;EAAuB,gBAAA;ALwgzCvB;;AKvgzCA;EAA8B,gBAAA;AL2gzC9B;;AK1gzCA;EAA8B,gBAAA;AL8gzC9B;;AK7gzCA;EAAgC,gBAAA;ALihzChC;;AKhhzCA;EAAgC,gBAAA;ALohzChC;;AKnhzCA;EAA4B,gBAAA;ALuhzC5B;;AKthzCA;EAAoC,gBAAA;AL0hzCpC;;AKzhzCA;EAAoC,gBAAA;AL6hzCpC;;AK5hzCA;EAAuC,gBAAA;ALgizCvC;;AK/hzCA;EAAuC,gBAAA;ALmizCvC;;AKlizCA;EAA4B,gBAAA;ALsizC5B;;AKrizCA;EAA8B,gBAAA;ALyizC9B;;AKxizCA;EAA8B,gBAAA;AL4izC9B;;AK3izCA;EAA0B,gBAAA;AL+izC1B;;AK9izCA;EAA0B,gBAAA;ALkjzC1B;;AKjjzCA;EAA4B,gBAAA;ALqjzC5B;;AKpjzCA;EAA4B,gBAAA;ALwjzC5B;;AKvjzCA;EAA+B,gBAAA;AL2jzC/B;;AK1jzCA;EAA+B,gBAAA;AL8jzC/B;;AK7jzCA;EAA6B,gBAAA;ALikzC7B;;AKhkzCA;EAA6B,gBAAA;ALokzC7B;;AKnkzCA;EAAmC,gBAAA;ALukzCnC;;AKtkzCA;EAAmC,gBAAA;AL0kzCnC;;AKzkzCA;EAA4B,gBAAA;AL6kzC5B;;AK5kzCA;EAA4B,gBAAA;ALglzC5B;;AK/kzCA;EAAiC,gBAAA;ALmlzCjC;;AKllzCA;EAAiC,gBAAA;ALslzCjC;;AKrlzCA;EAA0B,gBAAA;ALylzC1B;;AKxlzCA;EAA0B,gBAAA;AL4lzC1B;;AK3lzCA;EAA8B,gBAAA;AL+lzC9B;;AK9lzCA;EAA8B,gBAAA;ALkmzC9B;;AKjmzCA;EAAgC,gBAAA;ALqmzChC;;AKpmzCA;EAAgC,gBAAA;ALwmzChC;;AKvmzCA;EAAgC,gBAAA;AL2mzChC;;AK1mzCA;EAAgC,gBAAA;AL8mzChC;;AK7mzCA;EAA6B,gBAAA;ALinzC7B;;AKhnzCA;EAA6B,gBAAA;ALonzC7B;;AKnnzCA;EAA0B,gBAAA;ALunzC1B;;AKtnzCA;EAA0B,gBAAA;AL0nzC1B;;AKznzCA;EAAuB,gBAAA;AL6nzCvB;;AK5nzCA;EAAuB,gBAAA;ALgozCvB;;AK/nzCA;EAAuB,gBAAA;ALmozCvB;;AKlozCA;EAAuB,gBAAA;ALsozCvB;;AKrozCA;EAA2B,gBAAA;ALyozC3B;;AKxozCA;EAA2B,gBAAA;AL4ozC3B;;AK3ozCA;EAAuB,gBAAA;AL+ozCvB;;AK9ozCA;EAAuB,gBAAA;ALkpzCvB;;AKjpzCA;EAA4B,gBAAA;ALqpzC5B;;AKppzCA;EAA4B,gBAAA;ALwpzC5B;;AKvpzCA;EAA2B,gBAAA;AL2pzC3B;;AK1pzCA;EAA2B,gBAAA;AL8pzC3B;;AK7pzCA;EAAwB,gBAAA;ALiqzCxB;;AKhqzCA;EAAwB,gBAAA;ALoqzCxB;;AKnqzCA;EAAoC,gBAAA;ALuqzCpC;;AKtqzCA;EAAoC,gBAAA;AL0qzCpC;;AKzqzCA;EAA4B,gBAAA;AL6qzC5B;;AK5qzCA;EAA4B,gBAAA;ALgrzC5B;;AK/qzCA;EAA2B,gBAAA;ALmrzC3B;;AKlrzCA;EAA2B,gBAAA;ALsrzC3B;;AKrrzCA;EAA4B,gBAAA;ALyrzC5B;;AKxrzCA;EAA4B,gBAAA;AL4rzC5B;;AK3rzCA;EAAkB,gBAAA;AL+rzClB;;AK9rzCA;EAAyB,gBAAA;ALkszCzB;;AKjszCA;EAAyB,gBAAA;ALqszCzB;;AKpszCA;EAAyB,gBAAA;ALwszCzB;;AKvszCA;EAAyB,gBAAA;AL2szCzB;;AK1szCA;EAAuB,gBAAA;AL8szCvB;;AK7szCA;EAAuB,gBAAA;ALitzCvB;;AKhtzCA;EAA4B,gBAAA;ALotzC5B;;AKntzCA;EAA4B,gBAAA;ALutzC5B;;AKttzCA;EAA4B,gBAAA;AL0tzC5B;;AKztzCA;EAA4B,gBAAA;AL6tzC5B;;AK5tzCA;EAA4B,gBAAA;ALguzC5B;;AK/tzCA;EAA4B,gBAAA;ALmuzC5B;;AKluzCA;EAA0B,gBAAA;ALsuzC1B;;AKruzCA;EAA0B,gBAAA;ALyuzC1B;;AKxuzCA;EAA6B,gBAAA;AL4uzC7B;;AK3uzCA;EAA6B,gBAAA;AL+uzC7B;;AK9uzCA;EAA6B,gBAAA;ALkvzC7B;;AKjvzCA;EAA6B,gBAAA;ALqvzC7B;;AKpvzCA;EAA2B,gBAAA;ALwvzC3B;;AKvvzCA;EAA2B,gBAAA;AL2vzC3B;;AK1vzCA;EAAyB,gBAAA;AL8vzCzB;;AK7vzCA;EAAyB,gBAAA;ALiwzCzB;;AKhwzCA;EAAyB,gBAAA;ALowzCzB;;AKnwzCA;EAAyB,gBAAA;ALuwzCzB;;AKtwzCA;EAA2B,gBAAA;AL0wzC3B;;AKzwzCA;EAA2B,gBAAA;AL6wzC3B;;AK5wzCA;EAA8B,gBAAA;ALgxzC9B;;AK/wzCA;EAA8B,gBAAA;ALmxzC9B;;AKlxzCA;EAA8B,gBAAA;ALsxzC9B;;AKrxzCA;EAA8B,gBAAA;ALyxzC9B;;AKxxzCA;EAA8B,gBAAA;AL4xzC9B;;AK3xzCA;EAA8B,gBAAA;AL+xzC9B;;AK9xzCA;EAA8B,gBAAA;ALkyzC9B;;AKjyzCA;EAA8B,gBAAA;ALqyzC9B;;AKpyzCA;EAA4B,gBAAA;ALwyzC5B;;AKvyzCA;EAA4B,gBAAA;AL2yzC5B;;AK1yzCA;EAA2B,gBAAA;AL8yzC3B;;AK7yzCA;EAA4B,gBAAA;ALizzC5B;;AKhzzCA;EAA4B,gBAAA;ALozzC5B;;AKnzzCA;EAA4B,gBAAA;ALuzzC5B;;AKtzzCA;EAA0B,gBAAA;AL0zzC1B;;AKzzzCA;EAA0B,gBAAA;AL6zzC1B;;AK5zzCA;EAA0B,gBAAA;ALg0zC1B;;AK/zzCA;EAA0B,gBAAA;ALm0zC1B;;AKl0zCA;EAA0B,gBAAA;ALs0zC1B;;AKr0zCA;EAA0B,gBAAA;ALy0zC1B;;AKx0zCA;EAAwB,gBAAA;AL40zCxB;;AK30zCA;EAAwB,gBAAA;AL+0zCxB;;AK90zCA;EAA+B,gBAAA;ALk1zC/B;;AKj1zCA;EAA+B,gBAAA;ALq1zC/B;;AKp1zCA;EAAwB,gBAAA;ALw1zCxB;;AKv1zCA;EAAwB,gBAAA;AL21zCxB;;AK11zCA;EAAsB,gBAAA;AL81zCtB;;AK71zCA;EAAsB,gBAAA;ALi2zCtB;;AKh2zCA;EAA6B,gBAAA;ALo2zC7B;;AKn2zCA;EAA6B,gBAAA;ALu2zC7B;;AKt2zCA;EAA6B,gBAAA;AL02zC7B;;AKz2zCA;EAA6B,gBAAA;AL62zC7B;;AK52zCA;EAA6B,gBAAA;ALg3zC7B;;AK/2zCA;EAA6B,gBAAA;ALm3zC7B;;AKl3zCA;EAA2B,gBAAA;ALs3zC3B;;AKr3zCA;EAA2B,gBAAA;ALy3zC3B;;AKx3zCA;EAAwB,gBAAA;AL43zCxB;;AK33zCA;EAAwB,gBAAA;AL+3zCxB;;AK93zCA;EAAsB,gBAAA;ALk4zCtB;;AKj4zCA;EAAsB,gBAAA;ALq4zCtB;;AKp4zCA;EAA2B,gBAAA;ALw4zC3B;;AKv4zCA;EAA2B,gBAAA;AL24zC3B;;AK14zCA;EAAyB,gBAAA;AL84zCzB;;AK74zCA;EAAyB,gBAAA;ALi5zCzB;;AKh5zCA;EAAyB,gBAAA;ALo5zCzB;;AKn5zCA;EAAyB,gBAAA;ALu5zCzB;;AKt5zCA;EAAyB,gBAAA;AL05zCzB;;AKz5zCA;EAAyB,gBAAA;AL65zCzB;;AK55zCA;EAAuB,gBAAA;ALg6zCvB;;AK/5zCA;EAAuB,gBAAA;ALm6zCvB;;AKl6zCA;EAA6B,gBAAA;ALs6zC7B;;AKr6zCA;EAA6B,gBAAA;ALy6zC7B;;AKx6zCA;EAA6B,gBAAA;AL46zC7B;;AK36zCA;EAA6B,gBAAA;AL+6zC7B;;AK96zCA;EAAiC,gBAAA;ALk7zCjC;;AKj7zCA;EAAiC,gBAAA;ALq7zCjC;;AKp7zCA;EAAiC,gBAAA;ALw7zCjC;;AKv7zCA;EAAiC,gBAAA;AL27zCjC;;AK17zCA;EAA2B,gBAAA;AL87zC3B;;AK77zCA;EAA2B,gBAAA;ALi8zC3B;;AKh8zCA;EAAgC,gBAAA;ALo8zChC;;AKn8zCA;EAAgC,gBAAA;ALu8zChC;;AKt8zCA;EAA2B,gBAAA;AL08zC3B;;AKz8zCA;EAA2B,gBAAA;AL68zC3B;;AK58zCA;EAA2B,gBAAA;ALg9zC3B;;AK/8zCA;EAA2B,gBAAA;ALm9zC3B;;AKl9zCA;EAAyB,gBAAA;ALs9zCzB;;AKr9zCA;EAA8B,gBAAA;ALy9zC9B;;AKx9zCA;EAA8B,gBAAA;AL49zC9B;;AK39zCA;EAAyB,gBAAA;AL+9zCzB;;AK99zCA;EAA6B,gBAAA;ALk+zC7B;;AKj+zCA;EAA6B,gBAAA;ALq+zC7B;;AKp+zCA;EAAgC,gBAAA;ALw+zChC;;AKv+zCA;EAAgC,gBAAA;AL2+zChC;;AK1+zCA;EAA0B,gBAAA;AL8+zC1B;;AK7+zCA;EAA0B,gBAAA;ALi/zC1B;;AKh/zCA;EAAsB,gBAAA;ALo/zCtB;;AKn/zCA;EAAsB,gBAAA;ALu/zCtB;;AKt/zCA;EAA8B,gBAAA;AL0/zC9B;;AKz/zCA;EAA8B,gBAAA;AL6/zC9B;;AK5/zCA;EAA0B,gBAAA;ALgg0C1B;;AK//zCA;EAA0B,gBAAA;ALmg0C1B;;AKlg0CA;EAAuB,gBAAA;ALsg0CvB;;AKrg0CA;EAAuB,gBAAA;ALyg0CvB;;AKxg0CA;EAA4B,gBAAA;AL4g0C5B;;AK3g0CA;EAA4B,gBAAA;AL+g0C5B;;AK9g0CA;EAA0B,gBAAA;ALkh0C1B;;AKjh0CA;EAA0B,gBAAA;ALqh0C1B;;AKph0CA;EAAyB,gBAAA;ALwh0CzB;;AKvh0CA;EAAyB,gBAAA;AL2h0CzB;;AK1h0CA;EAAwC,gBAAA;AL8h0CxC;;AK7h0CA;EAAwC,gBAAA;ALii0CxC;;AKhi0CA;EAAkC,gBAAA;ALoi0ClC;;AKni0CA;EAAkC,gBAAA;ALui0ClC;;AKti0CA;EAAgC,gBAAA;AL0i0ChC;;AKzi0CA;EAAgC,gBAAA;AL6i0ChC;;AK5i0CA;EAAyB,gBAAA;ALgj0CzB;;AK/i0CA;EAAyB,gBAAA;ALmj0CzB;;AKlj0CA;EAAyB,gBAAA;ALsj0CzB;;AKrj0CA;EAAyB,gBAAA;ALyj0CzB;;AKxj0CA;EAAyB,gBAAA;AL4j0CzB;;AK3j0CA;EAAyB,gBAAA;AL+j0CzB;;AK9j0CA;EAAyB,gBAAA;ALkk0CzB;;AKjk0CA;EAAyB,gBAAA;ALqk0CzB;;AKpk0CA;EAA6B,gBAAA;ALwk0C7B;;AKvk0CA;EAA6B,gBAAA;AL2k0C7B;;AK1k0CA;EAA8B,gBAAA;AL8k0C9B;;AK7k0CA;EAA8B,gBAAA;ALil0C9B;;AKhl0CA;EAAgC,gBAAA;ALol0ChC;;AKnl0CA;EAAgC,gBAAA;ALul0ChC;;AKtl0CA;EAAiC,gBAAA;AL0l0CjC;;AKzl0CA;EAAiC,gBAAA;AL6l0CjC;;AK5l0CA;EAA+B,gBAAA;ALgm0C/B;;AK/l0CA;EAA+B,gBAAA;ALmm0C/B;;AKlm0CA;EAA6B,gBAAA;ALsm0C7B;;AKrm0CA;EAA6B,gBAAA;ALym0C7B;;AKxm0CA;EAA+B,gBAAA;AL4m0C/B;;AK3m0CA;EAA+B,gBAAA;AL+m0C/B;;AK9m0CA;EAA2B,gBAAA;ALkn0C3B;;AKjn0CA;EAA2B,gBAAA;ALqn0C3B;;AKpn0CA;EAA2B,gBAAA;ALwn0C3B;;AKvn0CA;EAA2B,gBAAA;AL2n0C3B;;AK1n0CA;EAA4B,gBAAA;AL8n0C5B;;AK7n0CA;EAA4B,gBAAA;ALio0C5B;;AKho0CA;EAA+B,gBAAA;ALoo0C/B;;AKno0CA;EAA+B,gBAAA;ALuo0C/B;;AKto0CA;EAA6B,gBAAA;AL0o0C7B;;AKzo0CA;EAA6B,gBAAA;AL6o0C7B;;AK5o0CA;EAAgC,gBAAA;ALgp0ChC;;AK/o0CA;EAAgC,gBAAA;ALmp0ChC;;AKlp0CA;EAA+B,gBAAA;ALsp0C/B;;AKrp0CA;EAA+B,gBAAA;ALyp0C/B;;AKxp0CA;EAA+B,gBAAA;AL4p0C/B;;AK3p0CA;EAA+B,gBAAA;AL+p0C/B;;AK9p0CA;EAA6B,gBAAA;ALkq0C7B;;AKjq0CA;EAA6B,gBAAA;ALqq0C7B;;AKpq0CA;EAA8B,gBAAA;ALwq0C9B;;AKvq0CA;EAA8B,gBAAA;AL2q0C9B;;AK1q0CA;EAA6B,gBAAA;AL8q0C7B;;AK7q0CA;EAA6B,gBAAA;ALir0C7B;;AKhr0CA;EAA+B,gBAAA;ALor0C/B;;AKnr0CA;EAA+B,gBAAA;ALur0C/B;;AKtr0CA;EAAwB,gBAAA;AL0r0CxB;;AKzr0CA;EAAwB,gBAAA;AL6r0CxB;;AK5r0CA;EAAwC,gBAAA;ALgs0CxC;;AK/r0CA;EAAwC,gBAAA;ALms0CxC;;AKls0CA;EAAiC,gBAAA;ALss0CjC;;AKrs0CA;EAAiC,gBAAA;ALys0CjC;;AKxs0CA;EAAkC,gBAAA;AL4s0ClC;;AK3s0CA;EAAkC,gBAAA;AL+s0ClC;;AK9s0CA;EAA2B,gBAAA;ALkt0C3B;;AKjt0CA;EAAyC,gBAAA;ALqt0CzC;;AKpt0CA;EAAyC,gBAAA;ALwt0CzC;;AKvt0CA;EAA2B,gBAAA;AL2t0C3B;;AK1t0CA;EAA0C,gBAAA;AL8t0C1C;;AK7t0CA;EAA0C,gBAAA;ALiu0C1C;;AKhu0CA;EAAoC,gBAAA;ALou0CpC;;AKnu0CA;EAAoC,gBAAA;ALuu0CpC;;AKtu0CA;EAAgC,gBAAA;AL0u0ChC;;AKzu0CA;EAAgC,gBAAA;AL6u0ChC;;AK5u0CA;EAAyB,gBAAA;ALgv0CzB;;AK/u0CA;EAAyB,gBAAA;ALmv0CzB;;AKlv0CA;EAA+B,gBAAA;ALsv0C/B;;AKrv0CA;EAA+B,gBAAA;ALyv0C/B;;AKxv0CA;EAA4B,gBAAA;AL4v0C5B;;AK3v0CA;EAA4B,gBAAA;AL+v0C5B;;AK9v0CA;EAA8B,gBAAA;ALkw0C9B;;AKjw0CA;EAA8B,gBAAA;ALqw0C9B;;AKpw0CA;EAA4B,gBAAA;ALww0C5B;;AKvw0CA;EAA4B,gBAAA;AL2w0C5B;;AK1w0CA;EAA+B,gBAAA;AL8w0C/B;;AK7w0CA;EAA+B,gBAAA;ALix0C/B;;AKhx0CA;EAAwB,gBAAA;ALox0CxB;;AKnx0CA;EAAwB,gBAAA;ALux0CxB;;AKtx0CA;EAAoC,gBAAA;AL0x0CpC;;AKzx0CA;EAAoC,gBAAA;AL6x0CpC;;AK5x0CA;EAAwB,gBAAA;ALgy0CxB;;AK/x0CA;EAAwB,gBAAA;ALmy0CxB;;AKly0CA;EAA4B,gBAAA;ALsy0C5B;;AKry0CA;EAA4B,gBAAA;ALyy0C5B;;AKxy0CA;EAA8B,gBAAA;AL4y0C9B;;AK3y0CA;EAA8B,gBAAA;AL+y0C9B;;AK9y0CA;EAA2B,gBAAA;ALkz0C3B;;AKjz0CA;EAA2B,gBAAA;ALqz0C3B;;AKpz0CA;EAAyB,gBAAA;ALwz0CzB;;AKvz0CA;EAAyB,gBAAA;AL2z0CzB;;AK1z0CA;EAA2B,gBAAA;AL8z0C3B;;AK7z0CA;EAA2B,gBAAA;ALi00C3B;;AKh00CA;EAAuB,gBAAA;ALo00CvB;;AKn00CA;EAAuB,gBAAA;ALu00CvB;;AKt00CA;EAAyB,gBAAA;AL000CzB;;AKz00CA;EAAyB,gBAAA;AL600CzB;;AK500CA;EAA+B,gBAAA;ALg10C/B;;AK/00CA;EAA+B,gBAAA;ALm10C/B;;AKl10CA;EAAuB,gBAAA;ALs10CvB;;AKr10CA;EAA0B,gBAAA;ALy10C1B;;AKx10CA;EAA0B,gBAAA;AL410C1B;;AK310CA;EAAuB,gBAAA;AL+10CvB;;AK910CA;EAAuB,gBAAA;ALk20CvB;;AKj20CA;EAAwB,gBAAA;ALq20CxB;;AKp20CA;EAAwB,gBAAA;ALw20CxB;;AKv20CA;EAA0B,gBAAA;AL220C1B;;AK120CA;EAA0B,gBAAA;AL820C1B;;AK720CA;EAA0B,gBAAA;ALi30C1B;;AKh30CA;EAA0B,gBAAA;ALo30C1B;;AKn30CA;EAA4B,gBAAA;ALu30C5B;;AKt30CA;EAA4B,gBAAA;AL030C5B;;AKz30CA;EAA4B,gBAAA;AL630C5B;;AK530CA;EAA4B,gBAAA;ALg40C5B;;AK/30CA;EAA4B,gBAAA;ALm40C5B;;AKl40CA;EAA4B,gBAAA;ALs40C5B;;AKr40CA;EAA4B,gBAAA;ALy40C5B;;AKx40CA;EAA4B,gBAAA;AL440C5B;;AK340CA;EAAmC,gBAAA;AL+40CnC;;AK940CA;EAAmC,gBAAA;ALk50CnC;;AKj50CA;EAA0B,gBAAA;ALq50C1B;;AKp50CA;EAA0B,gBAAA;ALw50C1B;;AKv50CA;EAA8B,gBAAA;AL250C9B;;AK150CA;EAA8B,gBAAA;AL850C9B;;AK750CA;EAA4B,gBAAA;ALi60C5B;;AKh60CA;EAA4B,gBAAA;ALo60C5B;;AKn60CA;EAA2B,gBAAA;ALu60C3B;;AKt60CA;EAA2B,gBAAA;AL060C3B;;AKz60CA;EAAkC,gBAAA;AL660ClC;;AK560CA;EAAkC,gBAAA;ALg70ClC;;AK/60CA;EAAgC,gBAAA;ALm70ChC;;AKl70CA;EAAgC,gBAAA;ALs70ChC;;AKr70CA;EAAuC,gBAAA;ALy70CvC;;AKx70CA;EAAuC,gBAAA;AL470CvC;;AK370CA;EAA2B,gBAAA;AL+70C3B;;AK970CA;EAA2B,gBAAA;ALk80C3B;;AKj80CA;EAA6B,gBAAA;ALq80C7B;;AKp80CA;EAA6B,gBAAA;ALw80C7B;;AKv80CA;EAAkC,gBAAA;AL280ClC;;AK180CA;EAAkC,gBAAA;AL880ClC;;AK780CA;EAAgC,gBAAA;ALi90ChC;;AKh90CA;EAAgC,gBAAA;ALo90ChC;;AKn90CA;EAA2B,gBAAA;ALu90C3B;;AKt90CA;EAA2B,gBAAA;AL090C3B;;AKz90CA;EAA8B,gBAAA;AL690C9B;;AK590CA;EAA8B,gBAAA;ALg+0C9B;;AK/90CA;EAAiC,gBAAA;ALm+0CjC;;AKl+0CA;EAAiC,gBAAA;ALs+0CjC;;AKr+0CA;EAA2B,gBAAA;ALy+0C3B;;AKx+0CA;EAA2B,gBAAA;AL4+0C3B;;AK3+0CA;EAA4B,gBAAA;AL++0C5B;;AK9+0CA;EAA4B,gBAAA;ALk/0C5B;;AKj/0CA;EAAyB,gBAAA;ALq/0CzB;;AKp/0CA;EAAyB,gBAAA;ALw/0CzB;;AKv/0CA;EAA2B,gBAAA;AL2/0C3B;;AK1/0CA;EAA2B,gBAAA;AL8/0C3B;;AK7/0CA;EAA2B,gBAAA;ALig1C3B;;AKhg1CA;EAA2B,gBAAA;ALog1C3B;;AKng1CA;EAA2B,gBAAA;ALug1C3B;;AKtg1CA;EAA2B,gBAAA;AL0g1C3B;;AKzg1CA;EAA2B,gBAAA;AL6g1C3B;;AK5g1CA;EAA2B,gBAAA;ALgh1C3B;;AK/g1CA;EAAyB,gBAAA;ALmh1CzB;;AKlh1CA;EAAyB,gBAAA;ALsh1CzB;;AKrh1CA;EAAsB,gBAAA;ALyh1CtB;;AKxh1CA;EAAsB,gBAAA;AL4h1CtB;;AK3h1CA;EAAsC,gBAAA;AL+h1CtC;;AK9h1CA;EAAsC,gBAAA;ALki1CtC;;AKji1CA;EAAmC,gBAAA;ALqi1CnC;;AKpi1CA;EAAmC,gBAAA;ALwi1CnC;;AKvi1CA;EAAsC,gBAAA;AL2i1CtC;;AK1i1CA;EAAsC,gBAAA;AL8i1CtC;;AK7i1CA;EAAsC,gBAAA;ALij1CtC;;AKhj1CA;EAAsC,gBAAA;ALoj1CtC;;AKnj1CA;EAAsC,gBAAA;ALuj1CtC;;AKtj1CA;EAAsC,gBAAA;AL0j1CtC;;AKzj1CA;EAAwC,gBAAA;AL6j1CxC;;AK5j1CA;EAAwC,gBAAA;ALgk1CxC;;AK/j1CA;EAA2B,gBAAA;ALmk1C3B;;AKlk1CA;EAA2B,gBAAA;ALsk1C3B;;AKrk1CA;EAAyB,gBAAA;ALyk1CzB;;AKxk1CA;EAAyB,gBAAA;AL4k1CzB;;AK3k1CA;EAAuB,gBAAA;AL+k1CvB;;AK9k1CA;EAAuB,gBAAA;ALkl1CvB;;AKjl1CA;EAAuB,gBAAA;ALql1CvB;;AKpl1CA;EAAuB,gBAAA;ALwl1CvB;;AKvl1CA;EAAsB,gBAAA;AL2l1CtB;;AK1l1CA;EAAsB,gBAAA;AL8l1CtB;;AK7l1CA;EAA2B,gBAAA;ALim1C3B;;AKhm1CA;EAA2B,gBAAA;ALom1C3B;;AKnm1CA;EAAyB,gBAAA;ALum1CzB;;AKtm1CA;EAAyB,gBAAA;AL0m1CzB;;AKzm1CA;EAAqC,gBAAA;AL6m1CrC;;AK5m1CA;EAAqC,gBAAA;ALgn1CrC;;AK/m1CA;EAAmC,gBAAA;ALmn1CnC;;AKln1CA;EAAmC,gBAAA;ALsn1CnC;;AKrn1CA;EAA8B,gBAAA;ALyn1C9B;;AKxn1CA;EAA8B,gBAAA;AL4n1C9B;;AK3n1CA;EAA8B,gBAAA;AL+n1C9B;;AK9n1CA;EAA8B,gBAAA;ALko1C9B;;AKjo1CA;EAA4B,gBAAA;ALqo1C5B;;AKpo1CA;EAA4B,gBAAA;ALwo1C5B;;AKvo1CA;EAA6B,gBAAA;AL2o1C7B;;AK1o1CA;EAA6B,gBAAA;AL8o1C7B;;AK7o1CA;EAA2B,gBAAA;ALip1C3B;;AKhp1CA;EAA2B,gBAAA;ALop1C3B;;AKnp1CA;EAAgC,gBAAA;ALup1ChC;;AKtp1CA;EAAgC,gBAAA;AL0p1ChC;;AKzp1CA;EAA8B,gBAAA;AL6p1C9B;;AK5p1CA;EAA8B,gBAAA;ALgq1C9B;;AK/p1CA;EAA+B,gBAAA;ALmq1C/B;;AKlq1CA;EAA+B,gBAAA;ALsq1C/B;;AKrq1CA;EAA+B,gBAAA;ALyq1C/B;;AKxq1CA;EAA+B,gBAAA;AL4q1C/B;;AK3q1CA;EAA+B,gBAAA;AL+q1C/B;;AK9q1CA;EAA+B,gBAAA;ALkr1C/B;;AKjr1CA;EAA+B,gBAAA;ALqr1C/B;;AKpr1CA;EAA+B,gBAAA;ALwr1C/B;;AKvr1CA;EAA+B,gBAAA;AL2r1C/B;;AK1r1CA;EAA+B,gBAAA;AL8r1C/B;;AK7r1CA;EAA+B,gBAAA;ALis1C/B;;AKhs1CA;EAA+B,gBAAA;ALos1C/B;;AKns1CA;EAA6B,gBAAA;ALus1C7B;;AKts1CA;EAA6B,gBAAA;AL0s1C7B;;AKzs1CA;EAA2B,gBAAA;AL6s1C3B;;AK5s1CA;EAAwB,gBAAA;ALgt1CxB;;AK/s1CA;EAAyB,gBAAA;ALmt1CzB;;AKlt1CA;EAAyB,gBAAA;ALst1CzB;;AKrt1CA;EAAiC,gBAAA;ALyt1CjC;;AKxt1CA;EAAiC,gBAAA;AL4t1CjC;;AK3t1CA;EAA2B,gBAAA;AL+t1C3B;;AK9t1CA;EAA2B,gBAAA;ALku1C3B;;AKju1CA;EAA4B,gBAAA;ALqu1C5B;;AKpu1CA;EAA4B,gBAAA;ALwu1C5B;;AKvu1CA;EAAuB,gBAAA;AL2u1CvB;;AK1u1CA;EAAuB,gBAAA;AL8u1CvB;;AK7u1CA;EAA0B,gBAAA;ALiv1C1B;;AKhv1CA;EAA0B,gBAAA;ALov1C1B;;AKnv1CA;EAA0B,gBAAA;ALuv1C1B;;AKtv1CA;EAA0B,gBAAA;AL0v1C1B;;AKzv1CA;EAA0B,gBAAA;AL6v1C1B;;AK5v1CA;EAA0B,gBAAA;ALgw1C1B;;AK/v1CA;EAAyB,gBAAA;ALmw1CzB;;AKlw1CA;EAAyB,gBAAA;ALsw1CzB;;AKrw1CA;EAAyB,gBAAA;ALyw1CzB;;AKxw1CA;EAAyB,gBAAA;AL4w1CzB;;AK3w1CA;EAA8B,gBAAA;AL+w1C9B;;AK9w1CA;EAA8B,gBAAA;ALkx1C9B;;AKjx1CA;EAA8B,gBAAA;ALqx1C9B;;AKpx1CA;EAA8B,gBAAA;ALwx1C9B;;AKvx1CA;EAAuB,gBAAA;AL2x1CvB;;AK1x1CA;EAAuB,gBAAA;AL8x1CvB;;AK7x1CA;EAAgC,gBAAA;ALiy1ChC;;AKhy1CA;EAAgC,gBAAA;ALoy1ChC;;AKny1CA;EAA4B,gBAAA;ALuy1C5B;;AKty1CA;EAA4B,gBAAA;AL0y1C5B;;AKzy1CA;EAA4B,gBAAA;AL6y1C5B;;AK5y1CA;EAA4B,gBAAA;ALgz1C5B;;AK/y1CA;EAA0B,gBAAA;ALmz1C1B;;AKlz1CA;EAA0B,gBAAA;ALsz1C1B;;AKrz1CA;EAAyB,gBAAA;ALyz1CzB;;AKxz1CA;EAAyB,gBAAA;AL4z1CzB;;AK3z1CA;EAA6B,gBAAA;AL+z1C7B;;AK9z1CA;EAA6B,gBAAA;ALk01C7B;;AKj01CA;EAA6B,gBAAA;ALq01C7B;;AKp01CA;EAA6B,gBAAA;ALw01C7B;;AKv01CA;EAAmC,gBAAA;AL201CnC;;AK101CA;EAAmC,gBAAA;AL801CnC;;AK701CA;EAAiC,gBAAA;ALi11CjC;;AKh11CA;EAAiC,gBAAA;ALo11CjC;;AKn11CA;EAA2B,gBAAA;ALu11C3B;;AKt11CA;EAA2B,gBAAA;AL011C3B;;AKz11CA;EAAwB,gBAAA;AL611CxB;;AK511CA;EAAwB,gBAAA;ALg21CxB;;AK/11CA;EAA4B,gBAAA;ALm21C5B;;AKl21CA;EAA4B,gBAAA;ALs21C5B;;AKr21CA;EAA8B,gBAAA;ALy21C9B;;AKx21CA;EAA8B,gBAAA;AL421C9B;;AK321CA;EAA4B,gBAAA;AL+21C5B;;AK921CA;EAA4B,gBAAA;ALk31C5B;;AKj31CA;EAA2B,gBAAA;ALq31C3B;;AKp31CA;EAA2B,gBAAA;ALw31C3B;;AKv31CA;EAAwB,gBAAA;AL231CxB;;AK131CA;EAAwB,gBAAA;AL831CxB;;AK731CA;EAA0B,gBAAA;ALi41C1B;;AKh41CA;EAA0B,gBAAA;ALo41C1B;;AKn41CA;EAAuB,gBAAA;ALu41CvB;;AKt41CA;EAAuB,gBAAA;AL041CvB;;AKz41CA;EAA0B,gBAAA;AL641C1B;;AK541CA;EAA0B,gBAAA;ALg51C1B;;AK/41CA;EAA6B,gBAAA;ALm51C7B;;AKl51CA;EAA6B,gBAAA;ALs51C7B;;AKr51CA;EAA6B,gBAAA;ALy51C7B;;AKx51CA;EAA6B,gBAAA;AL451C7B;;AK351CA;EAAqB,gBAAA;AL+51CrB;;AK951CA;EAAqB,gBAAA;ALk61CrB;;AKj61CA;EAAsB,gBAAA;ALq61CtB;;AKp61CA;EAAsB,gBAAA;ALw61CtB;;AKv61CA;EAA2B,gBAAA;AL261C3B;;AK161CA;EAA2B,gBAAA;AL861C3B;;AK761CA;EAAyB,gBAAA;ALi71CzB;;AKh71CA;EAAyB,gBAAA;ALo71CzB;;AKn71CA;EAAwB,gBAAA;ALu71CxB;;AKt71CA;EAAwB,gBAAA;AL071CxB;;AKz71CA;EAA6B,gBAAA;AL671C7B;;AK571CA;EAA6B,gBAAA;ALg81C7B;;AK/71CA;EAAuB,gBAAA;ALm81CvB;;AKl81CA;EAAuB,gBAAA;ALs81CvB;;AKr81CA;EAAyB,gBAAA;ALy81CzB;;AKx81CA;EAAyB,gBAAA;AL481CzB;;AK381CA;EAA2B,gBAAA;AL+81C3B;;AK981CA;EAA2B,gBAAA;ALk91C3B;;AKj91CA;EAA8B,gBAAA;ALq91C9B;;AKp91CA;EAA8B,gBAAA;ALw91C9B;;AKv91CA;EAAuB,gBAAA;AL291CvB;;AK191CA;EAAuB,gBAAA;AL891CvB;;AK791CA;EAAwB,gBAAA;ALi+1CxB;;AKh+1CA;EAAwB,gBAAA;ALo+1CxB;;AKn+1CA;EAA4B,gBAAA;ALu+1C5B;;AKt+1CA;EAA4B,gBAAA;AL0+1C5B;;AKz+1CA;EAA0B,gBAAA;AL6+1C1B;;AK5+1CA;EAAgC,gBAAA;ALg/1ChC;;AK/+1CA;EAAgC,gBAAA;ALm/1ChC;;AKl/1CA;EAAgC,gBAAA;ALs/1ChC;;AKr/1CA;EAAgC,gBAAA;ALy/1ChC;;AKx/1CA;EAA0B,gBAAA;AL4/1C1B;;AK3/1CA;EAAiC,gBAAA;AL+/1CjC;;AK9/1CA;EAAiC,gBAAA;ALkg2CjC;;AKjg2CA;EAA8B,gBAAA;ALqg2C9B;;AKpg2CA;EAA8B,gBAAA;ALwg2C9B;;AKvg2CA;EAAkC,gBAAA;AL2g2ClC;;AK1g2CA;EAAkC,gBAAA;AL8g2ClC;;AK7g2CA;EAA4B,gBAAA;ALih2C5B;;AKhh2CA;EAA4B,gBAAA;ALoh2C5B;;AKnh2CA;EAAyB,gBAAA;ALuh2CzB;;AKth2CA;EAAsB,gBAAA;AL0h2CtB;;AKzh2CA;EAA2B,gBAAA;AL6h2C3B;;AK5h2CA;EAA4B,gBAAA;ALgi2C5B;;AK/h2CA;EAA4B,gBAAA;ALmi2C5B;;AKli2CA;EAAyB,gBAAA;ALsi2CzB;;AKri2CA;EAAyB,gBAAA;ALyi2CzB;;AKxi2CA;EAAgC,gBAAA;AL4i2ChC;;AK3i2CA;EAAgC,gBAAA;AL+i2ChC;;AK9i2CA;EAA2B,gBAAA;ALkj2C3B;;AKjj2CA;EAA2B,gBAAA;ALqj2C3B;;AKpj2CA;EAA+B,gBAAA;ALwj2C/B;;AKvj2CA;EAA+B,gBAAA;AL2j2C/B;;AK1j2CA;EAA+B,gBAAA;AL8j2C/B;;AK7j2CA;EAA+B,gBAAA;ALik2C/B;;AKhk2CA;EAAkC,gBAAA;ALok2ClC;;AKnk2CA;EAAkC,gBAAA;ALuk2ClC;;AKtk2CA;EAA2B,gBAAA;AL0k2C3B;;AKzk2CA;EAAiC,gBAAA;AL6k2CjC;;AK5k2CA;EAAiC,gBAAA;ALgl2CjC;;AK/k2CA;EAA2B,gBAAA;ALml2C3B;;AKll2CA;EAAgC,gBAAA;ALsl2ChC;;AKrl2CA;EAAgC,gBAAA;ALyl2ChC;;AKxl2CA;EAAwB,gBAAA;AL4l2CxB;;AK3l2CA;EAAwB,gBAAA;AL+l2CxB;;AK9l2CA;EAA4B,gBAAA;ALkm2C5B;;AKjm2CA;EAA4B,gBAAA;ALqm2C5B;;AKpm2CA;EAAsB,gBAAA;ALwm2CtB;;AKvm2CA;EAAsB,gBAAA;AL2m2CtB;;AK1m2CA;EAA0B,gBAAA;AL8m2C1B;;AK7m2CA;EAA0B,gBAAA;ALin2C1B;;AKhn2CA;EAA+B,gBAAA;ALon2C/B;;AKnn2CA;EAA+B,gBAAA;ALun2C/B;;AKtn2CA;EAAkC,gBAAA;AL0n2ClC;;AKzn2CA;EAAkC,gBAAA;AL6n2ClC;;AK5n2CA;EAA2B,gBAAA;ALgo2C3B;;AK/n2CA;EAA2B,gBAAA;ALmo2C3B;;AKlo2CA;EAA6B,gBAAA;ALso2C7B;;AKro2CA;EAA6B,gBAAA;ALyo2C7B;;AKxo2CA;EAA2B,gBAAA;AL4o2C3B;;AK3o2CA;EAA2B,gBAAA;AL+o2C3B;;AK9o2CA;EAAyB,gBAAA;ALkp2CzB;;AKjp2CA;EAAyB,gBAAA;ALqp2CzB;;AKpp2CA;EAAyB,gBAAA;ALwp2CzB;;AKvp2CA;EAAyB,gBAAA;AL2p2CzB;;AK1p2CA;EAAyB,gBAAA;AL8p2CzB;;AK7p2CA;EAAyB,gBAAA;ALiq2CzB;;AKhq2CA;EAA2B,gBAAA;ALoq2C3B;;AKnq2CA;EAA2B,gBAAA;ALuq2C3B;;AKtq2CA;EAA+B,gBAAA;AL0q2C/B;;AKzq2CA;EAA+B,gBAAA;AL6q2C/B;;AK5q2CA;EAA6B,gBAAA;ALgr2C7B;;AK/q2CA;EAA6B,gBAAA;ALmr2C7B;;AKlr2CA;EAA6B,gBAAA;ALsr2C7B;;AKrr2CA;EAA6B,gBAAA;ALyr2C7B;;AKxr2CA;EAA4B,gBAAA;AL4r2C5B;;AK3r2CA;EAA4B,gBAAA;AL+r2C5B;;AK9r2CA;EAA8B,gBAAA;ALks2C9B;;AKjs2CA;EAA8B,gBAAA;ALqs2C9B;;AKps2CA;EAA4B,gBAAA;ALws2C5B;;AKvs2CA;EAA4B,gBAAA;AL2s2C5B;;AK1s2CA;EAA8B,gBAAA;AL8s2C9B;;AK7s2CA;EAA8B,gBAAA;ALit2C9B;;AKht2CA;EAAgC,gBAAA;ALot2ChC;;AKnt2CA;EAAgC,gBAAA;ALut2ChC;;AKtt2CA;EAA4B,gBAAA;AL0t2C5B;;AKzt2CA;EAA4B,gBAAA;AL6t2C5B;;AK5t2CA;EAA+B,gBAAA;ALgu2C/B;;AK/t2CA;EAA+B,gBAAA;ALmu2C/B;;AKlu2CA;EAA6B,gBAAA;ALsu2C7B;;AKru2CA;EAA6B,gBAAA;ALyu2C7B;;AKxu2CA;EAAuB,gBAAA;AL4u2CvB;;AK3u2CA;EAA8B,gBAAA;AL+u2C9B;;AK9u2CA;EAA8B,gBAAA;ALkv2C9B;;AKjv2CA;EAA2B,gBAAA;ALqv2C3B;;AKpv2CA;EAA2B,gBAAA;ALwv2C3B;;AKvv2CA;EAA+B,gBAAA;AL2v2C/B;;AK1v2CA;EAA+B,gBAAA;AL8v2C/B;;AK7v2CA;EAA2B,gBAAA;ALiw2C3B;;AKhw2CA;EAA2B,gBAAA;ALow2C3B;;AKnw2CA;EAA4B,gBAAA;ALuw2C5B;;AKtw2CA;EAA4B,gBAAA;AL0w2C5B;;AKzw2CA;EAAuB,gBAAA;AL6w2CvB;;AK5w2CA;EAA8B,gBAAA;ALgx2C9B;;AK/w2CA;EAA8B,gBAAA;ALmx2C9B;;AKlx2CA;EAA8B,gBAAA;ALsx2C9B;;AKrx2CA;EAA8B,gBAAA;ALyx2C9B;;AKxx2CA;EAA4B,gBAAA;AL4x2C5B;;AK3x2CA;EAA4B,gBAAA;AL+x2C5B;;AK9x2CA;EAA4B,gBAAA;ALky2C5B;;AKjy2CA;EAA4B,gBAAA;ALqy2C5B;;AKpy2CA;EAA4B,gBAAA;ALwy2C5B;;AKvy2CA;EAA4B,gBAAA;AL2y2C5B;;AK1y2CA;EAA6B,gBAAA;AL8y2C7B;;AK7y2CA;EAA6B,gBAAA;ALiz2C7B;;AKhz2CA;EAA+B,gBAAA;ALoz2C/B;;AKnz2CA;EAA+B,gBAAA;ALuz2C/B;;AKtz2CA;EAA6B,gBAAA;AL0z2C7B;;AKzz2CA;EAA6B,gBAAA;AL6z2C7B;;AK5z2CA;EAA2B,gBAAA;ALg02C3B;;AK/z2CA;EAA2B,gBAAA;ALm02C3B;;AKl02CA;EAA6B,gBAAA;ALs02C7B;;AKr02CA;EAA6B,gBAAA;ALy02C7B;;AKx02CA;EAA2B,gBAAA;AL402C3B;;AK302CA;EAA2B,gBAAA;AL+02C3B;;AK902CA;EAA8B,gBAAA;ALk12C9B;;AKj12CA;EAA8B,gBAAA;ALq12C9B;;AKp12CA;EAA8B,gBAAA;ALw12C9B;;AKv12CA;EAA8B,gBAAA;AL212C9B;;AK112CA;EAAgC,gBAAA;AL812ChC;;AK712CA;EAAgC,gBAAA;ALi22ChC;;AKh22CA;EAAgC,gBAAA;ALo22ChC;;AKn22CA;EAAgC,gBAAA;ALu22ChC;;AKt22CA;EAA8B,gBAAA;AL022C9B;;AKz22CA;EAA8B,gBAAA;AL622C9B;;AK522CA;EAA6B,gBAAA;ALg32C7B;;AK/22CA;EAA6B,gBAAA;ALm32C7B;;AKl32CA;EAA4B,gBAAA;ALs32C5B;;AKr32CA;EAA4B,gBAAA;ALy32C5B;;AKx32CA;EAAgC,gBAAA;AL432ChC;;AK332CA;EAAgC,gBAAA;AL+32ChC;;AK932CA;EAA8B,gBAAA;ALk42C9B;;AKj42CA;EAA8B,gBAAA;ALq42C9B;;AKp42CA;EAA8B,gBAAA;ALw42C9B;;AKv42CA;EAA8B,gBAAA;AL242C9B;;AK142CA;EAA4B,gBAAA;AL842C5B;;AK742CA;EAA4B,gBAAA;ALi52C5B;;AKh52CA;EAA+B,gBAAA;ALo52C/B;;AKn52CA;EAA+B,gBAAA;ALu52C/B;;AKt52CA;EAA8B,gBAAA;AL052C9B;;AKz52CA;EAA8B,gBAAA;AL652C9B;;AK552CA;EAA4B,gBAAA;ALg62C5B;;AK/52CA;EAA4B,gBAAA;ALm62C5B;;AKl62CA;EAA2B,gBAAA;ALs62C3B;;AKr62CA;EAA2B,gBAAA;ALy62C3B;;AKx62CA;EAAuB,gBAAA;AL462CvB;;AK362CA;EAAuB,gBAAA;AL+62CvB;;AK962CA;EAA2B,gBAAA;ALk72C3B;;AKj72CA;EAA2B,gBAAA;ALq72C3B;;AKp72CA;EAA2B,gBAAA;ALw72C3B;;AKv72CA;EAA2B,gBAAA;AL272C3B;;AK172CA;EAAyB,gBAAA;AL872CzB;;AK772CA;EAAyB,gBAAA;ALi82CzB;;AKh82CA;EAA6B,gBAAA;ALo82C7B;;AKn82CA;EAA6B,gBAAA;ALu82C7B;;AKt82CA;EAA+B,gBAAA;AL082C/B;;AKz82CA;EAA+B,gBAAA;AL682C/B;;AK582CA;EAAyB,gBAAA;ALg92CzB;;AK/82CA;EAAyB,gBAAA;ALm92CzB;;AKl92CA;EAAgC,gBAAA;ALs92ChC;;AKr92CA;EAAgC,gBAAA;ALy92ChC;;AKx92CA;EAA8B,gBAAA;AL492C9B;;AK392CA;EAA8B,gBAAA;AL+92C9B;;AK992CA;EAAuB,gBAAA;ALk+2CvB;;AKj+2CA;EAAuB,gBAAA;ALq+2CvB;;AKp+2CA;EAA0B,gBAAA;ALw+2C1B;;AKv+2CA;EAA0B,gBAAA;AL2+2C1B;;AK1+2CA;EAAgC,gBAAA;AL8+2ChC;;AK7+2CA;EAAgC,gBAAA;ALi/2ChC;;AKh/2CA;EAAyB,gBAAA;ALo/2CzB;;AKn/2CA;EAAyB,gBAAA;ALu/2CzB;;AKt/2CA;EAAuB,gBAAA;AL0/2CvB;;AKz/2CA;EAAuB,gBAAA;AL6/2CvB;;AK5/2CA;EAA6B,gBAAA;ALgg3C7B;;AK//2CA;EAA6B,gBAAA;ALmg3C7B;;AKlg3CA;EAAwB,gBAAA;ALsg3CxB;;AKrg3CA;EAAwB,gBAAA;ALyg3CxB;;AKxg3CA;EAA8B,gBAAA;AL4g3C9B;;AK3g3CA;EAA8B,gBAAA;AL+g3C9B;;AK9g3CA;EAAiC,gBAAA;ALkh3CjC;;AKjh3CA;EAAiC,gBAAA;ALqh3CjC;;AKph3CA;EAAwB,gBAAA;ALwh3CxB;;AKvh3CA;EAAwB,gBAAA;AL2h3CxB;;AK1h3CA;EAAwB,gBAAA;AL8h3CxB;;AK7h3CA;EAA0B,gBAAA;ALii3C1B;;AKhi3CA;EAA0B,gBAAA;ALoi3C1B;;AKni3CA;EAA0B,gBAAA;ALui3C1B;;AKti3CA;EAA0B,gBAAA;AL0i3C1B;;AKzi3CA;EAA0B,gBAAA;AL6i3C1B;;AK5i3CA;EAA0B,gBAAA;ALgj3C1B;;AK/i3CA;EAAwB,gBAAA;ALmj3CxB;;AKlj3CA;EAAwB,gBAAA;ALsj3CxB;;AKrj3CA;EAAwB,gBAAA;ALyj3CxB;;AKxj3CA;EAAwB,gBAAA;AL4j3CxB;;AK3j3CA;EAA2B,gBAAA;AL+j3C3B;;AK9j3CA;EAA2B,gBAAA;ALkk3C3B;;AKjk3CA;EAA2B,gBAAA;ALqk3C3B;;AKpk3CA;EAA2B,gBAAA;ALwk3C3B;;AKvk3CA;EAA2B,gBAAA;AL2k3C3B;;AK1k3CA;EAA2B,gBAAA;AL8k3C3B;;AK7k3CA;EAA2B,gBAAA;ALil3C3B;;AKhl3CA;EAA2B,gBAAA;ALol3C3B;;AKnl3CA;EAA6B,gBAAA;ALul3C7B;;AKtl3CA;EAA6B,gBAAA;AL0l3C7B;;AKzl3CA;EAAiC,gBAAA;AL6l3CjC;;AK5l3CA;EAAiC,gBAAA;ALgm3CjC;;AK/l3CA;EAA+B,gBAAA;ALmm3C/B;;AKlm3CA;EAA+B,gBAAA;ALsm3C/B;;AKrm3CA;EAAkC,gBAAA;ALym3ClC;;AKxm3CA;EAAkC,gBAAA;AL4m3ClC;;AK3m3CA;EAAyB,gBAAA;AL+m3CzB;;AK9m3CA;EAAgC,gBAAA;ALkn3ChC;;AKjn3CA;EAAgC,gBAAA;ALqn3ChC;;AKpn3CA;EAAiC,gBAAA;ALwn3CjC;;AKvn3CA;EAAiC,gBAAA;AL2n3CjC;;AK1n3CA;EAA8B,gBAAA;AL8n3C9B;;AK7n3CA;EAA8B,gBAAA;ALio3C9B;;AKho3CA;EAAiC,gBAAA;ALoo3CjC;;AKno3CA;EAAiC,gBAAA;ALuo3CjC;;AKto3CA;EAAyB,gBAAA;AL0o3CzB;;AKzo3CA;EAA8B,gBAAA;AL6o3C9B;;AK5o3CA;EAA8B,gBAAA;ALgp3C9B;;AK/o3CA;EAA+B,gBAAA;ALmp3C/B;;AKlp3CA;EAA+B,gBAAA;ALsp3C/B;;AKrp3CA;EAA8B,gBAAA;ALyp3C9B;;AKxp3CA;EAA8B,gBAAA;AL4p3C9B;;AK3p3CA;EAAkC,gBAAA;AL+p3ClC;;AK9p3CA;EAAkC,gBAAA;ALkq3ClC;;AKjq3CA;EAAgC,gBAAA;ALqq3ChC;;AKpq3CA;EAAgC,gBAAA;ALwq3ChC;;AKvq3CA;EAAkC,gBAAA;AL2q3ClC;;AK1q3CA;EAAkC,gBAAA;AL8q3ClC;;AK7q3CA;EAAgC,gBAAA;ALir3ChC;;AKhr3CA;EAAgC,gBAAA;ALor3ChC;;AKnr3CA;EAAkC,gBAAA;ALur3ClC;;AKtr3CA;EAAkC,gBAAA;AL0r3ClC;;AKzr3CA;EAAgC,gBAAA;AL6r3ChC;;AK5r3CA;EAAgC,gBAAA;ALgs3ChC;;AK/r3CA;EAAkC,gBAAA;ALms3ClC;;AKls3CA;EAAkC,gBAAA;ALss3ClC;;AKrs3CA;EAAgC,gBAAA;ALys3ChC;;AKxs3CA;EAAgC,gBAAA;AL4s3ChC;;AK3s3CA;EAAgC,gBAAA;AL+s3ChC;;AK9s3CA;EAAgC,gBAAA;ALkt3ChC;;AKjt3CA;EAA8B,gBAAA;ALqt3C9B;;AKpt3CA;EAA8B,gBAAA;ALwt3C9B;;AKvt3CA;EAAiC,gBAAA;AL2t3CjC;;AK1t3CA;EAAiC,gBAAA;AL8t3CjC;;AK7t3CA;EAA6B,gBAAA;ALiu3C7B;;AKhu3CA;EAA6B,gBAAA;ALou3C7B;;AKnu3CA;EAA0B,gBAAA;ALuu3C1B;;AKtu3CA;EAA0B,gBAAA;AL0u3C1B;;AKzu3CA;EAAwB,gBAAA;AL6u3CxB;;AK5u3CA;EAAyB,gBAAA;ALgv3CzB;;AK/u3CA;EAAuB,gBAAA;ALmv3CvB;;AKlv3CA;EAA2B,gBAAA;ALsv3C3B;;AKrv3CA;EAA2B,gBAAA;ALyv3C3B;;AKxv3CA;EAA4B,gBAAA;AL4v3C5B;;AK3v3CA;EAA4B,gBAAA;AL+v3C5B;;AK9v3CA;EAA2B,gBAAA;ALkw3C3B;;AKjw3CA;EAA2B,gBAAA;ALqw3C3B;;AKpw3CA;EAAyB,gBAAA;ALww3CzB;;AKvw3CA;EAAyB,gBAAA;AL2w3CzB;;AK1w3CA;EAA0B,gBAAA;AL8w3C1B;;AK7w3CA;EAAyB,gBAAA;ALix3CzB;;AKhx3CA;EAAyB,gBAAA;ALox3CzB;;AKnx3CA;EAAkC,gBAAA;ALux3ClC;;AKtx3CA;EAAkC,gBAAA;AL0x3ClC;;AKzx3CA;EAA6B,gBAAA;AL6x3C7B;;AK5x3CA;EAA6B,gBAAA;ALgy3C7B;;AK/x3CA;EAA2B,gBAAA;ALmy3C3B;;AKly3CA;EAA2B,gBAAA;ALsy3C3B;;AKry3CA;EAAuB,gBAAA;ALyy3CvB;;AKxy3CA;EAA4B,gBAAA;AL4y3C5B;;AK3y3CA;EAA4B,gBAAA;AL+y3C5B;;AK9y3CA;EAAwB,gBAAA;ALkz3CxB;;AKjz3CA;EAAwB,gBAAA;ALqz3CxB;;AKpz3CA;EAA0B,gBAAA;ALwz3C1B;;AKvz3CA;EAA0B,gBAAA;AL2z3C1B;;AK1z3CA;EAAiC,gBAAA;AL8z3CjC;;AK7z3CA;EAAiC,gBAAA;ALi03CjC;;AKh03CA;EAAuB,gBAAA;ALo03CvB;;AKn03CA;EAAuB,gBAAA;ALu03CvB;;AKt03CA;EAA0B,gBAAA;AL003C1B;;AKz03CA;EAA0B,gBAAA;AL603C1B;;AK503CA;EAA8B,gBAAA;ALg13C9B;;AK/03CA;EAA8B,gBAAA;ALm13C9B;;AKl13CA;EAAyB,gBAAA;ALs13CzB;;AKr13CA;EAAyB,gBAAA;ALy13CzB;;AKx13CA;EAA6B,gBAAA;AL413C7B;;AK313CA;EAA6B,gBAAA;AL+13C7B;;AK913CA;EAA0B,gBAAA;ALk23C1B;;AKj23CA;EAA0B,gBAAA;ALq23C1B;;AKp23CA;EAAwB,gBAAA;ALw23CxB;;AKv23CA;EAAwB,gBAAA;AL223CxB;;AK123CA;EAA8B,gBAAA;AL823C9B;;AK723CA;EAA8B,gBAAA;ALi33C9B;;AKh33CA;EAAyB,gBAAA;ALo33CzB;;AKn33CA;EAAyB,gBAAA;ALu33CzB;;AKt33CA;EAAuB,gBAAA;AL033CvB;;AKz33CA;EAAuB,gBAAA;AL633CvB;;AK533CA;EAA6B,gBAAA;ALg43C7B;;AK/33CA;EAA6B,gBAAA;ALm43C7B;;AKl43CA;EAA6B,gBAAA;ALs43C7B;;AKr43CA;EAA6B,gBAAA;ALy43C7B;;AKx43CA;EAA4B,gBAAA;AL443C5B;;AK343CA;EAA4B,gBAAA;AL+43C5B;;AK943CA;EAAmC,gBAAA;ALk53CnC;;AKj53CA;EAAmC,gBAAA;ALq53CnC;;AKp53CA;EAAyC,gBAAA;ALw53CzC;;AKv53CA;EAAyC,gBAAA;AL253CzC;;AK153CA;EAAiC,gBAAA;AL853CjC;;AK753CA;EAAiC,gBAAA;ALi63CjC;;AKh63CA;EAAyC,gBAAA;ALo63CzC;;AKn63CA;EAAyC,gBAAA;ALu63CzC;;AKt63CA;EAAyB,gBAAA;AL063CzB;;AKz63CA;EAAyB,gBAAA;AL663CzB;;AK563CA;EAAyB,gBAAA;ALg73CzB;;AK/63CA;EAAyB,gBAAA;ALm73CzB;;AKl73CA;EAAyB,gBAAA;ALs73CzB;;AKr73CA;EAAyB,gBAAA;ALy73CzB;;AKx73CA;EAAwB,gBAAA;AL473CxB;;AK373CA;EAAwB,gBAAA;AL+73CxB;;AK973CA;EAAyB,gBAAA;ALk83CzB;;AKj83CA;EAAyB,gBAAA;ALq83CzB;;AKp83CA;EAAyB,gBAAA;ALw83CzB;;AKv83CA;EAAyB,gBAAA;AL283CzB;;AK183CA;EAA8B,gBAAA;AL883C9B;;AK783CA;EAA8B,gBAAA;ALi93C9B;;AKh93CA;EAA6B,gBAAA;ALo93C7B;;AKn93CA;EAA6B,gBAAA;ALu93C7B;;AKt93CA;EAAsB,gBAAA;AL093CtB;;AKz93CA;EAAsB,gBAAA;AL693CtB;;AK593CA;EAA6B,gBAAA;ALg+3C7B;;AK/93CA;EAA6B,gBAAA;ALm+3C7B;;AKl+3CA;EAAuB,gBAAA;ALs+3CvB;;AKr+3CA;EAAuB,gBAAA;ALy+3CvB;;AKx+3CA;EAA0B,gBAAA;AL4+3C1B;;AK3+3CA;EAA0B,gBAAA;AL++3C1B;;AK9+3CA;EAAwB,gBAAA;ALk/3CxB;;AKj/3CA;EAAwB,gBAAA;ALq/3CxB;;AKp/3CA;EAAwB,gBAAA;ALw/3CxB;;AKv/3CA;EAAwB,gBAAA;AL2/3CxB;;AK1/3CA;EAAiB,gBAAA;AL8/3CjB;;AK7/3CA;EAAiB,gBAAA;ALig4CjB;;AKhg4CA;EAAiB,gBAAA;ALog4CjB;;AKng4CA;EAAiB,gBAAA;ALug4CjB;;AKtg4CA;EAAiB,gBAAA;AL0g4CjB;;AKzg4CA;EAAiB,gBAAA;AL6g4CjB;;AK5g4CA;EAAuB,gBAAA;ALgh4CvB;;AK/g4CA;EAAuB,gBAAA;ALmh4CvB;;AKlh4CA;EAAyB,gBAAA;ALsh4CzB;;AKrh4CA;EAAyB,gBAAA;ALyh4CzB;;AKxh4CA;EAA4B,gBAAA;AL4h4C5B;;AK3h4CA;EAA4B,gBAAA;AL+h4C5B;;AK9h4CA;EAA6B,gBAAA;ALki4C7B;;AKji4CA;EAA6B,gBAAA;ALqi4C7B;;AKpi4CA;EAAiC,gBAAA;ALwi4CjC;;AKvi4CA;EAAiC,gBAAA;AL2i4CjC;;AK1i4CA;EAA0B,gBAAA;AL8i4C1B;;AK7i4CA;EAA0B,gBAAA;ALij4C1B;;AKhj4CA;EAA+B,gBAAA;ALoj4C/B;;AKnj4CA;EAA+B,gBAAA;ALuj4C/B;;AKtj4CA;EAA6B,gBAAA;AL0j4C7B;;AKzj4CA;EAA6B,gBAAA;AL6j4C7B;;AK5j4CA;EAAqB,gBAAA;ALgk4CrB;;AK/j4CA;EAAyB,gBAAA;ALmk4CzB;;AKlk4CA;EAAyB,gBAAA;ALsk4CzB;;AKrk4CA;EAAuB,gBAAA;ALyk4CvB;;AKxk4CA;EAAuB,gBAAA;AL4k4CvB;;AK3k4CA;EAAqB,gBAAA;AL+k4CrB;;AK9k4CA;EAAqB,gBAAA;ALkl4CrB;;AKjl4CA;EAAqB,gBAAA;ALql4CrB;;AKpl4CA;EAA4B,gBAAA;ALwl4C5B;;AKvl4CA;EAA4B,gBAAA;AL2l4C5B;;AK1l4CA;EAA8B,gBAAA;AL8l4C9B;;AK7l4CA;EAA8B,gBAAA;ALim4C9B;;AKhm4CA;EAA0B,gBAAA;ALom4C1B;;AKnm4CA;EAA0B,gBAAA;ALum4C1B;;AKtm4CA;EAA0B,gBAAA;AL0m4C1B;;AKzm4CA;EAA0B,gBAAA;AL6m4C1B;;AK5m4CA;EAA4B,gBAAA;ALgn4C5B;;AK/m4CA;EAA4B,gBAAA;ALmn4C5B;;AKln4CA;EAAwB,gBAAA;ALsn4CxB;;AKrn4CA;EAAwB,gBAAA;ALyn4CxB;;AKxn4CA;EAA8B,gBAAA;AL4n4C9B;;AK3n4CA;EAA8B,gBAAA;AL+n4C9B;;AK9n4CA;EAAyB,gBAAA;ALko4CzB;;AKjo4CA;EAAyB,gBAAA;ALqo4CzB;;AKpo4CA;EAAgC,gBAAA;ALwo4ChC;;AKvo4CA;EAAgC,gBAAA;AL2o4ChC;;AK1o4CA;EAA0B,gBAAA;AL8o4C1B;;AK7o4CA;EAA0B,gBAAA;ALip4C1B;;AKhp4CA;EAAyB,gBAAA;ALop4CzB;;AKnp4CA;EAAyB,gBAAA;ALup4CzB;;AKtp4CA;EAAyB,gBAAA;AL0p4CzB;;AKzp4CA;EAAyB,gBAAA;AL6p4CzB;;AK5p4CA;EAAyB,gBAAA;ALgq4CzB;;AK/p4CA;EAAyB,gBAAA;ALmq4CzB;;AKlq4CA;EAAyB,gBAAA;ALsq4CzB;;AKrq4CA;EAAyB,gBAAA;ALyq4CzB;;AKxq4CA;EAAyB,gBAAA;AL4q4CzB;;AK3q4CA;EAAyB,gBAAA;AL+q4CzB;;AK9q4CA;EAAyB,gBAAA;ALkr4CzB;;AKjr4CA;EAAyB,gBAAA;ALqr4CzB;;AKpr4CA;EAAyB,gBAAA;ALwr4CzB;;AKvr4CA;EAAyB,gBAAA;AL2r4CzB;;AK1r4CA;EAAuB,gBAAA;AL8r4CvB;;AK7r4CA;EAA4B,gBAAA;ALis4C5B;;AKhs4CA;EAA4B,gBAAA;ALos4C5B;;AKns4CA;EAA6B,gBAAA;ALus4C7B;;AKts4CA;EAA6B,gBAAA;AL0s4C7B;;AKzs4CA;EAAuB,gBAAA;AL6s4CvB;;AK5s4CA;EAA+B,gBAAA;ALgt4C/B;;AK/s4CA;EAA+B,gBAAA;ALmt4C/B;;AKlt4CA;EAA6B,gBAAA;ALst4C7B;;AKrt4CA;EAA6B,gBAAA;ALyt4C7B;;AKxt4CA;EAA4B,gBAAA;AL4t4C5B;;AK3t4CA;EAA4B,gBAAA;AL+t4C5B;;AK9t4CA;EAAiC,gBAAA;ALku4CjC;;AKju4CA;EAAiC,gBAAA;ALqu4CjC;;AKpu4CA;EAAyB,gBAAA;ALwu4CzB;;AKvu4CA;EAAyB,gBAAA;AL2u4CzB;;AK1u4CA;EAA2B,gBAAA;AL8u4C3B;;AK7u4CA;EAA2B,gBAAA;ALiv4C3B;;AKhv4CA;EAA4B,gBAAA;ALov4C5B;;AKnv4CA;EAA4B,gBAAA;ALuv4C5B;;AKtv4CA;EAAwB,gBAAA;AL0v4CxB;;AKzv4CA;EAAwB,gBAAA;AL6v4CxB;;AK5v4CA;EAA0B,gBAAA;ALgw4C1B;;AK/v4CA;EAA0B,gBAAA;ALmw4C1B;;AKlw4CA;EAAqB,gBAAA;ALsw4CrB;;AKrw4CA;EAAqB,gBAAA;ALyw4CrB;;AKxw4CA;EAAwB,gBAAA;AL4w4CxB;;AK3w4CA;EAAwB,gBAAA;AL+w4CxB;;AK9w4CA;EAAqB,gBAAA;ALkx4CrB;;AKjx4CA;EAAqB,gBAAA;ALqx4CrB;;AKpx4CA;EAA0B,gBAAA;ALwx4C1B;;AKvx4CA;EAA0B,gBAAA;AL2x4C1B;;AK1x4CA;EAA4B,gBAAA;AL8x4C5B;;AK7x4CA;EAA4B,gBAAA;ALiy4C5B;;AKhy4CA;EAA6B,gBAAA;ALoy4C7B;;AKny4CA;EAA6B,gBAAA;ALuy4C7B;;AKty4CA;EAAwB,gBAAA;AL0y4CxB;;AKzy4CA;EAAwB,gBAAA;AL6y4CxB;;AK5y4CA;EAAgC,gBAAA;ALgz4ChC;;AK/y4CA;EAAgC,gBAAA;ALmz4ChC;;AKlz4CA;EAAwB,gBAAA;ALsz4CxB;;AKrz4CA;EAAwB,gBAAA;ALyz4CxB;;AKxz4CA;EAAkC,gBAAA;AL4z4ClC;;AK3z4CA;EAAkC,gBAAA;AL+z4ClC;;AK9z4CA;EAAoC,gBAAA;ALk04CpC;;AKj04CA;EAAoC,gBAAA;ALq04CpC;;AKp04CA;EAA6B,gBAAA;ALw04C7B;;AKv04CA;EAA6B,gBAAA;AL204C7B;;AK104CA;EAAuC,gBAAA;AL804CvC;;AK704CA;EAAuC,gBAAA;ALi14CvC;;AKh14CA;EAA8B,gBAAA;ALo14C9B;;AKn14CA;EAA8B,gBAAA;ALu14C9B;;AKt14CA;EAAuC,gBAAA;AL014CvC;;AKz14CA;EAAuC,gBAAA;AL614CvC;;AK514CA;EAA6B,gBAAA;ALg24C7B;;AK/14CA;EAA6B,gBAAA;ALm24C7B;;AKl24CA;EAA+B,gBAAA;ALs24C/B;;AKr24CA;EAA+B,gBAAA;ALy24C/B;;AKx24CA;EAA+B,gBAAA;AL424C/B;;AK324CA;EAAgC,gBAAA;AL+24ChC;;AK924CA;EAAiC,gBAAA;ALk34CjC;;AKj34CA;EAA+B,gBAAA;ALq34C/B;;AKp34CA;EAA4B,gBAAA;ALw34C5B;;AKv34CA;EAA4B,gBAAA;AL234C5B;;AK134CA;EAA4B,gBAAA;AL834C5B;;AK734CA;EAA0B,gBAAA;ALi44C1B;;AKh44CA;EAA0B,gBAAA;ALo44C1B;;AKn44CA;EAA2B,gBAAA;ALu44C3B;;AKt44CA;EAA2B,gBAAA;AL044C3B;;AKz44CA;EAAoB,gBAAA;AL644CpB;;AK544CA;EAA6B,gBAAA;ALg54C7B;;AK/44CA;EAA6B,gBAAA;ALm54C7B;;AKl54CA;EAAwB,gBAAA;ALs54CxB;;AKr54CA;EAAwB,gBAAA;ALy54CxB;;AKx54CA;EAAsB,gBAAA;AL454CtB;;AK354CA;EAAsB,gBAAA;AL+54CtB;;AK954CA;EAA+B,gBAAA;ALk64C/B;;AKj64CA;EAA+B,gBAAA;ALq64C/B;;AKp64CA;EAA2B,gBAAA;ALw64C3B;;AKv64CA;EAA2B,gBAAA;AL264C3B;;AK164CA;EAA0B,gBAAA;AL864C1B;;AK764CA;EAA0B,gBAAA;ALi74C1B;;AKh74CA;EAA8B,gBAAA;ALo74C9B;;AKn74CA;EAA8B,gBAAA;ALu74C9B;;AKt74CA;EAAwB,gBAAA;AL074CxB;;AKz74CA;EAAwB,gBAAA;AL674CxB;;AK574CA;EAA4B,gBAAA;ALg84C5B;;AK/74CA;EAA4B,gBAAA;ALm84C5B;;AKl84CA;EAA2B,gBAAA;ALs84C3B;;AKr84CA;EAA2B,gBAAA;ALy84C3B;;AKx84CA;EAA2B,gBAAA;AL484C3B;;AK384CA;EAA2B,gBAAA;AL+84C3B;;AK984CA;EAA2B,gBAAA;ALk94C3B;;AKj94CA;EAA2B,gBAAA;ALq94C3B;;AKp94CA;EAA2B,gBAAA;ALw94C3B;;AKv94CA;EAA2B,gBAAA;AL294C3B;;AK194CA;EAA2B,gBAAA;AL894C3B;;AK794CA;EAA2B,gBAAA;ALi+4C3B;;AKh+4CA;EAAkC,gBAAA;ALo+4ClC;;AKn+4CA;EAAkC,gBAAA;ALu+4ClC;;AKt+4CA;EAAgC,gBAAA;AL0+4ChC;;AKz+4CA;EAAgC,gBAAA;AL6+4ChC;;AK5+4CA;EAAgC,gBAAA;ALg/4ChC;;AK/+4CA;EAAgC,gBAAA;ALm/4ChC;;AKl/4CA;EAAyB,gBAAA;ALs/4CzB;;AKr/4CA;EAA8B,gBAAA;ALy/4C9B;;AKx/4CA;EAA8B,gBAAA;AL4/4C9B;;AK3/4CA;EAAgC,gBAAA;AL+/4ChC;;AK9/4CA;EAAgC,gBAAA;ALkg5ChC;;AKjg5CA;EAA8B,gBAAA;ALqg5C9B;;AKpg5CA;EAA8B,gBAAA;ALwg5C9B;;AKvg5CA;EAAyB,gBAAA;AL2g5CzB;;AK1g5CA;EAAiC,gBAAA;AL8g5CjC;;AK7g5CA;EAAiC,gBAAA;ALih5CjC;;AKhh5CA;EAAiC,gBAAA;ALoh5CjC;;AKnh5CA;EAAiC,gBAAA;ALuh5CjC;;AKth5CA;EAA+B,gBAAA;AL0h5C/B;;AKzh5CA;EAA+B,gBAAA;AL6h5C/B;;AK5h5CA;EAA6B,gBAAA;ALgi5C7B;;AK/h5CA;EAA6B,gBAAA;ALmi5C7B;;AKli5CA;EAA+B,gBAAA;ALsi5C/B;;AKri5CA;EAA+B,gBAAA;ALyi5C/B;;AKxi5CA;EAA6B,gBAAA;AL4i5C7B;;AK3i5CA;EAA6B,gBAAA;AL+i5C7B;;AK9i5CA;EAAuB,gBAAA;ALkj5CvB;;AKjj5CA;EAAuB,gBAAA;ALqj5CvB;;AKpj5CA;EAA2B,gBAAA;ALwj5C3B;;AKvj5CA;EAA2B,gBAAA;AL2j5C3B;;AK1j5CA;EAA4B,gBAAA;AL8j5C5B;;AK7j5CA;EAAkC,gBAAA;ALik5ClC;;AKhk5CA;EAAkC,gBAAA;ALok5ClC;;AKnk5CA;EAA4B,gBAAA;ALuk5C5B;;AKtk5CA;EAA6B,gBAAA;AL0k5C7B;;AKzk5CA;EAA6B,gBAAA;AL6k5C7B;;AK5k5CA;EAAuB,gBAAA;ALgl5CvB;;AK/k5CA;EAAyB,gBAAA;ALml5CzB;;AKll5CA;EAAuB,gBAAA;ALsl5CvB;;AKrl5CA;EAAoB,gBAAA;ALyl5CpB;;AKxl5CA;EAA2B,gBAAA;AL4l5C3B;;AK3l5CA;EAAyB,gBAAA;AL+l5CzB;;AK9l5CA;EAAkB,gBAAA;ALkm5ClB;;AKjm5CA;EAA+B,gBAAA;ALqm5C/B;;AKpm5CA;EAA+B,gBAAA;ALwm5C/B;;AKvm5CA;EAA2B,gBAAA;AL2m5C3B;;AK1m5CA;EAA2B,gBAAA;AL8m5C3B;;AK7m5CA;EAAwB,gBAAA;ALin5CxB;;AKhn5CA;EAAwB,gBAAA;ALon5CxB;;AKnn5CA;EAA0B,gBAAA;ALun5C1B;;AKtn5CA;EAAwB,gBAAA;AL0n5CxB;;AKzn5CA;EAA0B,gBAAA;AL6n5C1B;;AK5n5CA;EAAgC,gBAAA;ALgo5ChC;;AK/n5CA;EAAgC,gBAAA;ALmo5ChC;;AKlo5CA;EAA4B,gBAAA;ALso5C5B;;AKro5CA;EAAuB,gBAAA;ALyo5CvB;;AKxo5CA;EAAuB,gBAAA;AL4o5CvB;;AK3o5CA;EAA2B,gBAAA;AL+o5C3B;;AK9o5CA;EAA2B,gBAAA;ALkp5C3B;;AKjp5CA;EAA2B,gBAAA;ALqp5C3B;;AKpp5CA;EAA2B,gBAAA;ALwp5C3B;;AKvp5CA;EAA2B,gBAAA;AL2p5C3B;;AK1p5CA;EAA2B,gBAAA;AL8p5C3B;;AK7p5CA;EAA2B,gBAAA;ALiq5C3B;;AKhq5CA;EAA2B,gBAAA;ALoq5C3B;;AKnq5CA;EAAyB,gBAAA;ALuq5CzB;;AKtq5CA;EAAyB,gBAAA;AL0q5CzB;;AKzq5CA;EAAyB,gBAAA;AL6q5CzB;;AK5q5CA;EAAyB,gBAAA;ALgr5CzB;;AK/q5CA;EAAuB,gBAAA;ALmr5CvB;;AKlr5CA;EAAuB,gBAAA;ALsr5CvB;;AKrr5CA;EAAgC,gBAAA;ALyr5ChC;;AKxr5CA;EAAgC,gBAAA;AL4r5ChC;;AK3r5CA;EAA8B,gBAAA;AL+r5C9B;;AK9r5CA;EAA8B,gBAAA;ALks5C9B;;AKjs5CA;EAA4B,gBAAA;ALqs5C5B;;AKps5CA;EAA4B,gBAAA;ALws5C5B;;AKvs5CA;EAA+B,gBAAA;AL2s5C/B;;AK1s5CA;EAA+B,gBAAA;AL8s5C/B;;AK7s5CA;EAA6B,gBAAA;ALit5C7B;;AKht5CA;EAA6B,gBAAA;ALot5C7B;;AKnt5CA;EAA+B,gBAAA;ALut5C/B;;AKtt5CA;EAA+B,gBAAA;AL0t5C/B;;AKzt5CA;EAAgC,gBAAA;AL6t5ChC;;AK5t5CA;EAAgC,gBAAA;ALgu5ChC;;AK/t5CA;EAAkC,gBAAA;ALmu5ClC;;AKlu5CA;EAAkC,gBAAA;ALsu5ClC;;AKru5CA;EAA+B,gBAAA;ALyu5C/B;;AKxu5CA;EAA+B,gBAAA;AL4u5C/B;;AK3u5CA;EAAkC,gBAAA;AL+u5ClC;;AK9u5CA;EAAkC,gBAAA;ALkv5ClC;;AKjv5CA;EAAwB,gBAAA;ALqv5CxB;;AKpv5CA;EAAwB,gBAAA;ALwv5CxB;;AKvv5CA;EAAsB,gBAAA;AL2v5CtB;;AK1v5CA;EAAsB,gBAAA;AL8v5CtB;;AK7v5CA;EAA0B,gBAAA;ALiw5C1B;;AKhw5CA;EAA0B,gBAAA;ALow5C1B;;AKnw5CA;EAAwB,gBAAA;ALuw5CxB;;AKtw5CA;EAAwB,gBAAA;AL0w5CxB;;AKzw5CA;EAA2B,gBAAA;AL6w5C3B;;AK5w5CA;EAA2B,gBAAA;ALgx5C3B;;AK/w5CA;EAA6B,gBAAA;ALmx5C7B;;AKlx5CA;EAA6B,gBAAA;ALsx5C7B;;AKrx5CA;EAA6B,gBAAA;ALyx5C7B;;AKxx5CA;EAA6B,gBAAA;AL4x5C7B;;AK3x5CA;EAAgC,gBAAA;AL+x5ChC;;AK9x5CA;EAAgC,gBAAA;ALky5ChC;;AKjy5CA;EAAuB,gBAAA;ALqy5CvB;;AKpy5CA;EAA8B,gBAAA;ALwy5C9B;;AKvy5CA;EAA8B,gBAAA;AL2y5C9B;;AK1y5CA;EAAuB,gBAAA;AL8y5CvB;;AK7y5CA;EAA4B,gBAAA;ALiz5C5B;;AKhz5CA;EAA4B,gBAAA;ALoz5C5B;;AKnz5CA;EAA4B,gBAAA;ALuz5C5B;;AKtz5CA;EAA4B,gBAAA;AL0z5C5B;;AKzz5CA;EAA4B,gBAAA;AL6z5C5B;;AK5z5CA;EAA4B,gBAAA;ALg05C5B;;AK/z5CA;EAAgC,gBAAA;ALm05ChC;;AKl05CA;EAAgC,gBAAA;ALs05ChC;;AKr05CA;EAA4B,gBAAA;ALy05C5B;;AKx05CA;EAA4B,gBAAA;AL405C5B;;AK305CA;EAA8B,gBAAA;AL+05C9B;;AK905CA;EAA8B,gBAAA;ALk15C9B;;AKj15CA;EAA8B,gBAAA;ALq15C9B;;AKp15CA;EAA8B,gBAAA;ALw15C9B;;AKv15CA;EAAwB,gBAAA;AL215CxB;;AK115CA;EAAwB,gBAAA;AL815CxB;;AK715CA;EAAsB,gBAAA;ALi25CtB;;AKh25CA;EAAsB,gBAAA;ALo25CtB;;AKn25CA;EAA4B,gBAAA;ALu25C5B;;AKt25CA;EAA4B,gBAAA;AL025C5B;;AKz25CA;EAA4B,gBAAA;AL625C5B;;AK525CA;EAA4B,gBAAA;ALg35C5B;;AK/25CA;EAA4B,gBAAA;ALm35C5B;;AKl35CA;EAA4B,gBAAA;ALs35C5B;;AKr35CA;EAA4B,gBAAA;ALy35C5B;;AKx35CA;EAA4B,gBAAA;AL435C5B;;AK335CA;EAA8B,gBAAA;AL+35C9B;;AK935CA;EAA8B,gBAAA;ALk45C9B;;AKj45CA;EAA0B,gBAAA;ALq45C1B;;AKp45CA;EAA0B,gBAAA;ALw45C1B;;AKv45CA;EAAgC,gBAAA;AL245ChC;;AK145CA;EAAgC,gBAAA;AL845ChC;;AK745CA;EAA+B,gBAAA;ALi55C/B;;AKh55CA;EAA+B,gBAAA;ALo55C/B;;AKn55CA;EAA+B,gBAAA;ALu55C/B;;AKt55CA;EAA+B,gBAAA;AL055C/B;;AKz55CA;EAA2B,gBAAA;AL655C3B;;AK555CA;EAA2B,gBAAA;ALg65C3B;;AK/55CA;EAA2B,gBAAA;ALm65C3B;;AKl65CA;EAA2B,gBAAA;ALs65C3B;;AKr65CA;EAAyB,gBAAA;ALy65CzB;;AKx65CA;EAAyB,gBAAA;AL465CzB;;AK365CA;EAA6B,gBAAA;AL+65C7B;;AK965CA;EAA6B,gBAAA;ALk75C7B;;AKj75CA;EAA2B,gBAAA;ALq75C3B;;AKp75CA;EAA2B,gBAAA;ALw75C3B;;AKv75CA;EAA0B,gBAAA;AL275C1B;;AK175CA;EAA0B,gBAAA;AL875C1B;;AK775CA;EAAwB,gBAAA;ALi85CxB;;AKh85CA;EAAwB,gBAAA;ALo85CxB;;AKn85CA;EAAkC,gBAAA;ALu85ClC;;AKt85CA;EAAkC,gBAAA;AL085ClC;;AKz85CA;EAAyB,gBAAA;AL685CzB;;AK585CA;EAAyB,gBAAA;ALg95CzB;;AK/85CA;EAAsB,gBAAA;ALm95CtB;;AKl95CA;EAAsB,gBAAA;ALs95CtB;;AKr95CA;EAAgC,gBAAA;ALy95ChC;;AKx95CA;EAAgC,gBAAA;AL495ChC;;AK395CA;EAAyB,gBAAA;AL+95CzB;;AK995CA;EAAyB,gBAAA;ALk+5CzB;;AKj+5CA;EAAyB,gBAAA;ALq+5CzB;;AKp+5CA;EAAyB,gBAAA;ALw+5CzB;;AKv+5CA;EAAyB,gBAAA;AL2+5CzB;;AK1+5CA;EAAyB,gBAAA;AL8+5CzB;;AK7+5CA;EAAyB,gBAAA;ALi/5CzB;;AKh/5CA;EAAyB,gBAAA;ALo/5CzB;;AKn/5CA;EAA2B,gBAAA;ALu/5C3B;;AKt/5CA;EAA2B,gBAAA;AL0/5C3B;;AKz/5CA;EAAuB,gBAAA;AL6/5CvB;;AK5/5CA;EAA4B,gBAAA;ALgg6C5B;;AK//5CA;EAA4B,gBAAA;ALmg6C5B;;AKlg6CA;EAAuB,gBAAA;ALsg6CvB;;AKrg6CA;EAA8B,gBAAA;ALyg6C9B;;AKxg6CA;EAA8B,gBAAA;AL4g6C9B;;AK3g6CA;EAAoC,gBAAA;AL+g6CpC;;AK9g6CA;EAAkC,gBAAA;ALkh6ClC;;AKjh6CA;EAA4B,gBAAA;ALqh6C5B;;AKph6CA;EAA4B,gBAAA;ALwh6C5B;;AKvh6CA;EAA4B,gBAAA;AL2h6C5B;;AK1h6CA;EAA4B,gBAAA;AL8h6C5B;;AK7h6CA;EAA0B,gBAAA;ALii6C1B;;AKhi6CA;EAA0B,gBAAA;ALoi6C1B;;AKni6CA;EAA4B,gBAAA;ALui6C5B;;AKti6CA;EAA4B,gBAAA;AL0i6C5B;;AKzi6CA;EAAyB,gBAAA;AL6i6CzB;;AK5i6CA;EAAyB,gBAAA;ALgj6CzB;;AK/i6CA;EAAwB,gBAAA;ALmj6CxB;;AKlj6CA;EAAwB,gBAAA;ALsj6CxB;;AKrj6CA;EAAsB,gBAAA;ALyj6CtB;;AKxj6CA;EAAsB,gBAAA;AL4j6CtB;;AK3j6CA;EAA0B,gBAAA;AL+j6C1B;;AK9j6CA;EAA0B,gBAAA;ALkk6C1B;;AKjk6CA;EAAyB,gBAAA;ALqk6CzB;;AKpk6CA;EAAyB,gBAAA;ALwk6CzB;;AKvk6CA;EAA6B,gBAAA;AL2k6C7B;;AK1k6CA;EAA6B,gBAAA;AL8k6C7B;;AK7k6CA;EAA4B,gBAAA;ALil6C5B;;AKhl6CA;EAA4B,gBAAA;ALol6C5B;;AKnl6CA;EAAsB,gBAAA;ALul6CtB;;AKtl6CA;EAA+B,gBAAA;AL0l6C/B;;AKzl6CA;EAA+B,gBAAA;AL6l6C/B;;AK5l6CA;EAAuB,gBAAA;ALgm6CvB;;AK/l6CA;EAAuB,gBAAA;ALmm6CvB;;AKlm6CA;EAAgC,gBAAA;ALsm6ChC;;AKrm6CA;EAAgC,gBAAA;ALym6ChC;;AKxm6CA;EAAmC,gBAAA;AL4m6CnC;;AK3m6CA;EAAmC,gBAAA;AL+m6CnC;;AK9m6CA;EAAmC,gBAAA;ALkn6CnC;;AKjn6CA;EAAmC,gBAAA;ALqn6CnC;;AKpn6CA;EAAsC,gBAAA;ALwn6CtC;;AKvn6CA;EAAsC,gBAAA;AL2n6CtC;;AK1n6CA;EAAiC,gBAAA;AL8n6CjC;;AK7n6CA;EAAiC,gBAAA;ALio6CjC;;AKho6CA;EAAoC,gBAAA;ALoo6CpC;;AKno6CA;EAAoC,gBAAA;ALuo6CpC;;AKto6CA;EAAkC,gBAAA;AL0o6ClC;;AKzo6CA;EAAkC,gBAAA;AL6o6ClC;;AK5o6CA;EAAqC,gBAAA;ALgp6CrC;;AK/o6CA;EAAqC,gBAAA;ALmp6CrC;;AKlp6CA;EAA6B,gBAAA;ALsp6C7B;;AKrp6CA;EAA6B,gBAAA;ALyp6C7B;;AKxp6CA;EAA8B,gBAAA;AL4p6C9B;;AK3p6CA;EAA8B,gBAAA;AL+p6C9B;;AK9p6CA;EAAuB,gBAAA;ALkq6CvB;;AKjq6CA;EAA6B,gBAAA;ALqq6C7B;;AKpq6CA;EAA6B,gBAAA;ALwq6C7B;;AKvq6CA;EAAuB,gBAAA;AL2q6CvB;;AK1q6CA;EAAyB,gBAAA;AL8q6CzB;;AK7q6CA;EAAyB,gBAAA;ALir6CzB;;AKhr6CA;EAAuB,gBAAA;ALor6CvB;;AKnr6CA;EAAuB,gBAAA;ALur6CvB;;AKtr6CA;EAA4B,gBAAA;AL0r6C5B;;AKzr6CA;EAA4B,gBAAA;AL6r6C5B;;AK5r6CA;EAAwB,gBAAA;ALgs6CxB;;AK/r6CA;EAAwB,gBAAA;ALms6CxB;;AKls6CA;EAA0B,gBAAA;ALss6C1B;;AKrs6CA;EAA0B,gBAAA;ALys6C1B;;AKxs6CA;EAAwB,gBAAA;AL4s6CxB;;AK3s6CA;EAAwB,gBAAA;AL+s6CxB;;AK9s6CA;EAA0B,gBAAA;ALkt6C1B;;AKjt6CA;EAA0B,gBAAA;ALqt6C1B;;AKpt6CA;EAAwB,gBAAA;ALwt6CxB;;AKvt6CA;EAAwB,gBAAA;AL2t6CxB;;AK1t6CA;EAAqB,gBAAA;AL8t6CrB;;AK7t6CA;EAAqB,gBAAA;ALiu6CrB;;AKhu6CA;EAA6B,gBAAA;ALou6C7B;;AKnu6CA;EAA6B,gBAAA;ALuu6C7B;;AKtu6CA;EAAsC,gBAAA;AL0u6CtC;;AKzu6CA;EAAsC,gBAAA;AL6u6CtC;;AK5u6CA;EAA0B,gBAAA;ALgv6C1B;;AK/u6CA;EAA0B,gBAAA;ALmv6C1B;;AKlv6CA;EAA4B,gBAAA;ALsv6C5B;;AKrv6CA;EAA4B,gBAAA;ALyv6C5B;;AKxv6CA;EAAuB,gBAAA;AL4v6CvB;;AK3v6CA;EAAiC,gBAAA;AL+v6CjC;;AK9v6CA;EAAiC,gBAAA;ALkw6CjC;;AKjw6CA;EAAiC,gBAAA;ALqw6CjC;;AKpw6CA;EAAiC,gBAAA;ALww6CjC;;AKvw6CA;EAAiC,gBAAA;AL2w6CjC;;AK1w6CA;EAAiC,gBAAA;AL8w6CjC;;AK7w6CA;EAAqC,gBAAA;ALix6CrC;;AKhx6CA;EAAqC,gBAAA;ALox6CrC;;AKnx6CA;EAA+B,gBAAA;ALux6C/B;;AKtx6CA;EAA+B,gBAAA;AL0x6C/B;;AKzx6CA;EAAmC,gBAAA;AL6x6CnC;;AK5x6CA;EAAmC,gBAAA;ALgy6CnC;;AK/x6CA;EAAwB,gBAAA;ALmy6CxB;;AKly6CA;EAAwB,gBAAA;ALsy6CxB;;AKry6CA;EAAsB,gBAAA;ALyy6CtB;;AKxy6CA;EAAsB,gBAAA;AL4y6CtB;;AK3y6CA;EAAsB,gBAAA;AL+y6CtB;;AK9y6CA;EAAsB,gBAAA;ALkz6CtB;;AKjz6CA;EAAsB,gBAAA;ALqz6CtB;;AKpz6CA;EAAsB,gBAAA;ALwz6CtB;;AKvz6CA;EAAsB,gBAAA;AL2z6CtB;;AK1z6CA;EAAsB,gBAAA;AL8z6CtB;;AK7z6CA;EAAsB,gBAAA;ALi06CtB;;AKh06CA;EAAsB,gBAAA;ALo06CtB;;AKn06CA;EAA0B,gBAAA;ALu06C1B;;AKt06CA;EAA0B,gBAAA;AL006C1B;;AKz06CA;EAAwB,gBAAA;AL606CxB;;AK506CA;EAAwB,gBAAA;ALg16CxB;;AK/06CA;EAAsB,gBAAA;ALm16CtB;;AKl16CA;EAAsB,gBAAA;ALs16CtB;;AKr16CA;EAAmB,gBAAA;ALy16CnB;;AKx16CA;EAA2B,gBAAA;AL416C3B;;AK316CA;EAA2B,gBAAA;AL+16C3B;;AK916CA;EAA8B,gBAAA;ALk26C9B;;AKj26CA;EAA8B,gBAAA;ALq26C9B;;AKp26CA;EAAwB,gBAAA;ALw26CxB;;AKv26CA;EAAwB,gBAAA;AL226CxB;;AK126CA;EAA6B,gBAAA;AL826C7B;;AK726CA;EAA6B,gBAAA;ALi36C7B;;AKh36CA;EAAgC,gBAAA;ALo36ChC;;AKn36CA;EAA2B,gBAAA;ALu36C3B;;AKt36CA;EAA2B,gBAAA;AL036C3B;;AKz36CA;EAAyB,gBAAA;AL636CzB;;AK536CA;EAAyB,gBAAA;ALg46CzB;;AK/36CA;EAA4B,gBAAA;ALm46C5B;;AKl46CA;EAAwB,gBAAA;ALs46CxB;;AKr46CA;EAAwB,gBAAA;ALy46CxB;;AKx46CA;EAA8B,gBAAA;AL446C9B;;AK346CA;EAA8B,gBAAA;AL+46C9B;;AK946CA;EAAwB,gBAAA;ALk56CxB;;AKj56CA;EAAwB,gBAAA;ALq56CxB;;AKp56CA;EAA0B,gBAAA;ALw56C1B;;AKv56CA;EAA0B,gBAAA;AL256C1B;;AK156CA;EAA0B,gBAAA;AL856C1B;;AK756CA;EAA0B,gBAAA;ALi66C1B;;AKh66CA;EAAuB,gBAAA;ALo66CvB;;AKn66CA;EAAyB,gBAAA;ALu66CzB;;AKt66CA;EAAyB,gBAAA;AL066CzB;;AKz66CA;EAA8B,gBAAA;AL666C9B;;AK566CA;EAA8B,gBAAA;ALg76C9B;;AK/66CA;EAA8B,gBAAA;ALm76C9B;;AKl76CA;EAA8B,gBAAA;ALs76C9B;;AKr76CA;EAA0B,gBAAA;ALy76C1B;;AKx76CA;EAA0B,gBAAA;AL476C1B;;AK376CA;EAA2B,gBAAA;AL+76C3B;;AK976CA;EAA2B,gBAAA;ALk86C3B;;AKj86CA;EAA0B,gBAAA;ALq86C1B;;AKp86CA;EAA0B,gBAAA;ALw86C1B;;AKv86CA;EAA+B,gBAAA;AL286C/B;;AK186CA;EAA+B,gBAAA;AL886C/B;;AK786CA;EAAwB,gBAAA;ALi96CxB;;AKh96CA;EAAwB,gBAAA;ALo96CxB;;AKn96CA;EAA6B,gBAAA;ALu96C7B;;AKt96CA;EAA6B,gBAAA;AL096C7B;;AKz96CA;EAAyB,gBAAA;AL696CzB;;AK596CA;EAAyB,gBAAA;ALg+6CzB;;AK/96CA;EAA0B,gBAAA;ALm+6C1B;;AKl+6CA;EAA0B,gBAAA;ALs+6C1B;;AKr+6CA;EAAyB,gBAAA;ALy+6CzB;;AKx+6CA;EAAyB,gBAAA;AL4+6CzB;;AK3+6CA;EAAiC,gBAAA;AL++6CjC;;AK9+6CA;EAAiC,gBAAA;ALk/6CjC;;AKj/6CA;EAA+B,gBAAA;ALq/6C/B;;AKp/6CA;EAA+B,gBAAA;ALw/6C/B;;AKv/6CA;EAA0B,gBAAA;AL2/6C1B;;AK1/6CA;EAA0B,gBAAA;AL8/6C1B;;AK7/6CA;EAA+B,gBAAA;ALig7C/B;;AKhg7CA;EAA+B,gBAAA;ALog7C/B;;AKng7CA;EAAwB,gBAAA;ALug7CxB;;AKtg7CA;EAA6B,gBAAA;AL0g7C7B;;AKzg7CA;EAA6B,gBAAA;AL6g7C7B;;AK5g7CA;EAAwB,gBAAA;ALgh7CxB;;AK/g7CA;EAA6B,gBAAA;ALmh7C7B;;AKlh7CA;EAA6B,gBAAA;ALsh7C7B;;AKrh7CA;EAAuC,gBAAA;ALyh7CvC;;AKxh7CA;EAAuC,gBAAA;AL4h7CvC;;AK3h7CA;EAA0C,gBAAA;AL+h7C1C;;AK9h7CA;EAA0C,gBAAA;ALki7C1C;;AKji7CA;EAAqC,gBAAA;ALqi7CrC;;AKpi7CA;EAAqC,gBAAA;ALwi7CrC;;AKvi7CA;EAA8B,gBAAA;AL2i7C9B;;AK1i7CA;EAA8B,gBAAA;AL8i7C9B;;AK7i7CA;EAAgC,gBAAA;ALij7ChC;;AKhj7CA;EAAgC,gBAAA;ALoj7ChC;;AKnj7CA;EAA4B,gBAAA;ALuj7C5B;;AKtj7CA;EAA4B,gBAAA;AL0j7C5B;;AKzj7CA;EAA+B,gBAAA;AL6j7C/B;;AK5j7CA;EAA+B,gBAAA;ALgk7C/B;;AK/j7CA;EAA4B,gBAAA;ALmk7C5B;;AKlk7CA;EAA4B,gBAAA;ALsk7C5B;;AKrk7CA;EAA4B,gBAAA;ALyk7C5B;;AKxk7CA;EAA4B,gBAAA;AL4k7C5B;;AK3k7CA;EAA0B,gBAAA;AL+k7C1B;;AK9k7CA;EAA2B,gBAAA;ALkl7C3B;;AKjl7CA;EAA2B,gBAAA;ALql7C3B;;AKpl7CA;EAAwB,gBAAA;ALwl7CxB;;AKvl7CA;EAAwB,gBAAA;AL2l7CxB;;AK1l7CA;EAAwB,gBAAA;AL8l7CxB;;AK7l7CA;EAAwB,gBAAA;ALim7CxB;;AKhm7CA;EAA8B,gBAAA;ALom7C9B;;AKnm7CA;EAA8B,gBAAA;ALum7C9B;;AKtm7CA;EAAuB,gBAAA;AL0m7CvB;;AKzm7CA;EAAuB,gBAAA;AL6m7CvB;;AK5m7CA;EAA8B,gBAAA;ALgn7C9B;;AK/m7CA;EAA8B,gBAAA;ALmn7C9B;;AKln7CA;EAAgC,gBAAA;ALsn7ChC;;AKrn7CA;EAAgC,gBAAA;ALyn7ChC;;AKxn7CA;EAA4B,gBAAA;AL4n7C5B;;AK3n7CA;EAA4B,gBAAA;AL+n7C5B;;AK9n7CA;EAA4B,gBAAA;ALko7C5B;;AKjo7CA;EAA4B,gBAAA;ALqo7C5B;;AKpo7CA;EAA8B,gBAAA;ALwo7C9B;;AKvo7CA;EAA8B,gBAAA;AL2o7C9B;;AK1o7CA;EAAyB,gBAAA;AL8o7CzB;;AK7o7CA;EAAyB,gBAAA;ALip7CzB;;AKhp7CA;EAAuB,gBAAA;ALop7CvB;;AKnp7CA;EAAuB,gBAAA;ALup7CvB;;AKtp7CA;EAA6B,gBAAA;AL0p7C7B;;AKzp7CA;EAA6B,gBAAA;AL6p7C7B;;AK5p7CA;EAA2B,gBAAA;ALgq7C3B;;AK/p7CA;EAA2B,gBAAA;ALmq7C3B;;AKlq7CA;EAA6B,gBAAA;ALsq7C7B;;AKrq7CA;EAA6B,gBAAA;ALyq7C7B;;AKxq7CA;EAA8B,gBAAA;AL4q7C9B;;AK3q7CA;EAA8B,gBAAA;AL+q7C9B;;AK9q7CA;EAA8B,gBAAA;ALkr7C9B;;AKjr7CA;EAA8B,gBAAA;ALqr7C9B;;AKpr7CA;EAA4B,gBAAA;ALwr7C5B;;AKvr7CA;EAA4B,gBAAA;AL2r7C5B;;AK1r7CA;EAAgC,gBAAA;AL8r7ChC;;AK7r7CA;EAAgC,gBAAA;ALis7ChC;;AKhs7CA;EAA0B,gBAAA;ALos7C1B;;AKns7CA;EAA0B,gBAAA;ALus7C1B;;AKts7CA;EAA+B,gBAAA;AL0s7C/B;;AKzs7CA;EAA+B,gBAAA;AL6s7C/B;;AK5s7CA;EAA0B,gBAAA;ALgt7C1B;;AK/s7CA;EAA0B,gBAAA;ALmt7C1B;;AKlt7CA;EAA8B,gBAAA;ALst7C9B;;AKrt7CA;EAA8B,gBAAA;ALyt7C9B;;AKxt7CA;EAA4B,gBAAA;AL4t7C5B;;AK3t7CA;EAA4B,gBAAA;AL+t7C5B;;AK9t7CA;EAAgC,gBAAA;ALku7ChC;;AKju7CA;EAAgC,gBAAA;ALqu7ChC;;AKpu7CA;EAAwB,gBAAA;ALwu7CxB;;AKvu7CA;EAAwB,gBAAA;AL2u7CxB;;AK1u7CA;EAA4B,gBAAA;AL8u7C5B;;AK7u7CA;EAA4B,gBAAA;ALiv7C5B;;AKhv7CA;EAA0B,gBAAA;ALov7C1B;;AKnv7CA;EAA0B,gBAAA;ALuv7C1B;;AKtv7CA;EAAqB,gBAAA;AL0v7CrB;;AKzv7CA;EAAqB,gBAAA;AL6v7CrB;;AK5v7CA;EAA0B,gBAAA;ALgw7C1B;;AK/v7CA;EAA0B,gBAAA;ALmw7C1B;;AKlw7CA;EAA4B,gBAAA;ALsw7C5B;;AKrw7CA;EAA4B,gBAAA;ALyw7C5B;;AKxw7CA;EAA0B,gBAAA;AL4w7C1B;;AK3w7CA;EAA0B,gBAAA;AL+w7C1B;;AK9w7CA;EAAkC,gBAAA;ALkx7ClC;;AKjx7CA;EAAkC,gBAAA;ALqx7ClC;;AKpx7CA;EAA2B,gBAAA;ALwx7C3B;;AKvx7CA;EAA2B,gBAAA;AL2x7C3B;;AK1x7CA;EAA2B,gBAAA;AL8x7C3B;;AK7x7CA;EAAgC,gBAAA;ALiy7ChC;;AKhy7CA;EAAgC,gBAAA;ALoy7ChC;;AKny7CA;EAA4B,gBAAA;ALuy7C5B;;AKty7CA;EAA4B,gBAAA;AL0y7C5B;;AKzy7CA;EAAwB,gBAAA;AL6y7CxB;;AK5y7CA;EAAwB,gBAAA;ALgz7CxB;;AK/y7CA;EAA0B,gBAAA;ALmz7C1B;;AKlz7CA;EAA0B,gBAAA;ALsz7C1B;;AKrz7CA;EAA+B,gBAAA;ALyz7C/B;;AKxz7CA;EAA+B,gBAAA;AL4z7C/B;;AK3z7CA;EAAwB,gBAAA;AL+z7CxB;;AK9z7CA;EAAwB,gBAAA;ALk07CxB;;AKj07CA;EAA0B,gBAAA;ALq07C1B;;AKp07CA;EAA0B,gBAAA;ALw07C1B;;AKv07CA;EAAwB,gBAAA;AL207CxB;;AK107CA;EAAwB,gBAAA;AL807CxB;;AK707CA;EAA0B,gBAAA;ALi17C1B;;AKh17CA;EAA0B,gBAAA;ALo17C1B;;AKn17CA;EAAgC,gBAAA;ALu17ChC;;AKt17CA;EAAgC,gBAAA;AL017ChC;;AKz17CA;EAA8B,gBAAA;AL617C9B;;AK517CA;EAA8B,gBAAA;ALg27C9B;;AK/17CA;EAA0B,gBAAA;ALm27C1B;;AKl27CA;EAA0B,gBAAA;ALs27C1B;;AKr27CA;EAA6B,gBAAA;ALy27C7B;;AKx27CA;EAA6B,gBAAA;AL427C7B;;AK327CA;EAAyB,gBAAA;AL+27CzB;;AK927CA;EAAyB,gBAAA;ALk37CzB;;AKj37CA;EAA0B,gBAAA;ALq37C1B;;AKp37CA;EAA0B,gBAAA;ALw37C1B;;AKv37CA;EAA2B,gBAAA;AL237C3B;;AK137CA;EAA2B,gBAAA;AL837C3B;;AK737CA;EAAyB,gBAAA;ALi47CzB;;AKh47CA;EAAyB,gBAAA;ALo47CzB;;AKn47CA;EAA6B,gBAAA;ALu47C7B;;AKt47CA;EAA6B,gBAAA;AL047C7B;;AKz47CA;EAA4B,gBAAA;AL647C5B;;AK547CA;EAA4B,gBAAA;ALg57C5B;;AK/47CA;EAAmC,gBAAA;ALm57CnC;;AKl57CA;EAAmC,gBAAA;ALs57CnC;;AKr57CA;EAAiC,gBAAA;ALy57CjC;;AKx57CA;EAAiC,gBAAA;AL457CjC;;AK357CA;EAA2B,gBAAA;AL+57C3B;;AK957CA;EAA2B,gBAAA;ALk67C3B;;AKj67CA;EAAyB,gBAAA;ALq67CzB;;AKp67CA;EAAyB,gBAAA;ALw67CzB;;AKv67CA;EAA6B,gBAAA;AL267C7B;;AK167CA;EAA6B,gBAAA;AL867C7B;;AK767CA;EAA4B,gBAAA;ALi77C5B;;AKh77CA;EAA4B,gBAAA;ALo77C5B;;AKn77CA;EAAwB,gBAAA;ALu77CxB;;AKt77CA;EAAwB,gBAAA;AL077CxB;;AKz77CA;EAA2B,gBAAA;AL677C3B;;AK577CA;EAA2B,gBAAA;ALg87C3B;;AK/77CA;EAA4B,gBAAA;ALm87C5B;;AKl87CA;EAA4B,gBAAA;ALs87C5B;;AKr87CA;EAA0B,gBAAA;ALy87C1B;;AKx87CA;EAA0B,gBAAA;AL487C1B;;AK387CA;EAA+B,gBAAA;AL+87C/B;;AK987CA;EAA+B,gBAAA;ALk97C/B;;AKj97CA;EAA6B,gBAAA;ALq97C7B;;AKp97CA;EAA6B,gBAAA;ALw97C7B;;AKv97CA;EAAyB,gBAAA;AL297CzB;;AK197CA;EAAyB,gBAAA;AL897CzB;;AK797CA;EAA8B,gBAAA;ALi+7C9B;;AKh+7CA;EAA8B,gBAAA;ALo+7C9B;;AKn+7CA;EAAyB,gBAAA;ALu+7CzB;;AKt+7CA;EAAyB,gBAAA;AL0+7CzB;;AKz+7CA;EAAyB,gBAAA;AL6+7CzB;;AK5+7CA;EAAyB,gBAAA;ALg/7CzB;;AK/+7CA;EAA2B,gBAAA;ALm/7C3B;;AKl/7CA;EAA2B,gBAAA;ALs/7C3B;;AKr/7CA;EAA2B,gBAAA;ALy/7C3B;;AKx/7CA;EAA2B,gBAAA;AL4/7C3B;;AK3/7CA;EAAwB,gBAAA;AL+/7CxB;;AK9/7CA;EAAwB,gBAAA;ALkg8CxB;;AKjg8CA;EAA2B,gBAAA;ALqg8C3B;;AKpg8CA;EAA2B,gBAAA;ALwg8C3B;;AKvg8CA;EAAyB,gBAAA;AL2g8CzB;;AK1g8CA;EAAyB,gBAAA;AL8g8CzB;;AK7g8CA;EAA8B,gBAAA;ALih8C9B;;AKhh8CA;EAA8B,gBAAA;ALoh8C9B;;AKnh8CA;EAA4B,gBAAA;ALuh8C5B;;AKth8CA;EAAwB,gBAAA;AL0h8CxB;;AKzh8CA;EAAwB,gBAAA;AL6h8CxB;;AK5h8CA;EAAyB,gBAAA;ALgi8CzB;;AK/h8CA;EAAyB,gBAAA;ALmi8CzB;;AKli8CA;EAAsB,gBAAA;ALsi8CtB;;AKri8CA;EAAsB,gBAAA;ALyi8CtB;;AKxi8CA;EAA0B,gBAAA;AL4i8C1B;;AK3i8CA;EAA0B,gBAAA;AL+i8C1B;;AK9i8CA;EAAwB,gBAAA;ALkj8CxB;;AKjj8CA;EAAwB,gBAAA;ALqj8CxB;;AKpj8CA;EAAsB,gBAAA;ALwj8CtB;;AKvj8CA;EAAsB,gBAAA;AL2j8CtB;;AK1j8CA;EAAyB,gBAAA;AL8j8CzB;;AK7j8CA;EAAyB,gBAAA;ALik8CzB;;AKhk8CA;EAAyB,gBAAA;ALok8CzB;;AKnk8CA;EAAyB,gBAAA;ALuk8CzB;;AKtk8CA;EAAuB,gBAAA;AL0k8CvB;;AKzk8CA;EAAuB,gBAAA;AL6k8CvB;;AK5k8CA;EAA2B,gBAAA;ALgl8C3B;;AK/k8CA;EAA2B,gBAAA;ALml8C3B;;AKll8CA;EAAyB,gBAAA;ALsl8CzB;;AKrl8CA;EAAyB,gBAAA;ALyl8CzB;;AKxl8CA;EAAyB,gBAAA;AL4l8CzB;;AK3l8CA;EAAyB,gBAAA;AL+l8CzB;;AK9l8CA;EAAuB,gBAAA;ALkm8CvB;;AKjm8CA;EAAuB,gBAAA;ALqm8CvB;;AKpm8CA;EAA2B,gBAAA;ALwm8C3B;;AKvm8CA;EAA2B,gBAAA;AL2m8C3B;;AK1m8CA;EAA2B,gBAAA;AL8m8C3B;;AK7m8CA;EAA2B,gBAAA;ALin8C3B;;AKhn8CA;EAAyB,gBAAA;ALon8CzB;;AKnn8CA;EAAyB,gBAAA;ALun8CzB;;AKtn8CA;EAAyB,gBAAA;AL0n8CzB;;AKzn8CA;EAAyB,gBAAA;AL6n8CzB;;AK5n8CA;EAAuB,gBAAA;ALgo8CvB;;AK/n8CA;EAAuB,gBAAA;ALmo8CvB;;AKlo8CA;EAA6B,gBAAA;ALso8C7B;;AKro8CA;EAA6B,gBAAA;ALyo8C7B;;AKxo8CA;EAA+B,gBAAA;AL4o8C/B;;AK3o8CA;EAA+B,gBAAA;AL+o8C/B;;AK9o8CA;EAA2B,gBAAA;ALkp8C3B;;AKjp8CA;EAA2B,gBAAA;ALqp8C3B;;AKpp8CA;EAA+B,gBAAA;ALwp8C/B;;AKvp8CA;EAA+B,gBAAA;AL2p8C/B;;AK1p8CA;EAA6B,gBAAA;AL8p8C7B;;AK7p8CA;EAA6B,gBAAA;ALiq8C7B;;AKhq8CA;EAA0B,gBAAA;ALoq8C1B;;AKnq8CA;EAA0B,gBAAA;ALuq8C1B;;AKtq8CA;EAA+B,gBAAA;AL0q8C/B;;AKzq8CA;EAA+B,gBAAA;AL6q8C/B;;AK5q8CA;EAA2B,gBAAA;ALgr8C3B;;AK/q8CA;EAA2B,gBAAA;ALmr8C3B;;AKlr8CA;EAA6B,gBAAA;ALsr8C7B;;AKrr8CA;EAA6B,gBAAA;ALyr8C7B;;AKxr8CA;EAAyB,gBAAA;AL4r8CzB;;AK3r8CA;EAAyB,gBAAA;AL+r8CzB;;AK9r8CA;EAAiC,gBAAA;ALks8CjC;;AKjs8CA;EAAiC,gBAAA;ALqs8CjC;;AKps8CA;EAA2B,gBAAA;ALws8C3B;;AKvs8CA;EAA2B,gBAAA;AL2s8C3B;;AK1s8CA;EAA2B,gBAAA;AL8s8C3B;;AK7s8CA;EAA+B,gBAAA;ALit8C/B;;AKht8CA;EAA+B,gBAAA;ALot8C/B;;AKnt8CA;EAA6B,gBAAA;ALut8C7B;;AKtt8CA;EAA6B,gBAAA;AL0t8C7B;;AKzt8CA;EAA0B,gBAAA;AL6t8C1B;;AK5t8CA;EAAyB,gBAAA;ALgu8CzB;;AK/t8CA;EAAyB,gBAAA;ALmu8CzB;;AKlu8CA;EAAuB,gBAAA;ALsu8CvB;;AKru8CA;EAAyB,gBAAA;ALyu8CzB;;AKxu8CA;EAAyB,gBAAA;AL4u8CzB;;AK3u8CA;EAA0B,gBAAA;AL+u8C1B;;AK9u8CA;EAA0B,gBAAA;ALkv8C1B;;AKjv8CA;EAA6B,gBAAA;ALqv8C7B;;AKpv8CA;EAA6B,gBAAA;ALwv8C7B;;AKvv8CA;EAA6B,gBAAA;AL2v8C7B;;AK1v8CA;EAA6B,gBAAA;AL8v8C7B;;AK7v8CA;EAA6B,gBAAA;ALiw8C7B;;AKhw8CA;EAA6B,gBAAA;ALow8C7B;;AKnw8CA;EAA6B,gBAAA;ALuw8C7B;;AKtw8CA;EAA6B,gBAAA;AL0w8C7B;;AKzw8CA;EAA6B,gBAAA;AL6w8C7B;;AK5w8CA;EAA6B,gBAAA;ALgx8C7B;;AK/w8CA;EAA2B,gBAAA;ALmx8C3B;;AKlx8CA;EAA2B,gBAAA;ALsx8C3B;;AKrx8CA;EAA0B,gBAAA;ALyx8C1B;;AKxx8CA;EAA0B,gBAAA;AL4x8C1B;;AK3x8CA;EAAwB,gBAAA;AL+x8CxB;;AK9x8CA;EAAwB,gBAAA;ALky8CxB;;AKjy8CA;EAA4B,gBAAA;ALqy8C5B;;AKpy8CA;EAA4B,gBAAA;ALwy8C5B;;AKvy8CA;EAA+B,gBAAA;AL2y8C/B;;AK1y8CA;EAA+B,gBAAA;AL8y8C/B;;AK7y8CA;EAAwB,gBAAA;ALiz8CxB;;AKhz8CA;EAAkC,gBAAA;ALoz8ClC;;AKnz8CA;EAAkC,gBAAA;ALuz8ClC;;AKtz8CA;EAAoC,gBAAA;AL0z8CpC;;AKzz8CA;EAAoC,gBAAA;AL6z8CpC;;AK5z8CA;EAAgC,gBAAA;ALg08ChC;;AK/z8CA;EAAgC,gBAAA;ALm08ChC;;AKl08CA;EAAwB,gBAAA;ALs08CxB;;AKr08CA;EAA+B,gBAAA;ALy08C/B;;AKx08CA;EAA+B,gBAAA;AL408C/B;;AK308CA;EAA+B,gBAAA;AL+08C/B;;AK908CA;EAA+B,gBAAA;ALk18C/B;;AKj18CA;EAAyB,gBAAA;ALq18CzB;;AKp18CA;EAA+B,gBAAA;ALw18C/B;;AKv18CA;EAA+B,gBAAA;AL218C/B;;AK118CA;EAAiC,gBAAA;AL818CjC;;AK718CA;EAAiC,gBAAA;ALi28CjC;;AKh28CA;EAAyB,gBAAA;ALo28CzB;;AKn28CA;EAA8B,gBAAA;ALu28C9B;;AKt28CA;EAA8B,gBAAA;AL028C9B;;AKz28CA;EAA8B,gBAAA;AL628C9B;;AK528CA;EAA8B,gBAAA;ALg38C9B;;AK/28CA;EAAyB,gBAAA;ALm38CzB;;AKl38CA;EAAyB,gBAAA;ALs38CzB;;AKr38CA;EAAuB,gBAAA;ALy38CvB;;AKx38CA;EAAuB,gBAAA;AL438CvB;;AK338CA;EAAwB,gBAAA;AL+38CxB;;AK938CA;EAAwB,gBAAA;ALk48CxB;;AKj48CA;EAAiC,gBAAA;ALq48CjC;;AKp48CA;EAAiC,gBAAA;ALw48CjC;;AKv48CA;EAAiC,gBAAA;AL248CjC;;AK148CA;EAAiC,gBAAA;AL848CjC;;AK748CA;EAA+B,gBAAA;ALi58C/B;;AKh58CA;EAA+B,gBAAA;ALo58C/B;;AKn58CA;EAAoC,gBAAA;ALu58CpC;;AKt58CA;EAAoC,gBAAA;AL058CpC;;AKz58CA;EAAkC,gBAAA;AL658ClC;;AK558CA;EAAkC,gBAAA;ALg68ClC;;AK/58CA;EAAkC,gBAAA;ALm68ClC;;AKl68CA;EAAkC,gBAAA;ALs68ClC;;AKr68CA;EAAgC,gBAAA;ALy68ChC;;AKx68CA;EAAgC,gBAAA;AL468ChC;;AK368CA;EAA0B,gBAAA;AL+68C1B;;AK968CA;EAA0B,gBAAA;ALk78C1B;;AKj78CA;EAA0B,gBAAA;ALq78C1B;;AKp78CA;EAA0B,gBAAA;ALw78C1B;;AKv78CA;EAA4B,gBAAA;AL278C5B;;AK178CA;EAA4B,gBAAA;AL878C5B;;AK778CA;EAA2B,gBAAA;ALi88C3B;;AKh88CA;EAA2B,gBAAA;ALo88C3B;;AKn88CA;EAA+B,gBAAA;ALu88C/B;;AKt88CA;EAA+B,gBAAA;AL088C/B;;AKz88CA;EAAgC,gBAAA;AL688ChC;;AK588CA;EAAgC,gBAAA;ALg98ChC;;AK/88CA;EAAgC,gBAAA;ALm98ChC;;AKl98CA;EAAgC,gBAAA;ALs98ChC;;AKr98CA;EAAgC,gBAAA;ALy98ChC;;AKx98CA;EAAgC,gBAAA;AL498ChC;;AK398CA;EAAoC,gBAAA;AL+98CpC;;AK998CA;EAAoC,gBAAA;ALk+8CpC;;AKj+8CA;EAA8B,gBAAA;ALq+8C9B;;AKp+8CA;EAA8B,gBAAA;ALw+8C9B;;AKv+8CA;EAAkC,gBAAA;AL2+8ClC;;AK1+8CA;EAAkC,gBAAA;AL8+8ClC;;AK7+8CA;EAA6B,gBAAA;ALi/8C7B;;AKh/8CA;EAA6B,gBAAA;ALo/8C7B;;AKn/8CA;EAA2B,gBAAA;ALu/8C3B;;AKt/8CA;EAA2B,gBAAA;AL0/8C3B;;AKz/8CA;EAA6B,gBAAA;AL6/8C7B;;AK5/8CA;EAA6B,gBAAA;ALgg9C7B;;AK//8CA;EAAsB,gBAAA;ALmg9CtB;;AKlg9CA;EAAsB,gBAAA;ALsg9CtB;;AKrg9CA;EAA4B,gBAAA;ALyg9C5B;;AKxg9CA;EAA4B,gBAAA;AL4g9C5B;;AK3g9CA;EAAiC,gBAAA;AL+g9CjC;;AK9g9CA;EAAiC,gBAAA;ALkh9CjC;;AKjh9CA;EAA+B,gBAAA;ALqh9C/B;;AKph9CA;EAA+B,gBAAA;ALwh9C/B;;AKvh9CA;EAAoC,gBAAA;AL2h9CpC;;AK1h9CA;EAAoC,gBAAA;AL8h9CpC;;AK7h9CA;EAA0B,gBAAA;ALii9C1B;;AKhi9CA;EAA0B,gBAAA;ALoi9C1B;;AKni9CA;EAAwB,gBAAA;ALui9CxB;;AKti9CA;EAAwB,gBAAA;AL0i9CxB;;AKzi9CA;EAAwB,gBAAA;AL6i9CxB;;AK5i9CA;EAAwB,gBAAA;ALgj9CxB;;AK/i9CA;EAAwB,gBAAA;ALmj9CxB;;AKlj9CA;EAAwB,gBAAA;ALsj9CxB;;AKrj9CA;EAAwB,gBAAA;ALyj9CxB;;AKxj9CA;EAAwB,gBAAA;AL4j9CxB;;AK3j9CA;EAA8B,gBAAA;AL+j9C9B;;AK9j9CA;EAA8B,gBAAA;ALkk9C9B;;AKjk9CA;EAA8B,gBAAA;ALqk9C9B;;AKpk9CA;EAA8B,gBAAA;ALwk9C9B;;AKvk9CA;EAA8B,gBAAA;AL2k9C9B;;AK1k9CA;EAA8B,gBAAA;AL8k9C9B;;AK7k9CA;EAA4B,gBAAA;ALil9C5B;;AKhl9CA;EAA4B,gBAAA;ALol9C5B;;AKnl9CA;EAA6B,gBAAA;ALul9C7B;;AKtl9CA;EAA6B,gBAAA;AL0l9C7B;;AKzl9CA;EAA2B,gBAAA;AL6l9C3B;;AK5l9CA;EAA2B,gBAAA;ALgm9C3B;;AK/l9CA;EAAwB,gBAAA;ALmm9CxB;;AKlm9CA;EAAwB,gBAAA;ALsm9CxB;;AKrm9CA;EAAsB,gBAAA;ALym9CtB;;AKxm9CA;EAAuB,gBAAA;AL4m9CvB;;AK3m9CA;EAA+B,gBAAA;AL+m9C/B;;AK9m9CA;EAA+B,gBAAA;ALkn9C/B;;AKjn9CA;EAA6B,gBAAA;ALqn9C7B;;AKpn9CA;EAA6B,gBAAA;ALwn9C7B;;AKvn9CA;EAA6B,gBAAA;AL2n9C7B;;AK1n9CA;EAA6B,gBAAA;AL8n9C7B;;AK7n9CA;EAAmB,gBAAA;ALio9CnB;;AKho9CA;EAAyB,gBAAA;ALoo9CzB;;AKno9CA;EAAyB,gBAAA;ALuo9CzB;;AKto9CA;EAAyB,gBAAA;AL0o9CzB;;AKzo9CA;EAAyB,gBAAA;AL6o9CzB;;AK5o9CA;EAAuB,gBAAA;ALgp9CvB;;AK/o9CA;EAAuB,gBAAA;ALmp9CvB;;AKlp9CA;EAA4B,gBAAA;ALsp9C5B;;AKrp9CA;EAA4B,gBAAA;ALyp9C5B;;AKxp9CA;EAA4B,gBAAA;AL4p9C5B;;AK3p9CA;EAA4B,gBAAA;AL+p9C5B;;AK9p9CA;EAA0B,gBAAA;ALkq9C1B;;AKjq9CA;EAA0B,gBAAA;ALqq9C1B;;AKpq9CA;EAA2B,gBAAA;ALwq9C3B;;AKvq9CA;EAA2B,gBAAA;AL2q9C3B;;AK1q9CA;EAAwB,gBAAA;AL8q9CxB;;AK7q9CA;EAAwB,gBAAA;ALir9CxB;;AKhr9CA;EAA6B,gBAAA;ALor9C7B;;AKnr9CA;EAA6B,gBAAA;ALur9C7B;;AKtr9CA;EAAoC,gBAAA;AL0r9CpC;;AKzr9CA;EAAkC,gBAAA;AL6r9ClC;;AK5r9CA;EAA0B,gBAAA;ALgs9C1B;;AK/r9CA;EAA0B,gBAAA;ALms9C1B;;AKls9CA;EAAsB,gBAAA;ALss9CtB;;AKrs9CA;EAAsB,gBAAA;ALys9CtB;;AKxs9CA;EAAwB,gBAAA;AL4s9CxB;;AK3s9CA;EAAwB,gBAAA;AL+s9CxB;;AK9s9CA;EAAiC,gBAAA;ALkt9CjC;;AKjt9CA;EAAiC,gBAAA;ALqt9CjC;;AKpt9CA;EAA6B,gBAAA;ALwt9C7B;;AKvt9CA;EAA6B,gBAAA;AL2t9C7B;;AK1t9CA;EAAuB,gBAAA;AL8t9CvB;;AK7t9CA;EAA4B,gBAAA;ALiu9C5B;;AKhu9CA;EAA4B,gBAAA;ALou9C5B;;AKnu9CA;EAA8B,gBAAA;ALuu9C9B;;AKtu9CA;EAA8B,gBAAA;AL0u9C9B;;AKzu9CA;EAAuB,gBAAA;AL6u9CvB;;AK5u9CA;EAAyB,gBAAA;ALgv9CzB;;AK/u9CA;EAAyB,gBAAA;ALmv9CzB;;AKlv9CA;EAA6B,gBAAA;ALsv9C7B;;AKrv9CA;EAA6B,gBAAA;ALyv9C7B;;AKxv9CA;EAAwB,gBAAA;AL4v9CxB;;AK3v9CA;EAAwB,gBAAA;AL+v9CxB;;AK9v9CA;EAA6B,gBAAA;ALkw9C7B;;AKjw9CA;EAA6B,gBAAA;ALqw9C7B;;AKpw9CA;EAA2B,gBAAA;ALww9C3B;;AKvw9CA;EAA2B,gBAAA;AL2w9C3B;;AK1w9CA;EAA8B,gBAAA;AL8w9C9B;;AK7w9CA;EAA8B,gBAAA;ALix9C9B;;AKhx9CA;EAAgC,gBAAA;ALox9ChC;;AKnx9CA;EAAgC,gBAAA;ALux9ChC;;AKtx9CA;EAA8B,gBAAA;AL0x9C9B;;AKzx9CA;EAA8B,gBAAA;AL6x9C9B;;AK5x9CA;EAAwB,gBAAA;ALgy9CxB;;AK/x9CA;EAAwB,gBAAA;ALmy9CxB;;AKly9CA;EAA8B,gBAAA;ALsy9C9B;;AKry9CA;EAA8B,gBAAA;ALyy9C9B;;AKxy9CA;EAAuB,gBAAA;AL4y9CvB;;AK3y9CA;EAAuB,gBAAA;AL+y9CvB;;AK9y9CA;EAA4B,gBAAA;ALkz9C5B;;AKjz9CA;EAA4B,gBAAA;ALqz9C5B;;AKpz9CA;EAA0B,gBAAA;ALwz9C1B;;AKvz9CA;EAA0B,gBAAA;AL2z9C1B;;AK1z9CA;EAA0B,gBAAA;AL8z9C1B;;AK7z9CA;EAA0B,gBAAA;ALi09C1B;;AKh09CA;EAAwB,gBAAA;ALo09CxB;;AKn09CA;EAAwB,gBAAA;ALu09CxB;;AKt09CA;EAA6B,gBAAA;AL009C7B;;AKz09CA;EAA2B,gBAAA;AL609C3B;;AK509CA;EAAyB,gBAAA;ALg19CzB;;AK/09CA;EAAuB,gBAAA;ALm19CvB;;AKl19CA;EAA2B,gBAAA;ALs19C3B;;AKr19CA;EAA2B,gBAAA;ALy19C3B;;AKx19CA;EAAyB,gBAAA;AL419CzB;;AK319CA;EAAyB,gBAAA;AL+19CzB;;AK919CA;EAA8B,gBAAA;ALk29C9B;;AKj29CA;EAA8B,gBAAA;ALq29C9B;;AKp29CA;EAA6B,gBAAA;ALw29C7B;;AKv29CA;EAA6B,gBAAA;AL229C7B;;AK129CA;EAA6B,gBAAA;AL829C7B;;AK729CA;EAA6B,gBAAA;ALi39C7B;;AKh39CA;EAA2B,gBAAA;ALo39C3B;;AKn39CA;EAA2B,gBAAA;ALu39C3B;;AKt39CA;EAA6B,gBAAA;AL039C7B;;AKz39CA;EAA6B,gBAAA;AL639C7B;;AK539CA;EAAsB,gBAAA;ALg49CtB;;AK/39CA;EAA4B,gBAAA;ALm49C5B;;AKl49CA;EAA4B,gBAAA;ALs49C5B;;AKr49CA;EAAsB,gBAAA;ALy49CtB;;AKx49CA;EAA2B,gBAAA;AL449C3B;;AK349CA;EAAyB,gBAAA;AL+49CzB;;AK949CA;EAAgC,gBAAA;ALk59ChC;;AKj59CA;EAAgC,gBAAA;ALq59ChC;;AKp59CA;EAAiC,gBAAA;ALw59CjC;;AKv59CA;EAAiC,gBAAA;AL259CjC;;AK159CA;EAAyB,gBAAA;AL859CzB;;AK759CA;EAAyB,gBAAA;ALi69CzB;;AKh69CA;EAA2B,gBAAA;ALo69C3B;;AKn69CA;EAA2B,gBAAA;ALu69C3B;;AKt69CA;EAAuB,gBAAA;AL069CvB;;AKz69CA;EAAuB,gBAAA;AL669CvB;;AK569CA;EAAyB,gBAAA;ALg79CzB;;AK/69CA;EAAyB,gBAAA;ALm79CzB;;AKl79CA;EAAwB,gBAAA;ALs79CxB;;AKr79CA;EAAwB,gBAAA;ALy79CxB;;AKx79CA;EAA0B,gBAAA;AL479C1B;;AK379CA;EAA0B,gBAAA;AL+79C1B;;AK979CA;EAAwB,gBAAA;ALk89CxB;;AKj89CA;EAAwB,gBAAA;ALq89CxB;;AKp89CA;EAA4B,gBAAA;ALw89C5B;;AKv89CA;EAA4B,gBAAA;AL289C5B;;AK189CA;EAA8B,gBAAA;AL889C9B;;AK789CA;EAA8B,gBAAA;ALi99C9B;;AKh99CA;EAA0B,gBAAA;ALo99C1B;;AKn99CA;EAA0B,gBAAA;ALu99C1B;;AKt99CA;EAAqB,gBAAA;AL099CrB;;AKz99CA;EAA4B,gBAAA;AL699C5B;;AK599CA;EAA4B,gBAAA;ALg+9C5B;;AK/99CA;EAAwB,gBAAA;ALm+9CxB;;AKl+9CA;EAAwB,gBAAA;ALs+9CxB;;AKr+9CA;EAAyB,gBAAA;ALy+9CzB;;AKx+9CA;EAAyB,gBAAA;AL4+9CzB;;AK3+9CA;EAA2B,gBAAA;AL++9C3B;;AK9+9CA;EAA2B,gBAAA;ALk/9C3B;;AKj/9CA;EAAyB,gBAAA;ALq/9CzB;;AKp/9CA;EAAyB,gBAAA;ALw/9CzB;;AKv/9CA;EAAuB,gBAAA;AL2/9CvB;;AK1/9CA;EAAuB,gBAAA;AL8/9CvB;;AK7/9CA;EAAuB,gBAAA;ALig+CvB;;AKhg+CA;EAAuB,gBAAA;ALog+CvB;;AKng+CA;EAAuB,gBAAA;ALug+CvB;;AKtg+CA;EAAuB,gBAAA;AL0g+CvB;;AKzg+CA;EAA4B,gBAAA;AL6g+C5B;;AK5g+CA;EAA4B,gBAAA;ALgh+C5B;;AK/g+CA;EAAuB,gBAAA;ALmh+CvB;;AKlh+CA;EAAuB,gBAAA;ALsh+CvB;;AKrh+CA;EAA2B,gBAAA;ALyh+C3B;;AKxh+CA;EAA2B,gBAAA;AL4h+C3B;;AK3h+CA;EAA4B,gBAAA;AL+h+C5B;;AK9h+CA;EAA4B,gBAAA;ALki+C5B;;AKji+CA;EAA2B,gBAAA;ALqi+C3B;;AKpi+CA;EAA2B,gBAAA;ALwi+C3B;;AKvi+CA;EAA+B,gBAAA;AL2i+C/B;;AK1i+CA;EAA+B,gBAAA;AL8i+C/B;;AK7i+CA;EAA2B,gBAAA;ALij+C3B;;AKhj+CA;EAA2B,gBAAA;ALoj+C3B;;AKnj+CA;EAAkC,gBAAA;ALuj+ClC;;AKtj+CA;EAAkC,gBAAA;AL0j+ClC;;AKzj+CA;EAA4B,gBAAA;AL6j+C5B;;AK5j+CA;EAA4B,gBAAA;ALgk+C5B;;AK/j+CA;EAA8B,gBAAA;ALmk+C9B;;AKlk+CA;EAA8B,gBAAA;ALsk+C9B;;AKrk+CA;EAA0B,gBAAA;ALyk+C1B;;AKxk+CA;EAAuB,gBAAA;AL4k+CvB;;AK3k+CA;EAAkB,gBAAA;AL+k+ClB;;AK9k+CA;EAA8B,gBAAA;ALkl+C9B;;AKjl+CA;EAA8B,gBAAA;ALql+C9B;;AKpl+CA;EAA6B,gBAAA;ALwl+C7B;;AKvl+CA;EAA6B,gBAAA;AL2l+C7B;;AK1l+CA;EAA2B,gBAAA;AL8l+C3B;;AK7l+CA;EAA2B,gBAAA;ALim+C3B;;AKhm+CA;EAAgC,gBAAA;ALom+ChC;;AKnm+CA;EAAgC,gBAAA;ALum+ChC;;AKtm+CA;EAA2B,gBAAA;AL0m+C3B;;AKzm+CA;EAA2B,gBAAA;AL6m+C3B;;AK5m+CA;EAAyB,gBAAA;ALgn+CzB;;AK/m+CA;EAAyB,gBAAA;ALmn+CzB;;AKln+CA;EAAuB,gBAAA;ALsn+CvB;;AKrn+CA;EAAuB,gBAAA;ALyn+CvB;;AKxn+CA;EAA0B,gBAAA;AL4n+C1B;;AK3n+CA;EAA0B,gBAAA;AL+n+C1B;;AK9n+CA;EAAwB,gBAAA;ALko+CxB;;AKjo+CA;EAA8B,gBAAA;ALqo+C9B;;AKpo+CA;EAA8B,gBAAA;ALwo+C9B;;AKvo+CA;EAAwB,gBAAA;AL2o+CxB;;AK1o+CA;EAAuB,gBAAA;AL8o+CvB;;AK7o+CA;EAAuB,gBAAA;ALip+CvB;;AKhp+CA;EAAyB,gBAAA;ALop+CzB;;AKnp+CA;EAAyB,gBAAA;ALup+CzB;;AKtp+CA;EAAwB,gBAAA;AL0p+CxB;;AKzp+CA;EAAwB,gBAAA;AL6p+CxB;;AK5p+CA;EAA0B,gBAAA;ALgq+C1B;;AK/p+CA;EAA0B,gBAAA;ALmq+C1B;;AKlq+CA;EAA4B,gBAAA;ALsq+C5B;;AKrq+CA;EAA4B,gBAAA;ALyq+C5B;;AKxq+CA;EAAgC,gBAAA;AL4q+ChC;;AK3q+CA;EAAgC,gBAAA;AL+q+ChC;;AK9q+CA;EAAwB,gBAAA;ALkr+CxB;;AKjr+CA;EAAwB,gBAAA;ALqr+CxB;;AKpr+CA;EAA6B,gBAAA;ALwr+C7B;;AKvr+CA;EAA6B,gBAAA;AL2r+C7B;;AK1r+CA;EAAyB,gBAAA;AL8r+CzB;;AK7r+CA;EAAuB,gBAAA;ALis+CvB;;AKhs+CA;EAA2B,gBAAA;ALos+C3B;;AKns+CA;EAA2B,gBAAA;ALus+C3B;;AKts+CA;EAA+B,gBAAA;AL0s+C/B;;AKzs+CA;EAA+B,gBAAA;AL6s+C/B;;AK5s+CA;EAAyB,gBAAA;ALgt+CzB;;AK/s+CA;EAAyB,gBAAA;ALmt+CzB;;AKlt+CA;EAAyB,gBAAA;ALst+CzB;;AKrt+CA;EAAyB,gBAAA;ALyt+CzB;;AKxt+CA;EAAwB,gBAAA;AL4t+CxB;;AK3t+CA;EAAwB,gBAAA;AL+t+CxB;;AK9t+CA;EAAyB,gBAAA;ALku+CzB;;AKju+CA;EAAyB,gBAAA;ALqu+CzB;;AKpu+CA;EAAuB,gBAAA;ALwu+CvB;;AKvu+CA;EAAuB,gBAAA;AL2u+CvB;;AK1u+CA;EAAqB,gBAAA;AL8u+CrB;;AK7u+CA;EAAqB,gBAAA;ALiv+CrB;;AKhv+CA;EAAyB,gBAAA;ALov+CzB;;AKnv+CA;EAAyB,gBAAA;ALuv+CzB;;AKtv+CA;EAA0B,gBAAA;AL0v+C1B;;AKzv+CA;EAA0B,gBAAA;AL6v+C1B;;AK5v+CA;EAA0B,gBAAA;ALgw+C1B;;AK/v+CA;EAA0B,gBAAA;ALmw+C1B;;AKlw+CA;EAAyB,gBAAA;ALsw+CzB;;AKrw+CA;EAAyB,gBAAA;ALyw+CzB;;AKxw+CA;EAAyB,gBAAA;AL4w+CzB;;AK3w+CA;EAAyB,gBAAA;AL+w+CzB;;AK9w+CA;EAA2B,gBAAA;ALkx+C3B;;AKjx+CA;EAA2B,gBAAA;ALqx+C3B;;AKpx+CA;EAAuB,gBAAA;ALwx+CvB;;AKvx+CA;EAA4B,gBAAA;AL2x+C5B;;AK1x+CA;EAA4B,gBAAA;AL8x+C5B;;AK7x+CA;EAA2B,gBAAA;ALiy+C3B;;AKhy+CA;EAA2B,gBAAA;ALoy+C3B;;AKny+CA;EAA2B,gBAAA;ALuy+C3B;;AKty+CA;EAA2B,gBAAA;AL0y+C3B;;AKzy+CA;EAAiC,gBAAA;AL6y+CjC;;AK5y+CA;EAAiC,gBAAA;ALgz+CjC;;AK/y+CA;EAA+B,gBAAA;ALmz+C/B;;AKlz+CA;EAA+B,gBAAA;ALsz+C/B;;AKrz+CA;EAAyB,gBAAA;ALyz+CzB;;AKxz+CA;EAAyB,gBAAA;AL4z+CzB;;AK3z+CA;EAAsB,gBAAA;AL+z+CtB;;AK9z+CA;EAAsB,gBAAA;ALk0+CtB;;AKj0+CA;EAAyB,gBAAA;ALq0+CzB;;AKp0+CA;EAAyB,gBAAA;ALw0+CzB;;AKv0+CA;EAAyB,gBAAA;AL20+CzB;;AK10+CA;EAAyB,gBAAA;AL80+CzB;;AK70+CA;EAAyB,gBAAA;ALi1+CzB;;AKh1+CA;EAAyB,gBAAA;ALo1+CzB;;AKn1+CA;EAAyB,gBAAA;ALu1+CzB;;AKt1+CA;EAAyB,gBAAA;AL01+CzB;;AKz1+CA;EAAyB,gBAAA;AL61+CzB;;AK51+CA;EAAyB,gBAAA;ALg2+CzB;;AK/1+CA;EAA2B,gBAAA;ALm2+C3B;;AKl2+CA;EAA2B,gBAAA;ALs2+C3B;;AKr2+CA;EAAuB,gBAAA;ALy2+CvB;;AKx2+CA;EAA8B,gBAAA;AL42+C9B;;AK32+CA;EAA8B,gBAAA;AL+2+C9B;;AK92+CA;EAA6B,gBAAA;ALk3+C7B;;AKj3+CA;EAA6B,gBAAA;ALq3+C7B;;AKp3+CA;EAAuB,gBAAA;ALw3+CvB;;AKv3+CA;EAAgC,gBAAA;AL23+ChC;;AK13+CA;EAAgC,gBAAA;AL83+ChC;;AK73+CA;EAAkC,gBAAA;ALi4+ClC;;AKh4+CA;EAAkC,gBAAA;ALo4+ClC;;AKn4+CA;EAAgC,gBAAA;ALu4+ChC;;AKt4+CA;EAAgC,gBAAA;AL04+ChC;;AKz4+CA;EAA8B,gBAAA;AL64+C9B;;AK54+CA;EAA8B,gBAAA;ALg5+C9B;;AK/4+CA;EAAgC,gBAAA;ALm5+ChC;;AKl5+CA;EAAgC,gBAAA;ALs5+ChC;;AKr5+CA;EAAgC,gBAAA;ALy5+ChC;;AKx5+CA;EAAgC,gBAAA;AL45+ChC;;AK35+CA;EAA8B,gBAAA;AL+5+C9B;;AK95+CA;EAA8B,gBAAA;ALk6+C9B;;AKj6+CA;EAA6B,gBAAA;ALq6+C7B;;AKp6+CA;EAA6B,gBAAA;ALw6+C7B;;AKv6+CA;EAA4B,gBAAA;AL26+C5B;;AK16+CA;EAA4B,gBAAA;AL86+C5B;;AK76+CA;EAAgC,gBAAA;ALi7+ChC;;AKh7+CA;EAAgC,gBAAA;ALo7+ChC;;AKn7+CA;EAA6B,gBAAA;ALu7+C7B;;AKt7+CA;EAA6B,gBAAA;AL07+C7B;;AKz7+CA;EAA4B,gBAAA;AL67+C5B;;AK57+CA;EAA4B,gBAAA;ALg8+C5B;;AK/7+CA;EAA6B,gBAAA;ALm8+C7B;;AKl8+CA;EAA6B,gBAAA;ALs8+C7B;;AKr8+CA;EAAiC,gBAAA;ALy8+CjC;;AKx8+CA;EAAiC,gBAAA;AL48+CjC;;AK38+CA;EAAwB,gBAAA;AL+8+CxB;;AK98+CA;EAAwB,gBAAA;ALk9+CxB;;AKj9+CA;EAA+B,gBAAA;ALq9+C/B;;AKp9+CA;EAA+B,gBAAA;ALw9+C/B;;AKv9+CA;EAA4B,gBAAA;AL29+C5B;;AK19+CA;EAA4B,gBAAA;AL89+C5B;;AK79+CA;EAA0B,gBAAA;ALi++C1B;;AKh++CA;EAA0B,gBAAA;ALo++C1B;;AKn++CA;EAAwB,gBAAA;ALu++CxB;;AKt++CA;EAAwB,gBAAA;AL0++CxB;;AKz++CA;EAA8B,gBAAA;AL6++C9B;;AK5++CA;EAA8B,gBAAA;ALg/+C9B;;AK/++CA;EAA4B,gBAAA;ALm/+C5B;;AKl/+CA;EAA4B,gBAAA;ALs/+C5B;;AKr/+CA;EAA8B,gBAAA;ALy/+C9B;;AKx/+CA;EAA8B,gBAAA;AL4/+C9B;;AK3/+CA;EAAsB,gBAAA;AL+/+CtB;;AK9/+CA;EAAsB,gBAAA;ALkg/CtB;;AKjg/CA;EAAwB,gBAAA;ALqg/CxB;;AKpg/CA;EAAwB,gBAAA;ALwg/CxB;;AKvg/CA;EAAuB,gBAAA;AL2g/CvB;;AK1g/CA;EAAuB,gBAAA;AL8g/CvB;;AK7g/CA;EAAoC,gBAAA;ALih/CpC;;AKhh/CA;EAAoC,gBAAA;ALoh/CpC;;AKnh/CA;EAA6B,gBAAA;ALuh/C7B;;AKth/CA;EAA6B,gBAAA;AL0h/C7B;;AKzh/CA;EAA8B,gBAAA;AL6h/C9B;;AK5h/CA;EAA8B,gBAAA;ALgi/C9B;;AK/h/CA;EAA8B,gBAAA;ALmi/C9B;;AKli/CA;EAA8B,gBAAA;ALsi/C9B;;AKri/CA;EAAqC,gBAAA;ALyi/CrC;;AKxi/CA;EAAqC,gBAAA;AL4i/CrC;;AK3i/CA;EAA4B,gBAAA;AL+i/C5B;;AK9i/CA;EAA4B,gBAAA;ALkj/C5B;;AKjj/CA;EAAiC,gBAAA;ALqj/CjC;;AKpj/CA;EAAiC,gBAAA;ALwj/CjC;;AKvj/CA;EAAwB,gBAAA;AL2j/CxB;;AK1j/CA;EAAwB,gBAAA;AL8j/CxB;;AK7j/CA;EAAuB,gBAAA;ALik/CvB;;AKhk/CA;EAAuB,gBAAA;ALok/CvB;;AKnk/CA;EAA2B,gBAAA;ALuk/C3B;;AKtk/CA;EAA2B,gBAAA;AL0k/C3B;;AKzk/CA;EAA2B,gBAAA;AL6k/C3B;;AK5k/CA;EAA2B,gBAAA;ALgl/C3B;;AK/k/CA;EAAyB,gBAAA;ALml/CzB;;AKll/CA;EAAyB,gBAAA;ALsl/CzB;;AKrl/CA;EAA8B,gBAAA;ALyl/C9B;;AKxl/CA;EAA8B,gBAAA;AL4l/C9B;;AK3l/CA;EAAyB,gBAAA;AL+l/CzB;;AK9l/CA;EAAyB,gBAAA;ALkm/CzB;;AKjm/CA;EAA2B,gBAAA;ALqm/C3B;;AKpm/CA;EAA2B,gBAAA;ALwm/C3B;;AKvm/CA;EAAyB,gBAAA;AL2m/CzB;;AK1m/CA;EAAyB,gBAAA;AL8m/CzB;;AK7m/CA;EAA6B,gBAAA;ALin/C7B;;AKhn/CA;EAA6B,gBAAA;ALon/C7B;;AKnn/CA;EAAwB,gBAAA;ALun/CxB;;AKtn/CA;EAAwB,gBAAA;AL0n/CxB;;AKzn/CA;EAA2B,gBAAA;AL6n/C3B;;AK5n/CA;EAA2B,gBAAA;ALgo/C3B;;AK/n/CA;EAA6B,gBAAA;ALmo/C7B;;AKlo/CA;EAA6B,gBAAA;ALso/C7B;;AKro/CA;EAAuB,gBAAA;ALyo/CvB;;AKxo/CA;EAAuB,gBAAA;AL4o/CvB;;AK3o/CA;EAA2B,gBAAA;AL+o/C3B;;AK9o/CA;EAA2B,gBAAA;ALkp/C3B;;AKjp/CA;EAA2B,gBAAA;ALqp/C3B;;AKpp/CA;EAA2B,gBAAA;ALwp/C3B;;AKvp/CA;EAAyB,gBAAA;AL2p/CzB;;AK1p/CA;EAAyB,gBAAA;AL8p/CzB;;AK7p/CA;EAA0B,gBAAA;ALiq/C1B;;AKhq/CA;EAA0B,gBAAA;ALoq/C1B;;AKnq/CA;EAAwB,gBAAA;ALuq/CxB;;AKtq/CA;EAAwB,gBAAA;AL0q/CxB;;AKzq/CA;EAAoC,gBAAA;AL6q/CpC;;AK5q/CA;EAAoC,gBAAA;ALgr/CpC;;AK/q/CA;EAAwB,gBAAA;ALmr/CxB;;AKlr/CA;EAAwB,gBAAA;ALsr/CxB;;AKrr/CA;EAAwB,gBAAA;ALyr/CxB;;AKxr/CA;EAAuB,gBAAA;AL4r/CvB;;AK3r/CA;EAAuB,gBAAA;AL+r/CvB;;AK9r/CA;EAAuB,gBAAA;ALks/CvB;;AKjs/CA;EAAuB,gBAAA;ALqs/CvB;;AKps/CA;EAA0B,gBAAA;ALws/C1B;;AKvs/CA;EAA0B,gBAAA;AL2s/C1B;;AK1s/CA;EAAwB,gBAAA;AL8s/CxB;;AK7s/CA;EAAwB,gBAAA;ALit/CxB;;AKht/CA;EAAwB,gBAAA;ALot/CxB;;AKnt/CA;EAAwB,gBAAA;ALut/CxB;;AKtt/CA;EAA0B,gBAAA;AL0t/C1B;;AKzt/CA;EAA0B,gBAAA;AL6t/C1B;;AK5t/CA;EAA2B,gBAAA;ALgu/C3B;;AK/t/CA;EAA2B,gBAAA;ALmu/C3B;;AKlu/CA;EAAsB,gBAAA;ALsu/CtB;;AKru/CA;EAAsB,gBAAA;ALyu/CtB;;AMp/jDA;;;;;;;CAAA;ACCE;;;;;EAAA;ACDF;EAQI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,6BAAA;EAAA,gCAAA;EAAA,8BAAA;EAAA,2BAAA;EAAA,8BAAA;EAAA,6BAAA;EAAA,6BAAA;EAAA,yBAAA;EAGF,6BAAA;EACA,uBAAA;EACA,+BAAA;EACA,+BAAA;EAMA,6CAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC4PI,8BALI;EDrPR,0BAAA;EACA,0BAAA;EACA,wBAAA;EAIA,qBAAA;EAIA,sBAAA;EACA,wBAAA;EACA,yCAAA;EACA,mDAAA;EAEA,2BAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,8BAAA;EAGA,qCAAA;EACA,iDAAA;EAEA,wBAAA;EAEA,0BAAA;AR+/jDF;;AUvjkDA;;;EAGE,sBAAA;AV0jkDF;;AU3ikDI;EANJ;IAOM,uBAAA;EV+ikDJ;AACF;;AUlikDA;EACE,SAAA;EACA,uCAAA;EDmPI,mCALI;EC5OR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;AVqikDF;;AU5hkDA;EACE,cAAA;EACA,cCmsB4B;EDlsB5B,SAAA;EACA,qBAAA;EACA,aCusB4B;AXw1iD9B;;AUrhkDA;EACE,aAAA;EACA,qBC0oB4B;EDvoB5B,gBC0oB4B;EDzoB5B,gBC0oB4B;AX44iD9B;;AUlhkDA;ED6MQ,uCAAA;ATy0jDR;AS3+jDI;EC3CJ;IDoNQ,qBAAA;ETs0jDN;AACF;;AUthkDA;EDwMQ,mCAAA;ATk1jDR;ASp/jDI;ECtCJ;ID+MQ,mBAAA;ET+0jDN;AACF;;AU1hkDA;EDmMQ,yCAAA;AT21jDR;AS7/jDI;ECjCJ;ID0MQ,sBAAA;ETw1jDN;AACF;;AU9hkDA;ED0LM,qBALI;AT62jDV;;AU7hkDA;EDqLM,sBALI;ATi3jDV;;AU5hkDA;EDgLM,oBALI;ATq3jDV;;AUrhkDA;EACE,aAAA;EACA,mBCkb0B;AXsmjD5B;;AU9gkDA;EACE,iCAAA;EACA,YAAA;EACA,8BAAA;AVihkDF;;AU3gkDA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AV8gkDF;;AUxgkDA;;EAEE,kBAAA;AV2gkDF;;AUxgkDA;;;EAGE,aAAA;EACA,mBAAA;AV2gkDF;;AUxgkDA;;;;EAIE,gBAAA;AV2gkDF;;AUxgkDA;EACE,gBC8gB4B;AX6/iD9B;;AUtgkDA;EACE,qBAAA;EACA,cAAA;AVygkDF;;AUngkDA;EACE,gBAAA;AVsgkDF;;AU9/jDA;;EAEE,mBCwf4B;AXygjD9B;;AUz/jDA;EDmFM,kBALI;AT+6jDV;;AUt/jDA;EACE,cC2jB4B;ED1jB5B,wCAAA;AVy/jDF;;AUh/jDA;;EAEE,kBAAA;ED+DI,iBALI;ECxDR,cAAA;EACA,wBAAA;AVm/jDF;;AUh/jDA;EAAM,eAAA;AVo/jDN;;AUn/jDA;EAAM,WAAA;AVu/jDN;;AUl/jDA;EACE,2BAAA;EACA,0BCoTwC;AXisjD1C;AUn/jDE;EACE,iCAAA;AVq/jDJ;;AU1+jDE;EAEE,cAAA;EACA,qBAAA;AV4+jDJ;;AUr+jDA;;;;EAIE,qCCoa4B;EF/YxB,cALI;ATy9jDV;;AUj+jDA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EDSI,kBALI;ATi+jDV;AUh+jDE;EDII,kBALI;ECGN,cAAA;EACA,kBAAA;AVk+jDJ;;AU99jDA;EDHM,kBALI;ECUR,2BAAA;EACA,qBAAA;AVi+jDF;AU99jDE;EACE,cAAA;AVg+jDJ;;AU59jDA;EACE,sBAAA;EDfI,kBALI;ECsBR,WC5JS;ED6JT,yBCpJS;EChJP,qBAAA;AZowkDJ;AU79jDE;EACE,UAAA;EDtBE,cALI;EC6BN,gBCoY0B;AX2ljD9B;;AUt9jDA;EACE,gBAAA;AVy9jDF;;AUn9jDA;;EAEE,sBAAA;AVs9jDF;;AU98jDA;EACE,oBAAA;EACA,yBAAA;AVi9jDF;;AU98jDA;EACE,oBCuc4B;EDtc5B,uBCsc4B;EDrc5B,cC/LS;EDgMT,gBAAA;AVi9jDF;;AU18jDA;EAEE,mBAAA;EACA,gCAAA;AV48jDF;;AUz8jDA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;AV48jDF;;AUp8jDA;EACE,qBAAA;AVu8jDF;;AUj8jDA;EAEE,gBAAA;AVm8jDF;;AU37jDA;EACE,UAAA;AV87jDF;;AUz7jDA;;;;;EAKE,SAAA;EACA,oBAAA;EDrHI,kBALI;EC4HR,oBAAA;AV47jDF;;AUx7jDA;;EAEE,oBAAA;AV27jDF;;AUt7jDA;EACE,eAAA;AVy7jDF;;AUt7jDA;EAGE,iBAAA;AVu7jDF;AUp7jDE;EACE,UAAA;AVs7jDJ;;AU/6jDA;EACE,wBAAA;AVk7jDF;;AU16jDA;;;;EAIE,0BAAA;AV66jDF;AU16jDI;;;;EACE,eAAA;AV+6jDN;;AUx6jDA;EACE,UAAA;EACA,kBAAA;AV26jDF;;AUt6jDA;EACE,gBAAA;AVy6jDF;;AU/5jDA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;AVk6jDF;;AU15jDA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBC8R4B;EFxetB,iCAAA;ATwmkDR;AS1wkDI;ECwWJ;ID/LQ,iBAAA;ETqmkDN;AACF;AUv6jDA;EAOE,oBAAA;AVm6jDF;AUj6jDE;EACE,WAAA;AVm6jDJ;;AU55jDA;;;;;;;EAOE,UAAA;AV+5jDF;;AU55jDA;EACE,YAAA;AV+5jDF;;AUt5jDA;EACE,oBAAA;EACA,6BAAA;AVy5jDF;;AUj5jDA;;;;;;;CAAA;AAWA;EACE,wBAAA;AVi5jDF;;AU54jDA;EACE,UAAA;AV+4jDF;;AUx4jDA;EACE,aAAA;EACA,0BAAA;AV24jDF;;AUt4jDA;EACE,qBAAA;AVy4jDF;;AUp4jDA;EACE,SAAA;AVu4jDF;;AUh4jDA;EACE,kBAAA;EACA,eAAA;AVm4jDF;;AU33jDA;EACE,wBAAA;AV83jDF;;AUt3jDA;EACE,wBAAA;AVy3jDF;;Aa77kDA;EJyQM,sBALI;EIlQR,gBF0tB4B;AXsujD9B;;Aa37kDE;EJsQM,iCAAA;ATyrkDR;AS31kDI;EIpGF;IJ6QM,eAAA;ETsrkDN;AACF;Aap8kDE;EAIE,gBF2sBkB;EE1sBlB,gBF0rB0B;AXywjD9B;;Aax8kDE;EJsQM,iCAAA;ATsskDR;ASx2kDI;EIpGF;IJ6QM,iBAAA;ETmskDN;AACF;Aaj9kDE;EAIE,gBF2sBkB;EE1sBlB,gBF0rB0B;AXsxjD9B;;Aar9kDE;EJsQM,iCAAA;ATmtkDR;ASr3kDI;EIpGF;IJ6QM,eAAA;ETgtkDN;AACF;Aa99kDE;EAIE,gBF2sBkB;EE1sBlB,gBF0rB0B;AXmyjD9B;;Aal+kDE;EJsQM,iCAAA;ATgukDR;ASl4kDI;EIpGF;IJ6QM,iBAAA;ET6tkDN;AACF;Aa3+kDE;EAIE,gBF2sBkB;EE1sBlB,gBF0rB0B;AXgzjD9B;;Aa/+kDE;EJsQM,iCAAA;AT6ukDR;AS/4kDI;EIpGF;IJ6QM,eAAA;ET0ukDN;AACF;Aax/kDE;EAIE,gBF2sBkB;EE1sBlB,gBF0rB0B;AX6zjD9B;;Aa5/kDE;EJsQM,iCAAA;AT0vkDR;AS55kDI;EIpGF;IJ6QM,iBAAA;ETuvkDN;AACF;AarglDE;EAIE,gBF2sBkB;EE1sBlB,gBF0rB0B;AX00jD9B;;Aaj/kDA;ECvDE,eAAA;EACA,gBAAA;Ad4ilDF;;Aaj/kDA;EC5DE,eAAA;EACA,gBAAA;AdijlDF;;Aan/kDA;EACE,qBAAA;Abs/kDF;Aap/kDE;EACE,oBFktB0B;AXoyjD9B;;Aa5+kDA;EJoNM,kBALI;EI7MR,yBAAA;Ab++kDF;;Aa3+kDA;EACE,mBF0aO;EF7NH,qBALI;ATuykDV;Aa5+kDE;EACE,gBAAA;Ab8+kDJ;;Aa1+kDA;EACE,iBAAA;EACA,mBFgaO;EF7NH,kBALI;EI5LR,cF4DS;AXi7kDX;Aa3+kDE;EACE,aAAA;Ab6+kDJ;;Ae7klDA;ECIE,eAAA;EAGA,YAAA;AhB2klDF;;Ae5klDA;EACE,gBJqlDkC;EIplDlC,mCJqlDkC;EIplDlC,wCAAA;EHGE,sBAAA;EIRF,eAAA;EAGA,YAAA;AhBollDF;;AetklDA;EAEE,qBAAA;AfwklDF;;AerklDA;EACE,qBAAA;EACA,cAAA;AfwklDF;;AerklDA;EN+PM,kBALI;EMxPR,cJwHS;AXg9kDX;;AiB1mlDE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AlBunlDF;;AmBjklDI;EF5CE;IACE,gBN4jBe;EXqjkDrB;AACF;AmBvklDI;EF5CE;IACE,gBN4jBe;EX0jkDrB;AACF;AmB5klDI;EF5CE;IACE,gBN4jBe;EX+jkDrB;AACF;AmBjllDI;EF5CE;IACE,iBN4jBe;EXokkDrB;AACF;AmBtllDI;EF5CE;IACE,iBN4jBe;EXykkDrB;AACF;AoBrplDE;ECAA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;ArBuplDF;AoB3plDI;ECaF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;ArBiplDF;;AqBlmlDM;EACE,SAAA;ArBqmlDR;;AqBlmlDM;EApCJ,cAAA;EACA,WAAA;ArB0olDF;;AqB5nlDE;EACE,cAAA;EACA,WAAA;ArB+nlDJ;;AqBjolDE;EACE,cAAA;EACA,UAAA;ArBoolDJ;;AqBtolDE;EACE,cAAA;EACA,qBAAA;ArByolDJ;;AqB3olDE;EACE,cAAA;EACA,UAAA;ArB8olDJ;;AqBhplDE;EACE,cAAA;EACA,UAAA;ArBmplDJ;;AqBrplDE;EACE,cAAA;EACA,qBAAA;ArBwplDJ;;AqBznlDM;EAhDJ,cAAA;EACA,WAAA;ArB6qlDF;;AqBxnlDU;EAhEN,cAAA;EACA,kBAAA;ArB4rlDJ;;AqB7nlDU;EAhEN,cAAA;EACA,mBAAA;ArBislDJ;;AqBlolDU;EAhEN,cAAA;EACA,UAAA;ArBsslDJ;;AqBvolDU;EAhEN,cAAA;EACA,mBAAA;ArB2slDJ;;AqB5olDU;EAhEN,cAAA;EACA,mBAAA;ArBgtlDJ;;AqBjplDU;EAhEN,cAAA;EACA,UAAA;ArBqtlDJ;;AqBtplDU;EAhEN,cAAA;EACA,mBAAA;ArB0tlDJ;;AqB3plDU;EAhEN,cAAA;EACA,mBAAA;ArB+tlDJ;;AqBhqlDU;EAhEN,cAAA;EACA,UAAA;ArBoulDJ;;AqBrqlDU;EAhEN,cAAA;EACA,mBAAA;ArByulDJ;;AqB1qlDU;EAhEN,cAAA;EACA,mBAAA;ArB8ulDJ;;AqB/qlDU;EAhEN,cAAA;EACA,WAAA;ArBmvlDJ;;AqB5qlDY;EAxDV,wBAAA;ArBwulDF;;AqBhrlDY;EAxDV,yBAAA;ArB4ulDF;;AqBprlDY;EAxDV,gBAAA;ArBgvlDF;;AqBxrlDY;EAxDV,yBAAA;ArBovlDF;;AqB5rlDY;EAxDV,yBAAA;ArBwvlDF;;AqBhslDY;EAxDV,gBAAA;ArB4vlDF;;AqBpslDY;EAxDV,yBAAA;ArBgwlDF;;AqBxslDY;EAxDV,yBAAA;ArBowlDF;;AqB5slDY;EAxDV,gBAAA;ArBwwlDF;;AqBhtlDY;EAxDV,yBAAA;ArB4wlDF;;AqBptlDY;EAxDV,yBAAA;ArBgxlDF;;AqB7slDQ;;EAEE,gBAAA;ArBgtlDV;;AqB7slDQ;;EAEE,gBAAA;ArBgtlDV;;AqBvtlDQ;;EAEE,sBAAA;ArB0tlDV;;AqBvtlDQ;;EAEE,sBAAA;ArB0tlDV;;AqBjulDQ;;EAEE,qBAAA;ArBoulDV;;AqBjulDQ;;EAEE,qBAAA;ArBoulDV;;AqB3ulDQ;;EAEE,mBAAA;ArB8ulDV;;AqB3ulDQ;;EAEE,mBAAA;ArB8ulDV;;AqBrvlDQ;;EAEE,qBAAA;ArBwvlDV;;AqBrvlDQ;;EAEE,qBAAA;ArBwvlDV;;AqB/vlDQ;;EAEE,mBAAA;ArBkwlDV;;AqB/vlDQ;;EAEE,mBAAA;ArBkwlDV;;AmB5zlDI;EEUE;IACE,SAAA;ErBszlDN;EqBnzlDI;IApCJ,cAAA;IACA,WAAA;ErB01lDA;EqB50lDA;IACE,cAAA;IACA,WAAA;ErB80lDF;EqBh1lDA;IACE,cAAA;IACA,UAAA;ErBk1lDF;EqBp1lDA;IACE,cAAA;IACA,qBAAA;ErBs1lDF;EqBx1lDA;IACE,cAAA;IACA,UAAA;ErB01lDF;EqB51lDA;IACE,cAAA;IACA,UAAA;ErB81lDF;EqBh2lDA;IACE,cAAA;IACA,qBAAA;ErBk2lDF;EqBn0lDI;IAhDJ,cAAA;IACA,WAAA;ErBs3lDA;EqBj0lDQ;IAhEN,cAAA;IACA,kBAAA;ErBo4lDF;EqBr0lDQ;IAhEN,cAAA;IACA,mBAAA;ErBw4lDF;EqBz0lDQ;IAhEN,cAAA;IACA,UAAA;ErB44lDF;EqB70lDQ;IAhEN,cAAA;IACA,mBAAA;ErBg5lDF;EqBj1lDQ;IAhEN,cAAA;IACA,mBAAA;ErBo5lDF;EqBr1lDQ;IAhEN,cAAA;IACA,UAAA;ErBw5lDF;EqBz1lDQ;IAhEN,cAAA;IACA,mBAAA;ErB45lDF;EqB71lDQ;IAhEN,cAAA;IACA,mBAAA;ErBg6lDF;EqBj2lDQ;IAhEN,cAAA;IACA,UAAA;ErBo6lDF;EqBr2lDQ;IAhEN,cAAA;IACA,mBAAA;ErBw6lDF;EqBz2lDQ;IAhEN,cAAA;IACA,mBAAA;ErB46lDF;EqB72lDQ;IAhEN,cAAA;IACA,WAAA;ErBg7lDF;EqBz2lDU;IAxDV,cAAA;ErBo6lDA;EqB52lDU;IAxDV,wBAAA;ErBu6lDA;EqB/2lDU;IAxDV,yBAAA;ErB06lDA;EqBl3lDU;IAxDV,gBAAA;ErB66lDA;EqBr3lDU;IAxDV,yBAAA;ErBg7lDA;EqBx3lDU;IAxDV,yBAAA;ErBm7lDA;EqB33lDU;IAxDV,gBAAA;ErBs7lDA;EqB93lDU;IAxDV,yBAAA;ErBy7lDA;EqBj4lDU;IAxDV,yBAAA;ErB47lDA;EqBp4lDU;IAxDV,gBAAA;ErB+7lDA;EqBv4lDU;IAxDV,yBAAA;ErBk8lDA;EqB14lDU;IAxDV,yBAAA;ErBq8lDA;EqBl4lDM;;IAEE,gBAAA;ErBo4lDR;EqBj4lDM;;IAEE,gBAAA;ErBm4lDR;EqB14lDM;;IAEE,sBAAA;ErB44lDR;EqBz4lDM;;IAEE,sBAAA;ErB24lDR;EqBl5lDM;;IAEE,qBAAA;ErBo5lDR;EqBj5lDM;;IAEE,qBAAA;ErBm5lDR;EqB15lDM;;IAEE,mBAAA;ErB45lDR;EqBz5lDM;;IAEE,mBAAA;ErB25lDR;EqBl6lDM;;IAEE,qBAAA;ErBo6lDR;EqBj6lDM;;IAEE,qBAAA;ErBm6lDR;EqB16lDM;;IAEE,mBAAA;ErB46lDR;EqBz6lDM;;IAEE,mBAAA;ErB26lDR;AACF;AmBt+lDI;EEUE;IACE,SAAA;ErB+9lDN;EqB59lDI;IApCJ,cAAA;IACA,WAAA;ErBmgmDA;EqBr/lDA;IACE,cAAA;IACA,WAAA;ErBu/lDF;EqBz/lDA;IACE,cAAA;IACA,UAAA;ErB2/lDF;EqB7/lDA;IACE,cAAA;IACA,qBAAA;ErB+/lDF;EqBjgmDA;IACE,cAAA;IACA,UAAA;ErBmgmDF;EqBrgmDA;IACE,cAAA;IACA,UAAA;ErBugmDF;EqBzgmDA;IACE,cAAA;IACA,qBAAA;ErB2gmDF;EqB5+lDI;IAhDJ,cAAA;IACA,WAAA;ErB+hmDA;EqB1+lDQ;IAhEN,cAAA;IACA,kBAAA;ErB6imDF;EqB9+lDQ;IAhEN,cAAA;IACA,mBAAA;ErBijmDF;EqBl/lDQ;IAhEN,cAAA;IACA,UAAA;ErBqjmDF;EqBt/lDQ;IAhEN,cAAA;IACA,mBAAA;ErByjmDF;EqB1/lDQ;IAhEN,cAAA;IACA,mBAAA;ErB6jmDF;EqB9/lDQ;IAhEN,cAAA;IACA,UAAA;ErBikmDF;EqBlgmDQ;IAhEN,cAAA;IACA,mBAAA;ErBqkmDF;EqBtgmDQ;IAhEN,cAAA;IACA,mBAAA;ErBykmDF;EqB1gmDQ;IAhEN,cAAA;IACA,UAAA;ErB6kmDF;EqB9gmDQ;IAhEN,cAAA;IACA,mBAAA;ErBilmDF;EqBlhmDQ;IAhEN,cAAA;IACA,mBAAA;ErBqlmDF;EqBthmDQ;IAhEN,cAAA;IACA,WAAA;ErBylmDF;EqBlhmDU;IAxDV,cAAA;ErB6kmDA;EqBrhmDU;IAxDV,wBAAA;ErBglmDA;EqBxhmDU;IAxDV,yBAAA;ErBmlmDA;EqB3hmDU;IAxDV,gBAAA;ErBslmDA;EqB9hmDU;IAxDV,yBAAA;ErBylmDA;EqBjimDU;IAxDV,yBAAA;ErB4lmDA;EqBpimDU;IAxDV,gBAAA;ErB+lmDA;EqBvimDU;IAxDV,yBAAA;ErBkmmDA;EqB1imDU;IAxDV,yBAAA;ErBqmmDA;EqB7imDU;IAxDV,gBAAA;ErBwmmDA;EqBhjmDU;IAxDV,yBAAA;ErB2mmDA;EqBnjmDU;IAxDV,yBAAA;ErB8mmDA;EqB3imDM;;IAEE,gBAAA;ErB6imDR;EqB1imDM;;IAEE,gBAAA;ErB4imDR;EqBnjmDM;;IAEE,sBAAA;ErBqjmDR;EqBljmDM;;IAEE,sBAAA;ErBojmDR;EqB3jmDM;;IAEE,qBAAA;ErB6jmDR;EqB1jmDM;;IAEE,qBAAA;ErB4jmDR;EqBnkmDM;;IAEE,mBAAA;ErBqkmDR;EqBlkmDM;;IAEE,mBAAA;ErBokmDR;EqB3kmDM;;IAEE,qBAAA;ErB6kmDR;EqB1kmDM;;IAEE,qBAAA;ErB4kmDR;EqBnlmDM;;IAEE,mBAAA;ErBqlmDR;EqBllmDM;;IAEE,mBAAA;ErBolmDR;AACF;AmB/omDI;EEUE;IACE,SAAA;ErBwomDN;EqBromDI;IApCJ,cAAA;IACA,WAAA;ErB4qmDA;EqB9pmDA;IACE,cAAA;IACA,WAAA;ErBgqmDF;EqBlqmDA;IACE,cAAA;IACA,UAAA;ErBoqmDF;EqBtqmDA;IACE,cAAA;IACA,qBAAA;ErBwqmDF;EqB1qmDA;IACE,cAAA;IACA,UAAA;ErB4qmDF;EqB9qmDA;IACE,cAAA;IACA,UAAA;ErBgrmDF;EqBlrmDA;IACE,cAAA;IACA,qBAAA;ErBormDF;EqBrpmDI;IAhDJ,cAAA;IACA,WAAA;ErBwsmDA;EqBnpmDQ;IAhEN,cAAA;IACA,kBAAA;ErBstmDF;EqBvpmDQ;IAhEN,cAAA;IACA,mBAAA;ErB0tmDF;EqB3pmDQ;IAhEN,cAAA;IACA,UAAA;ErB8tmDF;EqB/pmDQ;IAhEN,cAAA;IACA,mBAAA;ErBkumDF;EqBnqmDQ;IAhEN,cAAA;IACA,mBAAA;ErBsumDF;EqBvqmDQ;IAhEN,cAAA;IACA,UAAA;ErB0umDF;EqB3qmDQ;IAhEN,cAAA;IACA,mBAAA;ErB8umDF;EqB/qmDQ;IAhEN,cAAA;IACA,mBAAA;ErBkvmDF;EqBnrmDQ;IAhEN,cAAA;IACA,UAAA;ErBsvmDF;EqBvrmDQ;IAhEN,cAAA;IACA,mBAAA;ErB0vmDF;EqB3rmDQ;IAhEN,cAAA;IACA,mBAAA;ErB8vmDF;EqB/rmDQ;IAhEN,cAAA;IACA,WAAA;ErBkwmDF;EqB3rmDU;IAxDV,cAAA;ErBsvmDA;EqB9rmDU;IAxDV,wBAAA;ErByvmDA;EqBjsmDU;IAxDV,yBAAA;ErB4vmDA;EqBpsmDU;IAxDV,gBAAA;ErB+vmDA;EqBvsmDU;IAxDV,yBAAA;ErBkwmDA;EqB1smDU;IAxDV,yBAAA;ErBqwmDA;EqB7smDU;IAxDV,gBAAA;ErBwwmDA;EqBhtmDU;IAxDV,yBAAA;ErB2wmDA;EqBntmDU;IAxDV,yBAAA;ErB8wmDA;EqBttmDU;IAxDV,gBAAA;ErBixmDA;EqBztmDU;IAxDV,yBAAA;ErBoxmDA;EqB5tmDU;IAxDV,yBAAA;ErBuxmDA;EqBptmDM;;IAEE,gBAAA;ErBstmDR;EqBntmDM;;IAEE,gBAAA;ErBqtmDR;EqB5tmDM;;IAEE,sBAAA;ErB8tmDR;EqB3tmDM;;IAEE,sBAAA;ErB6tmDR;EqBpumDM;;IAEE,qBAAA;ErBsumDR;EqBnumDM;;IAEE,qBAAA;ErBqumDR;EqB5umDM;;IAEE,mBAAA;ErB8umDR;EqB3umDM;;IAEE,mBAAA;ErB6umDR;EqBpvmDM;;IAEE,qBAAA;ErBsvmDR;EqBnvmDM;;IAEE,qBAAA;ErBqvmDR;EqB5vmDM;;IAEE,mBAAA;ErB8vmDR;EqB3vmDM;;IAEE,mBAAA;ErB6vmDR;AACF;AmBxzmDI;EEUE;IACE,SAAA;ErBizmDN;EqB9ymDI;IApCJ,cAAA;IACA,WAAA;ErBq1mDA;EqBv0mDA;IACE,cAAA;IACA,WAAA;ErBy0mDF;EqB30mDA;IACE,cAAA;IACA,UAAA;ErB60mDF;EqB/0mDA;IACE,cAAA;IACA,qBAAA;ErBi1mDF;EqBn1mDA;IACE,cAAA;IACA,UAAA;ErBq1mDF;EqBv1mDA;IACE,cAAA;IACA,UAAA;ErBy1mDF;EqB31mDA;IACE,cAAA;IACA,qBAAA;ErB61mDF;EqB9zmDI;IAhDJ,cAAA;IACA,WAAA;ErBi3mDA;EqB5zmDQ;IAhEN,cAAA;IACA,kBAAA;ErB+3mDF;EqBh0mDQ;IAhEN,cAAA;IACA,mBAAA;ErBm4mDF;EqBp0mDQ;IAhEN,cAAA;IACA,UAAA;ErBu4mDF;EqBx0mDQ;IAhEN,cAAA;IACA,mBAAA;ErB24mDF;EqB50mDQ;IAhEN,cAAA;IACA,mBAAA;ErB+4mDF;EqBh1mDQ;IAhEN,cAAA;IACA,UAAA;ErBm5mDF;EqBp1mDQ;IAhEN,cAAA;IACA,mBAAA;ErBu5mDF;EqBx1mDQ;IAhEN,cAAA;IACA,mBAAA;ErB25mDF;EqB51mDQ;IAhEN,cAAA;IACA,UAAA;ErB+5mDF;EqBh2mDQ;IAhEN,cAAA;IACA,mBAAA;ErBm6mDF;EqBp2mDQ;IAhEN,cAAA;IACA,mBAAA;ErBu6mDF;EqBx2mDQ;IAhEN,cAAA;IACA,WAAA;ErB26mDF;EqBp2mDU;IAxDV,cAAA;ErB+5mDA;EqBv2mDU;IAxDV,wBAAA;ErBk6mDA;EqB12mDU;IAxDV,yBAAA;ErBq6mDA;EqB72mDU;IAxDV,gBAAA;ErBw6mDA;EqBh3mDU;IAxDV,yBAAA;ErB26mDA;EqBn3mDU;IAxDV,yBAAA;ErB86mDA;EqBt3mDU;IAxDV,gBAAA;ErBi7mDA;EqBz3mDU;IAxDV,yBAAA;ErBo7mDA;EqB53mDU;IAxDV,yBAAA;ErBu7mDA;EqB/3mDU;IAxDV,gBAAA;ErB07mDA;EqBl4mDU;IAxDV,yBAAA;ErB67mDA;EqBr4mDU;IAxDV,yBAAA;ErBg8mDA;EqB73mDM;;IAEE,gBAAA;ErB+3mDR;EqB53mDM;;IAEE,gBAAA;ErB83mDR;EqBr4mDM;;IAEE,sBAAA;ErBu4mDR;EqBp4mDM;;IAEE,sBAAA;ErBs4mDR;EqB74mDM;;IAEE,qBAAA;ErB+4mDR;EqB54mDM;;IAEE,qBAAA;ErB84mDR;EqBr5mDM;;IAEE,mBAAA;ErBu5mDR;EqBp5mDM;;IAEE,mBAAA;ErBs5mDR;EqB75mDM;;IAEE,qBAAA;ErB+5mDR;EqB55mDM;;IAEE,qBAAA;ErB85mDR;EqBr6mDM;;IAEE,mBAAA;ErBu6mDR;EqBp6mDM;;IAEE,mBAAA;ErBs6mDR;AACF;AmBj+mDI;EEUE;IACE,SAAA;ErB09mDN;EqBv9mDI;IApCJ,cAAA;IACA,WAAA;ErB8/mDA;EqBh/mDA;IACE,cAAA;IACA,WAAA;ErBk/mDF;EqBp/mDA;IACE,cAAA;IACA,UAAA;ErBs/mDF;EqBx/mDA;IACE,cAAA;IACA,qBAAA;ErB0/mDF;EqB5/mDA;IACE,cAAA;IACA,UAAA;ErB8/mDF;EqBhgnDA;IACE,cAAA;IACA,UAAA;ErBkgnDF;EqBpgnDA;IACE,cAAA;IACA,qBAAA;ErBsgnDF;EqBv+mDI;IAhDJ,cAAA;IACA,WAAA;ErB0hnDA;EqBr+mDQ;IAhEN,cAAA;IACA,kBAAA;ErBwinDF;EqBz+mDQ;IAhEN,cAAA;IACA,mBAAA;ErB4inDF;EqB7+mDQ;IAhEN,cAAA;IACA,UAAA;ErBgjnDF;EqBj/mDQ;IAhEN,cAAA;IACA,mBAAA;ErBojnDF;EqBr/mDQ;IAhEN,cAAA;IACA,mBAAA;ErBwjnDF;EqBz/mDQ;IAhEN,cAAA;IACA,UAAA;ErB4jnDF;EqB7/mDQ;IAhEN,cAAA;IACA,mBAAA;ErBgknDF;EqBjgnDQ;IAhEN,cAAA;IACA,mBAAA;ErBoknDF;EqBrgnDQ;IAhEN,cAAA;IACA,UAAA;ErBwknDF;EqBzgnDQ;IAhEN,cAAA;IACA,mBAAA;ErB4knDF;EqB7gnDQ;IAhEN,cAAA;IACA,mBAAA;ErBglnDF;EqBjhnDQ;IAhEN,cAAA;IACA,WAAA;ErBolnDF;EqB7gnDU;IAxDV,cAAA;ErBwknDA;EqBhhnDU;IAxDV,wBAAA;ErB2knDA;EqBnhnDU;IAxDV,yBAAA;ErB8knDA;EqBthnDU;IAxDV,gBAAA;ErBilnDA;EqBzhnDU;IAxDV,yBAAA;ErBolnDA;EqB5hnDU;IAxDV,yBAAA;ErBulnDA;EqB/hnDU;IAxDV,gBAAA;ErB0lnDA;EqBlinDU;IAxDV,yBAAA;ErB6lnDA;EqBrinDU;IAxDV,yBAAA;ErBgmnDA;EqBxinDU;IAxDV,gBAAA;ErBmmnDA;EqB3inDU;IAxDV,yBAAA;ErBsmnDA;EqB9inDU;IAxDV,yBAAA;ErBymnDA;EqBtinDM;;IAEE,gBAAA;ErBwinDR;EqBrinDM;;IAEE,gBAAA;ErBuinDR;EqB9inDM;;IAEE,sBAAA;ErBgjnDR;EqB7inDM;;IAEE,sBAAA;ErB+inDR;EqBtjnDM;;IAEE,qBAAA;ErBwjnDR;EqBrjnDM;;IAEE,qBAAA;ErBujnDR;EqB9jnDM;;IAEE,mBAAA;ErBgknDR;EqB7jnDM;;IAEE,mBAAA;ErB+jnDR;EqBtknDM;;IAEE,qBAAA;ErBwknDR;EqBrknDM;;IAEE,qBAAA;ErBuknDR;EqB9knDM;;IAEE,mBAAA;ErBglnDR;EqB7knDM;;IAEE,mBAAA;ErB+knDR;AACF;AsBrsnDA;EACE,sCAAA;EACA,0BAAA;EACA,+CAAA;EACA,iCAAA;EACA,8CAAA;EACA,qDAAA;EACA,6CAAA;EACA,kDAAA;EACA,4CAAA;EACA,iDAAA;EAEA,WAAA;EACA,mBXifO;EWhfP,4BAAA;EACA,mBXsxB4B;EWrxB5B,0CAAA;AtBssnDF;AsB/rnDE;EACE,uBAAA;EACA,oCAAA;EACA,wBXklB0B;EWjlB1B,wDAAA;AtBisnDJ;AsB9rnDE;EACE,uBAAA;AtBgsnDJ;AsB7rnDE;EACE,sBAAA;AtB+rnDJ;;AsB3rnDA;EACE,4CAAA;AtB8rnDF;;AsBvrnDA;EACE,iBAAA;AtB0rnDF;;AsBhrnDE;EACE,uBAAA;AtBmrnDJ;;AsBpqnDE;EACE,mBAAA;AtBuqnDJ;AsBpqnDI;EACE,mBAAA;AtBsqnDN;;AsB/pnDE;EACE,sBAAA;AtBkqnDJ;AsB/pnDE;EACE,mBAAA;AtBiqnDJ;;AsBvpnDE;EACE,gDAAA;EACA,oCAAA;AtB0pnDJ;;AsBppnDE;EACE,gDAAA;EACA,oCAAA;AtBupnDJ;;AsB/onDA;EACE,+CAAA;EACA,mCAAA;AtBkpnDF;;AsB1onDE;EACE,8CAAA;EACA,kCAAA;AtB6onDJ;;AuBlxnDE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,qDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvB8wnDJ;;AuBhynDE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,qDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvB4xnDJ;;AuB9ynDE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,oDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvB0ynDJ;;AuB5znDE;EAOE,sBAAA;EACA,uCAAA;EACA,oDAAA;EACA,qDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvBwznDJ;;AuB10nDE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,oDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvBs0nDJ;;AuBx1nDE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,oDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvBo1nDJ;;AuBt2nDE;EAOE,sBAAA;EACA,sBAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvBk2nDJ;;AuBp3nDE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,+CAAA;EACA,8BAAA;EACA,2BAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AvBg3nDJ;;AsBtunDI;EACE,gBAAA;EACA,iCAAA;AtByunDN;;AmB7znDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EtB+unDJ;AACF;AmBp0nDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EtBqvnDJ;AACF;AmB10nDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EtB2vnDJ;AACF;AmBh1nDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EtBiwnDJ;AACF;AmBt1nDI;EGkFA;IACE,gBAAA;IACA,iCAAA;EtBuwnDJ;AACF;AwBp6nDA;EACE,qBb+6BsC;AXu/lDxC;;AwB75nDA;EACE,+BAAA;EACA,kCAAA;EACA,gBAAA;EfoRI,kBALI;Ee3QR,gBbirB4B;AX6umD9B;;AwB15nDA;EACE,+BAAA;EACA,kCAAA;Ef0QI,sBALI;ATypnDV;;AwB15nDA;EACE,gCAAA;EACA,mCAAA;EfoQI,uBALI;AT+pnDV;;AyB37nDA;EACE,mBdu6BsC;EFvoBlC,kBALI;EgBvRR,cduJS;AXqynDX;;A0Bj8nDA;EACE,cAAA;EACA,WAAA;EACA,sBAAA;EjB8RI,oBALI;EiBtRR,gBfqrB4B;EeprB5B,gBf2rB4B;Ee1rB5B,2Bfo8BsC;Een8BtC,oCf87BsC;Ee77BtC,4BAAA;EACA,wCAAA;EACA,gBAAA;EdGE,sBAAA;EeHE,wEDMJ;A1B+7nDF;A2Bj8nDM;EDhBN;ICiBQ,gBAAA;E3Bo8nDN;AACF;A0Bl8nDE;EACE,gBAAA;A1Bo8nDJ;A0Bl8nDI;EACE,eAAA;A1Bo8nDN;A0B/7nDE;EACE,2Bf86BoC;Ee76BpC,oCfw6BoC;Eev6BpC,0Cfs7BoC;Eer7BpC,UAAA;EAKE,2Cf8zB0B;AX+nmDhC;A0Bt7nDE;EAEE,aAAA;A1Bu7nDJ;A0Bn7nDE;EACE,cfwGO;EetGP,UAAA;A1Bo7nDJ;A0B56nDE;EAEE,6Cfy4BoC;Eet4BpC,UAAA;A1B26nDJ;A0Bv6nDE;EACE,sBAAA;EACA,uBAAA;EACA,yBfixB0B;EehxB1B,2Bfi4BoC;EiB58BtC,gDjBqiCsC;Eex9BpC,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,4Bf2hB0B;Ee1hB1B,gBAAA;ECtEE,qIDuEF;A1By6nDJ;A2B5+nDM;EDuDJ;ICtDM,gBAAA;E3B++nDN;AACF;A0B36nDE;EACE,gDf88BoC;AX+9lDxC;;A0Bp6nDA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBf6lB4B;Ee5lB5B,2Bfs3BsC;Eer3BtC,6BAAA;EACA,yBAAA;EACA,mBAAA;A1Bu6nDF;A0Br6nDE;EACE,UAAA;A1Bu6nDJ;A0Bp6nDE;EAEE,gBAAA;EACA,eAAA;A1Bq6nDJ;;A0B15nDA;EACE,sCfu2BsC;Eet2BtC,uBAAA;EjBkKI,uBALI;EG7QN,qBAAA;AZ+goDJ;A0B35nDE;EACE,uBAAA;EACA,wBAAA;EACA,yBfiuB0B;AX4rmD9B;;A0Bz5nDA;EACE,sCf21BsC;Ee11BtC,sBAAA;EjBqJI,sBALI;EG7QN,qBAAA;AZ2hoDJ;A0B15nDE;EACE,sBAAA;EACA,uBAAA;EACA,yBfwtB0B;AXosmD9B;;A0Bp5nDE;EACE,oCfw0BoC;AX+kmDxC;A0Bp5nDE;EACE,sCfq0BoC;AXilmDxC;A0Bn5nDE;EACE,sCfk0BoC;AXmlmDxC;;A0Bh5nDA;EACE,Wf+zBsC;Ee9zBtC,gCfyzBsC;EexzBtC,ef8qB4B;AXqumD9B;A0Bj5nDE;EACE,eAAA;A1Bm5nDJ;A0Bh5nDE;EACE,oBAAA;EdpKA,sBAAA;AZujoDJ;A0B/4nDE;EdxKE,sBAAA;AZ0joDJ;A0B94nDE;EAAoB,kCf0yBkB;AXummDxC;A0Bh5nDE;EAAoB,kCf0yBkB;AXymmDxC;;A6B9koDA;EACE,cAAA;EACA,WAAA;EACA,oCAAA;EACA,sCAAA;EpB4RI,oBALI;EoBpRR,gBlBmrB4B;EkBlrB5B,gBlByrB4B;EkBxrB5B,2BlBk8BsC;EkBj8BtC,oClB47BsC;EkB37BtC,0DAAA;EACA,4BAAA;EACA,wClBwiCkC;EkBviClC,0BlBwiCkC;EkBviClC,wCAAA;EjBDE,sBAAA;EeHE,wEEOJ;A7B+koDF;A2BlloDM;EEfN;IFgBQ,gBAAA;E3BqloDN;AACF;A6BtmoDA;EAmBE,gBAAA;A7BsloDF;A6BploDE;EACE,0ClB+7BoC;EkB97BpC,UAAA;EAKE,2ClByiC4B;AXyimDlC;A6B9koDE;EAEE,qBlBwzB0B;EkBvzB1B,sBAAA;A7B+koDJ;A6B5koDE;EAEE,6ClBg6BoC;AX6qmDxC;A6BxkoDE;EACE,kBAAA;EACA,uCAAA;A7B0koDJ;;A6BtkoDA;EACE,oBlBizB4B;EkBhzB5B,uBlBgzB4B;EkB/yB5B,oBlBgzB4B;EFtkBxB,uBALI;EG7QN,qBAAA;AZmnoDJ;;A6BtkoDA;EACE,mBlB6yB4B;EkB5yB5B,sBlB4yB4B;EkB3yB5B,oBlB4yB4B;EF1kBxB,sBALI;EG7QN,qBAAA;AZ2noDJ;;A8B1ooDA;EACE,cAAA;EACA,sBnB4+BwC;EmB3+BxC,mBnB4+BwC;EmB3+BxC,uBnB4+BwC;AXiqmD1C;A8B3ooDE;EACE,WAAA;EACA,mBAAA;A9B6ooDJ;;A8BzooDA;EACE,oBnBk+BwC;EmBj+BxC,eAAA;EACA,iBAAA;A9B4ooDF;A8B1ooDE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;A9B4ooDJ;;A8BxooDA;EACE,YnBo9BwC;EmBn9BxC,anBm9BwC;EmBl9BxC,iBAAA;EACA,mBAAA;EACA,oCnB06BsC;EmBz6BtC,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,8CnBu9BwC;EmBt9BxC,gBAAA;EACA,yBAAA;A9B2ooDF;A8BxooDE;ElBvBE,qBAAA;AZkqoDJ;A8BvooDE;EAEE,kBnB88BsC;AX0rmD1C;A8BrooDE;EACE,uBnBq8BsC;AXksmD1C;A8BpooDE;EACE,0CnBk6BoC;EmBj6BpC,UAAA;EACA,2CnB8yB4B;AXw1mDhC;A8BnooDE;EACE,yBnB0HS;EmBzHT,qBnByHS;AX4goDb;A8BnooDI;EAII,0DAAA;A9BkooDR;A8B9noDI;EAII,0DAAA;A9B6noDR;A8BxnoDE;EACE,yBnBqGS;EmBpGT,qBnBoGS;EmB/FP,0DAAA;A9BsnoDN;A8BlnoDE;EACE,oBAAA;EACA,YAAA;EACA,YnB66BuC;AXusmD3C;A8B7moDI;EACE,eAAA;EACA,YnBo6BqC;AX2smD3C;;A8BjmoDA;EACE,mBnB+5BgC;AXqsmDlC;A8BlmoDE;EACE,UnB25B8B;EmB15B9B,mBAAA;EACA,0DAAA;EACA,gCAAA;ElB3GA,kBAAA;EeHE,iDGgHF;A9BomoDJ;A2BhtoDM;EGsGJ;IHrGM,gBAAA;E3BmtoDN;AACF;A8BvmoDI;EACE,0DAAA;A9BymoDN;A8BtmoDI;EACE,iCnB05B4B;EmBr5B1B,0DAAA;A9BomoDR;A8B/loDE;EACE,oBnBq4B8B;EmBp4B9B,eAAA;A9BimoDJ;A8B/loDI;EACE,oBAAA;EACA,cAAA;A9BimoDN;;A8B5loDA;EACE,qBAAA;EACA,kBnBm3BgC;AX4umDlC;;A8B5loDA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;A9B+loDF;A8B3loDI;EACE,oBAAA;EACA,YAAA;EACA,anBquBwB;AXw3mD9B;;A+BlwoDA;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;A/BqwoDF;A+BnwoDE;EACE,UAAA;A/BqwoDJ;A+BjwoDI;EAA0B,8DpBqlCa;AX+qmD3C;A+BnwoDI;EAA0B,8DpBolCa;AXkrmD3C;A+BnwoDE;EACE,SAAA;A/BqwoDJ;A+BlwoDE;EACE,WpBskCuC;EoBrkCvC,YpBqkCuC;EoBpkCvC,oBAAA;EHzBF,yBjBoLW;EoBzJT,SpBqkCuC;ECjlCvC,mBAAA;EeHE,oHIkBF;EJlBE,4GIkBF;A/BmwoDJ;A2BjxoDM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;E3BoxoDN;AACF;A+BhxoDE;EASE,gBAAA;A/B0woDJ;A+BxwoDI;EHjCF,0CjBqmCyC;AXusmD3C;A+BtwoDE;EACE,WpB+iC8B;EoB9iC9B,cpB+iC8B;EoB9iC9B,kBAAA;EACA,epB8iC8B;EoB7iC9B,oCpB8iC8B;EoB7iC9B,yBAAA;EnB7BA,mBAAA;AZsyoDJ;A+BpwoDE;EACE,WpB2iCuC;EoB1iCvC,YpB0iCuC;EiB7lCzC,yBjBoLW;EoB/HT,SpB2iCuC;ECjlCvC,mBAAA;EeHE,iHI4CF;EJ5CE,4GI4CF;A/BqwoDJ;A2B7yoDM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;E3BgzoDN;AACF;A+BjxoDE;EAQE,gBAAA;A/B4woDJ;A+B1woDI;EH3DF,0CjBqmCyC;AXmumD3C;A+BxwoDE;EACE,WpBqhC8B;EoBphC9B,cpBqhC8B;EoBphC9B,kBAAA;EACA,epBohC8B;EoBnhC9B,oCpBohC8B;EoBnhC9B,yBAAA;EnBvDA,mBAAA;AZk0oDJ;A+BtwoDE;EACE,oBAAA;A/BwwoDJ;A+BtwoDI;EACE,yBpB4EK;AX4roDX;A+BrwoDI;EACE,yBpBwEK;AX+roDX;;AgC91oDA;EACE,kBAAA;AhCi2oDF;AgC/1oDE;;;EAGE,0BrB+mC8B;EqB9mC9B,iBrB+mC8B;AXkvmDlC;AgC91oDE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,qBAAA;ELPE,gEKQF;AhCg2oDJ;A2Bp2oDM;EKVJ;ILWM,gBAAA;E3Bu2oDN;AACF;AgCl2oDE;;EAEE,oBAAA;AhCo2oDJ;AgCl2oDI;;EACE,kBAAA;AhCq2oDN;AgCl2oDI;;;EAEE,qBrBolC4B;EqBnlC5B,wBrBolC4B;AXixmDlC;AgCl2oDI;;EACE,qBrB+kC4B;EqB9kC5B,wBrB+kC4B;AXsxmDlC;AgCj2oDE;EACE,qBrBykC8B;EqBxkC9B,wBrBykC8B;AX0xmDlC;AgC51oDI;;;;EACE,arBkkC4B;EqBjkC5B,8DrBkkC4B;AX+xmDlC;AgC51oDI;EACE,arB2jC4B;EqB1jC5B,8DrB2jC4B;AXmymDlC;AgCz1oDI;EACE,mBAAA;AhC21oDN;;AiC95oDA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;AjCi6oDF;AiC/5oDE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AjCi6oDJ;AiC75oDE;;;EAGE,UAAA;AjC+5oDJ;AiCz5oDE;EACE,kBAAA;EACA,UAAA;AjC25oDJ;AiCz5oDI;EACE,UAAA;AjC25oDN;;AiCh5oDA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;ExBoPI,oBALI;EwB7OR,gBtB4oB4B;EsB3oB5B,gBtBkpB4B;EsBjpB5B,2BtB25BsC;EsB15BtC,kBAAA;EACA,mBAAA;EACA,gDtBi/BsC;EsBh/BtC,wCAAA;ErBtCE,sBAAA;AZ07oDJ;;AiC14oDA;;;;EAIE,sBAAA;ExB8NI,sBALI;EG7QN,qBAAA;AZm8oDJ;;AiC14oDA;;;;EAIE,uBAAA;ExBqNI,uBALI;EG7QN,qBAAA;AZ48oDJ;;AiC14oDA;;EAEE,qBAAA;AjC64oDF;;AiCh4oDI;;;;ErBjEA,0BAAA;EACA,6BAAA;AZw8oDJ;AiC/3oDI;;;;ErB1EA,0BAAA;EACA,6BAAA;AZ+8oDJ;AiCz3oDE;EACE,iBAAA;ErB1EA,yBAAA;EACA,4BAAA;AZs8oDJ;AiCz3oDE;;ErB9EE,yBAAA;EACA,4BAAA;AZ28oDJ;;AkCp+oDE;EACE,aAAA;EACA,WAAA;EACA,mBvBg5BoC;EFvoBlC,kBALI;EyBjQN,cvBinCqB;AXq3mDzB;;AkCn+oDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EzB4PE,uBALI;EyBpPN,WAvBc;EAwBd,yCAvBiB;EtBHjB,qBAAA;AZggpDJ;;AkCj+oDI;;;;EAEE,cAAA;AlCs+oDN;;AkCphpDI;EAoDE,qBvBslCmB;EuBnlCjB,iCvBu6BgC;EuBt6BhC,0DAAA;EACA,4BAAA;EACA,yDAAA;EACA,4DAAA;AlCk+oDR;AkC/9oDM;EACE,qBvB2kCiB;EuB1kCjB,4CA/Ca;AlCghpDrB;;AkCjipDI;EAyEI,iCvBq5BgC;EuBp5BhC,8EAAA;AlC49oDR;;AkCtipDI;EAiFE,qBvByjCmB;AXg6mDzB;AkCt9oDQ;EAEE,sBvBm+B8B;EuBl+B9B,oGAAA;EACA,6DAAA;EACA,uEAAA;AlCu9oDV;AkCn9oDM;EACE,qBvB4iCiB;EuB3iCjB,4CA9Ea;AlCmipDrB;;AkCpjpDI;EAuGI,sCAAA;AlCi9oDR;;AkCxjpDI;EA8GE,qBvB4hCmB;AXk7mDzB;AkC58oDM;EACE,yBvByhCiB;AXq7mDzB;AkC38oDM;EACE,4CApGa;AlCijpDrB;AkC18oDM;EACE,cvBihCiB;AX27mDzB;;AkCv8oDI;EACE,kBAAA;AlC08oDN;;AkCzkpDI;;;;;EAyIM,UAAA;AlCw8oDV;;AkC9jpDE;EACE,aAAA;EACA,WAAA;EACA,mBvBg5BoC;EFvoBlC,kBALI;EyBjQN,cvBinCqB;AX+8mDzB;;AkC7jpDE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EzB4PE,uBALI;EyBpPN,WAvBc;EAwBd,yCAvBiB;EtBHjB,qBAAA;AZ0lpDJ;;AkC3jpDI;;;;EAEE,cAAA;AlCgkpDN;;AkC9mpDI;EAoDE,qBvBslCmB;EuBnlCjB,iCvBu6BgC;EuBt6BhC,0DAAA;EACA,4BAAA;EACA,yDAAA;EACA,4DAAA;AlC4jpDR;AkCzjpDM;EACE,qBvB2kCiB;EuB1kCjB,4CA/Ca;AlC0mpDrB;;AkC3npDI;EAyEI,iCvBq5BgC;EuBp5BhC,8EAAA;AlCsjpDR;;AkChopDI;EAiFE,qBvByjCmB;AX0/mDzB;AkChjpDQ;EAEE,sBvBm+B8B;EuBl+B9B,oGAAA;EACA,6DAAA;EACA,uEAAA;AlCijpDV;AkC7ipDM;EACE,qBvB4iCiB;EuB3iCjB,4CA9Ea;AlC6npDrB;;AkC9opDI;EAuGI,sCAAA;AlC2ipDR;;AkClppDI;EA8GE,qBvB4hCmB;AX4gnDzB;AkCtipDM;EACE,yBvByhCiB;AX+gnDzB;AkCripDM;EACE,4CApGa;AlC2opDrB;AkCpipDM;EACE,cvBihCiB;AXqhnDzB;;AkCjipDI;EACE,kBAAA;AlCoipDN;;AkCnqpDI;;;;;EA2IM,UAAA;AlCgipDV;;AmC7qpDA;EAEE,0BAAA;EACA,0BAAA;EACA,sBAAA;E1B6RI,6BALI;E0BtRR,yBAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,kCAAA;EACA,+BAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,2EAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E1B4QI,kCALI;E0BrQR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;AnC2qpDF;A2B/rpDM;EQhBN;IRiBQ,gBAAA;E3BkspDN;AACF;AmC9qpDE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;AnC+qpDJ;AmC5qpDE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;AnC6qpDJ;AmC1qpDE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;AnCwqpDN;AmCpqpDE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;AnCkqpDN;AmC9ppDE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;AnC0ppDJ;AmCvppDI;EAKI,0CAAA;AnCqppDR;AmChppDE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;AnC+opDJ;;AmCnopDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,mDAAA;EACA,uCAAA;EACA,2BAAA;EACA,0CAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApC6upDF;;AmCpppDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,mDAAA;EACA,uCAAA;EACA,2BAAA;EACA,0CAAA;EACA,uDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApC8vpDF;;AmCrqpDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApC+wpDF;;AmCtrpDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,2CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCgypDF;;AmCvspDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,kDAAA;EACA,wCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCizpDF;;AmCxtpDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,iDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCk0pDF;;AmCzupDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,6CAAA;EACA,qDAAA;EACA,wCAAA;EACA,2BAAA;EACA,4CAAA;EACA,wDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCm1pDF;;AmC1vpDE;ECtGA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;ApCo2pDF;;AmCjvpDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC41pDF;;AmClwpDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC62pDF;;AmCnxpDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC83pDF;;AmCpypDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApC+4pDF;;AmCrzpDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCg6pDF;;AmCt0pDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCi7pDF;;AmCv1pDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCk8pDF;;AmCx2pDE;ECvGA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;ApCm9pDF;;AmC72pDA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,yBAAA;EACA,uCAAA;EAEA,0BxB0XwC;AXq/oD1C;AmCr2pDE;EACE,0BAAA;AnCu2pDJ;AmCp2pDE;EACE,gCAAA;AnCs2pDJ;;AmC31pDA;ECxIE,0BAAA;EACA,0BAAA;E3BoOI,+BALI;E2B7NR,8BAAA;ApCu+pDF;;AmC91pDA;EC5IE,2BAAA;EACA,0BAAA;E3BoOI,gCALI;E2B7NR,8BAAA;ApC8+pDF;;AqCjjqDA;EVgBM,gCUfJ;ArCojqDF;A2BjiqDM;EUpBN;IVqBQ,gBAAA;E3BoiqDN;AACF;AqCvjqDE;EACE,UAAA;ArCyjqDJ;;AqCnjqDE;EACE,aAAA;ArCsjqDJ;;AqCljqDA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;ArCqjqDF;A2BnjqDM;EULN;IVMQ,gBAAA;E3BsjqDN;AACF;AqCxjqDE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;ArC0jqDJ;A2B7jqDM;EUAJ;IVCM,gBAAA;E3BgkqDN;AACF;;AsCrlqDA;;;;;;EAME,kBAAA;AtCwlqDF;;AsCrlqDA;EACE,mBAAA;AtCwlqDF;;AsCjlqDA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E7B6QI,kCALI;E6BtQR,yCAAA;EACA,sBAAA;EACA,kDAAA;EACA,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,gDAAA;EACA,sCAAA;EACA,2DAAA;EACA,iCAAA;EACA,qDAAA;EACA,oCAAA;EACA,sDAAA;EACA,qCAAA;EACA,0CAAA;EACA,oCAAA;EACA,qCAAA;EACA,mCAAA;EACA,sCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E7BgPI,uCALI;E6BzOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;AZ2nqDJ;AsC9kqDE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AtCglqDJ;;AsCxjqDI;EACE,oBAAA;AtC2jqDN;AsCzjqDM;EACE,WAAA;EACA,OAAA;AtC2jqDR;;AsCvjqDI;EACE,kBAAA;AtC0jqDN;AsCxjqDM;EACE,QAAA;EACA,UAAA;AtC0jqDR;;AmBpmqDI;EmB4BA;IACE,oBAAA;EtC4kqDJ;EsC1kqDI;IACE,WAAA;IACA,OAAA;EtC4kqDN;EsCxkqDE;IACE,kBAAA;EtC0kqDJ;EsCxkqDI;IACE,QAAA;IACA,UAAA;EtC0kqDN;AACF;AmBrnqDI;EmB4BA;IACE,oBAAA;EtC4lqDJ;EsC1lqDI;IACE,WAAA;IACA,OAAA;EtC4lqDN;EsCxlqDE;IACE,kBAAA;EtC0lqDJ;EsCxlqDI;IACE,QAAA;IACA,UAAA;EtC0lqDN;AACF;AmBroqDI;EmB4BA;IACE,oBAAA;EtC4mqDJ;EsC1mqDI;IACE,WAAA;IACA,OAAA;EtC4mqDN;EsCxmqDE;IACE,kBAAA;EtC0mqDJ;EsCxmqDI;IACE,QAAA;IACA,UAAA;EtC0mqDN;AACF;AmBrpqDI;EmB4BA;IACE,oBAAA;EtC4nqDJ;EsC1nqDI;IACE,WAAA;IACA,OAAA;EtC4nqDN;EsCxnqDE;IACE,kBAAA;EtC0nqDJ;EsCxnqDI;IACE,QAAA;IACA,UAAA;EtC0nqDN;AACF;AmBrqqDI;EmB4BA;IACE,oBAAA;EtC4oqDJ;EsC1oqDI;IACE,WAAA;IACA,OAAA;EtC4oqDN;EsCxoqDE;IACE,kBAAA;EtC0oqDJ;EsCxoqDI;IACE,QAAA;IACA,UAAA;EtC0oqDN;AACF;AsCjoqDE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AtCmoqDJ;AsC1nqDE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AtC4nqDJ;AsCvnqDI;EACE,iBAAA;AtCynqDN;;AsCnnqDE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AtCsnqDJ;AsCjnqDI;EACE,iBAAA;AtCmnqDN;;AsC5mqDA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AtC+mqDF;;AsCzmqDA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3B4gB4B;E2B3gB5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;AtC4mqDF;AsC1mqDE;EAEE,0CAAA;EVzLF,kDU2LuB;AtC0mqDzB;AsCvmqDE;EAEE,2CAAA;EACA,qBAAA;EVjMF,mDUkMuB;AtCwmqDzB;AsCrmqDE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AtCsmqDJ;;AsChmqDA;EACE,cAAA;AtCmmqDF;;AsC/lqDA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E7B0EI,uBALI;E6BnER,sCAAA;EACA,mBAAA;AtCkmqDF;;AsC9lqDA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AtCimqDF;;AsC7lqDA;EAEE,4BAAA;EACA,yBAAA;EACA,kDAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,gDAAA;EACA,sDAAA;EACA,qCAAA;EACA,sEAAA;EACA,0CAAA;EACA,mCAAA;AtC+lqDF;;AuCp1qDA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AvCu1qDF;AuCr1qDE;;EACE,kBAAA;EACA,cAAA;AvCw1qDJ;AuCn1qDE;;;;;;;;;;;;EAME,UAAA;AvC21qDJ;;AuCt1qDA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AvCy1qDF;AuCv1qDE;EACE,WAAA;AvCy1qDJ;;AuCr1qDA;E3BhBI,sBAAA;AZy2qDJ;AuCr1qDE;;EAEE,iBAAA;AvCu1qDJ;AuCn1qDE;;;E3BVE,0BAAA;EACA,6BAAA;AZk2qDJ;AuC/0qDE;;;E3BNE,yBAAA;EACA,4BAAA;AZ01qDJ;;AuCl0qDA;EACE,uBAAA;EACA,sBAAA;AvCq0qDF;AuCn0qDE;EAGE,cAAA;AvCm0qDJ;AuCh0qDE;EACE,eAAA;AvCk0qDJ;;AuC9zqDA;EACE,uBAAA;EACA,sBAAA;AvCi0qDF;;AuC9zqDA;EACE,qBAAA;EACA,oBAAA;AvCi0qDF;;AuC7yqDA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AvCgzqDF;AuC9yqDE;;EAEE,WAAA;AvCgzqDJ;AuC7yqDE;;EAEE,gBAAA;AvC+yqDJ;AuC3yqDE;;E3B1FE,6BAAA;EACA,4BAAA;AZy4qDJ;AuC3yqDE;;E3B7GE,yBAAA;EACA,0BAAA;AZ45qDJ;;AwCp7qDA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,qCAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AxCm7qDF;;AwCh7qDA;EACE,cAAA;EACA,kEAAA;E/B4QI,uCALI;E+BrQR,2CAAA;EACA,+BAAA;EACA,qBAAA;EbbI,uGacJ;AxCm7qDF;A2B77qDM;EaGN;IbFQ,gBAAA;E3Bg8qDN;AACF;AwCt7qDE;EAEE,qCAAA;AxCu7qDJ;AwCl7qDE;EACE,wCAAA;EACA,oBAAA;EACA,eAAA;AxCo7qDJ;;AwC56qDA;EAEE,+BAAA;EACA,8CAAA;EACA,oCAAA;EACA,+FAAA;EACA,wCAAA;EACA,+DAAA;EACA,+GAAA;EAGA,oFAAA;AxC46qDF;AwC16qDE;EACE,yDAAA;EACA,gBAAA;EACA,yDAAA;E5BtCA,wDAAA;EACA,yDAAA;AZm9qDJ;AwC36qDI;EAGE,kBAAA;EACA,wDAAA;AxC26qDN;AwCx6qDI;EAEE,wCAAA;EACA,6BAAA;EACA,yBAAA;AxCy6qDN;AwCr6qDE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;AxCu6qDJ;AwCp6qDE;EAEE,sDAAA;E5BjEA,yBAAA;EACA,0BAAA;AZu+qDJ;;AwC55qDA;EAEE,qCAAA;EACA,sCAAA;EACA,sCAAA;AxC85qDF;AwC35qDE;EACE,gBAAA;EACA,SAAA;E5B9FA,gDAAA;AZ4/qDJ;AwC35qDI;EACE,wCAAA;EACA,6BAAA;EACA,yBAAA;AxC65qDN;AwCz5qDE;;EAEE,4CAAA;EZzHF,oDY0HuB;AxC25qDzB;;AwCj5qDE;;EAEE,cAAA;EACA,kBAAA;AxCo5qDJ;;AwC/4qDE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AxCk5qDJ;;AwC54qDE;;EACE,WAAA;AxCg5qDJ;;AwCt4qDE;EACE,aAAA;AxCy4qDJ;AwCv4qDE;EACE,cAAA;AxCy4qDJ;;AyC7irDA;EAEE,wBAAA;EACA,6BAAA;EACA,sCAAA;EACA,2CAAA;EACA,8CAAA;EACA,4CAAA;EACA,0CAAA;EACA,kCAAA;EACA,wCAAA;EACA,2CAAA;EACA,iDAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EACA,qEAAA;EACA,oDAAA;EACA,0CAAA;EACA,kCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;AzC6irDF;AyCvirDE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;AzC+irDJ;AyC3hrDA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;EhCkOI,2CALI;EgC3NR,mCAAA;EACA,qBAAA;EACA,mBAAA;AzC6hrDF;AyC3hrDE;EAEE,yCAAA;AzC4hrDJ;;AyClhrDA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AzCihrDF;AyC/grDE;;EAEE,oCAAA;AzCihrDJ;AyC9grDE;EACE,gBAAA;AzCghrDJ;;AyCvgrDA;EACE,mB9B4jCkC;E8B3jClC,sB9B2jCkC;E8B1jClC,6BAAA;AzC0grDF;AyCxgrDE;;;EAGE,oCAAA;AzC0grDJ;;AyC7/qDA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AzC8/qDF;;AyC1/qDA;EACE,8EAAA;EhCiJI,6CALI;EgC1IR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E7BtIE,qDAAA;EeHE,+Cc2IJ;AzC6/qDF;A2BporDM;Ec+HN;Id9HQ,gBAAA;E3BuorDN;AACF;AyChgrDE;EACE,qBAAA;AzCkgrDJ;AyC//qDE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;AzCigrDJ;;AyC3/qDA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;AzC8/qDF;;AyC3/qDA;EACE,yCAAA;EACA,gBAAA;AzC8/qDF;;AmBtnrDI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;EzCq/qDN;EyCn/qDM;IACE,mBAAA;EzCq/qDR;EyCn/qDQ;IACE,kBAAA;EzCq/qDV;EyCl/qDQ;IACE,kDAAA;IACA,iDAAA;EzCo/qDV;EyCh/qDM;IACE,iBAAA;EzCk/qDR;EyC/+qDM;IACE,wBAAA;IACA,gBAAA;EzCi/qDR;EyC9+qDM;IACE,aAAA;EzCg/qDR;EyC7+qDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;EzC6+qDR;EyC1+qDQ;IACE,aAAA;EzC4+qDV;EyCz+qDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzC2+qDV;AACF;AmBtqrDI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;EzCoirDN;EyClirDM;IACE,mBAAA;EzCoirDR;EyClirDQ;IACE,kBAAA;EzCoirDV;EyCjirDQ;IACE,kDAAA;IACA,iDAAA;EzCmirDV;EyC/hrDM;IACE,iBAAA;EzCiirDR;EyC9hrDM;IACE,wBAAA;IACA,gBAAA;EzCgirDR;EyC7hrDM;IACE,aAAA;EzC+hrDR;EyC5hrDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;EzC4hrDR;EyCzhrDQ;IACE,aAAA;EzC2hrDV;EyCxhrDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzC0hrDV;AACF;AmBrtrDI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;EzCmlrDN;EyCjlrDM;IACE,mBAAA;EzCmlrDR;EyCjlrDQ;IACE,kBAAA;EzCmlrDV;EyChlrDQ;IACE,kDAAA;IACA,iDAAA;EzCklrDV;EyC9krDM;IACE,iBAAA;EzCglrDR;EyC7krDM;IACE,wBAAA;IACA,gBAAA;EzC+krDR;EyC5krDM;IACE,aAAA;EzC8krDR;EyC3krDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;EzC2krDR;EyCxkrDQ;IACE,aAAA;EzC0krDV;EyCvkrDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzCykrDV;AACF;AmBpwrDI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;EzCkorDN;EyChorDM;IACE,mBAAA;EzCkorDR;EyChorDQ;IACE,kBAAA;EzCkorDV;EyC/nrDQ;IACE,kDAAA;IACA,iDAAA;EzCiorDV;EyC7nrDM;IACE,iBAAA;EzC+nrDR;EyC5nrDM;IACE,wBAAA;IACA,gBAAA;EzC8nrDR;EyC3nrDM;IACE,aAAA;EzC6nrDR;EyC1nrDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;EzC0nrDR;EyCvnrDQ;IACE,aAAA;EzCynrDV;EyCtnrDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzCwnrDV;AACF;AmBnzrDI;EsBoIA;IAEI,iBAAA;IACA,2BAAA;EzCirrDN;EyC/qrDM;IACE,mBAAA;EzCirrDR;EyC/qrDQ;IACE,kBAAA;EzCirrDV;EyC9qrDQ;IACE,kDAAA;IACA,iDAAA;EzCgrrDV;EyC5qrDM;IACE,iBAAA;EzC8qrDR;EyC3qrDM;IACE,wBAAA;IACA,gBAAA;EzC6qrDR;EyC1qrDM;IACE,aAAA;EzC4qrDR;EyCzqrDM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;Id5NJ,gBc8NI;EzCyqrDR;EyCtqrDQ;IACE,aAAA;EzCwqrDV;EyCrqrDQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;EzCuqrDV;AACF;AyC9trDI;EAEI,iBAAA;EACA,2BAAA;AzC+trDR;AyC7trDQ;EACE,mBAAA;AzC+trDV;AyC7trDU;EACE,kBAAA;AzC+trDZ;AyC5trDU;EACE,kDAAA;EACA,iDAAA;AzC8trDZ;AyC1trDQ;EACE,iBAAA;AzC4trDV;AyCztrDQ;EACE,wBAAA;EACA,gBAAA;AzC2trDV;AyCxtrDQ;EACE,aAAA;AzC0trDV;AyCvtrDQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ed5NJ,gBc8NI;AzCutrDV;AyCptrDU;EACE,aAAA;AzCstrDZ;AyCntrDU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;AzCqtrDZ;;AyCpsrDA;EAEE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;AzCssrDF;;A0Cr9rDA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,yBAAA;EACA,4CAAA;EACA,gCAAA;EACA,sDAAA;EACA,sCAAA;EACA,6BAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E9BdE,2CAAA;AZo+rDJ;A0Cl9rDE;EACE,eAAA;EACA,cAAA;A1Co9rDJ;A0Cj9rDE;EACE,mBAAA;EACA,sBAAA;A1Cm9rDJ;A0Cj9rDI;EACE,mBAAA;E9BnBF,0DAAA;EACA,2DAAA;AZu+rDJ;A0Cj9rDI;EACE,sBAAA;E9BVF,8DAAA;EACA,6DAAA;AZ89rDJ;A0C98rDE;;EAEE,aAAA;A1Cg9rDJ;;A0C58rDA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;A1C68rDF;;A0C18rDA;EACE,4CAAA;A1C68rDF;;A0C18rDA;EACE,sDAAA;EACA,gBAAA;A1C68rDF;;A0C18rDA;EACE,gBAAA;A1C68rDF;;A0Cr8rDE;EACE,oCAAA;A1Cw8rDJ;;A0Ch8rDA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;A1Cm8rDF;A0Cj8rDE;E9BxFE,wFAAA;AZ4hsDJ;;A0C/7rDA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;A1Ck8rDF;A0Ch8rDE;E9BnGE,wFAAA;AZsisDJ;;A0Cz7rDA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;A1C47rDF;A0C17rDE;EACE,mCAAA;EACA,sCAAA;A1C47rDJ;;A0Cx7rDA;EACE,uDAAA;EACA,sDAAA;A1C27rDF;;A0Cv7rDA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E9BrIE,iDAAA;AZgksDJ;;A0Cv7rDA;;;EAGE,WAAA;A1C07rDF;;A0Cv7rDA;;E9BtII,0DAAA;EACA,2DAAA;AZkksDJ;;A0Cx7rDA;;E9B7HI,8DAAA;EACA,6DAAA;AZ0jsDJ;;A0Cj7rDE;EACE,0CAAA;A1Co7rDJ;AmB1isDI;EuBkHJ;IAQI,aAAA;IACA,mBAAA;E1Co7rDF;E0Cj7rDE;IAEE,SAAA;IACA,gBAAA;E1Ck7rDJ;E0Ch7rDI;IACE,cAAA;IACA,cAAA;E1Ck7rDN;E0C76rDM;I9BtKJ,0BAAA;IACA,6BAAA;EZslsDF;E0C96rDQ;;IAGE,0BAAA;E1C+6rDV;E0C76rDQ;;IAGE,6BAAA;E1C86rDV;E0C16rDM;I9BvKJ,yBAAA;IACA,4BAAA;EZolsDF;E0C36rDQ;;IAGE,yBAAA;E1C46rDV;E0C16rDQ;;IAGE,4BAAA;E1C26rDV;AACF;;A2C3osDA;EAEE,0CAAA;EACA,uBAAA;EACA,8KAAA;EACA,mDAAA;EACA,gCAAA;EACA,qCAAA;EACA,uDAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,2BAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,mEAAA;EACA,0EAAA;EACA,sCAAA;EACA,mCAAA;EACA,mDAAA;EACA,iDAAA;A3C6osDF;;A2CzosDA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;ElCiQI,oBALI;EkC1PR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;E/BtBE,gBAAA;E+BwBF,qBAAA;EhB3BI,0CgB4BJ;A3C4osDF;A2BpqsDM;EgBWN;IhBVQ,gBAAA;E3BuqsDN;AACF;A2C/osDE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;A3CipsDJ;A2C/osDI;EACE,qDAAA;EACA,iDAAA;A3CipsDN;A2C5osDE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EhBlDE,mDgBmDF;A3C8osDJ;A2B7rsDM;EgBsCJ;IhBrCM,gBAAA;E3BgssDN;AACF;A2ChpsDE;EACE,UAAA;A3CkpsDJ;A2C/osDE;EACE,UAAA;EACA,wDAAA;EACA,UAAA;EACA,oDAAA;A3CipsDJ;;A2C7osDA;EACE,gBAAA;A3CgpsDF;;A2C7osDA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;A3CgpsDF;A2C9osDE;E/B/DE,yDAAA;EACA,0DAAA;AZgtsDJ;A2C/osDI;E/BlEA,+DAAA;EACA,gEAAA;AZotsDJ;A2C9osDE;EACE,aAAA;A3CgpsDJ;A2C5osDE;E/B9DE,6DAAA;EACA,4DAAA;AZ6ssDJ;A2C5osDM;E/BlEF,mEAAA;EACA,kEAAA;AZitsDJ;A2C3osDI;E/BvEA,6DAAA;EACA,4DAAA;AZqtsDJ;;A2CzosDA;EACE,8EAAA;A3C4osDF;;A2CnosDE;EACE,eAAA;A3CsosDJ;A2CnosDE;EACE,eAAA;EACA,cAAA;E/BpHA,gBAAA;AZ0vsDJ;A2CnosDI;EAAgB,aAAA;A3CsosDpB;A2CrosDI;EAAe,gBAAA;A3CwosDnB;A2CrosDM;E/B3HF,gBAAA;AZmwsDJ;;A4CtxsDA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,sCAAA;EACA,sCAAA;EACA,0CAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;EnCqRI,yCALI;EmC9QR,gBAAA;EACA,yCAAA;EhCAE,iDAAA;AZsxsDJ;;A4ChxsDE;EACE,iDAAA;A5CmxsDJ;A4CjxsDI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,iGAAA;A5CmxsDN;A4C/wsDE;EACE,6CAAA;A5CixsDJ;;A6CtzsDA;EAEE,kCAAA;EACA,mCAAA;EpCkSI,oCALI;EoC3RR,2CAAA;EACA,4CAAA;EACA,iCAAA;EACA,oDAAA;EACA,sCAAA;EACA,uDAAA;EACA,iCAAA;EACA,0DAAA;EACA,uDAAA;EACA,iCAAA;EACA,iEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,uCAAA;EACA,qDAAA;EACA,6DAAA;EAGA,aAAA;E/BpBA,eAAA;EACA,gBAAA;Ad20sDF;;A6CpzsDA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EpCsQI,yCALI;EoC/PR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;ElBpBI,qIkBqBJ;A7CuzsDF;A2Bx0sDM;EkBQN;IlBPQ,gBAAA;E3B20sDN;AACF;A6C1zsDE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;A7C2zsDJ;A6CxzsDE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UlC+wCgC;EkC9wChC,iDAAA;A7C0zsDJ;A6CvzsDE;EAEE,UAAA;EACA,wCAAA;EjBtDF,gDiBuDuB;EACrB,sDAAA;A7CwzsDJ;A6CrzsDE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;A7CszsDJ;;A6CjzsDE;EACE,iBlCkvCgC;AXkkqDpC;A6C/ysDM;EjC9BF,0DAAA;EACA,6DAAA;AZg1sDJ;A6C7ysDM;EjClDF,2DAAA;EACA,8DAAA;AZk2sDJ;;A6ChysDA;EClGE,iCAAA;EACA,iCAAA;ErCgSI,sCALI;EqCzRR,qCAAA;A9Cs4sDF;;A6CnysDA;ECtGE,iCAAA;EACA,kCAAA;ErCgSI,uCALI;EqCzRR,qCAAA;A9C64sDF;;A+C/4sDA;EAEE,4BAAA;EACA,4BAAA;EtC6RI,4BALI;EsCtRR,2BAAA;EACA,sBAAA;EACA,iCAAA;EAGA,qBAAA;EACA,4DAAA;EtCqRI,oCALI;EsC9QR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EnCJE,4CAAA;AZo5sDJ;A+C34sDE;EACE,aAAA;A/C64sDJ;;A+Cx4sDA;EACE,kBAAA;EACA,SAAA;A/C24sDF;;AgD36sDA;EAEE,0BAAA;EACA,0BAAA;EACA,4BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,yDAAA;EACA,iCAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;EpCFE,4CAAA;AZ86sDJ;;AgDv6sDA;EAEE,cAAA;AhDy6sDF;;AgDr6sDA;EACE,gBrC+pB4B;AXywrD9B;;AgDh6sDA;EACE,mBrCqgD8B;AX85pDhC;AgDh6sDE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;AhDk6sDJ;;AgDl5sDE;EChEA,wCAAA;EACA,wCAAA;EACA,iDAAA;AjDs9sDF;AiDh9sDE;EACE,4BAAA;AjDk9sDJ;;AgD35sDE;EChEA,2CAAA;EACA,uCAAA;EACA,iDAAA;AjD+9sDF;AiDz9sDE;EACE,6BAAA;AjD29sDJ;;AgDp6sDE;EChEA,uCAAA;EACA,yCAAA;EACA,iDAAA;AjDw+sDF;AiDl+sDE;EACE,0BAAA;AjDo+sDJ;;AgD76sDE;EChEA,yCAAA;EACA,wCAAA;EACA,iDAAA;AjDi/sDF;AiD3+sDE;EACE,6BAAA;AjD6+sDJ;;AgDt7sDE;EChEA,yCAAA;EACA,sCAAA;EACA,+CAAA;AjD0/sDF;AiDp/sDE;EACE,4BAAA;AjDs/sDJ;;AgD/7sDE;EChEA,qCAAA;EACA,yCAAA;EACA,iDAAA;AjDmgtDF;AiD7/sDE;EACE,2BAAA;AjD+/sDJ;;AgDx8sDE;EChEA,4CAAA;EACA,wCAAA;EACA,iDAAA;AjD4gtDF;AiDtgtDE;EACE,+BAAA;AjDwgtDJ;;AgDj9sDE;EChEA,0CAAA;EACA,uCAAA;EACA,iDAAA;AjDqhtDF;AiD/gtDE;EACE,4BAAA;AjDihtDJ;;AkDxhtDE;EACE;IAAK,+BvCijD2B;EX2+pDlC;AACF;AkDxhtDA;EAEE,8BAAA;EzCyRI,oCALI;EyClRR,yBAAA;EACA,oCAAA;EACA,8DAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;EzC6QI,uCALI;EyCtQR,uCAAA;EtCPE,+CAAA;AZ+htDJ;;AkDnhtDA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBvBI,6CuBwBJ;AlDshtDF;A2B1itDM;EuBWN;IvBVQ,gBAAA;E3B6itDN;AACF;;AkDxhtDA;EtBCE,qMAAA;EsBCA,oEAAA;AlD2htDF;;AkDvhtDE;EACE,kDAAA;AlD0htDJ;AkDvhtDM;EAJJ;IAKM,eAAA;ElD0htDN;AACF;;AmD7ktDA;EAEE,2CAAA;EACA,4CAAA;EACA,oDAAA;EACA,iCAAA;EACA,sCAAA;EACA,oCAAA;EACA,sCAAA;EACA,kDAAA;EACA,wDAAA;EACA,8DAAA;EACA,yDAAA;EACA,+DAAA;EACA,uCAAA;EACA,qDAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;AZultDJ;;AmDxktDA;EACE,qBAAA;EACA,sBAAA;AnD2ktDF;AmDzktDE;EAEE,oCAAA;EACA,0BAAA;AnD0ktDJ;;AmDjktDA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;AnDoktDF;AmDjktDE;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;AnDkktDJ;AmD/jtDE;EACE,+CAAA;EACA,uDAAA;AnDiktDJ;;AmDzjtDA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;AnD4jtDF;AmD1jtDE;EvCvDE,+BAAA;EACA,gCAAA;AZontDJ;AmD1jtDE;EvC7CE,mCAAA;EACA,kCAAA;AZ0mtDJ;AmD1jtDE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;AnD2jtDJ;AmDvjtDE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;AnDyjtDJ;AmDrjtDE;EACE,mBAAA;AnDujtDJ;AmDrjtDI;EACE,wDAAA;EACA,mDAAA;AnDujtDN;;AmD1itDI;EACE,mBAAA;AnD6itDN;AmD1itDQ;EvCvDJ,6DAAA;EAZA,0BAAA;AZintDJ;AmDzitDQ;EvCxEJ,2DAAA;EAYA,4BAAA;AZymtDJ;AmDxitDQ;EACE,aAAA;AnD0itDV;AmDvitDQ;EACE,mDAAA;EACA,oBAAA;AnDyitDV;AmDvitDU;EACE,yDAAA;EACA,oDAAA;AnDyitDZ;;AmB/ntDI;EgC8DA;IACE,mBAAA;EnDqktDJ;EmDlktDM;IvCvDJ,6DAAA;IAZA,0BAAA;EZyotDF;EmDjktDM;IvCxEJ,2DAAA;IAYA,4BAAA;EZiotDF;EmDhktDM;IACE,aAAA;EnDkktDR;EmD/jtDM;IACE,mDAAA;IACA,oBAAA;EnDiktDR;EmD/jtDQ;IACE,yDAAA;IACA,oDAAA;EnDiktDV;AACF;AmBxptDI;EgC8DA;IACE,mBAAA;EnD6ltDJ;EmD1ltDM;IvCvDJ,6DAAA;IAZA,0BAAA;EZiqtDF;EmDzltDM;IvCxEJ,2DAAA;IAYA,4BAAA;EZyptDF;EmDxltDM;IACE,aAAA;EnD0ltDR;EmDvltDM;IACE,mDAAA;IACA,oBAAA;EnDyltDR;EmDvltDQ;IACE,yDAAA;IACA,oDAAA;EnDyltDV;AACF;AmBhrtDI;EgC8DA;IACE,mBAAA;EnDqntDJ;EmDlntDM;IvCvDJ,6DAAA;IAZA,0BAAA;EZyrtDF;EmDjntDM;IvCxEJ,2DAAA;IAYA,4BAAA;EZirtDF;EmDhntDM;IACE,aAAA;EnDkntDR;EmD/mtDM;IACE,mDAAA;IACA,oBAAA;EnDintDR;EmD/mtDQ;IACE,yDAAA;IACA,oDAAA;EnDintDV;AACF;AmBxstDI;EgC8DA;IACE,mBAAA;EnD6otDJ;EmD1otDM;IvCvDJ,6DAAA;IAZA,0BAAA;EZittDF;EmDzotDM;IvCxEJ,2DAAA;IAYA,4BAAA;EZystDF;EmDxotDM;IACE,aAAA;EnD0otDR;EmDvotDM;IACE,mDAAA;IACA,oBAAA;EnDyotDR;EmDvotDQ;IACE,yDAAA;IACA,oDAAA;EnDyotDV;AACF;AmBhutDI;EgC8DA;IACE,mBAAA;EnDqqtDJ;EmDlqtDM;IvCvDJ,6DAAA;IAZA,0BAAA;EZyutDF;EmDjqtDM;IvCxEJ,2DAAA;IAYA,4BAAA;EZiutDF;EmDhqtDM;IACE,aAAA;EnDkqtDR;EmD/ptDM;IACE,mDAAA;IACA,oBAAA;EnDiqtDR;EmD/ptDQ;IACE,yDAAA;IACA,oDAAA;EnDiqtDV;AACF;AmDpptDA;EvChJI,gBAAA;AZuytDJ;AmDpptDE;EACE,mDAAA;AnDsptDJ;AmDpptDI;EACE,sBAAA;AnDsptDN;;AoD5ztDE;EACE,4BDmLyB;EClLzB,0CDiLsB;AnD8otD1B;AoD5ztDM;EAEE,4BD6KqB;EC5KrB,6CAAA;ApD6ztDR;AoD1ztDM;EACE,WzC0IG;EyCzIH,uCDuKqB;ECtKrB,mCDsKqB;AnDsptD7B;;AoD10tDE;EACE,6BDmLyB;EClLzB,0CDiLsB;AnD4ptD1B;AoD10tDM;EAEE,6BD6KqB;EC5KrB,6CAAA;ApD20tDR;AoDx0tDM;EACE,WzC0IG;EyCzIH,wCDuKqB;ECtKrB,oCDsKqB;AnDoqtD7B;;AoDx1tDE;EACE,0BDmLyB;EClLzB,wCDiLsB;AnD0qtD1B;AoDx1tDM;EAEE,0BD6KqB;EC5KrB,4CAAA;ApDy1tDR;AoDt1tDM;EACE,WzC0IG;EyCzIH,qCDuKqB;ECtKrB,iCDsKqB;AnDkrtD7B;;AoDt2tDE;EACE,6BDmLyB;EClLzB,0CDiLsB;AnDwrtD1B;AoDt2tDM;EAEE,6BD6KqB;EC5KrB,6CAAA;ApDu2tDR;AoDp2tDM;EACE,WzC0IG;EyCzIH,wCDuKqB;ECtKrB,oCDsKqB;AnDgstD7B;;AoDp3tDE;EACE,4BDmLyB;EClLzB,wCDiLsB;AnDsstD1B;AoDp3tDM;EAEE,4BD6KqB;EC5KrB,4CAAA;ApDq3tDR;AoDl3tDM;EACE,WzC0IG;EyCzIH,uCDuKqB;ECtKrB,mCDsKqB;AnD8stD7B;;AoDl4tDE;EACE,2BDmLyB;EClLzB,wCDiLsB;AnDottD1B;AoDl4tDM;EAEE,2BD6KqB;EC5KrB,4CAAA;ApDm4tDR;AoDh4tDM;EACE,WzC0IG;EyCzIH,sCDuKqB;ECtKrB,kCDsKqB;AnD4ttD7B;;AoDh5tDE;EACE,+BDmLyB;EClLzB,0CDiLsB;AnDkutD1B;AoDh5tDM;EAEE,+BD6KqB;EC5KrB,6CAAA;ApDi5tDR;AoD94tDM;EACE,WzC0IG;EyCzIH,0CDuKqB;ECtKrB,sCDsKqB;AnD0utD7B;;AoD95tDE;EACE,4BDmLyB;EClLzB,0CDiLsB;AnDgvtD1B;AoD95tDM;EAEE,4BD6KqB;EC5KrB,6CAAA;ApD+5tDR;AoD55tDM;EACE,WzC0IG;EyCzIH,uCDuKqB;ECtKrB,mCDsKqB;AnDwvtD7B;;AqD36tDA;EACE,uBAAA;EACA,U1CorD2B;E0CnrD3B,W1CmrD2B;E0ClrD3B,sBAAA;EACA,W1C0JS;E0CzJT,0FAAA;EACA,SAAA;EzCOE,sBAAA;EyCLF,Y1CorD2B;AX0vqD7B;AqD36tDE;EACE,W1CkJO;E0CjJP,qBAAA;EACA,a1C+qDyB;AX8vqD7B;AqD16tDE;EACE,UAAA;EACA,2C1C+0B4B;E0C90B5B,U1C0qDyB;AXkwqD7B;AqDz6tDE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,a1CoqDyB;AXswqD7B;;AqDt6tDA;EACE,kD1CgqD2B;AXywqD7B;;AsD/8tDA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7C+RI,8BALI;E6CxRR,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,2CAAA;EACA,iCAAA;EACA,uDAAA;EACA,gCAAA;EACA,+CAAA;EACA,mDAAA;EAGA,gCAAA;EACA,eAAA;E7CiRI,oCALI;E6C1QR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;E1CRE,4CAAA;AZw9tDJ;AsD78tDE;EACE,UAAA;AtD+8tDJ;AsD58tDE;EACE,aAAA;AtD88tDJ;;AsD18tDA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AtD48tDF;AsD18tDE;EACE,sCAAA;AtD48tDJ;;AsDx8tDA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;E1ChCE,0FAAA;EACA,2FAAA;AZ4+tDJ;AsD18tDE;EACE,oDAAA;EACA,sCAAA;AtD48tDJ;;AsDx8tDA;EACE,kCAAA;EACA,qBAAA;AtD28tDF;;AuDzguDA;EAEE,uBAAA;EACA,uBAAA;EACA,2BAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,+CAAA;EACA,4BAAA;EACA,gCAAA;EACA,8DAAA;EACA,kDAAA;EACA,oCAAA;EACA,oCAAA;EACA,0CAAA;EACA,sDAAA;EACA,iCAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,iCAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AvDuguDF;;AuDhguDA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AvDkguDF;AuD//tDE;E5B5CI,mC4B6CF;AvDiguDJ;A2B1iuDM;E4BwCJ;I5BvCM,gBAAA;E3B6iuDN;AACF;AuDvguDE;EAEE,8B5C49CgC;AX4irDpC;AuDtguDE;EACE,e5C09CgC;AX8irDpC;AuDpguDE;EACE,sB5Cu9CgC;AX+irDpC;;AuDlguDA;EACE,+CAAA;AvDqguDF;AuDnguDE;EACE,gBAAA;EACA,gBAAA;AvDqguDJ;AuDlguDE;EACE,gBAAA;AvDoguDJ;;AuDhguDA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AvDmguDF;;AuD//tDA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E3CrFE,4CAAA;E2CyFF,UAAA;AvD+/tDF;;AuD3/tDA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AvDiguD9D;AwD7muDE;EAAS,UAAA;AxDgnuDX;AwD/muDE;EAAS,mCD2GiF;AvDuguD5F;;AuDlguDA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,8BAAA;EACA,uCAAA;EACA,4FAAA;E3CtGE,2DAAA;EACA,4DAAA;AZ4muDJ;AuDpguDE;EACE,kGAAA;EACA,sJAAA;AvDsguDJ;;AuDjguDA;EACE,gBAAA;EACA,8CAAA;AvDoguDF;;AuD//tDA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AvDgguDF;;AuD5/tDA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E3C1HE,+DAAA;EACA,8DAAA;AZ0nuDJ;AuD3/tDE;EACE,8CAAA;AvD6/tDJ;;AmBzmuDI;EoCkHF;IACE,0BAAA;IACA,uDAAA;EvD2/tDF;EuDv/tDA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EvDy/tDF;EuDt/tDA;IACE,uBAAA;EvDw/tDF;AACF;AmBxnuDI;EoCoIF;;IAEE,uBAAA;EvDu/tDF;AACF;AmB9nuDI;EoC2IF;IACE,wBAAA;EvDs/tDF;AACF;AuD7+tDI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AvD++tDN;AuD7+tDM;EACE,YAAA;EACA,SAAA;E3C1MJ,gBAAA;AZ0ruDJ;AuD5+tDM;;E3C9MF,gBAAA;AZ8ruDJ;AuD3+tDM;EACE,gBAAA;AvD6+tDR;;AmBxouDI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDmguDJ;EuDjguDI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EZ8suDF;EuDhguDI;;I3C9MF,gBAAA;EZktuDF;EuD//tDI;IACE,gBAAA;EvDiguDN;AACF;AmB7puDI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDuhuDJ;EuDrhuDI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EZkuuDF;EuDphuDI;;I3C9MF,gBAAA;EZsuuDF;EuDnhuDI;IACE,gBAAA;EvDqhuDN;AACF;AmBjruDI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD2iuDJ;EuDziuDI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EZsvuDF;EuDxiuDI;;I3C9MF,gBAAA;EZ0vuDF;EuDviuDI;IACE,gBAAA;EvDyiuDN;AACF;AmBrsuDI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvD+juDJ;EuD7juDI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EZ0wuDF;EuD5juDI;;I3C9MF,gBAAA;EZ8wuDF;EuD3juDI;IACE,gBAAA;EvD6juDN;AACF;AmBztuDI;EoCyIA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EvDmluDJ;EuDjluDI;IACE,YAAA;IACA,SAAA;I3C1MJ,gBAAA;EZ8xuDF;EuDhluDI;;I3C9MF,gBAAA;EZkyuDF;EuD/kuDI;IACE,gBAAA;EvDiluDN;AACF;AyDxzuDA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,8BAAA;EACA,sBAAA;EhD8RI,oCALI;EgDvRR,wBAAA;EACA,qBAAA;EACA,kCAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,uCAAA;EACA,gCAAA;ECnBA,sC/CkrB4B;E+ChrB5B,kBAAA;EACA,gB/C2rB4B;E+C1rB5B,gB/CisB4B;E+ChsB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDsRI,sCALI;EgDrQR,qBAAA;EACA,UAAA;AzDg0uDF;AyD9zuDE;EAAS,kCAAA;AzDi0uDX;AyD/zuDE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AzDi0uDJ;AyD/zuDI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AzDi0uDN;;AyD5zuDA;EACE,SAAA;AzD+zuDF;AyD7zuDE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AzD+zuDJ;;AyD3zuDA,qBAAA;AACA;EACE,OAAA;EACA,qCAAA;EACA,qCAAA;AzD8zuDF;AyD5zuDE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AzD8zuDJ;;AyD1zuDA,mBAAA;AAEA;EACE,MAAA;AzD4zuDF;AyD1zuDE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AzD4zuDJ;;AyDxzuDA,qBAAA;AACA;EACE,QAAA;EACA,qCAAA;EACA,qCAAA;AzD2zuDF;AyDzzuDE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AzD2zuDJ;;AyDvzuDA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E7ClGE,8CAAA;AZ44uDJ;;A2D/5uDA;EAEE,yBAAA;EACA,6BAAA;ElDkSI,iCALI;EkD3RR,qBAAA;EACA,8BAAA;EACA,iDAAA;EACA,mCAAA;EACA,qDAAA;EACA,0DAAA;EACA,mCAAA;EACA,qCAAA;ElDyRI,wCALI;EkDlRR,2BAAA;EACA,4CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC/CkrB4B;E+ChrB5B,kBAAA;EACA,gB/C2rB4B;E+C1rB5B,gB/CisB4B;E+ChsB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDsRI,sCALI;EkDhQR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E/ChBE,8CAAA;AZ07uDJ;A2Dt6uDE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;A3Dw6uDJ;A2Dt6uDI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;A3Du6uDN;;A2Dj6uDE;EACE,oFAAA;A3Do6uDJ;A2Dl6uDI;EAEE,wFAAA;A3Dm6uDN;A2Dh6uDI;EACE,SAAA;EACA,gDAAA;A3Dk6uDN;A2D/5uDI;EACE,sCAAA;EACA,sCAAA;A3Di6uDN;;A2D55uDA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;A3D85uDJ;A2D55uDI;EAEE,kIAAA;A3D65uDN;A2D15uDI;EACE,OAAA;EACA,kDAAA;A3D45uDN;A2Dz5uDI;EACE,oCAAA;EACA,wCAAA;A3D25uDN;;A2Dt5uDA,mBAAA;AAGE;EACE,iFAAA;A3Du5uDJ;A2Dr5uDI;EAEE,wFAAA;A3Ds5uDN;A2Dn5uDI;EACE,MAAA;EACA,mDAAA;A3Dq5uDN;A2Dl5uDI;EACE,mCAAA;EACA,yCAAA;A3Do5uDN;A2D/4uDE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;A3Di5uDJ;;A2D74uDA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;A3D+4uDJ;A2D74uDI;EAEE,kIAAA;A3D84uDN;A2D34uDI;EACE,QAAA;EACA,iDAAA;A3D64uDN;A2D14uDI;EACE,qCAAA;EACA,uCAAA;A3D44uDN;;A2Dv4uDA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElDiHI,6CALI;EkD1GR,qCAAA;EACA,6CAAA;EACA,kFAAA;E/C5JE,6DAAA;EACA,8DAAA;AZshvDJ;A2Dx3uDE;EACE,aAAA;A3D03uDJ;;A2Dt3uDA;EACE,0EAAA;EACA,mCAAA;A3Dy3uDF;;A4D9ivDA;EACE,kBAAA;A5DijvDF;;A4D9ivDA;EACE,mBAAA;A5DijvDF;;A4D9ivDA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A5DijvDF;A6DvkvDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A7DykvDJ;;A4DljvDA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;A5DqjvDF;A2BpkvDM;EiCQN;IjCPQ,gBAAA;E3BukvDN;AACF;;A4DvjvDA;;;EAGE,cAAA;A5D0jvDF;;A4DvjvDA;;EAEE,2BAAA;A5D0jvDF;;A4DvjvDA;;EAEE,4BAAA;A5D0jvDF;;A4DjjvDE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;A5DojvDJ;A4DjjvDE;;;EAGE,UAAA;EACA,UAAA;A5DmjvDJ;A4DhjvDE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;A5DkjvDJ;A2B3mvDM;EiCqDJ;;IjCpDM,gBAAA;E3B+mvDN;AACF;;A4D/ivDA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjDwiDmC;EiDviDnC,UAAA;EACA,WjDwDS;EiDvDT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YjDmiDmC;EgBznD/B,8BiCuFJ;A5DijvDF;A2BpovDM;EiCkEN;;IjCjEQ,gBAAA;E3BwovDN;AACF;A4DpjvDE;;;EAEE,WjD8CO;EiD7CP,qBAAA;EACA,UAAA;EACA,YjD2hDiC;AX4hsDrC;;A4DpjvDA;EACE,OAAA;A5DujvDF;;A4DpjvDA;EACE,QAAA;A5DujvDF;;A4DljvDA;;EAEE,qBAAA;EACA,WjD4hDmC;EiD3hDnC,YjD2hDmC;EiD1hDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;A5DqjvDF;;A4DljvDA;;;;;;;GAAA;AAQA;EACE,0DAAA;A5DqjvDF;;A4DnjvDA;EACE,0DAAA;A5DsjvDF;;A4D9ivDA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBjDo+CmC;EiDn+CnC,mBAAA;EACA,gBjDk+CmC;EiDj+CnC,gBAAA;A5DgjvDF;A4D9ivDE;EACE,uBAAA;EACA,cAAA;EACA,WjDi+CiC;EiDh+CjC,WjDi+CiC;EiDh+CjC,UAAA;EACA,iBjDi+CiC;EiDh+CjC,gBjDg+CiC;EiD/9CjC,mBAAA;EACA,eAAA;EACA,sBjDzBO;EiD0BP,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YjDw9CiC;EgBjoD/B,6BiC0KF;A5D+ivDJ;A2BrtvDM;EiCqJJ;IjCpJM,gBAAA;E3BwtvDN;AACF;A4DjjvDE;EACE,UjDq9CiC;AX8lsDrC;;A4D1ivDA;EACE,kBAAA;EACA,UAAA;EACA,ejD+8CmC;EiD98CnC,SAAA;EACA,oBjD48CmC;EiD38CnC,uBjD28CmC;EiD18CnC,WjDpDS;EiDqDT,kBAAA;A5D6ivDF;;A4DvivDE;;EAEE,gCjD88CiC;AX4lsDrC;A4DvivDE;EACE,sBjDvDO;AXgmvDX;A4DtivDE;EACE,WjD3DO;AXmmvDX;;A8DnwvDA;;EAEE,qBAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;A9DqwvDF;;A8DjwvDA;EACE;IAAK,0CAAA;E9DqwvDL;AACF;A8DlwvDA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;A9DiwvDF;;A8D9vvDA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;A9DgwvDF;;A8DvvvDA;EACE;IACE,mBAAA;E9D0vvDF;E8DxvvDA;IACE,UAAA;IACA,eAAA;E9D0vvDF;AACF;A8DtvvDA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;A9DqvvDF;;A8DlvvDA;EACE,wBAAA;EACA,yBAAA;A9DqvvDF;;A8DjvvDE;EACE;;IAEE,kCAAA;E9DovvDJ;AACF;A+Dp0vDA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,iCAAA;EACA,iCAAA;EACA,sBAAA;EACA,uBAAA;EACA,gCAAA;EACA,mDAAA;EACA,kEAAA;A/Dq0vDF;;AmBtwvDI;E4C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC1BA,sCoC4BA;E/DszvDJ;AACF;A2B/0vDM;EoCUJ;IpCTM,gBAAA;E3Bk1vDN;AACF;AmB5xvDI;E4C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D6zvDN;E+D1zvDI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/D4zvDN;E+DzzvDI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/D2zvDN;E+DxzvDI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/D0zvDN;E+DvzvDI;IAEE,eAAA;E/DwzvDN;E+DrzvDI;IAGE,mBAAA;E/DqzvDN;AACF;AmBh1vDI;E4CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/DozvDN;E+DlzvDM;IACE,aAAA;E/DozvDR;E+DjzvDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/DkzvDR;AACF;;AmBp1vDI;E4C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC1BA,sCoC4BA;E/Do4vDJ;AACF;A2B75vDM;EoCUJ;IpCTM,gBAAA;E3Bg6vDN;AACF;AmB12vDI;E4C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/D24vDN;E+Dx4vDI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/D04vDN;E+Dv4vDI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/Dy4vDN;E+Dt4vDI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/Dw4vDN;E+Dr4vDI;IAEE,eAAA;E/Ds4vDN;E+Dn4vDI;IAGE,mBAAA;E/Dm4vDN;AACF;AmB95vDI;E4CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Dk4vDN;E+Dh4vDM;IACE,aAAA;E/Dk4vDR;E+D/3vDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/Dg4vDR;AACF;;AmBl6vDI;E4C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC1BA,sCoC4BA;E/Dk9vDJ;AACF;A2B3+vDM;EoCUJ;IpCTM,gBAAA;E3B8+vDN;AACF;AmBx7vDI;E4C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/Dy9vDN;E+Dt9vDI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/Dw9vDN;E+Dr9vDI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/Du9vDN;E+Dp9vDI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/Ds9vDN;E+Dn9vDI;IAEE,eAAA;E/Do9vDN;E+Dj9vDI;IAGE,mBAAA;E/Di9vDN;AACF;AmB5+vDI;E4CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/Dg9vDN;E+D98vDM;IACE,aAAA;E/Dg9vDR;E+D78vDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D88vDR;AACF;;AmBh/vDI;E4C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC1BA,sCoC4BA;E/DgiwDJ;AACF;A2BzjwDM;EoCUJ;IpCTM,gBAAA;E3B4jwDN;AACF;AmBtgwDI;E4C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/DuiwDN;E+DpiwDI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/DsiwDN;E+DniwDI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/DqiwDN;E+DliwDI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/DoiwDN;E+DjiwDI;IAEE,eAAA;E/DkiwDN;E+D/hwDI;IAGE,mBAAA;E/D+hwDN;AACF;AmB1jwDI;E4CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/D8hwDN;E+D5hwDM;IACE,aAAA;E/D8hwDR;E+D3hwDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D4hwDR;AACF;;AmB9jwDI;E4C9CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;IpC1BA,sCoC4BA;E/D8mwDJ;AACF;A2BvowDM;EoCUJ;IpCTM,gBAAA;E3B0owDN;AACF;AmBplwDI;E4C9BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;E/DqnwDN;E+DlnwDI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;E/DonwDN;E+DjnwDI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;E/DmnwDN;E+DhnwDI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;E/DknwDN;E+D/mwDI;IAEE,eAAA;E/DgnwDN;E+D7mwDI;IAGE,mBAAA;E/D6mwDN;AACF;AmBxowDI;E4CjCF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;E/D4mwDN;E+D1mwDM;IACE,aAAA;E/D4mwDR;E+DzmwDM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;E/D0mwDR;AACF;;A+D1rwDE;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EpC1BA,sCoC4BA;A/D2rwDN;A2BntwDM;EoCUJ;IpCTM,gBAAA;E3BstwDN;AACF;A+D9rwDM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;A/DgswDR;A+D7rwDM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;A/D+rwDR;A+D5rwDM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;A/D8rwDR;A+D3rwDM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;A/D6rwDR;A+D1rwDM;EAEE,eAAA;A/D2rwDR;A+DxrwDM;EAGE,mBAAA;A/DwrwDR;;A+D7pwDA;EPlHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7CgqCkC;E6C/pClC,YAAA;EACA,aAAA;EACA,sB7C4JS;AXunwDX;AwDhxwDE;EAAS,UAAA;AxDmxwDX;AwDlxwDE;EAAS,Y7C+/CyB;AXsxtDpC;;A+DzqwDA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,oEAAA;A/D4qwDF;A+D1qwDE;EACE,4FAAA;EACA,sDAAA;EACA,wDAAA;EACA,yDAAA;A/D4qwDJ;;A+DxqwDA;EACE,gBAAA;EACA,gBpD8jB4B;AX6mvD9B;;A+DxqwDA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;A/D2qwDF;;AgEzzwDA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YrDo1CkC;AXw+tDpC;AgE1zwDE;EACE,qBAAA;EACA,WAAA;AhE4zwDJ;;AgEvzwDA;EACE,iBAAA;AhE0zwDF;;AgEvzwDA;EACE,iBAAA;AhE0zwDF;;AgEvzwDA;EACE,iBAAA;AhE0zwDF;;AgErzwDE;EACE,mDAAA;AhEwzwDJ;;AgEpzwDA;EACE;IACE,YrDuzCgC;EXgguDlC;AACF;AgEpzwDA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;AhEszwDF;;AgEnzwDA;EACE;IACE,uBAAA;EhEszwDF;AACF;A6Dr2wDE;EACE,cAAA;EACA,WAAA;EACA,WAAA;A7Du2wDJ;;AiEv2wDE;EACE,sBAAA;EACA,uEAAA;AjE02wDJ;;AiE52wDE;EACE,sBAAA;EACA,wEAAA;AjE+2wDJ;;AiEj3wDE;EACE,sBAAA;EACA,wEAAA;AjEo3wDJ;;AiEt3wDE;EACE,sBAAA;EACA,wEAAA;AjEy3wDJ;;AiE33wDE;EACE,sBAAA;EACA,wEAAA;AjE83wDJ;;AiEh4wDE;EACE,sBAAA;EACA,wEAAA;AjEm4wDJ;;AiEr4wDE;EACE,sBAAA;EACA,yEAAA;AjEw4wDJ;;AiE14wDE;EACE,sBAAA;EACA,sEAAA;AjE64wDJ;;AkEn5wDE;EACE,yBAAA;AlEs5wDJ;AkEn5wDM;EAEE,wCAAA;AlEo5wDR;;AkE15wDE;EACE,yBAAA;AlE65wDJ;AkE15wDM;EAEE,wCAAA;AlE25wDR;;AkEj6wDE;EACE,yBAAA;AlEo6wDJ;AkEj6wDM;EAEE,sCAAA;AlEk6wDR;;AkEx6wDE;EACE,yBAAA;AlE26wDJ;AkEx6wDM;EAEE,yCAAA;AlEy6wDR;;AkE/6wDE;EACE,yBAAA;AlEk7wDJ;AkE/6wDM;EAEE,uCAAA;AlEg7wDR;;AkEt7wDE;EACE,yBAAA;AlEy7wDJ;AkEt7wDM;EAEE,sCAAA;AlEu7wDR;;AkE77wDE;EACE,yBAAA;AlEg8wDJ;AkE77wDM;EAEE,0CAAA;AlE87wDR;;AkEp8wDE;EACE,yBAAA;AlEu8wDJ;AkEp8wDM;EAEE,uCAAA;AlEq8wDR;;AmE18wDA;EACE,kBAAA;EACA,WAAA;AnE68wDF;AmE38wDE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;AnE68wDJ;AmE18wDE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AnE48wDJ;;AmEv8wDE;EACE,uBAAA;AnE08wDJ;;AmE38wDE;EACE,sBAAA;AnE88wDJ;;AmE/8wDE;EACE,yBAAA;AnEk9wDJ;;AmEn9wDE;EACE,iCAAA;AnEs9wDJ;;AoE3+wDA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,azD6pCkC;AXi1uDpC;;AoE3+wDA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,azDqpCkC;AXy1uDpC;;AoEt+wDI;EACE,gBAAA;EACA,MAAA;EACA,azDyoC8B;AXg2uDpC;;AoEt+wDI;EACE,gBAAA;EACA,SAAA;EACA,azDmoC8B;AXs2uDpC;;AmB18wDI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDyoC8B;EX62uDlC;EoEn/wDE;IACE,gBAAA;IACA,SAAA;IACA,azDmoC8B;EXk3uDlC;AACF;AmBv9wDI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDyoC8B;EXy3uDlC;EoE//wDE;IACE,gBAAA;IACA,SAAA;IACA,azDmoC8B;EX83uDlC;AACF;AmBn+wDI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDyoC8B;EXq4uDlC;EoE3gxDE;IACE,gBAAA;IACA,SAAA;IACA,azDmoC8B;EX04uDlC;AACF;AmB/+wDI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDyoC8B;EXi5uDlC;EoEvhxDE;IACE,gBAAA;IACA,SAAA;IACA,azDmoC8B;EXs5uDlC;AACF;AmB3/wDI;EiDxCA;IACE,gBAAA;IACA,MAAA;IACA,azDyoC8B;EX65uDlC;EoEnixDE;IACE,gBAAA;IACA,SAAA;IACA,azDmoC8B;EXk6uDlC;AACF;AqErkxDA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;ArEukxDF;;AqEpkxDA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;ArEukxDF;;AsE/kxDA;;ECIE,6BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AvEglxDF;;AwE3lxDE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U7DmiBsC;E6DliBtC,WAAA;AxE8lxDJ;;AyEtmxDA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;A1E0mxDF;;A2EhnxDA;EACE,qBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;EACA,8BAAA;EACA,ahEywB4B;AX02vD9B;;A4EvjxDQ;EAOI,mCAAA;A5EojxDZ;;A4E3jxDQ;EAOI,8BAAA;A5EwjxDZ;;A4E/jxDQ;EAOI,iCAAA;A5E4jxDZ;;A4EnkxDQ;EAOI,iCAAA;A5EgkxDZ;;A4EvkxDQ;EAOI,sCAAA;A5EokxDZ;;A4E3kxDQ;EAOI,mCAAA;A5EwkxDZ;;A4E/kxDQ;EAOI,sBAAA;A5E4kxDZ;;A4EnlxDQ;EAOI,uBAAA;A5EglxDZ;;A4EvlxDQ;EAOI,sBAAA;A5EolxDZ;;A4E3lxDQ;EAOI,qBAAA;A5EwlxDZ;;A4E/lxDQ;EAOI,wBAAA;A5E4lxDZ;;A4EnmxDQ;EAOI,uBAAA;A5EgmxDZ;;A4EvmxDQ;EAOI,wBAAA;A5EomxDZ;;A4E3mxDQ;EAOI,qBAAA;A5EwmxDZ;;A4E/mxDQ;EAOI,yBAAA;A5E4mxDZ;;A4EnnxDQ;EAOI,2BAAA;A5EgnxDZ;;A4EvnxDQ;EAOI,4BAAA;A5EonxDZ;;A4E3nxDQ;EAOI,2BAAA;A5EwnxDZ;;A4E/nxDQ;EAOI,0BAAA;A5E4nxDZ;;A4EnoxDQ;EAOI,gCAAA;A5EgoxDZ;;A4EvoxDQ;EAOI,yBAAA;A5EooxDZ;;A4E3oxDQ;EAOI,wBAAA;A5EwoxDZ;;A4E/oxDQ;EAOI,yBAAA;A5E4oxDZ;;A4EnpxDQ;EAOI,6BAAA;A5EgpxDZ;;A4EvpxDQ;EAOI,8BAAA;A5EopxDZ;;A4E3pxDQ;EAOI,wBAAA;A5EwpxDZ;;A4E/pxDQ;EAOI,+BAAA;A5E4pxDZ;;A4EnqxDQ;EAOI,wBAAA;A5EgqxDZ;;A4EvqxDQ;EAOI,uDAAA;A5EoqxDZ;;A4E3qxDQ;EAOI,8DAAA;A5EwqxDZ;;A4E/qxDQ;EAOI,wDAAA;A5E4qxDZ;;A4EnrxDQ;EAOI,2BAAA;A5EgrxDZ;;A4EvrxDQ;EAOI,2BAAA;A5EorxDZ;;A4E3rxDQ;EAOI,6BAAA;A5EwrxDZ;;A4E/rxDQ;EAOI,6BAAA;A5E4rxDZ;;A4EnsxDQ;EAOI,0BAAA;A5EgsxDZ;;A4EvsxDQ;EAOI,2BAAA;A5EosxDZ;;A4E3sxDQ;EAOI,iBAAA;A5EwsxDZ;;A4E/sxDQ;EAOI,mBAAA;A5E4sxDZ;;A4EntxDQ;EAOI,oBAAA;A5EgtxDZ;;A4EvtxDQ;EAOI,oBAAA;A5EotxDZ;;A4E3txDQ;EAOI,sBAAA;A5EwtxDZ;;A4E/txDQ;EAOI,uBAAA;A5E4txDZ;;A4EnuxDQ;EAOI,kBAAA;A5EguxDZ;;A4EvuxDQ;EAOI,oBAAA;A5EouxDZ;;A4E3uxDQ;EAOI,qBAAA;A5EwuxDZ;;A4E/uxDQ;EAOI,mBAAA;A5E4uxDZ;;A4EnvxDQ;EAOI,qBAAA;A5EgvxDZ;;A4EvvxDQ;EAOI,sBAAA;A5EovxDZ;;A4E3vxDQ;EAOI,2CAAA;A5EwvxDZ;;A4E/vxDQ;EAOI,sCAAA;A5E4vxDZ;;A4EnwxDQ;EAOI,sCAAA;A5EgwxDZ;;A4EvwxDQ;EAOI,uFAAA;A5EowxDZ;;A4E3wxDQ;EAOI,oBAAA;A5EwwxDZ;;A4E/wxDQ;EAOI,2FAAA;A5E4wxDZ;;A4EnxxDQ;EAOI,wBAAA;A5EgxxDZ;;A4EvxxDQ;EAOI,6FAAA;A5EoxxDZ;;A4E3xxDQ;EAOI,0BAAA;A5EwxxDZ;;A4E/xxDQ;EAOI,8FAAA;A5E4xxDZ;;A4EnyxDQ;EAOI,2BAAA;A5EgyxDZ;;A4EvyxDQ;EAOI,4FAAA;A5EoyxDZ;;A4E3yxDQ;EAOI,yBAAA;A5EwyxDZ;;A4E/yxDQ;EAIQ,sBAAA;EAGJ,8EAAA;A5E6yxDZ;;A4EpzxDQ;EAIQ,sBAAA;EAGJ,gFAAA;A5EkzxDZ;;A4EzzxDQ;EAIQ,sBAAA;EAGJ,8EAAA;A5EuzxDZ;;A4E9zxDQ;EAIQ,sBAAA;EAGJ,2EAAA;A5E4zxDZ;;A4En0xDQ;EAIQ,sBAAA;EAGJ,8EAAA;A5Ei0xDZ;;A4Ex0xDQ;EAIQ,sBAAA;EAGJ,6EAAA;A5Es0xDZ;;A4E70xDQ;EAIQ,sBAAA;EAGJ,4EAAA;A5E20xDZ;;A4El1xDQ;EAIQ,sBAAA;EAGJ,2EAAA;A5Eg1xDZ;;A4Ev1xDQ;EAIQ,sBAAA;EAGJ,4EAAA;A5Eq1xDZ;;A4Et2xDQ;EACE,sBAAA;A5Ey2xDV;;A4E12xDQ;EACE,sBAAA;A5E62xDV;;A4E92xDQ;EACE,sBAAA;A5Ei3xDV;;A4El3xDQ;EACE,sBAAA;A5Eq3xDV;;A4Et3xDQ;EACE,sBAAA;A5Ey3xDV;;A4E13xDQ;EACE,wBAAA;A5E63xDV;;A4E93xDQ;EACE,yBAAA;A5Ei4xDV;;A4El4xDQ;EACE,wBAAA;A5Eq4xDV;;A4Et4xDQ;EACE,yBAAA;A5Ey4xDV;;A4E14xDQ;EACE,sBAAA;A5E64xDV;;A4Ep4xDQ;EAOI,qBAAA;A5Ei4xDZ;;A4Ex4xDQ;EAOI,qBAAA;A5Eq4xDZ;;A4E54xDQ;EAOI,qBAAA;A5Ey4xDZ;;A4Eh5xDQ;EAOI,sBAAA;A5E64xDZ;;A4Ep5xDQ;EAOI,sBAAA;A5Ei5xDZ;;A4Ex5xDQ;EAOI,0BAAA;A5Eq5xDZ;;A4E55xDQ;EAOI,uBAAA;A5Ey5xDZ;;A4Eh6xDQ;EAOI,2BAAA;A5E65xDZ;;A4Ep6xDQ;EAOI,sBAAA;A5Ei6xDZ;;A4Ex6xDQ;EAOI,sBAAA;A5Eq6xDZ;;A4E56xDQ;EAOI,sBAAA;A5Ey6xDZ;;A4Eh7xDQ;EAOI,uBAAA;A5E66xDZ;;A4Ep7xDQ;EAOI,uBAAA;A5Ei7xDZ;;A4Ex7xDQ;EAOI,2BAAA;A5Eq7xDZ;;A4E57xDQ;EAOI,wBAAA;A5Ey7xDZ;;A4Eh8xDQ;EAOI,4BAAA;A5E67xDZ;;A4Ep8xDQ;EAOI,yBAAA;A5Ei8xDZ;;A4Ex8xDQ;EAOI,8BAAA;A5Eq8xDZ;;A4E58xDQ;EAOI,iCAAA;A5Ey8xDZ;;A4Eh9xDQ;EAOI,sCAAA;A5E68xDZ;;A4Ep9xDQ;EAOI,yCAAA;A5Ei9xDZ;;A4Ex9xDQ;EAOI,uBAAA;A5Eq9xDZ;;A4E59xDQ;EAOI,uBAAA;A5Ey9xDZ;;A4Eh+xDQ;EAOI,yBAAA;A5E69xDZ;;A4Ep+xDQ;EAOI,yBAAA;A5Ei+xDZ;;A4Ex+xDQ;EAOI,0BAAA;A5Eq+xDZ;;A4E5+xDQ;EAOI,4BAAA;A5Ey+xDZ;;A4Eh/xDQ;EAOI,kCAAA;A5E6+xDZ;;A4Ep/xDQ;EAOI,sCAAA;A5Ei/xDZ;;A4Ex/xDQ;EAOI,oCAAA;A5Eq/xDZ;;A4E5/xDQ;EAOI,kCAAA;A5Ey/xDZ;;A4EhgyDQ;EAOI,yCAAA;A5E6/xDZ;;A4EpgyDQ;EAOI,wCAAA;A5EigyDZ;;A4ExgyDQ;EAOI,wCAAA;A5EqgyDZ;;A4E5gyDQ;EAOI,kCAAA;A5EygyDZ;;A4EhhyDQ;EAOI,gCAAA;A5E6gyDZ;;A4EphyDQ;EAOI,8BAAA;A5EihyDZ;;A4ExhyDQ;EAOI,gCAAA;A5EqhyDZ;;A4E5hyDQ;EAOI,+BAAA;A5EyhyDZ;;A4EhiyDQ;EAOI,oCAAA;A5E6hyDZ;;A4EpiyDQ;EAOI,kCAAA;A5EiiyDZ;;A4ExiyDQ;EAOI,gCAAA;A5EqiyDZ;;A4E5iyDQ;EAOI,uCAAA;A5EyiyDZ;;A4EhjyDQ;EAOI,sCAAA;A5E6iyDZ;;A4EpjyDQ;EAOI,iCAAA;A5EijyDZ;;A4ExjyDQ;EAOI,2BAAA;A5EqjyDZ;;A4E5jyDQ;EAOI,iCAAA;A5EyjyDZ;;A4EhkyDQ;EAOI,+BAAA;A5E6jyDZ;;A4EpkyDQ;EAOI,6BAAA;A5EikyDZ;;A4ExkyDQ;EAOI,+BAAA;A5EqkyDZ;;A4E5kyDQ;EAOI,8BAAA;A5EykyDZ;;A4EhlyDQ;EAOI,oBAAA;A5E6kyDZ;;A4EplyDQ;EAOI,mBAAA;A5EilyDZ;;A4ExlyDQ;EAOI,mBAAA;A5EqlyDZ;;A4E5lyDQ;EAOI,mBAAA;A5EylyDZ;;A4EhmyDQ;EAOI,mBAAA;A5E6lyDZ;;A4EpmyDQ;EAOI,mBAAA;A5EimyDZ;;A4ExmyDQ;EAOI,mBAAA;A5EqmyDZ;;A4E5myDQ;EAOI,mBAAA;A5EymyDZ;;A4EhnyDQ;EAOI,oBAAA;A5E6myDZ;;A4EpnyDQ;EAOI,0BAAA;A5EinyDZ;;A4ExnyDQ;EAOI,yBAAA;A5EqnyDZ;;A4E5nyDQ;EAOI,uBAAA;A5EynyDZ;;A4EhoyDQ;EAOI,yBAAA;A5E6nyDZ;;A4EpoyDQ;EAOI,uBAAA;A5EioyDZ;;A4ExoyDQ;EAOI,uBAAA;A5EqoyDZ;;A4E5oyDQ;EAOI,0BAAA;EAAA,yBAAA;A5E0oyDZ;;A4EjpyDQ;EAOI,gCAAA;EAAA,+BAAA;A5E+oyDZ;;A4EtpyDQ;EAOI,+BAAA;EAAA,8BAAA;A5EopyDZ;;A4E3pyDQ;EAOI,6BAAA;EAAA,4BAAA;A5EypyDZ;;A4EhqyDQ;EAOI,+BAAA;EAAA,8BAAA;A5E8pyDZ;;A4ErqyDQ;EAOI,6BAAA;EAAA,4BAAA;A5EmqyDZ;;A4E1qyDQ;EAOI,6BAAA;EAAA,4BAAA;A5EwqyDZ;;A4E/qyDQ;EAOI,wBAAA;EAAA,2BAAA;A5E6qyDZ;;A4EpryDQ;EAOI,8BAAA;EAAA,iCAAA;A5EkryDZ;;A4EzryDQ;EAOI,6BAAA;EAAA,gCAAA;A5EuryDZ;;A4E9ryDQ;EAOI,2BAAA;EAAA,8BAAA;A5E4ryDZ;;A4EnsyDQ;EAOI,6BAAA;EAAA,gCAAA;A5EisyDZ;;A4ExsyDQ;EAOI,2BAAA;EAAA,8BAAA;A5EssyDZ;;A4E7syDQ;EAOI,2BAAA;EAAA,8BAAA;A5E2syDZ;;A4EltyDQ;EAOI,wBAAA;A5E+syDZ;;A4EttyDQ;EAOI,8BAAA;A5EmtyDZ;;A4E1tyDQ;EAOI,6BAAA;A5EutyDZ;;A4E9tyDQ;EAOI,2BAAA;A5E2tyDZ;;A4EluyDQ;EAOI,6BAAA;A5E+tyDZ;;A4EtuyDQ;EAOI,2BAAA;A5EmuyDZ;;A4E1uyDQ;EAOI,2BAAA;A5EuuyDZ;;A4E9uyDQ;EAOI,0BAAA;A5E2uyDZ;;A4ElvyDQ;EAOI,gCAAA;A5E+uyDZ;;A4EtvyDQ;EAOI,+BAAA;A5EmvyDZ;;A4E1vyDQ;EAOI,6BAAA;A5EuvyDZ;;A4E9vyDQ;EAOI,+BAAA;A5E2vyDZ;;A4ElwyDQ;EAOI,6BAAA;A5E+vyDZ;;A4EtwyDQ;EAOI,6BAAA;A5EmwyDZ;;A4E1wyDQ;EAOI,2BAAA;A5EuwyDZ;;A4E9wyDQ;EAOI,iCAAA;A5E2wyDZ;;A4ElxyDQ;EAOI,gCAAA;A5E+wyDZ;;A4EtxyDQ;EAOI,8BAAA;A5EmxyDZ;;A4E1xyDQ;EAOI,gCAAA;A5EuxyDZ;;A4E9xyDQ;EAOI,8BAAA;A5E2xyDZ;;A4ElyyDQ;EAOI,8BAAA;A5E+xyDZ;;A4EtyyDQ;EAOI,yBAAA;A5EmyyDZ;;A4E1yyDQ;EAOI,+BAAA;A5EuyyDZ;;A4E9yyDQ;EAOI,8BAAA;A5E2yyDZ;;A4ElzyDQ;EAOI,4BAAA;A5E+yyDZ;;A4EtzyDQ;EAOI,8BAAA;A5EmzyDZ;;A4E1zyDQ;EAOI,4BAAA;A5EuzyDZ;;A4E9zyDQ;EAOI,4BAAA;A5E2zyDZ;;A4El0yDQ;EAOI,2BAAA;A5E+zyDZ;;A4Et0yDQ;EAOI,0BAAA;A5Em0yDZ;;A4E10yDQ;EAOI,wBAAA;A5Eu0yDZ;;A4E90yDQ;EAOI,0BAAA;A5E20yDZ;;A4El1yDQ;EAOI,wBAAA;A5E+0yDZ;;A4Et1yDQ;EAOI,iCAAA;EAAA,gCAAA;A5Eo1yDZ;;A4E31yDQ;EAOI,gCAAA;EAAA,+BAAA;A5Ey1yDZ;;A4Eh2yDQ;EAOI,8BAAA;EAAA,6BAAA;A5E81yDZ;;A4Er2yDQ;EAOI,gCAAA;EAAA,+BAAA;A5Em2yDZ;;A4E12yDQ;EAOI,8BAAA;EAAA,6BAAA;A5Ew2yDZ;;A4E/2yDQ;EAOI,+BAAA;EAAA,kCAAA;A5E62yDZ;;A4Ep3yDQ;EAOI,8BAAA;EAAA,iCAAA;A5Ek3yDZ;;A4Ez3yDQ;EAOI,4BAAA;EAAA,+BAAA;A5Eu3yDZ;;A4E93yDQ;EAOI,8BAAA;EAAA,iCAAA;A5E43yDZ;;A4En4yDQ;EAOI,4BAAA;EAAA,+BAAA;A5Ei4yDZ;;A4Ex4yDQ;EAOI,+BAAA;A5Eq4yDZ;;A4E54yDQ;EAOI,8BAAA;A5Ey4yDZ;;A4Eh5yDQ;EAOI,4BAAA;A5E64yDZ;;A4Ep5yDQ;EAOI,8BAAA;A5Ei5yDZ;;A4Ex5yDQ;EAOI,4BAAA;A5Eq5yDZ;;A4E55yDQ;EAOI,iCAAA;A5Ey5yDZ;;A4Eh6yDQ;EAOI,gCAAA;A5E65yDZ;;A4Ep6yDQ;EAOI,8BAAA;A5Ei6yDZ;;A4Ex6yDQ;EAOI,gCAAA;A5Eq6yDZ;;A4E56yDQ;EAOI,8BAAA;A5Ey6yDZ;;A4Eh7yDQ;EAOI,kCAAA;A5E66yDZ;;A4Ep7yDQ;EAOI,iCAAA;A5Ei7yDZ;;A4Ex7yDQ;EAOI,+BAAA;A5Eq7yDZ;;A4E57yDQ;EAOI,iCAAA;A5Ey7yDZ;;A4Eh8yDQ;EAOI,+BAAA;A5E67yDZ;;A4Ep8yDQ;EAOI,gCAAA;A5Ei8yDZ;;A4Ex8yDQ;EAOI,+BAAA;A5Eq8yDZ;;A4E58yDQ;EAOI,6BAAA;A5Ey8yDZ;;A4Eh9yDQ;EAOI,+BAAA;A5E68yDZ;;A4Ep9yDQ;EAOI,6BAAA;A5Ei9yDZ;;A4Ex9yDQ;EAOI,qBAAA;A5Eq9yDZ;;A4E59yDQ;EAOI,2BAAA;A5Ey9yDZ;;A4Eh+yDQ;EAOI,0BAAA;A5E69yDZ;;A4Ep+yDQ;EAOI,wBAAA;A5Ei+yDZ;;A4Ex+yDQ;EAOI,0BAAA;A5Eq+yDZ;;A4E5+yDQ;EAOI,wBAAA;A5Ey+yDZ;;A4Eh/yDQ;EAOI,2BAAA;EAAA,0BAAA;A5E8+yDZ;;A4Er/yDQ;EAOI,iCAAA;EAAA,gCAAA;A5Em/yDZ;;A4E1/yDQ;EAOI,gCAAA;EAAA,+BAAA;A5Ew/yDZ;;A4E//yDQ;EAOI,8BAAA;EAAA,6BAAA;A5E6/yDZ;;A4EpgzDQ;EAOI,gCAAA;EAAA,+BAAA;A5EkgzDZ;;A4EzgzDQ;EAOI,8BAAA;EAAA,6BAAA;A5EugzDZ;;A4E9gzDQ;EAOI,yBAAA;EAAA,4BAAA;A5E4gzDZ;;A4EnhzDQ;EAOI,+BAAA;EAAA,kCAAA;A5EihzDZ;;A4ExhzDQ;EAOI,8BAAA;EAAA,iCAAA;A5EshzDZ;;A4E7hzDQ;EAOI,4BAAA;EAAA,+BAAA;A5E2hzDZ;;A4ElizDQ;EAOI,8BAAA;EAAA,iCAAA;A5EgizDZ;;A4EvizDQ;EAOI,4BAAA;EAAA,+BAAA;A5EqizDZ;;A4E5izDQ;EAOI,yBAAA;A5EyizDZ;;A4EhjzDQ;EAOI,+BAAA;A5E6izDZ;;A4EpjzDQ;EAOI,8BAAA;A5EijzDZ;;A4ExjzDQ;EAOI,4BAAA;A5EqjzDZ;;A4E5jzDQ;EAOI,8BAAA;A5EyjzDZ;;A4EhkzDQ;EAOI,4BAAA;A5E6jzDZ;;A4EpkzDQ;EAOI,2BAAA;A5EikzDZ;;A4ExkzDQ;EAOI,iCAAA;A5EqkzDZ;;A4E5kzDQ;EAOI,gCAAA;A5EykzDZ;;A4EhlzDQ;EAOI,8BAAA;A5E6kzDZ;;A4EplzDQ;EAOI,gCAAA;A5EilzDZ;;A4ExlzDQ;EAOI,8BAAA;A5EqlzDZ;;A4E5lzDQ;EAOI,4BAAA;A5EylzDZ;;A4EhmzDQ;EAOI,kCAAA;A5E6lzDZ;;A4EpmzDQ;EAOI,iCAAA;A5EimzDZ;;A4ExmzDQ;EAOI,+BAAA;A5EqmzDZ;;A4E5mzDQ;EAOI,iCAAA;A5EymzDZ;;A4EhnzDQ;EAOI,+BAAA;A5E6mzDZ;;A4EpnzDQ;EAOI,0BAAA;A5EinzDZ;;A4ExnzDQ;EAOI,gCAAA;A5EqnzDZ;;A4E5nzDQ;EAOI,+BAAA;A5EynzDZ;;A4EhozDQ;EAOI,6BAAA;A5E6nzDZ;;A4EpozDQ;EAOI,+BAAA;A5EiozDZ;;A4ExozDQ;EAOI,6BAAA;A5EqozDZ;;A4E5ozDQ;EAOI,iBAAA;A5EyozDZ;;A4EhpzDQ;EAOI,uBAAA;A5E6ozDZ;;A4EppzDQ;EAOI,sBAAA;A5EipzDZ;;A4ExpzDQ;EAOI,oBAAA;A5EqpzDZ;;A4E5pzDQ;EAOI,sBAAA;A5EypzDZ;;A4EhqzDQ;EAOI,oBAAA;A5E6pzDZ;;A4EpqzDQ;EAOI,gDAAA;A5EiqzDZ;;A4ExqzDQ;EAOI,kDAAA;A5EqqzDZ;;A4E5qzDQ;EAOI,8CAAA;A5EyqzDZ;;A4EhrzDQ;EAOI,oDAAA;A5E6qzDZ;;A4EprzDQ;EAOI,gCAAA;A5EirzDZ;;A4ExrzDQ;EAOI,iCAAA;A5EqrzDZ;;A4E5rzDQ;EAOI,+BAAA;A5EyrzDZ;;A4EhszDQ;EAOI,6BAAA;A5E6rzDZ;;A4EpszDQ;EAOI,6BAAA;A5EiszDZ;;A4ExszDQ;EAOI,2BAAA;A5EqszDZ;;A4E5szDQ;EAOI,+BAAA;A5EyszDZ;;A4EhtzDQ;EAOI,2BAAA;A5E6szDZ;;A4EptzDQ;EAOI,2BAAA;A5EitzDZ;;A4ExtzDQ;EAOI,2BAAA;A5EqtzDZ;;A4E5tzDQ;EAOI,8BAAA;A5EytzDZ;;A4EhuzDQ;EAOI,yBAAA;A5E6tzDZ;;A4EpuzDQ;EAOI,4BAAA;A5EiuzDZ;;A4ExuzDQ;EAOI,2BAAA;A5EquzDZ;;A4E5uzDQ;EAOI,yBAAA;A5EyuzDZ;;A4EhvzDQ;EAOI,2BAAA;A5E6uzDZ;;A4EpvzDQ;EAOI,4BAAA;A5EivzDZ;;A4ExvzDQ;EAOI,6BAAA;A5EqvzDZ;;A4E5vzDQ;EAOI,gCAAA;A5EyvzDZ;;A4EhwzDQ;EAOI,qCAAA;A5E6vzDZ;;A4EpwzDQ;EAOI,wCAAA;A5EiwzDZ;;A4ExwzDQ;EAOI,oCAAA;A5EqwzDZ;;A4E5wzDQ;EAOI,oCAAA;A5EywzDZ;;A4EhxzDQ;EAOI,qCAAA;A5E6wzDZ;;A4EpxzDQ;EAOI,8BAAA;A5EixzDZ;;A4ExxzDQ;EAOI,8BAAA;A5EqxzDZ;;A4E1yzDQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;A5E2xzDZ;;A4ExwzDQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;A5EiyzDZ;;A4ExyzDQ;EAIQ,oBAAA;EAGJ,uEAAA;A5EsyzDZ;;A4E7yzDQ;EAIQ,oBAAA;EAGJ,qEAAA;A5E2yzDZ;;A4ElzzDQ;EAIQ,oBAAA;EAGJ,kEAAA;A5EgzzDZ;;A4EvzzDQ;EAIQ,oBAAA;EAGJ,qEAAA;A5EqzzDZ;;A4E5zzDQ;EAIQ,oBAAA;EAGJ,oEAAA;A5E0zzDZ;;A4Ej0zDQ;EAIQ,oBAAA;EAGJ,mEAAA;A5E+zzDZ;;A4Et0zDQ;EAIQ,oBAAA;EAGJ,kEAAA;A5Eo0zDZ;;A4E30zDQ;EAIQ,oBAAA;EAGJ,mEAAA;A5Ey0zDZ;;A4Eh1zDQ;EAIQ,oBAAA;EAGJ,mEAAA;A5E80zDZ;;A4Er1zDQ;EAIQ,oBAAA;EAGJ,wEAAA;A5Em1zDZ;;A4E11zDQ;EAIQ,oBAAA;EAGJ,yBAAA;A5Ew1zDZ;;A4E/1zDQ;EAIQ,oBAAA;EAGJ,oCAAA;A5E61zDZ;;A4Ep2zDQ;EAIQ,oBAAA;EAGJ,0CAAA;A5Ek2zDZ;;A4Ez2zDQ;EAIQ,oBAAA;EAGJ,yBAAA;A5Eu2zDZ;;A4Ex3zDQ;EACE,uBAAA;A5E23zDV;;A4E53zDQ;EACE,sBAAA;A5E+3zDV;;A4Eh4zDQ;EACE,uBAAA;A5Em4zDV;;A4Ep4zDQ;EACE,oBAAA;A5Eu4zDV;;A4E93zDQ;EAIQ,kBAAA;EAGJ,8EAAA;A5E43zDZ;;A4En4zDQ;EAIQ,kBAAA;EAGJ,gFAAA;A5Ei4zDZ;;A4Ex4zDQ;EAIQ,kBAAA;EAGJ,8EAAA;A5Es4zDZ;;A4E74zDQ;EAIQ,kBAAA;EAGJ,2EAAA;A5E24zDZ;;A4El5zDQ;EAIQ,kBAAA;EAGJ,8EAAA;A5Eg5zDZ;;A4Ev5zDQ;EAIQ,kBAAA;EAGJ,6EAAA;A5Eq5zDZ;;A4E55zDQ;EAIQ,kBAAA;EAGJ,4EAAA;A5E05zDZ;;A4Ej6zDQ;EAIQ,kBAAA;EAGJ,2EAAA;A5E+5zDZ;;A4Et6zDQ;EAIQ,kBAAA;EAGJ,4EAAA;A5Eo6zDZ;;A4E36zDQ;EAIQ,kBAAA;EAGJ,4EAAA;A5Ey6zDZ;;A4Eh7zDQ;EAIQ,kBAAA;EAGJ,8EAAA;A5E86zDZ;;A4Er7zDQ;EAIQ,kBAAA;EAGJ,wCAAA;A5Em7zDZ;;A4Ep8zDQ;EACE,oBAAA;A5Eu8zDV;;A4Ex8zDQ;EACE,qBAAA;A5E28zDV;;A4E58zDQ;EACE,oBAAA;A5E+8zDV;;A4Eh9zDQ;EACE,qBAAA;A5Em9zDV;;A4Ep9zDQ;EACE,kBAAA;A5Eu9zDV;;A4E98zDQ;EAOI,+CAAA;A5E28zDZ;;A4El9zDQ;EAOI,mCAAA;UAAA,2BAAA;A5E+8zDZ;;A4Et9zDQ;EAOI,oCAAA;UAAA,4BAAA;A5Em9zDZ;;A4E19zDQ;EAOI,oCAAA;UAAA,4BAAA;A5Eu9zDZ;;A4E99zDQ;EAOI,+BAAA;A5E29zDZ;;A4El+zDQ;EAOI,+BAAA;A5E+9zDZ;;A4Et+zDQ;EAOI,iDAAA;A5Em+zDZ;;A4E1+zDQ;EAOI,2BAAA;A5Eu+zDZ;;A4E9+zDQ;EAOI,oDAAA;A5E2+zDZ;;A4El/zDQ;EAOI,iDAAA;A5E++zDZ;;A4Et/zDQ;EAOI,oDAAA;A5Em/zDZ;;A4E1/zDQ;EAOI,oDAAA;A5Eu/zDZ;;A4E9/zDQ;EAOI,qDAAA;A5E2/zDZ;;A4Elg0DQ;EAOI,6BAAA;A5E+/zDZ;;A4Etg0DQ;EAOI,sDAAA;A5Emg0DZ;;A4E1g0DQ;EAOI,0DAAA;EAAA,2DAAA;A5Ewg0DZ;;A4E/g0DQ;EAOI,2DAAA;EAAA,8DAAA;A5E6g0DZ;;A4Eph0DQ;EAOI,8DAAA;EAAA,6DAAA;A5Ekh0DZ;;A4Ezh0DQ;EAOI,6DAAA;EAAA,0DAAA;A5Euh0DZ;;A4E9h0DQ;EAOI,8BAAA;A5E2h0DZ;;A4Eli0DQ;EAOI,6BAAA;A5E+h0DZ;;AmBzi0DI;EyDGI;IAOI,sBAAA;E5Eoi0DV;E4E3i0DM;IAOI,uBAAA;E5Eui0DV;E4E9i0DM;IAOI,sBAAA;E5E0i0DV;E4Ejj0DM;IAOI,0BAAA;E5E6i0DV;E4Epj0DM;IAOI,gCAAA;E5Egj0DV;E4Evj0DM;IAOI,yBAAA;E5Emj0DV;E4E1j0DM;IAOI,wBAAA;E5Esj0DV;E4E7j0DM;IAOI,yBAAA;E5Eyj0DV;E4Ehk0DM;IAOI,6BAAA;E5E4j0DV;E4Enk0DM;IAOI,8BAAA;E5E+j0DV;E4Etk0DM;IAOI,wBAAA;E5Ekk0DV;E4Ezk0DM;IAOI,+BAAA;E5Eqk0DV;E4E5k0DM;IAOI,wBAAA;E5Ewk0DV;E4E/k0DM;IAOI,yBAAA;E5E2k0DV;E4Ell0DM;IAOI,8BAAA;E5E8k0DV;E4Erl0DM;IAOI,iCAAA;E5Eil0DV;E4Exl0DM;IAOI,sCAAA;E5Eol0DV;E4E3l0DM;IAOI,yCAAA;E5Eul0DV;E4E9l0DM;IAOI,uBAAA;E5E0l0DV;E4Ejm0DM;IAOI,uBAAA;E5E6l0DV;E4Epm0DM;IAOI,yBAAA;E5Egm0DV;E4Evm0DM;IAOI,yBAAA;E5Emm0DV;E4E1m0DM;IAOI,0BAAA;E5Esm0DV;E4E7m0DM;IAOI,4BAAA;E5Eym0DV;E4Ehn0DM;IAOI,kCAAA;E5E4m0DV;E4Enn0DM;IAOI,sCAAA;E5E+m0DV;E4Etn0DM;IAOI,oCAAA;E5Ekn0DV;E4Ezn0DM;IAOI,kCAAA;E5Eqn0DV;E4E5n0DM;IAOI,yCAAA;E5Ewn0DV;E4E/n0DM;IAOI,wCAAA;E5E2n0DV;E4Elo0DM;IAOI,wCAAA;E5E8n0DV;E4Ero0DM;IAOI,kCAAA;E5Eio0DV;E4Exo0DM;IAOI,gCAAA;E5Eoo0DV;E4E3o0DM;IAOI,8BAAA;E5Euo0DV;E4E9o0DM;IAOI,gCAAA;E5E0o0DV;E4Ejp0DM;IAOI,+BAAA;E5E6o0DV;E4Epp0DM;IAOI,oCAAA;E5Egp0DV;E4Evp0DM;IAOI,kCAAA;E5Emp0DV;E4E1p0DM;IAOI,gCAAA;E5Esp0DV;E4E7p0DM;IAOI,uCAAA;E5Eyp0DV;E4Ehq0DM;IAOI,sCAAA;E5E4p0DV;E4Enq0DM;IAOI,iCAAA;E5E+p0DV;E4Etq0DM;IAOI,2BAAA;E5Ekq0DV;E4Ezq0DM;IAOI,iCAAA;E5Eqq0DV;E4E5q0DM;IAOI,+BAAA;E5Ewq0DV;E4E/q0DM;IAOI,6BAAA;E5E2q0DV;E4Elr0DM;IAOI,+BAAA;E5E8q0DV;E4Err0DM;IAOI,8BAAA;E5Eir0DV;E4Exr0DM;IAOI,oBAAA;E5Eor0DV;E4E3r0DM;IAOI,mBAAA;E5Eur0DV;E4E9r0DM;IAOI,mBAAA;E5E0r0DV;E4Ejs0DM;IAOI,mBAAA;E5E6r0DV;E4Eps0DM;IAOI,mBAAA;E5Egs0DV;E4Evs0DM;IAOI,mBAAA;E5Ems0DV;E4E1s0DM;IAOI,mBAAA;E5Ess0DV;E4E7s0DM;IAOI,mBAAA;E5Eys0DV;E4Eht0DM;IAOI,oBAAA;E5E4s0DV;E4Ent0DM;IAOI,0BAAA;E5E+s0DV;E4Ett0DM;IAOI,yBAAA;E5Ekt0DV;E4Ezt0DM;IAOI,uBAAA;E5Eqt0DV;E4E5t0DM;IAOI,yBAAA;E5Ewt0DV;E4E/t0DM;IAOI,uBAAA;E5E2t0DV;E4Elu0DM;IAOI,uBAAA;E5E8t0DV;E4Eru0DM;IAOI,0BAAA;IAAA,yBAAA;E5Eku0DV;E4Ezu0DM;IAOI,gCAAA;IAAA,+BAAA;E5Esu0DV;E4E7u0DM;IAOI,+BAAA;IAAA,8BAAA;E5E0u0DV;E4Ejv0DM;IAOI,6BAAA;IAAA,4BAAA;E5E8u0DV;E4Erv0DM;IAOI,+BAAA;IAAA,8BAAA;E5Ekv0DV;E4Ezv0DM;IAOI,6BAAA;IAAA,4BAAA;E5Esv0DV;E4E7v0DM;IAOI,6BAAA;IAAA,4BAAA;E5E0v0DV;E4Ejw0DM;IAOI,wBAAA;IAAA,2BAAA;E5E8v0DV;E4Erw0DM;IAOI,8BAAA;IAAA,iCAAA;E5Ekw0DV;E4Ezw0DM;IAOI,6BAAA;IAAA,gCAAA;E5Esw0DV;E4E7w0DM;IAOI,2BAAA;IAAA,8BAAA;E5E0w0DV;E4Ejx0DM;IAOI,6BAAA;IAAA,gCAAA;E5E8w0DV;E4Erx0DM;IAOI,2BAAA;IAAA,8BAAA;E5Ekx0DV;E4Ezx0DM;IAOI,2BAAA;IAAA,8BAAA;E5Esx0DV;E4E7x0DM;IAOI,wBAAA;E5Eyx0DV;E4Ehy0DM;IAOI,8BAAA;E5E4x0DV;E4Eny0DM;IAOI,6BAAA;E5E+x0DV;E4Ety0DM;IAOI,2BAAA;E5Eky0DV;E4Ezy0DM;IAOI,6BAAA;E5Eqy0DV;E4E5y0DM;IAOI,2BAAA;E5Ewy0DV;E4E/y0DM;IAOI,2BAAA;E5E2y0DV;E4Elz0DM;IAOI,0BAAA;E5E8y0DV;E4Erz0DM;IAOI,gCAAA;E5Eiz0DV;E4Exz0DM;IAOI,+BAAA;E5Eoz0DV;E4E3z0DM;IAOI,6BAAA;E5Euz0DV;E4E9z0DM;IAOI,+BAAA;E5E0z0DV;E4Ej00DM;IAOI,6BAAA;E5E6z0DV;E4Ep00DM;IAOI,6BAAA;E5Eg00DV;E4Ev00DM;IAOI,2BAAA;E5Em00DV;E4E100DM;IAOI,iCAAA;E5Es00DV;E4E700DM;IAOI,gCAAA;E5Ey00DV;E4Eh10DM;IAOI,8BAAA;E5E400DV;E4En10DM;IAOI,gCAAA;E5E+00DV;E4Et10DM;IAOI,8BAAA;E5Ek10DV;E4Ez10DM;IAOI,8BAAA;E5Eq10DV;E4E510DM;IAOI,yBAAA;E5Ew10DV;E4E/10DM;IAOI,+BAAA;E5E210DV;E4El20DM;IAOI,8BAAA;E5E810DV;E4Er20DM;IAOI,4BAAA;E5Ei20DV;E4Ex20DM;IAOI,8BAAA;E5Eo20DV;E4E320DM;IAOI,4BAAA;E5Eu20DV;E4E920DM;IAOI,4BAAA;E5E020DV;E4Ej30DM;IAOI,2BAAA;E5E620DV;E4Ep30DM;IAOI,0BAAA;E5Eg30DV;E4Ev30DM;IAOI,wBAAA;E5Em30DV;E4E130DM;IAOI,0BAAA;E5Es30DV;E4E730DM;IAOI,wBAAA;E5Ey30DV;E4Eh40DM;IAOI,iCAAA;IAAA,gCAAA;E5E630DV;E4Ep40DM;IAOI,gCAAA;IAAA,+BAAA;E5Ei40DV;E4Ex40DM;IAOI,8BAAA;IAAA,6BAAA;E5Eq40DV;E4E540DM;IAOI,gCAAA;IAAA,+BAAA;E5Ey40DV;E4Eh50DM;IAOI,8BAAA;IAAA,6BAAA;E5E640DV;E4Ep50DM;IAOI,+BAAA;IAAA,kCAAA;E5Ei50DV;E4Ex50DM;IAOI,8BAAA;IAAA,iCAAA;E5Eq50DV;E4E550DM;IAOI,4BAAA;IAAA,+BAAA;E5Ey50DV;E4Eh60DM;IAOI,8BAAA;IAAA,iCAAA;E5E650DV;E4Ep60DM;IAOI,4BAAA;IAAA,+BAAA;E5Ei60DV;E4Ex60DM;IAOI,+BAAA;E5Eo60DV;E4E360DM;IAOI,8BAAA;E5Eu60DV;E4E960DM;IAOI,4BAAA;E5E060DV;E4Ej70DM;IAOI,8BAAA;E5E660DV;E4Ep70DM;IAOI,4BAAA;E5Eg70DV;E4Ev70DM;IAOI,iCAAA;E5Em70DV;E4E170DM;IAOI,gCAAA;E5Es70DV;E4E770DM;IAOI,8BAAA;E5Ey70DV;E4Eh80DM;IAOI,gCAAA;E5E470DV;E4En80DM;IAOI,8BAAA;E5E+70DV;E4Et80DM;IAOI,kCAAA;E5Ek80DV;E4Ez80DM;IAOI,iCAAA;E5Eq80DV;E4E580DM;IAOI,+BAAA;E5Ew80DV;E4E/80DM;IAOI,iCAAA;E5E280DV;E4El90DM;IAOI,+BAAA;E5E880DV;E4Er90DM;IAOI,gCAAA;E5Ei90DV;E4Ex90DM;IAOI,+BAAA;E5Eo90DV;E4E390DM;IAOI,6BAAA;E5Eu90DV;E4E990DM;IAOI,+BAAA;E5E090DV;E4Ej+0DM;IAOI,6BAAA;E5E690DV;E4Ep+0DM;IAOI,qBAAA;E5Eg+0DV;E4Ev+0DM;IAOI,2BAAA;E5Em+0DV;E4E1+0DM;IAOI,0BAAA;E5Es+0DV;E4E7+0DM;IAOI,wBAAA;E5Ey+0DV;E4Eh/0DM;IAOI,0BAAA;E5E4+0DV;E4En/0DM;IAOI,wBAAA;E5E++0DV;E4Et/0DM;IAOI,2BAAA;IAAA,0BAAA;E5Em/0DV;E4E1/0DM;IAOI,iCAAA;IAAA,gCAAA;E5Eu/0DV;E4E9/0DM;IAOI,gCAAA;IAAA,+BAAA;E5E2/0DV;E4Elg1DM;IAOI,8BAAA;IAAA,6BAAA;E5E+/0DV;E4Etg1DM;IAOI,gCAAA;IAAA,+BAAA;E5Emg1DV;E4E1g1DM;IAOI,8BAAA;IAAA,6BAAA;E5Eug1DV;E4E9g1DM;IAOI,yBAAA;IAAA,4BAAA;E5E2g1DV;E4Elh1DM;IAOI,+BAAA;IAAA,kCAAA;E5E+g1DV;E4Eth1DM;IAOI,8BAAA;IAAA,iCAAA;E5Emh1DV;E4E1h1DM;IAOI,4BAAA;IAAA,+BAAA;E5Euh1DV;E4E9h1DM;IAOI,8BAAA;IAAA,iCAAA;E5E2h1DV;E4Eli1DM;IAOI,4BAAA;IAAA,+BAAA;E5E+h1DV;E4Eti1DM;IAOI,yBAAA;E5Eki1DV;E4Ezi1DM;IAOI,+BAAA;E5Eqi1DV;E4E5i1DM;IAOI,8BAAA;E5Ewi1DV;E4E/i1DM;IAOI,4BAAA;E5E2i1DV;E4Elj1DM;IAOI,8BAAA;E5E8i1DV;E4Erj1DM;IAOI,4BAAA;E5Eij1DV;E4Exj1DM;IAOI,2BAAA;E5Eoj1DV;E4E3j1DM;IAOI,iCAAA;E5Euj1DV;E4E9j1DM;IAOI,gCAAA;E5E0j1DV;E4Ejk1DM;IAOI,8BAAA;E5E6j1DV;E4Epk1DM;IAOI,gCAAA;E5Egk1DV;E4Evk1DM;IAOI,8BAAA;E5Emk1DV;E4E1k1DM;IAOI,4BAAA;E5Esk1DV;E4E7k1DM;IAOI,kCAAA;E5Eyk1DV;E4Ehl1DM;IAOI,iCAAA;E5E4k1DV;E4Enl1DM;IAOI,+BAAA;E5E+k1DV;E4Etl1DM;IAOI,iCAAA;E5Ekl1DV;E4Ezl1DM;IAOI,+BAAA;E5Eql1DV;E4E5l1DM;IAOI,0BAAA;E5Ewl1DV;E4E/l1DM;IAOI,gCAAA;E5E2l1DV;E4Elm1DM;IAOI,+BAAA;E5E8l1DV;E4Erm1DM;IAOI,6BAAA;E5Eim1DV;E4Exm1DM;IAOI,+BAAA;E5Eom1DV;E4E3m1DM;IAOI,6BAAA;E5Eum1DV;E4E9m1DM;IAOI,iBAAA;E5E0m1DV;E4Ejn1DM;IAOI,uBAAA;E5E6m1DV;E4Epn1DM;IAOI,sBAAA;E5Egn1DV;E4Evn1DM;IAOI,oBAAA;E5Emn1DV;E4E1n1DM;IAOI,sBAAA;E5Esn1DV;E4E7n1DM;IAOI,oBAAA;E5Eyn1DV;E4Eho1DM;IAOI,2BAAA;E5E4n1DV;E4Eno1DM;IAOI,4BAAA;E5E+n1DV;E4Eto1DM;IAOI,6BAAA;E5Eko1DV;AACF;AmB7o1DI;EyDGI;IAOI,sBAAA;E5Euo1DV;E4E9o1DM;IAOI,uBAAA;E5E0o1DV;E4Ejp1DM;IAOI,sBAAA;E5E6o1DV;E4Epp1DM;IAOI,0BAAA;E5Egp1DV;E4Evp1DM;IAOI,gCAAA;E5Emp1DV;E4E1p1DM;IAOI,yBAAA;E5Esp1DV;E4E7p1DM;IAOI,wBAAA;E5Eyp1DV;E4Ehq1DM;IAOI,yBAAA;E5E4p1DV;E4Enq1DM;IAOI,6BAAA;E5E+p1DV;E4Etq1DM;IAOI,8BAAA;E5Ekq1DV;E4Ezq1DM;IAOI,wBAAA;E5Eqq1DV;E4E5q1DM;IAOI,+BAAA;E5Ewq1DV;E4E/q1DM;IAOI,wBAAA;E5E2q1DV;E4Elr1DM;IAOI,yBAAA;E5E8q1DV;E4Err1DM;IAOI,8BAAA;E5Eir1DV;E4Exr1DM;IAOI,iCAAA;E5Eor1DV;E4E3r1DM;IAOI,sCAAA;E5Eur1DV;E4E9r1DM;IAOI,yCAAA;E5E0r1DV;E4Ejs1DM;IAOI,uBAAA;E5E6r1DV;E4Eps1DM;IAOI,uBAAA;E5Egs1DV;E4Evs1DM;IAOI,yBAAA;E5Ems1DV;E4E1s1DM;IAOI,yBAAA;E5Ess1DV;E4E7s1DM;IAOI,0BAAA;E5Eys1DV;E4Eht1DM;IAOI,4BAAA;E5E4s1DV;E4Ent1DM;IAOI,kCAAA;E5E+s1DV;E4Ett1DM;IAOI,sCAAA;E5Ekt1DV;E4Ezt1DM;IAOI,oCAAA;E5Eqt1DV;E4E5t1DM;IAOI,kCAAA;E5Ewt1DV;E4E/t1DM;IAOI,yCAAA;E5E2t1DV;E4Elu1DM;IAOI,wCAAA;E5E8t1DV;E4Eru1DM;IAOI,wCAAA;E5Eiu1DV;E4Exu1DM;IAOI,kCAAA;E5Eou1DV;E4E3u1DM;IAOI,gCAAA;E5Euu1DV;E4E9u1DM;IAOI,8BAAA;E5E0u1DV;E4Ejv1DM;IAOI,gCAAA;E5E6u1DV;E4Epv1DM;IAOI,+BAAA;E5Egv1DV;E4Evv1DM;IAOI,oCAAA;E5Emv1DV;E4E1v1DM;IAOI,kCAAA;E5Esv1DV;E4E7v1DM;IAOI,gCAAA;E5Eyv1DV;E4Ehw1DM;IAOI,uCAAA;E5E4v1DV;E4Enw1DM;IAOI,sCAAA;E5E+v1DV;E4Etw1DM;IAOI,iCAAA;E5Ekw1DV;E4Ezw1DM;IAOI,2BAAA;E5Eqw1DV;E4E5w1DM;IAOI,iCAAA;E5Eww1DV;E4E/w1DM;IAOI,+BAAA;E5E2w1DV;E4Elx1DM;IAOI,6BAAA;E5E8w1DV;E4Erx1DM;IAOI,+BAAA;E5Eix1DV;E4Exx1DM;IAOI,8BAAA;E5Eox1DV;E4E3x1DM;IAOI,oBAAA;E5Eux1DV;E4E9x1DM;IAOI,mBAAA;E5E0x1DV;E4Ejy1DM;IAOI,mBAAA;E5E6x1DV;E4Epy1DM;IAOI,mBAAA;E5Egy1DV;E4Evy1DM;IAOI,mBAAA;E5Emy1DV;E4E1y1DM;IAOI,mBAAA;E5Esy1DV;E4E7y1DM;IAOI,mBAAA;E5Eyy1DV;E4Ehz1DM;IAOI,mBAAA;E5E4y1DV;E4Enz1DM;IAOI,oBAAA;E5E+y1DV;E4Etz1DM;IAOI,0BAAA;E5Ekz1DV;E4Ezz1DM;IAOI,yBAAA;E5Eqz1DV;E4E5z1DM;IAOI,uBAAA;E5Ewz1DV;E4E/z1DM;IAOI,yBAAA;E5E2z1DV;E4El01DM;IAOI,uBAAA;E5E8z1DV;E4Er01DM;IAOI,uBAAA;E5Ei01DV;E4Ex01DM;IAOI,0BAAA;IAAA,yBAAA;E5Eq01DV;E4E501DM;IAOI,gCAAA;IAAA,+BAAA;E5Ey01DV;E4Eh11DM;IAOI,+BAAA;IAAA,8BAAA;E5E601DV;E4Ep11DM;IAOI,6BAAA;IAAA,4BAAA;E5Ei11DV;E4Ex11DM;IAOI,+BAAA;IAAA,8BAAA;E5Eq11DV;E4E511DM;IAOI,6BAAA;IAAA,4BAAA;E5Ey11DV;E4Eh21DM;IAOI,6BAAA;IAAA,4BAAA;E5E611DV;E4Ep21DM;IAOI,wBAAA;IAAA,2BAAA;E5Ei21DV;E4Ex21DM;IAOI,8BAAA;IAAA,iCAAA;E5Eq21DV;E4E521DM;IAOI,6BAAA;IAAA,gCAAA;E5Ey21DV;E4Eh31DM;IAOI,2BAAA;IAAA,8BAAA;E5E621DV;E4Ep31DM;IAOI,6BAAA;IAAA,gCAAA;E5Ei31DV;E4Ex31DM;IAOI,2BAAA;IAAA,8BAAA;E5Eq31DV;E4E531DM;IAOI,2BAAA;IAAA,8BAAA;E5Ey31DV;E4Eh41DM;IAOI,wBAAA;E5E431DV;E4En41DM;IAOI,8BAAA;E5E+31DV;E4Et41DM;IAOI,6BAAA;E5Ek41DV;E4Ez41DM;IAOI,2BAAA;E5Eq41DV;E4E541DM;IAOI,6BAAA;E5Ew41DV;E4E/41DM;IAOI,2BAAA;E5E241DV;E4El51DM;IAOI,2BAAA;E5E841DV;E4Er51DM;IAOI,0BAAA;E5Ei51DV;E4Ex51DM;IAOI,gCAAA;E5Eo51DV;E4E351DM;IAOI,+BAAA;E5Eu51DV;E4E951DM;IAOI,6BAAA;E5E051DV;E4Ej61DM;IAOI,+BAAA;E5E651DV;E4Ep61DM;IAOI,6BAAA;E5Eg61DV;E4Ev61DM;IAOI,6BAAA;E5Em61DV;E4E161DM;IAOI,2BAAA;E5Es61DV;E4E761DM;IAOI,iCAAA;E5Ey61DV;E4Eh71DM;IAOI,gCAAA;E5E461DV;E4En71DM;IAOI,8BAAA;E5E+61DV;E4Et71DM;IAOI,gCAAA;E5Ek71DV;E4Ez71DM;IAOI,8BAAA;E5Eq71DV;E4E571DM;IAOI,8BAAA;E5Ew71DV;E4E/71DM;IAOI,yBAAA;E5E271DV;E4El81DM;IAOI,+BAAA;E5E871DV;E4Er81DM;IAOI,8BAAA;E5Ei81DV;E4Ex81DM;IAOI,4BAAA;E5Eo81DV;E4E381DM;IAOI,8BAAA;E5Eu81DV;E4E981DM;IAOI,4BAAA;E5E081DV;E4Ej91DM;IAOI,4BAAA;E5E681DV;E4Ep91DM;IAOI,2BAAA;E5Eg91DV;E4Ev91DM;IAOI,0BAAA;E5Em91DV;E4E191DM;IAOI,wBAAA;E5Es91DV;E4E791DM;IAOI,0BAAA;E5Ey91DV;E4Eh+1DM;IAOI,wBAAA;E5E491DV;E4En+1DM;IAOI,iCAAA;IAAA,gCAAA;E5Eg+1DV;E4Ev+1DM;IAOI,gCAAA;IAAA,+BAAA;E5Eo+1DV;E4E3+1DM;IAOI,8BAAA;IAAA,6BAAA;E5Ew+1DV;E4E/+1DM;IAOI,gCAAA;IAAA,+BAAA;E5E4+1DV;E4En/1DM;IAOI,8BAAA;IAAA,6BAAA;E5Eg/1DV;E4Ev/1DM;IAOI,+BAAA;IAAA,kCAAA;E5Eo/1DV;E4E3/1DM;IAOI,8BAAA;IAAA,iCAAA;E5Ew/1DV;E4E//1DM;IAOI,4BAAA;IAAA,+BAAA;E5E4/1DV;E4Eng2DM;IAOI,8BAAA;IAAA,iCAAA;E5Egg2DV;E4Evg2DM;IAOI,4BAAA;IAAA,+BAAA;E5Eog2DV;E4E3g2DM;IAOI,+BAAA;E5Eug2DV;E4E9g2DM;IAOI,8BAAA;E5E0g2DV;E4Ejh2DM;IAOI,4BAAA;E5E6g2DV;E4Eph2DM;IAOI,8BAAA;E5Egh2DV;E4Evh2DM;IAOI,4BAAA;E5Emh2DV;E4E1h2DM;IAOI,iCAAA;E5Esh2DV;E4E7h2DM;IAOI,gCAAA;E5Eyh2DV;E4Ehi2DM;IAOI,8BAAA;E5E4h2DV;E4Eni2DM;IAOI,gCAAA;E5E+h2DV;E4Eti2DM;IAOI,8BAAA;E5Eki2DV;E4Ezi2DM;IAOI,kCAAA;E5Eqi2DV;E4E5i2DM;IAOI,iCAAA;E5Ewi2DV;E4E/i2DM;IAOI,+BAAA;E5E2i2DV;E4Elj2DM;IAOI,iCAAA;E5E8i2DV;E4Erj2DM;IAOI,+BAAA;E5Eij2DV;E4Exj2DM;IAOI,gCAAA;E5Eoj2DV;E4E3j2DM;IAOI,+BAAA;E5Euj2DV;E4E9j2DM;IAOI,6BAAA;E5E0j2DV;E4Ejk2DM;IAOI,+BAAA;E5E6j2DV;E4Epk2DM;IAOI,6BAAA;E5Egk2DV;E4Evk2DM;IAOI,qBAAA;E5Emk2DV;E4E1k2DM;IAOI,2BAAA;E5Esk2DV;E4E7k2DM;IAOI,0BAAA;E5Eyk2DV;E4Ehl2DM;IAOI,wBAAA;E5E4k2DV;E4Enl2DM;IAOI,0BAAA;E5E+k2DV;E4Etl2DM;IAOI,wBAAA;E5Ekl2DV;E4Ezl2DM;IAOI,2BAAA;IAAA,0BAAA;E5Esl2DV;E4E7l2DM;IAOI,iCAAA;IAAA,gCAAA;E5E0l2DV;E4Ejm2DM;IAOI,gCAAA;IAAA,+BAAA;E5E8l2DV;E4Erm2DM;IAOI,8BAAA;IAAA,6BAAA;E5Ekm2DV;E4Ezm2DM;IAOI,gCAAA;IAAA,+BAAA;E5Esm2DV;E4E7m2DM;IAOI,8BAAA;IAAA,6BAAA;E5E0m2DV;E4Ejn2DM;IAOI,yBAAA;IAAA,4BAAA;E5E8m2DV;E4Ern2DM;IAOI,+BAAA;IAAA,kCAAA;E5Ekn2DV;E4Ezn2DM;IAOI,8BAAA;IAAA,iCAAA;E5Esn2DV;E4E7n2DM;IAOI,4BAAA;IAAA,+BAAA;E5E0n2DV;E4Ejo2DM;IAOI,8BAAA;IAAA,iCAAA;E5E8n2DV;E4Ero2DM;IAOI,4BAAA;IAAA,+BAAA;E5Eko2DV;E4Ezo2DM;IAOI,yBAAA;E5Eqo2DV;E4E5o2DM;IAOI,+BAAA;E5Ewo2DV;E4E/o2DM;IAOI,8BAAA;E5E2o2DV;E4Elp2DM;IAOI,4BAAA;E5E8o2DV;E4Erp2DM;IAOI,8BAAA;E5Eip2DV;E4Exp2DM;IAOI,4BAAA;E5Eop2DV;E4E3p2DM;IAOI,2BAAA;E5Eup2DV;E4E9p2DM;IAOI,iCAAA;E5E0p2DV;E4Ejq2DM;IAOI,gCAAA;E5E6p2DV;E4Epq2DM;IAOI,8BAAA;E5Egq2DV;E4Evq2DM;IAOI,gCAAA;E5Emq2DV;E4E1q2DM;IAOI,8BAAA;E5Esq2DV;E4E7q2DM;IAOI,4BAAA;E5Eyq2DV;E4Ehr2DM;IAOI,kCAAA;E5E4q2DV;E4Enr2DM;IAOI,iCAAA;E5E+q2DV;E4Etr2DM;IAOI,+BAAA;E5Ekr2DV;E4Ezr2DM;IAOI,iCAAA;E5Eqr2DV;E4E5r2DM;IAOI,+BAAA;E5Ewr2DV;E4E/r2DM;IAOI,0BAAA;E5E2r2DV;E4Els2DM;IAOI,gCAAA;E5E8r2DV;E4Ers2DM;IAOI,+BAAA;E5Eis2DV;E4Exs2DM;IAOI,6BAAA;E5Eos2DV;E4E3s2DM;IAOI,+BAAA;E5Eus2DV;E4E9s2DM;IAOI,6BAAA;E5E0s2DV;E4Ejt2DM;IAOI,iBAAA;E5E6s2DV;E4Ept2DM;IAOI,uBAAA;E5Egt2DV;E4Evt2DM;IAOI,sBAAA;E5Emt2DV;E4E1t2DM;IAOI,oBAAA;E5Est2DV;E4E7t2DM;IAOI,sBAAA;E5Eyt2DV;E4Ehu2DM;IAOI,oBAAA;E5E4t2DV;E4Enu2DM;IAOI,2BAAA;E5E+t2DV;E4Etu2DM;IAOI,4BAAA;E5Eku2DV;E4Ezu2DM;IAOI,6BAAA;E5Equ2DV;AACF;AmBhv2DI;EyDGI;IAOI,sBAAA;E5E0u2DV;E4Ejv2DM;IAOI,uBAAA;E5E6u2DV;E4Epv2DM;IAOI,sBAAA;E5Egv2DV;E4Evv2DM;IAOI,0BAAA;E5Emv2DV;E4E1v2DM;IAOI,gCAAA;E5Esv2DV;E4E7v2DM;IAOI,yBAAA;E5Eyv2DV;E4Ehw2DM;IAOI,wBAAA;E5E4v2DV;E4Enw2DM;IAOI,yBAAA;E5E+v2DV;E4Etw2DM;IAOI,6BAAA;E5Ekw2DV;E4Ezw2DM;IAOI,8BAAA;E5Eqw2DV;E4E5w2DM;IAOI,wBAAA;E5Eww2DV;E4E/w2DM;IAOI,+BAAA;E5E2w2DV;E4Elx2DM;IAOI,wBAAA;E5E8w2DV;E4Erx2DM;IAOI,yBAAA;E5Eix2DV;E4Exx2DM;IAOI,8BAAA;E5Eox2DV;E4E3x2DM;IAOI,iCAAA;E5Eux2DV;E4E9x2DM;IAOI,sCAAA;E5E0x2DV;E4Ejy2DM;IAOI,yCAAA;E5E6x2DV;E4Epy2DM;IAOI,uBAAA;E5Egy2DV;E4Evy2DM;IAOI,uBAAA;E5Emy2DV;E4E1y2DM;IAOI,yBAAA;E5Esy2DV;E4E7y2DM;IAOI,yBAAA;E5Eyy2DV;E4Ehz2DM;IAOI,0BAAA;E5E4y2DV;E4Enz2DM;IAOI,4BAAA;E5E+y2DV;E4Etz2DM;IAOI,kCAAA;E5Ekz2DV;E4Ezz2DM;IAOI,sCAAA;E5Eqz2DV;E4E5z2DM;IAOI,oCAAA;E5Ewz2DV;E4E/z2DM;IAOI,kCAAA;E5E2z2DV;E4El02DM;IAOI,yCAAA;E5E8z2DV;E4Er02DM;IAOI,wCAAA;E5Ei02DV;E4Ex02DM;IAOI,wCAAA;E5Eo02DV;E4E302DM;IAOI,kCAAA;E5Eu02DV;E4E902DM;IAOI,gCAAA;E5E002DV;E4Ej12DM;IAOI,8BAAA;E5E602DV;E4Ep12DM;IAOI,gCAAA;E5Eg12DV;E4Ev12DM;IAOI,+BAAA;E5Em12DV;E4E112DM;IAOI,oCAAA;E5Es12DV;E4E712DM;IAOI,kCAAA;E5Ey12DV;E4Eh22DM;IAOI,gCAAA;E5E412DV;E4En22DM;IAOI,uCAAA;E5E+12DV;E4Et22DM;IAOI,sCAAA;E5Ek22DV;E4Ez22DM;IAOI,iCAAA;E5Eq22DV;E4E522DM;IAOI,2BAAA;E5Ew22DV;E4E/22DM;IAOI,iCAAA;E5E222DV;E4El32DM;IAOI,+BAAA;E5E822DV;E4Er32DM;IAOI,6BAAA;E5Ei32DV;E4Ex32DM;IAOI,+BAAA;E5Eo32DV;E4E332DM;IAOI,8BAAA;E5Eu32DV;E4E932DM;IAOI,oBAAA;E5E032DV;E4Ej42DM;IAOI,mBAAA;E5E632DV;E4Ep42DM;IAOI,mBAAA;E5Eg42DV;E4Ev42DM;IAOI,mBAAA;E5Em42DV;E4E142DM;IAOI,mBAAA;E5Es42DV;E4E742DM;IAOI,mBAAA;E5Ey42DV;E4Eh52DM;IAOI,mBAAA;E5E442DV;E4En52DM;IAOI,mBAAA;E5E+42DV;E4Et52DM;IAOI,oBAAA;E5Ek52DV;E4Ez52DM;IAOI,0BAAA;E5Eq52DV;E4E552DM;IAOI,yBAAA;E5Ew52DV;E4E/52DM;IAOI,uBAAA;E5E252DV;E4El62DM;IAOI,yBAAA;E5E852DV;E4Er62DM;IAOI,uBAAA;E5Ei62DV;E4Ex62DM;IAOI,uBAAA;E5Eo62DV;E4E362DM;IAOI,0BAAA;IAAA,yBAAA;E5Ew62DV;E4E/62DM;IAOI,gCAAA;IAAA,+BAAA;E5E462DV;E4En72DM;IAOI,+BAAA;IAAA,8BAAA;E5Eg72DV;E4Ev72DM;IAOI,6BAAA;IAAA,4BAAA;E5Eo72DV;E4E372DM;IAOI,+BAAA;IAAA,8BAAA;E5Ew72DV;E4E/72DM;IAOI,6BAAA;IAAA,4BAAA;E5E472DV;E4En82DM;IAOI,6BAAA;IAAA,4BAAA;E5Eg82DV;E4Ev82DM;IAOI,wBAAA;IAAA,2BAAA;E5Eo82DV;E4E382DM;IAOI,8BAAA;IAAA,iCAAA;E5Ew82DV;E4E/82DM;IAOI,6BAAA;IAAA,gCAAA;E5E482DV;E4En92DM;IAOI,2BAAA;IAAA,8BAAA;E5Eg92DV;E4Ev92DM;IAOI,6BAAA;IAAA,gCAAA;E5Eo92DV;E4E392DM;IAOI,2BAAA;IAAA,8BAAA;E5Ew92DV;E4E/92DM;IAOI,2BAAA;IAAA,8BAAA;E5E492DV;E4En+2DM;IAOI,wBAAA;E5E+92DV;E4Et+2DM;IAOI,8BAAA;E5Ek+2DV;E4Ez+2DM;IAOI,6BAAA;E5Eq+2DV;E4E5+2DM;IAOI,2BAAA;E5Ew+2DV;E4E/+2DM;IAOI,6BAAA;E5E2+2DV;E4El/2DM;IAOI,2BAAA;E5E8+2DV;E4Er/2DM;IAOI,2BAAA;E5Ei/2DV;E4Ex/2DM;IAOI,0BAAA;E5Eo/2DV;E4E3/2DM;IAOI,gCAAA;E5Eu/2DV;E4E9/2DM;IAOI,+BAAA;E5E0/2DV;E4Ejg3DM;IAOI,6BAAA;E5E6/2DV;E4Epg3DM;IAOI,+BAAA;E5Egg3DV;E4Evg3DM;IAOI,6BAAA;E5Emg3DV;E4E1g3DM;IAOI,6BAAA;E5Esg3DV;E4E7g3DM;IAOI,2BAAA;E5Eyg3DV;E4Ehh3DM;IAOI,iCAAA;E5E4g3DV;E4Enh3DM;IAOI,gCAAA;E5E+g3DV;E4Eth3DM;IAOI,8BAAA;E5Ekh3DV;E4Ezh3DM;IAOI,gCAAA;E5Eqh3DV;E4E5h3DM;IAOI,8BAAA;E5Ewh3DV;E4E/h3DM;IAOI,8BAAA;E5E2h3DV;E4Eli3DM;IAOI,yBAAA;E5E8h3DV;E4Eri3DM;IAOI,+BAAA;E5Eii3DV;E4Exi3DM;IAOI,8BAAA;E5Eoi3DV;E4E3i3DM;IAOI,4BAAA;E5Eui3DV;E4E9i3DM;IAOI,8BAAA;E5E0i3DV;E4Ejj3DM;IAOI,4BAAA;E5E6i3DV;E4Epj3DM;IAOI,4BAAA;E5Egj3DV;E4Evj3DM;IAOI,2BAAA;E5Emj3DV;E4E1j3DM;IAOI,0BAAA;E5Esj3DV;E4E7j3DM;IAOI,wBAAA;E5Eyj3DV;E4Ehk3DM;IAOI,0BAAA;E5E4j3DV;E4Enk3DM;IAOI,wBAAA;E5E+j3DV;E4Etk3DM;IAOI,iCAAA;IAAA,gCAAA;E5Emk3DV;E4E1k3DM;IAOI,gCAAA;IAAA,+BAAA;E5Euk3DV;E4E9k3DM;IAOI,8BAAA;IAAA,6BAAA;E5E2k3DV;E4Ell3DM;IAOI,gCAAA;IAAA,+BAAA;E5E+k3DV;E4Etl3DM;IAOI,8BAAA;IAAA,6BAAA;E5Eml3DV;E4E1l3DM;IAOI,+BAAA;IAAA,kCAAA;E5Eul3DV;E4E9l3DM;IAOI,8BAAA;IAAA,iCAAA;E5E2l3DV;E4Elm3DM;IAOI,4BAAA;IAAA,+BAAA;E5E+l3DV;E4Etm3DM;IAOI,8BAAA;IAAA,iCAAA;E5Emm3DV;E4E1m3DM;IAOI,4BAAA;IAAA,+BAAA;E5Eum3DV;E4E9m3DM;IAOI,+BAAA;E5E0m3DV;E4Ejn3DM;IAOI,8BAAA;E5E6m3DV;E4Epn3DM;IAOI,4BAAA;E5Egn3DV;E4Evn3DM;IAOI,8BAAA;E5Emn3DV;E4E1n3DM;IAOI,4BAAA;E5Esn3DV;E4E7n3DM;IAOI,iCAAA;E5Eyn3DV;E4Eho3DM;IAOI,gCAAA;E5E4n3DV;E4Eno3DM;IAOI,8BAAA;E5E+n3DV;E4Eto3DM;IAOI,gCAAA;E5Eko3DV;E4Ezo3DM;IAOI,8BAAA;E5Eqo3DV;E4E5o3DM;IAOI,kCAAA;E5Ewo3DV;E4E/o3DM;IAOI,iCAAA;E5E2o3DV;E4Elp3DM;IAOI,+BAAA;E5E8o3DV;E4Erp3DM;IAOI,iCAAA;E5Eip3DV;E4Exp3DM;IAOI,+BAAA;E5Eop3DV;E4E3p3DM;IAOI,gCAAA;E5Eup3DV;E4E9p3DM;IAOI,+BAAA;E5E0p3DV;E4Ejq3DM;IAOI,6BAAA;E5E6p3DV;E4Epq3DM;IAOI,+BAAA;E5Egq3DV;E4Evq3DM;IAOI,6BAAA;E5Emq3DV;E4E1q3DM;IAOI,qBAAA;E5Esq3DV;E4E7q3DM;IAOI,2BAAA;E5Eyq3DV;E4Ehr3DM;IAOI,0BAAA;E5E4q3DV;E4Enr3DM;IAOI,wBAAA;E5E+q3DV;E4Etr3DM;IAOI,0BAAA;E5Ekr3DV;E4Ezr3DM;IAOI,wBAAA;E5Eqr3DV;E4E5r3DM;IAOI,2BAAA;IAAA,0BAAA;E5Eyr3DV;E4Ehs3DM;IAOI,iCAAA;IAAA,gCAAA;E5E6r3DV;E4Eps3DM;IAOI,gCAAA;IAAA,+BAAA;E5Eis3DV;E4Exs3DM;IAOI,8BAAA;IAAA,6BAAA;E5Eqs3DV;E4E5s3DM;IAOI,gCAAA;IAAA,+BAAA;E5Eys3DV;E4Eht3DM;IAOI,8BAAA;IAAA,6BAAA;E5E6s3DV;E4Ept3DM;IAOI,yBAAA;IAAA,4BAAA;E5Eit3DV;E4Ext3DM;IAOI,+BAAA;IAAA,kCAAA;E5Eqt3DV;E4E5t3DM;IAOI,8BAAA;IAAA,iCAAA;E5Eyt3DV;E4Ehu3DM;IAOI,4BAAA;IAAA,+BAAA;E5E6t3DV;E4Epu3DM;IAOI,8BAAA;IAAA,iCAAA;E5Eiu3DV;E4Exu3DM;IAOI,4BAAA;IAAA,+BAAA;E5Equ3DV;E4E5u3DM;IAOI,yBAAA;E5Ewu3DV;E4E/u3DM;IAOI,+BAAA;E5E2u3DV;E4Elv3DM;IAOI,8BAAA;E5E8u3DV;E4Erv3DM;IAOI,4BAAA;E5Eiv3DV;E4Exv3DM;IAOI,8BAAA;E5Eov3DV;E4E3v3DM;IAOI,4BAAA;E5Euv3DV;E4E9v3DM;IAOI,2BAAA;E5E0v3DV;E4Ejw3DM;IAOI,iCAAA;E5E6v3DV;E4Epw3DM;IAOI,gCAAA;E5Egw3DV;E4Evw3DM;IAOI,8BAAA;E5Emw3DV;E4E1w3DM;IAOI,gCAAA;E5Esw3DV;E4E7w3DM;IAOI,8BAAA;E5Eyw3DV;E4Ehx3DM;IAOI,4BAAA;E5E4w3DV;E4Enx3DM;IAOI,kCAAA;E5E+w3DV;E4Etx3DM;IAOI,iCAAA;E5Ekx3DV;E4Ezx3DM;IAOI,+BAAA;E5Eqx3DV;E4E5x3DM;IAOI,iCAAA;E5Ewx3DV;E4E/x3DM;IAOI,+BAAA;E5E2x3DV;E4Ely3DM;IAOI,0BAAA;E5E8x3DV;E4Ery3DM;IAOI,gCAAA;E5Eiy3DV;E4Exy3DM;IAOI,+BAAA;E5Eoy3DV;E4E3y3DM;IAOI,6BAAA;E5Euy3DV;E4E9y3DM;IAOI,+BAAA;E5E0y3DV;E4Ejz3DM;IAOI,6BAAA;E5E6y3DV;E4Epz3DM;IAOI,iBAAA;E5Egz3DV;E4Evz3DM;IAOI,uBAAA;E5Emz3DV;E4E1z3DM;IAOI,sBAAA;E5Esz3DV;E4E7z3DM;IAOI,oBAAA;E5Eyz3DV;E4Eh03DM;IAOI,sBAAA;E5E4z3DV;E4En03DM;IAOI,oBAAA;E5E+z3DV;E4Et03DM;IAOI,2BAAA;E5Ek03DV;E4Ez03DM;IAOI,4BAAA;E5Eq03DV;E4E503DM;IAOI,6BAAA;E5Ew03DV;AACF;AmBn13DI;EyDGI;IAOI,sBAAA;E5E603DV;E4Ep13DM;IAOI,uBAAA;E5Eg13DV;E4Ev13DM;IAOI,sBAAA;E5Em13DV;E4E113DM;IAOI,0BAAA;E5Es13DV;E4E713DM;IAOI,gCAAA;E5Ey13DV;E4Eh23DM;IAOI,yBAAA;E5E413DV;E4En23DM;IAOI,wBAAA;E5E+13DV;E4Et23DM;IAOI,yBAAA;E5Ek23DV;E4Ez23DM;IAOI,6BAAA;E5Eq23DV;E4E523DM;IAOI,8BAAA;E5Ew23DV;E4E/23DM;IAOI,wBAAA;E5E223DV;E4El33DM;IAOI,+BAAA;E5E823DV;E4Er33DM;IAOI,wBAAA;E5Ei33DV;E4Ex33DM;IAOI,yBAAA;E5Eo33DV;E4E333DM;IAOI,8BAAA;E5Eu33DV;E4E933DM;IAOI,iCAAA;E5E033DV;E4Ej43DM;IAOI,sCAAA;E5E633DV;E4Ep43DM;IAOI,yCAAA;E5Eg43DV;E4Ev43DM;IAOI,uBAAA;E5Em43DV;E4E143DM;IAOI,uBAAA;E5Es43DV;E4E743DM;IAOI,yBAAA;E5Ey43DV;E4Eh53DM;IAOI,yBAAA;E5E443DV;E4En53DM;IAOI,0BAAA;E5E+43DV;E4Et53DM;IAOI,4BAAA;E5Ek53DV;E4Ez53DM;IAOI,kCAAA;E5Eq53DV;E4E553DM;IAOI,sCAAA;E5Ew53DV;E4E/53DM;IAOI,oCAAA;E5E253DV;E4El63DM;IAOI,kCAAA;E5E853DV;E4Er63DM;IAOI,yCAAA;E5Ei63DV;E4Ex63DM;IAOI,wCAAA;E5Eo63DV;E4E363DM;IAOI,wCAAA;E5Eu63DV;E4E963DM;IAOI,kCAAA;E5E063DV;E4Ej73DM;IAOI,gCAAA;E5E663DV;E4Ep73DM;IAOI,8BAAA;E5Eg73DV;E4Ev73DM;IAOI,gCAAA;E5Em73DV;E4E173DM;IAOI,+BAAA;E5Es73DV;E4E773DM;IAOI,oCAAA;E5Ey73DV;E4Eh83DM;IAOI,kCAAA;E5E473DV;E4En83DM;IAOI,gCAAA;E5E+73DV;E4Et83DM;IAOI,uCAAA;E5Ek83DV;E4Ez83DM;IAOI,sCAAA;E5Eq83DV;E4E583DM;IAOI,iCAAA;E5Ew83DV;E4E/83DM;IAOI,2BAAA;E5E283DV;E4El93DM;IAOI,iCAAA;E5E883DV;E4Er93DM;IAOI,+BAAA;E5Ei93DV;E4Ex93DM;IAOI,6BAAA;E5Eo93DV;E4E393DM;IAOI,+BAAA;E5Eu93DV;E4E993DM;IAOI,8BAAA;E5E093DV;E4Ej+3DM;IAOI,oBAAA;E5E693DV;E4Ep+3DM;IAOI,mBAAA;E5Eg+3DV;E4Ev+3DM;IAOI,mBAAA;E5Em+3DV;E4E1+3DM;IAOI,mBAAA;E5Es+3DV;E4E7+3DM;IAOI,mBAAA;E5Ey+3DV;E4Eh/3DM;IAOI,mBAAA;E5E4+3DV;E4En/3DM;IAOI,mBAAA;E5E++3DV;E4Et/3DM;IAOI,mBAAA;E5Ek/3DV;E4Ez/3DM;IAOI,oBAAA;E5Eq/3DV;E4E5/3DM;IAOI,0BAAA;E5Ew/3DV;E4E//3DM;IAOI,yBAAA;E5E2/3DV;E4Elg4DM;IAOI,uBAAA;E5E8/3DV;E4Erg4DM;IAOI,yBAAA;E5Eig4DV;E4Exg4DM;IAOI,uBAAA;E5Eog4DV;E4E3g4DM;IAOI,uBAAA;E5Eug4DV;E4E9g4DM;IAOI,0BAAA;IAAA,yBAAA;E5E2g4DV;E4Elh4DM;IAOI,gCAAA;IAAA,+BAAA;E5E+g4DV;E4Eth4DM;IAOI,+BAAA;IAAA,8BAAA;E5Emh4DV;E4E1h4DM;IAOI,6BAAA;IAAA,4BAAA;E5Euh4DV;E4E9h4DM;IAOI,+BAAA;IAAA,8BAAA;E5E2h4DV;E4Eli4DM;IAOI,6BAAA;IAAA,4BAAA;E5E+h4DV;E4Eti4DM;IAOI,6BAAA;IAAA,4BAAA;E5Emi4DV;E4E1i4DM;IAOI,wBAAA;IAAA,2BAAA;E5Eui4DV;E4E9i4DM;IAOI,8BAAA;IAAA,iCAAA;E5E2i4DV;E4Elj4DM;IAOI,6BAAA;IAAA,gCAAA;E5E+i4DV;E4Etj4DM;IAOI,2BAAA;IAAA,8BAAA;E5Emj4DV;E4E1j4DM;IAOI,6BAAA;IAAA,gCAAA;E5Euj4DV;E4E9j4DM;IAOI,2BAAA;IAAA,8BAAA;E5E2j4DV;E4Elk4DM;IAOI,2BAAA;IAAA,8BAAA;E5E+j4DV;E4Etk4DM;IAOI,wBAAA;E5Ekk4DV;E4Ezk4DM;IAOI,8BAAA;E5Eqk4DV;E4E5k4DM;IAOI,6BAAA;E5Ewk4DV;E4E/k4DM;IAOI,2BAAA;E5E2k4DV;E4Ell4DM;IAOI,6BAAA;E5E8k4DV;E4Erl4DM;IAOI,2BAAA;E5Eil4DV;E4Exl4DM;IAOI,2BAAA;E5Eol4DV;E4E3l4DM;IAOI,0BAAA;E5Eul4DV;E4E9l4DM;IAOI,gCAAA;E5E0l4DV;E4Ejm4DM;IAOI,+BAAA;E5E6l4DV;E4Epm4DM;IAOI,6BAAA;E5Egm4DV;E4Evm4DM;IAOI,+BAAA;E5Emm4DV;E4E1m4DM;IAOI,6BAAA;E5Esm4DV;E4E7m4DM;IAOI,6BAAA;E5Eym4DV;E4Ehn4DM;IAOI,2BAAA;E5E4m4DV;E4Enn4DM;IAOI,iCAAA;E5E+m4DV;E4Etn4DM;IAOI,gCAAA;E5Ekn4DV;E4Ezn4DM;IAOI,8BAAA;E5Eqn4DV;E4E5n4DM;IAOI,gCAAA;E5Ewn4DV;E4E/n4DM;IAOI,8BAAA;E5E2n4DV;E4Elo4DM;IAOI,8BAAA;E5E8n4DV;E4Ero4DM;IAOI,yBAAA;E5Eio4DV;E4Exo4DM;IAOI,+BAAA;E5Eoo4DV;E4E3o4DM;IAOI,8BAAA;E5Euo4DV;E4E9o4DM;IAOI,4BAAA;E5E0o4DV;E4Ejp4DM;IAOI,8BAAA;E5E6o4DV;E4Epp4DM;IAOI,4BAAA;E5Egp4DV;E4Evp4DM;IAOI,4BAAA;E5Emp4DV;E4E1p4DM;IAOI,2BAAA;E5Esp4DV;E4E7p4DM;IAOI,0BAAA;E5Eyp4DV;E4Ehq4DM;IAOI,wBAAA;E5E4p4DV;E4Enq4DM;IAOI,0BAAA;E5E+p4DV;E4Etq4DM;IAOI,wBAAA;E5Ekq4DV;E4Ezq4DM;IAOI,iCAAA;IAAA,gCAAA;E5Esq4DV;E4E7q4DM;IAOI,gCAAA;IAAA,+BAAA;E5E0q4DV;E4Ejr4DM;IAOI,8BAAA;IAAA,6BAAA;E5E8q4DV;E4Err4DM;IAOI,gCAAA;IAAA,+BAAA;E5Ekr4DV;E4Ezr4DM;IAOI,8BAAA;IAAA,6BAAA;E5Esr4DV;E4E7r4DM;IAOI,+BAAA;IAAA,kCAAA;E5E0r4DV;E4Ejs4DM;IAOI,8BAAA;IAAA,iCAAA;E5E8r4DV;E4Ers4DM;IAOI,4BAAA;IAAA,+BAAA;E5Eks4DV;E4Ezs4DM;IAOI,8BAAA;IAAA,iCAAA;E5Ess4DV;E4E7s4DM;IAOI,4BAAA;IAAA,+BAAA;E5E0s4DV;E4Ejt4DM;IAOI,+BAAA;E5E6s4DV;E4Ept4DM;IAOI,8BAAA;E5Egt4DV;E4Evt4DM;IAOI,4BAAA;E5Emt4DV;E4E1t4DM;IAOI,8BAAA;E5Est4DV;E4E7t4DM;IAOI,4BAAA;E5Eyt4DV;E4Ehu4DM;IAOI,iCAAA;E5E4t4DV;E4Enu4DM;IAOI,gCAAA;E5E+t4DV;E4Etu4DM;IAOI,8BAAA;E5Eku4DV;E4Ezu4DM;IAOI,gCAAA;E5Equ4DV;E4E5u4DM;IAOI,8BAAA;E5Ewu4DV;E4E/u4DM;IAOI,kCAAA;E5E2u4DV;E4Elv4DM;IAOI,iCAAA;E5E8u4DV;E4Erv4DM;IAOI,+BAAA;E5Eiv4DV;E4Exv4DM;IAOI,iCAAA;E5Eov4DV;E4E3v4DM;IAOI,+BAAA;E5Euv4DV;E4E9v4DM;IAOI,gCAAA;E5E0v4DV;E4Ejw4DM;IAOI,+BAAA;E5E6v4DV;E4Epw4DM;IAOI,6BAAA;E5Egw4DV;E4Evw4DM;IAOI,+BAAA;E5Emw4DV;E4E1w4DM;IAOI,6BAAA;E5Esw4DV;E4E7w4DM;IAOI,qBAAA;E5Eyw4DV;E4Ehx4DM;IAOI,2BAAA;E5E4w4DV;E4Enx4DM;IAOI,0BAAA;E5E+w4DV;E4Etx4DM;IAOI,wBAAA;E5Ekx4DV;E4Ezx4DM;IAOI,0BAAA;E5Eqx4DV;E4E5x4DM;IAOI,wBAAA;E5Ewx4DV;E4E/x4DM;IAOI,2BAAA;IAAA,0BAAA;E5E4x4DV;E4Eny4DM;IAOI,iCAAA;IAAA,gCAAA;E5Egy4DV;E4Evy4DM;IAOI,gCAAA;IAAA,+BAAA;E5Eoy4DV;E4E3y4DM;IAOI,8BAAA;IAAA,6BAAA;E5Ewy4DV;E4E/y4DM;IAOI,gCAAA;IAAA,+BAAA;E5E4y4DV;E4Enz4DM;IAOI,8BAAA;IAAA,6BAAA;E5Egz4DV;E4Evz4DM;IAOI,yBAAA;IAAA,4BAAA;E5Eoz4DV;E4E3z4DM;IAOI,+BAAA;IAAA,kCAAA;E5Ewz4DV;E4E/z4DM;IAOI,8BAAA;IAAA,iCAAA;E5E4z4DV;E4En04DM;IAOI,4BAAA;IAAA,+BAAA;E5Eg04DV;E4Ev04DM;IAOI,8BAAA;IAAA,iCAAA;E5Eo04DV;E4E304DM;IAOI,4BAAA;IAAA,+BAAA;E5Ew04DV;E4E/04DM;IAOI,yBAAA;E5E204DV;E4El14DM;IAOI,+BAAA;E5E804DV;E4Er14DM;IAOI,8BAAA;E5Ei14DV;E4Ex14DM;IAOI,4BAAA;E5Eo14DV;E4E314DM;IAOI,8BAAA;E5Eu14DV;E4E914DM;IAOI,4BAAA;E5E014DV;E4Ej24DM;IAOI,2BAAA;E5E614DV;E4Ep24DM;IAOI,iCAAA;E5Eg24DV;E4Ev24DM;IAOI,gCAAA;E5Em24DV;E4E124DM;IAOI,8BAAA;E5Es24DV;E4E724DM;IAOI,gCAAA;E5Ey24DV;E4Eh34DM;IAOI,8BAAA;E5E424DV;E4En34DM;IAOI,4BAAA;E5E+24DV;E4Et34DM;IAOI,kCAAA;E5Ek34DV;E4Ez34DM;IAOI,iCAAA;E5Eq34DV;E4E534DM;IAOI,+BAAA;E5Ew34DV;E4E/34DM;IAOI,iCAAA;E5E234DV;E4El44DM;IAOI,+BAAA;E5E834DV;E4Er44DM;IAOI,0BAAA;E5Ei44DV;E4Ex44DM;IAOI,gCAAA;E5Eo44DV;E4E344DM;IAOI,+BAAA;E5Eu44DV;E4E944DM;IAOI,6BAAA;E5E044DV;E4Ej54DM;IAOI,+BAAA;E5E644DV;E4Ep54DM;IAOI,6BAAA;E5Eg54DV;E4Ev54DM;IAOI,iBAAA;E5Em54DV;E4E154DM;IAOI,uBAAA;E5Es54DV;E4E754DM;IAOI,sBAAA;E5Ey54DV;E4Eh64DM;IAOI,oBAAA;E5E454DV;E4En64DM;IAOI,sBAAA;E5E+54DV;E4Et64DM;IAOI,oBAAA;E5Ek64DV;E4Ez64DM;IAOI,2BAAA;E5Eq64DV;E4E564DM;IAOI,4BAAA;E5Ew64DV;E4E/64DM;IAOI,6BAAA;E5E264DV;AACF;AmBt74DI;EyDGI;IAOI,sBAAA;E5Eg74DV;E4Ev74DM;IAOI,uBAAA;E5Em74DV;E4E174DM;IAOI,sBAAA;E5Es74DV;E4E774DM;IAOI,0BAAA;E5Ey74DV;E4Eh84DM;IAOI,gCAAA;E5E474DV;E4En84DM;IAOI,yBAAA;E5E+74DV;E4Et84DM;IAOI,wBAAA;E5Ek84DV;E4Ez84DM;IAOI,yBAAA;E5Eq84DV;E4E584DM;IAOI,6BAAA;E5Ew84DV;E4E/84DM;IAOI,8BAAA;E5E284DV;E4El94DM;IAOI,wBAAA;E5E884DV;E4Er94DM;IAOI,+BAAA;E5Ei94DV;E4Ex94DM;IAOI,wBAAA;E5Eo94DV;E4E394DM;IAOI,yBAAA;E5Eu94DV;E4E994DM;IAOI,8BAAA;E5E094DV;E4Ej+4DM;IAOI,iCAAA;E5E694DV;E4Ep+4DM;IAOI,sCAAA;E5Eg+4DV;E4Ev+4DM;IAOI,yCAAA;E5Em+4DV;E4E1+4DM;IAOI,uBAAA;E5Es+4DV;E4E7+4DM;IAOI,uBAAA;E5Ey+4DV;E4Eh/4DM;IAOI,yBAAA;E5E4+4DV;E4En/4DM;IAOI,yBAAA;E5E++4DV;E4Et/4DM;IAOI,0BAAA;E5Ek/4DV;E4Ez/4DM;IAOI,4BAAA;E5Eq/4DV;E4E5/4DM;IAOI,kCAAA;E5Ew/4DV;E4E//4DM;IAOI,sCAAA;E5E2/4DV;E4Elg5DM;IAOI,oCAAA;E5E8/4DV;E4Erg5DM;IAOI,kCAAA;E5Eig5DV;E4Exg5DM;IAOI,yCAAA;E5Eog5DV;E4E3g5DM;IAOI,wCAAA;E5Eug5DV;E4E9g5DM;IAOI,wCAAA;E5E0g5DV;E4Ejh5DM;IAOI,kCAAA;E5E6g5DV;E4Eph5DM;IAOI,gCAAA;E5Egh5DV;E4Evh5DM;IAOI,8BAAA;E5Emh5DV;E4E1h5DM;IAOI,gCAAA;E5Esh5DV;E4E7h5DM;IAOI,+BAAA;E5Eyh5DV;E4Ehi5DM;IAOI,oCAAA;E5E4h5DV;E4Eni5DM;IAOI,kCAAA;E5E+h5DV;E4Eti5DM;IAOI,gCAAA;E5Eki5DV;E4Ezi5DM;IAOI,uCAAA;E5Eqi5DV;E4E5i5DM;IAOI,sCAAA;E5Ewi5DV;E4E/i5DM;IAOI,iCAAA;E5E2i5DV;E4Elj5DM;IAOI,2BAAA;E5E8i5DV;E4Erj5DM;IAOI,iCAAA;E5Eij5DV;E4Exj5DM;IAOI,+BAAA;E5Eoj5DV;E4E3j5DM;IAOI,6BAAA;E5Euj5DV;E4E9j5DM;IAOI,+BAAA;E5E0j5DV;E4Ejk5DM;IAOI,8BAAA;E5E6j5DV;E4Epk5DM;IAOI,oBAAA;E5Egk5DV;E4Evk5DM;IAOI,mBAAA;E5Emk5DV;E4E1k5DM;IAOI,mBAAA;E5Esk5DV;E4E7k5DM;IAOI,mBAAA;E5Eyk5DV;E4Ehl5DM;IAOI,mBAAA;E5E4k5DV;E4Enl5DM;IAOI,mBAAA;E5E+k5DV;E4Etl5DM;IAOI,mBAAA;E5Ekl5DV;E4Ezl5DM;IAOI,mBAAA;E5Eql5DV;E4E5l5DM;IAOI,oBAAA;E5Ewl5DV;E4E/l5DM;IAOI,0BAAA;E5E2l5DV;E4Elm5DM;IAOI,yBAAA;E5E8l5DV;E4Erm5DM;IAOI,uBAAA;E5Eim5DV;E4Exm5DM;IAOI,yBAAA;E5Eom5DV;E4E3m5DM;IAOI,uBAAA;E5Eum5DV;E4E9m5DM;IAOI,uBAAA;E5E0m5DV;E4Ejn5DM;IAOI,0BAAA;IAAA,yBAAA;E5E8m5DV;E4Ern5DM;IAOI,gCAAA;IAAA,+BAAA;E5Ekn5DV;E4Ezn5DM;IAOI,+BAAA;IAAA,8BAAA;E5Esn5DV;E4E7n5DM;IAOI,6BAAA;IAAA,4BAAA;E5E0n5DV;E4Ejo5DM;IAOI,+BAAA;IAAA,8BAAA;E5E8n5DV;E4Ero5DM;IAOI,6BAAA;IAAA,4BAAA;E5Eko5DV;E4Ezo5DM;IAOI,6BAAA;IAAA,4BAAA;E5Eso5DV;E4E7o5DM;IAOI,wBAAA;IAAA,2BAAA;E5E0o5DV;E4Ejp5DM;IAOI,8BAAA;IAAA,iCAAA;E5E8o5DV;E4Erp5DM;IAOI,6BAAA;IAAA,gCAAA;E5Ekp5DV;E4Ezp5DM;IAOI,2BAAA;IAAA,8BAAA;E5Esp5DV;E4E7p5DM;IAOI,6BAAA;IAAA,gCAAA;E5E0p5DV;E4Ejq5DM;IAOI,2BAAA;IAAA,8BAAA;E5E8p5DV;E4Erq5DM;IAOI,2BAAA;IAAA,8BAAA;E5Ekq5DV;E4Ezq5DM;IAOI,wBAAA;E5Eqq5DV;E4E5q5DM;IAOI,8BAAA;E5Ewq5DV;E4E/q5DM;IAOI,6BAAA;E5E2q5DV;E4Elr5DM;IAOI,2BAAA;E5E8q5DV;E4Err5DM;IAOI,6BAAA;E5Eir5DV;E4Exr5DM;IAOI,2BAAA;E5Eor5DV;E4E3r5DM;IAOI,2BAAA;E5Eur5DV;E4E9r5DM;IAOI,0BAAA;E5E0r5DV;E4Ejs5DM;IAOI,gCAAA;E5E6r5DV;E4Eps5DM;IAOI,+BAAA;E5Egs5DV;E4Evs5DM;IAOI,6BAAA;E5Ems5DV;E4E1s5DM;IAOI,+BAAA;E5Ess5DV;E4E7s5DM;IAOI,6BAAA;E5Eys5DV;E4Eht5DM;IAOI,6BAAA;E5E4s5DV;E4Ent5DM;IAOI,2BAAA;E5E+s5DV;E4Ett5DM;IAOI,iCAAA;E5Ekt5DV;E4Ezt5DM;IAOI,gCAAA;E5Eqt5DV;E4E5t5DM;IAOI,8BAAA;E5Ewt5DV;E4E/t5DM;IAOI,gCAAA;E5E2t5DV;E4Elu5DM;IAOI,8BAAA;E5E8t5DV;E4Eru5DM;IAOI,8BAAA;E5Eiu5DV;E4Exu5DM;IAOI,yBAAA;E5Eou5DV;E4E3u5DM;IAOI,+BAAA;E5Euu5DV;E4E9u5DM;IAOI,8BAAA;E5E0u5DV;E4Ejv5DM;IAOI,4BAAA;E5E6u5DV;E4Epv5DM;IAOI,8BAAA;E5Egv5DV;E4Evv5DM;IAOI,4BAAA;E5Emv5DV;E4E1v5DM;IAOI,4BAAA;E5Esv5DV;E4E7v5DM;IAOI,2BAAA;E5Eyv5DV;E4Ehw5DM;IAOI,0BAAA;E5E4v5DV;E4Enw5DM;IAOI,wBAAA;E5E+v5DV;E4Etw5DM;IAOI,0BAAA;E5Ekw5DV;E4Ezw5DM;IAOI,wBAAA;E5Eqw5DV;E4E5w5DM;IAOI,iCAAA;IAAA,gCAAA;E5Eyw5DV;E4Ehx5DM;IAOI,gCAAA;IAAA,+BAAA;E5E6w5DV;E4Epx5DM;IAOI,8BAAA;IAAA,6BAAA;E5Eix5DV;E4Exx5DM;IAOI,gCAAA;IAAA,+BAAA;E5Eqx5DV;E4E5x5DM;IAOI,8BAAA;IAAA,6BAAA;E5Eyx5DV;E4Ehy5DM;IAOI,+BAAA;IAAA,kCAAA;E5E6x5DV;E4Epy5DM;IAOI,8BAAA;IAAA,iCAAA;E5Eiy5DV;E4Exy5DM;IAOI,4BAAA;IAAA,+BAAA;E5Eqy5DV;E4E5y5DM;IAOI,8BAAA;IAAA,iCAAA;E5Eyy5DV;E4Ehz5DM;IAOI,4BAAA;IAAA,+BAAA;E5E6y5DV;E4Epz5DM;IAOI,+BAAA;E5Egz5DV;E4Evz5DM;IAOI,8BAAA;E5Emz5DV;E4E1z5DM;IAOI,4BAAA;E5Esz5DV;E4E7z5DM;IAOI,8BAAA;E5Eyz5DV;E4Eh05DM;IAOI,4BAAA;E5E4z5DV;E4En05DM;IAOI,iCAAA;E5E+z5DV;E4Et05DM;IAOI,gCAAA;E5Ek05DV;E4Ez05DM;IAOI,8BAAA;E5Eq05DV;E4E505DM;IAOI,gCAAA;E5Ew05DV;E4E/05DM;IAOI,8BAAA;E5E205DV;E4El15DM;IAOI,kCAAA;E5E805DV;E4Er15DM;IAOI,iCAAA;E5Ei15DV;E4Ex15DM;IAOI,+BAAA;E5Eo15DV;E4E315DM;IAOI,iCAAA;E5Eu15DV;E4E915DM;IAOI,+BAAA;E5E015DV;E4Ej25DM;IAOI,gCAAA;E5E615DV;E4Ep25DM;IAOI,+BAAA;E5Eg25DV;E4Ev25DM;IAOI,6BAAA;E5Em25DV;E4E125DM;IAOI,+BAAA;E5Es25DV;E4E725DM;IAOI,6BAAA;E5Ey25DV;E4Eh35DM;IAOI,qBAAA;E5E425DV;E4En35DM;IAOI,2BAAA;E5E+25DV;E4Et35DM;IAOI,0BAAA;E5Ek35DV;E4Ez35DM;IAOI,wBAAA;E5Eq35DV;E4E535DM;IAOI,0BAAA;E5Ew35DV;E4E/35DM;IAOI,wBAAA;E5E235DV;E4El45DM;IAOI,2BAAA;IAAA,0BAAA;E5E+35DV;E4Et45DM;IAOI,iCAAA;IAAA,gCAAA;E5Em45DV;E4E145DM;IAOI,gCAAA;IAAA,+BAAA;E5Eu45DV;E4E945DM;IAOI,8BAAA;IAAA,6BAAA;E5E245DV;E4El55DM;IAOI,gCAAA;IAAA,+BAAA;E5E+45DV;E4Et55DM;IAOI,8BAAA;IAAA,6BAAA;E5Em55DV;E4E155DM;IAOI,yBAAA;IAAA,4BAAA;E5Eu55DV;E4E955DM;IAOI,+BAAA;IAAA,kCAAA;E5E255DV;E4El65DM;IAOI,8BAAA;IAAA,iCAAA;E5E+55DV;E4Et65DM;IAOI,4BAAA;IAAA,+BAAA;E5Em65DV;E4E165DM;IAOI,8BAAA;IAAA,iCAAA;E5Eu65DV;E4E965DM;IAOI,4BAAA;IAAA,+BAAA;E5E265DV;E4El75DM;IAOI,yBAAA;E5E865DV;E4Er75DM;IAOI,+BAAA;E5Ei75DV;E4Ex75DM;IAOI,8BAAA;E5Eo75DV;E4E375DM;IAOI,4BAAA;E5Eu75DV;E4E975DM;IAOI,8BAAA;E5E075DV;E4Ej85DM;IAOI,4BAAA;E5E675DV;E4Ep85DM;IAOI,2BAAA;E5Eg85DV;E4Ev85DM;IAOI,iCAAA;E5Em85DV;E4E185DM;IAOI,gCAAA;E5Es85DV;E4E785DM;IAOI,8BAAA;E5Ey85DV;E4Eh95DM;IAOI,gCAAA;E5E485DV;E4En95DM;IAOI,8BAAA;E5E+85DV;E4Et95DM;IAOI,4BAAA;E5Ek95DV;E4Ez95DM;IAOI,kCAAA;E5Eq95DV;E4E595DM;IAOI,iCAAA;E5Ew95DV;E4E/95DM;IAOI,+BAAA;E5E295DV;E4El+5DM;IAOI,iCAAA;E5E895DV;E4Er+5DM;IAOI,+BAAA;E5Ei+5DV;E4Ex+5DM;IAOI,0BAAA;E5Eo+5DV;E4E3+5DM;IAOI,gCAAA;E5Eu+5DV;E4E9+5DM;IAOI,+BAAA;E5E0+5DV;E4Ej/5DM;IAOI,6BAAA;E5E6+5DV;E4Ep/5DM;IAOI,+BAAA;E5Eg/5DV;E4Ev/5DM;IAOI,6BAAA;E5Em/5DV;E4E1/5DM;IAOI,iBAAA;E5Es/5DV;E4E7/5DM;IAOI,uBAAA;E5Ey/5DV;E4Ehg6DM;IAOI,sBAAA;E5E4/5DV;E4Eng6DM;IAOI,oBAAA;E5E+/5DV;E4Etg6DM;IAOI,sBAAA;E5Ekg6DV;E4Ezg6DM;IAOI,oBAAA;E5Eqg6DV;E4E5g6DM;IAOI,2BAAA;E5Ewg6DV;E4E/g6DM;IAOI,4BAAA;E5E2g6DV;E4Elh6DM;IAOI,6BAAA;E5E8g6DV;AACF;A6Erk6DA;ED+CQ;IAOI,gCAAA;E5Emh6DV;E4E1h6DM;IAOI,8BAAA;E5Esh6DV;E4E7h6DM;IAOI,iCAAA;E5Eyh6DV;AACF;A6E7j6DA;ED4BQ;IAOI,0BAAA;E5E8h6DV;E4Eri6DM;IAOI,gCAAA;E5Eii6DV;E4Exi6DM;IAOI,yBAAA;E5Eoi6DV;E4E3i6DM;IAOI,wBAAA;E5Eui6DV;E4E9i6DM;IAOI,yBAAA;E5E0i6DV;E4Ejj6DM;IAOI,6BAAA;E5E6i6DV;E4Epj6DM;IAOI,8BAAA;E5Egj6DV;E4Evj6DM;IAOI,wBAAA;E5Emj6DV;E4E1j6DM;IAOI,+BAAA;E5Esj6DV;E4E7j6DM;IAOI,wBAAA;E5Eyj6DV;AACF;A8Eno6DA;;;;;;;CAAA;ACUA;EACI,wBAAA;EACA,6CAAA;EACA,sFAAA;EACA,gBAAA;A/Emo6DJ;A+Eho6DA;EACI,wBAAA;EACA,6CAAA;EACA,wFAAA;EACA,gBAAA;A/Eko6DJ;A+Eho6DA;EACI,wBAAA;EACA,6CAAA;EACA,uFAAA;EACA,gBAAA;A/Eko6DJ;A+Eho6DA;EACI,wBAAA;EACA,6CAAA;EACA,yFAAA;EACA,gBAAA;A/Eko6DJ;A+Eho6DA;EACI,wBAAA;EAEA,qFAAA;EACA,gBAAA;A/Eio6DJ;AgFtq6DA;EAGE,2BAAA;EACA,kFAAA;EACA,4CAAA;EACA,6CAAA;EACA,oFAAA;EACA,gDAAA;EACA,iDAAA;EACA,uCAAA;EAGA,mCAAA;EACA,2CAAA;EACA,8CAAA;EACA,+CAAA;EACA,+CAAA;EACA,kDAAA;EACA,mDAAA;EACA,wFAAA;EAIA,oBAAA;EACA,+BAAA;EAEA,4BAAA;EACA,oCAAA;EAGA,8BAAA;EAEA,4BAAA;EACA,iCAAA;EAGA,oBAAA;EACA,0BAAA;EAGA,oBAAA;EACA,2EAAA;EACA,sCAAA;EAGA,qCAAA;EACA,4BAAA;EAEA,qEAAA;EACA,4EAAA;EACA,4EAAA;EACA,gDAAA;EACA,kEAAA;EAGA,4CAAA;EAGA,2BAAA;EAIA,wBAAA;EACA,8BAAA;EAGA,0BAAA;EAGA,yBAAA;EACA,0BAAA;EACA,0BAAA;AhF2o6DF;AgFxo6DE;EACE,qCAAA;AhF0o6DJ;AgFto6DE;EACE,qBAAA;EACA,gCAAA;EACA,mCAAA;EACA,qDAAA;AhFwo6DJ;AgF5t6DA;EAwFE,iCAAA;EAGA,mBAAA;EACA,0BAAA;EACA,6CAAA;EACA,+BAAA;EAGA,kCAAA;EAGA,+CAAA;AhFio6DF;;AiFpu6DA;EA2BI,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIF,qBAAA;EACA,4BAAA;EACA,wBAAA;EACA,kCAAA;EAGA,2BAAA;EACA,gFAAA;EACA,4CAAA;EACA,6CAAA;EACA,sFAAA;EACA,gDAAA;EACA,iDAAA;EACA,uCAAA;EAGA,mCAAA;EACA,2CAAA;EACA,8CAAA;EACA,+CAAA;EACA,yFAAA;EACA,kDAAA;EACA,mDAAA;EACA,sFAAA;EAGA,uBAAA;EACA,+BAAA;EAEA,4BAAA;EACA,oCAAA;EAGA,8BAAA;EAEA,6DAAA;EACA,iCAAA;EAGA,uBAAA;EACA,0BAAA;EAGA,yDAAA;EACA,+BAAA;EACA,mCAAA;EAGA,qCAAA;EACA,4BAAA;EAGA,qEAAA;EACA,oCAAA;EACA,4EAAA;EACA,gDAAA;EACA,kEAAA;EAGA,oEAAA;EAGA,2BAAA;EAGA,mBAAA;EACA,0BAAA;EACA,kBAAA;EACA,4BAAA;EAGA,wBAAA;EACA,8BAAA;EAGA,4DAAA;AjFsr6DF;AiFnr6DE;EACE,2DAAA;EACA,iCAAA;EACA,wDAAA;EACA,oEAAA;EACA,+BAAA;EACA,wCAAA;EACA,qEAAA;AjFqr6DJ;AiFjr6DE;EACE,0DAAA;EACA,gCAAA;EACA,mEAAA;EACA,wDAAA;AjFmr6DJ;AiF/q6DE;EACE,8BAAA;EACA,4BAAA;EACA,sCAAA;AjFir6DJ;AiF9q6DE;EACE,8BAAA;EACA,wBAAA;EACA,sCAAA;AjFgr6DJ;AiF7q6DE;EACE,oCAAA;EACA,kDAAA;EACA,4DAAA;AjF+q6DJ;AiF5q6DE;EACE,+BAAA;EACA,2BAAA;EACA,qCAAA;AjF8q6DJ;AiF3q6DE;EACE,8BAAA;EACA,wBAAA;EACA,qCAAA;AjF6q6DJ;AiF1q6DE;EACE,qCAAA;EACA,iDAAA;EACA,2DAAA;AjF4q6DJ;AiFxq6DE;EACE,qBAAA;EACA,yBAAA;AjF0q6DJ;AiFj16DA;EA0KE,4BAAA;EACA,yBAAA;EACA,2BAAA;AjF0q6DF;AiFvq6DE;EACE,sBAAA;AjFyq6DJ;AiFrq6DE;EACE,wCAAA;EACA,qCAAA;AjFuq6DJ;AiFnq6DE;EACE,wCAAA;EACA,0BAAA;EACA,8BAAA;AjFqq6DJ;AiFjq6DE;;;;;;EAME,0BAAA;AjFmq6DJ;AiF9p6DE;EACE,yBAAA;AjFgq6DJ;AiF5p6DE;EACE,gDAAA;EACA,+CAAA;EACA,8CAAA;AjF8p6DJ;AiF3p6DE;EACE,sBAAA;EACA,wCAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;AjF6p6DJ;AiFzp6DE;EACE,qCAAA;EACA,4CAAA;EACA,iDAAA;EACA,yDAAA;AjF2p6DJ;AiF/36DA;EAwOE,mEAAA;AjF0p6DF;AiFvp6DE;EACE,yDAAA;AjFyp6DJ;AiFrp6DE;EACE,iEAAA;EACA,iEAAA;AjFup6DJ;AiFz46DA;EAsPE,sDAAA;EACA,0BAAA;EACA,8DAAA;EACA,+BAAA;EAGA,kCAAA;EAGA,8DAAA;AjFkp6DF;;AiF9o6DA;EACE,+FAAA;EACA,qDAAA;EACA,8CAAA;AjFip6DF;;AiF9o6DA;EACE,8FAAA;EACA,uDAAA;EACA,gDAAA;AjFip6DF;;AiF9o6DA;EACE,4FAAA;EACA,qDAAA;EACA,8CAAA;AjFip6DF;;AiF9o6DA;EACE,qFAAA;EACA,qDAAA;EACA,8CAAA;AjFip6DF;;AkFx66DA;EACI,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,aAAA;EACA,qCvEqF8C;EuEpF9C,6BAAA;AlF266DJ;AkFz66DI;EACI,4CvE0nBsB;AXiz5D9B;AkFx66DI;EAbJ;IAcQ,WvEC0C;EX066DhD;AACF;;AkFx66DA;EACI,aAAA;EAEA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,YvEkE+C;EuEjE/C,oCAAA;AlF266DJ;AkFv66DI;EAXJ;IAYQ,8CAAA;ElF066DN;AACF;AkFv66DQ;EACI,oBAAA;AlFy66DZ;AkFr66DI;EACI,YAAA;EACA,WAAA;AlFu66DR;AkFr66DQ;EAJJ;IAKQ,YAAA;IACA,WAAA;ElFw66DV;AACF;AkFr66DI;EACI,yBAAA;AlFu66DR;;AkFn66DA,WAAA;AAEA;EACI,yBAAA;AlFq66DJ;AkFn66DI;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,4CvEmC0C;EuElC1C,gBAAA;AlFq66DR;AkFl66DI;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;EACA,MAAA;EACA,cvEiFG;AXm16DX;AkFj66DI;EACI,UAAA;EACA,qBAAA;AlFm66DR;AkFh66DI;EA3BJ;IA4BQ,8BAAA;ElFm66DN;AACF;;AkF756DI;EACI,kBAAA;EACA,gBAAA;AlFg66DR;AkF956DQ;EACI,2BvE4pCwB;AXow4DpC;;AkF356DA;EAEQ;IACI,aAAA;ElF656DV;EkF156DM;IACI,qBAAA;ElF456DV;AACF;AkFx56DA;EACI,YvExB+C;EuEyB/C,aAAA;EACA,mBAAA;AlF056DJ;;AkFv56DA;EACI,YAAA;EACA,WAAA;AlF056DJ;;AkFv56DA;EACI,QAAA;EACA,mBAAA;AlF056DJ;;AkFv56DA;EACI,WAAA;EACA,mBAAA;AlF056DJ;;AkFt56DI;EADJ;IAEQ,0CvEhCS;EX076Df;AACF;AkFx56DI;EACI,mBAAA;AlF056DR;;AkFt56DA;EACI,qBAAA;EACA,oBAAA;EACA,kBAAA;AlFy56DJ;AkFv56DI;EACI,kBAAA;EACA,UAAA;AlFy56DR;;AkFp56DA;EACI,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,oCAAA;AlFu56DJ;AkFr56DI;EACI,YAAA;AlFu56DR;AkFp56DI;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AlFs56DR;AkFn56DI;EACI,kDAAA;AlFq56DR;;AkF946DQ;EACI,gBAAA;AlFi56DZ;;AkFz46DQ;EACI,gBAAA;AlF446DZ;;AkFt46DI;EACI,0CvE1GyC;EuE2GzC,sCvE3GyC;AXo/6DjD;AkFr46DQ;EACI,uCvE/GqC;AXs/6DjD;AkFr46DY;EAEI,2CAAA;EACA,WvE9DL;AXo86DX;AkFh46DQ;EADJ;IAEQ,+CvElHU;EXq/6DpB;AACF;AkFj46DQ;EACI,2CAAA;AlFm46DZ;AkFh46DQ;EACI,kDAAA;AlFk46DZ;AkF936DI;EACI,aAAA;AlFg46DR;AkF736DI;EACI,qBAAA;AlF+36DR;AkF336DQ;EACI,2CAAA;EACA,WvE5FD;AXy96DX;AkF136DQ;;EAEI,+BAAA;AlF436DZ;AkFv36DQ;EACI,yBvEpGD;AX696DX;;AkFp36DA;EAEQ;IACI,gBAAA;ElFs36DV;EkFp36DU;IACI,WAAA;ElFs36Dd;AACF;AkFj36DA;EACI;IACI,oBAAA;ElFm36DN;AACF;AkF926DQ;EACI;IACI,kBAAA;IACA,4CvE2Wc;EXqg6D5B;EkF726DU;IACI,qBAAA;IACA,eAAA;ElF+26Dd;EkF526DU;IACI,kBAAA;ElF826Dd;EkF326DU;IACI,cAAA;IACA,cAAA;ElF626Dd;EkFx26Dc;IACI,wCAAA;IACA,kBAAA;IACA,WAAA;IACA,gBAAA;ElF026DlB;EkFx26DkB;IACI,aAAA;ElF026DtB;EkFv26DkB;IACI,cAAA;ElFy26DtB;AACF;AkFl26DgB;EACI,aAAA;AlFo26DpB;AkFj26DgB;EACI,cAAA;AlFm26DpB;;AkF316DI;EACI,OAAA;EACA,2CAAA;AlF816DR;AkF516DQ;EACI;IACI,gBAAA;ElF816Dd;AACF;AkFz16DQ;EADJ;IAEQ,gBvE/PuC;EX2l7DjD;AACF;AkF/16DI;EAKI,mEAAA;AlF616DR;AkFx16DY;EADJ;IAEQ,+BAAA;ElF216Dd;AACF;;AkFj16DY;EADJ;IAEQ,UvE7VkC;EXkr7DhD;AACF;AkF/06DY;EADJ;IAEQ,WvEtWkC;EXwr7DhD;AACF;;AkF306DQ;EADJ;IAEQ,wBAAA;ElF+06DV;AACF;AkF506DI;EACI,aAAA;AlF806DR;;AmFlt7DA;EACI,oBAAA;EACA,0CAAA;EACA,4CxEiG8C;EwEhG9C,6BAAA;EACA,0BAAA;EACA,oCAAA;AnFqt7DJ;AmFnt7DI;EACI,6BAAA;EACA,UAAA;AnFqt7DR;AmFlt7DI;EACI,gBAAA;EACA,0BAAA;EACA,yBAAA;AnFot7DR;;AmF/s7DI;EACI,iBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AnFkt7DR;AmFht7DQ;EARJ;IASQ,mBAAA;EnFmt7DV;AACF;;AmF7s7DQ;EACI,iBAAA;EACA,wCAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;AnFgt7DZ;AmF9s7DY;EARJ;IASQ,mBAAA;EnFit7Dd;AACF;;AoFhw7DA;EACI,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,QAAA;EACA,6BzEyGW;EyExGX,WzES8C;EyER9C,YzEqGY;EyEpGZ,qCzEqGQ;AX8p7DZ;AoFjw7DI;EAVJ;IAWQ,OAAA;EpFow7DN;AACF;;AoF7v7DQ;EACI,UzEHsC;AXmw7DlD;AoF9v7DY;EAHJ;IAIQ,OAAA;EpFiw7Dd;AACF;AoF7v7DQ;EACI,WzEbsC;AX4w7DlD;AoF7v7DY;EAHJ;IAIQ,OAAA;EpFgw7Dd;AACF;;AoFzv7DI;EACI,kBAAA;ApF4v7DR;;AoFtv7DI;EACI;IACI,kBAAA;IACA,6BAAA;EpFyv7DV;AACF;;AoFnv7DQ;EADJ;IAEQ,wBAAA;EpFuv7DV;AACF;;AqFlz7DA;EACI,kB1Ec8C;E0Eb9C,gBAAA;ArFqz7DJ;AqFnz7DI;EACI,yBAAA;EACA,gB1EoF2C;AXiu7DnD;;AqFjz7DA;EACI,6BAAA;ArFoz7DJ;AqFlz7DI;EAHJ;IAIQ,kB1EC0C;EXoz7DhD;AACF;;AqFlz7DA;EACI,uEAAA;ArFqz7DJ;;AqFlz7DA;EACI,Y1ER8C;E0ES9C,a1ED8C;E0EE9C,sC1EL8C;E0EM9C,4BAAA;EACA,SAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,4C1EV8C;E0EW9C,gCAAA;EACA,6BAAA;ArFqz7DJ;AqFlz7DQ;EACI,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,yC1EdsC;E0EetC,oB1EjBsC;E0EkBtC,oC1EhCsC;AXo17DlD;AqFlz7DY;EACI,gD1EjBkC;AXq07DlD;AqFjz7DY;EACI,+C1EtBkC;AXy07DlD;AqFhz7DY;EACI,qBAAA;EACA,kB1EdkC;E0EelC,eAAA;EACA,oBAAA;ArFkz7DhB;AqF/y7DY;EACI,WAAA;EACA,sBAAA;EACA,yC1EpCkC;AXq17DlD;AqF9y7DY;EACI,iBAAA;EACA,kBAAA;EACA,UAAA;ArFgz7DhB;AqF7y7DY;EACI,+C1E7CkC;AX417DlD;AqF7y7DgB;EACI,+C1EhD8B;E0EiD9B,6BAAA;ArF+y7DpB;AqF1y7DgB;EACI,cAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,0C1EnD8B;AX+17DlD;AqFzy7DgB;EACI,gD1ElE8B;AX627DlD;AqFzy7DoB;EACI,+C1EtE0B;E0EuE1B,6BAAA;ArF2y7DxB;AqFxy7DoB;EACI,wBAAA;EACA,gD1E3E0B;AXq37DlD;AqFvy7DoB;EACI,UAAA;EACA,2D1EhF0B;AXy37DlD;AqFny7DoB;EACI,wBAAA;ArFqy7DxB;AqF/x7DQ;EACI,qB1ElFsC;AXm37DlD;AqF/x7DY;EACI,kCAAA;EACA,6C1E7FkC;E0E8FlC,iBAAA;EACA,kBAAA;EACA,mB1ElGkC;E0EmGlC,oC1EzHkC;AX057DlD;AqF/x7DgB;EACI,WAAA;EACA,UAAA;EACA,aAAA;EACA,wD1EvG8B;E0EwG9B,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gCAAA;EACA,YAAA;ArFiy7DpB;AqF9x7DgB;EACI,mD1E/G8B;AX+47DlD;AqF9x7DoB;EACI,yEAAA;EACA,UAAA;ArFgy7DxB;AqF5x7DgB;EACI,gD1E9H8B;AX457DlD;AqF5x7DoB;EACI,2D1EjI0B;AX+57DlD;AqFzx7DY;EACI,kBAAA;ArF2x7DhB;AqFvx7DoB;EACI,WAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,iBAAA;EACA,SAAA;ArFyx7DxB;AqFlx7DI;EACI,c1E1BG;E0E2BH,aAAA;ArFox7DR;;AqFhx7DA;EACI,iBAAA;EACA,kBAAA;EACA,6BAAA;ArFmx7DJ;AqFjx7DI;EALJ;IAMQ,aAAA;ErFox7DN;AACF;;AqFjx7DA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;ArFox7DJ;AqFlx7DI;EACI,yB1EjDG;E0EkDH,kBAAA;EACA,kBAAA;EACA,iDAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;ArFox7DR;AqFlx7DQ;EACI,MAAA;EACA,UAAA;ArFox7DZ;AqFjx7DQ;EACI,QAAA;ArFmx7DZ;AqFhx7DQ;EACI,SAAA;EACA,UAAA;ArFkx7DZ;AqF3w7DY;EACI,SAAA;ArF6w7DhB;AqF1w7DY;EACI,YAAA;ArF4w7DhB;AqFvw7DI;EACI,yBAAA;ArFyw7DR;AqFrw7DY;EACI,SAAA;EACA,QAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;ArFuw7DhB;AqFpw7DY;EACI,SAAA;EACA,SAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;ArFsw7DhB;AqFnw7DY;EACI,SAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;ArFqw7DhB;;AqF/v7DA;EACI,iB1EzL+C;AX277DnD;AqFhw7DI;EACI,aAAA;ArFkw7DR;;AqF9v7DA;EACI,aAAA;ArFiw7DJ;;AqF5v7DQ;EACI,SAAA;ArF+v7DZ;AqF7v7DY;EACI,WAAA;EACA,UAAA;ArF+v7DhB;AqF3v7DQ;EAVJ;IAWQ,kBAAA;IACA,sBAAA;ErF8v7DV;AACF;AqFzv7DQ;EACI,UAAA;ArF2v7DZ;AqFtv7DQ;EADJ;IAEQ,aAAA;ErFyv7DV;AACF;AqFtv7DI;EACI,aAAA;ArFwv7DR;AqFnv7DQ;EACI,iB1ElTsC;AXui8DlD;AqFnv7DY;EAHJ;IAIQ,cAAA;ErFsv7Dd;AACF;AqFlv7DY;EACI,aAAA;ArFov7DhB;AqFjv7DY;EACI,qBAAA;ArFmv7DhB;AqF/u7DQ;EACI,qBAAA;ArFiv7DZ;AqF9u7DQ;EACI;IACI,aAAA;ErFgv7Dd;AACF;AqF5u7DQ;EACI,W1E/UsC;AX6j8DlD;AqF5u7DY;EACI,aAAA;ArF8u7DhB;AqF3u7DoB;EACI,gBAAA;ArF6u7DxB;AqFru7DgB;EACI,aAAA;ArFuu7DpB;AqFpu7DgB;EACI,kBAAA;ArFsu7DpB;AqFpu7DoB;EACI,aAAA;ArFsu7DxB;AqFnu7DoB;EACI,cAAA;EACA,iBAAA;EACA,eAAA;ArFqu7DxB;AqFhu7DoB;EACI,aAAA;ArFku7DxB;AqF/t7DoB;EACI,eAAA;ArFiu7DxB;AqF/t7DwB;EAGI,eAAA;ArF+t7D5B;AqF3t7DoB;EACI,iBAAA;ArF6t7DxB;AqF1t7DoB;EAEI,aAAA;ArF2t7DxB;AqFvt7DgB;EACI,aAAA;ArFyt7DpB;AqFrt7DY;EACI,uBAAA;ArFut7DhB;AqFrt7DgB;EACI;IACI,qBAAA;ErFut7DtB;EqFpt7DkB;IACI,gBAAA;ErFst7DtB;AACF;AqFlt7DoB;EACI,cAAA;ArFot7DxB;AqF9s7DoB;EACI,eAAA;ArFgt7DxB;AqF9s7DwB;EAGI,eAAA;ArF8s7D5B;AqF1s7DoB;EACI,sBAAA;ArF4s7DxB;AqFzs7DoB;EAGI,qBAAA;ArFys7DxB;AqFps7DoB;EACI,qBAAA;ArFss7DxB;AqFns7DoB;EACI,aAAA;ArFqs7DxB;AqFjs7DgB;EACI,gBAAA;ArFms7DpB;AqFjs7DoB;EACI,qBAAA;ArFms7DxB;AqFhs7DoB;EACI,aAAA;ArFks7DxB;AqFxr7DY;EADJ;IAEQ,oB1EuHc;EXok7D5B;AACF;AqFtr7DQ;EACI,gBAAA;ArFwr7DZ;AqFrr7DQ;EACI,aAAA;ArFur7DZ;AqFpr7DQ;EACI,qBAAA;ArFsr7DZ;AqFjr7DQ;EADJ;IAEQ,kBAAA;ErFor7DV;EqFlr7DU;IACI,iB1E7ekC;EXiq8DhD;AACF;AqFjr7DQ;EACI,uBAAA;ArFmr7DZ;AqFhr7DQ;EACI,eAAA;EACA,UAAA;EACA,W1ExfsC;E0EyftC,UAAA;EACA,MAAA;EACA,sC1ExfsC;AX0q8DlD;AqF9q7DY;EACI,aAAA;ArFgr7DhB;AqF7q7DY;EACI,qBAAA;ArF+q7DhB;AqF1q7DQ;EACI,kBAAA;EACA,sBAAA;EACA,iB1EncuC;AX+m8DnD;AqF1q7DY;;EAEI,4BAAA;ArF4q7DhB;AqFzq7DY;;EAEI,wBAAA;ArF2q7DhB;AqFxq7DY;EACI,oBAAA;ArF0q7DhB;AqFpq7DgB;EACI,wBAAA;ArFsq7DpB;AqFnq7DgB;EACI,kBAAA;EACA,eAAA;ArFqq7DpB;AqFnq7DoB;EACI,aAAA;ArFqq7DxB;AqFlq7DoB;EACI,cAAA;EACA,iBAAA;ArFoq7DxB;AqF/p7DoB;EACI,aAAA;ArFiq7DxB;AqF9p7DoB;EACI,eAAA;ArFgq7DxB;AqF7p7DoB;EACI,iBAAA;ArF+p7DxB;AqF5p7DoB;EAEI,aAAA;ArF6p7DxB;AqFzp7DgB;EACI,aAAA;EACA,uBAAA;ArF2p7DpB;AqFxp7DgB;EACI,kBAAA;ArF0p7DpB;AqFvp7DA;EAC4B,kBAAA;EACA,yBAAA;EACA,W1E3cjB;E0E4ciB,iD1EvjBoB;E0EwjBpB,gBAAA;ArFyp7D5B;AqFvp7D4B;EACI,oD1ExjBgB;E0EyjBhB,+BAAA;ArFyp7DhC;AqFtp7D4B;EACI,qBAAA;EACA,kBAAA;ArFwp7DhC;AqFrp7D4B;EACI,cAAA;EACA,wBAAA;EACA,W1E5drB;AXmn8DX;AqFpp7DA;EAC4B,cAAA;EACA,U1EtmBsB;E0EumBtB,kBAAA;EACA,YAAA;EACA,sC1EtmBsB;E0EumBtB,uBAAA;EACA,iBAAA;EACA,0BAAA;EACA,4C1ExlBsB;AX8u8DlD;AqFjp7DgB;EACI,UAAA;ArFmp7DpB;AqFhp7DiC;EACD,+C1E7mBkB;AX+v8DlD;AqFhp7DgC;EACI,cAAA;ArFkp7DpC;AqF3o7DwB;EACI,yBAAA;EACA,kCAAA;ArF6o7D5B;AqFzo7DoB;EACI,qBAAA;EACA,MAAA;EACA,6BAAA;ArF2o7DxB;AqFno7DQ;EACI;IACI,kB1ErpBkC;EX0x8DhD;AACF;AqFlo7DQ;EACI,Y1E1pBsC;AX8x8DlD;AqFho7DQ;EACI,uBAAA;ArFko7DZ;AqF9n7DgB;EACI,cAAA;EACA,kBAAA;EACA,yBAAA;ArFgo7DpB;AqF9n7DoB;EACI,cAAA;ArFgo7DxB;AqF7n7DoB;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;ArF+n7DxB;AqF5n7DoB;EACI,wBAAA;ArF8n7DxB;AqF3n7DoB;EACI,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,QAAA;ArF6n7DxB;AqFzn7DwB;EACI,aAAA;ArF2n7D5B;AqFtn7DgB;EACI,wBAAA;ArFwn7DpB;AqFrn7DgB;EACI,eAAA;ArFun7DpB;AqFln7DY;EACI,kBAAA;ArFon7DhB;AqFln7DgB;EACI,0BAAA;ArFon7DpB;AqF7m7DQ;EACI,2C1E/rBoC;E0EgsBpC,uDAAA;ArF+m7DZ;AqF5m7DgB;EACI,yD1ElsB4B;AXgz8DhD;AqF1m7DY;EACI,8C1EvsBgC;AXmz8DhD;AqFtm7DY;EACI,8C1E9sBgC;AXsz8DhD;AqFtm7DgB;EACI,qD1E/sB4B;AXuz8DhD;AqFpm7DoB;EACI,cAAA;ArFsm7DxB;AqFnm7DoB;EACI,qD1ExtBwB;AX6z8DhD;AqFnm7DwB;EACI,cAAA;ArFqm7D5B;AqFlm7DwB;EACI,qD1E/tBoB;E0EguBpB,8BAAA;ArFom7D5B;AqF/l7DgB;EACI,8C1ExuB4B;E0EyuB5B,8BAAA;ArFim7DpB;AqF9l7DgB;EACI,oD1E5uB4B;AX408DhD;AqF9l7DoB;EACI,oD1E/uBwB;E0EgvBxB,+BAAA;ArFgm7DxB;AqFzl7DgB;EACI,qD1EvvB4B;AXk18DhD;AqFzl7DoB;EACI,oD1E3vBwB;E0E4vBxB,+BAAA;ArF2l7DxB;AqFrl7DgB;EACI,kD1EjwB4B;AXw18DhD;AqFrl7DoB;EACI,wEAAA;ArFul7DxB;AqFpl7DoB;EACI,oD1E1wBwB;AXg28DhD;AqFpl7DwB;EACI,0EAAA;ArFsl7D5B;AqFll7DoB;EACI,qD1EjxBwB;AXq28DhD;AqF9k7DwB;EACI,wCAAA;ArFgl7D5B;AqF5k7D4B;EACI,0EAAA;ArF8k7DhC;AqF1k7DwB;EACI,qD1ElyBoB;AX828DhD;AqF1k7D4B;EACI,2EAAA;ArF4k7DhC;AqFnk7DY;EACI,2C1EnzBgC;AXw38DhD;AqF7j7DiC;EACD,2C1E5zBgB;AX238DhD;AqF1j7DoB;EACI,UAAA;ArF4j7DxB;AqFzj7D4B;EACI,yBAAA;EACA,kCAAA;ArF2j7DhC;AqFrj7DgC;EACI,qD1E10BY;AXi48DhD;AqFrj7DoC;EACI,cAAA;ArFuj7DxC;AqFjj7DwB;EACI,qBAAA;EACA,MAAA;EACA,6BAAA;ArFmj7D5B;AqF5i7DQ;EACI,+C1E11BoC;AXw48DhD;AqF3i7DQ;EACI,aAAA;ArF6i7DZ;AqF1i7DQ;EACI,qBAAA;ArF4i7DZ;AqFvi7DQ;EACI,qBAAA;ArFyi7DZ;AqFti7DQ;EACI,aAAA;ArFwi7DZ;AqFli7DQ;;EAEI,iBAAA;ArFoi7DZ;AqFji7DQ;EACI;IACI,kBAAA;ErFmi7Dd;EqFhi7DU;IACI,cAAA;IACA,cAAA;IACA,oB1ErVc;EXu37D5B;EqF/h7DU;IACI,oB1EzVc;EX037D5B;EqF9h7DU;IACI,wBAAA;IACA,c1E9Vc;I0E+Vd,UAAA;IACA,wC1Ez6BkC;I0E06BlC,kBAAA;IACA,eAAA;IACA,UAAA;ErFgi7Dd;EqF9h7Dc;IACI,aAAA;ErFgi7DlB;EqFvh7Dc;IACI,qBAAA;ErFyh7DlB;EqFth7Dc;IACI,aAAA;ErFwh7DlB;AACF;AqFph7DQ;EACI,6CAAA;ArFsh7DZ;AqFlh7DY;EACI,gBAAA;ArFoh7DhB;AqF/g7DY;EAEI;;IAEI,kBAAA;ErFgh7DlB;AACF;AqFrg7DQ;EACI,aAAA;ArFug7DZ;AqFpg7DQ;EACI,qBAAA;ArFsg7DZ;;AqFjg7DA;EACI,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,0C1Ez9B8C;E0E09B9C,gB1ErU0B;AXy07D9B;AqFlg7DI;EACI,kBAAA;EACA,qBAAA;ArFog7DR;AqFjg7DI;EACI,aAAA;ArFmg7DR;;AqF//6DA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;EACA,aAAA;EACA,aAAA;ArFkg7DJ;;AqF7/6DI;EACI,cAAA;ArFgg7DR;AqF7/6DI;EACI,yBAAA;EACA,aAAA;ArF+/6DR;;AqFt/6DgB;EACI,yBAAA;ArFy/6DpB;AqFt/6DgB;EACI,yBAAA;ArFw/6DpB;;AqF/+6DI;EACI,+C1ElgC4C;E0EmgC5C,+DAAA;ArFk/6DR;AqF/+6DY;EACI,0C1ErgCoC;AXs/8DpD;AqF7+6DQ;EACI,+B1E1gCwC;AXy/8DpD;AqFz+6DQ;EACI,+B1EjhCwC;AX4/8DpD;AqFz+6DY;EACI,qD1E7hCgC;AXwg9DhD;AqFv+6DgB;EACI,cAAA;ArFy+6DpB;AqFt+6DgB;EACI,qD1EtiC4B;AX8g9DhD;AqFv+6DoB;EACI,cAAA;ArFy+6DxB;AqFt+6DoB;EACI,qD1E5iCwB;E0E6iCxB,8BAAA;ArFw+6DxB;AqFn+6DY;EACI,+B1E1iCoC;E0E2iCpC,8BAAA;ArFq+6DhB;AqFl+6DY;EACI,oD1EzjCgC;AX6h9DhD;AqFn+6DgB;EACI,oD1E3jC4B;E0E4jC5B,+BAAA;ArFq+6DpB;AqF996DY;EACI,qD1EnkCgC;AXmi9DhD;AqF/96DgB;EACI,oD1EtkC4B;E0EukC5B,+BAAA;ArFi+6DpB;AqF396DY;EACI,+B1EnkCoC;AXgi9DpD;AqF396DgB;EACI,qDAAA;ArF696DpB;AqF196DgB;EACI,oD1ErlC4B;AXij9DhD;AqF196DoB;EACI,0EAAA;ArF496DxB;AqFx96DgB;EACI,qD1E5lC4B;AXsj9DhD;AqFp96DoB;EACI,wCAAA;ArFs96DxB;AqFl96DwB;EACI,0EAAA;ArFo96D5B;AqFh96DoB;EACI,qD1E7mCwB;AX+j9DhD;AqFj96DwB;EACI,2EAAA;ArFm96D5B;AqF186DQ;EACI,+C1ElnCwC;AX8j9DpD;AqFp86D6B;EACD,2C1EtoCoB;AX4k9DhD;AqFj86DgB;EACI,UAAA;ArFm86DpB;AqFh86DwB;EACI,yBAAA;EACA,kCAAA;ArFk86D5B;AqF776DiC;EACD,qD1EnpCgB;AXkl9DhD;AqF776DgC;EACI,cAAA;ArF+76DpC;AqFz76DoB;EACI,qBAAA;EACA,MAAA;EACA,6BAAA;ArF276DxB;AqFj76DiC;EACD,+C1EnqCoB;AXsl9DpD;AqF166DI;EACI,+B1EzqC4C;AXql9DpD;;AqFx66DA;EACI,2EAAA;ArF266DJ;;AqFx66DA;EACI,0EAAA;ArF266DJ;;AqFx66DA;EACI,wEAAA;ArF266DJ;;AqFx66DA;EACI,wEAAA;ArF266DJ;;AqFt66DA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,wBAAA;EACA,aAAA;ArFy66DJ;;AqFr66DI;EACI,0DAAA;ArFw66DR;;AqFp66DI;EACI,0DAAA;ArFu66DR;;AqFn66DI;EACI,0DAAA;ArFs66DR;;AqFl66DI;EACI,0DAAA;ArFq66DR;;AsF1r9DI;EACI,cAAA;AtF6r9DR;AsF1r9DI;EAEI;;;;;;;IAEI,cAAA;IACA,cAAA;EtFgs9DV;EsF7r9DM;IACI,kBAAA;EtF+r9DV;AACF;AsF5r9DI;EACI,8BAAA;AtF8r9DR;AsF5r9DQ;EAHJ;IAIQ,oB3EskBkB;EXyn8D5B;AACF;AsF5r9DI;EACI,+B3EqFM;E2EpFN,+BAAA;EACA,2BAAA;EACA,4C3EgC2C;E2E/B3C,gB3E0D2C;E2EzD3C,eAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AtF8r9DR;AsF5r9DQ;EACI;IACI,UAAA;EtF8r9Dd;AACF;AsF3r9DQ;EACI,mBAAA;AtF6r9DZ;AsF3r9DY;EACI,eAAA;AtF6r9DhB;AsF1r9DoB;EACI,qBAAA;AtF4r9DxB;AsFzr9DoB;EAEI,yC3EwDK;AXko9D7B;AsFrr9DY;EACI,kC3EiDM;E2EhDN,uBAAA;AtFur9DhB;AsFrr9DgB;EACI,cAAA;AtFur9DpB;AsFpr9DgB;EACI,yC3E0CS;AX4o9D7B;AsFrr9DoB;EACI,yC3EwCK;AX+o9D7B;AsFrr9DoB;EACI,yC3EqCK;E2EpCL,4BAAA;AtFur9DxB;AsFnr9DgB;EACI,yC3E+BS;AXsp9D7B;AsFnr9DoB;EACI,yC3E4BK;E2E3BL,4BAAA;AtFqr9DxB;AsFlr9DoB;EACI,yC3EuBK;AX6p9D7B;AsF/q9DoB;EACI,yC3EiBK;E2EhBL,4BAAA;AtFir9DxB;AsF3q9DgB;EACI,UAAA;EACA,mCAAA;AtF6q9DpB;AsFxq9DgB;EACI,eAAA;AtF0q9DpB;AsFrq9DQ;EACI,aAAA;AtFuq9DZ;AsFlq9DQ;EACI,kBAAA;AtFoq9DZ;AsFlq9DY;EACI,WAAA;EACA,kCAAA;AtFoq9DhB;AsFhq9DgB;EACI,aAAA;AtFkq9DpB;AsF7p9DgB;EACI,yC3EzBS;AXwr9D7B;AsF7p9DoB;EACI,yC3E5BK;E2E6BL,4BAAA;AtF+p9DxB;AsF5p9DoB;EACI,yC3EjCK;AX+r9D7B;AsF1p9DgB;EAA8B;IACtB,cAAA;IACA,uBAAA;EtF6p9DtB;AACF;AsFzp9DY;EACI,yC3E7Ca;AXws9D7B;AsFtp9DI;EACI,kBAAA;EACA,gB3EtG2C;E2EuG3C,iBAAA;EACA,4C3EzG2C;E2E0G3C,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,SAAA;EACA,a3Eg/B4B;E2E/+B5B,sCAAA;EACA,4BAAA;EACA,sCAAA;EACA,qB3E2csB;E2E1ctB,aAAA;AtFwp9DR;AsFtp9DQ;EACI,MAAA;EACA,UAAA;AtFwp9DZ;AsFpp9DI;EACI,YAAA;AtFsp9DR;AsFnp9DI;EACI,aAAA;AtFqp9DR;AsFlp9DI;EACI,sBAAA;EACA,WAAA;AtFop9DR;AsFjp9DI;EACI;IACI,aAAA;EtFmp9DV;AACF;;AsF7o9DQ;EACI;IACI,cAAA;IACA,iBAAA;IACA,gBAAA;IACA,eAAA;EtFgp9Dd;EsF9o9Dc;IACI,sBAAA;EtFgp9DlB;EsF/o9DF;IACwB,oB3E9L0B;EX+09DhD;EsF9o9DkB;IACI,qBAAA;EtFgp9DtB;EsF3o9DU;IACI,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,kBAAA;IACA,OAAA;IACA,eAAA;IACA,cAAA;EtF6o9Dd;EsF3o9Dc;IACI,cAAA;EtF6o9DlB;EsFzo9DU;IACI,kBAAA;EtF2o9Dd;EsFxo9DU;IACI,UAAA;EtF0o9Dd;EsFvo9DU;IACI,WAAA;EtFyo9Dd;AACF;;AsF/n9DgB;EACI,aAAA;AtFko9DpB;AsF/n9DgB;EACI,cAAA;AtFio9DpB;;AsFrn9DgB;EACI,oCAAA;AtFwn9DpB;AsFhn9DoB;EACI,qCAAA;AtFkn9DxB;;AuFl59DI;EACI,iBAAA;EACA,Y5EwE2C;E4EvE3C,U5EsE2C;AX+09DnD;AuFn59DQ;EACI,sBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,qDAAA;EACA,gB5EgrBkB;AXqu8D9B;AuFn59DY;EACI,wBAAA;AvFq59DhB;AuFl59DY;EACI,aAAA;AvFo59DhB;AuFh59DQ;EACI,0BAAA;AvFk59DZ;AuFh59DY;EAHJ;IAIQ,iBAAA;EvFm59Dd;AACF;AuFj59DY;EACI,aAAA;AvFm59DhB;AuF/49DgB;EACI,yBAAA;EACA,uBAAA;AvFi59DpB;AuF549DgB;EACI,yBAAA;EACA,uBAAA;AvF849DpB;AuFx49DoB;EACI,SAAA;AvF049DxB;AuFx49DwB;EACI,WAAA;EACA,UAAA;AvF049D5B;AuFn49DgB;EACI,yC5ErC8B;AX069DlD;AuFn49DoB;EACI,gD5EtC0B;AX269DlD;AuF/39DQ;EACI,UAAA;AvFi49DZ;AuF739DI;EACI,+BAAA;AvF+39DR;AuF739DQ;EAHJ;IAIQ,iB5EPuC;EXu49DjD;AACF;AuF739DI;EACI,W5EZ2C;E4Ea3C,sD5Ef2C;E4EgB3C,YAAA;EACA,WAAA;EACA,4C5Ed2C;E4Ee3C,MAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AvF+39DR;AuF739DQ;EACI,kBAAA;EACA,gBAAA;AvF+39DZ;AuF539DgB;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;AvF839DpB;AuFz39DQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,yC5E1FsC;E4E2FtC,UAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AvF239DZ;AuFz39DY;EACI,WAAA;EACA,yC5EtGkC;AXi+9DlD;AuFx39DY;EACI,yCAAA;EACA,c5E+CH;AX209Db;AuFx39DgB;EACI,c5E4CP;E4E3CO,4BAAA;AvF039DpB;AuFp39DI;EACI,aAAA;AvFs39DR;AuFn39DI;EAGQ;IACI,cAAA;EvFm39Dd;EuFh39DU;IACI,aAAA;EvFk39Dd;AACF;AuF329DgB;EACI,aAAA;AvF629DpB;AuF129DgB;EACI,cAAA;AvF429DpB;AuFr29DQ;EACI,2D5EjGsC;AXw89DlD;AuFr29DY;EACI,+C5EjGkC;AXw89DlD;AuFr29DgB;EACI,sD5EnG8B;E4EoG9B,8D5EnG8B;AX089DlD;AuFl29DQ;EACI,kD5E7GsC;E4E8GtC,oD5E7GsC;AXi99DlD;AuFj29DgB;EACI,cAAA;AvFm29DpB;AuFh29DgB;EACI,aAAA;AvFk29DpB;AuF519DoB;EACI,+C5E3H0B;AXy99DlD;AuFn19DwB;EAEI,sD5EvIsB;AX299DlD;AuFl19D4B;EACI,4EAAA;AvFo19DhC;AuF709DoB;EACI,sD5ElJ0B;AXi+9DlD;AuF709DwB;EACI,iE5ErJsB;AXo+9DlD;AuF509DwB;EACI,iEAAA;AvF809D5B;AuFr09DQ;EACI,2D5EvKsC;AX8+9DlD;AuFr09DY;EACI,+B5ElKkC;AXy+9DlD;AuFr09DgB;EACI,sD5EzK8B;E4E0K9B,8D5EzK8B;AXg/9DlD;AuFl09DQ;EACI,kD5EnLsC;E4EoLtC,oD5EnLsC;AXu/9DlD;AuFj09DgB;EACI,cAAA;AvFm09DpB;AuFh09DgB;EACI,aAAA;AvFk09DpB;AuF5z9DoB;EACI,+B5E5L0B;AX0/9DlD;AuFnz9DwB;EAEI,sD5E7MsB;AXig+DlD;AuFlz9D4B;EACI,4EAAA;AvFoz9DhC;AuF7y9DoB;EACI,sD5ExN0B;AXug+DlD;AuF7y9DwB;EACI,iE5E3NsB;AX0g+DlD;AuF5y9DwB;EACI,iEAAA;AvF8y9D5B;AuFty9DY;EACI,2B5E9JL;AXs89DX;AuFly9DQ;EACI,QAAA;EACA,eAAA;AvFoy9DZ;AuFly9DY;EAJJ;IAKQ,aAAA;EvFqy9Dd;AACF;AuFly9DQ;;EAEI,aAAA;AvFoy9DZ;AuFjy9DQ;EACI,iB5EtQuC;AXyi+DnD;AuFhy9DQ;;EAEI,U5E3QuC;AX6i+DnD;AuF/x9DQ;EACI;IACI,cAAA;EvFiy9Dd;EuF9x9DU;;IAEI,OAAA;EvFgy9Dd;AACF;AuFzx9DQ;EAFJ;;IAGQ,U5E9RuC;EX2j+DjD;AACF;AuF1x9DI;EACI;IACI,cAAA;EvF4x9DV;EuFzx9DM;;IAEI,OAAA;EvF2x9DV;AACF;;AwF9o+DI;EACI,yC7EwHgB;AXyh+DxB;AwF9o+DI;EACI,iB7EmHgB;E6ElHhB,cAAA;EACA,4C7E4nBsB;E6E3nBtB,mCAAA;AxFgp+DR;AwF5o+DQ;EACI,iBAAA;AxF8o+DZ;AwF1o+DI;;EAEI,iB7EqGgB;E6EpGhB,cAAA;EACA,kBAAA;AxF4o+DR;AwFto+DY;EACI;IACI,kBAAA;ExFwo+DlB;AACF;AwFpo+DgB;EADJ;IAEQ,cAAA;ExFuo+DlB;AACF;AwFno+DQ;;;EAEI,kBAAA;EACA,8BAAA;AxFso+DZ;AwFpo+DY;EALJ;;;IAMQ,qBAAA;ExFyo+Dd;AACF;AwFlo+DQ;;;EAEI,+BAAA;AxFqo+DZ;AwFno+DY;EAJJ;;;IAKQ,sBAAA;ExFwo+Dd;AACF;AwFlo+DQ;;EAEI,+BAAA;AxFoo+DZ;AwFlo+DY;EAJJ;;IAKQ,sBAAA;ExFso+Dd;AACF;AwF/n+DQ;EACI,mCAAA;AxFio+DZ;AwF9n+DQ;EACI;IACI,iBAAA;IACA,gBAAA;ExFgo+Dd;EwF7n+DU;IACI,iBAAA;ExF+n+Dd;AACF;AwFvn+DY;;;;;EAEI,eAAA;EACA,kBAAA;AxF4n+DhB;;AwFln+DI;;;EAGI,eAAA;AxFqn+DR;AwFln+DI;;EAEI,iBAAA;AxFon+DR;AwFjn+DI;EACI,+BAAA;AxFmn+DR;AwF5m+DQ;;;;EAEI,kBAAA;AxFgn+DZ;;AwFxm+DI;EAEI;;IAEI,kBAAA;ExF0m+DV;AACF;AwFtm+DQ;EAEI;;IAEI,kBAAA;ExFum+Dd;AACF;;AyFtw+DA;;;;;;uDAAA;AAOC;EACG,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,wCAAA;AzFyw+DJ;;AyFvw+DE;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,8BAAA;EAIA,qJAAA;EAIA,6BAAA;EAIA,uCAAA;EAKA,mCAAA;EACA,oBAAA;AzF0w+DJ;;AyFxw+DE;EACE,oCAAA;EAIA,6KAAA;AzF2w+DJ;;AyFzw+DE;EACE,8BAAA;AzF4w+DJ;;AyF1w+DE;EACE,oCAAA;AzF6w+DJ;;AyF3w+DE;EAIE,2BAAA;AzF8w+DJ;;AyF5w+DE;;EAME,wBAAA;EACA,2EAAA;AzF+w+DJ;;AyF7w+DE;;;;EAIE,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,kCAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,UAAA;AzFgx+DJ;;AyF9w+DE;EACE,qBAAA;EACA,oBAAA;AzFix+DJ;;AyF/w+DE;EACE,SAAA;EACA,qBAAA;AzFkx+DJ;;AyFhx+DE;EACE,oBAAA;EACA,sBAAA;AzFmx+DJ;;AyFjx+DE;EACE,UAAA;AzFox+DJ;;AyFlx+DE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AzFqx+DJ;;AyFnx+DE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AzFsx+DJ;;AyFpx+DE;EACE,wBAAA;EAEA,iDAAA;EAIA,qBAAA;AzFux+DJ;;AyFrx+DE;EAEE,+CAAA;AzFwx+DJ;;AyFtx+DE;EACE,cAAA;AzFyx+DJ;;AyFrx+DI;EACI,0CAAA;AzFwx+DR;;AyFnx+DI;EACI,wCAAA;AzFsx+DR;;AyFlx+DI;EACI,yCAAA;AzFqx+DR;;AyFjx+DI;EACI,yCAAA;AzFox+DR;;AyFhx+DI;EACI,yCAAA;AzFmx+DR;;AyF/w+DI;EACI,yCAAA;AzFkx+DR;;A0Fn7+DA;EACI,cAAA;EACA,aAAA;A1Fs7+DJ;;A0Fn7+DA;EACI,YAAA;EACA,WAAA;A1Fs7+DJ;;A0Fn7+DA;EACI,YAAA;EACA,WAAA;A1Fs7+DJ;;A0Fn7+DA;EACI,cAAA;EACA,aAAA;A1Fs7+DJ;;A0Fn7+DA;EACI,YAAA;EACA,WAAA;A1Fs7+DJ;;A0Fn7+DA;EACI,cAAA;EACA,aAAA;A1Fs7+DJ;;A0Fn7+DA;EACI,mBAAA;EACA,yB/EoJS;E+EnJT,W/EqHO;E+EpHP,aAAA;EACA,gB/E0FiB;E+EzFjB,YAAA;EACA,uBAAA;EACA,WAAA;A1Fs7+DJ;;A0Fl7+DA;EACI,kBAAA;EACA,aAAA;EACA,eAAA;A1Fq7+DJ;A0Fn7+DI;EACI,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,oBAAA;A1Fq7+DR;A0Fn7+DQ;EACI,kBAAA;EACA,2BAAA;EACA,UAAA;A1Fq7+DZ;;A2F5++DI;EACI,gBhF2Ha;AXo3+DrB;A2F5++DI;EACI,chFsJG;AXw1+DX;A2Fz++DY;EACI,WAAA;EACA,iCAAA;A3F2++DhB;A2Fv++DgB;EACI,WAAA;A3Fy++DpB;;A2F99+DQ;EACI,iCAAA;EACA,oCAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;A3Fi++DZ;A2F79+DY;EACI,iCAAA;EACA,iBAAA;EACA,kBAAA;A3F+9+DhB;;A2Fr9+DQ;EACI,iCAAA;EACA,oCAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;A3Fw9+DZ;A2Fp9+DY;EACI,iCAAA;EACA,iBAAA;EACA,kBAAA;A3Fs9+DhB;;A2F58+DI;EACI,qBAAA;A3F+8+DR;A2F78+DQ;EACI,kBAAA;EACA,ahFoyC8B;EgFnyC9B,SAAA;A3F+8+DZ;A2F38+DY;EACI,SAAA;A3F68+DhB;;A2Fp8+DI;EACI,4CAAA;EACA,sBhF0hBsB;AX669D9B;A2Fr8+DQ;EACI,eAAA;A3Fu8+DZ;A2Fp8+DQ;EACI,sBhFmhBkB;AXm79D9B;A2Fp8+DY;EACI,4BAAA;EACA,6BAAA;A3Fs8+DhB;;A2F/7+DI;EACI,6CAAA;A3Fk8+DR;;A2Fz7+DQ;EACI,oCAAA;A3F47+DZ;A2F17+DY;EACI,gBAAA;A3F47+DhB;A2F17+DgB;EACI,chFyFL;EgFxFK,mDAAA;A3F47+DpB;A2Fz7+DgB;EACI,chFoFL;AXu2+Df;;A2Fn7+DY;EACI,gBAAA;A3Fs7+DhB;A2Fp7+DgB;EACI,WhFCT;EgFAS,oCAAA;A3Fs7+DpB;;A2F/8+DQ;EACI,qCAAA;A3Fk9+DZ;A2Fh9+DY;EACI,gBAAA;A3Fk9+DhB;A2Fh9+DgB;EACI,chFyFL;EgFxFK,oDAAA;A3Fk9+DpB;A2F/8+DgB;EACI,chFoFL;AX63+Df;;A2Fz8+DY;EACI,gBAAA;A3F48+DhB;A2F18+DgB;EACI,WhFCT;EgFAS,oCAAA;A3F48+DpB;;A2Fr++DQ;EACI,qCAAA;A3Fw++DZ;A2Ft++DY;EACI,gBAAA;A3Fw++DhB;A2Ft++DgB;EACI,chFyFL;EgFxFK,oDAAA;A3Fw++DpB;A2Fr++DgB;EACI,chFoFL;AXm5+Df;;A2F/9+DY;EACI,gBAAA;A3Fk++DhB;A2Fh++DgB;EACI,WhFCT;EgFAS,oCAAA;A3Fk++DpB;;A2F3/+DQ;EACI,qCAAA;A3F8/+DZ;A2F5/+DY;EACI,gBAAA;A3F8/+DhB;A2F5/+DgB;EACI,chFyFL;EgFxFK,oDAAA;A3F8/+DpB;A2F3/+DgB;EACI,chFoFL;AXy6+Df;;A2Fr/+DY;EACI,gBAAA;A3Fw/+DhB;A2Ft/+DgB;EACI,WhFCT;EgFAS,oCAAA;A3Fw/+DpB;;A2Fjh/DQ;EACI,qCAAA;A3Foh/DZ;A2Flh/DY;EACI,gBAAA;A3Foh/DhB;A2Flh/DgB;EACI,chFyFL;EgFxFK,oDAAA;A3Foh/DpB;A2Fjh/DgB;EACI,chFoFL;AX+7+Df;;A2F3g/DY;EACI,gBAAA;A3F8g/DhB;A2F5g/DgB;EACI,WhFCT;EgFAS,oCAAA;A3F8g/DpB;;A2Fvi/DQ;EACI,qCAAA;A3F0i/DZ;A2Fxi/DY;EACI,gBAAA;A3F0i/DhB;A2Fxi/DgB;EACI,chFyFL;EgFxFK,oDAAA;A3F0i/DpB;A2Fvi/DgB;EACI,chFoFL;AXq9+Df;;A2Fji/DY;EACI,gBAAA;A3Foi/DhB;A2Fli/DgB;EACI,WhFCT;EgFAS,oCAAA;A3Foi/DpB;;A2F7j/DQ;EACI,sCAAA;A3Fgk/DZ;A2F9j/DY;EACI,gBAAA;A3Fgk/DhB;A2F9j/DgB;EACI,chFyFL;EgFxFK,qDAAA;A3Fgk/DpB;A2F7j/DgB;EACI,chFoFL;AX2++Df;;A2Fvj/DY;EACI,gBAAA;A3F0j/DhB;A2Fxj/DgB;EACI,WhFCT;EgFAS,oCAAA;A3F0j/DpB;;A2Fnl/DQ;EACI,mCAAA;A3Fsl/DZ;A2Fpl/DY;EACI,gBAAA;A3Fsl/DhB;A2Fpl/DgB;EACI,chFyFL;EgFxFK,kDAAA;A3Fsl/DpB;A2Fnl/DgB;EACI,chFoFL;AXig/Df;;A2F7k/DY;EACI,gBAAA;A3Fgl/DhB;A2F9k/DgB;EACI,WhFCT;EgFAS,oCAAA;A3Fgl/DpB;;A2Fpk/DQ;EACI,8CAAA;A3Fuk/DZ;A2Ftk/DY;EACI,0DAAA;A3Fwk/DhB;A2Fpk/DQ;EACI,0DAAA;A3Fsk/DZ;;A2F9j/DQ;EACI,yBAAA;A3Fik/DZ;;A4Fjv/DE;EACE,0BAAA;A5Fov/DJ;;A4Frv/DE;EACE,0BAAA;A5Fwv/DJ;;A4Fzv/DE;EACE,0BAAA;A5F4v/DJ;;A4F7v/DE;EACE,0BAAA;A5Fgw/DJ;;A4Fjw/DE;EACE,0BAAA;A5Fow/DJ;;A4Frw/DE;EACE,0BAAA;A5Fww/DJ;;A4Fzw/DE;EACE,0BAAA;A5F4w/DJ;;A4F7w/DE;EACE,0BAAA;A5Fgx/DJ;;A4Fjx/DE;EACE,0BAAA;A5Fox/DJ;;A4Frx/DE;EACE,0BAAA;A5Fwx/DJ;;A4Fzx/DE;EACE,0BAAA;A5F4x/DJ;;A4F7x/DE;EACE,0BAAA;A5Fgy/DJ;;A4Fjy/DE;EACE,0BAAA;A5Foy/DJ;;A4Fry/DE;EACE,0BAAA;A5Fwy/DJ;;A4Fzy/DE;EACE,0BAAA;A5F4y/DJ;;A4F7y/DE;EACE,0BAAA;A5Fgz/DJ;;A4Fjz/DE;EACE,0BAAA;A5Foz/DJ;;A4F/y/DA;EACI,uCAAA;A5Fkz/DJ;;A4Fhz/DA;EACI,wCAAA;A5Fmz/DJ;;A4F7y/DI;EACI,+BAAA;A5Fgz/DR;;A4F9y/DI;EACI,mCAAA;A5Fiz/DR;;A4F/y/DI;EACI,sCAAA;A5Fkz/DR;;A4Fhz/DI;EACI,qCAAA;A5Fmz/DR;;A4Fjz/DI;EACI,oCAAA;A5Foz/DR;;A4F/y/DQ;EACI,uBAAA;A5Fkz/DZ;A4Fjz/DY;EACI,+BAAA;A5Fmz/DhB;;A4Fx0/DI;EACI,+BAAA;A5F20/DR;;A4Fz0/DI;EACI,mCAAA;A5F40/DR;;A4F10/DI;EACI,sCAAA;A5F60/DR;;A4F30/DI;EACI,qCAAA;A5F80/DR;;A4F50/DI;EACI,oCAAA;A5F+0/DR;;A4F10/DQ;EACI,uBAAA;A5F60/DZ;A4F50/DY;EACI,+BAAA;A5F80/DhB;;A4Fn2/DI;EACI,+BAAA;A5Fs2/DR;;A4Fp2/DI;EACI,mCAAA;A5Fu2/DR;;A4Fr2/DI;EACI,sCAAA;A5Fw2/DR;;A4Ft2/DI;EACI,qCAAA;A5Fy2/DR;;A4Fv2/DI;EACI,oCAAA;A5F02/DR;;A4Fr2/DQ;EACI,uBAAA;A5Fw2/DZ;A4Fv2/DY;EACI,+BAAA;A5Fy2/DhB;;A4F93/DI;EACI,+BAAA;A5Fi4/DR;;A4F/3/DI;EACI,mCAAA;A5Fk4/DR;;A4Fh4/DI;EACI,sCAAA;A5Fm4/DR;;A4Fj4/DI;EACI,qCAAA;A5Fo4/DR;;A4Fl4/DI;EACI,oCAAA;A5Fq4/DR;;A4Fh4/DQ;EACI,uBAAA;A5Fm4/DZ;A4Fl4/DY;EACI,+BAAA;A5Fo4/DhB;;A4Fz5/DI;EACI,8BAAA;A5F45/DR;;A4F15/DI;EACI,kCAAA;A5F65/DR;;A4F35/DI;EACI,qCAAA;A5F85/DR;;A4F55/DI;EACI,oCAAA;A5F+5/DR;;A4F75/DI;EACI,mCAAA;A5Fg6/DR;;A4F35/DQ;EACI,uBAAA;A5F85/DZ;A4F75/DY;EACI,8BAAA;A5F+5/DhB;;A4Fp7/DI;EACI,+BAAA;A5Fu7/DR;;A4Fr7/DI;EACI,mCAAA;A5Fw7/DR;;A4Ft7/DI;EACI,sCAAA;A5Fy7/DR;;A4Fv7/DI;EACI,qCAAA;A5F07/DR;;A4Fx7/DI;EACI,oCAAA;A5F27/DR;;A4Ft7/DQ;EACI,uBAAA;A5Fy7/DZ;A4Fx7/DY;EACI,+BAAA;A5F07/DhB;;A4F/8/DI;EACI,8BAAA;A5Fk9/DR;;A4Fh9/DI;EACI,kCAAA;A5Fm9/DR;;A4Fj9/DI;EACI,qCAAA;A5Fo9/DR;;A4Fl9/DI;EACI,oCAAA;A5Fq9/DR;;A4Fn9/DI;EACI,mCAAA;A5Fs9/DR;;A4Fj9/DQ;EACI,uBAAA;A5Fo9/DZ;A4Fn9/DY;EACI,8BAAA;A5Fq9/DhB;;A4F78/DI;EACI,gCAAA;A5Fg9/DR;A4F/8/DQ;EACI,gDAAA;A5Fi9/DZ;;A4Fz8/DA;EACI,sCjFmnB0B;AXy1+D9B;;A4Fz8/DA;EACI,oCjFtD8C;AXkggElD;;A4Fv8/DA;EACI,gBjFuDiB;AXm5/DrB;;A4Fr8/DA;EACI,SAAA;A5Fw8/DJ;;A4Fn8/DA;EACI,YAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cjFmEO;EiFlEP,kBAAA;EACA,oBAAA;A5Fs8/DJ;A4Fp8/DI;EACI,cjF+DG;EiF9DH,yBjF0DG;AX44/DX;;A4Fh8/DA;EACI,yDAAA;A5Fm8/DJ;;A4F/7/DA;EACI,eAAA;A5Fk8/DJ;;A4F/7/DA;EACI,eAAA;A5Fk8/DJ;;A4F/7/DA;EACI,gBAAA;A5Fk8/DJ;;A4F/7/DA;EACI,gBAAA;A5Fk8/DJ;;A4F/7/DA;EACI,gBAAA;A5Fk8/DJ;;A4F97/DA;EACI,YAAA;EACA,WAAA;A5Fi8/DJ;;A4F97/DA;EACI,YAAA;EACA,WAAA;A5Fi8/DJ;;A4F97/DA;EACI,YAAA;EACA,WAAA;A5Fi8/DJ;;A4F97/DA;EACI,YAAA;EACA,WAAA;A5Fi8/DJ;;A4F97/DA;EACI,YAAA;EACA,WAAA;A5Fi8/DJ;;A4F97/DA;EACI,YAAA;EACA,WAAA;A5Fi8/DJ;;A4F77/DA;EACI,cjFHO;EiFIP,+BAAA;A5Fg8/DJ;;A4F37/DI;EACI,cjFwDO;EiFvDP,6BAAA;A5F87/DR;;A4Fh8/DI;EACI,cjFwDO;EiFvDP,8BAAA;A5Fm8/DR;;A4Fr8/DI;EACI,cjFwDO;EiFvDP,8BAAA;A5Fw8/DR;;A4F18/DI;EACI,cjFwDO;EiFvDP,8BAAA;A5F68/DR;;A4F/8/DI;EACI,cjFwDO;EiFvDP,8BAAA;A5Fk9/DR;;A4Fp9/DI;EACI,cjFwDO;EiFvDP,8BAAA;A5Fu9/DR;;A4Fz9/DI;EACI,cjFwDO;EiFvDP,+BAAA;A5F49/DR;;A4F99/DI;EACI,cjFwDO;EiFvDP,4BAAA;A5Fi+/DR;;A4F59/DA;EACI,kBAAA;A5F+9/DJ;A4F99/DI;EACI,kBAAA;A5Fg+/DR;A4F99/DI;EACI,eAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,cjF5BG;AX4//DX;;A4Fz9/DA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,sBjFxCO;AXoggEX;;A4Fv9/DA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;A5F09/DJ;;A4Ft9/DA;EACI,wBAAA;UAAA,gBAAA;A5Fy9/DJ;;A4Ft9/DA;EACI,YAAA;EACA,qBAAA;EACA,oCAAA;EACA,iCAAA;A5Fy9/DJ;;A4Fp9/DI;EAFJ;IAGQ,aAAA;IACA,0BAAA;IACA,aAAA;IACA,UAAA;IACA,QAAA;IACA,WAAA;IACA,aAAA;E5Fw9/DN;E4Fv9/DM;IACI,eAAA;IACA,MAAA;IACA,UAAA;IACA,WAAA;IACA,SAAA;IACA,uCAAA;E5Fy9/DV;E4Ft9/DM;IACI,eAAA;IACA,YAAA;IACA,iBAAA;E5Fw9/DV;E4Ft9/DM;IACI,gBAAA;IACA,+BAAA;E5Fw9/DV;AACF;;A4Fn9/DI;EACI;IACI,+BAAA;IACA,eAAA;IACA,+BAAA;E5Fs9/DV;AACF;;A4Fj9/DA;EACI,iBAAA;A5Fo9/DJ;;A4Fh9/DA;EACI,gBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,4BAAA;EACA,mBAAA;A5Fm9/DJ;;A4F/8/DA;EACI,yBAAA;A5Fk9/DJ;A4Fj9/DI;EACI,cjFhIG;AXmlgEX;A4Fj9/DI;EACI,yBAAA;A5Fm9/DR;A4Fl9/DQ;EACI,cjFxGC;AX4jgEb;A4Fl9/DY;EACI,gBAAA;A5Fo9/DhB;;A4F98/DA;EACI,kCAAA;A5Fi9/DJ;;A4F98/DA;EACI,iCAAA;A5Fi9/DJ;;A4F78/DI;EACI,kDAAA;A5Fg9/DR;;A4F38/DA;EACI,eAAA;EACA,aAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;A5F88/DJ;A4F78/DI;EACI,uCAAA;A5F+8/DR;;A4F38/DA;EACE;IACE,wBAAA;IACA,UAAA;E5F88/DF;E4F38/DA;IACE,4BAAA;IACA,UAAA;E5F68/DF;AACF;A4F18/DA;EACI,eAAA;A5F48/DJ;;A6F9xgEA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,0CAAA;EACA,aAAA;A7FiygEJ;;A6F9xgEA;EACI,UAAA;EACA,kBAAA;A7FiygEJ;;A6F9xgEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;A7FiygEJ;;A8FlzgEI;;;;EACI,gBAAA;A9FwzgER;;A+F5zgEI;EACI,+CAAA;EACA,iBAAA;A/F+zgER;A+F7zgEQ;EACI,iBAAA;A/F+zgEZ;;A+FxzgEA,aAAA;AAEA;EACI,gBAAA;A/F0zgEJ;A+FxzgEI;EACI,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,8BAAA;A/F0zgER;A+FxzgEQ;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBpFoHD;AXssgEX;A+FvzgEQ;EACI,yBAAA;A/FyzgEZ;;A+FnzgEA;EACI,kBAAA;A/FszgEJ;A+FpzgEI;EACI,gBAAA;EACA,kBAAA;A/FszgER;A+FpzgEQ;EAEI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,yCAAA;EACA,SAAA;EACA,wBAAA;EACA,SAAA;EACA,oBAAA;A/FqzgEZ;A+FlzgEQ;EACI,UAAA;EACA,UAAA;EACA,oBAAA;A/FozgEZ;A+F9ygEY;EACI,UAAA;A/FgzgEhB;A+F7ygEY;EACI,UAAA;A/F+ygEhB;;A+FtygEQ;EACI,yBpFkGC;AXusgEb;;A+FpygEA;EACI,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,0CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;A/FuygEJ;;A+FjygEQ;EACI,aAAA;A/FoygEZ;A+FjygEQ;EACI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,wCAAA;EACA,oBAAA;EACA,iBAAA;EACA,cpF2DC;AXwugEb;A+FhygEQ;EACI,yBpFuDC;EoFtDD,qBpFsDC;EoFrDD,WpFuBD;AX2wgEX;;AgGh6gEA;EACI,iBAAA;EACA,oBAAA;AhGm6gEJ;AgGj6gEI;EACI,mBAAA;EACA,gBAAA;AhGm6gER;;AgG95gEA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;AhGi6gEJ;;AgG75gEI;EACI,4BAAA;AhGg6gER;;AgG35gEA;EACI,yBAAA;AhG85gEJ;AgG55gEI;EACI,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,sBAAA;AhG85gER;AgG35gEI;EACI,kBAAA;EACA,oBAAA;EACA,YAAA;AhG65gER;AgG15gEI;EACI,gBAAA;AhG45gER;AgGz5gEY;EACI,crFiIH;EqFhIG,qBAAA;AhG25gEhB;;AgGl5gEI;EACI,yBrFyFG;EqFxFH,gBAAA;EACA,iBAAA;EACA,gBrF4Da;EqF3Db,kBAAA;AhGq5gER;;AgG74gEQ;EACI,aAAA;AhGg5gEZ;AgG74gEY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,wCAAA;AhG+4gEhB;AgG74gEY;EACI,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,4CAAA;EACA,eAAA;EACA,WrFuDL;AXw1gEX;;AgGv4gEI;EACI,gCAAA;AhG04gER;AgGz4gEQ;EACI,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,crFoEC;AXu0gEb;;AgGp4gEQ;EACI,gCAAA;AhGu4gEZ;AgGr4gEQ;EACI,2DAAA;AhGu4gEZ;AgGp4gEQ;EACI,0DAAA;AhGs4gEZ;AgGl4gEY;EACI,qDAAA;AhGo4gEhB;;AiGvghEA;EACI;;;;;;;IAOI,wBAAA;EjG0ghEN;EiGxghEE;;;;;IAKI,UAAA;IACA,SAAA;EjG0ghEN;EiGvghEE;IACI,SAAA;IACA,2BAAA;EjGyghEN;EiGrghEM;IACI,wBAAA;EjGughEV;EiGnghEM;IACI,yBAAA;IACA,qBAAA;IACA,0BAAA;EjGqghEV;AACF;AkGxihEA;EACI,kBAAA;AlG0ihEJ;AkGxihEI;EACI,iBAAA;EACA,+CAAA;EACA,WvFgJG;EuF/IH,oBvF8qBsB;EuF7qBtB,gBvForBsB;EuFnrBtB,kBAAA;EACA,UAAA;EACA,QAAA;AlG0ihER;AkGxihEQ;EACI,4BAAA;AlG0ihEZ;AkGvihEQ;EACI,qBAAA;AlGyihEZ;AkGvihEY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,8BAAA;AlGyihEhB;AkGtihEY;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,8BAAA;AlGwihEhB;AkGhihEQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,SAAA;AlGkihEZ;AkG5hhEI;EACI,gBAAA;AlG8hhER;AkG5hhEQ;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;AlG8hhEZ;AkG3hhEY;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AlG6hhEhB;AkGthhEQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AlGwhhEZ;AkGthhEY;EACI,4BAAA;AlGwhhEhB;AkGrhhEY;EACI,iBAAA;AlGuhhEhB;AkGrhhEgB;EAEI,WAAA;EACA,WAAA;EACA,8BAAA;AlGshhEpB;AkGhhhEY;EACI,UAAA;EACA,WAAA;AlGkhhEhB;AkG9ghEQ;EACI,WAAA;EACA,UAAA;AlGghhEZ;AkG5ghEY;EACI,wBAAA;EACA,YAAA;EACA,UAAA;AlG8ghEhB;AkGzghEY;EACI,UAAA;EACA,WAAA;AlG2ghEhB;AkGzghEgB;EACI,UAAA;EACA,YAAA;EACA,wBAAA;AlG2ghEpB;AkGpghEI;EACI,WAAA;AlGsghER;AkGjghEQ;EACI,mBAAA;AlGmghEZ;AkGjghEY;EACI,sFAAA;AlGmghEhB;AkG//gEgB;EACI,0BAAA;EACA,yBAAA;AlGighEpB;AkG9/gEgB;EACI,0BAAA;EACA,4BAAA;AlGgghEpB;AkG1/gEY;EACI,mBAAA;AlG4/gEhB;AkGz/gEoB;EACI,2BAAA;EACA,yBAAA;AlG2/gExB;AkGx/gEoB;EACI,2BAAA;EACA,4BAAA;AlG0/gExB;AkG1hhEQ;EACI,mBAAA;AlG4hhEZ;AkG1hhEY;EACI,4DAAA;AlG4hhEhB;AkGxhhEgB;EACI,0BAAA;EACA,yBAAA;AlG0hhEpB;AkGvhhEgB;EACI,0BAAA;EACA,4BAAA;AlGyhhEpB;AkGnhhEY;EACI,mBAAA;AlGqhhEhB;AkGlhhEoB;EACI,2BAAA;EACA,yBAAA;AlGohhExB;AkGjhhEoB;EACI,2BAAA;EACA,4BAAA;AlGmhhExB;AkGnjhEQ;EACI,mBAAA;AlGqjhEZ;AkGnjhEY;EACI,uFAAA;AlGqjhEhB;AkGjjhEgB;EACI,0BAAA;EACA,yBAAA;AlGmjhEpB;AkGhjhEgB;EACI,0BAAA;EACA,4BAAA;AlGkjhEpB;AkG5ihEY;EACI,mBAAA;AlG8ihEhB;AkG3ihEoB;EACI,2BAAA;EACA,yBAAA;AlG6ihExB;AkG1ihEoB;EACI,2BAAA;EACA,4BAAA;AlG4ihExB;AkG5khEQ;EACI,mBAAA;AlG8khEZ;AkG5khEY;EACI,mEAAA;AlG8khEhB;AkG1khEgB;EACI,0BAAA;EACA,yBAAA;AlG4khEpB;AkGzkhEgB;EACI,0BAAA;EACA,4BAAA;AlG2khEpB;AkGrkhEY;EACI,mBAAA;AlGukhEhB;AkGpkhEoB;EACI,2BAAA;EACA,yBAAA;AlGskhExB;AkGnkhEoB;EACI,2BAAA;EACA,4BAAA;AlGqkhExB;AkGrmhEQ;EACI,mBAAA;AlGumhEZ;AkGrmhEY;EACI,sFAAA;AlGumhEhB;AkGnmhEgB;EACI,0BAAA;EACA,yBAAA;AlGqmhEpB;AkGlmhEgB;EACI,0BAAA;EACA,4BAAA;AlGomhEpB;AkG9lhEY;EACI,mBAAA;AlGgmhEhB;AkG7lhEoB;EACI,2BAAA;EACA,yBAAA;AlG+lhExB;AkG5lhEoB;EACI,2BAAA;EACA,4BAAA;AlG8lhExB;AkG9nhEQ;EACI,mBAAA;AlGgohEZ;AkG9nhEY;EACI,uFAAA;AlGgohEhB;AkG5nhEgB;EACI,0BAAA;EACA,yBAAA;AlG8nhEpB;AkG3nhEgB;EACI,0BAAA;EACA,4BAAA;AlG6nhEpB;AkGvnhEY;EACI,mBAAA;AlGynhEhB;AkGtnhEoB;EACI,2BAAA;EACA,yBAAA;AlGwnhExB;AkGrnhEoB;EACI,2BAAA;EACA,4BAAA;AlGunhExB;AkGvphEQ;EACI,mBAAA;AlGyphEZ;AkGvphEY;EACI,0DAAA;AlGyphEhB;AkGrphEgB;EACI,0BAAA;EACA,yBAAA;AlGuphEpB;AkGpphEgB;EACI,0BAAA;EACA,4BAAA;AlGsphEpB;AkGhphEY;EACI,mBAAA;AlGkphEhB;AkG/ohEoB;EACI,2BAAA;EACA,yBAAA;AlGiphExB;AkG9ohEoB;EACI,2BAAA;EACA,4BAAA;AlGgphExB;AkGhrhEQ;EACI,mBAAA;AlGkrhEZ;AkGhrhEY;EACI,6EAAA;AlGkrhEhB;AkG9qhEgB;EACI,0BAAA;EACA,yBAAA;AlGgrhEpB;AkG7qhEgB;EACI,0BAAA;EACA,4BAAA;AlG+qhEpB;AkGzqhEY;EACI,mBAAA;AlG2qhEhB;AkGxqhEoB;EACI,2BAAA;EACA,yBAAA;AlG0qhExB;AkGvqhEoB;EACI,2BAAA;EACA,4BAAA;AlGyqhExB;AkG/phEI;EACI,gBAAA;EACA,UAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AlGiqhER;AkGh2hEA;EAmMI,eAAA;AlGgqhEJ;AkG/phEI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AlGiqhER;AkG/phEQ;EACI,eAAA;EACA,WvF1DD;EuF2DC,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;EACA,wEAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBvFkekB;AX+rgE9B;AkG/phEY;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,mCAAA;EACA,oCAAA;AlGiqhEhB;AkG9phEY;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,kCAAA;EACA,oCAAA;AlGgqhEhB;AkGvphEY;EACI,mBAAA;AlGyphEhB;AkGvphEgB;EACI,sEAAA;EACA,qEAAA;AlGyphEpB;AkGtphEgB;EACI,uEAAA;EACA,qEAAA;AlGwphEpB;AkGlqhEY;EACI,mBAAA;AlGoqhEhB;AkGlqhEgB;EACI,wEAAA;EACA,uEAAA;AlGoqhEpB;AkGjqhEgB;EACI,yEAAA;EACA,uEAAA;AlGmqhEpB;AkG7qhEY;EACI,mBAAA;AlG+qhEhB;AkG7qhEgB;EACI,uEAAA;EACA,sEAAA;AlG+qhEpB;AkG5qhEgB;EACI,wEAAA;EACA,sEAAA;AlG8qhEpB;AkGxrhEY;EACI,mBAAA;AlG0rhEhB;AkGxrhEgB;EACI,oDAAA;EACA,mDAAA;AlG0rhEpB;AkGvrhEgB;EACI,qDAAA;EACA,mDAAA;AlGyrhEpB;AkGnshEY;EACI,mBAAA;AlGqshEhB;AkGnshEgB;EACI,yEAAA;EACA,wEAAA;AlGqshEpB;AkGlshEgB;EACI,0EAAA;EACA,wEAAA;AlGoshEpB;AkG9shEY;EACI,mBAAA;AlGgthEhB;AkG9shEgB;EACI,wEAAA;EACA,uEAAA;AlGgthEpB;AkG7shEgB;EACI,yEAAA;EACA,uEAAA;AlG+shEpB;AkGzthEY;EACI,mBAAA;AlG2thEhB;AkGzthEgB;EACI,8CAAA;EACA,6CAAA;AlG2thEpB;AkGxthEgB;EACI,+CAAA;EACA,6CAAA;AlG0thEpB;AkGpuhEY;EACI,mBAAA;AlGsuhEhB;AkGpuhEgB;EACI,4BAAA;EACA,2BAAA;AlGsuhEpB;AkGnuhEgB;EACI,6BAAA;EACA,2BAAA;AlGquhEpB;;AkG1thEQ;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;AlG6thEZ;;AkGxthEA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;AlG2thEJ;AkGzthEI;EACI,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WvFvIG;EuFwIH,eAAA;EACA,cAAA;EACA,sBAAA;EACA,4BAAA;EACA,WAAA;AlG2thER;AkGzthEQ;EAEI,kBAAA;EACA,WAAA;AlG0thEZ;AkGvthEQ;EACI,WAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;AlGythEZ;AkGtthEQ;EACI,WAAA;EACA,UAAA;EACA,UAAA;EACA,MAAA;EACA,0BAAA;AlGwthEZ;AkGpthEI;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mCAAA;EACA,oCAAA;EACA,sBAAA;AlGsthER;;AkG9shEQ;EACI,mBAAA;AlGithEZ;AkG/shEY;EACI,mBAAA;AlGithEhB;AkG9shEY;EACI,4DAAA;AlGgthEhB;AkG5shEQ;EACI,yBAAA;AlG8shEZ;;AkG3thEQ;EACI,mBAAA;AlG8thEZ;AkG5thEY;EACI,mBAAA;AlG8thEhB;AkG3thEY;EACI,kCAAA;AlG6thEhB;AkGzthEQ;EACI,yBAAA;AlG2thEZ;;AkGxuhEQ;EACI,mBAAA;AlG2uhEZ;AkGzuhEY;EACI,mBAAA;AlG2uhEhB;AkGxuhEY;EACI,6DAAA;AlG0uhEhB;AkGtuhEQ;EACI,yBAAA;AlGwuhEZ;;AkGrvhEQ;EACI,mBAAA;AlGwvhEZ;AkGtvhEY;EACI,mBAAA;AlGwvhEhB;AkGrvhEY;EACI,yCAAA;AlGuvhEhB;AkGnvhEQ;EACI,yBAAA;AlGqvhEZ;;AkGlwhEQ;EACI,mBAAA;AlGqwhEZ;AkGnwhEY;EACI,mBAAA;AlGqwhEhB;AkGlwhEY;EACI,4DAAA;AlGowhEhB;AkGhwhEQ;EACI,yBAAA;AlGkwhEZ;;AkG/whEQ;EACI,mBAAA;AlGkxhEZ;AkGhxhEY;EACI,mBAAA;AlGkxhEhB;AkG/whEY;EACI,6DAAA;AlGixhEhB;AkG7whEQ;EACI,yBAAA;AlG+whEZ;;AkG5xhEQ;EACI,mBAAA;AlG+xhEZ;AkG7xhEY;EACI,mBAAA;AlG+xhEhB;AkG5xhEY;EACI,gCAAA;AlG8xhEhB;AkG1xhEQ;EACI,yBAAA;AlG4xhEZ;;AkGzyhEQ;EACI,mBAAA;AlG4yhEZ;AkG1yhEY;EACI,mBAAA;AlG4yhEhB;AkGzyhEY;EACI,mDAAA;AlG2yhEhB;AkGvyhEQ;EACI,yBAAA;AlGyyhEZ;;AkGlyhEI;EACI,4BAAA;EACA,yBAAA;AlGqyhER;AkGnyhEQ;EACI,yBAAA;EACA,UAAA;AlGqyhEZ;AkGhyhEQ;EACI,wBAAA;AlGkyhEZ;AkGhyhEY;EACI,UAAA;AlGkyhEhB;AkG7xhEQ;EACI,2BAAA;EACA,yBAAA;AlG+xhEZ;AkG7xhEY;EACI,yBAAA;EACA,UAAA;AlG+xhEhB;AkG1xhEY;EACI,wBAAA;AlG4xhEhB;AkG1xhEgB;EACI,UAAA;AlG4xhEpB;;AmGzpiEI;EACE,sBxF+8C8B;AX6s/DpC;;AmGvpiEI;EACI,cxFmNO;EwFlNP,gCAAA;AnG0piER;;AmG5piEI;EACI,cxFmNO;EwFlNP,gCAAA;AnG+piER;;AmGjqiEI;EACI,cxFmNO;EwFlNP,gCAAA;AnGoqiER;;AmGtqiEI;EACI,cxFmNO;EwFlNP,gCAAA;AnGyqiER;;AmG3qiEI;EACI,cxFmNO;EwFlNP,gCAAA;AnG8qiER;;AmGhriEI;EACI,cxFmNO;EwFlNP,gCAAA;AnGmriER;;AmGrriEI;EACI,cxFmNO;EwFlNP,gCAAA;AnGwriER;;AmG1riEI;EACI,cxFmNO;EwFlNP,gCAAA;AnG6riER;;AoGvsiEA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;ApG0siEF;;AoGvsiEA;EACE,kBAAA;EACA,aAAA;EACA,cAAA;ApG0siEF;;AqGrtiEA;EACI,kBAAA;EACA,gBAAA;ArGwtiEJ;;AqGrtiEA;;;;;;;;;;;;EAYI,8B1F+GY;E0F9GZ,oC1FT8C;AXiuiElD;;AqGrtiEA;EACI,gCAAA;ArGwtiEJ;;AqGrtiEA;EACI,gB1FmGiB;E0FlGjB,qB1Fq5BoC;AXm0gExC;;AqGttiEA;;EAEE,gB1F6pB4B;AX4jhE9B;;AqGptiEA;EACI,kBAAA;EACA,yCAAA;ArGutiEJ;;AqGptiEA;EACI,cAAA;EACA,0CAAA;EACA,iBAAA;ArGutiEJ;;AqG5siEI;EANJ;;;;;;IAOQ,iBAAA;ErGqtiEN;AACF;;AqGjtiEA;EACI,kBAAA;ArGotiEJ;;AsG/wiEI;EACI,W3FkJG;AXgoiEX;;AsG5wiEA;EACI,0CAAA;EACA,iBAAA;AtG+wiEJ;;AsG1wiEA;EACI,eAAA;AtG6wiEJ;;AsGxwiEA;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;AtG2wiEJ;AsGzwiEI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,2CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AtG2wiER;AsGvwiEI;EACI,gBAAA;AtGywiER;AsGvwiEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,0B3FmIH;E2FlIG,YAAA;AtGywiEhB;;AsGhwiEA;EACI,sBAAA;AtGmwiEJ;;AsG9viEA;EACI,0CAAA;EACA,oC3FojB0B;E2FnjB1B,qBAAA;EACA,2BAAA;AtGiwiEJ;;AsG5viEA;EACI,UAAA;AtG+viEJ;AsG7viEI;EACI,oBAAA;AtG+viER;AsG7viEI;EACI,oBAAA;EACA,kC3FyiBsB;E2FxiBtB,mC3FwiBsB;E2FviBtB,wBAAA;AtG+viER;;AsGxviEI;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;EACA,4BAAA;AtG2viER;;AsGlviEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtGqviEZ;;AsG/uiEQ;EACI,c3FyGG;AXyoiEf;;AsG5uiEQ;EACI,0B3FkGG;AX6oiEf;;AsGzuiEQ;EACI,yB3F2FG;AXipiEf;;AsGnuiEY;EACI,yB3FiFD;E2FhFC,WAAA;AtGsuiEhB;;AsG7tiEY;EACI,WAAA;EACA,yB3FqED;AX2piEf;AsG/tiEgB;EACI,qCAAA;AtGiuiEpB;;AsGztiEY;EACI,c3F0DD;AXkqiEf;;AsGntiEY;EACI,yB3FgDD;E2F/CC,WAAA;AtGstiEhB;;AsG1xiEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtG6xiEZ;;AsGvxiEQ;EACI,c3FyGG;AXiriEf;;AsGpxiEQ;EACI,0B3FkGG;AXqriEf;;AsGjxiEQ;EACI,yB3F2FG;AXyriEf;;AsG3wiEY;EACI,yB3FiFD;E2FhFC,WAAA;AtG8wiEhB;;AsGrwiEY;EACI,WAAA;EACA,yB3FqED;AXmsiEf;AsGvwiEgB;EACI,qCAAA;AtGywiEpB;;AsGjwiEY;EACI,c3F0DD;AX0siEf;;AsG3viEY;EACI,yB3FgDD;E2F/CC,WAAA;AtG8viEhB;;AsGl0iEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtGq0iEZ;;AsG/ziEQ;EACI,c3FyGG;AXytiEf;;AsG5ziEQ;EACI,0B3FkGG;AX6tiEf;;AsGzziEQ;EACI,yB3F2FG;AXiuiEf;;AsGnziEY;EACI,yB3FiFD;E2FhFC,WAAA;AtGsziEhB;;AsG7yiEY;EACI,WAAA;EACA,yB3FqED;AX2uiEf;AsG/yiEgB;EACI,qCAAA;AtGiziEpB;;AsGzyiEY;EACI,c3F0DD;AXkviEf;;AsGnyiEY;EACI,yB3FgDD;E2F/CC,WAAA;AtGsyiEhB;;AsG12iEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtG62iEZ;;AsGv2iEQ;EACI,c3FyGG;AXiwiEf;;AsGp2iEQ;EACI,0B3FkGG;AXqwiEf;;AsGj2iEQ;EACI,yB3F2FG;AXywiEf;;AsG31iEY;EACI,yB3FiFD;E2FhFC,WAAA;AtG81iEhB;;AsGr1iEY;EACI,WAAA;EACA,yB3FqED;AXmxiEf;AsGv1iEgB;EACI,qCAAA;AtGy1iEpB;;AsGj1iEY;EACI,c3F0DD;AX0xiEf;;AsG30iEY;EACI,yB3FgDD;E2F/CC,WAAA;AtG80iEhB;;AsGl5iEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtGq5iEZ;;AsG/4iEQ;EACI,c3FyGG;AXyyiEf;;AsG54iEQ;EACI,0B3FkGG;AX6yiEf;;AsGz4iEQ;EACI,yB3F2FG;AXiziEf;;AsGn4iEY;EACI,yB3FiFD;E2FhFC,WAAA;AtGs4iEhB;;AsG73iEY;EACI,WAAA;EACA,yB3FqED;AX2ziEf;AsG/3iEgB;EACI,qCAAA;AtGi4iEpB;;AsGz3iEY;EACI,c3F0DD;AXk0iEf;;AsGn3iEY;EACI,yB3FgDD;E2F/CC,WAAA;AtGs3iEhB;;AsG17iEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtG67iEZ;;AsGv7iEQ;EACI,c3FyGG;AXi1iEf;;AsGp7iEQ;EACI,0B3FkGG;AXq1iEf;;AsGj7iEQ;EACI,yB3F2FG;AXy1iEf;;AsG36iEY;EACI,yB3FiFD;E2FhFC,WAAA;AtG86iEhB;;AsGr6iEY;EACI,WAAA;EACA,yB3FqED;AXm2iEf;AsGv6iEgB;EACI,qCAAA;AtGy6iEpB;;AsGj6iEY;EACI,c3F0DD;AX02iEf;;AsG35iEY;EACI,yB3FgDD;E2F/CC,WAAA;AtG85iEhB;;AsGl+iEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtGq+iEZ;;AsG/9iEQ;EACI,c3FyGG;AXy3iEf;;AsG59iEQ;EACI,0B3FkGG;AX63iEf;;AsGz9iEQ;EACI,yB3F2FG;AXi4iEf;;AsGn9iEY;EACI,yB3FiFD;E2FhFC,WAAA;AtGs9iEhB;;AsG78iEY;EACI,WAAA;EACA,yB3FqED;AX24iEf;AsG/8iEgB;EACI,qCAAA;AtGi9iEpB;;AsGz8iEY;EACI,c3F0DD;AXk5iEf;;AsGn8iEY;EACI,yB3FgDD;E2F/CC,WAAA;AtGs8iEhB;;AsG1gjEQ;EACI,yB3FkHG;E2FjHH,qB3FiHG;E2FhHH,WAAA;AtG6gjEZ;;AsGvgjEQ;EACI,c3FyGG;AXi6iEf;;AsGpgjEQ;EACI,0B3FkGG;AXq6iEf;;AsGjgjEQ;EACI,yB3F2FG;AXy6iEf;;AsG3/iEY;EACI,yB3FiFD;E2FhFC,WAAA;AtG8/iEhB;;AsGr/iEY;EACI,WAAA;EACA,yB3FqED;AXm7iEf;AsGv/iEgB;EACI,qCAAA;AtGy/iEpB;;AsGj/iEY;EACI,c3F0DD;AX07iEf;;AsG3+iEY;EACI,yB3FgDD;E2F/CC,WAAA;AtG8+iEhB;;AsGx+iEI;EACI,kCAAA;AtG2+iER;AsG1+iEQ;EACI,kCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,+CAAA;AtG4+iEZ;;AsGv+iEA;EACI,qBAAA;AtG0+iEJ;;AuGxqjEI;EACI,oDAAA;AvG2qjER;;AuG5qjEI;EACI,qDAAA;AvG+qjER;;AuGhrjEI;EACI,qDAAA;AvGmrjER;;AuGprjEI;EACI,qDAAA;AvGurjER;;AuGxrjEI;EACI,qDAAA;AvG2rjER;;AuG5rjEI;EACI,qDAAA;AvG+rjER;;AuGhsjEI;EACI,sDAAA;AvGmsjER;;AuGpsjEI;EACI,mDAAA;AvGusjER;;AuGnsjEA;EACI,2DAAA;AvGssjEJ;;AuGnsjEA;EACI,4DAAA;AvGssjEJ;;AwGpsjEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxG8sjEJ;;AwG1sjEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGotjEJ;;AwGhtjEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxG0tjEJ;;AwGttjEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGgujEJ;;AwG5tjEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGsujEJ;;AwGlujEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxG4ujEJ;;AwGxujEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGkvjEJ;;AwG9ujEI;EANA,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGwvjEJ;;AwG7ujEA;EACI,0CAAA;EACA,iBAAA;AxGgvjEJ;;AwG5ujEI;EA1BA,c7F2NW;E6F1NX,wCAAA;AxG0wjEJ;;AwG5ujEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGwwjEJ;;AwG3ujEY;EACI,2B7FoLD;AX0jjEf;;AwG3vjEI;EA1BA,c7F2NW;E6F1NX,yCAAA;AxGyxjEJ;;AwG3vjEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGuxjEJ;;AwG1vjEY;EACI,2B7FoLD;AXykjEf;;AwG1wjEI;EA1BA,c7F2NW;E6F1NX,yCAAA;AxGwyjEJ;;AwG1wjEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGsyjEJ;;AwGzwjEY;EACI,2B7FoLD;AXwljEf;;AwGzxjEI;EA1BA,c7F2NW;E6F1NX,yCAAA;AxGuzjEJ;;AwGzxjEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGqzjEJ;;AwGxxjEY;EACI,2B7FoLD;AXumjEf;;AwGxyjEI;EA1BA,c7F2NW;E6F1NX,yCAAA;AxGs0jEJ;;AwGxyjEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGo0jEJ;;AwGvyjEY;EACI,2B7FoLD;AXsnjEf;;AwGvzjEI;EA1BA,c7F2NW;E6F1NX,yCAAA;AxGq1jEJ;;AwGvzjEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGm1jEJ;;AwGtzjEY;EACI,2B7FoLD;AXqojEf;;AwGt0jEI;EA1BA,c7F2NW;E6F1NX,0CAAA;AxGo2jEJ;;AwGt0jEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGk2jEJ;;AwGr0jEY;EACI,2B7FoLD;AXopjEf;;AwGr1jEI;EA1BA,c7F2NW;E6F1NX,uCAAA;AxGm3jEJ;;AwGr1jEQ;EAxBJ,c7FoNW;E6FnNX,yBAAA;EACA,6BAAA;AxGi3jEJ;;AwGp1jEY;EACI,2B7FoLD;AXmqjEf;;AwG/0jEA;EACI,sBAAA;AxGk1jEJ;;AwG70jEA;EACI,gBAAA;EACA,kBAAA;AxGg1jEJ;AwG/0jEI;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,2B7FsHK;E6FrHL,WAAA;EACA,MAAA;AxGi1jER;;AwGpzjEI;EACI,6DAXI;AxGk0jEZ;;AwGxzjEI;EACI,6DAXI;AxGs0jEZ;;AwG5zjEI;EACI,6DAXI;AxG00jEZ;;AwGh0jEI;EACI,6DAXI;AxG80jEZ;;AwGp0jEI;EACI,wGAXI;AxGk1jEZ;;AwGx0jEI;EACI,6DAXI;AxGs1jEZ;;AwG50jEI;EACI,6DAXI;AxG01jEZ;;AyG76jEA;;EAEI,wBAAA;EACA,kBAAA;AzGg7jEJ;;AyG76jEA;EACI,gB9FioB0B;AX+yiE9B;AyG/6jEI;EACI,yBAAA;AzGi7jER;;AyG56jEA;EACI,mBAAA;AzG+6jEJ;;AyG36jEA;EACI,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gCAAA;EACA,+BAAA;EACA,UAAA;AzG86jEJ;AyG56jEI;;;EAGI,sBAAA;AzG86jER;AyG36jEI;EACI,kCAAA;EACA,iCAAA;AzG66jER;AyG16jEI;EACI,kCAAA;EACA,iCAAA;AzG46jER;;AyGp5jEI;EAfA,c9F4KW;E8F3KX,wCAAA;EACA,yBAAA;AzGu6jEJ;AyGr6jEI;EAGI,W9F8FG;E8F7FH,yB9FoKO;E8FnKP,yBAAA;AzGq6jER;;AyG/5jEI;EAfA,c9F4KW;E8F3KX,yCAAA;EACA,yBAAA;AzGk7jEJ;AyGh7jEI;EAGI,W9F8FG;E8F7FH,yB9FoKO;E8FnKP,yBAAA;AzGg7jER;;AyG16jEI;EAfA,c9F4KW;E8F3KX,yCAAA;EACA,yBAAA;AzG67jEJ;AyG37jEI;EAGI,W9F8FG;E8F7FH,yB9FoKO;E8FnKP,yBAAA;AzG27jER;;AyGr7jEI;EAfA,c9F4KW;E8F3KX,yCAAA;EACA,yBAAA;AzGw8jEJ;AyGt8jEI;EAGI,W9F8FG;E8F7FH,yB9FoKO;E8FnKP,yBAAA;AzGs8jER;;AyGh8jEI;EAfA,c9F4KW;E8F3KX,yCAAA;EACA,yBAAA;AzGm9jEJ;AyGj9jEI;EAGI,W9F8FG;E8F7FH,yB9FoKO;E8FnKP,yBAAA;AzGi9jER;;AyG38jEI;EAfA,c9F4KW;E8F3KX,yCAAA;EACA,yBAAA;AzG89jEJ;AyG59jEI;EAGI,W9F8FG;E8F7FH,yB9FoKO;E8FnKP,yBAAA;AzG49jER;;AyGt9jEI;EAfA,c9F4KW;E8F3KX,0CAAA;EACA,yBAAA;AzGy+jEJ;AyGv+jEI;EAGI,W9F8FG;E8F7FH,yB9FoKO;E8FnKP,yBAAA;AzGu+jER;;AyGj+jEI;EAfA,c9F4KW;E8F3KX,uCAAA;EACA,yBAAA;AzGo/jEJ;AyGl/jEI;EAGI,W9F8FG;E8F7FH,yB9FoKO;E8FnKP,yBAAA;AzGk/jER;;AyGp9jEI;EAdA,c9FmJW;E8FlJX,yBAAA;AzGs+jEJ;AyGp+jEI;EAGI,c9F6IO;E8F5IP,wCAAA;EACA,yBAAA;AzGo+jER;;AyG99jEI;EAdA,c9FmJW;E8FlJX,yBAAA;AzGg/jEJ;AyG9+jEI;EAGI,c9F6IO;E8F5IP,yCAAA;EACA,yBAAA;AzG8+jER;;AyGx+jEI;EAdA,c9FmJW;E8FlJX,yBAAA;AzG0/jEJ;AyGx/jEI;EAGI,c9F6IO;E8F5IP,yCAAA;EACA,yBAAA;AzGw/jER;;AyGl/jEI;EAdA,c9FmJW;E8FlJX,yBAAA;AzGogkEJ;AyGlgkEI;EAGI,c9F6IO;E8F5IP,yCAAA;EACA,yBAAA;AzGkgkER;;AyG5/jEI;EAdA,c9FmJW;E8FlJX,yBAAA;AzG8gkEJ;AyG5gkEI;EAGI,c9F6IO;E8F5IP,yCAAA;EACA,yBAAA;AzG4gkER;;AyGtgkEI;EAdA,c9FmJW;E8FlJX,yBAAA;AzGwhkEJ;AyGthkEI;EAGI,c9F6IO;E8F5IP,yCAAA;EACA,yBAAA;AzGshkER;;AyGhhkEI;EAdA,c9FmJW;E8FlJX,yBAAA;AzGkikEJ;AyGhikEI;EAGI,c9F6IO;E8F5IP,0CAAA;EACA,yBAAA;AzGgikER;;AyG1hkEI;EAdA,c9FmJW;E8FlJX,yBAAA;AzG4ikEJ;AyG1ikEI;EAGI,c9F6IO;E8F5IP,uCAAA;EACA,yBAAA;AzG0ikER;;AyG/hkEA;EACI,yBAAA;AzGkikEJ;;AyG9hkEA;EACI,kBAAA;EACA,kBAAA;AzGiikEJ;AyG/hkEI;EACI,kBAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,0CAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AzGiikER;AyG7hkEQ;EACI,wCAAA;AzG+hkEZ;AyG3hkEI;EACI,oB9FiuBsB;E8FhuBtB,mBAAA;AzG6hkER;AyG3hkEQ;EACI,WAAA;EACA,UAAA;AzG6hkEZ;;AyGthkEA;EACI,gBAAA;EACA,oDAAA;EACA,wDAAA;AzGyhkEJ;AyGvhkEI;EACI,wBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,iCAAA;EACA,sBAAA;EACA,wCAAA;EACA,wDAAA;AzGyhkER;AyGthkEI;EACI,cAAA;EACA,wCAAA;EACA,wDAAA;AzGwhkER;AyGphkEQ;EACI,UAAA;EACA,+BAAA;AzGshkEZ;AyGnhkEQ;EACI,UAAA;EACA,kCAAA;AzGqhkEZ;;AyG9gkEI;EACI,yB9F8CO;E8F7CP,qB9F6CO;AXo+jEf;AyG/gkEQ;EAGI,c9FwCG;E8FvCH,wCAAA;AzG+gkEZ;;AyGvhkEI;EACI,yB9F8CO;E8F7CP,qB9F6CO;AX6+jEf;AyGxhkEQ;EAGI,c9FwCG;E8FvCH,yCAAA;AzGwhkEZ;;AyGhikEI;EACI,yB9F8CO;E8F7CP,qB9F6CO;AXs/jEf;AyGjikEQ;EAGI,c9FwCG;E8FvCH,yCAAA;AzGiikEZ;;AyGzikEI;EACI,yB9F8CO;E8F7CP,qB9F6CO;AX+/jEf;AyG1ikEQ;EAGI,c9FwCG;E8FvCH,yCAAA;AzG0ikEZ;;AyGljkEI;EACI,yB9F8CO;E8F7CP,qB9F6CO;AXwgkEf;AyGnjkEQ;EAGI,c9FwCG;E8FvCH,yCAAA;AzGmjkEZ;;AyG3jkEI;EACI,yB9F8CO;E8F7CP,qB9F6CO;AXihkEf;AyG5jkEQ;EAGI,c9FwCG;E8FvCH,yCAAA;AzG4jkEZ;;AyGpkkEI;EACI,yB9F8CO;E8F7CP,qB9F6CO;AX0hkEf;AyGrkkEQ;EAGI,c9FwCG;E8FvCH,0CAAA;AzGqkkEZ;;AyG7kkEI;EACI,yB9F8CO;E8F7CP,qB9F6CO;AXmikEf;AyG9kkEQ;EAGI,c9FwCG;E8FvCH,uCAAA;AzG8kkEZ;;AyGhkkEI;EACI,gBAAA;AzGmkkER;;AyG7jkEI;EACI,YAAA;AzGgkkER;AyG7jkEI;;;;;EAKI,yCAAA;EACA,c9FzBK;AXwlkEb;;AyGxjkEI;;;;EAII,qBAAA;EACA,iDAAA;EACA,6CAAA;AzG2jkER;AyGxjkEI;;;;;;;;;;;;;;;EAeI,qBAAA;EACA,iDAAA;EACA,6CAAA;AzG0jkER;AyGvjkEI;;;;EAII,sBAAA;EACA,gDAAA;EACA,4CAAA;AzGyjkER;AyGtjkEI;;;;;;;;;;;;;;;EAeI,sBAAA;EACA,gDAAA;EACA,4CAAA;AzGwjkER;AyGnjkEI;EACI,qBAAA;EACA,gDAAA;AzGqjkER;AyGnjkEQ;EACI,qBAAA;EACA,iCAAA;AzGqjkEZ;AyGjjkEI;EACI,qBAAA;EACA,+CAAA;AzGmjkER;AyGjjkEQ;EACI,sBAAA;EACA,gCAAA;AzGmjkEZ;AyG9ikEI;EACI,qBAAA;AzGgjkER;AyG9ikEQ;EAGI,qBAAA;EACA,gDAAA;AzG8ikEZ;AyG1ikEI;EACI,qBAAA;AzG4ikER;AyG1ikEQ;EAGI,qBAAA;EACA,+CAAA;AzG0ikEZ;;AyGnikEI;;EAEI,YAAA;EACA,WAAA;AzGsikER;;AyG3hkEQ;;;EACI,0EAAA;AzGgikEZ;;AyGjikEQ;;;EACI,0EAAA;AzGsikEZ;;AyGvikEQ;;;EACI,0EAAA;AzG4ikEZ;;AyG7ikEQ;;;EACI,yDAAA;AzGkjkEZ;;AyGnjkEQ;;;EACI,2EAAA;AzGwjkEZ;;AyGzjkEQ;;;EACI,0EAAA;AzG8jkEZ;;AyG/jkEQ;;;EACI,iDAAA;AzGokkEZ;;AyGrkkEQ;;;EACI,gEAAA;AzG0kkEZ;;AyGnkkEI;EACI,aAAA;AzGskkER;AyGlkkEQ;EACI,aAAA;AzGokkEZ;AyGjkkEQ;EACI,cAAA;AzGmkkEZ;;A0Gt6kEI;EACI,yBAAA;A1Gy6kER;A0Gt6kEQ;EACI,oCAAA;EACA,eAAA;A1Gw6kEZ;;A2Gj7kEA;EACI,qBhG4lB0B;EgG3lB1B,4ChGkoB0B;AXkzjE9B;;A2Gj7kEA;EACI,+CAAA;A3Go7kEJ;;A2G/6kEI;EACI,eAAA;A3Gk7kER;;A2G96kEA;EACI,4CAAA;A3Gi7kEJ;;A2G96kEA;EACI,chG0IO;AXuykEX;;A2G96kEA;EACI,eAAA;EACA,iBAAA;A3Gi7kEJ;;A2G96kEA;EACI,mBAAA;A3Gi7kEJ;;A2G96kEA;EACI,2BAAA;A3Gi7kEJ;;A2G96kEA;EACI,oBAAA;A3Gi7kEJ;A2G/6kEI;EACI,wCAAA;EACA,6ChG4lBsB;AXq1jE9B;;A2Gn6kEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXmwkEf;A2Gr6kEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3Gu6kEZ;A2Gp6kEQ;EACI,WhGoFD;AXk1kEX;;A2Gh7kEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXgxkEf;A2Gl7kEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3Go7kEZ;A2Gj7kEQ;EACI,WhGoFD;AX+1kEX;;A2G77kEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AX6xkEf;A2G/7kEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3Gi8kEZ;A2G97kEQ;EACI,WhGoFD;AX42kEX;;A2G18kEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AX0ykEf;A2G58kEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3G88kEZ;A2G38kEQ;EACI,WhGoFD;AXy3kEX;;A2Gv9kEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXuzkEf;A2Gz9kEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3G29kEZ;A2Gx9kEQ;EACI,WhGoFD;AXs4kEX;;A2Gp+kEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXo0kEf;A2Gt+kEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3Gw+kEZ;A2Gr+kEQ;EACI,WhGoFD;AXm5kEX;;A2Gj/kEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AXi1kEf;A2Gn/kEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3Gq/kEZ;A2Gl/kEQ;EACI,WhGoFD;AXg6kEX;;A2G9/kEI;EANA,WhGoGO;EgGnGP,yBhG0KW;AX81kEf;A2GhglEQ;EACI,0CAAA;EACA,WhGyFD;EgGxFC,yBAAA;A3GkglEZ;A2G//kEQ;EACI,WhGoFD;AX66kEX;;A2G1/kEI;EACI,gCAAA;A3G6/kER;A2G5/kEQ;EACI,qBhGiJG;AX62kEf;;A2GjglEI;EACI,gCAAA;A3GoglER;A2GnglEQ;EACI,qBhGiJG;AXo3kEf;;A2GxglEI;EACI,gCAAA;A3G2glER;A2G1glEQ;EACI,qBhGiJG;AX23kEf;;A2G/glEI;EACI,gCAAA;A3GkhlER;A2GjhlEQ;EACI,qBhGiJG;AXk4kEf;;A2GthlEI;EACI,gCAAA;A3GyhlER;A2GxhlEQ;EACI,qBhGiJG;AXy4kEf;;A2G7hlEI;EACI,gCAAA;A3GgilER;A2G/hlEQ;EACI,qBhGiJG;AXg5kEf;;A2GpilEI;EACI,gCAAA;A3GuilER;A2GtilEQ;EACI,qBhGiJG;AXu5kEf;;A2G3ilEI;EACI,gCAAA;A3G8ilER;A2G7ilEQ;EACI,qBhGiJG;AX85kEf;;A2GzilEA;EACI,iCAAA;A3G4ilEJ;A2G3ilEI;EACI,sCAAA;EACA,+CAAA;A3G6ilER;A2G3ilEI;EACI,sCAAA;A3G6ilER;;A2GzilEA;EACI,gBAAA;A3G4ilEJ;;A2GtilEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gDAAA;EACA,aAAA;A3GyilEJ;;A2GtilEA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2CAAA;A3GyilEJ;;A2GtilEA;EACI,kCAAA;A3GyilEJ;;A2GtilEA;EACC;IAAK,yBAAA;E3G0ilEJ;AACF;A2GxilEA;EACI,kBAAA;EACA,gBAAA;A3G0ilEJ;A2GzilEI;EACI,WAAA;EACA,wCAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;A3G2ilER;A2GzilEI;EACI,kDAAA;A3G2ilER;;A2GvilEA;EACI,gBAAA;A3G0ilEJ;A2GzilEI;EACI,eAAA;A3G2ilER;A2GxilEQ;EACI,aAAA;A3G0ilEZ;A2GxilEQ;EACI,cAAA;A3G0ilEZ;A2GvilEY;EACI,cAAA;A3GyilEhB;A2GvilEY;EACI,aAAA;A3GyilEhB;;A4G1slEA;EACI,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,oCAAA;A5G6slEJ;;A4G1slEA;EACI,6CjG4nB0B;EiG3nB1B,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;A5G6slEJ;A4G3slEI;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;A5G6slER;A4G1slEI;EACI,iCAAA;A5G4slER;;A4GxslEA;EACI;IACI,gBAAA;E5G2slEN;E4GxslEE;IACI,eAAA;E5G0slEN;AACF;A4GvslEA;EACI;IACI,gBAAA;E5GyslEN;E4GtslEE;IACI,kBAAA;E5GwslEN;AACF;A4GrslEA;EACI;IACI,YAAA;E5GuslEN;E4GpslEE;IACI,YAAA;E5GsslEN;E4GnslEE;IACI,YAAA;E5GqslEN;AACF;A4GlslEA;EACI,iBAAA;A5GoslEJ;A4GnslEI;EACI,gBAAA;A5GqslER;A4GlslEI;EACI,WAAA;EACA,kBAAA;EACA,2CAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,OAAA;EACA,kCAAA;A5GoslER;;A4G9rlEA;EACI,2BAAA;A5GislEJ;;A4G1rlEA;EACI,YAAA;A5G6rlEJ;;A4G1rlEA;EACI,YAAA;A5G6rlEJ;;A4GzrlEI;EACI,kBAAA;A5G4rlER;A4GzrlEI;EACI,oBAAA;A5G2rlER;;A4GtrlEI;EACI,SAAA;A5GyrlER;A4GxrlEQ;EACI,+BAAA;A5G0rlEZ;A4GzrlEY;EACI,uCAAA;A5G2rlEhB;A4GzrlEY;EACI,WjGiCL;AX0plEX;;A4GjrlEQ;EACE,yCAAA;EACA,cjG4FK;AXwllEf;;A4GtrlEQ;EACE,0CAAA;EACA,cjG4FK;AX6llEf;;A4G3rlEQ;EACE,0CAAA;EACA,cjG4FK;AXkmlEf;;A4GhslEQ;EACE,0CAAA;EACA,cjG4FK;AXumlEf;;A4GrslEQ;EACE,0CAAA;EACA,cjG4FK;AX4mlEf;;A4G1slEQ;EACE,0CAAA;EACA,cjG4FK;AXinlEf;;A4G/slEQ;EACE,2CAAA;EACA,cjG4FK;AXsnlEf;;A4GptlEQ;EACE,wCAAA;EACA,cjG4FK;AX2nlEf;;A6Gr1lEQ;;EACI,yBAAA;EACA,gBlGwHS;AXiulErB;;A6Gn1lEI;EACI,yBAAA;EACA,gBlGgHa;AXsulErB;;A6Gh1lEI;;EAEI,gBlGmnBsB;AXgukE9B;;A6G/0lEA;EACI,2CAAA;A7Gk1lEJ;A6Gh1lEI;EACI,kBAAA;A7Gk1lER;A6Gh1lEQ;EACI,YAAA;EACA,gBlG4FS;AXsvlErB;A6Gh1lEY;EACI,WAAA;EACA,mBlG+IH;EkG9IG,WAAA;EACA,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,6BAAA;EACA,mBAAA;A7Gk1lEhB;A6G/0lEY;EACI,clGoIH;AX6slEb;A6G/0lEgB;EACI,mBAAA;A7Gi1lEpB;A6G30lEI;EACI,iBAAA;A7G60lER;A6G30lEQ;EACI,kBAAA;A7G60lEZ;;A6Gp0lEQ;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;A7Gu0lEZ;A6Gr0lEY;EACI,eAAA;A7Gu0lEhB;;A6G9zlEQ;EACI,yBlGmED;EkGlEC,aAAA;A7Gi0lEZ;;A6GxzlEQ;EACI,kBAAA;EACA,kBAAA;A7G2zlEZ;A6GzzlEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;ElF9FV,uGkF+FU;A7G2zlEhB;A2Bt5lEM;EkFoFM;IlFnFJ,gBAAA;E3By5lEN;AACF;A6G5zlEgB;EACI,yBlGoEP;AX0vlEb;;A6GrzlEI;EACI,kBAAA;EACA,gBAAA;A7GwzlER;A6GtzlEQ;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;A7GwzlEZ;A6GtzlEY;EACI,eAAA;A7GwzlEhB;A6GrzlEY;EACI,eAAA;A7GuzlEhB;A6GnzlEgB;EACI,WlGST;AX4ylEX;A6GjzlEY;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,oBAAA;A7GmzlEhB;A6GjzlEgB;EACI,QAAA;EACA,2BAAA;A7GmzlEpB;A6GhzlEgB;EACI,aAAA;A7GkzlEpB;A6G7ylEgB;EACI,WAAA;EACA,0BAAA;A7G+ylEpB;A6G5ylEgB;EACI,UAAA;A7G8ylEpB;;A6GpylEI;EACI,iCAAA;EACA,eAAA;EACA,kBAAA;A7GuylER;A6GrylEQ;EACI;IACI,WAAA;IACA,kBAAA;IACA,YAAA;IACA,QAAA;IACA,2BAAA;IACA,8BAAA;IACA,8BAAA;IACA,uCAAA;E7GuylEd;E6GnylEc;IACI,0BlGjBP;EXszlEX;AACF;;A6G7xlEI;EACI,kBAAA;A7GgylER;A6G9xlEQ;EACI,2BAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;A7GgylEZ;A6G9xlEY;EACI,kBAAA;A7GgylEhB;A6G7xlEY;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,QAAA;EACA,YAAA;EACA,6DAAA;EACA,yBlGjDH;EkGkDG,WAAA;A7G+xlEhB;A6G5xlEY;EAEI,WlGrFL;EkGsFK,wCAAA;A7G6xlEhB;A6G3xlEgB;EACI,WAAA;EACA,OAAA;A7G6xlEpB;;A6GrxlEI;EACI,iCAAA;A7GwxlER;A6GtxlEQ;EACI,yBlGxEC;AXg2lEb;;A6G/wlEY;EACI,clGzCD;EkG0CC,yBlG1CD;AX4zlEf;;A6GpxlEY;EACI,clGzCD;EkG0CC,yBlG1CD;AXi0lEf;;A6GzxlEY;EACI,clGzCD;EkG0CC,yBlG1CD;AXs0lEf;;A6G9xlEY;EACI,clGzCD;EkG0CC,yBlG1CD;AX20lEf;;A6GnylEY;EACI,clGzCD;EkG0CC,yBlG1CD;AXg1lEf;;A6GxylEY;EACI,clGzCD;EkG0CC,yBlG1CD;AXq1lEf;;A6G7ylEY;EACI,clGzCD;EkG0CC,yBlG1CD;AX01lEf;;A6GlzlEY;EACI,clGzCD;EkG0CC,yBlG1CD;AX+1lEf;;A6G/ylEA;EACI,yBlG1FS;EkG2FT,sBlG4W0B;AXs8kE9B;A6G/ylEQ;EACI,gCAAA;A7GizlEZ;A6G/ylEY;EACI,WlGhIL;EkGiIK,0CAAA;A7GizlEhB;A6G1ylEY;EACI,qCAAA;A7G4ylEhB;A6G1ylEgB;EACI,clG3IT;EkG4IS,yBlG/GP;AX25lEb;;A6GnylEI;EACI,yBlGhFO;AXs3lEf;;A6GvylEI;EACI,yBlGhFO;AX03lEf;;A6G3ylEI;EACI,yBlGhFO;AX83lEf;;A6G/ylEI;EACI,yBlGhFO;AXk4lEf;;A6GnzlEI;EACI,yBlGhFO;AXs4lEf;;A6GvzlEI;EACI,yBlGhFO;AX04lEf;;A6G3zlEI;EACI,yBlGhFO;AX84lEf;;A6G/zlEI;EACI,yBlGhFO;AXk5lEf;;A6G9zlEA;EACI,iCAAA;A7Gi0lEJ;;A6G1zlEY;EACI,WlGpKL;EkGqKK,yBlG9FD;AX25lEf;A6GvzlEgB;EACI,clGrGL;EkGsGK,0CAAA;A7GyzlEpB;A6GlzlEgB;EACI,clG9GL;EkG+GK,0CAAA;A7GozlEpB;A6GlzlEoB;EACI,yBlGlHT;AXs6lEf;A6G3ylEoB;EACI,yBlG5HT;AXy6lEf;A6GpylEoB;EACI,0BlGtIT;AX46lEf;;A6Gh1lEY;EACI,WlGpKL;EkGqKK,yBlG9FD;AXi7lEf;A6G70lEgB;EACI,clGrGL;EkGsGK,0CAAA;A7G+0lEpB;A6Gx0lEgB;EACI,clG9GL;EkG+GK,0CAAA;A7G00lEpB;A6Gx0lEoB;EACI,yBlGlHT;AX47lEf;A6Gj0lEoB;EACI,yBlG5HT;AX+7lEf;A6G1zlEoB;EACI,0BlGtIT;AXk8lEf;;A6Gt2lEY;EACI,WlGpKL;EkGqKK,yBlG9FD;AXu8lEf;A6Gn2lEgB;EACI,clGrGL;EkGsGK,0CAAA;A7Gq2lEpB;A6G91lEgB;EACI,clG9GL;EkG+GK,0CAAA;A7Gg2lEpB;A6G91lEoB;EACI,yBlGlHT;AXk9lEf;A6Gv1lEoB;EACI,yBlG5HT;AXq9lEf;A6Gh1lEoB;EACI,0BlGtIT;AXw9lEf;;A6G53lEY;EACI,WlGpKL;EkGqKK,yBlG9FD;AX69lEf;A6Gz3lEgB;EACI,clGrGL;EkGsGK,0CAAA;A7G23lEpB;A6Gp3lEgB;EACI,clG9GL;EkG+GK,0CAAA;A7Gs3lEpB;A6Gp3lEoB;EACI,yBlGlHT;AXw+lEf;A6G72lEoB;EACI,yBlG5HT;AX2+lEf;A6Gt2lEoB;EACI,0BlGtIT;AX8+lEf;;A6Gl5lEY;EACI,WlGpKL;EkGqKK,yBlG9FD;AXm/lEf;A6G/4lEgB;EACI,clGrGL;EkGsGK,0CAAA;A7Gi5lEpB;A6G14lEgB;EACI,clG9GL;EkG+GK,0CAAA;A7G44lEpB;A6G14lEoB;EACI,yBlGlHT;AX8/lEf;A6Gn4lEoB;EACI,yBlG5HT;AXigmEf;A6G53lEoB;EACI,0BlGtIT;AXogmEf;;A6Gx6lEY;EACI,WlGpKL;EkGqKK,yBlG9FD;AXygmEf;A6Gr6lEgB;EACI,clGrGL;EkGsGK,0CAAA;A7Gu6lEpB;A6Gh6lEgB;EACI,clG9GL;EkG+GK,0CAAA;A7Gk6lEpB;A6Gh6lEoB;EACI,yBlGlHT;AXohmEf;A6Gz5lEoB;EACI,yBlG5HT;AXuhmEf;A6Gl5lEoB;EACI,0BlGtIT;AX0hmEf;;A6G97lEY;EACI,WlGpKL;EkGqKK,yBlG9FD;AX+hmEf;A6G37lEgB;EACI,clGrGL;EkGsGK,0CAAA;A7G67lEpB;A6Gt7lEgB;EACI,clG9GL;EkG+GK,0CAAA;A7Gw7lEpB;A6Gt7lEoB;EACI,yBlGlHT;AX0imEf;A6G/6lEoB;EACI,yBlG5HT;AX6imEf;A6Gx6lEoB;EACI,0BlGtIT;AXgjmEf;;A6Gp9lEY;EACI,WlGpKL;EkGqKK,yBlG9FD;AXqjmEf;A6Gj9lEgB;EACI,clGrGL;EkGsGK,0CAAA;A7Gm9lEpB;A6G58lEgB;EACI,clG9GL;EkG+GK,0CAAA;A7G88lEpB;A6G58lEoB;EACI,yBlGlHT;AXgkmEf;A6Gr8lEoB;EACI,yBlG5HT;AXmkmEf;A6G97lEoB;EACI,0BlGtIT;AXskmEf;;A6Gv7lEA;EACI,kBAAA;EACA,kBAAA;EACA,iBAAA;A7G07lEJ;A6Gx7lEI;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,WAAA;A7G07lER;A6Gv7lEI;EACI,mBAAA;EACA,kBAAA;EACA,8BAAA;A7Gy7lER;A6Gv7lEQ;EACI,WAAA;EACA,YAAA;EACA,iCAAA;EACA,UAAA;EACA,qBAAA;EACA,gBlGvQS;AXgsmErB;A6Gv7lEY;EAEI,yBlGpNH;EkGqNG,WlGnPL;AX2qmEX;;A6Gh7lEI;EACI,iCAAA;A7Gm7lER;A6Gj7lEQ;EACI,gBAAA;EACA,kBAAA;EACA,gBlG1RS;EkG2RT,qBAAA;A7Gm7lEZ;A6Gj7lEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;A7Gm7lEhB;A6Gh7lEY;EACI,yCAAA;EACA,clGjPH;AXmqmEb;A6Gh7lEgB;EACI,8BAAA;A7Gk7lEpB;A6G96lEY;EACI,wCAAA;EACA,clG1PH;EkG2PG,gBAAA;A7Gg7lEhB;A6G96lEgB;EACI,yCAAA;A7Gg7lEpB;A6Gx6lEoB;EACI,aAAA;A7G06lExB;;A6Gh6lEI;EACI,SAAA;A7Gm6lER;A6Gj6lEQ;EACI,gBAAA;EACA,gDAAA;EACA,wCAAA;EACA,qBAAA;A7Gm6lEZ;A6Gj6lEY;EACI,gBlG6Oc;AXsrlE9B;A6Gh6lEY;EACI,clG5RH;EkG6RG,sBAAA;EACA,gBlGxVK;EkGyVL,WAAA;A7Gk6lEhB;A6G75lEgB;EACI,clGlSP;AXismEb;A6G75lEoB;EACI,gBAAA;A7G+5lExB;A6G15lEY;EACI,qBlGjTH;AX6smEb;A6Gz5lEY;EACI,qBlG/SH;AX0smEb;;A6Gl5lEQ;EACI,6BAAA;EACA,oCAAA;A7Gq5lEZ;A6Gn5lEY;EACI,qBlGnUH;EkGoUG,6BAAA;EACA,clGrUH;AX0tmEb;;A6G14lEgB;EACI,clGxSL;EkGySK,qBlGzSL;AXsrmEf;;A6G/4lEgB;EACI,clGxSL;EkGySK,qBlGzSL;AX2rmEf;;A6Gp5lEgB;EACI,clGxSL;EkGySK,qBlGzSL;AXgsmEf;;A6Gz5lEgB;EACI,clGxSL;EkGySK,qBlGzSL;AXqsmEf;;A6G95lEgB;EACI,clGxSL;EkGySK,qBlGzSL;AX0smEf;;A6Gn6lEgB;EACI,clGxSL;EkGySK,qBlGzSL;AX+smEf;;A6Gx6lEgB;EACI,clGxSL;EkGySK,qBlGzSL;AXotmEf;;A6G76lEgB;EACI,clGxSL;EkGySK,qBlGzSL;AXytmEf;;A6Gv6lEI;EACI,kBAAA;EACA,gBAAA;A7G06lER;A6Gx6lEQ;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,mCAAA;EACA,kBAAA;EACA,yBAAA;A7G06lEZ;A6Gx6lEY;EAEI,cAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,mCAAA;EACA,yBAAA;A7Gy6lEhB;A6Gt6lEY;EACI,wBAAA;EACA,YAAA;EACA,4BAAA;A7Gw6lEhB;A6Gr6lEY;EACI,wBAAA;EACA,WAAA;EACA,6BAAA;A7Gu6lEhB;A6Gp6lEY;EAGI,yBlGlYH;EkGmYG,WlGjaL;AXq0mEX;A6Gj6lEY;EACI,UAAA;A7Gm6lEhB;;A8G79mEI;EACI,gBnG0rBsB;AXsylE9B;A8G79mEI;EACI,oCnGinBsB;AX82lE9B;A8G79mEI;EACI,qBnGmmBsB;AX43lE9B;;A8Gx9mEI;;EAEI,mBAAA;A9G29mER;;A8Gr9mEA;EACI,mBAAA;A9Gw9mEJ;A8Gn9mEQ;;EACI,kBAAA;A9Gs9mEZ;A8Gn9mEQ;;EACI,mBAAA;A9Gs9mEZ;A8Gl9mEI;EACI,qBnGokBsB;AXg5lE9B;;A8G58mEY;EACI,gCAAA;A9G+8mEhB;;A8Gz8mEY;EACI,iFAAA;A9G48mEhB;;A8Gp9mEY;EACI,gCAAA;A9Gu9mEhB;;A8Gj9mEY;EACI,mFAAA;A9Go9mEhB;;A8G59mEY;EACI,gCAAA;A9G+9mEhB;;A8Gz9mEY;EACI,kFAAA;A9G49mEhB;;A8Gp+mEY;EACI,gCAAA;A9Gu+mEhB;;A8Gj+mEY;EACI,6DAAA;A9Go+mEhB;;A8G5+mEY;EACI,gCAAA;A9G++mEhB;;A8Gz+mEY;EACI,iFAAA;A9G4+mEhB;;A8Gp/mEY;EACI,gCAAA;A9Gu/mEhB;;A8Gj/mEY;EACI,mFAAA;A9Go/mEhB;;A8G5/mEY;EACI,gCAAA;A9G+/mEhB;;A8Gz/mEY;EACI,qCAAA;A9G4/mEhB;;A8GpgnEY;EACI,gCAAA;A9GugnEhB;;A8GjgnEY;EACI,uEAAA;A9GognEhB;;A8G7/mEI;EACI,iBAAA;EACA,kBAAA;A9GggnER;A8G//mEQ;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;A9GignEZ;A8G9/mEI;EACI,kBAAA;A9GggnER;A8G//mEQ;EACI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,oCAAA;A9GignEZ;A8G//mEQ;EACI,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,oCAAA;EACA,iBAAA;EACA,SAAA;A9GignEZ;;A8G3/mEI;EACI,iCAAA;EACA,2BAAA;A9G8/mER;A8G7/mEQ;EACI,iCAAA;A9G+/mEZ;;A8Gz/mEI;EACI,8CAAA;EACA,2BAAA;A9G4/mER;A8Gz/mEI;;EAEI,2BAAA;EACA,mCAAA;A9G2/mER;A8Gx/mEI;;EAEI,2CAAA;A9G0/mER;;A8Gr/mEI;EACI,mCAAA;EACA,2BAAA;EACA,wCAAA;A9Gw/mER;A8Gr/mEI;EACI,oBAAA;A9Gu/mER;A8Gp/mEI;EACI,oCAAA;A9Gs/mER;;A+G5nnEA;EACI,gBpG2rB0B;AXo8lE9B;;A+G3nnEI;EACI,iBAAA;A/G8nnER;A+G5nnEQ;EACI,4BAAA;A/G8nnEZ;A+G1nnEI;EACI,cAAA;A/G4nnER;;A+GtnnEE;EACC,UAAA;EACA,0BAAA;EACA,gCAAA;A/GynnEH;A+GrnnEG;EACC,UAAA;EACA,wBAAA;A/GunnEJ;A+GjnnEE;EACC,sCAAA;EACA,6BAAA;A/GmnnEH;A+G/mnEG;EACC,eAAA;A/GinnEJ;A+G3mnEE;EACC,oCAAA;EACA,4BAAA;A/G6mnEH;A+GzmnEG;EACC,eAAA;A/G2mnEJ;A+GtmnEC;EACC,mBAAA;A/GwmnEF;A+GtmnEE;EACC,UAAA;EACA,0BAAA;EACA,oBAAA;A/GwmnEH;A+GpmnEG;EACC,UAAA;EACA,wBAAA;A/GsmnEJ;A+GhmnEE;EACC,UAAA;EACA,qBAAA;EACA,yBAAA;A/GkmnEH;A+G9lnEG;EACC,UAAA;EACA,mBAAA;A/GgmnEJ;;A+GzlnEA;EACC,qBpG05CmC;AXkskEpC;;A+GxlnEA;EACC,aAAA;EACA,qBAAA;EACA,gCAAA;A/G2lnED;A+GzlnEC;EALD;IAME,+BAAA;E/G4lnEA;AACF;;A+GzlnEA;EACC,aAAA;EACA,qBAAA;EACA,gCAAA;EACA,qBpGw4CmC;AXotkEpC;A+G1lnEC;EAND;IAOE,+BAAA;E/G6lnEA;AACF;;A+G1lnEA;EACC;IACC,UAAA;IACA,kCAAA;E/G6lnEA;E+G1lnED;IACC,UAAA;IACA,wBAAA;E/G4lnEA;AACF;A+GxlnEA;EACC;IACC,UAAA;IACA,iCAAA;E/G0lnEA;E+GvlnED;IACC,UAAA;IACA,wBAAA;E/GylnEA;AACF;A+GtlnEA;EACC;IACC,UAAA;IACA,iCAAA;E/GwlnEA;E+GrlnED;IACC,UAAA;E/GulnEA;AACF;A+GplnEA;EACC,0DAAA;EACA,sBAAA;EACA,2BAAA;A/GslnED;;AgHlvnEQ;EACI,oBAAA;EACA,sBrGsnBkB;AX+nmE9B;;AgH9unEI;EACI,8BAAA;EACA,wBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AhHivnER;AgH7unEQ;EACI,eAAA;EACA,gBAAA;AhH+unEZ;;AgHzunEI;EACI,gBrGymBsB;AXmomE9B;;AiH1wnEA;EACI,WAAA;AjH6wnEJ;;AiHzwnEA;EACI,YAAA;AjH4wnEJ;;AiHxwnEA;EACI,YAAA;AjH2wnEJ;;AiHxwnEA;EACI,kBAAA;AjH2wnEJ;AiHzwnEI;EACI,kBAAA;EACA,UAAA;AjH2wnER;AiHzwnEQ;EACI,oCAAA;AjH2wnEZ;;AiHpwnEA;EACI,kBAAA;AjHuwnEJ;AiHrwnEI;EACI,kBAAA;EACA,kBAAA;EACA,8BAAA;AjHuwnER;;AiHnwnEA;EACI;IACI,QAAA;EjHswnEN;AACF;AiHjwnEA;EACI,YAAA;EACA,YAAA;EACA,mBAAA;AjHmwnEJ;AiHjwnEI;EACI,kBAAA;EACA,mBAAA;AjHmwnER;AiHjwnEQ;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,sBtGwFD;EsGvFC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;AjHmwnEZ;;AiH5vnEA;EACI,iBAAA;AjH+vnEJ;AiH7vnEI;EACI,kBAAA;EACA,iBAAA;AjH+vnER;AiH7vnEQ;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBtGgGC;EsG/FD,WtGiED;EsGhEC,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AjH+vnEZ;AiH7vnEY;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBtGqFH;EsGpFG,YAAA;EACA,SAAA;EACA,2BAAA;AjH+vnEhB;;AiHxvnEA;EACI,eAAA;AjH2vnEJ;AiHzvnEI;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,WtGsCG;AXqtnEX;AiH1vnEQ;EACI,WAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;AjH4vnEZ;;AiHrvnEI;EACI,yBtG8FO;AX0pnEf;AiHvvnEQ;EACI,0BtG4FG;AX6pnEf;AiHvvnEQ;EACI,mDAAA;EACA,yBAAA;AjHyvnEZ;AiHxvnEY;EACI,yCAAA;AjH0vnEhB;;AiHnwnEI;EACI,yBtG8FO;AXwqnEf;AiHrwnEQ;EACI,0BtG4FG;AX2qnEf;AiHrwnEQ;EACI,oDAAA;EACA,yBAAA;AjHuwnEZ;AiHtwnEY;EACI,0CAAA;AjHwwnEhB;;AiHjxnEI;EACI,yBtG8FO;AXsrnEf;AiHnxnEQ;EACI,0BtG4FG;AXyrnEf;AiHnxnEQ;EACI,oDAAA;EACA,yBAAA;AjHqxnEZ;AiHpxnEY;EACI,0CAAA;AjHsxnEhB;;AiH/xnEI;EACI,yBtG8FO;AXosnEf;AiHjynEQ;EACI,0BtG4FG;AXusnEf;AiHjynEQ;EACI,oDAAA;EACA,yBAAA;AjHmynEZ;AiHlynEY;EACI,0CAAA;AjHoynEhB;;AiH7ynEI;EACI,yBtG8FO;AXktnEf;AiH/ynEQ;EACI,0BtG4FG;AXqtnEf;AiH/ynEQ;EACI,oDAAA;EACA,yBAAA;AjHiznEZ;AiHhznEY;EACI,0CAAA;AjHkznEhB;;AiH3znEI;EACI,yBtG8FO;AXgunEf;AiH7znEQ;EACI,0BtG4FG;AXmunEf;AiH7znEQ;EACI,oDAAA;EACA,yBAAA;AjH+znEZ;AiH9znEY;EACI,0CAAA;AjHg0nEhB;;AiHz0nEI;EACI,yBtG8FO;AX8unEf;AiH30nEQ;EACI,0BtG4FG;AXivnEf;AiH30nEQ;EACI,qDAAA;EACA,yBAAA;AjH60nEZ;AiH50nEY;EACI,2CAAA;AjH80nEhB;;AiHv1nEI;EACI,yBtG8FO;AX4vnEf;AiHz1nEQ;EACI,0BtG4FG;AX+vnEf;AiHz1nEQ;EACI,kDAAA;EACA,yBAAA;AjH21nEZ;AiH11nEY;EACI,wCAAA;AjH41nEhB;;AkHn+nEA;EACI,6CvGqoB0B;AXi2mE9B;;AmHt+nEA;EACI,2CAAA;AnHy+nEJ;;AmHp+nEI;EACI,aAAA;EACA,sBAAA;AnHu+nER;AmHr+nEQ;EACI,qDAAA;EACA,iBAAA;EACA,sBAAA;AnHu+nEZ;;AmH99nEY;EACI,cAAA;EACA,qBAAA;EACA,yCAAA;AnHi+nEhB;AmH/9nEgB;EACI,cAAA;AnHi+nEpB;AmH59nEgB;EACI,qBAAA;AnH89nEpB;AmH59nEoB;EACI,cAAA;AnH89nExB;;AmH7+nEY;EACI,cAAA;EACA,qBAAA;EACA,0CAAA;AnHg/nEhB;AmH9+nEgB;EACI,cAAA;AnHg/nEpB;AmH3+nEgB;EACI,qBAAA;AnH6+nEpB;AmH3+nEoB;EACI,cAAA;AnH6+nExB;;AmH5/nEY;EACI,cAAA;EACA,qBAAA;EACA,0CAAA;AnH+/nEhB;AmH7/nEgB;EACI,cAAA;AnH+/nEpB;AmH1/nEgB;EACI,qBAAA;AnH4/nEpB;AmH1/nEoB;EACI,cAAA;AnH4/nExB;;AmH3goEY;EACI,cAAA;EACA,qBAAA;EACA,0CAAA;AnH8goEhB;AmH5goEgB;EACI,cAAA;AnH8goEpB;AmHzgoEgB;EACI,qBAAA;AnH2goEpB;AmHzgoEoB;EACI,cAAA;AnH2goExB;;AmH1hoEY;EACI,cAAA;EACA,qBAAA;EACA,0CAAA;AnH6hoEhB;AmH3hoEgB;EACI,cAAA;AnH6hoEpB;AmHxhoEgB;EACI,qBAAA;AnH0hoEpB;AmHxhoEoB;EACI,cAAA;AnH0hoExB;;AmHzioEY;EACI,cAAA;EACA,qBAAA;EACA,0CAAA;AnH4ioEhB;AmH1ioEgB;EACI,cAAA;AnH4ioEpB;AmHvioEgB;EACI,qBAAA;AnHyioEpB;AmHvioEoB;EACI,cAAA;AnHyioExB;;AmHxjoEY;EACI,cAAA;EACA,qBAAA;EACA,2CAAA;AnH2joEhB;AmHzjoEgB;EACI,cAAA;AnH2joEpB;AmHtjoEgB;EACI,qBAAA;AnHwjoEpB;AmHtjoEoB;EACI,cAAA;AnHwjoExB;;AmHvkoEY;EACI,cAAA;EACA,qBAAA;EACA,wCAAA;AnH0koEhB;AmHxkoEgB;EACI,cAAA;AnH0koEpB;AmHrkoEgB;EACI,qBAAA;AnHukoEpB;AmHrkoEoB;EACI,cAAA;AnHukoExB;;AmH7joEQ;EACI,qBAAA;EACA,4BAAA;EACA,gDAAA;AnHgkoEZ;AmH/joEY;EACI,qBAAA;AnHikoEhB;AmH7joEY;EACI,4BAAA;AnH+joEhB;AmH9joEgB;EACI,qBAAA;AnHgkoEpB;;AoH5noEA;EACI,kBAAA;EACA,gBAAA;ApH+noEJ;AoH5noEI;EACI,eAAA;ApH8noER;AoH3noEI;EACI,eAAA;ApH6noER;;AoHlnoEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AX+6nEf;;AoH9moEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXo7nEf;AoH/moEgB;EACI,yBzG0LL;AXu7nEf;;AoH/noEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AX47nEf;;AoH3noEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXi8nEf;AoH5noEgB;EACI,yBzG0LL;AXo8nEf;;AoH5ooEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AXy8nEf;;AoHxooEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AX88nEf;AoHzooEgB;EACI,yBzG0LL;AXi9nEf;;AoHzpoEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AXs9nEf;;AoHrpoEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AX29nEf;AoHtpoEgB;EACI,yBzG0LL;AX89nEf;;AoHtqoEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AXm+nEf;;AoHlqoEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXw+nEf;AoHnqoEgB;EACI,yBzG0LL;AX2+nEf;;AoHnroEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AXg/nEf;;AoH/qoEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXq/nEf;AoHhroEgB;EACI,yBzG0LL;AXw/nEf;;AoHhsoEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AX6/nEf;;AoH5roEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AXkgoEf;AoH7roEgB;EACI,yBzG0LL;AXqgoEf;;AoH7soEY;EACI,yBzGuMD;EyGtMC,qBzGsMD;AX0goEf;;AoHzsoEY;EACI,qBzG8LD;EyG7LC,yBzG6LD;AX+goEf;AoH1soEgB;EACI,yBzG0LL;AXkhoEf;;AoHrsoEA;EACI,eAAA;EACA,gBAAA;ApHwsoEJ;;AoHpsoEA;EACI,eAAA;EACA,qBAAA;ApHusoEJ;AoHrsoEI;EACI,YAAA;EACA,cAAA;EACA,oBAAA;ApHusoER;AoHpsoEI;EACI,cAAA;ApHssoER;AoHlsoEQ;EACI,qBAAA;ApHosoEZ;;AoHvroEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AX6ioEf;;AoH7roEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AXmjoEf;;AoHnsoEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AXyjoEf;;AoHzsoEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AX+joEf;;AoH/soEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AXqkoEf;;AoHrtoEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AX2koEf;;AoH3toEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AXiloEf;;AoHjuoEgB;EACI,czG+IL;EyG9IK,6BAAA;EACA,qBzG6IL;AXuloEf;;AoH5toEI;EACI,kBAAA;ApH+toER;AoH7toEQ;EACI,sBAAA;ApH+toEZ;AoH7toEY;EACI,iBAAA;EACA,oCAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;ApH+toEhB;;AoHjtoEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AX6moEf;;AoHvtoEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AXmnoEf;;AoH7toEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AXynoEf;;AoHnuoEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AX+noEf;;AoHzuoEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AXqooEf;;AoH/uoEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AX2ooEf;;AoHrvoEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AXipoEf;;AoH3voEgB;EACI,czGyGL;EyGxGK,6BAAA;EACA,qBzGuGL;AXupoEf;;AoHtvoEI;EACI,kBAAA;ApHyvoER;AoHvvoEQ;EACI,sBAAA;ApHyvoEZ;AoHvvoEY;EACI,iBAAA;EACA,oCAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;ApHyvoEhB;;AoHhvoEA;EACI,oBAAA;EACA,gBAAA;EACA,iBAAA;ApHmvoEJ;AoHjvoEI;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;ApHmvoER;AoHhvoEI;EACI,sBAAA;ApHkvoER;;AoH9uoEA;EACI,qBAAA;EACA,gBAAA;EACA,iBAAA;ApHivoEJ;AoH/uoEI;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;ApHivoER;;AoH7uoEA;EACI,kBAAA;ApHgvoEJ;;AoHvuoEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AX0soEf;;AoHjuoEoB;EACI,czGsBT;AX8soEf;;AoHhvoEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AXmtoEf;;AoH1uoEoB;EACI,czGsBT;AXutoEf;;AoHzvoEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AX4toEf;;AoHnvoEoB;EACI,czGsBT;AXguoEf;;AoHlwoEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AXquoEf;;AoH5voEoB;EACI,czGsBT;AXyuoEf;;AoH3woEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AX8uoEf;;AoHrwoEoB;EACI,czGsBT;AXkvoEf;;AoHpxoEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AXuvoEf;;AoH9woEoB;EACI,czGsBT;AX2voEf;;AoH7xoEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AXgwoEf;;AoHvxoEoB;EACI,czGsBT;AXowoEf;;AoHtyoEY;EACI,yBzGiCD;EyGhCC,qBzGgCD;AXywoEf;;AoHhyoEoB;EACI,czGsBT;AX6woEf;;AoHvxoEI;EACI,kBAAA;EACA,sBAAA;ApH0xoER;AoHxxoEQ;EACI,iBAAA;EACA,oCAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,czGlED;EgBhJL,iDyFmNM;ApH0xoEZ;A2Bz+oEM;EyFuME;IzFtMA,gBAAA;E3B4+oEN;AACF;AoH5xoEQ;EACI,sBAAA;EACA,oCzGmuB4B;EgB37BlC,iDyFyNM;ApH8xoEZ;A2Bn/oEM;EyFkNE;IzFjNA,gBAAA;E3Bs/oEN;AACF;AoHjyoEY;EACI,WAAA;EACA,UAAA;ApHmyoEhB;AoH/xoEQ;EACI,sBAAA;ApHiyoEZ;;AoH1xoEA;EACI,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,0BAAA;ApH6xoEJ;AoH3xoEI;EACI,YAAA;EACA,cAAA;EACA,oBAAA;EACA,4BAAA;ApH6xoER;AoH1xoEI;EACI,gBAAA;EACA,kBAAA;ApH4xoER;;AoHvxoEA;EACI,UAAA;ApH0xoEJ;AoHxxoEI;EACI,0CAAA;EACA,8CAAA;EACA,sBzG4WsB;EyG3WtB,aAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;ApH0xoER;AoHxxoEQ;EACI,eAAA;ApH0xoEZ;AoHtxoEI;EACI,aAAA;ApHwxoER;AoHtxoEQ;EACI,gCAAA;ApHwxoEZ;AoHtxoEY;EACI,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,czGtHH;AX84oEb;AoHhxoEgB;EACI,WzG7JT;AX+6oEX;;AoHzwoEQ;EACI,0DAAA;ApH4woEZ;;AqHxkpEA;EACI,kBAAA;ArH2kpEJ;AqH1kpEI;EACI,oBAAA;EACA,kBAAA;ArH4kpER;AqH1kpEI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;ArH4kpER;AqHzkpEQ;EACI,qBAAA;EACA,oB1Gy0BkB;E0Gx0BlB,kBAAA;ArH2kpEZ;AqHzkpEQ;EACI,UAAA;EACA,WAAA;ArH2kpEZ;;AqHrkpEI;EACI,0DAAA;EACA,+CAAA;EACA,+CAAA;ArHwkpER;AqHrkpEI;EACI,oCAAA;EACA,oCAAA;ArHukpER;;AsHvmpEY;EACI,oCAAA;EACA,qB3GsND;AXo5oEf;;AsH5mpEY;EACI,oCAAA;EACA,qB3GsND;AXy5oEf;;AsHjnpEY;EACI,oCAAA;EACA,qB3GsND;AX85oEf;;AsHtnpEY;EACI,oCAAA;EACA,qB3GsND;AXm6oEf;;AsH3npEY;EACI,oCAAA;EACA,qB3GsND;AXw6oEf;;AsHhopEY;EACI,oCAAA;EACA,qB3GsND;AX66oEf;;AsHropEY;EACI,oCAAA;EACA,qB3GsND;AXk7oEf;;AsH1opEY;EACI,oCAAA;EACA,qB3GsND;AXu7oEf;;AsHvopEA;EACI,yBAAA;AtH0opEJ;;AsHvopEA;EACI,kBAAA;AtH0opEJ;AsHzopEI;EACI,c3GwIG;AXmgpEX;AsHzopEI;EACI,gB3GinBsB;AX0hoE9B;AsH1opEQ;EACI,W3G6HD;AX+gpEX;AsH1opEQ;EACI,+BAAA;AtH4opEZ;;AuHxqpEA;EACE,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,2BAAA;EACA,yBAAA;EACA,uBAAA;AvH2qpEF;;AuHxqpEA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;AvH2qpEF;;AuHxqpEA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;AvH2qpEF;;AuHxqpEA;EACE,6BAAA;EACA,8BAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;AvH2qpEF;;AuHxqpEA;EACE,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA,EAAA,mGAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA,EAAA,mFAAA;EACA,eAAA,EAAA,kDAAA;EACA,gBAAA,EAAA,0CAAA;EACA,qBAAA;EACA,uBAAA;AvH2qpEF;;AuHxqpEA;;EAEE,aAAA;AvH2qpEF;;AuHxqpEA;;EAEE,YAAA;EACA,cAAA;AvH2qpEF;;AuHxqpEA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;AvH2qpEF;;AuHxqpEA;EACE,8BAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;AvH2qpEF;;AuHxqpEA;EACE,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;AvH2qpEF;;AuHxqpEA;EACE,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;EACA,gBAAA;AvH2qpEF;;AuHxqpEA;EACE,oBAAA;EACA,iBAAA;EACA,yBAAA;AvH2qpEF;;AuHxqpEA;EACE,mBAAA;AvH2qpEF;;AuHxqpEA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;AvH2qpEF;;AuHxqpEA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,+BAAA;AvH2qpEF;;AuHxqpEA;EACE,0DAAA;EACA,YAAA;EACA,6BAAA;AvH2qpEF;;AuHxqpEA;EACE,MAAA;EACA,WAAA;AvH2qpEF;;AuHxqpEA;EACE,QAAA;EACA,WAAA;AvH2qpEF;;AuHxqpEA;EACE,OAAA;EACA,YAAA;AvH2qpEF;;AuHxqpEA;EACE,YAAA;EACA,SAAA;EACA,UAAA;AvH2qpEF;;AuHxqpEA;EACE,WAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,WAAA;AvH2qpEF;;AuHxqpEA,gBAAA;AACA;EACE,WAAA;EACA,OAAA;AvH2qpEF;;AuHxqpEA;EACE,cAAA;EACA,eAAA;EACA,UAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AvH2qpEF;;AuHxqpEA;EACE,eAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;AvH2qpEF;;AuHxqpEA;EACE,YAAA;AvH2qpEF;;AuHtqpEI;EACE,mB5GES;AXuqpEf;;AuH1qpEI;EACE,mB5GES;AX2qpEf;;AuH9qpEI;EACE,mB5GES;AX+qpEf;;AuHlrpEI;EACE,mB5GES;AXmrpEf;;AuHtrpEI;EACE,mB5GES;AXurpEf;;AuH1rpEI;EACE,mB5GES;AX2rpEf;;AuH9rpEI;EACE,mB5GES;AX+rpEf;;AuHlspEI;EACE,mB5GES;AXmspEf;;AwHp6pEA;;;;EAAA;AAMA;;EAEI,YAAA;EACA,gBAAA;EACA,wBAAA;EACA,sEAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EAIA,WAAA;EAKA,aAAA;AxHo6pEJ;;AwHz5pEA;;;;EAII,iBAAA;EACA,mBAAA;AxHo6pEJ;;AwHj6pEA;EACI;;IAEI,iBAAA;ExHo6pEN;AACF;AwHj6pEA,gBAAA;AACA;EACI,YAAA;EACA,SAAA;EACA,cAAA;AxHm6pEJ;;AwHh6pEA;;EAEI,sCAAA;AxHm6pEJ;;AwHh6pEA,gBAAA;AACA;EACI,cAAA;EACA,oBAAA;EACA,mBAAA;AxHm6pEJ;;AwHh6pEA;;;;EAII,gBAAA;AxHm6pEJ;;AwHh6pEA;EACI,WAAA;AxHm6pEJ;;AwHh6pEA;EACI,YAAA;AxHm6pEJ;;AwHh6pEA;;;;;;;EAOI,c7G6FS;AXs0pEb;;AwHh6pEA;;;;;;EAMI,WAAA;AxHm6pEJ;;AwHh6pEA;;;;;EAKI,cAAA;EACA,oEAAA;EACA,kCAAA;AxHm6pEJ;;AwHh6pEA;;;EAGI,WAAA;AxHm6pEJ;;AwHh6pEA;;EAEI,cAAA;AxHm6pEJ;;AwHh6pEA;;;EAGI,WAAA;AxHm6pEJ;;AwHh6pEA;;EAEI,iBAAA;AxHm6pEJ;;AwHj6pEA;EACI,kBAAA;AxHo6pEJ;;AwHj6pEA;EACI,YAAA;AxHo6pEJ;;AwHj6pEA,iBAAA;AACA;;EAEI,mB7GQO;AX45pEX;;AwHj6pEA;;EAEI,c7GOO;E6GNP,iBAAA;AxHo6pEJ;;AwH55pEI;EACI,wBAAA;AxH+5pER;AwH55pEI;EACI,WAAA;AxH85pER;AwH35pEI;EACI,YAAA;AxH65pER;AwH15pEI;EACI,+CAAA;EACA,mBAAA;EACA,iCAAA;AxH45pER;AwHz5pEI;EACI,mBAAA;EACA,iCAAA;AxH25pER;;AwHp5pEA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AxHu5pEJ;;AwHl5pEA;EACI,6BAAA;EACA,sBAAA;EACA,qBAAA;AxHq5pEJ;;AwHl5pEA;EACI,qBAAA;AxHq5pEJ;AwHp5pEI;EACI,gCAAA;EACA,kCAAA;EACA,mCAAA;EACA,gJAAA;EACA,gCAAA;EACA,oDAAA;EACA,6BAAA;EACA,yBAAA;EACA,2BAAA;AxHs5pER;AwHr5pEQ;EACI,wBAAA;EACA,2BAAA;AxHu5pEZ;AwHr5pEQ;EACI,oCAAA;EACA,sBAAA;AxHu5pEZ;;AyHrnqEE;EACE,oBAAA;EACA,eAAA;EACA,gB9GwHiB;AXggqErB;;AyHpnqEA;EACE,oBAAA;EACA,qB9GknB4B;E8GjnB5B,0CAAA;EACA,2BAAA;AzHunqEF;AyHrnqEE;EACE,8BAAA;AzHunqEJ;AyHpnqEE;EACE,2BAAA;AzHsnqEJ;;AyHlnqEA;EACE,4CAAA;EACA,2BAAA;AzHqnqEF;;AyHlnqEA;EACE,eAAA;AzHqnqEF;;AyHjnqEE;EACE,qB9GyJS;E8GxJT,c9GwJS;AX49pEb;AyHjnqEI;EACE,yB9GkJO;AXi+pEb;AyHhnqEI;EACE,qCAAA;AzHknqEN;AyH/mqEE;EACE,qB9GyIS;E8GxIT,c9GwIS;AXy+pEb;;AyH5mqEE;EACE,gBAAA;AzH+mqEJ;;AyH3mqEA;EACE,qDAAA;AzH8mqEF;;AyH3mqEA;EACE,yCAAA;AzH8mqEF;;AyH1mqEE;EACE,mB9G+GS;AX8/pEb;AyH5mqEI;EACE,mB9G6GO;AXigqEb;AyH7mqEM;EACE,kCAAA;AzH+mqER;AyH3mqEE;EACE,mB9GsGS;AXugqEb;;AyHxmqEE;EACE,qCAAA;EACA,sCAAA;AzH2mqEJ;;AyHvmqEA;EACE,wCAAA;AzH0mqEF;AyHzmqEE;EACE,gBAAA;EACA,0C9Gy3BoC;AXkvoExC;;AyHvmqEA;EACE,YAAA;EACA,cAAA;EACA,sBAAA;EhH6LI,oBALI;EgHrLR,gB9GolB4B;E8GnlB5B,gB9G0lB4B;E8GzlB5B,2B9Gm2BsC;E8Gl2BtC,oC9G61BsC;E8G51BtC,4BAAA;EACA,wCAAA;AzHymqEF;;AyHtmqEA;EACE,sC9G+jB4B;E8G9jB5B,gB9GykB4B;E8GxkB5B,eAAA;AzHymqEF;AyHxmqEE;EACE,gBAAA;AzH0mqEJ;AyHvmqEE;EACE,c9G4DS;AX6iqEb;;AyHrmqEA;EACE,6BAAA;AzHwmqEF;;A0HpuqEA;EACE,iBAAA;EACA,yCAAA;EACA,oCAAA;EACA,kBAAA;A1HuuqEF;A0HruqEE;EACE,eAAA;EACA,WAAA;EACA,aAAA;A1HuuqEJ;;A2HhvqEA;EACE,mBhHwLW;AX2jqEb;;A2HhvqEA;EACE,mBhHoLW;EgHnLX,mCAAA;EACA,gBAAA;A3HmvqEF;;A2HhvqEA;EACE,WAAA;A3HmvqEF;A2HlvqEE;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;A3HovqEJ;A2HlvqEI;EACE,aAAA;A3HovqEN;A2HlvqEI;EACE,UAAA;A3HovqEN;;A2H/uqEA;EACE,YAAA;A3HkvqEF;;A2H7uqEA;EACE,sBAAA;EACA,oChHklB4B;EgHjlB5B,qBhHslB4B;EgHrlB5B,0CAAA;EACA,2BAAA;A3HgvqEF;;A2H3uqEA;EACE,UAAA;A3H8uqEF;A2H7uqEE;EACE,YAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;A3H+uqEJ;A2H9uqEI;EACE,aAAA;A3HgvqEN;A2H9uqEI;EACE,UAAA;A3HgvqEN;A2H5uqEE;EACE,MAAA;A3H8uqEJ;;A2H1uqEA;EACE,eAAA;A3H6uqEF;;A2HzuqEE;EACE,YAAA;A3H4uqEJ;;A2HxuqEA;EACE,gBAAA;A3H2uqEF;;A2HxuqEA;EACE,gBAAA;EACA,iCAAA;EACA,6BAAA;A3H2uqEF;;A2HvuqEE;EACE,UAAA;A3H0uqEJ;;A2HpuqEA;EACC,YAAA;EACA,qBAAA;EACA,aAAA;A3HuuqED;;A2HpuqEA;EACC,aAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,wCAAA;A3HuuqED;;A2HpuqEA;EACC,iBAAA;EACA,aAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;EACA,wCAAA;EACG,mBAAA;EACA,kBAAA;A3HuuqEJ;;A2HnuqEI;EACI,mBhH6DK;AXyqqEb;;A2HjuqEI;EACI,mBhH0DK;AX0qqEb;;A2H/tqEI;EACI,mBhH8CK;AXorqEb;;A2H3tqEI;EACI,2BAAA;A3H8tqER;;A2HvtqEA;EACI,eAAA;EACA,chHKO;EgHJP,cAAA;EACA,cAAA;A3H0tqEJ;A2HztqEI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;A3H2tqER;;A2HrtqEA;EACI,aAAA;A3HwtqEJ;;A2HttqEA;EACI,cAAA;A3HytqEJ;;A2HptqEA;EAAa,mBhHWA;AX6sqEb;;A2HvtqEA;EAAa,mBhHYA;AX+sqEb;;A2H1tqEA;EAAa,mBhHYA;AXktqEb;;A2H7tqEA;EAAa,mBhHKA;AX4tqEb;;A2HhuqEA;EAAa,mBhHKA;AX+tqEb;;A2HhuqEA;EACI,YAAA;A3HmuqEJ;A2HjuqEQ;EACI,qBhHDC;AXouqEb;;A2H1tqEI;EACE,mBhH2BS;AXksqEf;A2H1tqEI;EACE,mBhHuBS;AXqsqEf;A2HxtqEM;EACE,qBhHkBO;AXwsqEf;;A2HpuqEI;EACE,mBhH2BS;AX4sqEf;A2HpuqEI;EACE,mBhHuBS;AX+sqEf;A2HluqEM;EACE,qBhHkBO;AXktqEf;;A2H9uqEI;EACE,mBhH2BS;AXstqEf;A2H9uqEI;EACE,mBhHuBS;AXytqEf;A2H5uqEM;EACE,qBhHkBO;AX4tqEf;;A2HxvqEI;EACE,mBhH2BS;AXguqEf;A2HxvqEI;EACE,mBhHuBS;AXmuqEf;A2HtvqEM;EACE,qBhHkBO;AXsuqEf;;A2HlwqEI;EACE,mBhH2BS;AX0uqEf;A2HlwqEI;EACE,mBhHuBS;AX6uqEf;A2HhwqEM;EACE,qBhHkBO;AXgvqEf;;A2H5wqEI;EACE,mBhH2BS;AXovqEf;A2H5wqEI;EACE,mBhHuBS;AXuvqEf;A2H1wqEM;EACE,qBhHkBO;AX0vqEf;;A2HtxqEI;EACE,mBhH2BS;AX8vqEf;A2HtxqEI;EACE,mBhHuBS;AXiwqEf;A2HpxqEM;EACE,qBhHkBO;AXowqEf;;A2HhyqEI;EACE,mBhH2BS;AXwwqEf;A2HhyqEI;EACE,mBhHuBS;AX2wqEf;A2H9xqEM;EACE,qBhHkBO;AX8wqEf;;A2HvxqEE;EACE,YAAA;A3H0xqEJ;A2HxxqEI;EACE,WAAA;EACA,YAAA;A3H0xqEN;;A2HpxqEE;EACE,WAAA;A3HuxqEJ;A2HrxqEI;EACE,WAAA;EACA,YAAA;A3HuxqEN;;A2HjxqEE;EACE,WAAA;A3HoxqEJ;A2HlxqEI;EACE,WAAA;EACA,YAAA;A3HoxqEN;;A2H5wqEE;EACE,UAAA;EACA,kBAAA;EACA,WAAA;A3H+wqEJ;A2H7wqEE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;A3H+wqEJ;;A2H1wqEE;EACE,qBhH3ES;EgH4ET,sBhHhHO;AX63qEX;;A2HxwqEE;EACE,kBAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,qBhHvFS;EgHwFT,sBhH5HO;AXu4qEX;;A4H3hrEI;EACI,yCAAA;EACA,qCAAA;A5H8hrER;;A4H1hrEA;EACI,eAAA;A5H6hrEJ;;A4HxhrEI;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;A5H2hrER;A4HzhrEI;EACI,kBAAA;A5H2hrER;;A6HrjrEA;EACI,oCAAA;EACA,4ClHkoB0B;AXs7pE9B;;A6HnjrEQ;EACI,iCAAA;EACA,uBAAA;A7HsjrEZ;A6HnjrEQ;EACI,qCAAA;A7HqjrEZ;A6HpjrEY;EACI,qCAAA;A7HsjrEhB;;A6HhjrEA;EACI,iCAAA;A7HmjrEJ;;A6HhjrEA;EACI,eAAA;EACA,gBlHkGiB;EkHjGjB,2BAAA;A7HmjrEJ;;A6HhjrEA;EACI,gBlHm7CgC;EkHl7ChC,oBlHopB0B;EkHnpB1B,2BAAA;A7HmjrEJ;;A6H/irEI;EACI,6DAAA;EACA,WlH8GG;AXo8qEX;A6H/irEI;EACI,2CAAA;EACA,qBAAA;A7HijrER;A6H9irEI;EACI,6DAAA;EACA,WlHoGG;AX48qEX;;A6H5irEA;EACI,0BAAA;A7H+irEJ;;A6H7irEA;;EAEI,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,UAAA;EACA,wCAAA;EACA,uBAAA;EACA,clHmHS;AX67qEb;;A6H7irEA;EACI,UAAA;A7HgjrEJ;;A6H7irEA;EACI,oBAAA;A7HgjrEJ;;A8HznrEA;EACI,uBAAA;EACA,sBAAA;EACA,wCAAA;EACA,0BAAA;EACA,kBAAA;A9H4nrEJ;A8H3nrEI;EACI,iCAAA;EACA,0BAAA;EACA,cAAA;EACA,yBAAA;A9H6nrER;;A8HxnrEI;EACI,2BAAA;A9H2nrER;;A8HvnrEI;EACI,2BAAA;A9H0nrER;;A8HtnrEA;EACI,sBAAA;EACA,sBAAA;EACA,iCAAA;EACA,8BAAA;EACA,gBnH0mB0B;AX+gqE9B;A8HxnrEI;EACI,UAAA;A9H0nrER;;A8HrnrEI;EACI,UAAA;EACA,WAAA;EACA,sBnH8GG;EmH7GH,YAAA;EACA,yBAAA;A9HwnrER;A8HvnrEQ;EACI,UAAA;EACA,WAAA;A9HynrEZ;;A8HpnrEA;EACI,WnHmGO;EmHlGP,eAAA;EACA,oCAAA;EACA,0BAAA;A9HunrEJ;;A8HlnrEI;EACI,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;EACA,uBAAA;EACA,yBAAA;A9HqnrER;A8HpnrEQ;EACI,yBAAA;EACA,qBAAA;A9HsnrEZ;;A8HjnrEA;EACI,sBAAA;EACA,qDAAA;A9HonrEJ;A8HnnrEI;EACI,oCAAA;A9HqnrER;;A8HhnrEA;EACI,2CAAA;EACA,0BAAA;EACA,cAAA;EACA,sBAAA;A9HmnrEJ;A8HlnrEI;EACI,sBnH6DG;AXujrEX;;A8H/mrEI;EACI,oCAAA;A9HknrER;A8H/mrEQ;EACI,oCAAA;A9HinrEZ;A8H7mrEQ;EACI,WnH8CD;AXikrEX;A8H9mrEY;EACI,UAAA;A9HgnrEhB;A8H5mrEI;EACI,wCAAA;A9H8mrER;;A+H5trEA;EACE,YAAA;EACA,kBAAA;A/H+trEF;A+H7trEE;EACE,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,cpHyIO;EoHxIP,iCAAA;EACA,UAAA;A/H+trEJ;A+H5trEE;EACE,wCAAA;EACA,oCpH66BoC;EoH56BpC,+BpHgmB0B;EoH/lB1B,kCpH+lB0B;AX+nqE9B;A+H1trEI;EACE,wBAAA;A/H4trEN;A+HztrEI;EACE,WAAA;A/H2trEN;A+HxtrEI;EACE,WAAA;A/H0trEN;A+HvtrEI;EACE,+CAAA;EACA,mBAAA;EACA,oCAAA;A/HytrEN;A+HttrEI;EACE,mBAAA;EACA,oCpHm5BkC;AXq0pExC;A+HptrEE;EACE,eAAA;A/HstrEJ;A+HntrEE;EACE,2BpH+4BoC;AXs0pExC;A+HptrEI;EACE,wCAAA;A/HstrEN;A+HltrEE;EACE,wCAAA;EACA,8BpHk4BoC;EoHj4BpC,gCpHqjB0B;EoHpjB1B,mCpHojB0B;AXgqqE9B;A+HjtrEE;EACE,cAAA;EACA,sBAAA;EAEA,oBpHumB0B;EoHtmB1B,2BpH63BoC;EoH53BpC,oCpHu3BoC;EoHt3BpC,wCAAA;EACA,sBpHyiB0B;EoHxiB1B,mBAAA;A/HktrEJ;A+HjtrEI;EACE,cpHuEK;AX4orEX;A+H/srEE;EACE,gBpHkmB0B;EoHjmB1B,yBAAA;A/HitrEJ;;AgI5yrEA;EACE,oCAAA;EACA,6CrHooB4B;EqHnoB5B,kBAAA;EACA,wCAAA;AhI+yrEF;;AgI3yrEE;EACE,0CAAA;EACA,gDAAA;EACA,kBAAA;EACA,gBrH4nB0B;AXkrqE9B;AgI7yrEI;EACE,kBAAA;AhI+yrEN;;AgIvyrEM;EACE,oBAAA;EACA,cAAA;AhI0yrER;AgIvyrEM;EACE,mBAAA;EACA,eAAA;AhIyyrER;AgInyrEI;EACE,eAAA;AhIqyrEN;AgIhyrEI;EACE,mBrH0IO;AXwprEb;AgI/xrEI;EACE,oCrHy5BkC;EqHx5BlC,2BrH65BkC;EqH55BlC,wCAAA;EACA,sBrH0kBwB;AXutqE9B;AgI9xrEI;EACE,iCAAA;AhIgyrEN;AgI/xrEM;EACE,gBAAA;EACA,oCrH+4BgC;EqH94BhC,0CrH65BgC;AXo4pExC;AgI7xrEI;EACE,8BAAA;AhI+xrEN;AgI5xrEI;EACE,8BAAA;AhI8xrEN;;AiIh2rEA;EACE,gBAAA;AjIm2rEF;AiIh2rEI;EACE,eAAA;AjIk2rEN;;AiI71rEA;EACE,yCAAA;EACA,oCAAA;AjIg2rEF;;AiI71rEA;EACE,2BAAA;AjIg2rEF;AiI/1rEE;EACE,gBtH2GiB;AXsvrErB;;AiI71rEA;EACE,aAAA;AjIg2rEF;;AiI71rEA;EACE,oCAAA;AjIg2rEF;;AkI13rEA;;EAEI,wBAAA;EACA,YAAA;AlI63rEJ;;AkI13rEA;EACI,wCAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;EtHIA,sBAAA;EsHFA,8BvH07BoC;EuHz7BpC,YAAA;AlI63rEJ;AkI33rEI;EACI,UAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,uBAAA;EACA,2BvHs7BgC;EuHr7BhC,sBvHomBsB;AXyxqE9B;AkI33rEQ;EACI,UAAA;AlI63rEZ;AkIz3rEI;EACI,YAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,2BAAA;EACA,2BAAA;EACA,YAAA;EACA,sBvHmlBsB;AXwyqE9B;AkIx3rEI;EACI,2BAAA;AlI03rER;AkIx3rEQ;EACI,oCvHw5B4B;AXk+pExC;AkIt3rEI;EACI,2BAAA;AlIw3rER;AkIt3rEQ;EACI,oCvHg5B4B;AXw+pExC;AkIp3rEI;EACI,aAAA;EACA,WAAA;AlIs3rER;AkIp3rEQ;EACI,cAAA;AlIs3rEZ;AkIn3rEQ;EACI,YAAA;AlIq3rEZ;;AkI52rEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AXwyrEX;;AkIj3rEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AX6yrEX;;AkIt3rEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AXkzrEX;;AkI33rEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AXuzrEX;;AkIh4rEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AX4zrEX;;AkIr4rEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AXi0rEX;;AkI14rEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AXs0rEX;;AkI/4rEY;EACI,yBvH+ID;EuH9IC,WvHuEL;AX20rEX;;AmIj+rEA;EACI,iDAAA;AnIo+rEJ;AmIl+rEI;EACI,sCAAA;AnIo+rER;AmIl+rEI;EACI,sDAAA;AnIo+rER;AmIj+rEI;EACI,gBAAA;AnIm+rER;AmIh+rEI;EACI,mDAAA;AnIk+rER;AmIh+rEQ;EACI,0BAAA;AnIk+rEZ;AmI/9rEQ;EACI,kCAAA;AnIi+rEZ;AmI79rEI;EACI,wBAAA;EACA,qDAAA;EACA,+CAAA;EACA,2BAAA;AnI+9rER;AmI59rEI;EACI,2CAAA;EACA,6CxHmmBsB;EwHlmBtB,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBxHslBsB;AXw4qE9B;AmI39rEI;EACI,2CAAA;AnI69rER;AmIx9rEY;EAEI,OAAA;EACA,sBAAA;AnIy9rEhB;AmIn9rEQ;EACI,2BAAA;AnIq9rEZ;AmIj9rEI;EACI,wDAAA;EACA,gCAAA;EACA,mDAAA;AnIm9rER;;AmI58rEI;;;EACI,2BAAA;EACA,4CAAA;AnIi9rER;AmI78rEQ;;EACI,sCAAA;AnIg9rEZ;AmI58rEI;;EACI,sCAAA;AnI+8rER;;AmI38rEA;;EAEI,iCAAA;EACA,uCAAA;EACA,wCAAA;AnI88rEJ;;AmI38rEA;;EAEI,iCAAA;EACA,oCAAA;EACA,qCAAA;AnI88rEJ;;AmI38rEA;EACI,4BAAA;AnI88rEJ;;AmI38rEA;EACI,2BAAA;AnI88rEJ;;AmIv8rEY;;;EAEI,2BAAA;AnI28rEhB;;AmIn8rEQ;EACI,8BAAA;EACA,yBAAA;AnIs8rEZ;AmIl8rEI;EACI,yCAAA;EACA,mDAAA;AnIo8rER;AmIn8rEQ;EACI,yDAAA;EACA,2BAAA;AnIq8rEZ;AmIj8rEI;EACI,2BAAA;EACA,mDAAA;AnIm8rER;AmIh8rEY;EACI,oCAAA;AnIk8rEhB;AmI/7rEY;EACI,sDAAA;AnIi8rEhB;;AmIz7rEA;EACI,2BAAA;AnI47rEJ;;AmIt7rEI;EACE,aAAA;EACA,8BAAA;AnIy7rEN;AmIr7rEM;EACE,mDAAA;EACA,2BAAA;AnIu7rER;AmIn7rEI;;EAEE,iCAAA;EACA,uCAAA;EACA,wCAAA;AnIq7rEN;AmIl7rEI;;EAEE,iCAAA;EACA,oCAAA;EACA,qCAAA;AnIo7rEN;;AmI/6rEI;EACI,2BAAA;AnIk7rER;;AoInnsEA;EACI,gBAAA;ApIsnsEJ;AoIpnsEI;;EAEI,mBAAA;EACA,gBAAA;ApIsnsER;AoInnsEI;EACI,mBAAA;EACA,mBAAA;EACA,iBAAA;ApIqnsER;;AoIjnsEA;EACI,sCzH8pB0B;AXs9qE9B;AoIlnsEI;EACI,oCzHy7BgC;EyHx7BhC,8BAAA;EACA,+BAAA;ApIonsER;;AoIhnsEA;EACI,wCAAA;EACA,sBzH+lB0B;AXohrE9B;;AoIhnsEA;EACI,iDAAA;ApImnsEJ;AoIjnsEI;EACI,wBAAA;EACA,mCAAA;ApImnsER;AoIjnsEQ;EACI,yBAAA;ApImnsEZ;AoI/msEI;EACI,2BAAA;EACA,4BAAA;EACA,oCzH+5BgC;AXktqExC;AoI9msEY;EACI,yBAAA;ApIgnsEhB;AoI5msEQ;EACI,6CzH+kBkB;EyH9kBlB,qBzHqkBkB;AXyirE9B;;AoIvmsEI;;;EAGI,oCAAA;ApI0msER;AoIvmsEI;EACI,kCAAA;ApIymsER;AoIrmsEQ;EACI,QAAA;EACA,UAAA;ApIumsEZ;AoIlmsEQ;EACI,mCAAA;ApIomsEZ;;AoI9lsEI;EACI,sCAAA;EACA,+CAAA;ApIimsER;;AqI3rsEA;EACI,2B1HsyB0B;E0HryB1B,UAAA;EACA,cAAA;ArI8rsEJ;;AqI3rsEA;EACI,gBAAA;EACA,wCAAA;EACA,kBAAA;ArI8rsEJ;AqI5rsEI;EACI,wBAAA;ArI8rsER;AqI3rsEI;EACI,WAAA;ArI6rsER;AqI1rsEI;EACI,YAAA;ArI4rsER;AqIzrsEI;EACI,iDAAA;EACA,mBAAA;EACA,0CAAA;ArI2rsER;AqIxrsEI;EACI,mBAAA;EACA,0CAAA;ArI0rsER;;AqItrsEA;EACI,uBAAA;EACA,iBAAA;ArIyrsEJ;;AqItrsEA;EACI,WAAA;ArIyrsEJ;;AqItrsEA;EACI,6B1H2vB0B;AX87qE9B;;AqItrsEA;;EAEI,wCAAA;EACA,uBAAA;ArIyrsEJ;;AqIrrsEI;EACI,aAAA;EACA,2B1H8uBsB;E0H7uBtB,iDAAA;ArIwrsER;AqIlrsEQ;EAEI,iDAAA;ArImrsEZ;;AqI9qsEA;EACI,cAAA;ArIirsEJ;;AqI9qsEA;EACI,gBAAA;EACA,wCAAA;EACA,aAAA;EACA,6B1HytB0B;AXw9qE9B;;AqI9qsEA;EACI,c1HyEO;E0HxEP,0BAAA;ArIirsEJ;;AqI5qsEI;EACI,mBAAA;EACA,iCAAA;EACA,wCAAA;EACA,0C1HwtC4B;E0HvtC5B,2B1HqckC;AX0urE1C;AqI7qsEQ;EACI,8CAAA;ArI+qsEZ;AqI5qsEQ;EAGI,c1HqDD;E0HpDC,0C1H6sCwB;AX+9pEpC;AqIzqsEQ;EACI,yB1H4CD;E0H3CC,iC1Hyb8B;AXkvrE1C;AqIxqsEQ;EACI,gBAAA;ArI0qsEZ;AqIrqsEY;EACI,6BAAA;ArIuqsEhB;AqInqsEQ;EACI,yB1HwDC;E0HvDD,W1HyBD;E0HxBC,qB1HsDC;E0HrDD,gB1HFS;AXuqsErB;;AqIhqsEA;EACI,kBAAA;EACA,WAAA;ArImqsEJ;AqIjqsEI;EACI,gBAAA;EACA,wBAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,eAAA;EACA,c1HYG;AXupsEX;;AqI/psEA;EACI,oC1HwzBoC;E0HvzBpC,oC1HizBoC;E0HhzBpC,2B1HqzBoC;E0HpzBpC,gB1H0iB0B;E0HziB1B,sCAAA;EACA,sB1Hie0B;EF1VxB,oBALI;ATiisEV;AqIhqsEI;EACI,gBAAA;EACA,0C1HuzBgC;E0HtzBhC,oC1HuyBgC;AX23qExC;AqI/psEI;EACI,c1HRG;AXyqsEX;;AqI5psEI;EACI,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,gB1H+gBsB;AXgprE9B;;AqI3psEA;EACI,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;ArI8psEJ;;AqI3psEA;EACI,wBAAA;ArI8psEJ;;AqI1psEI;EACI,oBAAA;ArI6psER;;AqIppsEI;EACI,sBAAA;ArIupsER;AqIppsEI;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;ArIspsER;AqInpsEI;EACI,iBAAA;ArIqpsER;;AqI/osEI;EACI,8C1HylBsB;AXyjrE9B;AqIhpsEI;EACI,yB1HzCK;E0H0CL,qB1H1CK;E0H8CD,0DAAA;ArI+osEZ;;AqI1osEI;EACI,Y1HqwBkC;E0HpwBlC,a1HowBkC;E0HnwBlC,mBAAA;EACA,oC1H4tBgC;E0H3tBhC,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,8C1HywBkC;E0HxwBlC,gBAAA;EACA,+BAAA;ArI6osER;AqI3osEQ;EzHpOJ,qBAAA;AZk3sEJ;;AqIvosEI;EACI,qBAAA;EACA,oBAAA;ArI0osER;;AqItosEA;EACI,0CAAA;ArIyosEJ;;AqIposEQ;EACI,kD1H27CiB;AX4spE7B;;AsI94sEA;EACI,gBAAA;EACA,yBAAA;EACA,QAAA;AtIi5sEJ;AsI/4sEQ;EACI,cAAA;EACA,yBAAA;EACA,2B3H2hB8B;E2H1hB9B,0C3H4yCwB;E2H3yCxB,wCAAA;EACA,sB3HgnBkB;AXiyrE9B;AsI74sEY;EACI,W3HsIL;EiBtJT,yBjBoLW;E2HlKG,qB3HkKH;AX6usEb;;AsIz4sEA;EACI,yBAAA;UAAA,iBAAA;EACA,aAAA;EACA,mBAAA;AtI44sEJ;AsI34sEI;EACI,qBAAA;EACA,qBAAA;AtI64sER;;AsIz4sEA;;EAEI,c3HgJS;E2H/IT,gB3HwFiB;E2HvFjB,yBAAA;EACA,0C3H8wCgC;E2H7wChC,wCAAA;EACA,sB3HklB0B;AX0zrE9B;AsI34sEI;;EACI,0DAAA;AtI84sER;AsI34sEI;;EACI,c3H6GG;E2H5GH,eAAA;AtI84sER;AsI54sEQ;;EACI,c3HyGD;AXsysEX;;AuIl8sEA;EACI,2BAAA;AvIq8sEJ;AuIp8sEI;EACI,iDAAA;AvIs8sER;AuIp8sEI;EACI,cAAA;AvIs8sER;;AuIl8sEA;;EAEI,iDAAA;AvIq8sEJ;;AuIl8sEA;EACI,mDAAA;EACA,qDAAA;EACA,uDAAA;AvIq8sEJ;AuIp8sEI;EACI,iDAAA;EACA,yBAAA;AvIs8sER;AuIn8sEI;EACI,4DAAA;EACA,0DAAA;AvIq8sER;;AuIh8sEI;EACI,sBAAA;AvIm8sER;;AuI/7sEA;EACI,gB5HwFiB;AX02sErB;;AuI/7sEA;EACI,oBAAA;EACA,uCAAA;AvIk8sEJ;;AuI/7sEA;EACI,yBAAA;EACA,iDAAA;EACA,0BAAA;AvIk8sEJ;;AuI/7sEA;EACI,qBAAA;AvIk8sEJ;;AuI/7sEA;EACI,a5HmGO;AX+1sEX;;AuI77sEI;;EACI,iDAAA;EACA,a5H4FG;AXq2sEX;;AuI77sEA;EACI,gBAAA;AvIg8sEJ;;AuI37sEA;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;AvI87sEJ;;AuI37sEA;EACI,eAAA;AvI87sEJ;;AuI37sEA;;EAEI,UAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oCAAA;EACA,wCAAA;AvI87sEJ;;AuI37sEA;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;AvI87sEJ;AuI77sEI;EACI,wBAAA;EACA,6BAAA;AvI+7sER;;AuI37sEA;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,6BAAA;AvI87sEJ;AuI77sEI;EACI,sCAAA;EACA,wBAAA;EACA,UAAA;AvI+7sER;;AuI37sEA;EACI;IACI,0BAAA;EvI87sEN;EuI57sEE;IACI,2BAAA;EvI87sEN;AACF;AuIx7sEI;EACI,8B5HqfsB;AXq8rE9B;;AuIr7sEI;EACI,8B5H+esB;AXy8rE9B;AuIt7sEI;EACI,0BAAA;AvIw7sER;;AuIh7sEQ;;EACI,8BAAA;AvIo7sEZ;AuIh7sEI;EACI,8BAAA;AvIk7sER;AuI76sEQ;;EACI,gCAAA;AvIg7sEZ;AuI36sEQ;EACI,uBAAA;AvI66sEZ;AuIz6sEI;EACI,gCAAA;AvI26sER;AuIv6sEQ;EACI,8BAAA;AvIy6sEZ;AuIn6sEQ;;EACI,gCAAA;AvIs6sEZ;;AwI3ltEA;EACE,iBAAA;AxI8ltEF;;AyIhmtEA;EACI,aAAA;AzImmtEJ;;AyIhmtEA;EACI,aAAA;AzImmtEJ;;A0IvmtEA;EACE,aAAA;EACA,mB/HoJS;E+HnJT,kBAAA;A1I0mtEF;;A0IvmtEA;EACE,cAAA;EACA,kBAAA;EACA,W/H4IS;E+H3IT,eAAA;EACA,iBAAA;EACA,mB/HuKW;E+HtKX,kBAAA;EACA,kBAAA;A1I0mtEF;;A0IvmtEA;EACE,SAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;A1I0mtEF;A0IzmtEE;EACE,aAAA;EACA,mCAAA;EACA,oCAAA;EACA,8BAAA;A1I2mtEJ;A0IzmtEE;EACE,UAAA;EACA,mCAAA;EACA,oCAAA;EACA,iCAAA;A1I2mtEJ;;A2I7otEA;EACI,cAAA;A3IgptEJ;A2I9otEI;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EAEA,oBhI4qBsB;EgI3qBtB,gBhIirBsB;EgIhrBtB,gBhIurBsB;EgItrBtB,2BhIg8BgC;EgI/7BhC,oChI07BgC;EgIz7BhC,4BAAA;EACA,wCAAA;EACA,sBhI2mBsB;EgI1mBtB,sBAAA;A3I+otER;A2I7otEQ;EACI,qBAAA;EACA,yBAAA;EACA,+BAAA;A3I+otEZ;A2I5otEQ;EACI,8CAAA;EACA,2BhIi7B4B;AX6trExC;A2I3otEQ;EACI,2BhI66B4B;AXgurExC;A2IzotEI;EACI,sBhIulBsB;EgItlBtB,oChIytC4B;EgIxtC5B,sBhIgHG;EgI/GH,6ChI+lBsB;EgI9lBtB,UAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,6BAAA;EACA,wBAAA;EACA,yBAAA;A3I2otER;A2IzotEQ;EACI,oBhIooBkB;EgInoBlB,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBhIiGD;EgIhGC,2BhIssCwB;AXq8qEpC;A2IzotEY;EACI,chI8HH;EgI7HG,gBhIkoBc;EgIjoBd,YAAA;A3I2otEhB;A2IxotEY;EAEI,4BhIusCoB;EiBvwClC,yBjBuJS;AXmjtEX;A2IrotEQ;EACI,sBAAA;EACA,kBAAA;EACA,gBhIqDS;AXkltErB;;A4I/stEA;EACI,kBAAA;EACA,yBjIkLS;EiIjLT,sCjI4qB0B;EiI3qB1B,6CjIkoB0B;EiIjoB1B,gBAAA;A5IkttEJ;;A4I9stEI;EACI,sCjIqqBsB;EiIpqBtB,oBjI0qBsB;EiIzqBtB,wBAAA;A5IittER;;A4I7stEA;EACI,yBjImKS;AX6itEb;;A6IjutEA;EACI,aAAA;A7IoutEJ;A6InutEI;EACI,UAAA;EACA,oClIK0C;AXgutElD;;A8IxutEA;;EAEI,wCAAA;A9I2utEJ;;A8ItutEQ;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;A9IyutEZ;A8ItutEQ;EAEI;;;IAGI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,WAAA;IACA,cAAA;E9IuutEd;E8IputEU;IACI,WAAA;E9IsutEd;E8InutEU;IACI,aAAA;E9IqutEd;AACF;A8IlutEQ;EACI,0BAAA;A9IoutEZ;A8IhutEI;EACI,iCAAA;A9IkutER;A8I/ttEI;EACI,cAAA;EACA,gBAAA;A9IiutER;A8I9ttEI;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBnImEa;EmIlEb,WAAA;A9IgutER;A8I5ttEQ;EACI,wCAAA;A9I8ttEZ;A8I5ttEY;EACI,yBnIiHH;EmIhHG,WnIkFL;AX4otEX;A8IxttEQ;EACI,wCAAA;A9I0ttEZ;A8IrttEQ;EACI,wCAAA;A9IuttEZ;A8InttEI;EACI,uBAAA;A9IqttER;A8IjttEQ;EACI,sBAAA;A9ImttEZ;A8I/stEI;;;EAGI,sBAAA;A9IittER;A8I9stEI;EACI,6CAAA;EACA,4CAAA;A9IgttER;A8I7stEI;EACI,aAAA;A9I+stER;;A8I3stEA;EACI,2BAAA;A9I8stEJ;;A8I3stEA;EACI,WnIkCO;AX4qtEX;;A8I1stEI;EACI,mBnIgCG;EmI/BH,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBnIgkBsB;AX6osE9B;;A8IvstEI;;;;;;;;;;EAUI,qBnIYG;AX8rtEX;A8IvstEI;EACI,sCAAA;A9IystER;;A8IrstEA;EACI,oCAAA;EACA,oCnIge0B;EmI/d1B,cnIKO;EmIJP,0BAAA;EACA,gBAAA;EACA,4BAAA;EACA,uBAAA;A9IwstEJ;;A8IrstEA;;;EAGI,yBnIkBS;EmIjBT,WnIbO;EmIcP,iBAAA;A9IwstEJ;;A8IrstEA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;A9IwstEJ;;A8IrstEA;;EAEI,yBnICS;AXustEb;;A8IrstEA;;EAEI,yBnIJS;AX4stEb;;A8IjstEA;;EAEI,2BAAA;EACA,uBAAA;EACA,mBAAA;A9IostEJ;;A8IjstEA;EACI,6BAAA;EACA,aAAA;A9IostEJ;;A8IjstEA;EACI,aAAA;A9IostEJ;;A8IjstEA;EACI,WnI1DO;AX8vtEX;;A8IhstEI;EACI,gBAAA;EACA,iBAAA;EACA,aAAA;A9ImstER;;A8I7rtEI;EACI,cnIvEG;AXuwtEX;;A8I5rtEA;;EAEI,kBAAA;EACA,cAAA;EACA,aAAA;A9I+rtEJ;A8I7rtEI;;EACI,kBAAA;EACA,iCAAA;EACA,eAAA;EACA,MAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A9IgstER;;A8I3rtEI;EACI,gBAAA;A9I8rtER;;A8IzrtEI;EACI,gBAAA;A9I4rtER;;A8IvrtEI;EACI,gBnIoYsB;AXszsE9B;A8IzrtEQ;EACI,cnInFC;EmIoFD,0CAAA;EACA,YAAA;EACA,gBAAA;A9I2rtEZ;A8IzrtEY;EAEI,WnIvHL;EmIwHK,yBnI3FH;AXqxtEb;A8IrrtEI;EACI,oCAAA;EACA,enIlGK;AXyxtEb;;A8IlrtEI;EADJ;IAEQ,sBAAA;IACA,SAAA;E9IsrtEN;AACF;;A8IjrtEQ;EACI,6BAAA;A9IortEZ;;A8I9qtEI;EACI,aAAA;A9IirtER;A8I7qtEQ;EACI,aAAA;A9I+qtEZ;A8I5qtEQ;EACI,aAAA;A9I8qtEZ;A8I3qtEQ;EACI,cAAA;A9I6qtEZ;;A8IvqtEI;EACI,0BAAA;A9I0qtER;;A8IrqtEI;EACI,0BAAA;A9IwqtER;;A8IjqtEQ;EACI,+CAAA;A9IoqtEZ;;A8I/ptEA;EACI,oCnIqS0B;AX63sE9B;;A8IzptEgB;;EAEI,yBAAA;A9I4ptEpB;;A8InptEgB;EACI,yBAAA;A9IsptEpB;;A8I9otEY;EACI,yBAAA;A9IiptEhB;A8I/otEsC;EACd,yBAAA;A9IiptExB;A8I7otEgB;EACI,qBnI3JL;AX0ytEf;;A8I5qtEgB;;EAEI,yBAAA;A9I+qtEpB;;A8ItqtEgB;EACI,yBAAA;A9IyqtEpB;;A8IjqtEY;EACI,yBAAA;A9IoqtEhB;A8IlqtEsC;EACd,yBAAA;A9IoqtExB;A8IhqtEgB;EACI,qBnI3JL;AX6ztEf;;A8I/rtEgB;;EAEI,yBAAA;A9IkstEpB;;A8IzrtEgB;EACI,yBAAA;A9I4rtEpB;;A8IprtEY;EACI,yBAAA;A9IurtEhB;A8IrrtEsC;EACd,yBAAA;A9IurtExB;A8InrtEgB;EACI,qBnI3JL;AXg1tEf;;A8IlttEgB;;EAEI,yBAAA;A9IqttEpB;;A8I5stEgB;EACI,yBAAA;A9I+stEpB;;A8IvstEY;EACI,yBAAA;A9I0stEhB;A8IxstEsC;EACd,yBAAA;A9I0stExB;A8ItstEgB;EACI,qBnI3JL;AXm2tEf;;A8IrutEgB;;EAEI,yBAAA;A9IwutEpB;;A8I/ttEgB;EACI,yBAAA;A9IkutEpB;;A8I1ttEY;EACI,yBAAA;A9I6ttEhB;A8I3ttEsC;EACd,yBAAA;A9I6ttExB;A8IzttEgB;EACI,qBnI3JL;AXs3tEf;;A8IxvtEgB;;EAEI,yBAAA;A9I2vtEpB;;A8IlvtEgB;EACI,yBAAA;A9IqvtEpB;;A8I7utEY;EACI,yBAAA;A9IgvtEhB;A8I9utEsC;EACd,yBAAA;A9IgvtExB;A8I5utEgB;EACI,qBnI3JL;AXy4tEf;;A8I3wtEgB;;EAEI,yBAAA;A9I8wtEpB;;A8IrwtEgB;EACI,yBAAA;A9IwwtEpB;;A8IhwtEY;EACI,yBAAA;A9ImwtEhB;A8IjwtEsC;EACd,yBAAA;A9ImwtExB;A8I/vtEgB;EACI,qBnI3JL;AX45tEf;;A8I9xtEgB;;EAEI,yBAAA;A9IiytEpB;;A8IxxtEgB;EACI,yBAAA;A9I2xtEpB;;A8InxtEY;EACI,yBAAA;A9IsxtEhB;A8IpxtEsC;EACd,yBAAA;A9IsxtExB;A8IlxtEgB;EACI,qBnI3JL;AX+6tEf;;A8I5wtEI;EACI,gCAAA;A9I+wtER;;A8I3wtEA;EACI,cAAA;A9I8wtEJ;A8I7wtEI;EACI,mBAAA;A9I+wtER;;A+IvpuEA;EACI,uBAAA;EACA,uDAAA;EACA,oBAAA;EACA,aAAA;A/I0puEJ;A+IxpuEI;EACI,iDAAA;EACA,sCAAA;A/I0puER;A+IxpuEI;EAVJ;IAWQ,qBAAA;IACA,oBAAA;IACA,aAAA;E/I2puEN;AACF;A+IzpuEI;EACI,yBAAA;A/I2puER;A+IxpuEI;EACI,uBAAA;A/I0puER;A+IzpuEQ;EACI,+CAAA;EACA,sCAAA;EACA,iCAAA;EACA,+BAAA;A/I2puEZ;A+I1puEY;EACI,yBAAA;A/I4puEhB;A+IxpuEQ;EACI,qCAAA;EACA,WAAA;EACA,SAAA;A/I0puEZ;A+ItpuEI;EACI,oCAAA;A/IwpuER;A+IvpuEQ;EACI,kDAAA;A/IypuEZ;A+ItpuEY;EACI,kDAAA;A/IwpuEhB;;A+IjpuEA;EACI,6DAAA;A/IopuEJ;;A+IjpuEA;EACI,qDAAA;A/IopuEJ;;AgJ9suEA;;EAEI,kBAAA;EACA,aAAA;EACA,gBrIwrB0B;EqIvrB1B,8CAAA;AhJituEJ;;AgJ9suEA;;;;;EAKI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,oCAAA;AhJituEJ;;AgJ9suEA;;;;;EAKI,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,iBAAA;EACA,oCAAA;AhJituEJ;;AgJ9suEA;EACI,gBrIypB0B;EqIxpB1B,gBAAA;AhJituEJ;;AgJrsuEgC;EACI,yBrImIvB;EqIlIuB,sCAAA;AhJwsuEpC;AgJ/ruEwC;EACI,yBrI2H/B;AXskuEb;AgJ1ruEoC;EACI,yBrImH3B;AXykuEb;AgJ9quEwB;EACI,gBAAA;AhJgruE5B;;AgJpquEI;;EAEI,kBAAA;EACA,mBAAA;AhJuquER;AgJpquEI;;EAEI,kBAAA;AhJsquER;AgJlquEQ;EACI,WAAA;AhJoquEZ;AgJ/puEgB;EACI,wBAAA;AhJiquEpB;AgJ9puEgB;EACI,cAAA;AhJgquEpB;;AgJrpuEY;EACI,sBrIoBL;EqInBK,oCrIofc;EqInfd,gBAAA;EACA,WAAA;AhJwpuEhB;AgJtpuEY;EACI,gBrI22CoB;AX6yrEpC;AgJvpuEgB;EACI,sBrI6iBU;EqI5iBV,gBrIijBU;EqIhjBV,mBAAA;AhJypuEpB;AgJrpuEwB;EACI,uBAAA;AhJupuE5B;AgJlpuEY;EACI,eAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,0CAAA;EACA,oCrIydc;AX2rtE9B;AgJnpuEgB;EACI,iCAAA;AhJqpuEpB;;AgJ1ouEI;;;;EAII,oCrIwcsB;EqIvctB,2BAAA;EACA,yBAAA;AhJ6ouER;;AiJ9zuEA;EACI,sBAAA;AjJi0uEJ;;AiJ9zuEI;EACI,wCAAA;EACA,gCtI89BgC;EsI79BhC,oCtIg8BgC;EsI/7BhC,aAAA;AjJi0uER;AiJh0uEQ;EACI,iBAAA;EACA,kBAAA;EACA,2BtIg8B4B;AXk4sExC;AiJh0uEQ;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,UAAA;AjJk0uEZ;AiJj0uEY;EACI,wEAAA;EACA,2BAAA;AjJm0uEhB;;AiJ1zuEY;EACI,mFAAA;EACA,sCAAA;AjJ6zuEhB;;AiJvzuEA;EACI,iBAAA;AjJ0zuEJ;;AiJvzuEA;EACI,sCAAA;EACA,4CtIwlB0B;EsIvlB1B,sCAAA;EACA,aAAA;AjJ0zuEJ;;AiJtzuEI;EACI,6CtIs5BgC;AXm6sExC;AiJvzuEI;EACI,aAAA;EACA,sCAAA;AjJyzuER;AiJxzuEQ;EACI,aAAA;EACA,wCAAA;EACA,oCtI44B4B;EsI34B5B,2BtIg5B4B;EsI/4B5B,sBtI8jBkB;AX4vtE9B;AiJvzuEI;EACI,yBtImHK;AXssuEb;AiJvzuEI;EACI,sCAAA;EACA,0CAAA;AjJyzuER;AiJxzuEQ;EACI,yBtI6GC;EsI5GD,WtI8ED;AX4uuEX;AiJtzuEQ;EACI,kBAAA;EACA,kBAAA;AjJwzuEZ;AiJpzuEQ;EACI,aAAA;EACA,UAAA;EACA,aAAA;EACA,UAAA;AjJszuEZ;;AiJ/yuEI;EACI,oCtIs4BgC;EsIr4BhC,mDAAA;EACA,oCtIu2BgC;AX28sExC;AiJhzuEQ;EACI,gBAAA;AjJkzuEZ;AiJhzuEQ;EACI,SAAA;EACA,2BtIq2B4B;AX68sExC;AiJhzuEQ;EACI,yBtI0EC;EsIzED,YAAA;EACA,WtI0CD;EsIzCC,kBAAA;EACA,YAAA;EACA,eAAA;AjJkzuEZ;AiJhzuEQ;EACI,WtIoCD;EsInCC,iBAAA;EACA,oCAAA;EACA,cAAA;EACA,QAAA;AjJkzuEZ;AiJjzuEY;EACI,WtI8BL;EsI7BK,yBtI2DH;AXwvuEb;AiJ9yuEQ;EACI,eAAA;EACA,sCtI+iBkB;AXiwtE9B;AiJ3yuEY;EACI,ctIsBL;AXuxuEX;;AiJryuEQ;EACI,6CtI0zB4B;EsIzzB5B,eAAA;AjJwyuEZ;;AkJ17uEA;EACI,kBAAA;AlJ67uEJ;AkJ17uEQ;EACI,iBAAA;EACA,gBAAA;AlJ47uEZ;AkJ17uEY;EACI,wBAAA;AlJ47uEhB;AkJz7uEY;EACI,UAAA;AlJ27uEhB;AkJx7uEY;EACI,YAAA;AlJ07uEhB;AkJv7uEY;EACI,iDAAA;EACA,kBAAA;AlJy7uEhB;AkJt7uEY;EACI,kBAAA;AlJw7uEhB;;AkJj7uEI;EACI,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,6BAAA;EACA,qBAAA;AlJo7uER;;AkJ96uEI;;EACI,iBAAA;EACA,oCAAA;EACA,kBAAA;EACA,avI6yBsB;EuI5yBtB,WvI2yBsB;EuI1yBtB,eAAA;AlJk7uER;;AkJ76uEI;EACI,aAAA;AlJg7uER;;AkJ36uEI;EACI,aAAA;AlJ86uER;;AmJz+uEA;EACI,kBAAA;EACA,WxImJO;EwIlJP,qBAAA;EACA,uFAAA;EACA,mBxIoLS;EwInLT,eAAA;EACA,UAAA;EACA,wDAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;AnJ4+uEJ;AmJ3+uEI;EACI,UAAA;AnJ6+uER;;AmJx+uEA;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AnJ2+uEJ;;AmJx+uEA;EACI,WAAA;AnJ2+uEJ;;AmJx+uEA;EACI,UAAA;AnJ2+uEJ;AmJ1+uEI;EACI,UAAA;EACA,cAAA;EACA,iBAAA;AnJ4+uER;;AmJx+uEA;EACI,WAAA;AnJ2+uEJ;;AmJx+uEA;EACI,cAAA;AnJ2+uEJ;;AmJx+uEA;EACI,mBAAA;AnJ2+uEJ;;AmJx+uEA;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AnJ2+uEJ;;AmJx+uEA;EACI,iBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,sBAAA;EACA,2BAAA;AnJ2+uEJ;;AmJx+uEA;EACI;IACI,iBAAA;IACA,kBAAA;IACA,OAAA;IACA,QAAA;IACA,2BAAA;IAAA,sBAAA;EnJ2+uEN;AACF;AoJ1jvEA;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;ApJ4jvEJ;AoJ1jvEI;EACI,aAAA;ApJ4jvER;AoJzjvEI;EACI,gBAAA;ApJ2jvER;AoJvjvEQ;;EAEI,iDAAA;EACA,mBAAA;EACA,yBAAA;UAAA,iBAAA;ApJyjvEZ;AoJtjvEQ;EACI,mBAAA;ApJwjvEZ;AoJpjvEI;EACI,wBAAA;ApJsjvER;AoJljvEI;EACI,eAAA;ApJojvER;AoJnjvEQ;EACI,uBAAA;ApJqjvEZ;AoJljvEQ;EACI,cAAA;EACA,WAAA;EACA,sBAAA;EACA,oCzI85B4B;EyI75B5B,wCAAA;EACA,oBzI0oBkB;EyIzoBlB,sBzI+kBkB;EyI9kBlB,2BzI+5B4B;EyI95B5B,mBAAA;ApJojvEZ;AoJjjvEQ;EACI,0DAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;ApJmjvEZ;AoJjjvEY;EACI,UAAA;ApJmjvEhB;AoJhjvEY;EACI,mCAAA;ApJkjvEhB;AoJ9ivEQ;EACI,aAAA;ApJgjvEZ;AoJ7ivEQ;EACI,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,6CAAA;EACA,aAAA;EACA,UAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;ApJ+ivEZ;AoJ5ivEQ;EACI,aAAA;EACA,2CAAA;ApJ8ivEZ;AoJpivEQ;EACI,YAAA;EACA,qBzI+uBkB;AXuztE9B;AoJnivEQ;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,+CAAA;EACA,eAAA;EACA,0DAAA;EACA,oBAAA;EACA,UAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;ApJqivEZ;AoJpivEY;EACI,UAAA;ApJsivEhB;AoJnivEQ;EACI,oBAAA;ApJqivEZ;AoJpivEY;EACI,gBAAA;ApJsivEhB;AoJhivEQ;EACI,gBAAA;ApJkivEZ;;AoJ3hvEI;EACI,iCAAA;EACA,YAAA;ApJ8hvER;;AoJ1hvEA;EACI,qBAAA;EACA,sBAAA;EACA,WAAA;EACA,oCzIyyBoC;EyIxyBpC,qCAAA;EACA,wCAAA;EACA,iCAAA;EACA,oBzImhB0B;EyIlhB1B,kBAAA;EACA,gBAAA;ApJ6hvEJ;;AoJvhvEI;;EACI,0CzI2yBgC;AXgvtExC;;AoJvhvEA;EACI,SAAA;EACA,eAAA;EACA,gBAAA;ApJ0hvEJ;;AoJvhvEA;EACI,qBAAA;EACA,yBAAA;EACA,WAAA;ApJ0hvEJ;AoJxhvEI;EACI,WAAA;ApJ0hvER;;AoJthvEA;EACI,eAAA;ApJyhvEJ;AoJxhvEI;EACI,qBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBzIofsB;EyInftB,oBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBzIvBK;EyIwBL,yBAAA;EACA,qBAAA;EACA,sBAAA;EACA,WzIzDG;EyI0DH,gBzIwbsB;AXkmuE9B;AoJzhvEQ;EACI,kBAAA;ApJ2hvEZ;AoJxhvEQ;EACI,yBzIlCC;EyImCD,yBAAA;ApJ0hvEZ;;AoJlhvEQ;EACI,yBzI7CC;EyI8CD,yBAAA;ApJqhvEZ;;AoJhhvEA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;EACA,wCAAA;EACA,6CzIyZ0B;EyIxZ1B,SAAA;EACA,aAAA;EACA,4BAAA;EACA,gCAAA;EACA,iCAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,0BAAA;ApJmhvEJ;AoJlhvEI;EACI,mBAAA;EACA,6BAAA;ApJohvER;AoJjhvEI;EACI,iDAAA;ApJmhvER;AoJhhvEI;EACI,qBAAA;ApJkhvER;AoJ/gvEI;EACI,kBAAA;EACA,gBzI3Ia;AX4pvErB;AoJ9gvEI;EACI,aAAA;ApJghvER;;AoJ3gvEI;EACI,oCzI4+B4B;AXkitEpC;;AoJzgvEI;EACI,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,kCAAA;ApJ4gvER;AoJ3gvEQ;EACI,iCAAA;EACA,2BAAA;ApJ6gvEZ;;AoJvgvEI;EACI,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;EACA,4BAAA;ApJ0gvER;AoJvgvEI;EACI,kBAAA;EACA,oBzIsYsB;EyIrYtB,oCAAA;ApJygvER;;AoJngvEA;EAIY;IACI,+BAAA;IACA,eAAA;IACA,UAAA;IACA,kBAAA;IACA,WAAA;IACA,QAAA;IACA,2BAAA;EpJmgvEd;EoJ//uEc;IACI,YAAA;EpJigvElB;AACF;AoJz/uEA;EACI,eAAA;ApJ2/uEJ;;AoJx/uEA;EACI,eAAA;ApJ2/uEJ;;AoJx/uEA;EACI,mBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,YAAA;ApJ2/uEJ;;AoJx/uEA;EACI,gBzI8V0B;EyI7V1B,eAAA;EACA,kBAAA;EACA,+CAAA;EACA,czItMO;AXisvEX;;AoJx/uEA;EACI,oBAAA;EACA,gBAAA;EACA,SAAA;EACA,6BAAA;EACA,4BAAA;EACA,2BAAA;EACA,eAAA;ApJ2/uEJ;AoJ1/uEI;EACI,aAAA;ApJ4/uER;;AoJx/uEA;EACI,qBAAA;EACA,wBAAA;EACA,oCzIklBoC;EyIjlBpC,2BzIslBoC;EyIrlBpC,oBzI8T0B;EyI7T1B,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;ApJ2/uEJ;AoJ1/uEI;EACI,UAAA;ApJ4/uER;AoJ1/uEI;EACI,czIrOG;AXiuvEX;;AoJx/uEA;EACI,czI1OO;EyI2OP,UAAA;ApJ2/uEJ;;AoJr/uEQ;EACI,kDzIozCiB;AXossE7B;;AqJt4vEA;EACI,uBAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;EACA,gCAAA;EACA,4KAAA;ArJy4vEJ;AqJv4vEI;EAEI,UAAA;EACA,iBAAA;EACA,mBAAA;ArJw4vER;AqJr4vEI;EACI,qBAAA;EACA,aAAA;ArJu4vER;AqJp4vEI;EACQ,4DAAA;ArJs4vEZ;AqJn4vEI;EACI,cAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;ArJq4vER;AqJn4vEQ;EACI,cAAA;EACA,WAAA;ArJq4vEZ;AqJn4vEY;EACI,WAAA;EACA,wCAAA;EACA,gBAAA;EACA,0BAAA;ArJq4vEhB;AqJl4vEgB;EACI,WAAA;EACA,eAAA;EACA,eAAA;ArJo4vEpB;AqJl4vEoB;EACI,eAAA;EACA,kBAAA;ArJo4vExB;AqJ93vEQ;EACI,mDAAA;EACA,sB1IsjBkB;AX00uE9B;AqJ53vEI;EACI,kBAAA;EACA,qBAAA;ArJ83vER;AqJ73vEQ;EACI,YAAA;EACA,cAAA;ArJ+3vEZ;AqJ33vEI;EACI,2BAAA;ArJ63vER;AqJ13vEI;EACI,6CAAA;ArJ43vER;AqJz3vEI;;EAEI,gBAAA;EACA,6BAAA;EACA,4BAAA;ArJ23vER;AqJx3vEI;EACI,cAAA;ArJ03vER;AqJv3vEI;EACI,YAAA;EACA,4CAAA;ArJy3vER;AqJt3vEI;EACI,YAAA;ArJw3vER;AqJr3vEI;EAEI,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;ArJs3vER;AqJn3vEI;EAIE,UAAA;EACA,WAAA;ArJk3vEN;AqJ/2vEI;EAEE,SAAA;EACA,UAAA;ArJg3vEN;AqJ72vEI;EACI,iBAAA;EACA,cAAA;ArJ+2vER;AqJ72vEI;EACI,iBAAA;EACA,cAAA;ArJ+2vER;AqJ52vEI;EAEI,YAAA;ArJ62vER;AqJ32vEI;EACI,4B1I8BK;AX+0vEb;AqJ32vEI;EACI,4B1I2BK;AXk1vEb;AqJ12vEI;EAEI,SAAA;ArJ22vER;AqJz2vEI;EACI,yB1ImBK;AXw1vEb;AqJz2vEI;EACI,yB1IgBK;AX21vEb;AqJz2vEI;EACI,UAAA;ArJ22vER;;AqJv2vEA;EACI,kBAAA;EACA,qBAAA;ArJ02vEJ;;AqJv2vEA;EACI,aAAA;EACA,yB1IES;E0IDT,8BAAA;ArJ02vEJ;AqJx2vEI;EACI,uBAAA;EACA,+BAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,SAAA;ArJ02vER;AqJv2vEI;;EAEI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,+BAAA;EACA,8BAAA;ArJy2vER;AqJv2vEQ;;EACE,aAAA;ArJ02vEV;AqJv2vEQ;;EACI,kBAAA;ArJ02vEZ;AqJv2vEQ;;EACI;2BAAA;EAEA;SAAA;EAEE,OAAA;EACF;yBAAA;EAEA;SAAA;ArJ22vEZ;AqJv4vEI;;EA+BM;qBAAA;EAEF;mBAAA;ArJ62vER;AqJ12vEQ;;EACI;2BAAA;EAEA;SAAA;EAEE,QAAA;EACF;yBAAA;EAEA;SAAA;ArJ82vEZ;AqJ15vEI;;EA+CM;qBAAA;EAEF;mBAAA;ArJg3vER;AqJ72vEQ;;EACI,cAAA;ArJg3vEZ;AqJ92vEY;;EACI,8BAAA;ArJi3vEhB;AqJ72vEQ;;EACI,WAAA;EACA,YAAA;ArJg3vEZ;AqJ92vEY;;EACI,qBAAA;EACA,aAAA;ArJi3vEhB;;AqJ32vEA;EACI,kBAAA;EACA,YAAA;ArJ82vEJ;AqJ52vEI;;EAEI,qBAAA;ArJ82vER;AqJ32vEI;EACI,WAAA;ArJ62vER;AqJ32vEQ;EACI,aAAA;ArJ62vEZ;AqJ12vEQ;EAEI,SAAA;EACA,wBAAA;ArJ22vEZ;AqJv2vEI;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,gDAAA;EACA,sBAAA;ArJy2vER;AqJv2vEQ;EACI,8BAAA;ArJy2vEZ;AqJt2vEQ;EACI,8BAAA;ArJw2vEZ;AqJr2vEQ;EACI,cAAA;EACA,WAAA;EACA,kBAAA;ArJu2vEZ;AqJp2vEQ;EACI,MAAA;EACA,gBAAA;ArJs2vEZ;AqJp2vEY;EACI,kCAAA;EACA,mCAAA;EACA,8CAAA;EACA,QAAA;ArJs2vEhB;AqJl2vEQ;EACI,QAAA;ArJo2vEZ;AqJl2vEY;EACI,kCAAA;EACA,mCAAA;EACA,2CAAA;EACA,QAAA;ArJo2vEhB;AqJh2vEQ;EACI,cAAA;EACA,YAAA;ArJk2vEZ;AqJh2vEY;EACI,wBAAA;ArJk2vEhB;AqJ51vEI;EACI,+BAAA;ArJ81vER;AqJ71vEQ;EACI,UAAA;ArJ+1vEZ;;AqJ11vEA;EACI,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,qCAAA;ArJ61vEJ;AqJ31vEI;EACI,oBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;ArJ61vER;AqJ31vEQ;EACI,+BAAA;ArJ61vEZ;AqJz1vEI;EACI,UAAA;EACA,aAAA;EACA,qBAAA;ArJ21vER;AqJv1vEQ;EACI,uCAAA;ArJy1vEZ;AqJv1vEQ;EACI,oCAAA;ArJy1vEZ;AqJr1vEI;EACI,uBAAA;EACA,sBAAA;EACA,cAAA;EACA,YAAA;EACA,oBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gB1IkSsB;E0IjStB,oBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,uBAAA;EACA,qBAAA;ArJu1vER;AqJr1vEQ;EACI,UAAA;ArJu1vEZ;AqJp1vEQ;EAEI,eAAA;EACA,+BAAA;EACA,uBAAA;EACA,oBAAA;ArJq1vEZ;AqJj1vEI;EACI,oBAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,gB1ImQsB;E0IlQtB,YAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EACA,uBAAA;EACA,WAAA;ArJm1vER;AqJj1vEQ;EAEI,aAAA;ArJk1vEZ;AqJ/0vEQ;EACI,6BAAA;ArJi1vEZ;AqJ90vEQ;EACI,6BAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;ArJg1vEZ;;AqJ10vEA;EACI,yB1InSS;E0IoST,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,+CAAA;ArJ60vEJ;AqJ50vEI;EACI,aAAA;EACA,SAAA;ArJ80vER;;AqJ10vEA;EACI,eAAA;EACA,cAAA;EACA,mB1IpTS;E0IqTT,W1InVO;E0IoVP,cAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,gB1IlXiB;AX+rwErB;;AqJ10vEA;;EAEI,kBAAA;ArJ60vEJ;;AqJ30vEA;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;ArJ80vEJ;AqJ70vEI;EACI,UAAA;ArJ+0vER;;AqJ30vEA;EACI,UAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,sBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,qCAAA;EACA,UAAA;ArJ80vEJ;AqJ70vEI;EACI,4BAAA;ArJ+0vER;;AqJ30vEA;EACI,gBAAA;EACA,6BAAA;EACA,oBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,qBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;ArJ80vEJ;AqJ50vEI;EAEI,gDAAA;ArJ60vER;AqJ10vEI;EAYI,eAAA;EACA,UAAA;EACA,iCAAA;EACA,6BAAA;ArJi0vER;AqJ9zvEI;EACI,qB1I3YK;E0I4YL,wCAAA;EACA,gB1IuEsB;AXyvvE9B;AqJ9zvEQ;EAEI,qB1IjZC;E0IkZD,yCAAA;EACA,qBAAA;ArJ+zvEZ;AqJ3zvEI;EAkBI,mB1IzaK;E0I0aL,gB1I0CsB;E0IzCtB,W1IzcG;E0I0cH,qB1I5aK;AXwtwEb;AqJtyvEQ;EACI,4BAAA;ArJwyvEZ;AqJvyvEY;EACI,6BAAA;ArJyyvEhB;AqJtyvEY;EACI,mBAAA;ArJwyvEhB;AqJhyvEQ;EACI,4BAAA;ArJkyvEZ;AqJ9xvEI;EACI,gBAAA;EACA,6DAAA;ArJgyvER;AqJ7xvEI;EAOI,0CAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;ArJyxvER;AqJtxvEI;EAEI,mBAAA;EACA,0CAAA;ArJuxvER;AqJpxvEI;EACI,gBAAA;EACA,6CAAA;ArJsxvER;AqJnxvEI;EACI,kBAAA;ArJqxvER;;AqJjxvEA;EACI,eAAA;ArJoxvEJ;;AqJjxvEA;EACI,WAAA;ArJoxvEJ;AqJnxvEI;EACI,eAAA;EACA,2BAAA;ArJqxvER;AqJlxvEI;EACI,WAAA;EACA,WAAA;EACA,iBAAA;ArJoxvER;AqJhxvEQ;EAEI,cAAA;EACA,WAAA;EACA,eAAA;EACA,oCAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;ArJixvEZ;;AqJ3wvEA;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;ArJ8wvEJ;;AqJ3wvEA;EACI,qBAAA;EACA,UAAA;EACA,sBAAA;ArJ8wvEJ;;AqJ3wvEA;EACI,kBAAA;EACA,UAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,aAAA;ArJ8wvEJ;AqJ5wvEI;EACI,WAAA;EACA,cAAA;EACA,WAAA;ArJ8wvER;AqJ5wvEI;EACI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;ArJ8wvER;AqJ3wvEgB;EACI,2C1I1GU;AXu3vE9B;AqJvwvEI;EACI,UAAA;ArJywvER;AqJtwvEI;EACI,UAAA;ArJwwvER;AqJpwvEI;EACI,uBAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,oBAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,qBAAA;ArJswvER;AqJpwvEQ;EACI,iBAAA;ArJswvEZ;AqJnwvEQ;EAEE,gBAAA;ArJowvEV;AqJjwvEQ;EACI,UAAA;EACA,SAAA;ArJmwvEZ;AqJ9vvEI;;EAEI,eAAA;EACA,WAAA;EACA,oBAAA;EACA,2BAAA;EACA,iBAAA;EACA,SAAA;EACA,yBAAA;UAAA,iBAAA;EACA,kBAAA;ArJgwvER;AqJ7vvEI;EACI,UAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ArJ+vvER;AqJ3vvEQ;EACI,mCAAA;ArJ6vvEZ;;AqJrvvEI;;;;;EAEI,6BAAA;ArJ2vvER;;AqJvvvEA;EACI,eAAA;EACA,oC1IiJoC;AXymvExC;;AqJvvvEA;EACI,aAAA;ArJ0vvEJ;;AqJvvvEA;EACI;IACI,UAAA;IACA,mCAAA;ErJ0vvEN;EqJxvvEE;IACI,UAAA;IACA,+BAAA;ErJ0vvEN;AACF;AqJvvvEA;;EAEI,aAAA;ArJyvvEJ;;AsJjkxEI;EACI,oB3IyGQ;E2IxGR,kBAAA;EACA,UAAA;EACA,WAAA;AtJokxER;AsJlkxEI;EACI,OAAA;EACA,6BAAA;EACA,2BAAA;AtJokxER;;AsJhkxEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;AtJmkxEJ;AsJjkxEI;EARJ;IASQ,aAAA;EtJokxEN;AACF;;AsJjkxEA;EACI,0DAAA;EACA,2BAAA;EACA,sBAAA;AtJokxEJ;AsJlkxEI;EACI,uFAAA;EACA,YAAA;AtJokxER;;AsJhkxEA;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,oBAAA;AtJmkxEJ;AsJlkxEI;EACI,WAAA;EACA,YAAA;EACA,uBAAA;AtJokxER;;AsJ9jxEQ;EACI,gBAAA;AtJikxEZ;;AsJ5jxEA;EACI,kBAAA;AtJ+jxEJ;;AsJ1jxEA;EACI,kBAAA;AtJ6jxEJ;AsJ5jxEI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,6CAAA;EACA,SAAA;AtJ8jxER;AsJ3jxEI;EACI,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,0CAAA;EACA,iBAAA;AtJ6jxER;;AsJvjxEA;EACI,yD3IgDY;AX0gxEhB;AsJxjxEI;EACI,0DAAA;EACA,2BAAA;EACA,sBAAA;EACA,UAAA;EACA,6BAAA;AtJ0jxER;AsJvjxEI;EACI,+BAAA;AtJyjxER;;AsJpjxEA;EACI,aAAA;AtJujxEJ;AsJrjxEI;EACI,kBAAA;AtJujxER;AsJrjxEQ;EACI,c3IuEC;AXg/wEb;AsJrjxEY;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AtJujxEhB;AsJnjxEQ;EACI,c3I0DC;AX2/wEb;AsJnjxEY;EACI,kBAAA;EACA,UAAA;EACA,YAAA;AtJqjxEhB;;AuJvrxEA;EACE,2BAAA;AvJ0rxEF;;AuJrrxEA;EACE,kBAAA;AvJwrxEF;AuJvrxEE;EAFF;IAGI,oBAAA;EvJ0rxEF;AACF;AuJzrxEE;EACE,6BAAA;EACA,qBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,6BAAA;AvJ2rxEJ;AuJzrxEI;EACE,yBAAA;EACA,wBAAA;AvJ2rxEN;AuJzrxEI;;EAEE,aAAA;AvJ2rxEN;AuJxrxEE;EACE,2BAAA;AvJ0rxEJ;AuJzrxEI;EACE,eAAA;EACA,WAAA;EACA,OAAA;AvJ2rxEN;AuJzrxEI;EACE,wCAAA;EACA,kBAAA;EACA,YAAA;AvJ2rxEN;AuJzrxEI;EACE,iCAAA;EACA,YAAA;AvJ2rxEN;AuJ1rxEM;EACE,qBAAA;EACA,iCAAA;AvJ4rxER;AuJxrxEM;EACE,sBAAA;EACA,yB5IuIK;E4ItIL,gCAAA;AvJ0rxER;AuJzrxEQ;EACE,yBAAA;EACA,oDAAA;AvJ2rxEV;AuJxrxEM;EACE,oCAAA;EACA,gCAAA;EACA,W5IyFG;AXimxEX;AuJvrxEI;EACE,YAAA;EACA,iBAAA;AvJyrxEN;AuJrrxEE;EACE,uBAAA;AvJurxEJ;;AuJlrxEE;EACE,8CAAA;AvJqrxEJ;AuJprxEI;EACE,WAAA;AvJsrxEN;AuJprxEI;EACE;IACE,iBAAA;EvJsrxEN;EuJprxEI;IACE,8CAAA;EvJsrxEN;AACF;AuJprxEI;EAbF;IAcI,iBAAA;IACA,+CAAA;EvJurxEJ;AACF;;AuJnrxEA;EAEI;;IAEE,WAAA;EvJqrxEJ;AACF;AuJjrxEA;EACE,2BAAA;AvJmrxEF;;AuJ9qxEA;EACE,0DAAA;EACA,sBAAA;AvJirxEF;;AuJ5qxEI;EACE,0CAAA;EACA,iBAAA;EACA,eAAA;AvJ+qxEN;AuJ7qxEM;EALF;IAMI,eAAA;IACA,gBAAA;EvJgrxEN;AACF;AuJ5qxEM;EADF;IAEI,eAAA;EvJ+qxEN;AACF;;AuJ1qxEA;EACE,kBAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AvJ6qxEF;;AuJzqxEE;;EAEE,SAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;EACA,c5I6BS;E4I5BT,qBAAA;EACA,sBAAA;AvJ4qxEJ;AuJ1qxEE;EACE,sBAAA;EACA,qBAAA;AvJ4qxEJ;;AuJvqxEE;EACE,2CAAA;EACA,0BAAA;AvJ0qxEJ;;AuJrqxEE;EACE;;IAEE,sBAAA;IACA,0BAAA;EvJwqxEJ;AACF;;AuJpqxEA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,sBAAA;AvJuqxEF;;AwJ71xEA;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;AxJg2xEF;AwJ91xEE;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,oC7I+He;E6I9Hf,SAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AxJg2xEJ;;AwJ51xEA;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AxJ+1xEF;AwJ71xEE;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;EACA,wCAAA;EACA,mBAAA;EACA,c7IoJS;E6InJT,UAAA;AxJ+1xEJ;AwJ51xEE;EACE,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AxJ81xEJ;AwJ31xEE;EACE,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,wCAAA;EACA,sB7IkkB0B;E6IjkB1B,mD7I2kB0B;AXkxwE9B;AwJ11xEE;EACE,OAAA;AxJ41xEJ;AwJ11xEI;EACE,uBAAA;EACA,iBAAA;AxJ41xEN;AwJx1xEE;EACE,SAAA;AxJ01xEJ;AwJx1xEI;EACE,WAAA;AxJ01xEN;AwJv1xEI;EACE,wBAAA;EACA,eAAA;AxJy1xEN;AwJt1xEI;EACE,UAAA;EACA,sDAAA;AxJw1xEN;;AwJn1xEA;EAEI;IACE,UAAA;IACA,aAAA;ExJq1xEJ;EwJj1xEA;IACE,WAAA;IACA,kBAAA;IACA,kBAAA;ExJm1xEF;EwJj1xEE;IAEE,QAAA;ExJk1xEJ;EwJh1xEI;IACE,WAAA;IACA,YAAA;IACA,MAAA;IACA,eAAA;IACA,OAAA;ExJk1xEN;EwJ/0xEI;IACE,WAAA;IACA,wEAAA;ExJi1xEN;EwJ90xEI;IACE,WAAA;IACA,UAAA;IACA,WAAA;IACA,QAAA;IACA,gBAAA;ExJg1xEN;AACF;AwJ30xEA;EACE,kBAAA;AxJ60xEF;AwJ30xEE;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,oC7IJe;AXi1xEnB;AwJ10xEE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AxJ40xEJ;AwJ10xEI;EACE,oBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,oC7InBa;E6IoBb,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AxJ40xEN;AwJ30xEM;EACE,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;AxJ60xER;AwJx0xEE;EACE,eAAA;EACA,gB7IjDiB;E6IkDjB,kBAAA;EACA,iBAAA;AxJ00xEJ;AwJx0xEI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,mB7IDO;E6IEP,0CAAA;EACA,mBAAA;EACA,UAAA;AxJ00xEN;AwJt0xEE;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;AxJw0xEJ;AwJv0xEI;EATF;IAUI,eAAA;ExJ00xEJ;AACF;AwJx0xEI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,0EAAA;EAEA,kBAAA;AxJy0xEN;AwJt0xEI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,wEAAA;EACA,kBAAA;AxJw0xEN;AwJr0xEI;EACE,kBAAA;EACA,WAAA;AxJu0xEN;AwJn0xEE;EACE,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;AxJq0xEJ;AwJp0xEI;EATF;IAUI,eAAA;ExJu0xEJ;AACF;AwJr0xEI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,yDAAA;EAEA,kBAAA;AxJs0xEN;AwJn0xEI;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;EACA,wEAAA;EACA,kBAAA;AxJq0xEN;AwJl0xEI;EACE,kBAAA;EACA,WAAA;AxJo0xEN;AwJh0xEE;EACE,kBAAA;EACA,qBAAA;EACA,wCAAA;EACA,kBAAA;EACA,gB7I7IO;E6I8IP,WAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AxJk0xEJ;AwJh0xEI;EACE,cAAA;AxJk0xEN;AwJh0xEM;EACE,UAAA;EACA,gBAAA;EACA,UAAA;EACA,wEAAA;AxJk0xER;AwJ/zxEM;EACE,UAAA;EACA,gBAAA;EACA,UAAA;EACA,0EAAA;EAEA,kBAAA;EACA,UAAA;AxJg0xER;;AwJzzxEA;EACE,kBAAA;EACA,WAAA;EACA,cAAA;AxJ4zxEF;AwJ1zxEE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,OAAA;EACA,WAAA;EACA,0C7ItMe;AXkgyEnB;AwJxzxEI;EACE,qBAAA;EACA,6BAAA;EACA,gBAAA;AxJ0zxEN;AwJxzxEM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,mB7I1KK;E6I2KL,WAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;EACA,0CAAA;AxJ0zxER;AwJtzxEI;EACE,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0C7IpOa;AX4hyEnB;AwJtzxEM;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,SAAA;EACA,UAAA;EACA,0EAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;AxJwzxER;AwJpzxEI;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AxJszxEN;AwJnzxEI;EACE,eAAA;EACA,0BAAA;AxJqzxEN;AwJnzxEM;EACE,yBAAA;AxJqzxER;AwJnzxEQ;EACE,aAAA;EACA,SAAA;EACA,0EAAA;AxJqzxEV;AwJjzxEM;EACE,yBAAA;AxJmzxER;AwJ9yxEE;;EAEE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,mEAAA;AxJgzxEJ;AwJ9yxEI;;EACE,eAAA;EACA,W7I/QK;AXgkyEX;AwJ/yxEI;;EACE,wCAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;EACA,oBAAA;AxJkzxEN;AwJ9yxEE;EACE,QAAA;AxJgzxEJ;AwJ9yxEI;EACE,gBAAA;EACA,sBAAA;AxJgzxEN;AwJ5yxEE;EACE,OAAA;AxJ8yxEJ;AwJ5yxEI;EACE,gBAAA;EACA,sBAAA;AxJ8yxEN;;AwJvyxEA;EACE,kBAAA;EACA,gBAAA;AxJ0yxEF;AwJxyxEE;EACE,kBAAA;AxJ0yxEJ;AwJxyxEI;EACE,UAAA;AxJ0yxEN;AwJvyxEI;EACE,0CAAA;EACA,0CAAA;EACA,YAAA;EACA,WAAA;AxJyyxEN;AwJtyxEI;EACE,WAAA;EACA,kBAAA;EACA,8CAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;AxJwyxEN;AwJryxEM;EACE,yBAAA;AxJuyxER;;AyJxwyEI;EACI,kBAAA;EACA,eAAA;AzJ2wyER;AyJzwyEQ;EACI,cAAA;EACA,2BAAA;EACA,gB9IorBkB;E8InrBlB,iBAAA;EACA,WAAA;EACA,eAAA;AzJ2wyEZ;;AyJtwyEA;EACI,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,mBAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;AzJywyEJ;AyJvwyEI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;EACA,0CAAA;EACA,oBAAA;AzJywyER;AyJtwyEI;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;AzJwwyER;AyJtwyEQ;EACI,cAAA;AzJwwyEZ;AyJrwyEQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,wGAAA;EACA,kBAAA;EACA,gBAAA;EACA,mCAAA;EACA,aAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;AzJuwyEZ;AyJrwyEY;EACI,W9IuFL;E8ItFK,SAAA;EACA,eAAA;AzJuwyEhB;AyJlwyEI;EACI,gCAAA;AzJowyER;AyJjwyEI;EACI,kBAAA;AzJmwyER;AyJjwyEQ;EACI,eAAA;EACA,kBAAA;EACA,aAAA;AzJmwyEZ;AyJhwyEQ;EACI,SAAA;EACA,oBAAA;EACA,c9IsED;AX4ryEX;AyJ7vyEQ;EACI,YAAA;AzJ+vyEZ;AyJ5vyEQ;EACI,SAAA;AzJ8vyEZ;AyJ5vyEY;EACI,UAAA;AzJ8vyEhB;AyJ1vyEQ;EACI,UAAA;EACA,mBAAA;AzJ4vyEZ;;AyJrvyEQ;EACI,iCAAA;AzJwvyEZ;;A0Jz2yEA;EACI,gBAAA;A1J42yEJ;;A0Jx2yEI;EACI,gBAAA;A1J22yER;A0Jx2yEI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,cAAA;A1J02yER;A0Jv2yEI;EACI;IACI,gBAAA;E1Jy2yEV;E0Jt2yEM;IACI,qBAAA;IACA,SAAA;E1Jw2yEV;AACF;A0Jr2yEI;EACI;IACI,eAAA;IACA,gBAAA;E1Ju2yEV;E0Jp2yEM;IACI,kBAAA;IACA,QAAA;E1Js2yEV;AACF;;A0Jj2yEA;EACI;IACI,yBAAA;E1Jo2yEN;E0Jj2yEE;IACI,yCAAA;E1Jm2yEN;E0Jh2yEE;IACI,uCAAA;E1Jk2yEN;E0J/1yEE;IACI,yCAAA;E1Ji2yEN;E0J91yEE;IACI,uCAAA;E1Jg2yEN;E0J71yEE;IACI,wCAAA;E1J+1yEN;E0J51yEE;IACI,yBAAA;E1J81yEN;AACF;A0J31yEA;EACI,sCAAA;A1J61yEJ;;A2Jt6yEA;EACI,4CAAA;A3Jy6yEJ;A2Jv6yEI;EAHJ;IAIQ,gBAAA;E3J06yEN;AACF;;A2Jp6yEA;EACI,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,aAAA;A3Ju6yEJ;A2Jt6yEI;EANJ;IAOQ,aAAA;E3Jy6yEN;AACF;A2Jv6yEI;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,mBhJuJK;EgJtJL,8FAAA;A3Jy6yER;A2Jr6yEI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A3Ju6yER;;A2Jj6yEQ;EACI,+BAAA;A3Jo6yEZ;A2Jl6yEY;EACI,0CAAA;A3Jo6yEhB;;A2J95yEA;EACI,wCAAA;EACA,6CAAA;A3Ji6yEJ;;A2J35yEQ;EACI,0BhJ+JG;AX+vyEf;;A2J/5yEQ;EACI,0BhJ+JG;AXmwyEf;;A2Jn6yEQ;EACI,0BhJ+JG;AXuwyEf;;A2Jv6yEQ;EACI,0BhJ+JG;AX2wyEf;;A2J36yEQ;EACI,0BhJ+JG;AX+wyEf;;A2J/6yEQ;EACI,0BhJ+JG;AXmxyEf;;A2Jn7yEQ;EACI,0BhJ+JG;AXuxyEf;;A2Jv7yEQ;EACI,0BhJ+JG;AX2xyEf;;A2Jr7yEA;EACI,kBAAA;A3Jw7yEJ;A2Jt7yEI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;A3Jw7yER;A2Jt7yEQ;EALJ;IAMQ,aAAA;E3Jy7yEV;AACF;A2Jt7yEI;EACI,aAAA;A3Jw7yER;A2Jr7yEI;EACI,eAAA;A3Ju7yER;;A2Jn7yEA;EACI,kBAAA;EACA,qBAAA;A3Js7yEJ;A2Jp7yEI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;A3Js7yER;A2Jn7yEI;EACI,iBAAA;A3Jq7yER;A2Jl7yEI;EACI,aAAA;A3Jo7yER;;A2J/6yEI;EACI,kBAAA;A3Jk7yER;A2Jh7yEQ;EACI,6BAAA;A3Jk7yEZ;A2Jh7yEY;EACI,gBAAA;A3Jk7yEhB;A2J96yEQ;EACI,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;A3Jg7yEZ;A2J56yEY;EACI,QAAA;A3J86yEhB;A2Jz6yEY;EACI,YAAA;EACA,QAAA;A3J26yEhB;;A2Jr6yEA;EACI,kBAAA;EACA,aAAA;A3Jw6yEJ;A2Jt6yEI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;A3Jw6yER;A2Jr6yEI;EACI,WAAA;EACA,aAAA;EACA,iBAAA;A3Ju6yER;A2Jr6yEQ;EALJ;IAMQ,aAAA;E3Jw6yEV;AACF;A2Jr6yEI;EACI,aAAA;A3Ju6yER;A2Jp6yEI;EACI,eAAA;A3Js6yER;;A2Jl6yEA;EAGQ;IACI,wBAAA;E3Jm6yEV;AACF;A4JvlzEA;EACI,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;A5JylzEJ;A4JvlzEI;EACI,kBAAA;A5JylzER;;A4JrlzEA;EACI,kBAAA;A5JwlzEJ;A4JtlzEI;EACI,UAAA;EACA,SAAA;EACA,gBAAA;A5JwlzER;A4JtlzEQ;EACI,cAAA;EACA,2BAAA;EACA,0CAAA;EACA,4CjJ6mBkB;EiJ5mBlB,oBjJ6pBkB;EiJ5pBlB,YAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A5JwlzEZ;A4JtlzEY;EACI,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;A5JwlzEhB;;A4J/kzEY;EACI,UAAA;EACA,uBAAA;EACA,kBAAA;A5JklzEhB;A4J7kzEI;EACI,kBAAA;EACA,WAAA;A5J+kzER;A4J7kzEQ;EACI,WAAA;EACA,cAAA;EACA,QAAA;EACA,aAAA;EACA,8CAAA;EACA,YAAA;EACA,kBAAA;A5J+kzEZ;A4J3kzEY;EACI,aAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;EACA,gDAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,8CAAA;A5J6kzEhB;A4J3kzEgB;EACI,WAAA;EACA,UAAA;A5J6kzEpB;A4JvkzEI;EAGY;IACI,UAAA;IACA,UAAA;IACA,iBAAA;E5JukzElB;E4JnkzEU;IACI,WAAA;E5JqkzEd;AACF;;A4JhkzEA;EACI,WAAA;A5JmkzEJ;A4JhkzEQ;EACI,aAAA;EACA,YAAA;EACA,wBAAA;EACA,iBAAA;EACA,gDAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;A5JkkzEZ;A4JhkzEY;EACI,WAAA;EACA,WAAA;A5JkkzEhB;A4J9jzEQ;EACI,cAAA;EACA,WAAA;A5JgkzEZ;A4J7jzEgB;EACI,YAAA;A5J+jzEpB;A4JzjzEI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,6CAAA;EACA,+CAAA;EACA,8CAAA;EACA,cAAA;EACA,UAAA;EACA,UAAA;A5J2jzER;A4JxjzEI;EAEQ;IACI,UAAA;IACA,SAAA;IACA,gBAAA;E5JyjzEd;E4JrjzEM;IACI,kBAAA;IACA,OAAA;IACA,UAAA;E5JujzEV;AACF;;A4JnjzEA;EACI,8CAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;A5JsjzEJ;A4JpjzEI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,8CAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;A5JsjzER;A4JnjzEI;EACI,sBAAA;EACA,UAAA;A5JqjzER;A4JljzEI;EACI,eAAA;EACA,kBAAA;A5JojzER;A4JljzEQ;EACI,kBAAA;EACA,gDAAA;EACA,YAAA;A5JojzEZ;A4JljzEY;EACI,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;A5JojzEhB;A4J/izEI;EACI,cAAA;EACA,WAAA;A5JijzER;A4J9izEI;EACI;IACI,YAAA;E5JgjzEV;AACF;A4J7izEI;EA3DJ;IA4DQ,WAAA;IACA,WAAA;IACA,cAAA;E5JgjzEN;E4J9izEM;IACI,WAAA;IACA,cAAA;IACA,kBAAA;IACA,QAAA;IACA,YAAA;IACA,4BAAA;IACA,UAAA;IACA,UAAA;IACA,QAAA;IACA,iBAAA;E5JgjzEV;E4J5izEU;IACI,aAAA;E5J8izEd;AACF;;A4JpizEI;EACI,UAAA;EACA,iBAAA;EACA,kBAAA;A5JuizER;A4JtizEQ;EACI,kBAAA;A5JwizEZ;A4JtizEQ;EAPJ;IAQQ,gBAAA;E5JyizEV;E4JvizEc;IACI,eAAA;E5JyizElB;E4JxizEkB;IACI,aAAA;E5J0izEtB;E4JtizEc;IACI,aAAA;E5JwizElB;AACF;A4JnizEI;EACI;IACI,kBAAA;E5JqizEV;E4JpizEU;IACI,iBAAA;E5JsizEd;E4JrizEc;;IAEI,kBAAA;E5JuizElB;E4JrizEkB;;IACI,WAAA;IACA,yBAAA;IACA,+CAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;E5JwizEtB;E4JpizEkB;IACI,WAAA;E5JsizEtB;E4JnizEc;IACI,kBAAA;IACA,0BAAA;E5JqizElB;E4JnizEkB;IACI,WAAA;IACA,WAAA;IACA,6CAAA;IACA,kBAAA;IACA,QAAA;IACA,2BAAA;IACA,OAAA;E5JqizEtB;E4JjizEc;IACI,iBAAA;E5JmizElB;AACF;A4J/hzEI;EACI;IACI,iBAAA;E5JiizEV;E4JhizEU;IACI,iBAAA;E5JkizEd;E4JhizEc;IACI,WAAA;IACA,YAAA;IACA,QAAA;IACA,+CAAA;IACA,kBAAA;IACA,MAAA;IACA,OAAA;IACA,QAAA;IACA,gBAAA;E5JkizElB;E4J/hzEc;IACI,WAAA;IACA,WAAA;IACA,6CAAA;IACA,kBAAA;IACA,MAAA;IACA,SAAA;E5JiizElB;E4J7hzEkB;IACI,aAAA;E5J+hzEtB;E4J1hzEkB;IACI,WAAA;IACA,YAAA;IACA,+CAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;E5J4hzEtB;E4J1hzEkB;IACI,YAAA;E5J4hzEtB;E4JxhzEc;IACI,kBAAA;E5J0hzElB;E4JxhzEkB;IACI,WAAA;IACA,YAAA;IACA,+CAAA;IACA,kBAAA;IACA,SAAA;IACA,SAAA;IACA,cAAA;E5J0hzEtB;AACF;A4JphzEI;EACI,2BAAA;EACA,gBAAA;EACA,cAAA;A5JshzER;;A4J9gzEI;EACI,2BAAA;EACA,cAAA;A5JihzER;A4J9gzEQ;EACI,eAAA;A5JghzEZ;A4J9gzEY;EACI,aAAA;A5JghzEhB;A4J5gzEQ;EACI,aAAA;A5J8gzEZ;A4J3gzEI;EACI,kBAAA;EACA,iBAAA;A5J6gzER;A4J5gzEQ;EACI,WAAA;EACA,8CAAA;EACA,kBAAA;EACA,MAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;A5J8gzEZ;A4J3gzEY;EACI,kBAAA;EACA,2BAAA;A5J6gzEhB;A4J5gzEgB;EACI,WAAA;EACA,WAAA;EACA,6CAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,OAAA;A5J8gzEpB;A4J1gzEQ;EACI,iBAAA;A5J4gzEZ;A4JxgzEQ;EACI,kBAAA;A5J0gzEZ;A4JzgzEY;EACI,kBAAA;A5J2gzEhB;A4J1gzEgB;EACI,WAAA;EACA,YAAA;EACA,8CAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,gBAAA;A5J4gzEpB;A4JzgzEoB;EACI,YAAA;A5J2gzExB;A4JpgzEY;EACI,YAAA;A5JsgzEhB;;A6J99zEA;EACI,aAAA;EACA,kBAAA;EACA,qBAAA;A7Ji+zEJ;A6J/9zEI;EACI,aAAA;EACA,WAAA;EACA,iBAAA;A7Ji+zER;A6J99zEI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,8FAAA;EACA,YAAA;A7Jg+zER;;A6J39zEI;EACI,mBAAA;A7J89zER;A6J59zEQ;EACI,cAAA;EACA,UAAA;A7J89zEZ;A6J39zEQ;EACI,gBAAA;A7J69zEZ;A6J39zEY;EACI,kBAAA;A7J69zEhB;A6J39zEgB;EACI,WAAA;A7J69zEpB;A6Jz9zEY;EACI,cAAA;A7J29zEhB;A6Jv9zEgB;EACI,qBAAA;EACA,cAAA;A7Jy9zEpB;A6Jt9zEgB;EACI,WlJkGT;AXs3zEX;A6Jr9zE2B;EACH,WlJ8Fb;AXy3zEX;A6Jl9zEY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;A7Jo9zEhB;A6Jl9zEgB;EACI,eAAA;A7Jo9zEpB;A6Jj9zEgB;EACI,gBAAA;EACA,gBAAA;EACA,kBAAA;A7Jm9zEpB;A6J/8zEY;EACI,WAAA;EACA,gBAAA;A7Ji9zEhB;A6J78zEQ;EACI;IACI,cAAA;IACA,aAAA;E7J+8zEd;AACF;A6J58zEQ;EACI;IACI,cAAA;IACA,UAAA;E7J88zEd;AACF;A6J38zEQ;EACI;IACI,cAAA;IACA,WAAA;E7J68zEd;AACF;A6Jz8zEI;EACI,sBAAA;A7J28zER;A6Jz8zEQ;EACI,mBAAA;A7J28zEZ;A6Jz8zEY;EACI,mBAAA;EACA,8BAAA;A7J28zEhB;A6Jx8zEY;EACI,aAAA;EACA,mBAAA;A7J08zEhB;A6Jx8zEgB;EACI,YAAA;EACA,WAAA;EACA,eAAA;A7J08zEpB;A6Jv8zEgB;EACI,iBAAA;A7Jy8zEpB;A6Jr8zEY;EACI,WAAA;EACA,cAAA;EAEA,QAAA;A7Ju8zEhB;A6Jp8zEY;EACI,clJuCH;AX+5zEb;A6Jl8zEQ;EAtCJ;IAuCQ,mBAAA;E7Jq8zEV;E6Jp8zEU;IAGI,cAAA;IACA,WAAA;E7Js8zEd;E6Jl8zEc;IACI,WAAA;IACA,cAAA;IACA,SAAA;IACA,mBAAA;E7Jo8zElB;E6Jl8zEkB;IACI,UAAA;E7Jo8zEtB;E6Jh8zEc;IACI,mBAAA;E7Jk8zElB;E6J/7zEc;IACI,WAAA;IACA,gBAAA;E7Ji8zElB;AACF;;A6J37zEA;EACI,cAAA;A7J87zEJ;;A6Jz7zEQ;EACI,yBlJEC;EkJDD,WlJrCD;AXi+zEX;;A6Jt7zEI;EACI,qBAAA;EACA,cAAA;EACA,WAAA;A7Jy7zER;A6Jv7zEI;EACI,WlJjDG;AX0+zEX;A6Jr7zEQ;EACI,WlJtDD;AX6+zEX;;A8Jjo0EA;EACI,kBAAA;EACA,aAAA;EACA,SAAA;A9Joo0EJ;A8Jjo0EI;EACI,UAAA;A9Jmo0ER;A8Jho0EgB;EACI,aAAA;A9Jko0EpB;A8J7n0EI;EACI,eAAA;EACA,gBnJyGa;EmJxGb,cAAA;EACA,kBAAA;EACA,oCAAA;EACA,yBAAA;A9J+n0ER;A8J5n0EI;EACI,0CAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBnJ4lBsB;EmJ3lBtB,4CnJomBsB;EmJnmBtB,gBnJ2pBsB;EmJ1pBtB,eAAA;A9J8n0ER;A8J7n0EQ;EARJ;IASQ,eAAA;E9Jgo0EV;AACF;A8J9n0EQ;EACI,YAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;EACA,qBAAA;A9Jgo0EZ;;A8J1n0EA;EACI,sCAAA;A9J6n0EJ;;A8J1n0EA;EACI;IAAK,wBAAA;E9J8n0EP;E8J7n0EE;IAAO,4BAAA;E9Jgo0ET;AACF;A8J9n0EA;EACI,gBnJ8nB0B;EmJ7nB1B,yBAAA;EACA,WnJsFO;EmJrFP,4BAAA;A9Jgo0EJ;;A8J7n0EA;EACI,gBAAA;A9Jgo0EJ;;A+Jrs0EA;EACI,kBAAA;EACA,gBAAA;A/Jws0EJ;A+Jts0EI;EACI,eAAA;EACA,WpJgJG;EoJ/IH,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;A/Jws0ER;A+Jts0EQ;EACI,eAAA;A/Jws0EZ;A+Jrs0EQ;EAdJ;IAeQ,eAAA;E/Jws0EV;E+Jts0EU;IACI,eAAA;E/Jws0Ed;AACF;;A+Jls0EI;EACI,aAAA;A/Jqs0ER;A+Jps0EQ;EACI,cAAA;A/Jss0EZ;A+Jps0EQ;EACI,cAAA;A/Jss0EZ;A+Jps0EQ;EACI,cAAA;A/Jss0EZ;;A+Jjs0EA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;A/Jos0EJ;A+Jls0EI;EACI,iBAAA;EACA,eAAA;A/Jos0ER;A+Jjs0EI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,oBAAA;EACA,mCAAA;EACA,iCAAA;A/Jms0ER;A+Jjs0EQ;EACI,qBAAA;A/Jms0EZ;A+Jhs0EQ;EACI,qBAAA;A/Jks0EZ;;A+J7r0EA;EACI;IACI,UAAA;IACA,mBAAA;E/Jgs0EN;E+J7r0EE;IACI,UAAA;IACA,mBAAA;E/J+r0EN;AACF;A+J3r0EI;EACI,WAAA;EACA,qBAAA;A/J6r0ER;;AgK3x0EA;EACI,aAAA;AhK8x0EJ;;AgK1x0EI;EACI,UAAA;EACA,YAAA;EACA,0CAAA;AhK6x0ER;AgK1x0EI;EACI,0CAAA;AhK4x0ER;;AgKrx0EI;EADJ;IAEQ,gBAAA;IACA,wBAAA;EhKyx0EN;AACF;;AgKpx0EQ;EACI,wCAAA;EACA,sBrJ4lBkB;EqJ3lBlB,eAAA;EACA,eAAA;AhKux0EZ;AgKnx0EY;EACI,iCAAA;AhKqx0EhB;;AgK5w0EY;EACI,crJ0IH;AXqo0Eb;;AiK7z0EQ;EACI,YAAA;AjKg00EZ;;AiK1z0EI;EACI,YAAA;EACA,mBAAA;EACA,eAAA;AjK6z0ER;AiK3z0EI;EACI,uBAAA;AjK6z0ER;AiK3z0EI;EACI,WAAA;AjK6z0ER;AiK5z0EQ;EACI,QAAA;AjK8z0EZ;AiK5z0EQ;EACI,mBAAA;AjK8z0EZ;;AkKr10EA;EACE,kBAAA;EACA,kBAAA;AlKw10EF;;AkKn10EA;EACE,2BAAA;EACA,kBAAA;EACA,0CAAA;AlKs10EF;AkKp10EE;EALF;IAMI,gBAAA;IACA,gBAAA;IACA,uCAAA;ElKu10EF;AACF;;AkKp10EA;EACE,SAAA;AlKu10EF;AkKn10EM;EACE,mDvJ4Ge;EuJ3Gf,wBvJ4GgB;AXyu0ExB;AkKn10EQ;EACE,8DAAA;EACA,yBAAA;AlKq10EV;AkKh10EI;EACE,cAAA;EACA,iBAAA;EACA,2BAAA;EACA,oBAAA;EACA,oCvJ9B4C;EuJ+B5C,gBvJoFe;EuJnFf,oBvJ2oBwB;AXuszE9B;AkK/00EI;EACE,eAAA;AlKi10EN;AkK900EI;EACE,gBvJ0oBwB;AXsszE9B;AkK700EI;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AlK+00EN;AkK700EM;EACE,iBAAA;EACA,gBvJ8nBsB;EuJ7nBtB,eAAA;AlK+00ER;;AkKz00EA;EACE,kBAAA;AlK400EF;AkK100EE;EACE,WAAA;EACA,YAAA;EACA,yBvJgFO;EuJ/EP,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;AlK400EJ;AkKx00EI;EACE,yBvJoGO;AXsu0Eb;AkKr00EI;EACE,yBvJ6FO;AX0u0Eb;;AkKl00EA;EACE,+BAAA;AlKq00EF;AkKn00EE;EAHF;IAII,2BAAA;ElKs00EF;AACF;;AkKh00EE;EACE,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,2BAAA;EACA,oCvJvG8C;EuJwG9C,gBvJWiB;EuJVjB,oBvJkkB0B;AXiwzE9B;;AkK/z0EA;EACE,iBAAA;EACA,cvJ2DW;EuJ1DX,gBvJGmB;EuJFnB,kBAAA;EACA,eAAA;AlKk00EF;AkKj00EE;EACE,WAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,UAAA;EACA,QAAA;EACA,iCAAA;AlKm00EJ;;AkK7z0EA;EACE,oDAAA;EACA,oBAAA;EACA,kBAAA;EACA,mCAAA;AlKg00EF;AkK9z0EE;EANF;IAOI,kBAAA;IACA,OAAA;IACA,QAAA;IACA,WAAA;IACA,wBAAA;IACA,kBAAA;IACA,2BAAA;IACA,WAAA;IACA,iBAAA;ElKi00EF;EkK/z0EE;IACE,mBAAA;IACA,wBAAA;ElKi00EJ;AACF;AkK9z0EE;EACE,kBAAA;AlKg00EJ;AkK5z0EI;EACE,aAAA;AlK8z0EN;AkK3z0EM;EADF;IAEI,wBAAA;ElK8z0EN;AACF;;AkKzz0EA;EACE,oCAAA;EACA,0CAAA;AlK4z0EF;AkK3z0EE;EAHF;IAII,eAAA;IACA,OAAA;IACA,QAAA;IACA,MAAA;IACA,UAAA;ElK8z0EF;AACF;;AkK1z0EE;EACE,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cvJxCO;AXq20EX;AkK3z0EE;EAVF;IAWI,aAAA;IACA,yBAAA;ElK8z0EF;AACF;;AkK3z0EA;EACE,sCAAA;AlK8z0EF;AkK7z0EE;EAFF;IAGI,sCAAA;ElKg00EF;AACF;AkK9z0EE;EACE,aAAA;EACA,sBAAA;AlKg00EJ;AkK9z0EI;EACE,gBAAA;AlKg00EN;AkK5z0EE;EACE,iBAAA;EACA,gBAAA;AlK8z0EJ;AkK7z0EI;EACE,aAAA;AlK+z0EN;AkKzz0EM;EACE,gBAAA;AlK2z0ER;AkKpz0EM;EACE,aAAA;AlKsz0ER;AkKnz0EI;EACE,kBAAA;AlKqz0EN;AkKjz0EM;EACE,mBAAA;AlKmz0ER;AkK9y0EE;EACE,kBAAA;AlKgz0EJ;AkK9y0EI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AlKgz0EN;AkK5y0EE;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AlK8y0EJ;AkK5y0EI;EACE,sBvJ1HK;EuJ2HL,kBAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;AlK8y0EN;AkK3y0EI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,OAAA;EACA,QAAA;EACA,wCAAA;EACA,SAAA;AlK6y0EN;AkK1y0EI;EACE,eAAA;AlK4y0EN;AkKxy0EE;EACE,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,qBAAA;EACA,cAAA;AlK0y0EJ;AkKxy0EI;EAPF;IAQI,cAAA;ElK2y0EJ;AACF;AkKzy0EI;EACE,aAAA;EACA,mBAAA;AlK2y0EN;AkKxy0EI;EACE,qBAAA;EACA,sBAAA;AlK0y0EN;AkKvy0EI;EACE,kBAAA;EACA,iCvJ3LkB;EuJ4LlB,kBAAA;EACA,kBAAA;EACA,6CvJoUwB;AXq+zE9B;AkKty0EQ;EACE;IACE,aAAA;ElKwy0EV;EkKry0EQ;IACE,cAAA;ElKuy0EV;AACF;AkKly0EI;EACE,gBvJrNe;EuJsNf,aAAA;EACA,eAAA;EACA,mBAAA;EACA,QAAA;AlKoy0EN;AkKhy0EM;EACE,eAAA;EACA,YAAA;EACA,cvJjMG;AXm+0EX;AkKjy0EQ;EACE,aAAA;AlKmy0EV;AkKhy0EQ;EARF;IASI,aAAA;ElKmy0ER;AACF;AkK/x0EI;EACE,eAAA;EACA,eAAA;EACA,iBAAA;AlKiy0EN;AkK9x0EI;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,QAAA;AlKgy0EN;AkK9x0EM;EACE,kBAAA;AlKgy0ER;AkK7x0EM;EACE,gBAAA;AlK+x0ER;AkK5x0EM;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;AlK8x0ER;AkK3x0EU;EACE,eAAA;EACA,WvJhPD;EuJiPC,qBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,kBAAA;AlK6x0EZ;AkKtx0EE;EACE,yBAAA;AlKwx0EJ;AkKtx0EI;EACE,QAAA;EACA,iBAAA;EACA,iBAAA;AlKwx0EN;AkKrx0EI;EACE,gBAAA;EACA,cvJnQK;AX0h1EX;AkKpx0EI;EACE,iBAAA;AlKsx0EN;AkKpx0EM;EACE,yBAAA;AlKsx0ER;AkKpx0EQ;EACE,QAAA;EACA,mDvJrSa;EuJsSb,wBvJrSc;EuJsSd,iBAAA;EACA,gBvJ2NoB;AX2j0E9B;AkKpx0EU;EACE,0CAAA;EACA,4CAAA;EACA,cvJnRD;AXyi1EX;AkKpx0EY;EACE,qCAAA;AlKsx0Ed;AkKhx0EM;EACE,yBAAA;AlKkx0ER;AkKhx0EQ;EACE,QAAA;AlKkx0EV;AkK/w0EQ;EACE,QAAA;AlKix0EV;AkK9w0EQ;EACE,QAAA;AlKgx0EV;AkK5w0EM;EACE,QAAA;AlK8w0ER;AkK1w0EI;EACE,yBvJlTK;AX8j1EX;;AkKvw0EA;EACE,iCAAA;EACA,0CAAA;EACA,kBAAA;EACA,UAAA;AlK0w0EF;AkKxw0EE;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,cvJ3SS;AXqj1Eb;AkKxw0EE;EACE,cAAA;AlK0w0EJ;;AkKtw0EA;EACE,aAAA;AlKyw0EF;AkKvw0EI;EACE,gBAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,cAAA;AlKyw0EN;AkKxw0EM;EACE,cvJvVG;AXim1EX;;AkKnw0EA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;AlKsw0EF;;AkKnw0EA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,4CAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,oBAAA;AlKsw0EF;AkKpw0EE;EAXF;IAYI,aAAA;ElKuw0EF;AACF;AkKrw0EE;EACE,4BAAA;EACA,UAAA;AlKuw0EJ;AkKrw0EI;EAJF;IAKI,4BAAA;ElKww0EJ;AACF;;AkKpw0EA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kDAAA;EACA,qDAAA;AlKuw0EF;AkKrw0EE;EACE,qCAAA;EACA,eAAA;AlKuw0EJ;;AkKjw0EE;EACE,2BAAA;AlKow0EJ;AkKhw0EI;EACE,0BAAA;AlKkw0EN;AkK9v0EE;EACE,oBAAA;EACA,qBAAA;AlKgw0EJ;;AkKzv0EI;EADF;IAEI,yBAAA;IACA,0BAAA;ElK6v0EJ;AACF;AkK5v0EI;EALF;IAMI,wBAAA;ElK+v0EJ;AACF;AkK5v0EE;EACE,wCAAA;AlK8v0EJ;AkK7v0EI;EAFF;IAGI,uCAAA;ElKgw0EJ;AACF;AkK7v0EE;EACE,2BAAA;AlK+v0EJ;AkK9v0EI;EAFF;IAGI,2BAAA;ElKiw0EJ;AACF;AkK9v0EE;EACE,sCAAA;AlKgw0EJ;AkK/v0EI;EAFF;IAGI,sCAAA;ElKkw0EJ;AACF;;AmK311EA;EACE,kBAAA;EACA,kBAAA;AnK811EF;;AmKz11EA;EACE,2BAAA;EACA,kBAAA;EACA,0CAAA;EACA,oBAAA;AnK411EF;AmK111EE;EANF;IAOI,gBAAA;IACA,gBAAA;IACA,uCAAA;EnK611EF;AACF;AmK311EE;EAZF;IAaI,eAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6CxJ2mB0B;IwJ1mB1B,4BAAA;IACA,kBAAA;IACA,aAAA;EnK811EF;EmK511EE;IACE,mBAAA;IACA,eAAA;EnK811EJ;AACF;AmK311EE;EACE,2BAAA;AnK611EJ;AmK311EI;EAHF;IAII,2BAAA;EnK811EJ;AACF;;AmKz11EE;EACE,aAAA;EACA,mBAAA;EACA,cxJyGO;EwJxGP,cAAA;EACA,gBxJwEiB;AXox1ErB;AmK111EI;EACE,cxJ4HO;AXgu1Eb;AmKz11EI;EACE,eAAA;AnK211EN;AmKx11EI;EACE,cxJ0HO;EwJzHP,gBxJ2nBwB;AX+t0E9B;AmKx11EM;EACE,cxJsHK;AXou1Eb;;AmKn11EE;EACE,iBAAA;AnKs11EJ;AmKr11EI;EACE,gDAAA;AnKu11EN;;AmKl11EE;EACE,cxJwEO;AX6w1EX;AmKn11EI;EACE,cxJ4FO;AXyv1Eb;;AmKh11EA;EACE,WAAA;EACA,0CAAA;EACA,oBAAA;AnKm11EF;;AmKh11EA;EACE,eAAA;EACA,YxJQc;EwJPd,SAAA;EACA,2BAAA;EACA,UAAA;AnKm11EF;;AmKh11EA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,0CAAA;EACA,2BAAA;EACA,oBAAA;EACA,kBAAA;EACA,wCAAA;AnKm11EF;;AmK/01EE;EACE,eAAA;EACA,mBAAA;AnKk11EJ;AmK/01EE;EACE,iBAAA;AnKi11EJ;AmK/01EI;EAHF;IAII,eAAA;EnKk11EJ;AACF;;AmK901EA;EACE,2BAAA;AnKi11EF;AmK/01EE;EAHF;IAII,2BAAA;EnKk11EF;AACF;;AmK/01EA;EACE,2BAAA;AnKk11EF;AmKh11EE;EAHF;IAII,2BAAA;EnKm11EF;AACF;;AmKh11EA;EACE,cAAA;EACA,eAAA;EACA,SAAA;AnKm11EF;AmKj11EE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,WAAA;AnKm11EJ;AmKj11EI;EACE,yBAAA;AnKm11EN;AmKh11EI;EACE,2BAAA;EACA,0BAAA;AnKk11EN;AmK/01EI;EACE,WAAA;EACA,kBAAA;AnKi11EN;AmK901EI;EACE,YAAA;AnKg11EN;AmK901EM;;;EAGE,cAAA;EACA,WAAA;AnKg11ER;AmK701EM;EACE,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AnK+01ER;AmK501EM;EACE,qBAAA;EACA,mBAAA;AnK801ER;AmK301EM;EACE,gBAAA;EACA,gBAAA;AnK601ER;AmK101EM;EACE,kBAAA;EACA,MAAA;EACA,UAAA;EACA,QAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AnK401ER;AmK101EQ;EAVF;IAWI,UAAA;EnK601ER;AACF;AmKz01EI;EACE,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;AnK201EN;AmKz01EM;;EAEE,kBAAA;EACA,MAAA;AnK201ER;AmKx01EM;EACE,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AnK001ER;AmKx01EQ;EACE,yBAAA;AnK001EV;AmKt01EM;EACE,QAAA;EACA,YAAA;EACA,kBAAA;AnKw01ER;AmKp01EI;EAEE,iCAAA;EACA,iCAAA;AnKq01EN;AmKl01EI;EACE,yBAAA;AnKo01EN;AmKl01EM;EACE,yBAAA;EACA,gBxJibsB;AXm50E9B;;AmK9z1EA;;EAEE,aAAA;AnKi01EF;;AmK9z1EA;EACE,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;AnKi01EF;;AmK9z1EA;EACE,mBAAA;AnKi01EF;;AmK9z1EA;EACE;IACE,eAAA;IACA,MAAA;IACA,SAAA;IACA,UAAA;IACA,QAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6CxJuV0B;IwJtV1B,2BAAA;EnKi01EF;EmK7z1EE;IACE,eAAA;EnK+z1EJ;AACF;AmK3z1EA;EACE;IACE,YAAA;EnK6z1EF;AACF;AmKzz1EE;EACE,4BAAA;AnK2z1EJ;;AmKvz1EA;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,YxJ9Nc;EwJ+Nd,WxJ/Nc;EwJgOd,UAAA;EACA,aAAA;AnK0z1EF;AmKzz1EE;EACE,6CxJuT0B;AXog1E9B;AmKxz1EE;EAZF;IAaI,UAAA;IACA,WAAA;EnK2z1EF;AACF;;AmKrz1EI;EADF;IAEI,yBAAA;IACA,0BAAA;EnKyz1EJ;AACF;AmKxz1EI;EALF;IAMI,wBAAA;EnK2z1EJ;AACF;AmKxz1EE;EACE,wCAAA;AnK0z1EJ;AmKzz1EI;EAFF;IAGI,aAAA;EnK4z1EJ;AACF;AmK3z1EI;EACE,2BAAA;AnK6z1EN;AmK5z1EM;EAFF;IAGI,2BAAA;EnK+z1EN;AACF;AmK3z1EE;EACE,2BAAA;AnK6z1EJ;AmK1z1EE;EACE,2BAAA;AnK4z1EJ;AmK3z1EI;EAFF;IAGI,2BAAA;EnK8z1EJ;AACF;;AmKzz1EE;EACE,wBAAA;AnK4z1EJ;;AoK3r2EA;EACI,aAAA;EACA,gBAAA;EACA,oBAAA;ApK8r2EJ;AoK5r2EI;EACI,gBAAA;EACA,kBAAA;ApK8r2ER;AoK3r2EI;EACI,wBAAA;ApK6r2ER;AoK1r2EI;EACI,WAAA;ApK4r2ER;AoKzr2EI;EACI,WAAA;ApK2r2ER;AoKxr2EI;EACI,iDAAA;EACA,kBAAA;ApK0r2ER;AoKvr2EI;EACI,kBAAA;ApKyr2ER;;AoKpr2EI;EACI,sCAAA;ApKur2ER;AoKpr2EI;EACI,aAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;ApKsr2ER;AoKnr2EI;EACI,kBAAA;ApKqr2ER;;AoKjr2EA;EACI,+BAAA;ApKor2EJ;;AoKhr2EA;EACI,iBAAA;EACA,kBAAA;ApKmr2EJ;AoKhr2EQ;EACA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,0DAAA;EACA,sBAAA;EACA,2BAAA;ApKkr2ER;;AoK3q2EQ;EACI,UAAA;ApK8q2EZ;AoK1q2EY;EACI,UAAA;ApK4q2EhB;;AqKhw2EI;EACI,0CAAA;EACA,eAAA;ArKmw2ER;;AqK7v2EA;EACI,eAAA;EACA,kBAAA;ArKgw2EJ;AqK9v2EI;EAJJ;IAKQ,eAAA;ErKiw2EN;AACF;;AqK9v2EA;EACI,kBAAA;ArKiw2EJ;AqK/v2EI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yCAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;ArKiw2ER;;AqK3v2EA;EACI,iBAAA;EACA,yBAAA;ArK8v2EJ;AqK7v2EI;EAHJ;IAIQ,0CAAA;IACA,kDAAA;IACA,iBAAA;ErKgw2EN;AACF;AqK5v2EY;EACI,eAAA;EACA,gB1J6EK;E0J5EL,oBAAA;EACA,oC1JxCkC;E0JyClC,qBAAA;EACA,aAAA;ArK8v2EhB;AqK5v2EgB;EARJ;IASQ,gBAAA;ErK+v2ElB;AACF;AqK7v2EgB;EAGI,yBAAA;ArK6v2EpB;AqKzv2EgB;EACI,yBAAA;ArK2v2EpB;AqKrv2EI;EACI,0CAAA;EACA,kDAAA;ArKuv2ER;;AqKhv2EQ;EACI,aAAA;ArKmv2EZ;AqKhv2EQ;EACI,cAAA;ArKkv2EZ;AqK7u2EY;EACI,sCAAA;ArK+u2EhB;AqKxu2EgB;EACI,qBAAA;ArK0u2EpB;AqKru2EY;EACI,cAAA;ArKuu2EhB;AqKpu2EY;EACI,aAAA;ArKsu2EhB;;AqK9t2EA;EACI,gDAAA;ArKiu2EJ;AqK7t2EY;EACI,8BAAA;ArK+t2EhB;;AqKzt2EA;EACI,0DAAA;EACA,6BAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;ArK4t2EJ;;AqKzt2EA;EACI,kBAAA;EACA,UAAA;ArK4t2EJ;AqKzt2EQ;EACI,0CAAA;EACA,YAAA;EACA,kBAAA;ArK2t2EZ;AqKvt2EI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;ArKyt2ER;AqKtt2EI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;ArKwt2ER;;AqKnt2EA;EACI,gBAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;ArKst2EJ;;AqKjt2EA;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;ArKot2EJ;;AqKht2EA;EACI,kBAAA;ArKmt2EJ;AqKjt2EI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;ArKmt2ER;;AqK/s2EA;EACI,cAAA;ArKkt2EJ;;AqK7s2EQ;EACI,cAAA;EACA,cAAA;EACA,cAAA;EACA,gCAAA;ArKgt2EZ;AqK9s2EY;EACI,+BAAA;ArKgt2EhB;;AqKzs2EI;EACI,cAAA;EACA,2CAAA;EACA,yBAAA;ArK4s2ER;AqK1s2EQ;EACI,W1JtED;E0JuEC,yB1JzCC;AXqv2Eb;;AqKts2EI;EACI,YAAA;ArKys2ER;;AqKhs2EQ;;EAEI,YAAA;ArKms2EZ;AqKhs2EQ;EACI,qDAAA;ArKks2EZ;AqK1r2EgB;EACI,aAAA;ArK4r2EpB;AqKzr2EgB;EACI,cAAA;ArK2r2EpB;;AsK172EI;EACI,c3J0JG;E2JzJH,iCAAA;EACA,4C3JgoBsB;E2J/nBtB,oB3JgrBsB;AX6w1E9B;AsK572EQ;EAEI,yBAAA;EACA,c3J8KC;AX+w2Eb;;AsKx72EA;EACI,kBAAA;EACA,gBAAA;AtK272EJ;AsK172EI;EACI,aAAA;EACA,iBAAA;AtK472ER;AsK172EI;EACI,kBAAA;EACA,gBAAA;EACA,UAAA;AtK472ER;AsK372EQ;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,uCAAA;EACA,UAAA;EACA,yBAAA;AtK672EZ;AsK172EQ;EACI,QAAA;EACA,kBAAA;EACA,SAAA;EACA,gCAAA;AtK472EZ;AsK172EY;EACI,UAAA;EACA,aAAA;EACA,qBAAA;AtK472EhB;AsKp72EgB;EACI,UAAA;EACA,SAAA;AtKs72EpB;AsKl72EY;EACI,UAAA;AtKo72EhB;AsKh72EI;EACI,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,0CAAA;EACA,0BAAA;EACA,YAAA;AtKk72ER;;AsK762EA;EAEI,sBAAA;EACA,2BAAA;EACA,wBAAA;AtK+62EJ;AsK962EI;EACI,yBAAA;EACA,aAAA;AtKg72ER;;AsK362EI;EACI,aAAA;AtK862ER;AsK562EQ;EACI,cAAA;AtK862EZ;;AuK3g3EA;EACI,+BAAA;AvK8g3EJ;AuK5g3EI;EAHJ;IAIQ,2BAAA;EvK+g3EN;AACF;AuK7g3EI;EACI,gBAAA;AvK+g3ER;AuK7g3EQ;EACI,qBAAA;EACA,gB5JiHS;E4JhHT,yBAAA;AvK+g3EZ;AuK7g3EY;EAGI,c5JwKH;AXq22Eb;AuKxg3EY;EACI,kBAAA;EACA,kBAAA;AvK0g3EhB;AuKxg3EgB;EACI,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,kCAAA;EACA,oCAAA;AvK0g3EpB;;AuKng3EA;EACI,kBAAA;EACA,0CAAA;AvKsg3EJ;AuKpg3EI;EAJJ;IAKQ,gBAAA;IACA,gBAAA;IACA,sCAAA;EvKug3EN;AACF;AuKrg3EI;EAVJ;IAWQ,eAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6C5J6kBsB;I4J5kBtB,4BAAA;IACA,kBAAA;IACA,aAAA;EvKwg3EN;EuKtg3EM;IACI,mBAAA;IACA,eAAA;EvKwg3EV;AACF;;AuKpg3EA;EACI,2BAAA;AvKug3EJ;AuKtg3EI;EAFJ;IAGQ,2BAAA;EvKyg3EN;AACF;;AuKtg3EA;EACI,0CAAA;AvKyg3EJ;;AuKtg3EA;EACI,2BAAA;AvKyg3EJ;AuKxg3EI;EAFJ;IAGQ,2BAAA;EvK2g3EN;AACF;AuKzg3EI;EACI,YAAA;AvK2g3ER;;AuKvg3EA;EACI,2BAAA;AvK0g3EJ;AuKzg3EI;EAFJ;IAGQ,aAAA;EvK4g3EN;AACF;AuK1g3EI;EACI,YAAA;AvK4g3ER;;AuKxg3EA;EACI,UAAA;EACA,eAAA;EACA,0CAAA;EACA,aAAA;AvK2g3EJ;;AuKvg3EI;EACI,cAAA;AvK0g3ER;;AuKtg3EA;EACI,aAAA;AvKyg3EJ;;AuKtg3EA;EACI;IACI,eAAA;IACA,MAAA;IACA,SAAA;IACA,UAAA;IACA,QAAA;IACA,YAAA;IACA,eAAA;IACA,aAAA;IACA,6C5JqgBsB;I4JpgBtB,2BAAA;EvKyg3EN;EuKrg3EM;IACI,eAAA;EvKug3EV;AACF;AuKng3EA;EACI,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AvKqg3EJ;;AwKnp3EQ;EACI,2BAAA;EACA,eAAA;EACA,gB7JwHS;E6JvHT,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AxKsp3EZ;AwKrp3EY;EACI,c7J8KH;AXy+2Eb;;AwKjp3EA;EACI,2BAAA;EACA,gBAAA;AxKop3EJ;AwKnp3EI;EACI,wBAAA;AxKqp3ER;AwKlp3EI;EACI,UAAA;AxKop3ER;AwKjp3EI;EACI,YAAA;AxKmp3ER;AwKhp3EI;EACI,iDAAA;EACA,kBAAA;AxKkp3ER;AwK/o3EI;EACI,kBAAA;AxKip3ER;;AwKzo3EgB;EACI,6BAAA;AxK4o3EpB;;AwKro3EA;EACI,YAAA;AxKwo3EJ;;AwKro3EA;EACI,aAAA;AxKwo3EJ;;AyKps3EA;EACI,0DAAA;EACA,sBAAA;EACA,2BAAA;AzKus3EJ;;AyKns3EI;EACI,aAAA;AzKss3ER;;AyK/r3EY;EADJ;IAEQ,UAAA;EzKms3Ed;AACF;;A0Kxt3EA;EACI,UAAA;A1K2t3EJ;;A0Kpt3EY;EACI,cAAA;EACA,aAAA;A1Kut3EhB;A0Klt3EI;EAVJ;IAWQ,0CAAA;IACA,eAAA;E1Kqt3EN;AACF;;A0Kjt3EA;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;A1Kot3EJ;;A0Kjt3EA;EACI,0CAAA;EACA,sB/JimB0B;E+JhmB1B,gBAAA;A1Kot3EJ;A0Klt3EI;EACI,YAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;A1Kot3ER;A0Kjt3EI;EACI,gBAAA;A1Kmt3ER;A0Kht3EI;EACI,8CAAA;A1Kkt3ER;A0K/s3EI;EApBJ;IAqBQ,6BAAA;E1Kkt3EN;E0Kht3EM;IACI,sB/JsGD;I+JrGC,sB/J0kBkB;EXwo2E5B;E0K/s3EM;IACI,SAAA;E1Kit3EV;E0K9s3EM;IACI,sB/JkkBkB;EX8o2E5B;AACF;;A0K5s3EA;EACI,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;A1K+s3EJ;A0K7s3EI;EACI,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A1K+s3ER;A0K5s3EI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A1K8s3ER;A0K3s3EI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A1K6s3ER;A0K1s3EI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,wCAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;A1K4s3ER;A0Kzs3EI;EAhDJ;IAiDQ,aAAA;E1K4s3EN;AACF;;A0Kxs3EI;EACI,kBAAA;EACA,UAAA;A1K2s3ER;;A0Kts3EA;;;EAGI,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;A1Kys3EJ;A0Kvs3EI;;;EACI,2BAAA;A1K2s3ER;;A0Kvs3EA;EACI,YAAA;EACA,SAAA;A1K0s3EJ;A0Kxs3EI;EAJJ;IAKQ,OAAA;E1K2s3EN;AACF;;A0Kxs3EA;EACI,YAAA;EACA,aAAA;A1K2s3EJ;A0Kzs3EI;EAJJ;IAKQ,QAAA;E1K4s3EN;AACF;;A0Kzs3EA;EACI,YAAA;EACA,aAAA;A1K4s3EJ;A0K1s3EI;EAJJ;IAKQ,QAAA;IACA,SAAA;E1K6s3EN;AACF;;A0K1s3EA;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,iKAAA;EACA,UAAA;EACA,YAAA;A1K6s3EJ;A0K3s3EI;EACI,kBAAA;EACA,UAAA;A1K6s3ER;;A0Kzs3EA;EACI,kBAAA;A1K4s3EJ;A0K1s3EI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,yBAAA;EACA,UAAA;EACA,sB/J0bsB;AXkx2E9B;A0K1s3EQ;EAXJ;IAYQ,WAAA;IACA,SAAA;E1K6s3EV;AACF;;A0Kxs3EA;EACI,kBAAA;EACA,aAAA;EACA,YAAA;A1K2s3EJ;;A2K753EA;;;;;;CAAA;AAUE;EACE,oCAAA;EACA,oCAAA;A3K653EJ;A2K353EI;EACE,oCAAA;A3K653EN;A2Kz53EE;EACE,oCAAA;EACA,oCAAA;EACA,gBAAA;A3K253EJ;A2Kz53EI;EACE,+CAAA;A3K253EN;A2Kv53EE;EACE,oCAAA;A3Ky53EJ;A2Kv53EI;EACE,eAAA;EACA,oCAAA;A3Ky53EN;A2Kv53EM;EACE,oCAAA;A3Ky53ER;A2Kr53EI;EACE,eAAA;EACA,oCAAA;A3Ku53EN;A2Kn53EE;EACE,iCAAA;A3Kq53EJ;A2Kl53EE;EACE,8BhKgFY;AXo03EhB;A2Kj53EE;EACE,8BhK4EY;AXu03EhB;A2Kh53EE;;EAEE,8BhKuEY;AX203EhB;A2K/43EE;EACE,2BAAA;A3Ki53EJ;;A2K743EA;;EAEE,SAAA;A3Kg53EF;;A2K743EA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;A3Kg53EF;;A2K743EA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,sCAAA;A3Kg53EF;;A2K743EA;EACE,WAAA;EACA,UAAA;A3Kg53EF;;A2K743EA;EACE;IACE,OAAA;E3Kg53EF;E2K743EA;IACE,WAAA;E3K+43EF;AACF;A2K143EA;;;;EAIE,wCAAA;EACA,sCAAA;A3K443EF;;A2Kz43EA;EACE,sDAAA;EACA,qDAAA;A3K443EF;;A2Kz43EA;EACE,sDAAA;EACA,qDAAA;A3K443EF;;A2Kz43EA;EACE,qDAAA;EACA,sDAAA;A3K443EF;;A2Kz43EA;EACE,sDAAA;A3K443EF;;A2Kx43EA;EACE,yBAAA;A3K243EF;;A2Kx43EA;EACE,yBAAA;EACA,wCAAA;EACA,yBAAA;A3K243EF;;A2Kx43EA;EACE,iCAAA;EACA,uDAAA;A3K243EF;;A2Kx43EA;EACE,UAAA;EACA,iBAAA;EACA,eAAA;A3K243EF;;A2Kz43EA;EACE,mBAAA;A3K443EF;;A2Kz43EA;EACE,+CAAA;A3K443EF;;A2Kz43EA;EACE,yBAAA;A3K443EF;;A2Kz43EA;EACE,yBAAA;A3K443EF;;A2Kz43EA;EACE,yBAAA;A3K443EF;;A2Kz43EA;EACE,2BAAA;A3K443EF;;A2Kz43EA;EACE,aAAA;EACA,2BAAA;EACA,6CAAA;EACA,eAAA;EACA,+EAAA;A3K443EF;;A2Kz43EA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;A3K443EF;;A2Kz43EA,wCAAA;AACA;EACE;IACE,UAAA;IACA,0CAAA;E3K443EF;AACF;A2Kz43EA;EACE;IACE,UAAA;IACA,wCAAA;E3K243EF;AACF;A2Kx43EA;;GAAA;AAKA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;A3Kw43EF;;A2Kr43EA;EACE,aAAA;EACA,8CAAA;EACA,QAAA;A3Kw43EF;;A2Kr43EA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;A3Kw43EF;A2Kt43EE;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A3Kw43EJ;;A2Kp43EA;EACE,cAAA;EACA,aAAA;EACA,UAAA;EACA,SAAA;A3Ku43EF;;A2Kp43EA;EACE,gBAAA;EACA,MAAA;EACA,YAAA;A3Ku43EF;;A2Kp43EA;EACE,gBAAA;EACA,SAAA;EACA,YAAA;A3Ku43EF;;A2Kp43EA;EAEE,gBAAA;EACA,uBAAA;A3Ku43EF;;A2Kp43EA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;A3Ku43EF;;A2Kp43EA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,WACE;A3Ks43EJ;;A2Kn43EA;EACE,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;A3Ks43EF;;A2Kn43EA;EACE,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;A3Ks43EF;;A2Kn43EA;EACE,0BAAA;A3Ks43EF;;A2Kl43EA;EACE,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;A3Kq43EF;;A2Kl43EA;EACE,uCAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;A3Kq43EF;;A2Kl43EA;EACE,0BAAA;A3Kq43EF;;A2Kl43EA;EACE,YAAA;A3Kq43EF;;A2Kl43EA;EACE,WAAA;EACA,0DAAA;EACA,uBAAA;EACA,4BAAA;EACA,sCAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;A3Kq43EF;;A2Kl43EA;EACE,YAAA;A3Kq43EF;;A2Kl43EA;EACE,WAAA;EACA,0DAAA;EACA,uBAAA;EACA,4BAAA;EACA,gCAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,cAAA;A3Kq43EF;;A2Kl43EA;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;A3Kq43EF;;A2Kl43EA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;A3Kq43EF;;A2Kl43EA;EACE,oCAAA;A3Kq43EF;;A2Kj43EA;EACE,gBAAA;EACA,4BAAA;A3Ko43EF;A2Kl43EE;EACE,UAAA;A3Ko43EJ;A2Kj43EE;EACE,uBAAA;A3Km43EJ;A2Kh43EE;EACE,oCAAA;EACA,kBAAA;A3Kk43EJ;;A2K533EA;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,0ChKxDS;AXu73EX;;A2K533EA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;A3K+33EF;A2K733EE;EANF;IAOI,SAAA;IACA,WAAA;E3Kg43EF;AACF;A2K933EE;EAXF;IAYI,SAAA;IACA,WAAA;E3Ki43EF;AACF;;A2K933EA;EACE,iBAAA;EACA,+CAAA;EACA,gBAAA;EACA,8BAAA;A3Ki43EF;;A2K933EA;EACE,gBAAA;EACA,2BAAA;EACA,SAAA;EACA,sCAAA;EACA,yBAAA;EACA,2DAAA;A3Ki43EF;;AA9x4EE;EACE,kDAAA;AAiy4EJ;;AA5x4EE;EACE,aAAA;AA+x4EJ;;AA3x4EA;EACE,uBAAA;EACA,sBAAA;EACA,6BAAA;EACA,uBAAA;EACA,oBAAA;AA8x4EF;;AA3x4EA;;EAEE,sBAAA;AA8x4EF;;AA3x4EA;EACE,8BAAA;EACA,8CAAA;EAEA,2BAAA;AA8x4EF;;AA3x4EA;EACE,8BAAA;EACA,6BAAA;EACA,oCAAA;EACA,4CAAA;EACA,wCAAA;EACA,2BAAA;EACA,sBAAA;AA8x4EF;;AA3x4EA;EACE,kBAAA;AA8x4EF;;AA1x4EA;;EAEE,uBAAA;EACA,0BAAA;EACA,iBAAA;AA6x4EF;;AA1x4EA;EACE,uBAAA;AA6x4EF;;AmBvx4EI;EnBFF;IACE,yBAAA;IACA,kBAAA;EA6x4EF;EA3x4EE;;;IAGE,WAAA;IACA,cAAA;IACA,WAAA;IACA,cAAA;EA6x4EJ;EAtx4EM;IACE,WAAA;EAwx4ER;EAlx4EA;IACE,aAAA;EAox4EF;AACF;AAjx4EA;EACE,wBAAA;AAmx4EF;;AAhx4EA;EACE,aAAA;AAmx4EF;;AAhx4EA;EACE,aAAA;AAmx4EF;;AAhx4EA;EACE,oCAAA;AAmx4EF;;AAxw4EI;EACE,8BAAA;AA2w4EN;;AA5w4EI;EACE,8BAAA;AA+w4EN;;AAhx4EI;EACE,8BAAA;AAmx4EN;;AApx4EI;EACE,8BAAA;AAux4EN;;AAxx4EI;EACE,8BAAA;AA2x4EN;;AA5x4EI;EACE,8BAAA;AA+x4EN;;AAhy4EI;EACE,8BAAA;AAmy4EN;;AApy4EI;EACE,8BAAA;AAuy4EN;;AAhy4EE;EACE,eAAA;EACA,YAAA;EACA,cWsBO;AX6w4EX;;AA/x4EA;EACE,wBAAA;AAky4EF;;AA9x4EE;EACE,wBAAA;AAiy4EJ;;AA1x4EE;EACE,6BAAA;AA6x4EJ;;AAzx4EA;EACE,WAAA;EACA,SAAA;EACA,aAAA;AA4x4EF;;AAvx4EA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;AA0x4EF;;AAtx4EE;EACE,gBAAA;AAyx4EJ;AAtx4EE;EACE,QAAA;AAwx4EJ;AArx4EE;EACE,cW9BO;AXqz4EX;;AAjx4EA;EACE,oCW2wBsC;EX1wBtC,mDAAA;EACA,sCAAA;AAox4EF;;AAjx4EA;EACE,sCAAA;EACA,4CAAA;EACA,sCAAA;AAox4EF;;AAhx4EE;EACE,wDAAA;EACA,mDAAA;AAmx4EJ;;AA/w4EA;EACE,+CAAA;EACA,+CAAA;AAkx4EF;;AA/w4EA;EACE,+CAAA;EACA,+CAAA;AAkx4EF;;AA/w4EA,kCAAA;AACA;;;;EAIE,kEAAA;EACA,+CAAA;EACA,sCAAA;EACA,wDAAA;AAkx4EF","sourcesContent":["@import \"../scss/icons.scss\";\n@import \"../scss/config/default/bootstrap.scss\";\n@import \"../scss/config/default/app.scss\";\n@import \"../scss/config/default/custom.scss\";\n@import\"./shepherd.css\";\n@import \"./mermaid.min.css\";\n\n//RTL \n// @import \"../scss/rtl/components-rtl\";\n// @import \"../scss/rtl/layouts-rtl\";\n// @import \"../scss/rtl/plugins-rtl\";\n// @import \"../scss/rtl/pages-rtl\";\n\n\n//Rigthsidebar offcanvas\n.offcanvas-header-dark {\n  .btn-close {\n    filter: invert(1) grayscale(100%) brightness(200%);\n  }\n}\n\nbody {\n  * {\n    outline: none;\n  }\n}\n\n.noUi-horizontal .noUi-handle {\n  height: 16px !important;\n  width: 16px !important;\n  border-radius: 50% !important;\n  right: -10px !important;\n  top: -7px !important;\n}\n\n.noUi-connect,\n.noUi-horizontal {\n  height: 2px !important;\n}\n\n.noUi-handle {\n  background: #0ab39c !important;\n  border: 2px solid var(--vz-card-bg) !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.noUi-target {\n  background: #fafafa !important;\n  border-radius: 4px !important;\n  border: 1px solid #d3d3d3 !important;\n  background-color: var(--vz-light) !important;\n  border-color: var(--vz-light) !important;\n  box-shadow: none !important;\n  height: 4px !important;\n}\n\n.dropzone .dz-message {\n  text-align: center;\n}\n\n// //Calendar\n.fc-direction-ltr .fc-daygrid-event.fc-event-end,\n.fc-direction-rtl .fc-daygrid-event.fc-event-start {\n  padding: 5px !important;\n  font-size: 12px !important;\n  margin-right: 2px;\n}\n\n.fc-event {\n  border: none !important;\n}\n\n@include media-breakpoint-down(sm) {\n  .fc-toolbar {\n    display: block !important;\n    text-align: center;\n\n    .fc-left,\n    .fc-right,\n    .fc-center {\n      float: none;\n      display: block;\n      clear: both;\n      margin: 10px 0;\n    }\n  }\n\n  .fc {\n    .fc-toolbar {\n      >* {\n        >* {\n          float: none;\n        }\n      }\n    }\n  }\n\n  .fc-today-button {\n    display: none;\n  }\n}\n\n.flatpickr-calendar.open {\n  z-index: 1090 !important;\n}\n\n.upcoming-scheduled .flatpickr-input[readonly] {\n  display: none;\n}\n\n.ql-container.ql-snow {\n  height: 250px;\n}\n\n.rangeslider-horizontal .rangeslider__fill {\n  background-color: #405189 !important;\n}\n\n// .Toastify__toast {\n//   min-height: 43px !important;\n//   max-height: 43px !important;\n// }\n\n@each $color,\n$value in $theme-colors {\n  .simplebar-track-#{$color} {\n    .simplebar-scrollbar:before {\n      background: $value  !important;\n    }\n  }\n}\n\n// chat\n.chat-conversation .chat-list .message-box-drop {\n  .nav-btn {\n    font-size: 18px;\n    padding: 4px;\n    color: $gray-600;\n  }\n}\n\n.chatwidgets {\n  height: 250px !important;\n}\n\n[data-layout=\"horizontal\"] .chat-conversation{\n  &.chatwidgets {\n    height: 250px !important;\n  }\n}\n\n// authentication\n\n#tsparticles {\n  canvas {\n    position: absolute !important;\n  }\n}\n\n.alert-msg-show {\n  right: 24px;\n  top: 40px;\n  z-index: 1005;\n}\n\n// Emoji Picker\n\n.pickerEmoji {\n  position: absolute;\n  bottom: -50px;\n  left: 10%;\n  transform: translateX(-50%);\n}\n\n.Toastify {\n  .Toastify__toast {\n    min-height: 43px;\n  }\n\n  .Toastify__close-button {\n    top: 6px;\n  }\n\n  .Toastify__close-button--light {\n    color: $light;\n  }\n}\n\n// Tranfer List\n\n.rdl-filter, .rdl-control{\n  background-color: $input-bg;\n  border: 1px solid $input-border-color !important;\n  color: $input-color !important;\n}\n\n.rdl-move{\n  background: var(--#{$prefix}light) !important;\n  border: 1px solid var(--#{$prefix}light) !important;\n  color: var(--#{$prefix}body-color) !important;\n}\n\n.react-dual-listbox {\n  input:disabled, select:disabled{\n    background-color: $input-disabled-bg !important;\n    border: 1px solid $input-border-color !important;\n  }\n}\n\n.css-26l3qy-menu{\n  background-color: var(--#{$prefix}gray-200) !important;\n  border-color: var(--#{$prefix}border-color) !important;\n}\n\n.css-1n7v3ny-option{\n  background-color: var(--#{$prefix}gray-300) !important;\n  border-color: var(--#{$prefix}border-color) !important;\n}\n\n/* Change the white to any color */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover, \ninput:-webkit-autofill:focus, \ninput:-webkit-autofill:active{\n  -webkit-box-shadow: 0 0 0 30px var(--#{$prefix}input-bg) inset !important;\n  background-color: var(--#{$prefix}input-bg) !important;\n  color: var(--#{$prefix}body-color) !important;\n  -webkit-text-fill-color: var(--#{$prefix}body-color) !important;\n}\n","/*\r\nTemplate Name: Velzon - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 2.0.0\r\nWebsite: https://Themesbrand.com/\r\nContact: Themesbrand@gmail.com\r\nFile: Icons Css File\r\n*/\r\n\r\n// Icons Scss\r\n@import \"plugins/icons/materialdesignicons\";\r\n@import \"plugins/icons/boxicons\";\r\n@import \"plugins/icons/line-awesome\";\r\n@import \"plugins/icons/remixicon\";","/* MaterialDesignIcons.com */\r\n@font-face {\r\n  font-family: \"Material Design Icons\";\r\n  src: url(\"../../../fonts/materialdesignicons-webfont.eot?v=6.5.95\");\r\n  src: url(\"../../../fonts/materialdesignicons-webfont.eot?#iefix&v=6.5.95\") format(\"embedded-opentype\"), url(\"../../../fonts/materialdesignicons-webfont.woff2?v=6.5.95\") format(\"woff2\"), url(\"../../../fonts/materialdesignicons-webfont.woff?v=6.5.95\") format(\"woff\"), url(\"../../../fonts/materialdesignicons-webfont.ttf?v=6.5.95\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n.mdi:before,\r\n.mdi-set {\r\n  display: inline-block;\r\n  font: normal normal normal 24px/1 \"Material Design Icons\";\r\n  font-size: inherit;\r\n  text-rendering: auto;\r\n  line-height: inherit;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.mdi-ab-testing::before {\r\n  content: \"\\F01C9\";\r\n}\r\n\r\n.mdi-abacus::before {\r\n  content: \"\\F16E0\";\r\n}\r\n\r\n.mdi-abjad-arabic::before {\r\n  content: \"\\F1328\";\r\n}\r\n\r\n.mdi-abjad-hebrew::before {\r\n  content: \"\\F1329\";\r\n}\r\n\r\n.mdi-abugida-devanagari::before {\r\n  content: \"\\F132A\";\r\n}\r\n\r\n.mdi-abugida-thai::before {\r\n  content: \"\\F132B\";\r\n}\r\n\r\n.mdi-access-point::before {\r\n  content: \"\\F0003\";\r\n}\r\n\r\n.mdi-access-point-check::before {\r\n  content: \"\\F1538\";\r\n}\r\n\r\n.mdi-access-point-minus::before {\r\n  content: \"\\F1539\";\r\n}\r\n\r\n.mdi-access-point-network::before {\r\n  content: \"\\F0002\";\r\n}\r\n\r\n.mdi-access-point-network-off::before {\r\n  content: \"\\F0BE1\";\r\n}\r\n\r\n.mdi-access-point-off::before {\r\n  content: \"\\F1511\";\r\n}\r\n\r\n.mdi-access-point-plus::before {\r\n  content: \"\\F153A\";\r\n}\r\n\r\n.mdi-access-point-remove::before {\r\n  content: \"\\F153B\";\r\n}\r\n\r\n.mdi-account::before {\r\n  content: \"\\F0004\";\r\n}\r\n\r\n.mdi-account-alert::before {\r\n  content: \"\\F0005\";\r\n}\r\n\r\n.mdi-account-alert-outline::before {\r\n  content: \"\\F0B50\";\r\n}\r\n\r\n.mdi-account-arrow-down::before {\r\n  content: \"\\F1868\";\r\n}\r\n\r\n.mdi-account-arrow-down-outline::before {\r\n  content: \"\\F1869\";\r\n}\r\n\r\n.mdi-account-arrow-left::before {\r\n  content: \"\\F0B51\";\r\n}\r\n\r\n.mdi-account-arrow-left-outline::before {\r\n  content: \"\\F0B52\";\r\n}\r\n\r\n.mdi-account-arrow-right::before {\r\n  content: \"\\F0B53\";\r\n}\r\n\r\n.mdi-account-arrow-right-outline::before {\r\n  content: \"\\F0B54\";\r\n}\r\n\r\n.mdi-account-arrow-up::before {\r\n  content: \"\\F1867\";\r\n}\r\n\r\n.mdi-account-arrow-up-outline::before {\r\n  content: \"\\F186A\";\r\n}\r\n\r\n.mdi-account-box::before {\r\n  content: \"\\F0006\";\r\n}\r\n\r\n.mdi-account-box-multiple::before {\r\n  content: \"\\F0934\";\r\n}\r\n\r\n.mdi-account-box-multiple-outline::before {\r\n  content: \"\\F100A\";\r\n}\r\n\r\n.mdi-account-box-outline::before {\r\n  content: \"\\F0007\";\r\n}\r\n\r\n.mdi-account-cancel::before {\r\n  content: \"\\F12DF\";\r\n}\r\n\r\n.mdi-account-cancel-outline::before {\r\n  content: \"\\F12E0\";\r\n}\r\n\r\n.mdi-account-cash::before {\r\n  content: \"\\F1097\";\r\n}\r\n\r\n.mdi-account-cash-outline::before {\r\n  content: \"\\F1098\";\r\n}\r\n\r\n.mdi-account-check::before {\r\n  content: \"\\F0008\";\r\n}\r\n\r\n.mdi-account-check-outline::before {\r\n  content: \"\\F0BE2\";\r\n}\r\n\r\n.mdi-account-child::before {\r\n  content: \"\\F0A89\";\r\n}\r\n\r\n.mdi-account-child-circle::before {\r\n  content: \"\\F0A8A\";\r\n}\r\n\r\n.mdi-account-child-outline::before {\r\n  content: \"\\F10C8\";\r\n}\r\n\r\n.mdi-account-circle::before {\r\n  content: \"\\F0009\";\r\n}\r\n\r\n.mdi-account-circle-outline::before {\r\n  content: \"\\F0B55\";\r\n}\r\n\r\n.mdi-account-clock::before {\r\n  content: \"\\F0B56\";\r\n}\r\n\r\n.mdi-account-clock-outline::before {\r\n  content: \"\\F0B57\";\r\n}\r\n\r\n.mdi-account-cog::before {\r\n  content: \"\\F1370\";\r\n}\r\n\r\n.mdi-account-cog-outline::before {\r\n  content: \"\\F1371\";\r\n}\r\n\r\n.mdi-account-convert::before {\r\n  content: \"\\F000A\";\r\n}\r\n\r\n.mdi-account-convert-outline::before {\r\n  content: \"\\F1301\";\r\n}\r\n\r\n.mdi-account-cowboy-hat::before {\r\n  content: \"\\F0E9B\";\r\n}\r\n\r\n.mdi-account-cowboy-hat-outline::before {\r\n  content: \"\\F17F3\";\r\n}\r\n\r\n.mdi-account-details::before {\r\n  content: \"\\F0631\";\r\n}\r\n\r\n.mdi-account-details-outline::before {\r\n  content: \"\\F1372\";\r\n}\r\n\r\n.mdi-account-edit::before {\r\n  content: \"\\F06BC\";\r\n}\r\n\r\n.mdi-account-edit-outline::before {\r\n  content: \"\\F0FFB\";\r\n}\r\n\r\n.mdi-account-eye::before {\r\n  content: \"\\F0420\";\r\n}\r\n\r\n.mdi-account-eye-outline::before {\r\n  content: \"\\F127B\";\r\n}\r\n\r\n.mdi-account-filter::before {\r\n  content: \"\\F0936\";\r\n}\r\n\r\n.mdi-account-filter-outline::before {\r\n  content: \"\\F0F9D\";\r\n}\r\n\r\n.mdi-account-group::before {\r\n  content: \"\\F0849\";\r\n}\r\n\r\n.mdi-account-group-outline::before {\r\n  content: \"\\F0B58\";\r\n}\r\n\r\n.mdi-account-hard-hat::before {\r\n  content: \"\\F05B5\";\r\n}\r\n\r\n.mdi-account-heart::before {\r\n  content: \"\\F0899\";\r\n}\r\n\r\n.mdi-account-heart-outline::before {\r\n  content: \"\\F0BE3\";\r\n}\r\n\r\n.mdi-account-injury::before {\r\n  content: \"\\F1815\";\r\n}\r\n\r\n.mdi-account-injury-outline::before {\r\n  content: \"\\F1816\";\r\n}\r\n\r\n.mdi-account-key::before {\r\n  content: \"\\F000B\";\r\n}\r\n\r\n.mdi-account-key-outline::before {\r\n  content: \"\\F0BE4\";\r\n}\r\n\r\n.mdi-account-lock::before {\r\n  content: \"\\F115E\";\r\n}\r\n\r\n.mdi-account-lock-open::before {\r\n  content: \"\\F1960\";\r\n}\r\n\r\n.mdi-account-lock-open-outline::before {\r\n  content: \"\\F1961\";\r\n}\r\n\r\n.mdi-account-lock-outline::before {\r\n  content: \"\\F115F\";\r\n}\r\n\r\n.mdi-account-minus::before {\r\n  content: \"\\F000D\";\r\n}\r\n\r\n.mdi-account-minus-outline::before {\r\n  content: \"\\F0AEC\";\r\n}\r\n\r\n.mdi-account-multiple::before {\r\n  content: \"\\F000E\";\r\n}\r\n\r\n.mdi-account-multiple-check::before {\r\n  content: \"\\F08C5\";\r\n}\r\n\r\n.mdi-account-multiple-check-outline::before {\r\n  content: \"\\F11FE\";\r\n}\r\n\r\n.mdi-account-multiple-minus::before {\r\n  content: \"\\F05D3\";\r\n}\r\n\r\n.mdi-account-multiple-minus-outline::before {\r\n  content: \"\\F0BE5\";\r\n}\r\n\r\n.mdi-account-multiple-outline::before {\r\n  content: \"\\F000F\";\r\n}\r\n\r\n.mdi-account-multiple-plus::before {\r\n  content: \"\\F0010\";\r\n}\r\n\r\n.mdi-account-multiple-plus-outline::before {\r\n  content: \"\\F0800\";\r\n}\r\n\r\n.mdi-account-multiple-remove::before {\r\n  content: \"\\F120A\";\r\n}\r\n\r\n.mdi-account-multiple-remove-outline::before {\r\n  content: \"\\F120B\";\r\n}\r\n\r\n.mdi-account-music::before {\r\n  content: \"\\F0803\";\r\n}\r\n\r\n.mdi-account-music-outline::before {\r\n  content: \"\\F0CE9\";\r\n}\r\n\r\n.mdi-account-network::before {\r\n  content: \"\\F0011\";\r\n}\r\n\r\n.mdi-account-network-outline::before {\r\n  content: \"\\F0BE6\";\r\n}\r\n\r\n.mdi-account-off::before {\r\n  content: \"\\F0012\";\r\n}\r\n\r\n.mdi-account-off-outline::before {\r\n  content: \"\\F0BE7\";\r\n}\r\n\r\n.mdi-account-outline::before {\r\n  content: \"\\F0013\";\r\n}\r\n\r\n.mdi-account-plus::before {\r\n  content: \"\\F0014\";\r\n}\r\n\r\n.mdi-account-plus-outline::before {\r\n  content: \"\\F0801\";\r\n}\r\n\r\n.mdi-account-question::before {\r\n  content: \"\\F0B59\";\r\n}\r\n\r\n.mdi-account-question-outline::before {\r\n  content: \"\\F0B5A\";\r\n}\r\n\r\n.mdi-account-reactivate::before {\r\n  content: \"\\F152B\";\r\n}\r\n\r\n.mdi-account-reactivate-outline::before {\r\n  content: \"\\F152C\";\r\n}\r\n\r\n.mdi-account-remove::before {\r\n  content: \"\\F0015\";\r\n}\r\n\r\n.mdi-account-remove-outline::before {\r\n  content: \"\\F0AED\";\r\n}\r\n\r\n.mdi-account-search::before {\r\n  content: \"\\F0016\";\r\n}\r\n\r\n.mdi-account-search-outline::before {\r\n  content: \"\\F0935\";\r\n}\r\n\r\n.mdi-account-settings::before {\r\n  content: \"\\F0630\";\r\n}\r\n\r\n.mdi-account-settings-outline::before {\r\n  content: \"\\F10C9\";\r\n}\r\n\r\n.mdi-account-star::before {\r\n  content: \"\\F0017\";\r\n}\r\n\r\n.mdi-account-star-outline::before {\r\n  content: \"\\F0BE8\";\r\n}\r\n\r\n.mdi-account-supervisor::before {\r\n  content: \"\\F0A8B\";\r\n}\r\n\r\n.mdi-account-supervisor-circle::before {\r\n  content: \"\\F0A8C\";\r\n}\r\n\r\n.mdi-account-supervisor-circle-outline::before {\r\n  content: \"\\F14EC\";\r\n}\r\n\r\n.mdi-account-supervisor-outline::before {\r\n  content: \"\\F112D\";\r\n}\r\n\r\n.mdi-account-switch::before {\r\n  content: \"\\F0019\";\r\n}\r\n\r\n.mdi-account-switch-outline::before {\r\n  content: \"\\F04CB\";\r\n}\r\n\r\n.mdi-account-sync::before {\r\n  content: \"\\F191B\";\r\n}\r\n\r\n.mdi-account-sync-outline::before {\r\n  content: \"\\F191C\";\r\n}\r\n\r\n.mdi-account-tie::before {\r\n  content: \"\\F0CE3\";\r\n}\r\n\r\n.mdi-account-tie-hat::before {\r\n  content: \"\\F1898\";\r\n}\r\n\r\n.mdi-account-tie-hat-outline::before {\r\n  content: \"\\F1899\";\r\n}\r\n\r\n.mdi-account-tie-outline::before {\r\n  content: \"\\F10CA\";\r\n}\r\n\r\n.mdi-account-tie-voice::before {\r\n  content: \"\\F1308\";\r\n}\r\n\r\n.mdi-account-tie-voice-off::before {\r\n  content: \"\\F130A\";\r\n}\r\n\r\n.mdi-account-tie-voice-off-outline::before {\r\n  content: \"\\F130B\";\r\n}\r\n\r\n.mdi-account-tie-voice-outline::before {\r\n  content: \"\\F1309\";\r\n}\r\n\r\n.mdi-account-voice::before {\r\n  content: \"\\F05CB\";\r\n}\r\n\r\n.mdi-account-voice-off::before {\r\n  content: \"\\F0ED4\";\r\n}\r\n\r\n.mdi-account-wrench::before {\r\n  content: \"\\F189A\";\r\n}\r\n\r\n.mdi-account-wrench-outline::before {\r\n  content: \"\\F189B\";\r\n}\r\n\r\n.mdi-adjust::before {\r\n  content: \"\\F001A\";\r\n}\r\n\r\n.mdi-advertisements::before {\r\n  content: \"\\F192A\";\r\n}\r\n\r\n.mdi-advertisements-off::before {\r\n  content: \"\\F192B\";\r\n}\r\n\r\n.mdi-air-conditioner::before {\r\n  content: \"\\F001B\";\r\n}\r\n\r\n.mdi-air-filter::before {\r\n  content: \"\\F0D43\";\r\n}\r\n\r\n.mdi-air-horn::before {\r\n  content: \"\\F0DAC\";\r\n}\r\n\r\n.mdi-air-humidifier::before {\r\n  content: \"\\F1099\";\r\n}\r\n\r\n.mdi-air-humidifier-off::before {\r\n  content: \"\\F1466\";\r\n}\r\n\r\n.mdi-air-purifier::before {\r\n  content: \"\\F0D44\";\r\n}\r\n\r\n.mdi-airbag::before {\r\n  content: \"\\F0BE9\";\r\n}\r\n\r\n.mdi-airballoon::before {\r\n  content: \"\\F001C\";\r\n}\r\n\r\n.mdi-airballoon-outline::before {\r\n  content: \"\\F100B\";\r\n}\r\n\r\n.mdi-airplane::before {\r\n  content: \"\\F001D\";\r\n}\r\n\r\n.mdi-airplane-alert::before {\r\n  content: \"\\F187A\";\r\n}\r\n\r\n.mdi-airplane-check::before {\r\n  content: \"\\F187B\";\r\n}\r\n\r\n.mdi-airplane-clock::before {\r\n  content: \"\\F187C\";\r\n}\r\n\r\n.mdi-airplane-cog::before {\r\n  content: \"\\F187D\";\r\n}\r\n\r\n.mdi-airplane-edit::before {\r\n  content: \"\\F187E\";\r\n}\r\n\r\n.mdi-airplane-landing::before {\r\n  content: \"\\F05D4\";\r\n}\r\n\r\n.mdi-airplane-marker::before {\r\n  content: \"\\F187F\";\r\n}\r\n\r\n.mdi-airplane-minus::before {\r\n  content: \"\\F1880\";\r\n}\r\n\r\n.mdi-airplane-off::before {\r\n  content: \"\\F001E\";\r\n}\r\n\r\n.mdi-airplane-plus::before {\r\n  content: \"\\F1881\";\r\n}\r\n\r\n.mdi-airplane-remove::before {\r\n  content: \"\\F1882\";\r\n}\r\n\r\n.mdi-airplane-search::before {\r\n  content: \"\\F1883\";\r\n}\r\n\r\n.mdi-airplane-settings::before {\r\n  content: \"\\F1884\";\r\n}\r\n\r\n.mdi-airplane-takeoff::before {\r\n  content: \"\\F05D5\";\r\n}\r\n\r\n.mdi-airport::before {\r\n  content: \"\\F084B\";\r\n}\r\n\r\n.mdi-alarm::before {\r\n  content: \"\\F0020\";\r\n}\r\n\r\n.mdi-alarm-bell::before {\r\n  content: \"\\F078E\";\r\n}\r\n\r\n.mdi-alarm-check::before {\r\n  content: \"\\F0021\";\r\n}\r\n\r\n.mdi-alarm-light::before {\r\n  content: \"\\F078F\";\r\n}\r\n\r\n.mdi-alarm-light-off::before {\r\n  content: \"\\F171E\";\r\n}\r\n\r\n.mdi-alarm-light-off-outline::before {\r\n  content: \"\\F171F\";\r\n}\r\n\r\n.mdi-alarm-light-outline::before {\r\n  content: \"\\F0BEA\";\r\n}\r\n\r\n.mdi-alarm-multiple::before {\r\n  content: \"\\F0022\";\r\n}\r\n\r\n.mdi-alarm-note::before {\r\n  content: \"\\F0E71\";\r\n}\r\n\r\n.mdi-alarm-note-off::before {\r\n  content: \"\\F0E72\";\r\n}\r\n\r\n.mdi-alarm-off::before {\r\n  content: \"\\F0023\";\r\n}\r\n\r\n.mdi-alarm-panel::before {\r\n  content: \"\\F15C4\";\r\n}\r\n\r\n.mdi-alarm-panel-outline::before {\r\n  content: \"\\F15C5\";\r\n}\r\n\r\n.mdi-alarm-plus::before {\r\n  content: \"\\F0024\";\r\n}\r\n\r\n.mdi-alarm-snooze::before {\r\n  content: \"\\F068E\";\r\n}\r\n\r\n.mdi-album::before {\r\n  content: \"\\F0025\";\r\n}\r\n\r\n.mdi-alert::before {\r\n  content: \"\\F0026\";\r\n}\r\n\r\n.mdi-alert-box::before {\r\n  content: \"\\F0027\";\r\n}\r\n\r\n.mdi-alert-box-outline::before {\r\n  content: \"\\F0CE4\";\r\n}\r\n\r\n.mdi-alert-circle::before {\r\n  content: \"\\F0028\";\r\n}\r\n\r\n.mdi-alert-circle-check::before {\r\n  content: \"\\F11ED\";\r\n}\r\n\r\n.mdi-alert-circle-check-outline::before {\r\n  content: \"\\F11EE\";\r\n}\r\n\r\n.mdi-alert-circle-outline::before {\r\n  content: \"\\F05D6\";\r\n}\r\n\r\n.mdi-alert-decagram::before {\r\n  content: \"\\F06BD\";\r\n}\r\n\r\n.mdi-alert-decagram-outline::before {\r\n  content: \"\\F0CE5\";\r\n}\r\n\r\n.mdi-alert-minus::before {\r\n  content: \"\\F14BB\";\r\n}\r\n\r\n.mdi-alert-minus-outline::before {\r\n  content: \"\\F14BE\";\r\n}\r\n\r\n.mdi-alert-octagon::before {\r\n  content: \"\\F0029\";\r\n}\r\n\r\n.mdi-alert-octagon-outline::before {\r\n  content: \"\\F0CE6\";\r\n}\r\n\r\n.mdi-alert-octagram::before {\r\n  content: \"\\F0767\";\r\n}\r\n\r\n.mdi-alert-octagram-outline::before {\r\n  content: \"\\F0CE7\";\r\n}\r\n\r\n.mdi-alert-outline::before {\r\n  content: \"\\F002A\";\r\n}\r\n\r\n.mdi-alert-plus::before {\r\n  content: \"\\F14BA\";\r\n}\r\n\r\n.mdi-alert-plus-outline::before {\r\n  content: \"\\F14BD\";\r\n}\r\n\r\n.mdi-alert-remove::before {\r\n  content: \"\\F14BC\";\r\n}\r\n\r\n.mdi-alert-remove-outline::before {\r\n  content: \"\\F14BF\";\r\n}\r\n\r\n.mdi-alert-rhombus::before {\r\n  content: \"\\F11CE\";\r\n}\r\n\r\n.mdi-alert-rhombus-outline::before {\r\n  content: \"\\F11CF\";\r\n}\r\n\r\n.mdi-alien::before {\r\n  content: \"\\F089A\";\r\n}\r\n\r\n.mdi-alien-outline::before {\r\n  content: \"\\F10CB\";\r\n}\r\n\r\n.mdi-align-horizontal-center::before {\r\n  content: \"\\F11C3\";\r\n}\r\n\r\n.mdi-align-horizontal-distribute::before {\r\n  content: \"\\F1962\";\r\n}\r\n\r\n.mdi-align-horizontal-left::before {\r\n  content: \"\\F11C2\";\r\n}\r\n\r\n.mdi-align-horizontal-right::before {\r\n  content: \"\\F11C4\";\r\n}\r\n\r\n.mdi-align-vertical-bottom::before {\r\n  content: \"\\F11C5\";\r\n}\r\n\r\n.mdi-align-vertical-center::before {\r\n  content: \"\\F11C6\";\r\n}\r\n\r\n.mdi-align-vertical-distribute::before {\r\n  content: \"\\F1963\";\r\n}\r\n\r\n.mdi-align-vertical-top::before {\r\n  content: \"\\F11C7\";\r\n}\r\n\r\n.mdi-all-inclusive::before {\r\n  content: \"\\F06BE\";\r\n}\r\n\r\n.mdi-all-inclusive-box::before {\r\n  content: \"\\F188D\";\r\n}\r\n\r\n.mdi-all-inclusive-box-outline::before {\r\n  content: \"\\F188E\";\r\n}\r\n\r\n.mdi-allergy::before {\r\n  content: \"\\F1258\";\r\n}\r\n\r\n.mdi-alpha::before {\r\n  content: \"\\F002B\";\r\n}\r\n\r\n.mdi-alpha-a::before {\r\n  content: \"\\F0AEE\";\r\n}\r\n\r\n.mdi-alpha-a-box::before {\r\n  content: \"\\F0B08\";\r\n}\r\n\r\n.mdi-alpha-a-box-outline::before {\r\n  content: \"\\F0BEB\";\r\n}\r\n\r\n.mdi-alpha-a-circle::before {\r\n  content: \"\\F0BEC\";\r\n}\r\n\r\n.mdi-alpha-a-circle-outline::before {\r\n  content: \"\\F0BED\";\r\n}\r\n\r\n.mdi-alpha-b::before {\r\n  content: \"\\F0AEF\";\r\n}\r\n\r\n.mdi-alpha-b-box::before {\r\n  content: \"\\F0B09\";\r\n}\r\n\r\n.mdi-alpha-b-box-outline::before {\r\n  content: \"\\F0BEE\";\r\n}\r\n\r\n.mdi-alpha-b-circle::before {\r\n  content: \"\\F0BEF\";\r\n}\r\n\r\n.mdi-alpha-b-circle-outline::before {\r\n  content: \"\\F0BF0\";\r\n}\r\n\r\n.mdi-alpha-c::before {\r\n  content: \"\\F0AF0\";\r\n}\r\n\r\n.mdi-alpha-c-box::before {\r\n  content: \"\\F0B0A\";\r\n}\r\n\r\n.mdi-alpha-c-box-outline::before {\r\n  content: \"\\F0BF1\";\r\n}\r\n\r\n.mdi-alpha-c-circle::before {\r\n  content: \"\\F0BF2\";\r\n}\r\n\r\n.mdi-alpha-c-circle-outline::before {\r\n  content: \"\\F0BF3\";\r\n}\r\n\r\n.mdi-alpha-d::before {\r\n  content: \"\\F0AF1\";\r\n}\r\n\r\n.mdi-alpha-d-box::before {\r\n  content: \"\\F0B0B\";\r\n}\r\n\r\n.mdi-alpha-d-box-outline::before {\r\n  content: \"\\F0BF4\";\r\n}\r\n\r\n.mdi-alpha-d-circle::before {\r\n  content: \"\\F0BF5\";\r\n}\r\n\r\n.mdi-alpha-d-circle-outline::before {\r\n  content: \"\\F0BF6\";\r\n}\r\n\r\n.mdi-alpha-e::before {\r\n  content: \"\\F0AF2\";\r\n}\r\n\r\n.mdi-alpha-e-box::before {\r\n  content: \"\\F0B0C\";\r\n}\r\n\r\n.mdi-alpha-e-box-outline::before {\r\n  content: \"\\F0BF7\";\r\n}\r\n\r\n.mdi-alpha-e-circle::before {\r\n  content: \"\\F0BF8\";\r\n}\r\n\r\n.mdi-alpha-e-circle-outline::before {\r\n  content: \"\\F0BF9\";\r\n}\r\n\r\n.mdi-alpha-f::before {\r\n  content: \"\\F0AF3\";\r\n}\r\n\r\n.mdi-alpha-f-box::before {\r\n  content: \"\\F0B0D\";\r\n}\r\n\r\n.mdi-alpha-f-box-outline::before {\r\n  content: \"\\F0BFA\";\r\n}\r\n\r\n.mdi-alpha-f-circle::before {\r\n  content: \"\\F0BFB\";\r\n}\r\n\r\n.mdi-alpha-f-circle-outline::before {\r\n  content: \"\\F0BFC\";\r\n}\r\n\r\n.mdi-alpha-g::before {\r\n  content: \"\\F0AF4\";\r\n}\r\n\r\n.mdi-alpha-g-box::before {\r\n  content: \"\\F0B0E\";\r\n}\r\n\r\n.mdi-alpha-g-box-outline::before {\r\n  content: \"\\F0BFD\";\r\n}\r\n\r\n.mdi-alpha-g-circle::before {\r\n  content: \"\\F0BFE\";\r\n}\r\n\r\n.mdi-alpha-g-circle-outline::before {\r\n  content: \"\\F0BFF\";\r\n}\r\n\r\n.mdi-alpha-h::before {\r\n  content: \"\\F0AF5\";\r\n}\r\n\r\n.mdi-alpha-h-box::before {\r\n  content: \"\\F0B0F\";\r\n}\r\n\r\n.mdi-alpha-h-box-outline::before {\r\n  content: \"\\F0C00\";\r\n}\r\n\r\n.mdi-alpha-h-circle::before {\r\n  content: \"\\F0C01\";\r\n}\r\n\r\n.mdi-alpha-h-circle-outline::before {\r\n  content: \"\\F0C02\";\r\n}\r\n\r\n.mdi-alpha-i::before {\r\n  content: \"\\F0AF6\";\r\n}\r\n\r\n.mdi-alpha-i-box::before {\r\n  content: \"\\F0B10\";\r\n}\r\n\r\n.mdi-alpha-i-box-outline::before {\r\n  content: \"\\F0C03\";\r\n}\r\n\r\n.mdi-alpha-i-circle::before {\r\n  content: \"\\F0C04\";\r\n}\r\n\r\n.mdi-alpha-i-circle-outline::before {\r\n  content: \"\\F0C05\";\r\n}\r\n\r\n.mdi-alpha-j::before {\r\n  content: \"\\F0AF7\";\r\n}\r\n\r\n.mdi-alpha-j-box::before {\r\n  content: \"\\F0B11\";\r\n}\r\n\r\n.mdi-alpha-j-box-outline::before {\r\n  content: \"\\F0C06\";\r\n}\r\n\r\n.mdi-alpha-j-circle::before {\r\n  content: \"\\F0C07\";\r\n}\r\n\r\n.mdi-alpha-j-circle-outline::before {\r\n  content: \"\\F0C08\";\r\n}\r\n\r\n.mdi-alpha-k::before {\r\n  content: \"\\F0AF8\";\r\n}\r\n\r\n.mdi-alpha-k-box::before {\r\n  content: \"\\F0B12\";\r\n}\r\n\r\n.mdi-alpha-k-box-outline::before {\r\n  content: \"\\F0C09\";\r\n}\r\n\r\n.mdi-alpha-k-circle::before {\r\n  content: \"\\F0C0A\";\r\n}\r\n\r\n.mdi-alpha-k-circle-outline::before {\r\n  content: \"\\F0C0B\";\r\n}\r\n\r\n.mdi-alpha-l::before {\r\n  content: \"\\F0AF9\";\r\n}\r\n\r\n.mdi-alpha-l-box::before {\r\n  content: \"\\F0B13\";\r\n}\r\n\r\n.mdi-alpha-l-box-outline::before {\r\n  content: \"\\F0C0C\";\r\n}\r\n\r\n.mdi-alpha-l-circle::before {\r\n  content: \"\\F0C0D\";\r\n}\r\n\r\n.mdi-alpha-l-circle-outline::before {\r\n  content: \"\\F0C0E\";\r\n}\r\n\r\n.mdi-alpha-m::before {\r\n  content: \"\\F0AFA\";\r\n}\r\n\r\n.mdi-alpha-m-box::before {\r\n  content: \"\\F0B14\";\r\n}\r\n\r\n.mdi-alpha-m-box-outline::before {\r\n  content: \"\\F0C0F\";\r\n}\r\n\r\n.mdi-alpha-m-circle::before {\r\n  content: \"\\F0C10\";\r\n}\r\n\r\n.mdi-alpha-m-circle-outline::before {\r\n  content: \"\\F0C11\";\r\n}\r\n\r\n.mdi-alpha-n::before {\r\n  content: \"\\F0AFB\";\r\n}\r\n\r\n.mdi-alpha-n-box::before {\r\n  content: \"\\F0B15\";\r\n}\r\n\r\n.mdi-alpha-n-box-outline::before {\r\n  content: \"\\F0C12\";\r\n}\r\n\r\n.mdi-alpha-n-circle::before {\r\n  content: \"\\F0C13\";\r\n}\r\n\r\n.mdi-alpha-n-circle-outline::before {\r\n  content: \"\\F0C14\";\r\n}\r\n\r\n.mdi-alpha-o::before {\r\n  content: \"\\F0AFC\";\r\n}\r\n\r\n.mdi-alpha-o-box::before {\r\n  content: \"\\F0B16\";\r\n}\r\n\r\n.mdi-alpha-o-box-outline::before {\r\n  content: \"\\F0C15\";\r\n}\r\n\r\n.mdi-alpha-o-circle::before {\r\n  content: \"\\F0C16\";\r\n}\r\n\r\n.mdi-alpha-o-circle-outline::before {\r\n  content: \"\\F0C17\";\r\n}\r\n\r\n.mdi-alpha-p::before {\r\n  content: \"\\F0AFD\";\r\n}\r\n\r\n.mdi-alpha-p-box::before {\r\n  content: \"\\F0B17\";\r\n}\r\n\r\n.mdi-alpha-p-box-outline::before {\r\n  content: \"\\F0C18\";\r\n}\r\n\r\n.mdi-alpha-p-circle::before {\r\n  content: \"\\F0C19\";\r\n}\r\n\r\n.mdi-alpha-p-circle-outline::before {\r\n  content: \"\\F0C1A\";\r\n}\r\n\r\n.mdi-alpha-q::before {\r\n  content: \"\\F0AFE\";\r\n}\r\n\r\n.mdi-alpha-q-box::before {\r\n  content: \"\\F0B18\";\r\n}\r\n\r\n.mdi-alpha-q-box-outline::before {\r\n  content: \"\\F0C1B\";\r\n}\r\n\r\n.mdi-alpha-q-circle::before {\r\n  content: \"\\F0C1C\";\r\n}\r\n\r\n.mdi-alpha-q-circle-outline::before {\r\n  content: \"\\F0C1D\";\r\n}\r\n\r\n.mdi-alpha-r::before {\r\n  content: \"\\F0AFF\";\r\n}\r\n\r\n.mdi-alpha-r-box::before {\r\n  content: \"\\F0B19\";\r\n}\r\n\r\n.mdi-alpha-r-box-outline::before {\r\n  content: \"\\F0C1E\";\r\n}\r\n\r\n.mdi-alpha-r-circle::before {\r\n  content: \"\\F0C1F\";\r\n}\r\n\r\n.mdi-alpha-r-circle-outline::before {\r\n  content: \"\\F0C20\";\r\n}\r\n\r\n.mdi-alpha-s::before {\r\n  content: \"\\F0B00\";\r\n}\r\n\r\n.mdi-alpha-s-box::before {\r\n  content: \"\\F0B1A\";\r\n}\r\n\r\n.mdi-alpha-s-box-outline::before {\r\n  content: \"\\F0C21\";\r\n}\r\n\r\n.mdi-alpha-s-circle::before {\r\n  content: \"\\F0C22\";\r\n}\r\n\r\n.mdi-alpha-s-circle-outline::before {\r\n  content: \"\\F0C23\";\r\n}\r\n\r\n.mdi-alpha-t::before {\r\n  content: \"\\F0B01\";\r\n}\r\n\r\n.mdi-alpha-t-box::before {\r\n  content: \"\\F0B1B\";\r\n}\r\n\r\n.mdi-alpha-t-box-outline::before {\r\n  content: \"\\F0C24\";\r\n}\r\n\r\n.mdi-alpha-t-circle::before {\r\n  content: \"\\F0C25\";\r\n}\r\n\r\n.mdi-alpha-t-circle-outline::before {\r\n  content: \"\\F0C26\";\r\n}\r\n\r\n.mdi-alpha-u::before {\r\n  content: \"\\F0B02\";\r\n}\r\n\r\n.mdi-alpha-u-box::before {\r\n  content: \"\\F0B1C\";\r\n}\r\n\r\n.mdi-alpha-u-box-outline::before {\r\n  content: \"\\F0C27\";\r\n}\r\n\r\n.mdi-alpha-u-circle::before {\r\n  content: \"\\F0C28\";\r\n}\r\n\r\n.mdi-alpha-u-circle-outline::before {\r\n  content: \"\\F0C29\";\r\n}\r\n\r\n.mdi-alpha-v::before {\r\n  content: \"\\F0B03\";\r\n}\r\n\r\n.mdi-alpha-v-box::before {\r\n  content: \"\\F0B1D\";\r\n}\r\n\r\n.mdi-alpha-v-box-outline::before {\r\n  content: \"\\F0C2A\";\r\n}\r\n\r\n.mdi-alpha-v-circle::before {\r\n  content: \"\\F0C2B\";\r\n}\r\n\r\n.mdi-alpha-v-circle-outline::before {\r\n  content: \"\\F0C2C\";\r\n}\r\n\r\n.mdi-alpha-w::before {\r\n  content: \"\\F0B04\";\r\n}\r\n\r\n.mdi-alpha-w-box::before {\r\n  content: \"\\F0B1E\";\r\n}\r\n\r\n.mdi-alpha-w-box-outline::before {\r\n  content: \"\\F0C2D\";\r\n}\r\n\r\n.mdi-alpha-w-circle::before {\r\n  content: \"\\F0C2E\";\r\n}\r\n\r\n.mdi-alpha-w-circle-outline::before {\r\n  content: \"\\F0C2F\";\r\n}\r\n\r\n.mdi-alpha-x::before {\r\n  content: \"\\F0B05\";\r\n}\r\n\r\n.mdi-alpha-x-box::before {\r\n  content: \"\\F0B1F\";\r\n}\r\n\r\n.mdi-alpha-x-box-outline::before {\r\n  content: \"\\F0C30\";\r\n}\r\n\r\n.mdi-alpha-x-circle::before {\r\n  content: \"\\F0C31\";\r\n}\r\n\r\n.mdi-alpha-x-circle-outline::before {\r\n  content: \"\\F0C32\";\r\n}\r\n\r\n.mdi-alpha-y::before {\r\n  content: \"\\F0B06\";\r\n}\r\n\r\n.mdi-alpha-y-box::before {\r\n  content: \"\\F0B20\";\r\n}\r\n\r\n.mdi-alpha-y-box-outline::before {\r\n  content: \"\\F0C33\";\r\n}\r\n\r\n.mdi-alpha-y-circle::before {\r\n  content: \"\\F0C34\";\r\n}\r\n\r\n.mdi-alpha-y-circle-outline::before {\r\n  content: \"\\F0C35\";\r\n}\r\n\r\n.mdi-alpha-z::before {\r\n  content: \"\\F0B07\";\r\n}\r\n\r\n.mdi-alpha-z-box::before {\r\n  content: \"\\F0B21\";\r\n}\r\n\r\n.mdi-alpha-z-box-outline::before {\r\n  content: \"\\F0C36\";\r\n}\r\n\r\n.mdi-alpha-z-circle::before {\r\n  content: \"\\F0C37\";\r\n}\r\n\r\n.mdi-alpha-z-circle-outline::before {\r\n  content: \"\\F0C38\";\r\n}\r\n\r\n.mdi-alphabet-aurebesh::before {\r\n  content: \"\\F132C\";\r\n}\r\n\r\n.mdi-alphabet-cyrillic::before {\r\n  content: \"\\F132D\";\r\n}\r\n\r\n.mdi-alphabet-greek::before {\r\n  content: \"\\F132E\";\r\n}\r\n\r\n.mdi-alphabet-latin::before {\r\n  content: \"\\F132F\";\r\n}\r\n\r\n.mdi-alphabet-piqad::before {\r\n  content: \"\\F1330\";\r\n}\r\n\r\n.mdi-alphabet-tengwar::before {\r\n  content: \"\\F1337\";\r\n}\r\n\r\n.mdi-alphabetical::before {\r\n  content: \"\\F002C\";\r\n}\r\n\r\n.mdi-alphabetical-off::before {\r\n  content: \"\\F100C\";\r\n}\r\n\r\n.mdi-alphabetical-variant::before {\r\n  content: \"\\F100D\";\r\n}\r\n\r\n.mdi-alphabetical-variant-off::before {\r\n  content: \"\\F100E\";\r\n}\r\n\r\n.mdi-altimeter::before {\r\n  content: \"\\F05D7\";\r\n}\r\n\r\n.mdi-ambulance::before {\r\n  content: \"\\F002F\";\r\n}\r\n\r\n.mdi-ammunition::before {\r\n  content: \"\\F0CE8\";\r\n}\r\n\r\n.mdi-ampersand::before {\r\n  content: \"\\F0A8D\";\r\n}\r\n\r\n.mdi-amplifier::before {\r\n  content: \"\\F0030\";\r\n}\r\n\r\n.mdi-amplifier-off::before {\r\n  content: \"\\F11B5\";\r\n}\r\n\r\n.mdi-anchor::before {\r\n  content: \"\\F0031\";\r\n}\r\n\r\n.mdi-android::before {\r\n  content: \"\\F0032\";\r\n}\r\n\r\n.mdi-android-messages::before {\r\n  content: \"\\F0D45\";\r\n}\r\n\r\n.mdi-android-studio::before {\r\n  content: \"\\F0034\";\r\n}\r\n\r\n.mdi-angle-acute::before {\r\n  content: \"\\F0937\";\r\n}\r\n\r\n.mdi-angle-obtuse::before {\r\n  content: \"\\F0938\";\r\n}\r\n\r\n.mdi-angle-right::before {\r\n  content: \"\\F0939\";\r\n}\r\n\r\n.mdi-angular::before {\r\n  content: \"\\F06B2\";\r\n}\r\n\r\n.mdi-angularjs::before {\r\n  content: \"\\F06BF\";\r\n}\r\n\r\n.mdi-animation::before {\r\n  content: \"\\F05D8\";\r\n}\r\n\r\n.mdi-animation-outline::before {\r\n  content: \"\\F0A8F\";\r\n}\r\n\r\n.mdi-animation-play::before {\r\n  content: \"\\F093A\";\r\n}\r\n\r\n.mdi-animation-play-outline::before {\r\n  content: \"\\F0A90\";\r\n}\r\n\r\n.mdi-ansible::before {\r\n  content: \"\\F109A\";\r\n}\r\n\r\n.mdi-antenna::before {\r\n  content: \"\\F1119\";\r\n}\r\n\r\n.mdi-anvil::before {\r\n  content: \"\\F089B\";\r\n}\r\n\r\n.mdi-apache-kafka::before {\r\n  content: \"\\F100F\";\r\n}\r\n\r\n.mdi-api::before {\r\n  content: \"\\F109B\";\r\n}\r\n\r\n.mdi-api-off::before {\r\n  content: \"\\F1257\";\r\n}\r\n\r\n.mdi-apple::before {\r\n  content: \"\\F0035\";\r\n}\r\n\r\n.mdi-apple-finder::before {\r\n  content: \"\\F0036\";\r\n}\r\n\r\n.mdi-apple-icloud::before {\r\n  content: \"\\F0038\";\r\n}\r\n\r\n.mdi-apple-ios::before {\r\n  content: \"\\F0037\";\r\n}\r\n\r\n.mdi-apple-keyboard-caps::before {\r\n  content: \"\\F0632\";\r\n}\r\n\r\n.mdi-apple-keyboard-command::before {\r\n  content: \"\\F0633\";\r\n}\r\n\r\n.mdi-apple-keyboard-control::before {\r\n  content: \"\\F0634\";\r\n}\r\n\r\n.mdi-apple-keyboard-option::before {\r\n  content: \"\\F0635\";\r\n}\r\n\r\n.mdi-apple-keyboard-shift::before {\r\n  content: \"\\F0636\";\r\n}\r\n\r\n.mdi-apple-safari::before {\r\n  content: \"\\F0039\";\r\n}\r\n\r\n.mdi-application::before {\r\n  content: \"\\F08C6\";\r\n}\r\n\r\n.mdi-application-array::before {\r\n  content: \"\\F10F5\";\r\n}\r\n\r\n.mdi-application-array-outline::before {\r\n  content: \"\\F10F6\";\r\n}\r\n\r\n.mdi-application-braces::before {\r\n  content: \"\\F10F7\";\r\n}\r\n\r\n.mdi-application-braces-outline::before {\r\n  content: \"\\F10F8\";\r\n}\r\n\r\n.mdi-application-brackets::before {\r\n  content: \"\\F0C8B\";\r\n}\r\n\r\n.mdi-application-brackets-outline::before {\r\n  content: \"\\F0C8C\";\r\n}\r\n\r\n.mdi-application-cog::before {\r\n  content: \"\\F0675\";\r\n}\r\n\r\n.mdi-application-cog-outline::before {\r\n  content: \"\\F1577\";\r\n}\r\n\r\n.mdi-application-edit::before {\r\n  content: \"\\F00AE\";\r\n}\r\n\r\n.mdi-application-edit-outline::before {\r\n  content: \"\\F0619\";\r\n}\r\n\r\n.mdi-application-export::before {\r\n  content: \"\\F0DAD\";\r\n}\r\n\r\n.mdi-application-import::before {\r\n  content: \"\\F0DAE\";\r\n}\r\n\r\n.mdi-application-outline::before {\r\n  content: \"\\F0614\";\r\n}\r\n\r\n.mdi-application-parentheses::before {\r\n  content: \"\\F10F9\";\r\n}\r\n\r\n.mdi-application-parentheses-outline::before {\r\n  content: \"\\F10FA\";\r\n}\r\n\r\n.mdi-application-settings::before {\r\n  content: \"\\F0B60\";\r\n}\r\n\r\n.mdi-application-settings-outline::before {\r\n  content: \"\\F1555\";\r\n}\r\n\r\n.mdi-application-variable::before {\r\n  content: \"\\F10FB\";\r\n}\r\n\r\n.mdi-application-variable-outline::before {\r\n  content: \"\\F10FC\";\r\n}\r\n\r\n.mdi-approximately-equal::before {\r\n  content: \"\\F0F9E\";\r\n}\r\n\r\n.mdi-approximately-equal-box::before {\r\n  content: \"\\F0F9F\";\r\n}\r\n\r\n.mdi-apps::before {\r\n  content: \"\\F003B\";\r\n}\r\n\r\n.mdi-apps-box::before {\r\n  content: \"\\F0D46\";\r\n}\r\n\r\n.mdi-arch::before {\r\n  content: \"\\F08C7\";\r\n}\r\n\r\n.mdi-archive::before {\r\n  content: \"\\F003C\";\r\n}\r\n\r\n.mdi-archive-alert::before {\r\n  content: \"\\F14FD\";\r\n}\r\n\r\n.mdi-archive-alert-outline::before {\r\n  content: \"\\F14FE\";\r\n}\r\n\r\n.mdi-archive-arrow-down::before {\r\n  content: \"\\F1259\";\r\n}\r\n\r\n.mdi-archive-arrow-down-outline::before {\r\n  content: \"\\F125A\";\r\n}\r\n\r\n.mdi-archive-arrow-up::before {\r\n  content: \"\\F125B\";\r\n}\r\n\r\n.mdi-archive-arrow-up-outline::before {\r\n  content: \"\\F125C\";\r\n}\r\n\r\n.mdi-archive-cancel::before {\r\n  content: \"\\F174B\";\r\n}\r\n\r\n.mdi-archive-cancel-outline::before {\r\n  content: \"\\F174C\";\r\n}\r\n\r\n.mdi-archive-check::before {\r\n  content: \"\\F174D\";\r\n}\r\n\r\n.mdi-archive-check-outline::before {\r\n  content: \"\\F174E\";\r\n}\r\n\r\n.mdi-archive-clock::before {\r\n  content: \"\\F174F\";\r\n}\r\n\r\n.mdi-archive-clock-outline::before {\r\n  content: \"\\F1750\";\r\n}\r\n\r\n.mdi-archive-cog::before {\r\n  content: \"\\F1751\";\r\n}\r\n\r\n.mdi-archive-cog-outline::before {\r\n  content: \"\\F1752\";\r\n}\r\n\r\n.mdi-archive-edit::before {\r\n  content: \"\\F1753\";\r\n}\r\n\r\n.mdi-archive-edit-outline::before {\r\n  content: \"\\F1754\";\r\n}\r\n\r\n.mdi-archive-eye::before {\r\n  content: \"\\F1755\";\r\n}\r\n\r\n.mdi-archive-eye-outline::before {\r\n  content: \"\\F1756\";\r\n}\r\n\r\n.mdi-archive-lock::before {\r\n  content: \"\\F1757\";\r\n}\r\n\r\n.mdi-archive-lock-open::before {\r\n  content: \"\\F1758\";\r\n}\r\n\r\n.mdi-archive-lock-open-outline::before {\r\n  content: \"\\F1759\";\r\n}\r\n\r\n.mdi-archive-lock-outline::before {\r\n  content: \"\\F175A\";\r\n}\r\n\r\n.mdi-archive-marker::before {\r\n  content: \"\\F175B\";\r\n}\r\n\r\n.mdi-archive-marker-outline::before {\r\n  content: \"\\F175C\";\r\n}\r\n\r\n.mdi-archive-minus::before {\r\n  content: \"\\F175D\";\r\n}\r\n\r\n.mdi-archive-minus-outline::before {\r\n  content: \"\\F175E\";\r\n}\r\n\r\n.mdi-archive-music::before {\r\n  content: \"\\F175F\";\r\n}\r\n\r\n.mdi-archive-music-outline::before {\r\n  content: \"\\F1760\";\r\n}\r\n\r\n.mdi-archive-off::before {\r\n  content: \"\\F1761\";\r\n}\r\n\r\n.mdi-archive-off-outline::before {\r\n  content: \"\\F1762\";\r\n}\r\n\r\n.mdi-archive-outline::before {\r\n  content: \"\\F120E\";\r\n}\r\n\r\n.mdi-archive-plus::before {\r\n  content: \"\\F1763\";\r\n}\r\n\r\n.mdi-archive-plus-outline::before {\r\n  content: \"\\F1764\";\r\n}\r\n\r\n.mdi-archive-refresh::before {\r\n  content: \"\\F1765\";\r\n}\r\n\r\n.mdi-archive-refresh-outline::before {\r\n  content: \"\\F1766\";\r\n}\r\n\r\n.mdi-archive-remove::before {\r\n  content: \"\\F1767\";\r\n}\r\n\r\n.mdi-archive-remove-outline::before {\r\n  content: \"\\F1768\";\r\n}\r\n\r\n.mdi-archive-search::before {\r\n  content: \"\\F1769\";\r\n}\r\n\r\n.mdi-archive-search-outline::before {\r\n  content: \"\\F176A\";\r\n}\r\n\r\n.mdi-archive-settings::before {\r\n  content: \"\\F176B\";\r\n}\r\n\r\n.mdi-archive-settings-outline::before {\r\n  content: \"\\F176C\";\r\n}\r\n\r\n.mdi-archive-star::before {\r\n  content: \"\\F176D\";\r\n}\r\n\r\n.mdi-archive-star-outline::before {\r\n  content: \"\\F176E\";\r\n}\r\n\r\n.mdi-archive-sync::before {\r\n  content: \"\\F176F\";\r\n}\r\n\r\n.mdi-archive-sync-outline::before {\r\n  content: \"\\F1770\";\r\n}\r\n\r\n.mdi-arm-flex::before {\r\n  content: \"\\F0FD7\";\r\n}\r\n\r\n.mdi-arm-flex-outline::before {\r\n  content: \"\\F0FD6\";\r\n}\r\n\r\n.mdi-arrange-bring-forward::before {\r\n  content: \"\\F003D\";\r\n}\r\n\r\n.mdi-arrange-bring-to-front::before {\r\n  content: \"\\F003E\";\r\n}\r\n\r\n.mdi-arrange-send-backward::before {\r\n  content: \"\\F003F\";\r\n}\r\n\r\n.mdi-arrange-send-to-back::before {\r\n  content: \"\\F0040\";\r\n}\r\n\r\n.mdi-arrow-all::before {\r\n  content: \"\\F0041\";\r\n}\r\n\r\n.mdi-arrow-bottom-left::before {\r\n  content: \"\\F0042\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-bold-box::before {\r\n  content: \"\\F1964\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-bold-box-outline::before {\r\n  content: \"\\F1965\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-bold-outline::before {\r\n  content: \"\\F09B7\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-thick::before {\r\n  content: \"\\F09B8\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-thin::before {\r\n  content: \"\\F19B6\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-thin-circle-outline::before {\r\n  content: \"\\F1596\";\r\n}\r\n\r\n.mdi-arrow-bottom-right::before {\r\n  content: \"\\F0043\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-bold-box::before {\r\n  content: \"\\F1966\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-bold-box-outline::before {\r\n  content: \"\\F1967\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-bold-outline::before {\r\n  content: \"\\F09B9\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-thick::before {\r\n  content: \"\\F09BA\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-thin::before {\r\n  content: \"\\F19B7\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-thin-circle-outline::before {\r\n  content: \"\\F1595\";\r\n}\r\n\r\n.mdi-arrow-collapse::before {\r\n  content: \"\\F0615\";\r\n}\r\n\r\n.mdi-arrow-collapse-all::before {\r\n  content: \"\\F0044\";\r\n}\r\n\r\n.mdi-arrow-collapse-down::before {\r\n  content: \"\\F0792\";\r\n}\r\n\r\n.mdi-arrow-collapse-horizontal::before {\r\n  content: \"\\F084C\";\r\n}\r\n\r\n.mdi-arrow-collapse-left::before {\r\n  content: \"\\F0793\";\r\n}\r\n\r\n.mdi-arrow-collapse-right::before {\r\n  content: \"\\F0794\";\r\n}\r\n\r\n.mdi-arrow-collapse-up::before {\r\n  content: \"\\F0795\";\r\n}\r\n\r\n.mdi-arrow-collapse-vertical::before {\r\n  content: \"\\F084D\";\r\n}\r\n\r\n.mdi-arrow-decision::before {\r\n  content: \"\\F09BB\";\r\n}\r\n\r\n.mdi-arrow-decision-auto::before {\r\n  content: \"\\F09BC\";\r\n}\r\n\r\n.mdi-arrow-decision-auto-outline::before {\r\n  content: \"\\F09BD\";\r\n}\r\n\r\n.mdi-arrow-decision-outline::before {\r\n  content: \"\\F09BE\";\r\n}\r\n\r\n.mdi-arrow-down::before {\r\n  content: \"\\F0045\";\r\n}\r\n\r\n.mdi-arrow-down-bold::before {\r\n  content: \"\\F072E\";\r\n}\r\n\r\n.mdi-arrow-down-bold-box::before {\r\n  content: \"\\F072F\";\r\n}\r\n\r\n.mdi-arrow-down-bold-box-outline::before {\r\n  content: \"\\F0730\";\r\n}\r\n\r\n.mdi-arrow-down-bold-circle::before {\r\n  content: \"\\F0047\";\r\n}\r\n\r\n.mdi-arrow-down-bold-circle-outline::before {\r\n  content: \"\\F0048\";\r\n}\r\n\r\n.mdi-arrow-down-bold-hexagon-outline::before {\r\n  content: \"\\F0049\";\r\n}\r\n\r\n.mdi-arrow-down-bold-outline::before {\r\n  content: \"\\F09BF\";\r\n}\r\n\r\n.mdi-arrow-down-box::before {\r\n  content: \"\\F06C0\";\r\n}\r\n\r\n.mdi-arrow-down-circle::before {\r\n  content: \"\\F0CDB\";\r\n}\r\n\r\n.mdi-arrow-down-circle-outline::before {\r\n  content: \"\\F0CDC\";\r\n}\r\n\r\n.mdi-arrow-down-drop-circle::before {\r\n  content: \"\\F004A\";\r\n}\r\n\r\n.mdi-arrow-down-drop-circle-outline::before {\r\n  content: \"\\F004B\";\r\n}\r\n\r\n.mdi-arrow-down-left::before {\r\n  content: \"\\F17A1\";\r\n}\r\n\r\n.mdi-arrow-down-left-bold::before {\r\n  content: \"\\F17A2\";\r\n}\r\n\r\n.mdi-arrow-down-right::before {\r\n  content: \"\\F17A3\";\r\n}\r\n\r\n.mdi-arrow-down-right-bold::before {\r\n  content: \"\\F17A4\";\r\n}\r\n\r\n.mdi-arrow-down-thick::before {\r\n  content: \"\\F0046\";\r\n}\r\n\r\n.mdi-arrow-down-thin::before {\r\n  content: \"\\F19B3\";\r\n}\r\n\r\n.mdi-arrow-down-thin-circle-outline::before {\r\n  content: \"\\F1599\";\r\n}\r\n\r\n.mdi-arrow-expand::before {\r\n  content: \"\\F0616\";\r\n}\r\n\r\n.mdi-arrow-expand-all::before {\r\n  content: \"\\F004C\";\r\n}\r\n\r\n.mdi-arrow-expand-down::before {\r\n  content: \"\\F0796\";\r\n}\r\n\r\n.mdi-arrow-expand-horizontal::before {\r\n  content: \"\\F084E\";\r\n}\r\n\r\n.mdi-arrow-expand-left::before {\r\n  content: \"\\F0797\";\r\n}\r\n\r\n.mdi-arrow-expand-right::before {\r\n  content: \"\\F0798\";\r\n}\r\n\r\n.mdi-arrow-expand-up::before {\r\n  content: \"\\F0799\";\r\n}\r\n\r\n.mdi-arrow-expand-vertical::before {\r\n  content: \"\\F084F\";\r\n}\r\n\r\n.mdi-arrow-horizontal-lock::before {\r\n  content: \"\\F115B\";\r\n}\r\n\r\n.mdi-arrow-left::before {\r\n  content: \"\\F004D\";\r\n}\r\n\r\n.mdi-arrow-left-bold::before {\r\n  content: \"\\F0731\";\r\n}\r\n\r\n.mdi-arrow-left-bold-box::before {\r\n  content: \"\\F0732\";\r\n}\r\n\r\n.mdi-arrow-left-bold-box-outline::before {\r\n  content: \"\\F0733\";\r\n}\r\n\r\n.mdi-arrow-left-bold-circle::before {\r\n  content: \"\\F004F\";\r\n}\r\n\r\n.mdi-arrow-left-bold-circle-outline::before {\r\n  content: \"\\F0050\";\r\n}\r\n\r\n.mdi-arrow-left-bold-hexagon-outline::before {\r\n  content: \"\\F0051\";\r\n}\r\n\r\n.mdi-arrow-left-bold-outline::before {\r\n  content: \"\\F09C0\";\r\n}\r\n\r\n.mdi-arrow-left-bottom::before {\r\n  content: \"\\F17A5\";\r\n}\r\n\r\n.mdi-arrow-left-bottom-bold::before {\r\n  content: \"\\F17A6\";\r\n}\r\n\r\n.mdi-arrow-left-box::before {\r\n  content: \"\\F06C1\";\r\n}\r\n\r\n.mdi-arrow-left-circle::before {\r\n  content: \"\\F0CDD\";\r\n}\r\n\r\n.mdi-arrow-left-circle-outline::before {\r\n  content: \"\\F0CDE\";\r\n}\r\n\r\n.mdi-arrow-left-drop-circle::before {\r\n  content: \"\\F0052\";\r\n}\r\n\r\n.mdi-arrow-left-drop-circle-outline::before {\r\n  content: \"\\F0053\";\r\n}\r\n\r\n.mdi-arrow-left-right::before {\r\n  content: \"\\F0E73\";\r\n}\r\n\r\n.mdi-arrow-left-right-bold::before {\r\n  content: \"\\F0E74\";\r\n}\r\n\r\n.mdi-arrow-left-right-bold-outline::before {\r\n  content: \"\\F09C1\";\r\n}\r\n\r\n.mdi-arrow-left-thick::before {\r\n  content: \"\\F004E\";\r\n}\r\n\r\n.mdi-arrow-left-thin::before {\r\n  content: \"\\F19B1\";\r\n}\r\n\r\n.mdi-arrow-left-thin-circle-outline::before {\r\n  content: \"\\F159A\";\r\n}\r\n\r\n.mdi-arrow-left-top::before {\r\n  content: \"\\F17A7\";\r\n}\r\n\r\n.mdi-arrow-left-top-bold::before {\r\n  content: \"\\F17A8\";\r\n}\r\n\r\n.mdi-arrow-projectile::before {\r\n  content: \"\\F1840\";\r\n}\r\n\r\n.mdi-arrow-projectile-multiple::before {\r\n  content: \"\\F183F\";\r\n}\r\n\r\n.mdi-arrow-right::before {\r\n  content: \"\\F0054\";\r\n}\r\n\r\n.mdi-arrow-right-bold::before {\r\n  content: \"\\F0734\";\r\n}\r\n\r\n.mdi-arrow-right-bold-box::before {\r\n  content: \"\\F0735\";\r\n}\r\n\r\n.mdi-arrow-right-bold-box-outline::before {\r\n  content: \"\\F0736\";\r\n}\r\n\r\n.mdi-arrow-right-bold-circle::before {\r\n  content: \"\\F0056\";\r\n}\r\n\r\n.mdi-arrow-right-bold-circle-outline::before {\r\n  content: \"\\F0057\";\r\n}\r\n\r\n.mdi-arrow-right-bold-hexagon-outline::before {\r\n  content: \"\\F0058\";\r\n}\r\n\r\n.mdi-arrow-right-bold-outline::before {\r\n  content: \"\\F09C2\";\r\n}\r\n\r\n.mdi-arrow-right-bottom::before {\r\n  content: \"\\F17A9\";\r\n}\r\n\r\n.mdi-arrow-right-bottom-bold::before {\r\n  content: \"\\F17AA\";\r\n}\r\n\r\n.mdi-arrow-right-box::before {\r\n  content: \"\\F06C2\";\r\n}\r\n\r\n.mdi-arrow-right-circle::before {\r\n  content: \"\\F0CDF\";\r\n}\r\n\r\n.mdi-arrow-right-circle-outline::before {\r\n  content: \"\\F0CE0\";\r\n}\r\n\r\n.mdi-arrow-right-drop-circle::before {\r\n  content: \"\\F0059\";\r\n}\r\n\r\n.mdi-arrow-right-drop-circle-outline::before {\r\n  content: \"\\F005A\";\r\n}\r\n\r\n.mdi-arrow-right-thick::before {\r\n  content: \"\\F0055\";\r\n}\r\n\r\n.mdi-arrow-right-thin::before {\r\n  content: \"\\F19B0\";\r\n}\r\n\r\n.mdi-arrow-right-thin-circle-outline::before {\r\n  content: \"\\F1598\";\r\n}\r\n\r\n.mdi-arrow-right-top::before {\r\n  content: \"\\F17AB\";\r\n}\r\n\r\n.mdi-arrow-right-top-bold::before {\r\n  content: \"\\F17AC\";\r\n}\r\n\r\n.mdi-arrow-split-horizontal::before {\r\n  content: \"\\F093B\";\r\n}\r\n\r\n.mdi-arrow-split-vertical::before {\r\n  content: \"\\F093C\";\r\n}\r\n\r\n.mdi-arrow-top-left::before {\r\n  content: \"\\F005B\";\r\n}\r\n\r\n.mdi-arrow-top-left-bold-box::before {\r\n  content: \"\\F1968\";\r\n}\r\n\r\n.mdi-arrow-top-left-bold-box-outline::before {\r\n  content: \"\\F1969\";\r\n}\r\n\r\n.mdi-arrow-top-left-bold-outline::before {\r\n  content: \"\\F09C3\";\r\n}\r\n\r\n.mdi-arrow-top-left-bottom-right::before {\r\n  content: \"\\F0E75\";\r\n}\r\n\r\n.mdi-arrow-top-left-bottom-right-bold::before {\r\n  content: \"\\F0E76\";\r\n}\r\n\r\n.mdi-arrow-top-left-thick::before {\r\n  content: \"\\F09C4\";\r\n}\r\n\r\n.mdi-arrow-top-left-thin::before {\r\n  content: \"\\F19B5\";\r\n}\r\n\r\n.mdi-arrow-top-left-thin-circle-outline::before {\r\n  content: \"\\F1593\";\r\n}\r\n\r\n.mdi-arrow-top-right::before {\r\n  content: \"\\F005C\";\r\n}\r\n\r\n.mdi-arrow-top-right-bold-box::before {\r\n  content: \"\\F196A\";\r\n}\r\n\r\n.mdi-arrow-top-right-bold-box-outline::before {\r\n  content: \"\\F196B\";\r\n}\r\n\r\n.mdi-arrow-top-right-bold-outline::before {\r\n  content: \"\\F09C5\";\r\n}\r\n\r\n.mdi-arrow-top-right-bottom-left::before {\r\n  content: \"\\F0E77\";\r\n}\r\n\r\n.mdi-arrow-top-right-bottom-left-bold::before {\r\n  content: \"\\F0E78\";\r\n}\r\n\r\n.mdi-arrow-top-right-thick::before {\r\n  content: \"\\F09C6\";\r\n}\r\n\r\n.mdi-arrow-top-right-thin::before {\r\n  content: \"\\F19B4\";\r\n}\r\n\r\n.mdi-arrow-top-right-thin-circle-outline::before {\r\n  content: \"\\F1594\";\r\n}\r\n\r\n.mdi-arrow-u-down-left::before {\r\n  content: \"\\F17AD\";\r\n}\r\n\r\n.mdi-arrow-u-down-left-bold::before {\r\n  content: \"\\F17AE\";\r\n}\r\n\r\n.mdi-arrow-u-down-right::before {\r\n  content: \"\\F17AF\";\r\n}\r\n\r\n.mdi-arrow-u-down-right-bold::before {\r\n  content: \"\\F17B0\";\r\n}\r\n\r\n.mdi-arrow-u-left-bottom::before {\r\n  content: \"\\F17B1\";\r\n}\r\n\r\n.mdi-arrow-u-left-bottom-bold::before {\r\n  content: \"\\F17B2\";\r\n}\r\n\r\n.mdi-arrow-u-left-top::before {\r\n  content: \"\\F17B3\";\r\n}\r\n\r\n.mdi-arrow-u-left-top-bold::before {\r\n  content: \"\\F17B4\";\r\n}\r\n\r\n.mdi-arrow-u-right-bottom::before {\r\n  content: \"\\F17B5\";\r\n}\r\n\r\n.mdi-arrow-u-right-bottom-bold::before {\r\n  content: \"\\F17B6\";\r\n}\r\n\r\n.mdi-arrow-u-right-top::before {\r\n  content: \"\\F17B7\";\r\n}\r\n\r\n.mdi-arrow-u-right-top-bold::before {\r\n  content: \"\\F17B8\";\r\n}\r\n\r\n.mdi-arrow-u-up-left::before {\r\n  content: \"\\F17B9\";\r\n}\r\n\r\n.mdi-arrow-u-up-left-bold::before {\r\n  content: \"\\F17BA\";\r\n}\r\n\r\n.mdi-arrow-u-up-right::before {\r\n  content: \"\\F17BB\";\r\n}\r\n\r\n.mdi-arrow-u-up-right-bold::before {\r\n  content: \"\\F17BC\";\r\n}\r\n\r\n.mdi-arrow-up::before {\r\n  content: \"\\F005D\";\r\n}\r\n\r\n.mdi-arrow-up-bold::before {\r\n  content: \"\\F0737\";\r\n}\r\n\r\n.mdi-arrow-up-bold-box::before {\r\n  content: \"\\F0738\";\r\n}\r\n\r\n.mdi-arrow-up-bold-box-outline::before {\r\n  content: \"\\F0739\";\r\n}\r\n\r\n.mdi-arrow-up-bold-circle::before {\r\n  content: \"\\F005F\";\r\n}\r\n\r\n.mdi-arrow-up-bold-circle-outline::before {\r\n  content: \"\\F0060\";\r\n}\r\n\r\n.mdi-arrow-up-bold-hexagon-outline::before {\r\n  content: \"\\F0061\";\r\n}\r\n\r\n.mdi-arrow-up-bold-outline::before {\r\n  content: \"\\F09C7\";\r\n}\r\n\r\n.mdi-arrow-up-box::before {\r\n  content: \"\\F06C3\";\r\n}\r\n\r\n.mdi-arrow-up-circle::before {\r\n  content: \"\\F0CE1\";\r\n}\r\n\r\n.mdi-arrow-up-circle-outline::before {\r\n  content: \"\\F0CE2\";\r\n}\r\n\r\n.mdi-arrow-up-down::before {\r\n  content: \"\\F0E79\";\r\n}\r\n\r\n.mdi-arrow-up-down-bold::before {\r\n  content: \"\\F0E7A\";\r\n}\r\n\r\n.mdi-arrow-up-down-bold-outline::before {\r\n  content: \"\\F09C8\";\r\n}\r\n\r\n.mdi-arrow-up-drop-circle::before {\r\n  content: \"\\F0062\";\r\n}\r\n\r\n.mdi-arrow-up-drop-circle-outline::before {\r\n  content: \"\\F0063\";\r\n}\r\n\r\n.mdi-arrow-up-left::before {\r\n  content: \"\\F17BD\";\r\n}\r\n\r\n.mdi-arrow-up-left-bold::before {\r\n  content: \"\\F17BE\";\r\n}\r\n\r\n.mdi-arrow-up-right::before {\r\n  content: \"\\F17BF\";\r\n}\r\n\r\n.mdi-arrow-up-right-bold::before {\r\n  content: \"\\F17C0\";\r\n}\r\n\r\n.mdi-arrow-up-thick::before {\r\n  content: \"\\F005E\";\r\n}\r\n\r\n.mdi-arrow-up-thin::before {\r\n  content: \"\\F19B2\";\r\n}\r\n\r\n.mdi-arrow-up-thin-circle-outline::before {\r\n  content: \"\\F1597\";\r\n}\r\n\r\n.mdi-arrow-vertical-lock::before {\r\n  content: \"\\F115C\";\r\n}\r\n\r\n.mdi-artstation::before {\r\n  content: \"\\F0B5B\";\r\n}\r\n\r\n.mdi-aspect-ratio::before {\r\n  content: \"\\F0A24\";\r\n}\r\n\r\n.mdi-assistant::before {\r\n  content: \"\\F0064\";\r\n}\r\n\r\n.mdi-asterisk::before {\r\n  content: \"\\F06C4\";\r\n}\r\n\r\n.mdi-at::before {\r\n  content: \"\\F0065\";\r\n}\r\n\r\n.mdi-atlassian::before {\r\n  content: \"\\F0804\";\r\n}\r\n\r\n.mdi-atm::before {\r\n  content: \"\\F0D47\";\r\n}\r\n\r\n.mdi-atom::before {\r\n  content: \"\\F0768\";\r\n}\r\n\r\n.mdi-atom-variant::before {\r\n  content: \"\\F0E7B\";\r\n}\r\n\r\n.mdi-attachment::before {\r\n  content: \"\\F0066\";\r\n}\r\n\r\n.mdi-audio-input-rca::before {\r\n  content: \"\\F186B\";\r\n}\r\n\r\n.mdi-audio-input-stereo-minijack::before {\r\n  content: \"\\F186C\";\r\n}\r\n\r\n.mdi-audio-input-xlr::before {\r\n  content: \"\\F186D\";\r\n}\r\n\r\n.mdi-audio-video::before {\r\n  content: \"\\F093D\";\r\n}\r\n\r\n.mdi-audio-video-off::before {\r\n  content: \"\\F11B6\";\r\n}\r\n\r\n.mdi-augmented-reality::before {\r\n  content: \"\\F0850\";\r\n}\r\n\r\n.mdi-auto-download::before {\r\n  content: \"\\F137E\";\r\n}\r\n\r\n.mdi-auto-fix::before {\r\n  content: \"\\F0068\";\r\n}\r\n\r\n.mdi-auto-upload::before {\r\n  content: \"\\F0069\";\r\n}\r\n\r\n.mdi-autorenew::before {\r\n  content: \"\\F006A\";\r\n}\r\n\r\n.mdi-av-timer::before {\r\n  content: \"\\F006B\";\r\n}\r\n\r\n.mdi-aws::before {\r\n  content: \"\\F0E0F\";\r\n}\r\n\r\n.mdi-axe::before {\r\n  content: \"\\F08C8\";\r\n}\r\n\r\n.mdi-axe-battle::before {\r\n  content: \"\\F1842\";\r\n}\r\n\r\n.mdi-axis::before {\r\n  content: \"\\F0D48\";\r\n}\r\n\r\n.mdi-axis-arrow::before {\r\n  content: \"\\F0D49\";\r\n}\r\n\r\n.mdi-axis-arrow-info::before {\r\n  content: \"\\F140E\";\r\n}\r\n\r\n.mdi-axis-arrow-lock::before {\r\n  content: \"\\F0D4A\";\r\n}\r\n\r\n.mdi-axis-lock::before {\r\n  content: \"\\F0D4B\";\r\n}\r\n\r\n.mdi-axis-x-arrow::before {\r\n  content: \"\\F0D4C\";\r\n}\r\n\r\n.mdi-axis-x-arrow-lock::before {\r\n  content: \"\\F0D4D\";\r\n}\r\n\r\n.mdi-axis-x-rotate-clockwise::before {\r\n  content: \"\\F0D4E\";\r\n}\r\n\r\n.mdi-axis-x-rotate-counterclockwise::before {\r\n  content: \"\\F0D4F\";\r\n}\r\n\r\n.mdi-axis-x-y-arrow-lock::before {\r\n  content: \"\\F0D50\";\r\n}\r\n\r\n.mdi-axis-y-arrow::before {\r\n  content: \"\\F0D51\";\r\n}\r\n\r\n.mdi-axis-y-arrow-lock::before {\r\n  content: \"\\F0D52\";\r\n}\r\n\r\n.mdi-axis-y-rotate-clockwise::before {\r\n  content: \"\\F0D53\";\r\n}\r\n\r\n.mdi-axis-y-rotate-counterclockwise::before {\r\n  content: \"\\F0D54\";\r\n}\r\n\r\n.mdi-axis-z-arrow::before {\r\n  content: \"\\F0D55\";\r\n}\r\n\r\n.mdi-axis-z-arrow-lock::before {\r\n  content: \"\\F0D56\";\r\n}\r\n\r\n.mdi-axis-z-rotate-clockwise::before {\r\n  content: \"\\F0D57\";\r\n}\r\n\r\n.mdi-axis-z-rotate-counterclockwise::before {\r\n  content: \"\\F0D58\";\r\n}\r\n\r\n.mdi-babel::before {\r\n  content: \"\\F0A25\";\r\n}\r\n\r\n.mdi-baby::before {\r\n  content: \"\\F006C\";\r\n}\r\n\r\n.mdi-baby-bottle::before {\r\n  content: \"\\F0F39\";\r\n}\r\n\r\n.mdi-baby-bottle-outline::before {\r\n  content: \"\\F0F3A\";\r\n}\r\n\r\n.mdi-baby-buggy::before {\r\n  content: \"\\F13E0\";\r\n}\r\n\r\n.mdi-baby-carriage::before {\r\n  content: \"\\F068F\";\r\n}\r\n\r\n.mdi-baby-carriage-off::before {\r\n  content: \"\\F0FA0\";\r\n}\r\n\r\n.mdi-baby-face::before {\r\n  content: \"\\F0E7C\";\r\n}\r\n\r\n.mdi-baby-face-outline::before {\r\n  content: \"\\F0E7D\";\r\n}\r\n\r\n.mdi-backburger::before {\r\n  content: \"\\F006D\";\r\n}\r\n\r\n.mdi-backspace::before {\r\n  content: \"\\F006E\";\r\n}\r\n\r\n.mdi-backspace-outline::before {\r\n  content: \"\\F0B5C\";\r\n}\r\n\r\n.mdi-backspace-reverse::before {\r\n  content: \"\\F0E7E\";\r\n}\r\n\r\n.mdi-backspace-reverse-outline::before {\r\n  content: \"\\F0E7F\";\r\n}\r\n\r\n.mdi-backup-restore::before {\r\n  content: \"\\F006F\";\r\n}\r\n\r\n.mdi-bacteria::before {\r\n  content: \"\\F0ED5\";\r\n}\r\n\r\n.mdi-bacteria-outline::before {\r\n  content: \"\\F0ED6\";\r\n}\r\n\r\n.mdi-badge-account::before {\r\n  content: \"\\F0DA7\";\r\n}\r\n\r\n.mdi-badge-account-alert::before {\r\n  content: \"\\F0DA8\";\r\n}\r\n\r\n.mdi-badge-account-alert-outline::before {\r\n  content: \"\\F0DA9\";\r\n}\r\n\r\n.mdi-badge-account-horizontal::before {\r\n  content: \"\\F0E0D\";\r\n}\r\n\r\n.mdi-badge-account-horizontal-outline::before {\r\n  content: \"\\F0E0E\";\r\n}\r\n\r\n.mdi-badge-account-outline::before {\r\n  content: \"\\F0DAA\";\r\n}\r\n\r\n.mdi-badminton::before {\r\n  content: \"\\F0851\";\r\n}\r\n\r\n.mdi-bag-carry-on::before {\r\n  content: \"\\F0F3B\";\r\n}\r\n\r\n.mdi-bag-carry-on-check::before {\r\n  content: \"\\F0D65\";\r\n}\r\n\r\n.mdi-bag-carry-on-off::before {\r\n  content: \"\\F0F3C\";\r\n}\r\n\r\n.mdi-bag-checked::before {\r\n  content: \"\\F0F3D\";\r\n}\r\n\r\n.mdi-bag-personal::before {\r\n  content: \"\\F0E10\";\r\n}\r\n\r\n.mdi-bag-personal-off::before {\r\n  content: \"\\F0E11\";\r\n}\r\n\r\n.mdi-bag-personal-off-outline::before {\r\n  content: \"\\F0E12\";\r\n}\r\n\r\n.mdi-bag-personal-outline::before {\r\n  content: \"\\F0E13\";\r\n}\r\n\r\n.mdi-bag-suitcase::before {\r\n  content: \"\\F158B\";\r\n}\r\n\r\n.mdi-bag-suitcase-off::before {\r\n  content: \"\\F158D\";\r\n}\r\n\r\n.mdi-bag-suitcase-off-outline::before {\r\n  content: \"\\F158E\";\r\n}\r\n\r\n.mdi-bag-suitcase-outline::before {\r\n  content: \"\\F158C\";\r\n}\r\n\r\n.mdi-baguette::before {\r\n  content: \"\\F0F3E\";\r\n}\r\n\r\n.mdi-balcony::before {\r\n  content: \"\\F1817\";\r\n}\r\n\r\n.mdi-balloon::before {\r\n  content: \"\\F0A26\";\r\n}\r\n\r\n.mdi-ballot::before {\r\n  content: \"\\F09C9\";\r\n}\r\n\r\n.mdi-ballot-outline::before {\r\n  content: \"\\F09CA\";\r\n}\r\n\r\n.mdi-ballot-recount::before {\r\n  content: \"\\F0C39\";\r\n}\r\n\r\n.mdi-ballot-recount-outline::before {\r\n  content: \"\\F0C3A\";\r\n}\r\n\r\n.mdi-bandage::before {\r\n  content: \"\\F0DAF\";\r\n}\r\n\r\n.mdi-bank::before {\r\n  content: \"\\F0070\";\r\n}\r\n\r\n.mdi-bank-check::before {\r\n  content: \"\\F1655\";\r\n}\r\n\r\n.mdi-bank-minus::before {\r\n  content: \"\\F0DB0\";\r\n}\r\n\r\n.mdi-bank-off::before {\r\n  content: \"\\F1656\";\r\n}\r\n\r\n.mdi-bank-off-outline::before {\r\n  content: \"\\F1657\";\r\n}\r\n\r\n.mdi-bank-outline::before {\r\n  content: \"\\F0E80\";\r\n}\r\n\r\n.mdi-bank-plus::before {\r\n  content: \"\\F0DB1\";\r\n}\r\n\r\n.mdi-bank-remove::before {\r\n  content: \"\\F0DB2\";\r\n}\r\n\r\n.mdi-bank-transfer::before {\r\n  content: \"\\F0A27\";\r\n}\r\n\r\n.mdi-bank-transfer-in::before {\r\n  content: \"\\F0A28\";\r\n}\r\n\r\n.mdi-bank-transfer-out::before {\r\n  content: \"\\F0A29\";\r\n}\r\n\r\n.mdi-barcode::before {\r\n  content: \"\\F0071\";\r\n}\r\n\r\n.mdi-barcode-off::before {\r\n  content: \"\\F1236\";\r\n}\r\n\r\n.mdi-barcode-scan::before {\r\n  content: \"\\F0072\";\r\n}\r\n\r\n.mdi-barley::before {\r\n  content: \"\\F0073\";\r\n}\r\n\r\n.mdi-barley-off::before {\r\n  content: \"\\F0B5D\";\r\n}\r\n\r\n.mdi-barn::before {\r\n  content: \"\\F0B5E\";\r\n}\r\n\r\n.mdi-barrel::before {\r\n  content: \"\\F0074\";\r\n}\r\n\r\n.mdi-baseball::before {\r\n  content: \"\\F0852\";\r\n}\r\n\r\n.mdi-baseball-bat::before {\r\n  content: \"\\F0853\";\r\n}\r\n\r\n.mdi-baseball-diamond::before {\r\n  content: \"\\F15EC\";\r\n}\r\n\r\n.mdi-baseball-diamond-outline::before {\r\n  content: \"\\F15ED\";\r\n}\r\n\r\n.mdi-bash::before {\r\n  content: \"\\F1183\";\r\n}\r\n\r\n.mdi-basket::before {\r\n  content: \"\\F0076\";\r\n}\r\n\r\n.mdi-basket-check::before {\r\n  content: \"\\F18E5\";\r\n}\r\n\r\n.mdi-basket-check-outline::before {\r\n  content: \"\\F18E6\";\r\n}\r\n\r\n.mdi-basket-fill::before {\r\n  content: \"\\F0077\";\r\n}\r\n\r\n.mdi-basket-minus::before {\r\n  content: \"\\F1523\";\r\n}\r\n\r\n.mdi-basket-minus-outline::before {\r\n  content: \"\\F1524\";\r\n}\r\n\r\n.mdi-basket-off::before {\r\n  content: \"\\F1525\";\r\n}\r\n\r\n.mdi-basket-off-outline::before {\r\n  content: \"\\F1526\";\r\n}\r\n\r\n.mdi-basket-outline::before {\r\n  content: \"\\F1181\";\r\n}\r\n\r\n.mdi-basket-plus::before {\r\n  content: \"\\F1527\";\r\n}\r\n\r\n.mdi-basket-plus-outline::before {\r\n  content: \"\\F1528\";\r\n}\r\n\r\n.mdi-basket-remove::before {\r\n  content: \"\\F1529\";\r\n}\r\n\r\n.mdi-basket-remove-outline::before {\r\n  content: \"\\F152A\";\r\n}\r\n\r\n.mdi-basket-unfill::before {\r\n  content: \"\\F0078\";\r\n}\r\n\r\n.mdi-basketball::before {\r\n  content: \"\\F0806\";\r\n}\r\n\r\n.mdi-basketball-hoop::before {\r\n  content: \"\\F0C3B\";\r\n}\r\n\r\n.mdi-basketball-hoop-outline::before {\r\n  content: \"\\F0C3C\";\r\n}\r\n\r\n.mdi-bat::before {\r\n  content: \"\\F0B5F\";\r\n}\r\n\r\n.mdi-bathtub::before {\r\n  content: \"\\F1818\";\r\n}\r\n\r\n.mdi-bathtub-outline::before {\r\n  content: \"\\F1819\";\r\n}\r\n\r\n.mdi-battery::before {\r\n  content: \"\\F0079\";\r\n}\r\n\r\n.mdi-battery-10::before {\r\n  content: \"\\F007A\";\r\n}\r\n\r\n.mdi-battery-10-bluetooth::before {\r\n  content: \"\\F093E\";\r\n}\r\n\r\n.mdi-battery-20::before {\r\n  content: \"\\F007B\";\r\n}\r\n\r\n.mdi-battery-20-bluetooth::before {\r\n  content: \"\\F093F\";\r\n}\r\n\r\n.mdi-battery-30::before {\r\n  content: \"\\F007C\";\r\n}\r\n\r\n.mdi-battery-30-bluetooth::before {\r\n  content: \"\\F0940\";\r\n}\r\n\r\n.mdi-battery-40::before {\r\n  content: \"\\F007D\";\r\n}\r\n\r\n.mdi-battery-40-bluetooth::before {\r\n  content: \"\\F0941\";\r\n}\r\n\r\n.mdi-battery-50::before {\r\n  content: \"\\F007E\";\r\n}\r\n\r\n.mdi-battery-50-bluetooth::before {\r\n  content: \"\\F0942\";\r\n}\r\n\r\n.mdi-battery-60::before {\r\n  content: \"\\F007F\";\r\n}\r\n\r\n.mdi-battery-60-bluetooth::before {\r\n  content: \"\\F0943\";\r\n}\r\n\r\n.mdi-battery-70::before {\r\n  content: \"\\F0080\";\r\n}\r\n\r\n.mdi-battery-70-bluetooth::before {\r\n  content: \"\\F0944\";\r\n}\r\n\r\n.mdi-battery-80::before {\r\n  content: \"\\F0081\";\r\n}\r\n\r\n.mdi-battery-80-bluetooth::before {\r\n  content: \"\\F0945\";\r\n}\r\n\r\n.mdi-battery-90::before {\r\n  content: \"\\F0082\";\r\n}\r\n\r\n.mdi-battery-90-bluetooth::before {\r\n  content: \"\\F0946\";\r\n}\r\n\r\n.mdi-battery-alert::before {\r\n  content: \"\\F0083\";\r\n}\r\n\r\n.mdi-battery-alert-bluetooth::before {\r\n  content: \"\\F0947\";\r\n}\r\n\r\n.mdi-battery-alert-variant::before {\r\n  content: \"\\F10CC\";\r\n}\r\n\r\n.mdi-battery-alert-variant-outline::before {\r\n  content: \"\\F10CD\";\r\n}\r\n\r\n.mdi-battery-arrow-down::before {\r\n  content: \"\\F17DE\";\r\n}\r\n\r\n.mdi-battery-arrow-down-outline::before {\r\n  content: \"\\F17DF\";\r\n}\r\n\r\n.mdi-battery-arrow-up::before {\r\n  content: \"\\F17E0\";\r\n}\r\n\r\n.mdi-battery-arrow-up-outline::before {\r\n  content: \"\\F17E1\";\r\n}\r\n\r\n.mdi-battery-bluetooth::before {\r\n  content: \"\\F0948\";\r\n}\r\n\r\n.mdi-battery-bluetooth-variant::before {\r\n  content: \"\\F0949\";\r\n}\r\n\r\n.mdi-battery-charging::before {\r\n  content: \"\\F0084\";\r\n}\r\n\r\n.mdi-battery-charging-10::before {\r\n  content: \"\\F089C\";\r\n}\r\n\r\n.mdi-battery-charging-100::before {\r\n  content: \"\\F0085\";\r\n}\r\n\r\n.mdi-battery-charging-20::before {\r\n  content: \"\\F0086\";\r\n}\r\n\r\n.mdi-battery-charging-30::before {\r\n  content: \"\\F0087\";\r\n}\r\n\r\n.mdi-battery-charging-40::before {\r\n  content: \"\\F0088\";\r\n}\r\n\r\n.mdi-battery-charging-50::before {\r\n  content: \"\\F089D\";\r\n}\r\n\r\n.mdi-battery-charging-60::before {\r\n  content: \"\\F0089\";\r\n}\r\n\r\n.mdi-battery-charging-70::before {\r\n  content: \"\\F089E\";\r\n}\r\n\r\n.mdi-battery-charging-80::before {\r\n  content: \"\\F008A\";\r\n}\r\n\r\n.mdi-battery-charging-90::before {\r\n  content: \"\\F008B\";\r\n}\r\n\r\n.mdi-battery-charging-high::before {\r\n  content: \"\\F12A6\";\r\n}\r\n\r\n.mdi-battery-charging-low::before {\r\n  content: \"\\F12A4\";\r\n}\r\n\r\n.mdi-battery-charging-medium::before {\r\n  content: \"\\F12A5\";\r\n}\r\n\r\n.mdi-battery-charging-outline::before {\r\n  content: \"\\F089F\";\r\n}\r\n\r\n.mdi-battery-charging-wireless::before {\r\n  content: \"\\F0807\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-10::before {\r\n  content: \"\\F0808\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-20::before {\r\n  content: \"\\F0809\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-30::before {\r\n  content: \"\\F080A\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-40::before {\r\n  content: \"\\F080B\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-50::before {\r\n  content: \"\\F080C\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-60::before {\r\n  content: \"\\F080D\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-70::before {\r\n  content: \"\\F080E\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-80::before {\r\n  content: \"\\F080F\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-90::before {\r\n  content: \"\\F0810\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-alert::before {\r\n  content: \"\\F0811\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-outline::before {\r\n  content: \"\\F0812\";\r\n}\r\n\r\n.mdi-battery-check::before {\r\n  content: \"\\F17E2\";\r\n}\r\n\r\n.mdi-battery-check-outline::before {\r\n  content: \"\\F17E3\";\r\n}\r\n\r\n.mdi-battery-heart::before {\r\n  content: \"\\F120F\";\r\n}\r\n\r\n.mdi-battery-heart-outline::before {\r\n  content: \"\\F1210\";\r\n}\r\n\r\n.mdi-battery-heart-variant::before {\r\n  content: \"\\F1211\";\r\n}\r\n\r\n.mdi-battery-high::before {\r\n  content: \"\\F12A3\";\r\n}\r\n\r\n.mdi-battery-lock::before {\r\n  content: \"\\F179C\";\r\n}\r\n\r\n.mdi-battery-lock-open::before {\r\n  content: \"\\F179D\";\r\n}\r\n\r\n.mdi-battery-low::before {\r\n  content: \"\\F12A1\";\r\n}\r\n\r\n.mdi-battery-medium::before {\r\n  content: \"\\F12A2\";\r\n}\r\n\r\n.mdi-battery-minus::before {\r\n  content: \"\\F17E4\";\r\n}\r\n\r\n.mdi-battery-minus-outline::before {\r\n  content: \"\\F17E5\";\r\n}\r\n\r\n.mdi-battery-minus-variant::before {\r\n  content: \"\\F008C\";\r\n}\r\n\r\n.mdi-battery-negative::before {\r\n  content: \"\\F008D\";\r\n}\r\n\r\n.mdi-battery-off::before {\r\n  content: \"\\F125D\";\r\n}\r\n\r\n.mdi-battery-off-outline::before {\r\n  content: \"\\F125E\";\r\n}\r\n\r\n.mdi-battery-outline::before {\r\n  content: \"\\F008E\";\r\n}\r\n\r\n.mdi-battery-plus::before {\r\n  content: \"\\F17E6\";\r\n}\r\n\r\n.mdi-battery-plus-outline::before {\r\n  content: \"\\F17E7\";\r\n}\r\n\r\n.mdi-battery-plus-variant::before {\r\n  content: \"\\F008F\";\r\n}\r\n\r\n.mdi-battery-positive::before {\r\n  content: \"\\F0090\";\r\n}\r\n\r\n.mdi-battery-remove::before {\r\n  content: \"\\F17E8\";\r\n}\r\n\r\n.mdi-battery-remove-outline::before {\r\n  content: \"\\F17E9\";\r\n}\r\n\r\n.mdi-battery-sync::before {\r\n  content: \"\\F1834\";\r\n}\r\n\r\n.mdi-battery-sync-outline::before {\r\n  content: \"\\F1835\";\r\n}\r\n\r\n.mdi-battery-unknown::before {\r\n  content: \"\\F0091\";\r\n}\r\n\r\n.mdi-battery-unknown-bluetooth::before {\r\n  content: \"\\F094A\";\r\n}\r\n\r\n.mdi-beach::before {\r\n  content: \"\\F0092\";\r\n}\r\n\r\n.mdi-beaker::before {\r\n  content: \"\\F0CEA\";\r\n}\r\n\r\n.mdi-beaker-alert::before {\r\n  content: \"\\F1229\";\r\n}\r\n\r\n.mdi-beaker-alert-outline::before {\r\n  content: \"\\F122A\";\r\n}\r\n\r\n.mdi-beaker-check::before {\r\n  content: \"\\F122B\";\r\n}\r\n\r\n.mdi-beaker-check-outline::before {\r\n  content: \"\\F122C\";\r\n}\r\n\r\n.mdi-beaker-minus::before {\r\n  content: \"\\F122D\";\r\n}\r\n\r\n.mdi-beaker-minus-outline::before {\r\n  content: \"\\F122E\";\r\n}\r\n\r\n.mdi-beaker-outline::before {\r\n  content: \"\\F0690\";\r\n}\r\n\r\n.mdi-beaker-plus::before {\r\n  content: \"\\F122F\";\r\n}\r\n\r\n.mdi-beaker-plus-outline::before {\r\n  content: \"\\F1230\";\r\n}\r\n\r\n.mdi-beaker-question::before {\r\n  content: \"\\F1231\";\r\n}\r\n\r\n.mdi-beaker-question-outline::before {\r\n  content: \"\\F1232\";\r\n}\r\n\r\n.mdi-beaker-remove::before {\r\n  content: \"\\F1233\";\r\n}\r\n\r\n.mdi-beaker-remove-outline::before {\r\n  content: \"\\F1234\";\r\n}\r\n\r\n.mdi-bed::before {\r\n  content: \"\\F02E3\";\r\n}\r\n\r\n.mdi-bed-double::before {\r\n  content: \"\\F0FD4\";\r\n}\r\n\r\n.mdi-bed-double-outline::before {\r\n  content: \"\\F0FD3\";\r\n}\r\n\r\n.mdi-bed-empty::before {\r\n  content: \"\\F08A0\";\r\n}\r\n\r\n.mdi-bed-king::before {\r\n  content: \"\\F0FD2\";\r\n}\r\n\r\n.mdi-bed-king-outline::before {\r\n  content: \"\\F0FD1\";\r\n}\r\n\r\n.mdi-bed-outline::before {\r\n  content: \"\\F0099\";\r\n}\r\n\r\n.mdi-bed-queen::before {\r\n  content: \"\\F0FD0\";\r\n}\r\n\r\n.mdi-bed-queen-outline::before {\r\n  content: \"\\F0FDB\";\r\n}\r\n\r\n.mdi-bed-single::before {\r\n  content: \"\\F106D\";\r\n}\r\n\r\n.mdi-bed-single-outline::before {\r\n  content: \"\\F106E\";\r\n}\r\n\r\n.mdi-bee::before {\r\n  content: \"\\F0FA1\";\r\n}\r\n\r\n.mdi-bee-flower::before {\r\n  content: \"\\F0FA2\";\r\n}\r\n\r\n.mdi-beehive-off-outline::before {\r\n  content: \"\\F13ED\";\r\n}\r\n\r\n.mdi-beehive-outline::before {\r\n  content: \"\\F10CE\";\r\n}\r\n\r\n.mdi-beekeeper::before {\r\n  content: \"\\F14E2\";\r\n}\r\n\r\n.mdi-beer::before {\r\n  content: \"\\F0098\";\r\n}\r\n\r\n.mdi-beer-outline::before {\r\n  content: \"\\F130C\";\r\n}\r\n\r\n.mdi-bell::before {\r\n  content: \"\\F009A\";\r\n}\r\n\r\n.mdi-bell-alert::before {\r\n  content: \"\\F0D59\";\r\n}\r\n\r\n.mdi-bell-alert-outline::before {\r\n  content: \"\\F0E81\";\r\n}\r\n\r\n.mdi-bell-badge::before {\r\n  content: \"\\F116B\";\r\n}\r\n\r\n.mdi-bell-badge-outline::before {\r\n  content: \"\\F0178\";\r\n}\r\n\r\n.mdi-bell-cancel::before {\r\n  content: \"\\F13E7\";\r\n}\r\n\r\n.mdi-bell-cancel-outline::before {\r\n  content: \"\\F13E8\";\r\n}\r\n\r\n.mdi-bell-check::before {\r\n  content: \"\\F11E5\";\r\n}\r\n\r\n.mdi-bell-check-outline::before {\r\n  content: \"\\F11E6\";\r\n}\r\n\r\n.mdi-bell-circle::before {\r\n  content: \"\\F0D5A\";\r\n}\r\n\r\n.mdi-bell-circle-outline::before {\r\n  content: \"\\F0D5B\";\r\n}\r\n\r\n.mdi-bell-minus::before {\r\n  content: \"\\F13E9\";\r\n}\r\n\r\n.mdi-bell-minus-outline::before {\r\n  content: \"\\F13EA\";\r\n}\r\n\r\n.mdi-bell-off::before {\r\n  content: \"\\F009B\";\r\n}\r\n\r\n.mdi-bell-off-outline::before {\r\n  content: \"\\F0A91\";\r\n}\r\n\r\n.mdi-bell-outline::before {\r\n  content: \"\\F009C\";\r\n}\r\n\r\n.mdi-bell-plus::before {\r\n  content: \"\\F009D\";\r\n}\r\n\r\n.mdi-bell-plus-outline::before {\r\n  content: \"\\F0A92\";\r\n}\r\n\r\n.mdi-bell-remove::before {\r\n  content: \"\\F13EB\";\r\n}\r\n\r\n.mdi-bell-remove-outline::before {\r\n  content: \"\\F13EC\";\r\n}\r\n\r\n.mdi-bell-ring::before {\r\n  content: \"\\F009E\";\r\n}\r\n\r\n.mdi-bell-ring-outline::before {\r\n  content: \"\\F009F\";\r\n}\r\n\r\n.mdi-bell-sleep::before {\r\n  content: \"\\F00A0\";\r\n}\r\n\r\n.mdi-bell-sleep-outline::before {\r\n  content: \"\\F0A93\";\r\n}\r\n\r\n.mdi-beta::before {\r\n  content: \"\\F00A1\";\r\n}\r\n\r\n.mdi-betamax::before {\r\n  content: \"\\F09CB\";\r\n}\r\n\r\n.mdi-biathlon::before {\r\n  content: \"\\F0E14\";\r\n}\r\n\r\n.mdi-bicycle::before {\r\n  content: \"\\F109C\";\r\n}\r\n\r\n.mdi-bicycle-basket::before {\r\n  content: \"\\F1235\";\r\n}\r\n\r\n.mdi-bicycle-cargo::before {\r\n  content: \"\\F189C\";\r\n}\r\n\r\n.mdi-bicycle-electric::before {\r\n  content: \"\\F15B4\";\r\n}\r\n\r\n.mdi-bicycle-penny-farthing::before {\r\n  content: \"\\F15E9\";\r\n}\r\n\r\n.mdi-bike::before {\r\n  content: \"\\F00A3\";\r\n}\r\n\r\n.mdi-bike-fast::before {\r\n  content: \"\\F111F\";\r\n}\r\n\r\n.mdi-billboard::before {\r\n  content: \"\\F1010\";\r\n}\r\n\r\n.mdi-billiards::before {\r\n  content: \"\\F0B61\";\r\n}\r\n\r\n.mdi-billiards-rack::before {\r\n  content: \"\\F0B62\";\r\n}\r\n\r\n.mdi-binoculars::before {\r\n  content: \"\\F00A5\";\r\n}\r\n\r\n.mdi-bio::before {\r\n  content: \"\\F00A6\";\r\n}\r\n\r\n.mdi-biohazard::before {\r\n  content: \"\\F00A7\";\r\n}\r\n\r\n.mdi-bird::before {\r\n  content: \"\\F15C6\";\r\n}\r\n\r\n.mdi-bitbucket::before {\r\n  content: \"\\F00A8\";\r\n}\r\n\r\n.mdi-bitcoin::before {\r\n  content: \"\\F0813\";\r\n}\r\n\r\n.mdi-black-mesa::before {\r\n  content: \"\\F00A9\";\r\n}\r\n\r\n.mdi-blender::before {\r\n  content: \"\\F0CEB\";\r\n}\r\n\r\n.mdi-blender-outline::before {\r\n  content: \"\\F181A\";\r\n}\r\n\r\n.mdi-blender-software::before {\r\n  content: \"\\F00AB\";\r\n}\r\n\r\n.mdi-blinds::before {\r\n  content: \"\\F00AC\";\r\n}\r\n\r\n.mdi-blinds-open::before {\r\n  content: \"\\F1011\";\r\n}\r\n\r\n.mdi-block-helper::before {\r\n  content: \"\\F00AD\";\r\n}\r\n\r\n.mdi-blood-bag::before {\r\n  content: \"\\F0CEC\";\r\n}\r\n\r\n.mdi-bluetooth::before {\r\n  content: \"\\F00AF\";\r\n}\r\n\r\n.mdi-bluetooth-audio::before {\r\n  content: \"\\F00B0\";\r\n}\r\n\r\n.mdi-bluetooth-connect::before {\r\n  content: \"\\F00B1\";\r\n}\r\n\r\n.mdi-bluetooth-off::before {\r\n  content: \"\\F00B2\";\r\n}\r\n\r\n.mdi-bluetooth-settings::before {\r\n  content: \"\\F00B3\";\r\n}\r\n\r\n.mdi-bluetooth-transfer::before {\r\n  content: \"\\F00B4\";\r\n}\r\n\r\n.mdi-blur::before {\r\n  content: \"\\F00B5\";\r\n}\r\n\r\n.mdi-blur-linear::before {\r\n  content: \"\\F00B6\";\r\n}\r\n\r\n.mdi-blur-off::before {\r\n  content: \"\\F00B7\";\r\n}\r\n\r\n.mdi-blur-radial::before {\r\n  content: \"\\F00B8\";\r\n}\r\n\r\n.mdi-bolt::before {\r\n  content: \"\\F0DB3\";\r\n}\r\n\r\n.mdi-bomb::before {\r\n  content: \"\\F0691\";\r\n}\r\n\r\n.mdi-bomb-off::before {\r\n  content: \"\\F06C5\";\r\n}\r\n\r\n.mdi-bone::before {\r\n  content: \"\\F00B9\";\r\n}\r\n\r\n.mdi-book::before {\r\n  content: \"\\F00BA\";\r\n}\r\n\r\n.mdi-book-account::before {\r\n  content: \"\\F13AD\";\r\n}\r\n\r\n.mdi-book-account-outline::before {\r\n  content: \"\\F13AE\";\r\n}\r\n\r\n.mdi-book-alert::before {\r\n  content: \"\\F167C\";\r\n}\r\n\r\n.mdi-book-alert-outline::before {\r\n  content: \"\\F167D\";\r\n}\r\n\r\n.mdi-book-alphabet::before {\r\n  content: \"\\F061D\";\r\n}\r\n\r\n.mdi-book-arrow-down::before {\r\n  content: \"\\F167E\";\r\n}\r\n\r\n.mdi-book-arrow-down-outline::before {\r\n  content: \"\\F167F\";\r\n}\r\n\r\n.mdi-book-arrow-left::before {\r\n  content: \"\\F1680\";\r\n}\r\n\r\n.mdi-book-arrow-left-outline::before {\r\n  content: \"\\F1681\";\r\n}\r\n\r\n.mdi-book-arrow-right::before {\r\n  content: \"\\F1682\";\r\n}\r\n\r\n.mdi-book-arrow-right-outline::before {\r\n  content: \"\\F1683\";\r\n}\r\n\r\n.mdi-book-arrow-up::before {\r\n  content: \"\\F1684\";\r\n}\r\n\r\n.mdi-book-arrow-up-outline::before {\r\n  content: \"\\F1685\";\r\n}\r\n\r\n.mdi-book-cancel::before {\r\n  content: \"\\F1686\";\r\n}\r\n\r\n.mdi-book-cancel-outline::before {\r\n  content: \"\\F1687\";\r\n}\r\n\r\n.mdi-book-check::before {\r\n  content: \"\\F14F3\";\r\n}\r\n\r\n.mdi-book-check-outline::before {\r\n  content: \"\\F14F4\";\r\n}\r\n\r\n.mdi-book-clock::before {\r\n  content: \"\\F1688\";\r\n}\r\n\r\n.mdi-book-clock-outline::before {\r\n  content: \"\\F1689\";\r\n}\r\n\r\n.mdi-book-cog::before {\r\n  content: \"\\F168A\";\r\n}\r\n\r\n.mdi-book-cog-outline::before {\r\n  content: \"\\F168B\";\r\n}\r\n\r\n.mdi-book-cross::before {\r\n  content: \"\\F00A2\";\r\n}\r\n\r\n.mdi-book-edit::before {\r\n  content: \"\\F168C\";\r\n}\r\n\r\n.mdi-book-edit-outline::before {\r\n  content: \"\\F168D\";\r\n}\r\n\r\n.mdi-book-education::before {\r\n  content: \"\\F16C9\";\r\n}\r\n\r\n.mdi-book-education-outline::before {\r\n  content: \"\\F16CA\";\r\n}\r\n\r\n.mdi-book-information-variant::before {\r\n  content: \"\\F106F\";\r\n}\r\n\r\n.mdi-book-lock::before {\r\n  content: \"\\F079A\";\r\n}\r\n\r\n.mdi-book-lock-open::before {\r\n  content: \"\\F079B\";\r\n}\r\n\r\n.mdi-book-lock-open-outline::before {\r\n  content: \"\\F168E\";\r\n}\r\n\r\n.mdi-book-lock-outline::before {\r\n  content: \"\\F168F\";\r\n}\r\n\r\n.mdi-book-marker::before {\r\n  content: \"\\F1690\";\r\n}\r\n\r\n.mdi-book-marker-outline::before {\r\n  content: \"\\F1691\";\r\n}\r\n\r\n.mdi-book-minus::before {\r\n  content: \"\\F05D9\";\r\n}\r\n\r\n.mdi-book-minus-multiple::before {\r\n  content: \"\\F0A94\";\r\n}\r\n\r\n.mdi-book-minus-multiple-outline::before {\r\n  content: \"\\F090B\";\r\n}\r\n\r\n.mdi-book-minus-outline::before {\r\n  content: \"\\F1692\";\r\n}\r\n\r\n.mdi-book-multiple::before {\r\n  content: \"\\F00BB\";\r\n}\r\n\r\n.mdi-book-multiple-outline::before {\r\n  content: \"\\F0436\";\r\n}\r\n\r\n.mdi-book-music::before {\r\n  content: \"\\F0067\";\r\n}\r\n\r\n.mdi-book-music-outline::before {\r\n  content: \"\\F1693\";\r\n}\r\n\r\n.mdi-book-off::before {\r\n  content: \"\\F1694\";\r\n}\r\n\r\n.mdi-book-off-outline::before {\r\n  content: \"\\F1695\";\r\n}\r\n\r\n.mdi-book-open::before {\r\n  content: \"\\F00BD\";\r\n}\r\n\r\n.mdi-book-open-blank-variant::before {\r\n  content: \"\\F00BE\";\r\n}\r\n\r\n.mdi-book-open-outline::before {\r\n  content: \"\\F0B63\";\r\n}\r\n\r\n.mdi-book-open-page-variant::before {\r\n  content: \"\\F05DA\";\r\n}\r\n\r\n.mdi-book-open-page-variant-outline::before {\r\n  content: \"\\F15D6\";\r\n}\r\n\r\n.mdi-book-open-variant::before {\r\n  content: \"\\F14F7\";\r\n}\r\n\r\n.mdi-book-outline::before {\r\n  content: \"\\F0B64\";\r\n}\r\n\r\n.mdi-book-play::before {\r\n  content: \"\\F0E82\";\r\n}\r\n\r\n.mdi-book-play-outline::before {\r\n  content: \"\\F0E83\";\r\n}\r\n\r\n.mdi-book-plus::before {\r\n  content: \"\\F05DB\";\r\n}\r\n\r\n.mdi-book-plus-multiple::before {\r\n  content: \"\\F0A95\";\r\n}\r\n\r\n.mdi-book-plus-multiple-outline::before {\r\n  content: \"\\F0ADE\";\r\n}\r\n\r\n.mdi-book-plus-outline::before {\r\n  content: \"\\F1696\";\r\n}\r\n\r\n.mdi-book-refresh::before {\r\n  content: \"\\F1697\";\r\n}\r\n\r\n.mdi-book-refresh-outline::before {\r\n  content: \"\\F1698\";\r\n}\r\n\r\n.mdi-book-remove::before {\r\n  content: \"\\F0A97\";\r\n}\r\n\r\n.mdi-book-remove-multiple::before {\r\n  content: \"\\F0A96\";\r\n}\r\n\r\n.mdi-book-remove-multiple-outline::before {\r\n  content: \"\\F04CA\";\r\n}\r\n\r\n.mdi-book-remove-outline::before {\r\n  content: \"\\F1699\";\r\n}\r\n\r\n.mdi-book-search::before {\r\n  content: \"\\F0E84\";\r\n}\r\n\r\n.mdi-book-search-outline::before {\r\n  content: \"\\F0E85\";\r\n}\r\n\r\n.mdi-book-settings::before {\r\n  content: \"\\F169A\";\r\n}\r\n\r\n.mdi-book-settings-outline::before {\r\n  content: \"\\F169B\";\r\n}\r\n\r\n.mdi-book-sync::before {\r\n  content: \"\\F169C\";\r\n}\r\n\r\n.mdi-book-sync-outline::before {\r\n  content: \"\\F16C8\";\r\n}\r\n\r\n.mdi-book-variant::before {\r\n  content: \"\\F00BF\";\r\n}\r\n\r\n.mdi-book-variant-multiple::before {\r\n  content: \"\\F00BC\";\r\n}\r\n\r\n.mdi-bookmark::before {\r\n  content: \"\\F00C0\";\r\n}\r\n\r\n.mdi-bookmark-box-multiple::before {\r\n  content: \"\\F196C\";\r\n}\r\n\r\n.mdi-bookmark-box-multiple-outline::before {\r\n  content: \"\\F196D\";\r\n}\r\n\r\n.mdi-bookmark-check::before {\r\n  content: \"\\F00C1\";\r\n}\r\n\r\n.mdi-bookmark-check-outline::before {\r\n  content: \"\\F137B\";\r\n}\r\n\r\n.mdi-bookmark-minus::before {\r\n  content: \"\\F09CC\";\r\n}\r\n\r\n.mdi-bookmark-minus-outline::before {\r\n  content: \"\\F09CD\";\r\n}\r\n\r\n.mdi-bookmark-multiple::before {\r\n  content: \"\\F0E15\";\r\n}\r\n\r\n.mdi-bookmark-multiple-outline::before {\r\n  content: \"\\F0E16\";\r\n}\r\n\r\n.mdi-bookmark-music::before {\r\n  content: \"\\F00C2\";\r\n}\r\n\r\n.mdi-bookmark-music-outline::before {\r\n  content: \"\\F1379\";\r\n}\r\n\r\n.mdi-bookmark-off::before {\r\n  content: \"\\F09CE\";\r\n}\r\n\r\n.mdi-bookmark-off-outline::before {\r\n  content: \"\\F09CF\";\r\n}\r\n\r\n.mdi-bookmark-outline::before {\r\n  content: \"\\F00C3\";\r\n}\r\n\r\n.mdi-bookmark-plus::before {\r\n  content: \"\\F00C5\";\r\n}\r\n\r\n.mdi-bookmark-plus-outline::before {\r\n  content: \"\\F00C4\";\r\n}\r\n\r\n.mdi-bookmark-remove::before {\r\n  content: \"\\F00C6\";\r\n}\r\n\r\n.mdi-bookmark-remove-outline::before {\r\n  content: \"\\F137A\";\r\n}\r\n\r\n.mdi-bookshelf::before {\r\n  content: \"\\F125F\";\r\n}\r\n\r\n.mdi-boom-gate::before {\r\n  content: \"\\F0E86\";\r\n}\r\n\r\n.mdi-boom-gate-alert::before {\r\n  content: \"\\F0E87\";\r\n}\r\n\r\n.mdi-boom-gate-alert-outline::before {\r\n  content: \"\\F0E88\";\r\n}\r\n\r\n.mdi-boom-gate-arrow-down::before {\r\n  content: \"\\F0E89\";\r\n}\r\n\r\n.mdi-boom-gate-arrow-down-outline::before {\r\n  content: \"\\F0E8A\";\r\n}\r\n\r\n.mdi-boom-gate-arrow-up::before {\r\n  content: \"\\F0E8C\";\r\n}\r\n\r\n.mdi-boom-gate-arrow-up-outline::before {\r\n  content: \"\\F0E8D\";\r\n}\r\n\r\n.mdi-boom-gate-outline::before {\r\n  content: \"\\F0E8B\";\r\n}\r\n\r\n.mdi-boom-gate-up::before {\r\n  content: \"\\F17F9\";\r\n}\r\n\r\n.mdi-boom-gate-up-outline::before {\r\n  content: \"\\F17FA\";\r\n}\r\n\r\n.mdi-boombox::before {\r\n  content: \"\\F05DC\";\r\n}\r\n\r\n.mdi-boomerang::before {\r\n  content: \"\\F10CF\";\r\n}\r\n\r\n.mdi-bootstrap::before {\r\n  content: \"\\F06C6\";\r\n}\r\n\r\n.mdi-border-all::before {\r\n  content: \"\\F00C7\";\r\n}\r\n\r\n.mdi-border-all-variant::before {\r\n  content: \"\\F08A1\";\r\n}\r\n\r\n.mdi-border-bottom::before {\r\n  content: \"\\F00C8\";\r\n}\r\n\r\n.mdi-border-bottom-variant::before {\r\n  content: \"\\F08A2\";\r\n}\r\n\r\n.mdi-border-color::before {\r\n  content: \"\\F00C9\";\r\n}\r\n\r\n.mdi-border-horizontal::before {\r\n  content: \"\\F00CA\";\r\n}\r\n\r\n.mdi-border-inside::before {\r\n  content: \"\\F00CB\";\r\n}\r\n\r\n.mdi-border-left::before {\r\n  content: \"\\F00CC\";\r\n}\r\n\r\n.mdi-border-left-variant::before {\r\n  content: \"\\F08A3\";\r\n}\r\n\r\n.mdi-border-none::before {\r\n  content: \"\\F00CD\";\r\n}\r\n\r\n.mdi-border-none-variant::before {\r\n  content: \"\\F08A4\";\r\n}\r\n\r\n.mdi-border-outside::before {\r\n  content: \"\\F00CE\";\r\n}\r\n\r\n.mdi-border-right::before {\r\n  content: \"\\F00CF\";\r\n}\r\n\r\n.mdi-border-right-variant::before {\r\n  content: \"\\F08A5\";\r\n}\r\n\r\n.mdi-border-style::before {\r\n  content: \"\\F00D0\";\r\n}\r\n\r\n.mdi-border-top::before {\r\n  content: \"\\F00D1\";\r\n}\r\n\r\n.mdi-border-top-variant::before {\r\n  content: \"\\F08A6\";\r\n}\r\n\r\n.mdi-border-vertical::before {\r\n  content: \"\\F00D2\";\r\n}\r\n\r\n.mdi-bottle-soda::before {\r\n  content: \"\\F1070\";\r\n}\r\n\r\n.mdi-bottle-soda-classic::before {\r\n  content: \"\\F1071\";\r\n}\r\n\r\n.mdi-bottle-soda-classic-outline::before {\r\n  content: \"\\F1363\";\r\n}\r\n\r\n.mdi-bottle-soda-outline::before {\r\n  content: \"\\F1072\";\r\n}\r\n\r\n.mdi-bottle-tonic::before {\r\n  content: \"\\F112E\";\r\n}\r\n\r\n.mdi-bottle-tonic-outline::before {\r\n  content: \"\\F112F\";\r\n}\r\n\r\n.mdi-bottle-tonic-plus::before {\r\n  content: \"\\F1130\";\r\n}\r\n\r\n.mdi-bottle-tonic-plus-outline::before {\r\n  content: \"\\F1131\";\r\n}\r\n\r\n.mdi-bottle-tonic-skull::before {\r\n  content: \"\\F1132\";\r\n}\r\n\r\n.mdi-bottle-tonic-skull-outline::before {\r\n  content: \"\\F1133\";\r\n}\r\n\r\n.mdi-bottle-wine::before {\r\n  content: \"\\F0854\";\r\n}\r\n\r\n.mdi-bottle-wine-outline::before {\r\n  content: \"\\F1310\";\r\n}\r\n\r\n.mdi-bow-arrow::before {\r\n  content: \"\\F1841\";\r\n}\r\n\r\n.mdi-bow-tie::before {\r\n  content: \"\\F0678\";\r\n}\r\n\r\n.mdi-bowl::before {\r\n  content: \"\\F028E\";\r\n}\r\n\r\n.mdi-bowl-mix::before {\r\n  content: \"\\F0617\";\r\n}\r\n\r\n.mdi-bowl-mix-outline::before {\r\n  content: \"\\F02E4\";\r\n}\r\n\r\n.mdi-bowl-outline::before {\r\n  content: \"\\F02A9\";\r\n}\r\n\r\n.mdi-bowling::before {\r\n  content: \"\\F00D3\";\r\n}\r\n\r\n.mdi-box::before {\r\n  content: \"\\F00D4\";\r\n}\r\n\r\n.mdi-box-cutter::before {\r\n  content: \"\\F00D5\";\r\n}\r\n\r\n.mdi-box-cutter-off::before {\r\n  content: \"\\F0B4A\";\r\n}\r\n\r\n.mdi-box-shadow::before {\r\n  content: \"\\F0637\";\r\n}\r\n\r\n.mdi-boxing-glove::before {\r\n  content: \"\\F0B65\";\r\n}\r\n\r\n.mdi-braille::before {\r\n  content: \"\\F09D0\";\r\n}\r\n\r\n.mdi-brain::before {\r\n  content: \"\\F09D1\";\r\n}\r\n\r\n.mdi-bread-slice::before {\r\n  content: \"\\F0CEE\";\r\n}\r\n\r\n.mdi-bread-slice-outline::before {\r\n  content: \"\\F0CEF\";\r\n}\r\n\r\n.mdi-bridge::before {\r\n  content: \"\\F0618\";\r\n}\r\n\r\n.mdi-briefcase::before {\r\n  content: \"\\F00D6\";\r\n}\r\n\r\n.mdi-briefcase-account::before {\r\n  content: \"\\F0CF0\";\r\n}\r\n\r\n.mdi-briefcase-account-outline::before {\r\n  content: \"\\F0CF1\";\r\n}\r\n\r\n.mdi-briefcase-check::before {\r\n  content: \"\\F00D7\";\r\n}\r\n\r\n.mdi-briefcase-check-outline::before {\r\n  content: \"\\F131E\";\r\n}\r\n\r\n.mdi-briefcase-clock::before {\r\n  content: \"\\F10D0\";\r\n}\r\n\r\n.mdi-briefcase-clock-outline::before {\r\n  content: \"\\F10D1\";\r\n}\r\n\r\n.mdi-briefcase-download::before {\r\n  content: \"\\F00D8\";\r\n}\r\n\r\n.mdi-briefcase-download-outline::before {\r\n  content: \"\\F0C3D\";\r\n}\r\n\r\n.mdi-briefcase-edit::before {\r\n  content: \"\\F0A98\";\r\n}\r\n\r\n.mdi-briefcase-edit-outline::before {\r\n  content: \"\\F0C3E\";\r\n}\r\n\r\n.mdi-briefcase-eye::before {\r\n  content: \"\\F17D9\";\r\n}\r\n\r\n.mdi-briefcase-eye-outline::before {\r\n  content: \"\\F17DA\";\r\n}\r\n\r\n.mdi-briefcase-minus::before {\r\n  content: \"\\F0A2A\";\r\n}\r\n\r\n.mdi-briefcase-minus-outline::before {\r\n  content: \"\\F0C3F\";\r\n}\r\n\r\n.mdi-briefcase-off::before {\r\n  content: \"\\F1658\";\r\n}\r\n\r\n.mdi-briefcase-off-outline::before {\r\n  content: \"\\F1659\";\r\n}\r\n\r\n.mdi-briefcase-outline::before {\r\n  content: \"\\F0814\";\r\n}\r\n\r\n.mdi-briefcase-plus::before {\r\n  content: \"\\F0A2B\";\r\n}\r\n\r\n.mdi-briefcase-plus-outline::before {\r\n  content: \"\\F0C40\";\r\n}\r\n\r\n.mdi-briefcase-remove::before {\r\n  content: \"\\F0A2C\";\r\n}\r\n\r\n.mdi-briefcase-remove-outline::before {\r\n  content: \"\\F0C41\";\r\n}\r\n\r\n.mdi-briefcase-search::before {\r\n  content: \"\\F0A2D\";\r\n}\r\n\r\n.mdi-briefcase-search-outline::before {\r\n  content: \"\\F0C42\";\r\n}\r\n\r\n.mdi-briefcase-upload::before {\r\n  content: \"\\F00D9\";\r\n}\r\n\r\n.mdi-briefcase-upload-outline::before {\r\n  content: \"\\F0C43\";\r\n}\r\n\r\n.mdi-briefcase-variant::before {\r\n  content: \"\\F1494\";\r\n}\r\n\r\n.mdi-briefcase-variant-off::before {\r\n  content: \"\\F165A\";\r\n}\r\n\r\n.mdi-briefcase-variant-off-outline::before {\r\n  content: \"\\F165B\";\r\n}\r\n\r\n.mdi-briefcase-variant-outline::before {\r\n  content: \"\\F1495\";\r\n}\r\n\r\n.mdi-brightness-1::before {\r\n  content: \"\\F00DA\";\r\n}\r\n\r\n.mdi-brightness-2::before {\r\n  content: \"\\F00DB\";\r\n}\r\n\r\n.mdi-brightness-3::before {\r\n  content: \"\\F00DC\";\r\n}\r\n\r\n.mdi-brightness-4::before {\r\n  content: \"\\F00DD\";\r\n}\r\n\r\n.mdi-brightness-5::before {\r\n  content: \"\\F00DE\";\r\n}\r\n\r\n.mdi-brightness-6::before {\r\n  content: \"\\F00DF\";\r\n}\r\n\r\n.mdi-brightness-7::before {\r\n  content: \"\\F00E0\";\r\n}\r\n\r\n.mdi-brightness-auto::before {\r\n  content: \"\\F00E1\";\r\n}\r\n\r\n.mdi-brightness-percent::before {\r\n  content: \"\\F0CF2\";\r\n}\r\n\r\n.mdi-broadcast::before {\r\n  content: \"\\F1720\";\r\n}\r\n\r\n.mdi-broadcast-off::before {\r\n  content: \"\\F1721\";\r\n}\r\n\r\n.mdi-broom::before {\r\n  content: \"\\F00E2\";\r\n}\r\n\r\n.mdi-brush::before {\r\n  content: \"\\F00E3\";\r\n}\r\n\r\n.mdi-brush-off::before {\r\n  content: \"\\F1771\";\r\n}\r\n\r\n.mdi-brush-variant::before {\r\n  content: \"\\F1813\";\r\n}\r\n\r\n.mdi-bucket::before {\r\n  content: \"\\F1415\";\r\n}\r\n\r\n.mdi-bucket-outline::before {\r\n  content: \"\\F1416\";\r\n}\r\n\r\n.mdi-buffet::before {\r\n  content: \"\\F0578\";\r\n}\r\n\r\n.mdi-bug::before {\r\n  content: \"\\F00E4\";\r\n}\r\n\r\n.mdi-bug-check::before {\r\n  content: \"\\F0A2E\";\r\n}\r\n\r\n.mdi-bug-check-outline::before {\r\n  content: \"\\F0A2F\";\r\n}\r\n\r\n.mdi-bug-outline::before {\r\n  content: \"\\F0A30\";\r\n}\r\n\r\n.mdi-bugle::before {\r\n  content: \"\\F0DB4\";\r\n}\r\n\r\n.mdi-bulldozer::before {\r\n  content: \"\\F0B22\";\r\n}\r\n\r\n.mdi-bullet::before {\r\n  content: \"\\F0CF3\";\r\n}\r\n\r\n.mdi-bulletin-board::before {\r\n  content: \"\\F00E5\";\r\n}\r\n\r\n.mdi-bullhorn::before {\r\n  content: \"\\F00E6\";\r\n}\r\n\r\n.mdi-bullhorn-outline::before {\r\n  content: \"\\F0B23\";\r\n}\r\n\r\n.mdi-bullhorn-variant::before {\r\n  content: \"\\F196E\";\r\n}\r\n\r\n.mdi-bullhorn-variant-outline::before {\r\n  content: \"\\F196F\";\r\n}\r\n\r\n.mdi-bullseye::before {\r\n  content: \"\\F05DD\";\r\n}\r\n\r\n.mdi-bullseye-arrow::before {\r\n  content: \"\\F08C9\";\r\n}\r\n\r\n.mdi-bulma::before {\r\n  content: \"\\F12E7\";\r\n}\r\n\r\n.mdi-bunk-bed::before {\r\n  content: \"\\F1302\";\r\n}\r\n\r\n.mdi-bunk-bed-outline::before {\r\n  content: \"\\F0097\";\r\n}\r\n\r\n.mdi-bus::before {\r\n  content: \"\\F00E7\";\r\n}\r\n\r\n.mdi-bus-alert::before {\r\n  content: \"\\F0A99\";\r\n}\r\n\r\n.mdi-bus-articulated-end::before {\r\n  content: \"\\F079C\";\r\n}\r\n\r\n.mdi-bus-articulated-front::before {\r\n  content: \"\\F079D\";\r\n}\r\n\r\n.mdi-bus-clock::before {\r\n  content: \"\\F08CA\";\r\n}\r\n\r\n.mdi-bus-double-decker::before {\r\n  content: \"\\F079E\";\r\n}\r\n\r\n.mdi-bus-electric::before {\r\n  content: \"\\F191D\";\r\n}\r\n\r\n.mdi-bus-marker::before {\r\n  content: \"\\F1212\";\r\n}\r\n\r\n.mdi-bus-multiple::before {\r\n  content: \"\\F0F3F\";\r\n}\r\n\r\n.mdi-bus-school::before {\r\n  content: \"\\F079F\";\r\n}\r\n\r\n.mdi-bus-side::before {\r\n  content: \"\\F07A0\";\r\n}\r\n\r\n.mdi-bus-stop::before {\r\n  content: \"\\F1012\";\r\n}\r\n\r\n.mdi-bus-stop-covered::before {\r\n  content: \"\\F1013\";\r\n}\r\n\r\n.mdi-bus-stop-uncovered::before {\r\n  content: \"\\F1014\";\r\n}\r\n\r\n.mdi-butterfly::before {\r\n  content: \"\\F1589\";\r\n}\r\n\r\n.mdi-butterfly-outline::before {\r\n  content: \"\\F158A\";\r\n}\r\n\r\n.mdi-cabin-a-frame::before {\r\n  content: \"\\F188C\";\r\n}\r\n\r\n.mdi-cable-data::before {\r\n  content: \"\\F1394\";\r\n}\r\n\r\n.mdi-cached::before {\r\n  content: \"\\F00E8\";\r\n}\r\n\r\n.mdi-cactus::before {\r\n  content: \"\\F0DB5\";\r\n}\r\n\r\n.mdi-cake::before {\r\n  content: \"\\F00E9\";\r\n}\r\n\r\n.mdi-cake-layered::before {\r\n  content: \"\\F00EA\";\r\n}\r\n\r\n.mdi-cake-variant::before {\r\n  content: \"\\F00EB\";\r\n}\r\n\r\n.mdi-cake-variant-outline::before {\r\n  content: \"\\F17F0\";\r\n}\r\n\r\n.mdi-calculator::before {\r\n  content: \"\\F00EC\";\r\n}\r\n\r\n.mdi-calculator-variant::before {\r\n  content: \"\\F0A9A\";\r\n}\r\n\r\n.mdi-calculator-variant-outline::before {\r\n  content: \"\\F15A6\";\r\n}\r\n\r\n.mdi-calendar::before {\r\n  content: \"\\F00ED\";\r\n}\r\n\r\n.mdi-calendar-account::before {\r\n  content: \"\\F0ED7\";\r\n}\r\n\r\n.mdi-calendar-account-outline::before {\r\n  content: \"\\F0ED8\";\r\n}\r\n\r\n.mdi-calendar-alert::before {\r\n  content: \"\\F0A31\";\r\n}\r\n\r\n.mdi-calendar-arrow-left::before {\r\n  content: \"\\F1134\";\r\n}\r\n\r\n.mdi-calendar-arrow-right::before {\r\n  content: \"\\F1135\";\r\n}\r\n\r\n.mdi-calendar-blank::before {\r\n  content: \"\\F00EE\";\r\n}\r\n\r\n.mdi-calendar-blank-multiple::before {\r\n  content: \"\\F1073\";\r\n}\r\n\r\n.mdi-calendar-blank-outline::before {\r\n  content: \"\\F0B66\";\r\n}\r\n\r\n.mdi-calendar-check::before {\r\n  content: \"\\F00EF\";\r\n}\r\n\r\n.mdi-calendar-check-outline::before {\r\n  content: \"\\F0C44\";\r\n}\r\n\r\n.mdi-calendar-clock::before {\r\n  content: \"\\F00F0\";\r\n}\r\n\r\n.mdi-calendar-clock-outline::before {\r\n  content: \"\\F16E1\";\r\n}\r\n\r\n.mdi-calendar-collapse-horizontal::before {\r\n  content: \"\\F189D\";\r\n}\r\n\r\n.mdi-calendar-cursor::before {\r\n  content: \"\\F157B\";\r\n}\r\n\r\n.mdi-calendar-edit::before {\r\n  content: \"\\F08A7\";\r\n}\r\n\r\n.mdi-calendar-end::before {\r\n  content: \"\\F166C\";\r\n}\r\n\r\n.mdi-calendar-expand-horizontal::before {\r\n  content: \"\\F189E\";\r\n}\r\n\r\n.mdi-calendar-export::before {\r\n  content: \"\\F0B24\";\r\n}\r\n\r\n.mdi-calendar-heart::before {\r\n  content: \"\\F09D2\";\r\n}\r\n\r\n.mdi-calendar-import::before {\r\n  content: \"\\F0B25\";\r\n}\r\n\r\n.mdi-calendar-lock::before {\r\n  content: \"\\F1641\";\r\n}\r\n\r\n.mdi-calendar-lock-outline::before {\r\n  content: \"\\F1642\";\r\n}\r\n\r\n.mdi-calendar-minus::before {\r\n  content: \"\\F0D5C\";\r\n}\r\n\r\n.mdi-calendar-month::before {\r\n  content: \"\\F0E17\";\r\n}\r\n\r\n.mdi-calendar-month-outline::before {\r\n  content: \"\\F0E18\";\r\n}\r\n\r\n.mdi-calendar-multiple::before {\r\n  content: \"\\F00F1\";\r\n}\r\n\r\n.mdi-calendar-multiple-check::before {\r\n  content: \"\\F00F2\";\r\n}\r\n\r\n.mdi-calendar-multiselect::before {\r\n  content: \"\\F0A32\";\r\n}\r\n\r\n.mdi-calendar-outline::before {\r\n  content: \"\\F0B67\";\r\n}\r\n\r\n.mdi-calendar-plus::before {\r\n  content: \"\\F00F3\";\r\n}\r\n\r\n.mdi-calendar-question::before {\r\n  content: \"\\F0692\";\r\n}\r\n\r\n.mdi-calendar-range::before {\r\n  content: \"\\F0679\";\r\n}\r\n\r\n.mdi-calendar-range-outline::before {\r\n  content: \"\\F0B68\";\r\n}\r\n\r\n.mdi-calendar-refresh::before {\r\n  content: \"\\F01E1\";\r\n}\r\n\r\n.mdi-calendar-refresh-outline::before {\r\n  content: \"\\F0203\";\r\n}\r\n\r\n.mdi-calendar-remove::before {\r\n  content: \"\\F00F4\";\r\n}\r\n\r\n.mdi-calendar-remove-outline::before {\r\n  content: \"\\F0C45\";\r\n}\r\n\r\n.mdi-calendar-search::before {\r\n  content: \"\\F094C\";\r\n}\r\n\r\n.mdi-calendar-star::before {\r\n  content: \"\\F09D3\";\r\n}\r\n\r\n.mdi-calendar-start::before {\r\n  content: \"\\F166D\";\r\n}\r\n\r\n.mdi-calendar-sync::before {\r\n  content: \"\\F0E8E\";\r\n}\r\n\r\n.mdi-calendar-sync-outline::before {\r\n  content: \"\\F0E8F\";\r\n}\r\n\r\n.mdi-calendar-text::before {\r\n  content: \"\\F00F5\";\r\n}\r\n\r\n.mdi-calendar-text-outline::before {\r\n  content: \"\\F0C46\";\r\n}\r\n\r\n.mdi-calendar-today::before {\r\n  content: \"\\F00F6\";\r\n}\r\n\r\n.mdi-calendar-week::before {\r\n  content: \"\\F0A33\";\r\n}\r\n\r\n.mdi-calendar-week-begin::before {\r\n  content: \"\\F0A34\";\r\n}\r\n\r\n.mdi-calendar-weekend::before {\r\n  content: \"\\F0ED9\";\r\n}\r\n\r\n.mdi-calendar-weekend-outline::before {\r\n  content: \"\\F0EDA\";\r\n}\r\n\r\n.mdi-call-made::before {\r\n  content: \"\\F00F7\";\r\n}\r\n\r\n.mdi-call-merge::before {\r\n  content: \"\\F00F8\";\r\n}\r\n\r\n.mdi-call-missed::before {\r\n  content: \"\\F00F9\";\r\n}\r\n\r\n.mdi-call-received::before {\r\n  content: \"\\F00FA\";\r\n}\r\n\r\n.mdi-call-split::before {\r\n  content: \"\\F00FB\";\r\n}\r\n\r\n.mdi-camcorder::before {\r\n  content: \"\\F00FC\";\r\n}\r\n\r\n.mdi-camcorder-off::before {\r\n  content: \"\\F00FF\";\r\n}\r\n\r\n.mdi-camera::before {\r\n  content: \"\\F0100\";\r\n}\r\n\r\n.mdi-camera-account::before {\r\n  content: \"\\F08CB\";\r\n}\r\n\r\n.mdi-camera-burst::before {\r\n  content: \"\\F0693\";\r\n}\r\n\r\n.mdi-camera-control::before {\r\n  content: \"\\F0B69\";\r\n}\r\n\r\n.mdi-camera-document::before {\r\n  content: \"\\F1871\";\r\n}\r\n\r\n.mdi-camera-document-off::before {\r\n  content: \"\\F1872\";\r\n}\r\n\r\n.mdi-camera-enhance::before {\r\n  content: \"\\F0101\";\r\n}\r\n\r\n.mdi-camera-enhance-outline::before {\r\n  content: \"\\F0B6A\";\r\n}\r\n\r\n.mdi-camera-flip::before {\r\n  content: \"\\F15D9\";\r\n}\r\n\r\n.mdi-camera-flip-outline::before {\r\n  content: \"\\F15DA\";\r\n}\r\n\r\n.mdi-camera-front::before {\r\n  content: \"\\F0102\";\r\n}\r\n\r\n.mdi-camera-front-variant::before {\r\n  content: \"\\F0103\";\r\n}\r\n\r\n.mdi-camera-gopro::before {\r\n  content: \"\\F07A1\";\r\n}\r\n\r\n.mdi-camera-image::before {\r\n  content: \"\\F08CC\";\r\n}\r\n\r\n.mdi-camera-iris::before {\r\n  content: \"\\F0104\";\r\n}\r\n\r\n.mdi-camera-marker::before {\r\n  content: \"\\F19A7\";\r\n}\r\n\r\n.mdi-camera-marker-outline::before {\r\n  content: \"\\F19A8\";\r\n}\r\n\r\n.mdi-camera-metering-center::before {\r\n  content: \"\\F07A2\";\r\n}\r\n\r\n.mdi-camera-metering-matrix::before {\r\n  content: \"\\F07A3\";\r\n}\r\n\r\n.mdi-camera-metering-partial::before {\r\n  content: \"\\F07A4\";\r\n}\r\n\r\n.mdi-camera-metering-spot::before {\r\n  content: \"\\F07A5\";\r\n}\r\n\r\n.mdi-camera-off::before {\r\n  content: \"\\F05DF\";\r\n}\r\n\r\n.mdi-camera-off-outline::before {\r\n  content: \"\\F19BF\";\r\n}\r\n\r\n.mdi-camera-outline::before {\r\n  content: \"\\F0D5D\";\r\n}\r\n\r\n.mdi-camera-party-mode::before {\r\n  content: \"\\F0105\";\r\n}\r\n\r\n.mdi-camera-plus::before {\r\n  content: \"\\F0EDB\";\r\n}\r\n\r\n.mdi-camera-plus-outline::before {\r\n  content: \"\\F0EDC\";\r\n}\r\n\r\n.mdi-camera-rear::before {\r\n  content: \"\\F0106\";\r\n}\r\n\r\n.mdi-camera-rear-variant::before {\r\n  content: \"\\F0107\";\r\n}\r\n\r\n.mdi-camera-retake::before {\r\n  content: \"\\F0E19\";\r\n}\r\n\r\n.mdi-camera-retake-outline::before {\r\n  content: \"\\F0E1A\";\r\n}\r\n\r\n.mdi-camera-switch::before {\r\n  content: \"\\F0108\";\r\n}\r\n\r\n.mdi-camera-switch-outline::before {\r\n  content: \"\\F084A\";\r\n}\r\n\r\n.mdi-camera-timer::before {\r\n  content: \"\\F0109\";\r\n}\r\n\r\n.mdi-camera-wireless::before {\r\n  content: \"\\F0DB6\";\r\n}\r\n\r\n.mdi-camera-wireless-outline::before {\r\n  content: \"\\F0DB7\";\r\n}\r\n\r\n.mdi-campfire::before {\r\n  content: \"\\F0EDD\";\r\n}\r\n\r\n.mdi-cancel::before {\r\n  content: \"\\F073A\";\r\n}\r\n\r\n.mdi-candelabra::before {\r\n  content: \"\\F17D2\";\r\n}\r\n\r\n.mdi-candelabra-fire::before {\r\n  content: \"\\F17D3\";\r\n}\r\n\r\n.mdi-candle::before {\r\n  content: \"\\F05E2\";\r\n}\r\n\r\n.mdi-candy::before {\r\n  content: \"\\F1970\";\r\n}\r\n\r\n.mdi-candy-off::before {\r\n  content: \"\\F1971\";\r\n}\r\n\r\n.mdi-candy-off-outline::before {\r\n  content: \"\\F1972\";\r\n}\r\n\r\n.mdi-candy-outline::before {\r\n  content: \"\\F1973\";\r\n}\r\n\r\n.mdi-candycane::before {\r\n  content: \"\\F010A\";\r\n}\r\n\r\n.mdi-cannabis::before {\r\n  content: \"\\F07A6\";\r\n}\r\n\r\n.mdi-cannabis-off::before {\r\n  content: \"\\F166E\";\r\n}\r\n\r\n.mdi-caps-lock::before {\r\n  content: \"\\F0A9B\";\r\n}\r\n\r\n.mdi-car::before {\r\n  content: \"\\F010B\";\r\n}\r\n\r\n.mdi-car-2-plus::before {\r\n  content: \"\\F1015\";\r\n}\r\n\r\n.mdi-car-3-plus::before {\r\n  content: \"\\F1016\";\r\n}\r\n\r\n.mdi-car-arrow-left::before {\r\n  content: \"\\F13B2\";\r\n}\r\n\r\n.mdi-car-arrow-right::before {\r\n  content: \"\\F13B3\";\r\n}\r\n\r\n.mdi-car-back::before {\r\n  content: \"\\F0E1B\";\r\n}\r\n\r\n.mdi-car-battery::before {\r\n  content: \"\\F010C\";\r\n}\r\n\r\n.mdi-car-brake-abs::before {\r\n  content: \"\\F0C47\";\r\n}\r\n\r\n.mdi-car-brake-alert::before {\r\n  content: \"\\F0C48\";\r\n}\r\n\r\n.mdi-car-brake-fluid-level::before {\r\n  content: \"\\F1909\";\r\n}\r\n\r\n.mdi-car-brake-hold::before {\r\n  content: \"\\F0D5E\";\r\n}\r\n\r\n.mdi-car-brake-low-pressure::before {\r\n  content: \"\\F190A\";\r\n}\r\n\r\n.mdi-car-brake-parking::before {\r\n  content: \"\\F0D5F\";\r\n}\r\n\r\n.mdi-car-brake-retarder::before {\r\n  content: \"\\F1017\";\r\n}\r\n\r\n.mdi-car-brake-temperature::before {\r\n  content: \"\\F190B\";\r\n}\r\n\r\n.mdi-car-brake-worn-linings::before {\r\n  content: \"\\F190C\";\r\n}\r\n\r\n.mdi-car-child-seat::before {\r\n  content: \"\\F0FA3\";\r\n}\r\n\r\n.mdi-car-clock::before {\r\n  content: \"\\F1974\";\r\n}\r\n\r\n.mdi-car-clutch::before {\r\n  content: \"\\F1018\";\r\n}\r\n\r\n.mdi-car-cog::before {\r\n  content: \"\\F13CC\";\r\n}\r\n\r\n.mdi-car-connected::before {\r\n  content: \"\\F010D\";\r\n}\r\n\r\n.mdi-car-convertible::before {\r\n  content: \"\\F07A7\";\r\n}\r\n\r\n.mdi-car-coolant-level::before {\r\n  content: \"\\F1019\";\r\n}\r\n\r\n.mdi-car-cruise-control::before {\r\n  content: \"\\F0D60\";\r\n}\r\n\r\n.mdi-car-defrost-front::before {\r\n  content: \"\\F0D61\";\r\n}\r\n\r\n.mdi-car-defrost-rear::before {\r\n  content: \"\\F0D62\";\r\n}\r\n\r\n.mdi-car-door::before {\r\n  content: \"\\F0B6B\";\r\n}\r\n\r\n.mdi-car-door-lock::before {\r\n  content: \"\\F109D\";\r\n}\r\n\r\n.mdi-car-electric::before {\r\n  content: \"\\F0B6C\";\r\n}\r\n\r\n.mdi-car-electric-outline::before {\r\n  content: \"\\F15B5\";\r\n}\r\n\r\n.mdi-car-emergency::before {\r\n  content: \"\\F160F\";\r\n}\r\n\r\n.mdi-car-esp::before {\r\n  content: \"\\F0C49\";\r\n}\r\n\r\n.mdi-car-estate::before {\r\n  content: \"\\F07A8\";\r\n}\r\n\r\n.mdi-car-hatchback::before {\r\n  content: \"\\F07A9\";\r\n}\r\n\r\n.mdi-car-info::before {\r\n  content: \"\\F11BE\";\r\n}\r\n\r\n.mdi-car-key::before {\r\n  content: \"\\F0B6D\";\r\n}\r\n\r\n.mdi-car-lifted-pickup::before {\r\n  content: \"\\F152D\";\r\n}\r\n\r\n.mdi-car-light-alert::before {\r\n  content: \"\\F190D\";\r\n}\r\n\r\n.mdi-car-light-dimmed::before {\r\n  content: \"\\F0C4A\";\r\n}\r\n\r\n.mdi-car-light-fog::before {\r\n  content: \"\\F0C4B\";\r\n}\r\n\r\n.mdi-car-light-high::before {\r\n  content: \"\\F0C4C\";\r\n}\r\n\r\n.mdi-car-limousine::before {\r\n  content: \"\\F08CD\";\r\n}\r\n\r\n.mdi-car-multiple::before {\r\n  content: \"\\F0B6E\";\r\n}\r\n\r\n.mdi-car-off::before {\r\n  content: \"\\F0E1C\";\r\n}\r\n\r\n.mdi-car-outline::before {\r\n  content: \"\\F14ED\";\r\n}\r\n\r\n.mdi-car-parking-lights::before {\r\n  content: \"\\F0D63\";\r\n}\r\n\r\n.mdi-car-pickup::before {\r\n  content: \"\\F07AA\";\r\n}\r\n\r\n.mdi-car-seat::before {\r\n  content: \"\\F0FA4\";\r\n}\r\n\r\n.mdi-car-seat-cooler::before {\r\n  content: \"\\F0FA5\";\r\n}\r\n\r\n.mdi-car-seat-heater::before {\r\n  content: \"\\F0FA6\";\r\n}\r\n\r\n.mdi-car-select::before {\r\n  content: \"\\F1879\";\r\n}\r\n\r\n.mdi-car-settings::before {\r\n  content: \"\\F13CD\";\r\n}\r\n\r\n.mdi-car-shift-pattern::before {\r\n  content: \"\\F0F40\";\r\n}\r\n\r\n.mdi-car-side::before {\r\n  content: \"\\F07AB\";\r\n}\r\n\r\n.mdi-car-speed-limiter::before {\r\n  content: \"\\F190E\";\r\n}\r\n\r\n.mdi-car-sports::before {\r\n  content: \"\\F07AC\";\r\n}\r\n\r\n.mdi-car-tire-alert::before {\r\n  content: \"\\F0C4D\";\r\n}\r\n\r\n.mdi-car-traction-control::before {\r\n  content: \"\\F0D64\";\r\n}\r\n\r\n.mdi-car-turbocharger::before {\r\n  content: \"\\F101A\";\r\n}\r\n\r\n.mdi-car-wash::before {\r\n  content: \"\\F010E\";\r\n}\r\n\r\n.mdi-car-windshield::before {\r\n  content: \"\\F101B\";\r\n}\r\n\r\n.mdi-car-windshield-outline::before {\r\n  content: \"\\F101C\";\r\n}\r\n\r\n.mdi-car-wireless::before {\r\n  content: \"\\F1878\";\r\n}\r\n\r\n.mdi-car-wrench::before {\r\n  content: \"\\F1814\";\r\n}\r\n\r\n.mdi-carabiner::before {\r\n  content: \"\\F14C0\";\r\n}\r\n\r\n.mdi-caravan::before {\r\n  content: \"\\F07AD\";\r\n}\r\n\r\n.mdi-card::before {\r\n  content: \"\\F0B6F\";\r\n}\r\n\r\n.mdi-card-account-details::before {\r\n  content: \"\\F05D2\";\r\n}\r\n\r\n.mdi-card-account-details-outline::before {\r\n  content: \"\\F0DAB\";\r\n}\r\n\r\n.mdi-card-account-details-star::before {\r\n  content: \"\\F02A3\";\r\n}\r\n\r\n.mdi-card-account-details-star-outline::before {\r\n  content: \"\\F06DB\";\r\n}\r\n\r\n.mdi-card-account-mail::before {\r\n  content: \"\\F018E\";\r\n}\r\n\r\n.mdi-card-account-mail-outline::before {\r\n  content: \"\\F0E98\";\r\n}\r\n\r\n.mdi-card-account-phone::before {\r\n  content: \"\\F0E99\";\r\n}\r\n\r\n.mdi-card-account-phone-outline::before {\r\n  content: \"\\F0E9A\";\r\n}\r\n\r\n.mdi-card-bulleted::before {\r\n  content: \"\\F0B70\";\r\n}\r\n\r\n.mdi-card-bulleted-off::before {\r\n  content: \"\\F0B71\";\r\n}\r\n\r\n.mdi-card-bulleted-off-outline::before {\r\n  content: \"\\F0B72\";\r\n}\r\n\r\n.mdi-card-bulleted-outline::before {\r\n  content: \"\\F0B73\";\r\n}\r\n\r\n.mdi-card-bulleted-settings::before {\r\n  content: \"\\F0B74\";\r\n}\r\n\r\n.mdi-card-bulleted-settings-outline::before {\r\n  content: \"\\F0B75\";\r\n}\r\n\r\n.mdi-card-minus::before {\r\n  content: \"\\F1600\";\r\n}\r\n\r\n.mdi-card-minus-outline::before {\r\n  content: \"\\F1601\";\r\n}\r\n\r\n.mdi-card-multiple::before {\r\n  content: \"\\F17F1\";\r\n}\r\n\r\n.mdi-card-multiple-outline::before {\r\n  content: \"\\F17F2\";\r\n}\r\n\r\n.mdi-card-off::before {\r\n  content: \"\\F1602\";\r\n}\r\n\r\n.mdi-card-off-outline::before {\r\n  content: \"\\F1603\";\r\n}\r\n\r\n.mdi-card-outline::before {\r\n  content: \"\\F0B76\";\r\n}\r\n\r\n.mdi-card-plus::before {\r\n  content: \"\\F11FF\";\r\n}\r\n\r\n.mdi-card-plus-outline::before {\r\n  content: \"\\F1200\";\r\n}\r\n\r\n.mdi-card-remove::before {\r\n  content: \"\\F1604\";\r\n}\r\n\r\n.mdi-card-remove-outline::before {\r\n  content: \"\\F1605\";\r\n}\r\n\r\n.mdi-card-search::before {\r\n  content: \"\\F1074\";\r\n}\r\n\r\n.mdi-card-search-outline::before {\r\n  content: \"\\F1075\";\r\n}\r\n\r\n.mdi-card-text::before {\r\n  content: \"\\F0B77\";\r\n}\r\n\r\n.mdi-card-text-outline::before {\r\n  content: \"\\F0B78\";\r\n}\r\n\r\n.mdi-cards::before {\r\n  content: \"\\F0638\";\r\n}\r\n\r\n.mdi-cards-club::before {\r\n  content: \"\\F08CE\";\r\n}\r\n\r\n.mdi-cards-club-outline::before {\r\n  content: \"\\F189F\";\r\n}\r\n\r\n.mdi-cards-diamond::before {\r\n  content: \"\\F08CF\";\r\n}\r\n\r\n.mdi-cards-diamond-outline::before {\r\n  content: \"\\F101D\";\r\n}\r\n\r\n.mdi-cards-heart::before {\r\n  content: \"\\F08D0\";\r\n}\r\n\r\n.mdi-cards-heart-outline::before {\r\n  content: \"\\F18A0\";\r\n}\r\n\r\n.mdi-cards-outline::before {\r\n  content: \"\\F0639\";\r\n}\r\n\r\n.mdi-cards-playing::before {\r\n  content: \"\\F18A1\";\r\n}\r\n\r\n.mdi-cards-playing-club::before {\r\n  content: \"\\F18A2\";\r\n}\r\n\r\n.mdi-cards-playing-club-multiple::before {\r\n  content: \"\\F18A3\";\r\n}\r\n\r\n.mdi-cards-playing-club-multiple-outline::before {\r\n  content: \"\\F18A4\";\r\n}\r\n\r\n.mdi-cards-playing-club-outline::before {\r\n  content: \"\\F18A5\";\r\n}\r\n\r\n.mdi-cards-playing-diamond::before {\r\n  content: \"\\F18A6\";\r\n}\r\n\r\n.mdi-cards-playing-diamond-multiple::before {\r\n  content: \"\\F18A7\";\r\n}\r\n\r\n.mdi-cards-playing-diamond-multiple-outline::before {\r\n  content: \"\\F18A8\";\r\n}\r\n\r\n.mdi-cards-playing-diamond-outline::before {\r\n  content: \"\\F18A9\";\r\n}\r\n\r\n.mdi-cards-playing-heart::before {\r\n  content: \"\\F18AA\";\r\n}\r\n\r\n.mdi-cards-playing-heart-multiple::before {\r\n  content: \"\\F18AB\";\r\n}\r\n\r\n.mdi-cards-playing-heart-multiple-outline::before {\r\n  content: \"\\F18AC\";\r\n}\r\n\r\n.mdi-cards-playing-heart-outline::before {\r\n  content: \"\\F18AD\";\r\n}\r\n\r\n.mdi-cards-playing-outline::before {\r\n  content: \"\\F063A\";\r\n}\r\n\r\n.mdi-cards-playing-spade::before {\r\n  content: \"\\F18AE\";\r\n}\r\n\r\n.mdi-cards-playing-spade-multiple::before {\r\n  content: \"\\F18AF\";\r\n}\r\n\r\n.mdi-cards-playing-spade-multiple-outline::before {\r\n  content: \"\\F18B0\";\r\n}\r\n\r\n.mdi-cards-playing-spade-outline::before {\r\n  content: \"\\F18B1\";\r\n}\r\n\r\n.mdi-cards-spade::before {\r\n  content: \"\\F08D1\";\r\n}\r\n\r\n.mdi-cards-spade-outline::before {\r\n  content: \"\\F18B2\";\r\n}\r\n\r\n.mdi-cards-variant::before {\r\n  content: \"\\F06C7\";\r\n}\r\n\r\n.mdi-carrot::before {\r\n  content: \"\\F010F\";\r\n}\r\n\r\n.mdi-cart::before {\r\n  content: \"\\F0110\";\r\n}\r\n\r\n.mdi-cart-arrow-down::before {\r\n  content: \"\\F0D66\";\r\n}\r\n\r\n.mdi-cart-arrow-right::before {\r\n  content: \"\\F0C4E\";\r\n}\r\n\r\n.mdi-cart-arrow-up::before {\r\n  content: \"\\F0D67\";\r\n}\r\n\r\n.mdi-cart-check::before {\r\n  content: \"\\F15EA\";\r\n}\r\n\r\n.mdi-cart-heart::before {\r\n  content: \"\\F18E0\";\r\n}\r\n\r\n.mdi-cart-minus::before {\r\n  content: \"\\F0D68\";\r\n}\r\n\r\n.mdi-cart-off::before {\r\n  content: \"\\F066B\";\r\n}\r\n\r\n.mdi-cart-outline::before {\r\n  content: \"\\F0111\";\r\n}\r\n\r\n.mdi-cart-plus::before {\r\n  content: \"\\F0112\";\r\n}\r\n\r\n.mdi-cart-remove::before {\r\n  content: \"\\F0D69\";\r\n}\r\n\r\n.mdi-cart-variant::before {\r\n  content: \"\\F15EB\";\r\n}\r\n\r\n.mdi-case-sensitive-alt::before {\r\n  content: \"\\F0113\";\r\n}\r\n\r\n.mdi-cash::before {\r\n  content: \"\\F0114\";\r\n}\r\n\r\n.mdi-cash-100::before {\r\n  content: \"\\F0115\";\r\n}\r\n\r\n.mdi-cash-check::before {\r\n  content: \"\\F14EE\";\r\n}\r\n\r\n.mdi-cash-fast::before {\r\n  content: \"\\F185C\";\r\n}\r\n\r\n.mdi-cash-lock::before {\r\n  content: \"\\F14EA\";\r\n}\r\n\r\n.mdi-cash-lock-open::before {\r\n  content: \"\\F14EB\";\r\n}\r\n\r\n.mdi-cash-marker::before {\r\n  content: \"\\F0DB8\";\r\n}\r\n\r\n.mdi-cash-minus::before {\r\n  content: \"\\F1260\";\r\n}\r\n\r\n.mdi-cash-multiple::before {\r\n  content: \"\\F0116\";\r\n}\r\n\r\n.mdi-cash-plus::before {\r\n  content: \"\\F1261\";\r\n}\r\n\r\n.mdi-cash-refund::before {\r\n  content: \"\\F0A9C\";\r\n}\r\n\r\n.mdi-cash-register::before {\r\n  content: \"\\F0CF4\";\r\n}\r\n\r\n.mdi-cash-remove::before {\r\n  content: \"\\F1262\";\r\n}\r\n\r\n.mdi-cassette::before {\r\n  content: \"\\F09D4\";\r\n}\r\n\r\n.mdi-cast::before {\r\n  content: \"\\F0118\";\r\n}\r\n\r\n.mdi-cast-audio::before {\r\n  content: \"\\F101E\";\r\n}\r\n\r\n.mdi-cast-audio-variant::before {\r\n  content: \"\\F1749\";\r\n}\r\n\r\n.mdi-cast-connected::before {\r\n  content: \"\\F0119\";\r\n}\r\n\r\n.mdi-cast-education::before {\r\n  content: \"\\F0E1D\";\r\n}\r\n\r\n.mdi-cast-off::before {\r\n  content: \"\\F078A\";\r\n}\r\n\r\n.mdi-cast-variant::before {\r\n  content: \"\\F001F\";\r\n}\r\n\r\n.mdi-castle::before {\r\n  content: \"\\F011A\";\r\n}\r\n\r\n.mdi-cat::before {\r\n  content: \"\\F011B\";\r\n}\r\n\r\n.mdi-cctv::before {\r\n  content: \"\\F07AE\";\r\n}\r\n\r\n.mdi-cctv-off::before {\r\n  content: \"\\F185F\";\r\n}\r\n\r\n.mdi-ceiling-fan::before {\r\n  content: \"\\F1797\";\r\n}\r\n\r\n.mdi-ceiling-fan-light::before {\r\n  content: \"\\F1798\";\r\n}\r\n\r\n.mdi-ceiling-light::before {\r\n  content: \"\\F0769\";\r\n}\r\n\r\n.mdi-ceiling-light-multiple::before {\r\n  content: \"\\F18DD\";\r\n}\r\n\r\n.mdi-ceiling-light-multiple-outline::before {\r\n  content: \"\\F18DE\";\r\n}\r\n\r\n.mdi-ceiling-light-outline::before {\r\n  content: \"\\F17C7\";\r\n}\r\n\r\n.mdi-cellphone::before {\r\n  content: \"\\F011C\";\r\n}\r\n\r\n.mdi-cellphone-arrow-down::before {\r\n  content: \"\\F09D5\";\r\n}\r\n\r\n.mdi-cellphone-basic::before {\r\n  content: \"\\F011E\";\r\n}\r\n\r\n.mdi-cellphone-charging::before {\r\n  content: \"\\F1397\";\r\n}\r\n\r\n.mdi-cellphone-check::before {\r\n  content: \"\\F17FD\";\r\n}\r\n\r\n.mdi-cellphone-cog::before {\r\n  content: \"\\F0951\";\r\n}\r\n\r\n.mdi-cellphone-dock::before {\r\n  content: \"\\F011F\";\r\n}\r\n\r\n.mdi-cellphone-information::before {\r\n  content: \"\\F0F41\";\r\n}\r\n\r\n.mdi-cellphone-key::before {\r\n  content: \"\\F094E\";\r\n}\r\n\r\n.mdi-cellphone-link::before {\r\n  content: \"\\F0121\";\r\n}\r\n\r\n.mdi-cellphone-link-off::before {\r\n  content: \"\\F0122\";\r\n}\r\n\r\n.mdi-cellphone-lock::before {\r\n  content: \"\\F094F\";\r\n}\r\n\r\n.mdi-cellphone-marker::before {\r\n  content: \"\\F183A\";\r\n}\r\n\r\n.mdi-cellphone-message::before {\r\n  content: \"\\F08D3\";\r\n}\r\n\r\n.mdi-cellphone-message-off::before {\r\n  content: \"\\F10D2\";\r\n}\r\n\r\n.mdi-cellphone-nfc::before {\r\n  content: \"\\F0E90\";\r\n}\r\n\r\n.mdi-cellphone-nfc-off::before {\r\n  content: \"\\F12D8\";\r\n}\r\n\r\n.mdi-cellphone-off::before {\r\n  content: \"\\F0950\";\r\n}\r\n\r\n.mdi-cellphone-play::before {\r\n  content: \"\\F101F\";\r\n}\r\n\r\n.mdi-cellphone-remove::before {\r\n  content: \"\\F094D\";\r\n}\r\n\r\n.mdi-cellphone-screenshot::before {\r\n  content: \"\\F0A35\";\r\n}\r\n\r\n.mdi-cellphone-settings::before {\r\n  content: \"\\F0123\";\r\n}\r\n\r\n.mdi-cellphone-sound::before {\r\n  content: \"\\F0952\";\r\n}\r\n\r\n.mdi-cellphone-text::before {\r\n  content: \"\\F08D2\";\r\n}\r\n\r\n.mdi-cellphone-wireless::before {\r\n  content: \"\\F0815\";\r\n}\r\n\r\n.mdi-centos::before {\r\n  content: \"\\F111A\";\r\n}\r\n\r\n.mdi-certificate::before {\r\n  content: \"\\F0124\";\r\n}\r\n\r\n.mdi-certificate-outline::before {\r\n  content: \"\\F1188\";\r\n}\r\n\r\n.mdi-chair-rolling::before {\r\n  content: \"\\F0F48\";\r\n}\r\n\r\n.mdi-chair-school::before {\r\n  content: \"\\F0125\";\r\n}\r\n\r\n.mdi-chandelier::before {\r\n  content: \"\\F1793\";\r\n}\r\n\r\n.mdi-charity::before {\r\n  content: \"\\F0C4F\";\r\n}\r\n\r\n.mdi-chart-arc::before {\r\n  content: \"\\F0126\";\r\n}\r\n\r\n.mdi-chart-areaspline::before {\r\n  content: \"\\F0127\";\r\n}\r\n\r\n.mdi-chart-areaspline-variant::before {\r\n  content: \"\\F0E91\";\r\n}\r\n\r\n.mdi-chart-bar::before {\r\n  content: \"\\F0128\";\r\n}\r\n\r\n.mdi-chart-bar-stacked::before {\r\n  content: \"\\F076A\";\r\n}\r\n\r\n.mdi-chart-bell-curve::before {\r\n  content: \"\\F0C50\";\r\n}\r\n\r\n.mdi-chart-bell-curve-cumulative::before {\r\n  content: \"\\F0FA7\";\r\n}\r\n\r\n.mdi-chart-box::before {\r\n  content: \"\\F154D\";\r\n}\r\n\r\n.mdi-chart-box-outline::before {\r\n  content: \"\\F154E\";\r\n}\r\n\r\n.mdi-chart-box-plus-outline::before {\r\n  content: \"\\F154F\";\r\n}\r\n\r\n.mdi-chart-bubble::before {\r\n  content: \"\\F05E3\";\r\n}\r\n\r\n.mdi-chart-donut::before {\r\n  content: \"\\F07AF\";\r\n}\r\n\r\n.mdi-chart-donut-variant::before {\r\n  content: \"\\F07B0\";\r\n}\r\n\r\n.mdi-chart-gantt::before {\r\n  content: \"\\F066C\";\r\n}\r\n\r\n.mdi-chart-histogram::before {\r\n  content: \"\\F0129\";\r\n}\r\n\r\n.mdi-chart-line::before {\r\n  content: \"\\F012A\";\r\n}\r\n\r\n.mdi-chart-line-stacked::before {\r\n  content: \"\\F076B\";\r\n}\r\n\r\n.mdi-chart-line-variant::before {\r\n  content: \"\\F07B1\";\r\n}\r\n\r\n.mdi-chart-multiline::before {\r\n  content: \"\\F08D4\";\r\n}\r\n\r\n.mdi-chart-multiple::before {\r\n  content: \"\\F1213\";\r\n}\r\n\r\n.mdi-chart-pie::before {\r\n  content: \"\\F012B\";\r\n}\r\n\r\n.mdi-chart-ppf::before {\r\n  content: \"\\F1380\";\r\n}\r\n\r\n.mdi-chart-sankey::before {\r\n  content: \"\\F11DF\";\r\n}\r\n\r\n.mdi-chart-sankey-variant::before {\r\n  content: \"\\F11E0\";\r\n}\r\n\r\n.mdi-chart-scatter-plot::before {\r\n  content: \"\\F0E92\";\r\n}\r\n\r\n.mdi-chart-scatter-plot-hexbin::before {\r\n  content: \"\\F066D\";\r\n}\r\n\r\n.mdi-chart-timeline::before {\r\n  content: \"\\F066E\";\r\n}\r\n\r\n.mdi-chart-timeline-variant::before {\r\n  content: \"\\F0E93\";\r\n}\r\n\r\n.mdi-chart-timeline-variant-shimmer::before {\r\n  content: \"\\F15B6\";\r\n}\r\n\r\n.mdi-chart-tree::before {\r\n  content: \"\\F0E94\";\r\n}\r\n\r\n.mdi-chart-waterfall::before {\r\n  content: \"\\F1918\";\r\n}\r\n\r\n.mdi-chat::before {\r\n  content: \"\\F0B79\";\r\n}\r\n\r\n.mdi-chat-alert::before {\r\n  content: \"\\F0B7A\";\r\n}\r\n\r\n.mdi-chat-alert-outline::before {\r\n  content: \"\\F12C9\";\r\n}\r\n\r\n.mdi-chat-minus::before {\r\n  content: \"\\F1410\";\r\n}\r\n\r\n.mdi-chat-minus-outline::before {\r\n  content: \"\\F1413\";\r\n}\r\n\r\n.mdi-chat-outline::before {\r\n  content: \"\\F0EDE\";\r\n}\r\n\r\n.mdi-chat-plus::before {\r\n  content: \"\\F140F\";\r\n}\r\n\r\n.mdi-chat-plus-outline::before {\r\n  content: \"\\F1412\";\r\n}\r\n\r\n.mdi-chat-processing::before {\r\n  content: \"\\F0B7B\";\r\n}\r\n\r\n.mdi-chat-processing-outline::before {\r\n  content: \"\\F12CA\";\r\n}\r\n\r\n.mdi-chat-question::before {\r\n  content: \"\\F1738\";\r\n}\r\n\r\n.mdi-chat-question-outline::before {\r\n  content: \"\\F1739\";\r\n}\r\n\r\n.mdi-chat-remove::before {\r\n  content: \"\\F1411\";\r\n}\r\n\r\n.mdi-chat-remove-outline::before {\r\n  content: \"\\F1414\";\r\n}\r\n\r\n.mdi-chat-sleep::before {\r\n  content: \"\\F12D1\";\r\n}\r\n\r\n.mdi-chat-sleep-outline::before {\r\n  content: \"\\F12D2\";\r\n}\r\n\r\n.mdi-check::before {\r\n  content: \"\\F012C\";\r\n}\r\n\r\n.mdi-check-all::before {\r\n  content: \"\\F012D\";\r\n}\r\n\r\n.mdi-check-bold::before {\r\n  content: \"\\F0E1E\";\r\n}\r\n\r\n.mdi-check-circle::before {\r\n  content: \"\\F05E0\";\r\n}\r\n\r\n.mdi-check-circle-outline::before {\r\n  content: \"\\F05E1\";\r\n}\r\n\r\n.mdi-check-decagram::before {\r\n  content: \"\\F0791\";\r\n}\r\n\r\n.mdi-check-decagram-outline::before {\r\n  content: \"\\F1740\";\r\n}\r\n\r\n.mdi-check-network::before {\r\n  content: \"\\F0C53\";\r\n}\r\n\r\n.mdi-check-network-outline::before {\r\n  content: \"\\F0C54\";\r\n}\r\n\r\n.mdi-check-outline::before {\r\n  content: \"\\F0855\";\r\n}\r\n\r\n.mdi-check-underline::before {\r\n  content: \"\\F0E1F\";\r\n}\r\n\r\n.mdi-check-underline-circle::before {\r\n  content: \"\\F0E20\";\r\n}\r\n\r\n.mdi-check-underline-circle-outline::before {\r\n  content: \"\\F0E21\";\r\n}\r\n\r\n.mdi-checkbook::before {\r\n  content: \"\\F0A9D\";\r\n}\r\n\r\n.mdi-checkbox-blank::before {\r\n  content: \"\\F012E\";\r\n}\r\n\r\n.mdi-checkbox-blank-badge::before {\r\n  content: \"\\F1176\";\r\n}\r\n\r\n.mdi-checkbox-blank-badge-outline::before {\r\n  content: \"\\F0117\";\r\n}\r\n\r\n.mdi-checkbox-blank-circle::before {\r\n  content: \"\\F012F\";\r\n}\r\n\r\n.mdi-checkbox-blank-circle-outline::before {\r\n  content: \"\\F0130\";\r\n}\r\n\r\n.mdi-checkbox-blank-off::before {\r\n  content: \"\\F12EC\";\r\n}\r\n\r\n.mdi-checkbox-blank-off-outline::before {\r\n  content: \"\\F12ED\";\r\n}\r\n\r\n.mdi-checkbox-blank-outline::before {\r\n  content: \"\\F0131\";\r\n}\r\n\r\n.mdi-checkbox-intermediate::before {\r\n  content: \"\\F0856\";\r\n}\r\n\r\n.mdi-checkbox-marked::before {\r\n  content: \"\\F0132\";\r\n}\r\n\r\n.mdi-checkbox-marked-circle::before {\r\n  content: \"\\F0133\";\r\n}\r\n\r\n.mdi-checkbox-marked-circle-outline::before {\r\n  content: \"\\F0134\";\r\n}\r\n\r\n.mdi-checkbox-marked-circle-plus-outline::before {\r\n  content: \"\\F1927\";\r\n}\r\n\r\n.mdi-checkbox-marked-outline::before {\r\n  content: \"\\F0135\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank::before {\r\n  content: \"\\F0136\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank-circle::before {\r\n  content: \"\\F063B\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank-circle-outline::before {\r\n  content: \"\\F063C\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank-outline::before {\r\n  content: \"\\F0137\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked::before {\r\n  content: \"\\F0138\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked-circle::before {\r\n  content: \"\\F063D\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked-circle-outline::before {\r\n  content: \"\\F063E\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked-outline::before {\r\n  content: \"\\F0139\";\r\n}\r\n\r\n.mdi-checkbox-multiple-outline::before {\r\n  content: \"\\F0C51\";\r\n}\r\n\r\n.mdi-checkbox-outline::before {\r\n  content: \"\\F0C52\";\r\n}\r\n\r\n.mdi-checkerboard::before {\r\n  content: \"\\F013A\";\r\n}\r\n\r\n.mdi-checkerboard-minus::before {\r\n  content: \"\\F1202\";\r\n}\r\n\r\n.mdi-checkerboard-plus::before {\r\n  content: \"\\F1201\";\r\n}\r\n\r\n.mdi-checkerboard-remove::before {\r\n  content: \"\\F1203\";\r\n}\r\n\r\n.mdi-cheese::before {\r\n  content: \"\\F12B9\";\r\n}\r\n\r\n.mdi-cheese-off::before {\r\n  content: \"\\F13EE\";\r\n}\r\n\r\n.mdi-chef-hat::before {\r\n  content: \"\\F0B7C\";\r\n}\r\n\r\n.mdi-chemical-weapon::before {\r\n  content: \"\\F013B\";\r\n}\r\n\r\n.mdi-chess-bishop::before {\r\n  content: \"\\F085C\";\r\n}\r\n\r\n.mdi-chess-king::before {\r\n  content: \"\\F0857\";\r\n}\r\n\r\n.mdi-chess-knight::before {\r\n  content: \"\\F0858\";\r\n}\r\n\r\n.mdi-chess-pawn::before {\r\n  content: \"\\F0859\";\r\n}\r\n\r\n.mdi-chess-queen::before {\r\n  content: \"\\F085A\";\r\n}\r\n\r\n.mdi-chess-rook::before {\r\n  content: \"\\F085B\";\r\n}\r\n\r\n.mdi-chevron-double-down::before {\r\n  content: \"\\F013C\";\r\n}\r\n\r\n.mdi-chevron-double-left::before {\r\n  content: \"\\F013D\";\r\n}\r\n\r\n.mdi-chevron-double-right::before {\r\n  content: \"\\F013E\";\r\n}\r\n\r\n.mdi-chevron-double-up::before {\r\n  content: \"\\F013F\";\r\n}\r\n\r\n.mdi-chevron-down::before {\r\n  content: \"\\F0140\";\r\n}\r\n\r\n.mdi-chevron-down-box::before {\r\n  content: \"\\F09D6\";\r\n}\r\n\r\n.mdi-chevron-down-box-outline::before {\r\n  content: \"\\F09D7\";\r\n}\r\n\r\n.mdi-chevron-down-circle::before {\r\n  content: \"\\F0B26\";\r\n}\r\n\r\n.mdi-chevron-down-circle-outline::before {\r\n  content: \"\\F0B27\";\r\n}\r\n\r\n.mdi-chevron-left::before {\r\n  content: \"\\F0141\";\r\n}\r\n\r\n.mdi-chevron-left-box::before {\r\n  content: \"\\F09D8\";\r\n}\r\n\r\n.mdi-chevron-left-box-outline::before {\r\n  content: \"\\F09D9\";\r\n}\r\n\r\n.mdi-chevron-left-circle::before {\r\n  content: \"\\F0B28\";\r\n}\r\n\r\n.mdi-chevron-left-circle-outline::before {\r\n  content: \"\\F0B29\";\r\n}\r\n\r\n.mdi-chevron-right::before {\r\n  content: \"\\F0142\";\r\n}\r\n\r\n.mdi-chevron-right-box::before {\r\n  content: \"\\F09DA\";\r\n}\r\n\r\n.mdi-chevron-right-box-outline::before {\r\n  content: \"\\F09DB\";\r\n}\r\n\r\n.mdi-chevron-right-circle::before {\r\n  content: \"\\F0B2A\";\r\n}\r\n\r\n.mdi-chevron-right-circle-outline::before {\r\n  content: \"\\F0B2B\";\r\n}\r\n\r\n.mdi-chevron-triple-down::before {\r\n  content: \"\\F0DB9\";\r\n}\r\n\r\n.mdi-chevron-triple-left::before {\r\n  content: \"\\F0DBA\";\r\n}\r\n\r\n.mdi-chevron-triple-right::before {\r\n  content: \"\\F0DBB\";\r\n}\r\n\r\n.mdi-chevron-triple-up::before {\r\n  content: \"\\F0DBC\";\r\n}\r\n\r\n.mdi-chevron-up::before {\r\n  content: \"\\F0143\";\r\n}\r\n\r\n.mdi-chevron-up-box::before {\r\n  content: \"\\F09DC\";\r\n}\r\n\r\n.mdi-chevron-up-box-outline::before {\r\n  content: \"\\F09DD\";\r\n}\r\n\r\n.mdi-chevron-up-circle::before {\r\n  content: \"\\F0B2C\";\r\n}\r\n\r\n.mdi-chevron-up-circle-outline::before {\r\n  content: \"\\F0B2D\";\r\n}\r\n\r\n.mdi-chili-alert::before {\r\n  content: \"\\F17EA\";\r\n}\r\n\r\n.mdi-chili-alert-outline::before {\r\n  content: \"\\F17EB\";\r\n}\r\n\r\n.mdi-chili-hot::before {\r\n  content: \"\\F07B2\";\r\n}\r\n\r\n.mdi-chili-hot-outline::before {\r\n  content: \"\\F17EC\";\r\n}\r\n\r\n.mdi-chili-medium::before {\r\n  content: \"\\F07B3\";\r\n}\r\n\r\n.mdi-chili-medium-outline::before {\r\n  content: \"\\F17ED\";\r\n}\r\n\r\n.mdi-chili-mild::before {\r\n  content: \"\\F07B4\";\r\n}\r\n\r\n.mdi-chili-mild-outline::before {\r\n  content: \"\\F17EE\";\r\n}\r\n\r\n.mdi-chili-off::before {\r\n  content: \"\\F1467\";\r\n}\r\n\r\n.mdi-chili-off-outline::before {\r\n  content: \"\\F17EF\";\r\n}\r\n\r\n.mdi-chip::before {\r\n  content: \"\\F061A\";\r\n}\r\n\r\n.mdi-church::before {\r\n  content: \"\\F0144\";\r\n}\r\n\r\n.mdi-cigar::before {\r\n  content: \"\\F1189\";\r\n}\r\n\r\n.mdi-cigar-off::before {\r\n  content: \"\\F141B\";\r\n}\r\n\r\n.mdi-circle::before {\r\n  content: \"\\F0765\";\r\n}\r\n\r\n.mdi-circle-box::before {\r\n  content: \"\\F15DC\";\r\n}\r\n\r\n.mdi-circle-box-outline::before {\r\n  content: \"\\F15DD\";\r\n}\r\n\r\n.mdi-circle-double::before {\r\n  content: \"\\F0E95\";\r\n}\r\n\r\n.mdi-circle-edit-outline::before {\r\n  content: \"\\F08D5\";\r\n}\r\n\r\n.mdi-circle-expand::before {\r\n  content: \"\\F0E96\";\r\n}\r\n\r\n.mdi-circle-half::before {\r\n  content: \"\\F1395\";\r\n}\r\n\r\n.mdi-circle-half-full::before {\r\n  content: \"\\F1396\";\r\n}\r\n\r\n.mdi-circle-medium::before {\r\n  content: \"\\F09DE\";\r\n}\r\n\r\n.mdi-circle-multiple::before {\r\n  content: \"\\F0B38\";\r\n}\r\n\r\n.mdi-circle-multiple-outline::before {\r\n  content: \"\\F0695\";\r\n}\r\n\r\n.mdi-circle-off-outline::before {\r\n  content: \"\\F10D3\";\r\n}\r\n\r\n.mdi-circle-opacity::before {\r\n  content: \"\\F1853\";\r\n}\r\n\r\n.mdi-circle-outline::before {\r\n  content: \"\\F0766\";\r\n}\r\n\r\n.mdi-circle-slice-1::before {\r\n  content: \"\\F0A9E\";\r\n}\r\n\r\n.mdi-circle-slice-2::before {\r\n  content: \"\\F0A9F\";\r\n}\r\n\r\n.mdi-circle-slice-3::before {\r\n  content: \"\\F0AA0\";\r\n}\r\n\r\n.mdi-circle-slice-4::before {\r\n  content: \"\\F0AA1\";\r\n}\r\n\r\n.mdi-circle-slice-5::before {\r\n  content: \"\\F0AA2\";\r\n}\r\n\r\n.mdi-circle-slice-6::before {\r\n  content: \"\\F0AA3\";\r\n}\r\n\r\n.mdi-circle-slice-7::before {\r\n  content: \"\\F0AA4\";\r\n}\r\n\r\n.mdi-circle-slice-8::before {\r\n  content: \"\\F0AA5\";\r\n}\r\n\r\n.mdi-circle-small::before {\r\n  content: \"\\F09DF\";\r\n}\r\n\r\n.mdi-circular-saw::before {\r\n  content: \"\\F0E22\";\r\n}\r\n\r\n.mdi-city::before {\r\n  content: \"\\F0146\";\r\n}\r\n\r\n.mdi-city-variant::before {\r\n  content: \"\\F0A36\";\r\n}\r\n\r\n.mdi-city-variant-outline::before {\r\n  content: \"\\F0A37\";\r\n}\r\n\r\n.mdi-clipboard::before {\r\n  content: \"\\F0147\";\r\n}\r\n\r\n.mdi-clipboard-account::before {\r\n  content: \"\\F0148\";\r\n}\r\n\r\n.mdi-clipboard-account-outline::before {\r\n  content: \"\\F0C55\";\r\n}\r\n\r\n.mdi-clipboard-alert::before {\r\n  content: \"\\F0149\";\r\n}\r\n\r\n.mdi-clipboard-alert-outline::before {\r\n  content: \"\\F0CF7\";\r\n}\r\n\r\n.mdi-clipboard-arrow-down::before {\r\n  content: \"\\F014A\";\r\n}\r\n\r\n.mdi-clipboard-arrow-down-outline::before {\r\n  content: \"\\F0C56\";\r\n}\r\n\r\n.mdi-clipboard-arrow-left::before {\r\n  content: \"\\F014B\";\r\n}\r\n\r\n.mdi-clipboard-arrow-left-outline::before {\r\n  content: \"\\F0CF8\";\r\n}\r\n\r\n.mdi-clipboard-arrow-right::before {\r\n  content: \"\\F0CF9\";\r\n}\r\n\r\n.mdi-clipboard-arrow-right-outline::before {\r\n  content: \"\\F0CFA\";\r\n}\r\n\r\n.mdi-clipboard-arrow-up::before {\r\n  content: \"\\F0C57\";\r\n}\r\n\r\n.mdi-clipboard-arrow-up-outline::before {\r\n  content: \"\\F0C58\";\r\n}\r\n\r\n.mdi-clipboard-check::before {\r\n  content: \"\\F014E\";\r\n}\r\n\r\n.mdi-clipboard-check-multiple::before {\r\n  content: \"\\F1263\";\r\n}\r\n\r\n.mdi-clipboard-check-multiple-outline::before {\r\n  content: \"\\F1264\";\r\n}\r\n\r\n.mdi-clipboard-check-outline::before {\r\n  content: \"\\F08A8\";\r\n}\r\n\r\n.mdi-clipboard-clock::before {\r\n  content: \"\\F16E2\";\r\n}\r\n\r\n.mdi-clipboard-clock-outline::before {\r\n  content: \"\\F16E3\";\r\n}\r\n\r\n.mdi-clipboard-edit::before {\r\n  content: \"\\F14E5\";\r\n}\r\n\r\n.mdi-clipboard-edit-outline::before {\r\n  content: \"\\F14E6\";\r\n}\r\n\r\n.mdi-clipboard-file::before {\r\n  content: \"\\F1265\";\r\n}\r\n\r\n.mdi-clipboard-file-outline::before {\r\n  content: \"\\F1266\";\r\n}\r\n\r\n.mdi-clipboard-flow::before {\r\n  content: \"\\F06C8\";\r\n}\r\n\r\n.mdi-clipboard-flow-outline::before {\r\n  content: \"\\F1117\";\r\n}\r\n\r\n.mdi-clipboard-list::before {\r\n  content: \"\\F10D4\";\r\n}\r\n\r\n.mdi-clipboard-list-outline::before {\r\n  content: \"\\F10D5\";\r\n}\r\n\r\n.mdi-clipboard-minus::before {\r\n  content: \"\\F1618\";\r\n}\r\n\r\n.mdi-clipboard-minus-outline::before {\r\n  content: \"\\F1619\";\r\n}\r\n\r\n.mdi-clipboard-multiple::before {\r\n  content: \"\\F1267\";\r\n}\r\n\r\n.mdi-clipboard-multiple-outline::before {\r\n  content: \"\\F1268\";\r\n}\r\n\r\n.mdi-clipboard-off::before {\r\n  content: \"\\F161A\";\r\n}\r\n\r\n.mdi-clipboard-off-outline::before {\r\n  content: \"\\F161B\";\r\n}\r\n\r\n.mdi-clipboard-outline::before {\r\n  content: \"\\F014C\";\r\n}\r\n\r\n.mdi-clipboard-play::before {\r\n  content: \"\\F0C59\";\r\n}\r\n\r\n.mdi-clipboard-play-multiple::before {\r\n  content: \"\\F1269\";\r\n}\r\n\r\n.mdi-clipboard-play-multiple-outline::before {\r\n  content: \"\\F126A\";\r\n}\r\n\r\n.mdi-clipboard-play-outline::before {\r\n  content: \"\\F0C5A\";\r\n}\r\n\r\n.mdi-clipboard-plus::before {\r\n  content: \"\\F0751\";\r\n}\r\n\r\n.mdi-clipboard-plus-outline::before {\r\n  content: \"\\F131F\";\r\n}\r\n\r\n.mdi-clipboard-pulse::before {\r\n  content: \"\\F085D\";\r\n}\r\n\r\n.mdi-clipboard-pulse-outline::before {\r\n  content: \"\\F085E\";\r\n}\r\n\r\n.mdi-clipboard-remove::before {\r\n  content: \"\\F161C\";\r\n}\r\n\r\n.mdi-clipboard-remove-outline::before {\r\n  content: \"\\F161D\";\r\n}\r\n\r\n.mdi-clipboard-search::before {\r\n  content: \"\\F161E\";\r\n}\r\n\r\n.mdi-clipboard-search-outline::before {\r\n  content: \"\\F161F\";\r\n}\r\n\r\n.mdi-clipboard-text::before {\r\n  content: \"\\F014D\";\r\n}\r\n\r\n.mdi-clipboard-text-clock::before {\r\n  content: \"\\F18F9\";\r\n}\r\n\r\n.mdi-clipboard-text-clock-outline::before {\r\n  content: \"\\F18FA\";\r\n}\r\n\r\n.mdi-clipboard-text-multiple::before {\r\n  content: \"\\F126B\";\r\n}\r\n\r\n.mdi-clipboard-text-multiple-outline::before {\r\n  content: \"\\F126C\";\r\n}\r\n\r\n.mdi-clipboard-text-off::before {\r\n  content: \"\\F1620\";\r\n}\r\n\r\n.mdi-clipboard-text-off-outline::before {\r\n  content: \"\\F1621\";\r\n}\r\n\r\n.mdi-clipboard-text-outline::before {\r\n  content: \"\\F0A38\";\r\n}\r\n\r\n.mdi-clipboard-text-play::before {\r\n  content: \"\\F0C5B\";\r\n}\r\n\r\n.mdi-clipboard-text-play-outline::before {\r\n  content: \"\\F0C5C\";\r\n}\r\n\r\n.mdi-clipboard-text-search::before {\r\n  content: \"\\F1622\";\r\n}\r\n\r\n.mdi-clipboard-text-search-outline::before {\r\n  content: \"\\F1623\";\r\n}\r\n\r\n.mdi-clippy::before {\r\n  content: \"\\F014F\";\r\n}\r\n\r\n.mdi-clock::before {\r\n  content: \"\\F0954\";\r\n}\r\n\r\n.mdi-clock-alert::before {\r\n  content: \"\\F0955\";\r\n}\r\n\r\n.mdi-clock-alert-outline::before {\r\n  content: \"\\F05CE\";\r\n}\r\n\r\n.mdi-clock-check::before {\r\n  content: \"\\F0FA8\";\r\n}\r\n\r\n.mdi-clock-check-outline::before {\r\n  content: \"\\F0FA9\";\r\n}\r\n\r\n.mdi-clock-digital::before {\r\n  content: \"\\F0E97\";\r\n}\r\n\r\n.mdi-clock-edit::before {\r\n  content: \"\\F19BA\";\r\n}\r\n\r\n.mdi-clock-edit-outline::before {\r\n  content: \"\\F19BB\";\r\n}\r\n\r\n.mdi-clock-end::before {\r\n  content: \"\\F0151\";\r\n}\r\n\r\n.mdi-clock-fast::before {\r\n  content: \"\\F0152\";\r\n}\r\n\r\n.mdi-clock-in::before {\r\n  content: \"\\F0153\";\r\n}\r\n\r\n.mdi-clock-minus::before {\r\n  content: \"\\F1863\";\r\n}\r\n\r\n.mdi-clock-minus-outline::before {\r\n  content: \"\\F1864\";\r\n}\r\n\r\n.mdi-clock-out::before {\r\n  content: \"\\F0154\";\r\n}\r\n\r\n.mdi-clock-outline::before {\r\n  content: \"\\F0150\";\r\n}\r\n\r\n.mdi-clock-plus::before {\r\n  content: \"\\F1861\";\r\n}\r\n\r\n.mdi-clock-plus-outline::before {\r\n  content: \"\\F1862\";\r\n}\r\n\r\n.mdi-clock-remove::before {\r\n  content: \"\\F1865\";\r\n}\r\n\r\n.mdi-clock-remove-outline::before {\r\n  content: \"\\F1866\";\r\n}\r\n\r\n.mdi-clock-start::before {\r\n  content: \"\\F0155\";\r\n}\r\n\r\n.mdi-clock-time-eight::before {\r\n  content: \"\\F1446\";\r\n}\r\n\r\n.mdi-clock-time-eight-outline::before {\r\n  content: \"\\F1452\";\r\n}\r\n\r\n.mdi-clock-time-eleven::before {\r\n  content: \"\\F1449\";\r\n}\r\n\r\n.mdi-clock-time-eleven-outline::before {\r\n  content: \"\\F1455\";\r\n}\r\n\r\n.mdi-clock-time-five::before {\r\n  content: \"\\F1443\";\r\n}\r\n\r\n.mdi-clock-time-five-outline::before {\r\n  content: \"\\F144F\";\r\n}\r\n\r\n.mdi-clock-time-four::before {\r\n  content: \"\\F1442\";\r\n}\r\n\r\n.mdi-clock-time-four-outline::before {\r\n  content: \"\\F144E\";\r\n}\r\n\r\n.mdi-clock-time-nine::before {\r\n  content: \"\\F1447\";\r\n}\r\n\r\n.mdi-clock-time-nine-outline::before {\r\n  content: \"\\F1453\";\r\n}\r\n\r\n.mdi-clock-time-one::before {\r\n  content: \"\\F143F\";\r\n}\r\n\r\n.mdi-clock-time-one-outline::before {\r\n  content: \"\\F144B\";\r\n}\r\n\r\n.mdi-clock-time-seven::before {\r\n  content: \"\\F1445\";\r\n}\r\n\r\n.mdi-clock-time-seven-outline::before {\r\n  content: \"\\F1451\";\r\n}\r\n\r\n.mdi-clock-time-six::before {\r\n  content: \"\\F1444\";\r\n}\r\n\r\n.mdi-clock-time-six-outline::before {\r\n  content: \"\\F1450\";\r\n}\r\n\r\n.mdi-clock-time-ten::before {\r\n  content: \"\\F1448\";\r\n}\r\n\r\n.mdi-clock-time-ten-outline::before {\r\n  content: \"\\F1454\";\r\n}\r\n\r\n.mdi-clock-time-three::before {\r\n  content: \"\\F1441\";\r\n}\r\n\r\n.mdi-clock-time-three-outline::before {\r\n  content: \"\\F144D\";\r\n}\r\n\r\n.mdi-clock-time-twelve::before {\r\n  content: \"\\F144A\";\r\n}\r\n\r\n.mdi-clock-time-twelve-outline::before {\r\n  content: \"\\F1456\";\r\n}\r\n\r\n.mdi-clock-time-two::before {\r\n  content: \"\\F1440\";\r\n}\r\n\r\n.mdi-clock-time-two-outline::before {\r\n  content: \"\\F144C\";\r\n}\r\n\r\n.mdi-close::before {\r\n  content: \"\\F0156\";\r\n}\r\n\r\n.mdi-close-box::before {\r\n  content: \"\\F0157\";\r\n}\r\n\r\n.mdi-close-box-multiple::before {\r\n  content: \"\\F0C5D\";\r\n}\r\n\r\n.mdi-close-box-multiple-outline::before {\r\n  content: \"\\F0C5E\";\r\n}\r\n\r\n.mdi-close-box-outline::before {\r\n  content: \"\\F0158\";\r\n}\r\n\r\n.mdi-close-circle::before {\r\n  content: \"\\F0159\";\r\n}\r\n\r\n.mdi-close-circle-multiple::before {\r\n  content: \"\\F062A\";\r\n}\r\n\r\n.mdi-close-circle-multiple-outline::before {\r\n  content: \"\\F0883\";\r\n}\r\n\r\n.mdi-close-circle-outline::before {\r\n  content: \"\\F015A\";\r\n}\r\n\r\n.mdi-close-network::before {\r\n  content: \"\\F015B\";\r\n}\r\n\r\n.mdi-close-network-outline::before {\r\n  content: \"\\F0C5F\";\r\n}\r\n\r\n.mdi-close-octagon::before {\r\n  content: \"\\F015C\";\r\n}\r\n\r\n.mdi-close-octagon-outline::before {\r\n  content: \"\\F015D\";\r\n}\r\n\r\n.mdi-close-outline::before {\r\n  content: \"\\F06C9\";\r\n}\r\n\r\n.mdi-close-thick::before {\r\n  content: \"\\F1398\";\r\n}\r\n\r\n.mdi-closed-caption::before {\r\n  content: \"\\F015E\";\r\n}\r\n\r\n.mdi-closed-caption-outline::before {\r\n  content: \"\\F0DBD\";\r\n}\r\n\r\n.mdi-cloud::before {\r\n  content: \"\\F015F\";\r\n}\r\n\r\n.mdi-cloud-alert::before {\r\n  content: \"\\F09E0\";\r\n}\r\n\r\n.mdi-cloud-braces::before {\r\n  content: \"\\F07B5\";\r\n}\r\n\r\n.mdi-cloud-check::before {\r\n  content: \"\\F0160\";\r\n}\r\n\r\n.mdi-cloud-check-outline::before {\r\n  content: \"\\F12CC\";\r\n}\r\n\r\n.mdi-cloud-circle::before {\r\n  content: \"\\F0161\";\r\n}\r\n\r\n.mdi-cloud-download::before {\r\n  content: \"\\F0162\";\r\n}\r\n\r\n.mdi-cloud-download-outline::before {\r\n  content: \"\\F0B7D\";\r\n}\r\n\r\n.mdi-cloud-lock::before {\r\n  content: \"\\F11F1\";\r\n}\r\n\r\n.mdi-cloud-lock-outline::before {\r\n  content: \"\\F11F2\";\r\n}\r\n\r\n.mdi-cloud-off-outline::before {\r\n  content: \"\\F0164\";\r\n}\r\n\r\n.mdi-cloud-outline::before {\r\n  content: \"\\F0163\";\r\n}\r\n\r\n.mdi-cloud-print::before {\r\n  content: \"\\F0165\";\r\n}\r\n\r\n.mdi-cloud-print-outline::before {\r\n  content: \"\\F0166\";\r\n}\r\n\r\n.mdi-cloud-question::before {\r\n  content: \"\\F0A39\";\r\n}\r\n\r\n.mdi-cloud-refresh::before {\r\n  content: \"\\F052A\";\r\n}\r\n\r\n.mdi-cloud-search::before {\r\n  content: \"\\F0956\";\r\n}\r\n\r\n.mdi-cloud-search-outline::before {\r\n  content: \"\\F0957\";\r\n}\r\n\r\n.mdi-cloud-sync::before {\r\n  content: \"\\F063F\";\r\n}\r\n\r\n.mdi-cloud-sync-outline::before {\r\n  content: \"\\F12D6\";\r\n}\r\n\r\n.mdi-cloud-tags::before {\r\n  content: \"\\F07B6\";\r\n}\r\n\r\n.mdi-cloud-upload::before {\r\n  content: \"\\F0167\";\r\n}\r\n\r\n.mdi-cloud-upload-outline::before {\r\n  content: \"\\F0B7E\";\r\n}\r\n\r\n.mdi-clover::before {\r\n  content: \"\\F0816\";\r\n}\r\n\r\n.mdi-coach-lamp::before {\r\n  content: \"\\F1020\";\r\n}\r\n\r\n.mdi-coat-rack::before {\r\n  content: \"\\F109E\";\r\n}\r\n\r\n.mdi-code-array::before {\r\n  content: \"\\F0168\";\r\n}\r\n\r\n.mdi-code-braces::before {\r\n  content: \"\\F0169\";\r\n}\r\n\r\n.mdi-code-braces-box::before {\r\n  content: \"\\F10D6\";\r\n}\r\n\r\n.mdi-code-brackets::before {\r\n  content: \"\\F016A\";\r\n}\r\n\r\n.mdi-code-equal::before {\r\n  content: \"\\F016B\";\r\n}\r\n\r\n.mdi-code-greater-than::before {\r\n  content: \"\\F016C\";\r\n}\r\n\r\n.mdi-code-greater-than-or-equal::before {\r\n  content: \"\\F016D\";\r\n}\r\n\r\n.mdi-code-json::before {\r\n  content: \"\\F0626\";\r\n}\r\n\r\n.mdi-code-less-than::before {\r\n  content: \"\\F016E\";\r\n}\r\n\r\n.mdi-code-less-than-or-equal::before {\r\n  content: \"\\F016F\";\r\n}\r\n\r\n.mdi-code-not-equal::before {\r\n  content: \"\\F0170\";\r\n}\r\n\r\n.mdi-code-not-equal-variant::before {\r\n  content: \"\\F0171\";\r\n}\r\n\r\n.mdi-code-parentheses::before {\r\n  content: \"\\F0172\";\r\n}\r\n\r\n.mdi-code-parentheses-box::before {\r\n  content: \"\\F10D7\";\r\n}\r\n\r\n.mdi-code-string::before {\r\n  content: \"\\F0173\";\r\n}\r\n\r\n.mdi-code-tags::before {\r\n  content: \"\\F0174\";\r\n}\r\n\r\n.mdi-code-tags-check::before {\r\n  content: \"\\F0694\";\r\n}\r\n\r\n.mdi-codepen::before {\r\n  content: \"\\F0175\";\r\n}\r\n\r\n.mdi-coffee::before {\r\n  content: \"\\F0176\";\r\n}\r\n\r\n.mdi-coffee-maker::before {\r\n  content: \"\\F109F\";\r\n}\r\n\r\n.mdi-coffee-maker-check::before {\r\n  content: \"\\F1931\";\r\n}\r\n\r\n.mdi-coffee-maker-check-outline::before {\r\n  content: \"\\F1932\";\r\n}\r\n\r\n.mdi-coffee-maker-outline::before {\r\n  content: \"\\F181B\";\r\n}\r\n\r\n.mdi-coffee-off::before {\r\n  content: \"\\F0FAA\";\r\n}\r\n\r\n.mdi-coffee-off-outline::before {\r\n  content: \"\\F0FAB\";\r\n}\r\n\r\n.mdi-coffee-outline::before {\r\n  content: \"\\F06CA\";\r\n}\r\n\r\n.mdi-coffee-to-go::before {\r\n  content: \"\\F0177\";\r\n}\r\n\r\n.mdi-coffee-to-go-outline::before {\r\n  content: \"\\F130E\";\r\n}\r\n\r\n.mdi-coffin::before {\r\n  content: \"\\F0B7F\";\r\n}\r\n\r\n.mdi-cog::before {\r\n  content: \"\\F0493\";\r\n}\r\n\r\n.mdi-cog-box::before {\r\n  content: \"\\F0494\";\r\n}\r\n\r\n.mdi-cog-clockwise::before {\r\n  content: \"\\F11DD\";\r\n}\r\n\r\n.mdi-cog-counterclockwise::before {\r\n  content: \"\\F11DE\";\r\n}\r\n\r\n.mdi-cog-off::before {\r\n  content: \"\\F13CE\";\r\n}\r\n\r\n.mdi-cog-off-outline::before {\r\n  content: \"\\F13CF\";\r\n}\r\n\r\n.mdi-cog-outline::before {\r\n  content: \"\\F08BB\";\r\n}\r\n\r\n.mdi-cog-pause::before {\r\n  content: \"\\F1933\";\r\n}\r\n\r\n.mdi-cog-pause-outline::before {\r\n  content: \"\\F1934\";\r\n}\r\n\r\n.mdi-cog-play::before {\r\n  content: \"\\F1935\";\r\n}\r\n\r\n.mdi-cog-play-outline::before {\r\n  content: \"\\F1936\";\r\n}\r\n\r\n.mdi-cog-refresh::before {\r\n  content: \"\\F145E\";\r\n}\r\n\r\n.mdi-cog-refresh-outline::before {\r\n  content: \"\\F145F\";\r\n}\r\n\r\n.mdi-cog-stop::before {\r\n  content: \"\\F1937\";\r\n}\r\n\r\n.mdi-cog-stop-outline::before {\r\n  content: \"\\F1938\";\r\n}\r\n\r\n.mdi-cog-sync::before {\r\n  content: \"\\F1460\";\r\n}\r\n\r\n.mdi-cog-sync-outline::before {\r\n  content: \"\\F1461\";\r\n}\r\n\r\n.mdi-cog-transfer::before {\r\n  content: \"\\F105B\";\r\n}\r\n\r\n.mdi-cog-transfer-outline::before {\r\n  content: \"\\F105C\";\r\n}\r\n\r\n.mdi-cogs::before {\r\n  content: \"\\F08D6\";\r\n}\r\n\r\n.mdi-collage::before {\r\n  content: \"\\F0640\";\r\n}\r\n\r\n.mdi-collapse-all::before {\r\n  content: \"\\F0AA6\";\r\n}\r\n\r\n.mdi-collapse-all-outline::before {\r\n  content: \"\\F0AA7\";\r\n}\r\n\r\n.mdi-color-helper::before {\r\n  content: \"\\F0179\";\r\n}\r\n\r\n.mdi-comma::before {\r\n  content: \"\\F0E23\";\r\n}\r\n\r\n.mdi-comma-box::before {\r\n  content: \"\\F0E2B\";\r\n}\r\n\r\n.mdi-comma-box-outline::before {\r\n  content: \"\\F0E24\";\r\n}\r\n\r\n.mdi-comma-circle::before {\r\n  content: \"\\F0E25\";\r\n}\r\n\r\n.mdi-comma-circle-outline::before {\r\n  content: \"\\F0E26\";\r\n}\r\n\r\n.mdi-comment::before {\r\n  content: \"\\F017A\";\r\n}\r\n\r\n.mdi-comment-account::before {\r\n  content: \"\\F017B\";\r\n}\r\n\r\n.mdi-comment-account-outline::before {\r\n  content: \"\\F017C\";\r\n}\r\n\r\n.mdi-comment-alert::before {\r\n  content: \"\\F017D\";\r\n}\r\n\r\n.mdi-comment-alert-outline::before {\r\n  content: \"\\F017E\";\r\n}\r\n\r\n.mdi-comment-arrow-left::before {\r\n  content: \"\\F09E1\";\r\n}\r\n\r\n.mdi-comment-arrow-left-outline::before {\r\n  content: \"\\F09E2\";\r\n}\r\n\r\n.mdi-comment-arrow-right::before {\r\n  content: \"\\F09E3\";\r\n}\r\n\r\n.mdi-comment-arrow-right-outline::before {\r\n  content: \"\\F09E4\";\r\n}\r\n\r\n.mdi-comment-bookmark::before {\r\n  content: \"\\F15AE\";\r\n}\r\n\r\n.mdi-comment-bookmark-outline::before {\r\n  content: \"\\F15AF\";\r\n}\r\n\r\n.mdi-comment-check::before {\r\n  content: \"\\F017F\";\r\n}\r\n\r\n.mdi-comment-check-outline::before {\r\n  content: \"\\F0180\";\r\n}\r\n\r\n.mdi-comment-edit::before {\r\n  content: \"\\F11BF\";\r\n}\r\n\r\n.mdi-comment-edit-outline::before {\r\n  content: \"\\F12C4\";\r\n}\r\n\r\n.mdi-comment-eye::before {\r\n  content: \"\\F0A3A\";\r\n}\r\n\r\n.mdi-comment-eye-outline::before {\r\n  content: \"\\F0A3B\";\r\n}\r\n\r\n.mdi-comment-flash::before {\r\n  content: \"\\F15B0\";\r\n}\r\n\r\n.mdi-comment-flash-outline::before {\r\n  content: \"\\F15B1\";\r\n}\r\n\r\n.mdi-comment-minus::before {\r\n  content: \"\\F15DF\";\r\n}\r\n\r\n.mdi-comment-minus-outline::before {\r\n  content: \"\\F15E0\";\r\n}\r\n\r\n.mdi-comment-multiple::before {\r\n  content: \"\\F085F\";\r\n}\r\n\r\n.mdi-comment-multiple-outline::before {\r\n  content: \"\\F0181\";\r\n}\r\n\r\n.mdi-comment-off::before {\r\n  content: \"\\F15E1\";\r\n}\r\n\r\n.mdi-comment-off-outline::before {\r\n  content: \"\\F15E2\";\r\n}\r\n\r\n.mdi-comment-outline::before {\r\n  content: \"\\F0182\";\r\n}\r\n\r\n.mdi-comment-plus::before {\r\n  content: \"\\F09E5\";\r\n}\r\n\r\n.mdi-comment-plus-outline::before {\r\n  content: \"\\F0183\";\r\n}\r\n\r\n.mdi-comment-processing::before {\r\n  content: \"\\F0184\";\r\n}\r\n\r\n.mdi-comment-processing-outline::before {\r\n  content: \"\\F0185\";\r\n}\r\n\r\n.mdi-comment-question::before {\r\n  content: \"\\F0817\";\r\n}\r\n\r\n.mdi-comment-question-outline::before {\r\n  content: \"\\F0186\";\r\n}\r\n\r\n.mdi-comment-quote::before {\r\n  content: \"\\F1021\";\r\n}\r\n\r\n.mdi-comment-quote-outline::before {\r\n  content: \"\\F1022\";\r\n}\r\n\r\n.mdi-comment-remove::before {\r\n  content: \"\\F05DE\";\r\n}\r\n\r\n.mdi-comment-remove-outline::before {\r\n  content: \"\\F0187\";\r\n}\r\n\r\n.mdi-comment-search::before {\r\n  content: \"\\F0A3C\";\r\n}\r\n\r\n.mdi-comment-search-outline::before {\r\n  content: \"\\F0A3D\";\r\n}\r\n\r\n.mdi-comment-text::before {\r\n  content: \"\\F0188\";\r\n}\r\n\r\n.mdi-comment-text-multiple::before {\r\n  content: \"\\F0860\";\r\n}\r\n\r\n.mdi-comment-text-multiple-outline::before {\r\n  content: \"\\F0861\";\r\n}\r\n\r\n.mdi-comment-text-outline::before {\r\n  content: \"\\F0189\";\r\n}\r\n\r\n.mdi-compare::before {\r\n  content: \"\\F018A\";\r\n}\r\n\r\n.mdi-compare-horizontal::before {\r\n  content: \"\\F1492\";\r\n}\r\n\r\n.mdi-compare-remove::before {\r\n  content: \"\\F18B3\";\r\n}\r\n\r\n.mdi-compare-vertical::before {\r\n  content: \"\\F1493\";\r\n}\r\n\r\n.mdi-compass::before {\r\n  content: \"\\F018B\";\r\n}\r\n\r\n.mdi-compass-off::before {\r\n  content: \"\\F0B80\";\r\n}\r\n\r\n.mdi-compass-off-outline::before {\r\n  content: \"\\F0B81\";\r\n}\r\n\r\n.mdi-compass-outline::before {\r\n  content: \"\\F018C\";\r\n}\r\n\r\n.mdi-compass-rose::before {\r\n  content: \"\\F1382\";\r\n}\r\n\r\n.mdi-cone::before {\r\n  content: \"\\F194C\";\r\n}\r\n\r\n.mdi-cone-off::before {\r\n  content: \"\\F194D\";\r\n}\r\n\r\n.mdi-connection::before {\r\n  content: \"\\F1616\";\r\n}\r\n\r\n.mdi-console::before {\r\n  content: \"\\F018D\";\r\n}\r\n\r\n.mdi-console-line::before {\r\n  content: \"\\F07B7\";\r\n}\r\n\r\n.mdi-console-network::before {\r\n  content: \"\\F08A9\";\r\n}\r\n\r\n.mdi-console-network-outline::before {\r\n  content: \"\\F0C60\";\r\n}\r\n\r\n.mdi-consolidate::before {\r\n  content: \"\\F10D8\";\r\n}\r\n\r\n.mdi-contactless-payment::before {\r\n  content: \"\\F0D6A\";\r\n}\r\n\r\n.mdi-contactless-payment-circle::before {\r\n  content: \"\\F0321\";\r\n}\r\n\r\n.mdi-contactless-payment-circle-outline::before {\r\n  content: \"\\F0408\";\r\n}\r\n\r\n.mdi-contacts::before {\r\n  content: \"\\F06CB\";\r\n}\r\n\r\n.mdi-contacts-outline::before {\r\n  content: \"\\F05B8\";\r\n}\r\n\r\n.mdi-contain::before {\r\n  content: \"\\F0A3E\";\r\n}\r\n\r\n.mdi-contain-end::before {\r\n  content: \"\\F0A3F\";\r\n}\r\n\r\n.mdi-contain-start::before {\r\n  content: \"\\F0A40\";\r\n}\r\n\r\n.mdi-content-copy::before {\r\n  content: \"\\F018F\";\r\n}\r\n\r\n.mdi-content-cut::before {\r\n  content: \"\\F0190\";\r\n}\r\n\r\n.mdi-content-duplicate::before {\r\n  content: \"\\F0191\";\r\n}\r\n\r\n.mdi-content-paste::before {\r\n  content: \"\\F0192\";\r\n}\r\n\r\n.mdi-content-save::before {\r\n  content: \"\\F0193\";\r\n}\r\n\r\n.mdi-content-save-alert::before {\r\n  content: \"\\F0F42\";\r\n}\r\n\r\n.mdi-content-save-alert-outline::before {\r\n  content: \"\\F0F43\";\r\n}\r\n\r\n.mdi-content-save-all::before {\r\n  content: \"\\F0194\";\r\n}\r\n\r\n.mdi-content-save-all-outline::before {\r\n  content: \"\\F0F44\";\r\n}\r\n\r\n.mdi-content-save-check::before {\r\n  content: \"\\F18EA\";\r\n}\r\n\r\n.mdi-content-save-check-outline::before {\r\n  content: \"\\F18EB\";\r\n}\r\n\r\n.mdi-content-save-cog::before {\r\n  content: \"\\F145B\";\r\n}\r\n\r\n.mdi-content-save-cog-outline::before {\r\n  content: \"\\F145C\";\r\n}\r\n\r\n.mdi-content-save-edit::before {\r\n  content: \"\\F0CFB\";\r\n}\r\n\r\n.mdi-content-save-edit-outline::before {\r\n  content: \"\\F0CFC\";\r\n}\r\n\r\n.mdi-content-save-move::before {\r\n  content: \"\\F0E27\";\r\n}\r\n\r\n.mdi-content-save-move-outline::before {\r\n  content: \"\\F0E28\";\r\n}\r\n\r\n.mdi-content-save-off::before {\r\n  content: \"\\F1643\";\r\n}\r\n\r\n.mdi-content-save-off-outline::before {\r\n  content: \"\\F1644\";\r\n}\r\n\r\n.mdi-content-save-outline::before {\r\n  content: \"\\F0818\";\r\n}\r\n\r\n.mdi-content-save-settings::before {\r\n  content: \"\\F061B\";\r\n}\r\n\r\n.mdi-content-save-settings-outline::before {\r\n  content: \"\\F0B2E\";\r\n}\r\n\r\n.mdi-contrast::before {\r\n  content: \"\\F0195\";\r\n}\r\n\r\n.mdi-contrast-box::before {\r\n  content: \"\\F0196\";\r\n}\r\n\r\n.mdi-contrast-circle::before {\r\n  content: \"\\F0197\";\r\n}\r\n\r\n.mdi-controller-classic::before {\r\n  content: \"\\F0B82\";\r\n}\r\n\r\n.mdi-controller-classic-outline::before {\r\n  content: \"\\F0B83\";\r\n}\r\n\r\n.mdi-cookie::before {\r\n  content: \"\\F0198\";\r\n}\r\n\r\n.mdi-cookie-alert::before {\r\n  content: \"\\F16D0\";\r\n}\r\n\r\n.mdi-cookie-alert-outline::before {\r\n  content: \"\\F16D1\";\r\n}\r\n\r\n.mdi-cookie-check::before {\r\n  content: \"\\F16D2\";\r\n}\r\n\r\n.mdi-cookie-check-outline::before {\r\n  content: \"\\F16D3\";\r\n}\r\n\r\n.mdi-cookie-clock::before {\r\n  content: \"\\F16E4\";\r\n}\r\n\r\n.mdi-cookie-clock-outline::before {\r\n  content: \"\\F16E5\";\r\n}\r\n\r\n.mdi-cookie-cog::before {\r\n  content: \"\\F16D4\";\r\n}\r\n\r\n.mdi-cookie-cog-outline::before {\r\n  content: \"\\F16D5\";\r\n}\r\n\r\n.mdi-cookie-edit::before {\r\n  content: \"\\F16E6\";\r\n}\r\n\r\n.mdi-cookie-edit-outline::before {\r\n  content: \"\\F16E7\";\r\n}\r\n\r\n.mdi-cookie-lock::before {\r\n  content: \"\\F16E8\";\r\n}\r\n\r\n.mdi-cookie-lock-outline::before {\r\n  content: \"\\F16E9\";\r\n}\r\n\r\n.mdi-cookie-minus::before {\r\n  content: \"\\F16DA\";\r\n}\r\n\r\n.mdi-cookie-minus-outline::before {\r\n  content: \"\\F16DB\";\r\n}\r\n\r\n.mdi-cookie-off::before {\r\n  content: \"\\F16EA\";\r\n}\r\n\r\n.mdi-cookie-off-outline::before {\r\n  content: \"\\F16EB\";\r\n}\r\n\r\n.mdi-cookie-outline::before {\r\n  content: \"\\F16DE\";\r\n}\r\n\r\n.mdi-cookie-plus::before {\r\n  content: \"\\F16D6\";\r\n}\r\n\r\n.mdi-cookie-plus-outline::before {\r\n  content: \"\\F16D7\";\r\n}\r\n\r\n.mdi-cookie-refresh::before {\r\n  content: \"\\F16EC\";\r\n}\r\n\r\n.mdi-cookie-refresh-outline::before {\r\n  content: \"\\F16ED\";\r\n}\r\n\r\n.mdi-cookie-remove::before {\r\n  content: \"\\F16D8\";\r\n}\r\n\r\n.mdi-cookie-remove-outline::before {\r\n  content: \"\\F16D9\";\r\n}\r\n\r\n.mdi-cookie-settings::before {\r\n  content: \"\\F16DC\";\r\n}\r\n\r\n.mdi-cookie-settings-outline::before {\r\n  content: \"\\F16DD\";\r\n}\r\n\r\n.mdi-coolant-temperature::before {\r\n  content: \"\\F03C8\";\r\n}\r\n\r\n.mdi-copyleft::before {\r\n  content: \"\\F1939\";\r\n}\r\n\r\n.mdi-copyright::before {\r\n  content: \"\\F05E6\";\r\n}\r\n\r\n.mdi-cordova::before {\r\n  content: \"\\F0958\";\r\n}\r\n\r\n.mdi-corn::before {\r\n  content: \"\\F07B8\";\r\n}\r\n\r\n.mdi-corn-off::before {\r\n  content: \"\\F13EF\";\r\n}\r\n\r\n.mdi-cosine-wave::before {\r\n  content: \"\\F1479\";\r\n}\r\n\r\n.mdi-counter::before {\r\n  content: \"\\F0199\";\r\n}\r\n\r\n.mdi-countertop::before {\r\n  content: \"\\F181C\";\r\n}\r\n\r\n.mdi-countertop-outline::before {\r\n  content: \"\\F181D\";\r\n}\r\n\r\n.mdi-cow::before {\r\n  content: \"\\F019A\";\r\n}\r\n\r\n.mdi-cow-off::before {\r\n  content: \"\\F18FC\";\r\n}\r\n\r\n.mdi-cpu-32-bit::before {\r\n  content: \"\\F0EDF\";\r\n}\r\n\r\n.mdi-cpu-64-bit::before {\r\n  content: \"\\F0EE0\";\r\n}\r\n\r\n.mdi-cradle::before {\r\n  content: \"\\F198B\";\r\n}\r\n\r\n.mdi-cradle-outline::before {\r\n  content: \"\\F1991\";\r\n}\r\n\r\n.mdi-crane::before {\r\n  content: \"\\F0862\";\r\n}\r\n\r\n.mdi-creation::before {\r\n  content: \"\\F0674\";\r\n}\r\n\r\n.mdi-creative-commons::before {\r\n  content: \"\\F0D6B\";\r\n}\r\n\r\n.mdi-credit-card::before {\r\n  content: \"\\F0FEF\";\r\n}\r\n\r\n.mdi-credit-card-check::before {\r\n  content: \"\\F13D0\";\r\n}\r\n\r\n.mdi-credit-card-check-outline::before {\r\n  content: \"\\F13D1\";\r\n}\r\n\r\n.mdi-credit-card-chip::before {\r\n  content: \"\\F190F\";\r\n}\r\n\r\n.mdi-credit-card-chip-outline::before {\r\n  content: \"\\F1910\";\r\n}\r\n\r\n.mdi-credit-card-clock::before {\r\n  content: \"\\F0EE1\";\r\n}\r\n\r\n.mdi-credit-card-clock-outline::before {\r\n  content: \"\\F0EE2\";\r\n}\r\n\r\n.mdi-credit-card-edit::before {\r\n  content: \"\\F17D7\";\r\n}\r\n\r\n.mdi-credit-card-edit-outline::before {\r\n  content: \"\\F17D8\";\r\n}\r\n\r\n.mdi-credit-card-fast::before {\r\n  content: \"\\F1911\";\r\n}\r\n\r\n.mdi-credit-card-fast-outline::before {\r\n  content: \"\\F1912\";\r\n}\r\n\r\n.mdi-credit-card-lock::before {\r\n  content: \"\\F18E7\";\r\n}\r\n\r\n.mdi-credit-card-lock-outline::before {\r\n  content: \"\\F18E8\";\r\n}\r\n\r\n.mdi-credit-card-marker::before {\r\n  content: \"\\F06A8\";\r\n}\r\n\r\n.mdi-credit-card-marker-outline::before {\r\n  content: \"\\F0DBE\";\r\n}\r\n\r\n.mdi-credit-card-minus::before {\r\n  content: \"\\F0FAC\";\r\n}\r\n\r\n.mdi-credit-card-minus-outline::before {\r\n  content: \"\\F0FAD\";\r\n}\r\n\r\n.mdi-credit-card-multiple::before {\r\n  content: \"\\F0FF0\";\r\n}\r\n\r\n.mdi-credit-card-multiple-outline::before {\r\n  content: \"\\F019C\";\r\n}\r\n\r\n.mdi-credit-card-off::before {\r\n  content: \"\\F0FF1\";\r\n}\r\n\r\n.mdi-credit-card-off-outline::before {\r\n  content: \"\\F05E4\";\r\n}\r\n\r\n.mdi-credit-card-outline::before {\r\n  content: \"\\F019B\";\r\n}\r\n\r\n.mdi-credit-card-plus::before {\r\n  content: \"\\F0FF2\";\r\n}\r\n\r\n.mdi-credit-card-plus-outline::before {\r\n  content: \"\\F0676\";\r\n}\r\n\r\n.mdi-credit-card-refresh::before {\r\n  content: \"\\F1645\";\r\n}\r\n\r\n.mdi-credit-card-refresh-outline::before {\r\n  content: \"\\F1646\";\r\n}\r\n\r\n.mdi-credit-card-refund::before {\r\n  content: \"\\F0FF3\";\r\n}\r\n\r\n.mdi-credit-card-refund-outline::before {\r\n  content: \"\\F0AA8\";\r\n}\r\n\r\n.mdi-credit-card-remove::before {\r\n  content: \"\\F0FAE\";\r\n}\r\n\r\n.mdi-credit-card-remove-outline::before {\r\n  content: \"\\F0FAF\";\r\n}\r\n\r\n.mdi-credit-card-scan::before {\r\n  content: \"\\F0FF4\";\r\n}\r\n\r\n.mdi-credit-card-scan-outline::before {\r\n  content: \"\\F019D\";\r\n}\r\n\r\n.mdi-credit-card-search::before {\r\n  content: \"\\F1647\";\r\n}\r\n\r\n.mdi-credit-card-search-outline::before {\r\n  content: \"\\F1648\";\r\n}\r\n\r\n.mdi-credit-card-settings::before {\r\n  content: \"\\F0FF5\";\r\n}\r\n\r\n.mdi-credit-card-settings-outline::before {\r\n  content: \"\\F08D7\";\r\n}\r\n\r\n.mdi-credit-card-sync::before {\r\n  content: \"\\F1649\";\r\n}\r\n\r\n.mdi-credit-card-sync-outline::before {\r\n  content: \"\\F164A\";\r\n}\r\n\r\n.mdi-credit-card-wireless::before {\r\n  content: \"\\F0802\";\r\n}\r\n\r\n.mdi-credit-card-wireless-off::before {\r\n  content: \"\\F057A\";\r\n}\r\n\r\n.mdi-credit-card-wireless-off-outline::before {\r\n  content: \"\\F057B\";\r\n}\r\n\r\n.mdi-credit-card-wireless-outline::before {\r\n  content: \"\\F0D6C\";\r\n}\r\n\r\n.mdi-cricket::before {\r\n  content: \"\\F0D6D\";\r\n}\r\n\r\n.mdi-crop::before {\r\n  content: \"\\F019E\";\r\n}\r\n\r\n.mdi-crop-free::before {\r\n  content: \"\\F019F\";\r\n}\r\n\r\n.mdi-crop-landscape::before {\r\n  content: \"\\F01A0\";\r\n}\r\n\r\n.mdi-crop-portrait::before {\r\n  content: \"\\F01A1\";\r\n}\r\n\r\n.mdi-crop-rotate::before {\r\n  content: \"\\F0696\";\r\n}\r\n\r\n.mdi-crop-square::before {\r\n  content: \"\\F01A2\";\r\n}\r\n\r\n.mdi-cross::before {\r\n  content: \"\\F0953\";\r\n}\r\n\r\n.mdi-cross-bolnisi::before {\r\n  content: \"\\F0CED\";\r\n}\r\n\r\n.mdi-cross-celtic::before {\r\n  content: \"\\F0CF5\";\r\n}\r\n\r\n.mdi-cross-outline::before {\r\n  content: \"\\F0CF6\";\r\n}\r\n\r\n.mdi-crosshairs::before {\r\n  content: \"\\F01A3\";\r\n}\r\n\r\n.mdi-crosshairs-gps::before {\r\n  content: \"\\F01A4\";\r\n}\r\n\r\n.mdi-crosshairs-off::before {\r\n  content: \"\\F0F45\";\r\n}\r\n\r\n.mdi-crosshairs-question::before {\r\n  content: \"\\F1136\";\r\n}\r\n\r\n.mdi-crowd::before {\r\n  content: \"\\F1975\";\r\n}\r\n\r\n.mdi-crown::before {\r\n  content: \"\\F01A5\";\r\n}\r\n\r\n.mdi-crown-circle::before {\r\n  content: \"\\F17DC\";\r\n}\r\n\r\n.mdi-crown-circle-outline::before {\r\n  content: \"\\F17DD\";\r\n}\r\n\r\n.mdi-crown-outline::before {\r\n  content: \"\\F11D0\";\r\n}\r\n\r\n.mdi-cryengine::before {\r\n  content: \"\\F0959\";\r\n}\r\n\r\n.mdi-crystal-ball::before {\r\n  content: \"\\F0B2F\";\r\n}\r\n\r\n.mdi-cube::before {\r\n  content: \"\\F01A6\";\r\n}\r\n\r\n.mdi-cube-off::before {\r\n  content: \"\\F141C\";\r\n}\r\n\r\n.mdi-cube-off-outline::before {\r\n  content: \"\\F141D\";\r\n}\r\n\r\n.mdi-cube-outline::before {\r\n  content: \"\\F01A7\";\r\n}\r\n\r\n.mdi-cube-scan::before {\r\n  content: \"\\F0B84\";\r\n}\r\n\r\n.mdi-cube-send::before {\r\n  content: \"\\F01A8\";\r\n}\r\n\r\n.mdi-cube-unfolded::before {\r\n  content: \"\\F01A9\";\r\n}\r\n\r\n.mdi-cup::before {\r\n  content: \"\\F01AA\";\r\n}\r\n\r\n.mdi-cup-off::before {\r\n  content: \"\\F05E5\";\r\n}\r\n\r\n.mdi-cup-off-outline::before {\r\n  content: \"\\F137D\";\r\n}\r\n\r\n.mdi-cup-outline::before {\r\n  content: \"\\F130F\";\r\n}\r\n\r\n.mdi-cup-water::before {\r\n  content: \"\\F01AB\";\r\n}\r\n\r\n.mdi-cupboard::before {\r\n  content: \"\\F0F46\";\r\n}\r\n\r\n.mdi-cupboard-outline::before {\r\n  content: \"\\F0F47\";\r\n}\r\n\r\n.mdi-cupcake::before {\r\n  content: \"\\F095A\";\r\n}\r\n\r\n.mdi-curling::before {\r\n  content: \"\\F0863\";\r\n}\r\n\r\n.mdi-currency-bdt::before {\r\n  content: \"\\F0864\";\r\n}\r\n\r\n.mdi-currency-brl::before {\r\n  content: \"\\F0B85\";\r\n}\r\n\r\n.mdi-currency-btc::before {\r\n  content: \"\\F01AC\";\r\n}\r\n\r\n.mdi-currency-cny::before {\r\n  content: \"\\F07BA\";\r\n}\r\n\r\n.mdi-currency-eth::before {\r\n  content: \"\\F07BB\";\r\n}\r\n\r\n.mdi-currency-eur::before {\r\n  content: \"\\F01AD\";\r\n}\r\n\r\n.mdi-currency-eur-off::before {\r\n  content: \"\\F1315\";\r\n}\r\n\r\n.mdi-currency-gbp::before {\r\n  content: \"\\F01AE\";\r\n}\r\n\r\n.mdi-currency-ils::before {\r\n  content: \"\\F0C61\";\r\n}\r\n\r\n.mdi-currency-inr::before {\r\n  content: \"\\F01AF\";\r\n}\r\n\r\n.mdi-currency-jpy::before {\r\n  content: \"\\F07BC\";\r\n}\r\n\r\n.mdi-currency-krw::before {\r\n  content: \"\\F07BD\";\r\n}\r\n\r\n.mdi-currency-kzt::before {\r\n  content: \"\\F0865\";\r\n}\r\n\r\n.mdi-currency-mnt::before {\r\n  content: \"\\F1512\";\r\n}\r\n\r\n.mdi-currency-ngn::before {\r\n  content: \"\\F01B0\";\r\n}\r\n\r\n.mdi-currency-php::before {\r\n  content: \"\\F09E6\";\r\n}\r\n\r\n.mdi-currency-rial::before {\r\n  content: \"\\F0E9C\";\r\n}\r\n\r\n.mdi-currency-rub::before {\r\n  content: \"\\F01B1\";\r\n}\r\n\r\n.mdi-currency-rupee::before {\r\n  content: \"\\F1976\";\r\n}\r\n\r\n.mdi-currency-sign::before {\r\n  content: \"\\F07BE\";\r\n}\r\n\r\n.mdi-currency-try::before {\r\n  content: \"\\F01B2\";\r\n}\r\n\r\n.mdi-currency-twd::before {\r\n  content: \"\\F07BF\";\r\n}\r\n\r\n.mdi-currency-usd::before {\r\n  content: \"\\F01C1\";\r\n}\r\n\r\n.mdi-currency-usd-off::before {\r\n  content: \"\\F067A\";\r\n}\r\n\r\n.mdi-current-ac::before {\r\n  content: \"\\F1480\";\r\n}\r\n\r\n.mdi-current-dc::before {\r\n  content: \"\\F095C\";\r\n}\r\n\r\n.mdi-cursor-default::before {\r\n  content: \"\\F01C0\";\r\n}\r\n\r\n.mdi-cursor-default-click::before {\r\n  content: \"\\F0CFD\";\r\n}\r\n\r\n.mdi-cursor-default-click-outline::before {\r\n  content: \"\\F0CFE\";\r\n}\r\n\r\n.mdi-cursor-default-gesture::before {\r\n  content: \"\\F1127\";\r\n}\r\n\r\n.mdi-cursor-default-gesture-outline::before {\r\n  content: \"\\F1128\";\r\n}\r\n\r\n.mdi-cursor-default-outline::before {\r\n  content: \"\\F01BF\";\r\n}\r\n\r\n.mdi-cursor-move::before {\r\n  content: \"\\F01BE\";\r\n}\r\n\r\n.mdi-cursor-pointer::before {\r\n  content: \"\\F01BD\";\r\n}\r\n\r\n.mdi-cursor-text::before {\r\n  content: \"\\F05E7\";\r\n}\r\n\r\n.mdi-curtains::before {\r\n  content: \"\\F1846\";\r\n}\r\n\r\n.mdi-curtains-closed::before {\r\n  content: \"\\F1847\";\r\n}\r\n\r\n.mdi-cylinder::before {\r\n  content: \"\\F194E\";\r\n}\r\n\r\n.mdi-cylinder-off::before {\r\n  content: \"\\F194F\";\r\n}\r\n\r\n.mdi-dance-ballroom::before {\r\n  content: \"\\F15FB\";\r\n}\r\n\r\n.mdi-dance-pole::before {\r\n  content: \"\\F1578\";\r\n}\r\n\r\n.mdi-data-matrix::before {\r\n  content: \"\\F153C\";\r\n}\r\n\r\n.mdi-data-matrix-edit::before {\r\n  content: \"\\F153D\";\r\n}\r\n\r\n.mdi-data-matrix-minus::before {\r\n  content: \"\\F153E\";\r\n}\r\n\r\n.mdi-data-matrix-plus::before {\r\n  content: \"\\F153F\";\r\n}\r\n\r\n.mdi-data-matrix-remove::before {\r\n  content: \"\\F1540\";\r\n}\r\n\r\n.mdi-data-matrix-scan::before {\r\n  content: \"\\F1541\";\r\n}\r\n\r\n.mdi-database::before {\r\n  content: \"\\F01BC\";\r\n}\r\n\r\n.mdi-database-alert::before {\r\n  content: \"\\F163A\";\r\n}\r\n\r\n.mdi-database-alert-outline::before {\r\n  content: \"\\F1624\";\r\n}\r\n\r\n.mdi-database-arrow-down::before {\r\n  content: \"\\F163B\";\r\n}\r\n\r\n.mdi-database-arrow-down-outline::before {\r\n  content: \"\\F1625\";\r\n}\r\n\r\n.mdi-database-arrow-left::before {\r\n  content: \"\\F163C\";\r\n}\r\n\r\n.mdi-database-arrow-left-outline::before {\r\n  content: \"\\F1626\";\r\n}\r\n\r\n.mdi-database-arrow-right::before {\r\n  content: \"\\F163D\";\r\n}\r\n\r\n.mdi-database-arrow-right-outline::before {\r\n  content: \"\\F1627\";\r\n}\r\n\r\n.mdi-database-arrow-up::before {\r\n  content: \"\\F163E\";\r\n}\r\n\r\n.mdi-database-arrow-up-outline::before {\r\n  content: \"\\F1628\";\r\n}\r\n\r\n.mdi-database-check::before {\r\n  content: \"\\F0AA9\";\r\n}\r\n\r\n.mdi-database-check-outline::before {\r\n  content: \"\\F1629\";\r\n}\r\n\r\n.mdi-database-clock::before {\r\n  content: \"\\F163F\";\r\n}\r\n\r\n.mdi-database-clock-outline::before {\r\n  content: \"\\F162A\";\r\n}\r\n\r\n.mdi-database-cog::before {\r\n  content: \"\\F164B\";\r\n}\r\n\r\n.mdi-database-cog-outline::before {\r\n  content: \"\\F164C\";\r\n}\r\n\r\n.mdi-database-edit::before {\r\n  content: \"\\F0B86\";\r\n}\r\n\r\n.mdi-database-edit-outline::before {\r\n  content: \"\\F162B\";\r\n}\r\n\r\n.mdi-database-export::before {\r\n  content: \"\\F095E\";\r\n}\r\n\r\n.mdi-database-export-outline::before {\r\n  content: \"\\F162C\";\r\n}\r\n\r\n.mdi-database-eye::before {\r\n  content: \"\\F191F\";\r\n}\r\n\r\n.mdi-database-eye-off::before {\r\n  content: \"\\F1920\";\r\n}\r\n\r\n.mdi-database-eye-off-outline::before {\r\n  content: \"\\F1921\";\r\n}\r\n\r\n.mdi-database-eye-outline::before {\r\n  content: \"\\F1922\";\r\n}\r\n\r\n.mdi-database-import::before {\r\n  content: \"\\F095D\";\r\n}\r\n\r\n.mdi-database-import-outline::before {\r\n  content: \"\\F162D\";\r\n}\r\n\r\n.mdi-database-lock::before {\r\n  content: \"\\F0AAA\";\r\n}\r\n\r\n.mdi-database-lock-outline::before {\r\n  content: \"\\F162E\";\r\n}\r\n\r\n.mdi-database-marker::before {\r\n  content: \"\\F12F6\";\r\n}\r\n\r\n.mdi-database-marker-outline::before {\r\n  content: \"\\F162F\";\r\n}\r\n\r\n.mdi-database-minus::before {\r\n  content: \"\\F01BB\";\r\n}\r\n\r\n.mdi-database-minus-outline::before {\r\n  content: \"\\F1630\";\r\n}\r\n\r\n.mdi-database-off::before {\r\n  content: \"\\F1640\";\r\n}\r\n\r\n.mdi-database-off-outline::before {\r\n  content: \"\\F1631\";\r\n}\r\n\r\n.mdi-database-outline::before {\r\n  content: \"\\F1632\";\r\n}\r\n\r\n.mdi-database-plus::before {\r\n  content: \"\\F01BA\";\r\n}\r\n\r\n.mdi-database-plus-outline::before {\r\n  content: \"\\F1633\";\r\n}\r\n\r\n.mdi-database-refresh::before {\r\n  content: \"\\F05C2\";\r\n}\r\n\r\n.mdi-database-refresh-outline::before {\r\n  content: \"\\F1634\";\r\n}\r\n\r\n.mdi-database-remove::before {\r\n  content: \"\\F0D00\";\r\n}\r\n\r\n.mdi-database-remove-outline::before {\r\n  content: \"\\F1635\";\r\n}\r\n\r\n.mdi-database-search::before {\r\n  content: \"\\F0866\";\r\n}\r\n\r\n.mdi-database-search-outline::before {\r\n  content: \"\\F1636\";\r\n}\r\n\r\n.mdi-database-settings::before {\r\n  content: \"\\F0D01\";\r\n}\r\n\r\n.mdi-database-settings-outline::before {\r\n  content: \"\\F1637\";\r\n}\r\n\r\n.mdi-database-sync::before {\r\n  content: \"\\F0CFF\";\r\n}\r\n\r\n.mdi-database-sync-outline::before {\r\n  content: \"\\F1638\";\r\n}\r\n\r\n.mdi-death-star::before {\r\n  content: \"\\F08D8\";\r\n}\r\n\r\n.mdi-death-star-variant::before {\r\n  content: \"\\F08D9\";\r\n}\r\n\r\n.mdi-deathly-hallows::before {\r\n  content: \"\\F0B87\";\r\n}\r\n\r\n.mdi-debian::before {\r\n  content: \"\\F08DA\";\r\n}\r\n\r\n.mdi-debug-step-into::before {\r\n  content: \"\\F01B9\";\r\n}\r\n\r\n.mdi-debug-step-out::before {\r\n  content: \"\\F01B8\";\r\n}\r\n\r\n.mdi-debug-step-over::before {\r\n  content: \"\\F01B7\";\r\n}\r\n\r\n.mdi-decagram::before {\r\n  content: \"\\F076C\";\r\n}\r\n\r\n.mdi-decagram-outline::before {\r\n  content: \"\\F076D\";\r\n}\r\n\r\n.mdi-decimal::before {\r\n  content: \"\\F10A1\";\r\n}\r\n\r\n.mdi-decimal-comma::before {\r\n  content: \"\\F10A2\";\r\n}\r\n\r\n.mdi-decimal-comma-decrease::before {\r\n  content: \"\\F10A3\";\r\n}\r\n\r\n.mdi-decimal-comma-increase::before {\r\n  content: \"\\F10A4\";\r\n}\r\n\r\n.mdi-decimal-decrease::before {\r\n  content: \"\\F01B6\";\r\n}\r\n\r\n.mdi-decimal-increase::before {\r\n  content: \"\\F01B5\";\r\n}\r\n\r\n.mdi-delete::before {\r\n  content: \"\\F01B4\";\r\n}\r\n\r\n.mdi-delete-alert::before {\r\n  content: \"\\F10A5\";\r\n}\r\n\r\n.mdi-delete-alert-outline::before {\r\n  content: \"\\F10A6\";\r\n}\r\n\r\n.mdi-delete-circle::before {\r\n  content: \"\\F0683\";\r\n}\r\n\r\n.mdi-delete-circle-outline::before {\r\n  content: \"\\F0B88\";\r\n}\r\n\r\n.mdi-delete-clock::before {\r\n  content: \"\\F1556\";\r\n}\r\n\r\n.mdi-delete-clock-outline::before {\r\n  content: \"\\F1557\";\r\n}\r\n\r\n.mdi-delete-empty::before {\r\n  content: \"\\F06CC\";\r\n}\r\n\r\n.mdi-delete-empty-outline::before {\r\n  content: \"\\F0E9D\";\r\n}\r\n\r\n.mdi-delete-forever::before {\r\n  content: \"\\F05E8\";\r\n}\r\n\r\n.mdi-delete-forever-outline::before {\r\n  content: \"\\F0B89\";\r\n}\r\n\r\n.mdi-delete-off::before {\r\n  content: \"\\F10A7\";\r\n}\r\n\r\n.mdi-delete-off-outline::before {\r\n  content: \"\\F10A8\";\r\n}\r\n\r\n.mdi-delete-outline::before {\r\n  content: \"\\F09E7\";\r\n}\r\n\r\n.mdi-delete-restore::before {\r\n  content: \"\\F0819\";\r\n}\r\n\r\n.mdi-delete-sweep::before {\r\n  content: \"\\F05E9\";\r\n}\r\n\r\n.mdi-delete-sweep-outline::before {\r\n  content: \"\\F0C62\";\r\n}\r\n\r\n.mdi-delete-variant::before {\r\n  content: \"\\F01B3\";\r\n}\r\n\r\n.mdi-delta::before {\r\n  content: \"\\F01C2\";\r\n}\r\n\r\n.mdi-desk::before {\r\n  content: \"\\F1239\";\r\n}\r\n\r\n.mdi-desk-lamp::before {\r\n  content: \"\\F095F\";\r\n}\r\n\r\n.mdi-deskphone::before {\r\n  content: \"\\F01C3\";\r\n}\r\n\r\n.mdi-desktop-classic::before {\r\n  content: \"\\F07C0\";\r\n}\r\n\r\n.mdi-desktop-mac::before {\r\n  content: \"\\F01C4\";\r\n}\r\n\r\n.mdi-desktop-mac-dashboard::before {\r\n  content: \"\\F09E8\";\r\n}\r\n\r\n.mdi-desktop-tower::before {\r\n  content: \"\\F01C5\";\r\n}\r\n\r\n.mdi-desktop-tower-monitor::before {\r\n  content: \"\\F0AAB\";\r\n}\r\n\r\n.mdi-details::before {\r\n  content: \"\\F01C6\";\r\n}\r\n\r\n.mdi-dev-to::before {\r\n  content: \"\\F0D6E\";\r\n}\r\n\r\n.mdi-developer-board::before {\r\n  content: \"\\F0697\";\r\n}\r\n\r\n.mdi-deviantart::before {\r\n  content: \"\\F01C7\";\r\n}\r\n\r\n.mdi-devices::before {\r\n  content: \"\\F0FB0\";\r\n}\r\n\r\n.mdi-dharmachakra::before {\r\n  content: \"\\F094B\";\r\n}\r\n\r\n.mdi-diabetes::before {\r\n  content: \"\\F1126\";\r\n}\r\n\r\n.mdi-dialpad::before {\r\n  content: \"\\F061C\";\r\n}\r\n\r\n.mdi-diameter::before {\r\n  content: \"\\F0C63\";\r\n}\r\n\r\n.mdi-diameter-outline::before {\r\n  content: \"\\F0C64\";\r\n}\r\n\r\n.mdi-diameter-variant::before {\r\n  content: \"\\F0C65\";\r\n}\r\n\r\n.mdi-diamond::before {\r\n  content: \"\\F0B8A\";\r\n}\r\n\r\n.mdi-diamond-outline::before {\r\n  content: \"\\F0B8B\";\r\n}\r\n\r\n.mdi-diamond-stone::before {\r\n  content: \"\\F01C8\";\r\n}\r\n\r\n.mdi-dice-1::before {\r\n  content: \"\\F01CA\";\r\n}\r\n\r\n.mdi-dice-1-outline::before {\r\n  content: \"\\F114A\";\r\n}\r\n\r\n.mdi-dice-2::before {\r\n  content: \"\\F01CB\";\r\n}\r\n\r\n.mdi-dice-2-outline::before {\r\n  content: \"\\F114B\";\r\n}\r\n\r\n.mdi-dice-3::before {\r\n  content: \"\\F01CC\";\r\n}\r\n\r\n.mdi-dice-3-outline::before {\r\n  content: \"\\F114C\";\r\n}\r\n\r\n.mdi-dice-4::before {\r\n  content: \"\\F01CD\";\r\n}\r\n\r\n.mdi-dice-4-outline::before {\r\n  content: \"\\F114D\";\r\n}\r\n\r\n.mdi-dice-5::before {\r\n  content: \"\\F01CE\";\r\n}\r\n\r\n.mdi-dice-5-outline::before {\r\n  content: \"\\F114E\";\r\n}\r\n\r\n.mdi-dice-6::before {\r\n  content: \"\\F01CF\";\r\n}\r\n\r\n.mdi-dice-6-outline::before {\r\n  content: \"\\F114F\";\r\n}\r\n\r\n.mdi-dice-d10::before {\r\n  content: \"\\F1153\";\r\n}\r\n\r\n.mdi-dice-d10-outline::before {\r\n  content: \"\\F076F\";\r\n}\r\n\r\n.mdi-dice-d12::before {\r\n  content: \"\\F1154\";\r\n}\r\n\r\n.mdi-dice-d12-outline::before {\r\n  content: \"\\F0867\";\r\n}\r\n\r\n.mdi-dice-d20::before {\r\n  content: \"\\F1155\";\r\n}\r\n\r\n.mdi-dice-d20-outline::before {\r\n  content: \"\\F05EA\";\r\n}\r\n\r\n.mdi-dice-d4::before {\r\n  content: \"\\F1150\";\r\n}\r\n\r\n.mdi-dice-d4-outline::before {\r\n  content: \"\\F05EB\";\r\n}\r\n\r\n.mdi-dice-d6::before {\r\n  content: \"\\F1151\";\r\n}\r\n\r\n.mdi-dice-d6-outline::before {\r\n  content: \"\\F05ED\";\r\n}\r\n\r\n.mdi-dice-d8::before {\r\n  content: \"\\F1152\";\r\n}\r\n\r\n.mdi-dice-d8-outline::before {\r\n  content: \"\\F05EC\";\r\n}\r\n\r\n.mdi-dice-multiple::before {\r\n  content: \"\\F076E\";\r\n}\r\n\r\n.mdi-dice-multiple-outline::before {\r\n  content: \"\\F1156\";\r\n}\r\n\r\n.mdi-digital-ocean::before {\r\n  content: \"\\F1237\";\r\n}\r\n\r\n.mdi-dip-switch::before {\r\n  content: \"\\F07C1\";\r\n}\r\n\r\n.mdi-directions::before {\r\n  content: \"\\F01D0\";\r\n}\r\n\r\n.mdi-directions-fork::before {\r\n  content: \"\\F0641\";\r\n}\r\n\r\n.mdi-disc::before {\r\n  content: \"\\F05EE\";\r\n}\r\n\r\n.mdi-disc-alert::before {\r\n  content: \"\\F01D1\";\r\n}\r\n\r\n.mdi-disc-player::before {\r\n  content: \"\\F0960\";\r\n}\r\n\r\n.mdi-discord::before {\r\n  content: \"\\F066F\";\r\n}\r\n\r\n.mdi-dishwasher::before {\r\n  content: \"\\F0AAC\";\r\n}\r\n\r\n.mdi-dishwasher-alert::before {\r\n  content: \"\\F11B8\";\r\n}\r\n\r\n.mdi-dishwasher-off::before {\r\n  content: \"\\F11B9\";\r\n}\r\n\r\n.mdi-disqus::before {\r\n  content: \"\\F01D2\";\r\n}\r\n\r\n.mdi-distribute-horizontal-center::before {\r\n  content: \"\\F11C9\";\r\n}\r\n\r\n.mdi-distribute-horizontal-left::before {\r\n  content: \"\\F11C8\";\r\n}\r\n\r\n.mdi-distribute-horizontal-right::before {\r\n  content: \"\\F11CA\";\r\n}\r\n\r\n.mdi-distribute-vertical-bottom::before {\r\n  content: \"\\F11CB\";\r\n}\r\n\r\n.mdi-distribute-vertical-center::before {\r\n  content: \"\\F11CC\";\r\n}\r\n\r\n.mdi-distribute-vertical-top::before {\r\n  content: \"\\F11CD\";\r\n}\r\n\r\n.mdi-diversify::before {\r\n  content: \"\\F1877\";\r\n}\r\n\r\n.mdi-diving::before {\r\n  content: \"\\F1977\";\r\n}\r\n\r\n.mdi-diving-flippers::before {\r\n  content: \"\\F0DBF\";\r\n}\r\n\r\n.mdi-diving-helmet::before {\r\n  content: \"\\F0DC0\";\r\n}\r\n\r\n.mdi-diving-scuba::before {\r\n  content: \"\\F0DC1\";\r\n}\r\n\r\n.mdi-diving-scuba-flag::before {\r\n  content: \"\\F0DC2\";\r\n}\r\n\r\n.mdi-diving-scuba-tank::before {\r\n  content: \"\\F0DC3\";\r\n}\r\n\r\n.mdi-diving-scuba-tank-multiple::before {\r\n  content: \"\\F0DC4\";\r\n}\r\n\r\n.mdi-diving-snorkel::before {\r\n  content: \"\\F0DC5\";\r\n}\r\n\r\n.mdi-division::before {\r\n  content: \"\\F01D4\";\r\n}\r\n\r\n.mdi-division-box::before {\r\n  content: \"\\F01D5\";\r\n}\r\n\r\n.mdi-dlna::before {\r\n  content: \"\\F0A41\";\r\n}\r\n\r\n.mdi-dna::before {\r\n  content: \"\\F0684\";\r\n}\r\n\r\n.mdi-dns::before {\r\n  content: \"\\F01D6\";\r\n}\r\n\r\n.mdi-dns-outline::before {\r\n  content: \"\\F0B8C\";\r\n}\r\n\r\n.mdi-dock-bottom::before {\r\n  content: \"\\F10A9\";\r\n}\r\n\r\n.mdi-dock-left::before {\r\n  content: \"\\F10AA\";\r\n}\r\n\r\n.mdi-dock-right::before {\r\n  content: \"\\F10AB\";\r\n}\r\n\r\n.mdi-dock-top::before {\r\n  content: \"\\F1513\";\r\n}\r\n\r\n.mdi-dock-window::before {\r\n  content: \"\\F10AC\";\r\n}\r\n\r\n.mdi-docker::before {\r\n  content: \"\\F0868\";\r\n}\r\n\r\n.mdi-doctor::before {\r\n  content: \"\\F0A42\";\r\n}\r\n\r\n.mdi-dog::before {\r\n  content: \"\\F0A43\";\r\n}\r\n\r\n.mdi-dog-service::before {\r\n  content: \"\\F0AAD\";\r\n}\r\n\r\n.mdi-dog-side::before {\r\n  content: \"\\F0A44\";\r\n}\r\n\r\n.mdi-dog-side-off::before {\r\n  content: \"\\F16EE\";\r\n}\r\n\r\n.mdi-dolby::before {\r\n  content: \"\\F06B3\";\r\n}\r\n\r\n.mdi-dolly::before {\r\n  content: \"\\F0E9E\";\r\n}\r\n\r\n.mdi-dolphin::before {\r\n  content: \"\\F18B4\";\r\n}\r\n\r\n.mdi-domain::before {\r\n  content: \"\\F01D7\";\r\n}\r\n\r\n.mdi-domain-off::before {\r\n  content: \"\\F0D6F\";\r\n}\r\n\r\n.mdi-domain-plus::before {\r\n  content: \"\\F10AD\";\r\n}\r\n\r\n.mdi-domain-remove::before {\r\n  content: \"\\F10AE\";\r\n}\r\n\r\n.mdi-dome-light::before {\r\n  content: \"\\F141E\";\r\n}\r\n\r\n.mdi-domino-mask::before {\r\n  content: \"\\F1023\";\r\n}\r\n\r\n.mdi-donkey::before {\r\n  content: \"\\F07C2\";\r\n}\r\n\r\n.mdi-door::before {\r\n  content: \"\\F081A\";\r\n}\r\n\r\n.mdi-door-closed::before {\r\n  content: \"\\F081B\";\r\n}\r\n\r\n.mdi-door-closed-lock::before {\r\n  content: \"\\F10AF\";\r\n}\r\n\r\n.mdi-door-open::before {\r\n  content: \"\\F081C\";\r\n}\r\n\r\n.mdi-door-sliding::before {\r\n  content: \"\\F181E\";\r\n}\r\n\r\n.mdi-door-sliding-lock::before {\r\n  content: \"\\F181F\";\r\n}\r\n\r\n.mdi-door-sliding-open::before {\r\n  content: \"\\F1820\";\r\n}\r\n\r\n.mdi-doorbell::before {\r\n  content: \"\\F12E6\";\r\n}\r\n\r\n.mdi-doorbell-video::before {\r\n  content: \"\\F0869\";\r\n}\r\n\r\n.mdi-dot-net::before {\r\n  content: \"\\F0AAE\";\r\n}\r\n\r\n.mdi-dots-circle::before {\r\n  content: \"\\F1978\";\r\n}\r\n\r\n.mdi-dots-grid::before {\r\n  content: \"\\F15FC\";\r\n}\r\n\r\n.mdi-dots-hexagon::before {\r\n  content: \"\\F15FF\";\r\n}\r\n\r\n.mdi-dots-horizontal::before {\r\n  content: \"\\F01D8\";\r\n}\r\n\r\n.mdi-dots-horizontal-circle::before {\r\n  content: \"\\F07C3\";\r\n}\r\n\r\n.mdi-dots-horizontal-circle-outline::before {\r\n  content: \"\\F0B8D\";\r\n}\r\n\r\n.mdi-dots-square::before {\r\n  content: \"\\F15FD\";\r\n}\r\n\r\n.mdi-dots-triangle::before {\r\n  content: \"\\F15FE\";\r\n}\r\n\r\n.mdi-dots-vertical::before {\r\n  content: \"\\F01D9\";\r\n}\r\n\r\n.mdi-dots-vertical-circle::before {\r\n  content: \"\\F07C4\";\r\n}\r\n\r\n.mdi-dots-vertical-circle-outline::before {\r\n  content: \"\\F0B8E\";\r\n}\r\n\r\n.mdi-download::before {\r\n  content: \"\\F01DA\";\r\n}\r\n\r\n.mdi-download-box::before {\r\n  content: \"\\F1462\";\r\n}\r\n\r\n.mdi-download-box-outline::before {\r\n  content: \"\\F1463\";\r\n}\r\n\r\n.mdi-download-circle::before {\r\n  content: \"\\F1464\";\r\n}\r\n\r\n.mdi-download-circle-outline::before {\r\n  content: \"\\F1465\";\r\n}\r\n\r\n.mdi-download-lock::before {\r\n  content: \"\\F1320\";\r\n}\r\n\r\n.mdi-download-lock-outline::before {\r\n  content: \"\\F1321\";\r\n}\r\n\r\n.mdi-download-multiple::before {\r\n  content: \"\\F09E9\";\r\n}\r\n\r\n.mdi-download-network::before {\r\n  content: \"\\F06F4\";\r\n}\r\n\r\n.mdi-download-network-outline::before {\r\n  content: \"\\F0C66\";\r\n}\r\n\r\n.mdi-download-off::before {\r\n  content: \"\\F10B0\";\r\n}\r\n\r\n.mdi-download-off-outline::before {\r\n  content: \"\\F10B1\";\r\n}\r\n\r\n.mdi-download-outline::before {\r\n  content: \"\\F0B8F\";\r\n}\r\n\r\n.mdi-drag::before {\r\n  content: \"\\F01DB\";\r\n}\r\n\r\n.mdi-drag-horizontal::before {\r\n  content: \"\\F01DC\";\r\n}\r\n\r\n.mdi-drag-horizontal-variant::before {\r\n  content: \"\\F12F0\";\r\n}\r\n\r\n.mdi-drag-variant::before {\r\n  content: \"\\F0B90\";\r\n}\r\n\r\n.mdi-drag-vertical::before {\r\n  content: \"\\F01DD\";\r\n}\r\n\r\n.mdi-drag-vertical-variant::before {\r\n  content: \"\\F12F1\";\r\n}\r\n\r\n.mdi-drama-masks::before {\r\n  content: \"\\F0D02\";\r\n}\r\n\r\n.mdi-draw::before {\r\n  content: \"\\F0F49\";\r\n}\r\n\r\n.mdi-draw-pen::before {\r\n  content: \"\\F19B9\";\r\n}\r\n\r\n.mdi-drawing::before {\r\n  content: \"\\F01DE\";\r\n}\r\n\r\n.mdi-drawing-box::before {\r\n  content: \"\\F01DF\";\r\n}\r\n\r\n.mdi-dresser::before {\r\n  content: \"\\F0F4A\";\r\n}\r\n\r\n.mdi-dresser-outline::before {\r\n  content: \"\\F0F4B\";\r\n}\r\n\r\n.mdi-drone::before {\r\n  content: \"\\F01E2\";\r\n}\r\n\r\n.mdi-dropbox::before {\r\n  content: \"\\F01E3\";\r\n}\r\n\r\n.mdi-drupal::before {\r\n  content: \"\\F01E4\";\r\n}\r\n\r\n.mdi-duck::before {\r\n  content: \"\\F01E5\";\r\n}\r\n\r\n.mdi-dumbbell::before {\r\n  content: \"\\F01E6\";\r\n}\r\n\r\n.mdi-dump-truck::before {\r\n  content: \"\\F0C67\";\r\n}\r\n\r\n.mdi-ear-hearing::before {\r\n  content: \"\\F07C5\";\r\n}\r\n\r\n.mdi-ear-hearing-off::before {\r\n  content: \"\\F0A45\";\r\n}\r\n\r\n.mdi-earbuds::before {\r\n  content: \"\\F184F\";\r\n}\r\n\r\n.mdi-earbuds-off::before {\r\n  content: \"\\F1850\";\r\n}\r\n\r\n.mdi-earbuds-off-outline::before {\r\n  content: \"\\F1851\";\r\n}\r\n\r\n.mdi-earbuds-outline::before {\r\n  content: \"\\F1852\";\r\n}\r\n\r\n.mdi-earth::before {\r\n  content: \"\\F01E7\";\r\n}\r\n\r\n.mdi-earth-arrow-right::before {\r\n  content: \"\\F1311\";\r\n}\r\n\r\n.mdi-earth-box::before {\r\n  content: \"\\F06CD\";\r\n}\r\n\r\n.mdi-earth-box-minus::before {\r\n  content: \"\\F1407\";\r\n}\r\n\r\n.mdi-earth-box-off::before {\r\n  content: \"\\F06CE\";\r\n}\r\n\r\n.mdi-earth-box-plus::before {\r\n  content: \"\\F1406\";\r\n}\r\n\r\n.mdi-earth-box-remove::before {\r\n  content: \"\\F1408\";\r\n}\r\n\r\n.mdi-earth-minus::before {\r\n  content: \"\\F1404\";\r\n}\r\n\r\n.mdi-earth-off::before {\r\n  content: \"\\F01E8\";\r\n}\r\n\r\n.mdi-earth-plus::before {\r\n  content: \"\\F1403\";\r\n}\r\n\r\n.mdi-earth-remove::before {\r\n  content: \"\\F1405\";\r\n}\r\n\r\n.mdi-egg::before {\r\n  content: \"\\F0AAF\";\r\n}\r\n\r\n.mdi-egg-easter::before {\r\n  content: \"\\F0AB0\";\r\n}\r\n\r\n.mdi-egg-fried::before {\r\n  content: \"\\F184A\";\r\n}\r\n\r\n.mdi-egg-off::before {\r\n  content: \"\\F13F0\";\r\n}\r\n\r\n.mdi-egg-off-outline::before {\r\n  content: \"\\F13F1\";\r\n}\r\n\r\n.mdi-egg-outline::before {\r\n  content: \"\\F13F2\";\r\n}\r\n\r\n.mdi-eiffel-tower::before {\r\n  content: \"\\F156B\";\r\n}\r\n\r\n.mdi-eight-track::before {\r\n  content: \"\\F09EA\";\r\n}\r\n\r\n.mdi-eject::before {\r\n  content: \"\\F01EA\";\r\n}\r\n\r\n.mdi-eject-outline::before {\r\n  content: \"\\F0B91\";\r\n}\r\n\r\n.mdi-electric-switch::before {\r\n  content: \"\\F0E9F\";\r\n}\r\n\r\n.mdi-electric-switch-closed::before {\r\n  content: \"\\F10D9\";\r\n}\r\n\r\n.mdi-electron-framework::before {\r\n  content: \"\\F1024\";\r\n}\r\n\r\n.mdi-elephant::before {\r\n  content: \"\\F07C6\";\r\n}\r\n\r\n.mdi-elevation-decline::before {\r\n  content: \"\\F01EB\";\r\n}\r\n\r\n.mdi-elevation-rise::before {\r\n  content: \"\\F01EC\";\r\n}\r\n\r\n.mdi-elevator::before {\r\n  content: \"\\F01ED\";\r\n}\r\n\r\n.mdi-elevator-down::before {\r\n  content: \"\\F12C2\";\r\n}\r\n\r\n.mdi-elevator-passenger::before {\r\n  content: \"\\F1381\";\r\n}\r\n\r\n.mdi-elevator-passenger-off::before {\r\n  content: \"\\F1979\";\r\n}\r\n\r\n.mdi-elevator-passenger-off-outline::before {\r\n  content: \"\\F197A\";\r\n}\r\n\r\n.mdi-elevator-passenger-outline::before {\r\n  content: \"\\F197B\";\r\n}\r\n\r\n.mdi-elevator-up::before {\r\n  content: \"\\F12C1\";\r\n}\r\n\r\n.mdi-ellipse::before {\r\n  content: \"\\F0EA0\";\r\n}\r\n\r\n.mdi-ellipse-outline::before {\r\n  content: \"\\F0EA1\";\r\n}\r\n\r\n.mdi-email::before {\r\n  content: \"\\F01EE\";\r\n}\r\n\r\n.mdi-email-alert::before {\r\n  content: \"\\F06CF\";\r\n}\r\n\r\n.mdi-email-alert-outline::before {\r\n  content: \"\\F0D42\";\r\n}\r\n\r\n.mdi-email-box::before {\r\n  content: \"\\F0D03\";\r\n}\r\n\r\n.mdi-email-check::before {\r\n  content: \"\\F0AB1\";\r\n}\r\n\r\n.mdi-email-check-outline::before {\r\n  content: \"\\F0AB2\";\r\n}\r\n\r\n.mdi-email-edit::before {\r\n  content: \"\\F0EE3\";\r\n}\r\n\r\n.mdi-email-edit-outline::before {\r\n  content: \"\\F0EE4\";\r\n}\r\n\r\n.mdi-email-fast::before {\r\n  content: \"\\F186F\";\r\n}\r\n\r\n.mdi-email-fast-outline::before {\r\n  content: \"\\F1870\";\r\n}\r\n\r\n.mdi-email-lock::before {\r\n  content: \"\\F01F1\";\r\n}\r\n\r\n.mdi-email-mark-as-unread::before {\r\n  content: \"\\F0B92\";\r\n}\r\n\r\n.mdi-email-minus::before {\r\n  content: \"\\F0EE5\";\r\n}\r\n\r\n.mdi-email-minus-outline::before {\r\n  content: \"\\F0EE6\";\r\n}\r\n\r\n.mdi-email-multiple::before {\r\n  content: \"\\F0EE7\";\r\n}\r\n\r\n.mdi-email-multiple-outline::before {\r\n  content: \"\\F0EE8\";\r\n}\r\n\r\n.mdi-email-newsletter::before {\r\n  content: \"\\F0FB1\";\r\n}\r\n\r\n.mdi-email-off::before {\r\n  content: \"\\F13E3\";\r\n}\r\n\r\n.mdi-email-off-outline::before {\r\n  content: \"\\F13E4\";\r\n}\r\n\r\n.mdi-email-open::before {\r\n  content: \"\\F01EF\";\r\n}\r\n\r\n.mdi-email-open-multiple::before {\r\n  content: \"\\F0EE9\";\r\n}\r\n\r\n.mdi-email-open-multiple-outline::before {\r\n  content: \"\\F0EEA\";\r\n}\r\n\r\n.mdi-email-open-outline::before {\r\n  content: \"\\F05EF\";\r\n}\r\n\r\n.mdi-email-outline::before {\r\n  content: \"\\F01F0\";\r\n}\r\n\r\n.mdi-email-plus::before {\r\n  content: \"\\F09EB\";\r\n}\r\n\r\n.mdi-email-plus-outline::before {\r\n  content: \"\\F09EC\";\r\n}\r\n\r\n.mdi-email-receive::before {\r\n  content: \"\\F10DA\";\r\n}\r\n\r\n.mdi-email-receive-outline::before {\r\n  content: \"\\F10DB\";\r\n}\r\n\r\n.mdi-email-remove::before {\r\n  content: \"\\F1661\";\r\n}\r\n\r\n.mdi-email-remove-outline::before {\r\n  content: \"\\F1662\";\r\n}\r\n\r\n.mdi-email-seal::before {\r\n  content: \"\\F195B\";\r\n}\r\n\r\n.mdi-email-seal-outline::before {\r\n  content: \"\\F195C\";\r\n}\r\n\r\n.mdi-email-search::before {\r\n  content: \"\\F0961\";\r\n}\r\n\r\n.mdi-email-search-outline::before {\r\n  content: \"\\F0962\";\r\n}\r\n\r\n.mdi-email-send::before {\r\n  content: \"\\F10DC\";\r\n}\r\n\r\n.mdi-email-send-outline::before {\r\n  content: \"\\F10DD\";\r\n}\r\n\r\n.mdi-email-sync::before {\r\n  content: \"\\F12C7\";\r\n}\r\n\r\n.mdi-email-sync-outline::before {\r\n  content: \"\\F12C8\";\r\n}\r\n\r\n.mdi-email-variant::before {\r\n  content: \"\\F05F0\";\r\n}\r\n\r\n.mdi-ember::before {\r\n  content: \"\\F0B30\";\r\n}\r\n\r\n.mdi-emby::before {\r\n  content: \"\\F06B4\";\r\n}\r\n\r\n.mdi-emoticon::before {\r\n  content: \"\\F0C68\";\r\n}\r\n\r\n.mdi-emoticon-angry::before {\r\n  content: \"\\F0C69\";\r\n}\r\n\r\n.mdi-emoticon-angry-outline::before {\r\n  content: \"\\F0C6A\";\r\n}\r\n\r\n.mdi-emoticon-confused::before {\r\n  content: \"\\F10DE\";\r\n}\r\n\r\n.mdi-emoticon-confused-outline::before {\r\n  content: \"\\F10DF\";\r\n}\r\n\r\n.mdi-emoticon-cool::before {\r\n  content: \"\\F0C6B\";\r\n}\r\n\r\n.mdi-emoticon-cool-outline::before {\r\n  content: \"\\F01F3\";\r\n}\r\n\r\n.mdi-emoticon-cry::before {\r\n  content: \"\\F0C6C\";\r\n}\r\n\r\n.mdi-emoticon-cry-outline::before {\r\n  content: \"\\F0C6D\";\r\n}\r\n\r\n.mdi-emoticon-dead::before {\r\n  content: \"\\F0C6E\";\r\n}\r\n\r\n.mdi-emoticon-dead-outline::before {\r\n  content: \"\\F069B\";\r\n}\r\n\r\n.mdi-emoticon-devil::before {\r\n  content: \"\\F0C6F\";\r\n}\r\n\r\n.mdi-emoticon-devil-outline::before {\r\n  content: \"\\F01F4\";\r\n}\r\n\r\n.mdi-emoticon-excited::before {\r\n  content: \"\\F0C70\";\r\n}\r\n\r\n.mdi-emoticon-excited-outline::before {\r\n  content: \"\\F069C\";\r\n}\r\n\r\n.mdi-emoticon-frown::before {\r\n  content: \"\\F0F4C\";\r\n}\r\n\r\n.mdi-emoticon-frown-outline::before {\r\n  content: \"\\F0F4D\";\r\n}\r\n\r\n.mdi-emoticon-happy::before {\r\n  content: \"\\F0C71\";\r\n}\r\n\r\n.mdi-emoticon-happy-outline::before {\r\n  content: \"\\F01F5\";\r\n}\r\n\r\n.mdi-emoticon-kiss::before {\r\n  content: \"\\F0C72\";\r\n}\r\n\r\n.mdi-emoticon-kiss-outline::before {\r\n  content: \"\\F0C73\";\r\n}\r\n\r\n.mdi-emoticon-lol::before {\r\n  content: \"\\F1214\";\r\n}\r\n\r\n.mdi-emoticon-lol-outline::before {\r\n  content: \"\\F1215\";\r\n}\r\n\r\n.mdi-emoticon-neutral::before {\r\n  content: \"\\F0C74\";\r\n}\r\n\r\n.mdi-emoticon-neutral-outline::before {\r\n  content: \"\\F01F6\";\r\n}\r\n\r\n.mdi-emoticon-outline::before {\r\n  content: \"\\F01F2\";\r\n}\r\n\r\n.mdi-emoticon-poop::before {\r\n  content: \"\\F01F7\";\r\n}\r\n\r\n.mdi-emoticon-poop-outline::before {\r\n  content: \"\\F0C75\";\r\n}\r\n\r\n.mdi-emoticon-sad::before {\r\n  content: \"\\F0C76\";\r\n}\r\n\r\n.mdi-emoticon-sad-outline::before {\r\n  content: \"\\F01F8\";\r\n}\r\n\r\n.mdi-emoticon-sick::before {\r\n  content: \"\\F157C\";\r\n}\r\n\r\n.mdi-emoticon-sick-outline::before {\r\n  content: \"\\F157D\";\r\n}\r\n\r\n.mdi-emoticon-tongue::before {\r\n  content: \"\\F01F9\";\r\n}\r\n\r\n.mdi-emoticon-tongue-outline::before {\r\n  content: \"\\F0C77\";\r\n}\r\n\r\n.mdi-emoticon-wink::before {\r\n  content: \"\\F0C78\";\r\n}\r\n\r\n.mdi-emoticon-wink-outline::before {\r\n  content: \"\\F0C79\";\r\n}\r\n\r\n.mdi-engine::before {\r\n  content: \"\\F01FA\";\r\n}\r\n\r\n.mdi-engine-off::before {\r\n  content: \"\\F0A46\";\r\n}\r\n\r\n.mdi-engine-off-outline::before {\r\n  content: \"\\F0A47\";\r\n}\r\n\r\n.mdi-engine-outline::before {\r\n  content: \"\\F01FB\";\r\n}\r\n\r\n.mdi-epsilon::before {\r\n  content: \"\\F10E0\";\r\n}\r\n\r\n.mdi-equal::before {\r\n  content: \"\\F01FC\";\r\n}\r\n\r\n.mdi-equal-box::before {\r\n  content: \"\\F01FD\";\r\n}\r\n\r\n.mdi-equalizer::before {\r\n  content: \"\\F0EA2\";\r\n}\r\n\r\n.mdi-equalizer-outline::before {\r\n  content: \"\\F0EA3\";\r\n}\r\n\r\n.mdi-eraser::before {\r\n  content: \"\\F01FE\";\r\n}\r\n\r\n.mdi-eraser-variant::before {\r\n  content: \"\\F0642\";\r\n}\r\n\r\n.mdi-escalator::before {\r\n  content: \"\\F01FF\";\r\n}\r\n\r\n.mdi-escalator-box::before {\r\n  content: \"\\F1399\";\r\n}\r\n\r\n.mdi-escalator-down::before {\r\n  content: \"\\F12C0\";\r\n}\r\n\r\n.mdi-escalator-up::before {\r\n  content: \"\\F12BF\";\r\n}\r\n\r\n.mdi-eslint::before {\r\n  content: \"\\F0C7A\";\r\n}\r\n\r\n.mdi-et::before {\r\n  content: \"\\F0AB3\";\r\n}\r\n\r\n.mdi-ethereum::before {\r\n  content: \"\\F086A\";\r\n}\r\n\r\n.mdi-ethernet::before {\r\n  content: \"\\F0200\";\r\n}\r\n\r\n.mdi-ethernet-cable::before {\r\n  content: \"\\F0201\";\r\n}\r\n\r\n.mdi-ethernet-cable-off::before {\r\n  content: \"\\F0202\";\r\n}\r\n\r\n.mdi-ev-plug-ccs1::before {\r\n  content: \"\\F1519\";\r\n}\r\n\r\n.mdi-ev-plug-ccs2::before {\r\n  content: \"\\F151A\";\r\n}\r\n\r\n.mdi-ev-plug-chademo::before {\r\n  content: \"\\F151B\";\r\n}\r\n\r\n.mdi-ev-plug-tesla::before {\r\n  content: \"\\F151C\";\r\n}\r\n\r\n.mdi-ev-plug-type1::before {\r\n  content: \"\\F151D\";\r\n}\r\n\r\n.mdi-ev-plug-type2::before {\r\n  content: \"\\F151E\";\r\n}\r\n\r\n.mdi-ev-station::before {\r\n  content: \"\\F05F1\";\r\n}\r\n\r\n.mdi-evernote::before {\r\n  content: \"\\F0204\";\r\n}\r\n\r\n.mdi-excavator::before {\r\n  content: \"\\F1025\";\r\n}\r\n\r\n.mdi-exclamation::before {\r\n  content: \"\\F0205\";\r\n}\r\n\r\n.mdi-exclamation-thick::before {\r\n  content: \"\\F1238\";\r\n}\r\n\r\n.mdi-exit-run::before {\r\n  content: \"\\F0A48\";\r\n}\r\n\r\n.mdi-exit-to-app::before {\r\n  content: \"\\F0206\";\r\n}\r\n\r\n.mdi-expand-all::before {\r\n  content: \"\\F0AB4\";\r\n}\r\n\r\n.mdi-expand-all-outline::before {\r\n  content: \"\\F0AB5\";\r\n}\r\n\r\n.mdi-expansion-card::before {\r\n  content: \"\\F08AE\";\r\n}\r\n\r\n.mdi-expansion-card-variant::before {\r\n  content: \"\\F0FB2\";\r\n}\r\n\r\n.mdi-exponent::before {\r\n  content: \"\\F0963\";\r\n}\r\n\r\n.mdi-exponent-box::before {\r\n  content: \"\\F0964\";\r\n}\r\n\r\n.mdi-export::before {\r\n  content: \"\\F0207\";\r\n}\r\n\r\n.mdi-export-variant::before {\r\n  content: \"\\F0B93\";\r\n}\r\n\r\n.mdi-eye::before {\r\n  content: \"\\F0208\";\r\n}\r\n\r\n.mdi-eye-arrow-left::before {\r\n  content: \"\\F18FD\";\r\n}\r\n\r\n.mdi-eye-arrow-left-outline::before {\r\n  content: \"\\F18FE\";\r\n}\r\n\r\n.mdi-eye-arrow-right::before {\r\n  content: \"\\F18FF\";\r\n}\r\n\r\n.mdi-eye-arrow-right-outline::before {\r\n  content: \"\\F1900\";\r\n}\r\n\r\n.mdi-eye-check::before {\r\n  content: \"\\F0D04\";\r\n}\r\n\r\n.mdi-eye-check-outline::before {\r\n  content: \"\\F0D05\";\r\n}\r\n\r\n.mdi-eye-circle::before {\r\n  content: \"\\F0B94\";\r\n}\r\n\r\n.mdi-eye-circle-outline::before {\r\n  content: \"\\F0B95\";\r\n}\r\n\r\n.mdi-eye-minus::before {\r\n  content: \"\\F1026\";\r\n}\r\n\r\n.mdi-eye-minus-outline::before {\r\n  content: \"\\F1027\";\r\n}\r\n\r\n.mdi-eye-off::before {\r\n  content: \"\\F0209\";\r\n}\r\n\r\n.mdi-eye-off-outline::before {\r\n  content: \"\\F06D1\";\r\n}\r\n\r\n.mdi-eye-outline::before {\r\n  content: \"\\F06D0\";\r\n}\r\n\r\n.mdi-eye-plus::before {\r\n  content: \"\\F086B\";\r\n}\r\n\r\n.mdi-eye-plus-outline::before {\r\n  content: \"\\F086C\";\r\n}\r\n\r\n.mdi-eye-refresh::before {\r\n  content: \"\\F197C\";\r\n}\r\n\r\n.mdi-eye-refresh-outline::before {\r\n  content: \"\\F197D\";\r\n}\r\n\r\n.mdi-eye-remove::before {\r\n  content: \"\\F15E3\";\r\n}\r\n\r\n.mdi-eye-remove-outline::before {\r\n  content: \"\\F15E4\";\r\n}\r\n\r\n.mdi-eye-settings::before {\r\n  content: \"\\F086D\";\r\n}\r\n\r\n.mdi-eye-settings-outline::before {\r\n  content: \"\\F086E\";\r\n}\r\n\r\n.mdi-eyedropper::before {\r\n  content: \"\\F020A\";\r\n}\r\n\r\n.mdi-eyedropper-minus::before {\r\n  content: \"\\F13DD\";\r\n}\r\n\r\n.mdi-eyedropper-off::before {\r\n  content: \"\\F13DF\";\r\n}\r\n\r\n.mdi-eyedropper-plus::before {\r\n  content: \"\\F13DC\";\r\n}\r\n\r\n.mdi-eyedropper-remove::before {\r\n  content: \"\\F13DE\";\r\n}\r\n\r\n.mdi-eyedropper-variant::before {\r\n  content: \"\\F020B\";\r\n}\r\n\r\n.mdi-face-agent::before {\r\n  content: \"\\F0D70\";\r\n}\r\n\r\n.mdi-face-man::before {\r\n  content: \"\\F0643\";\r\n}\r\n\r\n.mdi-face-man-outline::before {\r\n  content: \"\\F0B96\";\r\n}\r\n\r\n.mdi-face-man-profile::before {\r\n  content: \"\\F0644\";\r\n}\r\n\r\n.mdi-face-man-shimmer::before {\r\n  content: \"\\F15CC\";\r\n}\r\n\r\n.mdi-face-man-shimmer-outline::before {\r\n  content: \"\\F15CD\";\r\n}\r\n\r\n.mdi-face-mask::before {\r\n  content: \"\\F1586\";\r\n}\r\n\r\n.mdi-face-mask-outline::before {\r\n  content: \"\\F1587\";\r\n}\r\n\r\n.mdi-face-recognition::before {\r\n  content: \"\\F0C7B\";\r\n}\r\n\r\n.mdi-face-woman::before {\r\n  content: \"\\F1077\";\r\n}\r\n\r\n.mdi-face-woman-outline::before {\r\n  content: \"\\F1078\";\r\n}\r\n\r\n.mdi-face-woman-profile::before {\r\n  content: \"\\F1076\";\r\n}\r\n\r\n.mdi-face-woman-shimmer::before {\r\n  content: \"\\F15CE\";\r\n}\r\n\r\n.mdi-face-woman-shimmer-outline::before {\r\n  content: \"\\F15CF\";\r\n}\r\n\r\n.mdi-facebook::before {\r\n  content: \"\\F020C\";\r\n}\r\n\r\n.mdi-facebook-gaming::before {\r\n  content: \"\\F07DD\";\r\n}\r\n\r\n.mdi-facebook-messenger::before {\r\n  content: \"\\F020E\";\r\n}\r\n\r\n.mdi-facebook-workplace::before {\r\n  content: \"\\F0B31\";\r\n}\r\n\r\n.mdi-factory::before {\r\n  content: \"\\F020F\";\r\n}\r\n\r\n.mdi-family-tree::before {\r\n  content: \"\\F160E\";\r\n}\r\n\r\n.mdi-fan::before {\r\n  content: \"\\F0210\";\r\n}\r\n\r\n.mdi-fan-alert::before {\r\n  content: \"\\F146C\";\r\n}\r\n\r\n.mdi-fan-auto::before {\r\n  content: \"\\F171D\";\r\n}\r\n\r\n.mdi-fan-chevron-down::before {\r\n  content: \"\\F146D\";\r\n}\r\n\r\n.mdi-fan-chevron-up::before {\r\n  content: \"\\F146E\";\r\n}\r\n\r\n.mdi-fan-minus::before {\r\n  content: \"\\F1470\";\r\n}\r\n\r\n.mdi-fan-off::before {\r\n  content: \"\\F081D\";\r\n}\r\n\r\n.mdi-fan-plus::before {\r\n  content: \"\\F146F\";\r\n}\r\n\r\n.mdi-fan-remove::before {\r\n  content: \"\\F1471\";\r\n}\r\n\r\n.mdi-fan-speed-1::before {\r\n  content: \"\\F1472\";\r\n}\r\n\r\n.mdi-fan-speed-2::before {\r\n  content: \"\\F1473\";\r\n}\r\n\r\n.mdi-fan-speed-3::before {\r\n  content: \"\\F1474\";\r\n}\r\n\r\n.mdi-fast-forward::before {\r\n  content: \"\\F0211\";\r\n}\r\n\r\n.mdi-fast-forward-10::before {\r\n  content: \"\\F0D71\";\r\n}\r\n\r\n.mdi-fast-forward-15::before {\r\n  content: \"\\F193A\";\r\n}\r\n\r\n.mdi-fast-forward-30::before {\r\n  content: \"\\F0D06\";\r\n}\r\n\r\n.mdi-fast-forward-5::before {\r\n  content: \"\\F11F8\";\r\n}\r\n\r\n.mdi-fast-forward-60::before {\r\n  content: \"\\F160B\";\r\n}\r\n\r\n.mdi-fast-forward-outline::before {\r\n  content: \"\\F06D2\";\r\n}\r\n\r\n.mdi-fax::before {\r\n  content: \"\\F0212\";\r\n}\r\n\r\n.mdi-feather::before {\r\n  content: \"\\F06D3\";\r\n}\r\n\r\n.mdi-feature-search::before {\r\n  content: \"\\F0A49\";\r\n}\r\n\r\n.mdi-feature-search-outline::before {\r\n  content: \"\\F0A4A\";\r\n}\r\n\r\n.mdi-fedora::before {\r\n  content: \"\\F08DB\";\r\n}\r\n\r\n.mdi-fence::before {\r\n  content: \"\\F179A\";\r\n}\r\n\r\n.mdi-fence-electric::before {\r\n  content: \"\\F17F6\";\r\n}\r\n\r\n.mdi-fencing::before {\r\n  content: \"\\F14C1\";\r\n}\r\n\r\n.mdi-ferris-wheel::before {\r\n  content: \"\\F0EA4\";\r\n}\r\n\r\n.mdi-ferry::before {\r\n  content: \"\\F0213\";\r\n}\r\n\r\n.mdi-file::before {\r\n  content: \"\\F0214\";\r\n}\r\n\r\n.mdi-file-account::before {\r\n  content: \"\\F073B\";\r\n}\r\n\r\n.mdi-file-account-outline::before {\r\n  content: \"\\F1028\";\r\n}\r\n\r\n.mdi-file-alert::before {\r\n  content: \"\\F0A4B\";\r\n}\r\n\r\n.mdi-file-alert-outline::before {\r\n  content: \"\\F0A4C\";\r\n}\r\n\r\n.mdi-file-cabinet::before {\r\n  content: \"\\F0AB6\";\r\n}\r\n\r\n.mdi-file-cad::before {\r\n  content: \"\\F0EEB\";\r\n}\r\n\r\n.mdi-file-cad-box::before {\r\n  content: \"\\F0EEC\";\r\n}\r\n\r\n.mdi-file-cancel::before {\r\n  content: \"\\F0DC6\";\r\n}\r\n\r\n.mdi-file-cancel-outline::before {\r\n  content: \"\\F0DC7\";\r\n}\r\n\r\n.mdi-file-certificate::before {\r\n  content: \"\\F1186\";\r\n}\r\n\r\n.mdi-file-certificate-outline::before {\r\n  content: \"\\F1187\";\r\n}\r\n\r\n.mdi-file-chart::before {\r\n  content: \"\\F0215\";\r\n}\r\n\r\n.mdi-file-chart-outline::before {\r\n  content: \"\\F1029\";\r\n}\r\n\r\n.mdi-file-check::before {\r\n  content: \"\\F0216\";\r\n}\r\n\r\n.mdi-file-check-outline::before {\r\n  content: \"\\F0E29\";\r\n}\r\n\r\n.mdi-file-clock::before {\r\n  content: \"\\F12E1\";\r\n}\r\n\r\n.mdi-file-clock-outline::before {\r\n  content: \"\\F12E2\";\r\n}\r\n\r\n.mdi-file-cloud::before {\r\n  content: \"\\F0217\";\r\n}\r\n\r\n.mdi-file-cloud-outline::before {\r\n  content: \"\\F102A\";\r\n}\r\n\r\n.mdi-file-code::before {\r\n  content: \"\\F022E\";\r\n}\r\n\r\n.mdi-file-code-outline::before {\r\n  content: \"\\F102B\";\r\n}\r\n\r\n.mdi-file-cog::before {\r\n  content: \"\\F107B\";\r\n}\r\n\r\n.mdi-file-cog-outline::before {\r\n  content: \"\\F107C\";\r\n}\r\n\r\n.mdi-file-compare::before {\r\n  content: \"\\F08AA\";\r\n}\r\n\r\n.mdi-file-delimited::before {\r\n  content: \"\\F0218\";\r\n}\r\n\r\n.mdi-file-delimited-outline::before {\r\n  content: \"\\F0EA5\";\r\n}\r\n\r\n.mdi-file-document::before {\r\n  content: \"\\F0219\";\r\n}\r\n\r\n.mdi-file-document-edit::before {\r\n  content: \"\\F0DC8\";\r\n}\r\n\r\n.mdi-file-document-edit-outline::before {\r\n  content: \"\\F0DC9\";\r\n}\r\n\r\n.mdi-file-document-multiple::before {\r\n  content: \"\\F1517\";\r\n}\r\n\r\n.mdi-file-document-multiple-outline::before {\r\n  content: \"\\F1518\";\r\n}\r\n\r\n.mdi-file-document-outline::before {\r\n  content: \"\\F09EE\";\r\n}\r\n\r\n.mdi-file-download::before {\r\n  content: \"\\F0965\";\r\n}\r\n\r\n.mdi-file-download-outline::before {\r\n  content: \"\\F0966\";\r\n}\r\n\r\n.mdi-file-edit::before {\r\n  content: \"\\F11E7\";\r\n}\r\n\r\n.mdi-file-edit-outline::before {\r\n  content: \"\\F11E8\";\r\n}\r\n\r\n.mdi-file-excel::before {\r\n  content: \"\\F021B\";\r\n}\r\n\r\n.mdi-file-excel-box::before {\r\n  content: \"\\F021C\";\r\n}\r\n\r\n.mdi-file-excel-box-outline::before {\r\n  content: \"\\F102C\";\r\n}\r\n\r\n.mdi-file-excel-outline::before {\r\n  content: \"\\F102D\";\r\n}\r\n\r\n.mdi-file-export::before {\r\n  content: \"\\F021D\";\r\n}\r\n\r\n.mdi-file-export-outline::before {\r\n  content: \"\\F102E\";\r\n}\r\n\r\n.mdi-file-eye::before {\r\n  content: \"\\F0DCA\";\r\n}\r\n\r\n.mdi-file-eye-outline::before {\r\n  content: \"\\F0DCB\";\r\n}\r\n\r\n.mdi-file-find::before {\r\n  content: \"\\F021E\";\r\n}\r\n\r\n.mdi-file-find-outline::before {\r\n  content: \"\\F0B97\";\r\n}\r\n\r\n.mdi-file-gif-box::before {\r\n  content: \"\\F0D78\";\r\n}\r\n\r\n.mdi-file-hidden::before {\r\n  content: \"\\F0613\";\r\n}\r\n\r\n.mdi-file-image::before {\r\n  content: \"\\F021F\";\r\n}\r\n\r\n.mdi-file-image-marker::before {\r\n  content: \"\\F1772\";\r\n}\r\n\r\n.mdi-file-image-marker-outline::before {\r\n  content: \"\\F1773\";\r\n}\r\n\r\n.mdi-file-image-minus::before {\r\n  content: \"\\F193B\";\r\n}\r\n\r\n.mdi-file-image-minus-outline::before {\r\n  content: \"\\F193C\";\r\n}\r\n\r\n.mdi-file-image-outline::before {\r\n  content: \"\\F0EB0\";\r\n}\r\n\r\n.mdi-file-image-plus::before {\r\n  content: \"\\F193D\";\r\n}\r\n\r\n.mdi-file-image-plus-outline::before {\r\n  content: \"\\F193E\";\r\n}\r\n\r\n.mdi-file-image-remove::before {\r\n  content: \"\\F193F\";\r\n}\r\n\r\n.mdi-file-image-remove-outline::before {\r\n  content: \"\\F1940\";\r\n}\r\n\r\n.mdi-file-import::before {\r\n  content: \"\\F0220\";\r\n}\r\n\r\n.mdi-file-import-outline::before {\r\n  content: \"\\F102F\";\r\n}\r\n\r\n.mdi-file-jpg-box::before {\r\n  content: \"\\F0225\";\r\n}\r\n\r\n.mdi-file-key::before {\r\n  content: \"\\F1184\";\r\n}\r\n\r\n.mdi-file-key-outline::before {\r\n  content: \"\\F1185\";\r\n}\r\n\r\n.mdi-file-link::before {\r\n  content: \"\\F1177\";\r\n}\r\n\r\n.mdi-file-link-outline::before {\r\n  content: \"\\F1178\";\r\n}\r\n\r\n.mdi-file-lock::before {\r\n  content: \"\\F0221\";\r\n}\r\n\r\n.mdi-file-lock-outline::before {\r\n  content: \"\\F1030\";\r\n}\r\n\r\n.mdi-file-marker::before {\r\n  content: \"\\F1774\";\r\n}\r\n\r\n.mdi-file-marker-outline::before {\r\n  content: \"\\F1775\";\r\n}\r\n\r\n.mdi-file-move::before {\r\n  content: \"\\F0AB9\";\r\n}\r\n\r\n.mdi-file-move-outline::before {\r\n  content: \"\\F1031\";\r\n}\r\n\r\n.mdi-file-multiple::before {\r\n  content: \"\\F0222\";\r\n}\r\n\r\n.mdi-file-multiple-outline::before {\r\n  content: \"\\F1032\";\r\n}\r\n\r\n.mdi-file-music::before {\r\n  content: \"\\F0223\";\r\n}\r\n\r\n.mdi-file-music-outline::before {\r\n  content: \"\\F0E2A\";\r\n}\r\n\r\n.mdi-file-outline::before {\r\n  content: \"\\F0224\";\r\n}\r\n\r\n.mdi-file-pdf-box::before {\r\n  content: \"\\F0226\";\r\n}\r\n\r\n.mdi-file-percent::before {\r\n  content: \"\\F081E\";\r\n}\r\n\r\n.mdi-file-percent-outline::before {\r\n  content: \"\\F1033\";\r\n}\r\n\r\n.mdi-file-phone::before {\r\n  content: \"\\F1179\";\r\n}\r\n\r\n.mdi-file-phone-outline::before {\r\n  content: \"\\F117A\";\r\n}\r\n\r\n.mdi-file-plus::before {\r\n  content: \"\\F0752\";\r\n}\r\n\r\n.mdi-file-plus-outline::before {\r\n  content: \"\\F0EED\";\r\n}\r\n\r\n.mdi-file-png-box::before {\r\n  content: \"\\F0E2D\";\r\n}\r\n\r\n.mdi-file-powerpoint::before {\r\n  content: \"\\F0227\";\r\n}\r\n\r\n.mdi-file-powerpoint-box::before {\r\n  content: \"\\F0228\";\r\n}\r\n\r\n.mdi-file-powerpoint-box-outline::before {\r\n  content: \"\\F1034\";\r\n}\r\n\r\n.mdi-file-powerpoint-outline::before {\r\n  content: \"\\F1035\";\r\n}\r\n\r\n.mdi-file-presentation-box::before {\r\n  content: \"\\F0229\";\r\n}\r\n\r\n.mdi-file-question::before {\r\n  content: \"\\F086F\";\r\n}\r\n\r\n.mdi-file-question-outline::before {\r\n  content: \"\\F1036\";\r\n}\r\n\r\n.mdi-file-refresh::before {\r\n  content: \"\\F0918\";\r\n}\r\n\r\n.mdi-file-refresh-outline::before {\r\n  content: \"\\F0541\";\r\n}\r\n\r\n.mdi-file-remove::before {\r\n  content: \"\\F0B98\";\r\n}\r\n\r\n.mdi-file-remove-outline::before {\r\n  content: \"\\F1037\";\r\n}\r\n\r\n.mdi-file-replace::before {\r\n  content: \"\\F0B32\";\r\n}\r\n\r\n.mdi-file-replace-outline::before {\r\n  content: \"\\F0B33\";\r\n}\r\n\r\n.mdi-file-restore::before {\r\n  content: \"\\F0670\";\r\n}\r\n\r\n.mdi-file-restore-outline::before {\r\n  content: \"\\F1038\";\r\n}\r\n\r\n.mdi-file-search::before {\r\n  content: \"\\F0C7C\";\r\n}\r\n\r\n.mdi-file-search-outline::before {\r\n  content: \"\\F0C7D\";\r\n}\r\n\r\n.mdi-file-send::before {\r\n  content: \"\\F022A\";\r\n}\r\n\r\n.mdi-file-send-outline::before {\r\n  content: \"\\F1039\";\r\n}\r\n\r\n.mdi-file-settings::before {\r\n  content: \"\\F1079\";\r\n}\r\n\r\n.mdi-file-settings-outline::before {\r\n  content: \"\\F107A\";\r\n}\r\n\r\n.mdi-file-sign::before {\r\n  content: \"\\F19C3\";\r\n}\r\n\r\n.mdi-file-star::before {\r\n  content: \"\\F103A\";\r\n}\r\n\r\n.mdi-file-star-outline::before {\r\n  content: \"\\F103B\";\r\n}\r\n\r\n.mdi-file-swap::before {\r\n  content: \"\\F0FB4\";\r\n}\r\n\r\n.mdi-file-swap-outline::before {\r\n  content: \"\\F0FB5\";\r\n}\r\n\r\n.mdi-file-sync::before {\r\n  content: \"\\F1216\";\r\n}\r\n\r\n.mdi-file-sync-outline::before {\r\n  content: \"\\F1217\";\r\n}\r\n\r\n.mdi-file-table::before {\r\n  content: \"\\F0C7E\";\r\n}\r\n\r\n.mdi-file-table-box::before {\r\n  content: \"\\F10E1\";\r\n}\r\n\r\n.mdi-file-table-box-multiple::before {\r\n  content: \"\\F10E2\";\r\n}\r\n\r\n.mdi-file-table-box-multiple-outline::before {\r\n  content: \"\\F10E3\";\r\n}\r\n\r\n.mdi-file-table-box-outline::before {\r\n  content: \"\\F10E4\";\r\n}\r\n\r\n.mdi-file-table-outline::before {\r\n  content: \"\\F0C7F\";\r\n}\r\n\r\n.mdi-file-tree::before {\r\n  content: \"\\F0645\";\r\n}\r\n\r\n.mdi-file-tree-outline::before {\r\n  content: \"\\F13D2\";\r\n}\r\n\r\n.mdi-file-undo::before {\r\n  content: \"\\F08DC\";\r\n}\r\n\r\n.mdi-file-undo-outline::before {\r\n  content: \"\\F103C\";\r\n}\r\n\r\n.mdi-file-upload::before {\r\n  content: \"\\F0A4D\";\r\n}\r\n\r\n.mdi-file-upload-outline::before {\r\n  content: \"\\F0A4E\";\r\n}\r\n\r\n.mdi-file-video::before {\r\n  content: \"\\F022B\";\r\n}\r\n\r\n.mdi-file-video-outline::before {\r\n  content: \"\\F0E2C\";\r\n}\r\n\r\n.mdi-file-word::before {\r\n  content: \"\\F022C\";\r\n}\r\n\r\n.mdi-file-word-box::before {\r\n  content: \"\\F022D\";\r\n}\r\n\r\n.mdi-file-word-box-outline::before {\r\n  content: \"\\F103D\";\r\n}\r\n\r\n.mdi-file-word-outline::before {\r\n  content: \"\\F103E\";\r\n}\r\n\r\n.mdi-film::before {\r\n  content: \"\\F022F\";\r\n}\r\n\r\n.mdi-filmstrip::before {\r\n  content: \"\\F0230\";\r\n}\r\n\r\n.mdi-filmstrip-box::before {\r\n  content: \"\\F0332\";\r\n}\r\n\r\n.mdi-filmstrip-box-multiple::before {\r\n  content: \"\\F0D18\";\r\n}\r\n\r\n.mdi-filmstrip-off::before {\r\n  content: \"\\F0231\";\r\n}\r\n\r\n.mdi-filter::before {\r\n  content: \"\\F0232\";\r\n}\r\n\r\n.mdi-filter-check::before {\r\n  content: \"\\F18EC\";\r\n}\r\n\r\n.mdi-filter-check-outline::before {\r\n  content: \"\\F18ED\";\r\n}\r\n\r\n.mdi-filter-menu::before {\r\n  content: \"\\F10E5\";\r\n}\r\n\r\n.mdi-filter-menu-outline::before {\r\n  content: \"\\F10E6\";\r\n}\r\n\r\n.mdi-filter-minus::before {\r\n  content: \"\\F0EEE\";\r\n}\r\n\r\n.mdi-filter-minus-outline::before {\r\n  content: \"\\F0EEF\";\r\n}\r\n\r\n.mdi-filter-off::before {\r\n  content: \"\\F14EF\";\r\n}\r\n\r\n.mdi-filter-off-outline::before {\r\n  content: \"\\F14F0\";\r\n}\r\n\r\n.mdi-filter-outline::before {\r\n  content: \"\\F0233\";\r\n}\r\n\r\n.mdi-filter-plus::before {\r\n  content: \"\\F0EF0\";\r\n}\r\n\r\n.mdi-filter-plus-outline::before {\r\n  content: \"\\F0EF1\";\r\n}\r\n\r\n.mdi-filter-remove::before {\r\n  content: \"\\F0234\";\r\n}\r\n\r\n.mdi-filter-remove-outline::before {\r\n  content: \"\\F0235\";\r\n}\r\n\r\n.mdi-filter-variant::before {\r\n  content: \"\\F0236\";\r\n}\r\n\r\n.mdi-filter-variant-minus::before {\r\n  content: \"\\F1112\";\r\n}\r\n\r\n.mdi-filter-variant-plus::before {\r\n  content: \"\\F1113\";\r\n}\r\n\r\n.mdi-filter-variant-remove::before {\r\n  content: \"\\F103F\";\r\n}\r\n\r\n.mdi-finance::before {\r\n  content: \"\\F081F\";\r\n}\r\n\r\n.mdi-find-replace::before {\r\n  content: \"\\F06D4\";\r\n}\r\n\r\n.mdi-fingerprint::before {\r\n  content: \"\\F0237\";\r\n}\r\n\r\n.mdi-fingerprint-off::before {\r\n  content: \"\\F0EB1\";\r\n}\r\n\r\n.mdi-fire::before {\r\n  content: \"\\F0238\";\r\n}\r\n\r\n.mdi-fire-alert::before {\r\n  content: \"\\F15D7\";\r\n}\r\n\r\n.mdi-fire-circle::before {\r\n  content: \"\\F1807\";\r\n}\r\n\r\n.mdi-fire-extinguisher::before {\r\n  content: \"\\F0EF2\";\r\n}\r\n\r\n.mdi-fire-hydrant::before {\r\n  content: \"\\F1137\";\r\n}\r\n\r\n.mdi-fire-hydrant-alert::before {\r\n  content: \"\\F1138\";\r\n}\r\n\r\n.mdi-fire-hydrant-off::before {\r\n  content: \"\\F1139\";\r\n}\r\n\r\n.mdi-fire-off::before {\r\n  content: \"\\F1722\";\r\n}\r\n\r\n.mdi-fire-truck::before {\r\n  content: \"\\F08AB\";\r\n}\r\n\r\n.mdi-firebase::before {\r\n  content: \"\\F0967\";\r\n}\r\n\r\n.mdi-firefox::before {\r\n  content: \"\\F0239\";\r\n}\r\n\r\n.mdi-fireplace::before {\r\n  content: \"\\F0E2E\";\r\n}\r\n\r\n.mdi-fireplace-off::before {\r\n  content: \"\\F0E2F\";\r\n}\r\n\r\n.mdi-firewire::before {\r\n  content: \"\\F05BE\";\r\n}\r\n\r\n.mdi-firework::before {\r\n  content: \"\\F0E30\";\r\n}\r\n\r\n.mdi-firework-off::before {\r\n  content: \"\\F1723\";\r\n}\r\n\r\n.mdi-fish::before {\r\n  content: \"\\F023A\";\r\n}\r\n\r\n.mdi-fish-off::before {\r\n  content: \"\\F13F3\";\r\n}\r\n\r\n.mdi-fishbowl::before {\r\n  content: \"\\F0EF3\";\r\n}\r\n\r\n.mdi-fishbowl-outline::before {\r\n  content: \"\\F0EF4\";\r\n}\r\n\r\n.mdi-fit-to-page::before {\r\n  content: \"\\F0EF5\";\r\n}\r\n\r\n.mdi-fit-to-page-outline::before {\r\n  content: \"\\F0EF6\";\r\n}\r\n\r\n.mdi-fit-to-screen::before {\r\n  content: \"\\F18F4\";\r\n}\r\n\r\n.mdi-fit-to-screen-outline::before {\r\n  content: \"\\F18F5\";\r\n}\r\n\r\n.mdi-flag::before {\r\n  content: \"\\F023B\";\r\n}\r\n\r\n.mdi-flag-checkered::before {\r\n  content: \"\\F023C\";\r\n}\r\n\r\n.mdi-flag-minus::before {\r\n  content: \"\\F0B99\";\r\n}\r\n\r\n.mdi-flag-minus-outline::before {\r\n  content: \"\\F10B2\";\r\n}\r\n\r\n.mdi-flag-off::before {\r\n  content: \"\\F18EE\";\r\n}\r\n\r\n.mdi-flag-off-outline::before {\r\n  content: \"\\F18EF\";\r\n}\r\n\r\n.mdi-flag-outline::before {\r\n  content: \"\\F023D\";\r\n}\r\n\r\n.mdi-flag-plus::before {\r\n  content: \"\\F0B9A\";\r\n}\r\n\r\n.mdi-flag-plus-outline::before {\r\n  content: \"\\F10B3\";\r\n}\r\n\r\n.mdi-flag-remove::before {\r\n  content: \"\\F0B9B\";\r\n}\r\n\r\n.mdi-flag-remove-outline::before {\r\n  content: \"\\F10B4\";\r\n}\r\n\r\n.mdi-flag-triangle::before {\r\n  content: \"\\F023F\";\r\n}\r\n\r\n.mdi-flag-variant::before {\r\n  content: \"\\F0240\";\r\n}\r\n\r\n.mdi-flag-variant-outline::before {\r\n  content: \"\\F023E\";\r\n}\r\n\r\n.mdi-flare::before {\r\n  content: \"\\F0D72\";\r\n}\r\n\r\n.mdi-flash::before {\r\n  content: \"\\F0241\";\r\n}\r\n\r\n.mdi-flash-alert::before {\r\n  content: \"\\F0EF7\";\r\n}\r\n\r\n.mdi-flash-alert-outline::before {\r\n  content: \"\\F0EF8\";\r\n}\r\n\r\n.mdi-flash-auto::before {\r\n  content: \"\\F0242\";\r\n}\r\n\r\n.mdi-flash-off::before {\r\n  content: \"\\F0243\";\r\n}\r\n\r\n.mdi-flash-outline::before {\r\n  content: \"\\F06D5\";\r\n}\r\n\r\n.mdi-flash-red-eye::before {\r\n  content: \"\\F067B\";\r\n}\r\n\r\n.mdi-flashlight::before {\r\n  content: \"\\F0244\";\r\n}\r\n\r\n.mdi-flashlight-off::before {\r\n  content: \"\\F0245\";\r\n}\r\n\r\n.mdi-flask::before {\r\n  content: \"\\F0093\";\r\n}\r\n\r\n.mdi-flask-empty::before {\r\n  content: \"\\F0094\";\r\n}\r\n\r\n.mdi-flask-empty-minus::before {\r\n  content: \"\\F123A\";\r\n}\r\n\r\n.mdi-flask-empty-minus-outline::before {\r\n  content: \"\\F123B\";\r\n}\r\n\r\n.mdi-flask-empty-off::before {\r\n  content: \"\\F13F4\";\r\n}\r\n\r\n.mdi-flask-empty-off-outline::before {\r\n  content: \"\\F13F5\";\r\n}\r\n\r\n.mdi-flask-empty-outline::before {\r\n  content: \"\\F0095\";\r\n}\r\n\r\n.mdi-flask-empty-plus::before {\r\n  content: \"\\F123C\";\r\n}\r\n\r\n.mdi-flask-empty-plus-outline::before {\r\n  content: \"\\F123D\";\r\n}\r\n\r\n.mdi-flask-empty-remove::before {\r\n  content: \"\\F123E\";\r\n}\r\n\r\n.mdi-flask-empty-remove-outline::before {\r\n  content: \"\\F123F\";\r\n}\r\n\r\n.mdi-flask-minus::before {\r\n  content: \"\\F1240\";\r\n}\r\n\r\n.mdi-flask-minus-outline::before {\r\n  content: \"\\F1241\";\r\n}\r\n\r\n.mdi-flask-off::before {\r\n  content: \"\\F13F6\";\r\n}\r\n\r\n.mdi-flask-off-outline::before {\r\n  content: \"\\F13F7\";\r\n}\r\n\r\n.mdi-flask-outline::before {\r\n  content: \"\\F0096\";\r\n}\r\n\r\n.mdi-flask-plus::before {\r\n  content: \"\\F1242\";\r\n}\r\n\r\n.mdi-flask-plus-outline::before {\r\n  content: \"\\F1243\";\r\n}\r\n\r\n.mdi-flask-remove::before {\r\n  content: \"\\F1244\";\r\n}\r\n\r\n.mdi-flask-remove-outline::before {\r\n  content: \"\\F1245\";\r\n}\r\n\r\n.mdi-flask-round-bottom::before {\r\n  content: \"\\F124B\";\r\n}\r\n\r\n.mdi-flask-round-bottom-empty::before {\r\n  content: \"\\F124C\";\r\n}\r\n\r\n.mdi-flask-round-bottom-empty-outline::before {\r\n  content: \"\\F124D\";\r\n}\r\n\r\n.mdi-flask-round-bottom-outline::before {\r\n  content: \"\\F124E\";\r\n}\r\n\r\n.mdi-fleur-de-lis::before {\r\n  content: \"\\F1303\";\r\n}\r\n\r\n.mdi-flip-horizontal::before {\r\n  content: \"\\F10E7\";\r\n}\r\n\r\n.mdi-flip-to-back::before {\r\n  content: \"\\F0247\";\r\n}\r\n\r\n.mdi-flip-to-front::before {\r\n  content: \"\\F0248\";\r\n}\r\n\r\n.mdi-flip-vertical::before {\r\n  content: \"\\F10E8\";\r\n}\r\n\r\n.mdi-floor-lamp::before {\r\n  content: \"\\F08DD\";\r\n}\r\n\r\n.mdi-floor-lamp-dual::before {\r\n  content: \"\\F1040\";\r\n}\r\n\r\n.mdi-floor-lamp-dual-outline::before {\r\n  content: \"\\F17CE\";\r\n}\r\n\r\n.mdi-floor-lamp-outline::before {\r\n  content: \"\\F17C8\";\r\n}\r\n\r\n.mdi-floor-lamp-torchiere::before {\r\n  content: \"\\F1747\";\r\n}\r\n\r\n.mdi-floor-lamp-torchiere-outline::before {\r\n  content: \"\\F17D6\";\r\n}\r\n\r\n.mdi-floor-lamp-torchiere-variant::before {\r\n  content: \"\\F1041\";\r\n}\r\n\r\n.mdi-floor-lamp-torchiere-variant-outline::before {\r\n  content: \"\\F17CF\";\r\n}\r\n\r\n.mdi-floor-plan::before {\r\n  content: \"\\F0821\";\r\n}\r\n\r\n.mdi-floppy::before {\r\n  content: \"\\F0249\";\r\n}\r\n\r\n.mdi-floppy-variant::before {\r\n  content: \"\\F09EF\";\r\n}\r\n\r\n.mdi-flower::before {\r\n  content: \"\\F024A\";\r\n}\r\n\r\n.mdi-flower-outline::before {\r\n  content: \"\\F09F0\";\r\n}\r\n\r\n.mdi-flower-pollen::before {\r\n  content: \"\\F1885\";\r\n}\r\n\r\n.mdi-flower-pollen-outline::before {\r\n  content: \"\\F1886\";\r\n}\r\n\r\n.mdi-flower-poppy::before {\r\n  content: \"\\F0D08\";\r\n}\r\n\r\n.mdi-flower-tulip::before {\r\n  content: \"\\F09F1\";\r\n}\r\n\r\n.mdi-flower-tulip-outline::before {\r\n  content: \"\\F09F2\";\r\n}\r\n\r\n.mdi-focus-auto::before {\r\n  content: \"\\F0F4E\";\r\n}\r\n\r\n.mdi-focus-field::before {\r\n  content: \"\\F0F4F\";\r\n}\r\n\r\n.mdi-focus-field-horizontal::before {\r\n  content: \"\\F0F50\";\r\n}\r\n\r\n.mdi-focus-field-vertical::before {\r\n  content: \"\\F0F51\";\r\n}\r\n\r\n.mdi-folder::before {\r\n  content: \"\\F024B\";\r\n}\r\n\r\n.mdi-folder-account::before {\r\n  content: \"\\F024C\";\r\n}\r\n\r\n.mdi-folder-account-outline::before {\r\n  content: \"\\F0B9C\";\r\n}\r\n\r\n.mdi-folder-alert::before {\r\n  content: \"\\F0DCC\";\r\n}\r\n\r\n.mdi-folder-alert-outline::before {\r\n  content: \"\\F0DCD\";\r\n}\r\n\r\n.mdi-folder-check::before {\r\n  content: \"\\F197E\";\r\n}\r\n\r\n.mdi-folder-check-outline::before {\r\n  content: \"\\F197F\";\r\n}\r\n\r\n.mdi-folder-clock::before {\r\n  content: \"\\F0ABA\";\r\n}\r\n\r\n.mdi-folder-clock-outline::before {\r\n  content: \"\\F0ABB\";\r\n}\r\n\r\n.mdi-folder-cog::before {\r\n  content: \"\\F107F\";\r\n}\r\n\r\n.mdi-folder-cog-outline::before {\r\n  content: \"\\F1080\";\r\n}\r\n\r\n.mdi-folder-download::before {\r\n  content: \"\\F024D\";\r\n}\r\n\r\n.mdi-folder-download-outline::before {\r\n  content: \"\\F10E9\";\r\n}\r\n\r\n.mdi-folder-edit::before {\r\n  content: \"\\F08DE\";\r\n}\r\n\r\n.mdi-folder-edit-outline::before {\r\n  content: \"\\F0DCE\";\r\n}\r\n\r\n.mdi-folder-eye::before {\r\n  content: \"\\F178A\";\r\n}\r\n\r\n.mdi-folder-eye-outline::before {\r\n  content: \"\\F178B\";\r\n}\r\n\r\n.mdi-folder-google-drive::before {\r\n  content: \"\\F024E\";\r\n}\r\n\r\n.mdi-folder-heart::before {\r\n  content: \"\\F10EA\";\r\n}\r\n\r\n.mdi-folder-heart-outline::before {\r\n  content: \"\\F10EB\";\r\n}\r\n\r\n.mdi-folder-hidden::before {\r\n  content: \"\\F179E\";\r\n}\r\n\r\n.mdi-folder-home::before {\r\n  content: \"\\F10B5\";\r\n}\r\n\r\n.mdi-folder-home-outline::before {\r\n  content: \"\\F10B6\";\r\n}\r\n\r\n.mdi-folder-image::before {\r\n  content: \"\\F024F\";\r\n}\r\n\r\n.mdi-folder-information::before {\r\n  content: \"\\F10B7\";\r\n}\r\n\r\n.mdi-folder-information-outline::before {\r\n  content: \"\\F10B8\";\r\n}\r\n\r\n.mdi-folder-key::before {\r\n  content: \"\\F08AC\";\r\n}\r\n\r\n.mdi-folder-key-network::before {\r\n  content: \"\\F08AD\";\r\n}\r\n\r\n.mdi-folder-key-network-outline::before {\r\n  content: \"\\F0C80\";\r\n}\r\n\r\n.mdi-folder-key-outline::before {\r\n  content: \"\\F10EC\";\r\n}\r\n\r\n.mdi-folder-lock::before {\r\n  content: \"\\F0250\";\r\n}\r\n\r\n.mdi-folder-lock-open::before {\r\n  content: \"\\F0251\";\r\n}\r\n\r\n.mdi-folder-marker::before {\r\n  content: \"\\F126D\";\r\n}\r\n\r\n.mdi-folder-marker-outline::before {\r\n  content: \"\\F126E\";\r\n}\r\n\r\n.mdi-folder-move::before {\r\n  content: \"\\F0252\";\r\n}\r\n\r\n.mdi-folder-move-outline::before {\r\n  content: \"\\F1246\";\r\n}\r\n\r\n.mdi-folder-multiple::before {\r\n  content: \"\\F0253\";\r\n}\r\n\r\n.mdi-folder-multiple-image::before {\r\n  content: \"\\F0254\";\r\n}\r\n\r\n.mdi-folder-multiple-outline::before {\r\n  content: \"\\F0255\";\r\n}\r\n\r\n.mdi-folder-multiple-plus::before {\r\n  content: \"\\F147E\";\r\n}\r\n\r\n.mdi-folder-multiple-plus-outline::before {\r\n  content: \"\\F147F\";\r\n}\r\n\r\n.mdi-folder-music::before {\r\n  content: \"\\F1359\";\r\n}\r\n\r\n.mdi-folder-music-outline::before {\r\n  content: \"\\F135A\";\r\n}\r\n\r\n.mdi-folder-network::before {\r\n  content: \"\\F0870\";\r\n}\r\n\r\n.mdi-folder-network-outline::before {\r\n  content: \"\\F0C81\";\r\n}\r\n\r\n.mdi-folder-open::before {\r\n  content: \"\\F0770\";\r\n}\r\n\r\n.mdi-folder-open-outline::before {\r\n  content: \"\\F0DCF\";\r\n}\r\n\r\n.mdi-folder-outline::before {\r\n  content: \"\\F0256\";\r\n}\r\n\r\n.mdi-folder-plus::before {\r\n  content: \"\\F0257\";\r\n}\r\n\r\n.mdi-folder-plus-outline::before {\r\n  content: \"\\F0B9D\";\r\n}\r\n\r\n.mdi-folder-pound::before {\r\n  content: \"\\F0D09\";\r\n}\r\n\r\n.mdi-folder-pound-outline::before {\r\n  content: \"\\F0D0A\";\r\n}\r\n\r\n.mdi-folder-refresh::before {\r\n  content: \"\\F0749\";\r\n}\r\n\r\n.mdi-folder-refresh-outline::before {\r\n  content: \"\\F0542\";\r\n}\r\n\r\n.mdi-folder-remove::before {\r\n  content: \"\\F0258\";\r\n}\r\n\r\n.mdi-folder-remove-outline::before {\r\n  content: \"\\F0B9E\";\r\n}\r\n\r\n.mdi-folder-search::before {\r\n  content: \"\\F0968\";\r\n}\r\n\r\n.mdi-folder-search-outline::before {\r\n  content: \"\\F0969\";\r\n}\r\n\r\n.mdi-folder-settings::before {\r\n  content: \"\\F107D\";\r\n}\r\n\r\n.mdi-folder-settings-outline::before {\r\n  content: \"\\F107E\";\r\n}\r\n\r\n.mdi-folder-star::before {\r\n  content: \"\\F069D\";\r\n}\r\n\r\n.mdi-folder-star-multiple::before {\r\n  content: \"\\F13D3\";\r\n}\r\n\r\n.mdi-folder-star-multiple-outline::before {\r\n  content: \"\\F13D4\";\r\n}\r\n\r\n.mdi-folder-star-outline::before {\r\n  content: \"\\F0B9F\";\r\n}\r\n\r\n.mdi-folder-swap::before {\r\n  content: \"\\F0FB6\";\r\n}\r\n\r\n.mdi-folder-swap-outline::before {\r\n  content: \"\\F0FB7\";\r\n}\r\n\r\n.mdi-folder-sync::before {\r\n  content: \"\\F0D0B\";\r\n}\r\n\r\n.mdi-folder-sync-outline::before {\r\n  content: \"\\F0D0C\";\r\n}\r\n\r\n.mdi-folder-table::before {\r\n  content: \"\\F12E3\";\r\n}\r\n\r\n.mdi-folder-table-outline::before {\r\n  content: \"\\F12E4\";\r\n}\r\n\r\n.mdi-folder-text::before {\r\n  content: \"\\F0C82\";\r\n}\r\n\r\n.mdi-folder-text-outline::before {\r\n  content: \"\\F0C83\";\r\n}\r\n\r\n.mdi-folder-upload::before {\r\n  content: \"\\F0259\";\r\n}\r\n\r\n.mdi-folder-upload-outline::before {\r\n  content: \"\\F10ED\";\r\n}\r\n\r\n.mdi-folder-zip::before {\r\n  content: \"\\F06EB\";\r\n}\r\n\r\n.mdi-folder-zip-outline::before {\r\n  content: \"\\F07B9\";\r\n}\r\n\r\n.mdi-font-awesome::before {\r\n  content: \"\\F003A\";\r\n}\r\n\r\n.mdi-food::before {\r\n  content: \"\\F025A\";\r\n}\r\n\r\n.mdi-food-apple::before {\r\n  content: \"\\F025B\";\r\n}\r\n\r\n.mdi-food-apple-outline::before {\r\n  content: \"\\F0C84\";\r\n}\r\n\r\n.mdi-food-croissant::before {\r\n  content: \"\\F07C8\";\r\n}\r\n\r\n.mdi-food-drumstick::before {\r\n  content: \"\\F141F\";\r\n}\r\n\r\n.mdi-food-drumstick-off::before {\r\n  content: \"\\F1468\";\r\n}\r\n\r\n.mdi-food-drumstick-off-outline::before {\r\n  content: \"\\F1469\";\r\n}\r\n\r\n.mdi-food-drumstick-outline::before {\r\n  content: \"\\F1420\";\r\n}\r\n\r\n.mdi-food-fork-drink::before {\r\n  content: \"\\F05F2\";\r\n}\r\n\r\n.mdi-food-halal::before {\r\n  content: \"\\F1572\";\r\n}\r\n\r\n.mdi-food-hot-dog::before {\r\n  content: \"\\F184B\";\r\n}\r\n\r\n.mdi-food-kosher::before {\r\n  content: \"\\F1573\";\r\n}\r\n\r\n.mdi-food-off::before {\r\n  content: \"\\F05F3\";\r\n}\r\n\r\n.mdi-food-off-outline::before {\r\n  content: \"\\F1915\";\r\n}\r\n\r\n.mdi-food-outline::before {\r\n  content: \"\\F1916\";\r\n}\r\n\r\n.mdi-food-steak::before {\r\n  content: \"\\F146A\";\r\n}\r\n\r\n.mdi-food-steak-off::before {\r\n  content: \"\\F146B\";\r\n}\r\n\r\n.mdi-food-takeout-box::before {\r\n  content: \"\\F1836\";\r\n}\r\n\r\n.mdi-food-takeout-box-outline::before {\r\n  content: \"\\F1837\";\r\n}\r\n\r\n.mdi-food-turkey::before {\r\n  content: \"\\F171C\";\r\n}\r\n\r\n.mdi-food-variant::before {\r\n  content: \"\\F025C\";\r\n}\r\n\r\n.mdi-food-variant-off::before {\r\n  content: \"\\F13E5\";\r\n}\r\n\r\n.mdi-foot-print::before {\r\n  content: \"\\F0F52\";\r\n}\r\n\r\n.mdi-football::before {\r\n  content: \"\\F025D\";\r\n}\r\n\r\n.mdi-football-australian::before {\r\n  content: \"\\F025E\";\r\n}\r\n\r\n.mdi-football-helmet::before {\r\n  content: \"\\F025F\";\r\n}\r\n\r\n.mdi-forest::before {\r\n  content: \"\\F1897\";\r\n}\r\n\r\n.mdi-forklift::before {\r\n  content: \"\\F07C9\";\r\n}\r\n\r\n.mdi-form-dropdown::before {\r\n  content: \"\\F1400\";\r\n}\r\n\r\n.mdi-form-select::before {\r\n  content: \"\\F1401\";\r\n}\r\n\r\n.mdi-form-textarea::before {\r\n  content: \"\\F1095\";\r\n}\r\n\r\n.mdi-form-textbox::before {\r\n  content: \"\\F060E\";\r\n}\r\n\r\n.mdi-form-textbox-lock::before {\r\n  content: \"\\F135D\";\r\n}\r\n\r\n.mdi-form-textbox-password::before {\r\n  content: \"\\F07F5\";\r\n}\r\n\r\n.mdi-format-align-bottom::before {\r\n  content: \"\\F0753\";\r\n}\r\n\r\n.mdi-format-align-center::before {\r\n  content: \"\\F0260\";\r\n}\r\n\r\n.mdi-format-align-justify::before {\r\n  content: \"\\F0261\";\r\n}\r\n\r\n.mdi-format-align-left::before {\r\n  content: \"\\F0262\";\r\n}\r\n\r\n.mdi-format-align-middle::before {\r\n  content: \"\\F0754\";\r\n}\r\n\r\n.mdi-format-align-right::before {\r\n  content: \"\\F0263\";\r\n}\r\n\r\n.mdi-format-align-top::before {\r\n  content: \"\\F0755\";\r\n}\r\n\r\n.mdi-format-annotation-minus::before {\r\n  content: \"\\F0ABC\";\r\n}\r\n\r\n.mdi-format-annotation-plus::before {\r\n  content: \"\\F0646\";\r\n}\r\n\r\n.mdi-format-bold::before {\r\n  content: \"\\F0264\";\r\n}\r\n\r\n.mdi-format-clear::before {\r\n  content: \"\\F0265\";\r\n}\r\n\r\n.mdi-format-color-fill::before {\r\n  content: \"\\F0266\";\r\n}\r\n\r\n.mdi-format-color-highlight::before {\r\n  content: \"\\F0E31\";\r\n}\r\n\r\n.mdi-format-color-marker-cancel::before {\r\n  content: \"\\F1313\";\r\n}\r\n\r\n.mdi-format-color-text::before {\r\n  content: \"\\F069E\";\r\n}\r\n\r\n.mdi-format-columns::before {\r\n  content: \"\\F08DF\";\r\n}\r\n\r\n.mdi-format-float-center::before {\r\n  content: \"\\F0267\";\r\n}\r\n\r\n.mdi-format-float-left::before {\r\n  content: \"\\F0268\";\r\n}\r\n\r\n.mdi-format-float-none::before {\r\n  content: \"\\F0269\";\r\n}\r\n\r\n.mdi-format-float-right::before {\r\n  content: \"\\F026A\";\r\n}\r\n\r\n.mdi-format-font::before {\r\n  content: \"\\F06D6\";\r\n}\r\n\r\n.mdi-format-font-size-decrease::before {\r\n  content: \"\\F09F3\";\r\n}\r\n\r\n.mdi-format-font-size-increase::before {\r\n  content: \"\\F09F4\";\r\n}\r\n\r\n.mdi-format-header-1::before {\r\n  content: \"\\F026B\";\r\n}\r\n\r\n.mdi-format-header-2::before {\r\n  content: \"\\F026C\";\r\n}\r\n\r\n.mdi-format-header-3::before {\r\n  content: \"\\F026D\";\r\n}\r\n\r\n.mdi-format-header-4::before {\r\n  content: \"\\F026E\";\r\n}\r\n\r\n.mdi-format-header-5::before {\r\n  content: \"\\F026F\";\r\n}\r\n\r\n.mdi-format-header-6::before {\r\n  content: \"\\F0270\";\r\n}\r\n\r\n.mdi-format-header-decrease::before {\r\n  content: \"\\F0271\";\r\n}\r\n\r\n.mdi-format-header-equal::before {\r\n  content: \"\\F0272\";\r\n}\r\n\r\n.mdi-format-header-increase::before {\r\n  content: \"\\F0273\";\r\n}\r\n\r\n.mdi-format-header-pound::before {\r\n  content: \"\\F0274\";\r\n}\r\n\r\n.mdi-format-horizontal-align-center::before {\r\n  content: \"\\F061E\";\r\n}\r\n\r\n.mdi-format-horizontal-align-left::before {\r\n  content: \"\\F061F\";\r\n}\r\n\r\n.mdi-format-horizontal-align-right::before {\r\n  content: \"\\F0620\";\r\n}\r\n\r\n.mdi-format-indent-decrease::before {\r\n  content: \"\\F0275\";\r\n}\r\n\r\n.mdi-format-indent-increase::before {\r\n  content: \"\\F0276\";\r\n}\r\n\r\n.mdi-format-italic::before {\r\n  content: \"\\F0277\";\r\n}\r\n\r\n.mdi-format-letter-case::before {\r\n  content: \"\\F0B34\";\r\n}\r\n\r\n.mdi-format-letter-case-lower::before {\r\n  content: \"\\F0B35\";\r\n}\r\n\r\n.mdi-format-letter-case-upper::before {\r\n  content: \"\\F0B36\";\r\n}\r\n\r\n.mdi-format-letter-ends-with::before {\r\n  content: \"\\F0FB8\";\r\n}\r\n\r\n.mdi-format-letter-matches::before {\r\n  content: \"\\F0FB9\";\r\n}\r\n\r\n.mdi-format-letter-spacing::before {\r\n  content: \"\\F1956\";\r\n}\r\n\r\n.mdi-format-letter-starts-with::before {\r\n  content: \"\\F0FBA\";\r\n}\r\n\r\n.mdi-format-line-spacing::before {\r\n  content: \"\\F0278\";\r\n}\r\n\r\n.mdi-format-line-style::before {\r\n  content: \"\\F05C8\";\r\n}\r\n\r\n.mdi-format-line-weight::before {\r\n  content: \"\\F05C9\";\r\n}\r\n\r\n.mdi-format-list-bulleted::before {\r\n  content: \"\\F0279\";\r\n}\r\n\r\n.mdi-format-list-bulleted-square::before {\r\n  content: \"\\F0DD0\";\r\n}\r\n\r\n.mdi-format-list-bulleted-triangle::before {\r\n  content: \"\\F0EB2\";\r\n}\r\n\r\n.mdi-format-list-bulleted-type::before {\r\n  content: \"\\F027A\";\r\n}\r\n\r\n.mdi-format-list-checkbox::before {\r\n  content: \"\\F096A\";\r\n}\r\n\r\n.mdi-format-list-checks::before {\r\n  content: \"\\F0756\";\r\n}\r\n\r\n.mdi-format-list-group::before {\r\n  content: \"\\F1860\";\r\n}\r\n\r\n.mdi-format-list-numbered::before {\r\n  content: \"\\F027B\";\r\n}\r\n\r\n.mdi-format-list-numbered-rtl::before {\r\n  content: \"\\F0D0D\";\r\n}\r\n\r\n.mdi-format-list-text::before {\r\n  content: \"\\F126F\";\r\n}\r\n\r\n.mdi-format-overline::before {\r\n  content: \"\\F0EB3\";\r\n}\r\n\r\n.mdi-format-page-break::before {\r\n  content: \"\\F06D7\";\r\n}\r\n\r\n.mdi-format-page-split::before {\r\n  content: \"\\F1917\";\r\n}\r\n\r\n.mdi-format-paint::before {\r\n  content: \"\\F027C\";\r\n}\r\n\r\n.mdi-format-paragraph::before {\r\n  content: \"\\F027D\";\r\n}\r\n\r\n.mdi-format-pilcrow::before {\r\n  content: \"\\F06D8\";\r\n}\r\n\r\n.mdi-format-quote-close::before {\r\n  content: \"\\F027E\";\r\n}\r\n\r\n.mdi-format-quote-close-outline::before {\r\n  content: \"\\F11A8\";\r\n}\r\n\r\n.mdi-format-quote-open::before {\r\n  content: \"\\F0757\";\r\n}\r\n\r\n.mdi-format-quote-open-outline::before {\r\n  content: \"\\F11A7\";\r\n}\r\n\r\n.mdi-format-rotate-90::before {\r\n  content: \"\\F06AA\";\r\n}\r\n\r\n.mdi-format-section::before {\r\n  content: \"\\F069F\";\r\n}\r\n\r\n.mdi-format-size::before {\r\n  content: \"\\F027F\";\r\n}\r\n\r\n.mdi-format-strikethrough::before {\r\n  content: \"\\F0280\";\r\n}\r\n\r\n.mdi-format-strikethrough-variant::before {\r\n  content: \"\\F0281\";\r\n}\r\n\r\n.mdi-format-subscript::before {\r\n  content: \"\\F0282\";\r\n}\r\n\r\n.mdi-format-superscript::before {\r\n  content: \"\\F0283\";\r\n}\r\n\r\n.mdi-format-text::before {\r\n  content: \"\\F0284\";\r\n}\r\n\r\n.mdi-format-text-rotation-angle-down::before {\r\n  content: \"\\F0FBB\";\r\n}\r\n\r\n.mdi-format-text-rotation-angle-up::before {\r\n  content: \"\\F0FBC\";\r\n}\r\n\r\n.mdi-format-text-rotation-down::before {\r\n  content: \"\\F0D73\";\r\n}\r\n\r\n.mdi-format-text-rotation-down-vertical::before {\r\n  content: \"\\F0FBD\";\r\n}\r\n\r\n.mdi-format-text-rotation-none::before {\r\n  content: \"\\F0D74\";\r\n}\r\n\r\n.mdi-format-text-rotation-up::before {\r\n  content: \"\\F0FBE\";\r\n}\r\n\r\n.mdi-format-text-rotation-vertical::before {\r\n  content: \"\\F0FBF\";\r\n}\r\n\r\n.mdi-format-text-variant::before {\r\n  content: \"\\F0E32\";\r\n}\r\n\r\n.mdi-format-text-variant-outline::before {\r\n  content: \"\\F150F\";\r\n}\r\n\r\n.mdi-format-text-wrapping-clip::before {\r\n  content: \"\\F0D0E\";\r\n}\r\n\r\n.mdi-format-text-wrapping-overflow::before {\r\n  content: \"\\F0D0F\";\r\n}\r\n\r\n.mdi-format-text-wrapping-wrap::before {\r\n  content: \"\\F0D10\";\r\n}\r\n\r\n.mdi-format-textbox::before {\r\n  content: \"\\F0D11\";\r\n}\r\n\r\n.mdi-format-textdirection-l-to-r::before {\r\n  content: \"\\F0285\";\r\n}\r\n\r\n.mdi-format-textdirection-r-to-l::before {\r\n  content: \"\\F0286\";\r\n}\r\n\r\n.mdi-format-title::before {\r\n  content: \"\\F05F4\";\r\n}\r\n\r\n.mdi-format-underline::before {\r\n  content: \"\\F0287\";\r\n}\r\n\r\n.mdi-format-underline-wavy::before {\r\n  content: \"\\F18E9\";\r\n}\r\n\r\n.mdi-format-vertical-align-bottom::before {\r\n  content: \"\\F0621\";\r\n}\r\n\r\n.mdi-format-vertical-align-center::before {\r\n  content: \"\\F0622\";\r\n}\r\n\r\n.mdi-format-vertical-align-top::before {\r\n  content: \"\\F0623\";\r\n}\r\n\r\n.mdi-format-wrap-inline::before {\r\n  content: \"\\F0288\";\r\n}\r\n\r\n.mdi-format-wrap-square::before {\r\n  content: \"\\F0289\";\r\n}\r\n\r\n.mdi-format-wrap-tight::before {\r\n  content: \"\\F028A\";\r\n}\r\n\r\n.mdi-format-wrap-top-bottom::before {\r\n  content: \"\\F028B\";\r\n}\r\n\r\n.mdi-forum::before {\r\n  content: \"\\F028C\";\r\n}\r\n\r\n.mdi-forum-outline::before {\r\n  content: \"\\F0822\";\r\n}\r\n\r\n.mdi-forward::before {\r\n  content: \"\\F028D\";\r\n}\r\n\r\n.mdi-forwardburger::before {\r\n  content: \"\\F0D75\";\r\n}\r\n\r\n.mdi-fountain::before {\r\n  content: \"\\F096B\";\r\n}\r\n\r\n.mdi-fountain-pen::before {\r\n  content: \"\\F0D12\";\r\n}\r\n\r\n.mdi-fountain-pen-tip::before {\r\n  content: \"\\F0D13\";\r\n}\r\n\r\n.mdi-fraction-one-half::before {\r\n  content: \"\\F1992\";\r\n}\r\n\r\n.mdi-freebsd::before {\r\n  content: \"\\F08E0\";\r\n}\r\n\r\n.mdi-french-fries::before {\r\n  content: \"\\F1957\";\r\n}\r\n\r\n.mdi-frequently-asked-questions::before {\r\n  content: \"\\F0EB4\";\r\n}\r\n\r\n.mdi-fridge::before {\r\n  content: \"\\F0290\";\r\n}\r\n\r\n.mdi-fridge-alert::before {\r\n  content: \"\\F11B1\";\r\n}\r\n\r\n.mdi-fridge-alert-outline::before {\r\n  content: \"\\F11B2\";\r\n}\r\n\r\n.mdi-fridge-bottom::before {\r\n  content: \"\\F0292\";\r\n}\r\n\r\n.mdi-fridge-industrial::before {\r\n  content: \"\\F15EE\";\r\n}\r\n\r\n.mdi-fridge-industrial-alert::before {\r\n  content: \"\\F15EF\";\r\n}\r\n\r\n.mdi-fridge-industrial-alert-outline::before {\r\n  content: \"\\F15F0\";\r\n}\r\n\r\n.mdi-fridge-industrial-off::before {\r\n  content: \"\\F15F1\";\r\n}\r\n\r\n.mdi-fridge-industrial-off-outline::before {\r\n  content: \"\\F15F2\";\r\n}\r\n\r\n.mdi-fridge-industrial-outline::before {\r\n  content: \"\\F15F3\";\r\n}\r\n\r\n.mdi-fridge-off::before {\r\n  content: \"\\F11AF\";\r\n}\r\n\r\n.mdi-fridge-off-outline::before {\r\n  content: \"\\F11B0\";\r\n}\r\n\r\n.mdi-fridge-outline::before {\r\n  content: \"\\F028F\";\r\n}\r\n\r\n.mdi-fridge-top::before {\r\n  content: \"\\F0291\";\r\n}\r\n\r\n.mdi-fridge-variant::before {\r\n  content: \"\\F15F4\";\r\n}\r\n\r\n.mdi-fridge-variant-alert::before {\r\n  content: \"\\F15F5\";\r\n}\r\n\r\n.mdi-fridge-variant-alert-outline::before {\r\n  content: \"\\F15F6\";\r\n}\r\n\r\n.mdi-fridge-variant-off::before {\r\n  content: \"\\F15F7\";\r\n}\r\n\r\n.mdi-fridge-variant-off-outline::before {\r\n  content: \"\\F15F8\";\r\n}\r\n\r\n.mdi-fridge-variant-outline::before {\r\n  content: \"\\F15F9\";\r\n}\r\n\r\n.mdi-fruit-cherries::before {\r\n  content: \"\\F1042\";\r\n}\r\n\r\n.mdi-fruit-cherries-off::before {\r\n  content: \"\\F13F8\";\r\n}\r\n\r\n.mdi-fruit-citrus::before {\r\n  content: \"\\F1043\";\r\n}\r\n\r\n.mdi-fruit-citrus-off::before {\r\n  content: \"\\F13F9\";\r\n}\r\n\r\n.mdi-fruit-grapes::before {\r\n  content: \"\\F1044\";\r\n}\r\n\r\n.mdi-fruit-grapes-outline::before {\r\n  content: \"\\F1045\";\r\n}\r\n\r\n.mdi-fruit-pineapple::before {\r\n  content: \"\\F1046\";\r\n}\r\n\r\n.mdi-fruit-watermelon::before {\r\n  content: \"\\F1047\";\r\n}\r\n\r\n.mdi-fuel::before {\r\n  content: \"\\F07CA\";\r\n}\r\n\r\n.mdi-fuel-cell::before {\r\n  content: \"\\F18B5\";\r\n}\r\n\r\n.mdi-fullscreen::before {\r\n  content: \"\\F0293\";\r\n}\r\n\r\n.mdi-fullscreen-exit::before {\r\n  content: \"\\F0294\";\r\n}\r\n\r\n.mdi-function::before {\r\n  content: \"\\F0295\";\r\n}\r\n\r\n.mdi-function-variant::before {\r\n  content: \"\\F0871\";\r\n}\r\n\r\n.mdi-furigana-horizontal::before {\r\n  content: \"\\F1081\";\r\n}\r\n\r\n.mdi-furigana-vertical::before {\r\n  content: \"\\F1082\";\r\n}\r\n\r\n.mdi-fuse::before {\r\n  content: \"\\F0C85\";\r\n}\r\n\r\n.mdi-fuse-alert::before {\r\n  content: \"\\F142D\";\r\n}\r\n\r\n.mdi-fuse-blade::before {\r\n  content: \"\\F0C86\";\r\n}\r\n\r\n.mdi-fuse-off::before {\r\n  content: \"\\F142C\";\r\n}\r\n\r\n.mdi-gamepad::before {\r\n  content: \"\\F0296\";\r\n}\r\n\r\n.mdi-gamepad-circle::before {\r\n  content: \"\\F0E33\";\r\n}\r\n\r\n.mdi-gamepad-circle-down::before {\r\n  content: \"\\F0E34\";\r\n}\r\n\r\n.mdi-gamepad-circle-left::before {\r\n  content: \"\\F0E35\";\r\n}\r\n\r\n.mdi-gamepad-circle-outline::before {\r\n  content: \"\\F0E36\";\r\n}\r\n\r\n.mdi-gamepad-circle-right::before {\r\n  content: \"\\F0E37\";\r\n}\r\n\r\n.mdi-gamepad-circle-up::before {\r\n  content: \"\\F0E38\";\r\n}\r\n\r\n.mdi-gamepad-down::before {\r\n  content: \"\\F0E39\";\r\n}\r\n\r\n.mdi-gamepad-left::before {\r\n  content: \"\\F0E3A\";\r\n}\r\n\r\n.mdi-gamepad-outline::before {\r\n  content: \"\\F1919\";\r\n}\r\n\r\n.mdi-gamepad-right::before {\r\n  content: \"\\F0E3B\";\r\n}\r\n\r\n.mdi-gamepad-round::before {\r\n  content: \"\\F0E3C\";\r\n}\r\n\r\n.mdi-gamepad-round-down::before {\r\n  content: \"\\F0E3D\";\r\n}\r\n\r\n.mdi-gamepad-round-left::before {\r\n  content: \"\\F0E3E\";\r\n}\r\n\r\n.mdi-gamepad-round-outline::before {\r\n  content: \"\\F0E3F\";\r\n}\r\n\r\n.mdi-gamepad-round-right::before {\r\n  content: \"\\F0E40\";\r\n}\r\n\r\n.mdi-gamepad-round-up::before {\r\n  content: \"\\F0E41\";\r\n}\r\n\r\n.mdi-gamepad-square::before {\r\n  content: \"\\F0EB5\";\r\n}\r\n\r\n.mdi-gamepad-square-outline::before {\r\n  content: \"\\F0EB6\";\r\n}\r\n\r\n.mdi-gamepad-up::before {\r\n  content: \"\\F0E42\";\r\n}\r\n\r\n.mdi-gamepad-variant::before {\r\n  content: \"\\F0297\";\r\n}\r\n\r\n.mdi-gamepad-variant-outline::before {\r\n  content: \"\\F0EB7\";\r\n}\r\n\r\n.mdi-gamma::before {\r\n  content: \"\\F10EE\";\r\n}\r\n\r\n.mdi-gantry-crane::before {\r\n  content: \"\\F0DD1\";\r\n}\r\n\r\n.mdi-garage::before {\r\n  content: \"\\F06D9\";\r\n}\r\n\r\n.mdi-garage-alert::before {\r\n  content: \"\\F0872\";\r\n}\r\n\r\n.mdi-garage-alert-variant::before {\r\n  content: \"\\F12D5\";\r\n}\r\n\r\n.mdi-garage-lock::before {\r\n  content: \"\\F17FB\";\r\n}\r\n\r\n.mdi-garage-open::before {\r\n  content: \"\\F06DA\";\r\n}\r\n\r\n.mdi-garage-open-variant::before {\r\n  content: \"\\F12D4\";\r\n}\r\n\r\n.mdi-garage-variant::before {\r\n  content: \"\\F12D3\";\r\n}\r\n\r\n.mdi-garage-variant-lock::before {\r\n  content: \"\\F17FC\";\r\n}\r\n\r\n.mdi-gas-cylinder::before {\r\n  content: \"\\F0647\";\r\n}\r\n\r\n.mdi-gas-station::before {\r\n  content: \"\\F0298\";\r\n}\r\n\r\n.mdi-gas-station-off::before {\r\n  content: \"\\F1409\";\r\n}\r\n\r\n.mdi-gas-station-off-outline::before {\r\n  content: \"\\F140A\";\r\n}\r\n\r\n.mdi-gas-station-outline::before {\r\n  content: \"\\F0EB8\";\r\n}\r\n\r\n.mdi-gate::before {\r\n  content: \"\\F0299\";\r\n}\r\n\r\n.mdi-gate-alert::before {\r\n  content: \"\\F17F8\";\r\n}\r\n\r\n.mdi-gate-and::before {\r\n  content: \"\\F08E1\";\r\n}\r\n\r\n.mdi-gate-arrow-left::before {\r\n  content: \"\\F17F7\";\r\n}\r\n\r\n.mdi-gate-arrow-right::before {\r\n  content: \"\\F1169\";\r\n}\r\n\r\n.mdi-gate-nand::before {\r\n  content: \"\\F08E2\";\r\n}\r\n\r\n.mdi-gate-nor::before {\r\n  content: \"\\F08E3\";\r\n}\r\n\r\n.mdi-gate-not::before {\r\n  content: \"\\F08E4\";\r\n}\r\n\r\n.mdi-gate-open::before {\r\n  content: \"\\F116A\";\r\n}\r\n\r\n.mdi-gate-or::before {\r\n  content: \"\\F08E5\";\r\n}\r\n\r\n.mdi-gate-xnor::before {\r\n  content: \"\\F08E6\";\r\n}\r\n\r\n.mdi-gate-xor::before {\r\n  content: \"\\F08E7\";\r\n}\r\n\r\n.mdi-gatsby::before {\r\n  content: \"\\F0E43\";\r\n}\r\n\r\n.mdi-gauge::before {\r\n  content: \"\\F029A\";\r\n}\r\n\r\n.mdi-gauge-empty::before {\r\n  content: \"\\F0873\";\r\n}\r\n\r\n.mdi-gauge-full::before {\r\n  content: \"\\F0874\";\r\n}\r\n\r\n.mdi-gauge-low::before {\r\n  content: \"\\F0875\";\r\n}\r\n\r\n.mdi-gavel::before {\r\n  content: \"\\F029B\";\r\n}\r\n\r\n.mdi-gender-female::before {\r\n  content: \"\\F029C\";\r\n}\r\n\r\n.mdi-gender-male::before {\r\n  content: \"\\F029D\";\r\n}\r\n\r\n.mdi-gender-male-female::before {\r\n  content: \"\\F029E\";\r\n}\r\n\r\n.mdi-gender-male-female-variant::before {\r\n  content: \"\\F113F\";\r\n}\r\n\r\n.mdi-gender-non-binary::before {\r\n  content: \"\\F1140\";\r\n}\r\n\r\n.mdi-gender-transgender::before {\r\n  content: \"\\F029F\";\r\n}\r\n\r\n.mdi-gentoo::before {\r\n  content: \"\\F08E8\";\r\n}\r\n\r\n.mdi-gesture::before {\r\n  content: \"\\F07CB\";\r\n}\r\n\r\n.mdi-gesture-double-tap::before {\r\n  content: \"\\F073C\";\r\n}\r\n\r\n.mdi-gesture-pinch::before {\r\n  content: \"\\F0ABD\";\r\n}\r\n\r\n.mdi-gesture-spread::before {\r\n  content: \"\\F0ABE\";\r\n}\r\n\r\n.mdi-gesture-swipe::before {\r\n  content: \"\\F0D76\";\r\n}\r\n\r\n.mdi-gesture-swipe-down::before {\r\n  content: \"\\F073D\";\r\n}\r\n\r\n.mdi-gesture-swipe-horizontal::before {\r\n  content: \"\\F0ABF\";\r\n}\r\n\r\n.mdi-gesture-swipe-left::before {\r\n  content: \"\\F073E\";\r\n}\r\n\r\n.mdi-gesture-swipe-right::before {\r\n  content: \"\\F073F\";\r\n}\r\n\r\n.mdi-gesture-swipe-up::before {\r\n  content: \"\\F0740\";\r\n}\r\n\r\n.mdi-gesture-swipe-vertical::before {\r\n  content: \"\\F0AC0\";\r\n}\r\n\r\n.mdi-gesture-tap::before {\r\n  content: \"\\F0741\";\r\n}\r\n\r\n.mdi-gesture-tap-box::before {\r\n  content: \"\\F12A9\";\r\n}\r\n\r\n.mdi-gesture-tap-button::before {\r\n  content: \"\\F12A8\";\r\n}\r\n\r\n.mdi-gesture-tap-hold::before {\r\n  content: \"\\F0D77\";\r\n}\r\n\r\n.mdi-gesture-two-double-tap::before {\r\n  content: \"\\F0742\";\r\n}\r\n\r\n.mdi-gesture-two-tap::before {\r\n  content: \"\\F0743\";\r\n}\r\n\r\n.mdi-ghost::before {\r\n  content: \"\\F02A0\";\r\n}\r\n\r\n.mdi-ghost-off::before {\r\n  content: \"\\F09F5\";\r\n}\r\n\r\n.mdi-ghost-off-outline::before {\r\n  content: \"\\F165C\";\r\n}\r\n\r\n.mdi-ghost-outline::before {\r\n  content: \"\\F165D\";\r\n}\r\n\r\n.mdi-gift::before {\r\n  content: \"\\F0E44\";\r\n}\r\n\r\n.mdi-gift-off::before {\r\n  content: \"\\F16EF\";\r\n}\r\n\r\n.mdi-gift-off-outline::before {\r\n  content: \"\\F16F0\";\r\n}\r\n\r\n.mdi-gift-open::before {\r\n  content: \"\\F16F1\";\r\n}\r\n\r\n.mdi-gift-open-outline::before {\r\n  content: \"\\F16F2\";\r\n}\r\n\r\n.mdi-gift-outline::before {\r\n  content: \"\\F02A1\";\r\n}\r\n\r\n.mdi-git::before {\r\n  content: \"\\F02A2\";\r\n}\r\n\r\n.mdi-github::before {\r\n  content: \"\\F02A4\";\r\n}\r\n\r\n.mdi-gitlab::before {\r\n  content: \"\\F0BA0\";\r\n}\r\n\r\n.mdi-glass-cocktail::before {\r\n  content: \"\\F0356\";\r\n}\r\n\r\n.mdi-glass-cocktail-off::before {\r\n  content: \"\\F15E6\";\r\n}\r\n\r\n.mdi-glass-flute::before {\r\n  content: \"\\F02A5\";\r\n}\r\n\r\n.mdi-glass-fragile::before {\r\n  content: \"\\F1873\";\r\n}\r\n\r\n.mdi-glass-mug::before {\r\n  content: \"\\F02A6\";\r\n}\r\n\r\n.mdi-glass-mug-off::before {\r\n  content: \"\\F15E7\";\r\n}\r\n\r\n.mdi-glass-mug-variant::before {\r\n  content: \"\\F1116\";\r\n}\r\n\r\n.mdi-glass-mug-variant-off::before {\r\n  content: \"\\F15E8\";\r\n}\r\n\r\n.mdi-glass-pint-outline::before {\r\n  content: \"\\F130D\";\r\n}\r\n\r\n.mdi-glass-stange::before {\r\n  content: \"\\F02A7\";\r\n}\r\n\r\n.mdi-glass-tulip::before {\r\n  content: \"\\F02A8\";\r\n}\r\n\r\n.mdi-glass-wine::before {\r\n  content: \"\\F0876\";\r\n}\r\n\r\n.mdi-glasses::before {\r\n  content: \"\\F02AA\";\r\n}\r\n\r\n.mdi-globe-light::before {\r\n  content: \"\\F12D7\";\r\n}\r\n\r\n.mdi-globe-model::before {\r\n  content: \"\\F08E9\";\r\n}\r\n\r\n.mdi-gmail::before {\r\n  content: \"\\F02AB\";\r\n}\r\n\r\n.mdi-gnome::before {\r\n  content: \"\\F02AC\";\r\n}\r\n\r\n.mdi-go-kart::before {\r\n  content: \"\\F0D79\";\r\n}\r\n\r\n.mdi-go-kart-track::before {\r\n  content: \"\\F0D7A\";\r\n}\r\n\r\n.mdi-gog::before {\r\n  content: \"\\F0BA1\";\r\n}\r\n\r\n.mdi-gold::before {\r\n  content: \"\\F124F\";\r\n}\r\n\r\n.mdi-golf::before {\r\n  content: \"\\F0823\";\r\n}\r\n\r\n.mdi-golf-cart::before {\r\n  content: \"\\F11A4\";\r\n}\r\n\r\n.mdi-golf-tee::before {\r\n  content: \"\\F1083\";\r\n}\r\n\r\n.mdi-gondola::before {\r\n  content: \"\\F0686\";\r\n}\r\n\r\n.mdi-goodreads::before {\r\n  content: \"\\F0D7B\";\r\n}\r\n\r\n.mdi-google::before {\r\n  content: \"\\F02AD\";\r\n}\r\n\r\n.mdi-google-ads::before {\r\n  content: \"\\F0C87\";\r\n}\r\n\r\n.mdi-google-analytics::before {\r\n  content: \"\\F07CC\";\r\n}\r\n\r\n.mdi-google-assistant::before {\r\n  content: \"\\F07CD\";\r\n}\r\n\r\n.mdi-google-cardboard::before {\r\n  content: \"\\F02AE\";\r\n}\r\n\r\n.mdi-google-chrome::before {\r\n  content: \"\\F02AF\";\r\n}\r\n\r\n.mdi-google-circles::before {\r\n  content: \"\\F02B0\";\r\n}\r\n\r\n.mdi-google-circles-communities::before {\r\n  content: \"\\F02B1\";\r\n}\r\n\r\n.mdi-google-circles-extended::before {\r\n  content: \"\\F02B2\";\r\n}\r\n\r\n.mdi-google-circles-group::before {\r\n  content: \"\\F02B3\";\r\n}\r\n\r\n.mdi-google-classroom::before {\r\n  content: \"\\F02C0\";\r\n}\r\n\r\n.mdi-google-cloud::before {\r\n  content: \"\\F11F6\";\r\n}\r\n\r\n.mdi-google-controller::before {\r\n  content: \"\\F02B4\";\r\n}\r\n\r\n.mdi-google-controller-off::before {\r\n  content: \"\\F02B5\";\r\n}\r\n\r\n.mdi-google-downasaur::before {\r\n  content: \"\\F1362\";\r\n}\r\n\r\n.mdi-google-drive::before {\r\n  content: \"\\F02B6\";\r\n}\r\n\r\n.mdi-google-earth::before {\r\n  content: \"\\F02B7\";\r\n}\r\n\r\n.mdi-google-fit::before {\r\n  content: \"\\F096C\";\r\n}\r\n\r\n.mdi-google-glass::before {\r\n  content: \"\\F02B8\";\r\n}\r\n\r\n.mdi-google-hangouts::before {\r\n  content: \"\\F02C9\";\r\n}\r\n\r\n.mdi-google-home::before {\r\n  content: \"\\F0824\";\r\n}\r\n\r\n.mdi-google-keep::before {\r\n  content: \"\\F06DC\";\r\n}\r\n\r\n.mdi-google-lens::before {\r\n  content: \"\\F09F6\";\r\n}\r\n\r\n.mdi-google-maps::before {\r\n  content: \"\\F05F5\";\r\n}\r\n\r\n.mdi-google-my-business::before {\r\n  content: \"\\F1048\";\r\n}\r\n\r\n.mdi-google-nearby::before {\r\n  content: \"\\F02B9\";\r\n}\r\n\r\n.mdi-google-play::before {\r\n  content: \"\\F02BC\";\r\n}\r\n\r\n.mdi-google-plus::before {\r\n  content: \"\\F02BD\";\r\n}\r\n\r\n.mdi-google-podcast::before {\r\n  content: \"\\F0EB9\";\r\n}\r\n\r\n.mdi-google-spreadsheet::before {\r\n  content: \"\\F09F7\";\r\n}\r\n\r\n.mdi-google-street-view::before {\r\n  content: \"\\F0C88\";\r\n}\r\n\r\n.mdi-google-translate::before {\r\n  content: \"\\F02BF\";\r\n}\r\n\r\n.mdi-gradient-horizontal::before {\r\n  content: \"\\F174A\";\r\n}\r\n\r\n.mdi-gradient-vertical::before {\r\n  content: \"\\F06A0\";\r\n}\r\n\r\n.mdi-grain::before {\r\n  content: \"\\F0D7C\";\r\n}\r\n\r\n.mdi-graph::before {\r\n  content: \"\\F1049\";\r\n}\r\n\r\n.mdi-graph-outline::before {\r\n  content: \"\\F104A\";\r\n}\r\n\r\n.mdi-graphql::before {\r\n  content: \"\\F0877\";\r\n}\r\n\r\n.mdi-grass::before {\r\n  content: \"\\F1510\";\r\n}\r\n\r\n.mdi-grave-stone::before {\r\n  content: \"\\F0BA2\";\r\n}\r\n\r\n.mdi-grease-pencil::before {\r\n  content: \"\\F0648\";\r\n}\r\n\r\n.mdi-greater-than::before {\r\n  content: \"\\F096D\";\r\n}\r\n\r\n.mdi-greater-than-or-equal::before {\r\n  content: \"\\F096E\";\r\n}\r\n\r\n.mdi-greenhouse::before {\r\n  content: \"\\F002D\";\r\n}\r\n\r\n.mdi-grid::before {\r\n  content: \"\\F02C1\";\r\n}\r\n\r\n.mdi-grid-large::before {\r\n  content: \"\\F0758\";\r\n}\r\n\r\n.mdi-grid-off::before {\r\n  content: \"\\F02C2\";\r\n}\r\n\r\n.mdi-grill::before {\r\n  content: \"\\F0E45\";\r\n}\r\n\r\n.mdi-grill-outline::before {\r\n  content: \"\\F118A\";\r\n}\r\n\r\n.mdi-group::before {\r\n  content: \"\\F02C3\";\r\n}\r\n\r\n.mdi-guitar-acoustic::before {\r\n  content: \"\\F0771\";\r\n}\r\n\r\n.mdi-guitar-electric::before {\r\n  content: \"\\F02C4\";\r\n}\r\n\r\n.mdi-guitar-pick::before {\r\n  content: \"\\F02C5\";\r\n}\r\n\r\n.mdi-guitar-pick-outline::before {\r\n  content: \"\\F02C6\";\r\n}\r\n\r\n.mdi-guy-fawkes-mask::before {\r\n  content: \"\\F0825\";\r\n}\r\n\r\n.mdi-hail::before {\r\n  content: \"\\F0AC1\";\r\n}\r\n\r\n.mdi-hair-dryer::before {\r\n  content: \"\\F10EF\";\r\n}\r\n\r\n.mdi-hair-dryer-outline::before {\r\n  content: \"\\F10F0\";\r\n}\r\n\r\n.mdi-halloween::before {\r\n  content: \"\\F0BA3\";\r\n}\r\n\r\n.mdi-hamburger::before {\r\n  content: \"\\F0685\";\r\n}\r\n\r\n.mdi-hamburger-check::before {\r\n  content: \"\\F1776\";\r\n}\r\n\r\n.mdi-hamburger-minus::before {\r\n  content: \"\\F1777\";\r\n}\r\n\r\n.mdi-hamburger-off::before {\r\n  content: \"\\F1778\";\r\n}\r\n\r\n.mdi-hamburger-plus::before {\r\n  content: \"\\F1779\";\r\n}\r\n\r\n.mdi-hamburger-remove::before {\r\n  content: \"\\F177A\";\r\n}\r\n\r\n.mdi-hammer::before {\r\n  content: \"\\F08EA\";\r\n}\r\n\r\n.mdi-hammer-screwdriver::before {\r\n  content: \"\\F1322\";\r\n}\r\n\r\n.mdi-hammer-sickle::before {\r\n  content: \"\\F1887\";\r\n}\r\n\r\n.mdi-hammer-wrench::before {\r\n  content: \"\\F1323\";\r\n}\r\n\r\n.mdi-hand-back-left::before {\r\n  content: \"\\F0E46\";\r\n}\r\n\r\n.mdi-hand-back-left-off::before {\r\n  content: \"\\F1830\";\r\n}\r\n\r\n.mdi-hand-back-left-off-outline::before {\r\n  content: \"\\F1832\";\r\n}\r\n\r\n.mdi-hand-back-left-outline::before {\r\n  content: \"\\F182C\";\r\n}\r\n\r\n.mdi-hand-back-right::before {\r\n  content: \"\\F0E47\";\r\n}\r\n\r\n.mdi-hand-back-right-off::before {\r\n  content: \"\\F1831\";\r\n}\r\n\r\n.mdi-hand-back-right-off-outline::before {\r\n  content: \"\\F1833\";\r\n}\r\n\r\n.mdi-hand-back-right-outline::before {\r\n  content: \"\\F182D\";\r\n}\r\n\r\n.mdi-hand-clap::before {\r\n  content: \"\\F194B\";\r\n}\r\n\r\n.mdi-hand-coin::before {\r\n  content: \"\\F188F\";\r\n}\r\n\r\n.mdi-hand-coin-outline::before {\r\n  content: \"\\F1890\";\r\n}\r\n\r\n.mdi-hand-extended::before {\r\n  content: \"\\F18B6\";\r\n}\r\n\r\n.mdi-hand-extended-outline::before {\r\n  content: \"\\F18B7\";\r\n}\r\n\r\n.mdi-hand-front-left::before {\r\n  content: \"\\F182B\";\r\n}\r\n\r\n.mdi-hand-front-left-outline::before {\r\n  content: \"\\F182E\";\r\n}\r\n\r\n.mdi-hand-front-right::before {\r\n  content: \"\\F0A4F\";\r\n}\r\n\r\n.mdi-hand-front-right-outline::before {\r\n  content: \"\\F182F\";\r\n}\r\n\r\n.mdi-hand-heart::before {\r\n  content: \"\\F10F1\";\r\n}\r\n\r\n.mdi-hand-heart-outline::before {\r\n  content: \"\\F157E\";\r\n}\r\n\r\n.mdi-hand-okay::before {\r\n  content: \"\\F0A50\";\r\n}\r\n\r\n.mdi-hand-peace::before {\r\n  content: \"\\F0A51\";\r\n}\r\n\r\n.mdi-hand-peace-variant::before {\r\n  content: \"\\F0A52\";\r\n}\r\n\r\n.mdi-hand-pointing-down::before {\r\n  content: \"\\F0A53\";\r\n}\r\n\r\n.mdi-hand-pointing-left::before {\r\n  content: \"\\F0A54\";\r\n}\r\n\r\n.mdi-hand-pointing-right::before {\r\n  content: \"\\F02C7\";\r\n}\r\n\r\n.mdi-hand-pointing-up::before {\r\n  content: \"\\F0A55\";\r\n}\r\n\r\n.mdi-hand-saw::before {\r\n  content: \"\\F0E48\";\r\n}\r\n\r\n.mdi-hand-wash::before {\r\n  content: \"\\F157F\";\r\n}\r\n\r\n.mdi-hand-wash-outline::before {\r\n  content: \"\\F1580\";\r\n}\r\n\r\n.mdi-hand-water::before {\r\n  content: \"\\F139F\";\r\n}\r\n\r\n.mdi-hand-wave::before {\r\n  content: \"\\F1821\";\r\n}\r\n\r\n.mdi-hand-wave-outline::before {\r\n  content: \"\\F1822\";\r\n}\r\n\r\n.mdi-handball::before {\r\n  content: \"\\F0F53\";\r\n}\r\n\r\n.mdi-handcuffs::before {\r\n  content: \"\\F113E\";\r\n}\r\n\r\n.mdi-hands-pray::before {\r\n  content: \"\\F0579\";\r\n}\r\n\r\n.mdi-handshake::before {\r\n  content: \"\\F1218\";\r\n}\r\n\r\n.mdi-handshake-outline::before {\r\n  content: \"\\F15A1\";\r\n}\r\n\r\n.mdi-hanger::before {\r\n  content: \"\\F02C8\";\r\n}\r\n\r\n.mdi-hard-hat::before {\r\n  content: \"\\F096F\";\r\n}\r\n\r\n.mdi-harddisk::before {\r\n  content: \"\\F02CA\";\r\n}\r\n\r\n.mdi-harddisk-plus::before {\r\n  content: \"\\F104B\";\r\n}\r\n\r\n.mdi-harddisk-remove::before {\r\n  content: \"\\F104C\";\r\n}\r\n\r\n.mdi-hat-fedora::before {\r\n  content: \"\\F0BA4\";\r\n}\r\n\r\n.mdi-hazard-lights::before {\r\n  content: \"\\F0C89\";\r\n}\r\n\r\n.mdi-hdr::before {\r\n  content: \"\\F0D7D\";\r\n}\r\n\r\n.mdi-hdr-off::before {\r\n  content: \"\\F0D7E\";\r\n}\r\n\r\n.mdi-head::before {\r\n  content: \"\\F135E\";\r\n}\r\n\r\n.mdi-head-alert::before {\r\n  content: \"\\F1338\";\r\n}\r\n\r\n.mdi-head-alert-outline::before {\r\n  content: \"\\F1339\";\r\n}\r\n\r\n.mdi-head-check::before {\r\n  content: \"\\F133A\";\r\n}\r\n\r\n.mdi-head-check-outline::before {\r\n  content: \"\\F133B\";\r\n}\r\n\r\n.mdi-head-cog::before {\r\n  content: \"\\F133C\";\r\n}\r\n\r\n.mdi-head-cog-outline::before {\r\n  content: \"\\F133D\";\r\n}\r\n\r\n.mdi-head-dots-horizontal::before {\r\n  content: \"\\F133E\";\r\n}\r\n\r\n.mdi-head-dots-horizontal-outline::before {\r\n  content: \"\\F133F\";\r\n}\r\n\r\n.mdi-head-flash::before {\r\n  content: \"\\F1340\";\r\n}\r\n\r\n.mdi-head-flash-outline::before {\r\n  content: \"\\F1341\";\r\n}\r\n\r\n.mdi-head-heart::before {\r\n  content: \"\\F1342\";\r\n}\r\n\r\n.mdi-head-heart-outline::before {\r\n  content: \"\\F1343\";\r\n}\r\n\r\n.mdi-head-lightbulb::before {\r\n  content: \"\\F1344\";\r\n}\r\n\r\n.mdi-head-lightbulb-outline::before {\r\n  content: \"\\F1345\";\r\n}\r\n\r\n.mdi-head-minus::before {\r\n  content: \"\\F1346\";\r\n}\r\n\r\n.mdi-head-minus-outline::before {\r\n  content: \"\\F1347\";\r\n}\r\n\r\n.mdi-head-outline::before {\r\n  content: \"\\F135F\";\r\n}\r\n\r\n.mdi-head-plus::before {\r\n  content: \"\\F1348\";\r\n}\r\n\r\n.mdi-head-plus-outline::before {\r\n  content: \"\\F1349\";\r\n}\r\n\r\n.mdi-head-question::before {\r\n  content: \"\\F134A\";\r\n}\r\n\r\n.mdi-head-question-outline::before {\r\n  content: \"\\F134B\";\r\n}\r\n\r\n.mdi-head-remove::before {\r\n  content: \"\\F134C\";\r\n}\r\n\r\n.mdi-head-remove-outline::before {\r\n  content: \"\\F134D\";\r\n}\r\n\r\n.mdi-head-snowflake::before {\r\n  content: \"\\F134E\";\r\n}\r\n\r\n.mdi-head-snowflake-outline::before {\r\n  content: \"\\F134F\";\r\n}\r\n\r\n.mdi-head-sync::before {\r\n  content: \"\\F1350\";\r\n}\r\n\r\n.mdi-head-sync-outline::before {\r\n  content: \"\\F1351\";\r\n}\r\n\r\n.mdi-headphones::before {\r\n  content: \"\\F02CB\";\r\n}\r\n\r\n.mdi-headphones-bluetooth::before {\r\n  content: \"\\F0970\";\r\n}\r\n\r\n.mdi-headphones-box::before {\r\n  content: \"\\F02CC\";\r\n}\r\n\r\n.mdi-headphones-off::before {\r\n  content: \"\\F07CE\";\r\n}\r\n\r\n.mdi-headphones-settings::before {\r\n  content: \"\\F02CD\";\r\n}\r\n\r\n.mdi-headset::before {\r\n  content: \"\\F02CE\";\r\n}\r\n\r\n.mdi-headset-dock::before {\r\n  content: \"\\F02CF\";\r\n}\r\n\r\n.mdi-headset-off::before {\r\n  content: \"\\F02D0\";\r\n}\r\n\r\n.mdi-heart::before {\r\n  content: \"\\F02D1\";\r\n}\r\n\r\n.mdi-heart-box::before {\r\n  content: \"\\F02D2\";\r\n}\r\n\r\n.mdi-heart-box-outline::before {\r\n  content: \"\\F02D3\";\r\n}\r\n\r\n.mdi-heart-broken::before {\r\n  content: \"\\F02D4\";\r\n}\r\n\r\n.mdi-heart-broken-outline::before {\r\n  content: \"\\F0D14\";\r\n}\r\n\r\n.mdi-heart-circle::before {\r\n  content: \"\\F0971\";\r\n}\r\n\r\n.mdi-heart-circle-outline::before {\r\n  content: \"\\F0972\";\r\n}\r\n\r\n.mdi-heart-cog::before {\r\n  content: \"\\F1663\";\r\n}\r\n\r\n.mdi-heart-cog-outline::before {\r\n  content: \"\\F1664\";\r\n}\r\n\r\n.mdi-heart-flash::before {\r\n  content: \"\\F0EF9\";\r\n}\r\n\r\n.mdi-heart-half::before {\r\n  content: \"\\F06DF\";\r\n}\r\n\r\n.mdi-heart-half-full::before {\r\n  content: \"\\F06DE\";\r\n}\r\n\r\n.mdi-heart-half-outline::before {\r\n  content: \"\\F06E0\";\r\n}\r\n\r\n.mdi-heart-minus::before {\r\n  content: \"\\F142F\";\r\n}\r\n\r\n.mdi-heart-minus-outline::before {\r\n  content: \"\\F1432\";\r\n}\r\n\r\n.mdi-heart-multiple::before {\r\n  content: \"\\F0A56\";\r\n}\r\n\r\n.mdi-heart-multiple-outline::before {\r\n  content: \"\\F0A57\";\r\n}\r\n\r\n.mdi-heart-off::before {\r\n  content: \"\\F0759\";\r\n}\r\n\r\n.mdi-heart-off-outline::before {\r\n  content: \"\\F1434\";\r\n}\r\n\r\n.mdi-heart-outline::before {\r\n  content: \"\\F02D5\";\r\n}\r\n\r\n.mdi-heart-plus::before {\r\n  content: \"\\F142E\";\r\n}\r\n\r\n.mdi-heart-plus-outline::before {\r\n  content: \"\\F1431\";\r\n}\r\n\r\n.mdi-heart-pulse::before {\r\n  content: \"\\F05F6\";\r\n}\r\n\r\n.mdi-heart-remove::before {\r\n  content: \"\\F1430\";\r\n}\r\n\r\n.mdi-heart-remove-outline::before {\r\n  content: \"\\F1433\";\r\n}\r\n\r\n.mdi-heart-settings::before {\r\n  content: \"\\F1665\";\r\n}\r\n\r\n.mdi-heart-settings-outline::before {\r\n  content: \"\\F1666\";\r\n}\r\n\r\n.mdi-helicopter::before {\r\n  content: \"\\F0AC2\";\r\n}\r\n\r\n.mdi-help::before {\r\n  content: \"\\F02D6\";\r\n}\r\n\r\n.mdi-help-box::before {\r\n  content: \"\\F078B\";\r\n}\r\n\r\n.mdi-help-circle::before {\r\n  content: \"\\F02D7\";\r\n}\r\n\r\n.mdi-help-circle-outline::before {\r\n  content: \"\\F0625\";\r\n}\r\n\r\n.mdi-help-network::before {\r\n  content: \"\\F06F5\";\r\n}\r\n\r\n.mdi-help-network-outline::before {\r\n  content: \"\\F0C8A\";\r\n}\r\n\r\n.mdi-help-rhombus::before {\r\n  content: \"\\F0BA5\";\r\n}\r\n\r\n.mdi-help-rhombus-outline::before {\r\n  content: \"\\F0BA6\";\r\n}\r\n\r\n.mdi-hexadecimal::before {\r\n  content: \"\\F12A7\";\r\n}\r\n\r\n.mdi-hexagon::before {\r\n  content: \"\\F02D8\";\r\n}\r\n\r\n.mdi-hexagon-multiple::before {\r\n  content: \"\\F06E1\";\r\n}\r\n\r\n.mdi-hexagon-multiple-outline::before {\r\n  content: \"\\F10F2\";\r\n}\r\n\r\n.mdi-hexagon-outline::before {\r\n  content: \"\\F02D9\";\r\n}\r\n\r\n.mdi-hexagon-slice-1::before {\r\n  content: \"\\F0AC3\";\r\n}\r\n\r\n.mdi-hexagon-slice-2::before {\r\n  content: \"\\F0AC4\";\r\n}\r\n\r\n.mdi-hexagon-slice-3::before {\r\n  content: \"\\F0AC5\";\r\n}\r\n\r\n.mdi-hexagon-slice-4::before {\r\n  content: \"\\F0AC6\";\r\n}\r\n\r\n.mdi-hexagon-slice-5::before {\r\n  content: \"\\F0AC7\";\r\n}\r\n\r\n.mdi-hexagon-slice-6::before {\r\n  content: \"\\F0AC8\";\r\n}\r\n\r\n.mdi-hexagram::before {\r\n  content: \"\\F0AC9\";\r\n}\r\n\r\n.mdi-hexagram-outline::before {\r\n  content: \"\\F0ACA\";\r\n}\r\n\r\n.mdi-high-definition::before {\r\n  content: \"\\F07CF\";\r\n}\r\n\r\n.mdi-high-definition-box::before {\r\n  content: \"\\F0878\";\r\n}\r\n\r\n.mdi-highway::before {\r\n  content: \"\\F05F7\";\r\n}\r\n\r\n.mdi-hiking::before {\r\n  content: \"\\F0D7F\";\r\n}\r\n\r\n.mdi-history::before {\r\n  content: \"\\F02DA\";\r\n}\r\n\r\n.mdi-hockey-puck::before {\r\n  content: \"\\F0879\";\r\n}\r\n\r\n.mdi-hockey-sticks::before {\r\n  content: \"\\F087A\";\r\n}\r\n\r\n.mdi-hololens::before {\r\n  content: \"\\F02DB\";\r\n}\r\n\r\n.mdi-home::before {\r\n  content: \"\\F02DC\";\r\n}\r\n\r\n.mdi-home-account::before {\r\n  content: \"\\F0826\";\r\n}\r\n\r\n.mdi-home-alert::before {\r\n  content: \"\\F087B\";\r\n}\r\n\r\n.mdi-home-alert-outline::before {\r\n  content: \"\\F15D0\";\r\n}\r\n\r\n.mdi-home-analytics::before {\r\n  content: \"\\F0EBA\";\r\n}\r\n\r\n.mdi-home-assistant::before {\r\n  content: \"\\F07D0\";\r\n}\r\n\r\n.mdi-home-automation::before {\r\n  content: \"\\F07D1\";\r\n}\r\n\r\n.mdi-home-battery::before {\r\n  content: \"\\F1901\";\r\n}\r\n\r\n.mdi-home-battery-outline::before {\r\n  content: \"\\F1902\";\r\n}\r\n\r\n.mdi-home-circle::before {\r\n  content: \"\\F07D2\";\r\n}\r\n\r\n.mdi-home-circle-outline::before {\r\n  content: \"\\F104D\";\r\n}\r\n\r\n.mdi-home-city::before {\r\n  content: \"\\F0D15\";\r\n}\r\n\r\n.mdi-home-city-outline::before {\r\n  content: \"\\F0D16\";\r\n}\r\n\r\n.mdi-home-edit::before {\r\n  content: \"\\F1159\";\r\n}\r\n\r\n.mdi-home-edit-outline::before {\r\n  content: \"\\F115A\";\r\n}\r\n\r\n.mdi-home-export-outline::before {\r\n  content: \"\\F0F9B\";\r\n}\r\n\r\n.mdi-home-flood::before {\r\n  content: \"\\F0EFA\";\r\n}\r\n\r\n.mdi-home-floor-0::before {\r\n  content: \"\\F0DD2\";\r\n}\r\n\r\n.mdi-home-floor-1::before {\r\n  content: \"\\F0D80\";\r\n}\r\n\r\n.mdi-home-floor-2::before {\r\n  content: \"\\F0D81\";\r\n}\r\n\r\n.mdi-home-floor-3::before {\r\n  content: \"\\F0D82\";\r\n}\r\n\r\n.mdi-home-floor-a::before {\r\n  content: \"\\F0D83\";\r\n}\r\n\r\n.mdi-home-floor-b::before {\r\n  content: \"\\F0D84\";\r\n}\r\n\r\n.mdi-home-floor-g::before {\r\n  content: \"\\F0D85\";\r\n}\r\n\r\n.mdi-home-floor-l::before {\r\n  content: \"\\F0D86\";\r\n}\r\n\r\n.mdi-home-floor-negative-1::before {\r\n  content: \"\\F0DD3\";\r\n}\r\n\r\n.mdi-home-group::before {\r\n  content: \"\\F0DD4\";\r\n}\r\n\r\n.mdi-home-group-minus::before {\r\n  content: \"\\F19C1\";\r\n}\r\n\r\n.mdi-home-group-plus::before {\r\n  content: \"\\F19C0\";\r\n}\r\n\r\n.mdi-home-group-remove::before {\r\n  content: \"\\F19C2\";\r\n}\r\n\r\n.mdi-home-heart::before {\r\n  content: \"\\F0827\";\r\n}\r\n\r\n.mdi-home-import-outline::before {\r\n  content: \"\\F0F9C\";\r\n}\r\n\r\n.mdi-home-lightbulb::before {\r\n  content: \"\\F1251\";\r\n}\r\n\r\n.mdi-home-lightbulb-outline::before {\r\n  content: \"\\F1252\";\r\n}\r\n\r\n.mdi-home-lightning-bolt::before {\r\n  content: \"\\F1903\";\r\n}\r\n\r\n.mdi-home-lightning-bolt-outline::before {\r\n  content: \"\\F1904\";\r\n}\r\n\r\n.mdi-home-lock::before {\r\n  content: \"\\F08EB\";\r\n}\r\n\r\n.mdi-home-lock-open::before {\r\n  content: \"\\F08EC\";\r\n}\r\n\r\n.mdi-home-map-marker::before {\r\n  content: \"\\F05F8\";\r\n}\r\n\r\n.mdi-home-minus::before {\r\n  content: \"\\F0974\";\r\n}\r\n\r\n.mdi-home-minus-outline::before {\r\n  content: \"\\F13D5\";\r\n}\r\n\r\n.mdi-home-modern::before {\r\n  content: \"\\F02DD\";\r\n}\r\n\r\n.mdi-home-outline::before {\r\n  content: \"\\F06A1\";\r\n}\r\n\r\n.mdi-home-plus::before {\r\n  content: \"\\F0975\";\r\n}\r\n\r\n.mdi-home-plus-outline::before {\r\n  content: \"\\F13D6\";\r\n}\r\n\r\n.mdi-home-remove::before {\r\n  content: \"\\F1247\";\r\n}\r\n\r\n.mdi-home-remove-outline::before {\r\n  content: \"\\F13D7\";\r\n}\r\n\r\n.mdi-home-roof::before {\r\n  content: \"\\F112B\";\r\n}\r\n\r\n.mdi-home-search::before {\r\n  content: \"\\F13B0\";\r\n}\r\n\r\n.mdi-home-search-outline::before {\r\n  content: \"\\F13B1\";\r\n}\r\n\r\n.mdi-home-switch::before {\r\n  content: \"\\F1794\";\r\n}\r\n\r\n.mdi-home-switch-outline::before {\r\n  content: \"\\F1795\";\r\n}\r\n\r\n.mdi-home-thermometer::before {\r\n  content: \"\\F0F54\";\r\n}\r\n\r\n.mdi-home-thermometer-outline::before {\r\n  content: \"\\F0F55\";\r\n}\r\n\r\n.mdi-home-variant::before {\r\n  content: \"\\F02DE\";\r\n}\r\n\r\n.mdi-home-variant-outline::before {\r\n  content: \"\\F0BA7\";\r\n}\r\n\r\n.mdi-hook::before {\r\n  content: \"\\F06E2\";\r\n}\r\n\r\n.mdi-hook-off::before {\r\n  content: \"\\F06E3\";\r\n}\r\n\r\n.mdi-hoop-house::before {\r\n  content: \"\\F0E56\";\r\n}\r\n\r\n.mdi-hops::before {\r\n  content: \"\\F02DF\";\r\n}\r\n\r\n.mdi-horizontal-rotate-clockwise::before {\r\n  content: \"\\F10F3\";\r\n}\r\n\r\n.mdi-horizontal-rotate-counterclockwise::before {\r\n  content: \"\\F10F4\";\r\n}\r\n\r\n.mdi-horse::before {\r\n  content: \"\\F15BF\";\r\n}\r\n\r\n.mdi-horse-human::before {\r\n  content: \"\\F15C0\";\r\n}\r\n\r\n.mdi-horse-variant::before {\r\n  content: \"\\F15C1\";\r\n}\r\n\r\n.mdi-horse-variant-fast::before {\r\n  content: \"\\F186E\";\r\n}\r\n\r\n.mdi-horseshoe::before {\r\n  content: \"\\F0A58\";\r\n}\r\n\r\n.mdi-hospital::before {\r\n  content: \"\\F0FF6\";\r\n}\r\n\r\n.mdi-hospital-box::before {\r\n  content: \"\\F02E0\";\r\n}\r\n\r\n.mdi-hospital-box-outline::before {\r\n  content: \"\\F0FF7\";\r\n}\r\n\r\n.mdi-hospital-building::before {\r\n  content: \"\\F02E1\";\r\n}\r\n\r\n.mdi-hospital-marker::before {\r\n  content: \"\\F02E2\";\r\n}\r\n\r\n.mdi-hot-tub::before {\r\n  content: \"\\F0828\";\r\n}\r\n\r\n.mdi-hours-24::before {\r\n  content: \"\\F1478\";\r\n}\r\n\r\n.mdi-hubspot::before {\r\n  content: \"\\F0D17\";\r\n}\r\n\r\n.mdi-hulu::before {\r\n  content: \"\\F0829\";\r\n}\r\n\r\n.mdi-human::before {\r\n  content: \"\\F02E6\";\r\n}\r\n\r\n.mdi-human-baby-changing-table::before {\r\n  content: \"\\F138B\";\r\n}\r\n\r\n.mdi-human-cane::before {\r\n  content: \"\\F1581\";\r\n}\r\n\r\n.mdi-human-capacity-decrease::before {\r\n  content: \"\\F159B\";\r\n}\r\n\r\n.mdi-human-capacity-increase::before {\r\n  content: \"\\F159C\";\r\n}\r\n\r\n.mdi-human-child::before {\r\n  content: \"\\F02E7\";\r\n}\r\n\r\n.mdi-human-dolly::before {\r\n  content: \"\\F1980\";\r\n}\r\n\r\n.mdi-human-edit::before {\r\n  content: \"\\F14E8\";\r\n}\r\n\r\n.mdi-human-female::before {\r\n  content: \"\\F0649\";\r\n}\r\n\r\n.mdi-human-female-boy::before {\r\n  content: \"\\F0A59\";\r\n}\r\n\r\n.mdi-human-female-dance::before {\r\n  content: \"\\F15C9\";\r\n}\r\n\r\n.mdi-human-female-female::before {\r\n  content: \"\\F0A5A\";\r\n}\r\n\r\n.mdi-human-female-girl::before {\r\n  content: \"\\F0A5B\";\r\n}\r\n\r\n.mdi-human-greeting::before {\r\n  content: \"\\F17C4\";\r\n}\r\n\r\n.mdi-human-greeting-proximity::before {\r\n  content: \"\\F159D\";\r\n}\r\n\r\n.mdi-human-greeting-variant::before {\r\n  content: \"\\F064A\";\r\n}\r\n\r\n.mdi-human-handsdown::before {\r\n  content: \"\\F064B\";\r\n}\r\n\r\n.mdi-human-handsup::before {\r\n  content: \"\\F064C\";\r\n}\r\n\r\n.mdi-human-male::before {\r\n  content: \"\\F064D\";\r\n}\r\n\r\n.mdi-human-male-board::before {\r\n  content: \"\\F0890\";\r\n}\r\n\r\n.mdi-human-male-board-poll::before {\r\n  content: \"\\F0846\";\r\n}\r\n\r\n.mdi-human-male-boy::before {\r\n  content: \"\\F0A5C\";\r\n}\r\n\r\n.mdi-human-male-child::before {\r\n  content: \"\\F138C\";\r\n}\r\n\r\n.mdi-human-male-female::before {\r\n  content: \"\\F02E8\";\r\n}\r\n\r\n.mdi-human-male-female-child::before {\r\n  content: \"\\F1823\";\r\n}\r\n\r\n.mdi-human-male-girl::before {\r\n  content: \"\\F0A5D\";\r\n}\r\n\r\n.mdi-human-male-height::before {\r\n  content: \"\\F0EFB\";\r\n}\r\n\r\n.mdi-human-male-height-variant::before {\r\n  content: \"\\F0EFC\";\r\n}\r\n\r\n.mdi-human-male-male::before {\r\n  content: \"\\F0A5E\";\r\n}\r\n\r\n.mdi-human-non-binary::before {\r\n  content: \"\\F1848\";\r\n}\r\n\r\n.mdi-human-pregnant::before {\r\n  content: \"\\F05CF\";\r\n}\r\n\r\n.mdi-human-queue::before {\r\n  content: \"\\F1571\";\r\n}\r\n\r\n.mdi-human-scooter::before {\r\n  content: \"\\F11E9\";\r\n}\r\n\r\n.mdi-human-wheelchair::before {\r\n  content: \"\\F138D\";\r\n}\r\n\r\n.mdi-human-white-cane::before {\r\n  content: \"\\F1981\";\r\n}\r\n\r\n.mdi-humble-bundle::before {\r\n  content: \"\\F0744\";\r\n}\r\n\r\n.mdi-hvac::before {\r\n  content: \"\\F1352\";\r\n}\r\n\r\n.mdi-hvac-off::before {\r\n  content: \"\\F159E\";\r\n}\r\n\r\n.mdi-hydraulic-oil-level::before {\r\n  content: \"\\F1324\";\r\n}\r\n\r\n.mdi-hydraulic-oil-temperature::before {\r\n  content: \"\\F1325\";\r\n}\r\n\r\n.mdi-hydro-power::before {\r\n  content: \"\\F12E5\";\r\n}\r\n\r\n.mdi-hydrogen-station::before {\r\n  content: \"\\F1894\";\r\n}\r\n\r\n.mdi-ice-cream::before {\r\n  content: \"\\F082A\";\r\n}\r\n\r\n.mdi-ice-cream-off::before {\r\n  content: \"\\F0E52\";\r\n}\r\n\r\n.mdi-ice-pop::before {\r\n  content: \"\\F0EFD\";\r\n}\r\n\r\n.mdi-id-card::before {\r\n  content: \"\\F0FC0\";\r\n}\r\n\r\n.mdi-identifier::before {\r\n  content: \"\\F0EFE\";\r\n}\r\n\r\n.mdi-ideogram-cjk::before {\r\n  content: \"\\F1331\";\r\n}\r\n\r\n.mdi-ideogram-cjk-variant::before {\r\n  content: \"\\F1332\";\r\n}\r\n\r\n.mdi-image::before {\r\n  content: \"\\F02E9\";\r\n}\r\n\r\n.mdi-image-album::before {\r\n  content: \"\\F02EA\";\r\n}\r\n\r\n.mdi-image-area::before {\r\n  content: \"\\F02EB\";\r\n}\r\n\r\n.mdi-image-area-close::before {\r\n  content: \"\\F02EC\";\r\n}\r\n\r\n.mdi-image-auto-adjust::before {\r\n  content: \"\\F0FC1\";\r\n}\r\n\r\n.mdi-image-broken::before {\r\n  content: \"\\F02ED\";\r\n}\r\n\r\n.mdi-image-broken-variant::before {\r\n  content: \"\\F02EE\";\r\n}\r\n\r\n.mdi-image-edit::before {\r\n  content: \"\\F11E3\";\r\n}\r\n\r\n.mdi-image-edit-outline::before {\r\n  content: \"\\F11E4\";\r\n}\r\n\r\n.mdi-image-filter-black-white::before {\r\n  content: \"\\F02F0\";\r\n}\r\n\r\n.mdi-image-filter-center-focus::before {\r\n  content: \"\\F02F1\";\r\n}\r\n\r\n.mdi-image-filter-center-focus-strong::before {\r\n  content: \"\\F0EFF\";\r\n}\r\n\r\n.mdi-image-filter-center-focus-strong-outline::before {\r\n  content: \"\\F0F00\";\r\n}\r\n\r\n.mdi-image-filter-center-focus-weak::before {\r\n  content: \"\\F02F2\";\r\n}\r\n\r\n.mdi-image-filter-drama::before {\r\n  content: \"\\F02F3\";\r\n}\r\n\r\n.mdi-image-filter-frames::before {\r\n  content: \"\\F02F4\";\r\n}\r\n\r\n.mdi-image-filter-hdr::before {\r\n  content: \"\\F02F5\";\r\n}\r\n\r\n.mdi-image-filter-none::before {\r\n  content: \"\\F02F6\";\r\n}\r\n\r\n.mdi-image-filter-tilt-shift::before {\r\n  content: \"\\F02F7\";\r\n}\r\n\r\n.mdi-image-filter-vintage::before {\r\n  content: \"\\F02F8\";\r\n}\r\n\r\n.mdi-image-frame::before {\r\n  content: \"\\F0E49\";\r\n}\r\n\r\n.mdi-image-marker::before {\r\n  content: \"\\F177B\";\r\n}\r\n\r\n.mdi-image-marker-outline::before {\r\n  content: \"\\F177C\";\r\n}\r\n\r\n.mdi-image-minus::before {\r\n  content: \"\\F1419\";\r\n}\r\n\r\n.mdi-image-move::before {\r\n  content: \"\\F09F8\";\r\n}\r\n\r\n.mdi-image-multiple::before {\r\n  content: \"\\F02F9\";\r\n}\r\n\r\n.mdi-image-multiple-outline::before {\r\n  content: \"\\F02EF\";\r\n}\r\n\r\n.mdi-image-off::before {\r\n  content: \"\\F082B\";\r\n}\r\n\r\n.mdi-image-off-outline::before {\r\n  content: \"\\F11D1\";\r\n}\r\n\r\n.mdi-image-outline::before {\r\n  content: \"\\F0976\";\r\n}\r\n\r\n.mdi-image-plus::before {\r\n  content: \"\\F087C\";\r\n}\r\n\r\n.mdi-image-remove::before {\r\n  content: \"\\F1418\";\r\n}\r\n\r\n.mdi-image-search::before {\r\n  content: \"\\F0977\";\r\n}\r\n\r\n.mdi-image-search-outline::before {\r\n  content: \"\\F0978\";\r\n}\r\n\r\n.mdi-image-size-select-actual::before {\r\n  content: \"\\F0C8D\";\r\n}\r\n\r\n.mdi-image-size-select-large::before {\r\n  content: \"\\F0C8E\";\r\n}\r\n\r\n.mdi-image-size-select-small::before {\r\n  content: \"\\F0C8F\";\r\n}\r\n\r\n.mdi-image-text::before {\r\n  content: \"\\F160D\";\r\n}\r\n\r\n.mdi-import::before {\r\n  content: \"\\F02FA\";\r\n}\r\n\r\n.mdi-inbox::before {\r\n  content: \"\\F0687\";\r\n}\r\n\r\n.mdi-inbox-arrow-down::before {\r\n  content: \"\\F02FB\";\r\n}\r\n\r\n.mdi-inbox-arrow-down-outline::before {\r\n  content: \"\\F1270\";\r\n}\r\n\r\n.mdi-inbox-arrow-up::before {\r\n  content: \"\\F03D1\";\r\n}\r\n\r\n.mdi-inbox-arrow-up-outline::before {\r\n  content: \"\\F1271\";\r\n}\r\n\r\n.mdi-inbox-full::before {\r\n  content: \"\\F1272\";\r\n}\r\n\r\n.mdi-inbox-full-outline::before {\r\n  content: \"\\F1273\";\r\n}\r\n\r\n.mdi-inbox-multiple::before {\r\n  content: \"\\F08B0\";\r\n}\r\n\r\n.mdi-inbox-multiple-outline::before {\r\n  content: \"\\F0BA8\";\r\n}\r\n\r\n.mdi-inbox-outline::before {\r\n  content: \"\\F1274\";\r\n}\r\n\r\n.mdi-inbox-remove::before {\r\n  content: \"\\F159F\";\r\n}\r\n\r\n.mdi-inbox-remove-outline::before {\r\n  content: \"\\F15A0\";\r\n}\r\n\r\n.mdi-incognito::before {\r\n  content: \"\\F05F9\";\r\n}\r\n\r\n.mdi-incognito-circle::before {\r\n  content: \"\\F1421\";\r\n}\r\n\r\n.mdi-incognito-circle-off::before {\r\n  content: \"\\F1422\";\r\n}\r\n\r\n.mdi-incognito-off::before {\r\n  content: \"\\F0075\";\r\n}\r\n\r\n.mdi-induction::before {\r\n  content: \"\\F184C\";\r\n}\r\n\r\n.mdi-infinity::before {\r\n  content: \"\\F06E4\";\r\n}\r\n\r\n.mdi-information::before {\r\n  content: \"\\F02FC\";\r\n}\r\n\r\n.mdi-information-off::before {\r\n  content: \"\\F178C\";\r\n}\r\n\r\n.mdi-information-off-outline::before {\r\n  content: \"\\F178D\";\r\n}\r\n\r\n.mdi-information-outline::before {\r\n  content: \"\\F02FD\";\r\n}\r\n\r\n.mdi-information-variant::before {\r\n  content: \"\\F064E\";\r\n}\r\n\r\n.mdi-instagram::before {\r\n  content: \"\\F02FE\";\r\n}\r\n\r\n.mdi-instrument-triangle::before {\r\n  content: \"\\F104E\";\r\n}\r\n\r\n.mdi-integrated-circuit-chip::before {\r\n  content: \"\\F1913\";\r\n}\r\n\r\n.mdi-invert-colors::before {\r\n  content: \"\\F0301\";\r\n}\r\n\r\n.mdi-invert-colors-off::before {\r\n  content: \"\\F0E4A\";\r\n}\r\n\r\n.mdi-iobroker::before {\r\n  content: \"\\F12E8\";\r\n}\r\n\r\n.mdi-ip::before {\r\n  content: \"\\F0A5F\";\r\n}\r\n\r\n.mdi-ip-network::before {\r\n  content: \"\\F0A60\";\r\n}\r\n\r\n.mdi-ip-network-outline::before {\r\n  content: \"\\F0C90\";\r\n}\r\n\r\n.mdi-ip-outline::before {\r\n  content: \"\\F1982\";\r\n}\r\n\r\n.mdi-ipod::before {\r\n  content: \"\\F0C91\";\r\n}\r\n\r\n.mdi-iron::before {\r\n  content: \"\\F1824\";\r\n}\r\n\r\n.mdi-iron-board::before {\r\n  content: \"\\F1838\";\r\n}\r\n\r\n.mdi-iron-outline::before {\r\n  content: \"\\F1825\";\r\n}\r\n\r\n.mdi-island::before {\r\n  content: \"\\F104F\";\r\n}\r\n\r\n.mdi-iv-bag::before {\r\n  content: \"\\F10B9\";\r\n}\r\n\r\n.mdi-jabber::before {\r\n  content: \"\\F0DD5\";\r\n}\r\n\r\n.mdi-jeepney::before {\r\n  content: \"\\F0302\";\r\n}\r\n\r\n.mdi-jellyfish::before {\r\n  content: \"\\F0F01\";\r\n}\r\n\r\n.mdi-jellyfish-outline::before {\r\n  content: \"\\F0F02\";\r\n}\r\n\r\n.mdi-jira::before {\r\n  content: \"\\F0303\";\r\n}\r\n\r\n.mdi-jquery::before {\r\n  content: \"\\F087D\";\r\n}\r\n\r\n.mdi-jsfiddle::before {\r\n  content: \"\\F0304\";\r\n}\r\n\r\n.mdi-jump-rope::before {\r\n  content: \"\\F12FF\";\r\n}\r\n\r\n.mdi-kabaddi::before {\r\n  content: \"\\F0D87\";\r\n}\r\n\r\n.mdi-kangaroo::before {\r\n  content: \"\\F1558\";\r\n}\r\n\r\n.mdi-karate::before {\r\n  content: \"\\F082C\";\r\n}\r\n\r\n.mdi-kayaking::before {\r\n  content: \"\\F08AF\";\r\n}\r\n\r\n.mdi-keg::before {\r\n  content: \"\\F0305\";\r\n}\r\n\r\n.mdi-kettle::before {\r\n  content: \"\\F05FA\";\r\n}\r\n\r\n.mdi-kettle-alert::before {\r\n  content: \"\\F1317\";\r\n}\r\n\r\n.mdi-kettle-alert-outline::before {\r\n  content: \"\\F1318\";\r\n}\r\n\r\n.mdi-kettle-off::before {\r\n  content: \"\\F131B\";\r\n}\r\n\r\n.mdi-kettle-off-outline::before {\r\n  content: \"\\F131C\";\r\n}\r\n\r\n.mdi-kettle-outline::before {\r\n  content: \"\\F0F56\";\r\n}\r\n\r\n.mdi-kettle-pour-over::before {\r\n  content: \"\\F173C\";\r\n}\r\n\r\n.mdi-kettle-steam::before {\r\n  content: \"\\F1319\";\r\n}\r\n\r\n.mdi-kettle-steam-outline::before {\r\n  content: \"\\F131A\";\r\n}\r\n\r\n.mdi-kettlebell::before {\r\n  content: \"\\F1300\";\r\n}\r\n\r\n.mdi-key::before {\r\n  content: \"\\F0306\";\r\n}\r\n\r\n.mdi-key-alert::before {\r\n  content: \"\\F1983\";\r\n}\r\n\r\n.mdi-key-alert-outline::before {\r\n  content: \"\\F1984\";\r\n}\r\n\r\n.mdi-key-arrow-right::before {\r\n  content: \"\\F1312\";\r\n}\r\n\r\n.mdi-key-chain::before {\r\n  content: \"\\F1574\";\r\n}\r\n\r\n.mdi-key-chain-variant::before {\r\n  content: \"\\F1575\";\r\n}\r\n\r\n.mdi-key-change::before {\r\n  content: \"\\F0307\";\r\n}\r\n\r\n.mdi-key-link::before {\r\n  content: \"\\F119F\";\r\n}\r\n\r\n.mdi-key-minus::before {\r\n  content: \"\\F0308\";\r\n}\r\n\r\n.mdi-key-outline::before {\r\n  content: \"\\F0DD6\";\r\n}\r\n\r\n.mdi-key-plus::before {\r\n  content: \"\\F0309\";\r\n}\r\n\r\n.mdi-key-remove::before {\r\n  content: \"\\F030A\";\r\n}\r\n\r\n.mdi-key-star::before {\r\n  content: \"\\F119E\";\r\n}\r\n\r\n.mdi-key-variant::before {\r\n  content: \"\\F030B\";\r\n}\r\n\r\n.mdi-key-wireless::before {\r\n  content: \"\\F0FC2\";\r\n}\r\n\r\n.mdi-keyboard::before {\r\n  content: \"\\F030C\";\r\n}\r\n\r\n.mdi-keyboard-backspace::before {\r\n  content: \"\\F030D\";\r\n}\r\n\r\n.mdi-keyboard-caps::before {\r\n  content: \"\\F030E\";\r\n}\r\n\r\n.mdi-keyboard-close::before {\r\n  content: \"\\F030F\";\r\n}\r\n\r\n.mdi-keyboard-esc::before {\r\n  content: \"\\F12B7\";\r\n}\r\n\r\n.mdi-keyboard-f1::before {\r\n  content: \"\\F12AB\";\r\n}\r\n\r\n.mdi-keyboard-f10::before {\r\n  content: \"\\F12B4\";\r\n}\r\n\r\n.mdi-keyboard-f11::before {\r\n  content: \"\\F12B5\";\r\n}\r\n\r\n.mdi-keyboard-f12::before {\r\n  content: \"\\F12B6\";\r\n}\r\n\r\n.mdi-keyboard-f2::before {\r\n  content: \"\\F12AC\";\r\n}\r\n\r\n.mdi-keyboard-f3::before {\r\n  content: \"\\F12AD\";\r\n}\r\n\r\n.mdi-keyboard-f4::before {\r\n  content: \"\\F12AE\";\r\n}\r\n\r\n.mdi-keyboard-f5::before {\r\n  content: \"\\F12AF\";\r\n}\r\n\r\n.mdi-keyboard-f6::before {\r\n  content: \"\\F12B0\";\r\n}\r\n\r\n.mdi-keyboard-f7::before {\r\n  content: \"\\F12B1\";\r\n}\r\n\r\n.mdi-keyboard-f8::before {\r\n  content: \"\\F12B2\";\r\n}\r\n\r\n.mdi-keyboard-f9::before {\r\n  content: \"\\F12B3\";\r\n}\r\n\r\n.mdi-keyboard-off::before {\r\n  content: \"\\F0310\";\r\n}\r\n\r\n.mdi-keyboard-off-outline::before {\r\n  content: \"\\F0E4B\";\r\n}\r\n\r\n.mdi-keyboard-outline::before {\r\n  content: \"\\F097B\";\r\n}\r\n\r\n.mdi-keyboard-return::before {\r\n  content: \"\\F0311\";\r\n}\r\n\r\n.mdi-keyboard-settings::before {\r\n  content: \"\\F09F9\";\r\n}\r\n\r\n.mdi-keyboard-settings-outline::before {\r\n  content: \"\\F09FA\";\r\n}\r\n\r\n.mdi-keyboard-space::before {\r\n  content: \"\\F1050\";\r\n}\r\n\r\n.mdi-keyboard-tab::before {\r\n  content: \"\\F0312\";\r\n}\r\n\r\n.mdi-keyboard-tab-reverse::before {\r\n  content: \"\\F0325\";\r\n}\r\n\r\n.mdi-keyboard-variant::before {\r\n  content: \"\\F0313\";\r\n}\r\n\r\n.mdi-khanda::before {\r\n  content: \"\\F10FD\";\r\n}\r\n\r\n.mdi-kickstarter::before {\r\n  content: \"\\F0745\";\r\n}\r\n\r\n.mdi-kite::before {\r\n  content: \"\\F1985\";\r\n}\r\n\r\n.mdi-kite-outline::before {\r\n  content: \"\\F1986\";\r\n}\r\n\r\n.mdi-kitesurfing::before {\r\n  content: \"\\F1744\";\r\n}\r\n\r\n.mdi-klingon::before {\r\n  content: \"\\F135B\";\r\n}\r\n\r\n.mdi-knife::before {\r\n  content: \"\\F09FB\";\r\n}\r\n\r\n.mdi-knife-military::before {\r\n  content: \"\\F09FC\";\r\n}\r\n\r\n.mdi-koala::before {\r\n  content: \"\\F173F\";\r\n}\r\n\r\n.mdi-kodi::before {\r\n  content: \"\\F0314\";\r\n}\r\n\r\n.mdi-kubernetes::before {\r\n  content: \"\\F10FE\";\r\n}\r\n\r\n.mdi-label::before {\r\n  content: \"\\F0315\";\r\n}\r\n\r\n.mdi-label-multiple::before {\r\n  content: \"\\F1375\";\r\n}\r\n\r\n.mdi-label-multiple-outline::before {\r\n  content: \"\\F1376\";\r\n}\r\n\r\n.mdi-label-off::before {\r\n  content: \"\\F0ACB\";\r\n}\r\n\r\n.mdi-label-off-outline::before {\r\n  content: \"\\F0ACC\";\r\n}\r\n\r\n.mdi-label-outline::before {\r\n  content: \"\\F0316\";\r\n}\r\n\r\n.mdi-label-percent::before {\r\n  content: \"\\F12EA\";\r\n}\r\n\r\n.mdi-label-percent-outline::before {\r\n  content: \"\\F12EB\";\r\n}\r\n\r\n.mdi-label-variant::before {\r\n  content: \"\\F0ACD\";\r\n}\r\n\r\n.mdi-label-variant-outline::before {\r\n  content: \"\\F0ACE\";\r\n}\r\n\r\n.mdi-ladder::before {\r\n  content: \"\\F15A2\";\r\n}\r\n\r\n.mdi-ladybug::before {\r\n  content: \"\\F082D\";\r\n}\r\n\r\n.mdi-lambda::before {\r\n  content: \"\\F0627\";\r\n}\r\n\r\n.mdi-lamp::before {\r\n  content: \"\\F06B5\";\r\n}\r\n\r\n.mdi-lamp-outline::before {\r\n  content: \"\\F17D0\";\r\n}\r\n\r\n.mdi-lamps::before {\r\n  content: \"\\F1576\";\r\n}\r\n\r\n.mdi-lamps-outline::before {\r\n  content: \"\\F17D1\";\r\n}\r\n\r\n.mdi-lan::before {\r\n  content: \"\\F0317\";\r\n}\r\n\r\n.mdi-lan-check::before {\r\n  content: \"\\F12AA\";\r\n}\r\n\r\n.mdi-lan-connect::before {\r\n  content: \"\\F0318\";\r\n}\r\n\r\n.mdi-lan-disconnect::before {\r\n  content: \"\\F0319\";\r\n}\r\n\r\n.mdi-lan-pending::before {\r\n  content: \"\\F031A\";\r\n}\r\n\r\n.mdi-language-c::before {\r\n  content: \"\\F0671\";\r\n}\r\n\r\n.mdi-language-cpp::before {\r\n  content: \"\\F0672\";\r\n}\r\n\r\n.mdi-language-csharp::before {\r\n  content: \"\\F031B\";\r\n}\r\n\r\n.mdi-language-css3::before {\r\n  content: \"\\F031C\";\r\n}\r\n\r\n.mdi-language-fortran::before {\r\n  content: \"\\F121A\";\r\n}\r\n\r\n.mdi-language-go::before {\r\n  content: \"\\F07D3\";\r\n}\r\n\r\n.mdi-language-haskell::before {\r\n  content: \"\\F0C92\";\r\n}\r\n\r\n.mdi-language-html5::before {\r\n  content: \"\\F031D\";\r\n}\r\n\r\n.mdi-language-java::before {\r\n  content: \"\\F0B37\";\r\n}\r\n\r\n.mdi-language-javascript::before {\r\n  content: \"\\F031E\";\r\n}\r\n\r\n.mdi-language-kotlin::before {\r\n  content: \"\\F1219\";\r\n}\r\n\r\n.mdi-language-lua::before {\r\n  content: \"\\F08B1\";\r\n}\r\n\r\n.mdi-language-markdown::before {\r\n  content: \"\\F0354\";\r\n}\r\n\r\n.mdi-language-markdown-outline::before {\r\n  content: \"\\F0F5B\";\r\n}\r\n\r\n.mdi-language-php::before {\r\n  content: \"\\F031F\";\r\n}\r\n\r\n.mdi-language-python::before {\r\n  content: \"\\F0320\";\r\n}\r\n\r\n.mdi-language-r::before {\r\n  content: \"\\F07D4\";\r\n}\r\n\r\n.mdi-language-ruby::before {\r\n  content: \"\\F0D2D\";\r\n}\r\n\r\n.mdi-language-ruby-on-rails::before {\r\n  content: \"\\F0ACF\";\r\n}\r\n\r\n.mdi-language-rust::before {\r\n  content: \"\\F1617\";\r\n}\r\n\r\n.mdi-language-swift::before {\r\n  content: \"\\F06E5\";\r\n}\r\n\r\n.mdi-language-typescript::before {\r\n  content: \"\\F06E6\";\r\n}\r\n\r\n.mdi-language-xaml::before {\r\n  content: \"\\F0673\";\r\n}\r\n\r\n.mdi-laptop::before {\r\n  content: \"\\F0322\";\r\n}\r\n\r\n.mdi-laptop-off::before {\r\n  content: \"\\F06E7\";\r\n}\r\n\r\n.mdi-laravel::before {\r\n  content: \"\\F0AD0\";\r\n}\r\n\r\n.mdi-laser-pointer::before {\r\n  content: \"\\F1484\";\r\n}\r\n\r\n.mdi-lasso::before {\r\n  content: \"\\F0F03\";\r\n}\r\n\r\n.mdi-lastpass::before {\r\n  content: \"\\F0446\";\r\n}\r\n\r\n.mdi-latitude::before {\r\n  content: \"\\F0F57\";\r\n}\r\n\r\n.mdi-launch::before {\r\n  content: \"\\F0327\";\r\n}\r\n\r\n.mdi-lava-lamp::before {\r\n  content: \"\\F07D5\";\r\n}\r\n\r\n.mdi-layers::before {\r\n  content: \"\\F0328\";\r\n}\r\n\r\n.mdi-layers-edit::before {\r\n  content: \"\\F1892\";\r\n}\r\n\r\n.mdi-layers-minus::before {\r\n  content: \"\\F0E4C\";\r\n}\r\n\r\n.mdi-layers-off::before {\r\n  content: \"\\F0329\";\r\n}\r\n\r\n.mdi-layers-off-outline::before {\r\n  content: \"\\F09FD\";\r\n}\r\n\r\n.mdi-layers-outline::before {\r\n  content: \"\\F09FE\";\r\n}\r\n\r\n.mdi-layers-plus::before {\r\n  content: \"\\F0E4D\";\r\n}\r\n\r\n.mdi-layers-remove::before {\r\n  content: \"\\F0E4E\";\r\n}\r\n\r\n.mdi-layers-search::before {\r\n  content: \"\\F1206\";\r\n}\r\n\r\n.mdi-layers-search-outline::before {\r\n  content: \"\\F1207\";\r\n}\r\n\r\n.mdi-layers-triple::before {\r\n  content: \"\\F0F58\";\r\n}\r\n\r\n.mdi-layers-triple-outline::before {\r\n  content: \"\\F0F59\";\r\n}\r\n\r\n.mdi-lead-pencil::before {\r\n  content: \"\\F064F\";\r\n}\r\n\r\n.mdi-leaf::before {\r\n  content: \"\\F032A\";\r\n}\r\n\r\n.mdi-leaf-circle::before {\r\n  content: \"\\F1905\";\r\n}\r\n\r\n.mdi-leaf-circle-outline::before {\r\n  content: \"\\F1906\";\r\n}\r\n\r\n.mdi-leaf-maple::before {\r\n  content: \"\\F0C93\";\r\n}\r\n\r\n.mdi-leaf-maple-off::before {\r\n  content: \"\\F12DA\";\r\n}\r\n\r\n.mdi-leaf-off::before {\r\n  content: \"\\F12D9\";\r\n}\r\n\r\n.mdi-leak::before {\r\n  content: \"\\F0DD7\";\r\n}\r\n\r\n.mdi-leak-off::before {\r\n  content: \"\\F0DD8\";\r\n}\r\n\r\n.mdi-led-off::before {\r\n  content: \"\\F032B\";\r\n}\r\n\r\n.mdi-led-on::before {\r\n  content: \"\\F032C\";\r\n}\r\n\r\n.mdi-led-outline::before {\r\n  content: \"\\F032D\";\r\n}\r\n\r\n.mdi-led-strip::before {\r\n  content: \"\\F07D6\";\r\n}\r\n\r\n.mdi-led-strip-variant::before {\r\n  content: \"\\F1051\";\r\n}\r\n\r\n.mdi-led-variant-off::before {\r\n  content: \"\\F032E\";\r\n}\r\n\r\n.mdi-led-variant-on::before {\r\n  content: \"\\F032F\";\r\n}\r\n\r\n.mdi-led-variant-outline::before {\r\n  content: \"\\F0330\";\r\n}\r\n\r\n.mdi-leek::before {\r\n  content: \"\\F117D\";\r\n}\r\n\r\n.mdi-less-than::before {\r\n  content: \"\\F097C\";\r\n}\r\n\r\n.mdi-less-than-or-equal::before {\r\n  content: \"\\F097D\";\r\n}\r\n\r\n.mdi-library::before {\r\n  content: \"\\F0331\";\r\n}\r\n\r\n.mdi-library-shelves::before {\r\n  content: \"\\F0BA9\";\r\n}\r\n\r\n.mdi-license::before {\r\n  content: \"\\F0FC3\";\r\n}\r\n\r\n.mdi-lifebuoy::before {\r\n  content: \"\\F087E\";\r\n}\r\n\r\n.mdi-light-flood-down::before {\r\n  content: \"\\F1987\";\r\n}\r\n\r\n.mdi-light-flood-up::before {\r\n  content: \"\\F1988\";\r\n}\r\n\r\n.mdi-light-recessed::before {\r\n  content: \"\\F179B\";\r\n}\r\n\r\n.mdi-light-switch::before {\r\n  content: \"\\F097E\";\r\n}\r\n\r\n.mdi-lightbulb::before {\r\n  content: \"\\F0335\";\r\n}\r\n\r\n.mdi-lightbulb-auto::before {\r\n  content: \"\\F1800\";\r\n}\r\n\r\n.mdi-lightbulb-auto-outline::before {\r\n  content: \"\\F1801\";\r\n}\r\n\r\n.mdi-lightbulb-cfl::before {\r\n  content: \"\\F1208\";\r\n}\r\n\r\n.mdi-lightbulb-cfl-off::before {\r\n  content: \"\\F1209\";\r\n}\r\n\r\n.mdi-lightbulb-cfl-spiral::before {\r\n  content: \"\\F1275\";\r\n}\r\n\r\n.mdi-lightbulb-cfl-spiral-off::before {\r\n  content: \"\\F12C3\";\r\n}\r\n\r\n.mdi-lightbulb-fluorescent-tube::before {\r\n  content: \"\\F1804\";\r\n}\r\n\r\n.mdi-lightbulb-fluorescent-tube-outline::before {\r\n  content: \"\\F1805\";\r\n}\r\n\r\n.mdi-lightbulb-group::before {\r\n  content: \"\\F1253\";\r\n}\r\n\r\n.mdi-lightbulb-group-off::before {\r\n  content: \"\\F12CD\";\r\n}\r\n\r\n.mdi-lightbulb-group-off-outline::before {\r\n  content: \"\\F12CE\";\r\n}\r\n\r\n.mdi-lightbulb-group-outline::before {\r\n  content: \"\\F1254\";\r\n}\r\n\r\n.mdi-lightbulb-multiple::before {\r\n  content: \"\\F1255\";\r\n}\r\n\r\n.mdi-lightbulb-multiple-off::before {\r\n  content: \"\\F12CF\";\r\n}\r\n\r\n.mdi-lightbulb-multiple-off-outline::before {\r\n  content: \"\\F12D0\";\r\n}\r\n\r\n.mdi-lightbulb-multiple-outline::before {\r\n  content: \"\\F1256\";\r\n}\r\n\r\n.mdi-lightbulb-off::before {\r\n  content: \"\\F0E4F\";\r\n}\r\n\r\n.mdi-lightbulb-off-outline::before {\r\n  content: \"\\F0E50\";\r\n}\r\n\r\n.mdi-lightbulb-on::before {\r\n  content: \"\\F06E8\";\r\n}\r\n\r\n.mdi-lightbulb-on-outline::before {\r\n  content: \"\\F06E9\";\r\n}\r\n\r\n.mdi-lightbulb-outline::before {\r\n  content: \"\\F0336\";\r\n}\r\n\r\n.mdi-lightbulb-spot::before {\r\n  content: \"\\F17F4\";\r\n}\r\n\r\n.mdi-lightbulb-spot-off::before {\r\n  content: \"\\F17F5\";\r\n}\r\n\r\n.mdi-lightbulb-variant::before {\r\n  content: \"\\F1802\";\r\n}\r\n\r\n.mdi-lightbulb-variant-outline::before {\r\n  content: \"\\F1803\";\r\n}\r\n\r\n.mdi-lighthouse::before {\r\n  content: \"\\F09FF\";\r\n}\r\n\r\n.mdi-lighthouse-on::before {\r\n  content: \"\\F0A00\";\r\n}\r\n\r\n.mdi-lightning-bolt::before {\r\n  content: \"\\F140B\";\r\n}\r\n\r\n.mdi-lightning-bolt-circle::before {\r\n  content: \"\\F0820\";\r\n}\r\n\r\n.mdi-lightning-bolt-outline::before {\r\n  content: \"\\F140C\";\r\n}\r\n\r\n.mdi-line-scan::before {\r\n  content: \"\\F0624\";\r\n}\r\n\r\n.mdi-lingerie::before {\r\n  content: \"\\F1476\";\r\n}\r\n\r\n.mdi-link::before {\r\n  content: \"\\F0337\";\r\n}\r\n\r\n.mdi-link-box::before {\r\n  content: \"\\F0D1A\";\r\n}\r\n\r\n.mdi-link-box-outline::before {\r\n  content: \"\\F0D1B\";\r\n}\r\n\r\n.mdi-link-box-variant::before {\r\n  content: \"\\F0D1C\";\r\n}\r\n\r\n.mdi-link-box-variant-outline::before {\r\n  content: \"\\F0D1D\";\r\n}\r\n\r\n.mdi-link-lock::before {\r\n  content: \"\\F10BA\";\r\n}\r\n\r\n.mdi-link-off::before {\r\n  content: \"\\F0338\";\r\n}\r\n\r\n.mdi-link-plus::before {\r\n  content: \"\\F0C94\";\r\n}\r\n\r\n.mdi-link-variant::before {\r\n  content: \"\\F0339\";\r\n}\r\n\r\n.mdi-link-variant-minus::before {\r\n  content: \"\\F10FF\";\r\n}\r\n\r\n.mdi-link-variant-off::before {\r\n  content: \"\\F033A\";\r\n}\r\n\r\n.mdi-link-variant-plus::before {\r\n  content: \"\\F1100\";\r\n}\r\n\r\n.mdi-link-variant-remove::before {\r\n  content: \"\\F1101\";\r\n}\r\n\r\n.mdi-linkedin::before {\r\n  content: \"\\F033B\";\r\n}\r\n\r\n.mdi-linux::before {\r\n  content: \"\\F033D\";\r\n}\r\n\r\n.mdi-linux-mint::before {\r\n  content: \"\\F08ED\";\r\n}\r\n\r\n.mdi-lipstick::before {\r\n  content: \"\\F13B5\";\r\n}\r\n\r\n.mdi-liquid-spot::before {\r\n  content: \"\\F1826\";\r\n}\r\n\r\n.mdi-liquor::before {\r\n  content: \"\\F191E\";\r\n}\r\n\r\n.mdi-list-status::before {\r\n  content: \"\\F15AB\";\r\n}\r\n\r\n.mdi-litecoin::before {\r\n  content: \"\\F0A61\";\r\n}\r\n\r\n.mdi-loading::before {\r\n  content: \"\\F0772\";\r\n}\r\n\r\n.mdi-location-enter::before {\r\n  content: \"\\F0FC4\";\r\n}\r\n\r\n.mdi-location-exit::before {\r\n  content: \"\\F0FC5\";\r\n}\r\n\r\n.mdi-lock::before {\r\n  content: \"\\F033E\";\r\n}\r\n\r\n.mdi-lock-alert::before {\r\n  content: \"\\F08EE\";\r\n}\r\n\r\n.mdi-lock-alert-outline::before {\r\n  content: \"\\F15D1\";\r\n}\r\n\r\n.mdi-lock-check::before {\r\n  content: \"\\F139A\";\r\n}\r\n\r\n.mdi-lock-check-outline::before {\r\n  content: \"\\F16A8\";\r\n}\r\n\r\n.mdi-lock-clock::before {\r\n  content: \"\\F097F\";\r\n}\r\n\r\n.mdi-lock-minus::before {\r\n  content: \"\\F16A9\";\r\n}\r\n\r\n.mdi-lock-minus-outline::before {\r\n  content: \"\\F16AA\";\r\n}\r\n\r\n.mdi-lock-off::before {\r\n  content: \"\\F1671\";\r\n}\r\n\r\n.mdi-lock-off-outline::before {\r\n  content: \"\\F1672\";\r\n}\r\n\r\n.mdi-lock-open::before {\r\n  content: \"\\F033F\";\r\n}\r\n\r\n.mdi-lock-open-alert::before {\r\n  content: \"\\F139B\";\r\n}\r\n\r\n.mdi-lock-open-alert-outline::before {\r\n  content: \"\\F15D2\";\r\n}\r\n\r\n.mdi-lock-open-check::before {\r\n  content: \"\\F139C\";\r\n}\r\n\r\n.mdi-lock-open-check-outline::before {\r\n  content: \"\\F16AB\";\r\n}\r\n\r\n.mdi-lock-open-minus::before {\r\n  content: \"\\F16AC\";\r\n}\r\n\r\n.mdi-lock-open-minus-outline::before {\r\n  content: \"\\F16AD\";\r\n}\r\n\r\n.mdi-lock-open-outline::before {\r\n  content: \"\\F0340\";\r\n}\r\n\r\n.mdi-lock-open-plus::before {\r\n  content: \"\\F16AE\";\r\n}\r\n\r\n.mdi-lock-open-plus-outline::before {\r\n  content: \"\\F16AF\";\r\n}\r\n\r\n.mdi-lock-open-remove::before {\r\n  content: \"\\F16B0\";\r\n}\r\n\r\n.mdi-lock-open-remove-outline::before {\r\n  content: \"\\F16B1\";\r\n}\r\n\r\n.mdi-lock-open-variant::before {\r\n  content: \"\\F0FC6\";\r\n}\r\n\r\n.mdi-lock-open-variant-outline::before {\r\n  content: \"\\F0FC7\";\r\n}\r\n\r\n.mdi-lock-outline::before {\r\n  content: \"\\F0341\";\r\n}\r\n\r\n.mdi-lock-pattern::before {\r\n  content: \"\\F06EA\";\r\n}\r\n\r\n.mdi-lock-plus::before {\r\n  content: \"\\F05FB\";\r\n}\r\n\r\n.mdi-lock-plus-outline::before {\r\n  content: \"\\F16B2\";\r\n}\r\n\r\n.mdi-lock-question::before {\r\n  content: \"\\F08EF\";\r\n}\r\n\r\n.mdi-lock-remove::before {\r\n  content: \"\\F16B3\";\r\n}\r\n\r\n.mdi-lock-remove-outline::before {\r\n  content: \"\\F16B4\";\r\n}\r\n\r\n.mdi-lock-reset::before {\r\n  content: \"\\F0773\";\r\n}\r\n\r\n.mdi-lock-smart::before {\r\n  content: \"\\F08B2\";\r\n}\r\n\r\n.mdi-locker::before {\r\n  content: \"\\F07D7\";\r\n}\r\n\r\n.mdi-locker-multiple::before {\r\n  content: \"\\F07D8\";\r\n}\r\n\r\n.mdi-login::before {\r\n  content: \"\\F0342\";\r\n}\r\n\r\n.mdi-login-variant::before {\r\n  content: \"\\F05FC\";\r\n}\r\n\r\n.mdi-logout::before {\r\n  content: \"\\F0343\";\r\n}\r\n\r\n.mdi-logout-variant::before {\r\n  content: \"\\F05FD\";\r\n}\r\n\r\n.mdi-longitude::before {\r\n  content: \"\\F0F5A\";\r\n}\r\n\r\n.mdi-looks::before {\r\n  content: \"\\F0344\";\r\n}\r\n\r\n.mdi-lotion::before {\r\n  content: \"\\F1582\";\r\n}\r\n\r\n.mdi-lotion-outline::before {\r\n  content: \"\\F1583\";\r\n}\r\n\r\n.mdi-lotion-plus::before {\r\n  content: \"\\F1584\";\r\n}\r\n\r\n.mdi-lotion-plus-outline::before {\r\n  content: \"\\F1585\";\r\n}\r\n\r\n.mdi-loupe::before {\r\n  content: \"\\F0345\";\r\n}\r\n\r\n.mdi-lumx::before {\r\n  content: \"\\F0346\";\r\n}\r\n\r\n.mdi-lungs::before {\r\n  content: \"\\F1084\";\r\n}\r\n\r\n.mdi-mace::before {\r\n  content: \"\\F1843\";\r\n}\r\n\r\n.mdi-magazine-pistol::before {\r\n  content: \"\\F0324\";\r\n}\r\n\r\n.mdi-magazine-rifle::before {\r\n  content: \"\\F0323\";\r\n}\r\n\r\n.mdi-magic-staff::before {\r\n  content: \"\\F1844\";\r\n}\r\n\r\n.mdi-magnet::before {\r\n  content: \"\\F0347\";\r\n}\r\n\r\n.mdi-magnet-on::before {\r\n  content: \"\\F0348\";\r\n}\r\n\r\n.mdi-magnify::before {\r\n  content: \"\\F0349\";\r\n}\r\n\r\n.mdi-magnify-close::before {\r\n  content: \"\\F0980\";\r\n}\r\n\r\n.mdi-magnify-expand::before {\r\n  content: \"\\F1874\";\r\n}\r\n\r\n.mdi-magnify-minus::before {\r\n  content: \"\\F034A\";\r\n}\r\n\r\n.mdi-magnify-minus-cursor::before {\r\n  content: \"\\F0A62\";\r\n}\r\n\r\n.mdi-magnify-minus-outline::before {\r\n  content: \"\\F06EC\";\r\n}\r\n\r\n.mdi-magnify-plus::before {\r\n  content: \"\\F034B\";\r\n}\r\n\r\n.mdi-magnify-plus-cursor::before {\r\n  content: \"\\F0A63\";\r\n}\r\n\r\n.mdi-magnify-plus-outline::before {\r\n  content: \"\\F06ED\";\r\n}\r\n\r\n.mdi-magnify-remove-cursor::before {\r\n  content: \"\\F120C\";\r\n}\r\n\r\n.mdi-magnify-remove-outline::before {\r\n  content: \"\\F120D\";\r\n}\r\n\r\n.mdi-magnify-scan::before {\r\n  content: \"\\F1276\";\r\n}\r\n\r\n.mdi-mail::before {\r\n  content: \"\\F0EBB\";\r\n}\r\n\r\n.mdi-mailbox::before {\r\n  content: \"\\F06EE\";\r\n}\r\n\r\n.mdi-mailbox-open::before {\r\n  content: \"\\F0D88\";\r\n}\r\n\r\n.mdi-mailbox-open-outline::before {\r\n  content: \"\\F0D89\";\r\n}\r\n\r\n.mdi-mailbox-open-up::before {\r\n  content: \"\\F0D8A\";\r\n}\r\n\r\n.mdi-mailbox-open-up-outline::before {\r\n  content: \"\\F0D8B\";\r\n}\r\n\r\n.mdi-mailbox-outline::before {\r\n  content: \"\\F0D8C\";\r\n}\r\n\r\n.mdi-mailbox-up::before {\r\n  content: \"\\F0D8D\";\r\n}\r\n\r\n.mdi-mailbox-up-outline::before {\r\n  content: \"\\F0D8E\";\r\n}\r\n\r\n.mdi-manjaro::before {\r\n  content: \"\\F160A\";\r\n}\r\n\r\n.mdi-map::before {\r\n  content: \"\\F034D\";\r\n}\r\n\r\n.mdi-map-check::before {\r\n  content: \"\\F0EBC\";\r\n}\r\n\r\n.mdi-map-check-outline::before {\r\n  content: \"\\F0EBD\";\r\n}\r\n\r\n.mdi-map-clock::before {\r\n  content: \"\\F0D1E\";\r\n}\r\n\r\n.mdi-map-clock-outline::before {\r\n  content: \"\\F0D1F\";\r\n}\r\n\r\n.mdi-map-legend::before {\r\n  content: \"\\F0A01\";\r\n}\r\n\r\n.mdi-map-marker::before {\r\n  content: \"\\F034E\";\r\n}\r\n\r\n.mdi-map-marker-account::before {\r\n  content: \"\\F18E3\";\r\n}\r\n\r\n.mdi-map-marker-account-outline::before {\r\n  content: \"\\F18E4\";\r\n}\r\n\r\n.mdi-map-marker-alert::before {\r\n  content: \"\\F0F05\";\r\n}\r\n\r\n.mdi-map-marker-alert-outline::before {\r\n  content: \"\\F0F06\";\r\n}\r\n\r\n.mdi-map-marker-check::before {\r\n  content: \"\\F0C95\";\r\n}\r\n\r\n.mdi-map-marker-check-outline::before {\r\n  content: \"\\F12FB\";\r\n}\r\n\r\n.mdi-map-marker-circle::before {\r\n  content: \"\\F034F\";\r\n}\r\n\r\n.mdi-map-marker-distance::before {\r\n  content: \"\\F08F0\";\r\n}\r\n\r\n.mdi-map-marker-down::before {\r\n  content: \"\\F1102\";\r\n}\r\n\r\n.mdi-map-marker-left::before {\r\n  content: \"\\F12DB\";\r\n}\r\n\r\n.mdi-map-marker-left-outline::before {\r\n  content: \"\\F12DD\";\r\n}\r\n\r\n.mdi-map-marker-minus::before {\r\n  content: \"\\F0650\";\r\n}\r\n\r\n.mdi-map-marker-minus-outline::before {\r\n  content: \"\\F12F9\";\r\n}\r\n\r\n.mdi-map-marker-multiple::before {\r\n  content: \"\\F0350\";\r\n}\r\n\r\n.mdi-map-marker-multiple-outline::before {\r\n  content: \"\\F1277\";\r\n}\r\n\r\n.mdi-map-marker-off::before {\r\n  content: \"\\F0351\";\r\n}\r\n\r\n.mdi-map-marker-off-outline::before {\r\n  content: \"\\F12FD\";\r\n}\r\n\r\n.mdi-map-marker-outline::before {\r\n  content: \"\\F07D9\";\r\n}\r\n\r\n.mdi-map-marker-path::before {\r\n  content: \"\\F0D20\";\r\n}\r\n\r\n.mdi-map-marker-plus::before {\r\n  content: \"\\F0651\";\r\n}\r\n\r\n.mdi-map-marker-plus-outline::before {\r\n  content: \"\\F12F8\";\r\n}\r\n\r\n.mdi-map-marker-question::before {\r\n  content: \"\\F0F07\";\r\n}\r\n\r\n.mdi-map-marker-question-outline::before {\r\n  content: \"\\F0F08\";\r\n}\r\n\r\n.mdi-map-marker-radius::before {\r\n  content: \"\\F0352\";\r\n}\r\n\r\n.mdi-map-marker-radius-outline::before {\r\n  content: \"\\F12FC\";\r\n}\r\n\r\n.mdi-map-marker-remove::before {\r\n  content: \"\\F0F09\";\r\n}\r\n\r\n.mdi-map-marker-remove-outline::before {\r\n  content: \"\\F12FA\";\r\n}\r\n\r\n.mdi-map-marker-remove-variant::before {\r\n  content: \"\\F0F0A\";\r\n}\r\n\r\n.mdi-map-marker-right::before {\r\n  content: \"\\F12DC\";\r\n}\r\n\r\n.mdi-map-marker-right-outline::before {\r\n  content: \"\\F12DE\";\r\n}\r\n\r\n.mdi-map-marker-star::before {\r\n  content: \"\\F1608\";\r\n}\r\n\r\n.mdi-map-marker-star-outline::before {\r\n  content: \"\\F1609\";\r\n}\r\n\r\n.mdi-map-marker-up::before {\r\n  content: \"\\F1103\";\r\n}\r\n\r\n.mdi-map-minus::before {\r\n  content: \"\\F0981\";\r\n}\r\n\r\n.mdi-map-outline::before {\r\n  content: \"\\F0982\";\r\n}\r\n\r\n.mdi-map-plus::before {\r\n  content: \"\\F0983\";\r\n}\r\n\r\n.mdi-map-search::before {\r\n  content: \"\\F0984\";\r\n}\r\n\r\n.mdi-map-search-outline::before {\r\n  content: \"\\F0985\";\r\n}\r\n\r\n.mdi-mapbox::before {\r\n  content: \"\\F0BAA\";\r\n}\r\n\r\n.mdi-margin::before {\r\n  content: \"\\F0353\";\r\n}\r\n\r\n.mdi-marker::before {\r\n  content: \"\\F0652\";\r\n}\r\n\r\n.mdi-marker-cancel::before {\r\n  content: \"\\F0DD9\";\r\n}\r\n\r\n.mdi-marker-check::before {\r\n  content: \"\\F0355\";\r\n}\r\n\r\n.mdi-mastodon::before {\r\n  content: \"\\F0AD1\";\r\n}\r\n\r\n.mdi-material-design::before {\r\n  content: \"\\F0986\";\r\n}\r\n\r\n.mdi-material-ui::before {\r\n  content: \"\\F0357\";\r\n}\r\n\r\n.mdi-math-compass::before {\r\n  content: \"\\F0358\";\r\n}\r\n\r\n.mdi-math-cos::before {\r\n  content: \"\\F0C96\";\r\n}\r\n\r\n.mdi-math-integral::before {\r\n  content: \"\\F0FC8\";\r\n}\r\n\r\n.mdi-math-integral-box::before {\r\n  content: \"\\F0FC9\";\r\n}\r\n\r\n.mdi-math-log::before {\r\n  content: \"\\F1085\";\r\n}\r\n\r\n.mdi-math-norm::before {\r\n  content: \"\\F0FCA\";\r\n}\r\n\r\n.mdi-math-norm-box::before {\r\n  content: \"\\F0FCB\";\r\n}\r\n\r\n.mdi-math-sin::before {\r\n  content: \"\\F0C97\";\r\n}\r\n\r\n.mdi-math-tan::before {\r\n  content: \"\\F0C98\";\r\n}\r\n\r\n.mdi-matrix::before {\r\n  content: \"\\F0628\";\r\n}\r\n\r\n.mdi-medal::before {\r\n  content: \"\\F0987\";\r\n}\r\n\r\n.mdi-medal-outline::before {\r\n  content: \"\\F1326\";\r\n}\r\n\r\n.mdi-medical-bag::before {\r\n  content: \"\\F06EF\";\r\n}\r\n\r\n.mdi-meditation::before {\r\n  content: \"\\F117B\";\r\n}\r\n\r\n.mdi-memory::before {\r\n  content: \"\\F035B\";\r\n}\r\n\r\n.mdi-menorah::before {\r\n  content: \"\\F17D4\";\r\n}\r\n\r\n.mdi-menorah-fire::before {\r\n  content: \"\\F17D5\";\r\n}\r\n\r\n.mdi-menu::before {\r\n  content: \"\\F035C\";\r\n}\r\n\r\n.mdi-menu-down::before {\r\n  content: \"\\F035D\";\r\n}\r\n\r\n.mdi-menu-down-outline::before {\r\n  content: \"\\F06B6\";\r\n}\r\n\r\n.mdi-menu-left::before {\r\n  content: \"\\F035E\";\r\n}\r\n\r\n.mdi-menu-left-outline::before {\r\n  content: \"\\F0A02\";\r\n}\r\n\r\n.mdi-menu-open::before {\r\n  content: \"\\F0BAB\";\r\n}\r\n\r\n.mdi-menu-right::before {\r\n  content: \"\\F035F\";\r\n}\r\n\r\n.mdi-menu-right-outline::before {\r\n  content: \"\\F0A03\";\r\n}\r\n\r\n.mdi-menu-swap::before {\r\n  content: \"\\F0A64\";\r\n}\r\n\r\n.mdi-menu-swap-outline::before {\r\n  content: \"\\F0A65\";\r\n}\r\n\r\n.mdi-menu-up::before {\r\n  content: \"\\F0360\";\r\n}\r\n\r\n.mdi-menu-up-outline::before {\r\n  content: \"\\F06B7\";\r\n}\r\n\r\n.mdi-merge::before {\r\n  content: \"\\F0F5C\";\r\n}\r\n\r\n.mdi-message::before {\r\n  content: \"\\F0361\";\r\n}\r\n\r\n.mdi-message-alert::before {\r\n  content: \"\\F0362\";\r\n}\r\n\r\n.mdi-message-alert-outline::before {\r\n  content: \"\\F0A04\";\r\n}\r\n\r\n.mdi-message-arrow-left::before {\r\n  content: \"\\F12F2\";\r\n}\r\n\r\n.mdi-message-arrow-left-outline::before {\r\n  content: \"\\F12F3\";\r\n}\r\n\r\n.mdi-message-arrow-right::before {\r\n  content: \"\\F12F4\";\r\n}\r\n\r\n.mdi-message-arrow-right-outline::before {\r\n  content: \"\\F12F5\";\r\n}\r\n\r\n.mdi-message-badge::before {\r\n  content: \"\\F1941\";\r\n}\r\n\r\n.mdi-message-badge-outline::before {\r\n  content: \"\\F1942\";\r\n}\r\n\r\n.mdi-message-bookmark::before {\r\n  content: \"\\F15AC\";\r\n}\r\n\r\n.mdi-message-bookmark-outline::before {\r\n  content: \"\\F15AD\";\r\n}\r\n\r\n.mdi-message-bulleted::before {\r\n  content: \"\\F06A2\";\r\n}\r\n\r\n.mdi-message-bulleted-off::before {\r\n  content: \"\\F06A3\";\r\n}\r\n\r\n.mdi-message-cog::before {\r\n  content: \"\\F06F1\";\r\n}\r\n\r\n.mdi-message-cog-outline::before {\r\n  content: \"\\F1172\";\r\n}\r\n\r\n.mdi-message-draw::before {\r\n  content: \"\\F0363\";\r\n}\r\n\r\n.mdi-message-flash::before {\r\n  content: \"\\F15A9\";\r\n}\r\n\r\n.mdi-message-flash-outline::before {\r\n  content: \"\\F15AA\";\r\n}\r\n\r\n.mdi-message-image::before {\r\n  content: \"\\F0364\";\r\n}\r\n\r\n.mdi-message-image-outline::before {\r\n  content: \"\\F116C\";\r\n}\r\n\r\n.mdi-message-lock::before {\r\n  content: \"\\F0FCC\";\r\n}\r\n\r\n.mdi-message-lock-outline::before {\r\n  content: \"\\F116D\";\r\n}\r\n\r\n.mdi-message-minus::before {\r\n  content: \"\\F116E\";\r\n}\r\n\r\n.mdi-message-minus-outline::before {\r\n  content: \"\\F116F\";\r\n}\r\n\r\n.mdi-message-off::before {\r\n  content: \"\\F164D\";\r\n}\r\n\r\n.mdi-message-off-outline::before {\r\n  content: \"\\F164E\";\r\n}\r\n\r\n.mdi-message-outline::before {\r\n  content: \"\\F0365\";\r\n}\r\n\r\n.mdi-message-plus::before {\r\n  content: \"\\F0653\";\r\n}\r\n\r\n.mdi-message-plus-outline::before {\r\n  content: \"\\F10BB\";\r\n}\r\n\r\n.mdi-message-processing::before {\r\n  content: \"\\F0366\";\r\n}\r\n\r\n.mdi-message-processing-outline::before {\r\n  content: \"\\F1170\";\r\n}\r\n\r\n.mdi-message-question::before {\r\n  content: \"\\F173A\";\r\n}\r\n\r\n.mdi-message-question-outline::before {\r\n  content: \"\\F173B\";\r\n}\r\n\r\n.mdi-message-reply::before {\r\n  content: \"\\F0367\";\r\n}\r\n\r\n.mdi-message-reply-outline::before {\r\n  content: \"\\F173D\";\r\n}\r\n\r\n.mdi-message-reply-text::before {\r\n  content: \"\\F0368\";\r\n}\r\n\r\n.mdi-message-reply-text-outline::before {\r\n  content: \"\\F173E\";\r\n}\r\n\r\n.mdi-message-settings::before {\r\n  content: \"\\F06F0\";\r\n}\r\n\r\n.mdi-message-settings-outline::before {\r\n  content: \"\\F1171\";\r\n}\r\n\r\n.mdi-message-star::before {\r\n  content: \"\\F069A\";\r\n}\r\n\r\n.mdi-message-star-outline::before {\r\n  content: \"\\F1250\";\r\n}\r\n\r\n.mdi-message-text::before {\r\n  content: \"\\F0369\";\r\n}\r\n\r\n.mdi-message-text-clock::before {\r\n  content: \"\\F1173\";\r\n}\r\n\r\n.mdi-message-text-clock-outline::before {\r\n  content: \"\\F1174\";\r\n}\r\n\r\n.mdi-message-text-lock::before {\r\n  content: \"\\F0FCD\";\r\n}\r\n\r\n.mdi-message-text-lock-outline::before {\r\n  content: \"\\F1175\";\r\n}\r\n\r\n.mdi-message-text-outline::before {\r\n  content: \"\\F036A\";\r\n}\r\n\r\n.mdi-message-video::before {\r\n  content: \"\\F036B\";\r\n}\r\n\r\n.mdi-meteor::before {\r\n  content: \"\\F0629\";\r\n}\r\n\r\n.mdi-metronome::before {\r\n  content: \"\\F07DA\";\r\n}\r\n\r\n.mdi-metronome-tick::before {\r\n  content: \"\\F07DB\";\r\n}\r\n\r\n.mdi-micro-sd::before {\r\n  content: \"\\F07DC\";\r\n}\r\n\r\n.mdi-microphone::before {\r\n  content: \"\\F036C\";\r\n}\r\n\r\n.mdi-microphone-minus::before {\r\n  content: \"\\F08B3\";\r\n}\r\n\r\n.mdi-microphone-off::before {\r\n  content: \"\\F036D\";\r\n}\r\n\r\n.mdi-microphone-outline::before {\r\n  content: \"\\F036E\";\r\n}\r\n\r\n.mdi-microphone-plus::before {\r\n  content: \"\\F08B4\";\r\n}\r\n\r\n.mdi-microphone-question::before {\r\n  content: \"\\F1989\";\r\n}\r\n\r\n.mdi-microphone-question-outline::before {\r\n  content: \"\\F198A\";\r\n}\r\n\r\n.mdi-microphone-settings::before {\r\n  content: \"\\F036F\";\r\n}\r\n\r\n.mdi-microphone-variant::before {\r\n  content: \"\\F0370\";\r\n}\r\n\r\n.mdi-microphone-variant-off::before {\r\n  content: \"\\F0371\";\r\n}\r\n\r\n.mdi-microscope::before {\r\n  content: \"\\F0654\";\r\n}\r\n\r\n.mdi-microsoft::before {\r\n  content: \"\\F0372\";\r\n}\r\n\r\n.mdi-microsoft-access::before {\r\n  content: \"\\F138E\";\r\n}\r\n\r\n.mdi-microsoft-azure::before {\r\n  content: \"\\F0805\";\r\n}\r\n\r\n.mdi-microsoft-azure-devops::before {\r\n  content: \"\\F0FD5\";\r\n}\r\n\r\n.mdi-microsoft-bing::before {\r\n  content: \"\\F00A4\";\r\n}\r\n\r\n.mdi-microsoft-dynamics-365::before {\r\n  content: \"\\F0988\";\r\n}\r\n\r\n.mdi-microsoft-edge::before {\r\n  content: \"\\F01E9\";\r\n}\r\n\r\n.mdi-microsoft-excel::before {\r\n  content: \"\\F138F\";\r\n}\r\n\r\n.mdi-microsoft-internet-explorer::before {\r\n  content: \"\\F0300\";\r\n}\r\n\r\n.mdi-microsoft-office::before {\r\n  content: \"\\F03C6\";\r\n}\r\n\r\n.mdi-microsoft-onedrive::before {\r\n  content: \"\\F03CA\";\r\n}\r\n\r\n.mdi-microsoft-onenote::before {\r\n  content: \"\\F0747\";\r\n}\r\n\r\n.mdi-microsoft-outlook::before {\r\n  content: \"\\F0D22\";\r\n}\r\n\r\n.mdi-microsoft-powerpoint::before {\r\n  content: \"\\F1390\";\r\n}\r\n\r\n.mdi-microsoft-sharepoint::before {\r\n  content: \"\\F1391\";\r\n}\r\n\r\n.mdi-microsoft-teams::before {\r\n  content: \"\\F02BB\";\r\n}\r\n\r\n.mdi-microsoft-visual-studio::before {\r\n  content: \"\\F0610\";\r\n}\r\n\r\n.mdi-microsoft-visual-studio-code::before {\r\n  content: \"\\F0A1E\";\r\n}\r\n\r\n.mdi-microsoft-windows::before {\r\n  content: \"\\F05B3\";\r\n}\r\n\r\n.mdi-microsoft-windows-classic::before {\r\n  content: \"\\F0A21\";\r\n}\r\n\r\n.mdi-microsoft-word::before {\r\n  content: \"\\F1392\";\r\n}\r\n\r\n.mdi-microsoft-xbox::before {\r\n  content: \"\\F05B9\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller::before {\r\n  content: \"\\F05BA\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-alert::before {\r\n  content: \"\\F074B\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-charging::before {\r\n  content: \"\\F0A22\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-empty::before {\r\n  content: \"\\F074C\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-full::before {\r\n  content: \"\\F074D\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-low::before {\r\n  content: \"\\F074E\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-medium::before {\r\n  content: \"\\F074F\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-unknown::before {\r\n  content: \"\\F0750\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-menu::before {\r\n  content: \"\\F0E6F\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-off::before {\r\n  content: \"\\F05BB\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-view::before {\r\n  content: \"\\F0E70\";\r\n}\r\n\r\n.mdi-microwave::before {\r\n  content: \"\\F0C99\";\r\n}\r\n\r\n.mdi-microwave-off::before {\r\n  content: \"\\F1423\";\r\n}\r\n\r\n.mdi-middleware::before {\r\n  content: \"\\F0F5D\";\r\n}\r\n\r\n.mdi-middleware-outline::before {\r\n  content: \"\\F0F5E\";\r\n}\r\n\r\n.mdi-midi::before {\r\n  content: \"\\F08F1\";\r\n}\r\n\r\n.mdi-midi-port::before {\r\n  content: \"\\F08F2\";\r\n}\r\n\r\n.mdi-mine::before {\r\n  content: \"\\F0DDA\";\r\n}\r\n\r\n.mdi-minecraft::before {\r\n  content: \"\\F0373\";\r\n}\r\n\r\n.mdi-mini-sd::before {\r\n  content: \"\\F0A05\";\r\n}\r\n\r\n.mdi-minidisc::before {\r\n  content: \"\\F0A06\";\r\n}\r\n\r\n.mdi-minus::before {\r\n  content: \"\\F0374\";\r\n}\r\n\r\n.mdi-minus-box::before {\r\n  content: \"\\F0375\";\r\n}\r\n\r\n.mdi-minus-box-multiple::before {\r\n  content: \"\\F1141\";\r\n}\r\n\r\n.mdi-minus-box-multiple-outline::before {\r\n  content: \"\\F1142\";\r\n}\r\n\r\n.mdi-minus-box-outline::before {\r\n  content: \"\\F06F2\";\r\n}\r\n\r\n.mdi-minus-circle::before {\r\n  content: \"\\F0376\";\r\n}\r\n\r\n.mdi-minus-circle-multiple::before {\r\n  content: \"\\F035A\";\r\n}\r\n\r\n.mdi-minus-circle-multiple-outline::before {\r\n  content: \"\\F0AD3\";\r\n}\r\n\r\n.mdi-minus-circle-off::before {\r\n  content: \"\\F1459\";\r\n}\r\n\r\n.mdi-minus-circle-off-outline::before {\r\n  content: \"\\F145A\";\r\n}\r\n\r\n.mdi-minus-circle-outline::before {\r\n  content: \"\\F0377\";\r\n}\r\n\r\n.mdi-minus-network::before {\r\n  content: \"\\F0378\";\r\n}\r\n\r\n.mdi-minus-network-outline::before {\r\n  content: \"\\F0C9A\";\r\n}\r\n\r\n.mdi-minus-thick::before {\r\n  content: \"\\F1639\";\r\n}\r\n\r\n.mdi-mirror::before {\r\n  content: \"\\F11FD\";\r\n}\r\n\r\n.mdi-mirror-rectangle::before {\r\n  content: \"\\F179F\";\r\n}\r\n\r\n.mdi-mirror-variant::before {\r\n  content: \"\\F17A0\";\r\n}\r\n\r\n.mdi-mixed-martial-arts::before {\r\n  content: \"\\F0D8F\";\r\n}\r\n\r\n.mdi-mixed-reality::before {\r\n  content: \"\\F087F\";\r\n}\r\n\r\n.mdi-molecule::before {\r\n  content: \"\\F0BAC\";\r\n}\r\n\r\n.mdi-molecule-co::before {\r\n  content: \"\\F12FE\";\r\n}\r\n\r\n.mdi-molecule-co2::before {\r\n  content: \"\\F07E4\";\r\n}\r\n\r\n.mdi-monitor::before {\r\n  content: \"\\F0379\";\r\n}\r\n\r\n.mdi-monitor-cellphone::before {\r\n  content: \"\\F0989\";\r\n}\r\n\r\n.mdi-monitor-cellphone-star::before {\r\n  content: \"\\F098A\";\r\n}\r\n\r\n.mdi-monitor-dashboard::before {\r\n  content: \"\\F0A07\";\r\n}\r\n\r\n.mdi-monitor-edit::before {\r\n  content: \"\\F12C6\";\r\n}\r\n\r\n.mdi-monitor-eye::before {\r\n  content: \"\\F13B4\";\r\n}\r\n\r\n.mdi-monitor-lock::before {\r\n  content: \"\\F0DDB\";\r\n}\r\n\r\n.mdi-monitor-multiple::before {\r\n  content: \"\\F037A\";\r\n}\r\n\r\n.mdi-monitor-off::before {\r\n  content: \"\\F0D90\";\r\n}\r\n\r\n.mdi-monitor-screenshot::before {\r\n  content: \"\\F0E51\";\r\n}\r\n\r\n.mdi-monitor-share::before {\r\n  content: \"\\F1483\";\r\n}\r\n\r\n.mdi-monitor-shimmer::before {\r\n  content: \"\\F1104\";\r\n}\r\n\r\n.mdi-monitor-small::before {\r\n  content: \"\\F1876\";\r\n}\r\n\r\n.mdi-monitor-speaker::before {\r\n  content: \"\\F0F5F\";\r\n}\r\n\r\n.mdi-monitor-speaker-off::before {\r\n  content: \"\\F0F60\";\r\n}\r\n\r\n.mdi-monitor-star::before {\r\n  content: \"\\F0DDC\";\r\n}\r\n\r\n.mdi-moon-first-quarter::before {\r\n  content: \"\\F0F61\";\r\n}\r\n\r\n.mdi-moon-full::before {\r\n  content: \"\\F0F62\";\r\n}\r\n\r\n.mdi-moon-last-quarter::before {\r\n  content: \"\\F0F63\";\r\n}\r\n\r\n.mdi-moon-new::before {\r\n  content: \"\\F0F64\";\r\n}\r\n\r\n.mdi-moon-waning-crescent::before {\r\n  content: \"\\F0F65\";\r\n}\r\n\r\n.mdi-moon-waning-gibbous::before {\r\n  content: \"\\F0F66\";\r\n}\r\n\r\n.mdi-moon-waxing-crescent::before {\r\n  content: \"\\F0F67\";\r\n}\r\n\r\n.mdi-moon-waxing-gibbous::before {\r\n  content: \"\\F0F68\";\r\n}\r\n\r\n.mdi-moped::before {\r\n  content: \"\\F1086\";\r\n}\r\n\r\n.mdi-moped-electric::before {\r\n  content: \"\\F15B7\";\r\n}\r\n\r\n.mdi-moped-electric-outline::before {\r\n  content: \"\\F15B8\";\r\n}\r\n\r\n.mdi-moped-outline::before {\r\n  content: \"\\F15B9\";\r\n}\r\n\r\n.mdi-more::before {\r\n  content: \"\\F037B\";\r\n}\r\n\r\n.mdi-mortar-pestle::before {\r\n  content: \"\\F1748\";\r\n}\r\n\r\n.mdi-mortar-pestle-plus::before {\r\n  content: \"\\F03F1\";\r\n}\r\n\r\n.mdi-mosque::before {\r\n  content: \"\\F1827\";\r\n}\r\n\r\n.mdi-mother-heart::before {\r\n  content: \"\\F1314\";\r\n}\r\n\r\n.mdi-mother-nurse::before {\r\n  content: \"\\F0D21\";\r\n}\r\n\r\n.mdi-motion::before {\r\n  content: \"\\F15B2\";\r\n}\r\n\r\n.mdi-motion-outline::before {\r\n  content: \"\\F15B3\";\r\n}\r\n\r\n.mdi-motion-pause::before {\r\n  content: \"\\F1590\";\r\n}\r\n\r\n.mdi-motion-pause-outline::before {\r\n  content: \"\\F1592\";\r\n}\r\n\r\n.mdi-motion-play::before {\r\n  content: \"\\F158F\";\r\n}\r\n\r\n.mdi-motion-play-outline::before {\r\n  content: \"\\F1591\";\r\n}\r\n\r\n.mdi-motion-sensor::before {\r\n  content: \"\\F0D91\";\r\n}\r\n\r\n.mdi-motion-sensor-off::before {\r\n  content: \"\\F1435\";\r\n}\r\n\r\n.mdi-motorbike::before {\r\n  content: \"\\F037C\";\r\n}\r\n\r\n.mdi-motorbike-electric::before {\r\n  content: \"\\F15BA\";\r\n}\r\n\r\n.mdi-mouse::before {\r\n  content: \"\\F037D\";\r\n}\r\n\r\n.mdi-mouse-bluetooth::before {\r\n  content: \"\\F098B\";\r\n}\r\n\r\n.mdi-mouse-move-down::before {\r\n  content: \"\\F1550\";\r\n}\r\n\r\n.mdi-mouse-move-up::before {\r\n  content: \"\\F1551\";\r\n}\r\n\r\n.mdi-mouse-move-vertical::before {\r\n  content: \"\\F1552\";\r\n}\r\n\r\n.mdi-mouse-off::before {\r\n  content: \"\\F037E\";\r\n}\r\n\r\n.mdi-mouse-variant::before {\r\n  content: \"\\F037F\";\r\n}\r\n\r\n.mdi-mouse-variant-off::before {\r\n  content: \"\\F0380\";\r\n}\r\n\r\n.mdi-move-resize::before {\r\n  content: \"\\F0655\";\r\n}\r\n\r\n.mdi-move-resize-variant::before {\r\n  content: \"\\F0656\";\r\n}\r\n\r\n.mdi-movie::before {\r\n  content: \"\\F0381\";\r\n}\r\n\r\n.mdi-movie-check::before {\r\n  content: \"\\F16F3\";\r\n}\r\n\r\n.mdi-movie-check-outline::before {\r\n  content: \"\\F16F4\";\r\n}\r\n\r\n.mdi-movie-cog::before {\r\n  content: \"\\F16F5\";\r\n}\r\n\r\n.mdi-movie-cog-outline::before {\r\n  content: \"\\F16F6\";\r\n}\r\n\r\n.mdi-movie-edit::before {\r\n  content: \"\\F1122\";\r\n}\r\n\r\n.mdi-movie-edit-outline::before {\r\n  content: \"\\F1123\";\r\n}\r\n\r\n.mdi-movie-filter::before {\r\n  content: \"\\F1124\";\r\n}\r\n\r\n.mdi-movie-filter-outline::before {\r\n  content: \"\\F1125\";\r\n}\r\n\r\n.mdi-movie-minus::before {\r\n  content: \"\\F16F7\";\r\n}\r\n\r\n.mdi-movie-minus-outline::before {\r\n  content: \"\\F16F8\";\r\n}\r\n\r\n.mdi-movie-off::before {\r\n  content: \"\\F16F9\";\r\n}\r\n\r\n.mdi-movie-off-outline::before {\r\n  content: \"\\F16FA\";\r\n}\r\n\r\n.mdi-movie-open::before {\r\n  content: \"\\F0FCE\";\r\n}\r\n\r\n.mdi-movie-open-check::before {\r\n  content: \"\\F16FB\";\r\n}\r\n\r\n.mdi-movie-open-check-outline::before {\r\n  content: \"\\F16FC\";\r\n}\r\n\r\n.mdi-movie-open-cog::before {\r\n  content: \"\\F16FD\";\r\n}\r\n\r\n.mdi-movie-open-cog-outline::before {\r\n  content: \"\\F16FE\";\r\n}\r\n\r\n.mdi-movie-open-edit::before {\r\n  content: \"\\F16FF\";\r\n}\r\n\r\n.mdi-movie-open-edit-outline::before {\r\n  content: \"\\F1700\";\r\n}\r\n\r\n.mdi-movie-open-minus::before {\r\n  content: \"\\F1701\";\r\n}\r\n\r\n.mdi-movie-open-minus-outline::before {\r\n  content: \"\\F1702\";\r\n}\r\n\r\n.mdi-movie-open-off::before {\r\n  content: \"\\F1703\";\r\n}\r\n\r\n.mdi-movie-open-off-outline::before {\r\n  content: \"\\F1704\";\r\n}\r\n\r\n.mdi-movie-open-outline::before {\r\n  content: \"\\F0FCF\";\r\n}\r\n\r\n.mdi-movie-open-play::before {\r\n  content: \"\\F1705\";\r\n}\r\n\r\n.mdi-movie-open-play-outline::before {\r\n  content: \"\\F1706\";\r\n}\r\n\r\n.mdi-movie-open-plus::before {\r\n  content: \"\\F1707\";\r\n}\r\n\r\n.mdi-movie-open-plus-outline::before {\r\n  content: \"\\F1708\";\r\n}\r\n\r\n.mdi-movie-open-remove::before {\r\n  content: \"\\F1709\";\r\n}\r\n\r\n.mdi-movie-open-remove-outline::before {\r\n  content: \"\\F170A\";\r\n}\r\n\r\n.mdi-movie-open-settings::before {\r\n  content: \"\\F170B\";\r\n}\r\n\r\n.mdi-movie-open-settings-outline::before {\r\n  content: \"\\F170C\";\r\n}\r\n\r\n.mdi-movie-open-star::before {\r\n  content: \"\\F170D\";\r\n}\r\n\r\n.mdi-movie-open-star-outline::before {\r\n  content: \"\\F170E\";\r\n}\r\n\r\n.mdi-movie-outline::before {\r\n  content: \"\\F0DDD\";\r\n}\r\n\r\n.mdi-movie-play::before {\r\n  content: \"\\F170F\";\r\n}\r\n\r\n.mdi-movie-play-outline::before {\r\n  content: \"\\F1710\";\r\n}\r\n\r\n.mdi-movie-plus::before {\r\n  content: \"\\F1711\";\r\n}\r\n\r\n.mdi-movie-plus-outline::before {\r\n  content: \"\\F1712\";\r\n}\r\n\r\n.mdi-movie-remove::before {\r\n  content: \"\\F1713\";\r\n}\r\n\r\n.mdi-movie-remove-outline::before {\r\n  content: \"\\F1714\";\r\n}\r\n\r\n.mdi-movie-roll::before {\r\n  content: \"\\F07DE\";\r\n}\r\n\r\n.mdi-movie-search::before {\r\n  content: \"\\F11D2\";\r\n}\r\n\r\n.mdi-movie-search-outline::before {\r\n  content: \"\\F11D3\";\r\n}\r\n\r\n.mdi-movie-settings::before {\r\n  content: \"\\F1715\";\r\n}\r\n\r\n.mdi-movie-settings-outline::before {\r\n  content: \"\\F1716\";\r\n}\r\n\r\n.mdi-movie-star::before {\r\n  content: \"\\F1717\";\r\n}\r\n\r\n.mdi-movie-star-outline::before {\r\n  content: \"\\F1718\";\r\n}\r\n\r\n.mdi-mower::before {\r\n  content: \"\\F166F\";\r\n}\r\n\r\n.mdi-mower-bag::before {\r\n  content: \"\\F1670\";\r\n}\r\n\r\n.mdi-muffin::before {\r\n  content: \"\\F098C\";\r\n}\r\n\r\n.mdi-multicast::before {\r\n  content: \"\\F1893\";\r\n}\r\n\r\n.mdi-multiplication::before {\r\n  content: \"\\F0382\";\r\n}\r\n\r\n.mdi-multiplication-box::before {\r\n  content: \"\\F0383\";\r\n}\r\n\r\n.mdi-mushroom::before {\r\n  content: \"\\F07DF\";\r\n}\r\n\r\n.mdi-mushroom-off::before {\r\n  content: \"\\F13FA\";\r\n}\r\n\r\n.mdi-mushroom-off-outline::before {\r\n  content: \"\\F13FB\";\r\n}\r\n\r\n.mdi-mushroom-outline::before {\r\n  content: \"\\F07E0\";\r\n}\r\n\r\n.mdi-music::before {\r\n  content: \"\\F075A\";\r\n}\r\n\r\n.mdi-music-accidental-double-flat::before {\r\n  content: \"\\F0F69\";\r\n}\r\n\r\n.mdi-music-accidental-double-sharp::before {\r\n  content: \"\\F0F6A\";\r\n}\r\n\r\n.mdi-music-accidental-flat::before {\r\n  content: \"\\F0F6B\";\r\n}\r\n\r\n.mdi-music-accidental-natural::before {\r\n  content: \"\\F0F6C\";\r\n}\r\n\r\n.mdi-music-accidental-sharp::before {\r\n  content: \"\\F0F6D\";\r\n}\r\n\r\n.mdi-music-box::before {\r\n  content: \"\\F0384\";\r\n}\r\n\r\n.mdi-music-box-multiple::before {\r\n  content: \"\\F0333\";\r\n}\r\n\r\n.mdi-music-box-multiple-outline::before {\r\n  content: \"\\F0F04\";\r\n}\r\n\r\n.mdi-music-box-outline::before {\r\n  content: \"\\F0385\";\r\n}\r\n\r\n.mdi-music-circle::before {\r\n  content: \"\\F0386\";\r\n}\r\n\r\n.mdi-music-circle-outline::before {\r\n  content: \"\\F0AD4\";\r\n}\r\n\r\n.mdi-music-clef-alto::before {\r\n  content: \"\\F0F6E\";\r\n}\r\n\r\n.mdi-music-clef-bass::before {\r\n  content: \"\\F0F6F\";\r\n}\r\n\r\n.mdi-music-clef-treble::before {\r\n  content: \"\\F0F70\";\r\n}\r\n\r\n.mdi-music-note::before {\r\n  content: \"\\F0387\";\r\n}\r\n\r\n.mdi-music-note-bluetooth::before {\r\n  content: \"\\F05FE\";\r\n}\r\n\r\n.mdi-music-note-bluetooth-off::before {\r\n  content: \"\\F05FF\";\r\n}\r\n\r\n.mdi-music-note-eighth::before {\r\n  content: \"\\F0388\";\r\n}\r\n\r\n.mdi-music-note-eighth-dotted::before {\r\n  content: \"\\F0F71\";\r\n}\r\n\r\n.mdi-music-note-half::before {\r\n  content: \"\\F0389\";\r\n}\r\n\r\n.mdi-music-note-half-dotted::before {\r\n  content: \"\\F0F72\";\r\n}\r\n\r\n.mdi-music-note-off::before {\r\n  content: \"\\F038A\";\r\n}\r\n\r\n.mdi-music-note-off-outline::before {\r\n  content: \"\\F0F73\";\r\n}\r\n\r\n.mdi-music-note-outline::before {\r\n  content: \"\\F0F74\";\r\n}\r\n\r\n.mdi-music-note-plus::before {\r\n  content: \"\\F0DDE\";\r\n}\r\n\r\n.mdi-music-note-quarter::before {\r\n  content: \"\\F038B\";\r\n}\r\n\r\n.mdi-music-note-quarter-dotted::before {\r\n  content: \"\\F0F75\";\r\n}\r\n\r\n.mdi-music-note-sixteenth::before {\r\n  content: \"\\F038C\";\r\n}\r\n\r\n.mdi-music-note-sixteenth-dotted::before {\r\n  content: \"\\F0F76\";\r\n}\r\n\r\n.mdi-music-note-whole::before {\r\n  content: \"\\F038D\";\r\n}\r\n\r\n.mdi-music-note-whole-dotted::before {\r\n  content: \"\\F0F77\";\r\n}\r\n\r\n.mdi-music-off::before {\r\n  content: \"\\F075B\";\r\n}\r\n\r\n.mdi-music-rest-eighth::before {\r\n  content: \"\\F0F78\";\r\n}\r\n\r\n.mdi-music-rest-half::before {\r\n  content: \"\\F0F79\";\r\n}\r\n\r\n.mdi-music-rest-quarter::before {\r\n  content: \"\\F0F7A\";\r\n}\r\n\r\n.mdi-music-rest-sixteenth::before {\r\n  content: \"\\F0F7B\";\r\n}\r\n\r\n.mdi-music-rest-whole::before {\r\n  content: \"\\F0F7C\";\r\n}\r\n\r\n.mdi-mustache::before {\r\n  content: \"\\F15DE\";\r\n}\r\n\r\n.mdi-nail::before {\r\n  content: \"\\F0DDF\";\r\n}\r\n\r\n.mdi-nas::before {\r\n  content: \"\\F08F3\";\r\n}\r\n\r\n.mdi-nativescript::before {\r\n  content: \"\\F0880\";\r\n}\r\n\r\n.mdi-nature::before {\r\n  content: \"\\F038E\";\r\n}\r\n\r\n.mdi-nature-people::before {\r\n  content: \"\\F038F\";\r\n}\r\n\r\n.mdi-navigation::before {\r\n  content: \"\\F0390\";\r\n}\r\n\r\n.mdi-navigation-outline::before {\r\n  content: \"\\F1607\";\r\n}\r\n\r\n.mdi-navigation-variant::before {\r\n  content: \"\\F18F0\";\r\n}\r\n\r\n.mdi-navigation-variant-outline::before {\r\n  content: \"\\F18F1\";\r\n}\r\n\r\n.mdi-near-me::before {\r\n  content: \"\\F05CD\";\r\n}\r\n\r\n.mdi-necklace::before {\r\n  content: \"\\F0F0B\";\r\n}\r\n\r\n.mdi-needle::before {\r\n  content: \"\\F0391\";\r\n}\r\n\r\n.mdi-netflix::before {\r\n  content: \"\\F0746\";\r\n}\r\n\r\n.mdi-network::before {\r\n  content: \"\\F06F3\";\r\n}\r\n\r\n.mdi-network-off::before {\r\n  content: \"\\F0C9B\";\r\n}\r\n\r\n.mdi-network-off-outline::before {\r\n  content: \"\\F0C9C\";\r\n}\r\n\r\n.mdi-network-outline::before {\r\n  content: \"\\F0C9D\";\r\n}\r\n\r\n.mdi-network-strength-1::before {\r\n  content: \"\\F08F4\";\r\n}\r\n\r\n.mdi-network-strength-1-alert::before {\r\n  content: \"\\F08F5\";\r\n}\r\n\r\n.mdi-network-strength-2::before {\r\n  content: \"\\F08F6\";\r\n}\r\n\r\n.mdi-network-strength-2-alert::before {\r\n  content: \"\\F08F7\";\r\n}\r\n\r\n.mdi-network-strength-3::before {\r\n  content: \"\\F08F8\";\r\n}\r\n\r\n.mdi-network-strength-3-alert::before {\r\n  content: \"\\F08F9\";\r\n}\r\n\r\n.mdi-network-strength-4::before {\r\n  content: \"\\F08FA\";\r\n}\r\n\r\n.mdi-network-strength-4-alert::before {\r\n  content: \"\\F08FB\";\r\n}\r\n\r\n.mdi-network-strength-4-cog::before {\r\n  content: \"\\F191A\";\r\n}\r\n\r\n.mdi-network-strength-off::before {\r\n  content: \"\\F08FC\";\r\n}\r\n\r\n.mdi-network-strength-off-outline::before {\r\n  content: \"\\F08FD\";\r\n}\r\n\r\n.mdi-network-strength-outline::before {\r\n  content: \"\\F08FE\";\r\n}\r\n\r\n.mdi-new-box::before {\r\n  content: \"\\F0394\";\r\n}\r\n\r\n.mdi-newspaper::before {\r\n  content: \"\\F0395\";\r\n}\r\n\r\n.mdi-newspaper-check::before {\r\n  content: \"\\F1943\";\r\n}\r\n\r\n.mdi-newspaper-minus::before {\r\n  content: \"\\F0F0C\";\r\n}\r\n\r\n.mdi-newspaper-plus::before {\r\n  content: \"\\F0F0D\";\r\n}\r\n\r\n.mdi-newspaper-remove::before {\r\n  content: \"\\F1944\";\r\n}\r\n\r\n.mdi-newspaper-variant::before {\r\n  content: \"\\F1001\";\r\n}\r\n\r\n.mdi-newspaper-variant-multiple::before {\r\n  content: \"\\F1002\";\r\n}\r\n\r\n.mdi-newspaper-variant-multiple-outline::before {\r\n  content: \"\\F1003\";\r\n}\r\n\r\n.mdi-newspaper-variant-outline::before {\r\n  content: \"\\F1004\";\r\n}\r\n\r\n.mdi-nfc::before {\r\n  content: \"\\F0396\";\r\n}\r\n\r\n.mdi-nfc-search-variant::before {\r\n  content: \"\\F0E53\";\r\n}\r\n\r\n.mdi-nfc-tap::before {\r\n  content: \"\\F0397\";\r\n}\r\n\r\n.mdi-nfc-variant::before {\r\n  content: \"\\F0398\";\r\n}\r\n\r\n.mdi-nfc-variant-off::before {\r\n  content: \"\\F0E54\";\r\n}\r\n\r\n.mdi-ninja::before {\r\n  content: \"\\F0774\";\r\n}\r\n\r\n.mdi-nintendo-game-boy::before {\r\n  content: \"\\F1393\";\r\n}\r\n\r\n.mdi-nintendo-switch::before {\r\n  content: \"\\F07E1\";\r\n}\r\n\r\n.mdi-nintendo-wii::before {\r\n  content: \"\\F05AB\";\r\n}\r\n\r\n.mdi-nintendo-wiiu::before {\r\n  content: \"\\F072D\";\r\n}\r\n\r\n.mdi-nix::before {\r\n  content: \"\\F1105\";\r\n}\r\n\r\n.mdi-nodejs::before {\r\n  content: \"\\F0399\";\r\n}\r\n\r\n.mdi-noodles::before {\r\n  content: \"\\F117E\";\r\n}\r\n\r\n.mdi-not-equal::before {\r\n  content: \"\\F098D\";\r\n}\r\n\r\n.mdi-not-equal-variant::before {\r\n  content: \"\\F098E\";\r\n}\r\n\r\n.mdi-note::before {\r\n  content: \"\\F039A\";\r\n}\r\n\r\n.mdi-note-alert::before {\r\n  content: \"\\F177D\";\r\n}\r\n\r\n.mdi-note-alert-outline::before {\r\n  content: \"\\F177E\";\r\n}\r\n\r\n.mdi-note-check::before {\r\n  content: \"\\F177F\";\r\n}\r\n\r\n.mdi-note-check-outline::before {\r\n  content: \"\\F1780\";\r\n}\r\n\r\n.mdi-note-edit::before {\r\n  content: \"\\F1781\";\r\n}\r\n\r\n.mdi-note-edit-outline::before {\r\n  content: \"\\F1782\";\r\n}\r\n\r\n.mdi-note-minus::before {\r\n  content: \"\\F164F\";\r\n}\r\n\r\n.mdi-note-minus-outline::before {\r\n  content: \"\\F1650\";\r\n}\r\n\r\n.mdi-note-multiple::before {\r\n  content: \"\\F06B8\";\r\n}\r\n\r\n.mdi-note-multiple-outline::before {\r\n  content: \"\\F06B9\";\r\n}\r\n\r\n.mdi-note-off::before {\r\n  content: \"\\F1783\";\r\n}\r\n\r\n.mdi-note-off-outline::before {\r\n  content: \"\\F1784\";\r\n}\r\n\r\n.mdi-note-outline::before {\r\n  content: \"\\F039B\";\r\n}\r\n\r\n.mdi-note-plus::before {\r\n  content: \"\\F039C\";\r\n}\r\n\r\n.mdi-note-plus-outline::before {\r\n  content: \"\\F039D\";\r\n}\r\n\r\n.mdi-note-remove::before {\r\n  content: \"\\F1651\";\r\n}\r\n\r\n.mdi-note-remove-outline::before {\r\n  content: \"\\F1652\";\r\n}\r\n\r\n.mdi-note-search::before {\r\n  content: \"\\F1653\";\r\n}\r\n\r\n.mdi-note-search-outline::before {\r\n  content: \"\\F1654\";\r\n}\r\n\r\n.mdi-note-text::before {\r\n  content: \"\\F039E\";\r\n}\r\n\r\n.mdi-note-text-outline::before {\r\n  content: \"\\F11D7\";\r\n}\r\n\r\n.mdi-notebook::before {\r\n  content: \"\\F082E\";\r\n}\r\n\r\n.mdi-notebook-check::before {\r\n  content: \"\\F14F5\";\r\n}\r\n\r\n.mdi-notebook-check-outline::before {\r\n  content: \"\\F14F6\";\r\n}\r\n\r\n.mdi-notebook-edit::before {\r\n  content: \"\\F14E7\";\r\n}\r\n\r\n.mdi-notebook-edit-outline::before {\r\n  content: \"\\F14E9\";\r\n}\r\n\r\n.mdi-notebook-minus::before {\r\n  content: \"\\F1610\";\r\n}\r\n\r\n.mdi-notebook-minus-outline::before {\r\n  content: \"\\F1611\";\r\n}\r\n\r\n.mdi-notebook-multiple::before {\r\n  content: \"\\F0E55\";\r\n}\r\n\r\n.mdi-notebook-outline::before {\r\n  content: \"\\F0EBF\";\r\n}\r\n\r\n.mdi-notebook-plus::before {\r\n  content: \"\\F1612\";\r\n}\r\n\r\n.mdi-notebook-plus-outline::before {\r\n  content: \"\\F1613\";\r\n}\r\n\r\n.mdi-notebook-remove::before {\r\n  content: \"\\F1614\";\r\n}\r\n\r\n.mdi-notebook-remove-outline::before {\r\n  content: \"\\F1615\";\r\n}\r\n\r\n.mdi-notification-clear-all::before {\r\n  content: \"\\F039F\";\r\n}\r\n\r\n.mdi-npm::before {\r\n  content: \"\\F06F7\";\r\n}\r\n\r\n.mdi-nuke::before {\r\n  content: \"\\F06A4\";\r\n}\r\n\r\n.mdi-null::before {\r\n  content: \"\\F07E2\";\r\n}\r\n\r\n.mdi-numeric::before {\r\n  content: \"\\F03A0\";\r\n}\r\n\r\n.mdi-numeric-0::before {\r\n  content: \"\\F0B39\";\r\n}\r\n\r\n.mdi-numeric-0-box::before {\r\n  content: \"\\F03A1\";\r\n}\r\n\r\n.mdi-numeric-0-box-multiple::before {\r\n  content: \"\\F0F0E\";\r\n}\r\n\r\n.mdi-numeric-0-box-multiple-outline::before {\r\n  content: \"\\F03A2\";\r\n}\r\n\r\n.mdi-numeric-0-box-outline::before {\r\n  content: \"\\F03A3\";\r\n}\r\n\r\n.mdi-numeric-0-circle::before {\r\n  content: \"\\F0C9E\";\r\n}\r\n\r\n.mdi-numeric-0-circle-outline::before {\r\n  content: \"\\F0C9F\";\r\n}\r\n\r\n.mdi-numeric-1::before {\r\n  content: \"\\F0B3A\";\r\n}\r\n\r\n.mdi-numeric-1-box::before {\r\n  content: \"\\F03A4\";\r\n}\r\n\r\n.mdi-numeric-1-box-multiple::before {\r\n  content: \"\\F0F0F\";\r\n}\r\n\r\n.mdi-numeric-1-box-multiple-outline::before {\r\n  content: \"\\F03A5\";\r\n}\r\n\r\n.mdi-numeric-1-box-outline::before {\r\n  content: \"\\F03A6\";\r\n}\r\n\r\n.mdi-numeric-1-circle::before {\r\n  content: \"\\F0CA0\";\r\n}\r\n\r\n.mdi-numeric-1-circle-outline::before {\r\n  content: \"\\F0CA1\";\r\n}\r\n\r\n.mdi-numeric-10::before {\r\n  content: \"\\F0FE9\";\r\n}\r\n\r\n.mdi-numeric-10-box::before {\r\n  content: \"\\F0F7D\";\r\n}\r\n\r\n.mdi-numeric-10-box-multiple::before {\r\n  content: \"\\F0FEA\";\r\n}\r\n\r\n.mdi-numeric-10-box-multiple-outline::before {\r\n  content: \"\\F0FEB\";\r\n}\r\n\r\n.mdi-numeric-10-box-outline::before {\r\n  content: \"\\F0F7E\";\r\n}\r\n\r\n.mdi-numeric-10-circle::before {\r\n  content: \"\\F0FEC\";\r\n}\r\n\r\n.mdi-numeric-10-circle-outline::before {\r\n  content: \"\\F0FED\";\r\n}\r\n\r\n.mdi-numeric-2::before {\r\n  content: \"\\F0B3B\";\r\n}\r\n\r\n.mdi-numeric-2-box::before {\r\n  content: \"\\F03A7\";\r\n}\r\n\r\n.mdi-numeric-2-box-multiple::before {\r\n  content: \"\\F0F10\";\r\n}\r\n\r\n.mdi-numeric-2-box-multiple-outline::before {\r\n  content: \"\\F03A8\";\r\n}\r\n\r\n.mdi-numeric-2-box-outline::before {\r\n  content: \"\\F03A9\";\r\n}\r\n\r\n.mdi-numeric-2-circle::before {\r\n  content: \"\\F0CA2\";\r\n}\r\n\r\n.mdi-numeric-2-circle-outline::before {\r\n  content: \"\\F0CA3\";\r\n}\r\n\r\n.mdi-numeric-3::before {\r\n  content: \"\\F0B3C\";\r\n}\r\n\r\n.mdi-numeric-3-box::before {\r\n  content: \"\\F03AA\";\r\n}\r\n\r\n.mdi-numeric-3-box-multiple::before {\r\n  content: \"\\F0F11\";\r\n}\r\n\r\n.mdi-numeric-3-box-multiple-outline::before {\r\n  content: \"\\F03AB\";\r\n}\r\n\r\n.mdi-numeric-3-box-outline::before {\r\n  content: \"\\F03AC\";\r\n}\r\n\r\n.mdi-numeric-3-circle::before {\r\n  content: \"\\F0CA4\";\r\n}\r\n\r\n.mdi-numeric-3-circle-outline::before {\r\n  content: \"\\F0CA5\";\r\n}\r\n\r\n.mdi-numeric-4::before {\r\n  content: \"\\F0B3D\";\r\n}\r\n\r\n.mdi-numeric-4-box::before {\r\n  content: \"\\F03AD\";\r\n}\r\n\r\n.mdi-numeric-4-box-multiple::before {\r\n  content: \"\\F0F12\";\r\n}\r\n\r\n.mdi-numeric-4-box-multiple-outline::before {\r\n  content: \"\\F03B2\";\r\n}\r\n\r\n.mdi-numeric-4-box-outline::before {\r\n  content: \"\\F03AE\";\r\n}\r\n\r\n.mdi-numeric-4-circle::before {\r\n  content: \"\\F0CA6\";\r\n}\r\n\r\n.mdi-numeric-4-circle-outline::before {\r\n  content: \"\\F0CA7\";\r\n}\r\n\r\n.mdi-numeric-5::before {\r\n  content: \"\\F0B3E\";\r\n}\r\n\r\n.mdi-numeric-5-box::before {\r\n  content: \"\\F03B1\";\r\n}\r\n\r\n.mdi-numeric-5-box-multiple::before {\r\n  content: \"\\F0F13\";\r\n}\r\n\r\n.mdi-numeric-5-box-multiple-outline::before {\r\n  content: \"\\F03AF\";\r\n}\r\n\r\n.mdi-numeric-5-box-outline::before {\r\n  content: \"\\F03B0\";\r\n}\r\n\r\n.mdi-numeric-5-circle::before {\r\n  content: \"\\F0CA8\";\r\n}\r\n\r\n.mdi-numeric-5-circle-outline::before {\r\n  content: \"\\F0CA9\";\r\n}\r\n\r\n.mdi-numeric-6::before {\r\n  content: \"\\F0B3F\";\r\n}\r\n\r\n.mdi-numeric-6-box::before {\r\n  content: \"\\F03B3\";\r\n}\r\n\r\n.mdi-numeric-6-box-multiple::before {\r\n  content: \"\\F0F14\";\r\n}\r\n\r\n.mdi-numeric-6-box-multiple-outline::before {\r\n  content: \"\\F03B4\";\r\n}\r\n\r\n.mdi-numeric-6-box-outline::before {\r\n  content: \"\\F03B5\";\r\n}\r\n\r\n.mdi-numeric-6-circle::before {\r\n  content: \"\\F0CAA\";\r\n}\r\n\r\n.mdi-numeric-6-circle-outline::before {\r\n  content: \"\\F0CAB\";\r\n}\r\n\r\n.mdi-numeric-7::before {\r\n  content: \"\\F0B40\";\r\n}\r\n\r\n.mdi-numeric-7-box::before {\r\n  content: \"\\F03B6\";\r\n}\r\n\r\n.mdi-numeric-7-box-multiple::before {\r\n  content: \"\\F0F15\";\r\n}\r\n\r\n.mdi-numeric-7-box-multiple-outline::before {\r\n  content: \"\\F03B7\";\r\n}\r\n\r\n.mdi-numeric-7-box-outline::before {\r\n  content: \"\\F03B8\";\r\n}\r\n\r\n.mdi-numeric-7-circle::before {\r\n  content: \"\\F0CAC\";\r\n}\r\n\r\n.mdi-numeric-7-circle-outline::before {\r\n  content: \"\\F0CAD\";\r\n}\r\n\r\n.mdi-numeric-8::before {\r\n  content: \"\\F0B41\";\r\n}\r\n\r\n.mdi-numeric-8-box::before {\r\n  content: \"\\F03B9\";\r\n}\r\n\r\n.mdi-numeric-8-box-multiple::before {\r\n  content: \"\\F0F16\";\r\n}\r\n\r\n.mdi-numeric-8-box-multiple-outline::before {\r\n  content: \"\\F03BA\";\r\n}\r\n\r\n.mdi-numeric-8-box-outline::before {\r\n  content: \"\\F03BB\";\r\n}\r\n\r\n.mdi-numeric-8-circle::before {\r\n  content: \"\\F0CAE\";\r\n}\r\n\r\n.mdi-numeric-8-circle-outline::before {\r\n  content: \"\\F0CAF\";\r\n}\r\n\r\n.mdi-numeric-9::before {\r\n  content: \"\\F0B42\";\r\n}\r\n\r\n.mdi-numeric-9-box::before {\r\n  content: \"\\F03BC\";\r\n}\r\n\r\n.mdi-numeric-9-box-multiple::before {\r\n  content: \"\\F0F17\";\r\n}\r\n\r\n.mdi-numeric-9-box-multiple-outline::before {\r\n  content: \"\\F03BD\";\r\n}\r\n\r\n.mdi-numeric-9-box-outline::before {\r\n  content: \"\\F03BE\";\r\n}\r\n\r\n.mdi-numeric-9-circle::before {\r\n  content: \"\\F0CB0\";\r\n}\r\n\r\n.mdi-numeric-9-circle-outline::before {\r\n  content: \"\\F0CB1\";\r\n}\r\n\r\n.mdi-numeric-9-plus::before {\r\n  content: \"\\F0FEE\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box::before {\r\n  content: \"\\F03BF\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box-multiple::before {\r\n  content: \"\\F0F18\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box-multiple-outline::before {\r\n  content: \"\\F03C0\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box-outline::before {\r\n  content: \"\\F03C1\";\r\n}\r\n\r\n.mdi-numeric-9-plus-circle::before {\r\n  content: \"\\F0CB2\";\r\n}\r\n\r\n.mdi-numeric-9-plus-circle-outline::before {\r\n  content: \"\\F0CB3\";\r\n}\r\n\r\n.mdi-numeric-negative-1::before {\r\n  content: \"\\F1052\";\r\n}\r\n\r\n.mdi-numeric-positive-1::before {\r\n  content: \"\\F15CB\";\r\n}\r\n\r\n.mdi-nut::before {\r\n  content: \"\\F06F8\";\r\n}\r\n\r\n.mdi-nutrition::before {\r\n  content: \"\\F03C2\";\r\n}\r\n\r\n.mdi-nuxt::before {\r\n  content: \"\\F1106\";\r\n}\r\n\r\n.mdi-oar::before {\r\n  content: \"\\F067C\";\r\n}\r\n\r\n.mdi-ocarina::before {\r\n  content: \"\\F0DE0\";\r\n}\r\n\r\n.mdi-oci::before {\r\n  content: \"\\F12E9\";\r\n}\r\n\r\n.mdi-ocr::before {\r\n  content: \"\\F113A\";\r\n}\r\n\r\n.mdi-octagon::before {\r\n  content: \"\\F03C3\";\r\n}\r\n\r\n.mdi-octagon-outline::before {\r\n  content: \"\\F03C4\";\r\n}\r\n\r\n.mdi-octagram::before {\r\n  content: \"\\F06F9\";\r\n}\r\n\r\n.mdi-octagram-outline::before {\r\n  content: \"\\F0775\";\r\n}\r\n\r\n.mdi-octahedron::before {\r\n  content: \"\\F1950\";\r\n}\r\n\r\n.mdi-octahedron-off::before {\r\n  content: \"\\F1951\";\r\n}\r\n\r\n.mdi-odnoklassniki::before {\r\n  content: \"\\F03C5\";\r\n}\r\n\r\n.mdi-offer::before {\r\n  content: \"\\F121B\";\r\n}\r\n\r\n.mdi-office-building::before {\r\n  content: \"\\F0991\";\r\n}\r\n\r\n.mdi-office-building-cog::before {\r\n  content: \"\\F1949\";\r\n}\r\n\r\n.mdi-office-building-cog-outline::before {\r\n  content: \"\\F194A\";\r\n}\r\n\r\n.mdi-office-building-marker::before {\r\n  content: \"\\F1520\";\r\n}\r\n\r\n.mdi-office-building-marker-outline::before {\r\n  content: \"\\F1521\";\r\n}\r\n\r\n.mdi-office-building-outline::before {\r\n  content: \"\\F151F\";\r\n}\r\n\r\n.mdi-oil::before {\r\n  content: \"\\F03C7\";\r\n}\r\n\r\n.mdi-oil-lamp::before {\r\n  content: \"\\F0F19\";\r\n}\r\n\r\n.mdi-oil-level::before {\r\n  content: \"\\F1053\";\r\n}\r\n\r\n.mdi-oil-temperature::before {\r\n  content: \"\\F0FF8\";\r\n}\r\n\r\n.mdi-om::before {\r\n  content: \"\\F0973\";\r\n}\r\n\r\n.mdi-omega::before {\r\n  content: \"\\F03C9\";\r\n}\r\n\r\n.mdi-one-up::before {\r\n  content: \"\\F0BAD\";\r\n}\r\n\r\n.mdi-onepassword::before {\r\n  content: \"\\F0881\";\r\n}\r\n\r\n.mdi-opacity::before {\r\n  content: \"\\F05CC\";\r\n}\r\n\r\n.mdi-open-in-app::before {\r\n  content: \"\\F03CB\";\r\n}\r\n\r\n.mdi-open-in-new::before {\r\n  content: \"\\F03CC\";\r\n}\r\n\r\n.mdi-open-source-initiative::before {\r\n  content: \"\\F0BAE\";\r\n}\r\n\r\n.mdi-openid::before {\r\n  content: \"\\F03CD\";\r\n}\r\n\r\n.mdi-opera::before {\r\n  content: \"\\F03CE\";\r\n}\r\n\r\n.mdi-orbit::before {\r\n  content: \"\\F0018\";\r\n}\r\n\r\n.mdi-orbit-variant::before {\r\n  content: \"\\F15DB\";\r\n}\r\n\r\n.mdi-order-alphabetical-ascending::before {\r\n  content: \"\\F020D\";\r\n}\r\n\r\n.mdi-order-alphabetical-descending::before {\r\n  content: \"\\F0D07\";\r\n}\r\n\r\n.mdi-order-bool-ascending::before {\r\n  content: \"\\F02BE\";\r\n}\r\n\r\n.mdi-order-bool-ascending-variant::before {\r\n  content: \"\\F098F\";\r\n}\r\n\r\n.mdi-order-bool-descending::before {\r\n  content: \"\\F1384\";\r\n}\r\n\r\n.mdi-order-bool-descending-variant::before {\r\n  content: \"\\F0990\";\r\n}\r\n\r\n.mdi-order-numeric-ascending::before {\r\n  content: \"\\F0545\";\r\n}\r\n\r\n.mdi-order-numeric-descending::before {\r\n  content: \"\\F0546\";\r\n}\r\n\r\n.mdi-origin::before {\r\n  content: \"\\F0B43\";\r\n}\r\n\r\n.mdi-ornament::before {\r\n  content: \"\\F03CF\";\r\n}\r\n\r\n.mdi-ornament-variant::before {\r\n  content: \"\\F03D0\";\r\n}\r\n\r\n.mdi-outdoor-lamp::before {\r\n  content: \"\\F1054\";\r\n}\r\n\r\n.mdi-overscan::before {\r\n  content: \"\\F1005\";\r\n}\r\n\r\n.mdi-owl::before {\r\n  content: \"\\F03D2\";\r\n}\r\n\r\n.mdi-pac-man::before {\r\n  content: \"\\F0BAF\";\r\n}\r\n\r\n.mdi-package::before {\r\n  content: \"\\F03D3\";\r\n}\r\n\r\n.mdi-package-down::before {\r\n  content: \"\\F03D4\";\r\n}\r\n\r\n.mdi-package-up::before {\r\n  content: \"\\F03D5\";\r\n}\r\n\r\n.mdi-package-variant::before {\r\n  content: \"\\F03D6\";\r\n}\r\n\r\n.mdi-package-variant-closed::before {\r\n  content: \"\\F03D7\";\r\n}\r\n\r\n.mdi-page-first::before {\r\n  content: \"\\F0600\";\r\n}\r\n\r\n.mdi-page-last::before {\r\n  content: \"\\F0601\";\r\n}\r\n\r\n.mdi-page-layout-body::before {\r\n  content: \"\\F06FA\";\r\n}\r\n\r\n.mdi-page-layout-footer::before {\r\n  content: \"\\F06FB\";\r\n}\r\n\r\n.mdi-page-layout-header::before {\r\n  content: \"\\F06FC\";\r\n}\r\n\r\n.mdi-page-layout-header-footer::before {\r\n  content: \"\\F0F7F\";\r\n}\r\n\r\n.mdi-page-layout-sidebar-left::before {\r\n  content: \"\\F06FD\";\r\n}\r\n\r\n.mdi-page-layout-sidebar-right::before {\r\n  content: \"\\F06FE\";\r\n}\r\n\r\n.mdi-page-next::before {\r\n  content: \"\\F0BB0\";\r\n}\r\n\r\n.mdi-page-next-outline::before {\r\n  content: \"\\F0BB1\";\r\n}\r\n\r\n.mdi-page-previous::before {\r\n  content: \"\\F0BB2\";\r\n}\r\n\r\n.mdi-page-previous-outline::before {\r\n  content: \"\\F0BB3\";\r\n}\r\n\r\n.mdi-pail::before {\r\n  content: \"\\F1417\";\r\n}\r\n\r\n.mdi-pail-minus::before {\r\n  content: \"\\F1437\";\r\n}\r\n\r\n.mdi-pail-minus-outline::before {\r\n  content: \"\\F143C\";\r\n}\r\n\r\n.mdi-pail-off::before {\r\n  content: \"\\F1439\";\r\n}\r\n\r\n.mdi-pail-off-outline::before {\r\n  content: \"\\F143E\";\r\n}\r\n\r\n.mdi-pail-outline::before {\r\n  content: \"\\F143A\";\r\n}\r\n\r\n.mdi-pail-plus::before {\r\n  content: \"\\F1436\";\r\n}\r\n\r\n.mdi-pail-plus-outline::before {\r\n  content: \"\\F143B\";\r\n}\r\n\r\n.mdi-pail-remove::before {\r\n  content: \"\\F1438\";\r\n}\r\n\r\n.mdi-pail-remove-outline::before {\r\n  content: \"\\F143D\";\r\n}\r\n\r\n.mdi-palette::before {\r\n  content: \"\\F03D8\";\r\n}\r\n\r\n.mdi-palette-advanced::before {\r\n  content: \"\\F03D9\";\r\n}\r\n\r\n.mdi-palette-outline::before {\r\n  content: \"\\F0E0C\";\r\n}\r\n\r\n.mdi-palette-swatch::before {\r\n  content: \"\\F08B5\";\r\n}\r\n\r\n.mdi-palette-swatch-outline::before {\r\n  content: \"\\F135C\";\r\n}\r\n\r\n.mdi-palette-swatch-variant::before {\r\n  content: \"\\F195A\";\r\n}\r\n\r\n.mdi-palm-tree::before {\r\n  content: \"\\F1055\";\r\n}\r\n\r\n.mdi-pan::before {\r\n  content: \"\\F0BB4\";\r\n}\r\n\r\n.mdi-pan-bottom-left::before {\r\n  content: \"\\F0BB5\";\r\n}\r\n\r\n.mdi-pan-bottom-right::before {\r\n  content: \"\\F0BB6\";\r\n}\r\n\r\n.mdi-pan-down::before {\r\n  content: \"\\F0BB7\";\r\n}\r\n\r\n.mdi-pan-horizontal::before {\r\n  content: \"\\F0BB8\";\r\n}\r\n\r\n.mdi-pan-left::before {\r\n  content: \"\\F0BB9\";\r\n}\r\n\r\n.mdi-pan-right::before {\r\n  content: \"\\F0BBA\";\r\n}\r\n\r\n.mdi-pan-top-left::before {\r\n  content: \"\\F0BBB\";\r\n}\r\n\r\n.mdi-pan-top-right::before {\r\n  content: \"\\F0BBC\";\r\n}\r\n\r\n.mdi-pan-up::before {\r\n  content: \"\\F0BBD\";\r\n}\r\n\r\n.mdi-pan-vertical::before {\r\n  content: \"\\F0BBE\";\r\n}\r\n\r\n.mdi-panda::before {\r\n  content: \"\\F03DA\";\r\n}\r\n\r\n.mdi-pandora::before {\r\n  content: \"\\F03DB\";\r\n}\r\n\r\n.mdi-panorama::before {\r\n  content: \"\\F03DC\";\r\n}\r\n\r\n.mdi-panorama-fisheye::before {\r\n  content: \"\\F03DD\";\r\n}\r\n\r\n.mdi-panorama-horizontal::before {\r\n  content: \"\\F1928\";\r\n}\r\n\r\n.mdi-panorama-horizontal-outline::before {\r\n  content: \"\\F03DE\";\r\n}\r\n\r\n.mdi-panorama-outline::before {\r\n  content: \"\\F198C\";\r\n}\r\n\r\n.mdi-panorama-sphere::before {\r\n  content: \"\\F198D\";\r\n}\r\n\r\n.mdi-panorama-sphere-outline::before {\r\n  content: \"\\F198E\";\r\n}\r\n\r\n.mdi-panorama-variant::before {\r\n  content: \"\\F198F\";\r\n}\r\n\r\n.mdi-panorama-variant-outline::before {\r\n  content: \"\\F1990\";\r\n}\r\n\r\n.mdi-panorama-vertical::before {\r\n  content: \"\\F1929\";\r\n}\r\n\r\n.mdi-panorama-vertical-outline::before {\r\n  content: \"\\F03DF\";\r\n}\r\n\r\n.mdi-panorama-wide-angle::before {\r\n  content: \"\\F195F\";\r\n}\r\n\r\n.mdi-panorama-wide-angle-outline::before {\r\n  content: \"\\F03E0\";\r\n}\r\n\r\n.mdi-paper-cut-vertical::before {\r\n  content: \"\\F03E1\";\r\n}\r\n\r\n.mdi-paper-roll::before {\r\n  content: \"\\F1157\";\r\n}\r\n\r\n.mdi-paper-roll-outline::before {\r\n  content: \"\\F1158\";\r\n}\r\n\r\n.mdi-paperclip::before {\r\n  content: \"\\F03E2\";\r\n}\r\n\r\n.mdi-parachute::before {\r\n  content: \"\\F0CB4\";\r\n}\r\n\r\n.mdi-parachute-outline::before {\r\n  content: \"\\F0CB5\";\r\n}\r\n\r\n.mdi-paragliding::before {\r\n  content: \"\\F1745\";\r\n}\r\n\r\n.mdi-parking::before {\r\n  content: \"\\F03E3\";\r\n}\r\n\r\n.mdi-party-popper::before {\r\n  content: \"\\F1056\";\r\n}\r\n\r\n.mdi-passport::before {\r\n  content: \"\\F07E3\";\r\n}\r\n\r\n.mdi-passport-biometric::before {\r\n  content: \"\\F0DE1\";\r\n}\r\n\r\n.mdi-pasta::before {\r\n  content: \"\\F1160\";\r\n}\r\n\r\n.mdi-patio-heater::before {\r\n  content: \"\\F0F80\";\r\n}\r\n\r\n.mdi-patreon::before {\r\n  content: \"\\F0882\";\r\n}\r\n\r\n.mdi-pause::before {\r\n  content: \"\\F03E4\";\r\n}\r\n\r\n.mdi-pause-circle::before {\r\n  content: \"\\F03E5\";\r\n}\r\n\r\n.mdi-pause-circle-outline::before {\r\n  content: \"\\F03E6\";\r\n}\r\n\r\n.mdi-pause-octagon::before {\r\n  content: \"\\F03E7\";\r\n}\r\n\r\n.mdi-pause-octagon-outline::before {\r\n  content: \"\\F03E8\";\r\n}\r\n\r\n.mdi-paw::before {\r\n  content: \"\\F03E9\";\r\n}\r\n\r\n.mdi-paw-off::before {\r\n  content: \"\\F0657\";\r\n}\r\n\r\n.mdi-paw-off-outline::before {\r\n  content: \"\\F1676\";\r\n}\r\n\r\n.mdi-paw-outline::before {\r\n  content: \"\\F1675\";\r\n}\r\n\r\n.mdi-peace::before {\r\n  content: \"\\F0884\";\r\n}\r\n\r\n.mdi-peanut::before {\r\n  content: \"\\F0FFC\";\r\n}\r\n\r\n.mdi-peanut-off::before {\r\n  content: \"\\F0FFD\";\r\n}\r\n\r\n.mdi-peanut-off-outline::before {\r\n  content: \"\\F0FFF\";\r\n}\r\n\r\n.mdi-peanut-outline::before {\r\n  content: \"\\F0FFE\";\r\n}\r\n\r\n.mdi-pen::before {\r\n  content: \"\\F03EA\";\r\n}\r\n\r\n.mdi-pen-lock::before {\r\n  content: \"\\F0DE2\";\r\n}\r\n\r\n.mdi-pen-minus::before {\r\n  content: \"\\F0DE3\";\r\n}\r\n\r\n.mdi-pen-off::before {\r\n  content: \"\\F0DE4\";\r\n}\r\n\r\n.mdi-pen-plus::before {\r\n  content: \"\\F0DE5\";\r\n}\r\n\r\n.mdi-pen-remove::before {\r\n  content: \"\\F0DE6\";\r\n}\r\n\r\n.mdi-pencil::before {\r\n  content: \"\\F03EB\";\r\n}\r\n\r\n.mdi-pencil-box::before {\r\n  content: \"\\F03EC\";\r\n}\r\n\r\n.mdi-pencil-box-multiple::before {\r\n  content: \"\\F1144\";\r\n}\r\n\r\n.mdi-pencil-box-multiple-outline::before {\r\n  content: \"\\F1145\";\r\n}\r\n\r\n.mdi-pencil-box-outline::before {\r\n  content: \"\\F03ED\";\r\n}\r\n\r\n.mdi-pencil-circle::before {\r\n  content: \"\\F06FF\";\r\n}\r\n\r\n.mdi-pencil-circle-outline::before {\r\n  content: \"\\F0776\";\r\n}\r\n\r\n.mdi-pencil-lock::before {\r\n  content: \"\\F03EE\";\r\n}\r\n\r\n.mdi-pencil-lock-outline::before {\r\n  content: \"\\F0DE7\";\r\n}\r\n\r\n.mdi-pencil-minus::before {\r\n  content: \"\\F0DE8\";\r\n}\r\n\r\n.mdi-pencil-minus-outline::before {\r\n  content: \"\\F0DE9\";\r\n}\r\n\r\n.mdi-pencil-off::before {\r\n  content: \"\\F03EF\";\r\n}\r\n\r\n.mdi-pencil-off-outline::before {\r\n  content: \"\\F0DEA\";\r\n}\r\n\r\n.mdi-pencil-outline::before {\r\n  content: \"\\F0CB6\";\r\n}\r\n\r\n.mdi-pencil-plus::before {\r\n  content: \"\\F0DEB\";\r\n}\r\n\r\n.mdi-pencil-plus-outline::before {\r\n  content: \"\\F0DEC\";\r\n}\r\n\r\n.mdi-pencil-remove::before {\r\n  content: \"\\F0DED\";\r\n}\r\n\r\n.mdi-pencil-remove-outline::before {\r\n  content: \"\\F0DEE\";\r\n}\r\n\r\n.mdi-pencil-ruler::before {\r\n  content: \"\\F1353\";\r\n}\r\n\r\n.mdi-penguin::before {\r\n  content: \"\\F0EC0\";\r\n}\r\n\r\n.mdi-pentagon::before {\r\n  content: \"\\F0701\";\r\n}\r\n\r\n.mdi-pentagon-outline::before {\r\n  content: \"\\F0700\";\r\n}\r\n\r\n.mdi-pentagram::before {\r\n  content: \"\\F1667\";\r\n}\r\n\r\n.mdi-percent::before {\r\n  content: \"\\F03F0\";\r\n}\r\n\r\n.mdi-percent-outline::before {\r\n  content: \"\\F1278\";\r\n}\r\n\r\n.mdi-periodic-table::before {\r\n  content: \"\\F08B6\";\r\n}\r\n\r\n.mdi-perspective-less::before {\r\n  content: \"\\F0D23\";\r\n}\r\n\r\n.mdi-perspective-more::before {\r\n  content: \"\\F0D24\";\r\n}\r\n\r\n.mdi-ph::before {\r\n  content: \"\\F17C5\";\r\n}\r\n\r\n.mdi-phone::before {\r\n  content: \"\\F03F2\";\r\n}\r\n\r\n.mdi-phone-alert::before {\r\n  content: \"\\F0F1A\";\r\n}\r\n\r\n.mdi-phone-alert-outline::before {\r\n  content: \"\\F118E\";\r\n}\r\n\r\n.mdi-phone-bluetooth::before {\r\n  content: \"\\F03F3\";\r\n}\r\n\r\n.mdi-phone-bluetooth-outline::before {\r\n  content: \"\\F118F\";\r\n}\r\n\r\n.mdi-phone-cancel::before {\r\n  content: \"\\F10BC\";\r\n}\r\n\r\n.mdi-phone-cancel-outline::before {\r\n  content: \"\\F1190\";\r\n}\r\n\r\n.mdi-phone-check::before {\r\n  content: \"\\F11A9\";\r\n}\r\n\r\n.mdi-phone-check-outline::before {\r\n  content: \"\\F11AA\";\r\n}\r\n\r\n.mdi-phone-classic::before {\r\n  content: \"\\F0602\";\r\n}\r\n\r\n.mdi-phone-classic-off::before {\r\n  content: \"\\F1279\";\r\n}\r\n\r\n.mdi-phone-dial::before {\r\n  content: \"\\F1559\";\r\n}\r\n\r\n.mdi-phone-dial-outline::before {\r\n  content: \"\\F155A\";\r\n}\r\n\r\n.mdi-phone-forward::before {\r\n  content: \"\\F03F4\";\r\n}\r\n\r\n.mdi-phone-forward-outline::before {\r\n  content: \"\\F1191\";\r\n}\r\n\r\n.mdi-phone-hangup::before {\r\n  content: \"\\F03F5\";\r\n}\r\n\r\n.mdi-phone-hangup-outline::before {\r\n  content: \"\\F1192\";\r\n}\r\n\r\n.mdi-phone-in-talk::before {\r\n  content: \"\\F03F6\";\r\n}\r\n\r\n.mdi-phone-in-talk-outline::before {\r\n  content: \"\\F1182\";\r\n}\r\n\r\n.mdi-phone-incoming::before {\r\n  content: \"\\F03F7\";\r\n}\r\n\r\n.mdi-phone-incoming-outline::before {\r\n  content: \"\\F1193\";\r\n}\r\n\r\n.mdi-phone-lock::before {\r\n  content: \"\\F03F8\";\r\n}\r\n\r\n.mdi-phone-lock-outline::before {\r\n  content: \"\\F1194\";\r\n}\r\n\r\n.mdi-phone-log::before {\r\n  content: \"\\F03F9\";\r\n}\r\n\r\n.mdi-phone-log-outline::before {\r\n  content: \"\\F1195\";\r\n}\r\n\r\n.mdi-phone-message::before {\r\n  content: \"\\F1196\";\r\n}\r\n\r\n.mdi-phone-message-outline::before {\r\n  content: \"\\F1197\";\r\n}\r\n\r\n.mdi-phone-minus::before {\r\n  content: \"\\F0658\";\r\n}\r\n\r\n.mdi-phone-minus-outline::before {\r\n  content: \"\\F1198\";\r\n}\r\n\r\n.mdi-phone-missed::before {\r\n  content: \"\\F03FA\";\r\n}\r\n\r\n.mdi-phone-missed-outline::before {\r\n  content: \"\\F11A5\";\r\n}\r\n\r\n.mdi-phone-off::before {\r\n  content: \"\\F0DEF\";\r\n}\r\n\r\n.mdi-phone-off-outline::before {\r\n  content: \"\\F11A6\";\r\n}\r\n\r\n.mdi-phone-outgoing::before {\r\n  content: \"\\F03FB\";\r\n}\r\n\r\n.mdi-phone-outgoing-outline::before {\r\n  content: \"\\F1199\";\r\n}\r\n\r\n.mdi-phone-outline::before {\r\n  content: \"\\F0DF0\";\r\n}\r\n\r\n.mdi-phone-paused::before {\r\n  content: \"\\F03FC\";\r\n}\r\n\r\n.mdi-phone-paused-outline::before {\r\n  content: \"\\F119A\";\r\n}\r\n\r\n.mdi-phone-plus::before {\r\n  content: \"\\F0659\";\r\n}\r\n\r\n.mdi-phone-plus-outline::before {\r\n  content: \"\\F119B\";\r\n}\r\n\r\n.mdi-phone-refresh::before {\r\n  content: \"\\F1993\";\r\n}\r\n\r\n.mdi-phone-refresh-outline::before {\r\n  content: \"\\F1994\";\r\n}\r\n\r\n.mdi-phone-remove::before {\r\n  content: \"\\F152F\";\r\n}\r\n\r\n.mdi-phone-remove-outline::before {\r\n  content: \"\\F1530\";\r\n}\r\n\r\n.mdi-phone-return::before {\r\n  content: \"\\F082F\";\r\n}\r\n\r\n.mdi-phone-return-outline::before {\r\n  content: \"\\F119C\";\r\n}\r\n\r\n.mdi-phone-ring::before {\r\n  content: \"\\F11AB\";\r\n}\r\n\r\n.mdi-phone-ring-outline::before {\r\n  content: \"\\F11AC\";\r\n}\r\n\r\n.mdi-phone-rotate-landscape::before {\r\n  content: \"\\F0885\";\r\n}\r\n\r\n.mdi-phone-rotate-portrait::before {\r\n  content: \"\\F0886\";\r\n}\r\n\r\n.mdi-phone-settings::before {\r\n  content: \"\\F03FD\";\r\n}\r\n\r\n.mdi-phone-settings-outline::before {\r\n  content: \"\\F119D\";\r\n}\r\n\r\n.mdi-phone-sync::before {\r\n  content: \"\\F1995\";\r\n}\r\n\r\n.mdi-phone-sync-outline::before {\r\n  content: \"\\F1996\";\r\n}\r\n\r\n.mdi-phone-voip::before {\r\n  content: \"\\F03FE\";\r\n}\r\n\r\n.mdi-pi::before {\r\n  content: \"\\F03FF\";\r\n}\r\n\r\n.mdi-pi-box::before {\r\n  content: \"\\F0400\";\r\n}\r\n\r\n.mdi-pi-hole::before {\r\n  content: \"\\F0DF1\";\r\n}\r\n\r\n.mdi-piano::before {\r\n  content: \"\\F067D\";\r\n}\r\n\r\n.mdi-piano-off::before {\r\n  content: \"\\F0698\";\r\n}\r\n\r\n.mdi-pickaxe::before {\r\n  content: \"\\F08B7\";\r\n}\r\n\r\n.mdi-picture-in-picture-bottom-right::before {\r\n  content: \"\\F0E57\";\r\n}\r\n\r\n.mdi-picture-in-picture-bottom-right-outline::before {\r\n  content: \"\\F0E58\";\r\n}\r\n\r\n.mdi-picture-in-picture-top-right::before {\r\n  content: \"\\F0E59\";\r\n}\r\n\r\n.mdi-picture-in-picture-top-right-outline::before {\r\n  content: \"\\F0E5A\";\r\n}\r\n\r\n.mdi-pier::before {\r\n  content: \"\\F0887\";\r\n}\r\n\r\n.mdi-pier-crane::before {\r\n  content: \"\\F0888\";\r\n}\r\n\r\n.mdi-pig::before {\r\n  content: \"\\F0401\";\r\n}\r\n\r\n.mdi-pig-variant::before {\r\n  content: \"\\F1006\";\r\n}\r\n\r\n.mdi-pig-variant-outline::before {\r\n  content: \"\\F1678\";\r\n}\r\n\r\n.mdi-piggy-bank::before {\r\n  content: \"\\F1007\";\r\n}\r\n\r\n.mdi-piggy-bank-outline::before {\r\n  content: \"\\F1679\";\r\n}\r\n\r\n.mdi-pill::before {\r\n  content: \"\\F0402\";\r\n}\r\n\r\n.mdi-pillar::before {\r\n  content: \"\\F0702\";\r\n}\r\n\r\n.mdi-pin::before {\r\n  content: \"\\F0403\";\r\n}\r\n\r\n.mdi-pin-off::before {\r\n  content: \"\\F0404\";\r\n}\r\n\r\n.mdi-pin-off-outline::before {\r\n  content: \"\\F0930\";\r\n}\r\n\r\n.mdi-pin-outline::before {\r\n  content: \"\\F0931\";\r\n}\r\n\r\n.mdi-pine-tree::before {\r\n  content: \"\\F0405\";\r\n}\r\n\r\n.mdi-pine-tree-box::before {\r\n  content: \"\\F0406\";\r\n}\r\n\r\n.mdi-pine-tree-fire::before {\r\n  content: \"\\F141A\";\r\n}\r\n\r\n.mdi-pinterest::before {\r\n  content: \"\\F0407\";\r\n}\r\n\r\n.mdi-pinwheel::before {\r\n  content: \"\\F0AD5\";\r\n}\r\n\r\n.mdi-pinwheel-outline::before {\r\n  content: \"\\F0AD6\";\r\n}\r\n\r\n.mdi-pipe::before {\r\n  content: \"\\F07E5\";\r\n}\r\n\r\n.mdi-pipe-disconnected::before {\r\n  content: \"\\F07E6\";\r\n}\r\n\r\n.mdi-pipe-leak::before {\r\n  content: \"\\F0889\";\r\n}\r\n\r\n.mdi-pipe-valve::before {\r\n  content: \"\\F184D\";\r\n}\r\n\r\n.mdi-pipe-wrench::before {\r\n  content: \"\\F1354\";\r\n}\r\n\r\n.mdi-pirate::before {\r\n  content: \"\\F0A08\";\r\n}\r\n\r\n.mdi-pistol::before {\r\n  content: \"\\F0703\";\r\n}\r\n\r\n.mdi-piston::before {\r\n  content: \"\\F088A\";\r\n}\r\n\r\n.mdi-pitchfork::before {\r\n  content: \"\\F1553\";\r\n}\r\n\r\n.mdi-pizza::before {\r\n  content: \"\\F0409\";\r\n}\r\n\r\n.mdi-play::before {\r\n  content: \"\\F040A\";\r\n}\r\n\r\n.mdi-play-box::before {\r\n  content: \"\\F127A\";\r\n}\r\n\r\n.mdi-play-box-multiple::before {\r\n  content: \"\\F0D19\";\r\n}\r\n\r\n.mdi-play-box-multiple-outline::before {\r\n  content: \"\\F13E6\";\r\n}\r\n\r\n.mdi-play-box-outline::before {\r\n  content: \"\\F040B\";\r\n}\r\n\r\n.mdi-play-circle::before {\r\n  content: \"\\F040C\";\r\n}\r\n\r\n.mdi-play-circle-outline::before {\r\n  content: \"\\F040D\";\r\n}\r\n\r\n.mdi-play-network::before {\r\n  content: \"\\F088B\";\r\n}\r\n\r\n.mdi-play-network-outline::before {\r\n  content: \"\\F0CB7\";\r\n}\r\n\r\n.mdi-play-outline::before {\r\n  content: \"\\F0F1B\";\r\n}\r\n\r\n.mdi-play-pause::before {\r\n  content: \"\\F040E\";\r\n}\r\n\r\n.mdi-play-protected-content::before {\r\n  content: \"\\F040F\";\r\n}\r\n\r\n.mdi-play-speed::before {\r\n  content: \"\\F08FF\";\r\n}\r\n\r\n.mdi-playlist-check::before {\r\n  content: \"\\F05C7\";\r\n}\r\n\r\n.mdi-playlist-edit::before {\r\n  content: \"\\F0900\";\r\n}\r\n\r\n.mdi-playlist-minus::before {\r\n  content: \"\\F0410\";\r\n}\r\n\r\n.mdi-playlist-music::before {\r\n  content: \"\\F0CB8\";\r\n}\r\n\r\n.mdi-playlist-music-outline::before {\r\n  content: \"\\F0CB9\";\r\n}\r\n\r\n.mdi-playlist-play::before {\r\n  content: \"\\F0411\";\r\n}\r\n\r\n.mdi-playlist-plus::before {\r\n  content: \"\\F0412\";\r\n}\r\n\r\n.mdi-playlist-remove::before {\r\n  content: \"\\F0413\";\r\n}\r\n\r\n.mdi-playlist-star::before {\r\n  content: \"\\F0DF2\";\r\n}\r\n\r\n.mdi-plex::before {\r\n  content: \"\\F06BA\";\r\n}\r\n\r\n.mdi-pliers::before {\r\n  content: \"\\F19A4\";\r\n}\r\n\r\n.mdi-plus::before {\r\n  content: \"\\F0415\";\r\n}\r\n\r\n.mdi-plus-box::before {\r\n  content: \"\\F0416\";\r\n}\r\n\r\n.mdi-plus-box-multiple::before {\r\n  content: \"\\F0334\";\r\n}\r\n\r\n.mdi-plus-box-multiple-outline::before {\r\n  content: \"\\F1143\";\r\n}\r\n\r\n.mdi-plus-box-outline::before {\r\n  content: \"\\F0704\";\r\n}\r\n\r\n.mdi-plus-circle::before {\r\n  content: \"\\F0417\";\r\n}\r\n\r\n.mdi-plus-circle-multiple::before {\r\n  content: \"\\F034C\";\r\n}\r\n\r\n.mdi-plus-circle-multiple-outline::before {\r\n  content: \"\\F0418\";\r\n}\r\n\r\n.mdi-plus-circle-outline::before {\r\n  content: \"\\F0419\";\r\n}\r\n\r\n.mdi-plus-minus::before {\r\n  content: \"\\F0992\";\r\n}\r\n\r\n.mdi-plus-minus-box::before {\r\n  content: \"\\F0993\";\r\n}\r\n\r\n.mdi-plus-minus-variant::before {\r\n  content: \"\\F14C9\";\r\n}\r\n\r\n.mdi-plus-network::before {\r\n  content: \"\\F041A\";\r\n}\r\n\r\n.mdi-plus-network-outline::before {\r\n  content: \"\\F0CBA\";\r\n}\r\n\r\n.mdi-plus-outline::before {\r\n  content: \"\\F0705\";\r\n}\r\n\r\n.mdi-plus-thick::before {\r\n  content: \"\\F11EC\";\r\n}\r\n\r\n.mdi-podcast::before {\r\n  content: \"\\F0994\";\r\n}\r\n\r\n.mdi-podium::before {\r\n  content: \"\\F0D25\";\r\n}\r\n\r\n.mdi-podium-bronze::before {\r\n  content: \"\\F0D26\";\r\n}\r\n\r\n.mdi-podium-gold::before {\r\n  content: \"\\F0D27\";\r\n}\r\n\r\n.mdi-podium-silver::before {\r\n  content: \"\\F0D28\";\r\n}\r\n\r\n.mdi-point-of-sale::before {\r\n  content: \"\\F0D92\";\r\n}\r\n\r\n.mdi-pokeball::before {\r\n  content: \"\\F041D\";\r\n}\r\n\r\n.mdi-pokemon-go::before {\r\n  content: \"\\F0A09\";\r\n}\r\n\r\n.mdi-poker-chip::before {\r\n  content: \"\\F0830\";\r\n}\r\n\r\n.mdi-polaroid::before {\r\n  content: \"\\F041E\";\r\n}\r\n\r\n.mdi-police-badge::before {\r\n  content: \"\\F1167\";\r\n}\r\n\r\n.mdi-police-badge-outline::before {\r\n  content: \"\\F1168\";\r\n}\r\n\r\n.mdi-police-station::before {\r\n  content: \"\\F1839\";\r\n}\r\n\r\n.mdi-poll::before {\r\n  content: \"\\F041F\";\r\n}\r\n\r\n.mdi-polo::before {\r\n  content: \"\\F14C3\";\r\n}\r\n\r\n.mdi-polymer::before {\r\n  content: \"\\F0421\";\r\n}\r\n\r\n.mdi-pool::before {\r\n  content: \"\\F0606\";\r\n}\r\n\r\n.mdi-popcorn::before {\r\n  content: \"\\F0422\";\r\n}\r\n\r\n.mdi-post::before {\r\n  content: \"\\F1008\";\r\n}\r\n\r\n.mdi-post-outline::before {\r\n  content: \"\\F1009\";\r\n}\r\n\r\n.mdi-postage-stamp::before {\r\n  content: \"\\F0CBB\";\r\n}\r\n\r\n.mdi-pot::before {\r\n  content: \"\\F02E5\";\r\n}\r\n\r\n.mdi-pot-mix::before {\r\n  content: \"\\F065B\";\r\n}\r\n\r\n.mdi-pot-mix-outline::before {\r\n  content: \"\\F0677\";\r\n}\r\n\r\n.mdi-pot-outline::before {\r\n  content: \"\\F02FF\";\r\n}\r\n\r\n.mdi-pot-steam::before {\r\n  content: \"\\F065A\";\r\n}\r\n\r\n.mdi-pot-steam-outline::before {\r\n  content: \"\\F0326\";\r\n}\r\n\r\n.mdi-pound::before {\r\n  content: \"\\F0423\";\r\n}\r\n\r\n.mdi-pound-box::before {\r\n  content: \"\\F0424\";\r\n}\r\n\r\n.mdi-pound-box-outline::before {\r\n  content: \"\\F117F\";\r\n}\r\n\r\n.mdi-power::before {\r\n  content: \"\\F0425\";\r\n}\r\n\r\n.mdi-power-cycle::before {\r\n  content: \"\\F0901\";\r\n}\r\n\r\n.mdi-power-off::before {\r\n  content: \"\\F0902\";\r\n}\r\n\r\n.mdi-power-on::before {\r\n  content: \"\\F0903\";\r\n}\r\n\r\n.mdi-power-plug::before {\r\n  content: \"\\F06A5\";\r\n}\r\n\r\n.mdi-power-plug-off::before {\r\n  content: \"\\F06A6\";\r\n}\r\n\r\n.mdi-power-plug-off-outline::before {\r\n  content: \"\\F1424\";\r\n}\r\n\r\n.mdi-power-plug-outline::before {\r\n  content: \"\\F1425\";\r\n}\r\n\r\n.mdi-power-settings::before {\r\n  content: \"\\F0426\";\r\n}\r\n\r\n.mdi-power-sleep::before {\r\n  content: \"\\F0904\";\r\n}\r\n\r\n.mdi-power-socket::before {\r\n  content: \"\\F0427\";\r\n}\r\n\r\n.mdi-power-socket-au::before {\r\n  content: \"\\F0905\";\r\n}\r\n\r\n.mdi-power-socket-ch::before {\r\n  content: \"\\F0FB3\";\r\n}\r\n\r\n.mdi-power-socket-de::before {\r\n  content: \"\\F1107\";\r\n}\r\n\r\n.mdi-power-socket-eu::before {\r\n  content: \"\\F07E7\";\r\n}\r\n\r\n.mdi-power-socket-fr::before {\r\n  content: \"\\F1108\";\r\n}\r\n\r\n.mdi-power-socket-it::before {\r\n  content: \"\\F14FF\";\r\n}\r\n\r\n.mdi-power-socket-jp::before {\r\n  content: \"\\F1109\";\r\n}\r\n\r\n.mdi-power-socket-uk::before {\r\n  content: \"\\F07E8\";\r\n}\r\n\r\n.mdi-power-socket-us::before {\r\n  content: \"\\F07E9\";\r\n}\r\n\r\n.mdi-power-standby::before {\r\n  content: \"\\F0906\";\r\n}\r\n\r\n.mdi-powershell::before {\r\n  content: \"\\F0A0A\";\r\n}\r\n\r\n.mdi-prescription::before {\r\n  content: \"\\F0706\";\r\n}\r\n\r\n.mdi-presentation::before {\r\n  content: \"\\F0428\";\r\n}\r\n\r\n.mdi-presentation-play::before {\r\n  content: \"\\F0429\";\r\n}\r\n\r\n.mdi-pretzel::before {\r\n  content: \"\\F1562\";\r\n}\r\n\r\n.mdi-printer::before {\r\n  content: \"\\F042A\";\r\n}\r\n\r\n.mdi-printer-3d::before {\r\n  content: \"\\F042B\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle::before {\r\n  content: \"\\F0E5B\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-alert::before {\r\n  content: \"\\F11C0\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-alert-outline::before {\r\n  content: \"\\F11C1\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-heat::before {\r\n  content: \"\\F18B8\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-heat-outline::before {\r\n  content: \"\\F18B9\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-outline::before {\r\n  content: \"\\F0E5C\";\r\n}\r\n\r\n.mdi-printer-alert::before {\r\n  content: \"\\F042C\";\r\n}\r\n\r\n.mdi-printer-check::before {\r\n  content: \"\\F1146\";\r\n}\r\n\r\n.mdi-printer-eye::before {\r\n  content: \"\\F1458\";\r\n}\r\n\r\n.mdi-printer-off::before {\r\n  content: \"\\F0E5D\";\r\n}\r\n\r\n.mdi-printer-off-outline::before {\r\n  content: \"\\F1785\";\r\n}\r\n\r\n.mdi-printer-outline::before {\r\n  content: \"\\F1786\";\r\n}\r\n\r\n.mdi-printer-pos::before {\r\n  content: \"\\F1057\";\r\n}\r\n\r\n.mdi-printer-search::before {\r\n  content: \"\\F1457\";\r\n}\r\n\r\n.mdi-printer-settings::before {\r\n  content: \"\\F0707\";\r\n}\r\n\r\n.mdi-printer-wireless::before {\r\n  content: \"\\F0A0B\";\r\n}\r\n\r\n.mdi-priority-high::before {\r\n  content: \"\\F0603\";\r\n}\r\n\r\n.mdi-priority-low::before {\r\n  content: \"\\F0604\";\r\n}\r\n\r\n.mdi-professional-hexagon::before {\r\n  content: \"\\F042D\";\r\n}\r\n\r\n.mdi-progress-alert::before {\r\n  content: \"\\F0CBC\";\r\n}\r\n\r\n.mdi-progress-check::before {\r\n  content: \"\\F0995\";\r\n}\r\n\r\n.mdi-progress-clock::before {\r\n  content: \"\\F0996\";\r\n}\r\n\r\n.mdi-progress-close::before {\r\n  content: \"\\F110A\";\r\n}\r\n\r\n.mdi-progress-download::before {\r\n  content: \"\\F0997\";\r\n}\r\n\r\n.mdi-progress-pencil::before {\r\n  content: \"\\F1787\";\r\n}\r\n\r\n.mdi-progress-question::before {\r\n  content: \"\\F1522\";\r\n}\r\n\r\n.mdi-progress-star::before {\r\n  content: \"\\F1788\";\r\n}\r\n\r\n.mdi-progress-upload::before {\r\n  content: \"\\F0998\";\r\n}\r\n\r\n.mdi-progress-wrench::before {\r\n  content: \"\\F0CBD\";\r\n}\r\n\r\n.mdi-projector::before {\r\n  content: \"\\F042E\";\r\n}\r\n\r\n.mdi-projector-screen::before {\r\n  content: \"\\F042F\";\r\n}\r\n\r\n.mdi-projector-screen-off::before {\r\n  content: \"\\F180D\";\r\n}\r\n\r\n.mdi-projector-screen-off-outline::before {\r\n  content: \"\\F180E\";\r\n}\r\n\r\n.mdi-projector-screen-outline::before {\r\n  content: \"\\F1724\";\r\n}\r\n\r\n.mdi-projector-screen-variant::before {\r\n  content: \"\\F180F\";\r\n}\r\n\r\n.mdi-projector-screen-variant-off::before {\r\n  content: \"\\F1810\";\r\n}\r\n\r\n.mdi-projector-screen-variant-off-outline::before {\r\n  content: \"\\F1811\";\r\n}\r\n\r\n.mdi-projector-screen-variant-outline::before {\r\n  content: \"\\F1812\";\r\n}\r\n\r\n.mdi-propane-tank::before {\r\n  content: \"\\F1357\";\r\n}\r\n\r\n.mdi-propane-tank-outline::before {\r\n  content: \"\\F1358\";\r\n}\r\n\r\n.mdi-protocol::before {\r\n  content: \"\\F0FD8\";\r\n}\r\n\r\n.mdi-publish::before {\r\n  content: \"\\F06A7\";\r\n}\r\n\r\n.mdi-publish-off::before {\r\n  content: \"\\F1945\";\r\n}\r\n\r\n.mdi-pulse::before {\r\n  content: \"\\F0430\";\r\n}\r\n\r\n.mdi-pump::before {\r\n  content: \"\\F1402\";\r\n}\r\n\r\n.mdi-pumpkin::before {\r\n  content: \"\\F0BBF\";\r\n}\r\n\r\n.mdi-purse::before {\r\n  content: \"\\F0F1C\";\r\n}\r\n\r\n.mdi-purse-outline::before {\r\n  content: \"\\F0F1D\";\r\n}\r\n\r\n.mdi-puzzle::before {\r\n  content: \"\\F0431\";\r\n}\r\n\r\n.mdi-puzzle-check::before {\r\n  content: \"\\F1426\";\r\n}\r\n\r\n.mdi-puzzle-check-outline::before {\r\n  content: \"\\F1427\";\r\n}\r\n\r\n.mdi-puzzle-edit::before {\r\n  content: \"\\F14D3\";\r\n}\r\n\r\n.mdi-puzzle-edit-outline::before {\r\n  content: \"\\F14D9\";\r\n}\r\n\r\n.mdi-puzzle-heart::before {\r\n  content: \"\\F14D4\";\r\n}\r\n\r\n.mdi-puzzle-heart-outline::before {\r\n  content: \"\\F14DA\";\r\n}\r\n\r\n.mdi-puzzle-minus::before {\r\n  content: \"\\F14D1\";\r\n}\r\n\r\n.mdi-puzzle-minus-outline::before {\r\n  content: \"\\F14D7\";\r\n}\r\n\r\n.mdi-puzzle-outline::before {\r\n  content: \"\\F0A66\";\r\n}\r\n\r\n.mdi-puzzle-plus::before {\r\n  content: \"\\F14D0\";\r\n}\r\n\r\n.mdi-puzzle-plus-outline::before {\r\n  content: \"\\F14D6\";\r\n}\r\n\r\n.mdi-puzzle-remove::before {\r\n  content: \"\\F14D2\";\r\n}\r\n\r\n.mdi-puzzle-remove-outline::before {\r\n  content: \"\\F14D8\";\r\n}\r\n\r\n.mdi-puzzle-star::before {\r\n  content: \"\\F14D5\";\r\n}\r\n\r\n.mdi-puzzle-star-outline::before {\r\n  content: \"\\F14DB\";\r\n}\r\n\r\n.mdi-pyramid::before {\r\n  content: \"\\F1952\";\r\n}\r\n\r\n.mdi-pyramid-off::before {\r\n  content: \"\\F1953\";\r\n}\r\n\r\n.mdi-qi::before {\r\n  content: \"\\F0999\";\r\n}\r\n\r\n.mdi-qqchat::before {\r\n  content: \"\\F0605\";\r\n}\r\n\r\n.mdi-qrcode::before {\r\n  content: \"\\F0432\";\r\n}\r\n\r\n.mdi-qrcode-edit::before {\r\n  content: \"\\F08B8\";\r\n}\r\n\r\n.mdi-qrcode-minus::before {\r\n  content: \"\\F118C\";\r\n}\r\n\r\n.mdi-qrcode-plus::before {\r\n  content: \"\\F118B\";\r\n}\r\n\r\n.mdi-qrcode-remove::before {\r\n  content: \"\\F118D\";\r\n}\r\n\r\n.mdi-qrcode-scan::before {\r\n  content: \"\\F0433\";\r\n}\r\n\r\n.mdi-quadcopter::before {\r\n  content: \"\\F0434\";\r\n}\r\n\r\n.mdi-quality-high::before {\r\n  content: \"\\F0435\";\r\n}\r\n\r\n.mdi-quality-low::before {\r\n  content: \"\\F0A0C\";\r\n}\r\n\r\n.mdi-quality-medium::before {\r\n  content: \"\\F0A0D\";\r\n}\r\n\r\n.mdi-quora::before {\r\n  content: \"\\F0D29\";\r\n}\r\n\r\n.mdi-rabbit::before {\r\n  content: \"\\F0907\";\r\n}\r\n\r\n.mdi-racing-helmet::before {\r\n  content: \"\\F0D93\";\r\n}\r\n\r\n.mdi-racquetball::before {\r\n  content: \"\\F0D94\";\r\n}\r\n\r\n.mdi-radar::before {\r\n  content: \"\\F0437\";\r\n}\r\n\r\n.mdi-radiator::before {\r\n  content: \"\\F0438\";\r\n}\r\n\r\n.mdi-radiator-disabled::before {\r\n  content: \"\\F0AD7\";\r\n}\r\n\r\n.mdi-radiator-off::before {\r\n  content: \"\\F0AD8\";\r\n}\r\n\r\n.mdi-radio::before {\r\n  content: \"\\F0439\";\r\n}\r\n\r\n.mdi-radio-am::before {\r\n  content: \"\\F0CBE\";\r\n}\r\n\r\n.mdi-radio-fm::before {\r\n  content: \"\\F0CBF\";\r\n}\r\n\r\n.mdi-radio-handheld::before {\r\n  content: \"\\F043A\";\r\n}\r\n\r\n.mdi-radio-off::before {\r\n  content: \"\\F121C\";\r\n}\r\n\r\n.mdi-radio-tower::before {\r\n  content: \"\\F043B\";\r\n}\r\n\r\n.mdi-radioactive::before {\r\n  content: \"\\F043C\";\r\n}\r\n\r\n.mdi-radioactive-circle::before {\r\n  content: \"\\F185D\";\r\n}\r\n\r\n.mdi-radioactive-circle-outline::before {\r\n  content: \"\\F185E\";\r\n}\r\n\r\n.mdi-radioactive-off::before {\r\n  content: \"\\F0EC1\";\r\n}\r\n\r\n.mdi-radiobox-blank::before {\r\n  content: \"\\F043D\";\r\n}\r\n\r\n.mdi-radiobox-marked::before {\r\n  content: \"\\F043E\";\r\n}\r\n\r\n.mdi-radiology-box::before {\r\n  content: \"\\F14C5\";\r\n}\r\n\r\n.mdi-radiology-box-outline::before {\r\n  content: \"\\F14C6\";\r\n}\r\n\r\n.mdi-radius::before {\r\n  content: \"\\F0CC0\";\r\n}\r\n\r\n.mdi-radius-outline::before {\r\n  content: \"\\F0CC1\";\r\n}\r\n\r\n.mdi-railroad-light::before {\r\n  content: \"\\F0F1E\";\r\n}\r\n\r\n.mdi-rake::before {\r\n  content: \"\\F1544\";\r\n}\r\n\r\n.mdi-raspberry-pi::before {\r\n  content: \"\\F043F\";\r\n}\r\n\r\n.mdi-ray-end::before {\r\n  content: \"\\F0440\";\r\n}\r\n\r\n.mdi-ray-end-arrow::before {\r\n  content: \"\\F0441\";\r\n}\r\n\r\n.mdi-ray-start::before {\r\n  content: \"\\F0442\";\r\n}\r\n\r\n.mdi-ray-start-arrow::before {\r\n  content: \"\\F0443\";\r\n}\r\n\r\n.mdi-ray-start-end::before {\r\n  content: \"\\F0444\";\r\n}\r\n\r\n.mdi-ray-start-vertex-end::before {\r\n  content: \"\\F15D8\";\r\n}\r\n\r\n.mdi-ray-vertex::before {\r\n  content: \"\\F0445\";\r\n}\r\n\r\n.mdi-razor-double-edge::before {\r\n  content: \"\\F1997\";\r\n}\r\n\r\n.mdi-razor-single-edge::before {\r\n  content: \"\\F1998\";\r\n}\r\n\r\n.mdi-react::before {\r\n  content: \"\\F0708\";\r\n}\r\n\r\n.mdi-read::before {\r\n  content: \"\\F0447\";\r\n}\r\n\r\n.mdi-receipt::before {\r\n  content: \"\\F0449\";\r\n}\r\n\r\n.mdi-record::before {\r\n  content: \"\\F044A\";\r\n}\r\n\r\n.mdi-record-circle::before {\r\n  content: \"\\F0EC2\";\r\n}\r\n\r\n.mdi-record-circle-outline::before {\r\n  content: \"\\F0EC3\";\r\n}\r\n\r\n.mdi-record-player::before {\r\n  content: \"\\F099A\";\r\n}\r\n\r\n.mdi-record-rec::before {\r\n  content: \"\\F044B\";\r\n}\r\n\r\n.mdi-rectangle::before {\r\n  content: \"\\F0E5E\";\r\n}\r\n\r\n.mdi-rectangle-outline::before {\r\n  content: \"\\F0E5F\";\r\n}\r\n\r\n.mdi-recycle::before {\r\n  content: \"\\F044C\";\r\n}\r\n\r\n.mdi-recycle-variant::before {\r\n  content: \"\\F139D\";\r\n}\r\n\r\n.mdi-reddit::before {\r\n  content: \"\\F044D\";\r\n}\r\n\r\n.mdi-redhat::before {\r\n  content: \"\\F111B\";\r\n}\r\n\r\n.mdi-redo::before {\r\n  content: \"\\F044E\";\r\n}\r\n\r\n.mdi-redo-variant::before {\r\n  content: \"\\F044F\";\r\n}\r\n\r\n.mdi-reflect-horizontal::before {\r\n  content: \"\\F0A0E\";\r\n}\r\n\r\n.mdi-reflect-vertical::before {\r\n  content: \"\\F0A0F\";\r\n}\r\n\r\n.mdi-refresh::before {\r\n  content: \"\\F0450\";\r\n}\r\n\r\n.mdi-refresh-auto::before {\r\n  content: \"\\F18F2\";\r\n}\r\n\r\n.mdi-refresh-circle::before {\r\n  content: \"\\F1377\";\r\n}\r\n\r\n.mdi-regex::before {\r\n  content: \"\\F0451\";\r\n}\r\n\r\n.mdi-registered-trademark::before {\r\n  content: \"\\F0A67\";\r\n}\r\n\r\n.mdi-reiterate::before {\r\n  content: \"\\F1588\";\r\n}\r\n\r\n.mdi-relation-many-to-many::before {\r\n  content: \"\\F1496\";\r\n}\r\n\r\n.mdi-relation-many-to-one::before {\r\n  content: \"\\F1497\";\r\n}\r\n\r\n.mdi-relation-many-to-one-or-many::before {\r\n  content: \"\\F1498\";\r\n}\r\n\r\n.mdi-relation-many-to-only-one::before {\r\n  content: \"\\F1499\";\r\n}\r\n\r\n.mdi-relation-many-to-zero-or-many::before {\r\n  content: \"\\F149A\";\r\n}\r\n\r\n.mdi-relation-many-to-zero-or-one::before {\r\n  content: \"\\F149B\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-many::before {\r\n  content: \"\\F149C\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-one::before {\r\n  content: \"\\F149D\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-one-or-many::before {\r\n  content: \"\\F149E\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-only-one::before {\r\n  content: \"\\F149F\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-zero-or-many::before {\r\n  content: \"\\F14A0\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-zero-or-one::before {\r\n  content: \"\\F14A1\";\r\n}\r\n\r\n.mdi-relation-one-to-many::before {\r\n  content: \"\\F14A2\";\r\n}\r\n\r\n.mdi-relation-one-to-one::before {\r\n  content: \"\\F14A3\";\r\n}\r\n\r\n.mdi-relation-one-to-one-or-many::before {\r\n  content: \"\\F14A4\";\r\n}\r\n\r\n.mdi-relation-one-to-only-one::before {\r\n  content: \"\\F14A5\";\r\n}\r\n\r\n.mdi-relation-one-to-zero-or-many::before {\r\n  content: \"\\F14A6\";\r\n}\r\n\r\n.mdi-relation-one-to-zero-or-one::before {\r\n  content: \"\\F14A7\";\r\n}\r\n\r\n.mdi-relation-only-one-to-many::before {\r\n  content: \"\\F14A8\";\r\n}\r\n\r\n.mdi-relation-only-one-to-one::before {\r\n  content: \"\\F14A9\";\r\n}\r\n\r\n.mdi-relation-only-one-to-one-or-many::before {\r\n  content: \"\\F14AA\";\r\n}\r\n\r\n.mdi-relation-only-one-to-only-one::before {\r\n  content: \"\\F14AB\";\r\n}\r\n\r\n.mdi-relation-only-one-to-zero-or-many::before {\r\n  content: \"\\F14AC\";\r\n}\r\n\r\n.mdi-relation-only-one-to-zero-or-one::before {\r\n  content: \"\\F14AD\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-many::before {\r\n  content: \"\\F14AE\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-one::before {\r\n  content: \"\\F14AF\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-one-or-many::before {\r\n  content: \"\\F14B0\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-only-one::before {\r\n  content: \"\\F14B1\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-zero-or-many::before {\r\n  content: \"\\F14B2\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-zero-or-one::before {\r\n  content: \"\\F14B3\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-many::before {\r\n  content: \"\\F14B4\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-one::before {\r\n  content: \"\\F14B5\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-one-or-many::before {\r\n  content: \"\\F14B6\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-only-one::before {\r\n  content: \"\\F14B7\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-zero-or-many::before {\r\n  content: \"\\F14B8\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-zero-or-one::before {\r\n  content: \"\\F14B9\";\r\n}\r\n\r\n.mdi-relative-scale::before {\r\n  content: \"\\F0452\";\r\n}\r\n\r\n.mdi-reload::before {\r\n  content: \"\\F0453\";\r\n}\r\n\r\n.mdi-reload-alert::before {\r\n  content: \"\\F110B\";\r\n}\r\n\r\n.mdi-reminder::before {\r\n  content: \"\\F088C\";\r\n}\r\n\r\n.mdi-remote::before {\r\n  content: \"\\F0454\";\r\n}\r\n\r\n.mdi-remote-desktop::before {\r\n  content: \"\\F08B9\";\r\n}\r\n\r\n.mdi-remote-off::before {\r\n  content: \"\\F0EC4\";\r\n}\r\n\r\n.mdi-remote-tv::before {\r\n  content: \"\\F0EC5\";\r\n}\r\n\r\n.mdi-remote-tv-off::before {\r\n  content: \"\\F0EC6\";\r\n}\r\n\r\n.mdi-rename-box::before {\r\n  content: \"\\F0455\";\r\n}\r\n\r\n.mdi-reorder-horizontal::before {\r\n  content: \"\\F0688\";\r\n}\r\n\r\n.mdi-reorder-vertical::before {\r\n  content: \"\\F0689\";\r\n}\r\n\r\n.mdi-repeat::before {\r\n  content: \"\\F0456\";\r\n}\r\n\r\n.mdi-repeat-off::before {\r\n  content: \"\\F0457\";\r\n}\r\n\r\n.mdi-repeat-once::before {\r\n  content: \"\\F0458\";\r\n}\r\n\r\n.mdi-repeat-variant::before {\r\n  content: \"\\F0547\";\r\n}\r\n\r\n.mdi-replay::before {\r\n  content: \"\\F0459\";\r\n}\r\n\r\n.mdi-reply::before {\r\n  content: \"\\F045A\";\r\n}\r\n\r\n.mdi-reply-all::before {\r\n  content: \"\\F045B\";\r\n}\r\n\r\n.mdi-reply-all-outline::before {\r\n  content: \"\\F0F1F\";\r\n}\r\n\r\n.mdi-reply-circle::before {\r\n  content: \"\\F11AE\";\r\n}\r\n\r\n.mdi-reply-outline::before {\r\n  content: \"\\F0F20\";\r\n}\r\n\r\n.mdi-recivil_budget::before {\r\n  content: \"\\F045C\";\r\n}\r\n\r\n.mdi-resistor::before {\r\n  content: \"\\F0B44\";\r\n}\r\n\r\n.mdi-resistor-nodes::before {\r\n  content: \"\\F0B45\";\r\n}\r\n\r\n.mdi-resize::before {\r\n  content: \"\\F0A68\";\r\n}\r\n\r\n.mdi-resize-bottom-right::before {\r\n  content: \"\\F045D\";\r\n}\r\n\r\n.mdi-responsive::before {\r\n  content: \"\\F045E\";\r\n}\r\n\r\n.mdi-restart::before {\r\n  content: \"\\F0709\";\r\n}\r\n\r\n.mdi-restart-alert::before {\r\n  content: \"\\F110C\";\r\n}\r\n\r\n.mdi-restart-off::before {\r\n  content: \"\\F0D95\";\r\n}\r\n\r\n.mdi-restore::before {\r\n  content: \"\\F099B\";\r\n}\r\n\r\n.mdi-restore-alert::before {\r\n  content: \"\\F110D\";\r\n}\r\n\r\n.mdi-rewind::before {\r\n  content: \"\\F045F\";\r\n}\r\n\r\n.mdi-rewind-10::before {\r\n  content: \"\\F0D2A\";\r\n}\r\n\r\n.mdi-rewind-15::before {\r\n  content: \"\\F1946\";\r\n}\r\n\r\n.mdi-rewind-30::before {\r\n  content: \"\\F0D96\";\r\n}\r\n\r\n.mdi-rewind-5::before {\r\n  content: \"\\F11F9\";\r\n}\r\n\r\n.mdi-rewind-60::before {\r\n  content: \"\\F160C\";\r\n}\r\n\r\n.mdi-rewind-outline::before {\r\n  content: \"\\F070A\";\r\n}\r\n\r\n.mdi-rhombus::before {\r\n  content: \"\\F070B\";\r\n}\r\n\r\n.mdi-rhombus-medium::before {\r\n  content: \"\\F0A10\";\r\n}\r\n\r\n.mdi-rhombus-medium-outline::before {\r\n  content: \"\\F14DC\";\r\n}\r\n\r\n.mdi-rhombus-outline::before {\r\n  content: \"\\F070C\";\r\n}\r\n\r\n.mdi-rhombus-split::before {\r\n  content: \"\\F0A11\";\r\n}\r\n\r\n.mdi-rhombus-split-outline::before {\r\n  content: \"\\F14DD\";\r\n}\r\n\r\n.mdi-ribbon::before {\r\n  content: \"\\F0460\";\r\n}\r\n\r\n.mdi-rice::before {\r\n  content: \"\\F07EA\";\r\n}\r\n\r\n.mdi-rickshaw::before {\r\n  content: \"\\F15BB\";\r\n}\r\n\r\n.mdi-rickshaw-electric::before {\r\n  content: \"\\F15BC\";\r\n}\r\n\r\n.mdi-ring::before {\r\n  content: \"\\F07EB\";\r\n}\r\n\r\n.mdi-rivet::before {\r\n  content: \"\\F0E60\";\r\n}\r\n\r\n.mdi-road::before {\r\n  content: \"\\F0461\";\r\n}\r\n\r\n.mdi-road-variant::before {\r\n  content: \"\\F0462\";\r\n}\r\n\r\n.mdi-robber::before {\r\n  content: \"\\F1058\";\r\n}\r\n\r\n.mdi-robot::before {\r\n  content: \"\\F06A9\";\r\n}\r\n\r\n.mdi-robot-angry::before {\r\n  content: \"\\F169D\";\r\n}\r\n\r\n.mdi-robot-angry-outline::before {\r\n  content: \"\\F169E\";\r\n}\r\n\r\n.mdi-robot-confused::before {\r\n  content: \"\\F169F\";\r\n}\r\n\r\n.mdi-robot-confused-outline::before {\r\n  content: \"\\F16A0\";\r\n}\r\n\r\n.mdi-robot-dead::before {\r\n  content: \"\\F16A1\";\r\n}\r\n\r\n.mdi-robot-dead-outline::before {\r\n  content: \"\\F16A2\";\r\n}\r\n\r\n.mdi-robot-excited::before {\r\n  content: \"\\F16A3\";\r\n}\r\n\r\n.mdi-robot-excited-outline::before {\r\n  content: \"\\F16A4\";\r\n}\r\n\r\n.mdi-robot-happy::before {\r\n  content: \"\\F1719\";\r\n}\r\n\r\n.mdi-robot-happy-outline::before {\r\n  content: \"\\F171A\";\r\n}\r\n\r\n.mdi-robot-industrial::before {\r\n  content: \"\\F0B46\";\r\n}\r\n\r\n.mdi-robot-love::before {\r\n  content: \"\\F16A5\";\r\n}\r\n\r\n.mdi-robot-love-outline::before {\r\n  content: \"\\F16A6\";\r\n}\r\n\r\n.mdi-robot-mower::before {\r\n  content: \"\\F11F7\";\r\n}\r\n\r\n.mdi-robot-mower-outline::before {\r\n  content: \"\\F11F3\";\r\n}\r\n\r\n.mdi-robot-off::before {\r\n  content: \"\\F16A7\";\r\n}\r\n\r\n.mdi-robot-off-outline::before {\r\n  content: \"\\F167B\";\r\n}\r\n\r\n.mdi-robot-outline::before {\r\n  content: \"\\F167A\";\r\n}\r\n\r\n.mdi-robot-vacuum::before {\r\n  content: \"\\F070D\";\r\n}\r\n\r\n.mdi-robot-vacuum-variant::before {\r\n  content: \"\\F0908\";\r\n}\r\n\r\n.mdi-rocket::before {\r\n  content: \"\\F0463\";\r\n}\r\n\r\n.mdi-rocket-launch::before {\r\n  content: \"\\F14DE\";\r\n}\r\n\r\n.mdi-rocket-launch-outline::before {\r\n  content: \"\\F14DF\";\r\n}\r\n\r\n.mdi-rocket-outline::before {\r\n  content: \"\\F13AF\";\r\n}\r\n\r\n.mdi-rodent::before {\r\n  content: \"\\F1327\";\r\n}\r\n\r\n.mdi-roller-skate::before {\r\n  content: \"\\F0D2B\";\r\n}\r\n\r\n.mdi-roller-skate-off::before {\r\n  content: \"\\F0145\";\r\n}\r\n\r\n.mdi-rollerblade::before {\r\n  content: \"\\F0D2C\";\r\n}\r\n\r\n.mdi-rollerblade-off::before {\r\n  content: \"\\F002E\";\r\n}\r\n\r\n.mdi-rollupjs::before {\r\n  content: \"\\F0BC0\";\r\n}\r\n\r\n.mdi-roman-numeral-1::before {\r\n  content: \"\\F1088\";\r\n}\r\n\r\n.mdi-roman-numeral-10::before {\r\n  content: \"\\F1091\";\r\n}\r\n\r\n.mdi-roman-numeral-2::before {\r\n  content: \"\\F1089\";\r\n}\r\n\r\n.mdi-roman-numeral-3::before {\r\n  content: \"\\F108A\";\r\n}\r\n\r\n.mdi-roman-numeral-4::before {\r\n  content: \"\\F108B\";\r\n}\r\n\r\n.mdi-roman-numeral-5::before {\r\n  content: \"\\F108C\";\r\n}\r\n\r\n.mdi-roman-numeral-6::before {\r\n  content: \"\\F108D\";\r\n}\r\n\r\n.mdi-roman-numeral-7::before {\r\n  content: \"\\F108E\";\r\n}\r\n\r\n.mdi-roman-numeral-8::before {\r\n  content: \"\\F108F\";\r\n}\r\n\r\n.mdi-roman-numeral-9::before {\r\n  content: \"\\F1090\";\r\n}\r\n\r\n.mdi-room-service::before {\r\n  content: \"\\F088D\";\r\n}\r\n\r\n.mdi-room-service-outline::before {\r\n  content: \"\\F0D97\";\r\n}\r\n\r\n.mdi-rotate-360::before {\r\n  content: \"\\F1999\";\r\n}\r\n\r\n.mdi-rotate-3d::before {\r\n  content: \"\\F0EC7\";\r\n}\r\n\r\n.mdi-rotate-3d-variant::before {\r\n  content: \"\\F0464\";\r\n}\r\n\r\n.mdi-rotate-left::before {\r\n  content: \"\\F0465\";\r\n}\r\n\r\n.mdi-rotate-left-variant::before {\r\n  content: \"\\F0466\";\r\n}\r\n\r\n.mdi-rotate-orbit::before {\r\n  content: \"\\F0D98\";\r\n}\r\n\r\n.mdi-rotate-right::before {\r\n  content: \"\\F0467\";\r\n}\r\n\r\n.mdi-rotate-right-variant::before {\r\n  content: \"\\F0468\";\r\n}\r\n\r\n.mdi-rounded-corner::before {\r\n  content: \"\\F0607\";\r\n}\r\n\r\n.mdi-router::before {\r\n  content: \"\\F11E2\";\r\n}\r\n\r\n.mdi-router-network::before {\r\n  content: \"\\F1087\";\r\n}\r\n\r\n.mdi-router-wireless::before {\r\n  content: \"\\F0469\";\r\n}\r\n\r\n.mdi-router-wireless-off::before {\r\n  content: \"\\F15A3\";\r\n}\r\n\r\n.mdi-router-wireless-settings::before {\r\n  content: \"\\F0A69\";\r\n}\r\n\r\n.mdi-routes::before {\r\n  content: \"\\F046A\";\r\n}\r\n\r\n.mdi-routes-clock::before {\r\n  content: \"\\F1059\";\r\n}\r\n\r\n.mdi-rowing::before {\r\n  content: \"\\F0608\";\r\n}\r\n\r\n.mdi-rss::before {\r\n  content: \"\\F046B\";\r\n}\r\n\r\n.mdi-rss-box::before {\r\n  content: \"\\F046C\";\r\n}\r\n\r\n.mdi-rss-off::before {\r\n  content: \"\\F0F21\";\r\n}\r\n\r\n.mdi-rug::before {\r\n  content: \"\\F1475\";\r\n}\r\n\r\n.mdi-rugby::before {\r\n  content: \"\\F0D99\";\r\n}\r\n\r\n.mdi-ruler::before {\r\n  content: \"\\F046D\";\r\n}\r\n\r\n.mdi-ruler-square::before {\r\n  content: \"\\F0CC2\";\r\n}\r\n\r\n.mdi-ruler-square-compass::before {\r\n  content: \"\\F0EBE\";\r\n}\r\n\r\n.mdi-run::before {\r\n  content: \"\\F070E\";\r\n}\r\n\r\n.mdi-run-fast::before {\r\n  content: \"\\F046E\";\r\n}\r\n\r\n.mdi-rv-truck::before {\r\n  content: \"\\F11D4\";\r\n}\r\n\r\n.mdi-sack::before {\r\n  content: \"\\F0D2E\";\r\n}\r\n\r\n.mdi-sack-percent::before {\r\n  content: \"\\F0D2F\";\r\n}\r\n\r\n.mdi-safe::before {\r\n  content: \"\\F0A6A\";\r\n}\r\n\r\n.mdi-safe-square::before {\r\n  content: \"\\F127C\";\r\n}\r\n\r\n.mdi-safe-square-outline::before {\r\n  content: \"\\F127D\";\r\n}\r\n\r\n.mdi-safety-goggles::before {\r\n  content: \"\\F0D30\";\r\n}\r\n\r\n.mdi-sail-boat::before {\r\n  content: \"\\F0EC8\";\r\n}\r\n\r\n.mdi-sale::before {\r\n  content: \"\\F046F\";\r\n}\r\n\r\n.mdi-salesforce::before {\r\n  content: \"\\F088E\";\r\n}\r\n\r\n.mdi-sass::before {\r\n  content: \"\\F07EC\";\r\n}\r\n\r\n.mdi-satellite::before {\r\n  content: \"\\F0470\";\r\n}\r\n\r\n.mdi-satellite-uplink::before {\r\n  content: \"\\F0909\";\r\n}\r\n\r\n.mdi-satellite-variant::before {\r\n  content: \"\\F0471\";\r\n}\r\n\r\n.mdi-sausage::before {\r\n  content: \"\\F08BA\";\r\n}\r\n\r\n.mdi-sausage-off::before {\r\n  content: \"\\F1789\";\r\n}\r\n\r\n.mdi-saw-blade::before {\r\n  content: \"\\F0E61\";\r\n}\r\n\r\n.mdi-sawtooth-wave::before {\r\n  content: \"\\F147A\";\r\n}\r\n\r\n.mdi-saxophone::before {\r\n  content: \"\\F0609\";\r\n}\r\n\r\n.mdi-scale::before {\r\n  content: \"\\F0472\";\r\n}\r\n\r\n.mdi-scale-balance::before {\r\n  content: \"\\F05D1\";\r\n}\r\n\r\n.mdi-scale-bathroom::before {\r\n  content: \"\\F0473\";\r\n}\r\n\r\n.mdi-scale-off::before {\r\n  content: \"\\F105A\";\r\n}\r\n\r\n.mdi-scale-unbalanced::before {\r\n  content: \"\\F19B8\";\r\n}\r\n\r\n.mdi-scan-helper::before {\r\n  content: \"\\F13D8\";\r\n}\r\n\r\n.mdi-scanner::before {\r\n  content: \"\\F06AB\";\r\n}\r\n\r\n.mdi-scanner-off::before {\r\n  content: \"\\F090A\";\r\n}\r\n\r\n.mdi-scatter-plot::before {\r\n  content: \"\\F0EC9\";\r\n}\r\n\r\n.mdi-scatter-plot-outline::before {\r\n  content: \"\\F0ECA\";\r\n}\r\n\r\n.mdi-scent::before {\r\n  content: \"\\F1958\";\r\n}\r\n\r\n.mdi-scent-off::before {\r\n  content: \"\\F1959\";\r\n}\r\n\r\n.mdi-school::before {\r\n  content: \"\\F0474\";\r\n}\r\n\r\n.mdi-school-outline::before {\r\n  content: \"\\F1180\";\r\n}\r\n\r\n.mdi-scissors-cutting::before {\r\n  content: \"\\F0A6B\";\r\n}\r\n\r\n.mdi-scooter::before {\r\n  content: \"\\F15BD\";\r\n}\r\n\r\n.mdi-scooter-electric::before {\r\n  content: \"\\F15BE\";\r\n}\r\n\r\n.mdi-scoreboard::before {\r\n  content: \"\\F127E\";\r\n}\r\n\r\n.mdi-scoreboard-outline::before {\r\n  content: \"\\F127F\";\r\n}\r\n\r\n.mdi-screen-rotation::before {\r\n  content: \"\\F0475\";\r\n}\r\n\r\n.mdi-screen-rotation-lock::before {\r\n  content: \"\\F0478\";\r\n}\r\n\r\n.mdi-screw-flat-top::before {\r\n  content: \"\\F0DF3\";\r\n}\r\n\r\n.mdi-screw-lag::before {\r\n  content: \"\\F0DF4\";\r\n}\r\n\r\n.mdi-screw-machine-flat-top::before {\r\n  content: \"\\F0DF5\";\r\n}\r\n\r\n.mdi-screw-machine-round-top::before {\r\n  content: \"\\F0DF6\";\r\n}\r\n\r\n.mdi-screw-round-top::before {\r\n  content: \"\\F0DF7\";\r\n}\r\n\r\n.mdi-screwdriver::before {\r\n  content: \"\\F0476\";\r\n}\r\n\r\n.mdi-script::before {\r\n  content: \"\\F0BC1\";\r\n}\r\n\r\n.mdi-script-outline::before {\r\n  content: \"\\F0477\";\r\n}\r\n\r\n.mdi-script-text::before {\r\n  content: \"\\F0BC2\";\r\n}\r\n\r\n.mdi-script-text-key::before {\r\n  content: \"\\F1725\";\r\n}\r\n\r\n.mdi-script-text-key-outline::before {\r\n  content: \"\\F1726\";\r\n}\r\n\r\n.mdi-script-text-outline::before {\r\n  content: \"\\F0BC3\";\r\n}\r\n\r\n.mdi-script-text-play::before {\r\n  content: \"\\F1727\";\r\n}\r\n\r\n.mdi-script-text-play-outline::before {\r\n  content: \"\\F1728\";\r\n}\r\n\r\n.mdi-sd::before {\r\n  content: \"\\F0479\";\r\n}\r\n\r\n.mdi-seal::before {\r\n  content: \"\\F047A\";\r\n}\r\n\r\n.mdi-seal-variant::before {\r\n  content: \"\\F0FD9\";\r\n}\r\n\r\n.mdi-search-web::before {\r\n  content: \"\\F070F\";\r\n}\r\n\r\n.mdi-seat::before {\r\n  content: \"\\F0CC3\";\r\n}\r\n\r\n.mdi-seat-flat::before {\r\n  content: \"\\F047B\";\r\n}\r\n\r\n.mdi-seat-flat-angled::before {\r\n  content: \"\\F047C\";\r\n}\r\n\r\n.mdi-seat-individual-suite::before {\r\n  content: \"\\F047D\";\r\n}\r\n\r\n.mdi-seat-legroom-extra::before {\r\n  content: \"\\F047E\";\r\n}\r\n\r\n.mdi-seat-legroom-normal::before {\r\n  content: \"\\F047F\";\r\n}\r\n\r\n.mdi-seat-legroom-reduced::before {\r\n  content: \"\\F0480\";\r\n}\r\n\r\n.mdi-seat-outline::before {\r\n  content: \"\\F0CC4\";\r\n}\r\n\r\n.mdi-seat-passenger::before {\r\n  content: \"\\F1249\";\r\n}\r\n\r\n.mdi-seat-recline-extra::before {\r\n  content: \"\\F0481\";\r\n}\r\n\r\n.mdi-seat-recline-normal::before {\r\n  content: \"\\F0482\";\r\n}\r\n\r\n.mdi-seatbelt::before {\r\n  content: \"\\F0CC5\";\r\n}\r\n\r\n.mdi-security::before {\r\n  content: \"\\F0483\";\r\n}\r\n\r\n.mdi-security-network::before {\r\n  content: \"\\F0484\";\r\n}\r\n\r\n.mdi-seed::before {\r\n  content: \"\\F0E62\";\r\n}\r\n\r\n.mdi-seed-off::before {\r\n  content: \"\\F13FD\";\r\n}\r\n\r\n.mdi-seed-off-outline::before {\r\n  content: \"\\F13FE\";\r\n}\r\n\r\n.mdi-seed-outline::before {\r\n  content: \"\\F0E63\";\r\n}\r\n\r\n.mdi-seesaw::before {\r\n  content: \"\\F15A4\";\r\n}\r\n\r\n.mdi-segment::before {\r\n  content: \"\\F0ECB\";\r\n}\r\n\r\n.mdi-select::before {\r\n  content: \"\\F0485\";\r\n}\r\n\r\n.mdi-select-all::before {\r\n  content: \"\\F0486\";\r\n}\r\n\r\n.mdi-select-color::before {\r\n  content: \"\\F0D31\";\r\n}\r\n\r\n.mdi-select-compare::before {\r\n  content: \"\\F0AD9\";\r\n}\r\n\r\n.mdi-select-drag::before {\r\n  content: \"\\F0A6C\";\r\n}\r\n\r\n.mdi-select-group::before {\r\n  content: \"\\F0F82\";\r\n}\r\n\r\n.mdi-select-inverse::before {\r\n  content: \"\\F0487\";\r\n}\r\n\r\n.mdi-select-marker::before {\r\n  content: \"\\F1280\";\r\n}\r\n\r\n.mdi-select-multiple::before {\r\n  content: \"\\F1281\";\r\n}\r\n\r\n.mdi-select-multiple-marker::before {\r\n  content: \"\\F1282\";\r\n}\r\n\r\n.mdi-select-off::before {\r\n  content: \"\\F0488\";\r\n}\r\n\r\n.mdi-select-place::before {\r\n  content: \"\\F0FDA\";\r\n}\r\n\r\n.mdi-select-remove::before {\r\n  content: \"\\F17C1\";\r\n}\r\n\r\n.mdi-select-search::before {\r\n  content: \"\\F1204\";\r\n}\r\n\r\n.mdi-selection::before {\r\n  content: \"\\F0489\";\r\n}\r\n\r\n.mdi-selection-drag::before {\r\n  content: \"\\F0A6D\";\r\n}\r\n\r\n.mdi-selection-ellipse::before {\r\n  content: \"\\F0D32\";\r\n}\r\n\r\n.mdi-selection-ellipse-arrow-inside::before {\r\n  content: \"\\F0F22\";\r\n}\r\n\r\n.mdi-selection-ellipse-remove::before {\r\n  content: \"\\F17C2\";\r\n}\r\n\r\n.mdi-selection-marker::before {\r\n  content: \"\\F1283\";\r\n}\r\n\r\n.mdi-selection-multiple::before {\r\n  content: \"\\F1285\";\r\n}\r\n\r\n.mdi-selection-multiple-marker::before {\r\n  content: \"\\F1284\";\r\n}\r\n\r\n.mdi-selection-off::before {\r\n  content: \"\\F0777\";\r\n}\r\n\r\n.mdi-selection-remove::before {\r\n  content: \"\\F17C3\";\r\n}\r\n\r\n.mdi-selection-search::before {\r\n  content: \"\\F1205\";\r\n}\r\n\r\n.mdi-semantic-web::before {\r\n  content: \"\\F1316\";\r\n}\r\n\r\n.mdi-send::before {\r\n  content: \"\\F048A\";\r\n}\r\n\r\n.mdi-send-check::before {\r\n  content: \"\\F1161\";\r\n}\r\n\r\n.mdi-send-check-outline::before {\r\n  content: \"\\F1162\";\r\n}\r\n\r\n.mdi-send-circle::before {\r\n  content: \"\\F0DF8\";\r\n}\r\n\r\n.mdi-send-circle-outline::before {\r\n  content: \"\\F0DF9\";\r\n}\r\n\r\n.mdi-send-clock::before {\r\n  content: \"\\F1163\";\r\n}\r\n\r\n.mdi-send-clock-outline::before {\r\n  content: \"\\F1164\";\r\n}\r\n\r\n.mdi-send-lock::before {\r\n  content: \"\\F07ED\";\r\n}\r\n\r\n.mdi-send-lock-outline::before {\r\n  content: \"\\F1166\";\r\n}\r\n\r\n.mdi-send-outline::before {\r\n  content: \"\\F1165\";\r\n}\r\n\r\n.mdi-serial-port::before {\r\n  content: \"\\F065C\";\r\n}\r\n\r\n.mdi-server::before {\r\n  content: \"\\F048B\";\r\n}\r\n\r\n.mdi-server-minus::before {\r\n  content: \"\\F048C\";\r\n}\r\n\r\n.mdi-server-network::before {\r\n  content: \"\\F048D\";\r\n}\r\n\r\n.mdi-server-network-off::before {\r\n  content: \"\\F048E\";\r\n}\r\n\r\n.mdi-server-off::before {\r\n  content: \"\\F048F\";\r\n}\r\n\r\n.mdi-server-plus::before {\r\n  content: \"\\F0490\";\r\n}\r\n\r\n.mdi-server-remove::before {\r\n  content: \"\\F0491\";\r\n}\r\n\r\n.mdi-server-security::before {\r\n  content: \"\\F0492\";\r\n}\r\n\r\n.mdi-set-all::before {\r\n  content: \"\\F0778\";\r\n}\r\n\r\n.mdi-set-center::before {\r\n  content: \"\\F0779\";\r\n}\r\n\r\n.mdi-set-center-right::before {\r\n  content: \"\\F077A\";\r\n}\r\n\r\n.mdi-set-left::before {\r\n  content: \"\\F077B\";\r\n}\r\n\r\n.mdi-set-left-center::before {\r\n  content: \"\\F077C\";\r\n}\r\n\r\n.mdi-set-left-right::before {\r\n  content: \"\\F077D\";\r\n}\r\n\r\n.mdi-set-merge::before {\r\n  content: \"\\F14E0\";\r\n}\r\n\r\n.mdi-set-none::before {\r\n  content: \"\\F077E\";\r\n}\r\n\r\n.mdi-set-right::before {\r\n  content: \"\\F077F\";\r\n}\r\n\r\n.mdi-set-split::before {\r\n  content: \"\\F14E1\";\r\n}\r\n\r\n.mdi-set-square::before {\r\n  content: \"\\F145D\";\r\n}\r\n\r\n.mdi-set-top-box::before {\r\n  content: \"\\F099F\";\r\n}\r\n\r\n.mdi-settings-helper::before {\r\n  content: \"\\F0A6E\";\r\n}\r\n\r\n.mdi-shaker::before {\r\n  content: \"\\F110E\";\r\n}\r\n\r\n.mdi-shaker-outline::before {\r\n  content: \"\\F110F\";\r\n}\r\n\r\n.mdi-shape::before {\r\n  content: \"\\F0831\";\r\n}\r\n\r\n.mdi-shape-circle-plus::before {\r\n  content: \"\\F065D\";\r\n}\r\n\r\n.mdi-shape-outline::before {\r\n  content: \"\\F0832\";\r\n}\r\n\r\n.mdi-shape-oval-plus::before {\r\n  content: \"\\F11FA\";\r\n}\r\n\r\n.mdi-shape-plus::before {\r\n  content: \"\\F0495\";\r\n}\r\n\r\n.mdi-shape-polygon-plus::before {\r\n  content: \"\\F065E\";\r\n}\r\n\r\n.mdi-shape-rectangle-plus::before {\r\n  content: \"\\F065F\";\r\n}\r\n\r\n.mdi-shape-square-plus::before {\r\n  content: \"\\F0660\";\r\n}\r\n\r\n.mdi-shape-square-rounded-plus::before {\r\n  content: \"\\F14FA\";\r\n}\r\n\r\n.mdi-share::before {\r\n  content: \"\\F0496\";\r\n}\r\n\r\n.mdi-share-all::before {\r\n  content: \"\\F11F4\";\r\n}\r\n\r\n.mdi-share-all-outline::before {\r\n  content: \"\\F11F5\";\r\n}\r\n\r\n.mdi-share-circle::before {\r\n  content: \"\\F11AD\";\r\n}\r\n\r\n.mdi-share-off::before {\r\n  content: \"\\F0F23\";\r\n}\r\n\r\n.mdi-share-off-outline::before {\r\n  content: \"\\F0F24\";\r\n}\r\n\r\n.mdi-share-outline::before {\r\n  content: \"\\F0932\";\r\n}\r\n\r\n.mdi-share-variant::before {\r\n  content: \"\\F0497\";\r\n}\r\n\r\n.mdi-share-variant-outline::before {\r\n  content: \"\\F1514\";\r\n}\r\n\r\n.mdi-shark::before {\r\n  content: \"\\F18BA\";\r\n}\r\n\r\n.mdi-shark-fin::before {\r\n  content: \"\\F1673\";\r\n}\r\n\r\n.mdi-shark-fin-outline::before {\r\n  content: \"\\F1674\";\r\n}\r\n\r\n.mdi-shark-off::before {\r\n  content: \"\\F18BB\";\r\n}\r\n\r\n.mdi-sheep::before {\r\n  content: \"\\F0CC6\";\r\n}\r\n\r\n.mdi-shield::before {\r\n  content: \"\\F0498\";\r\n}\r\n\r\n.mdi-shield-account::before {\r\n  content: \"\\F088F\";\r\n}\r\n\r\n.mdi-shield-account-outline::before {\r\n  content: \"\\F0A12\";\r\n}\r\n\r\n.mdi-shield-account-variant::before {\r\n  content: \"\\F15A7\";\r\n}\r\n\r\n.mdi-shield-account-variant-outline::before {\r\n  content: \"\\F15A8\";\r\n}\r\n\r\n.mdi-shield-airplane::before {\r\n  content: \"\\F06BB\";\r\n}\r\n\r\n.mdi-shield-airplane-outline::before {\r\n  content: \"\\F0CC7\";\r\n}\r\n\r\n.mdi-shield-alert::before {\r\n  content: \"\\F0ECC\";\r\n}\r\n\r\n.mdi-shield-alert-outline::before {\r\n  content: \"\\F0ECD\";\r\n}\r\n\r\n.mdi-shield-bug::before {\r\n  content: \"\\F13DA\";\r\n}\r\n\r\n.mdi-shield-bug-outline::before {\r\n  content: \"\\F13DB\";\r\n}\r\n\r\n.mdi-shield-car::before {\r\n  content: \"\\F0F83\";\r\n}\r\n\r\n.mdi-shield-check::before {\r\n  content: \"\\F0565\";\r\n}\r\n\r\n.mdi-shield-check-outline::before {\r\n  content: \"\\F0CC8\";\r\n}\r\n\r\n.mdi-shield-cross::before {\r\n  content: \"\\F0CC9\";\r\n}\r\n\r\n.mdi-shield-cross-outline::before {\r\n  content: \"\\F0CCA\";\r\n}\r\n\r\n.mdi-shield-crown::before {\r\n  content: \"\\F18BC\";\r\n}\r\n\r\n.mdi-shield-crown-outline::before {\r\n  content: \"\\F18BD\";\r\n}\r\n\r\n.mdi-shield-edit::before {\r\n  content: \"\\F11A0\";\r\n}\r\n\r\n.mdi-shield-edit-outline::before {\r\n  content: \"\\F11A1\";\r\n}\r\n\r\n.mdi-shield-half::before {\r\n  content: \"\\F1360\";\r\n}\r\n\r\n.mdi-shield-half-full::before {\r\n  content: \"\\F0780\";\r\n}\r\n\r\n.mdi-shield-home::before {\r\n  content: \"\\F068A\";\r\n}\r\n\r\n.mdi-shield-home-outline::before {\r\n  content: \"\\F0CCB\";\r\n}\r\n\r\n.mdi-shield-key::before {\r\n  content: \"\\F0BC4\";\r\n}\r\n\r\n.mdi-shield-key-outline::before {\r\n  content: \"\\F0BC5\";\r\n}\r\n\r\n.mdi-shield-link-variant::before {\r\n  content: \"\\F0D33\";\r\n}\r\n\r\n.mdi-shield-link-variant-outline::before {\r\n  content: \"\\F0D34\";\r\n}\r\n\r\n.mdi-shield-lock::before {\r\n  content: \"\\F099D\";\r\n}\r\n\r\n.mdi-shield-lock-open::before {\r\n  content: \"\\F199A\";\r\n}\r\n\r\n.mdi-shield-lock-open-outline::before {\r\n  content: \"\\F199B\";\r\n}\r\n\r\n.mdi-shield-lock-outline::before {\r\n  content: \"\\F0CCC\";\r\n}\r\n\r\n.mdi-shield-moon::before {\r\n  content: \"\\F1828\";\r\n}\r\n\r\n.mdi-shield-moon-outline::before {\r\n  content: \"\\F1829\";\r\n}\r\n\r\n.mdi-shield-off::before {\r\n  content: \"\\F099E\";\r\n}\r\n\r\n.mdi-shield-off-outline::before {\r\n  content: \"\\F099C\";\r\n}\r\n\r\n.mdi-shield-outline::before {\r\n  content: \"\\F0499\";\r\n}\r\n\r\n.mdi-shield-plus::before {\r\n  content: \"\\F0ADA\";\r\n}\r\n\r\n.mdi-shield-plus-outline::before {\r\n  content: \"\\F0ADB\";\r\n}\r\n\r\n.mdi-shield-refresh::before {\r\n  content: \"\\F00AA\";\r\n}\r\n\r\n.mdi-shield-refresh-outline::before {\r\n  content: \"\\F01E0\";\r\n}\r\n\r\n.mdi-shield-remove::before {\r\n  content: \"\\F0ADC\";\r\n}\r\n\r\n.mdi-shield-remove-outline::before {\r\n  content: \"\\F0ADD\";\r\n}\r\n\r\n.mdi-shield-search::before {\r\n  content: \"\\F0D9A\";\r\n}\r\n\r\n.mdi-shield-star::before {\r\n  content: \"\\F113B\";\r\n}\r\n\r\n.mdi-shield-star-outline::before {\r\n  content: \"\\F113C\";\r\n}\r\n\r\n.mdi-shield-sun::before {\r\n  content: \"\\F105D\";\r\n}\r\n\r\n.mdi-shield-sun-outline::before {\r\n  content: \"\\F105E\";\r\n}\r\n\r\n.mdi-shield-sword::before {\r\n  content: \"\\F18BE\";\r\n}\r\n\r\n.mdi-shield-sword-outline::before {\r\n  content: \"\\F18BF\";\r\n}\r\n\r\n.mdi-shield-sync::before {\r\n  content: \"\\F11A2\";\r\n}\r\n\r\n.mdi-shield-sync-outline::before {\r\n  content: \"\\F11A3\";\r\n}\r\n\r\n.mdi-shimmer::before {\r\n  content: \"\\F1545\";\r\n}\r\n\r\n.mdi-ship-wheel::before {\r\n  content: \"\\F0833\";\r\n}\r\n\r\n.mdi-shipping-pallet::before {\r\n  content: \"\\F184E\";\r\n}\r\n\r\n.mdi-shoe-ballet::before {\r\n  content: \"\\F15CA\";\r\n}\r\n\r\n.mdi-shoe-cleat::before {\r\n  content: \"\\F15C7\";\r\n}\r\n\r\n.mdi-shoe-formal::before {\r\n  content: \"\\F0B47\";\r\n}\r\n\r\n.mdi-shoe-heel::before {\r\n  content: \"\\F0B48\";\r\n}\r\n\r\n.mdi-shoe-print::before {\r\n  content: \"\\F0DFA\";\r\n}\r\n\r\n.mdi-shoe-sneaker::before {\r\n  content: \"\\F15C8\";\r\n}\r\n\r\n.mdi-shopping::before {\r\n  content: \"\\F049A\";\r\n}\r\n\r\n.mdi-shopping-music::before {\r\n  content: \"\\F049B\";\r\n}\r\n\r\n.mdi-shopping-outline::before {\r\n  content: \"\\F11D5\";\r\n}\r\n\r\n.mdi-shopping-search::before {\r\n  content: \"\\F0F84\";\r\n}\r\n\r\n.mdi-shore::before {\r\n  content: \"\\F14F9\";\r\n}\r\n\r\n.mdi-shovel::before {\r\n  content: \"\\F0710\";\r\n}\r\n\r\n.mdi-shovel-off::before {\r\n  content: \"\\F0711\";\r\n}\r\n\r\n.mdi-shower::before {\r\n  content: \"\\F09A0\";\r\n}\r\n\r\n.mdi-shower-head::before {\r\n  content: \"\\F09A1\";\r\n}\r\n\r\n.mdi-shredder::before {\r\n  content: \"\\F049C\";\r\n}\r\n\r\n.mdi-shuffle::before {\r\n  content: \"\\F049D\";\r\n}\r\n\r\n.mdi-shuffle-disabled::before {\r\n  content: \"\\F049E\";\r\n}\r\n\r\n.mdi-shuffle-variant::before {\r\n  content: \"\\F049F\";\r\n}\r\n\r\n.mdi-shuriken::before {\r\n  content: \"\\F137F\";\r\n}\r\n\r\n.mdi-sickle::before {\r\n  content: \"\\F18C0\";\r\n}\r\n\r\n.mdi-sigma::before {\r\n  content: \"\\F04A0\";\r\n}\r\n\r\n.mdi-sigma-lower::before {\r\n  content: \"\\F062B\";\r\n}\r\n\r\n.mdi-sign-caution::before {\r\n  content: \"\\F04A1\";\r\n}\r\n\r\n.mdi-sign-direction::before {\r\n  content: \"\\F0781\";\r\n}\r\n\r\n.mdi-sign-direction-minus::before {\r\n  content: \"\\F1000\";\r\n}\r\n\r\n.mdi-sign-direction-plus::before {\r\n  content: \"\\F0FDC\";\r\n}\r\n\r\n.mdi-sign-direction-remove::before {\r\n  content: \"\\F0FDD\";\r\n}\r\n\r\n.mdi-sign-pole::before {\r\n  content: \"\\F14F8\";\r\n}\r\n\r\n.mdi-sign-real-estate::before {\r\n  content: \"\\F1118\";\r\n}\r\n\r\n.mdi-sign-text::before {\r\n  content: \"\\F0782\";\r\n}\r\n\r\n.mdi-signal::before {\r\n  content: \"\\F04A2\";\r\n}\r\n\r\n.mdi-signal-2g::before {\r\n  content: \"\\F0712\";\r\n}\r\n\r\n.mdi-signal-3g::before {\r\n  content: \"\\F0713\";\r\n}\r\n\r\n.mdi-signal-4g::before {\r\n  content: \"\\F0714\";\r\n}\r\n\r\n.mdi-signal-5g::before {\r\n  content: \"\\F0A6F\";\r\n}\r\n\r\n.mdi-signal-cellular-1::before {\r\n  content: \"\\F08BC\";\r\n}\r\n\r\n.mdi-signal-cellular-2::before {\r\n  content: \"\\F08BD\";\r\n}\r\n\r\n.mdi-signal-cellular-3::before {\r\n  content: \"\\F08BE\";\r\n}\r\n\r\n.mdi-signal-cellular-outline::before {\r\n  content: \"\\F08BF\";\r\n}\r\n\r\n.mdi-signal-distance-variant::before {\r\n  content: \"\\F0E64\";\r\n}\r\n\r\n.mdi-signal-hspa::before {\r\n  content: \"\\F0715\";\r\n}\r\n\r\n.mdi-signal-hspa-plus::before {\r\n  content: \"\\F0716\";\r\n}\r\n\r\n.mdi-signal-off::before {\r\n  content: \"\\F0783\";\r\n}\r\n\r\n.mdi-signal-variant::before {\r\n  content: \"\\F060A\";\r\n}\r\n\r\n.mdi-signature::before {\r\n  content: \"\\F0DFB\";\r\n}\r\n\r\n.mdi-signature-freehand::before {\r\n  content: \"\\F0DFC\";\r\n}\r\n\r\n.mdi-signature-image::before {\r\n  content: \"\\F0DFD\";\r\n}\r\n\r\n.mdi-signature-text::before {\r\n  content: \"\\F0DFE\";\r\n}\r\n\r\n.mdi-silo::before {\r\n  content: \"\\F0B49\";\r\n}\r\n\r\n.mdi-silverware::before {\r\n  content: \"\\F04A3\";\r\n}\r\n\r\n.mdi-silverware-clean::before {\r\n  content: \"\\F0FDE\";\r\n}\r\n\r\n.mdi-silverware-fork::before {\r\n  content: \"\\F04A4\";\r\n}\r\n\r\n.mdi-silverware-fork-knife::before {\r\n  content: \"\\F0A70\";\r\n}\r\n\r\n.mdi-silverware-spoon::before {\r\n  content: \"\\F04A5\";\r\n}\r\n\r\n.mdi-silverware-variant::before {\r\n  content: \"\\F04A6\";\r\n}\r\n\r\n.mdi-sim::before {\r\n  content: \"\\F04A7\";\r\n}\r\n\r\n.mdi-sim-alert::before {\r\n  content: \"\\F04A8\";\r\n}\r\n\r\n.mdi-sim-alert-outline::before {\r\n  content: \"\\F15D3\";\r\n}\r\n\r\n.mdi-sim-off::before {\r\n  content: \"\\F04A9\";\r\n}\r\n\r\n.mdi-sim-off-outline::before {\r\n  content: \"\\F15D4\";\r\n}\r\n\r\n.mdi-sim-outline::before {\r\n  content: \"\\F15D5\";\r\n}\r\n\r\n.mdi-simple-icons::before {\r\n  content: \"\\F131D\";\r\n}\r\n\r\n.mdi-sina-weibo::before {\r\n  content: \"\\F0ADF\";\r\n}\r\n\r\n.mdi-sine-wave::before {\r\n  content: \"\\F095B\";\r\n}\r\n\r\n.mdi-sitemap::before {\r\n  content: \"\\F04AA\";\r\n}\r\n\r\n.mdi-sitemap-outline::before {\r\n  content: \"\\F199C\";\r\n}\r\n\r\n.mdi-size-l::before {\r\n  content: \"\\F13A6\";\r\n}\r\n\r\n.mdi-size-m::before {\r\n  content: \"\\F13A5\";\r\n}\r\n\r\n.mdi-size-s::before {\r\n  content: \"\\F13A4\";\r\n}\r\n\r\n.mdi-size-xl::before {\r\n  content: \"\\F13A7\";\r\n}\r\n\r\n.mdi-size-xs::before {\r\n  content: \"\\F13A3\";\r\n}\r\n\r\n.mdi-size-xxl::before {\r\n  content: \"\\F13A8\";\r\n}\r\n\r\n.mdi-size-xxs::before {\r\n  content: \"\\F13A2\";\r\n}\r\n\r\n.mdi-size-xxxl::before {\r\n  content: \"\\F13A9\";\r\n}\r\n\r\n.mdi-skate::before {\r\n  content: \"\\F0D35\";\r\n}\r\n\r\n.mdi-skate-off::before {\r\n  content: \"\\F0699\";\r\n}\r\n\r\n.mdi-skateboard::before {\r\n  content: \"\\F14C2\";\r\n}\r\n\r\n.mdi-skateboarding::before {\r\n  content: \"\\F0501\";\r\n}\r\n\r\n.mdi-skew-less::before {\r\n  content: \"\\F0D36\";\r\n}\r\n\r\n.mdi-skew-more::before {\r\n  content: \"\\F0D37\";\r\n}\r\n\r\n.mdi-ski::before {\r\n  content: \"\\F1304\";\r\n}\r\n\r\n.mdi-ski-cross-country::before {\r\n  content: \"\\F1305\";\r\n}\r\n\r\n.mdi-ski-water::before {\r\n  content: \"\\F1306\";\r\n}\r\n\r\n.mdi-skip-backward::before {\r\n  content: \"\\F04AB\";\r\n}\r\n\r\n.mdi-skip-backward-outline::before {\r\n  content: \"\\F0F25\";\r\n}\r\n\r\n.mdi-skip-forward::before {\r\n  content: \"\\F04AC\";\r\n}\r\n\r\n.mdi-skip-forward-outline::before {\r\n  content: \"\\F0F26\";\r\n}\r\n\r\n.mdi-skip-next::before {\r\n  content: \"\\F04AD\";\r\n}\r\n\r\n.mdi-skip-next-circle::before {\r\n  content: \"\\F0661\";\r\n}\r\n\r\n.mdi-skip-next-circle-outline::before {\r\n  content: \"\\F0662\";\r\n}\r\n\r\n.mdi-skip-next-outline::before {\r\n  content: \"\\F0F27\";\r\n}\r\n\r\n.mdi-skip-previous::before {\r\n  content: \"\\F04AE\";\r\n}\r\n\r\n.mdi-skip-previous-circle::before {\r\n  content: \"\\F0663\";\r\n}\r\n\r\n.mdi-skip-previous-circle-outline::before {\r\n  content: \"\\F0664\";\r\n}\r\n\r\n.mdi-skip-previous-outline::before {\r\n  content: \"\\F0F28\";\r\n}\r\n\r\n.mdi-skull::before {\r\n  content: \"\\F068C\";\r\n}\r\n\r\n.mdi-skull-crossbones::before {\r\n  content: \"\\F0BC6\";\r\n}\r\n\r\n.mdi-skull-crossbones-outline::before {\r\n  content: \"\\F0BC7\";\r\n}\r\n\r\n.mdi-skull-outline::before {\r\n  content: \"\\F0BC8\";\r\n}\r\n\r\n.mdi-skull-scan::before {\r\n  content: \"\\F14C7\";\r\n}\r\n\r\n.mdi-skull-scan-outline::before {\r\n  content: \"\\F14C8\";\r\n}\r\n\r\n.mdi-skype::before {\r\n  content: \"\\F04AF\";\r\n}\r\n\r\n.mdi-skype-business::before {\r\n  content: \"\\F04B0\";\r\n}\r\n\r\n.mdi-slack::before {\r\n  content: \"\\F04B1\";\r\n}\r\n\r\n.mdi-slash-forward::before {\r\n  content: \"\\F0FDF\";\r\n}\r\n\r\n.mdi-slash-forward-box::before {\r\n  content: \"\\F0FE0\";\r\n}\r\n\r\n.mdi-sledding::before {\r\n  content: \"\\F041B\";\r\n}\r\n\r\n.mdi-sleep::before {\r\n  content: \"\\F04B2\";\r\n}\r\n\r\n.mdi-sleep-off::before {\r\n  content: \"\\F04B3\";\r\n}\r\n\r\n.mdi-slide::before {\r\n  content: \"\\F15A5\";\r\n}\r\n\r\n.mdi-slope-downhill::before {\r\n  content: \"\\F0DFF\";\r\n}\r\n\r\n.mdi-slope-uphill::before {\r\n  content: \"\\F0E00\";\r\n}\r\n\r\n.mdi-slot-machine::before {\r\n  content: \"\\F1114\";\r\n}\r\n\r\n.mdi-slot-machine-outline::before {\r\n  content: \"\\F1115\";\r\n}\r\n\r\n.mdi-smart-card::before {\r\n  content: \"\\F10BD\";\r\n}\r\n\r\n.mdi-smart-card-off::before {\r\n  content: \"\\F18F7\";\r\n}\r\n\r\n.mdi-smart-card-off-outline::before {\r\n  content: \"\\F18F8\";\r\n}\r\n\r\n.mdi-smart-card-outline::before {\r\n  content: \"\\F10BE\";\r\n}\r\n\r\n.mdi-smart-card-reader::before {\r\n  content: \"\\F10BF\";\r\n}\r\n\r\n.mdi-smart-card-reader-outline::before {\r\n  content: \"\\F10C0\";\r\n}\r\n\r\n.mdi-smog::before {\r\n  content: \"\\F0A71\";\r\n}\r\n\r\n.mdi-smoke::before {\r\n  content: \"\\F1799\";\r\n}\r\n\r\n.mdi-smoke-detector::before {\r\n  content: \"\\F0392\";\r\n}\r\n\r\n.mdi-smoke-detector-alert::before {\r\n  content: \"\\F192E\";\r\n}\r\n\r\n.mdi-smoke-detector-alert-outline::before {\r\n  content: \"\\F192F\";\r\n}\r\n\r\n.mdi-smoke-detector-off::before {\r\n  content: \"\\F1809\";\r\n}\r\n\r\n.mdi-smoke-detector-off-outline::before {\r\n  content: \"\\F180A\";\r\n}\r\n\r\n.mdi-smoke-detector-outline::before {\r\n  content: \"\\F1808\";\r\n}\r\n\r\n.mdi-smoke-detector-variant::before {\r\n  content: \"\\F180B\";\r\n}\r\n\r\n.mdi-smoke-detector-variant-alert::before {\r\n  content: \"\\F1930\";\r\n}\r\n\r\n.mdi-smoke-detector-variant-off::before {\r\n  content: \"\\F180C\";\r\n}\r\n\r\n.mdi-smoking::before {\r\n  content: \"\\F04B4\";\r\n}\r\n\r\n.mdi-smoking-off::before {\r\n  content: \"\\F04B5\";\r\n}\r\n\r\n.mdi-smoking-pipe::before {\r\n  content: \"\\F140D\";\r\n}\r\n\r\n.mdi-smoking-pipe-off::before {\r\n  content: \"\\F1428\";\r\n}\r\n\r\n.mdi-snail::before {\r\n  content: \"\\F1677\";\r\n}\r\n\r\n.mdi-snake::before {\r\n  content: \"\\F150E\";\r\n}\r\n\r\n.mdi-snapchat::before {\r\n  content: \"\\F04B6\";\r\n}\r\n\r\n.mdi-snowboard::before {\r\n  content: \"\\F1307\";\r\n}\r\n\r\n.mdi-snowflake::before {\r\n  content: \"\\F0717\";\r\n}\r\n\r\n.mdi-snowflake-alert::before {\r\n  content: \"\\F0F29\";\r\n}\r\n\r\n.mdi-snowflake-melt::before {\r\n  content: \"\\F12CB\";\r\n}\r\n\r\n.mdi-snowflake-off::before {\r\n  content: \"\\F14E3\";\r\n}\r\n\r\n.mdi-snowflake-variant::before {\r\n  content: \"\\F0F2A\";\r\n}\r\n\r\n.mdi-snowman::before {\r\n  content: \"\\F04B7\";\r\n}\r\n\r\n.mdi-snowmobile::before {\r\n  content: \"\\F06DD\";\r\n}\r\n\r\n.mdi-soccer::before {\r\n  content: \"\\F04B8\";\r\n}\r\n\r\n.mdi-soccer-field::before {\r\n  content: \"\\F0834\";\r\n}\r\n\r\n.mdi-social-distance-2-meters::before {\r\n  content: \"\\F1579\";\r\n}\r\n\r\n.mdi-social-distance-6-feet::before {\r\n  content: \"\\F157A\";\r\n}\r\n\r\n.mdi-sofa::before {\r\n  content: \"\\F04B9\";\r\n}\r\n\r\n.mdi-sofa-outline::before {\r\n  content: \"\\F156D\";\r\n}\r\n\r\n.mdi-sofa-single::before {\r\n  content: \"\\F156E\";\r\n}\r\n\r\n.mdi-sofa-single-outline::before {\r\n  content: \"\\F156F\";\r\n}\r\n\r\n.mdi-solar-panel::before {\r\n  content: \"\\F0D9B\";\r\n}\r\n\r\n.mdi-solar-panel-large::before {\r\n  content: \"\\F0D9C\";\r\n}\r\n\r\n.mdi-solar-power::before {\r\n  content: \"\\F0A72\";\r\n}\r\n\r\n.mdi-soldering-iron::before {\r\n  content: \"\\F1092\";\r\n}\r\n\r\n.mdi-solid::before {\r\n  content: \"\\F068D\";\r\n}\r\n\r\n.mdi-sony-playstation::before {\r\n  content: \"\\F0414\";\r\n}\r\n\r\n.mdi-sort::before {\r\n  content: \"\\F04BA\";\r\n}\r\n\r\n.mdi-sort-alphabetical-ascending::before {\r\n  content: \"\\F05BD\";\r\n}\r\n\r\n.mdi-sort-alphabetical-ascending-variant::before {\r\n  content: \"\\F1148\";\r\n}\r\n\r\n.mdi-sort-alphabetical-descending::before {\r\n  content: \"\\F05BF\";\r\n}\r\n\r\n.mdi-sort-alphabetical-descending-variant::before {\r\n  content: \"\\F1149\";\r\n}\r\n\r\n.mdi-sort-alphabetical-variant::before {\r\n  content: \"\\F04BB\";\r\n}\r\n\r\n.mdi-sort-ascending::before {\r\n  content: \"\\F04BC\";\r\n}\r\n\r\n.mdi-sort-bool-ascending::before {\r\n  content: \"\\F1385\";\r\n}\r\n\r\n.mdi-sort-bool-ascending-variant::before {\r\n  content: \"\\F1386\";\r\n}\r\n\r\n.mdi-sort-bool-descending::before {\r\n  content: \"\\F1387\";\r\n}\r\n\r\n.mdi-sort-bool-descending-variant::before {\r\n  content: \"\\F1388\";\r\n}\r\n\r\n.mdi-sort-calendar-ascending::before {\r\n  content: \"\\F1547\";\r\n}\r\n\r\n.mdi-sort-calendar-descending::before {\r\n  content: \"\\F1548\";\r\n}\r\n\r\n.mdi-sort-clock-ascending::before {\r\n  content: \"\\F1549\";\r\n}\r\n\r\n.mdi-sort-clock-ascending-outline::before {\r\n  content: \"\\F154A\";\r\n}\r\n\r\n.mdi-sort-clock-descending::before {\r\n  content: \"\\F154B\";\r\n}\r\n\r\n.mdi-sort-clock-descending-outline::before {\r\n  content: \"\\F154C\";\r\n}\r\n\r\n.mdi-sort-descending::before {\r\n  content: \"\\F04BD\";\r\n}\r\n\r\n.mdi-sort-numeric-ascending::before {\r\n  content: \"\\F1389\";\r\n}\r\n\r\n.mdi-sort-numeric-ascending-variant::before {\r\n  content: \"\\F090D\";\r\n}\r\n\r\n.mdi-sort-numeric-descending::before {\r\n  content: \"\\F138A\";\r\n}\r\n\r\n.mdi-sort-numeric-descending-variant::before {\r\n  content: \"\\F0AD2\";\r\n}\r\n\r\n.mdi-sort-numeric-variant::before {\r\n  content: \"\\F04BE\";\r\n}\r\n\r\n.mdi-sort-reverse-variant::before {\r\n  content: \"\\F033C\";\r\n}\r\n\r\n.mdi-sort-variant::before {\r\n  content: \"\\F04BF\";\r\n}\r\n\r\n.mdi-sort-variant-lock::before {\r\n  content: \"\\F0CCD\";\r\n}\r\n\r\n.mdi-sort-variant-lock-open::before {\r\n  content: \"\\F0CCE\";\r\n}\r\n\r\n.mdi-sort-variant-remove::before {\r\n  content: \"\\F1147\";\r\n}\r\n\r\n.mdi-soundbar::before {\r\n  content: \"\\F17DB\";\r\n}\r\n\r\n.mdi-soundcloud::before {\r\n  content: \"\\F04C0\";\r\n}\r\n\r\n.mdi-source-branch::before {\r\n  content: \"\\F062C\";\r\n}\r\n\r\n.mdi-source-branch-check::before {\r\n  content: \"\\F14CF\";\r\n}\r\n\r\n.mdi-source-branch-minus::before {\r\n  content: \"\\F14CB\";\r\n}\r\n\r\n.mdi-source-branch-plus::before {\r\n  content: \"\\F14CA\";\r\n}\r\n\r\n.mdi-source-branch-refresh::before {\r\n  content: \"\\F14CD\";\r\n}\r\n\r\n.mdi-source-branch-remove::before {\r\n  content: \"\\F14CC\";\r\n}\r\n\r\n.mdi-source-branch-sync::before {\r\n  content: \"\\F14CE\";\r\n}\r\n\r\n.mdi-source-commit::before {\r\n  content: \"\\F0718\";\r\n}\r\n\r\n.mdi-source-commit-end::before {\r\n  content: \"\\F0719\";\r\n}\r\n\r\n.mdi-source-commit-end-local::before {\r\n  content: \"\\F071A\";\r\n}\r\n\r\n.mdi-source-commit-local::before {\r\n  content: \"\\F071B\";\r\n}\r\n\r\n.mdi-source-commit-next-local::before {\r\n  content: \"\\F071C\";\r\n}\r\n\r\n.mdi-source-commit-start::before {\r\n  content: \"\\F071D\";\r\n}\r\n\r\n.mdi-source-commit-start-next-local::before {\r\n  content: \"\\F071E\";\r\n}\r\n\r\n.mdi-source-fork::before {\r\n  content: \"\\F04C1\";\r\n}\r\n\r\n.mdi-source-merge::before {\r\n  content: \"\\F062D\";\r\n}\r\n\r\n.mdi-source-pull::before {\r\n  content: \"\\F04C2\";\r\n}\r\n\r\n.mdi-source-repository::before {\r\n  content: \"\\F0CCF\";\r\n}\r\n\r\n.mdi-source-repository-multiple::before {\r\n  content: \"\\F0CD0\";\r\n}\r\n\r\n.mdi-soy-sauce::before {\r\n  content: \"\\F07EE\";\r\n}\r\n\r\n.mdi-soy-sauce-off::before {\r\n  content: \"\\F13FC\";\r\n}\r\n\r\n.mdi-spa::before {\r\n  content: \"\\F0CD1\";\r\n}\r\n\r\n.mdi-spa-outline::before {\r\n  content: \"\\F0CD2\";\r\n}\r\n\r\n.mdi-space-invaders::before {\r\n  content: \"\\F0BC9\";\r\n}\r\n\r\n.mdi-space-station::before {\r\n  content: \"\\F1383\";\r\n}\r\n\r\n.mdi-spade::before {\r\n  content: \"\\F0E65\";\r\n}\r\n\r\n.mdi-speaker::before {\r\n  content: \"\\F04C3\";\r\n}\r\n\r\n.mdi-speaker-bluetooth::before {\r\n  content: \"\\F09A2\";\r\n}\r\n\r\n.mdi-speaker-multiple::before {\r\n  content: \"\\F0D38\";\r\n}\r\n\r\n.mdi-speaker-off::before {\r\n  content: \"\\F04C4\";\r\n}\r\n\r\n.mdi-speaker-wireless::before {\r\n  content: \"\\F071F\";\r\n}\r\n\r\n.mdi-spear::before {\r\n  content: \"\\F1845\";\r\n}\r\n\r\n.mdi-speedometer::before {\r\n  content: \"\\F04C5\";\r\n}\r\n\r\n.mdi-speedometer-medium::before {\r\n  content: \"\\F0F85\";\r\n}\r\n\r\n.mdi-speedometer-slow::before {\r\n  content: \"\\F0F86\";\r\n}\r\n\r\n.mdi-spellcheck::before {\r\n  content: \"\\F04C6\";\r\n}\r\n\r\n.mdi-sphere::before {\r\n  content: \"\\F1954\";\r\n}\r\n\r\n.mdi-sphere-off::before {\r\n  content: \"\\F1955\";\r\n}\r\n\r\n.mdi-spider::before {\r\n  content: \"\\F11EA\";\r\n}\r\n\r\n.mdi-spider-thread::before {\r\n  content: \"\\F11EB\";\r\n}\r\n\r\n.mdi-spider-web::before {\r\n  content: \"\\F0BCA\";\r\n}\r\n\r\n.mdi-spirit-level::before {\r\n  content: \"\\F14F1\";\r\n}\r\n\r\n.mdi-spoon-sugar::before {\r\n  content: \"\\F1429\";\r\n}\r\n\r\n.mdi-spotify::before {\r\n  content: \"\\F04C7\";\r\n}\r\n\r\n.mdi-spotlight::before {\r\n  content: \"\\F04C8\";\r\n}\r\n\r\n.mdi-spotlight-beam::before {\r\n  content: \"\\F04C9\";\r\n}\r\n\r\n.mdi-spray::before {\r\n  content: \"\\F0665\";\r\n}\r\n\r\n.mdi-spray-bottle::before {\r\n  content: \"\\F0AE0\";\r\n}\r\n\r\n.mdi-sprinkler::before {\r\n  content: \"\\F105F\";\r\n}\r\n\r\n.mdi-sprinkler-fire::before {\r\n  content: \"\\F199D\";\r\n}\r\n\r\n.mdi-sprinkler-variant::before {\r\n  content: \"\\F1060\";\r\n}\r\n\r\n.mdi-sprout::before {\r\n  content: \"\\F0E66\";\r\n}\r\n\r\n.mdi-sprout-outline::before {\r\n  content: \"\\F0E67\";\r\n}\r\n\r\n.mdi-square::before {\r\n  content: \"\\F0764\";\r\n}\r\n\r\n.mdi-square-circle::before {\r\n  content: \"\\F1500\";\r\n}\r\n\r\n.mdi-square-edit-outline::before {\r\n  content: \"\\F090C\";\r\n}\r\n\r\n.mdi-square-medium::before {\r\n  content: \"\\F0A13\";\r\n}\r\n\r\n.mdi-square-medium-outline::before {\r\n  content: \"\\F0A14\";\r\n}\r\n\r\n.mdi-square-off::before {\r\n  content: \"\\F12EE\";\r\n}\r\n\r\n.mdi-square-off-outline::before {\r\n  content: \"\\F12EF\";\r\n}\r\n\r\n.mdi-square-opacity::before {\r\n  content: \"\\F1854\";\r\n}\r\n\r\n.mdi-square-outline::before {\r\n  content: \"\\F0763\";\r\n}\r\n\r\n.mdi-square-root::before {\r\n  content: \"\\F0784\";\r\n}\r\n\r\n.mdi-square-root-box::before {\r\n  content: \"\\F09A3\";\r\n}\r\n\r\n.mdi-square-rounded::before {\r\n  content: \"\\F14FB\";\r\n}\r\n\r\n.mdi-square-rounded-outline::before {\r\n  content: \"\\F14FC\";\r\n}\r\n\r\n.mdi-square-small::before {\r\n  content: \"\\F0A15\";\r\n}\r\n\r\n.mdi-square-wave::before {\r\n  content: \"\\F147B\";\r\n}\r\n\r\n.mdi-squeegee::before {\r\n  content: \"\\F0AE1\";\r\n}\r\n\r\n.mdi-ssh::before {\r\n  content: \"\\F08C0\";\r\n}\r\n\r\n.mdi-stack-exchange::before {\r\n  content: \"\\F060B\";\r\n}\r\n\r\n.mdi-stack-overflow::before {\r\n  content: \"\\F04CC\";\r\n}\r\n\r\n.mdi-stackpath::before {\r\n  content: \"\\F0359\";\r\n}\r\n\r\n.mdi-stadium::before {\r\n  content: \"\\F0FF9\";\r\n}\r\n\r\n.mdi-stadium-variant::before {\r\n  content: \"\\F0720\";\r\n}\r\n\r\n.mdi-stairs::before {\r\n  content: \"\\F04CD\";\r\n}\r\n\r\n.mdi-stairs-box::before {\r\n  content: \"\\F139E\";\r\n}\r\n\r\n.mdi-stairs-down::before {\r\n  content: \"\\F12BE\";\r\n}\r\n\r\n.mdi-stairs-up::before {\r\n  content: \"\\F12BD\";\r\n}\r\n\r\n.mdi-stamper::before {\r\n  content: \"\\F0D39\";\r\n}\r\n\r\n.mdi-standard-definition::before {\r\n  content: \"\\F07EF\";\r\n}\r\n\r\n.mdi-star::before {\r\n  content: \"\\F04CE\";\r\n}\r\n\r\n.mdi-star-box::before {\r\n  content: \"\\F0A73\";\r\n}\r\n\r\n.mdi-star-box-multiple::before {\r\n  content: \"\\F1286\";\r\n}\r\n\r\n.mdi-star-box-multiple-outline::before {\r\n  content: \"\\F1287\";\r\n}\r\n\r\n.mdi-star-box-outline::before {\r\n  content: \"\\F0A74\";\r\n}\r\n\r\n.mdi-star-check::before {\r\n  content: \"\\F1566\";\r\n}\r\n\r\n.mdi-star-check-outline::before {\r\n  content: \"\\F156A\";\r\n}\r\n\r\n.mdi-star-circle::before {\r\n  content: \"\\F04CF\";\r\n}\r\n\r\n.mdi-star-circle-outline::before {\r\n  content: \"\\F09A4\";\r\n}\r\n\r\n.mdi-star-cog::before {\r\n  content: \"\\F1668\";\r\n}\r\n\r\n.mdi-star-cog-outline::before {\r\n  content: \"\\F1669\";\r\n}\r\n\r\n.mdi-star-crescent::before {\r\n  content: \"\\F0979\";\r\n}\r\n\r\n.mdi-star-david::before {\r\n  content: \"\\F097A\";\r\n}\r\n\r\n.mdi-star-face::before {\r\n  content: \"\\F09A5\";\r\n}\r\n\r\n.mdi-star-four-points::before {\r\n  content: \"\\F0AE2\";\r\n}\r\n\r\n.mdi-star-four-points-outline::before {\r\n  content: \"\\F0AE3\";\r\n}\r\n\r\n.mdi-star-half::before {\r\n  content: \"\\F0246\";\r\n}\r\n\r\n.mdi-star-half-full::before {\r\n  content: \"\\F04D0\";\r\n}\r\n\r\n.mdi-star-minus::before {\r\n  content: \"\\F1564\";\r\n}\r\n\r\n.mdi-star-minus-outline::before {\r\n  content: \"\\F1568\";\r\n}\r\n\r\n.mdi-star-off::before {\r\n  content: \"\\F04D1\";\r\n}\r\n\r\n.mdi-star-off-outline::before {\r\n  content: \"\\F155B\";\r\n}\r\n\r\n.mdi-star-outline::before {\r\n  content: \"\\F04D2\";\r\n}\r\n\r\n.mdi-star-plus::before {\r\n  content: \"\\F1563\";\r\n}\r\n\r\n.mdi-star-plus-outline::before {\r\n  content: \"\\F1567\";\r\n}\r\n\r\n.mdi-star-remove::before {\r\n  content: \"\\F1565\";\r\n}\r\n\r\n.mdi-star-remove-outline::before {\r\n  content: \"\\F1569\";\r\n}\r\n\r\n.mdi-star-settings::before {\r\n  content: \"\\F166A\";\r\n}\r\n\r\n.mdi-star-settings-outline::before {\r\n  content: \"\\F166B\";\r\n}\r\n\r\n.mdi-star-shooting::before {\r\n  content: \"\\F1741\";\r\n}\r\n\r\n.mdi-star-shooting-outline::before {\r\n  content: \"\\F1742\";\r\n}\r\n\r\n.mdi-star-three-points::before {\r\n  content: \"\\F0AE4\";\r\n}\r\n\r\n.mdi-star-three-points-outline::before {\r\n  content: \"\\F0AE5\";\r\n}\r\n\r\n.mdi-state-machine::before {\r\n  content: \"\\F11EF\";\r\n}\r\n\r\n.mdi-steam::before {\r\n  content: \"\\F04D3\";\r\n}\r\n\r\n.mdi-steering::before {\r\n  content: \"\\F04D4\";\r\n}\r\n\r\n.mdi-steering-off::before {\r\n  content: \"\\F090E\";\r\n}\r\n\r\n.mdi-step-backward::before {\r\n  content: \"\\F04D5\";\r\n}\r\n\r\n.mdi-step-backward-2::before {\r\n  content: \"\\F04D6\";\r\n}\r\n\r\n.mdi-step-forward::before {\r\n  content: \"\\F04D7\";\r\n}\r\n\r\n.mdi-step-forward-2::before {\r\n  content: \"\\F04D8\";\r\n}\r\n\r\n.mdi-stethoscope::before {\r\n  content: \"\\F04D9\";\r\n}\r\n\r\n.mdi-sticker::before {\r\n  content: \"\\F1364\";\r\n}\r\n\r\n.mdi-sticker-alert::before {\r\n  content: \"\\F1365\";\r\n}\r\n\r\n.mdi-sticker-alert-outline::before {\r\n  content: \"\\F1366\";\r\n}\r\n\r\n.mdi-sticker-check::before {\r\n  content: \"\\F1367\";\r\n}\r\n\r\n.mdi-sticker-check-outline::before {\r\n  content: \"\\F1368\";\r\n}\r\n\r\n.mdi-sticker-circle-outline::before {\r\n  content: \"\\F05D0\";\r\n}\r\n\r\n.mdi-sticker-emoji::before {\r\n  content: \"\\F0785\";\r\n}\r\n\r\n.mdi-sticker-minus::before {\r\n  content: \"\\F1369\";\r\n}\r\n\r\n.mdi-sticker-minus-outline::before {\r\n  content: \"\\F136A\";\r\n}\r\n\r\n.mdi-sticker-outline::before {\r\n  content: \"\\F136B\";\r\n}\r\n\r\n.mdi-sticker-plus::before {\r\n  content: \"\\F136C\";\r\n}\r\n\r\n.mdi-sticker-plus-outline::before {\r\n  content: \"\\F136D\";\r\n}\r\n\r\n.mdi-sticker-remove::before {\r\n  content: \"\\F136E\";\r\n}\r\n\r\n.mdi-sticker-remove-outline::before {\r\n  content: \"\\F136F\";\r\n}\r\n\r\n.mdi-sticker-text::before {\r\n  content: \"\\F178E\";\r\n}\r\n\r\n.mdi-sticker-text-outline::before {\r\n  content: \"\\F178F\";\r\n}\r\n\r\n.mdi-stocking::before {\r\n  content: \"\\F04DA\";\r\n}\r\n\r\n.mdi-stomach::before {\r\n  content: \"\\F1093\";\r\n}\r\n\r\n.mdi-stool::before {\r\n  content: \"\\F195D\";\r\n}\r\n\r\n.mdi-stool-outline::before {\r\n  content: \"\\F195E\";\r\n}\r\n\r\n.mdi-stop::before {\r\n  content: \"\\F04DB\";\r\n}\r\n\r\n.mdi-stop-circle::before {\r\n  content: \"\\F0666\";\r\n}\r\n\r\n.mdi-stop-circle-outline::before {\r\n  content: \"\\F0667\";\r\n}\r\n\r\n.mdi-store::before {\r\n  content: \"\\F04DC\";\r\n}\r\n\r\n.mdi-store-24-hour::before {\r\n  content: \"\\F04DD\";\r\n}\r\n\r\n.mdi-store-alert::before {\r\n  content: \"\\F18C1\";\r\n}\r\n\r\n.mdi-store-alert-outline::before {\r\n  content: \"\\F18C2\";\r\n}\r\n\r\n.mdi-store-check::before {\r\n  content: \"\\F18C3\";\r\n}\r\n\r\n.mdi-store-check-outline::before {\r\n  content: \"\\F18C4\";\r\n}\r\n\r\n.mdi-store-clock::before {\r\n  content: \"\\F18C5\";\r\n}\r\n\r\n.mdi-store-clock-outline::before {\r\n  content: \"\\F18C6\";\r\n}\r\n\r\n.mdi-store-cog::before {\r\n  content: \"\\F18C7\";\r\n}\r\n\r\n.mdi-store-cog-outline::before {\r\n  content: \"\\F18C8\";\r\n}\r\n\r\n.mdi-store-edit::before {\r\n  content: \"\\F18C9\";\r\n}\r\n\r\n.mdi-store-edit-outline::before {\r\n  content: \"\\F18CA\";\r\n}\r\n\r\n.mdi-store-marker::before {\r\n  content: \"\\F18CB\";\r\n}\r\n\r\n.mdi-store-marker-outline::before {\r\n  content: \"\\F18CC\";\r\n}\r\n\r\n.mdi-store-minus::before {\r\n  content: \"\\F165E\";\r\n}\r\n\r\n.mdi-store-minus-outline::before {\r\n  content: \"\\F18CD\";\r\n}\r\n\r\n.mdi-store-off::before {\r\n  content: \"\\F18CE\";\r\n}\r\n\r\n.mdi-store-off-outline::before {\r\n  content: \"\\F18CF\";\r\n}\r\n\r\n.mdi-store-outline::before {\r\n  content: \"\\F1361\";\r\n}\r\n\r\n.mdi-store-plus::before {\r\n  content: \"\\F165F\";\r\n}\r\n\r\n.mdi-store-plus-outline::before {\r\n  content: \"\\F18D0\";\r\n}\r\n\r\n.mdi-store-remove::before {\r\n  content: \"\\F1660\";\r\n}\r\n\r\n.mdi-store-remove-outline::before {\r\n  content: \"\\F18D1\";\r\n}\r\n\r\n.mdi-store-search::before {\r\n  content: \"\\F18D2\";\r\n}\r\n\r\n.mdi-store-search-outline::before {\r\n  content: \"\\F18D3\";\r\n}\r\n\r\n.mdi-store-settings::before {\r\n  content: \"\\F18D4\";\r\n}\r\n\r\n.mdi-store-settings-outline::before {\r\n  content: \"\\F18D5\";\r\n}\r\n\r\n.mdi-storefront::before {\r\n  content: \"\\F07C7\";\r\n}\r\n\r\n.mdi-storefront-outline::before {\r\n  content: \"\\F10C1\";\r\n}\r\n\r\n.mdi-stove::before {\r\n  content: \"\\F04DE\";\r\n}\r\n\r\n.mdi-strategy::before {\r\n  content: \"\\F11D6\";\r\n}\r\n\r\n.mdi-stretch-to-page::before {\r\n  content: \"\\F0F2B\";\r\n}\r\n\r\n.mdi-stretch-to-page-outline::before {\r\n  content: \"\\F0F2C\";\r\n}\r\n\r\n.mdi-string-lights::before {\r\n  content: \"\\F12BA\";\r\n}\r\n\r\n.mdi-string-lights-off::before {\r\n  content: \"\\F12BB\";\r\n}\r\n\r\n.mdi-subdirectory-arrow-left::before {\r\n  content: \"\\F060C\";\r\n}\r\n\r\n.mdi-subdirectory-arrow-right::before {\r\n  content: \"\\F060D\";\r\n}\r\n\r\n.mdi-submarine::before {\r\n  content: \"\\F156C\";\r\n}\r\n\r\n.mdi-subtitles::before {\r\n  content: \"\\F0A16\";\r\n}\r\n\r\n.mdi-subtitles-outline::before {\r\n  content: \"\\F0A17\";\r\n}\r\n\r\n.mdi-subway::before {\r\n  content: \"\\F06AC\";\r\n}\r\n\r\n.mdi-subway-alert-variant::before {\r\n  content: \"\\F0D9D\";\r\n}\r\n\r\n.mdi-subway-variant::before {\r\n  content: \"\\F04DF\";\r\n}\r\n\r\n.mdi-summit::before {\r\n  content: \"\\F0786\";\r\n}\r\n\r\n.mdi-sun-compass::before {\r\n  content: \"\\F19A5\";\r\n}\r\n\r\n.mdi-sun-snowflake::before {\r\n  content: \"\\F1796\";\r\n}\r\n\r\n.mdi-sun-thermometer::before {\r\n  content: \"\\F18D6\";\r\n}\r\n\r\n.mdi-sun-thermometer-outline::before {\r\n  content: \"\\F18D7\";\r\n}\r\n\r\n.mdi-sun-wireless::before {\r\n  content: \"\\F17FE\";\r\n}\r\n\r\n.mdi-sun-wireless-outline::before {\r\n  content: \"\\F17FF\";\r\n}\r\n\r\n.mdi-sunglasses::before {\r\n  content: \"\\F04E0\";\r\n}\r\n\r\n.mdi-surfing::before {\r\n  content: \"\\F1746\";\r\n}\r\n\r\n.mdi-surround-sound::before {\r\n  content: \"\\F05C5\";\r\n}\r\n\r\n.mdi-surround-sound-2-0::before {\r\n  content: \"\\F07F0\";\r\n}\r\n\r\n.mdi-surround-sound-2-1::before {\r\n  content: \"\\F1729\";\r\n}\r\n\r\n.mdi-surround-sound-3-1::before {\r\n  content: \"\\F07F1\";\r\n}\r\n\r\n.mdi-surround-sound-5-1::before {\r\n  content: \"\\F07F2\";\r\n}\r\n\r\n.mdi-surround-sound-5-1-2::before {\r\n  content: \"\\F172A\";\r\n}\r\n\r\n.mdi-surround-sound-7-1::before {\r\n  content: \"\\F07F3\";\r\n}\r\n\r\n.mdi-svg::before {\r\n  content: \"\\F0721\";\r\n}\r\n\r\n.mdi-swap-horizontal::before {\r\n  content: \"\\F04E1\";\r\n}\r\n\r\n.mdi-swap-horizontal-bold::before {\r\n  content: \"\\F0BCD\";\r\n}\r\n\r\n.mdi-swap-horizontal-circle::before {\r\n  content: \"\\F0FE1\";\r\n}\r\n\r\n.mdi-swap-horizontal-circle-outline::before {\r\n  content: \"\\F0FE2\";\r\n}\r\n\r\n.mdi-swap-horizontal-variant::before {\r\n  content: \"\\F08C1\";\r\n}\r\n\r\n.mdi-swap-vertical::before {\r\n  content: \"\\F04E2\";\r\n}\r\n\r\n.mdi-swap-vertical-bold::before {\r\n  content: \"\\F0BCE\";\r\n}\r\n\r\n.mdi-swap-vertical-circle::before {\r\n  content: \"\\F0FE3\";\r\n}\r\n\r\n.mdi-swap-vertical-circle-outline::before {\r\n  content: \"\\F0FE4\";\r\n}\r\n\r\n.mdi-swap-vertical-variant::before {\r\n  content: \"\\F08C2\";\r\n}\r\n\r\n.mdi-swim::before {\r\n  content: \"\\F04E3\";\r\n}\r\n\r\n.mdi-switch::before {\r\n  content: \"\\F04E4\";\r\n}\r\n\r\n.mdi-sword::before {\r\n  content: \"\\F04E5\";\r\n}\r\n\r\n.mdi-sword-cross::before {\r\n  content: \"\\F0787\";\r\n}\r\n\r\n.mdi-syllabary-hangul::before {\r\n  content: \"\\F1333\";\r\n}\r\n\r\n.mdi-syllabary-hiragana::before {\r\n  content: \"\\F1334\";\r\n}\r\n\r\n.mdi-syllabary-katakana::before {\r\n  content: \"\\F1335\";\r\n}\r\n\r\n.mdi-syllabary-katakana-halfwidth::before {\r\n  content: \"\\F1336\";\r\n}\r\n\r\n.mdi-symbol::before {\r\n  content: \"\\F1501\";\r\n}\r\n\r\n.mdi-symfony::before {\r\n  content: \"\\F0AE6\";\r\n}\r\n\r\n.mdi-sync::before {\r\n  content: \"\\F04E6\";\r\n}\r\n\r\n.mdi-sync-alert::before {\r\n  content: \"\\F04E7\";\r\n}\r\n\r\n.mdi-sync-circle::before {\r\n  content: \"\\F1378\";\r\n}\r\n\r\n.mdi-sync-off::before {\r\n  content: \"\\F04E8\";\r\n}\r\n\r\n.mdi-tab::before {\r\n  content: \"\\F04E9\";\r\n}\r\n\r\n.mdi-tab-minus::before {\r\n  content: \"\\F0B4B\";\r\n}\r\n\r\n.mdi-tab-plus::before {\r\n  content: \"\\F075C\";\r\n}\r\n\r\n.mdi-tab-remove::before {\r\n  content: \"\\F0B4C\";\r\n}\r\n\r\n.mdi-tab-search::before {\r\n  content: \"\\F199E\";\r\n}\r\n\r\n.mdi-tab-unselected::before {\r\n  content: \"\\F04EA\";\r\n}\r\n\r\n.mdi-table::before {\r\n  content: \"\\F04EB\";\r\n}\r\n\r\n.mdi-table-account::before {\r\n  content: \"\\F13B9\";\r\n}\r\n\r\n.mdi-table-alert::before {\r\n  content: \"\\F13BA\";\r\n}\r\n\r\n.mdi-table-arrow-down::before {\r\n  content: \"\\F13BB\";\r\n}\r\n\r\n.mdi-table-arrow-left::before {\r\n  content: \"\\F13BC\";\r\n}\r\n\r\n.mdi-table-arrow-right::before {\r\n  content: \"\\F13BD\";\r\n}\r\n\r\n.mdi-table-arrow-up::before {\r\n  content: \"\\F13BE\";\r\n}\r\n\r\n.mdi-table-border::before {\r\n  content: \"\\F0A18\";\r\n}\r\n\r\n.mdi-table-cancel::before {\r\n  content: \"\\F13BF\";\r\n}\r\n\r\n.mdi-table-chair::before {\r\n  content: \"\\F1061\";\r\n}\r\n\r\n.mdi-table-check::before {\r\n  content: \"\\F13C0\";\r\n}\r\n\r\n.mdi-table-clock::before {\r\n  content: \"\\F13C1\";\r\n}\r\n\r\n.mdi-table-cog::before {\r\n  content: \"\\F13C2\";\r\n}\r\n\r\n.mdi-table-column::before {\r\n  content: \"\\F0835\";\r\n}\r\n\r\n.mdi-table-column-plus-after::before {\r\n  content: \"\\F04EC\";\r\n}\r\n\r\n.mdi-table-column-plus-before::before {\r\n  content: \"\\F04ED\";\r\n}\r\n\r\n.mdi-table-column-remove::before {\r\n  content: \"\\F04EE\";\r\n}\r\n\r\n.mdi-table-column-width::before {\r\n  content: \"\\F04EF\";\r\n}\r\n\r\n.mdi-table-edit::before {\r\n  content: \"\\F04F0\";\r\n}\r\n\r\n.mdi-table-eye::before {\r\n  content: \"\\F1094\";\r\n}\r\n\r\n.mdi-table-eye-off::before {\r\n  content: \"\\F13C3\";\r\n}\r\n\r\n.mdi-table-furniture::before {\r\n  content: \"\\F05BC\";\r\n}\r\n\r\n.mdi-table-headers-eye::before {\r\n  content: \"\\F121D\";\r\n}\r\n\r\n.mdi-table-headers-eye-off::before {\r\n  content: \"\\F121E\";\r\n}\r\n\r\n.mdi-table-heart::before {\r\n  content: \"\\F13C4\";\r\n}\r\n\r\n.mdi-table-key::before {\r\n  content: \"\\F13C5\";\r\n}\r\n\r\n.mdi-table-large::before {\r\n  content: \"\\F04F1\";\r\n}\r\n\r\n.mdi-table-large-plus::before {\r\n  content: \"\\F0F87\";\r\n}\r\n\r\n.mdi-table-large-remove::before {\r\n  content: \"\\F0F88\";\r\n}\r\n\r\n.mdi-table-lock::before {\r\n  content: \"\\F13C6\";\r\n}\r\n\r\n.mdi-table-merge-cells::before {\r\n  content: \"\\F09A6\";\r\n}\r\n\r\n.mdi-table-minus::before {\r\n  content: \"\\F13C7\";\r\n}\r\n\r\n.mdi-table-multiple::before {\r\n  content: \"\\F13C8\";\r\n}\r\n\r\n.mdi-table-network::before {\r\n  content: \"\\F13C9\";\r\n}\r\n\r\n.mdi-table-of-contents::before {\r\n  content: \"\\F0836\";\r\n}\r\n\r\n.mdi-table-off::before {\r\n  content: \"\\F13CA\";\r\n}\r\n\r\n.mdi-table-picnic::before {\r\n  content: \"\\F1743\";\r\n}\r\n\r\n.mdi-table-pivot::before {\r\n  content: \"\\F183C\";\r\n}\r\n\r\n.mdi-table-plus::before {\r\n  content: \"\\F0A75\";\r\n}\r\n\r\n.mdi-table-refresh::before {\r\n  content: \"\\F13A0\";\r\n}\r\n\r\n.mdi-table-remove::before {\r\n  content: \"\\F0A76\";\r\n}\r\n\r\n.mdi-table-row::before {\r\n  content: \"\\F0837\";\r\n}\r\n\r\n.mdi-table-row-height::before {\r\n  content: \"\\F04F2\";\r\n}\r\n\r\n.mdi-table-row-plus-after::before {\r\n  content: \"\\F04F3\";\r\n}\r\n\r\n.mdi-table-row-plus-before::before {\r\n  content: \"\\F04F4\";\r\n}\r\n\r\n.mdi-table-row-remove::before {\r\n  content: \"\\F04F5\";\r\n}\r\n\r\n.mdi-table-search::before {\r\n  content: \"\\F090F\";\r\n}\r\n\r\n.mdi-table-settings::before {\r\n  content: \"\\F0838\";\r\n}\r\n\r\n.mdi-table-split-cell::before {\r\n  content: \"\\F142A\";\r\n}\r\n\r\n.mdi-table-star::before {\r\n  content: \"\\F13CB\";\r\n}\r\n\r\n.mdi-table-sync::before {\r\n  content: \"\\F13A1\";\r\n}\r\n\r\n.mdi-table-tennis::before {\r\n  content: \"\\F0E68\";\r\n}\r\n\r\n.mdi-tablet::before {\r\n  content: \"\\F04F6\";\r\n}\r\n\r\n.mdi-tablet-android::before {\r\n  content: \"\\F04F7\";\r\n}\r\n\r\n.mdi-tablet-cellphone::before {\r\n  content: \"\\F09A7\";\r\n}\r\n\r\n.mdi-tablet-dashboard::before {\r\n  content: \"\\F0ECE\";\r\n}\r\n\r\n.mdi-taco::before {\r\n  content: \"\\F0762\";\r\n}\r\n\r\n.mdi-tag::before {\r\n  content: \"\\F04F9\";\r\n}\r\n\r\n.mdi-tag-arrow-down::before {\r\n  content: \"\\F172B\";\r\n}\r\n\r\n.mdi-tag-arrow-down-outline::before {\r\n  content: \"\\F172C\";\r\n}\r\n\r\n.mdi-tag-arrow-left::before {\r\n  content: \"\\F172D\";\r\n}\r\n\r\n.mdi-tag-arrow-left-outline::before {\r\n  content: \"\\F172E\";\r\n}\r\n\r\n.mdi-tag-arrow-right::before {\r\n  content: \"\\F172F\";\r\n}\r\n\r\n.mdi-tag-arrow-right-outline::before {\r\n  content: \"\\F1730\";\r\n}\r\n\r\n.mdi-tag-arrow-up::before {\r\n  content: \"\\F1731\";\r\n}\r\n\r\n.mdi-tag-arrow-up-outline::before {\r\n  content: \"\\F1732\";\r\n}\r\n\r\n.mdi-tag-faces::before {\r\n  content: \"\\F04FA\";\r\n}\r\n\r\n.mdi-tag-heart::before {\r\n  content: \"\\F068B\";\r\n}\r\n\r\n.mdi-tag-heart-outline::before {\r\n  content: \"\\F0BCF\";\r\n}\r\n\r\n.mdi-tag-minus::before {\r\n  content: \"\\F0910\";\r\n}\r\n\r\n.mdi-tag-minus-outline::before {\r\n  content: \"\\F121F\";\r\n}\r\n\r\n.mdi-tag-multiple::before {\r\n  content: \"\\F04FB\";\r\n}\r\n\r\n.mdi-tag-multiple-outline::before {\r\n  content: \"\\F12F7\";\r\n}\r\n\r\n.mdi-tag-off::before {\r\n  content: \"\\F1220\";\r\n}\r\n\r\n.mdi-tag-off-outline::before {\r\n  content: \"\\F1221\";\r\n}\r\n\r\n.mdi-tag-outline::before {\r\n  content: \"\\F04FC\";\r\n}\r\n\r\n.mdi-tag-plus::before {\r\n  content: \"\\F0722\";\r\n}\r\n\r\n.mdi-tag-plus-outline::before {\r\n  content: \"\\F1222\";\r\n}\r\n\r\n.mdi-tag-remove::before {\r\n  content: \"\\F0723\";\r\n}\r\n\r\n.mdi-tag-remove-outline::before {\r\n  content: \"\\F1223\";\r\n}\r\n\r\n.mdi-tag-search::before {\r\n  content: \"\\F1907\";\r\n}\r\n\r\n.mdi-tag-search-outline::before {\r\n  content: \"\\F1908\";\r\n}\r\n\r\n.mdi-tag-text::before {\r\n  content: \"\\F1224\";\r\n}\r\n\r\n.mdi-tag-text-outline::before {\r\n  content: \"\\F04FD\";\r\n}\r\n\r\n.mdi-tailwind::before {\r\n  content: \"\\F13FF\";\r\n}\r\n\r\n.mdi-tangram::before {\r\n  content: \"\\F04F8\";\r\n}\r\n\r\n.mdi-tank::before {\r\n  content: \"\\F0D3A\";\r\n}\r\n\r\n.mdi-tanker-truck::before {\r\n  content: \"\\F0FE5\";\r\n}\r\n\r\n.mdi-tape-drive::before {\r\n  content: \"\\F16DF\";\r\n}\r\n\r\n.mdi-tape-measure::before {\r\n  content: \"\\F0B4D\";\r\n}\r\n\r\n.mdi-target::before {\r\n  content: \"\\F04FE\";\r\n}\r\n\r\n.mdi-target-account::before {\r\n  content: \"\\F0BD0\";\r\n}\r\n\r\n.mdi-target-variant::before {\r\n  content: \"\\F0A77\";\r\n}\r\n\r\n.mdi-taxi::before {\r\n  content: \"\\F04FF\";\r\n}\r\n\r\n.mdi-tea::before {\r\n  content: \"\\F0D9E\";\r\n}\r\n\r\n.mdi-tea-outline::before {\r\n  content: \"\\F0D9F\";\r\n}\r\n\r\n.mdi-teamviewer::before {\r\n  content: \"\\F0500\";\r\n}\r\n\r\n.mdi-teddy-bear::before {\r\n  content: \"\\F18FB\";\r\n}\r\n\r\n.mdi-telescope::before {\r\n  content: \"\\F0B4E\";\r\n}\r\n\r\n.mdi-television::before {\r\n  content: \"\\F0502\";\r\n}\r\n\r\n.mdi-television-ambient-light::before {\r\n  content: \"\\F1356\";\r\n}\r\n\r\n.mdi-television-box::before {\r\n  content: \"\\F0839\";\r\n}\r\n\r\n.mdi-television-classic::before {\r\n  content: \"\\F07F4\";\r\n}\r\n\r\n.mdi-television-classic-off::before {\r\n  content: \"\\F083A\";\r\n}\r\n\r\n.mdi-television-guide::before {\r\n  content: \"\\F0503\";\r\n}\r\n\r\n.mdi-television-off::before {\r\n  content: \"\\F083B\";\r\n}\r\n\r\n.mdi-television-pause::before {\r\n  content: \"\\F0F89\";\r\n}\r\n\r\n.mdi-television-play::before {\r\n  content: \"\\F0ECF\";\r\n}\r\n\r\n.mdi-television-shimmer::before {\r\n  content: \"\\F1110\";\r\n}\r\n\r\n.mdi-television-stop::before {\r\n  content: \"\\F0F8A\";\r\n}\r\n\r\n.mdi-temperature-celsius::before {\r\n  content: \"\\F0504\";\r\n}\r\n\r\n.mdi-temperature-fahrenheit::before {\r\n  content: \"\\F0505\";\r\n}\r\n\r\n.mdi-temperature-kelvin::before {\r\n  content: \"\\F0506\";\r\n}\r\n\r\n.mdi-tennis::before {\r\n  content: \"\\F0DA0\";\r\n}\r\n\r\n.mdi-tennis-ball::before {\r\n  content: \"\\F0507\";\r\n}\r\n\r\n.mdi-tent::before {\r\n  content: \"\\F0508\";\r\n}\r\n\r\n.mdi-terraform::before {\r\n  content: \"\\F1062\";\r\n}\r\n\r\n.mdi-terrain::before {\r\n  content: \"\\F0509\";\r\n}\r\n\r\n.mdi-test-tube::before {\r\n  content: \"\\F0668\";\r\n}\r\n\r\n.mdi-test-tube-empty::before {\r\n  content: \"\\F0911\";\r\n}\r\n\r\n.mdi-test-tube-off::before {\r\n  content: \"\\F0912\";\r\n}\r\n\r\n.mdi-text::before {\r\n  content: \"\\F09A8\";\r\n}\r\n\r\n.mdi-text-account::before {\r\n  content: \"\\F1570\";\r\n}\r\n\r\n.mdi-text-box::before {\r\n  content: \"\\F021A\";\r\n}\r\n\r\n.mdi-text-box-check::before {\r\n  content: \"\\F0EA6\";\r\n}\r\n\r\n.mdi-text-box-check-outline::before {\r\n  content: \"\\F0EA7\";\r\n}\r\n\r\n.mdi-text-box-minus::before {\r\n  content: \"\\F0EA8\";\r\n}\r\n\r\n.mdi-text-box-minus-outline::before {\r\n  content: \"\\F0EA9\";\r\n}\r\n\r\n.mdi-text-box-multiple::before {\r\n  content: \"\\F0AB7\";\r\n}\r\n\r\n.mdi-text-box-multiple-outline::before {\r\n  content: \"\\F0AB8\";\r\n}\r\n\r\n.mdi-text-box-outline::before {\r\n  content: \"\\F09ED\";\r\n}\r\n\r\n.mdi-text-box-plus::before {\r\n  content: \"\\F0EAA\";\r\n}\r\n\r\n.mdi-text-box-plus-outline::before {\r\n  content: \"\\F0EAB\";\r\n}\r\n\r\n.mdi-text-box-remove::before {\r\n  content: \"\\F0EAC\";\r\n}\r\n\r\n.mdi-text-box-remove-outline::before {\r\n  content: \"\\F0EAD\";\r\n}\r\n\r\n.mdi-text-box-search::before {\r\n  content: \"\\F0EAE\";\r\n}\r\n\r\n.mdi-text-box-search-outline::before {\r\n  content: \"\\F0EAF\";\r\n}\r\n\r\n.mdi-text-long::before {\r\n  content: \"\\F09AA\";\r\n}\r\n\r\n.mdi-text-recognition::before {\r\n  content: \"\\F113D\";\r\n}\r\n\r\n.mdi-text-search::before {\r\n  content: \"\\F13B8\";\r\n}\r\n\r\n.mdi-text-shadow::before {\r\n  content: \"\\F0669\";\r\n}\r\n\r\n.mdi-text-short::before {\r\n  content: \"\\F09A9\";\r\n}\r\n\r\n.mdi-text-to-speech::before {\r\n  content: \"\\F050A\";\r\n}\r\n\r\n.mdi-text-to-speech-off::before {\r\n  content: \"\\F050B\";\r\n}\r\n\r\n.mdi-texture::before {\r\n  content: \"\\F050C\";\r\n}\r\n\r\n.mdi-texture-box::before {\r\n  content: \"\\F0FE6\";\r\n}\r\n\r\n.mdi-theater::before {\r\n  content: \"\\F050D\";\r\n}\r\n\r\n.mdi-theme-light-dark::before {\r\n  content: \"\\F050E\";\r\n}\r\n\r\n.mdi-thermometer::before {\r\n  content: \"\\F050F\";\r\n}\r\n\r\n.mdi-thermometer-alert::before {\r\n  content: \"\\F0E01\";\r\n}\r\n\r\n.mdi-thermometer-bluetooth::before {\r\n  content: \"\\F1895\";\r\n}\r\n\r\n.mdi-thermometer-chevron-down::before {\r\n  content: \"\\F0E02\";\r\n}\r\n\r\n.mdi-thermometer-chevron-up::before {\r\n  content: \"\\F0E03\";\r\n}\r\n\r\n.mdi-thermometer-high::before {\r\n  content: \"\\F10C2\";\r\n}\r\n\r\n.mdi-thermometer-lines::before {\r\n  content: \"\\F0510\";\r\n}\r\n\r\n.mdi-thermometer-low::before {\r\n  content: \"\\F10C3\";\r\n}\r\n\r\n.mdi-thermometer-minus::before {\r\n  content: \"\\F0E04\";\r\n}\r\n\r\n.mdi-thermometer-off::before {\r\n  content: \"\\F1531\";\r\n}\r\n\r\n.mdi-thermometer-plus::before {\r\n  content: \"\\F0E05\";\r\n}\r\n\r\n.mdi-thermostat::before {\r\n  content: \"\\F0393\";\r\n}\r\n\r\n.mdi-thermostat-box::before {\r\n  content: \"\\F0891\";\r\n}\r\n\r\n.mdi-thought-bubble::before {\r\n  content: \"\\F07F6\";\r\n}\r\n\r\n.mdi-thought-bubble-outline::before {\r\n  content: \"\\F07F7\";\r\n}\r\n\r\n.mdi-thumb-down::before {\r\n  content: \"\\F0511\";\r\n}\r\n\r\n.mdi-thumb-down-outline::before {\r\n  content: \"\\F0512\";\r\n}\r\n\r\n.mdi-thumb-up::before {\r\n  content: \"\\F0513\";\r\n}\r\n\r\n.mdi-thumb-up-outline::before {\r\n  content: \"\\F0514\";\r\n}\r\n\r\n.mdi-thumbs-up-down::before {\r\n  content: \"\\F0515\";\r\n}\r\n\r\n.mdi-thumbs-up-down-outline::before {\r\n  content: \"\\F1914\";\r\n}\r\n\r\n.mdi-ticket::before {\r\n  content: \"\\F0516\";\r\n}\r\n\r\n.mdi-ticket-account::before {\r\n  content: \"\\F0517\";\r\n}\r\n\r\n.mdi-ticket-confirmation::before {\r\n  content: \"\\F0518\";\r\n}\r\n\r\n.mdi-ticket-confirmation-outline::before {\r\n  content: \"\\F13AA\";\r\n}\r\n\r\n.mdi-ticket-outline::before {\r\n  content: \"\\F0913\";\r\n}\r\n\r\n.mdi-ticket-percent::before {\r\n  content: \"\\F0724\";\r\n}\r\n\r\n.mdi-ticket-percent-outline::before {\r\n  content: \"\\F142B\";\r\n}\r\n\r\n.mdi-tie::before {\r\n  content: \"\\F0519\";\r\n}\r\n\r\n.mdi-tilde::before {\r\n  content: \"\\F0725\";\r\n}\r\n\r\n.mdi-tilde-off::before {\r\n  content: \"\\F18F3\";\r\n}\r\n\r\n.mdi-timelapse::before {\r\n  content: \"\\F051A\";\r\n}\r\n\r\n.mdi-timeline::before {\r\n  content: \"\\F0BD1\";\r\n}\r\n\r\n.mdi-timeline-alert::before {\r\n  content: \"\\F0F95\";\r\n}\r\n\r\n.mdi-timeline-alert-outline::before {\r\n  content: \"\\F0F98\";\r\n}\r\n\r\n.mdi-timeline-check::before {\r\n  content: \"\\F1532\";\r\n}\r\n\r\n.mdi-timeline-check-outline::before {\r\n  content: \"\\F1533\";\r\n}\r\n\r\n.mdi-timeline-clock::before {\r\n  content: \"\\F11FB\";\r\n}\r\n\r\n.mdi-timeline-clock-outline::before {\r\n  content: \"\\F11FC\";\r\n}\r\n\r\n.mdi-timeline-help::before {\r\n  content: \"\\F0F99\";\r\n}\r\n\r\n.mdi-timeline-help-outline::before {\r\n  content: \"\\F0F9A\";\r\n}\r\n\r\n.mdi-timeline-minus::before {\r\n  content: \"\\F1534\";\r\n}\r\n\r\n.mdi-timeline-minus-outline::before {\r\n  content: \"\\F1535\";\r\n}\r\n\r\n.mdi-timeline-outline::before {\r\n  content: \"\\F0BD2\";\r\n}\r\n\r\n.mdi-timeline-plus::before {\r\n  content: \"\\F0F96\";\r\n}\r\n\r\n.mdi-timeline-plus-outline::before {\r\n  content: \"\\F0F97\";\r\n}\r\n\r\n.mdi-timeline-remove::before {\r\n  content: \"\\F1536\";\r\n}\r\n\r\n.mdi-timeline-remove-outline::before {\r\n  content: \"\\F1537\";\r\n}\r\n\r\n.mdi-timeline-text::before {\r\n  content: \"\\F0BD3\";\r\n}\r\n\r\n.mdi-timeline-text-outline::before {\r\n  content: \"\\F0BD4\";\r\n}\r\n\r\n.mdi-timer::before {\r\n  content: \"\\F13AB\";\r\n}\r\n\r\n.mdi-timer-10::before {\r\n  content: \"\\F051C\";\r\n}\r\n\r\n.mdi-timer-3::before {\r\n  content: \"\\F051D\";\r\n}\r\n\r\n.mdi-timer-cog::before {\r\n  content: \"\\F1925\";\r\n}\r\n\r\n.mdi-timer-cog-outline::before {\r\n  content: \"\\F1926\";\r\n}\r\n\r\n.mdi-timer-off::before {\r\n  content: \"\\F13AC\";\r\n}\r\n\r\n.mdi-timer-off-outline::before {\r\n  content: \"\\F051E\";\r\n}\r\n\r\n.mdi-timer-outline::before {\r\n  content: \"\\F051B\";\r\n}\r\n\r\n.mdi-timer-sand::before {\r\n  content: \"\\F051F\";\r\n}\r\n\r\n.mdi-timer-sand-complete::before {\r\n  content: \"\\F199F\";\r\n}\r\n\r\n.mdi-timer-sand-empty::before {\r\n  content: \"\\F06AD\";\r\n}\r\n\r\n.mdi-timer-sand-full::before {\r\n  content: \"\\F078C\";\r\n}\r\n\r\n.mdi-timer-sand-paused::before {\r\n  content: \"\\F19A0\";\r\n}\r\n\r\n.mdi-timer-settings::before {\r\n  content: \"\\F1923\";\r\n}\r\n\r\n.mdi-timer-settings-outline::before {\r\n  content: \"\\F1924\";\r\n}\r\n\r\n.mdi-timetable::before {\r\n  content: \"\\F0520\";\r\n}\r\n\r\n.mdi-tire::before {\r\n  content: \"\\F1896\";\r\n}\r\n\r\n.mdi-toaster::before {\r\n  content: \"\\F1063\";\r\n}\r\n\r\n.mdi-toaster-off::before {\r\n  content: \"\\F11B7\";\r\n}\r\n\r\n.mdi-toaster-oven::before {\r\n  content: \"\\F0CD3\";\r\n}\r\n\r\n.mdi-toggle-switch::before {\r\n  content: \"\\F0521\";\r\n}\r\n\r\n.mdi-toggle-switch-off::before {\r\n  content: \"\\F0522\";\r\n}\r\n\r\n.mdi-toggle-switch-off-outline::before {\r\n  content: \"\\F0A19\";\r\n}\r\n\r\n.mdi-toggle-switch-outline::before {\r\n  content: \"\\F0A1A\";\r\n}\r\n\r\n.mdi-toilet::before {\r\n  content: \"\\F09AB\";\r\n}\r\n\r\n.mdi-toolbox::before {\r\n  content: \"\\F09AC\";\r\n}\r\n\r\n.mdi-toolbox-outline::before {\r\n  content: \"\\F09AD\";\r\n}\r\n\r\n.mdi-tools::before {\r\n  content: \"\\F1064\";\r\n}\r\n\r\n.mdi-tooltip::before {\r\n  content: \"\\F0523\";\r\n}\r\n\r\n.mdi-tooltip-account::before {\r\n  content: \"\\F000C\";\r\n}\r\n\r\n.mdi-tooltip-cellphone::before {\r\n  content: \"\\F183B\";\r\n}\r\n\r\n.mdi-tooltip-check::before {\r\n  content: \"\\F155C\";\r\n}\r\n\r\n.mdi-tooltip-check-outline::before {\r\n  content: \"\\F155D\";\r\n}\r\n\r\n.mdi-tooltip-edit::before {\r\n  content: \"\\F0524\";\r\n}\r\n\r\n.mdi-tooltip-edit-outline::before {\r\n  content: \"\\F12C5\";\r\n}\r\n\r\n.mdi-tooltip-image::before {\r\n  content: \"\\F0525\";\r\n}\r\n\r\n.mdi-tooltip-image-outline::before {\r\n  content: \"\\F0BD5\";\r\n}\r\n\r\n.mdi-tooltip-minus::before {\r\n  content: \"\\F155E\";\r\n}\r\n\r\n.mdi-tooltip-minus-outline::before {\r\n  content: \"\\F155F\";\r\n}\r\n\r\n.mdi-tooltip-outline::before {\r\n  content: \"\\F0526\";\r\n}\r\n\r\n.mdi-tooltip-plus::before {\r\n  content: \"\\F0BD6\";\r\n}\r\n\r\n.mdi-tooltip-plus-outline::before {\r\n  content: \"\\F0527\";\r\n}\r\n\r\n.mdi-tooltip-remove::before {\r\n  content: \"\\F1560\";\r\n}\r\n\r\n.mdi-tooltip-remove-outline::before {\r\n  content: \"\\F1561\";\r\n}\r\n\r\n.mdi-tooltip-text::before {\r\n  content: \"\\F0528\";\r\n}\r\n\r\n.mdi-tooltip-text-outline::before {\r\n  content: \"\\F0BD7\";\r\n}\r\n\r\n.mdi-tooth::before {\r\n  content: \"\\F08C3\";\r\n}\r\n\r\n.mdi-tooth-outline::before {\r\n  content: \"\\F0529\";\r\n}\r\n\r\n.mdi-toothbrush::before {\r\n  content: \"\\F1129\";\r\n}\r\n\r\n.mdi-toothbrush-electric::before {\r\n  content: \"\\F112C\";\r\n}\r\n\r\n.mdi-toothbrush-paste::before {\r\n  content: \"\\F112A\";\r\n}\r\n\r\n.mdi-torch::before {\r\n  content: \"\\F1606\";\r\n}\r\n\r\n.mdi-tortoise::before {\r\n  content: \"\\F0D3B\";\r\n}\r\n\r\n.mdi-toslink::before {\r\n  content: \"\\F12B8\";\r\n}\r\n\r\n.mdi-tournament::before {\r\n  content: \"\\F09AE\";\r\n}\r\n\r\n.mdi-tow-truck::before {\r\n  content: \"\\F083C\";\r\n}\r\n\r\n.mdi-tower-beach::before {\r\n  content: \"\\F0681\";\r\n}\r\n\r\n.mdi-tower-fire::before {\r\n  content: \"\\F0682\";\r\n}\r\n\r\n.mdi-town-hall::before {\r\n  content: \"\\F1875\";\r\n}\r\n\r\n.mdi-toy-brick::before {\r\n  content: \"\\F1288\";\r\n}\r\n\r\n.mdi-toy-brick-marker::before {\r\n  content: \"\\F1289\";\r\n}\r\n\r\n.mdi-toy-brick-marker-outline::before {\r\n  content: \"\\F128A\";\r\n}\r\n\r\n.mdi-toy-brick-minus::before {\r\n  content: \"\\F128B\";\r\n}\r\n\r\n.mdi-toy-brick-minus-outline::before {\r\n  content: \"\\F128C\";\r\n}\r\n\r\n.mdi-toy-brick-outline::before {\r\n  content: \"\\F128D\";\r\n}\r\n\r\n.mdi-toy-brick-plus::before {\r\n  content: \"\\F128E\";\r\n}\r\n\r\n.mdi-toy-brick-plus-outline::before {\r\n  content: \"\\F128F\";\r\n}\r\n\r\n.mdi-toy-brick-remove::before {\r\n  content: \"\\F1290\";\r\n}\r\n\r\n.mdi-toy-brick-remove-outline::before {\r\n  content: \"\\F1291\";\r\n}\r\n\r\n.mdi-toy-brick-search::before {\r\n  content: \"\\F1292\";\r\n}\r\n\r\n.mdi-toy-brick-search-outline::before {\r\n  content: \"\\F1293\";\r\n}\r\n\r\n.mdi-track-light::before {\r\n  content: \"\\F0914\";\r\n}\r\n\r\n.mdi-trackpad::before {\r\n  content: \"\\F07F8\";\r\n}\r\n\r\n.mdi-trackpad-lock::before {\r\n  content: \"\\F0933\";\r\n}\r\n\r\n.mdi-tractor::before {\r\n  content: \"\\F0892\";\r\n}\r\n\r\n.mdi-tractor-variant::before {\r\n  content: \"\\F14C4\";\r\n}\r\n\r\n.mdi-trademark::before {\r\n  content: \"\\F0A78\";\r\n}\r\n\r\n.mdi-traffic-cone::before {\r\n  content: \"\\F137C\";\r\n}\r\n\r\n.mdi-traffic-light::before {\r\n  content: \"\\F052B\";\r\n}\r\n\r\n.mdi-traffic-light-outline::before {\r\n  content: \"\\F182A\";\r\n}\r\n\r\n.mdi-train::before {\r\n  content: \"\\F052C\";\r\n}\r\n\r\n.mdi-train-car::before {\r\n  content: \"\\F0BD8\";\r\n}\r\n\r\n.mdi-train-car-passenger::before {\r\n  content: \"\\F1733\";\r\n}\r\n\r\n.mdi-train-car-passenger-door::before {\r\n  content: \"\\F1734\";\r\n}\r\n\r\n.mdi-train-car-passenger-door-open::before {\r\n  content: \"\\F1735\";\r\n}\r\n\r\n.mdi-train-car-passenger-variant::before {\r\n  content: \"\\F1736\";\r\n}\r\n\r\n.mdi-train-variant::before {\r\n  content: \"\\F08C4\";\r\n}\r\n\r\n.mdi-tram::before {\r\n  content: \"\\F052D\";\r\n}\r\n\r\n.mdi-tram-side::before {\r\n  content: \"\\F0FE7\";\r\n}\r\n\r\n.mdi-transcribe::before {\r\n  content: \"\\F052E\";\r\n}\r\n\r\n.mdi-transcribe-close::before {\r\n  content: \"\\F052F\";\r\n}\r\n\r\n.mdi-transfer::before {\r\n  content: \"\\F1065\";\r\n}\r\n\r\n.mdi-transfer-down::before {\r\n  content: \"\\F0DA1\";\r\n}\r\n\r\n.mdi-transfer-left::before {\r\n  content: \"\\F0DA2\";\r\n}\r\n\r\n.mdi-transfer-right::before {\r\n  content: \"\\F0530\";\r\n}\r\n\r\n.mdi-transfer-up::before {\r\n  content: \"\\F0DA3\";\r\n}\r\n\r\n.mdi-transit-connection::before {\r\n  content: \"\\F0D3C\";\r\n}\r\n\r\n.mdi-transit-connection-horizontal::before {\r\n  content: \"\\F1546\";\r\n}\r\n\r\n.mdi-transit-connection-variant::before {\r\n  content: \"\\F0D3D\";\r\n}\r\n\r\n.mdi-transit-detour::before {\r\n  content: \"\\F0F8B\";\r\n}\r\n\r\n.mdi-transit-skip::before {\r\n  content: \"\\F1515\";\r\n}\r\n\r\n.mdi-transit-transfer::before {\r\n  content: \"\\F06AE\";\r\n}\r\n\r\n.mdi-transition::before {\r\n  content: \"\\F0915\";\r\n}\r\n\r\n.mdi-transition-masked::before {\r\n  content: \"\\F0916\";\r\n}\r\n\r\n.mdi-translate::before {\r\n  content: \"\\F05CA\";\r\n}\r\n\r\n.mdi-translate-off::before {\r\n  content: \"\\F0E06\";\r\n}\r\n\r\n.mdi-transmission-tower::before {\r\n  content: \"\\F0D3E\";\r\n}\r\n\r\n.mdi-transmission-tower-export::before {\r\n  content: \"\\F192C\";\r\n}\r\n\r\n.mdi-transmission-tower-import::before {\r\n  content: \"\\F192D\";\r\n}\r\n\r\n.mdi-trash-can::before {\r\n  content: \"\\F0A79\";\r\n}\r\n\r\n.mdi-trash-can-outline::before {\r\n  content: \"\\F0A7A\";\r\n}\r\n\r\n.mdi-tray::before {\r\n  content: \"\\F1294\";\r\n}\r\n\r\n.mdi-tray-alert::before {\r\n  content: \"\\F1295\";\r\n}\r\n\r\n.mdi-tray-arrow-down::before {\r\n  content: \"\\F0120\";\r\n}\r\n\r\n.mdi-tray-arrow-up::before {\r\n  content: \"\\F011D\";\r\n}\r\n\r\n.mdi-tray-full::before {\r\n  content: \"\\F1296\";\r\n}\r\n\r\n.mdi-tray-minus::before {\r\n  content: \"\\F1297\";\r\n}\r\n\r\n.mdi-tray-plus::before {\r\n  content: \"\\F1298\";\r\n}\r\n\r\n.mdi-tray-remove::before {\r\n  content: \"\\F1299\";\r\n}\r\n\r\n.mdi-treasure-chest::before {\r\n  content: \"\\F0726\";\r\n}\r\n\r\n.mdi-tree::before {\r\n  content: \"\\F0531\";\r\n}\r\n\r\n.mdi-tree-outline::before {\r\n  content: \"\\F0E69\";\r\n}\r\n\r\n.mdi-trello::before {\r\n  content: \"\\F0532\";\r\n}\r\n\r\n.mdi-trending-down::before {\r\n  content: \"\\F0533\";\r\n}\r\n\r\n.mdi-trending-neutral::before {\r\n  content: \"\\F0534\";\r\n}\r\n\r\n.mdi-trending-up::before {\r\n  content: \"\\F0535\";\r\n}\r\n\r\n.mdi-triangle::before {\r\n  content: \"\\F0536\";\r\n}\r\n\r\n.mdi-triangle-outline::before {\r\n  content: \"\\F0537\";\r\n}\r\n\r\n.mdi-triangle-wave::before {\r\n  content: \"\\F147C\";\r\n}\r\n\r\n.mdi-triforce::before {\r\n  content: \"\\F0BD9\";\r\n}\r\n\r\n.mdi-trophy::before {\r\n  content: \"\\F0538\";\r\n}\r\n\r\n.mdi-trophy-award::before {\r\n  content: \"\\F0539\";\r\n}\r\n\r\n.mdi-trophy-broken::before {\r\n  content: \"\\F0DA4\";\r\n}\r\n\r\n.mdi-trophy-outline::before {\r\n  content: \"\\F053A\";\r\n}\r\n\r\n.mdi-trophy-variant::before {\r\n  content: \"\\F053B\";\r\n}\r\n\r\n.mdi-trophy-variant-outline::before {\r\n  content: \"\\F053C\";\r\n}\r\n\r\n.mdi-truck::before {\r\n  content: \"\\F053D\";\r\n}\r\n\r\n.mdi-truck-cargo-container::before {\r\n  content: \"\\F18D8\";\r\n}\r\n\r\n.mdi-truck-check::before {\r\n  content: \"\\F0CD4\";\r\n}\r\n\r\n.mdi-truck-check-outline::before {\r\n  content: \"\\F129A\";\r\n}\r\n\r\n.mdi-truck-delivery::before {\r\n  content: \"\\F053E\";\r\n}\r\n\r\n.mdi-truck-delivery-outline::before {\r\n  content: \"\\F129B\";\r\n}\r\n\r\n.mdi-truck-fast::before {\r\n  content: \"\\F0788\";\r\n}\r\n\r\n.mdi-truck-fast-outline::before {\r\n  content: \"\\F129C\";\r\n}\r\n\r\n.mdi-truck-flatbed::before {\r\n  content: \"\\F1891\";\r\n}\r\n\r\n.mdi-truck-minus::before {\r\n  content: \"\\F19AE\";\r\n}\r\n\r\n.mdi-truck-minus-outline::before {\r\n  content: \"\\F19BD\";\r\n}\r\n\r\n.mdi-truck-outline::before {\r\n  content: \"\\F129D\";\r\n}\r\n\r\n.mdi-truck-plus::before {\r\n  content: \"\\F19AD\";\r\n}\r\n\r\n.mdi-truck-plus-outline::before {\r\n  content: \"\\F19BC\";\r\n}\r\n\r\n.mdi-truck-remove::before {\r\n  content: \"\\F19AF\";\r\n}\r\n\r\n.mdi-truck-remove-outline::before {\r\n  content: \"\\F19BE\";\r\n}\r\n\r\n.mdi-truck-snowflake::before {\r\n  content: \"\\F19A6\";\r\n}\r\n\r\n.mdi-truck-trailer::before {\r\n  content: \"\\F0727\";\r\n}\r\n\r\n.mdi-trumpet::before {\r\n  content: \"\\F1096\";\r\n}\r\n\r\n.mdi-tshirt-crew::before {\r\n  content: \"\\F0A7B\";\r\n}\r\n\r\n.mdi-tshirt-crew-outline::before {\r\n  content: \"\\F053F\";\r\n}\r\n\r\n.mdi-tshirt-v::before {\r\n  content: \"\\F0A7C\";\r\n}\r\n\r\n.mdi-tshirt-v-outline::before {\r\n  content: \"\\F0540\";\r\n}\r\n\r\n.mdi-tumble-dryer::before {\r\n  content: \"\\F0917\";\r\n}\r\n\r\n.mdi-tumble-dryer-alert::before {\r\n  content: \"\\F11BA\";\r\n}\r\n\r\n.mdi-tumble-dryer-off::before {\r\n  content: \"\\F11BB\";\r\n}\r\n\r\n.mdi-tune::before {\r\n  content: \"\\F062E\";\r\n}\r\n\r\n.mdi-tune-variant::before {\r\n  content: \"\\F1542\";\r\n}\r\n\r\n.mdi-tune-vertical::before {\r\n  content: \"\\F066A\";\r\n}\r\n\r\n.mdi-tune-vertical-variant::before {\r\n  content: \"\\F1543\";\r\n}\r\n\r\n.mdi-tunnel::before {\r\n  content: \"\\F183D\";\r\n}\r\n\r\n.mdi-tunnel-outline::before {\r\n  content: \"\\F183E\";\r\n}\r\n\r\n.mdi-turkey::before {\r\n  content: \"\\F171B\";\r\n}\r\n\r\n.mdi-turnstile::before {\r\n  content: \"\\F0CD5\";\r\n}\r\n\r\n.mdi-turnstile-outline::before {\r\n  content: \"\\F0CD6\";\r\n}\r\n\r\n.mdi-turtle::before {\r\n  content: \"\\F0CD7\";\r\n}\r\n\r\n.mdi-twitch::before {\r\n  content: \"\\F0543\";\r\n}\r\n\r\n.mdi-twitter::before {\r\n  content: \"\\F0544\";\r\n}\r\n\r\n.mdi-two-factor-authentication::before {\r\n  content: \"\\F09AF\";\r\n}\r\n\r\n.mdi-typewriter::before {\r\n  content: \"\\F0F2D\";\r\n}\r\n\r\n.mdi-ubisoft::before {\r\n  content: \"\\F0BDA\";\r\n}\r\n\r\n.mdi-ubuntu::before {\r\n  content: \"\\F0548\";\r\n}\r\n\r\n.mdi-ufo::before {\r\n  content: \"\\F10C4\";\r\n}\r\n\r\n.mdi-ufo-outline::before {\r\n  content: \"\\F10C5\";\r\n}\r\n\r\n.mdi-ultra-high-definition::before {\r\n  content: \"\\F07F9\";\r\n}\r\n\r\n.mdi-umbraco::before {\r\n  content: \"\\F0549\";\r\n}\r\n\r\n.mdi-umbrella::before {\r\n  content: \"\\F054A\";\r\n}\r\n\r\n.mdi-umbrella-beach::before {\r\n  content: \"\\F188A\";\r\n}\r\n\r\n.mdi-umbrella-beach-outline::before {\r\n  content: \"\\F188B\";\r\n}\r\n\r\n.mdi-umbrella-closed::before {\r\n  content: \"\\F09B0\";\r\n}\r\n\r\n.mdi-umbrella-closed-outline::before {\r\n  content: \"\\F13E2\";\r\n}\r\n\r\n.mdi-umbrella-closed-variant::before {\r\n  content: \"\\F13E1\";\r\n}\r\n\r\n.mdi-umbrella-outline::before {\r\n  content: \"\\F054B\";\r\n}\r\n\r\n.mdi-undo::before {\r\n  content: \"\\F054C\";\r\n}\r\n\r\n.mdi-undo-variant::before {\r\n  content: \"\\F054D\";\r\n}\r\n\r\n.mdi-unfold-less-horizontal::before {\r\n  content: \"\\F054E\";\r\n}\r\n\r\n.mdi-unfold-less-vertical::before {\r\n  content: \"\\F0760\";\r\n}\r\n\r\n.mdi-unfold-more-horizontal::before {\r\n  content: \"\\F054F\";\r\n}\r\n\r\n.mdi-unfold-more-vertical::before {\r\n  content: \"\\F0761\";\r\n}\r\n\r\n.mdi-ungroup::before {\r\n  content: \"\\F0550\";\r\n}\r\n\r\n.mdi-unicode::before {\r\n  content: \"\\F0ED0\";\r\n}\r\n\r\n.mdi-unicorn::before {\r\n  content: \"\\F15C2\";\r\n}\r\n\r\n.mdi-unicorn-variant::before {\r\n  content: \"\\F15C3\";\r\n}\r\n\r\n.mdi-unicycle::before {\r\n  content: \"\\F15E5\";\r\n}\r\n\r\n.mdi-unity::before {\r\n  content: \"\\F06AF\";\r\n}\r\n\r\n.mdi-unreal::before {\r\n  content: \"\\F09B1\";\r\n}\r\n\r\n.mdi-update::before {\r\n  content: \"\\F06B0\";\r\n}\r\n\r\n.mdi-upload::before {\r\n  content: \"\\F0552\";\r\n}\r\n\r\n.mdi-upload-lock::before {\r\n  content: \"\\F1373\";\r\n}\r\n\r\n.mdi-upload-lock-outline::before {\r\n  content: \"\\F1374\";\r\n}\r\n\r\n.mdi-upload-multiple::before {\r\n  content: \"\\F083D\";\r\n}\r\n\r\n.mdi-upload-network::before {\r\n  content: \"\\F06F6\";\r\n}\r\n\r\n.mdi-upload-network-outline::before {\r\n  content: \"\\F0CD8\";\r\n}\r\n\r\n.mdi-upload-off::before {\r\n  content: \"\\F10C6\";\r\n}\r\n\r\n.mdi-upload-off-outline::before {\r\n  content: \"\\F10C7\";\r\n}\r\n\r\n.mdi-upload-outline::before {\r\n  content: \"\\F0E07\";\r\n}\r\n\r\n.mdi-usb::before {\r\n  content: \"\\F0553\";\r\n}\r\n\r\n.mdi-usb-flash-drive::before {\r\n  content: \"\\F129E\";\r\n}\r\n\r\n.mdi-usb-flash-drive-outline::before {\r\n  content: \"\\F129F\";\r\n}\r\n\r\n.mdi-usb-port::before {\r\n  content: \"\\F11F0\";\r\n}\r\n\r\n.mdi-vacuum::before {\r\n  content: \"\\F19A1\";\r\n}\r\n\r\n.mdi-vacuum-outline::before {\r\n  content: \"\\F19A2\";\r\n}\r\n\r\n.mdi-valve::before {\r\n  content: \"\\F1066\";\r\n}\r\n\r\n.mdi-valve-closed::before {\r\n  content: \"\\F1067\";\r\n}\r\n\r\n.mdi-valve-open::before {\r\n  content: \"\\F1068\";\r\n}\r\n\r\n.mdi-van-passenger::before {\r\n  content: \"\\F07FA\";\r\n}\r\n\r\n.mdi-van-utility::before {\r\n  content: \"\\F07FB\";\r\n}\r\n\r\n.mdi-vanish::before {\r\n  content: \"\\F07FC\";\r\n}\r\n\r\n.mdi-vanish-quarter::before {\r\n  content: \"\\F1554\";\r\n}\r\n\r\n.mdi-vanity-light::before {\r\n  content: \"\\F11E1\";\r\n}\r\n\r\n.mdi-variable::before {\r\n  content: \"\\F0AE7\";\r\n}\r\n\r\n.mdi-variable-box::before {\r\n  content: \"\\F1111\";\r\n}\r\n\r\n.mdi-vector-arrange-above::before {\r\n  content: \"\\F0554\";\r\n}\r\n\r\n.mdi-vector-arrange-below::before {\r\n  content: \"\\F0555\";\r\n}\r\n\r\n.mdi-vector-bezier::before {\r\n  content: \"\\F0AE8\";\r\n}\r\n\r\n.mdi-vector-circle::before {\r\n  content: \"\\F0556\";\r\n}\r\n\r\n.mdi-vector-circle-variant::before {\r\n  content: \"\\F0557\";\r\n}\r\n\r\n.mdi-vector-combine::before {\r\n  content: \"\\F0558\";\r\n}\r\n\r\n.mdi-vector-curve::before {\r\n  content: \"\\F0559\";\r\n}\r\n\r\n.mdi-vector-difference::before {\r\n  content: \"\\F055A\";\r\n}\r\n\r\n.mdi-vector-difference-ab::before {\r\n  content: \"\\F055B\";\r\n}\r\n\r\n.mdi-vector-difference-ba::before {\r\n  content: \"\\F055C\";\r\n}\r\n\r\n.mdi-vector-ellipse::before {\r\n  content: \"\\F0893\";\r\n}\r\n\r\n.mdi-vector-intersection::before {\r\n  content: \"\\F055D\";\r\n}\r\n\r\n.mdi-vector-line::before {\r\n  content: \"\\F055E\";\r\n}\r\n\r\n.mdi-vector-link::before {\r\n  content: \"\\F0FE8\";\r\n}\r\n\r\n.mdi-vector-point::before {\r\n  content: \"\\F055F\";\r\n}\r\n\r\n.mdi-vector-polygon::before {\r\n  content: \"\\F0560\";\r\n}\r\n\r\n.mdi-vector-polygon-variant::before {\r\n  content: \"\\F1856\";\r\n}\r\n\r\n.mdi-vector-polyline::before {\r\n  content: \"\\F0561\";\r\n}\r\n\r\n.mdi-vector-polyline-edit::before {\r\n  content: \"\\F1225\";\r\n}\r\n\r\n.mdi-vector-polyline-minus::before {\r\n  content: \"\\F1226\";\r\n}\r\n\r\n.mdi-vector-polyline-plus::before {\r\n  content: \"\\F1227\";\r\n}\r\n\r\n.mdi-vector-polyline-remove::before {\r\n  content: \"\\F1228\";\r\n}\r\n\r\n.mdi-vector-radius::before {\r\n  content: \"\\F074A\";\r\n}\r\n\r\n.mdi-vector-rectangle::before {\r\n  content: \"\\F05C6\";\r\n}\r\n\r\n.mdi-vector-selection::before {\r\n  content: \"\\F0562\";\r\n}\r\n\r\n.mdi-vector-square::before {\r\n  content: \"\\F0001\";\r\n}\r\n\r\n.mdi-vector-square-close::before {\r\n  content: \"\\F1857\";\r\n}\r\n\r\n.mdi-vector-square-edit::before {\r\n  content: \"\\F18D9\";\r\n}\r\n\r\n.mdi-vector-square-minus::before {\r\n  content: \"\\F18DA\";\r\n}\r\n\r\n.mdi-vector-square-open::before {\r\n  content: \"\\F1858\";\r\n}\r\n\r\n.mdi-vector-square-plus::before {\r\n  content: \"\\F18DB\";\r\n}\r\n\r\n.mdi-vector-square-remove::before {\r\n  content: \"\\F18DC\";\r\n}\r\n\r\n.mdi-vector-triangle::before {\r\n  content: \"\\F0563\";\r\n}\r\n\r\n.mdi-vector-union::before {\r\n  content: \"\\F0564\";\r\n}\r\n\r\n.mdi-vhs::before {\r\n  content: \"\\F0A1B\";\r\n}\r\n\r\n.mdi-vibrate::before {\r\n  content: \"\\F0566\";\r\n}\r\n\r\n.mdi-vibrate-off::before {\r\n  content: \"\\F0CD9\";\r\n}\r\n\r\n.mdi-video::before {\r\n  content: \"\\F0567\";\r\n}\r\n\r\n.mdi-video-3d::before {\r\n  content: \"\\F07FD\";\r\n}\r\n\r\n.mdi-video-3d-off::before {\r\n  content: \"\\F13D9\";\r\n}\r\n\r\n.mdi-video-3d-variant::before {\r\n  content: \"\\F0ED1\";\r\n}\r\n\r\n.mdi-video-4k-box::before {\r\n  content: \"\\F083E\";\r\n}\r\n\r\n.mdi-video-account::before {\r\n  content: \"\\F0919\";\r\n}\r\n\r\n.mdi-video-box::before {\r\n  content: \"\\F00FD\";\r\n}\r\n\r\n.mdi-video-box-off::before {\r\n  content: \"\\F00FE\";\r\n}\r\n\r\n.mdi-video-check::before {\r\n  content: \"\\F1069\";\r\n}\r\n\r\n.mdi-video-check-outline::before {\r\n  content: \"\\F106A\";\r\n}\r\n\r\n.mdi-video-high-definition::before {\r\n  content: \"\\F152E\";\r\n}\r\n\r\n.mdi-video-image::before {\r\n  content: \"\\F091A\";\r\n}\r\n\r\n.mdi-video-input-antenna::before {\r\n  content: \"\\F083F\";\r\n}\r\n\r\n.mdi-video-input-component::before {\r\n  content: \"\\F0840\";\r\n}\r\n\r\n.mdi-video-input-hdmi::before {\r\n  content: \"\\F0841\";\r\n}\r\n\r\n.mdi-video-input-scart::before {\r\n  content: \"\\F0F8C\";\r\n}\r\n\r\n.mdi-video-input-svideo::before {\r\n  content: \"\\F0842\";\r\n}\r\n\r\n.mdi-video-marker::before {\r\n  content: \"\\F19A9\";\r\n}\r\n\r\n.mdi-video-marker-outline::before {\r\n  content: \"\\F19AA\";\r\n}\r\n\r\n.mdi-video-minus::before {\r\n  content: \"\\F09B2\";\r\n}\r\n\r\n.mdi-video-minus-outline::before {\r\n  content: \"\\F02BA\";\r\n}\r\n\r\n.mdi-video-off::before {\r\n  content: \"\\F0568\";\r\n}\r\n\r\n.mdi-video-off-outline::before {\r\n  content: \"\\F0BDB\";\r\n}\r\n\r\n.mdi-video-outline::before {\r\n  content: \"\\F0BDC\";\r\n}\r\n\r\n.mdi-video-plus::before {\r\n  content: \"\\F09B3\";\r\n}\r\n\r\n.mdi-video-plus-outline::before {\r\n  content: \"\\F01D3\";\r\n}\r\n\r\n.mdi-video-stabilization::before {\r\n  content: \"\\F091B\";\r\n}\r\n\r\n.mdi-video-switch::before {\r\n  content: \"\\F0569\";\r\n}\r\n\r\n.mdi-video-switch-outline::before {\r\n  content: \"\\F0790\";\r\n}\r\n\r\n.mdi-video-vintage::before {\r\n  content: \"\\F0A1C\";\r\n}\r\n\r\n.mdi-video-wireless::before {\r\n  content: \"\\F0ED2\";\r\n}\r\n\r\n.mdi-video-wireless-outline::before {\r\n  content: \"\\F0ED3\";\r\n}\r\n\r\n.mdi-view-agenda::before {\r\n  content: \"\\F056A\";\r\n}\r\n\r\n.mdi-view-agenda-outline::before {\r\n  content: \"\\F11D8\";\r\n}\r\n\r\n.mdi-view-array::before {\r\n  content: \"\\F056B\";\r\n}\r\n\r\n.mdi-view-array-outline::before {\r\n  content: \"\\F1485\";\r\n}\r\n\r\n.mdi-view-carousel::before {\r\n  content: \"\\F056C\";\r\n}\r\n\r\n.mdi-view-carousel-outline::before {\r\n  content: \"\\F1486\";\r\n}\r\n\r\n.mdi-view-column::before {\r\n  content: \"\\F056D\";\r\n}\r\n\r\n.mdi-view-column-outline::before {\r\n  content: \"\\F1487\";\r\n}\r\n\r\n.mdi-view-comfy::before {\r\n  content: \"\\F0E6A\";\r\n}\r\n\r\n.mdi-view-comfy-outline::before {\r\n  content: \"\\F1488\";\r\n}\r\n\r\n.mdi-view-compact::before {\r\n  content: \"\\F0E6B\";\r\n}\r\n\r\n.mdi-view-compact-outline::before {\r\n  content: \"\\F0E6C\";\r\n}\r\n\r\n.mdi-view-dashboard::before {\r\n  content: \"\\F056E\";\r\n}\r\n\r\n.mdi-view-dashboard-edit::before {\r\n  content: \"\\F1947\";\r\n}\r\n\r\n.mdi-view-dashboard-edit-outline::before {\r\n  content: \"\\F1948\";\r\n}\r\n\r\n.mdi-view-dashboard-outline::before {\r\n  content: \"\\F0A1D\";\r\n}\r\n\r\n.mdi-view-dashboard-variant::before {\r\n  content: \"\\F0843\";\r\n}\r\n\r\n.mdi-view-dashboard-variant-outline::before {\r\n  content: \"\\F1489\";\r\n}\r\n\r\n.mdi-view-day::before {\r\n  content: \"\\F056F\";\r\n}\r\n\r\n.mdi-view-day-outline::before {\r\n  content: \"\\F148A\";\r\n}\r\n\r\n.mdi-view-gallery::before {\r\n  content: \"\\F1888\";\r\n}\r\n\r\n.mdi-view-gallery-outline::before {\r\n  content: \"\\F1889\";\r\n}\r\n\r\n.mdi-view-grid::before {\r\n  content: \"\\F0570\";\r\n}\r\n\r\n.mdi-view-grid-outline::before {\r\n  content: \"\\F11D9\";\r\n}\r\n\r\n.mdi-view-grid-plus::before {\r\n  content: \"\\F0F8D\";\r\n}\r\n\r\n.mdi-view-grid-plus-outline::before {\r\n  content: \"\\F11DA\";\r\n}\r\n\r\n.mdi-view-headline::before {\r\n  content: \"\\F0571\";\r\n}\r\n\r\n.mdi-view-list::before {\r\n  content: \"\\F0572\";\r\n}\r\n\r\n.mdi-view-list-outline::before {\r\n  content: \"\\F148B\";\r\n}\r\n\r\n.mdi-view-module::before {\r\n  content: \"\\F0573\";\r\n}\r\n\r\n.mdi-view-module-outline::before {\r\n  content: \"\\F148C\";\r\n}\r\n\r\n.mdi-view-parallel::before {\r\n  content: \"\\F0728\";\r\n}\r\n\r\n.mdi-view-parallel-outline::before {\r\n  content: \"\\F148D\";\r\n}\r\n\r\n.mdi-view-quilt::before {\r\n  content: \"\\F0574\";\r\n}\r\n\r\n.mdi-view-quilt-outline::before {\r\n  content: \"\\F148E\";\r\n}\r\n\r\n.mdi-view-sequential::before {\r\n  content: \"\\F0729\";\r\n}\r\n\r\n.mdi-view-sequential-outline::before {\r\n  content: \"\\F148F\";\r\n}\r\n\r\n.mdi-view-split-horizontal::before {\r\n  content: \"\\F0BCB\";\r\n}\r\n\r\n.mdi-view-split-vertical::before {\r\n  content: \"\\F0BCC\";\r\n}\r\n\r\n.mdi-view-stream::before {\r\n  content: \"\\F0575\";\r\n}\r\n\r\n.mdi-view-stream-outline::before {\r\n  content: \"\\F1490\";\r\n}\r\n\r\n.mdi-view-week::before {\r\n  content: \"\\F0576\";\r\n}\r\n\r\n.mdi-view-week-outline::before {\r\n  content: \"\\F1491\";\r\n}\r\n\r\n.mdi-vimeo::before {\r\n  content: \"\\F0577\";\r\n}\r\n\r\n.mdi-violin::before {\r\n  content: \"\\F060F\";\r\n}\r\n\r\n.mdi-virtual-reality::before {\r\n  content: \"\\F0894\";\r\n}\r\n\r\n.mdi-virus::before {\r\n  content: \"\\F13B6\";\r\n}\r\n\r\n.mdi-virus-off::before {\r\n  content: \"\\F18E1\";\r\n}\r\n\r\n.mdi-virus-off-outline::before {\r\n  content: \"\\F18E2\";\r\n}\r\n\r\n.mdi-virus-outline::before {\r\n  content: \"\\F13B7\";\r\n}\r\n\r\n.mdi-vlc::before {\r\n  content: \"\\F057C\";\r\n}\r\n\r\n.mdi-voicemail::before {\r\n  content: \"\\F057D\";\r\n}\r\n\r\n.mdi-volleyball::before {\r\n  content: \"\\F09B4\";\r\n}\r\n\r\n.mdi-volume-high::before {\r\n  content: \"\\F057E\";\r\n}\r\n\r\n.mdi-volume-low::before {\r\n  content: \"\\F057F\";\r\n}\r\n\r\n.mdi-volume-medium::before {\r\n  content: \"\\F0580\";\r\n}\r\n\r\n.mdi-volume-minus::before {\r\n  content: \"\\F075E\";\r\n}\r\n\r\n.mdi-volume-mute::before {\r\n  content: \"\\F075F\";\r\n}\r\n\r\n.mdi-volume-off::before {\r\n  content: \"\\F0581\";\r\n}\r\n\r\n.mdi-volume-plus::before {\r\n  content: \"\\F075D\";\r\n}\r\n\r\n.mdi-volume-source::before {\r\n  content: \"\\F1120\";\r\n}\r\n\r\n.mdi-volume-variant-off::before {\r\n  content: \"\\F0E08\";\r\n}\r\n\r\n.mdi-volume-vibrate::before {\r\n  content: \"\\F1121\";\r\n}\r\n\r\n.mdi-vote::before {\r\n  content: \"\\F0A1F\";\r\n}\r\n\r\n.mdi-vote-outline::before {\r\n  content: \"\\F0A20\";\r\n}\r\n\r\n.mdi-vpn::before {\r\n  content: \"\\F0582\";\r\n}\r\n\r\n.mdi-vuejs::before {\r\n  content: \"\\F0844\";\r\n}\r\n\r\n.mdi-vuetify::before {\r\n  content: \"\\F0E6D\";\r\n}\r\n\r\n.mdi-walk::before {\r\n  content: \"\\F0583\";\r\n}\r\n\r\n.mdi-wall::before {\r\n  content: \"\\F07FE\";\r\n}\r\n\r\n.mdi-wall-sconce::before {\r\n  content: \"\\F091C\";\r\n}\r\n\r\n.mdi-wall-sconce-flat::before {\r\n  content: \"\\F091D\";\r\n}\r\n\r\n.mdi-wall-sconce-flat-outline::before {\r\n  content: \"\\F17C9\";\r\n}\r\n\r\n.mdi-wall-sconce-flat-variant::before {\r\n  content: \"\\F041C\";\r\n}\r\n\r\n.mdi-wall-sconce-flat-variant-outline::before {\r\n  content: \"\\F17CA\";\r\n}\r\n\r\n.mdi-wall-sconce-outline::before {\r\n  content: \"\\F17CB\";\r\n}\r\n\r\n.mdi-wall-sconce-round::before {\r\n  content: \"\\F0748\";\r\n}\r\n\r\n.mdi-wall-sconce-round-outline::before {\r\n  content: \"\\F17CC\";\r\n}\r\n\r\n.mdi-wall-sconce-round-variant::before {\r\n  content: \"\\F091E\";\r\n}\r\n\r\n.mdi-wall-sconce-round-variant-outline::before {\r\n  content: \"\\F17CD\";\r\n}\r\n\r\n.mdi-wallet::before {\r\n  content: \"\\F0584\";\r\n}\r\n\r\n.mdi-wallet-giftcard::before {\r\n  content: \"\\F0585\";\r\n}\r\n\r\n.mdi-wallet-membership::before {\r\n  content: \"\\F0586\";\r\n}\r\n\r\n.mdi-wallet-outline::before {\r\n  content: \"\\F0BDD\";\r\n}\r\n\r\n.mdi-wallet-plus::before {\r\n  content: \"\\F0F8E\";\r\n}\r\n\r\n.mdi-wallet-plus-outline::before {\r\n  content: \"\\F0F8F\";\r\n}\r\n\r\n.mdi-wallet-travel::before {\r\n  content: \"\\F0587\";\r\n}\r\n\r\n.mdi-wallpaper::before {\r\n  content: \"\\F0E09\";\r\n}\r\n\r\n.mdi-wan::before {\r\n  content: \"\\F0588\";\r\n}\r\n\r\n.mdi-wardrobe::before {\r\n  content: \"\\F0F90\";\r\n}\r\n\r\n.mdi-wardrobe-outline::before {\r\n  content: \"\\F0F91\";\r\n}\r\n\r\n.mdi-warehouse::before {\r\n  content: \"\\F0F81\";\r\n}\r\n\r\n.mdi-washing-machine::before {\r\n  content: \"\\F072A\";\r\n}\r\n\r\n.mdi-washing-machine-alert::before {\r\n  content: \"\\F11BC\";\r\n}\r\n\r\n.mdi-washing-machine-off::before {\r\n  content: \"\\F11BD\";\r\n}\r\n\r\n.mdi-watch::before {\r\n  content: \"\\F0589\";\r\n}\r\n\r\n.mdi-watch-export::before {\r\n  content: \"\\F058A\";\r\n}\r\n\r\n.mdi-watch-export-variant::before {\r\n  content: \"\\F0895\";\r\n}\r\n\r\n.mdi-watch-import::before {\r\n  content: \"\\F058B\";\r\n}\r\n\r\n.mdi-watch-import-variant::before {\r\n  content: \"\\F0896\";\r\n}\r\n\r\n.mdi-watch-variant::before {\r\n  content: \"\\F0897\";\r\n}\r\n\r\n.mdi-watch-vibrate::before {\r\n  content: \"\\F06B1\";\r\n}\r\n\r\n.mdi-watch-vibrate-off::before {\r\n  content: \"\\F0CDA\";\r\n}\r\n\r\n.mdi-water::before {\r\n  content: \"\\F058C\";\r\n}\r\n\r\n.mdi-water-alert::before {\r\n  content: \"\\F1502\";\r\n}\r\n\r\n.mdi-water-alert-outline::before {\r\n  content: \"\\F1503\";\r\n}\r\n\r\n.mdi-water-boiler::before {\r\n  content: \"\\F0F92\";\r\n}\r\n\r\n.mdi-water-boiler-alert::before {\r\n  content: \"\\F11B3\";\r\n}\r\n\r\n.mdi-water-boiler-off::before {\r\n  content: \"\\F11B4\";\r\n}\r\n\r\n.mdi-water-check::before {\r\n  content: \"\\F1504\";\r\n}\r\n\r\n.mdi-water-check-outline::before {\r\n  content: \"\\F1505\";\r\n}\r\n\r\n.mdi-water-circle::before {\r\n  content: \"\\F1806\";\r\n}\r\n\r\n.mdi-water-minus::before {\r\n  content: \"\\F1506\";\r\n}\r\n\r\n.mdi-water-minus-outline::before {\r\n  content: \"\\F1507\";\r\n}\r\n\r\n.mdi-water-off::before {\r\n  content: \"\\F058D\";\r\n}\r\n\r\n.mdi-water-off-outline::before {\r\n  content: \"\\F1508\";\r\n}\r\n\r\n.mdi-water-opacity::before {\r\n  content: \"\\F1855\";\r\n}\r\n\r\n.mdi-water-outline::before {\r\n  content: \"\\F0E0A\";\r\n}\r\n\r\n.mdi-water-percent::before {\r\n  content: \"\\F058E\";\r\n}\r\n\r\n.mdi-water-percent-alert::before {\r\n  content: \"\\F1509\";\r\n}\r\n\r\n.mdi-water-plus::before {\r\n  content: \"\\F150A\";\r\n}\r\n\r\n.mdi-water-plus-outline::before {\r\n  content: \"\\F150B\";\r\n}\r\n\r\n.mdi-water-polo::before {\r\n  content: \"\\F12A0\";\r\n}\r\n\r\n.mdi-water-pump::before {\r\n  content: \"\\F058F\";\r\n}\r\n\r\n.mdi-water-pump-off::before {\r\n  content: \"\\F0F93\";\r\n}\r\n\r\n.mdi-water-remove::before {\r\n  content: \"\\F150C\";\r\n}\r\n\r\n.mdi-water-remove-outline::before {\r\n  content: \"\\F150D\";\r\n}\r\n\r\n.mdi-water-sync::before {\r\n  content: \"\\F17C6\";\r\n}\r\n\r\n.mdi-water-well::before {\r\n  content: \"\\F106B\";\r\n}\r\n\r\n.mdi-water-well-outline::before {\r\n  content: \"\\F106C\";\r\n}\r\n\r\n.mdi-waterfall::before {\r\n  content: \"\\F1849\";\r\n}\r\n\r\n.mdi-watering-can::before {\r\n  content: \"\\F1481\";\r\n}\r\n\r\n.mdi-watering-can-outline::before {\r\n  content: \"\\F1482\";\r\n}\r\n\r\n.mdi-watermark::before {\r\n  content: \"\\F0612\";\r\n}\r\n\r\n.mdi-wave::before {\r\n  content: \"\\F0F2E\";\r\n}\r\n\r\n.mdi-waveform::before {\r\n  content: \"\\F147D\";\r\n}\r\n\r\n.mdi-waves::before {\r\n  content: \"\\F078D\";\r\n}\r\n\r\n.mdi-waves-arrow-left::before {\r\n  content: \"\\F1859\";\r\n}\r\n\r\n.mdi-waves-arrow-right::before {\r\n  content: \"\\F185A\";\r\n}\r\n\r\n.mdi-waves-arrow-up::before {\r\n  content: \"\\F185B\";\r\n}\r\n\r\n.mdi-waze::before {\r\n  content: \"\\F0BDE\";\r\n}\r\n\r\n.mdi-weather-cloudy::before {\r\n  content: \"\\F0590\";\r\n}\r\n\r\n.mdi-weather-cloudy-alert::before {\r\n  content: \"\\F0F2F\";\r\n}\r\n\r\n.mdi-weather-cloudy-arrow-right::before {\r\n  content: \"\\F0E6E\";\r\n}\r\n\r\n.mdi-weather-cloudy-clock::before {\r\n  content: \"\\F18F6\";\r\n}\r\n\r\n.mdi-weather-fog::before {\r\n  content: \"\\F0591\";\r\n}\r\n\r\n.mdi-weather-hail::before {\r\n  content: \"\\F0592\";\r\n}\r\n\r\n.mdi-weather-hazy::before {\r\n  content: \"\\F0F30\";\r\n}\r\n\r\n.mdi-weather-hurricane::before {\r\n  content: \"\\F0898\";\r\n}\r\n\r\n.mdi-weather-lightning::before {\r\n  content: \"\\F0593\";\r\n}\r\n\r\n.mdi-weather-lightning-rainy::before {\r\n  content: \"\\F067E\";\r\n}\r\n\r\n.mdi-weather-night::before {\r\n  content: \"\\F0594\";\r\n}\r\n\r\n.mdi-weather-night-partly-cloudy::before {\r\n  content: \"\\F0F31\";\r\n}\r\n\r\n.mdi-weather-partly-cloudy::before {\r\n  content: \"\\F0595\";\r\n}\r\n\r\n.mdi-weather-partly-lightning::before {\r\n  content: \"\\F0F32\";\r\n}\r\n\r\n.mdi-weather-partly-rainy::before {\r\n  content: \"\\F0F33\";\r\n}\r\n\r\n.mdi-weather-partly-snowy::before {\r\n  content: \"\\F0F34\";\r\n}\r\n\r\n.mdi-weather-partly-snowy-rainy::before {\r\n  content: \"\\F0F35\";\r\n}\r\n\r\n.mdi-weather-pouring::before {\r\n  content: \"\\F0596\";\r\n}\r\n\r\n.mdi-weather-rainy::before {\r\n  content: \"\\F0597\";\r\n}\r\n\r\n.mdi-weather-snowy::before {\r\n  content: \"\\F0598\";\r\n}\r\n\r\n.mdi-weather-snowy-heavy::before {\r\n  content: \"\\F0F36\";\r\n}\r\n\r\n.mdi-weather-snowy-rainy::before {\r\n  content: \"\\F067F\";\r\n}\r\n\r\n.mdi-weather-sunny::before {\r\n  content: \"\\F0599\";\r\n}\r\n\r\n.mdi-weather-sunny-alert::before {\r\n  content: \"\\F0F37\";\r\n}\r\n\r\n.mdi-weather-sunny-off::before {\r\n  content: \"\\F14E4\";\r\n}\r\n\r\n.mdi-weather-sunset::before {\r\n  content: \"\\F059A\";\r\n}\r\n\r\n.mdi-weather-sunset-down::before {\r\n  content: \"\\F059B\";\r\n}\r\n\r\n.mdi-weather-sunset-up::before {\r\n  content: \"\\F059C\";\r\n}\r\n\r\n.mdi-weather-tornado::before {\r\n  content: \"\\F0F38\";\r\n}\r\n\r\n.mdi-weather-windy::before {\r\n  content: \"\\F059D\";\r\n}\r\n\r\n.mdi-weather-windy-variant::before {\r\n  content: \"\\F059E\";\r\n}\r\n\r\n.mdi-web::before {\r\n  content: \"\\F059F\";\r\n}\r\n\r\n.mdi-web-box::before {\r\n  content: \"\\F0F94\";\r\n}\r\n\r\n.mdi-web-cancel::before {\r\n  content: \"\\F1790\";\r\n}\r\n\r\n.mdi-web-check::before {\r\n  content: \"\\F0789\";\r\n}\r\n\r\n.mdi-web-clock::before {\r\n  content: \"\\F124A\";\r\n}\r\n\r\n.mdi-web-minus::before {\r\n  content: \"\\F10A0\";\r\n}\r\n\r\n.mdi-web-off::before {\r\n  content: \"\\F0A8E\";\r\n}\r\n\r\n.mdi-web-plus::before {\r\n  content: \"\\F0033\";\r\n}\r\n\r\n.mdi-web-refresh::before {\r\n  content: \"\\F1791\";\r\n}\r\n\r\n.mdi-web-remove::before {\r\n  content: \"\\F0551\";\r\n}\r\n\r\n.mdi-web-sync::before {\r\n  content: \"\\F1792\";\r\n}\r\n\r\n.mdi-webcam::before {\r\n  content: \"\\F05A0\";\r\n}\r\n\r\n.mdi-webcam-off::before {\r\n  content: \"\\F1737\";\r\n}\r\n\r\n.mdi-webhook::before {\r\n  content: \"\\F062F\";\r\n}\r\n\r\n.mdi-webpack::before {\r\n  content: \"\\F072B\";\r\n}\r\n\r\n.mdi-webrtc::before {\r\n  content: \"\\F1248\";\r\n}\r\n\r\n.mdi-wechat::before {\r\n  content: \"\\F0611\";\r\n}\r\n\r\n.mdi-weight::before {\r\n  content: \"\\F05A1\";\r\n}\r\n\r\n.mdi-weight-gram::before {\r\n  content: \"\\F0D3F\";\r\n}\r\n\r\n.mdi-weight-kilogram::before {\r\n  content: \"\\F05A2\";\r\n}\r\n\r\n.mdi-weight-lifter::before {\r\n  content: \"\\F115D\";\r\n}\r\n\r\n.mdi-weight-pound::before {\r\n  content: \"\\F09B5\";\r\n}\r\n\r\n.mdi-whatsapp::before {\r\n  content: \"\\F05A3\";\r\n}\r\n\r\n.mdi-wheel-barrow::before {\r\n  content: \"\\F14F2\";\r\n}\r\n\r\n.mdi-wheelchair-accessibility::before {\r\n  content: \"\\F05A4\";\r\n}\r\n\r\n.mdi-whistle::before {\r\n  content: \"\\F09B6\";\r\n}\r\n\r\n.mdi-whistle-outline::before {\r\n  content: \"\\F12BC\";\r\n}\r\n\r\n.mdi-white-balance-auto::before {\r\n  content: \"\\F05A5\";\r\n}\r\n\r\n.mdi-white-balance-incandescent::before {\r\n  content: \"\\F05A6\";\r\n}\r\n\r\n.mdi-white-balance-iridescent::before {\r\n  content: \"\\F05A7\";\r\n}\r\n\r\n.mdi-white-balance-sunny::before {\r\n  content: \"\\F05A8\";\r\n}\r\n\r\n.mdi-widgets::before {\r\n  content: \"\\F072C\";\r\n}\r\n\r\n.mdi-widgets-outline::before {\r\n  content: \"\\F1355\";\r\n}\r\n\r\n.mdi-wifi::before {\r\n  content: \"\\F05A9\";\r\n}\r\n\r\n.mdi-wifi-alert::before {\r\n  content: \"\\F16B5\";\r\n}\r\n\r\n.mdi-wifi-arrow-down::before {\r\n  content: \"\\F16B6\";\r\n}\r\n\r\n.mdi-wifi-arrow-left::before {\r\n  content: \"\\F16B7\";\r\n}\r\n\r\n.mdi-wifi-arrow-left-right::before {\r\n  content: \"\\F16B8\";\r\n}\r\n\r\n.mdi-wifi-arrow-right::before {\r\n  content: \"\\F16B9\";\r\n}\r\n\r\n.mdi-wifi-arrow-up::before {\r\n  content: \"\\F16BA\";\r\n}\r\n\r\n.mdi-wifi-arrow-up-down::before {\r\n  content: \"\\F16BB\";\r\n}\r\n\r\n.mdi-wifi-cancel::before {\r\n  content: \"\\F16BC\";\r\n}\r\n\r\n.mdi-wifi-check::before {\r\n  content: \"\\F16BD\";\r\n}\r\n\r\n.mdi-wifi-cog::before {\r\n  content: \"\\F16BE\";\r\n}\r\n\r\n.mdi-wifi-lock::before {\r\n  content: \"\\F16BF\";\r\n}\r\n\r\n.mdi-wifi-lock-open::before {\r\n  content: \"\\F16C0\";\r\n}\r\n\r\n.mdi-wifi-marker::before {\r\n  content: \"\\F16C1\";\r\n}\r\n\r\n.mdi-wifi-minus::before {\r\n  content: \"\\F16C2\";\r\n}\r\n\r\n.mdi-wifi-off::before {\r\n  content: \"\\F05AA\";\r\n}\r\n\r\n.mdi-wifi-plus::before {\r\n  content: \"\\F16C3\";\r\n}\r\n\r\n.mdi-wifi-refresh::before {\r\n  content: \"\\F16C4\";\r\n}\r\n\r\n.mdi-wifi-remove::before {\r\n  content: \"\\F16C5\";\r\n}\r\n\r\n.mdi-wifi-settings::before {\r\n  content: \"\\F16C6\";\r\n}\r\n\r\n.mdi-wifi-star::before {\r\n  content: \"\\F0E0B\";\r\n}\r\n\r\n.mdi-wifi-strength-1::before {\r\n  content: \"\\F091F\";\r\n}\r\n\r\n.mdi-wifi-strength-1-alert::before {\r\n  content: \"\\F0920\";\r\n}\r\n\r\n.mdi-wifi-strength-1-lock::before {\r\n  content: \"\\F0921\";\r\n}\r\n\r\n.mdi-wifi-strength-1-lock-open::before {\r\n  content: \"\\F16CB\";\r\n}\r\n\r\n.mdi-wifi-strength-2::before {\r\n  content: \"\\F0922\";\r\n}\r\n\r\n.mdi-wifi-strength-2-alert::before {\r\n  content: \"\\F0923\";\r\n}\r\n\r\n.mdi-wifi-strength-2-lock::before {\r\n  content: \"\\F0924\";\r\n}\r\n\r\n.mdi-wifi-strength-2-lock-open::before {\r\n  content: \"\\F16CC\";\r\n}\r\n\r\n.mdi-wifi-strength-3::before {\r\n  content: \"\\F0925\";\r\n}\r\n\r\n.mdi-wifi-strength-3-alert::before {\r\n  content: \"\\F0926\";\r\n}\r\n\r\n.mdi-wifi-strength-3-lock::before {\r\n  content: \"\\F0927\";\r\n}\r\n\r\n.mdi-wifi-strength-3-lock-open::before {\r\n  content: \"\\F16CD\";\r\n}\r\n\r\n.mdi-wifi-strength-4::before {\r\n  content: \"\\F0928\";\r\n}\r\n\r\n.mdi-wifi-strength-4-alert::before {\r\n  content: \"\\F0929\";\r\n}\r\n\r\n.mdi-wifi-strength-4-lock::before {\r\n  content: \"\\F092A\";\r\n}\r\n\r\n.mdi-wifi-strength-4-lock-open::before {\r\n  content: \"\\F16CE\";\r\n}\r\n\r\n.mdi-wifi-strength-alert-outline::before {\r\n  content: \"\\F092B\";\r\n}\r\n\r\n.mdi-wifi-strength-lock-open-outline::before {\r\n  content: \"\\F16CF\";\r\n}\r\n\r\n.mdi-wifi-strength-lock-outline::before {\r\n  content: \"\\F092C\";\r\n}\r\n\r\n.mdi-wifi-strength-off::before {\r\n  content: \"\\F092D\";\r\n}\r\n\r\n.mdi-wifi-strength-off-outline::before {\r\n  content: \"\\F092E\";\r\n}\r\n\r\n.mdi-wifi-strength-outline::before {\r\n  content: \"\\F092F\";\r\n}\r\n\r\n.mdi-wifi-sync::before {\r\n  content: \"\\F16C7\";\r\n}\r\n\r\n.mdi-wikipedia::before {\r\n  content: \"\\F05AC\";\r\n}\r\n\r\n.mdi-wind-turbine::before {\r\n  content: \"\\F0DA5\";\r\n}\r\n\r\n.mdi-wind-turbine-alert::before {\r\n  content: \"\\F19AB\";\r\n}\r\n\r\n.mdi-wind-turbine-check::before {\r\n  content: \"\\F19AC\";\r\n}\r\n\r\n.mdi-window-close::before {\r\n  content: \"\\F05AD\";\r\n}\r\n\r\n.mdi-window-closed::before {\r\n  content: \"\\F05AE\";\r\n}\r\n\r\n.mdi-window-closed-variant::before {\r\n  content: \"\\F11DB\";\r\n}\r\n\r\n.mdi-window-maximize::before {\r\n  content: \"\\F05AF\";\r\n}\r\n\r\n.mdi-window-minimize::before {\r\n  content: \"\\F05B0\";\r\n}\r\n\r\n.mdi-window-open::before {\r\n  content: \"\\F05B1\";\r\n}\r\n\r\n.mdi-window-open-variant::before {\r\n  content: \"\\F11DC\";\r\n}\r\n\r\n.mdi-window-restore::before {\r\n  content: \"\\F05B2\";\r\n}\r\n\r\n.mdi-window-shutter::before {\r\n  content: \"\\F111C\";\r\n}\r\n\r\n.mdi-window-shutter-alert::before {\r\n  content: \"\\F111D\";\r\n}\r\n\r\n.mdi-window-shutter-open::before {\r\n  content: \"\\F111E\";\r\n}\r\n\r\n.mdi-windsock::before {\r\n  content: \"\\F15FA\";\r\n}\r\n\r\n.mdi-wiper::before {\r\n  content: \"\\F0AE9\";\r\n}\r\n\r\n.mdi-wiper-wash::before {\r\n  content: \"\\F0DA6\";\r\n}\r\n\r\n.mdi-wiper-wash-alert::before {\r\n  content: \"\\F18DF\";\r\n}\r\n\r\n.mdi-wizard-hat::before {\r\n  content: \"\\F1477\";\r\n}\r\n\r\n.mdi-wordpress::before {\r\n  content: \"\\F05B4\";\r\n}\r\n\r\n.mdi-wrap::before {\r\n  content: \"\\F05B6\";\r\n}\r\n\r\n.mdi-wrap-disabled::before {\r\n  content: \"\\F0BDF\";\r\n}\r\n\r\n.mdi-wrench::before {\r\n  content: \"\\F05B7\";\r\n}\r\n\r\n.mdi-wrench-clock::before {\r\n  content: \"\\F19A3\";\r\n}\r\n\r\n.mdi-wrench-outline::before {\r\n  content: \"\\F0BE0\";\r\n}\r\n\r\n.mdi-xamarin::before {\r\n  content: \"\\F0845\";\r\n}\r\n\r\n.mdi-xml::before {\r\n  content: \"\\F05C0\";\r\n}\r\n\r\n.mdi-xmpp::before {\r\n  content: \"\\F07FF\";\r\n}\r\n\r\n.mdi-yahoo::before {\r\n  content: \"\\F0B4F\";\r\n}\r\n\r\n.mdi-yeast::before {\r\n  content: \"\\F05C1\";\r\n}\r\n\r\n.mdi-yin-yang::before {\r\n  content: \"\\F0680\";\r\n}\r\n\r\n.mdi-yoga::before {\r\n  content: \"\\F117C\";\r\n}\r\n\r\n.mdi-youtube::before {\r\n  content: \"\\F05C3\";\r\n}\r\n\r\n.mdi-youtube-gaming::before {\r\n  content: \"\\F0848\";\r\n}\r\n\r\n.mdi-youtube-studio::before {\r\n  content: \"\\F0847\";\r\n}\r\n\r\n.mdi-youtube-subscription::before {\r\n  content: \"\\F0D40\";\r\n}\r\n\r\n.mdi-youtube-tv::before {\r\n  content: \"\\F0448\";\r\n}\r\n\r\n.mdi-yurt::before {\r\n  content: \"\\F1516\";\r\n}\r\n\r\n.mdi-z-wave::before {\r\n  content: \"\\F0AEA\";\r\n}\r\n\r\n.mdi-zend::before {\r\n  content: \"\\F0AEB\";\r\n}\r\n\r\n.mdi-zigbee::before {\r\n  content: \"\\F0D41\";\r\n}\r\n\r\n.mdi-zip-box::before {\r\n  content: \"\\F05C4\";\r\n}\r\n\r\n.mdi-zip-box-outline::before {\r\n  content: \"\\F0FFA\";\r\n}\r\n\r\n.mdi-zip-disk::before {\r\n  content: \"\\F0A23\";\r\n}\r\n\r\n.mdi-zodiac-aquarius::before {\r\n  content: \"\\F0A7D\";\r\n}\r\n\r\n.mdi-zodiac-aries::before {\r\n  content: \"\\F0A7E\";\r\n}\r\n\r\n.mdi-zodiac-cancer::before {\r\n  content: \"\\F0A7F\";\r\n}\r\n\r\n.mdi-zodiac-capricorn::before {\r\n  content: \"\\F0A80\";\r\n}\r\n\r\n.mdi-zodiac-gemini::before {\r\n  content: \"\\F0A81\";\r\n}\r\n\r\n.mdi-zodiac-leo::before {\r\n  content: \"\\F0A82\";\r\n}\r\n\r\n.mdi-zodiac-libra::before {\r\n  content: \"\\F0A83\";\r\n}\r\n\r\n.mdi-zodiac-pisces::before {\r\n  content: \"\\F0A84\";\r\n}\r\n\r\n.mdi-zodiac-sagittarius::before {\r\n  content: \"\\F0A85\";\r\n}\r\n\r\n.mdi-zodiac-scorpio::before {\r\n  content: \"\\F0A86\";\r\n}\r\n\r\n.mdi-zodiac-taurus::before {\r\n  content: \"\\F0A87\";\r\n}\r\n\r\n.mdi-zodiac-virgo::before {\r\n  content: \"\\F0A88\";\r\n}\r\n\r\n.mdi-blank::before {\r\n  content: \"\\F68C\";\r\n  visibility: hidden;\r\n}\r\n\r\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\r\n  font-size: 18px;\r\n}\r\n\r\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\r\n  font-size: 24px;\r\n}\r\n\r\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\r\n  font-size: 36px;\r\n}\r\n\r\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\r\n  font-size: 48px;\r\n}\r\n\r\n.mdi-dark:before {\r\n  color: rgba(0, 0, 0, 0.54);\r\n}\r\n\r\n.mdi-dark.mdi-inactive:before {\r\n  color: rgba(0, 0, 0, 0.26);\r\n}\r\n\r\n.mdi-light:before {\r\n  color: white;\r\n}\r\n\r\n.mdi-light.mdi-inactive:before {\r\n  color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.mdi-rotate-45 {\r\n  /*\r\n        // Not included in civil_budget\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(45deg);\r\n            transform: scaleX(-1) rotate(45deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(45deg);\r\n            -ms-transform: rotate(45deg);\r\n            transform: scaleY(-1) rotate(45deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-45:before {\r\n  -webkit-transform: rotate(45deg);\r\n  -ms-transform: rotate(45deg);\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.mdi-rotate-90 {\r\n  /*\r\n        // Not included in civil_budget\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(90deg);\r\n            transform: scaleX(-1) rotate(90deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(90deg);\r\n            -ms-transform: rotate(90deg);\r\n            transform: scaleY(-1) rotate(90deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-90:before {\r\n  -webkit-transform: rotate(90deg);\r\n  -ms-transform: rotate(90deg);\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.mdi-rotate-135 {\r\n  /*\r\n        // Not included in civil_budget\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(135deg);\r\n            transform: scaleX(-1) rotate(135deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(135deg);\r\n            -ms-transform: rotate(135deg);\r\n            transform: scaleY(-1) rotate(135deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-135:before {\r\n  -webkit-transform: rotate(135deg);\r\n  -ms-transform: rotate(135deg);\r\n  transform: rotate(135deg);\r\n}\r\n\r\n.mdi-rotate-180 {\r\n  /*\r\n        // Not included in civil_budget\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(180deg);\r\n            transform: scaleX(-1) rotate(180deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(180deg);\r\n            -ms-transform: rotate(180deg);\r\n            transform: scaleY(-1) rotate(180deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-180:before {\r\n  -webkit-transform: rotate(180deg);\r\n  -ms-transform: rotate(180deg);\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.mdi-rotate-225 {\r\n  /*\r\n        // Not included in civil_budget\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(225deg);\r\n            transform: scaleX(-1) rotate(225deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(225deg);\r\n            -ms-transform: rotate(225deg);\r\n            transform: scaleY(-1) rotate(225deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-225:before {\r\n  -webkit-transform: rotate(225deg);\r\n  -ms-transform: rotate(225deg);\r\n  transform: rotate(225deg);\r\n}\r\n\r\n.mdi-rotate-270 {\r\n  /*\r\n        // Not included in civil_budget\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(270deg);\r\n            transform: scaleX(-1) rotate(270deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(270deg);\r\n            -ms-transform: rotate(270deg);\r\n            transform: scaleY(-1) rotate(270deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-270:before {\r\n  -webkit-transform: rotate(270deg);\r\n  -ms-transform: rotate(270deg);\r\n  transform: rotate(270deg);\r\n}\r\n\r\n.mdi-rotate-315 {\r\n  /*\r\n        // Not included in civil_budget\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(315deg);\r\n            transform: scaleX(-1) rotate(315deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(315deg);\r\n            -ms-transform: rotate(315deg);\r\n            transform: scaleY(-1) rotate(315deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-315:before {\r\n  -webkit-transform: rotate(315deg);\r\n  -ms-transform: rotate(315deg);\r\n  transform: rotate(315deg);\r\n}\r\n\r\n.mdi-flip-h:before {\r\n  -webkit-transform: scaleX(-1);\r\n  transform: scaleX(-1);\r\n  filter: FlipH;\r\n  -ms-filter: \"FlipH\";\r\n}\r\n\r\n.mdi-flip-v:before {\r\n  -webkit-transform: scaleY(-1);\r\n  transform: scaleY(-1);\r\n  filter: FlipV;\r\n  -ms-filter: \"FlipV\";\r\n}\r\n\r\n.mdi-spin:before {\r\n  -webkit-animation: mdi-spin 2s infinite linear;\r\n  animation: mdi-spin 2s infinite linear;\r\n}\r\n\r\n@-webkit-keyframes mdi-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(359deg);\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n\r\n@keyframes mdi-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(359deg);\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n\r\n/*# sourceMappingURL=materialdesignicons.css.map */","// boxicons 2.1.1\r\n\r\n@font-face\r\n{\r\n    font-family: 'boxicons';\r\n    font-weight: normal;\r\n    font-style: normal;\r\n\r\n    src: url('../../../fonts/boxicons.eot');\r\n    src: url('../../../fonts/boxicons.eot') format('embedded-opentype'),\r\n    url('../../../fonts/boxicons.woff2') format('woff2'),\r\n    url('../../../fonts/boxicons.woff') format('woff'),\r\n    url('../../../fonts/boxicons.ttf') format('truetype'),\r\n    url('../../../fonts/boxicons.svg?#boxicons') format('svg');\r\n}\r\n.bx\r\n{\r\n    font-family: 'boxicons' !important;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-variant: normal;\r\n    line-height: 1;\r\n    text-rendering: auto;\r\n    display: inline-block;\r\n\r\n    text-transform: none;\r\n\r\n    speak: none;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n}\r\n.bx-ul\r\n{\r\n    margin-left: 2em;\r\n    padding-left: 0;\r\n\r\n    list-style: none;\r\n}\r\n.bx-ul > li\r\n{\r\n    position: relative;\r\n}\r\n.bx-ul .bx\r\n{\r\n    font-size: inherit;\r\n    line-height: inherit;\r\n\r\n    position: absolute;\r\n    left: -2em;\r\n\r\n    width: 2em;\r\n\r\n    text-align: center;\r\n}\r\n@-webkit-keyframes spin\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: rotate(0);\r\n                transform: rotate(0);\r\n    }\r\n    100%\r\n    {\r\n        -webkit-transform: rotate(359deg);\r\n                transform: rotate(359deg);\r\n    }\r\n}\r\n@keyframes spin\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: rotate(0);\r\n                transform: rotate(0);\r\n    }\r\n    100%\r\n    {\r\n        -webkit-transform: rotate(359deg);\r\n                transform: rotate(359deg);\r\n    }\r\n}\r\n@-webkit-keyframes burst\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: scale(1);\r\n                transform: scale(1);\r\n\r\n        opacity: 1;\r\n    }\r\n    90%\r\n    {\r\n        -webkit-transform: scale(1.5);\r\n                transform: scale(1.5);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@keyframes burst\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: scale(1);\r\n                transform: scale(1);\r\n\r\n        opacity: 1;\r\n    }\r\n    90%\r\n    {\r\n        -webkit-transform: scale(1.5);\r\n                transform: scale(1.5);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@-webkit-keyframes flashing\r\n{\r\n    0%\r\n    {\r\n        opacity: 1;\r\n    }\r\n    45%\r\n    {\r\n        opacity: 0;\r\n    }\r\n    90%\r\n    {\r\n        opacity: 1;\r\n    }\r\n}\r\n@keyframes flashing\r\n{\r\n    0%\r\n    {\r\n        opacity: 1;\r\n    }\r\n    45%\r\n    {\r\n        opacity: 0;\r\n    }\r\n    90%\r\n    {\r\n        opacity: 1;\r\n    }\r\n}\r\n@-webkit-keyframes fade-left\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateX(0);\r\n                transform: translateX(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateX(-20px);\r\n                transform: translateX(-20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@keyframes fade-left\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateX(0);\r\n                transform: translateX(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateX(-20px);\r\n                transform: translateX(-20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@-webkit-keyframes fade-right\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateX(0);\r\n                transform: translateX(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateX(20px);\r\n                transform: translateX(20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@keyframes fade-right\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateX(0);\r\n                transform: translateX(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateX(20px);\r\n                transform: translateX(20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@-webkit-keyframes fade-up\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateY(0);\r\n                transform: translateY(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateY(-20px);\r\n                transform: translateY(-20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@keyframes fade-up\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateY(0);\r\n                transform: translateY(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateY(-20px);\r\n                transform: translateY(-20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@-webkit-keyframes fade-down\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateY(0);\r\n                transform: translateY(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateY(20px);\r\n                transform: translateY(20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@keyframes fade-down\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateY(0);\r\n                transform: translateY(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateY(20px);\r\n                transform: translateY(20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@-webkit-keyframes tada\r\n{\r\n    from\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n                transform: scale3d(1, 1, 1);\r\n    }\r\n\r\n    10%,\r\n    20%\r\n    {\r\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\r\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\r\n    }\r\n\r\n    30%,\r\n    50%,\r\n    70%,\r\n    90%\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n    }\r\n\r\n    40%,\r\n    60%,\r\n    80%\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\r\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\r\n    }\r\n\r\n    to\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n                transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n\r\n@keyframes tada\r\n{\r\n    from\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n                transform: scale3d(1, 1, 1);\r\n    }\r\n\r\n    10%,\r\n    20%\r\n    {\r\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\r\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\r\n    }\r\n\r\n    30%,\r\n    50%,\r\n    70%,\r\n    90%\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n    }\r\n\r\n    40%,\r\n    60%,\r\n    80%\r\n    {\r\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\r\n                transform: rotate3d(0, 0, 1, -10deg);\r\n    }\r\n\r\n    to\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n                transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n.bx-spin\r\n{\r\n    -webkit-animation: spin 2s linear infinite;\r\n            animation: spin 2s linear infinite;\r\n}\r\n.bx-spin-hover:hover\r\n{\r\n    -webkit-animation: spin 2s linear infinite;\r\n            animation: spin 2s linear infinite;\r\n}\r\n\r\n.bx-tada\r\n{\r\n    -webkit-animation: tada 1.5s ease infinite;\r\n            animation: tada 1.5s ease infinite;\r\n}\r\n.bx-tada-hover:hover\r\n{\r\n    -webkit-animation: tada 1.5s ease infinite;\r\n            animation: tada 1.5s ease infinite;\r\n}\r\n\r\n.bx-flashing\r\n{\r\n    -webkit-animation: flashing 1.5s infinite linear;\r\n            animation: flashing 1.5s infinite linear;\r\n}\r\n.bx-flashing-hover:hover\r\n{\r\n    -webkit-animation: flashing 1.5s infinite linear;\r\n            animation: flashing 1.5s infinite linear;\r\n}\r\n\r\n.bx-burst\r\n{\r\n    -webkit-animation: burst 1.5s infinite linear;\r\n            animation: burst 1.5s infinite linear;\r\n}\r\n.bx-burst-hover:hover\r\n{\r\n    -webkit-animation: burst 1.5s infinite linear;\r\n            animation: burst 1.5s infinite linear;\r\n}\r\n.bx-fade-up\r\n{\r\n    -webkit-animation: fade-up 1.5s infinite linear;\r\n            animation: fade-up 1.5s infinite linear;\r\n}\r\n.bx-fade-up-hover:hover\r\n{\r\n    -webkit-animation: fade-up 1.5s infinite linear;\r\n            animation: fade-up 1.5s infinite linear;\r\n}\r\n.bx-fade-down\r\n{\r\n    -webkit-animation: fade-down 1.5s infinite linear;\r\n            animation: fade-down 1.5s infinite linear;\r\n}\r\n.bx-fade-down-hover:hover\r\n{\r\n    -webkit-animation: fade-down 1.5s infinite linear;\r\n            animation: fade-down 1.5s infinite linear;\r\n}\r\n.bx-fade-left\r\n{\r\n    -webkit-animation: fade-left 1.5s infinite linear;\r\n            animation: fade-left 1.5s infinite linear;\r\n}\r\n.bx-fade-left-hover:hover\r\n{\r\n    -webkit-animation: fade-left 1.5s infinite linear;\r\n            animation: fade-left 1.5s infinite linear;\r\n}\r\n.bx-fade-right\r\n{\r\n    -webkit-animation: fade-right 1.5s infinite linear;\r\n            animation: fade-right 1.5s infinite linear;\r\n}\r\n.bx-fade-right-hover:hover\r\n{\r\n    -webkit-animation: fade-right 1.5s infinite linear;\r\n            animation: fade-right 1.5s infinite linear;\r\n}\r\n.bx-xs\r\n{\r\n    font-size: 1rem!important;\r\n}\r\n.bx-sm\r\n{\r\n    font-size: 1.55rem!important;\r\n}\r\n.bx-md\r\n{\r\n    font-size: 2.25rem!important;\r\n}\r\n.bx-lg\r\n{\r\n    font-size: 3.0rem!important;\r\n}\r\n.bx-fw\r\n{\r\n    font-size: 1.2857142857em;\r\n    line-height: .8em;\r\n\r\n    width: 1.2857142857em;\r\n    height: .8em;\r\n    margin-top: -.2em!important;\r\n\r\n    vertical-align: middle;\r\n}\r\n.bx-pull-left\r\n{\r\n    float: left;\r\n\r\n    margin-right: .3em!important;\r\n}\r\n.bx-pull-right\r\n{\r\n    float: right;\r\n\r\n    margin-left: .3em!important;\r\n}\r\n.bx-rotate-90\r\n{\r\n    transform: rotate(90deg);\r\n\r\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';\r\n}\r\n.bx-rotate-180\r\n{\r\n    transform: rotate(180deg);\r\n\r\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';\r\n}\r\n.bx-rotate-270\r\n{\r\n    transform: rotate(270deg);\r\n\r\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';\r\n}\r\n.bx-flip-horizontal\r\n{\r\n    transform: scaleX(-1);\r\n\r\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)';\r\n}\r\n.bx-flip-vertical\r\n{\r\n    transform: scaleY(-1);\r\n\r\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';\r\n}\r\n.bx-border\r\n{\r\n    padding: .25em;\r\n\r\n    border: .07em solid rgba(0,0,0,.1);\r\n    border-radius: .25em;\r\n}\r\n.bx-border-circle\r\n{\r\n    padding: .25em;\r\n\r\n    border: .07em solid rgba(0,0,0,.1);\r\n    border-radius: 50%;\r\n}\r\n\r\n  \r\n  .bxl-meta:before {\r\n    content: \"\\ef27\";\r\n  }\r\n  .bx-lemon:before {\r\n    content: \"\\ef28\";\r\n  }\r\n  .bxs-lemon:before {\r\n    content: \"\\ef29\";\r\n  }\r\n  .bx-cricket-ball:before {\r\n    content: \"\\ef0c\";\r\n  }\r\n  .bx-baguette:before {\r\n    content: \"\\ef0d\";\r\n  }\r\n  .bx-bowl-hot:before {\r\n    content: \"\\ef0e\";\r\n  }\r\n  .bx-bowl-rice:before {\r\n    content: \"\\ef0f\";\r\n  }\r\n  .bx-cable-car:before {\r\n    content: \"\\ef10\";\r\n  }\r\n  .bx-candles:before {\r\n    content: \"\\ef11\";\r\n  }\r\n  .bx-circle-half:before {\r\n    content: \"\\ef12\";\r\n  }\r\n  .bx-circle-quarter:before {\r\n    content: \"\\ef13\";\r\n  }\r\n  .bx-circle-three-quarter:before {\r\n    content: \"\\ef14\";\r\n  }\r\n  .bx-cross:before {\r\n    content: \"\\ef15\";\r\n  }\r\n  .bx-fork:before {\r\n    content: \"\\ef16\";\r\n  }\r\n  .bx-knife:before {\r\n    content: \"\\ef17\";\r\n  }\r\n  .bx-money-withdraw:before {\r\n    content: \"\\ef18\";\r\n  }\r\n  .bx-popsicle:before {\r\n    content: \"\\ef19\";\r\n  }\r\n  .bx-scatter-chart:before {\r\n    content: \"\\ef1a\";\r\n  }\r\n  .bxs-baguette:before {\r\n    content: \"\\ef1b\";\r\n  }\r\n  .bxs-bowl-hot:before {\r\n    content: \"\\ef1c\";\r\n  }\r\n  .bxs-bowl-rice:before {\r\n    content: \"\\ef1d\";\r\n  }\r\n  .bxs-cable-car:before {\r\n    content: \"\\ef1e\";\r\n  }\r\n  .bxs-circle-half:before {\r\n    content: \"\\ef1f\";\r\n  }\r\n  .bxs-circle-quarter:before {\r\n    content: \"\\ef20\";\r\n  }\r\n  .bxs-circle-three-quarter:before {\r\n    content: \"\\ef21\";\r\n  }\r\n  .bxs-cricket-ball:before {\r\n    content: \"\\ef22\";\r\n  }\r\n  .bxs-invader:before {\r\n    content: \"\\ef23\";\r\n  }\r\n  .bx-male-female:before {\r\n    content: \"\\ef24\";\r\n  }\r\n  .bxs-popsicle:before {\r\n    content: \"\\ef25\";\r\n  }\r\n  .bxs-tree-alt:before {\r\n    content: \"\\ef26\";\r\n  }\r\n  .bxl-venmo:before {\r\n    content: \"\\e900\";\r\n  }\r\n  .bxl-upwork:before {\r\n    content: \"\\e901\";\r\n  }\r\n  .bxl-netlify:before {\r\n    content: \"\\e902\";\r\n  }\r\n  .bxl-java:before {\r\n    content: \"\\e903\";\r\n  }\r\n  .bxl-heroku:before {\r\n    content: \"\\e904\";\r\n  }\r\n  .bxl-go-lang:before {\r\n    content: \"\\e905\";\r\n  }\r\n  .bxl-gmail:before {\r\n    content: \"\\e906\";\r\n  }\r\n  .bxl-flask:before {\r\n    content: \"\\e907\";\r\n  }\r\n  .bxl-99designs:before {\r\n    content: \"\\e908\";\r\n  }\r\n  .bxl-500px:before {\r\n    content: \"\\e909\";\r\n  }\r\n  .bxl-adobe:before {\r\n    content: \"\\e90a\";\r\n  }\r\n  .bxl-airbnb:before {\r\n    content: \"\\e90b\";\r\n  }\r\n  .bxl-algolia:before {\r\n    content: \"\\e90c\";\r\n  }\r\n  .bxl-amazon:before {\r\n    content: \"\\e90d\";\r\n  }\r\n  .bxl-android:before {\r\n    content: \"\\e90e\";\r\n  }\r\n  .bxl-angular:before {\r\n    content: \"\\e90f\";\r\n  }\r\n  .bxl-apple:before {\r\n    content: \"\\e910\";\r\n  }\r\n  .bxl-audible:before {\r\n    content: \"\\e911\";\r\n  }\r\n  .bxl-aws:before {\r\n    content: \"\\e912\";\r\n  }\r\n  .bxl-baidu:before {\r\n    content: \"\\e913\";\r\n  }\r\n  .bxl-behance:before {\r\n    content: \"\\e914\";\r\n  }\r\n  .bxl-bing:before {\r\n    content: \"\\e915\";\r\n  }\r\n  .bxl-bitcoin:before {\r\n    content: \"\\e916\";\r\n  }\r\n  .bxl-blender:before {\r\n    content: \"\\e917\";\r\n  }\r\n  .bxl-blogger:before {\r\n    content: \"\\e918\";\r\n  }\r\n  .bxl-bootstrap:before {\r\n    content: \"\\e919\";\r\n  }\r\n  .bxl-chrome:before {\r\n    content: \"\\e91a\";\r\n  }\r\n  .bxl-codepen:before {\r\n    content: \"\\e91b\";\r\n  }\r\n  .bxl-c-plus-plus:before {\r\n    content: \"\\e91c\";\r\n  }\r\n  .bxl-creative-commons:before {\r\n    content: \"\\e91d\";\r\n  }\r\n  .bxl-css3:before {\r\n    content: \"\\e91e\";\r\n  }\r\n  .bxl-dailymotion:before {\r\n    content: \"\\e91f\";\r\n  }\r\n  .bxl-deviantart:before {\r\n    content: \"\\e920\";\r\n  }\r\n  .bxl-dev-to:before {\r\n    content: \"\\e921\";\r\n  }\r\n  .bxl-digg:before {\r\n    content: \"\\e922\";\r\n  }\r\n  .bxl-digitalocean:before {\r\n    content: \"\\e923\";\r\n  }\r\n  .bxl-discord:before {\r\n    content: \"\\e924\";\r\n  }\r\n  .bxl-discord-alt:before {\r\n    content: \"\\e925\";\r\n  }\r\n  .bxl-discourse:before {\r\n    content: \"\\e926\";\r\n  }\r\n  .bxl-django:before {\r\n    content: \"\\e927\";\r\n  }\r\n  .bxl-docker:before {\r\n    content: \"\\e928\";\r\n  }\r\n  .bxl-dribbble:before {\r\n    content: \"\\e929\";\r\n  }\r\n  .bxl-dropbox:before {\r\n    content: \"\\e92a\";\r\n  }\r\n  .bxl-drupal:before {\r\n    content: \"\\e92b\";\r\n  }\r\n  .bxl-ebay:before {\r\n    content: \"\\e92c\";\r\n  }\r\n  .bxl-edge:before {\r\n    content: \"\\e92d\";\r\n  }\r\n  .bxl-etsy:before {\r\n    content: \"\\e92e\";\r\n  }\r\n  .bxl-facebook:before {\r\n    content: \"\\e92f\";\r\n  }\r\n  .bxl-facebook-circle:before {\r\n    content: \"\\e930\";\r\n  }\r\n  .bxl-facebook-square:before {\r\n    content: \"\\e931\";\r\n  }\r\n  .bxl-figma:before {\r\n    content: \"\\e932\";\r\n  }\r\n  .bxl-firebase:before {\r\n    content: \"\\e933\";\r\n  }\r\n  .bxl-firefox:before {\r\n    content: \"\\e934\";\r\n  }\r\n  .bxl-flickr:before {\r\n    content: \"\\e935\";\r\n  }\r\n  .bxl-flickr-square:before {\r\n    content: \"\\e936\";\r\n  }\r\n  .bxl-flutter:before {\r\n    content: \"\\e937\";\r\n  }\r\n  .bxl-foursquare:before {\r\n    content: \"\\e938\";\r\n  }\r\n  .bxl-git:before {\r\n    content: \"\\e939\";\r\n  }\r\n  .bxl-github:before {\r\n    content: \"\\e93a\";\r\n  }\r\n  .bxl-gitlab:before {\r\n    content: \"\\e93b\";\r\n  }\r\n  .bxl-google:before {\r\n    content: \"\\e93c\";\r\n  }\r\n  .bxl-google-cloud:before {\r\n    content: \"\\e93d\";\r\n  }\r\n  .bxl-google-plus:before {\r\n    content: \"\\e93e\";\r\n  }\r\n  .bxl-google-plus-circle:before {\r\n    content: \"\\e93f\";\r\n  }\r\n  .bxl-html5:before {\r\n    content: \"\\e940\";\r\n  }\r\n  .bxl-imdb:before {\r\n    content: \"\\e941\";\r\n  }\r\n  .bxl-instagram:before {\r\n    content: \"\\e942\";\r\n  }\r\n  .bxl-instagram-alt:before {\r\n    content: \"\\e943\";\r\n  }\r\n  .bxl-internet-explorer:before {\r\n    content: \"\\e944\";\r\n  }\r\n  .bxl-invision:before {\r\n    content: \"\\e945\";\r\n  }\r\n  .bxl-javascript:before {\r\n    content: \"\\e946\";\r\n  }\r\n  .bxl-joomla:before {\r\n    content: \"\\e947\";\r\n  }\r\n  .bxl-jquery:before {\r\n    content: \"\\e948\";\r\n  }\r\n  .bxl-jsfiddle:before {\r\n    content: \"\\e949\";\r\n  }\r\n  .bxl-kickstarter:before {\r\n    content: \"\\e94a\";\r\n  }\r\n  .bxl-kubernetes:before {\r\n    content: \"\\e94b\";\r\n  }\r\n  .bxl-less:before {\r\n    content: \"\\e94c\";\r\n  }\r\n  .bxl-linkedin:before {\r\n    content: \"\\e94d\";\r\n  }\r\n  .bxl-linkedin-square:before {\r\n    content: \"\\e94e\";\r\n  }\r\n  .bxl-magento:before {\r\n    content: \"\\e94f\";\r\n  }\r\n  .bxl-mailchimp:before {\r\n    content: \"\\e950\";\r\n  }\r\n  .bxl-markdown:before {\r\n    content: \"\\e951\";\r\n  }\r\n  .bxl-mastercard:before {\r\n    content: \"\\e952\";\r\n  }\r\n  .bxl-mastodon:before {\r\n    content: \"\\e953\";\r\n  }\r\n  .bxl-medium:before {\r\n    content: \"\\e954\";\r\n  }\r\n  .bxl-medium-old:before {\r\n    content: \"\\e955\";\r\n  }\r\n  .bxl-medium-square:before {\r\n    content: \"\\e956\";\r\n  }\r\n  .bxl-messenger:before {\r\n    content: \"\\e957\";\r\n  }\r\n  .bxl-microsoft:before {\r\n    content: \"\\e958\";\r\n  }\r\n  .bxl-microsoft-teams:before {\r\n    content: \"\\e959\";\r\n  }\r\n  .bxl-nodejs:before {\r\n    content: \"\\e95a\";\r\n  }\r\n  .bxl-ok-ru:before {\r\n    content: \"\\e95b\";\r\n  }\r\n  .bxl-opera:before {\r\n    content: \"\\e95c\";\r\n  }\r\n  .bxl-patreon:before {\r\n    content: \"\\e95d\";\r\n  }\r\n  .bxl-paypal:before {\r\n    content: \"\\e95e\";\r\n  }\r\n  .bxl-periscope:before {\r\n    content: \"\\e95f\";\r\n  }\r\n  .bxl-php:before {\r\n    content: \"\\e960\";\r\n  }\r\n  .bxl-pinterest:before {\r\n    content: \"\\e961\";\r\n  }\r\n  .bxl-pinterest-alt:before {\r\n    content: \"\\e962\";\r\n  }\r\n  .bxl-play-store:before {\r\n    content: \"\\e963\";\r\n  }\r\n  .bxl-pocket:before {\r\n    content: \"\\e964\";\r\n  }\r\n  .bxl-product-hunt:before {\r\n    content: \"\\e965\";\r\n  }\r\n  .bxl-python:before {\r\n    content: \"\\e966\";\r\n  }\r\n  .bxl-quora:before {\r\n    content: \"\\e967\";\r\n  }\r\n  .bxl-react:before {\r\n    content: \"\\e968\";\r\n  }\r\n  .bxl-redbubble:before {\r\n    content: \"\\e969\";\r\n  }\r\n  .bxl-reddit:before {\r\n    content: \"\\e96a\";\r\n  }\r\n  .bxl-redux:before {\r\n    content: \"\\e96b\";\r\n  }\r\n  .bxl-sass:before {\r\n    content: \"\\e96c\";\r\n  }\r\n  .bxl-shopify:before {\r\n    content: \"\\e96d\";\r\n  }\r\n  .bxl-sketch:before {\r\n    content: \"\\e96e\";\r\n  }\r\n  .bxl-skype:before {\r\n    content: \"\\e96f\";\r\n  }\r\n  .bxl-slack:before {\r\n    content: \"\\e970\";\r\n  }\r\n  .bxl-slack-old:before {\r\n    content: \"\\e971\";\r\n  }\r\n  .bxl-snapchat:before {\r\n    content: \"\\e972\";\r\n  }\r\n  .bxl-soundcloud:before {\r\n    content: \"\\e973\";\r\n  }\r\n  .bxl-spotify:before {\r\n    content: \"\\e974\";\r\n  }\r\n  .bxl-spring-boot:before {\r\n    content: \"\\e975\";\r\n  }\r\n  .bxl-squarespace:before {\r\n    content: \"\\e976\";\r\n  }\r\n  .bxl-stack-overflow:before {\r\n    content: \"\\e977\";\r\n  }\r\n  .bxl-steam:before {\r\n    content: \"\\e978\";\r\n  }\r\n  .bxl-stripe:before {\r\n    content: \"\\e979\";\r\n  }\r\n  .bxl-tailwind-css:before {\r\n    content: \"\\e97a\";\r\n  }\r\n  .bxl-telegram:before {\r\n    content: \"\\e97b\";\r\n  }\r\n  .bxl-tiktok:before {\r\n    content: \"\\e97c\";\r\n  }\r\n  .bxl-trello:before {\r\n    content: \"\\e97d\";\r\n  }\r\n  .bxl-trip-advisor:before {\r\n    content: \"\\e97e\";\r\n  }\r\n  .bxl-tumblr:before {\r\n    content: \"\\e97f\";\r\n  }\r\n  .bxl-tux:before {\r\n    content: \"\\e980\";\r\n  }\r\n  .bxl-twitch:before {\r\n    content: \"\\e981\";\r\n  }\r\n  .bxl-twitter:before {\r\n    content: \"\\e982\";\r\n  }\r\n  .bxl-unity:before {\r\n    content: \"\\e983\";\r\n  }\r\n  .bxl-unsplash:before {\r\n    content: \"\\e984\";\r\n  }\r\n  .bxl-vimeo:before {\r\n    content: \"\\e985\";\r\n  }\r\n  .bxl-visa:before {\r\n    content: \"\\e986\";\r\n  }\r\n  .bxl-visual-studio:before {\r\n    content: \"\\e987\";\r\n  }\r\n  .bxl-vk:before {\r\n    content: \"\\e988\";\r\n  }\r\n  .bxl-vuejs:before {\r\n    content: \"\\e989\";\r\n  }\r\n  .bxl-whatsapp:before {\r\n    content: \"\\e98a\";\r\n  }\r\n  .bxl-whatsapp-square:before {\r\n    content: \"\\e98b\";\r\n  }\r\n  .bxl-wikipedia:before {\r\n    content: \"\\e98c\";\r\n  }\r\n  .bxl-windows:before {\r\n    content: \"\\e98d\";\r\n  }\r\n  .bxl-wix:before {\r\n    content: \"\\e98e\";\r\n  }\r\n  .bxl-wordpress:before {\r\n    content: \"\\e98f\";\r\n  }\r\n  .bxl-yahoo:before {\r\n    content: \"\\e990\";\r\n  }\r\n  .bxl-yelp:before {\r\n    content: \"\\e991\";\r\n  }\r\n  .bxl-youtube:before {\r\n    content: \"\\e992\";\r\n  }\r\n  .bxl-zoom:before {\r\n    content: \"\\e993\";\r\n  }\r\n  .bx-collapse-alt:before {\r\n    content: \"\\e994\";\r\n  }\r\n  .bx-collapse-horizontal:before {\r\n    content: \"\\e995\";\r\n  }\r\n  .bx-collapse-vertical:before {\r\n    content: \"\\e996\";\r\n  }\r\n  .bx-expand-horizontal:before {\r\n    content: \"\\e997\";\r\n  }\r\n  .bx-expand-vertical:before {\r\n    content: \"\\e998\";\r\n  }\r\n  .bx-injection:before {\r\n    content: \"\\e999\";\r\n  }\r\n  .bx-leaf:before {\r\n    content: \"\\e99a\";\r\n  }\r\n  .bx-math:before {\r\n    content: \"\\e99b\";\r\n  }\r\n  .bx-party:before {\r\n    content: \"\\e99c\";\r\n  }\r\n  .bx-abacus:before {\r\n    content: \"\\e99d\";\r\n  }\r\n  .bx-accessibility:before {\r\n    content: \"\\e99e\";\r\n  }\r\n  .bx-add-to-queue:before {\r\n    content: \"\\e99f\";\r\n  }\r\n  .bx-adjust:before {\r\n    content: \"\\e9a0\";\r\n  }\r\n  .bx-alarm:before {\r\n    content: \"\\e9a1\";\r\n  }\r\n  .bx-alarm-add:before {\r\n    content: \"\\e9a2\";\r\n  }\r\n  .bx-alarm-exclamation:before {\r\n    content: \"\\e9a3\";\r\n  }\r\n  .bx-alarm-off:before {\r\n    content: \"\\e9a4\";\r\n  }\r\n  .bx-alarm-snooze:before {\r\n    content: \"\\e9a5\";\r\n  }\r\n  .bx-album:before {\r\n    content: \"\\e9a6\";\r\n  }\r\n  .bx-align-justify:before {\r\n    content: \"\\e9a7\";\r\n  }\r\n  .bx-align-left:before {\r\n    content: \"\\e9a8\";\r\n  }\r\n  .bx-align-middle:before {\r\n    content: \"\\e9a9\";\r\n  }\r\n  .bx-align-right:before {\r\n    content: \"\\e9aa\";\r\n  }\r\n  .bx-analyse:before {\r\n    content: \"\\e9ab\";\r\n  }\r\n  .bx-anchor:before {\r\n    content: \"\\e9ac\";\r\n  }\r\n  .bx-angry:before {\r\n    content: \"\\e9ad\";\r\n  }\r\n  .bx-aperture:before {\r\n    content: \"\\e9ae\";\r\n  }\r\n  .bx-arch:before {\r\n    content: \"\\e9af\";\r\n  }\r\n  .bx-archive:before {\r\n    content: \"\\e9b0\";\r\n  }\r\n  .bx-archive-in:before {\r\n    content: \"\\e9b1\";\r\n  }\r\n  .bx-archive-out:before {\r\n    content: \"\\e9b2\";\r\n  }\r\n  .bx-area:before {\r\n    content: \"\\e9b3\";\r\n  }\r\n  .bx-arrow-back:before {\r\n    content: \"\\e9b4\";\r\n  }\r\n  .bx-arrow-from-bottom:before {\r\n    content: \"\\e9b5\";\r\n  }\r\n  .bx-arrow-from-left:before {\r\n    content: \"\\e9b6\";\r\n  }\r\n  .bx-arrow-from-right:before {\r\n    content: \"\\e9b7\";\r\n  }\r\n  .bx-arrow-from-top:before {\r\n    content: \"\\e9b8\";\r\n  }\r\n  .bx-arrow-to-bottom:before {\r\n    content: \"\\e9b9\";\r\n  }\r\n  .bx-arrow-to-left:before {\r\n    content: \"\\e9ba\";\r\n  }\r\n  .bx-arrow-to-right:before {\r\n    content: \"\\e9bb\";\r\n  }\r\n  .bx-arrow-to-top:before {\r\n    content: \"\\e9bc\";\r\n  }\r\n  .bx-at:before {\r\n    content: \"\\e9bd\";\r\n  }\r\n  .bx-atom:before {\r\n    content: \"\\e9be\";\r\n  }\r\n  .bx-award:before {\r\n    content: \"\\e9bf\";\r\n  }\r\n  .bx-badge:before {\r\n    content: \"\\e9c0\";\r\n  }\r\n  .bx-badge-check:before {\r\n    content: \"\\e9c1\";\r\n  }\r\n  .bx-ball:before {\r\n    content: \"\\e9c2\";\r\n  }\r\n  .bx-band-aid:before {\r\n    content: \"\\e9c3\";\r\n  }\r\n  .bx-bar-chart:before {\r\n    content: \"\\e9c4\";\r\n  }\r\n  .bx-bar-chart-alt:before {\r\n    content: \"\\e9c5\";\r\n  }\r\n  .bx-bar-chart-alt-2:before {\r\n    content: \"\\e9c6\";\r\n  }\r\n  .bx-bar-chart-square:before {\r\n    content: \"\\e9c7\";\r\n  }\r\n  .bx-barcode:before {\r\n    content: \"\\e9c8\";\r\n  }\r\n  .bx-barcode-reader:before {\r\n    content: \"\\e9c9\";\r\n  }\r\n  .bx-baseball:before {\r\n    content: \"\\e9ca\";\r\n  }\r\n  .bx-basket:before {\r\n    content: \"\\e9cb\";\r\n  }\r\n  .bx-basketball:before {\r\n    content: \"\\e9cc\";\r\n  }\r\n  .bx-bath:before {\r\n    content: \"\\e9cd\";\r\n  }\r\n  .bx-battery:before {\r\n    content: \"\\e9ce\";\r\n  }\r\n  .bx-bed:before {\r\n    content: \"\\e9cf\";\r\n  }\r\n  .bx-been-here:before {\r\n    content: \"\\e9d0\";\r\n  }\r\n  .bx-beer:before {\r\n    content: \"\\e9d1\";\r\n  }\r\n  .bx-bell:before {\r\n    content: \"\\e9d2\";\r\n  }\r\n  .bx-bell-minus:before {\r\n    content: \"\\e9d3\";\r\n  }\r\n  .bx-bell-off:before {\r\n    content: \"\\e9d4\";\r\n  }\r\n  .bx-bell-plus:before {\r\n    content: \"\\e9d5\";\r\n  }\r\n  .bx-bible:before {\r\n    content: \"\\e9d6\";\r\n  }\r\n  .bx-bitcoin:before {\r\n    content: \"\\e9d7\";\r\n  }\r\n  .bx-blanket:before {\r\n    content: \"\\e9d8\";\r\n  }\r\n  .bx-block:before {\r\n    content: \"\\e9d9\";\r\n  }\r\n  .bx-bluetooth:before {\r\n    content: \"\\e9da\";\r\n  }\r\n  .bx-body:before {\r\n    content: \"\\e9db\";\r\n  }\r\n  .bx-bold:before {\r\n    content: \"\\e9dc\";\r\n  }\r\n  .bx-bolt-circle:before {\r\n    content: \"\\e9dd\";\r\n  }\r\n  .bx-bomb:before {\r\n    content: \"\\e9de\";\r\n  }\r\n  .bx-bone:before {\r\n    content: \"\\e9df\";\r\n  }\r\n  .bx-bong:before {\r\n    content: \"\\e9e0\";\r\n  }\r\n  .bx-book:before {\r\n    content: \"\\e9e1\";\r\n  }\r\n  .bx-book-add:before {\r\n    content: \"\\e9e2\";\r\n  }\r\n  .bx-book-alt:before {\r\n    content: \"\\e9e3\";\r\n  }\r\n  .bx-book-bookmark:before {\r\n    content: \"\\e9e4\";\r\n  }\r\n  .bx-book-content:before {\r\n    content: \"\\e9e5\";\r\n  }\r\n  .bx-book-heart:before {\r\n    content: \"\\e9e6\";\r\n  }\r\n  .bx-bookmark:before {\r\n    content: \"\\e9e7\";\r\n  }\r\n  .bx-bookmark-alt:before {\r\n    content: \"\\e9e8\";\r\n  }\r\n  .bx-bookmark-alt-minus:before {\r\n    content: \"\\e9e9\";\r\n  }\r\n  .bx-bookmark-alt-plus:before {\r\n    content: \"\\e9ea\";\r\n  }\r\n  .bx-bookmark-heart:before {\r\n    content: \"\\e9eb\";\r\n  }\r\n  .bx-bookmark-minus:before {\r\n    content: \"\\e9ec\";\r\n  }\r\n  .bx-bookmark-plus:before {\r\n    content: \"\\e9ed\";\r\n  }\r\n  .bx-bookmarks:before {\r\n    content: \"\\e9ee\";\r\n  }\r\n  .bx-book-open:before {\r\n    content: \"\\e9ef\";\r\n  }\r\n  .bx-book-reader:before {\r\n    content: \"\\e9f0\";\r\n  }\r\n  .bx-border-all:before {\r\n    content: \"\\e9f1\";\r\n  }\r\n  .bx-border-bottom:before {\r\n    content: \"\\e9f2\";\r\n  }\r\n  .bx-border-inner:before {\r\n    content: \"\\e9f3\";\r\n  }\r\n  .bx-border-left:before {\r\n    content: \"\\e9f4\";\r\n  }\r\n  .bx-border-none:before {\r\n    content: \"\\e9f5\";\r\n  }\r\n  .bx-border-outer:before {\r\n    content: \"\\e9f6\";\r\n  }\r\n  .bx-border-radius:before {\r\n    content: \"\\e9f7\";\r\n  }\r\n  .bx-border-right:before {\r\n    content: \"\\e9f8\";\r\n  }\r\n  .bx-border-top:before {\r\n    content: \"\\e9f9\";\r\n  }\r\n  .bx-bot:before {\r\n    content: \"\\e9fa\";\r\n  }\r\n  .bx-bowling-ball:before {\r\n    content: \"\\e9fb\";\r\n  }\r\n  .bx-box:before {\r\n    content: \"\\e9fc\";\r\n  }\r\n  .bx-bracket:before {\r\n    content: \"\\e9fd\";\r\n  }\r\n  .bx-braille:before {\r\n    content: \"\\e9fe\";\r\n  }\r\n  .bx-brain:before {\r\n    content: \"\\e9ff\";\r\n  }\r\n  .bx-briefcase:before {\r\n    content: \"\\ea00\";\r\n  }\r\n  .bx-briefcase-alt:before {\r\n    content: \"\\ea01\";\r\n  }\r\n  .bx-briefcase-alt-2:before {\r\n    content: \"\\ea02\";\r\n  }\r\n  .bx-brightness:before {\r\n    content: \"\\ea03\";\r\n  }\r\n  .bx-brightness-half:before {\r\n    content: \"\\ea04\";\r\n  }\r\n  .bx-broadcast:before {\r\n    content: \"\\ea05\";\r\n  }\r\n  .bx-brush:before {\r\n    content: \"\\ea06\";\r\n  }\r\n  .bx-brush-alt:before {\r\n    content: \"\\ea07\";\r\n  }\r\n  .bx-bug:before {\r\n    content: \"\\ea08\";\r\n  }\r\n  .bx-bug-alt:before {\r\n    content: \"\\ea09\";\r\n  }\r\n  .bx-building:before {\r\n    content: \"\\ea0a\";\r\n  }\r\n  .bx-building-house:before {\r\n    content: \"\\ea0b\";\r\n  }\r\n  .bx-buildings:before {\r\n    content: \"\\ea0c\";\r\n  }\r\n  .bx-bulb:before {\r\n    content: \"\\ea0d\";\r\n  }\r\n  .bx-bullseye:before {\r\n    content: \"\\ea0e\";\r\n  }\r\n  .bx-buoy:before {\r\n    content: \"\\ea0f\";\r\n  }\r\n  .bx-bus:before {\r\n    content: \"\\ea10\";\r\n  }\r\n  .bx-bus-school:before {\r\n    content: \"\\ea11\";\r\n  }\r\n  .bx-cabinet:before {\r\n    content: \"\\ea12\";\r\n  }\r\n  .bx-cake:before {\r\n    content: \"\\ea13\";\r\n  }\r\n  .bx-calculator:before {\r\n    content: \"\\ea14\";\r\n  }\r\n  .bx-calendar:before {\r\n    content: \"\\ea15\";\r\n  }\r\n  .bx-calendar-alt:before {\r\n    content: \"\\ea16\";\r\n  }\r\n  .bx-calendar-check:before {\r\n    content: \"\\ea17\";\r\n  }\r\n  .bx-calendar-edit:before {\r\n    content: \"\\ea18\";\r\n  }\r\n  .bx-calendar-event:before {\r\n    content: \"\\ea19\";\r\n  }\r\n  .bx-calendar-exclamation:before {\r\n    content: \"\\ea1a\";\r\n  }\r\n  .bx-calendar-heart:before {\r\n    content: \"\\ea1b\";\r\n  }\r\n  .bx-calendar-minus:before {\r\n    content: \"\\ea1c\";\r\n  }\r\n  .bx-calendar-plus:before {\r\n    content: \"\\ea1d\";\r\n  }\r\n  .bx-calendar-star:before {\r\n    content: \"\\ea1e\";\r\n  }\r\n  .bx-calendar-week:before {\r\n    content: \"\\ea1f\";\r\n  }\r\n  .bx-calendar-x:before {\r\n    content: \"\\ea20\";\r\n  }\r\n  .bx-camera:before {\r\n    content: \"\\ea21\";\r\n  }\r\n  .bx-camera-home:before {\r\n    content: \"\\ea22\";\r\n  }\r\n  .bx-camera-movie:before {\r\n    content: \"\\ea23\";\r\n  }\r\n  .bx-camera-off:before {\r\n    content: \"\\ea24\";\r\n  }\r\n  .bx-capsule:before {\r\n    content: \"\\ea25\";\r\n  }\r\n  .bx-captions:before {\r\n    content: \"\\ea26\";\r\n  }\r\n  .bx-car:before {\r\n    content: \"\\ea27\";\r\n  }\r\n  .bx-card:before {\r\n    content: \"\\ea28\";\r\n  }\r\n  .bx-caret-down:before {\r\n    content: \"\\ea29\";\r\n  }\r\n  .bx-caret-down-circle:before {\r\n    content: \"\\ea2a\";\r\n  }\r\n  .bx-caret-down-square:before {\r\n    content: \"\\ea2b\";\r\n  }\r\n  .bx-caret-left:before {\r\n    content: \"\\ea2c\";\r\n  }\r\n  .bx-caret-left-circle:before {\r\n    content: \"\\ea2d\";\r\n  }\r\n  .bx-caret-left-square:before {\r\n    content: \"\\ea2e\";\r\n  }\r\n  .bx-caret-right:before {\r\n    content: \"\\ea2f\";\r\n  }\r\n  .bx-caret-right-circle:before {\r\n    content: \"\\ea30\";\r\n  }\r\n  .bx-caret-right-square:before {\r\n    content: \"\\ea31\";\r\n  }\r\n  .bx-caret-up:before {\r\n    content: \"\\ea32\";\r\n  }\r\n  .bx-caret-up-circle:before {\r\n    content: \"\\ea33\";\r\n  }\r\n  .bx-caret-up-square:before {\r\n    content: \"\\ea34\";\r\n  }\r\n  .bx-carousel:before {\r\n    content: \"\\ea35\";\r\n  }\r\n  .bx-cart:before {\r\n    content: \"\\ea36\";\r\n  }\r\n  .bx-cart-alt:before {\r\n    content: \"\\ea37\";\r\n  }\r\n  .bx-cast:before {\r\n    content: \"\\ea38\";\r\n  }\r\n  .bx-category:before {\r\n    content: \"\\ea39\";\r\n  }\r\n  .bx-category-alt:before {\r\n    content: \"\\ea3a\";\r\n  }\r\n  .bx-cctv:before {\r\n    content: \"\\ea3b\";\r\n  }\r\n  .bx-certification:before {\r\n    content: \"\\ea3c\";\r\n  }\r\n  .bx-chair:before {\r\n    content: \"\\ea3d\";\r\n  }\r\n  .bx-chalkboard:before {\r\n    content: \"\\ea3e\";\r\n  }\r\n  .bx-chart:before {\r\n    content: \"\\ea3f\";\r\n  }\r\n  .bx-chat:before {\r\n    content: \"\\ea40\";\r\n  }\r\n  .bx-check:before {\r\n    content: \"\\ea41\";\r\n  }\r\n  .bx-checkbox:before {\r\n    content: \"\\ea42\";\r\n  }\r\n  .bx-checkbox-checked:before {\r\n    content: \"\\ea43\";\r\n  }\r\n  .bx-checkbox-minus:before {\r\n    content: \"\\ea44\";\r\n  }\r\n  .bx-checkbox-square:before {\r\n    content: \"\\ea45\";\r\n  }\r\n  .bx-check-circle:before {\r\n    content: \"\\ea46\";\r\n  }\r\n  .bx-check-double:before {\r\n    content: \"\\ea47\";\r\n  }\r\n  .bx-check-shield:before {\r\n    content: \"\\ea48\";\r\n  }\r\n  .bx-check-square:before {\r\n    content: \"\\ea49\";\r\n  }\r\n  .bx-chevron-down:before {\r\n    content: \"\\ea4a\";\r\n  }\r\n  .bx-chevron-down-circle:before {\r\n    content: \"\\ea4b\";\r\n  }\r\n  .bx-chevron-down-square:before {\r\n    content: \"\\ea4c\";\r\n  }\r\n  .bx-chevron-left:before {\r\n    content: \"\\ea4d\";\r\n  }\r\n  .bx-chevron-left-circle:before {\r\n    content: \"\\ea4e\";\r\n  }\r\n  .bx-chevron-left-square:before {\r\n    content: \"\\ea4f\";\r\n  }\r\n  .bx-chevron-right:before {\r\n    content: \"\\ea50\";\r\n  }\r\n  .bx-chevron-right-circle:before {\r\n    content: \"\\ea51\";\r\n  }\r\n  .bx-chevron-right-square:before {\r\n    content: \"\\ea52\";\r\n  }\r\n  .bx-chevrons-down:before {\r\n    content: \"\\ea53\";\r\n  }\r\n  .bx-chevrons-left:before {\r\n    content: \"\\ea54\";\r\n  }\r\n  .bx-chevrons-right:before {\r\n    content: \"\\ea55\";\r\n  }\r\n  .bx-chevrons-up:before {\r\n    content: \"\\ea56\";\r\n  }\r\n  .bx-chevron-up:before {\r\n    content: \"\\ea57\";\r\n  }\r\n  .bx-chevron-up-circle:before {\r\n    content: \"\\ea58\";\r\n  }\r\n  .bx-chevron-up-square:before {\r\n    content: \"\\ea59\";\r\n  }\r\n  .bx-chip:before {\r\n    content: \"\\ea5a\";\r\n  }\r\n  .bx-church:before {\r\n    content: \"\\ea5b\";\r\n  }\r\n  .bx-circle:before {\r\n    content: \"\\ea5c\";\r\n  }\r\n  .bx-clinic:before {\r\n    content: \"\\ea5d\";\r\n  }\r\n  .bx-clipboard:before {\r\n    content: \"\\ea5e\";\r\n  }\r\n  .bx-closet:before {\r\n    content: \"\\ea5f\";\r\n  }\r\n  .bx-cloud:before {\r\n    content: \"\\ea60\";\r\n  }\r\n  .bx-cloud-download:before {\r\n    content: \"\\ea61\";\r\n  }\r\n  .bx-cloud-drizzle:before {\r\n    content: \"\\ea62\";\r\n  }\r\n  .bx-cloud-lightning:before {\r\n    content: \"\\ea63\";\r\n  }\r\n  .bx-cloud-light-rain:before {\r\n    content: \"\\ea64\";\r\n  }\r\n  .bx-cloud-rain:before {\r\n    content: \"\\ea65\";\r\n  }\r\n  .bx-cloud-snow:before {\r\n    content: \"\\ea66\";\r\n  }\r\n  .bx-cloud-upload:before {\r\n    content: \"\\ea67\";\r\n  }\r\n  .bx-code:before {\r\n    content: \"\\ea68\";\r\n  }\r\n  .bx-code-alt:before {\r\n    content: \"\\ea69\";\r\n  }\r\n  .bx-code-block:before {\r\n    content: \"\\ea6a\";\r\n  }\r\n  .bx-code-curly:before {\r\n    content: \"\\ea6b\";\r\n  }\r\n  .bx-coffee:before {\r\n    content: \"\\ea6c\";\r\n  }\r\n  .bx-coffee-togo:before {\r\n    content: \"\\ea6d\";\r\n  }\r\n  .bx-cog:before {\r\n    content: \"\\ea6e\";\r\n  }\r\n  .bx-coin:before {\r\n    content: \"\\ea6f\";\r\n  }\r\n  .bx-coin-stack:before {\r\n    content: \"\\ea70\";\r\n  }\r\n  .bx-collapse:before {\r\n    content: \"\\ea71\";\r\n  }\r\n  .bx-collection:before {\r\n    content: \"\\ea72\";\r\n  }\r\n  .bx-color-fill:before {\r\n    content: \"\\ea73\";\r\n  }\r\n  .bx-columns:before {\r\n    content: \"\\ea74\";\r\n  }\r\n  .bx-command:before {\r\n    content: \"\\ea75\";\r\n  }\r\n  .bx-comment:before {\r\n    content: \"\\ea76\";\r\n  }\r\n  .bx-comment-add:before {\r\n    content: \"\\ea77\";\r\n  }\r\n  .bx-comment-check:before {\r\n    content: \"\\ea78\";\r\n  }\r\n  .bx-comment-detail:before {\r\n    content: \"\\ea79\";\r\n  }\r\n  .bx-comment-dots:before {\r\n    content: \"\\ea7a\";\r\n  }\r\n  .bx-comment-edit:before {\r\n    content: \"\\ea7b\";\r\n  }\r\n  .bx-comment-error:before {\r\n    content: \"\\ea7c\";\r\n  }\r\n  .bx-comment-minus:before {\r\n    content: \"\\ea7d\";\r\n  }\r\n  .bx-comment-x:before {\r\n    content: \"\\ea7e\";\r\n  }\r\n  .bx-compass:before {\r\n    content: \"\\ea7f\";\r\n  }\r\n  .bx-confused:before {\r\n    content: \"\\ea80\";\r\n  }\r\n  .bx-conversation:before {\r\n    content: \"\\ea81\";\r\n  }\r\n  .bx-cookie:before {\r\n    content: \"\\ea82\";\r\n  }\r\n  .bx-cool:before {\r\n    content: \"\\ea83\";\r\n  }\r\n  .bx-copy:before {\r\n    content: \"\\ea84\";\r\n  }\r\n  .bx-copy-alt:before {\r\n    content: \"\\ea85\";\r\n  }\r\n  .bx-copyright:before {\r\n    content: \"\\ea86\";\r\n  }\r\n  .bx-credit-card:before {\r\n    content: \"\\ea87\";\r\n  }\r\n  .bx-credit-card-alt:before {\r\n    content: \"\\ea88\";\r\n  }\r\n  .bx-credit-card-front:before {\r\n    content: \"\\ea89\";\r\n  }\r\n  .bx-crop:before {\r\n    content: \"\\ea8a\";\r\n  }\r\n  .bx-crosshair:before {\r\n    content: \"\\ea8b\";\r\n  }\r\n  .bx-crown:before {\r\n    content: \"\\ea8c\";\r\n  }\r\n  .bx-cube:before {\r\n    content: \"\\ea8d\";\r\n  }\r\n  .bx-cube-alt:before {\r\n    content: \"\\ea8e\";\r\n  }\r\n  .bx-cuboid:before {\r\n    content: \"\\ea8f\";\r\n  }\r\n  .bx-current-location:before {\r\n    content: \"\\ea90\";\r\n  }\r\n  .bx-customize:before {\r\n    content: \"\\ea91\";\r\n  }\r\n  .bx-cut:before {\r\n    content: \"\\ea92\";\r\n  }\r\n  .bx-cycling:before {\r\n    content: \"\\ea93\";\r\n  }\r\n  .bx-cylinder:before {\r\n    content: \"\\ea94\";\r\n  }\r\n  .bx-data:before {\r\n    content: \"\\ea95\";\r\n  }\r\n  .bx-desktop:before {\r\n    content: \"\\ea96\";\r\n  }\r\n  .bx-detail:before {\r\n    content: \"\\ea97\";\r\n  }\r\n  .bx-devices:before {\r\n    content: \"\\ea98\";\r\n  }\r\n  .bx-dialpad:before {\r\n    content: \"\\ea99\";\r\n  }\r\n  .bx-dialpad-alt:before {\r\n    content: \"\\ea9a\";\r\n  }\r\n  .bx-diamond:before {\r\n    content: \"\\ea9b\";\r\n  }\r\n  .bx-dice-1:before {\r\n    content: \"\\ea9c\";\r\n  }\r\n  .bx-dice-2:before {\r\n    content: \"\\ea9d\";\r\n  }\r\n  .bx-dice-3:before {\r\n    content: \"\\ea9e\";\r\n  }\r\n  .bx-dice-4:before {\r\n    content: \"\\ea9f\";\r\n  }\r\n  .bx-dice-5:before {\r\n    content: \"\\eaa0\";\r\n  }\r\n  .bx-dice-6:before {\r\n    content: \"\\eaa1\";\r\n  }\r\n  .bx-directions:before {\r\n    content: \"\\eaa2\";\r\n  }\r\n  .bx-disc:before {\r\n    content: \"\\eaa3\";\r\n  }\r\n  .bx-dish:before {\r\n    content: \"\\eaa4\";\r\n  }\r\n  .bx-dislike:before {\r\n    content: \"\\eaa5\";\r\n  }\r\n  .bx-dizzy:before {\r\n    content: \"\\eaa6\";\r\n  }\r\n  .bx-dna:before {\r\n    content: \"\\eaa7\";\r\n  }\r\n  .bx-dock-bottom:before {\r\n    content: \"\\eaa8\";\r\n  }\r\n  .bx-dock-left:before {\r\n    content: \"\\eaa9\";\r\n  }\r\n  .bx-dock-right:before {\r\n    content: \"\\eaaa\";\r\n  }\r\n  .bx-dock-top:before {\r\n    content: \"\\eaab\";\r\n  }\r\n  .bx-dollar:before {\r\n    content: \"\\eaac\";\r\n  }\r\n  .bx-dollar-circle:before {\r\n    content: \"\\eaad\";\r\n  }\r\n  .bx-donate-blood:before {\r\n    content: \"\\eaae\";\r\n  }\r\n  .bx-donate-heart:before {\r\n    content: \"\\eaaf\";\r\n  }\r\n  .bx-door-open:before {\r\n    content: \"\\eab0\";\r\n  }\r\n  .bx-dots-horizontal:before {\r\n    content: \"\\eab1\";\r\n  }\r\n  .bx-dots-horizontal-rounded:before {\r\n    content: \"\\eab2\";\r\n  }\r\n  .bx-dots-vertical:before {\r\n    content: \"\\eab3\";\r\n  }\r\n  .bx-dots-vertical-rounded:before {\r\n    content: \"\\eab4\";\r\n  }\r\n  .bx-doughnut-chart:before {\r\n    content: \"\\eab5\";\r\n  }\r\n  .bx-down-arrow:before {\r\n    content: \"\\eab6\";\r\n  }\r\n  .bx-down-arrow-alt:before {\r\n    content: \"\\eab7\";\r\n  }\r\n  .bx-down-arrow-circle:before {\r\n    content: \"\\eab8\";\r\n  }\r\n  .bx-download:before {\r\n    content: \"\\eab9\";\r\n  }\r\n  .bx-downvote:before {\r\n    content: \"\\eaba\";\r\n  }\r\n  .bx-drink:before {\r\n    content: \"\\eabb\";\r\n  }\r\n  .bx-droplet:before {\r\n    content: \"\\eabc\";\r\n  }\r\n  .bx-dumbbell:before {\r\n    content: \"\\eabd\";\r\n  }\r\n  .bx-duplicate:before {\r\n    content: \"\\eabe\";\r\n  }\r\n  .bx-edit:before {\r\n    content: \"\\eabf\";\r\n  }\r\n  .bx-edit-alt:before {\r\n    content: \"\\eac0\";\r\n  }\r\n  .bx-envelope:before {\r\n    content: \"\\eac1\";\r\n  }\r\n  .bx-envelope-open:before {\r\n    content: \"\\eac2\";\r\n  }\r\n  .bx-equalizer:before {\r\n    content: \"\\eac3\";\r\n  }\r\n  .bx-eraser:before {\r\n    content: \"\\eac4\";\r\n  }\r\n  .bx-error:before {\r\n    content: \"\\eac5\";\r\n  }\r\n  .bx-error-alt:before {\r\n    content: \"\\eac6\";\r\n  }\r\n  .bx-error-circle:before {\r\n    content: \"\\eac7\";\r\n  }\r\n  .bx-euro:before {\r\n    content: \"\\eac8\";\r\n  }\r\n  .bx-exclude:before {\r\n    content: \"\\eac9\";\r\n  }\r\n  .bx-exit:before {\r\n    content: \"\\eaca\";\r\n  }\r\n  .bx-exit-fullscreen:before {\r\n    content: \"\\eacb\";\r\n  }\r\n  .bx-expand:before {\r\n    content: \"\\eacc\";\r\n  }\r\n  .bx-expand-alt:before {\r\n    content: \"\\eacd\";\r\n  }\r\n  .bx-export:before {\r\n    content: \"\\eace\";\r\n  }\r\n  .bx-extension:before {\r\n    content: \"\\eacf\";\r\n  }\r\n  .bx-face:before {\r\n    content: \"\\ead0\";\r\n  }\r\n  .bx-fast-forward:before {\r\n    content: \"\\ead1\";\r\n  }\r\n  .bx-fast-forward-circle:before {\r\n    content: \"\\ead2\";\r\n  }\r\n  .bx-female:before {\r\n    content: \"\\ead3\";\r\n  }\r\n  .bx-female-sign:before {\r\n    content: \"\\ead4\";\r\n  }\r\n  .bx-file:before {\r\n    content: \"\\ead5\";\r\n  }\r\n  .bx-file-blank:before {\r\n    content: \"\\ead6\";\r\n  }\r\n  .bx-file-find:before {\r\n    content: \"\\ead7\";\r\n  }\r\n  .bx-film:before {\r\n    content: \"\\ead8\";\r\n  }\r\n  .bx-filter:before {\r\n    content: \"\\ead9\";\r\n  }\r\n  .bx-filter-alt:before {\r\n    content: \"\\eada\";\r\n  }\r\n  .bx-fingerprint:before {\r\n    content: \"\\eadb\";\r\n  }\r\n  .bx-first-aid:before {\r\n    content: \"\\eadc\";\r\n  }\r\n  .bx-first-page:before {\r\n    content: \"\\eadd\";\r\n  }\r\n  .bx-flag:before {\r\n    content: \"\\eade\";\r\n  }\r\n  .bx-folder:before {\r\n    content: \"\\eadf\";\r\n  }\r\n  .bx-folder-minus:before {\r\n    content: \"\\eae0\";\r\n  }\r\n  .bx-folder-open:before {\r\n    content: \"\\eae1\";\r\n  }\r\n  .bx-folder-plus:before {\r\n    content: \"\\eae2\";\r\n  }\r\n  .bx-font:before {\r\n    content: \"\\eae3\";\r\n  }\r\n  .bx-font-color:before {\r\n    content: \"\\eae4\";\r\n  }\r\n  .bx-font-family:before {\r\n    content: \"\\eae5\";\r\n  }\r\n  .bx-font-size:before {\r\n    content: \"\\eae6\";\r\n  }\r\n  .bx-food-menu:before {\r\n    content: \"\\eae7\";\r\n  }\r\n  .bx-food-tag:before {\r\n    content: \"\\eae8\";\r\n  }\r\n  .bx-football:before {\r\n    content: \"\\eae9\";\r\n  }\r\n  .bx-fridge:before {\r\n    content: \"\\eaea\";\r\n  }\r\n  .bx-fullscreen:before {\r\n    content: \"\\eaeb\";\r\n  }\r\n  .bx-game:before {\r\n    content: \"\\eaec\";\r\n  }\r\n  .bx-gas-pump:before {\r\n    content: \"\\eaed\";\r\n  }\r\n  .bx-ghost:before {\r\n    content: \"\\eaee\";\r\n  }\r\n  .bx-gift:before {\r\n    content: \"\\eaef\";\r\n  }\r\n  .bx-git-branch:before {\r\n    content: \"\\eaf0\";\r\n  }\r\n  .bx-git-commit:before {\r\n    content: \"\\eaf1\";\r\n  }\r\n  .bx-git-compare:before {\r\n    content: \"\\eaf2\";\r\n  }\r\n  .bx-git-merge:before {\r\n    content: \"\\eaf3\";\r\n  }\r\n  .bx-git-pull-request:before {\r\n    content: \"\\eaf4\";\r\n  }\r\n  .bx-git-repo-forked:before {\r\n    content: \"\\eaf5\";\r\n  }\r\n  .bx-glasses:before {\r\n    content: \"\\eaf6\";\r\n  }\r\n  .bx-glasses-alt:before {\r\n    content: \"\\eaf7\";\r\n  }\r\n  .bx-globe:before {\r\n    content: \"\\eaf8\";\r\n  }\r\n  .bx-globe-alt:before {\r\n    content: \"\\eaf9\";\r\n  }\r\n  .bx-grid:before {\r\n    content: \"\\eafa\";\r\n  }\r\n  .bx-grid-alt:before {\r\n    content: \"\\eafb\";\r\n  }\r\n  .bx-grid-horizontal:before {\r\n    content: \"\\eafc\";\r\n  }\r\n  .bx-grid-small:before {\r\n    content: \"\\eafd\";\r\n  }\r\n  .bx-grid-vertical:before {\r\n    content: \"\\eafe\";\r\n  }\r\n  .bx-group:before {\r\n    content: \"\\eaff\";\r\n  }\r\n  .bx-handicap:before {\r\n    content: \"\\eb00\";\r\n  }\r\n  .bx-happy:before {\r\n    content: \"\\eb01\";\r\n  }\r\n  .bx-happy-alt:before {\r\n    content: \"\\eb02\";\r\n  }\r\n  .bx-happy-beaming:before {\r\n    content: \"\\eb03\";\r\n  }\r\n  .bx-happy-heart-eyes:before {\r\n    content: \"\\eb04\";\r\n  }\r\n  .bx-hash:before {\r\n    content: \"\\eb05\";\r\n  }\r\n  .bx-hdd:before {\r\n    content: \"\\eb06\";\r\n  }\r\n  .bx-heading:before {\r\n    content: \"\\eb07\";\r\n  }\r\n  .bx-headphone:before {\r\n    content: \"\\eb08\";\r\n  }\r\n  .bx-health:before {\r\n    content: \"\\eb09\";\r\n  }\r\n  .bx-heart:before {\r\n    content: \"\\eb0a\";\r\n  }\r\n  .bx-heart-circle:before {\r\n    content: \"\\eb0b\";\r\n  }\r\n  .bx-heart-square:before {\r\n    content: \"\\eb0c\";\r\n  }\r\n  .bx-help-circle:before {\r\n    content: \"\\eb0d\";\r\n  }\r\n  .bx-hide:before {\r\n    content: \"\\eb0e\";\r\n  }\r\n  .bx-highlight:before {\r\n    content: \"\\eb0f\";\r\n  }\r\n  .bx-history:before {\r\n    content: \"\\eb10\";\r\n  }\r\n  .bx-hive:before {\r\n    content: \"\\eb11\";\r\n  }\r\n  .bx-home:before {\r\n    content: \"\\eb12\";\r\n  }\r\n  .bx-home-alt:before {\r\n    content: \"\\eb13\";\r\n  }\r\n  .bx-home-circle:before {\r\n    content: \"\\eb14\";\r\n  }\r\n  .bx-home-heart:before {\r\n    content: \"\\eb15\";\r\n  }\r\n  .bx-home-smile:before {\r\n    content: \"\\eb16\";\r\n  }\r\n  .bx-horizontal-center:before {\r\n    content: \"\\eb17\";\r\n  }\r\n  .bx-hotel:before {\r\n    content: \"\\eb18\";\r\n  }\r\n  .bx-hourglass:before {\r\n    content: \"\\eb19\";\r\n  }\r\n  .bx-id-card:before {\r\n    content: \"\\eb1a\";\r\n  }\r\n  .bx-image:before {\r\n    content: \"\\eb1b\";\r\n  }\r\n  .bx-image-add:before {\r\n    content: \"\\eb1c\";\r\n  }\r\n  .bx-image-alt:before {\r\n    content: \"\\eb1d\";\r\n  }\r\n  .bx-images:before {\r\n    content: \"\\eb1e\";\r\n  }\r\n  .bx-import:before {\r\n    content: \"\\eb1f\";\r\n  }\r\n  .bx-infinite:before {\r\n    content: \"\\eb20\";\r\n  }\r\n  .bx-info-circle:before {\r\n    content: \"\\eb21\";\r\n  }\r\n  .bx-info-square:before {\r\n    content: \"\\eb22\";\r\n  }\r\n  .bx-intersect:before {\r\n    content: \"\\eb23\";\r\n  }\r\n  .bx-italic:before {\r\n    content: \"\\eb24\";\r\n  }\r\n  .bx-joystick:before {\r\n    content: \"\\eb25\";\r\n  }\r\n  .bx-joystick-alt:before {\r\n    content: \"\\eb26\";\r\n  }\r\n  .bx-joystick-button:before {\r\n    content: \"\\eb27\";\r\n  }\r\n  .bx-key:before {\r\n    content: \"\\eb28\";\r\n  }\r\n  .bx-label:before {\r\n    content: \"\\eb29\";\r\n  }\r\n  .bx-landscape:before {\r\n    content: \"\\eb2a\";\r\n  }\r\n  .bx-laptop:before {\r\n    content: \"\\eb2b\";\r\n  }\r\n  .bx-last-page:before {\r\n    content: \"\\eb2c\";\r\n  }\r\n  .bx-laugh:before {\r\n    content: \"\\eb2d\";\r\n  }\r\n  .bx-layer:before {\r\n    content: \"\\eb2e\";\r\n  }\r\n  .bx-layer-minus:before {\r\n    content: \"\\eb2f\";\r\n  }\r\n  .bx-layer-plus:before {\r\n    content: \"\\eb30\";\r\n  }\r\n  .bx-layout:before {\r\n    content: \"\\eb31\";\r\n  }\r\n  .bx-left-arrow:before {\r\n    content: \"\\eb32\";\r\n  }\r\n  .bx-left-arrow-alt:before {\r\n    content: \"\\eb33\";\r\n  }\r\n  .bx-left-arrow-circle:before {\r\n    content: \"\\eb34\";\r\n  }\r\n  .bx-left-down-arrow-circle:before {\r\n    content: \"\\eb35\";\r\n  }\r\n  .bx-left-indent:before {\r\n    content: \"\\eb36\";\r\n  }\r\n  .bx-left-top-arrow-circle:before {\r\n    content: \"\\eb37\";\r\n  }\r\n  .bx-library:before {\r\n    content: \"\\eb38\";\r\n  }\r\n  .bx-like:before {\r\n    content: \"\\eb39\";\r\n  }\r\n  .bx-line-chart:before {\r\n    content: \"\\eb3a\";\r\n  }\r\n  .bx-line-chart-down:before {\r\n    content: \"\\eb3b\";\r\n  }\r\n  .bx-link:before {\r\n    content: \"\\eb3c\";\r\n  }\r\n  .bx-link-alt:before {\r\n    content: \"\\eb3d\";\r\n  }\r\n  .bx-link-external:before {\r\n    content: \"\\eb3e\";\r\n  }\r\n  .bx-lira:before {\r\n    content: \"\\eb3f\";\r\n  }\r\n  .bx-list-check:before {\r\n    content: \"\\eb40\";\r\n  }\r\n  .bx-list-minus:before {\r\n    content: \"\\eb41\";\r\n  }\r\n  .bx-list-ol:before {\r\n    content: \"\\eb42\";\r\n  }\r\n  .bx-list-plus:before {\r\n    content: \"\\eb43\";\r\n  }\r\n  .bx-list-ul:before {\r\n    content: \"\\eb44\";\r\n  }\r\n  .bx-loader:before {\r\n    content: \"\\eb45\";\r\n  }\r\n  .bx-loader-alt:before {\r\n    content: \"\\eb46\";\r\n  }\r\n  .bx-loader-circle:before {\r\n    content: \"\\eb47\";\r\n  }\r\n  .bx-location-plus:before {\r\n    content: \"\\eb48\";\r\n  }\r\n  .bx-lock:before {\r\n    content: \"\\eb49\";\r\n  }\r\n  .bx-lock-alt:before {\r\n    content: \"\\eb4a\";\r\n  }\r\n  .bx-lock-open:before {\r\n    content: \"\\eb4b\";\r\n  }\r\n  .bx-lock-open-alt:before {\r\n    content: \"\\eb4c\";\r\n  }\r\n  .bx-log-in:before {\r\n    content: \"\\eb4d\";\r\n  }\r\n  .bx-log-in-circle:before {\r\n    content: \"\\eb4e\";\r\n  }\r\n  .bx-log-out:before {\r\n    content: \"\\eb4f\";\r\n  }\r\n  .bx-log-out-circle:before {\r\n    content: \"\\eb50\";\r\n  }\r\n  .bx-low-vision:before {\r\n    content: \"\\eb51\";\r\n  }\r\n  .bx-magnet:before {\r\n    content: \"\\eb52\";\r\n  }\r\n  .bx-mail-send:before {\r\n    content: \"\\eb53\";\r\n  }\r\n  .bx-male:before {\r\n    content: \"\\eb54\";\r\n  }\r\n  .bx-male-sign:before {\r\n    content: \"\\eb55\";\r\n  }\r\n  .bx-map:before {\r\n    content: \"\\eb56\";\r\n  }\r\n  .bx-map-alt:before {\r\n    content: \"\\eb57\";\r\n  }\r\n  .bx-map-pin:before {\r\n    content: \"\\eb58\";\r\n  }\r\n  .bx-mask:before {\r\n    content: \"\\eb59\";\r\n  }\r\n  .bx-medal:before {\r\n    content: \"\\eb5a\";\r\n  }\r\n  .bx-meh:before {\r\n    content: \"\\eb5b\";\r\n  }\r\n  .bx-meh-alt:before {\r\n    content: \"\\eb5c\";\r\n  }\r\n  .bx-meh-blank:before {\r\n    content: \"\\eb5d\";\r\n  }\r\n  .bx-memory-card:before {\r\n    content: \"\\eb5e\";\r\n  }\r\n  .bx-menu:before {\r\n    content: \"\\eb5f\";\r\n  }\r\n  .bx-menu-alt-left:before {\r\n    content: \"\\eb60\";\r\n  }\r\n  .bx-menu-alt-right:before {\r\n    content: \"\\eb61\";\r\n  }\r\n  .bx-merge:before {\r\n    content: \"\\eb62\";\r\n  }\r\n  .bx-message:before {\r\n    content: \"\\eb63\";\r\n  }\r\n  .bx-message-add:before {\r\n    content: \"\\eb64\";\r\n  }\r\n  .bx-message-alt:before {\r\n    content: \"\\eb65\";\r\n  }\r\n  .bx-message-alt-add:before {\r\n    content: \"\\eb66\";\r\n  }\r\n  .bx-message-alt-check:before {\r\n    content: \"\\eb67\";\r\n  }\r\n  .bx-message-alt-detail:before {\r\n    content: \"\\eb68\";\r\n  }\r\n  .bx-message-alt-dots:before {\r\n    content: \"\\eb69\";\r\n  }\r\n  .bx-message-alt-edit:before {\r\n    content: \"\\eb6a\";\r\n  }\r\n  .bx-message-alt-error:before {\r\n    content: \"\\eb6b\";\r\n  }\r\n  .bx-message-alt-minus:before {\r\n    content: \"\\eb6c\";\r\n  }\r\n  .bx-message-alt-x:before {\r\n    content: \"\\eb6d\";\r\n  }\r\n  .bx-message-check:before {\r\n    content: \"\\eb6e\";\r\n  }\r\n  .bx-message-detail:before {\r\n    content: \"\\eb6f\";\r\n  }\r\n  .bx-message-dots:before {\r\n    content: \"\\eb70\";\r\n  }\r\n  .bx-message-edit:before {\r\n    content: \"\\eb71\";\r\n  }\r\n  .bx-message-error:before {\r\n    content: \"\\eb72\";\r\n  }\r\n  .bx-message-minus:before {\r\n    content: \"\\eb73\";\r\n  }\r\n  .bx-message-rounded:before {\r\n    content: \"\\eb74\";\r\n  }\r\n  .bx-message-rounded-add:before {\r\n    content: \"\\eb75\";\r\n  }\r\n  .bx-message-rounded-check:before {\r\n    content: \"\\eb76\";\r\n  }\r\n  .bx-message-rounded-detail:before {\r\n    content: \"\\eb77\";\r\n  }\r\n  .bx-message-rounded-dots:before {\r\n    content: \"\\eb78\";\r\n  }\r\n  .bx-message-rounded-edit:before {\r\n    content: \"\\eb79\";\r\n  }\r\n  .bx-message-rounded-error:before {\r\n    content: \"\\eb7a\";\r\n  }\r\n  .bx-message-rounded-minus:before {\r\n    content: \"\\eb7b\";\r\n  }\r\n  .bx-message-rounded-x:before {\r\n    content: \"\\eb7c\";\r\n  }\r\n  .bx-message-square:before {\r\n    content: \"\\eb7d\";\r\n  }\r\n  .bx-message-square-add:before {\r\n    content: \"\\eb7e\";\r\n  }\r\n  .bx-message-square-check:before {\r\n    content: \"\\eb7f\";\r\n  }\r\n  .bx-message-square-detail:before {\r\n    content: \"\\eb80\";\r\n  }\r\n  .bx-message-square-dots:before {\r\n    content: \"\\eb81\";\r\n  }\r\n  .bx-message-square-edit:before {\r\n    content: \"\\eb82\";\r\n  }\r\n  .bx-message-square-error:before {\r\n    content: \"\\eb83\";\r\n  }\r\n  .bx-message-square-minus:before {\r\n    content: \"\\eb84\";\r\n  }\r\n  .bx-message-square-x:before {\r\n    content: \"\\eb85\";\r\n  }\r\n  .bx-message-x:before {\r\n    content: \"\\eb86\";\r\n  }\r\n  .bx-meteor:before {\r\n    content: \"\\eb87\";\r\n  }\r\n  .bx-microchip:before {\r\n    content: \"\\eb88\";\r\n  }\r\n  .bx-microphone:before {\r\n    content: \"\\eb89\";\r\n  }\r\n  .bx-microphone-off:before {\r\n    content: \"\\eb8a\";\r\n  }\r\n  .bx-minus:before {\r\n    content: \"\\eb8b\";\r\n  }\r\n  .bx-minus-back:before {\r\n    content: \"\\eb8c\";\r\n  }\r\n  .bx-minus-circle:before {\r\n    content: \"\\eb8d\";\r\n  }\r\n  .bx-minus-front:before {\r\n    content: \"\\eb8e\";\r\n  }\r\n  .bx-mobile:before {\r\n    content: \"\\eb8f\";\r\n  }\r\n  .bx-mobile-alt:before {\r\n    content: \"\\eb90\";\r\n  }\r\n  .bx-mobile-landscape:before {\r\n    content: \"\\eb91\";\r\n  }\r\n  .bx-mobile-vibration:before {\r\n    content: \"\\eb92\";\r\n  }\r\n  .bx-money:before {\r\n    content: \"\\eb93\";\r\n  }\r\n  .bx-moon:before {\r\n    content: \"\\eb94\";\r\n  }\r\n  .bx-mouse:before {\r\n    content: \"\\eb95\";\r\n  }\r\n  .bx-mouse-alt:before {\r\n    content: \"\\eb96\";\r\n  }\r\n  .bx-move:before {\r\n    content: \"\\eb97\";\r\n  }\r\n  .bx-move-horizontal:before {\r\n    content: \"\\eb98\";\r\n  }\r\n  .bx-move-vertical:before {\r\n    content: \"\\eb99\";\r\n  }\r\n  .bx-movie:before {\r\n    content: \"\\eb9a\";\r\n  }\r\n  .bx-movie-play:before {\r\n    content: \"\\eb9b\";\r\n  }\r\n  .bx-music:before {\r\n    content: \"\\eb9c\";\r\n  }\r\n  .bx-navigation:before {\r\n    content: \"\\eb9d\";\r\n  }\r\n  .bx-network-chart:before {\r\n    content: \"\\eb9e\";\r\n  }\r\n  .bx-news:before {\r\n    content: \"\\eb9f\";\r\n  }\r\n  .bx-no-entry:before {\r\n    content: \"\\eba0\";\r\n  }\r\n  .bx-note:before {\r\n    content: \"\\eba1\";\r\n  }\r\n  .bx-notepad:before {\r\n    content: \"\\eba2\";\r\n  }\r\n  .bx-notification:before {\r\n    content: \"\\eba3\";\r\n  }\r\n  .bx-notification-off:before {\r\n    content: \"\\eba4\";\r\n  }\r\n  .bx-outline:before {\r\n    content: \"\\eba5\";\r\n  }\r\n  .bx-package:before {\r\n    content: \"\\eba6\";\r\n  }\r\n  .bx-paint:before {\r\n    content: \"\\eba7\";\r\n  }\r\n  .bx-paint-roll:before {\r\n    content: \"\\eba8\";\r\n  }\r\n  .bx-palette:before {\r\n    content: \"\\eba9\";\r\n  }\r\n  .bx-paperclip:before {\r\n    content: \"\\ebaa\";\r\n  }\r\n  .bx-paper-plane:before {\r\n    content: \"\\ebab\";\r\n  }\r\n  .bx-paragraph:before {\r\n    content: \"\\ebac\";\r\n  }\r\n  .bx-paste:before {\r\n    content: \"\\ebad\";\r\n  }\r\n  .bx-pause:before {\r\n    content: \"\\ebae\";\r\n  }\r\n  .bx-pause-circle:before {\r\n    content: \"\\ebaf\";\r\n  }\r\n  .bx-pen:before {\r\n    content: \"\\ebb0\";\r\n  }\r\n  .bx-pencil:before {\r\n    content: \"\\ebb1\";\r\n  }\r\n  .bx-phone:before {\r\n    content: \"\\ebb2\";\r\n  }\r\n  .bx-phone-call:before {\r\n    content: \"\\ebb3\";\r\n  }\r\n  .bx-phone-incoming:before {\r\n    content: \"\\ebb4\";\r\n  }\r\n  .bx-phone-off:before {\r\n    content: \"\\ebb5\";\r\n  }\r\n  .bx-phone-outgoing:before {\r\n    content: \"\\ebb6\";\r\n  }\r\n  .bx-photo-album:before {\r\n    content: \"\\ebb7\";\r\n  }\r\n  .bx-pie-chart:before {\r\n    content: \"\\ebb8\";\r\n  }\r\n  .bx-pie-chart-alt:before {\r\n    content: \"\\ebb9\";\r\n  }\r\n  .bx-pie-chart-alt-2:before {\r\n    content: \"\\ebba\";\r\n  }\r\n  .bx-pin:before {\r\n    content: \"\\ebbb\";\r\n  }\r\n  .bx-planet:before {\r\n    content: \"\\ebbc\";\r\n  }\r\n  .bx-play:before {\r\n    content: \"\\ebbd\";\r\n  }\r\n  .bx-play-circle:before {\r\n    content: \"\\ebbe\";\r\n  }\r\n  .bx-plug:before {\r\n    content: \"\\ebbf\";\r\n  }\r\n  .bx-plus:before {\r\n    content: \"\\ebc0\";\r\n  }\r\n  .bx-plus-circle:before {\r\n    content: \"\\ebc1\";\r\n  }\r\n  .bx-plus-medical:before {\r\n    content: \"\\ebc2\";\r\n  }\r\n  .bx-podcast:before {\r\n    content: \"\\ebc3\";\r\n  }\r\n  .bx-pointer:before {\r\n    content: \"\\ebc4\";\r\n  }\r\n  .bx-poll:before {\r\n    content: \"\\ebc5\";\r\n  }\r\n  .bx-polygon:before {\r\n    content: \"\\ebc6\";\r\n  }\r\n  .bx-pound:before {\r\n    content: \"\\ebc7\";\r\n  }\r\n  .bx-power-off:before {\r\n    content: \"\\ebc8\";\r\n  }\r\n  .bx-printer:before {\r\n    content: \"\\ebc9\";\r\n  }\r\n  .bx-pulse:before {\r\n    content: \"\\ebca\";\r\n  }\r\n  .bx-purchase-tag:before {\r\n    content: \"\\ebcb\";\r\n  }\r\n  .bx-purchase-tag-alt:before {\r\n    content: \"\\ebcc\";\r\n  }\r\n  .bx-pyramid:before {\r\n    content: \"\\ebcd\";\r\n  }\r\n  .bx-qr:before {\r\n    content: \"\\ebce\";\r\n  }\r\n  .bx-qr-scan:before {\r\n    content: \"\\ebcf\";\r\n  }\r\n  .bx-question-mark:before {\r\n    content: \"\\ebd0\";\r\n  }\r\n  .bx-radar:before {\r\n    content: \"\\ebd1\";\r\n  }\r\n  .bx-radio:before {\r\n    content: \"\\ebd2\";\r\n  }\r\n  .bx-radio-circle:before {\r\n    content: \"\\ebd3\";\r\n  }\r\n  .bx-radio-circle-marked:before {\r\n    content: \"\\ebd4\";\r\n  }\r\n  .bx-receipt:before {\r\n    content: \"\\ebd5\";\r\n  }\r\n  .bx-rectangle:before {\r\n    content: \"\\ebd6\";\r\n  }\r\n  .bx-recycle:before {\r\n    content: \"\\ebd7\";\r\n  }\r\n  .bx-redo:before {\r\n    content: \"\\ebd8\";\r\n  }\r\n  .bx-refresh:before {\r\n    content: \"\\ebd9\";\r\n  }\r\n  .bx-registered:before {\r\n    content: \"\\ebda\";\r\n  }\r\n  .bx-rename:before {\r\n    content: \"\\ebdb\";\r\n  }\r\n  .bx-repeat:before {\r\n    content: \"\\ebdc\";\r\n  }\r\n  .bx-reply:before {\r\n    content: \"\\ebdd\";\r\n  }\r\n  .bx-reply-all:before {\r\n    content: \"\\ebde\";\r\n  }\r\n  .bx-repost:before {\r\n    content: \"\\ebdf\";\r\n  }\r\n  .bx-reset:before {\r\n    content: \"\\ebe0\";\r\n  }\r\n  .bx-restaurant:before {\r\n    content: \"\\ebe1\";\r\n  }\r\n  .bx-revision:before {\r\n    content: \"\\ebe2\";\r\n  }\r\n  .bx-rewind:before {\r\n    content: \"\\ebe3\";\r\n  }\r\n  .bx-rewind-circle:before {\r\n    content: \"\\ebe4\";\r\n  }\r\n  .bx-right-arrow:before {\r\n    content: \"\\ebe5\";\r\n  }\r\n  .bx-right-arrow-alt:before {\r\n    content: \"\\ebe6\";\r\n  }\r\n  .bx-right-arrow-circle:before {\r\n    content: \"\\ebe7\";\r\n  }\r\n  .bx-right-down-arrow-circle:before {\r\n    content: \"\\ebe8\";\r\n  }\r\n  .bx-right-indent:before {\r\n    content: \"\\ebe9\";\r\n  }\r\n  .bx-right-top-arrow-circle:before {\r\n    content: \"\\ebea\";\r\n  }\r\n  .bx-rocket:before {\r\n    content: \"\\ebeb\";\r\n  }\r\n  .bx-rotate-left:before {\r\n    content: \"\\ebec\";\r\n  }\r\n  .bx-rotate-right:before {\r\n    content: \"\\ebed\";\r\n  }\r\n  .bx-rss:before {\r\n    content: \"\\ebee\";\r\n  }\r\n  .bx-ruble:before {\r\n    content: \"\\ebef\";\r\n  }\r\n  .bx-ruler:before {\r\n    content: \"\\ebf0\";\r\n  }\r\n  .bx-run:before {\r\n    content: \"\\ebf1\";\r\n  }\r\n  .bx-rupee:before {\r\n    content: \"\\ebf2\";\r\n  }\r\n  .bx-sad:before {\r\n    content: \"\\ebf3\";\r\n  }\r\n  .bx-save:before {\r\n    content: \"\\ebf4\";\r\n  }\r\n  .bx-scan:before {\r\n    content: \"\\ebf5\";\r\n  }\r\n  .bx-screenshot:before {\r\n    content: \"\\ebf6\";\r\n  }\r\n  .bx-search:before {\r\n    content: \"\\ebf7\";\r\n  }\r\n  .bx-search-alt:before {\r\n    content: \"\\ebf8\";\r\n  }\r\n  .bx-search-alt-2:before {\r\n    content: \"\\ebf9\";\r\n  }\r\n  .bx-selection:before {\r\n    content: \"\\ebfa\";\r\n  }\r\n  .bx-select-multiple:before {\r\n    content: \"\\ebfb\";\r\n  }\r\n  .bx-send:before {\r\n    content: \"\\ebfc\";\r\n  }\r\n  .bx-server:before {\r\n    content: \"\\ebfd\";\r\n  }\r\n  .bx-shape-circle:before {\r\n    content: \"\\ebfe\";\r\n  }\r\n  .bx-shape-polygon:before {\r\n    content: \"\\ebff\";\r\n  }\r\n  .bx-shape-square:before {\r\n    content: \"\\ec00\";\r\n  }\r\n  .bx-shape-triangle:before {\r\n    content: \"\\ec01\";\r\n  }\r\n  .bx-share:before {\r\n    content: \"\\ec02\";\r\n  }\r\n  .bx-share-alt:before {\r\n    content: \"\\ec03\";\r\n  }\r\n  .bx-shekel:before {\r\n    content: \"\\ec04\";\r\n  }\r\n  .bx-shield:before {\r\n    content: \"\\ec05\";\r\n  }\r\n  .bx-shield-alt:before {\r\n    content: \"\\ec06\";\r\n  }\r\n  .bx-shield-alt-2:before {\r\n    content: \"\\ec07\";\r\n  }\r\n  .bx-shield-quarter:before {\r\n    content: \"\\ec08\";\r\n  }\r\n  .bx-shield-x:before {\r\n    content: \"\\ec09\";\r\n  }\r\n  .bx-shocked:before {\r\n    content: \"\\ec0a\";\r\n  }\r\n  .bx-shopping-bag:before {\r\n    content: \"\\ec0b\";\r\n  }\r\n  .bx-show:before {\r\n    content: \"\\ec0c\";\r\n  }\r\n  .bx-show-alt:before {\r\n    content: \"\\ec0d\";\r\n  }\r\n  .bx-shuffle:before {\r\n    content: \"\\ec0e\";\r\n  }\r\n  .bx-sidebar:before {\r\n    content: \"\\ec0f\";\r\n  }\r\n  .bx-sitemap:before {\r\n    content: \"\\ec10\";\r\n  }\r\n  .bx-skip-next:before {\r\n    content: \"\\ec11\";\r\n  }\r\n  .bx-skip-next-circle:before {\r\n    content: \"\\ec12\";\r\n  }\r\n  .bx-skip-previous:before {\r\n    content: \"\\ec13\";\r\n  }\r\n  .bx-skip-previous-circle:before {\r\n    content: \"\\ec14\";\r\n  }\r\n  .bx-sleepy:before {\r\n    content: \"\\ec15\";\r\n  }\r\n  .bx-slider:before {\r\n    content: \"\\ec16\";\r\n  }\r\n  .bx-slider-alt:before {\r\n    content: \"\\ec17\";\r\n  }\r\n  .bx-slideshow:before {\r\n    content: \"\\ec18\";\r\n  }\r\n  .bx-smile:before {\r\n    content: \"\\ec19\";\r\n  }\r\n  .bx-sort:before {\r\n    content: \"\\ec1a\";\r\n  }\r\n  .bx-sort-alt-2:before {\r\n    content: \"\\ec1b\";\r\n  }\r\n  .bx-sort-a-z:before {\r\n    content: \"\\ec1c\";\r\n  }\r\n  .bx-sort-down:before {\r\n    content: \"\\ec1d\";\r\n  }\r\n  .bx-sort-up:before {\r\n    content: \"\\ec1e\";\r\n  }\r\n  .bx-sort-z-a:before {\r\n    content: \"\\ec1f\";\r\n  }\r\n  .bx-spa:before {\r\n    content: \"\\ec20\";\r\n  }\r\n  .bx-space-bar:before {\r\n    content: \"\\ec21\";\r\n  }\r\n  .bx-speaker:before {\r\n    content: \"\\ec22\";\r\n  }\r\n  .bx-spray-can:before {\r\n    content: \"\\ec23\";\r\n  }\r\n  .bx-spreadsheet:before {\r\n    content: \"\\ec24\";\r\n  }\r\n  .bx-square:before {\r\n    content: \"\\ec25\";\r\n  }\r\n  .bx-square-rounded:before {\r\n    content: \"\\ec26\";\r\n  }\r\n  .bx-star:before {\r\n    content: \"\\ec27\";\r\n  }\r\n  .bx-station:before {\r\n    content: \"\\ec28\";\r\n  }\r\n  .bx-stats:before {\r\n    content: \"\\ec29\";\r\n  }\r\n  .bx-sticker:before {\r\n    content: \"\\ec2a\";\r\n  }\r\n  .bx-stop:before {\r\n    content: \"\\ec2b\";\r\n  }\r\n  .bx-stop-circle:before {\r\n    content: \"\\ec2c\";\r\n  }\r\n  .bx-stopwatch:before {\r\n    content: \"\\ec2d\";\r\n  }\r\n  .bx-store:before {\r\n    content: \"\\ec2e\";\r\n  }\r\n  .bx-store-alt:before {\r\n    content: \"\\ec2f\";\r\n  }\r\n  .bx-street-view:before {\r\n    content: \"\\ec30\";\r\n  }\r\n  .bx-strikethrough:before {\r\n    content: \"\\ec31\";\r\n  }\r\n  .bx-subdirectory-left:before {\r\n    content: \"\\ec32\";\r\n  }\r\n  .bx-subdirectory-right:before {\r\n    content: \"\\ec33\";\r\n  }\r\n  .bx-sun:before {\r\n    content: \"\\ec34\";\r\n  }\r\n  .bx-support:before {\r\n    content: \"\\ec35\";\r\n  }\r\n  .bx-swim:before {\r\n    content: \"\\ec36\";\r\n  }\r\n  .bx-sync:before {\r\n    content: \"\\ec37\";\r\n  }\r\n  .bx-tab:before {\r\n    content: \"\\ec38\";\r\n  }\r\n  .bx-table:before {\r\n    content: \"\\ec39\";\r\n  }\r\n  .bx-tachometer:before {\r\n    content: \"\\ec3a\";\r\n  }\r\n  .bx-tag:before {\r\n    content: \"\\ec3b\";\r\n  }\r\n  .bx-tag-alt:before {\r\n    content: \"\\ec3c\";\r\n  }\r\n  .bx-target-lock:before {\r\n    content: \"\\ec3d\";\r\n  }\r\n  .bx-task:before {\r\n    content: \"\\ec3e\";\r\n  }\r\n  .bx-task-x:before {\r\n    content: \"\\ec3f\";\r\n  }\r\n  .bx-taxi:before {\r\n    content: \"\\ec40\";\r\n  }\r\n  .bx-tennis-ball:before {\r\n    content: \"\\ec41\";\r\n  }\r\n  .bx-terminal:before {\r\n    content: \"\\ec42\";\r\n  }\r\n  .bx-test-tube:before {\r\n    content: \"\\ec43\";\r\n  }\r\n  .bx-text:before {\r\n    content: \"\\ec44\";\r\n  }\r\n  .bx-time:before {\r\n    content: \"\\ec45\";\r\n  }\r\n  .bx-time-five:before {\r\n    content: \"\\ec46\";\r\n  }\r\n  .bx-timer:before {\r\n    content: \"\\ec47\";\r\n  }\r\n  .bx-tired:before {\r\n    content: \"\\ec48\";\r\n  }\r\n  .bx-toggle-left:before {\r\n    content: \"\\ec49\";\r\n  }\r\n  .bx-toggle-right:before {\r\n    content: \"\\ec4a\";\r\n  }\r\n  .bx-tone:before {\r\n    content: \"\\ec4b\";\r\n  }\r\n  .bx-traffic-cone:before {\r\n    content: \"\\ec4c\";\r\n  }\r\n  .bx-train:before {\r\n    content: \"\\ec4d\";\r\n  }\r\n  .bx-transfer:before {\r\n    content: \"\\ec4e\";\r\n  }\r\n  .bx-transfer-alt:before {\r\n    content: \"\\ec4f\";\r\n  }\r\n  .bx-trash:before {\r\n    content: \"\\ec50\";\r\n  }\r\n  .bx-trash-alt:before {\r\n    content: \"\\ec51\";\r\n  }\r\n  .bx-trending-down:before {\r\n    content: \"\\ec52\";\r\n  }\r\n  .bx-trending-up:before {\r\n    content: \"\\ec53\";\r\n  }\r\n  .bx-trim:before {\r\n    content: \"\\ec54\";\r\n  }\r\n  .bx-trip:before {\r\n    content: \"\\ec55\";\r\n  }\r\n  .bx-trophy:before {\r\n    content: \"\\ec56\";\r\n  }\r\n  .bx-tv:before {\r\n    content: \"\\ec57\";\r\n  }\r\n  .bx-underline:before {\r\n    content: \"\\ec58\";\r\n  }\r\n  .bx-undo:before {\r\n    content: \"\\ec59\";\r\n  }\r\n  .bx-unite:before {\r\n    content: \"\\ec5a\";\r\n  }\r\n  .bx-unlink:before {\r\n    content: \"\\ec5b\";\r\n  }\r\n  .bx-up-arrow:before {\r\n    content: \"\\ec5c\";\r\n  }\r\n  .bx-up-arrow-alt:before {\r\n    content: \"\\ec5d\";\r\n  }\r\n  .bx-up-arrow-circle:before {\r\n    content: \"\\ec5e\";\r\n  }\r\n  .bx-upload:before {\r\n    content: \"\\ec5f\";\r\n  }\r\n  .bx-upside-down:before {\r\n    content: \"\\ec60\";\r\n  }\r\n  .bx-upvote:before {\r\n    content: \"\\ec61\";\r\n  }\r\n  .bx-usb:before {\r\n    content: \"\\ec62\";\r\n  }\r\n  .bx-user:before {\r\n    content: \"\\ec63\";\r\n  }\r\n  .bx-user-check:before {\r\n    content: \"\\ec64\";\r\n  }\r\n  .bx-user-circle:before {\r\n    content: \"\\ec65\";\r\n  }\r\n  .bx-user-minus:before {\r\n    content: \"\\ec66\";\r\n  }\r\n  .bx-user-pin:before {\r\n    content: \"\\ec67\";\r\n  }\r\n  .bx-user-plus:before {\r\n    content: \"\\ec68\";\r\n  }\r\n  .bx-user-voice:before {\r\n    content: \"\\ec69\";\r\n  }\r\n  .bx-user-x:before {\r\n    content: \"\\ec6a\";\r\n  }\r\n  .bx-vector:before {\r\n    content: \"\\ec6b\";\r\n  }\r\n  .bx-vertical-center:before {\r\n    content: \"\\ec6c\";\r\n  }\r\n  .bx-vial:before {\r\n    content: \"\\ec6d\";\r\n  }\r\n  .bx-video:before {\r\n    content: \"\\ec6e\";\r\n  }\r\n  .bx-video-off:before {\r\n    content: \"\\ec6f\";\r\n  }\r\n  .bx-video-plus:before {\r\n    content: \"\\ec70\";\r\n  }\r\n  .bx-video-recording:before {\r\n    content: \"\\ec71\";\r\n  }\r\n  .bx-voicemail:before {\r\n    content: \"\\ec72\";\r\n  }\r\n  .bx-volume:before {\r\n    content: \"\\ec73\";\r\n  }\r\n  .bx-volume-full:before {\r\n    content: \"\\ec74\";\r\n  }\r\n  .bx-volume-low:before {\r\n    content: \"\\ec75\";\r\n  }\r\n  .bx-volume-mute:before {\r\n    content: \"\\ec76\";\r\n  }\r\n  .bx-walk:before {\r\n    content: \"\\ec77\";\r\n  }\r\n  .bx-wallet:before {\r\n    content: \"\\ec78\";\r\n  }\r\n  .bx-wallet-alt:before {\r\n    content: \"\\ec79\";\r\n  }\r\n  .bx-water:before {\r\n    content: \"\\ec7a\";\r\n  }\r\n  .bx-webcam:before {\r\n    content: \"\\ec7b\";\r\n  }\r\n  .bx-wifi:before {\r\n    content: \"\\ec7c\";\r\n  }\r\n  .bx-wifi-0:before {\r\n    content: \"\\ec7d\";\r\n  }\r\n  .bx-wifi-1:before {\r\n    content: \"\\ec7e\";\r\n  }\r\n  .bx-wifi-2:before {\r\n    content: \"\\ec7f\";\r\n  }\r\n  .bx-wifi-off:before {\r\n    content: \"\\ec80\";\r\n  }\r\n  .bx-wind:before {\r\n    content: \"\\ec81\";\r\n  }\r\n  .bx-window:before {\r\n    content: \"\\ec82\";\r\n  }\r\n  .bx-window-alt:before {\r\n    content: \"\\ec83\";\r\n  }\r\n  .bx-window-close:before {\r\n    content: \"\\ec84\";\r\n  }\r\n  .bx-window-open:before {\r\n    content: \"\\ec85\";\r\n  }\r\n  .bx-windows:before {\r\n    content: \"\\ec86\";\r\n  }\r\n  .bx-wine:before {\r\n    content: \"\\ec87\";\r\n  }\r\n  .bx-wink-smile:before {\r\n    content: \"\\ec88\";\r\n  }\r\n  .bx-wink-tongue:before {\r\n    content: \"\\ec89\";\r\n  }\r\n  .bx-won:before {\r\n    content: \"\\ec8a\";\r\n  }\r\n  .bx-world:before {\r\n    content: \"\\ec8b\";\r\n  }\r\n  .bx-wrench:before {\r\n    content: \"\\ec8c\";\r\n  }\r\n  .bx-x:before {\r\n    content: \"\\ec8d\";\r\n  }\r\n  .bx-x-circle:before {\r\n    content: \"\\ec8e\";\r\n  }\r\n  .bx-yen:before {\r\n    content: \"\\ec8f\";\r\n  }\r\n  .bx-zoom-in:before {\r\n    content: \"\\ec90\";\r\n  }\r\n  .bx-zoom-out:before {\r\n    content: \"\\ec91\";\r\n  }\r\n  .bxs-party:before {\r\n    content: \"\\ec92\";\r\n  }\r\n  .bxs-hot:before {\r\n    content: \"\\ec93\";\r\n  }\r\n  .bxs-droplet:before {\r\n    content: \"\\ec94\";\r\n  }\r\n  .bxs-cat:before {\r\n    content: \"\\ec95\";\r\n  }\r\n  .bxs-dog:before {\r\n    content: \"\\ec96\";\r\n  }\r\n  .bxs-injection:before {\r\n    content: \"\\ec97\";\r\n  }\r\n  .bxs-leaf:before {\r\n    content: \"\\ec98\";\r\n  }\r\n  .bxs-add-to-queue:before {\r\n    content: \"\\ec99\";\r\n  }\r\n  .bxs-adjust:before {\r\n    content: \"\\ec9a\";\r\n  }\r\n  .bxs-adjust-alt:before {\r\n    content: \"\\ec9b\";\r\n  }\r\n  .bxs-alarm:before {\r\n    content: \"\\ec9c\";\r\n  }\r\n  .bxs-alarm-add:before {\r\n    content: \"\\ec9d\";\r\n  }\r\n  .bxs-alarm-exclamation:before {\r\n    content: \"\\ec9e\";\r\n  }\r\n  .bxs-alarm-off:before {\r\n    content: \"\\ec9f\";\r\n  }\r\n  .bxs-alarm-snooze:before {\r\n    content: \"\\eca0\";\r\n  }\r\n  .bxs-album:before {\r\n    content: \"\\eca1\";\r\n  }\r\n  .bxs-ambulance:before {\r\n    content: \"\\eca2\";\r\n  }\r\n  .bxs-analyse:before {\r\n    content: \"\\eca3\";\r\n  }\r\n  .bxs-angry:before {\r\n    content: \"\\eca4\";\r\n  }\r\n  .bxs-arch:before {\r\n    content: \"\\eca5\";\r\n  }\r\n  .bxs-archive:before {\r\n    content: \"\\eca6\";\r\n  }\r\n  .bxs-archive-in:before {\r\n    content: \"\\eca7\";\r\n  }\r\n  .bxs-archive-out:before {\r\n    content: \"\\eca8\";\r\n  }\r\n  .bxs-area:before {\r\n    content: \"\\eca9\";\r\n  }\r\n  .bxs-arrow-from-bottom:before {\r\n    content: \"\\ecaa\";\r\n  }\r\n  .bxs-arrow-from-left:before {\r\n    content: \"\\ecab\";\r\n  }\r\n  .bxs-arrow-from-right:before {\r\n    content: \"\\ecac\";\r\n  }\r\n  .bxs-arrow-from-top:before {\r\n    content: \"\\ecad\";\r\n  }\r\n  .bxs-arrow-to-bottom:before {\r\n    content: \"\\ecae\";\r\n  }\r\n  .bxs-arrow-to-left:before {\r\n    content: \"\\ecaf\";\r\n  }\r\n  .bxs-arrow-to-right:before {\r\n    content: \"\\ecb0\";\r\n  }\r\n  .bxs-arrow-to-top:before {\r\n    content: \"\\ecb1\";\r\n  }\r\n  .bxs-award:before {\r\n    content: \"\\ecb2\";\r\n  }\r\n  .bxs-baby-carriage:before {\r\n    content: \"\\ecb3\";\r\n  }\r\n  .bxs-backpack:before {\r\n    content: \"\\ecb4\";\r\n  }\r\n  .bxs-badge:before {\r\n    content: \"\\ecb5\";\r\n  }\r\n  .bxs-badge-check:before {\r\n    content: \"\\ecb6\";\r\n  }\r\n  .bxs-badge-dollar:before {\r\n    content: \"\\ecb7\";\r\n  }\r\n  .bxs-ball:before {\r\n    content: \"\\ecb8\";\r\n  }\r\n  .bxs-band-aid:before {\r\n    content: \"\\ecb9\";\r\n  }\r\n  .bxs-bank:before {\r\n    content: \"\\ecba\";\r\n  }\r\n  .bxs-bar-chart-alt-2:before {\r\n    content: \"\\ecbb\";\r\n  }\r\n  .bxs-bar-chart-square:before {\r\n    content: \"\\ecbc\";\r\n  }\r\n  .bxs-barcode:before {\r\n    content: \"\\ecbd\";\r\n  }\r\n  .bxs-baseball:before {\r\n    content: \"\\ecbe\";\r\n  }\r\n  .bxs-basket:before {\r\n    content: \"\\ecbf\";\r\n  }\r\n  .bxs-basketball:before {\r\n    content: \"\\ecc0\";\r\n  }\r\n  .bxs-bath:before {\r\n    content: \"\\ecc1\";\r\n  }\r\n  .bxs-battery:before {\r\n    content: \"\\ecc2\";\r\n  }\r\n  .bxs-battery-charging:before {\r\n    content: \"\\ecc3\";\r\n  }\r\n  .bxs-battery-full:before {\r\n    content: \"\\ecc4\";\r\n  }\r\n  .bxs-battery-low:before {\r\n    content: \"\\ecc5\";\r\n  }\r\n  .bxs-bed:before {\r\n    content: \"\\ecc6\";\r\n  }\r\n  .bxs-been-here:before {\r\n    content: \"\\ecc7\";\r\n  }\r\n  .bxs-beer:before {\r\n    content: \"\\ecc8\";\r\n  }\r\n  .bxs-bell:before {\r\n    content: \"\\ecc9\";\r\n  }\r\n  .bxs-bell-minus:before {\r\n    content: \"\\ecca\";\r\n  }\r\n  .bxs-bell-off:before {\r\n    content: \"\\eccb\";\r\n  }\r\n  .bxs-bell-plus:before {\r\n    content: \"\\eccc\";\r\n  }\r\n  .bxs-bell-ring:before {\r\n    content: \"\\eccd\";\r\n  }\r\n  .bxs-bible:before {\r\n    content: \"\\ecce\";\r\n  }\r\n  .bxs-binoculars:before {\r\n    content: \"\\eccf\";\r\n  }\r\n  .bxs-blanket:before {\r\n    content: \"\\ecd0\";\r\n  }\r\n  .bxs-bolt:before {\r\n    content: \"\\ecd1\";\r\n  }\r\n  .bxs-bolt-circle:before {\r\n    content: \"\\ecd2\";\r\n  }\r\n  .bxs-bomb:before {\r\n    content: \"\\ecd3\";\r\n  }\r\n  .bxs-bone:before {\r\n    content: \"\\ecd4\";\r\n  }\r\n  .bxs-bong:before {\r\n    content: \"\\ecd5\";\r\n  }\r\n  .bxs-book:before {\r\n    content: \"\\ecd6\";\r\n  }\r\n  .bxs-book-add:before {\r\n    content: \"\\ecd7\";\r\n  }\r\n  .bxs-book-alt:before {\r\n    content: \"\\ecd8\";\r\n  }\r\n  .bxs-book-bookmark:before {\r\n    content: \"\\ecd9\";\r\n  }\r\n  .bxs-book-content:before {\r\n    content: \"\\ecda\";\r\n  }\r\n  .bxs-book-heart:before {\r\n    content: \"\\ecdb\";\r\n  }\r\n  .bxs-bookmark:before {\r\n    content: \"\\ecdc\";\r\n  }\r\n  .bxs-bookmark-alt:before {\r\n    content: \"\\ecdd\";\r\n  }\r\n  .bxs-bookmark-alt-minus:before {\r\n    content: \"\\ecde\";\r\n  }\r\n  .bxs-bookmark-alt-plus:before {\r\n    content: \"\\ecdf\";\r\n  }\r\n  .bxs-bookmark-heart:before {\r\n    content: \"\\ece0\";\r\n  }\r\n  .bxs-bookmark-minus:before {\r\n    content: \"\\ece1\";\r\n  }\r\n  .bxs-bookmark-plus:before {\r\n    content: \"\\ece2\";\r\n  }\r\n  .bxs-bookmarks:before {\r\n    content: \"\\ece3\";\r\n  }\r\n  .bxs-bookmark-star:before {\r\n    content: \"\\ece4\";\r\n  }\r\n  .bxs-book-open:before {\r\n    content: \"\\ece5\";\r\n  }\r\n  .bxs-book-reader:before {\r\n    content: \"\\ece6\";\r\n  }\r\n  .bxs-bot:before {\r\n    content: \"\\ece7\";\r\n  }\r\n  .bxs-bowling-ball:before {\r\n    content: \"\\ece8\";\r\n  }\r\n  .bxs-box:before {\r\n    content: \"\\ece9\";\r\n  }\r\n  .bxs-brain:before {\r\n    content: \"\\ecea\";\r\n  }\r\n  .bxs-briefcase:before {\r\n    content: \"\\eceb\";\r\n  }\r\n  .bxs-briefcase-alt:before {\r\n    content: \"\\ecec\";\r\n  }\r\n  .bxs-briefcase-alt-2:before {\r\n    content: \"\\eced\";\r\n  }\r\n  .bxs-brightness:before {\r\n    content: \"\\ecee\";\r\n  }\r\n  .bxs-brightness-half:before {\r\n    content: \"\\ecef\";\r\n  }\r\n  .bxs-brush:before {\r\n    content: \"\\ecf0\";\r\n  }\r\n  .bxs-brush-alt:before {\r\n    content: \"\\ecf1\";\r\n  }\r\n  .bxs-bug:before {\r\n    content: \"\\ecf2\";\r\n  }\r\n  .bxs-bug-alt:before {\r\n    content: \"\\ecf3\";\r\n  }\r\n  .bxs-building:before {\r\n    content: \"\\ecf4\";\r\n  }\r\n  .bxs-building-house:before {\r\n    content: \"\\ecf5\";\r\n  }\r\n  .bxs-buildings:before {\r\n    content: \"\\ecf6\";\r\n  }\r\n  .bxs-bulb:before {\r\n    content: \"\\ecf7\";\r\n  }\r\n  .bxs-bullseye:before {\r\n    content: \"\\ecf8\";\r\n  }\r\n  .bxs-buoy:before {\r\n    content: \"\\ecf9\";\r\n  }\r\n  .bxs-bus:before {\r\n    content: \"\\ecfa\";\r\n  }\r\n  .bxs-business:before {\r\n    content: \"\\ecfb\";\r\n  }\r\n  .bxs-bus-school:before {\r\n    content: \"\\ecfc\";\r\n  }\r\n  .bxs-cabinet:before {\r\n    content: \"\\ecfd\";\r\n  }\r\n  .bxs-cake:before {\r\n    content: \"\\ecfe\";\r\n  }\r\n  .bxs-calculator:before {\r\n    content: \"\\ecff\";\r\n  }\r\n  .bxs-calendar:before {\r\n    content: \"\\ed00\";\r\n  }\r\n  .bxs-calendar-alt:before {\r\n    content: \"\\ed01\";\r\n  }\r\n  .bxs-calendar-check:before {\r\n    content: \"\\ed02\";\r\n  }\r\n  .bxs-calendar-edit:before {\r\n    content: \"\\ed03\";\r\n  }\r\n  .bxs-calendar-event:before {\r\n    content: \"\\ed04\";\r\n  }\r\n  .bxs-calendar-exclamation:before {\r\n    content: \"\\ed05\";\r\n  }\r\n  .bxs-calendar-heart:before {\r\n    content: \"\\ed06\";\r\n  }\r\n  .bxs-calendar-minus:before {\r\n    content: \"\\ed07\";\r\n  }\r\n  .bxs-calendar-plus:before {\r\n    content: \"\\ed08\";\r\n  }\r\n  .bxs-calendar-star:before {\r\n    content: \"\\ed09\";\r\n  }\r\n  .bxs-calendar-week:before {\r\n    content: \"\\ed0a\";\r\n  }\r\n  .bxs-calendar-x:before {\r\n    content: \"\\ed0b\";\r\n  }\r\n  .bxs-camera:before {\r\n    content: \"\\ed0c\";\r\n  }\r\n  .bxs-camera-home:before {\r\n    content: \"\\ed0d\";\r\n  }\r\n  .bxs-camera-movie:before {\r\n    content: \"\\ed0e\";\r\n  }\r\n  .bxs-camera-off:before {\r\n    content: \"\\ed0f\";\r\n  }\r\n  .bxs-camera-plus:before {\r\n    content: \"\\ed10\";\r\n  }\r\n  .bxs-capsule:before {\r\n    content: \"\\ed11\";\r\n  }\r\n  .bxs-captions:before {\r\n    content: \"\\ed12\";\r\n  }\r\n  .bxs-car:before {\r\n    content: \"\\ed13\";\r\n  }\r\n  .bxs-car-battery:before {\r\n    content: \"\\ed14\";\r\n  }\r\n  .bxs-car-crash:before {\r\n    content: \"\\ed15\";\r\n  }\r\n  .bxs-card:before {\r\n    content: \"\\ed16\";\r\n  }\r\n  .bxs-caret-down-circle:before {\r\n    content: \"\\ed17\";\r\n  }\r\n  .bxs-caret-down-square:before {\r\n    content: \"\\ed18\";\r\n  }\r\n  .bxs-caret-left-circle:before {\r\n    content: \"\\ed19\";\r\n  }\r\n  .bxs-caret-left-square:before {\r\n    content: \"\\ed1a\";\r\n  }\r\n  .bxs-caret-right-circle:before {\r\n    content: \"\\ed1b\";\r\n  }\r\n  .bxs-caret-right-square:before {\r\n    content: \"\\ed1c\";\r\n  }\r\n  .bxs-caret-up-circle:before {\r\n    content: \"\\ed1d\";\r\n  }\r\n  .bxs-caret-up-square:before {\r\n    content: \"\\ed1e\";\r\n  }\r\n  .bxs-car-garage:before {\r\n    content: \"\\ed1f\";\r\n  }\r\n  .bxs-car-mechanic:before {\r\n    content: \"\\ed20\";\r\n  }\r\n  .bxs-carousel:before {\r\n    content: \"\\ed21\";\r\n  }\r\n  .bxs-cart:before {\r\n    content: \"\\ed22\";\r\n  }\r\n  .bxs-cart-add:before {\r\n    content: \"\\ed23\";\r\n  }\r\n  .bxs-cart-alt:before {\r\n    content: \"\\ed24\";\r\n  }\r\n  .bxs-cart-download:before {\r\n    content: \"\\ed25\";\r\n  }\r\n  .bxs-car-wash:before {\r\n    content: \"\\ed26\";\r\n  }\r\n  .bxs-category:before {\r\n    content: \"\\ed27\";\r\n  }\r\n  .bxs-category-alt:before {\r\n    content: \"\\ed28\";\r\n  }\r\n  .bxs-cctv:before {\r\n    content: \"\\ed29\";\r\n  }\r\n  .bxs-certification:before {\r\n    content: \"\\ed2a\";\r\n  }\r\n  .bxs-chalkboard:before {\r\n    content: \"\\ed2b\";\r\n  }\r\n  .bxs-chart:before {\r\n    content: \"\\ed2c\";\r\n  }\r\n  .bxs-chat:before {\r\n    content: \"\\ed2d\";\r\n  }\r\n  .bxs-checkbox:before {\r\n    content: \"\\ed2e\";\r\n  }\r\n  .bxs-checkbox-checked:before {\r\n    content: \"\\ed2f\";\r\n  }\r\n  .bxs-checkbox-minus:before {\r\n    content: \"\\ed30\";\r\n  }\r\n  .bxs-check-circle:before {\r\n    content: \"\\ed31\";\r\n  }\r\n  .bxs-check-shield:before {\r\n    content: \"\\ed32\";\r\n  }\r\n  .bxs-check-square:before {\r\n    content: \"\\ed33\";\r\n  }\r\n  .bxs-chess:before {\r\n    content: \"\\ed34\";\r\n  }\r\n  .bxs-chevron-down:before {\r\n    content: \"\\ed35\";\r\n  }\r\n  .bxs-chevron-down-circle:before {\r\n    content: \"\\ed36\";\r\n  }\r\n  .bxs-chevron-down-square:before {\r\n    content: \"\\ed37\";\r\n  }\r\n  .bxs-chevron-left:before {\r\n    content: \"\\ed38\";\r\n  }\r\n  .bxs-chevron-left-circle:before {\r\n    content: \"\\ed39\";\r\n  }\r\n  .bxs-chevron-left-square:before {\r\n    content: \"\\ed3a\";\r\n  }\r\n  .bxs-chevron-right:before {\r\n    content: \"\\ed3b\";\r\n  }\r\n  .bxs-chevron-right-circle:before {\r\n    content: \"\\ed3c\";\r\n  }\r\n  .bxs-chevron-right-square:before {\r\n    content: \"\\ed3d\";\r\n  }\r\n  .bxs-chevrons-down:before {\r\n    content: \"\\ed3e\";\r\n  }\r\n  .bxs-chevrons-left:before {\r\n    content: \"\\ed3f\";\r\n  }\r\n  .bxs-chevrons-right:before {\r\n    content: \"\\ed40\";\r\n  }\r\n  .bxs-chevrons-up:before {\r\n    content: \"\\ed41\";\r\n  }\r\n  .bxs-chevron-up:before {\r\n    content: \"\\ed42\";\r\n  }\r\n  .bxs-chevron-up-circle:before {\r\n    content: \"\\ed43\";\r\n  }\r\n  .bxs-chevron-up-square:before {\r\n    content: \"\\ed44\";\r\n  }\r\n  .bxs-chip:before {\r\n    content: \"\\ed45\";\r\n  }\r\n  .bxs-church:before {\r\n    content: \"\\ed46\";\r\n  }\r\n  .bxs-circle:before {\r\n    content: \"\\ed47\";\r\n  }\r\n  .bxs-city:before {\r\n    content: \"\\ed48\";\r\n  }\r\n  .bxs-clinic:before {\r\n    content: \"\\ed49\";\r\n  }\r\n  .bxs-cloud:before {\r\n    content: \"\\ed4a\";\r\n  }\r\n  .bxs-cloud-download:before {\r\n    content: \"\\ed4b\";\r\n  }\r\n  .bxs-cloud-lightning:before {\r\n    content: \"\\ed4c\";\r\n  }\r\n  .bxs-cloud-rain:before {\r\n    content: \"\\ed4d\";\r\n  }\r\n  .bxs-cloud-upload:before {\r\n    content: \"\\ed4e\";\r\n  }\r\n  .bxs-coffee:before {\r\n    content: \"\\ed4f\";\r\n  }\r\n  .bxs-coffee-alt:before {\r\n    content: \"\\ed50\";\r\n  }\r\n  .bxs-coffee-togo:before {\r\n    content: \"\\ed51\";\r\n  }\r\n  .bxs-cog:before {\r\n    content: \"\\ed52\";\r\n  }\r\n  .bxs-coin:before {\r\n    content: \"\\ed53\";\r\n  }\r\n  .bxs-coin-stack:before {\r\n    content: \"\\ed54\";\r\n  }\r\n  .bxs-collection:before {\r\n    content: \"\\ed55\";\r\n  }\r\n  .bxs-color-fill:before {\r\n    content: \"\\ed56\";\r\n  }\r\n  .bxs-comment:before {\r\n    content: \"\\ed57\";\r\n  }\r\n  .bxs-comment-add:before {\r\n    content: \"\\ed58\";\r\n  }\r\n  .bxs-comment-check:before {\r\n    content: \"\\ed59\";\r\n  }\r\n  .bxs-comment-detail:before {\r\n    content: \"\\ed5a\";\r\n  }\r\n  .bxs-comment-dots:before {\r\n    content: \"\\ed5b\";\r\n  }\r\n  .bxs-comment-edit:before {\r\n    content: \"\\ed5c\";\r\n  }\r\n  .bxs-comment-error:before {\r\n    content: \"\\ed5d\";\r\n  }\r\n  .bxs-comment-minus:before {\r\n    content: \"\\ed5e\";\r\n  }\r\n  .bxs-comment-x:before {\r\n    content: \"\\ed5f\";\r\n  }\r\n  .bxs-compass:before {\r\n    content: \"\\ed60\";\r\n  }\r\n  .bxs-component:before {\r\n    content: \"\\ed61\";\r\n  }\r\n  .bxs-confused:before {\r\n    content: \"\\ed62\";\r\n  }\r\n  .bxs-contact:before {\r\n    content: \"\\ed63\";\r\n  }\r\n  .bxs-conversation:before {\r\n    content: \"\\ed64\";\r\n  }\r\n  .bxs-cookie:before {\r\n    content: \"\\ed65\";\r\n  }\r\n  .bxs-cool:before {\r\n    content: \"\\ed66\";\r\n  }\r\n  .bxs-copy:before {\r\n    content: \"\\ed67\";\r\n  }\r\n  .bxs-copy-alt:before {\r\n    content: \"\\ed68\";\r\n  }\r\n  .bxs-copyright:before {\r\n    content: \"\\ed69\";\r\n  }\r\n  .bxs-coupon:before {\r\n    content: \"\\ed6a\";\r\n  }\r\n  .bxs-credit-card:before {\r\n    content: \"\\ed6b\";\r\n  }\r\n  .bxs-credit-card-alt:before {\r\n    content: \"\\ed6c\";\r\n  }\r\n  .bxs-credit-card-front:before {\r\n    content: \"\\ed6d\";\r\n  }\r\n  .bxs-crop:before {\r\n    content: \"\\ed6e\";\r\n  }\r\n  .bxs-crown:before {\r\n    content: \"\\ed6f\";\r\n  }\r\n  .bxs-cube:before {\r\n    content: \"\\ed70\";\r\n  }\r\n  .bxs-cube-alt:before {\r\n    content: \"\\ed71\";\r\n  }\r\n  .bxs-cuboid:before {\r\n    content: \"\\ed72\";\r\n  }\r\n  .bxs-customize:before {\r\n    content: \"\\ed73\";\r\n  }\r\n  .bxs-cylinder:before {\r\n    content: \"\\ed74\";\r\n  }\r\n  .bxs-dashboard:before {\r\n    content: \"\\ed75\";\r\n  }\r\n  .bxs-data:before {\r\n    content: \"\\ed76\";\r\n  }\r\n  .bxs-detail:before {\r\n    content: \"\\ed77\";\r\n  }\r\n  .bxs-devices:before {\r\n    content: \"\\ed78\";\r\n  }\r\n  .bxs-diamond:before {\r\n    content: \"\\ed79\";\r\n  }\r\n  .bxs-dice-1:before {\r\n    content: \"\\ed7a\";\r\n  }\r\n  .bxs-dice-2:before {\r\n    content: \"\\ed7b\";\r\n  }\r\n  .bxs-dice-3:before {\r\n    content: \"\\ed7c\";\r\n  }\r\n  .bxs-dice-4:before {\r\n    content: \"\\ed7d\";\r\n  }\r\n  .bxs-dice-5:before {\r\n    content: \"\\ed7e\";\r\n  }\r\n  .bxs-dice-6:before {\r\n    content: \"\\ed7f\";\r\n  }\r\n  .bxs-direction-left:before {\r\n    content: \"\\ed80\";\r\n  }\r\n  .bxs-direction-right:before {\r\n    content: \"\\ed81\";\r\n  }\r\n  .bxs-directions:before {\r\n    content: \"\\ed82\";\r\n  }\r\n  .bxs-disc:before {\r\n    content: \"\\ed83\";\r\n  }\r\n  .bxs-discount:before {\r\n    content: \"\\ed84\";\r\n  }\r\n  .bxs-dish:before {\r\n    content: \"\\ed85\";\r\n  }\r\n  .bxs-dislike:before {\r\n    content: \"\\ed86\";\r\n  }\r\n  .bxs-dizzy:before {\r\n    content: \"\\ed87\";\r\n  }\r\n  .bxs-dock-bottom:before {\r\n    content: \"\\ed88\";\r\n  }\r\n  .bxs-dock-left:before {\r\n    content: \"\\ed89\";\r\n  }\r\n  .bxs-dock-right:before {\r\n    content: \"\\ed8a\";\r\n  }\r\n  .bxs-dock-top:before {\r\n    content: \"\\ed8b\";\r\n  }\r\n  .bxs-dollar-circle:before {\r\n    content: \"\\ed8c\";\r\n  }\r\n  .bxs-donate-blood:before {\r\n    content: \"\\ed8d\";\r\n  }\r\n  .bxs-donate-heart:before {\r\n    content: \"\\ed8e\";\r\n  }\r\n  .bxs-door-open:before {\r\n    content: \"\\ed8f\";\r\n  }\r\n  .bxs-doughnut-chart:before {\r\n    content: \"\\ed90\";\r\n  }\r\n  .bxs-down-arrow:before {\r\n    content: \"\\ed91\";\r\n  }\r\n  .bxs-down-arrow-alt:before {\r\n    content: \"\\ed92\";\r\n  }\r\n  .bxs-down-arrow-circle:before {\r\n    content: \"\\ed93\";\r\n  }\r\n  .bxs-down-arrow-square:before {\r\n    content: \"\\ed94\";\r\n  }\r\n  .bxs-download:before {\r\n    content: \"\\ed95\";\r\n  }\r\n  .bxs-downvote:before {\r\n    content: \"\\ed96\";\r\n  }\r\n  .bxs-drink:before {\r\n    content: \"\\ed97\";\r\n  }\r\n  .bxs-droplet-half:before {\r\n    content: \"\\ed98\";\r\n  }\r\n  .bxs-dryer:before {\r\n    content: \"\\ed99\";\r\n  }\r\n  .bxs-duplicate:before {\r\n    content: \"\\ed9a\";\r\n  }\r\n  .bxs-edit:before {\r\n    content: \"\\ed9b\";\r\n  }\r\n  .bxs-edit-alt:before {\r\n    content: \"\\ed9c\";\r\n  }\r\n  .bxs-edit-location:before {\r\n    content: \"\\ed9d\";\r\n  }\r\n  .bxs-eject:before {\r\n    content: \"\\ed9e\";\r\n  }\r\n  .bxs-envelope:before {\r\n    content: \"\\ed9f\";\r\n  }\r\n  .bxs-envelope-open:before {\r\n    content: \"\\eda0\";\r\n  }\r\n  .bxs-eraser:before {\r\n    content: \"\\eda1\";\r\n  }\r\n  .bxs-error:before {\r\n    content: \"\\eda2\";\r\n  }\r\n  .bxs-error-alt:before {\r\n    content: \"\\eda3\";\r\n  }\r\n  .bxs-error-circle:before {\r\n    content: \"\\eda4\";\r\n  }\r\n  .bxs-ev-station:before {\r\n    content: \"\\eda5\";\r\n  }\r\n  .bxs-exit:before {\r\n    content: \"\\eda6\";\r\n  }\r\n  .bxs-extension:before {\r\n    content: \"\\eda7\";\r\n  }\r\n  .bxs-eyedropper:before {\r\n    content: \"\\eda8\";\r\n  }\r\n  .bxs-face:before {\r\n    content: \"\\eda9\";\r\n  }\r\n  .bxs-face-mask:before {\r\n    content: \"\\edaa\";\r\n  }\r\n  .bxs-factory:before {\r\n    content: \"\\edab\";\r\n  }\r\n  .bxs-fast-forward-circle:before {\r\n    content: \"\\edac\";\r\n  }\r\n  .bxs-file:before {\r\n    content: \"\\edad\";\r\n  }\r\n  .bxs-file-archive:before {\r\n    content: \"\\edae\";\r\n  }\r\n  .bxs-file-blank:before {\r\n    content: \"\\edaf\";\r\n  }\r\n  .bxs-file-css:before {\r\n    content: \"\\edb0\";\r\n  }\r\n  .bxs-file-doc:before {\r\n    content: \"\\edb1\";\r\n  }\r\n  .bxs-file-export:before {\r\n    content: \"\\edb2\";\r\n  }\r\n  .bxs-file-find:before {\r\n    content: \"\\edb3\";\r\n  }\r\n  .bxs-file-gif:before {\r\n    content: \"\\edb4\";\r\n  }\r\n  .bxs-file-html:before {\r\n    content: \"\\edb5\";\r\n  }\r\n  .bxs-file-image:before {\r\n    content: \"\\edb6\";\r\n  }\r\n  .bxs-file-import:before {\r\n    content: \"\\edb7\";\r\n  }\r\n  .bxs-file-jpg:before {\r\n    content: \"\\edb8\";\r\n  }\r\n  .bxs-file-js:before {\r\n    content: \"\\edb9\";\r\n  }\r\n  .bxs-file-json:before {\r\n    content: \"\\edba\";\r\n  }\r\n  .bxs-file-md:before {\r\n    content: \"\\edbb\";\r\n  }\r\n  .bxs-file-pdf:before {\r\n    content: \"\\edbc\";\r\n  }\r\n  .bxs-file-plus:before {\r\n    content: \"\\edbd\";\r\n  }\r\n  .bxs-file-png:before {\r\n    content: \"\\edbe\";\r\n  }\r\n  .bxs-file-txt:before {\r\n    content: \"\\edbf\";\r\n  }\r\n  .bxs-film:before {\r\n    content: \"\\edc0\";\r\n  }\r\n  .bxs-filter-alt:before {\r\n    content: \"\\edc1\";\r\n  }\r\n  .bxs-first-aid:before {\r\n    content: \"\\edc2\";\r\n  }\r\n  .bxs-flag:before {\r\n    content: \"\\edc3\";\r\n  }\r\n  .bxs-flag-alt:before {\r\n    content: \"\\edc4\";\r\n  }\r\n  .bxs-flag-checkered:before {\r\n    content: \"\\edc5\";\r\n  }\r\n  .bxs-flame:before {\r\n    content: \"\\edc6\";\r\n  }\r\n  .bxs-flask:before {\r\n    content: \"\\edc7\";\r\n  }\r\n  .bxs-florist:before {\r\n    content: \"\\edc8\";\r\n  }\r\n  .bxs-folder:before {\r\n    content: \"\\edc9\";\r\n  }\r\n  .bxs-folder-minus:before {\r\n    content: \"\\edca\";\r\n  }\r\n  .bxs-folder-open:before {\r\n    content: \"\\edcb\";\r\n  }\r\n  .bxs-folder-plus:before {\r\n    content: \"\\edcc\";\r\n  }\r\n  .bxs-food-menu:before {\r\n    content: \"\\edcd\";\r\n  }\r\n  .bxs-fridge:before {\r\n    content: \"\\edce\";\r\n  }\r\n  .bxs-game:before {\r\n    content: \"\\edcf\";\r\n  }\r\n  .bxs-gas-pump:before {\r\n    content: \"\\edd0\";\r\n  }\r\n  .bxs-ghost:before {\r\n    content: \"\\edd1\";\r\n  }\r\n  .bxs-gift:before {\r\n    content: \"\\edd2\";\r\n  }\r\n  .bxs-graduation:before {\r\n    content: \"\\edd3\";\r\n  }\r\n  .bxs-grid:before {\r\n    content: \"\\edd4\";\r\n  }\r\n  .bxs-grid-alt:before {\r\n    content: \"\\edd5\";\r\n  }\r\n  .bxs-group:before {\r\n    content: \"\\edd6\";\r\n  }\r\n  .bxs-guitar-amp:before {\r\n    content: \"\\edd7\";\r\n  }\r\n  .bxs-hand:before {\r\n    content: \"\\edd8\";\r\n  }\r\n  .bxs-hand-down:before {\r\n    content: \"\\edd9\";\r\n  }\r\n  .bxs-hand-left:before {\r\n    content: \"\\edda\";\r\n  }\r\n  .bxs-hand-right:before {\r\n    content: \"\\eddb\";\r\n  }\r\n  .bxs-hand-up:before {\r\n    content: \"\\eddc\";\r\n  }\r\n  .bxs-happy:before {\r\n    content: \"\\eddd\";\r\n  }\r\n  .bxs-happy-alt:before {\r\n    content: \"\\edde\";\r\n  }\r\n  .bxs-happy-beaming:before {\r\n    content: \"\\eddf\";\r\n  }\r\n  .bxs-happy-heart-eyes:before {\r\n    content: \"\\ede0\";\r\n  }\r\n  .bxs-hdd:before {\r\n    content: \"\\ede1\";\r\n  }\r\n  .bxs-heart:before {\r\n    content: \"\\ede2\";\r\n  }\r\n  .bxs-heart-circle:before {\r\n    content: \"\\ede3\";\r\n  }\r\n  .bxs-heart-square:before {\r\n    content: \"\\ede4\";\r\n  }\r\n  .bxs-help-circle:before {\r\n    content: \"\\ede5\";\r\n  }\r\n  .bxs-hide:before {\r\n    content: \"\\ede6\";\r\n  }\r\n  .bxs-home:before {\r\n    content: \"\\ede7\";\r\n  }\r\n  .bxs-home-circle:before {\r\n    content: \"\\ede8\";\r\n  }\r\n  .bxs-home-heart:before {\r\n    content: \"\\ede9\";\r\n  }\r\n  .bxs-home-smile:before {\r\n    content: \"\\edea\";\r\n  }\r\n  .bxs-hotel:before {\r\n    content: \"\\edeb\";\r\n  }\r\n  .bxs-hourglass:before {\r\n    content: \"\\edec\";\r\n  }\r\n  .bxs-hourglass-bottom:before {\r\n    content: \"\\eded\";\r\n  }\r\n  .bxs-hourglass-top:before {\r\n    content: \"\\edee\";\r\n  }\r\n  .bxs-id-card:before {\r\n    content: \"\\edef\";\r\n  }\r\n  .bxs-image:before {\r\n    content: \"\\edf0\";\r\n  }\r\n  .bxs-image-add:before {\r\n    content: \"\\edf1\";\r\n  }\r\n  .bxs-image-alt:before {\r\n    content: \"\\edf2\";\r\n  }\r\n  .bxs-inbox:before {\r\n    content: \"\\edf3\";\r\n  }\r\n  .bxs-info-circle:before {\r\n    content: \"\\edf4\";\r\n  }\r\n  .bxs-info-square:before {\r\n    content: \"\\edf5\";\r\n  }\r\n  .bxs-institution:before {\r\n    content: \"\\edf6\";\r\n  }\r\n  .bxs-joystick:before {\r\n    content: \"\\edf7\";\r\n  }\r\n  .bxs-joystick-alt:before {\r\n    content: \"\\edf8\";\r\n  }\r\n  .bxs-joystick-button:before {\r\n    content: \"\\edf9\";\r\n  }\r\n  .bxs-key:before {\r\n    content: \"\\edfa\";\r\n  }\r\n  .bxs-keyboard:before {\r\n    content: \"\\edfb\";\r\n  }\r\n  .bxs-label:before {\r\n    content: \"\\edfc\";\r\n  }\r\n  .bxs-landmark:before {\r\n    content: \"\\edfd\";\r\n  }\r\n  .bxs-landscape:before {\r\n    content: \"\\edfe\";\r\n  }\r\n  .bxs-laugh:before {\r\n    content: \"\\edff\";\r\n  }\r\n  .bxs-layer:before {\r\n    content: \"\\ee00\";\r\n  }\r\n  .bxs-layer-minus:before {\r\n    content: \"\\ee01\";\r\n  }\r\n  .bxs-layer-plus:before {\r\n    content: \"\\ee02\";\r\n  }\r\n  .bxs-layout:before {\r\n    content: \"\\ee03\";\r\n  }\r\n  .bxs-left-arrow:before {\r\n    content: \"\\ee04\";\r\n  }\r\n  .bxs-left-arrow-alt:before {\r\n    content: \"\\ee05\";\r\n  }\r\n  .bxs-left-arrow-circle:before {\r\n    content: \"\\ee06\";\r\n  }\r\n  .bxs-left-arrow-square:before {\r\n    content: \"\\ee07\";\r\n  }\r\n  .bxs-left-down-arrow-circle:before {\r\n    content: \"\\ee08\";\r\n  }\r\n  .bxs-left-top-arrow-circle:before {\r\n    content: \"\\ee09\";\r\n  }\r\n  .bxs-like:before {\r\n    content: \"\\ee0a\";\r\n  }\r\n  .bxs-location-plus:before {\r\n    content: \"\\ee0b\";\r\n  }\r\n  .bxs-lock:before {\r\n    content: \"\\ee0c\";\r\n  }\r\n  .bxs-lock-alt:before {\r\n    content: \"\\ee0d\";\r\n  }\r\n  .bxs-lock-open:before {\r\n    content: \"\\ee0e\";\r\n  }\r\n  .bxs-lock-open-alt:before {\r\n    content: \"\\ee0f\";\r\n  }\r\n  .bxs-log-in:before {\r\n    content: \"\\ee10\";\r\n  }\r\n  .bxs-log-in-circle:before {\r\n    content: \"\\ee11\";\r\n  }\r\n  .bxs-log-out:before {\r\n    content: \"\\ee12\";\r\n  }\r\n  .bxs-log-out-circle:before {\r\n    content: \"\\ee13\";\r\n  }\r\n  .bxs-low-vision:before {\r\n    content: \"\\ee14\";\r\n  }\r\n  .bxs-magic-wand:before {\r\n    content: \"\\ee15\";\r\n  }\r\n  .bxs-magnet:before {\r\n    content: \"\\ee16\";\r\n  }\r\n  .bxs-map:before {\r\n    content: \"\\ee17\";\r\n  }\r\n  .bxs-map-alt:before {\r\n    content: \"\\ee18\";\r\n  }\r\n  .bxs-map-pin:before {\r\n    content: \"\\ee19\";\r\n  }\r\n  .bxs-mask:before {\r\n    content: \"\\ee1a\";\r\n  }\r\n  .bxs-medal:before {\r\n    content: \"\\ee1b\";\r\n  }\r\n  .bxs-megaphone:before {\r\n    content: \"\\ee1c\";\r\n  }\r\n  .bxs-meh:before {\r\n    content: \"\\ee1d\";\r\n  }\r\n  .bxs-meh-alt:before {\r\n    content: \"\\ee1e\";\r\n  }\r\n  .bxs-meh-blank:before {\r\n    content: \"\\ee1f\";\r\n  }\r\n  .bxs-memory-card:before {\r\n    content: \"\\ee20\";\r\n  }\r\n  .bxs-message:before {\r\n    content: \"\\ee21\";\r\n  }\r\n  .bxs-message-add:before {\r\n    content: \"\\ee22\";\r\n  }\r\n  .bxs-message-alt:before {\r\n    content: \"\\ee23\";\r\n  }\r\n  .bxs-message-alt-add:before {\r\n    content: \"\\ee24\";\r\n  }\r\n  .bxs-message-alt-check:before {\r\n    content: \"\\ee25\";\r\n  }\r\n  .bxs-message-alt-detail:before {\r\n    content: \"\\ee26\";\r\n  }\r\n  .bxs-message-alt-dots:before {\r\n    content: \"\\ee27\";\r\n  }\r\n  .bxs-message-alt-edit:before {\r\n    content: \"\\ee28\";\r\n  }\r\n  .bxs-message-alt-error:before {\r\n    content: \"\\ee29\";\r\n  }\r\n  .bxs-message-alt-minus:before {\r\n    content: \"\\ee2a\";\r\n  }\r\n  .bxs-message-alt-x:before {\r\n    content: \"\\ee2b\";\r\n  }\r\n  .bxs-message-check:before {\r\n    content: \"\\ee2c\";\r\n  }\r\n  .bxs-message-detail:before {\r\n    content: \"\\ee2d\";\r\n  }\r\n  .bxs-message-dots:before {\r\n    content: \"\\ee2e\";\r\n  }\r\n  .bxs-message-edit:before {\r\n    content: \"\\ee2f\";\r\n  }\r\n  .bxs-message-error:before {\r\n    content: \"\\ee30\";\r\n  }\r\n  .bxs-message-minus:before {\r\n    content: \"\\ee31\";\r\n  }\r\n  .bxs-message-rounded:before {\r\n    content: \"\\ee32\";\r\n  }\r\n  .bxs-message-rounded-add:before {\r\n    content: \"\\ee33\";\r\n  }\r\n  .bxs-message-rounded-check:before {\r\n    content: \"\\ee34\";\r\n  }\r\n  .bxs-message-rounded-detail:before {\r\n    content: \"\\ee35\";\r\n  }\r\n  .bxs-message-rounded-dots:before {\r\n    content: \"\\ee36\";\r\n  }\r\n  .bxs-message-rounded-edit:before {\r\n    content: \"\\ee37\";\r\n  }\r\n  .bxs-message-rounded-error:before {\r\n    content: \"\\ee38\";\r\n  }\r\n  .bxs-message-rounded-minus:before {\r\n    content: \"\\ee39\";\r\n  }\r\n  .bxs-message-rounded-x:before {\r\n    content: \"\\ee3a\";\r\n  }\r\n  .bxs-message-square:before {\r\n    content: \"\\ee3b\";\r\n  }\r\n  .bxs-message-square-add:before {\r\n    content: \"\\ee3c\";\r\n  }\r\n  .bxs-message-square-check:before {\r\n    content: \"\\ee3d\";\r\n  }\r\n  .bxs-message-square-detail:before {\r\n    content: \"\\ee3e\";\r\n  }\r\n  .bxs-message-square-dots:before {\r\n    content: \"\\ee3f\";\r\n  }\r\n  .bxs-message-square-edit:before {\r\n    content: \"\\ee40\";\r\n  }\r\n  .bxs-message-square-error:before {\r\n    content: \"\\ee41\";\r\n  }\r\n  .bxs-message-square-minus:before {\r\n    content: \"\\ee42\";\r\n  }\r\n  .bxs-message-square-x:before {\r\n    content: \"\\ee43\";\r\n  }\r\n  .bxs-message-x:before {\r\n    content: \"\\ee44\";\r\n  }\r\n  .bxs-meteor:before {\r\n    content: \"\\ee45\";\r\n  }\r\n  .bxs-microchip:before {\r\n    content: \"\\ee46\";\r\n  }\r\n  .bxs-microphone:before {\r\n    content: \"\\ee47\";\r\n  }\r\n  .bxs-microphone-alt:before {\r\n    content: \"\\ee48\";\r\n  }\r\n  .bxs-microphone-off:before {\r\n    content: \"\\ee49\";\r\n  }\r\n  .bxs-minus-circle:before {\r\n    content: \"\\ee4a\";\r\n  }\r\n  .bxs-minus-square:before {\r\n    content: \"\\ee4b\";\r\n  }\r\n  .bxs-mobile:before {\r\n    content: \"\\ee4c\";\r\n  }\r\n  .bxs-mobile-vibration:before {\r\n    content: \"\\ee4d\";\r\n  }\r\n  .bxs-moon:before {\r\n    content: \"\\ee4e\";\r\n  }\r\n  .bxs-mouse:before {\r\n    content: \"\\ee4f\";\r\n  }\r\n  .bxs-mouse-alt:before {\r\n    content: \"\\ee50\";\r\n  }\r\n  .bxs-movie:before {\r\n    content: \"\\ee51\";\r\n  }\r\n  .bxs-movie-play:before {\r\n    content: \"\\ee52\";\r\n  }\r\n  .bxs-music:before {\r\n    content: \"\\ee53\";\r\n  }\r\n  .bxs-navigation:before {\r\n    content: \"\\ee54\";\r\n  }\r\n  .bxs-network-chart:before {\r\n    content: \"\\ee55\";\r\n  }\r\n  .bxs-news:before {\r\n    content: \"\\ee56\";\r\n  }\r\n  .bxs-no-entry:before {\r\n    content: \"\\ee57\";\r\n  }\r\n  .bxs-note:before {\r\n    content: \"\\ee58\";\r\n  }\r\n  .bxs-notepad:before {\r\n    content: \"\\ee59\";\r\n  }\r\n  .bxs-notification:before {\r\n    content: \"\\ee5a\";\r\n  }\r\n  .bxs-notification-off:before {\r\n    content: \"\\ee5b\";\r\n  }\r\n  .bxs-offer:before {\r\n    content: \"\\ee5c\";\r\n  }\r\n  .bxs-package:before {\r\n    content: \"\\ee5d\";\r\n  }\r\n  .bxs-paint:before {\r\n    content: \"\\ee5e\";\r\n  }\r\n  .bxs-paint-roll:before {\r\n    content: \"\\ee5f\";\r\n  }\r\n  .bxs-palette:before {\r\n    content: \"\\ee60\";\r\n  }\r\n  .bxs-paper-plane:before {\r\n    content: \"\\ee61\";\r\n  }\r\n  .bxs-parking:before {\r\n    content: \"\\ee62\";\r\n  }\r\n  .bxs-paste:before {\r\n    content: \"\\ee63\";\r\n  }\r\n  .bxs-pen:before {\r\n    content: \"\\ee64\";\r\n  }\r\n  .bxs-pencil:before {\r\n    content: \"\\ee65\";\r\n  }\r\n  .bxs-phone:before {\r\n    content: \"\\ee66\";\r\n  }\r\n  .bxs-phone-call:before {\r\n    content: \"\\ee67\";\r\n  }\r\n  .bxs-phone-incoming:before {\r\n    content: \"\\ee68\";\r\n  }\r\n  .bxs-phone-off:before {\r\n    content: \"\\ee69\";\r\n  }\r\n  .bxs-phone-outgoing:before {\r\n    content: \"\\ee6a\";\r\n  }\r\n  .bxs-photo-album:before {\r\n    content: \"\\ee6b\";\r\n  }\r\n  .bxs-piano:before {\r\n    content: \"\\ee6c\";\r\n  }\r\n  .bxs-pie-chart:before {\r\n    content: \"\\ee6d\";\r\n  }\r\n  .bxs-pie-chart-alt:before {\r\n    content: \"\\ee6e\";\r\n  }\r\n  .bxs-pie-chart-alt-2:before {\r\n    content: \"\\ee6f\";\r\n  }\r\n  .bxs-pin:before {\r\n    content: \"\\ee70\";\r\n  }\r\n  .bxs-pizza:before {\r\n    content: \"\\ee71\";\r\n  }\r\n  .bxs-plane:before {\r\n    content: \"\\ee72\";\r\n  }\r\n  .bxs-plane-alt:before {\r\n    content: \"\\ee73\";\r\n  }\r\n  .bxs-plane-land:before {\r\n    content: \"\\ee74\";\r\n  }\r\n  .bxs-planet:before {\r\n    content: \"\\ee75\";\r\n  }\r\n  .bxs-plane-take-off:before {\r\n    content: \"\\ee76\";\r\n  }\r\n  .bxs-playlist:before {\r\n    content: \"\\ee77\";\r\n  }\r\n  .bxs-plug:before {\r\n    content: \"\\ee78\";\r\n  }\r\n  .bxs-plus-circle:before {\r\n    content: \"\\ee79\";\r\n  }\r\n  .bxs-plus-square:before {\r\n    content: \"\\ee7a\";\r\n  }\r\n  .bxs-pointer:before {\r\n    content: \"\\ee7b\";\r\n  }\r\n  .bxs-polygon:before {\r\n    content: \"\\ee7c\";\r\n  }\r\n  .bxs-printer:before {\r\n    content: \"\\ee7d\";\r\n  }\r\n  .bxs-purchase-tag:before {\r\n    content: \"\\ee7e\";\r\n  }\r\n  .bxs-purchase-tag-alt:before {\r\n    content: \"\\ee7f\";\r\n  }\r\n  .bxs-pyramid:before {\r\n    content: \"\\ee80\";\r\n  }\r\n  .bxs-quote-alt-left:before {\r\n    content: \"\\ee81\";\r\n  }\r\n  .bxs-quote-alt-right:before {\r\n    content: \"\\ee82\";\r\n  }\r\n  .bxs-quote-left:before {\r\n    content: \"\\ee83\";\r\n  }\r\n  .bxs-quote-right:before {\r\n    content: \"\\ee84\";\r\n  }\r\n  .bxs-quote-single-left:before {\r\n    content: \"\\ee85\";\r\n  }\r\n  .bxs-quote-single-right:before {\r\n    content: \"\\ee86\";\r\n  }\r\n  .bxs-radiation:before {\r\n    content: \"\\ee87\";\r\n  }\r\n  .bxs-radio:before {\r\n    content: \"\\ee88\";\r\n  }\r\n  .bxs-receipt:before {\r\n    content: \"\\ee89\";\r\n  }\r\n  .bxs-rectangle:before {\r\n    content: \"\\ee8a\";\r\n  }\r\n  .bxs-registered:before {\r\n    content: \"\\ee8b\";\r\n  }\r\n  .bxs-rename:before {\r\n    content: \"\\ee8c\";\r\n  }\r\n  .bxs-report:before {\r\n    content: \"\\ee8d\";\r\n  }\r\n  .bxs-rewind-circle:before {\r\n    content: \"\\ee8e\";\r\n  }\r\n  .bxs-right-arrow:before {\r\n    content: \"\\ee8f\";\r\n  }\r\n  .bxs-right-arrow-alt:before {\r\n    content: \"\\ee90\";\r\n  }\r\n  .bxs-right-arrow-circle:before {\r\n    content: \"\\ee91\";\r\n  }\r\n  .bxs-right-arrow-square:before {\r\n    content: \"\\ee92\";\r\n  }\r\n  .bxs-right-down-arrow-circle:before {\r\n    content: \"\\ee93\";\r\n  }\r\n  .bxs-right-top-arrow-circle:before {\r\n    content: \"\\ee94\";\r\n  }\r\n  .bxs-rocket:before {\r\n    content: \"\\ee95\";\r\n  }\r\n  .bxs-ruler:before {\r\n    content: \"\\ee96\";\r\n  }\r\n  .bxs-sad:before {\r\n    content: \"\\ee97\";\r\n  }\r\n  .bxs-save:before {\r\n    content: \"\\ee98\";\r\n  }\r\n  .bxs-school:before {\r\n    content: \"\\ee99\";\r\n  }\r\n  .bxs-search:before {\r\n    content: \"\\ee9a\";\r\n  }\r\n  .bxs-search-alt-2:before {\r\n    content: \"\\ee9b\";\r\n  }\r\n  .bxs-select-multiple:before {\r\n    content: \"\\ee9c\";\r\n  }\r\n  .bxs-send:before {\r\n    content: \"\\ee9d\";\r\n  }\r\n  .bxs-server:before {\r\n    content: \"\\ee9e\";\r\n  }\r\n  .bxs-shapes:before {\r\n    content: \"\\ee9f\";\r\n  }\r\n  .bxs-share:before {\r\n    content: \"\\eea0\";\r\n  }\r\n  .bxs-share-alt:before {\r\n    content: \"\\eea1\";\r\n  }\r\n  .bxs-shield:before {\r\n    content: \"\\eea2\";\r\n  }\r\n  .bxs-shield-alt-2:before {\r\n    content: \"\\eea3\";\r\n  }\r\n  .bxs-shield-x:before {\r\n    content: \"\\eea4\";\r\n  }\r\n  .bxs-ship:before {\r\n    content: \"\\eea5\";\r\n  }\r\n  .bxs-shocked:before {\r\n    content: \"\\eea6\";\r\n  }\r\n  .bxs-shopping-bag:before {\r\n    content: \"\\eea7\";\r\n  }\r\n  .bxs-shopping-bag-alt:before {\r\n    content: \"\\eea8\";\r\n  }\r\n  .bxs-shopping-bags:before {\r\n    content: \"\\eea9\";\r\n  }\r\n  .bxs-show:before {\r\n    content: \"\\eeaa\";\r\n  }\r\n  .bxs-skip-next-circle:before {\r\n    content: \"\\eeab\";\r\n  }\r\n  .bxs-skip-previous-circle:before {\r\n    content: \"\\eeac\";\r\n  }\r\n  .bxs-skull:before {\r\n    content: \"\\eead\";\r\n  }\r\n  .bxs-sleepy:before {\r\n    content: \"\\eeae\";\r\n  }\r\n  .bxs-slideshow:before {\r\n    content: \"\\eeaf\";\r\n  }\r\n  .bxs-smile:before {\r\n    content: \"\\eeb0\";\r\n  }\r\n  .bxs-sort-alt:before {\r\n    content: \"\\eeb1\";\r\n  }\r\n  .bxs-spa:before {\r\n    content: \"\\eeb2\";\r\n  }\r\n  .bxs-speaker:before {\r\n    content: \"\\eeb3\";\r\n  }\r\n  .bxs-spray-can:before {\r\n    content: \"\\eeb4\";\r\n  }\r\n  .bxs-spreadsheet:before {\r\n    content: \"\\eeb5\";\r\n  }\r\n  .bxs-square:before {\r\n    content: \"\\eeb6\";\r\n  }\r\n  .bxs-square-rounded:before {\r\n    content: \"\\eeb7\";\r\n  }\r\n  .bxs-star:before {\r\n    content: \"\\eeb8\";\r\n  }\r\n  .bxs-star-half:before {\r\n    content: \"\\eeb9\";\r\n  }\r\n  .bxs-sticker:before {\r\n    content: \"\\eeba\";\r\n  }\r\n  .bxs-stopwatch:before {\r\n    content: \"\\eebb\";\r\n  }\r\n  .bxs-store:before {\r\n    content: \"\\eebc\";\r\n  }\r\n  .bxs-store-alt:before {\r\n    content: \"\\eebd\";\r\n  }\r\n  .bxs-sun:before {\r\n    content: \"\\eebe\";\r\n  }\r\n  .bxs-tachometer:before {\r\n    content: \"\\eebf\";\r\n  }\r\n  .bxs-tag:before {\r\n    content: \"\\eec0\";\r\n  }\r\n  .bxs-tag-alt:before {\r\n    content: \"\\eec1\";\r\n  }\r\n  .bxs-tag-x:before {\r\n    content: \"\\eec2\";\r\n  }\r\n  .bxs-taxi:before {\r\n    content: \"\\eec3\";\r\n  }\r\n  .bxs-tennis-ball:before {\r\n    content: \"\\eec4\";\r\n  }\r\n  .bxs-terminal:before {\r\n    content: \"\\eec5\";\r\n  }\r\n  .bxs-thermometer:before {\r\n    content: \"\\eec6\";\r\n  }\r\n  .bxs-time:before {\r\n    content: \"\\eec7\";\r\n  }\r\n  .bxs-time-five:before {\r\n    content: \"\\eec8\";\r\n  }\r\n  .bxs-timer:before {\r\n    content: \"\\eec9\";\r\n  }\r\n  .bxs-tired:before {\r\n    content: \"\\eeca\";\r\n  }\r\n  .bxs-toggle-left:before {\r\n    content: \"\\eecb\";\r\n  }\r\n  .bxs-toggle-right:before {\r\n    content: \"\\eecc\";\r\n  }\r\n  .bxs-tone:before {\r\n    content: \"\\eecd\";\r\n  }\r\n  .bxs-torch:before {\r\n    content: \"\\eece\";\r\n  }\r\n  .bxs-to-top:before {\r\n    content: \"\\eecf\";\r\n  }\r\n  .bxs-traffic:before {\r\n    content: \"\\eed0\";\r\n  }\r\n  .bxs-traffic-barrier:before {\r\n    content: \"\\eed1\";\r\n  }\r\n  .bxs-traffic-cone:before {\r\n    content: \"\\eed2\";\r\n  }\r\n  .bxs-train:before {\r\n    content: \"\\eed3\";\r\n  }\r\n  .bxs-trash:before {\r\n    content: \"\\eed4\";\r\n  }\r\n  .bxs-trash-alt:before {\r\n    content: \"\\eed5\";\r\n  }\r\n  .bxs-tree:before {\r\n    content: \"\\eed6\";\r\n  }\r\n  .bxs-trophy:before {\r\n    content: \"\\eed7\";\r\n  }\r\n  .bxs-truck:before {\r\n    content: \"\\eed8\";\r\n  }\r\n  .bxs-t-shirt:before {\r\n    content: \"\\eed9\";\r\n  }\r\n  .bxs-tv:before {\r\n    content: \"\\eeda\";\r\n  }\r\n  .bxs-up-arrow:before {\r\n    content: \"\\eedb\";\r\n  }\r\n  .bxs-up-arrow-alt:before {\r\n    content: \"\\eedc\";\r\n  }\r\n  .bxs-up-arrow-circle:before {\r\n    content: \"\\eedd\";\r\n  }\r\n  .bxs-up-arrow-square:before {\r\n    content: \"\\eede\";\r\n  }\r\n  .bxs-upside-down:before {\r\n    content: \"\\eedf\";\r\n  }\r\n  .bxs-upvote:before {\r\n    content: \"\\eee0\";\r\n  }\r\n  .bxs-user:before {\r\n    content: \"\\eee1\";\r\n  }\r\n  .bxs-user-account:before {\r\n    content: \"\\eee2\";\r\n  }\r\n  .bxs-user-badge:before {\r\n    content: \"\\eee3\";\r\n  }\r\n  .bxs-user-check:before {\r\n    content: \"\\eee4\";\r\n  }\r\n  .bxs-user-circle:before {\r\n    content: \"\\eee5\";\r\n  }\r\n  .bxs-user-detail:before {\r\n    content: \"\\eee6\";\r\n  }\r\n  .bxs-user-minus:before {\r\n    content: \"\\eee7\";\r\n  }\r\n  .bxs-user-pin:before {\r\n    content: \"\\eee8\";\r\n  }\r\n  .bxs-user-plus:before {\r\n    content: \"\\eee9\";\r\n  }\r\n  .bxs-user-rectangle:before {\r\n    content: \"\\eeea\";\r\n  }\r\n  .bxs-user-voice:before {\r\n    content: \"\\eeeb\";\r\n  }\r\n  .bxs-user-x:before {\r\n    content: \"\\eeec\";\r\n  }\r\n  .bxs-vector:before {\r\n    content: \"\\eeed\";\r\n  }\r\n  .bxs-vial:before {\r\n    content: \"\\eeee\";\r\n  }\r\n  .bxs-video:before {\r\n    content: \"\\eeef\";\r\n  }\r\n  .bxs-video-off:before {\r\n    content: \"\\eef0\";\r\n  }\r\n  .bxs-video-plus:before {\r\n    content: \"\\eef1\";\r\n  }\r\n  .bxs-video-recording:before {\r\n    content: \"\\eef2\";\r\n  }\r\n  .bxs-videos:before {\r\n    content: \"\\eef3\";\r\n  }\r\n  .bxs-virus:before {\r\n    content: \"\\eef4\";\r\n  }\r\n  .bxs-virus-block:before {\r\n    content: \"\\eef5\";\r\n  }\r\n  .bxs-volume:before {\r\n    content: \"\\eef6\";\r\n  }\r\n  .bxs-volume-full:before {\r\n    content: \"\\eef7\";\r\n  }\r\n  .bxs-volume-low:before {\r\n    content: \"\\eef8\";\r\n  }\r\n  .bxs-volume-mute:before {\r\n    content: \"\\eef9\";\r\n  }\r\n  .bxs-wallet:before {\r\n    content: \"\\eefa\";\r\n  }\r\n  .bxs-wallet-alt:before {\r\n    content: \"\\eefb\";\r\n  }\r\n  .bxs-washer:before {\r\n    content: \"\\eefc\";\r\n  }\r\n  .bxs-watch:before {\r\n    content: \"\\eefd\";\r\n  }\r\n  .bxs-watch-alt:before {\r\n    content: \"\\eefe\";\r\n  }\r\n  .bxs-webcam:before {\r\n    content: \"\\eeff\";\r\n  }\r\n  .bxs-widget:before {\r\n    content: \"\\ef00\";\r\n  }\r\n  .bxs-window-alt:before {\r\n    content: \"\\ef01\";\r\n  }\r\n  .bxs-wine:before {\r\n    content: \"\\ef02\";\r\n  }\r\n  .bxs-wink-smile:before {\r\n    content: \"\\ef03\";\r\n  }\r\n  .bxs-wink-tongue:before {\r\n    content: \"\\ef04\";\r\n  }\r\n  .bxs-wrench:before {\r\n    content: \"\\ef05\";\r\n  }\r\n  .bxs-x-circle:before {\r\n    content: \"\\ef06\";\r\n  }\r\n  .bxs-x-square:before {\r\n    content: \"\\ef07\";\r\n  }\r\n  .bxs-yin-yang:before {\r\n    content: \"\\ef08\";\r\n  }\r\n  .bxs-zap:before {\r\n    content: \"\\ef09\";\r\n  }\r\n  .bxs-zoom-in:before {\r\n    content: \"\\ef0a\";\r\n  }\r\n  .bxs-zoom-out:before {\r\n    content: \"\\ef0b\";\r\n  }\r\n  ",".la,\r\n.las,\r\n.lar,\r\n.lal,\r\n.lad,\r\n.lab {\r\n  -moz-osx-font-smoothing: grayscale;\r\n  -webkit-font-smoothing: antialiased;\r\n  display: inline-block;\r\n  font-style: normal;\r\n  font-variant: normal;\r\n  text-rendering: auto;\r\n  line-height: 1; }\r\n\r\n.la-lg {\r\n  font-size: 1.33333em;\r\n  line-height: 0.75em;\r\n  vertical-align: -.0667em; }\r\n\r\n.la-xs {\r\n  font-size: .75em; }\r\n\r\n.la-sm {\r\n  font-size: .875em; }\r\n\r\n.la-1x {\r\n  font-size: 1em; }\r\n\r\n.la-2x {\r\n  font-size: 2em; }\r\n\r\n.la-3x {\r\n  font-size: 3em; }\r\n\r\n.la-4x {\r\n  font-size: 4em; }\r\n\r\n.la-5x {\r\n  font-size: 5em; }\r\n\r\n.la-6x {\r\n  font-size: 6em; }\r\n\r\n.la-7x {\r\n  font-size: 7em; }\r\n\r\n.la-8x {\r\n  font-size: 8em; }\r\n\r\n.la-9x {\r\n  font-size: 9em; }\r\n\r\n.la-10x {\r\n  font-size: 10em; }\r\n\r\n.la-fw {\r\n  text-align: center;\r\n  width: 1.25em; }\r\n\r\n.la-ul {\r\n  list-style-type: none;\r\n  margin-left: 2.5em;\r\n  padding-left: 0; }\r\n  .la-ul > li {\r\n    position: relative; }\r\n\r\n.la-li {\r\n  left: -2em;\r\n  position: absolute;\r\n  text-align: center;\r\n  width: 2em;\r\n  line-height: inherit; }\r\n\r\n.la-border {\r\n  border: solid 0.08em #eee;\r\n  border-radius: .1em;\r\n  padding: .2em .25em .15em; }\r\n\r\n.la-pull-left {\r\n  float: left; }\r\n\r\n.la-pull-right {\r\n  float: right; }\r\n\r\n.la.la-pull-left,\r\n.las.la-pull-left,\r\n.lar.la-pull-left,\r\n.lal.la-pull-left,\r\n.lab.la-pull-left {\r\n  margin-right: .3em; }\r\n\r\n.la.la-pull-right,\r\n.las.la-pull-right,\r\n.lar.la-pull-right,\r\n.lal.la-pull-right,\r\n.lab.la-pull-right {\r\n  margin-left: .3em; }\r\n\r\n.la-spin {\r\n  -webkit-animation: la-spin 2s infinite linear;\r\n          animation: la-spin 2s infinite linear; }\r\n\r\n.la-pulse {\r\n  -webkit-animation: la-spin 1s infinite steps(8);\r\n          animation: la-spin 1s infinite steps(8); }\r\n\r\n@-webkit-keyframes la-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n            transform: rotate(0deg); }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n            transform: rotate(360deg); } }\r\n\r\n@keyframes la-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n            transform: rotate(0deg); }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n            transform: rotate(360deg); } }\r\n\r\n.la-rotate-90 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\r\n  -webkit-transform: rotate(90deg);\r\n          transform: rotate(90deg); }\r\n\r\n.la-rotate-180 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\r\n  -webkit-transform: rotate(180deg);\r\n          transform: rotate(180deg); }\r\n\r\n.la-rotate-270 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\r\n  -webkit-transform: rotate(270deg);\r\n          transform: rotate(270deg); }\r\n\r\n.la-flip-horizontal {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\r\n  -webkit-transform: scale(-1, 1);\r\n          transform: scale(-1, 1); }\r\n\r\n.la-flip-vertical {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\r\n  -webkit-transform: scale(1, -1);\r\n          transform: scale(1, -1); }\r\n\r\n.la-flip-both, .la-flip-horizontal.la-flip-vertical {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\r\n  -webkit-transform: scale(-1, -1);\r\n          transform: scale(-1, -1); }\r\n\r\n:root .la-rotate-90,\r\n:root .la-rotate-180,\r\n:root .la-rotate-270,\r\n:root .la-flip-horizontal,\r\n:root .la-flip-vertical,\r\n:root .la-flip-both {\r\n  -webkit-filter: none;\r\n          filter: none; }\r\n\r\n.la-stack {\r\n  display: inline-block;\r\n  height: 2em;\r\n  line-height: 2em;\r\n  position: relative;\r\n  vertical-align: middle;\r\n  width: 2.5em; }\r\n\r\n.la-stack-1x,\r\n.la-stack-2x {\r\n  left: 0;\r\n  position: absolute;\r\n  text-align: center;\r\n  width: 100%; }\r\n\r\n.la-stack-1x {\r\n  line-height: inherit; }\r\n\r\n.la-stack-2x {\r\n  font-size: 2em; }\r\n\r\n.la-inverse {\r\n  color: #fff; }\r\n\r\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\r\nreaders do not read off random characters that represent icons */\r\n.la-500px:before {\r\n  content: \"\\f26e\"; }\r\n\r\n.la-accessible-icon:before {\r\n  content: \"\\f368\"; }\r\n\r\n.la-accusoft:before {\r\n  content: \"\\f369\"; }\r\n\r\n.la-acquisitions-incorporated:before {\r\n  content: \"\\f6af\"; }\r\n\r\n.la-ad:before {\r\n  content: \"\\f641\"; }\r\n\r\n.la-address-book:before {\r\n  content: \"\\f2b9\"; }\r\n\r\n.la-address-card:before {\r\n  content: \"\\f2bb\"; }\r\n\r\n.la-adjust:before {\r\n  content: \"\\f042\"; }\r\n\r\n.la-adn:before {\r\n  content: \"\\f170\"; }\r\n\r\n.la-adobe:before {\r\n  content: \"\\f778\"; }\r\n\r\n.la-adversal:before {\r\n  content: \"\\f36a\"; }\r\n\r\n.la-affiliatetheme:before {\r\n  content: \"\\f36b\"; }\r\n\r\n.la-air-freshener:before {\r\n  content: \"\\f5d0\"; }\r\n\r\n.la-airbnb:before {\r\n  content: \"\\f834\"; }\r\n\r\n.la-algolia:before {\r\n  content: \"\\f36c\"; }\r\n\r\n.la-align-center:before {\r\n  content: \"\\f037\"; }\r\n\r\n.la-align-justify:before {\r\n  content: \"\\f039\"; }\r\n\r\n.la-align-left:before {\r\n  content: \"\\f036\"; }\r\n\r\n.la-align-right:before {\r\n  content: \"\\f038\"; }\r\n\r\n.la-alipay:before {\r\n  content: \"\\f642\"; }\r\n\r\n.la-allergies:before {\r\n  content: \"\\f461\"; }\r\n\r\n.la-amazon:before {\r\n  content: \"\\f270\"; }\r\n\r\n.la-amazon-pay:before {\r\n  content: \"\\f42c\"; }\r\n\r\n.la-ambulance:before {\r\n  content: \"\\f0f9\"; }\r\n\r\n.la-american-sign-language-interpreting:before {\r\n  content: \"\\f2a3\"; }\r\n\r\n.la-amilia:before {\r\n  content: \"\\f36d\"; }\r\n\r\n.la-anchor:before {\r\n  content: \"\\f13d\"; }\r\n\r\n.la-android:before {\r\n  content: \"\\f17b\"; }\r\n\r\n.la-angellist:before {\r\n  content: \"\\f209\"; }\r\n\r\n.la-angle-double-down:before {\r\n  content: \"\\f103\"; }\r\n\r\n.la-angle-double-left:before {\r\n  content: \"\\f100\"; }\r\n\r\n.la-angle-double-right:before {\r\n  content: \"\\f101\"; }\r\n\r\n.la-angle-double-up:before {\r\n  content: \"\\f102\"; }\r\n\r\n.la-angle-down:before {\r\n  content: \"\\f107\"; }\r\n\r\n.la-angle-left:before {\r\n  content: \"\\f104\"; }\r\n\r\n.la-angle-right:before {\r\n  content: \"\\f105\"; }\r\n\r\n.la-angle-up:before {\r\n  content: \"\\f106\"; }\r\n\r\n.la-angry:before {\r\n  content: \"\\f556\"; }\r\n\r\n.la-angrycreative:before {\r\n  content: \"\\f36e\"; }\r\n\r\n.la-angular:before {\r\n  content: \"\\f420\"; }\r\n\r\n.la-ankh:before {\r\n  content: \"\\f644\"; }\r\n\r\n.la-app-store:before {\r\n  content: \"\\f36f\"; }\r\n\r\n.la-app-store-ios:before {\r\n  content: \"\\f370\"; }\r\n\r\n.la-apper:before {\r\n  content: \"\\f371\"; }\r\n\r\n.la-apple:before {\r\n  content: \"\\f179\"; }\r\n\r\n.la-apple-alt:before {\r\n  content: \"\\f5d1\"; }\r\n\r\n.la-apple-pay:before {\r\n  content: \"\\f415\"; }\r\n\r\n.la-archive:before {\r\n  content: \"\\f187\"; }\r\n\r\n.la-archway:before {\r\n  content: \"\\f557\"; }\r\n\r\n.la-arrow-alt-circle-down:before {\r\n  content: \"\\f358\"; }\r\n\r\n.la-arrow-alt-circle-left:before {\r\n  content: \"\\f359\"; }\r\n\r\n.la-arrow-alt-circle-right:before {\r\n  content: \"\\f35a\"; }\r\n\r\n.la-arrow-alt-circle-up:before {\r\n  content: \"\\f35b\"; }\r\n\r\n.la-arrow-circle-down:before {\r\n  content: \"\\f0ab\"; }\r\n\r\n.la-arrow-circle-left:before {\r\n  content: \"\\f0a8\"; }\r\n\r\n.la-arrow-circle-right:before {\r\n  content: \"\\f0a9\"; }\r\n\r\n.la-arrow-circle-up:before {\r\n  content: \"\\f0aa\"; }\r\n\r\n.la-arrow-down:before {\r\n  content: \"\\f063\"; }\r\n\r\n.la-arrow-left:before {\r\n  content: \"\\f060\"; }\r\n\r\n.la-arrow-right:before {\r\n  content: \"\\f061\"; }\r\n\r\n.la-arrow-up:before {\r\n  content: \"\\f062\"; }\r\n\r\n.la-arrows-alt:before {\r\n  content: \"\\f0b2\"; }\r\n\r\n.la-arrows-alt-h:before {\r\n  content: \"\\f337\"; }\r\n\r\n.la-arrows-alt-v:before {\r\n  content: \"\\f338\"; }\r\n\r\n.la-artstation:before {\r\n  content: \"\\f77a\"; }\r\n\r\n.la-assistive-listening-systems:before {\r\n  content: \"\\f2a2\"; }\r\n\r\n.la-asterisk:before {\r\n  content: \"\\f069\"; }\r\n\r\n.la-asymmetrik:before {\r\n  content: \"\\f372\"; }\r\n\r\n.la-at:before {\r\n  content: \"\\f1fa\"; }\r\n\r\n.la-atlas:before {\r\n  content: \"\\f558\"; }\r\n\r\n.la-atlassian:before {\r\n  content: \"\\f77b\"; }\r\n\r\n.la-atom:before {\r\n  content: \"\\f5d2\"; }\r\n\r\n.la-audible:before {\r\n  content: \"\\f373\"; }\r\n\r\n.la-audio-description:before {\r\n  content: \"\\f29e\"; }\r\n\r\n.la-autoprefixer:before {\r\n  content: \"\\f41c\"; }\r\n\r\n.la-avianex:before {\r\n  content: \"\\f374\"; }\r\n\r\n.la-aviato:before {\r\n  content: \"\\f421\"; }\r\n\r\n.la-award:before {\r\n  content: \"\\f559\"; }\r\n\r\n.la-aws:before {\r\n  content: \"\\f375\"; }\r\n\r\n.la-baby:before {\r\n  content: \"\\f77c\"; }\r\n\r\n.la-baby-carriage:before {\r\n  content: \"\\f77d\"; }\r\n\r\n.la-backspace:before {\r\n  content: \"\\f55a\"; }\r\n\r\n.la-backward:before {\r\n  content: \"\\f04a\"; }\r\n\r\n.la-bacon:before {\r\n  content: \"\\f7e5\"; }\r\n\r\n.la-balance-scale:before {\r\n  content: \"\\f24e\"; }\r\n\r\n.la-balance-scale-left:before {\r\n  content: \"\\f515\"; }\r\n\r\n.la-balance-scale-right:before {\r\n  content: \"\\f516\"; }\r\n\r\n.la-ban:before {\r\n  content: \"\\f05e\"; }\r\n\r\n.la-band-aid:before {\r\n  content: \"\\f462\"; }\r\n\r\n.la-bandcamp:before {\r\n  content: \"\\f2d5\"; }\r\n\r\n.la-barcode:before {\r\n  content: \"\\f02a\"; }\r\n\r\n.la-bars:before {\r\n  content: \"\\f0c9\"; }\r\n\r\n.la-baseball-ball:before {\r\n  content: \"\\f433\"; }\r\n\r\n.la-basketball-ball:before {\r\n  content: \"\\f434\"; }\r\n\r\n.la-bath:before {\r\n  content: \"\\f2cd\"; }\r\n\r\n.la-battery-empty:before {\r\n  content: \"\\f244\"; }\r\n\r\n.la-battery-full:before {\r\n  content: \"\\f240\"; }\r\n\r\n.la-battery-half:before {\r\n  content: \"\\f242\"; }\r\n\r\n.la-battery-quarter:before {\r\n  content: \"\\f243\"; }\r\n\r\n.la-battery-three-quarters:before {\r\n  content: \"\\f241\"; }\r\n\r\n.la-battle-net:before {\r\n  content: \"\\f835\"; }\r\n\r\n.la-bed:before {\r\n  content: \"\\f236\"; }\r\n\r\n.la-beer:before {\r\n  content: \"\\f0fc\"; }\r\n\r\n.la-behance:before {\r\n  content: \"\\f1b4\"; }\r\n\r\n.la-behance-square:before {\r\n  content: \"\\f1b5\"; }\r\n\r\n.la-bell:before {\r\n  content: \"\\f0f3\"; }\r\n\r\n.la-bell-slash:before {\r\n  content: \"\\f1f6\"; }\r\n\r\n.la-bezier-curve:before {\r\n  content: \"\\f55b\"; }\r\n\r\n.la-bible:before {\r\n  content: \"\\f647\"; }\r\n\r\n.la-bicycle:before {\r\n  content: \"\\f206\"; }\r\n\r\n.la-biking:before {\r\n  content: \"\\f84a\"; }\r\n\r\n.la-bimobject:before {\r\n  content: \"\\f378\"; }\r\n\r\n.la-binoculars:before {\r\n  content: \"\\f1e5\"; }\r\n\r\n.la-biohazard:before {\r\n  content: \"\\f780\"; }\r\n\r\n.la-birthday-cake:before {\r\n  content: \"\\f1fd\"; }\r\n\r\n.la-bitbucket:before {\r\n  content: \"\\f171\"; }\r\n\r\n.la-bitcoin:before {\r\n  content: \"\\f379\"; }\r\n\r\n.la-bity:before {\r\n  content: \"\\f37a\"; }\r\n\r\n.la-black-tie:before {\r\n  content: \"\\f27e\"; }\r\n\r\n.la-blackberry:before {\r\n  content: \"\\f37b\"; }\r\n\r\n.la-blender:before {\r\n  content: \"\\f517\"; }\r\n\r\n.la-blender-phone:before {\r\n  content: \"\\f6b6\"; }\r\n\r\n.la-blind:before {\r\n  content: \"\\f29d\"; }\r\n\r\n.la-blog:before {\r\n  content: \"\\f781\"; }\r\n\r\n.la-blogger:before {\r\n  content: \"\\f37c\"; }\r\n\r\n.la-blogger-b:before {\r\n  content: \"\\f37d\"; }\r\n\r\n.la-bluetooth:before {\r\n  content: \"\\f293\"; }\r\n\r\n.la-bluetooth-b:before {\r\n  content: \"\\f294\"; }\r\n\r\n.la-bold:before {\r\n  content: \"\\f032\"; }\r\n\r\n.la-bolt:before {\r\n  content: \"\\f0e7\"; }\r\n\r\n.la-bomb:before {\r\n  content: \"\\f1e2\"; }\r\n\r\n.la-bone:before {\r\n  content: \"\\f5d7\"; }\r\n\r\n.la-bong:before {\r\n  content: \"\\f55c\"; }\r\n\r\n.la-book:before {\r\n  content: \"\\f02d\"; }\r\n\r\n.la-book-dead:before {\r\n  content: \"\\f6b7\"; }\r\n\r\n.la-book-medical:before {\r\n  content: \"\\f7e6\"; }\r\n\r\n.la-book-open:before {\r\n  content: \"\\f518\"; }\r\n\r\n.la-book-reader:before {\r\n  content: \"\\f5da\"; }\r\n\r\n.la-bookmark:before {\r\n  content: \"\\f02e\"; }\r\n\r\n.la-bootstrap:before {\r\n  content: \"\\f836\"; }\r\n\r\n.la-border-all:before {\r\n  content: \"\\f84c\"; }\r\n\r\n.la-border-none:before {\r\n  content: \"\\f850\"; }\r\n\r\n.la-border-style:before {\r\n  content: \"\\f853\"; }\r\n\r\n.la-bowling-ball:before {\r\n  content: \"\\f436\"; }\r\n\r\n.la-box:before {\r\n  content: \"\\f466\"; }\r\n\r\n.la-box-open:before {\r\n  content: \"\\f49e\"; }\r\n\r\n.la-boxes:before {\r\n  content: \"\\f468\"; }\r\n\r\n.la-braille:before {\r\n  content: \"\\f2a1\"; }\r\n\r\n.la-brain:before {\r\n  content: \"\\f5dc\"; }\r\n\r\n.la-bread-slice:before {\r\n  content: \"\\f7ec\"; }\r\n\r\n.la-briefcase:before {\r\n  content: \"\\f0b1\"; }\r\n\r\n.la-briefcase-medical:before {\r\n  content: \"\\f469\"; }\r\n\r\n.la-broadcast-tower:before {\r\n  content: \"\\f519\"; }\r\n\r\n.la-broom:before {\r\n  content: \"\\f51a\"; }\r\n\r\n.la-brush:before {\r\n  content: \"\\f55d\"; }\r\n\r\n.la-btc:before {\r\n  content: \"\\f15a\"; }\r\n\r\n.la-buffer:before {\r\n  content: \"\\f837\"; }\r\n\r\n.la-bug:before {\r\n  content: \"\\f188\"; }\r\n\r\n.la-building:before {\r\n  content: \"\\f1ad\"; }\r\n\r\n.la-bullhorn:before {\r\n  content: \"\\f0a1\"; }\r\n\r\n.la-bullseye:before {\r\n  content: \"\\f140\"; }\r\n\r\n.la-burn:before {\r\n  content: \"\\f46a\"; }\r\n\r\n.la-buromobelexperte:before {\r\n  content: \"\\f37f\"; }\r\n\r\n.la-bus:before {\r\n  content: \"\\f207\"; }\r\n\r\n.la-bus-alt:before {\r\n  content: \"\\f55e\"; }\r\n\r\n.la-business-time:before {\r\n  content: \"\\f64a\"; }\r\n\r\n.la-buy-n-large:before {\r\n  content: \"\\f8a6\"; }\r\n\r\n.la-buysellads:before {\r\n  content: \"\\f20d\"; }\r\n\r\n.la-calculator:before {\r\n  content: \"\\f1ec\"; }\r\n\r\n.la-calendar:before {\r\n  content: \"\\f133\"; }\r\n\r\n.la-calendar-alt:before {\r\n  content: \"\\f073\"; }\r\n\r\n.la-calendar-check:before {\r\n  content: \"\\f274\"; }\r\n\r\n.la-calendar-day:before {\r\n  content: \"\\f783\"; }\r\n\r\n.la-calendar-minus:before {\r\n  content: \"\\f272\"; }\r\n\r\n.la-calendar-plus:before {\r\n  content: \"\\f271\"; }\r\n\r\n.la-calendar-times:before {\r\n  content: \"\\f273\"; }\r\n\r\n.la-calendar-week:before {\r\n  content: \"\\f784\"; }\r\n\r\n.la-camera:before {\r\n  content: \"\\f030\"; }\r\n\r\n.la-camera-retro:before {\r\n  content: \"\\f083\"; }\r\n\r\n.la-campground:before {\r\n  content: \"\\f6bb\"; }\r\n\r\n.la-canadian-maple-leaf:before {\r\n  content: \"\\f785\"; }\r\n\r\n.la-candy-cane:before {\r\n  content: \"\\f786\"; }\r\n\r\n.la-cannabis:before {\r\n  content: \"\\f55f\"; }\r\n\r\n.la-capsules:before {\r\n  content: \"\\f46b\"; }\r\n\r\n.la-car:before {\r\n  content: \"\\f1b9\"; }\r\n\r\n.la-car-alt:before {\r\n  content: \"\\f5de\"; }\r\n\r\n.la-car-battery:before {\r\n  content: \"\\f5df\"; }\r\n\r\n.la-car-crash:before {\r\n  content: \"\\f5e1\"; }\r\n\r\n.la-car-side:before {\r\n  content: \"\\f5e4\"; }\r\n\r\n.la-caret-down:before {\r\n  content: \"\\f0d7\"; }\r\n\r\n.la-caret-left:before {\r\n  content: \"\\f0d9\"; }\r\n\r\n.la-caret-right:before {\r\n  content: \"\\f0da\"; }\r\n\r\n.la-caret-square-down:before {\r\n  content: \"\\f150\"; }\r\n\r\n.la-caret-square-left:before {\r\n  content: \"\\f191\"; }\r\n\r\n.la-caret-square-right:before {\r\n  content: \"\\f152\"; }\r\n\r\n.la-caret-square-up:before {\r\n  content: \"\\f151\"; }\r\n\r\n.la-caret-up:before {\r\n  content: \"\\f0d8\"; }\r\n\r\n.la-carrot:before {\r\n  content: \"\\f787\"; }\r\n\r\n.la-cart-arrow-down:before {\r\n  content: \"\\f218\"; }\r\n\r\n.la-cart-plus:before {\r\n  content: \"\\f217\"; }\r\n\r\n.la-cash-register:before {\r\n  content: \"\\f788\"; }\r\n\r\n.la-cat:before {\r\n  content: \"\\f6be\"; }\r\n\r\n.la-cc-amazon-pay:before {\r\n  content: \"\\f42d\"; }\r\n\r\n.la-cc-amex:before {\r\n  content: \"\\f1f3\"; }\r\n\r\n.la-cc-apple-pay:before {\r\n  content: \"\\f416\"; }\r\n\r\n.la-cc-diners-club:before {\r\n  content: \"\\f24c\"; }\r\n\r\n.la-cc-discover:before {\r\n  content: \"\\f1f2\"; }\r\n\r\n.la-cc-jcb:before {\r\n  content: \"\\f24b\"; }\r\n\r\n.la-cc-mastercard:before {\r\n  content: \"\\f1f1\"; }\r\n\r\n.la-cc-paypal:before {\r\n  content: \"\\f1f4\"; }\r\n\r\n.la-cc-stripe:before {\r\n  content: \"\\f1f5\"; }\r\n\r\n.la-cc-visa:before {\r\n  content: \"\\f1f0\"; }\r\n\r\n.la-centercode:before {\r\n  content: \"\\f380\"; }\r\n\r\n.la-centos:before {\r\n  content: \"\\f789\"; }\r\n\r\n.la-certificate:before {\r\n  content: \"\\f0a3\"; }\r\n\r\n.la-chair:before {\r\n  content: \"\\f6c0\"; }\r\n\r\n.la-chalkboard:before {\r\n  content: \"\\f51b\"; }\r\n\r\n.la-chalkboard-teacher:before {\r\n  content: \"\\f51c\"; }\r\n\r\n.la-charging-station:before {\r\n  content: \"\\f5e7\"; }\r\n\r\n.la-chart-area:before {\r\n  content: \"\\f1fe\"; }\r\n\r\n.la-chart-bar:before {\r\n  content: \"\\f080\"; }\r\n\r\n.la-chart-line:before {\r\n  content: \"\\f201\"; }\r\n\r\n.la-chart-pie:before {\r\n  content: \"\\f200\"; }\r\n\r\n.la-check:before {\r\n  content: \"\\f00c\"; }\r\n\r\n.la-check-circle:before {\r\n  content: \"\\f058\"; }\r\n\r\n.la-check-double:before {\r\n  content: \"\\f560\"; }\r\n\r\n.la-check-square:before {\r\n  content: \"\\f14a\"; }\r\n\r\n.la-cheese:before {\r\n  content: \"\\f7ef\"; }\r\n\r\n.la-chess:before {\r\n  content: \"\\f439\"; }\r\n\r\n.la-chess-bishop:before {\r\n  content: \"\\f43a\"; }\r\n\r\n.la-chess-board:before {\r\n  content: \"\\f43c\"; }\r\n\r\n.la-chess-king:before {\r\n  content: \"\\f43f\"; }\r\n\r\n.la-chess-knight:before {\r\n  content: \"\\f441\"; }\r\n\r\n.la-chess-pawn:before {\r\n  content: \"\\f443\"; }\r\n\r\n.la-chess-queen:before {\r\n  content: \"\\f445\"; }\r\n\r\n.la-chess-rook:before {\r\n  content: \"\\f447\"; }\r\n\r\n.la-chevron-circle-down:before {\r\n  content: \"\\f13a\"; }\r\n\r\n.la-chevron-circle-left:before {\r\n  content: \"\\f137\"; }\r\n\r\n.la-chevron-circle-right:before {\r\n  content: \"\\f138\"; }\r\n\r\n.la-chevron-circle-up:before {\r\n  content: \"\\f139\"; }\r\n\r\n.la-chevron-down:before {\r\n  content: \"\\f078\"; }\r\n\r\n.la-chevron-left:before {\r\n  content: \"\\f053\"; }\r\n\r\n.la-chevron-right:before {\r\n  content: \"\\f054\"; }\r\n\r\n.la-chevron-up:before {\r\n  content: \"\\f077\"; }\r\n\r\n.la-child:before {\r\n  content: \"\\f1ae\"; }\r\n\r\n.la-chrome:before {\r\n  content: \"\\f268\"; }\r\n\r\n.la-chromecast:before {\r\n  content: \"\\f838\"; }\r\n\r\n.la-church:before {\r\n  content: \"\\f51d\"; }\r\n\r\n.la-circle:before {\r\n  content: \"\\f111\"; }\r\n\r\n.la-circle-notch:before {\r\n  content: \"\\f1ce\"; }\r\n\r\n.la-city:before {\r\n  content: \"\\f64f\"; }\r\n\r\n.la-clinic-medical:before {\r\n  content: \"\\f7f2\"; }\r\n\r\n.la-clipboard:before {\r\n  content: \"\\f328\"; }\r\n\r\n.la-clipboard-check:before {\r\n  content: \"\\f46c\"; }\r\n\r\n.la-clipboard-list:before {\r\n  content: \"\\f46d\"; }\r\n\r\n.la-clock:before {\r\n  content: \"\\f017\"; }\r\n\r\n.la-clone:before {\r\n  content: \"\\f24d\"; }\r\n\r\n.la-closed-captioning:before {\r\n  content: \"\\f20a\"; }\r\n\r\n.la-cloud:before {\r\n  content: \"\\f0c2\"; }\r\n\r\n.la-cloud-download-alt:before {\r\n  content: \"\\f381\"; }\r\n\r\n.la-cloud-meatball:before {\r\n  content: \"\\f73b\"; }\r\n\r\n.la-cloud-moon:before {\r\n  content: \"\\f6c3\"; }\r\n\r\n.la-cloud-moon-rain:before {\r\n  content: \"\\f73c\"; }\r\n\r\n.la-cloud-rain:before {\r\n  content: \"\\f73d\"; }\r\n\r\n.la-cloud-showers-heavy:before {\r\n  content: \"\\f740\"; }\r\n\r\n.la-cloud-sun:before {\r\n  content: \"\\f6c4\"; }\r\n\r\n.la-cloud-sun-rain:before {\r\n  content: \"\\f743\"; }\r\n\r\n.la-cloud-upload-alt:before {\r\n  content: \"\\f382\"; }\r\n\r\n.la-cloudscale:before {\r\n  content: \"\\f383\"; }\r\n\r\n.la-cloudsmith:before {\r\n  content: \"\\f384\"; }\r\n\r\n.la-cloudversify:before {\r\n  content: \"\\f385\"; }\r\n\r\n.la-cocktail:before {\r\n  content: \"\\f561\"; }\r\n\r\n.la-code:before {\r\n  content: \"\\f121\"; }\r\n\r\n.la-code-branch:before {\r\n  content: \"\\f126\"; }\r\n\r\n.la-codepen:before {\r\n  content: \"\\f1cb\"; }\r\n\r\n.la-codiepie:before {\r\n  content: \"\\f284\"; }\r\n\r\n.la-coffee:before {\r\n  content: \"\\f0f4\"; }\r\n\r\n.la-cog:before {\r\n  content: \"\\f013\"; }\r\n\r\n.la-cogs:before {\r\n  content: \"\\f085\"; }\r\n\r\n.la-coins:before {\r\n  content: \"\\f51e\"; }\r\n\r\n.la-columns:before {\r\n  content: \"\\f0db\"; }\r\n\r\n.la-comment:before {\r\n  content: \"\\f075\"; }\r\n\r\n.la-comment-alt:before {\r\n  content: \"\\f27a\"; }\r\n\r\n.la-comment-dollar:before {\r\n  content: \"\\f651\"; }\r\n\r\n.la-comment-dots:before {\r\n  content: \"\\f4ad\"; }\r\n\r\n.la-comment-medical:before {\r\n  content: \"\\f7f5\"; }\r\n\r\n.la-comment-slash:before {\r\n  content: \"\\f4b3\"; }\r\n\r\n.la-comments:before {\r\n  content: \"\\f086\"; }\r\n\r\n.la-comments-dollar:before {\r\n  content: \"\\f653\"; }\r\n\r\n.la-compact-disc:before {\r\n  content: \"\\f51f\"; }\r\n\r\n.la-compass:before {\r\n  content: \"\\f14e\"; }\r\n\r\n.la-compress:before {\r\n  content: \"\\f066\"; }\r\n\r\n.la-compress-arrows-alt:before {\r\n  content: \"\\f78c\"; }\r\n\r\n.la-concierge-bell:before {\r\n  content: \"\\f562\"; }\r\n\r\n.la-confluence:before {\r\n  content: \"\\f78d\"; }\r\n\r\n.la-connectdevelop:before {\r\n  content: \"\\f20e\"; }\r\n\r\n.la-contao:before {\r\n  content: \"\\f26d\"; }\r\n\r\n.la-cookie:before {\r\n  content: \"\\f563\"; }\r\n\r\n.la-cookie-bite:before {\r\n  content: \"\\f564\"; }\r\n\r\n.la-copy:before {\r\n  content: \"\\f0c5\"; }\r\n\r\n.la-copyright:before {\r\n  content: \"\\f1f9\"; }\r\n\r\n.la-cotton-bureau:before {\r\n  content: \"\\f89e\"; }\r\n\r\n.la-couch:before {\r\n  content: \"\\f4b8\"; }\r\n\r\n.la-cpanel:before {\r\n  content: \"\\f388\"; }\r\n\r\n.la-creative-commons:before {\r\n  content: \"\\f25e\"; }\r\n\r\n.la-creative-commons-by:before {\r\n  content: \"\\f4e7\"; }\r\n\r\n.la-creative-commons-nc:before {\r\n  content: \"\\f4e8\"; }\r\n\r\n.la-creative-commons-nc-eu:before {\r\n  content: \"\\f4e9\"; }\r\n\r\n.la-creative-commons-nc-jp:before {\r\n  content: \"\\f4ea\"; }\r\n\r\n.la-creative-commons-nd:before {\r\n  content: \"\\f4eb\"; }\r\n\r\n.la-creative-commons-pd:before {\r\n  content: \"\\f4ec\"; }\r\n\r\n.la-creative-commons-pd-alt:before {\r\n  content: \"\\f4ed\"; }\r\n\r\n.la-creative-commons-remix:before {\r\n  content: \"\\f4ee\"; }\r\n\r\n.la-creative-commons-sa:before {\r\n  content: \"\\f4ef\"; }\r\n\r\n.la-creative-commons-sampling:before {\r\n  content: \"\\f4f0\"; }\r\n\r\n.la-creative-commons-sampling-plus:before {\r\n  content: \"\\f4f1\"; }\r\n\r\n.la-creative-commons-share:before {\r\n  content: \"\\f4f2\"; }\r\n\r\n.la-creative-commons-zero:before {\r\n  content: \"\\f4f3\"; }\r\n\r\n.la-credit-card:before {\r\n  content: \"\\f09d\"; }\r\n\r\n.la-critical-role:before {\r\n  content: \"\\f6c9\"; }\r\n\r\n.la-crop:before {\r\n  content: \"\\f125\"; }\r\n\r\n.la-crop-alt:before {\r\n  content: \"\\f565\"; }\r\n\r\n.la-cross:before {\r\n  content: \"\\f654\"; }\r\n\r\n.la-crosshairs:before {\r\n  content: \"\\f05b\"; }\r\n\r\n.la-crow:before {\r\n  content: \"\\f520\"; }\r\n\r\n.la-crown:before {\r\n  content: \"\\f521\"; }\r\n\r\n.la-crutch:before {\r\n  content: \"\\f7f7\"; }\r\n\r\n.la-css3:before {\r\n  content: \"\\f13c\"; }\r\n\r\n.la-css3-alt:before {\r\n  content: \"\\f38b\"; }\r\n\r\n.la-cube:before {\r\n  content: \"\\f1b2\"; }\r\n\r\n.la-cubes:before {\r\n  content: \"\\f1b3\"; }\r\n\r\n.la-cut:before {\r\n  content: \"\\f0c4\"; }\r\n\r\n.la-cuttlefish:before {\r\n  content: \"\\f38c\"; }\r\n\r\n.la-d-and-d:before {\r\n  content: \"\\f38d\"; }\r\n\r\n.la-d-and-d-beyond:before {\r\n  content: \"\\f6ca\"; }\r\n\r\n.la-dashcube:before {\r\n  content: \"\\f210\"; }\r\n\r\n.la-database:before {\r\n  content: \"\\f1c0\"; }\r\n\r\n.la-deaf:before {\r\n  content: \"\\f2a4\"; }\r\n\r\n.la-delicious:before {\r\n  content: \"\\f1a5\"; }\r\n\r\n.la-democrat:before {\r\n  content: \"\\f747\"; }\r\n\r\n.la-deploydog:before {\r\n  content: \"\\f38e\"; }\r\n\r\n.la-deskpro:before {\r\n  content: \"\\f38f\"; }\r\n\r\n.la-desktop:before {\r\n  content: \"\\f108\"; }\r\n\r\n.la-dev:before {\r\n  content: \"\\f6cc\"; }\r\n\r\n.la-deviantart:before {\r\n  content: \"\\f1bd\"; }\r\n\r\n.la-dharmachakra:before {\r\n  content: \"\\f655\"; }\r\n\r\n.la-dhl:before {\r\n  content: \"\\f790\"; }\r\n\r\n.la-diagnoses:before {\r\n  content: \"\\f470\"; }\r\n\r\n.la-diaspora:before {\r\n  content: \"\\f791\"; }\r\n\r\n.la-dice:before {\r\n  content: \"\\f522\"; }\r\n\r\n.la-dice-d20:before {\r\n  content: \"\\f6cf\"; }\r\n\r\n.la-dice-d6:before {\r\n  content: \"\\f6d1\"; }\r\n\r\n.la-dice-five:before {\r\n  content: \"\\f523\"; }\r\n\r\n.la-dice-four:before {\r\n  content: \"\\f524\"; }\r\n\r\n.la-dice-one:before {\r\n  content: \"\\f525\"; }\r\n\r\n.la-dice-six:before {\r\n  content: \"\\f526\"; }\r\n\r\n.la-dice-three:before {\r\n  content: \"\\f527\"; }\r\n\r\n.la-dice-two:before {\r\n  content: \"\\f528\"; }\r\n\r\n.la-digg:before {\r\n  content: \"\\f1a6\"; }\r\n\r\n.la-digital-ocean:before {\r\n  content: \"\\f391\"; }\r\n\r\n.la-digital-tachograph:before {\r\n  content: \"\\f566\"; }\r\n\r\n.la-directions:before {\r\n  content: \"\\f5eb\"; }\r\n\r\n.la-discord:before {\r\n  content: \"\\f392\"; }\r\n\r\n.la-discourse:before {\r\n  content: \"\\f393\"; }\r\n\r\n.la-divide:before {\r\n  content: \"\\f529\"; }\r\n\r\n.la-dizzy:before {\r\n  content: \"\\f567\"; }\r\n\r\n.la-dna:before {\r\n  content: \"\\f471\"; }\r\n\r\n.la-dochub:before {\r\n  content: \"\\f394\"; }\r\n\r\n.la-docker:before {\r\n  content: \"\\f395\"; }\r\n\r\n.la-dog:before {\r\n  content: \"\\f6d3\"; }\r\n\r\n.la-dollar-sign:before {\r\n  content: \"\\f155\"; }\r\n\r\n.la-dolly:before {\r\n  content: \"\\f472\"; }\r\n\r\n.la-dolly-flatbed:before {\r\n  content: \"\\f474\"; }\r\n\r\n.la-donate:before {\r\n  content: \"\\f4b9\"; }\r\n\r\n.la-door-closed:before {\r\n  content: \"\\f52a\"; }\r\n\r\n.la-door-open:before {\r\n  content: \"\\f52b\"; }\r\n\r\n.la-dot-circle:before {\r\n  content: \"\\f192\"; }\r\n\r\n.la-dove:before {\r\n  content: \"\\f4ba\"; }\r\n\r\n.la-download:before {\r\n  content: \"\\f019\"; }\r\n\r\n.la-draft2digital:before {\r\n  content: \"\\f396\"; }\r\n\r\n.la-drafting-compass:before {\r\n  content: \"\\f568\"; }\r\n\r\n.la-dragon:before {\r\n  content: \"\\f6d5\"; }\r\n\r\n.la-draw-polygon:before {\r\n  content: \"\\f5ee\"; }\r\n\r\n.la-dribbble:before {\r\n  content: \"\\f17d\"; }\r\n\r\n.la-dribbble-square:before {\r\n  content: \"\\f397\"; }\r\n\r\n.la-dropbox:before {\r\n  content: \"\\f16b\"; }\r\n\r\n.la-drum:before {\r\n  content: \"\\f569\"; }\r\n\r\n.la-drum-steelpan:before {\r\n  content: \"\\f56a\"; }\r\n\r\n.la-drumstick-bite:before {\r\n  content: \"\\f6d7\"; }\r\n\r\n.la-drupal:before {\r\n  content: \"\\f1a9\"; }\r\n\r\n.la-dumbbell:before {\r\n  content: \"\\f44b\"; }\r\n\r\n.la-dumpster:before {\r\n  content: \"\\f793\"; }\r\n\r\n.la-dumpster-fire:before {\r\n  content: \"\\f794\"; }\r\n\r\n.la-dungeon:before {\r\n  content: \"\\f6d9\"; }\r\n\r\n.la-dyalog:before {\r\n  content: \"\\f399\"; }\r\n\r\n.la-earlybirds:before {\r\n  content: \"\\f39a\"; }\r\n\r\n.la-ebay:before {\r\n  content: \"\\f4f4\"; }\r\n\r\n.la-edge:before {\r\n  content: \"\\f282\"; }\r\n\r\n.la-edit:before {\r\n  content: \"\\f044\"; }\r\n\r\n.la-egg:before {\r\n  content: \"\\f7fb\"; }\r\n\r\n.la-eject:before {\r\n  content: \"\\f052\"; }\r\n\r\n.la-elementor:before {\r\n  content: \"\\f430\"; }\r\n\r\n.la-ellipsis-h:before {\r\n  content: \"\\f141\"; }\r\n\r\n.la-ellipsis-v:before {\r\n  content: \"\\f142\"; }\r\n\r\n.la-ello:before {\r\n  content: \"\\f5f1\"; }\r\n\r\n.la-ember:before {\r\n  content: \"\\f423\"; }\r\n\r\n.la-empire:before {\r\n  content: \"\\f1d1\"; }\r\n\r\n.la-envelope:before {\r\n  content: \"\\f0e0\"; }\r\n\r\n.la-envelope-open:before {\r\n  content: \"\\f2b6\"; }\r\n\r\n.la-envelope-open-text:before {\r\n  content: \"\\f658\"; }\r\n\r\n.la-envelope-square:before {\r\n  content: \"\\f199\"; }\r\n\r\n.la-envira:before {\r\n  content: \"\\f299\"; }\r\n\r\n.la-equals:before {\r\n  content: \"\\f52c\"; }\r\n\r\n.la-eraser:before {\r\n  content: \"\\f12d\"; }\r\n\r\n.la-erlang:before {\r\n  content: \"\\f39d\"; }\r\n\r\n.la-ethereum:before {\r\n  content: \"\\f42e\"; }\r\n\r\n.la-ethernet:before {\r\n  content: \"\\f796\"; }\r\n\r\n.la-etsy:before {\r\n  content: \"\\f2d7\"; }\r\n\r\n.la-euro-sign:before {\r\n  content: \"\\f153\"; }\r\n\r\n.la-evernote:before {\r\n  content: \"\\f839\"; }\r\n\r\n.la-exchange-alt:before {\r\n  content: \"\\f362\"; }\r\n\r\n.la-exclamation:before {\r\n  content: \"\\f12a\"; }\r\n\r\n.la-exclamation-circle:before {\r\n  content: \"\\f06a\"; }\r\n\r\n.la-exclamation-triangle:before {\r\n  content: \"\\f071\"; }\r\n\r\n.la-expand:before {\r\n  content: \"\\f065\"; }\r\n\r\n.la-expand-arrows-alt:before {\r\n  content: \"\\f31e\"; }\r\n\r\n.la-expeditedssl:before {\r\n  content: \"\\f23e\"; }\r\n\r\n.la-external-link-alt:before {\r\n  content: \"\\f35d\"; }\r\n\r\n.la-external-link-square-alt:before {\r\n  content: \"\\f360\"; }\r\n\r\n.la-eye:before {\r\n  content: \"\\f06e\"; }\r\n\r\n.la-eye-dropper:before {\r\n  content: \"\\f1fb\"; }\r\n\r\n.la-eye-slash:before {\r\n  content: \"\\f070\"; }\r\n\r\n.la-facebook:before {\r\n  content: \"\\f09a\"; }\r\n\r\n.la-facebook-f:before {\r\n  content: \"\\f39e\"; }\r\n\r\n.la-facebook-messenger:before {\r\n  content: \"\\f39f\"; }\r\n\r\n.la-facebook-square:before {\r\n  content: \"\\f082\"; }\r\n\r\n.la-fan:before {\r\n  content: \"\\f863\"; }\r\n\r\n.la-fantasy-flight-games:before {\r\n  content: \"\\f6dc\"; }\r\n\r\n.la-fast-backward:before {\r\n  content: \"\\f049\"; }\r\n\r\n.la-fast-forward:before {\r\n  content: \"\\f050\"; }\r\n\r\n.la-fax:before {\r\n  content: \"\\f1ac\"; }\r\n\r\n.la-feather:before {\r\n  content: \"\\f52d\"; }\r\n\r\n.la-feather-alt:before {\r\n  content: \"\\f56b\"; }\r\n\r\n.la-fedex:before {\r\n  content: \"\\f797\"; }\r\n\r\n.la-fedora:before {\r\n  content: \"\\f798\"; }\r\n\r\n.la-female:before {\r\n  content: \"\\f182\"; }\r\n\r\n.la-fighter-jet:before {\r\n  content: \"\\f0fb\"; }\r\n\r\n.la-figma:before {\r\n  content: \"\\f799\"; }\r\n\r\n.la-file:before {\r\n  content: \"\\f15b\"; }\r\n\r\n.la-file-alt:before {\r\n  content: \"\\f15c\"; }\r\n\r\n.la-file-archive:before {\r\n  content: \"\\f1c6\"; }\r\n\r\n.la-file-audio:before {\r\n  content: \"\\f1c7\"; }\r\n\r\n.la-file-code:before {\r\n  content: \"\\f1c9\"; }\r\n\r\n.la-file-contract:before {\r\n  content: \"\\f56c\"; }\r\n\r\n.la-file-csv:before {\r\n  content: \"\\f6dd\"; }\r\n\r\n.la-file-download:before {\r\n  content: \"\\f56d\"; }\r\n\r\n.la-file-excel:before {\r\n  content: \"\\f1c3\"; }\r\n\r\n.la-file-export:before {\r\n  content: \"\\f56e\"; }\r\n\r\n.la-file-image:before {\r\n  content: \"\\f1c5\"; }\r\n\r\n.la-file-import:before {\r\n  content: \"\\f56f\"; }\r\n\r\n.la-file-invoice:before {\r\n  content: \"\\f570\"; }\r\n\r\n.la-file-invoice-dollar:before {\r\n  content: \"\\f571\"; }\r\n\r\n.la-file-medical:before {\r\n  content: \"\\f477\"; }\r\n\r\n.la-file-medical-alt:before {\r\n  content: \"\\f478\"; }\r\n\r\n.la-file-pdf:before {\r\n  content: \"\\f1c1\"; }\r\n\r\n.la-file-powerpoint:before {\r\n  content: \"\\f1c4\"; }\r\n\r\n.la-file-prescription:before {\r\n  content: \"\\f572\"; }\r\n\r\n.la-file-signature:before {\r\n  content: \"\\f573\"; }\r\n\r\n.la-file-upload:before {\r\n  content: \"\\f574\"; }\r\n\r\n.la-file-video:before {\r\n  content: \"\\f1c8\"; }\r\n\r\n.la-file-word:before {\r\n  content: \"\\f1c2\"; }\r\n\r\n.la-fill:before {\r\n  content: \"\\f575\"; }\r\n\r\n.la-fill-drip:before {\r\n  content: \"\\f576\"; }\r\n\r\n.la-film:before {\r\n  content: \"\\f008\"; }\r\n\r\n.la-filter:before {\r\n  content: \"\\f0b0\"; }\r\n\r\n.la-fingerprint:before {\r\n  content: \"\\f577\"; }\r\n\r\n.la-fire:before {\r\n  content: \"\\f06d\"; }\r\n\r\n.la-fire-alt:before {\r\n  content: \"\\f7e4\"; }\r\n\r\n.la-fire-extinguisher:before {\r\n  content: \"\\f134\"; }\r\n\r\n.la-firefox:before {\r\n  content: \"\\f269\"; }\r\n\r\n.la-first-aid:before {\r\n  content: \"\\f479\"; }\r\n\r\n.la-first-order:before {\r\n  content: \"\\f2b0\"; }\r\n\r\n.la-first-order-alt:before {\r\n  content: \"\\f50a\"; }\r\n\r\n.la-firstdraft:before {\r\n  content: \"\\f3a1\"; }\r\n\r\n.la-fish:before {\r\n  content: \"\\f578\"; }\r\n\r\n.la-fist-raised:before {\r\n  content: \"\\f6de\"; }\r\n\r\n.la-flag:before {\r\n  content: \"\\f024\"; }\r\n\r\n.la-flag-checkered:before {\r\n  content: \"\\f11e\"; }\r\n\r\n.la-flag-usa:before {\r\n  content: \"\\f74d\"; }\r\n\r\n.la-flask:before {\r\n  content: \"\\f0c3\"; }\r\n\r\n.la-flickr:before {\r\n  content: \"\\f16e\"; }\r\n\r\n.la-flipboard:before {\r\n  content: \"\\f44d\"; }\r\n\r\n.la-flushed:before {\r\n  content: \"\\f579\"; }\r\n\r\n.la-fly:before {\r\n  content: \"\\f417\"; }\r\n\r\n.la-folder:before {\r\n  content: \"\\f07b\"; }\r\n\r\n.la-folder-minus:before {\r\n  content: \"\\f65d\"; }\r\n\r\n.la-folder-open:before {\r\n  content: \"\\f07c\"; }\r\n\r\n.la-folder-plus:before {\r\n  content: \"\\f65e\"; }\r\n\r\n.la-font:before {\r\n  content: \"\\f031\"; }\r\n\r\n.la-font-awesome:before {\r\n  content: \"\\f2b4\"; }\r\n\r\n.la-font-awesome-alt:before {\r\n  content: \"\\f35c\"; }\r\n\r\n.la-font-awesome-flag:before {\r\n  content: \"\\f425\"; }\r\n\r\n.la-font-awesome-logo-full:before {\r\n  content: \"\\f4e6\"; }\r\n\r\n.la-fonticons:before {\r\n  content: \"\\f280\"; }\r\n\r\n.la-fonticons-fi:before {\r\n  content: \"\\f3a2\"; }\r\n\r\n.la-football-ball:before {\r\n  content: \"\\f44e\"; }\r\n\r\n.la-fort-awesome:before {\r\n  content: \"\\f286\"; }\r\n\r\n.la-fort-awesome-alt:before {\r\n  content: \"\\f3a3\"; }\r\n\r\n.la-forumbee:before {\r\n  content: \"\\f211\"; }\r\n\r\n.la-forward:before {\r\n  content: \"\\f04e\"; }\r\n\r\n.la-foursquare:before {\r\n  content: \"\\f180\"; }\r\n\r\n.la-free-code-camp:before {\r\n  content: \"\\f2c5\"; }\r\n\r\n.la-freebsd:before {\r\n  content: \"\\f3a4\"; }\r\n\r\n.la-frog:before {\r\n  content: \"\\f52e\"; }\r\n\r\n.la-frown:before {\r\n  content: \"\\f119\"; }\r\n\r\n.la-frown-open:before {\r\n  content: \"\\f57a\"; }\r\n\r\n.la-fulcrum:before {\r\n  content: \"\\f50b\"; }\r\n\r\n.la-funnel-dollar:before {\r\n  content: \"\\f662\"; }\r\n\r\n.la-futbol:before {\r\n  content: \"\\f1e3\"; }\r\n\r\n.la-galactic-republic:before {\r\n  content: \"\\f50c\"; }\r\n\r\n.la-galactic-senate:before {\r\n  content: \"\\f50d\"; }\r\n\r\n.la-gamepad:before {\r\n  content: \"\\f11b\"; }\r\n\r\n.la-gas-pump:before {\r\n  content: \"\\f52f\"; }\r\n\r\n.la-gavel:before {\r\n  content: \"\\f0e3\"; }\r\n\r\n.la-gem:before {\r\n  content: \"\\f3a5\"; }\r\n\r\n.la-genderless:before {\r\n  content: \"\\f22d\"; }\r\n\r\n.la-get-pocket:before {\r\n  content: \"\\f265\"; }\r\n\r\n.la-gg:before {\r\n  content: \"\\f260\"; }\r\n\r\n.la-gg-circle:before {\r\n  content: \"\\f261\"; }\r\n\r\n.la-ghost:before {\r\n  content: \"\\f6e2\"; }\r\n\r\n.la-gift:before {\r\n  content: \"\\f06b\"; }\r\n\r\n.la-gifts:before {\r\n  content: \"\\f79c\"; }\r\n\r\n.la-git:before {\r\n  content: \"\\f1d3\"; }\r\n\r\n.la-git-alt:before {\r\n  content: \"\\f841\"; }\r\n\r\n.la-git-square:before {\r\n  content: \"\\f1d2\"; }\r\n\r\n.la-github:before {\r\n  content: \"\\f09b\"; }\r\n\r\n.la-github-alt:before {\r\n  content: \"\\f113\"; }\r\n\r\n.la-github-square:before {\r\n  content: \"\\f092\"; }\r\n\r\n.la-gitkraken:before {\r\n  content: \"\\f3a6\"; }\r\n\r\n.la-gitlab:before {\r\n  content: \"\\f296\"; }\r\n\r\n.la-gitter:before {\r\n  content: \"\\f426\"; }\r\n\r\n.la-glass-cheers:before {\r\n  content: \"\\f79f\"; }\r\n\r\n.la-glass-martini:before {\r\n  content: \"\\f000\"; }\r\n\r\n.la-glass-martini-alt:before {\r\n  content: \"\\f57b\"; }\r\n\r\n.la-glass-whiskey:before {\r\n  content: \"\\f7a0\"; }\r\n\r\n.la-glasses:before {\r\n  content: \"\\f530\"; }\r\n\r\n.la-glide:before {\r\n  content: \"\\f2a5\"; }\r\n\r\n.la-glide-g:before {\r\n  content: \"\\f2a6\"; }\r\n\r\n.la-globe:before {\r\n  content: \"\\f0ac\"; }\r\n\r\n.la-globe-africa:before {\r\n  content: \"\\f57c\"; }\r\n\r\n.la-globe-americas:before {\r\n  content: \"\\f57d\"; }\r\n\r\n.la-globe-asia:before {\r\n  content: \"\\f57e\"; }\r\n\r\n.la-globe-europe:before {\r\n  content: \"\\f7a2\"; }\r\n\r\n.la-gofore:before {\r\n  content: \"\\f3a7\"; }\r\n\r\n.la-golf-ball:before {\r\n  content: \"\\f450\"; }\r\n\r\n.la-goodreads:before {\r\n  content: \"\\f3a8\"; }\r\n\r\n.la-goodreads-g:before {\r\n  content: \"\\f3a9\"; }\r\n\r\n.la-google:before {\r\n  content: \"\\f1a0\"; }\r\n\r\n.la-google-drive:before {\r\n  content: \"\\f3aa\"; }\r\n\r\n.la-google-play:before {\r\n  content: \"\\f3ab\"; }\r\n\r\n.la-google-plus:before {\r\n  content: \"\\f2b3\"; }\r\n\r\n.la-google-plus-g:before {\r\n  content: \"\\f0d5\"; }\r\n\r\n.la-google-plus-square:before {\r\n  content: \"\\f0d4\"; }\r\n\r\n.la-google-wallet:before {\r\n  content: \"\\f1ee\"; }\r\n\r\n.la-gopuram:before {\r\n  content: \"\\f664\"; }\r\n\r\n.la-graduation-cap:before {\r\n  content: \"\\f19d\"; }\r\n\r\n.la-gratipay:before {\r\n  content: \"\\f184\"; }\r\n\r\n.la-grav:before {\r\n  content: \"\\f2d6\"; }\r\n\r\n.la-greater-than:before {\r\n  content: \"\\f531\"; }\r\n\r\n.la-greater-than-equal:before {\r\n  content: \"\\f532\"; }\r\n\r\n.la-grimace:before {\r\n  content: \"\\f57f\"; }\r\n\r\n.la-grin:before {\r\n  content: \"\\f580\"; }\r\n\r\n.la-grin-alt:before {\r\n  content: \"\\f581\"; }\r\n\r\n.la-grin-beam:before {\r\n  content: \"\\f582\"; }\r\n\r\n.la-grin-beam-sweat:before {\r\n  content: \"\\f583\"; }\r\n\r\n.la-grin-hearts:before {\r\n  content: \"\\f584\"; }\r\n\r\n.la-grin-squint:before {\r\n  content: \"\\f585\"; }\r\n\r\n.la-grin-squint-tears:before {\r\n  content: \"\\f586\"; }\r\n\r\n.la-grin-stars:before {\r\n  content: \"\\f587\"; }\r\n\r\n.la-grin-tears:before {\r\n  content: \"\\f588\"; }\r\n\r\n.la-grin-tongue:before {\r\n  content: \"\\f589\"; }\r\n\r\n.la-grin-tongue-squint:before {\r\n  content: \"\\f58a\"; }\r\n\r\n.la-grin-tongue-wink:before {\r\n  content: \"\\f58b\"; }\r\n\r\n.la-grin-wink:before {\r\n  content: \"\\f58c\"; }\r\n\r\n.la-grip-horizontal:before {\r\n  content: \"\\f58d\"; }\r\n\r\n.la-grip-lines:before {\r\n  content: \"\\f7a4\"; }\r\n\r\n.la-grip-lines-vertical:before {\r\n  content: \"\\f7a5\"; }\r\n\r\n.la-grip-vertical:before {\r\n  content: \"\\f58e\"; }\r\n\r\n.la-gripfire:before {\r\n  content: \"\\f3ac\"; }\r\n\r\n.la-grunt:before {\r\n  content: \"\\f3ad\"; }\r\n\r\n.la-guitar:before {\r\n  content: \"\\f7a6\"; }\r\n\r\n.la-gulp:before {\r\n  content: \"\\f3ae\"; }\r\n\r\n.la-h-square:before {\r\n  content: \"\\f0fd\"; }\r\n\r\n.la-hacker-news:before {\r\n  content: \"\\f1d4\"; }\r\n\r\n.la-hacker-news-square:before {\r\n  content: \"\\f3af\"; }\r\n\r\n.la-hackerrank:before {\r\n  content: \"\\f5f7\"; }\r\n\r\n.la-hamburger:before {\r\n  content: \"\\f805\"; }\r\n\r\n.la-hammer:before {\r\n  content: \"\\f6e3\"; }\r\n\r\n.la-hamsa:before {\r\n  content: \"\\f665\"; }\r\n\r\n.la-hand-holding:before {\r\n  content: \"\\f4bd\"; }\r\n\r\n.la-hand-holding-heart:before {\r\n  content: \"\\f4be\"; }\r\n\r\n.la-hand-holding-usd:before {\r\n  content: \"\\f4c0\"; }\r\n\r\n.la-hand-lizard:before {\r\n  content: \"\\f258\"; }\r\n\r\n.la-hand-middle-finger:before {\r\n  content: \"\\f806\"; }\r\n\r\n.la-hand-paper:before {\r\n  content: \"\\f256\"; }\r\n\r\n.la-hand-peace:before {\r\n  content: \"\\f25b\"; }\r\n\r\n.la-hand-point-down:before {\r\n  content: \"\\f0a7\"; }\r\n\r\n.la-hand-point-left:before {\r\n  content: \"\\f0a5\"; }\r\n\r\n.la-hand-point-right:before {\r\n  content: \"\\f0a4\"; }\r\n\r\n.la-hand-point-up:before {\r\n  content: \"\\f0a6\"; }\r\n\r\n.la-hand-pointer:before {\r\n  content: \"\\f25a\"; }\r\n\r\n.la-hand-rock:before {\r\n  content: \"\\f255\"; }\r\n\r\n.la-hand-scissors:before {\r\n  content: \"\\f257\"; }\r\n\r\n.la-hand-spock:before {\r\n  content: \"\\f259\"; }\r\n\r\n.la-hands:before {\r\n  content: \"\\f4c2\"; }\r\n\r\n.la-hands-helping:before {\r\n  content: \"\\f4c4\"; }\r\n\r\n.la-handshake:before {\r\n  content: \"\\f2b5\"; }\r\n\r\n.la-hanukiah:before {\r\n  content: \"\\f6e6\"; }\r\n\r\n.la-hard-hat:before {\r\n  content: \"\\f807\"; }\r\n\r\n.la-hashtag:before {\r\n  content: \"\\f292\"; }\r\n\r\n.la-hat-cowboy:before {\r\n  content: \"\\f8c0\"; }\r\n\r\n.la-hat-cowboy-side:before {\r\n  content: \"\\f8c1\"; }\r\n\r\n.la-hat-wizard:before {\r\n  content: \"\\f6e8\"; }\r\n\r\n.la-haykal:before {\r\n  content: \"\\f666\"; }\r\n\r\n.la-hdd:before {\r\n  content: \"\\f0a0\"; }\r\n\r\n.la-heading:before {\r\n  content: \"\\f1dc\"; }\r\n\r\n.la-headphones:before {\r\n  content: \"\\f025\"; }\r\n\r\n.la-headphones-alt:before {\r\n  content: \"\\f58f\"; }\r\n\r\n.la-headset:before {\r\n  content: \"\\f590\"; }\r\n\r\n.la-heart:before {\r\n  content: \"\\f004\"; }\r\n\r\n.la-heart-broken:before {\r\n  content: \"\\f7a9\"; }\r\n\r\n.la-heartbeat:before {\r\n  content: \"\\f21e\"; }\r\n\r\n.la-helicopter:before {\r\n  content: \"\\f533\"; }\r\n\r\n.la-highlighter:before {\r\n  content: \"\\f591\"; }\r\n\r\n.la-hiking:before {\r\n  content: \"\\f6ec\"; }\r\n\r\n.la-hippo:before {\r\n  content: \"\\f6ed\"; }\r\n\r\n.la-hips:before {\r\n  content: \"\\f452\"; }\r\n\r\n.la-hire-a-helper:before {\r\n  content: \"\\f3b0\"; }\r\n\r\n.la-history:before {\r\n  content: \"\\f1da\"; }\r\n\r\n.la-hockey-puck:before {\r\n  content: \"\\f453\"; }\r\n\r\n.la-holly-berry:before {\r\n  content: \"\\f7aa\"; }\r\n\r\n.la-home:before {\r\n  content: \"\\f015\"; }\r\n\r\n.la-hooli:before {\r\n  content: \"\\f427\"; }\r\n\r\n.la-hornbill:before {\r\n  content: \"\\f592\"; }\r\n\r\n.la-horse:before {\r\n  content: \"\\f6f0\"; }\r\n\r\n.la-horse-head:before {\r\n  content: \"\\f7ab\"; }\r\n\r\n.la-hospital:before {\r\n  content: \"\\f0f8\"; }\r\n\r\n.la-hospital-alt:before {\r\n  content: \"\\f47d\"; }\r\n\r\n.la-hospital-symbol:before {\r\n  content: \"\\f47e\"; }\r\n\r\n.la-hot-tub:before {\r\n  content: \"\\f593\"; }\r\n\r\n.la-hotdog:before {\r\n  content: \"\\f80f\"; }\r\n\r\n.la-hotel:before {\r\n  content: \"\\f594\"; }\r\n\r\n.la-hotjar:before {\r\n  content: \"\\f3b1\"; }\r\n\r\n.la-hourglass:before {\r\n  content: \"\\f254\"; }\r\n\r\n.la-hourglass-end:before {\r\n  content: \"\\f253\"; }\r\n\r\n.la-hourglass-half:before {\r\n  content: \"\\f252\"; }\r\n\r\n.la-hourglass-start:before {\r\n  content: \"\\f251\"; }\r\n\r\n.la-house-damage:before {\r\n  content: \"\\f6f1\"; }\r\n\r\n.la-houzz:before {\r\n  content: \"\\f27c\"; }\r\n\r\n.la-hryvnia:before {\r\n  content: \"\\f6f2\"; }\r\n\r\n.la-html5:before {\r\n  content: \"\\f13b\"; }\r\n\r\n.la-hubspot:before {\r\n  content: \"\\f3b2\"; }\r\n\r\n.la-i-cursor:before {\r\n  content: \"\\f246\"; }\r\n\r\n.la-ice-cream:before {\r\n  content: \"\\f810\"; }\r\n\r\n.la-icicles:before {\r\n  content: \"\\f7ad\"; }\r\n\r\n.la-icons:before {\r\n  content: \"\\f86d\"; }\r\n\r\n.la-id-badge:before {\r\n  content: \"\\f2c1\"; }\r\n\r\n.la-id-card:before {\r\n  content: \"\\f2c2\"; }\r\n\r\n.la-id-card-alt:before {\r\n  content: \"\\f47f\"; }\r\n\r\n.la-igloo:before {\r\n  content: \"\\f7ae\"; }\r\n\r\n.la-image:before {\r\n  content: \"\\f03e\"; }\r\n\r\n.la-images:before {\r\n  content: \"\\f302\"; }\r\n\r\n.la-imdb:before {\r\n  content: \"\\f2d8\"; }\r\n\r\n.la-inbox:before {\r\n  content: \"\\f01c\"; }\r\n\r\n.la-indent:before {\r\n  content: \"\\f03c\"; }\r\n\r\n.la-industry:before {\r\n  content: \"\\f275\"; }\r\n\r\n.la-infinity:before {\r\n  content: \"\\f534\"; }\r\n\r\n.la-info:before {\r\n  content: \"\\f129\"; }\r\n\r\n.la-info-circle:before {\r\n  content: \"\\f05a\"; }\r\n\r\n.la-instagram:before {\r\n  content: \"\\f16d\"; }\r\n\r\n.la-intercom:before {\r\n  content: \"\\f7af\"; }\r\n\r\n.la-internet-explorer:before {\r\n  content: \"\\f26b\"; }\r\n\r\n.la-invision:before {\r\n  content: \"\\f7b0\"; }\r\n\r\n.la-ioxhost:before {\r\n  content: \"\\f208\"; }\r\n\r\n.la-italic:before {\r\n  content: \"\\f033\"; }\r\n\r\n.la-itch-io:before {\r\n  content: \"\\f83a\"; }\r\n\r\n.la-itunes:before {\r\n  content: \"\\f3b4\"; }\r\n\r\n.la-itunes-note:before {\r\n  content: \"\\f3b5\"; }\r\n\r\n.la-java:before {\r\n  content: \"\\f4e4\"; }\r\n\r\n.la-jedi:before {\r\n  content: \"\\f669\"; }\r\n\r\n.la-jedi-order:before {\r\n  content: \"\\f50e\"; }\r\n\r\n.la-jenkins:before {\r\n  content: \"\\f3b6\"; }\r\n\r\n.la-jira:before {\r\n  content: \"\\f7b1\"; }\r\n\r\n.la-joget:before {\r\n  content: \"\\f3b7\"; }\r\n\r\n.la-joint:before {\r\n  content: \"\\f595\"; }\r\n\r\n.la-joomla:before {\r\n  content: \"\\f1aa\"; }\r\n\r\n.la-journal-whills:before {\r\n  content: \"\\f66a\"; }\r\n\r\n.la-js:before {\r\n  content: \"\\f3b8\"; }\r\n\r\n.la-js-square:before {\r\n  content: \"\\f3b9\"; }\r\n\r\n.la-jsfiddle:before {\r\n  content: \"\\f1cc\"; }\r\n\r\n.la-kaaba:before {\r\n  content: \"\\f66b\"; }\r\n\r\n.la-kaggle:before {\r\n  content: \"\\f5fa\"; }\r\n\r\n.la-key:before {\r\n  content: \"\\f084\"; }\r\n\r\n.la-keybase:before {\r\n  content: \"\\f4f5\"; }\r\n\r\n.la-keyboard:before {\r\n  content: \"\\f11c\"; }\r\n\r\n.la-keycdn:before {\r\n  content: \"\\f3ba\"; }\r\n\r\n.la-khanda:before {\r\n  content: \"\\f66d\"; }\r\n\r\n.la-kickstarter:before {\r\n  content: \"\\f3bb\"; }\r\n\r\n.la-kickstarter-k:before {\r\n  content: \"\\f3bc\"; }\r\n\r\n.la-kiss:before {\r\n  content: \"\\f596\"; }\r\n\r\n.la-kiss-beam:before {\r\n  content: \"\\f597\"; }\r\n\r\n.la-kiss-wink-heart:before {\r\n  content: \"\\f598\"; }\r\n\r\n.la-kiwi-bird:before {\r\n  content: \"\\f535\"; }\r\n\r\n.la-korvue:before {\r\n  content: \"\\f42f\"; }\r\n\r\n.la-landmark:before {\r\n  content: \"\\f66f\"; }\r\n\r\n.la-language:before {\r\n  content: \"\\f1ab\"; }\r\n\r\n.la-laptop:before {\r\n  content: \"\\f109\"; }\r\n\r\n.la-laptop-code:before {\r\n  content: \"\\f5fc\"; }\r\n\r\n.la-laptop-medical:before {\r\n  content: \"\\f812\"; }\r\n\r\n.la-laravel:before {\r\n  content: \"\\f3bd\"; }\r\n\r\n.la-lastfm:before {\r\n  content: \"\\f202\"; }\r\n\r\n.la-lastfm-square:before {\r\n  content: \"\\f203\"; }\r\n\r\n.la-laugh:before {\r\n  content: \"\\f599\"; }\r\n\r\n.la-laugh-beam:before {\r\n  content: \"\\f59a\"; }\r\n\r\n.la-laugh-squint:before {\r\n  content: \"\\f59b\"; }\r\n\r\n.la-laugh-wink:before {\r\n  content: \"\\f59c\"; }\r\n\r\n.la-layer-group:before {\r\n  content: \"\\f5fd\"; }\r\n\r\n.la-leaf:before {\r\n  content: \"\\f06c\"; }\r\n\r\n.la-leanpub:before {\r\n  content: \"\\f212\"; }\r\n\r\n.la-lemon:before {\r\n  content: \"\\f094\"; }\r\n\r\n.la-less:before {\r\n  content: \"\\f41d\"; }\r\n\r\n.la-less-than:before {\r\n  content: \"\\f536\"; }\r\n\r\n.la-less-than-equal:before {\r\n  content: \"\\f537\"; }\r\n\r\n.la-level-down-alt:before {\r\n  content: \"\\f3be\"; }\r\n\r\n.la-level-up-alt:before {\r\n  content: \"\\f3bf\"; }\r\n\r\n.la-life-ring:before {\r\n  content: \"\\f1cd\"; }\r\n\r\n.la-lightbulb:before {\r\n  content: \"\\f0eb\"; }\r\n\r\n.la-line:before {\r\n  content: \"\\f3c0\"; }\r\n\r\n.la-link:before {\r\n  content: \"\\f0c1\"; }\r\n\r\n.la-linkedin:before {\r\n  content: \"\\f08c\"; }\r\n\r\n.la-linkedin-in:before {\r\n  content: \"\\f0e1\"; }\r\n\r\n.la-linode:before {\r\n  content: \"\\f2b8\"; }\r\n\r\n.la-linux:before {\r\n  content: \"\\f17c\"; }\r\n\r\n.la-lira-sign:before {\r\n  content: \"\\f195\"; }\r\n\r\n.la-list:before {\r\n  content: \"\\f03a\"; }\r\n\r\n.la-list-alt:before {\r\n  content: \"\\f022\"; }\r\n\r\n.la-list-ol:before {\r\n  content: \"\\f0cb\"; }\r\n\r\n.la-list-ul:before {\r\n  content: \"\\f0ca\"; }\r\n\r\n.la-location-arrow:before {\r\n  content: \"\\f124\"; }\r\n\r\n.la-lock:before {\r\n  content: \"\\f023\"; }\r\n\r\n.la-lock-open:before {\r\n  content: \"\\f3c1\"; }\r\n\r\n.la-long-arrow-alt-down:before {\r\n  content: \"\\f309\"; }\r\n\r\n.la-long-arrow-alt-left:before {\r\n  content: \"\\f30a\"; }\r\n\r\n.la-long-arrow-alt-right:before {\r\n  content: \"\\f30b\"; }\r\n\r\n.la-long-arrow-alt-up:before {\r\n  content: \"\\f30c\"; }\r\n\r\n.la-low-vision:before {\r\n  content: \"\\f2a8\"; }\r\n\r\n.la-luggage-cart:before {\r\n  content: \"\\f59d\"; }\r\n\r\n.la-lyft:before {\r\n  content: \"\\f3c3\"; }\r\n\r\n.la-magento:before {\r\n  content: \"\\f3c4\"; }\r\n\r\n.la-magic:before {\r\n  content: \"\\f0d0\"; }\r\n\r\n.la-magnet:before {\r\n  content: \"\\f076\"; }\r\n\r\n.la-mail-bulk:before {\r\n  content: \"\\f674\"; }\r\n\r\n.la-mailchimp:before {\r\n  content: \"\\f59e\"; }\r\n\r\n.la-male:before {\r\n  content: \"\\f183\"; }\r\n\r\n.la-mandalorian:before {\r\n  content: \"\\f50f\"; }\r\n\r\n.la-map:before {\r\n  content: \"\\f279\"; }\r\n\r\n.la-map-marked:before {\r\n  content: \"\\f59f\"; }\r\n\r\n.la-map-marked-alt:before {\r\n  content: \"\\f5a0\"; }\r\n\r\n.la-map-marker:before {\r\n  content: \"\\f041\"; }\r\n\r\n.la-map-marker-alt:before {\r\n  content: \"\\f3c5\"; }\r\n\r\n.la-map-pin:before {\r\n  content: \"\\f276\"; }\r\n\r\n.la-map-signs:before {\r\n  content: \"\\f277\"; }\r\n\r\n.la-markdown:before {\r\n  content: \"\\f60f\"; }\r\n\r\n.la-marker:before {\r\n  content: \"\\f5a1\"; }\r\n\r\n.la-mars:before {\r\n  content: \"\\f222\"; }\r\n\r\n.la-mars-double:before {\r\n  content: \"\\f227\"; }\r\n\r\n.la-mars-stroke:before {\r\n  content: \"\\f229\"; }\r\n\r\n.la-mars-stroke-h:before {\r\n  content: \"\\f22b\"; }\r\n\r\n.la-mars-stroke-v:before {\r\n  content: \"\\f22a\"; }\r\n\r\n.la-mask:before {\r\n  content: \"\\f6fa\"; }\r\n\r\n.la-mastodon:before {\r\n  content: \"\\f4f6\"; }\r\n\r\n.la-maxcdn:before {\r\n  content: \"\\f136\"; }\r\n\r\n.la-mdb:before {\r\n  content: \"\\f8ca\"; }\r\n\r\n.la-medal:before {\r\n  content: \"\\f5a2\"; }\r\n\r\n.la-medapps:before {\r\n  content: \"\\f3c6\"; }\r\n\r\n.la-medium:before {\r\n  content: \"\\f23a\"; }\r\n\r\n.la-medium-m:before {\r\n  content: \"\\f3c7\"; }\r\n\r\n.la-medkit:before {\r\n  content: \"\\f0fa\"; }\r\n\r\n.la-medrt:before {\r\n  content: \"\\f3c8\"; }\r\n\r\n.la-meetup:before {\r\n  content: \"\\f2e0\"; }\r\n\r\n.la-megaport:before {\r\n  content: \"\\f5a3\"; }\r\n\r\n.la-meh:before {\r\n  content: \"\\f11a\"; }\r\n\r\n.la-meh-blank:before {\r\n  content: \"\\f5a4\"; }\r\n\r\n.la-meh-rolling-eyes:before {\r\n  content: \"\\f5a5\"; }\r\n\r\n.la-memory:before {\r\n  content: \"\\f538\"; }\r\n\r\n.la-mendeley:before {\r\n  content: \"\\f7b3\"; }\r\n\r\n.la-menorah:before {\r\n  content: \"\\f676\"; }\r\n\r\n.la-mercury:before {\r\n  content: \"\\f223\"; }\r\n\r\n.la-meteor:before {\r\n  content: \"\\f753\"; }\r\n\r\n.la-microchip:before {\r\n  content: \"\\f2db\"; }\r\n\r\n.la-microphone:before {\r\n  content: \"\\f130\"; }\r\n\r\n.la-microphone-alt:before {\r\n  content: \"\\f3c9\"; }\r\n\r\n.la-microphone-alt-slash:before {\r\n  content: \"\\f539\"; }\r\n\r\n.la-microphone-slash:before {\r\n  content: \"\\f131\"; }\r\n\r\n.la-microscope:before {\r\n  content: \"\\f610\"; }\r\n\r\n.la-microsoft:before {\r\n  content: \"\\f3ca\"; }\r\n\r\n.la-minus:before {\r\n  content: \"\\f068\"; }\r\n\r\n.la-minus-circle:before {\r\n  content: \"\\f056\"; }\r\n\r\n.la-minus-square:before {\r\n  content: \"\\f146\"; }\r\n\r\n.la-mitten:before {\r\n  content: \"\\f7b5\"; }\r\n\r\n.la-mix:before {\r\n  content: \"\\f3cb\"; }\r\n\r\n.la-mixcloud:before {\r\n  content: \"\\f289\"; }\r\n\r\n.la-mizuni:before {\r\n  content: \"\\f3cc\"; }\r\n\r\n.la-mobile:before {\r\n  content: \"\\f10b\"; }\r\n\r\n.la-mobile-alt:before {\r\n  content: \"\\f3cd\"; }\r\n\r\n.la-modx:before {\r\n  content: \"\\f285\"; }\r\n\r\n.la-monero:before {\r\n  content: \"\\f3d0\"; }\r\n\r\n.la-money-bill:before {\r\n  content: \"\\f0d6\"; }\r\n\r\n.la-money-bill-alt:before {\r\n  content: \"\\f3d1\"; }\r\n\r\n.la-money-bill-wave:before {\r\n  content: \"\\f53a\"; }\r\n\r\n.la-money-bill-wave-alt:before {\r\n  content: \"\\f53b\"; }\r\n\r\n.la-money-check:before {\r\n  content: \"\\f53c\"; }\r\n\r\n.la-money-check-alt:before {\r\n  content: \"\\f53d\"; }\r\n\r\n.la-monument:before {\r\n  content: \"\\f5a6\"; }\r\n\r\n.la-moon:before {\r\n  content: \"\\f186\"; }\r\n\r\n.la-mortar-pestle:before {\r\n  content: \"\\f5a7\"; }\r\n\r\n.la-mosque:before {\r\n  content: \"\\f678\"; }\r\n\r\n.la-motorcycle:before {\r\n  content: \"\\f21c\"; }\r\n\r\n.la-mountain:before {\r\n  content: \"\\f6fc\"; }\r\n\r\n.la-mouse:before {\r\n  content: \"\\f8cc\"; }\r\n\r\n.la-mouse-pointer:before {\r\n  content: \"\\f245\"; }\r\n\r\n.la-mug-hot:before {\r\n  content: \"\\f7b6\"; }\r\n\r\n.la-music:before {\r\n  content: \"\\f001\"; }\r\n\r\n.la-napster:before {\r\n  content: \"\\f3d2\"; }\r\n\r\n.la-neos:before {\r\n  content: \"\\f612\"; }\r\n\r\n.la-network-wired:before {\r\n  content: \"\\f6ff\"; }\r\n\r\n.la-neuter:before {\r\n  content: \"\\f22c\"; }\r\n\r\n.la-newspaper:before {\r\n  content: \"\\f1ea\"; }\r\n\r\n.la-nimblr:before {\r\n  content: \"\\f5a8\"; }\r\n\r\n.la-node:before {\r\n  content: \"\\f419\"; }\r\n\r\n.la-node-js:before {\r\n  content: \"\\f3d3\"; }\r\n\r\n.la-not-equal:before {\r\n  content: \"\\f53e\"; }\r\n\r\n.la-notes-medical:before {\r\n  content: \"\\f481\"; }\r\n\r\n.la-npm:before {\r\n  content: \"\\f3d4\"; }\r\n\r\n.la-ns8:before {\r\n  content: \"\\f3d5\"; }\r\n\r\n.la-nutritionix:before {\r\n  content: \"\\f3d6\"; }\r\n\r\n.la-object-group:before {\r\n  content: \"\\f247\"; }\r\n\r\n.la-object-ungroup:before {\r\n  content: \"\\f248\"; }\r\n\r\n.la-odnoklassniki:before {\r\n  content: \"\\f263\"; }\r\n\r\n.la-odnoklassniki-square:before {\r\n  content: \"\\f264\"; }\r\n\r\n.la-oil-can:before {\r\n  content: \"\\f613\"; }\r\n\r\n.la-old-republic:before {\r\n  content: \"\\f510\"; }\r\n\r\n.la-om:before {\r\n  content: \"\\f679\"; }\r\n\r\n.la-opencart:before {\r\n  content: \"\\f23d\"; }\r\n\r\n.la-openid:before {\r\n  content: \"\\f19b\"; }\r\n\r\n.la-opera:before {\r\n  content: \"\\f26a\"; }\r\n\r\n.la-optin-monster:before {\r\n  content: \"\\f23c\"; }\r\n\r\n.la-orcid:before {\r\n  content: \"\\f8d2\"; }\r\n\r\n.la-osi:before {\r\n  content: \"\\f41a\"; }\r\n\r\n.la-otter:before {\r\n  content: \"\\f700\"; }\r\n\r\n.la-outdent:before {\r\n  content: \"\\f03b\"; }\r\n\r\n.la-page4:before {\r\n  content: \"\\f3d7\"; }\r\n\r\n.la-pagelines:before {\r\n  content: \"\\f18c\"; }\r\n\r\n.la-pager:before {\r\n  content: \"\\f815\"; }\r\n\r\n.la-paint-brush:before {\r\n  content: \"\\f1fc\"; }\r\n\r\n.la-paint-roller:before {\r\n  content: \"\\f5aa\"; }\r\n\r\n.la-palette:before {\r\n  content: \"\\f53f\"; }\r\n\r\n.la-palfed:before {\r\n  content: \"\\f3d8\"; }\r\n\r\n.la-pallet:before {\r\n  content: \"\\f482\"; }\r\n\r\n.la-paper-plane:before {\r\n  content: \"\\f1d8\"; }\r\n\r\n.la-paperclip:before {\r\n  content: \"\\f0c6\"; }\r\n\r\n.la-parachute-box:before {\r\n  content: \"\\f4cd\"; }\r\n\r\n.la-paragraph:before {\r\n  content: \"\\f1dd\"; }\r\n\r\n.la-parking:before {\r\n  content: \"\\f540\"; }\r\n\r\n.la-passport:before {\r\n  content: \"\\f5ab\"; }\r\n\r\n.la-pastafarianism:before {\r\n  content: \"\\f67b\"; }\r\n\r\n.la-paste:before {\r\n  content: \"\\f0ea\"; }\r\n\r\n.la-patreon:before {\r\n  content: \"\\f3d9\"; }\r\n\r\n.la-pause:before {\r\n  content: \"\\f04c\"; }\r\n\r\n.la-pause-circle:before {\r\n  content: \"\\f28b\"; }\r\n\r\n.la-paw:before {\r\n  content: \"\\f1b0\"; }\r\n\r\n.la-paypal:before {\r\n  content: \"\\f1ed\"; }\r\n\r\n.la-peace:before {\r\n  content: \"\\f67c\"; }\r\n\r\n.la-pen:before {\r\n  content: \"\\f304\"; }\r\n\r\n.la-pen-alt:before {\r\n  content: \"\\f305\"; }\r\n\r\n.la-pen-fancy:before {\r\n  content: \"\\f5ac\"; }\r\n\r\n.la-pen-nib:before {\r\n  content: \"\\f5ad\"; }\r\n\r\n.la-pen-square:before {\r\n  content: \"\\f14b\"; }\r\n\r\n.la-pencil-alt:before {\r\n  content: \"\\f303\"; }\r\n\r\n.la-pencil-ruler:before {\r\n  content: \"\\f5ae\"; }\r\n\r\n.la-penny-arcade:before {\r\n  content: \"\\f704\"; }\r\n\r\n.la-people-carry:before {\r\n  content: \"\\f4ce\"; }\r\n\r\n.la-pepper-hot:before {\r\n  content: \"\\f816\"; }\r\n\r\n.la-percent:before {\r\n  content: \"\\f295\"; }\r\n\r\n.la-percentage:before {\r\n  content: \"\\f541\"; }\r\n\r\n.la-periscope:before {\r\n  content: \"\\f3da\"; }\r\n\r\n.la-person-booth:before {\r\n  content: \"\\f756\"; }\r\n\r\n.la-phabricator:before {\r\n  content: \"\\f3db\"; }\r\n\r\n.la-phoenix-framework:before {\r\n  content: \"\\f3dc\"; }\r\n\r\n.la-phoenix-squadron:before {\r\n  content: \"\\f511\"; }\r\n\r\n.la-phone:before {\r\n  content: \"\\f095\"; }\r\n\r\n.la-phone-alt:before {\r\n  content: \"\\f879\"; }\r\n\r\n.la-phone-slash:before {\r\n  content: \"\\f3dd\"; }\r\n\r\n.la-phone-square:before {\r\n  content: \"\\f098\"; }\r\n\r\n.la-phone-square-alt:before {\r\n  content: \"\\f87b\"; }\r\n\r\n.la-phone-volume:before {\r\n  content: \"\\f2a0\"; }\r\n\r\n.la-photo-video:before {\r\n  content: \"\\f87c\"; }\r\n\r\n.la-php:before {\r\n  content: \"\\f457\"; }\r\n\r\n.la-pied-piper:before {\r\n  content: \"\\f2ae\"; }\r\n\r\n.la-pied-piper-alt:before {\r\n  content: \"\\f1a8\"; }\r\n\r\n.la-pied-piper-hat:before {\r\n  content: \"\\f4e5\"; }\r\n\r\n.la-pied-piper-pp:before {\r\n  content: \"\\f1a7\"; }\r\n\r\n.la-piggy-bank:before {\r\n  content: \"\\f4d3\"; }\r\n\r\n.la-pills:before {\r\n  content: \"\\f484\"; }\r\n\r\n.la-pinterest:before {\r\n  content: \"\\f0d2\"; }\r\n\r\n.la-pinterest-p:before {\r\n  content: \"\\f231\"; }\r\n\r\n.la-pinterest-square:before {\r\n  content: \"\\f0d3\"; }\r\n\r\n.la-pizza-slice:before {\r\n  content: \"\\f818\"; }\r\n\r\n.la-place-of-worship:before {\r\n  content: \"\\f67f\"; }\r\n\r\n.la-plane:before {\r\n  content: \"\\f072\"; }\r\n\r\n.la-plane-arrival:before {\r\n  content: \"\\f5af\"; }\r\n\r\n.la-plane-departure:before {\r\n  content: \"\\f5b0\"; }\r\n\r\n.la-play:before {\r\n  content: \"\\f04b\"; }\r\n\r\n.la-play-circle:before {\r\n  content: \"\\f144\"; }\r\n\r\n.la-playstation:before {\r\n  content: \"\\f3df\"; }\r\n\r\n.la-plug:before {\r\n  content: \"\\f1e6\"; }\r\n\r\n.la-plus:before {\r\n  content: \"\\f067\"; }\r\n\r\n.la-plus-circle:before {\r\n  content: \"\\f055\"; }\r\n\r\n.la-plus-square:before {\r\n  content: \"\\f0fe\"; }\r\n\r\n.la-podcast:before {\r\n  content: \"\\f2ce\"; }\r\n\r\n.la-poll:before {\r\n  content: \"\\f681\"; }\r\n\r\n.la-poll-h:before {\r\n  content: \"\\f682\"; }\r\n\r\n.la-poo:before {\r\n  content: \"\\f2fe\"; }\r\n\r\n.la-poo-storm:before {\r\n  content: \"\\f75a\"; }\r\n\r\n.la-poop:before {\r\n  content: \"\\f619\"; }\r\n\r\n.la-portrait:before {\r\n  content: \"\\f3e0\"; }\r\n\r\n.la-pound-sign:before {\r\n  content: \"\\f154\"; }\r\n\r\n.la-power-off:before {\r\n  content: \"\\f011\"; }\r\n\r\n.la-pray:before {\r\n  content: \"\\f683\"; }\r\n\r\n.la-praying-hands:before {\r\n  content: \"\\f684\"; }\r\n\r\n.la-prescription:before {\r\n  content: \"\\f5b1\"; }\r\n\r\n.la-prescription-bottle:before {\r\n  content: \"\\f485\"; }\r\n\r\n.la-prescription-bottle-alt:before {\r\n  content: \"\\f486\"; }\r\n\r\n.la-print:before {\r\n  content: \"\\f02f\"; }\r\n\r\n.la-procedures:before {\r\n  content: \"\\f487\"; }\r\n\r\n.la-product-hunt:before {\r\n  content: \"\\f288\"; }\r\n\r\n.la-project-diagram:before {\r\n  content: \"\\f542\"; }\r\n\r\n.la-pushed:before {\r\n  content: \"\\f3e1\"; }\r\n\r\n.la-puzzle-piece:before {\r\n  content: \"\\f12e\"; }\r\n\r\n.la-python:before {\r\n  content: \"\\f3e2\"; }\r\n\r\n.la-qq:before {\r\n  content: \"\\f1d6\"; }\r\n\r\n.la-qrcode:before {\r\n  content: \"\\f029\"; }\r\n\r\n.la-question:before {\r\n  content: \"\\f128\"; }\r\n\r\n.la-question-circle:before {\r\n  content: \"\\f059\"; }\r\n\r\n.la-quidditch:before {\r\n  content: \"\\f458\"; }\r\n\r\n.la-quinscape:before {\r\n  content: \"\\f459\"; }\r\n\r\n.la-quora:before {\r\n  content: \"\\f2c4\"; }\r\n\r\n.la-quote-left:before {\r\n  content: \"\\f10d\"; }\r\n\r\n.la-quote-right:before {\r\n  content: \"\\f10e\"; }\r\n\r\n.la-quran:before {\r\n  content: \"\\f687\"; }\r\n\r\n.la-r-project:before {\r\n  content: \"\\f4f7\"; }\r\n\r\n.la-radiation:before {\r\n  content: \"\\f7b9\"; }\r\n\r\n.la-radiation-alt:before {\r\n  content: \"\\f7ba\"; }\r\n\r\n.la-rainbow:before {\r\n  content: \"\\f75b\"; }\r\n\r\n.la-random:before {\r\n  content: \"\\f074\"; }\r\n\r\n.la-raspberry-pi:before {\r\n  content: \"\\f7bb\"; }\r\n\r\n.la-ravelry:before {\r\n  content: \"\\f2d9\"; }\r\n\r\n.la-react:before {\r\n  content: \"\\f41b\"; }\r\n\r\n.la-reacteurope:before {\r\n  content: \"\\f75d\"; }\r\n\r\n.la-readme:before {\r\n  content: \"\\f4d5\"; }\r\n\r\n.la-rebel:before {\r\n  content: \"\\f1d0\"; }\r\n\r\n.la-receipt:before {\r\n  content: \"\\f543\"; }\r\n\r\n.la-record-vinyl:before {\r\n  content: \"\\f8d9\"; }\r\n\r\n.la-recycle:before {\r\n  content: \"\\f1b8\"; }\r\n\r\n.la-red-river:before {\r\n  content: \"\\f3e3\"; }\r\n\r\n.la-reddit:before {\r\n  content: \"\\f1a1\"; }\r\n\r\n.la-reddit-alien:before {\r\n  content: \"\\f281\"; }\r\n\r\n.la-reddit-square:before {\r\n  content: \"\\f1a2\"; }\r\n\r\n.la-redhat:before {\r\n  content: \"\\f7bc\"; }\r\n\r\n.la-redo:before {\r\n  content: \"\\f01e\"; }\r\n\r\n.la-redo-alt:before {\r\n  content: \"\\f2f9\"; }\r\n\r\n.la-registered:before {\r\n  content: \"\\f25d\"; }\r\n\r\n.la-remove-format:before {\r\n  content: \"\\f87d\"; }\r\n\r\n.la-renren:before {\r\n  content: \"\\f18b\"; }\r\n\r\n.la-reply:before {\r\n  content: \"\\f3e5\"; }\r\n\r\n.la-reply-all:before {\r\n  content: \"\\f122\"; }\r\n\r\n.la-replyd:before {\r\n  content: \"\\f3e6\"; }\r\n\r\n.la-republican:before {\r\n  content: \"\\f75e\"; }\r\n\r\n.la-researchgate:before {\r\n  content: \"\\f4f8\"; }\r\n\r\n.la-resolving:before {\r\n  content: \"\\f3e7\"; }\r\n\r\n.la-restroom:before {\r\n  content: \"\\f7bd\"; }\r\n\r\n.la-retweet:before {\r\n  content: \"\\f079\"; }\r\n\r\n.la-rev:before {\r\n  content: \"\\f5b2\"; }\r\n\r\n.la-ribbon:before {\r\n  content: \"\\f4d6\"; }\r\n\r\n.la-ring:before {\r\n  content: \"\\f70b\"; }\r\n\r\n.la-road:before {\r\n  content: \"\\f018\"; }\r\n\r\n.la-robot:before {\r\n  content: \"\\f544\"; }\r\n\r\n.la-rocket:before {\r\n  content: \"\\f135\"; }\r\n\r\n.la-rocketchat:before {\r\n  content: \"\\f3e8\"; }\r\n\r\n.la-rockrms:before {\r\n  content: \"\\f3e9\"; }\r\n\r\n.la-route:before {\r\n  content: \"\\f4d7\"; }\r\n\r\n.la-rss:before {\r\n  content: \"\\f09e\"; }\r\n\r\n.la-rss-square:before {\r\n  content: \"\\f143\"; }\r\n\r\n.la-ruble-sign:before {\r\n  content: \"\\f158\"; }\r\n\r\n.la-ruler:before {\r\n  content: \"\\f545\"; }\r\n\r\n.la-ruler-combined:before {\r\n  content: \"\\f546\"; }\r\n\r\n.la-ruler-horizontal:before {\r\n  content: \"\\f547\"; }\r\n\r\n.la-ruler-vertical:before {\r\n  content: \"\\f548\"; }\r\n\r\n.la-running:before {\r\n  content: \"\\f70c\"; }\r\n\r\n.la-rupee-sign:before {\r\n  content: \"\\f156\"; }\r\n\r\n.la-sad-cry:before {\r\n  content: \"\\f5b3\"; }\r\n\r\n.la-sad-tear:before {\r\n  content: \"\\f5b4\"; }\r\n\r\n.la-safari:before {\r\n  content: \"\\f267\"; }\r\n\r\n.la-salesforce:before {\r\n  content: \"\\f83b\"; }\r\n\r\n.la-sass:before {\r\n  content: \"\\f41e\"; }\r\n\r\n.la-satellite:before {\r\n  content: \"\\f7bf\"; }\r\n\r\n.la-satellite-dish:before {\r\n  content: \"\\f7c0\"; }\r\n\r\n.la-save:before {\r\n  content: \"\\f0c7\"; }\r\n\r\n.la-schlix:before {\r\n  content: \"\\f3ea\"; }\r\n\r\n.la-school:before {\r\n  content: \"\\f549\"; }\r\n\r\n.la-screwdriver:before {\r\n  content: \"\\f54a\"; }\r\n\r\n.la-scribd:before {\r\n  content: \"\\f28a\"; }\r\n\r\n.la-scroll:before {\r\n  content: \"\\f70e\"; }\r\n\r\n.la-sd-card:before {\r\n  content: \"\\f7c2\"; }\r\n\r\n.la-search:before {\r\n  content: \"\\f002\"; }\r\n\r\n.la-search-dollar:before {\r\n  content: \"\\f688\"; }\r\n\r\n.la-search-location:before {\r\n  content: \"\\f689\"; }\r\n\r\n.la-search-minus:before {\r\n  content: \"\\f010\"; }\r\n\r\n.la-search-plus:before {\r\n  content: \"\\f00e\"; }\r\n\r\n.la-searchengin:before {\r\n  content: \"\\f3eb\"; }\r\n\r\n.la-seedling:before {\r\n  content: \"\\f4d8\"; }\r\n\r\n.la-sellcast:before {\r\n  content: \"\\f2da\"; }\r\n\r\n.la-sellsy:before {\r\n  content: \"\\f213\"; }\r\n\r\n.la-server:before {\r\n  content: \"\\f233\"; }\r\n\r\n.la-servicestack:before {\r\n  content: \"\\f3ec\"; }\r\n\r\n.la-shapes:before {\r\n  content: \"\\f61f\"; }\r\n\r\n.la-share:before {\r\n  content: \"\\f064\"; }\r\n\r\n.la-share-alt:before {\r\n  content: \"\\f1e0\"; }\r\n\r\n.la-share-alt-square:before {\r\n  content: \"\\f1e1\"; }\r\n\r\n.la-share-square:before {\r\n  content: \"\\f14d\"; }\r\n\r\n.la-shekel-sign:before {\r\n  content: \"\\f20b\"; }\r\n\r\n.la-shield-alt:before {\r\n  content: \"\\f3ed\"; }\r\n\r\n.la-ship:before {\r\n  content: \"\\f21a\"; }\r\n\r\n.la-shipping-fast:before {\r\n  content: \"\\f48b\"; }\r\n\r\n.la-shirtsinbulk:before {\r\n  content: \"\\f214\"; }\r\n\r\n.la-shoe-prints:before {\r\n  content: \"\\f54b\"; }\r\n\r\n.la-shopping-bag:before {\r\n  content: \"\\f290\"; }\r\n\r\n.la-shopping-basket:before {\r\n  content: \"\\f291\"; }\r\n\r\n.la-shopping-cart:before {\r\n  content: \"\\f07a\"; }\r\n\r\n.la-shopware:before {\r\n  content: \"\\f5b5\"; }\r\n\r\n.la-shower:before {\r\n  content: \"\\f2cc\"; }\r\n\r\n.la-shuttle-van:before {\r\n  content: \"\\f5b6\"; }\r\n\r\n.la-sign:before {\r\n  content: \"\\f4d9\"; }\r\n\r\n.la-sign-in-alt:before {\r\n  content: \"\\f2f6\"; }\r\n\r\n.la-sign-language:before {\r\n  content: \"\\f2a7\"; }\r\n\r\n.la-sign-out-alt:before {\r\n  content: \"\\f2f5\"; }\r\n\r\n.la-signal:before {\r\n  content: \"\\f012\"; }\r\n\r\n.la-signature:before {\r\n  content: \"\\f5b7\"; }\r\n\r\n.la-sim-card:before {\r\n  content: \"\\f7c4\"; }\r\n\r\n.la-simplybuilt:before {\r\n  content: \"\\f215\"; }\r\n\r\n.la-sistrix:before {\r\n  content: \"\\f3ee\"; }\r\n\r\n.la-sitemap:before {\r\n  content: \"\\f0e8\"; }\r\n\r\n.la-sith:before {\r\n  content: \"\\f512\"; }\r\n\r\n.la-skating:before {\r\n  content: \"\\f7c5\"; }\r\n\r\n.la-sketch:before {\r\n  content: \"\\f7c6\"; }\r\n\r\n.la-skiing:before {\r\n  content: \"\\f7c9\"; }\r\n\r\n.la-skiing-nordic:before {\r\n  content: \"\\f7ca\"; }\r\n\r\n.la-skull:before {\r\n  content: \"\\f54c\"; }\r\n\r\n.la-skull-crossbones:before {\r\n  content: \"\\f714\"; }\r\n\r\n.la-skyatlas:before {\r\n  content: \"\\f216\"; }\r\n\r\n.la-skype:before {\r\n  content: \"\\f17e\"; }\r\n\r\n.la-slack:before {\r\n  content: \"\\f198\"; }\r\n\r\n.la-slack-hash:before {\r\n  content: \"\\f3ef\"; }\r\n\r\n.la-slash:before {\r\n  content: \"\\f715\"; }\r\n\r\n.la-sleigh:before {\r\n  content: \"\\f7cc\"; }\r\n\r\n.la-sliders-h:before {\r\n  content: \"\\f1de\"; }\r\n\r\n.la-slideshare:before {\r\n  content: \"\\f1e7\"; }\r\n\r\n.la-smile:before {\r\n  content: \"\\f118\"; }\r\n\r\n.la-smile-beam:before {\r\n  content: \"\\f5b8\"; }\r\n\r\n.la-smile-wink:before {\r\n  content: \"\\f4da\"; }\r\n\r\n.la-smog:before {\r\n  content: \"\\f75f\"; }\r\n\r\n.la-smoking:before {\r\n  content: \"\\f48d\"; }\r\n\r\n.la-smoking-ban:before {\r\n  content: \"\\f54d\"; }\r\n\r\n.la-sms:before {\r\n  content: \"\\f7cd\"; }\r\n\r\n.la-snapchat:before {\r\n  content: \"\\f2ab\"; }\r\n\r\n.la-snapchat-ghost:before {\r\n  content: \"\\f2ac\"; }\r\n\r\n.la-snapchat-square:before {\r\n  content: \"\\f2ad\"; }\r\n\r\n.la-snowboarding:before {\r\n  content: \"\\f7ce\"; }\r\n\r\n.la-snowflake:before {\r\n  content: \"\\f2dc\"; }\r\n\r\n.la-snowman:before {\r\n  content: \"\\f7d0\"; }\r\n\r\n.la-snowplow:before {\r\n  content: \"\\f7d2\"; }\r\n\r\n.la-socks:before {\r\n  content: \"\\f696\"; }\r\n\r\n.la-solar-panel:before {\r\n  content: \"\\f5ba\"; }\r\n\r\n.la-sort:before {\r\n  content: \"\\f0dc\"; }\r\n\r\n.la-sort-alpha-down:before {\r\n  content: \"\\f15d\"; }\r\n\r\n.la-sort-alpha-down-alt:before {\r\n  content: \"\\f881\"; }\r\n\r\n.la-sort-alpha-up:before {\r\n  content: \"\\f15e\"; }\r\n\r\n.la-sort-alpha-up-alt:before {\r\n  content: \"\\f882\"; }\r\n\r\n.la-sort-amount-down:before {\r\n  content: \"\\f160\"; }\r\n\r\n.la-sort-amount-down-alt:before {\r\n  content: \"\\f884\"; }\r\n\r\n.la-sort-amount-up:before {\r\n  content: \"\\f161\"; }\r\n\r\n.la-sort-amount-up-alt:before {\r\n  content: \"\\f885\"; }\r\n\r\n.la-sort-down:before {\r\n  content: \"\\f0dd\"; }\r\n\r\n.la-sort-numeric-down:before {\r\n  content: \"\\f162\"; }\r\n\r\n.la-sort-numeric-down-alt:before {\r\n  content: \"\\f886\"; }\r\n\r\n.la-sort-numeric-up:before {\r\n  content: \"\\f163\"; }\r\n\r\n.la-sort-numeric-up-alt:before {\r\n  content: \"\\f887\"; }\r\n\r\n.la-sort-up:before {\r\n  content: \"\\f0de\"; }\r\n\r\n.la-soundcloud:before {\r\n  content: \"\\f1be\"; }\r\n\r\n.la-sourcetree:before {\r\n  content: \"\\f7d3\"; }\r\n\r\n.la-spa:before {\r\n  content: \"\\f5bb\"; }\r\n\r\n.la-space-shuttle:before {\r\n  content: \"\\f197\"; }\r\n\r\n.la-speakap:before {\r\n  content: \"\\f3f3\"; }\r\n\r\n.la-speaker-deck:before {\r\n  content: \"\\f83c\"; }\r\n\r\n.la-spell-check:before {\r\n  content: \"\\f891\"; }\r\n\r\n.la-spider:before {\r\n  content: \"\\f717\"; }\r\n\r\n.la-spinner:before {\r\n  content: \"\\f110\"; }\r\n\r\n.la-splotch:before {\r\n  content: \"\\f5bc\"; }\r\n\r\n.la-spotify:before {\r\n  content: \"\\f1bc\"; }\r\n\r\n.la-spray-can:before {\r\n  content: \"\\f5bd\"; }\r\n\r\n.la-square:before {\r\n  content: \"\\f0c8\"; }\r\n\r\n.la-square-full:before {\r\n  content: \"\\f45c\"; }\r\n\r\n.la-square-root-alt:before {\r\n  content: \"\\f698\"; }\r\n\r\n.la-squarespace:before {\r\n  content: \"\\f5be\"; }\r\n\r\n.la-stack-exchange:before {\r\n  content: \"\\f18d\"; }\r\n\r\n.la-stack-overflow:before {\r\n  content: \"\\f16c\"; }\r\n\r\n.la-stackpath:before {\r\n  content: \"\\f842\"; }\r\n\r\n.la-stamp:before {\r\n  content: \"\\f5bf\"; }\r\n\r\n.la-star:before {\r\n  content: \"\\f005\"; }\r\n\r\n.la-star-and-crescent:before {\r\n  content: \"\\f699\"; }\r\n\r\n.la-star-half:before {\r\n  content: \"\\f089\"; }\r\n\r\n.la-star-half-alt:before {\r\n  content: \"\\f5c0\"; }\r\n\r\n.la-star-of-david:before {\r\n  content: \"\\f69a\"; }\r\n\r\n.la-star-of-life:before {\r\n  content: \"\\f621\"; }\r\n\r\n.la-staylinked:before {\r\n  content: \"\\f3f5\"; }\r\n\r\n.la-steam:before {\r\n  content: \"\\f1b6\"; }\r\n\r\n.la-steam-square:before {\r\n  content: \"\\f1b7\"; }\r\n\r\n.la-steam-symbol:before {\r\n  content: \"\\f3f6\"; }\r\n\r\n.la-step-backward:before {\r\n  content: \"\\f048\"; }\r\n\r\n.la-step-forward:before {\r\n  content: \"\\f051\"; }\r\n\r\n.la-stethoscope:before {\r\n  content: \"\\f0f1\"; }\r\n\r\n.la-sticker-mule:before {\r\n  content: \"\\f3f7\"; }\r\n\r\n.la-sticky-note:before {\r\n  content: \"\\f249\"; }\r\n\r\n.la-stop:before {\r\n  content: \"\\f04d\"; }\r\n\r\n.la-stop-circle:before {\r\n  content: \"\\f28d\"; }\r\n\r\n.la-stopwatch:before {\r\n  content: \"\\f2f2\"; }\r\n\r\n.la-store:before {\r\n  content: \"\\f54e\"; }\r\n\r\n.la-store-alt:before {\r\n  content: \"\\f54f\"; }\r\n\r\n.la-strava:before {\r\n  content: \"\\f428\"; }\r\n\r\n.la-stream:before {\r\n  content: \"\\f550\"; }\r\n\r\n.la-street-view:before {\r\n  content: \"\\f21d\"; }\r\n\r\n.la-strikethrough:before {\r\n  content: \"\\f0cc\"; }\r\n\r\n.la-stripe:before {\r\n  content: \"\\f429\"; }\r\n\r\n.la-stripe-s:before {\r\n  content: \"\\f42a\"; }\r\n\r\n.la-stroopwafel:before {\r\n  content: \"\\f551\"; }\r\n\r\n.la-studiovinari:before {\r\n  content: \"\\f3f8\"; }\r\n\r\n.la-stumbleupon:before {\r\n  content: \"\\f1a4\"; }\r\n\r\n.la-stumbleupon-circle:before {\r\n  content: \"\\f1a3\"; }\r\n\r\n.la-subscript:before {\r\n  content: \"\\f12c\"; }\r\n\r\n.la-subway:before {\r\n  content: \"\\f239\"; }\r\n\r\n.la-suitcase:before {\r\n  content: \"\\f0f2\"; }\r\n\r\n.la-suitcase-rolling:before {\r\n  content: \"\\f5c1\"; }\r\n\r\n.la-sun:before {\r\n  content: \"\\f185\"; }\r\n\r\n.la-superpowers:before {\r\n  content: \"\\f2dd\"; }\r\n\r\n.la-superscript:before {\r\n  content: \"\\f12b\"; }\r\n\r\n.la-supple:before {\r\n  content: \"\\f3f9\"; }\r\n\r\n.la-surprise:before {\r\n  content: \"\\f5c2\"; }\r\n\r\n.la-suse:before {\r\n  content: \"\\f7d6\"; }\r\n\r\n.la-swatchbook:before {\r\n  content: \"\\f5c3\"; }\r\n\r\n.la-swift:before {\r\n  content: \"\\f8e1\"; }\r\n\r\n.la-swimmer:before {\r\n  content: \"\\f5c4\"; }\r\n\r\n.la-swimming-pool:before {\r\n  content: \"\\f5c5\"; }\r\n\r\n.la-symfony:before {\r\n  content: \"\\f83d\"; }\r\n\r\n.la-synagogue:before {\r\n  content: \"\\f69b\"; }\r\n\r\n.la-sync:before {\r\n  content: \"\\f021\"; }\r\n\r\n.la-sync-alt:before {\r\n  content: \"\\f2f1\"; }\r\n\r\n.la-syringe:before {\r\n  content: \"\\f48e\"; }\r\n\r\n.la-table:before {\r\n  content: \"\\f0ce\"; }\r\n\r\n.la-table-tennis:before {\r\n  content: \"\\f45d\"; }\r\n\r\n.la-tablet:before {\r\n  content: \"\\f10a\"; }\r\n\r\n.la-tablet-alt:before {\r\n  content: \"\\f3fa\"; }\r\n\r\n.la-tablets:before {\r\n  content: \"\\f490\"; }\r\n\r\n.la-tachometer-alt:before {\r\n  content: \"\\f3fd\"; }\r\n\r\n.la-tag:before {\r\n  content: \"\\f02b\"; }\r\n\r\n.la-tags:before {\r\n  content: \"\\f02c\"; }\r\n\r\n.la-tape:before {\r\n  content: \"\\f4db\"; }\r\n\r\n.la-tasks:before {\r\n  content: \"\\f0ae\"; }\r\n\r\n.la-taxi:before {\r\n  content: \"\\f1ba\"; }\r\n\r\n.la-teamspeak:before {\r\n  content: \"\\f4f9\"; }\r\n\r\n.la-teeth:before {\r\n  content: \"\\f62e\"; }\r\n\r\n.la-teeth-open:before {\r\n  content: \"\\f62f\"; }\r\n\r\n.la-telegram:before {\r\n  content: \"\\f2c6\"; }\r\n\r\n.la-telegram-plane:before {\r\n  content: \"\\f3fe\"; }\r\n\r\n.la-temperature-high:before {\r\n  content: \"\\f769\"; }\r\n\r\n.la-temperature-low:before {\r\n  content: \"\\f76b\"; }\r\n\r\n.la-tencent-weibo:before {\r\n  content: \"\\f1d5\"; }\r\n\r\n.la-tenge:before {\r\n  content: \"\\f7d7\"; }\r\n\r\n.la-terminal:before {\r\n  content: \"\\f120\"; }\r\n\r\n.la-text-height:before {\r\n  content: \"\\f034\"; }\r\n\r\n.la-text-width:before {\r\n  content: \"\\f035\"; }\r\n\r\n.la-th:before {\r\n  content: \"\\f00a\"; }\r\n\r\n.la-th-large:before {\r\n  content: \"\\f009\"; }\r\n\r\n.la-th-list:before {\r\n  content: \"\\f00b\"; }\r\n\r\n.la-the-red-yeti:before {\r\n  content: \"\\f69d\"; }\r\n\r\n.la-theater-masks:before {\r\n  content: \"\\f630\"; }\r\n\r\n.la-themeco:before {\r\n  content: \"\\f5c6\"; }\r\n\r\n.la-themeisle:before {\r\n  content: \"\\f2b2\"; }\r\n\r\n.la-thermometer:before {\r\n  content: \"\\f491\"; }\r\n\r\n.la-thermometer-empty:before {\r\n  content: \"\\f2cb\"; }\r\n\r\n.la-thermometer-full:before {\r\n  content: \"\\f2c7\"; }\r\n\r\n.la-thermometer-half:before {\r\n  content: \"\\f2c9\"; }\r\n\r\n.la-thermometer-quarter:before {\r\n  content: \"\\f2ca\"; }\r\n\r\n.la-thermometer-three-quarters:before {\r\n  content: \"\\f2c8\"; }\r\n\r\n.la-think-peaks:before {\r\n  content: \"\\f731\"; }\r\n\r\n.la-thumbs-down:before {\r\n  content: \"\\f165\"; }\r\n\r\n.la-thumbs-up:before {\r\n  content: \"\\f164\"; }\r\n\r\n.la-thumbtack:before {\r\n  content: \"\\f08d\"; }\r\n\r\n.la-ticket-alt:before {\r\n  content: \"\\f3ff\"; }\r\n\r\n.la-times:before {\r\n  content: \"\\f00d\"; }\r\n\r\n.la-times-circle:before {\r\n  content: \"\\f057\"; }\r\n\r\n.la-tint:before {\r\n  content: \"\\f043\"; }\r\n\r\n.la-tint-slash:before {\r\n  content: \"\\f5c7\"; }\r\n\r\n.la-tired:before {\r\n  content: \"\\f5c8\"; }\r\n\r\n.la-toggle-off:before {\r\n  content: \"\\f204\"; }\r\n\r\n.la-toggle-on:before {\r\n  content: \"\\f205\"; }\r\n\r\n.la-toilet:before {\r\n  content: \"\\f7d8\"; }\r\n\r\n.la-toilet-paper:before {\r\n  content: \"\\f71e\"; }\r\n\r\n.la-toolbox:before {\r\n  content: \"\\f552\"; }\r\n\r\n.la-tools:before {\r\n  content: \"\\f7d9\"; }\r\n\r\n.la-tooth:before {\r\n  content: \"\\f5c9\"; }\r\n\r\n.la-torah:before {\r\n  content: \"\\f6a0\"; }\r\n\r\n.la-torii-gate:before {\r\n  content: \"\\f6a1\"; }\r\n\r\n.la-tractor:before {\r\n  content: \"\\f722\"; }\r\n\r\n.la-trade-federation:before {\r\n  content: \"\\f513\"; }\r\n\r\n.la-trademark:before {\r\n  content: \"\\f25c\"; }\r\n\r\n.la-traffic-light:before {\r\n  content: \"\\f637\"; }\r\n\r\n.la-train:before {\r\n  content: \"\\f238\"; }\r\n\r\n.la-tram:before {\r\n  content: \"\\f7da\"; }\r\n\r\n.la-transgender:before {\r\n  content: \"\\f224\"; }\r\n\r\n.la-transgender-alt:before {\r\n  content: \"\\f225\"; }\r\n\r\n.la-trash:before {\r\n  content: \"\\f1f8\"; }\r\n\r\n.la-trash-alt:before {\r\n  content: \"\\f2ed\"; }\r\n\r\n.la-trash-restore:before {\r\n  content: \"\\f829\"; }\r\n\r\n.la-trash-restore-alt:before {\r\n  content: \"\\f82a\"; }\r\n\r\n.la-tree:before {\r\n  content: \"\\f1bb\"; }\r\n\r\n.la-trello:before {\r\n  content: \"\\f181\"; }\r\n\r\n.la-tripadvisor:before {\r\n  content: \"\\f262\"; }\r\n\r\n.la-trophy:before {\r\n  content: \"\\f091\"; }\r\n\r\n.la-truck:before {\r\n  content: \"\\f0d1\"; }\r\n\r\n.la-truck-loading:before {\r\n  content: \"\\f4de\"; }\r\n\r\n.la-truck-monster:before {\r\n  content: \"\\f63b\"; }\r\n\r\n.la-truck-moving:before {\r\n  content: \"\\f4df\"; }\r\n\r\n.la-truck-pickup:before {\r\n  content: \"\\f63c\"; }\r\n\r\n.la-tshirt:before {\r\n  content: \"\\f553\"; }\r\n\r\n.la-tty:before {\r\n  content: \"\\f1e4\"; }\r\n\r\n.la-tumblr:before {\r\n  content: \"\\f173\"; }\r\n\r\n.la-tumblr-square:before {\r\n  content: \"\\f174\"; }\r\n\r\n.la-tv:before {\r\n  content: \"\\f26c\"; }\r\n\r\n.la-twitch:before {\r\n  content: \"\\f1e8\"; }\r\n\r\n.la-twitter:before {\r\n  content: \"\\f099\"; }\r\n\r\n.la-twitter-square:before {\r\n  content: \"\\f081\"; }\r\n\r\n.la-typo3:before {\r\n  content: \"\\f42b\"; }\r\n\r\n.la-uber:before {\r\n  content: \"\\f402\"; }\r\n\r\n.la-ubuntu:before {\r\n  content: \"\\f7df\"; }\r\n\r\n.la-uikit:before {\r\n  content: \"\\f403\"; }\r\n\r\n.la-umbraco:before {\r\n  content: \"\\f8e8\"; }\r\n\r\n.la-umbrella:before {\r\n  content: \"\\f0e9\"; }\r\n\r\n.la-umbrella-beach:before {\r\n  content: \"\\f5ca\"; }\r\n\r\n.la-underline:before {\r\n  content: \"\\f0cd\"; }\r\n\r\n.la-undo:before {\r\n  content: \"\\f0e2\"; }\r\n\r\n.la-undo-alt:before {\r\n  content: \"\\f2ea\"; }\r\n\r\n.la-uniregistry:before {\r\n  content: \"\\f404\"; }\r\n\r\n.la-universal-access:before {\r\n  content: \"\\f29a\"; }\r\n\r\n.la-university:before {\r\n  content: \"\\f19c\"; }\r\n\r\n.la-unlink:before {\r\n  content: \"\\f127\"; }\r\n\r\n.la-unlock:before {\r\n  content: \"\\f09c\"; }\r\n\r\n.la-unlock-alt:before {\r\n  content: \"\\f13e\"; }\r\n\r\n.la-untappd:before {\r\n  content: \"\\f405\"; }\r\n\r\n.la-upload:before {\r\n  content: \"\\f093\"; }\r\n\r\n.la-ups:before {\r\n  content: \"\\f7e0\"; }\r\n\r\n.la-usb:before {\r\n  content: \"\\f287\"; }\r\n\r\n.la-user:before {\r\n  content: \"\\f007\"; }\r\n\r\n.la-user-alt:before {\r\n  content: \"\\f406\"; }\r\n\r\n.la-user-alt-slash:before {\r\n  content: \"\\f4fa\"; }\r\n\r\n.la-user-astronaut:before {\r\n  content: \"\\f4fb\"; }\r\n\r\n.la-user-check:before {\r\n  content: \"\\f4fc\"; }\r\n\r\n.la-user-circle:before {\r\n  content: \"\\f2bd\"; }\r\n\r\n.la-user-clock:before {\r\n  content: \"\\f4fd\"; }\r\n\r\n.la-user-cog:before {\r\n  content: \"\\f4fe\"; }\r\n\r\n.la-user-edit:before {\r\n  content: \"\\f4ff\"; }\r\n\r\n.la-user-friends:before {\r\n  content: \"\\f500\"; }\r\n\r\n.la-user-graduate:before {\r\n  content: \"\\f501\"; }\r\n\r\n.la-user-injured:before {\r\n  content: \"\\f728\"; }\r\n\r\n.la-user-lock:before {\r\n  content: \"\\f502\"; }\r\n\r\n.la-user-md:before {\r\n  content: \"\\f0f0\"; }\r\n\r\n.la-user-minus:before {\r\n  content: \"\\f503\"; }\r\n\r\n.la-user-ninja:before {\r\n  content: \"\\f504\"; }\r\n\r\n.la-user-nurse:before {\r\n  content: \"\\f82f\"; }\r\n\r\n.la-user-plus:before {\r\n  content: \"\\f234\"; }\r\n\r\n.la-user-secret:before {\r\n  content: \"\\f21b\"; }\r\n\r\n.la-user-shield:before {\r\n  content: \"\\f505\"; }\r\n\r\n.la-user-slash:before {\r\n  content: \"\\f506\"; }\r\n\r\n.la-user-tag:before {\r\n  content: \"\\f507\"; }\r\n\r\n.la-user-tie:before {\r\n  content: \"\\f508\"; }\r\n\r\n.la-user-times:before {\r\n  content: \"\\f235\"; }\r\n\r\n.la-users:before {\r\n  content: \"\\f0c0\"; }\r\n\r\n.la-users-cog:before {\r\n  content: \"\\f509\"; }\r\n\r\n.la-usps:before {\r\n  content: \"\\f7e1\"; }\r\n\r\n.la-ussunnah:before {\r\n  content: \"\\f407\"; }\r\n\r\n.la-utensil-spoon:before {\r\n  content: \"\\f2e5\"; }\r\n\r\n.la-utensils:before {\r\n  content: \"\\f2e7\"; }\r\n\r\n.la-vaadin:before {\r\n  content: \"\\f408\"; }\r\n\r\n.la-vector-square:before {\r\n  content: \"\\f5cb\"; }\r\n\r\n.la-venus:before {\r\n  content: \"\\f221\"; }\r\n\r\n.la-venus-double:before {\r\n  content: \"\\f226\"; }\r\n\r\n.la-venus-mars:before {\r\n  content: \"\\f228\"; }\r\n\r\n.la-viacoin:before {\r\n  content: \"\\f237\"; }\r\n\r\n.la-viadeo:before {\r\n  content: \"\\f2a9\"; }\r\n\r\n.la-viadeo-square:before {\r\n  content: \"\\f2aa\"; }\r\n\r\n.la-vial:before {\r\n  content: \"\\f492\"; }\r\n\r\n.la-vials:before {\r\n  content: \"\\f493\"; }\r\n\r\n.la-viber:before {\r\n  content: \"\\f409\"; }\r\n\r\n.la-video:before {\r\n  content: \"\\f03d\"; }\r\n\r\n.la-video-slash:before {\r\n  content: \"\\f4e2\"; }\r\n\r\n.la-vihara:before {\r\n  content: \"\\f6a7\"; }\r\n\r\n.la-vimeo:before {\r\n  content: \"\\f40a\"; }\r\n\r\n.la-vimeo-square:before {\r\n  content: \"\\f194\"; }\r\n\r\n.la-vimeo-v:before {\r\n  content: \"\\f27d\"; }\r\n\r\n.la-vine:before {\r\n  content: \"\\f1ca\"; }\r\n\r\n.la-vk:before {\r\n  content: \"\\f189\"; }\r\n\r\n.la-vnv:before {\r\n  content: \"\\f40b\"; }\r\n\r\n.la-voicemail:before {\r\n  content: \"\\f897\"; }\r\n\r\n.la-volleyball-ball:before {\r\n  content: \"\\f45f\"; }\r\n\r\n.la-volume-down:before {\r\n  content: \"\\f027\"; }\r\n\r\n.la-volume-mute:before {\r\n  content: \"\\f6a9\"; }\r\n\r\n.la-volume-off:before {\r\n  content: \"\\f026\"; }\r\n\r\n.la-volume-up:before {\r\n  content: \"\\f028\"; }\r\n\r\n.la-vote-yea:before {\r\n  content: \"\\f772\"; }\r\n\r\n.la-vr-cardboard:before {\r\n  content: \"\\f729\"; }\r\n\r\n.la-vuejs:before {\r\n  content: \"\\f41f\"; }\r\n\r\n.la-walking:before {\r\n  content: \"\\f554\"; }\r\n\r\n.la-wallet:before {\r\n  content: \"\\f555\"; }\r\n\r\n.la-warehouse:before {\r\n  content: \"\\f494\"; }\r\n\r\n.la-water:before {\r\n  content: \"\\f773\"; }\r\n\r\n.la-wave-square:before {\r\n  content: \"\\f83e\"; }\r\n\r\n.la-waze:before {\r\n  content: \"\\f83f\"; }\r\n\r\n.la-weebly:before {\r\n  content: \"\\f5cc\"; }\r\n\r\n.la-weibo:before {\r\n  content: \"\\f18a\"; }\r\n\r\n.la-weight:before {\r\n  content: \"\\f496\"; }\r\n\r\n.la-weight-hanging:before {\r\n  content: \"\\f5cd\"; }\r\n\r\n.la-weixin:before {\r\n  content: \"\\f1d7\"; }\r\n\r\n.la-whatsapp:before {\r\n  content: \"\\f232\"; }\r\n\r\n.la-whatsapp-square:before {\r\n  content: \"\\f40c\"; }\r\n\r\n.la-wheelchair:before {\r\n  content: \"\\f193\"; }\r\n\r\n.la-whmcs:before {\r\n  content: \"\\f40d\"; }\r\n\r\n.la-wifi:before {\r\n  content: \"\\f1eb\"; }\r\n\r\n.la-wikipedia-w:before {\r\n  content: \"\\f266\"; }\r\n\r\n.la-wind:before {\r\n  content: \"\\f72e\"; }\r\n\r\n.la-window-close:before {\r\n  content: \"\\f410\"; }\r\n\r\n.la-window-maximize:before {\r\n  content: \"\\f2d0\"; }\r\n\r\n.la-window-minimize:before {\r\n  content: \"\\f2d1\"; }\r\n\r\n.la-window-restore:before {\r\n  content: \"\\f2d2\"; }\r\n\r\n.la-windows:before {\r\n  content: \"\\f17a\"; }\r\n\r\n.la-wine-bottle:before {\r\n  content: \"\\f72f\"; }\r\n\r\n.la-wine-glass:before {\r\n  content: \"\\f4e3\"; }\r\n\r\n.la-wine-glass-alt:before {\r\n  content: \"\\f5ce\"; }\r\n\r\n.la-wix:before {\r\n  content: \"\\f5cf\"; }\r\n\r\n.la-wizards-of-the-coast:before {\r\n  content: \"\\f730\"; }\r\n\r\n.la-wolf-pack-battalion:before {\r\n  content: \"\\f514\"; }\r\n\r\n.la-won-sign:before {\r\n  content: \"\\f159\"; }\r\n\r\n.la-wordpress:before {\r\n  content: \"\\f19a\"; }\r\n\r\n.la-wordpress-simple:before {\r\n  content: \"\\f411\"; }\r\n\r\n.la-wpbeginner:before {\r\n  content: \"\\f297\"; }\r\n\r\n.la-wpexplorer:before {\r\n  content: \"\\f2de\"; }\r\n\r\n.la-wpforms:before {\r\n  content: \"\\f298\"; }\r\n\r\n.la-wpressr:before {\r\n  content: \"\\f3e4\"; }\r\n\r\n.la-wrench:before {\r\n  content: \"\\f0ad\"; }\r\n\r\n.la-x-ray:before {\r\n  content: \"\\f497\"; }\r\n\r\n.la-xbox:before {\r\n  content: \"\\f412\"; }\r\n\r\n.la-xing:before {\r\n  content: \"\\f168\"; }\r\n\r\n.la-xing-square:before {\r\n  content: \"\\f169\"; }\r\n\r\n.la-y-combinator:before {\r\n  content: \"\\f23b\"; }\r\n\r\n.la-yahoo:before {\r\n  content: \"\\f19e\"; }\r\n\r\n.la-yammer:before {\r\n  content: \"\\f840\"; }\r\n\r\n.la-yandex:before {\r\n  content: \"\\f413\"; }\r\n\r\n.la-yandex-international:before {\r\n  content: \"\\f414\"; }\r\n\r\n.la-yarn:before {\r\n  content: \"\\f7e3\"; }\r\n\r\n.la-yelp:before {\r\n  content: \"\\f1e9\"; }\r\n\r\n.la-yen-sign:before {\r\n  content: \"\\f157\"; }\r\n\r\n.la-yin-yang:before {\r\n  content: \"\\f6ad\"; }\r\n\r\n.la-yoast:before {\r\n  content: \"\\f2b1\"; }\r\n\r\n.la-youtube:before {\r\n  content: \"\\f167\"; }\r\n\r\n.la-youtube-square:before {\r\n  content: \"\\f431\"; }\r\n\r\n.la-zhihu:before {\r\n  content: \"\\f63f\"; }\r\n\r\n.sr-only {\r\n  border: 0;\r\n  clip: rect(0, 0, 0, 0);\r\n  height: 1px;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  position: absolute;\r\n  width: 1px; }\r\n\r\n.sr-only-focusable:active, .sr-only-focusable:focus {\r\n  clip: auto;\r\n  height: auto;\r\n  margin: 0;\r\n  overflow: visible;\r\n  position: static;\r\n  width: auto; }\r\n@font-face {\r\n  font-family: 'Line Awesome Brands';\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-display: auto;\r\n  src: url(\"../../../fonts/la-brands-400.eot\");\r\n  src: url(\"../../../fonts/la-brands-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-brands-400.woff2\") format(\"woff2\"), url(\"../../../fonts/la-brands-400.woff\") format(\"woff\"), url(\"../../../fonts/la-brands-400.ttf\") format(\"truetype\"), url(\"../../../fonts/la-brands-400.svg#lineawesome\") format(\"svg\"); }\r\n\r\n.lab {\r\n  font-family: 'Line Awesome Brands'; }\r\n@font-face {\r\n  font-family: 'Line Awesome Free';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: auto;\r\n  src: url(\"../../../fonts/la-regular-400.eot\");\r\n  src: url(\"../../../fonts/la-regular-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-regular-400.woff2\") format(\"woff2\"), url(\"../../../fonts/la-regular-400.woff\") format(\"woff\"), url(\"../../../fonts/la-regular-400.ttf\") format(\"truetype\"), url(\"../../../fonts/la-regular-400.svg#lineawesome\") format(\"svg\"); }\r\n\r\n.lar {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n@font-face {\r\n  font-family: 'Line Awesome Free';\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: auto;\r\n  src: url(\"../../../fonts/la-solid-900.eot\");\r\n  src: url(\"../../../fonts/la-solid-900.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-solid-900.woff2\") format(\"woff2\"), url(\"../../../fonts/la-solid-900.woff\") format(\"woff\"), url(\"../../../fonts/la-solid-900.ttf\") format(\"truetype\"), url(\"../../../fonts/la-solid-900.svg#lineawesome\") format(\"svg\"); }\r\n\r\n.la,\r\n.las {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 900; }\r\n\r\n.la.la-glass:before {\r\n  content: \"\\f000\"; }\r\n\r\n.la.la-meetup {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-star-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-star-o:before {\r\n  content: \"\\f005\"; }\r\n\r\n.la.la-remove:before {\r\n  content: \"\\f00d\"; }\r\n\r\n.la.la-close:before {\r\n  content: \"\\f00d\"; }\r\n\r\n.la.la-gear:before {\r\n  content: \"\\f013\"; }\r\n\r\n.la.la-trash-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-trash-o:before {\r\n  content: \"\\f2ed\"; }\r\n\r\n.la.la-file-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-o:before {\r\n  content: \"\\f15b\"; }\r\n\r\n.la.la-clock-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-clock-o:before {\r\n  content: \"\\f017\"; }\r\n\r\n.la.la-arrow-circle-o-down {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-arrow-circle-o-down:before {\r\n  content: \"\\f358\"; }\r\n\r\n.la.la-arrow-circle-o-up {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-arrow-circle-o-up:before {\r\n  content: \"\\f35b\"; }\r\n\r\n.la.la-play-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-play-circle-o:before {\r\n  content: \"\\f144\"; }\r\n\r\n.la.la-repeat:before {\r\n  content: \"\\f01e\"; }\r\n\r\n.la.la-rotate-right:before {\r\n  content: \"\\f01e\"; }\r\n\r\n.la.la-refresh:before {\r\n  content: \"\\f021\"; }\r\n\r\n.la.la-list-alt {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-dedent:before {\r\n  content: \"\\f03b\"; }\r\n\r\n.la.la-video-camera:before {\r\n  content: \"\\f03d\"; }\r\n\r\n.la.la-picture-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-picture-o:before {\r\n  content: \"\\f03e\"; }\r\n\r\n.la.la-photo {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-photo:before {\r\n  content: \"\\f03e\"; }\r\n\r\n.la.la-image {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-image:before {\r\n  content: \"\\f03e\"; }\r\n\r\n.la.la-pencil:before {\r\n  content: \"\\f303\"; }\r\n\r\n.la.la-map-marker:before {\r\n  content: \"\\f3c5\"; }\r\n\r\n.la.la-pencil-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-pencil-square-o:before {\r\n  content: \"\\f044\"; }\r\n\r\n.la.la-share-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-share-square-o:before {\r\n  content: \"\\f14d\"; }\r\n\r\n.la.la-check-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-check-square-o:before {\r\n  content: \"\\f14a\"; }\r\n\r\n.la.la-arrows:before {\r\n  content: \"\\f0b2\"; }\r\n\r\n.la.la-times-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-times-circle-o:before {\r\n  content: \"\\f057\"; }\r\n\r\n.la.la-check-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-check-circle-o:before {\r\n  content: \"\\f058\"; }\r\n\r\n.la.la-mail-forward:before {\r\n  content: \"\\f064\"; }\r\n\r\n.la.la-eye {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-eye-slash {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-warning:before {\r\n  content: \"\\f071\"; }\r\n\r\n.la.la-calendar:before {\r\n  content: \"\\f073\"; }\r\n\r\n.la.la-arrows-v:before {\r\n  content: \"\\f338\"; }\r\n\r\n.la.la-arrows-h:before {\r\n  content: \"\\f337\"; }\r\n\r\n.la.la-bar-chart {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-bar-chart:before {\r\n  content: \"\\f080\"; }\r\n\r\n.la.la-bar-chart-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-bar-chart-o:before {\r\n  content: \"\\f080\"; }\r\n\r\n.la.la-twitter-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-facebook-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gears:before {\r\n  content: \"\\f085\"; }\r\n\r\n.la.la-thumbs-o-up {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-thumbs-o-up:before {\r\n  content: \"\\f164\"; }\r\n\r\n.la.la-thumbs-o-down {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-thumbs-o-down:before {\r\n  content: \"\\f165\"; }\r\n\r\n.la.la-heart-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-heart-o:before {\r\n  content: \"\\f004\"; }\r\n\r\n.la.la-sign-out:before {\r\n  content: \"\\f2f5\"; }\r\n\r\n.la.la-linkedin-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-linkedin-square:before {\r\n  content: \"\\f08c\"; }\r\n\r\n.la.la-thumb-tack:before {\r\n  content: \"\\f08d\"; }\r\n\r\n.la.la-external-link:before {\r\n  content: \"\\f35d\"; }\r\n\r\n.la.la-sign-in:before {\r\n  content: \"\\f2f6\"; }\r\n\r\n.la.la-github-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-lemon-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-lemon-o:before {\r\n  content: \"\\f094\"; }\r\n\r\n.la.la-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-square-o:before {\r\n  content: \"\\f0c8\"; }\r\n\r\n.la.la-bookmark-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-bookmark-o:before {\r\n  content: \"\\f02e\"; }\r\n\r\n.la.la-twitter {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-facebook {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-facebook:before {\r\n  content: \"\\f39e\"; }\r\n\r\n.la.la-facebook-f {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-facebook-f:before {\r\n  content: \"\\f39e\"; }\r\n\r\n.la.la-github {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-credit-card {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-feed:before {\r\n  content: \"\\f09e\"; }\r\n\r\n.la.la-hdd-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hdd-o:before {\r\n  content: \"\\f0a0\"; }\r\n\r\n.la.la-hand-o-right {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-o-right:before {\r\n  content: \"\\f0a4\"; }\r\n\r\n.la.la-hand-o-left {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-o-left:before {\r\n  content: \"\\f0a5\"; }\r\n\r\n.la.la-hand-o-up {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-o-up:before {\r\n  content: \"\\f0a6\"; }\r\n\r\n.la.la-hand-o-down {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-o-down:before {\r\n  content: \"\\f0a7\"; }\r\n\r\n.la.la-arrows-alt:before {\r\n  content: \"\\f31e\"; }\r\n\r\n.la.la-group:before {\r\n  content: \"\\f0c0\"; }\r\n\r\n.la.la-chain:before {\r\n  content: \"\\f0c1\"; }\r\n\r\n.la.la-scissors:before {\r\n  content: \"\\f0c4\"; }\r\n\r\n.la.la-files-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-files-o:before {\r\n  content: \"\\f0c5\"; }\r\n\r\n.la.la-floppy-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-floppy-o:before {\r\n  content: \"\\f0c7\"; }\r\n\r\n.la.la-navicon:before {\r\n  content: \"\\f0c9\"; }\r\n\r\n.la.la-reorder:before {\r\n  content: \"\\f0c9\"; }\r\n\r\n.la.la-pinterest {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pinterest-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus:before {\r\n  content: \"\\f0d5\"; }\r\n\r\n.la.la-money {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-money:before {\r\n  content: \"\\f3d1\"; }\r\n\r\n.la.la-unsorted:before {\r\n  content: \"\\f0dc\"; }\r\n\r\n.la.la-sort-desc:before {\r\n  content: \"\\f0dd\"; }\r\n\r\n.la.la-sort-asc:before {\r\n  content: \"\\f0de\"; }\r\n\r\n.la.la-linkedin {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-linkedin:before {\r\n  content: \"\\f0e1\"; }\r\n\r\n.la.la-rotate-left:before {\r\n  content: \"\\f0e2\"; }\r\n\r\n.la.la-legal:before {\r\n  content: \"\\f0e3\"; }\r\n\r\n.la.la-tachometer:before {\r\n  content: \"\\f3fd\"; }\r\n\r\n.la.la-dashboard:before {\r\n  content: \"\\f3fd\"; }\r\n\r\n.la.la-comment-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-comment-o:before {\r\n  content: \"\\f075\"; }\r\n\r\n.la.la-comments-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-comments-o:before {\r\n  content: \"\\f086\"; }\r\n\r\n.la.la-flash:before {\r\n  content: \"\\f0e7\"; }\r\n\r\n.la.la-clipboard {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-paste {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-paste:before {\r\n  content: \"\\f328\"; }\r\n\r\n.la.la-lightbulb-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-lightbulb-o:before {\r\n  content: \"\\f0eb\"; }\r\n\r\n.la.la-exchange:before {\r\n  content: \"\\f362\"; }\r\n\r\n.la.la-cloud-download:before {\r\n  content: \"\\f381\"; }\r\n\r\n.la.la-cloud-upload:before {\r\n  content: \"\\f382\"; }\r\n\r\n.la.la-bell-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-bell-o:before {\r\n  content: \"\\f0f3\"; }\r\n\r\n.la.la-cutlery:before {\r\n  content: \"\\f2e7\"; }\r\n\r\n.la.la-file-text-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-text-o:before {\r\n  content: \"\\f15c\"; }\r\n\r\n.la.la-building-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-building-o:before {\r\n  content: \"\\f1ad\"; }\r\n\r\n.la.la-hospital-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hospital-o:before {\r\n  content: \"\\f0f8\"; }\r\n\r\n.la.la-tablet:before {\r\n  content: \"\\f3fa\"; }\r\n\r\n.la.la-mobile:before {\r\n  content: \"\\f3cd\"; }\r\n\r\n.la.la-mobile-phone:before {\r\n  content: \"\\f3cd\"; }\r\n\r\n.la.la-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-circle-o:before {\r\n  content: \"\\f111\"; }\r\n\r\n.la.la-mail-reply:before {\r\n  content: \"\\f3e5\"; }\r\n\r\n.la.la-github-alt {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-folder-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-folder-o:before {\r\n  content: \"\\f07b\"; }\r\n\r\n.la.la-folder-open-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-folder-open-o:before {\r\n  content: \"\\f07c\"; }\r\n\r\n.la.la-smile-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-smile-o:before {\r\n  content: \"\\f118\"; }\r\n\r\n.la.la-frown-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-frown-o:before {\r\n  content: \"\\f119\"; }\r\n\r\n.la.la-meh-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-meh-o:before {\r\n  content: \"\\f11a\"; }\r\n\r\n.la.la-keyboard-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-keyboard-o:before {\r\n  content: \"\\f11c\"; }\r\n\r\n.la.la-flag-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-flag-o:before {\r\n  content: \"\\f024\"; }\r\n\r\n.la.la-mail-reply-all:before {\r\n  content: \"\\f122\"; }\r\n\r\n.la.la-star-half-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-star-half-o:before {\r\n  content: \"\\f089\"; }\r\n\r\n.la.la-star-half-empty {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-star-half-empty:before {\r\n  content: \"\\f089\"; }\r\n\r\n.la.la-star-half-full {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-star-half-full:before {\r\n  content: \"\\f089\"; }\r\n\r\n.la.la-code-fork:before {\r\n  content: \"\\f126\"; }\r\n\r\n.la.la-chain-broken:before {\r\n  content: \"\\f127\"; }\r\n\r\n.la.la-shield:before {\r\n  content: \"\\f3ed\"; }\r\n\r\n.la.la-calendar-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-o:before {\r\n  content: \"\\f133\"; }\r\n\r\n.la.la-maxcdn {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-html5 {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-css3 {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ticket:before {\r\n  content: \"\\f3ff\"; }\r\n\r\n.la.la-minus-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-minus-square-o:before {\r\n  content: \"\\f146\"; }\r\n\r\n.la.la-level-up:before {\r\n  content: \"\\f3bf\"; }\r\n\r\n.la.la-level-down:before {\r\n  content: \"\\f3be\"; }\r\n\r\n.la.la-pencil-square:before {\r\n  content: \"\\f14b\"; }\r\n\r\n.la.la-external-link-square:before {\r\n  content: \"\\f360\"; }\r\n\r\n.la.la-compass {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-caret-square-o-down {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-caret-square-o-down:before {\r\n  content: \"\\f150\"; }\r\n\r\n.la.la-toggle-down {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-toggle-down:before {\r\n  content: \"\\f150\"; }\r\n\r\n.la.la-caret-square-o-up {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-caret-square-o-up:before {\r\n  content: \"\\f151\"; }\r\n\r\n.la.la-toggle-up {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-toggle-up:before {\r\n  content: \"\\f151\"; }\r\n\r\n.la.la-caret-square-o-right {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-caret-square-o-right:before {\r\n  content: \"\\f152\"; }\r\n\r\n.la.la-toggle-right {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-toggle-right:before {\r\n  content: \"\\f152\"; }\r\n\r\n.la.la-eur:before {\r\n  content: \"\\f153\"; }\r\n\r\n.la.la-euro:before {\r\n  content: \"\\f153\"; }\r\n\r\n.la.la-gbp:before {\r\n  content: \"\\f154\"; }\r\n\r\n.la.la-usd:before {\r\n  content: \"\\f155\"; }\r\n\r\n.la.la-dollar:before {\r\n  content: \"\\f155\"; }\r\n\r\n.la.la-inr:before {\r\n  content: \"\\f156\"; }\r\n\r\n.la.la-rupee:before {\r\n  content: \"\\f156\"; }\r\n\r\n.la.la-jpy:before {\r\n  content: \"\\f157\"; }\r\n\r\n.la.la-cny:before {\r\n  content: \"\\f157\"; }\r\n\r\n.la.la-rmb:before {\r\n  content: \"\\f157\"; }\r\n\r\n.la.la-yen:before {\r\n  content: \"\\f157\"; }\r\n\r\n.la.la-rub:before {\r\n  content: \"\\f158\"; }\r\n\r\n.la.la-ruble:before {\r\n  content: \"\\f158\"; }\r\n\r\n.la.la-rouble:before {\r\n  content: \"\\f158\"; }\r\n\r\n.la.la-krw:before {\r\n  content: \"\\f159\"; }\r\n\r\n.la.la-won:before {\r\n  content: \"\\f159\"; }\r\n\r\n.la.la-btc {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bitcoin {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bitcoin:before {\r\n  content: \"\\f15a\"; }\r\n\r\n.la.la-file-text:before {\r\n  content: \"\\f15c\"; }\r\n\r\n.la.la-sort-alpha-asc:before {\r\n  content: \"\\f15d\"; }\r\n\r\n.la.la-sort-alpha-desc:before {\r\n  content: \"\\f881\"; }\r\n\r\n.la.la-sort-amount-asc:before {\r\n  content: \"\\f160\"; }\r\n\r\n.la.la-sort-amount-desc:before {\r\n  content: \"\\f884\"; }\r\n\r\n.la.la-sort-numeric-asc:before {\r\n  content: \"\\f162\"; }\r\n\r\n.la.la-sort-numeric-desc:before {\r\n  content: \"\\f886\"; }\r\n\r\n.la.la-youtube-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-youtube {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-xing {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-xing-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-youtube-play {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-youtube-play:before {\r\n  content: \"\\f167\"; }\r\n\r\n.la.la-dropbox {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-stack-overflow {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-instagram {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-flickr {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-adn {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bitbucket {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bitbucket-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bitbucket-square:before {\r\n  content: \"\\f171\"; }\r\n\r\n.la.la-tumblr {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-tumblr-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-long-arrow-down:before {\r\n  content: \"\\f309\"; }\r\n\r\n.la.la-long-arrow-up:before {\r\n  content: \"\\f30c\"; }\r\n\r\n.la.la-long-arrow-left:before {\r\n  content: \"\\f30a\"; }\r\n\r\n.la.la-long-arrow-right:before {\r\n  content: \"\\f30b\"; }\r\n\r\n.la.la-apple {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-windows {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-android {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-linux {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-dribbble {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-skype {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-foursquare {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-trello {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gratipay {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gittip {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gittip:before {\r\n  content: \"\\f184\"; }\r\n\r\n.la.la-sun-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-sun-o:before {\r\n  content: \"\\f185\"; }\r\n\r\n.la.la-moon-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-moon-o:before {\r\n  content: \"\\f186\"; }\r\n\r\n.la.la-vk {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-weibo {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-renren {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pagelines {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-stack-exchange {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-arrow-circle-o-right {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-arrow-circle-o-right:before {\r\n  content: \"\\f35a\"; }\r\n\r\n.la.la-arrow-circle-o-left {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-arrow-circle-o-left:before {\r\n  content: \"\\f359\"; }\r\n\r\n.la.la-caret-square-o-left {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-caret-square-o-left:before {\r\n  content: \"\\f191\"; }\r\n\r\n.la.la-toggle-left {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-toggle-left:before {\r\n  content: \"\\f191\"; }\r\n\r\n.la.la-dot-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-dot-circle-o:before {\r\n  content: \"\\f192\"; }\r\n\r\n.la.la-vimeo-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-try:before {\r\n  content: \"\\f195\"; }\r\n\r\n.la.la-turkish-lira:before {\r\n  content: \"\\f195\"; }\r\n\r\n.la.la-plus-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-plus-square-o:before {\r\n  content: \"\\f0fe\"; }\r\n\r\n.la.la-slack {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wordpress {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-openid {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-institution:before {\r\n  content: \"\\f19c\"; }\r\n\r\n.la.la-bank:before {\r\n  content: \"\\f19c\"; }\r\n\r\n.la.la-mortar-board:before {\r\n  content: \"\\f19d\"; }\r\n\r\n.la.la-yahoo {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-reddit {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-reddit-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-stumbleupon-circle {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-stumbleupon {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-delicious {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-digg {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pied-piper-pp {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pied-piper-alt {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-drupal {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-joomla {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-spoon:before {\r\n  content: \"\\f2e5\"; }\r\n\r\n.la.la-behance {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-behance-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-steam {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-steam-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-automobile:before {\r\n  content: \"\\f1b9\"; }\r\n\r\n.la.la-cab:before {\r\n  content: \"\\f1ba\"; }\r\n\r\n.la.la-envelope-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-envelope-o:before {\r\n  content: \"\\f0e0\"; }\r\n\r\n.la.la-deviantart {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-soundcloud {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-pdf-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-pdf-o:before {\r\n  content: \"\\f1c1\"; }\r\n\r\n.la.la-file-word-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-word-o:before {\r\n  content: \"\\f1c2\"; }\r\n\r\n.la.la-file-excel-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-excel-o:before {\r\n  content: \"\\f1c3\"; }\r\n\r\n.la.la-file-powerpoint-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-powerpoint-o:before {\r\n  content: \"\\f1c4\"; }\r\n\r\n.la.la-file-image-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-image-o:before {\r\n  content: \"\\f1c5\"; }\r\n\r\n.la.la-file-photo-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-photo-o:before {\r\n  content: \"\\f1c5\"; }\r\n\r\n.la.la-file-picture-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-picture-o:before {\r\n  content: \"\\f1c5\"; }\r\n\r\n.la.la-file-archive-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-archive-o:before {\r\n  content: \"\\f1c6\"; }\r\n\r\n.la.la-file-zip-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-zip-o:before {\r\n  content: \"\\f1c6\"; }\r\n\r\n.la.la-file-audio-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-audio-o:before {\r\n  content: \"\\f1c7\"; }\r\n\r\n.la.la-file-sound-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-sound-o:before {\r\n  content: \"\\f1c7\"; }\r\n\r\n.la.la-file-video-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-video-o:before {\r\n  content: \"\\f1c8\"; }\r\n\r\n.la.la-file-movie-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-movie-o:before {\r\n  content: \"\\f1c8\"; }\r\n\r\n.la.la-file-code-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-code-o:before {\r\n  content: \"\\f1c9\"; }\r\n\r\n.la.la-vine {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-codepen {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-jsfiddle {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-life-ring {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-life-bouy {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-life-bouy:before {\r\n  content: \"\\f1cd\"; }\r\n\r\n.la.la-life-buoy {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-life-buoy:before {\r\n  content: \"\\f1cd\"; }\r\n\r\n.la.la-life-saver {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-life-saver:before {\r\n  content: \"\\f1cd\"; }\r\n\r\n.la.la-support {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-support:before {\r\n  content: \"\\f1cd\"; }\r\n\r\n.la.la-circle-o-notch:before {\r\n  content: \"\\f1ce\"; }\r\n\r\n.la.la-rebel {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ra {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ra:before {\r\n  content: \"\\f1d0\"; }\r\n\r\n.la.la-resistance {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-resistance:before {\r\n  content: \"\\f1d0\"; }\r\n\r\n.la.la-empire {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ge {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ge:before {\r\n  content: \"\\f1d1\"; }\r\n\r\n.la.la-git-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-git {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-hacker-news {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-y-combinator-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-y-combinator-square:before {\r\n  content: \"\\f1d4\"; }\r\n\r\n.la.la-yc-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-yc-square:before {\r\n  content: \"\\f1d4\"; }\r\n\r\n.la.la-tencent-weibo {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-qq {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-weixin {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wechat {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wechat:before {\r\n  content: \"\\f1d7\"; }\r\n\r\n.la.la-send:before {\r\n  content: \"\\f1d8\"; }\r\n\r\n.la.la-paper-plane-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-paper-plane-o:before {\r\n  content: \"\\f1d8\"; }\r\n\r\n.la.la-send-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-send-o:before {\r\n  content: \"\\f1d8\"; }\r\n\r\n.la.la-circle-thin {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-circle-thin:before {\r\n  content: \"\\f111\"; }\r\n\r\n.la.la-header:before {\r\n  content: \"\\f1dc\"; }\r\n\r\n.la.la-sliders:before {\r\n  content: \"\\f1de\"; }\r\n\r\n.la.la-futbol-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-futbol-o:before {\r\n  content: \"\\f1e3\"; }\r\n\r\n.la.la-soccer-ball-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-soccer-ball-o:before {\r\n  content: \"\\f1e3\"; }\r\n\r\n.la.la-slideshare {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-twitch {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-yelp {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-newspaper-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-newspaper-o:before {\r\n  content: \"\\f1ea\"; }\r\n\r\n.la.la-paypal {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-wallet {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-visa {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-mastercard {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-discover {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-amex {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-paypal {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-stripe {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bell-slash-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-bell-slash-o:before {\r\n  content: \"\\f1f6\"; }\r\n\r\n.la.la-trash:before {\r\n  content: \"\\f2ed\"; }\r\n\r\n.la.la-copyright {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-eyedropper:before {\r\n  content: \"\\f1fb\"; }\r\n\r\n.la.la-area-chart:before {\r\n  content: \"\\f1fe\"; }\r\n\r\n.la.la-pie-chart:before {\r\n  content: \"\\f200\"; }\r\n\r\n.la.la-line-chart:before {\r\n  content: \"\\f201\"; }\r\n\r\n.la.la-lastfm {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-lastfm-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ioxhost {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-angellist {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc:before {\r\n  content: \"\\f20a\"; }\r\n\r\n.la.la-ils:before {\r\n  content: \"\\f20b\"; }\r\n\r\n.la.la-shekel:before {\r\n  content: \"\\f20b\"; }\r\n\r\n.la.la-sheqel:before {\r\n  content: \"\\f20b\"; }\r\n\r\n.la.la-meanpath {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-meanpath:before {\r\n  content: \"\\f2b4\"; }\r\n\r\n.la.la-buysellads {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-connectdevelop {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-dashcube {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-forumbee {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-leanpub {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-sellsy {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-shirtsinbulk {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-simplybuilt {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-skyatlas {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-diamond {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-diamond:before {\r\n  content: \"\\f3a5\"; }\r\n\r\n.la.la-intersex:before {\r\n  content: \"\\f224\"; }\r\n\r\n.la.la-facebook-official {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-facebook-official:before {\r\n  content: \"\\f09a\"; }\r\n\r\n.la.la-pinterest-p {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-whatsapp {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-hotel:before {\r\n  content: \"\\f236\"; }\r\n\r\n.la.la-viacoin {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-medium {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-y-combinator {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-yc {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-yc:before {\r\n  content: \"\\f23b\"; }\r\n\r\n.la.la-optin-monster {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-opencart {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-expeditedssl {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-battery-4:before {\r\n  content: \"\\f240\"; }\r\n\r\n.la.la-battery:before {\r\n  content: \"\\f240\"; }\r\n\r\n.la.la-battery-3:before {\r\n  content: \"\\f241\"; }\r\n\r\n.la.la-battery-2:before {\r\n  content: \"\\f242\"; }\r\n\r\n.la.la-battery-1:before {\r\n  content: \"\\f243\"; }\r\n\r\n.la.la-battery-0:before {\r\n  content: \"\\f244\"; }\r\n\r\n.la.la-object-group {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-object-ungroup {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-sticky-note-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-sticky-note-o:before {\r\n  content: \"\\f249\"; }\r\n\r\n.la.la-cc-jcb {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-diners-club {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-clone {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hourglass-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hourglass-o:before {\r\n  content: \"\\f254\"; }\r\n\r\n.la.la-hourglass-1:before {\r\n  content: \"\\f251\"; }\r\n\r\n.la.la-hourglass-2:before {\r\n  content: \"\\f252\"; }\r\n\r\n.la.la-hourglass-3:before {\r\n  content: \"\\f253\"; }\r\n\r\n.la.la-hand-rock-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-rock-o:before {\r\n  content: \"\\f255\"; }\r\n\r\n.la.la-hand-grab-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-grab-o:before {\r\n  content: \"\\f255\"; }\r\n\r\n.la.la-hand-paper-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-paper-o:before {\r\n  content: \"\\f256\"; }\r\n\r\n.la.la-hand-stop-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-stop-o:before {\r\n  content: \"\\f256\"; }\r\n\r\n.la.la-hand-scissors-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-scissors-o:before {\r\n  content: \"\\f257\"; }\r\n\r\n.la.la-hand-lizard-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-lizard-o:before {\r\n  content: \"\\f258\"; }\r\n\r\n.la.la-hand-spock-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-spock-o:before {\r\n  content: \"\\f259\"; }\r\n\r\n.la.la-hand-pointer-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-pointer-o:before {\r\n  content: \"\\f25a\"; }\r\n\r\n.la.la-hand-peace-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-peace-o:before {\r\n  content: \"\\f25b\"; }\r\n\r\n.la.la-registered {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-creative-commons {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gg {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gg-circle {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-tripadvisor {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-odnoklassniki {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-odnoklassniki-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-get-pocket {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wikipedia-w {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-safari {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-chrome {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-firefox {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-opera {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-internet-explorer {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-television:before {\r\n  content: \"\\f26c\"; }\r\n\r\n.la.la-contao {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-500px {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-amazon {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-plus-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-plus-o:before {\r\n  content: \"\\f271\"; }\r\n\r\n.la.la-calendar-minus-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-minus-o:before {\r\n  content: \"\\f272\"; }\r\n\r\n.la.la-calendar-times-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-times-o:before {\r\n  content: \"\\f273\"; }\r\n\r\n.la.la-calendar-check-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-check-o:before {\r\n  content: \"\\f274\"; }\r\n\r\n.la.la-map-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-map-o:before {\r\n  content: \"\\f279\"; }\r\n\r\n.la.la-commenting:before {\r\n  content: \"\\f4ad\"; }\r\n\r\n.la.la-commenting-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-commenting-o:before {\r\n  content: \"\\f4ad\"; }\r\n\r\n.la.la-houzz {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-vimeo {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-vimeo:before {\r\n  content: \"\\f27d\"; }\r\n\r\n.la.la-black-tie {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-fonticons {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-reddit-alien {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-edge {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-credit-card-alt:before {\r\n  content: \"\\f09d\"; }\r\n\r\n.la.la-codiepie {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-modx {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-fort-awesome {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-usb {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-product-hunt {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-mixcloud {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-scribd {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pause-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-pause-circle-o:before {\r\n  content: \"\\f28b\"; }\r\n\r\n.la.la-stop-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-stop-circle-o:before {\r\n  content: \"\\f28d\"; }\r\n\r\n.la.la-bluetooth {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bluetooth-b {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gitlab {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wpbeginner {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wpforms {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-envira {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wheelchair-alt {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wheelchair-alt:before {\r\n  content: \"\\f368\"; }\r\n\r\n.la.la-question-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-question-circle-o:before {\r\n  content: \"\\f059\"; }\r\n\r\n.la.la-volume-control-phone:before {\r\n  content: \"\\f2a0\"; }\r\n\r\n.la.la-asl-interpreting:before {\r\n  content: \"\\f2a3\"; }\r\n\r\n.la.la-deafness:before {\r\n  content: \"\\f2a4\"; }\r\n\r\n.la.la-hard-of-hearing:before {\r\n  content: \"\\f2a4\"; }\r\n\r\n.la.la-glide {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-glide-g {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-signing:before {\r\n  content: \"\\f2a7\"; }\r\n\r\n.la.la-viadeo {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-viadeo-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-snapchat {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-snapchat-ghost {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-snapchat-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pied-piper {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-first-order {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-yoast {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-themeisle {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus-official {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus-official:before {\r\n  content: \"\\f2b3\"; }\r\n\r\n.la.la-google-plus-circle {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus-circle:before {\r\n  content: \"\\f2b3\"; }\r\n\r\n.la.la-font-awesome {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-fa {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-fa:before {\r\n  content: \"\\f2b4\"; }\r\n\r\n.la.la-handshake-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-handshake-o:before {\r\n  content: \"\\f2b5\"; }\r\n\r\n.la.la-envelope-open-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-envelope-open-o:before {\r\n  content: \"\\f2b6\"; }\r\n\r\n.la.la-linode {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-address-book-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-address-book-o:before {\r\n  content: \"\\f2b9\"; }\r\n\r\n.la.la-vcard:before {\r\n  content: \"\\f2bb\"; }\r\n\r\n.la.la-address-card-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-address-card-o:before {\r\n  content: \"\\f2bb\"; }\r\n\r\n.la.la-vcard-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-vcard-o:before {\r\n  content: \"\\f2bb\"; }\r\n\r\n.la.la-user-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-user-circle-o:before {\r\n  content: \"\\f2bd\"; }\r\n\r\n.la.la-user-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-user-o:before {\r\n  content: \"\\f007\"; }\r\n\r\n.la.la-id-badge {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-drivers-license:before {\r\n  content: \"\\f2c2\"; }\r\n\r\n.la.la-id-card-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-id-card-o:before {\r\n  content: \"\\f2c2\"; }\r\n\r\n.la.la-drivers-license-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-drivers-license-o:before {\r\n  content: \"\\f2c2\"; }\r\n\r\n.la.la-quora {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-free-code-camp {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-telegram {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-thermometer-4:before {\r\n  content: \"\\f2c7\"; }\r\n\r\n.la.la-thermometer:before {\r\n  content: \"\\f2c7\"; }\r\n\r\n.la.la-thermometer-3:before {\r\n  content: \"\\f2c8\"; }\r\n\r\n.la.la-thermometer-2:before {\r\n  content: \"\\f2c9\"; }\r\n\r\n.la.la-thermometer-1:before {\r\n  content: \"\\f2ca\"; }\r\n\r\n.la.la-thermometer-0:before {\r\n  content: \"\\f2cb\"; }\r\n\r\n.la.la-bathtub:before {\r\n  content: \"\\f2cd\"; }\r\n\r\n.la.la-s15:before {\r\n  content: \"\\f2cd\"; }\r\n\r\n.la.la-window-maximize {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-window-restore {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-times-rectangle:before {\r\n  content: \"\\f410\"; }\r\n\r\n.la.la-window-close-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-window-close-o:before {\r\n  content: \"\\f410\"; }\r\n\r\n.la.la-times-rectangle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-times-rectangle-o:before {\r\n  content: \"\\f410\"; }\r\n\r\n.la.la-bandcamp {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-grav {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-etsy {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-imdb {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ravelry {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-eercast {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-eercast:before {\r\n  content: \"\\f2da\"; }\r\n\r\n.la.la-snowflake-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-snowflake-o:before {\r\n  content: \"\\f2dc\"; }\r\n\r\n.la.la-superpowers {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wpexplorer {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-spotify {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n","/*\r\n* Remix Icon v2.5.0\r\n* https://remixicon.com\r\n* https://github.com/Remix-Design/RemixIcon\r\n*\r\n* Copyright RemixIcon.com\r\n* Released under the Apache License Version 2.0\r\n*\r\n* Date: 2020-05-23\r\n*/\r\n@font-face {\r\n  font-family: \"remixicon\";\r\n  src: url('../../../fonts/remixicon.eot?t=1590207869815'); /* IE9*/\r\n  src: url('../../../fonts/remixicon.eot?t=1590207869815#iefix') format('embedded-opentype'), /* IE6-IE8 */\r\n  url(\"../../../fonts/remixicon.woff2?t=1590207869815\") format(\"woff2\"),\r\n  url(\"../../../fonts/remixicon.woff?t=1590207869815\") format(\"woff\"),\r\n  url('../../../fonts/remixicon.ttf?t=1590207869815') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/\r\n  url('../../../fonts/remixicon.svg?t=1590207869815#remixicon') format('svg'); /* iOS 4.1- */\r\n  font-display: swap;\r\n}\r\n\r\n[class^=\"ri-\"], [class*=\" ri-\"] {\r\n  font-family: 'remixicon' !important;\r\n  font-style: normal;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.ri-lg { font-size: 1.3333em; line-height: 0.75em; vertical-align: -.0667em; }\r\n.ri-xl { font-size: 1.5em; line-height: 0.6666em; vertical-align: -.075em; }\r\n.ri-xxs { font-size: .5em; }\r\n.ri-xs { font-size: .75em; }\r\n.ri-sm { font-size: .875em }\r\n.ri-1x { font-size: 1em; }\r\n.ri-2x { font-size: 2em; }\r\n.ri-3x { font-size: 3em; }\r\n.ri-4x { font-size: 4em; }\r\n.ri-5x { font-size: 5em; }\r\n.ri-6x { font-size: 6em; }\r\n.ri-7x { font-size: 7em; }\r\n.ri-8x { font-size: 8em; }\r\n.ri-9x { font-size: 9em; }\r\n.ri-10x { font-size: 10em; }\r\n.ri-fw { text-align: center; width: 1.25em; }\r\n\r\n.ri-24-hours-fill:before { content: \"\\ea01\"; }\r\n.ri-24-hours-line:before { content: \"\\ea02\"; }\r\n.ri-4k-fill:before { content: \"\\ea03\"; }\r\n.ri-4k-line:before { content: \"\\ea04\"; }\r\n.ri-a-b:before { content: \"\\ea05\"; }\r\n.ri-account-box-fill:before { content: \"\\ea06\"; }\r\n.ri-account-box-line:before { content: \"\\ea07\"; }\r\n.ri-account-circle-fill:before { content: \"\\ea08\"; }\r\n.ri-account-circle-line:before { content: \"\\ea09\"; }\r\n.ri-account-pin-box-fill:before { content: \"\\ea0a\"; }\r\n.ri-account-pin-box-line:before { content: \"\\ea0b\"; }\r\n.ri-account-pin-circle-fill:before { content: \"\\ea0c\"; }\r\n.ri-account-pin-circle-line:before { content: \"\\ea0d\"; }\r\n.ri-add-box-fill:before { content: \"\\ea0e\"; }\r\n.ri-add-box-line:before { content: \"\\ea0f\"; }\r\n.ri-add-circle-fill:before { content: \"\\ea10\"; }\r\n.ri-add-circle-line:before { content: \"\\ea11\"; }\r\n.ri-add-fill:before { content: \"\\ea12\"; }\r\n.ri-add-line:before { content: \"\\ea13\"; }\r\n.ri-admin-fill:before { content: \"\\ea14\"; }\r\n.ri-admin-line:before { content: \"\\ea15\"; }\r\n.ri-advertisement-fill:before { content: \"\\ea16\"; }\r\n.ri-advertisement-line:before { content: \"\\ea17\"; }\r\n.ri-airplay-fill:before { content: \"\\ea18\"; }\r\n.ri-airplay-line:before { content: \"\\ea19\"; }\r\n.ri-alarm-fill:before { content: \"\\ea1a\"; }\r\n.ri-alarm-line:before { content: \"\\ea1b\"; }\r\n.ri-alarm-warning-fill:before { content: \"\\ea1c\"; }\r\n.ri-alarm-warning-line:before { content: \"\\ea1d\"; }\r\n.ri-album-fill:before { content: \"\\ea1e\"; }\r\n.ri-album-line:before { content: \"\\ea1f\"; }\r\n.ri-alert-fill:before { content: \"\\ea20\"; }\r\n.ri-alert-line:before { content: \"\\ea21\"; }\r\n.ri-aliens-fill:before { content: \"\\ea22\"; }\r\n.ri-aliens-line:before { content: \"\\ea23\"; }\r\n.ri-align-bottom:before { content: \"\\ea24\"; }\r\n.ri-align-center:before { content: \"\\ea25\"; }\r\n.ri-align-justify:before { content: \"\\ea26\"; }\r\n.ri-align-left:before { content: \"\\ea27\"; }\r\n.ri-align-right:before { content: \"\\ea28\"; }\r\n.ri-align-top:before { content: \"\\ea29\"; }\r\n.ri-align-vertically:before { content: \"\\ea2a\"; }\r\n.ri-alipay-fill:before { content: \"\\ea2b\"; }\r\n.ri-alipay-line:before { content: \"\\ea2c\"; }\r\n.ri-amazon-fill:before { content: \"\\ea2d\"; }\r\n.ri-amazon-line:before { content: \"\\ea2e\"; }\r\n.ri-anchor-fill:before { content: \"\\ea2f\"; }\r\n.ri-anchor-line:before { content: \"\\ea30\"; }\r\n.ri-ancient-gate-fill:before { content: \"\\ea31\"; }\r\n.ri-ancient-gate-line:before { content: \"\\ea32\"; }\r\n.ri-ancient-pavilion-fill:before { content: \"\\ea33\"; }\r\n.ri-ancient-pavilion-line:before { content: \"\\ea34\"; }\r\n.ri-android-fill:before { content: \"\\ea35\"; }\r\n.ri-android-line:before { content: \"\\ea36\"; }\r\n.ri-angularjs-fill:before { content: \"\\ea37\"; }\r\n.ri-angularjs-line:before { content: \"\\ea38\"; }\r\n.ri-anticlockwise-2-fill:before { content: \"\\ea39\"; }\r\n.ri-anticlockwise-2-line:before { content: \"\\ea3a\"; }\r\n.ri-anticlockwise-fill:before { content: \"\\ea3b\"; }\r\n.ri-anticlockwise-line:before { content: \"\\ea3c\"; }\r\n.ri-app-store-fill:before { content: \"\\ea3d\"; }\r\n.ri-app-store-line:before { content: \"\\ea3e\"; }\r\n.ri-apple-fill:before { content: \"\\ea3f\"; }\r\n.ri-apple-line:before { content: \"\\ea40\"; }\r\n.ri-apps-2-fill:before { content: \"\\ea41\"; }\r\n.ri-apps-2-line:before { content: \"\\ea42\"; }\r\n.ri-apps-fill:before { content: \"\\ea43\"; }\r\n.ri-apps-line:before { content: \"\\ea44\"; }\r\n.ri-archive-drawer-fill:before { content: \"\\ea45\"; }\r\n.ri-archive-drawer-line:before { content: \"\\ea46\"; }\r\n.ri-archive-fill:before { content: \"\\ea47\"; }\r\n.ri-archive-line:before { content: \"\\ea48\"; }\r\n.ri-arrow-down-circle-fill:before { content: \"\\ea49\"; }\r\n.ri-arrow-down-circle-line:before { content: \"\\ea4a\"; }\r\n.ri-arrow-down-fill:before { content: \"\\ea4b\"; }\r\n.ri-arrow-down-line:before { content: \"\\ea4c\"; }\r\n.ri-arrow-down-s-fill:before { content: \"\\ea4d\"; }\r\n.ri-arrow-down-s-line:before { content: \"\\ea4e\"; }\r\n.ri-arrow-drop-down-fill:before { content: \"\\ea4f\"; }\r\n.ri-arrow-drop-down-line:before { content: \"\\ea50\"; }\r\n.ri-arrow-drop-left-fill:before { content: \"\\ea51\"; }\r\n.ri-arrow-drop-left-line:before { content: \"\\ea52\"; }\r\n.ri-arrow-drop-right-fill:before { content: \"\\ea53\"; }\r\n.ri-arrow-drop-right-line:before { content: \"\\ea54\"; }\r\n.ri-arrow-drop-up-fill:before { content: \"\\ea55\"; }\r\n.ri-arrow-drop-up-line:before { content: \"\\ea56\"; }\r\n.ri-arrow-go-back-fill:before { content: \"\\ea57\"; }\r\n.ri-arrow-go-back-line:before { content: \"\\ea58\"; }\r\n.ri-arrow-go-forward-fill:before { content: \"\\ea59\"; }\r\n.ri-arrow-go-forward-line:before { content: \"\\ea5a\"; }\r\n.ri-arrow-left-circle-fill:before { content: \"\\ea5b\"; }\r\n.ri-arrow-left-circle-line:before { content: \"\\ea5c\"; }\r\n.ri-arrow-left-down-fill:before { content: \"\\ea5d\"; }\r\n.ri-arrow-left-down-line:before { content: \"\\ea5e\"; }\r\n.ri-arrow-left-fill:before { content: \"\\ea5f\"; }\r\n.ri-arrow-left-line:before { content: \"\\ea60\"; }\r\n.ri-arrow-left-right-fill:before { content: \"\\ea61\"; }\r\n.ri-arrow-left-right-line:before { content: \"\\ea62\"; }\r\n.ri-arrow-left-s-fill:before { content: \"\\ea63\"; }\r\n.ri-arrow-left-s-line:before { content: \"\\ea64\"; }\r\n.ri-arrow-left-up-fill:before { content: \"\\ea65\"; }\r\n.ri-arrow-left-up-line:before { content: \"\\ea66\"; }\r\n.ri-arrow-right-circle-fill:before { content: \"\\ea67\"; }\r\n.ri-arrow-right-circle-line:before { content: \"\\ea68\"; }\r\n.ri-arrow-right-down-fill:before { content: \"\\ea69\"; }\r\n.ri-arrow-right-down-line:before { content: \"\\ea6a\"; }\r\n.ri-arrow-right-fill:before { content: \"\\ea6b\"; }\r\n.ri-arrow-right-line:before { content: \"\\ea6c\"; }\r\n.ri-arrow-right-s-fill:before { content: \"\\ea6d\"; }\r\n.ri-arrow-right-s-line:before { content: \"\\ea6e\"; }\r\n.ri-arrow-right-up-fill:before { content: \"\\ea6f\"; }\r\n.ri-arrow-right-up-line:before { content: \"\\ea70\"; }\r\n.ri-arrow-up-circle-fill:before { content: \"\\ea71\"; }\r\n.ri-arrow-up-circle-line:before { content: \"\\ea72\"; }\r\n.ri-arrow-up-down-fill:before { content: \"\\ea73\"; }\r\n.ri-arrow-up-down-line:before { content: \"\\ea74\"; }\r\n.ri-arrow-up-fill:before { content: \"\\ea75\"; }\r\n.ri-arrow-up-line:before { content: \"\\ea76\"; }\r\n.ri-arrow-up-s-fill:before { content: \"\\ea77\"; }\r\n.ri-arrow-up-s-line:before { content: \"\\ea78\"; }\r\n.ri-artboard-2-fill:before { content: \"\\ea79\"; }\r\n.ri-artboard-2-line:before { content: \"\\ea7a\"; }\r\n.ri-artboard-fill:before { content: \"\\ea7b\"; }\r\n.ri-artboard-line:before { content: \"\\ea7c\"; }\r\n.ri-article-fill:before { content: \"\\ea7d\"; }\r\n.ri-article-line:before { content: \"\\ea7e\"; }\r\n.ri-aspect-ratio-fill:before { content: \"\\ea7f\"; }\r\n.ri-aspect-ratio-line:before { content: \"\\ea80\"; }\r\n.ri-asterisk:before { content: \"\\ea81\"; }\r\n.ri-at-fill:before { content: \"\\ea82\"; }\r\n.ri-at-line:before { content: \"\\ea83\"; }\r\n.ri-attachment-2:before { content: \"\\ea84\"; }\r\n.ri-attachment-fill:before { content: \"\\ea85\"; }\r\n.ri-attachment-line:before { content: \"\\ea86\"; }\r\n.ri-auction-fill:before { content: \"\\ea87\"; }\r\n.ri-auction-line:before { content: \"\\ea88\"; }\r\n.ri-award-fill:before { content: \"\\ea89\"; }\r\n.ri-award-line:before { content: \"\\ea8a\"; }\r\n.ri-baidu-fill:before { content: \"\\ea8b\"; }\r\n.ri-baidu-line:before { content: \"\\ea8c\"; }\r\n.ri-ball-pen-fill:before { content: \"\\ea8d\"; }\r\n.ri-ball-pen-line:before { content: \"\\ea8e\"; }\r\n.ri-bank-card-2-fill:before { content: \"\\ea8f\"; }\r\n.ri-bank-card-2-line:before { content: \"\\ea90\"; }\r\n.ri-bank-card-fill:before { content: \"\\ea91\"; }\r\n.ri-bank-card-line:before { content: \"\\ea92\"; }\r\n.ri-bank-fill:before { content: \"\\ea93\"; }\r\n.ri-bank-line:before { content: \"\\ea94\"; }\r\n.ri-bar-chart-2-fill:before { content: \"\\ea95\"; }\r\n.ri-bar-chart-2-line:before { content: \"\\ea96\"; }\r\n.ri-bar-chart-box-fill:before { content: \"\\ea97\"; }\r\n.ri-bar-chart-box-line:before { content: \"\\ea98\"; }\r\n.ri-bar-chart-fill:before { content: \"\\ea99\"; }\r\n.ri-bar-chart-grouped-fill:before { content: \"\\ea9a\"; }\r\n.ri-bar-chart-grouped-line:before { content: \"\\ea9b\"; }\r\n.ri-bar-chart-horizontal-fill:before { content: \"\\ea9c\"; }\r\n.ri-bar-chart-horizontal-line:before { content: \"\\ea9d\"; }\r\n.ri-bar-chart-line:before { content: \"\\ea9e\"; }\r\n.ri-barcode-box-fill:before { content: \"\\ea9f\"; }\r\n.ri-barcode-box-line:before { content: \"\\eaa0\"; }\r\n.ri-barcode-fill:before { content: \"\\eaa1\"; }\r\n.ri-barcode-line:before { content: \"\\eaa2\"; }\r\n.ri-barricade-fill:before { content: \"\\eaa3\"; }\r\n.ri-barricade-line:before { content: \"\\eaa4\"; }\r\n.ri-base-station-fill:before { content: \"\\eaa5\"; }\r\n.ri-base-station-line:before { content: \"\\eaa6\"; }\r\n.ri-basketball-fill:before { content: \"\\eaa7\"; }\r\n.ri-basketball-line:before { content: \"\\eaa8\"; }\r\n.ri-battery-2-charge-fill:before { content: \"\\eaa9\"; }\r\n.ri-battery-2-charge-line:before { content: \"\\eaaa\"; }\r\n.ri-battery-2-fill:before { content: \"\\eaab\"; }\r\n.ri-battery-2-line:before { content: \"\\eaac\"; }\r\n.ri-battery-charge-fill:before { content: \"\\eaad\"; }\r\n.ri-battery-charge-line:before { content: \"\\eaae\"; }\r\n.ri-battery-fill:before { content: \"\\eaaf\"; }\r\n.ri-battery-line:before { content: \"\\eab0\"; }\r\n.ri-battery-low-fill:before { content: \"\\eab1\"; }\r\n.ri-battery-low-line:before { content: \"\\eab2\"; }\r\n.ri-battery-saver-fill:before { content: \"\\eab3\"; }\r\n.ri-battery-saver-line:before { content: \"\\eab4\"; }\r\n.ri-battery-share-fill:before { content: \"\\eab5\"; }\r\n.ri-battery-share-line:before { content: \"\\eab6\"; }\r\n.ri-bear-smile-fill:before { content: \"\\eab7\"; }\r\n.ri-bear-smile-line:before { content: \"\\eab8\"; }\r\n.ri-behance-fill:before { content: \"\\eab9\"; }\r\n.ri-behance-line:before { content: \"\\eaba\"; }\r\n.ri-bell-fill:before { content: \"\\eabb\"; }\r\n.ri-bell-line:before { content: \"\\eabc\"; }\r\n.ri-bike-fill:before { content: \"\\eabd\"; }\r\n.ri-bike-line:before { content: \"\\eabe\"; }\r\n.ri-bilibili-fill:before { content: \"\\eabf\"; }\r\n.ri-bilibili-line:before { content: \"\\eac0\"; }\r\n.ri-bill-fill:before { content: \"\\eac1\"; }\r\n.ri-bill-line:before { content: \"\\eac2\"; }\r\n.ri-billiards-fill:before { content: \"\\eac3\"; }\r\n.ri-billiards-line:before { content: \"\\eac4\"; }\r\n.ri-bit-coin-fill:before { content: \"\\eac5\"; }\r\n.ri-bit-coin-line:before { content: \"\\eac6\"; }\r\n.ri-blaze-fill:before { content: \"\\eac7\"; }\r\n.ri-blaze-line:before { content: \"\\eac8\"; }\r\n.ri-bluetooth-connect-fill:before { content: \"\\eac9\"; }\r\n.ri-bluetooth-connect-line:before { content: \"\\eaca\"; }\r\n.ri-bluetooth-fill:before { content: \"\\eacb\"; }\r\n.ri-bluetooth-line:before { content: \"\\eacc\"; }\r\n.ri-blur-off-fill:before { content: \"\\eacd\"; }\r\n.ri-blur-off-line:before { content: \"\\eace\"; }\r\n.ri-body-scan-fill:before { content: \"\\eacf\"; }\r\n.ri-body-scan-line:before { content: \"\\ead0\"; }\r\n.ri-bold:before { content: \"\\ead1\"; }\r\n.ri-book-2-fill:before { content: \"\\ead2\"; }\r\n.ri-book-2-line:before { content: \"\\ead3\"; }\r\n.ri-book-3-fill:before { content: \"\\ead4\"; }\r\n.ri-book-3-line:before { content: \"\\ead5\"; }\r\n.ri-book-fill:before { content: \"\\ead6\"; }\r\n.ri-book-line:before { content: \"\\ead7\"; }\r\n.ri-book-mark-fill:before { content: \"\\ead8\"; }\r\n.ri-book-mark-line:before { content: \"\\ead9\"; }\r\n.ri-book-open-fill:before { content: \"\\eada\"; }\r\n.ri-book-open-line:before { content: \"\\eadb\"; }\r\n.ri-book-read-fill:before { content: \"\\eadc\"; }\r\n.ri-book-read-line:before { content: \"\\eadd\"; }\r\n.ri-booklet-fill:before { content: \"\\eade\"; }\r\n.ri-booklet-line:before { content: \"\\eadf\"; }\r\n.ri-bookmark-2-fill:before { content: \"\\eae0\"; }\r\n.ri-bookmark-2-line:before { content: \"\\eae1\"; }\r\n.ri-bookmark-3-fill:before { content: \"\\eae2\"; }\r\n.ri-bookmark-3-line:before { content: \"\\eae3\"; }\r\n.ri-bookmark-fill:before { content: \"\\eae4\"; }\r\n.ri-bookmark-line:before { content: \"\\eae5\"; }\r\n.ri-boxing-fill:before { content: \"\\eae6\"; }\r\n.ri-boxing-line:before { content: \"\\eae7\"; }\r\n.ri-braces-fill:before { content: \"\\eae8\"; }\r\n.ri-braces-line:before { content: \"\\eae9\"; }\r\n.ri-brackets-fill:before { content: \"\\eaea\"; }\r\n.ri-brackets-line:before { content: \"\\eaeb\"; }\r\n.ri-briefcase-2-fill:before { content: \"\\eaec\"; }\r\n.ri-briefcase-2-line:before { content: \"\\eaed\"; }\r\n.ri-briefcase-3-fill:before { content: \"\\eaee\"; }\r\n.ri-briefcase-3-line:before { content: \"\\eaef\"; }\r\n.ri-briefcase-4-fill:before { content: \"\\eaf0\"; }\r\n.ri-briefcase-4-line:before { content: \"\\eaf1\"; }\r\n.ri-briefcase-5-fill:before { content: \"\\eaf2\"; }\r\n.ri-briefcase-5-line:before { content: \"\\eaf3\"; }\r\n.ri-briefcase-fill:before { content: \"\\eaf4\"; }\r\n.ri-briefcase-line:before { content: \"\\eaf5\"; }\r\n.ri-bring-forward:before { content: \"\\eaf6\"; }\r\n.ri-bring-to-front:before { content: \"\\eaf7\"; }\r\n.ri-broadcast-fill:before { content: \"\\eaf8\"; }\r\n.ri-broadcast-line:before { content: \"\\eaf9\"; }\r\n.ri-brush-2-fill:before { content: \"\\eafa\"; }\r\n.ri-brush-2-line:before { content: \"\\eafb\"; }\r\n.ri-brush-3-fill:before { content: \"\\eafc\"; }\r\n.ri-brush-3-line:before { content: \"\\eafd\"; }\r\n.ri-brush-4-fill:before { content: \"\\eafe\"; }\r\n.ri-brush-4-line:before { content: \"\\eaff\"; }\r\n.ri-brush-fill:before { content: \"\\eb00\"; }\r\n.ri-brush-line:before { content: \"\\eb01\"; }\r\n.ri-bubble-chart-fill:before { content: \"\\eb02\"; }\r\n.ri-bubble-chart-line:before { content: \"\\eb03\"; }\r\n.ri-bug-2-fill:before { content: \"\\eb04\"; }\r\n.ri-bug-2-line:before { content: \"\\eb05\"; }\r\n.ri-bug-fill:before { content: \"\\eb06\"; }\r\n.ri-bug-line:before { content: \"\\eb07\"; }\r\n.ri-building-2-fill:before { content: \"\\eb08\"; }\r\n.ri-building-2-line:before { content: \"\\eb09\"; }\r\n.ri-building-3-fill:before { content: \"\\eb0a\"; }\r\n.ri-building-3-line:before { content: \"\\eb0b\"; }\r\n.ri-building-4-fill:before { content: \"\\eb0c\"; }\r\n.ri-building-4-line:before { content: \"\\eb0d\"; }\r\n.ri-building-fill:before { content: \"\\eb0e\"; }\r\n.ri-building-line:before { content: \"\\eb0f\"; }\r\n.ri-bus-2-fill:before { content: \"\\eb10\"; }\r\n.ri-bus-2-line:before { content: \"\\eb11\"; }\r\n.ri-bus-fill:before { content: \"\\eb12\"; }\r\n.ri-bus-line:before { content: \"\\eb13\"; }\r\n.ri-bus-wifi-fill:before { content: \"\\eb14\"; }\r\n.ri-bus-wifi-line:before { content: \"\\eb15\"; }\r\n.ri-cactus-fill:before { content: \"\\eb16\"; }\r\n.ri-cactus-line:before { content: \"\\eb17\"; }\r\n.ri-cake-2-fill:before { content: \"\\eb18\"; }\r\n.ri-cake-2-line:before { content: \"\\eb19\"; }\r\n.ri-cake-3-fill:before { content: \"\\eb1a\"; }\r\n.ri-cake-3-line:before { content: \"\\eb1b\"; }\r\n.ri-cake-fill:before { content: \"\\eb1c\"; }\r\n.ri-cake-line:before { content: \"\\eb1d\"; }\r\n.ri-calculator-fill:before { content: \"\\eb1e\"; }\r\n.ri-calculator-line:before { content: \"\\eb1f\"; }\r\n.ri-calendar-2-fill:before { content: \"\\eb20\"; }\r\n.ri-calendar-2-line:before { content: \"\\eb21\"; }\r\n.ri-calendar-check-fill:before { content: \"\\eb22\"; }\r\n.ri-calendar-check-line:before { content: \"\\eb23\"; }\r\n.ri-calendar-event-fill:before { content: \"\\eb24\"; }\r\n.ri-calendar-event-line:before { content: \"\\eb25\"; }\r\n.ri-calendar-fill:before { content: \"\\eb26\"; }\r\n.ri-calendar-line:before { content: \"\\eb27\"; }\r\n.ri-calendar-todo-fill:before { content: \"\\eb28\"; }\r\n.ri-calendar-todo-line:before { content: \"\\eb29\"; }\r\n.ri-camera-2-fill:before { content: \"\\eb2a\"; }\r\n.ri-camera-2-line:before { content: \"\\eb2b\"; }\r\n.ri-camera-3-fill:before { content: \"\\eb2c\"; }\r\n.ri-camera-3-line:before { content: \"\\eb2d\"; }\r\n.ri-camera-fill:before { content: \"\\eb2e\"; }\r\n.ri-camera-lens-fill:before { content: \"\\eb2f\"; }\r\n.ri-camera-lens-line:before { content: \"\\eb30\"; }\r\n.ri-camera-line:before { content: \"\\eb31\"; }\r\n.ri-camera-off-fill:before { content: \"\\eb32\"; }\r\n.ri-camera-off-line:before { content: \"\\eb33\"; }\r\n.ri-camera-switch-fill:before { content: \"\\eb34\"; }\r\n.ri-camera-switch-line:before { content: \"\\eb35\"; }\r\n.ri-capsule-fill:before { content: \"\\eb36\"; }\r\n.ri-capsule-line:before { content: \"\\eb37\"; }\r\n.ri-car-fill:before { content: \"\\eb38\"; }\r\n.ri-car-line:before { content: \"\\eb39\"; }\r\n.ri-car-washing-fill:before { content: \"\\eb3a\"; }\r\n.ri-car-washing-line:before { content: \"\\eb3b\"; }\r\n.ri-caravan-fill:before { content: \"\\eb3c\"; }\r\n.ri-caravan-line:before { content: \"\\eb3d\"; }\r\n.ri-cast-fill:before { content: \"\\eb3e\"; }\r\n.ri-cast-line:before { content: \"\\eb3f\"; }\r\n.ri-cellphone-fill:before { content: \"\\eb40\"; }\r\n.ri-cellphone-line:before { content: \"\\eb41\"; }\r\n.ri-celsius-fill:before { content: \"\\eb42\"; }\r\n.ri-celsius-line:before { content: \"\\eb43\"; }\r\n.ri-centos-fill:before { content: \"\\eb44\"; }\r\n.ri-centos-line:before { content: \"\\eb45\"; }\r\n.ri-character-recognition-fill:before { content: \"\\eb46\"; }\r\n.ri-character-recognition-line:before { content: \"\\eb47\"; }\r\n.ri-charging-pile-2-fill:before { content: \"\\eb48\"; }\r\n.ri-charging-pile-2-line:before { content: \"\\eb49\"; }\r\n.ri-charging-pile-fill:before { content: \"\\eb4a\"; }\r\n.ri-charging-pile-line:before { content: \"\\eb4b\"; }\r\n.ri-chat-1-fill:before { content: \"\\eb4c\"; }\r\n.ri-chat-1-line:before { content: \"\\eb4d\"; }\r\n.ri-chat-2-fill:before { content: \"\\eb4e\"; }\r\n.ri-chat-2-line:before { content: \"\\eb4f\"; }\r\n.ri-chat-3-fill:before { content: \"\\eb50\"; }\r\n.ri-chat-3-line:before { content: \"\\eb51\"; }\r\n.ri-chat-4-fill:before { content: \"\\eb52\"; }\r\n.ri-chat-4-line:before { content: \"\\eb53\"; }\r\n.ri-chat-check-fill:before { content: \"\\eb54\"; }\r\n.ri-chat-check-line:before { content: \"\\eb55\"; }\r\n.ri-chat-delete-fill:before { content: \"\\eb56\"; }\r\n.ri-chat-delete-line:before { content: \"\\eb57\"; }\r\n.ri-chat-download-fill:before { content: \"\\eb58\"; }\r\n.ri-chat-download-line:before { content: \"\\eb59\"; }\r\n.ri-chat-follow-up-fill:before { content: \"\\eb5a\"; }\r\n.ri-chat-follow-up-line:before { content: \"\\eb5b\"; }\r\n.ri-chat-forward-fill:before { content: \"\\eb5c\"; }\r\n.ri-chat-forward-line:before { content: \"\\eb5d\"; }\r\n.ri-chat-heart-fill:before { content: \"\\eb5e\"; }\r\n.ri-chat-heart-line:before { content: \"\\eb5f\"; }\r\n.ri-chat-history-fill:before { content: \"\\eb60\"; }\r\n.ri-chat-history-line:before { content: \"\\eb61\"; }\r\n.ri-chat-new-fill:before { content: \"\\eb62\"; }\r\n.ri-chat-new-line:before { content: \"\\eb63\"; }\r\n.ri-chat-off-fill:before { content: \"\\eb64\"; }\r\n.ri-chat-off-line:before { content: \"\\eb65\"; }\r\n.ri-chat-poll-fill:before { content: \"\\eb66\"; }\r\n.ri-chat-poll-line:before { content: \"\\eb67\"; }\r\n.ri-chat-private-fill:before { content: \"\\eb68\"; }\r\n.ri-chat-private-line:before { content: \"\\eb69\"; }\r\n.ri-chat-quote-fill:before { content: \"\\eb6a\"; }\r\n.ri-chat-quote-line:before { content: \"\\eb6b\"; }\r\n.ri-chat-settings-fill:before { content: \"\\eb6c\"; }\r\n.ri-chat-settings-line:before { content: \"\\eb6d\"; }\r\n.ri-chat-smile-2-fill:before { content: \"\\eb6e\"; }\r\n.ri-chat-smile-2-line:before { content: \"\\eb6f\"; }\r\n.ri-chat-smile-3-fill:before { content: \"\\eb70\"; }\r\n.ri-chat-smile-3-line:before { content: \"\\eb71\"; }\r\n.ri-chat-smile-fill:before { content: \"\\eb72\"; }\r\n.ri-chat-smile-line:before { content: \"\\eb73\"; }\r\n.ri-chat-upload-fill:before { content: \"\\eb74\"; }\r\n.ri-chat-upload-line:before { content: \"\\eb75\"; }\r\n.ri-chat-voice-fill:before { content: \"\\eb76\"; }\r\n.ri-chat-voice-line:before { content: \"\\eb77\"; }\r\n.ri-check-double-fill:before { content: \"\\eb78\"; }\r\n.ri-check-double-line:before { content: \"\\eb79\"; }\r\n.ri-check-fill:before { content: \"\\eb7a\"; }\r\n.ri-check-line:before { content: \"\\eb7b\"; }\r\n.ri-checkbox-blank-circle-fill:before { content: \"\\eb7c\"; }\r\n.ri-checkbox-blank-circle-line:before { content: \"\\eb7d\"; }\r\n.ri-checkbox-blank-fill:before { content: \"\\eb7e\"; }\r\n.ri-checkbox-blank-line:before { content: \"\\eb7f\"; }\r\n.ri-checkbox-circle-fill:before { content: \"\\eb80\"; }\r\n.ri-checkbox-circle-line:before { content: \"\\eb81\"; }\r\n.ri-checkbox-fill:before { content: \"\\eb82\"; }\r\n.ri-checkbox-indeterminate-fill:before { content: \"\\eb83\"; }\r\n.ri-checkbox-indeterminate-line:before { content: \"\\eb84\"; }\r\n.ri-checkbox-line:before { content: \"\\eb85\"; }\r\n.ri-checkbox-multiple-blank-fill:before { content: \"\\eb86\"; }\r\n.ri-checkbox-multiple-blank-line:before { content: \"\\eb87\"; }\r\n.ri-checkbox-multiple-fill:before { content: \"\\eb88\"; }\r\n.ri-checkbox-multiple-line:before { content: \"\\eb89\"; }\r\n.ri-china-railway-fill:before { content: \"\\eb8a\"; }\r\n.ri-china-railway-line:before { content: \"\\eb8b\"; }\r\n.ri-chrome-fill:before { content: \"\\eb8c\"; }\r\n.ri-chrome-line:before { content: \"\\eb8d\"; }\r\n.ri-clapperboard-fill:before { content: \"\\eb8e\"; }\r\n.ri-clapperboard-line:before { content: \"\\eb8f\"; }\r\n.ri-clipboard-fill:before { content: \"\\eb90\"; }\r\n.ri-clipboard-line:before { content: \"\\eb91\"; }\r\n.ri-clockwise-2-fill:before { content: \"\\eb92\"; }\r\n.ri-clockwise-2-line:before { content: \"\\eb93\"; }\r\n.ri-clockwise-fill:before { content: \"\\eb94\"; }\r\n.ri-clockwise-line:before { content: \"\\eb95\"; }\r\n.ri-close-circle-fill:before { content: \"\\eb96\"; }\r\n.ri-close-circle-line:before { content: \"\\eb97\"; }\r\n.ri-close-fill:before { content: \"\\eb98\"; }\r\n.ri-close-line:before { content: \"\\eb99\"; }\r\n.ri-closed-captioning-fill:before { content: \"\\eb9a\"; }\r\n.ri-closed-captioning-line:before { content: \"\\eb9b\"; }\r\n.ri-cloud-fill:before { content: \"\\eb9c\"; }\r\n.ri-cloud-line:before { content: \"\\eb9d\"; }\r\n.ri-cloud-off-fill:before { content: \"\\eb9e\"; }\r\n.ri-cloud-off-line:before { content: \"\\eb9f\"; }\r\n.ri-cloud-windy-fill:before { content: \"\\eba0\"; }\r\n.ri-cloud-windy-line:before { content: \"\\eba1\"; }\r\n.ri-cloudy-2-fill:before { content: \"\\eba2\"; }\r\n.ri-cloudy-2-line:before { content: \"\\eba3\"; }\r\n.ri-cloudy-fill:before { content: \"\\eba4\"; }\r\n.ri-cloudy-line:before { content: \"\\eba5\"; }\r\n.ri-code-box-fill:before { content: \"\\eba6\"; }\r\n.ri-code-box-line:before { content: \"\\eba7\"; }\r\n.ri-code-fill:before { content: \"\\eba8\"; }\r\n.ri-code-line:before { content: \"\\eba9\"; }\r\n.ri-code-s-fill:before { content: \"\\ebaa\"; }\r\n.ri-code-s-line:before { content: \"\\ebab\"; }\r\n.ri-code-s-slash-fill:before { content: \"\\ebac\"; }\r\n.ri-code-s-slash-line:before { content: \"\\ebad\"; }\r\n.ri-code-view:before { content: \"\\ebae\"; }\r\n.ri-codepen-fill:before { content: \"\\ebaf\"; }\r\n.ri-codepen-line:before { content: \"\\ebb0\"; }\r\n.ri-coin-fill:before { content: \"\\ebb1\"; }\r\n.ri-coin-line:before { content: \"\\ebb2\"; }\r\n.ri-coins-fill:before { content: \"\\ebb3\"; }\r\n.ri-coins-line:before { content: \"\\ebb4\"; }\r\n.ri-collage-fill:before { content: \"\\ebb5\"; }\r\n.ri-collage-line:before { content: \"\\ebb6\"; }\r\n.ri-command-fill:before { content: \"\\ebb7\"; }\r\n.ri-command-line:before { content: \"\\ebb8\"; }\r\n.ri-community-fill:before { content: \"\\ebb9\"; }\r\n.ri-community-line:before { content: \"\\ebba\"; }\r\n.ri-compass-2-fill:before { content: \"\\ebbb\"; }\r\n.ri-compass-2-line:before { content: \"\\ebbc\"; }\r\n.ri-compass-3-fill:before { content: \"\\ebbd\"; }\r\n.ri-compass-3-line:before { content: \"\\ebbe\"; }\r\n.ri-compass-4-fill:before { content: \"\\ebbf\"; }\r\n.ri-compass-4-line:before { content: \"\\ebc0\"; }\r\n.ri-compass-discover-fill:before { content: \"\\ebc1\"; }\r\n.ri-compass-discover-line:before { content: \"\\ebc2\"; }\r\n.ri-compass-fill:before { content: \"\\ebc3\"; }\r\n.ri-compass-line:before { content: \"\\ebc4\"; }\r\n.ri-compasses-2-fill:before { content: \"\\ebc5\"; }\r\n.ri-compasses-2-line:before { content: \"\\ebc6\"; }\r\n.ri-compasses-fill:before { content: \"\\ebc7\"; }\r\n.ri-compasses-line:before { content: \"\\ebc8\"; }\r\n.ri-computer-fill:before { content: \"\\ebc9\"; }\r\n.ri-computer-line:before { content: \"\\ebca\"; }\r\n.ri-contacts-book-2-fill:before { content: \"\\ebcb\"; }\r\n.ri-contacts-book-2-line:before { content: \"\\ebcc\"; }\r\n.ri-contacts-book-fill:before { content: \"\\ebcd\"; }\r\n.ri-contacts-book-line:before { content: \"\\ebce\"; }\r\n.ri-contacts-book-upload-fill:before { content: \"\\ebcf\"; }\r\n.ri-contacts-book-upload-line:before { content: \"\\ebd0\"; }\r\n.ri-contacts-fill:before { content: \"\\ebd1\"; }\r\n.ri-contacts-line:before { content: \"\\ebd2\"; }\r\n.ri-contrast-2-fill:before { content: \"\\ebd3\"; }\r\n.ri-contrast-2-line:before { content: \"\\ebd4\"; }\r\n.ri-contrast-drop-2-fill:before { content: \"\\ebd5\"; }\r\n.ri-contrast-drop-2-line:before { content: \"\\ebd6\"; }\r\n.ri-contrast-drop-fill:before { content: \"\\ebd7\"; }\r\n.ri-contrast-drop-line:before { content: \"\\ebd8\"; }\r\n.ri-contrast-fill:before { content: \"\\ebd9\"; }\r\n.ri-contrast-line:before { content: \"\\ebda\"; }\r\n.ri-copper-coin-fill:before { content: \"\\ebdb\"; }\r\n.ri-copper-coin-line:before { content: \"\\ebdc\"; }\r\n.ri-copper-diamond-fill:before { content: \"\\ebdd\"; }\r\n.ri-copper-diamond-line:before { content: \"\\ebde\"; }\r\n.ri-copyleft-fill:before { content: \"\\ebdf\"; }\r\n.ri-copyleft-line:before { content: \"\\ebe0\"; }\r\n.ri-copyright-fill:before { content: \"\\ebe1\"; }\r\n.ri-copyright-line:before { content: \"\\ebe2\"; }\r\n.ri-coreos-fill:before { content: \"\\ebe3\"; }\r\n.ri-coreos-line:before { content: \"\\ebe4\"; }\r\n.ri-coupon-2-fill:before { content: \"\\ebe5\"; }\r\n.ri-coupon-2-line:before { content: \"\\ebe6\"; }\r\n.ri-coupon-3-fill:before { content: \"\\ebe7\"; }\r\n.ri-coupon-3-line:before { content: \"\\ebe8\"; }\r\n.ri-coupon-4-fill:before { content: \"\\ebe9\"; }\r\n.ri-coupon-4-line:before { content: \"\\ebea\"; }\r\n.ri-coupon-5-fill:before { content: \"\\ebeb\"; }\r\n.ri-coupon-5-line:before { content: \"\\ebec\"; }\r\n.ri-coupon-fill:before { content: \"\\ebed\"; }\r\n.ri-coupon-line:before { content: \"\\ebee\"; }\r\n.ri-cpu-fill:before { content: \"\\ebef\"; }\r\n.ri-cpu-line:before { content: \"\\ebf0\"; }\r\n.ri-creative-commons-by-fill:before { content: \"\\ebf1\"; }\r\n.ri-creative-commons-by-line:before { content: \"\\ebf2\"; }\r\n.ri-creative-commons-fill:before { content: \"\\ebf3\"; }\r\n.ri-creative-commons-line:before { content: \"\\ebf4\"; }\r\n.ri-creative-commons-nc-fill:before { content: \"\\ebf5\"; }\r\n.ri-creative-commons-nc-line:before { content: \"\\ebf6\"; }\r\n.ri-creative-commons-nd-fill:before { content: \"\\ebf7\"; }\r\n.ri-creative-commons-nd-line:before { content: \"\\ebf8\"; }\r\n.ri-creative-commons-sa-fill:before { content: \"\\ebf9\"; }\r\n.ri-creative-commons-sa-line:before { content: \"\\ebfa\"; }\r\n.ri-creative-commons-zero-fill:before { content: \"\\ebfb\"; }\r\n.ri-creative-commons-zero-line:before { content: \"\\ebfc\"; }\r\n.ri-criminal-fill:before { content: \"\\ebfd\"; }\r\n.ri-criminal-line:before { content: \"\\ebfe\"; }\r\n.ri-crop-2-fill:before { content: \"\\ebff\"; }\r\n.ri-crop-2-line:before { content: \"\\ec00\"; }\r\n.ri-crop-fill:before { content: \"\\ec01\"; }\r\n.ri-crop-line:before { content: \"\\ec02\"; }\r\n.ri-css3-fill:before { content: \"\\ec03\"; }\r\n.ri-css3-line:before { content: \"\\ec04\"; }\r\n.ri-cup-fill:before { content: \"\\ec05\"; }\r\n.ri-cup-line:before { content: \"\\ec06\"; }\r\n.ri-currency-fill:before { content: \"\\ec07\"; }\r\n.ri-currency-line:before { content: \"\\ec08\"; }\r\n.ri-cursor-fill:before { content: \"\\ec09\"; }\r\n.ri-cursor-line:before { content: \"\\ec0a\"; }\r\n.ri-customer-service-2-fill:before { content: \"\\ec0b\"; }\r\n.ri-customer-service-2-line:before { content: \"\\ec0c\"; }\r\n.ri-customer-service-fill:before { content: \"\\ec0d\"; }\r\n.ri-customer-service-line:before { content: \"\\ec0e\"; }\r\n.ri-dashboard-2-fill:before { content: \"\\ec0f\"; }\r\n.ri-dashboard-2-line:before { content: \"\\ec10\"; }\r\n.ri-dashboard-3-fill:before { content: \"\\ec11\"; }\r\n.ri-dashboard-3-line:before { content: \"\\ec12\"; }\r\n.ri-dashboard-fill:before { content: \"\\ec13\"; }\r\n.ri-dashboard-line:before { content: \"\\ec14\"; }\r\n.ri-database-2-fill:before { content: \"\\ec15\"; }\r\n.ri-database-2-line:before { content: \"\\ec16\"; }\r\n.ri-database-fill:before { content: \"\\ec17\"; }\r\n.ri-database-line:before { content: \"\\ec18\"; }\r\n.ri-delete-back-2-fill:before { content: \"\\ec19\"; }\r\n.ri-delete-back-2-line:before { content: \"\\ec1a\"; }\r\n.ri-delete-back-fill:before { content: \"\\ec1b\"; }\r\n.ri-delete-back-line:before { content: \"\\ec1c\"; }\r\n.ri-delete-bin-2-fill:before { content: \"\\ec1d\"; }\r\n.ri-delete-bin-2-line:before { content: \"\\ec1e\"; }\r\n.ri-delete-bin-3-fill:before { content: \"\\ec1f\"; }\r\n.ri-delete-bin-3-line:before { content: \"\\ec20\"; }\r\n.ri-delete-bin-4-fill:before { content: \"\\ec21\"; }\r\n.ri-delete-bin-4-line:before { content: \"\\ec22\"; }\r\n.ri-delete-bin-5-fill:before { content: \"\\ec23\"; }\r\n.ri-delete-bin-5-line:before { content: \"\\ec24\"; }\r\n.ri-delete-bin-6-fill:before { content: \"\\ec25\"; }\r\n.ri-delete-bin-6-line:before { content: \"\\ec26\"; }\r\n.ri-delete-bin-7-fill:before { content: \"\\ec27\"; }\r\n.ri-delete-bin-7-line:before { content: \"\\ec28\"; }\r\n.ri-delete-bin-fill:before { content: \"\\ec29\"; }\r\n.ri-delete-bin-line:before { content: \"\\ec2a\"; }\r\n.ri-delete-column:before { content: \"\\ec2b\"; }\r\n.ri-delete-row:before { content: \"\\ec2c\"; }\r\n.ri-device-fill:before { content: \"\\ec2d\"; }\r\n.ri-device-line:before { content: \"\\ec2e\"; }\r\n.ri-device-recover-fill:before { content: \"\\ec2f\"; }\r\n.ri-device-recover-line:before { content: \"\\ec30\"; }\r\n.ri-dingding-fill:before { content: \"\\ec31\"; }\r\n.ri-dingding-line:before { content: \"\\ec32\"; }\r\n.ri-direction-fill:before { content: \"\\ec33\"; }\r\n.ri-direction-line:before { content: \"\\ec34\"; }\r\n.ri-disc-fill:before { content: \"\\ec35\"; }\r\n.ri-disc-line:before { content: \"\\ec36\"; }\r\n.ri-discord-fill:before { content: \"\\ec37\"; }\r\n.ri-discord-line:before { content: \"\\ec38\"; }\r\n.ri-discuss-fill:before { content: \"\\ec39\"; }\r\n.ri-discuss-line:before { content: \"\\ec3a\"; }\r\n.ri-dislike-fill:before { content: \"\\ec3b\"; }\r\n.ri-dislike-line:before { content: \"\\ec3c\"; }\r\n.ri-disqus-fill:before { content: \"\\ec3d\"; }\r\n.ri-disqus-line:before { content: \"\\ec3e\"; }\r\n.ri-divide-fill:before { content: \"\\ec3f\"; }\r\n.ri-divide-line:before { content: \"\\ec40\"; }\r\n.ri-donut-chart-fill:before { content: \"\\ec41\"; }\r\n.ri-donut-chart-line:before { content: \"\\ec42\"; }\r\n.ri-door-closed-fill:before { content: \"\\ec43\"; }\r\n.ri-door-closed-line:before { content: \"\\ec44\"; }\r\n.ri-door-fill:before { content: \"\\ec45\"; }\r\n.ri-door-line:before { content: \"\\ec46\"; }\r\n.ri-door-lock-box-fill:before { content: \"\\ec47\"; }\r\n.ri-door-lock-box-line:before { content: \"\\ec48\"; }\r\n.ri-door-lock-fill:before { content: \"\\ec49\"; }\r\n.ri-door-lock-line:before { content: \"\\ec4a\"; }\r\n.ri-door-open-fill:before { content: \"\\ec4b\"; }\r\n.ri-door-open-line:before { content: \"\\ec4c\"; }\r\n.ri-dossier-fill:before { content: \"\\ec4d\"; }\r\n.ri-dossier-line:before { content: \"\\ec4e\"; }\r\n.ri-douban-fill:before { content: \"\\ec4f\"; }\r\n.ri-douban-line:before { content: \"\\ec50\"; }\r\n.ri-double-quotes-l:before { content: \"\\ec51\"; }\r\n.ri-double-quotes-r:before { content: \"\\ec52\"; }\r\n.ri-download-2-fill:before { content: \"\\ec53\"; }\r\n.ri-download-2-line:before { content: \"\\ec54\"; }\r\n.ri-download-cloud-2-fill:before { content: \"\\ec55\"; }\r\n.ri-download-cloud-2-line:before { content: \"\\ec56\"; }\r\n.ri-download-cloud-fill:before { content: \"\\ec57\"; }\r\n.ri-download-cloud-line:before { content: \"\\ec58\"; }\r\n.ri-download-fill:before { content: \"\\ec59\"; }\r\n.ri-download-line:before { content: \"\\ec5a\"; }\r\n.ri-draft-fill:before { content: \"\\ec5b\"; }\r\n.ri-draft-line:before { content: \"\\ec5c\"; }\r\n.ri-drag-drop-fill:before { content: \"\\ec5d\"; }\r\n.ri-drag-drop-line:before { content: \"\\ec5e\"; }\r\n.ri-drag-move-2-fill:before { content: \"\\ec5f\"; }\r\n.ri-drag-move-2-line:before { content: \"\\ec60\"; }\r\n.ri-drag-move-fill:before { content: \"\\ec61\"; }\r\n.ri-drag-move-line:before { content: \"\\ec62\"; }\r\n.ri-dribbble-fill:before { content: \"\\ec63\"; }\r\n.ri-dribbble-line:before { content: \"\\ec64\"; }\r\n.ri-drive-fill:before { content: \"\\ec65\"; }\r\n.ri-drive-line:before { content: \"\\ec66\"; }\r\n.ri-drizzle-fill:before { content: \"\\ec67\"; }\r\n.ri-drizzle-line:before { content: \"\\ec68\"; }\r\n.ri-drop-fill:before { content: \"\\ec69\"; }\r\n.ri-drop-line:before { content: \"\\ec6a\"; }\r\n.ri-dropbox-fill:before { content: \"\\ec6b\"; }\r\n.ri-dropbox-line:before { content: \"\\ec6c\"; }\r\n.ri-dual-sim-1-fill:before { content: \"\\ec6d\"; }\r\n.ri-dual-sim-1-line:before { content: \"\\ec6e\"; }\r\n.ri-dual-sim-2-fill:before { content: \"\\ec6f\"; }\r\n.ri-dual-sim-2-line:before { content: \"\\ec70\"; }\r\n.ri-dv-fill:before { content: \"\\ec71\"; }\r\n.ri-dv-line:before { content: \"\\ec72\"; }\r\n.ri-dvd-fill:before { content: \"\\ec73\"; }\r\n.ri-dvd-line:before { content: \"\\ec74\"; }\r\n.ri-e-bike-2-fill:before { content: \"\\ec75\"; }\r\n.ri-e-bike-2-line:before { content: \"\\ec76\"; }\r\n.ri-e-bike-fill:before { content: \"\\ec77\"; }\r\n.ri-e-bike-line:before { content: \"\\ec78\"; }\r\n.ri-earth-fill:before { content: \"\\ec79\"; }\r\n.ri-earth-line:before { content: \"\\ec7a\"; }\r\n.ri-earthquake-fill:before { content: \"\\ec7b\"; }\r\n.ri-earthquake-line:before { content: \"\\ec7c\"; }\r\n.ri-edge-fill:before { content: \"\\ec7d\"; }\r\n.ri-edge-line:before { content: \"\\ec7e\"; }\r\n.ri-edit-2-fill:before { content: \"\\ec7f\"; }\r\n.ri-edit-2-line:before { content: \"\\ec80\"; }\r\n.ri-edit-box-fill:before { content: \"\\ec81\"; }\r\n.ri-edit-box-line:before { content: \"\\ec82\"; }\r\n.ri-edit-circle-fill:before { content: \"\\ec83\"; }\r\n.ri-edit-circle-line:before { content: \"\\ec84\"; }\r\n.ri-edit-fill:before { content: \"\\ec85\"; }\r\n.ri-edit-line:before { content: \"\\ec86\"; }\r\n.ri-eject-fill:before { content: \"\\ec87\"; }\r\n.ri-eject-line:before { content: \"\\ec88\"; }\r\n.ri-emotion-2-fill:before { content: \"\\ec89\"; }\r\n.ri-emotion-2-line:before { content: \"\\ec8a\"; }\r\n.ri-emotion-fill:before { content: \"\\ec8b\"; }\r\n.ri-emotion-happy-fill:before { content: \"\\ec8c\"; }\r\n.ri-emotion-happy-line:before { content: \"\\ec8d\"; }\r\n.ri-emotion-laugh-fill:before { content: \"\\ec8e\"; }\r\n.ri-emotion-laugh-line:before { content: \"\\ec8f\"; }\r\n.ri-emotion-line:before { content: \"\\ec90\"; }\r\n.ri-emotion-normal-fill:before { content: \"\\ec91\"; }\r\n.ri-emotion-normal-line:before { content: \"\\ec92\"; }\r\n.ri-emotion-sad-fill:before { content: \"\\ec93\"; }\r\n.ri-emotion-sad-line:before { content: \"\\ec94\"; }\r\n.ri-emotion-unhappy-fill:before { content: \"\\ec95\"; }\r\n.ri-emotion-unhappy-line:before { content: \"\\ec96\"; }\r\n.ri-empathize-fill:before { content: \"\\ec97\"; }\r\n.ri-empathize-line:before { content: \"\\ec98\"; }\r\n.ri-emphasis-cn:before { content: \"\\ec99\"; }\r\n.ri-emphasis:before { content: \"\\ec9a\"; }\r\n.ri-english-input:before { content: \"\\ec9b\"; }\r\n.ri-equalizer-fill:before { content: \"\\ec9c\"; }\r\n.ri-equalizer-line:before { content: \"\\ec9d\"; }\r\n.ri-eraser-fill:before { content: \"\\ec9e\"; }\r\n.ri-eraser-line:before { content: \"\\ec9f\"; }\r\n.ri-error-warning-fill:before { content: \"\\eca0\"; }\r\n.ri-error-warning-line:before { content: \"\\eca1\"; }\r\n.ri-evernote-fill:before { content: \"\\eca2\"; }\r\n.ri-evernote-line:before { content: \"\\eca3\"; }\r\n.ri-exchange-box-fill:before { content: \"\\eca4\"; }\r\n.ri-exchange-box-line:before { content: \"\\eca5\"; }\r\n.ri-exchange-cny-fill:before { content: \"\\eca6\"; }\r\n.ri-exchange-cny-line:before { content: \"\\eca7\"; }\r\n.ri-exchange-dollar-fill:before { content: \"\\eca8\"; }\r\n.ri-exchange-dollar-line:before { content: \"\\eca9\"; }\r\n.ri-exchange-fill:before { content: \"\\ecaa\"; }\r\n.ri-exchange-funds-fill:before { content: \"\\ecab\"; }\r\n.ri-exchange-funds-line:before { content: \"\\ecac\"; }\r\n.ri-exchange-line:before { content: \"\\ecad\"; }\r\n.ri-external-link-fill:before { content: \"\\ecae\"; }\r\n.ri-external-link-line:before { content: \"\\ecaf\"; }\r\n.ri-eye-2-fill:before { content: \"\\ecb0\"; }\r\n.ri-eye-2-line:before { content: \"\\ecb1\"; }\r\n.ri-eye-close-fill:before { content: \"\\ecb2\"; }\r\n.ri-eye-close-line:before { content: \"\\ecb3\"; }\r\n.ri-eye-fill:before { content: \"\\ecb4\"; }\r\n.ri-eye-line:before { content: \"\\ecb5\"; }\r\n.ri-eye-off-fill:before { content: \"\\ecb6\"; }\r\n.ri-eye-off-line:before { content: \"\\ecb7\"; }\r\n.ri-facebook-box-fill:before { content: \"\\ecb8\"; }\r\n.ri-facebook-box-line:before { content: \"\\ecb9\"; }\r\n.ri-facebook-circle-fill:before { content: \"\\ecba\"; }\r\n.ri-facebook-circle-line:before { content: \"\\ecbb\"; }\r\n.ri-facebook-fill:before { content: \"\\ecbc\"; }\r\n.ri-facebook-line:before { content: \"\\ecbd\"; }\r\n.ri-fahrenheit-fill:before { content: \"\\ecbe\"; }\r\n.ri-fahrenheit-line:before { content: \"\\ecbf\"; }\r\n.ri-feedback-fill:before { content: \"\\ecc0\"; }\r\n.ri-feedback-line:before { content: \"\\ecc1\"; }\r\n.ri-file-2-fill:before { content: \"\\ecc2\"; }\r\n.ri-file-2-line:before { content: \"\\ecc3\"; }\r\n.ri-file-3-fill:before { content: \"\\ecc4\"; }\r\n.ri-file-3-line:before { content: \"\\ecc5\"; }\r\n.ri-file-4-fill:before { content: \"\\ecc6\"; }\r\n.ri-file-4-line:before { content: \"\\ecc7\"; }\r\n.ri-file-add-fill:before { content: \"\\ecc8\"; }\r\n.ri-file-add-line:before { content: \"\\ecc9\"; }\r\n.ri-file-chart-2-fill:before { content: \"\\ecca\"; }\r\n.ri-file-chart-2-line:before { content: \"\\eccb\"; }\r\n.ri-file-chart-fill:before { content: \"\\eccc\"; }\r\n.ri-file-chart-line:before { content: \"\\eccd\"; }\r\n.ri-file-cloud-fill:before { content: \"\\ecce\"; }\r\n.ri-file-cloud-line:before { content: \"\\eccf\"; }\r\n.ri-file-code-fill:before { content: \"\\ecd0\"; }\r\n.ri-file-code-line:before { content: \"\\ecd1\"; }\r\n.ri-file-copy-2-fill:before { content: \"\\ecd2\"; }\r\n.ri-file-copy-2-line:before { content: \"\\ecd3\"; }\r\n.ri-file-copy-fill:before { content: \"\\ecd4\"; }\r\n.ri-file-copy-line:before { content: \"\\ecd5\"; }\r\n.ri-file-damage-fill:before { content: \"\\ecd6\"; }\r\n.ri-file-damage-line:before { content: \"\\ecd7\"; }\r\n.ri-file-download-fill:before { content: \"\\ecd8\"; }\r\n.ri-file-download-line:before { content: \"\\ecd9\"; }\r\n.ri-file-edit-fill:before { content: \"\\ecda\"; }\r\n.ri-file-edit-line:before { content: \"\\ecdb\"; }\r\n.ri-file-excel-2-fill:before { content: \"\\ecdc\"; }\r\n.ri-file-excel-2-line:before { content: \"\\ecdd\"; }\r\n.ri-file-excel-fill:before { content: \"\\ecde\"; }\r\n.ri-file-excel-line:before { content: \"\\ecdf\"; }\r\n.ri-file-fill:before { content: \"\\ece0\"; }\r\n.ri-file-forbid-fill:before { content: \"\\ece1\"; }\r\n.ri-file-forbid-line:before { content: \"\\ece2\"; }\r\n.ri-file-gif-fill:before { content: \"\\ece3\"; }\r\n.ri-file-gif-line:before { content: \"\\ece4\"; }\r\n.ri-file-history-fill:before { content: \"\\ece5\"; }\r\n.ri-file-history-line:before { content: \"\\ece6\"; }\r\n.ri-file-hwp-fill:before { content: \"\\ece7\"; }\r\n.ri-file-hwp-line:before { content: \"\\ece8\"; }\r\n.ri-file-info-fill:before { content: \"\\ece9\"; }\r\n.ri-file-info-line:before { content: \"\\ecea\"; }\r\n.ri-file-line:before { content: \"\\eceb\"; }\r\n.ri-file-list-2-fill:before { content: \"\\ecec\"; }\r\n.ri-file-list-2-line:before { content: \"\\eced\"; }\r\n.ri-file-list-3-fill:before { content: \"\\ecee\"; }\r\n.ri-file-list-3-line:before { content: \"\\ecef\"; }\r\n.ri-file-list-fill:before { content: \"\\ecf0\"; }\r\n.ri-file-list-line:before { content: \"\\ecf1\"; }\r\n.ri-file-lock-fill:before { content: \"\\ecf2\"; }\r\n.ri-file-lock-line:before { content: \"\\ecf3\"; }\r\n.ri-file-mark-fill:before { content: \"\\ecf4\"; }\r\n.ri-file-mark-line:before { content: \"\\ecf5\"; }\r\n.ri-file-music-fill:before { content: \"\\ecf6\"; }\r\n.ri-file-music-line:before { content: \"\\ecf7\"; }\r\n.ri-file-paper-2-fill:before { content: \"\\ecf8\"; }\r\n.ri-file-paper-2-line:before { content: \"\\ecf9\"; }\r\n.ri-file-paper-fill:before { content: \"\\ecfa\"; }\r\n.ri-file-paper-line:before { content: \"\\ecfb\"; }\r\n.ri-file-pdf-fill:before { content: \"\\ecfc\"; }\r\n.ri-file-pdf-line:before { content: \"\\ecfd\"; }\r\n.ri-file-ppt-2-fill:before { content: \"\\ecfe\"; }\r\n.ri-file-ppt-2-line:before { content: \"\\ecff\"; }\r\n.ri-file-ppt-fill:before { content: \"\\ed00\"; }\r\n.ri-file-ppt-line:before { content: \"\\ed01\"; }\r\n.ri-file-reduce-fill:before { content: \"\\ed02\"; }\r\n.ri-file-reduce-line:before { content: \"\\ed03\"; }\r\n.ri-file-search-fill:before { content: \"\\ed04\"; }\r\n.ri-file-search-line:before { content: \"\\ed05\"; }\r\n.ri-file-settings-fill:before { content: \"\\ed06\"; }\r\n.ri-file-settings-line:before { content: \"\\ed07\"; }\r\n.ri-file-shield-2-fill:before { content: \"\\ed08\"; }\r\n.ri-file-shield-2-line:before { content: \"\\ed09\"; }\r\n.ri-file-shield-fill:before { content: \"\\ed0a\"; }\r\n.ri-file-shield-line:before { content: \"\\ed0b\"; }\r\n.ri-file-shred-fill:before { content: \"\\ed0c\"; }\r\n.ri-file-shred-line:before { content: \"\\ed0d\"; }\r\n.ri-file-text-fill:before { content: \"\\ed0e\"; }\r\n.ri-file-text-line:before { content: \"\\ed0f\"; }\r\n.ri-file-transfer-fill:before { content: \"\\ed10\"; }\r\n.ri-file-transfer-line:before { content: \"\\ed11\"; }\r\n.ri-file-unknow-fill:before { content: \"\\ed12\"; }\r\n.ri-file-unknow-line:before { content: \"\\ed13\"; }\r\n.ri-file-upload-fill:before { content: \"\\ed14\"; }\r\n.ri-file-upload-line:before { content: \"\\ed15\"; }\r\n.ri-file-user-fill:before { content: \"\\ed16\"; }\r\n.ri-file-user-line:before { content: \"\\ed17\"; }\r\n.ri-file-warning-fill:before { content: \"\\ed18\"; }\r\n.ri-file-warning-line:before { content: \"\\ed19\"; }\r\n.ri-file-word-2-fill:before { content: \"\\ed1a\"; }\r\n.ri-file-word-2-line:before { content: \"\\ed1b\"; }\r\n.ri-file-word-fill:before { content: \"\\ed1c\"; }\r\n.ri-file-word-line:before { content: \"\\ed1d\"; }\r\n.ri-file-zip-fill:before { content: \"\\ed1e\"; }\r\n.ri-file-zip-line:before { content: \"\\ed1f\"; }\r\n.ri-film-fill:before { content: \"\\ed20\"; }\r\n.ri-film-line:before { content: \"\\ed21\"; }\r\n.ri-filter-2-fill:before { content: \"\\ed22\"; }\r\n.ri-filter-2-line:before { content: \"\\ed23\"; }\r\n.ri-filter-3-fill:before { content: \"\\ed24\"; }\r\n.ri-filter-3-line:before { content: \"\\ed25\"; }\r\n.ri-filter-fill:before { content: \"\\ed26\"; }\r\n.ri-filter-line:before { content: \"\\ed27\"; }\r\n.ri-filter-off-fill:before { content: \"\\ed28\"; }\r\n.ri-filter-off-line:before { content: \"\\ed29\"; }\r\n.ri-find-replace-fill:before { content: \"\\ed2a\"; }\r\n.ri-find-replace-line:before { content: \"\\ed2b\"; }\r\n.ri-finder-fill:before { content: \"\\ed2c\"; }\r\n.ri-finder-line:before { content: \"\\ed2d\"; }\r\n.ri-fingerprint-2-fill:before { content: \"\\ed2e\"; }\r\n.ri-fingerprint-2-line:before { content: \"\\ed2f\"; }\r\n.ri-fingerprint-fill:before { content: \"\\ed30\"; }\r\n.ri-fingerprint-line:before { content: \"\\ed31\"; }\r\n.ri-fire-fill:before { content: \"\\ed32\"; }\r\n.ri-fire-line:before { content: \"\\ed33\"; }\r\n.ri-firefox-fill:before { content: \"\\ed34\"; }\r\n.ri-firefox-line:before { content: \"\\ed35\"; }\r\n.ri-first-aid-kit-fill:before { content: \"\\ed36\"; }\r\n.ri-first-aid-kit-line:before { content: \"\\ed37\"; }\r\n.ri-flag-2-fill:before { content: \"\\ed38\"; }\r\n.ri-flag-2-line:before { content: \"\\ed39\"; }\r\n.ri-flag-fill:before { content: \"\\ed3a\"; }\r\n.ri-flag-line:before { content: \"\\ed3b\"; }\r\n.ri-flashlight-fill:before { content: \"\\ed3c\"; }\r\n.ri-flashlight-line:before { content: \"\\ed3d\"; }\r\n.ri-flask-fill:before { content: \"\\ed3e\"; }\r\n.ri-flask-line:before { content: \"\\ed3f\"; }\r\n.ri-flight-land-fill:before { content: \"\\ed40\"; }\r\n.ri-flight-land-line:before { content: \"\\ed41\"; }\r\n.ri-flight-takeoff-fill:before { content: \"\\ed42\"; }\r\n.ri-flight-takeoff-line:before { content: \"\\ed43\"; }\r\n.ri-flood-fill:before { content: \"\\ed44\"; }\r\n.ri-flood-line:before { content: \"\\ed45\"; }\r\n.ri-flow-chart:before { content: \"\\ed46\"; }\r\n.ri-flutter-fill:before { content: \"\\ed47\"; }\r\n.ri-flutter-line:before { content: \"\\ed48\"; }\r\n.ri-focus-2-fill:before { content: \"\\ed49\"; }\r\n.ri-focus-2-line:before { content: \"\\ed4a\"; }\r\n.ri-focus-3-fill:before { content: \"\\ed4b\"; }\r\n.ri-focus-3-line:before { content: \"\\ed4c\"; }\r\n.ri-focus-fill:before { content: \"\\ed4d\"; }\r\n.ri-focus-line:before { content: \"\\ed4e\"; }\r\n.ri-foggy-fill:before { content: \"\\ed4f\"; }\r\n.ri-foggy-line:before { content: \"\\ed50\"; }\r\n.ri-folder-2-fill:before { content: \"\\ed51\"; }\r\n.ri-folder-2-line:before { content: \"\\ed52\"; }\r\n.ri-folder-3-fill:before { content: \"\\ed53\"; }\r\n.ri-folder-3-line:before { content: \"\\ed54\"; }\r\n.ri-folder-4-fill:before { content: \"\\ed55\"; }\r\n.ri-folder-4-line:before { content: \"\\ed56\"; }\r\n.ri-folder-5-fill:before { content: \"\\ed57\"; }\r\n.ri-folder-5-line:before { content: \"\\ed58\"; }\r\n.ri-folder-add-fill:before { content: \"\\ed59\"; }\r\n.ri-folder-add-line:before { content: \"\\ed5a\"; }\r\n.ri-folder-chart-2-fill:before { content: \"\\ed5b\"; }\r\n.ri-folder-chart-2-line:before { content: \"\\ed5c\"; }\r\n.ri-folder-chart-fill:before { content: \"\\ed5d\"; }\r\n.ri-folder-chart-line:before { content: \"\\ed5e\"; }\r\n.ri-folder-download-fill:before { content: \"\\ed5f\"; }\r\n.ri-folder-download-line:before { content: \"\\ed60\"; }\r\n.ri-folder-fill:before { content: \"\\ed61\"; }\r\n.ri-folder-forbid-fill:before { content: \"\\ed62\"; }\r\n.ri-folder-forbid-line:before { content: \"\\ed63\"; }\r\n.ri-folder-history-fill:before { content: \"\\ed64\"; }\r\n.ri-folder-history-line:before { content: \"\\ed65\"; }\r\n.ri-folder-info-fill:before { content: \"\\ed66\"; }\r\n.ri-folder-info-line:before { content: \"\\ed67\"; }\r\n.ri-folder-keyhole-fill:before { content: \"\\ed68\"; }\r\n.ri-folder-keyhole-line:before { content: \"\\ed69\"; }\r\n.ri-folder-line:before { content: \"\\ed6a\"; }\r\n.ri-folder-lock-fill:before { content: \"\\ed6b\"; }\r\n.ri-folder-lock-line:before { content: \"\\ed6c\"; }\r\n.ri-folder-music-fill:before { content: \"\\ed6d\"; }\r\n.ri-folder-music-line:before { content: \"\\ed6e\"; }\r\n.ri-folder-open-fill:before { content: \"\\ed6f\"; }\r\n.ri-folder-open-line:before { content: \"\\ed70\"; }\r\n.ri-folder-received-fill:before { content: \"\\ed71\"; }\r\n.ri-folder-received-line:before { content: \"\\ed72\"; }\r\n.ri-folder-reduce-fill:before { content: \"\\ed73\"; }\r\n.ri-folder-reduce-line:before { content: \"\\ed74\"; }\r\n.ri-folder-settings-fill:before { content: \"\\ed75\"; }\r\n.ri-folder-settings-line:before { content: \"\\ed76\"; }\r\n.ri-folder-shared-fill:before { content: \"\\ed77\"; }\r\n.ri-folder-shared-line:before { content: \"\\ed78\"; }\r\n.ri-folder-shield-2-fill:before { content: \"\\ed79\"; }\r\n.ri-folder-shield-2-line:before { content: \"\\ed7a\"; }\r\n.ri-folder-shield-fill:before { content: \"\\ed7b\"; }\r\n.ri-folder-shield-line:before { content: \"\\ed7c\"; }\r\n.ri-folder-transfer-fill:before { content: \"\\ed7d\"; }\r\n.ri-folder-transfer-line:before { content: \"\\ed7e\"; }\r\n.ri-folder-unknow-fill:before { content: \"\\ed7f\"; }\r\n.ri-folder-unknow-line:before { content: \"\\ed80\"; }\r\n.ri-folder-upload-fill:before { content: \"\\ed81\"; }\r\n.ri-folder-upload-line:before { content: \"\\ed82\"; }\r\n.ri-folder-user-fill:before { content: \"\\ed83\"; }\r\n.ri-folder-user-line:before { content: \"\\ed84\"; }\r\n.ri-folder-warning-fill:before { content: \"\\ed85\"; }\r\n.ri-folder-warning-line:before { content: \"\\ed86\"; }\r\n.ri-folder-zip-fill:before { content: \"\\ed87\"; }\r\n.ri-folder-zip-line:before { content: \"\\ed88\"; }\r\n.ri-folders-fill:before { content: \"\\ed89\"; }\r\n.ri-folders-line:before { content: \"\\ed8a\"; }\r\n.ri-font-color:before { content: \"\\ed8b\"; }\r\n.ri-font-size-2:before { content: \"\\ed8c\"; }\r\n.ri-font-size:before { content: \"\\ed8d\"; }\r\n.ri-football-fill:before { content: \"\\ed8e\"; }\r\n.ri-football-line:before { content: \"\\ed8f\"; }\r\n.ri-footprint-fill:before { content: \"\\ed90\"; }\r\n.ri-footprint-line:before { content: \"\\ed91\"; }\r\n.ri-forbid-2-fill:before { content: \"\\ed92\"; }\r\n.ri-forbid-2-line:before { content: \"\\ed93\"; }\r\n.ri-forbid-fill:before { content: \"\\ed94\"; }\r\n.ri-forbid-line:before { content: \"\\ed95\"; }\r\n.ri-format-clear:before { content: \"\\ed96\"; }\r\n.ri-fridge-fill:before { content: \"\\ed97\"; }\r\n.ri-fridge-line:before { content: \"\\ed98\"; }\r\n.ri-fullscreen-exit-fill:before { content: \"\\ed99\"; }\r\n.ri-fullscreen-exit-line:before { content: \"\\ed9a\"; }\r\n.ri-fullscreen-fill:before { content: \"\\ed9b\"; }\r\n.ri-fullscreen-line:before { content: \"\\ed9c\"; }\r\n.ri-function-fill:before { content: \"\\ed9d\"; }\r\n.ri-function-line:before { content: \"\\ed9e\"; }\r\n.ri-functions:before { content: \"\\ed9f\"; }\r\n.ri-funds-box-fill:before { content: \"\\eda0\"; }\r\n.ri-funds-box-line:before { content: \"\\eda1\"; }\r\n.ri-funds-fill:before { content: \"\\eda2\"; }\r\n.ri-funds-line:before { content: \"\\eda3\"; }\r\n.ri-gallery-fill:before { content: \"\\eda4\"; }\r\n.ri-gallery-line:before { content: \"\\eda5\"; }\r\n.ri-gallery-upload-fill:before { content: \"\\eda6\"; }\r\n.ri-gallery-upload-line:before { content: \"\\eda7\"; }\r\n.ri-game-fill:before { content: \"\\eda8\"; }\r\n.ri-game-line:before { content: \"\\eda9\"; }\r\n.ri-gamepad-fill:before { content: \"\\edaa\"; }\r\n.ri-gamepad-line:before { content: \"\\edab\"; }\r\n.ri-gas-station-fill:before { content: \"\\edac\"; }\r\n.ri-gas-station-line:before { content: \"\\edad\"; }\r\n.ri-gatsby-fill:before { content: \"\\edae\"; }\r\n.ri-gatsby-line:before { content: \"\\edaf\"; }\r\n.ri-genderless-fill:before { content: \"\\edb0\"; }\r\n.ri-genderless-line:before { content: \"\\edb1\"; }\r\n.ri-ghost-2-fill:before { content: \"\\edb2\"; }\r\n.ri-ghost-2-line:before { content: \"\\edb3\"; }\r\n.ri-ghost-fill:before { content: \"\\edb4\"; }\r\n.ri-ghost-line:before { content: \"\\edb5\"; }\r\n.ri-ghost-smile-fill:before { content: \"\\edb6\"; }\r\n.ri-ghost-smile-line:before { content: \"\\edb7\"; }\r\n.ri-gift-2-fill:before { content: \"\\edb8\"; }\r\n.ri-gift-2-line:before { content: \"\\edb9\"; }\r\n.ri-gift-fill:before { content: \"\\edba\"; }\r\n.ri-gift-line:before { content: \"\\edbb\"; }\r\n.ri-git-branch-fill:before { content: \"\\edbc\"; }\r\n.ri-git-branch-line:before { content: \"\\edbd\"; }\r\n.ri-git-commit-fill:before { content: \"\\edbe\"; }\r\n.ri-git-commit-line:before { content: \"\\edbf\"; }\r\n.ri-git-merge-fill:before { content: \"\\edc0\"; }\r\n.ri-git-merge-line:before { content: \"\\edc1\"; }\r\n.ri-git-pull-request-fill:before { content: \"\\edc2\"; }\r\n.ri-git-pull-request-line:before { content: \"\\edc3\"; }\r\n.ri-git-repository-commits-fill:before { content: \"\\edc4\"; }\r\n.ri-git-repository-commits-line:before { content: \"\\edc5\"; }\r\n.ri-git-repository-fill:before { content: \"\\edc6\"; }\r\n.ri-git-repository-line:before { content: \"\\edc7\"; }\r\n.ri-git-repository-private-fill:before { content: \"\\edc8\"; }\r\n.ri-git-repository-private-line:before { content: \"\\edc9\"; }\r\n.ri-github-fill:before { content: \"\\edca\"; }\r\n.ri-github-line:before { content: \"\\edcb\"; }\r\n.ri-gitlab-fill:before { content: \"\\edcc\"; }\r\n.ri-gitlab-line:before { content: \"\\edcd\"; }\r\n.ri-global-fill:before { content: \"\\edce\"; }\r\n.ri-global-line:before { content: \"\\edcf\"; }\r\n.ri-globe-fill:before { content: \"\\edd0\"; }\r\n.ri-globe-line:before { content: \"\\edd1\"; }\r\n.ri-goblet-fill:before { content: \"\\edd2\"; }\r\n.ri-goblet-line:before { content: \"\\edd3\"; }\r\n.ri-google-fill:before { content: \"\\edd4\"; }\r\n.ri-google-line:before { content: \"\\edd5\"; }\r\n.ri-google-play-fill:before { content: \"\\edd6\"; }\r\n.ri-google-play-line:before { content: \"\\edd7\"; }\r\n.ri-government-fill:before { content: \"\\edd8\"; }\r\n.ri-government-line:before { content: \"\\edd9\"; }\r\n.ri-gps-fill:before { content: \"\\edda\"; }\r\n.ri-gps-line:before { content: \"\\eddb\"; }\r\n.ri-gradienter-fill:before { content: \"\\eddc\"; }\r\n.ri-gradienter-line:before { content: \"\\eddd\"; }\r\n.ri-grid-fill:before { content: \"\\edde\"; }\r\n.ri-grid-line:before { content: \"\\eddf\"; }\r\n.ri-group-2-fill:before { content: \"\\ede0\"; }\r\n.ri-group-2-line:before { content: \"\\ede1\"; }\r\n.ri-group-fill:before { content: \"\\ede2\"; }\r\n.ri-group-line:before { content: \"\\ede3\"; }\r\n.ri-guide-fill:before { content: \"\\ede4\"; }\r\n.ri-guide-line:before { content: \"\\ede5\"; }\r\n.ri-h-1:before { content: \"\\ede6\"; }\r\n.ri-h-2:before { content: \"\\ede7\"; }\r\n.ri-h-3:before { content: \"\\ede8\"; }\r\n.ri-h-4:before { content: \"\\ede9\"; }\r\n.ri-h-5:before { content: \"\\edea\"; }\r\n.ri-h-6:before { content: \"\\edeb\"; }\r\n.ri-hail-fill:before { content: \"\\edec\"; }\r\n.ri-hail-line:before { content: \"\\eded\"; }\r\n.ri-hammer-fill:before { content: \"\\edee\"; }\r\n.ri-hammer-line:before { content: \"\\edef\"; }\r\n.ri-hand-coin-fill:before { content: \"\\edf0\"; }\r\n.ri-hand-coin-line:before { content: \"\\edf1\"; }\r\n.ri-hand-heart-fill:before { content: \"\\edf2\"; }\r\n.ri-hand-heart-line:before { content: \"\\edf3\"; }\r\n.ri-hand-sanitizer-fill:before { content: \"\\edf4\"; }\r\n.ri-hand-sanitizer-line:before { content: \"\\edf5\"; }\r\n.ri-handbag-fill:before { content: \"\\edf6\"; }\r\n.ri-handbag-line:before { content: \"\\edf7\"; }\r\n.ri-hard-drive-2-fill:before { content: \"\\edf8\"; }\r\n.ri-hard-drive-2-line:before { content: \"\\edf9\"; }\r\n.ri-hard-drive-fill:before { content: \"\\edfa\"; }\r\n.ri-hard-drive-line:before { content: \"\\edfb\"; }\r\n.ri-hashtag:before { content: \"\\edfc\"; }\r\n.ri-haze-2-fill:before { content: \"\\edfd\"; }\r\n.ri-haze-2-line:before { content: \"\\edfe\"; }\r\n.ri-haze-fill:before { content: \"\\edff\"; }\r\n.ri-haze-line:before { content: \"\\ee00\"; }\r\n.ri-hd-fill:before { content: \"\\ee01\"; }\r\n.ri-hd-line:before { content: \"\\ee02\"; }\r\n.ri-heading:before { content: \"\\ee03\"; }\r\n.ri-headphone-fill:before { content: \"\\ee04\"; }\r\n.ri-headphone-line:before { content: \"\\ee05\"; }\r\n.ri-health-book-fill:before { content: \"\\ee06\"; }\r\n.ri-health-book-line:before { content: \"\\ee07\"; }\r\n.ri-heart-2-fill:before { content: \"\\ee08\"; }\r\n.ri-heart-2-line:before { content: \"\\ee09\"; }\r\n.ri-heart-3-fill:before { content: \"\\ee0a\"; }\r\n.ri-heart-3-line:before { content: \"\\ee0b\"; }\r\n.ri-heart-add-fill:before { content: \"\\ee0c\"; }\r\n.ri-heart-add-line:before { content: \"\\ee0d\"; }\r\n.ri-heart-fill:before { content: \"\\ee0e\"; }\r\n.ri-heart-line:before { content: \"\\ee0f\"; }\r\n.ri-heart-pulse-fill:before { content: \"\\ee10\"; }\r\n.ri-heart-pulse-line:before { content: \"\\ee11\"; }\r\n.ri-hearts-fill:before { content: \"\\ee12\"; }\r\n.ri-hearts-line:before { content: \"\\ee13\"; }\r\n.ri-heavy-showers-fill:before { content: \"\\ee14\"; }\r\n.ri-heavy-showers-line:before { content: \"\\ee15\"; }\r\n.ri-history-fill:before { content: \"\\ee16\"; }\r\n.ri-history-line:before { content: \"\\ee17\"; }\r\n.ri-home-2-fill:before { content: \"\\ee18\"; }\r\n.ri-home-2-line:before { content: \"\\ee19\"; }\r\n.ri-home-3-fill:before { content: \"\\ee1a\"; }\r\n.ri-home-3-line:before { content: \"\\ee1b\"; }\r\n.ri-home-4-fill:before { content: \"\\ee1c\"; }\r\n.ri-home-4-line:before { content: \"\\ee1d\"; }\r\n.ri-home-5-fill:before { content: \"\\ee1e\"; }\r\n.ri-home-5-line:before { content: \"\\ee1f\"; }\r\n.ri-home-6-fill:before { content: \"\\ee20\"; }\r\n.ri-home-6-line:before { content: \"\\ee21\"; }\r\n.ri-home-7-fill:before { content: \"\\ee22\"; }\r\n.ri-home-7-line:before { content: \"\\ee23\"; }\r\n.ri-home-8-fill:before { content: \"\\ee24\"; }\r\n.ri-home-8-line:before { content: \"\\ee25\"; }\r\n.ri-home-fill:before { content: \"\\ee26\"; }\r\n.ri-home-gear-fill:before { content: \"\\ee27\"; }\r\n.ri-home-gear-line:before { content: \"\\ee28\"; }\r\n.ri-home-heart-fill:before { content: \"\\ee29\"; }\r\n.ri-home-heart-line:before { content: \"\\ee2a\"; }\r\n.ri-home-line:before { content: \"\\ee2b\"; }\r\n.ri-home-smile-2-fill:before { content: \"\\ee2c\"; }\r\n.ri-home-smile-2-line:before { content: \"\\ee2d\"; }\r\n.ri-home-smile-fill:before { content: \"\\ee2e\"; }\r\n.ri-home-smile-line:before { content: \"\\ee2f\"; }\r\n.ri-home-wifi-fill:before { content: \"\\ee30\"; }\r\n.ri-home-wifi-line:before { content: \"\\ee31\"; }\r\n.ri-honor-of-kings-fill:before { content: \"\\ee32\"; }\r\n.ri-honor-of-kings-line:before { content: \"\\ee33\"; }\r\n.ri-honour-fill:before { content: \"\\ee34\"; }\r\n.ri-honour-line:before { content: \"\\ee35\"; }\r\n.ri-hospital-fill:before { content: \"\\ee36\"; }\r\n.ri-hospital-line:before { content: \"\\ee37\"; }\r\n.ri-hotel-bed-fill:before { content: \"\\ee38\"; }\r\n.ri-hotel-bed-line:before { content: \"\\ee39\"; }\r\n.ri-hotel-fill:before { content: \"\\ee3a\"; }\r\n.ri-hotel-line:before { content: \"\\ee3b\"; }\r\n.ri-hotspot-fill:before { content: \"\\ee3c\"; }\r\n.ri-hotspot-line:before { content: \"\\ee3d\"; }\r\n.ri-hq-fill:before { content: \"\\ee3e\"; }\r\n.ri-hq-line:before { content: \"\\ee3f\"; }\r\n.ri-html5-fill:before { content: \"\\ee40\"; }\r\n.ri-html5-line:before { content: \"\\ee41\"; }\r\n.ri-ie-fill:before { content: \"\\ee42\"; }\r\n.ri-ie-line:before { content: \"\\ee43\"; }\r\n.ri-image-2-fill:before { content: \"\\ee44\"; }\r\n.ri-image-2-line:before { content: \"\\ee45\"; }\r\n.ri-image-add-fill:before { content: \"\\ee46\"; }\r\n.ri-image-add-line:before { content: \"\\ee47\"; }\r\n.ri-image-edit-fill:before { content: \"\\ee48\"; }\r\n.ri-image-edit-line:before { content: \"\\ee49\"; }\r\n.ri-image-fill:before { content: \"\\ee4a\"; }\r\n.ri-image-line:before { content: \"\\ee4b\"; }\r\n.ri-inbox-archive-fill:before { content: \"\\ee4c\"; }\r\n.ri-inbox-archive-line:before { content: \"\\ee4d\"; }\r\n.ri-inbox-fill:before { content: \"\\ee4e\"; }\r\n.ri-inbox-line:before { content: \"\\ee4f\"; }\r\n.ri-inbox-unarchive-fill:before { content: \"\\ee50\"; }\r\n.ri-inbox-unarchive-line:before { content: \"\\ee51\"; }\r\n.ri-increase-decrease-fill:before { content: \"\\ee52\"; }\r\n.ri-increase-decrease-line:before { content: \"\\ee53\"; }\r\n.ri-indent-decrease:before { content: \"\\ee54\"; }\r\n.ri-indent-increase:before { content: \"\\ee55\"; }\r\n.ri-indeterminate-circle-fill:before { content: \"\\ee56\"; }\r\n.ri-indeterminate-circle-line:before { content: \"\\ee57\"; }\r\n.ri-information-fill:before { content: \"\\ee58\"; }\r\n.ri-information-line:before { content: \"\\ee59\"; }\r\n.ri-infrared-thermometer-fill:before { content: \"\\ee5a\"; }\r\n.ri-infrared-thermometer-line:before { content: \"\\ee5b\"; }\r\n.ri-ink-bottle-fill:before { content: \"\\ee5c\"; }\r\n.ri-ink-bottle-line:before { content: \"\\ee5d\"; }\r\n.ri-input-cursor-move:before { content: \"\\ee5e\"; }\r\n.ri-input-method-fill:before { content: \"\\ee5f\"; }\r\n.ri-input-method-line:before { content: \"\\ee60\"; }\r\n.ri-insert-column-left:before { content: \"\\ee61\"; }\r\n.ri-insert-column-right:before { content: \"\\ee62\"; }\r\n.ri-insert-row-bottom:before { content: \"\\ee63\"; }\r\n.ri-insert-row-top:before { content: \"\\ee64\"; }\r\n.ri-instagram-fill:before { content: \"\\ee65\"; }\r\n.ri-instagram-line:before { content: \"\\ee66\"; }\r\n.ri-install-fill:before { content: \"\\ee67\"; }\r\n.ri-install-line:before { content: \"\\ee68\"; }\r\n.ri-invision-fill:before { content: \"\\ee69\"; }\r\n.ri-invision-line:before { content: \"\\ee6a\"; }\r\n.ri-italic:before { content: \"\\ee6b\"; }\r\n.ri-kakao-talk-fill:before { content: \"\\ee6c\"; }\r\n.ri-kakao-talk-line:before { content: \"\\ee6d\"; }\r\n.ri-key-2-fill:before { content: \"\\ee6e\"; }\r\n.ri-key-2-line:before { content: \"\\ee6f\"; }\r\n.ri-key-fill:before { content: \"\\ee70\"; }\r\n.ri-key-line:before { content: \"\\ee71\"; }\r\n.ri-keyboard-box-fill:before { content: \"\\ee72\"; }\r\n.ri-keyboard-box-line:before { content: \"\\ee73\"; }\r\n.ri-keyboard-fill:before { content: \"\\ee74\"; }\r\n.ri-keyboard-line:before { content: \"\\ee75\"; }\r\n.ri-keynote-fill:before { content: \"\\ee76\"; }\r\n.ri-keynote-line:before { content: \"\\ee77\"; }\r\n.ri-knife-blood-fill:before { content: \"\\ee78\"; }\r\n.ri-knife-blood-line:before { content: \"\\ee79\"; }\r\n.ri-knife-fill:before { content: \"\\ee7a\"; }\r\n.ri-knife-line:before { content: \"\\ee7b\"; }\r\n.ri-landscape-fill:before { content: \"\\ee7c\"; }\r\n.ri-landscape-line:before { content: \"\\ee7d\"; }\r\n.ri-layout-2-fill:before { content: \"\\ee7e\"; }\r\n.ri-layout-2-line:before { content: \"\\ee7f\"; }\r\n.ri-layout-3-fill:before { content: \"\\ee80\"; }\r\n.ri-layout-3-line:before { content: \"\\ee81\"; }\r\n.ri-layout-4-fill:before { content: \"\\ee82\"; }\r\n.ri-layout-4-line:before { content: \"\\ee83\"; }\r\n.ri-layout-5-fill:before { content: \"\\ee84\"; }\r\n.ri-layout-5-line:before { content: \"\\ee85\"; }\r\n.ri-layout-6-fill:before { content: \"\\ee86\"; }\r\n.ri-layout-6-line:before { content: \"\\ee87\"; }\r\n.ri-layout-bottom-2-fill:before { content: \"\\ee88\"; }\r\n.ri-layout-bottom-2-line:before { content: \"\\ee89\"; }\r\n.ri-layout-bottom-fill:before { content: \"\\ee8a\"; }\r\n.ri-layout-bottom-line:before { content: \"\\ee8b\"; }\r\n.ri-layout-column-fill:before { content: \"\\ee8c\"; }\r\n.ri-layout-column-line:before { content: \"\\ee8d\"; }\r\n.ri-layout-fill:before { content: \"\\ee8e\"; }\r\n.ri-layout-grid-fill:before { content: \"\\ee8f\"; }\r\n.ri-layout-grid-line:before { content: \"\\ee90\"; }\r\n.ri-layout-left-2-fill:before { content: \"\\ee91\"; }\r\n.ri-layout-left-2-line:before { content: \"\\ee92\"; }\r\n.ri-layout-left-fill:before { content: \"\\ee93\"; }\r\n.ri-layout-left-line:before { content: \"\\ee94\"; }\r\n.ri-layout-line:before { content: \"\\ee95\"; }\r\n.ri-layout-masonry-fill:before { content: \"\\ee96\"; }\r\n.ri-layout-masonry-line:before { content: \"\\ee97\"; }\r\n.ri-layout-right-2-fill:before { content: \"\\ee98\"; }\r\n.ri-layout-right-2-line:before { content: \"\\ee99\"; }\r\n.ri-layout-right-fill:before { content: \"\\ee9a\"; }\r\n.ri-layout-right-line:before { content: \"\\ee9b\"; }\r\n.ri-layout-row-fill:before { content: \"\\ee9c\"; }\r\n.ri-layout-row-line:before { content: \"\\ee9d\"; }\r\n.ri-layout-top-2-fill:before { content: \"\\ee9e\"; }\r\n.ri-layout-top-2-line:before { content: \"\\ee9f\"; }\r\n.ri-layout-top-fill:before { content: \"\\eea0\"; }\r\n.ri-layout-top-line:before { content: \"\\eea1\"; }\r\n.ri-leaf-fill:before { content: \"\\eea2\"; }\r\n.ri-leaf-line:before { content: \"\\eea3\"; }\r\n.ri-lifebuoy-fill:before { content: \"\\eea4\"; }\r\n.ri-lifebuoy-line:before { content: \"\\eea5\"; }\r\n.ri-lightbulb-fill:before { content: \"\\eea6\"; }\r\n.ri-lightbulb-flash-fill:before { content: \"\\eea7\"; }\r\n.ri-lightbulb-flash-line:before { content: \"\\eea8\"; }\r\n.ri-lightbulb-line:before { content: \"\\eea9\"; }\r\n.ri-line-chart-fill:before { content: \"\\eeaa\"; }\r\n.ri-line-chart-line:before { content: \"\\eeab\"; }\r\n.ri-line-fill:before { content: \"\\eeac\"; }\r\n.ri-line-height:before { content: \"\\eead\"; }\r\n.ri-line-line:before { content: \"\\eeae\"; }\r\n.ri-link-m:before { content: \"\\eeaf\"; }\r\n.ri-link-unlink-m:before { content: \"\\eeb0\"; }\r\n.ri-link-unlink:before { content: \"\\eeb1\"; }\r\n.ri-link:before { content: \"\\eeb2\"; }\r\n.ri-linkedin-box-fill:before { content: \"\\eeb3\"; }\r\n.ri-linkedin-box-line:before { content: \"\\eeb4\"; }\r\n.ri-linkedin-fill:before { content: \"\\eeb5\"; }\r\n.ri-linkedin-line:before { content: \"\\eeb6\"; }\r\n.ri-links-fill:before { content: \"\\eeb7\"; }\r\n.ri-links-line:before { content: \"\\eeb8\"; }\r\n.ri-list-check-2:before { content: \"\\eeb9\"; }\r\n.ri-list-check:before { content: \"\\eeba\"; }\r\n.ri-list-ordered:before { content: \"\\eebb\"; }\r\n.ri-list-settings-fill:before { content: \"\\eebc\"; }\r\n.ri-list-settings-line:before { content: \"\\eebd\"; }\r\n.ri-list-unordered:before { content: \"\\eebe\"; }\r\n.ri-live-fill:before { content: \"\\eebf\"; }\r\n.ri-live-line:before { content: \"\\eec0\"; }\r\n.ri-loader-2-fill:before { content: \"\\eec1\"; }\r\n.ri-loader-2-line:before { content: \"\\eec2\"; }\r\n.ri-loader-3-fill:before { content: \"\\eec3\"; }\r\n.ri-loader-3-line:before { content: \"\\eec4\"; }\r\n.ri-loader-4-fill:before { content: \"\\eec5\"; }\r\n.ri-loader-4-line:before { content: \"\\eec6\"; }\r\n.ri-loader-5-fill:before { content: \"\\eec7\"; }\r\n.ri-loader-5-line:before { content: \"\\eec8\"; }\r\n.ri-loader-fill:before { content: \"\\eec9\"; }\r\n.ri-loader-line:before { content: \"\\eeca\"; }\r\n.ri-lock-2-fill:before { content: \"\\eecb\"; }\r\n.ri-lock-2-line:before { content: \"\\eecc\"; }\r\n.ri-lock-fill:before { content: \"\\eecd\"; }\r\n.ri-lock-line:before { content: \"\\eece\"; }\r\n.ri-lock-password-fill:before { content: \"\\eecf\"; }\r\n.ri-lock-password-line:before { content: \"\\eed0\"; }\r\n.ri-lock-unlock-fill:before { content: \"\\eed1\"; }\r\n.ri-lock-unlock-line:before { content: \"\\eed2\"; }\r\n.ri-login-box-fill:before { content: \"\\eed3\"; }\r\n.ri-login-box-line:before { content: \"\\eed4\"; }\r\n.ri-login-circle-fill:before { content: \"\\eed5\"; }\r\n.ri-login-circle-line:before { content: \"\\eed6\"; }\r\n.ri-logout-box-fill:before { content: \"\\eed7\"; }\r\n.ri-logout-box-line:before { content: \"\\eed8\"; }\r\n.ri-logout-box-r-fill:before { content: \"\\eed9\"; }\r\n.ri-logout-box-r-line:before { content: \"\\eeda\"; }\r\n.ri-logout-circle-fill:before { content: \"\\eedb\"; }\r\n.ri-logout-circle-line:before { content: \"\\eedc\"; }\r\n.ri-logout-circle-r-fill:before { content: \"\\eedd\"; }\r\n.ri-logout-circle-r-line:before { content: \"\\eede\"; }\r\n.ri-luggage-cart-fill:before { content: \"\\eedf\"; }\r\n.ri-luggage-cart-line:before { content: \"\\eee0\"; }\r\n.ri-luggage-deposit-fill:before { content: \"\\eee1\"; }\r\n.ri-luggage-deposit-line:before { content: \"\\eee2\"; }\r\n.ri-lungs-fill:before { content: \"\\eee3\"; }\r\n.ri-lungs-line:before { content: \"\\eee4\"; }\r\n.ri-mac-fill:before { content: \"\\eee5\"; }\r\n.ri-mac-line:before { content: \"\\eee6\"; }\r\n.ri-macbook-fill:before { content: \"\\eee7\"; }\r\n.ri-macbook-line:before { content: \"\\eee8\"; }\r\n.ri-magic-fill:before { content: \"\\eee9\"; }\r\n.ri-magic-line:before { content: \"\\eeea\"; }\r\n.ri-mail-add-fill:before { content: \"\\eeeb\"; }\r\n.ri-mail-add-line:before { content: \"\\eeec\"; }\r\n.ri-mail-check-fill:before { content: \"\\eeed\"; }\r\n.ri-mail-check-line:before { content: \"\\eeee\"; }\r\n.ri-mail-close-fill:before { content: \"\\eeef\"; }\r\n.ri-mail-close-line:before { content: \"\\eef0\"; }\r\n.ri-mail-download-fill:before { content: \"\\eef1\"; }\r\n.ri-mail-download-line:before { content: \"\\eef2\"; }\r\n.ri-mail-fill:before { content: \"\\eef3\"; }\r\n.ri-mail-forbid-fill:before { content: \"\\eef4\"; }\r\n.ri-mail-forbid-line:before { content: \"\\eef5\"; }\r\n.ri-mail-line:before { content: \"\\eef6\"; }\r\n.ri-mail-lock-fill:before { content: \"\\eef7\"; }\r\n.ri-mail-lock-line:before { content: \"\\eef8\"; }\r\n.ri-mail-open-fill:before { content: \"\\eef9\"; }\r\n.ri-mail-open-line:before { content: \"\\eefa\"; }\r\n.ri-mail-send-fill:before { content: \"\\eefb\"; }\r\n.ri-mail-send-line:before { content: \"\\eefc\"; }\r\n.ri-mail-settings-fill:before { content: \"\\eefd\"; }\r\n.ri-mail-settings-line:before { content: \"\\eefe\"; }\r\n.ri-mail-star-fill:before { content: \"\\eeff\"; }\r\n.ri-mail-star-line:before { content: \"\\ef00\"; }\r\n.ri-mail-unread-fill:before { content: \"\\ef01\"; }\r\n.ri-mail-unread-line:before { content: \"\\ef02\"; }\r\n.ri-mail-volume-fill:before { content: \"\\ef03\"; }\r\n.ri-mail-volume-line:before { content: \"\\ef04\"; }\r\n.ri-map-2-fill:before { content: \"\\ef05\"; }\r\n.ri-map-2-line:before { content: \"\\ef06\"; }\r\n.ri-map-fill:before { content: \"\\ef07\"; }\r\n.ri-map-line:before { content: \"\\ef08\"; }\r\n.ri-map-pin-2-fill:before { content: \"\\ef09\"; }\r\n.ri-map-pin-2-line:before { content: \"\\ef0a\"; }\r\n.ri-map-pin-3-fill:before { content: \"\\ef0b\"; }\r\n.ri-map-pin-3-line:before { content: \"\\ef0c\"; }\r\n.ri-map-pin-4-fill:before { content: \"\\ef0d\"; }\r\n.ri-map-pin-4-line:before { content: \"\\ef0e\"; }\r\n.ri-map-pin-5-fill:before { content: \"\\ef0f\"; }\r\n.ri-map-pin-5-line:before { content: \"\\ef10\"; }\r\n.ri-map-pin-add-fill:before { content: \"\\ef11\"; }\r\n.ri-map-pin-add-line:before { content: \"\\ef12\"; }\r\n.ri-map-pin-fill:before { content: \"\\ef13\"; }\r\n.ri-map-pin-line:before { content: \"\\ef14\"; }\r\n.ri-map-pin-range-fill:before { content: \"\\ef15\"; }\r\n.ri-map-pin-range-line:before { content: \"\\ef16\"; }\r\n.ri-map-pin-time-fill:before { content: \"\\ef17\"; }\r\n.ri-map-pin-time-line:before { content: \"\\ef18\"; }\r\n.ri-map-pin-user-fill:before { content: \"\\ef19\"; }\r\n.ri-map-pin-user-line:before { content: \"\\ef1a\"; }\r\n.ri-mark-pen-fill:before { content: \"\\ef1b\"; }\r\n.ri-mark-pen-line:before { content: \"\\ef1c\"; }\r\n.ri-markdown-fill:before { content: \"\\ef1d\"; }\r\n.ri-markdown-line:before { content: \"\\ef1e\"; }\r\n.ri-markup-fill:before { content: \"\\ef1f\"; }\r\n.ri-markup-line:before { content: \"\\ef20\"; }\r\n.ri-mastercard-fill:before { content: \"\\ef21\"; }\r\n.ri-mastercard-line:before { content: \"\\ef22\"; }\r\n.ri-mastodon-fill:before { content: \"\\ef23\"; }\r\n.ri-mastodon-line:before { content: \"\\ef24\"; }\r\n.ri-medal-2-fill:before { content: \"\\ef25\"; }\r\n.ri-medal-2-line:before { content: \"\\ef26\"; }\r\n.ri-medal-fill:before { content: \"\\ef27\"; }\r\n.ri-medal-line:before { content: \"\\ef28\"; }\r\n.ri-medicine-bottle-fill:before { content: \"\\ef29\"; }\r\n.ri-medicine-bottle-line:before { content: \"\\ef2a\"; }\r\n.ri-medium-fill:before { content: \"\\ef2b\"; }\r\n.ri-medium-line:before { content: \"\\ef2c\"; }\r\n.ri-men-fill:before { content: \"\\ef2d\"; }\r\n.ri-men-line:before { content: \"\\ef2e\"; }\r\n.ri-mental-health-fill:before { content: \"\\ef2f\"; }\r\n.ri-mental-health-line:before { content: \"\\ef30\"; }\r\n.ri-menu-2-fill:before { content: \"\\ef31\"; }\r\n.ri-menu-2-line:before { content: \"\\ef32\"; }\r\n.ri-menu-3-fill:before { content: \"\\ef33\"; }\r\n.ri-menu-3-line:before { content: \"\\ef34\"; }\r\n.ri-menu-4-fill:before { content: \"\\ef35\"; }\r\n.ri-menu-4-line:before { content: \"\\ef36\"; }\r\n.ri-menu-5-fill:before { content: \"\\ef37\"; }\r\n.ri-menu-5-line:before { content: \"\\ef38\"; }\r\n.ri-menu-add-fill:before { content: \"\\ef39\"; }\r\n.ri-menu-add-line:before { content: \"\\ef3a\"; }\r\n.ri-menu-fill:before { content: \"\\ef3b\"; }\r\n.ri-menu-fold-fill:before { content: \"\\ef3c\"; }\r\n.ri-menu-fold-line:before { content: \"\\ef3d\"; }\r\n.ri-menu-line:before { content: \"\\ef3e\"; }\r\n.ri-menu-unfold-fill:before { content: \"\\ef3f\"; }\r\n.ri-menu-unfold-line:before { content: \"\\ef40\"; }\r\n.ri-merge-cells-horizontal:before { content: \"\\ef41\"; }\r\n.ri-merge-cells-vertical:before { content: \"\\ef42\"; }\r\n.ri-message-2-fill:before { content: \"\\ef43\"; }\r\n.ri-message-2-line:before { content: \"\\ef44\"; }\r\n.ri-message-3-fill:before { content: \"\\ef45\"; }\r\n.ri-message-3-line:before { content: \"\\ef46\"; }\r\n.ri-message-fill:before { content: \"\\ef47\"; }\r\n.ri-message-line:before { content: \"\\ef48\"; }\r\n.ri-messenger-fill:before { content: \"\\ef49\"; }\r\n.ri-messenger-line:before { content: \"\\ef4a\"; }\r\n.ri-meteor-fill:before { content: \"\\ef4b\"; }\r\n.ri-meteor-line:before { content: \"\\ef4c\"; }\r\n.ri-mic-2-fill:before { content: \"\\ef4d\"; }\r\n.ri-mic-2-line:before { content: \"\\ef4e\"; }\r\n.ri-mic-fill:before { content: \"\\ef4f\"; }\r\n.ri-mic-line:before { content: \"\\ef50\"; }\r\n.ri-mic-off-fill:before { content: \"\\ef51\"; }\r\n.ri-mic-off-line:before { content: \"\\ef52\"; }\r\n.ri-mickey-fill:before { content: \"\\ef53\"; }\r\n.ri-mickey-line:before { content: \"\\ef54\"; }\r\n.ri-microscope-fill:before { content: \"\\ef55\"; }\r\n.ri-microscope-line:before { content: \"\\ef56\"; }\r\n.ri-microsoft-fill:before { content: \"\\ef57\"; }\r\n.ri-microsoft-line:before { content: \"\\ef58\"; }\r\n.ri-mind-map:before { content: \"\\ef59\"; }\r\n.ri-mini-program-fill:before { content: \"\\ef5a\"; }\r\n.ri-mini-program-line:before { content: \"\\ef5b\"; }\r\n.ri-mist-fill:before { content: \"\\ef5c\"; }\r\n.ri-mist-line:before { content: \"\\ef5d\"; }\r\n.ri-money-cny-box-fill:before { content: \"\\ef5e\"; }\r\n.ri-money-cny-box-line:before { content: \"\\ef5f\"; }\r\n.ri-money-cny-circle-fill:before { content: \"\\ef60\"; }\r\n.ri-money-cny-circle-line:before { content: \"\\ef61\"; }\r\n.ri-money-dollar-box-fill:before { content: \"\\ef62\"; }\r\n.ri-money-dollar-box-line:before { content: \"\\ef63\"; }\r\n.ri-money-dollar-circle-fill:before { content: \"\\ef64\"; }\r\n.ri-money-dollar-circle-line:before { content: \"\\ef65\"; }\r\n.ri-money-euro-box-fill:before { content: \"\\ef66\"; }\r\n.ri-money-euro-box-line:before { content: \"\\ef67\"; }\r\n.ri-money-euro-circle-fill:before { content: \"\\ef68\"; }\r\n.ri-money-euro-circle-line:before { content: \"\\ef69\"; }\r\n.ri-money-pound-box-fill:before { content: \"\\ef6a\"; }\r\n.ri-money-pound-box-line:before { content: \"\\ef6b\"; }\r\n.ri-money-pound-circle-fill:before { content: \"\\ef6c\"; }\r\n.ri-money-pound-circle-line:before { content: \"\\ef6d\"; }\r\n.ri-moon-clear-fill:before { content: \"\\ef6e\"; }\r\n.ri-moon-clear-line:before { content: \"\\ef6f\"; }\r\n.ri-moon-cloudy-fill:before { content: \"\\ef70\"; }\r\n.ri-moon-cloudy-line:before { content: \"\\ef71\"; }\r\n.ri-moon-fill:before { content: \"\\ef72\"; }\r\n.ri-moon-foggy-fill:before { content: \"\\ef73\"; }\r\n.ri-moon-foggy-line:before { content: \"\\ef74\"; }\r\n.ri-moon-line:before { content: \"\\ef75\"; }\r\n.ri-more-2-fill:before { content: \"\\ef76\"; }\r\n.ri-more-2-line:before { content: \"\\ef77\"; }\r\n.ri-more-fill:before { content: \"\\ef78\"; }\r\n.ri-more-line:before { content: \"\\ef79\"; }\r\n.ri-motorbike-fill:before { content: \"\\ef7a\"; }\r\n.ri-motorbike-line:before { content: \"\\ef7b\"; }\r\n.ri-mouse-fill:before { content: \"\\ef7c\"; }\r\n.ri-mouse-line:before { content: \"\\ef7d\"; }\r\n.ri-movie-2-fill:before { content: \"\\ef7e\"; }\r\n.ri-movie-2-line:before { content: \"\\ef7f\"; }\r\n.ri-movie-fill:before { content: \"\\ef80\"; }\r\n.ri-movie-line:before { content: \"\\ef81\"; }\r\n.ri-music-2-fill:before { content: \"\\ef82\"; }\r\n.ri-music-2-line:before { content: \"\\ef83\"; }\r\n.ri-music-fill:before { content: \"\\ef84\"; }\r\n.ri-music-line:before { content: \"\\ef85\"; }\r\n.ri-mv-fill:before { content: \"\\ef86\"; }\r\n.ri-mv-line:before { content: \"\\ef87\"; }\r\n.ri-navigation-fill:before { content: \"\\ef88\"; }\r\n.ri-navigation-line:before { content: \"\\ef89\"; }\r\n.ri-netease-cloud-music-fill:before { content: \"\\ef8a\"; }\r\n.ri-netease-cloud-music-line:before { content: \"\\ef8b\"; }\r\n.ri-netflix-fill:before { content: \"\\ef8c\"; }\r\n.ri-netflix-line:before { content: \"\\ef8d\"; }\r\n.ri-newspaper-fill:before { content: \"\\ef8e\"; }\r\n.ri-newspaper-line:before { content: \"\\ef8f\"; }\r\n.ri-node-tree:before { content: \"\\ef90\"; }\r\n.ri-notification-2-fill:before { content: \"\\ef91\"; }\r\n.ri-notification-2-line:before { content: \"\\ef92\"; }\r\n.ri-notification-3-fill:before { content: \"\\ef93\"; }\r\n.ri-notification-3-line:before { content: \"\\ef94\"; }\r\n.ri-notification-4-fill:before { content: \"\\ef95\"; }\r\n.ri-notification-4-line:before { content: \"\\ef96\"; }\r\n.ri-notification-badge-fill:before { content: \"\\ef97\"; }\r\n.ri-notification-badge-line:before { content: \"\\ef98\"; }\r\n.ri-notification-fill:before { content: \"\\ef99\"; }\r\n.ri-notification-line:before { content: \"\\ef9a\"; }\r\n.ri-notification-off-fill:before { content: \"\\ef9b\"; }\r\n.ri-notification-off-line:before { content: \"\\ef9c\"; }\r\n.ri-npmjs-fill:before { content: \"\\ef9d\"; }\r\n.ri-npmjs-line:before { content: \"\\ef9e\"; }\r\n.ri-number-0:before { content: \"\\ef9f\"; }\r\n.ri-number-1:before { content: \"\\efa0\"; }\r\n.ri-number-2:before { content: \"\\efa1\"; }\r\n.ri-number-3:before { content: \"\\efa2\"; }\r\n.ri-number-4:before { content: \"\\efa3\"; }\r\n.ri-number-5:before { content: \"\\efa4\"; }\r\n.ri-number-6:before { content: \"\\efa5\"; }\r\n.ri-number-7:before { content: \"\\efa6\"; }\r\n.ri-number-8:before { content: \"\\efa7\"; }\r\n.ri-number-9:before { content: \"\\efa8\"; }\r\n.ri-numbers-fill:before { content: \"\\efa9\"; }\r\n.ri-numbers-line:before { content: \"\\efaa\"; }\r\n.ri-nurse-fill:before { content: \"\\efab\"; }\r\n.ri-nurse-line:before { content: \"\\efac\"; }\r\n.ri-oil-fill:before { content: \"\\efad\"; }\r\n.ri-oil-line:before { content: \"\\efae\"; }\r\n.ri-omega:before { content: \"\\efaf\"; }\r\n.ri-open-arm-fill:before { content: \"\\efb0\"; }\r\n.ri-open-arm-line:before { content: \"\\efb1\"; }\r\n.ri-open-source-fill:before { content: \"\\efb2\"; }\r\n.ri-open-source-line:before { content: \"\\efb3\"; }\r\n.ri-opera-fill:before { content: \"\\efb4\"; }\r\n.ri-opera-line:before { content: \"\\efb5\"; }\r\n.ri-order-play-fill:before { content: \"\\efb6\"; }\r\n.ri-order-play-line:before { content: \"\\efb7\"; }\r\n.ri-organization-chart:before { content: \"\\efb8\"; }\r\n.ri-outlet-2-fill:before { content: \"\\efb9\"; }\r\n.ri-outlet-2-line:before { content: \"\\efba\"; }\r\n.ri-outlet-fill:before { content: \"\\efbb\"; }\r\n.ri-outlet-line:before { content: \"\\efbc\"; }\r\n.ri-page-separator:before { content: \"\\efbd\"; }\r\n.ri-pages-fill:before { content: \"\\efbe\"; }\r\n.ri-pages-line:before { content: \"\\efbf\"; }\r\n.ri-paint-brush-fill:before { content: \"\\efc0\"; }\r\n.ri-paint-brush-line:before { content: \"\\efc1\"; }\r\n.ri-paint-fill:before { content: \"\\efc2\"; }\r\n.ri-paint-line:before { content: \"\\efc3\"; }\r\n.ri-palette-fill:before { content: \"\\efc4\"; }\r\n.ri-palette-line:before { content: \"\\efc5\"; }\r\n.ri-pantone-fill:before { content: \"\\efc6\"; }\r\n.ri-pantone-line:before { content: \"\\efc7\"; }\r\n.ri-paragraph:before { content: \"\\efc8\"; }\r\n.ri-parent-fill:before { content: \"\\efc9\"; }\r\n.ri-parent-line:before { content: \"\\efca\"; }\r\n.ri-parentheses-fill:before { content: \"\\efcb\"; }\r\n.ri-parentheses-line:before { content: \"\\efcc\"; }\r\n.ri-parking-box-fill:before { content: \"\\efcd\"; }\r\n.ri-parking-box-line:before { content: \"\\efce\"; }\r\n.ri-parking-fill:before { content: \"\\efcf\"; }\r\n.ri-parking-line:before { content: \"\\efd0\"; }\r\n.ri-passport-fill:before { content: \"\\efd1\"; }\r\n.ri-passport-line:before { content: \"\\efd2\"; }\r\n.ri-patreon-fill:before { content: \"\\efd3\"; }\r\n.ri-patreon-line:before { content: \"\\efd4\"; }\r\n.ri-pause-circle-fill:before { content: \"\\efd5\"; }\r\n.ri-pause-circle-line:before { content: \"\\efd6\"; }\r\n.ri-pause-fill:before { content: \"\\efd7\"; }\r\n.ri-pause-line:before { content: \"\\efd8\"; }\r\n.ri-pause-mini-fill:before { content: \"\\efd9\"; }\r\n.ri-pause-mini-line:before { content: \"\\efda\"; }\r\n.ri-paypal-fill:before { content: \"\\efdb\"; }\r\n.ri-paypal-line:before { content: \"\\efdc\"; }\r\n.ri-pen-nib-fill:before { content: \"\\efdd\"; }\r\n.ri-pen-nib-line:before { content: \"\\efde\"; }\r\n.ri-pencil-fill:before { content: \"\\efdf\"; }\r\n.ri-pencil-line:before { content: \"\\efe0\"; }\r\n.ri-pencil-ruler-2-fill:before { content: \"\\efe1\"; }\r\n.ri-pencil-ruler-2-line:before { content: \"\\efe2\"; }\r\n.ri-pencil-ruler-fill:before { content: \"\\efe3\"; }\r\n.ri-pencil-ruler-line:before { content: \"\\efe4\"; }\r\n.ri-percent-fill:before { content: \"\\efe5\"; }\r\n.ri-percent-line:before { content: \"\\efe6\"; }\r\n.ri-phone-camera-fill:before { content: \"\\efe7\"; }\r\n.ri-phone-camera-line:before { content: \"\\efe8\"; }\r\n.ri-phone-fill:before { content: \"\\efe9\"; }\r\n.ri-phone-find-fill:before { content: \"\\efea\"; }\r\n.ri-phone-find-line:before { content: \"\\efeb\"; }\r\n.ri-phone-line:before { content: \"\\efec\"; }\r\n.ri-phone-lock-fill:before { content: \"\\efed\"; }\r\n.ri-phone-lock-line:before { content: \"\\efee\"; }\r\n.ri-picture-in-picture-2-fill:before { content: \"\\efef\"; }\r\n.ri-picture-in-picture-2-line:before { content: \"\\eff0\"; }\r\n.ri-picture-in-picture-exit-fill:before { content: \"\\eff1\"; }\r\n.ri-picture-in-picture-exit-line:before { content: \"\\eff2\"; }\r\n.ri-picture-in-picture-fill:before { content: \"\\eff3\"; }\r\n.ri-picture-in-picture-line:before { content: \"\\eff4\"; }\r\n.ri-pie-chart-2-fill:before { content: \"\\eff5\"; }\r\n.ri-pie-chart-2-line:before { content: \"\\eff6\"; }\r\n.ri-pie-chart-box-fill:before { content: \"\\eff7\"; }\r\n.ri-pie-chart-box-line:before { content: \"\\eff8\"; }\r\n.ri-pie-chart-fill:before { content: \"\\eff9\"; }\r\n.ri-pie-chart-line:before { content: \"\\effa\"; }\r\n.ri-pin-distance-fill:before { content: \"\\effb\"; }\r\n.ri-pin-distance-line:before { content: \"\\effc\"; }\r\n.ri-ping-pong-fill:before { content: \"\\effd\"; }\r\n.ri-ping-pong-line:before { content: \"\\effe\"; }\r\n.ri-pinterest-fill:before { content: \"\\efff\"; }\r\n.ri-pinterest-line:before { content: \"\\f000\"; }\r\n.ri-pinyin-input:before { content: \"\\f001\"; }\r\n.ri-pixelfed-fill:before { content: \"\\f002\"; }\r\n.ri-pixelfed-line:before { content: \"\\f003\"; }\r\n.ri-plane-fill:before { content: \"\\f004\"; }\r\n.ri-plane-line:before { content: \"\\f005\"; }\r\n.ri-plant-fill:before { content: \"\\f006\"; }\r\n.ri-plant-line:before { content: \"\\f007\"; }\r\n.ri-play-circle-fill:before { content: \"\\f008\"; }\r\n.ri-play-circle-line:before { content: \"\\f009\"; }\r\n.ri-play-fill:before { content: \"\\f00a\"; }\r\n.ri-play-line:before { content: \"\\f00b\"; }\r\n.ri-play-list-2-fill:before { content: \"\\f00c\"; }\r\n.ri-play-list-2-line:before { content: \"\\f00d\"; }\r\n.ri-play-list-add-fill:before { content: \"\\f00e\"; }\r\n.ri-play-list-add-line:before { content: \"\\f00f\"; }\r\n.ri-play-list-fill:before { content: \"\\f010\"; }\r\n.ri-play-list-line:before { content: \"\\f011\"; }\r\n.ri-play-mini-fill:before { content: \"\\f012\"; }\r\n.ri-play-mini-line:before { content: \"\\f013\"; }\r\n.ri-playstation-fill:before { content: \"\\f014\"; }\r\n.ri-playstation-line:before { content: \"\\f015\"; }\r\n.ri-plug-2-fill:before { content: \"\\f016\"; }\r\n.ri-plug-2-line:before { content: \"\\f017\"; }\r\n.ri-plug-fill:before { content: \"\\f018\"; }\r\n.ri-plug-line:before { content: \"\\f019\"; }\r\n.ri-polaroid-2-fill:before { content: \"\\f01a\"; }\r\n.ri-polaroid-2-line:before { content: \"\\f01b\"; }\r\n.ri-polaroid-fill:before { content: \"\\f01c\"; }\r\n.ri-polaroid-line:before { content: \"\\f01d\"; }\r\n.ri-police-car-fill:before { content: \"\\f01e\"; }\r\n.ri-police-car-line:before { content: \"\\f01f\"; }\r\n.ri-price-tag-2-fill:before { content: \"\\f020\"; }\r\n.ri-price-tag-2-line:before { content: \"\\f021\"; }\r\n.ri-price-tag-3-fill:before { content: \"\\f022\"; }\r\n.ri-price-tag-3-line:before { content: \"\\f023\"; }\r\n.ri-price-tag-fill:before { content: \"\\f024\"; }\r\n.ri-price-tag-line:before { content: \"\\f025\"; }\r\n.ri-printer-cloud-fill:before { content: \"\\f026\"; }\r\n.ri-printer-cloud-line:before { content: \"\\f027\"; }\r\n.ri-printer-fill:before { content: \"\\f028\"; }\r\n.ri-printer-line:before { content: \"\\f029\"; }\r\n.ri-product-hunt-fill:before { content: \"\\f02a\"; }\r\n.ri-product-hunt-line:before { content: \"\\f02b\"; }\r\n.ri-profile-fill:before { content: \"\\f02c\"; }\r\n.ri-profile-line:before { content: \"\\f02d\"; }\r\n.ri-projector-2-fill:before { content: \"\\f02e\"; }\r\n.ri-projector-2-line:before { content: \"\\f02f\"; }\r\n.ri-projector-fill:before { content: \"\\f030\"; }\r\n.ri-projector-line:before { content: \"\\f031\"; }\r\n.ri-psychotherapy-fill:before { content: \"\\f032\"; }\r\n.ri-psychotherapy-line:before { content: \"\\f033\"; }\r\n.ri-pulse-fill:before { content: \"\\f034\"; }\r\n.ri-pulse-line:before { content: \"\\f035\"; }\r\n.ri-pushpin-2-fill:before { content: \"\\f036\"; }\r\n.ri-pushpin-2-line:before { content: \"\\f037\"; }\r\n.ri-pushpin-fill:before { content: \"\\f038\"; }\r\n.ri-pushpin-line:before { content: \"\\f039\"; }\r\n.ri-qq-fill:before { content: \"\\f03a\"; }\r\n.ri-qq-line:before { content: \"\\f03b\"; }\r\n.ri-qr-code-fill:before { content: \"\\f03c\"; }\r\n.ri-qr-code-line:before { content: \"\\f03d\"; }\r\n.ri-qr-scan-2-fill:before { content: \"\\f03e\"; }\r\n.ri-qr-scan-2-line:before { content: \"\\f03f\"; }\r\n.ri-qr-scan-fill:before { content: \"\\f040\"; }\r\n.ri-qr-scan-line:before { content: \"\\f041\"; }\r\n.ri-question-answer-fill:before { content: \"\\f042\"; }\r\n.ri-question-answer-line:before { content: \"\\f043\"; }\r\n.ri-question-fill:before { content: \"\\f044\"; }\r\n.ri-question-line:before { content: \"\\f045\"; }\r\n.ri-question-mark:before { content: \"\\f046\"; }\r\n.ri-questionnaire-fill:before { content: \"\\f047\"; }\r\n.ri-questionnaire-line:before { content: \"\\f048\"; }\r\n.ri-quill-pen-fill:before { content: \"\\f049\"; }\r\n.ri-quill-pen-line:before { content: \"\\f04a\"; }\r\n.ri-radar-fill:before { content: \"\\f04b\"; }\r\n.ri-radar-line:before { content: \"\\f04c\"; }\r\n.ri-radio-2-fill:before { content: \"\\f04d\"; }\r\n.ri-radio-2-line:before { content: \"\\f04e\"; }\r\n.ri-radio-button-fill:before { content: \"\\f04f\"; }\r\n.ri-radio-button-line:before { content: \"\\f050\"; }\r\n.ri-radio-fill:before { content: \"\\f051\"; }\r\n.ri-radio-line:before { content: \"\\f052\"; }\r\n.ri-rainbow-fill:before { content: \"\\f053\"; }\r\n.ri-rainbow-line:before { content: \"\\f054\"; }\r\n.ri-rainy-fill:before { content: \"\\f055\"; }\r\n.ri-rainy-line:before { content: \"\\f056\"; }\r\n.ri-reactjs-fill:before { content: \"\\f057\"; }\r\n.ri-reactjs-line:before { content: \"\\f058\"; }\r\n.ri-record-circle-fill:before { content: \"\\f059\"; }\r\n.ri-record-circle-line:before { content: \"\\f05a\"; }\r\n.ri-record-mail-fill:before { content: \"\\f05b\"; }\r\n.ri-record-mail-line:before { content: \"\\f05c\"; }\r\n.ri-recycle-fill:before { content: \"\\f05d\"; }\r\n.ri-recycle-line:before { content: \"\\f05e\"; }\r\n.ri-red-packet-fill:before { content: \"\\f05f\"; }\r\n.ri-red-packet-line:before { content: \"\\f060\"; }\r\n.ri-reddit-fill:before { content: \"\\f061\"; }\r\n.ri-reddit-line:before { content: \"\\f062\"; }\r\n.ri-refresh-fill:before { content: \"\\f063\"; }\r\n.ri-refresh-line:before { content: \"\\f064\"; }\r\n.ri-refund-2-fill:before { content: \"\\f065\"; }\r\n.ri-refund-2-line:before { content: \"\\f066\"; }\r\n.ri-refund-fill:before { content: \"\\f067\"; }\r\n.ri-refund-line:before { content: \"\\f068\"; }\r\n.ri-registered-fill:before { content: \"\\f069\"; }\r\n.ri-registered-line:before { content: \"\\f06a\"; }\r\n.ri-remixicon-fill:before { content: \"\\f06b\"; }\r\n.ri-remixicon-line:before { content: \"\\f06c\"; }\r\n.ri-remote-control-2-fill:before { content: \"\\f06d\"; }\r\n.ri-remote-control-2-line:before { content: \"\\f06e\"; }\r\n.ri-remote-control-fill:before { content: \"\\f06f\"; }\r\n.ri-remote-control-line:before { content: \"\\f070\"; }\r\n.ri-repeat-2-fill:before { content: \"\\f071\"; }\r\n.ri-repeat-2-line:before { content: \"\\f072\"; }\r\n.ri-repeat-fill:before { content: \"\\f073\"; }\r\n.ri-repeat-line:before { content: \"\\f074\"; }\r\n.ri-repeat-one-fill:before { content: \"\\f075\"; }\r\n.ri-repeat-one-line:before { content: \"\\f076\"; }\r\n.ri-reply-all-fill:before { content: \"\\f077\"; }\r\n.ri-reply-all-line:before { content: \"\\f078\"; }\r\n.ri-reply-fill:before { content: \"\\f079\"; }\r\n.ri-reply-line:before { content: \"\\f07a\"; }\r\n.ri-reserved-fill:before { content: \"\\f07b\"; }\r\n.ri-reserved-line:before { content: \"\\f07c\"; }\r\n.ri-rest-time-fill:before { content: \"\\f07d\"; }\r\n.ri-rest-time-line:before { content: \"\\f07e\"; }\r\n.ri-restart-fill:before { content: \"\\f07f\"; }\r\n.ri-restart-line:before { content: \"\\f080\"; }\r\n.ri-restaurant-2-fill:before { content: \"\\f081\"; }\r\n.ri-restaurant-2-line:before { content: \"\\f082\"; }\r\n.ri-restaurant-fill:before { content: \"\\f083\"; }\r\n.ri-restaurant-line:before { content: \"\\f084\"; }\r\n.ri-rewind-fill:before { content: \"\\f085\"; }\r\n.ri-rewind-line:before { content: \"\\f086\"; }\r\n.ri-rewind-mini-fill:before { content: \"\\f087\"; }\r\n.ri-rewind-mini-line:before { content: \"\\f088\"; }\r\n.ri-rhythm-fill:before { content: \"\\f089\"; }\r\n.ri-rhythm-line:before { content: \"\\f08a\"; }\r\n.ri-riding-fill:before { content: \"\\f08b\"; }\r\n.ri-riding-line:before { content: \"\\f08c\"; }\r\n.ri-road-map-fill:before { content: \"\\f08d\"; }\r\n.ri-road-map-line:before { content: \"\\f08e\"; }\r\n.ri-roadster-fill:before { content: \"\\f08f\"; }\r\n.ri-roadster-line:before { content: \"\\f090\"; }\r\n.ri-robot-fill:before { content: \"\\f091\"; }\r\n.ri-robot-line:before { content: \"\\f092\"; }\r\n.ri-rocket-2-fill:before { content: \"\\f093\"; }\r\n.ri-rocket-2-line:before { content: \"\\f094\"; }\r\n.ri-rocket-fill:before { content: \"\\f095\"; }\r\n.ri-rocket-line:before { content: \"\\f096\"; }\r\n.ri-rotate-lock-fill:before { content: \"\\f097\"; }\r\n.ri-rotate-lock-line:before { content: \"\\f098\"; }\r\n.ri-rounded-corner:before { content: \"\\f099\"; }\r\n.ri-route-fill:before { content: \"\\f09a\"; }\r\n.ri-route-line:before { content: \"\\f09b\"; }\r\n.ri-router-fill:before { content: \"\\f09c\"; }\r\n.ri-router-line:before { content: \"\\f09d\"; }\r\n.ri-rss-fill:before { content: \"\\f09e\"; }\r\n.ri-rss-line:before { content: \"\\f09f\"; }\r\n.ri-ruler-2-fill:before { content: \"\\f0a0\"; }\r\n.ri-ruler-2-line:before { content: \"\\f0a1\"; }\r\n.ri-ruler-fill:before { content: \"\\f0a2\"; }\r\n.ri-ruler-line:before { content: \"\\f0a3\"; }\r\n.ri-run-fill:before { content: \"\\f0a4\"; }\r\n.ri-run-line:before { content: \"\\f0a5\"; }\r\n.ri-safari-fill:before { content: \"\\f0a6\"; }\r\n.ri-safari-line:before { content: \"\\f0a7\"; }\r\n.ri-safe-2-fill:before { content: \"\\f0a8\"; }\r\n.ri-safe-2-line:before { content: \"\\f0a9\"; }\r\n.ri-safe-fill:before { content: \"\\f0aa\"; }\r\n.ri-safe-line:before { content: \"\\f0ab\"; }\r\n.ri-sailboat-fill:before { content: \"\\f0ac\"; }\r\n.ri-sailboat-line:before { content: \"\\f0ad\"; }\r\n.ri-save-2-fill:before { content: \"\\f0ae\"; }\r\n.ri-save-2-line:before { content: \"\\f0af\"; }\r\n.ri-save-3-fill:before { content: \"\\f0b0\"; }\r\n.ri-save-3-line:before { content: \"\\f0b1\"; }\r\n.ri-save-fill:before { content: \"\\f0b2\"; }\r\n.ri-save-line:before { content: \"\\f0b3\"; }\r\n.ri-scales-2-fill:before { content: \"\\f0b4\"; }\r\n.ri-scales-2-line:before { content: \"\\f0b5\"; }\r\n.ri-scales-3-fill:before { content: \"\\f0b6\"; }\r\n.ri-scales-3-line:before { content: \"\\f0b7\"; }\r\n.ri-scales-fill:before { content: \"\\f0b8\"; }\r\n.ri-scales-line:before { content: \"\\f0b9\"; }\r\n.ri-scan-2-fill:before { content: \"\\f0ba\"; }\r\n.ri-scan-2-line:before { content: \"\\f0bb\"; }\r\n.ri-scan-fill:before { content: \"\\f0bc\"; }\r\n.ri-scan-line:before { content: \"\\f0bd\"; }\r\n.ri-scissors-2-fill:before { content: \"\\f0be\"; }\r\n.ri-scissors-2-line:before { content: \"\\f0bf\"; }\r\n.ri-scissors-cut-fill:before { content: \"\\f0c0\"; }\r\n.ri-scissors-cut-line:before { content: \"\\f0c1\"; }\r\n.ri-scissors-fill:before { content: \"\\f0c2\"; }\r\n.ri-scissors-line:before { content: \"\\f0c3\"; }\r\n.ri-screenshot-2-fill:before { content: \"\\f0c4\"; }\r\n.ri-screenshot-2-line:before { content: \"\\f0c5\"; }\r\n.ri-screenshot-fill:before { content: \"\\f0c6\"; }\r\n.ri-screenshot-line:before { content: \"\\f0c7\"; }\r\n.ri-sd-card-fill:before { content: \"\\f0c8\"; }\r\n.ri-sd-card-line:before { content: \"\\f0c9\"; }\r\n.ri-sd-card-mini-fill:before { content: \"\\f0ca\"; }\r\n.ri-sd-card-mini-line:before { content: \"\\f0cb\"; }\r\n.ri-search-2-fill:before { content: \"\\f0cc\"; }\r\n.ri-search-2-line:before { content: \"\\f0cd\"; }\r\n.ri-search-eye-fill:before { content: \"\\f0ce\"; }\r\n.ri-search-eye-line:before { content: \"\\f0cf\"; }\r\n.ri-search-fill:before { content: \"\\f0d0\"; }\r\n.ri-search-line:before { content: \"\\f0d1\"; }\r\n.ri-secure-payment-fill:before { content: \"\\f0d2\"; }\r\n.ri-secure-payment-line:before { content: \"\\f0d3\"; }\r\n.ri-seedling-fill:before { content: \"\\f0d4\"; }\r\n.ri-seedling-line:before { content: \"\\f0d5\"; }\r\n.ri-send-backward:before { content: \"\\f0d6\"; }\r\n.ri-send-plane-2-fill:before { content: \"\\f0d7\"; }\r\n.ri-send-plane-2-line:before { content: \"\\f0d8\"; }\r\n.ri-send-plane-fill:before { content: \"\\f0d9\"; }\r\n.ri-send-plane-line:before { content: \"\\f0da\"; }\r\n.ri-send-to-back:before { content: \"\\f0db\"; }\r\n.ri-sensor-fill:before { content: \"\\f0dc\"; }\r\n.ri-sensor-line:before { content: \"\\f0dd\"; }\r\n.ri-separator:before { content: \"\\f0de\"; }\r\n.ri-server-fill:before { content: \"\\f0df\"; }\r\n.ri-server-line:before { content: \"\\f0e0\"; }\r\n.ri-service-fill:before { content: \"\\f0e1\"; }\r\n.ri-service-line:before { content: \"\\f0e2\"; }\r\n.ri-settings-2-fill:before { content: \"\\f0e3\"; }\r\n.ri-settings-2-line:before { content: \"\\f0e4\"; }\r\n.ri-settings-3-fill:before { content: \"\\f0e5\"; }\r\n.ri-settings-3-line:before { content: \"\\f0e6\"; }\r\n.ri-settings-4-fill:before { content: \"\\f0e7\"; }\r\n.ri-settings-4-line:before { content: \"\\f0e8\"; }\r\n.ri-settings-5-fill:before { content: \"\\f0e9\"; }\r\n.ri-settings-5-line:before { content: \"\\f0ea\"; }\r\n.ri-settings-6-fill:before { content: \"\\f0eb\"; }\r\n.ri-settings-6-line:before { content: \"\\f0ec\"; }\r\n.ri-settings-fill:before { content: \"\\f0ed\"; }\r\n.ri-settings-line:before { content: \"\\f0ee\"; }\r\n.ri-shape-2-fill:before { content: \"\\f0ef\"; }\r\n.ri-shape-2-line:before { content: \"\\f0f0\"; }\r\n.ri-shape-fill:before { content: \"\\f0f1\"; }\r\n.ri-shape-line:before { content: \"\\f0f2\"; }\r\n.ri-share-box-fill:before { content: \"\\f0f3\"; }\r\n.ri-share-box-line:before { content: \"\\f0f4\"; }\r\n.ri-share-circle-fill:before { content: \"\\f0f5\"; }\r\n.ri-share-circle-line:before { content: \"\\f0f6\"; }\r\n.ri-share-fill:before { content: \"\\f0f7\"; }\r\n.ri-share-forward-2-fill:before { content: \"\\f0f8\"; }\r\n.ri-share-forward-2-line:before { content: \"\\f0f9\"; }\r\n.ri-share-forward-box-fill:before { content: \"\\f0fa\"; }\r\n.ri-share-forward-box-line:before { content: \"\\f0fb\"; }\r\n.ri-share-forward-fill:before { content: \"\\f0fc\"; }\r\n.ri-share-forward-line:before { content: \"\\f0fd\"; }\r\n.ri-share-line:before { content: \"\\f0fe\"; }\r\n.ri-shield-check-fill:before { content: \"\\f0ff\"; }\r\n.ri-shield-check-line:before { content: \"\\f100\"; }\r\n.ri-shield-cross-fill:before { content: \"\\f101\"; }\r\n.ri-shield-cross-line:before { content: \"\\f102\"; }\r\n.ri-shield-fill:before { content: \"\\f103\"; }\r\n.ri-shield-flash-fill:before { content: \"\\f104\"; }\r\n.ri-shield-flash-line:before { content: \"\\f105\"; }\r\n.ri-shield-keyhole-fill:before { content: \"\\f106\"; }\r\n.ri-shield-keyhole-line:before { content: \"\\f107\"; }\r\n.ri-shield-line:before { content: \"\\f108\"; }\r\n.ri-shield-star-fill:before { content: \"\\f109\"; }\r\n.ri-shield-star-line:before { content: \"\\f10a\"; }\r\n.ri-shield-user-fill:before { content: \"\\f10b\"; }\r\n.ri-shield-user-line:before { content: \"\\f10c\"; }\r\n.ri-ship-2-fill:before { content: \"\\f10d\"; }\r\n.ri-ship-2-line:before { content: \"\\f10e\"; }\r\n.ri-ship-fill:before { content: \"\\f10f\"; }\r\n.ri-ship-line:before { content: \"\\f110\"; }\r\n.ri-shirt-fill:before { content: \"\\f111\"; }\r\n.ri-shirt-line:before { content: \"\\f112\"; }\r\n.ri-shopping-bag-2-fill:before { content: \"\\f113\"; }\r\n.ri-shopping-bag-2-line:before { content: \"\\f114\"; }\r\n.ri-shopping-bag-3-fill:before { content: \"\\f115\"; }\r\n.ri-shopping-bag-3-line:before { content: \"\\f116\"; }\r\n.ri-shopping-bag-fill:before { content: \"\\f117\"; }\r\n.ri-shopping-bag-line:before { content: \"\\f118\"; }\r\n.ri-shopping-basket-2-fill:before { content: \"\\f119\"; }\r\n.ri-shopping-basket-2-line:before { content: \"\\f11a\"; }\r\n.ri-shopping-basket-fill:before { content: \"\\f11b\"; }\r\n.ri-shopping-basket-line:before { content: \"\\f11c\"; }\r\n.ri-shopping-cart-2-fill:before { content: \"\\f11d\"; }\r\n.ri-shopping-cart-2-line:before { content: \"\\f11e\"; }\r\n.ri-shopping-cart-fill:before { content: \"\\f11f\"; }\r\n.ri-shopping-cart-line:before { content: \"\\f120\"; }\r\n.ri-showers-fill:before { content: \"\\f121\"; }\r\n.ri-showers-line:before { content: \"\\f122\"; }\r\n.ri-shuffle-fill:before { content: \"\\f123\"; }\r\n.ri-shuffle-line:before { content: \"\\f124\"; }\r\n.ri-shut-down-fill:before { content: \"\\f125\"; }\r\n.ri-shut-down-line:before { content: \"\\f126\"; }\r\n.ri-side-bar-fill:before { content: \"\\f127\"; }\r\n.ri-side-bar-line:before { content: \"\\f128\"; }\r\n.ri-signal-tower-fill:before { content: \"\\f129\"; }\r\n.ri-signal-tower-line:before { content: \"\\f12a\"; }\r\n.ri-signal-wifi-1-fill:before { content: \"\\f12b\"; }\r\n.ri-signal-wifi-1-line:before { content: \"\\f12c\"; }\r\n.ri-signal-wifi-2-fill:before { content: \"\\f12d\"; }\r\n.ri-signal-wifi-2-line:before { content: \"\\f12e\"; }\r\n.ri-signal-wifi-3-fill:before { content: \"\\f12f\"; }\r\n.ri-signal-wifi-3-line:before { content: \"\\f130\"; }\r\n.ri-signal-wifi-error-fill:before { content: \"\\f131\"; }\r\n.ri-signal-wifi-error-line:before { content: \"\\f132\"; }\r\n.ri-signal-wifi-fill:before { content: \"\\f133\"; }\r\n.ri-signal-wifi-line:before { content: \"\\f134\"; }\r\n.ri-signal-wifi-off-fill:before { content: \"\\f135\"; }\r\n.ri-signal-wifi-off-line:before { content: \"\\f136\"; }\r\n.ri-sim-card-2-fill:before { content: \"\\f137\"; }\r\n.ri-sim-card-2-line:before { content: \"\\f138\"; }\r\n.ri-sim-card-fill:before { content: \"\\f139\"; }\r\n.ri-sim-card-line:before { content: \"\\f13a\"; }\r\n.ri-single-quotes-l:before { content: \"\\f13b\"; }\r\n.ri-single-quotes-r:before { content: \"\\f13c\"; }\r\n.ri-sip-fill:before { content: \"\\f13d\"; }\r\n.ri-sip-line:before { content: \"\\f13e\"; }\r\n.ri-skip-back-fill:before { content: \"\\f13f\"; }\r\n.ri-skip-back-line:before { content: \"\\f140\"; }\r\n.ri-skip-back-mini-fill:before { content: \"\\f141\"; }\r\n.ri-skip-back-mini-line:before { content: \"\\f142\"; }\r\n.ri-skip-forward-fill:before { content: \"\\f143\"; }\r\n.ri-skip-forward-line:before { content: \"\\f144\"; }\r\n.ri-skip-forward-mini-fill:before { content: \"\\f145\"; }\r\n.ri-skip-forward-mini-line:before { content: \"\\f146\"; }\r\n.ri-skull-2-fill:before { content: \"\\f147\"; }\r\n.ri-skull-2-line:before { content: \"\\f148\"; }\r\n.ri-skull-fill:before { content: \"\\f149\"; }\r\n.ri-skull-line:before { content: \"\\f14a\"; }\r\n.ri-skype-fill:before { content: \"\\f14b\"; }\r\n.ri-skype-line:before { content: \"\\f14c\"; }\r\n.ri-slack-fill:before { content: \"\\f14d\"; }\r\n.ri-slack-line:before { content: \"\\f14e\"; }\r\n.ri-slice-fill:before { content: \"\\f14f\"; }\r\n.ri-slice-line:before { content: \"\\f150\"; }\r\n.ri-slideshow-2-fill:before { content: \"\\f151\"; }\r\n.ri-slideshow-2-line:before { content: \"\\f152\"; }\r\n.ri-slideshow-3-fill:before { content: \"\\f153\"; }\r\n.ri-slideshow-3-line:before { content: \"\\f154\"; }\r\n.ri-slideshow-4-fill:before { content: \"\\f155\"; }\r\n.ri-slideshow-4-line:before { content: \"\\f156\"; }\r\n.ri-slideshow-fill:before { content: \"\\f157\"; }\r\n.ri-slideshow-line:before { content: \"\\f158\"; }\r\n.ri-smartphone-fill:before { content: \"\\f159\"; }\r\n.ri-smartphone-line:before { content: \"\\f15a\"; }\r\n.ri-snapchat-fill:before { content: \"\\f15b\"; }\r\n.ri-snapchat-line:before { content: \"\\f15c\"; }\r\n.ri-snowy-fill:before { content: \"\\f15d\"; }\r\n.ri-snowy-line:before { content: \"\\f15e\"; }\r\n.ri-sort-asc:before { content: \"\\f15f\"; }\r\n.ri-sort-desc:before { content: \"\\f160\"; }\r\n.ri-sound-module-fill:before { content: \"\\f161\"; }\r\n.ri-sound-module-line:before { content: \"\\f162\"; }\r\n.ri-soundcloud-fill:before { content: \"\\f163\"; }\r\n.ri-soundcloud-line:before { content: \"\\f164\"; }\r\n.ri-space-ship-fill:before { content: \"\\f165\"; }\r\n.ri-space-ship-line:before { content: \"\\f166\"; }\r\n.ri-space:before { content: \"\\f167\"; }\r\n.ri-spam-2-fill:before { content: \"\\f168\"; }\r\n.ri-spam-2-line:before { content: \"\\f169\"; }\r\n.ri-spam-3-fill:before { content: \"\\f16a\"; }\r\n.ri-spam-3-line:before { content: \"\\f16b\"; }\r\n.ri-spam-fill:before { content: \"\\f16c\"; }\r\n.ri-spam-line:before { content: \"\\f16d\"; }\r\n.ri-speaker-2-fill:before { content: \"\\f16e\"; }\r\n.ri-speaker-2-line:before { content: \"\\f16f\"; }\r\n.ri-speaker-3-fill:before { content: \"\\f170\"; }\r\n.ri-speaker-3-line:before { content: \"\\f171\"; }\r\n.ri-speaker-fill:before { content: \"\\f172\"; }\r\n.ri-speaker-line:before { content: \"\\f173\"; }\r\n.ri-spectrum-fill:before { content: \"\\f174\"; }\r\n.ri-spectrum-line:before { content: \"\\f175\"; }\r\n.ri-speed-fill:before { content: \"\\f176\"; }\r\n.ri-speed-line:before { content: \"\\f177\"; }\r\n.ri-speed-mini-fill:before { content: \"\\f178\"; }\r\n.ri-speed-mini-line:before { content: \"\\f179\"; }\r\n.ri-split-cells-horizontal:before { content: \"\\f17a\"; }\r\n.ri-split-cells-vertical:before { content: \"\\f17b\"; }\r\n.ri-spotify-fill:before { content: \"\\f17c\"; }\r\n.ri-spotify-line:before { content: \"\\f17d\"; }\r\n.ri-spy-fill:before { content: \"\\f17e\"; }\r\n.ri-spy-line:before { content: \"\\f17f\"; }\r\n.ri-stack-fill:before { content: \"\\f180\"; }\r\n.ri-stack-line:before { content: \"\\f181\"; }\r\n.ri-stack-overflow-fill:before { content: \"\\f182\"; }\r\n.ri-stack-overflow-line:before { content: \"\\f183\"; }\r\n.ri-stackshare-fill:before { content: \"\\f184\"; }\r\n.ri-stackshare-line:before { content: \"\\f185\"; }\r\n.ri-star-fill:before { content: \"\\f186\"; }\r\n.ri-star-half-fill:before { content: \"\\f187\"; }\r\n.ri-star-half-line:before { content: \"\\f188\"; }\r\n.ri-star-half-s-fill:before { content: \"\\f189\"; }\r\n.ri-star-half-s-line:before { content: \"\\f18a\"; }\r\n.ri-star-line:before { content: \"\\f18b\"; }\r\n.ri-star-s-fill:before { content: \"\\f18c\"; }\r\n.ri-star-s-line:before { content: \"\\f18d\"; }\r\n.ri-star-smile-fill:before { content: \"\\f18e\"; }\r\n.ri-star-smile-line:before { content: \"\\f18f\"; }\r\n.ri-steam-fill:before { content: \"\\f190\"; }\r\n.ri-steam-line:before { content: \"\\f191\"; }\r\n.ri-steering-2-fill:before { content: \"\\f192\"; }\r\n.ri-steering-2-line:before { content: \"\\f193\"; }\r\n.ri-steering-fill:before { content: \"\\f194\"; }\r\n.ri-steering-line:before { content: \"\\f195\"; }\r\n.ri-stethoscope-fill:before { content: \"\\f196\"; }\r\n.ri-stethoscope-line:before { content: \"\\f197\"; }\r\n.ri-sticky-note-2-fill:before { content: \"\\f198\"; }\r\n.ri-sticky-note-2-line:before { content: \"\\f199\"; }\r\n.ri-sticky-note-fill:before { content: \"\\f19a\"; }\r\n.ri-sticky-note-line:before { content: \"\\f19b\"; }\r\n.ri-stock-fill:before { content: \"\\f19c\"; }\r\n.ri-stock-line:before { content: \"\\f19d\"; }\r\n.ri-stop-circle-fill:before { content: \"\\f19e\"; }\r\n.ri-stop-circle-line:before { content: \"\\f19f\"; }\r\n.ri-stop-fill:before { content: \"\\f1a0\"; }\r\n.ri-stop-line:before { content: \"\\f1a1\"; }\r\n.ri-stop-mini-fill:before { content: \"\\f1a2\"; }\r\n.ri-stop-mini-line:before { content: \"\\f1a3\"; }\r\n.ri-store-2-fill:before { content: \"\\f1a4\"; }\r\n.ri-store-2-line:before { content: \"\\f1a5\"; }\r\n.ri-store-3-fill:before { content: \"\\f1a6\"; }\r\n.ri-store-3-line:before { content: \"\\f1a7\"; }\r\n.ri-store-fill:before { content: \"\\f1a8\"; }\r\n.ri-store-line:before { content: \"\\f1a9\"; }\r\n.ri-strikethrough-2:before { content: \"\\f1aa\"; }\r\n.ri-strikethrough:before { content: \"\\f1ab\"; }\r\n.ri-subscript-2:before { content: \"\\f1ac\"; }\r\n.ri-subscript:before { content: \"\\f1ad\"; }\r\n.ri-subtract-fill:before { content: \"\\f1ae\"; }\r\n.ri-subtract-line:before { content: \"\\f1af\"; }\r\n.ri-subway-fill:before { content: \"\\f1b0\"; }\r\n.ri-subway-line:before { content: \"\\f1b1\"; }\r\n.ri-subway-wifi-fill:before { content: \"\\f1b2\"; }\r\n.ri-subway-wifi-line:before { content: \"\\f1b3\"; }\r\n.ri-suitcase-2-fill:before { content: \"\\f1b4\"; }\r\n.ri-suitcase-2-line:before { content: \"\\f1b5\"; }\r\n.ri-suitcase-3-fill:before { content: \"\\f1b6\"; }\r\n.ri-suitcase-3-line:before { content: \"\\f1b7\"; }\r\n.ri-suitcase-fill:before { content: \"\\f1b8\"; }\r\n.ri-suitcase-line:before { content: \"\\f1b9\"; }\r\n.ri-sun-cloudy-fill:before { content: \"\\f1ba\"; }\r\n.ri-sun-cloudy-line:before { content: \"\\f1bb\"; }\r\n.ri-sun-fill:before { content: \"\\f1bc\"; }\r\n.ri-sun-foggy-fill:before { content: \"\\f1bd\"; }\r\n.ri-sun-foggy-line:before { content: \"\\f1be\"; }\r\n.ri-sun-line:before { content: \"\\f1bf\"; }\r\n.ri-superscript-2:before { content: \"\\f1c0\"; }\r\n.ri-superscript:before { content: \"\\f1c1\"; }\r\n.ri-surgical-mask-fill:before { content: \"\\f1c2\"; }\r\n.ri-surgical-mask-line:before { content: \"\\f1c3\"; }\r\n.ri-surround-sound-fill:before { content: \"\\f1c4\"; }\r\n.ri-surround-sound-line:before { content: \"\\f1c5\"; }\r\n.ri-survey-fill:before { content: \"\\f1c6\"; }\r\n.ri-survey-line:before { content: \"\\f1c7\"; }\r\n.ri-swap-box-fill:before { content: \"\\f1c8\"; }\r\n.ri-swap-box-line:before { content: \"\\f1c9\"; }\r\n.ri-swap-fill:before { content: \"\\f1ca\"; }\r\n.ri-swap-line:before { content: \"\\f1cb\"; }\r\n.ri-switch-fill:before { content: \"\\f1cc\"; }\r\n.ri-switch-line:before { content: \"\\f1cd\"; }\r\n.ri-sword-fill:before { content: \"\\f1ce\"; }\r\n.ri-sword-line:before { content: \"\\f1cf\"; }\r\n.ri-syringe-fill:before { content: \"\\f1d0\"; }\r\n.ri-syringe-line:before { content: \"\\f1d1\"; }\r\n.ri-t-box-fill:before { content: \"\\f1d2\"; }\r\n.ri-t-box-line:before { content: \"\\f1d3\"; }\r\n.ri-t-shirt-2-fill:before { content: \"\\f1d4\"; }\r\n.ri-t-shirt-2-line:before { content: \"\\f1d5\"; }\r\n.ri-t-shirt-air-fill:before { content: \"\\f1d6\"; }\r\n.ri-t-shirt-air-line:before { content: \"\\f1d7\"; }\r\n.ri-t-shirt-fill:before { content: \"\\f1d8\"; }\r\n.ri-t-shirt-line:before { content: \"\\f1d9\"; }\r\n.ri-table-2:before { content: \"\\f1da\"; }\r\n.ri-table-alt-fill:before { content: \"\\f1db\"; }\r\n.ri-table-alt-line:before { content: \"\\f1dc\"; }\r\n.ri-table-fill:before { content: \"\\f1dd\"; }\r\n.ri-table-line:before { content: \"\\f1de\"; }\r\n.ri-tablet-fill:before { content: \"\\f1df\"; }\r\n.ri-tablet-line:before { content: \"\\f1e0\"; }\r\n.ri-takeaway-fill:before { content: \"\\f1e1\"; }\r\n.ri-takeaway-line:before { content: \"\\f1e2\"; }\r\n.ri-taobao-fill:before { content: \"\\f1e3\"; }\r\n.ri-taobao-line:before { content: \"\\f1e4\"; }\r\n.ri-tape-fill:before { content: \"\\f1e5\"; }\r\n.ri-tape-line:before { content: \"\\f1e6\"; }\r\n.ri-task-fill:before { content: \"\\f1e7\"; }\r\n.ri-task-line:before { content: \"\\f1e8\"; }\r\n.ri-taxi-fill:before { content: \"\\f1e9\"; }\r\n.ri-taxi-line:before { content: \"\\f1ea\"; }\r\n.ri-taxi-wifi-fill:before { content: \"\\f1eb\"; }\r\n.ri-taxi-wifi-line:before { content: \"\\f1ec\"; }\r\n.ri-team-fill:before { content: \"\\f1ed\"; }\r\n.ri-team-line:before { content: \"\\f1ee\"; }\r\n.ri-telegram-fill:before { content: \"\\f1ef\"; }\r\n.ri-telegram-line:before { content: \"\\f1f0\"; }\r\n.ri-temp-cold-fill:before { content: \"\\f1f1\"; }\r\n.ri-temp-cold-line:before { content: \"\\f1f2\"; }\r\n.ri-temp-hot-fill:before { content: \"\\f1f3\"; }\r\n.ri-temp-hot-line:before { content: \"\\f1f4\"; }\r\n.ri-terminal-box-fill:before { content: \"\\f1f5\"; }\r\n.ri-terminal-box-line:before { content: \"\\f1f6\"; }\r\n.ri-terminal-fill:before { content: \"\\f1f7\"; }\r\n.ri-terminal-line:before { content: \"\\f1f8\"; }\r\n.ri-terminal-window-fill:before { content: \"\\f1f9\"; }\r\n.ri-terminal-window-line:before { content: \"\\f1fa\"; }\r\n.ri-test-tube-fill:before { content: \"\\f1fb\"; }\r\n.ri-test-tube-line:before { content: \"\\f1fc\"; }\r\n.ri-text-direction-l:before { content: \"\\f1fd\"; }\r\n.ri-text-direction-r:before { content: \"\\f1fe\"; }\r\n.ri-text-spacing:before { content: \"\\f1ff\"; }\r\n.ri-text-wrap:before { content: \"\\f200\"; }\r\n.ri-text:before { content: \"\\f201\"; }\r\n.ri-thermometer-fill:before { content: \"\\f202\"; }\r\n.ri-thermometer-line:before { content: \"\\f203\"; }\r\n.ri-thumb-down-fill:before { content: \"\\f204\"; }\r\n.ri-thumb-down-line:before { content: \"\\f205\"; }\r\n.ri-thumb-up-fill:before { content: \"\\f206\"; }\r\n.ri-thumb-up-line:before { content: \"\\f207\"; }\r\n.ri-thunderstorms-fill:before { content: \"\\f208\"; }\r\n.ri-thunderstorms-line:before { content: \"\\f209\"; }\r\n.ri-ticket-2-fill:before { content: \"\\f20a\"; }\r\n.ri-ticket-2-line:before { content: \"\\f20b\"; }\r\n.ri-ticket-fill:before { content: \"\\f20c\"; }\r\n.ri-ticket-line:before { content: \"\\f20d\"; }\r\n.ri-time-fill:before { content: \"\\f20e\"; }\r\n.ri-time-line:before { content: \"\\f20f\"; }\r\n.ri-timer-2-fill:before { content: \"\\f210\"; }\r\n.ri-timer-2-line:before { content: \"\\f211\"; }\r\n.ri-timer-fill:before { content: \"\\f212\"; }\r\n.ri-timer-flash-fill:before { content: \"\\f213\"; }\r\n.ri-timer-flash-line:before { content: \"\\f214\"; }\r\n.ri-timer-line:before { content: \"\\f215\"; }\r\n.ri-todo-fill:before { content: \"\\f216\"; }\r\n.ri-todo-line:before { content: \"\\f217\"; }\r\n.ri-toggle-fill:before { content: \"\\f218\"; }\r\n.ri-toggle-line:before { content: \"\\f219\"; }\r\n.ri-tools-fill:before { content: \"\\f21a\"; }\r\n.ri-tools-line:before { content: \"\\f21b\"; }\r\n.ri-tornado-fill:before { content: \"\\f21c\"; }\r\n.ri-tornado-line:before { content: \"\\f21d\"; }\r\n.ri-trademark-fill:before { content: \"\\f21e\"; }\r\n.ri-trademark-line:before { content: \"\\f21f\"; }\r\n.ri-traffic-light-fill:before { content: \"\\f220\"; }\r\n.ri-traffic-light-line:before { content: \"\\f221\"; }\r\n.ri-train-fill:before { content: \"\\f222\"; }\r\n.ri-train-line:before { content: \"\\f223\"; }\r\n.ri-train-wifi-fill:before { content: \"\\f224\"; }\r\n.ri-train-wifi-line:before { content: \"\\f225\"; }\r\n.ri-translate-2:before { content: \"\\f226\"; }\r\n.ri-translate:before { content: \"\\f227\"; }\r\n.ri-travesti-fill:before { content: \"\\f228\"; }\r\n.ri-travesti-line:before { content: \"\\f229\"; }\r\n.ri-treasure-map-fill:before { content: \"\\f22a\"; }\r\n.ri-treasure-map-line:before { content: \"\\f22b\"; }\r\n.ri-trello-fill:before { content: \"\\f22c\"; }\r\n.ri-trello-line:before { content: \"\\f22d\"; }\r\n.ri-trophy-fill:before { content: \"\\f22e\"; }\r\n.ri-trophy-line:before { content: \"\\f22f\"; }\r\n.ri-truck-fill:before { content: \"\\f230\"; }\r\n.ri-truck-line:before { content: \"\\f231\"; }\r\n.ri-tumblr-fill:before { content: \"\\f232\"; }\r\n.ri-tumblr-line:before { content: \"\\f233\"; }\r\n.ri-tv-2-fill:before { content: \"\\f234\"; }\r\n.ri-tv-2-line:before { content: \"\\f235\"; }\r\n.ri-tv-fill:before { content: \"\\f236\"; }\r\n.ri-tv-line:before { content: \"\\f237\"; }\r\n.ri-twitch-fill:before { content: \"\\f238\"; }\r\n.ri-twitch-line:before { content: \"\\f239\"; }\r\n.ri-twitter-fill:before { content: \"\\f23a\"; }\r\n.ri-twitter-line:before { content: \"\\f23b\"; }\r\n.ri-typhoon-fill:before { content: \"\\f23c\"; }\r\n.ri-typhoon-line:before { content: \"\\f23d\"; }\r\n.ri-u-disk-fill:before { content: \"\\f23e\"; }\r\n.ri-u-disk-line:before { content: \"\\f23f\"; }\r\n.ri-ubuntu-fill:before { content: \"\\f240\"; }\r\n.ri-ubuntu-line:before { content: \"\\f241\"; }\r\n.ri-umbrella-fill:before { content: \"\\f242\"; }\r\n.ri-umbrella-line:before { content: \"\\f243\"; }\r\n.ri-underline:before { content: \"\\f244\"; }\r\n.ri-uninstall-fill:before { content: \"\\f245\"; }\r\n.ri-uninstall-line:before { content: \"\\f246\"; }\r\n.ri-unsplash-fill:before { content: \"\\f247\"; }\r\n.ri-unsplash-line:before { content: \"\\f248\"; }\r\n.ri-upload-2-fill:before { content: \"\\f249\"; }\r\n.ri-upload-2-line:before { content: \"\\f24a\"; }\r\n.ri-upload-cloud-2-fill:before { content: \"\\f24b\"; }\r\n.ri-upload-cloud-2-line:before { content: \"\\f24c\"; }\r\n.ri-upload-cloud-fill:before { content: \"\\f24d\"; }\r\n.ri-upload-cloud-line:before { content: \"\\f24e\"; }\r\n.ri-upload-fill:before { content: \"\\f24f\"; }\r\n.ri-upload-line:before { content: \"\\f250\"; }\r\n.ri-usb-fill:before { content: \"\\f251\"; }\r\n.ri-usb-line:before { content: \"\\f252\"; }\r\n.ri-user-2-fill:before { content: \"\\f253\"; }\r\n.ri-user-2-line:before { content: \"\\f254\"; }\r\n.ri-user-3-fill:before { content: \"\\f255\"; }\r\n.ri-user-3-line:before { content: \"\\f256\"; }\r\n.ri-user-4-fill:before { content: \"\\f257\"; }\r\n.ri-user-4-line:before { content: \"\\f258\"; }\r\n.ri-user-5-fill:before { content: \"\\f259\"; }\r\n.ri-user-5-line:before { content: \"\\f25a\"; }\r\n.ri-user-6-fill:before { content: \"\\f25b\"; }\r\n.ri-user-6-line:before { content: \"\\f25c\"; }\r\n.ri-user-add-fill:before { content: \"\\f25d\"; }\r\n.ri-user-add-line:before { content: \"\\f25e\"; }\r\n.ri-user-fill:before { content: \"\\f25f\"; }\r\n.ri-user-follow-fill:before { content: \"\\f260\"; }\r\n.ri-user-follow-line:before { content: \"\\f261\"; }\r\n.ri-user-heart-fill:before { content: \"\\f262\"; }\r\n.ri-user-heart-line:before { content: \"\\f263\"; }\r\n.ri-user-line:before { content: \"\\f264\"; }\r\n.ri-user-location-fill:before { content: \"\\f265\"; }\r\n.ri-user-location-line:before { content: \"\\f266\"; }\r\n.ri-user-received-2-fill:before { content: \"\\f267\"; }\r\n.ri-user-received-2-line:before { content: \"\\f268\"; }\r\n.ri-user-received-fill:before { content: \"\\f269\"; }\r\n.ri-user-received-line:before { content: \"\\f26a\"; }\r\n.ri-user-search-fill:before { content: \"\\f26b\"; }\r\n.ri-user-search-line:before { content: \"\\f26c\"; }\r\n.ri-user-settings-fill:before { content: \"\\f26d\"; }\r\n.ri-user-settings-line:before { content: \"\\f26e\"; }\r\n.ri-user-shared-2-fill:before { content: \"\\f26f\"; }\r\n.ri-user-shared-2-line:before { content: \"\\f270\"; }\r\n.ri-user-shared-fill:before { content: \"\\f271\"; }\r\n.ri-user-shared-line:before { content: \"\\f272\"; }\r\n.ri-user-smile-fill:before { content: \"\\f273\"; }\r\n.ri-user-smile-line:before { content: \"\\f274\"; }\r\n.ri-user-star-fill:before { content: \"\\f275\"; }\r\n.ri-user-star-line:before { content: \"\\f276\"; }\r\n.ri-user-unfollow-fill:before { content: \"\\f277\"; }\r\n.ri-user-unfollow-line:before { content: \"\\f278\"; }\r\n.ri-user-voice-fill:before { content: \"\\f279\"; }\r\n.ri-user-voice-line:before { content: \"\\f27a\"; }\r\n.ri-video-add-fill:before { content: \"\\f27b\"; }\r\n.ri-video-add-line:before { content: \"\\f27c\"; }\r\n.ri-video-chat-fill:before { content: \"\\f27d\"; }\r\n.ri-video-chat-line:before { content: \"\\f27e\"; }\r\n.ri-video-download-fill:before { content: \"\\f27f\"; }\r\n.ri-video-download-line:before { content: \"\\f280\"; }\r\n.ri-video-fill:before { content: \"\\f281\"; }\r\n.ri-video-line:before { content: \"\\f282\"; }\r\n.ri-video-upload-fill:before { content: \"\\f283\"; }\r\n.ri-video-upload-line:before { content: \"\\f284\"; }\r\n.ri-vidicon-2-fill:before { content: \"\\f285\"; }\r\n.ri-vidicon-2-line:before { content: \"\\f286\"; }\r\n.ri-vidicon-fill:before { content: \"\\f287\"; }\r\n.ri-vidicon-line:before { content: \"\\f288\"; }\r\n.ri-vimeo-fill:before { content: \"\\f289\"; }\r\n.ri-vimeo-line:before { content: \"\\f28a\"; }\r\n.ri-vip-crown-2-fill:before { content: \"\\f28b\"; }\r\n.ri-vip-crown-2-line:before { content: \"\\f28c\"; }\r\n.ri-vip-crown-fill:before { content: \"\\f28d\"; }\r\n.ri-vip-crown-line:before { content: \"\\f28e\"; }\r\n.ri-vip-diamond-fill:before { content: \"\\f28f\"; }\r\n.ri-vip-diamond-line:before { content: \"\\f290\"; }\r\n.ri-vip-fill:before { content: \"\\f291\"; }\r\n.ri-vip-line:before { content: \"\\f292\"; }\r\n.ri-virus-fill:before { content: \"\\f293\"; }\r\n.ri-virus-line:before { content: \"\\f294\"; }\r\n.ri-visa-fill:before { content: \"\\f295\"; }\r\n.ri-visa-line:before { content: \"\\f296\"; }\r\n.ri-voice-recognition-fill:before { content: \"\\f297\"; }\r\n.ri-voice-recognition-line:before { content: \"\\f298\"; }\r\n.ri-voiceprint-fill:before { content: \"\\f299\"; }\r\n.ri-voiceprint-line:before { content: \"\\f29a\"; }\r\n.ri-volume-down-fill:before { content: \"\\f29b\"; }\r\n.ri-volume-down-line:before { content: \"\\f29c\"; }\r\n.ri-volume-mute-fill:before { content: \"\\f29d\"; }\r\n.ri-volume-mute-line:before { content: \"\\f29e\"; }\r\n.ri-volume-off-vibrate-fill:before { content: \"\\f29f\"; }\r\n.ri-volume-off-vibrate-line:before { content: \"\\f2a0\"; }\r\n.ri-volume-up-fill:before { content: \"\\f2a1\"; }\r\n.ri-volume-up-line:before { content: \"\\f2a2\"; }\r\n.ri-volume-vibrate-fill:before { content: \"\\f2a3\"; }\r\n.ri-volume-vibrate-line:before { content: \"\\f2a4\"; }\r\n.ri-vuejs-fill:before { content: \"\\f2a5\"; }\r\n.ri-vuejs-line:before { content: \"\\f2a6\"; }\r\n.ri-walk-fill:before { content: \"\\f2a7\"; }\r\n.ri-walk-line:before { content: \"\\f2a8\"; }\r\n.ri-wallet-2-fill:before { content: \"\\f2a9\"; }\r\n.ri-wallet-2-line:before { content: \"\\f2aa\"; }\r\n.ri-wallet-3-fill:before { content: \"\\f2ab\"; }\r\n.ri-wallet-3-line:before { content: \"\\f2ac\"; }\r\n.ri-wallet-fill:before { content: \"\\f2ad\"; }\r\n.ri-wallet-line:before { content: \"\\f2ae\"; }\r\n.ri-water-flash-fill:before { content: \"\\f2af\"; }\r\n.ri-water-flash-line:before { content: \"\\f2b0\"; }\r\n.ri-webcam-fill:before { content: \"\\f2b1\"; }\r\n.ri-webcam-line:before { content: \"\\f2b2\"; }\r\n.ri-wechat-2-fill:before { content: \"\\f2b3\"; }\r\n.ri-wechat-2-line:before { content: \"\\f2b4\"; }\r\n.ri-wechat-fill:before { content: \"\\f2b5\"; }\r\n.ri-wechat-line:before { content: \"\\f2b6\"; }\r\n.ri-wechat-pay-fill:before { content: \"\\f2b7\"; }\r\n.ri-wechat-pay-line:before { content: \"\\f2b8\"; }\r\n.ri-weibo-fill:before { content: \"\\f2b9\"; }\r\n.ri-weibo-line:before { content: \"\\f2ba\"; }\r\n.ri-whatsapp-fill:before { content: \"\\f2bb\"; }\r\n.ri-whatsapp-line:before { content: \"\\f2bc\"; }\r\n.ri-wheelchair-fill:before { content: \"\\f2bd\"; }\r\n.ri-wheelchair-line:before { content: \"\\f2be\"; }\r\n.ri-wifi-fill:before { content: \"\\f2bf\"; }\r\n.ri-wifi-line:before { content: \"\\f2c0\"; }\r\n.ri-wifi-off-fill:before { content: \"\\f2c1\"; }\r\n.ri-wifi-off-line:before { content: \"\\f2c2\"; }\r\n.ri-window-2-fill:before { content: \"\\f2c3\"; }\r\n.ri-window-2-line:before { content: \"\\f2c4\"; }\r\n.ri-window-fill:before { content: \"\\f2c5\"; }\r\n.ri-window-line:before { content: \"\\f2c6\"; }\r\n.ri-windows-fill:before { content: \"\\f2c7\"; }\r\n.ri-windows-line:before { content: \"\\f2c8\"; }\r\n.ri-windy-fill:before { content: \"\\f2c9\"; }\r\n.ri-windy-line:before { content: \"\\f2ca\"; }\r\n.ri-wireless-charging-fill:before { content: \"\\f2cb\"; }\r\n.ri-wireless-charging-line:before { content: \"\\f2cc\"; }\r\n.ri-women-fill:before { content: \"\\f2cd\"; }\r\n.ri-women-line:before { content: \"\\f2ce\"; }\r\n.ri-wubi-input:before { content: \"\\f2cf\"; }\r\n.ri-xbox-fill:before { content: \"\\f2d0\"; }\r\n.ri-xbox-line:before { content: \"\\f2d1\"; }\r\n.ri-xing-fill:before { content: \"\\f2d2\"; }\r\n.ri-xing-line:before { content: \"\\f2d3\"; }\r\n.ri-youtube-fill:before { content: \"\\f2d4\"; }\r\n.ri-youtube-line:before { content: \"\\f2d5\"; }\r\n.ri-zcool-fill:before { content: \"\\f2d6\"; }\r\n.ri-zcool-line:before { content: \"\\f2d7\"; }\r\n.ri-zhihu-fill:before { content: \"\\f2d8\"; }\r\n.ri-zhihu-line:before { content: \"\\f2d9\"; }\r\n.ri-zoom-in-fill:before { content: \"\\f2da\"; }\r\n.ri-zoom-in-line:before { content: \"\\f2db\"; }\r\n.ri-zoom-out-fill:before { content: \"\\f2dc\"; }\r\n.ri-zoom-out-line:before { content: \"\\f2dd\"; }\r\n.ri-zzz-fill:before { content: \"\\f2de\"; }\r\n.ri-zzz-line:before { content: \"\\f2df\"; }\r\n\r\n","/*\r\nTemplate Name: Velzon - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 2.0.0\r\nWebsite: https://Themesbrand.com/\r\nContact: Themesbrand@gmail.com\r\nFile: Custom Bootstrap Css File\r\n*/\r\n\r\n\r\n//Core files\r\n@import \"./node_modules/bootstrap/scss/functions\";\r\n@import \"./node_modules/bootstrap/scss/variables\";\r\n@import \"variables\";\r\n@import \"./node_modules/bootstrap/scss/bootstrap\";\r\n\r\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.2.3 (https://getbootstrap.com/)\n   * Copyright 2011-2022 The Bootstrap Authors\n   * Copyright 2011-2022 Twitter, Inc.\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{$font-family-base};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  --#{$prefix}body-color: #{$body-color};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n  --#{$prefix}body-bg: #{$body-bg};\n  // scss-docs-end root-body-variables\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-2xl: #{$border-radius-2xl};\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n\n  --#{$prefix}code-color: #{$code-color};\n\n  --#{$prefix}highlight-bg: #{$mark-bg};\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: var(--#{$prefix}link-color);\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: var(--#{$prefix}link-hover-color);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');\r\n//\r\n// custom-variables\r\n//\r\n\r\n// Prefix for :root CSS variables\r\n\r\n$variable-prefix:             vz-; // Deprecated in v5.2.0 for the shorter `$prefix`\r\n$prefix:                      $variable-prefix;\r\n\r\n// Font Family\r\n$font-family-primary:                             'Open Sans', sans-serif;\r\n$font-family-secondary:                           'Open Sans', sans-serif;\r\n\r\n//\r\n// Vertical Menu\r\n//\r\n$vertical-menu-width:                             250px;\r\n$vertical-menu-width-md:                          180px;\r\n$vertical-menu-width-sm:                          70px;\r\n\r\n// Light Menu\r\n$vertical-menu-bg:                                var(--#{$prefix}vertical-menu-bg);\r\n$vertical-menu-box-shadow:                        0 2px 4px rgba(15,34,58,0.12);\r\n$vertical-menu-border:                            $white;\r\n$vertical-menu-z-index:                           1002;\r\n$vertical-menu-item-font-size:                    0.9375rem;\r\n$vertical-menu-item-font-family:                  $font-family-secondary;\r\n$vertical-menu-item-color:                        var(--#{$prefix}vertical-menu-item-color);\r\n$vertical-menu-item-hover-color:                  var(--#{$prefix}vertical-menu-item-hover-color);\r\n$vertical-menu-item-active-color:                 var(--#{$prefix}vertical-menu-item-active-color);\r\n$vertical-menu-item-padding-x:                    1.5rem;\r\n$vertical-menu-item-padding-y:                    0.625rem;\r\n$vertical-menu-sub-item-font-size:                0.813rem;\r\n$vertical-menu-sub-item-font-family:              $font-family-primary;\r\n$vertical-menu-sub-item-color:                    var(--#{$prefix}vertical-menu-sub-item-color);\r\n$vertical-menu-sub-item-hover-color:              var(--#{$prefix}vertical-menu-sub-item-hover-color);\r\n$vertical-menu-sub-item-active-color:             var(--#{$prefix}vertical-menu-sub-item-active-color);\r\n$vertical-menu-sub-item-padding-x:                1.5rem;\r\n$vertical-menu-sub-item-padding-y:                0.55rem;\r\n$vertical-menu-dropdown-box-shadow:               0 2px 4px rgba(15,34,58,0.12);\r\n$vertical-menu-title-color:                       var(--#{$prefix}vertical-menu-title-color);\r\n$vertical-menu-item-icon-width:                   1.75rem;\r\n\r\n// Dark Menu\r\n$vertical-menu-bg-dark:                         var(--#{$prefix}vertical-menu-bg-dark);\r\n$vertical-menu-border-dark:                     var(--#{$prefix}vertical-menu-bg-dark);\r\n$vertical-menu-item-color-dark:                 var(--#{$prefix}vertical-menu-item-color-dark);\r\n$vertical-menu-item-hover-color-dark:           var(--#{$prefix}vertical-menu-item-hover-color-dark);\r\n$vertical-menu-item-active-color-dark:          var(--#{$prefix}vertical-menu-item-active-color-dark);\r\n$vertical-menu-sub-item-color-dark:             var(--#{$prefix}vertical-menu-sub-item-color-dark);\r\n$vertical-menu-sub-item-hover-color-dark:       var(--#{$prefix}vertical-menu-sub-item-hover-color-dark);\r\n$vertical-menu-sub-item-active-color-dark:      var(--#{$prefix}vertical-menu-sub-item-active-color-dark);\r\n$vertical-menu-title-color-dark:                var(--#{$prefix}vertical-menu-title-color-dark);\r\n\r\n// vertical gradient Menu\r\n$vertical-menu-bg-gradient:                         var(--#{$prefix}vertical-menu-bg-gradient);\r\n$vertical-menu-border-gradient:                     var(--#{$prefix}vertical-menu-border-gradient);\r\n$vertical-menu-item-color-gradient:                 rgba($white, 0.5);\r\n$vertical-menu-sub-item-color-gradient:             rgba($white, 0.5);\r\n$vertical-menu-title-color-gradient:                rgba($white, 0.5);\r\n\r\n//\r\n// Horizontal Menu\r\n//\r\n$horizontal-menu-box-shadow:                       0 2px 4px rgba(15,34,58,0.12);\r\n$horizontal-menu-dropdown-box-shadow:              0 0px 5px rgba(15,34,58,0.15);\r\n$horizontal-menu-dropdown-min-width:               12rem; \r\n$horizontal-menu-item-padding-x:                   1.5rem;\r\n$horizontal-menu-item-padding-y:                   0.75rem;\r\n\r\n//\r\n// Two Column Menu\r\n//\r\n$twocolumn-menu-iconview-bg:                       var(--#{$prefix}twocolumn-menu-iconview-bg);\r\n$twocolumn-menu-bg:                                var(--#{$prefix}twocolumn-menu-bg);\r\n$twocolumn-menu-iconview-width:                    70px;\r\n$twocolumn-menu-width:                             220px;\r\n$twocolumn-menu-box-shadow:                        0 2px 4px rgba(15,34,58,0.12);\r\n$twocolumn-menu-z-index:                           1002;\r\n// dark\r\n$twocolumn-menu-iconview-bg-dark:                 var(--#{$prefix}twocolumn-menu-iconview-bg-dark);\r\n$twocolumn-menu-bg-dark:                          var(--#{$prefix}twocolumn-menu-bg-dark);\r\n$twocolumn-menu-border-dark:                      var(--#{$prefix}twocolumn-menu-bg-dark);\r\n$twocolumn-menu-item-color-dark:                  var(--#{$prefix}twocolumn-menu-item-color-dark);\r\n$twocolumn-menu-item-active-color-dark:           var(--#{$prefix}twocolumn-menu-item-active-color-dark);\r\n$twocolumn-menu-item-active-bg-dark:              var(--#{$prefix}twocolumn-menu-item-active-bg-dark);\r\n\r\n// gradient Menu\r\n$twocolumn-menu-item-color-gradient:              rgba($white, 0.6);\r\n\r\n// Topbar - (Default Light)\r\n$header-height:                                    70px;\r\n$header-bg:                                       var(--#{$prefix}header-bg);\r\n$header-item-color:                               var(--#{$prefix}header-item-color);\r\n\r\n// Topbar - Dark\r\n$header-bg-dark:                                 var(--#{$prefix}header-bg-dark);\r\n$header-item-color-dark:                         var(--#{$prefix}header-item-color-dark); \r\n\r\n// Topbar Search\r\n$topbar-search-bg:                                var(--#{$prefix}topbar-search-bg);\r\n$page-title-box-shadow:                           0 1px 2px rgba(56,65,74,0.15);\r\n$page-title-border:                               none;\r\n\r\n// Topbar User\r\n$topbar-user-bg: var(--#{$prefix}topbar-user-bg);\r\n$topbar-user-bg-dark: var(--#{$prefix}topbar-user-bg-dark);\r\n\r\n// Footer\r\n$footer-height: 60px;\r\n$footer-bg: var(--#{$prefix}footer-bg);\r\n$footer-color: var(--#{$prefix}footer-color);\r\n\r\n// Horizontal nav\r\n$topnav-bg:   var(--#{$prefix}topnav-bg);\r\n$topnav-item-color:   var(--#{$prefix}topnav-item-color);\r\n$topnav-item-color-active:   var(--#{$prefix}topnav-item-color-active);\r\n\r\n// Brand \r\n$navbar-brand-box-width: 240px;\r\n\r\n// Boxed layout width\r\n$boxed-layout-width:    1300px;\r\n$boxed-body-bg:         var(--#{$prefix}boxed-body-bg);\r\n\r\n// Font Weight\r\n$font-weight-medium: 500;\r\n\r\n// heading\r\n$heading-color: var(--#{$prefix}heading-color);\r\n$heading-font-family:         $font-family-primary;\r\n\r\n// Chat\r\n$chat-primary-bg:       var(--#{$prefix}light);\r\n$chat-secondary-bg:    rgba(var(--#{$prefix}success-rgb), 0.15);\r\n$chat-secondary-color:  var(--#{$prefix}success);\r\n\r\n// Timeline\r\n$timeline-color:   var(--#{$prefix}card-bg-custom);     \r\n\r\n//auth pages\r\n$auth-bg-cover: linear-gradient(-45deg, $primary 50%, $success);\r\n\r\n// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n// Color system\r\n\r\n// scss-docs-start gray-color-variables\r\n$white:    #fff;\r\n$gray-100: #f3f6f9;\r\n$gray-200: #eff2f7;\r\n$gray-300: #e9ebec;\r\n$gray-400: #ced4da;\r\n$gray-500: #adb5bd;\r\n$gray-600: #878a99;\r\n$gray-700: #495057;\r\n$gray-800: #343a40;\r\n$gray-900: #212529;\r\n$black:    #000;\r\n\r\n// fusv-disable\r\n// scss-docs-start gray-colors-map\r\n$grays: (\r\n  \"100\": $gray-100,\r\n  \"200\": $gray-200,\r\n  \"300\": $gray-300,\r\n  \"400\": $gray-400,\r\n  \"500\": $gray-500,\r\n  \"600\": $gray-600,\r\n  \"700\": $gray-700,\r\n  \"800\": $gray-800,\r\n  \"900\": $gray-900\r\n);\r\n// scss-docs-end gray-colors-map\r\n// fusv-enable\r\n\r\n// scss-docs-start color-variables\r\n$blue:       #3577f1;\r\n$indigo:     #405189;\r\n$purple:     #6559cc;\r\n$pink:       #f672a7;\r\n$red:        #f06548;\r\n$orange:     #f1963b;\r\n$yellow:     #f7b84b;\r\n$green:      #0ab39c;\r\n$teal:       #02a8b5;\r\n$cyan:       #299cdb;\r\n// scss-docs-end color-variables\r\n\r\n// scss-docs-start colors-map\r\n$colors: (\r\n  \"blue\":       $blue,\r\n  \"indigo\":     $indigo,\r\n  \"purple\":     $purple,\r\n  \"pink\":       $pink,\r\n  \"red\":        $red,\r\n  \"orange\":     $orange,\r\n  \"yellow\":     $yellow,\r\n  \"green\":      $green,\r\n  \"teal\":       $teal,\r\n  \"cyan\":       $cyan,\r\n  \"white\":      $white,\r\n  \"gray\":       $gray-600,\r\n  \"gray-dark\":  $gray-800\r\n);\r\n// scss-docs-end colors-map\r\n\r\n// scss-docs-start theme-color-variables\r\n$primary:       $indigo;\r\n$secondary:     $blue;\r\n$success:       $green;\r\n$info:          $cyan;\r\n$warning:       $yellow;\r\n$danger:        $red;\r\n$light:         $gray-100;\r\n$dark:          $gray-900;\r\n// scss-docs-end theme-color-variables\r\n\r\n// scss-docs-start theme-colors-map\r\n$theme-colors: (\r\n  \"primary\":    $primary,\r\n  \"secondary\":  $secondary,\r\n  \"success\":    $success,\r\n  \"info\":       $info,\r\n  \"warning\":    $warning,\r\n  \"danger\":     $danger,\r\n  \"light\":      $light,\r\n  \"dark\":       $dark\r\n);\r\n// scss-docs-end theme-colors-map\r\n\r\n// scss-docs-start theme-colors-rgb\r\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\");\r\n// scss-docs-end theme-colors-rgb\r\n\r\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\r\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\r\n$min-contrast-ratio:   1.75;\r\n\r\n// Customize the light and dark text colors for use in our color contrast function.\r\n$color-contrast-dark:      $black;\r\n$color-contrast-light:     $white;\r\n\r\n// fusv-disable\r\n$blue-100: tint-color($blue, 80%);\r\n$blue-200: tint-color($blue, 60%);\r\n$blue-300: tint-color($blue, 40%);\r\n$blue-400: tint-color($blue, 20%);\r\n$blue-500: $blue;\r\n$blue-600: shade-color($blue, 20%);\r\n$blue-700: shade-color($blue, 40%);\r\n$blue-800: shade-color($blue, 60%);\r\n$blue-900: shade-color($blue, 80%);\r\n\r\n$indigo-100: tint-color($indigo, 80%);\r\n$indigo-200: tint-color($indigo, 60%);\r\n$indigo-300: tint-color($indigo, 40%);\r\n$indigo-400: tint-color($indigo, 20%);\r\n$indigo-500: $indigo;\r\n$indigo-600: shade-color($indigo, 20%);\r\n$indigo-700: shade-color($indigo, 40%);\r\n$indigo-800: shade-color($indigo, 60%);\r\n$indigo-900: shade-color($indigo, 80%);\r\n\r\n$purple-100: tint-color($purple, 80%);\r\n$purple-200: tint-color($purple, 60%);\r\n$purple-300: tint-color($purple, 40%);\r\n$purple-400: tint-color($purple, 20%);\r\n$purple-500: $purple;\r\n$purple-600: shade-color($purple, 20%);\r\n$purple-700: shade-color($purple, 40%);\r\n$purple-800: shade-color($purple, 60%);\r\n$purple-900: shade-color($purple, 80%);\r\n\r\n$pink-100: tint-color($pink, 80%);\r\n$pink-200: tint-color($pink, 60%);\r\n$pink-300: tint-color($pink, 40%);\r\n$pink-400: tint-color($pink, 20%);\r\n$pink-500: $pink;\r\n$pink-600: shade-color($pink, 20%);\r\n$pink-700: shade-color($pink, 40%);\r\n$pink-800: shade-color($pink, 60%);\r\n$pink-900: shade-color($pink, 80%);\r\n\r\n$red-100: tint-color($red, 80%);\r\n$red-200: tint-color($red, 60%);\r\n$red-300: tint-color($red, 40%);\r\n$red-400: tint-color($red, 20%);\r\n$red-500: $red;\r\n$red-600: shade-color($red, 20%);\r\n$red-700: shade-color($red, 40%);\r\n$red-800: shade-color($red, 60%);\r\n$red-900: shade-color($red, 80%);\r\n\r\n$orange-100: tint-color($orange, 80%);\r\n$orange-200: tint-color($orange, 60%);\r\n$orange-300: tint-color($orange, 40%);\r\n$orange-400: tint-color($orange, 20%);\r\n$orange-500: $orange;\r\n$orange-600: shade-color($orange, 20%);\r\n$orange-700: shade-color($orange, 40%);\r\n$orange-800: shade-color($orange, 60%);\r\n$orange-900: shade-color($orange, 80%);\r\n\r\n$yellow-100: tint-color($yellow, 80%);\r\n$yellow-200: tint-color($yellow, 60%);\r\n$yellow-300: tint-color($yellow, 40%);\r\n$yellow-400: tint-color($yellow, 20%);\r\n$yellow-500: $yellow;\r\n$yellow-600: shade-color($yellow, 20%);\r\n$yellow-700: shade-color($yellow, 40%);\r\n$yellow-800: shade-color($yellow, 60%);\r\n$yellow-900: shade-color($yellow, 80%);\r\n\r\n$green-100: tint-color($green, 80%);\r\n$green-200: tint-color($green, 60%);\r\n$green-300: tint-color($green, 40%);\r\n$green-400: tint-color($green, 20%);\r\n$green-500: $green;\r\n$green-600: shade-color($green, 20%);\r\n$green-700: shade-color($green, 40%);\r\n$green-800: shade-color($green, 60%);\r\n$green-900: shade-color($green, 80%);\r\n\r\n$teal-100: tint-color($teal, 80%);\r\n$teal-200: tint-color($teal, 60%);\r\n$teal-300: tint-color($teal, 40%);\r\n$teal-400: tint-color($teal, 20%);\r\n$teal-500: $teal;\r\n$teal-600: shade-color($teal, 20%);\r\n$teal-700: shade-color($teal, 40%);\r\n$teal-800: shade-color($teal, 60%);\r\n$teal-900: shade-color($teal, 80%);\r\n\r\n$cyan-100: tint-color($cyan, 80%);\r\n$cyan-200: tint-color($cyan, 60%);\r\n$cyan-300: tint-color($cyan, 40%);\r\n$cyan-400: tint-color($cyan, 20%);\r\n$cyan-500: $cyan;\r\n$cyan-600: shade-color($cyan, 20%);\r\n$cyan-700: shade-color($cyan, 40%);\r\n$cyan-800: shade-color($cyan, 60%);\r\n$cyan-900: shade-color($cyan, 80%);\r\n$blues: (\r\n  \"blue-100\": $blue-100,\r\n  \"blue-200\": $blue-200,\r\n  \"blue-300\": $blue-300,\r\n  \"blue-400\": $blue-400,\r\n  \"blue-500\": $blue-500,\r\n  \"blue-600\": $blue-600,\r\n  \"blue-700\": $blue-700,\r\n  \"blue-800\": $blue-800,\r\n  \"blue-900\": $blue-900\r\n);\r\n\r\n$indigos: (\r\n  \"indigo-100\": $indigo-100,\r\n  \"indigo-200\": $indigo-200,\r\n  \"indigo-300\": $indigo-300,\r\n  \"indigo-400\": $indigo-400,\r\n  \"indigo-500\": $indigo-500,\r\n  \"indigo-600\": $indigo-600,\r\n  \"indigo-700\": $indigo-700,\r\n  \"indigo-800\": $indigo-800,\r\n  \"indigo-900\": $indigo-900\r\n);\r\n\r\n$purples: (\r\n  \"purple-100\": $purple-200,\r\n  \"purple-200\": $purple-100,\r\n  \"purple-300\": $purple-300,\r\n  \"purple-400\": $purple-400,\r\n  \"purple-500\": $purple-500,\r\n  \"purple-600\": $purple-600,\r\n  \"purple-700\": $purple-700,\r\n  \"purple-800\": $purple-800,\r\n  \"purple-900\": $purple-900\r\n);\r\n\r\n$pinks: (\r\n  \"pink-100\": $pink-100,\r\n  \"pink-200\": $pink-200,\r\n  \"pink-300\": $pink-300,\r\n  \"pink-400\": $pink-400,\r\n  \"pink-500\": $pink-500,\r\n  \"pink-600\": $pink-600,\r\n  \"pink-700\": $pink-700,\r\n  \"pink-800\": $pink-800,\r\n  \"pink-900\": $pink-900\r\n);\r\n\r\n$reds: (\r\n  \"red-100\": $red-100,\r\n  \"red-200\": $red-200,\r\n  \"red-300\": $red-300,\r\n  \"red-400\": $red-400,\r\n  \"red-500\": $red-500,\r\n  \"red-600\": $red-600,\r\n  \"red-700\": $red-700,\r\n  \"red-800\": $red-800,\r\n  \"red-900\": $red-900\r\n);\r\n\r\n$oranges: (\r\n  \"orange-100\": $orange-100,\r\n  \"orange-200\": $orange-200,\r\n  \"orange-300\": $orange-300,\r\n  \"orange-400\": $orange-400,\r\n  \"orange-500\": $orange-500,\r\n  \"orange-600\": $orange-600,\r\n  \"orange-700\": $orange-700,\r\n  \"orange-800\": $orange-800,\r\n  \"orange-900\": $orange-900\r\n);\r\n\r\n$yellows: (\r\n  \"yellow-100\": $yellow-100,\r\n  \"yellow-200\": $yellow-200,\r\n  \"yellow-300\": $yellow-300,\r\n  \"yellow-400\": $yellow-400,\r\n  \"yellow-500\": $yellow-500,\r\n  \"yellow-600\": $yellow-600,\r\n  \"yellow-700\": $yellow-700,\r\n  \"yellow-800\": $yellow-800,\r\n  \"yellow-900\": $yellow-900\r\n);\r\n\r\n$greens: (\r\n  \"green-100\": $green-100,\r\n  \"green-200\": $green-200,\r\n  \"green-300\": $green-300,\r\n  \"green-400\": $green-400,\r\n  \"green-500\": $green-500,\r\n  \"green-600\": $green-600,\r\n  \"green-700\": $green-700,\r\n  \"green-800\": $green-800,\r\n  \"green-900\": $green-900\r\n);\r\n\r\n$teals: (\r\n  \"teal-100\": $teal-100,\r\n  \"teal-200\": $teal-200,\r\n  \"teal-300\": $teal-300,\r\n  \"teal-400\": $teal-400,\r\n  \"teal-500\": $teal-500,\r\n  \"teal-600\": $teal-600,\r\n  \"teal-700\": $teal-700,\r\n  \"teal-800\": $teal-800,\r\n  \"teal-900\": $teal-900\r\n);\r\n\r\n$cyans: (\r\n  \"cyan-100\": $cyan-100,\r\n  \"cyan-200\": $cyan-200,\r\n  \"cyan-300\": $cyan-300,\r\n  \"cyan-400\": $cyan-400,\r\n  \"cyan-500\": $cyan-500,\r\n  \"cyan-600\": $cyan-600,\r\n  \"cyan-700\": $cyan-700,\r\n  \"cyan-800\": $cyan-800,\r\n  \"cyan-900\": $cyan-900\r\n);\r\n// fusv-enable\r\n\r\n// Characters which are escaped by the escape-svg function\r\n$escaped-characters: (\r\n  (\"<\", \"%3c\"),\r\n  (\">\", \"%3e\"),\r\n  (\"#\", \"%23\"),\r\n  (\"(\", \"%28\"),\r\n  (\")\", \"%29\"),\r\n);\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret:                false;\r\n$enable-rounded:              true;\r\n$enable-shadows:              false;\r\n$enable-gradients:            false;\r\n$enable-transitions:          true;\r\n$enable-reduced-motion:       true;\r\n$enable-smooth-scroll:        true;\r\n$enable-grid-classes:         true;\r\n$enable-cssgrid:              false;\r\n$enable-button-pointers:      true;\r\n$enable-rfs:                  true;\r\n$enable-validation-icons:     true;\r\n$enable-negative-margins:     true;\r\n$enable-deprecation-messages: true;\r\n$enable-important-utilities:  true;\r\n\r\n// Gradient\r\n//\r\n// The gradient which is added to components if `$enable-gradients` is `true`\r\n// This gradient is also added to elements with `.bg-gradient`\r\n// scss-docs-start variable-gradient\r\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0));\r\n// scss-docs-end variable-gradient\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n// scss-docs-start spacer-variables-maps\r\n$spacer: 1rem;\r\n$spacers: (\r\n  0: 0,\r\n  1: $spacer * .25,\r\n  2: $spacer * .5,\r\n  3: $spacer,\r\n  4: $spacer * 1.5,\r\n  5: $spacer * 3,\r\n);\r\n\r\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\r\n// scss-docs-end spacer-variables-maps\r\n\r\n// Position\r\n//\r\n// Define the edge positioning anchors of the position utilities.\r\n\r\n// scss-docs-start position-map\r\n$position-values: (\r\n  0: 0,\r\n  50: 50%,\r\n  100: 100%\r\n);\r\n// scss-docs-end position-map\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg:                   #f3f3f9;\r\n$body-color:                $gray-900;\r\n$body-text-align:           null;\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-color:                              var(--#{$prefix}link-color);\r\n$link-decoration:                         underline;\r\n$link-shade-percentage:                   20%;\r\n$link-hover-color:                        var(--#{$prefix}link-hover-color);\r\n$link-hover-decoration:                   null;\r\n\r\n$stretched-link-pseudo-element:           after;\r\n$stretched-link-z-index:                  1;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom:   1rem;\r\n\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n// scss-docs-start grid-breakpoints\r\n$grid-breakpoints: (\r\n  xs: 0,\r\n  sm: 576px,\r\n  md: 768px,\r\n  lg: 992px,\r\n  xl: 1200px,\r\n  xxl: 1400px\r\n);\r\n// scss-docs-end grid-breakpoints\r\n\r\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\r\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\r\n\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n// scss-docs-start container-max-widths\r\n$container-max-widths: (\r\n  sm: 540px,\r\n  md: 720px,\r\n  lg: 960px,\r\n  xl: 1140px,\r\n  xxl: 1320px\r\n);\r\n// scss-docs-end container-max-widths\r\n\r\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\r\n\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns:                12;\r\n$grid-gutter-width:           1.5rem;\r\n$grid-row-columns:            6;\r\n\r\n// $gutters: $spacers;\r\n\r\n// Container padding\r\n\r\n$container-padding-x: $grid-gutter-width * 1;\r\n\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n// scss-docs-start border-variables\r\n$border-width:                1px;\r\n$border-widths: (\r\n  1: 1px,\r\n  2: 2px,\r\n  3: 3px,\r\n  4: 4px,\r\n  5: 5px\r\n);\r\n\r\n$border-style:                solid;\r\n$border-color-translucent:    rgba($black, .175);\r\n$border-color:                var(--#{$prefix}border-color);\r\n// scss-docs-end border-variables\r\n\r\n// scss-docs-start border-radius-variables\r\n$border-radius:               .25rem;\r\n$border-radius-sm:            .2rem;\r\n$border-radius-lg:            .3rem;\r\n$border-radius-xl:            1rem;\r\n$border-radius-2xl:           2rem;\r\n$border-radius-pill:          50rem;\r\n// scss-docs-end border-radius-variables\r\n\r\n// scss-docs-start box-shadow-variables\r\n$box-shadow:                  0 1px 2px rgba(56,65,74,0.15);\r\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075);\r\n$box-shadow-lg:               0 5px 10px rgba(30, 32, 37, 0.12);\r\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075);\r\n$element-shadow:              none;\r\n// scss-docs-end box-shadow-variables\r\n\r\n$component-active-color:      $white;\r\n$component-active-bg:         $primary;\r\n\r\n// scss-docs-start caret-variables\r\n$caret-width:                 .3em;\r\n$caret-vertical-align:        $caret-width * .85;\r\n$caret-spacing:               $caret-width * .85;\r\n// scss-docs-end caret-variables\r\n\r\n$transition-base:             all .2s ease-in-out;\r\n$transition-fade:             opacity .15s linear;\r\n// scss-docs-start collapse-transition\r\n$transition-collapse:         height .35s ease;\r\n$transition-collapse-width:   width .35s ease;\r\n// scss-docs-end collapse-transition\r\n\r\n// stylelint-disable function-disallowed-list\r\n// scss-docs-start aspect-ratios\r\n$aspect-ratios: (\r\n  \"1x1\": 100%,\r\n  \"4x3\": calc(3 / 4 * 100%),\r\n  \"16x9\": calc(9 / 16 * 100%),\r\n  \"21x9\": calc(9 / 21 * 100%)\r\n);\r\n// scss-docs-end aspect-ratios\r\n// stylelint-enable function-disallowed-list\r\n\r\n// Typography\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// scss-docs-start font-variables\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif:      $font-family-primary;\r\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n// stylelint-enable value-keyword-case\r\n$font-family-base:            var(--#{$prefix}font-sans-serif);\r\n$font-family-code:            var(--#{$prefix}font-monospace);\r\n\r\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\r\n// $font-size-base affects the font size of the body text\r\n$font-size-root:              null;\r\n$font-size-base:              0.8125rem; // Assumes the browser default, typically `16px`\r\n$font-size-sm:                $font-size-base * .875;\r\n$font-size-lg:                $font-size-base * 1.25;\r\n\r\n$font-weight-lighter:         lighter;\r\n$font-weight-light:           300;\r\n$font-weight-normal:          400;\r\n$font-weight-semibold:        600;\r\n$font-weight-bold:            700;\r\n$font-weight-bolder:          bolder;\r\n\r\n$font-weight-base:            $font-weight-normal;\r\n\r\n$line-height-base:            1.5;\r\n$line-height-sm:              1.25;\r\n$line-height-lg:              2;\r\n\r\n$h1-font-size:                $font-size-base * 2.5;\r\n$h2-font-size:                $font-size-base * 2;\r\n$h3-font-size:                $font-size-base * 1.75;\r\n$h4-font-size:                $font-size-base * 1.5;\r\n$h5-font-size:                $font-size-base * 1.25;\r\n$h6-font-size:                $font-size-base;\r\n// scss-docs-end font-variables\r\n\r\n// scss-docs-start font-sizes\r\n$font-sizes: (\r\n  1: $h1-font-size,\r\n  2: $h2-font-size,\r\n  3: $h3-font-size,\r\n  4: $h4-font-size,\r\n  5: $h5-font-size,\r\n  6: $h6-font-size\r\n);\r\n// scss-docs-end font-sizes\r\n\r\n// scss-docs-start headings-variables\r\n$headings-margin-bottom:      $spacer * .5;\r\n$headings-font-family:        null;\r\n$headings-font-style:         null;\r\n$headings-font-weight:        500;\r\n$headings-line-height:        1.2;\r\n$headings-color:              null;\r\n// scss-docs-end headings-variables\r\n\r\n// scss-docs-start display-headings\r\n$display-font-sizes: (\r\n  1: 5rem,\r\n  2: 4.5rem,\r\n  3: 4rem,\r\n  4: 3.5rem,\r\n  5: 3rem,\r\n  6: 2.5rem\r\n);\r\n\r\n$display-font-family: null;\r\n$display-font-style:  null;\r\n$display-font-weight: 300;\r\n$display-line-height: $headings-line-height;\r\n// scss-docs-end display-headings\r\n\r\n// scss-docs-start type-variables\r\n$lead-font-size:              $font-size-base * 1.25;\r\n$lead-font-weight:            300;\r\n\r\n$small-font-size:             .875em;\r\n\r\n$sub-sup-font-size:           .75em;\r\n\r\n$text-muted:                  $gray-600;\r\n\r\n$initialism-font-size:        $small-font-size;\r\n\r\n$blockquote-margin-y:         $spacer;\r\n$blockquote-font-size:        $font-size-base * 1.1;\r\n$blockquote-footer-color:     $gray-600;\r\n$blockquote-footer-font-size: $small-font-size;\r\n\r\n$hr-margin-y:                 $spacer;\r\n$hr-color:                    inherit;\r\n// fusv-disable\r\n$hr-bg-color:                 null; // Deprecated in v5.2.0\r\n$hr-height:                   $border-width;\r\n// fusv-enable\r\n$hr-border-color:             null; // Allows for inherited colors\r\n$hr-border-width:             $border-width;\r\n$hr-opacity:                  .25;\r\n\r\n$legend-margin-bottom:        .5rem;\r\n$legend-font-size:            1.5rem;\r\n$legend-font-weight:          null;\r\n\r\n$mark-padding:                .2em;\r\n\r\n$dt-font-weight:              $font-weight-semibold;\r\n\r\n$list-inline-padding:         .5rem;\r\n\r\n$mark-bg:                     #fcf8e3;\r\n// scss-docs-end type-variables\r\n\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n// scss-docs-start table-variables\r\n$table-cell-padding-y:        .75rem;\r\n$table-cell-padding-x:        .6rem;\r\n$table-cell-padding-y-sm:     .3rem;\r\n$table-cell-padding-x-sm:     .25rem;\r\n\r\n$table-cell-vertical-align:   top;\r\n\r\n$table-color:                 var(--#{$prefix}body-color);\r\n$table-bg:                    transparent;\r\n$table-accent-bg:             transparent;\r\n\r\n$table-th-font-weight:        null;\r\n\r\n$table-striped-color:         $table-color;\r\n$table-striped-bg-factor:     .02;\r\n$table-striped-bg:            rgba(var(--#{$prefix}dark-rgb), $table-striped-bg-factor);\r\n\r\n$table-active-color:          $table-color;\r\n$table-active-bg-factor:      1;\r\n$table-active-bg:             rgba(var(--#{$prefix}light-rgb), $table-active-bg-factor);\r\n\r\n$table-hover-color:           $table-color;\r\n$table-hover-bg-factor:       1;\r\n$table-hover-bg:              rgba(var(--#{$prefix}light-rgb), $table-hover-bg-factor);\r\n\r\n$table-border-factor:         .1;\r\n$table-border-width:          $border-width;\r\n$table-border-color:          $border-color;\r\n\r\n$table-striped-order:         odd;\r\n$table-striped-columns-order: even;\r\n\r\n$table-group-separator-color: $border-color;\r\n\r\n$table-caption-color:         $text-muted;\r\n\r\n$table-bg-scale:              -80%;\r\n// scss-docs-end table-variables\r\n\r\n// scss-docs-start table-loop\r\n$table-variants: (\r\n  \"primary\":    shift-color($primary, $table-bg-scale),\r\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\r\n  \"success\":    shift-color($success, $table-bg-scale),\r\n  \"info\":       shift-color($info, $table-bg-scale),\r\n  \"warning\":    shift-color($warning, $table-bg-scale),\r\n  \"danger\":     shift-color($danger, $table-bg-scale),\r\n  \"light\":      $light,\r\n  \"dark\":       $dark,\r\n);\r\n// scss-docs-end table-loop\r\n\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n// scss-docs-start input-btn-variables\r\n$input-btn-padding-y:         .5rem;\r\n$input-btn-padding-x:         .9rem;\r\n$input-btn-font-family:       null;\r\n$input-btn-font-size:         $font-size-base;\r\n$input-btn-line-height:       $line-height-base;\r\n\r\n$input-btn-focus-width:         0;\r\n$input-btn-focus-color-opacity: .25;\r\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity);\r\n$input-btn-focus-blur:          0;\r\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color;\r\n\r\n$input-btn-padding-y-sm:      .25rem;\r\n$input-btn-padding-x-sm:      .5rem;\r\n$input-btn-font-size-sm:      $font-size-sm;\r\n\r\n$input-btn-padding-y-lg:      .7rem;\r\n$input-btn-padding-x-lg:      1.2rem;\r\n$input-btn-font-size-lg:      $font-size-lg;\r\n\r\n$input-btn-border-width:      $border-width;\r\n// scss-docs-end input-btn-variables\r\n\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n// scss-docs-start btn-variables\r\n$btn-padding-y:               $input-btn-padding-y;\r\n$btn-padding-x:               $input-btn-padding-x;\r\n$btn-font-family:             $input-btn-font-family;\r\n$btn-font-size:               $input-btn-font-size;\r\n$btn-line-height:             $input-btn-line-height;\r\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\r\n\r\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\r\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\r\n$btn-font-size-sm:            $input-btn-font-size-sm;\r\n\r\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\r\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\r\n$btn-font-size-lg:            $input-btn-font-size-lg;\r\n\r\n$btn-border-width:            $input-btn-border-width;\r\n\r\n$btn-font-weight:             $font-weight-normal;\r\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075);\r\n$btn-focus-width:             $input-btn-focus-width;\r\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow;\r\n$btn-disabled-opacity:        .65;\r\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125);\r\n\r\n$btn-link-color:              $link-color;\r\n$btn-link-hover-color:        $link-hover-color;\r\n$btn-link-disabled-color:     $gray-600;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius:           $border-radius;\r\n$btn-border-radius-sm:        $border-radius-sm;\r\n$btn-border-radius-lg:        $border-radius-lg;\r\n\r\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n\r\n$btn-hover-bg-shade-amount:       15%;\r\n$btn-hover-bg-tint-amount:        15%;\r\n$btn-hover-border-shade-amount:   20%;\r\n$btn-hover-border-tint-amount:    10%;\r\n$btn-active-bg-shade-amount:      20%;\r\n$btn-active-bg-tint-amount:       20%;\r\n$btn-active-border-shade-amount:  25%;\r\n$btn-active-border-tint-amount:   10%;\r\n// scss-docs-end btn-variables\r\n\r\n\r\n// Forms\r\n\r\n// scss-docs-start form-text-variables\r\n$form-text-margin-top:                  .25rem;\r\n$form-text-font-size:                   $small-font-size;\r\n$form-text-font-style:                  null;\r\n$form-text-font-weight:                 null;\r\n$form-text-color:                       $text-muted;\r\n// scss-docs-end form-text-variables\r\n\r\n// scss-docs-start form-label-variables\r\n$form-label-margin-bottom:              .5rem;\r\n$form-label-font-size:                  null;\r\n$form-label-font-style:                 null;\r\n$form-label-font-weight:                null;\r\n$form-label-color:                      null;\r\n// scss-docs-end form-label-variables\r\n\r\n// scss-docs-start form-input-variables\r\n$input-padding-y:                       $input-btn-padding-y;\r\n$input-padding-x:                       $input-btn-padding-x;\r\n$input-font-family:                     $input-btn-font-family;\r\n$input-font-size:                       $input-btn-font-size;\r\n$input-font-weight:                     $font-weight-base;\r\n$input-line-height:                     $input-btn-line-height;\r\n\r\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\r\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\r\n$input-font-size-sm:                    $input-btn-font-size-sm;\r\n\r\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\r\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\r\n$input-font-size-lg:                    $input-btn-font-size-lg;\r\n\r\n$input-bg:                              var(--#{$prefix}input-bg);\r\n$input-disabled-color:                  null;\r\n$input-disabled-bg:                     var(--#{$prefix}input-disabled-bg);\r\n$input-disabled-border-color:           null;\r\n\r\n$input-color:                           var(--#{$prefix}body-color);\r\n$input-border-color:                    var(--#{$prefix}input-border);\r\n$input-border-width:                    $input-btn-border-width;\r\n$input-box-shadow:                      $box-shadow-inset;\r\n\r\n$input-border-radius:                   $border-radius;\r\n$input-border-radius-sm:                $border-radius-sm;\r\n$input-border-radius-lg:                $border-radius-lg;\r\n\r\n$input-focus-bg:                        $input-bg;\r\n$input-focus-border-color:              var(--#{$prefix}input-focus-border);\r\n$input-focus-color:                     $input-color;\r\n$input-focus-width:                     $input-btn-focus-width;\r\n$input-focus-box-shadow:                $input-btn-focus-box-shadow;\r\n\r\n$input-placeholder-color:               $gray-600;\r\n$input-plaintext-color:                 var(--#{$prefix}body-color);\r\n\r\n$input-height-border:                   $input-border-width * 2;\r\n\r\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2);\r\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y);\r\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5);\r\n\r\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\r\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\r\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\r\n\r\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n$form-color-width:                      3rem;\r\n// scss-docs-end form-input-variables\r\n\r\n// scss-docs-start form-check-variables\r\n$form-check-input-width:                  1.1em;\r\n$form-check-min-height:                   $font-size-base * $line-height-base;\r\n$form-check-padding-start:                $form-check-input-width + .5em;\r\n$form-check-margin-bottom:                .125rem;\r\n$form-check-label-color:                  null;\r\n$form-check-label-cursor:                 null;\r\n$form-check-transition:                   null;\r\n\r\n$form-check-input-active-filter:          brightness(90%);\r\n\r\n$form-check-input-bg:                     $input-bg;\r\n$form-check-input-border:                 1px solid var(--#{$prefix}input-check-border);\r\n$form-check-input-border-radius:          .25em;\r\n$form-check-radio-border-radius:          50%;\r\n$form-check-input-focus-border:           $input-focus-border-color;\r\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow;\r\n\r\n$form-check-input-checked-color:          $component-active-color;\r\n$form-check-input-checked-bg-color:       $component-active-bg;\r\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color;\r\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\r\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\r\n\r\n$form-check-input-indeterminate-color:          $component-active-color;\r\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\r\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\r\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\r\n\r\n$form-check-input-disabled-opacity:        .5;\r\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity;\r\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity;\r\n\r\n$form-check-inline-margin-end:    1rem;\r\n// scss-docs-end form-check-variables\r\n\r\n// scss-docs-start form-switch-variables\r\n$form-switch-color:               rgba(0, 0, 0, .25);\r\n$form-switch-width:               2em;\r\n$form-switch-padding-start:       $form-switch-width + .5em;\r\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\r\n$form-switch-border-radius:       $form-switch-width;\r\n$form-switch-transition:          background-position .15s ease-in-out;\r\n\r\n$form-switch-focus-color:         tint-color($component-active-bg, 50%);\r\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\r\n\r\n$form-switch-checked-color:       $component-active-color;\r\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\r\n$form-switch-checked-bg-position: right center;\r\n// scss-docs-end form-switch-variables\r\n\r\n// scss-docs-start input-group-variables\r\n$input-group-addon-padding-y:           $input-padding-y;\r\n$input-group-addon-padding-x:           $input-padding-x;\r\n$input-group-addon-font-weight:         $input-font-weight;\r\n$input-group-addon-color:               $input-color;\r\n$input-group-addon-bg:                  var(--#{$prefix}input-group-addon-bg);\r\n$input-group-addon-border-color:        $input-border-color;\r\n// scss-docs-end input-group-variables\r\n\r\n// scss-docs-start form-select-variables\r\n$form-select-padding-y:             $input-padding-y;\r\n$form-select-padding-x:             $input-padding-x;\r\n$form-select-font-family:           $input-font-family;\r\n$form-select-font-size:             $input-font-size;\r\n$form-select-indicator-padding:     $form-select-padding-x * 3; // Extra padding for background-image\r\n$form-select-font-weight:           $input-font-weight;\r\n$form-select-line-height:           $input-line-height;\r\n$form-select-color:                 $input-color;\r\n$form-select-bg:                    $input-bg;\r\n$form-select-disabled-color:        null;\r\n$form-select-disabled-bg:           $input-disabled-bg;\r\n$form-select-disabled-border-color: $input-disabled-border-color;\r\n$form-select-bg-position:           right $form-select-padding-x center;\r\n$form-select-bg-size:               16px 12px; // In pixels because image dimensions\r\n$form-select-indicator-color:       $gray-800;\r\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\r\n\r\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding;\r\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding;\r\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half;\r\n\r\n$form-select-border-width:        $input-border-width;\r\n$form-select-border-color:        $input-border-color;\r\n$form-select-border-radius:       $border-radius;\r\n$form-select-box-shadow:          $box-shadow-inset;\r\n\r\n$form-select-focus-border-color:  $input-focus-border-color;\r\n$form-select-focus-width:         $input-focus-width;\r\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color;\r\n\r\n$form-select-padding-y-sm:        $input-padding-y-sm;\r\n$form-select-padding-x-sm:        $input-padding-x-sm;\r\n$form-select-font-size-sm:        $input-font-size-sm;\r\n$form-select-border-radius-sm:    $input-border-radius-sm;\r\n\r\n$form-select-padding-y-lg:        $input-padding-y-lg;\r\n$form-select-padding-x-lg:        $input-padding-x-lg;\r\n$form-select-font-size-lg:        $input-font-size-lg;\r\n$form-select-border-radius-lg:    $input-border-radius-lg;\r\n\r\n$form-select-transition:          $input-transition;\r\n// scss-docs-end form-select-variables\r\n\r\n// scss-docs-start form-range-variables\r\n$form-range-track-width:          100%;\r\n$form-range-track-height:         .5rem;\r\n$form-range-track-cursor:         pointer;\r\n$form-range-track-bg:             var(--#{$prefix}gray-300);\r\n$form-range-track-border-radius:  1rem;\r\n$form-range-track-box-shadow:     $box-shadow-inset;\r\n\r\n$form-range-thumb-width:                   1rem;\r\n$form-range-thumb-height:                  $form-range-thumb-width;\r\n$form-range-thumb-bg:                      $component-active-bg;\r\n$form-range-thumb-border:                  0;\r\n$form-range-thumb-border-radius:           1rem;\r\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\r\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\r\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in Edge\r\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%);\r\n$form-range-thumb-disabled-bg:             $gray-500;\r\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n// scss-docs-end form-range-variables\r\n\r\n// scss-docs-start form-file-variables\r\n$form-file-button-color:          $input-color;\r\n$form-file-button-bg:             $input-group-addon-bg;\r\n$form-file-button-hover-bg:       $input-group-addon-bg;\r\n// scss-docs-end form-file-variables\r\n\r\n// scss-docs-start form-floating-variables\r\n$form-floating-height:            add(3.5rem, $input-height-border);\r\n$form-floating-line-height:       1.25;\r\n$form-floating-padding-x:         $input-padding-x;\r\n$form-floating-padding-y:         1rem;\r\n$form-floating-input-padding-t:   1.625rem;\r\n$form-floating-input-padding-b:   .625rem;\r\n$form-floating-label-opacity:     .65;\r\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem);\r\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out;\r\n// scss-docs-end form-floating-variables\r\n\r\n// Form validation\r\n\r\n// scss-docs-start form-feedback-variables\r\n$form-feedback-margin-top:          $form-text-margin-top;\r\n$form-feedback-font-size:           $form-text-font-size;\r\n$form-feedback-font-style:          $form-text-font-style;\r\n$form-feedback-valid-color:         $success;\r\n$form-feedback-invalid-color:       $danger;\r\n\r\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\r\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\r\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\r\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\r\n// scss-docs-end form-feedback-variables\r\n\r\n// scss-docs-start form-validation-states\r\n$form-validation-states: (\r\n  \"valid\": (\r\n    \"color\": $form-feedback-valid-color,\r\n    \"icon\": $form-feedback-icon-valid\r\n  ),\r\n  \"invalid\": (\r\n    \"color\": $form-feedback-invalid-color,\r\n    \"icon\": $form-feedback-icon-invalid\r\n  )\r\n);\r\n// scss-docs-end form-validation-states\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n// scss-docs-start zindex-stack\r\n$zindex-dropdown:                   1000;\r\n$zindex-sticky:                     1020;\r\n$zindex-fixed:                      1030;\r\n$zindex-offcanvas-backdrop:         1040;\r\n$zindex-offcanvas:                  1045;\r\n$zindex-modal-backdrop:             1050;\r\n$zindex-modal:                      1055;\r\n$zindex-popover:                    1070;\r\n$zindex-tooltip:                    1080;\r\n$zindex-toast:                      1090;\r\n// scss-docs-end zindex-stack\r\n\r\n\r\n// Navs\r\n\r\n// scss-docs-start nav-variables\r\n$nav-link-padding-y:                .5rem;\r\n$nav-link-padding-x:                1rem;\r\n$nav-link-font-size:                null;\r\n$nav-link-font-weight:              null;\r\n$nav-link-color:                    $link-color;\r\n$nav-link-hover-color:              $link-hover-color;\r\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\r\n$nav-link-disabled-color:           $gray-600;\r\n\r\n$nav-tabs-border-color:             var(--#{$prefix}gray-300);\r\n$nav-tabs-border-width:             $border-width;\r\n$nav-tabs-border-radius:            $border-radius;\r\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}gray-300) var(--#{$prefix}gray-300) $nav-tabs-border-color;\r\n$nav-tabs-link-active-color:        $gray-700;\r\n$nav-tabs-link-active-bg:           var(--#{$prefix}nav-tabs-link-active-bg);\r\n$nav-tabs-link-active-border-color: var(--#{$prefix}gray-300) var(--#{$prefix}gray-300) $nav-tabs-link-active-bg;\r\n\r\n$nav-pills-border-radius:           $border-radius;\r\n$nav-pills-link-active-color:       $component-active-color;\r\n$nav-pills-link-active-bg:          $component-active-bg;\r\n// scss-docs-end nav-variables\r\n\r\n\r\n// Navbar\r\n\r\n// scss-docs-start navbar-variables\r\n$navbar-padding-y:                  $spacer * .5;\r\n$navbar-padding-x:                  null;\r\n\r\n$navbar-nav-link-padding-x:         .5rem;\r\n\r\n$navbar-brand-font-size:            $font-size-lg;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\r\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\r\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5;\r\n$navbar-brand-margin-end:           1rem;\r\n\r\n$navbar-toggler-padding-y:          .25rem;\r\n$navbar-toggler-padding-x:          .75rem;\r\n$navbar-toggler-font-size:          $font-size-lg;\r\n$navbar-toggler-border-radius:      $btn-border-radius;\r\n$navbar-toggler-focus-width:        $btn-focus-width;\r\n$navbar-toggler-transition:         box-shadow .15s ease-in-out;\r\n// scss-docs-end navbar-variables\r\n\r\n// scss-docs-start navbar-theme-variables\r\n$navbar-dark-color:                 rgba($white, .55);\r\n$navbar-dark-hover-color:           rgba($white, .75);\r\n$navbar-dark-active-color:          $white;\r\n$navbar-dark-disabled-color:        rgba($white, .25);\r\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n$navbar-dark-toggler-border-color:  rgba($white, .1);\r\n\r\n$navbar-light-color:                rgba($black, .55);\r\n$navbar-light-hover-color:          rgba($black, .7);\r\n$navbar-light-active-color:         rgba($black, .9);\r\n$navbar-light-disabled-color:       rgba($black, .3);\r\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n$navbar-light-toggler-border-color: rgba($black, .1);\r\n\r\n$navbar-light-brand-color:                $navbar-light-active-color;\r\n$navbar-light-brand-hover-color:          $navbar-light-active-color;\r\n$navbar-dark-brand-color:                 $navbar-dark-active-color;\r\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color;\r\n// scss-docs-end navbar-theme-variables\r\n\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n// scss-docs-start dropdown-variables\r\n$dropdown-min-width:                10rem;\r\n$dropdown-padding-x:                0;\r\n$dropdown-padding-y:                .5rem;\r\n$dropdown-spacer:                   .125rem;\r\n$dropdown-font-size:                $font-size-base;\r\n$dropdown-color:                    var(--#{$prefix}body-color);\r\n$dropdown-bg:                       $white;\r\n$dropdown-border-color:             var(--#{$prefix}border-color);\r\n$dropdown-border-radius:            $border-radius-lg;\r\n$dropdown-border-width:             0;\r\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width);\r\n$dropdown-divider-bg:               $dropdown-border-color;\r\n$dropdown-divider-margin-y:         $spacer * .5;\r\n$dropdown-box-shadow:               $box-shadow-lg;\r\n\r\n$dropdown-link-color:               $gray-900;\r\n$dropdown-link-hover-color:         #{shade-color($gray-900, 10%)};\r\n$dropdown-link-hover-bg:            $gray-100;\r\n\r\n$dropdown-link-active-color:        #{shade-color($gray-900, 10%)};\r\n$dropdown-link-active-bg:           $gray-100;\r\n\r\n$dropdown-link-disabled-color:      $gray-500;\r\n\r\n$dropdown-item-padding-y:           0.35rem;\r\n$dropdown-item-padding-x:           1.2rem;\r\n\r\n$dropdown-header-color:             $gray-600;\r\n$dropdown-header-padding-x:         $dropdown-item-padding-x;\r\n$dropdown-header-padding-y:         $dropdown-padding-y;\r\n// fusv-disable\r\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x; // Deprecated in v5.2.0\r\n// scss-docs-end dropdown-variables\r\n\r\n// scss-docs-start dropdown-dark-variables\r\n$dropdown-dark-color:               $gray-300;\r\n$dropdown-dark-bg:                  $gray-800;\r\n$dropdown-dark-border-color:        $dropdown-border-color;\r\n$dropdown-dark-divider-bg:          $dropdown-divider-bg;\r\n$dropdown-dark-box-shadow:          null;\r\n$dropdown-dark-link-color:          $dropdown-dark-color;\r\n$dropdown-dark-link-hover-color:    $white;\r\n$dropdown-dark-link-hover-bg:       rgba($white, .15);\r\n$dropdown-dark-link-active-color:   $white;\r\n$dropdown-dark-link-active-bg:      lighten($dropdown-dark-bg, 5%);\r\n$dropdown-dark-link-disabled-color: $gray-500;\r\n$dropdown-dark-header-color:        $gray-500;\r\n// scss-docs-end dropdown-dark-variables\r\n\r\n\r\n// Pagination\r\n\r\n// scss-docs-start pagination-variables\r\n$pagination-padding-y:              .375rem;\r\n$pagination-padding-x:              .75rem;\r\n$pagination-padding-y-sm:           .25rem;\r\n$pagination-padding-x-sm:           .5rem;\r\n$pagination-padding-y-lg:           .6rem;\r\n$pagination-padding-x-lg:           1.2rem;\r\n\r\n$pagination-font-size:              $font-size-base;\r\n$pagination-color:                  $link-color;\r\n$pagination-bg:                     var(--#{$prefix}card-bg-custom);\r\n$pagination-border-width:           $border-width;\r\n$pagination-border-radius:          $border-radius;\r\n$pagination-margin-start:           -$pagination-border-width;\r\n$pagination-border-color:           var(--#{$prefix}border-color);\r\n\r\n$pagination-focus-color:            $link-hover-color;\r\n$pagination-focus-bg:               $gray-200;\r\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow;\r\n$pagination-focus-outline:          0;\r\n\r\n$pagination-hover-color:            $link-hover-color;\r\n$pagination-hover-bg:               $gray-200;\r\n$pagination-hover-border-color:     var(--#{$prefix}border-color);\r\n\r\n$pagination-active-color:           $component-active-color;\r\n$pagination-active-bg:              $component-active-bg;\r\n$pagination-active-border-color:    $pagination-active-bg;\r\n\r\n$pagination-disabled-color:         $gray-600;\r\n$pagination-disabled-bg:            $pagination-bg;\r\n$pagination-disabled-border-color:  $pagination-border-color;\r\n\r\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n\r\n$pagination-border-radius-sm:       $border-radius-sm;\r\n$pagination-border-radius-lg:       $border-radius-lg;\r\n// scss-docs-end pagination-variables\r\n\r\n\r\n// Placeholders\r\n\r\n// scss-docs-start placeholders\r\n$placeholder-opacity-max:           .5;\r\n$placeholder-opacity-min:           .2;\r\n// scss-docs-end placeholders\r\n\r\n// Cards\r\n\r\n// scss-docs-start card-variables\r\n$card-spacer-y:                     $spacer;\r\n$card-spacer-x:                     $spacer;\r\n$card-title-spacer-y:               $spacer * .5;\r\n$card-border-width:                 0;\r\n$card-border-color:                 rgba($black, .125);\r\n$card-border-radius:                $border-radius;\r\n$card-box-shadow:                   $box-shadow;\r\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\r\n$card-cap-padding-y:                $card-spacer-y;\r\n$card-cap-padding-x:                $card-spacer-x;\r\n$card-cap-bg:                       $white;\r\n$card-cap-color:                    null;\r\n$card-height:                       null;\r\n$card-color:                        null;\r\n$card-bg:                           $white;\r\n$card-img-overlay-padding:          $spacer;\r\n$card-group-margin:                 $grid-gutter-width * .5;\r\n// scss-docs-end card-variables\r\n\r\n// Accordion\r\n\r\n// scss-docs-start accordion-variables\r\n$accordion-padding-y:                     1rem;\r\n$accordion-padding-x:                     1.25rem;\r\n$accordion-color:                         var(--#{$prefix}body-color);\r\n$accordion-bg:                            $white;\r\n$accordion-border-width:                  $border-width;\r\n$accordion-border-color:                  var(--#{$prefix}border-color);\r\n$accordion-border-radius:                 $border-radius;\r\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width);\r\n\r\n$accordion-body-padding-y:                $accordion-padding-y;\r\n$accordion-body-padding-x:                $accordion-padding-x;\r\n\r\n$accordion-button-padding-y:              $accordion-padding-y;\r\n$accordion-button-padding-x:              $accordion-padding-x;\r\n$accordion-button-color:                  $accordion-color;\r\n$accordion-button-bg:                     $accordion-bg;\r\n$accordion-transition:                    $btn-transition, border-radius .15s ease;\r\n$accordion-button-active-bg:              rgba($component-active-bg, 0.05);\r\n$accordion-button-active-color:           shade-color($primary, 10%);\r\n\r\n$accordion-button-focus-border-color:     $input-focus-border-color;\r\n$accordion-button-focus-box-shadow:       inset 0 ($accordion-border-width * -1) 0 $accordion-border-color;\r\n\r\n$accordion-icon-width:                    0.75rem;\r\n$accordion-icon-color:                    $accordion-color;\r\n$accordion-icon-active-color:             $accordion-button-active-color;\r\n$accordion-icon-transition:               transform .2s ease-in-out;\r\n$accordion-icon-transform:                rotate(-180deg);\r\n\r\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n// scss-docs-end accordion-variables\r\n\r\n// Tooltips\r\n\r\n// scss-docs-start tooltip-variables\r\n$tooltip-font-size:                 $font-size-sm;\r\n$tooltip-max-width:                 200px;\r\n$tooltip-color:                     $white;\r\n$tooltip-bg:                        $black;\r\n$tooltip-border-radius:             $border-radius-sm;\r\n$tooltip-opacity:                   .9;\r\n$tooltip-padding-y:                 $spacer * .4;\r\n$tooltip-padding-x:                 $spacer * .7;\r\n$tooltip-margin:                    0;\r\n\r\n$tooltip-arrow-width:               .8rem;\r\n$tooltip-arrow-height:              .4rem;\r\n$tooltip-arrow-color:               $tooltip-bg;\r\n// scss-docs-end tooltip-variables\r\n\r\n// Form tooltips must come after regular tooltips\r\n// scss-docs-start tooltip-feedback-variables\r\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\r\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\r\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\r\n$form-feedback-tooltip-line-height:   null;\r\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\r\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\r\n// scss-docs-end tooltip-feedback-variables\r\n\r\n\r\n// Popovers\r\n\r\n// scss-docs-start popover-variables\r\n$popover-font-size:                 $font-size-base;\r\n$popover-bg:                        $white;\r\n$popover-max-width:                 276px;\r\n$popover-border-width:              $border-width;\r\n$popover-border-color:              var(--#{$prefix}border-color);\r\n$popover-border-radius:             $border-radius;\r\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width);\r\n$popover-box-shadow:                $box-shadow-lg;\r\n\r\n$popover-header-font-size:          $font-size-base;\r\n$popover-header-bg:                 var(--#{$prefix}popover-bg);\r\n$popover-header-color:              $headings-color;\r\n$popover-header-padding-y:          .7rem;\r\n$popover-header-padding-x:          $spacer;\r\n\r\n$popover-body-color:                var(--#{$prefix}body-color);\r\n$popover-body-padding-y:            $spacer;\r\n$popover-body-padding-x:            $spacer;\r\n\r\n$popover-arrow-width:               1rem;\r\n$popover-arrow-height:              .5rem;\r\n$popover-arrow-color:               var(--#{$prefix}popover-bg);\r\n\r\n$popover-arrow-outer-color:         var(--#{$prefix}border-color);\r\n// scss-docs-end popover-variables\r\n\r\n\r\n// Toasts\r\n\r\n// scss-docs-start toast-variables\r\n$toast-max-width:                   350px;\r\n$toast-padding-x:                   .75rem;\r\n$toast-padding-y:                   .5rem;\r\n$toast-font-size:                   .875rem;\r\n$toast-color:                       null;\r\n$toast-background-color:            rgba($white, .85);\r\n$toast-border-width:                1px;\r\n$toast-border-color:                rgba($black, .1);\r\n$toast-border-radius:               $border-radius;\r\n$toast-box-shadow:                  $box-shadow;\r\n$toast-spacing:                     $container-padding-x;\r\n\r\n$toast-header-color:                $gray-600;\r\n$toast-header-background-color:     rgba($white, .85);\r\n$toast-header-border-color:         rgba($black, .05);\r\n// scss-docs-end toast-variables\r\n\r\n\r\n// Badges\r\n\r\n// scss-docs-start badge-variables\r\n$badge-font-size:                   .75em;\r\n$badge-font-weight:                 $font-weight-semibold;\r\n$badge-color:                       $white;\r\n$badge-padding-y:                   .35em;\r\n$badge-padding-x:                   .65em;\r\n$badge-border-radius:               $border-radius;\r\n// scss-docs-end badge-variables\r\n\r\n\r\n// Modals\r\n\r\n// scss-docs-start modal-variables\r\n$modal-inner-padding:               $spacer * 1.25;\r\n\r\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\r\n$modal-footer-margin-between:       .5rem;\r\n\r\n$modal-dialog-margin:               .5rem;\r\n$modal-dialog-margin-y-sm-up:       1.75rem;\r\n\r\n$modal-title-line-height:           $line-height-base;\r\n\r\n$modal-content-color:               null;\r\n$modal-content-bg:                  $white;\r\n$modal-content-border-color:        $border-color;\r\n$modal-content-border-width:        $border-width;\r\n$modal-content-border-radius:       $border-radius-lg;\r\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\r\n$modal-content-box-shadow-xs:       $box-shadow-sm;\r\n$modal-content-box-shadow-sm-up:    $box-shadow;\r\n\r\n$modal-backdrop-bg:                 $black;\r\n$modal-backdrop-opacity:            .5;\r\n$modal-header-border-color:         $border-color;\r\n$modal-footer-border-color:         $modal-header-border-color;\r\n$modal-header-border-width:         0;\r\n$modal-footer-border-width:         $modal-header-border-width;\r\n$modal-header-padding-y:            $modal-inner-padding;\r\n$modal-header-padding-x:            $modal-inner-padding;\r\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\r\n\r\n$modal-footer-bg:                   null;\r\n$modal-sm:                          400px;\r\n$modal-md:                          600px;\r\n$modal-lg:                          900px;\r\n$modal-xl:                          1240px;\r\n\r\n$modal-fade-transform:              translate(0, -50px);\r\n$modal-show-transform:              none;\r\n$modal-transition:                  transform .3s ease-out;\r\n$modal-scale-transform:             scale(1.02);\r\n// scss-docs-end modal-variables\r\n\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n// scss-docs-start alert-variables\r\n$alert-padding-y:               $spacer * 0.8;\r\n$alert-padding-x:               $spacer;\r\n$alert-margin-bottom:           1rem;\r\n$alert-border-radius:           $border-radius;\r\n$alert-link-font-weight:        $font-weight-semibold;\r\n$alert-border-width:            $border-width;\r\n$alert-bg-scale:                -85%;\r\n$alert-border-scale:            -70%;\r\n$alert-color-scale:             25%;\r\n$alert-dismissible-padding-r:   $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\r\n// scss-docs-end alert-variables\r\n\r\n\r\n// Progress bars\r\n\r\n// scss-docs-start progress-variables\r\n$progress-height:                   0.625rem;\r\n$progress-font-size:                $font-size-base * .75;\r\n$progress-bg:                       $gray-200;\r\n$progress-border-radius:            $border-radius;\r\n$progress-box-shadow:               $box-shadow-inset;\r\n$progress-bar-color:                $white;\r\n$progress-bar-bg:                   $primary;\r\n$progress-bar-animation-timing:     1s linear infinite;\r\n$progress-bar-transition:           width .6s ease;\r\n// scss-docs-end progress-variables\r\n\r\n\r\n// List group\r\n\r\n// scss-docs-start list-group-variables\r\n$list-group-color:                  var(--#{$prefix}body-color);\r\n$list-group-bg:                     var(--#{$prefix}card-bg-custom);\r\n$list-group-border-color:           var(--#{$prefix}border-color);\r\n$list-group-border-width:           $border-width;\r\n$list-group-border-radius:          $border-radius;\r\n\r\n$list-group-item-padding-y:         $spacer * .7;\r\n$list-group-item-padding-x:         $spacer;\r\n$list-group-item-bg-scale:          -80%;\r\n$list-group-item-color-scale:       40%;\r\n\r\n$list-group-hover-bg:               var(--#{$prefix}list-group-hover-bg);\r\n$list-group-active-color:           $component-active-color;\r\n$list-group-active-bg:              $component-active-bg;\r\n$list-group-active-border-color:    $list-group-active-bg;\r\n\r\n$list-group-disabled-color:         $gray-600;\r\n$list-group-disabled-bg:            $list-group-bg;\r\n\r\n$list-group-action-color:           var(--#{$prefix}body-color);\r\n$list-group-action-hover-color:     $list-group-action-color;\r\n\r\n$list-group-action-active-color:    var(--#{$prefix}body-color);\r\n$list-group-action-active-bg:       var(--#{$prefix}list-group-hover-bg);;\r\n// scss-docs-end list-group-variables\r\n\r\n\r\n// Image thumbnails\r\n\r\n// scss-docs-start thumbnail-variables\r\n$thumbnail-padding:                 .25rem;\r\n$thumbnail-bg:                      var(--#{$prefix}body-bg);\r\n$thumbnail-border-width:            $border-width;\r\n$thumbnail-border-color:            var(--#{$prefix}border-color);\r\n$thumbnail-border-radius:           $border-radius;\r\n$thumbnail-box-shadow:              $box-shadow-sm;\r\n// scss-docs-end thumbnail-variables\r\n\r\n\r\n// Figures\r\n\r\n// scss-docs-start figure-variables\r\n$figure-caption-font-size:          $small-font-size;\r\n$figure-caption-color:              $gray-600;\r\n// scss-docs-end figure-variables\r\n\r\n\r\n// Breadcrumbs\r\n\r\n// scss-docs-start breadcrumb-variables\r\n$breadcrumb-font-size:              null;\r\n$breadcrumb-padding-y:              0;\r\n$breadcrumb-padding-x:              0;\r\n$breadcrumb-item-padding-x:         .3rem;\r\n$breadcrumb-margin-bottom:          1rem;\r\n$breadcrumb-bg:                     null;\r\n$breadcrumb-divider-color:          $gray-600;\r\n$breadcrumb-active-color:           $gray-600;\r\n$breadcrumb-divider:                quote(\"\\F0142\");\r\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\r\n$breadcrumb-border-radius:          null;\r\n// scss-docs-end breadcrumb-variables\r\n\r\n// Carousel\r\n\r\n// scss-docs-start carousel-variables\r\n$carousel-control-color:             $white;\r\n$carousel-control-width:             15%;\r\n$carousel-control-opacity:           .5;\r\n$carousel-control-hover-opacity:     .9;\r\n$carousel-control-transition:        opacity .15s ease;\r\n\r\n$carousel-indicator-width:           30px;\r\n$carousel-indicator-height:          3px;\r\n$carousel-indicator-hit-area-height: 10px;\r\n$carousel-indicator-spacer:          3px;\r\n$carousel-indicator-opacity:         .5;\r\n$carousel-indicator-active-bg:       $white;\r\n$carousel-indicator-active-opacity:  1;\r\n$carousel-indicator-transition:      opacity .6s ease;\r\n\r\n$carousel-caption-width:             70%;\r\n$carousel-caption-color:             $white;\r\n$carousel-caption-padding-y:         1.25rem;\r\n$carousel-caption-spacer:            1.25rem;\r\n\r\n$carousel-control-icon-width:        2rem;\r\n\r\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\r\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\r\n\r\n$carousel-transition-duration:       .6s;\r\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\r\n\r\n$carousel-dark-indicator-active-bg:  $black;\r\n$carousel-dark-caption-color:        $black;\r\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100);\r\n// scss-docs-end carousel-variables\r\n\r\n\r\n// Spinners\r\n\r\n// scss-docs-start spinner-variables\r\n$spinner-width:           2rem;\r\n$spinner-height:          $spinner-width;\r\n$spinner-vertical-align:  -.125em;\r\n$spinner-border-width:    .25em;\r\n$spinner-animation-speed: .75s;\r\n\r\n$spinner-width-sm:        1rem;\r\n$spinner-height-sm:       $spinner-width-sm;\r\n$spinner-border-width-sm: .2em;\r\n// scss-docs-end spinner-variables\r\n\r\n\r\n// Close\r\n\r\n// scss-docs-start close-variables\r\n$btn-close-width:            1em;\r\n$btn-close-height:           $btn-close-width;\r\n$btn-close-padding-x:        .25em;\r\n$btn-close-padding-y:        $btn-close-padding-x;\r\n$btn-close-color:            $black;\r\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\r\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow;\r\n$btn-close-opacity:          .5;\r\n$btn-close-hover-opacity:    .75;\r\n$btn-close-focus-opacity:    1;\r\n$btn-close-disabled-opacity: .25;\r\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%);\r\n// scss-docs-end close-variables\r\n\r\n\r\n// Offcanvas\r\n\r\n// scss-docs-start offcanvas-variables\r\n$offcanvas-padding-y:               $modal-inner-padding;\r\n$offcanvas-padding-x:               $modal-inner-padding;\r\n$offcanvas-horizontal-width:        400px;\r\n$offcanvas-vertical-height:         30vh;\r\n$offcanvas-transition-duration:     .3s;\r\n$offcanvas-border-color:            $modal-content-border-color;\r\n$offcanvas-border-width:            $modal-content-border-width;\r\n$offcanvas-title-line-height:       $modal-title-line-height;\r\n$offcanvas-bg-color:                $modal-content-bg;\r\n$offcanvas-color:                   $modal-content-color;\r\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs;\r\n$offcanvas-backdrop-bg:             $modal-backdrop-bg;\r\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity;\r\n// scss-docs-end offcanvas-variables\r\n\r\n// Code\r\n\r\n$code-font-size:                    $small-font-size;\r\n$code-color:                        $pink;\r\n\r\n$kbd-padding-y:                     .2rem;\r\n$kbd-padding-x:                     .4rem;\r\n$kbd-font-size:                     $code-font-size;\r\n$kbd-color:                         $white;\r\n$kbd-bg:                            $gray-900;\r\n$nested-kbd-font-weight:            $font-weight-bold;; // Deprecated in v5.2.0, removing in v6\r\n\r\n$pre-color:                         null;\r\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: var(--#{$prefix}table-color);\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: ($table-border-width * 2) solid $table-group-separator-color;\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-accent-bg: var(--#{$prefix}table-active-bg);\n  color: var(--#{$prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-hover-bg);\n    color: var(--#{$prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: escape-svg($form-select-indicator);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: $form-check-input-bg;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-input-checked-bg-image);\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-radio-checked-bg-image);\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$prefix}gradient);\n    } @else {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: escape-svg($form-switch-bg-image);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-switch-checked-bg-image);\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: -$input-border-width;\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$body-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    background: none;\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == ($pagination-border-width * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $state, $value in $theme-colors {\n  $alert-background: shift-color($value, $alert-bg-scale);\n  $alert-border: shift-color($value, $alert-border-scale);\n  $alert-color: shift-color($value, $alert-color-scale);\n\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  }\n  .alert-#{$state} {\n    @include alert-variant($alert-background, $alert-border, $alert-color);\n  }\n}\n// scss-docs-end alert-modifiers\n","// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  --#{$prefix}alert-color: #{$color};\n  --#{$prefix}alert-bg: #{$background};\n  --#{$prefix}alert-border-color: #{$border};\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n\n  .alert-link {\n    color: shade-color($color, 20%);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $value in $theme-colors {\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\n  }\n\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\n}\n// scss-docs-end list-group-modifiers\n","// List Groups\n\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        color: $color;\n        background-color: shade-color($background, 10%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: $btn-close-color;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: $btn-close-opacity;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-close-focus-shadow;\n    opacity: $btn-close-focus-opacity;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.btn-close-white {\n  filter: $btn-close-white-filter;\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  padding: var(--#{$prefix}tooltip-arrow-height);\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: 0;\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: 0;\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(transform $offcanvas-transition-duration ease-in-out);\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: $offcanvas-title-line-height;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// stylelint-disable function-name-case\n\n// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  $color-rgb: to-rgb($value);\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA($color-rgb, var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value !important; // stylelint-disable-line declaration-no-important\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage)) !important; // stylelint-disable-line declaration-no-important\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*\r\nTemplate Name: Velzon - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 2.0.0\r\nWebsite: https://themesbrand.com/\r\nContact: support@themesbrand.com\r\nFile: Main Css File\r\n*/\r\n\r\n\r\n//Fonts\r\n@import \"../../fonts/fonts\";\r\n\r\n//Core files\r\n@import \"./node_modules/bootstrap/scss/functions\";\r\n@import \"./node_modules/bootstrap/scss/variables\";\r\n@import \"variables\";\r\n@import \"./node_modules/bootstrap/scss/mixins\";\r\n\r\n@import \"theme-light\";\r\n@import \"theme-dark\";\r\n\r\n// Structure\r\n@import \"../../structure/topbar\";\r\n@import \"../../structure/page-head\";\r\n@import \"../../structure/footer\";\r\n@import \"../../structure/vertical\";\r\n@import \"../../structure/horizontal\";\r\n@import \"../../structure/two-column\";\r\n@import \"../../structure/layouts\";\r\n\r\n// Components\r\n@import \"../../components/waves\";\r\n@import \"../../components/avatar\";\r\n@import \"../../components/accordion\";\r\n@import \"../../components/helper\";\r\n@import \"../../components/preloader\";\r\n@import \"../../components/forms\";\r\n@import \"../../components/widgets\";\r\n@import \"../../components/demos\";\r\n@import \"../../components/print\";\r\n@import \"../../components/ribbons\";\r\n@import \"../../components/toast\";\r\n@import \"../../components/scrollspy\";\r\n\r\n// Bootstrap components\r\n@import \"../../components/reboot\";\r\n@import \"../../components/alerts\";\r\n@import \"../../components/backgrounds\";\r\n@import \"../../components/badge\";\r\n@import \"../../components/buttons\";\r\n@import \"../../components/breadcrumb\";\r\n@import \"../../components/card\";\r\n@import \"../../components/dropdown\";\r\n@import \"../../components/nav\";\r\n@import \"../../components/table\";\r\n@import \"../../components/modal\";\r\n@import \"../../components/pagination\";\r\n@import \"../../components/progress\";\r\n@import \"../../components/popover\";\r\n@import \"../../components/type\";\r\n@import \"../../components/form-check\";\r\n@import \"../../components/form-control\";\r\n@import \"../../components/list-group\";\r\n\r\n// Plugins\r\n@import \"../../plugins/custom-scrollbar\";\r\n@import \"../../plugins/prismjs\";\r\n@import \"../../plugins/sweetalert2\";\r\n@import \"../../plugins/dropzone\";\r\n@import \"../../plugins/range-slider\";\r\n@import \"../../plugins/sortablejs\";\r\n@import \"../../plugins/tour\";\r\n@import \"../../plugins/swiper\";\r\n@import \"../../plugins/multijs\";\r\n@import \"../../plugins/colorpicker\";\r\n@import \"../../plugins/filepond\";\r\n@import \"../../plugins/form-input-spin\";\r\n@import \"../../plugins/ckeditor\";\r\n@import \"../../plugins/quilljs\";\r\n@import \"../../plugins/gridjs\";\r\n@import \"../../plugins/listjs\";\r\n@import \"../../plugins/apexcharts\";\r\n@import \"../../plugins/chartjs\";\r\n@import \"../../plugins/echarts\";\r\n@import \"../../plugins/google-map\";\r\n@import \"../../plugins/autocomplete\";\r\n@import \"../../plugins/vector-maps\";\r\n@import \"../../plugins/leaflet-maps\";\r\n@import \"../../plugins/fullcalendar\";\r\n@import \"../../plugins/emoji-picker\";\r\n@import \"../../plugins/datatables\";\r\n@import \"../../plugins/select2\";\r\n@import \"../../plugins/flag-input\";\r\n\r\n// Plugins\r\n@import \"../../plugins/toastify\";\r\n@import \"../../plugins/choices\";\r\n@import \"../../plugins/flatpicker\";\r\n\r\n// Pages\r\n@import \"../../pages/authentication\";\r\n@import \"../../pages/dashboard\";\r\n@import \"../../pages/timeline\";\r\n@import \"../../pages/gallery\";\r\n@import \"../../pages/errors\";\r\n@import \"../../pages/profile\";\r\n@import \"../../pages/sitemap\";\r\n@import \"../../pages/team\";\r\n@import \"../../pages/coming-soon\";\r\n@import \"../../pages/search-results\";\r\n@import \"../../pages/ecommerce\";\r\n@import \"../../pages/invoice\";\r\n@import \"../../pages/chat\";\r\n@import \"../../pages/email\";\r\n@import \"../../pages/kanban\";\r\n@import \"../../pages/landing\";\r\n@import \"../../pages/nft-landing\";\r\n@import \"../../pages/file-manager\";\r\n@import \"../../pages/to-do\";\r\n@import \"../../pages/jobs\";\r\n@import \"../../pages/job-landing\";","//\r\n// Google font - Poppins\r\n//\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');\r\n\r\n//\r\n// Premium Font : HKGrotesk\r\n//\r\n\r\n@font-face {\r\n    font-family: \"hkgrotesk\";\r\n    src: url(\"../../fonts/hkgrotesk-light.eot\");\r\n    src: local('hkgrotesk light'), url(\"../../fonts/hkgrotesk-light.woff\") format(\"woff\");\r\n    font-weight: 300;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"hkgrotesk\";\r\n    src: url(\"../../fonts/hkgrotesk-regular.eot\");\r\n    src: local('hkgrotesk regular'), url(\"../../fonts/hkgrotesk-regular.woff\") format(\"woff\");\r\n    font-weight: 400;\r\n}\r\n@font-face {\r\n    font-family: \"hkgrotesk\";\r\n    src: url(\"../../fonts/hkgrotesk-medium.eot\");\r\n    src: local('hkgrotesk medium'), url(\"../../fonts/hkgrotesk-medium.woff\") format(\"woff\");\r\n    font-weight: 500;\r\n}\r\n@font-face {\r\n    font-family: \"hkgrotesk\";\r\n    src: url(\"../../fonts/hkgrotesk-semibold.eot\");\r\n    src: local('hkgrotesk semibold'), url(\"../../fonts/hkgrotesk-semibold.woff\") format(\"woff\");\r\n    font-weight: 600;\r\n}\r\n@font-face {\r\n    font-family: \"hkgrotesk\";\r\n    // src: url(\"../../fonts/hkgrotesk-bold.eot\");\r\n    src: local('hkgrotesk bold'), url(\"../../fonts/hkgrotesk-bold.woff\") format(\"woff\");\r\n    font-weight: 700;\r\n}","// :root CSS variables\r\n\r\n:root{\r\n\r\n    //vertical light\r\n  --#{$prefix}vertical-menu-bg:                      #{$white};\r\n  --#{$prefix}vertical-menu-item-color:              #{darken($gray-600, 10%)};\r\n  --#{$prefix}vertical-menu-item-hover-color:        #{$primary};\r\n  --#{$prefix}vertical-menu-item-active-color:       #{$primary};\r\n  --#{$prefix}vertical-menu-sub-item-color:          #{darken($gray-600, 4%)};\r\n  --#{$prefix}vertical-menu-sub-item-hover-color:    #{$primary};\r\n  --#{$prefix}vertical-menu-sub-item-active-color:   #{$primary};\r\n  --#{$prefix}vertical-menu-title-color:             #919da9;\r\n  \r\n  //vertical dark\r\n  --#{$prefix}vertical-menu-bg-dark:                 #{$gray-900};\r\n  --#{$prefix}vertical-menu-item-color-dark:          #a3a6b7;\r\n  --#{$prefix}vertical-menu-item-hover-color-dark:    #{$white};\r\n  --#{$prefix}vertical-menu-item-active-color-dark:  #{$white};\r\n  --#{$prefix}vertical-menu-sub-item-color-dark:     #a3a6b7;\r\n  --#{$prefix}vertical-menu-sub-item-hover-color-dark: #{$white};\r\n  --#{$prefix}vertical-menu-sub-item-active-color-dark: #{$white};\r\n  --#{$prefix}vertical-menu-title-color-dark:         #{darken($gray-600, 10%)};\r\n\r\n\r\n  // Topbar - (Default Light)\r\n  --#{$prefix}header-bg:  #{$white};\r\n  --#{$prefix}header-item-color:  #e9ecef;\r\n  // Topbar - Dark\r\n  --#{$prefix}header-bg-dark:  #{$primary};\r\n  --#{$prefix}header-item-color-dark:  #b0c4d9;\r\n\r\n  // Topbar Search\r\n  --#{$prefix}topbar-search-bg: #f3f3f9;\r\n  // Topbar User\r\n  --#{$prefix}topbar-user-bg: #f3f3f9;\r\n  --#{$prefix}topbar-user-bg-dark: #52639c;\r\n\r\n  //footer\r\n  --#{$prefix}footer-bg: #{$white};\r\n  --#{$prefix}footer-color: #98a6ad;\r\n\r\n  // Horizontal nav\r\n  --#{$prefix}topnav-bg: #{$white};\r\n  --#{$prefix}topnav-item-color: #{darken($gray-600, 10%)};\r\n  --#{$prefix}topnav-item-color-active: #{$primary};\r\n\r\n  // twocolumn menu\r\n  --#{$prefix}twocolumn-menu-iconview-bg: #{$white};\r\n  --#{$prefix}twocolumn-menu-bg:  #{$white};\r\n  // two column dark\r\n  --#{$prefix}twocolumn-menu-iconview-bg-dark: var(--#{$prefix}vertical-menu-bg-dark);\r\n  --#{$prefix}twocolumn-menu-bg-dark:  #{lighten($primary, 2%)};\r\n  --#{$prefix}twocolumn-menu-item-color-dark: var(--#{$prefix}vertical-menu-item-color-dark);\r\n  --#{$prefix}twocolumn-menu-item-active-color-dark:  #{$white};\r\n  --#{$prefix}twocolumn-menu-item-active-bg-dark:  #{rgba($white, .15)};\r\n\r\n  // boxed \r\n  --#{$prefix}boxed-body-bg: #{darken($body-bg, 4%)};\r\n\r\n  // heading-color\r\n  --#{$prefix}heading-color: #{$gray-700};\r\n  \r\n  // component variable\r\n  // link\r\n  --#{$prefix}link-color: #{$primary};\r\n  --#{$prefix}link-hover-color: #{$primary};\r\n\r\n  // Border variable\r\n  --#{$prefix}border-color:  #{$gray-300};\r\n\r\n  // card\r\n  --#{$prefix}card-bg-custom: #{$white};\r\n  --#{$prefix}card-logo-dark: block;\r\n  --#{$prefix}card-logo-light: none;\r\n\r\n  // nav tabs\r\n  .nav-tabs {\r\n    --#{$prefix}nav-tabs-link-active-bg:           #{$body-bg};\r\n  }\r\n\r\n  //choices \r\n  .choices, .flatpickr-calendar, .ck, .ql-toolbar, .select2-container, .menu-dropdown{\r\n    --#{$prefix}choices-bg:                        #{$white};\r\n    --#{$prefix}choices-link-color:                #{$gray-900};\r\n    --#{$prefix}choices-link-hover-bg:             #{$gray-100};\r\n    --#{$prefix}choices-link-active-color:         #{shade-color($gray-900, 10%)};\r\n  }\r\n\r\n  //list\r\n  --#{$prefix}list-group-hover-bg: #{$gray-100};\r\n\r\n  // form\r\n  --#{$prefix}input-bg: #{$white};\r\n  --#{$prefix}input-border: #{$gray-400};\r\n  --#{$prefix}input-focus-border: #{tint-color($component-active-bg, 50%)};\r\n  --#{$prefix}input-disabled-bg: #{$gray-200};\r\n\r\n  // input-group-addon\r\n  --#{$prefix}input-group-addon-bg: #{$gray-200};\r\n\r\n  //check\r\n  --#{$prefix}input-check-border: var(--#{$prefix}input-border);\r\n}\r\n","// :root CSS dark variables\r\n\r\n\r\n[data-layout-mode=\"dark\"]{\r\n\r\n  // Color system - Dark Mode only\r\n  $gray-100: #1a1d21;\r\n  $gray-200: #212529;\r\n  $gray-300: #2a2f34;\r\n  $gray-400: #878a99;\r\n  $gray-500: #adb5bd;\r\n  $gray-600: #bfc8e2;\r\n  $gray-700: #ced4da;\r\n  $gray-800: #eff2f7;\r\n  $gray-900: #f3f6f9;\r\n  \r\n  $grays: (\r\n      \"100\": $gray-100,\r\n      \"200\": $gray-200,\r\n      \"300\": $gray-300,\r\n      \"400\": $gray-400,\r\n      \"500\": $gray-500,\r\n      \"600\": $gray-600,\r\n      \"700\": $gray-700,\r\n      \"800\": $gray-800,\r\n      \"900\": $gray-900\r\n  );\r\n\r\n  // Prefix for :root CSS variables\r\n  @each $color, $value in $grays {\r\n    --#{$prefix}gray-#{$color}: #{$value};\r\n  }\r\n\r\n  // body\r\n  --#{$prefix}body-bg :  #{$gray-100};\r\n  --#{$prefix}body-bg-rgb :  #{to-rgb($gray-100)};\r\n  --#{$prefix}body-color: #{$gray-700};\r\n  --#{$prefix}body-color-rgb: #{to-rgb($gray-700)};\r\n\r\n  //vertical light\r\n  --#{$prefix}vertical-menu-bg:                      #{$white};\r\n  --#{$prefix}vertical-menu-item-color:              #{darken($gray-400, 16%)};\r\n  --#{$prefix}vertical-menu-item-hover-color:        #{$primary};\r\n  --#{$prefix}vertical-menu-item-active-color:       #{$primary};\r\n  --#{$prefix}vertical-menu-sub-item-color:          #{darken($gray-400, 12%)};\r\n  --#{$prefix}vertical-menu-sub-item-hover-color:    #{$primary};\r\n  --#{$prefix}vertical-menu-sub-item-active-color:   #{$primary};\r\n  --#{$prefix}vertical-menu-title-color:             #{$gray-400};\r\n\r\n  //vertical dark\r\n  --#{$prefix}vertical-menu-bg-dark:                 #{$gray-200};\r\n  --#{$prefix}vertical-menu-item-color-dark:         #{$gray-400};\r\n  --#{$prefix}vertical-menu-item-hover-color-dark:   #{$white};\r\n  --#{$prefix}vertical-menu-item-active-color-dark:  #{$white};\r\n  --#{$prefix}vertical-menu-sub-item-color-dark:     #{darken($gray-400, 4%)};\r\n  --#{$prefix}vertical-menu-sub-item-hover-color-dark: #{$white};\r\n  --#{$prefix}vertical-menu-sub-item-active-color-dark: #{$white};\r\n  --#{$prefix}vertical-menu-title-color-dark:         #{darken($gray-400, 16%)};\r\n\r\n  // Topbar - (Default Light)\r\n  --#{$prefix}header-bg:  #292e32;\r\n  --#{$prefix}header-item-color:  #e9ecef;\r\n  // Topbar - Dark\r\n  --#{$prefix}header-bg-dark:  #{$primary};\r\n  --#{$prefix}header-item-color-dark:  #b0c4d9;\r\n\r\n  // Topbar Search\r\n  --#{$prefix}topbar-search-bg: #202328;\r\n  // Topbar User\r\n  --#{$prefix}topbar-user-bg: #{lighten($gray-300, 3%)};\r\n  --#{$prefix}topbar-user-bg-dark: #52639c;\r\n  \r\n  //footer\r\n  --#{$prefix}footer-bg: #{$gray-200};\r\n  --#{$prefix}footer-color: #{$gray-400};\r\n  \r\n  // Horizontal nav\r\n  --#{$prefix}topnav-bg: #{lighten($gray-200, 2.5%)};\r\n  --#{$prefix}topnav-item-color: #{$gray-400};\r\n  --#{$prefix}topnav-item-color-active: #{$white};\r\n  \r\n  // twocolumn menu\r\n  --#{$prefix}twocolumn-menu-iconview-bg: #{$white};\r\n  --#{$prefix}twocolumn-menu-bg:  #{$white};\r\n  \r\n  // two column dark\r\n  --#{$prefix}twocolumn-menu-iconview-bg-dark: var(--#{$prefix}vertical-menu-bg-dark);\r\n  --#{$prefix}twocolumn-menu-bg-dark:  #30363a;\r\n  --#{$prefix}twocolumn-menu-item-color-dark: var(--#{$prefix}vertical-menu-item-color-dark);\r\n  --#{$prefix}twocolumn-menu-item-active-color-dark:  #{$white};\r\n  --#{$prefix}twocolumn-menu-item-active-bg-dark:  #{rgba($white, .15)};\r\n  \r\n  // boxed \r\n  --#{$prefix}boxed-body-bg: #{darken($gray-100, 4%)};\r\n  \r\n  // heading-color\r\n  --#{$prefix}heading-color: #{$gray-700};\r\n  \r\n  // component variable\r\n  --#{$prefix}light: #{$gray-300};\r\n  --#{$prefix}light-rgb: #{to-rgb($gray-300)};\r\n  --#{$prefix}dark: #{$gray-800};\r\n  --#{$prefix}dark-rgb: #{to-rgb($gray-800)};\r\n  \r\n  // link\r\n  --#{$prefix}link-color: #{$gray-700};\r\n  --#{$prefix}link-hover-color: #{$gray-700};\r\n  \r\n  // Border variable\r\n  --#{$prefix}border-color:  #{lighten($gray-300, 3.5%)};\r\n  \r\n  // dropdown\r\n  .dropdown-menu {\r\n    --#{$prefix}dropdown-bg:                         #{lighten($gray-200, 3.5%)};\r\n    --#{$prefix}dropdown-link-color:                 #{$gray-500};\r\n    --#{$prefix}dropdown-link-hover-color:           #{shade-color($gray-700, 10%)};\r\n    --#{$prefix}dropdown-link-hover-bg:              #{lighten($gray-300, 2%)};\r\n    --#{$prefix}dropdown-border-width:               1px;\r\n    --#{$prefix}dropdown-link-active-color:          #{$gray-500};\r\n    --#{$prefix}dropdown-link-active-bg:             #{lighten($gray-300, 2%)};\r\n  }\r\n\r\n  //choices \r\n  .choices, .flatpickr-calendar, .ck, .ql-toolbar, .select2-container, .menu-dropdown {\r\n    --#{$prefix}choices-bg:                          #{lighten($gray-200, 3.5%)};\r\n    --#{$prefix}choices-link-color:                  #{$gray-500};\r\n    --#{$prefix}choices-link-hover-bg:               #{lighten($gray-300, 2%)};\r\n    --#{$prefix}choices-link-active-color:           #{shade-color($gray-900, 10%)};\r\n  }\r\n  \r\n  //buttons\r\n  .btn-light {\r\n    --#{$prefix}btn-color:                           var(--#{$prefix}dark);\r\n    --#{$prefix}btn-bg:                              var(--#{$prefix}light);\r\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}light);\r\n  }\r\n\r\n  .btn-outline-light {\r\n    --#{$prefix}btn-color:                           var(--#{$prefix}dark);\r\n    --#{$prefix}btn-bg:                              transparent;\r\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}light);\r\n  }\r\n  \r\n  .btn-light, .btn-outline-light {\r\n    --#{$prefix}btn-hover-color:                     var(--#{$prefix}dark);\r\n    --#{$prefix}btn-hover-bg:                        rgba(var(--#{$prefix}light-rgb), 0.75);\r\n    --#{$prefix}btn-hover-border-color:              rgba(var(--#{$prefix}light-rgb), 0.75);\r\n  }\r\n\r\n  .btn-dark {\r\n    --#{$prefix}btn-color:                           var(--#{$prefix}light);\r\n    --#{$prefix}btn-bg:                              var(--#{$prefix}dark);\r\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}dark);\r\n  }\r\n\r\n  .btn-outline-dark {\r\n    --#{$prefix}btn-color:                           var(--#{$prefix}dark);\r\n    --#{$prefix}btn-bg:                              transparent;\r\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}dark);\r\n  }\r\n\r\n  .btn-dark, .btn-outline-dark {\r\n    --#{$prefix}btn-hover-color:                     var(--#{$prefix}light);\r\n    --#{$prefix}btn-hover-bg:                        rgba(var(--#{$prefix}dark-rgb), 0.75);\r\n    --#{$prefix}btn-hover-border-color:              rgba(var(--#{$prefix}dark-rgb), 0.75);\r\n  }\r\n\r\n  // card\r\n  .card {\r\n    --#{$prefix}card-bg:                             #{$gray-200};\r\n    --#{$prefix}card-cap-bg:                         #{$gray-200};\r\n  }\r\n  \r\n  --#{$prefix}card-bg-custom:                        #{$gray-200};\r\n  --#{$prefix}card-logo-dark:                        none;\r\n  --#{$prefix}card-logo-light:                       block;\r\n  \r\n  // modal\r\n  .modal {\r\n    --#{$prefix}modal-bg:                            #{$gray-200};\r\n  }\r\n  \r\n  // nav tabs\r\n  .nav-tabs {\r\n    --#{$prefix}nav-tabs-link-active-color:          #{$gray-900};\r\n    --#{$prefix}nav-tabs-link-active-bg:             #{$gray-300};\r\n  }\r\n\r\n  // accordion\r\n  .accordion{\r\n    --#{$prefix}accordion-button-active-color:       #{$white};\r\n    --#{$prefix}accordion-bg:                        #{$gray-200};\r\n    --#{$prefix}accordion-btn-bg:                    #{$gray-200};\r\n  }\r\n  \r\n  //offcanvas\r\n  .offcanvas,\r\n  .offcanvas-lg,\r\n  .offcanvas-md,\r\n  .offcanvas-sm,\r\n  .offcanvas-xl,\r\n  .offcanvas-xxl {\r\n    --#{$prefix}offcanvas-bg:                        #{$gray-200};\r\n      \r\n  }\r\n\r\n  // progress\r\n  .progress{\r\n    --#{$prefix}progress-bg:                         #{$gray-300};\r\n  }\r\n\r\n  //table\r\n  .table {\r\n    --vz-table-striped-bg:                          #{rgba($white, .03)};\r\n    --vz-table-active-bg:                          #{rgba($white, .07)};\r\n    --vz-table-hover-bg:                          #{rgba($white, .07)};\r\n  }\r\n\r\n  .table-light{\r\n    --vz-table-color:                                #{$white};\r\n    --vz-table-bg:                                   #{rgba($white, .05)};\r\n    --vz-table-border-color:                         #{$border-color};\r\n    --vz-table-striped-bg:                           #{rgba($white, .07)};\r\n    --vz-table-striped-color:                        #{$white};\r\n  }\r\n\r\n  // toast\r\n  .toast {\r\n    --#{$prefix}toast-bg:                            #{rgba($gray-300, .85)};\r\n    --#{$prefix}toast-header-bg:                     #{rgba($gray-300, .85)};\r\n    --#{$prefix}toast-border-color:                  #{rgba($white, .1)};\r\n    --#{$prefix}toast-header-border-color:           #{rgba($white, .05)};\r\n  }\r\n\r\n  //list\r\n  --#{$prefix}list-group-hover-bg:                   #{lighten($gray-200, 2.5%)};\r\n\r\n  // popover\r\n  .popover{\r\n    --#{$prefix}popover-bg:                          #{lighten($gray-200, 1%)};\r\n  }\r\n\r\n  // pagination\r\n  .pagination{\r\n    --#{$prefix}pagination-hover-bg:                   #{lighten($gray-200, 4%)};\r\n    --#{$prefix}pagination-focus-bg:                   #{lighten($gray-200, 4%)};\r\n  }\r\n\r\n  //form\r\n  --#{$prefix}input-bg:                              #{lighten($gray-200, 2%)};\r\n  --#{$prefix}input-border:                          #{$gray-300};\r\n  --#{$prefix}input-focus-border:                    #{lighten($gray-300, 4%)};\r\n  --#{$prefix}input-disabled-bg:                     #{$gray-200};\r\n\r\n  // input-group-addon\r\n  --#{$prefix}input-group-addon-bg:                  #{$gray-300};\r\n\r\n  //check\r\n  --#{$prefix}input-check-border:                    #{lighten($gray-300, 4%)};\r\n}\r\n\r\n//sidebar color\r\n[data-sidebar=\"gradient\"] { \r\n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, var(--#{$prefix}primary), var(--#{$prefix}success));\r\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}success);\r\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}success);\r\n}\r\n\r\n[data-sidebar=\"gradient-2\"] { \r\n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}secondary));\r\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}secondary);\r\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}secondary);\r\n}\r\n\r\n[data-sidebar=\"gradient-3\"] { \r\n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}success));\r\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}success);\r\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}success);\r\n}\r\n\r\n[data-sidebar=\"gradient-4\"] { \r\n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, #1a1d21, var(--#{$prefix}primary));\r\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}primary);\r\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}primary);\r\n}","//\r\n// _topbar.scss\r\n//\r\n\r\n#page-topbar {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    left: 0;\r\n    z-index: 1002;\r\n    background-color: $header-bg;\r\n    transition: all 0.1s ease-out;\r\n\r\n    &.topbar-shadow {\r\n        box-shadow: $box-shadow;\r\n    }\r\n\r\n    @media (min-width: 768px) {\r\n        left: $vertical-menu-width;\r\n    }\r\n}\r\n\r\n.navbar-header {\r\n    display: flex;\r\n    -ms-flex-pack: justify;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin: 0 auto;\r\n    height: $header-height;\r\n    padding: 0 $grid-gutter-width 0 calc(#{$grid-gutter-width} / 2)\r\n    /*rtl: 0 0 0 calc(#{$grid-gutter-width} / 2) */\r\n    ;\r\n\r\n    @media (max-width: 767.98px) {\r\n        padding: 0 calc(#{$grid-gutter-width} / 2) 0 calc(#{$grid-gutter-width} / 2);\r\n    }\r\n\r\n    .topbar-head-dropdown {\r\n        .dropdown-menu.show {\r\n            top: 13px !important;\r\n        }\r\n    }\r\n\r\n    .btn-topbar {\r\n        height: 42px;\r\n        width: 42px;\r\n\r\n        @media (max-width: 360px) {\r\n            height: 36px;\r\n            width: 36px;\r\n        }\r\n    }\r\n\r\n    .user-name-text {\r\n        color: var(--#{$prefix}gray-700);\r\n    }\r\n}\r\n\r\n/* Search */\r\n\r\n.app-search {\r\n    padding: calc(#{$header-height - 38px} / 2) 0;\r\n\r\n    .form-control {\r\n        border: none;\r\n        height: 38px;\r\n        padding-left: 40px;\r\n        padding-right: 30px;\r\n        background-color: $topbar-search-bg;\r\n        box-shadow: none;\r\n    }\r\n\r\n    span.search-widget-icon {\r\n        position: absolute;\r\n        z-index: 10;\r\n        font-size: 18px;\r\n        line-height: 38px;\r\n        left: 13px;\r\n        top: 0;\r\n        color: $gray-600;\r\n    }\r\n\r\n    .search-widget-icon-close {\r\n        right: 7px;\r\n        left: auto !important;\r\n    }\r\n\r\n    @media (max-width: 1023.99px) {\r\n        padding-left: calc(#{$grid-gutter-width} / 2);\r\n    }\r\n}\r\n\r\n// Mega menu\r\n\r\n.megamenu-list {\r\n    li {\r\n        position: relative;\r\n        padding: 5px 0px;\r\n\r\n        a {\r\n            color: $dropdown-color;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n    .logo {\r\n        span.logo-lg {\r\n            display: none;\r\n        }\r\n\r\n        span.logo-sm {\r\n            display: inline-block;\r\n        }\r\n    }\r\n}\r\n\r\n.header-item {\r\n    height: $header-height;\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.header-profile-user {\r\n    height: 32px;\r\n    width: 32px;\r\n}\r\n\r\n.topbar-badge-sm {\r\n    right: 0;\r\n    top: 7px !important;\r\n}\r\n\r\n.topbar-badge {\r\n    right: -9px;\r\n    top: 4px !important;\r\n}\r\n\r\n.topbar-user {\r\n    @media (min-width: 768px) {\r\n        background-color: $topbar-user-bg;\r\n    }\r\n\r\n    .dropdown-menu {\r\n        top: 6px !important;\r\n    }\r\n}\r\n\r\n.notification-item {\r\n    padding: 0.75rem 1rem;\r\n    white-space: inherit;\r\n    position: relative;\r\n\r\n    .form-check-input {\r\n        position: relative;\r\n        z-index: 2;\r\n    }\r\n}\r\n\r\n// Dropdown with Icons\r\n.dropdown-icon-item {\r\n    display: block;\r\n    border-radius: 3px;\r\n    line-height: 34px;\r\n    text-align: center;\r\n    padding: 15px 0 9px;\r\n    border: 1px solid transparent;\r\n    color: var(--#{$prefix}dropdown-link-color);\r\n\r\n    img {\r\n        height: 24px;\r\n    }\r\n\r\n    span {\r\n        display: block;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n    }\r\n\r\n    &:hover {\r\n        background-color: var(--#{$prefix}dropdown-link-hover-bg);\r\n    }\r\n}\r\n\r\n// Full Screen\r\n.fullscreen-enable {\r\n    [data-toggle=\"fullscreen\"] {\r\n        .bx-fullscreen::before {\r\n            content: \"\\eacb\";\r\n        }\r\n    }\r\n}\r\n\r\n// Dark mode enable\r\n[data-layout-mode=\"dark\"] {\r\n    .light-dark-mode {\r\n        .bx-moon::before {\r\n            content: \"\\ec34\";\r\n        }\r\n    }\r\n}\r\n\r\n[data-topbar=\"dark\"] {\r\n    #page-topbar {\r\n        background-color: $header-bg-dark;\r\n        border-color: $header-bg-dark;\r\n    }\r\n\r\n    .navbar-header {\r\n        .btn-topbar {\r\n            color: $header-item-color-dark;\r\n\r\n            &:hover,\r\n            &:focus {\r\n                background-color: rgba($white, 0.07);\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n\r\n    .topbar-user {\r\n        @media (min-width: 767.99px) {\r\n            background-color: $topbar-user-bg-dark;\r\n        }\r\n\r\n        .user-name-text {\r\n            color: rgba($white, 0.85) !important;\r\n        }\r\n\r\n        .user-name-sub-text {\r\n            color: $header-item-color-dark !important;\r\n        }\r\n    }\r\n\r\n    .logo-dark {\r\n        display: none;\r\n    }\r\n\r\n    .logo-light {\r\n        display: inline-block;\r\n    }\r\n\r\n    .app-search {\r\n        .form-control {\r\n            background-color: rgba($white, 0.05);\r\n            color: $white;\r\n        }\r\n\r\n        span.search-widget-icon,\r\n        input.form-control::-webkit-input-placeholder {\r\n            color: rgba($white, 0.5);\r\n        }\r\n    }\r\n\r\n    .hamburger-icon {\r\n        span {\r\n            background-color: $gray-300;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n    .navbar-header {\r\n        .dropdown {\r\n            position: static;\r\n\r\n            .dropdown-menu {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 767.98px){\r\n    #search-dropdown-reponsive{\r\n        top: 54px !important;\r\n    }\r\n}\r\n\r\n[data-layout=\"vertical\"] {\r\n    &[data-layout-style=\"detached\"] {\r\n        @media (min-width: 1024.1px) {\r\n            #page-topbar {\r\n                left: 0 !important;\r\n                box-shadow: $box-shadow;\r\n            }\r\n\r\n            .horizontal-logo {\r\n                display: inline-block;\r\n                padding-left: 0;\r\n            }\r\n\r\n            .topnav-hamburger {\r\n                visibility: hidden;\r\n            }\r\n\r\n            .layout-width {\r\n                max-width: 95%;\r\n                margin: 0 auto;\r\n            }\r\n\r\n            &[data-sidebar-size=\"sm\"],\r\n            &[data-sidebar-size=\"sm-hover\"] {\r\n                .navbar-brand-box {\r\n                    background-color: transparent !important;\r\n                    position: relative;\r\n                    width: auto;\r\n                    text-align: left;\r\n\r\n                    .logo-sm {\r\n                        display: none;\r\n                    }\r\n\r\n                    .logo-lg {\r\n                        display: block;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &[data-topbar=\"dark\"] {\r\n            .horizontal-logo {\r\n                .logo-dark {\r\n                    display: none;\r\n                }\r\n\r\n                .logo-light {\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout=\"horizontal\"] {\r\n    #page-topbar {\r\n        left: 0;\r\n        border-bottom: 1px solid var(--#{$prefix}gray-300);\r\n\r\n        @media (min-width: 1024.1px) {\r\n            &.topbar-shadow {\r\n                box-shadow: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    .page-content {\r\n        @media (min-width: 1024.1px) {\r\n            margin-top: $header-height;\r\n        }\r\n\r\n        padding: calc(45px + #{$grid-gutter-width}) calc(#{$grid-gutter-width} / 2) $footer-height calc(#{$grid-gutter-width} / 2);\r\n    }\r\n\r\n    &[data-layout-width=\"boxed\"] {\r\n        .page-content {\r\n            @media (min-width: 1024.1px) {\r\n                min-height: calc(100vh - #{$footer-height + $header-height});\r\n            }   \r\n        }\r\n    }\r\n}\r\n\r\n[data-layout=\"vertical\"] {\r\n\r\n    &[data-sidebar-size=\"sm\"],\r\n    &[data-sidebar-size=\"sm-hover\"] {\r\n        #page-topbar {\r\n            @media (min-width: 768px) {\r\n                left: $vertical-menu-width-sm;\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar-size=\"md\"] {\r\n        #page-topbar {\r\n            @media (min-width: 768px) {\r\n                left: $vertical-menu-width-md;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout=\"twocolumn\"] {\r\n    #page-topbar {\r\n        @media (min-width: 768px) {\r\n            left: calc(#{$twocolumn-menu-iconview-width} + #{$twocolumn-menu-width});\r\n        }\r\n    }\r\n\r\n    .horizontal-logo {\r\n        display: none;\r\n    }\r\n}","// \r\n// _page-head.scss\r\n// \r\n\r\n.page-title-box {\r\n    padding: 10px $grid-gutter-width;\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n    box-shadow: $page-title-box-shadow;\r\n    border-bottom: 1px solid $page-title-border;\r\n    border-top: 1px solid $page-title-border;\r\n    margin: -23px (-$grid-gutter-width * 1) $grid-gutter-width (-$grid-gutter-width * 1);\r\n\r\n    .breadcrumb {\r\n        background-color: transparent;\r\n        padding: 0;\r\n    }\r\n\r\n    h4 {\r\n        font-weight: 700;\r\n        font-size: 15px!important;\r\n        text-transform: uppercase;\r\n    }\r\n}\r\n\r\n[data-layout=\"horizontal\"] {\r\n    .page-title-box {\r\n        padding: 1.2rem 0;\r\n        background-color: transparent !important;\r\n        border-bottom: none;\r\n        border-top: none;\r\n        box-shadow: none;\r\n        margin: 0;\r\n\r\n        @media (min-width: 1024.1px) {\r\n            margin: -19px 0 0 0;\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout=\"vertical\"] {\r\n    &[data-layout-style=\"detached\"]{\r\n        .page-title-box {\r\n            padding: 1.2rem 0;\r\n            background-color: transparent !important;\r\n            border-bottom: none;\r\n            border-top: none;\r\n            box-shadow: none;\r\n            margin: 0;\r\n    \r\n            @media (min-width: 1024.1px) {\r\n                margin: -19px 0 0 0;\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// _footer.scss\r\n// \r\n\r\n.footer {\r\n    bottom: 0;\r\n    padding: 20px calc(#{$grid-gutter-width} * 0.5);\r\n    position: absolute;\r\n    right: 0;\r\n    color: $footer-color;\r\n    left: $vertical-menu-width;\r\n    height: $footer-height;\r\n    background-color: $footer-bg;\r\n\r\n    @media (max-width: 991.98px) {\r\n        left: 0;\r\n    }\r\n}\r\n\r\n[data-layout=\"vertical\"] {\r\n\r\n    &[data-sidebar-size=\"sm\"],\r\n    &[data-sidebar-size=\"sm-hover\"] {\r\n        .footer {\r\n            left: $vertical-menu-width-sm;\r\n\r\n            @media (max-width: 767.98px) {\r\n                left: 0;\r\n            }\r\n        }\r\n    }\r\n    &[data-sidebar-size=\"md\"] {\r\n        .footer {\r\n            left: $vertical-menu-width-md;\r\n\r\n            @media (max-width: 991.98px) {\r\n                left: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n[data-layout=\"horizontal\"]{\r\n    .footer {\r\n        left: 0 !important;\r\n    } \r\n}\r\n\r\n[data-layout=\"vertical\"][data-layout-style=\"detached\"] {\r\n\r\n    @media (min-width: 1024.1px) {\r\n        .footer {\r\n            left: 0 !important;\r\n            background-color: transparent;\r\n        } \r\n    }\r\n}\r\n\r\n[data-layout=\"twocolumn\"] { \r\n    .footer {\r\n        @media (min-width: 768.1px) {\r\n            left: calc(#{$twocolumn-menu-iconview-width} + #{$twocolumn-menu-width});\r\n        }\r\n    }\r\n}","//\r\n// _vertical.scss\r\n// \r\n\r\n.app-content {\r\n    margin-left: $vertical-menu-width;\r\n    overflow: hidden;\r\n\r\n    .content {\r\n        padding: 0 15px 10px 15px;\r\n        margin-top: $header-height;\r\n    }\r\n}\r\n\r\n.main-content {\r\n    transition: all .1s ease-out;\r\n\r\n    @media (min-width: 768px) {\r\n        margin-left: $vertical-menu-width;\r\n    }\r\n}\r\n\r\n.page-content {\r\n    padding: calc(#{$header-height} + #{$grid-gutter-width}) calc(#{$grid-gutter-width} * 0.5) $footer-height calc(#{$grid-gutter-width} * 0.5);\r\n}\r\n\r\n.navbar-menu {\r\n    width: $vertical-menu-width;\r\n    z-index: $vertical-menu-z-index;\r\n    background: $vertical-menu-bg;\r\n    border-right: 1px solid $vertical-menu-border;\r\n    bottom: 0;\r\n    margin-top: 0;\r\n    position: fixed;\r\n    top: 0;\r\n    box-shadow: $vertical-menu-box-shadow;\r\n    padding: 0 0 calc(#{$header-height} + 25px) 0;\r\n    transition: all .1s ease-out;\r\n\r\n    .navbar-nav {\r\n        .nav-link {\r\n            display: flex;\r\n            align-items: center;\r\n            padding: $vertical-menu-item-padding-y $vertical-menu-item-padding-x;\r\n            color: $vertical-menu-item-color;\r\n            font-size: $vertical-menu-item-font-size;\r\n            font-family: $vertical-menu-item-font-family;\r\n\r\n            &.active {\r\n                color: $vertical-menu-item-active-color;\r\n            }\r\n\r\n            &:hover {\r\n                color: $vertical-menu-item-hover-color;\r\n            }\r\n\r\n            i {\r\n                display: inline-block;\r\n                min-width: $vertical-menu-item-icon-width;\r\n                font-size: 18px;\r\n                line-height: inherit;\r\n            }\r\n\r\n            svg {\r\n                width: 18px;\r\n                margin-right: 0.665rem;\r\n                color: $vertical-menu-item-color;\r\n            }\r\n\r\n            .badge {\r\n                margin-left: auto;\r\n                margin-right: -2px;\r\n                z-index: 1;\r\n            }\r\n\r\n            &:hover {\r\n                color: $vertical-menu-item-hover-color;\r\n\r\n                .icon-dual {\r\n                    color: $vertical-menu-item-hover-color;\r\n                    fill: rgba($primary, 0.16);\r\n                }\r\n            }\r\n\r\n            &[data-bs-toggle=collapse] {\r\n                &:after {\r\n                    display: block;\r\n                    content: \"\\F0142\";\r\n                    font-family: 'Material Design Icons';\r\n                    margin-left: auto;\r\n                    transition: transform .2s;\r\n                    font-size: 1.05rem;\r\n                    position: absolute;\r\n                    right: 18px;\r\n                    color: $vertical-menu-title-color;\r\n                }\r\n\r\n                &[aria-expanded=true] {\r\n                    color: $vertical-menu-item-active-color;\r\n\r\n                    .icon-dual {\r\n                        color: $vertical-menu-item-hover-color;\r\n                        fill: rgba($primary, 0.16);\r\n                    }\r\n\r\n                    &:after {\r\n                        transform: rotate(90deg);\r\n                        color: $vertical-menu-item-active-color;\r\n                    }\r\n\r\n                    &:before {\r\n                        opacity: 1;\r\n                        background-color: $vertical-menu-item-active-color;\r\n                    }\r\n                }\r\n            }\r\n            &.collapsed {\r\n                &.active {\r\n                    &::after {\r\n                        transform: rotate(90deg);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .nav-sm {\r\n            padding-left: $vertical-menu-item-icon-width;\r\n\r\n            .nav-link {\r\n                padding: $vertical-menu-sub-item-padding-y $vertical-menu-sub-item-padding-x !important;\r\n                color: $vertical-menu-sub-item-color;\r\n                white-space: none;\r\n                position: relative;\r\n                font-size: $vertical-menu-sub-item-font-size;\r\n                font-family: $vertical-menu-sub-item-font-family;\r\n\r\n                &:before {\r\n                    content: '';\r\n                    width: 6px;\r\n                    height: 1.5px;\r\n                    background-color: $vertical-menu-sub-item-color;\r\n                    position: absolute;\r\n                    left: 2px;\r\n                    top: 16.5px;\r\n                    transition: all .4s ease-in-out;\r\n                    opacity: 0.5;\r\n                }\r\n\r\n                &:hover {\r\n                    color: $vertical-menu-sub-item-hover-color;\r\n\r\n                    &:before {\r\n                        background-color: $vertical-menu-sub-item-hover-color !important;\r\n                        opacity: 1;\r\n                    }\r\n                }\r\n\r\n                &.active {\r\n                    color: $vertical-menu-item-active-color;\r\n\r\n                    &:before {\r\n                        background-color: $vertical-menu-item-active-color;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .nav-sm {\r\n                padding-left: 15px;\r\n\r\n                .nav-link {\r\n\r\n                    &:before {\r\n                        height: 5px;\r\n                        width: 5px;\r\n                        left: 5px;\r\n                        border-radius: 50%;\r\n                        background-color: transparent;\r\n                        border: 1px solid;\r\n                        top: 16px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .btn-vertical-sm-hover {\r\n        color: $text-muted;\r\n        display: none;\r\n    }\r\n}\r\n\r\n.navbar-brand-box {\r\n    padding: 0 1.3rem;\r\n    text-align: center;\r\n    transition: all .1s ease-out;\r\n\r\n    @media (max-width: 767.98px) {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.hamburger-icon {\r\n    width: 20px;\r\n    height: 14px;\r\n    position: relative;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n\r\n    span {\r\n        background-color: $text-muted;\r\n        position: absolute;\r\n        border-radius: 2px;\r\n        transition: .3s cubic-bezier(.8, .5, .2, 1.4);\r\n        width: 100%;\r\n        height: 2px;\r\n        display: block;\r\n        left: 0px;\r\n\r\n        &:nth-child(1) {\r\n            top: 0;\r\n            width: 80%;\r\n        }\r\n\r\n        &:nth-child(2) {\r\n            top: 6px;\r\n        }\r\n\r\n        &:nth-child(3) {\r\n            bottom: 0;\r\n            width: 60%;\r\n        }\r\n    }\r\n\r\n    .vertical-menu-btn:hover &:not(.open) {\r\n        span {\r\n\r\n            &:nth-child(1) {\r\n                top: -1px;\r\n            }\r\n\r\n            &:nth-child(3) {\r\n                bottom: -1px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.open {\r\n        transform: rotate(-90deg);\r\n\r\n        span {\r\n\r\n            &:nth-child(1) {\r\n                left: 1px;\r\n                top: 5px;\r\n                width: 20px;\r\n                transform: rotate(90deg);\r\n                transition-delay: 150ms;\r\n            }\r\n\r\n            &:nth-child(2) {\r\n                left: 3px;\r\n                top: 13px;\r\n                width: 10px;\r\n                transform: rotate(45deg);\r\n                transition-delay: 50ms;\r\n            }\r\n\r\n            &:nth-child(3) {\r\n                left: 9px;\r\n                top: 13px;\r\n                width: 10px;\r\n                transform: rotate(-45deg);\r\n                transition-delay: 100ms;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.logo {\r\n    line-height: $header-height;\r\n\r\n    .logo-sm {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.logo-light {\r\n    display: none;\r\n}\r\n\r\n[data-layout=\"vertical\"] {\r\n    .app-menu {\r\n        .row {\r\n            margin: 0;\r\n\r\n            >* {\r\n                width: 100%;\r\n                padding: 0;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 767.98px) {\r\n            margin-left: -100%;\r\n            padding: 10px 0 20px 0;\r\n        }\r\n\r\n    }\r\n\r\n    .navbar-menu {\r\n        .container-fluid {\r\n            padding: 0;\r\n        }\r\n    }\r\n\r\n    .navbar-brand-box {\r\n        @media (max-width: 767.98px) {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .horizontal-logo {\r\n        display: none;\r\n    }\r\n\r\n    &[data-sidebar-size=\"sm-hover\"] {\r\n\r\n        .main-content {\r\n            margin-left: $vertical-menu-width-sm;\r\n\r\n            @media (max-width: 767.98px) {\r\n                margin-left: 0;\r\n            }\r\n        }\r\n\r\n        .logo {\r\n            span.logo-lg {\r\n                display: none;\r\n            }\r\n\r\n            span.logo-sm {\r\n                display: inline-block;\r\n            }\r\n        }\r\n\r\n        .btn-vertical-sm-hover {\r\n            display: inline-block;\r\n        }\r\n\r\n        @media (min-width: 768px) {\r\n            .topnav-hamburger {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        // Side menu\r\n        .navbar-menu {\r\n            width: $vertical-menu-width-sm;\r\n\r\n            .btn-vertical-sm-hover {\r\n                display: none;\r\n\r\n                i {\r\n                    &.ri-record-circle-line:before {\r\n                        content: \"\\EB7D\";\r\n                    }\r\n                }\r\n            }\r\n\r\n            // Sidebar Menu\r\n            .navbar-nav {\r\n\r\n                .badge {\r\n                    display: none;\r\n                }\r\n\r\n                .menu-title {\r\n                    text-align: center;\r\n\r\n                    span {\r\n                        display: none;\r\n                    }\r\n\r\n                    i {\r\n                        display: block;\r\n                        line-height: 36px;\r\n                        font-size: 1rem;\r\n                    }\r\n                }\r\n\r\n                .nav-link {\r\n                    span {\r\n                        display: none;\r\n                    }\r\n\r\n                    i {\r\n                        font-size: 22px;\r\n\r\n                        &.las,\r\n                        &.lar,\r\n                        &.lab {\r\n                            font-size: 24px;\r\n                        }\r\n                    }\r\n\r\n                    svg {\r\n                        margin-right: 0px;\r\n                    }\r\n\r\n                    &:after,\r\n                    &:before {\r\n                        display: none;\r\n                    }\r\n                }\r\n\r\n                .menu-dropdown {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            &:hover {\r\n                width: $vertical-menu-width !important;\r\n\r\n                @media (min-width: 1024.99px) {\r\n                    .btn-vertical-sm-hover {\r\n                        display: inline-block;\r\n                    }\r\n\r\n                    .navbar-brand-box {\r\n                        text-align: left;\r\n                    }\r\n                }\r\n\r\n                .navbar-nav {\r\n                    .menu-dropdown.show {\r\n                        display: block;\r\n                    }\r\n                }\r\n\r\n                .nav-link {\r\n\r\n                    i {\r\n                        font-size: 18px;\r\n\r\n                        &.las,\r\n                        &.lar,\r\n                        &.lab {\r\n                            font-size: 20px;\r\n                        }\r\n                    }\r\n\r\n                    svg {\r\n                        margin-right: 0.665rem;\r\n                    }\r\n\r\n                    span,\r\n                    &:after,\r\n                    &:before {\r\n                        display: inline-block;\r\n                    }\r\n                }\r\n\r\n                .logo {\r\n                    span.logo-lg {\r\n                        display: inline-block;\r\n                    }\r\n\r\n                    span.logo-sm {\r\n                        display: none;\r\n                    }\r\n                }\r\n\r\n                .menu-title {\r\n                    text-align: left;\r\n\r\n                    span {\r\n                        display: inline-block;\r\n                    }\r\n\r\n                    i {\r\n                        display: none;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar-size=\"sm-hover\"],\r\n    &[data-sidebar-size=\"sm-hover-active\"] {\r\n        .navbar-header {\r\n            @media (min-width: 1025px) {\r\n                padding-left: $grid-gutter-width;\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar-size=\"sm-hover-active\"] {\r\n        .navbar-brand-box {\r\n            text-align: left;\r\n        }\r\n\r\n        .topnav-hamburger {\r\n            display: none;\r\n        }\r\n\r\n        .btn-vertical-sm-hover {\r\n            display: inline-block;\r\n        }\r\n    }\r\n\r\n    &[data-sidebar-size=\"sm\"] {\r\n        @media (min-width: 768px) {\r\n            min-height: 1400px;\r\n\r\n            .main-content {\r\n                margin-left: $vertical-menu-width-sm;\r\n            }\r\n        }\r\n\r\n        #page-topbar {\r\n            z-index: calc(#{$vertical-menu-z-index} + 1);\r\n        }\r\n\r\n        .navbar-brand-box {\r\n            position: fixed;\r\n            padding: 0;\r\n            width: $vertical-menu-width-sm;\r\n            z-index: 1;\r\n            top: 0;\r\n            background: $vertical-menu-bg;\r\n        }\r\n\r\n        .logo {\r\n            span.logo-lg {\r\n                display: none;\r\n            }\r\n\r\n            span.logo-sm {\r\n                display: inline-block;\r\n            }\r\n        }\r\n\r\n        // Side menu\r\n        .navbar-menu {\r\n            position: absolute;\r\n            width: $vertical-menu-width-sm !important;\r\n            padding-top: $header-height;\r\n\r\n            .simplebar-mask,\r\n            .simplebar-content-wrapper {\r\n                overflow: visible !important;\r\n            }\r\n\r\n            .simplebar-scrollbar,\r\n            .vertical-menu-btn {\r\n                display: none !important;\r\n            }\r\n\r\n            .simplebar-offset {\r\n                bottom: 0 !important;\r\n            }\r\n\r\n            // Sidebar Menu\r\n            .navbar-nav {\r\n\r\n                .badge {\r\n                    display: none !important;\r\n                }\r\n\r\n                .menu-title {\r\n                    text-align: center;\r\n                    font-size: 1rem;\r\n\r\n                    span {\r\n                        display: none;\r\n                    }\r\n\r\n                    i {\r\n                        display: block;\r\n                        line-height: 36px;\r\n                    }\r\n                }\r\n\r\n                .nav-link {\r\n                    span {\r\n                        display: none;\r\n                    }\r\n\r\n                    i {\r\n                        font-size: 22px;\r\n                    }\r\n\r\n                    svg {\r\n                        margin-right: 0px;\r\n                    }\r\n\r\n                    &:after,\r\n                    &:before {\r\n                        display: none;\r\n                    }\r\n                }\r\n\r\n                .menu-dropdown {\r\n                    display: none;\r\n                    height: auto !important;\r\n                }\r\n\r\n                .nav-item {\r\n                    position: relative;\r\n\r\n                    &:hover {\r\n> a.menu-link {\r\n                            position: relative;\r\n                            width: calc(200px + #{$vertical-menu-width-sm});\r\n                            color: $white;\r\n                            background-color: $vertical-menu-bg-dark;\r\n                            transition: none;\r\n\r\n                            .icon-dual {\r\n                                color: $vertical-menu-item-hover-color-dark;\r\n                                fill: rgba($white, 0.16);\r\n                            }\r\n\r\n                            span {\r\n                                display: inline-block;\r\n                                padding-left: 25px;\r\n                            }\r\n\r\n                            &:after {\r\n                                display: block;\r\n                                transform: rotate(90deg);\r\n                                color: $white;\r\n                            }\r\n                        }\r\n> .menu-dropdown {\r\n                            display: block;\r\n                            left: $vertical-menu-width-sm;\r\n                            position: absolute;\r\n                            width: 200px;\r\n                            background: $vertical-menu-bg;\r\n                            height: auto !important;\r\n                            padding: 0.5rem 0;\r\n                            border-radius: 0 0 3px 3px;\r\n                            box-shadow: $vertical-menu-dropdown-box-shadow;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .nav-sm {\r\n                    padding: 0;\r\n\r\n                    .nav-item {\r\n                        &:hover {>.nav-link {\r\n                                color: $vertical-menu-item-hover-color;\r\n\r\n                                &:after {\r\n                                    color: inherit;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    .nav-link {\r\n                        &:after {\r\n                            display: block !important;\r\n                            transform: rotate(0deg) !important;\r\n                        }\r\n                    }\r\n\r\n                    .menu-dropdown {\r\n                        left: 100% !important;\r\n                        top: 0;\r\n                        border-radius: 3px !important;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar-size=\"md\"] {\r\n        @media (min-width: 768px) {\r\n            .main-content {\r\n                margin-left: $vertical-menu-width-md;\r\n            }\r\n        }\r\n\r\n        .navbar-brand-box {\r\n            width: $vertical-menu-width-md;\r\n        }\r\n\r\n        // Side menu\r\n        .navbar-menu {\r\n            width: $vertical-menu-width-md !important;\r\n\r\n            // Sidebar Menu\r\n            .navbar-nav {\r\n                .nav-link {\r\n                    display: block;\r\n                    text-align: center;\r\n                    padding: $vertical-menu-sub-item-padding-y $vertical-menu-sub-item-padding-x*0.35;\r\n\r\n                    i {\r\n                        display: block;\r\n                    }\r\n\r\n                    svg {\r\n                        display: block;\r\n                        margin-left: auto;\r\n                        margin-right: auto;\r\n                    }\r\n\r\n                    &:before {\r\n                        display: none !important;\r\n                    }\r\n\r\n                    &[data-bs-toggle=collapse]:after {\r\n                        position: relative;\r\n                        display: inline-block;\r\n                        right: 0;\r\n                        top: 3px;\r\n                    }\r\n\r\n                    &.menu-link {\r\n                        &[data-bs-toggle=collapse]:after {\r\n                            display: none;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .badge {\r\n                    display: none !important;\r\n                }\r\n\r\n                .nav-sm {\r\n                    padding-left: 0;\r\n                }\r\n            }\r\n\r\n\r\n            .menu-title {\r\n                text-align: center;\r\n\r\n                span {\r\n                    text-decoration: underline;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar=\"dark\"] {\r\n        .navbar-menu {\r\n            background: $vertical-menu-bg-dark;\r\n            border-right: 1px solid $vertical-menu-border-dark;\r\n\r\n            .hamburger-icon {\r\n                span {\r\n                    background-color: $vertical-menu-item-color-dark;\r\n                }\r\n            }\r\n\r\n            .btn-vertical-sm-hover {\r\n                color: $vertical-menu-item-color-dark;\r\n            }\r\n        }\r\n\r\n        .navbar-nav {\r\n\r\n            .nav-link {\r\n                color: $vertical-menu-item-color-dark;\r\n\r\n                &.active {\r\n                    color: $vertical-menu-item-active-color-dark;\r\n                }\r\n\r\n                &[data-bs-toggle=collapse] {\r\n                    &:after {\r\n                        color: inherit;\r\n                    }\r\n\r\n                    &[aria-expanded=true] {\r\n                        color: $vertical-menu-item-active-color-dark;\r\n\r\n                        &:after {\r\n                            color: inherit;\r\n                        }\r\n\r\n                        .icon-dual {\r\n                            color: $vertical-menu-item-active-color-dark;\r\n                            fill: rgba($white, 0.10);\r\n                        }\r\n                    }\r\n                }\r\n\r\n                svg {\r\n                    color: $vertical-menu-item-color-dark;\r\n                    fill: rgba($white, 0.10);\r\n                }\r\n\r\n                &:hover {\r\n                    color: $vertical-menu-item-hover-color-dark;\r\n\r\n                    .icon-dual {\r\n                        color: $vertical-menu-item-hover-color-dark;\r\n                        fill: rgba($white, 0.16);\r\n                    }\r\n                }\r\n\r\n            }\r\n\r\n            >.nav-item {\r\n                .nav-link.active {\r\n                    color: $vertical-menu-item-active-color-dark;\r\n\r\n                    .icon-dual {\r\n                        color: $vertical-menu-item-hover-color-dark;\r\n                        fill: rgba($white, 0.16);\r\n                    }\r\n                }\r\n            }\r\n\r\n            .nav-sm {\r\n                .nav-link {\r\n                    color: $vertical-menu-sub-item-color-dark;\r\n\r\n                    &:before {\r\n                        background-color: $vertical-menu-sub-item-color-dark !important;\r\n                    }\r\n\r\n                    &:hover {\r\n                        color: $vertical-menu-item-hover-color-dark;\r\n\r\n                        &:before {\r\n                            background-color: $vertical-menu-item-hover-color-dark !important;\r\n                        }\r\n                    }\r\n\r\n                    &.active {\r\n                        color: $vertical-menu-item-active-color-dark;\r\n                    }\r\n                }\r\n\r\n                .nav-sm {\r\n                    .nav-link {\r\n                        &:before {\r\n                            background-color: transparent !important;\r\n                        }\r\n\r\n                        &:hover {\r\n                            &:before {\r\n                                background-color: $vertical-menu-item-hover-color-dark !important;\r\n                            }\r\n                        }\r\n\r\n                        &.active {\r\n                            color: $vertical-menu-item-active-color-dark;\r\n\r\n                            &:before {\r\n                                background-color: $vertical-menu-item-active-color-dark !important;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &[data-sidebar-size=\"sm\"] {\r\n            .navbar-brand-box {\r\n                background: $vertical-menu-bg-dark;\r\n            }\r\n\r\n            // Side menu\r\n            .navbar-menu {\r\n                .navbar-nav {\r\n                    .nav-item {\r\n\r\n                        &:hover {>.menu-dropdown {\r\n                                background: $vertical-menu-bg-dark;\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    .nav-sm {\r\n                        padding: 0;\r\n\r\n                        .nav-link {\r\n                            &:after {\r\n                                display: block !important;\r\n                                transform: rotate(0deg) !important;\r\n                            }\r\n                        }\r\n\r\n                        .nav-item {\r\n                            &:hover {\r\n                                >.nav-link {\r\n                                    color: $vertical-menu-item-active-color-dark;\r\n\r\n                                    &:after {\r\n                                        color: inherit;\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n\r\n                        .menu-dropdown {\r\n                            left: 100% !important;\r\n                            top: 0;\r\n                            border-radius: 3px !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .menu-title {\r\n            color: $vertical-menu-title-color-dark;\r\n        }\r\n\r\n        .logo-dark {\r\n            display: none;\r\n        }\r\n\r\n        .logo-light {\r\n            display: inline-block;\r\n        }\r\n    }\r\n\r\n    &[data-sidebar=\"light\"] {\r\n        .logo-dark {\r\n            display: inline-block;\r\n        }\r\n\r\n        .logo-light {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    &[data-layout-style=\"detached\"] {\r\n\r\n        #layout-wrapper,\r\n        .main-content {\r\n            min-height: 100vh;\r\n        }\r\n\r\n        @media (min-width: 1024.1px) {\r\n            .main-content {\r\n                position: relative;\r\n            }\r\n\r\n            #layout-wrapper {\r\n                max-width: 95%;\r\n                margin: 0 auto;\r\n                padding-left: $grid-gutter-width;\r\n            }\r\n\r\n            .navbar-header {\r\n                padding-left: $grid-gutter-width;\r\n            }\r\n\r\n            .navbar-menu {\r\n                top: calc(#{$header-height} + #{$grid-gutter-width});\r\n                bottom: $grid-gutter-width;\r\n                padding: 0;\r\n                border-right: $vertical-menu-bg;\r\n                border-radius: 5px;\r\n                padding: 10px 0;\r\n                z-index: 1;\r\n\r\n                .navbar-brand-box {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            &[data-sidebar=\"dark\"], \r\n            &[data-sidebar=\"gradient\"],\r\n            &[data-sidebar=\"gradient-2\"],\r\n            &[data-sidebar=\"gradient-3\"],\r\n            &[data-sidebar=\"gradient-4\"] {\r\n                .logo-dark {\r\n                    display: inline-block;\r\n                }\r\n\r\n                .logo-light {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n\r\n        .footer {\r\n            border-top: 1px dashed $border-color;\r\n        }\r\n\r\n        .auth-page-wrapper {\r\n            .footer {\r\n                border-top: none;\r\n            }\r\n        }\r\n\r\n        &[data-sidebar-size=\"sm\"] {\r\n            @media (min-width: 768px) {\r\n\r\n                #layout-wrapper,\r\n                .main-content {\r\n                    min-height: 1400px;\r\n                }\r\n            }\r\n        }\r\n\r\n\r\n    }\r\n\r\n    &[data-sidebar=\"gradient\"],\r\n    &[data-sidebar=\"gradient-2\"],\r\n    &[data-sidebar=\"gradient-3\"],\r\n    &[data-sidebar=\"gradient-4\"] { \r\n        .logo-dark {\r\n            display: none;\r\n        }\r\n    \r\n        .logo-light {\r\n            display: inline-block;\r\n        }\r\n    }\r\n}\r\n\r\n.menu-title {\r\n    letter-spacing: .05em;\r\n    cursor: default;\r\n    font-size: 11px;\r\n    text-transform: uppercase;\r\n    color: $vertical-menu-title-color;\r\n    font-weight: $font-weight-semibold;\r\n\r\n    span {\r\n        padding: 12px 20px;\r\n        display: inline-block;\r\n    }\r\n\r\n    i {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.vertical-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: rgba($dark, 0.35);\r\n    z-index: 1003;\r\n    display: none;\r\n}\r\n\r\n// Mobile Menu\r\n.vertical-sidebar-enable {\r\n    .vertical-overlay {\r\n        display: block;\r\n    }\r\n\r\n    .app-menu {\r\n        margin-left: 0 !important;\r\n        z-index: 1004;\r\n    }\r\n}\r\n\r\n// rtl\r\n[dir=\"rtl\"] {\r\n    .navbar-menu {\r\n        .navbar-nav {\r\n            .nav-link[data-bs-toggle=collapse] {\r\n                &:after {\r\n                    transform: rotate(180deg);\r\n                }\r\n\r\n                &[aria-expanded=true]:after {\r\n                    transform: rotate(270deg);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n//gradient sidebar\r\n[data-sidebar=\"gradient\"],[data-sidebar=\"gradient-2\"], [data-sidebar=\"gradient-3\"], [data-sidebar=\"gradient-4\"] {\r\n    .navbar-menu {\r\n        background: $vertical-menu-bg-gradient;\r\n        border-right: 1px solid $vertical-menu-border-gradient;\r\n\r\n        .hamburger-icon {\r\n            span {\r\n                background-color: $vertical-menu-item-color-gradient;\r\n            }\r\n        }\r\n\r\n        .btn-vertical-sm-hover {\r\n            color: $vertical-menu-item-color-gradient;\r\n        }\r\n    }\r\n\r\n    .navbar-nav {\r\n        \r\n        .nav-link {\r\n            color: $vertical-menu-item-color-gradient;\r\n\r\n            &.active{\r\n                color: $vertical-menu-item-active-color-dark;\r\n            }\r\n\r\n            &[data-bs-toggle=collapse]{\r\n                &:after {\r\n                    color: inherit;\r\n                }\r\n\r\n                &[aria-expanded=true]{\r\n                    color: $vertical-menu-item-active-color-dark;\r\n                    &:after {\r\n                        color: inherit;\r\n                    }\r\n\r\n                    .icon-dual {\r\n                        color: $vertical-menu-item-active-color-dark;\r\n                        fill: rgba($white , 0.10);\r\n                    }\r\n                }\r\n            }\r\n\r\n            svg {\r\n                color:  $vertical-menu-item-color-gradient;\r\n                fill: rgba($white , 0.10);\r\n            }\r\n\r\n            &:hover {\r\n                color: $vertical-menu-item-hover-color-dark;\r\n                .icon-dual {\r\n                    color: $vertical-menu-item-hover-color-dark;\r\n                    fill: rgba($white , 0.16);\r\n                }\r\n            }\r\n            \r\n        }\r\n\r\n        > .nav-item {\r\n            .nav-link.active {\r\n                color: $vertical-menu-item-active-color-dark;\r\n                .icon-dual {\r\n                    color: $vertical-menu-item-hover-color-dark;\r\n                    fill: rgba($white , 0.16);\r\n                }\r\n            }\r\n        }\r\n\r\n        .nav-sm {\r\n            .nav-link {\r\n                color: $vertical-menu-sub-item-color-gradient;\r\n\r\n                &:before {\r\n                    background-color: $vertical-menu-sub-item-color-gradient !important;\r\n                }\r\n\r\n                &:hover {\r\n                    color: $vertical-menu-item-hover-color-dark;\r\n\r\n                    &:before {\r\n                        background-color: $vertical-menu-item-hover-color-dark !important;\r\n                    }\r\n                }\r\n                \r\n                &.active {\r\n                    color: $vertical-menu-item-active-color-dark;\r\n                }\r\n            }\r\n\r\n            .nav-sm {\r\n                .nav-link {\r\n                    &:before {\r\n                        background-color: transparent !important;\r\n                    }\r\n\r\n                    &:hover {\r\n                        &:before {\r\n                            background-color: $vertical-menu-item-hover-color-dark !important;\r\n                        }\r\n                    }\r\n\r\n                    &.active {\r\n                        color: $vertical-menu-item-active-color-dark;\r\n                        &:before {\r\n                            background-color: $vertical-menu-item-active-color-dark !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar-size=\"sm\"] {\r\n        .navbar-brand-box {\r\n            background: $vertical-menu-bg-gradient;\r\n        }\r\n\r\n        // Side menu\r\n        .navbar-menu {\r\n            .navbar-nav {\r\n                .nav-item {\r\n\r\n                    &:hover {>  .menu-dropdown {\r\n                            background: $vertical-menu-bg-dark;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .nav-sm {\r\n                    padding: 0;\r\n\r\n                    .nav-link {\r\n                        &:after {\r\n                            display: block !important;\r\n                            transform: rotate(0deg) !important;\r\n                        }\r\n                    }\r\n\r\n                    .nav-item {\r\n                        &:hover {> .nav-link {\r\n                                color: $vertical-menu-item-active-color-dark;\r\n    \r\n                                &:after {\r\n                                    color: inherit;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n\r\n                    .menu-dropdown {\r\n                        left: 100% !important;\r\n                        top: 0;\r\n                        border-radius: 3px !important;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        &[data-layout=vertical] {\r\n            .navbar-menu {\r\n                .navbar-nav {\r\n                    .nav-item{\r\n                        \r\n                        &:hover {>a.menu-link {\r\n                                background: $vertical-menu-bg-gradient;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .menu-title {\r\n        color: $vertical-menu-title-color-gradient;\r\n    }\r\n}\r\n\r\n.bg-vertical-gradient {\r\n    background: linear-gradient(to right, var(--#{$prefix}primary), var(--#{$prefix}success));;\r\n}\r\n\r\n.bg-vertical-gradient-2 {\r\n    background: linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}secondary));\r\n}\r\n\r\n.bg-vertical-gradient-3 {\r\n    background: linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}success));\r\n}\r\n\r\n.bg-vertical-gradient-4 {\r\n    background: linear-gradient(to right, var(--#{$prefix}dark), var(--#{$prefix}primary));\r\n}\r\n\r\n\r\n//sidebar-images\r\n.sidebar-background {\r\n    position: absolute;\r\n    z-index: -1;\r\n    height: 100%;\r\n    width: 100%;\r\n    display: block;\r\n    top: 0;\r\n    left: 0;\r\n    background-size: cover;\r\n    background-position: 50%;\r\n    opacity: .07;\r\n}\r\n\r\n[data-sidebar-image=\"img-1\"]{\r\n    .sidebar-background { \r\n        background-image: url('../../images/sidebar/img-1.jpg');\r\n    }\r\n}\r\n[data-sidebar-image=\"img-2\"]{\r\n    .sidebar-background { \r\n        background-image: url('../../images/sidebar/img-2.jpg');\r\n    }\r\n}\r\n[data-sidebar-image=\"img-3\"]{\r\n    .sidebar-background { \r\n        background-image: url('../../images/sidebar/img-3.jpg');\r\n    }\r\n}\r\n[data-sidebar-image=\"img-4\"]{\r\n    .sidebar-background { \r\n        background-image: url('../../images/sidebar/img-4.jpg');\r\n    }\r\n}","//\r\n// _horizontal.scss\r\n// \r\n\r\n[data-layout=\"horizontal\"] {\r\n\r\n    .main-content {\r\n        margin-left: 0;\r\n    }\r\n\r\n    @media (min-width: 1024.1px) {\r\n\r\n        .layout-width,\r\n        .container-fluid {\r\n            max-width: 90%;\r\n            margin: 0 auto;\r\n        }\r\n\r\n        .topnav-hamburger {\r\n            visibility: hidden;\r\n        }\r\n    }\r\n\r\n    .horizontal-logo {\r\n        padding-left: calc(#{$grid-gutter-width} / 2);\r\n\r\n        @media (max-width: 1024.98px) {\r\n            padding-left: $grid-gutter-width;\r\n        }\r\n    }\r\n\r\n    .navbar-menu {\r\n        background: $topnav-bg;\r\n        border-right-color: transparent;\r\n        padding: 0 calc(#{$grid-gutter-width} / 2);\r\n        box-shadow: $horizontal-menu-box-shadow;\r\n        margin-top: $header-height;\r\n        position: fixed;\r\n        left: 0;\r\n        right: 0;\r\n        z-index: 100;\r\n        width: 100%;\r\n        bottom: auto;\r\n\r\n        @media (max-width:575.98px) {\r\n            .container-fluid {\r\n                padding: 0;\r\n            }\r\n        }\r\n\r\n        .navbar-nav {\r\n            flex-direction: row;\r\n\r\n            .nav-sm {\r\n                padding-left: 0;\r\n\r\n                .nav-link {\r\n                    &:before {\r\n                        opacity: 0 !important;\r\n                    }\r\n\r\n                    &:hover,\r\n                    &.active {\r\n                        color: $topnav-item-color-active;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .nav-link {\r\n                color: $topnav-item-color;\r\n                padding: $horizontal-menu-item-padding-y $horizontal-menu-item-padding-x;\r\n\r\n                i {\r\n                    line-height: 1;\r\n                }\r\n\r\n                &.active {\r\n                    color: $topnav-item-color-active;\r\n                    &:after {\r\n                        color: $topnav-item-color-active;\r\n                    }\r\n                    .icon-dual {\r\n                        color: $topnav-item-color-active;\r\n                        fill: rgba($primary, 0.10);\r\n                    }\r\n                }\r\n\r\n                &[data-bs-toggle=collapse][aria-expanded=true] {\r\n                    color: $topnav-item-color-active;\r\n\r\n                    .icon-dual {\r\n                        color: $topnav-item-color-active;\r\n                        fill: rgba($primary, 0.10);\r\n                    }\r\n\r\n                    &:after {\r\n                        color: $topnav-item-color-active;\r\n                    }\r\n                }\r\n\r\n                &:hover {\r\n                    .icon-dual {\r\n                        color: $topnav-item-color-active;\r\n                        fill: rgba($primary, 0.10);\r\n                    }\r\n                }\r\n            }\r\n\r\n            >.nav-item {\r\n                >.nav-link[data-bs-toggle=collapse]:after {\r\n                    right: 0px;\r\n                    transform: rotate(90deg) !important;\r\n                }\r\n            }\r\n\r\n            >li:nth-of-type(2) {\r\n                >.nav-link.menu-link {\r\n                    padding-left: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        .navbar-brand-box {\r\n            display: none;\r\n        }\r\n    }\r\n\r\n    .navbar-nav {\r\n        .nav-item {\r\n            position: relative;\r\n\r\n            .nav-link[data-bs-toggle=collapse]:after {\r\n                right: 10px;\r\n                transform: rotate(0deg) !important;\r\n            }\r\n\r\n            >.nav-link {\r\n                >.badge {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            &:hover {\r\n                >.nav-link {\r\n                    color: $topnav-item-color-active;\r\n\r\n                    .icon-dual {\r\n                        color: $topnav-item-color-active;\r\n                        fill: rgba($primary, 0.10);\r\n                    }\r\n\r\n                    &:after {\r\n                        color: $topnav-item-color-active;\r\n                    }\r\n                }\r\n\r\n                @media (min-width: 1024.1px) {>.menu-dropdown {\r\n                        display: block;\r\n                        height: auto !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            &.active {\r\n                color: $topnav-item-color-active;\r\n            }\r\n        }\r\n    }\r\n\r\n    .menu-dropdown {\r\n        position: absolute;\r\n        min-width: $horizontal-menu-dropdown-min-width;\r\n        padding: $dropdown-padding-y $dropdown-padding-x;\r\n        box-shadow: $horizontal-menu-dropdown-box-shadow;\r\n        animation-name: DropDownSlide;\r\n        animation-duration: .3s;\r\n        animation-fill-mode: both;\r\n        margin: 0;\r\n        z-index: $zindex-dropdown;\r\n        background-color: var(--#{$prefix}choices-bg);\r\n        background-clip: padding-box;\r\n        border: $dropdown-border-width solid $dropdown-border-color;\r\n        border-radius: $dropdown-border-radius;\r\n        display: none;\r\n\r\n        .menu-dropdown {\r\n            top: 0;\r\n            left: 100%;\r\n        }\r\n    }\r\n\r\n    .mega-dropdown-menu {\r\n        width: 40rem;\r\n    }\r\n\r\n    .menu-title {\r\n        display: none;\r\n    }\r\n\r\n    .dropdown-custom-right {\r\n        left: -100% !important;\r\n        right: 100%;\r\n    }\r\n\r\n    @media (max-width: 1024px) {\r\n        .navbar-menu {\r\n            display: none;\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout=\"horizontal\"] {\r\n    .menu {\r\n        @media (max-width: 1024px) {\r\n            .navbar-menu {\r\n                display: block;\r\n                max-height: 360px;\r\n                overflow-y: auto;\r\n                padding-left: 0;\r\n\r\n                .navbar-nav {\r\n                    flex-direction: column;\r\n>li:nth-of-type(2)>.nav-link.menu-link {\r\n                        padding-left: $vertical-menu-item-padding-x;\r\n                    }\r\n\r\n                    .nav-sm .nav-link:before {\r\n                        opacity: 1 !important;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .menu-dropdown {\r\n                position: relative;\r\n                min-width: 100%;\r\n                box-shadow: none;\r\n                padding-left: 28px;\r\n                left: 0;\r\n                animation: none;\r\n                padding-top: 0;\r\n\r\n                &.show {\r\n                    display: block;\r\n                }\r\n            }\r\n\r\n            .dropdown-custom-right {\r\n                left: 0 !important;\r\n            }\r\n\r\n            .nav-item .nav-link[data-bs-toggle=collapse]:after {\r\n                right: 0px;\r\n            }\r\n\r\n            .mega-dropdown-menu {\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// theme dark\r\n[data-layout-mode=\"dark\"] {\r\n    &[data-topbar=\"light\"] {\r\n        .navbar-header {\r\n            .horizontal-logo {\r\n                .logo-dark {\r\n                    display: none;\r\n                }\r\n\r\n                .logo-light {\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// rtl\r\n[dir=\"rtl\"]{\r\n    &[data-layout=horizontal] {\r\n        .navbar-menu {\r\n            .navbar-nav>.nav-item>.nav-link[data-bs-toggle=collapse]{\r\n                &:after{\r\n                    transform: rotate(-90deg) !important;\r\n                }\r\n            }\r\n        }\r\n\r\n        .navbar-nav{\r\n            .nav-item {\r\n                .nav-link[data-bs-toggle=collapse]{\r\n                    &:after{\r\n                        transform: rotate(-180deg)!important;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// _two-column.scss\r\n// \r\n\r\n[data-layout=\"twocolumn\"] {\r\n    .app-menu {\r\n        padding-bottom: 0;\r\n        width: $twocolumn-menu-width;\r\n        left: $twocolumn-menu-iconview-width;\r\n\r\n        .menu-link {\r\n            letter-spacing: .05em;\r\n            cursor: default;\r\n            font-size: 11px;\r\n            text-transform: uppercase;\r\n            color: $vertical-menu-title-color !important;\r\n            font-weight: $font-weight-semibold;\r\n\r\n            &:after {\r\n                display: none !important;\r\n            }\r\n\r\n            i {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .navbar-nav {\r\n            height: calc(100vh - #{$header-height});\r\n\r\n            @media (max-width: 767.98px) {\r\n                padding-top: 16px;\r\n            }\r\n\r\n            >li:not(.twocolumn-item-show) {\r\n                display: none;\r\n            }\r\n\r\n            .twocolumn-item-show {\r\n                >div {\r\n                    display: block !important;\r\n                    height: auto !important;\r\n                }\r\n            }\r\n\r\n            >.nav-item {\r\n                >.menu-dropdown {\r\n                    display: block !important;\r\n                    height: auto !important;\r\n                }\r\n            }\r\n\r\n            .nav-item {\r\n                .menu-dropdown {\r\n                    .row {\r\n                        margin: 0;\r\n\r\n                        .col-lg-4 {\r\n                            width: 100%;\r\n                            padding: 0;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .nav-sm {\r\n                .nav-link {\r\n                    color: $vertical-menu-item-color;\r\n\r\n                    &.active {\r\n                        color: $vertical-menu-item-active-color;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .container-fluid {\r\n            padding: 0;\r\n        }\r\n    }\r\n\r\n    .main-content {\r\n        margin-left: calc(#{$twocolumn-menu-width} + #{$twocolumn-menu-iconview-width});\r\n\r\n        @media (max-width:767.98px) {\r\n            margin-left: $twocolumn-menu-iconview-width;\r\n        }\r\n    }\r\n\r\n    .twocolumn-iconview {\r\n        width: $twocolumn-menu-iconview-width;\r\n        background-color: $twocolumn-menu-iconview-bg;\r\n        height: 100%;\r\n        left: -$twocolumn-menu-iconview-width;\r\n        box-shadow: $twocolumn-menu-box-shadow;\r\n        top: 0;\r\n        position: absolute;\r\n        padding: 0;\r\n        text-align: center;\r\n\r\n        li {\r\n            position: relative;\r\n            list-style: none;\r\n\r\n            .nav-icon {\r\n                &::after {\r\n                    content: \"\";\r\n                    position: absolute;\r\n                    top: 0;\r\n                    right: 0;\r\n                    bottom: 0;\r\n                    left: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        .nav-icon {\r\n            width: 42px;\r\n            height: 42px;\r\n            line-height: 42px;\r\n            color: $vertical-menu-item-color;\r\n            z-index: 1;\r\n            font-size: 22px;\r\n            text-align: center;\r\n            border-radius: 3px;\r\n            margin: 5px 0;\r\n            display: inline-flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n\r\n            .icon-dual {\r\n                width: 18px;\r\n                color: $vertical-menu-item-color;\r\n            }\r\n\r\n            &.active {\r\n                background-color: rgba($primary, 0.15);\r\n                color: $primary;\r\n\r\n                .icon-dual {\r\n                    color: $primary;\r\n                    fill: rgba($primary, 0.10);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .menu-title {\r\n        display: none;\r\n    }\r\n\r\n    @media (max-width: 991.98px) {\r\n        .logo {\r\n\r\n            span.logo-lg {\r\n                display: block;\r\n            }\r\n\r\n            span.logo-sm {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar=\"light\"] {\r\n        .app-menu {\r\n            .navbar-brand-box {\r\n                .logo-light {\r\n                    display: none;\r\n                }\r\n\r\n                .logo-dark {\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar=\"dark\"] {\r\n        .twocolumn-iconview {\r\n            background-color: $twocolumn-menu-iconview-bg-dark;\r\n\r\n            .nav-icon {\r\n                color: $twocolumn-menu-item-color-dark;\r\n\r\n                &.active {\r\n                    color: $twocolumn-menu-item-active-color-dark;\r\n                    background-color: $twocolumn-menu-item-active-bg-dark;\r\n                }\r\n            }\r\n        }\r\n\r\n        .app-menu {\r\n            background-color: $twocolumn-menu-bg-dark;\r\n            border-right-color: $twocolumn-menu-border-dark;\r\n\r\n            .navbar-brand-box {\r\n                .logo-light {\r\n                    display: block;\r\n                }\r\n\r\n                .logo-dark {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            .navbar-nav {\r\n                .nav-sm {\r\n                    .nav-link {\r\n                        color: $twocolumn-menu-item-color-dark;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .navbar-menu {\r\n            .navbar-nav {\r\n                .nav-sm {\r\n                    .nav-link {\r\n\r\n                        &:hover,\r\n                        &.active {\r\n                            color: $twocolumn-menu-item-active-color-dark;\r\n\r\n                            &::before {\r\n                                background-color: $twocolumn-menu-item-active-color-dark !important;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .nav-link {\r\n                    &[data-bs-toggle=collapse][aria-expanded=true] {\r\n                        color: $twocolumn-menu-item-active-color-dark;\r\n\r\n                        &:before {\r\n                            background-color: $twocolumn-menu-item-active-color-dark;\r\n                        }\r\n\r\n                        &::after {\r\n                            color: $twocolumn-menu-item-active-color-dark !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar=\"gradient\"], &[data-sidebar=\"gradient-2\"], &[data-sidebar=\"gradient-3\"], &[data-sidebar=\"gradient-4\"] {\r\n        .twocolumn-iconview {\r\n            background-color: $twocolumn-menu-iconview-bg-dark;\r\n    \r\n            .nav-icon {\r\n                color: $twocolumn-menu-item-color-gradient;\r\n    \r\n                &.active {\r\n                    color: $twocolumn-menu-item-active-color-dark;\r\n                    background-color: $twocolumn-menu-item-active-bg-dark;\r\n                }\r\n            }\r\n        }\r\n    \r\n        .app-menu {\r\n            background-color: $twocolumn-menu-bg-dark;\r\n            border-right-color: $twocolumn-menu-border-dark;\r\n    \r\n            .navbar-brand-box {\r\n                .logo-light {\r\n                    display: block;\r\n                }\r\n    \r\n                .logo-dark {\r\n                    display: none;\r\n                }\r\n            }\r\n    \r\n            .navbar-nav {\r\n                .nav-sm {\r\n                    .nav-link {\r\n                        color: $twocolumn-menu-item-color-gradient;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    \r\n        .navbar-menu {\r\n            .navbar-nav {\r\n                .nav-sm {\r\n                    .nav-link {\r\n    \r\n                        &:hover,\r\n                        &.active {\r\n                            color: $twocolumn-menu-item-active-color-dark;\r\n    \r\n                            &::before {\r\n                                background-color: $twocolumn-menu-item-active-color-dark !important;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n    \r\n                .nav-link {\r\n                    &[data-bs-toggle=collapse][aria-expanded=true] {\r\n                        color: $twocolumn-menu-item-active-color-dark;\r\n    \r\n                        &:before {\r\n                            background-color: $twocolumn-menu-item-active-color-dark;\r\n                        }\r\n    \r\n                        &::after {\r\n                            color: $twocolumn-menu-item-active-color-dark !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &[data-layout-mode=\"dark\"] {\r\n            .app-menu {\r\n                border-right-color: $gray-700; \r\n            }\r\n        }\r\n    }\r\n\r\n    .twocolumn-panel {\r\n        .app-menu {\r\n            width: 0;\r\n            border-right: 0;\r\n\r\n            @media (max-width: 575.98px) {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .navbar-brand-box,\r\n        .navbar-nav {\r\n            display: none;\r\n        }\r\n\r\n        .main-content {\r\n            margin-left: $twocolumn-menu-iconview-width;\r\n        }\r\n\r\n        #page-topbar,\r\n        .footer {\r\n            left: $twocolumn-menu-iconview-width;\r\n        }\r\n\r\n        @media (max-width: 575.98px) {\r\n            .main-content {\r\n                margin-left: 0;\r\n            }\r\n\r\n            #page-topbar,\r\n            .footer {\r\n                left: 0;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    #page-topbar,\r\n    .footer {\r\n        @media (max-width: 767.98px) {\r\n            left: $twocolumn-menu-iconview-width;\r\n        }\r\n    }\r\n\r\n    @media (max-width: 575.98px) {\r\n        .main-content {\r\n            margin-left: 0;\r\n        }\r\n\r\n        #page-topbar,\r\n        .footer {\r\n            left: 0;\r\n        }\r\n    }\r\n}","// \r\n// _layouts.scss\r\n// \r\n\r\n[data-layout-width=\"boxed\"] {\r\n    body {\r\n        background-color: $boxed-body-bg;\r\n    }\r\n\r\n    #layout-wrapper {\r\n        max-width: $boxed-layout-width;\r\n        margin: 0 auto;\r\n        box-shadow: $box-shadow;\r\n        background-color: var(--#{$prefix}body-bg);\r\n    }\r\n\r\n    &[data-layout=\"vertical\"] {\r\n        #layout-wrapper {\r\n            min-height: 100vh;\r\n        }\r\n    }\r\n\r\n    #page-topbar,\r\n    .footer {\r\n        max-width: $boxed-layout-width;\r\n        margin: 0 auto;\r\n        left: 0 !important;\r\n    }\r\n\r\n    &[data-sidebar-size=\"sm-hover\"],\r\n    &[data-sidebar-size=\"sm\"] {\r\n        &[data-layout=\"vertical\"] {\r\n            @media (min-width: 768px) {\r\n                #layout-wrapper {\r\n                    min-height: 1400px;\r\n                }\r\n            }\r\n\r\n            .main-content {\r\n                @media (max-width: 767.98px) {\r\n                    margin-left: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        #page-topbar,\r\n        .footer {\r\n            left: 0 !important;\r\n            max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width-sm});\r\n\r\n            @media (min-width: 768px) {\r\n                left: $vertical-menu-width-sm !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar-size=\"sm-hover-active\"],\r\n    &[data-sidebar-size=\"lg\"] {\r\n\r\n        #page-topbar,\r\n        .footer {\r\n            max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width});\r\n\r\n            @media (min-width: 768px) {\r\n                left: $vertical-menu-width !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar-size=\"md\"] {\r\n\r\n        #page-topbar,\r\n        .footer {\r\n            max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width-md});\r\n\r\n            @media (min-width: 768px) {\r\n                left: $vertical-menu-width-md !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    // deteched\r\n\r\n    &[data-layout=vertical][data-layout-style=detached] {\r\n        body {\r\n            background-color: var(--#{$prefix}body-bg);\r\n        }\r\n\r\n        @media (min-width: 1024.1px) {\r\n            #layout-wrapper {\r\n                max-width: 1300px;\r\n                box-shadow: none;\r\n            }\r\n\r\n            .layout-width {\r\n                max-width: 1300px;\r\n            }\r\n        }\r\n\r\n        &[data-sidebar-size=\"sm-hover\"],\r\n        &[data-sidebar-size=\"sm\"],\r\n        &[data-sidebar-size=\"md\"],\r\n        &[data-sidebar-size=\"lg\"] {\r\n\r\n            #page-topbar,\r\n            .footer {\r\n                max-width: 100%;\r\n                left: 0 !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Horizontal Boxed Layout\r\n\r\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"] {\r\n\r\n    #page-topbar,\r\n    #layout-wrapper,\r\n    .footer {\r\n        max-width: 100%;\r\n    }\r\n\r\n    .container-fluid,\r\n    .navbar-header {\r\n        max-width: $boxed-layout-width;\r\n    }\r\n\r\n    .navbar-header {\r\n        padding: 0 calc(#{$grid-gutter-width} / 2) 0 0;\r\n    }\r\n\r\n    &[data-sidebar-size=\"sm-hover\"],\r\n    &[data-sidebar-size=\"sm\"] &[data-sidebar-size=\"sm-hover-active\"],\r\n    &[data-sidebar-size=\"lg\"] {\r\n\r\n        #page-topbar,\r\n        .footer {\r\n            left: 0 !important;\r\n        }\r\n    }\r\n}\r\n\r\n// Scrollable layout\r\n\r\n[data-layout-position=\"scrollable\"] {\r\n    @media (min-width: 992px) {\r\n\r\n        #page-topbar,\r\n        .navbar-menu {\r\n            position: absolute;\r\n        }\r\n    }\r\n\r\n    &[data-layout=\"horizontal\"] {\r\n        @media (min-width: 992px) {\r\n\r\n            #page-topbar,\r\n            .topnav {\r\n                position: absolute;\r\n            }\r\n        }\r\n    }\r\n}","\r\n/*!\r\n * Waves v0.7.6\r\n * http://fian.my.id/Waves \r\n * \r\n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \r\n * Released under the MIT license \r\n * https://github.com/fians/Waves/blob/master/LICENSE */\r\n .waves-effect {\r\n    position: relative;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    -webkit-tap-highlight-color: transparent;\r\n  }\r\n  .waves-effect .waves-ripple {\r\n    position: absolute;\r\n    border-radius: 50%;\r\n    width: 100px;\r\n    height: 100px;\r\n    margin-top: -50px;\r\n    margin-left: -50px;\r\n    opacity: 0;\r\n    background: rgba(0, 0, 0, 0.2);\r\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    -webkit-transition: all 0.5s ease-out;\r\n    -moz-transition: all 0.5s ease-out;\r\n    -o-transition: all 0.5s ease-out;\r\n    transition: all 0.5s ease-out;\r\n    -webkit-transition-property: -webkit-transform, opacity;\r\n    -moz-transition-property: -moz-transform, opacity;\r\n    -o-transition-property: -o-transform, opacity;\r\n    transition-property: transform, opacity;\r\n    -webkit-transform: scale(0) translate(0, 0);\r\n    -moz-transform: scale(0) translate(0, 0);\r\n    -ms-transform: scale(0) translate(0, 0);\r\n    -o-transform: scale(0) translate(0, 0);\r\n    transform: scale(0) translate(0, 0);\r\n    pointer-events: none;\r\n  }\r\n  .waves-effect.waves-light .waves-ripple {\r\n    background: rgba(255, 255, 255, 0.4);\r\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n  }\r\n  .waves-effect.waves-classic .waves-ripple {\r\n    background: rgba(0, 0, 0, 0.2);\r\n  }\r\n  .waves-effect.waves-classic.waves-light .waves-ripple {\r\n    background: rgba(255, 255, 255, 0.4);\r\n  }\r\n  .waves-notransition {\r\n    -webkit-transition: none !important;\r\n    -moz-transition: none !important;\r\n    -o-transition: none !important;\r\n    transition: none !important;\r\n  }\r\n  .waves-button,\r\n  .waves-circle {\r\n    -webkit-transform: translateZ(0);\r\n    -moz-transform: translateZ(0);\r\n    -ms-transform: translateZ(0);\r\n    -o-transform: translateZ(0);\r\n    transform: translateZ(0);\r\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\r\n  }\r\n  .waves-button,\r\n  .waves-button:hover,\r\n  .waves-button:visited,\r\n  .waves-button-input {\r\n    white-space: nowrap;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n    border: none;\r\n    outline: none;\r\n    color: inherit;\r\n    background-color: rgba(0, 0, 0, 0);\r\n    font-size: 1em;\r\n    line-height: 1em;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    z-index: 1;\r\n  }\r\n  .waves-button {\r\n    padding: 0.85em 1.1em;\r\n    border-radius: 0.2em;\r\n  }\r\n  .waves-button-input {\r\n    margin: 0;\r\n    padding: 0.85em 1.1em;\r\n  }\r\n  .waves-input-wrapper {\r\n    border-radius: 0.2em;\r\n    vertical-align: bottom;\r\n  }\r\n  .waves-input-wrapper.waves-button {\r\n    padding: 0;\r\n  }\r\n  .waves-input-wrapper .waves-button-input {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1;\r\n  }\r\n  .waves-circle {\r\n    text-align: center;\r\n    width: 2.5em;\r\n    height: 2.5em;\r\n    line-height: 2.5em;\r\n    border-radius: 50%;\r\n  }\r\n  .waves-float {\r\n    -webkit-mask-image: none;\r\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\r\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\r\n    -webkit-transition: all 300ms;\r\n    -moz-transition: all 300ms;\r\n    -o-transition: all 300ms;\r\n    transition: all 300ms;\r\n  }\r\n  .waves-float:active {\r\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\r\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\r\n  }\r\n  .waves-block {\r\n    display: block;\r\n  }\r\n\r\n.waves-effect.waves-light {\r\n    .waves-ripple {\r\n        background-color: rgba($white, 0.4);\r\n    }\r\n}\r\n\r\n.waves-effect.waves-primary {\r\n    .waves-ripple {\r\n        background-color: rgba($primary, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-success {\r\n    .waves-ripple {\r\n        background-color: rgba($success, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-info {\r\n    .waves-ripple {\r\n        background-color: rgba($info, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-warning {\r\n    .waves-ripple {\r\n        background-color: rgba($warning, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-danger {\r\n    .waves-ripple {\r\n        background-color: rgba($danger, 0.4);\r\n    }\r\n}","//\r\n// avatar.scss\r\n//\r\n\r\n.avatar-xxs {\r\n    height: 1.5rem;\r\n    width: 1.5rem;\r\n}\r\n\r\n.avatar-xs {\r\n    height: 2rem;\r\n    width: 2rem;\r\n}\r\n\r\n.avatar-sm {\r\n    height: 3rem;\r\n    width: 3rem;\r\n}\r\n\r\n.avatar-md {\r\n    height: 4.5rem;\r\n    width: 4.5rem;\r\n}\r\n\r\n.avatar-lg {\r\n    height: 6rem;\r\n    width: 6rem;\r\n}\r\n\r\n.avatar-xl {\r\n    height: 7.5rem;\r\n    width: 7.5rem;\r\n}\r\n\r\n.avatar-title {\r\n    align-items: center;\r\n    background-color: $primary;\r\n    color: $white;\r\n    display: flex;\r\n    font-weight: $font-weight-medium;\r\n    height: 100%;\r\n    justify-content: center;\r\n    width: 100%;\r\n}\r\n\r\n// avatar group\r\n.avatar-group {\r\n    padding-left: 12px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n\r\n    .avatar-group-item {\r\n        margin-left: -12px;\r\n        border: 2px solid var(--#{$prefix}card-bg-custom);\r\n        border-radius: 50%;\r\n        transition: all 0.2s;\r\n\r\n        &:hover {\r\n            position: relative;\r\n            transform: translateY(-2px);\r\n            z-index: 1;\r\n        }\r\n    }\r\n}","//\r\n// accordion.scss\r\n//\r\n\r\n.accordion {\r\n    .accordion-button {\r\n        font-weight: $font-weight-medium;\r\n    }\r\n\r\n    .accordion-body {\r\n        color: $text-muted;\r\n    }\r\n\r\n    &.accordion-icon-none {\r\n        .accordion-button {\r\n            &::after {\r\n                content: \"\";\r\n                background-image: none !important;\r\n            }\r\n\r\n            &:not(.collapsed) {\r\n                &::after {\r\n                    content: \"\";\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Accordion with icon\r\n\r\n.custom-accordionwithicon {\r\n    .accordion-button {\r\n        &::after {\r\n            background-image: none !important;\r\n            font-family: \"Material Design Icons\";\r\n            content: \"\\F0142\";\r\n            font-size: 1.1rem;\r\n            vertical-align: middle;\r\n            line-height: 0.8;\r\n        }\r\n\r\n        &:not(.collapsed) {\r\n            &::after {\r\n                background-image: none !important;\r\n                content: \"\\F0140\";\r\n                margin-right: -3px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Accordion with plus icon\r\n\r\n.custom-accordionwithicon-plus {\r\n    .accordion-button {\r\n        &::after {\r\n            background-image: none !important;\r\n            font-family: \"Material Design Icons\";\r\n            content: \"\\F0415\";\r\n            font-size: 1.1rem;\r\n            vertical-align: middle;\r\n            line-height: 0.8;\r\n        }\r\n\r\n        &:not(.collapsed) {\r\n            &::after {\r\n                background-image: none !important;\r\n                content: \"\\F0374\";\r\n                margin-right: -3px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// left Icon accordion\r\n\r\n.lefticon-accordion {\r\n    .accordion-button {\r\n        padding-left: 2.75rem;\r\n\r\n        &::after {\r\n            position: absolute;\r\n            left: $accordion-button-padding-x;\r\n            top: 14px;\r\n        }\r\n\r\n        &:not(.collapsed) {\r\n            &::after {\r\n                top: 20px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// border accordion\r\n\r\n.accordion-border-box {\r\n    .accordion-item {\r\n        border-top: $accordion-border-width solid $accordion-border-color;\r\n        border-radius: $accordion-border-radius;\r\n\r\n        &:not(:first-of-type) {\r\n            margin-top: 8px;\r\n        }\r\n\r\n        .accordion-button {\r\n            border-radius: $accordion-border-radius;\r\n\r\n            &:not(.collapsed) {\r\n                border-bottom-left-radius: 0;\r\n                border-bottom-right-radius: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.custom-accordion-border {\r\n    .accordion-item {\r\n        border-left: 3px solid $accordion-border-color;\r\n    }\r\n}\r\n\r\n//accordion Color \r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .accordion-#{$color} {\r\n        .accordion-item {\r\n            border-color: rgba($value, 0.6);\r\n\r\n            .accordion-button {\r\n                box-shadow: none;\r\n\r\n                &:not(.collapsed) {\r\n                    color: $value;\r\n                    background-color: rgba($value, 0.1) !important;\r\n                }\r\n\r\n                &::after {\r\n                    color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .accordion-fill-#{$color} {\r\n        .accordion-item {\r\n            .accordion-button {\r\n                box-shadow: none;\r\n\r\n                &:not(.collapsed) {\r\n                    color: $white;\r\n                    background-color: $value !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// theme dark\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .accordion-button {\r\n        &:not(.collapsed) {\r\n            color: var(--#{$prefix}accordion-button-active-color);\r\n            &:after{\r\n                background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$white}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\"));\r\n            }\r\n        }\r\n\r\n        &:after{\r\n            background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$gray-500}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\"));\r\n        }\r\n    }\r\n}\r\n\r\n// rtl\r\n[dir=\"rtl\"]{\r\n    .custom-accordionwithicon {\r\n        .accordion-button::after{\r\n            transform: rotate(180deg);\r\n        }\r\n    }\r\n}","//\r\n// _helper.scss\r\n//\r\n\r\n$font-size-mixing: 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 36, 48;\r\n\r\n@each $font-size-mixing in $font-size-mixing {\r\n  .fs-#{$font-size-mixing} {\r\n    font-size: #{$font-size-mixing}px !important;\r\n  }\r\n}\r\n\r\n// border-color\r\n.border-dark {\r\n    border-color: var(--#{$prefix}dark)!important;\r\n}\r\n.border-light {\r\n    border-color: var(--#{$prefix}light)!important;\r\n}\r\n\r\n// Border Style\r\n$border-style-mixing: double, dashed, groove, outset, ridge, dotted, inset;\r\n@each $border-style-mixing in $border-style-mixing {\r\n    .border-#{$border-style-mixing} {\r\n        border-style: #{$border-style-mixing} !important;\r\n    }\r\n    .border-top-#{$border-style-mixing} {\r\n        border-top-style: #{$border-style-mixing} !important;\r\n    }\r\n    .border-bottom-#{$border-style-mixing} {\r\n        border-bottom-style: #{$border-style-mixing} !important;\r\n    }\r\n    .border-end-#{$border-style-mixing} {\r\n        border-right-style: #{$border-style-mixing} !important;\r\n    }\r\n    .border-start-#{$border-style-mixing} {\r\n        border-left-style: #{$border-style-mixing} !important;\r\n    }\r\n    \r\n    // List Group Flush Style\r\n    .list-group-flush {\r\n        &.border-#{$border-style-mixing} { \r\n            border: none !important;\r\n            .list-group-item {\r\n                border-style: #{$border-style-mixing} !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n//link\r\n[data-layout-mode=\"dark\"]{\r\n    .link-dark, .link-light{\r\n        color: var(--#{$prefix}dark) !important;\r\n        &:focus, &:hover{\r\n            color: rgba(var(--#{$prefix}dark-rgb), 0.75) !important;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Font Family\r\n\r\n.ff-base {\r\n    font-family: $font-family-base;\r\n}\r\n\r\n.ff-secondary {\r\n    font-family: $font-family-secondary;\r\n}\r\n\r\n// Font weight help class\r\n\r\n.fw-medium {\r\n    font-weight: $font-weight-medium;\r\n}\r\n\r\n// Flex\r\n\r\n.flex-1 {\r\n    flex: 1;\r\n}\r\n\r\n// Social\r\n\r\n.social-list-item {\r\n    height: 2rem;\r\n    width: 2rem;\r\n    line-height: calc(2rem - 4px);\r\n    display: block;\r\n    border: 2px solid $gray-500;\r\n    border-radius: 50%;\r\n    color: $gray-500;\r\n    text-align: center;\r\n    transition: all 0.4s;\r\n\r\n    &:hover {\r\n        color: $gray-600;\r\n        background-color: $gray-200;\r\n    }\r\n}\r\n\r\n\r\n// Backgroun pattern\r\n.bg-pattern {\r\n    background: url(\"../../images/modal-bg.png\") $modal-content-bg;\r\n}\r\n\r\n// Fixed minimum width\r\n.w-xs {\r\n    min-width: 80px;\r\n}\r\n\r\n.w-sm {\r\n    min-width: 95px;\r\n}\r\n\r\n.w-md {\r\n    min-width: 110px;\r\n}\r\n\r\n.w-lg {\r\n    min-width: 140px;\r\n}\r\n\r\n.w-xl {\r\n    min-width: 160px;\r\n}\r\n\r\n// Icons Sizes\r\n.icon-xs {\r\n    height: 16px;\r\n    width: 16px;\r\n}\r\n\r\n.icon-sm {\r\n    height: 18px;\r\n    width: 18px;\r\n}\r\n\r\n.icon-md {\r\n    height: 22px;\r\n    width: 22px;\r\n}\r\n\r\n.icon-lg {\r\n    height: 24px;\r\n    width: 24px;\r\n}\r\n\r\n.icon-xl {\r\n    height: 28px;\r\n    width: 28px;\r\n}\r\n\r\n.icon-xxl {\r\n    height: 32px;\r\n    width: 32px;\r\n}\r\n\r\n// Dual Icons\r\n.icon-dual {\r\n    color: $gray-500;\r\n    fill: rgba($gray-500,0.16);\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .icon-dual-#{$color} {\r\n        color: $value;\r\n        fill: rgba($value, 0.16);\r\n    }\r\n}\r\n\r\n// Search \r\n.search-box{\r\n    position: relative;\r\n    .form-control{\r\n        padding-left: 40px;\r\n    }\r\n    .search-icon{\r\n        font-size: 14px;\r\n        position: absolute;\r\n        left: 13px;\r\n        top: 0;\r\n        height: 100%;\r\n        display: flex;\r\n        align-items: center;\r\n        color: $text-muted;\r\n    }\r\n}\r\n\r\n\r\n// overlay\r\n\r\n.bg-overlay {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    top: 0;\r\n    opacity: 0.7;\r\n    background-color: $black;\r\n}\r\n\r\n// Btn Customizer\r\n\r\n.customizer-setting {\r\n    position: fixed;\r\n    bottom: 40px;\r\n    right: 20px;\r\n    z-index: 1000;\r\n}\r\n\r\n// \r\ncode {\r\n    user-select: all;\r\n}\r\n\r\n.layout-rightside {\r\n    width: 280px;\r\n    margin-right: -#{$grid-gutter-width};\r\n    margin-top: calc(1px - #{$grid-gutter-width} * 1.1);\r\n    height: calc(100% + #{$grid-gutter-width} * 1.1);\r\n}\r\n\r\n.layout-rightside-col {\r\n\r\n    @media (max-width: 1699.98px) { \r\n        display: none;\r\n        position: fixed !important;\r\n        height: 100vh;\r\n        right: 0px;\r\n        top: 0px;\r\n        bottom: 0px;\r\n        z-index: 1004;\r\n        .overlay{\r\n            position: fixed;\r\n            top: 0;\r\n            right: 0px;\r\n            bottom: 0px;\r\n            left: 0px;\r\n            background-color: rgba($dark, 0.2);\r\n           \r\n        }\r\n        .layout-rightside {\r\n            margin-top: 0px;\r\n            height: 100%;\r\n            margin-left: auto;\r\n        }\r\n        .card-body {\r\n            overflow-y: auto;\r\n            padding-bottom: 1rem !important;\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout=\"horizontal\"], [data-layout-style=detached]{\r\n    @media (min-width: 1700px) {\r\n        .layout-rightside{\r\n            margin-top: calc(28px - #{$grid-gutter-width});\r\n            margin-right: 0;\r\n            height: calc(100% - calc(#{$grid-gutter-width} / 5));\r\n        }\r\n    }\r\n}\r\n\r\n// object fit cover\r\n.object-cover{\r\n    object-fit: cover;\r\n}\r\n\r\n// text-truncate-two-lines\r\n.text-truncate-two-lines{\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    -webkit-line-clamp: 2;\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n    white-space: normal;\r\n}\r\n\r\n// Favourite button \r\n.favourite-btn{\r\n    border-color: transparent;\r\n    .ri-star-fill{\r\n        color: $text-muted;\r\n    }\r\n    &.active{\r\n        border-color: transparent;\r\n        .ri-star-fill{\r\n            color: $warning;\r\n            \r\n            &:before{\r\n                content: \"\\f186\";\r\n            }\r\n        }\r\n    }\r\n}\r\n// card\r\n.card-logo-light{\r\n    display: var(--#{$prefix}card-logo-light);\r\n}\r\n\r\n.card-logo-dark{\r\n    display: var(--#{$prefix}card-logo-dark);\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .btn-close{\r\n        filter: invert(1) grayscale(100%) brightness(200%);\r\n    }\r\n}\r\n\r\n\r\n#back-to-top {\r\n    position: fixed;\r\n    bottom: 100px;\r\n    right: 28px;\r\n    transition: all 0.5s ease;\r\n    display: none;\r\n    z-index: 1000;\r\n    &:hover {\r\n        animation: fade-up 1.5s infinite linear;\r\n    }\r\n}\r\n\r\n@keyframes fade-up {\r\n  0% {\r\n    transform: translateY(0);\r\n    opacity: 1;\r\n  }\r\n\r\n  75% {\r\n    transform: translateY(-20px);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.cursor-pointer {\r\n    cursor: pointer;\r\n}","// \r\n// preloader.scss\r\n//\r\n\r\n#preloader {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n    z-index: 9999;\r\n}\r\n\r\n[data-preloader=\"disable\"] #preloader {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n}\r\n\r\n#status {\r\n    width: 40px;\r\n    height: 40px;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    margin: -20px 0 0 -20px;\r\n}","//\r\n// forms.scss\r\n//\r\n\r\n[type=\"tel\"],\r\n[type=\"url\"],\r\n[type=\"email\"],\r\n[type=\"number\"] {\r\n    &::placeholder {\r\n        text-align: left /*rtl: right*/;\r\n    }\r\n}\r\n","// \r\n// Widgets.scss\r\n// \r\n\r\n.main-chart {\r\n    .chart-border-left {\r\n        border-left: 1.4px solid $border-color;\r\n        padding: 2px 20px;\r\n\r\n        &:last-child {\r\n            margin-right: 0px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n/* Activity */\r\n\r\n.activity-feed {\r\n    list-style: none;\r\n\r\n    .feed-item {\r\n        position: relative;\r\n        padding-bottom: 27px;\r\n        padding-left: 16px;\r\n        border-left: 2px solid $light;\r\n\r\n        &:after {\r\n            content: \"\";\r\n            display: block;\r\n            position: absolute;\r\n            top: 4px;\r\n            left: -6px;\r\n            width: 10px;\r\n            height: 10px;\r\n            border-radius: 50%;\r\n            border: 2px solid $primary;\r\n            background-color: $card-bg;\r\n        }\r\n\r\n        &:last-child {\r\n            border-color: transparent;\r\n        }\r\n    }\r\n}\r\n\r\n// mini-stats-wid\r\n.mini-stats-wid {\r\n    position: relative;\r\n\r\n    .mini-stat-icon {\r\n        overflow: hidden;\r\n        position: relative;\r\n\r\n        &:before,\r\n        &:after {\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 8px;\r\n            height: 69px;\r\n            background-color: rgba($success, .1);\r\n            left: 3px;\r\n            transform: rotate(32deg);\r\n            top: -8px;\r\n            transition: all 0.4s;\r\n        }\r\n\r\n        &::after {\r\n            left: 27px;\r\n            width: 8px;\r\n            transition: all 0.2s;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        .mini-stat-icon {\r\n            &::after {\r\n                left: 60px;\r\n            }\r\n\r\n            &::before {\r\n                left: 50px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// credit card widget\r\n.card-wrapper{\r\n    .jp-card{\r\n        .jp-card-back, .jp-card-front{\r\n            background-color: $success;\r\n        }\r\n    }\r\n}\r\n\r\n.notification-elem{\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    visibility: hidden;\r\n    opacity: 0;\r\n}\r\n\r\n//ecommerce widgets\r\n.clothes-size {\r\n    li {\r\n        input[type=\"radio\"] {\r\n            display: none;\r\n        }\r\n\r\n        label {\r\n            display: inline-block;\r\n            font-size: 14px;\r\n            border-radius: 5px;\r\n            border: 1px solid $border-color;\r\n            text-transform: none;\r\n            letter-spacing: 0;\r\n            color: $primary;\r\n        }\r\n\r\n        input[type=\"radio\"]:checked+label {\r\n            background-color: $primary;\r\n            border-color: $primary;\r\n            color: $white;\r\n        }\r\n    }\r\n}","// \r\n// _demos.scss\r\n// \r\n\r\n// Buttons demo\r\n.button-items {\r\n    margin-left: -8px;\r\n    margin-bottom: -12px;\r\n\r\n    .btn {\r\n        margin-bottom: 12px;\r\n        margin-left: 8px;\r\n    }\r\n}\r\n\r\n// Modals\r\n.bs-example-modal {\r\n    position: relative;\r\n    top: auto;\r\n    right: auto;\r\n    bottom: auto;\r\n    left: auto;\r\n    z-index: 1;\r\n    display: block;\r\n}\r\n\r\n[dir=\"rtl\"] {\r\n    .modal-open {\r\n        padding-left: 0px !important;\r\n    }\r\n}\r\n\r\n// Icon demo ( Demo only )\r\n.icon-demo-content {\r\n    color: var(--#{$prefix}gray-500);\r\n\r\n    i {\r\n        font-size: 24px;\r\n        margin-right: 10px;\r\n        color: var(--#{$prefix}gray-600);\r\n        transition: all 0.4s;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    svg {\r\n        margin-right: 10px;\r\n        transition: all 0.4s;\r\n        height: 20px;\r\n    }\r\n\r\n    .col-lg-4 {\r\n        margin-top: 24px;\r\n\r\n        &:hover {\r\n            i, svg {\r\n                color: $primary;\r\n                transform: scale(1.5);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Grid\r\n\r\n.grid-structure {\r\n    .grid-container {\r\n        background-color: $gray-100;\r\n        margin-top: 10px;\r\n        font-size: .8rem;\r\n        font-weight: $font-weight-medium;\r\n        padding: 10px 20px;\r\n    }\r\n}\r\n\r\n// customizer switch\r\n\r\n.img-switch{\r\n    .card-radio{\r\n        .form-check-input {\r\n            display: none;\r\n    \r\n            &:checked+.form-check-label {\r\n            &::before{\r\n                content: \"\";\r\n                position: absolute;\r\n                top: 0;\r\n                right: 0;\r\n                bottom: 0;\r\n                left: 0;\r\n                background-color: rgba($primary, 0.5);\r\n            }\r\n            &::after{\r\n                content: '\\eb80';\r\n                font-family: \"remixicon\";\r\n                position: absolute;\r\n                top: 50%;\r\n                left: 50%;\r\n                transform: translateY(-50%) translateX(-50%);\r\n                font-size: 18px;\r\n                color: $white;\r\n            }\r\n        }\r\n        }\r\n    }\r\n}\r\n\r\n[data-bs-target=\"#collapseBgGradient\"]{\r\n    &.active{\r\n        border-color: $primary !important;\r\n        &::before{\r\n            content: \"\\eb80\";\r\n            font-family: remixicon;\r\n            position: absolute;\r\n            top: 2px;\r\n            right: 6px;\r\n            font-size: 16px;\r\n            color: $primary;\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .colorscheme-cardradio{\r\n        .form-check-label{\r\n            background-color: var(--#{$prefix}dark);\r\n        }\r\n        .bg-light{\r\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.1)!important;\r\n        }\r\n\r\n        .bg-soft-light {\r\n            background-color: rgba(var(--#{$prefix}dark-rgb),.1)!important;\r\n        }\r\n\r\n        .dark{\r\n            .bg-dark{\r\n                background-color: var(--#{$prefix}card-bg-custom)!important;\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// print.scss\r\n//\r\n\r\n// Used invoice page\r\n@media print {\r\n    .vertical-menu,\r\n    .right-bar,\r\n    .page-title-box,\r\n    .navbar-header,\r\n    .app-menu,\r\n    .footer,\r\n    #back-to-top {\r\n        display: none !important;\r\n    }\r\n    .card-body,\r\n    .main-content,\r\n    .right-bar,\r\n    .page-content,\r\n    body {\r\n        padding: 0;\r\n        margin: 0;\r\n    }\r\n\r\n    .card{\r\n        border: 0;\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    .invoice-details{\r\n        .d-sm-flex{\r\n            display: flex !important;\r\n        }\r\n    }\r\n    .address{\r\n        &.col-sm-6 {\r\n            flex: 0 0 auto !important;\r\n            width: 50% !important;\r\n            max-width: 100% !important;\r\n        }\r\n    }\r\n}","// \r\n// ribbons.scss\r\n//\r\n\r\n.ribbon-box {\r\n    position: relative;\r\n\r\n    .ribbon {\r\n        padding: 5px 12px;\r\n        box-shadow: 2px 5px 10px rgba($dark, 0.15);\r\n        color: $white;\r\n        font-size: $font-size-base;\r\n        font-weight: $font-weight-semibold;\r\n        position: absolute;\r\n        left: -1px;\r\n        top: 5px;\r\n\r\n        &.round-shape {\r\n            border-radius: 0 30px 30px 0;\r\n        }\r\n\r\n        &.ribbon-shape {\r\n            display: inline-block;\r\n\r\n            &::before {\r\n                content: \"\";\r\n                position: absolute;\r\n                right: -17px;\r\n                top: 0;\r\n                border: 14px solid transparent;\r\n            }\r\n\r\n            &::after {\r\n                content: \"\";\r\n                position: absolute;\r\n                right: -17px;\r\n                bottom: 0;\r\n                border: 14px solid transparent;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    // ribbon circle\r\n    &.ribbon-circle {\r\n        .ribbon {\r\n            width: 48px;\r\n            height: 48px;\r\n            border-radius: 50%;\r\n            padding: 0;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            left: 20px;\r\n            top: 20px;\r\n        }\r\n    }\r\n\r\n    // ribbon fill\r\n\r\n    &.ribbon-fill {\r\n        overflow: hidden;\r\n            \r\n        .ribbon {\r\n            transform: rotate(-45deg);\r\n            width: 93px;\r\n            height: 52px;\r\n            left: -36px;\r\n            top: -16px;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: flex-end;\r\n        }\r\n        &.ribbon-sm {\r\n            .ribbon {\r\n                padding: 2px 12px;\r\n                width: 78px;\r\n                height: 42px;\r\n                font-size: 12px;\r\n                box-shadow: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    // right\r\n    &.right {\r\n        .ribbon {\r\n            position: absolute;\r\n            left: auto;\r\n            right: 0;\r\n\r\n            &.round-shape {\r\n                border-radius: 30px 0 0 30px;\r\n            }\r\n\r\n            &.ribbon-shape {\r\n                text-align: right;\r\n\r\n                &::before,\r\n                &::after {\r\n                    right: auto;\r\n                    left: -17px;\r\n                    border-left-color: transparent;\r\n                }\r\n            }\r\n        }\r\n\r\n        &.ribbon-circle {\r\n            .ribbon {\r\n                left: auto;\r\n                right: 20px;\r\n            }\r\n        }\r\n\r\n        .icon-ribbon {\r\n            right: 24px;\r\n            left: auto;\r\n        }\r\n\r\n        &.ribbon-fill {\r\n            .ribbon {\r\n                transform: rotate(45deg);\r\n                right: -38px;\r\n                left: auto;\r\n            }\r\n        }\r\n\r\n        &.ribbon-box {\r\n            .ribbon-two {\r\n                left: auto;\r\n                right: -5px;\r\n\r\n                span {\r\n                    left: auto;\r\n                    right: -21px;\r\n                    transform: rotate(45deg);\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .ribbon-content {\r\n        clear: both;\r\n    }\r\n\r\n    @each $color,\r\n    $value in $theme-colors {\r\n        .ribbon-#{$color} {\r\n            background: ($value);\r\n\r\n            &:before {\r\n                border-color: darken(($value), 10%) transparent transparent;\r\n            }\r\n\r\n            &.ribbon-shape {\r\n                &::before {\r\n                    border-left-color: ($value);\r\n                    border-top-color: ($value);\r\n                }\r\n\r\n                &::after {\r\n                    border-left-color: ($value);\r\n                    border-bottom-color: ($value);\r\n                }\r\n            }\r\n        }\r\n\r\n        &.right {\r\n            .ribbon-#{$color} {\r\n                background: ($value);\r\n\r\n                &.ribbon-shape {\r\n                    &::before {\r\n                        border-right-color: ($value);\r\n                        border-top-color: ($value);\r\n                    }\r\n\r\n                    &::after {\r\n                        border-right-color: ($value);\r\n                        border-bottom-color: ($value);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    // Icon ribbon\r\n\r\n    .icon-ribbon {\r\n        box-shadow: none;\r\n        left: 24px;\r\n        top: -12px;\r\n        font-size: 40px;\r\n        padding: 0;\r\n    }\r\n\r\n\r\n    /* Ribbon two */\r\n    .ribbon-two {\r\n        position: absolute;\r\n        left: -5px;\r\n        top: -5px;\r\n        z-index: 1;\r\n        overflow: hidden;\r\n        width: 75px;\r\n        height: 75px;\r\n        text-align: right;\r\n\r\n        span {\r\n            font-size: 13px;\r\n            color: $white;\r\n            text-align: center;\r\n            line-height: 20px;\r\n            transform: rotate(-45deg);\r\n            width: 100px;\r\n            display: block;\r\n            box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\r\n            position: absolute;\r\n            top: 19px;\r\n            left: -21px;\r\n            font-weight: $font-weight-semibold;\r\n\r\n            &:before {\r\n                content: \"\";\r\n                position: absolute;\r\n                left: 0;\r\n                top: 100%;\r\n                z-index: -1;\r\n                border-right: 3px solid transparent;\r\n                border-bottom: 3px solid transparent;\r\n            }\r\n\r\n            &:after {\r\n                content: \"\";\r\n                position: absolute;\r\n                right: 0;\r\n                top: 100%;\r\n                z-index: -1;\r\n                border-left: 3px solid transparent;\r\n                border-bottom: 3px solid transparent;\r\n            }\r\n        }\r\n    }\r\n\r\n    @each $color,\r\n    $value in $theme-colors {\r\n        .ribbon-two-#{$color} {\r\n\r\n            span {\r\n                background: ($value);\r\n\r\n                &:before {\r\n                    border-left: 3px solid darken(($value), 15%);\r\n                    border-top: 3px solid darken(($value), 15%);\r\n                }\r\n\r\n                &:after {\r\n                    border-right: 3px solid darken(($value), 15%);\r\n                    border-top: 3px solid darken(($value), 15%);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n\r\n.ribbon-box {\r\n    &.right {\r\n        .ribbon-three {\r\n            position: absolute;\r\n            top: -6.1px;\r\n            right: 10px;\r\n            left: auto;\r\n        }\r\n    }\r\n}\r\n\r\n.ribbon-three {\r\n    position: absolute;\r\n    top: -6.1px;\r\n    left: 10px;\r\n\r\n    span {\r\n        position: relative;\r\n        display: block;\r\n        text-align: center;\r\n        color: $white;\r\n        font-size: 14px;\r\n        line-height: 1;\r\n        padding: 12px 8px 10px;\r\n        border-top-right-radius: 8px;\r\n        width: 90px;\r\n\r\n        &::after,\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n        }\r\n\r\n        &::before {\r\n            height: 6px;\r\n            width: 6px;\r\n            left: -6px;\r\n            top: 0;\r\n        }\r\n\r\n        &::after {\r\n            height: 6px;\r\n            width: 8px;\r\n            left: -8px;\r\n            top: 0;\r\n            border-radius: 8px 8px 0 0;\r\n        }\r\n    }\r\n\r\n    &::after {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 0;\r\n        height: 0;\r\n        border-left: 44px solid transparent;\r\n        border-right: 44px solid transparent;\r\n        border-top: 10px solid;\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .ribbon-three-#{$color} {\r\n\r\n        span {\r\n            background: ($value);\r\n\r\n            &:before {\r\n                background: ($value);\r\n            }\r\n\r\n            &:after {\r\n                background: darken($value, 10%);\r\n            }\r\n        }\r\n\r\n        &::after {\r\n            border-top-color: ($value);\r\n        }\r\n    }\r\n}\r\n\r\n//Ribbon Hover\r\n.ribbon-box {\r\n    .trending-ribbon {\r\n        transform: translateX(-50px);\r\n        transition: all 0.5s ease;\r\n\r\n        .trending-ribbon-text {\r\n            transition: all 0.5s ease;\r\n            opacity: 0;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        .trending-ribbon {\r\n            transform: translateX(0);\r\n\r\n            .trending-ribbon-text {\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n    &.right {\r\n        .trending-ribbon {\r\n            transform: translateX(50px);\r\n            transition: all 0.5s ease;\r\n    \r\n            .trending-ribbon-text {\r\n                transition: all 0.5s ease;\r\n                opacity: 0;\r\n            }\r\n        }\r\n    \r\n        &:hover {\r\n            .trending-ribbon {\r\n                transform: translateX(0);\r\n    \r\n                .trending-ribbon-text {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// toast.scss\r\n//\r\n\r\n\r\n// toast\r\n.toast { \r\n    &:not(:last-child) {\r\n      margin-bottom: $toast-padding-x;\r\n    }\r\n}\r\n\r\n@mixin toast-border-variant($bg) {\r\n    .toast-body{\r\n        color: $bg;\r\n        border-bottom: 3px solid $bg;\r\n    }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n    .toast-border-#{$color} {\r\n        @include toast-border-variant($value);\r\n    }\r\n}","//\r\n// scrollspy.scss\r\n//\r\n\r\n// Scrollspy\r\n.scrollspy-example {\r\n  position: relative;\r\n  height: 200px;\r\n  margin-top: .5rem;\r\n  overflow: auto;\r\n}\r\n\r\n.scrollspy-example-2 {\r\n  position: relative;\r\n  height: 370px;\r\n  overflow: auto;\r\n}","// \r\n// reboot.scss\r\n//\r\n\r\nhtml {\r\n    position: relative;\r\n    min-height: 100%;\r\n}\r\n\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n    color: $heading-color;\r\n    font-family: $heading-font-family;\r\n}\r\n\r\na {\r\n    text-decoration: none !important;\r\n}\r\n\r\nlabel {\r\n    font-weight: $font-weight-medium;\r\n    margin-bottom: $form-label-margin-bottom;\r\n}\r\nb,\r\nstrong {\r\n  font-weight: $font-weight-semibold;\r\n}\r\n\r\n// blockquote\r\n\r\n.blockquote {\r\n    padding: 10px 20px;\r\n    border-left: 4px solid var(--#{$prefix}gray-300);\r\n}\r\n\r\n.blockquote-reverse {\r\n    border-left: 0;\r\n    border-right: 4px solid var(--#{$prefix}gray-300);\r\n    text-align: right;\r\n}\r\n\r\n// container\r\n\r\n.container,\r\n.container-lg,\r\n.container-md,\r\n.container-sm,\r\n.container-xl,\r\n.container-xxl {\r\n    @media (min-width: 1200px) {\r\n        max-width: 1140px;\r\n    }\r\n}\r\n\r\n// row\r\n.row>*{\r\n    position: relative;\r\n}\r\n\r\n// mixing\r\n\r\n@function set-color-from-background($color) {\r\n    @if (lightness($color) > 70) {\r\n        @return $color-contrast-dark;\r\n    }\r\n    @else {\r\n        @return $color-contrast-light;\r\n    }\r\n}","//\r\n// alerts.scss\r\n//\r\n\r\n// alert solid\r\n\r\n.alert-solid {\r\n    .alert-link {\r\n        color: $white;\r\n    }\r\n}\r\n\r\n// alert outline\r\n\r\n.alert-outline {\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n    border-width: 2px;\r\n}\r\n\r\n// alert borderless\r\n\r\n.alert-borderless {\r\n    border-width: 0;\r\n}\r\n\r\n// alert-label-icon\r\n\r\n.alert-label-icon {\r\n    position: relative;\r\n    padding-left: 60px;\r\n    border: 0;\r\n\r\n    .label-icon {\r\n        position: absolute;\r\n        width: 45px;\r\n        height: 100%;\r\n        left: 0;\r\n        top: 0;\r\n        background-color: rgba($white, 0.15);\r\n        font-size: 16px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    // label arrow\r\n    &.label-arrow {\r\n        overflow: hidden;\r\n        .label-icon {\r\n            &:after {\r\n                content: \"\";\r\n                position: absolute;\r\n                border: 6px solid transparent;\r\n                border-left-color: $primary;\r\n                right: -12px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Alert border left example\r\n\r\n.alert-border-left {\r\n    border-left: 3px solid;\r\n}\r\n\r\n// alert top border example\r\n\r\n.alert-top-border {\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n    border-color: $border-color;\r\n    border-top: 2px solid;\r\n    color: var(--#{$prefix}body-color);\r\n}\r\n\r\n//alert additional example\r\n\r\n.alert-additional { \r\n    padding: 0;\r\n\r\n    .alert-body{\r\n        padding: $alert-padding-y $alert-padding-x;\r\n    }\r\n    .alert-content {\r\n        padding: $alert-padding-y $alert-padding-x;\r\n        border-bottom-left-radius: $alert-border-radius;\r\n        border-bottom-right-radius: $alert-border-radius;\r\n        margin: 0 (-$alert-border-width) (-$alert-border-width) (-$alert-border-width);\r\n    }\r\n}\r\n\r\n// rounded label example\r\n\r\n.rounded-label {\r\n    .label-icon {\r\n        width: 45px;\r\n        height: 26px;\r\n        left: 0px;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        border-radius: 0 30px 30px 0;\r\n    }\r\n}\r\n\r\n// Alert example loop\r\n\r\n@each $color, $value in $theme-colors {\r\n    // alert solid\r\n    .alert-solid {\r\n        &.alert-#{$color} {\r\n            background-color: $value;\r\n            border-color: $value;\r\n            color: set-color-from-background($value);\r\n        }\r\n    }\r\n\r\n    // alert outline\r\n    .alert-outline {\r\n        &.alert-#{$color} {\r\n            color: $value;\r\n        }\r\n    }\r\n\r\n    // alert border left\r\n    .alert-border-left {\r\n        &.alert-#{$color} {\r\n            border-left-color: $value;\r\n        }\r\n    }\r\n\r\n    // alert top border\r\n    .alert-top-border {\r\n        &.alert-#{$color} {\r\n            border-top-color: $value;\r\n        }\r\n    }\r\n    \r\n\r\n    // rounded label\r\n\r\n    .rounded-label {\r\n        &.alert-#{$color} {\r\n            .label-icon {\r\n                background-color: $value;\r\n                color: set-color-from-background($value);\r\n            }\r\n        }\r\n    }\r\n\r\n    // label arrow\r\n\r\n    .label-arrow {\r\n        &.alert-#{$color} {\r\n            .label-icon {\r\n                color: set-color-from-background($value);\r\n                background-color: $value;\r\n                &:after {\r\n                    border-left-color: $value !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .alert{\r\n        &.alert-#{$color} {\r\n            .btn-close::after{\r\n                color: $value;\r\n            }\r\n        }\r\n        \r\n    }\r\n\r\n    //alert additional example\r\n    .alert-additional {\r\n        &.alert-#{$color} {\r\n            .alert-content {\r\n                background-color: $value;\r\n                color: set-color-from-background($value);\r\n            }\r\n        }\r\n    }   \r\n}\r\n.alert-dismissible {\r\n    .btn-close {\r\n        background: transparent !important;\r\n        &::after {\r\n            background: transparent !important;\r\n            content: \"\\F0156\" !important;\r\n            font-size: 18px;\r\n            line-height:15px;\r\n            font-family: \"Material Design Icons\" !important;\r\n        }\r\n    }\r\n}\r\n\r\n.alert-outline.alert-dark{\r\n    color: var(--#{$prefix}dark);\r\n}\r\n   ","// \r\n// backgrounds.scss\r\n//\r\n\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .bg-soft-#{$color} {\r\n        background-color: rgba(($value), 0.18) !important;\r\n    }\r\n}\r\n\r\n.bg-soft-dark{\r\n    background-color: rgba(var(--#{$prefix}dark-rgb),.18)!important;\r\n}\r\n\r\n.bg-soft-light{\r\n    background-color: rgba(var(--#{$prefix}light-rgb),.18)!important;\r\n}\r\n\r\n","// \r\n// badge.scss\r\n//\r\n\r\n// Soft badge\r\n@mixin badge-variant-soft($bg) {\r\n    color: $bg;\r\n    background-color: rgba($bg, 0.1);\r\n}\r\n\r\n\r\n// Outline badge\r\n@mixin badge-variant-outline($bg) {\r\n    color: $bg;\r\n    border: 1px solid $bg;\r\n    background-color: transparent;\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n    .badge-outline-#{$color} {\r\n        @include badge-variant-outline($value);\r\n    }\r\n}\r\n\r\n// badge outline\r\n\r\n.badge-outline {\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n    border: 1px solid;\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n    .badge-soft-#{$color} {\r\n        @include badge-variant-soft($value);\r\n    }\r\n\r\n    .badge-outline {\r\n        &.badge-#{$color} {\r\n            @include badge-variant-outline($value);\r\n        }\r\n    }\r\n\r\n    .badge-label {\r\n        &.bg-#{$color} {\r\n            &:before {\r\n                border-right-color: $value;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// badge-border\r\n\r\n.badge-border {\r\n    border-left: 2px solid;\r\n}\r\n\r\n// badge-label\r\n\r\n.badge-label {\r\n    margin-left: 8px;\r\n    position: relative;\r\n    &:before {\r\n        content: \"\";\r\n        position: absolute;\r\n        border: 8px solid transparent;\r\n        border-right-color: $primary;\r\n        left: -14px;\r\n        top: 0;\r\n    }\r\n}\r\n\r\n// [data-layout-mode=\"dark\"]{\r\n//     .badge{\r\n//         &.bg-dark{\r\n//             background-color: var(--#{$prefix}light) !important;\r\n//         }\r\n\r\n//         &.bg-light{\r\n//             background-color: var(--#{$prefix}dark) !important;\r\n//             color: var(--#{$prefix}light) !important;\r\n//         }\r\n//     }\r\n// }\r\n\r\n//Badge Gradient Style\r\n$gradients: ();\r\n$gradients: map-merge((primary: linear-gradient(135deg, $primary 0%, $success 100%),\r\n        secondary: linear-gradient(135deg, $secondary 0%, $info 100%),\r\n        success: linear-gradient(135deg, $success 0%, $warning 100%),\r\n        danger: linear-gradient(135deg, $danger 0%, $secondary 100%),\r\n        warning: linear-gradient(135deg, $warning 0%, darken($warning, 15%) 100%),\r\n        info: linear-gradient(135deg, $info 0%, $success 100%),\r\n        dark: linear-gradient(135deg, $dark 0%, $primary 100%)),\r\n    $gradients);\r\n\r\n@mixin badge-gradient($parent, $gradient) {\r\n    #{$parent} {\r\n        background: $gradient;\r\n    }\r\n}\r\n\r\n@each $gradient,\r\n$value in $gradients {\r\n    @include badge-gradient(\".badge-gradient-#{$gradient}\", $value);\r\n}","// \r\n// _buttons.scss\r\n// \r\n\r\nbutton,\r\na {\r\n    outline: none !important;\r\n    position: relative;\r\n}\r\n\r\n.btn {\r\n    box-shadow: $element-shadow;\r\n    &:hover, &.active, &:focus, &:active, &.show {\r\n        border-color: transparent;\r\n    }\r\n}\r\n\r\n// Rounded Buttons\r\n.btn-rounded {\r\n    border-radius: 30px;\r\n}\r\n\r\n\r\n.btn-icon {\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: calc(#{$btn-padding-y * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n    width: calc(#{$btn-padding-y * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n    padding: 0;\r\n\r\n    i,\r\n    svg,\r\n    img {\r\n        vertical-align: middle;\r\n    }\r\n\r\n    &.btn-sm {\r\n        height: calc(#{$btn-padding-y-sm * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n        width: calc(#{$btn-padding-y-sm * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n    }\r\n\r\n    &.btn-lg {\r\n        height: calc(#{$btn-padding-y-lg * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n        width: calc(#{$btn-padding-y-lg * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n    }\r\n}\r\n\r\n//\r\n// Soft Buttons\r\n// \r\n\r\n@mixin button-variant-soft($bg) {\r\n    color: $bg;\r\n    background-color: rgba($bg, 0.1);\r\n    border-color: transparent;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n        color: $white;\r\n        background-color: $bg;\r\n        border-color: transparent;\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .btn-soft-#{$color} {\r\n        @include button-variant-soft($value);\r\n    }\r\n}\r\n\r\n//\r\n// Ghost Buttons\r\n// \r\n\r\n@mixin button-variant-ghost($bg) {\r\n    color: $bg;\r\n    border-color: transparent;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n        color: $bg;\r\n        background-color: rgba($bg, 0.1);\r\n        border-color: transparent;\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .btn-ghost-#{$color} {\r\n        @include button-variant-ghost($value);\r\n    }\r\n}\r\n\r\n.btn-ghost-secondary {\r\n    color: var(--#{$prefix}gray-700);\r\n}\r\n\r\n//button with icon\r\n.btn-label {\r\n    position: relative;\r\n    padding-left: 44px;\r\n\r\n    .label-icon {\r\n        position: absolute;\r\n        width: 35.5px;\r\n        left: -$btn-border-width;\r\n        top: -$btn-border-width;\r\n        bottom: -$btn-border-width;\r\n        background-color: rgba($white, 0.1);\r\n        font-size: 16px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    &.btn-light {\r\n        .label-icon {\r\n            background-color: rgba($dark, 0.05);\r\n        }\r\n    }\r\n\r\n    &.right {\r\n        padding-left: $btn-padding-x;\r\n        padding-right: 44px;\r\n\r\n        .label-icon {\r\n            right: -$btn-border-width;\r\n            left: auto;\r\n        }\r\n    }\r\n}\r\n\r\n// Animation Button\r\n\r\n.btn-animation {\r\n    overflow: hidden;\r\n    transition: border-color 0.3s, background-color 0.3s;\r\n    transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\r\n\r\n    &::after {\r\n        content: attr(data-text);\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n        top: 0;\r\n        left: 0;\r\n        opacity: 0;\r\n        transform: translate3d(0, 25%, 0);\r\n        padding: $btn-padding-y $btn-padding-x;\r\n        transition: transform 0.3s, opacity 0.3s;\r\n        transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\r\n    }\r\n\r\n    >span {\r\n        display: block;\r\n        transition: transform 0.3s, opacity 0.3s;\r\n        transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\r\n    }\r\n\r\n    &:hover {\r\n        &::after {\r\n            opacity: 1;\r\n            transform: translate3d(0, 0, 0);\r\n        }\r\n\r\n        >span {\r\n            opacity: 0;\r\n            transform: translate3d(0, -25%, 0);\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@mixin button-variant($bg) {\r\n    &.btn-animation {\r\n        background-color: $bg;\r\n        border-color: $bg;\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:active {\r\n            color: $bg;\r\n            background-color: rgba($bg, 0.1);\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .btn-#{$color} {\r\n        @include button-variant($value);\r\n    }\r\n}\r\n\r\n//btn group\r\n.btn-group-vertical {\r\n    label {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n// btn group radio\r\n.btn-group.radio {\r\n    .btn {\r\n        border: none;\r\n    }\r\n\r\n    .btn-check:active+.btn-light,\r\n    .btn-check:checked+.btn-light,\r\n    .btn-light.active,\r\n    .btn-light.dropdown-toggle.show,\r\n    .btn-light:active {\r\n        background-color: rgba($info, 0.2);\r\n        color: $info;\r\n    }\r\n}\r\n\r\n// theme dark\r\n[data-layout-mode=\"dark\"] {\r\n\r\n    .btn-check:focus+.btn-light,\r\n    .btn-check:focus+.btn-outline-light,\r\n    .btn-check:focus+.btn-soft-light,\r\n    .btn-soft-light:focus {\r\n        color: var(--#{$prefix}dark);\r\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\r\n        border-color: rgba(var(--#{$prefix}light-rgb), 0.75);\r\n    }\r\n\r\n    .btn-check:active+.btn-light,\r\n    .btn-check:active+.btn-outline-light,\r\n    .btn-check:active+.btn-soft-light,\r\n    .btn-check:checked+.btn-light,\r\n    .btn-check:checked+.btn-outline-light,\r\n    .btn-check:checked+.btn-soft-light,\r\n    .btn-light.active,\r\n    .btn-light:active,\r\n    .btn-outline-light.active,\r\n    .btn-outline-light:active,\r\n    .btn-soft-light.active,\r\n    .btn-soft-light:active,\r\n    .show>.btn-light.dropdown-toggle,\r\n    .show>.btn-outline-light.dropdown-toggle,\r\n    .show>.btn-soft-light.dropdown-toggle {\r\n        color: var(--#{$prefix}dark);\r\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\r\n        border-color: rgba(var(--#{$prefix}light-rgb), 0.75);\r\n    }\r\n\r\n    .btn-check:focus+.btn-dark,\r\n    .btn-check:focus+.btn-outline-dark,\r\n    .btn-check:focus+.btn-soft-dark,\r\n    .btn-soft-dark:focus {\r\n        color: var(--#{$prefix}light);\r\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\r\n        border-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\r\n    }\r\n\r\n    .btn-check:active+.btn-dark,\r\n    .btn-check:active+.btn-outline-dark,\r\n    .btn-check:active+.btn-soft-dark,\r\n    .btn-check:checked+.btn-dark,\r\n    .btn-check:checked+.btn-outline-dark,\r\n    .btn-check:checked+.btn-soft-dark,\r\n    .btn-dark.active,\r\n    .btn-dark:active,\r\n    .btn-outline-dark.active,\r\n    .btn-outline-dark:active,\r\n    .btn-soft-dark.active,\r\n    .btn-soft-dark:active,\r\n    .show>.btn-dark.dropdown-toggle,\r\n    .show>.btn-outline-dark.dropdown-toggle,\r\n    .show>.btn-soft-dark.dropdown-toggle {\r\n        color: var(--#{$prefix}light);\r\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\r\n        border-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\r\n    }\r\n\r\n    // soft\r\n\r\n    .btn-soft-light {\r\n        color: var(--#{$prefix}dark);\r\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.1);\r\n\r\n        &:hover {\r\n            color: var(--#{$prefix}dark);\r\n            background-color: var(--#{$prefix}light);\r\n        }\r\n    }\r\n\r\n    .btn-soft-dark {\r\n        color: var(--#{$prefix}dark);\r\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\r\n\r\n        &:hover {\r\n            color: var(--#{$prefix}light);\r\n            background-color: var(--#{$prefix}dark);\r\n        }\r\n    }\r\n\r\n    // ghost\r\n    .btn-ghost-light {\r\n        color: var(--#{$prefix}dark);\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:active {\r\n            color: var(--#{$prefix}dark);\r\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.5);\r\n        }\r\n    }\r\n\r\n    .btn-ghost-dark {\r\n        color: var(--#{$prefix}dark);\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:active {\r\n            color: var(--#{$prefix}dark);\r\n            background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\r\n        }\r\n    }\r\n}\r\n\r\n.btn-load {\r\n\r\n    .spinner-border,\r\n    .spinner-grow {\r\n        height: 19px;\r\n        width: 19px;\r\n    }\r\n}\r\n\r\n//Border Bottom Buttons Style\r\n@each $color,\r\n$value in $theme-colors {\r\n\r\n    .btn-#{$color},\r\n    .btn-outline-#{$color},\r\n    .btn-soft-#{$color} {\r\n        &.btn-border {\r\n            border-bottom: 2px solid darken($value, 8%);\r\n        }\r\n    }\r\n}\r\n\r\n//custom toggle\r\n.custom-toggle {\r\n    .icon-off {\r\n        display: none;\r\n    }\r\n\r\n    &.active {\r\n        .icon-on {\r\n            display: none;\r\n        }\r\n\r\n        .icon-off {\r\n            display: block;\r\n        }\r\n    }\r\n}","// \r\n// breadcrumb.scss\r\n//\r\n\r\n\r\n// Breadcrumb item arrow\r\n.breadcrumb-item {\r\n    > a {\r\n        color: var(--#{$prefix}gray-700);\r\n    }\r\n    +.breadcrumb-item {\r\n        &::before {\r\n            font-family: \"Material Design Icons\";\r\n            font-size: 11px;\r\n        }\r\n    }\r\n}\r\n  ","// \r\n// _card.scss\r\n// \r\n\r\n.card {\r\n    margin-bottom: $grid-gutter-width;\r\n    box-shadow: $card-box-shadow;\r\n}\r\n\r\n.card-header {\r\n    border-bottom: 1px solid $border-color;\r\n}\r\n\r\n//Card Header Dropdown\r\n.card-header-dropdown {\r\n    .dropdown-btn {\r\n        padding: $card-cap-padding-y 0;\r\n    }\r\n}\r\n\r\n.card-footer {\r\n    border-top: 1px solid $border-color;\r\n}\r\n\r\n.card-drop {\r\n    color: $body-color;\r\n}\r\n\r\n.card-title {\r\n    font-size: 16px;\r\n    margin: 0 0 7px 0;\r\n}\r\n\r\n.card-title-desc {\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.card-height-100 {\r\n    height: calc(100% - #{$grid-gutter-width});\r\n}\r\n\r\n.card-animate{\r\n    transition: all 0.4s;\r\n\r\n    &:hover{\r\n        transform: translateY(calc(#{-$grid-gutter-width} / 5));\r\n        box-shadow: $box-shadow-lg;\r\n    }\r\n}\r\n\r\n\r\n// card color variant\r\n\r\n@mixin card-variant($bg) {\r\n    color: $white;\r\n    background-color: $bg;\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .card-#{$color} {\r\n        @include card-variant($value);\r\n\r\n        .card-header, .card-footer {\r\n            background-color: rgba($white, 0.1);\r\n            color: $white;\r\n            border-color: transparent;\r\n        }\r\n\r\n        .card-title {\r\n            color: $white;\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .card-border-#{$color} {\r\n        border-color: $value !important;\r\n        .card-header, .card-footer {\r\n            border-color: $value;\r\n        }\r\n\r\n    }\r\n}\r\n\r\n.card-light{\r\n    background-color: var(--#{$prefix}light);\r\n    .card-header, .card-footer{\r\n        color: var(--#{$prefix}body-color) !important;\r\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\r\n    }\r\n    .card-title, .card-text { \r\n        color: var(--#{$prefix}body-color) !important;\r\n    }\r\n}\r\n\r\n.stretched-link {\r\n    position: static;\r\n}\r\n\r\n\r\n// Loader\r\n\r\n.card-preloader {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.6);\r\n    z-index: 9999;\r\n}\r\n\r\n.card-status {\r\n    width: 40px;\r\n    height: 40px;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%,-50%)!important;\r\n}\r\n\r\n.custom-loader {\r\n    animation: spin 2s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n\tto { transform: rotate(360deg) }\r\n}\r\n\r\n.card-overlay{\r\n    position: relative;\r\n    overflow: hidden;\r\n    &:before {\r\n        content: \"\";\r\n        background-color: rgba($primary, 0.20);\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n        left: 0;\r\n        bottom: 0;\r\n    }\r\n    .card-header, .card-footer {\r\n        border-color: rgba($white, 0.15) !important;\r\n    }\r\n}\r\n\r\n.card-toolbar-menu {\r\n    line-height: 0.8;\r\n    a {\r\n        font-size: 17px;\r\n    }\r\n    .minimize-card {\r\n        .plus{\r\n            display: none;\r\n        }  \r\n        .minus {\r\n            display: block;\r\n        }\r\n        &.collapsed{\r\n            .plus{\r\n                display: block;\r\n            }  \r\n            .minus {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// _dropdown.scss\r\n// \r\n\r\n.dropdown-toggle::after {\r\n    display: inline-block;\r\n    margin-left: .255em;\r\n    font-size: 15px;\r\n    line-height: 15px;\r\n    content: \"\\F0140\";\r\n    font-family: \"Material Design Icons\";\r\n}\r\n\r\n.dropdown-menu {\r\n    box-shadow: $box-shadow-lg;\r\n    animation-name: DropDownSlide;\r\n    animation-duration: .3s;\r\n    animation-fill-mode: both;\r\n    position: absolute;\r\n    z-index: 1000;\r\n\r\n    &.dropdown-megamenu {\r\n        padding: 20px;\r\n        left: 0 !important;\r\n        right: 0 !important;\r\n    }\r\n\r\n    &[data-popper-placement=\"top-start\"] {\r\n        animation-name: DropDownSlideDown;\r\n    }\r\n}\r\n\r\n@keyframes DropDownSlide {\r\n    100% {\r\n        margin-top: -1px;\r\n    }\r\n\r\n    0% {\r\n        margin-top: 8px;\r\n    }\r\n}\r\n\r\n@keyframes DropDownSlideDown {\r\n    100% {\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    0% {\r\n        margin-bottom: 8px;\r\n    }\r\n}\r\n\r\n@media (min-width: 600px) {\r\n    .dropdown-menu-xl {\r\n        width: 420px;\r\n    }\r\n\r\n    .dropdown-menu-lg {\r\n        width: 320px;\r\n    }\r\n\r\n    .dropdown-menu-md {\r\n        width: 240px;\r\n    }\r\n}\r\n\r\n.dropdown-toggle-split {\r\n    border-left: none;\r\n    &::after {\r\n        margin-left: 0px;\r\n    }\r\n\r\n    &:before {\r\n        content: \"\";\r\n        position: absolute;\r\n        background-color: rgba($white,0.12);\r\n        top: -$btn-border-width;\r\n        bottom: -$btn-border-width;\r\n        right: -$btn-border-width;\r\n        left: 0;\r\n        border-radius: 0 $btn-border-radius $btn-border-radius 0;\r\n    }\r\n}\r\n\r\n// Dropdown Mega Menu\r\n\r\n.dropdown-mega {\r\n    position: static !important;\r\n}\r\n\r\n\r\n\r\n// Dropdown size\r\n\r\n.dropdown-mega-menu-xl {\r\n    width: 38rem;\r\n}\r\n\r\n.dropdown-mega-menu-lg {\r\n    width: 26rem;\r\n}\r\n\r\n[dir=\"ltr\"] {\r\n    .dropdown-menu-start {\r\n        --bs-position: end;\r\n    }\r\n\r\n    .dropdown-menu-end {\r\n        --bs-position: start;\r\n    }\r\n}\r\n// Custom Dropdown with Tabs\r\n.dropdown-head{\r\n    .nav-tabs-custom{\r\n        border: 0;\r\n        .nav-link  {\r\n            color: rgba($white, 0.6);\r\n            &.active {\r\n                background-color: var(--#{$prefix}dropdown-bg);\r\n            }\r\n            &:hover {\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .dropdownmenu-#{$color} {\r\n      .dropdown-item{\r\n        &:focus, &:hover, &.active{\r\n          background-color: rgba(($value), 0.07);\r\n          color: $value;\r\n        }\r\n      }\r\n    }\r\n}","//\r\n// _nav.scss\r\n//\r\n\r\n.nav-tabs,\r\n.nav-pills {\r\n    >li {\r\n        >a {\r\n            color: var(--#{$prefix}gray-700);\r\n            font-weight: $font-weight-medium;\r\n        }\r\n    }\r\n}\r\n\r\n.nav-pills {\r\n    >a {\r\n        color: var(--#{$prefix}gray-700);\r\n        font-weight: $font-weight-medium;\r\n    }\r\n}\r\n\r\n.nav-pills {\r\n\r\n    .nav-link.active,\r\n    .show>.nav-link {\r\n        box-shadow: $element-shadow;\r\n    }\r\n}\r\n\r\n.nav-tabs-custom {\r\n    border-bottom: 1px solid var(--#{$prefix}gray-300);\r\n\r\n    .nav-item {\r\n        position: relative;\r\n\r\n        .nav-link {\r\n            border: none;\r\n            font-weight: $font-weight-medium;\r\n\r\n            &::after {\r\n                content: \"\";\r\n                background: $primary;\r\n                height: 1px;\r\n                position: absolute;\r\n                width: 100%;\r\n                left: 0;\r\n                bottom: 0;\r\n                transition: all 250ms ease 0s;\r\n                transform: scale(0);\r\n            }\r\n\r\n            &.active {\r\n                color: $primary;\r\n\r\n                &:after {\r\n                    transform: scale(1);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.card-header-tabs {\r\n        margin-top: -1rem;\r\n\r\n        .nav-link {\r\n            padding: $card-cap-padding-y $card-cap-padding-x;\r\n        }\r\n    }\r\n}\r\n\r\n// vertical nav\r\n\r\n.vertical-nav {\r\n    .nav {\r\n        .nav-link {\r\n            padding: 24px 16px;\r\n            text-align: center;\r\n            margin-bottom: 8px;\r\n\r\n            .nav-icon {\r\n                font-size: 24px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n//Navtab custom\r\n.navtab-bg {\r\n    li {\r\n        >a {\r\n            background-color: $gray-300;\r\n            margin: 0 5px;\r\n        }\r\n    }\r\n}\r\n\r\n// arrow-navtabs\r\n\r\n.arrow-navtabs {\r\n    .nav-item {\r\n        .nav-link {\r\n            position: relative;\r\n            text-align: center;\r\n\r\n            &:before {\r\n                content: \"\";\r\n                position: absolute;\r\n                border: 6px solid transparent;\r\n                bottom: -12px;\r\n                left: 50%;\r\n                transform: translateX(-50%);\r\n                @include transition($nav-link-transition);\r\n            }\r\n\r\n            &.active {\r\n                &:before {\r\n                    border-top-color: $primary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// custom hover tab\r\n.custom-hover-nav-tabs {\r\n    .nav-item {\r\n        text-align: center;\r\n        overflow: hidden;\r\n\r\n        .nav-link {\r\n            width: 120px;\r\n            height: 45px;\r\n            position: relative;\r\n            border-radius: 0px;\r\n\r\n            .nav-icon {\r\n                font-size: 22px;\r\n            }\r\n\r\n            .nav-titl {\r\n                font-size: 14px;\r\n            }\r\n\r\n            &.active {\r\n                .nav-tab-position {\r\n                    color: $white;\r\n                }\r\n            }\r\n\r\n            .nav-tab-position {\r\n                position: absolute;\r\n                left: 0;\r\n                right: 0;\r\n                transition: all 0.4s;\r\n\r\n                &.nav-icon {\r\n                    top: 50%;\r\n                    transform: translateY(-50%);\r\n                }\r\n\r\n                &.nav-titl {\r\n                    bottom: -20px;\r\n                }\r\n            }\r\n\r\n            &:hover {\r\n                .nav-titl {\r\n                    bottom: 50%;\r\n                    transform: translateY(50%);\r\n                }\r\n\r\n                .nav-icon {\r\n                    top: -20px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// custom vertical tab\r\n\r\n.custom-verti-nav-pills {\r\n    .nav-link {\r\n        background-color: var(--#{$prefix}light);\r\n        margin-top: 7px;\r\n        position: relative;\r\n\r\n        @media (min-width: 992px) {\r\n            &::before {\r\n                content: \"\";\r\n                position: absolute;\r\n                right: -20px;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n                border: 12px solid transparent;\r\n                border-left-color: transparent;\r\n                transition: border-left-color 0.04 ease;\r\n            }\r\n\r\n            &.active {\r\n                &::before {\r\n                    border-left-color: $primary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// animation nav\r\n.animation-nav {\r\n    li {\r\n        position: relative;\r\n\r\n        a {\r\n            color: var(--#{$prefix}body-color);\r\n            border-radius: 4px;\r\n            position: relative;\r\n            overflow: hidden;\r\n            transition: all 0.4s;\r\n            z-index: 1;\r\n\r\n            span {\r\n                position: relative;\r\n            }\r\n\r\n            &::before {\r\n                content: \"\";\r\n                position: absolute;\r\n                top: 0;\r\n                width: 0;\r\n                right: 0;\r\n                height: 100%;\r\n                transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;\r\n                background-color: $primary;\r\n                z-index: -1;\r\n            }\r\n\r\n            &:hover,\r\n            &.active {\r\n                color: $white;\r\n                background-color: transparent !important;\r\n\r\n                &::before {\r\n                    width: 100%;\r\n                    left: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.nav-border-top {\r\n    .nav-link {\r\n        border-top: 3px solid transparent;\r\n\r\n        &.active {\r\n            border-top-color: $primary;\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .nav-border-top-#{$color} {\r\n        .nav-link {\r\n            &.active {\r\n                color: $value;\r\n                border-top-color: $value;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.nav-custom {\r\n    background-color: $primary;\r\n    border-radius: $card-border-radius;\r\n\r\n    .nav-item {\r\n        .nav-link {\r\n            color: rgba($white, 0.75);\r\n\r\n            &.active {\r\n                color: $white;\r\n                background-color: rgba($white, 0.1);\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-custom-light {\r\n        .nav-item {\r\n            .nav-link {\r\n                color: rgba(var(--#{$prefix}dark-rgb), 0.75);\r\n\r\n                &.active {\r\n                    color: $light;\r\n                    background-color: $primary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .nav-custom-#{$color} {\r\n        background-color: $value;\r\n    }\r\n}\r\n\r\n.nav-custom-light {\r\n    background-color: var(--#{$prefix}light);\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .nav-#{$color} {\r\n        .nav-link {\r\n            &.active {\r\n                color: $white;\r\n                background-color: $value;\r\n            }\r\n        }\r\n\r\n        &.nav-tabs {\r\n            .nav-link {\r\n                &.active {\r\n                    color: $value;\r\n                    background-color: var(--#{$prefix}card-bg-custom);\r\n                }\r\n            }\r\n        }\r\n\r\n        &.nav-tabs-custom {\r\n            .nav-link {\r\n                &.active {\r\n                    color: $value;\r\n                    background-color: var(--#{$prefix}card-bg-custom);\r\n\r\n                    &::after {\r\n                        background-color: $value;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &.arrow-navtabs {\r\n            .nav-link {\r\n                &.active {\r\n                    &::before {\r\n                        border-top-color: $value;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &.custom-verti-nav-pills {\r\n            .nav-link {\r\n                &.active {\r\n                    &::before {\r\n                        border-left-color: $value;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// progress nav\r\n.progress-nav {\r\n    position: relative;\r\n    margin-right: 1rem;\r\n    margin-left: 1rem;\r\n\r\n    .progress {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        width: 100%;\r\n    }\r\n\r\n    .nav {\r\n        margin-right: -1rem;\r\n        margin-left: -1rem;\r\n        justify-content: space-between;\r\n\r\n        .nav-link {\r\n            width: 2rem;\r\n            height: 2rem;\r\n            background-color: var(--#{$prefix}light);\r\n            padding: 0;\r\n            color: var(--#{$prefix}dark);\r\n            font-weight: $font-weight-medium;\r\n\r\n            &.active,\r\n            &.done {\r\n                background-color: $primary;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Step arrow nav\r\n.step-arrow-nav {\r\n    .nav {\r\n        background-color: var(--#{$prefix}light);\r\n\r\n        .nav-link {\r\n            border-radius: 0;\r\n            position: relative;\r\n            font-weight: $font-weight-medium;\r\n            color: var(--#{$prefix}dark);\r\n\r\n            &::before {\r\n                content: \"\";\r\n                position: absolute;\r\n                border: 7px solid transparent;\r\n                right: -14px;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n            }\r\n\r\n            &.done {\r\n                background-color: rgba($primary, 0.05);\r\n                color: $primary;\r\n\r\n                &::before {\r\n                    border-left-color: transparent;\r\n                }\r\n            }\r\n\r\n            &.active {\r\n                background-color: rgba($primary, 0.1);\r\n                color: $primary;\r\n                box-shadow: none;\r\n\r\n                &::before {\r\n                    border-left-color: rgba($primary, 0.1);\r\n                }\r\n            }\r\n        }\r\n\r\n        .nav-item {\r\n            &:last-child {\r\n                .nav-link {\r\n                    &:before {\r\n                        display: none;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// vertical nav step\r\n.vertical-navs-step {\r\n    .nav {\r\n        gap: 16px;\r\n\r\n        .nav-link {\r\n            text-align: left;\r\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.4);\r\n            border: 1px solid var(--#{$prefix}border-color);\r\n            color: var(--#{$prefix}dark);\r\n\r\n            .step-title {\r\n                font-weight: $font-weight-semibold;\r\n            }\r\n\r\n            .step-icon {\r\n                color: $danger;\r\n                vertical-align: middle;\r\n                font-weight: $font-weight-medium;\r\n                float: left;\r\n            }\r\n\r\n            &.active,\r\n            &.done {\r\n                .step-icon {\r\n                    color: $success;\r\n\r\n                    &:before {\r\n                        content: \"\\eb80\";\r\n                    }\r\n                }\r\n            }\r\n\r\n            &.active {\r\n                border-color: $primary;\r\n            }\r\n\r\n            &.done {\r\n                border-color: $success;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n//Outline Border Nav\r\n.nav-custom-outline {\r\n    &.nav {\r\n        .nav-link {\r\n            border: 1px solid transparent;\r\n            border-bottom: 2px solid transparent;\r\n\r\n            &.active {\r\n                border-color: $primary;\r\n                background-color: transparent;\r\n                color: $primary;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .nav-#{$color} {\r\n        &.nav-custom-outline {\r\n            .nav-link {\r\n                &.active {\r\n                    color: $value;\r\n                    border-color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n//customs nav\r\n.nav-customs {\r\n    &.nav {\r\n        padding-left: 34px;\r\n        overflow: hidden;\r\n\r\n        .nav-link {\r\n            position: relative;\r\n            display: block;\r\n            float: right;\r\n            background-color: var(--#{$prefix}body-bg);\r\n            margin-right: 46px;\r\n            transition: all 0.5s ease;\r\n\r\n            &::before,\r\n            &::after {\r\n                display: block;\r\n                content: \" \";\r\n                position: absolute;\r\n                top: -1px;\r\n                bottom: -1px;\r\n                width: 37px;\r\n                background-color: var(--#{$prefix}body-bg);\r\n                transition: all 0.5s ease;\r\n            }\r\n\r\n            &::before {\r\n                border-radius: 0 8px 0 0;\r\n                right: -24px;\r\n                transform: skew(30deg, 0deg);\r\n            }\r\n\r\n            &::after {\r\n                border-radius: 8px 0 0 0;\r\n                left: -24px;\r\n                transform: skew(-30deg, 0deg);\r\n            }\r\n\r\n            &.active,\r\n            &.active:before,\r\n            &.active:after {\r\n                background-color: $primary;\r\n                color: $white;\r\n            }\r\n\r\n            &.active {\r\n                z-index: 1;\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// _table.scss\r\n// \r\n\r\n.table {\r\n    th {\r\n        font-weight: $font-weight-semibold;\r\n    }\r\n\r\n    >thead {\r\n        border-color: $table-border-color;\r\n    }\r\n    >:not(:first-child) {\r\n        border-top-width: $table-border-width;\r\n    }\r\n}\r\n\r\n\r\n.table-nowrap {\r\n\r\n    th,\r\n    td {\r\n        white-space: nowrap;\r\n    }\r\n}\r\n\r\n// card table\r\n\r\n.table-card{\r\n    margin: (-$card-spacer-y) (-$card-spacer-x);\r\n\r\n    th,\r\n    td {\r\n\r\n        &:first-child{\r\n            padding-left: 16px;\r\n        }\r\n\r\n        &:last-child{\r\n            padding-right: 16px;\r\n        }\r\n    }\r\n\r\n    .table > :not(:first-child) {\r\n        border-top-width: $table-border-width;\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .border-#{$color} {\r\n        &.table {\r\n            > thead {\r\n                border-color: $value !important;\r\n            }\r\n        }\r\n    }\r\n    .table-#{$color} {\r\n        &.table {\r\n            > thead {\r\n                border-bottom-color:lighten($value, 10%) !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.table {\r\n    .form-check {\r\n        padding-left: 0px;\r\n        margin-bottom: 0px;\r\n        .form-check-input {\r\n            margin-left: 0px;\r\n            margin-top: 0px;\r\n            float: none;\r\n            vertical-align: middle;\r\n        }\r\n    }\r\n    .sort {\r\n        position: relative;\r\n        &::before {\r\n            content: \"\\f035d\";\r\n            position: absolute;\r\n            right: 0.5rem;\r\n            top: 18px;\r\n            font-size: 0.8rem;\r\n            font-family: \"Material Design Icons\";\r\n        }\r\n        &::after {\r\n            position:absolute;\r\n            right: 0.5rem;\r\n            content: \"\\f0360\";\r\n            font-family: \"Material Design Icons\";\r\n            font-size: 0.8rem;\r\n            top: 12px;\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout-mode=\"dark\"] {\r\n    .table-light {\r\n        background-color: var(--#{$variable-prefix}light);\r\n        color: var(--#{$variable-prefix}body-color);\r\n        th,td {\r\n            background-color: var(--#{$variable-prefix}light);\r\n        }\r\n    }\r\n}\r\n\r\n.rdt_Table {\r\n    &.eSTlnH {\r\n        background-color: var(--#{$variable-prefix}card-bg) !important;\r\n        color: var(--#{$variable-prefix}body-color);\r\n    }\r\n\r\n    .gZWIKX,\r\n    .jVeafb {\r\n        color: var(--#{$variable-prefix}body-color);\r\n        background-color: var(--#{$variable-prefix}card-bg);\r\n    }\r\n\r\n    .jVeafb:not(:last-of-type),\r\n    .gZWIKX {\r\n        border-bottom-color: var(--#{$variable-prefix}border-color);\r\n    }\r\n}\r\n\r\n.rdt_Pagination {\r\n    &.jxflYm {\r\n        background-color: var(--#{$variable-prefix}card-bg);\r\n        color: var(--#{$variable-prefix}body-color);\r\n        border-top-color: var(--#{$variable-prefix}border-color);\r\n    }\r\n\r\n    .bvxQGL {\r\n        fill: var(--#{$variable-prefix}dark);\r\n    }\r\n\r\n    .bvxQGL:disabled {\r\n        fill: rgba(var(--#{$variable-prefix}dark-rgb), 0.25);\r\n    }\r\n}","//\r\n// _modal.scss\r\n//\r\n\r\n.modal-title {\r\n    font-weight: $font-weight-semibold;\r\n}\r\n\r\n.modal-dialog:not(.modal-dialog-scrollable) {\r\n    .modal-header {\r\n        padding-bottom: 0;\r\n    \r\n        .btn-close {\r\n            margin-top: -$modal-header-padding;\r\n        }\r\n    }\r\n    \r\n    .modal-footer {\r\n        padding-top: 0;\r\n    }\r\n}\r\n\r\n.modal {\r\n\t&.fadeInRight {\r\n\t\t.modal-dialog {\r\n\t\t\topacity: 0;\r\n\t\t\ttransform: translateX(20%);\r\n\t\t\ttransition: all .3s ease-in-out;\r\n\t\t}\r\n\r\n\t\t&.show {\r\n\t\t\t.modal-dialog {\r\n\t\t\t\topacity: 1;\r\n\t\t\t\ttransform: translateX(0);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.fadeInLeft {\r\n\t\t.modal-dialog {\r\n\t\t\tanimation: fadeInLeft 0.3s ease-in-out;\r\n\t\t\ttransform: translate(-50%, 0);\r\n\t\t}\r\n\r\n\t\t&.show {\r\n\t\t\t.modal-dialog {\r\n\t\t\t\ttransform: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.fadeInUp {\r\n\t\t.modal-dialog {\r\n\t\t\tanimation: fadeInUp 0.3s ease-in-out;\r\n\t\t\ttransform: translate(0, 30%);\r\n\t\t}\r\n\r\n\t\t&.show {\r\n\t\t\t.modal-dialog {\r\n\t\t\t\ttransform: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.flip {\r\n\t\tperspective: 1300px;\r\n\r\n\t\t.modal-dialog {\r\n\t\t\topacity: 0;\r\n\t\t\ttransform: rotateY(-70deg);\r\n\t\t\ttransition: all .3s;\r\n\t\t}\r\n\r\n\t\t&.show {\r\n\t\t\t.modal-dialog {\r\n\t\t\t\topacity: 1;\r\n\t\t\t\ttransform: rotateY(0deg);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.zoomIn {\r\n\t\t.modal-dialog {\r\n\t\t\topacity: 0;\r\n\t\t\ttransform: scale(.7);\r\n\t\t\ttransition: all .3s ease;\r\n\t\t}\r\n\r\n\t\t&.show {\r\n\t\t\t.modal-dialog {\r\n\t\t\t\topacity: 1;\r\n\t\t\t\ttransform: scale(1)\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n.modal-dialog-right {\r\n\tmargin-right: $modal-dialog-margin-y-sm-up;\r\n}\r\n\r\n// modal-dialog-bottom\r\n.modal-dialog-bottom {\r\n\tdisplay: flex;\r\n\talign-items: flex-end;\r\n\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up});\r\n\r\n\t@media (min-width: 576px) {\r\n\t\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up*2 });\r\n\t}\r\n}\r\n\r\n.modal-dialog-bottom-right {\r\n\tdisplay: flex;\r\n\talign-items: flex-end;\r\n\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up});\r\n\tmargin-right: $modal-dialog-margin-y-sm-up;\r\n\r\n\t@media (min-width: 576px) {\r\n\t\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up*2 });\r\n\t}\r\n}\r\n\r\n@keyframes fadeInLeft {\r\n\t0% {\r\n\t\topacity: 0;\r\n\t\ttransform: translate3d(-30%, 0, 0);\r\n\t}\r\n\r\n\tto {\r\n\t\topacity: 1;\r\n\t\ttransform: translateZ(0);\r\n\t}\r\n}\r\n\r\n\r\n@keyframes fadeInUp {\r\n\t0% {\r\n\t\topacity: 0;\r\n\t\ttransform: translate3d(0, 30%, 0);\r\n\t}\r\n\r\n\tto {\r\n\t\topacity: 1;\r\n\t\ttransform: translateZ(0);\r\n\t}\r\n}\r\n\r\n@keyframes zoomIn {\r\n\t0% {\r\n\t\topacity: 0;\r\n\t\ttransform: scale3d(.3, .3, .3);\r\n\t}\r\n\r\n\t50% {\r\n\t\topacity: 1\r\n\t}\r\n}\r\n\r\n.login-modal {\r\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1016%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(64%2c 81%2c 137%2c 1)'%3e%3c/rect%3e%3cpath d='M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704' fill='%2333416e'%3e%3c/path%3e%3cpath d='M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672' fill='%234d61a4'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1016'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e\");\r\n\tbackground-size: cover;\r\n\tbackground-position: center;\r\n}","// \r\n// _pagination.scss\r\n// \r\n\r\n// Pagination Separated\r\n.pagination-separated {\r\n    .page-item {\r\n        .page-link {\r\n            margin-left: 0.35rem;\r\n            border-radius: $border-radius;\r\n        }\r\n    }\r\n}\r\n\r\n// Pagination rounded (Custom)\r\n.pagination-rounded {\r\n    .page-link {\r\n        border-radius: 30px !important;\r\n        margin: 0 3px !important;\r\n        border: none;\r\n        min-width: 32px;\r\n        min-height: 32px;\r\n        text-align: center;\r\n    }\r\n\r\n    &.pagination-sm {\r\n        .page-link {\r\n            min-width: 25px;\r\n            min-height: 25px;\r\n        }\r\n    }\r\n}\r\n\r\n.page-item.active {\r\n    .page-link{\r\n        box-shadow: $element-shadow;\r\n    }\r\n}","// \r\n// _progress.scss\r\n// \r\n\r\n// Progress height small\r\n.progress-sm {\r\n    height: 5px;\r\n}\r\n\r\n// Progress height large\r\n.progress-lg {\r\n    height: 12px;\r\n}\r\n\r\n// Progress height Extra large\r\n.progress-xl {\r\n    height: 16px;\r\n}\r\n\r\n.custom-progess {\r\n    position: relative;\r\n\r\n    .progress-icon {\r\n        position: absolute;\r\n        top: -12px;\r\n\r\n        .avatar-title {\r\n            background: var(--#{$prefix}card-bg-custom);\r\n        }\r\n    }\r\n}\r\n\r\n// animated-progress\r\n\r\n.animated-progress {\r\n    position: relative;\r\n\r\n    .progress-bar {\r\n        position: relative;\r\n        border-radius: 6px;\r\n        animation: animate-positive 2s;\r\n    }\r\n}\r\n\r\n@keyframes animate-positive {\r\n    0% {\r\n        width: 0;\r\n    }\r\n}\r\n\r\n// custom-progress\r\n\r\n.custom-progress {\r\n    height: 15px;\r\n    padding: 4px;\r\n    border-radius: 30px;\r\n\r\n    .progress-bar {\r\n        position: relative;\r\n        border-radius: 30px;\r\n\r\n        &::before {\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 4px;\r\n            height: 4px;\r\n            background-color: $white;\r\n            border-radius: 7px;\r\n            right: 2px;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n\r\n        }\r\n    }\r\n}\r\n\r\n// progress withlabel\r\n.progress-label {\r\n    overflow: visible;\r\n\r\n    .progress-bar {\r\n        position: relative;\r\n        overflow: visible;\r\n\r\n        .label {\r\n            position: absolute;\r\n            top: -25px;\r\n            right: -9px;\r\n            background-color: $primary;\r\n            color: $white;\r\n            display: inline-block;\r\n            line-height: 18px;\r\n            padding: 0 4px;\r\n            border-radius: 4px;\r\n\r\n            &:after {\r\n                content: \"\";\r\n                position: absolute;\r\n                border: 4px solid transparent;\r\n                border-top-color: $primary;\r\n                bottom: -7px;\r\n                left: 50%;\r\n                transform: translateX(-50%);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.progress-step-arrow {\r\n    height: 3.25rem;\r\n\r\n    .progress-bar {\r\n        position: relative;\r\n        overflow: initial;\r\n        font-size: .875rem;\r\n        color: $white;\r\n        &::after {\r\n            content: \"\";\r\n            position: absolute;\r\n            border: 10px solid transparent;\r\n            bottom: 15px;\r\n            right: -20px;\r\n            z-index: 1;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@mixin progress-variant($bg) {\r\n    .progress-bar {\r\n        background-color: $bg;\r\n        &::after { \r\n            border-left-color: $bg;\r\n        }\r\n        &:nth-child(2) {\r\n            background-color: rgba($bg, 0.1) !important;\r\n            color: $bg !important;\r\n            &::after { \r\n                border-left-color: rgba($bg, 0.1);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n    .progress-#{$color} {\r\n        @include progress-variant($value);\r\n    }\r\n}\r\n\r\n","// \r\n// _popover.scss\r\n// \r\n\r\n.popover {\r\n    box-shadow: $popover-box-shadow;\r\n}","// \r\n// type.scss\r\n//\r\n\r\n// Text colors\r\n.text-white-75 {\r\n    color: rgba($white, 0.75) !important;\r\n}\r\n\r\n// Blockquote\r\n.custom-blockquote {\r\n    &.blockquote {\r\n        padding: 16px;\r\n        border-left: 3px solid;\r\n        \r\n        &.blockquote-outline{\r\n            background-color: var(--#{$prefix}card-bg-custom) !important;\r\n            border: 1px solid;\r\n            border-left: 3px solid;\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .custom-blockquote {\r\n        &.blockquote {\r\n            &.blockquote-#{$color} {\r\n                color: #{$value};\r\n                border-color: #{$value};\r\n                background-color: rgba($value, 0.15);\r\n\r\n                .blockquote-footer {\r\n                    color: #{$value};\r\n                }\r\n            }\r\n\r\n            &.blockquote-outline{\r\n                &.blockquote-#{$color} {\r\n                    border-color: #{$value};\r\n\r\n                    .blockquote-footer {\r\n                        color: #{$value};\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.custom-blockquote{\r\n    &.blockquote{\r\n        &.blockquote-dark{\r\n            color: var(--#{$prefix}dark);\r\n            border-color: var(--#{$prefix}dark);\r\n            background-color: rgba(var(--#{$prefix}dark-rgb), 0.15);\r\n            .blockquote-footer {\r\n                color: var(--#{$prefix}dark);\r\n            }\r\n        }\r\n        &.blockquote-outline{\r\n            &.blockquote-dark{\r\n                border-color: var(--#{$prefix}dark);\r\n                .blockquote-footer {\r\n                    color: var(--#{$prefix}dark);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// _form-check.scss\r\n//\r\n\r\n.form-check {\r\n    position: relative;\r\n    text-align: left\r\n        /*rtl: right*/;\r\n\r\n    .form-check-input {\r\n        cursor: pointer;\r\n    }\r\n\r\n    label {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n\r\n// checkbox color\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .form-check-#{$color} {\r\n        .form-check-input {\r\n            &:checked {\r\n                background-color: $value;\r\n                border-color: $value;\r\n            }\r\n        }\r\n    }\r\n\r\n    .form-radio-#{$color} {\r\n        .form-check-input {\r\n            &:checked {\r\n                border-color: $value;\r\n                background-color: $value;\r\n\r\n                &:after {\r\n                    background-color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.form-check-label {\r\n    cursor: pointer;\r\n    margin-bottom: 0;\r\n}\r\n\r\n// checkbox input right\r\n.form-check-right {\r\n    padding-left: 0;\r\n    display: inline-block;\r\n\r\n    .form-check-input {\r\n        float: right;\r\n        margin-left: 0;\r\n        margin-right: $form-check-padding-start * -1;\r\n    }\r\n\r\n    .form-check-label {\r\n        display: block;\r\n    }\r\n\r\n    &.form-switch {\r\n        .form-check-input {\r\n            margin-right: $form-check-padding-start * -1.6;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Checkbox outline\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .form-check-outline {\r\n        &.form-check-#{$color} {\r\n            .form-check-input {\r\n                &:checked[type=checkbox] {\r\n                    color: $value;\r\n                    background-color: transparent;\r\n                    border-color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.form-check-outline {\r\n    .form-check-input {\r\n        position: relative;\r\n\r\n        &:checked[type=checkbox] {\r\n            background-image: none;\r\n\r\n            &::before {\r\n                content: \"\\F012C\";\r\n                font-family: \"Material Design Icons\";\r\n                top: -2px;\r\n                position: absolute;\r\n                font-weight: 700;\r\n                font-size: 11px;\r\n                left: 1px;\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n// Radio\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .form-radio-outline {\r\n        &.form-radio-#{$color} {\r\n            .form-check-input {\r\n                &:checked[type=radio] {\r\n                    color: $value;\r\n                    background-color: transparent;\r\n                    border-color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.form-radio-outline {\r\n    .form-check-input {\r\n        position: relative;\r\n\r\n        &:checked[type=radio] {\r\n            background-image: none;\r\n\r\n            &::before {\r\n                content: \"\\F0765\";\r\n                font-family: \"Material Design Icons\";\r\n                top: 0px;\r\n                position: absolute;\r\n                font-size: 8px;\r\n                left: 2.2px;\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n// Switch sizes\r\n\r\n.form-switch-md {\r\n    padding-left: 2.5rem;\r\n    min-height: 22px;\r\n    line-height: 22px;\r\n\r\n    .form-check-input {\r\n        width: 40px;\r\n        height: 20px;\r\n        left: -0.5rem;\r\n        position: relative;\r\n    }\r\n\r\n    .form-check-label {\r\n        vertical-align: middle;\r\n    }\r\n}\r\n\r\n.form-switch-lg {\r\n    padding-left: 2.75rem;\r\n    min-height: 28px;\r\n    line-height: 28px;\r\n\r\n    .form-check-input {\r\n        width: 48px;\r\n        height: 24px;\r\n        left: -0.75rem;\r\n        position: relative;\r\n    }\r\n}\r\n\r\n.input-group-text {\r\n    margin-bottom: 0px;\r\n}\r\n\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .form-switch-#{$color} {\r\n        .form-check-input {\r\n\r\n            &:checked {\r\n                background-color: $value;\r\n                border-color: $value;\r\n            }\r\n        }\r\n    }\r\n\r\n    .form-switch-custom {\r\n        &.form-switch-#{$color} {\r\n            .form-check-input {\r\n                &:checked {\r\n                    &::before {\r\n                        color: $value;\r\n                    }\r\n\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Custom Switch style\r\n\r\n.form-switch-custom {\r\n    .form-check-input {\r\n        position: relative;\r\n        background-image: none;\r\n\r\n        &::before {\r\n            content: \"\\F0765\";\r\n            font-family: \"Material Design Icons\";\r\n            top: -9px;\r\n            position: absolute;\r\n            font-size: 20px;\r\n            left: -3px;\r\n            color: $text-muted;\r\n            @include transition($form-switch-transition);\r\n        }\r\n\r\n        &:checked {\r\n            background-image: none;\r\n            background-color: $form-check-input-bg;\r\n            @include transition($form-switch-transition);\r\n\r\n            &::before {\r\n                right: -3px;\r\n                left: auto;\r\n            }\r\n        }\r\n\r\n        &:focus {\r\n            background-image: none;\r\n        }\r\n    }\r\n}\r\n\r\n// Switch - Right\r\n\r\n.form-switch-right {\r\n    display: inline-block;\r\n    padding-right: $form-check-padding-start * .5;\r\n    margin-bottom: 0;\r\n    padding-left: 0 !important;\r\n\r\n    .form-check-input {\r\n        float: right;\r\n        margin-left: 0;\r\n        margin-right: $form-check-padding-start * -1;\r\n        margin-top: .1em !important;\r\n    }\r\n\r\n    label {\r\n        margin-bottom: 0;\r\n        margin-right: 1rem;\r\n    }\r\n}\r\n\r\n// card radio\r\n.card-radio {\r\n    padding: 0;\r\n\r\n    .form-check-label {\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n        border: 1px solid var(--#{$prefix}input-check-border);\r\n        border-radius: $border-radius;\r\n        padding: 1rem;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        display: block;\r\n        position: relative;\r\n        padding-right: 32px;\r\n\r\n        &:hover {\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .form-check-input {\r\n        display: none;\r\n\r\n        &:checked+.form-check-label {\r\n            border-color: $primary !important;\r\n\r\n            &:before {\r\n                content: '\\eb80';\r\n                font-family: \"remixicon\";\r\n                position: absolute;\r\n                top: 2px;\r\n                right: 6px;\r\n                font-size: 16px;\r\n                color: $primary;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.dark {\r\n        .form-check-input {\r\n            &:checked+.form-check-label {\r\n                &:before {\r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .form-switch{\r\n        .form-check-input, .form-check-input:focus{\r\n            background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$gray-400}'/></svg>\"));\r\n        }\r\n    }\r\n}\r\n","//\r\n// _form-control.scss\r\n//\r\n\r\n\r\n.form-icon{\r\n    position: relative;\r\n    .form-control-icon {\r\n        padding-left: $input-padding-x*3;\r\n        position: relative;\r\n    }\r\n    i {\r\n        position: absolute;\r\n        top: 0px;\r\n        bottom: 0px;\r\n        left: 18px;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    &.right{\r\n        .form-control-icon {\r\n            padding-right: $input-padding-x*3;\r\n            padding-left: $input-padding-x;\r\n            position: relative;\r\n        }\r\n        i {\r\n            left: auto;\r\n            right: 18px;\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .form-select {\r\n        background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$gray-400}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\"));\r\n        background-color: var(--#{$prefix}gray-200) !important;\r\n        border-color: var(--#{$prefix}border-color) !important;\r\n    }\r\n\r\n    .form-control {\r\n        background-color: var(--#{$prefix}gray-200);\r\n        border-color: var(--#{$prefix}border-color);\r\n    }\r\n  }","//\r\n// _list-group.scss\r\n//\r\n\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .list-group-fill-#{$color} {\r\n        .list-group-item {\r\n            &.active {\r\n                background-color: $value !important;\r\n                border-color: $value;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.list-group-fill-light {\r\n    color: $dark !important;\r\n}\r\n\r\n.list-group-item {\r\n    margin-bottom: 0px;\r\n    .list-text {\r\n        color: $text-muted;\r\n    }\r\n    &.active {\r\n        box-shadow: $element-shadow;\r\n        .list-title {\r\n            color: $white;\r\n        }\r\n        .list-text {\r\n            color: rgba($white, 0.50);\r\n        }\r\n    }\r\n}","//\r\n// _custom-scrollbar.scss\r\n//\r\n\r\n[data-simplebar] {\r\n  position: relative;\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.simplebar-wrapper {\r\n  overflow: hidden;\r\n  width: inherit;\r\n  height: inherit;\r\n  max-width: inherit;\r\n  max-height: inherit;\r\n}\r\n\r\n.simplebar-mask {\r\n  direction: inherit;\r\n  position: absolute;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  margin: 0;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: auto !important;\r\n  height: auto !important;\r\n  z-index: 0;\r\n}\r\n\r\n.simplebar-offset {\r\n  direction: inherit !important;\r\n  box-sizing: inherit !important;\r\n  resize: none !important;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0 !important;\r\n  bottom: 0;\r\n  right: 0 !important;\r\n  padding: 0;\r\n  margin: 0;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.simplebar-content-wrapper {\r\n  direction: inherit;\r\n  box-sizing: border-box !important;\r\n  position: relative;\r\n  display: block;\r\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\r\n  width: auto;\r\n  visibility: visible;\r\n  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\r\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\r\n  max-height: 100%; /* Needed for vertical scroll to trigger */\r\n  scrollbar-width: none;\r\n  padding: 0px !important;\r\n}\r\n\r\n.simplebar-content-wrapper::-webkit-scrollbar,\r\n.simplebar-hide-scrollbar::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.simplebar-content:before,\r\n.simplebar-content:after {\r\n  content: ' ';\r\n  display: table;\r\n}\r\n\r\n.simplebar-placeholder {\r\n  max-height: 100%;\r\n  max-width: 100%;\r\n  width: 100%;\r\n  pointer-events: none;\r\n}\r\n\r\n.simplebar-height-auto-observer-wrapper {\r\n  box-sizing: inherit !important;\r\n  height: 100%;\r\n  width: 100%;\r\n  max-width: 1px;\r\n  position: relative;\r\n  float: left;\r\n  max-height: 1px;\r\n  overflow: hidden;\r\n  z-index: -1;\r\n  padding: 0;\r\n  margin: 0;\r\n  pointer-events: none;\r\n  flex-grow: inherit;\r\n  flex-shrink: 0;\r\n  flex-basis: 0;\r\n}\r\n\r\n.simplebar-height-auto-observer {\r\n  box-sizing: inherit;\r\n  display: block;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 1000%;\r\n  width: 1000%;\r\n  min-height: 1px;\r\n  min-width: 1px;\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n  z-index: -1;\r\n}\r\n\r\n.simplebar-track {\r\n  z-index: 1;\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  pointer-events: none;\r\n  overflow: hidden;\r\n}\r\n\r\n[data-simplebar].simplebar-dragging .simplebar-content {\r\n  pointer-events: none;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n}\r\n\r\n[data-simplebar].simplebar-dragging .simplebar-track {\r\n  pointer-events: all;\r\n}\r\n\r\n.simplebar-scrollbar {\r\n  position: absolute;\r\n  right: 2px;\r\n  width: 6px;\r\n  min-height: 10px;\r\n}\r\n\r\n.simplebar-scrollbar:before {\r\n  position: absolute;\r\n  content: '';\r\n  background: #a2adb7;\r\n  border-radius: 7px;\r\n  left: 0;\r\n  right: 0;\r\n  opacity: 0;\r\n  transition: opacity 0.2s linear;\r\n}\r\n\r\n.simplebar-scrollbar.simplebar-visible:before {\r\n  /* When hovered, remove all transitions from drag handle */\r\n  opacity: 0.5;\r\n  transition: opacity 0s linear;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical {\r\n  top: 0;\r\n  width: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\r\n  top: 2px;\r\n  bottom: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal {\r\n  left: 0;\r\n  height: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\r\n  height: 100%;\r\n  left: 2px;\r\n  right: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\r\n  right: auto;\r\n  left: 0;\r\n  top: 2px;\r\n  height: 7px;\r\n  min-height: 0;\r\n  min-width: 10px;\r\n  width: auto;\r\n}\r\n\r\n/* Rtl support */\r\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\r\n  right: auto;\r\n  left: 0;\r\n}\r\n\r\n.hs-dummy-scrollbar-size {\r\n  direction: rtl;\r\n  position: fixed;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  height: 500px;\r\n  width: 500px;\r\n  overflow-y: hidden;\r\n  overflow-x: scroll;\r\n}\r\n\r\n.simplebar-hide-scrollbar {\r\n  position: fixed;\r\n  left: 0;\r\n  visibility: hidden;\r\n  overflow-y: scroll;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.custom-scroll {\r\n  height: 100%;\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  [data-simplebar-track=\"#{$color}\"]{\r\n    .simplebar-scrollbar:before{\r\n      background: $value;\r\n    }\r\n  }\r\n}","/**\r\n * prism.js default theme for JavaScript, CSS and HTML\r\n * Based on dabblet (http://dabblet.com)\r\n * @author Lea Verou\r\n */\r\n\r\ncode[class*=\"language-\"],\r\npre[class*=\"language-\"] {\r\n    color: black;\r\n    background: none;\r\n    text-shadow: 0 1px white;\r\n    font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\r\n    font-size: 1em;\r\n    text-align: left;\r\n    white-space: pre;\r\n    word-spacing: normal;\r\n    word-break: normal;\r\n    word-wrap: normal;\r\n    line-height: 1.5;\r\n\r\n    -moz-tab-size: 4;\r\n    -o-tab-size: 4;\r\n    tab-size: 4;\r\n\r\n    -webkit-hyphens: none;\r\n    -moz-hyphens: none;\r\n    -ms-hyphens: none;\r\n    hyphens: none;\r\n}\r\n\r\npre[class*=\"language-\"]::-moz-selection,\r\npre[class*=\"language-\"] ::-moz-selection,\r\ncode[class*=\"language-\"]::-moz-selection,\r\ncode[class*=\"language-\"] ::-moz-selection {\r\n    text-shadow: none;\r\n    background: #b3d4fc;\r\n}\r\n\r\npre[class*=\"language-\"]::selection,\r\npre[class*=\"language-\"] ::selection,\r\ncode[class*=\"language-\"]::selection,\r\ncode[class*=\"language-\"] ::selection {\r\n    text-shadow: none;\r\n    background: #b3d4fc;\r\n}\r\n\r\n@media print {\r\n    code[class*=\"language-\"],\r\n    pre[class*=\"language-\"] {\r\n        text-shadow: none;\r\n    }\r\n}\r\n\r\n/* Code blocks */\r\npre[class*=\"language-\"] {\r\n    padding: 1em;\r\n    margin: 0;\r\n    overflow: auto;\r\n}\r\n\r\n:not(pre) > code[class*=\"language-\"],\r\npre[class*=\"language-\"] {\r\n    background: var(--#{$prefix}light) !important;\r\n}\r\n\r\n/* Inline code */\r\n:not(pre) > code[class*=\"language-\"] {\r\n    padding: 0.1em;\r\n    border-radius: 0.3em;\r\n    white-space: normal;\r\n}\r\n\r\n.token.comment,\r\n.token.prolog,\r\n.token.doctype,\r\n.token.cdata {\r\n    color: slategray;\r\n}\r\n\r\n.token.punctuation {\r\n    color: #999;\r\n}\r\n\r\n.token.namespace {\r\n    opacity: 0.7;\r\n}\r\n\r\n.token.property,\r\n.token.tag,\r\n.token.boolean,\r\n.token.number,\r\n.token.constant,\r\n.token.symbol,\r\n.token.deleted {\r\n    color: $danger;\r\n}\r\n\r\n.token.selector,\r\n.token.attr-name,\r\n.token.string,\r\n.token.char,\r\n.token.builtin,\r\n.token.inserted {\r\n    color: #690;\r\n}\r\n\r\n.token.operator,\r\n.token.entity,\r\n.token.url,\r\n.language-css .token.string,\r\n.style .token.string {\r\n    color: #9a6e3a;\r\n    /* This background color was intended by the author of this theme. */\r\n    background: hsla(0, 0%, 100%, 0.5);\r\n}\r\n\r\n.token.atrule,\r\n.token.attr-value,\r\n.token.keyword {\r\n    color: #07a;\r\n}\r\n\r\n.token.function,\r\n.token.class-name {\r\n    color: #dd4a68;\r\n}\r\n\r\n.token.regex,\r\n.token.important,\r\n.token.variable {\r\n    color: #e90;\r\n}\r\n\r\n.token.important,\r\n.token.bold {\r\n    font-weight: bold;\r\n}\r\n.token.italic {\r\n    font-style: italic;\r\n}\r\n\r\n.token.entity {\r\n    cursor: help;\r\n}\r\n\r\n/* Prism editor */\r\n:not(pre) > code[class*=\"language-\"],\r\npre[class*=\"language-\"] {\r\n    background: $gray-200;\r\n}\r\n\r\ncode[class*=\"language-\"],\r\npre[class*=\"language-\"] {\r\n    color: $gray-600;\r\n    text-shadow: none;\r\n}\r\n\r\n\r\n\r\n// Scrollbar\r\n\r\n.language-markup {\r\n    &::-webkit-scrollbar {\r\n        -webkit-appearance: none;\r\n    }\r\n\r\n    &::-webkit-scrollbar:vertical {\r\n        width: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar:horizontal {\r\n        height: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n        background-color: rgba(var(--#{$prefix}dark-rgb), .1);\r\n        border-radius: 10px;\r\n        border: 2px solid var(--#{$prefix}light)\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n        border-radius: 10px;\r\n        background-color: var(--#{$prefix}light)\r\n    }\r\n}\r\n\r\n\r\n// Scroll-top\r\n\r\n#scroll-top {\r\n    width: 30px;\r\n    height: 30px;\r\n    position: fixed;\r\n    bottom: 65px;\r\n    right: 30px;\r\n    background: #343a40;\r\n    border-color: transparent;\r\n    border-radius: 3px;\r\n    color: #ffffff;\r\n    transition: all 0.5s ease;\r\n}\r\n\r\n// Toolbar (Copy button)\r\n\r\n.btn-clipboard {\r\n    position: absolute !important;\r\n    right: 15px !important;\r\n    z-index: 1 !important;\r\n}\r\n\r\ndiv.code-toolbar > .toolbar {\r\n    opacity: 1 !important;\r\n    button {\r\n        display: inline-block !important;\r\n        margin: 0.375rem 0.5rem !important;\r\n        padding: 0.25rem 0.75rem !important;\r\n        transition: $btn-transition !important;\r\n        border-radius: $border-radius-sm !important;\r\n        border: $border-width solid rgba($primary, 0.35) !important;\r\n        background-color: transparent;\r\n        color: $primary !important;\r\n        box-shadow: none !important;\r\n        &:focus {\r\n            outline: none !important;\r\n            box-shadow: none !important;\r\n        }\r\n        &:hover {\r\n            background-color: $primary !important;\r\n            color: $white !important;\r\n        }\r\n    }\r\n}\r\n","\r\n//\r\n//  _sweetalert2.scss\r\n//\r\n\r\n.swal2-container {\r\n  .swal2-title{\r\n    padding: 24px 24px 0;\r\n    font-size: 20px;\r\n    font-weight: $font-weight-medium;\r\n  }  \r\n}\r\n\r\n.swal2-popup{\r\n  padding-bottom: 24px;\r\n  border-radius: $modal-content-border-radius;\r\n  background-color: var(--#{$prefix}card-bg-custom);\r\n  color: var(--#{$prefix}body-color);\r\n\r\n  .swal2-title{\r\n    color: var(--#{$prefix}heading-color);\r\n  }\r\n\r\n  .swal2-html-container{\r\n    color: var(--#{$prefix}body-color);\r\n  }\r\n}\r\n\r\n.swal2-footer{\r\n  border-top: 1px solid var(--#{$prefix}border-color);\r\n  color: var(--#{$prefix}body-color);\r\n}\r\n\r\n.swal2-html-container{\r\n  font-size: 16px;\r\n}\r\n\r\n.swal2-icon{\r\n  &.swal2-question{\r\n    border-color: $info;\r\n    color: $info;\r\n  }\r\n  &.swal2-success {\r\n    [class^=swal2-success-line]{\r\n      background-color: $success;\r\n    }\r\n\r\n    .swal2-success-ring{\r\n      border-color: rgba($success, 0.3);\r\n    }\r\n  }\r\n  &.swal2-warning{\r\n    border-color: $warning;\r\n    color: $warning;\r\n  }\r\n}\r\n\r\n.swal2-styled{\r\n  &:focus{\r\n    box-shadow: none;\r\n  }\r\n}\r\n\r\n.swal2-loader{\r\n  border-color: $primary transparent $primary transparent;\r\n}\r\n\r\n.swal2-timer-progress-bar{\r\n  background-color: rgba($success, 0.4);\r\n}\r\n\r\n.swal2-progress-steps {\r\n  .swal2-progress-step{\r\n    background: $primary;\r\n    &.swal2-active-progress-step{\r\n      background: $primary;\r\n      &~.swal2-progress-step, &~.swal2-progress-step-line{\r\n        background: rgba($primary, 0.3);\r\n      }\r\n    }\r\n  }\r\n  .swal2-progress-step-line{\r\n    background: $primary;\r\n  }\r\n}\r\n\r\n.swal2-actions.swal2-loading{\r\n  .swal2-styled.swal2-confirm{\r\n    border-left-color: $primary !important;\r\n    border-right-color: $primary !important;\r\n  }\r\n}\r\n\r\n.swal2-file, .swal2-input, .swal2-textarea{\r\n  border: 1px solid $input-border-color;\r\n  &:focus{\r\n    box-shadow: none;\r\n    border-color: $input-focus-border-color;\r\n  }\r\n}\r\n\r\n.swal2-input{\r\n  height: auto;\r\n  display: block;\r\n  padding: $input-padding-y $input-padding-x;\r\n  font-family: $input-font-family;\r\n  @include font-size($input-font-size);\r\n  font-weight: $input-font-weight;\r\n  line-height: $input-line-height;\r\n  color: $input-color;\r\n  background-color: $input-bg;\r\n  background-clip: padding-box;\r\n  border: $input-border-width solid $input-border-color;\r\n}\r\n\r\n.swal2-close{\r\n  font-family: $font-family-base;\r\n  font-weight: $font-weight-light;\r\n  font-size: 28px;\r\n  &:focus{\r\n    box-shadow: none;\r\n  }\r\n\r\n  &:hover{\r\n    color: $primary;\r\n  }\r\n}\r\n\r\n.swal2-validation-message{\r\n  background-color: transparent;\r\n}","//\r\n// Dropzone\r\n//\r\n\r\n\r\n.dropzone {\r\n  min-height: 230px;\r\n  border: 2px dashed var(--#{$prefix}border-color);\r\n  background: var(--#{$prefix}card-bg-custom);\r\n  border-radius: 6px;\r\n\r\n  .dz-message {\r\n    font-size: 24px;\r\n    width: 100%;\r\n    margin: 1em 0;\r\n  }\r\n}\r\n","\r\n//\r\n// _range-slider.scss\r\n//\r\n\r\n.noUi-connect{\r\n  background: $success;\r\n}\r\n\r\n.noUi-handle{\r\n  background: $success;\r\n  border: 2px solid var(--#{$prefix}card-bg);\r\n  box-shadow: none;\r\n}\r\n\r\n.noUi-horizontal{\r\n  height: 4px;\r\n  .noUi-handle{\r\n    height: 16px;\r\n    width: 16px;\r\n    border-radius: 50%;\r\n    right: -10px !important;\r\n    top: -7px;\r\n\r\n    &::before, &::after{\r\n      display: none;\r\n    }\r\n    &:focus{\r\n      outline: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.noUi-pips-horizontal{\r\n  height: 50px;\r\n}\r\n\r\n// tooltip\r\n\r\n.noUi-tooltip{\r\n  padding: $tooltip-padding-y $tooltip-padding-x;\r\n  border-color: $border-color;\r\n  border-radius: $tooltip-border-radius;\r\n  background-color: var(--#{$prefix}card-bg-custom);\r\n  color: var(--#{$prefix}body-color);\r\n}\r\n\r\n// Vertical Slider\r\n\r\n.noUi-vertical{\r\n  width: 4px;\r\n  .noUi-handle{\r\n    height: 16px;\r\n    width: 16px;\r\n    right: -8px;\r\n    top: -12px;\r\n    left: auto;\r\n    border-radius: 50%;\r\n    &::before, &::after{\r\n      display: none;\r\n    }\r\n    &:focus{\r\n      outline: 0;\r\n    }\r\n  }\r\n\r\n  .noUi-origin{\r\n    top: 0;\r\n  }\r\n}\r\n\r\n.noUi-value{\r\n  font-size: 12px;\r\n}\r\n\r\n.noUi-marker-horizontal{\r\n  &.noUi-marker-large{\r\n    height: 12px;\r\n  }\r\n}\r\n\r\n.noUi-value-horizontal{\r\n  padding-top: 4px;\r\n}\r\n\r\n.noUi-target{\r\n  box-shadow: none;\r\n  background-color: var(--#{$prefix}light);\r\n  border-color: var(--#{$prefix}light);\r\n}\r\n\r\n.noUi-touch-area{\r\n  &:focus{\r\n    outline: 0;\r\n  }\r\n}\r\n\r\n// Colorpicker\r\n\r\n#red, #green, #blue {\r\n\tmargin: 10px;\r\n\tdisplay: inline-block;\r\n\theight: 200px;\r\n}\r\n\r\n#colorpicker {\r\n\theight: 240px;\r\n\twidth: 310px;\r\n\tmargin: 0 auto;\r\n\tpadding: 10px;\r\n\tborder: 1px solid $border-color;\r\n}\r\n\r\n#result {\r\n\tmargin: 60px 26px;\r\n\theight: 100px;\r\n\twidth: 100px;\r\n\tdisplay: inline-block;\r\n\tvertical-align: top;\r\n\tborder: 1px solid $border-color;\r\n    box-shadow: 0 0 3px;\r\n    border-radius: 7px;\r\n}\r\n\r\n#red {\r\n    .noUi-connect {\r\n        background: $danger;\r\n    }\r\n}\r\n\r\n#green {\r\n    .noUi-connect {\r\n        background: $success;\r\n    }\r\n}\r\n\r\n#blue {\r\n    .noUi-connect {\r\n        background: $primary;\r\n    }\r\n}\r\n\r\n// Adding keyboard support\r\n\r\n.form-control{\r\n    &.keyboard{\r\n        max-width: 340px !important;\r\n    }\r\n}\r\n\r\n\r\n// Non linear slider\r\n\r\n.example-val{\r\n    font-size: 12px;\r\n    color: $text-muted;\r\n    display: block;\r\n    margin: 15px 0;\r\n    &:before{\r\n        content: \"Value: \";\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n    }\r\n}\r\n\r\n// showing tooltips\r\n\r\n.noUi-tooltip {\r\n    display: none;\r\n}\r\n.noUi-active .noUi-tooltip {\r\n    display: block;\r\n}\r\n\r\n// Colored Connect Elements\r\n\r\n.c-1-color { background: $danger; }\r\n.c-2-color { background: $warning; }\r\n.c-3-color { background: $success; }\r\n.c-4-color { background: $primary; }\r\n.c-5-color { background: $purple; }\r\n\r\n//  slider togle\r\n\r\n#slider-toggle {\r\n    height: 50px;\r\n    &.off{\r\n        .noUi-handle{\r\n            border-color: $danger;\r\n        }\r\n    }\r\n}\r\n\r\n// rangeslider color\r\n\r\n@each $color, $value in $theme-colors {\r\n  [data-slider-color=\"#{$color}\"] {\r\n    .noUi-connect{\r\n      background: $value;\r\n    }\r\n\r\n    .noUi-handle{\r\n      background: $value;\r\n    }\r\n\r\n    &[data-slider-style=\"border\"], &[data-slider-style=\"square\"]{\r\n      .noUi-handle{\r\n        border-color: $value;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// rangeslider sizes\r\n\r\n[data-slider-size=\"lg\"]{\r\n  &.noUi-horizontal{\r\n    height: 12px;\r\n\r\n    .noUi-handle{\r\n      width: 24px;\r\n      height: 24px;\r\n    }\r\n  }\r\n}\r\n\r\n[data-slider-size=\"md\"]{\r\n  &.noUi-horizontal{\r\n    height: 8px;\r\n\r\n    .noUi-handle{\r\n      width: 20px;\r\n      height: 20px;\r\n    }\r\n  }\r\n}\r\n\r\n[data-slider-size=\"sm\"]{\r\n  &.noUi-horizontal{\r\n    height: 4px;\r\n\r\n    .noUi-handle{\r\n      width: 16px;\r\n      height: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n// rangeslider style\r\n\r\n[data-slider-style=\"line\"]{\r\n  &.noUi-horizontal .noUi-handle{\r\n    width: 8px;\r\n    border-radius: 4px;\r\n    right: -8px;\r\n  }\r\n  &.noUi-vertical .noUi-handle{\r\n    height: 8px;\r\n    border-radius: 4px;\r\n    top: -3px;\r\n  }\r\n}\r\n\r\n[data-slider-style=\"border\"]{\r\n  .noUi-handle{\r\n    border-color: $success;\r\n    background-color: $card-bg;\r\n  }\r\n}\r\n\r\n[data-slider-style=\"square\"]{\r\n  .noUi-handle{\r\n    border-radius: 0px;\r\n    transform: rotate(45deg);\r\n    height: 10px;\r\n    width: 10px;\r\n    top: -4px;\r\n    border-color: $success;\r\n    background-color: $card-bg;\r\n  }\r\n}\r\n\r\n","// \r\n// _sortablejs.scss\r\n// \r\n\r\n\r\n.nested-list{\r\n    .list-group-item{\r\n        background-color: rgba($primary, 0.05);\r\n        border-color: rgba($primary, 0.05);\r\n    }\r\n}\r\n\r\n.nested-list, .nested-1, .nested-2, .nested-3{\r\n    margin-top: 5px;\r\n}\r\n\r\n\r\n.nested-sortable-handle{\r\n    .handle{\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n        width: 42px;\r\n        height: 42px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        cursor: grab;\r\n    }\r\n    .list-group-item{\r\n        padding-left: 42px;\r\n    }\r\n}","// \r\n// tour.scss\r\n// \r\n\r\n.shepherd-element{\r\n    background: var(--#{$prefix}card-bg-custom);\r\n    box-shadow: $box-shadow;\r\n}\r\n\r\n.shepherd-has-title{\r\n    .shepherd-content{\r\n        .shepherd-header{\r\n            background-color: var(--#{$prefix}light);\r\n            padding: $toast-padding-y $toast-padding-x;\r\n        }\r\n\r\n        .shepherd-cancel-icon{\r\n            color: rgba(var(--#{$prefix}dark-rgb), .75);\r\n            &:hover{\r\n                color: rgba(var(--#{$prefix}dark-rgb), .75);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.shepherd-element.shepherd-has-title[data-popper-placement^=bottom]>.shepherd-arrow:before{\r\n    background-color: var(--#{$prefix}light);\r\n}\r\n\r\n.shepherd-title{\r\n    font-size: 15px;\r\n    font-weight: $font-weight-medium;\r\n    color: var(--#{$prefix}body-color);\r\n}\r\n\r\n.shepherd-text{\r\n    padding: $toast-padding-x;\r\n    font-size: $font-size-base;\r\n    color: var(--#{$prefix}body-color);\r\n}\r\n\r\n.shepherd-button{\r\n    &.btn-success:not(:disabled):hover{\r\n        background: darken($success, 2.5%);\r\n        color: $white;\r\n    }\r\n\r\n    &.btn-light:not(:disabled):hover{\r\n        background: rgba(var(--#{$prefix}light-rgb), .75);\r\n        color: var(--#{$prefix}dark);\r\n    }\r\n\r\n    &.btn-primary:not(:disabled):hover{\r\n        background: darken($primary, 2.5%);\r\n        color: $white;\r\n    }\r\n}\r\n\r\n.shepherd-footer{\r\n    padding: 0 $toast-padding-x $toast-padding-x;\r\n}\r\n.shepherd-arrow,\r\n.shepherd-arrow:before{\r\n    content: \"\\ea75\";\r\n    font-family: 'remixicon';\r\n    font-size: 24px;\r\n    z-index: 1;\r\n    background-color: transparent !important;\r\n    transform: rotate(0deg);\r\n    color: $primary;\r\n}\r\n\r\n.shepherd-element[data-popper-placement^=bottom]>.shepherd-arrow{\r\n    top: -18px;\r\n}\r\n\r\n.shepherd-button{\r\n    margin-right: 0.5rem;\r\n}","//\r\n// _swiper.scss\r\n//\r\n\r\n.swiper-button-next, .swiper-button-prev {\r\n    height: 32px !important;\r\n    width: 32px !important;\r\n    background-color: rgba($primary, 0.2);\r\n    backdrop-filter: blur(2px);\r\n    border-radius: 8px;\r\n    &::after {\r\n        font-family: remixicon !important;\r\n        font-size: 28px !important;\r\n        color: rgba($primary, 1);\r\n        transition: all 0.3s ease;\r\n    }\r\n}\r\n\r\n.swiper-button-prev {\r\n    &::after {\r\n        content: \"\\ea64\" !important;\r\n    }\r\n}\r\n.swiper-button-next {\r\n    &::after {\r\n        content: \"\\ea6e\" !important;\r\n    }\r\n}\r\n\r\n.swiper-pagination-bullet{\r\n    width: 22px !important;\r\n    height: 5px !important;\r\n    background-color: $white !important;\r\n    border-radius: 50px !important;\r\n    box-shadow: $element-shadow;\r\n    .swiper-pagination-bullet-active{\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n.dynamic-pagination{\r\n    .swiper-pagination-bullet {\r\n        width: 8px;\r\n        height: 8px;\r\n        background-color: $white;\r\n        opacity: 0.5;\r\n        transition: all 0.5s ease;\r\n        &.swiper-pagination-bullet-active{\r\n            opacity: 1;\r\n            width: 20px;\r\n        }\r\n    }\r\n}\r\n\r\n.swiper-pagination-fraction {\r\n    color: $white;\r\n    font-size: 16px;\r\n    background-color: rgba($black, 0.3);\r\n    backdrop-filter: blur(2px);\r\n}\r\n\r\n\r\n.pagination-custom{\r\n    .swiper-pagination-bullet {\r\n        height: 25px !important;\r\n        width: 25px !important;\r\n        line-height: 25px !important;\r\n        border-radius: 8px !important;\r\n        background-color: $white !important;\r\n        opacity: 0.5 !important;\r\n        transition: all 0.5s ease;\r\n        &.swiper-pagination-bullet-active{\r\n            color: $secondary !important;\r\n            opacity: 1 !important;\r\n        }\r\n    }\r\n}\r\n\r\n.swiper-pagination-progressbar{\r\n    height: 6px !important;\r\n    background-color: rgba($success, 0.25) !important;\r\n    .swiper-pagination-progressbar-fill {\r\n        background-color: $success !important;\r\n    }\r\n}\r\n\r\n\r\n.swiper-scrollbar {\r\n    background-color: rgba($white, 0.35);\r\n    backdrop-filter: blur(2px);\r\n    padding: 1.2px;\r\n    height: 6px !important;\r\n    .swiper-scrollbar-drag {\r\n        background-color: $white;\r\n    }\r\n}\r\n\r\n.swiper-pagination-dark {\r\n    .swiper-pagination-bullet {\r\n        background-color: $secondary !important;\r\n    }\r\n    .dynamic-pagination{\r\n        .swiper-pagination-bullet { \r\n            background-color: $secondary !important;\r\n        }\r\n    }\r\n    &.pagination-custom{\r\n        .swiper-pagination-bullet { \r\n            color: $white;\r\n            &.swiper-pagination-bullet-active{\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n    &.swiper-scrollbar { \r\n        background-color: rgba($dark, 0.35); \r\n    }\r\n}","\r\n//\r\n// _multijs.scss\r\n//\r\n\r\n.multi-wrapper{\r\n  border: none;\r\n  position: relative;\r\n\r\n  &::before{\r\n    content: \"\\ea61\";\r\n    position: absolute;\r\n    font-family: \"remixicon\";\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    bottom: 86px;\r\n    width: 32px;\r\n    height: 32px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 16px;\r\n    border-radius: 50%;\r\n    color: $text-muted;\r\n    background-color: var(--#{$prefix}light);\r\n    z-index: 1;\r\n  }\r\n  \r\n  .non-selected-wrapper{\r\n    border: 1px solid $input-border-color;\r\n    background-color: $input-bg;\r\n    border-top-left-radius: $border-radius;\r\n    border-bottom-left-radius: $border-radius;\r\n  }\r\n\r\n  .selected-wrapper, .non-selected-wrapper{\r\n    &::-webkit-scrollbar {\r\n      -webkit-appearance: none;\r\n    }\r\n  \r\n    &::-webkit-scrollbar:vertical {\r\n      width: 10px;\r\n    }\r\n  \r\n    &::-webkit-scrollbar:horizontal {\r\n      height: 9px;\r\n    }\r\n  \r\n    &::-webkit-scrollbar-thumb {\r\n      background-color: rgba(var(--#{$prefix}dark-rgb), .2);\r\n      border-radius: 10px;\r\n      border: 2px solid $input-bg;\r\n    }\r\n  \r\n    &::-webkit-scrollbar-track {\r\n      border-radius: 10px;  \r\n      background-color: $input-bg; \r\n    }\r\n}\r\n\r\n  .item-group .group-label{\r\n    font-size: 12px;\r\n  }\r\n\r\n  .item{\r\n    color: $input-color;\r\n    &:hover{\r\n      background-color: rgba($primary, 0.1);\r\n    }\r\n  }\r\n\r\n  .selected-wrapper{\r\n    border: 1px solid $input-border-color;\r\n    background: $input-bg;\r\n    border-top-right-radius: $border-radius;\r\n    border-bottom-right-radius: $border-radius;\r\n  }\r\n\r\n  .search-input{\r\n    flex: 0 0 auto;\r\n    padding: $input-padding-y $input-padding-x;\r\n    font-family: $input-font-family;\r\n    font-size: $input-font-size;\r\n    color: $input-color;\r\n    background-color: $input-bg;\r\n    border: $input-border-width solid $input-border-color;\r\n    border-radius: $input-border-radius;\r\n    margin-bottom: 16px;\r\n    &::placeholder{\r\n      color: $input-placeholder-color;\r\n    }\r\n  }\r\n\r\n  .header{\r\n    font-weight: $font-weight-semibold;\r\n    color: var(--#{$prefix}gray-600);\r\n  }\r\n}","//\r\n// _colorpicker.scss\r\n//\r\n\r\n.pcr-app{\r\n  background: var(--#{$prefix}card-bg-custom);\r\n  box-shadow: $box-shadow-lg;\r\n  border-radius: 4px;\r\n  border: 1px solid $border-color;\r\n}\r\n\r\n.pickr{\r\n  .pcr-button{\r\n    border: 4px solid var(--#{$prefix}card-bg-custom);\r\n    box-shadow: 0px 0px 0 2px $border-color;\r\n    border-radius: 50%;\r\n    box-shadow: $element-shadow;\r\n    &::after, &::before{\r\n      border-radius: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n.pcr-app{\r\n  &[data-theme=classic]{\r\n    .pcr-selection {\r\n      .pcr-color-preview{\r\n        margin-right: .75em;\r\n        margin-left: 0;\r\n      }\r\n  \r\n      .pcr-color-chooser, .pcr-color-opacity{\r\n        margin-left: .75em;\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  &[data-theme=\"monolith\"]{\r\n    .pcr-result{\r\n      min-width: 100%;\r\n    }\r\n  }\r\n\r\n  .pcr-interaction{\r\n    .pcr-type.active{\r\n      background: $primary;\r\n    }\r\n\r\n    .pcr-result{\r\n      background-color: $input-bg;\r\n      color: $input-color;\r\n      border: 1px solid $input-border-color;\r\n      border-radius: $input-border-radius;\r\n    }\r\n\r\n    input{\r\n      border-radius: $input-border-radius !important;\r\n      &:focus{\r\n        box-shadow: none;\r\n        background-color: $input-focus-bg;\r\n        border-color: $input-focus-border-color;\r\n      }\r\n    }\r\n\r\n    .pcr-save{\r\n      background: $success !important;\r\n    }\r\n\r\n    .pcr-clear, .pcr-cancel{\r\n      background: $danger !important;\r\n    }\r\n  }\r\n}","//\r\n// filepond\r\n//\r\n\r\n.filepond--root{\r\n  margin-bottom: 0;\r\n\r\n  &[data-style-panel-layout~=circle]{\r\n    .filepond--drop-label label{\r\n      font-size: 14px;\r\n    }\r\n  }\r\n}\r\n\r\n.filepond--panel-root{\r\n  border: 2px dashed var(--#{$prefix}border-color);\r\n  background: var(--#{$prefix}card-bg-custom);\r\n}\r\n\r\n.filepond--drop-label {\r\n  color: var(--#{$prefix}body-color);\r\n  label{\r\n    font-weight: $font-weight-medium;\r\n  }\r\n}\r\n\r\n.filepond--credits {\r\n  display: none;\r\n}\r\n\r\n.filepond--item-panel {\r\n  background-color: $primary !important;\r\n}","//\r\n// _form-input-spin.scss\r\n//\r\n\r\n\r\n[type=\"number\"]::-webkit-inner-spin-button,\r\n[type=\"number\"]::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    height: auto;\r\n}\r\n\r\n.input-step {\r\n    border: 1px solid $input-border-color;\r\n    display: inline-flex;\r\n    overflow: visible;\r\n    height: 37.5px;\r\n    @include border-radius($input-border-radius, 0);\r\n    background: $input-bg;\r\n    padding: 4px;\r\n\r\n    input {\r\n        width: 4em;\r\n        height: 100%;\r\n        text-align: center;\r\n        border: 0;\r\n        background: transparent;\r\n        color: $input-color;\r\n        border-radius: $input-border-radius;\r\n\r\n        &:focus-visible {\r\n            outline: 0;\r\n        }\r\n    }\r\n\r\n    button {\r\n        width: 1.4em;\r\n        font-weight: 300;\r\n        height: 100%;\r\n        line-height: 0.1em;\r\n        font-size: 1.4em;\r\n        padding: 0.2em !important;\r\n        background: var(--#{$prefix}light);\r\n        color: var(--#{$prefix}body-color);\r\n        border: none;\r\n        border-radius: $btn-border-radius;\r\n    }\r\n\r\n    &.light {\r\n        background: var(--#{$prefix}light);\r\n\r\n        button {\r\n            background-color: $input-bg;\r\n        }\r\n    }\r\n\r\n    &.light-input {\r\n        background: var(--#{$prefix}light);\r\n\r\n        input {\r\n            background-color: $input-bg;\r\n        }\r\n    }\r\n\r\n    &.full-width {\r\n        display: flex;\r\n        width: 100%;\r\n\r\n        button {\r\n            flex-shrink: 0;\r\n        }\r\n\r\n        input {\r\n            flex-grow: 1;\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .input-step {\r\n        &.step-#{$color} {\r\n            button {\r\n                background-color: $value;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// _ckeditor.scss\r\n//\r\n\r\n.ck {\r\n    font-family: $font-family-base !important;\r\n\r\n    &.ck-reset_all, &.ck-reset_all *{\r\n        color: var(--#{$prefix}body-color) !important;\r\n    }\r\n    &.ck-toolbar{\r\n        background: #{rgba(var(--#{$prefix}light-rgb), .75)} !important;\r\n    }\r\n\r\n    p {\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    &.ck-toolbar {\r\n        border: 1px solid $input-border-color !important;\r\n\r\n        &.ck-toolbar_grouping>.ck-toolbar__items {\r\n            flex-wrap: wrap !important;\r\n        }\r\n\r\n        .ck.ck-toolbar__separator {\r\n            background: transparent !important;\r\n        }\r\n    }\r\n\r\n    &.ck-editor__main>.ck-editor__editable {\r\n        border-top: 0 !important;\r\n        background-color: var(--#{$prefix}card-bg-custom) !important;\r\n        border-color: $input-border-color !important;\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    &.ck-dropdown__panel{\r\n        background: var(--#{$prefix}choices-bg) !important;\r\n        box-shadow: $box-shadow-lg;\r\n        animation-name: DropDownSlide;\r\n        animation-duration: .3s;\r\n        animation-fill-mode: both;\r\n        border-radius: $dropdown-border-radius;\r\n    }\r\n\r\n    &.ck-list {\r\n        background: var(--#{$prefix}choices-bg) !important;\r\n    }\r\n\r\n    &.ck-dropdown {\r\n        .ck-dropdown__panel {\r\n            &.ck-dropdown__panel_ne,\r\n            &.ck-dropdown__panel_se {\r\n                left: 0;\r\n                right: auto !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.ck-editor__editable_inline {\r\n        &[dir=ltr] {\r\n            text-align: left !important;\r\n        }\r\n    }\r\n\r\n    &.ck-dropdown__panel {\r\n        box-shadow: $dropdown-box-shadow !important;\r\n        border-radius: $dropdown-border-radius !important;\r\n        border: 1px solid $dropdown-border-color !important;\r\n    }\r\n}\r\n\r\n.ck.ck-button, \r\na.ck.ck-button{\r\n\r\n    &:focus, &:active{\r\n        box-shadow: none !important;\r\n        border: 1px solid var(--#{$prefix}light) !important;\r\n    }\r\n\r\n    &:not(.ck-disabled){\r\n        &:hover{\r\n            background: var(--#{$prefix}light) !important;\r\n        }\r\n    }\r\n\r\n    &.ck-on{\r\n        background: var(--#{$prefix}light) !important;\r\n    }\r\n}\r\n\r\n.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \r\n.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\r\n    border-radius: $border-radius !important;\r\n    border-bottom-left-radius: 0 !important;\r\n    border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \r\n.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\r\n    border-radius: $border-radius !important;\r\n    border-top-left-radius: 0 !important;\r\n    border-top-right-radius: 0 !important;\r\n}\r\n\r\n.ck-editor__editable {\r\n    min-height: 245px !important;\r\n}\r\n\r\n.ck[class*=ck-heading_heading] {\r\n    font-weight: $font-weight-medium !important;\r\n}\r\n\r\n.ck,\r\na.ck {\r\n    &.ck-button {\r\n        &.ck-on:not(.ck-disabled) {\r\n            &:hover,\r\n            &:active {\r\n                box-shadow: none !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.ck{\r\n    &.ck-tooltip{\r\n        .ck-tooltip__text {\r\n            background: $dark !important;\r\n            color: $light !important;\r\n        }\r\n    }\r\n\r\n    &.ck-input-text{\r\n        background: $input-bg !important;\r\n        border: 1px solid $input-border-color !important;\r\n        &:focus{\r\n            border: 1px solid $input-focus-border-color !important;\r\n            box-shadow: none !important;\r\n        }\r\n    }\r\n\r\n    &.ck-balloon-panel{\r\n        background: $dropdown-bg !important;\r\n        border: 1px solid $dropdown-border-color !important;\r\n\r\n        &[class*=arrow_n]{\r\n            &:after{\r\n                border-bottom-color: $dropdown-bg !important;\r\n            }\r\n\r\n            &::before{\r\n                border-bottom-color: $dropdown-border-color !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{\r\n    background: $dropdown-bg !important;\r\n}\r\n\r\n// ck-editor-reverse\r\n\r\n.ck-editor-reverse{\r\n    .ck-editor{\r\n      display: flex;\r\n      flex-direction: column-reverse;\r\n    }\r\n  \r\n    .ck{\r\n      &.ck-editor__main>.ck-editor__editable{\r\n        border: 1px solid $input-border-color !important;\r\n        border-bottom: 0 !important;\r\n      }\r\n    }\r\n  \r\n    .ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \r\n    .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\r\n      border-radius: $border-radius !important;\r\n      border-bottom-left-radius: 0 !important;\r\n      border-bottom-right-radius: 0 !important;\r\n    }\r\n  \r\n    .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \r\n    .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\r\n      border-radius: $border-radius !important;\r\n      border-top-left-radius: 0 !important;\r\n      border-top-right-radius: 0 !important;\r\n    }\r\n}\r\n\r\n[dir=\"rtl\"] {\r\n    .ck.ck-toolbar>.ck-toolbar__items {\r\n        flex-direction: row-reverse;\r\n    }\r\n}","//\r\n// _quilljs.scss\r\n//\r\n\r\n.ql-editor {\r\n    text-align: left;\r\n\r\n    ol,\r\n    ul {\r\n        padding-left: 1.5em;\r\n        padding-right: 0;\r\n    }\r\n\r\n    li:not(.ql-direction-rtl)::before {\r\n        margin-left: -1.5em;\r\n        margin-right: 0.3em;\r\n        text-align: right;\r\n    }\r\n}\r\n\r\n.ql-container {\r\n    font-family: $font-family-base;\r\n\r\n    &.ql-snow {\r\n        border-color: $input-border-color;\r\n        border-bottom-left-radius: 4px;\r\n        border-bottom-right-radius: 4px;\r\n    }\r\n}\r\n\r\n.ql-bubble {\r\n    border: $input-border-width solid $input-border-color;\r\n    border-radius: $input-border-radius;\r\n}\r\n\r\n.ql-toolbar {\r\n    font-family: $font-family-base !important;\r\n\r\n    span {\r\n        outline: none !important;\r\n        color: var(--#{$prefix}choices-link-color);\r\n\r\n        &:hover {\r\n            color: $primary !important;\r\n        }\r\n    }\r\n\r\n    &.ql-snow {\r\n        border-top-left-radius: 4px;\r\n        border-top-right-radius: 4px;\r\n        border-color: $input-border-color;\r\n\r\n        .ql-picker.ql-expanded {\r\n            .ql-picker-label {\r\n                border-color: transparent;\r\n            }\r\n        }\r\n\r\n        .ql-picker-options {\r\n            box-shadow: $dropdown-box-shadow;\r\n            border-radius: $dropdown-border-radius;\r\n        }\r\n    }\r\n}\r\n\r\n.ql-snow {\r\n\r\n    .ql-stroke,\r\n    .ql-script,\r\n    .ql-strike svg {\r\n        stroke: var(--#{$prefix}choices-link-color);\r\n    }\r\n\r\n    .ql-fill {\r\n        fill: var(--#{$prefix}choices-link-color);\r\n    }\r\n\r\n    .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) {\r\n        svg {\r\n            right: 0;\r\n            left: auto;\r\n        }\r\n    }\r\n\r\n    .ql-picker {\r\n        &.ql-expanded .ql-picker-label {\r\n            color: var(--#{$prefix}choices-link-color);\r\n        }\r\n    }\r\n}\r\n\r\n.ql-snow {\r\n    .ql-picker-options {\r\n        background-color: var(--#{$prefix}choices-bg);\r\n        border-color: $dropdown-border-color !important;\r\n    }\r\n}","// \r\n// _gridjs.scss\r\n// \r\n\r\n.gridjs-container {\r\n    color: $table-color;\r\n    padding: 0;\r\n    display: block;\r\n}\r\n\r\n.gridjs-wrapper {\r\n    box-shadow: none;\r\n    border: 1px solid $table-border-color;\r\n    border-radius: 0px;\r\n\r\n    &::-webkit-scrollbar {\r\n        -webkit-appearance: none;\r\n    }\r\n\r\n    &::-webkit-scrollbar:vertical {\r\n        width: 12px;\r\n    }\r\n\r\n    &::-webkit-scrollbar:horizontal {\r\n        height: 12px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\r\n        border-radius: 10px;\r\n        border: 2px solid var(--#{$prefix}card-bg-custom);\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n        border-radius: 10px;\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n    }\r\n}\r\n\r\n.gridjs-footer {\r\n    border: none !important;\r\n    padding: 12px 0 0;\r\n}\r\n\r\n.gridjs-table {\r\n    width: 100%;\r\n}\r\n\r\n.gridjs-tbody, td.gridjs-td{\r\n    background-color: $table-bg;\r\n}\r\n\r\nth.gridjs-th,\r\ntd.gridjs-td {\r\n    border: 1px solid $table-border-color;\r\n    padding: $table-cell-padding-y $table-cell-padding-x;\r\n}\r\n\r\nth {\r\n    &.gridjs-th {\r\n        border-top: 0;\r\n        color: $table-color;\r\n        background-color: rgba(var(--#{$prefix}light-rgb), .75);\r\n\r\n    }\r\n\r\n    &.gridjs-th-sort {\r\n\r\n        &:focus,\r\n        &:hover {\r\n            background-color: rgba(var(--#{$prefix}light-rgb), .85);\r\n        }\r\n    }\r\n}\r\n\r\n.gridjs-head{\r\n    padding-top: 0;\r\n}\r\n\r\n.gridjs-footer {\r\n    box-shadow: none;\r\n    border: 1px solid $table-border-color;\r\n    border-top: 0;\r\n    background-color: $table-bg;\r\n}\r\n\r\n.gridjs-summary {\r\n    color: $text-muted;\r\n    margin-top: 8px !important;\r\n}\r\n\r\n.gridjs-pagination {\r\n\r\n    .gridjs-pages button {\r\n        margin-left: 0.3rem;\r\n        border-radius: $border-radius !important;\r\n        border: 1px solid $pagination-border-color;\r\n        background-color: $pagination-bg;\r\n        color: $pagination-color;\r\n\r\n        &:last-child{\r\n            border-right: 1px solid $pagination-border-color;\r\n        }\r\n\r\n        &:disabled,\r\n        &:hover:disabled,\r\n        &[disabled] {\r\n            color: $pagination-disabled-color;\r\n            background-color: $pagination-bg;\r\n        }\r\n\r\n        &:hover {\r\n            background-color: $pagination-hover-bg;\r\n            color: $pagination-hover-color;\r\n        }\r\n\r\n        &:focus {\r\n            box-shadow: none;\r\n        }\r\n\r\n        &:last-child,\r\n        &:first-child {\r\n            &:hover {\r\n                background-color: transparent;\r\n            }\r\n        }\r\n\r\n        &.gridjs-currentPage {\r\n            background-color: $pagination-active-bg;\r\n            color: $pagination-active-color;\r\n            border-color: $pagination-active-border-color;\r\n            font-weight: $font-weight-medium;\r\n        }\r\n    }\r\n}\r\n\r\n.gridjs-search {\r\n    position: relative;\r\n    float: left;\r\n\r\n    &::before {\r\n        content: \"\\f0d1\";\r\n        font-family: \"remixicon\";\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        left: 10px;\r\n        font-size: 14px;\r\n        color: $text-muted;\r\n    }\r\n}\r\n\r\ninput.gridjs-input {\r\n    border-color: $input-border-color;\r\n    background-color: $input-bg;\r\n    color: $input-color;\r\n    line-height: $input-line-height;\r\n    padding: $input-padding-y $input-padding-x $input-padding-y $input-padding-x*2.25;\r\n    border-radius: $input-border-radius;\r\n    @include font-size($input-font-size);\r\n\r\n    &:focus {\r\n        box-shadow: none;\r\n        border-color: $input-focus-border-color;\r\n        background-color: $input-focus-bg;\r\n    }\r\n\r\n    &::placeholder{\r\n        color: $input-placeholder-color;\r\n    }\r\n}\r\n\r\nth.gridjs-th {\r\n    .gridjs-th-content {\r\n        float: none;\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        font-weight: $font-weight-semibold;\r\n    }\r\n}\r\n\r\nbutton.gridjs-sort {\r\n    float: none;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    width: 10px;\r\n    height: 20px;\r\n}\r\n\r\nth.gridjs-th-sort .gridjs-th-content {\r\n    width: calc(100% - 10px);\r\n}\r\n\r\nbutton{\r\n    &.gridjs-sort-asc, &.gridjs-sort-desc{\r\n        background-size: 7px;\r\n    }\r\n}\r\n\r\n\r\n// card table\r\n\r\n.table-card{\r\n\r\n    .gridjs-head{\r\n        padding: 16px 16px 5px;\r\n    }\r\n\r\n    .gridjs-wrapper{\r\n        border-top: 0;\r\n        border-radius: 0;\r\n        border-width: 1px 0;\r\n    }\r\n\r\n    .gridjs-footer{\r\n        padding: 8px 16px;\r\n    }\r\n}\r\n\r\n// gridjs selection\r\n.gridjs-tr-selected {\r\n    td{\r\n        background-color: $table-active-bg;\r\n    }\r\n    .gridjs-td .gridjs-checkbox[type=checkbox]{\r\n        background-color: $form-check-input-checked-bg-color;\r\n        border-color: $form-check-input-checked-border-color;\r\n        @if $enable-gradients {\r\n            background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$prefix}gradient);\r\n          } @else {\r\n            background-image: escape-svg($form-check-input-checked-bg-image);\r\n          }\r\n    }\r\n}\r\n.gridjs-td{\r\n    .gridjs-checkbox{\r\n        width: $form-check-input-width;\r\n        height: $form-check-input-width;\r\n        vertical-align: top;\r\n        background-color: $form-check-input-bg;\r\n        background-repeat: no-repeat;\r\n        background-position: center;\r\n        background-size: contain;\r\n        border: $form-check-input-border;\r\n        appearance: none;\r\n        print-print-color-adjust: exact; // Keep themed appearance for print\r\n        @include transition($form-check-transition);\r\n        &[type=\"checkbox\"] {\r\n          @include border-radius($form-check-input-border-radius);\r\n        }\r\n    }\r\n}\r\n\r\n.gridjs-border-none{\r\n    td.gridjs-td, th.gridjs-th{\r\n        border-right-width: 0;\r\n        border-left-width: 0;\r\n    }\r\n}\r\n\r\n.gridjs-loading-bar {\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    button{\r\n        &.gridjs-sort-neutral, &.gridjs-sort-asc, &.gridjs-sort-desc{\r\n            filter: $btn-close-white-filter;\r\n        }\r\n    }\r\n}","// \r\n// _listjs.scss\r\n// \r\n\r\n.listjs-pagination{\r\n    margin-bottom: 0;\r\n    justify-content: flex-end;\r\n    gap: 8px;\r\n    li{\r\n        .page{\r\n            display: block;\r\n            padding: $pagination-padding-y $pagination-padding-x;\r\n            color: $pagination-color;\r\n            background-color: $pagination-bg;\r\n            border: $pagination-border-width solid $pagination-border-color;\r\n            border-radius: $border-radius;\r\n        }\r\n\r\n        &.active{\r\n            .page{\r\n                color: $pagination-active-color;\r\n                @include gradient-bg($pagination-active-bg);\r\n                border-color: $pagination-active-border-color;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.pagination-wrap {\r\n    user-select: none;\r\n    display: flex;\r\n    align-items: center;\r\n    a {\r\n        text-decoration: none;\r\n        display: inline-block;\r\n    }\r\n}\r\n\r\n.pagination-next,\r\n.pagination-prev {\r\n    color: $primary;\r\n    font-weight: $font-weight-medium;\r\n    padding: $pagination-padding-y $pagination-padding-x;\r\n    background-color: $pagination-bg;\r\n    border: $pagination-border-width solid $pagination-border-color;\r\n    border-radius: $border-radius; \r\n    &:hover {\r\n        color: lighten($primary, 20%);\r\n    }\r\n\r\n    &.disabled {\r\n        color: $text-muted;\r\n        cursor: default;\r\n\r\n        &:hover {\r\n            color: $text-muted;\r\n        }\r\n    }\r\n}","//\r\n// apexcharts.scss\r\n//\r\n\r\n.apex-charts {\r\n    min-height: 10px !important;\r\n    text {\r\n        font-family: $font-family-base !important;\r\n    }\r\n    .apexcharts-canvas {\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n.apexcharts-tooltip-title,\r\n.apexcharts-tooltip-text {\r\n    font-family: $font-family-base !important;  \r\n}\r\n\r\n.apexcharts-tooltip{\r\n    border: 1px solid $border-color !important;\r\n    background-color: var(--#{$prefix}card-bg-custom) !important;\r\n    box-shadow: $box-shadow !important;\r\n    * {\r\n        font-family: $font-family-base !important;\r\n        color: $gray-600 !important;\r\n    }\r\n\r\n    .apexcharts-tooltip-title{\r\n        background-color: rgba(var(--#{$prefix}light-rgb), .75) !important;\r\n        border-bottom: 1px solid $border-color !important;\r\n    }\r\n}\r\n\r\n.apexcharts-tooltip.apexcharts-theme-dark{\r\n    * {\r\n        color: $white !important;\r\n    }\r\n}\r\n\r\n.apexcharts-legend-series {\r\n    font-weight: $font-weight-medium;\r\n}\r\n\r\n.apexcharts-gridline {\r\n    pointer-events: none;\r\n    stroke: rgba(var(--#{$prefix}light-rgb), .75);\r\n}\r\n\r\n.apexcharts-legend-text {\r\n    color: $gray-600 !important;\r\n    font-family: $font-family-base !important;\r\n    font-size: 13px !important;\r\n}\r\n\r\n.apexcharts-pie-label {\r\n    fill: $white !important;\r\n}\r\n\r\n.apexcharts-title-text, .apexcharts-subtitle-text{\r\n    fill: $gray-500;\r\n}\r\n\r\n.apexcharts-yaxis,\r\n.apexcharts-xaxis {\r\n    text {\r\n        font-family: $font-family-base !important;\r\n        fill: $gray-500;\r\n    }\r\n}\r\n\r\n.apexcharts-yaxis-title {\r\n    font-weight: 500;\r\n}\r\n\r\n// column dynamic loaded chart\r\n\r\n#dynamicloadedchart-wrap {\r\n    margin: 0px auto;\r\n    max-width: 800px;\r\n    position: relative;\r\n}\r\n\r\n.chart-box {\r\n    padding-left: 0;\r\n}\r\n\r\n#chart-year,\r\n#chart-quarter {\r\n    width: 96%;\r\n    max-width: 48%;\r\n    box-shadow: none;\r\n    padding-left: 0;\r\n    padding-top: 20px;\r\n    background: var(--#{$prefix}card-bg-custom);\r\n    border: 1px solid $border-color;\r\n}\r\n\r\n#chart-year {\r\n    float: left;\r\n    position: relative;\r\n    transition: 1s ease transform;\r\n    z-index: 3;\r\n    &.chart-quarter-activated {\r\n        transform: translateX(0);\r\n        transition: 1s ease transform;\r\n    }\r\n}\r\n\r\n#chart-quarter {\r\n    float: left;\r\n    position: relative;\r\n    z-index: -2;\r\n    transition: 1s ease transform;\r\n    &.active {\r\n        transition: 1.1s ease-in-out transform;\r\n        transform: translateX(0);\r\n        z-index: 1;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 480px) {\r\n    #chart-year {\r\n        transform: translateX(50%);\r\n    }\r\n    #chart-quarter {\r\n        transform: translateX(-50%);\r\n    }\r\n}\r\n\r\n// radar chart\r\n\r\n.apexcharts-radar-series{\r\n    polygon, line{\r\n        stroke: $border-color;\r\n    }\r\n}\r\n\r\n.apexcharts-pie{\r\n    circle ,line{\r\n        stroke: $border-color;\r\n    }\r\n    text{\r\n        fill: var(--#{$prefix}body-color);\r\n    }\r\n}\r\n\r\n.apex-charts {\r\n\r\n    .apexcharts-xaxis,\r\n    .apexcharts-yaxis {\r\n        line {\r\n            stroke: var(--#{$prefix}border-color);\r\n        }\r\n    }\r\n\r\n    .apexcharts-xaxis-tick {\r\n        stroke: var(--#{$prefix}border-color);\r\n    }\r\n\r\n    .apexcharts-pie-series,\r\n    .apexcharts-bar-series {\r\n        path {\r\n            stroke: var(--#{$prefix}card-bg-custom);\r\n        }\r\n    }\r\n\r\n    .apexcharts-radialbar-track {\r\n        path {\r\n            stroke: var(--#{$prefix}light);\r\n        }\r\n    }\r\n\r\n    .apexcharts-marker {\r\n        stroke: var(--#{$prefix}card-bg-custom);\r\n    }\r\n\r\n    .apexcharts-boxPlot-series {\r\n        path {\r\n            stroke: var(--#{$prefix}border-color);\r\n        }\r\n    }\r\n\r\n    .apexcharts-treemap,\r\n    .apexcharts-heatmap-series {\r\n        rect {\r\n            stroke: var(--#{$prefix}card-bg-custom);\r\n        }\r\n    }\r\n}","\r\n//\r\n// _chartjs.scss\r\n//\r\n\r\n.chartjs-chart{\r\n  max-height: 320px;\r\n}\r\n  ","//\r\n// echarts.scss\r\n//\r\n\r\n.e-charts{\r\n    height: 350px;\r\n}\r\n\r\n.e-charts-height{\r\n    height: 300px;\r\n}","\r\n//\r\n// _google-map.scss\r\n//\r\n\r\n.gmaps, .gmaps-panaroma {\r\n  height: 300px;\r\n  background: $gray-100;\r\n  border-radius: 3px;\r\n}\r\n\r\n.gmaps-overlay {\r\n  display: block;\r\n  text-align: center;\r\n  color: $white;\r\n  font-size: 16px;\r\n  line-height: 40px;\r\n  background: $primary;\r\n  border-radius: 4px;\r\n  padding: 10px 20px;\r\n}\r\n\r\n.gmaps-overlay_arrow {\r\n  left: 50%;\r\n  margin-left: -16px;\r\n  width: 0;\r\n  height: 0;\r\n  position: absolute;\r\n  &.above {\r\n    bottom: -15px;\r\n    border-left: 16px solid transparent;\r\n    border-right: 16px solid transparent;\r\n    border-top: 16px solid $primary;\r\n  }\r\n  &.below {\r\n    top: -15px;\r\n    border-left: 16px solid transparent;\r\n    border-right: 16px solid transparent;\r\n    border-bottom: 16px solid $primary;\r\n  }\r\n  \r\n}","//\r\n// _autocomplete.scss\r\n//\r\n\r\n.autoComplete_wrapper {\r\n    display: block;\r\n\r\n    >input {\r\n        display: block;\r\n        width: 100%;\r\n        height: auto;\r\n        padding: $input-padding-y $input-padding-x;\r\n        font-family: $input-font-family;\r\n        font-size: $input-font-size;\r\n        font-weight: $input-font-weight;\r\n        line-height: $input-line-height;\r\n        color: $input-color;\r\n        background-color: $input-bg;\r\n        background-clip: padding-box;\r\n        border: $input-border-width solid $input-border-color;\r\n        border-radius: $input-border-radius;\r\n        background-image: none;\r\n\r\n        &::placeholder {\r\n            padding: 0 !important;\r\n            color: $input-placeholder-color !important;\r\n            font-size: $input-font-size !important;\r\n        }\r\n\r\n        &:focus {\r\n            border: $input-border-width solid $input-focus-border-color;\r\n            color: $input-focus-color;\r\n        }\r\n\r\n        &:hover {\r\n            color: $input-color;\r\n        }\r\n    }\r\n\r\n    >ul {\r\n        border-radius: $border-radius;\r\n        border-color: $dropdown-border-color;\r\n        background-color: $dropdown-bg;\r\n        box-shadow: $dropdown-box-shadow;\r\n        padding: 0;\r\n        overflow: auto;\r\n        max-height: 160px;\r\n        margin: 0;\r\n        animation-name: DropDownSlide;\r\n        animation-duration: .3s;\r\n        animation-fill-mode: both;\r\n\r\n        > li {\r\n            font-size: $dropdown-font-size;\r\n            margin: 0;\r\n            padding: $dropdown-item-padding-y $dropdown-item-padding-x;\r\n            border-radius: 0;\r\n            background-color: $dropdown-bg;\r\n            color: $dropdown-color;\r\n\r\n            mark {\r\n                color: $danger;\r\n                font-weight: $font-weight-semibold;\r\n                padding: 1px;\r\n            }\r\n\r\n            &[aria-selected=true],\r\n            &:hover {\r\n                color: $dropdown-link-hover-color;\r\n                @include gradient-bg($dropdown-link-hover-bg);\r\n            }\r\n        }\r\n\r\n        .no_result {\r\n            padding: $dropdown-item-padding-y *2 $dropdown-item-padding-x;\r\n            font-style: italic;\r\n            font-weight: $font-weight-medium;\r\n        }\r\n    }\r\n}","//\r\n// vector-maps.scss\r\n//\r\n\r\n.jvm-tooltip {\r\n    border-radius: 3px;\r\n    background-color: $primary;\r\n    font-family: $font-family-base;\r\n    box-shadow: $box-shadow-lg;\r\n    padding: 5px 9px;\r\n}\r\n\r\n.jvm-container {\r\n    text {\r\n        font-family: $font-family-base;\r\n        font-size: $font-size-base;\r\n        fill: var(--#{$prefix}gray-700);\r\n    }\r\n}\r\n\r\n.jvm-zoom-btn {\r\n    background-color: $primary;\r\n}","//\r\n// _leaflet-maps.scss\r\n//\r\n\r\n.leaflet-map {\r\n    height: 300px;\r\n    &.leaflet-container{\r\n        z-index: 0;\r\n        font-family: $font-family-primary;\r\n    }\r\n}","// \r\n// _fullcalendar.scss\r\n// \r\n\r\n\r\n.fc td,\r\n.fc th {\r\n    border: $table-border-width solid $table-border-color;\r\n}\r\n\r\n.fc {\r\n    .fc-toolbar {\r\n        h2 {\r\n            font-size: 16px;\r\n            line-height: 30px;\r\n            text-transform: uppercase;\r\n        }\r\n\r\n        @media (max-width: 767.98px) {\r\n\r\n            .fc-left,\r\n            .fc-right,\r\n            .fc-center {\r\n                float: none;\r\n                display: block;\r\n                text-align: center;\r\n                clear: both;\r\n                margin: 10px 0;\r\n            }\r\n\r\n            >*>* {\r\n                float: none;\r\n            }\r\n\r\n            .fc-today-button {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .btn {\r\n            text-transform: capitalize;\r\n        }\r\n    }\r\n\r\n    .fc-col-header-cell {\r\n        background-color: var(--#{$prefix}light);\r\n    }\r\n\r\n    .fc-col-header-cell-cushion {\r\n        display: block;\r\n        padding: 8px 4px;\r\n    }\r\n\r\n    .fc-daygrid-day-number {\r\n        width: 24px;\r\n        height: 24px;\r\n        border-radius: 50%;\r\n        padding: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        font-size: 12px;\r\n        font-weight: $font-weight-medium;\r\n        margin: 2px;\r\n    }\r\n\r\n    .fc-daygrid-day {\r\n        &.fc-day-today {\r\n            background-color: rgba($primary, 0.1);\r\n    \r\n            .fc-daygrid-day-number {\r\n                background-color: $primary;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n\r\n    .fc-daygrid-day {\r\n        &.fc-day-today {\r\n            background-color: rgba($primary, 0.1);\r\n        }\r\n    }\r\n    \r\n    .fc-timegrid-col {\r\n        &.fc-day-today {\r\n            background-color: rgba($primary, 0.1);\r\n        }\r\n    }\r\n\r\n    .fc-list-event:hover td {\r\n        background: transparent;\r\n    }\r\n\r\n    .fc-list-event-title {\r\n        a {\r\n            color: $white !important;\r\n        }\r\n    }\r\n\r\n    .fc-col-header,\r\n    .fc-daygrid-body,\r\n    .fc-scrollgrid-sync-table {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .fc-scrollgrid-section>*{\r\n        border-left: $table-border-width solid $table-border-color;\r\n        border-top: $table-border-width solid $table-border-color;\r\n    }\r\n\r\n    .fc-scrollgrid-section-liquid>td{\r\n        border-top: 0;\r\n    }\r\n}\r\n\r\n.fc-theme-bootstrap a:not([href]) {\r\n    color: var(--#{$prefix}body-color);\r\n}\r\n\r\n.fc-event {\r\n    color: $white;\r\n}\r\n\r\n.fc {\r\n    th.fc-widget-header {\r\n        background: $gray-300;\r\n        line-height: 20px;\r\n        padding: 10px 0;\r\n        text-transform: uppercase;\r\n        font-weight: $font-weight-bold;\r\n    }\r\n}\r\n\r\n.fc-unthemed {\r\n\r\n    .fc-content,\r\n    .fc-divider,\r\n    .fc-list-heading td,\r\n    .fc-list-view,\r\n    .fc-popover,\r\n    .fc-row,\r\n    tbody,\r\n    td,\r\n    th,\r\n    thead {\r\n        border-color: $gray-300;\r\n    }\r\n\r\n    td.fc-today {\r\n        background: lighten($gray-200, 2%);\r\n    }\r\n}\r\n\r\n.fc-button {\r\n    background: var(--#{$prefix}card-bg-custom);\r\n    border-color: $border-color;\r\n    color: $gray-700;\r\n    text-transform: capitalize;\r\n    box-shadow: none;\r\n    padding: 6px 12px !important;\r\n    height: auto !important;\r\n}\r\n\r\n.fc-state-down,\r\n.fc-state-active,\r\n.fc-state-disabled {\r\n    background-color: $primary;\r\n    color: $white;\r\n    text-shadow: none;\r\n}\r\n\r\n.fc-event {\r\n    border-radius: 2px;\r\n    border: none;\r\n    cursor: move;\r\n    font-size: 0.8125rem;\r\n    margin: 5px 7px;\r\n    padding: 5px 5px;\r\n    text-align: center;\r\n}\r\n\r\n.fc-event,\r\n.fc-event-dot {\r\n    background-color: $primary;\r\n}\r\n\r\n.fc-daygrid-dot-event.fc-event-mirror,\r\n.fc-daygrid-dot-event:hover {\r\n    background-color: $primary;\r\n}\r\n\r\n// .fc-daygrid-dot-event {\r\n//     color: $white !important;\r\n// }\r\n\r\n.fc-event-title,\r\n.fc-sticky {\r\n    font-weight: $font-weight-semibold !important;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.fc-daygrid-event-dot {\r\n    border-color: $white !important;\r\n    display: none;\r\n}\r\n\r\n.fc-event-time {\r\n    display: none;\r\n}\r\n\r\n.fc-event .fc-content {\r\n    color: $white;\r\n}\r\n\r\n#external-events {\r\n    .external-event {\r\n        text-align: left;\r\n        padding: 8px 16px;\r\n        margin: 6px 0;\r\n    }\r\n}\r\n\r\n\r\n.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {\r\n    .fc-content {\r\n        color: $light;\r\n    }\r\n}\r\n\r\n.fc-prev-button,\r\n.fc-next-button {\r\n    position: relative;\r\n    height: 37.5px;\r\n    width: 37.5px;\r\n\r\n    &::before {\r\n        position: absolute;\r\n        font-family: remixicon !important;\r\n        font-size: 20px;\r\n        top: 0;\r\n        bottom: 0px;\r\n        left: 0;\r\n        right: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n.fc-prev-button {\r\n    &::before {\r\n        content: \"\\ea64\";\r\n    }\r\n}\r\n\r\n.fc-next-button {\r\n    &::before {\r\n        content: \"\\ea6e\";\r\n    }\r\n}\r\n\r\n.fc-toolbar-chunk {\r\n    .btn-group {\r\n        box-shadow: $element-shadow;\r\n        .btn {\r\n            color: $secondary;\r\n            background-color: rgba($secondary, 0.15);\r\n            border: none;\r\n            box-shadow: none;\r\n\r\n            &:hover,\r\n            &.active {\r\n                color: $white;\r\n                background-color: $secondary;\r\n            }\r\n        }\r\n    }\r\n\r\n    .fc-today-button {\r\n        background-color: $secondary !important;\r\n        border: $secondary;\r\n    }\r\n}\r\n\r\n.fc-toolbar {\r\n    @media (max-width: 575.98px) {\r\n        flex-direction: column;\r\n        gap: 16px;\r\n    }\r\n}\r\n\r\n#upcoming-event-list {\r\n    .card {\r\n        &:last-child {\r\n            margin-bottom: 6px !important;\r\n        }\r\n    }\r\n}\r\n\r\n#event-modal {\r\n    .event-details {\r\n        display: none;\r\n    }\r\n\r\n    .view-event {\r\n        .event-form {\r\n            display: none;\r\n        }\r\n\r\n        #event-category-tag {\r\n            display: none;\r\n        }\r\n\r\n        .event-details {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n.fc-daygrid-event-harness {\r\n    .fc-daygrid-event {\r\n        backdrop-filter: blur(4px);\r\n    }\r\n}\r\n\r\n.fc-timegrid-event-harness {\r\n    .fc-timegrid-event {\r\n        backdrop-filter: blur(4px);\r\n    }\r\n}\r\n\r\n\r\n.fc-timegrid-slots {\r\n    table {\r\n        tr {\r\n            border-color: $border-color !important;\r\n        }\r\n    }\r\n}\r\n\r\n.fc-list-table {\r\n    border-color: $border-color;\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .fc-daygrid-event-harness {\r\n        .fc-daygrid-event {\r\n            &.bg-soft-#{$color} {\r\n\r\n                .fc-event-title,\r\n                .fc-event-main {\r\n                    color: $value !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .fc-timegrid-event-harness {\r\n        .fc-timegrid-event {\r\n            &.bg-soft-#{$color} {\r\n                .fc-event-title {\r\n                    color: $value !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .fc-list-table {\r\n        .fc-list-event {\r\n            &.bg-soft-#{$color} {\r\n                color: $value !important;\r\n\r\n                .fc-list-event-title {>a {\r\n                        color: $value !important;\r\n                    }\r\n                }\r\n\r\n                .fc-list-event-dot {\r\n                    border-color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark{\r\n    .fc-event-main, .fc-event-title {\r\n        color:  var(--#{$prefix}dark) !important;\r\n    }\r\n}\r\n\r\n.fc-direction-ltr{\r\n    direction: ltr;\r\n    .fc-toolbar>*>:not(:first-child){\r\n        margin-left: 0.75em;\r\n    }\r\n}","//\r\n// emoji-picker.scss\r\n//\r\n\r\n.fg-emoji-picker{\r\n    width: 250px !important;\r\n    box-shadow: $box-shadow !important;\r\n    top: auto !important;\r\n    bottom: 130px;\r\n\r\n    *{\r\n        font-family: $font-family-base !important;\r\n        color: var(--#{$prefix}body-color) !important;\r\n    }\r\n    @media (max-width:991.98px) {\r\n        left: 14px !important;\r\n        top: auto !important;\r\n        bottom: 118px;\r\n    }\r\n\r\n    .fg-emoji-picker-container-title{\r\n        color: $dark !important;\r\n    }\r\n\r\n    .fg-emoji-picker-search{\r\n        height: 40px !important;\r\n        input{\r\n            background-color: $input-bg !important;\r\n            color: $input-color !important;\r\n            padding: $input-btn-padding-y $input-btn-padding-x !important;\r\n            font-size: $font-size-base !important;\r\n            &::placeholder{\r\n                color: $input-placeholder-color !important;\r\n            }\r\n        }\r\n\r\n        svg{\r\n            fill: var(--#{$prefix}body-color) !important;\r\n            right: 11px;\r\n            top: 12px;\r\n        }\r\n    }\r\n\r\n    .fg-emoji-picker-categories{\r\n        background-color: $light !important;\r\n        li.active{\r\n            background-color: rgba(var(--bs-primary-rgb), 0.2);\r\n        }\r\n        a{\r\n            &:hover{\r\n                background-color: rgba(var(--bs-primary-rgb), 0.2);\r\n            }\r\n        }\r\n        \r\n    }\r\n}\r\n\r\n.fg-emoji-picker-grid > li:hover{\r\n    background-color: rgba(var(--bs-primary-rgb), 0.2) !important;\r\n}\r\n\r\na.fg-emoji-picker-close-button{\r\n    background-color: darken($light, 4%) !important;\r\n}","//\r\n// _datatables.scss\r\n//\r\n\r\ntable.dataTable td.dataTables_empty,\r\ntable.dataTable th.dataTables_empty {\r\n    text-align: center;\r\n    padding: 50px;\r\n    font-weight: $font-weight-semibold;\r\n    --vz-table-accent-bg: var(--#{$prefix}card-bg-custom);\r\n}\r\n\r\ntable.dataTable>thead .sorting:before,\r\ntable.dataTable>thead .sorting_asc:before,\r\ntable.dataTable>thead .sorting_desc:before,\r\ntable.dataTable>thead .sorting_asc_disabled:before,\r\ntable.dataTable>thead .sorting_desc_disabled:before {\r\n    content:\"\\f0360\";\r\n    position: absolute;\r\n    right: 0.5rem;\r\n    top: 12px;\r\n    font-size: .8rem;\r\n    font-family: \"Material Design Icons\";\r\n}\r\n\r\ntable.dataTable>thead .sorting:after,\r\ntable.dataTable>thead .sorting_asc:after,\r\ntable.dataTable>thead .sorting_desc:after,\r\ntable.dataTable>thead .sorting_asc_disabled:after,\r\ntable.dataTable>thead .sorting_desc_disabled:after {\r\n    content: \"\\f035d\";\r\n    position: absolute;\r\n    right: 0.5rem;\r\n    top: 18px;\r\n    font-size: .8rem;\r\n    font-family: \"Material Design Icons\";\r\n}\r\n\r\ntable.dataTable>tbody>tr.child span.dtr-title {\r\n    font-weight: $font-weight-semibold;\r\n    min-width: 150px;\r\n}\r\n\r\n\r\n//responsive \r\ntable {\r\n    &.dataTable {\r\n        &.dtr-inline {\r\n            &.collapsed {\r\n                >tbody {>tr {\r\n> th,> td {\r\n                            &.dtr-control {\r\n                                &::before {\r\n                                    background-color: $primary;\r\n                                    border-color: var(--#{$prefix}card-bg-custom);\r\n                                }\r\n                            }\r\n                        }\r\n\r\n                        &.parent {\r\n                            &.parent {\r\n                                >th {\r\n                                    &.dtr-control {\r\n                                        &::before {\r\n                                            background-color: $danger;\r\n                                        }\r\n                                    }\r\n                                }\r\n                            }\r\n>td {\r\n                                &.dtr-control {\r\n                                    &::before {\r\n                                        background-color: $danger;\r\n                                    }\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        >tbody {\r\n            >tr {\r\n                &.child {\r\n                    span {\r\n                        &.dtr-title {\r\n                            min-width: 135px;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.table-card {\r\n\r\n    .dataTables_length,\r\n    .dataTables_filter {\r\n        padding: $card-cap-padding-y $card-cap-padding-x;\r\n        padding-bottom: 0px;\r\n    }\r\n\r\n    .dataTables_info,\r\n    .dataTables_paginate {\r\n        padding: $card-cap-padding-y $card-cap-padding-x;\r\n    }\r\n\r\n    div.dataTables_wrapper {\r\n        .col-md-6 {\r\n            width: 100%;\r\n        }\r\n\r\n        div {\r\n            &.dataTables_filter {\r\n                input {\r\n                    width: calc(100% - 52px);\r\n                }\r\n\r\n                label {\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\ndiv{\r\n    &.dtr-modal {\r\n        div {\r\n            &.dtr-modal-display {\r\n                background-color: $modal-content-bg;\r\n                border-color: $border-color;\r\n                box-shadow: none;\r\n                height: 70%;\r\n            }\r\n            &.dtr-modal-content {\r\n                padding: $modal-inner-padding;\r\n                h2 {\r\n                    font-size: $font-size-lg;\r\n                    font-weight: $font-weight-semibold;\r\n                    margin-bottom: 15px;\r\n                }\r\n                .dtr-details{\r\n                    tr {\r\n                        td {\r\n                            padding: $table-cell-padding-y $table-cell-padding-x;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n            &.dtr-modal-close {\r\n                font-size: 24px;\r\n                top: 9px;\r\n                right: 11px;\r\n                width: 30px;\r\n                height: 30px;\r\n                line-height: 30px;\r\n                background-color: var(--#{$prefix}card-bg-custom);\r\n                border-color: $border-color;\r\n                &:hover {\r\n                    background-color: var(--#{$prefix}light);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n\r\n.dt-buttons {\r\n    button.dt-button,\r\n    div.dt-button,\r\n    a.dt-button,\r\n    input.dt-button {\r\n        border-color: $border-color;\r\n        background: var(--#{$prefix}light);\r\n        color: var(--#{$prefix}gray-800);\r\n    }\r\n}","//\r\n// Select 2\r\n//\r\n\r\n.select2.select2-container{\r\n    width: 100% !important;\r\n}\r\n.select2-container {\r\n    .select2-selection--single {\r\n        border: $input-border-width solid $input-border-color;\r\n        height: $input-height;\r\n        background-color: $input-bg;\r\n        outline: none;\r\n        .select2-selection__rendered {\r\n            line-height: 36px;\r\n            padding-left: 12px;\r\n            color: $input-color;\r\n        }\r\n        .select2-selection__arrow {\r\n            height: 34px;\r\n            width: 34px;\r\n            /*rtl:ignore*/\r\n            right: 3px;\r\n            b {\r\n                border-color: $input-border-color transparent transparent transparent;\r\n                border-width: 6px 6px 0 6px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.select2-container--open {\r\n    .select2-selection--single {\r\n        .select2-selection__arrow {\r\n            b {\r\n                border-color: transparent transparent $input-border-color transparent !important;\r\n                border-width: 0 6px 6px 6px !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.select2-results__option {\r\n    padding: 6px 12px;\r\n}\r\n\r\n.select2-dropdown {\r\n    border: $dropdown-border-width solid $dropdown-border-color;\r\n    box-shadow: $box-shadow;\r\n    background-color: var(--#{$prefix}choices-bg);\r\n    z-index: $zindex-modal + 1;\r\n}\r\n\r\n.select2-container--default {\r\n    .select2-results__option--selected {\r\n        background-color: $input-disabled-bg;\r\n    }\r\n    .select2-search--dropdown {\r\n        padding: 10px;\r\n        background-color: var(--#{$prefix}choices-bg);\r\n        .select2-search__field {\r\n            outline: none;\r\n            border: 1px solid $input-border-color;\r\n            background-color: $input-bg;\r\n            color: $input-color;\r\n            border-radius: $input-border-radius;\r\n        }\r\n    }\r\n    .select2-results__option--highlighted[aria-selected] {\r\n        background-color: $primary;\r\n    }\r\n    .select2-results__option[aria-selected=true] {\r\n        background-color: var(--#{$prefix}choices-bg);\r\n        color: var(--#{$prefix}choices-link-active-color);\r\n        &:hover {\r\n            background-color: $primary;\r\n            color: $white;\r\n        }\r\n    }\r\n    .select2-selection--multiple {\r\n        .select2-selection__choice__display {\r\n            padding-left: 36px;\r\n            padding-right: 5px;\r\n        }\r\n    }\r\n    .select2-selection--single {\r\n        .select2-selection__arrow {\r\n            /*rtl:ignore*/\r\n            right: 1px;\r\n            /*rtl:ignore*/\r\n            left: auto;\r\n        }\r\n    }\r\n    \r\n}\r\n\r\n.select2-container {\r\n    .select2-selection--multiple {\r\n        min-height: $input-height;\r\n        border: $input-border-width solid $input-border-color !important;\r\n        background-color: $input-bg;\r\n\r\n        .select2-selection__rendered {\r\n            padding: 1px 4px;\r\n        }\r\n        .select2-search__field {\r\n            border: 0;\r\n            color: $input-color;\r\n        }\r\n        .select2-selection__choice {\r\n            background-color: $primary;\r\n            border: none;\r\n            color: $white;\r\n            border-radius: 3px;\r\n            padding: 3px;\r\n            margin-top: 6px;\r\n        }\r\n        .select2-selection__choice__remove {\r\n            color: $white;\r\n            margin-right: 7px;\r\n            border-color: tint-color($primary, 10%);\r\n            padding: 0 8px;\r\n            top: 3px;\r\n            &:hover {\r\n                color: $white;\r\n                background-color: $primary;\r\n            }\r\n        }\r\n    }\r\n    .select2-search--inline {\r\n        .select2-search__field {\r\n            margin-top: 7px;\r\n            font-family: $font-family-base;\r\n        }\r\n    }\r\n    .select2-search {\r\n        textarea {\r\n            &::placeholder {\r\n                color: $input-placeholder-color;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.select2-container--default{\r\n    &.select2-container--disabled {\r\n        .select2-selection--single, .select2-selection--multiple {\r\n            background-color: $input-disabled-bg;\r\n            cursor: default;\r\n        }\r\n    }\r\n}\r\n","// flag input\r\n\r\n[data-input-flag] {\r\n    position: relative;\r\n\r\n    .dropdown-menu {\r\n        .dropdown-menu-list {\r\n            max-height: 158px;\r\n            overflow-y: auto;\r\n\r\n            &::-webkit-scrollbar {\r\n                -webkit-appearance: none;\r\n            }\r\n\r\n            &::-webkit-scrollbar:vertical {\r\n                width: 8px;\r\n            }\r\n\r\n            &::-webkit-scrollbar:horizontal {\r\n                height: 10px;\r\n            }\r\n\r\n            &::-webkit-scrollbar-thumb {\r\n                background-color: rgba(var(--#{$prefix}dark-rgb), .075);\r\n                border-radius: 8px;\r\n            }\r\n\r\n            &::-webkit-scrollbar-track {\r\n                border-radius: 8px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n[data-option-flag-img-name] {\r\n    .flag-input {\r\n        padding-left: 45px;\r\n        background-image: url(\"../../images/flags/us.svg\");\r\n        background-repeat: no-repeat;\r\n        background-position: 14px 8px;\r\n        background-size: 18px;\r\n    }\r\n}\r\n\r\n[data-option-flag-name],\r\n[data-option-flag-img-name] {\r\n    &::before {\r\n        content: \"\\f0140\";\r\n        font-family: \"Material Design Icons\";\r\n        position: absolute;\r\n        right: $input-padding-x;\r\n        top: $input-padding-y;\r\n        font-size: 16px;\r\n    }\r\n}\r\n\r\n[data-option-countrycode=\"false\"] {\r\n    .country-codeno {\r\n        display: none;\r\n    }\r\n}\r\n\r\n[data-search-input=\"false\"] {\r\n    .searchlist-input {\r\n        display: none;\r\n    }\r\n}","// \r\n// toastify.scss\r\n// \r\n\r\n\r\n.toastify {\r\n    padding: 12px 16px;\r\n    color: $white;\r\n    display: inline-block;\r\n    box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);\r\n    background: $success;\r\n    position: fixed;\r\n    opacity: 0;\r\n    transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    border-radius: 2px;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    max-width: calc(50% - 20px);\r\n    z-index: 2147483647;\r\n    &.on {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n\r\n.toast-close {\r\n    opacity: 0.4;\r\n    padding: 0 5px;\r\n    position: relative;\r\n    left: 4px;\r\n    margin-left: 4px;\r\n    border: none;\r\n    background: none;\r\n}\r\n\r\n.toastify-right {\r\n    right: 15px;\r\n}\r\n\r\n.toastify-left {\r\n    left: 15px;\r\n    .toast-close {\r\n        left: -4px;\r\n        margin-left: 0;\r\n        margin-right: 4px;\r\n    }\r\n}\r\n\r\n.toastify-top {\r\n    top: -150px;\r\n}\r\n\r\n.toastify-bottom {\r\n    bottom: -150px;\r\n}\r\n\r\n.toastify-rounded {\r\n    border-radius: 25px;\r\n}\r\n\r\n.toastify-avatar {\r\n    width: 1.5em;\r\n    height: 1.5em;\r\n    margin: -7px 5px;\r\n    border-radius: 2px;\r\n}\r\n\r\n.toastify-center {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    left: 0;\r\n    right: 0;\r\n    max-width: fit-content;\r\n    max-width: -moz-fit-content;\r\n}\r\n\r\n@media only screen and (max-width: 360px) {\r\n    .toastify-right, .toastify-left {\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n        left: 0;\r\n        right: 0;\r\n        max-width: fit-content;\r\n    }\r\n}","//\r\n// _choices.scss\r\n//\r\n\r\n.choices {\r\n    position: relative;\r\n    margin-bottom: 24px;\r\n    font-size: 16px;\r\n\r\n    &:focus {\r\n        outline: none;\r\n    }\r\n\r\n    &:last-child {\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    &.is-disabled{\r\n        .choices__inner,\r\n        .choices__input {\r\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\r\n            cursor: not-allowed;\r\n            user-select: none;\r\n        }\r\n\r\n        .choices__item {\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n    [hidden] {\r\n        display: none !important;\r\n    }\r\n    \r\n    // data-type = select-one\r\n    &[data-type*='select-one'] {\r\n        cursor: pointer;\r\n        .choices__inner{\r\n            padding-bottom: 0.25rem;\r\n        }\r\n\r\n        .choices__input{\r\n            display: block;\r\n            width: 100%;\r\n            padding: $input-padding-y $input-padding-x;\r\n            background-color: $input-bg;\r\n            border: 1px solid $input-border-color;\r\n            font-size: $input-font-size;\r\n            border-radius: $input-border-radius;\r\n            color: $input-color;\r\n            margin-bottom: 10px;\r\n        }\r\n\r\n        .choices__button{\r\n            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\r\n            padding: 0;\r\n            background-size: 8px;\r\n            position: absolute;\r\n            top: 50%;\r\n            right: 0;\r\n            left: auto;\r\n            margin-top: -10px;\r\n            margin-right: 25px;\r\n            margin-left: 0;\r\n            height: 20px;\r\n            width: 20px;\r\n            border-radius: 10em;\r\n            opacity: 0.5;\r\n\r\n            &:hover, &:focus {\r\n                opacity: 1;\r\n            }\r\n\r\n            &:focus {\r\n                box-shadow: 0px 0px 0px 2px #00bcd4;\r\n            }\r\n        }\r\n\r\n        .choices__item[data-value=''] .choices__button {\r\n            display: none;\r\n        }\r\n\r\n        &:after {\r\n            content: \"\\F0140\";\r\n            position: absolute;\r\n            border: 0;\r\n            border-color: $dark transparent transparent;\r\n            right: 11.5px;\r\n            left: auto;\r\n            font-family: 'Material Design Icons';\r\n            width: auto;\r\n            height: auto;\r\n            margin-top: 0;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            pointer-events: none;\r\n        }\r\n\r\n        &.is-open:after {\r\n            margin-top: 0;\r\n            transform: translateY(-50%) rotate(-180deg);\r\n        }\r\n\r\n    }\r\n\r\n\r\n    // data-type = select- multiple & text\r\n\r\n    &[data-type*='select-multiple'],\r\n    &[data-type*='text'] {\r\n        .choices__inner {\r\n            cursor: text;\r\n            padding-right: $form-select-padding-x;\r\n        }\r\n\r\n        .choices__button {\r\n            position: relative;\r\n            display: inline-block;\r\n            margin-top: 0;\r\n            margin-right: -4px;\r\n            margin-bottom: 0;\r\n            margin-left: 8px;\r\n            padding-left: 16px;\r\n            border-left: 1px solid rgba($white, 0.5);\r\n            border-right: 0;\r\n            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\r\n            background-size: 8px;\r\n            width: 8px;\r\n            line-height: 1;\r\n            opacity: 0.75;\r\n            border-radius: 0;\r\n            &:hover, &:focus {\r\n                opacity: 1;\r\n            }\r\n        }\r\n        .choices__list--dropdown{\r\n            padding-bottom: 10px;\r\n            .choices__list{\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-type*=select-multiple] {\r\n        .choices__input {\r\n            padding-top: 3px;\r\n        }\r\n    }\r\n}\r\n\r\n//Select Light\r\n.input-light {\r\n    .choices__inner { \r\n        background-color: var(--#{$prefix}light);\r\n        border: none;\r\n    }\r\n}\r\n  \r\n.choices__inner {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    width: 100%;\r\n    background-color: $form-select-bg;\r\n    padding: 0.25rem ($form-select-padding-x + $form-select-indicator-padding) 0.1rem 0.5rem;\r\n    border: $form-select-border-width solid $form-select-border-color;\r\n    border-radius: $form-select-border-radius !important;\r\n    font-size: $input-font-size;\r\n    min-height: 37.5px;\r\n    overflow: hidden;\r\n}\r\n\r\n  \r\n.is-focused,\r\n.is-open {\r\n    .choices__inner {\r\n        border-color: $input-focus-border-color;\r\n    }\r\n}\r\n  \r\n.choices__list {\r\n    margin: 0;\r\n    padding-left: 0;\r\n    list-style: none;\r\n}\r\n  \r\n.choices__list--single {\r\n    display: inline-block;\r\n    padding: 4px 16px 4px 4px;\r\n    width: 100%;\r\n\r\n    .choices__item {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.choices__list--multiple {\r\n    display: inline;\r\n    .choices__item {\r\n        display: inline-block;\r\n        vertical-align: initial;\r\n        border-radius: 7px;\r\n        padding: 2px 7px;\r\n        font-size: 11px;\r\n        font-weight: $font-weight-normal;\r\n        margin-right: 3.75px;\r\n        margin-bottom: 3.75px;\r\n        margin-top: 2px;\r\n        background-color: $primary;\r\n        border: 1px solid $primary;\r\n        word-break: break-all;\r\n        box-sizing: border-box;\r\n        color: $white;\r\n        box-shadow: $element-shadow;\r\n        &[data-deletable] {\r\n            padding-right: 5px;\r\n        }\r\n\r\n        &.is-highlighted {\r\n            background-color: $primary;\r\n            border: 1px solid $primary;\r\n        }\r\n    }\r\n}\r\n\r\n  \r\n.is-disabled {\r\n    .choices__list--multiple {\r\n        .choices__item {\r\n            background-color: $secondary;\r\n            border: 1px solid $secondary\r\n        }\r\n    }\r\n}\r\n  \r\n.choices__list--dropdown {\r\n    visibility: hidden;\r\n    z-index: 1;\r\n    position: absolute;\r\n    width: 100%;\r\n    background-color: var(--#{$prefix}choices-bg);\r\n    border: 1px solid var(--#{$prefix}border-color);\r\n    box-shadow: $dropdown-box-shadow;\r\n    top: 100%;\r\n    margin-top: 0;\r\n    padding: 10px 10px 20px 10px;\r\n    border-bottom-left-radius: 2.5px;\r\n    border-bottom-right-radius: 2.5px;\r\n    overflow: hidden;\r\n    word-break: break-all;\r\n    will-change: visibility;\r\n    animation-duration: .3s;\r\n    animation-fill-mode: both;\r\n    transform: translateY(1px);\r\n    &.is-active {\r\n        visibility: visible;\r\n        animation-name: DropDownSlide;\r\n    }\r\n\r\n    .choices__item--selectable.is-highlighted {\r\n        background-color: var(--#{$prefix}choices-link-hover-bg);\r\n    }\r\n\r\n    .choices__list {\r\n        margin: 0 -16px -16px;\r\n    }\r\n\r\n    .has-no-results {\r\n        font-style: italic;\r\n        font-weight: $font-weight-medium;\r\n    }\r\n\r\n    .choices__item--selectable:after{\r\n        display: none;\r\n    }\r\n}\r\n  \r\n.is-open{\r\n    .choices__list--dropdown {\r\n        border-color: $dropdown-border-color;\r\n    }\r\n}\r\n  \r\n.is-flipped{\r\n    .choices__list--dropdown {\r\n        top: auto;\r\n        bottom: 100%;\r\n        margin-top: 0;\r\n        margin-bottom: -1px;\r\n        border-radius: 0.25rem 0.25rem 0 0;\r\n        &.is-active {\r\n            animation-name: DropDownSlideDown;\r\n            transform: translateY(-1px);\r\n        }\r\n    }\r\n}\r\n  \r\n.choices__list--dropdown{\r\n    .choices__list {\r\n        position: relative;\r\n        max-height: 300px;\r\n        overflow: auto;\r\n        -webkit-overflow-scrolling: touch;\r\n        will-change: scroll-position;\r\n    }\r\n\r\n    .choices__item {\r\n        position: relative;\r\n        font-size: $dropdown-font-size;\r\n        padding: $dropdown-item-padding-y $dropdown-item-padding-x $dropdown-item-padding-y 16px;\r\n    }\r\n}\r\n  \r\n\r\n  \r\n@media (min-width: 640px) {\r\n    .choices__list--dropdown {\r\n        .choices__item--selectable {\r\n\r\n            &:after {\r\n                content: attr(data-select-text);\r\n                font-size: 12px;\r\n                opacity: 0;\r\n                position: absolute;\r\n                right: 10px;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n            }\r\n\r\n            &.is-highlighted {\r\n                &:after {\r\n                    opacity: 0.5;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    \r\n\r\n}\r\n  \r\n.choices__item {\r\n    cursor: default;\r\n}\r\n  \r\n.choices__item--selectable {\r\n    cursor: pointer;\r\n}\r\n  \r\n.choices__item--disabled {\r\n    cursor: not-allowed;\r\n    user-select: none;\r\n    opacity: 0.5;\r\n}\r\n  \r\n.choices__heading {\r\n    font-weight: $font-weight-semibold;\r\n    font-size: 12px;\r\n    padding: 10px 16px;\r\n    border-bottom: 1px solid $border-color;\r\n    color: $text-muted;\r\n}\r\n  \r\n.choices__button {\r\n    text-indent: -9999px;\r\n    appearance: none;\r\n    border: 0;\r\n    background-color: transparent;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    cursor: pointer;\r\n    &:focus {\r\n        outline: none;\r\n    }\r\n}\r\n  \r\n.choices__input {\r\n    display: inline-block;\r\n    vertical-align: baseline;\r\n    background-color: $input-bg;\r\n    color: $input-color;\r\n    font-size: $input-font-size;\r\n    margin-bottom: 0;\r\n    border: 0;\r\n    border-radius: 0;\r\n    max-width: 100%;\r\n    padding: 2px 0 2px 2px;\r\n    &:focus {\r\n        outline: 0;\r\n    }\r\n    &::placeholder {\r\n        color: $input-placeholder-color;\r\n    }\r\n}\r\n  \r\n.choices__placeholder {\r\n    color: $input-placeholder-color;\r\n    opacity: 1;\r\n}\r\n\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .choices[data-type*=select-one]{\r\n        .choices__button{\r\n            filter: $btn-close-white-filter;\r\n        }\r\n    }\r\n}","//\r\n// _flatpicker.scss\r\n//\r\n\r\n.flatpickr-calendar {\r\n    background: transparent;\r\n    opacity: 0;\r\n    display: none;\r\n    text-align: center;\r\n    visibility: hidden;\r\n    padding: 0;\r\n    animation: none;\r\n    direction: ltr;\r\n    border: 0;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    border-radius: 5px;\r\n    position: absolute;\r\n    width: 307.875px;\r\n    box-sizing: border-box;\r\n    touch-action: manipulation;\r\n    background: var(--#{$prefix}choices-bg);\r\n    box-shadow: 1px 0 0 $border-color, -1px 0 0 $border-color, 0 1px 0 $border-color, 0 -1px 0 $border-color, 0 3px 13px rgba(0, 0, 0, 0.08);\r\n\r\n    &.open,\r\n    &.inline {\r\n        opacity: 1;\r\n        max-height: 640px;\r\n        visibility: visible;\r\n    }\r\n\r\n    &.open {\r\n        display: inline-block;\r\n        z-index: 1056;\r\n    }\r\n\r\n    &.animate.open {\r\n            animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\r\n    }\r\n\r\n    &.inline {\r\n        display: block;\r\n        position: relative;\r\n        top: 2px;\r\n        width: 100%;\r\n        box-shadow: none;\r\n\r\n        .flatpickr-rContainer {\r\n            display: block;\r\n            width: 100%;\r\n\r\n            .flatpickr-days {\r\n                width: 100%;\r\n                border: $input-border-width solid $input-border-color;\r\n                border-top: none;\r\n                border-radius: 0 0 5px 5px;\r\n\r\n\r\n                .dayContainer {\r\n                    width: 100%;\r\n                    min-width: 100%;\r\n                    max-width: 100%;\r\n\r\n                    .flatpickr-day {\r\n                        max-width: 100%;\r\n                        border-radius: 4px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .flatpickr-time {\r\n            border: $input-border-width solid $input-border-color !important;\r\n            border-radius: $input-border-radius;\r\n        }\r\n    }\r\n\r\n    &.static {\r\n        position: absolute;\r\n        top: calc(100% + 2px);\r\n        &.open {\r\n            z-index: 999;\r\n            display: block;\r\n        }\r\n    }\r\n\r\n    &.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    &.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {\r\n        box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\r\n    }\r\n\r\n    .hasWeeks .dayContainer,\r\n    .hasTime .dayContainer {\r\n        border-bottom: 0;\r\n        border-bottom-right-radius: 0;\r\n        border-bottom-left-radius: 0;\r\n    }\r\n\r\n    .hasWeeks .dayContainer {\r\n        border-left: 0;\r\n    }\r\n\r\n    &.hasTime .flatpickr-time {\r\n        height: 40px;\r\n        border-top: 1px solid $border-color;\r\n    }\r\n\r\n    &.noCalendar.hasTime .flatpickr-time {\r\n        height: auto;\r\n    }\r\n\r\n    &::before,\r\n    &::after {\r\n        position: absolute;\r\n        display: block;\r\n        pointer-events: none;\r\n        border: solid transparent;\r\n        content: '';\r\n        height: 0;\r\n        width: 0;\r\n        left: 22px;\r\n    }\r\n\r\n    &.rightMost::before,\r\n    &.arrowRight::before,\r\n    &.rightMost::after,\r\n    &.arrowRight::after {\r\n      left: auto;\r\n      right: 22px;\r\n    }\r\n\r\n    &.arrowCenter::before,\r\n    &.arrowCenter::after {\r\n      left: 50%;\r\n      right: 50%;\r\n    }\r\n\r\n    &::before {\r\n        border-width: 5px;\r\n        margin: 0 -5px;\r\n    }\r\n    &::after {\r\n        border-width: 4px;\r\n        margin: 0 -4px;\r\n    }\r\n\r\n    &.arrowTop::before,\r\n    &.arrowTop::after {\r\n        bottom: 100%;\r\n    }\r\n    &.arrowTop::before {\r\n        border-bottom-color: $primary;\r\n    }\r\n    &.arrowTop::after {\r\n        border-bottom-color: $primary;\r\n    }\r\n\r\n    &.arrowBottom::before,\r\n    &.arrowBottom::after {\r\n        top: 100%;\r\n    }\r\n    &.arrowBottom::before {\r\n        border-top-color: $primary;\r\n    }\r\n    &.arrowBottom::after {\r\n        border-top-color: $primary;\r\n    }\r\n    &:focus {\r\n        outline: 0;\r\n    }\r\n}\r\n\r\n.flatpickr-wrapper {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.flatpickr-months {\r\n    display: flex;\r\n    background-color: $primary;\r\n    border-radius: 5px 5px 0px 0px;\r\n\r\n    .flatpickr-month {\r\n        background: transparent;\r\n        color: rgba($white, 0.9);\r\n        fill: rgba($white, 0.9);\r\n        height: 34px;\r\n        line-height: 1;\r\n        text-align: center;\r\n        position: relative;\r\n        user-select: none;\r\n        overflow: hidden;\r\n        flex: 1;\r\n    }\r\n\r\n    .flatpickr-prev-month,\r\n    .flatpickr-next-month {\r\n        text-decoration: none;\r\n        cursor: pointer;\r\n        position: absolute;\r\n        top: 0;\r\n        height: 34px;\r\n        padding: 10px;\r\n        z-index: 3;\r\n        color: rgba($white, 0.9);\r\n        fill: rgba($white, 0.9);\r\n\r\n        &.flatpickr-disabled{\r\n          display: none;\r\n        }\r\n\r\n        i {\r\n            position: relative;\r\n        }\r\n\r\n        &.flatpickr-prev-month {\r\n            /*\r\n                  /*rtl:begin:ignore*/\r\n            /*\r\n                  */\r\n              left: 0;\r\n            /*\r\n                  /*rtl:end:ignore*/\r\n            /*\r\n                  */\r\n        }\r\n          /*\r\n        /*rtl:begin:ignore*/\r\n        /*\r\n        /*rtl:end:ignore*/\r\n\r\n        &.flatpickr-next-month {\r\n            /*\r\n                  /*rtl:begin:ignore*/\r\n            /*\r\n                  */\r\n              right: 0;\r\n            /*\r\n                  /*rtl:end:ignore*/\r\n            /*\r\n                  */\r\n        }\r\n          /*\r\n        /*rtl:begin:ignore*/\r\n        /*\r\n        /*rtl:end:ignore*/\r\n\r\n        &:hover {\r\n            color: #959ea9;\r\n\r\n            svg {\r\n                fill: rgba($white, 0.9);\r\n            }\r\n        }\r\n\r\n        svg {\r\n            width: 14px;\r\n            height: 14px;\r\n\r\n            path {\r\n                transition: fill 0.1s;\r\n                fill: inherit;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.numInputWrapper {\r\n    position: relative;\r\n    height: auto;\r\n\r\n    input,\r\n    span {\r\n        display: inline-block;\r\n    }\r\n\r\n    input {\r\n        width: 100%;\r\n\r\n        &::-ms-clear {\r\n            display: none;\r\n        }\r\n\r\n        &::-webkit-outer-spin-button,\r\n        &::-webkit-inner-spin-button {\r\n            margin: 0;\r\n            -webkit-appearance: none;\r\n        }\r\n    }\r\n\r\n    span {\r\n        position: absolute;\r\n        right: 0;\r\n        width: 14px;\r\n        padding: 0 4px 0 2px;\r\n        height: 50%;\r\n        line-height: 50%;\r\n        opacity: 0;\r\n        cursor: pointer;\r\n        border: 1px solid rgba(var(--#{$prefix}dark-rgb),0.15);\r\n        box-sizing: border-box;\r\n\r\n        &:hover {\r\n            background: rgba(0,0,0,0.1);\r\n        }\r\n\r\n        &:active {\r\n            background: rgba(0,0,0,0.2);\r\n        }\r\n\r\n        &:after {\r\n            display: block;\r\n            content: \"\";\r\n            position: absolute;\r\n        }\r\n\r\n        &.arrowUp {\r\n            top: 0;\r\n            border-bottom: 0;\r\n\r\n            &:after {\r\n                border-left: 4px solid transparent;\r\n                border-right: 4px solid transparent;\r\n                border-bottom: 4px solid rgba(57,57,57,0.6);\r\n                top: 26%;\r\n            }\r\n        }\r\n\r\n        &.arrowDown {\r\n            top: 50%;\r\n\r\n            &:after {\r\n                border-left: 4px solid transparent;\r\n                border-right: 4px solid transparent;\r\n                border-top: 4px solid rgba(57,57,57,0.6);\r\n                top: 40%;\r\n            }\r\n        }\r\n\r\n        svg {\r\n            width: inherit;\r\n            height: auto;\r\n\r\n            path {\r\n                fill: rgba(0,0,0,0.5);\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    &:hover {\r\n        background: rgba(0,0,0,0.05);\r\n        span {\r\n            opacity: 1;\r\n        }\r\n    }\r\n}\r\n\r\n.flatpickr-current-month {\r\n    font-size: 100%;\r\n    line-height: inherit;\r\n    font-weight: 300;\r\n    color: inherit;\r\n    position: absolute;\r\n    width: 75%;\r\n    left: 12.5%;\r\n    padding: 7.48px 0 0 0;\r\n    line-height: 1;\r\n    height: 34px;\r\n    display: inline-block;\r\n    text-align: center;\r\n    transform: translate3d(0px, 0px, 0px);\r\n\r\n    span.cur-month {\r\n        font-family: inherit;\r\n        font-weight: 700;\r\n        color: inherit;\r\n        display: inline-block;\r\n        margin-left: 0.5ch;\r\n        padding: 0;\r\n\r\n        &:hover {\r\n            background: rgba(0,0,0,0.05);\r\n        }\r\n    }\r\n\r\n    .numInputWrapper {\r\n        width: 6ch;\r\n        width: 7ch\\0;\r\n        display: inline-block;\r\n    }\r\n\r\n    span{\r\n        &.arrowUp::after {\r\n            border-bottom-color: rgba(0,0,0,0.9);\r\n        }\r\n        &.arrowDown:after {\r\n            border-top-color: rgba(0,0,0,0.9);\r\n        }\r\n    }\r\n\r\n    input.cur-year {\r\n        background: transparent;\r\n        box-sizing: border-box;\r\n        color: inherit;\r\n        cursor: text;\r\n        padding: 0 0 0 0.5ch;\r\n        margin: 0;\r\n        display: inline-block;\r\n        font-size: inherit;\r\n        font-family: inherit;\r\n        font-weight: $font-weight-semibold;\r\n        line-height: inherit;\r\n        height: auto;\r\n        border: 0;\r\n        border-radius: 0;\r\n        vertical-align: initial;\r\n        appearance: textfield;\r\n\r\n        &:focus {\r\n            outline: 0;\r\n        }\r\n\r\n        &[disabled],\r\n        &[disabled]:hover {\r\n            font-size: 100%;\r\n            color: rgba($white, 0.9);\r\n            background: transparent;\r\n            pointer-events: none;\r\n        }\r\n    }\r\n\r\n    .flatpickr-monthDropdown-months {\r\n        appearance: menulist;\r\n        background: transparent;\r\n        border: none;\r\n        border-radius: 0;\r\n        box-sizing: border-box;\r\n        color: inherit;\r\n        cursor: pointer;\r\n        font-size: inherit;\r\n        font-family: inherit;\r\n        font-weight: $font-weight-semibold;\r\n        height: auto;\r\n        line-height: inherit;\r\n        margin: -1px 0 0 0;\r\n        outline: none;\r\n        padding: 0 0 0 0.5ch;\r\n        position: relative;\r\n        vertical-align: initial;\r\n        width: auto;\r\n\r\n        &:focus,\r\n        &:active {\r\n            outline: none;\r\n        }\r\n\r\n        &:hover {\r\n            background-color: transparent;\r\n        }\r\n\r\n        .flatpickr-monthDropdown-month {\r\n            background-color: transparent;\r\n            outline: none;\r\n            padding: 0;\r\n            color: rgba($black, 0.8);\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.flatpickr-weekdays {\r\n    background-color: $primary;\r\n    text-align: center;\r\n    overflow: hidden;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 36px;\r\n    border-bottom: 1px solid $border-color;\r\n    .flatpickr-weekdaycontainer {\r\n        display: flex;\r\n        flex: 1;\r\n    }\r\n}\r\n\r\nspan.flatpickr-weekday {\r\n    cursor: default;\r\n    font-size: 90%;\r\n    background: $primary;\r\n    color: $white;\r\n    line-height: 1;\r\n    margin: 0;\r\n    text-align: center;\r\n    display: block;\r\n    flex: 1;\r\n    font-weight: $font-weight-medium;\r\n}\r\n\r\n.dayContainer,\r\n.flatpickr-weeks {\r\n    padding: 1px 0 0 0;\r\n}\r\n.flatpickr-days {\r\n    position: relative;\r\n    overflow: hidden;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    width: 307.875px;\r\n    &:focus {\r\n        outline: 0;\r\n    }\r\n}\r\n\r\n.dayContainer {\r\n    padding: 0;\r\n    outline: 0;\r\n    text-align: left;\r\n    width: 307.875px;\r\n    min-width: 307.875px;\r\n    max-width: 307.875px;\r\n    box-sizing: border-box;\r\n    display: inline-block;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-around;\r\n    transform: translate3d(0px, 0px, 0px);\r\n    opacity: 1;\r\n    + .dayContainer {\r\n        box-shadow: -1px 0 0 #e6e6e6;\r\n    }\r\n}\r\n\r\n.flatpickr-day {\r\n    background: none;\r\n    border: 1px solid transparent;\r\n    border-radius: 150px;\r\n    box-sizing: border-box;\r\n    color: var(--#{$prefix}body-color);\r\n    cursor: pointer;\r\n    font-weight: 400;\r\n    width: 14.2857143%;\r\n    flex-basis: 14.2857143%;\r\n    max-width: 39px;\r\n    height: 39px;\r\n    line-height: 39px;\r\n    margin: 0;\r\n    display: inline-block;\r\n    position: relative;\r\n    justify-content: center;\r\n    text-align: center;\r\n\r\n    &:hover,\r\n    &:focus {\r\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.7);\r\n    }\r\n\r\n    &.inRange,\r\n    &.prevMonthDay.inRange,\r\n    &.nextMonthDay.inRange,\r\n    &.today.inRange,\r\n    &.prevMonthDay.today.inRange,\r\n    &.nextMonthDay.today.inRange,\r\n    &:hover,\r\n    &.prevMonthDay:hover,\r\n    &.nextMonthDay:hover,\r\n    &:focus,\r\n    &.prevMonthDay:focus,\r\n    &.nextMonthDay:focus {\r\n        cursor: pointer;\r\n        outline: 0;\r\n        background-color: var(--#{$prefix}light);\r\n        border-color: var(--#{$prefix}light);\r\n    }\r\n\r\n    &.today {\r\n        border-color: $primary;\r\n        background-color: rgba($primary, 0.1);\r\n        box-shadow: $element-shadow;\r\n\r\n        &:hover,\r\n        &:focus {\r\n            border-color: $primary;\r\n            background-color: rgba($primary, 0.15);\r\n            color: var(--#{$prefix}dark);\r\n        }\r\n    }\r\n\r\n    &.selected,\r\n    &.startRange,\r\n    &.endRange,\r\n    &.selected.inRange,\r\n    &.startRange.inRange,\r\n    &.endRange.inRange,\r\n    &.selected:focus,\r\n    &.startRange:focus,\r\n    &.endRange:focus,\r\n    &.selected:hover,\r\n    &.startRange:hover,\r\n    &.endRange:hover,\r\n    &.selected.prevMonthDay,\r\n    &.startRange.prevMonthDay,\r\n    &.endRange.prevMonthDay,\r\n    &.selected.nextMonthDay,\r\n    &.startRange.nextMonthDay,\r\n    &.endRange.nextMonthDay {\r\n        background: $primary;\r\n        box-shadow: $element-shadow;\r\n        color: $white;\r\n        border-color: $primary;\r\n    }\r\n\r\n    &.selected,\r\n    &.startRange,\r\n    &.endRange{\r\n        &.startRange {\r\n            border-radius: 50px 0 0 50px;\r\n            + .endRange:not(:nth-child(7n+1)) {\r\n                box-shadow: -10px 0 0 $primary;\r\n            }\r\n\r\n            .endRange{\r\n                border-radius: 50px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.selected,\r\n    &.startRange,\r\n    &.endRange{\r\n        &.endRange {\r\n            border-radius: 0 50px 50px 0;\r\n        }\r\n    }\r\n\r\n    &.inRange {\r\n        border-radius: 0;\r\n        box-shadow: -5px 0 0 var(--#{$prefix}light), 5px 0 0 var(--#{$prefix}light);\r\n    }\r\n\r\n    &.flatpickr-disabled,\r\n    &.flatpickr-disabled:hover,\r\n    &.prevMonthDay,\r\n    &.nextMonthDay,\r\n    &.notAllowed,\r\n    &.notAllowed.prevMonthDay,\r\n    &.notAllowed.nextMonthDay {\r\n        color: rgba(var(--#{$prefix}body-color-rgb),0.3);\r\n        background: transparent;\r\n        border-color: transparent;\r\n        cursor: default;\r\n    }\r\n\r\n    &.flatpickr-disabled,\r\n    &.flatpickr-disabled:hover {\r\n        cursor: not-allowed;\r\n        color: rgba(var(--#{$prefix}body-color-rgb),0.3);\r\n    }\r\n\r\n    &.week.selected {\r\n        border-radius: 0;\r\n        box-shadow: -5px 0 0 $primary, 5px 0 0 $primary;\r\n    }\r\n\r\n    &.hidden {\r\n        visibility: hidden;\r\n    }\r\n}\r\n\r\n.rangeMode .flatpickr-day {\r\n    margin-top: 1px;\r\n}\r\n\r\n.flatpickr-weekwrapper {\r\n    float: left;\r\n    .flatpickr-weeks {\r\n        padding: 0 12px;\r\n        box-shadow: 1px 0 0 #e6e6e6;\r\n    }\r\n\r\n    .flatpickr-weekday {\r\n        float: none;\r\n        width: 100%;\r\n        line-height: 35px;\r\n    }\r\n\r\n    span{\r\n        &.flatpickr-day,\r\n        &.flatpickr-day:hover {\r\n            display: block;\r\n            width: 100%;\r\n            max-width: none;\r\n            color: rgba(var(--#{$prefix}dark-rgb),0.3);\r\n            background: transparent;\r\n            cursor: default;\r\n            border: none;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.flatpickr-innerContainer {\r\n    display: block;\r\n    display: flex;\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n}\r\n\r\n.flatpickr-rContainer {\r\n    display: inline-block;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.flatpickr-time {\r\n    text-align: center;\r\n    outline: 0;\r\n    display: block;\r\n    height: 0;\r\n    line-height: 40px;\r\n    max-height: 40px;\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n    display: flex;\r\n\r\n    &:after {\r\n        content: \"\";\r\n        display: table;\r\n        clear: both;\r\n    }\r\n    .numInputWrapper {\r\n        flex: 1;\r\n        width: 40%;\r\n        height: 40px;\r\n        float: left;\r\n        span{\r\n            &.arrowUp, &.arrowDown{\r\n                &:after {\r\n                    border-bottom-color: $border-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.hasSeconds .numInputWrapper {\r\n        width: 26%;\r\n    }\r\n\r\n    &.time24hr .numInputWrapper {\r\n        width: 49%;\r\n    }\r\n\r\n\r\n    input {\r\n        background: transparent;\r\n        box-shadow: none;\r\n        border: 0;\r\n        border-radius: 0;\r\n        text-align: center;\r\n        margin: 0;\r\n        padding: 0;\r\n        height: inherit;\r\n        line-height: inherit;\r\n        color: var(--#{$prefix}body-color);\r\n        font-size: 14px;\r\n        position: relative;\r\n        box-sizing: border-box;\r\n        appearance: textfield;\r\n\r\n        &.flatpickr-hour {\r\n            font-weight: bold;\r\n        }\r\n\r\n        &.flatpickr-minute,\r\n        &.flatpickr-second {\r\n          font-weight: 400;\r\n        }\r\n\r\n        &:focus {\r\n            outline: 0;\r\n            border: 0;\r\n        }\r\n    }\r\n\r\n\r\n    .flatpickr-time-separator,\r\n    .flatpickr-am-pm {\r\n        height: inherit;\r\n        float: left;\r\n        line-height: inherit;\r\n        color: var(--#{$prefix}body-color);\r\n        font-weight: bold;\r\n        width: 2%;\r\n        user-select: none;\r\n        align-self: center;\r\n    }\r\n\r\n    .flatpickr-am-pm {\r\n        outline: 0;\r\n        width: 18%;\r\n        cursor: pointer;\r\n        text-align: center;\r\n        font-weight: 400;\r\n    }\r\n\r\n    input, .flatpickr-am-pm{\r\n        &:hover, &:focus{\r\n            background: rgba($primary, 0.04);\r\n        }\r\n    }\r\n}\r\n\r\n.flatpickr-am-pm,\r\n.numInput,\r\n.numInputWrapper {\r\n    &:focus,\r\n    &:hover {\r\n        background-color: transparent;\r\n    }\r\n}\r\n\r\n.flatpickr-input[readonly] {\r\n    cursor: pointer;\r\n    background-color: $input-bg;\r\n}\r\n\r\n[data-inline-date=\"true\"],[data-time-inline] {\r\n    display: none;\r\n}\r\n\r\n@keyframes fpFadeInDown {\r\n    from {\r\n        opacity: 0;\r\n        transform: translate3d(0, -20px, 0);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n  \r\n[datepicker-inline],\r\n[timepicker-inline] {\r\n    display: none;\r\n}","//\r\n// _authentication.scss\r\n//\r\n\r\n\r\n.auth-page-wrapper{\r\n    .auth-page-content{\r\n        padding-bottom: $footer-height;\r\n        position: relative;\r\n        z-index: 2;\r\n        width: 100%;\r\n    }\r\n    .footer{\r\n        left: 0;\r\n        background-color: transparent;\r\n        color: var(--#{$prefix}body-color);\r\n    }\r\n}\r\n\r\n.auth-one-bg-position{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 420px;\r\n    \r\n    @media (max-width: 575.98px) {\r\n        height: 280px;\r\n    }\r\n}\r\n\r\n.auth-one-bg{\r\n    background-image: url(\"../../images/auth-erp-bg.jpg\");\r\n    background-position: center;\r\n    background-size: cover;\r\n\r\n    .bg-overlay{\r\n        background: linear-gradient(to right, darken($dark, 6%), $dark);\r\n        opacity: 0.3;\r\n    }\r\n}\r\n\r\n.shape{\r\n    position: absolute;\r\n    bottom: 0;\r\n    right: 0;\r\n    left: 0;\r\n    z-index: 1;\r\n    pointer-events: none;\r\n    >svg {\r\n        width: 100%;\r\n        height: auto;\r\n        fill: var(--#{$prefix}body-bg);\r\n    }\r\n}\r\n\r\n.auth-pass-inputgroup{\r\n    input[type=\"text\"] + .btn .ri-eye-fill{\r\n        &:before{\r\n            content: \"\\ecb6\";\r\n        }\r\n    }\r\n}\r\n\r\n.particles-js-canvas-el{\r\n    position: relative;\r\n}\r\n\r\n// signin card title\r\n\r\n.signin-other-title{\r\n    position: relative;\r\n    &:after{\r\n        content: \"\";\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 1px;\r\n        left: 0;\r\n        right: 0;\r\n        border-top: 1px dashed var(--#{$prefix}border-color);\r\n        top: 10px;\r\n    }\r\n\r\n    .title{\r\n        display: inline-block;\r\n        position: relative;\r\n        z-index: 9;\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n        padding: 2px 16px;\r\n    }\r\n}\r\n\r\n// Auth cover\r\n\r\n.auth-bg-cover{\r\n    background: $auth-bg-cover;\r\n\r\n    > .bg-overlay{\r\n        background-image: url(\"../../images/cover-pattern.png\");\r\n        background-position: center;\r\n        background-size: cover;\r\n        opacity: 1;\r\n        background-color: transparent;\r\n    }\r\n\r\n    .footer{\r\n        color: rgba($white, .5);\r\n    }\r\n}\r\n\r\n//passowrd validations \r\n#password-contain {\r\n    display: none;\r\n\r\n    p {\r\n        padding-left: 13px;\r\n\r\n        &.valid {\r\n            color: $success;\r\n\r\n            &::before {\r\n                position: relative;\r\n                left: -8px;\r\n                content: \"✔\";\r\n            }\r\n        }\r\n\r\n        &.invalid {\r\n            color: $danger;\r\n\r\n            &::before {\r\n                position: relative;\r\n                left: -8px;\r\n                content: \"✖\";\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// _dashboard.scss\r\n//\r\n\r\n.dash-filter-picker {\r\n  min-width: 210px !important;\r\n}\r\n\r\n// Flatpickr Calendar\r\n\r\n.upcoming-scheduled {\r\n  position: relative;\r\n  @media (max-width: 575.98px) {\r\n    top: 35px !important;\r\n  }\r\n  .flatpickr-months {\r\n    position: absolute !important;\r\n    top: -45px !important;\r\n    left: auto !important;\r\n    right: 0px !important;\r\n    width: 200px;\r\n    background-color: transparent;\r\n\r\n    .flatpickr-month {\r\n      color: $gray-600 !important;\r\n      fill: $gray-600 !important;\r\n    }\r\n    .flatpickr-prev-month,\r\n    .flatpickr-next-month {\r\n      display: none;\r\n    }\r\n  }\r\n  .flatpickr-calendar {\r\n    box-shadow: none !important;\r\n    .flatpickr-current-month {\r\n      font-size: 13px;\r\n      width: 100%;\r\n      left: 0;\r\n    }\r\n    .flatpickr-monthDropdown-months {\r\n      border: 1px solid $border-color;\r\n      border-radius: 4px;\r\n      height: 26px;\r\n    }\r\n    .flatpickr-weekdays {\r\n      background-color: var(--#{$prefix}light);\r\n      border: none;\r\n      span.flatpickr-weekday {\r\n        color: var(--#{$prefix}dark);\r\n        background-color: var(--#{$prefix}light);\r\n      }\r\n    }\r\n    .flatpickr-day {\r\n      &.today {\r\n        color: $white !important;\r\n        background-color: $success;\r\n        border-color: $success !important;\r\n        &:hover {\r\n          color: $success !important;\r\n          background-color: rgba($success, 0.2) !important;\r\n        }\r\n      }\r\n      &.selected {\r\n        background-color: $success !important;\r\n        border-color: $success !important;\r\n        color: $white;\r\n      }\r\n    }\r\n    .numInputWrapper {\r\n      width: 7.5ch;\r\n      margin-left: 10px;\r\n    }\r\n  }\r\n\r\n  .flatpickr-days {\r\n    border: none !important;\r\n  }\r\n}\r\n\r\n.crm-widget {\r\n  .col {\r\n    border-right: 1px solid $border-color;\r\n    &:last-child {\r\n      border: 0px;\r\n    }\r\n    @media (min-width: 768px) and (max-width: 1399.98px) {\r\n      &:nth-child(3) {\r\n        border-right: 0px;\r\n      }\r\n      &:last-child {\r\n        border-right: 1px solid $border-color;\r\n      }\r\n    }\r\n    @media (max-width: 767.98px) {\r\n      border-right: 0px;\r\n      border-bottom: 1px solid $border-color;\r\n    }\r\n  }\r\n}\r\n\r\n@media (min-width: 1400px) and (max-width: 1599.98px) {\r\n  .project-wrapper {\r\n    > .col-xxl-8,\r\n    .col-xxl-4 {\r\n      width: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n.crypto-widget {\r\n  max-width: 130px !important;\r\n}\r\n\r\n//nft dashboard\r\n\r\n.bg-marketplace {\r\n  background-image: url(../../images/nft/marketplace.png);\r\n  background-size: cover;\r\n}\r\n\r\n.dash-countdown {\r\n  .countdownlist {\r\n    .count-num {\r\n      background-color: var(--#{$prefix}card-bg-custom);\r\n      padding: 16px 8px;\r\n      font-size: 22px;\r\n\r\n      @media (max-width: 575.98px) {\r\n        font-size: 16px;\r\n        padding: 8px 6px;\r\n      }\r\n    }\r\n\r\n    .count-title {\r\n      @media (max-width: 575.98px) {\r\n        font-size: 10px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.marketplace-icon {\r\n  position: absolute;\r\n  float: right;\r\n  top: 30px;\r\n  left: 30px;\r\n}\r\n\r\n.marketplace-swiper {\r\n  .swiper-button-next,\r\n  .swiper-button-prev {\r\n    top: 34px;\r\n    width: 28px;\r\n    height: 28px;\r\n    background-color: rgba($primary, 0.1);\r\n    color: $primary;\r\n    border-radius: 0.3rem;\r\n    right: 16px !important;\r\n  }\r\n  .swiper-button-prev {\r\n    right: 58px !important;\r\n    left: auto !important;\r\n  }\r\n}\r\n\r\n.dash-collection {\r\n  .content {\r\n    background-color: rgba($white, 0.25);\r\n    backdrop-filter: blur(5px);\r\n  }\r\n}\r\n\r\n.dash-nft {\r\n  @media (max-width: 1441.98px) {\r\n    .col-xxl-9,\r\n    .col-xxl-3 {\r\n      width: 100% !important;\r\n      max-width: 100% !important;\r\n    }\r\n  }\r\n}\r\n\r\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\r\n  width: 32px;\r\n  height: 32px;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n}\r\n","//\r\n// _timeline.scss\r\n//\r\n\r\n.timeline {\r\n  position: relative;\r\n  width: 100%;\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n\r\n  &::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 2px;\r\n    background: $timeline-color;\r\n    top: 57px;\r\n    bottom: 166px;\r\n    left: 50%;\r\n    margin-left: -1.5px;\r\n  }\r\n}\r\n\r\n.timeline-item {\r\n  padding: 30px 60px;\r\n  position: relative;\r\n  background: inherit;\r\n  width: 50%;\r\n\r\n  .icon {\r\n    position: absolute;\r\n    display: inline-flex;\r\n    width: 60px;\r\n    height: 60px;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 25px;\r\n    top: 30px;\r\n    right: -30px;\r\n    padding: 9px 0;\r\n    background: var(--#{$prefix}card-bg-custom);\r\n    border: 1px solid $border-color;\r\n    border-radius: 50px;\r\n    color: $success;\r\n    z-index: 1;\r\n  }\r\n\r\n  .date {\r\n    position: absolute;\r\n    display: inline-block;\r\n    width: calc(100% - 48px);\r\n    top: 50px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    font-style: italic;\r\n  }\r\n\r\n  .content {\r\n    padding: 20px;\r\n    background: var(--#{$prefix}card-bg-custom);\r\n    position: relative;\r\n    border: 1px solid $border-color;\r\n    border-radius: $border-radius;\r\n    box-shadow: $box-shadow-sm;\r\n  }\r\n\r\n  &.left {\r\n    left: 0;\r\n\r\n    .date {\r\n      left: calc(100% + 48px);\r\n      text-align: start;\r\n    }\r\n  }\r\n\r\n  &.right {\r\n    left: 50%;\r\n\r\n    .icon {\r\n      left: -30px;\r\n    }\r\n\r\n    .date {\r\n      right: calc(100% + 48px);\r\n      text-align: end;\r\n    }\r\n\r\n    &::before {\r\n      left: 28px;\r\n      border-color: transparent transparent transparent $white;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n  .timeline {\r\n    &::after {\r\n      left: 24px;\r\n      bottom: 180px;\r\n    }\r\n  }\r\n\r\n  .timeline-item {\r\n    width: 100%;\r\n    padding-left: 48px;\r\n    padding-right: 0px;\r\n\r\n    &.right,\r\n    &.left {\r\n      left: 0%;\r\n\r\n      .icon {\r\n        width: 45px;\r\n        height: 45px;\r\n        top: 0;\r\n        font-size: 18px;\r\n        left: 0;\r\n      }\r\n\r\n      &::before {\r\n        left: 110px;\r\n        border-color: transparent transparent transparent $border-color;\r\n      }\r\n\r\n      .date {\r\n        right: auto;\r\n        left: 48px;\r\n        width: 79px;\r\n        top: 8px;\r\n        text-align: left;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.timeline-2 {\r\n  position: relative;\r\n\r\n  &::after {\r\n    position: absolute;\r\n    content: \"\";\r\n    width: 2px;\r\n    height: 100%;\r\n    top: 15px;\r\n    left: 5px;\r\n    margin-left: -1px;\r\n    background: $timeline-color;\r\n  }\r\n\r\n  .timeline-year {\r\n    position: relative;\r\n    width: 100%;\r\n    text-align: left;\r\n    z-index: 1;\r\n\r\n    p {\r\n      display: inline-flex;\r\n      width: 80px;\r\n      height: 80px;\r\n      margin: 0;\r\n      padding: 23px 10px;\r\n      background: $timeline-color;\r\n      border-radius: 50px;\r\n      text-transform: uppercase;\r\n      align-items: center;\r\n      justify-content: center;\r\n      text-align: center;\r\n      span {\r\n        display: -webkit-box;\r\n        -webkit-line-clamp: 2;\r\n        -webkit-box-orient: vertical;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n      }\r\n    }\r\n  }\r\n\r\n  .timeline-date {\r\n    font-size: 14px;\r\n    font-weight: $font-weight-medium;\r\n    margin: 24px 0 0 0;\r\n    margin-left: 15px;\r\n\r\n    &::after {\r\n      content: \"\";\r\n      display: block;\r\n      position: absolute;\r\n      width: 14px;\r\n      height: 14px;\r\n      top: 26px;\r\n      left: 10px;\r\n      align-items: left;\r\n      background: $success;\r\n      border: 3px solid $timeline-color;\r\n      border-radius: 50px;\r\n      z-index: 1;\r\n    }\r\n  }\r\n\r\n  .timeline-box {\r\n    position: relative;\r\n    display: inline-block;\r\n    margin: 10px 22px;\r\n    padding: 15px;\r\n    border: 1px solid $border-color;\r\n    border-radius: 6px;\r\n    background: var(--#{$prefix}card-bg-custom);\r\n    max-width: 695px;\r\n    @media (max-width: 991.98px) {\r\n      margin-right: 0;\r\n    }\r\n\r\n    &::after {\r\n      content: \"\";\r\n      display: block;\r\n      position: absolute;\r\n      width: 0;\r\n      height: 0;\r\n      border-style: solid;\r\n      top: 26px;\r\n      right: 100%;\r\n      border-color: transparent var(--#{$prefix}card-bg-custom) transparent\r\n        transparent;\r\n      border-width: 10px;\r\n    }\r\n\r\n    &::before {\r\n      content: \"\";\r\n      display: block;\r\n      position: absolute;\r\n      width: 0;\r\n      height: 0;\r\n      border-style: solid;\r\n      right: 100%;\r\n      top: 24px;\r\n      border-color: transparent $border-color transparent transparent;\r\n      border-width: 12px;\r\n    }\r\n\r\n    .timeline-text {\r\n      position: relative;\r\n      float: left;\r\n    }\r\n  }\r\n\r\n  .timeline-box-s {\r\n    position: relative;\r\n    display: inline-block;\r\n    margin: 10px 22px;\r\n    padding: 15px;\r\n    border: 1px solid $border-color;\r\n    border-radius: 6px;\r\n    background: var(--#{$prefix}card-bg-custom);\r\n    max-width: 695px;\r\n    @media (max-width: 991.98px) {\r\n      margin-right: 0;\r\n    }\r\n\r\n    &::after {\r\n      content: \"\";\r\n      display: block;\r\n      position: absolute;\r\n      width: 0;\r\n      height: 0;\r\n      border-style: solid;\r\n      top: 26px;\r\n      right: 100%;\r\n      border-color: transparent $yellow transparent\r\n        transparent;\r\n      border-width: 10px;\r\n    }\r\n\r\n    &::before {\r\n      content: \"\";\r\n      display: block;\r\n      position: absolute;\r\n      width: 0;\r\n      height: 0;\r\n      border-style: solid;\r\n      right: 100%;\r\n      top: 24px;\r\n      border-color: transparent $border-color transparent transparent;\r\n      border-width: 12px;\r\n    }\r\n\r\n    .timeline-text {\r\n      position: relative;\r\n      float: left;\r\n    }\r\n  }\r\n\r\n  .timeline-launch {\r\n    position: relative;\r\n    display: inline-block;\r\n    border: 1px solid $border-color;\r\n    border-radius: 6px;\r\n    background: $white;\r\n    width: 100%;\r\n    margin-top: 15px;\r\n    padding: 0;\r\n    border: none;\r\n    text-align: left;\r\n    background: transparent;\r\n\r\n    .timeline-box {\r\n      margin-left: 0;\r\n\r\n      &::after {\r\n        left: 30px;\r\n        margin-left: 0px;\r\n        top: -20px;\r\n        border-color: transparent transparent $border-color transparent;\r\n      }\r\n\r\n      &::before {\r\n        left: 30px;\r\n        margin-left: 0px;\r\n        top: -19px;\r\n        border-color: transparent transparent var(--#{$prefix}card-bg-custom)\r\n          transparent;\r\n        border-width: 10px;\r\n        z-index: 1;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// Horizontal Timeline\r\n.horizontal-timeline {\r\n  position: relative;\r\n  width: 100%;\r\n  margin: 0 auto;\r\n\r\n  &::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    width: 100%;\r\n    top: 174px;\r\n    left: 0;\r\n    height: 2px;\r\n    background-color: $timeline-color;\r\n  }\r\n\r\n  .swiper-slide {\r\n    .item-box {\r\n      margin: 227px 0px 0px;\r\n      background-color: transparent;\r\n      box-shadow: none;\r\n\r\n      &::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0px;\r\n        right: 0px;\r\n        margin: 0px auto;\r\n        background: $primary;\r\n        width: 13px;\r\n        height: 13px;\r\n        top: -59px;\r\n        border-radius: 50px;\r\n        border: 3px solid $timeline-color;\r\n      }\r\n    }\r\n\r\n    .timeline-content {\r\n      min-height: 110px;\r\n      display: flex;\r\n      justify-content: center;\r\n      align-items: center;\r\n      position: relative;\r\n      background-color: $timeline-color;\r\n\r\n      &::before {\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        width: 0;\r\n        height: 0;\r\n        border-style: solid;\r\n        left: 0px;\r\n        top: -23px;\r\n        border-color: transparent transparent $timeline-color transparent;\r\n        border-width: 12px;\r\n        right: 0;\r\n        margin: 0 auto;\r\n      }\r\n    }\r\n\r\n    .time {\r\n      position: absolute;\r\n      top: -86px;\r\n      right: 0px;\r\n      left: 0px;\r\n      margin: 0px auto;\r\n    }\r\n\r\n    &:nth-child(even) {\r\n      margin-top: 5px;\r\n      transform: rotate(-180deg);\r\n\r\n      .timeline-content {\r\n        transform: rotate(180deg);\r\n\r\n        &::before {\r\n          bottom: -23px;\r\n          top: auto;\r\n          border-color: $timeline-color transparent transparent transparent;\r\n        }\r\n      }\r\n\r\n      .time {\r\n        transform: rotate(180deg);\r\n      }\r\n    }\r\n  }\r\n\r\n  .swiper-button-next,\r\n  .swiper-button-prev {\r\n    height: 40px;\r\n    width: 40px;\r\n    line-height: 40px;\r\n    border-radius: 50%;\r\n    background-color: lighten($primary, 2.5%);\r\n\r\n    &::after {\r\n      font-size: 24px;\r\n      color: $white;\r\n    }\r\n    &.swiper-button-disabled {\r\n      background-color: rgba($primary, 0.5);\r\n      opacity: 1;\r\n      cursor: auto;\r\n      backdrop-filter: blur(25px);\r\n      pointer-events: none;\r\n    }\r\n  }\r\n\r\n  .swiper-button-next {\r\n    right: 0;\r\n\r\n    &::after {\r\n      content: \"\\EA6E\";\r\n      font-family: remixicon;\r\n    }\r\n  }\r\n\r\n  .swiper-button-prev {\r\n    left: 0;\r\n\r\n    &::after {\r\n      content: \"\\EA64\";\r\n      font-family: remixicon;\r\n    }\r\n  }\r\n}\r\n\r\n//activity-timeline\r\n\r\n.acitivity-timeline {\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  .acitivity-item {\r\n    position: relative;\r\n\r\n    .flex-shrink-0 {\r\n      z-index: 2;\r\n    }\r\n\r\n    .acitivity-avatar {\r\n      background-color: var(--#{$prefix}card-bg-custom);\r\n      border: 3px solid var(--#{$prefix}card-bg-custom);\r\n      height: 32px;\r\n      width: 32px;\r\n    }\r\n\r\n    &:before {\r\n      content: \"\";\r\n      position: absolute;\r\n      border-left: 1px dashed $border-color;\r\n      left: 16px;\r\n      height: 100%;\r\n      top: 5px;\r\n      z-index: 0;\r\n    }\r\n    &:last-child {\r\n      &::before {\r\n        border-color: transparent;\r\n      }\r\n    }\r\n  }\r\n}\r\n","    //\r\n// _gallery.scss\r\n//\r\n\r\n.categories-filter {\r\n    .list-inline-item {\r\n        position: relative;\r\n        margin-right: 0;\r\n\r\n        a {\r\n            display: block;\r\n            color: var(--#{$prefix}body-color);\r\n            font-weight: $font-weight-semibold;\r\n            padding: 8px 15px;\r\n            margin: 5px;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n}\r\n\r\n.gallery-box {\r\n    position: relative;\r\n    overflow: hidden;\r\n    border: 1px solid transparent;\r\n    margin-bottom: 10px;\r\n    box-shadow: none;\r\n    background-color: transparent;\r\n    padding: 8px;\r\n\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        width: 100%;\r\n        height: 0;\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n        transition: all 0.4s;\r\n    }\r\n\r\n    .gallery-container {\r\n        position: relative;\r\n        overflow: hidden;\r\n        border-radius: 4px;\r\n\r\n        a {\r\n            display: block;\r\n        }\r\n\r\n        .gallery-overlay {\r\n            position: absolute;\r\n            top: 0px;\r\n            left: 0px;\r\n            bottom: 0px;\r\n            right: 0px;\r\n            opacity: 0;\r\n            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, .5) 100%);\r\n            visibility: hidden;\r\n            overflow: hidden;\r\n            transition: all 0.4s ease-in-out 0s;\r\n            display: flex;\r\n            width: 100%;\r\n            align-items: flex-end;\r\n            padding: 16px;\r\n\r\n            .overlay-caption {\r\n                color: $white;\r\n                margin: 0;\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .gallery-img {\r\n        transition: all 0.2s ease-in-out;\r\n    }\r\n\r\n    .box-content {\r\n        position: relative;\r\n\r\n        .title {\r\n            font-size: 14px;\r\n            margin-bottom: 4px;\r\n            display: none;\r\n        }\r\n\r\n        .post {\r\n            margin: 0;\r\n            transition: all 0.2s;\r\n            color: $text-muted;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        &::before {\r\n            height: 100%;\r\n        }\r\n\r\n        .box-content {\r\n            bottom: 0;\r\n\r\n            .post {\r\n                opacity: 1;\r\n            }\r\n        }\r\n\r\n        .gallery-overlay {\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n    }\r\n}\r\n\r\n.gallery-light {\r\n    .gallery-box {\r\n        &::before {\r\n            background-color: var(--#{$prefix}light);\r\n        }\r\n    }\r\n}","//\r\n// _errors.scss\r\n//\r\n\r\n.error-basic-img{\r\n    max-width: 450px;\r\n}\r\n\r\n.error-500 {\r\n    .title {\r\n        font-size: 250px;\r\n    }\r\n\r\n    .error-500-img {\r\n        position: absolute;\r\n        top: 57px;\r\n        left: 0;\r\n        right: 0;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    @media (min-width: 768px) and (max-width: 991.98px) {\r\n        .title {\r\n            font-size: 150px;\r\n        }\r\n\r\n        .error-500-img {\r\n            width: 20% !important;\r\n            top: 43px;\r\n        }\r\n    }\r\n\r\n    @media (max-width: 767.98px) {\r\n        .title {\r\n            font-size: 68px;\r\n            margin-top: 35px;\r\n        }\r\n\r\n        .error-500-img {\r\n            position: relative;\r\n            top: 0px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@keyframes errorAnimation {\r\n    0% {\r\n        transform: translateX(0%);\r\n    }\r\n\r\n    15% {\r\n        transform: translateX(-25%) rotate(-5deg);\r\n    }\r\n\r\n    30% {\r\n        transform: translateX(20%) rotate(3deg);\r\n    }\r\n\r\n    45% {\r\n        transform: translateX(-15%) rotate(-3deg);\r\n    }\r\n\r\n    60% {\r\n        transform: translateX(10%) rotate(2deg);\r\n    }\r\n\r\n    75% {\r\n        transform: translateX(-5%) rotate(-1deg);\r\n    }\r\n\r\n    100% {\r\n        transform: translateX(0%);\r\n    }\r\n}\r\n\r\n.error-img {\r\n    animation: errorAnimation 20s infinite;\r\n}","//\r\n// _profile.scss\r\n//\r\n\r\n.error-text {\r\n    text-shadow: 4px 4px rgba($success, 0.4);\r\n\r\n    @media (min-width: 1200px) {\r\n        font-size: 10rem;\r\n    }\r\n}\r\n\r\n\r\n// profile\r\n\r\n.profile-wid-bg {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    height: 320px;\r\n    @media (max-width: 575.98px) {\r\n        height: 445px;\r\n    }\r\n\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        opacity: 0.9;\r\n        background: $primary;\r\n        background: linear-gradient(to top, darken($primary, 25%), $primary);\r\n\r\n    }\r\n\r\n    .profile-wid-img {\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n    }\r\n}\r\n\r\n.profile-nav {\r\n    &.nav-pills {\r\n        .nav-link {\r\n            color: rgba($white, 0.8);\r\n\r\n            &::before {\r\n                background-color: rgba($white, 0.1);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.profile-project-card {\r\n    border: 1px solid $border-color;\r\n    border-left: 3px solid $border-color;\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .profile-project-card {\r\n        &.profile-project-#{$color} {\r\n            border-left-color: $value;\r\n        }\r\n    }\r\n}\r\n\r\n.user-profile-img {\r\n    position: relative;\r\n\r\n    .profile-img {\r\n        width: 100%;\r\n        height: 250px;\r\n        object-fit: cover;\r\n\r\n        @media (max-width:991px) {\r\n            height: 160px;\r\n        }\r\n    }\r\n\r\n    .profile-foreground-img-file-input {\r\n        display: none;\r\n    }\r\n\r\n    .profile-photo-edit {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.profile-user {\r\n    position: relative;\r\n    display: inline-block;\r\n\r\n    .profile-photo-edit {\r\n        position: absolute;\r\n        right: 0;\r\n        left: auto;\r\n        bottom: 0;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .user-profile-image {\r\n        object-fit: cover;\r\n    }\r\n\r\n    .profile-img-file-input {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.profile-timeline {\r\n    .accordion-item {\r\n        position: relative;\r\n\r\n        .accordion-button {\r\n            background-color: transparent;\r\n\r\n            &::after {\r\n                background: none;\r\n            }\r\n        }\r\n\r\n        &::before {\r\n            content: \"\";\r\n            border-left: 2px dashed $border-color;\r\n            position: absolute;\r\n            height: 100%;\r\n            left: 23px;\r\n        }\r\n\r\n        &:first-child {\r\n            &::before {\r\n                top: 8px;\r\n            }\r\n        }\r\n\r\n        &:last-child {\r\n            &::before {\r\n                height: 20px;\r\n                top: 3px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.profile-setting-img {\r\n    position: relative;\r\n    height: 260px;\r\n\r\n    .overlay-content {\r\n        content: \"\";\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n    }\r\n\r\n    .profile-img {\r\n        width: 100%;\r\n        height: 250px;\r\n        object-fit: cover;\r\n\r\n        @media (max-width:991.98px) {\r\n            height: 160px;\r\n        }\r\n    }\r\n\r\n    .profile-foreground-img-file-input {\r\n        display: none;\r\n    }\r\n\r\n    .profile-photo-edit {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n\r\n    [data-layout=\"horizontal\"]{\r\n        .profile-foreground{\r\n            margin-top: 0 !important;\r\n        }\r\n    }\r\n}","//\r\n// _sitemap.scss\r\n//\r\n\r\n.sitemap-content {\r\n    width: 100%;\r\n    max-width: 1142px;\r\n    margin: 0 auto;\r\n    padding: 0 20px;\r\n\r\n    * {\r\n        position: relative;\r\n    }\r\n}\r\n\r\n.sitemap-horizontal {\r\n    position: relative;\r\n\r\n    ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        list-style: none;\r\n\r\n        a {\r\n            display: block;\r\n            background: var(--#{$prefix}light);\r\n            border: 2px solid var(--#{$prefix}card-bg-custom);\r\n            box-shadow: $box-shadow;\r\n            font-size: $font-size-base;\r\n            height: 60px;\r\n            padding: 8px;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n\r\n            span {\r\n                display: -webkit-box;\r\n                -webkit-line-clamp: 2;\r\n                -webkit-box-orient: vertical;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.administration {\r\n    .director {\r\n        >li {\r\n            >a {\r\n                width: 50%;\r\n                margin: 0 auto 0px auto;\r\n                border-radius: 4px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .subdirector {\r\n        position: absolute;\r\n        width: 100%;\r\n\r\n        &::after {\r\n            content: \"\";\r\n            display: block;\r\n            width: 0;\r\n            height: 130px;\r\n            border-left: 2px dashed $border-color;\r\n            left: 45.45%;\r\n            position: relative;\r\n        }\r\n\r\n        >li {\r\n            &:first-child {\r\n                width: 18.59%;\r\n                height: 64px;\r\n                margin: 0 auto 92px auto;\r\n                padding-top: 25px;\r\n                border-bottom: 2px dashed $border-color;\r\n                z-index: 1;\r\n                float: right;\r\n                right: 27.2%;\r\n                border-left: 2px dashed $border-color;\r\n\r\n                a {\r\n                    width: 100%;\r\n                    left: 25px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n        .subdirector {\r\n            >li {\r\n                &:first-child {\r\n                    width: 40%;\r\n                    right: 10%;\r\n                    margin-right: 2px;\r\n                }\r\n            }\r\n\r\n            &::after {\r\n                left: 49.8%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.departments {\r\n    width: 100%;\r\n\r\n    >li {\r\n        &:first-child {\r\n            width: 18.59%;\r\n            height: 64px;\r\n            margin: 0 auto 92px auto;\r\n            padding-top: 25px;\r\n            border-bottom: 2px dashed $border-color;\r\n            z-index: 1;\r\n            float: left;\r\n            left: 27%;\r\n\r\n            a {\r\n                width: 100%;\r\n                right: 25px;\r\n            }\r\n        }\r\n\r\n        &:nth-child(2) {\r\n            margin-left: 0;\r\n            clear: left;\r\n\r\n            &.department {\r\n                &:before {\r\n                    border: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &::after {\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        width: 81.1%;\r\n        height: 22px;\r\n        border-top: 2px dashed $border-color;\r\n        border-right: 2px dashed $border-color;\r\n        border-left: 2px dashed $border-color;\r\n        margin: 0 auto;\r\n        top: 130px;\r\n        left: 9.1%\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n        >li {\r\n            &:first-child {\r\n                width: 40%;\r\n                left: 10%;\r\n                margin-left: 2px;\r\n            }\r\n        }\r\n\r\n        &::after {\r\n            border-right: none;\r\n            left: 0;\r\n            width: 50%;\r\n        }\r\n    }\r\n}\r\n\r\n.department {\r\n    border-left: 2px dashed $border-color;\r\n    float: left;\r\n    margin-left: 1.75%;\r\n    margin-bottom: 60px;\r\n    width: 18.25%;\r\n\r\n    &::before {\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        width: 0;\r\n        height: 22px;\r\n        border-left: 2px dashed $border-color;\r\n        z-index: 1;\r\n        top: -22px;\r\n        left: 50%;\r\n        margin-left: -4px;\r\n    }\r\n\r\n    >a {\r\n        margin: 0 0 -26px -4px;\r\n        z-index: 1;\r\n    }\r\n\r\n    ul {\r\n        margin-top: 0px;\r\n        margin-bottom: 0px;\r\n\r\n        li {\r\n            padding-left: 25px;\r\n            border-bottom: 2px dashed $border-color;\r\n            height: 80px;\r\n\r\n            a {\r\n                background: var(--#{$prefix}card-bg-custom);\r\n                margin-top: 48px;\r\n                position: absolute;\r\n                z-index: 1;\r\n                width: 90%;\r\n                height: 60px;\r\n                vertical-align: middle;\r\n                right: -1px;\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n\r\n    &:first-child {\r\n        margin-left: 0;\r\n        clear: left;\r\n    }\r\n\r\n    @media screen and (min-width: 768px) {\r\n        &:last-child:before {\r\n            border: none;\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n        float: none;\r\n        width: 100%;\r\n        margin-left: 0;\r\n\r\n        &::before {\r\n            content: \"\";\r\n            display: block;\r\n            position: absolute;\r\n            width: 0;\r\n            height: 60px;\r\n            border-left: 2px dashed $white;\r\n            z-index: 1;\r\n            top: -60px;\r\n            left: 0%;\r\n            margin-left: -4px;\r\n        }\r\n\r\n        &:nth-child(2) {\r\n            &::before {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n// sitemap\r\n\r\n.hori-sitemap {\r\n    ul {\r\n        padding: 0;\r\n        padding-top: 10px;\r\n        text-align: center;\r\n        li {\r\n            position: relative;\r\n        }\r\n        @media (max-width: 575.98px) {\r\n            text-align: left;\r\n            .parent-title {\r\n                a {\r\n                    padding-left: 0;\r\n                    &:after {\r\n                        display: none;\r\n                    }\r\n                }\r\n\r\n                &:before {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    @media (max-width: 575.98px) {\r\n        >ul {\r\n            position: relative;\r\n            li {\r\n                padding-top: 10px;\r\n                .second-list,\r\n                .sub-list {\r\n                    position: relative;\r\n\r\n                    &:before {\r\n                        content: \"\";\r\n                        height: calc(100% - 14px);\r\n                        border-right: 2px dashed $border-color;\r\n                        position: absolute;\r\n                        top: 0px;\r\n                        left: 0px;\r\n                    }\r\n                }\r\n                .sub-list {\r\n                    &:before {\r\n                        height: 38%;\r\n                    }\r\n                }\r\n                a {\r\n                    position: relative;\r\n                    padding: 4px 16px 4px 36px;\r\n\r\n                    &:after {\r\n                        content: \"\";\r\n                        width: 24px;\r\n                        border-top: 2px dashed $border-color;\r\n                        position: absolute;\r\n                        top: 50%;\r\n                        transform: translateY(-50%);\r\n                        left: 0;\r\n                    }\r\n                }\r\n\r\n                ul {\r\n                    margin-left: 36px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    @media (min-width: 576px) {\r\n        ul {\r\n            padding-top: 20px;\r\n            li {\r\n                padding-top: 30px;\r\n\r\n                &:before {\r\n                    content: \"\";\r\n                    height: 24px;\r\n                    width: 0;\r\n                    border-right: 2px dashed $border-color;\r\n                    position: absolute;\r\n                    top: 0;\r\n                    left: 0;\r\n                    right: 0;\r\n                    margin: 0px auto;\r\n                }\r\n\r\n                &:after {\r\n                    content: \"\";\r\n                    width: 100%;\r\n                    border-top: 2px dashed $border-color;\r\n                    position: absolute;\r\n                    top: 0;\r\n                    left: 50%;\r\n                }\r\n\r\n                &:last-of-type {\r\n                    &:after {\r\n                        display: none;\r\n                    }\r\n                }\r\n\r\n                &.parent-title {\r\n                    &::before {\r\n                        content: \"\";\r\n                        height: 23px;\r\n                        border-right: 2px dashed $border-color;\r\n                        position: absolute;\r\n                        top: 28px;\r\n                        left: 0;\r\n                    }\r\n                    &::after {\r\n                        border: none;\r\n                    }\r\n                }\r\n\r\n                .sub-title {\r\n                    position: relative;\r\n\r\n                    &::before {\r\n                        content: \"\";\r\n                        height: 21px;\r\n                        border-right: 2px dashed $border-color;\r\n                        position: absolute;\r\n                        top: 27px;\r\n                        left: 49%;\r\n                        margin: 0 auto;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    a {\r\n        color: var(--#{$prefix}body-color);\r\n        padding: 4px 0px;\r\n        display: block;\r\n\r\n    }\r\n}\r\n\r\n\r\n// vertical sitemap\r\n.verti-sitemap { \r\n    a {\r\n        color: var(--#{$prefix}body-color);\r\n        display: block;\r\n    }\r\n    .parent-title {\r\n        a {\r\n            padding-left: 0;\r\n\r\n            &:before {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        &:before {\r\n            display: none;\r\n        }\r\n    }\r\n    .first-list {\r\n        position: relative;\r\n        padding-top: 10px;\r\n        &:before {\r\n            content: \"\";\r\n            border-left: 2px dashed $border-color;\r\n            position: absolute;\r\n            top: 0;\r\n            height: 100%;\r\n            bottom: 0;\r\n            left: 0;\r\n        }\r\n        .list-wrap, li {\r\n            a {\r\n                position: relative;\r\n                padding: 10px 16px 4px 36px;\r\n                &::before {\r\n                    content: \"\";\r\n                    width: 24px;\r\n                    border-top: 2px dashed $border-color;\r\n                    position: absolute;\r\n                    top: 50%;\r\n                    transform: translateY(-50%);\r\n                    left: 0;\r\n                }\r\n            }\r\n        }\r\n        .second-list, .third-list {\r\n            margin-left: 42px;\r\n            \r\n        }\r\n\r\n        .third-list, .second-list {\r\n            position: relative;\r\n            li {\r\n                position: relative;\r\n                &:before {\r\n                    content: \"\";\r\n                    height: 100%;\r\n                    border-left: 2px dashed $border-color;\r\n                    position: absolute;\r\n                    top: 0;\r\n                    left: 0;\r\n                    margin: 0px auto;\r\n                }\r\n                &:last-child {\r\n                    &::before {\r\n                        height: 13px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n        \r\n        &:last-child {\r\n            &::before {\r\n                height: 25px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n","//\r\n// _team.scss\r\n//\r\n\r\n.team-box .team-cover, .profile-offcanvas .team-cover, .modal-team-cover{\r\n    display: none;\r\n    position: relative;\r\n    margin-bottom: -140px;\r\n\r\n    img {\r\n        height: 140px;\r\n        width: 100%;\r\n        object-fit: cover;\r\n    }\r\n\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 100%;\r\n        background: linear-gradient(to top, darken($primary, 25%), $primary);\r\n        opacity: 0.6;\r\n    }\r\n}\r\n\r\n.team-list {\r\n    &.grid-view-filter {\r\n        flex-flow: row wrap;\r\n\r\n        .col {\r\n            flex: 0 0 auto;\r\n            width: 25%;\r\n        }\r\n\r\n        .team-box {\r\n            overflow: hidden;\r\n\r\n            .team-row {\r\n                align-items: start;\r\n\r\n                .col {\r\n                    width: 100%;\r\n                }\r\n            }\r\n\r\n            .team-cover {\r\n                display: block;\r\n            }\r\n\r\n            .team-settings {\r\n                .col {\r\n                    width: 50% !important;\r\n                    flex: 0 0 auto;\r\n                }\r\n\r\n                .btn-star {\r\n                    color: $white;\r\n                }\r\n\r\n                .dropdown {>a {\r\n                        color: $white;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .team-profile-img {\r\n                display: flex;\r\n                flex-direction: column;\r\n                align-items: center;\r\n                margin-bottom: 25px;\r\n                margin-top: 36px;\r\n\r\n                .avatar-lg {\r\n                    font-size: 22px;\r\n                }\r\n\r\n                .team-content {\r\n                    margin-left: 0px;\r\n                    margin-top: 25px;\r\n                    text-align: center;\r\n                }\r\n            }\r\n\r\n            .view-btn {\r\n                width: 100%;\r\n                margin-top: 25px;\r\n            }\r\n        }\r\n\r\n        @media (min-width: 1200px) and (max-width: 1399.98px) {\r\n            .col {\r\n                flex: 0 0 auto;\r\n                width: 33.33%;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 1199.98px) {\r\n            .col {\r\n                flex: 0 0 auto;\r\n                width: 50%;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 767.98px) {\r\n            .col {\r\n                flex: 0 0 auto;\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.list-view-filter {\r\n        flex-direction: column;\r\n\r\n        .team-box {\r\n            margin-bottom: 10px;\r\n\r\n            .team-row {\r\n                align-items: center;\r\n                justify-content: space-between;\r\n            }\r\n\r\n            .team-profile-img {\r\n                display: flex;\r\n                align-items: center;\r\n\r\n                .avatar-lg {\r\n                    height: 4rem;\r\n                    width: 4rem;\r\n                    font-size: 16px;\r\n                }\r\n\r\n                .team-content {\r\n                    margin-left: 15px;\r\n                }\r\n            }\r\n\r\n            .team-settings {\r\n                width: auto;\r\n                flex: 0 0 auto;\r\n                -webkit-box-ordinal-group: 7;\r\n                order: 6;\r\n            }\r\n\r\n            .btn-star {\r\n                color: $primary;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 767.98px) {\r\n            flex-direction: row;\r\n            .col {\r\n                -webkit-box-flex: 0;\r\n                -ms-flex: 0 0 auto;\r\n                flex: 0 0 auto;\r\n                width: 100%;\r\n            }\r\n            .team-box {\r\n\r\n                .team-settings {\r\n                    width: 100%;\r\n                    flex: 0 0 auto;\r\n                    order: -1;\r\n                    margin-bottom: 10px;\r\n\r\n                    .col {\r\n                        width: 50%;\r\n                    }\r\n                }\r\n\r\n                .team-profile-img {\r\n                    margin-bottom: 25px;\r\n                }\r\n\r\n                .view-btn {\r\n                    width: 100%;\r\n                    margin-top: 25px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.modal-team-cover{\r\n    display: block;\r\n}\r\n\r\n.list-grid-nav {\r\n    .nav-link {\r\n        &.active {\r\n            background-color: $info;\r\n            color: $white;\r\n        }\r\n    }\r\n}\r\n\r\n.profile-offcanvas  {\r\n    .team-cover {\r\n        margin-bottom: -132px;\r\n        display: block;\r\n        z-index: -1;\r\n    }\r\n    .btn-star {\r\n        color: $white;\r\n    }\r\n\r\n    .dropdown {\r\n        >a {\r\n            color: $white;\r\n        }\r\n    }\r\n}","// \r\n// _coming-soon.scss\r\n//\r\n\r\n// countdownlist\r\n\r\n.countdownlist {\r\n    text-align: center;\r\n    display: flex;\r\n    gap: 24px;\r\n\r\n\r\n    .countdownlist-item{\r\n        width: 25%;\r\n        &:last-of-type{\r\n            .count-num{\r\n                &::after{\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .count-title{\r\n        font-size: 13px;\r\n        font-weight: $font-weight-medium;\r\n        display: block;\r\n        margin-bottom: 8px;\r\n        color: rgba(var(--#{$prefix}dark-rgb), 0.5);\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    .count-num{\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n        padding: 16px 8px;\r\n        position: relative;\r\n        border-radius: $card-border-radius;\r\n        box-shadow: $box-shadow;\r\n        font-weight: $font-weight-semibold;\r\n        font-size: 32px;\r\n        @media (max-width: 575.98px) {\r\n            font-size: 18px;\r\n        }\r\n    \r\n        &::after{\r\n            content: \":\";\r\n            font-size: 20px;\r\n            position: absolute;\r\n            right: -16px;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            color: var(--#{$prefix}dark);\r\n        }\r\n    }\r\n}\r\n// coming soon \r\n\r\n.move-animation{\r\n    animation: mover 1s infinite  alternate;\r\n}\r\n\r\n@keyframes mover {\r\n    0% { transform: translateY(0); }\r\n    100% { transform: translateY(-16px); }\r\n}\r\n\r\n.coming-soon-text{\r\n    font-weight: $font-weight-semibold;\r\n    text-transform: uppercase;\r\n    color: $white;\r\n    text-shadow: 3px 4px $success;\r\n}\r\n\r\n.countdown-input-group{\r\n    max-width: 400px;\r\n}\r\n","//\r\n// _search-results.scss\r\n//\r\n\r\n.search-more-results {\r\n    position: relative;\r\n    overflow: hidden;\r\n\r\n    .nav-icon {\r\n        font-size: 14px;\r\n        color: $white;\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        text-align: center;\r\n        left: 0;\r\n        right: 0;\r\n\r\n        i {\r\n            font-size: 20px;\r\n        }\r\n\r\n        @media (max-width: 767.98px) {\r\n            font-size: 14px;\r\n\r\n            i {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.video-list {\r\n    .list-element {\r\n        display: none;\r\n        &:nth-child(1) {\r\n            display: block;\r\n        }\r\n        &:nth-child(2) {\r\n            display: block;\r\n        }\r\n        &:nth-child(3) {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n.search-voice {\r\n    height: 120px;\r\n    width: 120px;\r\n    line-height: 120px;\r\n    margin: 0px auto;\r\n    text-align: center;\r\n    border-radius: 50%;\r\n    z-index: 1;\r\n    position: relative;\r\n\r\n    i {\r\n        line-height: 56px;\r\n        font-size: 30px;\r\n    }\r\n\r\n    .voice-wave {\r\n        position: absolute;\r\n        width: 120px;\r\n        height: 120px;\r\n        z-index: -1;\r\n        left: 0px;\r\n        right: 0px;\r\n        margin: 0px auto;\r\n        opacity: 0;\r\n        border-radius: 100px;\r\n        animation: voice-wave 1.8s infinite;\r\n        background-color: var(--#{$prefix}light);\r\n\r\n        &:nth-child(2) {\r\n            animation-delay: 0.3s;\r\n        }\r\n\r\n        &:nth-child(3) {\r\n            animation-delay: 0.6s;\r\n        }\r\n    }\r\n}\r\n\r\n@keyframes voice-wave {\r\n    0% {\r\n        opacity: 1;\r\n        transform: scale(0);\r\n    }\r\n\r\n    100% {\r\n        opacity: 0;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n.images-menu {\r\n    .swiper-slide {\r\n        width: auto;\r\n        display: inline-block;\r\n    }\r\n}","//\r\n// _ecommerce.scss\r\n//\r\n\r\n// product list\r\n\r\n#selection-element { \r\n    display: none;\r\n}\r\n\r\n.filter-choices-input{\r\n    .choices__inner{\r\n        padding: 0;\r\n        border: none;\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n    }\r\n\r\n    .choices__input{\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n    }\r\n}\r\n\r\n//  product detail\r\n\r\n.sticky-side-div{\r\n    @media (min-width: 992px){\r\n        position: sticky;\r\n        top: calc(#{$header-height} + #{$grid-gutter-width});\r\n    }\r\n}\r\n\r\n.product-img-slider{\r\n    .product-nav-slider{\r\n        .nav-slide-item{\r\n            border: 1px solid $border-color;\r\n            border-radius: $border-radius;\r\n            padding: 0.5rem;\r\n            cursor: pointer;\r\n        }\r\n\r\n        .swiper-slide-thumb-active{\r\n            .nav-slide-item{\r\n                background-color: var(--#{$prefix}light);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.filter-list{\r\n    a {\r\n        &.active {\r\n            .listname {\r\n                color: $success;\r\n            }\r\n        }   \r\n    }\r\n}","//\r\n// _invoice.scss\r\n//\r\n\r\n.invoice-table {\r\n    tbody {\r\n        &:last-child {\r\n            border: none;\r\n        }\r\n    }\r\n}\r\n\r\n.currency-select {\r\n    .choices__inner {\r\n        padding:0px;\r\n        padding-right: 15px;\r\n        min-height: 0px;\r\n    }\r\n    .choices__list--single {\r\n        padding: 0px 16px 0 4px;\r\n    }\r\n    .choices[data-type*=select-one]{\r\n        bottom: 0px;\r\n        :after { \r\n            top: 4px;\r\n        }\r\n        .choices__inner {\r\n            padding-bottom: 0px;\r\n        }\r\n    }\r\n}","//\r\n// _chat.scss\r\n//\r\n\r\n.chat-wrapper {\r\n  position: relative;\r\n  overflow-x: hidden;\r\n}\r\n\r\n// chat left sidebar\r\n\r\n.chat-leftsidebar {\r\n  height: calc(100vh - 137px);\r\n  position: relative;\r\n  background-color: var(--#{$prefix}card-bg-custom);\r\n\r\n  @media (min-width: 992px) {\r\n    min-width: 300px;\r\n    max-width: 300px;\r\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\r\n  }\r\n}\r\n\r\n.chat-list {\r\n  margin: 0;\r\n\r\n  > li {\r\n    &.active {\r\n      a {\r\n        background-color: $chat-secondary-bg;\r\n        color: $chat-secondary-color;\r\n\r\n        .badge {\r\n          background-color: rgba(var(--#{$prefix}success-rgb), 0.15) !important;\r\n          color: $success !important;\r\n        }\r\n      }\r\n    }\r\n\r\n    a {\r\n      display: block;\r\n      padding: 7px 24px;\r\n      color: var(--#{$prefix}body-color);\r\n      transition: all 0.4s;\r\n      font-family: $font-family-secondary;\r\n      font-weight: $font-weight-medium;\r\n      font-size: $font-size-base;\r\n    }\r\n\r\n    .chat-user-message {\r\n      font-size: 14px;\r\n    }\r\n\r\n    .unread-msg-user {\r\n      font-weight: $font-weight-semibold;\r\n    }\r\n\r\n    .unread-message {\r\n      position: absolute;\r\n      display: inline-block;\r\n      right: 24px /*rtl:auto*/;\r\n      left: auto /*rtl:0*/;\r\n      top: 33px;\r\n\r\n      .badge {\r\n        line-height: 16px;\r\n        font-weight: $font-weight-semibold;\r\n        font-size: 10px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.chat-user-img {\r\n  position: relative;\r\n\r\n  .user-status {\r\n    width: 10px;\r\n    height: 10px;\r\n    background-color: $gray-500;\r\n    border-radius: 50%;\r\n    border: 2px solid var(--#{$prefix}card-bg-custom);\r\n    position: absolute;\r\n    right: 0;\r\n    left: auto;\r\n    bottom: 0;\r\n  }\r\n\r\n  &.online {\r\n    .user-status {\r\n      background-color: $success;\r\n    }\r\n  }\r\n\r\n  &.away {\r\n    .user-status {\r\n      background-color: $warning;\r\n    }\r\n  }\r\n}\r\n\r\n.chat-room-list {\r\n  max-height: calc(100vh - 296px);\r\n\r\n  @media (max-width: 991.98px) {\r\n    height: calc(100vh - 296px);\r\n  }\r\n}\r\n\r\n// contact list\r\n\r\n.contact-list {\r\n  li {\r\n    cursor: pointer;\r\n    padding: 8px 24px;\r\n    transition: all 0.4s;\r\n    color: var(--#{$prefix}body-color);\r\n    font-family: $font-family-secondary;\r\n    font-weight: $font-weight-medium;\r\n    font-size: $font-size-base;\r\n  }\r\n}\r\n\r\n.contact-list-title {\r\n  padding: 6px 24px;\r\n  color: $primary;\r\n  font-weight: $font-weight-medium;\r\n  position: relative;\r\n  font-size: 12px;\r\n  &:after {\r\n    content: \"\";\r\n    height: 1px;\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    left: 50px;\r\n    right: 0;\r\n    background-color: var(--#{$prefix}light);\r\n  }\r\n}\r\n\r\n// user chat\r\n\r\n.user-chat {\r\n  background: url(\"../../images/chat-bg-pattern.png\");\r\n  transition: all 0.4s;\r\n  position: relative;\r\n  background-color: var(--#{$prefix}body-bg);\r\n\r\n  @media (max-width: 991.98px) {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 3px;\r\n    width: 100%;\r\n    height: calc(100% - 3px);\r\n    visibility: hidden;\r\n    transform: translateX(100%);\r\n    z-index: 99;\r\n    padding-top: 70px;\r\n\r\n    &.user-chat-show {\r\n      visibility: visible;\r\n      transform: translateX(0);\r\n    }\r\n  }\r\n\r\n  .chat-content {\r\n    position: relative;\r\n  }\r\n\r\n  &.user-chat-show {\r\n    .chat-welcome-section {\r\n      display: none;\r\n    }\r\n    .chat-content {\r\n      @media (min-width: 992px) {\r\n        display: flex !important;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.user-chat-topbar {\r\n  border-bottom: 1px solid transparent;\r\n  background-color: var(--#{$prefix}card-bg-custom);\r\n  @media (max-width: 991.98px) {\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    z-index: 1;\r\n  }\r\n}\r\n\r\n.user-chat-nav {\r\n  .nav-btn {\r\n    height: 40px;\r\n    width: 40px;\r\n    line-height: 40px;\r\n    box-shadow: none;\r\n    padding: 0;\r\n    font-size: 20px;\r\n    color: $gray-800;\r\n  }\r\n  @media (max-width: 575.98px) {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n  }\r\n}\r\n\r\n.chat-conversation {\r\n  height: calc(100vh - 299px) !important;\r\n  @media (max-width: 991.98px) {\r\n    height: calc(100vh - 275px) !important;\r\n  }\r\n\r\n  .simplebar-content-wrapper {\r\n    display: flex;\r\n    flex-direction: column;\r\n\r\n    .simplebar-content {\r\n      margin-top: auto;\r\n    }\r\n  }\r\n\r\n  .chat-conversation-list {\r\n    padding-top: 10px;\r\n    margin-bottom: 0;\r\n    > li {\r\n      display: flex;\r\n    }\r\n  }\r\n\r\n  li {\r\n    &:last-of-type {\r\n      .conversation-list {\r\n        margin-bottom: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  .chat-list {\r\n    &.left {\r\n      .check-message-icon {\r\n        display: none;\r\n      }\r\n    }\r\n    .message-box-drop {\r\n      visibility: hidden;\r\n    }\r\n\r\n    &:hover {\r\n      .message-box-drop {\r\n        visibility: visible;\r\n      }\r\n    }\r\n  }\r\n\r\n  .chat-avatar {\r\n    margin: 0 16px 0 0 /*rtl:0 0 0 16px*/;\r\n\r\n    img {\r\n      width: 28px;\r\n      height: 28px;\r\n      border-radius: 50%;\r\n    }\r\n  }\r\n\r\n  .chat-day-title {\r\n    position: relative;\r\n    text-align: center;\r\n    margin-bottom: 24px;\r\n    margin-top: 12px;\r\n    width: 100%;\r\n\r\n    .title {\r\n      background-color: $white;\r\n      position: relative;\r\n      font-size: 13px;\r\n      z-index: 1;\r\n      padding: 6px 12px;\r\n      border-radius: 5px;\r\n    }\r\n\r\n    &:before {\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 100%;\r\n      height: 1px;\r\n      left: 0;\r\n      right: 0;\r\n      background-color: rgba($primary, 0.2);\r\n      top: 10px;\r\n    }\r\n\r\n    .badge {\r\n      font-size: 12px;\r\n    }\r\n  }\r\n\r\n  .conversation-list {\r\n    margin-bottom: 24px;\r\n    display: inline-flex;\r\n    position: relative;\r\n    align-items: flex-end;\r\n    max-width: 80%;\r\n\r\n    @media (max-width: 575.98px) {\r\n      max-width: 90%;\r\n    }\r\n\r\n    .ctext-wrap {\r\n      display: flex;\r\n      margin-bottom: 10px;\r\n    }\r\n\r\n    .ctext-content {\r\n      word-wrap: break-word;\r\n      word-break: break-word;\r\n    }\r\n\r\n    .ctext-wrap-content {\r\n      padding: 12px 20px;\r\n      background-color: $chat-primary-bg;\r\n      position: relative;\r\n      border-radius: 3px;\r\n      box-shadow: $box-shadow-lg;\r\n\r\n      .attached-file {\r\n        @media (max-width: 575.98px) {\r\n          .attached-file-avatar {\r\n            display: none;\r\n          }\r\n\r\n          .dropdown .dropdown-toggle {\r\n            display: block;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    .conversation-name {\r\n      font-weight: $font-weight-medium;\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      align-items: center;\r\n      gap: 8px;\r\n    }\r\n\r\n    .dropdown {\r\n      .dropdown-toggle {\r\n        font-size: 18px;\r\n        padding: 4px;\r\n        color: $gray-600;\r\n        &::after {\r\n          display: none;\r\n        }\r\n\r\n        @media (max-width: 575.98px) {\r\n          display: none;\r\n        }\r\n      }\r\n    }\r\n\r\n    .chat-time {\r\n      font-size: 12px;\r\n      margin-top: 4px;\r\n      text-align: right;\r\n    }\r\n\r\n    .message-img {\r\n      border-radius: 0.2rem;\r\n      position: relative;\r\n      display: flex;\r\n      flex-wrap: wrap;\r\n      gap: 8px;\r\n\r\n      .message-img-list {\r\n        position: relative;\r\n      }\r\n\r\n      img {\r\n        max-width: 150px;\r\n      }\r\n\r\n      .message-img-link {\r\n        position: absolute;\r\n        right: 10px /*rtl:auto*/;\r\n        left: auto /*rtl:0*/;\r\n        bottom: 10px;\r\n\r\n        li {\r\n          > a {\r\n            font-size: 18px;\r\n            color: $white;\r\n            display: inline-block;\r\n            line-height: 20px;\r\n            width: 26px;\r\n            height: 24px;\r\n            border-radius: 3px;\r\n            background-color: rgba($dark, 0.7);\r\n            text-align: center;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .right {\r\n    justify-content: flex-end;\r\n\r\n    .chat-avatar {\r\n      order: 3;\r\n      margin-right: 0px;\r\n      margin-left: 16px;\r\n    }\r\n\r\n    .chat-time {\r\n      text-align: left;\r\n      color: $gray-600;\r\n    }\r\n\r\n    .conversation-list {\r\n      text-align: right;\r\n\r\n      .ctext-wrap {\r\n        justify-content: flex-end;\r\n\r\n        .ctext-wrap-content {\r\n          order: 2;\r\n          background-color: $chat-secondary-bg;\r\n          color: $chat-secondary-color;\r\n          text-align: right;\r\n          box-shadow: $element-shadow;\r\n\r\n          .replymessage-block {\r\n            background-color: rgba($white, 0.5);\r\n            border-color: rgba(var(--vz-success-rgb), 1);\r\n            color: $body-color;\r\n\r\n            .conversation-name {\r\n              color: rgba(var(--vz-success-rgb), 1);\r\n            }\r\n          }\r\n        }\r\n      }\r\n\r\n      .conversation-name {\r\n        justify-content: flex-end;\r\n\r\n        .check-message-icon {\r\n          order: 1;\r\n        }\r\n\r\n        .time {\r\n          order: 2;\r\n        }\r\n\r\n        .name {\r\n          order: 3;\r\n        }\r\n      }\r\n\r\n      .dropdown {\r\n        order: 1;\r\n      }\r\n    }\r\n\r\n    .dot {\r\n      background-color: $dark;\r\n    }\r\n  }\r\n}\r\n\r\n.chat-input-section {\r\n  border-top: 1px solid transparent;\r\n  background-color: var(--#{$prefix}card-bg-custom);\r\n  position: relative;\r\n  z-index: 1;\r\n\r\n  .chat-input-feedback {\r\n    display: none;\r\n    position: absolute;\r\n    top: -20px;\r\n    left: 4px;\r\n    font-size: 12px;\r\n    color: $danger;\r\n  }\r\n  .show {\r\n    display: block;\r\n  }\r\n}\r\n\r\n.chat-input-links {\r\n  display: flex;\r\n  .links-list-item {\r\n    > .btn {\r\n      box-shadow: none;\r\n      padding: 0;\r\n      font-size: 20px;\r\n      width: 37.5px;\r\n      height: 37.5px;\r\n      &.btn-link {\r\n        color: $gray-600;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n//Copy Message Alert\r\n.copyclipboard-alert {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  display: none;\r\n}\r\n\r\n.replyCard {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  border-top: 1px solid $border-color;\r\n  overflow: hidden;\r\n  opacity: 0;\r\n  bottom: 0;\r\n  border-radius: 0;\r\n  transition: all 0.4s;\r\n\r\n  @media (max-width: 991.98px) {\r\n    bottom: -12px;\r\n  }\r\n\r\n  &.show {\r\n    transform: translateY(-88px);\r\n    opacity: 1;\r\n\r\n    @media (max-width: 991.98px) {\r\n      transform: translateY(-83px);\r\n    }\r\n  }\r\n}\r\n\r\n.replymessage-block {\r\n  padding: 12px 20px;\r\n  margin-bottom: 8px;\r\n  text-align: left;\r\n  border-radius: 4px;\r\n  background-color: rgba(var(--vz-success-rgb), 0.1);\r\n  border-left: 2px solid rgba(var(--vz-success-rgb), 1);\r\n\r\n  .conversation-name {\r\n    color: rgba(var(--vz-success-rgb), 1);\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n// Chat Small\r\n.chat-sm {\r\n  .ctext-wrap-content {\r\n    box-shadow: none !important;\r\n  }\r\n\r\n  .message-img {\r\n    img {\r\n      max-width: 90px !important;\r\n    }\r\n  }\r\n\r\n  .message-img-link {\r\n    bottom: 0 !important;\r\n    right: 5px !important;\r\n  }\r\n}\r\n\r\n// for horizontal layout\r\n[data-layout=\"horizontal\"] {\r\n  .chat-wrapper {\r\n    @media (min-width: 1025px) {\r\n      margin-left: 0 !important;\r\n      margin-right: 0 !important;\r\n    }\r\n    @media (max-width: 991.98px) {\r\n      margin-top: 0 !important;\r\n    }\r\n  }\r\n\r\n  .chat-leftsidebar {\r\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 54px);\r\n    @media (max-width: 991.98px) {\r\n      height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\r\n    }\r\n  }\r\n\r\n  .chat-room-list {\r\n    height: calc(100vh - 352px);\r\n    @media (max-width: 991.98px) {\r\n      height: calc(100vh - 265px);\r\n    }\r\n  }\r\n\r\n  .chat-conversation {\r\n    height: calc(100vh - 343px) !important;\r\n    @media (max-width: 991.98px) {\r\n      height: calc(100vh - 275px) !important;\r\n    }\r\n  }\r\n}\r\n","//\r\n// _email.scss\r\n//\r\n\r\n.email-wrapper {\r\n  position: relative;\r\n  overflow-x: hidden;\r\n}\r\n\r\n// chat left sidebar\r\n\r\n.email-menu-sidebar {\r\n  height: calc(100vh - 137px);\r\n  position: relative;\r\n  background-color: var(--#{$prefix}card-bg-custom);\r\n  transition: all 0.2s;\r\n\r\n  @media (min-width: 992px) {\r\n    min-width: 250px;\r\n    max-width: 250px;\r\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\r\n  }\r\n\r\n  @media (max-width: 991.98px) {\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 200px;\r\n    max-width: 100%;\r\n    z-index: 1003;\r\n    box-shadow: $box-shadow-lg;\r\n    transform: translateX(-100%);\r\n    visibility: hidden;\r\n    height: 100vh;\r\n\r\n    &.menubar-show {\r\n      visibility: visible;\r\n      transform: none;\r\n    }\r\n  }\r\n\r\n  .email-menu-sidebar-scroll {\r\n    height: calc(100vh - 295px);\r\n\r\n    @media (max-width: 991.98px) {\r\n      height: calc(100vh - 150px);\r\n    }\r\n  }\r\n}\r\n\r\n.mail-list {\r\n  a {\r\n    display: flex;\r\n    align-items: center;\r\n    color: $gray-600;\r\n    padding: 5px 0;\r\n    font-weight: $font-weight-medium;\r\n\r\n    &:hover {\r\n      color: $primary;\r\n    }\r\n\r\n    i {\r\n      font-size: 14px;\r\n    }\r\n\r\n    &.active {\r\n      color: $success;\r\n      font-weight: $font-weight-semibold;\r\n\r\n      i {\r\n        color: $success;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.email-chat-list {\r\n  a {\r\n    padding: 6px 24px;\r\n    &.active {\r\n      background-color: rgba(var(--#{$prefix}light-rgb), 0.7);\r\n    }\r\n  }\r\n}\r\n.email-topbar-link {\r\n  .btn-ghost-secondary {\r\n    color: $text-muted;\r\n\r\n    &:hover {\r\n      color: $secondary;\r\n    }\r\n  }\r\n}\r\n\r\n.email-content {\r\n  width: 100%;\r\n  background-color: var(--#{$prefix}card-bg-custom);\r\n  transition: all 0.2s;\r\n}\r\n\r\n.unreadConversations-alert {\r\n  position: fixed;\r\n  bottom: $footer-height;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 1;\r\n}\r\n\r\n.email-detail-content {\r\n  position: absolute;\r\n  top: 4px;\r\n  bottom: 4px;\r\n  left: 68%;\r\n  width: 32%;\r\n  background-color: var(--#{$prefix}card-bg-custom);\r\n  transform: translateX(200%);\r\n  transition: all 0.2s;\r\n  visibility: hidden;\r\n  border-left: 2px solid var(--#{$prefix}body-bg);\r\n}\r\n\r\n.email-detail-show {\r\n  .email-detail-content {\r\n    transform: none;\r\n    visibility: visible;\r\n  }\r\n\r\n  .email-content {\r\n    margin-right: 32%;\r\n\r\n    @media (max-width: 1349.98px) {\r\n      margin-right: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.email-detail-content-scroll {\r\n  height: calc(100vh - 390px);\r\n\r\n  @media (max-width: 1349.98px) {\r\n    height: calc(100vh - 252px);\r\n  }\r\n}\r\n\r\n.message-list-content {\r\n  height: calc(100vh - 242px);\r\n\r\n  @media (max-width: 575.98px) {\r\n    height: calc(100vh - 230px);\r\n  }\r\n}\r\n\r\n.message-list {\r\n  display: block;\r\n  padding-left: 0;\r\n  margin: 0;\r\n\r\n  li {\r\n    position: relative;\r\n    display: block;\r\n    height: 50px;\r\n    line-height: 50px;\r\n    cursor: default;\r\n    transition-duration: 0.3s;\r\n    clear: both;\r\n\r\n    a {\r\n      color: var(--#{$prefix}gray-700);\r\n    }\r\n\r\n    &:hover {\r\n      background: var(--#{$prefix}light);\r\n      transition-duration: 0.05s;\r\n    }\r\n\r\n    .col-mail {\r\n      float: left;\r\n      position: relative;\r\n    }\r\n\r\n    .col-mail-1 {\r\n      width: 280px;\r\n\r\n      .star-toggle,\r\n      .checkbox-wrapper-mail,\r\n      .dot {\r\n        display: block;\r\n        float: left;\r\n      }\r\n\r\n      .dot {\r\n        border: 4px solid transparent;\r\n        border-radius: 100px;\r\n        margin: 22px 26px 0;\r\n        height: 0;\r\n        width: 0;\r\n        line-height: 0;\r\n        font-size: 0;\r\n      }\r\n\r\n      .checkbox-wrapper-mail {\r\n        margin: 15px 0 0 20px;\r\n        line-height: normal;\r\n      }\r\n\r\n      .star-toggle {\r\n        margin-top: 18px;\r\n        margin-left: 5px;\r\n      }\r\n\r\n      .title {\r\n        position: absolute;\r\n        top: 0;\r\n        left: 95px;\r\n        right: 0;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n        margin-bottom: 0;\r\n\r\n        @media (max-width: 575.98px) {\r\n          left: 95px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .col-mail-2 {\r\n      position: absolute;\r\n      top: 0;\r\n      left: 280px;\r\n      right: 0;\r\n      bottom: 0;\r\n\r\n      .subject,\r\n      .date {\r\n        position: absolute;\r\n        top: 0;\r\n      }\r\n\r\n      .subject {\r\n        left: 0;\r\n        right: 110px;\r\n        text-overflow: ellipsis;\r\n        overflow: hidden;\r\n        white-space: nowrap;\r\n\r\n        .teaser {\r\n          color: var(--#{$prefix}gray-600);\r\n        }\r\n      }\r\n\r\n      .date {\r\n        right: 0;\r\n        width: 100px;\r\n        padding-left: 20px;\r\n      }\r\n    }\r\n\r\n    &.active,\r\n    &.active:hover {\r\n      box-shadow: inset 3px 0 0 $primary;\r\n      background-color: var(--#{$prefix}light);\r\n    }\r\n\r\n    &.unread {\r\n      color: var(--#{$prefix}gray-800);\r\n\r\n      a {\r\n        color: var(--#{$prefix}gray-800);\r\n        font-weight: $font-weight-semibold;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n#unreadConversations,\r\n#email-topbar-actions {\r\n  display: none;\r\n}\r\n\r\n#elmLoader {\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n}\r\n\r\n.email-compose-input {\r\n  padding-right: 80px;\r\n}\r\n\r\n@media (max-width: 1349.98px) {\r\n  .email-detail-content {\r\n    position: fixed;\r\n    top: 0;\r\n    bottom: 0;\r\n    left: auto;\r\n    right: 0;\r\n    width: 400px;\r\n    max-width: 100%;\r\n    z-index: 1003;\r\n    box-shadow: $box-shadow-lg;\r\n    transform: translateX(100%);\r\n  }\r\n\r\n  .email-detail-show {\r\n    .email-detail-content {\r\n      transform: none;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n  .message-list li .col-mail-1 {\r\n    width: 180px;\r\n  }\r\n}\r\n\r\n.email-editor {\r\n  .ck-editor__editable_inline {\r\n    min-height: 200px !important;\r\n  }\r\n}\r\n\r\n.email-chat-detail {\r\n  width: 350px;\r\n  position: fixed;\r\n  max-width: 100%;\r\n  bottom: $footer-height;\r\n  right: $footer-height;\r\n  z-index: 9;\r\n  display: none;\r\n  .card {\r\n    box-shadow: $box-shadow-lg;\r\n  }\r\n\r\n  @media (max-width: 515.98px) {\r\n    left: 16px;\r\n    right: 16px;\r\n  }\r\n}\r\n\r\n// for horizontal layout\r\n[data-layout=\"horizontal\"] {\r\n  .email-wrapper {\r\n    @media (min-width: 1025px) {\r\n      margin-left: 0 !important;\r\n      margin-right: 0 !important;\r\n    }\r\n    @media (max-width: 991.98px) {\r\n      margin-top: 0 !important;\r\n    }\r\n  }\r\n\r\n  .email-menu-sidebar {\r\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 54px);\r\n    @media (max-width: 991.98px) {\r\n      height: 100vh;\r\n    }\r\n    .email-menu-sidebar-scroll {\r\n      height: calc(100vh - 330px);\r\n      @media (max-width: 991.98px) {\r\n        height: calc(100vh - 150px);\r\n      }\r\n    }\r\n  }\r\n\r\n  .message-list-content {\r\n    height: calc(100vh - 289px);\r\n  }\r\n\r\n  .email-detail-content-scroll {\r\n    height: calc(100vh - 435px);\r\n    @media (max-width: 1349.98px) {\r\n      height: calc(100vh - 252px);\r\n    }\r\n  }\r\n}\r\n\r\n.email-chat-element {\r\n  .chat-conversation1 {\r\n    height: 250px !important;\r\n  }\r\n}\r\n","//\r\n// _kanban.scss\r\n//\r\n\r\n.tasks-board {\r\n    display: flex;\r\n    overflow-x: auto;\r\n    align-items: stretch;\r\n\r\n    .tasks-list {\r\n        min-width: 300px;\r\n        margin-right: 24px;\r\n    }\r\n\r\n    &::-webkit-scrollbar {\r\n        -webkit-appearance: none;\r\n    }\r\n\r\n    &::-webkit-scrollbar:vertical {\r\n        width: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar:horizontal {\r\n        height: 8px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\r\n        border-radius: 8px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n        border-radius: 8px;\r\n    }\r\n}\r\n\r\n.tasks-box {\r\n    .progress {\r\n        border-radius: 0px 0px $card-border-radius $card-border-radius;\r\n    }\r\n\r\n    .tasks-img {\r\n        height: 135px;\r\n        width: 100%;\r\n        object-fit: cover;\r\n        object-position: center;\r\n        margin: 12px 0px;\r\n    }\r\n\r\n    &:last-child {\r\n        margin-bottom: 0px;\r\n    }\r\n}\r\n\r\n.tasks-wrapper {\r\n    max-height: calc(100vh - 418px);\r\n}\r\n\r\n\r\n.tasks {\r\n    min-height: 180px;\r\n    position: relative;\r\n\r\n    &.noTask{\r\n        &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        height: 180px;\r\n        width: 270px;\r\n        margin: 0 auto;\r\n        background-image: url('../../images/file.png');\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n    }\r\n}\r\n\r\n#tasksList {\r\n    tr {\r\n        .tasks-list-menu {\r\n            opacity: 0;\r\n        }\r\n\r\n        &:hover {\r\n            .tasks-list-menu {\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// _landing.scss\r\n//\r\n\r\n.layout-wrapper {\r\n    &.landing {\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n        font-size: 15px;\r\n    }\r\n}\r\n\r\n// helper\r\n\r\n.section {\r\n    padding: 90px 0;\r\n    position: relative;\r\n\r\n    @media (max-width:767.98px) {\r\n        padding: 50px 0;\r\n    }\r\n}\r\n\r\n.icon-effect {\r\n    position: relative;\r\n\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        width: 24px;\r\n        height: 24px;\r\n        background-color: rgba($success, 0.2);\r\n        border-radius: 50%;\r\n        bottom: 0;\r\n        left: 0;\r\n    }\r\n}\r\n\r\n// navbar\r\n\r\n.navbar-landing {\r\n    padding: 10px 0px;\r\n    transition: all 0.5s ease;\r\n    @media (max-width: 991.98px) {\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n        box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\r\n        padding: 10px 8px;\r\n    }\r\n\r\n    .navbar-nav {\r\n        .nav-item {\r\n            .nav-link {\r\n                font-size: 16px;\r\n                font-weight: $font-weight-medium;\r\n                transition: all 0.4s;\r\n                font-family: $font-family-secondary;\r\n                color: var(--#{$prefix}dark);\r\n                padding: 14px;\r\n\r\n                @media (max-width: 991.98px) {\r\n                    padding: 8px 0px;\r\n                }\r\n\r\n                &:hover,\r\n                &.active,\r\n                &:focus {\r\n                    color: $success !important;\r\n                }\r\n            }\r\n            &.active {\r\n                .nav-link {\r\n                    color: $success !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.is-sticky {\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n        box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\r\n    }\r\n}\r\n\r\n//navbar-light\r\n.navbar-light{\r\n    .navbar-brand {\r\n        .card-logo-dark {\r\n            display: none;\r\n        }\r\n    \r\n        .card-logo-light {\r\n            display: block;\r\n        }\r\n    }\r\n    .navbar-nav {\r\n        .nav-item {\r\n            .nav-link {\r\n                color: rgba(var(--#{$prefix}white-rgb), 0.75);\r\n            }\r\n        }\r\n    }\r\n    &.is-sticky {\r\n        .navbar-nav {\r\n            .nav-item {\r\n                .nav-link {\r\n                    color: var(--#{$prefix}dark);\r\n                }\r\n            }\r\n        }\r\n        .navbar-brand {\r\n            .card-logo-dark {\r\n                display: block;\r\n            }\r\n        \r\n            .card-logo-light {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// hero section\r\n\r\n.hero-section {\r\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.5);\r\n\r\n    .hero-shape-svg {\r\n        svg {\r\n            path {\r\n                fill: var(--#{$prefix}card-bg-custom);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.bg-overlay-pattern {\r\n    background-image: url(\"../../images/landing/bg-pattern.png\");\r\n    background-color: transparent;\r\n    background-position: center;\r\n    background-size: cover;\r\n    opacity: 0.2;\r\n}\r\n\r\n.demo-carousel {\r\n    position: relative;\r\n    z-index: 1;\r\n\r\n    .carousel-item {\r\n        .demo-item {\r\n            background-color: var(--#{$prefix}card-bg-custom);\r\n            padding: 8px;\r\n            border-radius: 7px;\r\n        }\r\n    }\r\n\r\n    .demo-img-patten-top {\r\n        position: absolute;\r\n        right: -50px;\r\n        top: -16px;\r\n        max-width: 230px;\r\n    }\r\n\r\n    .demo-img-patten-bottom {\r\n        position: absolute;\r\n        left: -70px;\r\n        bottom: -50px;\r\n        max-width: 230px;\r\n    }\r\n}\r\n\r\n// client images\r\n.client-images img {\r\n    max-height: 45px;\r\n    width: auto;\r\n    margin: 12px auto;\r\n    transition: all .4s;\r\n}\r\n\r\n// plan\r\n\r\n.plan-box {\r\n    max-width: 356px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n// work process\r\n.process-card {\r\n    position: relative;\r\n\r\n    .process-arrow-img {\r\n        position: absolute;\r\n        left: 75%;\r\n        top: 7%;\r\n        width: 50%;\r\n        opacity: .1;\r\n    }\r\n}\r\n\r\n.custom-footer {\r\n    color: #9ba7b3;\r\n}\r\n\r\n.footer-list {\r\n    li {\r\n        a {\r\n            color: #9ba7b3;\r\n            padding: 7px 0;\r\n            display: block;\r\n            transition: all 0.3s ease-in-out;\r\n\r\n            &:hover {\r\n                color: rgba($white, 0.9);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.footer-social-link {\r\n    .avatar-title {\r\n        color: #778089;\r\n        background-color: rgba($white, 0.05);\r\n        transition: all 0.3s ease;\r\n\r\n        &:hover {\r\n            color: $white;\r\n            background-color: $primary;\r\n        }\r\n    }\r\n}\r\n\r\n#back-to-top {\r\n    &.landing-back-top {\r\n        bottom: 35px;\r\n    }\r\n}\r\n\r\n// dark\r\n\r\n[data-layout-mode=\"dark\"] {\r\n    .layout-wrapper.landing {\r\n\r\n        .demo-img-patten-top,\r\n        .demo-img-patten-bottom {\r\n            opacity: .2;\r\n        }\r\n\r\n        footer.bg-dark {\r\n            background-color: var(--#{$prefix}card-bg-custom) !important;\r\n        }\r\n    }\r\n\r\n    //navbar-light\r\n    .navbar-light{\r\n        &.is-sticky { \r\n            .navbar-brand {\r\n                .card-logo-dark {\r\n                    display: none;\r\n                }\r\n        \r\n                .card-logo-light {\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// _nft-landing.scss\r\n//\r\n\r\n.bookmark-icon {\r\n    .btn {\r\n        color: $text-muted;\r\n        background-color: var(--#{$prefix}light);\r\n        box-shadow: $box-shadow;\r\n        font-size: $font-size-base;\r\n        &:hover,\r\n        &.active {\r\n            border-color: transparent;\r\n            color: $danger;\r\n        }\r\n    }\r\n}\r\n\r\n.explore-box {\r\n    border-radius: 9px;\r\n    overflow: hidden;\r\n    .explore-img {\r\n        height: 280px;\r\n        object-fit: cover;\r\n    }\r\n    .explore-place-bid-img {\r\n        position: relative;\r\n        overflow: hidden;\r\n        z-index: 0;\r\n        .bg-overlay {\r\n            position: absolute;\r\n            right: 0;\r\n            left: 0;\r\n            top: 0;\r\n            bottom: 0;\r\n            background-color: rgba($dark, 0.4);\r\n            opacity: 0;\r\n            transition: all 0.5s ease;\r\n        }\r\n    \r\n        .place-bid-btn {\r\n            top: 50%;\r\n            position: absolute;\r\n            left: 50%;\r\n            transform: translate(-50%, -50%);\r\n    \r\n            .btn {\r\n                opacity: 0;\r\n                bottom: -25px;\r\n                transition: 0.5s ease;\r\n            }\r\n        }\r\n    }\r\n    \r\n    &:hover {\r\n        .explore-place-bid-img {\r\n            .place-bid-btn {\r\n                .btn {\r\n                    opacity: 1;\r\n                    bottom: 0;\r\n                }\r\n            }\r\n    \r\n            .bg-overlay {\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n    .discount-time {\r\n        position: absolute;\r\n        bottom: 0;\r\n        left: 0;\r\n        right: 0;\r\n        text-align: center;\r\n        background-color: rgba($white, 0.4);\r\n        backdrop-filter: blur(5px);\r\n        padding: 8px;\r\n    }\r\n}\r\n\r\n//\r\n.nft-hero {\r\n    // background-image: url('../../images/nft/bg-home.jpg');\r\n    background-size: cover;\r\n    background-position: bottom;\r\n    padding: 222px 0 150px 0;\r\n    .bg-overlay {\r\n        background-color: #05175f;\r\n        opacity: 0.85;\r\n    }\r\n}\r\n\r\n#explorecard-list {\r\n    .list-element {\r\n        display: none;\r\n\r\n        &:nth-child(-n+10) {\r\n            display: block;\r\n        }\r\n    }\r\n}","//\r\n// _file-manager.scss\r\n//\r\n\r\n.file-manager-menu {\r\n    max-height: calc(100vh - 296px);\r\n\r\n    @media (max-width: 991.98px) {\r\n        height: calc(100vh - 296px);\r\n    }\r\n\r\n    li {\r\n        padding: 5px 0px;\r\n\r\n        a {\r\n            color: var(--#{$prefix}dark);\r\n            font-weight: $font-weight-medium;\r\n            transition: all 0.5s ease;\r\n\r\n            &.active,\r\n            &:hover,\r\n            &[aria-expanded=\"true\"]{\r\n                color: $success;\r\n            }\r\n        }\r\n\r\n        .sub-menu {\r\n            li {\r\n                padding-left: 25px;\r\n                position: relative;\r\n\r\n                &::before {\r\n                    content: \"\\f0374\";\r\n                    position: absolute;\r\n                    left: 0px;\r\n                    font-family: Material Design Icons;\r\n                    color: rgba(var(--#{$prefix}dark-rgb), 0.4);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.file-manager-sidebar {\r\n    position: relative;\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n\r\n    @media (min-width: 992px) {\r\n        min-width: 300px;\r\n        max-width: 300px;\r\n        height: calc(100vh - #{$header-height} - #{$footer-height} + 20);\r\n    }\r\n\r\n    @media (max-width: 991.98px) {\r\n        position: fixed;\r\n        top: 0;\r\n        bottom: 0;\r\n        left: 0;\r\n        width: 200px;\r\n        max-width: 100%;\r\n        z-index: 1003;\r\n        box-shadow: $box-shadow-lg;\r\n        transform: translateX(-100%);\r\n        visibility: hidden;\r\n        height: 100vh;\r\n\r\n        &.menubar-show {\r\n            visibility: visible;\r\n            transform: none;\r\n        }\r\n    }\r\n}\r\n\r\n.file-menu-sidebar-scroll{\r\n    height: calc(100vh - 505px);\r\n    @media (max-width: 991.98px) {\r\n        height: calc(100vh - 320px);\r\n    }\r\n}\r\n\r\n.file-manager-content {\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n}\r\n\r\n.file-manager-content-scroll{\r\n    height: calc(100vh - 185px);\r\n    @media (max-width: 991.98px) {\r\n        height: calc(100vh - 144px);\r\n    }\r\n\r\n    .simplebar-content{\r\n        height: 100%;\r\n    }\r\n}\r\n\r\n.file-detail-content-scroll{\r\n    height: calc(100vh - 180px);\r\n    @media (max-width: 991.98px) {\r\n        height: 100vh;\r\n    }\r\n\r\n    .simplebar-content{\r\n        height: 100%;\r\n    }\r\n}\r\n\r\n.file-manager-detail-content {\r\n    width: 32%;\r\n    max-width: 100%;\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n    display: none;\r\n}\r\n\r\n.file-detail-show{\r\n    .file-manager-detail-content{\r\n        display: block;\r\n    }\r\n}\r\n\r\n#file-overview{\r\n    display: none;\r\n}\r\n\r\n@media (max-width: 1399.98px) {\r\n    .file-manager-detail-content {\r\n        position: fixed;\r\n        top: 0;\r\n        bottom: 0;\r\n        left: auto;\r\n        right: 0;\r\n        width: 400px;\r\n        max-width: 100%;\r\n        z-index: 1003;\r\n        box-shadow: $box-shadow-lg;\r\n        transform: translateX(100%);\r\n    }\r\n\r\n    .file-detail-show {\r\n        .file-manager-detail-content {\r\n            transform: none;\r\n        }\r\n    }\r\n}\r\n\r\n.file-details-box {\r\n    height: 195px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}","//\r\n// _to-do.scss\r\n//\r\n\r\n.to-do-menu {\r\n    li {\r\n        .nav-link {\r\n            color: var(--#{$prefix}body-color);\r\n            padding-left: 0;\r\n            font-weight: $font-weight-medium;\r\n            background-color: var(--#{$prefix}light);\r\n            padding: 10px 12px;\r\n            border-radius: 4px;\r\n            display: block;\r\n            margin-bottom: 8px;\r\n            &:hover, &.active {\r\n                color: $success;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.todo-content {\r\n    height: calc(100vh - 362px);\r\n    overflow-y: auto;\r\n    &::-webkit-scrollbar {\r\n        -webkit-appearance: none;\r\n    }\r\n\r\n    &::-webkit-scrollbar:vertical {\r\n        width: 8px;\r\n    }\r\n\r\n    &::-webkit-scrollbar:horizontal {\r\n        height: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\r\n        border-radius: 8px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n        border-radius: 8px;\r\n    }\r\n}\r\n\r\n.todo-task {\r\n    table{\r\n        .form-check{\r\n            .form-check-input {\r\n                &:checked+.form-check-label {\r\n                    text-decoration: line-through;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.task-handle{\r\n    cursor: move;\r\n}\r\n\r\n#task-error-msg{\r\n    display: none;\r\n}","//\r\n// _invoice.scss\r\n//\r\n\r\n.bg-job {\r\n    background-image: url(../../images/new.png);\r\n    background-size: cover;\r\n    background-position: center;\r\n}\r\n\r\n.job-list-view-card{\r\n    .background {\r\n        height: 130px;\r\n    }\r\n}\r\n\r\n.job-list-row {\r\n    &.row {\r\n        .col-xxl-3 {\r\n            @media (min-width: 1400px) and (max-width: 1499.98px) {\r\n                width: 33%; \r\n            }\r\n        }\r\n    }\r\n}",".custom-container {\r\n    width: 90%;\r\n}\r\n\r\n//********** Navbar **********//\r\n.job-navbar {\r\n    .dropdown-menu {\r\n        .dropdown-item {\r\n            .avatar-sm {\r\n                height: 2.5rem;\r\n                width: 2.5rem;\r\n            }\r\n        }\r\n    }\r\n\r\n    @media (max-width: 991.98px) {\r\n        background-color: var(--#{$prefix}card-bg-custom);\r\n        padding: 16px 0;\r\n    }\r\n}\r\n\r\n//********** Home **********//\r\n.job-hero-section {\r\n    position: relative;\r\n    padding: 165px 0;\r\n    overflow-x: hidden;\r\n}\r\n\r\n.job-panel-filter {\r\n    background-color: var(--#{$prefix}card-bg-custom);\r\n    border-radius: $border-radius;\r\n    overflow: hidden;\r\n\r\n    .form-control {\r\n        height: 45px;\r\n        border: none;\r\n        border-radius: 0;\r\n        background-color: transparent;\r\n    }\r\n\r\n    .btn {\r\n        border-radius: 0;\r\n    }\r\n\r\n    input.form-control {\r\n        border-right: 1px solid $border-color;\r\n    }\r\n\r\n    @media (max-width: 767.98px) {\r\n        background-color: transparent;\r\n\r\n        .form-control {\r\n            background-color: $white;\r\n            border-radius: $input-border-radius;\r\n        }\r\n\r\n        input.form-control {\r\n            border: 0;\r\n        }\r\n\r\n        .btn {\r\n            border-radius: $btn-border-radius;\r\n        }\r\n    }\r\n}\r\n\r\n.circle-effect {\r\n    position: absolute;\r\n    top: 0;\r\n    z-index: 0;\r\n    right: -55px;\r\n    margin: 0 auto;\r\n\r\n    .circle {\r\n        border: 1px solid $border-color;\r\n        height: 240px;\r\n        width: 240px;\r\n        margin: 0 auto;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .circle2 {\r\n        position: absolute;\r\n        top: -20px;\r\n        right: -20px;\r\n        border: 1px solid $border-color;\r\n        height: 280px;\r\n        width: 280px;\r\n        margin: 0 auto;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .circle3 {\r\n        position: absolute;\r\n        top: -40px;\r\n        right: -40px;\r\n        border: 1px solid $border-color;\r\n        height: 320px;\r\n        width: 320px;\r\n        margin: 0 auto;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    .circle4 {\r\n        position: absolute;\r\n        top: -60px;\r\n        right: -60px;\r\n        border: 1px solid $border-color;\r\n        height: 360px;\r\n        width: 360px;\r\n        margin: 0 auto;\r\n        border-radius: 50%;\r\n    }\r\n\r\n    @media (max-width: 991.98px) {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.home-img {\r\n    .user-img {\r\n        position: relative;\r\n        z-index: 1;\r\n    }\r\n}\r\n\r\n//********** About **********//\r\n.application-box,\r\n.feedback-box,\r\n.inquiry-box {\r\n    max-width: 240px;\r\n    position: absolute;\r\n    z-index: 2;\r\n    transition: all 0.5s ease;\r\n\r\n    &:hover {\r\n        transform: translateY(-5px);\r\n    }\r\n}\r\n\r\n.inquiry-box {\r\n    left: -134px;\r\n    top: 90px;\r\n\r\n    @media (max-width: 991.98px) {\r\n        left: 0;\r\n    }\r\n}\r\n\r\n.application-box {\r\n    bottom: 50px;\r\n    right: -160px;\r\n\r\n    @media (max-width: 991.98px) {\r\n        right: 0;\r\n    }\r\n}\r\n\r\n.feedback-box {\r\n    right: -50px;\r\n    bottom: -54px;\r\n\r\n    @media (max-width: 576.98px) {\r\n        right: 0;\r\n        bottom: 0;\r\n    }\r\n}\r\n\r\n.job-icon-effect {\r\n    height: 30px;\r\n    width: 30px;\r\n    position: absolute;\r\n    top: 0px;\r\n    left: -2%;\r\n    border-radius: 50%;\r\n    background: repeating-linear-gradient(-55deg, rgba($white, 0) 0.8px, $success 1.6px, $success 2px, rgba($white, 0) 3.8px, rgba($white, 0) 5px);\r\n    z-index: 0;\r\n    opacity: 0.20;\r\n\r\n    span {\r\n        position: relative;\r\n        z-index: 1;\r\n    }\r\n}\r\n\r\n.about-img-section {\r\n    position: relative;\r\n\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 20px;\r\n        right: -20px;\r\n        top: -20px;\r\n        bottom: 20px;\r\n        border: 1px solid $info;\r\n        z-index: 0;\r\n        border-radius: $border-radius;\r\n\r\n        @media (max-width: 576.98px) {\r\n            right: 20px;\r\n            top: 20px;\r\n        }\r\n    }\r\n\r\n}\r\n\r\n.features-company-widgets {\r\n    position: absolute;\r\n    bottom: -18px;\r\n    right: -35px;\r\n}","/*\r\nTemplate Name: Velzon - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nWebsite: https://themesbrand.com/\r\nContact: support@themesbrand.com\r\nFile: Custom Css File\r\n*/\r\n@import url('https://fonts.googleapis.com/css?family=Source+Sans+Pro:regular,bold,italic&subset=latin,latin-ext');\r\n\r\n.css-b62m3t-container {\r\n  .css-13cymwt-control {\r\n    background-color: var(--#{$prefix}gray-200);\r\n    border-color: var(--#{$prefix}border-color);\r\n\r\n    &:hover {\r\n      border-color: var(--#{$prefix}border-color);\r\n    }\r\n  }\r\n\r\n  .css-t3ipsp-control {\r\n    background-color: var(--#{$prefix}gray-200);\r\n    border-color: var(--#{$prefix}border-color);\r\n    box-shadow: none;\r\n\r\n    &:hover {\r\n      border-color: var(--#{$prefix}border-color) !important;\r\n    }\r\n  }\r\n\r\n  .css-1nmdiq5-menu {\r\n    background-color: var(--#{$prefix}gray-200);\r\n\r\n    .css-10wo9uf-option {\r\n      cursor: pointer;\r\n      background-color: var(--#{$prefix}gray-200);\r\n\r\n      &:active {\r\n        background-color: var(--#{$prefix}gray-200);\r\n      }\r\n    }\r\n\r\n    .css-d7l1ni-option {\r\n      cursor: pointer;\r\n      background-color: var(--#{$prefix}gray-100);\r\n    }\r\n  }\r\n\r\n  .css-1p3m7a8-multiValue {\r\n    background-color: var(--#{$variable-prefix}light);\r\n  }\r\n\r\n  .css-wsp0cs-MultiValueGeneric {\r\n    color: $heading-color;\r\n  }\r\n\r\n  .css-12jo7m5 {\r\n    color: $heading-color;\r\n  }\r\n\r\n  .css-6j8wv5-Input,\r\n  .css-qc6sy-singleValue {\r\n    color: $heading-color;\r\n  }\r\n\r\n  .css-1dimb5e-singleValue {\r\n    color: var(--vz-body-color);\r\n  }\r\n}\r\n\r\n.marketplace-swiper .swiper-button-next,\r\n.marketplace-swiper .swiper-button-prev {\r\n  top: 24px;\r\n}\r\n\r\n.marquee {\r\n  width: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n  height: 22px;\r\n  line-height: 2;\r\n}\r\n\r\n.marquee div {\r\n  display: block;\r\n  width: 200%;\r\n  height: 30px;\r\n  position: absolute;\r\n  overflow: hidden;\r\n  animation: marquee 35s linear infinite;\r\n}\r\n\r\n.marquee span {\r\n  float: left;\r\n  width: 50%;\r\n}\r\n\r\n@keyframes marquee {\r\n  0% {\r\n    left: 0;\r\n  }\r\n\r\n  100% {\r\n    left: -100%;\r\n  }\r\n}\r\n\r\n// Data Table\r\n\r\n.kVrXuC,\r\n.dwPlXY,\r\n.gKbhqU,\r\n.iSAVrt {\r\n  background-color: $table-bg !important;\r\n  color: $table-color !important;\r\n}\r\n\r\n.fyrdjl {\r\n  color: rgba(var(--#{$prefix}body-color-rgb), 0.54) !important;\r\n  fill: rgba(var(--#{$prefix}body-color-rgb), 0.54) !important;\r\n}\r\n\r\n.fyrdjl:disabled {\r\n  color: rgba(var(--#{$prefix}body-color-rgb), 0.18) !important;\r\n  fill: rgba(var(--#{$prefix}body-color-rgb), 0.18) !important;\r\n}\r\n\r\n.iSAVrt {\r\n  background-color: var(--#{$prefix}card-bg-custom) !important;\r\n  border-bottom-color: $table-border-color !important;\r\n}\r\n\r\n.dwPlXY:not(:last-of-type) {\r\n  border-bottom-color: $table-border-color !important;\r\n}\r\n\r\n//\r\n.dropdown-item a {\r\n  display: block !important;\r\n}\r\n\r\n.react-trello-board {\r\n  height: 77.2vh !important;\r\n  background-color: transparent !important;\r\n  color: #495057 !important;\r\n}\r\n\r\n.react-trello-lane {\r\n  background-color: #fff !important;\r\n  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;\r\n}\r\n\r\n.react-trello-lane div {\r\n  width: 99%;\r\n  margin-left: 0.5%;\r\n  margin-top: 6px;\r\n}\r\n.react-trello-lane header {\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.clGdKf {\r\n  border: 1px solid rgb(204, 204, 204) !important;\r\n}\r\n\r\n.sc-kpDqfm {\r\n  color: #495057 !important;\r\n}\r\n\r\n.sc-cPiKLX {\r\n  color: #495057 !important;\r\n}\r\n\r\n.sc-dAlyuH {\r\n  color: #495057 !important;\r\n}\r\n\r\n.sc-dhKdcB {\r\n  max-height: 68vh !important;\r\n}\r\n\r\n.flex-container {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n  /* Mengatur ruang antara item secara merata */\r\n  flex-wrap: wrap;\r\n  /* Memungkinkan item untuk melingkar ke baris baru jika ruang tidak mencukupi */\r\n}\r\n\r\n.flex-item {\r\n  width: calc(5.5%);\r\n  text-align: center;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Media query untuk layar lebih kecil */\r\n@media (max-width: 768px) {\r\n  .flex-item {\r\n    width: calc(12%);\r\n    /* Lebar item 50% pada layar lebih kecil */\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .flex-item {\r\n    width: calc(25%);\r\n    /* Lebar penuh pada layar sangat kecil */\r\n  }\r\n}\r\n\r\n/* .smooth-dnd-container.horizontal {\r\n  white-space: normal !important;\r\n} */\r\n\r\n\r\n#dashboard-custom-tooltip {\r\n  width: 400px;\r\n  position: absolute;\r\n  display: none;\r\n  z-index: 1052;\r\n}\r\n\r\n.block-badge-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fill, 56px);\r\n  gap: 5px;\r\n}\r\n\r\n.block-badge-cell {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 30px;\r\n  text-align: center;\r\n\r\n  .badge {\r\n    border-radius: 8px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n}\r\n\r\n.tableFixHead {\r\n  overflow: auto;\r\n  height: 720px;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.tableFixHead thead th {\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 100;\r\n}\r\n\r\n.tableFixHead tfoot th {\r\n  position: sticky;\r\n  bottom: 0;\r\n  z-index: 100;\r\n}\r\n\r\n.sticky-col {\r\n  position: -webkit-sticky;\r\n  position: sticky;\r\n  background-color: white;\r\n}\r\n\r\n.sticky-first-col {\r\n  width: 100px;\r\n  min-width: 100px;\r\n  max-width: 100px;\r\n  left: 0px;\r\n}\r\n\r\n.sticky-second-col {\r\n  width: 150px;\r\n  min-width: 150px;\r\n  max-width: 150px;\r\n  left:\r\n    100px;\r\n}\r\n\r\n.courier-prime-regular {\r\n  font-family: \"Courier Prime\", monospace;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n}\r\n\r\n.courier-prime-bold {\r\n  font-family: \"Courier Prime\", monospace;\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  font-style: normal;\r\n}\r\n\r\n.text-capitalize {\r\n  text-transform: capitalize;\r\n}\r\n\r\n\r\n.courier-prime-regular-italic {\r\n  font-family: \"Courier Prime\", monospace;\r\n  font-weight: 400;\r\n  font-size: 15px;\r\n  font-style: italic;\r\n}\r\n\r\n.courier-prime-bold-italic {\r\n  font-family: \"Courier Prime\", monospace;\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  font-style: italic;\r\n}\r\n\r\n.Toastify__toast-container {\r\n  z-index: 200000 !important;\r\n}\r\n\r\n.hero-kwitansi {\r\n  padding: 0px;\r\n}\r\n\r\n.hero-kwitansi::before {\r\n  content: \"\";\r\n  background-image: url('../../../images/logo-sm.png');\r\n  background-size: \"100%\";\r\n  background-repeat: no-repeat;\r\n  background-position: right 40px center;\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  opacity: 0.075;\r\n}\r\n\r\n.hero-spk {\r\n  padding: 0px;\r\n}\r\n\r\n.hero-spk::before {\r\n  content: \"\";\r\n  background-image: url('../../../images/logo-sm.png');\r\n  background-size: \"100%\";\r\n  background-repeat: no-repeat;\r\n  background-position: right 200px;\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  opacity: 0.075;\r\n}\r\n\r\n.accordion-button:after {\r\n  margin-top: -2px;\r\n  margin-left: -13px;\r\n  margin-right: 0.5em; // just extra space between text and icon\r\n}\r\n\r\n.accordion-button:not(.collapsed)::after {\r\n  margin-top: -7px;\r\n  margin-left: -6px;\r\n  margin-right: 0.5em; // just extra space between text and icon\r\n}\r\n\r\n.ledger-content:hover {\r\n  background-color: #e9ebec !important;\r\n}\r\n\r\n// daftar transaksi di bawah baris akun (acc-ledger) -> area scroll\r\n.ledger-trans-scroll {\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n\r\n  &::-webkit-scrollbar {\r\n    width: 6px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n    background: transparent;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background-color: rgba(0, 0, 0, 0.2);\r\n    border-radius: 3px;\r\n  }\r\n}\r\n\r\n// baris TOTAL nempel di bawah area scroll.\r\n// butuh warna solid (bukan bg-soft-info) karena sticky bakal transparan\r\n.ledger-trans-total {\r\n  position: sticky;\r\n  bottom: 0;\r\n  z-index: 2;\r\n  background-color: $cyan-100;\r\n}\r\n\r\n.floating-btn {\r\n  position: absolute;\r\n  top: 60px;\r\n  right: 60px;\r\n  z-index: 50;\r\n\r\n  @media (max-width: 768px) {\r\n    top: 40px;\r\n    right: 40px;\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    top: 20px;\r\n    right: 20px;\r\n  }\r\n}\r\n\r\n.table-container-sticky {\r\n  max-height: 530px;\r\n  /* Set a fixed height for the scrollable area */\r\n  overflow-y: auto;\r\n  /* Enable vertical scrolling */\r\n}\r\n\r\n.table-fixed-header thead th {\r\n  position: sticky;\r\n  /* Make the header sticky */\r\n  top: -1px;\r\n  /* Stick to the top of the container */\r\n  background-color: #d8edf9;\r\n  /* Add a background color so content doesn't show through */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
